/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 8648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./cn.json": 7184,
	"./de.json": 532,
	"./en.json": 1005,
	"./es.json": 3458,
	"./fr.json": 1822,
	"./hr.json": 5849,
	"./it.json": 5744,
	"./jp.json": 9494,
	"./kr.json": 6600,
	"./nl.json": 5464,
	"./pl.json": 5726,
	"./pt.json": 6709,
	"./ru.json": 8809,
	"./th.json": 6734,
	"./tr.json": 8923,
	"./vi.json": 3821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8648;

/***/ }),

/***/ 7743:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(1102);
var tryToString = __webpack_require__(869);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 9277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(1102);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(593);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ 7166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(2417);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 9567:
/***/ (function(module) {

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),

/***/ 5984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(9567);
var DESCRIPTORS = __webpack_require__(801);
var global = __webpack_require__(40);
var isCallable = __webpack_require__(1102);
var isObject = __webpack_require__(2417);
var hasOwn = __webpack_require__(2578);
var classof = __webpack_require__(7862);
var tryToString = __webpack_require__(869);
var createNonEnumerableProperty = __webpack_require__(4020);
var defineBuiltIn = __webpack_require__(616);
var defineBuiltInAccessor = __webpack_require__(1679);
var isPrototypeOf = __webpack_require__(593);
var getPrototypeOf = __webpack_require__(9615);
var setPrototypeOf = __webpack_require__(9733);
var wellKnownSymbol = __webpack_require__(5326);
var uid = __webpack_require__(8930);
var InternalStateModule = __webpack_require__(8156);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ 7645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var lengthOfArrayLike = __webpack_require__(8525);

module.exports = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),

/***/ 7632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(9419);
var toAbsoluteIndex = __webpack_require__(598);
var lengthOfArrayLike = __webpack_require__(8525);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 5963:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(801);
var isArray = __webpack_require__(2369);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 4081:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var lengthOfArrayLike = __webpack_require__(8525);

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed
module.exports = function (O, C) {
  var len = lengthOfArrayLike(O);
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = O[len - k - 1];
  return A;
};


/***/ }),

/***/ 9589:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var lengthOfArrayLike = __webpack_require__(8525);
var toIntegerOrInfinity = __webpack_require__(6001);

var $RangeError = RangeError;

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
module.exports = function (O, C, index, value) {
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  if (actualIndex >= len || actualIndex < 0) throw $RangeError('Incorrect index');
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = k === actualIndex ? value : O[k];
  return A;
};


/***/ }),

/***/ 156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1022);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 7862:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(7358);
var isCallable = __webpack_require__(1102);
var classofRaw = __webpack_require__(156);
var wellKnownSymbol = __webpack_require__(5326);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasOwn = __webpack_require__(2578);
var ownKeys = __webpack_require__(5450);
var getOwnPropertyDescriptorModule = __webpack_require__(161);
var definePropertyModule = __webpack_require__(8825);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 2960:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(1433);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 4020:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(801);
var definePropertyModule = __webpack_require__(8825);
var createPropertyDescriptor = __webpack_require__(1163);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 1163:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 1679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var makeBuiltIn = __webpack_require__(2407);
var defineProperty = __webpack_require__(8825);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 616:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(1102);
var definePropertyModule = __webpack_require__(8825);
var makeBuiltIn = __webpack_require__(2407);
var defineGlobalProperty = __webpack_require__(3995);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 3995:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(40);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 801:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(1433);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 5492:
/***/ (function(module) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(40);
var isObject = __webpack_require__(2417);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 9487:
/***/ (function(module) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 7614:
/***/ (function(module) {

module.exports = {
  IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
  DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
  HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
  WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
  InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
  NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
  NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
  NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
  NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
  InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
  InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
  SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
  InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
  NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
  InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
  ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
  TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
  SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
  NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
  AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
  URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
  QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
  TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
  InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
  DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
};


/***/ }),

/***/ 2883:
/***/ (function(module) {

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 3533:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(40);
var userAgent = __webpack_require__(2883);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 5854:
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 2316:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1022);

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ 2822:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(40);
var getOwnPropertyDescriptor = (__webpack_require__(161).f);
var createNonEnumerableProperty = __webpack_require__(4020);
var defineBuiltIn = __webpack_require__(616);
var defineGlobalProperty = __webpack_require__(3995);
var copyConstructorProperties = __webpack_require__(282);
var isForced = __webpack_require__(947);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 1433:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 9951:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(1433);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 8441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(9951);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 6990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(801);
var hasOwn = __webpack_require__(2578);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 3496:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1022);
var aCallable = __webpack_require__(7743);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 1022:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(9951);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5257:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(40);
var isCallable = __webpack_require__(1102);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 2702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aCallable = __webpack_require__(7743);
var isNullOrUndefined = __webpack_require__(3028);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 40:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ 2578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1022);
var toObject = __webpack_require__(2570);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 27:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 3252:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(801);
var fails = __webpack_require__(1433);
var createElement = __webpack_require__(237);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 8115:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1022);
var fails = __webpack_require__(1433);
var classof = __webpack_require__(156);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 9584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(1102);
var isObject = __webpack_require__(2417);
var setPrototypeOf = __webpack_require__(9733);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 6426:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1022);
var isCallable = __webpack_require__(1102);
var store = __webpack_require__(939);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 8156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(3148);
var global = __webpack_require__(40);
var isObject = __webpack_require__(2417);
var createNonEnumerableProperty = __webpack_require__(4020);
var hasOwn = __webpack_require__(2578);
var shared = __webpack_require__(939);
var sharedKey = __webpack_require__(5356);
var hiddenKeys = __webpack_require__(27);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 2369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(156);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ 8927:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(7862);

module.exports = function (it) {
  var klass = classof(it);
  return klass == 'BigInt64Array' || klass == 'BigUint64Array';
};


/***/ }),

/***/ 1102:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var $documentAll = __webpack_require__(5492);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 947:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(1433);
var isCallable = __webpack_require__(1102);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 3028:
/***/ (function(module) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 2417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(1102);
var $documentAll = __webpack_require__(5492);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 4298:
/***/ (function(module) {

module.exports = false;


/***/ }),

/***/ 830:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5257);
var isCallable = __webpack_require__(1102);
var isPrototypeOf = __webpack_require__(593);
var USE_SYMBOL_AS_UID = __webpack_require__(503);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 8525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toLength = __webpack_require__(3332);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 2407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1022);
var fails = __webpack_require__(1433);
var isCallable = __webpack_require__(1102);
var hasOwn = __webpack_require__(2578);
var DESCRIPTORS = __webpack_require__(801);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(6990).CONFIGURABLE);
var inspectSource = __webpack_require__(6426);
var InternalStateModule = __webpack_require__(8156);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 7026:
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 2391:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(119);

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ 8825:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(801);
var IE8_DOM_DEFINE = __webpack_require__(3252);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(4278);
var anObject = __webpack_require__(7166);
var toPropertyKey = __webpack_require__(700);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 161:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(801);
var call = __webpack_require__(8441);
var propertyIsEnumerableModule = __webpack_require__(5790);
var createPropertyDescriptor = __webpack_require__(1163);
var toIndexedObject = __webpack_require__(9419);
var toPropertyKey = __webpack_require__(700);
var hasOwn = __webpack_require__(2578);
var IE8_DOM_DEFINE = __webpack_require__(3252);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 7687:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(11);
var enumBugKeys = __webpack_require__(5854);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 4038:
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 9615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasOwn = __webpack_require__(2578);
var isCallable = __webpack_require__(1102);
var toObject = __webpack_require__(2570);
var sharedKey = __webpack_require__(5356);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(2960);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1022);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 11:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1022);
var hasOwn = __webpack_require__(2578);
var toIndexedObject = __webpack_require__(9419);
var indexOf = (__webpack_require__(7632).indexOf);
var hiddenKeys = __webpack_require__(27);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 5790:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 9733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(3496);
var anObject = __webpack_require__(7166);
var aPossiblePrototype = __webpack_require__(9277);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 3440:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(8441);
var isCallable = __webpack_require__(1102);
var isObject = __webpack_require__(2417);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 5450:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5257);
var uncurryThis = __webpack_require__(1022);
var getOwnPropertyNamesModule = __webpack_require__(7687);
var getOwnPropertySymbolsModule = __webpack_require__(4038);
var anObject = __webpack_require__(7166);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 4791:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__(3028);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 5356:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(7593);
var uid = __webpack_require__(8930);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(40);
var defineGlobalProperty = __webpack_require__(3995);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 7593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_PURE = __webpack_require__(4298);
var store = __webpack_require__(939);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.31.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 595:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(3533);
var fails = __webpack_require__(1433);
var global = __webpack_require__(40);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(6001);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 4793:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPrimitive = __webpack_require__(1925);

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};


/***/ }),

/***/ 9419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(8115);
var requireObjectCoercible = __webpack_require__(4791);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 6001:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trunc = __webpack_require__(7026);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 3332:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(6001);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 2570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(4791);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 1925:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(8441);
var isObject = __webpack_require__(2417);
var isSymbol = __webpack_require__(830);
var getMethod = __webpack_require__(2702);
var ordinaryToPrimitive = __webpack_require__(3440);
var wellKnownSymbol = __webpack_require__(5326);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPrimitive = __webpack_require__(1925);
var isSymbol = __webpack_require__(830);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 7358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5326);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(7862);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 869:
/***/ (function(module) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 8930:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1022);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 503:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(595);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 4278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(801);
var fails = __webpack_require__(1433);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ 7304:
/***/ (function(module) {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 3148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(40);
var isCallable = __webpack_require__(1102);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 5326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(40);
var shared = __webpack_require__(7593);
var hasOwn = __webpack_require__(2578);
var uid = __webpack_require__(8930);
var NATIVE_SYMBOL = __webpack_require__(595);
var USE_SYMBOL_AS_UID = __webpack_require__(503);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 3340:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2822);
var toObject = __webpack_require__(2570);
var lengthOfArrayLike = __webpack_require__(8525);
var setArrayLength = __webpack_require__(5963);
var doesNotExceedSafeInteger = __webpack_require__(9487);
var fails = __webpack_require__(1433);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ 5834:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arrayToReversed = __webpack_require__(4081);
var ArrayBufferViewCore = __webpack_require__(5984);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// `%TypedArray%.prototype.toReversed` method
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed
exportTypedArrayMethod('toReversed', function toReversed() {
  return arrayToReversed(aTypedArray(this), getTypedArrayConstructor(this));
});


/***/ }),

/***/ 9890:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(5984);
var uncurryThis = __webpack_require__(1022);
var aCallable = __webpack_require__(7743);
var arrayFromConstructorAndList = __webpack_require__(7645);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var sort = uncurryThis(ArrayBufferViewCore.TypedArrayPrototype.sort);

// `%TypedArray%.prototype.toSorted` method
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toSorted
exportTypedArrayMethod('toSorted', function toSorted(compareFn) {
  if (compareFn !== undefined) aCallable(compareFn);
  var O = aTypedArray(this);
  var A = arrayFromConstructorAndList(getTypedArrayConstructor(O), O);
  return sort(A, compareFn);
});


/***/ }),

/***/ 4365:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arrayWith = __webpack_require__(9589);
var ArrayBufferViewCore = __webpack_require__(5984);
var isBigIntArray = __webpack_require__(8927);
var toIntegerOrInfinity = __webpack_require__(6001);
var toBigInt = __webpack_require__(4793);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var PROPER_ORDER = !!function () {
  try {
    // eslint-disable-next-line no-throw-literal, es/no-typed-arrays, es/no-array-prototype-with -- required for testing
    new Int8Array(1)['with'](2, { valueOf: function () { throw 8; } });
  } catch (error) {
    // some early implementations, like WebKit, does not follow the final semantic
    // https://github.com/tc39/proposal-change-array-by-copy/pull/86
    return error === 8;
  }
}();

// `%TypedArray%.prototype.with` method
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
exportTypedArrayMethod('with', { 'with': function (index, value) {
  var O = aTypedArray(this);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualValue = isBigIntArray(O) ? toBigInt(value) : +value;
  return arrayWith(O, getTypedArrayConstructor(O), relativeIndex, actualValue);
} }['with'], !PROPER_ORDER);


/***/ }),

/***/ 7765:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2822);
var global = __webpack_require__(40);
var getBuiltIn = __webpack_require__(5257);
var createPropertyDescriptor = __webpack_require__(1163);
var defineProperty = (__webpack_require__(8825).f);
var hasOwn = __webpack_require__(2578);
var anInstance = __webpack_require__(875);
var inheritIfRequired = __webpack_require__(9584);
var normalizeStringArgument = __webpack_require__(2391);
var DOMExceptionConstants = __webpack_require__(7614);
var clearErrorStack = __webpack_require__(2316);
var DESCRIPTORS = __webpack_require__(801);
var IS_PURE = __webpack_require__(4298);

var DOM_EXCEPTION = 'DOMException';
var Error = getBuiltIn('Error');
var NativeDOMException = getBuiltIn(DOM_EXCEPTION);

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var that = new NativeDOMException(message, name);
  var error = Error(message);
  error.name = DOM_EXCEPTION;
  defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  inheritIfRequired(that, this, $DOMException);
  return that;
};

var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;

var ERROR_HAS_STACK = 'stack' in Error(DOM_EXCEPTION);
var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(global, DOM_EXCEPTION);

// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
// https://github.com/Jarred-Sumner/bun/issues/399
var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);

var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;

// `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
$({ global: true, constructor: true, forced: IS_PURE || FORCED_CONSTRUCTOR }, { // TODO: fix export logic
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
  if (!IS_PURE) {
    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
  }

  for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
    var constant = DOMExceptionConstants[key];
    var constantName = constant.s;
    if (!hasOwn(PolyfilledDOMException, constantName)) {
      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
    }
  }
}


/***/ }),

/***/ 1295:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(616);
var uncurryThis = __webpack_require__(1022);
var toString = __webpack_require__(119);
var validateArgumentsLength = __webpack_require__(7304);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var append = uncurryThis(URLSearchParamsPrototype.append);
var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
var push = uncurryThis([].push);
var params = new $URLSearchParams('a=1&a=2');

params['delete']('a', 1);

if (params + '' !== 'a=2') {
  defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach(this, function (v, k) { // also validates `this`
      push(entries, { key: k, value: v });
    });
    validateArgumentsLength(length, 1);
    var key = toString(name);
    var value = toString($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ 5611:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(616);
var uncurryThis = __webpack_require__(1022);
var toString = __webpack_require__(119);
var validateArgumentsLength = __webpack_require__(7304);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
var $has = uncurryThis(URLSearchParamsPrototype.has);
var params = new $URLSearchParams('a=1');

if (params.has('a', 2)) {
  defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    } return false;
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ 2166:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(801);
var uncurryThis = __webpack_require__(1022);
var defineBuiltInAccessor = __webpack_require__(1679);

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}


/***/ }),

/***/ 3823:
/***/ (function(module) {

/*! @license DOMPurify 2.4.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.7/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    var _transformCaseFunc;

    transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */


  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */


    DOMPurify.version = '2.4.7';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */

    var ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */

    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */


      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */


      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */


      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */


      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */


      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // For XHTML and XML documents that support custom namespaces


      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */


    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */


    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */


    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */


      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */


      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */


    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */


    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */


    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */


    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */


    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */


      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */


      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */


      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */


      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */


      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */


      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */


        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */


      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Make sure that older browsers don't get fallback-tag mXSS */


      if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */


      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */


      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */

      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (value) {
        return false;
      } else ;

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */


    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */


    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */


        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */


        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */


        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */


        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */


        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */


        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */


        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                {
                  value = trustedTypesPolicy.createHTML(value);
                  break;
                }

              case 'TrustedScriptURL':
                {
                  value = trustedTypesPolicy.createScriptURL(value);
                  break;
                }
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */


        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */


    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */


      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */


        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */


        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */


      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        if (typeof dirty.toString === 'function') {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        } else {
          throw typeErrorCreate('toString is not a function');
        }
      }
      /* Check we can run. Otherwise fall back or ignore */


      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */


      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */


      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */


        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */


      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */


      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */


      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */


        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */


        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */


      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */


      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */


    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */


    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */


    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */


    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */


    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */


    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */


    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ 2869:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 12:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buildDirective = void 0;
var dompurify_1 = __webpack_require__(3823);
function setUpHooks(config) {
    var hooks = config.hooks;
    var hookName;
    for (hookName in hooks) {
        dompurify_1.addHook(hookName, hooks[hookName]);
    }
}
function buildDirective(config) {
    if (config === void 0) { config = {}; }
    setUpHooks(config);
    var updateComponent = function (el, binding) {
        if (binding.oldValue === binding.value) {
            return;
        }
        var arg = binding.arg;
        var namedConfigurations = config.namedConfigurations;
        if (namedConfigurations &&
            typeof namedConfigurations[arg] !== 'undefined') {
            el.innerHTML = dompurify_1.sanitize(binding.value, namedConfigurations[arg]);
            return;
        }
        el.innerHTML = dompurify_1.sanitize(binding.value, config.default);
    };
    return {
        inserted: updateComponent,
        update: updateComponent,
    };
}
exports.buildDirective = buildDirective;


/***/ }),

/***/ 5320:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var dompurify_html_1 = __webpack_require__(12);
exports.Z = {
    install: function (Vue, config) {
        if (config === void 0) { config = {}; }
        Vue.directive('dompurify-html', dompurify_html_1.buildDirective(config));
    },
};


/***/ }),

/***/ 7184:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"活动设置下拉列表"," Stage Control":" 演示区控制","Stage Controls and Information":"演示区控制和信息","Live in ":"距离直播开始时间： ","Start Session":"开始会议","End Session":"结束会议","Present Screen":"当前屏幕","Rehearse On Stage":"在演示区排练","Turn on Microphone":"开启麦克风","Turn off Microphone":"关闭麦克风","Turn on camera":"开启摄像头","Turn off camera":"关闭摄像头","rehearsal mode":"排练模式","People Watching: ${watchCount}":"观看人数：${watchCount}","Turn on Audio":"开启音频","Turn off Audio":"关闭音频","Are you sure you want to leave this room?":"确定要离开这个房间吗？","you will be redirected to stage in":"几秒钟后，您将被重定向到演示区","sec. . ":"。 ","Skip to Main Navigation":"跳转到主导航","Skip to Chat":"跳转到聊天","Skip to Meeting Controls":"跳转到会议控件","LinkedIn":"领英","Live in":"以下时间后开始直播","UPCOMING":"即将举行的","Rehearse on stage":"在演示区排练","Watch Rehearsal":"观看彩排","Answered by:":"回答者：","Speaker Off":"扬声器关闭","Speaker On":"扬声器开启","Speaker Controls":"扬声器控件","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"所有演示区元素都存在于共享图像后面。 停止全屏图像共享后，它们将再次可见。","Close Ticker Popup":"关闭 Ticker 弹出窗口","Open GIF Picker":"打开 GIF 选择器","Open Emoji Picker":"打开表情符号选择器","Send Message":"发送消息","Tabs: Messaging and More":"选项卡：消息及更多","Thanks for attending!":"感谢您的参与！"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" 您订阅的专场中没有即将举行的会议。请切换到其他专场以观看实时会议","Redirecting you to ":"将您重定向到 ","in ":"在 ","seconds":"秒后","Main Navigation":"主导航","YOU ARE HERE":"您的位置","Live Now":"立即直播","SUBMIT":"提交","Allocated time for engagement has ended. You will be redirected to main stage":"分配的参与时间已结束。您将被重定向到主演示区","Wrap up in":"以下时间后结束","Session overrun by":"会议超时","Ending in":"距离结束时间：","Bring this session live?":"直播此会议？","START SESSION":"开始会议","Bring this session to end?":"结束此会议？","END SESSION":"结束会议","Go On Stage":"上台","Muted by organizer":"已被组织者静音","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"活动组织者之一已将您的音频静音。您可以通过单击麦克风按钮来取消静音。","Gifs":"Gif","Stickers":"贴纸","Launch Survey":"启动调查","Microphone is on":"麦克风已开启","Microphone is off":"麦克风已关闭","Secret Code’s length should be 6 digits":"秘密代码长度应为 6 位","Closing in 00:":"00: 后关闭","Submit":"提交","Questions":"问题","Preview":"预览","Close Survey":"关闭调查","This is a required question":"这是一个必答问题","Enter the text you’d like to present on stage below.":"在下面的演示区输入您想展示的文字。","Use Chrome/Edge for best performance":"使用 Chrome/Edge 以获得最佳效果","Do you want to launch your survey now?":"您想立即启动调查吗？","Success! Your Survey has been launched for attendees.":"成功！您的调查已为与会者启动。","Unable to publish. Please try again.":"无法发布。请重试。","Are you sure you want to close this survey?":"您确定要关闭此调查吗？","Success! Your Survey has been closed for attendees.":"成功！您的调查已对与会者关闭。","Unable to un-publish. Please try again.":"无法取消发布。请重试。","Please answer all required questions.":"请回答所有必答问题。","You have already submitted this survey.":"您已经提交了此调查。","Success! Thank you for your feedback.":"成功！感谢您的反馈。","Unable to submit. Please try again.":"无法提交。请重试。","Launch surveys will take over attendees\' engagement panel.":"启动的调查将覆盖与会者的参与面板。","Closing this survey will remove it from attendees\' engagement panel.":"关闭此调查会将其从与会者的参与面板中移除。","Survey":"调查","Updating Survey...":"正在更新调查...","Closing":"关闭","Goldcast needs access to your camera and microphone":"Goldcast 需要访问您的摄像头和麦克风","Goldcast needs access to your microphone":"Goldcast 需要访问您的麦克风","Goldcast needs access to your camera":"Goldcast 需要访问您的摄像头","SPEAKERS":"嘉宾","Mark as Unanswered":"标记为未回答","Mark as Answered":"标记为已回答","Remove from Priority":"从优先项中移除","Mark as Priority":"标记为优先项","Answer":"答案","Enter answer...":"输入答案……","Answered by":"回答者：","Submit Answer":"提交答案","Test your system’s speaker":"测试系统扬声器","Click \\"Yes\\" if you hear the sound.":"如果您听到声音，请单击“是”。","Load previous":"加载上一个","Hide Name":"隐藏姓名","Text Q&A is disabled in On Demand mode.":"在按需模式下，文字问答处于禁用状态。","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"已达到文字问答上限。与会者将无法提出新问题。","Sent to Q&A":"发送到问答","Couldn\'t post as Q&A. Please try again.":"无法发布为问答。请重试。","Yes this is being recorded":"是，这正在录制中","No this is not being recorded":"不，这未在录制中","System\'s Speaker Check":"系统扬声器检查","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"为确保您能够在活动期间听见声音，请确保系统扬声器工作正常","Click on “Test your system’s speaker” to proceed":"单击“测试系统扬声器”以继续","Error while sharing message to screen. Post not found":"分享消息到屏幕时出错。未找到帖子","Lost connection to servers. Refresh your page to get live event experience.":"与服务器失去连接。刷新页面以获得实时活动体验。","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"VPN/防火墙在干扰您的身份验证。请切换您的网络或与您的 IT 团队联系，以使<a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>这些域</a>能够顺利访问 Goldcast。","It\'s taking too long":"花费时间过长","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"您似乎是在通过 VPN 连接或开启了防火墙。请参考此<a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>帮助文档</a>并将所需域列入白名单以使 Goldcast 顺利运行，否则您应更换网络","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"您似乎是在通过 VPN 连接或开启了防火墙。请参考此<a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>帮助文档</a>并将所需域列入白名单以使 Goldcast 顺利运行，否则您应更换网络或在精简模式下观看会议","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"由于网络带宽不足，无法连接 Goldcast 视频直播服务。请更换网络以连接实时直播服务。","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"由于网络带宽不足，无法连接 Goldcast 视频直播服务。请切换到精简模式或更换网络以连接直播服务","Most Upvotes":"最多点赞","Most Recent":"最新","My Questions":"我的问题","Prioritized":"已按优先级排列","Approved":"已批准","Unapproved":"未获批准","Unanswered":"未回答","Failed to update answer. Please try again!":"无法更新答案。请重试！","Failed to post answer. Please try again!":"无法发布答案。请重试！","Failed to delete question. Please try again!":"删除问题失败。请重试！","Survey Link":"调查链接","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"切换将重新加载当前页面到与会者视图。要切换回组织者视图，请在配置文件下拉列表中关闭与会者视图。","You haven\'t asked any questions yet":"您还没有提出任何问题","No prioritized questions":"没有优先问题","Create prioritized list of questions for speakers by marking questions as priority":"通过将问题标记为优先项，为演讲人创建优先问题列表","No Approved Questions":"没有已批准的问题","Approve incoming questions to see list of approved questions":"批准传入问题以查看已批准问题列表","No Unapproved Questions":"没有未获批准的问题","No Answered Questions":"没有已回答的问题","Answer a question on stage or with inline text":"在演示台上或使用嵌入式文本回答问题","All questions are answered":"所有问题都已回答","Rate Your Experience":"为您的体验评分","How satisfied are you with Goldcast?":"您对 Goldcast 的满意度如何？","What are the main reasons for your rating?":"您所给评分的主要原因是什么？","I am interested in seeing a demo of Goldcast":"我有兴趣观看 Goldcast 的演示","Thank You":"谢谢","Your feedback was successfully submitted.":"您的反馈已成功提交。","Tell us how we can improve...":"请告诉我们，我们可以如何改进……","1 Slide":"1 张幻灯片","Your internet connection is unstable.":"您的互联网连接不稳定。","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"您似乎在讲话时设置了静音。单击麦克风图标取消静音","The registration could not be completed! Please check that this email is allowed to register for the event.":"无法完成注册！请检查此电子邮件地址是否允许注册该活动。","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"看起来您已经注册了此活动！如果您没有收到注册确认，请检查您的垃圾邮件文件夹。如果您需要进一步协助，请联系活动组织者。","Your registration could not be completed. This event has reached its registration capacity.":"无法完成注册！本次活动报名人数已满。","Image cannot be an svg":"图像不能是 svg 文件","This should be a valid linkedin url":"这应该是一个有效的 linkedin url","This should be a valid twitter url":"这应该是一个有效的 twitter url","This should be a valid url":"这应该是一个有效的 url","Video":"视频","Read Less":"阅读更少","live":"正在进行","Opened":"已打开","In person only":"仅限亲自","Stage Stream":"演示区域直播","Streaming not available":"直播不可用","Close TV":"关闭电视","Streaming is not available for prerecorded and RTMP sessions":"直播不可用于录播和 RTMP 会议","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"将您的计算机连接到电视屏幕或投影仪，让在场与会者能够看到虚拟演示区域上正在发生的事情，包括幻灯片、问答等。连接后，单击“打开电视”并将新窗口拖动或共享到您的电视屏幕或投影仪。 ","Close Setup Mode":"关闭设置模式","Help":"帮助","upcoming":"即将举行的","ended":"已结束","Remove from favorites":"从收藏夹中移除","Add to favorites":"添加到收藏夹","PLAY RECORDING":"播放录像","VIEW RECORDING":"观看录像","VIEW RECORDINGS":"查看录像","Virtual Backgrounds":"虚拟背景","No Device Available":"无可用设备","Needs permission":"需要权限","Device not detected":"未检测到设备","Camera is on":"摄像头已开启","Camera is off":"摄像头已关闭","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"镜像视频不会呈现给观众。观众看到的均是非镜像视频","Mirror My Video":"镜像我的视频","Camera":"摄像头","1. Click on Safari > Settings for this\\n            website":"1. 单击 Safari > 此网站的设置","1. Click the lock":"1. 单击","icon in your browser’s address bar":"浏览器地址栏中的锁状图标","3. Unmute":"3. 取消静音","and":"和","icons from stage control panel":"演示区控制面板上的图标","icon from stage control panel":"演示区控制面板上的图标","2. Set camera and microphone to “Allow”.":"2. 将摄像头和麦克风设置为“允许”。","2. Set camera to “Allow”.":"2. 将摄像头设置为“允许”。","2. Set microphone to \\"Allow\\"":"2. 将麦克风设置为“允许”","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. 选择“始终允许 Goldcast 访问您的摄像头和麦克风”","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. 选择“始终允许 Goldcast 访问您的摄像头”。","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. 选择“始终允许 Goldcast 访问您的麦克风”","Questions?":"有任何疑问吗？","If you’re having issues, check out our comprehensive":"如果您遇到问题，请参阅我们的综合","help docs":"帮助文档","Speaker is on":"扬声器已打开","Stop Test":"停止测试","Test your system’s audio":"测试系统音频","Still can\'t hear any sound?":"仍然听不到任何声音？","Microphone":"麦克风","Audio is being played in system\'s default audio device.":"正在系统的默认音频设备中播放音频。","Click to view/change audio device":"单击以查看/更改音频设备","Speaker":"嘉宾","Play Recording":"播放录像","Recording for this broadcast is currently being processed and will be available soon":"此广播的录像目前正在处理中，即将就绪","You haven\'t favorited anything yet!":"您尚未收藏任何内容！","Add an item to favorites by selecting the ♡ in the top right corner.":"选择右上角的 ♡ 可添加项目到收藏夹。","Session has ended":"会议已结束","System Check":"系统检查","Need help? Check out the":"需要帮助？查看","Skip Checks and Continue":"跳过检查并继续","Click the button above to run the test":"单击上面的按钮运行测试","Test Screenshare":"测试屏幕共享","Share message to stage":"将消息分享到演示区","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"在下面输入您要用于 ticker 的文本。要将 ticker 转换为超链接，请输入 URL。","Ticker":"Ticker","Coffee Break! Be back in 10m.":"休息时间！10 分钟后回来。","Enter Message":"输入消息","https://www.xyz.com":"https://www.xyz.com","Launch":"启动","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"感谢您提交问题。您当前的其中一个问题获得批准后，就可以提交另一个。","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"对不起！“问答”目前已被禁用。再次启用“问答”后，您才能提交问题。","Votes":"票数","Vote":"投票","is inviting you to a video call":"正在邀请您加入视频通话","ENTER ROOM":"进入会议室","Start the conversation!":"开始对话！","Couldn\'t send message. Click here to retry.":"无法发送消息。单击此处重试。","Couldn\'t add emoji. Please try again.":"无法添加表情符号。请重试。","Couldn\'t remove emoji. Please try again.":"无法移除表情符号。请重试。","Couldn\'t delete message. Please try again.":"无法删除消息。请重试。","Couldn\'t pin message. Please try again.":"无法置顶消息。请重试。","Couldn\'t unpin message. Please try again.":"无法取消置顶消息。请重试。","Today":"今天","No messages yet":"暂无消息","Messages from organizers and speakers appear here!":"组织者和演讲人的消息显示在这里！","Next Session is Starting":"下一会议即将开始","Go to Next Session":"转到下一会议","I’d like to stay":"我想留下来","My favorites":"我的收藏夹","1. Click on the lock icon in your address bar":"1. 单击地址栏中的锁状图标","We recommend organizers and speakers use a desktop\\n        device":"我们建议组织者和演讲人使用桌面设备","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"为确保与会者、演讲人和组织者获得最佳体验，必须从桌面使用 Goldcast。用移动设备广播将导致较差的体验。","Watch Now":"立即观看","Video progress time":"视频进度时间","Total video duration":"视频总时长","Rate Goldcast!":"评价 Goldcast！","Running Required Checks...":"正在运行所需的检查……","Test Your Setup":"测试您的设置","Test your Computer Device, Microphone and Camera before you join the event":"在参加活动之前测试您的计算机设备、麦克风和摄像头","Speaker and microphone not working?":"扬声器和麦克风不工作？","Passed":"已通过","Fix Audio Issues":"修复音频问题","Check if audio is being played in other sound devices connected to phone/tablet":"检查连接到手机/平板电脑的其他声音设备是否正在播放音频","Check if correct audio device is chosen from the below dropdown":"检查是否从下拉菜单中选择了正确的音频设备","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>单击此处</a>以检查是否在需要播放音频的位置选择了正确的音频设备","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>单击此处</a>以检查是否在需要播放音频的位置选择了正确的音频设备","Right click on the browser tab & click “Unmute Site”":"右键单击浏览器标签页并单击“取消网站静音”","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"检查浏览器的标签页是否已取消静音，或单击“窗口” > “取消静音此标签页”","System Check Failed!":"系统检查失败！","System Check Passed!":"系统检查通过！","Complete checks to proceed":"完成检查以继续","Enter Event":"进入活动","Skip Screen Sharing Check? ":"跳过屏幕共享检查？ ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"如果需要在活动中展示您的屏幕，我们建议完成屏幕共享检查。","Ignore & Enter Event":"忽略并进入活动","Test screenshare":"测试屏幕共享","Retry Now":"立即重试","SHARE":"分享","Rooms Closed":"会议室已关闭","Discussion rooms are now closed. You are being redirected to the Stage.":"讨论室现已关闭。您正被重定向到演示区域。","Return To Stage":"返回演示区","Unrecognized embedded widget provider - ":"无法识别的嵌入式小部件提供程序 - ","Room Ended":"会议讨论已结束","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"您的活动组织者已关闭所有会议室。现在，您将被重定向到演示区域。","Video Q&A Request Cancelled":"视频问答请求已取消","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"您的视频问答请求已被取消，因为您正在精简模式下观看。切换到直播模式以再次举手。","Camera Passed":"摄像头已通过检查","Camera Error":"摄像头错误","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"浏览器未授予摄像头权限。单击“允许摄像头”。","Camera permissions aren’t granted from system. Click “Allow Camera”":"系统未授予摄像头权限。单击“允许摄像头”","Uh-oh! Error occurred while creating camera stream":"哎呀！创建摄像头直播时出错","Close other applications which might use camera stream":"关闭其他可能使用摄像头直播的应用程序","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>单击此处</a>，检查浏览器是否可以访问摄像头","Microphone Passed":"麦克风已通过检查","Microphone Error":"麦克风错误","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"浏览器未授予麦克风权限。单击“允许麦克风”","Mic permissions aren’t granted from system. Click “Allow Microphone”":"系统未授予麦克风权限。单击“允许麦克风”","Uh-oh! Error occurred while creating mic stream":"哎呀！创建麦克风直播时出错","Close other applications which might use mic stream":"关闭其他可能使用麦克风直播的应用程序","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>单击此处</a>，检查浏览器是否可以访问麦克风","Speaker and Microphone Error":"扬声器和麦克风错误","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"要显示连接到系统的扬声器设备列表，需要麦克风权限。单击“允许麦克风”","It seems mic is being used by other application. Close other applications to proceed.":"似乎其他应用程序正在使用麦克风。关闭其他应用程序以继续。","Camera & Microphone Error":"摄像头和麦克风错误","To enable permissions, click the Allow Camera & Mic button below":"要启用权限，请单击下面的“允许摄像头和麦克风”按钮","Network Connection":"网络连接","Check Passed":"已通过检查","Could not establish a network connection":"无法建立网络连接","Connect to a different network, or use a mobile hotspot.":"连接到其他网络，或使用移动热点。","Disable any VPN or firewall is connected.":"禁用已连接的任何 VPN 或防火墙。","Connection: Good":"连接：良好","Network Connection Error":"网络连接错误","Can’t connect to network. Change your network or limited functionality will be available during event.":"无法连接到网络。更改您的网络，否则活动期间只能使用有限的功能。","AdBlocker":"广告拦截器","AdBlocker not detected.":"未检测到广告拦截器。","AdBlocker detected. This may degrade your event experience.":"检测到广告拦截器。这可能会降低您的活动体验。","Disable adblocker for best experience.":"禁用广告拦截器以获得最佳体验。","You are using ":"您正在使用 ","Use Windows or Mac OS for best performance":"使用 Windows 或 Mac OS 以获得最佳效果","Browser Check":"浏览器检查","Check Passed.":"已通过检查。","Switch To Lite Mode":"切换到精简模式","Your pending Video Q&A request will be cancelled once you switch to lite mode":"切换到精简模式后，待处理的视频问答请求将被取消","Stay on Live Mode":"保持直播模式","Unable to mark as favorite":"无法标记为收藏项","Event organizers must enter the event to select favorites.":"活动组织者必须进入活动才能选择收藏夹。","Make an Announcement":"发布公告","STOP":"停止","InPerson CheckIn App":"现场签到应用程序","App to Check-In In-Person attendees":"用于与会者现场签到的应用程序","SEE AGENDA":"查看日程","Please visit the Agenda tab to view the session recordings":"请访问“议程”标签页以查看会议录像","The session recordings will be available soon in the Agenda tab":"会议录像很快即会在“议程”标签页中提供","FAILED!":"失败！","Next session is beginning":"下一会议即将开始","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"是否要进入下一会议？您的直播将继续，您的电视将播放新会议。","Banners":"横幅广告","Images":"图像","Screen Share":"屏幕共享","Browser might not have screen-recording permission on your computer.":"浏览器可能没有在计算机上录制屏幕的权限。","Open System Preferences":"打开系统偏好设置","Error publishing screen because someone else started screen share already.":"发布屏幕时出错，因为有人已经开始了屏幕共享。","Live Feed":"实时源","Check Your Network":"检查您的网络","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"我们在播放视频时检测到错误！如果您在播放视频时遇到问题，请尝试刷新页面或切换到精简模式。","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"我们在播放视频时检测到错误！如果您在播放视频时遇到问题，请尝试刷新页面。","All Dates":"所有日期","All Tracks":"所有专场","Create Ticker":"创建 Ticker","Booths Closed":"小隔间已关闭","Your event organizer has closed all the booths. You will now be redirected to the stage":"您的活动组织者已关闭所有小隔间。您现在将被重定向到演示区域","Visit the Polls tab to view live results.":"访问“投票”标签页以查看实时结果。","A new poll is open! Visit the Polls tab to vote.":"新投票已开始！访问“投票”标签页进行投票。","Vote for Polls":"投票","Go to Polls Tab":"转到“投票”标签页","Microphone audio too low":"麦克风音频太低","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"我们检测到您的音频存在问题。如果问题仍然存在，我们建议您尝试静音/取消静音或使用其他设备。","Audio/Video bitrate too low":"音频/视频比特率太低","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"您的网络防火墙设置正在阻止音/视频直播。我们建议您切换到其他网络连接。","Error sharing screen":"共享屏幕时出错","A network error occurred while sharing screen. Please check your network connection.":"共享屏幕时发生了网络错误。请检查您的网络连接。","Apologies, due to some errors, we need to refresh the page!":"抱歉，由于出现错误，我们需要刷新页面！","Warning":"警告","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"我们检测到您的视频存在问题。我们建议您尝试关闭浏览器的其他标签页或设备上运行的其他应用程序，并检查/升级互联网连接以解决此问题。","No results found":"未找到结果","Audio":"音频","Please choose another microphone and camera":"请选择其他麦克风和摄像头","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"当前选择的麦克风和摄像头不工作。请在下面的下拉列表中选择其他麦克风和摄像头。","The currently selected camera is not working. Please choose another camera in the dropdown below.":"当前选择的摄像头不工作。请在下面的下拉列表中选择另一个摄像头。","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"您可以在没有摄像头的情况下继续，但我们建议您解决冲突以确保流畅的广播体验","Please choose another microphone":"请选择其他麦克风","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"当前选择的麦克风不工作。请在下面的下拉列表中选择其他麦克风。","Please check that your TV speaker is correct":"请检查您的电视扬声器是否正确","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"当前选择的扬声器不工作。请在下面的下拉列表中选择其他扬声器。","Your answer":"您的答案","Edit":"编辑","Delete":"删除","Settings":"设置","Signing Out":"登出","Confirming your account...":"正在确认您的帐户……","Something Went Wrong. Please Retry :(":"出错了。请重试 :(","Resending Mail":"重新发送邮件","offline":"离线","I am inviting you to a video meeting:":"我邀请您参加一个视频会议：","Resending secure login link to your email":"正在重新发送安全登录链接到您的电子邮箱","Sending secure login link to your email":"正在发送安全登录链接到您的电子邮箱","Something went Wrong. Please Retry :(":"出错了。请重试 :(","Updating your password":"更新您的密码","Sending mail":"正在发送邮件","Verifying":"正在验证","This might be slower than usual":"这可能比平时慢","Checking":"正在检查","New results available! Refresh!":"新结果可用！刷新！","Saving":"正在保存","Turn off Attendee mode":"关闭与会者模式","See Attendee View":"查看与会者视图","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"当前观看此会议的与会者总数 \\n注意：这仅供组织者查看","Session Count":"会议数","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"当前观看实时会议的与会者数量。注意：这仅供组织者查看","Role":"角色","Total Attendees":"与会者总数","Total number of attendees online at this time Note: This is for organizer eyes only":"目前在线的与会者总数 \\n注意：这仅供组织者查看","My Profile":"我的个人资料","Languages":"语言","Filling out your profile can help you connect with people with similar interests.":"填写个人资料可以帮助您与兴趣相投的人建立联系。","type to search for your address":"键入以搜索您的地址","Could not open direct call":"无法打开直接呼叫","Chat messages can only be published from inside a broadcast.":"聊天消息只能在广播内发布。","Stage Logo can only be published from inside a broadcast.":"演示区域徽标只能在广播内发布。","Loading Speakers":"正在加载演讲人","Raise hand is disabled for organizer accounts, but active for attendee accounts":"组织者帐户的举手功能被禁用，但与会者帐户可使用举手功能","Disabled in lite mode, return to live if you’d like to raise hand!":"在精简模式下禁用，如果您想举手，请返回直播模式！","Raise hand to enter stage for video q&a":"举手进入舞台加入视频问答","Speakers":"嘉宾","Hosting organization: {organization}":"主办组织：{organization}","Failed to switch {deviceTag}":"切换 {deviceTag} 失败","Make sure your {deviceTag} is not being used by any other application and is working properly.":"确保您的 {deviceTag} 没有被任何其他应用程序使用并且工作正常。","Facing issues with audio or video? Switch on lite mode":"遇到了音频或视频问题？转为精简模式","Failed to get event for eventID: {eventID}":"未能获取 eventID 为 {eventID} 的活动","Error while playing video.":"播放视频时出错。","Speakers only, attendees can\'t see this chat":"仅限演讲人，与会者无法看到此聊天","Kudo":"Kudo","Room":"会议室","Session":"会话","Booth":"小隔间","Public":"公共","Drift":"漂移","Slides":"幻灯片","Videos":"视频","Chat":"聊天","Messages":"私信","Poll":"投票","Docs":"文件","Q&A":"问答","Media":"媒体","Messages Chat":"消息聊天","Leaderboard":"排行榜","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"注意：您也是这次活动的演讲人。您可以随时进入后台区域并登上演示区域。","Switch to Attendee View":"切换到与会者视图","Return to Organizer View":"返回组织者视图","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"关闭与会者视图将重新加载当前页面并返回到组织者视图。您想继续吗？","Switch":"切换","Request Sent":"请求已发送","Your request for a demo has been submitted":"您的演示请求已提交","Organizer Redirection":"组织者重定向","YES, REDIRECT":"是的，重定向","DISMISS":"取消","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"与会者正被重定向到下一会议：{title}。您是否也希望被重定向到下一会议？","Stage":"当前专场","Rooms":"会议室","Join a round table to discuss moderated topics with your fellow attendees":"加入圆桌会议，与其他与会者讨论会议主题","Booths":"小隔间","Join a booth to know more about a sponsor":"进入小隔间以更多了解赞助商信息","You are in the booth":"您在小隔间中","People":"参与人","Connect with your fellow attendees":"连线其他与会者","Connect with speakers":"连线演讲人","starting in {duration}":"{duration} 后开始","You will be redirected to booths in {duration}":"{duration} 后，您将被重定向到小隔间","booths":"小隔间","agenda":"议程","You will be redirected to {word} in {duration}":"{duration} 后，您将被重定向到 {word}","You will be redirected to the live stage in {duration}":"{duration} 后，您将被重定向到现场演示区域","- You are about to be redirected to {tabTitle} in {duration}":"——{duration} 后，您将被重定向到 {tabTitle}","See Agenda":"查看日程","Break":"休息","{title} is now live":"{title} 现已上线","Apologies, due to an error we need to refresh the page!":"抱歉，由于出现错误，我们需要刷新页面！","Network interruption detected":"检测到网络中断","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"您的网络连接有问题。如果您正在使用 VPN，请考虑将其禁用。或者，尝试连接到其他网络","No audio output device detected":"未检测到音频输出设备","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"如果您遇到任何问题，请连接扬声器/耳机，并使用齿轮图标对其进行测试。","Please disable ad blocker for this page":"请禁用此页的广告拦截器","Yes, I understand":"是的，我明白","No event user found so attended not marked!":"未找到活动用户，因此未标记与会！","Wait while the speaker approves your video q&a request":"等待演讲人通过您的视频问答请求","Organizer":"组织者","UPNEXT":"下一个即将开始","Ended":"已结束","Hide":"隐藏","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"此页面将在 {durationLeftToRedirect} 秒后自动重定向。","Register":"注册","Error: User unable to be registered for this event. Please contact event organizer for assistance":"错误：用户无法注册此活动。请联系活动组织者寻求帮助","You are already registered!":"您已注册！","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"看起来您已注册此活动！如果您没有收到注册确认，请检查您的垃圾邮件文件夹。如需进一步协助，请联系活动组织者","Thank you for registering!":"感谢您注册！","Submit another response":"提交另一个回复","Share":"分享","Know someone who want to attend this?":"知道有人想参加此活动吗？","COPY LINK":"复制链接","Powered by":"提供支持:","VIEW PROFILE":"查看个人资料","You can access the event landing here":"您可以在此访问活动登陆页","Need Help?":"需要帮助？","Welcome back":"欢迎回来","Checking...":"正在检查……","Close":"关闭","Enter":"进入","See {roomCount} Room(s)":"查看 {roomCount} 个会议室","Back":"返回","Request a Demo":"请求演示","Loading":"加载中","Thread":"话题","Load more":"加载更多","Heads up!":"注意！","YES":"是","No":"否","Following":"已关注","Error in loading drimify":"加载 drimify 时出错","You\'re not registered for this event":"您没有注册当前活动","Check out other events":"查看其他活动","Date":"日期","Location":"地区","How are you attending the event":"您是如何参加活动的","In Person":"亲自","Virtually":"虚拟","Event Widgets":"活动小部件","Chat • Messages • Q&A • Poll • Docs":"聊天 • 消息 • 问答 • 投票 • 文档","DISCUSSION":"讨论","JOIN":"加入","WAIT":"等待","more":"更多","See Profile":"查看个人资料","Filter":"筛选","Video player not supported by your browser":"当前浏览器不支持视频播放器","We recommend using the latest version of Google Chrome to access your conference":"我们建议使用最新版本的 Google Chrome 浏览器参加会议","ANSWER":"答案","REJECT":"拒绝","Don’t ask me this next time":"下次不要再询问我","Cancel":"取消","Lite Mode":"精简模式","On":"开启","Connection Issues? Turn on Lite Mode":"有连接问题？开启精简模式","Turn On Lite Mode":"开启精简模式","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"精简模式会导致现场直播和您在屏幕上看到的内容之间有 30 秒的延迟。您想继续吗？","Turn On":"开启","Lite Mode Active!":"精简模式已开启！","Thanks for your patience, lite mode now on!":"感谢您的耐心等待，精简模式现已开启！","Turn off Lite Mode?":"关闭精简模式？","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"关闭精简模式返回观看直播。注意，当我们赶上直播时，将有 30 秒的差距。","Lite Mode Off!":"精简模式已关闭！","Thanks for your patience, we’ve returned to the live broadcast!":"感谢您的耐心等待，我们已经恢复现场直播！","Lite Mode Unavailable":"精简模式不可用","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"很抱歉 Lite 模式目前不可用给您带来的不便，请切换到直播模式以继续您的会话。","Turn off Lite mode?":"关闭精简模式？","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"我们检测到您的连接已恢复正常。您想要切换回直播吗？注意，当我们赶上直播时，将有 30 秒的差距。","Turn Off":"关闭","Lite mode is disabled for organizer accounts, but active for attendee accounts":"组织者帐户的精简模式被禁用，但与会者帐户可使用精简模式","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"您的浏览器不支持精简模式。我们建议使用最新版本的 Google Chrome 浏览器","Lite mode is not curently available. We’ll let you know once it’s available again":"精简模式目前不可用。一旦它再次可用，我们会通知您","Turn off Lite Mode":"关闭精简模式","We’ll let you know when Lite mode is available again":"精简模式再次可用时，我们会通知您","Lite Mode Available":"精简模式可用","Loading Lite Mode...":"正在加载精简模式……","Turning Off Lite Mode":"关闭精简模式","Lite Mode On":"精简模式开启","Audio/Video Issues?":"音频/视频问题？","Error":"错误","Click a video to play":"单击视频以播放","Error starting video!":"启动视频时出错！","Please rotate your device to {mode} mode":"请将设备旋转到 {mode} 模式","landscape":"横向","portrait":"纵向","Thank you for attending this event!":"感谢您参加本次活动！","Go to Rooms":"前往会议室","Please use a desktop or laptop Google Chrome browser to access your conference":"请使用电脑和谷歌浏览器","If on Desktop":"如果是使用台式机","Please increase the width of your window":"请增大窗口宽度","Alternatively, check out the":"或者，查看","Youtube Livestream":"Youtube Livestream","Search":"查找","Profile":"个人资料","Yes":"是","Loading Chat":"加载聊天内容","Please wait while we fetch the chat":"我们正在提取聊天内容，请稍候","Load old messages":"加载之前的消息","Join the room to see chat":"进入会议室以查看聊天内容","Live Chat":"在线聊天","Uh..oh we couldn\'t load the content":"糟了，我们无法加载内容","Please reload the page":"请重新加载页面","New comments":"新评论","Start the conversation":"开始对话","Be the first to add to chat!":"说点什么！","Enter your message":"输入您的消息","Joining chat!":"加入聊天！","See all pinned messages":"查看所有置顶的消息","Failed to send! Retry?":"发送失败！重试？","Search for attendee":"搜索与会者","Up to date":"最新","Start a new conversation, We think you\'ll enjoy":"开始新的对话，我们认为您会喜欢","chatting with these recommended attendees!":"与这些推荐的与会者聊天！","Searching":"正在搜索","Load Previous":"加载上一个","Load Next":"加载下一个","Loading Channel":"加载通道","Please wait while we fetch the channel":"我们正在获取通道时，请稍候","Please wait while we fetch the messages":"我们正在获取消息时，请稍候","Send the first message":"发送第一条消息","Join":"加入","link":"链接","download":"下载","Click to open":"单击以打开","No open polls":"没有开放的问卷调查","Check back later to see if a poll opens up!":"稍后再回来查看是否开启了问卷调查！","Loading Poll":"加载投票","Please wait while we fetch the polls":"我们正在提取投票结果时，请稍候","Uh oh.. we couldn’t load the content":"糟了，我们无法加载内容","Polls":"投票","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"要启动问卷调查，请在 Goldcast 管理面板中添加对此会议的问题和回复","Stop Sharing":"停止分享","Can\'t publish polls while something else is being presented on stage":"在演示区域上展示其他内容的时候不能发布问卷调查","Open":"打开","Cancel your video q&a request":"取消您的视频问答请求","Pending...":"等待中……","Leave Stage":"退场","Raise Hand":"举手","Text Q&A":"文字问答","Video Q&A":"视频问答","Loading Q&amp;A":"加载问答","Please wait while we fetch the Q&amp;A":"我们正在提取问答内容，请稍候","Uh oh.. we couldn\'t load the content":"糟了，我们无法加载内容","No Questions Yet":"还没有问题","Tell your audience to send in questions!":"请告诉您的观众发送问题！","Be the first to ask a question!":"做第一个提出问题的人！","Tell your audience to raise their hand!":"请告诉您的观众举手提问！","Approve":"允许","Reject":"拒绝","End":"停止播放","RELOAD":"重新载入","Logos On Stage":"演示区域上的徽标","No File Chosen":"未选择文件","loading":"加载中","Can\'t publish a slide when there is something else being presented on stage":"在舞台上展示其他内容的时候不能发布幻灯片","Change Deck":"切换幻灯片","stop-screen-share":"停止屏幕共享","screen-share":"屏幕共享","Select a deck to begin presenting":"选择要开始展示的幻灯片","CONFIRM":"确认","If you’re having issues, please refer to the":"如果您遇到问题，请参阅","SPEAKER":"扬声器","Issue Testing Audio!":"发出测试音频！","VPN and adblockers may cause video issues, please disable them before proceeding":"VPN 和广告拦截器可能会导致视频问题，请在继续之前将它们禁用","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"请注意，VPN 和广告拦截器可能会导致视频问题，因此请确保在广播期间将它们保持禁用","Follow":"关注","Read More":"阅读更多","Ask a question":"问一个问题","Shared":"已分享","Answered":"已回复","Waiting Approval":"等待批准","cancel":"取消","ENTER":"进入","Upcoming Events":"即将举行的活动","Past Events":"参加过的活动","Goldcast":"Goldcast","MANAGE EVENT":"管理活动","Edit Profile":"编辑个人资料","Stay tuned!":"敬请关注！","Sign-in instructions will be available here 12 hours prior to the event":"活动开始前 12 小时将在此处提供登录说明","Please log out":"请退出","Logout":"退出","Continue as {differentUser}":"继续以 {differentUser} 的身份登录","You are already logged in as {user}.":"您已经以 {user} 的身份登录。","EMAIL":"邮箱","user@email.com":"user@email.com","FIRST NAME":"名","First Name":"名","LAST NAME":"姓","Last Name":"姓","You are not registered to this event":"您尚未注册此活动","Please enter your email and name":"请输入您的电子邮箱和姓名","Please enter your email":"请输入您的电子邮箱","We have sent a secret code to":"我们已将密码发送至","BACK":"返回","Didn\'t receive an email? Make sure to check spam list":"没有收到邮件？请务必检查垃圾邮件","Resend Mail":"重新发送邮件","SECRET CODE":"密码","Please enter the temporary password sent to your email":"请输入发送到您邮箱的临时密码","NEW PASSWORD":"新密码","Please enter a new password":"请输入新密码","CONFIRM PASSWORD":"确认密码","Please re-enter the new password":"请重新输入新密码","Password length should be atleast 8":"密码长度至少应为 8 位","Password and Confirm Password don\'t match !!":"密码和确认密码不匹配！！","Please enter your password to continue":"请输入您的密码以继续","Logging you in...":"正在登录……","PASSWORD":"密码","Forgot credentials?":"忘记了登录凭据？","Forgot Password? A mail will be sent to your registered email.":"忘记密码？一封邮件将发送到您的注册邮箱。","Email cannot be blank!!":"邮箱地址不能为空！！","We have sent a secure login link to":"我们已发送了一个安全登录链接至","from":"自","Please use that to access your event.":"请使用这个链接来进入活动。","Please check spam/promotion too if you can\'t find it.":"如果找不到，请检查垃圾/广告邮件。","Thank You !":"谢谢！","The link is not valid.":"链接无效。","Please be patient.":"请耐心等待。","We are verifying your link.":"我们正在验证您的链接。","Thank you for entering the code!":"感谢您输入密码！","Please create a new password":"请创建一个新密码","Signing you up...":"正在注册……","We have sent a temporary password to":"我们已将临时密码发送至","TEMPORARY PASSWORD":"临时密码","Please enter the temporary password sent to your mail":"请输入发送到您邮箱的临时密码","Password Length should be 8":"密码长度应为 8 位","Okay":"确定","Backstage: {title}":"后台：{title}","Prep Area":"等待区","Starting at {time}":"{time} 开始","person":"人","inside":"内部","No one is inside":"里面没人","This area is for you to sync up with your fellow speakers before you go on stage.":"会议开始前你可以和其他嘉宾在这里准备会议内容","This area is for you to check your cam and mic before you enter the room.":"该区域供您在进入会议室之前检查您的摄像头和麦克风。","I\'m Ready":"准备好了","Watch Live":"观看直播","Backstage":"后台","You are sharing your screen":"您正在共享屏幕","LIVE":"正在进行","Live":"正在进行","Virtual":"虚拟","Only available for ":"仅适用于 ","See Booths":"查看小隔间","See Rooms":"查看会议室","Enter Backstage":"进入后台","This track has no upcoming sessions. Check out a different track.":"此专场没有即将举行的会议。查看其他专场。","View":"查看","Agenda":"议程","Scroll to see all tracks":"滚动以查看所有专场","No Agenda Items to show!":"没有可显示的议程项目！","ENTER EVENT":"进入活动","change":"更新","Upload":"上传","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG、GIF 或 PNG。最大不超过 5MB","Create Profile":"创建","Email":"邮箱","Company":"公司","Title":"职位","No matching locations found":"未找到匹配的地区","You can try searching for the location with another keyword":"您可以尝试使用其他关键字搜索该地区","Interest Tags":"我感兴趣的","Pick your first tag":"选择您的第一个标签","Save":"保存","Searching...":"正在搜索……","Twitter":"Twitter","Select Your First Tags":"选择最先的一些标签","Add Interest tags":"添加兴趣标签","Congratulations!":"恭喜！","Your first Goldcast event is set up":"您的首次 Goldcast 活动已完成设置","You can always visit":"您可以随时访问","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"有关如何设置和执行活动的说明","See My Event":"查看我的活动","Peak Community":"Peak Community","Loading Lite Mode... This may take up to 30s":"正在加载精简模式……这最长可能需要 30 秒","Loading Video...":"正在加载视频……","Video will begin at session start time":"视频将在会议开始时播放","TIME":"时间","TITLE":"职位","STATUS":"状态","END":"停止播放","START":"开始","AGENDA":"议程","Enable Audio":"启用音频","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"由于浏览器自动播放政策，音频已被静音。单击下方的启用，取消静音。您稍后还可以通过嵌入式控件取消音频静音。","Enable":"启用","You are being redirected outside the room. Would you like to continue?":"您正被重定向到会议室外。您想继续吗？","Continue":"继续","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"或者，您可以使用精简模式，该模式将有 30 秒的直播延迟","We detected a network issue":"我们检测到一个网络问题","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"请确保您不是通过 VPN/防火墙连接。如果问题仍然存在，请尝试更换您的网络、浏览器或设备。","Could not connect":"无法连接","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"这可能是由于安全网络、浏览器/设备问题造成的。如果问题仍然存在，请尝试更换您的网络、浏览器或设备","Switch to Lite Mode":"切换到精简模式","Leave":"离开","Screenshare had an issue":"屏幕共享出了问题","Could not share screen unexpectedly. Refresh & retry. On mac go to":"突然无法共享屏幕。刷新并重试。在 mac 上转到","and check if your browser has the required permission":"并检查您的浏览器是否具备所需权限","Uh OH... Something went wrong":"哎呀……出错了","To fix this, click the":"要解决此问题，请单击","in your URL bar, then select “Allow”, and then click “Try Again”":"在 URL 栏中，选择“允许”，然后单击“重试”","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"由于未知原因，无法初始化媒体流！我们的平台可能不支持您的浏览器。我们建议使用“Google Chrome 浏览器”。如果此问题仍然存在，请联系 Goldcast 支持","To fix this, make sure your":"要解决此问题，请确保您的","is not being accessed by any other app. If not, please try changing your":"未被任何其他应用程序访问。如果没有，请尝试更改您的","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"设备，通过单击“转到设置”。解决可能的问题后，点击“重试”！","Go To Settings":"转到设置","Try Again":"再试一次","Try Joining without Video":"尝试不开视频加入","A refresh and rejoin should work":"刷新并重新加入应该可以解决问题","Refresh & Rejoin":"刷新并重新加入","Start Chat":"开始聊天","On Stage":"上台","Connect your on-site camera and microphone to present to your virtual attendees":"连接现场摄像头和麦克风，开始向虚拟与会者演示","Stop Streaming":"停止直播","Start Streaming":"开始直播","Set up on-site video feed":"设置现场视频源","Open TV":"打开电视","Layout: {layout} ":"布局：{layout} ","With Speaker Videos":"带有演讲人视频","Full Screen":"全屏","No Speakers":"无演讲人","Turn Off Setup Mode":"关闭设置模式","Setup Mode":"设置模式","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"如果您想停止 {roomTitle} 的设置模式，请按“关闭”。这样做也会关闭所有进行中的直播。","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"正在准备直播：{roomTitle}。请仅在现场位置使用设置模式进行直播。","Starting in {duration}":"{duration} 后开始","Can\'t share screen while there is something else being presented on stage":"在演示区域上展示其他内容的时候不能共享屏幕","You are now in attendee view!":"现在是与会者视图！","You are now in organizer view!":"现在是组织者视图！","Note :":"注意：","Only organizer accounts can see this tag, normal attendees can’t see this":"只有组织者帐户可以看到此标签，普通与会者无法看到此标签","Attendee":"与会者","Event Information":"活动信息","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"活动信息仅对组织者可见！<br />这一部分对与会者不可见","Operating System":"操作系统","Secondary Booths":"二级小隔间","Sort":"排序","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"关注 {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2} 将自动取消您对 {track1_Would_you_like_to_continue} 的关注","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1} 您想继续吗？","Track only available for {tracks}":"专场仅可用于 {tracks}","Add to Calendar":"加入我的日程","Open Speakers Control Panel":"打开演讲人控制面板","Move Offstage ↓":"移下演示区 ↓","Error Moving ⚠":"移动时发生错误 ⚠","Off Stage":"离开演示区","Move to Stage":"移到演示区","An error occurred!":"发生错误！","{eventName} Documents":"{eventName} 文档"," Set Up Mode":" 设置模式","Camera & Mic blocked":"摄像头和麦克风被禁用","Camera/Mic Inaccessible":"无法访问摄像头/麦克风","Camera/Mic Not Found":"找不到摄像头/麦克风","Camera Inaccessible":"无法访问摄像头","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"摄像头已被占用或不支持该分辨率。请确保您的摄像头没有被其他应用程序使用，然后重试！","No microphone/camera is found":"未找到麦克风/摄像头","The browser does not support using camera and microphone!":"浏览器不支持使用摄像头和麦克风！","{n} Slides":"{n} 张幻灯片","Starting in {timeduration}":"{timeduration} 后开始","{eventtitle} has ended":"{eventtitle} 已结束","This is a text q&a question!":"这是一个文字问答题！","Click here{if_it_does_not}":"单击此处 {if_it_does_not}","{click_here}if it does not":"如果没有，{click_here}","{title}up next":"{title}即将开始","seat(s) open":"个席位开放","Signal strength is low. Close other windows or connect to a different network.":"信号强度低。关闭其他窗口或连接到其他网络。","GO BACKSTAGE":"进入候场区","LEAVE STAGE":"退场","LEAVE":"离开","This event begins on{startitme}":"此活动将于 {startitme} 开始","Please refresh to enter.":"请刷新以进入。","people":"参与人","Oops, Something went wrong":"哎呀，出错了","Back Home":"返回主页","Deciding where to go ...":"决定前往何处……","Go to Event Hub":"转到活动中心","CREATE":"创建","Attending Virtually":"虚拟与会","Attending In Person":"亲身与会","Click to change your attendance type":"单击以更改您的与会类型","Open Chat":"打开聊天","Create your profile for {eventtitle}":"创建您的个人资料用于 {eventtitle}","Move to stage":"移到演示区","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"活动组织者已请求将您移到演示区来演播<strong>{broadcastTitle}</strong>。<br /><br />如果您单击接受请求，您将为活动参与者现场直播。<br /><br />","Go Live On Stage":"在演示区上现场直播","Moved to backstage":"已移至后台","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"组织者已将您从演示区移除。请不要在未联系组织者的情况下尝试重新加入。","Error creating Screen stream":"创建屏幕直播时出错","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"未授予共享屏幕权限。请*单击此处*查看故障排除文档。","Error publishing stream":"发布直播时出错","Could not publish stream. Please refresh and try again!":"无法发布直播。请刷新并重试！","Error publishing screen":"发布屏幕时出错","Error publishing screen. Please refresh and try again!":"发布屏幕时出错。请刷新并重试！","Error unpublishing stream":"取消发布直播时出错","Error unpublishing stream. Please refresh and try again!":"取消发布直播时出错。请刷新并重试！","Invalid Publish Operation":"无效的发布操作","{username} profile picture":"{username} 个人资料照片","Default":"默认","A-Z":"A-Z","Random":"随机","All":"全部","Past":"过去的","Upcoming":"即将举行的","Learn More":"了解更多","close":"关闭","Discussion Rooms":"讨论室","ATTENDEE MODE":"与会者模式","Loading...":"加载中……","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"设备被浏览器禁用或未授予使用权限。请授予权限并单击“重试”","You are now registered. You will receive an email confirming details shortly.":"您已注册！您很快会收到一封确认详情的电子邮件。","Streaming to Virtual Users from on-site video feed":"使用现场视频源向虚拟用户直播","Ending in ":"距离结束时间： ","GO LIVE":"开始直播","You have no past events.":"您没有过往活动。","You have no upcoming or live events.":"您没有即将举行的活动或现场活动。","left":"左","center":"中","right":"右","top":"顶部","bottom":"底部","loading...":"加载中……","Loading ...":"加载中……","Failed to redirect!":"重定向失败！","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"您似乎启用了广告拦截器。这可能会影响您获得最佳体验。请将其禁用。<br />&lt;br / &gt; 如果您需要相关帮助，请单击<a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>此处</a>以获得进一步说明。","redirecting in {duration}":"{duration} 后重定向","STOP VIDEO":"停止视频","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"您即将停止播放此视频。您的广播将返回直播模式，您的观众将看到演讲人和听到其演讲。您确定吗？","STOP SHARING":"停止分享","No Next Slide":"没有下一张幻灯片","Next Slide":"下一张幻灯片","No Previous Slide":"没有上一张幻灯片","Previous Slide":"上一张幻灯片","something went wrong while recording the response please try again":"录制响应时出错，请重试","Start In-Person Streaming":"开始面对面直播","Stop In-Person Streaming":"停止面对面直播","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"您的视频正在缓冲，测试会议将很快开始。这在实际会议期间不会发生。","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"Ticker 将显示在所有与会者网页的顶部。要将 ticker 转换为超链接，请在下面输入 URL","Allow {key}":"允许 {key}","{messageType} can only be published from inside a broadcast.":"{messageType} 只能从广播内部发布。","To grant {deviceName} access to this page, follow the two steps below:":"要授予 {deviceName} 访问此页面的权限，请执行以下两个步骤：","2. Allow {deviceName} access and then refresh the page.":"2. 允许 {deviceName} 访问，然后刷新页面。"}');

/***/ }),

/***/ 532:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Drop-down-Menü „Event-Einstellungen“"," Stage Control":" Bühnensteuerung","Stage Controls and Information":"Bühnensteuerung und Infos","Live in ":"Live in ","Start Session":"Sitzung starten","End Session":"Sitzung beenden","Present Screen":"Bildschirm präsentieren","Rehearse On Stage":"Auf der Bühne proben","Turn on Microphone":"Mikrofon einschalten","Turn off Microphone":"Mikrofon ausschalten","Turn on camera":"Kamera einschalten","Turn off camera":"Kamera ausschalten","rehearsal mode":"Probemodus","People Watching: ${watchCount}":"Zuschauerzahl: ${watchCount}","Turn on Audio":"Audio einschalten","Turn off Audio":"Audio ausschalten","Are you sure you want to leave this room?":"Möchtest du diesen Raum wirklich verlassen?","you will be redirected to stage in":"Zeit bis zur Weiterleitung zur Bühne:","sec. . ":"Sek. ","Skip to Main Navigation":"Zur Hauptnavigation springen","Skip to Chat":"Zum Chat springen","Skip to Meeting Controls":"Zur Meeting-Steuerung springen","LinkedIn":"LinkedIn","Live in":"Live in","UPCOMING":"Bevorstehende","Rehearse on stage":"Auf der Bühne proben","Watch Rehearsal":"Probe ansehen","Answered by:":"Beantwortet von:","Speaker Off":"Lautsprecher aus","Speaker On":"Lautsprecher ein","Speaker Controls":"Speaker-Steuerung","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"Alle Bühnenelemente befinden hinter dem geteilten Bild. Sie werden wieder sichtbar, sobald die Freigabe von Bildern im Vollbildmodus beendet ist.","Close Ticker Popup":"Ticker-Pop-up schließen","Open GIF Picker":"GIF-Picker öffnen","Open Emoji Picker":"Emoji-Picker öffnen","Send Message":"Nachricht senden","Tabs: Messaging and More":"Registerkarten: Messaging und mehr","Thanks for attending!":"Vielen Dank fürs Teilnehmen!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" Keine bevorstehenden Sitzungen in deinem abonnierten Track. Bitte wechsle zu anderen Tracks, um Live-Sitzungen zu sehen.","Redirecting you to ":"Weiterleitung zu ","in ":"in ","seconds":"Sekunden","Main Navigation":"Hauptnavigation","YOU ARE HERE":"DU BIST HIER","Live Now":"Jetzt live","SUBMIT":"EINREICHEN","Allocated time for engagement has ended. You will be redirected to main stage":"Die für das Engagement zugewiesene Zeit ist abgelaufen. Du wirst zur Hauptbühne weitergeleitet.","Wrap up in":"Endet in","Session overrun by":"Sitzung überschritten um","Ending in":"Endet in","Bring this session live?":"Diese Sitzung liveschalten?","START SESSION":"SITZUNG STARTEN","Bring this session to end?":"Diese Sitzung beenden?","END SESSION":"SITZUNG BEENDEN","Go On Stage":"Die Bühne betreten","Muted by organizer":"Vom Veranstalter stummgeschaltet","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"Einer der Event-Veranstalter hat deinen Ton stummgeschaltet. Du kannst die Stummschaltung aufheben, indem du auf die Mikrofon-Schaltfläche klickst.","Gifs":"GIFs","Stickers":"Sticker","Launch Survey":"Umfrage starten","Microphone is on":"Mikrofon ist eingeschaltet","Microphone is off":"Mikrofon ist ausgeschaltet","Secret Code’s length should be 6 digits":"Der geheime Code muss 6 Ziffern lang sein","Closing in 00:":"Schließen in 00:","Submit":"EINREICHEN","Questions":"Fragen","Preview":"Vorschau","Close Survey":"Umfrage schließen","This is a required question":"Das ist eine Pflichtfrage","Enter the text you’d like to present on stage below.":"Gib unten den Text ein,\\nden du auf der Bühne präsentieren möchtest.","Use Chrome/Edge for best performance":"Verwende Chrome/Edge für eine optimale Performance.","Do you want to launch your survey now?":"Möchtest du deine Umfrage jetzt starten?","Success! Your Survey has been launched for attendees.":"Das hat geklappt! Deine Umfrage wurde für die Teilnehmer/innen gestartet.","Unable to publish. Please try again.":"Veröffentlichen nicht möglich. Bitte versuche es erneut.","Are you sure you want to close this survey?":"Möchtest du diese Umfrage wirklich schließen?","Success! Your Survey has been closed for attendees.":"Das hat geklappt! Deine Umfrage wurde für die Teilnehmer/innen geschlossen.","Unable to un-publish. Please try again.":"Die Veröffentlichung kann nicht rückgängig gemacht werden. Bitte versuche es erneut.","Please answer all required questions.":"Bitte beantworte alle Pflichtfragen.","You have already submitted this survey.":"Du hast diese Umfrage bereits eingereicht.","Success! Thank you for your feedback.":"Das hat geklappt! Danke für deine Rückmeldung.","Unable to submit. Please try again.":"Einreichen nicht möglich. Bitte versuche es erneut.","Launch surveys will take over attendees\' engagement panel.":"Wenn du eine Umfrage startest, wird sie auf dem Engagement-Panel der Teilnehmer/innen angezeigt.","Closing this survey will remove it from attendees\' engagement panel.":"Wenn du diese Umfrage schließt, wird sie aus dem Engagement-Panel der Teilnehmer/innen entfernt.","Survey":"UMFRAGE","Updating Survey...":"Umfrage wird aktualisiert...","Closing":"Schließen","Goldcast needs access to your camera and microphone":"Goldcast benötigt Zugriff auf deine Kamera und dein Mikrofon","Goldcast needs access to your microphone":"Goldcast benötigt Zugriff auf dein Mikrofon.","Goldcast needs access to your camera":"Goldcast benötigt Zugriff auf deine Kamera.","SPEAKERS":"SPEAKER","Mark as Unanswered":"Als unbeantwortet markieren","Mark as Answered":"Als beantwortet markieren","Remove from Priority":"Aus Priorität entfernen","Mark as Priority":"Als Priorität markieren","Answer":"ANTWORTEN","Enter answer...":"Antwort eingeben …","Answered by":"Beantwortet von","Submit Answer":"Antwort abschicken","Test your system’s speaker":"Den Lautsprecher deines Systems testen","Click \\"Yes\\" if you hear the sound.":"Klicke auf „Ja“, wenn du den Ton hörst.","Load previous":"Vorheriges Element laden","Hide Name":"Name ausblenden","Text Q&A is disabled in On Demand mode.":"Text Q&A ist im On-Demand-Modus deaktiviert.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"Text Q&A-Grenze erreicht. Die Teilnehmer können keine neuen Fragen stellen.","Sent to Q&A":"An Q&A gesendet","Couldn\'t post as Q&A. Please try again.":"Konnte nicht als Q&A gepostet werden. Bitte erneut versuchen.","Yes this is being recorded":"Ja, das wird aufgezeichnet","No this is not being recorded":"Nein, das wird nicht aufgezeichnet","System\'s Speaker Check":"Test des Systemlautsprechers","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"Stelle sicher, dass die Lautsprecher deines Systems einwandfrei funktionieren, damit du während des Events etwas hören kannst.","Click on “Test your system’s speaker” to proceed":"Klicke auf „Den Lautsprecher deines Systems testen“, um fortzufahren","Error while sharing message to screen. Post not found":"Fehler beim Teilen der Nachricht auf dem Bildschirm. Beitrag nicht gefunden","Lost connection to servers. Refresh your page to get live event experience.":"Verbindung zu den Servern verloren. Aktualisiere deine Seite für ein Live-Event-Erlebnis.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"VPN/Firewall stört deine Authentifizierung. Bitte verwende ein anderes Netzwerk oder wende dich an dein IT-Team, um <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>diese Domains</a> für den reibungslosen Zugriff auf Goldcast zuzulassen.","It\'s taking too long":"Es dauert zu lange","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"Es scheint, dass du über VPN verbunden bist oder deine Firewall aktiviert hast. Bitte lies in diesem <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>Hilfedokument</a> nach, wie du die erforderlichen Domains auf die Whitelist setzt, damit Goldcast reibungslos funktioniert, oder verwende ein anderes Netzwerk.","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"Scheinbar bist du über VPN verbunden oder hast deine Firewall aktiviert. Bitte lies in diesem <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>Hilfedokument</a> nach, wie du die erforderlichen Domains auf die Whitelist setzt, damit Goldcast reibungslos funktioniert, verwende ein anderes Netzwerk oder schau dir die Sitzung im Lite-Modus an.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"Der Video-Streaming-Dienst von Goldcast kann aufgrund einer schlechten Netzwerkbandbreite keine Verbindung herstellen. Bitte verwende ein anderes Netzwerk, um dich mit dem Live-Streaming-Dienst zu verbinden.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"Der Video-Streaming-Dienst von Goldcast kann aufgrund einer schlechten Netzwerkbandbreite keine Verbindung herstellen. Bitte aktiviere den Lite-Modus oder verwende ein anderes Netzwerk, um dich mit dem Streaming-Dienst zu verbinden.","Most Upvotes":"Meiste positive Stimmen","Most Recent":"Neueste","My Questions":"Meine Fragen","Prioritized":"Priorisiert","Approved":"Genehmigt","Unapproved":"Nicht genehmigt","Unanswered":"Unbeantwortet","Failed to update answer. Please try again!":"Antwort konnte nicht aktualisiert werden. Bitte erneut versuchen!","Failed to post answer. Please try again!":"Antwort konnte nicht gepostet werden. Bitte erneut versuchen!","Failed to delete question. Please try again!":"Frage konnte nicht gelöscht werden. Bitte erneut versuchen!","Survey Link":"Link zur Umfrage","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"Wenn du wechselst, wird deine aktuelle Seite mit der Teilnehmer-Ansicht neu geladen. Wenn du zur Veranstalter-Ansicht zurückkehren willst, schalte die Teilnehmer-Ansicht im Dropdown-Menü „Profil“ aus.","You haven\'t asked any questions yet":"Du hast noch keine Fragen gestellt","No prioritized questions":"Keine priorisierten Fragen","Create prioritized list of questions for speakers by marking questions as priority":"Erstelle eine Liste mit priorisierten Fragen für Speaker, indem du Fragen als Priorität markierst","No Approved Questions":"Keine genehmigten Fragen","Approve incoming questions to see list of approved questions":"Genehmige eingehende Fragen, um eine Liste der genehmigten Fragen zu sehen","No Unapproved Questions":"Keine nicht genehmigten Fragen","No Answered Questions":"Keine beantworteten Fragen","Answer a question on stage or with inline text":"Eine Frage auf der Bühne oder mit Inline-Text beantworten","All questions are answered":"Alle Fragen werden beantwortet","Rate Your Experience":"Bewerte dein Erlebnis","How satisfied are you with Goldcast?":"Wie zufrieden bist du mit Goldcast?","What are the main reasons for your rating?":"Was sind die Hauptgründe für deine Bewertung?","I am interested in seeing a demo of Goldcast":"Ich bin an einer Demo von Goldcast interessiert","Thank You":"Vielen Dank","Your feedback was successfully submitted.":"Dein Feedback wurde erfolgreich übermittelt.","Tell us how we can improve...":"Sag uns, wie wir uns verbessern können …","1 Slide":"1 Folie","Your internet connection is unstable.":"Deine Internetverbindung ist instabil.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"Scheinbar ist dein Mikrofon stumm geschaltet. Klicke auf das Mikrofon-Symbol, um die Stummschaltung aufzuheben.","The registration could not be completed! Please check that this email is allowed to register for the event.":"Die Registrierung konnte nicht abgeschlossen werden! Bitte vergewissere dich, dass eine Registrierung für das Event mit dieser E-Mail-Adresse möglich ist.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Sieht so aus, als wären Sie bereits für dieses Event registriert. Bitte sehen Sie nach, ob die Anmeldebestätigung in Ihrem Spam-Ordner gelandet ist, wenn Sie sie nicht erhalten haben. Wenn Sie weitere Hilfe benötigen, wenden Sie sich bitte an den Veranstalter.","Your registration could not be completed. This event has reached its registration capacity.":"Deine Registrierung konnte nicht abgeschlossen werden. Dieses Event hat seine Anmeldekapazität erreicht.","Image cannot be an svg":"Bild darf kein SVG sein","This should be a valid linkedin url":"Sollte eine gültige LinkedIn-URL sein","This should be a valid twitter url":"Sollte eine gültige Twitter-URL sein","This should be a valid url":"Sollte eine gültige URL sein","Video":"Video","Read Less":"Weniger lesen","live":"LIVE","Opened":"Geöffnet","In person only":"Nur für Teilnehmer vor Ort","Stage Stream":"Bühnen-Stream","Streaming not available":"Streaming nicht verfügbar","Close TV":"Fernseher-Ansicht schließen","Streaming is not available for prerecorded and RTMP sessions":"Streaming ist für voraufgezeichnete und RTMP-Sitzungen nicht verfügbar","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Verbinde deinen Computer mit einem TV-Bildschirm oder Projektor, damit deine Teilnehmer vor Ort sehen können, was auf deiner virtuellen Bühne passiert, inklusive Folien, Q&A usw. Klicke nach dem Herstellen der Verbindung auf „TV ÖFFNEN“ und ziehe oder teile das neue Fenster auf den bzw. dem TV-Bildschirm oder Projektor. ","Close Setup Mode":"Setup-Modus schließen","Help":"Hilfe","upcoming":"Bevorstehende","ended":"Beendet","Remove from favorites":"Aus Favoriten entfernen","Add to favorites":"Zu Favoriten hinzufügen","PLAY RECORDING":"Aufzeichnung abspielen","VIEW RECORDING":"AUFZEICHNUNG ANZEIGEN","VIEW RECORDINGS":"AUFZEICHNUNGEN ANZEIGEN","Virtual Backgrounds":"Virtuelle Hintergründe","No Device Available":"Kein Gerät verfügbar","Needs permission":"Genehmigung erforderlich","Device not detected":"Gerät nicht erkannt","Camera is on":"Kamera ist eingeschaltet","Camera is off":"Kamera ist ausgeschaltet","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"Ein gespiegeltes Video wird den Zuschauern nicht angezeigt. Die Zuschauer sehen immer ein nicht gespiegeltes Video","Mirror My Video":"Mein Video spiegeln","Camera":"KAMERA","1. Click on Safari > Settings for this\\n            website":"1. Klicke auf Safari > Einstellungen für diese Website.","1. Click the lock":"1. Klicke in der Adressleiste deines Browsers","icon in your browser’s address bar":"auf das Schloss-Symbol.","3. Unmute":"3. Stummschaltung aufheben","and":"und","icons from stage control panel":"Symbole aus dem Bühnenbedienfeld","icon from stage control panel":"Symbol aus dem Bühnenbedienfeld","2. Set camera and microphone to “Allow”.":"2. Stelle Kamera und Mikrofon auf „Erlauben“.","2. Set camera to “Allow”.":"2. Stelle die Kamera auf „Erlauben“.","2. Set microphone to \\"Allow\\"":"2. Stelle das Mikrofon auf „Erlauben“.","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. Wähle „Goldcast immer erlauben, auf deine Kamera und dein Mikrofon zuzugreifen“.","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. Wähle „Goldcast immer erlauben, auf deine Kamera zuzugreifen“.","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. Wähle „Goldcast immer erlauben, auf dein Mikrofon zuzugreifen“.","Questions?":"Fragen?","If you’re having issues, check out our comprehensive":"Sollte ein Problem auftreten, findest du Unterstützung in unserer umfassenden","help docs":"Hilfedokumentation","Speaker is on":"Lautsprecher ist eingeschaltet","Stop Test":"Test stoppen","Test your system’s audio":"Die Audiowiedergabe deines Systems testen","Still can\'t hear any sound?":"Du kannst immer noch keinen Ton hören?","Microphone":"MIKROFON","Audio is being played in system\'s default audio device.":"Audio wird auf dem Standardaudiogerät des Systems abgespielt.","Click to view/change audio device":"Zum Anzeigen/Ändern des Audiogeräts klicken","Speaker":"Speaker","Play Recording":"Aufzeichnung abspielen","Recording for this broadcast is currently being processed and will be available soon":"Die Aufzeichnung für diese Sendung wird derzeit noch bearbeitet und wird in Kürze verfügbar sein.","You haven\'t favorited anything yet!":"Du hast noch nichts als Favorit markiert!","Add an item to favorites by selecting the ♡ in the top right corner.":"Um etwas zu deinen Favoriten hinzuzufügen, musst du nur das ♡ in der oberen rechten Ecke auswählen.","Session has ended":"Sitzung wurde beendet","System Check":"Systemtest","Need help? Check out the":"Brauchst du Hilfe? Überprüfe","Skip Checks and Continue":"Tests überspringen und fortfahren","Click the button above to run the test":"Zum Ausführen des Tests auf den Knopf oben drücken","Test Screenshare":"Bildschirmfreigabe testen","Share message to stage":"Nachricht für Bühne freigeben","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"Gib unten den Text ein, den du für den Ticker verwenden möchtest. Um den Ticker in einen Hyperlink zu verwandeln, gib eine URL ein.","Ticker":"Ticker","Coffee Break! Be back in 10m.":"Kaffeepause! Bin in 10 Minuten zurück.","Enter Message":"Nachricht eingeben","https://www.xyz.com":"https://www.xyz.com","Launch":"Start","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Vielen Dank, dass du deine Fragen eingereicht hast. Du kannst eine weitere einreichen, sobald eine deiner vorherigen Fragen genehmigt wurde.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"Q&A ist derzeit deaktiviert. Du kannst deine Frage einreichen, sobald Q&A wieder aktiviert ist.","Votes":"Stimmen","Vote":"Stimme","is inviting you to a video call":"lädt dich zu einem Videoanruf ein","ENTER ROOM":"RAUM BETRETEN","Start the conversation!":"Starten Sie die Unterhaltung!","Couldn\'t send message. Click here to retry.":"Nachricht konnte nicht gesendet werden. Hier klicken für einen erneuten Versuch.","Couldn\'t add emoji. Please try again.":"Emoji konnte nicht hinzugefügt werden. Bitte erneut versuchen.","Couldn\'t remove emoji. Please try again.":"Emoji konnte nicht entfernt werden. Bitte erneut versuchen.","Couldn\'t delete message. Please try again.":"Nachricht konnte nicht gelöscht werden. Bitte erneut versuchen.","Couldn\'t pin message. Please try again.":"Nachricht konnte nicht angeheftet werden. Bitte erneut versuchen.","Couldn\'t unpin message. Please try again.":"Nachricht konnte nicht entfernt werden. Bitte erneut versuchen.","Today":"Heute","No messages yet":"Noch keine Nachrichten","Messages from organizers and speakers appear here!":"Nachrichten von Veranstaltern und Speakern werden hier angezeigt.","Next Session is Starting":"Die nächste Sitzung beginnt","Go to Next Session":"Weiter zur nächsten Sitzung","I’d like to stay":"Ich möchte bleiben","My favorites":"Meine Favoriten","1. Click on the lock icon in your address bar":"1. Klicke auf das Schloss-Symbol in deiner Adressleiste.","We recommend organizers and speakers use a desktop\\n        device":"Wir empfehlen Veranstaltern und Speakern, ein Desktop-Gerät zu verwenden","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"Um das beste Erlebnis für Teilnehmer zu gewährleisten, müssen Speaker und Veranstalter\\n Goldcast von einem Desktop aus verwenden. Die Übertragung von einem mobilen Gerät aus führt\\nzu einem schlechteren Erlebnis.","Watch Now":"Jetzt ansehen","Video progress time":"Videofortschrittszeit","Total video duration":"Gesamtdauer des Videos","Rate Goldcast!":"Bewertung für Goldcast abgeben","Running Required Checks...":"Erforderliche Tests werden ausgeführt …","Test Your Setup":"Prüfen Sie Ihre Einrichtung","Test your Computer Device, Microphone and Camera before you join the event":"Teste deinen Computer, dein Mikrofon und deine Kamera, bevor du am Event teilnimmst","Speaker and microphone not working?":"Lautsprecher und Mikrofon funktionieren nicht?","Passed":"Bestanden","Fix Audio Issues":"Audioprobleme beheben","Check if audio is being played in other sound devices connected to phone/tablet":"Überprüfe, ob Audio auf anderen Audiogeräten wiedergegeben wird, die mit dem Telefon/Tablet verbunden sind.","Check if correct audio device is chosen from the below dropdown":"Prüfe, ob das richtige Audiogerät aus dem unten stehenden Dropdown-Menü ausgewählt wurde","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>Klicke hier</a>, um zu überprüfen, ob das richtige Audiogerät für die Audiowiedergabe ausgewählt wurde","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Klicke hier</a>, um zu überprüfen, ob das richtige Audiogerät für die Audiowiedergabe ausgewählt wurde","Right click on the browser tab & click “Unmute Site”":"Klicke mit der rechten Maustaste auf den Browser-Tab und dann auf „Stummschaltung für Website aufheben“.","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Prüfe, ob die Registerkarte des Browsers stumm geschaltet ist, oder klicke auf Fenster > Diese Registerkarte stumm schalten","System Check Failed!":"Systemtest fehlgeschlagen!","System Check Passed!":"Systemtest bestanden!","Complete checks to proceed":"Zum Fortfahren Tests abschließen","Enter Event":"An Event teilnehmen","Skip Screen Sharing Check? ":"Überprüfung der Bildschirmfreigabe überspringen? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"Wir empfehlen, die Überprüfung der Bildschirmfreigabe durchzuführen, wenn dein Bildschirm während des Events gezeigt werden soll","Ignore & Enter Event":"Ignorieren und Event beitreten","Test screenshare":"Bildschirmfreigabe testen","Retry Now":"Jetzt erneut versuchen","SHARE":"Freigeben","Rooms Closed":"Räume geschlossen","Discussion rooms are now closed. You are being redirected to the Stage.":"Diskussionsräume sind jetzt geschlossen. Du wirst zur Bühne weitergeleitet.","Return To Stage":"ZURÜCK ZUR BÜHNE","Unrecognized embedded widget provider - ":"Unbekannter Anbieter eingebetteter Widgets – ","Room Ended":"Raum wurde beendet","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"Der Veranstalter hat alle Räume geschlossen. Du wirst nun zur Eventbühne weitergeleitet.","Video Q&A Request Cancelled":"Anfrage für Video-Q&A abgebrochen","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Deine Anfrage für Video-Q&A wurde abgebrochen, da du den Lite-Modus aktiviert hast. Wechsle in den Live-Modus, um erneut die Hand zu heben.","Camera Passed":"Kamera bestanden","Camera Error":"Kamera-Fehler","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"Kamera-Berechtigungen werden vom Browser nicht erteilt. Klicke auf „Kamera zulassen“.","Camera permissions aren’t granted from system. Click “Allow Camera”":"Kamera-Berechtigungen werden vom System nicht erteilt. Klicke auf „Kamera zulassen“.","Uh-oh! Error occurred while creating camera stream":"Oh, oh! Beim Erstellen des Kamera-Streams ist ein Fehler aufgetreten","Close other applications which might use camera stream":"Schließe andere Anwendungen, die möglicherweise den Kamera-Stream verwenden","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>Klicke hier</a>, um zu überprüfen, ob der Browser Zugriff auf die Kamera hat.","Microphone Passed":"Mikrofon bestanden","Microphone Error":"Mikrofon-Fehler","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"Mikrofon-Berechtigungen werden vom Browser nicht erteilt. Klicke auf „Mikrofon zulassen“.","Mic permissions aren’t granted from system. Click “Allow Microphone”":"Mikrofon-Berechtigungen werden vom System nicht erteilt. Klicke auf „Mikrofon zulassen“.","Uh-oh! Error occurred while creating mic stream":"Oh, oh! Beim Erstellen des Mikrofon-Streams ist ein Fehler aufgetreten","Close other applications which might use mic stream":"Schließe andere Anwendungen, die möglicherweise den Mikrofon-Stream verwenden","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>Klicke hier</a>, um zu überprüfen, ob der Browser Zugriff auf das Mikrofon hat","Speaker and Microphone Error":"Lautsprecher- und Mikrofon-Fehler","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"Mikrofon-Berechtigungen sind erforderlich, um die Liste der an das System angeschlossenen Lautsprecher anzuzeigen. Klicke auf „Mikrofon zulassen“.","It seems mic is being used by other application. Close other applications to proceed.":"Scheinbar wird das Mikrofon von einer anderen Anwendung verwendet. Schließe andere Anwendungen, um fortzufahren.","Camera & Microphone Error":"Kamera- und Mikrofon-Fehler","To enable permissions, click the Allow Camera & Mic button below":"Um Berechtigungen zu aktivieren, klicke unten auf die Schaltfläche „Kamera und Mikrofon zulassen“.","Network Connection":"Netzwerkverbindung","Check Passed":"Prüfung bestanden","Could not establish a network connection":"Netzwerkverbindung fehlgeschlagen","Connect to a different network, or use a mobile hotspot.":"Verbinde dich mit einem anderen Netzwerk oder verwende einen mobilen Hotspot.","Disable any VPN or firewall is connected.":"Deaktiviere etwaige verbundene VPNs oder Firewalls.","Connection: Good":"Verbindung: Gut","Network Connection Error":"Netzwerkverbindungsfehler","Can’t connect to network. Change your network or limited functionality will be available during event.":"Verbindung zum Netzwerk fehlgeschlagen. Wähle ein anderes Netzwerk, um Funktionseinschränkungen zu verhindern.","AdBlocker":"Adblocker","AdBlocker not detected.":"AdBlocker nicht erkannt.","AdBlocker detected. This may degrade your event experience.":"Adblocker erkannt. Dieser kann dein Erlebnis beeinträchtigen.","Disable adblocker for best experience.":"Deaktiviere den Adblocker für eine optimale Erfahrung.","You are using ":"Du verwendest ","Use Windows or Mac OS for best performance":"Verwende Windows oder macOS für eine optimale Erfahrung","Browser Check":"Browsertest","Check Passed.":"Prüfung bestanden.","Switch To Lite Mode":"Zum Lite-Modus wechseln","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Deine ausstehende Anfrage für Video-Q&A wird abgebrochen, sobald du in den Lite-Modus wechselst","Stay on Live Mode":"Im Live-Modus bleiben","Unable to mark as favorite":"Kann nicht als Favorit markiert werden","Event organizers must enter the event to select favorites.":"Veranstalter müssen am Event teilnehmen, um Favoriten auszuwählen.","Make an Announcement":"Eine Ankündigung machen","STOP":"STOPP","InPerson CheckIn App":"App zum Vor-Ort-Check-in","App to Check-In In-Person attendees":"App zum Einchecken von Teilnehmern vor Ort","SEE AGENDA":"AGENDA ANSEHEN","Please visit the Agenda tab to view the session recordings":"Bitte besuche die Registerkarte „Agenda“, um die Sitzungsaufzeichnungen anzuzeigen.","The session recordings will be available soon in the Agenda tab":"Die Sitzungsaufzeichnungen werden in Kürze auf der Registerkarte „Agenda“ verfügbar sein.","FAILED!":"AKTION FEHLGESCHLAGEN","Next session is beginning":"Nächste Sitzung beginnt","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"Möchtest du mit der nächsten Sitzung fortfahren? Der Stream wird fortgesetzt und dein Fernseher überträgt die neue Sitzung.","Banners":"Banner","Images":"Bilder","Screen Share":"Bildschirmfreigabe","Browser might not have screen-recording permission on your computer.":"Der Browser hat möglicherweise keine Berechtigung zur Bildschirmaufzeichnung auf deinem Computer.","Open System Preferences":"Systemeinstellungen öffnen","Error publishing screen because someone else started screen share already.":"Fehler bei der Freigabe deines Bildschirms, da bereits jemand anderes mit der Bildschirmfreigabe begonnen hat.","Live Feed":"Live-Feed","Check Your Network":"Überprüfe dein Netzwerk","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"Beim Abspielen des Videos ist ein Fehler aufgetreten! Wenn du Probleme mit der Videowiedergabe hast, aktualisiere die Seite oder aktiviere den Lite-Modus.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"Beim Abspielen des Videos ist ein Fehler aufgetreten! Wenn du Probleme mit der Videowiedergabe hast, aktualisiere die Seite.","All Dates":"Alle Termine","All Tracks":"Alle Tracks","Create Ticker":"Ticker erstellen","Booths Closed":"Infostände geschlossen","Your event organizer has closed all the booths. You will now be redirected to the stage":"Der Veranstalter hat alle Infostände geschlossen. Du wirst nun zur Bühne weitergeleitet.","Visit the Polls tab to view live results.":"Besuche die Registerkarte „Umfragen“, um Live-Ergebnisse anzuzeigen.","A new poll is open! Visit the Polls tab to vote.":"Eine neue Umfrage wurde geöffnet! Besuche die Registerkarte „Umfragen“, um abzustimmen.","Vote for Polls":"Nimm an Umfragen teil","Go to Polls Tab":"Zur Registerkarte „Umfragen“","Microphone audio too low":"Mikrofonlautstärke zu niedrig","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"Wir haben ein Problem mit deiner Audioausgabe festgestellt. Wir empfehlen, das Mikrofon erst stummzuschalten und dann die Stummschaltung wieder aufzuheben. Wenn das Problem danach weiterhin besteht, kannst du auch ein anderes Gerät verwenden.","Audio/Video bitrate too low":"Audio-/Videobitrate zu niedrig","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"Die Einstellungen deiner Netzwerk-Firewall blockieren die A/V-Streams. Wir empfehlen dir, eine andere Netzwerkverbindung zu verwenden.","Error sharing screen":"Fehler bei der Bildschirmfreigabe","A network error occurred while sharing screen. Please check your network connection.":"Bei der Bildschirmfreigabe ist ein Netzwerkfehler aufgetreten. Bitte überprüfe deine Netzwerkverbindung.","Apologies, due to some errors, we need to refresh the page!":"Die Seite muss aufgrund einiger Fehler neu geladen werden.","Warning":"Achtung","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"Es gibt ein Problem mit deinem Video. Wir empfehlen, andere Browser-Tabs oder Anwendungen auf deinem Gerät zu schließen und deine Internetverbindung zu überprüfen bzw. die Verbindung neu herzustellen, um dieses Problem zu beheben.","No results found":"Keine Ergebnisse gefunden","Audio":"Audio","Please choose another microphone and camera":"Bitte wähle ein anderes Mikrofon und eine andere Kamera","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"Das aktuell ausgewählte Mikrofon und die Kamera funktionieren nicht. Bitte wähle aus den Dropdown-Listen unten ein anderes Mikrofon und eine andere Kamera aus.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"Die aktuell ausgewählte Kamera funktioniert nicht. Bitte wähle im Drop-down-Menü unten eine andere Kamera aus.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"Du kannst gerne ohne Kamera weitermachen, wir empfehlen jedoch, den Konflikt zu lösen, um eine reibungslose Übertragung zu gewährleisten","Please choose another microphone":"Bitte wähle ein anderes Mikrofon","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"Das aktuell ausgewählte Mikrofon funktioniert nicht. Bitte wähle aus der Dropdown-Liste unten ein anderes Mikrofon aus.","Please check that your TV speaker is correct":"Bitte überprüfe, ob dein TV-Lautsprecher korrekt ist","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"Der aktuell ausgewählte Lautsprecher funktioniert nicht. Bitte wähle aus der Dropdown-Liste unten einen anderen Lautsprecher aus.","Your answer":"Deine Antwort","Edit":"Bearbeiten","Delete":"Löschen","Settings":"Einstellungen","Signing Out":"Du wirst abgemeldet","Confirming your account...":"Dein Konto wird bestätigt ...","Something Went Wrong. Please Retry :(":"Etwas ist schiefgelaufen. Bitte versuch\'s noch mal :(","Resending Mail":"E-Mail wird erneut gesendet","offline":"offline","I am inviting you to a video meeting:":"Ich lade Sie zu einem Videomeeting ein:","Resending secure login link to your email":"Der sichere Anmeldungslink wird erneut an deine E-Mail-Adresse gesendet.","Sending secure login link to your email":"Der sichere Anmeldungslink wird an deine E-Mail-Adresse gesendet.","Something went Wrong. Please Retry :(":"Etwas ist schiefgelaufen. Bitte versuch\'s noch mal :(","Updating your password":"Dein Passwort wird aktualisiert","Sending mail":"E-Mail wird gesendet","Verifying":"Überprüfung läuft","This might be slower than usual":"Dieser Prozess kann langsamer als üblich ablaufen","Checking":"Wird überprüft","New results available! Refresh!":"Neue Ergebnisse verfügbar! Laden Sie die Seite neu.","Saving":"Wird gespeichert","Turn off Attendee mode":"Teilnehmer-Modus deaktivieren","See Attendee View":"Teilnehmer-Ansicht anzeigen","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Gesamtanzahl der Teilnehmer, die aktuell diese Sitzung ansehen Hinweis: Das sollten nur Veranstalter sehen","Session Count":"Sitzungsanzahl","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"Die Anzahl der Teilnehmer, die aktuell Live-Sitzungen ansehen. Hinweis: Das sollten nur Veranstalter sehen.","Role":"Rolle","Total Attendees":"Teilnehmer insgesamt","Total number of attendees online at this time Note: This is for organizer eyes only":"Gesamtanzahl der Teilnehmer, die aktuell online sind Hinweis: Das sollten nur Veranstalter sehen","My Profile":"Mein Profil","Languages":"Sprachen","Filling out your profile can help you connect with people with similar interests.":"Indem Sie Ihr Profil ausfüllen, können Sie leichter mit Menschen mit ähnlichen Interessen in Kontakt treten.","type to search for your address":"Gib etwas ein, um nach deiner Adresse zu suchen","Could not open direct call":"Es konnte kein direkter Anruf geöffnet werden","Chat messages can only be published from inside a broadcast.":"Chat-Nachrichten können nur aus einer Übertragung veröffentlicht werden.","Stage Logo can only be published from inside a broadcast.":"Das Bühnenlogo kann nur aus einer Übertragung veröffentlicht werden.","Loading Speakers":"Speaker werden geladen","Raise hand is disabled for organizer accounts, but active for attendee accounts":"„Hand heben“ ist für Veranstalterkonten deaktiviert, aber für Teilnehmerkonten aktiviert.","Disabled in lite mode, return to live if you’d like to raise hand!":"Diese Funktion ist im Lite-Modus deaktiviert. Kehren Sie zu Live zurück, um Ihre Hand zu heben.","Raise hand to enter stage for video q&a":"Heben Sie Ihre Hand, um die Bühne für das Video-Q&A zu betreten.","Speakers":"Speaker","Hosting organization: {organization}":"Veranstalter-Organisation: {organization}","Failed to switch {deviceTag}":"Wechsel auf {deviceTag} fehlgeschlagen","Make sure your {deviceTag} is not being used by any other application and is working properly.":"Achte darauf, dass dein {deviceTag} nicht von einer anderen Anwendung verwendet wird und ordnungsgemäß funktioniert.","Facing issues with audio or video? Switch on lite mode":"Probleme mit Audio oder Video? Lite-Modus aktivieren","Failed to get event for eventID: {eventID}":"Event für eventID {eventID} konnte nicht abgerufen werden","Error while playing video.":"Fehler bei Videowiedergabe","Speakers only, attendees can\'t see this chat":"Nur für Speaker, Teilnehmer können diesen Chat nicht sehen","Kudo":"Kudo","Room":"Raum","Session":"Sitzung","Booth":"Infostand","Public":"Öffentlich","Drift":"Drift","Slides":"Folien","Videos":"Videos","Chat":"Chat","Messages":"Nachrichten","Poll":"Umfrage","Docs":"Dokumente","Q&A":"Häufige Fragen","Media":"Medien","Messages Chat":"Nachrichten-Chat","Leaderboard":"Rangliste","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Hinweis: Du bist außerdem Speaker für dieses Event. Du kannst jederzeit den Backstagebereich betreten und auf die Bühne gehen.","Switch to Attendee View":"Zu Teilnehmer-Ansicht wechseln","Return to Organizer View":"Zu Veranstalter-Ansicht zurückkehren","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"Wenn du die Teilnehmer-Ansicht ausschaltest, wird deine aktuelle Seite neu geladen und du kehrst zur Veranstalter-Ansicht zurück. Möchtest du fortfahren?","Switch":"WECHSELN","Request Sent":"Anfrage gesendet","Your request for a demo has been submitted":"Deine Anfrage für eine Demo ist eingegangen.","Organizer Redirection":"Veranstalter-Weiterleitung","YES, REDIRECT":"JA, WEITERLEITEN","DISMISS":"ABLEHNEN","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"Teilnehmer werden zur nächsten Sitzung weitergeleitet: {title}. Möchtest du auch zur nächsten Sitzung weitergeleitet werden?","Stage":"Bühne","Rooms":"Räume","Join a round table to discuss moderated topics with your fellow attendees":"Nehmen Sie an einem runden Tisch teil, um mit anderen Teilnehmern ein moderiertes Gespräch zu führen","Booths":"Infostände","Join a booth to know more about a sponsor":"Nehmen Sie an einem Infostand teil, um mehr über einen Sponsor zu erfahren","You are in the booth":"Sie sind im Infostand.","People":"Personen","Connect with your fellow attendees":"Mit anderen Teilnehmern in Verbindung treten","Connect with speakers":"Mit Speakern in Verbindung treten","starting in {duration}":"startet in {duration}","You will be redirected to booths in {duration}":"Du wirst in {duration} an Stände weitergeleitet.","booths":"Infostände","agenda":"Agenda","You will be redirected to {word} in {duration}":"Du wirst in {duration} an {word} weitergeleitet.","You will be redirected to the live stage in {duration}":"Du wirst in {duration} auf die Live-Bühne weitergeleitet.","- You are about to be redirected to {tabTitle} in {duration}":"– Du wirst in {duration} an {tabTitle} weitergeleitet.","See Agenda":"Agenda ansehen","Break":"PAUSE","{title} is now live":"{title} ist jetzt live.","Apologies, due to an error we need to refresh the page!":"Leider müssen wir die Seite neu laden, es gab einen Fehler!","Network interruption detected":"Netzwerkunterbrechung festgestellt","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"Deine Internetverbindung hat Probleme. Wenn du ein VPN benutzt, kannst du es vorübergehend deaktivieren oder es mit einem anderen Netzwerk versuchen.","No audio output device detected":"Es wurde kein Audio-Ausgabegerät erkannt.","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Bitte verbinde deine Lautsprecher/Kopfhörer und teste sie mit dem Zahnrad-Symbol, falls du Probleme hast.","Please disable ad blocker for this page":"Bitte deaktiviere den Werbeblocker für diese Seite.","Yes, I understand":"Ja, ich verstehe","No event user found so attended not marked!":"Kein Eventnutzer gefunden, daher keine Teilnahme markiert!","Wait while the speaker approves your video q&a request":"Warten Sie, bis der Speaker Ihre Anfrage für ein Video-Q&A bestätigt hat.","Organizer":"Veranstalter:in","UPNEXT":"als Nächstes","Ended":"Beendet","Hide":"Ausblenden","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"Diese Seite leitet dich in {durationLeftToRedirect} Sekunden automatisch weiter.","Register":"Registrieren","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Fehler: Benutzer konnte nicht für dieses Event registriert werden. Bitte kontaktiere den Veranstalter für weitere Hilfe.","You are already registered!":"Sie sind bereits registriert!","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Sieht so aus, als wärst du bereits für dieses Event registriert. Wenn du die Anmeldebestätigung nicht erhalten hast, sieh bitte nach, ob sie in deinem Spam-Ordner gelandet ist. Wenn du weitere Hilfe benötigst, wende dich bitte an den Veranstalter.","Thank you for registering!":"Vielen Dank für Ihre Registrierung!","Submit another response":"Weitere Antwort einreichen","Share":"Freigeben","Know someone who want to attend this?":"Kennen Sie jemanden, der daran teilnehmen möchte?","COPY LINK":"LINK KOPIEREN","Powered by":"Powered by","VIEW PROFILE":"PROFIL ANZEIGEN","You can access the event landing here":"Du kannst hier auf das Event zugreifen.","Need Help?":"Brauchst du Hilfe?","Welcome back":"Willkommen zurück","Checking...":"Wird überprüft …","Close":"Schließen","Enter":"Beitreten","See {roomCount} Room(s)":"{roomCount} Raum/Räume anzeigen","Back":"Zurück","Request a Demo":"Eine Demo anfordern","Loading":"wird geladen","Thread":"Thread","Load more":"Mehr laden","Heads up!":"Achtung!","YES":"JA","No":"Nein","Following":"Folgt","Error in loading drimify":"Fehler beim Laden von drimify","You\'re not registered for this event":"Sie sind nicht für dieses Event registriert","Check out other events":"ANDERE EVENTS ANSEHEN","Date":"Datum","Location":"Standort","How are you attending the event":"Wie nimmst du am Event teil?","In Person":"Persönlich","Virtually":"Virtuell","Event Widgets":"Event-Widgets","Chat • Messages • Q&A • Poll • Docs":"Chat • Nachrichten • Q&A • Umfrage • Dokumente","DISCUSSION":"BESPRECHUNG","JOIN":"TEILNEHMEN","WAIT":"WARTEN","more":"mehr","See Profile":"Profil anzeigen","Filter":"Filter","Video player not supported by your browser":"Video-Player wird von Ihrem Browser nicht unterstützt","We recommend using the latest version of Google Chrome to access your conference":"Wir empfehlen für den Zugriff auf deine Konferenz die neueste Version von Google Chrome.","ANSWER":"ANTWORTEN","REJECT":"ABLEHNEN","Don’t ask me this next time":"Nächstes Mal nicht mehr fragen","Cancel":"Abbrechen","Lite Mode":"Lite-Modus","On":"ein","Connection Issues? Turn on Lite Mode":"Verbindungsprobleme? Lite-Modus aktivieren","Turn On Lite Mode":"Lite-Modus aktivieren","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"Im Lite-Modus kommt es zu einer Verzögerung von 30 Sekunden zwischen der Live-Übertragung und den Inhalten, die Sie auf Ihrem Bildschirm sehen. Möchten Sie fortfahren?","Turn On":"Aktivieren","Lite Mode Active!":"Lite-Modus aktiv!","Thanks for your patience, lite mode now on!":"Vielen Dank für Ihre Geduld! Der Lite-Modus ist jetzt aktiviert.","Turn off Lite Mode?":"Lite-Modus deaktivieren?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Der Lite-Modus wird ausgeschaltet, um zur Live-Übertragung zurückzukehren. Dies wird zu einer Verzögerung von 30 Sekunden führen.","Lite Mode Off!":"Lite-Modus aus!","Thanks for your patience, we’ve returned to the live broadcast!":"Vielen Dank für Ihre Geduld! Wir sind zur Live-Übertragung zurückgekehrt.","Lite Mode Unavailable":"Lite-Modus nicht verfügbar","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Der Lite-Modus ist im Moment nicht verfügbar. Bitte entschuldigen Sie die Unannehmlichkeiten. Wechseln Sie zur Live-Übertragung, um Ihre Sitzung fortzusetzen.","Turn off Lite mode?":"Lite-Modus deaktivieren?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"Wir haben festgestellt, dass Ihre Verbindung wieder hergestellt wurde. Möchten Sie zur Live-Übertragung zurückkehren? Dies wird zu einer Verzögerung von 30 Sekunden führen.","Turn Off":"Deaktivieren","Lite mode is disabled for organizer accounts, but active for attendee accounts":"Der Lite-Modus ist für Veranstalterkonten deaktiviert, aber für Teilnehmerkonten aktiviert.","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"Der Lite-Modus wird in deinem Browser nicht unterstützt. Wir empfehlen dir, die neueste Version von Google Chrome zu nutzen.","Lite mode is not curently available. We’ll let you know once it’s available again":"Der Lite-Modus ist derzeit nicht verfügbar. Wir melden uns, wenn er wieder verfügbar ist.","Turn off Lite Mode":"Lite-Modus deaktivieren","We’ll let you know when Lite mode is available again":"Wir geben dir Bescheid, wenn der Lite-Modus wieder verfügbar ist","Lite Mode Available":"Lite-Modus verfügbar","Loading Lite Mode...":"Lite-Modus wird geladen …","Turning Off Lite Mode":"Lite-Modus wird deaktiviert","Lite Mode On":"Lite-Modus aktiv","Audio/Video Issues?":"Audio-/Video-Probleme?","Error":"Fehler","Click a video to play":"Klicke zur Wiedergabe auf ein Video.","Error starting video!":"Video konnte nicht gestartet werden!","Please rotate your device to {mode} mode":"Bitte drehe dein Gerät auf {mode}.","landscape":"Querformat","portrait":"Hochformat","Thank you for attending this event!":"Vielen Dank, dass Sie an diesem Event teilnehmen!","Go to Rooms":"Zu den Räumen","Please use a desktop or laptop Google Chrome browser to access your conference":"Bitte verwenden Sie den Google-Chrome-Browser auf einem Desktop oder Laptop, um auf Ihre Konferenz zuzugreifen","If on Desktop":"Falls du einen Desktop benutzt","Please increase the width of your window":"Bitte erhöhen Sie die Breite Ihres Fensters","Alternatively, check out the":"Sehen Sie sich alternativ Folgendes an:","Youtube Livestream":"YouTube-Livestream","Search":"Suchen","Profile":"Profil","Yes":"Ja","Loading Chat":"Chat wird geladen","Please wait while we fetch the chat":"Bitte warten Sie, während wir den Chat abrufen","Load old messages":"Alte Nachrichten laden","Join the room to see chat":"Dem Raum beitreten, um den Chat anzuzeigen","Live Chat":"Live-Chat","Uh..oh we couldn\'t load the content":"Hoppla, wir konnten die Inhalte nicht laden.","Please reload the page":"Bitte lade die Seite erneut.","New comments":"Neue Kommentare","Start the conversation":"Starten Sie die Unterhaltung!","Be the first to add to chat!":"Sagen Sie als Erste/r etwas im Chat!","Enter your message":"Geben Sie Ihre Nachricht ein","Joining chat!":"Chat wird geladen!","See all pinned messages":"Alle angehefteten Nachrichten anzeigen","Failed to send! Retry?":"Senden fehlgeschlagen! Erneut versuchen?","Search for attendee":"Nach Teilnehmer suchen","Up to date":"Aktuell","Start a new conversation, We think you\'ll enjoy":"Beginnen Sie ein neues Gespräch. Es wird Ihnen bestimmt gefallen,","chatting with these recommended attendees!":"mit diesen empfohlenen Teilnehmern zu chatten!","Searching":"Suche läuft","Load Previous":"Vorheriges Element laden","Load Next":"Nächstes Element laden","Loading Channel":"Kanal wird geladen","Please wait while we fetch the channel":"Bitte warten Sie, während wir den Kanal abrufen","Please wait while we fetch the messages":"Bitte warten Sie, während wir die Nachrichten abrufen","Send the first message":"Die erste Nachricht senden","Join":"Beitreten","link":"Link","download":"Download","Click to open":"Zum Öffnen anklicken","No open polls":"Keine offenen Umfragen","Check back later to see if a poll opens up!":"Sieh später noch einmal nach, ob eine Umfrage eröffnet wurde!","Loading Poll":"Umfrage wird geladen","Please wait while we fetch the polls":"Bitte warten Sie, während wir die Abstimmungen abrufen","Uh oh.. we couldn’t load the content":"Hoppla, wir konnten die Inhalte nicht laden.","Polls":"Umfragen","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"Zum Starten einer Umfrage füge die Fragen und die Antwortmöglichkeiten zu dieser Sitzung im Goldcast Admin-Panel hinzu.","Stop Sharing":"Freigabe beenden","Can\'t publish polls while something else is being presented on stage":"Du kannst keine Umfragen veröffentlichen, wenn auf der Bühne gerade etwas anderes präsentiert wird.","Open":"Öffnen","Cancel your video q&a request":"Anfrage für ein Video-Q&A zurückziehen","Pending...":"Ausstehend …","Leave Stage":"Bühne verlassen","Raise Hand":"Hand heben","Text Q&A":"Nachrichten-Q&A","Video Q&A":"Video-Q&A","Loading Q&amp;A":"Q&amp;A wird geladen","Please wait while we fetch the Q&amp;A":"Bitte warten Sie, während wir das Q&amp;A abrufen.","Uh oh.. we couldn\'t load the content":"Hoppla, wir konnten die Inhalte nicht laden.","No Questions Yet":"Noch keine Fragen","Tell your audience to send in questions!":"Sag deinen Zuschauern, dass sie Fragen einschicken sollen!","Be the first to ask a question!":"Stelle deine Frage zuerst!","Tell your audience to raise their hand!":"Sag deinen Zuschauern, dass sie ihre Hand heben können!","Approve":"Genehmigen","Reject":"Ablehnen","End":"Beenden","RELOAD":"NEU LADEN","Logos On Stage":"Logos auf der Bühne","No File Chosen":"Keine Datei ausgewählt","loading":"wird geladen","Can\'t publish a slide when there is something else being presented on stage":"Eine Folie kann nicht veröffentlicht werden, wenn auf der Bühne gerade etwas anderes präsentiert wird.","Change Deck":"Präsentation ändern","stop-screen-share":"bildschirmaufzeichnung-stoppen","screen-share":"bildschirmaufzeichnung","Select a deck to begin presenting":"Wählen Sie eine Präsentation aus, um mit dem Vortrag zu beginnen","CONFIRM":"BESTÄTIGEN","If you’re having issues, please refer to the":"Falls Probleme bestehen, werfen Sie bitte einen Blick auf","SPEAKER":"SPEAKER","Issue Testing Audio!":"Probleme beim Audio-Test!","VPN and adblockers may cause video issues, please disable them before proceeding":"VPN und Adblocker können Probleme mit Videos verursachen. Bitte deaktiviere diese, bevor du fortfährst.","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"VPN und Adblocker können Probleme mit Videos verursachen. Stellen Sie daher sicher, dass diese während der Übertragung deaktiviert sind.","Follow":"Folgen","Read More":"Mehr erfahren","Ask a question":"Eine Frage stellen","Shared":"Freigegeben","Answered":"Beantwortet","Waiting Approval":"Warten auf die Genehmigung","cancel":"abbrechen","ENTER":"TEILNEHMEN","Upcoming Events":"Anstehende Events","Past Events":"Vergangene Events","Goldcast":"Goldcast","MANAGE EVENT":"EVENT VERWALTEN","Edit Profile":"Profil bearbeiten","Stay tuned!":"Bleiben Sie dran!","Sign-in instructions will be available here 12 hours prior to the event":"Die Anmeldeanweisungen werden hier 12 Stunden vor dem Event verfügbar sein.","Please log out":"Bitte melde dich ab","Logout":"Abmeldung","Continue as {differentUser}":"Fortfahren als {differentUser}","You are already logged in as {user}.":"Du bist bereits als {user} angemeldet.","EMAIL":"E-MAIL-ADRESSE","user@email.com":"user@email.com","FIRST NAME":"Vorname","First Name":"Vorname","LAST NAME":"Nachname","Last Name":"Nachname","You are not registered to this event":"Du bist nicht für dieses Event registriert.","Please enter your email and name":"Bitte gib deine E-Mail-Adresse und deinen Namen ein.","Please enter your email":"Bitte gib deine E-Mail-Adresse ein.","We have sent a secret code to":"Wir haben einen geheimen Code gesendet an.","BACK":"ZURÜCK","Didn\'t receive an email? Make sure to check spam list":"Du hast keine E-Mail erhalten? Überprüfe bitte die Spam-Liste.","Resend Mail":"E-Mail erneut senden","SECRET CODE":"GEHEIMER CODE","Please enter the temporary password sent to your email":"Bitte gib das temporäre Passwort ein, das an deine E-Mail-Adresse gesendet wurde.","NEW PASSWORD":"NEUES PASSWORT","Please enter a new password":"Bitte gib ein neues Passwort ein.","CONFIRM PASSWORD":"PASSWORT BESTÄTIGEN","Please re-enter the new password":"Bitte gibt das neue Passwort erneut ein.","Password length should be atleast 8":"Das Passwort muss mindestens acht Zeichen lang sein","Password and Confirm Password don\'t match !!":"Das Passwort und die Bestätigung stimmen nicht überein!","Please enter your password to continue":"Bitte gib zum Fortfahren dein Passwort ein.","Logging you in...":"Sie werden eingeloggt …","PASSWORD":"PASSWORT","Forgot credentials?":"Zugangsdaten vergessen?","Forgot Password? A mail will be sent to your registered email.":"Passwort vergessen? Wir senden eine E-Mail an deine registrierte E-Mail-Adresse.","Email cannot be blank!!":"Die E-Mail-Adresse ist eine Pflichtangabe!","We have sent a secure login link to":"Wir haben einen sicheren Login-Link gesendet an","from":"von","Please use that to access your event.":"Bitte benutzen Sie diesen, um auf Ihr Event zuzugreifen.","Please check spam/promotion too if you can\'t find it.":"Bitte prüfen Sie auch den Spam-/Werbeordner, wenn Sie sie nicht finden können.","Thank You !":"Vielen Dank!","The link is not valid.":"Der Link ist ungültig.","Please be patient.":"Bitte hab Geduld.","We are verifying your link.":"Wir verifizieren deinen Link.","Thank you for entering the code!":"Danke, dass du den Code eingegeben hast!","Please create a new password":"Bitte lege ein neues Passwort fest.","Signing you up...":"Sie werden angemeldet …","We have sent a temporary password to":"Wir haben ein temporäres Passwort gesendet an","TEMPORARY PASSWORD":"TEMPORÄRES PASSWORT","Please enter the temporary password sent to your mail":"Bitte gib das temporäre Passwort ein, das an deine E-Mail-Adresse gesendet wurde.","Password Length should be 8":"Das Passwort muss acht Zeichen lang sein","Okay":"OK","Backstage: {title}":"Backstage: {title}","Prep Area":"Vorbereitungsbereich","Starting at {time}":"Beginnt um {time}","person":"Person","inside":"innen","No one is inside":"Niemand nimmt gerade teil","This area is for you to sync up with your fellow speakers before you go on stage.":"In diesem Bereich können Sie sich mit den anderen Speakern abstimmen, bevor Sie auf die Bühne gehen.","This area is for you to check your cam and mic before you enter the room.":"In diesem Bereich können Sie Ihre Kamera und Ihr Mikrofon überprüfen, bevor Sie den Raum betreten.","I\'m Ready":"Ich bin bereit","Watch Live":"Live ansehen","Backstage":"Backstage","You are sharing your screen":"Sie geben jetzt Ihren Bildschirm frei","LIVE":"LIVE","Live":"LIVE","Virtual":"Virtuell","Only available for ":"Nur verfügbar für ","See Booths":"Infostände anzeigen","See Rooms":"Räume anzeigen","Enter Backstage":"Backstage","This track has no upcoming sessions. Check out a different track.":"Für diese Spur liegen keine kommenden Sitzungen vor. Sieh dir eine andere Spur an.","View":"Anzeigen","Agenda":"Agenda","Scroll to see all tracks":"Scrollen, um alle Tracks anzuzeigen","No Agenda Items to show!":"Keine Agendapunkte anzuzeigen!","ENTER EVENT":"AN EVENT TEILNEHMEN","change":"ändern","Upload":"Hochladen","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF ODER PNG. MAX. GRÖSSE 5 MB","Create Profile":"Profil erstellen","Email":"E-Mail-Adresse","Company":"Firma","Title":"Titel","No matching locations found":"Keine passenden Standorte gefunden","You can try searching for the location with another keyword":"Sie können versuchen, mit einem anderen Begriff nach dem Standort zu suchen","Interest Tags":"Tags für Interessen","Pick your first tag":"Wählen Sie Ihren ersten Tag","Save":"Speichern","Searching...":"Wird gesucht …","Twitter":"Twitter","Select Your First Tags":"Wählen Sie Ihre ersten Tags aus","Add Interest tags":"Interessentags hinzufügen","Congratulations!":"Gratulation!","Your first Goldcast event is set up":"Dein erstes Goldcast-Event ist eingerichtet.","You can always visit":"Besuchen Sie","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"für Anweisungen zum Einrichten und Durchführen deiner Events.","See My Event":"Mein Event anzeigen","Peak Community":"Peak Community","Loading Lite Mode... This may take up to 30s":"Lite-Modus wird geladen … Dies kann bis zu 30 Sekunden dauern.","Loading Video...":"Video wird geladen …","Video will begin at session start time":"Das Video wird zur Anfangszeit der Sitzung starten","TIME":"ZEIT","TITLE":"TITEL","STATUS":"STATUS","END":"Beenden","START":"START","AGENDA":"AGENDA","Enable Audio":"Audio aktivieren","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"Der Ton wurde aufgrund der Autoplay-Richtlinien des Browsers stummgeschaltet. Klicken Sie unten auf „Aktivieren“, um die Stummschaltung aufzuheben. Sie können die Stummschaltung auch später über eingebettete Steuerelemente aufheben.","Enable":"Aktivieren","You are being redirected outside the room. Would you like to continue?":"Sie werden auf eine Seite außerhalb des Raums weitergeleitet. Möchten Sie fortfahren?","Continue":"Fortfahren","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"Alternativ kannst du auch den Lite-Modus verwenden, bei dem es gegenüber der Live-Übertragung zu einer 30-sekündigen Verzögerung kommt.","We detected a network issue":"Wir haben ein Netzwerkproblem festgestellt.","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Bitte vergewissere dich, dass du nicht über ein VPN bzw. eine Firewall verbunden bist. Versuche es mit einem anderen Netzwerk, Browser oder Gerät, falls das Problem weiterhin besteht.","Could not connect":"Verbindung fehlgeschlagen","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"Dies könnte auf ein Problem mit einem gesicherten Netzwerk oder einem Browser/Gerät zurückzuführen sein. Bitte versuche es mit einem anderen Netzwerk, Browser oder Gerät, falls das Problem weiterhin besteht.","Switch to Lite Mode":"Zum Lite-Modus wechseln","Leave":"verlassen","Screenshare had an issue":"Es gab ein Problem bei der Bildschirmfreigabe","Could not share screen unexpectedly. Refresh & retry. On mac go to":"Bildschirmfreigabe unerwartet fehlgeschlagen Aktualisieren und erneut versuchen Gehe auf Mac zu","and check if your browser has the required permission":"und prüfe, ob dein Browser über die erforderliche Berechtigung verfügt.","Uh OH... Something went wrong":"Leider ist etwas schiefgelaufen","To fix this, click the":"Um dies zu beheben, klicken Sie auf","in your URL bar, then select “Allow”, and then click “Try Again”":"in Ihrer URL-Leiste, klicken Sie dann auf „Zulassen“ und anschließend auf „Erneut versuchen“","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"Wir konnten deinen Medien-Stream aus unbekannten Gründen nicht initialisieren. Dein Browser wird vielleicht nicht von unserer Plattform unterstützt. Wir empfehlen Google Chrome. Wende dich an den Goldcast-Support, wenn das Problem weiterhin besteht.","To fix this, make sure your":"Um dies zu beheben, stellen Sie sicher, dass Ihr","is not being accessed by any other app. If not, please try changing your":"von keiner anderen App genutzt wird. Falls dies nicht der Fall ist, ändern Sie bitte Ihre","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"Geräte mit einem Klick auf „Zu den Einstellungen“. Klicke nach der Lösung des vermutlichen Problems auf „Erneut versuchen“.","Go To Settings":"Zu den Einstellungen","Try Again":"Erneut versuchen","Try Joining without Video":"Ohne Video teilnehmen","A refresh and rejoin should work":"Es sollte helfen, wenn du die Seite aktualisierst und erneut beitrittst.","Refresh & Rejoin":"Aktualisieren & erneut beitreten","Start Chat":"Chat starten","On Stage":"Auf die Bühne","Connect your on-site camera and microphone to present to your virtual attendees":"Verbinde deine Kamera und dein Mikrofon vor Ort, um Präsentationen für deine virtuellen Teilnehmer zu halten","Stop Streaming":"Streaming beenden","Start Streaming":"Streaming starten","Set up on-site video feed":"Videofeed vor Ort einrichten","Open TV":"Auf TV anzeigen","Layout: {layout} ":"Layout: {layout} ","With Speaker Videos":"Mit Speaker-Videos","Full Screen":"Vollbildmodus","No Speakers":"Keine Speaker","Turn Off Setup Mode":"Einrichtungsmodus ausschalten","Setup Mode":"Einrichtungsmodus","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"Bitte drücke auf „deaktivieren“, wenn du den Konfigurationsmodus für {roomTitle} verlassen möchtest. Hierdurch werden auch alle aktiven Streams deaktiviert.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"Stream-Vorbereitung: {roomTitle}. Verwende diesen Modus bitte nur, um vom Live-Standort aus zu streamen.","Starting in {duration}":"Beginnt in {duration}","Can\'t share screen while there is something else being presented on stage":"Du kannst keine Bildschirmfreigabe starten, wenn auf der Bühne gerade etwas anderes präsentiert wird.","You are now in attendee view!":"Du bist jetzt in der Teilnehmer-Ansicht!","You are now in organizer view!":"Du bist jetzt in der Veranstalter-Ansicht!","Note :":"Hinweis:","Only organizer accounts can see this tag, normal attendees can’t see this":"Nur Veranstalter-Konten können dieses Tag sehen, normale Teilnehmer hingegen nicht","Attendee":"Teilnehmer","Event Information":"Eventinformationen","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"Die Event-Informationen sind nur für Veranstalter sichtbar!<br /> Dieser Abschnitt ist für Teilnehmer nicht sichtbar","Operating System":"Betriebssystem","Secondary Booths":"Sekundäre Infostände","Sort":"Sortieren","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"Folgt {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2}folgt dir automatisch nicht mehr von {track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}Möchtest du fortfahren?","Track only available for {tracks}":"Track nur verfügbar für {tracks}","Add to Calendar":"Zum Kalender hinzufügen","Open Speakers Control Panel":"Kontrollmenü für Speaker öffnen","Move Offstage ↓":"Von der Bühne weg verschieben ↓","Error Moving ⚠":"Fehler beim Verschieben ⚠","Off Stage":"Abseits der Bühne","Move to Stage":"Auf die Bühne verschieben","An error occurred!":"Es ist ein Fehler aufgetreten!","{eventName} Documents":"{eventName} Dokumente"," Set Up Mode":" Einrichtungsmodus","Camera & Mic blocked":"Kamera und Mikrofon blockiert","Camera/Mic Inaccessible":"Kamera/Mikrofon nicht zugänglich","Camera/Mic Not Found":"Kamera/Mikrofon nicht gefunden","Camera Inaccessible":"Kamera nicht zugänglich","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"Die Kamera ist besetzt oder die Auflösung wird nicht unterstützt. Bitte sorge dafür, dass deine Kamera nicht von einer anderen Anwendung genutzt wird, und versuche es erneut!","No microphone/camera is found":"Kein Mikrofon/keine Kamera gefunden","The browser does not support using camera and microphone!":"Der Browser unterstützt die Verwendung von Kamera und Mikrofon nicht!","{n} Slides":"{n} Folien","Starting in {timeduration}":"Beginnt in {timeduration}","{eventtitle} has ended":"{eventtitle} wurde beendet","This is a text q&a question!":"Dies ist eine Text-Q&A-Frage!","Click here{if_it_does_not}":"Hier klicken{if_it_does_not}","{click_here}if it does not":"{click_here}wenn dies nicht geschieht","{title}up next":"{title}als Nächstes","seat(s) open":"Platz/Plätze verfügbar","Signal strength is low. Close other windows or connect to a different network.":"Das Signal ist schwach. Schließe andere Fenster oder stelle eine Verbindung zu einem anderen Netzwerk her/","GO BACKSTAGE":"BACKSTAGE","LEAVE STAGE":"Bühne verlassen","LEAVE":"verlassen","This event begins on{startitme}":"Dieses Event beginnt am/um {startitme}","Please refresh to enter.":"Bitte zum Eingeben aktualisieren.","people":"Personen","Oops, Something went wrong":"Hoppla! Etwas ist schief gegangen","Back Home":"Zurück zur Startseite","Deciding where to go ...":"Entscheiden, wohin es geht ...","Go to Event Hub":"Zum Event-Hub gehen","CREATE":"ERSTELLEN","Attending Virtually":"Virtuell teilnehmen","Attending In Person":"Persönlich teilnehmen","Click to change your attendance type":"Klicke hier, um deinen Teilnahmetyp zu ändern","Open Chat":"Chat öffnen","Create your profile for {eventtitle}":"Erstelle dein Profil für {eventtitle}","Move to stage":"Auf die Bühne verschieben","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"Der/die Eventorganisator:in hat darum gebeten, dass du für <strong>{broadcastTitle}</strong> auf die Bühne wechselst.<br /><br />Wenn du die Anfrage per Klick akzeptierst, gehst du auf Sendung und bist für die Event-Teilnehmer sichtbar.<br /><br />","Go Live On Stage":"Auf der Bühne auf Sendung gehen","Moved to backstage":"In den Backstagebereich verschoben","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"Der/die Organisator:in hat dich von der Bühne entfernt. Bitte versuche es nicht erneut mit der Teilnahme, ohne den/die Organisator:in zu kontaktieren.","Error creating Screen stream":"Fehler beim Erstellen des Bildschirm-Streams","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"Keine Bildschirmfreigabe-Berechtigung. Bitte *hier klicken*, um die Fehlerbehebungsdokumentation durchzugehen.","Error publishing stream":"Fehler bei der Stream-Veröffentlichung","Could not publish stream. Please refresh and try again!":"Stream konnte nicht veröffentlicht werden. Bitte aktualisieren und erneut versuchen!","Error publishing screen":"Fehler bei der Bildschirm-Veröffentlichung","Error publishing screen. Please refresh and try again!":"Fehler bei der Bildschirm-Veröffentlichung. Bitte aktualisieren und erneut versuchen!","Error unpublishing stream":"Fehler beim Rückgängigmachen der Stream-Veröffentlichung","Error unpublishing stream. Please refresh and try again!":"Fehler beim Rückgängigmachen der Stream-Veröffentlichung. Bitte aktualisieren und erneut versuchen!","Invalid Publish Operation":"Ungültiger Veröffentlichungsvorgang","{username} profile picture":"{username} Profilbild","Default":"Standardeinstellung","A-Z":"A–Z","Random":"Zufällig","All":"Alle","Past":"Vergangene","Upcoming":"Bevorstehende","Learn More":"Mehr erfahren","close":"schließen","Discussion Rooms":"Diskussionsräume","ATTENDEE MODE":"TEILNEHMERMODUS","Loading...":"Wird geladen …","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"Das Gerät wurde von dem Browser deaktiviert oder es wurden keine Nutzungsberechtigungen erteilt. Bitte Berechtigungen erteilen und auf „Erneut versuchen“ klicken","You are now registered. You will receive an email confirming details shortly.":"Du bist jetzt registriert. In Kürze erhältst du eine E-Mail mit Einzelheiten zur Bestätigung.","Streaming to Virtual Users from on-site video feed":"Streaming an virtuelle Benutzer über Video-Feed auf der Website","Ending in ":"Endet in ","GO LIVE":"LIVE GEHEN","You have no past events.":"Es liegen keine vergangenen Events für dich vor.","You have no upcoming or live events.":"Es liegen keine bevorstehenden oder Live-Events für dich vor.","left":"links","center":"Mitte","right":"rechts","top":"Oben","bottom":"Unten","loading...":"wird geladen …","Loading ...":"Wird geladen …","Failed to redirect!":"Weiterleitung fehlgeschlagen!","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"Scheinbar hast du einen Werbeanzeigenblocker aktiviert. Dieser verhindert möglicherweise ein optimales Erlebnis für dich. Bitte deaktiviere ihn. <br />&lt;br / &gt; Wenn du hierbei Hilfe brauchst, klicke <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>hier</a>, um weitere Anweisungen zu erhalten.","redirecting in {duration}":"Weiterleitung in {duration}","STOP VIDEO":"VIDEO ANHALTEN","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"Du bist gerade dabei, dieses Video anzuhalten. Deine Übertragung wechselt dann in den Live-Modus zurück und dein Publikum wird deine Speaker sehen und hören. Bist du sicher?","STOP SHARING":"Freigabe beenden","No Next Slide":"Keine nächste Folie","Next Slide":"Nächste Folie","No Previous Slide":"Keine vorherige Folie","Previous Slide":"Vorherige Folie","something went wrong while recording the response please try again":"Beim Aufzeichnen der Antwort ist ein Fehler aufgetreten. Bitte versuche es erneut","Start In-Person Streaming":"Persönliches Streaming starten","Stop In-Person Streaming":"Persönliches Streaming beenden","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Dein Video wird zwischengespeichert. Die Testsitzung beginnt in Kürze. Dies geschieht nicht während der eigentlichen Sitzung.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"Der Ticker wird allen Teilnehmern oben auf der Webseite angezeigt. Um den Ticker in einen Hyperlink zu verwandeln, gib die URL unten ein","Allow {key}":"{key} zulassen","{messageType} can only be published from inside a broadcast.":"{messageType} kann nur innerhalb einer Übertragung veröffentlicht werden.","To grant {deviceName} access to this page, follow the two steps below:":"Führe die folgenden beiden Schritte aus, um {deviceName} Zugriff auf diese Seite zu gewähren:","2. Allow {deviceName} access and then refresh the page.":"2. Gewähre {deviceName} den Zugriff und aktualisiere dann die Seite."}');

/***/ }),

/***/ 1005:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Event Setting Dropdown"," Stage Control":" Stage Control","Stage Controls and Information":"Stage Controls and Information","Live in ":"Live in ","Start Session":"Start Session","End Session":"End Session","Present Screen":"Present Screen","Rehearse On Stage":"Rehearse On Stage","Turn on Microphone":"Turn on Microphone","Turn off Microphone":"Turn off Microphone","Turn on camera":"Turn on camera","Turn off camera":"Turn off camera","rehearsal mode":"rehearsal mode","People Watching: ${watchCount}":"People Watching: ${watchCount}","Turn on Audio":"Turn on Audio","Turn off Audio":"Turn off Audio","Are you sure you want to leave this room?":"Are you sure you want to leave this room?","you will be redirected to stage in":"you will be redirected to stage in","sec. . ":"sec. . ","Skip to Main Navigation":"Skip to Main Navigation","Skip to Chat":"Skip to Chat","Skip to Meeting Controls":"Skip to Meeting Controls","LinkedIn":"LinkedIn","Live in":"Live in","UPCOMING":"UPCOMING","Rehearse on stage":"Rehearse on stage","Watch Rehearsal":"Watch Rehearsal","Answered by:":"Answered by:","Speaker Off":"Speaker Off","Speaker On":"Speaker On","Speaker Controls":"Speaker Controls","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.","Close Ticker Popup":"Close Ticker Popup","Open GIF Picker":"Open GIF Picker","Open Emoji Picker":"Open Emoji Picker","Send Message":"Send Message","Tabs: Messaging and More":"Tabs: Messaging and More","Thanks for attending!":"Thanks for attending!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions","Redirecting you to ":"Redirecting you to ","in ":"in ","seconds":"seconds","Main Navigation":"Main Navigation","YOU ARE HERE":"YOU ARE HERE","Live Now":"Live Now","SUBMIT":"SUBMIT","Allocated time for engagement has ended. You will be redirected to main stage":"Allocated time for engagement has ended. You will be redirected to main stage","Wrap up in":"Wrap up in","Session overrun by":"Session overrun by","Ending in":"Ending in","Bring this session live?":"Bring this session live?","START SESSION":"START SESSION","Bring this session to end?":"Bring this session to end?","END SESSION":"END SESSION","Go On Stage":"Go On Stage","Muted by organizer":"Muted by organizer","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.","Gifs":"Gifs","Stickers":"Stickers","Launch Survey":"Launch Survey","Microphone is on":"Microphone is on","Microphone is off":"Microphone is off","Secret Code’s length should be 6 digits":"Secret Code’s length should be 6 digits","Closing in 00:":"Closing in 00:","Submit":"Submit","Questions":"Questions","Preview":"Preview","Close Survey":"Close Survey","This is a required question":"This is a required question","Enter the text you’d like to present on stage below.":"Enter the text you’d like to present on stage below.","Use Chrome/Edge for best performance":"Use Chrome/Edge for best performance","Do you want to launch your survey now?":"Do you want to launch your survey now?","Success! Your Survey has been launched for attendees.":"Success! Your Survey has been launched for attendees.","Unable to publish. Please try again.":"Unable to publish. Please try again.","Are you sure you want to close this survey?":"Are you sure you want to close this survey?","Success! Your Survey has been closed for attendees.":"Success! Your Survey has been closed for attendees.","Unable to un-publish. Please try again.":"Unable to un-publish. Please try again.","Please answer all required questions.":"Please answer all required questions.","You have already submitted this survey.":"You have already submitted this survey.","Success! Thank you for your feedback.":"Success! Thank you for your feedback.","Unable to submit. Please try again.":"Unable to submit. Please try again.","Launch surveys will take over attendees\' engagement panel.":"Launch surveys will take over attendees\' engagement panel.","Closing this survey will remove it from attendees\' engagement panel.":"Closing this survey will remove it from attendees\' engagement panel.","Survey":"Survey","Updating Survey...":"Updating Survey...","Closing":"Closing","Goldcast needs access to your camera and microphone":"Goldcast needs access to your camera and microphone","Goldcast needs access to your microphone":"Goldcast needs access to your microphone","Goldcast needs access to your camera":"Goldcast needs access to your camera","SPEAKERS":"SPEAKERS","Mark as Unanswered":"Mark as Unanswered","Mark as Answered":"Mark as Answered","Remove from Priority":"Remove from Priority","Mark as Priority":"Mark as Priority","Answer":"Answer","Enter answer...":"Enter answer...","Answered by":"Answered by","Submit Answer":"Submit Answer","Test your system’s speaker":"Test your system’s speaker","Click \\"Yes\\" if you hear the sound.":"Click \\"Yes\\" if you hear the sound.","Load previous":"Load previous","Hide Name":"Hide Name","Text Q&A is disabled in On Demand mode.":"Text Q&A is disabled in On Demand mode.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"Text Q&A limit reached. Attendees won\'t be able to ask new questions.","Sent to Q&A":"Sent to Q&A","Couldn\'t post as Q&A. Please try again.":"Couldn\'t post as Q&A. Please try again.","Yes this is being recorded":"Yes this is being recorded","No this is not being recorded":"No this is not being recorded","System\'s Speaker Check":"System\'s Speaker Check","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine","Click on “Test your system’s speaker” to proceed":"Click on “Test your system’s speaker” to proceed","Error while sharing message to screen. Post not found":"Error while sharing message to screen. Post not found","Lost connection to servers. Refresh your page to get live event experience.":"Lost connection to servers. Refresh your page to get live event experience.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.","It\'s taking too long":"It\'s taking too long","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service","Most Upvotes":"Most Upvotes","Most Recent":"Most Recent","My Questions":"My Questions","Prioritized":"Prioritized","Approved":"Approved","Unapproved":"Unapproved","Unanswered":"Unanswered","Failed to update answer. Please try again!":"Failed to update answer. Please try again!","Failed to post answer. Please try again!":"Failed to post answer. Please try again!","Failed to delete question. Please try again!":"Failed to delete question. Please try again!","Survey Link":"Survey Link","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.","You haven\'t asked any questions yet":"You haven\'t asked any questions yet","No prioritized questions":"No prioritized questions","Create prioritized list of questions for speakers by marking questions as priority":"Create prioritized list of questions for speakers by marking questions as priority","No Approved Questions":"No Approved Questions","Approve incoming questions to see list of approved questions":"Approve incoming questions to see list of approved questions","No Unapproved Questions":"No Unapproved Questions","No Answered Questions":"No Answered Questions","Answer a question on stage or with inline text":"Answer a question on stage or with inline text","All questions are answered":"All questions are answered","Rate Your Experience":"Rate Your Experience","How satisfied are you with Goldcast?":"How satisfied are you with Goldcast?","What are the main reasons for your rating?":"What are the main reasons for your rating?","I am interested in seeing a demo of Goldcast":"I am interested in seeing a demo of Goldcast","Thank You":"Thank You","Your feedback was successfully submitted.":"Your feedback was successfully submitted.","Tell us how we can improve...":"Tell us how we can improve...","1 Slide":"1 Slide","Your internet connection is unstable.":"Your internet connection is unstable.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"It seems that you are speaking on mute. Click on Mic icon to unmute yourself","The registration could not be completed! Please check that this email is allowed to register for the event.":"The registration could not be completed! Please check that this email is allowed to register for the event.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.","Your registration could not be completed. This event has reached its registration capacity.":"Your registration could not be completed. This event has reached its registration capacity.","Image cannot be an svg":"Image cannot be an svg","This should be a valid linkedin url":"This should be a valid linkedin url","This should be a valid twitter url":"This should be a valid twitter url","This should be a valid url":"This should be a valid url","Video":"Video","Read Less":"Read Less","live":"live","Opened":"Opened","In person only":"In person only","Stage Stream":"Stage Stream","Streaming not available":"Streaming not available","Close TV":"Close TV","Streaming is not available for prerecorded and RTMP sessions":"Streaming is not available for prerecorded and RTMP sessions","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ","Close Setup Mode":"Close Setup Mode","Help":"Help","upcoming":"upcoming","ended":"ended","Remove from favorites":"Remove from favorites","Add to favorites":"Add to favorites","PLAY RECORDING":"PLAY RECORDING","VIEW RECORDING":"VIEW RECORDING","VIEW RECORDINGS":"VIEW RECORDINGS","Virtual Backgrounds":"Virtual Backgrounds","No Device Available":"No Device Available","Needs permission":"Needs permission","Device not detected":"Device not detected","Camera is on":"Camera is on","Camera is off":"Camera is off","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video","Mirror My Video":"Mirror My Video","Camera":"Camera","1. Click on Safari > Settings for this\\n            website":"1. Click on Safari > Settings for this\\n            website","1. Click the lock":"1. Click the lock","icon in your browser’s address bar":"icon in your browser’s address bar","3. Unmute":"3. Unmute","and":"and","icons from stage control panel":"icons from stage control panel","icon from stage control panel":"icon from stage control panel","2. Set camera and microphone to “Allow”.":"2. Set camera and microphone to “Allow”.","2. Set camera to “Allow”.":"2. Set camera to “Allow”.","2. Set microphone to \\"Allow\\"":"2. Set microphone to \\"Allow\\"","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. Choose \\"Always allow Goldcast to access your camera and microphone\\"","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. Choose \\"Always allow Goldcast to access your camera.\\"","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. Choose \\"Always allow Goldcast to access your microphone\\"","Questions?":"Questions?","If you’re having issues, check out our comprehensive":"If you’re having issues, check out our comprehensive","help docs":"help docs","Speaker is on":"Speaker is on","Stop Test":"Stop Test","Test your system’s audio":"Test your system’s audio","Still can\'t hear any sound?":"Still can\'t hear any sound?","Microphone":"Microphone","Audio is being played in system\'s default audio device.":"Audio is being played in system\'s default audio device.","Click to view/change audio device":"Click to view/change audio device","Speaker":"Speaker","Play Recording":"Play Recording","Recording for this broadcast is currently being processed and will be available soon":"Recording for this broadcast is currently being processed and will be available soon","You haven\'t favorited anything yet!":"You haven\'t favorited anything yet!","Add an item to favorites by selecting the ♡ in the top right corner.":"Add an item to favorites by selecting the ♡ in the top right corner.","Session has ended":"Session has ended","System Check":"System Check","Need help? Check out the":"Need help? Check out the","Skip Checks and Continue":"Skip Checks and Continue","Click the button above to run the test":"Click the button above to run the test","Test Screenshare":"Test Screenshare","Share message to stage":"Share message to stage","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.","Ticker":"Ticker","Coffee Break! Be back in 10m.":"Coffee Break! Be back in 10m.","Enter Message":"Enter Message","https://www.xyz.com":"https://www.xyz.com","Launch":"Launch","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.","Votes":"Votes","Vote":"Vote","is inviting you to a video call":"is inviting you to a video call","ENTER ROOM":"ENTER ROOM","Start the conversation!":"Start the conversation!","Couldn\'t send message. Click here to retry.":"Couldn\'t send message. Click here to retry.","Couldn\'t add emoji. Please try again.":"Couldn\'t add emoji. Please try again.","Couldn\'t remove emoji. Please try again.":"Couldn\'t remove emoji. Please try again.","Couldn\'t delete message. Please try again.":"Couldn\'t delete message. Please try again.","Couldn\'t pin message. Please try again.":"Couldn\'t pin message. Please try again.","Couldn\'t unpin message. Please try again.":"Couldn\'t unpin message. Please try again.","Today":"Today","No messages yet":"No messages yet","Messages from organizers and speakers appear here!":"Messages from organizers and speakers appear here!","Next Session is Starting":"Next Session is Starting","Go to Next Session":"Go to Next Session","I’d like to stay":"I’d like to stay","My favorites":"My favorites","1. Click on the lock icon in your address bar":"1. Click on the lock icon in your address bar","We recommend organizers and speakers use a desktop\\n        device":"We recommend organizers and speakers use a desktop\\n        device","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.","Watch Now":"Watch Now","Video progress time":"Video progress time","Total video duration":"Total video duration","Rate Goldcast!":"Rate Goldcast!","Running Required Checks...":"Running Required Checks...","Test Your Setup":"Test Your Setup","Test your Computer Device, Microphone and Camera before you join the event":"Test your Computer Device, Microphone and Camera before you join the event","Speaker and microphone not working?":"Speaker and microphone not working?","Passed":"Passed","Fix Audio Issues":"Fix Audio Issues","Check if audio is being played in other sound devices connected to phone/tablet":"Check if audio is being played in other sound devices connected to phone/tablet","Check if correct audio device is chosen from the below dropdown":"Check if correct audio device is chosen from the below dropdown","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played","Right click on the browser tab & click “Unmute Site”":"Right click on the browser tab & click “Unmute Site”","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Check if browser\'s tab is unmuted or click Window > Unmute this tab","System Check Failed!":"System Check Failed!","System Check Passed!":"System Check Passed!","Complete checks to proceed":"Complete checks to proceed","Enter Event":"Enter Event","Skip Screen Sharing Check? ":"Skip Screen Sharing Check? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"We recommend to complete screen sharing check if your screen needs to be presented in the event","Ignore & Enter Event":"Ignore & Enter Event","Test screenshare":"Test screenshare","Retry Now":"Retry Now","SHARE":"SHARE","Rooms Closed":"Rooms Closed","Discussion rooms are now closed. You are being redirected to the Stage.":"Discussion rooms are now closed. You are being redirected to the Stage.","Return To Stage":"Return To Stage","Unrecognized embedded widget provider - ":"Unrecognized embedded widget provider - ","Room Ended":"Room Ended","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"Your event organizer has closed all the Rooms. You will now be redirected to the event stage.","Video Q&A Request Cancelled":"Video Q&A Request Cancelled","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.","Camera Passed":"Camera Passed","Camera Error":"Camera Error","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"Camera permissions aren’t granted from browser. Click “Allow Camera”.","Camera permissions aren’t granted from system. Click “Allow Camera”":"Camera permissions aren’t granted from system. Click “Allow Camera”","Uh-oh! Error occurred while creating camera stream":"Uh-oh! Error occurred while creating camera stream","Close other applications which might use camera stream":"Close other applications which might use camera stream","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera","Microphone Passed":"Microphone Passed","Microphone Error":"Microphone Error","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"Mic permissions aren’t granted from browser. Click “Allow Microphone”","Mic permissions aren’t granted from system. Click “Allow Microphone”":"Mic permissions aren’t granted from system. Click “Allow Microphone”","Uh-oh! Error occurred while creating mic stream":"Uh-oh! Error occurred while creating mic stream","Close other applications which might use mic stream":"Close other applications which might use mic stream","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic","Speaker and Microphone Error":"Speaker and Microphone Error","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”","It seems mic is being used by other application. Close other applications to proceed.":"It seems mic is being used by other application. Close other applications to proceed.","Camera & Microphone Error":"Camera & Microphone Error","To enable permissions, click the Allow Camera & Mic button below":"To enable permissions, click the Allow Camera & Mic button below","Network Connection":"Network Connection","Check Passed":"Check Passed","Could not establish a network connection":"Could not establish a network connection","Connect to a different network, or use a mobile hotspot.":"Connect to a different network, or use a mobile hotspot.","Disable any VPN or firewall is connected.":"Disable any VPN or firewall is connected.","Connection: Good":"Connection: Good","Network Connection Error":"Network Connection Error","Can’t connect to network. Change your network or limited functionality will be available during event.":"Can’t connect to network. Change your network or limited functionality will be available during event.","AdBlocker":"AdBlocker","AdBlocker not detected.":"AdBlocker not detected.","AdBlocker detected. This may degrade your event experience.":"AdBlocker detected. This may degrade your event experience.","Disable adblocker for best experience.":"Disable adblocker for best experience.","You are using ":"You are using ","Use Windows or Mac OS for best performance":"Use Windows or Mac OS for best performance","Browser Check":"Browser Check","Check Passed.":"Check Passed.","Switch To Lite Mode":"Switch To Lite Mode","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Your pending Video Q&A request will be cancelled once you switch to lite mode","Stay on Live Mode":"Stay on Live Mode","Unable to mark as favorite":"Unable to mark as favorite","Event organizers must enter the event to select favorites.":"Event organizers must enter the event to select favorites.","Make an Announcement":"Make an Announcement","STOP":"STOP","InPerson CheckIn App":"InPerson CheckIn App","App to Check-In In-Person attendees":"App to Check-In In-Person attendees","SEE AGENDA":"SEE AGENDA","Please visit the Agenda tab to view the session recordings":"Please visit the Agenda tab to view the session recordings","The session recordings will be available soon in the Agenda tab":"The session recordings will be available soon in the Agenda tab","FAILED!":"FAILED!","Next session is beginning":"Next session is beginning","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.","Banners":"Banners","Images":"Images","Screen Share":"Screen Share","Browser might not have screen-recording permission on your computer.":"Browser might not have screen-recording permission on your computer.","Open System Preferences":"Open System Preferences","Error publishing screen because someone else started screen share already.":"Error publishing screen because someone else started screen share already.","Live Feed":"Live Feed","Check Your Network":"Check Your Network","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.","All Dates":"All Dates","All Tracks":"All Tracks","Create Ticker":"Create Ticker","Booths Closed":"Booths Closed","Your event organizer has closed all the booths. You will now be redirected to the stage":"Your event organizer has closed all the booths. You will now be redirected to the stage","Visit the Polls tab to view live results.":"Visit the Polls tab to view live results.","A new poll is open! Visit the Polls tab to vote.":"A new poll is open! Visit the Polls tab to vote.","Vote for Polls":"Vote for Polls","Go to Polls Tab":"Go to Polls Tab","Microphone audio too low":"Microphone audio too low","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.","Audio/Video bitrate too low":"Audio/Video bitrate too low","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.","Error sharing screen":"Error sharing screen","A network error occurred while sharing screen. Please check your network connection.":"A network error occurred while sharing screen. Please check your network connection.","Apologies, due to some errors, we need to refresh the page!":"Apologies, due to some errors, we need to refresh the page!","Warning":"Warning","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.","No results found":"No results found","Audio":"Audio","Please choose another microphone and camera":"Please choose another microphone and camera","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"The currently selected camera is not working. Please choose another camera in the dropdown below.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience","Please choose another microphone":"Please choose another microphone","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"The currently selected microphone is not working. Please choose another microphone in the dropdown below.","Please check that your TV speaker is correct":"Please check that your TV speaker is correct","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"The currently selected speaker is not working. Please choose another speaker in the dropdown below.","Your answer":"Your answer","Edit":"Edit","Delete":"Delete","Settings":"Settings","Signing Out":"Signing Out","Confirming your account...":"Confirming your account...","Something Went Wrong. Please Retry :(":"Something Went Wrong. Please Retry :(","Resending Mail":"Resending Mail","offline":"offline","I am inviting you to a video meeting:":"I am inviting you to a video meeting:","Resending secure login link to your email":"Resending secure login link to your email","Sending secure login link to your email":"Sending secure login link to your email","Something went Wrong. Please Retry :(":"Something went Wrong. Please Retry :(","Updating your password":"Updating your password","Sending mail":"Sending mail","Verifying":"Verifying","This might be slower than usual":"This might be slower than usual","Checking":"Checking","New results available! Refresh!":"New results available! Refresh!","Saving":"Saving","Turn off Attendee mode":"Turn off Attendee mode","See Attendee View":"See Attendee View","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Total number of attendees currently viewing this session Note: This is for organizer eyes only","Session Count":"Session Count","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"The number of attendees currently viewing live sessions. Note: This is for organizer eyes only","Role":"Role","Total Attendees":"Total Attendees","Total number of attendees online at this time Note: This is for organizer eyes only":"Total number of attendees online at this time Note: This is for organizer eyes only","My Profile":"My Profile","Languages":"Languages","Filling out your profile can help you connect with people with similar interests.":"Filling out your profile can help you connect with people with similar interests.","type to search for your address":"type to search for your address","Could not open direct call":"Could not open direct call","Chat messages can only be published from inside a broadcast.":"Chat messages can only be published from inside a broadcast.","Stage Logo can only be published from inside a broadcast.":"Stage Logo can only be published from inside a broadcast.","Loading Speakers":"Loading Speakers","Raise hand is disabled for organizer accounts, but active for attendee accounts":"Raise hand is disabled for organizer accounts, but active for attendee accounts","Disabled in lite mode, return to live if you’d like to raise hand!":"Disabled in lite mode, return to live if you’d like to raise hand!","Raise hand to enter stage for video q&a":"Raise hand to enter stage for video q&a","Speakers":"Speakers","Hosting organization: {organization}":"Hosting organization: {organization}","Failed to switch {deviceTag}":"Failed to switch {deviceTag}","Make sure your {deviceTag} is not being used by any other application and is working properly.":"Make sure your {deviceTag} is not being used by any other application and is working properly.","Facing issues with audio or video? Switch on lite mode":"Facing issues with audio or video? Switch on lite mode","Failed to get event for eventID: {eventID}":"Failed to get event for eventID: {eventID}","Error while playing video.":"Error while playing video.","Speakers only, attendees can\'t see this chat":"Speakers only, attendees can\'t see this chat","Kudo":"Kudo","Room":"Room","Session":"Session","Booth":"Booth","Public":"Public","Drift":"Drift","Slides":"Slides","Videos":"Videos","Chat":"Chat","Messages":"Messages","Poll":"Poll","Docs":"Docs","Q&A":"Q&A","Media":"Media","Messages Chat":"Messages Chat","Leaderboard":"Leaderboard","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.","Switch to Attendee View":"Switch to Attendee View","Return to Organizer View":"Return to Organizer View","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?","Switch":"Switch","Request Sent":"Request Sent","Your request for a demo has been submitted":"Your request for a demo has been submitted","Organizer Redirection":"Organizer Redirection","YES, REDIRECT":"YES, REDIRECT","DISMISS":"DISMISS","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?","Stage":"Stage","Rooms":"Rooms","Join a round table to discuss moderated topics with your fellow attendees":"Join a round table to discuss moderated topics with your fellow attendees","Booths":"Booths","Join a booth to know more about a sponsor":"Join a booth to know more about a sponsor","You are in the booth":"You are in the booth","People":"People","Connect with your fellow attendees":"Connect with your fellow attendees","Connect with speakers":"Connect with speakers","starting in {duration}":"starting in {duration}","You will be redirected to booths in {duration}":"You will be redirected to booths in {duration}","booths":"booths","agenda":"agenda","You will be redirected to {word} in {duration}":"You will be redirected to {word} in {duration}","You will be redirected to the live stage in {duration}":"You will be redirected to the live stage in {duration}","- You are about to be redirected to {tabTitle} in {duration}":"- You are about to be redirected to {tabTitle} in {duration}","See Agenda":"See Agenda","Break":"Break","{title} is now live":"{title} is now live","Apologies, due to an error we need to refresh the page!":"Apologies, due to an error we need to refresh the page!","Network interruption detected":"Network interruption detected","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network","No audio output device detected":"No audio output device detected","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.","Please disable ad blocker for this page":"Please disable ad blocker for this page","Yes, I understand":"Yes, I understand","No event user found so attended not marked!":"No event user found so attended not marked!","Wait while the speaker approves your video q&a request":"Wait while the speaker approves your video q&a request","Organizer":"Organizer","UPNEXT":"UPNEXT","Ended":"Ended","Hide":"Hide","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"This page will automatically redirect you in {durationLeftToRedirect} seconds.","Register":"Register","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Error: User unable to be registered for this event. Please contact event organizer for assistance","You are already registered!":"You are already registered!","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer","Thank you for registering!":"Thank you for registering!","Submit another response":"Submit another response","Share":"Share","Know someone who want to attend this?":"Know someone who want to attend this?","COPY LINK":"COPY LINK","Powered by":"Powered by","VIEW PROFILE":"VIEW PROFILE","You can access the event landing here":"You can access the event landing here","Need Help?":"Need Help?","Welcome back":"Welcome back","Checking...":"Checking...","Close":"Close","Enter":"Enter","See {roomCount} Room(s)":"See {roomCount} Room(s)","Back":"Back","Request a Demo":"Request a Demo","Loading":"Loading","Thread":"Thread","Load more":"Load more","Heads up!":"Heads up!","YES":"YES","No":"No","Following":"Following","Error in loading drimify":"Error in loading drimify","You\'re not registered for this event":"You\'re not registered for this event","Check out other events":"Check out other events","Date":"Date","Location":"Location","How are you attending the event":"How are you attending the event","In Person":"In Person","Virtually":"Virtually","Event Widgets":"Event Widgets","Chat • Messages • Q&A • Poll • Docs":"Chat • Messages • Q&A • Poll • Docs","DISCUSSION":"DISCUSSION","JOIN":"JOIN","WAIT":"WAIT","more":"more","See Profile":"See Profile","Filter":"Filter","Video player not supported by your browser":"Video player not supported by your browser","We recommend using the latest version of Google Chrome to access your conference":"We recommend using the latest version of Google Chrome to access your conference","ANSWER":"ANSWER","REJECT":"REJECT","Don’t ask me this next time":"Don’t ask me this next time","Cancel":"Cancel","Lite Mode":"Lite Mode","On":"On","Connection Issues? Turn on Lite Mode":"Connection Issues? Turn on Lite Mode","Turn On Lite Mode":"Turn On Lite Mode","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?","Turn On":"Turn On","Lite Mode Active!":"Lite Mode Active!","Thanks for your patience, lite mode now on!":"Thanks for your patience, lite mode now on!","Turn off Lite Mode?":"Turn off Lite Mode?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.","Lite Mode Off!":"Lite Mode Off!","Thanks for your patience, we’ve returned to the live broadcast!":"Thanks for your patience, we’ve returned to the live broadcast!","Lite Mode Unavailable":"Lite Mode Unavailable","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.","Turn off Lite mode?":"Turn off Lite mode?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.","Turn Off":"Turn Off","Lite mode is disabled for organizer accounts, but active for attendee accounts":"Lite mode is disabled for organizer accounts, but active for attendee accounts","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome","Lite mode is not curently available. We’ll let you know once it’s available again":"Lite mode is not curently available. We’ll let you know once it’s available again","Turn off Lite Mode":"Turn off Lite Mode","We’ll let you know when Lite mode is available again":"We’ll let you know when Lite mode is available again","Lite Mode Available":"Lite Mode Available","Loading Lite Mode...":"Loading Lite Mode...","Turning Off Lite Mode":"Turning Off Lite Mode","Lite Mode On":"Lite Mode On","Audio/Video Issues?":"Audio/Video Issues?","Error":"Error","Click a video to play":"Click a video to play","Error starting video!":"Error starting video!","Please rotate your device to {mode} mode":"Please rotate your device to {mode} mode","landscape":"landscape","portrait":"portrait","Thank you for attending this event!":"Thank you for attending this event!","Go to Rooms":"Go to Rooms","Please use a desktop or laptop Google Chrome browser to access your conference":"Please use a desktop or laptop Google Chrome browser to access your conference","If on Desktop":"If on Desktop","Please increase the width of your window":"Please increase the width of your window","Alternatively, check out the":"Alternatively, check out the","Youtube Livestream":"Youtube Livestream","Search":"Search","Profile":"Profile","Yes":"Yes","Loading Chat":"Loading Chat","Please wait while we fetch the chat":"Please wait while we fetch the chat","Load old messages":"Load old messages","Join the room to see chat":"Join the room to see chat","Live Chat":"Live Chat","Uh..oh we couldn\'t load the content":"Uh..oh we couldn\'t load the content","Please reload the page":"Please reload the page","New comments":"New comments","Start the conversation":"Start the conversation","Be the first to add to chat!":"Be the first to add to chat!","Enter your message":"Enter your message","Joining chat!":"Joining chat!","See all pinned messages":"See all pinned messages","Failed to send! Retry?":"Failed to send! Retry?","Search for attendee":"Search for attendee","Up to date":"Up to date","Start a new conversation, We think you\'ll enjoy":"Start a new conversation, We think you\'ll enjoy","chatting with these recommended attendees!":"chatting with these recommended attendees!","Searching":"Searching","Load Previous":"Load Previous","Load Next":"Load Next","Loading Channel":"Loading Channel","Please wait while we fetch the channel":"Please wait while we fetch the channel","Please wait while we fetch the messages":"Please wait while we fetch the messages","Send the first message":"Send the first message","Join":"Join","link":"link","download":"download","Click to open":"Click to open","No open polls":"No open polls","Check back later to see if a poll opens up!":"Check back later to see if a poll opens up!","Loading Poll":"Loading Poll","Please wait while we fetch the polls":"Please wait while we fetch the polls","Uh oh.. we couldn’t load the content":"Uh oh.. we couldn’t load the content","Polls":"Polls","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel","Stop Sharing":"Stop Sharing","Can\'t publish polls while something else is being presented on stage":"Can\'t publish polls while something else is being presented on stage","Open":"Open","Cancel your video q&a request":"Cancel your video q&a request","Pending...":"Pending...","Leave Stage":"Leave Stage","Raise Hand":"Raise Hand","Text Q&A":"Text Q&A","Video Q&A":"Video Q&A","Loading Q&amp;A":"Loading Q&amp;A","Please wait while we fetch the Q&amp;A":"Please wait while we fetch the Q&amp;A","Uh oh.. we couldn\'t load the content":"Uh oh.. we couldn\'t load the content","No Questions Yet":"No Questions Yet","Tell your audience to send in questions!":"Tell your audience to send in questions!","Be the first to ask a question!":"Be the first to ask a question!","Tell your audience to raise their hand!":"Tell your audience to raise their hand!","Approve":"Approve","Reject":"Reject","End":"End","RELOAD":"RELOAD","Logos On Stage":"Logos On Stage","No File Chosen":"No File Chosen","loading":"loading","Can\'t publish a slide when there is something else being presented on stage":"Can\'t publish a slide when there is something else being presented on stage","Change Deck":"Change Deck","stop-screen-share":"stop-screen-share","screen-share":"screen-share","Select a deck to begin presenting":"Select a deck to begin presenting","CONFIRM":"CONFIRM","If you’re having issues, please refer to the":"If you’re having issues, please refer to the","SPEAKER":"SPEAKER","Issue Testing Audio!":"Issue Testing Audio!","VPN and adblockers may cause video issues, please disable them before proceeding":"VPN and adblockers may cause video issues, please disable them before proceeding","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast","Follow":"Follow","Read More":"Read More","Ask a question":"Ask a question","Shared":"Shared","Answered":"Answered","Waiting Approval":"Waiting Approval","cancel":"cancel","ENTER":"ENTER","Upcoming Events":"Upcoming Events","Past Events":"Past Events","Goldcast":"Goldcast","MANAGE EVENT":"MANAGE EVENT","Edit Profile":"Edit Profile","Stay tuned!":"Stay tuned!","Sign-in instructions will be available here 12 hours prior to the event":"Sign-in instructions will be available here 12 hours prior to the event","Please log out":"Please log out","Logout":"Logout","Continue as {differentUser}":"Continue as {differentUser}","You are already logged in as {user}.":"You are already logged in as {user}.","EMAIL":"EMAIL","user@email.com":"user@email.com","FIRST NAME":"FIRST NAME","First Name":"First Name","LAST NAME":"LAST NAME","Last Name":"Last Name","You are not registered to this event":"You are not registered to this event","Please enter your email and name":"Please enter your email and name","Please enter your email":"Please enter your email","We have sent a secret code to":"We have sent a secret code to","BACK":"BACK","Didn\'t receive an email? Make sure to check spam list":"Didn\'t receive an email? Make sure to check spam list","Resend Mail":"Resend Mail","SECRET CODE":"SECRET CODE","Please enter the temporary password sent to your email":"Please enter the temporary password sent to your email","NEW PASSWORD":"NEW PASSWORD","Please enter a new password":"Please enter a new password","CONFIRM PASSWORD":"CONFIRM PASSWORD","Please re-enter the new password":"Please re-enter the new password","Password length should be atleast 8":"Password length should be atleast 8","Password and Confirm Password don\'t match !!":"Password and Confirm Password don\'t match !!","Please enter your password to continue":"Please enter your password to continue","Logging you in...":"Logging you in...","PASSWORD":"PASSWORD","Forgot credentials?":"Forgot credentials?","Forgot Password? A mail will be sent to your registered email.":"Forgot Password? A mail will be sent to your registered email.","Email cannot be blank!!":"Email cannot be blank!!","We have sent a secure login link to":"We have sent a secure login link to","from":"from","Please use that to access your event.":"Please use that to access your event.","Please check spam/promotion too if you can\'t find it.":"Please check spam/promotion too if you can\'t find it.","Thank You !":"Thank You !","The link is not valid.":"The link is not valid.","Please be patient.":"Please be patient.","We are verifying your link.":"We are verifying your link.","Thank you for entering the code!":"Thank you for entering the code!","Please create a new password":"Please create a new password","Signing you up...":"Signing you up...","We have sent a temporary password to":"We have sent a temporary password to","TEMPORARY PASSWORD":"TEMPORARY PASSWORD","Please enter the temporary password sent to your mail":"Please enter the temporary password sent to your mail","Password Length should be 8":"Password Length should be 8","Okay":"Okay","Backstage: {title}":"Backstage: {title}","Prep Area":"Prep Area","Starting at {time}":"Starting at {time}","person":"person","inside":"inside","No one is inside":"No one is inside","This area is for you to sync up with your fellow speakers before you go on stage.":"This area is for you to sync up with your fellow speakers before you go on stage.","This area is for you to check your cam and mic before you enter the room.":"This area is for you to check your cam and mic before you enter the room.","I\'m Ready":"I\'m Ready","Watch Live":"Watch Live","Backstage":"Backstage","You are sharing your screen":"You are sharing your screen","LIVE":"LIVE","Live":"Live","Virtual":"Virtual","Only available for ":"Only available for ","See Booths":"See Booths","See Rooms":"See Rooms","Enter Backstage":"Enter Backstage","This track has no upcoming sessions. Check out a different track.":"This track has no upcoming sessions. Check out a different track.","View":"View","Agenda":"Agenda","Scroll to see all tracks":"Scroll to see all tracks","No Agenda Items to show!":"No Agenda Items to show!","ENTER EVENT":"ENTER EVENT","change":"change","Upload":"Upload","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF OR PNG. MAX SIZE OF 5MB","Create Profile":"Create Profile","Email":"Email","Company":"Company","Title":"Title","No matching locations found":"No matching locations found","You can try searching for the location with another keyword":"You can try searching for the location with another keyword","Interest Tags":"Interest Tags","Pick your first tag":"Pick your first tag","Save":"Save","Searching...":"Searching...","Twitter":"Twitter","Select Your First Tags":"Select Your First Tags","Add Interest tags":"Add Interest tags","Congratulations!":"Congratulations!","Your first Goldcast event is set up":"Your first Goldcast event is set up","You can always visit":"You can always visit","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"for instructions on how to set up and run your events","See My Event":"See My Event","Peak Community":"Peak Community","Loading Lite Mode... This may take up to 30s":"Loading Lite Mode... This may take up to 30s","Loading Video...":"Loading Video...","Video will begin at session start time":"Video will begin at session start time","TIME":"TIME","TITLE":"TITLE","STATUS":"STATUS","END":"END","START":"START","AGENDA":"AGENDA","Enable Audio":"Enable Audio","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.","Enable":"Enable","You are being redirected outside the room. Would you like to continue?":"You are being redirected outside the room. Would you like to continue?","Continue":"Continue","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"Alternatively, you can use lite mode which will have a 30s delay from the live broadcast","We detected a network issue":"We detected a network issue","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.","Could not connect":"Could not connect","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists","Switch to Lite Mode":"Switch to Lite Mode","Leave":"Leave","Screenshare had an issue":"Screenshare had an issue","Could not share screen unexpectedly. Refresh & retry. On mac go to":"Could not share screen unexpectedly. Refresh & retry. On mac go to","and check if your browser has the required permission":"and check if your browser has the required permission","Uh OH... Something went wrong":"Uh OH... Something went wrong","To fix this, click the":"To fix this, click the","in your URL bar, then select “Allow”, and then click “Try Again”":"in your URL bar, then select “Allow”, and then click “Try Again”","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support","To fix this, make sure your":"To fix this, make sure your","is not being accessed by any other app. If not, please try changing your":"is not being accessed by any other app. If not, please try changing your","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!","Go To Settings":"Go To Settings","Try Again":"Try Again","Try Joining without Video":"Try Joining without Video","A refresh and rejoin should work":"A refresh and rejoin should work","Refresh & Rejoin":"Refresh & Rejoin","Start Chat":"Start Chat","On Stage":"On Stage","Connect your on-site camera and microphone to present to your virtual attendees":"Connect your on-site camera and microphone to present to your virtual attendees","Stop Streaming":"Stop Streaming","Start Streaming":"Start Streaming","Set up on-site video feed":"Set up on-site video feed","Open TV":"Open TV","Layout: {layout} ":"Layout: {layout} ","With Speaker Videos":"With Speaker Videos","Full Screen":"Full Screen","No Speakers":"No Speakers","Turn Off Setup Mode":"Turn Off Setup Mode","Setup Mode":"Setup Mode","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.","Starting in {duration}":"Starting in {duration}","Can\'t share screen while there is something else being presented on stage":"Can\'t share screen while there is something else being presented on stage","You are now in attendee view!":"You are now in attendee view!","You are now in organizer view!":"You are now in organizer view!","Note :":"Note :","Only organizer accounts can see this tag, normal attendees can’t see this":"Only organizer accounts can see this tag, normal attendees can’t see this","Attendee":"Attendee","Event Information":"Event Information","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"Event Information is only visible to organizers! <br /> This section is not visible to attendees","Operating System":"Operating System","Secondary Booths":"Secondary Booths","Sort":"Sort","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?","Track only available for {tracks}":"Track only available for {tracks}","Add to Calendar":"Add to Calendar","Open Speakers Control Panel":"Open Speakers Control Panel","Move Offstage ↓":"Move Offstage ↓","Error Moving ⚠":"Error Moving ⚠","Off Stage":"Off Stage","Move to Stage":"Move to Stage","An error occurred!":"An error occurred!","{eventName} Documents":"{eventName} Documents"," Set Up Mode":" Set Up Mode","Camera & Mic blocked":"Camera & Mic blocked","Camera/Mic Inaccessible":"Camera/Mic Inaccessible","Camera/Mic Not Found":"Camera/Mic Not Found","Camera Inaccessible":"Camera Inaccessible","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!","No microphone/camera is found":"No microphone/camera is found","The browser does not support using camera and microphone!":"The browser does not support using camera and microphone!","{n} Slides":"{n} Slides","Starting in {timeduration}":"Starting in {timeduration}","{eventtitle} has ended":"{eventtitle} has ended","This is a text q&a question!":"This is a text q&a question!","Click here{if_it_does_not}":"Click here{if_it_does_not}","{click_here}if it does not":"{click_here}if it does not","{title}up next":"{title}up next","seat(s) open":"seat(s) open","Signal strength is low. Close other windows or connect to a different network.":"Signal strength is low. Close other windows or connect to a different network.","GO BACKSTAGE":"GO BACKSTAGE","LEAVE STAGE":"LEAVE STAGE","LEAVE":"LEAVE","This event begins on{startitme}":"This event begins on{startitme}","Please refresh to enter.":"Please refresh to enter.","people":"people","Oops, Something went wrong":"Oops, Something went wrong","Back Home":"Back Home","Deciding where to go ...":"Deciding where to go ...","Go to Event Hub":"Go to Event Hub","CREATE":"CREATE","Attending Virtually":"Attending Virtually","Attending In Person":"Attending In Person","Click to change your attendance type":"Click to change your attendance type","Open Chat":"Open Chat","Create your profile for {eventtitle}":"Create your profile for {eventtitle}","Move to stage":"Move to stage","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />","Go Live On Stage":"Go Live On Stage","Moved to backstage":"Moved to backstage","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.","Error creating Screen stream":"Error creating Screen stream","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.","Error publishing stream":"Error publishing stream","Could not publish stream. Please refresh and try again!":"Could not publish stream. Please refresh and try again!","Error publishing screen":"Error publishing screen","Error publishing screen. Please refresh and try again!":"Error publishing screen. Please refresh and try again!","Error unpublishing stream":"Error unpublishing stream","Error unpublishing stream. Please refresh and try again!":"Error unpublishing stream. Please refresh and try again!","Invalid Publish Operation":"Invalid Publish Operation","{username} profile picture":"{username} profile picture","Default":"Default","A-Z":"A-Z","Random":"Random","All":"All","Past":"Past","Upcoming":"Upcoming","Learn More":"Learn More","close":"close","Discussion Rooms":"Discussion Rooms","ATTENDEE MODE":"ATTENDEE MODE","Loading...":"Loading...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'","You are now registered. You will receive an email confirming details shortly.":"You are now registered. You will receive an email confirming details shortly.","Streaming to Virtual Users from on-site video feed":"Streaming to Virtual Users from on-site video feed","Ending in ":"Ending in ","GO LIVE":"GO LIVE","You have no past events.":"You have no past events.","You have no upcoming or live events.":"You have no upcoming or live events.","left":"left","center":"center","right":"right","top":"top","bottom":"bottom","loading...":"loading...","Loading ...":"Loading ...","Failed to redirect!":"Failed to redirect!","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.","redirecting in {duration}":"redirecting in {duration}","STOP VIDEO":"STOP VIDEO","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?","STOP SHARING":"STOP SHARING","No Next Slide":"No Next Slide","Next Slide":"Next Slide","No Previous Slide":"No Previous Slide","Previous Slide":"Previous Slide","something went wrong while recording the response please try again":"something went wrong while recording the response please try again","Start In-Person Streaming":"Start In-Person Streaming","Stop In-Person Streaming":"Stop In-Person Streaming","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Your video is being buffered and test session will begin shortly. This will not happen during the actual session.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below","Allow {key}":"Allow {key}","{messageType} can only be published from inside a broadcast.":"{messageType} can only be published from inside a broadcast.","To grant {deviceName} access to this page, follow the two steps below:":"To grant {deviceName} access to this page, follow the two steps below:","2. Allow {deviceName} access and then refresh the page.":"2. Allow {deviceName} access and then refresh the page."}');

/***/ }),

/***/ 3458:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Menú desplegable de configuración del evento"," Stage Control":" Control de escenario","Stage Controls and Information":"Información y controles de escenario","Live in ":"En directo en ","Start Session":"Iniciar sesión","End Session":"Finalizar sesión","Present Screen":"Presentar pantalla","Rehearse On Stage":"Ensayar en el escenario","Turn on Microphone":"Activar micrófono","Turn off Microphone":"Desactivar micrófono","Turn on camera":"Encender la cámara","Turn off camera":"Apagar la cámara","rehearsal mode":"modo de ensayo","People Watching: ${watchCount}":"Personas viendo: ${watchCount}","Turn on Audio":"Activar audio","Turn off Audio":"Desactivar audio","Are you sure you want to leave this room?":"¿Seguro que quieres salir de esta sala?","you will be redirected to stage in":"serás redirigido al escenario en","sec. . ":"s ","Skip to Main Navigation":"Ir a la navegación principal","Skip to Chat":"Ir al chat","Skip to Meeting Controls":"Ir a Controles de reunión","LinkedIn":"LinkedIn","Live in":"En directo en","UPCOMING":"Futuros","Rehearse on stage":"Ensayar en el escenario","Watch Rehearsal":"Ver ensayo","Answered by:":"Respondido por:","Speaker Off":"Altavoz desactivado","Speaker On":"Altavoz activado","Speaker Controls":"Controles de ponente","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"Todos los elementos del escenario están presentes detrás de la imagen compartida. Serán visibles nuevamente una vez que se deje de compartir imágenes en pantalla completa.","Close Ticker Popup":"Cerrar ventana emergente de teletipo","Open GIF Picker":"Abrir selector de GIF","Open Emoji Picker":"Abrir selector de emojis","Send Message":"Enviar mensaje","Tabs: Messaging and More":"Pestañas: mensajería y más","Thanks for attending!":"¡Gracias por asistir!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" No hay próximas sesiones en tu pista suscrita. Cambia a otras pistas para ver las sesiones en directo","Redirecting you to ":"Redirigiéndote a ","in ":"en ","seconds":"segundos","Main Navigation":"Navegación principal","YOU ARE HERE":"ESTÁS AQUÍ","Live Now":"En directo","SUBMIT":"ENVIAR","Allocated time for engagement has ended. You will be redirected to main stage":"El tiempo asignado para la interacción ha finalizado. Se te redirigirá al escenario principal","Wrap up in":"Termina en","Session overrun by":"Duración de sesión superada por","Ending in":"Termina en","Bring this session live?":"¿Poner en marcha esta sesión?","START SESSION":"INICIAR SESIÓN","Bring this session to end?":"¿Quieres terminar esta sesión?","END SESSION":"FINALIZAR SESIÓN","Go On Stage":"SUBIRTE AL ESCENARIO","Muted by organizer":"Silenciada por el organizador","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"Uno de los organizadores del evento ha silenciado tu audio. Puedes volver a activar el sonido pulsando el botón del micrófono.","Gifs":"Gifs","Stickers":"Stickers","Launch Survey":"Encuesta inicial","Microphone is on":"El micrófono está encendido","Microphone is off":"El micrófono está apagado","Secret Code’s length should be 6 digits":"La longitud del código secreto debe ser de 6 dígitos","Closing in 00:":"Cerrando en 00:","Submit":"ENVIAR","Questions":"Preguntas","Preview":"Vista previa","Close Survey":"Cerrar encuesta","This is a required question":"Esta es una pregunta obligatoria","Enter the text you’d like to present on stage below.":"Introduce el texto que deseas\\n presentar en el escenario a continuación.","Use Chrome/Edge for best performance":"Utiliza Chrome/Edge para obtener el mejor rendimiento","Do you want to launch your survey now?":"¿Quieres publicar tu encuesta ahora?","Success! Your Survey has been launched for attendees.":"¡Bien! Se ha publicado tu encuesta para los asistentes.","Unable to publish. Please try again.":"No se ha podido publicar. Inténtalo de nuevo.","Are you sure you want to close this survey?":"¿Seguro que quieres cerrar esta encuesta?","Success! Your Survey has been closed for attendees.":"¡Bien! Se ha cerrado tu encuesta para los asistentes.","Unable to un-publish. Please try again.":"No se ha podido cancelar la publicación. Inténtalo de nuevo.","Please answer all required questions.":"Responde a todas las preguntas necesarias.","You have already submitted this survey.":"Ya has enviado esta encuesta.","Success! Thank you for your feedback.":"Gracias por tus comentarios.","Unable to submit. Please try again.":"No se ha podido enviar. Inténtalo de nuevo.","Launch surveys will take over attendees\' engagement panel.":"Las encuestas iniciales se mostrarán en el panel de participación de los asistentes.","Closing this survey will remove it from attendees\' engagement panel.":"Al cerrar esta encuesta, se eliminará del panel de participación de los asistentes.","Survey":"ENCUESTA","Updating Survey...":"Actualizando encuesta...","Closing":"Cerrar","Goldcast needs access to your camera and microphone":"Goldcast necesita acceso a tu cámara y micrófono","Goldcast needs access to your microphone":"Goldcast necesita acceso a tu micrófono","Goldcast needs access to your camera":"Goldcast necesita acceso a tu cámara","SPEAKERS":"Expositores","Mark as Unanswered":"Marcar como no respondido","Mark as Answered":"Marcar como respondido","Remove from Priority":"Eliminar de prioridad","Mark as Priority":"Marcar como prioridad","Answer":"RESPONDER","Enter answer...":"Introduce la respuesta...","Answered by":"Respondido por","Submit Answer":"Enviar respuesta","Test your system’s speaker":"Prueba el altavoz de tu sistema","Click \\"Yes\\" if you hear the sound.":"Haz clic en «Sí» si escuchas el sonido.","Load previous":"Cargar anterior","Hide Name":"Ocultar nombre","Text Q&A is disabled in On Demand mode.":"Las preguntas y respuestas de texto están desactivadas en el modo On Demand.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"Se ha alcanzado el límite de preguntas y respuestas de texto. Los asistentes no podrán hacer nuevas preguntas.","Sent to Q&A":"Enviado a preguntas y respuestas","Couldn\'t post as Q&A. Please try again.":"No se ha podido publicar como preguntas y respuestas. Inténtalo de nuevo.","Yes this is being recorded":"Sí, esto se está grabando","No this is not being recorded":"No, esto no se está grabando","System\'s Speaker Check":"Comprobación del altavoz del sistema","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"Para asegurarte de que puedas escuchar durante el evento, asegúrate de que los altavoces del sistema funcionan correctamente","Click on “Test your system’s speaker” to proceed":"Haz clic en «Probar el altavoz de tu sistema» para continuar","Error while sharing message to screen. Post not found":"Error al compartir el mensaje en la pantalla. Publicación no encontrada","Lost connection to servers. Refresh your page to get live event experience.":"Se ha perdido la conexión con los servidores. Actualiza tu página para ver el evento en directo.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"VPN/Firewall está interfiriendo con tu autenticación. Cambia tu red o ponte en contacto con tu equipo de TI para permitir que <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>estos dominios</a> accedan a Goldcast sin problemas.","It\'s taking too long":"Está tardando demasiado","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"Parece que te has conectado a través de una VPN o tienes activado tu cortafuegos. Consulta este <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>documento de ayuda</a> e incluye en la lista blanca los dominios necesarios para que Goldcast funcione sin problemas; si no, debes cambiar tu red","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"Parece que te has conectado a través de una VPN o tienes activado tu cortafuegos. Consulta este <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>documento de ayuda</a> e incluye en la lista blanca los dominios necesarios para que Goldcast funcione sin problemas; si no, debes cambiar tu red o ver la sesión en el modo Lite","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"El servicio de transmisión de vídeo Goldcast no se puede conectar debido a un ancho de banda de red deficiente. Cambia tu red para conectar con el servicio de transmisión en vivo.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"El servicio de transmisión de vídeo Goldcast no se puede conectar debido a un ancho de banda de red deficiente. Cambia al modo Lite o cambia tu red para conectar con el servicio de transmisión","Most Upvotes":"Más votos positivos","Most Recent":"Más recientes","My Questions":"Mis preguntas","Prioritized":"Priorizado","Approved":"Aprobar","Unapproved":"No aprobado","Unanswered":"Sin respuesta","Failed to update answer. Please try again!":"Error al actualizar la respuesta. Inténtalo de nuevo.","Failed to post answer. Please try again!":"Error al publicar la respuesta. Inténtalo de nuevo.","Failed to delete question. Please try again!":"Error al eliminar la pregunta. Inténtalo de nuevo.","Survey Link":"Enlace de la encuesta","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"El cambio hará que se vuelva a cargar tu página actual con la vista de asistente. Para volver a la vista de organizador, desactiva la vista de asistente en el menú desplegable del perfil.","You haven\'t asked any questions yet":"Aún no has hecho ninguna pregunta","No prioritized questions":"Sin preguntas priorizadas","Create prioritized list of questions for speakers by marking questions as priority":"Crea una lista priorizada de preguntas para los oradores marcando las preguntas como prioritarias","No Approved Questions":"Preguntas no aprobadas","Approve incoming questions to see list of approved questions":"Aprueba preguntas entrantes para ver la lista de preguntas aprobadas","No Unapproved Questions":"No hay preguntas sin aprobar","No Answered Questions":"Preguntas sin respuesta","Answer a question on stage or with inline text":"Responde a una pregunta en el escenario o con texto en línea","All questions are answered":"Todas las preguntas serán respondidas","Rate Your Experience":"Valora tu experiencia","How satisfied are you with Goldcast?":"¿Cuál es tu grado de satisfacción con Goldcast?","What are the main reasons for your rating?":"¿Cuáles son los principales motivos de tu valoración?","I am interested in seeing a demo of Goldcast":"Me interesa ver una demostración de Goldcast","Thank You":"Gracias","Your feedback was successfully submitted.":"Tus comentarios se han enviado correctamente.","Tell us how we can improve...":"Dinos cómo podemos mejorar...","1 Slide":"1 diapositiva","Your internet connection is unstable.":"Tu conexión a internet es inestable.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"Parece que estás hablando con el micrófono en silencio. Haz clic en el icono de micrófono para activar el sonido","The registration could not be completed! Please check that this email is allowed to register for the event.":"No se ha podido completar el registro. Comprueba que este correo electrónico puede registrarse en el evento.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Parece que ya te has registrado para este evento. Revisa tu carpeta de correo no deseado para buscar la confirmación de registro, si no la has recibido. Si necesitas más ayuda, ponte en contacto con el organizador del evento.","Your registration could not be completed. This event has reached its registration capacity.":"No ha podido completar el registro. Este evento ha alcanzado su capacidad de registro.","Image cannot be an svg":"La imagen no puede estar en formato .svg","This should be a valid linkedin url":"Debe ser una URL de LinkedIn válida","This should be a valid twitter url":"Debe ser una URL de Twitter válida","This should be a valid url":"Debe ser una URL válida","Video":"vídeo","Read Less":"Leer menos","live":"EN VIVO","Opened":"Abierto","In person only":"Solo en persona","Stage Stream":"Transmisión de escenario","Streaming not available":"Transmisión no disponible","Close TV":"Cerrar TV","Streaming is not available for prerecorded and RTMP sessions":"La transmisión no está disponible para sesiones pregrabadas y RTMP","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Conecta tu ordenador a una pantalla de televisión o a un proyector para que los asistentes presenciales puedan ver lo que ocurre en tu escenario virtual, incluyendo diapositivas, preguntas y respuestas, etc. Una vez conectado, haz clic en TV ABIERTA y arrastra o comparte la nueva ventana a la pantalla de tu televisor o proyector. ","Close Setup Mode":"Cerrar modo Configuración","Help":"Ayuda","upcoming":"Futuros","ended":"Finalizado","Remove from favorites":"Eliminar de favoritos","Add to favorites":"Añadir a Favoritos","PLAY RECORDING":"Reproducir grabación","VIEW RECORDING":"VER GRABACIÓN","VIEW RECORDINGS":"VER GRABACIONES","Virtual Backgrounds":"Fondos virtuales","No Device Available":"No hay ningún dispositivo disponible","Needs permission":"Necesita permiso","Device not detected":"Dispositivo no detectado","Camera is on":"La cámara está encendida","Camera is off":"La cámara está apagada","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"El vídeo duplicado no se refleja en los espectadores. Los espectadores siempre ven vídeos no duplicados","Mirror My Video":"Duplicar mi vídeo","Camera":"CÁMARA","1. Click on Safari > Settings for this\\n            website":"1. Haz clic en Safari > Configuración para este\\n sitio web","1. Click the lock":"1. Haz clic en el candado","icon in your browser’s address bar":"de la barra de direcciones de tu navegador","3. Unmute":"3. Desactivar","and":"y","icons from stage control panel":"iconos del panel de control del escenario","icon from stage control panel":"icono del panel de control del escenario","2. Set camera and microphone to “Allow”.":"2. Configura la cámara y el micrófono en «Habilitar».","2. Set camera to “Allow”.":"2. Configura la cámara en «Habilitar».","2. Set microphone to \\"Allow\\"":"2. Configura el micrófono en «Habilitar».","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. Selecciona «Permitir siempre que Goldcast acceda a mi cámara y micrófono».","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. Selecciona «Permitir siempre que Goldcast acceda a mi cámara».","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. Elige «Permitir siempre que Goldcast acceda a mi micrófono».","Questions?":"¿Alguna pregunta?","If you’re having issues, check out our comprehensive":"Si tienes problemas, consulta nuestros detallados","help docs":"documentos de ayuda","Speaker is on":"El altavoz está encendido","Stop Test":"Detener prueba","Test your system’s audio":"Prueba el audio de tu sistema","Still can\'t hear any sound?":"¿Sigues sin escuchar ningún sonido?","Microphone":"MICRÓFONO","Audio is being played in system\'s default audio device.":"El audio se está reproduciendo en el dispositivo de audio predeterminado del sistema.","Click to view/change audio device":"Haz clic para ver/cambiar el dispositivo de audio","Speaker":"Expositor","Play Recording":"Reproducir grabación","Recording for this broadcast is currently being processed and will be available soon":"La grabación de esta emisión se está procesando en estos momentos y estará disponible en breve","You haven\'t favorited anything yet!":"¡Todavía no has marcado nada como favorito!","Add an item to favorites by selecting the ♡ in the top right corner.":"Añade un elemento a favoritos seleccionando el ♡ en la esquina superior derecha.","Session has ended":"La sesión ha finalizado","System Check":"Comprobación del sistema","Need help? Check out the":"¿Necesitas ayuda? Comprueba el","Skip Checks and Continue":"Omitir comprobaciones y continuar","Click the button above to run the test":"Haz clic en el botón de arriba para llevar a cabo la prueba","Test Screenshare":"Probar Compartir pantalla","Share message to stage":"Compartir mensaje en el escenario","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"Introduce el texto que te gustaría usar para el teletipo a continuación. Para convertir el teletipo en un hipervínculo, introduce una URL.","Ticker":"Teletipo","Coffee Break! Be back in 10m.":"¡Toca pausa para el café! Vuelve a intentarlo en 10 minutos.","Enter Message":"Escribir mensaje","https://www.xyz.com":"https://www.xyz.com","Launch":"Lanzamiento","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Gracias por enviar tus preguntas. Podrás enviar más una vez que se haya aprobado una de las actuales.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"Lo sentimos. El control de calidad está desactivado en estos momentos. Podrás enviar una pregunta una vez que el control de calidad esté habilitado de nuevo.","Votes":"Votos","Vote":"Votar","is inviting you to a video call":"te está invitando a una videollamada","ENTER ROOM":"INGRESAR A LA SALA DE CHAT","Start the conversation!":"Iniciar la conversación","Couldn\'t send message. Click here to retry.":"No se ha podido enviar el mensaje. Haz clic aquí para volver a intentarlo.","Couldn\'t add emoji. Please try again.":"No se ha podido añadir el emoji. Inténtalo de nuevo.","Couldn\'t remove emoji. Please try again.":"No se ha podido eliminar el emoji. Inténtalo de nuevo.","Couldn\'t delete message. Please try again.":"No se ha podido eliminar el mensaje. Inténtalo de nuevo.","Couldn\'t pin message. Please try again.":"No se ha podido anclar el mensaje. Inténtalo de nuevo.","Couldn\'t unpin message. Please try again.":"No se ha podido desanclar el mensaje. Inténtalo de nuevo.","Today":"Hoy","No messages yet":"Aún no hay mensajes","Messages from organizers and speakers appear here!":"¡Los mensajes de los organizadores y oradores aparecen aquí!","Next Session is Starting":"La próxima sesión está a empezando","Go to Next Session":"Ir a la siguiente sesión","I’d like to stay":"Me quiero quedar","My favorites":"Mis favoritos","1. Click on the lock icon in your address bar":"1. Haz clic en el icono del candado de la barra de direcciones","We recommend organizers and speakers use a desktop\\n        device":"Recomendamos que los organizadores y oradores usen un dispositivo\\n de escritorio","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"Para garantizar la mejor experiencia para los asistentes, los oradores y organizadores\\n deben usar Goldcast desde un ordenador de mesa. La transmisión desde un dispositivo móvil\\n provocará una experiencia degradada.","Watch Now":"Ver ahora","Video progress time":"Tiempo de progreso del vídeo","Total video duration":"Duración total del vídeo","Rate Goldcast!":"¡Califica a Goldcast!","Running Required Checks...":"Ejecutando las comprobaciones necesarias...","Test Your Setup":"Prueba tu configuración","Test your Computer Device, Microphone and Camera before you join the event":"Prueba tu dispositivo, micrófono y cámara antes de unirte al evento","Speaker and microphone not working?":"¿El altavoz y el micrófono no funcionan?","Passed":"Superadas","Fix Audio Issues":"Solucionar problemas de audio","Check if audio is being played in other sound devices connected to phone/tablet":"Verifica si el audio se está reproduciendo en otros dispositivos de sonido conectados al teléfono/tablet","Check if correct audio device is chosen from the below dropdown":"Comprueba si se elige el dispositivo de audio correcto en el menú desplegable de abajo","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>Haz clic aquí</a> para comprobar si se ha seleccionado el dispositivo de audio adecuado en el que reproducir","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Haga clic aquí</a> para comprobar si se ha seleccionado el dispositivo de audio adecuado en el que reproducir","Right click on the browser tab & click “Unmute Site”":"Haz clic con el botón derecho en la pestaña del navegador y luego en «Activar sonido en la página»","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Comprueba que la pestaña del navegador no esté silenciada o haz clic en Ventana> Activar el sonido de esta pestaña","System Check Failed!":"Las comprobaciones del sistema han dado error","System Check Passed!":"Comprobación del sistema superada","Complete checks to proceed":"Completa las comprobaciones para continuar","Enter Event":"INGRESAR AL EVENTO","Skip Screen Sharing Check? ":"¿Omitir comprobación de uso compartido de pantalla? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"Recomendamos completar el uso compartido de pantalla para verificar si tu pantalla debe presentarse en el evento.","Ignore & Enter Event":"Ignorar e introducir evento","Test screenshare":"Probar Compartir pantalla","Retry Now":"Reintentar ahora","SHARE":"Compartir","Rooms Closed":"Salas cerradas","Discussion rooms are now closed. You are being redirected to the Stage.":"Las salas de debate ya están cerradas. Te estamos redirigiendo al escenario.","Return To Stage":"VOLVER AL ESCENARIO","Unrecognized embedded widget provider - ":"Proveedor de widgets incrustados no reconocido - ","Room Ended":"Sala finalizada","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"El organizador de tu evento ha cerrado todas las salas. Ahora te redirigiremos al escenario del evento.","Video Q&A Request Cancelled":"Solicitud de preguntas y respuestas de vídeo cancelada","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Tu solicitud de preguntas y respuestas de vídeo se ha cancelado porque estás viendo en modo Lite. Cambia al modo en vivo para volver a levantar la mano.","Camera Passed":"Comprobación de cámara satisfactoria","Camera Error":"Error de cámara","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"Los permisos de la cámara no se conceden desde el navegador. Haz clic en «Permitir cámara».","Camera permissions aren’t granted from system. Click “Allow Camera”":"Los permisos de la cámara no se conceden desde el sistema. Haz clic en «Permitir cámara»","Uh-oh! Error occurred while creating camera stream":"¡Vaya! Se ha producido un error al crear la transmisión de cámara","Close other applications which might use camera stream":"Cierra otras aplicaciones que puedan utilizar la transmisión de cámara","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>Haz clic aquí</a> para comprobar si el navegador tiene acceso a la cámara","Microphone Passed":"Comprobación de micrófono satisfactoria","Microphone Error":"Error de micrófono","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"Los permisos del micrófono no se conceden desde el navegador. Haz clic en «Permitir micrófono»","Mic permissions aren’t granted from system. Click “Allow Microphone”":"Los permisos del micrófono no se conceden desde el sistema Haz clic en «Permitir micrófono»","Uh-oh! Error occurred while creating mic stream":"¡Vaya! Se ha producido un error al crear la transmisión del micrófono","Close other applications which might use mic stream":"Cierra otras aplicaciones que puedan utilizar la transmisión de micrófono","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>Haz clic aquí</a> para comprobar si el navegador tiene acceso al micrófono","Speaker and Microphone Error":"Error de altavoz y micrófono","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"Se requieren permisos de micrófono para mostrar la lista de dispositivos de altavoces conectados al sistema. Haz clic en «Permitir micrófono»","It seems mic is being used by other application. Close other applications to proceed.":"Parece que otra aplicación está utilizando el micrófono. Cierra otras aplicaciones para continuar.","Camera & Microphone Error":"Error de cámara y micrófono","To enable permissions, click the Allow Camera & Mic button below":"Para habilitar los permisos, haz clic en el botón Permitir cámara y micrófono a continuación","Network Connection":"Conexión de red","Check Passed":"Comprobación superada","Could not establish a network connection":"No se pudo establecer una conexión de red","Connect to a different network, or use a mobile hotspot.":"Conéctate a otra red o usa un punto de acceso móvil.","Disable any VPN or firewall is connected.":"Deshabilita cualquier VPN o cortafuegos conectado.","Connection: Good":"Conexión: buena","Network Connection Error":"Error de conexión de red","Can’t connect to network. Change your network or limited functionality will be available during event.":"No se puede conectar a la red. Cambia la red o la funcionalidad estará limitada durante el evento.","AdBlocker":"Bloqueador de anuncios","AdBlocker not detected.":"Bloqueador de anuncios no detectado.","AdBlocker detected. This may degrade your event experience.":"Bloqueador de anuncios detectado. Esto puede afectar la experiencia de tu evento.","Disable adblocker for best experience.":"Deshabilita el bloqueador de anuncios para una mejor experiencia.","You are using ":"Estás usando ","Use Windows or Mac OS for best performance":"Utiliza Windows o Mac OS para obtener el mejor rendimiento.","Browser Check":"Comprobación del navegador","Check Passed.":"Comprobación superada.","Switch To Lite Mode":"Cambiar al modo Lite","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Tu solicitud de preguntas y respuestas de vídeo pendiente se cancelará cuando cambies al modo Lite","Stay on Live Mode":"Permanece en el modo en vivo","Unable to mark as favorite":"No se puede marcar como favorito","Event organizers must enter the event to select favorites.":"Los organizadores de eventos deben entrar en el evento para seleccionar los favoritos.","Make an Announcement":"Hacer un anuncio","STOP":"DETENER","InPerson CheckIn App":"Aplicación de registro InPerson","App to Check-In In-Person attendees":"Aplicación InPerson de registro de asistentes","SEE AGENDA":"Ver agenda","Please visit the Agenda tab to view the session recordings":"Visita la pestaña Agenda para ver las grabaciones de la sesión","The session recordings will be available soon in the Agenda tab":"Las grabaciones de la sesión estarán disponibles pronto en la pestaña Agenda","FAILED!":"ERROR","Next session is beginning":"La próxima sesión está empezando","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"¿Quieres pasar a la siguiente sesión? Tu transmisión continuará y tu TV emitirá la nueva sesión.","Banners":"Banners","Images":"Imágenes","Screen Share":"Compartir pantalla","Browser might not have screen-recording permission on your computer.":"Es posible que el navegador no tenga permiso de grabación de pantalla en tu ordenador.","Open System Preferences":"Abrir preferencias del sistema","Error publishing screen because someone else started screen share already.":"Error al publicar la pantalla porque otra persona ya ha empezado a compartir la pantalla.","Live Feed":"Señal en vivo","Check Your Network":"Comprueba tu red","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"¡Hemos detectado un error al reproducir el vídeo! Si tienes problemas con la reproducción de vídeo, intenta actualizar la página o cambiar al modo Lite.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"¡Hemos detectado un error al reproducir el vídeo! Si tienes problemas con la reproducción de vídeo, prueba a actualizar la página.","All Dates":"Todas las fechas","All Tracks":"Todas las pistas","Create Ticker":"Crear teletipo","Booths Closed":"Cabinas cerradas","Your event organizer has closed all the booths. You will now be redirected to the stage":"El organizador de tu evento ha cerrado todas las cabinas. Ahora te redirigiremos al escenario.","Visit the Polls tab to view live results.":"Visita la pestaña de encuestas para ver los resultados en directo.","A new poll is open! Visit the Polls tab to vote.":"¡Ya hay una nueva encuesta abierta! Visita la pestaña Encuestas para votar.","Vote for Polls":"Votar encuestas","Go to Polls Tab":"Ir a la pestaña Encuestas","Microphone audio too low":"Audio del micrófono demasiado bajo","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"Hemos detectado un problema con tu audio. Recomendamos intentar silenciar/activar el sonido o usar otro dispositivo si el problema persiste.","Audio/Video bitrate too low":"Velocidad de bits de audio/vídeo demasiado baja","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"La configuración del cortafuegos de la red bloquea las transmisiones de A/V. Se recomienda cambiar a una conexión de red diferente.","Error sharing screen":"Error al compartir la pantalla","A network error occurred while sharing screen. Please check your network connection.":"Se ha producido un error de red al compartir la pantalla. Comprueba tu conexión de red.","Apologies, due to some errors, we need to refresh the page!":"Lo sentimos, debido a algunos errores, tenemos que actualizar la página.","Warning":"Advertencia","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"Hemos detectado un problema con tu vídeo. Te recomendamos que intentes cerrar otras pestañas del navegador u otras aplicaciones que se ejecuten en tu dispositivo y verifiques/actualices tu conexión a internet para resolver el problema.","No results found":"No se han encontrado resultados","Audio":"audio","Please choose another microphone and camera":"Elige otro micrófono y otra cámara","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"El micrófono y la cámara seleccionados actualmente no funcionan. Elige otro micrófono y cámara de los menús desplegables a continuación.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"La cámara seleccionada no funciona. Elige otra cámara en el menú desplegable a continuación.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"Te invitamos a continuar sin cámara, aunque te recomendamos que resuelvas el problema para garantizar una experiencia de transmisión fluida.","Please choose another microphone":"Elige otro micrófono","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"El micrófono seleccionado no funciona. Elige otro micrófono en el menú desplegable a continuación.","Please check that your TV speaker is correct":"Comprueba que el altavoz de tu TV sea el correcto","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"El altavoz seleccionado no funciona. Elige otro orador en el menú desplegable a continuación.","Your answer":"Tu respuesta","Edit":"Editar","Delete":"Eliminar","Settings":"Configuración","Signing Out":"Cerrando sesión","Confirming your account...":"Confirmando tu cuenta...","Something Went Wrong. Please Retry :(":"Algo ha salido mal Vuelve a intentarlo :(","Resending Mail":"Reenviando correo","offline":"sin conexión","I am inviting you to a video meeting:":"Te invito a una videollamada:","Resending secure login link to your email":"Volviendo a enviar enlace de acceso seguro a tu correo electrónico","Sending secure login link to your email":"Enviando enlace de acceso seguro a tu correo electrónico","Something went Wrong. Please Retry :(":"Algo ha salido mal. Vuelve a intentarlo :(","Updating your password":"Actualizando tu contraseña","Sending mail":"Enviando correo","Verifying":"Verificando","This might be slower than usual":"Podría tardar más de lo habitual","Checking":"Verificando","New results available! Refresh!":"Nuevos resultados disponibles Actualizar","Saving":"Guardando","Turn off Attendee mode":"Desactivar el modo asistente","See Attendee View":"Ver vista de asistente","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Número total de asistentes que están viendo esta sesión. Nota: esto solo lo verá el organizador","Session Count":"Recuento de sesión","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"El número de asistentes que está actualmente viendo sesiones en vivo. Nota: esto solo lo verá el organizador","Role":"Rol","Total Attendees":"Asistentes totales","Total number of attendees online at this time Note: This is for organizer eyes only":"Número total de asistentes en línea en este momento. Nota: esto solo lo verá el organizador","My Profile":"Mi perfil","Languages":"Idiomas","Filling out your profile can help you connect with people with similar interests.":"Completar tu perfil puede ayudarte a conectar con personas con intereses similares.","type to search for your address":"escribe para buscar tu dirección","Could not open direct call":"No se pudo abrir la llamada directa","Chat messages can only be published from inside a broadcast.":"Los mensajes de chat solo se pueden publicar desde una transmisión.","Stage Logo can only be published from inside a broadcast.":"El logotipo del escenario solo se puede publicar desde una emisión.","Loading Speakers":"Cargando altavoces","Raise hand is disabled for organizer accounts, but active for attendee accounts":"Levantar la mano está desactivado para las cuentas de organizador, pero activado para las cuentas de asistente","Disabled in lite mode, return to live if you’d like to raise hand!":"Desactivado en modo Lite, vuelve a Transmisión en vivo si quieres levantar la mano","Raise hand to enter stage for video q&a":"Levanta la mano para subir al escenario para preguntas y respuestas por vídeo","Speakers":"Expositores","Hosting organization: {organization}":"Organizadora: {organization}","Failed to switch {deviceTag}":"Error al cambiar {deviceTag}","Make sure your {deviceTag} is not being used by any other application and is working properly.":"Asegúrate de que tu {deviceTag} no está siendo utilizado por ninguna otra aplicación y que funciona correctamente.","Facing issues with audio or video? Switch on lite mode":"¿Problemas con el audio o el vídeo? Cambia al modo Lite","Failed to get event for eventID: {eventID}":"No se ha podido obtener el evento para eventID: {eventID}","Error while playing video.":"Error al reproducir el vídeo.","Speakers only, attendees can\'t see this chat":"Solo oradores, los asistentes no pueden ver este chat","Kudo":"Kudo","Room":"Sala de chat","Session":"Sesión","Booth":"Cabina","Public":"Público","Drift":"Drift","Slides":"Diapositivas","Videos":"Videos","Chat":"Chat","Messages":"Mensajes","Poll":"Encuesta","Docs":"Documentos","Q&A":"Preguntas y respuestas","Media":"medios de comunicación","Messages Chat":"Chat de mensajes","Leaderboard":"Tabla de clasificación","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Nota: tú también eres ponente de este evento. Siempre podrás entrar entre bastidores y subir al escenario.","Switch to Attendee View":"Cambiar a la vista de asistente","Return to Organizer View":"Volver a la vista de organizador","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"Desactivar la vista de asistente hará que se vuelva a cargar tu página actual con la vista de organizador. ¿Quieres continuar?","Switch":"CAMBIAR","Request Sent":"Solicitud enviada","Your request for a demo has been submitted":"Se ha enviado tu solicitud de demostración","Organizer Redirection":"Redirección del organizador","YES, REDIRECT":"SÍ, REDIRIGIR","DISMISS":"DESCARTAR","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"Se está redirigiendo a los asistentes a la siguiente sesión: {title}. ¿Quieres que te redirijamos a la próxima sesión?","Stage":"Escenario","Rooms":"Salas de chat","Join a round table to discuss moderated topics with your fellow attendees":"Únete a una mesa redonda para debatir temas moderados con tus compañeros asistentes","Booths":"Cabinas","Join a booth to know more about a sponsor":"Únete a una cabina para obtener más información sobre un patrocinador","You are in the booth":"Estás en la cabina","People":"Asistentes","Connect with your fellow attendees":"Conecta con tus compañeros asistentes","Connect with speakers":"Conectar con altavoces","starting in {duration}":"empieza en {duration}","You will be redirected to booths in {duration}":"Se te redirigirá a las cabinas en {duration}","booths":"Cabinas","agenda":"agenda","You will be redirected to {word} in {duration}":"Se te redirigirá a {word} en {duration}","You will be redirected to the live stage in {duration}":"Se te redirigirá al escenario en vivo en {duration}","- You are about to be redirected to {tabTitle} in {duration}":"- Estamos a punto de redirigirte a {tabTitle} en {duration}","See Agenda":"Ver agenda","Break":"PAUSA","{title} is now live":"{title} ya está en directo","Apologies, due to an error we need to refresh the page!":"Lo sentimos, debido a un error, tenemos que actualizar la página.","Network interruption detected":"Interrupción de red detectada","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"Tu conexión a internet está teniendo algunos problemas. Si estás utilizando una VPN, considera la posibilidad de desactivarla. Como alternativa, intenta conectarte a una red diferente","No audio output device detected":"No se ha detectado ningún dispositivo de salida de audio","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Conecta tus altavoces/auriculares y utiliza el icono del engranaje para probarlos si tienes algún problema.","Please disable ad blocker for this page":"Desactiva el bloqueador de anuncios para esta página","Yes, I understand":"Sí, entiendo","No event user found so attended not marked!":"No se ha encontrado ningún usuario del evento, por lo que no se ha registrado la asistencia.","Wait while the speaker approves your video q&a request":"Espera mientras el ponente aprueba tu solicitud de preguntas y respuestas por vídeo","Organizer":"Organizador","UPNEXT":"siguiente","Ended":"Finalizado","Hide":"Ocultar","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"Esta página te redirigirá automáticamente en {durationLeftToRedirect} segundos.","Register":"Registrarte","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Error: no se ha podido registrar al usuario para este evento. Ponte en contacto con el organizador del evento para obtener ayuda","You are already registered!":"Ya te has registrado.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Parece que ya te has registrado para este evento. Revisa tu carpeta de correo no deseado para buscar la confirmación de registro, si no la has recibido. Si necesitas más ayuda, ponte en contacto con el organizador del evento","Thank you for registering!":"¡Gracias por registrarte!","Submit another response":"Enviar otra respuesta","Share":"Compartir","Know someone who want to attend this?":"¿Conoces a alguien que quiera asistir a esto?","COPY LINK":"COPIAR ENLACE","Powered by":"Ejecutada por","VIEW PROFILE":"VER PERFIL","You can access the event landing here":"Puede acceder a la página de inicio del evento aquí","Need Help?":"¿Necesitas ayuda?","Welcome back":"Bienvenido de nuevo","Checking...":"Verificando…","Close":"Cerrar","Enter":"Ingresar","See {roomCount} Room(s)":"Ver {roomCount} sala(s)","Back":"Volver","Request a Demo":"Solicitar una demostración","Loading":"cargando","Thread":"Hilo","Load more":"Cargar más","Heads up!":"¡Aviso!","YES":"SÍ","No":"No","Following":"Seguiendo","Error in loading drimify":"Se ha producido un error al cargar drimify","You\'re not registered for this event":"No te has registrado para este evento","Check out other events":"ECHA UN VISTAZO A OTROS EVENTOS","Date":"Fecha","Location":"Ubicación","How are you attending the event":"¿Cómo vas a asistir al evento?","In Person":"En persona","Virtually":"De forma virtual","Event Widgets":"Widgets de eventos","Chat • Messages • Q&A • Poll • Docs":"Chat • Mensajes • Preguntas y respuestas • Encuesta • Documentos","DISCUSSION":"DEBATE","JOIN":"UNIRTE","WAIT":"ESPERA","more":"más","See Profile":"Ver perfil","Filter":"Filtrar","Video player not supported by your browser":"Reproductor de video no es compatible con tu navegador web","We recommend using the latest version of Google Chrome to access your conference":"Recomendamos utilizar la última versión de Google Chrome para acceder a tu conferencia.","ANSWER":"RESPONDER","REJECT":"RECHAZAR","Don’t ask me this next time":"No preguntarme la próxima vez","Cancel":"Cancelar","Lite Mode":"Modo Lite","On":"Encender","Connection Issues? Turn on Lite Mode":"¿Problemas de conexión? Activar el modo Lite","Turn On Lite Mode":"Activar el modo Lite","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"El modo Lite generará un retraso de 30 segundos entre la transmisión en vivo y lo que verás en tu pantalla. ¿Quieres continuar?","Turn On":"Activar","Lite Mode Active!":"Modo Lite activado","Thanks for your patience, lite mode now on!":"Gracias por tu paciencia, el modo Lite ya está activado","Turn off Lite Mode?":"¿Desactivar el modo Lite?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Desactivar el modo Lite para volver a ver la emisión en vivo. Atención, esto causará un intervalo de 30 segundos hasta que sincronicemos con el directo.","Lite Mode Off!":"Modo Lite desactivado","Thanks for your patience, we’ve returned to the live broadcast!":"Gracias por tu paciencia, hemos vuelto a la emisión en vivo.","Lite Mode Unavailable":"Modo Lite no disponible","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Sentimos las molestias, el modo Lite no está disponible en este momento; por favor cambia a Transmisión en Vivo para reanudar tu sesión.","Turn off Lite mode?":"¿Desactivar el modo Lite?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"Hemos detectado que tu conexión ha vuelto a la normalidad. ¿Quieres volver a la emisión en vivo? Atención, esto causará un intervalo de 30 segundos hasta que sincronicemos con el directo.","Turn Off":"Desactivar","Lite mode is disabled for organizer accounts, but active for attendee accounts":"El modo Lite está desactivado para las cuentas de organizador, pero activado para las cuentas de asistente","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"El modo Lite no es compatible con tu navegador. Recomendamos utilizar la versión más reciente de Google Chrome","Lite mode is not curently available. We’ll let you know once it’s available again":"El modo Lite no está disponible actualmente. Te informaremos cuando vuelva a estar disponible","Turn off Lite Mode":"Desactivar el modo Lite","We’ll let you know when Lite mode is available again":"Te informaremos cuando el modo Lite vuelva a estar disponible","Lite Mode Available":"Modo Lite disponible","Loading Lite Mode...":"Cargando modo Lite...","Turning Off Lite Mode":"Desactivando el modo Lite","Lite Mode On":"Modo Lite activado","Audio/Video Issues?":"¿Problemas de audio/vídeo?","Error":"Error","Click a video to play":"Haz clic en un vídeo para reproducirlo","Error starting video!":"Error al iniciar el vídeo","Please rotate your device to {mode} mode":"Gira tu dispositivo al modo {mode}","landscape":"horizontal","portrait":"vertical","Thank you for attending this event!":"Gracias por asistir al evento","Go to Rooms":"Ir a las salas","Please use a desktop or laptop Google Chrome browser to access your conference":"Utilica un navegador Google Chrome de escritorio o portátil para acceder a tu conferencia","If on Desktop":"Si estás en ordenador de mesa:","Please increase the width of your window":"Aumenta el ancho de la ventana","Alternatively, check out the":"También puedes consultar el","Youtube Livestream":"Transmisión en vivo de YouTube","Search":"Buscar","Profile":"Perfil","Yes":"Sí","Loading Chat":"Cargando chat","Please wait while we fetch the chat":"Por favor, espera mientras buscamos el chat","Load old messages":"Cargar mensajes antiguos","Join the room to see chat":"Únete a la sala para ver el chat","Live Chat":"Chat en vivo","Uh..oh we couldn\'t load the content":"Vaya, no hemos podido cargar el contenido","Please reload the page":"Vuelve a cargar la página","New comments":"Nuevos comentarios","Start the conversation":"Iniciar la conversación","Be the first to add to chat!":"¡Sé la primer persona en añadir al chat!","Enter your message":"Escribe tu mensaje","Joining chat!":"Uniéndose al chat","See all pinned messages":"Ver todos los mensajes anclados","Failed to send! Retry?":"Error al enviar. ¿Volver a intentarlo?","Search for attendee":"Buscar asistente","Up to date":"Actualizado","Start a new conversation, We think you\'ll enjoy":"Empieza una nueva conversación, creemos que la disfrutarás","chatting with these recommended attendees!":"chateando con estos asistentes recomendados","Searching":"Buscando","Load Previous":"Cargar anterior","Load Next":"Cargar Siguiente","Loading Channel":"Cargando canal","Please wait while we fetch the channel":"Por favor, espera mientras buscamos el canal","Please wait while we fetch the messages":"Por favor, espera mientras recuperamos los mensajes","Send the first message":"Enviar el primer mensaje","Join":"Unirse","link":"enlace","download":"descargar","Click to open":"Haz clic para abrir","No open polls":"No hay encuestas abiertas","Check back later to see if a poll opens up!":"¡Vuelve más tarde para ver si se abre una encuesta!","Loading Poll":"Cargando Encuesta","Please wait while we fetch the polls":"Por favor, espera mientras buscamos las encuestas","Uh oh.. we couldn’t load the content":"Vaya, no hemos podido cargar el contenido","Polls":"Encuestas","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"Para iniciar una encuesta, añade las preguntas y las respuestas a esta sesión en el panel de administración de Goldcast","Stop Sharing":"Dejar de compartir","Can\'t publish polls while something else is being presented on stage":"No se puede publicar una encuesta mientras se presenta otra cosa en el escenario","Open":"Abierto","Cancel your video q&a request":"Cancela tu solicitud de preguntas y respuestas por vídeo","Pending...":"Pendiente...","Leave Stage":"Abandonar Escenario","Raise Hand":"Levantar la mano","Text Q&A":"Preguntas y respuestas de texto","Video Q&A":"Preguntas y respuestas por vídeo","Loading Q&amp;A":"Cargando preguntas y respuestas","Please wait while we fetch the Q&amp;A":"Espera mientras obtenemos las preguntas y respuestas","Uh oh.. we couldn\'t load the content":"Vaya, no hemos podido cargar el contenido","No Questions Yet":"Todavía no hay preguntas","Tell your audience to send in questions!":"Dile a tu audiencia que envíe preguntas","Be the first to ask a question!":"¡Sé la primera persona en hacer una pregunta!","Tell your audience to raise their hand!":"Dile a tu audiencia que levante la mano","Approve":"Aprobar","Reject":"Rechazar","End":"Terminar","RELOAD":"REFRESCA","Logos On Stage":"Logotipos en el escenario","No File Chosen":"No se ha elegido ningún archivo","loading":"cargando","Can\'t publish a slide when there is something else being presented on stage":"No se puede publicar una diapositiva mientras se presenta otra cosa en el escenario","Change Deck":"Cambiar presentación","stop-screen-share":"stop-screen-share","screen-share":"screen-share","Select a deck to begin presenting":"Selecciona una presentación para empezar la ponencia","CONFIRM":"CONFIRMAR","If you’re having issues, please refer to the":"Si tienes problemas, consulta","SPEAKER":"ALTAVOZ","Issue Testing Audio!":"Se ha producido un problema al probar el audio","VPN and adblockers may cause video issues, please disable them before proceeding":"Las VPN y los bloqueadores de publicidad pueden causar problemas de vídeo, desactívalos antes de continuar","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"Como nota, las VPN y los bloqueadores de publicidad pueden causar problemas de vídeo, así que asegúrate de mantenerlos desactivados durante la emisión","Follow":"Seguir","Read More":"Más información","Ask a question":"Haz una pregunta","Shared":"Compartido","Answered":"Respondido","Waiting Approval":"Esperando aprobación","cancel":"cancelar","ENTER":"INGRESAR A","Upcoming Events":"Próximos eventos","Past Events":"Eventos anteriores","Goldcast":"Goldcast","MANAGE EVENT":"GESTIONAR EVENTO","Edit Profile":"Editar perfil","Stay tuned!":"¡Estate pendiente!","Sign-in instructions will be available here 12 hours prior to the event":"Las instrucciones de inscripción estarán disponibles aquí 12 horas antes del evento","Please log out":"Cierra la sesión","Logout":"Cerrar sesión","Continue as {differentUser}":"Continuar como {differentUser}","You are already logged in as {user}.":"Ya has iniciado sesión como {user}.","EMAIL":"CORREO ELECTRÓNICO","user@email.com":"user@email.com","FIRST NAME":"Nombre","First Name":"Nombre","LAST NAME":"Apellidos","Last Name":"Apellidos","You are not registered to this event":"No te has registrado para este evento","Please enter your email and name":"Introduce tu correo electrónico y tu nombre","Please enter your email":"Introduce tu correo electrónico","We have sent a secret code to":"Hemos enviado un código secreto a","BACK":"VOLVER","Didn\'t receive an email? Make sure to check spam list":"¿No has recibido un correo electrónico? Asegúrate de comprobar la lista de correo no deseado","Resend Mail":"Volver a enviar correo","SECRET CODE":"CÓDIGO SECRETO","Please enter the temporary password sent to your email":"Introduce la contraseña temporal enviada a tu correo electrónico","NEW PASSWORD":"NUEVA CONTRASEÑA","Please enter a new password":"Introduce una nueva contraseña","CONFIRM PASSWORD":"CONFIRMAR CONTRASEÑA","Please re-enter the new password":"Vuelve a introducir la nueva contraseña","Password length should be atleast 8":"La longitud de la contraseña debe ser de al menos 8","Password and Confirm Password don\'t match !!":"La contraseña y la confirmación de la contraseña no coinciden.","Please enter your password to continue":"Introduce tu contraseña para continuar","Logging you in...":"Iniciando sesión...","PASSWORD":"CONTRASEÑA","Forgot credentials?":"¿Has olvidado tus credenciales?","Forgot Password? A mail will be sent to your registered email.":"¿Has olvidado tu contraseña? Se te enviará un correo a tu correo electrónico registrado.","Email cannot be blank!!":"El correo electrónico no puede estar en blanco.","We have sent a secure login link to":"Hemos enviado un enlace de acceso seguro a","from":"de","Please use that to access your event.":"Utilízalo para acceder al evento.","Please check spam/promotion too if you can\'t find it.":"Consulta la carpeta correo no deseado/promociones si no lo encuentras.","Thank You !":"Gracias","The link is not valid.":"El enlace no es válido.","Please be patient.":"Por favor, ten paciencia.","We are verifying your link.":"Estamos verificando tu enlace.","Thank you for entering the code!":"Gracias por introducir el código.","Please create a new password":"Crea una nueva contraseña","Signing you up...":"Registrándote...","We have sent a temporary password to":"Hemos enviado una contraseña temporal a","TEMPORARY PASSWORD":"CONTRASEÑA TEMPORAL","Please enter the temporary password sent to your mail":"Introduce la contraseña temporal enviada a tu correo electrónico","Password Length should be 8":"La longitud de la contraseña debe ser de 8","Okay":"Vale","Backstage: {title}":"Entre bastidores: {title}","Prep Area":"AREA DE PREPARACIÓN","Starting at {time}":"Empieza a las {time}","person":"persona","inside":"dentro de","No one is inside":"No hay nadie dentro","This area is for you to sync up with your fellow speakers before you go on stage.":"Esta es una área de prueba para que lpuedas dialogar con tus compañeros expositores antes de subir al escenario.","This area is for you to check your cam and mic before you enter the room.":"Esta zona es para que compruebes tu cámara y tu micrófono antes de entrar en la sala.","I\'m Ready":"ESTOY LISTO","Watch Live":"Ver en vivo","Backstage":"Entre bastidores","You are sharing your screen":"Estás compartiendo tu pantalla","LIVE":"EN VIVO","Live":"EN VIVO","Virtual":"Virtual","Only available for ":"Solo disponible para ","See Booths":"Ver cabinas","See Rooms":"Ver salas","Enter Backstage":"Entrar entre bastidores","This track has no upcoming sessions. Check out a different track.":"Esta pista no tiene próximas sesiones. Echa un vistazo a otra.","View":"Ver","Agenda":"Agenda","Scroll to see all tracks":"Desplázate para ver todas las pistas","No Agenda Items to show!":"No hay elementos del orden del día que mostrar","ENTER EVENT":"INGRESAR AL EVENTO","change":"CAMBIAR","Upload":"Subir","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF O PNG. TAMAÑO MÁXIMO DE 5 MB","Create Profile":"CREAR PERFÍL DE USUARIO","Email":"Correo electrónico","Company":"Empresa","Title":"Título","No matching locations found":"No se han encontraron ubicaciones que coincidan","You can try searching for the location with another keyword":"Puedes intentar buscar la ubicación con otra palabra clave","Interest Tags":"Etiquetas de interés","Pick your first tag":"Elige tu primera etiqueta","Save":"Guardar","Searching...":"Buscando...","Twitter":"Twitter","Select Your First Tags":"Selecciona tus primeras etiquetas","Add Interest tags":"Añadir etiquetas de interés","Congratulations!":"Enhorabuena.","Your first Goldcast event is set up":"Tu primer evento de Goldcast está configurado","You can always visit":"Siempre puedes visitar","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"para obtener instrucciones sobre cómo configurar y llevar a cabo tus eventos","See My Event":"Ver mi evento","Peak Community":"Peak Community","Loading Lite Mode... This may take up to 30s":"Cargando modo Lite... Puede tardar hasta 30 s","Loading Video...":"Cargando vídeo...","Video will begin at session start time":"El vídeo comenzará a la hora de inicio de la sesión","TIME":"HORA","TITLE":"TÍTULO","STATUS":"ESTADO","END":"Terminar","START":"EMPEZAR","AGENDA":"AGENDA","Enable Audio":"Habilitar audio","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"Se ha silenciado el audio debido a las políticas de reproducción automática del navegador. Haz clic en habilitar abajo, para activar el sonido. También puedes activar el sonido más tarde a través de los controles integrados.","Enable":"Habilitar","You are being redirected outside the room. Would you like to continue?":"Te he estamos redirigiendo fuera de la sala. ¿Quieres continuar?","Continue":"Continuar","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"Como alternativa, puedes usar el modo Lite, que tendrá un retraso de 30 s en la transmisión en directo","We detected a network issue":"Hemos detectado un problema de red","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Asegúrate de no estar conectado a través de una VPN/Firewall. Intenta cambiar de red, de navegador o de dispositivo si el problema persiste.","Could not connect":"No se ha podido conectar","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"Esto podría deberse a un problema de seguridad de la red, del navegador o del dispositivo. Intenta cambiar de red, de navegador o de dispositivo si el problema persiste","Switch to Lite Mode":"Cambiar al modo Lite","Leave":"abandonar","Screenshare had an issue":"Se ha producido un error al compartir pantalla","Could not share screen unexpectedly. Refresh & retry. On mac go to":"No se ha podido compartir la pantalla de forma inesperada. Actualiza e inténtalo de nuevo. En un Mac dirígete a","and check if your browser has the required permission":"y comprueba si tu navegador tiene el permiso requerido","Uh OH... Something went wrong":"¡Vaya! Algo ha salido mal","To fix this, click the":"Para solucionarlo, haz clic en el","in your URL bar, then select “Allow”, and then click “Try Again”":"en tu barra de URL, luego selecciona \\"Permitir\\" y luego haz clic en \\"Volver a intentarlo\\"","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"No se ha podido inicializar la transmisión multimedia debido a una razón desconocida. Es posible que tu navegador no sea compatible con nuestra plataforma. Recomendamos utilizar \\"Google Chrome\\". Si este problema persiste, ponte en contacto con el servicio de asistencia de Goldcast","To fix this, make sure your":"Para solucionarlo, asegúrate de que ninguna aplicación está","is not being accessed by any other app. If not, please try changing your":"accediendo a tu Si no, intenta cambiar tu","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"dispositivos pulsando en \\"Ir a la configuración\\". ¡Después de resolver el probable problema, pulsa \\"Intentar de nuevo\\"!","Go To Settings":"Ir a Configuración","Try Again":"Volver a intentarlo","Try Joining without Video":"Prueba a unirte sin vídeo","A refresh and rejoin should work":"Actualizar y volver a unirse debería funcionar","Refresh & Rejoin":"Actualizar y volverse a unir","Start Chat":"Iniciar chat","On Stage":"Escenario","Connect your on-site camera and microphone to present to your virtual attendees":"Conecta tu cámara y micrófono in situ para presentar a sus asistentes virtuales","Stop Streaming":"Detener la transmisión","Start Streaming":"Empezar la transmisión","Set up on-site video feed":"Configurar la transmisión de vídeo in situ","Open TV":"Televisión abierta","Layout: {layout} ":"Diseño: {layout} ","With Speaker Videos":"Vídeos con ponentes","Full Screen":"Pantalla completa","No Speakers":"Sin ponentes","Turn Off Setup Mode":"Desactivar el modo de configuración","Setup Mode":"Modo configuración","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"Pulsa desactivar si deseas detener el modo de configuración para {roomTitle}. Al hacerlo, también se desactivarán las transmisiones activas.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"Preparando la transmisión: {roomTitle}. Utiliza este modo de configuración solo para transmitir desde la ubicación en directo.","Starting in {duration}":"Empieza en {duration}","Can\'t share screen while there is something else being presented on stage":"No se puede compartir la pantalla mientras se presenta otra cosa en el escenario","You are now in attendee view!":"Ahora estás en la vista de asistente.","You are now in organizer view!":"Ahora estás en la vista de organizador.","Note :":"Nota:","Only organizer accounts can see this tag, normal attendees can’t see this":"Solo las cuentas de organizador pueden ver esta etiqueta, los asistentes normales no pueden ver esto","Attendee":"Asistente","Event Information":"Información sobre el evento","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"La información del evento solo es visible para los organizadores <br /> Esta sección no es visible para los asistentes","Operating System":"Sistema operativo","Secondary Booths":"Cabinas secundarias","Sort":"Ordenar","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"Siguiendo a {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2}dejará de seguirte automáticamente desde{track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}¿Quieres continuar?","Track only available for {tracks}":"El seguimiento solo está disponible para {tracks}","Add to Calendar":"AGREGAR AL CALENDARIO","Open Speakers Control Panel":"Abrir el panel de control de los altavoces","Move Offstage ↓":"Sacar del escenario ↓","Error Moving ⚠":"Error de desplazamiento ⚠","Off Stage":"Fuera del escenario","Move to Stage":"Mover al escenario","An error occurred!":"Se ha producido un error","{eventName} Documents":"{eventName} Documentos"," Set Up Mode":" Modo configuración","Camera & Mic blocked":"La cámara y el micrófono están bloqueados","Camera/Mic Inaccessible":"No se puede acceder a la cámara/micrófono","Camera/Mic Not Found":"No se puede encontrar la cámara/micrófono","Camera Inaccessible":"No se puede acceder a la cámara","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"La cámara está ocupada o la resolución no es compatible. Asegúrate de que otra app no esté usando la cámara y vuelve a intentarlo.","No microphone/camera is found":"No se encontró ningún micrófono/cámara","The browser does not support using camera and microphone!":"El navegador no admite el uso de cámara ni micrófono.","{n} Slides":"{n} Diapositivas","Starting in {timeduration}":"Empieza en {timeduration}","{eventtitle} has ended":"{eventtitle} ha finalizado","This is a text q&a question!":"Esta es una pregunta de texto de preguntas y respuestas","Click here{if_it_does_not}":"Haz clic aquí{if_it_does_not}","{click_here}if it does not":"{click_here}si no lo hace","{title}up next":"{title}siguiente","seat(s) open":"espacio(s) disponible(s)","Signal strength is low. Close other windows or connect to a different network.":"La intensidad de la señal es baja. Cierra otras ventanas o conéctate a otra red.","GO BACKSTAGE":"IR ENTRE BASTIDORES","LEAVE STAGE":"Abandonar Escenario","LEAVE":"abandonar","This event begins on{startitme}":"Este evento comienza el{startitme}","Please refresh to enter.":"Actualiza para entrar.","people":"Asistentes","Oops, Something went wrong":"¡Vaya! Algo ha salido mal","Back Home":"Volver a inicio","Deciding where to go ...":"Decidir a dónde ir ...","Go to Event Hub":"Ir al Centro de eventos","CREATE":"CREAR","Attending Virtually":"Asistencia virtual","Attending In Person":"Asistencia presencial","Click to change your attendance type":"Haz clic para cambiar tu tipo de asistencia","Open Chat":"Abrir chat","Create your profile for {eventtitle}":"Crea tu perfil para {eventtitle}","Move to stage":"Mover al escenario","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"El organizador del evento ha solicitado tu traslado al escenario para <strong>{broadcastTitle}</strong>.<br /><br />Si haces clic para aceptar la solicitud, estarás en directo y serás visible para los asistentes al evento.<br /><br />","Go Live On Stage":"En directo en el escenario","Moved to backstage":"Trasladado a los bastidores","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"El organizador te ha retirado del escenario. No trates de reincorporarte sin ponerte en contacto con el organizador.","Error creating Screen stream":"Error al crear transmisión de Pantalla","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"No se ha concedido permiso para compartir pantalla. *Haz clic aquí* para consultar los documentos de resolución de problemas.","Error publishing stream":"Error al publicar la transmisión","Could not publish stream. Please refresh and try again!":"No se ha podido publicar la transmisión. Actualiza la página e inténtalo de nuevo.","Error publishing screen":"Error al publicar la pantalla","Error publishing screen. Please refresh and try again!":"Error al publicar la pantalla. Actualiza la página e inténtalo de nuevo.","Error unpublishing stream":"Error al cancelar la publicación de la transmisión","Error unpublishing stream. Please refresh and try again!":"Error al cancelar la publicación de la transmisión. Actualiza la página e inténtalo de nuevo.","Invalid Publish Operation":"Operación de publicación no válida","{username} profile picture":"Foto de perfil de {username}","Default":"Predeterminado","A-Z":"A-Z","Random":"Aleatorio","All":"Todo","Past":"Pasados","Upcoming":"Futuros","Learn More":"Más información","close":"cerrar","Discussion Rooms":"Salas de debate","ATTENDEE MODE":"MODO ASISTENTE","Loading...":"Cargando...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"El navegador ha deshabilitado el dispositivo o no tienes permiso para usarlo. Concédele permiso y haz clic en «Volver a intentarlo»","You are now registered. You will receive an email confirming details shortly.":"Ya te has registrado. En breve recibirás un correo electrónico con los detalles.","Streaming to Virtual Users from on-site video feed":"Transmitiendo a usuarios virtuales desde la señal de vídeo in situ","Ending in ":"Termina en ","GO LIVE":"AL DIRECTO","You have no past events.":"No tienes eventos pasados.","You have no upcoming or live events.":"No tiene eventos próximos o en vivo.","left":"izquierda","center":"centro","right":"derecha","top":"Arriba","bottom":"Abajo","loading...":"cargando...","Loading ...":"Cargando...","Failed to redirect!":"No se ha podido redirigir.","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"Parece que tienes un bloqueador de anuncios activado. Podría impedirte tener la mejor experiencia posible. Por favor, desactívalo. <br /><br /> Si necesitas ayuda para hacer esto, haz clic <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>aquí</a> para obtener más instrucciones.","redirecting in {duration}":"redirigiendo en {duration}","STOP VIDEO":"PARAR VÍDEO","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"Estás a punto de dejar de reproducir este vídeo. Tu emisión volverá a ser en vivo y tu público verá y escuchará a tus expositores. ¿Quieres seguir adelante?","STOP SHARING":"DEJAR DE COMPARTIR","No Next Slide":"No hay siguiente diapositiva","Next Slide":"Siguiente diapositiva","No Previous Slide":"No hay anterior diapositiva","Previous Slide":"Anterior diapositiva","something went wrong while recording the response please try again":"Se ha producido un error al grabar la respuesta, inténtalo de nuevo","Start In-Person Streaming":"Iniciar la transmisión en persona","Stop In-Person Streaming":"Detener la transmisión en persona","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Tu vídeo se está reproduciendo en búfer y la sesión de prueba comenzará en breve. Esto no sucederá durante la sesión real.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"El marcador aparecerá en la parte superior de la página web para todos los asistentes. Para convertir el teletipo en un hipervínculo, introduce la URL a continuación.","Allow {key}":"Permitir {key}","{messageType} can only be published from inside a broadcast.":"{messageType} solo se puede publicar desde una emisión.","To grant {deviceName} access to this page, follow the two steps below:":"Para conceder acceso a {deviceName} a esta página, sigue estos dos pasos:","2. Allow {deviceName} access and then refresh the page.":"2. Permite el acceso a {deviceName} y luego actualiza la página."}');

/***/ }),

/***/ 1822:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Liste déroulante des paramètres de l\'événement"," Stage Control":" Commandes de la scène","Stage Controls and Information":"Commandes et informations sur la scène","Live in ":"En direct dans ","Start Session":"Démarrer la session","End Session":"Terminer la session","Present Screen":"Présenter l\'écran","Rehearse On Stage":"Répéter sur scène","Turn on Microphone":"Activer le microphone","Turn off Microphone":"Désactiver le microphone","Turn on camera":"Allumer la caméra","Turn off camera":"Éteindre la caméra","rehearsal mode":"mode répétition","People Watching: ${watchCount}":"Spectateur·rice·s : ${watchCount}","Turn on Audio":"Activer le son","Turn off Audio":"Désactiver le son","Are you sure you want to leave this room?":"Voulez-vous vraiment quitter cette salle ?","you will be redirected to stage in":"vous allez être redirigé·e vers la scène dans","sec. . ":"sec. ","Skip to Main Navigation":"Accéder à la navigation principale","Skip to Chat":"Accéder au chat","Skip to Meeting Controls":"Accéder aux commandes de la réunion","LinkedIn":"LinkedIn","Live in":"En direct dans","UPCOMING":"À venir","Rehearse on stage":"Répéter sur scène","Watch Rehearsal":"Regarder la répétition","Answered by:":"Résolue par :","Speaker Off":"Haut-parleurs désactivés","Speaker On":"Haut-parleurs activés","Speaker Controls":"Commandes des haut-parleurs","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"Tous les éléments de scène se trouvent derrière l\'image partagée. Ils seront à nouveau visibles une fois que le partage d\'images en plein écran sera arrêté.","Close Ticker Popup":"Fermer la fenêtre du bandeau défilant","Open GIF Picker":"Ouvrir l\'outil de sélection de GIF","Open Emoji Picker":"Ouvrir l\'outil de sélection d\'émojis","Send Message":"Envoyer un message","Tabs: Messaging and More":"Onglets : Messagerie et plus","Thanks for attending!":"Merci pour votre participation !"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" Aucune session n\'est à venir pour le morceau auquel vous vous êtes abonné·e. Veuillez passer à d\'autres morceaux pour voir des sessions en direct.","Redirecting you to ":"Vous allez être redirigé·e vers ","in ":"dans ","seconds":"secondes","Main Navigation":"Navigation principale","YOU ARE HERE":"VOUS ÊTES ICI","Live Now":"En direct","SUBMIT":"ENVOYER","Allocated time for engagement has ended. You will be redirected to main stage":"Le temps imparti pour l\'interaction est terminé. Vous allez être redirigé·e vers la scène principale","Wrap up in":"Terminez dans","Session overrun by":"Dépassement du temps de la session de","Ending in":"Se termine dans","Bring this session live?":"Diffuser cette session en direct ?","START SESSION":"DÉMARRER LA SESSION","Bring this session to end?":"Mettre fin à cette session ?","END SESSION":"TERMINER LA SESSION","Go On Stage":"Monter sur scène","Muted by organizer":"Mis·e en sourdine par l\'hôte","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"L\'un des hôtes de l\'événement a coupé le son de votre appareil. Vous pouvez rétablir le son en cliquant sur le bouton du micro.","Gifs":"GIF","Stickers":"Autocollants","Launch Survey":"Lancer l\'enquête","Microphone is on":"Le microphone est activé","Microphone is off":"Le microphone est désactivé","Secret Code’s length should be 6 digits":"La longueur du code secret doit être de 6 chiffres","Closing in 00:":"Fermeture dans 00:","Submit":"ENVOYER","Questions":"Questions","Preview":"Aperçu","Close Survey":"Fermer l\'enquête","This is a required question":"Ceci est une question obligatoire","Enter the text you’d like to present on stage below.":"Ci-dessous, saisissez le texte que vous souhaitez présenter sur scène.","Use Chrome/Edge for best performance":"Utilisez Chrome/Edge pour des performances optimales","Do you want to launch your survey now?":"Voulez-vous lancer votre enquête maintenant ?","Success! Your Survey has been launched for attendees.":"Bravo ! Votre enquête a été lancée auprès des participants.","Unable to publish. Please try again.":"Échec de la publication. Veuillez réessayer.","Are you sure you want to close this survey?":"Voulez-vous vraiment fermer cette enquête ?","Success! Your Survey has been closed for attendees.":"Bravo ! Votre enquête a été fermée aux participants.","Unable to un-publish. Please try again.":"Impossible d\'annuler la publication. Veuillez réessayer.","Please answer all required questions.":"Veuillez répondre à toutes les questions obligatoires.","You have already submitted this survey.":"Vous avez déjà envoyé cette enquête.","Success! Thank you for your feedback.":"Bien reçu ! Merci pour votre retour.","Unable to submit. Please try again.":"Échec de l\'envoi. Veuillez réessayer.","Launch surveys will take over attendees\' engagement panel.":"Lorsque vous lancez des enquêtes, celles-ci occupent le panneau d\'interaction des participants.","Closing this survey will remove it from attendees\' engagement panel.":"La fermeture de cette enquête entraînera son retrait du panneau d\'interaction des participants.","Survey":"ENQUÊTE","Updating Survey...":"Mise à jour de l\'enquête...","Closing":"Fermeture","Goldcast needs access to your camera and microphone":"Goldcast a besoin d\'accéder à votre appareil photo et à votre microphone","Goldcast needs access to your microphone":"Goldcast a besoin d\'accéder à votre microphone","Goldcast needs access to your camera":"Goldcast a besoin d\'accéder à votre caméra","SPEAKERS":"Intervenant·e·s","Mark as Unanswered":"Marquer comme non résolue","Mark as Answered":"Marquer comme résolue","Remove from Priority":"Révoquer le statut prioritaire","Mark as Priority":"Marquer comme prioritaire","Answer":"RÉPONDRE","Enter answer...":"Saisissez votre réponse…","Answered by":"Résolue par","Submit Answer":"Envoyer la réponse","Test your system’s speaker":"Tester les haut-parleurs de l\'appareil","Click \\"Yes\\" if you hear the sound.":"Cliquez sur « Oui » si vous entendez le son.","Load previous":"Charger les éléments précédents","Hide Name":"Masquer le nom","Text Q&A is disabled in On Demand mode.":"Les questions et réponses textuelles sont désactivées en mode À la demande.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"Limite de questions et réponses textuelles atteinte. Les participant·e·s ne pourront pas poser de nouvelles questions.","Sent to Q&A":"Envoi en tant que Q&R","Couldn\'t post as Q&A. Please try again.":"Impossible de publier en tant que Q&R. Veuillez réessayer.","Yes this is being recorded":"Oui, c\'est enregistré","No this is not being recorded":"Non, ce n\'est pas enregistré","System\'s Speaker Check":"Vérification des haut-parleurs de l\'appareil","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"Assurez-vous du bon fonctionnement de vos haut-parleurs pour ne rien manquer de l\'événement","Click on “Test your system’s speaker” to proceed":"Cliquez sur « Tester les haut-parleurs de l\'appareil » pour continuer","Error while sharing message to screen. Post not found":"Une erreur s\'est produite lors du partage du message sur l\'écran. Message introuvable","Lost connection to servers. Refresh your page to get live event experience.":"Connexion aux serveurs perdue. Actualisez la page pour accéder à l\'événement en direct.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"Un VPN ou un pare-feu interfère avec votre authentification. Veuillez changer de réseau ou contacter votre équipe informatique pour autoriser <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>ces domaines</a> et accéder facilement à Goldcast.","It\'s taking too long":"Cela prend trop de temps","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"Il semble que vous utilisiez une connexion VPN ou que votre pare-feu soit activé. Veuillez consultez ce <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>document d\'aide</a> et mettre sur liste verte les domaines nécessaires au bon fonctionnement de Goldcast. Le cas échéant, changez de réseau.","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"Il semble que vous utilisiez une connexion VPN ou que votre pare-feu soit activé. Veuillez consultez ce <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>document d\'aide</a> et mettre sur liste verte les domaines nécessaires au bon fonctionnement de Goldcast. Le cas échéant, changez de réseau ou visionnez une session en mode Lite.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"Le service de streaming vidéo Goldcast ne parvient pas à se connecter en raison d\'une faible bande passante réseau. Pour vous connecter au service, veuillez changer de réseau.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"Le service de streaming vidéo Goldcast ne parvient pas à se connecter en raison d\'une faible bande passante réseau. Pour vous connecter au service, veuillez passer en mode Lite ou changer de réseau.","Most Upvotes":"Le plus d\'avis positifs","Most Recent":"Les plus récentes","My Questions":"Mes questions","Prioritized":"Prioritaire","Approved":"Approuvée","Unapproved":"Refusée","Unanswered":"Non résolue","Failed to update answer. Please try again!":"Impossible de mettre à jour la réponse. Veuillez réessayer.","Failed to post answer. Please try again!":"Impossible de publier la réponse. Veuillez réessayer.","Failed to delete question. Please try again!":"Impossible de supprimer la question. Veuillez réessayer.","Survey Link":"Lien vers l\'enquête","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"Lors du changement, la page en cours sera rechargée et affichera la vue du public. Pour revenir à celle du comité d\'organisation, désactivez la vue du public dans le menu déroulant du profil.","You haven\'t asked any questions yet":"Vous n\'avez pas encore posé de question","No prioritized questions":"Pas de question prioritaire","Create prioritized list of questions for speakers by marking questions as priority":"Créez une liste de questions prioritaires pour les intervenant·e·s en marquant les questions comme prioritaires","No Approved Questions":"Aucune question approuvée","Approve incoming questions to see list of approved questions":"Approuver les nouvelles questions génère une liste de questions approuvées","No Unapproved Questions":"Aucune question refusée","No Answered Questions":"Aucune question résolue","Answer a question on stage or with inline text":"Répondez à une question sur scène ou saisissez votre réponse","All questions are answered":"Toutes les questions ont été résolues","Rate Your Experience":"Évaluez votre expérience","How satisfied are you with Goldcast?":"De manière générale, êtes-vous satisfait·e de votre expérience sur Goldcast ?","What are the main reasons for your rating?":"Quelles sont les principales raisons motivant votre évaluation ?","I am interested in seeing a demo of Goldcast":"Je souhaite profiter d\'une démonstration de Goldcast","Thank You":"Merci","Your feedback was successfully submitted.":"Vos commentaires ont bien été envoyés.","Tell us how we can improve...":"Dites-nous comment nous pouvons nous améliorer…","1 Slide":"1 diapositive","Your internet connection is unstable.":"Votre connexion internet est instable.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"Votre micro semble coupé. Pour le réactiver, cliquez sur l\'icône Micro.","The registration could not be completed! Please check that this email is allowed to register for the event.":"L\'inscription n\'a pas pu être effectuée ! Veuillez vérifier que cette adresse e-mail est autorisée pour l\'inscription à l\'événement.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Il semblerait que vous soyez déjà inscrit·e à cet événement ! Si vous n\'avez pas reçu l\'e-mail de confirmation, veuillez vérifier votre dossier Spam. Si vous avez besoin d\'aide supplémentaire, veuillez contacter le comité d\'organisation de l\'événement.","Your registration could not be completed. This event has reached its registration capacity.":"Votre inscription n\'a pas pu être effectuée. Cet événement ne peut plus accepter de participant·e·s.","Image cannot be an svg":"L\'image ne peut pas être au format svg","This should be a valid linkedin url":"Ceci doit être une URL LinkedIn valide","This should be a valid twitter url":"Ceci doit être une URL Twitter valide","This should be a valid url":"Ceci doit être une URL valide","Video":"vidéo","Read Less":"Lire moins","live":"EN DIRECT","Opened":"Ouverte","In person only":"En personne uniquement","Stage Stream":"Flux de la scène","Streaming not available":"Diffusion non disponible","Close TV":"Fermer la TV","Streaming is not available for prerecorded and RTMP sessions":"La diffusion n\'est pas disponible pour les sessions préenregistrées et RTMP","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Connectez votre ordinateur à un écran de télévision ou à un projecteur pour permettre à votre public physique d\'observer ce qu\'il se passe sur votre scène virtuelle, comme les diapositives, les questions-réponses, etc. Une fois la connexion établie, cliquez sur OUVRIR LA TV et faites glisser ou partagez la nouvelle fenêtre sur votre écran de télévision ou votre projecteur. ","Close Setup Mode":"Fermer le mode Configuration","Help":"Aide","upcoming":"À venir","ended":"Terminé","Remove from favorites":"Supprimer des favoris","Add to favorites":"Ajouter aux favoris","PLAY RECORDING":"Lire l\'enregistrement","VIEW RECORDING":"AFFICHER L\'ENREGISTREMENT","VIEW RECORDINGS":"AFFICHER LES ENREGISTREMENTS","Virtual Backgrounds":"Arrière-plans virtuels","No Device Available":"Aucun appareil disponible","Needs permission":"Nécessite une autorisation","Device not detected":"Appareil non détecté","Camera is on":"La caméra est allumée","Camera is off":"La caméra est éteinte","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"La mise en miroir d\'une vidéo n\'affecte pas l\'expérience des spectateur·rice·s, qui verront toujours votre vidéo normalement.","Mirror My Video":"Mettre en miroir ma vidéo","Camera":"CAMÉRA","1. Click on Safari > Settings for this\\n            website":"1. Cliquez sur Safari > Réglages pour ce site Web","1. Click the lock":"1. Cliquez sur l\'icône en forme","icon in your browser’s address bar":"de cadenas dans la barre d\'adresse du navigateur","3. Unmute":"3. Réactivez le son","and":"et","icons from stage control panel":"icônes du panneau de commande de la scène","icon from stage control panel":"icône du panneau de commande de la scène","2. Set camera and microphone to “Allow”.":"2. Réglez la caméra et le microphone sur « Autoriser ».","2. Set camera to “Allow”.":"2. Réglez la caméra sur « Autoriser ».","2. Set microphone to \\"Allow\\"":"2. Réglez le microphone sur « Autoriser »","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. Choisissez « Toujours autoriser Goldcast à accéder à votre caméra et à votre microphone »","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. Choisissez « Toujours autoriser Goldcast à accéder à votre caméra ».","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. Choisissez « Toujours autoriser Goldcast à accéder à votre microphone »","Questions?":"Des questions ?","If you’re having issues, check out our comprehensive":"Si vous rencontrez des problèmes, consultez notre","help docs":"documentation d\'aide","Speaker is on":"Le haut-parleur est allumé","Stop Test":"Arrêter le test","Test your system’s audio":"Testez l\'audio de votre appareil","Still can\'t hear any sound?":"Vous n\'entendez toujours aucun son ?","Microphone":"MICROPHONE","Audio is being played in system\'s default audio device.":"Un son est joué sur le périphérique audio par défaut du système.","Click to view/change audio device":"Cliquez pour afficher/changer le périphérique audio","Speaker":"HAUT-PARLEUR","Play Recording":"Lire l\'enregistrement","Recording for this broadcast is currently being processed and will be available soon":"L\'enregistrement de cette diffusion est en cours de traitement et sera bientôt disponible","You haven\'t favorited anything yet!":"Vous n\'avez encore rien ajouté à vos favoris !","Add an item to favorites by selecting the ♡ in the top right corner.":"Ajoutez un article à vos favoris en sélectionnant le ♡ dans le coin supérieur droit.","Session has ended":"La session a pris fin","System Check":"Vérification du système","Need help? Check out the":"Besoin d\'aide ? Consultez","Skip Checks and Continue":"Ignorer les vérifications et continuer","Click the button above to run the test":"Cliquez sur le bouton ci-dessus pour exécuter le test","Test Screenshare":"Test du partage d\'écran","Share message to stage":"Partager le message sur la scène","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"Saisissez le texte que vous souhaitez utiliser pour le bandeau défilant ci-dessous. Pour transformer le bandeau défilant en hyperlien, saisissez une URL.","Ticker":"Bandeau défilant","Coffee Break! Be back in 10m.":"Pause café ! De retour dans 10 min.","Enter Message":"Saisissez votre message","https://www.xyz.com":"https://www.xyz.com","Launch":"Lancement","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Merci d\'avoir soumis vos questions. Vous pourrez en soumettre une autre une fois que l\'une d\'elles aura été approuvée.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"L\'assurance qualité est désactivée pour le moment. Vous pourrez soumettre une question dès que la fonctionnalité sera de nouveau activée.","Votes":"Votes","Vote":"Voter","is inviting you to a video call":"vous invite à un appel vidéo","ENTER ROOM":"ENTRER DANS LA SALLE","Start the conversation!":"Démarrez la conversation !","Couldn\'t send message. Click here to retry.":"Impossible d\'envoyer le message. Cliquez ici pour réessayer.","Couldn\'t add emoji. Please try again.":"Impossible d\'ajouter un émoji. Veuillez réessayer.","Couldn\'t remove emoji. Please try again.":"Impossible de supprimer l\'émoji. Veuillez réessayer.","Couldn\'t delete message. Please try again.":"Impossible de supprimer le message. Veuillez réessayer.","Couldn\'t pin message. Please try again.":"Impossible d\'épingler le message. Veuillez réessayer.","Couldn\'t unpin message. Please try again.":"Impossible de désépingler le message. Veuillez réessayer.","Today":"Aujourd\'hui","No messages yet":"Aucun message pour le moment","Messages from organizers and speakers appear here!":"Les messages du comité d\'organisation et des intervenants apparaissent ici !","Next Session is Starting":"La prochaine session commence","Go to Next Session":"Aller à la prochaine session","I’d like to stay":"Je voudrais rester","My favorites":"Mes favoris","1. Click on the lock icon in your address bar":"1. Cliquez sur l\'icône en forme de cadenas dans la barre d\'adresse","We recommend organizers and speakers use a desktop\\n        device":"Nous recommandons au comité d\'organisation et aux intervenant·e·s d\'utiliser un ordinateur","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"Pour offre la meilleure expérience possible aux participant·e·s, aux intervenant·e·s et au comité d\'organisation, il vous faut utiliser Goldcast depuis un ordinateur. La diffusion à partir d\'un appareil mobile peut altérer l\'expérience.","Watch Now":"Regarder maintenant","Video progress time":"Durée de progression de la vidéo","Total video duration":"Durée totale de la vidéo","Rate Goldcast!":"Évaluez Goldcast !","Running Required Checks...":"Exécution des vérifications requises…","Test Your Setup":"Testez votre configuration","Test your Computer Device, Microphone and Camera before you join the event":"Testez votre ordinateur, votre microphone et votre caméra avant de participer à l\'événement","Speaker and microphone not working?":"Le haut-parleur et le microphone ne fonctionnent pas ?","Passed":"Réussite","Fix Audio Issues":"Résoudre les problèmes audio","Check if audio is being played in other sound devices connected to phone/tablet":"Vérifiez si le son est diffusé par d\'autres périphériques audio connectés au téléphone/à la tablette","Check if correct audio device is chosen from the below dropdown":"Vérifiez si le bon périphérique audio est sélectionné dans le menu déroulant ci-dessous","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>Cliquez ici</a> pour vérifier si le bon périphérique audio est sélectionné","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Cliquez ici</a> pour vérifier si le bon périphérique audio est sélectionné","Right click on the browser tab & click “Unmute Site”":"Faites un clic droit sur l\'onglet du navigateur et cliquez sur « Réactiver le son du site »","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Vérifiez si le son a été réactivé dans l\'onglet du navigateur ou cliquez sur Fenêtre > Réactiver le son de cet onglet","System Check Failed!":"Échec de la vérification du système !","System Check Passed!":"Vérification du système réussie !","Complete checks to proceed":"Terminer les vérifications pour continuer","Enter Event":"REJOINDRE L\'ÉVÉNEMENT","Skip Screen Sharing Check? ":"Ignorer la vérification du partage d\'écran ? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"Nous vous recommandons de finaliser la vérification du partage d\'écran si votre écran doit être présenté lors de l\'événement","Ignore & Enter Event":"Ignorer et rejoindre l\'événement","Test screenshare":"Test du partage d\'écran","Retry Now":"Réessayer","SHARE":"Partager","Rooms Closed":"Salles fermées","Discussion rooms are now closed. You are being redirected to the Stage.":"Les salles de discussion sont maintenant fermées. Nous vous redirigeons vers la scène.","Return To Stage":"RETOUR À LA SCÈNE","Unrecognized embedded widget provider - ":"Fournisseur de widgets intégrés non reconnu – ","Room Ended":"Salle fermée","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"L\'hôte de votre événement a fermé toutes les salles. Nous allons maintenant vous rediriger vers la scène de l\'événement.","Video Q&A Request Cancelled":"Demande de Q&R vidéo annulée","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Votre demande de questions et réponses vidéo a été annulée puisque vous la visionnez en mode Lite. Passez au mode Direct pour lever à nouveau la main.","Camera Passed":"Caméra – Réussite","Camera Error":"Caméra – Erreur","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"Les autorisations de caméra ne sont pas accordées depuis le navigateur. Cliquez sur « Autoriser la caméra ».","Camera permissions aren’t granted from system. Click “Allow Camera”":"Les autorisations de caméra ne sont pas accordées depuis l\'appareil. Cliquez sur « Autoriser la caméra »","Uh-oh! Error occurred while creating camera stream":"Oups ! Une erreur s\'est produite lors de la création du flux de caméra","Close other applications which might use camera stream":"Fermez toute autre application qui pourrait utiliser le flux de caméra","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>Cliquez ici</a> pour vérifier si le navigateur a accès à la caméra","Microphone Passed":"Microphone – Réussite","Microphone Error":"Microphone – Erreur","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"Les autorisations de micro ne sont pas accordées depuis le navigateur. Cliquez sur « Autoriser le microphone »","Mic permissions aren’t granted from system. Click “Allow Microphone”":"Les autorisations de micro ne sont pas accordées depuis l\'appareil. Cliquez sur « Autoriser le microphone »","Uh-oh! Error occurred while creating mic stream":"Oups ! Une erreur s\'est produite lors de la création du flux de microphone","Close other applications which might use mic stream":"Fermez toute autre application qui pourrait utiliser le flux de micro","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>Cliquez ici</a> pour vérifier si le navigateur a accès au micro","Speaker and Microphone Error":"Erreur de haut-parleur et de microphone","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"Les autorisations de micro sont requises pour afficher la liste des haut-parleurs connectés à l\'appareil. Cliquez sur « Autoriser le microphone »","It seems mic is being used by other application. Close other applications to proceed.":"Il semble que le micro soit utilisé par une autre application. Fermez ces applications pour continuer.","Camera & Microphone Error":"Erreur de caméra et de microphone","To enable permissions, click the Allow Camera & Mic button below":"Pour activer les autorisations, cliquez sur le bouton « Autoriser la caméra et le micro » ci-dessous","Network Connection":"Connexion réseau","Check Passed":"Vérification réussie","Could not establish a network connection":"Impossible d\'établir une connexion réseau","Connect to a different network, or use a mobile hotspot.":"Connectez-vous à un autre réseau ou utilisez un hotspot mobile.","Disable any VPN or firewall is connected.":"Désactivez tout VPN ou pare-feu connecté.","Connection: Good":"Connexion : bonne","Network Connection Error":"Erreur de connexion réseau","Can’t connect to network. Change your network or limited functionality will be available during event.":"Impossible de se connecter au réseau. Changez de réseau ou la diffusion de l\'événement sera limitée.","AdBlocker":"AdBlocker","AdBlocker not detected.":"AdBlocker non détecté.","AdBlocker detected. This may degrade your event experience.":"AdBlocker détecté. Cela peut dégrader votre expérience lors des événements.","Disable adblocker for best experience.":"Désactivez le bloqueur de publicités pour une meilleure expérience.","You are using ":"Vous utilisez ","Use Windows or Mac OS for best performance":"Utilisez Windows ou Mac OS pour des performances optimales","Browser Check":"Vérification du navigateur","Check Passed.":"Vérification réussie.","Switch To Lite Mode":"Activer le mode Lite","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Votre demande de questions et réponses vidéo en attente sera annulée dès que vous passerez en mode Lite","Stay on Live Mode":"Rester en mode Direct","Unable to mark as favorite":"Impossible de marquer comme favori","Event organizers must enter the event to select favorites.":"Les hôtes d\'événements doivent rejoindre l\'événement pour sélectionner les favoris.","Make an Announcement":"Faire une annonce","STOP":"ARRÊTER","InPerson CheckIn App":"Application d\'enregistrement du public en personne","App to Check-In In-Person attendees":"Application pour enregistrer le public en personne","SEE AGENDA":"Voir l\'ordre du jour","Please visit the Agenda tab to view the session recordings":"Veuillez vous rendre sur l\'onglet Ordre du jour pour voir les enregistrements de la session","The session recordings will be available soon in the Agenda tab":"Les enregistrements de la session seront bientôt disponibles dans l\'onglet Ordre du jour","FAILED!":"ÉCHEC !","Next session is beginning":"La prochaine session commence","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"Voulez-vous passer à la prochaine session ? Votre flux se poursuivra et votre TV diffusera la nouvelle session.","Banners":"Bannières","Images":"Images","Screen Share":"Partage d\'écran","Browser might not have screen-recording permission on your computer.":"Il se peut que le navigateur de votre ordinateur ne soit pas autorisé à enregistrer l\'écran.","Open System Preferences":"Ouvrir les préférences système","Error publishing screen because someone else started screen share already.":"Erreur lors de la publication de l\'écran, car quelqu\'un d\'autre a déjà commencé le partage d\'écran.","Live Feed":"Flux en direct","Check Your Network":"Vérifier votre réseau","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"Nous avons détecté une erreur lors de la lecture de la vidéo ! Si vous n\'arrivez pas à lire la vidéo, essayez d\'actualiser la page ou de passer en mode Lite.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"Nous avons détecté une erreur lors de la lecture de la vidéo ! Si vous n\'arrivez pas à lire la vidéo, essayez d\'actualiser la page.","All Dates":"Toutes les dates","All Tracks":"Tous les morceaux","Create Ticker":"Créer un bandeau défilant","Booths Closed":"Stands fermés","Your event organizer has closed all the booths. You will now be redirected to the stage":"L\'hôte de votre événement a fermé tous les stands. Nous allons maintenant vous rediriger vers la scène.","Visit the Polls tab to view live results.":"Accédez à l\'onglet « Sondages » pour voir les résultats en direct.","A new poll is open! Visit the Polls tab to vote.":"Un nouveau sondage est ouvert ! Rendez-vous sur l\'onglet Sondages pour voter.","Vote for Polls":"Répondre aux sondages","Go to Polls Tab":"Accéder à l\'onglet Sondages","Microphone audio too low":"Audio du microphone trop faible","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"Nous avons détecté un problème avec votre audio. Nous vous recommandons d\'essayer de désactiver puis réactiver le son ou d\'utiliser un autre périphérique si le problème persiste.","Audio/Video bitrate too low":"Débit audio/vidéo trop faible","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"Les paramètres de votre pare-feu réseau bloquent les flux A/V. Nous vous recommandons de changer de connexion réseau.","Error sharing screen":"Erreur de partage de l\'écran","A network error occurred while sharing screen. Please check your network connection.":"Une erreur réseau s\'est produite lors du partage de l\'écran. Veuillez vérifier votre connexion réseau.","Apologies, due to some errors, we need to refresh the page!":"Désolé, nous devons actualiser la page en raison d\'erreurs !","Warning":"Avertissement","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"Nous avons détecté un problème avec votre vidéo. Nous vous recommandons d\'essayer de fermer les autres onglets du navigateur ou les autres applications en cours d\'exécution sur votre appareil et de vérifier/d\'améliorer votre connexion internet afin de résoudre ce problème.","No results found":"Aucun résultat trouvé","Audio":"audio","Please choose another microphone and camera":"Veuillez choisir un autre microphone et une autre caméra","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"Le micro et la caméra actuellement sélectionnés ne fonctionnent pas. Veuillez en choisir d\'autres dans les menus déroulants ci-dessous.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"La caméra actuellement sélectionnée ne fonctionne pas. Veuillez choisir une autre caméra dans le menu déroulant ci-dessous.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"Vous pouvez continuer sans caméra, mais nous vous recommandons de résoudre le conflit afin d\'assurer le bon déroulement de la diffusion","Please choose another microphone":"Veuillez choisir un autre microphone","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"Le micro actuellement sélectionné ne fonctionne pas. Veuillez en choisir un autre dans le menu déroulant ci-dessous.","Please check that your TV speaker is correct":"Veuillez vérifier que le haut-parleur de votre téléviseur fonctionnement correctement","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"Le haut-parleur actuellement sélectionné ne fonctionne pas. Veuillez en choisir un autre dans le menu déroulant ci-dessous.","Your answer":"Votre réponse","Edit":"Modifier","Delete":"Supprimer","Settings":"Paramètres","Signing Out":"Déconnexion","Confirming your account...":"Confirmation de votre compte…","Something Went Wrong. Please Retry :(":"Une erreur s\'est produite. Veuillez réessayer :(","Resending Mail":"Renvoi de l\'e-mail","offline":"hors ligne","I am inviting you to a video meeting:":"Je vous invite à une réunion vidéo :","Resending secure login link to your email":"Renvoi du lien de connexion sécurisé à votre adresse e-mail","Sending secure login link to your email":"Envoi du lien de connexion sécurisé à votre adresse e-mail","Something went Wrong. Please Retry :(":"Une erreur s\'est produite. Veuillez réessayer :(","Updating your password":"Mise à jour de votre mot de passe","Sending mail":"Envoi de l\'e-mail","Verifying":"Vérification","This might be slower than usual":"Cela peut prendre plus de temps que d\'habitude","Checking":"Vérification","New results available! Refresh!":"Nouveaux résultats disponibles ! Actualisez !","Saving":"Enregistrement","Turn off Attendee mode":"Désactiver le mode Audience","See Attendee View":"Afficher la vue du public","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Nombre total de participant·e·s qui regardent actuellement cette session. Remarque : ceci est visible uniquement par le comité d\'organisation","Session Count":"Nombre de sessions","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"Le nombre de participant·e·s qui consultent actuellement des sessions en direct. Remarque : ceci est visible uniquement par le comité d\'organisation","Role":"Rôle","Total Attendees":"Nombre total de participant·e·s","Total number of attendees online at this time Note: This is for organizer eyes only":"Nombre total de participant·e·s en ligne à l\'heure actuelle. Remarque : ceci est visible uniquement par le comité d\'organisation","My Profile":"Mon profil","Languages":"Langues","Filling out your profile can help you connect with people with similar interests.":"Le fait de remplir votre profil peut vous permettre d\'entrer en contact avec des personnes ayant des intérêts similaires.","type to search for your address":"saisissez quelque chose pour rechercher votre adresse","Could not open direct call":"Impossible d\'ouvrir l\'appel direct","Chat messages can only be published from inside a broadcast.":"Les messages instantanés peuvent être publiés uniquement lors d\'une diffusion.","Stage Logo can only be published from inside a broadcast.":"Les logos de scène peuvent être publiés uniquement lors d\'une diffusion.","Loading Speakers":"Chargement des intervenant·e·s","Raise hand is disabled for organizer accounts, but active for attendee accounts":"Le comité d\'organisation ne peut pas lever la main, mais le public oui","Disabled in lite mode, return to live if you’d like to raise hand!":"Désactivé en mode Lite, revenez au direct si vous souhaitez lever la main !","Raise hand to enter stage for video q&a":"Levez la main pour monter sur scène et poser une question en vidéo","Speakers":"Intervenant·e·s","Hosting organization: {organization}":"Entreprise organisatrice : {organization}","Failed to switch {deviceTag}":"Échec du changement de {deviceTag}","Make sure your {deviceTag} is not being used by any other application and is working properly.":"Vérifiez que votre {deviceTag} n\'est pas utilisé par une autre application et qu\'il fonctionne correctement.","Facing issues with audio or video? Switch on lite mode":"Vous rencontrez des problèmes audio ou vidéo ? Activez le mode Lite","Failed to get event for eventID: {eventID}":"Impossible d\'obtenir l\'événement pour l\'ID : {eventID}","Error while playing video.":"Erreur lors de la lecture de la vidéo.","Speakers only, attendees can\'t see this chat":"Intervenant·e·s uniquement ; les participant·e·s ne peuvent pas voir ce chat","Kudo":"Kudo","Room":"Salle","Session":"Session","Booth":"Stand","Public":"Public","Drift":"Drift","Slides":"Diapositives","Videos":"Vidéos","Chat":"Chat","Messages":"Messages","Poll":"Sondage","Docs":"Documents","Q&A":"Questions","Media":"Médias","Messages Chat":"Messages Chat","Leaderboard":"Classement","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Remarque : vous êtes également intervenant·e pour cet événement. Vous pourrez toujours accéder aux coulisses et monter sur scène.","Switch to Attendee View":"Passer à la vue du public","Return to Organizer View":"Retourner à la vue du comité d\'organisation","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"Le fait de désactiver la vue du public rechargera la page en cours et vous ramènera à la vue du comité d\'organisation. Voulez-vous continuer ?","Switch":"CHANGER","Request Sent":"Demande envoyée","Your request for a demo has been submitted":"Votre demande de démo a été envoyée","Organizer Redirection":"Redirection de l\'hôte","YES, REDIRECT":"OUI, REDIRIGER","DISMISS":"IGNORER","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"Nous redirigeons les participant·e·s vers la prochaine session : {title}. Voulez-vous également être redirigé·e vers la prochaine session ?","Stage":"Scène","Rooms":"Salles","Join a round table to discuss moderated topics with your fellow attendees":"Rejoignez une table ronde pour discuter de sujets encadrés avec le reste du public","Booths":"Stands","Join a booth to know more about a sponsor":"Rejoignez un stand pour en savoir plus sur un sponsor","You are in the booth":"Vous êtes sur le stand","People":"Personnes","Connect with your fellow attendees":"Contactez les autres participant·e·s","Connect with speakers":"Contactez les intervenant·e·s","starting in {duration}":"démarre dans {duration}","You will be redirected to booths in {duration}":"Vous allez être redirigé·e vers les stands dans {duration}","booths":"Stands","agenda":"Ordre du jour","You will be redirected to {word} in {duration}":"Vous allez être redirigé·e vers la session {word} dans {duration}","You will be redirected to the live stage in {duration}":"Vous allez être redirigé·e vers la scène dans {duration}","- You are about to be redirected to {tabTitle} in {duration}":"– Vous serez redirigé·e vers {tabTitle} dans {duration}","See Agenda":"Voir l\'ordre du jour","Break":"PAUSE","{title} is now live":"{title} est maintenant en direct","Apologies, due to an error we need to refresh the page!":"Désolé, nous devons actualiser la page en raison d\'une erreur !","Network interruption detected":"Interruption réseau détectée","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"Votre connexion internet rencontre des difficultés. Si vous utilisez un VPN, essayez de le désactiver. Sinon, essayez de vous connecter à un autre réseau","No audio output device detected":"Aucun périphérique de sortie audio détecté","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Veuillez connecter vos enceintes/écouteurs et utiliser l\'icône en forme d\'engrenage pour les tester si vous rencontrez des difficultés.","Please disable ad blocker for this page":"Veuillez désactiver le bloqueur de publicités pour cette page","Yes, I understand":"Oui, je comprends","No event user found so attended not marked!":"Aucun participant à l\'événement n\'a été trouvé. Personne n\'a donc été marqué.","Wait while the speaker approves your video q&a request":"Attendez que l\'intervenant·e approuve votre question vidéo","Organizer":"Hôte","UPNEXT":"à suivre","Ended":"Terminé","Hide":"Masquer","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"Cette page vous redirigera automatiquement dans {durationLeftToRedirect} secondes.","Register":"S\'inscrire","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Erreur : impossible d\'inscrire la personne à cet événement. Veuillez contacter le comité d\'organisation de l\'événement pour obtenir de l\'aide","You are already registered!":"Vous êtes déjà inscrit·e !","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Il semblerait que vous soyez déjà inscrit·e à cet événement ! Si vous n\'avez pas reçu l\'e-mail de confirmation, veuillez vérifier votre dossier Spam. Si vous avez besoin d\'aide supplémentaire, veuillez contacter le comité d\'organisation de l\'événement","Thank you for registering!":"Merci pour votre inscription !","Submit another response":"Envoyer une autre réponse","Share":"Partager","Know someone who want to attend this?":"Vous connaissez une personne qui aimerait y assister ?","COPY LINK":"COPIER LE LIEN","Powered by":"Proposé par","VIEW PROFILE":"AFFICHER LE PROFIL","You can access the event landing here":"La page de l\'événement est accessible ici","Need Help?":"Besoin d\'aide ?","Welcome back":"Fantastique, vous revoilà !","Checking...":"Vérification...","Close":"Fermer","Enter":"Entrer","See {roomCount} Room(s)":"Voir {roomCount} salle(s)","Back":"Retour","Request a Demo":"Demander une démo","Loading":"chargement","Thread":"Fil de discussion","Load more":"Charger plus","Heads up!":"Attention !","YES":"OUI","No":"Non","Following":"Abonné·e","Error in loading drimify":"Erreur lors du chargement de drimify","You\'re not registered for this event":"Vous n\'êtes pas inscrit·e à cet événement","Check out other events":"DÉCOUVREZ D\'AUTRES ÉVÉNEMENTS","Date":"Date","Location":"Ville","How are you attending the event":"Comment participez-vous à l\'événement","In Person":"En personne","Virtually":"Virtuellement","Event Widgets":"Widgets d\'événements","Chat • Messages • Q&A • Poll • Docs":"Chat • Messages • Q&R • Sondage • Documents","DISCUSSION":"DISCUSSION","JOIN":"REJOINDRE","WAIT":"ATTENDRE","more":"plus","See Profile":"Voir le profil","Filter":"Filtrer","Video player not supported by your browser":"Lecteur vidéo non pris en charge par votre navigateur","We recommend using the latest version of Google Chrome to access your conference":"Nous vous recommandons d\'utiliser la dernière version de Google Chrome pour accéder à votre conférence","ANSWER":"RÉPONDRE","REJECT":"REFUSER","Don’t ask me this next time":"Ne plus me demander","Cancel":"Annuler","Lite Mode":"Mode Lite","On":"Activer","Connection Issues? Turn on Lite Mode":"Problèmes de connexion ? Activez le mode Lite","Turn On Lite Mode":"Activer le mode Lite","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"Le mode Lite entraîne un décalage de 30 secondes entre le direct et ce que vous voyez sur votre écran. Voulez-vous continuer ?","Turn On":"Activer","Lite Mode Active!":"Mode Lite activé !","Thanks for your patience, lite mode now on!":"Merci pour votre patience, le mode Lite est maintenant activé !","Turn off Lite Mode?":"Désactiver le mode Lite ?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Désactivez le mode Lite pour revenir au direct. Sachez que cela provoquera un saut de 30 s pour rattraper le retard.","Lite Mode Off!":"Mode Lite désactivé !","Thanks for your patience, we’ve returned to the live broadcast!":"Merci de votre patience, nous voilà de retour au direct !","Lite Mode Unavailable":"Mode Lite non disponible","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Désolé pour le désagrément : le mode Lite n\'est pas disponible pour le moment, veuillez passer au direct pour poursuivre votre session.","Turn off Lite mode?":"Désactiver le mode Lite ?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"Nous avons remarqué que votre connexion est revenue à la normale. Voulez-vous revenir au direct ? Sachez que cela provoquera un saut de 30 s pour rattraper le retard.","Turn Off":"Désactiver","Lite mode is disabled for organizer accounts, but active for attendee accounts":"Le comité d\'organisation ne peut pas activer le mode Lite, mais le public oui","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"Le mode Lite n\'est pas pris en charge par votre navigateur. Nous vous recommandons d\'utiliser la dernière version de Google Chrome.","Lite mode is not curently available. We’ll let you know once it’s available again":"Le mode Lite n\'est pas disponible pour le moment. Nous vous informerons dès qu\'il sera à nouveau opérationnel","Turn off Lite Mode":"Désactiver le mode Lite","We’ll let you know when Lite mode is available again":"Nous vous informerons dès que le mode Lite sera à nouveau disponible","Lite Mode Available":"Mode Lite disponible","Loading Lite Mode...":"Chargement du mode Lite…","Turning Off Lite Mode":"Désactivation du mode Lite","Lite Mode On":"Mode Lite activé","Audio/Video Issues?":"Problèmes audio/vidéo ?","Error":"Erreur","Click a video to play":"Cliquez sur une vidéo pour la lire","Error starting video!":"Erreur lors du démarrage de la vidéo !","Please rotate your device to {mode} mode":"Veuillez faire pivoter votre appareil en mode {mode}","landscape":"paysage","portrait":"portrait","Thank you for attending this event!":"Merci pour votre participation à cet événement !","Go to Rooms":"Accéder aux salles","Please use a desktop or laptop Google Chrome browser to access your conference":"Veuillez utiliser un navigateur Google Chrome sur ordinateur pour accéder à votre conférence","If on Desktop":"Sur ordinateur","Please increase the width of your window":"Veuillez augmenter la largeur de votre fenêtre","Alternatively, check out the":"Vous pouvez également consulter les","Youtube Livestream":"Diffusion en direct sur YouTube","Search":"Recherche","Profile":"Profil","Yes":"Oui","Loading Chat":"Chargement du chat","Please wait while we fetch the chat":"Veuillez patienter pendant que nous récupérons le chat","Load old messages":"Charger les anciens messages","Join the room to see chat":"Rejoindre la salle pour voir le chat","Live Chat":"Chat en direct","Uh..oh we couldn\'t load the content":"Zut… le contenu n\'a pas pu être chargé","Please reload the page":"Veuillez recharger la page","New comments":"Nouveaux commentaires","Start the conversation":"Démarrez la conversation","Be the first to add to chat!":"Dites quelque chose en premier sur le chat !","Enter your message":"Saisissez votre message","Joining chat!":"Connexion au chat !","See all pinned messages":"Voir tous les messages épinglés","Failed to send! Retry?":"L\'envoi a échoué ! Réessayer ?","Search for attendee":"Rechercher des participant·e·s","Up to date":"Pas de nouveaux messages","Start a new conversation, We think you\'ll enjoy":"Démarrez une nouvelle conversation. Pourquoi ne pas","chatting with these recommended attendees!":"échanger avec ces personnes recommandées ?","Searching":"Recherche","Load Previous":"Charger les éléments précédents","Load Next":"Charger les éléments suivants","Loading Channel":"Chargement de la chaîne","Please wait while we fetch the channel":"Veuillez patienter pendant que nous récupérons la chaîne","Please wait while we fetch the messages":"Veuillez patienter pendant que nous récupérons les messages","Send the first message":"Envoyez le premier message","Join":"Rejoindre","link":"lien","download":"télécharger","Click to open":"Cliquer pour ouvrir","No open polls":"Pas de sondage ouvert","Check back later to see if a poll opens up!":"Revenez plus tard pour voir si un sondage est ouvert !","Loading Poll":"Chargement du sondage","Please wait while we fetch the polls":"Veuillez patienter pendant que nous récupérons les sondages","Uh oh.. we couldn’t load the content":"Zut… le contenu n\'a pas pu être chargé","Polls":"Sondages","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"Pour lancer un sondage, ajoutez la question et les réponses à cette session dans le panneau d\'administration Goldcast","Stop Sharing":"Arrêter le partage","Can\'t publish polls while something else is being presented on stage":"Impossible de publier un sondage alors que la scène est déjà occupée","Open":"Ouvrir","Cancel your video q&a request":"Annuler votre question vidéo","Pending...":"En attente...","Leave Stage":"Quitter la scène","Raise Hand":"Lever la main","Text Q&A":"Q&R textuel","Video Q&A":"Q&R vidéo","Loading Q&amp;A":"Chargement des questions","Please wait while we fetch the Q&amp;A":"Veuillez patienter pendant que nous récupérons les questions","Uh oh.. we couldn\'t load the content":"Zut… le contenu n\'a pas pu être chargé","No Questions Yet":"Aucune question pour le moment","Tell your audience to send in questions!":"Dites à votre public d\'envoyer des questions !","Be the first to ask a question!":"Posez une question en premier !","Tell your audience to raise their hand!":"Dites à votre public de lever la main !","Approve":"Approuver","Reject":"Refuser","End":"Terminer","RELOAD":"RECHARGER","Logos On Stage":"Logos sur scène","No File Chosen":"Aucun fichier choisi","loading":"chargement","Can\'t publish a slide when there is something else being presented on stage":"Impossible de publier une diapositive alors que la scène est déjà occupée","Change Deck":"Changer le diaporama","stop-screen-share":"arrêt du partage d\'écran","screen-share":"partage d\'écran","Select a deck to begin presenting":"Sélectionnez un diaporama pour commencer votre présentation","CONFIRM":"CONFIRMER","If you’re having issues, please refer to the":"Si vous rencontrez des problèmes, veuillez consulter","SPEAKER":"HAUT-PARLEUR","Issue Testing Audio!":"Problème lors du test audio !","VPN and adblockers may cause video issues, please disable them before proceeding":"Les VPN et les bloqueurs de publicité peuvent entraîner des problèmes de vidéo ; veuillez les désactiver avant de poursuivre","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"Veuillez noter que les VPN et les bloqueurs de publicité peuvent entraîner des problèmes de vidéo. Veillez donc à les désactiver au cours de la diffusion.","Follow":"S\'abonner","Read More":"En savoir plus","Ask a question":"Poser une question","Shared":"Partagée","Answered":"Résolue","Waiting Approval":"Approbation en attente","cancel":"annuler","ENTER":"ENTRER","Upcoming Events":"Événements à venir","Past Events":"Événements passés","Goldcast":"Goldcast","MANAGE EVENT":"GÉRER L\'ÉVÉNEMENT","Edit Profile":"Modifier le profil","Stay tuned!":"Restez à l\'écoute !","Sign-in instructions will be available here 12 hours prior to the event":"Les instructions d\'inscription seront disponibles ici 12 heures avant l\'événement","Please log out":"Veuillez vous déconnecter","Logout":"Déconnexion","Continue as {differentUser}":"Continuer en tant que {differentUser}","You are already logged in as {user}.":"Vous êtes déjà connecté·e en tant que {user}.","EMAIL":"E-MAIL","user@email.com":"user@email.com","FIRST NAME":"Prénom","First Name":"Prénom","LAST NAME":"Nom","Last Name":"Nom","You are not registered to this event":"Vous n\'êtes pas inscrit·e à cet événement","Please enter your email and name":"Veuillez saisir votre nom et votre adresse e-mail","Please enter your email":"Veuillez saisir votre adresse e-mail","We have sent a secret code to":"Nous avons envoyé un code secret à","BACK":"RETOUR","Didn\'t receive an email? Make sure to check spam list":"Vous n\'avez pas reçu d\'e-mail ? Vérifiez votre dossier Spam","Resend Mail":"Renvoyer l\'e-mail","SECRET CODE":"CODE SECRET","Please enter the temporary password sent to your email":"Veuillez saisir le mot de passe temporaire envoyé à votre adresse e-mail","NEW PASSWORD":"NOUVEAU MOT DE PASSE","Please enter a new password":"Veuillez saisir un nouveau mot de passe","CONFIRM PASSWORD":"CONFIRMER LE MOT DE PASSE","Please re-enter the new password":"Veuillez confirmer le nouveau mot de passe","Password length should be atleast 8":"Votre mot de passe doit contenir au moins 8 caractères.","Password and Confirm Password don\'t match !!":"Les mots de passe ne correspondent pas.","Please enter your password to continue":"Veuillez saisir votre mot de passe pour continuer","Logging you in...":"Connexion dans...","PASSWORD":"MOT DE PASSE","Forgot credentials?":"Vous avez oublié vos identifiants ?","Forgot Password? A mail will be sent to your registered email.":"Mot de passe oublié ? Un e-mail sera envoyé à l\'adresse que vous avez indiquée.","Email cannot be blank!!":"Vous devez indiquer une adresse e-mail.","We have sent a secure login link to":"Nous avons envoyé un lien de connexion sécurisé à","from":"depuis l\'adresse","Please use that to access your event.":"Veuillez l\'utiliser pour accéder à votre événement.","Please check spam/promotion too if you can\'t find it.":"Veuillez également vérifier votre dossier Spam/Promotions s\'il n\'apparaît pas.","Thank You !":"Merci !","The link is not valid.":"Le lien n\'est pas valide.","Please be patient.":"Veuillez patienter.","We are verifying your link.":"Nous vérifions votre lien.","Thank you for entering the code!":"Merci d\'avoir saisi le code !","Please create a new password":"Veuillez créer un nouveau mot de passe","Signing you up...":"Inscription en cours…","We have sent a temporary password to":"Nous avons envoyé un mot de passe temporaire à","TEMPORARY PASSWORD":"MOT DE PASSE TEMPORAIRE","Please enter the temporary password sent to your mail":"Veuillez saisir le mot de passe temporaire envoyé à votre adresse e-mail","Password Length should be 8":"Votre mot de passe doit contenir 8 caractères.","Okay":"D\'accord","Backstage: {title}":"Coulisses : {title}","Prep Area":"Loge","Starting at {time}":"Démarre à {time}","person":"personne","inside":"dans la salle","No one is inside":"Il n\'y a personne à l\'intérieur","This area is for you to sync up with your fellow speakers before you go on stage.":"Cet espace vous permet de vous concerter avec les autres intervenant·e·s avant de monter sur scène.","This area is for you to check your cam and mic before you enter the room.":"Cet espace vous permet de vérifier votre caméra et votre micro avant d\'entrer dans la salle.","I\'m Ready":"Je suis prêt·e","Watch Live":"Regarder en direct","Backstage":"Coulisses","You are sharing your screen":"Vous partagez actuellement votre écran","LIVE":"EN DIRECT","Live":"EN DIRECT","Virtual":"Virtuel","Only available for ":"Disponible uniquement pour ","See Booths":"Voir les stands","See Rooms":"Voir les salles","Enter Backstage":"Accéder aux coulisses","This track has no upcoming sessions. Check out a different track.":"Aucune session n\'est à venir pour ce morceau. Découvrez-en un autre.","View":"Afficher","Agenda":"Ordre du jour","Scroll to see all tracks":"Faites défiler pour voir tous les morceaux","No Agenda Items to show!":"Aucun point de l\'ordre du jour à montrer !","ENTER EVENT":"REJOINDRE L\'ÉVÉNEMENT","change":"modifier","Upload":"Télécharger","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF OU PNG. 5 Mo MAX.","Create Profile":"Créer un profil","Email":"E-mail","Company":"Entreprise","Title":"Poste","No matching locations found":"Aucune ville correspondante trouvée","You can try searching for the location with another keyword":"Vous pouvez essayer de rechercher la ville en modifiant votre saisie","Interest Tags":"Tags de centres d\'intérêt","Pick your first tag":"Choisissez votre premier tag","Save":"Enregistrer","Searching...":"Recherche...","Twitter":"Twitter","Select Your First Tags":"Sélectionnez vos premiers tags","Add Interest tags":"Ajouter des centres d\'intérêt","Congratulations!":"Félicitations !","Your first Goldcast event is set up":"Votre premier événement Goldcast est configuré","You can always visit":"Vous pouvez toujours consulter","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"pour en savoir plus sur la configuration et la gestion de vos événements","See My Event":"Voir mon événement","Peak Community":"Peak Community","Loading Lite Mode... This may take up to 30s":"Chargement du mode Lite… Cela peut prendre jusqu\'à 30 s","Loading Video...":"Chargement de la vidéo...","Video will begin at session start time":"La vidéo commencera dès le début de la session","TIME":"HEURE","TITLE":"POSTE","STATUS":"STATUT","END":"Terminer","START":"DÉMARRER","AGENDA":"Ordre du jour","Enable Audio":"Activer l\'audio","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"L\'audio a été coupé à cause de la politique de lecture automatique du navigateur. Cliquez sur Activer ci-dessous pour réactiver le son. Vous pouvez également réactiver le son ultérieurement grâce aux commandes intégrées.","Enable":"Activer","You are being redirected outside the room. Would you like to continue?":"Vous allez sortir de la salle. Voulez-vous continuer ?","Continue":"Continuer","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"Vous pouvez également utiliser le mode Lite, qui aura un retard de 30 s par rapport au direct","We detected a network issue":"Nous avons détecté un problème de réseau","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Veuillez ne pas vous connecter via un VPN ou un pare-feu. Essayez de changer de réseau, de navigateur ou d\'appareil si le problème persiste.","Could not connect":"Impossible de se connecter","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"Cela peut être dû à un problème de réseau sécurisé, de navigateur ou d\'appareil. Veuillez essayer de changer de réseau, de navigateur ou d\'appareil si le problème persiste","Switch to Lite Mode":"Activer le mode Lite","Leave":"quitter","Screenshare had an issue":"Un problème est survenu lors du partage d\'écran","Could not share screen unexpectedly. Refresh & retry. On mac go to":"Impossible de partager l\'écran. Veuillez actualiser et réessayer. Sur Mac, accédez à","and check if your browser has the required permission":"et vérifiez si votre navigateur dispose de l\'autorisation requise","Uh OH... Something went wrong":"Zut... une erreur s\'est produite","To fix this, click the":"Pour résoudre ce problème, cliquez sur","in your URL bar, then select “Allow”, and then click “Try Again”":"dans la barre d\'adresse et cliquez sur « Autoriser » puis sur « Réessayer »","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"Impossible d\'initialiser votre diffusion multimédia pour une raison inconnue ! Il est possible que votre navigateur ne soit pas pris en charge par notre plateforme. Nous vous recommandons d\'utiliser Google Chrome. Si le problème persiste, veuillez contacter l\'assistance Goldcast","To fix this, make sure your":"Pour résoudre ce problème, assurez-vous qu\'aucune autre application n\'utilise votre","is not being accessed by any other app. If not, please try changing your":". Si ce n\'est pas le cas, essayez de changer de","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"périphériques en cliquant sur « Accéder aux paramètres ». Une fois que vous pensez avoir résolu le problème, cliquez sur « Réessayer » !","Go To Settings":"Accéder aux paramètres","Try Again":"Réessayez","Try Joining without Video":"Essayez de rejoindre sans la vidéo","A refresh and rejoin should work":"Actualiser la page et rejoindre à nouveau devrait suffire","Refresh & Rejoin":"Actualiser et rejoindre","Start Chat":"Démarrer le chat","On Stage":"Sur scène","Connect your on-site camera and microphone to present to your virtual attendees":"Connectez votre caméra et micro sur site pour faire une présentation à votre public virtuel","Stop Streaming":"Arrêter le streaming","Start Streaming":"Démarrer le streaming","Set up on-site video feed":"Configurer un flux vidéo sur site","Open TV":"Ouvrir la TV","Layout: {layout} ":"Disposition : {layout} ","With Speaker Videos":"Avec vidéos des intervenant·e·s","Full Screen":"Plein écran","No Speakers":"Aucun·e intervenant·e","Turn Off Setup Mode":"Désactiver le mode Configuration","Setup Mode":"Mode Configuration","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"Pour désactiver le mode Configuration dans {roomTitle}, appuyez sur Désactiver. Cette action désactivera également tous les flux actifs.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"{roomTitle} : préparation de la diffusion. Veuillez utiliser le mode Configuration pour diffuser uniquement depuis l\'emplacement en direct.","Starting in {duration}":"Démarrage dans {duration}","Can\'t share screen while there is something else being presented on stage":"Impossible de partager l\'écran alors que la scène est déjà occupée","You are now in attendee view!":"La vue du public est désormais activée !","You are now in organizer view!":"La vue du comité d\'organisation est désormais activée !","Note :":"Remarque :","Only organizer accounts can see this tag, normal attendees can’t see this":"Seul le comité d\'organisation peut voir ce tag, contrairement au public","Attendee":"Participant·e","Event Information":"Informations sur l\'événement","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"Seuls les hôtes des événements peuvent consulter les informations associées.<br /> Le public ne peut pas accéder à cette section.","Operating System":"Système d\'exploitation","Secondary Booths":"Stands secondaires","Sort":"Trier","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"En vous abonnant à {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2}vous serez automatiquement désabonné·e de{track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}Voulez-vous continuer ?","Track only available for {tracks}":"Morceau disponible uniquement pour {tracks}","Add to Calendar":"Ajouter au calendrier","Open Speakers Control Panel":"Ouvrir le panneau de commande des haut-parleurs","Move Offstage ↓":"Déplacer hors scène ↓","Error Moving ⚠":"Erreur lors du déplacement ⚠","Off Stage":"Hors scène","Move to Stage":"Déplacer vers la scène","An error occurred!":"Une erreur s\'est produite !","{eventName} Documents":"Documents {eventName}"," Set Up Mode":" Mode Configuration","Camera & Mic blocked":"Caméra et micro bloqués","Camera/Mic Inaccessible":"Impossible d\'accéder à la caméra/au micro","Camera/Mic Not Found":"Caméra/micro introuvables","Camera Inaccessible":"Impossible d\'accéder à la caméra","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"Il semble que la caméra soit déjà utilisée ou que la résolution ne soit pas prise en charge. Assurez-vous que votre caméra n\'est pas utilisée par une autre application et réessayez !","No microphone/camera is found":"Aucun microphone ni aucune caméra n\'ont été trouvés","The browser does not support using camera and microphone!":"La caméra et le microphone ne peuvent pas être utilisés sur ce navigateur.","{n} Slides":"{n} diapositives","Starting in {timeduration}":"Démarrage dans {timeduration}","{eventtitle} has ended":"{eventtitle} a pris fin","This is a text q&a question!":"Il s\'agit d\'une question Q&R textuelle !","Click here{if_it_does_not}":"Cliquez ici{if_it_does_not}","{click_here}if it does not":"{click_here}si ce n\'est pas le cas","{title}up next":"{title}à suivre","seat(s) open":"place(s) disponible(s)","Signal strength is low. Close other windows or connect to a different network.":"L\'intensité du signal est faible. Fermez d\'autres fenêtres ou connectez-vous à un autre réseau.","GO BACKSTAGE":"ACCÉDER AUX COULISSES","LEAVE STAGE":"Quitter la scène","LEAVE":"quitter","This event begins on{startitme}":"Cet événement débute le {startitme}","Please refresh to enter.":"Veuillez actualiser la page pour y accéder.","people":"personnes","Oops, Something went wrong":"Oups, une erreur s\'est produite","Back Home":"Retour à l\'accueil","Deciding where to go ...":"Décider où aller...","Go to Event Hub":"Accéder au hub d\'événements","CREATE":"CRÉER","Attending Virtually":"Participation virtuelle","Attending In Person":"Participation en personne","Click to change your attendance type":"Cliquez pour sélectionner un autre type de participation","Open Chat":"Ouvrir le chat","Create your profile for {eventtitle}":"Créez votre profil pour {eventtitle}","Move to stage":"Déplacer vers la scène","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"L\'hôte de l\'événement vous demande de vous déplacer vers la scène pour <strong>{broadcastTitle}</strong>.<br /><br />Si vous acceptez cette demande, vous serez en direct et visible par les participants à l\'événement.<br /><br />","Go Live On Stage":"Monter sur scène","Moved to backstage":"Déplacé·e vers les coulisses","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"L\'hôte vous a retiré·e de la scène. N\'essayez pas d\'y retourner sans avoir contacté l\'hôte au préalable.","Error creating Screen stream":"Erreur lors de la création du flux d\'écran","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"Le partage d\'écran n\'a pas été autorisé. *Cliquez ici* pour accéder à une documentation d\'aide.","Error publishing stream":"Erreur lors de la publication du flux","Could not publish stream. Please refresh and try again!":"Impossible de publier le flux. Veuillez actualiser la page et réessayer.","Error publishing screen":"Erreur lors de la publication de l\'écran","Error publishing screen. Please refresh and try again!":"Une erreur s\'est produite lors de la publication de l\'écran. Veuillez actualiser la page et réessayer.","Error unpublishing stream":"Erreur lors de l\'annulation de la publication du flux","Error unpublishing stream. Please refresh and try again!":"Une erreur s\'est produite lors de l\'annulation de la publication du flux. Veuillez actualiser la page et réessayer.","Invalid Publish Operation":"Opération de publication non valide","{username} profile picture":"Photo de profil {username}","Default":"Par défaut","A-Z":"A-Z","Random":"Aléatoire","All":"Tous","Past":"Terminés","Upcoming":"À venir","Learn More":"En savoir plus","close":"fermer","Discussion Rooms":"Salles de discussion","ATTENDEE MODE":"MODE AUDIENCE","Loading...":"Chargement...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"L\'appareil a été désactivé par le navigateur ou les autorisations d\'utilisation n\'ont pas été accordées. Veuillez accorder les autorisations nécessaires, puis cliquez sur « Réessayer ».","You are now registered. You will receive an email confirming details shortly.":"Vous êtes maintenant inscrit·e. Vous recevrez sous peu un e-mail de confirmation.","Streaming to Virtual Users from on-site video feed":"Diffusion pour un public virtuel à partir d\'un flux vidéo sur site","Ending in ":"Se termine dans ","GO LIVE":"DIFFUSION EN DIRECT","You have no past events.":"Vous n\'avez aucun événement passé.","You have no upcoming or live events.":"Vous n\'avez aucun événement à venir ou en direct.","left":"gauche","center":"centre","right":"droit","top":"Haut","bottom":"Bas","loading...":"chargement...","Loading ...":"Chargement...","Failed to redirect!":"La redirection a échoué !","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"Il semblerait que votre bloqueur de publicités soit activé. Il pourrait vous empêcher de profiter d\'une expérience optimale. Veuillez le désactiver. <br />&lt;br / &gt; Si vous avez besoin d\'aide, cliquez <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>ici</a> pour obtenir des instructions.","redirecting in {duration}":"redirection dans {duration}","STOP VIDEO":"ARRÊTER LA VIDÉO","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"Vous êtes sur le point d\'arrêter la lecture de cette vidéo. Votre diffusion repassera en mode direct et votre public pourra voir et entendre vos intervenant·e·s. Voulez-vous vraiment continuer ?","STOP SHARING":"Arrêter le partage","No Next Slide":"Pas de diapositive suivante","Next Slide":"Diapositive suivante","No Previous Slide":"Pas de diapositive précédente","Previous Slide":"Diapositive précédente","something went wrong while recording the response please try again":"Une erreur s\'est produite lors de l\'enregistrement de la réponse, veuillez réessayer","Start In-Person Streaming":"Démarrer le streaming en personne","Stop In-Person Streaming":"Arrêter le streaming en personne","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Votre vidéo est mise en mémoire tampon et la session de test va commencer sous peu. Cela ne se produira pas pendant la session proprement dite.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"Le bandeau défilant apparaîtra en haut de la page Web pour tous les participants. Pour transformer le bandeau défilant en hyperlien, saisissez l\'URL ci-dessous","Allow {key}":"Autoriser {key}","{messageType} can only be published from inside a broadcast.":"{messageType} : publication possible uniquement lors d\'une diffusion.","To grant {deviceName} access to this page, follow the two steps below:":"Pour autoriser {deviceName} à accéder à cette page, suivez les deux étapes ci-dessous :","2. Allow {deviceName} access and then refresh the page.":"2. Accordez l\'accès à {deviceName}, puis actualisez la page."}');

/***/ }),

/***/ 5849:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Padajući izbornik postavki događaja"," Stage Control":" Upravljanje scenom","Stage Controls and Information":"Upravljanje i informacije o sceni","Live in ":"Uživo za ","Start Session":"Započni sesiju","End Session":"Završi sesiju","Present Screen":"Predstavi prikaz","Rehearse On Stage":"Proba na sceni","Turn on Microphone":"Uključi mikrofon","Turn off Microphone":"Isključi mikrofon","Turn on camera":"Uključi kameru","Turn off camera":"Isključi kameru","rehearsal mode":"način probe","People Watching: ${watchCount}":"Broj gledatelja: ${watchCount}","Turn on Audio":"Uključi zvuk","Turn off Audio":"Isključi zvuk","Are you sure you want to leave this room?":"Jeste li sigurni da želite napustiti ovu sobu?","you will be redirected to stage in":"prebacit ćete se na scenu za","sec. . ":"sek. ","Skip to Main Navigation":"Preskoči do glavne navigacije","Skip to Chat":"Preskoči do čavrljanja","Skip to Meeting Controls":"Preskoči do upravljanja sastankom","LinkedIn":"LinkedIn","Live in":"Uživo za","UPCOMING":"SLIJEDI USKORO","Rehearse on stage":"Proba na sceni","Watch Rehearsal":"Pogledaj probu","Answered by:":"Odgovorio:","Speaker Off":"Zvučnik je isključen","Speaker On":"Zvučnik je uključen","Speaker Controls":"Upravljanje zvučnicima","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"Svi elementi scene nalaze se iza zajedničke slike. Bit će ponovno vidljivi kada se zaustavi dijeljenje slike preko cijelog zaslona.","Close Ticker Popup":"Zatvori skočni prozor pomične poruke","Open GIF Picker":"Otvori odabir GIF-ova","Open Emoji Picker":"Otvori odabir emotikona","Send Message":"Pošalji poruku","Tabs: Messaging and More":"Kartice: slanje/primanje poruka itd.","Thanks for attending!":"Hvala vam na sudjelovanju!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" Za prijavljenu stazu nema nadolazećih sesija. Prebacite se na druge staze ako želite vidjeti sesije uživo.","Redirecting you to ":"Prebacujemo vas na ","in ":"za ","seconds":"sekundi","Main Navigation":"Glavna navigacija","YOU ARE HERE":"VI STE OVDJE","Live Now":"Sada je uživo","SUBMIT":"POŠALJI","Allocated time for engagement has ended. You will be redirected to main stage":"Dodijeljeno vrijeme za angažman je isteklo. Bit ćete preusmjereni na glavnu scenu","Wrap up in":"Završi za","Session overrun by":"Vrijeme sesije prekoračeno za","Ending in":"Završava za","Bring this session live?":"Prebaciti ovu sesiju na uživo?","START SESSION":"ZAPOČNI SESIJU","Bring this session to end?":"Privesti ovu sesiju kraju?","END SESSION":"ZAVRŠI SESIJU","Go On Stage":"Idi na scenu","Muted by organizer":"Organizator je isključio zvuk","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"Jedan od organizatora događaja isključio je vaš zvuk. Možete ga uključiti klikom na gumb mikrofona.","Gifs":"Gifovi","Stickers":"Naljepnice","Launch Survey":"Pokreni anketu","Microphone is on":"Mikrofon je uključen","Microphone is off":"Mikrofon je isključen","Secret Code’s length should be 6 digits":"Duljina tajne šifre trebala bi biti 6 znamenki","Closing in 00:":"Zatvaranje za 00:","Submit":"Pošalji","Questions":"Pitanja","Preview":"Pretpregled","Close Survey":"Zatvori anketu","This is a required question":"Ovo je obavezno pitanje","Enter the text you’d like to present on stage below.":"U nastavku unesite tekst koji želite predstaviti na sceni.","Use Chrome/Edge for best performance":"Koristite Chrome/Edge za najbolje performanse","Do you want to launch your survey now?":"Želite li sada pokrenuti svoju anketu?","Success! Your Survey has been launched for attendees.":"Uspjeh! Vaša je anketa pokrenuta za sudionike.","Unable to publish. Please try again.":"Objava nije uspjela. Pokušajte ponovno.","Are you sure you want to close this survey?":"Jeste li sigurni da želite zatvoriti ovu anketu?","Success! Your Survey has been closed for attendees.":"Uspjeh! Vaša je anketa zatvorena za sudionike.","Unable to un-publish. Please try again.":"Poništavanje objave nije uspjelo. Pokušajte ponovno.","Please answer all required questions.":"Odgovorite na sva potrebna pitanja.","You have already submitted this survey.":"Već ste predali ovu anketu.","Success! Thank you for your feedback.":"Uspjeh! Hvala vam na povratnim informacijama.","Unable to submit. Please try again.":"Slanje nije uspjelo. Pokušajte ponovno.","Launch surveys will take over attendees\' engagement panel.":"Pokretanje ankete će je staviti u prozor angažmana sudionika.","Closing this survey will remove it from attendees\' engagement panel.":"Zatvaranje ove ankete uklonit će je iz prozora za angažman sudionika.","Survey":"Anketa","Updating Survey...":"Ažuriranje ankete...","Closing":"Zatvaranje","Goldcast needs access to your camera and microphone":"Goldcast treba pristup vašoj kameri i mikrofonu","Goldcast needs access to your microphone":"Goldcast treba pristup vašem mikrofonu","Goldcast needs access to your camera":"Goldcast treba pristup vašoj kameri","SPEAKERS":"ZVUČNICI","Mark as Unanswered":"Označi kao neodgovoreno","Mark as Answered":"Označi kao odgovoreno","Remove from Priority":"Ukloni iz prioriteta","Mark as Priority":"Označi kao prioritet","Answer":"Odgovor","Enter answer...":"Unesite odgovor...","Answered by":"Odgovorio","Submit Answer":"Pošalji odgovor","Test your system’s speaker":"Testirajte zvučnik vašeg sustava","Click \\"Yes\\" if you hear the sound.":"Kliknite \\"Da\\" ako čujete zvuk.","Load previous":"Učitaj prethodno","Hide Name":"Sakrij ime","Text Q&A is disabled in On Demand mode.":"Tekstualna pitanja i odgovori onemogućeni su u načinu rada Na zahtjev.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"Dosegnuto je ograničenje tekstualnih pitanja i odgovora. Sudionici neće moći postavljati nova pitanja.","Sent to Q&A":"Poslano u Pitanja i odgovore","Couldn\'t post as Q&A. Please try again.":"Nije moguće objaviti kao pitanje i odgovor. Pokušajte ponovno.","Yes this is being recorded":"Da, ovo se snima","No this is not being recorded":"Ne, ovo se ne snima","System\'s Speaker Check":"Provjera zvučnika sustava","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"Kako biste bili sigurni da ćete moći čuti događaj tijekom njegovog odvijanja, provjerite funkcioniraju li ispravno zvučnici vašeg sustava","Click on “Test your system’s speaker” to proceed":"Za nastavak kliknite \\"Testirajte zvučnik svog sustava\\".","Error while sharing message to screen. Post not found":"Pogreška prilikom dijeljenja poruke na zaslonu. Objava nije pronađena","Lost connection to servers. Refresh your page to get live event experience.":"Izgubljena je veza s poslužiteljima. Osvježite svoju stranicu da biste omogućili događaj uživo.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"VPN/vatrozid ometa vašu autentifikaciju. Promijenite mrežu ili se povežite sa svojim IT timom kako biste <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>ovim domenama</a> omogućili nesmetan pristup Goldcastu.","It\'s taking too long":"Ovo traje predugo","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"Čini se da ste povezani putem VPN-a ili vam je vatrozid uključen. Pogledajte ovaj <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>dokument za pomoć</a> i dodajte potrebne domene na popis dozvoljenih domena kako bi Goldcast funkcionirao glatko; ili biste trebali promijeniti svoju mrežu","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"Čini se da ste povezani putem VPN-a ili vam je vatrozid uključen. Pogledajte ovaj <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>dokument za pomoć</a> i dodajte potrebne domene na popis dozvoljenih domena kako bi Goldcast funkcionirao glatko; ili biste trebali promijeniti svoju mrežu; ili sesiju gledajte u Jednostavnom načinu rada","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"Goldcastova usluga video prijenosa ne može se povezati zbog slabe propusnosti mreže. Promijenite svoju mrežu da biste se povezali s uslugom prijenosa uživo.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"Goldcastova usluga video prijenosa ne može se povezati zbog slabe propusnosti mreže. Prijeđite na Jednostavni način rada ili promijenite mrežu da biste se povezali s uslugom prijenosa","Most Upvotes":"Najviše glasova za","Most Recent":"Najnovije","My Questions":"Moja pitanja","Prioritized":"Prioriteti","Approved":"Odobreno","Unapproved":"Neodobreno","Unanswered":"Neodgovoreno","Failed to update answer. Please try again!":"Ažuriranje odgovora nije uspjelo. Pokušajte ponovno.","Failed to post answer. Please try again!":"Objava odgovora nije uspjela. Pokušajte ponovno.","Failed to delete question. Please try again!":"Brisanje pitanja nije uspjelo. Pokušajte ponovno.","Survey Link":"Poveznica na anketu","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"Prebacivanje će ponovno učitati vašu trenutačnu stranicu u prikaz sudionika. Za povratak na prikaz organizatora isključite prikaz sudionika u padajućem izborniku profila.","You haven\'t asked any questions yet":"Još niste postavili nijedno pitanje","No prioritized questions":"Nema prioritetnih pitanja","Create prioritized list of questions for speakers by marking questions as priority":"Izradite prioritetni popis pitanja za govornike označavanjem određenih pitanja prioritetnim","No Approved Questions":"Nema odobrenih pitanja","Approve incoming questions to see list of approved questions":"Odobrite dolazna pitanja da biste vidjeli prikazani popis odobrenih pitanja","No Unapproved Questions":"Nema prioritetnih pitanja","No Answered Questions":"Nema odgovorenih pitanja","Answer a question on stage or with inline text":"Odgovorite na pitanje na sceni ili umetnutim tekstom","All questions are answered":"Na sva je pitanja odgovoreno","Rate Your Experience":"Ocijenite svoj doživljaj","How satisfied are you with Goldcast?":"Koliko ste zadovoljni Goldcastom?","What are the main reasons for your rating?":"Koji su glavni razlozi vaše ocjene?","I am interested in seeing a demo of Goldcast":"Zanima me vidjeti demo Goldcasta","Thank You":"Hvala vam","Your feedback was successfully submitted.":"Vaše su povratne informacije uspješno poslane.","Tell us how we can improve...":"Recite nam kako se možemo poboljšati...","1 Slide":"1 slajd","Your internet connection is unstable.":"Vaša internetska veza je nestabilna.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"Čini se da pričate bez zvuka. Kliknite na ikonu mikrofona da biste uključili zvuk.","The registration could not be completed! Please check that this email is allowed to register for the event.":"Registracija se nije mogla dovršiti! Provjerite je li ova adresa e-pošte dopuštena u svrhu registracije za događaj.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Čini se da ste već registrirani za ovaj događaj! Provjerite mapu neželjene pošte za svoju potvrdu o registraciji, ako je još niste primili. Ako trebate dodatnu pomoć, obratite se organizatoru događaja.","Your registration could not be completed. This event has reached its registration capacity.":"Vaša se registracija se nije mogla dovršiti. Ovaj je događaj ispunio svoj kapacitet u smislu broja prijava.","Image cannot be an svg":"Slika ne može biti svg","This should be a valid linkedin url":"Ovo bi trebao biti važeći linkedin URL","This should be a valid twitter url":"Ovo bi trebao biti važeći Twitter URL","This should be a valid url":"Ovo bi trebao biti važeći URL","Video":"Video","Read Less":"Čitaj manje","live":"uživo","Opened":"Otvoreno","In person only":"Samo osobno","Stage Stream":"Prijenos na sceni","Streaming not available":"Prijenos nije dostupan","Close TV":"Zatvori TV","Streaming is not available for prerecorded and RTMP sessions":"Prijenos nije dostupan za unaprijed snimljene i RTMP sesije","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Povežite svoje računalo s TV ekranom ili projektorom kako biste prisutnim osobama omogućili da vide što se događa na vašoj virtualnoj sceni, uključujući slajdove, pitanja i odgovore itd. Nakon povezivanja kliknite OTVORI TV i povucite ili podijelite novi prozor na svom TV zaslonu ili projektoru. ","Close Setup Mode":"Zatvori način postavljanja","Help":"Pomoć","upcoming":"nadolazeće","ended":"završeno","Remove from favorites":"Ukloni iz omiljenih","Add to favorites":"Dodaj u omiljene","PLAY RECORDING":"REPRODUCIRAJ SNIMKU","VIEW RECORDING":"POGLEDAJ SNIMKU","VIEW RECORDINGS":"POGLEDAJ SNIMKE","Virtual Backgrounds":"Virtualne pozadine","No Device Available":"Nijedan uređaj nije dostupan","Needs permission":"Treba dopuštenje","Device not detected":"Uređaj nije otkriven","Camera is on":"Kamera je uključena","Camera is off":"Kamera je isključena","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"Zrcaljeni video ne odražava se gledateljima. Gledatelji uvijek vide nezrcaljeni video.","Mirror My Video":"Zrcali moj video","Camera":"Kamera","1. Click on Safari > Settings for this\\n            website":"1. Kliknite Safari > Postavke za ovo\\n          web mjesto","1. Click the lock":"1. Kliknite bravu","icon in your browser’s address bar":"ikonu u adresnoj traci preglednika","3. Unmute":"3. Uključite zvuk","and":"i","icons from stage control panel":"ikone s upravljačke ploče scene","icon from stage control panel":"ikonu s upravljačke ploče scene","2. Set camera and microphone to “Allow”.":"2. Postavite kameru i mikrofon na \\"Dopusti\\".","2. Set camera to “Allow”.":"2. Postavite kameru na \\"Dopusti\\".","2. Set microphone to \\"Allow\\"":"2. Postavite mikrofon na \\"Dopusti\\".","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. Odaberite \\"Uvijek dopusti Goldcastu pristup vašoj kameri i mikrofonu\\".","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. Odaberite \\"Uvijek dopusti Goldcastu pristup vašoj kameri\\".","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. Odaberite \\"Uvijek dopusti Goldcastu pristup vašem mikrofonu\\".","Questions?":"Pitanja?","If you’re having issues, check out our comprehensive":"Ako imate problema, pogledajte našu sveobuhvatnu ponudu","help docs":"dokumenata pomoći","Speaker is on":"Zvučnik je uključen","Stop Test":"Zaustavi test","Test your system’s audio":"Testirajte zvučnik vašeg sustava","Still can\'t hear any sound?":"I dalje ne možete čuti nikakav zvuk?","Microphone":"Mikrofon","Audio is being played in system\'s default audio device.":"Zvuk se reproducira na zadanom audio uređaju sustava.","Click to view/change audio device":"Kliknite za prikaz/promjenu audio uređaja","Speaker":"Zvučnik","Play Recording":"Reproduciraj snimku","Recording for this broadcast is currently being processed and will be available soon":"Snimka ovog emitiranja trenutačno se obrađuje i uskoro će biti dostupna","You haven\'t favorited anything yet!":"Još ništa niste postavili kao omiljeno!","Add an item to favorites by selecting the ♡ in the top right corner.":"Dodajte stavku u omiljene odabirom ♡ u gornjem desnom kutu.","Session has ended":"Sesija je završila","System Check":"Provjera sustava","Need help? Check out the":"Trebate pomoć? Provjerite","Skip Checks and Continue":"Preskoči provjere i nastavi","Click the button above to run the test":"Kliknite gornji gumb za pokretanje testa","Test Screenshare":"Testiraj dijeljenje zaslona","Share message to stage":"Podijeli poruku na sceni","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"U nastavku unesite tekst koji želite koristiti za pomičnu poruku. Da biste pomičnu poruku pretvorili u poveznicu, unesite URL.","Ticker":"Pomična poruka","Coffee Break! Be back in 10m.":"Pauza za kavu! Vraćam se za 10 minuta.","Enter Message":"Unesi poruku","https://www.xyz.com":"https://www.xyz.com","Launch":"Pokreni","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Hvala vam što ste poslali svoja pitanja. Moći ćete poslati još jedno nakon što jedno od vaših aktivnih bude odobreno.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"Žao nam je, ali značajka Pitanja i odgovori (QA) trenutačno je onemogućena. Moći ćete poslati pitanje kada ova značajka ponovno bude omogućena.","Votes":"Glasovi","Vote":"Glas","is inviting you to a video call":"vas poziva na video poziv","ENTER ROOM":"PRIKLJUČI SE","Start the conversation!":"Započnite razgovor!","Couldn\'t send message. Click here to retry.":"Nije bilo moguće poslati poruku. Kliknite ovdje za ponovni pokušaj.","Couldn\'t add emoji. Please try again.":"Nije bilo moguće dodati emotikon. Pokušajte ponovno.","Couldn\'t remove emoji. Please try again.":"Nije moguće ukloniti emotikon. Pokušajte ponovno.","Couldn\'t delete message. Please try again.":"Nije bilo moguće izbrisati poruku. Pokušajte ponovno.","Couldn\'t pin message. Please try again.":"Nije bilo moguće prikvačiti poruku. Pokušajte ponovno.","Couldn\'t unpin message. Please try again.":"Nije bilo moguće otkvačiti poruku. Pokušajte ponovno.","Today":"Danas","No messages yet":"Još nema poruka","Messages from organizers and speakers appear here!":"Ovdje se pojavljuju poruke organizatora i govornika!","Next Session is Starting":"Sljedeća sesija počinje","Go to Next Session":"Idi na sljedeću sesiju","I’d like to stay":"Želim ostati","My favorites":"Moji omiljeni","1. Click on the lock icon in your address bar":"1. Kliknite na ikonu lokota u adresnoj traci","We recommend organizers and speakers use a desktop\\n        device":"Preporučujemo organizatorima i govornicima da koriste stolno\\n        računalo","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"Kako bi osigurali najbolji doživljaj sudionicima, govornici i organizatori\\n        moraju koristiti Goldcast sa stolnog računala. Emitiranje s mobilnog uređaja\\n        uzrokovat će lošiji doživljaj","Watch Now":"Gledaj sada","Video progress time":"Vrijeme napredovanja videozapisa","Total video duration":"Ukupno trajanje videozapisa","Rate Goldcast!":"Ocijenite Goldcast!","Running Required Checks...":"Izvođenje potrebnih provjera...","Test Your Setup":"Testirajte svoje postavke","Test your Computer Device, Microphone and Camera before you join the event":"Testirajte svoj računalni uređaj, mikrofon i kameru prije nego što se pridružite događaju","Speaker and microphone not working?":"Zvučnik i mikrofon ne rade?","Passed":"Prošao","Fix Audio Issues":"Riješi problema sa zvukom","Check if audio is being played in other sound devices connected to phone/tablet":"Provjerite reproducira li se zvuk na drugim zvučnim uređajima povezanim s telefonom/tabletom","Check if correct audio device is chosen from the below dropdown":"Provjerite je li odabran ispravan audio uređaj s padajućeg izbornika u nastavku","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>Kliknite ovdje</a> kako biste provjerili je li odabran pravi audio uređaj na kojem treba reproducirati zvuk","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Kliknite ovdje</a> kako biste provjerili je li odabran pravi audio uređaj na kojem treba reproducirati zvuk","Right click on the browser tab & click “Unmute Site”":"Kliknite desnom tipkom miša na karticu preglednika i kliknite \\"Uključi zvuk stranice\\"","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Provjerite je li zvuk kartica preglednika uključen ili kliknite Prozor > Uključi zvuk ove kartice","System Check Failed!":"Provjera sustava nije uspjela!","System Check Passed!":"Provjera sustava je uspjela!","Complete checks to proceed":"Dovršite provjere za nastavak","Enter Event":"Pridruži se događaju","Skip Screen Sharing Check? ":"Preskočiti provjeru dijeljenja zaslona? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"Preporučujemo da dovršite provjeru dijeljenja zaslona ako vaš zaslon treba biti korišten na događaju","Ignore & Enter Event":"Ignoriraj i pridruži se događaju","Test screenshare":"Testiraj dijeljenje zaslona","Retry Now":"Pokušaj ponovno","SHARE":"DIJELI","Rooms Closed":"Sobe su zatvorene","Discussion rooms are now closed. You are being redirected to the Stage.":"Sobe za raspravu sada su zatvorene. Bit ćete preusmjereni na scenu,","Return To Stage":"Povratak na scenu","Unrecognized embedded widget provider - ":"Neprepoznati pružatelj ugrađenih widgeta - ","Room Ended":"Soba je završila","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"Vaš organizator događaja zatvorio je sve sobe. Sada ćete biti preusmjereni na scenu s događajima.","Video Q&A Request Cancelled":"Otkazan je zahtjev za video pitanja i odgovore","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Vaš zahtjev za video pitanja i odgovore otkazan je jer koristite gledanje u jednostavnom načinu rada. Prebacite se na način rada uživo za ponovno \'podizanje ruke\'.","Camera Passed":"Kamera je u redu","Camera Error":"Pogreška kamere","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"Dopuštenja za kameru ne daju se iz preglednika. Kliknite \\"Dopusti kameru\\".","Camera permissions aren’t granted from system. Click “Allow Camera”":"Dopuštenja za kameru ne daju se iz sustava. Kliknite \\"Dopusti kameru\\".","Uh-oh! Error occurred while creating camera stream":"Jao! Došlo je do pogreške prilikom stvaranja prijenosa putem kamere","Close other applications which might use camera stream":"Zatvorite ostale aplikacije koje bi mogle koristiti prijenos putem kamere","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>Kliknite ovdje</a> kako biste provjerili ima li preglednik pristup kameri","Microphone Passed":"Mikrofon je u redu","Microphone Error":"Pogreška mikrofona","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"Dopuštenja za mikrofon ne daju se iz preglednika. Kliknite \\"Dopusti mikrofon\\"","Mic permissions aren’t granted from system. Click “Allow Microphone”":"Dopuštenja za mikrofon ne daju se iz sustava. Kliknite \\"Dopusti mikrofon\\"","Uh-oh! Error occurred while creating mic stream":"Jao! Došlo je do pogreške prilikom stvaranja prijenosa putem mikrofona","Close other applications which might use mic stream":"Zatvorite ostale aplikacije koje bi mogle koristiti prijenos putem mikrofona","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>Kliknite ovdje</a> kako biste provjerili ima li preglednik pristup mikrofonu","Speaker and Microphone Error":"Pogreška zvučnika i mikrofona","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"Za prikaz popisa zvučnika povezanih sa sustavom potrebna su dopuštenja mikrofona. Kliknite \\"Dopusti mikrofon\\"","It seems mic is being used by other application. Close other applications to proceed.":"Čini se da mikrofon koristi druga aplikacija. Da biste nastavili, zatvorite druge aplikacije.","Camera & Microphone Error":"Pogreška kamere i mikrofona","To enable permissions, click the Allow Camera & Mic button below":"Da biste omogućili dopuštenja, kliknite gumb Dopusti kameru i mikrofon u nastavku","Network Connection":"Mrežna veza","Check Passed":"Provjera je uspjela","Could not establish a network connection":"Nije bilo moguće uspostaviti mrežnu vezu","Connect to a different network, or use a mobile hotspot.":"Povežite se putem druge mreže ili upotrijebite mobilnu pristupnu točku.","Disable any VPN or firewall is connected.":"Onemogućite sve povezane VPN-ove ili vatrozidove.","Connection: Good":"Veza: dobra","Network Connection Error":"Pogreška mrežne veze","Can’t connect to network. Change your network or limited functionality will be available during event.":"Spajanje na mrežu nije moguće. Promijenite svoju mrežu ili će tijekom događaja biti dostupna ograničena funkcionalnost.","AdBlocker":"Program za blokiranje oglasa","AdBlocker not detected.":"Program za blokiranje oglasa nije otkriven.","AdBlocker detected. This may degrade your event experience.":"Program za blokiranje oglasa je otkriven. To može pogoršati vaš doživljaj događaja.","Disable adblocker for best experience.":"Za najbolji doživljaj, isključite program za blokiranje oglasa.","You are using ":"Vi koristite ","Use Windows or Mac OS for best performance":"Koristite Windows ili Mac OS za najbolje performanse","Browser Check":"Provjera preglednika","Check Passed.":"Provjera je uspjela.","Switch To Lite Mode":"Prebaci se na jednostavni način","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Vaš zahtjev za video pitanja i odgovore bit će otkazan kada se prebacite na jednostavni način rada","Stay on Live Mode":"Ostani u načinu rada uživo","Unable to mark as favorite":"Nije moguće označiti kao omiljeno","Event organizers must enter the event to select favorites.":"Organizatori događaja moraju unijeti događaj kako bi odabrali omiljene.","Make an Announcement":"Napravite objavu","STOP":"ZAUSTAVI","InPerson CheckIn App":"Aplikacija za prijavu fizički prisutnih sudionika","App to Check-In In-Person attendees":"Aplikacija za prijavu fizički prisutnih sudionika","SEE AGENDA":"POGLEDAJ DNEVNI RED","Please visit the Agenda tab to view the session recordings":"Posjetite karticu Dnevni red kako biste pregledali snimke sesija","The session recordings will be available soon in the Agenda tab":"Snimke sesija bit će dostupne uskoro u kartici Dnevni red","FAILED!":"NIJE USPJELO!","Next session is beginning":"Sljedeća sesija počinje","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"Želite li prijeći na sljedeću sesiju? Vaš prijenos će se nastaviti i vaš TV će emitirati novu sesiju.","Banners":"Baneri","Images":"Slike","Screen Share":"Dijeljenje zaslona","Browser might not have screen-recording permission on your computer.":"Preglednik možda nema dozvolu za snimanje zaslona na vašem računalu.","Open System Preferences":"Otvori Postavke sustava","Error publishing screen because someone else started screen share already.":"Pogreška pri objavljivanju zaslona jer je netko drugi već započeo dijeljenje zaslona.","Live Feed":"Prijenos uživo","Check Your Network":"Provjerite svoju mrežu","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"Tijekom reprodukcije videozapisa otkrili smo pogrešku! Ako imate problema s reprodukcijom videozapisa, pokušajte osvježiti stranicu ili se prebaciti na jednostavni način rada.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"Tijekom reprodukcije videozapisa otkrili smo pogrešku! Ako imate problema s reprodukcijom videozapisa, pokušajte osvježiti stranicu.","All Dates":"Svi datumi","All Tracks":"Sve staze","Create Ticker":"Izradi pomičnu poruku","Booths Closed":"Kabine su zatvorene","Your event organizer has closed all the booths. You will now be redirected to the stage":"Vaš organizator događaja zatvorio je sve kabine. Bit ćete preusmjereni na scenu","Visit the Polls tab to view live results.":"Idite na karticu Ankete za pregled rezultata uživo.","A new poll is open! Visit the Polls tab to vote.":"Otvorena je nova anketa! Idite na karticu Ankete da biste glasovali.","Vote for Polls":"Glasujte za Ankete","Go to Polls Tab":"Idi na karticu Ankete","Microphone audio too low":"Zvuk mikrofona je preslab","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"Otkrili smo problem s vašim zvukom. Preporučujemo da pokušate isključiti/uključiti zvuk ili upotrijebiti drugi uređaj ako se problem nastavi.","Audio/Video bitrate too low":"Brzina prijenosa audio/video podataka je preniska","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"Vaše postavke mrežnog vatrozida blokiraju A/V prijenose. Preporučujemo da se prebacite na drugu mrežnu vezu.","Error sharing screen":"Pogreška pri dijeljenju zaslona","A network error occurred while sharing screen. Please check your network connection.":"Došlo je do mrežne pogreške tijekom dijeljenja zaslona. Provjerite svoju mrežnu vezu.","Apologies, due to some errors, we need to refresh the page!":"Isprike, zbog nekih pogrešaka moramo osvježiti stranicu!","Warning":"Upozorenje","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"Otkrili smo problem s vašim videom. Preporučujemo da pokušate zatvoriti druge kartice preglednika ili druge aplikacije koje se izvode na vašem uređaju i provjerite/poboljšajte svoju internetsku vezu kako biste riješili ovaj problem.","No results found":"Nije pronađen nijedan rezultat","Audio":"Audio","Please choose another microphone and camera":"Odaberite drugi mikrofon i kameru","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"Trenutačno odabrani mikrofon i kamera ne rade. Odaberite drugi mikrofon i kameru s padajućih izbornika u nastavku.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"Trenutačno odabrana kamera ne radi. Odaberite drugu kameru s padajućeg izbornika u nastavku.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"Možete nastaviti i bez kamere, no preporučujemo da riješite sukob kako biste osigurali glatko emitiranje","Please choose another microphone":"Odaberite drugi mikrofon","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"Trenutačno odabrani mikrofon ne radi. Odaberite drugi mikrofon s padajućeg izbornika u nastavku.","Please check that your TV speaker is correct":"Provjerite je li zvučnik vašeg TV-a ispravan","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"Trenutačno odabrani zvučnik ne radi. Odaberite drugi zvučnik s padajućeg izbornika u nastavku.","Your answer":"Vaš odgovor","Edit":"Uredi","Delete":"Izbriši","Settings":"Postavke","Signing Out":"Odjava","Confirming your account...":"Potvrđivanje vašeg računa...","Something Went Wrong. Please Retry :(":"Nešto nije bilo u redu. Pokušajte ponovno :(","Resending Mail":"Ponovno slanje e-pošte","offline":"izvan mreže","I am inviting you to a video meeting:":"Pozivam vas na video sastanak:","Resending secure login link to your email":"Ponovno slanje poveznice za sigurnu prijavu na vašu adresu e-pošte","Sending secure login link to your email":"Slanje poveznice za sigurnu prijavu na vašu adresu e-pošte","Something went Wrong. Please Retry :(":"Nešto nije bilo u redu. Pokušajte ponovno :(","Updating your password":"Ažuriranje vaše lozinke","Sending mail":"Slanje e-pošte","Verifying":"Provjera","This might be slower than usual":"Ovo može biti sporije nego inače","Checking":"Provjera u tijeku","New results available! Refresh!":"Novi rezultati su dostupni! Osvježi!","Saving":"Spremanje u tijeku","Turn off Attendee mode":"Isključi način rada za sudionike","See Attendee View":"Pogledaj Prikaz sudionika","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Ukupan broj sudionika koji trenutno gledaju ovu sesiju Napomena: ovo vidi samo organizator","Session Count":"Broj sesija","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"Broj sudionika koji trenutačno gledaju sesije uživo. Napomena: ovo vidi samo organizator","Role":"Uloga","Total Attendees":"Ukupno sudionika","Total number of attendees online at this time Note: This is for organizer eyes only":"Ukupan broj umreženih sudionika u ovom trenutku Napomena: ovo vidi samo organizator","My Profile":"Moj profil","Languages":"Jezici","Filling out your profile can help you connect with people with similar interests.":"Ispunjavanje profila može vam pomoći da se povežete s ljudima sličnih interesa.","type to search for your address":"upišite za traženje vaše adrese","Could not open direct call":"Nije bilo moguće otvoriti izravni poziv","Chat messages can only be published from inside a broadcast.":"Poruke čavrljanja mogu se objaviti samo unutar emitiranja.","Stage Logo can only be published from inside a broadcast.":"Logotip scene može se objaviti samo unutar emitiranja.","Loading Speakers":"Učitavanje zvučnika","Raise hand is disabled for organizer accounts, but active for attendee accounts":"Dizanje ruke onemogućeno je za račune organizatora, ali je aktivno za račune sudionika","Disabled in lite mode, return to live if you’d like to raise hand!":"Onemogućeno u jednostavnom načinu rada, vratite se na uživo ako želite podići ruku!","Raise hand to enter stage for video q&a":"Podignite ruku za ulazak na scenu za video pitanja i odgovore","Speakers":"Zvučnici","Hosting organization: {organization}":"Organizacija domaćin: {organization}","Failed to switch {deviceTag}":"Nije uspjela promjena {deviceTag}","Make sure your {deviceTag} is not being used by any other application and is working properly.":"Uvjerite se da vaš {deviceTag} ne koristi nijedna druga aplikacija i da funkcionira ispravno.","Facing issues with audio or video? Switch on lite mode":"Imate problema sa zvukom ili videom? Uključite jednostavni način rada","Failed to get event for eventID: {eventID}":"Nije uspjelo dohvaćanje događaja za eventID: {eventID}","Error while playing video.":"Pogreška tijekom reprodukcije videozapisa.","Speakers only, attendees can\'t see this chat":"Samo govornici, sudionici ne mogu vidjeti ovo čavrljanje","Kudo":"Pohvala","Room":"Soba","Session":"Sesija","Booth":"Kabina","Public":"Javno","Drift":"Drift","Slides":"Slajdovi","Videos":"Videozapisi","Chat":"Čavrljanje","Messages":"Poruke","Poll":"Anketa","Docs":"Dokumenti","Q&A":"Pitanja i odgovori","Media":"Mediji","Messages Chat":"Čavrljanje porukama","Leaderboard":"Prikaz vodećih","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Napomena: vi ste također govornik za ovaj događaj. Uvijek ćete moći ući iza scenei i izaći na scenu,","Switch to Attendee View":"Prebaci se na prikaz sudionika","Return to Organizer View":"Vrati se na prikaz organizatora","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"Isključivanje prikaza sudionika ponovno će učitati vašu trenutačnu stranicu i vratiti vas na prikaz organizatora. Želite li nastaviti?","Switch":"Zamijeni","Request Sent":"Zahtjev je poslan","Your request for a demo has been submitted":"Vaš zahtjev za demonstracijom je predan","Organizer Redirection":"Preusmjeravanje organizatora","YES, REDIRECT":"DA, PREUSMJERI","DISMISS":"ODBACI","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"Sudionici se preusmjeravaju na sljedeću sesiju: {title}. Želite li i vi biti preusmjereni na sljedeću sesiju?","Stage":"Scena","Rooms":"Sobe","Join a round table to discuss moderated topics with your fellow attendees":"Pridružite se okruglom stolu za raspravu o temama sa svojim sudionicima i moderatorom","Booths":"Kabine","Join a booth to know more about a sponsor":"Pridružite se kabini kako biste saznali više o sponzoru","You are in the booth":"Vi ste u kabini","People":"Osobe","Connect with your fellow attendees":"Povežite se s ostalim sudionicima","Connect with speakers":"Povežite se sa zvučnicima","starting in {duration}":"počinje za {duration}","You will be redirected to booths in {duration}":"Bit ćete preusmjereni na kabine za {duration}","booths":"kabine","agenda":"dnevni red","You will be redirected to {word} in {duration}":"Bit ćete preusmjereni na {word} za {duration}","You will be redirected to the live stage in {duration}":"Bit ćete preusmjereni na scenu uživo za {duration}","- You are about to be redirected to {tabTitle} in {duration}":"- Bit ćete preusmjereni na {tabTitle} za {duration}","See Agenda":"Pogledaj dnevni red","Break":"Pauza","{title} is now live":"{title} je sada uživo","Apologies, due to an error we need to refresh the page!":"Isprike, zbog pogreške moramo osvježiti stranicu!","Network interruption detected":"Otkriven je prekid mreže","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"Vaša internetska veza ima problema. Ako koristite VPN, razmislite o tome da ga onemogućite. Možete se i pokušati spojiti na drugu mrežu.","No audio output device detected":"Nije otkriven uređaj za izlaz zvuka","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Spojite svoje zvučnike/slušalice i upotrijebite ikonu zupčanika kako biste ih testirali ako postoje problemi.","Please disable ad blocker for this page":"Isključite program za blokiranje oglasa za ovu stranicu","Yes, I understand":"Da, razumijem","No event user found so attended not marked!":"Nije pronađen nijedan korisnik događaja pa je sudionici nisu označeni!","Wait while the speaker approves your video q&a request":"Pričekajte da govornik odobri vaš zahtjev za video pitanja i odgovore","Organizer":"Organizator","UPNEXT":"SLJEDEĆE","Ended":"Završeno","Hide":"Sakrij","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"Ova će vas stranica automatski preusmjeriti za {durationLeftToRedirect} sekundi.","Register":"Registracija","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Pogreška: korisnik se ne može registrirati za ovaj događaj. Obratite se organizatoru događaja za pomoć","You are already registered!":"Već ste registrirani!","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Čini se da ste već registrirani za ovaj događaj! Provjerite mapu neželjene pošte za svoju potvrdu o registraciji, ako je još niste primili. Ako trebate dodatnu pomoć, obratite se organizatoru događaja.","Thank you for registering!":"Hvala vam na registraciji!","Submit another response":"Pošalji drugi odgovor","Share":"Podijeli","Know someone who want to attend this?":"Znate li nekoga tko želi prisustvovati ovome?","COPY LINK":"KOPIRAJ POVEZNICU","Powered by":"Pokreće","VIEW PROFILE":"POGLEDAJ PROFIL","You can access the event landing here":"Događaju možete pristupiti ovdje","Need Help?":"Trebate pomoć?","Welcome back":"Dobrodošli natrag","Checking...":"Provjera u tijeku...","Close":"Zatvori","Enter":"Pristupi","See {roomCount} Room(s)":"Pogledaj {roomCount} sobu/e","Back":"Natrag","Request a Demo":"Zatraži demonstraciju","Loading":"Učitavanje u tijeku","Thread":"Thread","Load more":"Učitaj još","Heads up!":"Pazi!","YES":"DA","No":"Ne","Following":"Praćenje","Error in loading drimify":"Pogreška pri učitavanju drimifyja","You\'re not registered for this event":"Niste registrirani za ovaj događaj","Check out other events":"Pogledajte ostale događaje","Date":"Datum","Location":"Lokacija","How are you attending the event":"Kako ćete prisustvovati događaju","In Person":"Osobno (fizički)","Virtually":"Virtualno","Event Widgets":"Widgeti događaja","Chat • Messages • Q&A • Poll • Docs":"Čavrljanje • Poruke • Pitanja i odgovori • Ankete • Dokumenti","DISCUSSION":"RASPRAVA","JOIN":"PRIDRUŽI SE","WAIT":"PRIČEKAJ","more":"više","See Profile":"Pogledaj profil","Filter":"Filtar","Video player not supported by your browser":"Vaš preglednik ne podržava video player ","We recommend using the latest version of Google Chrome to access your conference":"Za pristup vašoj konferenciji preporučujemo korištenje najnovije verzije preglednika Google Chrome","ANSWER":"ODGOVORI","REJECT":"ODBIJ","Don’t ask me this next time":"Ne pitaj me ovo sljedeći put","Cancel":"Odustani","Lite Mode":"Jednostavni način rada","On":"Uklj.","Connection Issues? Turn on Lite Mode":"Problemi s vezom? Uključi Jednostavni način rada","Turn On Lite Mode":"Uključi Jednostavni način rada","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"Jednostavni način rada rezultirat će kašnjenjem od 30 sekundi između emitiranja uživo i onoga što ćete vidjeti na zaslonu. Želite li nastaviti?","Turn On":"Uključi","Lite Mode Active!":"Jednostavni način rada je aktivan!","Thanks for your patience, lite mode now on!":"Hvala vam na strpljenju, jednostavni način rada sada je uključen!","Turn off Lite Mode?":"Isključiti jednostavni način rada?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Isključivanje jednostavnog načina rada za povratak na gledanje prijenosa uživo. Pazite, ovo će uzrokovati razmak od 30 sekundi dok ne sustignemo prijenos uživo.","Lite Mode Off!":"Jednostavni način rada je isključen!","Thanks for your patience, we’ve returned to the live broadcast!":"Hvala vam na strpljenju, vratili smo se na prijenos uživo!","Lite Mode Unavailable":"Jednostavni način rada nije dostupan","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Ispričavamo se zbog neugodnosti Jednostavni način rada trenutačno nije dostupan, prebacite se na prijenos uživo kako biste nastavili sesiju.","Turn off Lite mode?":"Isključiti jednostavni način rada?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"Otkrili smo da se vaša veza vratila u normalu. Želite li se vratiti na prijenos uživo? Pazite, ovo će uzrokovati razmak od 30 sekundi dok ne sustignemo prijenos uživo.","Turn Off":"Uključi","Lite mode is disabled for organizer accounts, but active for attendee accounts":"Jednostavni način rada onemogućen je za račune organizatora, ali je aktivan za račune sudionika","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"Vaš preglednik ne podržava jednostavni način rada. Preporučujemo korištenje najnovije verzije preglednika Google Chrome.","Lite mode is not curently available. We’ll let you know once it’s available again":"Jednostavni način rada trenutačno nije dostupan. Obavijestit ćemo vas kada ponovno bude dostupan.","Turn off Lite Mode":"Isključi jednostavni način rada","We’ll let you know when Lite mode is available again":"Obavijestit ćemo vas kada jednostavni način rada ponovno bude dostupan","Lite Mode Available":"Dostupan je jednostavni način rada","Loading Lite Mode...":"Učitavanje jednostavnog načina rada...","Turning Off Lite Mode":"Isključivanje jednostavnog načina rada","Lite Mode On":"Jednostavni način rada je uključen","Audio/Video Issues?":"Problemi sa zvukom/videom?","Error":"Pogreška","Click a video to play":"Kliknite videozapis za reprodukciju","Error starting video!":"Pogreška pri pokretanju videozapisa!","Please rotate your device to {mode} mode":"Okrenite svoj uređaj za {mode} prikaz","landscape":"vodoravni","portrait":"okomiti","Thank you for attending this event!":"Hvala vam što prisustvujete ovom događaju!","Go to Rooms":"Idi u Sobe","Please use a desktop or laptop Google Chrome browser to access your conference":"Za pristup konferenciji koristite preglednik Google Chrome na stolnom ili prijenosnom računalu","If on Desktop":"Ako je na zaslonu računala","Please increase the width of your window":"Povećajte širinu prozora","Alternatively, check out the":"U protivnom, provjerite","Youtube Livestream":"Youtube Livestream","Search":"Traži","Profile":"Profil","Yes":"Da","Loading Chat":"Učitavanje čavrljanja","Please wait while we fetch the chat":"Pričekajte dok ne dohvatimo čavrljanje","Load old messages":"Učitaj stare poruke","Join the room to see chat":"Pridružite se sobi da vidite čavrljanje","Live Chat":"Čavrljanje uživo","Uh..oh we couldn\'t load the content":"Nismo mogli učitati sadržaj","Please reload the page":"Molimo vas da ponovno učitate stranicu","New comments":"Novi komentari","Start the conversation":"Započnite razgovor","Be the first to add to chat!":"Budite prvi koji će nešto dodati u čavrljanje!","Enter your message":"Unesite svoju poruku","Joining chat!":"Pridruživanje čavrljanju je u tijeku!","See all pinned messages":"Pogledaj sve prikvačene poruke","Failed to send! Retry?":"Neuspjelo slanje! Pokušati ponovno?","Search for attendee":"Potraži sudionika","Up to date":"Ažurirano","Start a new conversation, We think you\'ll enjoy":"Započnite novi razgovor, mislimo da ćete uživati","chatting with these recommended attendees!":"čavrljajući s ovim preporučenim sudionicima!","Searching":"Traženje u tijeku","Load Previous":"Učitaj prethodno","Load Next":"Učitaj sljedeće","Loading Channel":"Učitavanje kanala","Please wait while we fetch the channel":"Pričekajte dok ne dohvatimo kanal","Please wait while we fetch the messages":"Pričekajte dok ne dohvatimo poruke","Send the first message":"Pošalji prvu poruku","Join":"Pridruži se","link":"poveznica","download":"preuzmi","Click to open":"Kliknite za otvaranje","No open polls":"Nema otvorenih anketa","Check back later to see if a poll opens up!":"Provjerite kasnije da vidite hoće li neka anketa biti otvorena!","Loading Poll":"Učitavanje ankete","Please wait while we fetch the polls":"Pričekajte dok ne dohvatimo ankete","Uh oh.. we couldn’t load the content":"Nismo mogli učitati sadržaj","Polls":"Ankete","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"Da biste pokrenuli anketu, dodajte pitanje i odgovore ovoj sesiji na Goldcast Admin Panelu","Stop Sharing":"Zaustavi dijeljenje","Can\'t publish polls while something else is being presented on stage":"Ankete se ne mogu objaviti dok se nešto drugo prikazuje na sceni","Open":"Otvori","Cancel your video q&a request":"Otkažite svoj zahtjev za video pitanja i odgovore","Pending...":"U tijeku...","Leave Stage":"Napusti scenu","Raise Hand":"Podigni ruku","Text Q&A":"Tekstualna pitanja i odgovori","Video Q&A":"Video pitanja i odgovori","Loading Q&amp;A":"Učitavanje pitanja i odgovora","Please wait while we fetch the Q&amp;A":"Pričekajte dok ne dohvatimo pitanja i odgovore","Uh oh.. we couldn\'t load the content":"Nismo mogli učitati sadržaj","No Questions Yet":"Još nema pitanja","Tell your audience to send in questions!":"Recite sudionicima da pošalju pitanja!","Be the first to ask a question!":"Budite prvi koji će postaviti pitanje!","Tell your audience to raise their hand!":"Recite sudionicima da podignu ruku!","Approve":"Odobri","Reject":"Odbij","End":"Kraj","RELOAD":"UČITAJ PONOVNO","Logos On Stage":"Logotipi na sceni","No File Chosen":"Nije odabrana nijedna datoteka","loading":"učitavanje u tijeku","Can\'t publish a slide when there is something else being presented on stage":"Nije moguće objaviti slajd kada se na pozornici prikazuje nešto drugo","Change Deck":"Promijeni razinu","stop-screen-share":"zaustavi dijeljenje zaslona","screen-share":"dijeljenje zaslona","Select a deck to begin presenting":"Odaberite razinu za početak prezentacije","CONFIRM":"POTVRDI","If you’re having issues, please refer to the":"Ako imate problema, pogledajte","SPEAKER":"ZVUČNIK","Issue Testing Audio!":"Problem s testiranjem zvuka!","VPN and adblockers may cause video issues, please disable them before proceeding":"VPN i programi za blokiranje oglasa mogu uzrokovati probleme s videom, onemogućite ih prije nastavka","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"Napominjemo da VPN i programi za blokiranje oglasa mogu uzrokovati probleme s videom pa ih svakako držite onemogućenima tijekom emitiranja","Follow":"Prati","Read More":"Pročitaj više","Ask a question":"Postavi pitanje","Shared":"Podijeljeno","Answered":"Odgovoreno","Waiting Approval":"Čeka se odobrenje","cancel":"odustani","ENTER":"PRIKLJUČI SE","Upcoming Events":"Nadolazeći događaji","Past Events":"Prošli događaji","Goldcast":"Goldcast","MANAGE EVENT":"UPRAVLJAJ DOGAĐAJEM","Edit Profile":"Uredi profil","Stay tuned!":"Ostanite s nama!","Sign-in instructions will be available here 12 hours prior to the event":"Upute za prijavu bit će dostupne ovdje 12 sati prije događaja","Please log out":"Molimo vas da se odjavite","Logout":"Odjava","Continue as {differentUser}":"Nastavite kao {differentUser}","You are already logged in as {user}.":"Već ste prijavljeni kao {user}.","EMAIL":"E-POŠTA","user@email.com":"user@email.com","FIRST NAME":"IME","First Name":"Ime","LAST NAME":"PREZIME","Last Name":"Prezime","You are not registered to this event":"Niste registrirani za ovaj događaj","Please enter your email and name":"Unesite svoju e-poštu i ime","Please enter your email":"Unesite svoju e-poštu","We have sent a secret code to":"Poslali smo tajnu šifru na","BACK":"NATRAG","Didn\'t receive an email? Make sure to check spam list":"Niste primili e-poruku? Obavezno provjerite neželjenu poštu","Resend Mail":"Ponovno pošalji e-poruku","SECRET CODE":"TAJNA ŠIFRA","Please enter the temporary password sent to your email":"Unesite privremenu lozinku koja vam je poslana na putem e-pošte","NEW PASSWORD":"NOVA LOZINKA","Please enter a new password":"Unesite novu lozinku","CONFIRM PASSWORD":"POTVRDI LOZINKU","Please re-enter the new password":"Ponovno unesite novu lozinku","Password length should be atleast 8":"Duljina lozinke mora biti najmanje 8","Password and Confirm Password don\'t match !!":"Lozinka i potvrda lozinke se ne podudaraju!!","Please enter your password to continue":"Unesite svoju lozinku za nastavak","Logging you in...":"Prijavljujemo vas...","PASSWORD":"LOZINKA","Forgot credentials?":"Zaboravili ste podatke za prijavu?","Forgot Password? A mail will be sent to your registered email.":"Zaboravili ste lozinku? E-poruka će biti poslana na vašu registriranu adresu e-pošte.","Email cannot be blank!!":"E-poruka ne može biti prazna!!","We have sent a secure login link to":"Poslali smo sigurnu poveznicu za prijavu na","from":"od","Please use that to access your event.":"Koristite ovo za pristup svom događaju.","Please check spam/promotion too if you can\'t find it.":"Ako je ne možete pronaći, također provjerite neželjenu poštu/promotivne poruke.","Thank You !":"Hvala vam!","The link is not valid.":"Poveznica nije valjana.","Please be patient.":"Molimo za strpljenje.","We are verifying your link.":"Provjeravamo vašu poveznicu.","Thank you for entering the code!":"Hvala što ste unijeli šifru!","Please create a new password":"Izradite novu lozinku","Signing you up...":"Registriramo vas...","We have sent a temporary password to":"Privremenu smo lozinku poslali na","TEMPORARY PASSWORD":"PRIVREMENA LOZINKA","Please enter the temporary password sent to your mail":"Unesite privremenu lozinku koja vam je poslana na putem e-pošte","Password Length should be 8":"Duljina lozinke mora biti 8","Okay":"U redu","Backstage: {title}":"Iza scene: {title}","Prep Area":"Područje za pripreme","Starting at {time}":"Počinje u {time}","person":"osoba","inside":"unutra","No one is inside":"Nitko nije unutra","This area is for you to sync up with your fellow speakers before you go on stage.":"Ovo područje služi za sinkronizaciju s kolegama govornicima prije nego izađete na scenu.","This area is for you to check your cam and mic before you enter the room.":"Ovo područje služi za provjeru kamere i mikrofona prije nego što uđete u sobu.","I\'m Ready":"Spreman sam","Watch Live":"Gledaj uživo","Backstage":"Iza scene","You are sharing your screen":"Dijelite svoj zaslon","LIVE":"UŽIVO","Live":"Uživo","Virtual":"Virtualno","Only available for ":"Dostupno samo za ","See Booths":"Pogledaj kabine","See Rooms":"Pogledaj sobe","Enter Backstage":"Otiđi iza scene","This track has no upcoming sessions. Check out a different track.":"Ova staza nema nadolazećih sesija. Pogledajte drugu stazu.","View":"Pogledaj","Agenda":"Dnevni red","Scroll to see all tracks":"Pomiči se za pregled svih staza","No Agenda Items to show!":"Nema točaka dnevnog reda za prikaz!","ENTER EVENT":"PRIKLJUČI SE DOGAĐAJU","change":"promijeni","Upload":"Učitaj","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF ILI PNG. MAKS. VELIČINA 5 MB","Create Profile":"Izradi profil","Email":"E-pošta","Company":"Tvrtka","Title":"Oslovljavanje","No matching locations found":"Nisu pronađene odgovarajuće lokacije","You can try searching for the location with another keyword":"Možete pokušati pronaći lokaciju pomoću druge ključne riječi","Interest Tags":"Oznake interesa","Pick your first tag":"Odaberite svoju prvu oznaku","Save":"Spremi","Searching...":"Pretraživanje u tijeku...","Twitter":"Twitter","Select Your First Tags":"Odaberite svoje prve oznake","Add Interest tags":"Dodaj oznake interesa","Congratulations!":"Čestitamo!","Your first Goldcast event is set up":"Vaš prvi Goldcast događaj je postavljen","You can always visit":"Uvijek možete posjetiti","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"za upute o tome kako postaviti i voditi svoje događaje","See My Event":"Pogledaj Moj događaj","Peak Community":"Peak Community","Loading Lite Mode... This may take up to 30s":"Učitavanje jednostavnog načina rada...To može potrajati do 30 sekundi","Loading Video...":"Učitavanje videozapisa...","Video will begin at session start time":"Videozapis će započeti u trenutku početka sesije","TIME":"VRIJEME","TITLE":"NASLOV","STATUS":"STATUS","END":"KRAJ","START":"POČETAK","AGENDA":"DNEVNI RED","Enable Audio":"Uključi zvuk","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"Zvuk je isključen zbog pravila automatske reprodukcije preglednika. Za uključivanje zvuka kliknite Omogući u nastavku. Zvuk također možete uključiti kasnije putem ugrađenih kontrola.","Enable":"Omogući","You are being redirected outside the room. Would you like to continue?":"Preusmjereni ste izvan sobe. Želite li nastaviti?","Continue":"Nastavi","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"Možete koristiti i jednostavni način rada, koji će imati odgodu od 30 sekundi od prijenosa uživo","We detected a network issue":"Otkrili smo problem s mrežom","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Uvjerite se da niste povezani putem VPN-a/vatrozida. Pokušajte promijeniti mrežu, preglednik ili uređaj ako se problem nastavi.","Could not connect":"Nije bilo moguće povezati se","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"To bi moglo biti zbog problema sa sigurnom mrežom, preglednikom ili uređajem. Pokušajte promijeniti mrežu, preglednik ili uređaj ako se problem nastavi.","Switch to Lite Mode":"Prebaci se na jednostavni način rada","Leave":"Izađi","Screenshare had an issue":"Pojavio se problem s dijeljenjem zaslona","Could not share screen unexpectedly. Refresh & retry. On mac go to":"Neočekivano dijeljenje zaslona nije uspjelo. Osvježi i pokušaj ponovno. Na Macu idite na","and check if your browser has the required permission":"i provjerite ima li vaš preglednik potrebnu dozvolu","Uh OH... Something went wrong":"Nešto nije bilo u redu.","To fix this, click the":"Da biste to popravili, kliknite","in your URL bar, then select “Allow”, and then click “Try Again”":"u URL traci, zatim odaberite \\"Dopusti\\" i konačno kliknite \\"Pokušaj ponovno\\"","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"Zbog nepoznatog razloga nije bilo moguće pokrenuti vaš medijski prijenos! Naša platforma možda ne podržava vaš preglednik. Preporučujemo korištenje programa \\"Google Chrome\\". Ako se ovaj problem nastavi, obratite se Goldcastovoj podršci","To fix this, make sure your":"Da biste to popravili, uvjerite se da","is not being accessed by any other app. If not, please try changing your":"neka druga aplikacija.Ako ne pristupa, pokušajte izmijeniti postavke svojih","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"uređajima klikom na \\"Idi na postavke\\". Nakon što riješite vjerojatni problem, pritisnite \\"Pokušaj ponovno\\"!","Go To Settings":"Idi na Postavke","Try Again":"Pokušaj ponovno","Try Joining without Video":"Pokušajte se pridružiti bez videa","A refresh and rejoin should work":"Osvježavanje i ponovno pridruživanje trebali bi funkcionirati","Refresh & Rejoin":"Osvježi i ponovno se pridruži","Start Chat":"Pokreni čavrljanje","On Stage":"Na sceni","Connect your on-site camera and microphone to present to your virtual attendees":"Povežite svoju kameru i mikrofon na licu mjesta kako biste mogli izvesti prezentaciju svojim virtualnim sudionicima","Stop Streaming":"Zaustavi prijenos","Start Streaming":"Započni prijenos","Set up on-site video feed":"Postavi video prijenos na licu mjesta","Open TV":"Otvori TV","Layout: {layout} ":"Izgled: {layout} ","With Speaker Videos":"S videozapisima govornika","Full Screen":"Puni zaslon","No Speakers":"Nema zvučnika","Turn Off Setup Mode":"Isključi način postavljanja","Setup Mode":"Način postavljanja","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"Pritisnite Isključi ako želite zaustaviti način postavljanja za {roomTitle}. Time ćete također isključiti sve aktivne prijenose.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"Priprema za prijenos: {roomTitle}. Način postavljanja koristite samo za prijenos s lokacija uživo.","Starting in {duration}":"Počinje za {duration}","Can\'t share screen while there is something else being presented on stage":"Nije moguće dijeliti zaslon dok se na sceni prikazuje nešto drugo","You are now in attendee view!":"Sada ste u prikazu sudionika!","You are now in organizer view!":"Sada ste u prikazu organizatora!","Note :":"Napomena:","Only organizer accounts can see this tag, normal attendees can’t see this":"samo računi organizatora mogu vidjeti ovu oznaku, standardni sudionici to ne mogu vidjeti","Attendee":"Sudionici","Event Information":"Informacije o događaju","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"Informacije o događaju vidljive su samo organizatorima! <br /> Ovaj odjeljak nije vidljiv sudionicima","Operating System":"Operacijski sustav","Secondary Booths":"Sekundarne kabine","Sort":"Sortiraj","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"Praćenje {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2} će automatski ukinuti vaše praćenje {track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}Želite li nastaviti?","Track only available for {tracks}":"Staza je dostupna samo za {tracks}","Add to Calendar":"Dodaj u Kalendar","Open Speakers Control Panel":"Otvori upravljačku ploču zvučnika","Move Offstage ↓":"Micanje se sa scene ↓","Error Moving ⚠":"Pogreška pri pomicanju ⚠","Off Stage":"Izvan scene","Move to Stage":"Prijeđi na scenu","An error occurred!":"Desila se pogreška!","{eventName} Documents":"Dokumenti događaja {eventName}"," Set Up Mode":" Način postavljanja","Camera & Mic blocked":"Kamera i mikrofon blokirani su","Camera/Mic Inaccessible":"Kamera/mikrofon nedostupan","Camera/Mic Not Found":"Kamera/mikrofon nije pronađen","Camera Inaccessible":"Kamera je nedostupna","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"Kamera je zauzeta ili razlučivanje nije podržano. Uvjerite se da vašu kameru ne koristi druga aplikacija i pokušajte ponovno!","No microphone/camera is found":"Nije pronađen mikrofon/kamera","The browser does not support using camera and microphone!":"Preglednik ne podržava korištenje kamere i mikrofona!","{n} Slides":"{n} slajdova","Starting in {timeduration}":"Počinje za {timeduration}","{eventtitle} has ended":"Događaj {eventtitle} završio je","This is a text q&a question!":"Ovo je tekstualno pitanje!","Click here{if_it_does_not}":"Kliknite ovdje {if_it_does_not}","{click_here}if it does not":"{click_here} ako se to ne desi","{title}up next":"{title}sljedeći","seat(s) open":"otvoreno sjedalo/sjedala","Signal strength is low. Close other windows or connect to a different network.":"Jačina signala je mala. Zatvorite druge prozore ili se povežite na drugu mrežu.","GO BACKSTAGE":"IDI IZA SCENE","LEAVE STAGE":"NAPUSTI SCENU","LEAVE":"NAPUSTI","This event begins on{startitme}":"Ovaj događaj počinje u {startitme}","Please refresh to enter.":"Osvježite za ulazak.","people":"osobe","Oops, Something went wrong":"Nešto nije bilo u redu","Back Home":"Natrag na početnu","Deciding where to go ...":"Odlučivanje kamo ići...","Go to Event Hub":"Idi na Središte događaja","CREATE":"IZRADI","Attending Virtually":"Virtualno sudjelovanje","Attending In Person":"Fizičko sudjelovanje","Click to change your attendance type":"Kliknite za promjenu vrste prisutnosti","Open Chat":"Otvori čavrljanje","Create your profile for {eventtitle}":"Izradite svoj profil za {eventtitle}","Move to stage":"Prijeđi na scenu","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"Organizator događaja je zatražio da vas premjesti na scenu za <strong>{broadcastTitle}</strong>.<br /><br />Ako kliknete prihvaćanje zahtjeva, bit ćete uživo i vidljivi sudionicima događaja.<br /><br />","Go Live On Stage":"Idi uživo na scenu","Moved to backstage":"Premješteno iza scene","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"Organizator vas je uklonio sa scene. Molimo vas da se ne pokušavate ponovno pridružiti bez kontaktiranja organizatora.","Error creating Screen stream":"Pogreška pri stvaranju prijenosa prikaza na zaslonu","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"Dopuštenje za dijeljenje zaslona nije dodijeljeno. *Kliknite ovdje* da biste pregledali dokumente za rješavanje problema.","Error publishing stream":"Pogreška pri objavi prijenosa","Could not publish stream. Please refresh and try again!":"Nije bilo moguće objaviti prijenos. Osvježite i pokušajte ponovno!","Error publishing screen":"Pogreška pri objavi zaslona","Error publishing screen. Please refresh and try again!":"Pogreška pri objavi zaslona Osvježite i pokušajte ponovno!","Error unpublishing stream":"Pogreška pri prestanku objave prijenosa","Error unpublishing stream. Please refresh and try again!":"Pogreška pri prestanku objave prijenosa Osvježite i pokušajte ponovno!","Invalid Publish Operation":"Nevažeća operacija objavljivanja","{username} profile picture":"{username}: profilna slika","Default":"Zadano","A-Z":"A do Z","Random":"Nasumično","All":"Sve","Past":"Prošlo","Upcoming":"Nadolazeće","Learn More":"Saznaj više","close":"zatvori","Discussion Rooms":"Sobe za rasprave","ATTENDEE MODE":"NAČIN RADA SUDIONIKA","Loading...":"Učitavanje...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"Uređaj je onemogućen od strane preglednika ili nisu pružena dopuštenja za korištenje. Pružite dopuštenja i kliknite \\"Pokušaj ponovno\\"","You are now registered. You will receive an email confirming details shortly.":"Sada ste registrirani. Uskoro ćete primiti e-poruku s potvrdom pojedinosti.","Streaming to Virtual Users from on-site video feed":"Video prijenos virtualnim korisnicima s lica mjesta","Ending in ":"Završava za ","GO LIVE":"NA UŽIVO","You have no past events.":"Nemate prošlih događaja.","You have no upcoming or live events.":"Nemate nadolazećih događaja ili događaja uživo.","left":"lijevo","center":"sredina","right":"desno","top":"vrh","bottom":"dno","loading...":"učitavanje...","Loading ...":"Učitavanje...","Failed to redirect!":"Preusmjeravanje nije uspjelo!","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"Čini se da imate uključen program za blokiranje oglasa. To bi vas moglo spriječiti u najboljem doživljaju događaja. Molimo vas da ga onemogućite. <br />&lt;br/&gt;Ako trebate pomoć kako to učiniti, kliknite <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>ovdje</a> za daljnje upute.","redirecting in {duration}":"preusmjeravanje za {duration}","STOP VIDEO":"ZAUSTAVI VIDEO","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"Upravo ćete zaustaviti reprodukciju ovog videozapisa. Vaše će se emitiranje vratiti u način rada uživo i vaša će publika (sudionici) vidjeti i čuti vaše zvučnike. Jeste li sigurni?","STOP SHARING":"ZAUSTAVI DIJELJENJE","No Next Slide":"Nema sljedećeg slajda","Next Slide":"Sljedeći slajd","No Previous Slide":"Nema prethodnog slajda","Previous Slide":"Prethodni slajd","something went wrong while recording the response please try again":"Nešto nije bilo u redu tijekom snimanja odgovora; pokušajte ponovno","Start In-Person Streaming":"Započni osobni prijenos","Stop In-Person Streaming":"Zaustavi osobni prijenos","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Vaš se videozapis sprema u međuspremnik i uskoro će započeti testna sesija . To se neće dogoditi tijekom stvarne sesije.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"Pomična poruka pojavit će se na vrhu web stranice za sve sudionike. Za pretvaranje pomične poruke u poveznicu, unesite URL u nastavku","Allow {key}":"Dopusti {key}","{messageType} can only be published from inside a broadcast.":"{messageType} se može objaviti samo unutar emitiranja.","To grant {deviceName} access to this page, follow the two steps below:":"Da biste uređaju {deviceName} odobrili pristup ovoj stranici, slijedite dva koraka u nastavku:","2. Allow {deviceName} access and then refresh the page.":"2. Dopustite uređaju {deviceName} pristup i zatim osvježite stranicu."}');

/***/ }),

/***/ 5744:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Menu a discesa delle impostazioni degli eventi"," Stage Control":" Controllo del palco","Stage Controls and Information":"Controlli e informazioni sul palco","Live in ":"Live tra ","Start Session":"Avvia sessione","End Session":"Termina sessione","Present Screen":"Presenta schermo","Rehearse On Stage":"Prova sul palco","Turn on Microphone":"Attiva il microfono","Turn off Microphone":"Disattiva il microfono","Turn on camera":"Accendi la fotocamera","Turn off camera":"Spegni la fotocamera","rehearsal mode":"modalità prova","People Watching: ${watchCount}":"Persone che guardano: ${watchCount}","Turn on Audio":"Attiva l\'audio","Turn off Audio":"Disattiva l\'audio","Are you sure you want to leave this room?":"Vuoi davvero uscire da questa stanza?","you will be redirected to stage in":"ti reindirizzeremo al palco tra","sec. . ":"sec. . ","Skip to Main Navigation":"Passa alla navigazione principale","Skip to Chat":"Passa alla chat","Skip to Meeting Controls":"Passa ai controlli della riunione","LinkedIn":"LinkedIn","Live in":"In diretta tra","UPCOMING":"Prossimi","Rehearse on stage":"Prova sul palco","Watch Rehearsal":"Guarda le prove","Answered by:":"Risposta da:","Speaker Off":"Altoparlante spento","Speaker On":"Altoparlante acceso","Speaker Controls":"Controlli degli altoparlanti","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"Tutti gli elementi dello stage sono presenti dietro l\'immagine condivisa. Saranno di nuovo visibili una volta interrotta la condivisione dell\'immagine a schermo intero.","Close Ticker Popup":"Chiudi popup ticker","Open GIF Picker":"Apri selezionatore di GIF","Open Emoji Picker":"Apri selezionatore di emoji","Send Message":"Invia messaggio","Tabs: Messaging and More":"Schede: Messaggi e molto altro","Thanks for attending!":"Grazie per aver partecipato!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" Nessuna sessione imminente nella traccia a cui sei iscritto. Passa ad altre tracce per visualizzare le sessioni live","Redirecting you to ":"Reindirizzamento a ","in ":"tra ","seconds":"secondi","Main Navigation":"Navigazione principale","YOU ARE HERE":"SEI QUI","Live Now":"Live ora","SUBMIT":"INVIA","Allocated time for engagement has ended. You will be redirected to main stage":"Il tempo assegnato per il coinvolgimento è scaduto. Ti reindirizzeremo al palco principale","Wrap up in":"Termina tra","Session overrun by":"Tempo della sessione superato di","Ending in":"Termina tra","Bring this session live?":"Portare questa sessione live?","START SESSION":"AVVIA SESSIONE","Bring this session to end?":"Terminare questa sessione?","END SESSION":"TERMINA SESSIONE","Go On Stage":"Vai sul palco","Muted by organizer":"Audio disattivato dall\'organizzatore","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"Uno degli organizzatori dell\'evento ha disattivato il tuo audio. Puoi riattivarlo facendo clic sul pulsante del microfono.","Gifs":"Gif","Stickers":"Sticker","Launch Survey":"Avvia sondaggio","Microphone is on":"Il microfono è acceso","Microphone is off":"Il microfono è spento","Secret Code’s length should be 6 digits":"La lunghezza del codice segreto deve essere di 6 cifre","Closing in 00:":"Chiude tra 00:","Submit":"INVIA","Questions":"Domande","Preview":"Anteprima","Close Survey":"Chiudi sondaggio","This is a required question":"Questa è una domanda obbligatoria","Enter the text you’d like to present on stage below.":"Inserisci il testo che vorresti\\n presentare sul palco qui sotto.","Use Chrome/Edge for best performance":"Usa Chrome/Edge per ottenere le prestazioni migliori","Do you want to launch your survey now?":"Vuoi avviare il tuo sondaggio adesso?","Success! Your Survey has been launched for attendees.":"Fatto! Il tuo sondaggio è ora aperto ai partecipanti.","Unable to publish. Please try again.":"Impossibile pubblicare. Riprova.","Are you sure you want to close this survey?":"Vuoi davvero chiudere questo sondaggio?","Success! Your Survey has been closed for attendees.":"Fatto! Il tuo sondaggio è stato chiuso ai partecipanti.","Unable to un-publish. Please try again.":"Impossibile annullare la pubblicazione. Riprova.","Please answer all required questions.":"Rispondi a tutte le domande obbligatorie.","You have already submitted this survey.":"Hai già inviato questo sondaggio.","Success! Thank you for your feedback.":"Fatto! Grazie per il tuo feedback.","Unable to submit. Please try again.":"Impossibile inviare. Riprova.","Launch surveys will take over attendees\' engagement panel.":"Quando si avvia un sondaggio, questo coprirà pannello di coinvolgimento dei partecipanti.","Closing this survey will remove it from attendees\' engagement panel.":"Se chiudi questo sondaggio verrà rimosso dal pannello di coinvolgimento dei partecipanti.","Survey":"SONDAGGIO","Updating Survey...":"Aggiornamento sondaggio in corso...","Closing":"Chiusura in corso","Goldcast needs access to your camera and microphone":"Goldcast ha bisogno di accedere alla tua fotocamera e al tuo microfono","Goldcast needs access to your microphone":"Goldcast ha bisogno di accedere al tuo microfono","Goldcast needs access to your camera":"Goldcast ha bisogno di accedere alla tua fotocamera","SPEAKERS":"Relatori","Mark as Unanswered":"Segna come senza risposta","Mark as Answered":"Segna come risposta","Remove from Priority":"Rimuovi dalla priorità","Mark as Priority":"Segna come priorità","Answer":"RISPONDI","Enter answer...":"Inserisci risposta...","Answered by":"Risposta da","Submit Answer":"Invia risposta","Test your system’s speaker":"Prova l\'altoparlante del tuo sistema","Click \\"Yes\\" if you hear the sound.":"Fai clic su \\"Sì\\" se senti il suono.","Load previous":"Carica precedente","Hide Name":"Nascondi nome","Text Q&A is disabled in On Demand mode.":"Le domande e le risposte scritte sono disabilitate in modalità On Demand.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"Raggiunto il limite di domande e risposte scritte. I partecipanti non potranno fare nuove domande.","Sent to Q&A":"Inviato a Domande e risposte","Couldn\'t post as Q&A. Please try again.":"Impossibile pubblicare come Domande e risposte. Riprova.","Yes this is being recorded":"Sì, questo viene registrato","No this is not being recorded":"No, questo non viene registrato","System\'s Speaker Check":"Controllo altoparlanti del sistema","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"Per assicurarti di riuscire ad ascoltare durante l\'evento, verifica che gli altoparlanti del tuo sistema funzionino correttamente","Click on “Test your system’s speaker” to proceed":"Fai clic su \\"Prova l\'altoparlante del tuo sistema\\" per procedere","Error while sharing message to screen. Post not found":"Errore durante la condivisione del messaggio sullo schermo. Post non trovato","Lost connection to servers. Refresh your page to get live event experience.":"Connessione ai server interrotta. Aggiorna la tua pagina per vivere l\'esperienza di un evento dal vivo.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"La VPN o il firewall interferiscono con l\'autenticazione. Cambia rete o mettiti in contatto con il tuo team IT per consentire a <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>questi domini</a> di accedere a Goldcast senza problemi.","It\'s taking too long":"L\'operazione sta impiegando troppo tempo","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"Sembra che tu abbia una connessione tramite VPN o che il firewall sia attivato. Fai riferimento a questo <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>documento di aiuto</a> e alla whitelist dei domini richiesti affinché Goldcast funzioni correttamente oppure dovrai cambiare rete","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"Sembra che tu abbia una connessione tramite VPN o che il firewall sia attivato. Fai riferimento a questo <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>documento di aiuto</a> e alla whitelist dei domini richiesti affinché Goldcast funzioni correttamente oppure dovrai cambiare rete o guardare la sessione in modalità Lite","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"Il servizio di streaming video Goldcast non è in grado di connettersi a causa della scarsa larghezza di banda della rete. Cambia rete per connetterti al servizio di streaming live.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"Il servizio di streaming video Goldcast non è in grado di connettersi a causa della scarsa larghezza di banda della rete. Passa alla modalità Lite o cambia rete per connetterti al servizio di streaming","Most Upvotes":"Maggior numero di voti positivi","Most Recent":"Più recenti","My Questions":"Le mie domande","Prioritized":"Con priorità","Approved":"Approvata","Unapproved":"Non approvata","Unanswered":"Senza risposta","Failed to update answer. Please try again!":"Impossibile aggiornare la risposta. Riprova.","Failed to post answer. Please try again!":"Impossibile pubblicare la risposta. Riprova.","Failed to delete question. Please try again!":"Impossibile eliminare la domanda. Riprova.","Survey Link":"Link al sondaggio","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"Se cambi, la pagina corrente verrà ricaricata nella vista partecipante. Per tornare alla visualizzazione organizzatore, disattiva la visualizzazione partecipanti nel menu a discesa del profilo.","You haven\'t asked any questions yet":"Non hai ancora fatto nessuna domanda","No prioritized questions":"Nessuna domanda prioritaria","Create prioritized list of questions for speakers by marking questions as priority":"Crea un elenco di domande prioritarie per i relatori contrassegnando le domande come priorità","No Approved Questions":"Nessuna domanda approvata","Approve incoming questions to see list of approved questions":"Approva le domande in arrivo per visualizzare l\'elenco delle domande approvate","No Unapproved Questions":"Nessuna domanda non approvata","No Answered Questions":"Nessuna domanda con risposta","Answer a question on stage or with inline text":"Rispondi a una domanda sul palco o con testo incorporato","All questions are answered":"Tutte le domande hanno ricevuto una risposta","Rate Your Experience":"Valuta la tua esperienza","How satisfied are you with Goldcast?":"Quanto ti soddisfa Goldcast?","What are the main reasons for your rating?":"Quali sono i motivi principali della tua valutazione?","I am interested in seeing a demo of Goldcast":"Mi interessa vedere una demo di Goldcast","Thank You":"Grazie","Your feedback was successfully submitted.":"Il tuo feedback è stato inviato correttamente.","Tell us how we can improve...":"Spiegaci come possiamo migliorare...","1 Slide":"1 diapositiva","Your internet connection is unstable.":"La tua connessione a Internet è instabile.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"Sembra che il tuo microfono non sia attivo. Fai clic sull\'icona del microfono per attivare l\'audio","The registration could not be completed! Please check that this email is allowed to register for the event.":"Impossibile completare la registrazione. Verifica che questa email sia autorizzata a registrarsi all\'evento.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Sembra che tu abbia già effettuato la registrazione per questo evento. Se non hai ricevuto la conferma della registrazione, controlla la tua cartella di spam. Se hai bisogno di ulteriore assistenza, contatta l\'organizzatore dell\'evento.","Your registration could not be completed. This event has reached its registration capacity.":"Impossibile completare la registrazione. Questo evento ha raggiunto il limite massimo di registrazioni.","Image cannot be an svg":"L\'immagine non può essere in formato svg","This should be a valid linkedin url":"Deve essere un URL Linkedin valido","This should be a valid twitter url":"Deve essere un URL Twitter valido","This should be a valid url":"Deve essere un URL valido","Video":"video","Read Less":"Leggi meno","live":"LIVE","Opened":"Aperto","In person only":"Solo di persona","Stage Stream":"Flusso di fase","Streaming not available":"Streaming non disponibile","Close TV":"Chiudi TV","Streaming is not available for prerecorded and RTMP sessions":"Lo streaming non è disponibile per le sessioni preregistrate e RTMP","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Collega il tuo computer a uno schermo TV o a un proiettore per consentire ai partecipanti presenti di persona di vedere cosa sta succedendo sul palco virtuale, compresi slide, domande e risposte, ecc. Una volta effettuato il collegamento, fai clic su APRI TV e trascina o condividi la nuova finestra sullo schermo del televisore o sul proiettore. ","Close Setup Mode":"Chiudi modalità di configurazione","Help":"Aiuto","upcoming":"Prossimi","ended":"Finito","Remove from favorites":"Rimuovi dai preferiti","Add to favorites":"Aggiungi ai preferiti","PLAY RECORDING":"Riproduci registrazione","VIEW RECORDING":"VISUALIZZA REGISTRAZIONE","VIEW RECORDINGS":"VISUALIZZA REGISTRAZIONI","Virtual Backgrounds":"Sfondi virtuali","No Device Available":"Nessun dispositivo disponibile","Needs permission":"Richiede l\'autorizzazione","Device not detected":"Dispositivo non rilevato","Camera is on":"La fotocamera è accesa","Camera is off":"La fotocamera è spenta","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"Il video con mirroring non si riflette sugli spettatori. Gli spettatori vedono sempre il video senza mirroring","Mirror My Video":"Esegui il mirroring del mio video","Camera":"FOTOCAMERA","1. Click on Safari > Settings for this\\n            website":"1. Fai clic su Safari > Impostazioni per questo sito web","1. Click the lock":"1. Fai clic sull\'icona del lucchetto","icon in your browser’s address bar":"nella barra degli indirizzi del browser","3. Unmute":"3. Attiva l\'audio","and":"e","icons from stage control panel":"icone dal pannello di controllo del palco","icon from stage control panel":"icona dal pannello di controllo del palco","2. Set camera and microphone to “Allow”.":"2. Imposta la fotocamera e il microfono su \\"Consenti\\".","2. Set camera to “Allow”.":"2. Imposta la fotocamera su \\"Consenti\\".","2. Set microphone to \\"Allow\\"":"2. Imposta il microfono su \\"Consenti\\"","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. Scegli \\"Consenti sempre a Goldcast di accedere alla fotocamera e al microfono\\"","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. Scegli \\"Consenti sempre a Goldcast di accedere alla fotocamera\\".","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. Scegli \\"Consenti sempre a Goldcast di accedere al microfono\\"","Questions?":"Domande?","If you’re having issues, check out our comprehensive":"In caso di problemi, consulta la nostra","help docs":"guida completa","Speaker is on":"L\'altoparlante è attivo","Stop Test":"Interrompi test","Test your system’s audio":"Testa l\'audio del sistema","Still can\'t hear any sound?":"Non riesci ancora a sentire alcun suono?","Microphone":"MICROFONO","Audio is being played in system\'s default audio device.":"L\'audio viene riprodotto nel dispositivo audio predefinito del sistema.","Click to view/change audio device":"Fai clic per visualizzare/modificare il dispositivo audio","Speaker":"ALTOPARLANTE","Play Recording":"Riproduci registrazione","Recording for this broadcast is currently being processed and will be available soon":"La registrazione per questa trasmissione è in fase di elaborazione e sarà disponibile a breve","You haven\'t favorited anything yet!":"Non hai ancora aggiunto alcun elemento tra i preferiti.","Add an item to favorites by selecting the ♡ in the top right corner.":"Aggiungi un elemento ai preferiti selezionando il ♡ nell\'angolo in alto a destra.","Session has ended":"La sessione è terminata","System Check":"Controllo del sistema","Need help? Check out the":"Hai bisogno di aiuto? Dai un\'occhiata qui:","Skip Checks and Continue":"Salta le verifiche e continua","Click the button above to run the test":"Fai clic sul pulsante in alto per eseguire il test","Test Screenshare":"Prova la condivisione dello schermo","Share message to stage":"Condividi il messaggio sullo stage","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"Inserisci il testo che desideri utilizzare per il ticker qui sotto. Per trasformare il ticker in un collegamento ipertestuale, inserisci un URL.","Ticker":"Ticker","Coffee Break! Be back in 10m.":"Pausa caffè! Ci vediamo tra 10 min.","Enter Message":"Inserisci messaggio","https://www.xyz.com":"https://www.xyz.com","Launch":"Lancio","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Grazie per aver inviato le tue domande. Potrai inviarne un\'altra dopo che una di quelle attuali sarà stata approvata.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"Siamo spiacenti, il controllo qualità è attualmente disabilitato. Sarai in grado di inviare una domanda dopo che il servizio sarà nuovamente abilitato.","Votes":"Voti","Vote":"Vota","is inviting you to a video call":"ti sta invitando a una videochiamata","ENTER ROOM":"ENTRA NELLA STANZA","Start the conversation!":"Inizia la conversazione!","Couldn\'t send message. Click here to retry.":"Impossibile inviare il messaggio. Fai clic qui per riprovare.","Couldn\'t add emoji. Please try again.":"Impossibile aggiungere emoji. Riprova.","Couldn\'t remove emoji. Please try again.":"Impossibile rimuovere emoji. Riprova.","Couldn\'t delete message. Please try again.":"Impossibile eliminare il messaggio. Riprova.","Couldn\'t pin message. Please try again.":"Impossibile bloccare il messaggio. Riprova.","Couldn\'t unpin message. Please try again.":"Impossibile sbloccare il messaggio. Riprova.","Today":"Oggi","No messages yet":"Non ci sono ancora messaggi","Messages from organizers and speakers appear here!":"I messaggi degli organizzatori e dei relatori vengono visualizzati qui.","Next Session is Starting":"La prossima sessione è in fase di avvio","Go to Next Session":"Vai alla prossima sessione","I’d like to stay":"Vorrei restare","My favorites":"I miei preferiti","1. Click on the lock icon in your address bar":"1. Fai clic sull\'icona del lucchetto nella barra degli indirizzi","We recommend organizers and speakers use a desktop\\n        device":"Consigliamo agli organizzatori e ai relatori di utilizzare un\\ndispositivo desktop","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"Per garantire la migliore esperienza ai partecipanti, è necessario che i relatori e gli organizzatori utilizzino Goldcast da un dispositivo desktop. Se si trasmette da un dispositivo mobile,\\nl\'esperienza sarà di bassa qualità.","Watch Now":"Guarda ora","Video progress time":"Tempo di avanzamento del video","Total video duration":"Durata totale del video","Rate Goldcast!":"Valuta Goldcast","Running Required Checks...":"Esecuzione dei controlli obbligatori...","Test Your Setup":"Prova la tua configurazione","Test your Computer Device, Microphone and Camera before you join the event":"Prova il tuo computer, il microfono e la fotocamera prima di partecipare all\'evento","Speaker and microphone not working?":"Altoparlante e microfono non funzionano?","Passed":"Operazione completata","Fix Audio Issues":"Risolvi problemi audio","Check if audio is being played in other sound devices connected to phone/tablet":"Verifica se l\'audio viene riprodotto su altri dispositivi audio collegati al telefono/tablet","Check if correct audio device is chosen from the below dropdown":"Controlla se è stato scelto il dispositivo audio corretto dal menu a discesa in basso","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>Fai clic qui</a> per verificare se è selezionato il dispositivo audio corretto in cui riprodurre l\'audio","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Fai clic qui</a> per verificare se è selezionato il dispositivo audio corretto in cui riprodurre l\'audio","Right click on the browser tab & click “Unmute Site”":"Fai clic con il pulsante destro del mouse sulla scheda del browser, quindi fai clic su \\"Attiva audio del sito\\"","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Controlla se la scheda del browser è attiva o fai clic su Finestra > Riattiva questa scheda","System Check Failed!":"Controllo di sistema non riuscito.","System Check Passed!":"Controllo di sistema superato.","Complete checks to proceed":"Completa i controlli per continuare","Enter Event":"PARTECIPA ALL\'EVENTO","Skip Screen Sharing Check? ":"Saltare il controllo della condivisione dello schermo? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"Ti consigliamo di completare il controllo della condivisione dello schermo e verificare se lo schermo deve essere presentato durante l\'evento","Ignore & Enter Event":"Ignora e partecipa all\'evento","Test screenshare":"Prova la condivisione dello schermo","Retry Now":"Riprova ora","SHARE":"Condividi","Rooms Closed":"Stanze chiuse","Discussion rooms are now closed. You are being redirected to the Stage.":"Le stanze di discussione sono ora chiuse. Stiamo per reindirizzarti al palco.","Return To Stage":"TORNA AL PALCO","Unrecognized embedded widget provider - ":"Provider di widget incorporati non riconosciuto - ","Room Ended":"Stanza terminata","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"L\'organizzatore del tuo evento ha chiuso tutte le stanze. Stiamo per reindirizzarti al palco dell\'evento.","Video Q&A Request Cancelled":"Richiesta di domande e risposte video annullata","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"La tua richiesta di domande e risposte video è stata annullata perché stai utilizzando la modalità Lite. Passa alla modalità Live per alzare nuovamente la mano.","Camera Passed":"Fotocamera approvata","Camera Error":"Errore fotocamera","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"Il browser non concede le autorizzazioni per la fotocamera. Fai clic su \\"Consenti fotocamera\\".","Camera permissions aren’t granted from system. Click “Allow Camera”":"Il sistema non concede le autorizzazioni per la fotocamera. Fai clic su \\"Consenti fotocamera\\"","Uh-oh! Error occurred while creating camera stream":"Si è verificato un errore nella creazione del flusso video della fotocamera","Close other applications which might use camera stream":"Chiudi le altre applicazioni che potrebbero utilizzare il flusso video della fotocamera","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>Fai clic qui</a> per verificare se il browser ha accesso alla fotocamera","Microphone Passed":"Test del microfono superato","Microphone Error":"Errore microfono","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"Il browser non concede le autorizzazioni per il microfono. Fai clic su \\"Consenti microfono\\"","Mic permissions aren’t granted from system. Click “Allow Microphone”":"Il sistema non concede le autorizzazioni per il microfono. Fai clic su \\"Consenti microfono\\"","Uh-oh! Error occurred while creating mic stream":"Si è verificato un errore nella creazione del flusso audio del microfono","Close other applications which might use mic stream":"Chiudi le altre applicazioni che potrebbero utilizzare il flusso audio del microfono","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>Fai clic qui</a> per verificare se il browser ha accesso al microfono","Speaker and Microphone Error":"Errore altoparlante e microfono","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"Le autorizzazioni del microfono sono necessarie per mostrare l\'elenco degli altoparlanti collegati al sistema. Fai clic su \\"Consenti microfono\\"","It seems mic is being used by other application. Close other applications to proceed.":"Sembra che il microfono sia utilizzato da un\'altra applicazione. Chiudi le altre applicazioni per procedere.","Camera & Microphone Error":"Errore fotocamera e microfono","To enable permissions, click the Allow Camera & Mic button below":"Per abilitare le autorizzazioni, fai clic sul pulsante Consenti fotocamera e microfono in basso","Network Connection":"Connessione di rete","Check Passed":"Controllo superato","Could not establish a network connection":"Impossibile stabilire una connessione di rete","Connect to a different network, or use a mobile hotspot.":"Connettiti a una rete diversa o utilizza un hotspot mobile.","Disable any VPN or firewall is connected.":"Disattiva qualsiasi VPN o firewall collegati.","Connection: Good":"Connessione: buona","Network Connection Error":"Errore di connessione di rete","Can’t connect to network. Change your network or limited functionality will be available during event.":"Impossibile connettersi alla rete. Cambia rete per evitare che le funzionalità siano limitate durante l\'evento.","AdBlocker":"AdBlocker","AdBlocker not detected.":"AdBlocker non rilevato.","AdBlocker detected. This may degrade your event experience.":"Rilevato un blocco annunci. Ciò potrebbe compromettere l\'esperienza dell\'evento.","Disable adblocker for best experience.":"Disabilita il blocco annunci per un\'esperienza ottimale.","You are using ":"Tu stai usando ","Use Windows or Mac OS for best performance":"Utilizza Windows o Mac OS per prestazioni ottimali","Browser Check":"Controllo del browser","Check Passed.":"Controllo superato.","Switch To Lite Mode":"Passa alla modalità Lite","Your pending Video Q&A request will be cancelled once you switch to lite mode":"La tua richiesta di domande e risposte video in sospeso verrà annullata quando passi alla modalità Lite","Stay on Live Mode":"Rimani in modalità Live","Unable to mark as favorite":"Impossibile contrassegnare come preferito","Event organizers must enter the event to select favorites.":"Gli organizzatori di eventi devono inserire l\'evento per selezionare i preferiti.","Make an Announcement":"Fai un annuncio","STOP":"STOP","InPerson CheckIn App":"App per la registrazione di persona","App to Check-In In-Person attendees":"App per registrare i partecipanti di persona","SEE AGENDA":"Vedi programma","Please visit the Agenda tab to view the session recordings":"Visita la scheda Programma per visualizzare le registrazioni della sessione","The session recordings will be available soon in the Agenda tab":"Le registrazioni della sessione saranno disponibili a breve nella scheda Programma","FAILED!":"OPERAZIONE NON RIUSCITA","Next session is beginning":"Inizia la prossima sessione","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"Vuoi passare alla prossima sessione? Lo streaming continuerà e la TV trasmetterà la nuova sessione.","Banners":"Banner","Images":"Immagini","Screen Share":"Condivisione schermo","Browser might not have screen-recording permission on your computer.":"Il browser potrebbe non disporre dell\'autorizzazione per la registrazione dello schermo sul tuo computer.","Open System Preferences":"Apri Preferenze di sistema","Error publishing screen because someone else started screen share already.":"Errore durante la pubblicazione della schermata perché un altro utente ha già avviato la condivisione dello schermo.","Live Feed":"Feed live","Check Your Network":"Controlla la tua rete","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"Si è verificato un errore durante la riproduzione del video. Se riscontri problemi con la riproduzione del video, prova ad aggiornare la pagina o a passare alla modalità Lite.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"Si è verificato un errore durante la riproduzione del video. Se si verificano problemi con la riproduzione del video, prova ad aggiornare la pagina.","All Dates":"Tutte le date","All Tracks":"Tutte le tracce","Create Ticker":"Crea ticker","Booths Closed":"Stand chiusi","Your event organizer has closed all the booths. You will now be redirected to the stage":"L\'organizzatore del tuo evento ha chiuso tutti gli stand. Ti reindirizzeremo al palco","Visit the Polls tab to view live results.":"Visita la scheda Sondaggi per visualizzare i risultati in tempo reale.","A new poll is open! Visit the Polls tab to vote.":"È stato creato un nuovo sondaggio. Visita la scheda Sondaggi per votare.","Vote for Polls":"Vota per sondaggi","Go to Polls Tab":"Vai alla scheda sondaggi","Microphone audio too low":"Audio microfono troppo basso","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"Abbiamo rilevato un problema con l\'audio. Ti consigliamo di provare a disattivare/annullare l\'audio o utilizzare un altro dispositivo se il problema persiste.","Audio/Video bitrate too low":"Bitrate audio/video troppo basso","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"Le impostazioni del firewall di rete bloccano la trasmissione audio/video. Ti consigliamo di passare a una connessione di rete diversa.","Error sharing screen":"Errore nella condivisione dello schermo","A network error occurred while sharing screen. Please check your network connection.":"Si è verificato un errore di rete durante la condivisione dello schermo. Controlla la tua connessione di rete.","Apologies, due to some errors, we need to refresh the page!":"Spiacenti, a causa di alcuni errori dobbiamo aggiornare la pagina.","Warning":"Avvertimento","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"Abbiamo rilevato un problema con il video. Per risolverlo, ti consigliamo di chiudere le altre schede del browser o le altre applicazioni in esecuzione sul tuo dispositivo e controllare/aggiornare la connessione a Internet.","No results found":"Nessun risultato trovato","Audio":"audio","Please choose another microphone and camera":"Scegli un altro microfono e un\'altra fotocamera","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"Il microfono e la fotocamera attualmente selezionati non funzionano. Scegli un altro microfono e una fotocamera dai menu a discesa qui sotto.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"La fotocamera attualmente selezionata non funziona. Scegline un\'altra nel menu a discesa in basso.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"Puoi continuare senza fotocamera, ma ti consigliamo di risolvere il conflitto per garantire un\'esperienza di trasmissione più fluida.","Please choose another microphone":"Scegli un altro microfono","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"Il microfono attualmente selezionato non funziona. Scegline un altro nel menu a discesa qui sotto.","Please check that your TV speaker is correct":"Verifica che l\'altoparlante della tua TV sia corretto","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"L\'altoparlante attualmente selezionato non funziona. Scegline un altro nel menu a discesa qui sotto.","Your answer":"La tua risposta","Edit":"Modifica","Delete":"Elimina","Settings":"Impostazioni","Signing Out":"Disconnessione in corso","Confirming your account...":"Conferma dell\'account in corso...","Something Went Wrong. Please Retry :(":"Si è verificato un problema. Riprova :(","Resending Mail":"Nuovo invio dell\'email","offline":"offline","I am inviting you to a video meeting:":"Ti sto invitando a una riunione video:","Resending secure login link to your email":"Nuovo invio del link di accesso sicuro alla tua e-mail","Sending secure login link to your email":"Invio di un link di accesso sicuro alla tua e-mail","Something went Wrong. Please Retry :(":"Si è verificato un problema. Riprova :(","Updating your password":"Aggiornamento della password","Sending mail":"Invio dell\'e-mail","Verifying":"Verifica","This might be slower than usual":"Potrebbe essere più lento del solito","Checking":"Controllo","New results available! Refresh!":"Nuovi risultati disponibili. Aggiorna.","Saving":"Salvataggio","Turn off Attendee mode":"Disattiva la modalità partecipante","See Attendee View":"Visualizza la vista partecipanti","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Numero totale di partecipanti che stanno visualizzando questa sessione. Nota: riservato all\'organizzatore","Session Count":"Conteggio sessioni","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"Il numero di partecipanti che attualmente visualizzano le sessioni dal vivo. Nota: riservato all\'organizzatore","Role":"Ruolo","Total Attendees":"Totale partecipanti","Total number of attendees online at this time Note: This is for organizer eyes only":"Numero totale di partecipanti online in questo momento. Nota: riservato all\'organizzatore","My Profile":"Il mio profilo","Languages":"Lingue","Filling out your profile can help you connect with people with similar interests.":"Compilare il tuo profilo può aiutarti a connetterti con persone con interessi simili.","type to search for your address":"digita per cercare il tuo indirizzo","Could not open direct call":"Impossibile aprire la chiamata diretta","Chat messages can only be published from inside a broadcast.":"I messaggi di chat possono essere pubblicati solo all\'interno di una trasmissione.","Stage Logo can only be published from inside a broadcast.":"Il logo sul palco può essere pubblicato solo all\'interno di una trasmissione.","Loading Speakers":"Caricamento relatori","Raise hand is disabled for organizer accounts, but active for attendee accounts":"Alza la mano è disabilitato per gli account organizzatore, ma attivo per gli account dei partecipanti","Disabled in lite mode, return to live if you’d like to raise hand!":"Disabilitato in modalità lite, torna alla diretta se vuoi alzare la mano.","Raise hand to enter stage for video q&a":"Alza la mano per entrare nel palco per il video di domande e risposte","Speakers":"Relatori","Hosting organization: {organization}":"Organizzazione dell\'hosting: {organization}","Failed to switch {deviceTag}":"Impossibile cambiare {deviceTag}","Make sure your {deviceTag} is not being used by any other application and is working properly.":"Assicurati che il tuo {deviceTag} non sia utilizzato da nessun\'altra applicazione e che funzioni correttamente.","Facing issues with audio or video? Switch on lite mode":"Problemi con audio o video? Passa alla modalità lite","Failed to get event for eventID: {eventID}":"Impossibile ottenere l\'evento per EventID: {eventID}","Error while playing video.":"Errore durante la riproduzione del video.","Speakers only, attendees can\'t see this chat":"Riservato ai relatori, i partecipanti non possono vedere questa chat","Kudo":"Kudo","Room":"Stanza","Session":"Sessione","Booth":"Stand","Public":"Pubblica","Drift":"Drift","Slides":"Diapositive","Videos":"Video","Chat":"Chat","Messages":"Messaggi","Poll":"Sondaggio","Docs":"Documenti","Q&A":"Domande e risposte","Media":"Media","Messages Chat":"Chat messaggi","Leaderboard":"Leaderboard","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Nota: sei anche relatore per questo evento. Potrai sempre entrare nell\'area Backstage e salire sul palco.","Switch to Attendee View":"Passa alla visualizzazione partecipanti","Return to Organizer View":"Ritorna alla visualizzazione organizzatore","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"La disattivazione della visualizzazione partecipanti ricaricherà la pagina corrente e ti riporterà alla visualizzazione dell\'organizzatore. Vuoi continuare?","Switch":"CAMBIA","Request Sent":"Richiesta inviata","Your request for a demo has been submitted":"La tua richiesta di una demo è stata inviata","Organizer Redirection":"Reindirizzamento dell\'organizzatore","YES, REDIRECT":"SÌ, REINDIRIZZA","DISMISS":"IGNORA","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"I partecipanti verranno reindirizzati alla sessione successiva: {title}. Vuoi essere reindirizzato anche tu alla prossima sessione?","Stage":"Palco","Rooms":"Stanze","Join a round table to discuss moderated topics with your fellow attendees":"Unisciti a una tavola rotonda per partecipare a discussioni moderate con gli altri partecipanti","Booths":"Stand","Join a booth to know more about a sponsor":"Visita uno stand per saperne di più su uno sponsor","You are in the booth":"Sei nello stand","People":"Partecipanti","Connect with your fellow attendees":"Connettiti con gli altri partecipanti","Connect with speakers":"Connettiti con i relatori","starting in {duration}":"inizio tra {duration}","You will be redirected to booths in {duration}":"Verrai reindirizzato agli stand tra {duration}","booths":"Stand","agenda":"Programma","You will be redirected to {word} in {duration}":"Verrai reindirizzato a {word} tra {duration}","You will be redirected to the live stage in {duration}":"Verrai reindirizzato al palco live tra {duration}","- You are about to be redirected to {tabTitle} in {duration}":"- Stai per essere reindirizzato a {tabTitle} tra {duration}","See Agenda":"Vedi programma","Break":"PAUSA","{title} is now live":"{title} è ora live","Apologies, due to an error we need to refresh the page!":"Spiacenti, a causa di un errore dobbiamo aggiornare la pagina!","Network interruption detected":"Rilevata interruzione di rete","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"La tua connessione a Internet sta riscontrando alcuni problemi. Se stai utilizzando una VPN, valuta la possibilità di disabilitarla. In alternativa, prova a connetterti a una rete diversa","No audio output device detected":"Nessun dispositivo di uscita audio rilevato","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Collega i tuoi altoparlanti o le tue cuffie e usa l\'icona a forma di ingranaggio per testarli se riscontri problemi.","Please disable ad blocker for this page":"Disattiva il blocco degli annunci per questa pagina","Yes, I understand":"Sì, capisco","No event user found so attended not marked!":"Nessun utente dell\'evento trovato, quindi la partecipazione non è stata registrata.","Wait while the speaker approves your video q&a request":"Attendi che il relatore approvi la tua richiesta di video di domande e risposte","Organizer":"Organizzatore","UPNEXT":"a seguire","Ended":"Finito","Hide":"Nascondi","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"Questa pagina ti reindirizzerà automaticamente tra {durationLeftToRedirect} secondi.","Register":"Registrati","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Errore: l\'utente non può essere registrato per questo evento. Contatta l\'organizzatore dell\'evento per ricevere assistenza","You are already registered!":"Hai già effettuato la registrazione.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Sembra che tu abbia già effettuato la registrazione per questo evento! Se non hai ricevuto la conferma della registrazione, controlla la tua cartella di spam. Se hai bisogno di ulteriore assistenza, contatta l\'organizzatore dell\'evento","Thank you for registering!":"Grazie per aver effettuato la registrazione!","Submit another response":"Invia un\'altra risposta","Share":"Condividi","Know someone who want to attend this?":"Conosci qualcuno che vuole partecipare?","COPY LINK":"COPIA LINK","Powered by":"Powered by","VIEW PROFILE":"VISUALIZZA PROFILO","You can access the event landing here":"Puoi accedere all\'evento da qui","Need Help?":"Hai bisogno di aiuto?","Welcome back":"Bentornati","Checking...":"Verifica in corso...","Close":"Chiudi","Enter":"Entra","See {roomCount} Room(s)":"Vedi {roomCount} stanza/e","Back":"Indietro","Request a Demo":"Richiedi una demo","Loading":"caricamento","Thread":"Thread","Load more":"Carica altro","Heads up!":"Attenzione.","YES":"SÌ","No":"No","Following":"Stai seguendo","Error in loading drimify":"Errore durante il caricamento di drimify","You\'re not registered for this event":"Non hai effettuato la registrazione per questo evento","Check out other events":"SCOPRI ALTRI EVENTI","Date":"Data","Location":"Posizione","How are you attending the event":"Come partecipi all\'evento?","In Person":"Di persona","Virtually":"Virtualmente","Event Widgets":"Widget eventi","Chat • Messages • Q&A • Poll • Docs":"Chat • Messaggi • Domande e risposte • Sondaggio • Documenti","DISCUSSION":"DISCUSSIONE","JOIN":"PARTECIPA","WAIT":"ATTENDI","more":"altro","See Profile":"Vedi profilo","Filter":"Filtra","Video player not supported by your browser":"Lettore video non supportato dal tuo browser","We recommend using the latest version of Google Chrome to access your conference":"Ti consigliamo di utilizzare l\'ultima versione di Google Chrome per accedere alla conferenza","ANSWER":"RISPONDI","REJECT":"RIFIUTA","Don’t ask me this next time":"Non chiedermelo la prossima volta","Cancel":"Annulla","Lite Mode":"Modalità Lite","On":"On","Connection Issues? Turn on Lite Mode":"Problemi di connessione? Attiva la modalità Lite","Turn On Lite Mode":"Attiva la modalità lite","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"La modalità Lite comporterà un ritardo di 30 secondi tra la trasmissione in diretta e ciò che vedrai sullo schermo. Vuoi continuare?","Turn On":"Attiva","Lite Mode Active!":"Modalità Lite attivata!","Thanks for your patience, lite mode now on!":"Grazie per la pazienza, la modalità Lite è ora attiva.","Turn off Lite Mode?":"Disattivare la modalità Lite?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Disattivazione della modalità Lite per tornare a guardare la trasmissione in diretta. Attenzione, questo causerà un divario di 30 secondi mentre ci aggiorniamo.","Lite Mode Off!":"Modalità Lite disattivata!","Thanks for your patience, we’ve returned to the live broadcast!":"Grazie per la pazienza, siamo tornati alla trasmissione in diretta.","Lite Mode Unavailable":"Modalità Lite non disponibile","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Siamo spiacenti, la modalità Lite non è al momento disponibile. Passa alla trasmissione in diretta per riprendere la sessione.","Turn off Lite mode?":"Disattivare la modalità Lite?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"Abbiamo rilevato che la tua connessione è tornata alla normalità. Vuoi tornare alla trasmissione in diretta? Attenzione, questo causerà un divario di 30 secondi mentre ci aggiorniamo.","Turn Off":"Disattiva","Lite mode is disabled for organizer accounts, but active for attendee accounts":"La modalità Lite è disabilitata per gli account organizzatore, ma è attiva per gli account dei partecipanti","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"La modalità Lite non è supportata dal tuo browser. Consigliamo di utilizzare l\'ultima versione di Google Chrome","Lite mode is not curently available. We’ll let you know once it’s available again":"La modalità Lite non è attualmente disponibile. Ti comunicheremo quando lo sarà di nuovo","Turn off Lite Mode":"Disattiva la modalità Lite","We’ll let you know when Lite mode is available again":"Ti informeremo quando la modalità Lite sarà di nuovo disponibile","Lite Mode Available":"Modalità Lite disponibile","Loading Lite Mode...":"Caricamento modalità lite...","Turning Off Lite Mode":"Disattivazione della modalità Lite","Lite Mode On":"Modalità Lite attivata","Audio/Video Issues?":"Problemi di audio/video?","Error":"Errore","Click a video to play":"Clicca su un video per riprodurlo","Error starting video!":"Errore durante l\'avvio del video.","Please rotate your device to {mode} mode":"Ruota il dispositivo in modalità {mode}","landscape":"orizzontale","portrait":"verticale","Thank you for attending this event!":"Grazie per aver partecipato a questo evento.","Go to Rooms":"Vai alle stanze","Please use a desktop or laptop Google Chrome browser to access your conference":"Utilizza un browser Google Chrome per desktop o notebook per accedere alla conferenza","If on Desktop":"Se usi un PC desktop","Please increase the width of your window":"aumenta la larghezza della finestra","Alternatively, check out the":"In alternativa, dai un\'occhiata a","Youtube Livestream":"Live streaming di Youtube","Search":"Cerca","Profile":"Profilo","Yes":"Sì","Loading Chat":"Caricamento chat in corso","Please wait while we fetch the chat":"Attendi il recupero della chat","Load old messages":"Carica vecchi messaggi","Join the room to see chat":"Entra nella stanza per vedere la chat","Live Chat":"Chat live","Uh..oh we couldn\'t load the content":"Ops... non siamo riusciti a caricare il contenuto","Please reload the page":"Ricarica la pagina","New comments":"Nuovi commenti","Start the conversation":"Inizia la conversazione","Be the first to add to chat!":"Dai tu il via alla chat!","Enter your message":"Inserisci il tuo messaggio","Joining chat!":"Sta partecipando alla chat.","See all pinned messages":"Visualizza tutti i messaggi fissati","Failed to send! Retry?":"Invio non riuscito. Riprovare?","Search for attendee":"Cerca un partecipante","Up to date":"Tutti i messaggi letti","Start a new conversation, We think you\'ll enjoy":"Inizia una nuova conversazione: siamo sicuri che ti piacerà","chatting with these recommended attendees!":"chattare con questi partecipanti consigliati!","Searching":"Ricerca in corso","Load Previous":"Carica precedente","Load Next":"Carica prossimo","Loading Channel":"Caricamento canale","Please wait while we fetch the channel":"Attendi il recupero del canale","Please wait while we fetch the messages":"Attendi il recupero dei messaggi","Send the first message":"Invia il primo messaggio","Join":"Partecipa","link":"link","download":"download","Click to open":"Fai clic per aprire","No open polls":"Nessun sondaggio aperto","Check back later to see if a poll opens up!":"Torna più tardi per vedere se si apre un sondaggio!","Loading Poll":"Caricamento del sondaggio","Please wait while we fetch the polls":"Attendi il recupero dei sondaggi","Uh oh.. we couldn’t load the content":"Ops... non siamo riusciti a caricare il contenuto","Polls":"Sondaggi","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"Per avviare un sondaggio, aggiungi la domanda e le risposte a questa sessione nel pannello di amministrazione di Goldcast","Stop Sharing":"Interrompi condivisione","Can\'t publish polls while something else is being presented on stage":"Non è possibile pubblicare sondaggi mentre si sta presentando qualcos\'altro sul palco","Open":"Apri","Cancel your video q&a request":"Annulla la tua richiesta di video di domande e risposte","Pending...":"In sospeso...","Leave Stage":"Lascia il palco","Raise Hand":"Alza la mano","Text Q&A":"Testo Domande e risposte","Video Q&A":"Video Domande e risposte","Loading Q&amp;A":"Caricamento Domande e risposte","Please wait while we fetch the Q&amp;A":"Attendi il recupero di Domande e risposte","Uh oh.. we couldn\'t load the content":"Ops... non siamo riusciti a caricare il contenuto","No Questions Yet":"Ancora nessuna domanda","Tell your audience to send in questions!":"Invita il tuo pubblico a inviare domande.","Be the first to ask a question!":"Puoi essere il primo a fare una domanda.","Tell your audience to raise their hand!":"Invita il tuo pubblico ad alzare la mano.","Approve":"Approva","Reject":"Rifiuta","End":"Termina","RELOAD":"RICARICA","Logos On Stage":"Loghi sul palco","No File Chosen":"Nessun file selezionato","loading":"caricamento","Can\'t publish a slide when there is something else being presented on stage":"Non è possibile pubblicare un diapositiva mentre sul palco viene presentato qualcos\'altro","Change Deck":"Cambia presentazione","stop-screen-share":"interrompi-condivisione-schermo","screen-share":"condivisione-schermo","Select a deck to begin presenting":"Seleziona una presentazione per iniziare","CONFIRM":"CONFERMA","If you’re having issues, please refer to the":"In caso di problemi, consulta","SPEAKER":"ALTOPARLANTE","Issue Testing Audio!":"Problema durante il test dell\'audio","VPN and adblockers may cause video issues, please disable them before proceeding":"Le VPN e gli ad-blocker possono causare problemi video, quindi disabilitali prima di procedere","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"Nota: le VPN e gli ad-blocker possono causare problemi video, quindi assicurati che siano disabilitati durante la trasmissione","Follow":"Segui","Read More":"Leggi di più","Ask a question":"Fai una domanda","Shared":"Condivisa","Answered":"Risposte","Waiting Approval":"In attesa di approvazione","cancel":"annulla","ENTER":"ENTRA","Upcoming Events":"Prossimi eventi","Past Events":"Eventi passati","Goldcast":"Goldcast","MANAGE EVENT":"GESTISCI L\'EVENTO","Edit Profile":"Modifica profilo","Stay tuned!":"Continua a seguirci.","Sign-in instructions will be available here 12 hours prior to the event":"Le istruzioni per l\'accesso saranno disponibili qui 12 ore prima dell\'evento","Please log out":"Effettua la disconnessione","Logout":"Esci","Continue as {differentUser}":"Continua come {differentUser}","You are already logged in as {user}.":"Hai già effettuato l\'accesso come {user}.","EMAIL":"EMAIL","user@email.com":"user@email.com","FIRST NAME":"Nome","First Name":"Nome","LAST NAME":"Cognome","Last Name":"Cognome","You are not registered to this event":"Non sei registrato a questo evento","Please enter your email and name":"Inserisci il tuo indirizzo e-mail e il tuo nome","Please enter your email":"Inserisci il tuo indirizzo e-mail","We have sent a secret code to":"Abbiamo inviato un codice segreto a","BACK":"INDIETRO","Didn\'t receive an email? Make sure to check spam list":"Non hai ricevuto un\'e-mail? Controlla anche la cartella spam","Resend Mail":"Invia nuovamente l\'email","SECRET CODE":"CODICE SEGRETO","Please enter the temporary password sent to your email":"Inserisci la password temporanea inviata al tuo indirizzo e-mail","NEW PASSWORD":"NUOVA PASSWORD","Please enter a new password":"Inserisci una nuova password","CONFIRM PASSWORD":"CONFERMA PASSWORD","Please re-enter the new password":"Inserisci nuovamente la nuova password","Password length should be atleast 8":"La password deve essere lunga almeno 8 caratteri","Password and Confirm Password don\'t match !!":"La password e la password di conferma non corrispondono.","Please enter your password to continue":"Inserisci la password per continuare","Logging you in...":"Accesso in corso...","PASSWORD":"PASSWORD","Forgot credentials?":"Hai dimenticato le credenziali?","Forgot Password? A mail will be sent to your registered email.":"Password dimenticata? Verrà inviata una e-mail al tuo indirizzo di posta elettronica registrato.","Email cannot be blank!!":"Il campo e-mail non può essere vuoto.","We have sent a secure login link to":"Abbiamo inviato un link di accesso sicuro a","from":"da","Please use that to access your event.":"Utilizzalo per accedere al tuo evento.","Please check spam/promotion too if you can\'t find it.":"Controlla anche la cartella spam/promozioni se non riesci a trovarla.","Thank You !":"Grazie.","The link is not valid.":"Il link non è valido.","Please be patient.":"Un po\' di pazienza.","We are verifying your link.":"Stiamo verificando il tuo link.","Thank you for entering the code!":"Grazie per aver inserito il codice.","Please create a new password":"Crea una nuova password","Signing you up...":"Iscrizione in corso...","We have sent a temporary password to":"Abbiamo inviato una password temporanea a","TEMPORARY PASSWORD":"PASSWORD TEMPORANEA","Please enter the temporary password sent to your mail":"Inserisci la password temporanea inviata alla tua e-mail","Password Length should be 8":"La password deve essere lunga 8 caratteri","Okay":"OK","Backstage: {title}":"Backstage: {title}","Prep Area":"Area di preparazione","Starting at {time}":"Inizio alle {time}","person":"persona","inside":"dentro","No one is inside":"Dentro non c\'è nessuno","This area is for you to sync up with your fellow speakers before you go on stage.":"Quest\'area serve per sincronizzarti con gli altri relatori prima di salire sul palco.","This area is for you to check your cam and mic before you enter the room.":"Quest\'area serve per controllare la fotocamera e il microfono prima di entrare nella stanza.","I\'m Ready":"Sono pronto","Watch Live":"Guarda live","Backstage":"Backstage","You are sharing your screen":"Stai condividendo il tuo schermo","LIVE":"LIVE","Live":"LIVE","Virtual":"Virtuale","Only available for ":"Disponibile solo per ","See Booths":"Vedi stand","See Rooms":"Vedi stanze","Enter Backstage":"Entra nel backstage","This track has no upcoming sessions. Check out a different track.":"Questa traccia non ha sessioni imminenti. Prova una traccia diversa.","View":"Visualizza","Agenda":"Programma","Scroll to see all tracks":"Scorri per vedere tutte le tracce","No Agenda Items to show!":"Nessun punto del programma da mostrare.","ENTER EVENT":"PARTECIPA ALL\'EVENTO","change":"modifica","Upload":"Carica","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF O PNG. DIMENSIONE MAX 5 MB","Create Profile":"Crea profilo","Email":"Email","Company":"Azienda","Title":"Titolo","No matching locations found":"Nessuna località corrispondente trovata","You can try searching for the location with another keyword":"Puoi provare a cercare la località con un\'altra parola chiave","Interest Tags":"Tag di interesse","Pick your first tag":"Scegli il tuo primo tag","Save":"Salva","Searching...":"Ricerca in corso...","Twitter":"Twitter","Select Your First Tags":"Seleziona i tuoi primi tag","Add Interest tags":"Aggiungi tag di interesse","Congratulations!":"Congratulazioni!","Your first Goldcast event is set up":"Il tuo primo evento Goldcast è pronto","You can always visit":"Puoi sempre visitare","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"per istruzioni su come impostare e gestire i tuoi eventi","See My Event":"Vedi il mio evento","Peak Community":"Peak Community","Loading Lite Mode... This may take up to 30s":"Caricamento modalità lite... Questa operazione può richiedere fino a 30 secondi","Loading Video...":"Caricamento video...","Video will begin at session start time":"Il video inizierà quando comincerà la sessione","TIME":"ORA","TITLE":"TITOLO","STATUS":"STATO","END":"Termina","START":"INIZIA","AGENDA":"Programma","Enable Audio":"Abilita audio","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"L\'audio è stato disattivato a causa dei criteri di riproduzione automatica del browser. Fai clic su Abilita di seguito per riattivare l\'audio. Puoi anche riattivare l\'audio in un secondo momento tramite i controlli incorporati.","Enable":"Abilita","You are being redirected outside the room. Would you like to continue?":"Ti reindirizzeremo fuori dalla stanza. Vuoi continuare?","Continue":"Continua","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"In alternativa, puoi utilizzare la modalità lite, che avrà un ritardo di 30 secondi rispetto alla trasmissione in diretta","We detected a network issue":"Abbiamo rilevato un problema di rete","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Assicurati di non essere connesso tramite VPN/Firewall. Se il problema persiste, prova a cambiare rete, browser o dispositivo.","Could not connect":"Impossibile stabilire una connessione","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"Ciò potrebbe essere dovuto a un problema di rete sicura o browser/dispositivo. Se il problema persiste, prova a cambiare rete, browser o dispositivo.","Switch to Lite Mode":"Passa alla modalità Lite","Leave":"esci","Screenshare had an issue":"Si è verificato un problema alla condivisione dello schermo","Could not share screen unexpectedly. Refresh & retry. On mac go to":"Impossibile condividere lo schermo in maniera inaspettata. Aggiorna e riprova. Su mac vai su","and check if your browser has the required permission":"e controlla se il tuo browser dispone dell\'autorizzazione richiesta","Uh OH... Something went wrong":"Si è verificato un problema","To fix this, click the":"Per risolvere il problema, fai clic sul pulsante","in your URL bar, then select “Allow”, and then click “Try Again”":"nella barra degli URL, quindi seleziona \\"Consenti\\" e poi fai clic su \\"Riprova\\"","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"Impossibile inizializzare il tuo flusso multimediale per un motivo sconosciuto. Il tuo browser potrebbe non essere supportato dalla nostra piattaforma. Ti consigliamo di utilizzare \\"Google Chrome\\". Se il problema persiste, contatta il supporto Goldcast","To fix this, make sure your":"Per risolvere questo problema, assicurati che","is not being accessed by any other app. If not, please try changing your":"non sia utilizzato da altre app. In caso contrario, prova a cambiare","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"dispositivi facendo clic su \\"Vai a impostazioni\\". Dopo aver risolto il problema probabile, clicca su \\"Riprova\\".","Go To Settings":"Vai alle impostazioni","Try Again":"Prova di nuovo","Try Joining without Video":"Prova a partecipare senza video","A refresh and rejoin should work":"L\'aggiornamento e la nuova iscrizione dovrebbero funzionare","Refresh & Rejoin":"Aggiorna e partecipa di nuovo","Start Chat":"Avvia chat","On Stage":"Sul palco","Connect your on-site camera and microphone to present to your virtual attendees":"Collega la videocamera e il microfono sul posto per effettuare la presentazione ai partecipanti virtuali","Stop Streaming":"Interrompi streaming","Start Streaming":"Avvia streaming","Set up on-site video feed":"Imposta il feed video sul posto","Open TV":"Apri TV","Layout: {layout} ":"Layout: {layout} ","With Speaker Videos":"Con video dei relatori","Full Screen":"A schermo intero","No Speakers":"Nessun relatore","Turn Off Setup Mode":"Disattiva Modalità di configurazione","Setup Mode":"Modalità di configurazione","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"Disattiva se desideri interrompere la modalità di configurazione per {roomTitle}. In questo modo, verranno disattivati anche tutti gli stream attivi.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"Preparazione allo streaming: {roomTitle}. Utilizza la modalità di configurazione solo per trasmettere dalla posizione in tempo reale.","Starting in {duration}":"Inizio tra {duration}","Can\'t share screen while there is something else being presented on stage":"Impossibile condividere lo schermo mentre sul palco viene presentato qualcos\'altro","You are now in attendee view!":"Ora sei nella visualizzazione partecipanti.","You are now in organizer view!":"Ora sei nella visualizzazione organizzatore.","Note :":"Nota:","Only organizer accounts can see this tag, normal attendees can’t see this":"solo gli account organizzatori possono vedere questo tag, i partecipanti normali non possono vederlo","Attendee":"Partecipante","Event Information":"Informazioni sull\'evento","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"Le informazioni sull\'evento sono visibili solo agli organizzatori. <br /> Questa sezione non è visibile ai partecipanti","Operating System":"Sistema operativo","Secondary Booths":"Stand secondari","Sort":"Ordina","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"Stai seguendo {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2}smetterà automaticamente di seguirti{track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}Vuoi davvero continuare?","Track only available for {tracks}":"Traccia disponibile solo per {tracks}","Add to Calendar":"Aggiungi al calendario","Open Speakers Control Panel":"Apri il pannello di controllo dei relatori","Move Offstage ↓":"Sposta fuori scena ↓","Error Moving ⚠":"Errore durante lo spostamento ⚠","Off Stage":"Fuori scena","Move to Stage":"Sposta in scena","An error occurred!":"Si è verificato un errore.","{eventName} Documents":"Documenti di {eventName}"," Set Up Mode":" Modalità di configurazione","Camera & Mic blocked":"Fotocamera e microfono bloccati","Camera/Mic Inaccessible":"Fotocamera/microfono inaccessibile","Camera/Mic Not Found":"Fotocamera/microfono non trovata/o","Camera Inaccessible":"Fotocamera inaccessibile","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"La fotocamera è occupata o la risoluzione non è supportata. Assicurati che la fotocamera non sia utilizzata da un\'altra applicazione e riprova.","No microphone/camera is found":"Nessun microfono/fotocamera trovato","The browser does not support using camera and microphone!":"Il browser non supporta l\'uso di fotocamera e microfono.","{n} Slides":"{n} diapositive","Starting in {timeduration}":"Inizio tra {timeduration}","{eventtitle} has ended":"{eventtitle} si è concluso","This is a text q&a question!":"Questa è una domanda scritta!","Click here{if_it_does_not}":"Fai clic qui{if_it_does_not}","{click_here}if it does not":"{click_here}se così non fosse","{title}up next":"{title} a seguire","seat(s) open":"posto/i disponibile/i","Signal strength is low. Close other windows or connect to a different network.":"La potenza del segnale è bassa. Chiudi le altre finestre o collegati a una rete diversa.","GO BACKSTAGE":"VAI NEL BACKSTAGE","LEAVE STAGE":"Lascia il palco","LEAVE":"esci","This event begins on{startitme}":"Questo evento inizia il {startitme}","Please refresh to enter.":"Aggiorna per entrare.","people":"partecipanti","Oops, Something went wrong":"Si è verificato un problema","Back Home":"Torna alla home","Deciding where to go ...":"Decidere dove andare ...","Go to Event Hub":"Vai all\'hub eventi","CREATE":"CREA","Attending Virtually":"Partecipazione virtuale","Attending In Person":"Partecipazione di persona","Click to change your attendance type":"Fai clic per modificare il tipo di partecipazione","Open Chat":"Apri chat","Create your profile for {eventtitle}":"Crea il tuo profilo per {eventtitle}","Move to stage":"Sposta in scena","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"L\'organizzatore dell\'evento ha richiesto di spostarti in scena per <strong>{broadcastTitle}</strong>.<br /><br />Se fai clic per accettare la richiesta, sarai in diretta e visibile ai partecipanti all\'evento.<br /><br />","Go Live On Stage":"Vai in diretta in scena","Moved to backstage":"Spostato nel backstage","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"L\'organizzatore ti ha rimosso dal palco. Non tentare di partecipare di nuovo senza contattare l\'organizzatore.","Error creating Screen stream":"Errore durante la creazione del flusso dello schermo","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"L\'autorizzazione a condividere lo schermo non è stata concessa. *Fai clic qui* per visualizzare i documenti per la risoluzione dei problemi.","Error publishing stream":"Errore durante la pubblicazione del flusso","Could not publish stream. Please refresh and try again!":"Impossibile pubblicare il flusso. Aggiorna e riprova.","Error publishing screen":"Errore durante la pubblicazione dello schermo","Error publishing screen. Please refresh and try again!":"Errore durante la pubblicazione dello schermo. Aggiorna e riprova.","Error unpublishing stream":"Errore durante l\'annullamento della pubblicazione del flusso","Error unpublishing stream. Please refresh and try again!":"Errore durante l\'annullamento della pubblicazione del flusso. Aggiorna e riprova.","Invalid Publish Operation":"Operazione di pubblicazione non valida","{username} profile picture":"Immagine del profilo di {username}","Default":"Predefinito","A-Z":"A-Z","Random":"Casuale","All":"Tutto","Past":"Precedenti","Upcoming":"Prossimi","Learn More":"Ulteriori informazioni","close":"chiudi","Discussion Rooms":"Stanze per discussioni","ATTENDEE MODE":"MODALITÀ PARTECIPANTE","Loading...":"Caricamento in corso...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"Il dispositivo è disabilitato dal browser o non sono state concesse le autorizzazioni per l\'uso. Concedi le autorizzazioni e fai clic su \\"Riprova\\"","You are now registered. You will receive an email confirming details shortly.":"Ora hai effettuato la registrazione. A breve riceverai un\'email con la conferma dei dettagli.","Streaming to Virtual Users from on-site video feed":"Trasmissione agli utenti virtuali dal feed video sul posto","Ending in ":"Termina tra ","GO LIVE":"VAI IN DIRETTA","You have no past events.":"Non hai eventi passati.","You have no upcoming or live events.":"Non ci sono eventi imminenti o live.","left":"sinistra","center":"centro","right":"destra","top":"Alto","bottom":"Basso","loading...":"caricamento in corso...","Loading ...":"Caricamento in corso...","Failed to redirect!":"Impossibile reindirizzare.","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"Sembra che tu abbia un blocco degli annunci attivo. Questo potrebbe impedirti di vivere la migliore esperienza possibile. Disattivalo. <br />&lt;br / &gt; Se hai bisogno di aiuto su come fare, fai clic <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>qui</a> per ulteriori istruzioni.","redirecting in {duration}":"reindirizzamento tra {duration}","STOP VIDEO":"INTERROMPI VIDEO","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"Stai per interrompere la riproduzione di questo video. La tua trasmissione tornerà in modalità live e il pubblico vedrà e sentirà i tuoi altoparlanti. Vuoi continuare?","STOP SHARING":"Interrompi condivisione","No Next Slide":"Nessuna diapositiva successiva","Next Slide":"Diapositiva successiva","No Previous Slide":"Nessuna diapositiva precedente","Previous Slide":"Diapositiva precedente","something went wrong while recording the response please try again":"Si è verificato un errore durante la registrazione della risposta, riprova","Start In-Person Streaming":"Avvia streaming di persona","Stop In-Person Streaming":"Interrompi lo streaming di persona","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Il tuo video è in fase di buffering e la sessione di test inizierà a breve. Questo non avverrà durante la sessione vera e propria.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"Il ticker apparirà nella parte superiore della pagina web per tutti i partecipanti. Per trasformare il ticker in un collegamento ipertestuale, inserisci l\'URL seguente","Allow {key}":"Consenti {key}","{messageType} can only be published from inside a broadcast.":"{messageType} può essere pubblicato solo all\'interno di una trasmissione.","To grant {deviceName} access to this page, follow the two steps below:":"Per concedere a {deviceName} l\'accesso a questa pagina, segui questi passaggi:","2. Allow {deviceName} access and then refresh the page.":"2. Consenti l\'accesso a {deviceName} e poi aggiorna la pagina."}');

/***/ }),

/***/ 9494:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"イベント設定ドロップダウン"," Stage Control":" ステージのコントロール","Stage Controls and Information":"ステージのコントロールと情報","Live in ":"ライブの場所 ","Start Session":"セッションを開始","End Session":"セッションを終了","Present Screen":"画面を提示","Rehearse On Stage":"ステージでリハーサルする","Turn on Microphone":"マイクをオンにする","Turn off Microphone":"マイクをオフにする","Turn on camera":"カメラをオンにする","Turn off camera":"カメラをオフにする","rehearsal mode":"リハーサルモード","People Watching: ${watchCount}":"人間観察：${watchCount}","Turn on Audio":"音声をオンにする","Turn off Audio":"音声をオフにする","Are you sure you want to leave this room?":"本当にこの部屋を出ますか?","you will be redirected to stage in":"ステージにリダイレクトされます","sec. . ":"秒で ","Skip to Main Navigation":"メインナビゲーションへスキップ","Skip to Chat":"チャットへスキップ","Skip to Meeting Controls":"ミーティングコントロールへスキップ","LinkedIn":"Linkedin","Live in":"ライブの場所","UPCOMING":"今後の","Rehearse on stage":"ステージでリハーサルする","Watch Rehearsal":"リハーサルを見る","Answered by:":"回答者：","Speaker Off":"スピーカーオフ","Speaker On":"スピーカーオン","Speaker Controls":"スピーカーコントロール","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"すべてのステージ要素は、共有イメージの背後に存在します。全画面の画像の共有が停止されると、再び表示されるようになります。","Close Ticker Popup":"ティッカーのポップアップを閉じる","Open GIF Picker":"GIFピッカーを開く","Open Emoji Picker":"絵文字ピッカーを開く","Send Message":"メッセージを送る","Tabs: Messaging and More":"タブ：メッセージングその他","Thanks for attending!":"ご参加いただきありがとうございました！"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" サブスクライブ済みのトラックには、今後のセッションがありません。ライブセッションを表示するには、他のトラックに切り替えてください","Redirecting you to ":"次の先へリダイレクトします ","in ":"あと ","seconds":"数秒後に","Main Navigation":"メインナビゲーション","YOU ARE HERE":"現在の位置","Live Now":"今すぐライブで","SUBMIT":"提出","Allocated time for engagement has ended. You will be redirected to main stage":"エンゲージメントに割り当てられた時間が終了しました。メインステージにリダイレクトされます","Wrap up in":"終了までの時間","Session overrun by":"セッションの超過","Ending in":"終了","Bring this session live?":"このセッションをライブで行いますか？","START SESSION":"セッションを開始","Bring this session to end?":"このセッションを終了しますか?","END SESSION":"セッションを終了","Go On Stage":"ステージに上がる","Muted by organizer":"主催者によりミュートされました","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"イベント主催者の一人が、あなたの音声をミュートしました。マイクボタンをクリックすると、ご自分のミュートを解除できます。","Gifs":"GIF画像","Stickers":"ステッカー","Launch Survey":"調査を開始","Microphone is on":"マイクがオンになっています","Microphone is off":"マイクがオフになっています","Secret Code’s length should be 6 digits":"シークレットコードは6桁にしてください","Closing in 00:":"00で締めくくる：","Submit":"提出","Questions":"質問","Preview":"プレビュー","Close Survey":"アンケートを閉じる","This is a required question":"これは必須の質問です","Enter the text you’d like to present on stage below.":"ステージで提示したいテキストを以下に入力します。","Use Chrome/Edge for best performance":"最高のパフォーマンスを得るにはChromeまたはEdgeを使用してください","Do you want to launch your survey now?":"今すぐアンケートを開始しますか？","Success! Your Survey has been launched for attendees.":"成功！アンケートが参加者向けに開始されました。","Unable to publish. Please try again.":"公開できません。再度お試しください。","Are you sure you want to close this survey?":"このアンケートを閉じてもよいですか？","Success! Your Survey has been closed for attendees.":"成功！参加者へのアンケートを締め切りました。","Unable to un-publish. Please try again.":"非公開にできません。再度お試しください。","Please answer all required questions.":"必須の質問にすべて答えてください。","You have already submitted this survey.":"このアンケートはすでに送信されています。","Success! Thank you for your feedback.":"成功！ご意見ありがとうございます。","Unable to submit. Please try again.":"提出できません。再度お試しください。","Launch surveys will take over attendees\' engagement panel.":"開始されたアンケートが参加者のエンゲージメントパネルをカバーします。","Closing this survey will remove it from attendees\' engagement panel.":"このアンケートを終了すると、参加者のエンゲージメントパネルからアンケートが削除されます。","Survey":"調査","Updating Survey...":"アンケートを更新中...","Closing":"閉じる","Goldcast needs access to your camera and microphone":"Goldcastはカメラとマイクにアクセスする必要があります","Goldcast needs access to your microphone":"Goldcast にはお使いのマイクへのアクセス権が必要です","Goldcast needs access to your camera":"Goldcast にはカメラへのアクセス権が必要です","SPEAKERS":"スピーカー","Mark as Unanswered":"未回答としてマークする","Mark as Answered":"回答済みとしてマークする","Remove from Priority":"優先から削除する","Mark as Priority":"優先としてマークする","Answer":"答える","Enter answer...":"回答を入力する...","Answered by":"回答者","Submit Answer":"回答を送信する","Test your system’s speaker":"システムのスピーカーをテストする","Click \\"Yes\\" if you hear the sound.":"音が聞こえたら「はい」をクリックします。","Load previous":"前のものを読み込む","Hide Name":"名前を非表示にする","Text Q&A is disabled in On Demand mode.":"オンデマンドモードでは、テキストQ&Aは無効になっています。","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"テキストQ&Aが上限に達しました。出席者は新規の質問をすることができません。","Sent to Q&A":"質問はQ&Aセクションに送信されました","Couldn\'t post as Q&A. Please try again.":"Q&Aとして投稿できませんでした。再度お試しください。","Yes this is being recorded":"はい、これは記録されています","No this is not being recorded":"いいえ、これは記録されていません","System\'s Speaker Check":"システムのスピーカーチェック","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"確実にイベント中に音声が聞こえるようにするため、システムのスピーカーが正常に動作していることを確認します","Click on “Test your system’s speaker” to proceed":"「システムのスピーカーをテストする」をクリックして先に進みます","Error while sharing message to screen. Post not found":"画面にメッセージを共有している際にエラーが発生しました。投稿が見つかりません","Lost connection to servers. Refresh your page to get live event experience.":"サーバーへの接続が失われました。ページを更新して、ライブイベントの体験を取得します。","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"VPN/ファイアウォールが認証を妨害しています。スムーズにGoldcastにアクセスするため、ネットワークを切り替えるか、ITチームに連絡を取って、<a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>これらのドメイン</a>を許可します。","It\'s taking too long":"時間がかかりすぎています","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"VPN経由で接続されているか、ファイアウォールがオンになっていると思われます。Goldcastがスムーズに機能するためにこの<a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>ヘルプドキュメント</a> およびホワイトリストで必須のドメインを参照するか、あるいはネットワークを変更してください","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"VPN経由で接続されているか、ファイアウォールがオンになっていると思われます。Goldcastがスムーズに機能するためにこの<a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>ヘルプドキュメント</a>およびホワイトリストで必須のドメインを参照するか、あるいはネットワークを変更するか、またはライトモードでセッションを視聴するようにしてください。","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"ネットワーク帯域幅が不十分なため、Goldcastビデオストリーミングサービスに接続できません。ネットワークを変更してライブストリーミングサービスに接続してください。","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"ネットワーク帯域幅が不十分なため、Goldcastビデオストリーミングサービスに接続できません。ストリーミングサービスに接続するには、ライトモードに切り替えるか、ネットワークを変更します","Most Upvotes":"最多の賛成票","Most Recent":"最新のもの","My Questions":"私の質問","Prioritized":"優先されるもの","Approved":"承認済み","Unapproved":"未承認","Unanswered":"未回答","Failed to update answer. Please try again!":"回答を更新できませんでした。再度お試しください。","Failed to post answer. Please try again!":"回答を投稿できませんでした。再度お試しください。","Failed to delete question. Please try again!":"質問を削除できませんでした。再度お試しください。","Survey Link":"アンケートのリンク","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"切り替えると現在のページをリロードし、出席者ビューになります。主催者ビューに戻すには、プロファイルのドロップダウンで出席者ビューをオフに切り替えます。","You haven\'t asked any questions yet":"まだ何も質問されていません","No prioritized questions":"優先される質問がありません","Create prioritized list of questions for speakers by marking questions as priority":"質問を優先としてマークすることにより、講演者への質問の優先リストを作成します","No Approved Questions":"承認済みの質問はありません","Approve incoming questions to see list of approved questions":"受信した質問を承認して、承認済みの質問のリストを確認します","No Unapproved Questions":"未承認の質問はありません","No Answered Questions":"回答済みの質問はありません","Answer a question on stage or with inline text":"ステージでまたはインラインテキストで質問に答える","All questions are answered":"すべての質問は回答されます","Rate Your Experience":"ご自分の体験を評価する","How satisfied are you with Goldcast?":"Goldcastにどの程度満足されていますか？","What are the main reasons for your rating?":"評価の主な理由は何ですか?","I am interested in seeing a demo of Goldcast":"私はGoldcastのデモを見たいと思っています","Thank You":"ありがとうございます","Your feedback was successfully submitted.":"フィードバックが正常に送信されました。","Tell us how we can improve...":"どのような改善をご希望か教えてください...","1 Slide":"1 スライド","Your internet connection is unstable.":"インターネット接続が不安定です。","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"ミュートで話しておられると思われます。マイクのアイコンをクリックすると、ミュートが解除されます","The registration could not be completed! Please check that this email is allowed to register for the event.":"登録が完了しませんでした。このメールでイベントへ登録することが許可されていることをチェックしてください。","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"このイベントにはすでに登録されていると思われます。まだ確認を受け取りになれない場合は、登録確認が到着していないかどうかスパム用フォルダーを点検してみてください。さらにご支援が必要名場合、イベント運営者に連絡をお取りください。","Your registration could not be completed. This event has reached its registration capacity.":"登録を完了できませんでした。このイベントが登録容量に達しました。","Image cannot be an svg":"画像をsvg形式にできません","This should be a valid linkedin url":"これは有効なLinkedInのURLである必要があります","This should be a valid twitter url":"これは有効なTwitterのURLである必要があります","This should be a valid url":"これは有効なURLである必要があります","Video":"ビデオ","Read Less":"読み込み件数を減らす","live":"ライブ","Opened":"開きました","In person only":"イベント会場限定","Stage Stream":"ステージストリーム","Streaming not available":"ストリーミングは利用できません","Close TV":"テレビを閉じる","Streaming is not available for prerecorded and RTMP sessions":"ストリーミングは、事前に記録されたセッションと RTMPセッションでは利用できません","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"コンピューターをテレビ画面あるいはプロジェクターに接続すると、会場参加者は、質疑応答を含め仮想ステージの上演内容を見ることができます。接続したら、「テレビを開く」をクリックし、新しいウィンドウをテレビ画面やプロジェクターにドラッグするかまたは共有します。 ","Close Setup Mode":"セットアップモードを閉じる","Help":"ヘルプ","upcoming":"今後の","ended":"終了","Remove from favorites":"お気に入りから削除","Add to favorites":"お気に入りに追加","PLAY RECORDING":"録画の再生","VIEW RECORDING":"ビデオ録画","VIEW RECORDINGS":"録画の表示","Virtual Backgrounds":"バーチャル背景","No Device Available":"デバイスが利用できません","Needs permission":"許可が必要です","Device not detected":"デバイスが検出されません","Camera is on":"カメラがオンです","Camera is off":"カメラがオフです","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"ミラーリングされたビデオは視聴者に反映されません。視聴者は常にミラーリングされていないビデオを見ています","Mirror My Video":"マイビデオをミラーリングする","Camera":"カメラ","1. Click on Safari > Settings for this\\n            website":"1. Safari > このWeb サイトの設定、の順にクリックします","1. Click the lock":"1. ロックアイコンをクリックします","icon in your browser’s address bar":"ブラウザのアドレスバーにあります","3. Unmute":"3.ミュート解除","and":"および","icons from stage control panel":"ステージコントロールパネルにあるアイコン","icon from stage control panel":"ステージコントロールパネルにあるアイコン","2. Set camera and microphone to “Allow”.":"2. カメラとマイクを「許可」します。","2. Set camera to “Allow”.":"2. カメラを「許可」します。","2. Set microphone to \\"Allow\\"":"2. マイクを「許可」します","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2.「Goldcast がカメラとマイクにアクセスすることを常に許可する」を選択します。","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2.「Goldcast がカメラにアクセスすることを常に許可する」を選択します。","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2.「Goldcast がマイクにアクセスすることを常に許可する」を選択します。","Questions?":"質問がありますか？","If you’re having issues, check out our comprehensive":"問題が発生した場合は、総合ヘルプドキュメントを","help docs":"ご覧ください","Speaker is on":"スピーカーがオンになっています","Stop Test":"テスト停止","Test your system’s audio":"システムの音声をテストする","Still can\'t hear any sound?":"まだ音が聞こえませんか？","Microphone":"マイク","Audio is being played in system\'s default audio device.":"音声はシステムのデフォルトの音声デバイスで再生されています。","Click to view/change audio device":"ここをクリックして音声デバイスを表示/変更する","Speaker":"スピーカー","Play Recording":"録画の再生","Recording for this broadcast is currently being processed and will be available soon":"この放送の録画は現在処理中で、近日中に公開予定です","You haven\'t favorited anything yet!":"まだ何もお気に入り登録されていません。","Add an item to favorites by selecting the ♡ in the top right corner.":"右上の「♡」を選んで、アイテムをお気に入りに追加します。","Session has ended":"セッションは終了しました","System Check":"システムチェック","Need help? Check out the":"お困りですか？次をご確認ください","Skip Checks and Continue":"チェックをスキップして続ける","Click the button above to run the test":"このボタンをクリックしてテストを実行する","Test Screenshare":"スクリーンシェアのテスト","Share message to stage":"メッセージをステージに共有します","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"ティッカーに使用するテキストを以下に入力してください。ティッカーをハイパーリンクに変えるには、URLを入力します。","Ticker":"ティッカー","Coffee Break! Be back in 10m.":"コーヒーブレイク！10分で戻ってください。","Enter Message":"メッセージの入力","https://www.xyz.com":"https://www.xyz.com","Launch":"開始","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"質問をご提出いただきありがとうございます。現在のご質問が承認されると、別の質問を提出していただけます。","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"申し訳ございません。Q&A は現在、無効です。Q&Aが再び有効になると、質問を提出できるようになります。","Votes":"投票","Vote":"投票する","is inviting you to a video call":"ビデオ通話に招待中です","ENTER ROOM":"ルームに入る","Start the conversation!":"会話を始めましょう。","Couldn\'t send message. Click here to retry.":"メッセージを送信できませんでした。ここをクリックして再試行してください。","Couldn\'t add emoji. Please try again.":"絵文字を追加できませんでした。もう一度お試しください。","Couldn\'t remove emoji. Please try again.":"絵文字を削除できませんでした。もう一度お試しください。","Couldn\'t delete message. Please try again.":"メッセージを削除できませんでした。もう一度お試しください。","Couldn\'t pin message. Please try again.":"メッセージをピンできませんでした。もう一度お試しください。","Couldn\'t unpin message. Please try again.":"メッセージをピン留め解除できませんでした。もう一度お試しください。","Today":"今日","No messages yet":"メッセージはまだありません","Messages from organizers and speakers appear here!":"主催者や講演者からのメッセージがここに表示されます！","Next Session is Starting":"次のセッションが開始されます","Go to Next Session":"次のセッションへ","I’d like to stay":"このままでいます","My favorites":"お気に入り","1. Click on the lock icon in your address bar":"1. アドレスバーのロックアイコンをクリックします","We recommend organizers and speakers use a desktop\\n        device":"主催者と講演者はデスクトップデバイスを使用されることを推奨します","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"参加者、講演者、主催者に最高の体験を保証するためには、デスクトップからGoldcastを使用する必要があります。モバイルデバイスからブロードキャストすると、体験の質が低下することになります。","Watch Now":"今すぐ見る","Video progress time":"ビデオ進行時間","Total video duration":"ビデオの合計再生時間","Rate Goldcast!":"Goldcastを評価してください。","Running Required Checks...":"必須チェックを実行しています...","Test Your Setup":"セットアップのテスト","Test your Computer Device, Microphone and Camera before you join the event":"イベントに参加前に、コンピューターデバイス、マイク、カメラをテストしてください","Speaker and microphone not working?":"スピーカーとマイクが機能していませんか？","Passed":"成功","Fix Audio Issues":"音声の問題を修正する","Check if audio is being played in other sound devices connected to phone/tablet":"電話/タブレットに接続されている他のサウンドデバイスでオーディオが再生されているかどうかを確認します。","Check if correct audio device is chosen from the below dropdown":"以下のドロップダウンから正しい音声デバイスが選択されているかどうかを確認します","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>ここをクリック</a>して、音声を再生する必要がある場所で適切な音声デバイスが選択されているかどうかを確認します","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>ここをクリック</a> オーディオを再生する必要がある場所で、適切な音声デバイスが選択されているかどうかを確認します","Right click on the browser tab & click “Unmute Site”":"ブラウザのタブを右クリックし、「サイトのミュート解除」をクリックします","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"ブラウザのタブがミュート解除されているかどうかを確認するか、またはWindows > このタブのミュート解除、の順にクリックします","System Check Failed!":"システムチェックに失敗しました。","System Check Passed!":"システムチェックに成功しました。","Complete checks to proceed":"チェックを完了して、続けます","Enter Event":"イベント参加","Skip Screen Sharing Check? ":"画面共有チェックをスキップしますか? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"イベントで画面を提示する必要がある場合は、画面共有チェックを完了することを推奨します","Ignore & Enter Event":"無視してイベントを入力する","Test screenshare":"スクリーンシェアのテスト","Retry Now":"今すぐ再試行する","SHARE":"シェア","Rooms Closed":"ルームは閉まりました","Discussion rooms are now closed. You are being redirected to the Stage.":"ディスカッションルームは現在閉まっています。ステージへリダイレクトされます。","Return To Stage":"ステージに戻る","Unrecognized embedded widget provider - ":"認識できない埋め込みウィジェットプロバイダー -  ","Room Ended":"ルームが閉まりました","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"イベント主催者がすべてのルームを閉めました。イベントステージへリダイレクトされます。","Video Q&A Request Cancelled":"ビデオQ&Aリクエストがキャンセルされました","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"ライトモードで表示しているため、ビデオQ&Aリクエストはキャンセルされました。ライブモードに切り替えて、再度手を挙げます。","Camera Passed":"カメラ成功","Camera Error":"カメラエラー","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"カメラの許可がブラウザから付与されていません。「カメラを許可」をクリックします。","Camera permissions aren’t granted from system. Click “Allow Camera”":"カメラの許可がシステムから付与されていません。「カメラを許可」をクリックします","Uh-oh! Error occurred while creating camera stream":"あー！カメラストリームの作成中にエラーが発生しました","Close other applications which might use camera stream":"カメラストリームを使用する可能性のある他のアプリケーションを閉じる","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"ブラウザがカメラにアクセスできるかどうかを確認するには、<a href=\'ms-settings:privacy-webcam\'>ここをクリック</a>します","Microphone Passed":"マイク成功","Microphone Error":"マイクエラー","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"マイクの許可がブラウザから付与されていません。「マイクを許可」をクリックする","Mic permissions aren’t granted from system. Click “Allow Microphone”":"マイクの許可はシステムから付与されていません。「マイクを許可」をクリックする","Uh-oh! Error occurred while creating mic stream":"あー！マイクストリームの作成中にエラーが発生しました","Close other applications which might use mic stream":"マイクストリームを使用する可能性のある他のアプリケーションを閉じる","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"ブラウザがマイクにアクセスできるかどうかを確認するには、<a href=\'ms-settings:privacy-microphone\'>ここをクリック</a>します","Speaker and Microphone Error":"スピーカーとマイクのエラー","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"システムに接続されているスピーカーデバイスのリストを表示するには、マイクの許可が必要です。「マイクを許可」をクリックする","It seems mic is being used by other application. Close other applications to proceed.":"マイクは他のアプリケーションで使用されていると思われます。他のアプリケーションを閉じて先に進みます。","Camera & Microphone Error":"カメラとマイクのエラー","To enable permissions, click the Allow Camera & Mic button below":"許可を有効にするには、下の「カメラとマイクを許可」ボタンをクリックします","Network Connection":"ネットワーク接続","Check Passed":"チェック成功","Could not establish a network connection":"ネットワーク接続を確立できませんでした","Connect to a different network, or use a mobile hotspot.":"別のネットワークに接続するか、モバイルホットスポットを使用します。","Disable any VPN or firewall is connected.":"VPN またはファイアウォールが接続されている場合は無効にします。","Connection: Good":"接続：良好","Network Connection Error":"ネットワーク接続エラー","Can’t connect to network. Change your network or limited functionality will be available during event.":"ネットワークに接続できません。ネットワークを変更しないと、イベント中に利用できる機能が制限されます。","AdBlocker":"AdBlocker","AdBlocker not detected.":"AdBlockerは検出されませんでした。","AdBlocker detected. This may degrade your event experience.":"AdBlockerが検出されました。この場合、お客様のイベント体験が損なわれる可能性があります。","Disable adblocker for best experience.":"最高の体験を得るには、AdBlockerを無効にします。","You are using ":"使用中のもの ","Use Windows or Mac OS for best performance":"最高のパフォーマンスを得るには、Windows または Mac OS を使用してください","Browser Check":"ブラウザチェック","Check Passed.":"チェック成功。","Switch To Lite Mode":"ライトモードに切り替えます","Your pending Video Q&A request will be cancelled once you switch to lite mode":"保留中のビデオQ&Aリクエストは、ライトモードに切り替えた後にキャンセルされます","Stay on Live Mode":"ライブモードのまま継続する","Unable to mark as favorite":"お気に入りとしてマークできません","Event organizers must enter the event to select favorites.":"イベント主催者は、お気に入りを選択するにはイベントに参加する必要があります。","Make an Announcement":"発表する","STOP":"停止する","InPerson CheckIn App":"対面チェックインアプリ","App to Check-In In-Person attendees":"会場への参加者をチェックインするためのアプリ","SEE AGENDA":"アジェンダの確認","Please visit the Agenda tab to view the session recordings":"セッション録画を表示するには、「アジェンダ」タブにアクセスしてください。","The session recordings will be available soon in the Agenda tab":"セッション録画は、「アジェンダ」タブでまもなく利用できるようになります","FAILED!":"失敗しました！","Next session is beginning":"次のセッションが始まります","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"次のセッションに移りますか？ストリーミングは続行され、テレビは新しいセッションを放送します。","Banners":"バナー","Images":"画像","Screen Share":"スクリーンシェア","Browser might not have screen-recording permission on your computer.":"お使いのコンピューターでブラウザに画面記録の許可がない可能性があります。","Open System Preferences":"システム環境設定を開く","Error publishing screen because someone else started screen share already.":"他のユーザーがすでにスクリーンシェアを開始しているため、画面の公開中にエラーが発生しました。","Live Feed":"ライブ映像","Check Your Network":"ネットワークを確認する","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"ビデオの再生中にエラーが検出されました。ビデオの再生に問題がある場合は、ページを更新するか、ライトモードに切り替えてみてください。","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"ビデオの再生中にエラーが検出されました。ビデオの再生に問題がある場合は、ページの更新をお試しください。","All Dates":"すべての日付","All Tracks":"すべてのトラック","Create Ticker":"ティッカーの作成","Booths Closed":"ブースは閉まりました","Your event organizer has closed all the booths. You will now be redirected to the stage":"イベント主催者がすべてのブースを閉めました。ステージへリダイレクトされます。","Visit the Polls tab to view live results.":"「投票」タブにアクセスして、ライブ結果を表示します。","A new poll is open! Visit the Polls tab to vote.":"新しい投票所が開きました。「投票所」タブにアクセスして投票します。","Vote for Polls":"「投票所」で投票する","Go to Polls Tab":"「投票所」タブに移動","Microphone audio too low":"マイクの音声が小さすぎます","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"音声に問題が検出されました。問題が解決しない場合は、ミュート/ミュート解除するか、別のデバイスをご使用されることをお勧めします。","Audio/Video bitrate too low":"音声/ビデオのビットレートが低すぎます","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"ネットワークファイアウォールの設定により、A/V ストリームがブロックされています。別のネットワーク接続に切り替えることを推奨します。","Error sharing screen":"スクリーンシェアのエラー","A network error occurred while sharing screen. Please check your network connection.":"スクリーンシェア中にネットワークエラーが発生しました。ネットワーク接続を確認してください。","Apologies, due to some errors, we need to refresh the page!":"申し訳ございません、エラーが発生したためページを再読み込みする必要があります。","Warning":"警告","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"ビデオに問題が検出されました。この問題を解決するには、デバイスで実行されている他のブラウザタブまたは他のアプリケーションを閉じて、インターネット接続を確認/アップグレードすることを推奨します。","No results found":"結果が見つかりませんでした","Audio":"オーディオ","Please choose another microphone and camera":"別のマイクとカメラを選択してください","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"現在選択されているマイクとカメラが作動していません。他のマイクとカメラを下のドロップダウンから選択してください。","The currently selected camera is not working. Please choose another camera in the dropdown below.":"現在選択されているカメラは作動していません。下のドロップダウンから別のカメラを選択してください。","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"カメラなしで続行できますが、スムーズなブロードキャスト体験を確保するために競合を解決されることを推奨します","Please choose another microphone":"別のマイクを選択してください","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"現在選択されているマイクが作動していません。下のドロップダウンで別のマイクを選択してください。","Please check that your TV speaker is correct":"テレビのスピーカーが正しいことを確認してください","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"現在選択されているスピーカーが作動していません。下のドロップダウンから別のスピーカーを選択してください。","Your answer":"あなたの回答","Edit":"編集","Delete":"削除","Settings":"設定","Signing Out":"サインアウトしています","Confirming your account...":"あなたのアカウントを確認中です...","Something Went Wrong. Please Retry :(":"何らかの問題が発生しました。もう一度お試しください :(","Resending Mail":"メールの再送信","offline":"オフライン","I am inviting you to a video meeting:":"あなたをビデオミーティングに招待します:","Resending secure login link to your email":"セキュアなログイン用リンクをあなたのメールに再送信します","Sending secure login link to your email":"セキュアなログイン用リンクをあなたのメールに送信します","Something went Wrong. Please Retry :(":"何らかの問題が発生しました。もう一度お試しください :(","Updating your password":"あなたのパスワードを更新します","Sending mail":"メールを送信します","Verifying":"検証します","This might be slower than usual":"このため通常より遅くなる場合があります","Checking":"確認します","New results available! Refresh!":"新しい結果が利用できます!更新してください!","Saving":"保存します","Turn off Attendee mode":"出席者モードをオフにする","See Attendee View":"出席者ビューを見る","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"現在このセッションを閲覧している出席者の総数。注記: 主催者以外には秘密","Session Count":"セッション数","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"現在ライブセッションを閲覧している出席者の数注記: 主催者以外には秘密","Role":"役割","Total Attendees":"総出席者","Total number of attendees online at this time Note: This is for organizer eyes only":"今回オンラインでつながっている出席者の総数。注記: 主催者以外には秘密","My Profile":"マイプロフィール","Languages":"言語","Filling out your profile can help you connect with people with similar interests.":"ご自分のプロファイルを記入すれば、類似の興味を持つ参加者とつながるのに役立ちます。","type to search for your address":"入力してあなたのアドレスを検索します","Could not open direct call":"ダイレクトコールを開くことができませんでした","Chat messages can only be published from inside a broadcast.":"チャットメッセージはブロードキャスト内部からのみパブリッシュできます。","Stage Logo can only be published from inside a broadcast.":"ステージロゴはブロードキャスト内部からのみパブリッシュできます。","Loading Speakers":"スピーカーを読み込みます","Raise hand is disabled for organizer accounts, but active for attendee accounts":"レイズハンド・オプションは主催者アカウントには無効ですが、出席者アカウントにはアクティブになっています","Disabled in lite mode, return to live if you’d like to raise hand!":"ライトモードが無効になっています、手を挙げたい場合はライブへ戻ってください!","Raise hand to enter stage for video q&a":"手を挙げてビデオ Q&A のためにステージに入ります","Speakers":"スピーカー","Hosting organization: {organization}":"組織のホスティング: {organization}","Failed to switch {deviceTag}":"{deviceTag} を切り替えることができませんでした","Make sure your {deviceTag} is not being used by any other application and is working properly.":"{deviceTag} が他の何らかのアプリケーションに使用されておらず、かつ正常に作動していることを確認してください。","Facing issues with audio or video? Switch on lite mode":"オーディオやビデオに問題が出ていますか?Lite モードへ切り替えてください","Failed to get event for eventID: {eventID}":"eventID: {eventID} 用のイベントを取得できませんでした","Error while playing video.":"ビデオを再生中にエラーが発生しました。","Speakers only, attendees can\'t see this chat":"スピーカーのみ、参加者はこのチャットを見ることができません","Kudo":"Kudo","Room":"ルーム","Session":"セッション","Booth":"ブース","Public":"公開","Drift":"ドリフ","Slides":"スライド","Videos":"ビデオ","Chat":"チャット","Messages":"メッセージ","Poll":"投票","Docs":"ドキュメント","Q&A":"質疑応答","Media":"メディア","Messages Chat":"メッセージチャット","Leaderboard":"リーダーボード","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"注記: あなたはこのイベントのスピーカーでもあります。あなたはいつでもバックステージに入り、ステージに上がることができます。","Switch to Attendee View":"出席者ビューへ切り替える","Return to Organizer View":"主催者ビューに戻る","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"出席者ビューをオフに切り替えると、現在のページを再読み込みし、主催者ビューに戻します。続けますか?","Switch":"スイッチ","Request Sent":"リクエストが送られました","Your request for a demo has been submitted":"デモの要求が送信されました","Organizer Redirection":"主催者のリダイレクト","YES, REDIRECT":"はい、リダイレクトします","DISMISS":"却下","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"出席者は次のセッションにリダイレクトされているところです: {title}。あなたも次のセッションにリダイレクトされたいですか？","Stage":"ステージ","Rooms":"ルーム","Join a round table to discuss moderated topics with your fellow attendees":"ラウンドテーブルに参加し、モデレートされたトピックスを他の参加者と話し合う","Booths":"ブース","Join a booth to know more about a sponsor":"ブースに参加し、スポンサーのことを詳しく知る","You are in the booth":"あなたはブースに入っておられます","People":"参加者","Connect with your fellow attendees":"他の参加者とつなぐ","Connect with speakers":"スピーカーとつなぐ","starting in {duration}":"あと {duration} で開始します","You will be redirected to booths in {duration}":"あと {duration} でブースにリダイレクトされます","booths":"ブース","agenda":"アジェンダ","You will be redirected to {word} in {duration}":"あと{duration} で {word} へリダイレクトされます","You will be redirected to the live stage in {duration}":"あと {duration} でライブステージへリダイレクトされます","- You are about to be redirected to {tabTitle} in {duration}":"- あと {duration} で {tabTitle} へリダイレクトされようとしています","See Agenda":"アジェンダの確認","Break":"中断","{title} is now live":"{title} は現在ライブです","Apologies, due to an error we need to refresh the page!":"申し訳ございません、エラーが発生したためページを更新させていただく必要があります。","Network interruption detected":"ネットワークの中断が検出されました","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"あなたのインターネット接続に何らかの問題が発生しています。VPN をご使用の場合は、無効にすることを検討してください。あるいは、別のネットワークに接続してみてください","No audio output device detected":"オーディオ出力デバイスが検出されません","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"スピーカー/ヘッドフォンを接続し、ギアのアイコンを使って問題が起きているかどうかテストしてください。","Please disable ad blocker for this page":"このページに関してアドブロッカーを無効にしてください","Yes, I understand":"はい、わかりました","No event user found so attended not marked!":"イベントユーザーが見つからなかったため、マークされませんでした。","Wait while the speaker approves your video q&a request":"スピーカーがビデオ Q&A リクエストを承認するまで待ちます","Organizer":"オーガナイザー","UPNEXT":"次へ","Ended":"終了","Hide":"非表示","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"このページはあと {durationLeftToRedirect} 秒で自動的にリダイレクトされます。","Register":"登録","Error: User unable to be registered for this event. Please contact event organizer for assistance":"エラー: ユーザーはこのイベント用に登録できません。イベント主催者に連絡を取りヘルプを求めてください","You are already registered!":"すでに登録されています!","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"このイベントにはすでに登録されていると思われます。まだ確認を受け取りになれない場合は、登録確認が到着していないかどうかスパム用フォルダーを点検してみてください。さらにヘルプが必要な場合、イベント主催者に連絡をお取りください","Thank you for registering!":"登録に感謝します!","Submit another response":"別の応答を提出する","Share":"シェア","Know someone who want to attend this?":"これに参加したい人物を知っていますか?","COPY LINK":"リンクをコピー","Powered by":"搭載","VIEW PROFILE":"プロファイルの表示","You can access the event landing here":"ここからイベントのランディングページにアクセスできます","Need Help?":"お困りですか？","Welcome back":"ようこそお戻りを","Checking...":"チェックしています...","Close":"閉じる","Enter":"参加","See {roomCount} Room(s)":"{roomCount}部屋を見る","Back":"戻る","Request a Demo":"デモを要求する","Loading":"読み込み中","Thread":"スレッド","Load more":"追加で読み込む","Heads up!":"警告","YES":"はい","No":"いいえ","Following":"フォロー中","Error in loading drimify":"Drimify を読み込みの際にエラーが発生","You\'re not registered for this event":"あなたはこのイベントに登録されていません","Check out other events":"他のイベントをチェックする","Date":"日付","Location":"場所","How are you attending the event":"どのような形でイベントに参加されていますか","In Person":"直接生で","Virtually":"仮想的に","Event Widgets":"イベントのウィジェット","Chat • Messages • Q&A • Poll • Docs":"Chat • Messages • Q&A • Poll • Docs","DISCUSSION":"ディスカッション","JOIN":"参加","WAIT":"待機","more":"その他","See Profile":"プロファイルの確認","Filter":"フィルター","Video player not supported by your browser":"お使いのブラウザーはビデオプレーヤーに対応していません","We recommend using the latest version of Google Chrome to access your conference":"あなたの会議にアクセスするにはGoogle Chromeの最新バージョンをお使いになることを推奨します","ANSWER":"答える","REJECT":"拒否する","Don’t ask me this next time":"今後、このメッセージを表示しない","Cancel":"取り消し","Lite Mode":"Liteモード","On":"オンに","Connection Issues? Turn on Lite Mode":"接続の問題ですか?Lite モードをオンにしてください","Turn On Lite Mode":"Lite モードをオンにしてください","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"ライトモードではライブブロードキャストと画面上に映るものとの間に30秒の遅延が生じます。続けますか?","Turn On":"オンにする","Lite Mode Active!":"ライトモードがアクティブになりました！","Thanks for your patience, lite mode now on!":"お待たせいたしましt、現在ライトモードがオンになっています。","Turn off Lite Mode?":"ライトモードをオフにしますか？","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"ライトモードを切って、ライブブロードキャストの鑑賞に戻ります。ご注意ください、これを行えば追いつくまでに30秒のギャップが生じます。","Lite Mode Off!":"ライトモードはオフです！","Thanks for your patience, we’ve returned to the live broadcast!":"お待たせしました、ライブブロードキャストへ戻りました。","Lite Mode Unavailable":"ライト・モードは利用できません","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"ご不便をおかけして申し訳ございません。ライトモードが現在ご利用できませんので、ライブブロードキャストへ切り替えてセッションを再開してください。","Turn off Lite mode?":"ライトモードをオフにしますか？","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"お使いの接続が正常へ戻りましたことを検出しました。ライブブロードキャストへ切り替えて戻られますか?ご注意ください、これを行えば追いつくまでに30秒のギャップが生じます。","Turn Off":"OFFにする","Lite mode is disabled for organizer accounts, but active for attendee accounts":"Liteモードは主催者アカウントには無効ですが、出席者アカウントには有効になっています","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"お使いのブラウザではLiteモードはサポートされていません。Google Chromeの最新バージョンをお使いになることを推奨します","Lite mode is not curently available. We’ll let you know once it’s available again":"ライトモードは現在利用できません。再度利用できるようになればお知らせします","Turn off Lite Mode":"ライト・モードを切る","We’ll let you know when Lite mode is available again":"Liteモードが再度利用できるようになればお知らせします","Lite Mode Available":"Liteモードを利用できます","Loading Lite Mode...":"ライトモードを読み込んでいます...","Turning Off Lite Mode":"ライト・モードを切る","Lite Mode On":"ライト・モードがオンです","Audio/Video Issues?":"オーディオ/ビデオの問題ですか?","Error":"エラー","Click a video to play":"動画をクリックして再生する","Error starting video!":"エラーが発生してビデオを開始できませんでした。","Please rotate your device to {mode} mode":"お使いのデバイスを {mode}モードに回転してください","landscape":"横長","portrait":"縦長","Thank you for attending this event!":"このイベントへの参加に感謝します。","Go to Rooms":"ルームへ移動","Please use a desktop or laptop Google Chrome browser to access your conference":"デスクトップまたはラップトップの Google Chrome ブラウザーを使用してあなたの会議にアクセスしてください","If on Desktop":"デスクトップにある場合","Please increase the width of your window":"ウィンドウの幅を広げてください","Alternatively, check out the":"あるいは、次をチェック","Youtube Livestream":"Youtube のライブストリーム","Search":"検索","Profile":"プロファイル","Yes":"はい","Loading Chat":"チャットの読み込み中","Please wait while we fetch the chat":"チャットをフェッチするあいだ待機してください","Load old messages":"古いメッセージを読み込む","Join the room to see chat":"ルームに参加してチャットを見る","Live Chat":"ライブチャット","Uh..oh we couldn\'t load the content":"おっと、コンテンツの読み込みができませんでした","Please reload the page":"ページを再読み込みしてください","New comments":"新規コメント","Start the conversation":"会話を始める","Be the first to add to chat!":"一番乗りでチャットに参加しましょう。","Enter your message":"メッセージを入力","Joining chat!":"チャットに参加!","See all pinned messages":"すべてのピン留めしたメッセージを確認","Failed to send! Retry?":"送信できませんでした。再試行しますか?","Search for attendee":"参加者の検索","Up to date":"最新","Start a new conversation, We think you\'ll enjoy":"新規の会話を開始してください、お楽しみいただけると思います","chatting with these recommended attendees!":"これらの推奨される参加者とチャットする","Searching":"検索中","Load Previous":"前のものを読み込む","Load Next":"次を読み込む","Loading Channel":"チャネルの読み込み","Please wait while we fetch the channel":"チャネルをフェッチする間お待ちください","Please wait while we fetch the messages":"メッセージをフェッチする間お待ちください","Send the first message":"最初のメッセージを送る","Join":"参加","link":"リンク","download":"ダウンロード","Click to open":"クリックして開く","No open polls":"開放中の投票はありません","Check back later to see if a poll opens up!":"後ほどもう一度ポールが開いていないかどうか確認してください。","Loading Poll":"投票の読み込み","Please wait while we fetch the polls":"投票をフェッチする間お待ちください","Uh oh.. we couldn’t load the content":"おっと、コンテンツを読み込みできませんでした","Polls":"投票","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"ポールを開始するには、Goldcast 管理者パネルでこのセッションに質問と応答を追加します","Stop Sharing":"共有の停止","Can\'t publish polls while something else is being presented on stage":"他の何かがステージでプレゼンされている間はポールをパブリッシュできません","Open":"開く","Cancel your video q&a request":"ビデオ Q&A リクエストの取り消し","Pending...":"保留中...","Leave Stage":"ステージを終了する","Raise Hand":"挙手する","Text Q&A":"テキスト版 Q&A","Video Q&A":"ビデオQ&A","Loading Q&amp;A":"Q&amp;A の読み込み","Please wait while we fetch the Q&amp;A":"Q&amp;A をフェッチするあいだお待ちください","Uh oh.. we couldn\'t load the content":"おっと、コンテンツを読み込みできませんでした","No Questions Yet":"まだ質問がありません","Tell your audience to send in questions!":"オーディエンスに質問を送るように指示してください。","Be the first to ask a question!":"最初の質問者になってください。","Tell your audience to raise their hand!":"オーディエンスに手を挙げるように指示してください。","Approve":"承認","Reject":"拒否","End":"終了","RELOAD":"再読み込み","Logos On Stage":"ステージのロゴ","No File Chosen":"選択されたファイルはありません","loading":"読み込み中","Can\'t publish a slide when there is something else being presented on stage":"ステージ上で何か他のことがプレゼンされている時は、スライドをパブリッシュできません","Change Deck":"デッキの変更","stop-screen-share":"stop-screen-share ボタン","screen-share":"screen-share ボタン","Select a deck to begin presenting":"デッキを選択してプレゼンを開始します","CONFIRM":"確認","If you’re having issues, please refer to the":"問題があるようでしたら、参照してください","SPEAKER":"スピーカー","Issue Testing Audio!":"オーディオのテスト中に問題が生じました!","VPN and adblockers may cause video issues, please disable them before proceeding":"VPN とアドブロッカーを使うとビデオの障害が発生する可能性があります、続行する前にそれらを無効にしてください","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"注記として、VPN およびアドブロッカーを使うとビデオに障害が発生する可能性がありますので、ブロードキャスト中は無効のままにしておいてください","Follow":"フォロー","Read More":"詳細を読む","Ask a question":"質問する","Shared":"共有","Answered":"解答済み","Waiting Approval":"承認を待っています","cancel":"取り消し","ENTER":"参加","Upcoming Events":"今後のイベント","Past Events":"過去のイベント","Goldcast":"Goldcast","MANAGE EVENT":"イベントの管理","Edit Profile":"プロファイルの編集","Stay tuned!":"チャンネルを変えないでください。","Sign-in instructions will be available here 12 hours prior to the event":"サインインの方法はイベントの12時間前にここから入手できます","Please log out":"ログアウトしてください","Logout":"ログアウト","Continue as {differentUser}":"{differentUser} として継続します","You are already logged in as {user}.":"あなたは既に{user}としてログインしています。","EMAIL":"メール","user@email.com":"user@email.com","FIRST NAME":"名","First Name":"名","LAST NAME":"姓","Last Name":"姓","You are not registered to this event":"あなたはこのイベントに登録されていません","Please enter your email and name":"あなたのメールアドレスと名前を入力してください","Please enter your email":"あなたのメールアドレスを入力してください","We have sent a secret code to":"シークレットコードを次のところへ送りました","BACK":"戻る","Didn\'t receive an email? Make sure to check spam list":"メールを受け取られませんでしたか？スパムリストを点検してください","Resend Mail":"メールの再送信","SECRET CODE":"シークレットコード","Please enter the temporary password sent to your email":"あなたのメールアドレスへ送られた仮パスワードを入力してください","NEW PASSWORD":"新規パスワード","Please enter a new password":"新規パスワードを入力してください","CONFIRM PASSWORD":"パスワードの確認","Please re-enter the new password":"新規パスワードを再入力してください","Password length should be atleast 8":"パスワードの長さは8以上必要です","Password and Confirm Password don\'t match !!":"パスワードと確認用パスワードが一致しません!!","Please enter your password to continue":"続けるにはパスワードを入力してください","Logging you in...":"あなたは...にログインしています","PASSWORD":"パスワード","Forgot credentials?":"認証情報をお忘れですか?","Forgot Password? A mail will be sent to your registered email.":"パスワードを忘れましたか？あなたの登録メールアドレスへメールが送られます。","Email cannot be blank!!":"電子メールは空白にできません!!","We have sent a secure login link to":"セキュアなログインのリンクを次の先へ送信しました","from":"送信元","Please use that to access your event.":"それを使ってイベントにアクセスしてください","Please check spam/promotion too if you can\'t find it.":"見つからなければスパム/販促ツールもチェックしてください。","Thank You !":"ありがとうございます。","The link is not valid.":"リンクが有効ではありません。","Please be patient.":"しばらくお待ちください。","We are verifying your link.":"リンクを確認しています。","Thank you for entering the code!":"コードを入力してくださりありがとうございます。","Please create a new password":"新規パスワードを作成してください","Signing you up...":"あなたは...サインアップしています","We have sent a temporary password to":"仮パスワードを次のところへ送りました","TEMPORARY PASSWORD":"仮パスワード","Please enter the temporary password sent to your mail":"あなたのメールアドレスへ送信した仮パスワードを入力してください","Password Length should be 8":"パスワードの長さは8です","Okay":"オーケー","Backstage: {title}":"バックステージ: {title}","Prep Area":"準備エリア","Starting at {time}":"{time} に開始します","person":"人物","inside":"内部","No one is inside":"誰も入室していません","This area is for you to sync up with your fellow speakers before you go on stage.":"このエリアはステージへ上がる前に仲間のスピーカーと同期を取るための場所です。","This area is for you to check your cam and mic before you enter the room.":"このエリアはルームに入る前にカメラとマイクを点検する場所です。","I\'m Ready":"準備できました","Watch Live":"ライブで見る","Backstage":"バックステージ","You are sharing your screen":"スクリーンをシェアしています","LIVE":"ライブ","Live":"ライブ","Virtual":"バーチャル","Only available for ":"専用の利用者: ","See Booths":"ブースの確認","See Rooms":"ルームの確認","Enter Backstage":"バックステージに参加","This track has no upcoming sessions. Check out a different track.":"このトラックには、次回のセッションがありません。違うトラックもチェックしてください。","View":"表示","Agenda":"アジェンダ","Scroll to see all tracks":"スクロールしてすべてのトラックを見る","No Agenda Items to show!":"表示するアジェンダアイテムがありません。","ENTER EVENT":"イベント参加","change":"変更","Upload":"アップロード","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG、GIF または PNG。最大サイズは5MB","Create Profile":"プロファイルの作成","Email":"メール","Company":"会社","Title":"役職","No matching locations found":"一致するロケーションが見つかりません","You can try searching for the location with another keyword":"別のキーワードでロケーションを検索してみることができます","Interest Tags":"タグの挿入","Pick your first tag":"最初のタグの選択","Save":"保存","Searching...":"検索中...","Twitter":"Twitter","Select Your First Tags":"最初のタグを選択する","Add Interest tags":"関心対象タグを追加する","Congratulations!":"おめでとうございます。","Your first Goldcast event is set up":"あなたの最初の Goldcast イベントがセットアップされました","You can always visit":"いつでもアクセスできます","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"イベントをセットアップして実行する方法についての指示が必要な場合","See My Event":"マイ・イベントを見る","Peak Community":"ピーク・コミュニティ","Loading Lite Mode... This may take up to 30s":"ライトモードを読み込んでいます...これには最大30秒かかります","Loading Video...":"ビデオを読み込み中...","Video will begin at session start time":"映像はセッション開始時刻に始まります","TIME":"時間","TITLE":"役職","STATUS":"ステータス","END":"終了","START":"開始する","AGENDA":"アジェンダ","Enable Audio":"オーディオを有効にする","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"ブラウザーの自動再生ポリシーのためオーディオがミュートにされました。下の有効化をクリックしてミュートを解除します。エンベデッドコントロールによって後ほどオーディオのミュートを解除することもできます。","Enable":"有効にする","You are being redirected outside the room. Would you like to continue?":"あなたはルームの外へリダイレクトされます。続けますか?","Continue":"続ける","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"あるいは、ライブブロードキャストから30秒ディレイのあるライトモードを使用することもできます","We detected a network issue":"ネットワークの問題を検出しました","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"VPN/ファイアウォール経由で接続していないことをご確認ください。問題が解決しない場合はネットワークまたはブラウザー、デバイスを変更してみてください。","Could not connect":"接続できませんでした","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"これはセキュアなネットワーク、ブラウザー/デバイスの問題である可能性があります。この問題が解決しない場合はネットワーク、ブラウザー、デバイスを変更してみてください","Switch to Lite Mode":"ライトモードに切り替えます","Leave":"退席","Screenshare had an issue":"スクリーンショットに問題がありました","Could not share screen unexpectedly. Refresh & retry. On mac go to":"突然、画面の共有ができなくなりました。更新して再試行します。Mac では次へ移動","and check if your browser has the required permission":"また、ブラウザーに必要な許可が備わっているかどうか確認します","Uh OH... Something went wrong":"まずい、何か障害が起きました","To fix this, click the":"これを修復するには、次をクリック","in your URL bar, then select “Allow”, and then click “Try Again”":"あなたの URL バーで、次いで “Allow” を選択し、続いて “Try Again” をクリックします","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"不明な理由のためあなたのメディアストリームを開始できませんでした。ブラウザーが弊社プラットフォームに対応していない可能性があります。弊社としては、「Google Chrome」の使用を推奨します。この問題が解決しない場合は、Goldcast サポートに連絡してください","To fix this, make sure your":"これを修復するには、次を確認する","is not being accessed by any other app. If not, please try changing your":"には、他のアプリはアクセスしていません。違う場合は次を変更してみてください","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"「設定に移動」 をクリックしてデバイスを可能性のある問題を解決したあと、「Try Again」を押してください。","Go To Settings":"設定へ移動","Try Again":"再度試す","Try Joining without Video":"ビデオなしで参加を試みる","A refresh and rejoin should work":"更新して再参加すればうまく行くはずです","Refresh & Rejoin":"リフレッシュして再参加","Start Chat":"チャットの開始","On Stage":"オンステージ","Connect your on-site camera and microphone to present to your virtual attendees":"現場のカメラとマイクを接続し、仮想参加者に対して発表を行うことができます。","Stop Streaming":"ストリーミング停止","Start Streaming":"ストリーミング開始","Set up on-site video feed":"現場ビデオ配信の設定","Open TV":"オープンTV","Layout: {layout} ":"レイアウト: {layout} ","With Speaker Videos":"スピーカーのビデオ付き","Full Screen":"フルスクリーン","No Speakers":"スピーカーなし","Turn Off Setup Mode":"セットアップモードをオフにする","Setup Mode":"セットアップモード","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"{roomTitle}のセットアップモードを停止する場合は、[電源を切る] を押します。この操作を行うとアクティブなストリームもオフになります。","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"ストリーミングの準備中：{roomTitle}。ライブのロケーションからのみのストリーミングにはセットアップモードをお使いください。","Starting in {duration}":"あと {duration} で開始します","Can\'t share screen while there is something else being presented on stage":"ステージ上で何か他のことがプレゼンされているため画面を共有できません","You are now in attendee view!":"あなたは現在出席者ビューにいらっしゃいます。","You are now in organizer view!":"あなたは現在主催者ビューにいらっしゃいます。","Note :":"メモ:","Only organizer accounts can see this tag, normal attendees can’t see this":"主催者のアカウントだけがこのタグを見ることができ、普通の出席者は見ることができません","Attendee":"出席者","Event Information":"イベント情報","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"イベント情報は主催者だけが見ることができます! <br />このセクションは、出席者には表示されません。","Operating System":"オペレーティングシステム","Secondary Booths":"第2ブース","Sort":"ソート","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"{track2}をフォロー中です {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2}により自動的に{track1_Would_you_like_to_continue}からアンフォローされます","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}継続しますか?","Track only available for {tracks}":"トラックは{tracks}にだけ利用できます","Add to Calendar":"カレンダーへ追加","Open Speakers Control Panel":"スピーカーのコントロールパネルを開く","Move Offstage ↓":"オフステージに移動 ↓","Error Moving ⚠":"移動中にエラーが発生しました ⚠","Off Stage":"オフステージ","Move to Stage":"ステージへ移動","An error occurred!":"エラーが発生しました。","{eventName} Documents":"{eventName} 文書"," Set Up Mode":" セットアップモード","Camera & Mic blocked":"カメラとマイクがブロックされました","Camera/Mic Inaccessible":"カメラまたはマイクにアクセスできません","Camera/Mic Not Found":"カメラまたはマイクが見つかりません","Camera Inaccessible":"カメラにアクセスできません","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"カメラがすでに使用中か、またはこの解像度に対応していません。お使いのカメラが別のアプリケーションに使用されていないことを確認し、再度お試しください。","No microphone/camera is found":"マイクまたはカメラが見つかりません","The browser does not support using camera and microphone!":"ブラウザーがカメラとマイクの使用に対応していません。","{n} Slides":"{n} つのスライド","Starting in {timeduration}":"あと {timeduration} で開始します","{eventtitle} has ended":"{eventtitle}は終了しました","This is a text q&a question!":"これは質疑応答テキストの質問です。","Click here{if_it_does_not}":"{if_it_does_not}ここをクリックします","{click_here}if it does not":"できない場合は {click_here}","{title}up next":"{title}次にスタート","seat(s) open":"席が空いています","Signal strength is low. Close other windows or connect to a different network.":"信号強度が低いです。他のウィンドウを閉じるか、別のネットワークに接続してください。","GO BACKSTAGE":"バックステージへ移動","LEAVE STAGE":"ステージを終了する","LEAVE":"退席","This event begins on{startitme}":"このイベントは{startitme}に開始されます","Please refresh to enter.":"リフレッシュして入室してください。","people":"参加者","Oops, Something went wrong":"おっと、問題が発生しました","Back Home":"ホームへ戻る","Deciding where to go ...":"行き先を決定しています...","Go to Event Hub":"イベントハブへ移動する","CREATE":"作成","Attending Virtually":"仮想的に参加する","Attending In Person":"生で参加する","Click to change your attendance type":"クリックして参加のタイプを変更する","Open Chat":"オープンチャット","Create your profile for {eventtitle}":"{eventtitle}用のプロファイルを作成","Move to stage":"ステージへ移動","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"イベントのオーガナイザーがあなたを <strong>{broadcastTitle}</strong>のステージへ移動させるように要求しました。<br /><br />ここをクリックして要求を承認された場合、あなたはイベント参加者に対しライブで見えるようになります。<br /><br />","Go Live On Stage":"ステージでライブに切り替える","Moved to backstage":"バックステージへ移動","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"オーガナイザーがあなたをステージから退去させました。オーガナイザーに連絡することなく再参加を試みないでください。","Error creating Screen stream":"スクリーンのストリームを作成中にエラーが発生しました","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"画面を共有する許可が与えられていません。*ここをクリック*してトラブルシューティング資料に目を通してください。","Error publishing stream":"ストリームをパブリッシュ中にエラーが発生しました","Could not publish stream. Please refresh and try again!":"ストリームをパブリッシュできませんでした。リフレッシュして再度お試しください。","Error publishing screen":"スクリーンをパブリッシュ中にエラーが発生しました","Error publishing screen. Please refresh and try again!":"スクリーンをパブリッシュ中にエラーが発生しました。リフレッシュして再度お試しください。","Error unpublishing stream":"ストリームをアンパブリッシュ中にエラーが発生しました","Error unpublishing stream. Please refresh and try again!":"ストリームをアンパブリッシュ中にエラーが発生しました。リフレッシュして再度お試しください。","Invalid Publish Operation":"無効なパブリッシュ操作です","{username} profile picture":"{username} プロフィール画像","Default":"デフォルト","A-Z":"A-Z","Random":"ランダム","All":"すべて","Past":"過去の","Upcoming":"今後の","Learn More":"詳細を知る","close":"閉じる","Discussion Rooms":"ディスカッションルーム","ATTENDEE MODE":"参加者モード","Loading...":"読み込み中...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"デバイスがブラウザーにより無効にされたか、使用の許可が与えられませんでした。許可を取得し、「Try again」をクリックしてください","You are now registered. You will receive an email confirming details shortly.":"登録が完了しました。詳細確認用のメールがまもなく届きます。","Streaming to Virtual Users from on-site video feed":"現場のビデオフィードから仮想ユーザーへストリーム配信しています","Ending in ":"終了 ","GO LIVE":"ライブ配信する","You have no past events.":"過去のイベントはありません。","You have no upcoming or live events.":"次回やライブのイベントはありません。","left":"左","center":"中央","right":"右","top":"トップ","bottom":"ボトム","loading...":"読み込み中...","Loading ...":"読み込み中...","Failed to redirect!":"リダイレクトに失敗しました。","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"ブロッカーを有効にされたようです。これにより最も良好な体験ができなくなる可能性があります。無効にしてください。<br />&lt;br / &gt; このやり方についてヘルプが必要であれば、<a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>ここ</a>をクリックして詳細な説明をお読みください。","redirecting in {duration}":"{duration}でリダイレクトしています","STOP VIDEO":"ビデオを停止する","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"このビデオの再生を停止しようとしています。放送はライブ配信モードに戻り、オーディエンスはあなたのスピーカーを視聴できます。よろしいですか？","STOP SHARING":"共有の停止","No Next Slide":"次のスライドはありません","Next Slide":"次のスライド","No Previous Slide":"前のスライドはありません","Previous Slide":"前のスライド","something went wrong while recording the response please try again":"応答の記録中に問題が発生しました。もう一度やり直してください","Start In-Person Streaming":"会場でのストリーミングを開始","Stop In-Person Streaming":"会場でのストリーミングを停止","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"ビデオはバッファリングされており、テストセッションがまもなく開始されます。これは、実際のセッションでは発生しません。","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"ティッカーは、すべての参加者の Web ページ上部に表示されます。ティッカーをハイパーリンクに変えるには、以下にURLを入力します","Allow {key}":"{key}を許可する","{messageType} can only be published from inside a broadcast.":"{messageType} は、ブロードキャスト内からしか公開できません。","To grant {deviceName} access to this page, follow the two steps below:":"このページへの{deviceName}のアクセスを付与するには、次の 2 つの手順に従います。","2. Allow {deviceName} access and then refresh the page.":"2. {deviceName}のアクセスを許可し、ページを更新します。"}');

/***/ }),

/***/ 6600:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"이벤트 설정 드롭다운"," Stage Control":" 스테이지 제어","Stage Controls and Information":"스테이지 제어 및 정보","Live in ":"라이브 시작까지 ","Start Session":"세션 시작","End Session":"세션 종료","Present Screen":"화면 보여주기","Rehearse On Stage":"스테이지에서 리허설","Turn on Microphone":"마이크 켜기","Turn off Microphone":"마이크 끄기","Turn on camera":"카메라 켜기","Turn off camera":"카메라 끄기","rehearsal mode":"리허설 모드","People Watching: ${watchCount}":"시청 중인 사람: ${watchCount}","Turn on Audio":"오디오 켜기","Turn off Audio":"오디오 끄기","Are you sure you want to leave this room?":"이 방을 나가시겠어요?","you will be redirected to stage in":"곧 스테이지로 리디렉션 됩니다.","sec. . ":"초... ","Skip to Main Navigation":"메인 탐색으로 건너뛰기","Skip to Chat":"채팅으로 건너뛰기","Skip to Meeting Controls":"미팅 제어로 건너뛰기","LinkedIn":"Linkedin","Live in":"라이브 시작까지","UPCOMING":"다음","Rehearse on stage":"스테이지에서 리허설","Watch Rehearsal":"리허설 보기","Answered by:":"답변자:","Speaker Off":"스피커 끄기","Speaker On":"스피커 켜기","Speaker Controls":"발표자 제어","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"모든 스테이지 요소는 공유된 이미지 뒤에 표시됩니다. 전체 화면 이미지 공유가 중지되면 다시 표시됩니다.","Close Ticker Popup":"티커 팝업 닫기","Open GIF Picker":"GIF 선택기 열기","Open Emoji Picker":"이모티콘 선택기 열기","Send Message":"메시지 보내기","Tabs: Messaging and More":"탭: 메시징 및 기타","Thanks for attending!":"참석해 주셔서 감사합니다!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" 구독한 트랙에 예정된 세션이 없습니다.라이브 세션을 보려면 다른 트랙으로 전환하세요.","Redirecting you to ":"다음으로 리디렉션 중입니다. ","in ":"남은 시간: ","seconds":"초","Main Navigation":"메인 탐색","YOU ARE HERE":"현재 위치","Live Now":"지금 라이브 시작하기","SUBMIT":"제출","Allocated time for engagement has ended. You will be redirected to main stage":"참여에 할당된 시간이 종료되었습니다.메인 스테이지로 리디렉션됩니다.","Wrap up in":"종료까지","Session overrun by":"세션 시간 초과: ","Ending in":"종료까지 남은 시간:","Bring this session live?":"이 세션을 라이브로 진행하시겠어요?","START SESSION":"세션 시작","Bring this session to end?":"이 세션을 끝내시겠어요?","END SESSION":"세션 종료","Go On Stage":"스테이지로 이동","Muted by organizer":"주최자가 음소거함","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"이벤트 주최자 중 한 명이 회원님의 오디오를 음소거했습니다. 마이크 버튼을 클릭하여 음소거를 해제할 수 있습니다.","Gifs":"Gif","Stickers":"스티커","Launch Survey":"설문조사 시작","Microphone is on":"마이크가 켜져 있습니다.","Microphone is off":"마이크가 꺼져 있습니다.","Secret Code’s length should be 6 digits":"비밀 코드의 길이는 6자리여야 합니다.","Closing in 00:":"00 후 마감:","Submit":"제출","Questions":"질문","Preview":"미리 보기","Close Survey":"설문조사 닫기","This is a required question":"필수 질문입니다.","Enter the text you’d like to present on stage below.":"아래에서 스테이지에 표시하고 싶은 텍스트를 입력하세요.","Use Chrome/Edge for best performance":"최상의 성능을 위해 Chrome/Edge 사용","Do you want to launch your survey now?":"지금 설문조사를 시작하시겠어요?","Success! Your Survey has been launched for attendees.":"성공! 참석자를 위한 설문조사가 시작되었습니다.","Unable to publish. Please try again.":"게시할 수 없습니다. 다시 시도해 주세요.","Are you sure you want to close this survey?":"이 설문조사를 종료하시겠어요?","Success! Your Survey has been closed for attendees.":"성공! 참석자를 위한 설문조사가 종료되었습니다.","Unable to un-publish. Please try again.":"게시를 취소할 수 없습니다. 다시 시도해 주세요.","Please answer all required questions.":"필수 질문에 모두 답변해 주세요.","You have already submitted this survey.":"이미 이 설문조사를 제출했습니다.","Success! Thank you for your feedback.":"성공! 피드백을 보내주셔서 감사합니다.","Unable to submit. Please try again.":"제출할 수 없습니다. 다시 시도해 주세요.","Launch surveys will take over attendees\' engagement panel.":"시작 설문 조사는 참석자의 참여 패널을 대신합니다.","Closing this survey will remove it from attendees\' engagement panel.":"이 설문 조사를 종료하면 참석자의 참여 패널에서 제거됩니다.","Survey":"설문조사","Updating Survey...":"설문조사 업데이트 중...","Closing":"종료 중","Goldcast needs access to your camera and microphone":"Goldcast에서 카메라와 마이크에 대한 액세스가 필요합니다.","Goldcast needs access to your microphone":"Goldcast에서 마이크에 대한 액세스가 필요합니다.","Goldcast needs access to your camera":"Goldcast에서 카메라에 대한 액세스가 필요합니다.","SPEAKERS":"발표자","Mark as Unanswered":"답변되지 않음으로 표시","Mark as Answered":"답변됨으로 표시","Remove from Priority":"우선순위에서 제거","Mark as Priority":"우선순위로 표시","Answer":"답변","Enter answer...":"답변 입력...","Answered by":"답변자","Submit Answer":"답변 제출","Test your system’s speaker":"시스템의 스피커 테스트","Click \\"Yes\\" if you hear the sound.":"소리가 들리면 \'예\'를 클릭합니다.","Load previous":"이전 항목 로드하기","Hide Name":"이름 숨기기","Text Q&A is disabled in On Demand mode.":"온디맨드 모드에서는 텍스트 Q&A가 비활성화됩니다.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"텍스트 Q&A 한도에 도달했습니다. 참석자는 새로운 질문을 할 수 없습니다.","Sent to Q&A":"Q&A로 전송됨","Couldn\'t post as Q&A. Please try again.":"Q&A로 게시할 수 없습니다. 다시 시도해 주세요.","Yes this is being recorded":"예. 녹화 중입니다.","No this is not being recorded":"아니요. 녹화되고 있지 않습니다.","System\'s Speaker Check":"시스템 스피커 확인","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"이벤트 중에 들을 수 있는지 확인하려면 시스템 스피커가 제대로 작동하는지 확인하세요.","Click on “Test your system’s speaker” to proceed":"계속하려면 \'시스템 스피커 테스트\'를 클릭하세요.","Error while sharing message to screen. Post not found":"화면에 메시지를 공유하는 중 오류가 발생했습니다. 게시물을 찾을 수 없음","Lost connection to servers. Refresh your page to get live event experience.":"서버 연결이 끊어졌습니다. 라이브 이벤트를 경험하려면 페이지를 새로 고침하세요.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"VPN/방화벽이 인증을 방해하고 있습니다. 네트워크를 전환하거나 IT 팀에 문의하여 Goldcast에 원활히 액세스할 수 있도록 <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>이러한 도메인을</a> 허용해달라고 요청하세요.","It\'s taking too long":"너무 오래 걸립니다.","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"VPN을 통해 연결되었거나 방화벽이 켜져 있는 것 같습니다. Goldcast가 원활하게 작동할 수 있도록 이 <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>도움말 문서</a> 및 화이트리스트에 등록해야 하는 도메인을 확인하거나 네트워크를 변경해야 합니다.","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"VPN을 통해 연결되었거나 방화벽이 켜져 있는 것 같습니다. Goldcast가 원활하게 작동할 수 있도록 이 <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>도움말 문서</a> 및 화이트리스트에 등록해야 하는 도메인을 확인하거나 네트워크를 변경하거나 Lite 모드에서 세션을 시청하세요.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"네트워크 대역폭 부족으로 Goldcast 동영상 스트리밍 서비스를 연결할 수 없습니다. 라이브 스트리밍 서비스에 연결하려면 네트워크를 변경하세요.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"네트워크 대역폭 부족으로 Goldcast 동영상 스트리밍 서비스를 연결할 수 없습니다. Lite 모드로 전환하거나 네트워크를 변경하여 스트리밍 서비스에 연결하세요.","Most Upvotes":"최다 투표","Most Recent":"가장 최근","My Questions":"내 질문","Prioritized":"우선순위 지정됨","Approved":"승인됨","Unapproved":"승인되지 않음","Unanswered":"답변되지 않음","Failed to update answer. Please try again!":"답변을 업데이트하지 못했습니다. 다시 시도해 주세요!","Failed to post answer. Please try again!":"답변을 게시하지 못했습니다. 다시 시도해 주세요!","Failed to delete question. Please try again!":"질문을 삭제하지 못했습니다. 다시 시도해 주세요!","Survey Link":"설문조사 링크","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"전환을 하면 현재 페이지가 참석자 뷰로 다시 로드됩니다. 주최자 뷰로 다시 돌아가려면 프로필 드롭다운 메뉴에서 참석자 뷰 토글을 끄기로 전환하세요.","You haven\'t asked any questions yet":"아직 질문이 없습니다.","No prioritized questions":"우선순위가 지정된 질문 없음","Create prioritized list of questions for speakers by marking questions as priority":"질문을 우선순위로 표시하여 발표자를 위한 우선순위가 지정된 질문 목록 만들기","No Approved Questions":"승인된 질문 없음","Approve incoming questions to see list of approved questions":"들어오는 질문을 승인하여 승인된 질문 목록 확인","No Unapproved Questions":"승인되지 않은 질문 없음","No Answered Questions":"답변된 질문 없음","Answer a question on stage or with inline text":"스테이지에서 또는 인라인 텍스트로 질문에 답변하기","All questions are answered":"모든 질문에 대한 답변이 제공되었습니다.","Rate Your Experience":"경험 평가하기","How satisfied are you with Goldcast?":"Goldcast에 얼마나 만족하시나요?","What are the main reasons for your rating?":"이 평점을 준 주된 이유는 무엇인가요?","I am interested in seeing a demo of Goldcast":"Goldcast의 데모를 보고 싶습니다.","Thank You":"감사합니다.","Your feedback was successfully submitted.":"피드백이 성공적으로 제출되었습니다.","Tell us how we can improve...":"어떤 점을 개선하면 좋을지 알려 주세요...","1 Slide":"슬라이드 1장","Your internet connection is unstable.":"인터넷 연결이 불안정합니다.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"음소거 상태로 말하고 있는 것 같습니다. 마이크 아이콘을 클릭하여 음소거를 해제하세요.","The registration could not be completed! Please check that this email is allowed to register for the event.":"등록을 완료하지 못했습니다! 이 이메일을 해당 이벤트에 대해 등록할 수 있음을 확인하세요.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"이미 이 이벤트로 등록되어 있는 것 같습니다! 등록 확인 이메일을 받지 못한 경우, 스팸 폴더를 확인해 주세요. 더 도움이 필요하시면 이벤트 주최자에게 문의하세요.","Your registration could not be completed. This event has reached its registration capacity.":"등록을 완료하지 못했습니다. 이 이벤트는 등록 정원에 도달했습니다.","Image cannot be an svg":"svg은 이미지로 사용할 수 없습니다","This should be a valid linkedin url":"유효한 LinkedIn URL을 사용하세요","This should be a valid twitter url":"유효한 Twitter URL을 사용하세요","This should be a valid url":"유효한 URL을 사용하세요","Video":"동영상","Read Less":"간단히 보기","live":"라이브","Opened":"열림","In person only":"대면 전용","Stage Stream":"스테이지 스트림","Streaming not available":"스트리밍을 사용할 수 없음","Close TV":"TV 닫기","Streaming is not available for prerecorded and RTMP sessions":"사전 녹화된 세션 및 RTMP 세션에서는 스트리밍을 사용할 수 없습니다.","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"대면 참석자들이 가상 스테이지(슬라이드, Q&A 등)에서 무슨 일이 일어나는지 볼 수 있도록 컴퓨터를 TV 화면 또는 프로젝터에 연결하세요. 연결이 되면 TV 열기(OPEN TV)를 클릭하고 새 창을 TV 화면 또는 프로젝터로 드래그하거나 공유하세요. ","Close Setup Mode":"설정 모드 닫기","Help":"도움말","upcoming":"다음","ended":"종료됨","Remove from favorites":"즐겨찾기에서 삭제","Add to favorites":"즐겨찾기에 추가","PLAY RECORDING":"녹화본 재생","VIEW RECORDING":"녹화본 보기","VIEW RECORDINGS":"녹화본 보기","Virtual Backgrounds":"가상 배경","No Device Available":"사용 가능한 장치 없음","Needs permission":"권한이 필요합니다","Device not detected":"기기가 감지되지 않음","Camera is on":"카메라가 켜져 있음","Camera is off":"카메라가 꺼져 있음","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"동영상 미러링은 시청자에게 적용되지 않습니다. 시청자는 항상 미러링되지 않은 동영상을 보게 됩니다.","Mirror My Video":"내 동영상 미러링","Camera":"카메라","1. Click on Safari > Settings for this\\n            website":"1. Safari > 이 웹사이트의 설정을 클릭합니다.","1. Click the lock":"1. 브라우저의 주소 표시줄에 있는","icon in your browser’s address bar":"자물쇠 아이콘을 클릭합니다","3. Unmute":"3. 음소거 해제","and":"및","icons from stage control panel":"스테이지 제어판의 아이콘","icon from stage control panel":"스테이지 제어판의 아이콘","2. Set camera and microphone to “Allow”.":"2. 카메라와 마이크를 \'허용\'으로 설정합니다.","2. Set camera to “Allow”.":"2. 카메라를 \'허용\'으로 설정합니다","2. Set microphone to \\"Allow\\"":"2. 마이크를 \'허용\'으로 설정합니다","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. \'Goldcast가 카메라와 마이크에 액세스할 수 있도록 항상 허용\'을 선택합니다.","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. \'항상 Goldcast가 카메라에 액세스하도록 허용\'을 선택합니다.","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. \'항상 Goldcast가 마이크에 액세스하도록 허용\'을 선택합니다.","Questions?":"질문이 있으신가요?","If you’re having issues, check out our comprehensive":"문제가 있는 경우 당사의 종합적인","help docs":"도움말 문서를 참조하세요","Speaker is on":"스피커가 켜져 있음","Stop Test":"테스트 중지","Test your system’s audio":"시스템 오디오 테스트","Still can\'t hear any sound?":"여전히 아무 소리도 들리지 않습니까?","Microphone":"마이크","Audio is being played in system\'s default audio device.":"오디오가 시스템의 기본 오디오 장치에서 재생되고 있습니다.","Click to view/change audio device":"오디오 장치를 보거나 변경하려면 클릭하세요.","Speaker":"스피커","Play Recording":"녹화본 재생","Recording for this broadcast is currently being processed and will be available soon":"이 방송에 대한 녹화를 현재 처리 중이며 곧 이용할 수 있습니다.","You haven\'t favorited anything yet!":"아직 즐겨찾기한 항목이 없습니다.","Add an item to favorites by selecting the ♡ in the top right corner.":"오른쪽 상단 모서리에 있는 ♡를 선택하여 즐겨찾기에 항목을 추가합니다.","Session has ended":"세션이 종료되었습니다","System Check":"시스템 점검","Need help? Check out the":"도움이 필요하세요? 다음을 확인하세요","Skip Checks and Continue":"점검 건너뛰고 계속하기","Click the button above to run the test":"위의 버튼을 클릭하여 테스트를 실행합니다.","Test Screenshare":"테스트 화면 공유","Share message to stage":"스테이지에 메시지 공유하기","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"아래 티커에 사용할 텍스트를 입력합니다. 티커를 하이퍼링크로 변환하려면 URL을 입력하세요.","Ticker":"티커","Coffee Break! Be back in 10m.":"휴식 시간입니다! 10분 후에 돌아오겠습니다.","Enter Message":"메시지 입력","https://www.xyz.com":"https://www.xyz.com","Launch":"시작하기","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"질문을 제출해 주셔서 감사합니다. 현재 질문 중 하나가 승인되면 다른 질문을 제출할 수 있습니다.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"죄송합니다. 현재 질의응답이 비활성화되었습니다. 질의응답이 다시 활성화되면 질문을 제출할 수 있습니다.","Votes":"투표","Vote":"투표","is inviting you to a video call":"화상 통화에 초대합니다","ENTER ROOM":"방에 입장하기","Start the conversation!":"대화를 시작하세요!","Couldn\'t send message. Click here to retry.":"메시지를 보낼 수 없습니다. 다시 시도하려면 여기를 클릭하세요.","Couldn\'t add emoji. Please try again.":"이모티콘을 추가할 수 없습니다. 다시 시도해 주세요.","Couldn\'t remove emoji. Please try again.":"이모티콘을 삭제할 수 없습니다. 다시 시도해 주세요.","Couldn\'t delete message. Please try again.":"메시지를 삭제할 수 없습니다. 다시 시도해 주세요.","Couldn\'t pin message. Please try again.":"메시지를 고정할 수 없습니다. 다시 시도해 주세요.","Couldn\'t unpin message. Please try again.":"메시지를 고정 해제할 수 없습니다. 다시 시도해 주세요.","Today":"오늘","No messages yet":"아직 메시지가 없습니다","Messages from organizers and speakers appear here!":"주최자와 발표자의 메시지는 여기에 나타납니다!","Next Session is Starting":"다음 세션이 시작됩니다","Go to Next Session":"다음 세션으로 이동","I’d like to stay":"머물고 싶습니다","My favorites":"내 즐겨찾기","1. Click on the lock icon in your address bar":"1. 주소 표시줄에서 자물쇠 아이콘을 클릭합니다.","We recommend organizers and speakers use a desktop\\n        device":"주최자와 발표자는 데스크톱을 사용하는 것이 좋습니다.","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"참석자, 발표자 및 주최자에게 최상의 경험을 제공하려면\\n 데스크톱에서 Goldcast를 사용해야 합니다. 모바일 장치에서 방송할 경우 영상의 품질이 저하됩니다.","Watch Now":"지금 보기","Video progress time":"동영상 진행 시간","Total video duration":"총 동영상 길이","Rate Goldcast!":"Goldcast를 평가해 주세요!","Running Required Checks...":"필수 점검 실행 중...","Test Your Setup":"설정 테스트하기","Test your Computer Device, Microphone and Camera before you join the event":"이벤트에 참여하기 전에 컴퓨터 장치, 마이크, 카메라를 테스트하세요.","Speaker and microphone not working?":"스피커와 마이크가 작동하지 않습니까?","Passed":"통과","Fix Audio Issues":"오디오 문제 해결하기","Check if audio is being played in other sound devices connected to phone/tablet":"휴대폰 및 태블릿에 연결된 다른 사운드 장치에서 오디오가 재생되고 있는지 확인하세요","Check if correct audio device is chosen from the below dropdown":"아래 드롭다운에서 올바른 오디오 장치가 선택되었는지 확인하세요.","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"오디오를 재생해야 하는 위치에 올바른 오디오 장치가 선택되었는지 확인하려면 <a href=\'ms-settings:sound\'>여기를 클릭하세요</a>.","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"오디오를 재생해야 하는 위치에 올바른 오디오 장치가 선택되었는지 확인하려면 <a href=\'x-apple.systempreferences:com.apple.preference.sound\'>여기를 클릭하세요</a>.","Right click on the browser tab & click “Unmute Site”":"브라우저 탭을 마우스 오른쪽 버튼으로 클릭하고 \'사이트 음소거 해제\'를 클릭하세요","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"브라우저의 탭이 음소거 해제되어 있는지 확인하거나 Window > 이 탭 음소거 해제하기를 클릭합니다.","System Check Failed!":"시스템 점검 실패!","System Check Passed!":"시스템 점검 통과!","Complete checks to proceed":"계속 진행하려면 점검을 완료하세요","Enter Event":"이벤트 참여하기","Skip Screen Sharing Check? ":"화면 공유 확인을 건너뛰시겠어요? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"이벤트에서 화면을 표시해야 하는 경우 화면 공유 확인을 완료하는 것이 좋습니다.","Ignore & Enter Event":"무시 및 이벤트 입장","Test screenshare":"테스트 화면 공유","Retry Now":"지금 다시 시도","SHARE":"공유","Rooms Closed":"방 닫힘","Discussion rooms are now closed. You are being redirected to the Stage.":"토론방은 현재 닫혀 있습니다. 스테이지로 리디렉션되고 있습니다.","Return To Stage":"스테이지로 돌아가기","Unrecognized embedded widget provider - ":"인식되지 않은 임베드된 위젯 공급자. ","Room Ended":"방 종료됨","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"이벤트 주최자가 모든 방을 닫았습니다. 이벤트 스테이지로 리디렉션됩니다.","Video Q&A Request Cancelled":"동영상 Q&A 요청이 취소되었습니다.","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Lite 모드에서 시청 중이어서 동영상 Q&A 요청이 취소되었습니다. 라이브 모드로 전환하여 다시 손을 드세요.","Camera Passed":"카메라 통과","Camera Error":"카메라 오류","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"브라우저에서 카메라 사용 권한이 부여되지 않았습니다. \'카메라 허용\'을 클릭합니다.","Camera permissions aren’t granted from system. Click “Allow Camera”":"시스템에서 카메라 사용 권한이 부여되지 않았습니다. \'카메라 허용\'을 클릭합니다.","Uh-oh! Error occurred while creating camera stream":"이런! 카메라 스트리밍을 생성하는 동안 오류가 발생했습니다.","Close other applications which might use camera stream":"카메라 스트리밍을 사용 중일 수 있는 다른 애플리케이션을 닫으세요.","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"브라우저에서 카메라에 액세스할 수 있는지 확인하려면 <a href=\'ms-settings:privacy-webcam\'>여기를 클릭하세요</a>.","Microphone Passed":"마이크 통과","Microphone Error":"마이크 오류","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"브라우저에서 마이크 사용 권한이 부여되지 않습니다. \'마이크 허용\'을 클릭합니다.","Mic permissions aren’t granted from system. Click “Allow Microphone”":"시스템에서 마이크 사용 권한이 부여되지 않습니다. \'마이크 허용\'을 클릭합니다.","Uh-oh! Error occurred while creating mic stream":"이런! 마이크 스트리밍을 생성하는 동안 오류가 발생했습니다.","Close other applications which might use mic stream":"마이크 스트리밍을 사용 중일 수 있는 다른 애플리케이션을 닫으세요.","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"브라우저가 마이크에 액세스할 수 있는지 확인하려면 <a href=\'ms-settings:privacy-microphone\'>여기를 클릭하세요</a>.","Speaker and Microphone Error":"스피커 및 마이크 오류","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"시스템에 연결된 스피커 장치 목록을 표시하려면 마이크 권한이 필요합니다. \'마이크 허용\'을 클릭합니다.","It seems mic is being used by other application. Close other applications to proceed.":"마이크가 다른 응용 프로그램에서 사용되고 있는 것 같습니다. 계속하려면 다른 애플리케이션을 닫으세요.","Camera & Microphone Error":"카메라 및 마이크 오류","To enable permissions, click the Allow Camera & Mic button below":"권한을 활성화하려면 아래에서 카메라 및 마이크 허용 버튼을 클릭하세요.","Network Connection":"네트워크 연결","Check Passed":"점검 통과","Could not establish a network connection":"네트워크 연결을 설정할 수 없습니다","Connect to a different network, or use a mobile hotspot.":"다른 네트워크에 연결하거나 모바일 핫스팟을 사용합니다.","Disable any VPN or firewall is connected.":"연결된 VPN 또는 방화벽을 비활성화하세요.","Connection: Good":"연결: 양호","Network Connection Error":"네트워크 연결 오류","Can’t connect to network. Change your network or limited functionality will be available during event.":"네트워크에 연결할 수 없습니다. 네트워크를 변경하지 않으면 이벤트 기간 동안 제한된 기능을 사용할 수 있습니다.","AdBlocker":"AdBlocker","AdBlocker not detected.":"AdBlocker가 감지되지 않았습니다.","AdBlocker detected. This may degrade your event experience.":"AdBlocker가 감지되었습니다. 이로 인해 이벤트 환경이 저하될 수 있습니다.","Disable adblocker for best experience.":"최상의 환경을 위해 AdBlocker를 비활성화하세요.","You are using ":"사용 중입니다. ","Use Windows or Mac OS for best performance":"최상의 성능을 위해 Windows 또는 Mac OS를 사용하세요","Browser Check":"브라우저 확인","Check Passed.":"점검 후 통과되었습니다.","Switch To Lite Mode":"Lite 모드로 전환하기","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Lite 모드로 전환하면 대기 중인 동영상 Q&A 요청이 취소됩니다.","Stay on Live Mode":"라이브 모드 유지","Unable to mark as favorite":"즐겨찾기로 표시할 수 없음","Event organizers must enter the event to select favorites.":"이벤트 주최자는 즐겨찾기를 선택하려면 이벤트에 입장해야 합니다.","Make an Announcement":"발표하기","STOP":"중지","InPerson CheckIn App":"직접 체크인하는 앱","App to Check-In In-Person attendees":"참석자가 직접 체크인하는 앱","SEE AGENDA":"안건 보기","Please visit the Agenda tab to view the session recordings":"안건 탭에서 세션 녹화본을 확인하세요.","The session recordings will be available soon in the Agenda tab":"세션 녹화본은 안건 탭에서 곧 이용할 수 있습니다.","FAILED!":"실패했습니다!","Next session is beginning":"다음 세션이 시작됩니다","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"다음 세션으로 이동하시겠습니까? 스트리밍이 계속되고 TV가 새 세션을 브로드캐스트합니다.","Banners":"배너","Images":"이미지","Screen Share":"화면 공유","Browser might not have screen-recording permission on your computer.":"브라우저에 컴퓨터의 화면 녹화 권한이 없을 수 있습니다.","Open System Preferences":"시스템 환경설정 열기","Error publishing screen because someone else started screen share already.":"다른 사람이 이미 화면 공유를 시작했기 때문에 화면 게시 중에 오류가 발생했습니다.","Live Feed":"라이브 피드","Check Your Network":"네트워크 확인","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"동영상 재생 중 오류가 감지되었습니다! 동영상 재생에 문제가 있는 경우 페이지를 새로 고침하거나 Lite 모드로 전환해 보세요.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"동영상 재생 중 오류가 감지되었습니다! 동영상 재생에 문제가 있는 경우 페이지를 새로 고침해 보세요.","All Dates":"모든 날짜","All Tracks":"모든 트랙","Create Ticker":"티커 만들기","Booths Closed":"부스 닫힘","Your event organizer has closed all the booths. You will now be redirected to the stage":"이벤트 주최자가 모든 부스를 닫았습니다. 이제 스테이지로 리디렉션됩니다.","Visit the Polls tab to view live results.":"여론 조사 탭으로 이동하여 실시간 결과를 확인하세요.","A new poll is open! Visit the Polls tab to vote.":"새로운 설문 조사가 열려 있습니다! 투표하려면 투표 탭을 이용하세요.","Vote for Polls":"설문 조사 투표","Go to Polls Tab":"설문 조사 탭으로 이동","Microphone audio too low":"마이크 오디오가 너무 낮습니다.","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"오디오에 문제가 있습니다. 문제가 지속되면 음소거/음소거 해제를 시도하거나 다른 장치를 사용하는 것이 좋습니다.","Audio/Video bitrate too low":"오디오/동영상 비트 전송 속도 너무 낮음","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"네트워크 방화벽 설정은 A/V 스트리밍을 차단합니다. 다른 네트워크 연결로 전환하는 것이 좋습니다.","Error sharing screen":"화면 공유 중 오류 발생","A network error occurred while sharing screen. Please check your network connection.":"화면을 공유하는 동안 네트워크 오류가 발생했습니다. 네트워크 연결을 확인하세요.","Apologies, due to some errors, we need to refresh the page!":"죄송합니다. 오류가 발생하여 페이지를 새로 고침해야 합니다!","Warning":"경고","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"동영상에 문제가 있습니다. 이 문제를 해결하려면 기기에서 실행 중인 다른 브라우저 탭이나 애플리케이션을 닫고, 인터넷 연결을 확인하여 업그레이드하는 것이 좋습니다.","No results found":"결과를 찾을 수 없음","Audio":"오디오","Please choose another microphone and camera":"다른 마이크와 카메라를 선택하세요.","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"현재 선택한 마이크와 카메라가 작동하지 않습니다. 아래 드롭다운에서 다른 마이크와 카메라를 선택하세요.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"현재 선택된 카메라가 작동하지 않습니다. 아래 드롭다운에서 다른 카메라를 선택하세요.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"카메라 없이 계속할 수 있지만 원활한 방송 환경을 위해 문제를 해결하는 것이 좋습니다.","Please choose another microphone":"다른 마이크를 선택하세요.","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"현재 선택한 마이크가 작동하지 않습니다. 아래 드롭다운에서 다른 마이크를 선택하세요.","Please check that your TV speaker is correct":"TV 스피커가 올바른지 확인하세요.","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"현재 선택한 스피커가 작동하지 않습니다. 아래 드롭다운에서 다른 스피커를 선택하세요.","Your answer":"답변","Edit":"수정","Delete":"삭제","Settings":"설정","Signing Out":"로그아웃 중","Confirming your account...":"계정 확인 중...","Something Went Wrong. Please Retry :(":"오류가 발생했습니다. 다시 시도해 주세요.","Resending Mail":"메일 재전송 중","offline":"오프라인","I am inviting you to a video meeting:":"동영상 회의에 초대합니다.","Resending secure login link to your email":"이메일로 안전한 로그인 링크 재전송 중","Sending secure login link to your email":"이메일로 안전한 로그인 링크 전송 중","Something went Wrong. Please Retry :(":"오류가 발생했습니다. 다시 시도해 주세요.","Updating your password":"비밀번호 업데이트 중","Sending mail":"메일 전송 중","Verifying":"인증 중","This might be slower than usual":"평소보다 처리 속도가 느릴 수 있습니다.","Checking":"확인 중","New results available! Refresh!":"새 결과가 있습니다! 새로 고침하세요!","Saving":"저장 중","Turn off Attendee mode":"참석자 모드 끄기","See Attendee View":"참석자 뷰 보기","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"현재 이 세션을 보고 있는 총 참석자의 수입니다. 참고: 주최자에게만 보입니다.","Session Count":"세션 계수","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"현재 라이브 세션을 보고 있는 참석자의 수입니다. 참고: 주최자에게만 보입니다.","Role":"역할","Total Attendees":"총 참석자","Total number of attendees online at this time Note: This is for organizer eyes only":"현재 온라인 상태인 총 참석자의 수입니다. 참고: 주최자에게만 보입니다.","My Profile":"내 프로필","Languages":"언어","Filling out your profile can help you connect with people with similar interests.":"프로필을 작성하면 비슷한 관심사를 가진 사람들과 연결하는 데 도움이 됩니다.","type to search for your address":"주소를 검색하려면 주소를 입력하세요.","Could not open direct call":"직접 호출을 열 수 없음","Chat messages can only be published from inside a broadcast.":"채팅 메시지는 방송 내부에서만 공개할 수 있습니다.","Stage Logo can only be published from inside a broadcast.":"스테이지 로고는 방송 내부에서만 공개할 수 있습니다.","Loading Speakers":"발표자 로딩 중","Raise hand is disabled for organizer accounts, but active for attendee accounts":"주최자 계정의 경우 손 들기 기능이 비활성화되어 있지만, 참석자 계정에서는 활성화되어 있습니다.","Disabled in lite mode, return to live if you’d like to raise hand!":"Lite 모드에서는 이용할 수 없습니다. 손을 들고 싶으면 라이브로 돌아가세요!","Raise hand to enter stage for video q&a":"손을 들어 동영상 Q&A를 위해 스테이지 들어가기","Speakers":"발표자","Hosting organization: {organization}":"주최 조직: {organization}","Failed to switch {deviceTag}":"{deviceTag}(으)로 전환하지 못했습니다.","Make sure your {deviceTag} is not being used by any other application and is working properly.":"{deviceTag}이(가) 다른 애플리케이션에서 사용되고 있지 않은지, 올바르게 작동하는지 확인하세요.","Facing issues with audio or video? Switch on lite mode":"오디오 또는 동영상 문제가 있나요? Lite 모드로 전환하기","Failed to get event for eventID: {eventID}":"이벤트 ID {eventID}에 대한 이벤트를 가져오지 못했습니다.","Error while playing video.":"동영상 재생 중 오류가 발생했습니다.","Speakers only, attendees can\'t see this chat":"발표자 전용이며 참석자는 이 채팅을 볼 수 없습니다.","Kudo":"칭찬","Room":"방","Session":"세션","Booth":"부스","Public":"공개","Drift":"드리프트","Slides":"슬라이드","Videos":"동영상","Chat":"채팅","Messages":"메시지","Poll":"여론 조사","Docs":"문서","Q&A":"질의응답","Media":"미디어","Messages Chat":"메시지 채팅","Leaderboard":"리더보드","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"참고: 귀하는 이 이벤트의 발표자이기도 합니다. 언제든지 백스테이지 영역에 들어가서 스테이지로 이동할 수 있습니다.","Switch to Attendee View":"참석자 뷰로 전환","Return to Organizer View":"주최자 뷰로 돌아가기","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"참석자 뷰를 끄기로 전환하면 현재 페이지가 다시 로드되며 주최자 뷰로 돌아갑니다. 계속하시겠어요?","Switch":"전환","Request Sent":"요청 전송됨","Your request for a demo has been submitted":"데모 요청이 제출되었습니다.","Organizer Redirection":"주최자 리디렉션","YES, REDIRECT":"예, 리디렉션합니다","DISMISS":"무시하기","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"참석자가 다음 세션으로 리디렉션되고 있습니다. {title}. 다음 세션으로 리디렉션되기를 원하시나요?","Stage":"스테이지","Rooms":"방","Join a round table to discuss moderated topics with your fellow attendees":"회의에 참여하여 동료 참석자와 적절한 주제에 대해 토론하세요.","Booths":"부스","Join a booth to know more about a sponsor":"부스에 참여하여 후원사에 대해 자세히 알아보세요.","You are in the booth":"부스 안에 있습니다.","People":"사람","Connect with your fellow attendees":"동료 참석자와 연결","Connect with speakers":"발표자와 연결","starting in {duration}":"{duration} 후 시작","You will be redirected to booths in {duration}":"{duration} 후에 부스로 리디렉션됩니다.","booths":"부스","agenda":"안건","You will be redirected to {word} in {duration}":"{duration} 후에 {word}(으)로 리디렉션됩니다.","You will be redirected to the live stage in {duration}":"{duration} 후에 라이브 스테이지로 리디렉션됩니다.","- You are about to be redirected to {tabTitle} in {duration}":"- {duration} 후에 {tabTitle}(으)로 리디렉션될 예정입니다.","See Agenda":"안건 보기","Break":"중단","{title} is now live":"{title}이(가) 현재 라이브 상태입니다.","Apologies, due to an error we need to refresh the page!":"죄송합니다. 오류가 발생하여 페이지를 새로 고침해야 합니다!","Network interruption detected":"네트워크 중단이 감지되었습니다.","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"인터넷 연결에 문제가 있습니다. VPN을 사용하는 경우 비활성화해 주시기 바랍니다. 또는 다른 네트워크에 연결해 보세요.","No audio output device detected":"감지된 오디오 출력 장치가 없습니다.","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"스피커/헤드폰을 연결하고 기어 아이콘을 사용하여 문제가 있는지 테스트하세요.","Please disable ad blocker for this page":"이 페이지에 대한 광고 차단 프로그램을 비활성화하세요.","Yes, I understand":"예, 이해합니다.","No event user found so attended not marked!":"이벤트 사용자를 찾을 수 없어 참석이 표시되지 않았습니다!","Wait while the speaker approves your video q&a request":"발표자가 동영상 Q&A 요청을 승인할 때까지 기다리세요.","Organizer":"주최자","UPNEXT":"다음 세션","Ended":"종료됨","Hide":"숨기기","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"이 페이지가 {durationLeftToRedirect}초 후 사용자를 자동으로 리디렉션합니다.","Register":"등록","Error: User unable to be registered for this event. Please contact event organizer for assistance":"오류: 사용자가 이 이벤트에 등록할 수 없습니다. 이벤트 주최자에게 연락하여 도움을 요청하세요.","You are already registered!":"이미 등록되어 있습니다!","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"이미 이 이벤트로 등록되어 있는 것 같습니다! 등록 확인 이메일을 받지 못한 경우, 스팸 폴더를 확인해 주세요. 더 도움이 필요하시면 이벤트 주최자에게 문의하세요.","Thank you for registering!":"등록해 주셔서 감사합니다!","Submit another response":"다른 답변 제출하기","Share":"공유","Know someone who want to attend this?":"이곳에 참석하고 싶은 사람을 알고 계세요?","COPY LINK":"링크 복사","Powered by":"운영사:","VIEW PROFILE":"프로필 보기","You can access the event landing here":"여기에서 이벤트 랜딩에 액세스할 수 있습니다.","Need Help?":"도움이 필요하세요?","Welcome back":"다시 돌아오신 걸 환영합니다.","Checking...":"확인 중...","Close":"닫기","Enter":"참여하기","See {roomCount} Room(s)":"방 {roomCount}개 보기","Back":"뒤로","Request a Demo":"데모 요청하기","Loading":"로딩 중","Thread":"대화 내역","Load more":"더 보기","Heads up!":"알려드립니다!","YES":"예","No":"아니요","Following":"팔로우 중","Error in loading drimify":"drimify 로딩 중 오류 발생","You\'re not registered for this event":"이 이벤트에 등록하지 않았습니다.","Check out other events":"다른 이벤트 확인하기","Date":"날짜","Location":"위치","How are you attending the event":"이벤트는 어떻게 참석하고 계세요?","In Person":"직접 만나서","Virtually":"가상으로","Event Widgets":"이벤트 위젯","Chat • Messages • Q&A • Poll • Docs":"채팅 • 메시지 • 질의응답 • 여론 조사 • 문서","DISCUSSION":"토론","JOIN":"참여하기","WAIT":"대기","more":"더 보기","See Profile":"프로필 보기","Filter":"필터","Video player not supported by your browser":"사용 중인 브라우저가 동영상 플레이어를 지원하지 않음","We recommend using the latest version of Google Chrome to access your conference":"회의에 액세스하려면 최신 버전의 Google Chrome을 이용하는 것이 좋습니다.","ANSWER":"답변","REJECT":"거부","Don’t ask me this next time":"다음에는 묻지 않기","Cancel":"취소","Lite Mode":"Lite 모드","On":"켜기","Connection Issues? Turn on Lite Mode":"연결 문제가 있나요? Lite 모드 켜기","Turn On Lite Mode":"Lite 모드 켜기","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"Lite 모드를 이용할 경우 실시간 방송이 화면에 표시될 때까지 30초 정도 지연이 발생합니다. 계속하시겠어요?","Turn On":"켜기","Lite Mode Active!":"Lite 모드가 활성화되었습니다!","Thanks for your patience, lite mode now on!":"기다려 주셔서 감사합니다. 이제 Lite 모드가 활성화되었습니다!","Turn off Lite Mode?":"Lite 모드를 끌까요?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"실시간 방송 보기로 돌아가기 위해 Lite 모드를 끕니다. 30초 정도의 지연이 발생할 수 있음을 유의하세요.","Lite Mode Off!":"Lite 모드가 꺼졌습니다!","Thanks for your patience, we’ve returned to the live broadcast!":"기다려 주셔서 감사합니다. 실시간 방송으로 돌아왔습니다!","Lite Mode Unavailable":"Lite 모드 이용 불가","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"현재 Lite 모드를 사용할 수 없는 점 양해 부탁드립니다. 세션을 재개하려면 실시간 방송으로 전환하세요.","Turn off Lite mode?":"Lite를 끌까요?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"연결이 정상으로 돌아왔음을 발견했습니다. 실시간 방송으로 다시 전환하시겠어요? 30초 정도의 지연이 발생할 수 있음을 유의하세요.","Turn Off":"끄기","Lite mode is disabled for organizer accounts, but active for attendee accounts":"주최자 계정의 경우 Lite 모드가 비활성화되어 있지만, 참석자 계정에서는 활성화되어 있습니다.","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"회원님의 브라우저에서는 Lite 모드가 지원되지 않습니다. 최신 버전의 Google Chrome을 사용하는 것이 좋습니다.","Lite mode is not curently available. We’ll let you know once it’s available again":"Lite 모드는 현재 이용할 수 없습니다. 다시 이용 가능해지면 알려드리겠습니다.","Turn off Lite Mode":"Lite 모드 끄기","We’ll let you know when Lite mode is available again":"다시 Lite 모드가 이용 가능해지면 알려드리겠습니다.","Lite Mode Available":"Lite 모드 이용 가능","Loading Lite Mode...":"Lite 모드 로딩 중...","Turning Off Lite Mode":"Lite 모드 끄는 중","Lite Mode On":"Lite 모드 켜짐","Audio/Video Issues?":"오디오/비디오 문제가 있으세요?","Error":"오류","Click a video to play":"재생할 동영상 클릭","Error starting video!":"동영상 시작 중 오류가 발생했습니다!","Please rotate your device to {mode} mode":"장치를 {mode} 모드로 회전하세요.","landscape":"가로","portrait":"세로","Thank you for attending this event!":"이 이벤트에 참석해 주셔서 감사합니다!","Go to Rooms":"방으로 이동하기","Please use a desktop or laptop Google Chrome browser to access your conference":"회의에 액세스하려면 데스크톱 또는 노트북에서 Google Chrome 브라우저를 사용하세요.","If on Desktop":"데스크톱을 사용하는 경우","Please increase the width of your window":"윈도우 창의 너비를 늘리세요.","Alternatively, check out the":"대신 다음을 확인하세요.","Youtube Livestream":"Youtube 라이브스트리밍","Search":"검색","Profile":"프로필","Yes":"예","Loading Chat":"채팅 로딩 중","Please wait while we fetch the chat":"채팅을 가져오는 동안 기다려 주세요.","Load old messages":"이전 메시지 로드하기","Join the room to see chat":"방에 참여하여 대화 보기","Live Chat":"라이브 채팅","Uh..oh we couldn\'t load the content":"죄송합니다. 콘텐츠를 로드하지 못했습니다.","Please reload the page":"페이지를 다시 로드하세요.","New comments":"새 댓글","Start the conversation":"대화 시작하기","Be the first to add to chat!":"먼저 대화를 시작해 보세요!","Enter your message":"메시지 입력하기","Joining chat!":"채팅에 참여합니다!","See all pinned messages":"고정된 메시지 모두 보기","Failed to send! Retry?":"전송에 실패했습니다. 다시 시도할까요?","Search for attendee":"참석자 검색","Up to date":"최신","Start a new conversation, We think you\'ll enjoy":"새 대화를 시작하세요. 마음에 드실 거예요.","chatting with these recommended attendees!":"추천 참석자들과 채팅하세요!","Searching":"검색 중","Load Previous":"이전 항목 로드하기","Load Next":"다음 로드하기","Loading Channel":"채널 로딩 중","Please wait while we fetch the channel":"채널을 가져오는 동안 기다려 주세요.","Please wait while we fetch the messages":"메시지를 가져오는 동안 기다려 주세요.","Send the first message":"첫 메시지 보내기","Join":"참여하기","link":"링크","download":"다운로드","Click to open":"클릭하여 열기","No open polls":"진행 중인 여론 조사 없음","Check back later to see if a poll opens up!":"나중에 다시 와서 진행 중인 여론 조사가 있는지 확인하세요!","Loading Poll":"여론 조사 로딩 중","Please wait while we fetch the polls":"여론 조사를 가져오는 동안 기다려 주세요.","Uh oh.. we couldn’t load the content":"죄송합니다. 콘텐츠를 로드하지 못했습니다.","Polls":"여론 조사","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"여론 조사를 실행하려면 Goldcast 관리자 패널에서 이 세션에 질문과 답변을 추가하세요.","Stop Sharing":"공유 중지","Can\'t publish polls while something else is being presented on stage":"스테이지에 다른 정보가 표시되어 있는 동안에는 여론 조사를 게시할 수 없습니다.","Open":"열기","Cancel your video q&a request":"동영상 Q&A 요청 취소","Pending...":"보류 중...","Leave Stage":"스테이지에서 나가기","Raise Hand":"손 들기","Text Q&A":"텍스트 질의응답","Video Q&A":"동영상 질의응답","Loading Q&amp;A":"질의응답 로딩 중","Please wait while we fetch the Q&amp;A":"질의응답을 가져오는 동안 기다려 주세요.","Uh oh.. we couldn\'t load the content":"죄송합니다. 콘텐츠를 로드하지 못했습니다.","No Questions Yet":"질문이 아직 없습니다.","Tell your audience to send in questions!":"청중들에게 질문을 보내라고 말하세요!","Be the first to ask a question!":"먼저 질문해 보세요!","Tell your audience to raise their hand!":"청중들에게 손을 들라고 말하세요!","Approve":"승인","Reject":"거부","End":"종료","RELOAD":"다시 로드하기","Logos On Stage":"스테이지의 로고","No File Chosen":"선택된 파일 없음","loading":"로딩 중","Can\'t publish a slide when there is something else being presented on stage":"스테이지에 다른 정보가 표시되어 있을 때는 슬라이드를 게시할 수 없습니다.","Change Deck":"데크 변경","stop-screen-share":"stop-screen-share","screen-share":"screen-share","Select a deck to begin presenting":"발표를 시작하려면 데크를 선택하세요.","CONFIRM":"확인","If you’re having issues, please refer to the":"문제가 있을 경우 다음을 참조하세요.","SPEAKER":"스피커","Issue Testing Audio!":"오디오 테스트 중 문제가 발생했습니다!","VPN and adblockers may cause video issues, please disable them before proceeding":"VPN 및 광고 차단 프로그램은 동영상 문제를 초래할 수 있으므로 진행하기 전에 비활성화하세요.","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"참고로 VPN 및 adblockers는 동영상 문제를 초래할 수 있으므로, 방송 중에는 비활성된 상태로 유지하세요.","Follow":"팔로우","Read More":"자세히 읽기","Ask a question":"질문하기","Shared":"공유됨","Answered":"답변됨","Waiting Approval":"승인 대기 중","cancel":"취소","ENTER":"참여하기","Upcoming Events":"다가오는 이벤트","Past Events":"지난 이벤트","Goldcast":"Goldcast","MANAGE EVENT":"이벤트 관리","Edit Profile":"프로필 수정","Stay tuned!":"업데이트를 기다려 주세요!","Sign-in instructions will be available here 12 hours prior to the event":"로그인 지침은 이벤트 시작 12시간 전에 여기에서 확인할 수 있습니다.","Please log out":"로그아웃해 주세요.","Logout":"로그아웃","Continue as {differentUser}":"{differentUser}(으)로 계속하기","You are already logged in as {user}.":"이미 {user}(으)로 로그인되어 있습니다.","EMAIL":"이메일","user@email.com":"user@email.com","FIRST NAME":"이름","First Name":"이름","LAST NAME":"성","Last Name":"성","You are not registered to this event":"이 이벤트에 등록하지 않았습니다.","Please enter your email and name":"이메일과 이름을 입력해 주세요.","Please enter your email":"이메일을 입력해 주세요.","We have sent a secret code to":"다음으로 비밀 코드를 전송했습니다.","BACK":"뒤로","Didn\'t receive an email? Make sure to check spam list":"이메일을 받지 못하셨나요? 스팸 편지함을 확인하세요.","Resend Mail":"메일 재전송","SECRET CODE":"비밀 코드","Please enter the temporary password sent to your email":"이메일로 전송된 임시 비밀번호를 입력하세요.","NEW PASSWORD":"새 비밀번호","Please enter a new password":"새 비밀번호를 입력하세요.","CONFIRM PASSWORD":"비밀번호 확인","Please re-enter the new password":"새 비밀번호를 다시 입력하세요.","Password length should be atleast 8":"비밀번호의 길이는 최소 8자 이상이어야 합니다.","Password and Confirm Password don\'t match !!":"비밀번호와 비밀번호 확인이 일치하지 않습니다!","Please enter your password to continue":"계속하려면 비밀번호를 입력하세요.","Logging you in...":"로그인 중입니다...","PASSWORD":"비밀번호","Forgot credentials?":"로그인 정보를 잊으셨어요?","Forgot Password? A mail will be sent to your registered email.":"비밀번호를 잊으셨나요? 등록된 이메일로 지침을 보내드립니다.","Email cannot be blank!!":"이메일 입력란을 비워 둘 수 없습니다!","We have sent a secure login link to":"다음으로 보안 로그인 링크를 전송했습니다.","from":"발신인:","Please use that to access your event.":"이를 사용해 이벤트에 액세스하세요.","Please check spam/promotion too if you can\'t find it.":"찾을 수 없다면 스팸/광고 편지함을 확인하세요.","Thank You !":"감사합니다!","The link is not valid.":"링크가 유효하지 않습니다.","Please be patient.":"기다려 주세요.","We are verifying your link.":"링크를 확인하고 있습니다.","Thank you for entering the code!":"코드를 입력해 주셔서 감사합니다!","Please create a new password":"새 비밀번호를 만드세요.","Signing you up...":"가입 중입니다...","We have sent a temporary password to":"다음으로 임시 비밀번호를 전송했습니다.","TEMPORARY PASSWORD":"임시 비밀번호","Please enter the temporary password sent to your mail":"이메일로 전송된 임시 비밀번호를 입력하세요.","Password Length should be 8":"비밀번호의 길이는 최소 8자 이상이어야 합니다.","Okay":"확인","Backstage: {title}":"백스테이지: {title}","Prep Area":"준비 영역","Starting at {time}":"{time}에 시작","person":"사람","inside":"참여 중","No one is inside":"안에 아무도 없습니다.","This area is for you to sync up with your fellow speakers before you go on stage.":"이 영역은 스테이지로 이동하기 전에 동료 발표자들과 서로 정보를 주고받는 곳입니다.","This area is for you to check your cam and mic before you enter the room.":"이 영역은 방에 입장하기 전에 카메라와 마이크를 확인하는 곳입니다.","I\'m Ready":"준비되었습니다.","Watch Live":"라이브 시청하기","Backstage":"백스테이지","You are sharing your screen":"화면을 공유 중입니다.","LIVE":"라이브","Live":"라이브","Virtual":"가상","Only available for ":"다음에 대해서만 사용 가능 ","See Booths":"부스 보기","See Rooms":"방 보기","Enter Backstage":"백스테이지 입장","This track has no upcoming sessions. Check out a different track.":"이 트랙에는 다음 세션이 없습니다. 다른 트랙을 확인하세요.","View":"보기","Agenda":"안건","Scroll to see all tracks":"스크롤해서 모든 트랙 보기","No Agenda Items to show!":"표시할 안건 항목이 없습니다!","ENTER EVENT":"이벤트 참여하기","change":"변경","Upload":"업로드","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF 또는 PNG. 최대 크기 5MB","Create Profile":"프로필 만들기","Email":"이메일","Company":"회사","Title":"직책","No matching locations found":"일치하는 위치를 찾을 수 없음","You can try searching for the location with another keyword":"다른 키워드를 사용해 위치를 검색해볼 수 있습니다.","Interest Tags":"관심 태그","Pick your first tag":"첫 번째 태그를 선택하세요.","Save":"저장","Searching...":"검색 중...","Twitter":"Twitter","Select Your First Tags":"첫 번째 태그 선택","Add Interest tags":"관심 태그 추가","Congratulations!":"축하합니다!","Your first Goldcast event is set up":"첫 Goldcast 이벤트가 설정되었습니다.","You can always visit":"언제든지 방문하여","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"이벤트 설정 및 실행 방법에 대한 지침을 확인할 수 있습니다.","See My Event":"내 이벤트 보기","Peak Community":"피크 커뮤니티","Loading Lite Mode... This may take up to 30s":"Lite 모드 로딩 중... 최대 30초가 소요될 수 있습니다.","Loading Video...":"동영상 로딩 중...","Video will begin at session start time":"동영상이 세션 시작 시간에 시작됩니다.","TIME":"시간","TITLE":"제목","STATUS":"상태","END":"종료","START":"시작","AGENDA":"안건","Enable Audio":"오디오 활성화","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"브라우저 오토플레이 정책으로 인해 오디오가 소거되었습니다. 음소거를 해제하려면 아래에서 활성화를 클릭하세요. 나중에 기본 제어판을 사용해 오디오 음소거를 해제할 수도 있습니다.","Enable":"활성화","You are being redirected outside the room. Would you like to continue?":"방 밖으로 이동합니다. 계속하시겠어요?","Continue":"계속","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"또는 라이브 방송보다 30초 정도 늦게 방영되는 Lite 모드를 대신 이용할 수 있습니다.","We detected a network issue":"네트워크 문제를 탐지했습니다.","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"VPN/Firewall을 통해 연결되어 있지 않도록 확인해 주세요. 문제가 지속될 경우 네트워크, 브라우저 또는 기기를 변경해 보세요.","Could not connect":"연결할 수 없음","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"보안 네트워크, 브라우저/기기 문제일 수 있습니다. 문제가 지속될 경우 네트워크, 브라우저 또는 기기를 변경해 보세요.","Switch to Lite Mode":"Lite 모드로 전환하기","Leave":"나가기","Screenshare had an issue":"화면 공유에 문제가 있었습니다.","Could not share screen unexpectedly. Refresh & retry. On mac go to":"예기치 않게 화면을 공유하지 못했습니다. 새로 고친 후에 다시 시도하세요. Mac에서는 다음으로 이동","and check if your browser has the required permission":"그리고 브라우저에 필수 권한이 있는지 확인하세요.","Uh OH... Something went wrong":"오류가 발생했습니다.","To fix this, click the":"이를 수정하려면 다음을 클릭하세요.","in your URL bar, then select “Allow”, and then click “Try Again”":"URL 바에서, 그리고 \\"허용\\"을 선택한 후 \\"다시 시도\\"를 클릭하세요.","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"알 수 없는 이유로 미디어 스트림을 초기화하지 못했습니다. 사용 중이 브라우저가 플랫폼에서 지원되지 않을 수 있습니다. \\"Google Chrome\\"을 이용하시는 것이 좋습니다. 문제가 지속되면 Goldcast 지원팀에 연락해 주세요.","To fix this, make sure your":"이를 수정하려면 다음을 수행하세요.","is not being accessed by any other app. If not, please try changing your":"다른 앱에서 액세스하고 있지 않습니다. 그렇지 않으면 다음을 변경해 보세요.","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"\\"설정으로 이동\\"을 클릭하여 장치 가능한 문제점을 해결한 후에 \\"다시 시도하기\\"를 클릭하세요!","Go To Settings":"설정으로 이동","Try Again":"다시 시도하기","Try Joining without Video":"동영상 없이 참여 시도하기","A refresh and rejoin should work":"새로 고친 후에 다시 참여하면 문제가 해결될 것입니다.","Refresh & Rejoin":"새로 고침 및 재참여","Start Chat":"채팅 시작하기","On Stage":"스테이지에 있음","Connect your on-site camera and microphone to present to your virtual attendees":"가상 참석자에게 표시되도록 현장 카메라 및 마이크 연결하기","Stop Streaming":"스트리밍 중지","Start Streaming":"스트리밍 시작","Set up on-site video feed":"현장 동영상 피드 설정하기","Open TV":"TV 열기","Layout: {layout} ":"레이아웃: {layout} ","With Speaker Videos":"발표자 동영상 이용","Full Screen":"전체 화면","No Speakers":"발표자 없음","Turn Off Setup Mode":"설정 모드 끄기","Setup Mode":"설정 모드","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"{roomTitle}에 대한 설정 모드를 중단하려면 끄기를 누르세요. 그렇게 하면 모든 활성 스트리밍 항목이 꺼집니다.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"스트리밍 준비: {roomTitle}. 라이브 위치에서 스트리밍할 때만 설정 모드를 사용해 주세요.","Starting in {duration}":"{duration} 후 시작","Can\'t share screen while there is something else being presented on stage":"스테이지에 다른 정보가 표시되어 있는 동안에는 화면을 공유할 수 없습니다.","You are now in attendee view!":"이제 참석자 뷰를 사용합니다!","You are now in organizer view!":"이제 주최자 뷰를 사용합니다!","Note :":"참고:","Only organizer accounts can see this tag, normal attendees can’t see this":"주최자 계정인 경우에만 이 태그를 볼 수 있고, 일반 참석자들은 이를 볼 수 없습니다.","Attendee":"참석자","Event Information":"이벤트 정보","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"이벤트 정보는 주최자에게만 표시됩니다! <br /> 이 섹션은 참석자에게 표시되지 않습니다.","Operating System":"운영 체제","Secondary Booths":"보조 부스","Sort":"정렬","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"팔로우 중: {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2} 님이 자동으로 {track1_Would_you_like_to_continue}에서 회원님을 언팔로우합니다.","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}계속하시겠어요?","Track only available for {tracks}":"{tracks}에 대해서만 추적 가능","Add to Calendar":"달력에 추가","Open Speakers Control Panel":"발표자 제어판 열기","Move Offstage ↓":"오프스테이지 이동 ↓","Error Moving ⚠":"이동 중 오류 발생 ⚠","Off Stage":"오프스테이지","Move to Stage":"스테이지로 이동","An error occurred!":"오류가 발생했습니다.","{eventName} Documents":"{eventName} 문서"," Set Up Mode":" 설정 모드","Camera & Mic blocked":"카메라 및 마이크 차단됨","Camera/Mic Inaccessible":"카메라/마이크 이용 불가","Camera/Mic Not Found":"카메라/마이크를 찾을 수 없음","Camera Inaccessible":"카메라 이용 불가","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"카메라를 이미 사용 중이거나 해상도가 지원되지 않습니다. 다른 애플리케이션에서 카메라를 사용하고 있지 않은지 확인하고 다시 시도하세요!","No microphone/camera is found":"마이크/카메라를 찾을 수 없음","The browser does not support using camera and microphone!":"사용 중인 브라우저가 카메라 및 마이크 사용을 지원하지 않습니다!","{n} Slides":"슬라이드 {n}장","Starting in {timeduration}":"{timeduration} 후 시작","{eventtitle} has ended":"{eventtitle}이(가) 종료되었습니다","This is a text q&a question!":"텍스트 Q&A 질문입니다!","Click here{if_it_does_not}":"여기 클릭{if_it_does_not}","{click_here}if it does not":"{click_here}그렇지 않다면","{title}up next":"{title}다음 세션","seat(s) open":"좌석 이용 가능","Signal strength is low. Close other windows or connect to a different network.":"신호 강도가 낮습니다. 다른 창을 닫거나 다른 네트워크에 연결하세요.","GO BACKSTAGE":"백스테이지로 이동","LEAVE STAGE":"스테이지에서 나가기","LEAVE":"나가기","This event begins on{startitme}":"이 이벤트는 {startitme}에 시작됩니다.","Please refresh to enter.":"입장하려면 새로 고침하세요.","people":"사람","Oops, Something went wrong":"죄송합니다. 오류가 발생했습니다.","Back Home":"홈으로 돌아가기","Deciding where to go ...":"어디로 이동할지 결정 중...","Go to Event Hub":"이벤트 허브로 이동","CREATE":"만들기","Attending Virtually":"가상으로 참여 중","Attending In Person":"대면으로 참여 중","Click to change your attendance type":"참석 유형을 변경하려면 클릭하기","Open Chat":"채팅 열기","Create your profile for {eventtitle}":"{eventtitle}에 대해 프로필 만들기","Move to stage":"스테이지로 이동","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"이벤트 주최자가 회원님을 <strong>{broadcastTitle}</strong>의 스테이지로 이동하도록 요청했습니다.<br /><br />요청 수락을 클릭하면 라이브로 이벤트 참석자들이 회원님을 볼 수 있게 됩니다.<br /><br />","Go Live On Stage":"스테이지에서 라이브 시작","Moved to backstage":"백스테이지로 이동됨","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"주최자가 회원님을 스테이지에서 제거했습니다. 주최자에게 연락하지 않고 재참여를 시도하지 마세요.","Error creating Screen stream":"화면 스트림을 만드는 중에 오류 발생","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"화면 공유 권한이 부여되지 않았습니다. *여기를 클릭*해 문제 해결 지침서를 확인하세요.","Error publishing stream":"스트림 게시 중 오류 발생","Could not publish stream. Please refresh and try again!":"스트림을 게시하지 못했습니다. 새로 고침한 후 다시 시도하세요!","Error publishing screen":"화면 게시 중 오류 발생","Error publishing screen. Please refresh and try again!":"화면 게시 중에 오류가 발생했습니다. 새로 고침한 후 다시 시도하세요!","Error unpublishing stream":"스트림 게시 취소 중 오류 발생","Error unpublishing stream. Please refresh and try again!":"스트림 게시 취소 중에 오류가 발생했습니다. 새로 고침한 후 다시 시도하세요!","Invalid Publish Operation":"올바르지 않은 게시 운영","{username} profile picture":"{username} 프로필 사진","Default":"기본값","A-Z":"A-Z","Random":"무작위","All":"전체","Past":"이전","Upcoming":"다음","Learn More":"더 알아보기","close":"닫기","Discussion Rooms":"토론 방","ATTENDEE MODE":"참석자 모드","Loading...":"로딩 중...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"해당 기기가 브라우저에서 비활성화되었거나 사용 권한이 부여되지 않았습니다. 권한을 제공하고 \'다시 시도하기\'를 클릭하세요.","You are now registered. You will receive an email confirming details shortly.":"등록이 완료되었습니다.곧 세부정보가 포함된 확인 메일이 발송될 예정입니다.","Streaming to Virtual Users from on-site video feed":"현장 동영상 피드로부터 가상 사용자에게 스트리밍","Ending in ":"종료까지 남은 시간: ","GO LIVE":"라이브 시작","You have no past events.":"지난 이벤트가 없습니다.","You have no upcoming or live events.":"다음 이벤트 또는 라이브 이벤트가 없습니다.","left":"왼쪽","center":"중앙","right":"오른쪽","top":"상단","bottom":"하단","loading...":"로딩 중...","Loading ...":"로딩 중...","Failed to redirect!":"리디렉션에 실패했습니다!","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"광고 블로커가 활성화되어 있는 것 같습니다. 최상의 경험을 제공받는 데 방해가 될 수 있습니다. 비활성화해 주세요. <br />&lt;br / &gt; 작동 방법과 관련해 도움이 필요하시면 <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>여기를</a> 클릭해 추가적인 지침을 확인하세요.","redirecting in {duration}":"{duration} 후 리디렉션","STOP VIDEO":"동영상 중지","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"이 동영상 재생을 중지하려고 합니다. 방송이 라이브 모드로 되돌아가며 청중이 발표자를 보고 들을 수 있게 됩니다. 진행하시겠어요?","STOP SHARING":"공유 중지","No Next Slide":"다음 슬라이드 없음","Next Slide":"다음 슬라이드","No Previous Slide":"이전 슬라이드 없음","Previous Slide":"이전 슬라이드","something went wrong while recording the response please try again":"응답을 기록하는 동안 문제가 발생했습니다. 다시 시도해 주세요","Start In-Person Streaming":"대면 스트리밍 시작","Stop In-Person Streaming":"대면 스트리밍 중지","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"동영상이 버퍼링되고 있으며 테스트 세션이 곧 시작됩니다. 이것은 실제 세션 중에는 발생하지 않습니다.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"티커는 모든 참석자의 웹페이지 상단에 나타납니다. 티커를 하이퍼링크로 변환하려면 하단에 URL을 입력하세요.","Allow {key}":"{key} 허용","{messageType} can only be published from inside a broadcast.":"{messageType}은(는) 방송 내부에서만 공개할 수 있습니다.","To grant {deviceName} access to this page, follow the two steps below:":"이 페이지에 {deviceName} 액세스 권한을 부여하려면 아래 두 단계를 따릅니다.","2. Allow {deviceName} access and then refresh the page.":"2. {deviceName} 액세스를 허용하고 페이지를 새로 고침하세요."}');

/***/ }),

/***/ 5464:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Vervolgkeuzelijst voor evenementinstellingen"," Stage Control":" Bediening podium","Stage Controls and Information":"Bediening en informatie podium","Live in ":"Live binnen ","Start Session":"Sessie initiëren","End Session":"Sessie beëindigen","Present Screen":"Huidig scherm","Rehearse On Stage":"Repeteren op het podium","Turn on Microphone":"Microfoon inschakelen","Turn off Microphone":"Microfoon uitschakelen","Turn on camera":"Camera inschakelen","Turn off camera":"Camera uitschakelen","rehearsal mode":"repetitiemodus","People Watching: ${watchCount}":"Kijkers: ${watchCount}","Turn on Audio":"Audio inschakelen","Turn off Audio":"Audio uitschakelen","Are you sure you want to leave this room?":"Weet je zeker dat je deze ruimte wilt verlaten?","you will be redirected to stage in":"je wordt doorverwezen naar het podium binnen","sec. . ":"sec. . ","Skip to Main Navigation":"Ga naar de hoofdnavigatie","Skip to Chat":"Ga naar de chat","Skip to Meeting Controls":"Ga naar de bediening voor meetings","LinkedIn":"LinkedIn","Live in":"Live binnen","UPCOMING":"Aanstaande","Rehearse on stage":"Repeteren op het podium","Watch Rehearsal":"Repetitie bekijken","Answered by:":"Beantwoord door:","Speaker Off":"Luidspreker uit","Speaker On":"Luidspreker aan","Speaker Controls":"Bediening luidsprekers","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"Alle elementen van het podium zijn aanwezig achter de gedeelde afbeelding. Deze worden weer zichtbaar wanneer het delen van afbeeldingen op volledig scherm wordt beëindigd.","Close Ticker Popup":"Pop-upvenster ticker sluiten","Open GIF Picker":"GIF-selectie openen","Open Emoji Picker":"Emoji-selectie openen","Send Message":"Een bericht versturen","Tabs: Messaging and More":"Tabbladen: berichten en meer","Thanks for attending!":"Bedankt voor je deelname!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" Geen geplande sessies in de track waarop je bent geabonneerd. Schakel over naar andere tracks om livesessies te zien","Redirecting you to ":"Je wordt doorverwezen naar ","in ":"binnen ","seconds":"seconden","Main Navigation":"Hoofdnavigatie","YOU ARE HERE":"JE BENT HIER","Live Now":"Nu Live","SUBMIT":"INDIENEN","Allocated time for engagement has ended. You will be redirected to main stage":"De toegewezen tijd voor betrokkenheid is afgelopen.Je wordt doorverwezen naar het hoofdpodium","Wrap up in":"Beëindigen in","Session overrun by":"Sessie overbrugd door","Ending in":"Eindigt binnen","Bring this session live?":"Deze sessie live uitzenden?","START SESSION":"Sessie initiëren","Bring this session to end?":"Deze sessie beëindigen?","END SESSION":"Sessie beëindigen","Go On Stage":"Naar het podium","Muted by organizer":"Gedempt door organisator","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"Een organisator van het evenement heeft je audio gedempt. Je kunt het dempen opheffen door op de microfoonknop te klikken.","Gifs":"Gif\'s","Stickers":"Stickers","Launch Survey":"Vragenlijst openen","Microphone is on":"Microfoon ingeschakeld","Microphone is off":"Microfoon uitgeschakeld","Secret Code’s length should be 6 digits":"De geheime code moet uit 6 tekens bestaan","Closing in 00:":"Sluiten in 00:","Submit":"INDIENEN","Questions":"Vragen","Preview":"Voorbeeld","Close Survey":"Vragenlijst sluiten","This is a required question":"Dit is een verplichte vraag","Enter the text you’d like to present on stage below.":"Voer hieronder de tekst in\\ndie je op het podium wilt presenteren.","Use Chrome/Edge for best performance":"Gebruik Chrome/Edge voor de beste prestaties","Do you want to launch your survey now?":"Wil je de vragenlijst nu publiceren?","Success! Your Survey has been launched for attendees.":"Gelukt! Je vragenlijst is beschikbaar voor respondenten.","Unable to publish. Please try again.":"Publiceren mislukt. Probeer het opnieuw.","Are you sure you want to close this survey?":"Weet je zeker dat je de vragenlijst wilt sluiten?","Success! Your Survey has been closed for attendees.":"Gelukt! Je vragenlijst is gesloten voor respondenten.","Unable to un-publish. Please try again.":"Publiceren kan niet ongedaan worden gemaakt. Probeer het opnieuw.","Please answer all required questions.":"Beantwoord alle vereiste vragen.","You have already submitted this survey.":"Je hebt deze vragenlijst al ingediend.","Success! Thank you for your feedback.":"Gelukt! Bedankt voor je feedback.","Unable to submit. Please try again.":"Indienen mislukt. Probeer het opnieuw.","Launch surveys will take over attendees\' engagement panel.":"Het lanceren van vragenlijsten zal prevaleren in het engagementspanel van respondenten.","Closing this survey will remove it from attendees\' engagement panel.":"Als je de vragenlijst sluit, wordt deze verwijderd uit het engagementpanel van de respondenten.","Survey":"VRAGENLIJST","Updating Survey...":"Vragenlijst wordt bijgewerkt...","Closing":"Sluiten","Goldcast needs access to your camera and microphone":"Goldcast heeft toegang tot je camera en microfoon nodig","Goldcast needs access to your microphone":"Goldcast heeft toegang tot je microfoon nodig","Goldcast needs access to your camera":"Goldcast heeft toegang tot je camera nodig","SPEAKERS":"Sprekers","Mark as Unanswered":"Markeren als onbeantwoord","Mark as Answered":"Markeren als beantwoord","Remove from Priority":"Verwijderen als prioriteit","Mark as Priority":"Markeren als prioriteit","Answer":"ANTWOORDEN","Enter answer...":"Antwoord invoeren…","Answered by":"Beantwoord door","Submit Answer":"Antwoord indienen","Test your system’s speaker":"Test de luidspreker van je systeem","Click \\"Yes\\" if you hear the sound.":"Klik op \'Ja\' als je het geluid hoort.","Load previous":"Laden Vorige","Hide Name":"Naam verbergen","Text Q&A is disabled in On Demand mode.":"Tekst V&A is niet mogelijk in On Demand-modus.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"Limiet V&A-tekst bereikt. Deelnemers kunnen geen nieuwe vragen stellen.","Sent to Q&A":"Verzonden naar V&A","Couldn\'t post as Q&A. Please try again.":"Plaatsen als V&A mislukt. Probeer het opnieuw.","Yes this is being recorded":"Ja, dit wordt opgenomen","No this is not being recorded":"Nee, dit wordt niet opgenomen","System\'s Speaker Check":"Systeemcontrole luidsprekers","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"Controleer of de luidsprekers van je systeem goed werken om te garanderen dat je geluid hebt tijdens het evenement.","Click on “Test your system’s speaker” to proceed":"Klik op \'Test de luidspreker van je systeem\' om verder te gaan","Error while sharing message to screen. Post not found":"Fout bij het delen van het bericht op het scherm. Bericht niet gevonden","Lost connection to servers. Refresh your page to get live event experience.":"Verbinding met servers verbroken. Vernieuw de pagina om het live evenement te zien.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"Een VPN of firewall verhindert de authenticatie. Verbind met een ander netwerk of neem contact op met het IT-team om <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>deze domeinen</a> toegang te geven tot Goldcast.","It\'s taking too long":"Het duurt te lang","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"Het lijkt erop dat je verbonden bent via een VPN of een firewall hebt aanstaan. Bekijk dit <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>hulpdocument</a> om de voor Goldcast vereiste domeinen te whitelisten of verbind met een ander netwerk","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"Het lijkt erop dat je verbonden bent via een VPN of een firewall hebt aanstaan. Bekijk dit <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>hulpdocument</a> om de voor Goldcast vereiste domeinen te whitelisten, verbind met een ander netwerk of bekijk de sessie met de lite-modus","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"De Goldcast-videostreaming kan geen verbinding maken vanwege een slechte netwerkbandbreedte. Verbind met een ander netwerk om de livestreamingdienst te gebruiken.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"De Goldcast-videostreaming kan geen verbinding maken vanwege een slechte netwerkbandbreedte. Schakel over naar de lite-modus of verbind met een ander netwerk om de streamingdienst te gebruiken","Most Upvotes":"Meeste likes","Most Recent":"Nieuwste","My Questions":"Mijn vragen","Prioritized":"Prioriteit","Approved":"Goedgekeurd","Unapproved":"Niet goedgekeurd","Unanswered":"Onbeantwoord","Failed to update answer. Please try again!":"Antwoord bijwerken mislukt. Probeer het opnieuw!","Failed to post answer. Please try again!":"Antwoord plaatsen mislukt. Probeer het opnieuw!","Failed to delete question. Please try again!":"Vraag verwijderen mislukt. Probeer het opnieuw!","Survey Link":"Link naar de enquête","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"Overschakelen zal je huidige pagina vernieuwen naar de weergave voor aanwezigen. Schakel de weergave voor aanwezigen uit in het keuzemenu op je profiel om terug over te schakelen naar de weergave voor organisatoren.","You haven\'t asked any questions yet":"Je hebt nog geen vragen gesteld","No prioritized questions":"Geen vragen met prioriteit","Create prioritized list of questions for speakers by marking questions as priority":"Maak een geprioriteerde lijst met vragen door belangrijke vragen als prioriteit te markeren","No Approved Questions":"Geen goedgekeurde vragen","Approve incoming questions to see list of approved questions":"Keur ontvangen vragen goed om de lijst met goedgekeurde vragen te bekijken","No Unapproved Questions":"Geen niet-goedgekeurde vragen","No Answered Questions":"Geen beantwoorde vragen","Answer a question on stage or with inline text":"Een vraag beantwoorden op het podium of met inline tekst","All questions are answered":"Alle vragen zijn beantwoord","Rate Your Experience":"Beoordeel je ervaring","How satisfied are you with Goldcast?":"Hoe tevreden ben je over Goldcast?","What are the main reasons for your rating?":"Wat zijn de belangrijkste redenen voor deze beoordeling?","I am interested in seeing a demo of Goldcast":"Ik heb interesse in een demo van Goldcast","Thank You":"Bedankt","Your feedback was successfully submitted.":"Je feedback is ingediend.","Tell us how we can improve...":"Vertel ons wat we kunnen verbeteren…","1 Slide":"1 slide","Your internet connection is unstable.":"Je internetverbinding is onstabiel.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"Het lijkt erop dat je microfoon is gedempt. Klik op het microfoon-pictogram om het dempen op te heffen","The registration could not be completed! Please check that this email is allowed to register for the event.":"De registratie kon niet worden voltooid! Controleer of u zich met dit e-mail kunt registreren voor het evenement.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Zo te zien ben je al ingeschreven voor dit evenement! Controleer je map met ongewenste berichten als je je registratiebevestiging niet ontvangen hebt. Als je meer hulp nodig hebt, neem dan contact op met de organisator van het evenement.","Your registration could not be completed. This event has reached its registration capacity.":"Je registratie kon niet worden voltooid. Dit evenement heeft de registratielimiet bereikt.","Image cannot be an svg":"Afbeelding kan geen svg-bestand zijn","This should be a valid linkedin url":"Dit moet een geldige linkedin-URL zijn","This should be a valid twitter url":"Dit moet een geldige twitter-URL zijn","This should be a valid url":"Dit moet een geldige URL zijn","Video":"video","Read Less":"Minder lezen","live":"LIVE","Opened":"Geopend","In person only":"Alleen in persoon","Stage Stream":"Stage Stream","Streaming not available":"Streamen is niet beschikbaar","Close TV":"TV afsluiten","Streaming is not available for prerecorded and RTMP sessions":"Streamen is niet mogelijk voor vooraf opgenomen en RTMP-sessies","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Sluit je computer aan op een tv-scherm of projector zodat de reële aanwezigen kunnen volgen wat er op je virtuele podium gebeurt. Eenmaal verbonden, klik je op TV OPENEN en sleep of deel je het nieuwe venster met je tv-scherm of projector. ","Close Setup Mode":"Sluit de instellingenmodus","Help":"Help","upcoming":"Aanstaande","ended":"Beëindigd","Remove from favorites":"Verwijderen uit favorieten","Add to favorites":"Toevoegen aan favorieten","PLAY RECORDING":"Opname afspelen","VIEW RECORDING":"OPNAME BEKIJKEN","VIEW RECORDINGS":"OPNAMES BEKIJKEN","Virtual Backgrounds":"Virtuele achtergronden","No Device Available":"Geen apparaat beschikbaar","Needs permission":"Heeft toestemming nodig","Device not detected":"Apparaat niet gedetecteerd","Camera is on":"Camera is ingeschakeld","Camera is off":"Camera is uitgeschakeld","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"Gespiegelde video heeft geen effect voor de kijkers. De kijkers zien altijd niet-gespiegelde video\'s","Mirror My Video":"Mijn video spiegelen","Camera":"CAMERA","1. Click on Safari > Settings for this\\n            website":"1. Klik op Safari > Instellingen voor deze\\nwebsite","1. Click the lock":"1. Klik op het slotpictigram","icon in your browser’s address bar":"pictogram in de adresbalk van je browser","3. Unmute":"3. Dempen opheffen","and":"en","icons from stage control panel":"pictogrammen voor het bedieningspaneel van het podium","icon from stage control panel":"pictogram voor het bedieningspaneel van het podium","2. Set camera and microphone to “Allow”.":"2. Stel de camera en microfoon in op \'Toestaan\'.","2. Set camera to “Allow”.":"2. Stel de camera in op \'Toestaan\'.","2. Set microphone to \\"Allow\\"":"2. Stel de microfoon in op \'Toestaan\'","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. Selecteer \'Goldcast altijd toegang tot je camera en microfoon verlenen\'","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. Selecteer \'Goldcast altijd toegang tot je camera verlenen\'","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. Selecteer \'Goldcast altijd toegang tot je microfoon verlenen\'","Questions?":"Vragen?","If you’re having issues, check out our comprehensive":"Als je problemen ondervindt, raadpleeg dan onze uitgebreide","help docs":"hulpdocumenten","Speaker is on":"Luidspreker is ingeschakeld","Stop Test":"Test stoppen","Test your system’s audio":"Test de audio van je systeem","Still can\'t hear any sound?":"Nog steeds geen geluid?","Microphone":"MICROFOON","Audio is being played in system\'s default audio device.":"Audio wordt afgespeeld via het standaard audioapparaat van het systeem.","Click to view/change audio device":"Klik om je audioapparaat te bekijken of te wijzigen","Speaker":"LUIDSPREKER","Play Recording":"Opname afspelen","Recording for this broadcast is currently being processed and will be available soon":"Deze opname wordt momenteel verwerkt en zal binnenkort beschikbaar zijn","You haven\'t favorited anything yet!":"Je hebt nog niets toegevoegd aan je favorieten!","Add an item to favorites by selecting the ♡ in the top right corner.":"Voeg een item toe aan je favorieten door het ♡ in de rechterbovenhoek te selecteren.","Session has ended":"De sessie is beëindigd","System Check":"Systeemcontrole","Need help? Check out the":"Hulp nodig? Bekijk de","Skip Checks and Continue":"Controles overslaan en doorgaan","Click the button above to run the test":"Klik op bovenstaande knop om de test uit te voeren","Test Screenshare":"Schermdeling testen","Share message to stage":"Bericht met podium delen","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"Voer hieronder je tekst voor de ticker in. Voer een URL in om de ticker in een hyperlink te veranderen.","Ticker":"Ticker","Coffee Break! Be back in 10m.":"Koffiepauze! Ben over 10 min. terug.","Enter Message":"Bericht invoeren","https://www.xyz.com":"https://www.xyz.com","Launch":"Openen","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Bedankt voor het indienen van je vragen. Je kunt een nieuwe indienen zodra één van de huidige is goedgekeurd.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"Sorry! QA is momenteel uitgeschakeld. Je kunt een vraag indienen zodra de QA weer is ingeschakeld.","Votes":"Stemmen","Vote":"Stem","is inviting you to a video call":"nodigt je uit voor een videogesprek","ENTER ROOM":"RUIMTE BETREDEN","Start the conversation!":"Start het gesprek!","Couldn\'t send message. Click here to retry.":"Bericht verzenden mislukt. Klik hier om het opnieuw te proberen.","Couldn\'t add emoji. Please try again.":"Emoji toevoegen mislukt. Probeer het opnieuw.","Couldn\'t remove emoji. Please try again.":"Emoji verwijderen mislukt. Probeer het opnieuw.","Couldn\'t delete message. Please try again.":"Bericht verwijderen mislukt. Probeer het opnieuw.","Couldn\'t pin message. Please try again.":"Bericht vastmaken mislukt. Probeer het opnieuw.","Couldn\'t unpin message. Please try again.":"Kon het bericht niet losmaken. Probeer het opnieuw.","Today":"Vandaag","No messages yet":"Nog geen berichten","Messages from organizers and speakers appear here!":"Berichten van organisatoren en sprekers verschijnen hier!","Next Session is Starting":"De volgende sessie begint","Go to Next Session":"Ga naar de volgende sessie","I’d like to stay":"Ik wil graag blijven","My favorites":"Mijn favorieten","1. Click on the lock icon in your address bar":"1. Klik op het slotpictogram in de adresbalk","We recommend organizers and speakers use a desktop\\n        device":"We raden organisatoren en sprekers aan een desktop\\n te gebruiken","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"Om de beste ervaring te garanderen moeten deelnemers, sprekers en organisatoren\\nGoldcast vanaf een desktop gebruiken. Broadcasting vanaf een mobiel apparaat resulteert\\nin een slechtere ervaring.","Watch Now":"Nu bekijken","Video progress time":"Videovoortgang","Total video duration":"Totale videoduur","Rate Goldcast!":"Beoordeel goldcast!","Running Required Checks...":"De vereiste controles worden uitgevoerd…","Test Your Setup":"Test je configuratie","Test your Computer Device, Microphone and Camera before you join the event":"Test je computer/apparaat, microfoon en camera voordat je deelneemt aan het evenement","Speaker and microphone not working?":"Werken de luidspreker en microfoon niet?","Passed":"Geslaagd","Fix Audio Issues":"Audioproblemen oplossen","Check if audio is being played in other sound devices connected to phone/tablet":"Controleer of de audio werkt op andere geluidsapparaten die zijn aangesloten op de telefoon/tablet","Check if correct audio device is chosen from the below dropdown":"Controleer in de onderstaande vervolgkeuzelijst of het juiste audioapparaat is geselecteerd","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>Klik hier</a> om te controleren of het juiste audioapparaat om geluid af te spelen is geselecteerd","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Klik hier</a> om te controleren of het juiste audioapparaat om geluid af te spelen is geselecteerd","Right click on the browser tab & click “Unmute Site”":"Klik met de rechtermuisknop op het tabblad en klik op \'Site dempen opheffen\'","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Controleer of het tabblad van de browser niet is gedempt of klik op Venster > Dit tabblad dempen opheffen","System Check Failed!":"Systeemcontrolefout!","System Check Passed!":"Systeemcontrole geslaagd!","Complete checks to proceed":"Voltooi de controles om verder te gaan","Enter Event":"NAAR HET EVENEMENT","Skip Screen Sharing Check? ":"Controle voor schermdelen overslaan? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"We raden aan de controle voor schermdelen door te lopen als je scherm wordt getoond tijdens het evenement","Ignore & Enter Event":"Negeren en evenement invoeren","Test screenshare":"Schermdeling testen","Retry Now":"Probeer het nu opnieuw","SHARE":"Delen","Rooms Closed":"Ruimtes gesloten","Discussion rooms are now closed. You are being redirected to the Stage.":"De discussieruimtes zijn nu gesloten. Je wordt omgeleid naar de Stage.","Return To Stage":"TERUG NAAR PODIUM","Unrecognized embedded widget provider - ":"Niet-erkende provider ingesloten widget - ","Room Ended":"Ruimte gesloten","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"De organisator van je evenement heeft alle ruimtes gesloten. Je wordt nu doorgestuurd naar de event stage.","Video Q&A Request Cancelled":"V&A-videoverzoek geannuleerd","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Je V&A-videoverzoek is geannuleerd omdat je de lite-modus gebruikt. Schakel over naar de live-modus om je hand opnieuw op te steken.","Camera Passed":"Cameracontrole geslaagd","Camera Error":"Camerafout","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"Er worden geen cameramachtigingen verleend door de browser. Klik op \'Camera toestaan\'.","Camera permissions aren’t granted from system. Click “Allow Camera”":"Er worden geen cameramachtigingen verleend door het systeem. Klik op \'Camera toestaan\'","Uh-oh! Error occurred while creating camera stream":"Oeps! Er is een fout opgetreden bij het aanmaken van de camerastream","Close other applications which might use camera stream":"Sluit andere toepassingen die mogelijk een camerastream gebruiken","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>Klik hier</a> om te controleren of de browser toegang heeft tot de camera","Microphone Passed":"Microfooncontrole geslaagd","Microphone Error":"Microfoonfout","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"Er worden geen microfoonmachtigingen verleend door de browser. Klik op \'Microfoon toestaan\'","Mic permissions aren’t granted from system. Click “Allow Microphone”":"Er worden geen microfoonmachtigingen verleend door het systeem. Klik op \'Microfoon toestaan\'","Uh-oh! Error occurred while creating mic stream":"Oeps! Er is een fout opgetreden bij het aanmaken van de microfoonstream","Close other applications which might use mic stream":"Sluit andere toepassingen die mogelijk een microfoonstream gebruiken","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>Klik hier</a> om te controleren of de browser toegang heeft tot de microfoon","Speaker and Microphone Error":"Luidspreker- en microfoonfout","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"Er zijn microfoonmachtigingen vereist om de lijst met op het systeem aangesloten luidsprekers weer te geven. Klik op \'Microfoon toestaan\'","It seems mic is being used by other application. Close other applications to proceed.":"Het lijkt erop dat de microfoon door een andere toepassing wordt gebruikt. Sluit andere toepassingen om verder te gaan.","Camera & Microphone Error":"Camera- en microfoonfout","To enable permissions, click the Allow Camera & Mic button below":"Klik hieronder op de knop \'Camera en microfoon toestaan\' om machtigingen in te schakelen","Network Connection":"Netwerkverbinding","Check Passed":"Controle geslaagd","Could not establish a network connection":"Kan geen netwerkverbinding tot stand brengen","Connect to a different network, or use a mobile hotspot.":"Maak verbinding met een ander netwerk of gebruik een mobiele hotspot.","Disable any VPN or firewall is connected.":"Schakel je VPN of firewall uit.","Connection: Good":"Verbinding: Goed","Network Connection Error":"Fout tijdens verbinding met netwerk","Can’t connect to network. Change your network or limited functionality will be available during event.":"Kan geen verbinding maken met het netwerk. Wijzig je netwerk zodat je niet van het evenement mist.","AdBlocker":"AdBlocker","AdBlocker not detected.":"Geen AdBlocker gedetecteerd.","AdBlocker detected. This may degrade your event experience.":"AdBlocker gedetecteerd. Dit kan uw evenementervaring negatief beïnvloeden.","Disable adblocker for best experience.":"Schakel adblocker uit voor de beste ervaring.","You are using ":"Je gebruikt ","Use Windows or Mac OS for best performance":"Gebruik Windows of Mac OS voor de beste prestaties","Browser Check":"Browser controleren","Check Passed.":"Controle geslaagd.","Switch To Lite Mode":"Lite-modus inschakelen","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Je lopende V&A-videoverzoek wordt geannuleerd zodra je overschakelt naar de lite-modus","Stay on Live Mode":"Blijf in live-modus","Unable to mark as favorite":"Kan niet worden gemarkeerd als favoriet","Event organizers must enter the event to select favorites.":"Organisatoren van evenementen moeten deelnemen aan het evenement om favorieten te selecteren.","Make an Announcement":"Maak een mededeling","STOP":"STOP","InPerson CheckIn App":"InPerson CheckIn App","App to Check-In In-Person attendees":"App om fysieke deelnemers in te checken","SEE AGENDA":"Agenda weergeven","Please visit the Agenda tab to view the session recordings":"Ga naar het tabblad Agenda om de sessieopnames te bekijken","The session recordings will be available soon in the Agenda tab":"De sessieopnames zijn weldra beschikbaar op het tabblad Agenda","FAILED!":"MISLUKT!","Next session is beginning":"Volgende sessie begint","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"Wil je verdergaan naar de volgende sessie? Je stream gaat door en je tv zal de nieuwe sessie uitzenden.","Banners":"Banners","Images":"Afbeeldingen","Screen Share":"Scherm delen","Browser might not have screen-recording permission on your computer.":"De browser heeft mogelijk geen machtiging voor schermopname op je computer.","Open System Preferences":"Systeemvoorkeuren openen","Error publishing screen because someone else started screen share already.":"Fout bij het publiceren van het scherm omdat iemand anders het scherm al deelt.","Live Feed":"Live-feed","Check Your Network":"Controleer je netwerk","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"We hebben een fout gedetecteerd tijdens het afspelen van de video! Als je problemen ondervindt met het afspelen van video\'s, vernieuwen dan de pagina of schakel over naar de lite-modus.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"We hebben een fout gedetecteerd tijdens het afspelen van de video! Als je problemen ondervindt met het afspelen van de video, vernieuw dan de pagina.","All Dates":"Alle datums","All Tracks":"Alle tracks","Create Ticker":"Teller aanmaken","Booths Closed":"Stands gesloten","Your event organizer has closed all the booths. You will now be redirected to the stage":"De organisator van het evenement heeft alle stands gesloten. Je wordt nu doorgestuurd naar het podium","Visit the Polls tab to view live results.":"Ga naar het tabblad Polls om de resultaten in realtime te bekijken.","A new poll is open! Visit the Polls tab to vote.":"Er is een nieuwe opiniepeiling beschikbaar! Ga naar het tabblad Opiniepeilingen om te stemmen.","Vote for Polls":"Stemmen voor opiniepeilingen","Go to Polls Tab":"Ga naar het tabblad Opiniepeilingen","Microphone audio too low":"Microfoongeluid te laag","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"We hebben een probleem met je audio gedetecteerd. Probeer om het geluid te dempen/aan te zetten of gebruik een ander toestel als het probleem zich blijft voordoen.","Audio/Video bitrate too low":"Bitrate van audio of video is te laag","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"De instellingen van je firewall blokkeren de A/V-streams. We raden je aan een andere netwerkverbinding te kiezen.","Error sharing screen":"Fout bij schermdeling","A network error occurred while sharing screen. Please check your network connection.":"Er is een netwerkfout opgetreden tijdens het delen van het scherm. Controleer je netwerkverbinding.","Apologies, due to some errors, we need to refresh the page!":"We moeten de pagina helaas vernieuwen vanwege enkele fouten!","Warning":"Waarschuwing","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"We hebben een probleem met je video gedetecteerd. We raden je aan om andere tabbladen of andere toepassingen op je apparaat te sluiten en je internetverbinding te controleren/upgraden om dit probleem op verhelpen.","No results found":"Geen resultaten gevonden","Audio":"audio","Please choose another microphone and camera":"Selecteer een andere microfoon en camera","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"De geselecteerde microfoon en camera werken niet. Kies een andere microfoon en camera uit onderstaande vervolgkeuzelijsten.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"De geselecteerde camera werkt niet. Selecteer een andere camera in onderstaande vervolgkeuzelijst.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"Je kunt doorgaan zonder camera, maar voor een soepele uitzendervaring raden we je echter aan om dit te verhelpen.","Please choose another microphone":"Selecteer een andere microfoon","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"De geselecteerde microfoon werkt niet. Kies een andere microfoon uit onderstaande vervolgkeuzelijst.","Please check that your TV speaker is correct":"Controleer of de luidspreker van je televisie correct werkt","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"De geselecteerde luidspreker werkt niet. Selecteer een andere luidspreker uit onderstaande vervolgkeuzelijst.","Your answer":"Je antwoord","Edit":"Bewerken","Delete":"Verwijderen","Settings":"Instellingen","Signing Out":"Afmelden","Confirming your account...":"Je account bevestigen...","Something Went Wrong. Please Retry :(":"Er ging iets fout. Probeer het opnieuw :(","Resending Mail":"Mail opnieuw verzenden","offline":"offline","I am inviting you to a video meeting:":"Ik nodig je uit voor een videomeeting:","Resending secure login link to your email":"Opnieuw een veilige loginlink naar je e-mailadres verzenden","Sending secure login link to your email":"Een veilige loginlink naar je e-mailadres verzenden","Something went Wrong. Please Retry :(":"Er ging iets fout. Probeer het opnieuw :(","Updating your password":"Je wachtwoord bijwerken","Sending mail":"E-mail versturen","Verifying":"Verifiëren","This might be slower than usual":"Dit verloopt mogelijk langzamer dan gebruikelijk","Checking":"Controleren","New results available! Refresh!":"Nieuwe resultaten beschikbaar! Vernieuwen!","Saving":"Opslaan","Turn off Attendee mode":"De aanwezigheidsmodus uitschakelen","See Attendee View":"Aanwezigen bekijken","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Het aantal deelnemers dat momenteel de live sessies bekijkt. Opmerking: dit is alleen bestemd voor de organisator","Session Count":"Aantal sessies","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"Het aantal deelnemers dat momenteel de live sessies bekijkt. Opmerking: dit is alleen bestemd voor de organisator","Role":"Functie","Total Attendees":"Totaal aantal aanwezigen","Total number of attendees online at this time Note: This is for organizer eyes only":"Totaal aantal aanwezigen dat op dit moment online is Opmerking: Dit is alleen bestemd voor de organisator","My Profile":"Mijn profiel","Languages":"Talen","Filling out your profile can help you connect with people with similar interests.":"Door je profiel in te vullen, kun je in contact komen met mensen met dezelfde interesses.","type to search for your address":"type om je adres te zoeken","Could not open direct call":"Kan geen directe oproep starten","Chat messages can only be published from inside a broadcast.":"Chatberichten kunnen alleen tijdens een uitzending worden gepubliceerd.","Stage Logo can only be published from inside a broadcast.":"Podiumlogo\'s kunnen alleen tijdens een uitzending worden gepubliceerd.","Loading Speakers":"Luidsprekers laden...","Raise hand is disabled for organizer accounts, but active for attendee accounts":"Een hand opsteken is uitgeschakeld voor organisatoren, maar ingeschakeld voor deelnemers","Disabled in lite mode, return to live if you’d like to raise hand!":"Uitgeschakeld in de Lite-modus, keer terug naar de Live-modus als je je hand wilt opsteken!","Raise hand to enter stage for video q&a":"Hand opsteken om een vraag te stellen","Speakers":"Sprekers","Hosting organization: {organization}":"Hostende organisatie: {organization}","Failed to switch {deviceTag}":"Overschakelen naar {deviceTag} mislukt","Make sure your {deviceTag} is not being used by any other application and is working properly.":"Controleer of je {deviceTag} niet door een andere toepassing wordt gebruikt en correct werkt.","Facing issues with audio or video? Switch on lite mode":"Problemen met audio of video? Lite-modus inschakelen","Failed to get event for eventID: {eventID}":"Gebeurtenis voor event-ID: {eventID} ophalen mislukt.","Error while playing video.":"Fout tijdens het afspelen van de video.","Speakers only, attendees can\'t see this chat":"Alleen voor sprekers, deelnemers kunnen deze chat niet zien","Kudo":"Kudo","Room":"Ruimte","Session":"Sessie","Booth":"Cabines","Public":"Openbaar","Drift":"Drift","Slides":"Dia\'s","Videos":"Video\'s","Chat":"Chat","Messages":"Berichten","Poll":"Poll","Docs":"Documenten","Q&A":"Vraag en antwoord","Media":"Media","Messages Chat":"Berichten Chat","Leaderboard":"Leaderboard","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Opmerking: Je bent eveneens spreker voor dit evenement. Je hebt altijd toegang tot de Backstage en het podium.","Switch to Attendee View":"Overschakelen naar weergave voor aanwezigen","Return to Organizer View":"Terug naar de weergave voor organisatoren","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"Als je de weergave voor deelnemers uitschakelt, wordt je huidige pagina vernieuwd en keer je terug naar de weergave voor organisatoren. Wil je verdergaan?","Switch":"WISSELEN","Request Sent":"Verzoek verzonden","Your request for a demo has been submitted":"Je aanvraag voor een demo is verstuurd","Organizer Redirection":"Organisator doorverwijzen","YES, REDIRECT":"JA, DOORVERWIJZEN","DISMISS":"AFWIJZEN","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"Deelnemers worden doorverwezen naar de volgende sessie: {title}. Wil je ook doorverwezen worden naar de volgende sessie?","Stage":"Podium","Rooms":"Ruimtes","Join a round table to discuss moderated topics with your fellow attendees":"Neem deel aan een rondetafelgesprek om gemodereerde onderwerpen met andere deelnemers te bespreken","Booths":"Cabines","Join a booth to know more about a sponsor":"Ga binnen in een cabine om meer te weten over een sponsor","You are in the booth":"Je bent in de cabine","People":"Mensen","Connect with your fellow attendees":"Verbinding maken met andere deelnemers","Connect with speakers":"Verbinding maken met luidsprekers","starting in {duration}":"Begint over {duration}","You will be redirected to booths in {duration}":"Je wordt doorverwezen naar de stands in {duration}","booths":"Cabines","agenda":"Agenda","You will be redirected to {word} in {duration}":"Je wordt doorverwezen naar {word} in {duration}","You will be redirected to the live stage in {duration}":"Je wordt doorverwezen naar het live podium in {duration}","- You are about to be redirected to {tabTitle} in {duration}":"- Je wordt zometeen doorverwezen naar {tabTitle} in {duration}","See Agenda":"Agenda weergeven","Break":"WACHTEN","{title} is now live":"{title} is nu live","Apologies, due to an error we need to refresh the page!":"Helaas moeten we de pagina vernieuwen vanwege een fout!","Network interruption detected":"Netwerkonderbreking vastgesteld","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"Je internetverbinding ondervindt problemen. Als je een VPN gebruikt, kun je deze proberen uit te schakelen. Probeer eventueel verbinding te maken met een ander netwerk","No audio output device detected":"Geen apparaat voor audio-output gevonden","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Sluit je luidsprekers/koptelefoon aan en gebruik het tandwielpictogram om te controleren op eventuele problemen.","Please disable ad blocker for this page":"Schakel je adblocker uit voor deze pagina","Yes, I understand":"Begrepen!","No event user found so attended not marked!":"Geen gebruiker van evenement gevonden, dus niet gemarkeerd!","Wait while the speaker approves your video q&a request":"Wacht terwijl de spreker je videoverzoek goedkeurt","Organizer":"Organisator","UPNEXT":"volgende","Ended":"Beëindigd","Hide":"Verbergen","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"Deze pagina verwijst je automatisch door in {durationLeftToRedirect} seconden.","Register":"Registreren","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Fout: Gebruiker kan niet voor dit evenement worden geregistreerd. Neem contact op met de organisator van het evenement voor hulp","You are already registered!":"Je bent al geregistreerd!","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Blijkbaar ben je al ingeschreven voor dit evenement! Controleer je map met ongewenste berichten als je de registratiebevestiging niet hebt ontvangen. Neem contact op met de organisator van het evenement voor verdere hulp.","Thank you for registering!":"Bedankt voor het registreren!","Submit another response":"Dien nog een reactie in","Share":"Delen","Know someone who want to attend this?":"Ken je iemand die de vergadering wilt bijwonen?","COPY LINK":"LINK KOPIËREN","Powered by":"Mogelijk gemaakt door","VIEW PROFILE":"PROFIEL BEKIJKEN","You can access the event landing here":"Je kunt het evenement hier openen","Need Help?":"Hulp nodig?","Welcome back":"Welkom terug","Checking...":"Controleren ...","Close":"Sluiten","Enter":"Binnengaan","See {roomCount} Room(s)":"Bekijk {roomCount} ruimte(s)","Back":"Terug","Request a Demo":"Een demo aanvragen","Loading":"laden","Thread":"Antwoorden","Load more":"Meer laden","Heads up!":"Goed zo!","YES":"JA","No":"Nee","Following":"Volgend","Error in loading drimify":"Fout bij het laden van drimify","You\'re not registered for this event":"Je bent niet geregistreerd voor dit evenement","Check out other events":"BEKIJK ANDERE EVENEMENTEN","Date":"Datum","Location":"Locatie","How are you attending the event":"Hoe ga je naar het evenement?","In Person":"Ter plaatse","Virtually":"Virtueel","Event Widgets":"Evenementwidgets","Chat • Messages • Q&A • Poll • Docs":"Chat • Berichten • Vraag en antwoord • Poll • Documenten","DISCUSSION":"DISCUSSIE","JOIN":"DEELNEMEN","WAIT":"WACHTEN","more":"meer","See Profile":"Profiel bekijken","Filter":"Filteren","Video player not supported by your browser":"Videospeler niet ondersteund door je browser","We recommend using the latest version of Google Chrome to access your conference":"We raden aan om de meest recente versie van Google Chrome te gebruiken om toegang te krijgen tot je conferentie","ANSWER":"ANTWOORDEN","REJECT":"AFWIJZEN","Don’t ask me this next time":"Dit niet meer opnieuw vragen","Cancel":"Annuleren","Lite Mode":"Lite-modus","On":"Aan","Connection Issues? Turn on Lite Mode":"Verbindingsproblemen? Lite-modus uitschakelen","Turn On Lite Mode":"Lite-modus inschakelen","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"In de Lite-modus is er een vertraging van 30 seconden tussen de live-uitzending en wat je op je scherm ziet. Wil je verdergaan?","Turn On":"Inschakelen","Lite Mode Active!":"Lite-modus actief!","Thanks for your patience, lite mode now on!":"Bedankt voor je geduld, de Lite-modus is nu ingeschakeld!","Turn off Lite Mode?":"Lite-modus uitschakelen?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Schakel de Lite modus uit om de live uitzending opnieuw te bekijken. Let op, dit brengt een vertraging van 30 s met zich mee.","Lite Mode Off!":"Lite-modus uitgeschakeld!","Thanks for your patience, we’ve returned to the live broadcast!":"Bedankt voor je geduld, we zijn terug in de live-uitzending!","Lite Mode Unavailable":"Lite-modus niet beschikbaar","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Sorry voor het ongemak. De Lite-modus is momenteel niet beschikbaar, schakel over naar Live Broadcast om je sessie te hervatten.","Turn off Lite mode?":"Lite-modus uitschakelen?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"We hebben gemerkt dat je verbinding weer normaal is. Wil je terugschakelen naar de live-uitzending? Let op, dit brengt een vertraging van 30 s met zich mee.","Turn Off":"Uitschakelen","Lite mode is disabled for organizer accounts, but active for attendee accounts":"De Lite-modus is uitgeschakeld voor organisatoren, maar ingeschakeld voor deelnemers","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"Lite-modus wordt niet ondersteund door je browser. We raden aan om de meest recente versie van Google Chrome te gebruiken","Lite mode is not curently available. We’ll let you know once it’s available again":"Lite-modus is momenteel niet beschikbaar. We laten het je weten zodra de modus weer beschikbaar is","Turn off Lite Mode":"Lite-modus uitschakelen","We’ll let you know when Lite mode is available again":"We laten het je weten zodra de Lite-modus weer beschikbaar is","Lite Mode Available":"Lite-modus beschikbaar","Loading Lite Mode...":"Lite-modus laden ...","Turning Off Lite Mode":"Lite-modus uitschakelen","Lite Mode On":"Lite-modus aan","Audio/Video Issues?":"Audio-/videoproblemen?","Error":"Fout","Click a video to play":"Klik op een video om deze af te spelen","Error starting video!":"Fout bij starten van video!","Please rotate your device to {mode} mode":"Draai je apparaat in de modus {mode}","landscape":"liggend","portrait":"staand","Thank you for attending this event!":"Bedankt om dit evenement bij te wonen!","Go to Rooms":"Naar Ruimtes gaan","Please use a desktop or laptop Google Chrome browser to access your conference":"Gebruik een Google Chrome-browser op je desktop of laptop om toegang te krijgen tot je conferentie","If on Desktop":"Op desktop","Please increase the width of your window":"Maak je venster breder","Alternatively, check out the":"Of bekijk de","Youtube Livestream":"YouTube-livestream","Search":"Zoeken","Profile":"Profiel","Yes":"Ja","Loading Chat":"Chat laden","Please wait while we fetch the chat":"Even geduld terwijl we de chat ophalen","Load old messages":"Oude berichten laden","Join the room to see chat":"Ga de ruimte binnen om de chat te zien","Live Chat":"Live chat","Uh..oh we couldn\'t load the content":"Oeps.. de inhoud kon niet geladen worden","Please reload the page":"Vernieuw de pagina","New comments":"Nieuwe reacties","Start the conversation":"Gesprek beginnen","Be the first to add to chat!":"Zeg als eerste iets in de chat!","Enter your message":"Schrijf je bericht","Joining chat!":"Je neemt dele aan de chat!","See all pinned messages":"Alle vastgezette berichten bekijken","Failed to send! Retry?":"Verzenden mislukt! Opnieuw proberen?","Search for attendee":"Deelnemer zoeken","Up to date":"Up-to-date","Start a new conversation, We think you\'ll enjoy":"Begin een nieuw gesprek, we denken dat je het leuk zult vinden","chatting with these recommended attendees!":"chatten met deze aanbevolen deelnemers!","Searching":"Zoeken","Load Previous":"Laden Vorige","Load Next":"Volgende laden","Loading Channel":"Kanaal laden","Please wait while we fetch the channel":"Even geduld terwijl we het kanaal ophalen","Please wait while we fetch the messages":"Even geduld terwijl we de berichten ophalen","Send the first message":"Stuur het eerste bericht","Join":"Deelnemen","link":"link","download":"downloaden","Click to open":"Klik om te openen","No open polls":"Geen opiniepeilingen beschikbaar","Check back later to see if a poll opens up!":"Kom later terug om na te gaan of er een opiniepeiling beschikbaar is!","Loading Poll":"Opiniepeiling laden","Please wait while we fetch the polls":"Even geduld terwijl we de polls ophalen","Uh oh.. we couldn’t load the content":"Oeps.. de inhoud kon niet geladen worden","Polls":"Polls","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"Voeg de vraag en antwoorden toe aan deze sessie in het beheerdersdashboard van Goldcast","Stop Sharing":"Delen stoppen","Can\'t publish polls while something else is being presented on stage":"Kan geen opiniepeilingen publiceren terwijl er iets anders op het podium wordt gepresenteerd","Open":"Openen","Cancel your video q&a request":"Annuleer je video-aanvraag voor vraag en antwoord","Pending...":"In behandeling ...","Leave Stage":"Podium verlaten","Raise Hand":"Hand opsteken","Text Q&A":"Tekst vraag en antwoord","Video Q&A":"Video - vragen en antwoorden","Loading Q&amp;A":"Vraag en antwoord laden","Please wait while we fetch the Q&amp;A":"Even geduld terwijl we vraag en antwoord ophalen","Uh oh.. we couldn\'t load the content":"Oeps.. de inhoud kon niet geladen worden","No Questions Yet":"Er werden nog geen vragen gesteld","Tell your audience to send in questions!":"Vraag uw publiek om vragen in te dienen!","Be the first to ask a question!":"Stel als eerste een vraag!","Tell your audience to raise their hand!":"Moedig uw publiek aan om hun inbreng te delen!","Approve":"Goedkeuren","Reject":"Afwijzen","End":"Beëindigen","RELOAD":"VERNIEUWEN","Logos On Stage":"Logo\'s op het podium","No File Chosen":"Geen bestand geselecteerd","loading":"laden","Can\'t publish a slide when there is something else being presented on stage":"Kan geen dia publiceren als er iets anders op het podium wordt gepresenteerd","Change Deck":"Diavoorstelling wijzigen","stop-screen-share":"stop-schermdelen","screen-share":"schermdelen","Select a deck to begin presenting":"Selecteer een diavoorstelling om te beginnen met presenteren","CONFIRM":"BEVESTIGEN","If you’re having issues, please refer to the":"Klik bij problemen op","SPEAKER":"LUIDSPREKER","Issue Testing Audio!":"Probleem met het testen van audio!","VPN and adblockers may cause video issues, please disable them before proceeding":"VPN en adblockers kunnen videoproblemen veroorzaken, schakel ze uit voordat je verdergaat","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"Let op: VPN en adblockers kunnen problemen met je video veroorzaken, laat ze tijdens je uitzending dus uitgeschakeld","Follow":"Volgen","Read More":"Lees verder","Ask a question":"Een vraag stellen","Shared":"Gedeeld","Answered":"Beantwoord","Waiting Approval":"Wachten op goedkeuring","cancel":"annuleren","ENTER":"BINNENGAAN","Upcoming Events":"Eerstvolgende evenementen","Past Events":"Past Events","Goldcast":"Goldcast","MANAGE EVENT":"EVENEMENT BEHEREN","Edit Profile":"Profiel bewerken","Stay tuned!":"Blijf ons volgen!","Sign-in instructions will be available here 12 hours prior to the event":"Twaalf uur voor het evenement zie je hier hoe je je kunt aanmelden","Please log out":"Gelieve uit te loggen","Logout":"Uitloggen","Continue as {differentUser}":"Ga door als {differentUser}","You are already logged in as {user}.":"Je bent al aangemeld als {user}.","EMAIL":"E-MAIL","user@email.com":"user@email.com","FIRST NAME":"Voornaam","First Name":"Voornaam","LAST NAME":"Achternaam","Last Name":"Achternaam","You are not registered to this event":"Je bent niet geregistreerd voor dit evenement","Please enter your email and name":"Voer je e-mail en naam in","Please enter your email":"Voer je e-mail in","We have sent a secret code to":"We hebben een geheime code verstuurd naar","BACK":"TERUG","Didn\'t receive an email? Make sure to check spam list":"Geen e-mail ontvangen? Controleer je map met ongewenste berichten","Resend Mail":"E-mail opnieuw verzenden","SECRET CODE":"GEHEIME CODE","Please enter the temporary password sent to your email":"Voer het tijdelijke wachtwoord in dat je per e-mail hebt ontvangen","NEW PASSWORD":"NIEUW WACHTWOORD","Please enter a new password":"Voer een nieuw wachtwoord in","CONFIRM PASSWORD":"WACHTWOORD BEVESTIGEN","Please re-enter the new password":"Voer het nieuwe wachtwoord opnieuw in","Password length should be atleast 8":"Wachtwoord moet uit minstens 8 tekens bestaan","Password and Confirm Password don\'t match !!":"Het wachtwoord en de wachtwoordbevestiging komen niet overeen!","Please enter your password to continue":"Voer uw wachtwoord in om verder te gaan","Logging you in...":"Inloggen ...","PASSWORD":"WACHTWOORD","Forgot credentials?":"Inloggegevens vergeten?","Forgot Password? A mail will be sent to your registered email.":"Wachtwoord vergeten? Er wordt een e-mail verzonden naar je geregistreerde e-mailadres.","Email cannot be blank!!":"E-mail mag niet leeg zijn!","We have sent a secure login link to":"We hebben een beveiligde inloglink gestuurd naar","from":"van","Please use that to access your event.":"Gebruik de link om toegang te krijgen tot je evenement.","Please check spam/promotion too if you can\'t find it.":"Controleer ook je spamfolder/reclameberichten als je de e-mail niet kunt vinden.","Thank You !":"Bedankt!","The link is not valid.":"De link is niet geldig.","Please be patient.":"Even geduld.","We are verifying your link.":"We verifiëren je link.","Thank you for entering the code!":"Bedankt voor het invoeren van de code!","Please create a new password":"Maak een nieuw wachtwoord aan","Signing you up...":"Aanmelden ...","We have sent a temporary password to":"We hebben een tijdelijk wachtwoord verstuurd naar","TEMPORARY PASSWORD":"TIJDELIJK WACHTWOORD","Please enter the temporary password sent to your mail":"Voer het tijdelijke wachtwoord in dat je per e-mail hebt ontvangen","Password Length should be 8":"Wachtwoord moet uit 8 tekens bestaan","Okay":"Oké","Backstage: {title}":"Backstage: {title}","Prep Area":"Voorbereidingsruimte","Starting at {time}":"Begint over {time}","person":"persoon","inside":"binnen","No one is inside":"Er is niemand binnen","This area is for you to sync up with your fellow speakers before you go on stage.":"Hier kun je met je medesprekers overleggen voordat je het podium op gaat.","This area is for you to check your cam and mic before you enter the room.":"Hier kun je je camera en microfoon controleren voordat je de ruimte binnengaat.","I\'m Ready":"Ik ben klaar","Watch Live":"Live kijken","Backstage":"Backstage","You are sharing your screen":"Je deelt je scherm","LIVE":"LIVE","Live":"LIVE","Virtual":"Virtueel","Only available for ":"Alleen beschikbaar voor ","See Booths":"Cabines bekijken","See Rooms":"Ruimtes bekijken","Enter Backstage":"Backstage gaan","This track has no upcoming sessions. Check out a different track.":"Dit traject heeft geen geplande sessies. Bekijk een ander traject.","View":"Bekijken","Agenda":"Agenda","Scroll to see all tracks":"Scroll om alle nummers te zien","No Agenda Items to show!":"Geen agenda-items om te tonen!","ENTER EVENT":"NAAR HET EVENEMENT","change":"wijzigen","Upload":"Uploaden","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF OF PNG. MAX. GROOTTE VAN 5 MB","Create Profile":"Profiel aanmaken","Email":"E-mailadres","Company":"Bedrijf","Title":"Titel","No matching locations found":"Geen overeenkomende locaties gevonden","You can try searching for the location with another keyword":"Je kunt proberen de locatie te zoeken met een ander trefwoord","Interest Tags":"Interessetags","Pick your first tag":"Kies je eerste tag","Save":"Opslaan","Searching...":"Zoeken ...","Twitter":"Twitter","Select Your First Tags":"Kies je eerste tags","Add Interest tags":"Interessetags toevoegen","Congratulations!":"Gefeliciteerd!","Your first Goldcast event is set up":"Je eerste Goldcast-evenement is opgezet","You can always visit":"Je kan altijd surfen naar","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"voor instructies over het opzetten en uitvoeren van je evenementen","See My Event":"Mijn evenement bekijken","Peak Community":"Peak Community","Loading Lite Mode... This may take up to 30s":"Lite-modus laden ... Dit kan tot 30 seconden duren","Loading Video...":"Video laden...","Video will begin at session start time":"De video begint bij aanvang van de sessie","TIME":"TIJD","TITLE":"TITEL","STATUS":"STATUS","END":"Beëindigen","START":"START","AGENDA":"Agenda","Enable Audio":"Audio inschakelen","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"Audio is gedempt vanwege beleid voor automatisch afspelen van browsers. Klik hieronder op inschakelen om het dempen ongedaan te maken. Je kunt het dempen van audio ook later ongedaan maken via ingesloten besturingselementen.","Enable":"Inschakelen","You are being redirected outside the room. Would you like to continue?":"Je wordt uit de ruimte geleid. Wil je verdergaan?","Continue":"Verdergaan","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"Je kunt ook kiezen voor de Lite-modus die 30 seconden achter loopt op de live-uitzending","We detected a network issue":"We stelden een netwerkprobleem vast","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Zorg ervoor dat je geen verbinding maakt via een VPN/Firewall. Probeer een ander(e) netwerk, browser of apparaat als het probleem aanhoudt.","Could not connect":"Kon niet verbinden","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"Dit kan te wijten zijn aan een beveiligd netwerk of een probleem met je browser/apparaat. Probeer een ander(e) netwerk, browser of apparaat als het probleem aanhoudt.","Switch to Lite Mode":"Lite-modus inschakelen","Leave":"verlaten","Screenshare had an issue":"Er was een probleem met het delen van het scherm","Could not share screen unexpectedly. Refresh & retry. On mac go to":"Onverwacht kon het scherm niet worden gedeeld. Vernieuwen en opnieuw proberen Ga op mac naar","and check if your browser has the required permission":"en controleer of je browser over de vereiste toestemming beschikt.","Uh OH... Something went wrong":"Oh oh ... Er ging iets mis","To fix this, click the":"Om dit op te lossen, klikt u op de","in your URL bar, then select “Allow”, and then click “Try Again”":"Klik in je URL-balk op \'Toestaan\' en vervolgens op \'Opnieuw proberen\'","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"Kan je mediastream niet initialiseren vanwege een onbekende reden! Je browser wordt mogelijk niet ondersteund door ons platform. We raden aan om Google Chrome te gebruiken. Neem contact op met de ondersteuning van Goldcast als dit probleem zich blijft voordoen","To fix this, make sure your":"Om dit op te lossen, moet u ervoor zorgen dat je","is not being accessed by any other app. If not, please try changing your":"niet wordt geopend door een andere app. Zo niet, probeer dan je","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"apparaten door op \\"Naar instellingen\\" te klikken. Klik na het oplossen van het vermoedelijke probleem op \'Opnieuw proberen\'!","Go To Settings":"Naar instellingen gaan","Try Again":"Probeer het opnieuw","Try Joining without Video":"Probeer deel te nemen zonder video","A refresh and rejoin should work":"Vernieuwen en opnieuw inloggen zou moeten lukken","Refresh & Rejoin":"Vernieuwen en opnieuw deelnemen","Start Chat":"Chat beginnen","On Stage":"Op het podium","Connect your on-site camera and microphone to present to your virtual attendees":"Sluit uw on-site camera en microfoon voor een presentatie aan uw virtuele aanwezigen","Stop Streaming":"Stop met streamen","Start Streaming":"Begin met streamen","Set up on-site video feed":"On-site videofeed instellen","Open TV":"TV openen","Layout: {layout} ":"Layout: {layout} ","With Speaker Videos":"Met video\'s van sprekers","Full Screen":"Volledig scherm","No Speakers":"Geen sprekers","Turn Off Setup Mode":"Installatiemodus uitschakelen","Setup Mode":"Installatiemodus","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"Druk op uitschakelen als je de configuratiemodus voor {roomTitle} wilt beëindigen. Hierdoor worden ook alle actieve streams uitgeschakeld.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"Voorbereiden om te streamen: {roomTitle}. Gebruik de instellingenmodus alleen om te streamen vanaf de live locatie.","Starting in {duration}":"Begint over {duration}","Can\'t share screen while there is something else being presented on stage":"Kan geen scherm delen terwijl er iets anders op het podium wordt gepresenteerd","You are now in attendee view!":"Je gebruikt nu de weergave voor deelnemers!","You are now in organizer view!":"Je gebruikt nu de weergave voor organisatoren!","Note :":"Opmerking:","Only organizer accounts can see this tag, normal attendees can’t see this":"Alleen organisatoren kunnen deze tag zien, nandere deelnemers kunnen dit niet zien","Attendee":"Deelnemer","Event Information":"Informatie over het evenement","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"Eventinformatie is alleen zichtbaar voor organisatoren! <br /> Dit gedeelte is niet zichtbaar voor deelnemers","Operating System":"Besturingssysteem","Secondary Booths":"Aanvullende cabines","Sort":"Filter","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"Je volgt {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2}zal je automatisch niet langer volgen op{track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}Wil je verdergaan?","Track only available for {tracks}":"Track alleen beschikbaar voor {tracks}","Add to Calendar":"Toevoegen aan agenda","Open Speakers Control Panel":"Configuratiescherm voor sprekers openen","Move Offstage ↓":"Verplaats uit Offstage ↓","Error Moving ⚠":"Fout bij verplaatsen ⚠","Off Stage":"Offstage","Move to Stage":"Naar podium","An error occurred!":"Er is een fout opgetreden!","{eventName} Documents":"{eventName} Documenten"," Set Up Mode":" Installatiemodus","Camera & Mic blocked":"Camera en microfoon geblokkeerd","Camera/Mic Inaccessible":"Camera/microfoon ontoegankelijk","Camera/Mic Not Found":"Camera/microfoon niet gevonden","Camera Inaccessible":"Camera ontoegankelijk","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"De camera is in gebruik of de resolutie wordt niet ondersteund. Controleer of je camera niet wordt gebruikt door een andere toepassing en probeer het opnieuw!","No microphone/camera is found":"Geen microfoon/camera gevonden","The browser does not support using camera and microphone!":"De browser ondersteunt geen camera en microfoon!","{n} Slides":"{n} Slides","Starting in {timeduration}":"Begint over {timeduration}","{eventtitle} has ended":"{eventtitle} is beëindigd","This is a text q&a question!":"Dit is een tekstuele Q&A-vraag!","Click here{if_it_does_not}":"Klik hier{if_it_does_not}","{click_here}if it does not":"{click_here}als dat niet het geval is","{title}up next":"{title}volgende","seat(s) open":"beschikbare plaats(en)","Signal strength is low. Close other windows or connect to a different network.":"Signaalsterkte is gering. Sluit andere vensters of maak verbinding met een ander netwerk.","GO BACKSTAGE":"NAAR BACKSTAGE","LEAVE STAGE":"Podium verlaten","LEAVE":"verlaten","This event begins on{startitme}":"Dit evenement begint om {startitme}","Please refresh to enter.":"Vernieuw om verder te gaan.","people":"mensen","Oops, Something went wrong":"Er is iets misgegaan","Back Home":"Terug naar startpagina","Deciding where to go ...":"Beslissen waar je heen wilt...","Go to Event Hub":"Ga naar de Eventhub","CREATE":"AANMAKEN","Attending Virtually":"Virtueel bijwonen","Attending In Person":"Persoonlijk bijwonen","Click to change your attendance type":"Klik om je aanwezigheid te wijzigen","Open Chat":"Chat openen","Create your profile for {eventtitle}":"Maak je profiel aan voor {eventtitle}","Move to stage":"Naar podium","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"De organisator van het evenement heeft verzocht je naar het podium te verplaatsen voor <strong>{broadcastTitle}</strong> .<br /><br />Als je de aanvraag accepteert, ben je live en zichtbaar voor deelnemers van het evenement.<br /><br />","Go Live On Stage":"Ga live op het podium","Moved to backstage":"Verplaatst naar backstage","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"De organisator heeft je van het podium verwijderd. Probeer niet om opnieuw deel te nemen zonder contact op te nemen met de organisator.","Error creating Screen stream":"Fout bij het aanmaken van de schermstream","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"Geen toestemming om het scherm te delen. *Klik hier* om de probleemoplossing te raadplegen.","Error publishing stream":"Fout bij het publiceren van de stream","Could not publish stream. Please refresh and try again!":"Kon de stream niet publiceren. Vernieuw en probeer het opnieuw!","Error publishing screen":"Fout bij het publiceren van het scherm","Error publishing screen. Please refresh and try again!":"Fout bij het publiceren van het scherm. Vernieuw en probeer het opnieuw!","Error unpublishing stream":"Fout bij het opheffen van de stream","Error unpublishing stream. Please refresh and try again!":"Fout bij het opheffen van de stream. Vernieuw en probeer het opnieuw!","Invalid Publish Operation":"Ongeldige publicering","{username} profile picture":"{username} profielfoto","Default":"Standaard","A-Z":"A-Z","Random":"Willekeurig","All":"Alle","Past":"Vorige","Upcoming":"Aanstaande","Learn More":"Meer informatie","close":"sluiten","Discussion Rooms":"Discussieruimten","ATTENDEE MODE":"DEELNEMERSMODUS","Loading...":"Bezig met laden ...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"Het apparaat is uitgeschakeld door de browser of er zijn geen toestemmingen verleend. Geef toestemming en klik op \'Opnieuw proberen\'","You are now registered. You will receive an email confirming details shortly.":"Je bent geregistreerd! Je ontvangt binnenkort een bevestigingsmail met de details.","Streaming to Virtual Users from on-site video feed":"Streaming naar virtuele gebruikers van de on-site videofeed","Ending in ":"Eindigt binnen ","GO LIVE":"GA LIVE","You have no past events.":"Je hebt geen eerdere evenementen.","You have no upcoming or live events.":"Je hebt geen aankomende of live evenementen.","left":"links","center":"centraal","right":"rechts","top":"Boven","bottom":"Onder","loading...":"bezig met laden ...","Loading ...":"Bezig met laden ...","Failed to redirect!":"Doorverwijzen mislukt!","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"Het lijkt erop dat je een adblocker gebruikt. Dit kan je gebruikerservaring beïnvloeden. Schakel je adblocker uit.<br />&lt;br / &gt; Klik <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>hier</a> voor meer instructies indien je hulp nodig hebt.","redirecting in {duration}":"doorverwijzen in {duration}","STOP VIDEO":"VIDEO AFSLUITEN","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"Je gaat deze video afsluiten Je keert terug naar de live-modus en je publiek zal je sprekers zien en horen. Weet je het zeker?","STOP SHARING":"Delen stoppen","No Next Slide":"Geen volgende slide","Next Slide":"Volgende slide","No Previous Slide":"Geen vorige slide","Previous Slide":"Vorige slide","something went wrong while recording the response please try again":"er is iets misgegaan tijdens het opslaan van het antwoord, probeer het opnieuw","Start In-Person Streaming":"Start persoonlijke streaming","Stop In-Person Streaming":"Stop persoonlijke streaming","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Je video wordt gebufferd, de testsessie begint zometeen. Dit zal niet gebeuren tijdens de eigenlijke sessie.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"De teller verschijnt bovenaan de webpagina voor alle deelnemers. Voer onderstaande URL in om de teller in een hyperlink te veranderen.","Allow {key}":"{key} toestaan","{messageType} can only be published from inside a broadcast.":"{messageType} kan alleen vanuit een broadcast worden gepubliceerd.","To grant {deviceName} access to this page, follow the two steps below:":"Volg deze twee stappen om {deviceName} toegang te verlenen tot deze pagina:","2. Allow {deviceName} access and then refresh the page.":"2. Geef {deviceName} toegang en vernieuw de pagina."}');

/***/ }),

/***/ 5726:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Lista rozwijana ustawień wydarzenia"," Stage Control":" Kontrola sceny","Stage Controls and Information":"Informacje i kontrola sceny","Live in ":"Na żywo za ","Start Session":"Rozpocznij sesję","End Session":"Zakończ sesję","Present Screen":"Zaprezentuj ekran","Rehearse On Stage":"Próba na scenie","Turn on Microphone":"Włącz mikrofon","Turn off Microphone":"Wyłącz mikrofon","Turn on camera":"Włącz kamerę","Turn off camera":"Wyłącz kamerę","rehearsal mode":"tryb próby","People Watching: ${watchCount}":"Osoby oglądające: ${watchCount}","Turn on Audio":"Włącz dźwięk","Turn off Audio":"Wyłącz dźwięk","Are you sure you want to leave this room?":"Czy na pewno chcesz opuścić ten pokój?","you will be redirected to stage in":"nastąpi przekierowanie na scenę za","sec. . ":"sek. ","Skip to Main Navigation":"Przejdź do nawigacji głównej","Skip to Chat":"Przejdź do czatu","Skip to Meeting Controls":"Przejdź do elementów sterujących spotkaniem","LinkedIn":"LinkedIn","Live in":"Na żywo za","UPCOMING":"Nadchodzące","Rehearse on stage":"Próba na scenie","Watch Rehearsal":"Zobacz próbę","Answered by:":"Odpowiedź od:","Speaker Off":"Głośnik wyłączony","Speaker On":"Głośnik włączony","Speaker Controls":"Sterowanie głośnikiem","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"Wszystkie elementy sceny znajdują się za udostępnionym obrazem. Staną się ponownie widoczne po zatrzymaniu pełnoekranowego udostępniania obrazu.","Close Ticker Popup":"Zamknij wyskakujące okienko paska","Open GIF Picker":"Otwórz selektor GIF","Open Emoji Picker":"Otwórz selektor emotikonów","Send Message":"Wyślij wiadomość","Tabs: Messaging and More":"Karty: Wiadomości i nie tylko","Thanks for attending!":"Dziękujemy za udział!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" Brak nadchodzących sesji w subskrybowanej ścieżce. Aby zobaczyć sesje na żywo, przełącz do innych ścieżek.","Redirecting you to ":"Przekierowanie do ","in ":"za ","seconds":"sek.","Main Navigation":"Nawigacja główna","YOU ARE HERE":"JESTEŚ TUTAJ","Live Now":"Teraz na żywo","SUBMIT":"Prześlij","Allocated time for engagement has ended. You will be redirected to main stage":"Czas przeznaczony na zaangażowanie dobiegł końca. Nastąpi przekierowanie na scenę główną.","Wrap up in":"Koniec za","Session overrun by":"Przekroczenie czasu sesji o","Ending in":"Zakończenie za","Bring this session live?":"Przełączyć tę sesję w tryb na żywo?","START SESSION":"ROZPOCZNIJ SESJĘ","Bring this session to end?":"Zakończyć tę sesję?","END SESSION":"ZAKOŃCZ SESJĘ","Go On Stage":"Wejdź na scenę","Muted by organizer":"Wyciszenie przez organizatora","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"Jeden z organizatorów wydarzenia wyciszył Twój dźwięk. Możesz wyłączyć wyciszenie, klikając przycisk mikrofonu.","Gifs":"Obrazy GIF","Stickers":"Naklejki","Launch Survey":"Uruchom ankietę","Microphone is on":"Mikrofon jest włączony","Microphone is off":"Mikrofon jest wyłączony","Secret Code’s length should be 6 digits":"Kod powinien mieć długość 6 cyfr","Closing in 00:":"Zamknięcie za 00:","Submit":"Prześlij","Questions":"Pytania","Preview":"Podgląd","Close Survey":"Zamknij ankietę","This is a required question":"To jest wymagane pytanie","Enter the text you’d like to present on stage below.":"Wpisz poniżej tekst, który chcesz zaprezentować na scenie.","Use Chrome/Edge for best performance":"Aby uzyskać najlepszą wydajność, korzystaj z przeglądarki Chrome/Edge.","Do you want to launch your survey now?":"Czy chcesz teraz uruchomić ankietę?","Success! Your Survey has been launched for attendees.":"Udało się. Twoja ankieta została uruchomiona i przesłana do uczestników.","Unable to publish. Please try again.":"Nie można opublikować. Spróbuj ponownie.","Are you sure you want to close this survey?":"Czy na pewno chcesz zamknąć tę ankietę?","Success! Your Survey has been closed for attendees.":"Udało się. Twoja ankieta została zamknięta dla uczestników.","Unable to un-publish. Please try again.":"Nie można cofnąć publikacji. Spróbuj ponownie.","Please answer all required questions.":"Odpowiedz na wszystkie wymagane pytania.","You have already submitted this survey.":"Ta ankieta została już przesłana.","Success! Thank you for your feedback.":"Udało się! Dziękujemy za Twoją opinię.","Unable to submit. Please try again.":"Nie można przesłać. Spróbuj ponownie.","Launch surveys will take over attendees\' engagement panel.":"Uruchomienie ankiety spowoduje zakrycie panelu zaangażowania uczestników.","Closing this survey will remove it from attendees\' engagement panel.":"Zamknięcie tej ankiety spowoduje usunięcie jej z panelu zaangażowania uczestników.","Survey":"Ankieta","Updating Survey...":"Aktualizowanie ankiety...","Closing":"Zamykanie","Goldcast needs access to your camera and microphone":"Goldcast wymaga dostępu do kamery i mikrofonu","Goldcast needs access to your microphone":"Goldcast wymaga dostępu do mikrofonu","Goldcast needs access to your camera":"Goldcast wymaga dostępu do kamery","SPEAKERS":"Prelegenci","Mark as Unanswered":"Oznacz jako bez odpowiedzi","Mark as Answered":"Oznacz jako z odpowiedzią","Remove from Priority":"Zmniejsz priorytet","Mark as Priority":"Oznacz jako priorytetowe","Answer":"Odpowiedz","Enter answer...":"Wpisz odpowiedź...","Answered by":"Odpowiedź od","Submit Answer":"Prześlij odpowiedź","Test your system’s speaker":"Przetestuj głośnik systemowy","Click \\"Yes\\" if you hear the sound.":"Kliknij „Tak”, jeśli słyszysz dźwięk.","Load previous":"Wczytaj poprzednie","Hide Name":"Ukryj nazwę","Text Q&A is disabled in On Demand mode.":"Tekstowe pytania i odpowiedzi są wyłączone w trybie Na żądanie.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"Osiągnięto limit tekstowych pytań i odpowiedzi. Uczestnicy nie będą mogli zadawać nowych pytań.","Sent to Q&A":"Wysłane do pytań i odpowiedzi","Couldn\'t post as Q&A. Please try again.":"Nie można opublikować jako pytania i odpowiedzi. Spróbuj ponownie.","Yes this is being recorded":"Tak, to jest nagrywane","No this is not being recorded":"Nie, to nie jest nagrywane","System\'s Speaker Check":"Test głośników systemowych","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"Aby mieć pewność, że usłyszysz wszystko podczas wydarzenia, sprawdź, czy głośniki systemowe działają prawidłowo","Click on “Test your system’s speaker” to proceed":"Kliknij „Przetestuj głośnik systemowy”, aby kontynuować","Error while sharing message to screen. Post not found":"Wystąpił błąd podczas udostępniania wiadomości na ekranie. Wpis nie został znaleziony.","Lost connection to servers. Refresh your page to get live event experience.":"Utracono połączenie z serwerami. Odśwież stronę, aby zobaczyć wydarzenia na żywo.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"Sieć VPN / zapora sieciowa zakłóca proces uwierzytelniania. Zmień sieć lub skontaktuj się z zespołem IT, aby umożliwić <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>tym domenom</a> bezproblemowy dostęp do Goldcast.","It\'s taking too long":"To trwa zbyt długo","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"Wygląda na to, że łączysz się przez sieć VPN lub masz włączoną zaporę sieciową. Aby platforma Goldcast działała bez problemów, zapoznaj się z tym <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>dokumentem pomocy</a> i umieść wymagane domeny na białej liście lub zmień sieć.","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"Wygląda na to, że łączysz się przez sieć VPN lub masz włączoną zaporę sieciową. Aby platforma Goldcast działała bez problemów, zapoznaj się z tym <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>dokumentem pomocy</a> i umieść wymagane domeny na białej liście albo zmień sieć lub zobacz sesję poświęconą trybowi uproszczonemu.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"Usługa strumieniowej transmisji wideo Goldcast nie może nawiązać połączenia z powodu niskiej przepustowości sieci. Zmień sieć, aby połączyć się z usługą na żywo.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"Usługa strumieniowej transmisji wideo Goldcast nie może nawiązać połączenia z powodu niskiej przepustowości sieci. Aby połączyć się z usługą strumieniowania na żywo, zmień tryb na uproszczony lub zmień sieć.","Most Upvotes":"Najwięcej głosów","Most Recent":"Najnowsze","My Questions":"Moje pytania","Prioritized":"Priorytetowe","Approved":"Zatwierdzone","Unapproved":"Niezatwierdzone","Unanswered":"Bez odpowiedzi","Failed to update answer. Please try again!":"Nie udało się zaktualizować odpowiedzi. Spróbuj ponownie!","Failed to post answer. Please try again!":"Nie udało się opublikować odpowiedzi. Spróbuj ponownie!","Failed to delete question. Please try again!":"Nie udało się usunąć pytania. Spróbuj ponownie!","Survey Link":"Łącze do ankiety","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"Przełączenie spowoduje ponowne wczytanie bieżącej strony do widoku uczestnika. Aby wrócić do widoku organizatora, wyłącz widok uczestnika na liście rozwijanej profilu.","You haven\'t asked any questions yet":"Nie masz jeszcze żadnych pytań","No prioritized questions":"Brak pytań priorytetowych","Create prioritized list of questions for speakers by marking questions as priority":"Skompiluj listę najważniejszych pytań do prelegentów, oznaczając je jako priorytetowe.","No Approved Questions":"Brak zatwierdzonych pytań","Approve incoming questions to see list of approved questions":"Zatwierdź przychodzące pytania, aby zobaczyć listę zatwierdzonych pytań","No Unapproved Questions":"Brak niezatwierdzonych pytań","No Answered Questions":"Brak pytań z odpowiedziami","Answer a question on stage or with inline text":"Odpowiedz na pytanie na scenie lub tekstowo","All questions are answered":"Udzielono odpowiedzi na wszystkie pytania","Rate Your Experience":"Oceń swoje wrażenia","How satisfied are you with Goldcast?":"Jak bardzo podoba Ci się Goldcast?","What are the main reasons for your rating?":"Jakie są główne powody Twojej oceny?","I am interested in seeing a demo of Goldcast":"Chcę zobaczyć wersję demonstracyjną Goldcast","Thank You":"Dziękuję","Your feedback was successfully submitted.":"Twoja opinia została pomyślnie przesłana.","Tell us how we can improve...":"Powiedz nam, jak możemy się poprawić...","1 Slide":"1 slajd","Your internet connection is unstable.":"Twoje połączenie internetowe jest niestabilne.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"Wygląda na to, że mówisz przy wyciszonym mikrofonie. Kliknij ikonę mikrofonu, aby anulować wyciszenie.","The registration could not be completed! Please check that this email is allowed to register for the event.":"Nie udało się dokończyć rejestracji! Sprawdź, czy ten adres e-mail umożliwia zarejestrowanie się na wydarzenie.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Wygląda na to, że jesteś już zarejestrowany(-a) na to wydarzenie! Jeśli nie masz jeszcze potwierdzenia rejestracji, sprawdź folder ze spamem. Jeśli potrzebujesz dalszej pomocy, skontaktuj się z organizatorem wydarzenia.","Your registration could not be completed. This event has reached its registration capacity.":"Nie udało się dokończyć Twojej rejestracji. Osiągnięto limit rejestracji na to wydarzenie.","Image cannot be an svg":"Obraz nie może być plikiem SVG","This should be a valid linkedin url":"Powinien to być prawidłowy adres URL w serwisie Linkedin","This should be a valid twitter url":"Powinien to być prawidłowy adres URL w serwisie Twitter","This should be a valid url":"Powinien to być prawidłowy adres URL","Video":"Obraz","Read Less":"Czytaj mniej","live":"na żywo","Opened":"Otwarto","In person only":"Tylko osobiście","Stage Stream":"Strumień danych ze sceny","Streaming not available":"Przesyłanie strumieniowe niedostępne","Close TV":"Zamknij TV","Streaming is not available for prerecorded and RTMP sessions":"Przesyłanie strumieniowe nie jest dostępne dla wstępnie nagranych sesji i sesji RTMP","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Podłącz komputer do ekranu telewizora lub projektora, aby umożliwić uczestnikom na miejscu oglądanie tego, co dzieje się na Twojej wirtualnej scenie, między innymi slajdów, pytań i odpowiedzi itp. Po podłączeniu kliknij OTWÓRZ TV i przeciągnij lub udostępnij nowe okno na ekranie telewizora lub projektora. ","Close Setup Mode":"Zamknij tryb konfiguracji","Help":"Pomoc","upcoming":"nadchodzące","ended":"zakończono","Remove from favorites":"Usuń z ulubionych","Add to favorites":"Dodaj do ulubionych","PLAY RECORDING":"ODTWÓRZ NAGRANIE","VIEW RECORDING":"ZOBACZ NAGRANIE","VIEW RECORDINGS":"PRZEGLĄDAJ NAGRANIA","Virtual Backgrounds":"Wirtualne tła","No Device Available":"Brak dostępnego urządzenia","Needs permission":"Wymaga uprawnienia dostępu","Device not detected":"Urządzenie nie zostało wykryte","Camera is on":"Kamera jest włączona","Camera is off":"Kamera jest wyłączona","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"Lustrzany obraz nie jest odbity lustrzany, gdy oglądają go widzowie. Widzowie zawsze widzą obraz bez odbicia lustrzanego.","Mirror My Video":"Odbij lustrzanie mój obraz","Camera":"Kamera","1. Click on Safari > Settings for this\\n            website":"1. Kliknij Safari > Ustawienia tej\\n            witryny.","1. Click the lock":"1. Kliknij ikonę","icon in your browser’s address bar":"kłódki na pasku adresu przeglądarki.","3. Unmute":"3. Wyłącz wyciszenie","and":"oraz","icons from stage control panel":"ikony z panelu sterowania sceną","icon from stage control panel":"ikona z panelu sterowania sceną","2. Set camera and microphone to “Allow”.":"2. Ustaw dla kamery i mikrofonu opcję „Zezwól”.","2. Set camera to “Allow”.":"2. Ustaw dla kamery opcję „Zezwól”.","2. Set microphone to \\"Allow\\"":"2. Ustaw dla mikrofonu opcję „Zezwól”.","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. Wybierz opcję „Zawsze zezwalaj Goldcast na dostęp do kamery i mikrofonu”.","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. Wybierz opcję „Zawsze zezwalaj Goldcast na dostęp do kamery”.","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. Wybierz opcję „Zawsze zezwalaj Goldcast na dostęp do mikrofonu”.","Questions?":"Pytania?","If you’re having issues, check out our comprehensive":"Jeśli masz problemy, sprawdź nasze kompleksowe","help docs":"dokumenty pomocy","Speaker is on":"Głośnik jest włączony","Stop Test":"Zatrzymaj test","Test your system’s audio":"Przetestuj dźwięk systemu","Still can\'t hear any sound?":"Nadal nie słyszysz żadnego dźwięku?","Microphone":"Mikrofon","Audio is being played in system\'s default audio device.":"Dźwięk jest odtwarzany w domyślnym systemowym urządzeniu audio.","Click to view/change audio device":"Kliknij, aby wyświetlić/zmienić urządzenie audio","Speaker":"Głośnik","Play Recording":"Odtwórz nagranie","Recording for this broadcast is currently being processed and will be available soon":"Nagranie tej transmisji jest obecnie przetwarzane i będzie wkrótce dostępne","You haven\'t favorited anything yet!":"Nie masz jeszcze żadnych ulubionych elementów!","Add an item to favorites by selecting the ♡ in the top right corner.":"Dodaj element do ulubionych, wybierając ikonę ♡ w prawym górnym rogu.","Session has ended":"Sesja została zakończona","System Check":"Test systemu","Need help? Check out the":"Potrzebujesz pomocy? Sprawdź","Skip Checks and Continue":"Pomiń testy i kontynuuj","Click the button above to run the test":"Kliknij przycisk powyżej, aby uruchomić test","Test Screenshare":"Przetestuj udostępnianie ekranu","Share message to stage":"Udostępnij wiadomość na scenie","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"Poniżej wpisz tekst, którego chcesz użyć na pasku tekstowym. Aby zamienić pasek w hiperłącze, wprowadź adres URL.","Ticker":"Pasek informacyjny","Coffee Break! Be back in 10m.":"Przerwa na kawę! Wracam za 10 minut.","Enter Message":"Wprowadź wiadomość","https://www.xyz.com":"https://www.xyz.com","Launch":"Uruchom","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Dziękujemy za przesłanie pytań. Przesłanie kolejnych będzie możliwe, gdy jedno z Twoich obecnych pytanie zostanie zatwierdzone.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"Niestety funkcja pytań i odpowiedzi jest chwilowo wyłączona. Przesłanie kolejnych pytań będzie możliwe po ponownym włączeniu funkcji pytań i odpowiedzi.","Votes":"Głosy","Vote":"Głosuj","is inviting you to a video call":"zaprasza Cię na rozmowę wideo","ENTER ROOM":"WEJDŹ DO POKOJU","Start the conversation!":"Rozpocznij rozmowę!","Couldn\'t send message. Click here to retry.":"Nie udało się wysłać wiadomości. Kliknij tutaj, aby spróbować ponownie.","Couldn\'t add emoji. Please try again.":"Nie można dodać emotikonu. Spróbuj ponownie.","Couldn\'t remove emoji. Please try again.":"Nie udało się usunąć emotikonów. Spróbuj ponownie.","Couldn\'t delete message. Please try again.":"Nie można usunąć wiadomości. Spróbuj ponownie.","Couldn\'t pin message. Please try again.":"Nie udało się przypiąć wiadomości. Spróbuj ponownie.","Couldn\'t unpin message. Please try again.":"Nie udało się odpiąć wiadomości. Spróbuj ponownie.","Today":"Dzisiaj","No messages yet":"Brak wiadomości","Messages from organizers and speakers appear here!":"Tutaj pojawiają się wiadomości od organizatorów i prelegentów!","Next Session is Starting":"Rozpoczyna się następna sesja","Go to Next Session":"Przejdź do następnej sesji","I’d like to stay":"Wolę zostać","My favorites":"Moje ulubione","1. Click on the lock icon in your address bar":"1. Kliknij ikonę kłódki na pasku adresu","We recommend organizers and speakers use a desktop\\n        device":"Zalecamy organizatorom i prelegentom korzystanie z urządzenia\\n        stacjonarnego","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"Aby zapewnić najlepsze wrażenia uczestnikom, prelegenci i organizatorzy\\npowinni korzystać z Goldcast na komputerze stacjonarnym. Transmisja z urządzenia mobilnego spowoduje\\npogorszenie jakości.","Watch Now":"Obejrzyj teraz","Video progress time":"Czas postępu filmu","Total video duration":"Całkowity czas trwania filmu","Rate Goldcast!":"Oceń Goldcast!","Running Required Checks...":"Przeprowadzanie wymaganych kontroli...","Test Your Setup":"Przetestuj konfigurację","Test your Computer Device, Microphone and Camera before you join the event":"Przed dołączeniem do wydarzenia przetestuj komputer, mikrofon i kamerę","Speaker and microphone not working?":"Głośnik i mikrofon nie działają?","Passed":"Powodzenie","Fix Audio Issues":"Napraw problemy z dźwiękiem","Check if audio is being played in other sound devices connected to phone/tablet":"Sprawdź, czy dźwięk jest odtwarzany przez inne urządzenia dźwiękowe podłączone do telefonu/tabletu.","Check if correct audio device is chosen from the below dropdown":"Sprawdź, czy z poniższej listy rozwijanej wybrano prawidłowe urządzenie audio","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>Kliknij tutaj</a>, aby sprawdzić, czy wybrano prawidłowe urządzenie audio do odtwarzania dźwięku.","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Kliknij tutaj</a>, aby sprawdzić, czy wybrano prawidłowe urządzenie audio do odtwarzania dźwięku.","Right click on the browser tab & click “Unmute Site”":"Kliknij prawym przyciskiem myszy kartę przeglądarki, a potem kliknij „Wyłącz wyciszenie witryny”.","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Sprawdź, czy karta przeglądarki nie jest wyciszona lub kliknij Okno > Wyłącz wyciszenie tej karty","System Check Failed!":"Sprawdzanie systemu nie powiodło się!","System Check Passed!":"Kontrola systemu zakończona pomyślnie!","Complete checks to proceed":"Przeprowadź testy, aby kontynuować","Enter Event":"Dołącz do wydarzenia","Skip Screen Sharing Check? ":"Pominąć sprawdzanie udostępniania ekranu? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"Zalecamy dokończenie testu udostępniania ekranu, jeśli Twój ekran ma być prezentowany podczas wydarzenia","Ignore & Enter Event":"Zignoruj i przejdź do wydarzenia","Test screenshare":"Przetestuj udostępnianie ekranu","Retry Now":"Spróbuj ponownie teraz","SHARE":"UDOSTĘPNIJ","Rooms Closed":"Pokoje zamknięte","Discussion rooms are now closed. You are being redirected to the Stage.":"Pokoje dyskusyjne są teraz zamknięte. Przekierujemy Cię na scenę.","Return To Stage":"Powrót na scenę","Unrecognized embedded widget provider - ":"Nierozpoznany dostawca osadzonego widżetu – ","Room Ended":"Pokój zamknięty","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"Organizator wydarzenia zamknął wszystkie pokoje. Przekierujemy Cię teraz na scenę wydarzenia.","Video Q&A Request Cancelled":"Prośba o sesję wideo pytań i odpowiedzi została anulowana","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Prośba o sesję wideo pytań i odpowiedzi została anulowana, ponieważ oglądasz wydarzenie w trybie uproszczonym. Przełącz na tryb na żywo, aby ponownie podnieść rękę.","Camera Passed":"Test kamery zaliczony","Camera Error":"Błąd kamery","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"Przeglądarka nie ma przypisanych uprawnień dostępu do kamery. Kliknij „Zezwól na dostęp do kamery”.","Camera permissions aren’t granted from system. Click “Allow Camera”":"System nie ma przypisanych uprawnień dostępu do kamery. Kliknij „Zezwól na dostęp do kamery”.","Uh-oh! Error occurred while creating camera stream":"Niestety podczas tworzenia strumienia danych z kamery wystąpił błąd.","Close other applications which might use camera stream":"Zamknij inne aplikacje, które mogą używać strumienia danych z kamery.","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>Kliknij tutaj</a>, aby sprawdzić, czy przeglądarka ma dostęp do kamery.","Microphone Passed":"Test mikrofonu zaliczony","Microphone Error":"Błąd mikrofonu","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"Przeglądarka nie ma przypisanych uprawnień dostępu do mikrofonu. Kliknij „Zezwól na dostęp do mikrofonu”.","Mic permissions aren’t granted from system. Click “Allow Microphone”":"System nie ma przypisanych uprawnień dostępu do mikrofonu. Kliknij „Zezwól na dostęp do mikrofonu”.","Uh-oh! Error occurred while creating mic stream":"Niestety podczas tworzenia strumienia danych z mikrofonu wystąpił błąd.","Close other applications which might use mic stream":"Zamknij inne aplikacje, które mogą używać strumienia danych z mikrofonu.","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>Kliknij tutaj</a>, aby sprawdzić, czy przeglądarka ma dostęp do mikrofonu.","Speaker and Microphone Error":"Błąd głośnika i mikrofonu","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"Aby wyświetlić listę głośników podłączonych do systemu, musisz przyznać uprawnienia dostępu do mikrofonu. Kliknij „Zezwól na dostęp do mikrofonu”.","It seems mic is being used by other application. Close other applications to proceed.":"Wygląda na to, że mikrofon jest używany przez inną aplikację. Zamknij inne aplikacje, aby kontynuować.","Camera & Microphone Error":"Błąd kamery i mikrofonu","To enable permissions, click the Allow Camera & Mic button below":"Aby włączyć uprawnienia, kliknij poniższy przycisk Zezwól na dostęp do kamery i mikrofonu.","Network Connection":"Połączenie sieciowe","Check Passed":"Test zaliczony","Could not establish a network connection":"Nie można ustanowić połączenia sieciowego","Connect to a different network, or use a mobile hotspot.":"Połącz się z inną siecią lub skorzystaj z mobilnego punktu dostępu.","Disable any VPN or firewall is connected.":"Wyłącz sieć VPN lub zaporę sieciową, jeśli jest włączona.","Connection: Good":"Połączenie: dobre","Network Connection Error":"Błąd połączenia sieciowego","Can’t connect to network. Change your network or limited functionality will be available during event.":"Nie można połączyć z siecią. Zmień sieć. Jeśli tego nie zrobisz, podczas wydarzenia niektóre funkcje nie będą dostępne.","AdBlocker":"Program blokujący reklamy","AdBlocker not detected.":"Nie wykryto wtyczki AdBlocker.","AdBlocker detected. This may degrade your event experience.":"Wykryto program blokujący reklamy. Może to pogorszyć odbiór wydarzenia.","Disable adblocker for best experience.":"Wyłącz program blokujący reklamy, aby uzyskać najlepsze wrażenia.","You are using ":"Używasz ","Use Windows or Mac OS for best performance":"Aby uzyskać najlepszą wydajność, korzystaj z systemu Windows lub Mac OS","Browser Check":"Test przeglądarki","Check Passed.":"Test zaliczony.","Switch To Lite Mode":"Przełącz na tryb uproszczony","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Po przejściu do trybu uproszczonego Twoja oczekująca prośba o sesję wideo pytań i odpowiedzi zostanie anulowana","Stay on Live Mode":"Pozostań w trybie na żywo","Unable to mark as favorite":"Nie można oznaczyć jako ulubione","Event organizers must enter the event to select favorites.":"Organizatorzy wydarzeń muszą dołączyć do wydarzenia, aby wybrać ulubione elementy.","Make an Announcement":"Dodaj ogłoszenie","STOP":"ZATRZYMAJ","InPerson CheckIn App":"Aplikacja InPerson CheckIn","App to Check-In In-Person attendees":"Aplikacja do meldowania uczestników zjawiających się osobiście","SEE AGENDA":"ZOBACZ PLAN DNIA","Please visit the Agenda tab to view the session recordings":"Przejdź na kartę Plan dnia, aby wyświetlić nagrania sesji","The session recordings will be available soon in the Agenda tab":"Nagrania z sesji będą dostępne wkrótce na karcie Plan dnia","FAILED!":"BŁĄD!","Next session is beginning":"Rozpoczyna się następna sesja","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"Czy chcesz przejść do następnej sesji? Transmisja będzie kontynuowana, a na telewizorze pojawi się nowa sesja.","Banners":"Banery","Images":"Obrazy","Screen Share":"Udostępnianie ekranu","Browser might not have screen-recording permission on your computer.":"Przeglądarka może nie mieć przyznanych uprawnień do nagrywania ekranu na komputerze.","Open System Preferences":"Otwórz preferencje systemowe","Error publishing screen because someone else started screen share already.":"Wystąpił błąd publikowania ekranu, ponieważ inna osoba rozpoczęła już udostępnianie ekranu.","Live Feed":"Transmisja na żywo","Check Your Network":"Sprawdź sieć","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"Wykryliśmy błąd podczas odtwarzania filmu! Jeśli masz problemy z odtwarzaniem filmu, spróbuj odświeżyć stronę lub przejdź do trybu uproszczonego.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"Wykryliśmy błąd podczas odtwarzania filmu! Jeśli masz problemy z odtwarzaniem filmu, spróbuj odświeżyć stronę.","All Dates":"Wszystkie daty","All Tracks":"Wszystkie ścieżki","Create Ticker":"Utwórz pasek informacyjny","Booths Closed":"Stoiska zamknięte","Your event organizer has closed all the booths. You will now be redirected to the stage":"Organizator wydarzenia zamknął wszystkie stoiska. Przekierujemy Cię teraz na scenę.","Visit the Polls tab to view live results.":"Odwiedź kartę Sondaże, aby wyświetlić wyniki na żywo.","A new poll is open! Visit the Polls tab to vote.":"Otwarto nowy sondaż! Przejdź na kartę Sondaże, aby zagłosować.","Vote for Polls":"Głosuj w sondażach","Go to Polls Tab":"Przejdź na kartę Sondaże","Microphone audio too low":"Zbyt niski poziom dźwięku mikrofonu","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"Wykryliśmy problem z dźwiękiem. Jeśli problem nie ustąpi, zalecamy wyciszenie/wyłączenie wyciszenia lub użycie innego urządzenia.","Audio/Video bitrate too low":"Zbyt niska szybkość transmisji dźwięku/obrazu","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"Ustawienia zapory sieciowej blokują strumienie A/V. Zalecamy przełączenie połączenia sieciowego na inne.","Error sharing screen":"Błąd udostępniania ekranu","A network error occurred while sharing screen. Please check your network connection.":"Podczas udostępniania ekranu wystąpił błąd sieci. Sprawdź połączenie sieciowe.","Apologies, due to some errors, we need to refresh the page!":"Niestety musimy odświeżyć stronę z powodu błędu!","Warning":"Ostrzeżenie","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"Wykryliśmy problem z obrazem wideo. Zalecamy zamknięcie innych kart przeglądarki lub innych aplikacji uruchomionych na Twoim urządzeniu i sprawdzenie/ulepszenie połączenia internetowego w celu rozwiązania tego problemu.","No results found":"Nie znaleziono wyników","Audio":"Dźwięk","Please choose another microphone and camera":"Wybierz inny mikrofon i kamerę","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"Obecnie wybrany mikrofon i wybrana kamera nie działają. Wybierz inny mikrofon i inną kamerę z poniższej listy rozwijanej.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"Obecnie wybrana kamera nie działa. Wybierz inną kamerę z poniższej listy rozwijanej.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"Możesz kontynuować bez kamery, ale zalecamy rozwiązanie konfliktu, gdyż zapewni to płynną transmisję.","Please choose another microphone":"Wybierz inny mikrofon","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"Obecnie wybrany mikrofon nie działa. Wybierz inny mikrofon z poniższej listy rozwijanej.","Please check that your TV speaker is correct":"Sprawdź, czy głośnik telewizora jest prawidłowy","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"Obecnie wybrany głośnik nie działa. Wybierz inny głośnik z poniższej listy rozwijanej.","Your answer":"Twoja odpowiedź","Edit":"Edytuj","Delete":"Usuń","Settings":"Ustawienia","Signing Out":"Wylogowywanie","Confirming your account...":"Potwierdzanie Twojego konta...","Something Went Wrong. Please Retry :(":"Wystąpił błąd. Spróbuj ponownie :(","Resending Mail":"Ponowne wysyłanie poczty","offline":"offline","I am inviting you to a video meeting:":"Zapraszam cię na spotkanie wideo:","Resending secure login link to your email":"Trwa ponowne wysyłanie bezpiecznego łącza logowania na Twój adres e-mail","Sending secure login link to your email":"Trwa wysyłanie bezpiecznego łącza logowania na Twój adres e-mail","Something went Wrong. Please Retry :(":"Wystąpił błąd. Spróbuj ponownie :(","Updating your password":"Trwa aktualizowanie hasła","Sending mail":"Wysyłanie poczty","Verifying":"Weryfikowanie","This might be slower than usual":"Może to trwać dłużej niż zwykle","Checking":"Sprawdzanie","New results available! Refresh!":"Nowe wyniki już dostępne! Odśwież!","Saving":"Zapisywanie","Turn off Attendee mode":"Wyłącz tryb uczestnika","See Attendee View":"Zobacz widok uczestnika","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Łączna liczba uczestników oglądających obecnie tę sesję. Uwaga: Te dane są widoczne tylko dla organizatora.","Session Count":"Liczba sesji","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"Liczba uczestników oglądających obecnie sesje na żywo. Uwaga: Te dane są widoczne tylko dla organizatora.","Role":"Rola","Total Attendees":"Łączna liczba uczestników","Total number of attendees online at this time Note: This is for organizer eyes only":"Całkowita liczba uczestników online w tej chwili. Uwaga: Te dane są widoczne tylko dla organizatora.","My Profile":"Mój profil","Languages":"Języki","Filling out your profile can help you connect with people with similar interests.":"Wypełnienie profilu może pomóc Ci nawiązać kontakt z osobami o podobnych zainteresowaniach.","type to search for your address":"wpisz, aby wyszukać adres","Could not open direct call":"Nie można otworzyć bezpośredniego połączenia","Chat messages can only be published from inside a broadcast.":"Wiadomości czatu mogą być publikowane tylko w ramach transmisji.","Stage Logo can only be published from inside a broadcast.":"Logo sceniczne może być publikowane wyłącznie w ramach transmisji.","Loading Speakers":"Wczytywanie głośników","Raise hand is disabled for organizer accounts, but active for attendee accounts":"Podniesienie ręki jest wyłączone w przypadku kont organizatorów, ale jest aktywne na kontach uczestników","Disabled in lite mode, return to live if you’d like to raise hand!":"Wyłączone w trybie uproszczonym. Wróć do trybu na żywo, jeśli chcesz podnieść rękę!","Raise hand to enter stage for video q&a":"Podnieś rękę, aby wejść na scenę i wziąć udział w sesji wideo pytań i odpowiedzi","Speakers":"Prelegenci","Hosting organization: {organization}":"Organizator: {organization}","Failed to switch {deviceTag}":"{deviceTag} – nie udało się przełączyć","Make sure your {deviceTag} is not being used by any other application and is working properly.":"{deviceTag} – upewnij się, że to urządzenie nie jest używane przez żadną inną aplikację i działa prawidłowo.","Facing issues with audio or video? Switch on lite mode":"Masz problemy z dźwiękiem lub obrazem? Włącz tryb uproszczony.","Failed to get event for eventID: {eventID}":"Nie można pobrać zdarzenia odpowiadającego ID zdarzenia: {eventID}","Error while playing video.":"Błąd podczas odtwarzania obrazu wideo.","Speakers only, attendees can\'t see this chat":"Tylko prelegenci; uczestnicy nie widzą tego czatu","Kudo":"Kudo","Room":"Pokój","Session":"Sesja","Booth":"Stoisko","Public":"Publiczny","Drift":"Drift","Slides":"Slajdy","Videos":"Filmy","Chat":"Czat","Messages":"Wiadomości","Poll":"Sondaż","Docs":"Dokumenty","Q&A":"Pytania i odpowiedzi","Media":"Media","Messages Chat":"Czat wiadomości","Leaderboard":"Tablica wyników","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Uwaga: jesteś także prelegentem tego wydarzenia. Zawsze możesz wejść za kulisy i wkroczyć na scenę.","Switch to Attendee View":"Przełącz do widoku uczestnika","Return to Organizer View":"Wróć do widoku organizatora","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"Wyłączenie widoku uczestnika spowoduje ponowne wczytanie bieżącej strony i powrót do widoku organizatora. Czy chcesz kontynuować?","Switch":"Przełącz","Request Sent":"Wysłano żądanie","Your request for a demo has been submitted":"Twoja prośba o wersję demonstracyjną została przesłana","Organizer Redirection":"Przekierowanie organizatora","YES, REDIRECT":"YES, PRZEKIERUJ","DISMISS":"ODRZUĆ","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"Uczestnicy są przekierowywani do następnej sesji: {title}. Czy przekierować Cię do następnej sesji?","Stage":"Scena","Rooms":"Pokoje","Join a round table to discuss moderated topics with your fellow attendees":"Dołącz do dyskusji przy okrągłym stole, aby omówić moderowane tematy z innymi uczestnikami","Booths":"Stoiska","Join a booth to know more about a sponsor":"Dołącz do stoiska, aby dowiedzieć się więcej o sponsorze","You are in the booth":"Jesteś na stoisku","People":"Osoby","Connect with your fellow attendees":"Połącz się z innymi uczestnikami","Connect with speakers":"Połącz się z prelegentami","starting in {duration}":"zaczyna się za {duration}","You will be redirected to booths in {duration}":"Przekierujemy Cię na stoisko za {duration}","booths":"stoiska","agenda":"plan","You will be redirected to {word} in {duration}":"Nastąpi przekierowanie do sesji {word} za {duration}","You will be redirected to the live stage in {duration}":"Nastąpi przekierowanie do sceny na żywo za {duration}","- You are about to be redirected to {tabTitle} in {duration}":"- Nastąpi przekierowanie do karty {tabTitle} za {duration}","See Agenda":"Zobacz plan dnia","Break":"Przerwa","{title} is now live":"{title} – teraz na żywo","Apologies, due to an error we need to refresh the page!":"Niestety musimy odświeżyć stronę z powodu błędu!","Network interruption detected":"Wykryto przerwę w działaniu sieci","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"Występują pewne problemy z połączeniem internetowym. Jeśli korzystasz z sieci VPN, rozważ jej wyłączenie. Ewentualnie spróbuj połączyć się z inną siecią.","No audio output device detected":"Nie wykryto wyjściowego urządzenia audio","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Jeśli napotkasz jakiekolwiek problemy, podłącz głośniki/słuchawki i użyj ikony koła zębatego, aby je przetestować.","Please disable ad blocker for this page":"Wyłącz blokowanie reklam na tej stronie","Yes, I understand":"Tak, rozumiem","No event user found so attended not marked!":"Nie znaleziono użytkownika wydarzenia, więc uczestniczył jako nieoznaczony!","Wait while the speaker approves your video q&a request":"Poczekaj, aż prelegent zatwierdzi Twoją prośbę sesję wideo pytań i odpowiedzi","Organizer":"Organizator","UPNEXT":"Następnie","Ended":"Zakończono","Hide":"Ukryj","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"Ta strona automatycznie przekieruje cię za {durationLeftToRedirect} s.","Register":"Zarejestruj się","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Błąd: Użytkownik nie może zarejestrować się na to wydarzenie. Skontaktuj się z organizatorem wydarzenia w celu uzyskania pomocy.","You are already registered!":"Już Cię zarejestrowaliśmy!","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Wygląda na to, że jesteś już zarejestrowany(-a) na to wydarzenie! Jeśli nie masz jeszcze potwierdzenia rejestracji, sprawdź folder ze spamem. Jeśli potrzebujesz dalszej pomocy, skontaktuj się z organizatorem wydarzenia.","Thank you for registering!":"Dziękujemy za rejestrację!","Submit another response":"Prześlij kolejną odpowiedź","Share":"Udostępnij","Know someone who want to attend this?":"Znasz kogoś, kto chciałby wziąć w tym udział?","COPY LINK":"SKOPIUJ ŁĄCZE","Powered by":"Obsługiwane przez","VIEW PROFILE":"ZOBACZ PROFIL","You can access the event landing here":"Możesz uzyskać dostęp do strony docelowej wydarzenia tutaj","Need Help?":"Potrzebujesz pomocy?","Welcome back":"Witaj z powrotem","Checking...":"Sprawdzanie...","Close":"Zamknij","Enter":"Dołącz","See {roomCount} Room(s)":"Zobacz pokoje: {roomCount}","Back":"Wstecz","Request a Demo":"Poproś o wersję demonstracyjną","Loading":"Wczytywanie","Thread":"Wątek","Load more":"Wczytaj więcej","Heads up!":"Uwaga!","YES":"TAK","No":"Nie","Following":"Obserwowanie","Error in loading drimify":"Błąd podczas wczytywania Drimify","You\'re not registered for this event":"Nie jesteś zarejestrowany(-a) na to wydarzenie","Check out other events":"Sprawdź inne wydarzenia","Date":"Data","Location":"Lokalizacja","How are you attending the event":"W jaki sposób weźmiesz udział w wydarzeniu?","In Person":"Osobiście","Virtually":"Wirtualnie","Event Widgets":"Widżety zdarzeń","Chat • Messages • Q&A • Poll • Docs":"Czat • Wiadomości • Pytania i odpowiedzi • Sondaż • Dokumenty","DISCUSSION":"DYSKUSJA","JOIN":"DOŁĄCZ","WAIT":"CZEKAJ","more":"więcej","See Profile":"Zobacz profil","Filter":"Filtr","Video player not supported by your browser":"Odtwarzacz wideo nie jest obsługiwany przez używaną przeglądarkę","We recommend using the latest version of Google Chrome to access your conference":"Zalecamy, aby uruchamiać konferencje w najnowszej wersji przeglądarki Google Chrome","ANSWER":"ODPOWIEDZ","REJECT":"ODRZUĆ","Don’t ask me this next time":"Nie pytaj mnie o to następnym razem","Cancel":"Anuluj","Lite Mode":"Tryb uproszczony","On":"Wł.","Connection Issues? Turn on Lite Mode":"Masz problemy z połączeniem? Włącz tryb uproszczony.","Turn On Lite Mode":"Włącz tryb uproszczony","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"Tryb uproszczony wprowadzi 30-sekundowe opóźnienie między transmisją na żywo a tym, co widać na ekranie. Czy chcesz kontynuować?","Turn On":"Włącz","Lite Mode Active!":"Tryb uproszczony jest aktywny!","Thanks for your patience, lite mode now on!":"Dziękujemy za cierpliwość. Tryb uproszczony jest już włączony!","Turn off Lite Mode?":"Wyłączyć tryb uproszczony?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Trwa wyłączanie trybu uproszczonego w celu powrotu do oglądania transmisji na żywo. Uwaga: spowoduje to 30-sekundową przerwę, gdyż musimy nadrobić zaległości.","Lite Mode Off!":"Tryb uproszczony wyłączony!","Thanks for your patience, we’ve returned to the live broadcast!":"Dziękujemy za cierpliwość. Wróciliśmy do transmisji na żywo!","Lite Mode Unavailable":"Tryb uproszczony niedostępny","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Przepraszamy za niedogodności. Tryb uproszczony jest obecnie niedostępny. Przełącz się na transmisję na żywo, aby wznowić sesję.","Turn off Lite mode?":"Wyłączyć tryb uproszczony?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"Wykryliśmy, że połączenie wróciło do normy. Czy chcesz wrócić do transmisji na żywo? Uwaga: spowoduje to 30-sekundową przerwę, gdyż musimy nadrobić zaległości.","Turn Off":"Wyłącz","Lite mode is disabled for organizer accounts, but active for attendee accounts":"Tryb uproszczony jest wyłączony w przypadku kont organizatorów, ale aktywny na kontach uczestników.","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"Tryb uproszczony nie jest obsługiwany w używanej przeglądarce. Zalecamy korzystanie z najnowszej wersji przeglądarki Google Chrome.","Lite mode is not curently available. We’ll let you know once it’s available again":"Tryb uproszczony jest obecnie niedostępny. Powiadomimy Cię, gdy będzie ponownie dostępny.","Turn off Lite Mode":"Wyłącz tryb uproszczony","We’ll let you know when Lite mode is available again":"Powiadomimy Cię, gdy tryb uproszczony będzie ponownie dostępny","Lite Mode Available":"Tryb uproszczony dostępny","Loading Lite Mode...":"Wczytywanie trybu uproszczonego...","Turning Off Lite Mode":"Wyłączanie trybu uproszczonego","Lite Mode On":"Tryb uproszczony włączony","Audio/Video Issues?":"Masz problemy z dźwiękiem/obrazem?","Error":"Błąd","Click a video to play":"Kliknij film, aby go odtworzyć","Error starting video!":"Błąd podczas uruchamiania filmu!","Please rotate your device to {mode} mode":"Obróć urządzenie do trybu {mode}","landscape":"poziomego","portrait":"pionowego","Thank you for attending this event!":"Dziękujemy za udział w tym wydarzeniu!","Go to Rooms":"Przejdź do pokoi","Please use a desktop or laptop Google Chrome browser to access your conference":"Aby uzyskać dostęp do konferencji, użyj przeglądarki Google Chrome na komputerze stacjonarnym lub laptopie.","If on Desktop":"Jeśli na komputerze stacjonarnym","Please increase the width of your window":"Zwiększ szerokość okna","Alternatively, check out the":"Ewentualnie sprawdź","Youtube Livestream":"Transmisja na żywo na Youtube","Search":"Szukaj","Profile":"Profil","Yes":"Tak","Loading Chat":"Wczytywanie czatu","Please wait while we fetch the chat":"Poczekaj, aż pobierzemy czat","Load old messages":"Wczytaj stare wiadomości","Join the room to see chat":"Dołącz do pokoju, aby zobaczyć czat","Live Chat":"Czat na żywo","Uh..oh we couldn\'t load the content":"Niestety nie mogliśmy wczytać treści","Please reload the page":"Ponownie wczytaj stronę","New comments":"Nowe komentarze","Start the conversation":"Rozpocznij rozmowę","Be the first to add to chat!":"Bądź pierwszą osobą, która napisze na czacie!","Enter your message":"Wpisz wiadomość","Joining chat!":"Dołączasz do czatu!","See all pinned messages":"Zobacz wszystkie przypięte wiadomości","Failed to send! Retry?":"Nie udało się wysłać! Spróbować ponownie?","Search for attendee":"Wyszukaj uczestnika","Up to date":"Aktualne","Start a new conversation, We think you\'ll enjoy":"Rozpocznij nową rozmowę. Na pewno Ci się spodoba.","chatting with these recommended attendees!":"rozmawiaj na czacie z tymi rekomendowanymi uczestnikami!","Searching":"Wyszukiwanie","Load Previous":"Wczytaj poprzedni","Load Next":"Wczytaj następny","Loading Channel":"Wczytywanie kanału","Please wait while we fetch the channel":"Poczekaj, aż pobierzemy kanał","Please wait while we fetch the messages":"Poczekaj, aż pobierzemy wiadomości","Send the first message":"Wyślij pierwszą wiadomość","Join":"Dołącz","link":"łącze","download":"pobierz","Click to open":"Kliknij, aby otworzyć","No open polls":"Brak otwartych sondaży","Check back later to see if a poll opens up!":"Wróć później, aby zobaczyć, czy jest dostępny sondaż!","Loading Poll":"Wczytywanie sondażu","Please wait while we fetch the polls":"Poczekaj, aż pobierzemy sondaże","Uh oh.. we couldn’t load the content":"Niestety nie mogliśmy wczytać treści","Polls":"Sondaże","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"Aby uruchomić sondaż, dodaj pytanie i odpowiedzi do tej sesji w panelu administracyjnym Goldcast.","Stop Sharing":"Zatrzymaj udostępnianie","Can\'t publish polls while something else is being presented on stage":"Nie możesz publikować sondaży, gdy na scenie są prezentowane inne treści.","Open":"Otwórz","Cancel your video q&a request":"Anuluj prośbę o sesję wideo pytań i odpowiedzi","Pending...":"Oczekuje...","Leave Stage":"Opuść scenę","Raise Hand":"Podnieś rękę","Text Q&A":"Tekstowa sesja pytań i odpowiedzi","Video Q&A":"Sesja wideo pytań i odpowiedzi","Loading Q&amp;A":"Wczytywanie pytań i odpowiedzi","Please wait while we fetch the Q&amp;A":"Poczekaj, aż pobierzemy pytania i odpowiedzi","Uh oh.. we couldn\'t load the content":"Niestety nie mogliśmy wczytać treści","No Questions Yet":"Nie ma jeszcze pytań","Tell your audience to send in questions!":"Powiedz swoim odbiorcom, aby przesłali pytania!","Be the first to ask a question!":"Bądź pierwszą osobą, która zada pytanie!","Tell your audience to raise their hand!":"Powiedz odbiorcom, by podnieśli rękę!","Approve":"Zatwierdź","Reject":"Odrzuć","End":"Zakończ","RELOAD":"WCZYTAJ PONOWNIE","Logos On Stage":"Logo na scenie","No File Chosen":"Nie wybrano pliku","loading":"wczytywanie","Can\'t publish a slide when there is something else being presented on stage":"Nie możesz publikować slajdów, gdy na scenie są prezentowane inne treści","Change Deck":"Zmień zestaw slajdów","stop-screen-share":"zatrzymaj udostępnianie ekranu","screen-share":"udostępnianie ekranu","Select a deck to begin presenting":"Wybierz zestaw slajdów, aby rozpocząć prezentację","CONFIRM":"POTWIERDŹ","If you’re having issues, please refer to the":"Jeśli masz problemy, patrz","SPEAKER":"GŁOŚNIK","Issue Testing Audio!":"Problem z testowaniem dźwięku!","VPN and adblockers may cause video issues, please disable them before proceeding":"Klienty VPN i programy blokujące reklamy mogą powodować problemy z obrazem. Wyłącz je przed kontynuowaniem.","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"Uwaga: klienty VPN i programy blokujące reklamy mogą powodować problemy z obrazem, więc dopilnuj, by były one wyłączone podczas transmisji.","Follow":"Obserwuj","Read More":"Czytaj więcej","Ask a question":"Zadaj pytanie","Shared":"Udostępniono","Answered":"Udzielono odpowiedzi","Waiting Approval":"Oczekuje na zatwierdzenie","cancel":"anuluj","ENTER":"DOŁĄCZ","Upcoming Events":"Nadchodzące wydarzenia","Past Events":"Minione wydarzenia","Goldcast":"Goldcast","MANAGE EVENT":"ZARZĄDZAJ WYDARZENIEM","Edit Profile":"Edytuj profil","Stay tuned!":"Bądź na bieżąco!","Sign-in instructions will be available here 12 hours prior to the event":"Instrukcje dotyczące rejestracji będą dostępne tutaj na 12 godzin przed wydarzeniem","Please log out":"Wyloguj się","Logout":"Wyloguj","Continue as {differentUser}":"Kontynuuj jako {differentUser}","You are already logged in as {user}.":"Zalogowaliśmy Cie już jako {user}.","EMAIL":"E-MAIL","user@email.com":"user@email.com","FIRST NAME":"IMIĘ","First Name":"Imię","LAST NAME":"NAZWISKO","Last Name":"Nazwisko","You are not registered to this event":"Nie jesteś zarejestrowany(-a) na to wydarzenie","Please enter your email and name":"Wprowadź swój adres e-mail i imię","Please enter your email":"Wprowadź swój adres e-mail","We have sent a secret code to":"Wysłaliśmy kod do","BACK":"WSTECZ","Didn\'t receive an email? Make sure to check spam list":"Nie dotarła do Ciebie wiadomość e-mail? Sprawdź folder ze spamem.","Resend Mail":"Wyślij ponownie","SECRET CODE":"KOD","Please enter the temporary password sent to your email":"Wprowadź tymczasowe hasło przesłane na Twój adres e-mail","NEW PASSWORD":"NOWE HASŁO","Please enter a new password":"Wprowadź nowe hasło","CONFIRM PASSWORD":"POTWIERDŹ HASŁO","Please re-enter the new password":"Wprowadź ponownie nowe hasło","Password length should be atleast 8":"Minimalna długość hasła to 8 znaków","Password and Confirm Password don\'t match !!":"Hasło i potwierdzenie hasła nie pasują do siebie!","Please enter your password to continue":"Wprowadź hasło, aby kontynuować","Logging you in...":"Logujemy Cię do...","PASSWORD":"HASŁO","Forgot credentials?":"Nie pamiętasz danych uwierzytelniających?","Forgot Password? A mail will be sent to your registered email.":"Nie pamiętasz hasła? Wyślemy wiadomość na zarejestrowany adres e-mail.","Email cannot be blank!!":"Adres e-mail nie może być pusty!!!","We have sent a secure login link to":"Wysłaliśmy bezpieczne łącze logowania na adres","from":"z adresu","Please use that to access your event.":"Użyj go, by uzyskać dostęp do wydarzenia.","Please check spam/promotion too if you can\'t find it.":"Jeśli nie możesz znaleźć wiadomości, sprawdź też folder ze spamem/promocjami.","Thank You !":"Dziękujemy!","The link is not valid.":"Łącze jest nieprawidłowe.","Please be patient.":"Zachowaj cierpliwość.","We are verifying your link.":"Weryfikujemy Twoje łącze.","Thank you for entering the code!":"Dziękujemy za wpisanie kodu!","Please create a new password":"Utwórz nowe hasło","Signing you up...":"Rejestrujemy Cię...","We have sent a temporary password to":"Wysłaliśmy tymczasowe hasło na adres","TEMPORARY PASSWORD":"HASŁO TYMCZASOWE","Please enter the temporary password sent to your mail":"Wprowadź tymczasowe hasło przesłane na Twój adres e-mail","Password Length should be 8":"Minimalna długość hasła to 8 znaków","Okay":"W porządku","Backstage: {title}":"Za kulisami: {title}","Prep Area":"Obszar przygotowawczy","Starting at {time}":"Zaczyna się o {time}","person":"osoba","inside":"w środku","No one is inside":"Nikogo nie ma w środku","This area is for you to sync up with your fellow speakers before you go on stage.":"W tym obszarze możesz komunikować się z innymi prelegentami przed wejściem na scenę.","This area is for you to check your cam and mic before you enter the room.":"Ten obszar umożliwia sprawdzenie kamery i mikrofonu przed wejściem do pokoju.","I\'m Ready":"Jestem gotowy(-a)","Watch Live":"Oglądaj na żywo","Backstage":"Za kulisami","You are sharing your screen":"Udostępniasz swój ekran","LIVE":"NA ŻYWO","Live":"Na żywo","Virtual":"Wirtualnie","Only available for ":"Dostępne tylko dla ","See Booths":"Zobacz stoiska","See Rooms":"Zobacz pokoje","Enter Backstage":"Wejdź za kulisy","This track has no upcoming sessions. Check out a different track.":"Ta ścieżka nie ma nadchodzących sesji. Sprawdź inną ścieżkę.","View":"Wyświetl","Agenda":"Plan dnia","Scroll to see all tracks":"Przewiń, aby zobaczyć wszystkie ścieżki","No Agenda Items to show!":"Brak elementów planu dnia do pokazania!","ENTER EVENT":"DOŁĄCZ DO WYDARZENIA","change":"zmień","Upload":"Prześlij","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF LUB PNG. MAKSYMALNY ROZMIAR: 5 MB","Create Profile":"Utwórz profil","Email":"E-mail","Company":"Firma","Title":"Tytuł","No matching locations found":"Nie znaleziono pasujących lokalizacji","You can try searching for the location with another keyword":"Możesz spróbować wyszukać lokalizację za pomocą innego słowa kluczowego","Interest Tags":"Tagi zainteresowań","Pick your first tag":"Wybierz pierwszy tag","Save":"Zapisz","Searching...":"Wyszukiwanie...","Twitter":"Twitter","Select Your First Tags":"Wybierz pierwsze tagi","Add Interest tags":"Dodaj tagi zainteresowań","Congratulations!":"Gratulujemy!","Your first Goldcast event is set up":"Twoje pierwsze wydarzenie Goldcast zostało skonfigurowane","You can always visit":"Zawsze możesz odwiedzić","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":", aby uzyskać instrukcje dotyczące konfigurowania i prowadzenia wydarzeń","See My Event":"Zobacz moje wydarzenie","Peak Community":"Najbardziej aktywni użytkownicy","Loading Lite Mode... This may take up to 30s":"Wczytywanie trybu uproszczonego... Może to potrwać do 30 sekund.","Loading Video...":"Wczytywanie wideo...","Video will begin at session start time":"Transmisja wideo rozpocznie się o godzinie rozpoczęcia sesji","TIME":"GODZINA","TITLE":"TYTUŁ","STATUS":"STATUS","END":"ZAKOŃCZ","START":"ROZPOCZNIJ","AGENDA":"PLAN DNIA","Enable Audio":"Włącz dźwięk","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"Dźwięk został wyciszony z powodu zasad automatycznego odtwarzania w przeglądarce. Kliknij Włącz poniżej, aby wyłączyć wyciszenie. Możesz także wyłączyć wyciszenie dźwięku później za pomocą wbudowanych elementów sterowania.","Enable":"Włącz","You are being redirected outside the room. Would you like to continue?":"Przekierowano Cię poza pokój. Czy chcesz kontynuować?","Continue":"Kontynuuj","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"Ewentualnie możesz użyć trybu uproszczonego, jednak występuje w nim 30-sekundowe opóźnienie względem transmisji na żywo.","We detected a network issue":"Wykryliśmy problem z siecią","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Upewnij się, że nie łączysz się przez sieć VPN / zaporę internetową. Jeśli problem nadal występuje, spróbuj zmienić sieć, przeglądarkę lub urządzenie.","Could not connect":"Nie można nawiązać połączenia","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"Może to być spowodowane zabezpieczeniami sieci albo problemem z przeglądarką lub urządzeniem. Jeśli problem nadal występuje, spróbuj zmienić sieć, przeglądarkę lub urządzenie.","Switch to Lite Mode":"Przełącz na tryb uproszczony","Leave":"Opuść","Screenshare had an issue":"Wystąpił problem z udostępnianiem ekranu","Could not share screen unexpectedly. Refresh & retry. On mac go to":"Wystąpił nieoczekiwany błąd i nie można udostępnić ekranu. Odśwież i spróbuj ponownie. Na komputerze Mac przejdź do","and check if your browser has the required permission":"i sprawdź, czy przeglądarka ma przypisane wymagane uprawnienia.","Uh OH... Something went wrong":"Niestety wystąpił błąd","To fix this, click the":"Aby to naprawić, kliknij","in your URL bar, then select “Allow”, and then click “Try Again”":"na pasku adresu URL, wybierz „Zezwól”, a następnie kliknij „Spróbuj ponownie”.","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"Nie udało się zainicjować strumienia multimediów z nieznanego powodu! Używana przez Ciebie przeglądarka może nie być obsługiwana przez naszą platformę. Zalecamy korzystanie z przeglądarki Google Chrome. Jeśli problem będzie się powtarzać, skontaktuj się z zespołem pomocy technicznej Goldcast.","To fix this, make sure your":"Aby to naprawić, upewnij się, że żadna inna aplikacja nie ma dostępu do","is not being accessed by any other app. If not, please try changing your":". Jeśli nie ma, spróbuj zmienić","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":", klikając „Przejdź do ustawień”. Po usunięciu prawdopodobnej przyczyny problemu naciśnij „Spróbuj ponownie”!","Go To Settings":"Przejdź do ustawień","Try Again":"Spróbuj ponownie","Try Joining without Video":"Spróbuj dołączyć bez wideo","A refresh and rejoin should work":"Powinno zadziałać odświeżenie i ponowne dołączenie","Refresh & Rejoin":"Odśwież i dołącz ponownie","Start Chat":"Rozpocznij czat","On Stage":"Na scenie","Connect your on-site camera and microphone to present to your virtual attendees":"Podłącz kamerę i mikrofon na miejscu, aby prezentować treści wirtualnym uczestnikom.","Stop Streaming":"Zatrzymaj strumieniowanie","Start Streaming":"Rozpocznij strumieniowanie","Set up on-site video feed":"Skonfiguruj kanał wideo na miejscu","Open TV":"Otwórz TV","Layout: {layout} ":"Układ: {layout} ","With Speaker Videos":"Z wideo prelegentów","Full Screen":"Pełny ekran","No Speakers":"Brak głośników","Turn Off Setup Mode":"Wyłącz tryb konfiguracji","Setup Mode":"Tryb konfiguracji","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"Naciśnij przycisk wyłączenia, aby wyłączyć tryb konfiguracji dla pokoju {roomTitle}. Spowoduje to również wyłączenie wszystkich aktywnych strumieni.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"Przygotowanie do transmisji strumieniowej: {roomTitle}. Używaj trybu konfiguracji wyłącznie do przesyłania strumieniowego z lokalizacji na żywo.","Starting in {duration}":"Zaczyna się za {duration}","Can\'t share screen while there is something else being presented on stage":"Nie możesz udostępniać ekranu, gdy na scenie są prezentowane inne treści","You are now in attendee view!":"Jesteś teraz w widoku uczestnika!","You are now in organizer view!":"Jesteś teraz w widoku organizatora!","Note :":"Uwaga:","Only organizer accounts can see this tag, normal attendees can’t see this":"Ten tag można zobaczyć tylko z konta organizatora. Zwykli uczestnicy go nie widzą.","Attendee":"Uczestnik","Event Information":"Informacje o wydarzeniu","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"Informacje o wydarzeniu są widoczne tylko dla organizatorów! <br /> Ta sekcja nie jest widoczna dla uczestników.","Operating System":"System operacyjny","Secondary Booths":"Stoiska dodatkowe","Sort":"Sortuj","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"Obserwowanie {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2} spowoduje automatyczne anulowanie obserwowania: {track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}Czy chcesz kontynuować?","Track only available for {tracks}":"Ścieżka dostępna tylko dla {tracks}","Add to Calendar":"Dodaj do Kalendarza","Open Speakers Control Panel":"Otwórz panel sterowania dla prelegentów","Move Offstage ↓":"Przenieś poza scenę ↓","Error Moving ⚠":"Błąd przenoszenia ⚠","Off Stage":"Poza sceną","Move to Stage":"Przenieś na scenę","An error occurred!":"Wystąpił błąd!","{eventName} Documents":"{eventName} – dokumenty"," Set Up Mode":" Tryb konfiguracji","Camera & Mic blocked":"Kamera i mikrofon zablokowane","Camera/Mic Inaccessible":"Kamera/mikrofon niedostępny","Camera/Mic Not Found":"Nie znaleziono kamery/mikrofonu","Camera Inaccessible":"Kamera niedostępna","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"Kamera jest zajęta lub rozdzielczość nie jest obsługiwana. Upewnij się, że kamera nie jest używana przez inną aplikację, i spróbuj ponownie!","No microphone/camera is found":"Nie znaleziono mikrofonu/kamery","The browser does not support using camera and microphone!":"Przeglądarka nie obsługuje korzystania z kamery i mikrofonu!","{n} Slides":"Slajdy: {n}","Starting in {timeduration}":"Zaczyna się za {timeduration}","{eventtitle} has ended":"Zakończono wydarzenie {eventtitle}","This is a text q&a question!":"To jest tekstowa sesja pytań i odpowiedzi!","Click here{if_it_does_not}":"Kliknij tutaj{if_it_does_not}","{click_here}if it does not":"{click_here}, jeśli nie","{title}up next":"Następnie: {title}","seat(s) open":"miejsc(-e/-a) otwartych(-e)","Signal strength is low. Close other windows or connect to a different network.":"Siła sygnału jest niska. Zamknij inne okna lub połącz się z inną siecią.","GO BACKSTAGE":"PRZEJDŹ ZA KULISY","LEAVE STAGE":"OPUŚĆ SCENĘ","LEAVE":"OPUŚĆ","This event begins on{startitme}":"To wydarzenie rozpoczyna się {startitme}","Please refresh to enter.":"Odśwież, aby wejść.","people":"osób(-oby)","Oops, Something went wrong":"Wystąpił błąd","Back Home":"Powrót na stronę główną","Deciding where to go ...":"Zastanawiamy się nad kolejną sesją...","Go to Event Hub":"Przejdź do centrum wydarzeń","CREATE":"UTWÓRZ","Attending Virtually":"Uczestnictwo wirtualne","Attending In Person":"Uczestnictwo osobiste","Click to change your attendance type":"Kliknij, aby zmienić rodzaj uczestnictwa","Open Chat":"Otwórz czat","Create your profile for {eventtitle}":"Utwórz profil dla wydarzenia {eventtitle}","Move to stage":"Przenieś na scenę","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"Organizator wydarzenia poprosił o przeniesienie Cię na scenę transmisji <strong>{broadcastTitle}</strong>.<br /><br />W przypadku zaakceptowania prośby rozpocznie się transmisja na żywo i będą Cię widzieć uczestnicy wydarzenia.<br /><br />","Go Live On Stage":"Wejdź na scenę na żywo","Moved to backstage":"Przeniesiono za kulisy","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"Organizator usunął Cię ze sceny. Nie próbuj ponownie dołączać bez uprzedniego kontaktu z organizatorem.","Error creating Screen stream":"Błąd tworzenia strumienia ekranu","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"Nie przyznano uprawnienia udostępniania ekranu. Kliknij tutaj, aby zapoznać się z dokumentacją dotyczącą rozwiązywania problemów.","Error publishing stream":"Błąd publikowania strumienia","Could not publish stream. Please refresh and try again!":"Nie udało się opublikować strumienia. Odśwież i spróbuj ponownie!","Error publishing screen":"Błąd publikowania ekranu","Error publishing screen. Please refresh and try again!":"Błąd publikowania ekranu. Odśwież i spróbuj ponownie!","Error unpublishing stream":"Błąd cofania publikacji strumienia","Error unpublishing stream. Please refresh and try again!":"Błąd cofania publikacji strumienia. Odśwież i spróbuj ponownie!","Invalid Publish Operation":"Nieprawidłowa operacja publikowania","{username} profile picture":"{username} – zdjęcie profilowe","Default":"Domyślnie","A-Z":"A–Z","Random":"Losowo","All":"Wszystkie","Past":"Wcześniejsze","Upcoming":"Nadchodzące","Learn More":"Dowiedz się więcej","close":"zamknij","Discussion Rooms":"Pokoje dyskusyjne","ATTENDEE MODE":"TRYB UCZESTNIKA","Loading...":"Wczytywanie...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"Urządzenie jest wyłączone przez przeglądarkę lub nie przyznano uprawnień do korzystania z niego. Przyznaj uprawnienia i kliknij „Spróbuj ponownie”.","You are now registered. You will receive an email confirming details shortly.":"Jesteś teraz zarejestrowany(-a). Wkrótce otrzymasz wiadomość e-mail ze szczegółowymi informacjami.","Streaming to Virtual Users from on-site video feed":"Strumieniowanie do użytkowników wirtualnych z kanału wideo na miejscu","Ending in ":"Zakończenie za ","GO LIVE":"ZACZNIJ TRANSMISJĘ NA ŻYWO","You have no past events.":"Nie masz żadnych przeszłych wydarzeń.","You have no upcoming or live events.":"Nie masz nadchodzących wydarzeń ani wydarzeń na żywo.","left":"z lewej","center":"na środku","right":"z prawej","top":"na górze","bottom":"na dole","loading...":"wczytywanie...","Loading ...":"Wczytywanie...","Failed to redirect!":"Nie udało się przekierować!","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"Wygląda na to, że masz włączony program blokujący reklamy. Jeśli tak jest, nasza aplikacja może nie zapewniać optymalnych wrażeń z obsługi. Zalecamy wyłączenie programu blokującego reklamy. <br />&lt;br /&gt; Jeśli nie wiesz, jak to zrobić, kliknij <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>tutaj</a>, aby uzyskać dalsze instrukcje.","redirecting in {duration}":"przekierowanie za {duration}","STOP VIDEO":"ZATRZYMAJ WIDEO","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"Zamierzasz zakończyć odtwarzanie tego filmu. Transmisja wróci do trybu na żywo, a odbiorcy zobaczą i usłyszą prelegentów. Czy chcesz kontynuować?","STOP SHARING":"ZATRZYMAJ UDOSTĘPNIANIE","No Next Slide":"Brak następnego slajdu","Next Slide":"Następny slajd","No Previous Slide":"Brak poprzedniego slajdu","Previous Slide":"Poprzedni slajd","something went wrong while recording the response please try again":"Wystąpił błąd podczas nagrywania odpowiedzi. Spróbuj ponownie.","Start In-Person Streaming":"Rozpocznij strumieniowanie na miejscu","Stop In-Person Streaming":"Zatrzymaj strumieniowanie na miejscu","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Trwa buforowanie obrazu wideo i wkrótce rozpocznie się sesja testowa. Nie stanie się to podczas właściwej sesji.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"Pasek informacyjny pojawi się w górnej części strony internetowej i będzie widoczny dla wszystkich uczestników. Aby zamienić pasek w hiperłącze, wprowadź adres URL poniżej.","Allow {key}":"Zezwól: {key}","{messageType} can only be published from inside a broadcast.":"Wiadomości {messageType} mogą być publikowane wyłącznie w ramach transmisji.","To grant {deviceName} access to this page, follow the two steps below:":"{deviceName} – aby to urządzenie miało dostęp do tej strony, wykonaj dwa poniższe kroki:","2. Allow {deviceName} access and then refresh the page.":"2. Przyznaj aplikacji „{deviceName}” dostęp, a następnie odśwież stronę."}');

/***/ }),

/***/ 6709:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Lista suspensa de configuração de evento"," Stage Control":" Controle do palco","Stage Controls and Information":"Controles e informações do palco","Live in ":"Ao vivo em ","Start Session":"Iniciar sessão","End Session":"Encerrar sessão","Present Screen":"Apresentar tela","Rehearse On Stage":"Ensaiar no palco","Turn on Microphone":"Ativar microfone","Turn off Microphone":"Desativar microfone","Turn on camera":"Ativar câmera","Turn off camera":"Desativar câmera","rehearsal mode":"modo de ensaio","People Watching: ${watchCount}":"Pessoas assistindo: ${watchCount}","Turn on Audio":"Ativar áudio","Turn off Audio":"Desativar áudio","Are you sure you want to leave this room?":"Tem certeza de que deseja sair desta sala?","you will be redirected to stage in":"seu redirecionamento para o palco será feito em","sec. . ":"s. ","Skip to Main Navigation":"Ir para a navegação principal","Skip to Chat":"Ir para o bate-papo","Skip to Meeting Controls":"Ir para os controles de reunião","LinkedIn":"LinkedIn","Live in":"Ao vivo em","UPCOMING":"Futuros","Rehearse on stage":"Ensaiar no palco","Watch Rehearsal":"Assistir ao ensaio","Answered by:":"Respondida por:","Speaker Off":"Alto-falante desativado","Speaker On":"Alto-falante ativado","Speaker Controls":"Controles de palestrante","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"Todos os elementos de palco estão atrás da imagem compartilhada. Eles estarão visíveis novamente quando o compartilhamento de imagens em tela cheia for interrompido.","Close Ticker Popup":"Fechar pop-up de marcador","Open GIF Picker":"Abrir seletor de GIF","Open Emoji Picker":"Abrir seletor de emoji","Send Message":"Enviar mensagem","Tabs: Messaging and More":"Guias: Mensagens e mais","Thanks for attending!":"Agradecemos sua participação!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" Não há sessões agendadas na lista em que você se inscreveu. Acesse outras listas para ver sessões ao vivo.","Redirecting you to ":"Redirecionando você para ","in ":"em ","seconds":"segundos","Main Navigation":"Navegação principal","YOU ARE HERE":"VOCÊ ESTÁ AQUI","Live Now":"Ao vivo agora","SUBMIT":"ENVIAR","Allocated time for engagement has ended. You will be redirected to main stage":"O tempo alocado para interação acabou. Você voltará para o palco principal.","Wrap up in":"Encerrar em","Session overrun by":"Sessão excedida em","Ending in":"Terminando em","Bring this session live?":"Começar esta sessão?","START SESSION":"INICIAR SESSÃO","Bring this session to end?":"Terminar esta sessão?","END SESSION":"ENCERRAR SESSÃO","Go On Stage":"Entrar no palco","Muted by organizer":"Silenciado pelo organizador","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"Um dos organizadores do evento silenciou seu áudio. Você pode ativar o som clicando no botão de microfone.","Gifs":"GIFs","Stickers":"Adesivos","Launch Survey":"Iniciar pesquisa","Microphone is on":"O microfone está ligado","Microphone is off":"O microfone está desligado","Secret Code’s length should be 6 digits":"O código secreto deve ter 6 dígitos","Closing in 00:":"Encerrando em 00:","Submit":"ENVIAR","Questions":"Perguntas","Preview":"Prévia","Close Survey":"Encerrar pesquisa","This is a required question":"Esta pergunta é obrigatória","Enter the text you’d like to present on stage below.":"Digite abaixo o texto que você gostaria de apresentar no palco.","Use Chrome/Edge for best performance":"Use o Chrome/Edge para ter o melhor desempenho","Do you want to launch your survey now?":"Deseja iniciar sua pesquisa agora?","Success! Your Survey has been launched for attendees.":"Sua pesquisa foi iniciada com sucesso para os participantes.","Unable to publish. Please try again.":"Não é possível publicar. Tente novamente.","Are you sure you want to close this survey?":"Tem certeza de que deseja encerrar esta pesquisa?","Success! Your Survey has been closed for attendees.":"Sua pesquisa foi encerrada com sucesso para os participantes.","Unable to un-publish. Please try again.":"Não é possível cancelar a publicação. Tente novamente.","Please answer all required questions.":"Responda a todas as perguntas obrigatórias.","You have already submitted this survey.":"Você já enviou esta pesquisa.","Success! Thank you for your feedback.":"Agradecemos seus comentários.","Unable to submit. Please try again.":"Não é possível enviar. Tente novamente.","Launch surveys will take over attendees\' engagement panel.":"Ao iniciar uma pesquisa, ela aparecerá no painel de interação dos participantes.","Closing this survey will remove it from attendees\' engagement panel.":"Ao encerrar uma pesquisa, ela será removida do painel de interação dos participantes.","Survey":"PESQUISA","Updating Survey...":"Atualizando pesquisa...","Closing":"Encerrando","Goldcast needs access to your camera and microphone":"A Goldcast precisa de acesso a sua câmera e seu microfone","Goldcast needs access to your microphone":"A Goldcast precisa acessar seu microfone","Goldcast needs access to your camera":"A Goldcast precisa acessar sua câmera","SPEAKERS":"PALESTRANTES","Mark as Unanswered":"Marcar como não respondida","Mark as Answered":"Marcar como respondida","Remove from Priority":"Remover da prioridade","Mark as Priority":"Marcar como prioridade","Answer":"RESPONDER","Enter answer...":"Digite a resposta…","Answered by":"Respondida por","Submit Answer":"Enviar resposta","Test your system’s speaker":"Testar o alto-falante do seu sistema","Click \\"Yes\\" if you hear the sound.":"Clique em \\"Sim\\" se ouvir o som.","Load previous":"Carregar anterior","Hide Name":"Ocultar nome","Text Q&A is disabled in On Demand mode.":"As perguntas e respostas em texto estão desativadas no modo Sob demanda.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"O limite de perguntas e respostas em texto foi atingido. Os participantes não poderão fazer novas perguntas.","Sent to Q&A":"Enviada para P&R","Couldn\'t post as Q&A. Please try again.":"Não foi possível publicar como P&R. Tente novamente.","Yes this is being recorded":"Sim, está sendo gravado","No this is not being recorded":"Não está sendo gravado","System\'s Speaker Check":"Verificação do alto-falante do sistema","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"Para garantir que você conseguirá ouvir durante o evento, verifique se os alto-falantes do sistema estão funcionando corretamente","Click on “Test your system’s speaker” to proceed":"Clique em \\"Testar alto-falante do sistema\\" para continuar.","Error while sharing message to screen. Post not found":"Erro ao compartilhar mensagem na tela. A publicação não foi encontrada.","Lost connection to servers. Refresh your page to get live event experience.":"A conexão com os servidores foi perdida. Recarregue a página para ter a experiência do evento ao vivo.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"A VPN ou o firewall está interferindo na autenticação. Troque de rede ou peça para sua equipe de TI permitir <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>estes domínios</a> para você acessar a Goldcast sem problemas.","It\'s taking too long":"Está demorando muito","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"Parece que você se conectou por VPN ou que o firewall está ativado. Consulte este <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>documento de ajuda</a> e adicione os domínios necessários à lista de permissões para que a Goldcast funcione sem problemas ou troque de rede.","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"Parece que você se conectou por VPN ou que o firewall está ativado. Consulte este <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>documento de ajuda</a> e adicione os domínios necessários à lista de permissões para que a Goldcast funcione sem problemas. Você também pode trocar de rede ou assistir à sessão no modo lite.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"Não é possível conectar o serviço de transmissão de vídeo da Goldcast devido à baixa largura de banda da rede. Troque de rede para se conectar ao serviço de transmissão ao vivo.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"Não é possível conectar o serviço de transmissão de vídeo da Goldcast devido à baixa largura de banda da rede. Mude para o modo lite ou troque de rede para se conectar ao serviço de transmissão.","Most Upvotes":"Mais votada","Most Recent":"Mais recente","My Questions":"Minhas perguntas","Prioritized":"Priorizadas","Approved":"Aprovadas","Unapproved":"Não aprovadas","Unanswered":"Sem resposta","Failed to update answer. Please try again!":"Falha ao atualizar a resposta. Tente novamente.","Failed to post answer. Please try again!":"Falha ao publicar a resposta. Tente novamente.","Failed to delete question. Please try again!":"Falha ao excluir a pergunta. Tente novamente.","Survey Link":"Link da pesquisa","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"Quando você mudar, a página atual será recarregada na exibição de participante. Para voltar à exibição de organizador, desative a exibição de participante no menu suspenso do perfil.","You haven\'t asked any questions yet":"Você ainda não fez perguntas","No prioritized questions":"Nenhuma pergunta priorizada","Create prioritized list of questions for speakers by marking questions as priority":"Marque as perguntas como prioridade para criar uma lista prioritária para os palestrantes.","No Approved Questions":"Nenhuma pergunta aprovada","Approve incoming questions to see list of approved questions":"Aprove as perguntas recebidas para ver uma lista de perguntas aprovadas.","No Unapproved Questions":"Nenhuma pergunta não aprovada","No Answered Questions":"Nenhuma pergunta respondida","Answer a question on stage or with inline text":"Responda a uma pergunta no palco ou com texto integrado.","All questions are answered":"Todas as perguntas foram respondidas.","Rate Your Experience":"Avalie sua experiência","How satisfied are you with Goldcast?":"Qual é seu nível de satisfação com a Goldcast?","What are the main reasons for your rating?":"Quais são os principais motivos da sua avaliação?","I am interested in seeing a demo of Goldcast":"Tenho interesse em assistir a uma demonstração da Goldcast.","Thank You":"Obrigado","Your feedback was successfully submitted.":"Seus comentários foram enviados.","Tell us how we can improve...":"Diga como podemos melhorar...","1 Slide":"1 slide","Your internet connection is unstable.":"Sua conexão com a internet está instável.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"Parece que você está falando com o microfone silenciado. Clique no ícone de microfone para ativá-lo.","The registration could not be completed! Please check that this email is allowed to register for the event.":"Não foi possível concluir a inscrição. Verifique se este e-mail tem permissão para se inscrever no evento.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Parece que você já se registrou neste evento. Se ainda não recebeu a confirmação, verifique sua pasta de spam. Entre em contato com a organização do evento caso precise de mais ajuda.","Your registration could not be completed. This event has reached its registration capacity.":"Não foi possível concluir sua inscrição. Este evento atingiu a capacidade máxima.","Image cannot be an svg":"A imagem não pode ser svg","This should be a valid linkedin url":"Deve ser um URL válido do LinkedIn","This should be a valid twitter url":"Deve ser um URL válido do Twitter","This should be a valid url":"Deve ser um URL válido","Video":"vídeo","Read Less":"Ler menos","live":"AO VIVO","Opened":"Aberta","In person only":"Apenas presencialmente","Stage Stream":"Transmissão do palco","Streaming not available":"Transmissão indisponível","Close TV":"Fechar TV","Streaming is not available for prerecorded and RTMP sessions":"A transmissão não está disponível para sessões pré-gravadas e RTMP","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Conecte o computador à tela da TV ou a um projetor para que os participantes presenciais possam acompanhar o que acontece no palco virtual, incluindo slides, perguntas e respostas, etc. Após fazer isso, clique em ABRIR TV e arraste ou compartilhe uma nova janela com a tela da TV ou o projetor. ","Close Setup Mode":"Fechar modo de preparação","Help":"Ajuda","upcoming":"Futuros","ended":"Encerrada","Remove from favorites":"Remover dos favoritos","Add to favorites":"Adicionar aos favoritos","PLAY RECORDING":"Reproduzir gravação","VIEW RECORDING":"VER GRAVAÇÃO","VIEW RECORDINGS":"VER GRAVAÇÕES","Virtual Backgrounds":"Planos de fundo virtuais","No Device Available":"Nenhum dispositivo disponível","Needs permission":"Precisa de permissão","Device not detected":"Dispositivo não detectado","Camera is on":"A câmera está ligada","Camera is off":"A câmera está desligada","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"O vídeo espelhado não é refletido para quem está assistindo. Os espectadores sempre veem o vídeo não espelhado.","Mirror My Video":"Espelhar meu vídeo","Camera":"CÂMERA","1. Click on Safari > Settings for this\\n            website":"1. Clique em Safari > Ajustes para este site","1. Click the lock":"1. Clique no ícone de cadeado","icon in your browser’s address bar":"na barra de endereço do navegador.","3. Unmute":"3. Ative o som","and":"e","icons from stage control panel":"ícones do painel de controle do palco","icon from stage control panel":"ícone do painel de controle do palco","2. Set camera and microphone to “Allow”.":"2. Mude a câmera e o microfone para \\"Permitir\\".","2. Set camera to “Allow”.":"2. Mude a câmera para \\"Permitir\\".","2. Set microphone to \\"Allow\\"":"2. Mude o microfone para \\"Permitir\\".","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. Escolha \\"Sempre permitir que a Goldcast acesse a câmera e o microfone\\".","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. Escolha \\"Sempre permitir que a Goldcast acesse a câmera\\".","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. Escolha \\"Sempre permitir que a Goldcast acesse o microfone\\".","Questions?":"Perguntas?","If you’re having issues, check out our comprehensive":"Se você estiver tendo problemas, confira nossa abrangente","help docs":"documentação de ajuda","Speaker is on":"O alto-falante está ligado","Stop Test":"Parar teste","Test your system’s audio":"Testar o áudio do seu sistema","Still can\'t hear any sound?":"Ainda não consegue ouvir o som?","Microphone":"MICROFONE","Audio is being played in system\'s default audio device.":"O som é reproduzido no dispositivo de áudio padrão do sistema.","Click to view/change audio device":"Clique para ver/alterar o dispositivo de áudio.","Speaker":"ALTO-FALANTE","Play Recording":"Reproduzir gravação","Recording for this broadcast is currently being processed and will be available soon":"A gravação desta transmissão está sendo processada e estará disponível em breve","You haven\'t favorited anything yet!":"Você ainda não marcou nada como favorito.","Add an item to favorites by selecting the ♡ in the top right corner.":"Adicione um item aos favoritos selecionando ♡ no canto superior direito.","Session has ended":"A sessão terminou","System Check":"Verificação do sistema","Need help? Check out the":"Precisa de ajuda? Confira","Skip Checks and Continue":"Ignorar verificações e continuar","Click the button above to run the test":"Clique no botão acima para testar.","Test Screenshare":"Testar compartilhamento de tela","Share message to stage":"Compartilhar a mensagem no palco","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"Digite abaixo o texto que você gostaria de usar para o marcador. Para transformar o marcador em um hiperlink, insira um URL.","Ticker":"Marcador","Coffee Break! Be back in 10m.":"Intervalo! Volte em 10 minutos.","Enter Message":"Digitar mensagem","https://www.xyz.com":"https://www.xyz.com","Launch":"Iniciar","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Agradecemos por enviar suas perguntas. Será possível enviar outra assim que uma das perguntas que você enviou for aprovada.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"As perguntas e respostas estão desativadas no momento. Você poderá enviar uma pergunta assim que o recurso for ativado novamente.","Votes":"Votos","Vote":"Votar","is inviting you to a video call":"está convidando você para uma chamada de vídeo","ENTER ROOM":"ENTRAR NA SALA","Start the conversation!":"Comece a conversa.","Couldn\'t send message. Click here to retry.":"Não foi possível enviar a mensagem. Clique aqui para tentar novamente.","Couldn\'t add emoji. Please try again.":"Não foi possível adicionar o emoji. Tente novamente.","Couldn\'t remove emoji. Please try again.":"Não foi possível remover o emoji. Tente novamente.","Couldn\'t delete message. Please try again.":"Não foi possível excluir a mensagem. Tente novamente.","Couldn\'t pin message. Please try again.":"Não foi possível fixar a mensagem. Tente novamente.","Couldn\'t unpin message. Please try again.":"Não foi possível desafixar a mensagem. Tente novamente.","Today":"Hoje","No messages yet":"Ainda não há mensagens","Messages from organizers and speakers appear here!":"As mensagens de organizadores e palestrantes aparecem aqui.","Next Session is Starting":"A próxima sessão está começando","Go to Next Session":"Ir para a próxima sessão","I’d like to stay":"Quero ficar","My favorites":"Meus favoritos","1. Click on the lock icon in your address bar":"1. Clique no ícone de cadeado na barra de endereço.","We recommend organizers and speakers use a desktop\\n        device":"Recomendamos que organizadores e palestrantes usem um computador.","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"Para garantir a melhor experiência para quem participa, palestrantes e organizadores devem usar a Goldcast em um computador. A transmissão de um dispositivo móvel proporcionará uma experiência inferior.","Watch Now":"Assistir agora","Video progress time":"Tempo de progresso do vídeo","Total video duration":"Duração total do vídeo","Rate Goldcast!":"Avalie a Goldcast.","Running Required Checks...":"Executando as verificações necessárias...","Test Your Setup":"Testar ajuste","Test your Computer Device, Microphone and Camera before you join the event":"Teste seu computador, o microfone e a câmera antes de entrar no evento","Speaker and microphone not working?":"Alto-falante e microfone não funcionam?","Passed":"Concluído com êxito","Fix Audio Issues":"Corrigir problemas de áudio","Check if audio is being played in other sound devices connected to phone/tablet":"Verifique se o áudio é reproduzido em outros dispositivos de som conectados ao telefone/tablet","Check if correct audio device is chosen from the below dropdown":"Verifique se o dispositivo de áudio correto está selecionado na lista suspensa abaixo.","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>Clique aqui</a> para verificar se o dispositivo de áudio em que o som precisa de ser reproduzido foi selecionado corretamente","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Clique aqui</a> para verificar se o dispositivo de áudio em que o som precisa de ser reproduzido foi selecionado corretamente","Right click on the browser tab & click “Unmute Site”":"Clique com o botão direito do mouse na guia do navegador e clique em \\"Reativar áudio do site\\"","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Verifique se a guia do navegador está com som ativado ou clique na janela > Reativar som desta guia.","System Check Failed!":"Falha na verificação do sistema.","System Check Passed!":"Êxito na verificação do sistema.","Complete checks to proceed":"Conclua as verificações para continuar","Enter Event":"ENTRAR NO EVENTO","Skip Screen Sharing Check? ":"Ignorar verificação de compartilhamento de tela? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"Recomendamos verificar o compartilhamento de tela se você precisar apresentar sua tela no evento.","Ignore & Enter Event":"Ignorar e entrar no evento","Test screenshare":"Testar compartilhamento de tela","Retry Now":"Repetir agora","SHARE":"Compartilhar","Rooms Closed":"Salas fechadas","Discussion rooms are now closed. You are being redirected to the Stage.":"As salas de discussão foram fechadas. Redirecionaremos você para o Palco.","Return To Stage":"RETORNAR AO PALCO","Unrecognized embedded widget provider - ":"Provedor de widget incorporado não reconhecido - ","Room Ended":"Sala encerrada","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"O organizador do evento fechou todas as salas. Redirecionaremos você para o palco do evento.","Video Q&A Request Cancelled":"Solicitação de P&R em vídeo cancelada","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Sua solicitação de perguntas e respostas em vídeo foi cancelada porque você está assistindo no modo lite. Mude para o modo ao vivo para levantar a mão novamente.","Camera Passed":"Câmera - Êxito","Camera Error":"Erro na câmera","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"O navegador não concede permissões para a câmera. Clique em \\"Permitir câmera\\".","Camera permissions aren’t granted from system. Click “Allow Camera”":"O sistema não concede permissões para a câmera. Clique em \\"Permitir câmera\\".","Uh-oh! Error occurred while creating camera stream":"Ops! Ocorreu um erro ao criar a transmissão da câmera","Close other applications which might use camera stream":"Feche outros aplicativos que possam usar a transmissão da câmera","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>Clique aqui</a> para verificar se o navegador tem acesso à câmera.","Microphone Passed":"Microfone - Êxito","Microphone Error":"Erro no microfone","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"O navegador não concede permissões para o microfone. Clique em \\"Permitir microfone\\".","Mic permissions aren’t granted from system. Click “Allow Microphone”":"O sistema não concede permissões para o microfone. Clique em \\"Permitir microfone\\".","Uh-oh! Error occurred while creating mic stream":"Ops! Ocorreu um erro ao criar a transmissão do microfone.","Close other applications which might use mic stream":"Feche outros aplicativos que possam usar a transmissão do microfone.","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>Clique aqui</a> para verificar se o navegador tem acesso ao microfone.","Speaker and Microphone Error":"Erro no alto-falante e microfone","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"As permissões de microfone são necessárias para mostrar a lista de alto-falantes conectados ao sistema. Clique em \\"Permitir microfone\\".","It seems mic is being used by other application. Close other applications to proceed.":"Parece que o microfone está sendo usado por outro aplicativo. Feche os outros aplicativos para prosseguir.","Camera & Microphone Error":"Erro na câmera e microfone","To enable permissions, click the Allow Camera & Mic button below":"Para ativar as permissões, clique no botão \\"Permitir câmera e microfone\\" abaixo.","Network Connection":"Conexão de rede","Check Passed":"Êxito na verificação","Could not establish a network connection":"Não foi possível estabelecer uma conexão de rede","Connect to a different network, or use a mobile hotspot.":"Conecte-se a outra rede ou use um ponto de acesso móvel.","Disable any VPN or firewall is connected.":"Desative qualquer VPN ou firewall conectado.","Connection: Good":"Conexão: boa","Network Connection Error":"Erro na conexão de rede","Can’t connect to network. Change your network or limited functionality will be available during event.":"Não é possível conectar à rede. Mude a rede ou as funções disponíveis durante o evento serão limitadas.","AdBlocker":"Bloqueador de anúncios","AdBlocker not detected.":"Bloqueador de anúncios não detectado.","AdBlocker detected. This may degrade your event experience.":"Bloqueador de anúncios detectado. Isso pode prejudicar sua experiência no evento.","Disable adblocker for best experience.":"Desative o bloqueador de anúncios para ter a melhor experiência.","You are using ":"Você está usando ","Use Windows or Mac OS for best performance":"Use o Windows ou macOS para ter o melhor desempenho","Browser Check":"Verificação do navegador","Check Passed.":"Êxito na verificação.","Switch To Lite Mode":"Alternar para modo lite","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Sua solicitação de perguntas e respostas em vídeo que está pendente será cancelada quando você mudar para o modo lite.","Stay on Live Mode":"Continuar no modo ao vivo","Unable to mark as favorite":"Não foi possível marcar como favorito","Event organizers must enter the event to select favorites.":"Os organizadores precisam entrar no evento para selecionar os favoritos.","Make an Announcement":"Fazer um anúncio","STOP":"PARAR","InPerson CheckIn App":"Aplicativo para check-in presencial","App to Check-In In-Person attendees":"Aplicativo para fazer check-in de participantes presenciais","SEE AGENDA":"Ver programação","Please visit the Agenda tab to view the session recordings":"Acesse a guia Programação para visualizar as gravações de sessão","The session recordings will be available soon in the Agenda tab":"As gravações de sessão estarão disponíveis em breve na guia Programação","FAILED!":"FALHA","Next session is beginning":"A próxima sessão está começando","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"Quer passar para a próxima sessão? Sua transmissão continuará, e a TV mostrará a nova sessão.","Banners":"Banners","Images":"Imagens","Screen Share":"Compartilhamento de tela","Browser might not have screen-recording permission on your computer.":"O navegador pode não ter permissão de gravação de tela no computador.","Open System Preferences":"Abrir Preferências do Sistema","Error publishing screen because someone else started screen share already.":"Erro ao publicar a tela porque outra pessoa já começou a compartilhar a tela.","Live Feed":"Feed ao vivo","Check Your Network":"Verificar a rede","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"Detectamos um erro durante a reprodução do vídeo. Se você estiver com problemas na reprodução do vídeo, tente recarregar a página ou mudar para o modo lite.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"Detectamos um erro durante a reprodução do vídeo. Se você estiver com problemas na reprodução do vídeo, tente recarregar a página.","All Dates":"Todas as datas","All Tracks":"Todas as listas","Create Ticker":"Criar marcador","Booths Closed":"Estandes fechados","Your event organizer has closed all the booths. You will now be redirected to the stage":"O organizador do evento fechou todos os estandes. Redirecionaremos você para o palco.","Visit the Polls tab to view live results.":"Acesse a guia Enquetes para ver os resultados em tempo real.","A new poll is open! Visit the Polls tab to vote.":"Uma nova enquete está aberta. Acesse a guia Enquetes para votar.","Vote for Polls":"Votar nas enquetes","Go to Polls Tab":"Ir para a guia Enquetes","Microphone audio too low":"O áudio do microfone está muito baixo","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"Detectamos um problema com seu áudio. Recomendamos tentar ativar/desativar o mudo ou usar outro dispositivo se o problema persistir.","Audio/Video bitrate too low":"Taxa de bits de áudio/vídeo muito baixa","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"Suas configurações de firewall de rede estão bloqueando as transmissões de áudio/vídeo. Recomendamos mudar para outra conexão de rede.","Error sharing screen":"Erro ao compartilhar tela","A network error occurred while sharing screen. Please check your network connection.":"Ocorreu um erro na rede durante o compartilhamento de tela. Verifique sua conexão de rede.","Apologies, due to some errors, we need to refresh the page!":"Lamentamos, mas a página precisa ser atualizada porque ocorreram alguns erros.","Warning":"Aviso","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"Detectamos um problema com seu vídeo. Recomendamos fechar outras guias do navegador ou outros aplicativos em execução no dispositivo e verificar/atualizar sua conexão com a internet para resolver esse problema.","No results found":"Nenhum resultado encontrado","Audio":"áudio","Please choose another microphone and camera":"Escolha outro microfone e câmera","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"O microfone e a câmera selecionados no momento não estão funcionando. Escolha outro microfone e outra câmera nas listas suspensas abaixo.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"A câmera selecionada no momento não está funcionando. Escolha outra câmera no menu suspenso abaixo.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"Embora você possa continuar sem uma câmera, recomendamos resolver o conflito para garantir uma experiência de transmissão tranquila.","Please choose another microphone":"Escolha outro microfone","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"O microfone selecionado no momento não está funcionando. Escolha outro na lista suspensa abaixo.","Please check that your TV speaker is correct":"Verifique se o alto-falante da TV é o correto","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"O alto-falante selecionado no momento não está funcionando. Escolha outro na lista suspensa abaixo.","Your answer":"Sua resposta","Edit":"Editar","Delete":"Apagar","Settings":"Configurações","Signing Out":"Desconectando","Confirming your account...":"Confirmando sua conta...","Something Went Wrong. Please Retry :(":"Parece que algo deu errado. Tente novamente :(","Resending Mail":"Reenviando e-mail","offline":"off-line","I am inviting you to a video meeting:":"Estou convidando você para uma chamada de vídeo:","Resending secure login link to your email":"Reenviando link de login seguro para seu e-mail","Sending secure login link to your email":"Enviando link de login seguro para seu e-mail","Something went Wrong. Please Retry :(":"Parece que algo deu errado. Tente novamente :(","Updating your password":"Atualizando sua senha","Sending mail":"Enviando e-mail","Verifying":"Confirmando","This might be slower than usual":"O processo pode estar mais lento do que o normal","Checking":"Verificando","New results available! Refresh!":"Novos resultados estão disponíveis. Atualize para visualizá-los.","Saving":"Salvando","Turn off Attendee mode":"Desativar modo participante","See Attendee View":"Ver exibição de participante","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Total de participantes vendo esta sessão no momento Nota: essa informação é apenas para o organizador","Session Count":"Contagem da sessão","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"Número de participantes vendo sessões ao vivo no momento. Nota: essa informação é apenas para o organizador","Role":"Função","Total Attendees":"Total de participantes","Total number of attendees online at this time Note: This is for organizer eyes only":"Total de participantes on-line no momento Nota: essa informação é apenas para o organizador","My Profile":"Meu perfil","Languages":"Idiomas","Filling out your profile can help you connect with people with similar interests.":"Ao preencher seu perfil, você pode encontrar pessoas com interesses parecidos.","type to search for your address":"digite para procurar seu endereço","Could not open direct call":"Não foi possível abrir uma chamada direta","Chat messages can only be published from inside a broadcast.":"As mensagens do bate-papo só podem ser publicadas de dentro de uma transmissão.","Stage Logo can only be published from inside a broadcast.":"O logotipo do palco só pode ser publicado de dentro de uma transmissão.","Loading Speakers":"Carregando palestrantes","Raise hand is disabled for organizer accounts, but active for attendee accounts":"O recurso Levantar a mão está desativado nas contas de organizadores, mas está ativo nas contas de participantes","Disabled in lite mode, return to live if you’d like to raise hand!":"Desativado no modo lite. Volte para o modo ao vivo para levantar a mão.","Raise hand to enter stage for video q&a":"Levante a mão para participar das perguntas e respostas em vídeo","Speakers":"Palestrantes","Hosting organization: {organization}":"Empresa organizadora: {organization}","Failed to switch {deviceTag}":"Falha ao mudar para {deviceTag}","Make sure your {deviceTag} is not being used by any other application and is working properly.":"Confirme se {deviceTag} não está sendo usado por outro aplicativo e se funciona corretamente.","Facing issues with audio or video? Switch on lite mode":"Problemas no áudio ou vídeo? Ative o modo lite","Failed to get event for eventID: {eventID}":"Falha ao obter o evento para eventID: {eventID}","Error while playing video.":"Erro na reprodução do vídeo.","Speakers only, attendees can\'t see this chat":"Apenas palestrantes. Os participantes não conseguem ver este bate-papo","Kudo":"Kudo","Room":"Sala","Session":"Sessão","Booth":"Estande","Public":"Público","Drift":"Drift","Slides":"Slides","Videos":"Vídeos","Chat":"Bate-papo","Messages":"Mensagens","Poll":"Enquete","Docs":"Arquivos","Q&A":"P&R","Media":"Mídia","Messages Chat":"Mensagens Bate-papo","Leaderboard":"Placar","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Nota: como você também é palestrante neste evento, sempre poderá acessar a área de bastidores e entrar no palco.","Switch to Attendee View":"Mudar para exibição de participante","Return to Organizer View":"Retornar à exibição de organizador","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"Quando você desativar a exibição de participante, a página atual será recarregada, e você retornará à exibição de organizador. Deseja continuar?","Switch":"Alternar","Request Sent":"Solicitação enviada","Your request for a demo has been submitted":"Sua solicitação pedindo uma demonstração foi enviada","Organizer Redirection":"Redirecionamento de organizador","YES, REDIRECT":"SIM, REDIRECIONAR","DISMISS":"IGNORAR","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"Os participantes estão sendo redirecionados para a próxima sessão: {title}. Também deseja ir para a próxima sessão?","Stage":"Palco","Rooms":"Salas","Join a round table to discuss moderated topics with your fellow attendees":"Participe de uma mesa redonda para discutir tópicos moderados com outros participantes","Booths":"Estandes","Join a booth to know more about a sponsor":"Entre em um estande para conhecer melhor um patrocinador","You are in the booth":"Você está no estande","People":"Pessoas","Connect with your fellow attendees":"Conecte-se com outros participantes","Connect with speakers":"Conecte-se com os palestrantes","starting in {duration}":"começa em {duration}","You will be redirected to booths in {duration}":"Seu redirecionamento para os estandes será feito em {duration}","booths":"estandes","agenda":"programação","You will be redirected to {word} in {duration}":"Seu redirecionamento para {word} será feito em {duration}","You will be redirected to the live stage in {duration}":"Seu redirecionamento para o palco ao vivo será feito em {duration}","- You are about to be redirected to {tabTitle} in {duration}":"- Seu redirecionamento para {tabTitle} acontecerá em {duration}","See Agenda":"Ver programação","Break":"Intervalo","{title} is now live":"{title} já está ao vivo","Apologies, due to an error we need to refresh the page!":"Lamentamos, mas ocorreu um erro, e a página precisa ser atualizada.","Network interruption detected":"Interrupção de rede detectada","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"Sua conexão com a internet está apresentando alguns problemas. Se você estiver usando uma VPN, considere desativá-la. Uma alternativa é conectar a outra rede","No audio output device detected":"Nenhum dispositivo de saída de áudio detectado","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Conecte alto-falantes/fones de ouvido e use o ícone de engrenagem para testar, se você tiver algum problema.","Please disable ad blocker for this page":"Desative o bloqueador de anúncios nesta página","Yes, I understand":"Sim, eu entendo","No event user found so attended not marked!":"Não foi possível encontrar o usuário. A presença no evento não foi registrada.","Wait while the speaker approves your video q&a request":"Espere o palestrante aprovar sua solicitação para perguntas e respostas em vídeo","Organizer":"Organizador","UPNEXT":"a seguir","Ended":"Encerrada","Hide":"Ocultar","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"Esta página redirecionará você automaticamente em {durationLeftToRedirect} segundos.","Register":"Registrar-se","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Erro: usuário não consegue se registrar neste evento. Entre em contato com o organizador para receber ajuda","You are already registered!":"Você já se registrou.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Parece que você já se registrou neste evento. Se ainda não recebeu a confirmação, verifique sua pasta de spam. Entre em contato com o organizador do evento caso precise de mais ajuda","Thank you for registering!":"Agradecemos por se registrar!","Submit another response":"Enviar outra resposta","Share":"Compartilhar","Know someone who want to attend this?":"Conhece alguém que deseja participar deste evento?","COPY LINK":"COPIAR LINK","Powered by":"Um desenvolvimento","VIEW PROFILE":"VER PERFIL","You can access the event landing here":"Você pode acessar a página inicial do evento aqui","Need Help?":"Precisa de ajuda?","Welcome back":"É bom ter você de volta!","Checking...":"Verificando...","Close":"Fechar","Enter":"Entrar","See {roomCount} Room(s)":"Ver {roomCount} sala(s)","Back":"Voltar","Request a Demo":"Solicitar uma demonstração","Loading":"Carregando","Thread":"Conversa","Load more":"Carregar mais","Heads up!":"Atenção!","YES":"SIM","No":"Não","Following":"Seguindo","Error in loading drimify":"Erro ao carregar Drimify","You\'re not registered for this event":"Você não se registrou neste evento","Check out other events":"Confira outros eventos","Date":"Data","Location":"Local","How are you attending the event":"Como você pretende participar do evento?","In Person":"Presencialmente","Virtually":"Virtualmente","Event Widgets":"Widgets de evento","Chat • Messages • Q&A • Poll • Docs":"Bate-papo • Mensagens • P&R • Enquete • Arquivos","DISCUSSION":"DISCUSSÃO","JOIN":"PARTICIPAR","WAIT":"AGUARDAR","more":"mais","See Profile":"Ver perfil","Filter":"Filtrar","Video player not supported by your browser":"O player de vídeo não é compatível com o navegador","We recommend using the latest version of Google Chrome to access your conference":"Recomendamos usar a versão mais recente do Google Chrome para acessar a conferência","ANSWER":"RESPONDER","REJECT":"REJEITAR","Don’t ask me this next time":"Não perguntar de novo","Cancel":"Cancelar","Lite Mode":"Modo lite","On":"Ativar","Connection Issues? Turn on Lite Mode":"Problemas de conexão? Ative o modo lite","Turn On Lite Mode":"Ativar modo lite","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"O modo lite tem um atraso de 30 segundos entre a transmissão ao vivo e o que aparece na sua tela. Deseja continuar?","Turn On":"Ativar","Lite Mode Active!":"O modo lite foi ativado.","Thanks for your patience, lite mode now on!":"Agradecemos sua paciência! O modo lite está ativo agora.","Turn off Lite Mode?":"Desativar o modo lite?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Desative o modo lite para voltar a assistir à transmissão ao vivo. Mas atenção, isso causa uma interrupção de 30s até recuperarmos o ritmo.","Lite Mode Off!":"O modo lite foi desativado.","Thanks for your patience, we’ve returned to the live broadcast!":"Agradecemos sua paciência! Estamos de volta com a transmissão ao vivo.","Lite Mode Unavailable":"Modo lite indisponível","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Lamentamos a inconveniência, mas o modo lite não está disponível no momento. Mude para a transmissão ao vivo para retomar a sessão.","Turn off Lite mode?":"Desativar o modo lite?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"Detectamos que sua conexão voltou ao normal. Deseja mudar para a transmissão ao vivo? Atenção, isso causa uma interrupção de 30s até recuperarmos o ritmo.","Turn Off":"Desativar","Lite mode is disabled for organizer accounts, but active for attendee accounts":"O modo lite está desativado nas contas de organizadores, mas está ativo nas contas de participantes","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"O modo lite não é compatível com o navegador. Recomendamos usar a versão mais recente do Google Chrome","Lite mode is not curently available. We’ll let you know once it’s available again":"O modo lite não está disponível no momento. Vamos avisar você assim que ele for disponibilizado novamente","Turn off Lite Mode":"Desativar modo lite","We’ll let you know when Lite mode is available again":"Vamos avisar você quando o modo lite estiver disponível novamente","Lite Mode Available":"Modo lite disponível","Loading Lite Mode...":"Carregando modo lite...","Turning Off Lite Mode":"Desativando modo lite","Lite Mode On":"Modo lite ativado","Audio/Video Issues?":"Problemas no áudio ou vídeo?","Error":"Erro","Click a video to play":"Clique em um vídeo para reproduzi-lo","Error starting video!":"Erro ao iniciar o vídeo.","Please rotate your device to {mode} mode":"Gire o dispositivo para a orientação {mode}","landscape":"paisagem","portrait":"retrato","Thank you for attending this event!":"Agradecemos por participar deste evento!","Go to Rooms":"Ir para as salas","Please use a desktop or laptop Google Chrome browser to access your conference":"Use o navegador Google Chrome em um computador para acessar a conferência","If on Desktop":"Se no computador","Please increase the width of your window":"Aumente a largura da janela","Alternatively, check out the":"Como alternativa, acompanhe a","Youtube Livestream":"Transmissão ao vivo no YouTube","Search":"Pesquisar","Profile":"Perfil","Yes":"Sim","Loading Chat":"Carregando bate-papo","Please wait while we fetch the chat":"Aguarde enquanto buscamos o bate-papo","Load old messages":"Carregar mensagens antigas","Join the room to see chat":"Entrar na sala para acompanhar o bate-papo","Live Chat":"Bate-papo ao vivo","Uh..oh we couldn\'t load the content":"Ih, não conseguimos carregar o conteúdo","Please reload the page":"Recarregue a página","New comments":"Novos comentários","Start the conversation":"Comece a conversa","Be the first to add to chat!":"Escreva uma mensagem para inaugurar o bate-papo.","Enter your message":"Digite sua mensagem","Joining chat!":"Entrando no bate-papo.","See all pinned messages":"Ver todas as mensagens fixadas","Failed to send! Retry?":"Falha no envio. Tentar de novo?","Search for attendee":"Procurar participante","Up to date":"Atualizado","Start a new conversation, We think you\'ll enjoy":"Comece uma nova conversa. Achamos que você vai curtir","chatting with these recommended attendees!":"fale com estes participantes recomendados.","Searching":"Pesquisando","Load Previous":"Carregar anterior","Load Next":"Carregar seguinte","Loading Channel":"Carregando canal","Please wait while we fetch the channel":"Aguarde enquanto buscamos o canal","Please wait while we fetch the messages":"Aguarde enquanto buscamos as mensagens","Send the first message":"Enviar a primeira mensagem","Join":"Participar","link":"link","download":"download","Click to open":"Clique para abrir","No open polls":"Nenhuma enquete aberta","Check back later to see if a poll opens up!":"Volte mais tarde para ver se uma enquete foi aberta.","Loading Poll":"Carregando enquete","Please wait while we fetch the polls":"Aguarde enquanto buscamos as enquetes","Uh oh.. we couldn’t load the content":"Ih, não conseguimos carregar o conteúdo","Polls":"Enquetes","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"Para abrir uma enquete, adicione a pergunta e as respostas a esta sessão no Painel de administração da Goldcast","Stop Sharing":"Interromper compartilhamento","Can\'t publish polls while something else is being presented on stage":"Não é possível publicar enquetes enquanto ocorre uma apresentação no palco","Open":"Abrir","Cancel your video q&a request":"Cancelar sua solicitação de P&R em vídeo","Pending...":"Pendente...","Leave Stage":"Sair do palco","Raise Hand":"Levantar a mão","Text Q&A":"P&R em texto","Video Q&A":"P&R em vídeo","Loading Q&amp;A":"Carregando perguntas e respostas","Please wait while we fetch the Q&amp;A":"Aguarde enquanto buscamos as perguntas e respostas","Uh oh.. we couldn\'t load the content":"Ih, não conseguimos carregar o conteúdo","No Questions Yet":"Nenhuma pergunta ainda","Tell your audience to send in questions!":"Peça para o público mandar perguntas.","Be the first to ask a question!":"Faça a primeira pergunta.","Tell your audience to raise their hand!":"Peça para o público levantar a mão.","Approve":"Aprovar","Reject":"Rejeitar","End":"Encerrar","RELOAD":"RECARREGAR","Logos On Stage":"Logotipos no palco","No File Chosen":"Nenhum arquivo selecionado","loading":"carregando","Can\'t publish a slide when there is something else being presented on stage":"Não é possível publicar um slide enquanto ocorre uma apresentação no palco","Change Deck":"Trocar apresentação","stop-screen-share":"parar compartilhamento","screen-share":"compartilhamento de tela","Select a deck to begin presenting":"Selecione uma apresentação para começar","CONFIRM":"CONFIRMAR","If you’re having issues, please refer to the":"Se você tiver problemas, consulte a","SPEAKER":"ALTO-FALANTE","Issue Testing Audio!":"Ocorreu um erro ao testar o áudio.","VPN and adblockers may cause video issues, please disable them before proceeding":"O uso de VPN e bloqueadores de anúncios pode causar problemas no vídeo. Desative esses recursos antes de continuar","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"Nota: como bloqueadores de anúncios e VPN podem causar problemas no vídeo, garanta que eles estejam desativados durante a transmissão","Follow":"Seguir","Read More":"Saiba mais","Ask a question":"Perguntar","Shared":"Compartilhada","Answered":"Respondida","Waiting Approval":"Aguardando aprovação","cancel":"cancelar","ENTER":"ENTRAR","Upcoming Events":"Próximos eventos","Past Events":"Eventos anteriores","Goldcast":"Goldcast","MANAGE EVENT":"GERENCIAR EVENTO","Edit Profile":"Editar perfil","Stay tuned!":"Fique por dentro","Sign-in instructions will be available here 12 hours prior to the event":"As instruções de acesso serão disponibilizadas aqui 12 horas antes do evento","Please log out":"Desconecte-se","Logout":"Desconectar","Continue as {differentUser}":"Continuar como {differentUser}","You are already logged in as {user}.":"Você já fez login como {user}.","EMAIL":"E-MAIL","user@email.com":"user@email.com","FIRST NAME":"NOME","First Name":"Nome","LAST NAME":"SOBRENOME","Last Name":"Sobrenome","You are not registered to this event":"Você não se registrou neste evento","Please enter your email and name":"Informe seu e-mail e nome","Please enter your email":"Informe seu e-mail","We have sent a secret code to":"Um código secreto foi enviado para","BACK":"VOLTAR","Didn\'t receive an email? Make sure to check spam list":"Não recebeu o e-mail? Não se esqueça de verificar a pasta de spam","Resend Mail":"Reenviar e-mail","SECRET CODE":"CÓDIGO SECRETO","Please enter the temporary password sent to your email":"Insira a senha temporária que foi enviada para seu e-mail","NEW PASSWORD":"NOVA SENHA","Please enter a new password":"Insira uma senha nova","CONFIRM PASSWORD":"CONFIRMAR SENHA","Please re-enter the new password":"Insira novamente a senha nova","Password length should be atleast 8":"A senha deve ter pelo menos 8 caracteres","Password and Confirm Password don\'t match !!":"As informações em Senha e Confirmar senha não são as mesmas.","Please enter your password to continue":"Insira sua senha para continuar","Logging you in...":"Conectando você...","PASSWORD":"SENHA","Forgot credentials?":"Esqueceu as credenciais?","Forgot Password? A mail will be sent to your registered email.":"Esqueceu a senha? Um e-mail será enviado para o endereço registrado.","Email cannot be blank!!":"O e-mail não pode ficar em branco.","We have sent a secure login link to":"Um link de login seguro foi enviado para","from":"de","Please use that to access your event.":"Use-o para acessar seu evento.","Please check spam/promotion too if you can\'t find it.":"Veja também a pasta de spam/promoções, caso não consiga encontrar o e-mail.","Thank You !":"Obrigado!","The link is not valid.":"O link não é válido.","Please be patient.":"Tenha um pouco de paciência.","We are verifying your link.":"Estamos verificando seu link.","Thank you for entering the code!":"Agradecemos por informar o código.","Please create a new password":"Crie uma senha nova","Signing you up...":"Fazendo sua inscrição...","We have sent a temporary password to":"Uma senha temporária foi enviada para","TEMPORARY PASSWORD":"SENHA TEMPORÁRIA","Please enter the temporary password sent to your mail":"Insira a senha temporária que foi enviada para seu e-mail","Password Length should be 8":"A senha deve ter 8 caracteres","Okay":"OK","Backstage: {title}":"Bastidores: {title}","Prep Area":"Área de preparação","Starting at {time}":"Começa às {time}","person":"pessoa","inside":"dentro","No one is inside":"Ninguém chegou ainda","This area is for you to sync up with your fellow speakers before you go on stage.":"Nesta área, você confere os últimos detalhes com outros palestrantes antes de entrar no palco.","This area is for you to check your cam and mic before you enter the room.":"Nesta área, você testa sua câmera e seu microfone antes de entrar na sala.","I\'m Ready":"Tudo pronto!","Watch Live":"Assistir ao vivo","Backstage":"Bastidores","You are sharing your screen":"Você está compartilhando sua tela","LIVE":"AO VIVO","Live":"AO VIVO","Virtual":"Virtual","Only available for ":"Disponível somente para ","See Booths":"Ver estandes","See Rooms":"Ver salas","Enter Backstage":"Entrar nos bastidores","This track has no upcoming sessions. Check out a different track.":"Esta lista não tem nenhuma sessão futura. Veja outra lista.","View":"Visualizar","Agenda":"Programação","Scroll to see all tracks":"Role para ver todas as listas","No Agenda Items to show!":"Não há itens da programação para mostrar.","ENTER EVENT":"ENTRAR NO EVENTO","change":"trocar","Upload":"Fazer upload","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF OU PNG. MÁX. 5 MB","Create Profile":"Criar perfil","Email":"E-mail","Company":"Empresa","Title":"Título","No matching locations found":"Nenhum local correspondente encontrado","You can try searching for the location with another keyword":"Tente procurar o local usando outra palavra-chave","Interest Tags":"Tags de interesse","Pick your first tag":"Escolha sua primeira tag","Save":"Salvar","Searching...":"Pesquisando...","Twitter":"Twitter","Select Your First Tags":"Selecionar suas primeiras tags","Add Interest tags":"Adicionar tags de interesse","Congratulations!":"Bom trabalho!","Your first Goldcast event is set up":"Seu primeiro evento Goldcast está organizado","You can always visit":"Você sempre pode acessar","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"para ver instruções sobre como preparar e realizar seus eventos","See My Event":"Ver meu evento","Peak Community":"Peak Community","Loading Lite Mode... This may take up to 30s":"Carregando modo lite... Isso pode levar até 30s","Loading Video...":"Carregando vídeo...","Video will begin at session start time":"O vídeo começará no horário de início da sessão","TIME":"HORÁRIO","TITLE":"TÍTULO","STATUS":"STATUS","END":"FIM","START":"INÍCIO","AGENDA":"PROGRAMAÇÃO","Enable Audio":"Ativar áudio","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"O áudio foi silenciado por causa das políticas de reprodução automática do navegador. Clique em ativar abaixo para reativar o áudio. Você também pode fazer isso depois nos controles integrados.","Enable":"Ativar","You are being redirected outside the room. Would you like to continue?":"Você será redirecionado para fora da sala. Deseja continuar?","Continue":"Continuar","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"Uma alternativa é usar o modo lite, que tem um atraso de 30s em relação à transmissão ao vivo","We detected a network issue":"Detectamos um problema na rede","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Certifique-se de que sua conexão não é feita por meio de uma VPN ou um firewall. Tente trocar de rede, navegador ou dispositivo se o problema continuar.","Could not connect":"Não foi possível conectar","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"Isso pode ter sido causado por um problema de rede segura ou no navegador/dispositivo. Tente trocar de rede, navegador ou dispositivo se o problema continuar","Switch to Lite Mode":"Alternar para modo lite","Leave":"Sair","Screenshare had an issue":"Problema no compartilhamento de tela","Could not share screen unexpectedly. Refresh & retry. On mac go to":"Não foi possível compartilhar a tela. Atualize e tente novamente. No Mac, acesse","and check if your browser has the required permission":"e confirme se o navegador tem a permissão necessária","Uh OH... Something went wrong":"Ih... Parece que algo deu errado","To fix this, click the":"Para corrigir, clique em","in your URL bar, then select “Allow”, and then click “Try Again”":"na barra de URL, selecione “Permitir” e clique em “Tentar novamente”","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"Um motivo desconhecido impediu a inicialização da sua transmissão de mídia. É possível que o navegador usado não seja compatível com a nossa plataforma. Recomendamos usar o Google Chrome. Se o problema continuar, entre em contato com o Suporte da Goldcast","To fix this, make sure your":"Para corrigir, verifique se","is not being accessed by any other app. If not, please try changing your":"não é acessado por outro aplicativo. Se esse não for o caso, tente mudar seus","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"dispositivos clicando em \\"Acessar configurações\\". Após resolver o possível problema, clique em “Tentar novamente”.","Go To Settings":"Acessar configurações","Try Again":"Tentar novamente","Try Joining without Video":"Tentar entrar sem vídeo","A refresh and rejoin should work":"Experimente atualizar e entrar novamente. Isso deve resolver","Refresh & Rejoin":"Atualizar e entrar novamente","Start Chat":"Começar bate-papo","On Stage":"No palco","Connect your on-site camera and microphone to present to your virtual attendees":"Conecte a câmera e o microfone do local para fazer sua apresentação para os participantes virtuais","Stop Streaming":"Parar de transmitir","Start Streaming":"Começar a transmitir","Set up on-site video feed":"Preparar feed de vídeo no local","Open TV":"Abrir TV","Layout: {layout} ":"Layout: {layout} ","With Speaker Videos":"Com o vídeo dos palestrantes","Full Screen":"Tela cheia","No Speakers":"Sem palestrantes","Turn Off Setup Mode":"Desativar modo de preparação","Setup Mode":"Modo de preparação","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"Pressione desativar caso queira parar o modo de preparação para {roomTitle}. Isso também desativará qualquer transmissão ativa.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"Preparando a transmissão: {roomTitle}. Use o modo de preparação apenas para transmitir de um local ao vivo.","Starting in {duration}":"Começa em {duration}","Can\'t share screen while there is something else being presented on stage":"Não é possível compartilhar a tela enquanto ocorre uma apresentação no palco","You are now in attendee view!":"Agora você está na exibição de participante.","You are now in organizer view!":"Agora você está na exibição de organizador.","Note :":"Nota:","Only organizer accounts can see this tag, normal attendees can’t see this":"Apenas contas de organizadores podem ver esta tag. Participantes comuns não conseguem vê-la","Attendee":"Participante","Event Information":"Informações sobre o evento","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"Somente os organizadores podem ver as informações do evento. <br /> Esta seção não está visível para os participantes","Operating System":"Sistema operacional","Secondary Booths":"Estandes secundárias","Sort":"Ordenar","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"Seguir {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2}automaticamente fará você parar de seguir{track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}Deseja continuar?","Track only available for {tracks}":"Trilha disponível apenas para {tracks}","Add to Calendar":"Adicionar ao calendário","Open Speakers Control Panel":"Abrir painel de controle para palestrantes","Move Offstage ↓":"Mover para fora do palco ↓","Error Moving ⚠":"Erro ao mover ⚠","Off Stage":"Fora do palco","Move to Stage":"Mover para o palco","An error occurred!":"Ocorreu um erro.","{eventName} Documents":"Documentos de {eventName}"," Set Up Mode":" Configurar modo","Camera & Mic blocked":"Câmera e microfone bloqueados","Camera/Mic Inaccessible":"Câmera/Microfone inacessível","Camera/Mic Not Found":"Câmera/Microfone não encontrado","Camera Inaccessible":"Câmera inacessível","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"A câmera está em uso ou a resolução não é compatível. Confirme se outro aplicativo não está usando a câmera e tente novamente.","No microphone/camera is found":"Nenhum microfone/câmera encontrado","The browser does not support using camera and microphone!":"O navegador não é compatível com o uso de câmera e microfone.","{n} Slides":"{n} slides","Starting in {timeduration}":"Começa em {timeduration}","{eventtitle} has ended":"{eventtitle} terminou","This is a text q&a question!":"Esta é uma pergunta em texto!","Click here{if_it_does_not}":"Clique aqui{if_it_does_not}","{click_here}if it does not":"{click_here}em caso contrário","{title}up next":"{title}a seguir","seat(s) open":"lugar(es) disponível(eis)","Signal strength is low. Close other windows or connect to a different network.":"A intensidade do sinal está baixa. Feche outras janelas ou conecte-se a outra rede.","GO BACKSTAGE":"ACESSAR BASTIDORES","LEAVE STAGE":"Sair do palco","LEAVE":"Sair","This event begins on{startitme}":"Este evento começa em {startitme}","Please refresh to enter.":"Atualize para entrar.","people":"Pessoas","Oops, Something went wrong":"Ih… algo deu errado.","Back Home":"Voltar para a tela inicial","Deciding where to go ...":"Decidindo aonde ir","Go to Event Hub":"Acessar a Central do Evento","CREATE":"CRIAR","Attending Virtually":"Participação virtual","Attending In Person":"Participação presencial","Click to change your attendance type":"Clique para mudar o tipo de participação","Open Chat":"Abrir bate-papo","Create your profile for {eventtitle}":"Crie seu perfil para {eventtitle}","Move to stage":"Mover para o palco","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"A organização do evento solicitou que você fosse ao palco como <strong>{broadcastTitle}</strong>.<br /><br />Se aceitar a solicitação, você ficará ao vivo e estará visível para os participantes.<br /><br />","Go Live On Stage":"Entrar no palco ao vivo","Moved to backstage":"Transferência para os bastidores concluída","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"A organização retirou você do palco. Por gentileza, não tente entrar novamente antes de contatar a organização.","Error creating Screen stream":"Erro ao criar a transmissão de tela","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"A permissão para compartilhar a tela não foi concedida. *Clique aqui* para ver os documentos de solução de problemas.","Error publishing stream":"Erro ao publicar a transmissão","Could not publish stream. Please refresh and try again!":"Não foi possível publicar a transmissão. Atualize e tente novamente.","Error publishing screen":"Erro ao publicar a tela","Error publishing screen. Please refresh and try again!":"Erro ao publicar a tela. Atualize e tente novamente.","Error unpublishing stream":"Erro ao cancelar a publicação da transmissão","Error unpublishing stream. Please refresh and try again!":"Erro ao cancelar a publicação da transmissão. Atualize e tente novamente.","Invalid Publish Operation":"Operação de publicação inválida","{username} profile picture":"Foto de perfil de {username}","Default":"Padrão","A-Z":"A-Z","Random":"Aleatório","All":"Tudo","Past":"Antigos","Upcoming":"Futuros","Learn More":"Saiba mais","close":"Fechar","Discussion Rooms":"Salas de debate","ATTENDEE MODE":"MODO DE PARTICIPANTE","Loading...":"Carregando...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"O navegador desativou o dispositivo ou as permissões de uso não foram concedidas. Conceda as permissões e clique em \\"Tentar novamente\\".","You are now registered. You will receive an email confirming details shortly.":"Você realizou sua inscrição. Em instantes, você receberá um e-mail confirmando os detalhes.","Streaming to Virtual Users from on-site video feed":"Transmitindo feed de vídeo do local para usuários virtuais","Ending in ":"Terminando em ","GO LIVE":"ENTRAR AO VIVO","You have no past events.":"Você não tem eventos anteriores.","You have no upcoming or live events.":"Você não tem eventos futuros ou eventos ao vivo.","left":"esquerda","center":"centro","right":"direita","top":"superior","bottom":"inferior","loading...":"carregando...","Loading ...":"Carregando...","Failed to redirect!":"Falha ao redirecionar.","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"Parece que há um bloqueador de anúncios ativo. Isso pode impedir que você tenha a melhor experiência possível. Por gentileza, desative-o. <br />&lt;br / &gt; Se precisa de ajuda para fazer isso, clique <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>aqui</a> para acessar mais informações.","redirecting in {duration}":"redirecionando em {duration}","STOP VIDEO":"PARAR VÍDEO","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"Você está prestes a parar de exibir este vídeo. Sua transmissão voltará ao modo ao vivo. Seu público voltará a ver você e os palestrantes. Tem certeza?","STOP SHARING":"Interromper compartilhamento","No Next Slide":"Nenhum slide seguinte","Next Slide":"Slide seguinte","No Previous Slide":"Nenhum slide anterior","Previous Slide":"Slide anterior","something went wrong while recording the response please try again":"Alguma coisa deu errado ao registrar a resposta. Tente novamente","Start In-Person Streaming":"Iniciar transmissão presencial","Stop In-Person Streaming":"Parar transmissão presencial","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Seu vídeo está sendo armazenado em buffer, e a sessão de teste começará em breve. Isso não acontecerá durante a sessão real.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"O marcador aparecerá na parte superior da página da web para todos os participantes. Para transformar o marcador em um hiperlink, insira o URL abaixo.","Allow {key}":"Permitir {key}","{messageType} can only be published from inside a broadcast.":"Só é possível publicar {messageType} de dentro de uma transmissão.","To grant {deviceName} access to this page, follow the two steps below:":"Para conceder a {deviceName} acesso a esta página, siga as duas etapas abaixo:","2. Allow {deviceName} access and then refresh the page.":"2. Permita o acesso de {deviceName} e, em seguida, recarregue a página."}');

/***/ }),

/***/ 8809:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Выпадающее меню с настройками мероприятия"," Stage Control":" Управление сценой","Stage Controls and Information":"Информация и элементы управления сценой","Live in ":"В эфире через ","Start Session":"Начать сеанс","End Session":"Завершить сеанс","Present Screen":"Показать экран","Rehearse On Stage":"Репетиция на сцене","Turn on Microphone":"Включить микрофон","Turn off Microphone":"Выключить микрофон","Turn on camera":"Включить камеру","Turn off camera":"Выключить камеру","rehearsal mode":"режим репетиции","People Watching: ${watchCount}":"Зрителей: ${watchCount}","Turn on Audio":"Включить звук","Turn off Audio":"Выключить звук","Are you sure you want to leave this room?":"Вы точно хотите покинуть эту комнату?","you will be redirected to stage in":"вы будете перенаправлены на сцену через","sec. . ":"сек. ","Skip to Main Navigation":"Перейти к основной навигации","Skip to Chat":"Перейти к чату","Skip to Meeting Controls":"Перейти к управлению совещанием","LinkedIn":"LinkedIn","Live in":"В эфире через","UPCOMING":"ДАЛЕЕ","Rehearse on stage":"Репетировать на сцене","Watch Rehearsal":"Просмотреть репетицию","Answered by:":"Автор ответа:","Speaker Off":"Колонка выкл.","Speaker On":"Колонка вкл.","Speaker Controls":"Управление докладчиками","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"Все элементы сцены скрыты за общим изображением. Вы увидите их вновь, когда публикация в полный экран будет остановлена.","Close Ticker Popup":"Закрыть всплывающее окно бегущей строки","Open GIF Picker":"Открыть меню гифок","Open Emoji Picker":"Открыть меню эмодзи","Send Message":"Отправить сообщение","Tabs: Messaging and More":"Вкладки: сообщения и не только","Thanks for attending!":"Спасибо за участие!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" В секции, на которую вы подписаны, нет предстоящих сеансов. Попробуйте переключиться на другую секцию.","Redirecting you to ":"Перенаправляем вас сюда: ","in ":"через ","seconds":"сек.","Main Navigation":"Основная навигация","YOU ARE HERE":"ВЫ ЗДЕСЬ","Live Now":"В прямом эфире","SUBMIT":"ОТПРАВИТЬ","Allocated time for engagement has ended. You will be redirected to main stage":"Время, выделенное на взаимодействие, истекло. Вы будете перенаправлены на основную сцену.","Wrap up in":"Пора закругляться через","Session overrun by":"Время сеанса превышено на","Ending in":"Закончится через","Bring this session live?":"Перевести сеанс в прямой эфир?","START SESSION":"НАЧАТЬ СЕАНС","Bring this session to end?":"Завершить сеанс?","END SESSION":"ЗАВЕРШИТЬ СЕАНС","Go On Stage":"Выйти на сцену","Muted by organizer":"Звук отключен организатором","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"Один из организаторов мероприятия отключил вам звук. Его можно включить с помощью кнопки «Микрофон».","Gifs":"Гифки","Stickers":"Стикеры","Launch Survey":"Запустить опрос","Microphone is on":"Микрофон включен","Microphone is off":"Микрофон выключен","Secret Code’s length should be 6 digits":"Секретный код должен состоять из 6 цифр","Closing in 00:":"Закроется через 00:","Submit":"Отправить","Questions":"Вопросы","Preview":"Предпросмотр","Close Survey":"Закрыть опрос","This is a required question":"Это обязательный вопрос","Enter the text you’d like to present on stage below.":"Введите ниже текст, который хотите показать на сцене.","Use Chrome/Edge for best performance":"Для оптимальной работы рекомендуем Chrome/Edge","Do you want to launch your survey now?":"Хотите запустить опрос сейчас?","Success! Your Survey has been launched for attendees.":"Готово! Ваш опрос запущен для участников.","Unable to publish. Please try again.":"Ошибка публикации. Повторите попытку.","Are you sure you want to close this survey?":"Вы точно хотите закрыть этот опрос?","Success! Your Survey has been closed for attendees.":"Готово! Опрос закрыт для участников.","Unable to un-publish. Please try again.":"Отменить публикацию не удалось. Повторите попытку.","Please answer all required questions.":"Пожалуйста, ответьте на все вопросы.","You have already submitted this survey.":"Вы уже отправили этот опрос.","Success! Thank you for your feedback.":"Готово! Благодарим вас за отзыв.","Unable to submit. Please try again.":"Ошибка отправки. Повторите попытку.","Launch surveys will take over attendees\' engagement panel.":"При запуске опрос займет панель взаимодействия в интерфейсе участников.","Closing this survey will remove it from attendees\' engagement panel.":"После закрытия опрос будет удален из панели взаимодействия в интерфейсе участников.","Survey":"Опрос","Updating Survey...":"Опрос обновляется...","Closing":"Закрытие","Goldcast needs access to your camera and microphone":"Goldcast нужен доступ к вашей камере и микрофону","Goldcast needs access to your microphone":"Goldcast нужен доступ к вашему микрофону","Goldcast needs access to your camera":"Goldcast нужен доступ к вашей камере","SPEAKERS":"ДОКЛАДЧИКИ","Mark as Unanswered":"Ответ не получен","Mark as Answered":"Ответ получен","Remove from Priority":"Снять пометку «Важно»","Mark as Priority":"Важно","Answer":"Ответить","Enter answer...":"Введите ответ...","Answered by":"Автор ответа:","Submit Answer":"Отправить ответ","Test your system’s speaker":"Тестировать колонки","Click \\"Yes\\" if you hear the sound.":"Если вы услышали звук, нажмите «Да».","Load previous":"Загрузить предыдущие","Hide Name":"Скрыть имя","Text Q&A is disabled in On Demand mode.":"В режиме «По запросу» отключены текстовые вопросы.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"Достигнут лимит текстовых вопросов. Участники не смогут задавать новые.","Sent to Q&A":"Отправлено в «Вопросы».","Couldn\'t post as Q&A. Please try again.":"Не удалось отправить вопрос. Повторите попытку.","Yes this is being recorded":"Да, ведется запись","No this is not being recorded":"Нет, запись не ведется","System\'s Speaker Check":"Проверка колонок системы","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"Чтобы во время мероприятия у вас не возникло проблем со звуком, убедитесь, что ваши колонки работают должным образом.","Click on “Test your system’s speaker” to proceed":"Чтобы продолжить, нажмите «Тестировать колонки».","Error while sharing message to screen. Post not found":"Ошибка публикации сообщения на экране. Пост не найден.","Lost connection to servers. Refresh your page to get live event experience.":"Утеряно соединение с серверами. Обновите страницу, чтобы смотреть прямой эфир.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"VPN/брандмауэр мешает процессу авторизации. Подключитесь к интернету или попросите ИТ-отдел разрешить <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>эти домены</a>, чтобы использовать Goldcast без проблем.","It\'s taking too long":"Этот процесс отнимает слишком много времени","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"Судя по всему, вы подключены через VPN или пользуетесь брандмауэром. Ознакомьтесь с <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>этим документом</a> и внесите в белый список домены, необходимые для бесперебойной работы Goldcast, либо подключитесь к другой сети.","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"Судя по всему, вы подключены через VPN или пользуетесь брандмауэром. Ознакомьтесь с <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>этим документом</a> и внесите в белый список домены, необходимые для бесперебойной работы Goldcast, подключитесь к другой сети или попробуйте смотреть сеанс в легком режиме.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"Сервис видеотрансляций Goldcast не может установить подключение из-за низкой пропускной способности сети. Чтобы смотреть прямые эфиры, подключитесь к другой сети.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"Сервис видеотрансляций Goldcast не может установить подключение из-за низкой пропускной способности сети. Чтобы смотреть прямые эфиры, перейдите в легкий режим или подключитесь к другой сети.","Most Upvotes":"Поддерживаемые","Most Recent":"Недавние","My Questions":"Мои вопросы","Prioritized":"Важные","Approved":"Одобренные","Unapproved":"Отклоненные","Unanswered":"Без ответа","Failed to update answer. Please try again!":"Обновить ответ не удалось. Повторите попытку.","Failed to post answer. Please try again!":"Опубликовать ответ не удалось. Повторите попытку.","Failed to delete question. Please try again!":"Удалить вопрос не удалось. Повторите попытку.","Survey Link":"Ссылка на опрос","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"Переключение приведет к перезагрузке страницы и переходу в режим участника. Чтобы вернуться в режим организатора, используйте переключатель в выпадающем меню профиля.","You haven\'t asked any questions yet":"Вы еще не задали ни одного вопроса.","No prioritized questions":"Важных вопросов пока нет","Create prioritized list of questions for speakers by marking questions as priority":"Используйте пометку «Важно», чтобы составить список приоритетных вопросов для докладчиков.","No Approved Questions":"Одобренных вопросов пока нет","Approve incoming questions to see list of approved questions":"Одобряйте вопросы по мере поступления, и они попадут в этот список.","No Unapproved Questions":"Отклоненных вопросов пока нет","No Answered Questions":"Ни один вопрос пока не получил ответа","Answer a question on stage or with inline text":"Отвечайте прямо на сцене или на панели вопросов.","All questions are answered":"На все вопросы получены ответы","Rate Your Experience":"Как впечатления?","How satisfied are you with Goldcast?":"Вы довольны работой Goldcast?","What are the main reasons for your rating?":"Что больше всего повлияло на вашу оценку?","I am interested in seeing a demo of Goldcast":"Я не против посмотреть демонстрацию Goldcast","Thank You":"Спасибо!","Your feedback was successfully submitted.":"Ваш отзыв отправлен.","Tell us how we can improve...":"Подскажите, как нам улучшить свой сервис...","1 Slide":"1 слайд","Your internet connection is unstable.":"У вас нестабильное интернет-соединение.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"Кажется, у вас отключен звук. Включите его с помощью значка микрофона.","The registration could not be completed! Please check that this email is allowed to register for the event.":"Ошибка регистрации! Убедитесь, что этот адрес допущен к записи на мероприятие.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Кажется, вы уже зарегистрированы на это мероприятие! Если письмо с подтверждением не пришло, попробуйте поискать его в папке «Спам». Если вам нужна дополнительная помощь, обратитесь к организатору мероприятия.","Your registration could not be completed. This event has reached its registration capacity.":"Ошибка регистрации! На мероприятие уже записалось максимум участников.","Image cannot be an svg":"Изображения в SVG не принимаются","This should be a valid linkedin url":"Требуется рабочая ссылка на LinkedIn","This should be a valid twitter url":"Требуется рабочая ссылка на Twitter","This should be a valid url":"Требуется допустимый URL-адрес","Video":"Видео","Read Less":"Свернуть текст","live":"прямой эфир","Opened":"Открыто","In person only":"Только лично","Stage Stream":"Трансляция сцены","Streaming not available":"Трансляция недоступна","Close TV":"Закрыть ТВ","Streaming is not available for prerecorded and RTMP sessions":"Трансляции не поддерживаются в предварительно записанных и RTMP-сеансах","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Подключите компьютер к экрану телевизора или проектору, чтобы посетители мероприятия могли видеть, что происходит на вашей виртуальной сцене, включая слайды, вопросы и ответы и так далее. Когда подключение будет установлено, нажмите «ОТКРЫТЬ ТВ» и опубликуйте или перетащите новое окно на проектор или экран телевизора. ","Close Setup Mode":"Закрыть режим настройки","Help":"Справка","upcoming":"на подходе","ended":"завершено","Remove from favorites":"Удалить из «Избранного»","Add to favorites":"Добавить в «Избранное»","PLAY RECORDING":"ПРОИГРАТЬ ЗАПИСЬ","VIEW RECORDING":"ПРОСМОТРЕТЬ ЗАПИСЬ","VIEW RECORDINGS":"ПРОСМОТРЕТЬ ЗАПИСИ","Virtual Backgrounds":"Виртуальные фоны","No Device Available":"Доступных устройств нет","Needs permission":"Требуется разрешение","Device not detected":"Устройство не обнаружено","Camera is on":"Камера включена","Camera is off":"Камера выключена","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"Эффект отражения не повлияет на зрителей. Для них видео не отражается.","Mirror My Video":"Отразить мое видео","Camera":"Камера","1. Click on Safari > Settings for this\\n            website":"1. Нажмите Safari > «Настройки [название нашего сайта]»","1. Click the lock":"1. Нажмите на значок","icon in your browser’s address bar":"замка в адресной строке браузера","3. Unmute":"3. Включите звук","and":"и","icons from stage control panel":"значки на панели управления сцены","icon from stage control panel":"значок на панели управления сцены","2. Set camera and microphone to “Allow”.":"2. Разрешите доступ к камере и микрофону.","2. Set camera to “Allow”.":"2. Разрешите доступ к камере.","2. Set microphone to \\"Allow\\"":"2. Разрешите доступ к микрофону.","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. Выберите вариант «Всегда предоставлять Goldcast доступ к камере и микрофону».","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. Выберите вариант «Всегда предоставлять Goldcast доступ к камере».","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. Выберите вариант «Всегда предоставлять Goldcast доступ к микрофону».","Questions?":"Есть вопросы?","If you’re having issues, check out our comprehensive":"Если у вас возникнут сложности, загляните в нашу подробную","help docs":"справочную документацию","Speaker is on":"Колонка включена","Stop Test":"Остановить тест","Test your system’s audio":"Тестировать звук системы","Still can\'t hear any sound?":"По-прежнему ничего не слышите?","Microphone":"Микрофон","Audio is being played in system\'s default audio device.":"Воспроизведение выполняется через звуковое устройство системы по умолчанию.","Click to view/change audio device":"Просмотреть/изменить звуковое устройство","Speaker":"Колонка","Play Recording":"Проиграть запись","Recording for this broadcast is currently being processed and will be available soon":"Запись трансляции обрабатывается и будет доступна совсем скоро.","You haven\'t favorited anything yet!":"Вы еще ничего не добавили в «Избранное»!","Add an item to favorites by selecting the ♡ in the top right corner.":"Добавьте что-нибудь в «Избранное» с помощью значка ♡ в правом верхнем углу.","Session has ended":"Сеанс завершен","System Check":"Проверка системы","Need help? Check out the":"Нужна помощь? Загляните в","Skip Checks and Continue":"Пропустить проверки и продолжить","Click the button above to run the test":"Запустите тест нажатием кнопки выше","Test Screenshare":"Тестировать демонстрацию экрана","Share message to stage":"Сообщение на сцену","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"Введите текст для бегущей строки в поле ниже. Чтобы превратить текст в гиперссылку, введите URL.","Ticker":"Бегущая строка","Coffee Break! Be back in 10m.":"Перерыв на кофе! Вернемся через 10 минут.","Enter Message":"Введите сообщение","https://www.xyz.com":"https://www.xyz.com","Launch":"Запустить","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Благодарим вас за вопросы! Как только один из них одобрят, вы сможете отправить еще один.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"К сожалению, раздел «Вопросы» сейчас закрыт. Когда его откроют, вы сможете отправить свой вопрос.","Votes":"голос.","Vote":"Голосовать","is inviting you to a video call":"приглашает вас пообщаться по видеосвязи","ENTER ROOM":"ВОЙТИ В КОМНАТУ","Start the conversation!":"Начните разговор!","Couldn\'t send message. Click here to retry.":"Отправить сообщение не удалось. Повторить попытку","Couldn\'t add emoji. Please try again.":"Добавить эмодзи не удалось. Повторите попытку.","Couldn\'t remove emoji. Please try again.":"Удалить эмодзи не удалось. Повторите попытку.","Couldn\'t delete message. Please try again.":"Удалить сообщение не удалось. Повторите попытку.","Couldn\'t pin message. Please try again.":"Закрепить сообщение не удалось. Повторите попытку.","Couldn\'t unpin message. Please try again.":"Открепить сообщение не удалось. Повторите попытку.","Today":"Сегодня","No messages yet":"Сообщений пока нет","Messages from organizers and speakers appear here!":"Сообщения от организаторов и докладчиков появятся здесь!","Next Session is Starting":"Начинается следующий сеанс","Go to Next Session":"К следующему сеансу","I’d like to stay":"Предпочитаю остаться","My favorites":"Мое избранное","1. Click on the lock icon in your address bar":"1. Нажмите на значок замка в адресной строке","We recommend organizers and speakers use a desktop\\n        device":"Рекомендуем организаторам и докладчикам пользоваться настольными устройствами.","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"Для удобства аудитории организаторы и докладчики должны использовать Goldcast на настольном компьютере. Трансляция с мобильного устройства негативно скажется на качестве.","Watch Now":"Смотреть","Video progress time":"Отсмотренное время","Total video duration":"Общая длина видео","Rate Goldcast!":"Оцените Goldcast!","Running Required Checks...":"Выполняются необходимые проверки...","Test Your Setup":"Протестируйте настройку","Test your Computer Device, Microphone and Camera before you join the event":"Прежде чем подключиться к мероприятию, протестируйте работу компьютера, микрофона и камеры.","Speaker and microphone not working?":"Не работают колонка и микрофон?","Passed":"В норме","Fix Audio Issues":"Устраните проблемы со звуком","Check if audio is being played in other sound devices connected to phone/tablet":"Возможно, звук воспроизводится на других устройствах, подключенных к телефону/планшету.","Check if correct audio device is chosen from the below dropdown":"Проверьте, то ли звуковое устройство выбрано из выпадающего списка ниже.","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"Проверьте <a href=\'ms-settings:sound\'>здесь</a>, правильно ли выбрано устройство для воспроизведения звука.","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"Проверьте <a href=\'x-apple.systempreferences:com.apple.preference.sound\'>здесь</a>, правильно ли выбрано устройство для воспроизведения звука.","Right click on the browser tab & click “Unmute Site”":"Щелкните по вкладке браузера правой кнопкой мышки и выберите опцию «Включить звук».","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Проверьте, не отключен ли звук во вкладке браузера, или нажмите «Окно» > «Включить звук на вкладке».","System Check Failed!":"Система не прошла проверку!","System Check Passed!":"Система успешно прошла проверку!","Complete checks to proceed":"Выполните проверки, чтобы продолжить","Enter Event":"Войти на мероприятие","Skip Screen Sharing Check? ":"Пропустить проверку демонстрации экрана? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"Если во время мероприятия вы планируете демонстрировать экран, рекомендуем заранее протестировать эту функцию.","Ignore & Enter Event":"Проигнорировать и войти","Test screenshare":"Тестировать демонстрацию экрана","Retry Now":"Повторить попытку","SHARE":"ПОДЕЛИТЬСЯ","Rooms Closed":"Комнаты закрыты","Discussion rooms are now closed. You are being redirected to the Stage.":"Переговорные комнаты закрыты. Мы перенаправим вас на сцену.","Return To Stage":"Вернуться на сцену","Unrecognized embedded widget provider - ":"Поставщик встроенного виджета не распознан - ","Room Ended":"Комната закрыта","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"Организатор мероприятия закрыл все комнаты. Мы перенаправим вас на сцену.","Video Q&A Request Cancelled":"Заявка на вопросы по видео отменена","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Ваша заявка на вопросы и ответы по видео была отменена, так как вы смотрите трансляцию в легком режиме. Перейдите в живой режим и поднимите руку снова.","Camera Passed":"Камера в норме","Camera Error":"Ошибка камеры","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"В браузере не выданы права доступа к камере. Нажмите «Открыть доступ к камере».","Camera permissions aren’t granted from system. Click “Allow Camera”":"В системе не выданы права доступа к камере. Нажмите «Открыть доступ к камере».","Uh-oh! Error occurred while creating camera stream":"Ой! При создании трансляции с камеры произошла ошибка.","Close other applications which might use camera stream":"Закройте другие приложения, которые могут задействовать трансляцию с камеры.","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"Проверьте, есть ли у браузера доступ к камере, <a href=\'ms-settings:privacy-webcam\'>здесь</a>.","Microphone Passed":"Микрофон в норме","Microphone Error":"Ошибка микрофона","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"В браузере не выданы права доступа к микрофону. Нажмите «Открыть доступ к микрофону».","Mic permissions aren’t granted from system. Click “Allow Microphone”":"В системе не выданы права доступа к микрофону. Нажмите «Открыть доступ к микрофону».","Uh-oh! Error occurred while creating mic stream":"Ой! При создании трансляции с микрофона произошла ошибка.","Close other applications which might use mic stream":"Закройте другие приложения, которые могут задействовать трансляцию с микрофона.","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"Проверьте, есть ли у браузера доступ к микрофону, <a href=\'ms-settings:privacy-microphone\'>здесь</a>.","Speaker and Microphone Error":"Ошибка колонки и микрофона","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"Чтобы показать список колонок, подключенных к системе, требуется доступ к микрофону. Нажмите «Открыть доступ к микрофону».","It seems mic is being used by other application. Close other applications to proceed.":"Похоже, что другое приложение также пользуется микрофоном. Закройте другие приложения, чтобы продолжить.","Camera & Microphone Error":"Ошибка камеры и микрофона","To enable permissions, click the Allow Camera & Mic button below":"Для выдачи необходимых разрешений нажмите кнопку «Открыть доступ к камере и микрофону» ниже","Network Connection":"Подключение к интернету","Check Passed":"Проверка прошла успешно","Could not establish a network connection":"Не удалось установить соединение с интернетом","Connect to a different network, or use a mobile hotspot.":"Подключитесь к другой сети или используйте мобильный хот-спот.","Disable any VPN or firewall is connected.":"Отключите VPN или брандмауэр.","Connection: Good":"Качество связи: хорошее","Network Connection Error":"Ошибка сетевого подключения","Can’t connect to network. Change your network or limited functionality will be available during event.":"Не удалось подключиться к интернету. Перейдите на другую сеть, иначе возможности платформы во время мероприятия будут ограничены.","AdBlocker":"Блокировщик рекламы","AdBlocker not detected.":"Блокировщиков рекламы не обнаружено.","AdBlocker detected. This may degrade your event experience.":"Обнаружен блокировщик рекламы. Он может понизить качество работы платформы.","Disable adblocker for best experience.":"Для оптимального результата отключите блокировщик рекламы.","You are using ":"Вы используете ","Use Windows or Mac OS for best performance":"Для оптимальной работы требуется Windows или Mac OS","Browser Check":"Проверка браузера","Check Passed.":"Проверка прошла успешно.","Switch To Lite Mode":"Перейти на легкий режим","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Переход на легкий режим приведет к отмене вашей заявки на вопросы и ответы по видео.","Stay on Live Mode":"Остаться в легком режиме","Unable to mark as favorite":"Не удалось добавить в «Избранное»","Event organizers must enter the event to select favorites.":"Чтобы выбрать «Избранное», организаторы должны войти на мероприятие.","Make an Announcement":"Сделать объявление","STOP":"ОСТАНОВИТЬ","InPerson CheckIn App":"Приложение для очной регистрации","App to Check-In In-Person attendees":"Приложение, где участники могут лично зарегистрироваться по прибытии","SEE AGENDA":"ОТКРЫТЬ ПОВЕСТКУ ДНЯ","Please visit the Agenda tab to view the session recordings":"Записи сеансов можно просмотреть во вкладке «Повестка дня»","The session recordings will be available soon in the Agenda tab":"Записи сеансов скоро появятся во вкладке «Повестка дня»","FAILED!":"ОШИБКА!","Next session is beginning":"Начинается следующий сеанс","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"Хотите перейти к следующему сеансу? Ваша трансляция продолжится, а на вашем телевизоре будет показан следующий сеанс.","Banners":"Баннеры","Images":"Изображения","Screen Share":"Демонстрация экрана","Browser might not have screen-recording permission on your computer.":"Возможно, у вашего браузера нет разрешения вести запись с экрана.","Open System Preferences":"Открыть системные настройки","Error publishing screen because someone else started screen share already.":"Опубликовать экран не удалось, так как кто-то другой уже начал демонстрацию экрана.","Live Feed":"Прямая трансляция","Check Your Network":"Проверьте подключение","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"При воспроизведении видео была обнаружена ошибка! Если возникнут проблемы с видео, попробуйте перезагрузить страницу или перейдите в легкий режим.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"При воспроизведении видео была обнаружена ошибка! Если у вас возникли проблемы с видео, попробуйте перезагрузить страницу.","All Dates":"Все даты","All Tracks":"Все секции","Create Ticker":"Создать бегущую строку","Booths Closed":"Стенды закрыты","Your event organizer has closed all the booths. You will now be redirected to the stage":"Организатор мероприятия закрыл все стенды. Мы перенаправим вас на сцену.","Visit the Polls tab to view live results.":"Результаты в реальном времени приведены во вкладке «Голосование».","A new poll is open! Visit the Polls tab to vote.":"Открылось новое голосование! Примите участие в одноименной вкладке.","Vote for Polls":"Участвуйте в голосовании!","Go to Polls Tab":"Открыть вкладку «Голосования»","Microphone audio too low":"Слишком низкая громкость микрофона","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"Обнаружена проблема со звуком. Если ошибка повторится, рекомендуем выключить и вновь включить звук либо использовать другое устройство.","Audio/Video bitrate too low":"Слишком низкий битрейт звука/видео","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"Настройки вашего сетевого брандмауэра блокируют аудио- и видеотрансляции. Рекомендуем подключиться к другой сети.","Error sharing screen":"Ошибка демонстрации экрана","A network error occurred while sharing screen. Please check your network connection.":"При попытке продемонстрировать экран произошла ошибка подключения. Проверьте соединение с интернетом.","Apologies, due to some errors, we need to refresh the page!":"Мы вынуждены обновить эту страницу в связи с ошибками. Приносим извинения!","Warning":"Внимание!","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"Обнаружена проблема с видео. Попробуйте закрыть другие вкладки браузера или другие приложения на устройстве. Также рекомендуем проверить соединение с интернетом или подключиться к более быстрой сети.","No results found":"Ничего не найдено","Audio":"Звук","Please choose another microphone and camera":"Выберите другой микрофон и камеру","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"Микрофон и камера, которые выбраны у вас сейчас, не работают. Выберите другие устройства из выпадающего списка ниже.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"Камера, которая выбрана у вас сейчас, не работает. Выберите другую из выпадающего списка ниже.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"Вы можете продолжить и без камеры, однако, чтобы трансляция прошла без перебоев, рекомендуем разрешить этот конфликт.","Please choose another microphone":"Выберите другой микрофон","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"Микрофон, который выбран у вас сейчас, не работает. Выберите другой из выпадающего списка ниже.","Please check that your TV speaker is correct":"Убедитесь, что ТВ-колонка указана верно","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"Колонка, которая выбрана у вас сейчас, не работает. Выберите другую из выпадающего списка ниже.","Your answer":"Ваш ответ","Edit":"Изменить","Delete":"Удалить","Settings":"Настройки","Signing Out":"Выполняется выход","Confirming your account...":"Учетная запись подтверждается...","Something Went Wrong. Please Retry :(":"Что-то пошло не так. Повторите попытку :(","Resending Mail":"Повторная отправка","offline":"офлайн","I am inviting you to a video meeting:":"Приглашаю на видеоконференцию:","Resending secure login link to your email":"Заново отправляем вам на почту безопасную ссылку для входа","Sending secure login link to your email":"Отправляем вам на почту безопасную ссылку для входа","Something went Wrong. Please Retry :(":"Что-то пошло не так. Повторите попытку :(","Updating your password":"Пароль обновляется","Sending mail":"Письмо отправляется","Verifying":"Выполняется подтверждение","This might be slower than usual":"Процесс идет медленнее обычного","Checking":"Выполняется проверка","New results available! Refresh!":"Есть новые результаты! Перезагрузите страницу.","Saving":"Выполняется сохранение","Turn off Attendee mode":"Выключить режим участника","See Attendee View":"Открыть режим участника","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Общее число участников, которые смотрят этот сеанс прямо сейчас. Примечание: информация только для организаторов.","Session Count":"Счетчик сеанса","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"Число участников, которые прямо сейчас смотрят сеансы в прямом эфире. Примечание: информация только для организаторов.","Role":"Роль","Total Attendees":"Всего участников","Total number of attendees online at this time Note: This is for organizer eyes only":"Общее число участников онлайн на данный момент. Примечание: информация только для организаторов.","My Profile":"Мой профиль","Languages":"Языки","Filling out your profile can help you connect with people with similar interests.":"Заполнение профиля поможет вам встретить людей с похожими интересами.","type to search for your address":"Начните ввод адреса для поиска","Could not open direct call":"Не удалось открыть прямой вызов","Chat messages can only be published from inside a broadcast.":"Сообщения в чат можно отправлять только из трансляции.","Stage Logo can only be published from inside a broadcast.":"Логотип для сцены можно опубликовать только из трансляции.","Loading Speakers":"Загружается список докладчиков","Raise hand is disabled for organizer accounts, but active for attendee accounts":"Функция «Поднять руку» отключена для организаторов, но работает для участников.","Disabled in lite mode, return to live if you’d like to raise hand!":"Эта функция не работает в легком режиме. Если вы хотите поднять руку, вернитесь в живой режим.","Raise hand to enter stage for video q&a":"Поднимите руку, чтобы выйти на сцену для участия в «Вопросах» по видео","Speakers":"Докладчики","Hosting organization: {organization}":"Принимающая организация: {organization}","Failed to switch {deviceTag}":"Не удалось переключить {deviceTag}","Make sure your {deviceTag} is not being used by any other application and is working properly.":"Убедитесь, что {deviceTag} не используется другими приложениями и работает должным образом.","Facing issues with audio or video? Switch on lite mode":"Проблемы со звуком или видео? Включите легкий режим.","Failed to get event for eventID: {eventID}":"Не найдено мероприятие с кодом: {eventID}","Error while playing video.":"Ошибка воспроизведения видео.","Speakers only, attendees can\'t see this chat":"Только для докладчиков. Участники не видят этот чат.","Kudo":"Kudo","Room":"Комната","Session":"Сеанс","Booth":"Стенд","Public":"Для всех","Drift":"Drift","Slides":"Слайды","Videos":"Видео","Chat":"Чат","Messages":"Сообщения","Poll":"Голосование","Docs":"Документы","Q&A":"Вопросы","Media":"Медиа","Messages Chat":"Чат с сообщениями","Leaderboard":"Таблица лидеров","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Примечание: вы также участвуете в качестве докладчика. Вы всегда можете попасть за кулисы или на сцену.","Switch to Attendee View":"Перейти в режим участника","Return to Organizer View":"Вернуться в режим организатора","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"Выход из режима участника приведет к перезагрузке текущей страницы и возвращению в режим организатора. Продолжить?","Switch":"Переключиться","Request Sent":"Запрос отправлен","Your request for a demo has been submitted":"Ваш запрос на демонстрацию отправлен","Organizer Redirection":"Перенаправление организатора","YES, REDIRECT":"ДА, ПЕРЕЙТИ","DISMISS":"ЗАКРЫТЬ","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"Участники перенаправляются на следующий сеанс: {title}. Хотите тоже перейти к следующему сеансу?","Stage":"Сцена","Rooms":"Комнаты","Join a round table to discuss moderated topics with your fellow attendees":"Соберитесь за круглым столом с другими участниками для обсуждения модерированных тем.","Booths":"Стенды","Join a booth to know more about a sponsor":"Посетите стенд для знакомства со спонсором!","You are in the booth":"Вы подошли к стенду","People":"Люди","Connect with your fellow attendees":"Общайтесь с другими участниками!","Connect with speakers":"Общайтесь с докладчиками!","starting in {duration}":"начнется через {duration}","You will be redirected to booths in {duration}":"Вы будете перенаправлены к стендам через {duration}","booths":"стенды","agenda":"ПОВЕСТКА ДНЯ","You will be redirected to {word} in {duration}":"Вы будете перенаправлены в раздел «{word}» через {duration}","You will be redirected to the live stage in {duration}":"Вы будете перенаправлены на «живую» сцену через {duration}","- You are about to be redirected to {tabTitle} in {duration}":"Вы будете перенаправлены во вкладку «{tabTitle}» через {duration}","See Agenda":"Открыть повестку дня","Break":"Перерыв","{title} is now live":"«{title}» в прямом эфире","Apologies, due to an error we need to refresh the page!":"Мы вынуждены обновить эту страницу в связи с ошибкой. Приносим извинения!","Network interruption detected":"Зафиксирован перебой в соединении","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"Возникли проблемы с вашим интернет-соединением. Если вы используете VPN, возможно, лучше его отключить. Либо попробуйте подключиться к другой сети.","No audio output device detected":"Устройств вывода звука не обнаружено","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Подключите колонки или наушники и, если возникнут проблемы, протестируйте их работу с помощью значка шестеренки.","Please disable ad blocker for this page":"Отключите блокировщик рекламы на этой странице","Yes, I understand":"Да, понимаю","No event user found so attended not marked!":"Пользователь не найден, поэтому отметка о посещении не поставлена!","Wait while the speaker approves your video q&a request":"Дождитесь, пока докладчик одобрит вашу заявку на участие в «Вопросах» по видео.","Organizer":"Организатор","UPNEXT":"ДАЛЕЕ","Ended":"Завершено","Hide":"Скрыть","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"Вы автоматически будете перенаправлены с этой страницы через {durationLeftToRedirect} сек.","Register":"Записаться","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Ошибка: не удалось записать пользователя на это мероприятие. Обратитесь за помощью к организатору.","You are already registered!":"Вы уже записаны!","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Кажется, вы уже записаны на это мероприятие! Если письмо с подтверждением не пришло, попробуйте поискать его в папке «Спам». Если вам нужна дополнительная помощь, обратитесь к организатору мероприятия.","Thank you for registering!":"Благодарим вас за запись!","Submit another response":"Отправить другой ответ","Share":"Поделиться","Know someone who want to attend this?":"Это мероприятие будет интересно вашим знакомым?","COPY LINK":"КОПИРОВАТЬ ССЫЛКУ","Powered by":"На базе","VIEW PROFILE":"ОТКРЫТЬ ПРОФИЛЬ","You can access the event landing here":"Целевую страницу мероприятия можно найти здесь","Need Help?":"Нужна помощь?","Welcome back":"С возвращением","Checking...":"Выполняется проверка...","Close":"Закрыть","Enter":"Войти","See {roomCount} Room(s)":"Просмотреть комнаты ({roomCount})","Back":"Назад","Request a Demo":"Запросить демо","Loading":"Идет загрузка","Thread":"Ветка","Load more":"Загрузить еще","Heads up!":"Внимание!","YES":"ДА","No":"Нет","Following":"Вы подписаны","Error in loading drimify":"Ошибка загрузки Drimify","You\'re not registered for this event":"Вы не записаны на это мероприятие","Check out other events":"Другие мероприятия","Date":"Дата","Location":"Место","How are you attending the event":"Как вы планируете участвовать?","In Person":"Лично","Virtually":"Виртульно","Event Widgets":"Виджеты мероприятия","Chat • Messages • Q&A • Poll • Docs":"Чат • Сообщения • Вопросы • Голосование • Документы","DISCUSSION":"ОБСУЖДЕНИЕ","JOIN":"ПРИСОЕДИНИТЬСЯ","WAIT":"ПОДОЖДАТЬ","more":"еще","See Profile":"Открыть профиль","Filter":"Фильтр","Video player not supported by your browser":"Ваш браузер не поддерживает этот видеоплеер","We recommend using the latest version of Google Chrome to access your conference":"Для участия в конференции рекомендуем использовать последнюю версию Google Chrome","ANSWER":"ОТВЕТИТЬ","REJECT":"ОТКЛОНИТЬ","Don’t ask me this next time":"Больше не спрашивать","Cancel":"Отмена","Lite Mode":"Легкий режим","On":"Вкл.","Connection Issues? Turn on Lite Mode":"Проблемы с соединением? Включите легкий режим!","Turn On Lite Mode":"Включить легкий режим","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"Переход на легкий режим приведет к 30-секундной задержке при воспроизведении трансляции на экране. Продолжить?","Turn On":"Включить","Lite Mode Active!":"Активирован легкий режим!","Thanks for your patience, lite mode now on!":"Спасибо за терпение! У вас включен легкий режим.","Turn off Lite Mode?":"Выключить легкий режим?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Отключение легкого режима позволит вам смотреть трансляцию в прямом эфире. Небольшая оговорка: вы упустите 30 секунд вещания.","Lite Mode Off!":"Легкий режим отключен!","Thanks for your patience, we’ve returned to the live broadcast!":"Спасибо за терпение! Мы вернулись к прямой трансляции.","Lite Mode Unavailable":"Легкий режим недоступен","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Приносим извинения за неудобства! В настоящий момент легкий режим недоступен. Чтобы продолжить сеанс, переключитесь на прямой эфир.","Turn off Lite mode?":"Выключить легкий режим?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"Ваше соединение вернулось к норме. Хотите вновь подключиться к прямой трансляции? Небольшая оговорка: вы упустите 30 секунд вещания.","Turn Off":"Выключить","Lite mode is disabled for organizer accounts, but active for attendee accounts":"Легкий режим отключен для организаторов, но работает для участников.","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"Легкий режим не поддерживается в вашем браузере. Рекомендуем использовать последнюю версию Google Chrome.","Lite mode is not curently available. We’ll let you know once it’s available again":"Легкий режим сейчас недоступен. Мы сообщим вам, когда он появится снова.","Turn off Lite Mode":"Выключить легкий режим","We’ll let you know when Lite mode is available again":"Мы сообщим вам, когда легкий режим вернется","Lite Mode Available":"Доступен легкий режим","Loading Lite Mode...":"Загружается легкий режим...","Turning Off Lite Mode":"Отключение легкого режима","Lite Mode On":"Включен легкий режим","Audio/Video Issues?":"Проблемы со звуком или видео?","Error":"Ошибка","Click a video to play":"Нажмите на видео, чтобы начать воспроизведение","Error starting video!":"Ошибка запуска видео!","Please rotate your device to {mode} mode":"Поверните устройство в {mode} режим","landscape":"альбомный","portrait":"портретный","Thank you for attending this event!":"Благодарим вас за участие!","Go to Rooms":"Перейти к комнатам","Please use a desktop or laptop Google Chrome browser to access your conference":"Рекомендуем посетить конференцию в браузере Google Chrome на настольном компьютере или ноутбуке.","If on Desktop":"Если вы пользуетесь компьютером","Please increase the width of your window":"Растяните окно вширь","Alternatively, check out the":"Либо загляните сюда:","Youtube Livestream":"Живая трансляция на YouTube","Search":"Поиск","Profile":"Профиль","Yes":"ДА","Loading Chat":"Чат загружается","Please wait while we fetch the chat":"Подождите: идет загрузка чата","Load old messages":"Загрузить старые сообщения","Join the room to see chat":"Чтобы увидеть чат, войдите в комнату","Live Chat":"Живой чат","Uh..oh we couldn\'t load the content":"Упс... Содержимое не загрузилось.","Please reload the page":"Перезагрузите страницу","New comments":"Новые комментарии","Start the conversation":"Начать беседу","Be the first to add to chat!":"Станьте автором первого сообщения!","Enter your message":"Введите сообщение","Joining chat!":"Присоединяемся к чату!","See all pinned messages":"Все закрепленные сообщения","Failed to send! Retry?":"Ошибка отправки. Попробуем еще раз?","Search for attendee":"Найти участника","Up to date":"Всё прочитано","Start a new conversation, We think you\'ll enjoy":"Заведите беседу. Будет весело!","chatting with these recommended attendees!":"общается с рекомендованными участниками в чате!","Searching":"Идет поиск","Load Previous":"Загрузить предыдущие","Load Next":"Загрузить следующие","Loading Channel":"Загрузка канала","Please wait while we fetch the channel":"Подождите: канал загружается","Please wait while we fetch the messages":"Подождите: сообщения загружаются","Send the first message":"Отправьте первое сообщение","Join":"Подключиться","link":"ссылка","download":"Скачать","Click to open":"Открыть","No open polls":"Открытых голосований нет","Check back later to see if a poll opens up!":"Загляните позже. Возможно, откроется голосование!","Loading Poll":"Загрузка голосования","Please wait while we fetch the polls":"Подождите: голосования загружаются","Uh oh.. we couldn’t load the content":"Упс... Содержимое не загрузилось.","Polls":"Голосования","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"Чтобы запустить голосование, добавьте вопросы и ответы к этому сеансу на панели администратора Goldcast.","Stop Sharing":"Остановить демонстрацию","Can\'t publish polls while something else is being presented on stage":"Невозможно запустить голосование, пока на сцене идет презентация.","Open":"Открыть","Cancel your video q&a request":"Отменить заявку на вопросы по видео","Pending...":"На рассмотрении...","Leave Stage":"Покинуть сцену","Raise Hand":"Поднять руку","Text Q&A":"Текстовые вопросы","Video Q&A":"Вопросы по видео","Loading Q&amp;A":"Вопросы и ответы загружаются","Please wait while we fetch the Q&amp;A":"Подождите: идет загрузка вопросов и ответов","Uh oh.. we couldn\'t load the content":"Упс... Содержимое не загрузилось.","No Questions Yet":"Вопросов пока нет","Tell your audience to send in questions!":"Напомните аудитории активнее задавать вопросы!","Be the first to ask a question!":"Станьте автором первого вопроса!","Tell your audience to raise their hand!":"Напомните аудитории активнее поднимать руки!","Approve":"Одобрить","Reject":"Отклонить","End":"Завершить","RELOAD":"ПЕРЕЗАГРУЗИТЬ","Logos On Stage":"Логотипы на сцене","No File Chosen":"Не выбрано ни одного файла","loading":"Идет загрузка","Can\'t publish a slide when there is something else being presented on stage":"Невозможно опубликовать слайд, пока на сцене идет презентация.","Change Deck":"Сменить стопку","stop-screen-share":"Остановить демонстрацию экрана","screen-share":"Демонстрация экрана","Select a deck to begin presenting":"Выберите стопку слайдов, чтобы начать презентацию","CONFIRM":"ПОДТВЕРДИТЬ","If you’re having issues, please refer to the":"Если возникнут сложности, загляните в","SPEAKER":"Колонка","Issue Testing Audio!":"Ошибка тестирования звука!","VPN and adblockers may cause video issues, please disable them before proceeding":"VPN и блокировщики рекламы могут вызвать проблемы с видео. Отключите их, прежде чем продолжить.","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"На заметку: VPN и блокировщики рекламы могут вызвать проблемы с видео. Обязательно отключите их на время трансляции.","Follow":"Подписаться на","Read More":"Читать дальше","Ask a question":"Задать вопрос","Shared":"Демонстрируется","Answered":"Ответ получен","Waiting Approval":"На рассмотрении","cancel":"отмена","ENTER":"Войти","Upcoming Events":"Предстоящие мероприятия","Past Events":"Прошлые мероприятия","Goldcast":"Goldcast","MANAGE EVENT":"УПРАВЛЕНИЕ МЕРОПРИЯТИЕМ","Edit Profile":"Изменить профиль","Stay tuned!":"Ждите новостей!","Sign-in instructions will be available here 12 hours prior to the event":"Инструкции по выполнению входа появятся здесь за 12 часов до начала мероприятия.","Please log out":"Выйдите из системы","Logout":"Выйти","Continue as {differentUser}":"Продолжить как {differentUser}","You are already logged in as {user}.":"Вы уже вошли как {user}.","EMAIL":"ЭЛЕКТРОННАЯ ПОЧТА","user@email.com":"user@email.com","FIRST NAME":"ИМЯ","First Name":"Имя","LAST NAME":"ФИМИЛИЯ","Last Name":"Фамилия","You are not registered to this event":"Вы не записаны на это мероприятие","Please enter your email and name":"Укажите свое имя и электронную почту","Please enter your email":"Укажите адрес электронной почты","We have sent a secret code to":"Мы отправили секретный код на адрес","BACK":"Назад","Didn\'t receive an email? Make sure to check spam list":"Не получили письмо? Обязательно проверьте папку «Спам».","Resend Mail":"Отправить заново","SECRET CODE":"СЕКРЕТНЫЙ КОД","Please enter the temporary password sent to your email":"Введите временный пароль, полученный по электронной почте","NEW PASSWORD":"НОВЫЙ ПАРОЛЬ","Please enter a new password":"Введите новый пароль","CONFIRM PASSWORD":"ПОДТВЕРДИТЕ ПАРОЛЬ","Please re-enter the new password":"Введите новый пароль еще раз","Password length should be atleast 8":"Длина пароля должна составлять минимум 8 символов","Password and Confirm Password don\'t match !!":"Введенные пароли не совпадают","Please enter your password to continue":"Чтобы продолжить, введите пароль","Logging you in...":"Выполняется вход...","PASSWORD":"ПАРОЛЬ","Forgot credentials?":"Забыли учетные данные?","Forgot Password? A mail will be sent to your registered email.":"Забыли пароль? Мы отправили письмо на ваш зарегистрированный адрес электронной почты.","Email cannot be blank!!":"Обязательно заполните поле для электронной почты!","We have sent a secure login link to":"Мы отправили безопасную ссылку для входа на адрес","from":"от","Please use that to access your event.":"Используйте ее для входа на мероприятие.","Please check spam/promotion too if you can\'t find it.":"Если не можете найти письмо, проверьте папку «Спам» и раздел «Рассылки».","Thank You !":"Спасибо!","The link is not valid.":"Ссылка не работает.","Please be patient.":"Немного терпения.","We are verifying your link.":"Мы проверяем вашу ссылку.","Thank you for entering the code!":"Спасибо за предоставленный код!","Please create a new password":"Создайте новый пароль","Signing you up...":"Выполняется регистрация...","We have sent a temporary password to":"Мы отправили вам временный пароль на адрес","TEMPORARY PASSWORD":"ВРЕМЕННЫЙ ПАРОЛЬ","Please enter the temporary password sent to your mail":"Введите временный пароль, отправленный вам на почту","Password Length should be 8":"Минимальная длина пароля — 8 символов","Okay":"OK","Backstage: {title}":"Закулисье: {title}","Prep Area":"Зона подготовки","Starting at {time}":"Начало в {time}","person":"чел.","inside":"внутри","No one is inside":"Внутри никого нет","This area is for you to sync up with your fellow speakers before you go on stage.":"Здесь вы можете согласовать свое выступление с другими докладчиками, прежде чем выйти на сцену.","This area is for you to check your cam and mic before you enter the room.":"Здесь вы можете проверить камеру и микрофон, прежде чем войти в комнату.","I\'m Ready":"Я готов(а)","Watch Live":"Смотреть в прямом эфире","Backstage":"Закулисье","You are sharing your screen":"Вы демонстрируете этот экран","LIVE":"прямой эфир","Live":"прямой эфир","Virtual":"Виртуальные","Only available for ":"Только для ","See Booths":"Посмотреть стенды","See Rooms":"Посмотреть комнаты","Enter Backstage":"Пройти за кулисы","This track has no upcoming sessions. Check out a different track.":"В этой секции нет предстоящих сеансов. Загляните в другую секцию.","View":"Посмотреть","Agenda":"Повестка дня","Scroll to see all tracks":"Прокрутите страницу, чтобы увидеть все секции","No Agenda Items to show!":"На повестке дня пока ничего нет!","ENTER EVENT":"Войти на мероприятие","change":"изменить","Upload":"Загрузить","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF ИЛИ PNG. РАЗМЕР ДО 5 МБ.","Create Profile":"Создать профиль","Email":"Электронная почта","Company":"Компания","Title":"Должность","No matching locations found":"Ничего не найдено","You can try searching for the location with another keyword":"Попробуйте выполнить поиск мест по другому ключевому слову.","Interest Tags":"Теги с интересами","Pick your first tag":"Выберите свой первый тег","Save":"Сохранить","Searching...":"Идет поиск...","Twitter":"Twitter","Select Your First Tags":"Выберите свои первые теги","Add Interest tags":"Добавить теги с интересами","Congratulations!":"Поздравляем!","Your first Goldcast event is set up":"Всё готово к вашему первому мероприятию на Goldcast","You can always visit":"Также не забывайте про страницу","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"с инструкциями по подготовке и проведению мероприятий.","See My Event":"Просмотреть мое мероприятие","Peak Community":"Сообщество Peak","Loading Lite Mode... This may take up to 30s":"Загружается легкий режим... Это займет до 30 секунд.","Loading Video...":"Видео загружается...","Video will begin at session start time":"Видео запустится в указанное время начала сеанса","TIME":"ВРЕМЯ","TITLE":"НАЗВАНИЕ","STATUS":"СТАТУС","END":"ОКОНЧАНИЕ","START":"НАЧАЛО","AGENDA":"ПОВЕСТКА ДНЯ","Enable Audio":"Включить звук","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"Браузер отключил звук согласно правилам автоматического воспроизведения. Включите звук ниже. Вы сможете выключить его позже с помощью встроенных элементов управления.","Enable":"Включить","You are being redirected outside the room. Would you like to continue?":"Вы будете перенаправлены за пределы комнаты. Продолжить?","Continue":"Продолжить","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"Вы также можете перейти на легкий режим, однако прямой эфир будет идти с 30-секундной задержкой.","We detected a network issue":"Обнаружена проблема с подключением","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Убедитесь, что вы подключены не через VPN/брандмауэр. Если ошибка повторится, попробуйте сменить сеть, браузер или устройство.","Could not connect":"Ошибка подключения","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"Возможно, возникла проблема с безопасной сетью, браузером или устройством. Если ошибка повторится, попробуйте сменить сеть, браузер или устройство.","Switch to Lite Mode":"Перейти на легкий режим","Leave":"Покинуть","Screenshare had an issue":"Ошибка демонстрации экрана","Could not share screen unexpectedly. Refresh & retry. On mac go to":"Непредвиденная ошибка демонстрации экрана. Обновите страницу и повторите попытку. На Mac откройте","and check if your browser has the required permission":"и проверьте, выдано ли браузеру необходимое разрешение.","Uh OH... Something went wrong":"Упс... Что-то пошло не так.","To fix this, click the":"Чтобы исправить ситуацию, нажмите","in your URL bar, then select “Allow”, and then click “Try Again”":"в адресной строке, выберите «Разрешить», а затем — «Повторить попытку».","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"По неустановленной причине запустить трансляцию не удалось. Возможно, платформа не поддерживает ваш браузер. Рекомендуем использовать Google Chrome. Если ошибка повторится, обратитесь в службу поддержки Goldcast.","To fix this, make sure your":"Чтобы исправить ситуацию, убедитесь, что","is not being accessed by any other app. If not, please try changing your":"не используется другим приложением. Если нет, попробуйте изменить свои","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"устройства в «Настройках». Устранив проблему, нажмите «Повторить попытку».","Go To Settings":"Открыть «Настройки»","Try Again":"Повторить попытку","Try Joining without Video":"Попробовать без видео","A refresh and rejoin should work":"Обновления и повторного входа обычно достаточно","Refresh & Rejoin":"Обновить и войти","Start Chat":"Начать чат","On Stage":"На сцене","Connect your on-site camera and microphone to present to your virtual attendees":"Подключите камеру и микрофон, чтобы провести презентацию для виртуальных участников.","Stop Streaming":"Остановить трансляцию","Start Streaming":"Начать трансляцию","Set up on-site video feed":"Настроить вещание с места событий","Open TV":"Открыть ТВ","Layout: {layout} ":"Макет: {layout} ","With Speaker Videos":"С видео докладчиков","Full Screen":"В полный экран","No Speakers":"Без докладчиков","Turn Off Setup Mode":"Выключить режим настройки","Setup Mode":"Режим настройки","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"Если вы хотите выйти из режима настройки комнаты «{roomTitle}», нажмите «Выключить». Все активные трансляции будут остановлены.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"Готовится к трансляции: {roomTitle}. Используйте режим настройки только при трансляции в прямом эфире с места событий.","Starting in {duration}":"начнется через {duration}","Can\'t share screen while there is something else being presented on stage":"Невозможно продемонстрировать экран, пока на сцене идет презентация.","You are now in attendee view!":"Вы перешли в режим участника!","You are now in organizer view!":"Вы перешли в режим организатора!","Note :":"Примечание:","Only organizer accounts can see this tag, normal attendees can’t see this":"Этот тег виден только организаторам. Обычные участники его не видят.","Attendee":"Участник","Event Information":"Информация о мероприятии","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"Информация о мероприятии доступна только организаторам! <br /> Участники не видят этот раздел.","Operating System":"Операционная система","Secondary Booths":"Вторичные стенды","Sort":"Сортировать","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"Подписка на {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2} автоматически заменит подписку на {track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}. Продолжить?","Track only available for {tracks}":"Секция доступна только для {tracks}","Add to Calendar":"Добавить в календарь","Open Speakers Control Panel":"Открыть панель управления докладчиками","Move Offstage ↓":"Снять со сцены ↓","Error Moving ⚠":"Ошибка перемещения ⚠","Off Stage":"Снят(а) со сцены","Move to Stage":"Перенести на сцену","An error occurred!":"Произошла ошибка!","{eventName} Documents":"Документы для «{eventName}»"," Set Up Mode":" Режим настройки","Camera & Mic blocked":"Камера и микрофон заблокированы","Camera/Mic Inaccessible":"Нет доступа к камере/микрофону","Camera/Mic Not Found":"Не удалось найти камеру/микрофон","Camera Inaccessible":"Камера недоступна","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"Камера занята, либо ее разрешение не поддерживается. Убедитесь, что камера не используется другим приложением, и повторите попытку.","No microphone/camera is found":"Не удалось найти камеру/микрофон","The browser does not support using camera and microphone!":"Ваш браузер не поддерживает использование камеры и микрофона.","{n} Slides":"Слайдов: {n}","Starting in {timeduration}":"начнется через {timeduration}","{eventtitle} has ended":"Мероприятие «{eventtitle}» завершилось","This is a text q&a question!":"Это текстовый вопрос!","Click here{if_it_does_not}":"Нажмите сюда{if_it_does_not}","{click_here}if it does not":"{click_here}, если этого не произойдет.","{title}up next":"Далее — «{title}»","seat(s) open":"мест свободно","Signal strength is low. Close other windows or connect to a different network.":"Низкий уровень сигнала. Закройте остальные окна или подключитесь к другой сети.","GO BACKSTAGE":"ПРОЙТИ ЗА КУЛИСЫ","LEAVE STAGE":"ПОКИНУТЬ СЦЕНУ","LEAVE":"ПОКИНУТЬ","This event begins on{startitme}":"Начало в {startitme}","Please refresh to enter.":"Обновите страницу, чтобы войти.","people":"Люди","Oops, Something went wrong":"Упс! Что-то пошло не так.","Back Home":"На главную","Deciding where to go ...":"Куда бы пойти...","Go to Event Hub":"В хаб мероприятий","CREATE":"СОЗДАТЬ","Attending Virtually":"Виртуально","Attending In Person":"Лично","Click to change your attendance type":"Изменить способ посещения","Open Chat":"Открыть чат","Create your profile for {eventtitle}":"Создайте себе профиль для «{eventtitle}»","Move to stage":"Перенести на сцену","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"Организатор мероприятия попросил переместить вас на сцену трансляции <strong>«{broadcastTitle}»</strong>.<br /><br />Приняв запрос, вы выйдете в прямой эфир перед участниками мероприятия.<br /><br />","Go Live On Stage":"Выйти в эфир на сцене","Moved to backstage":"Перенесли за кулисы","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"Организатор снял вас со сцены. Если вы хотите вернуться, обязательно свяжитесь с организатором.","Error creating Screen stream":"Ошибка трансляции экрана","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"Разрешение на демонстрацию экрана не выдано. Ознакомьтесь с документацией по устранению неполадок *здесь*.","Error publishing stream":"Ошибка публикации трансляции","Could not publish stream. Please refresh and try again!":"Опубликовать трансляцию не удалось. Обновите страницу и повторите попытку.","Error publishing screen":"Ошибка публикации экрана","Error publishing screen. Please refresh and try again!":"Ошибка публикации экрана. Обновите страницу и повторите попытку.","Error unpublishing stream":"Ошибка снятия трансляции с публикации","Error unpublishing stream. Please refresh and try again!":"Снять трансляцию с публикации не удалось. Обновите страницу и повторите попытку.","Invalid Publish Operation":"Недопустимая попытка публикации","{username} profile picture":"Фото профиля {username}","Default":"По умолчанию","A-Z":"По алфавиту","Random":"Случайно","All":"Все","Past":"Прошлые","Upcoming":"ДАЛЕЕ","Learn More":"Подробнее","close":"Закрыть","Discussion Rooms":"Переговорные комнаты","ATTENDEE MODE":"РЕЖИМ УЧАСТНИКА","Loading...":"Идет загрузка...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"Устройство отключено браузером или не имеет разрешений на использование. Выдайте разрешения и повторите попытку.","You are now registered. You will receive an email confirming details shortly.":"Вы прошли регистрацию. Письмо с подтверждением уже в пути!","Streaming to Virtual Users from on-site video feed":"Трансляция для виртуальных пользователей через видеосигнал с места событий","Ending in ":"Закончится через ","GO LIVE":"ВЫЙТИ В ЭФИР","You have no past events.":"У вас нет прошлых мероприятий.","You have no upcoming or live events.":"У вас нет предстоящих мероприятий.","left":"слева","center":"по центру","right":"справа","top":"сверху","bottom":"внизу","loading...":"загрузка...","Loading ...":"Идет загрузка...","Failed to redirect!":"Ошибка перенаправления!","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"Кажется, у вас включен блокировщик рекламы. С ним вы вряд ли сможете оценить возможности платформы в полной мере. Советуем его отключить. <br /><br /> Если вы не знаете, как это сделать, ищите инструкции <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>здесь</a>.","redirecting in {duration}":"перенаправление через {duration}","STOP VIDEO":"ОСТАНОВИТЬ ВИДЕО","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"Воспроизведение видео будет остановлено. Трансляция вернется в живой режим, а аудитория увидит и услышит ваших докладчиков. Продолжить?","STOP SHARING":"ОСТАНОВИТЬ ДЕМОНСТРАЦИЮ","No Next Slide":"Дальше слайдов нет","Next Slide":"Следующий слайд","No Previous Slide":"Предыдущих слайдов нет","Previous Slide":"Предыдущий слайд","something went wrong while recording the response please try again":"Во время записи ответа что-то пошло не так. Повторите попытку.","Start In-Person Streaming":"Начать очную трансляцию","Stop In-Person Streaming":"Остановить очную трансляцию","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Тестовый сеанс начнется скоро, а сейчас выполняется буферизация видео. Во время реального сеанса подобной проблемы не будет.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"Бегущая строка отображается вверху веб-страницы и видна всем участникам. Чтобы превратить ее в гиперссылку, введите URL ниже.","Allow {key}":"Разрешить {key}","{messageType} can only be published from inside a broadcast.":"{messageType} может публиковаться только из трансляции.","To grant {deviceName} access to this page, follow the two steps below:":"Как открыть доступ к этой странице для {deviceName}:","2. Allow {deviceName} access and then refresh the page.":"2. Откройте доступ для {deviceName} и перезагрузите страницу."}');

/***/ }),

/***/ 6734:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"ดรอปดาวน์การตั้งค่างานกิจกรรม"," Stage Control":" การควบคุมพื้นที่งาน","Stage Controls and Information":"การควบคุมและข้อมูลพื้นที่งาน","Live in ":"ถ่ายทอดสดใน ","Start Session":"เริ่มเซสชัน","End Session":"สิ้นสุดเซสชัน","Present Screen":"หน้าจอปัจจุบัน","Rehearse On Stage":"ฝึกซ้อมในพื้นที่งาน","Turn on Microphone":"เปิดไมโครโฟน","Turn off Microphone":"ปิดไมโครโฟน","Turn on camera":"เปิดกล้อง","Turn off camera":"ปิดกล้อง","rehearsal mode":"โหมดการฝึกซ้อม","People Watching: ${watchCount}":"จำนวนคนดู: ${watchCount}","Turn on Audio":"เปิดเสียง","Turn off Audio":"ปิดเสียง","Are you sure you want to leave this room?":"คุณแน่ใจหรือไม่ว่าต้องการออกจากห้องนี้","you will be redirected to stage in":"ระบบจะเปลี่ยนเส้นทางคุณไปยังพื้นที่งานใน","sec. . ":"วินาที ","Skip to Main Navigation":"ข้ามไปที่การนำทางหลัก","Skip to Chat":"ข้ามไปที่แชท","Skip to Meeting Controls":"ข้ามไปที่การควบคุมการประชุม","LinkedIn":"LinkedIn","Live in":"ถ่ายทอดสดใน","UPCOMING":"ที่กำลังจะมาถึง","Rehearse on stage":"ฝึกซ้อมในพื้นที่งาน","Watch Rehearsal":"ดูการฝึกซ้อม","Answered by:":"ตอบโดย:","Speaker Off":"ลำโพงปิดอยู่","Speaker On":"ลำโพงเปิดอยู่","Speaker Controls":"การควบคุมลำโพง","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"องค์ประกอบพื้นที่งานทั้งหมดจะแสดงอยู่ด้านหลังรูปภาพที่แชร์ สิ่งเหล่านี้จะปรากฏให้เห็นอีกครั้งเมื่อหยุดการแชร์รูปภาพแบบเต็มหน้าจอ","Close Ticker Popup":"ปิดป๊อปอัปทิกเกอร์","Open GIF Picker":"เปิดตัวเลือก GIF","Open Emoji Picker":"เปิดตัวเลือกอีโมจิ","Send Message":"ส่งข้อความ","Tabs: Messaging and More":"แท็บ: การส่งข้อความและอื่นๆ","Thanks for attending!":"ขอบคุณสำหรับการเข้าร่วม!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" ไม่มีเซสชันที่กำลังจะมาถึงในแทร็กที่คุณสมัครใช้บริการ โปรดเปลี่ยนไปใช้แทร็กอื่นเพื่อดูเซสชันสด","Redirecting you to ":"กำลังเปลี่ยนเส้นทางคุณไปที่ ","in ":"ใน ","seconds":"วินาที","Main Navigation":"การนำทางหลัก","YOU ARE HERE":"คุณอยู่ที่นี่","Live Now":"ถ่ายทอดสดตอนนี้","SUBMIT":"ส่ง","Allocated time for engagement has ended. You will be redirected to main stage":"เวลาที่จัดสรรสำหรับการมีส่วนร่วมสิ้นสุดลงแล้ว ระบบจะเปลี่ยนเส้นทางคุณไปยังพื้นที่งานหลัก","Wrap up in":"สิ้นสุดในอีก","Session overrun by":"เซสชันเลยเวลามาแล้ว","Ending in":"สิ้นสุดใน","Bring this session live?":"ไลฟ์เซสชันนี้ไหม","START SESSION":"เริ่มเซสชัน","Bring this session to end?":"สิ้นสุดเซสชันนี้ไหม","END SESSION":"สิ้นสุดเซสชัน","Go On Stage":"ไปยังพื้นที่งาน","Muted by organizer":"ปิดเสียงโดยผู้จัดงาน","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"หนึ่งในผู้จัดงานกิจกรรมได้ปิดเสียงของคุณ คุณสามารถเปิดเสียงตัวเองได้โดยคลิกปุ่มไมโครโฟน","Gifs":"GIF","Stickers":"สติกเกอร์","Launch Survey":"เริ่มทำแบบสำรวจ","Microphone is on":"ไมโครโฟนเปิดอยู่","Microphone is off":"ไมโครโฟนปิดอยู่","Secret Code’s length should be 6 digits":"รหัสลับควรมีความยาว 6 หลัก","Closing in 00:":"ปิดใน 00:","Submit":"ส่ง","Questions":"คำถาม","Preview":"ดูตัวอย่าง","Close Survey":"ปิดแบบสำรวจ","This is a required question":"ต้องตอบคำถามข้อนี้","Enter the text you’d like to present on stage below.":"ป้อนข้อความที่คุณต้องการนำเสนอในพื้นที่งานด้านล่าง","Use Chrome/Edge for best performance":"ใช้ Chrome/Edge เพื่อประสิทธิภาพที่ดีที่สุด","Do you want to launch your survey now?":"คุณต้องการเริ่มทำแบบสำรวจของคุณตอนนี้หรือไม่","Success! Your Survey has been launched for attendees.":"สำเร็จแล้ว! เริ่มทำแบบสำรวจของคุณสำหรับผู้เข้าร่วมแล้ว","Unable to publish. Please try again.":"ไม่สามารถเผยแพร่ได้ โปรดลองอีกครั้ง","Are you sure you want to close this survey?":"คุณแน่ใจหรือไม่ว่าต้องการปิดแบบสำรวจนี้","Success! Your Survey has been closed for attendees.":"สำเร็จแล้ว! ปิดแบบสำรวจของคุณสำหรับผู้เข้าร่วมแล้ว","Unable to un-publish. Please try again.":"ไม่สามารถยกเลิกการเผยแพร่ได้ โปรดลองอีกครั้ง","Please answer all required questions.":"โปรดตอบคำถามที่จำเป็นทั้งหมด","You have already submitted this survey.":"คุณได้ส่งแบบสำรวจนี้แล้ว","Success! Thank you for your feedback.":"สำเร็จแล้ว! ขอบคุณสำหรับความคิดเห็นของคุณ","Unable to submit. Please try again.":"ไม่สามารถส่งได้ โปรดลองอีกครั้ง","Launch surveys will take over attendees\' engagement panel.":"การเริ่มทำแบบสำรวจจะแทนที่แผงการมีส่วนร่วมของผู้เข้าร่วม","Closing this survey will remove it from attendees\' engagement panel.":"การปิดแบบสำรวจนี้จะลบแบบสำรวจออกจากแผงการมีส่วนร่วมของผู้เข้าร่วม","Survey":"แบบสำรวจ","Updating Survey...":"กำลังอัปเดตแบบสำรวจ...","Closing":"กำลังปิด","Goldcast needs access to your camera and microphone":"Goldcast ต้องได้รับสิทธิ์เข้าถึงกล้องและไมโครโฟนของคุณ","Goldcast needs access to your microphone":"Goldcast ต้องได้รับสิทธิ์เข้าถึงไมโครโฟนของคุณ","Goldcast needs access to your camera":"Goldcast ต้องได้รับสิทธิ์เข้าถึงกล้องของคุณ","SPEAKERS":"ลำโพง","Mark as Unanswered":"ทำเครื่องหมายว่ายังไม่ได้ตอบ","Mark as Answered":"ทำเครื่องหมายว่าตอบแล้ว","Remove from Priority":"นำออกจากลำดับความสำคัญ","Mark as Priority":"ทำเครื่องหมายว่าเป็นลำดับความสำคัญ","Answer":"ตอบ","Enter answer...":"ป้อนคำตอบ...","Answered by":"ตอบโดย","Submit Answer":"ส่งคำตอบ","Test your system’s speaker":"ทดสอบลำโพงของระบบ","Click \\"Yes\\" if you hear the sound.":"คลิก \\"ใช่\\" หากคุณได้ยินเสียง","Load previous":"โหลดก่อนหน้า","Hide Name":"ซ่อนชื่อ","Text Q&A is disabled in On Demand mode.":"ส่งข้อความสำหรับช่วงถามตอบถูกปิดใช้งานในโหมดออนดีมานด์","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"ส่งข้อความสำหรับช่วงถามตอบถึงขีดจำกัดแล้ว ผู้เข้าร่วมจะไม่สามารถถามคำถามใหม่ได้","Sent to Q&A":"ส่งไปช่วงถามตอบแล้ว","Couldn\'t post as Q&A. Please try again.":"ไม่สามารถโพสต์เป็นถามตอบได้ โปรดลองอีกครั้ง","Yes this is being recorded":"ใช่ กำลังบันทึกอยู่","No this is not being recorded":"ไม่ ไม่ได้บันทึกไว้","System\'s Speaker Check":"การตรวจสอบลำโพงของระบบ","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"เพื่อให้แน่ใจว่าคุณจะสามารถได้ยินในระหว่างงานกิจกรรม ตรวจสอบว่าลำโพงของระบบทำงานได้ดี","Click on “Test your system’s speaker” to proceed":"คลิกที่ \\"ทดสอบลำโพงของระบบ\\" เพื่อดำเนินการต่อ","Error while sharing message to screen. Post not found":"เกิดข้อผิดพลาดขณะแชร์ข้อความไปที่หน้าจอ ไม่พบโพสต์","Lost connection to servers. Refresh your page to get live event experience.":"สูญเสียการเชื่อมต่อกับเซิร์ฟเวอร์ รีเฟรชหน้าเว็บของคุณเพื่อรับประสบการณ์การถ่ายทอดสด","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"VPN/ไฟร์วอลล์กำลังรบกวนการตรวจสอบสิทธิ์ของคุณ โปรดเปลี่ยนเครือข่ายของคุณหรือเชื่อมต่อกับทีมไอทีของคุณเพื่อให้<a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>โดเมนเหล่านี้</a>เข้าถึง Goldcast ได้อย่างราบรื่น","It\'s taking too long":"ใช้เวลานานเกินไป","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"ดูเหมือนว่าคุณเชื่อมต่อผ่าน VPN หรือเปิดใช้งานไฟร์วอลล์ไว้ โปรดดู<a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>เอกสารความช่วยเหลือ</a>นี้และเพิ่มโดเมนที่จำเป็นลงในรายการที่อนุญาตพิเศษเพื่อให้ Goldcast ทำงานได้อย่างราบรื่น หรือคุณควรเปลี่ยนเครือข่ายของคุณ","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"ดูเหมือนว่าคุณเชื่อมต่อผ่าน VPN หรือเปิดใช้งานไฟร์วอลล์ไว้ โปรดดู<a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>เอกสารความช่วยเหลือ</a>นี้และเพิ่มโดเมนที่จำเป็นลงในรายการที่อนุญาตพิเศษเพื่อให้ Goldcast ทำงานได้อย่างราบรื่น หรือคุณควรเปลี่ยนเครือข่ายหรือดูเซสชันในโหมด Lite","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"บริการสตรีมมิ่งวิดีโอของ Goldcast ไม่สามารถเชื่อมต่อได้เนื่องจากแบนด์วิดท์เครือข่ายไม่เสถียร โปรดเปลี่ยนเครือข่ายของคุณเพื่อเชื่อมต่อกับบริการถ่ายทอดสด","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"บริการสตรีมมิ่งวิดีโอของ Goldcast ไม่สามารถเชื่อมต่อได้เนื่องจากแบนด์วิดท์เครือข่ายไม่เสถียร โปรดเปลี่ยนเป็นโหมด Lite หรือเปลี่ยนเครือข่ายของคุณเพื่อเชื่อมต่อกับบริการสตรีมมิ่ง","Most Upvotes":"โหวตสูงสุด","Most Recent":"ล่าสุด","My Questions":"คำถามของฉัน","Prioritized":"จัดลำดับความสำคัญแล้ว","Approved":"ได้รับการอนุมัติ","Unapproved":"ไม่ได้รับการอนุมัติ","Unanswered":"ยังไม่ได้ตอบ","Failed to update answer. Please try again!":"ไม่สามารถอัปเดตคำตอบได้ โปรดลองอีกครั้ง!","Failed to post answer. Please try again!":"ไม่สามารถโพสต์คำตอบได้ โปรดลองอีกครั้ง!","Failed to delete question. Please try again!":"ลบคำถามไม่สำเร็จ โปรดลองอีกครั้ง!","Survey Link":"ลิงก์แบบสำรวจ","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"การสลับเปลี่ยนจะโหลดหน้าปัจจุบันของคุณใหม่ไปยังมุมมองผู้เข้าร่วม หากต้องการเปลี่ยนกลับไปเป็นมุมมองผู้จัดงาน ให้ปิดมุมมองผู้เข้าร่วมในดรอปดาวน์ของโปรไฟล์","You haven\'t asked any questions yet":"คุณยังไม่ได้ถามคำถามใดๆ","No prioritized questions":"ไม่มีคำถามที่จัดลำดับความสำคัญ","Create prioritized list of questions for speakers by marking questions as priority":"สร้างรายการคำถามที่จัดลำดับความสำคัญสำหรับผู้บรรยายโดยทำเครื่องหมายคำถามว่ามีความสำคัญ","No Approved Questions":"ไม่มีคำถามที่ได้รับการอนุมัติ","Approve incoming questions to see list of approved questions":"อนุมัติคำถามที่เข้ามาใหม่เพื่อดูรายการคำถามที่ได้รับการอนุมัติ","No Unapproved Questions":"ไม่มีคำถามที่ไม่ได้รับการอนุมัติ","No Answered Questions":"ไม่มีคำถามที่ตอบแล้ว","Answer a question on stage or with inline text":"ตอบคำถามในพื้นที่งานหรือด้วยข้อความในบรรทัด","All questions are answered":"ตอบทุกคำถามแล้ว","Rate Your Experience":"ให้คะแนนประสบการณ์ของคุณ","How satisfied are you with Goldcast?":"คุณพอใจกับ Goldcast มากน้อยเพียงใด","What are the main reasons for your rating?":"เหตุผลหลักในการให้คะแนนของคุณคืออะไร","I am interested in seeing a demo of Goldcast":"ฉันสนใจที่จะลองใช้เดโมของ Goldcast","Thank You":"ขอบคุณ","Your feedback was successfully submitted.":"ส่งความคิดเห็นของคุณเรียบร้อยแล้ว","Tell us how we can improve...":"บอกเราว่าเราจะปรับปรุงให้ดีขึ้นได้อย่างไร...","1 Slide":"1 สไลด์","Your internet connection is unstable.":"การเชื่อมต่ออินเทอร์เน็ตของคุณไม่เสถียร","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"ดูเหมือนว่าคุณกำลังพูดในโหมดปิดเสียงคลิกที่ไอคอน \\"ไมโครโฟน\\" เพื่อเปิดเสียงตัวคุณเอง","The registration could not be completed! Please check that this email is allowed to register for the event.":"ไม่สามารถลงทะเบียนให้เสร็จสิ้นได้! โปรดตรวจสอบว่าอีเมลนี้ได้รับอนุญาตให้ลงทะเบียนเข้าร่วมงานกิจกรรมได้","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"ดูเหมือนว่าคุณได้ลงทะเบียนสำหรับงานกิจกรรมนี้แล้ว! โปรดตรวจสอบโฟลเดอร์สแปมของคุณเพื่อยืนยันการลงทะเบียนหากยังไม่ได้รับอีเมล หากคุณต้องการความช่วยเหลือเพิ่มเติม โปรดติดต่อผู้จัดงานกิจกรรม","Your registration could not be completed. This event has reached its registration capacity.":"การลงทะเบียนของคุณไม่เสร็จสมบูรณ์ งานกิจกรรมนี้มีผู้ลงทะเบียนครบจำนวนแล้ว","Image cannot be an svg":"รูปภาพต้องไม่เป็น svg","This should be a valid linkedin url":"ควรเป็น URL ของ LinkedIn ที่ถูกต้อง","This should be a valid twitter url":"ควรเป็น URL ของ Twitter ที่ถูกต้อง","This should be a valid url":"ควรเป็น URL ที่ถูกต้อง","Video":"วีดีโอ","Read Less":"อ่านน้อยลง","live":"ถ่ายทอดสด","Opened":"เปิดแล้ว","In person only":"ด้วยตนเองเท่านั้น","Stage Stream":"สตรีมพื้นที่งาน","Streaming not available":"ไม่สามารถสตรีมได้","Close TV":"ปิดทีวี","Streaming is not available for prerecorded and RTMP sessions":"การสตรีมไม่พร้อมใช้งานสำหรับเซสชันที่บันทึกไว้ล่วงหน้าและ RTMP","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"เชื่อมต่อคอมพิวเตอร์ของคุณเข้ากับจอทีวีหรือโปรเจ็กเตอร์เพื่อให้ผู้เข้าร่วมประชุมด้วยตนเองสามารถเห็นสิ่งที่เกิดขึ้นในพื้นที่งานออนไลน์ของคุณ รวมถึงสไลด์ ช่วงถามตอบ เป็นต้น เมื่อเชื่อมต่อแล้ว คลิก \\"เปิดทีวี\\" แล้วลากหรือแชร์หน้าต่างใหม่ไปยังหน้าจอทีวีหรือโปรเจ็กเตอร์ของคุณ ","Close Setup Mode":"ปิดโหมดการตั้งค่า","Help":"ความช่วยเหลือ","upcoming":"ที่กำลังจะมาถึง","ended":"สิ้นสุดแล้ว","Remove from favorites":"ลบออกจากรายการโปรด","Add to favorites":"เพิ่มลงในรายการโปรด","PLAY RECORDING":"เล่นรายการบันทึก","VIEW RECORDING":"ดูรายการบันทึก","VIEW RECORDINGS":"ดูรายการบันทึก","Virtual Backgrounds":"พื้นหลังเสมือนจริง","No Device Available":"ไม่มีอุปกรณ์ที่พร้อมใช้งาน","Needs permission":"ต้องได้รับสิทธิ์อนุญาต","Device not detected":"ตรวจไม่พบอุปกรณ์","Camera is on":"กล้องเปิดอยู่","Camera is off":"กล้องปิดอยู่","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"วิดีโอที่มิเรอร์ไม่ได้แสดงให้ผู้ชมเห็น ผู้ชมจะเห็นวิดีโอที่ไม่มีการมิเรอร์เสมอ","Mirror My Video":"มิเรอร์วิดีโอของฉัน","Camera":"กล้อง","1. Click on Safari > Settings for this\\n            website":"1. คลิกที่ Safari > การตั้งค่า สำหรับ\\nเว็บไซต์นี้","1. Click the lock":"1. คลิกไอคอนแม่กุญแจ","icon in your browser’s address bar":"ในแถบที่อยู่ของเบราว์เซอร์ของคุณ","3. Unmute":"3. เปิดเสียง","and":"และ","icons from stage control panel":"ไอคอนจากแผงควบคุมพื้นที่งาน","icon from stage control panel":"ไอคอนจากแผงควบคุมพื้นที่งาน","2. Set camera and microphone to “Allow”.":"2. ตั้งค่ากล้องและไมโครโฟนเป็น \\"อนุญาต\\"","2. Set camera to “Allow”.":"2. ตั้งค่ากล้องเป็น \\"อนุญาต\\"","2. Set microphone to \\"Allow\\"":"2. ตั้งค่าไมโครโฟนเป็น \\"อนุญาต\\"","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. เลือก \\"อนุญาตให้ Goldcast เข้าถึงกล้องและไมโครโฟนของคุณเสมอ\\"","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. เลือก \\"อนุญาตให้ Goldcast เข้าถึงกล้องของคุณเสมอ\\"","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. เลือก \\"อนุญาตให้ Goldcast เข้าถึงไมโครโฟนของคุณเสมอ\\"","Questions?":"มีข้อสงสัยหรือไม่","If you’re having issues, check out our comprehensive":"หากคุณประสบปัญหา โปรดดูเอกสารความช่วยเหลือ","help docs":"ที่ครอบคลุมของเรา","Speaker is on":"ลำโพงเปิดอยู่","Stop Test":"หยุดการทดสอบ","Test your system’s audio":"ทดสอบเสียงของระบบ","Still can\'t hear any sound?":"ยังไม่ได้ยินเสียงใดๆ ใช่ไหม","Microphone":"ไมโครโฟน","Audio is being played in system\'s default audio device.":"กำลังเล่นเสียงในอุปกรณ์เสียงเริ่มต้นของระบบ","Click to view/change audio device":"คลิกเพื่อดู/เปลี่ยนอุปกรณ์เสียง","Speaker":"ลำโพง","Play Recording":"เล่นการบันทึก","Recording for this broadcast is currently being processed and will be available soon":"การบันทึกสำหรับการออกอากาศนี้อยู่ระหว่างการประมวลผลและจะสามารถใช้งานได้เร็วๆ นี้","You haven\'t favorited anything yet!":"คุณยังไม่ได้เพิ่มลงในรายการโปรดใดๆ!","Add an item to favorites by selecting the ♡ in the top right corner.":"เพิ่มรายการลงในรายการโปรดโดยเลือก ♡ ที่มุมขวาบน","Session has ended":"เซสชันสิ้นสุดแล้ว","System Check":"การตรวจสอบระบบ","Need help? Check out the":"ต้องการความช่วยเหลือหรือไม่ ตรวจสอบ","Skip Checks and Continue":"ข้ามการตรวจสอบและดำเนินการต่อ","Click the button above to run the test":"คลิกปุ่มด้านบนเพื่อทำการทดสอบ","Test Screenshare":"ทดสอบการแชร์หน้าจอ","Share message to stage":"แชร์ข้อความไปยังพื้นที่งาน","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"ป้อนข้อความที่คุณต้องการใช้สำหรับทิกเกอร์ด้านล่าง หากต้องการเปลี่ยนทิกเกอร์ให้เป็นไฮเปอร์ลิงก์ ให้ป้อน URL","Ticker":"ทิกเกอร์","Coffee Break! Be back in 10m.":"ช่วงพักเบรค! จะกลับมาในอีก 10 นาที","Enter Message":"ป้อนข้อความ","https://www.xyz.com":"https://www.xyz.com","Launch":"เริ่มต้น","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"ขอบคุณสำหรับการส่งคำถามของคุณ คุณจะสามารถส่งอีกครั้งได้เมื่อหนึ่งในคำถามปัจจุบันของคุณได้รับการอนุมัติ","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"ขออภัย! \\"ถามตอบ\\" ถูกปิดใช้งานในขณะนี้ คุณจะสามารถส่งคำถามได้เมื่อเปิดใช้งาน \\"ถามตอบ\\" อีกครั้ง","Votes":"คะแนนโหวต","Vote":"คะแนนโหวต","is inviting you to a video call":"กำลังเชิญคุณเข้าร่วมวิดีโอคอล","ENTER ROOM":"เข้าร่วมห้อง","Start the conversation!":"เริ่มการสนทนา!","Couldn\'t send message. Click here to retry.":"ไม่สามารถส่งข้อความได้ คลิกที่นี่เพื่อลองอีกครั้ง","Couldn\'t add emoji. Please try again.":"ไม่สามารถเพิ่มอีโมจิได้ โปรดลองอีกครั้ง","Couldn\'t remove emoji. Please try again.":"ไม่สามารถลบอีโมจิได้ โปรดลองอีกครั้ง","Couldn\'t delete message. Please try again.":"ไม่สามารถลบข้อความได้ โปรดลองอีกครั้ง","Couldn\'t pin message. Please try again.":"ไม่สามารถปักหมุดข้อความได้ โปรดลองอีกครั้ง","Couldn\'t unpin message. Please try again.":"ไม่สามารถเลิกปักหมุดข้อความได้ โปรดลองอีกครั้ง","Today":"วันนี้","No messages yet":"ยังไม่มีข้อความ","Messages from organizers and speakers appear here!":"ข้อความจากผู้จัดงานและผู้พูดจะแสดงที่นี่!","Next Session is Starting":"เซสชันถัดไปกำลังเริ่มต้น","Go to Next Session":"ไปที่เซสชันถัดไป","I’d like to stay":"ฉันต้องการอยู่ที่เซสชันปัจจุบัน","My favorites":"รายการโปรดของฉัน","1. Click on the lock icon in your address bar":"1. คลิกที่ไอคอนแม่กุญแจในแถบที่อยู่ของคุณ","We recommend organizers and speakers use a desktop\\n        device":"เราขอแนะนำให้ผู้จัดงานและผู้พูดใช้อุปกรณ์\\nเดสก์ท็อป","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"เพื่อให้มั่นใจว่าผู้เข้าร่วม ผู้พูด และผู้จัดงานจะได้รับประสบการณ์ที่ดีที่สุด\\n ต้องใช้ Goldcast จากเดสก์ท็อป การออกอากาศจากอุปกรณ์มือถือจะ\\n ให้ประสบการณ์การใช้งานที่ไม่เต็มประสิทธิภาพ","Watch Now":"ดูเลย","Video progress time":"เวลาความคืบหน้าของวิดีโอ","Total video duration":"ระยะเวลาวิดีโอทั้งหมด","Rate Goldcast!":"ให้คะแนน Goldcast!","Running Required Checks...":"กำลังดำเนินการตรวจสอบที่จำเป็น...","Test Your Setup":"ทดสอบการตั้งค่าของคุณ","Test your Computer Device, Microphone and Camera before you join the event":"ทดสอบอุปกรณ์คอมพิวเตอร์ ไมโครโฟน และกล้องของคุณก่อนเข้าร่วมงานกิจกรรม","Speaker and microphone not working?":"ลำโพงและไมโครโฟนไม่ทำงานใช่ไหม","Passed":"ผ่านแล้ว","Fix Audio Issues":"แก้ไขปัญหาเสียง","Check if audio is being played in other sound devices connected to phone/tablet":"ตรวจสอบว่าเสียงกำลังเล่นอยู่ในอุปกรณ์เสียงอื่นๆ ที่เชื่อมต่อกับโทรศัพท์/แท็บเล็ตหรือไม่","Check if correct audio device is chosen from the below dropdown":"ตรวจสอบว่าได้เลือกอุปกรณ์เสียงที่ถูกต้องจากดรอปดาวน์ด้านล่างหรือไม่","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>คลิกที่นี่</a>เพื่อตรวจสอบว่าได้เลือกอุปกรณ์เสียงที่ถูกต้องซึ่งจำเป็นต้องเล่นเสียงหรือไม่","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>คลิกที่นี่</a>เพื่อตรวจสอบว่าได้เลือกอุปกรณ์เสียงที่ถูกต้องซึ่งจำเป็นต้องเล่นเสียงหรือไม่","Right click on the browser tab & click “Unmute Site”":"คลิกขวาที่แท็บเบราว์เซอร์และคลิก \\"เปิดเสียงในไซต์\\"","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"ตรวจสอบว่าแท็บของเบราว์เซอร์เปิดเสียงอยู่หรือคลิกหน้าต่าง > เปิดเสียงแท็บนี้","System Check Failed!":"การตรวจสอบระบบล้มเหลว!","System Check Passed!":"การตรวจสอบระบบผ่านแล้ว!","Complete checks to proceed":"ตรวจสอบให้เสร็จสิ้นเพื่อดำเนินการต่อ","Enter Event":"เข้าสู่งานกิจกรรม","Skip Screen Sharing Check? ":"ข้ามการตรวจสอบการแชร์หน้าจอใช่ไหม ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"เราแนะนำให้ทำการตรวจสอบการแชร์หน้าจอว่าจำเป็นต้องนำเสนอหน้าจอของคุณในงานกิจกรรมหรือไม่","Ignore & Enter Event":"ละเว้นและเข้าสู่งานกิจกรรม","Test screenshare":"ทดสอบการแชร์หน้าจอ","Retry Now":"ลองอีกครั้งตอนนี้","SHARE":"แชร์","Rooms Closed":"ห้องถูกปิดแล้ว","Discussion rooms are now closed. You are being redirected to the Stage.":"ขณะนี้ห้องสนทนาถูกปิดแล้ว ระบบกำลังเปลี่ยนเส้นทางคุณไปยังพื้นที่งาน","Return To Stage":"กลับสู่พื้นที่งาน","Unrecognized embedded widget provider - ":"ผู้ให้บริการวิดเจ็ตแบบฝังที่ไม่รู้จัก - ","Room Ended":"ห้องสิ้นสุดแล้ว","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"ผู้จัดงานกิจกรรมของคุณได้ปิดห้องทั้งหมดแล้ว ระบบจะเปลี่ยนเส้นทางคุณไปยังพื้นที่งานกิจกรรม","Video Q&A Request Cancelled":"คำขอถามตอบสำหรับวิดีโอถูกยกเลิก","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"คำขอถามตอบสำหรับวิดีโอของคุณถูกยกเลิกแล้วเนื่องจากคุณดูในโหมด Lite เปลี่ยนเป็นโหมดถ่ายทอดสดเพื่อยกมืออีกครั้ง","Camera Passed":"กล้องผ่านแล้ว","Camera Error":"ข้อผิดพลาดของกล้อง","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"ไม่อนุญาตให้ใช้กล้องจากเบราว์เซอร์ คลิก \\"อนุญาตกล้อง\\"","Camera permissions aren’t granted from system. Click “Allow Camera”":"ไม่อนุญาตให้ใช้กล้องจากระบบ คลิก \\"อนุญาตกล้อง\\"","Uh-oh! Error occurred while creating camera stream":"ขออภัย! เกิดข้อผิดพลาดขณะสร้างสตรีมกล้อง","Close other applications which might use camera stream":"ปิดแอปพลิเคชันอื่นที่อาจใช้สตรีมกล้อง","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>คลิกที่นี่</a>เพื่อตรวจสอบว่าเบราว์เซอร์มีสิทธิ์เข้าถึงกล้องหรือไม่","Microphone Passed":"ไมโครโฟนผ่านแล้ว","Microphone Error":"ข้อผิดพลาดของไมโครโฟน","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"ไม่อนุญาตให้ใช้ไมโครโฟนจากเบราว์เซอร์ คลิก \\"อนุญาตไมโครโฟน\\"","Mic permissions aren’t granted from system. Click “Allow Microphone”":"ไม่อนุญาตให้ใช้ไมโครโฟนจากระบบ คลิก \\"อนุญาตไมโครโฟน\\"","Uh-oh! Error occurred while creating mic stream":"ขออภัย! เกิดข้อผิดพลาดขณะสร้างสตรีมไมโครโฟน","Close other applications which might use mic stream":"ปิดแอปพลิเคชันอื่นที่อาจใช้สตรีมไมโครโฟน","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>คลิกที่นี่</a>เพื่อตรวจสอบว่าเบราว์เซอร์มีสิทธิ์เข้าถึงไมโครโฟนหรือไม่","Speaker and Microphone Error":"ข้อผิดพลาดของลำโพงและไมโครโฟน","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"จำเป็นต้องได้รับสิทธิ์สำหรับไมโครโฟนเพื่อแสดงรายการอุปกรณ์ลำโพงที่เชื่อมต่อกับระบบ คลิก \\"อนุญาตไมโครโฟน\\"","It seems mic is being used by other application. Close other applications to proceed.":"ดูเหมือนว่าแอปพลิเคชันอื่นกำลังใช้ไมโครโฟนอยู่ ปิดแอปพลิเคชันอื่นเพื่อดำเนินการต่อ","Camera & Microphone Error":"ข้อผิดพลาดของกล้องและไมโครโฟน","To enable permissions, click the Allow Camera & Mic button below":"หากต้องการให้สิทธิ์ ให้คลิกปุ่ม \\"อนุญาตกล้องและไมโครโฟน\\" ด้านล่าง","Network Connection":"การเชื่อมต่อเครือข่าย","Check Passed":"ผ่านการตรวจสอบแล้ว","Could not establish a network connection":"ไม่สามารถสร้างการเชื่อมต่อเครือข่ายได้","Connect to a different network, or use a mobile hotspot.":"เชื่อมต่อกับเครือข่ายอื่น หรือใช้ฮอตสปอตมือถือ","Disable any VPN or firewall is connected.":"ปิดใช้งาน VPN หรือไฟร์วอลล์ที่เชื่อมต่ออยู่","Connection: Good":"การเชื่อมต่อ: ดี","Network Connection Error":"เกิดข้อผิดพลาดในการเชื่อมต่อเครือข่าย","Can’t connect to network. Change your network or limited functionality will be available during event.":"ไม่สามารถเชื่อมต่อกับเครือข่ายได้ เปลี่ยนเครือข่ายของคุณหรือฟังก์ชันการทำงานที่จำกัดจะพร้อมใช้งานในระหว่างงานกิจกรรม","AdBlocker":"AdBlocker","AdBlocker not detected.":"ตรวจไม่พบ AdBlocker","AdBlocker detected. This may degrade your event experience.":"ตรวจพบ AdBlocker สิ่งนี้อาจทำให้ประสบการณ์งานกิจกรรมของคุณลดลง","Disable adblocker for best experience.":"ปิดใช้งาน AdBlocker เพื่อประสบการณ์ที่ดีที่สุด","You are using ":"คุณกำลังใช้ ","Use Windows or Mac OS for best performance":"ใช้ Windows หรือ Mac OS เพื่อประสิทธิภาพการใช้งานที่ดีที่สุด","Browser Check":"การตรวจสอบเบราว์เซอร์","Check Passed.":"ผ่านการตรวจสอบแล้ว","Switch To Lite Mode":"เปลี่ยนเป็นโหมด Lite","Your pending Video Q&A request will be cancelled once you switch to lite mode":"คำขอถามตอบสำหรับวิดีโอที่รอดำเนินการของคุณจะถูกยกเลิกเมื่อคุณเปลี่ยนเป็นโหมด Lite","Stay on Live Mode":"อยู่ในโหมดถ่ายทอดสด","Unable to mark as favorite":"ไม่สามารถทำเครื่องหมายเป็นรายการโปรดได้","Event organizers must enter the event to select favorites.":"ผู้จัดงานกิจกรรมจะต้องเข้าร่วมงานกิจกรรมเพื่อเลือกรายการโปรด","Make an Announcement":"ประกาศ","STOP":"หยุด","InPerson CheckIn App":"แอปเช็คอินด้วยตนเอง","App to Check-In In-Person attendees":"แอปสำหรับเช็คอินผู้เข้าร่วมด้วยตนเอง","SEE AGENDA":"ดูกำหนดการ","Please visit the Agenda tab to view the session recordings":"โปรดไปที่แท็บ \\"กำหนดการ\\" เพื่อดูการบันทึกเซสชัน","The session recordings will be available soon in the Agenda tab":"การบันทึกเซสชันจะพร้อมใช้งานเร็วๆ นี้ในแท็บ \\"กำหนดการ\\"","FAILED!":"ไม่สำเร็จ!","Next session is beginning":"เซสชันถัดไปกำลังเริ่มต้น","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"คุณต้องการย้ายไปยังเซสชันถัดไปหรือไม่ สตรีมของคุณจะดำเนินต่อไปและทีวีของคุณจะออกอากาศเซสชันใหม่","Banners":"แบนเนอร์","Images":"รูปภาพ","Screen Share":"การแชร์หน้าจอ","Browser might not have screen-recording permission on your computer.":"เบราว์เซอร์อาจไม่ได้รับสิทธิ์ให้บันทึกหน้าจอบนคอมพิวเตอร์ของคุณ","Open System Preferences":"เปิดการตั้งค่าระบบ","Error publishing screen because someone else started screen share already.":"เกิดข้อผิดพลาดในการเผยแพร่หน้าจอเนื่องจากมีคนอื่นเริ่มแชร์หน้าจอแล้ว","Live Feed":"ฟีดการถ่ายทอดสด","Check Your Network":"ตรวจสอบเครือข่ายของคุณ","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"เราตรวจพบข้อผิดพลาดขณะเล่นวิดีโอ! หากคุณกำลังประสบปัญหาในการเล่นวิดีโอ โปรดลองรีเฟรชหน้าเว็บหรือเปลี่ยนเป็นโหมด Lite","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"เราตรวจพบข้อผิดพลาดขณะเล่นวิดีโอ! หากคุณกำลังประสบปัญหาในการเล่นวิดีโอ โปรดลองรีเฟรชหน้าเว็บ","All Dates":"วันที่ทั้งหมด","All Tracks":"แทร็กทั้งหมด","Create Ticker":"สร้างทิกเกอร์","Booths Closed":"บูธถูกปิดแล้ว","Your event organizer has closed all the booths. You will now be redirected to the stage":"ผู้จัดงานกิจกรรมของคุณได้ปิดบูธทั้งหมดแล้ว ระบบจะเปลี่ยนเส้นทางคุณไปยังพื้นที่งาน","Visit the Polls tab to view live results.":"ไปที่แท็บโพลเพื่อดูผลการถ่ายทอดสด","A new poll is open! Visit the Polls tab to vote.":"เปิดโพลใหม่แล้ว! ไปที่แท็บโพลเพื่อโหวต","Vote for Polls":"โหวตแบบสำรวจ","Go to Polls Tab":"ไปที่แท็บโพลล์","Microphone audio too low":"เสียงไมโครโฟนต่ำเกินไป","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"เราตรวจพบปัญหาเกี่ยวกับเสียงของคุณ เราขอแนะนำให้ลองปิด/เปิดเสียง หรือใช้อุปกรณ์อื่นหากปัญหายังคงมีอยู่","Audio/Video bitrate too low":"บิตเรตเสียง/วิดีโอต่ำเกินไป","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"การตั้งค่าไฟร์วอลล์เครือข่ายของคุณบล็อกสตรีม A/V เราขอแนะนำให้คุณเปลี่ยนไปใช้การเชื่อมต่อเครือข่ายอื่น","Error sharing screen":"เกิดข้อผิดพลาดในการแชร์หน้าจอ","A network error occurred while sharing screen. Please check your network connection.":"เกิดข้อผิดพลาดของเครือข่ายขณะแชร์หน้าจอ โปรดตรวจสอบการเชื่อมต่อเครือข่ายของคุณ","Apologies, due to some errors, we need to refresh the page!":"ขออภัย เนื่องจากข้อผิดพลาดบางประการ เราจำเป็นต้องรีเฟรชหน้านี้!","Warning":"คำเตือน","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"เราตรวจพบปัญหาเกี่ยวกับวิดีโอของคุณ เราขอแนะนำให้ลองปิดแท็บเบราว์เซอร์อื่นหรือแอปพลิเคชันอื่นที่ทำงานบนอุปกรณ์ของคุณ และตรวจสอบ/อัปเกรดการเชื่อมต่ออินเทอร์เน็ตเพื่อแก้ไขปัญหานี้","No results found":"ไม่พบผลลัพธ์","Audio":"เสียง","Please choose another microphone and camera":"โปรดเลือกไมโครโฟนและกล้องอื่น","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"ไมโครโฟนและกล้องที่เลือกอยู่ในขณะนี้ไม่ทำงาน โปรดเลือกไมโครโฟนและกล้องอื่นจากดรอปดาวน์ด้านล่าง","The currently selected camera is not working. Please choose another camera in the dropdown below.":"กล้องที่เลือกอยู่ในขณะนี้ไม่ทำงาน โปรดเลือกกล้องอื่นในดรอปดาวน์ด้านล่าง","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"คุณสามารถดำเนินการต่อได้โดยไม่ต้องใช้กล้อง แต่เราขอแนะนำให้แก้ไขข้อขัดแย้งเพื่อให้แน่ใจว่าได้รับประสบการณ์การออกอากาศที่ราบรื่น","Please choose another microphone":"โปรดเลือกไมโครโฟนอื่น","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"ไมโครโฟนที่เลือกอยู่ในขณะนี้ไม่ทำงาน โปรดเลือกไมโครโฟนอื่นในดรอปดาวน์ด้านล่าง","Please check that your TV speaker is correct":"โปรดตรวจสอบว่าลำโพงทีวีของคุณถูกต้อง","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"ลำโพงที่เลือกอยู่ในขณะนี้ไม่ทำงาน โปรดเลือกลำโพงอื่นในดรอปดาวน์ด้านล่าง","Your answer":"คำตอบของคุณ","Edit":"แก้ไข","Delete":"ลบ","Settings":"การตั้งค่า","Signing Out":"ออกจากระบบแล้ว","Confirming your account...":"กำลังยืนยันบัญชีของคุณ...","Something Went Wrong. Please Retry :(":"เกิดข้อผิดพลาด โปรดลองอีกครั้ง :(","Resending Mail":"กำลังส่งอีเมลอีกครั้ง","offline":"ออฟไลน์","I am inviting you to a video meeting:":"ฉันกำลังเชิญคุณเข้าร่วมการประชุมทางวิดีโอ:","Resending secure login link to your email":"กำลังส่งลิงก์เข้าสู่ระบบที่ปลอดภัยไปยังอีเมลของคุณอีกครั้ง","Sending secure login link to your email":"กำลังส่งลิงก์เข้าสู่ระบบที่ปลอดภัยไปยังอีเมลของคุณ","Something went Wrong. Please Retry :(":"เกิดข้อผิดพลาด โปรดลองอีกครั้ง :(","Updating your password":"กำลังอัปเดตรหัสผ่านของคุณ","Sending mail":"กำลังส่งจดหมาย","Verifying":"กำลังยืนยัน","This might be slower than usual":"การดำเนินการนี้อาจจะช้ากว่าปกติ","Checking":"กำลังตรวจสอบ","New results available! Refresh!":"ผลลัพธ์ใหม่พร้อมแล้ว! รีเฟรช!","Saving":"กำลังบันทึก","Turn off Attendee mode":"ปิดโหมดผู้เข้าร่วม","See Attendee View":"ดูมุมมองผู้เข้าร่วม","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"จำนวนผู้เข้าร่วมทั้งหมดที่กำลังดูเซสชันนี้อยู่ หมายเหตุ: สำหรับมุมมองของผู้จัดงานเท่านั้น","Session Count":"จำนวนเซสชัน","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"จำนวนผู้เข้าร่วมที่กำลังดูเซสชันถ่ายทอดสดอยู่ หมายเหตุ: สำหรับมุมมองของผู้จัดงานเท่านั้น","Role":"บทบาท","Total Attendees":"ผู้เข้าร่วมทั้งหมด","Total number of attendees online at this time Note: This is for organizer eyes only":"จำนวนผู้เข้าร่วมออนไลน์ทั้งหมดในขณะนี้ หมายเหตุ: สำหรับมุมมองของผู้จัดงานเท่านั้น","My Profile":"โปรไฟล์ของฉัน","Languages":"ภาษา","Filling out your profile can help you connect with people with similar interests.":"การกรอกโปรไฟล์ของคุณจะช่วยให้คุณเชื่อมต่อกับคนที่มีความสนใจคล้ายกันได้","type to search for your address":"พิมพ์เพื่อค้นหาที่อยู่ของคุณ","Could not open direct call":"ไม่สามารถเปิดการโทรโดยตรงได้","Chat messages can only be published from inside a broadcast.":"สามารถเผยแพร่ข้อความแชทได้จากภายในการออกอากาศเท่านั้น","Stage Logo can only be published from inside a broadcast.":"สามารถเผยแพร่โลโก้พื้นที่งานได้จากภายในการออกอากาศเท่านั้น","Loading Speakers":"กำลังโหลดลำโพง","Raise hand is disabled for organizer accounts, but active for attendee accounts":"การยกมือถูกปิดใช้งานสำหรับบัญชีผู้จัดงาน แต่ใช้งานได้สำหรับบัญชีผู้เข้าร่วม","Disabled in lite mode, return to live if you’d like to raise hand!":"ปิดใช้งานในโหมด Lite แล้ว กลับมาถ่ายทอดสดอีกครั้งหากคุณต้องการยกมือ!","Raise hand to enter stage for video q&a":"ยกมือขึ้นเพื่อเข้าสู่พื้นที่งานในช่วงถามตอบสำหรับวิดีโอ","Speakers":"ลำโพง","Hosting organization: {organization}":"องค์กรที่จัด: {organization}","Failed to switch {deviceTag}":"ไม่สามารถเปลี่ยน {deviceTag} ได้","Make sure your {deviceTag} is not being used by any other application and is working properly.":"ตรวจสอบว่าแอปพลิเคชันอื่นไม่ได้ใช้งาน {deviceTag} ของคุณ และทำงานได้อย่างถูกต้อง","Facing issues with audio or video? Switch on lite mode":"หากประสบปัญหาเกี่ยวกับเสียงหรือวิดีโอ ให้เปิดโหมด Lite","Failed to get event for eventID: {eventID}":"ไม่สามารถรับ eventID สำหรับงานกิจกรรมได้: {eventID}","Error while playing video.":"เกิดข้อผิดพลาดขณะเล่นวิดีโอ","Speakers only, attendees can\'t see this chat":"เฉพาะผู้พูดท่านั้น ผู้เข้าร่วมจะไม่เห็นแชทนี้","Kudo":"Kudo","Room":"ห้อง","Session":"เซสชัน","Booth":"บูธ","Public":"สาธารณะ","Drift":"หลุด","Slides":"สไลด์","Videos":"วิดีโอ","Chat":"แชท","Messages":"ข้อความ","Poll":"โพล","Docs":"เอกสาร","Q&A":"ถามตอบ","Media":"สื่อ","Messages Chat":"ข้อความแชท","Leaderboard":"ลีดเดอร์บอร์ด","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"หมายเหตุ: คุณยังเป็นผู้พูดในงานกิจกรรมนี้ด้วย คุณจะสามารถเข้าสู่พื้นที่เบื้องหลังและในพื้นที่งานได้ตลอด","Switch to Attendee View":"เปลี่ยนไปยังมุมมองผู้เข้าร่วม","Return to Organizer View":"กลับไปที่มุมมองผู้จัดงาน","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"การปิดมุมมองผู้เข้าร่วมจะโหลดหน้าปัจจุบันของคุณใหม่และนำคุณกลับไปสู่มุมมองผู้จัดงาน คุณต้องการดำเนินการต่อหรือไม่","Switch":"เปลี่ยน","Request Sent":"ส่งคำขอแล้ว","Your request for a demo has been submitted":"ส่งคำขอของคุณสำหรับเดโมแล้ว","Organizer Redirection":"การเปลี่ยนเส้นทางของผู้จัดงาน","YES, REDIRECT":"ใช่ เปลี่ยนเส้นทาง","DISMISS":"ละทิ้ง","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"ระบบกำลังเปลี่ยนเส้นทางผู้เข้าร่วมไปยังเซสชันถัดไป: {title} คุณต้องการเปลี่ยนเส้นทางไปยังเซสชันถัดไปด้วยหรือไม่","Stage":"พื้นที่งาน","Rooms":"ห้อง","Join a round table to discuss moderated topics with your fellow attendees":"เข้าร่วมโต๊ะสนทนาเพื่อหารือเกี่ยวกับหัวข้อที่มีการดูแลกับผู้ร่วมประชุมของคุณ","Booths":"บูธ","Join a booth to know more about a sponsor":"เข้าร่วมบูธเพื่อดูข้อมูลเพิ่มเติมเกี่ยวกับผู้สนับสนุน","You are in the booth":"คุณอยู่ในบูธ","People":"ผู้คน","Connect with your fellow attendees":"เชื่อมต่อกับผู้ร่วมประชุมของคุณ","Connect with speakers":"เชื่อมต่อกับลำโพง","starting in {duration}":"เริ่มใน {duration}","You will be redirected to booths in {duration}":"ระบบจะเปลี่ยนเส้นทางคุณไปยังบูธใน {duration}","booths":"บูธ","agenda":"กำหนดการ","You will be redirected to {word} in {duration}":"ระบบจะเปลี่ยนเส้นทางคุณไปยัง{word}ใน {duration}","You will be redirected to the live stage in {duration}":"ระบบจะเปลี่ยนเส้นทางคุณไปยังพื้นที่งานที่ถ่ายทอดสดใน {duration}","- You are about to be redirected to {tabTitle} in {duration}":"- ระบบจะเปลี่ยนเส้นทางคุณไปยัง {tabTitle} ใน {duration}","See Agenda":"ดูกำหนดการ","Break":"พักเบรค","{title} is now live":"{title} ถ่ายทอดสดตอนนี้","Apologies, due to an error we need to refresh the page!":"ขออภัย เนื่องจากเกิดข้อผิดพลาด เราจำเป็นต้องรีเฟรชหน้านี้!","Network interruption detected":"ตรวจพบการหยุดชะงักของเครือข่าย","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"การเชื่อมต่ออินเทอร์เน็ตของคุณมีปัญหาบางประการ หากคุณใช้ VPN อยู่ ให้ลองปิดใช้งาน หรือลองเชื่อมต่อกับเครือข่ายอื่น","No audio output device detected":"ไม่พบอุปกรณ์เอาต์พุตเสียง","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"โปรดเชื่อมต่อลำโพง/หูฟังของคุณและใช้ไอคอนรูปเฟืองเพื่อทดสอบหากคุณประสบปัญหาใดๆ","Please disable ad blocker for this page":"โปรดปิดใช้งานตัวบล็อกโฆษณาสำหรับหน้านี้","Yes, I understand":"ใช่ ฉันเข้าใจแล้ว","No event user found so attended not marked!":"ไม่พบผู้ใช้งานกิจกรรม จึงไม่ได้ทำเครื่องหมายไว้ว่าเข้าร่วม!","Wait while the speaker approves your video q&a request":"รอในขณะที่ผู้พูดอนุมัติคำขอถามตอบสำหรับวิดีโอของคุณ","Organizer":"ผู้จัดงาน","UPNEXT":"ต่อไป","Ended":"สิ้นสุดแล้ว","Hide":"ซ่อน","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"หน้านี้จะเปลี่ยนเส้นทางคุณโดยอัตโนมัติใน {durationLeftToRedirect} วินาที","Register":"ลงทะเบียน","Error: User unable to be registered for this event. Please contact event organizer for assistance":"ข้อผิดพลาด: ไม่สามารถลงทะเบียนผู้ใช้สำหรับงานกิจกรรมนี้ได้ โปรดติดต่อผู้จัดงานเพื่อขอความช่วยเหลือ","You are already registered!":"คุณลงทะเบียนแล้ว!ป","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"ดูเหมือนว่าคุณได้ลงทะเบียนสำหรับงานกิจกรรมนี้แล้ว! โปรดตรวจสอบโฟลเดอร์สแปมของคุณเพื่อยืนยันการลงทะเบียนหากยังไม่ได้รับอีเมล หากคุณต้องการความช่วยเหลือเพิ่มเติม โปรดติดต่อผู้จัดงานกิจกรรม","Thank you for registering!":"ขอบคุณสำหรับการลงทะเบียน!","Submit another response":"ส่งคำตอบอีกครั้ง","Share":"แชร์","Know someone who want to attend this?":"รู้จักใครที่ต้องการเข้าร่วมงานกิจกรรมนี้หรือไม่","COPY LINK":"คัดลอกลิงก์","Powered by":"ขับเคลื่อนโดย","VIEW PROFILE":"ดูประวัติ","You can access the event landing here":"คุณสามารถเข้าถึงหน้าเริ่มต้นของงานกิจกรรมได้ที่นี่","Need Help?":"ต้องการความช่วยเหลือหรือไม่","Welcome back":"ยินดีต้อนอีกครั้ง","Checking...":"กำลังตรวจสอบ...","Close":"ปิด","Enter":"เข้าร่วม","See {roomCount} Room(s)":"ดู {roomCount} ห้อง","Back":"ย้อนกลับ","Request a Demo":"ส่งคำขอเดโม","Loading":"กำลังโหลด","Thread":"เธรด","Load more":"โหลดเพิ่ม","Heads up!":"แจ้งเตือนล่วงหน้า!","YES":"ใช่","No":"ไม่","Following":"กำลังติดตาม","Error in loading drimify":"เกิดข้อผิดพลาดในการโหลด Drimify","You\'re not registered for this event":"คุณไม่ได้ลงทะเบียนสำหรับงานกิจกรรมนี้","Check out other events":"สำรวจงานกิจกรรมอื่นๆ","Date":"วันที่","Location":"ตำแหน่งที่ตั้ง","How are you attending the event":"การเข้าร่วมงานกิจกรรมของคุณเป็นอย่างไรบ้าง","In Person":"ด้วยตนเอง","Virtually":"ออนไลน์","Event Widgets":"วิดเจ็ตงานกิจกรรม","Chat • Messages • Q&A • Poll • Docs":"แชท • ข้อความ • ถามและตอบ • โพลล์ • เอกสาร","DISCUSSION":"การพูดคุย","JOIN":"เข้าร่วม","WAIT":"รอ","more":"มากกว่า","See Profile":"ดูโปรไฟล์","Filter":"กรอง","Video player not supported by your browser":"เบราว์เซอร์ของคุณไม่รองรับโปรแกรมเล่นวิดีโอ","We recommend using the latest version of Google Chrome to access your conference":"เราขอแนะนำให้ใช้ Google Chrome เวอร์ชันล่าสุดเพื่อเข้าถึงการประชุมของคุณ","ANSWER":"ตอบ","REJECT":"ปฏิเสธ","Don’t ask me this next time":"ไม่ต้องถามครั้งหน้า","Cancel":"ยกเลิก","Lite Mode":"โหมด Lite","On":"เปิด","Connection Issues? Turn on Lite Mode":"มีปัญหาการเชื่อมต่อหรือไม่ เปิดโหมด Lite","Turn On Lite Mode":"เปิดโหมด Lite","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"โหมด Lite จะส่งผลให้มีเวลาหน่วง 30 วินาทีระหว่างการถ่ายทอดสดกับสิ่งที่คุณเห็นบนหน้าจอ คุณต้องการดำเนินการต่อหรือไม่","Turn On":"เปิด","Lite Mode Active!":"โหมด Lite ใช้งานอยู่!","Thanks for your patience, lite mode now on!":"ขอบคุณที่อดทนรอ โหมด Lite เปิดใช้งานแล้วตอนนี้!","Turn off Lite Mode?":"ปิดโหมด Lite หรือไม่","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"การปิดโหมด Lite เพื่อกลับไปดูการถ่ายทอดสด โปรดทราบว่าจะมีช่องว่าง 30 วินาทีขณะที่เราสตรีมการถ่ายทอดสด","Lite Mode Off!":"โหมด Lite ปิดอยู่!","Thanks for your patience, we’ve returned to the live broadcast!":"ขอบคุณที่อดทนรอ เราได้กลับมาถ่ายทอดสดแล้ว!","Lite Mode Unavailable":"โหมด Lite ไม่พร้อมใช้งาน","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"ขออภัยในความไม่สะดวก โหมด Lite ไม่พร้อมใช้งานในขณะนี้ โปรดเปลี่ยนไปใช้การถ่ายทอดสดเพื่อดำเนินการต่อเซสชันของคุณ","Turn off Lite mode?":"ปิดโหมด Lite หรือไม่","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"เราตรวจพบว่าการเชื่อมต่อของคุณกลับมาเป็นปกติแล้ว คุณต้องการเปลี่ยนกลับไปเป็นการถ่ายทอดสดหรือไม่ โปรดทราบว่าจะมีช่องว่าง 30 วินาทีขณะที่เราสตรีมการถ่ายทอดสด","Turn Off":"ปิด","Lite mode is disabled for organizer accounts, but active for attendee accounts":"โหมด Lite ถูกปิดใช้งานสำหรับบัญชีผู้จัดงาน แต่ใช้งานได้สำหรับบัญชีผู้เข้าร่วม","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"เบราว์เซอร์ของคุณไม่รองรับโหมด Lite เราขอแนะนำให้ใช้ Google Chrome เวอร์ชันล่าสุด","Lite mode is not curently available. We’ll let you know once it’s available again":"โหมด Lite ยังไม่พร้อมใช้งานในขณะนี้ เราจะแจ้งให้คุณทราบเมื่อพร้อมให้บริการอีกครั้ง","Turn off Lite Mode":"ปิดโหมด Lite","We’ll let you know when Lite mode is available again":"เราจะแจ้งให้คุณทราบเมื่อโหมด Lite พร้อมใช้งานอีกครั้ง","Lite Mode Available":"โหมด Lite พร้อมให้ใช้งาน","Loading Lite Mode...":"กำลังโหลดโหมด Lite...","Turning Off Lite Mode":"กำลังปิดโหมด Lite","Lite Mode On":"โหมด Lite เปิดอยู่","Audio/Video Issues?":"มีปัญหาเกี่ยวกับเสียง/วิดีโอหรือไม่","Error":"ข้อผิดพลาด","Click a video to play":"คลิกวิดีโอเพื่อเล่น","Error starting video!":"เกิดข้อผิดพลาดในการเริ่มวิดีโอ!","Please rotate your device to {mode} mode":"โปรดหมุนอุปกรณ์ของคุณไปที่โหมด{mode}","landscape":"แนวนอน","portrait":"แนวตั้ง","Thank you for attending this event!":"ขอบคุณสำหรับการเข้าร่วมงานกิจกรรมนี้!","Go to Rooms":"ไปที่ห้อง","Please use a desktop or laptop Google Chrome browser to access your conference":"โปรดใช้เบราว์เซอร์ Google Chrome บนเดสก์ท็อปหรือแล็ปท็อปเพื่อเข้าถึงการประชุมของคุณ","If on Desktop":"หากใช้งานบนเดสก์ท็อป","Please increase the width of your window":"โปรดเพิ่มความกว้างของหน้าต่างของคุณ","Alternatively, check out the":"หรือดูที่","Youtube Livestream":"การสตรีมแบบสดบน YouTube","Search":"ค้นหา","Profile":"โปรไฟล์","Yes":"ใช่","Loading Chat":"กำลังโหลดแชท","Please wait while we fetch the chat":"โปรดรอสักครู่ในขณะที่เราดึงข้อมูลแชท","Load old messages":"โหลดข้อความเก่า","Join the room to see chat":"เข้าร่วมห้องเพื่อดูแชท","Live Chat":"แชทสด","Uh..oh we couldn\'t load the content":"ขออภัย เราไม่สามารถโหลดเนื้อหาได้","Please reload the page":"โปรดโหลดหน้านี้ซ้ำ","New comments":"ความคิดเห็นใหม่","Start the conversation":"เริ่มการสนทนา","Be the first to add to chat!":"เป็นคนแรกที่จะเพิ่มลงในแชท!","Enter your message":"ป้อนข้อความของคุณ","Joining chat!":"กำลังเข้าร่วมแชท!","See all pinned messages":"ดูข้อความที่ปักหมุดไว้ทั้งหมด","Failed to send! Retry?":"ส่งไม่สำเร็จ! ลองอีกครั้งหรือไม่","Search for attendee":"ค้นหาผู้เข้าร่วม","Up to date":"ปัจจุบัน","Start a new conversation, We think you\'ll enjoy":"เริ่มการสนทนาใหม่ เราคิดว่าคุณจะสนุก","chatting with these recommended attendees!":"พูดคุยกับผู้เข้าร่วมที่แนะนำเหล่านี้!","Searching":"กำลังค้นหา","Load Previous":"โหลดก่อนหน้า","Load Next":"โหลดถัดไป","Loading Channel":"กำลังโหลดช่อง","Please wait while we fetch the channel":"โปรดรอสักครู่ในขณะที่เราดึงข้อมูลช่อง","Please wait while we fetch the messages":"โปรดรอสักครู่ในขณะที่เราดึงข้อความ","Send the first message":"ส่งข้อความแรก","Join":"เข้าร่วม","link":"ลิงก์","download":"ดาวน์โหลด","Click to open":"คลิกเพื่อเปิด","No open polls":"ไม่มีโพลที่เปิด","Check back later to see if a poll opens up!":"กลับมาตรวจสอบในภายหลังเพื่อดูว่ามีการเปิดโพลหรือไม่!","Loading Poll":"กำลังโหลดโพล","Please wait while we fetch the polls":"โปรดรอสักครู่ในขณะที่เราดึงข้อมูลโพล","Uh oh.. we couldn’t load the content":"ขออภัย.. เราไม่สามารถโหลดเนื้อหาได้","Polls":"โพล","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"หากต้องการเริ่มทำโพล ให้เพิ่มคำถามและคำตอบในเซสชันนี้ในแผงผู้ดูแลระบบ Goldcast","Stop Sharing":"หยุดแชร์","Can\'t publish polls while something else is being presented on stage":"ไม่สามารถเผยแพร่โพลได้ในขณะที่มีการนำเสนออย่างอื่นในพื้นที่งาน","Open":"เปิด","Cancel your video q&a request":"ยกเลิกคำขอถามตอบสำหรับวิดีโอของคุณ","Pending...":"รอดำเนินการ...","Leave Stage":"ออกจากพื้นที่งาน","Raise Hand":"ยกมือ","Text Q&A":"ส่งข้อความในช่วงถามตอบ","Video Q&A":"ช่วงถามตอบสำหรับวิดีโอ","Loading Q&amp;A":"กำลังโหลดช่วงถามตอบ","Please wait while we fetch the Q&amp;A":"โปรดรอสักครู่ในขณะที่เราดึงข้อมูลช่วงถามตอบ","Uh oh.. we couldn\'t load the content":"ขออภัย.. เราไม่สามารถโหลดเนื้อหาได้","No Questions Yet":"ยังไม่มีคำถาม","Tell your audience to send in questions!":"บอกให้ผู้ชมของคุณส่งคำถาม!","Be the first to ask a question!":"เป็นคนแรกที่ถามคำถาม!","Tell your audience to raise their hand!":"บอกให้ผู้ชมยกมือขึ้น!","Approve":"อนุมัติ","Reject":"ปฏิเสธ","End":"สิ้นสุด","RELOAD":"โหลดซ้ำ","Logos On Stage":"โลโก้ในพื้นที่งาน","No File Chosen":"ไม่มีไฟล์ที่เลือก","loading":"กำลังโหลด","Can\'t publish a slide when there is something else being presented on stage":"ไม่สามารถเผยแพร่สไลด์ได้เมื่อมีการนำเสนออย่างอื่นในพื้นที่งาน","Change Deck":"เปลี่ยนชุดสไลด์","stop-screen-share":"หยุดแชร์หน้าจอ","screen-share":"แชร์หน้าจอ","Select a deck to begin presenting":"เลือกชุดสไลด์เพื่อเริ่มการนำเสนอ","CONFIRM":"ยืนยัน","If you’re having issues, please refer to the":"หากคุณประสบปัญหา โปรดดูที่","SPEAKER":"ลำโพง","Issue Testing Audio!":"ปัญหาการทดสอบเสียง!","VPN and adblockers may cause video issues, please disable them before proceeding":"VPN และตัวบล็อกโฆษณาอาจทำให้เกิดปัญหาเกี่ยวกับวิดีโอ โปรดปิดใช้งานก่อนดำเนินการต่อ","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"โปรดทราบว่า VPN และตัวบล็อกโฆษณาอาจทำให้เกิดปัญหาเกี่ยวกับวิดีโอ โปรดตรวจสอบว่าคุณได้ปิดใช้งานสิ่งเหล่านี้ในระหว่างการออกอากาศ","Follow":"ติดตาม","Read More":"อ่านเพิ่มเติม","Ask a question":"ถามคำถาม","Shared":"แชร์แล้ว","Answered":"ตอบแล้ว","Waiting Approval":"รอการอนุมัติ","cancel":"ยกเลิก","ENTER":"เข้าร่วม","Upcoming Events":"งานกิจกรรมที่จะเกิดขึ้น","Past Events":"งานกิจกรรมที่ผ่านมา","Goldcast":"Goldcast","MANAGE EVENT":"จัดการงานกิจกรรม","Edit Profile":"แก้ไขโปรไฟล์","Stay tuned!":"คอยติดตาม!","Sign-in instructions will be available here 12 hours prior to the event":"คำแนะนำในการลงชื่อเข้าใช้จะปรากฏที่นี่เป็นเวลา 12 ชั่วโมงก่อนงานกิจกรรม","Please log out":"โปรดออกจากระบบ","Logout":"ออกจากระบบ","Continue as {differentUser}":"ดำเนินการต่อในชื่อ {differentUser}","You are already logged in as {user}.":"คุณเข้าสู่ระบบแล้วในชื่อ {user}","EMAIL":"อีเมล","user@email.com":"user@email.com","FIRST NAME":"ชื่อ","First Name":"ชื่อ","LAST NAME":"นามสกุล","Last Name":"นามสกุล","You are not registered to this event":"คุณไม่ได้ลงทะเบียนเข้าร่วมงานกิจกรรมนี้","Please enter your email and name":"โปรดป้อนอีเมลและชื่อของคุณ","Please enter your email":"โปรดป้อนอีเมลของคุณ","We have sent a secret code to":"เราได้ส่งรหัสลับไปที่","BACK":"ย้อนกลับ","Didn\'t receive an email? Make sure to check spam list":"หากไม่ได้รับอีเมล โปรดตรวจสอบที่รายการสแปม","Resend Mail":"ส่งอีเมลอีกครั้ง","SECRET CODE":"รหัสลับ","Please enter the temporary password sent to your email":"โปรดป้อนรหัสผ่านชั่วคราวที่ส่งไปยังอีเมลของคุณ","NEW PASSWORD":"รหัสผ่านใหม่","Please enter a new password":"โปรดป้อนรหัสผ่านใหม่","CONFIRM PASSWORD":"ยืนยันรหัสผ่าน","Please re-enter the new password":"โปรดป้อนรหัสผ่านใหม่อีกครั้ง","Password length should be atleast 8":"รหัสผ่านควรมีความยาวอย่างน้อย 8 ตัว","Password and Confirm Password don\'t match !!":"รหัสผ่านและการยืนยันรหัสผ่านไม่ตรงกัน!!","Please enter your password to continue":"โปรดป้อนรหัสผ่านเพื่อดำเนินการต่อ","Logging you in...":"กำลังเข้าสู่ระบบ...","PASSWORD":"รหัสผ่าน","Forgot credentials?":"ลืมข้อมูลเข้าสู่ระบบใช่ไหม","Forgot Password? A mail will be sent to your registered email.":"ลืมรหัสผ่านใช่ไหม ระบบจะส่งไปยังอีเมลที่คุณลงทะเบียนไว้","Email cannot be blank!!":"ต้องระบุอีเมล!!","We have sent a secure login link to":"เราได้ส่งลิงก์เข้าสู่ระบบที่ปลอดภัยไปที่","from":"จาก","Please use that to access your event.":"โปรดใช้เพื่อเข้าถึงงานกิจกรรมของคุณ","Please check spam/promotion too if you can\'t find it.":"โปรดตรวจสอบสแปม/โปรโมชันด้วยหากคุณไม่พบ","Thank You !":"ขอบคุณ","The link is not valid.":"ลิงก์ไม่ถูกต้อง","Please be patient.":"โปรดรอสักครู่","We are verifying your link.":"เรากำลังตรวจสอบลิงก์ของคุณ","Thank you for entering the code!":"ขอบคุณที่ป้อนรหัส!","Please create a new password":"โปรดสร้างรหัสผ่านใหม่","Signing you up...":"กำลังลงชื่อสมัครใช้...","We have sent a temporary password to":"เราได้ส่งรหัสผ่านชั่วคราวไปที่","TEMPORARY PASSWORD":"รหัสผ่านชั่วคราว","Please enter the temporary password sent to your mail":"โปรดป้อนรหัสผ่านชั่วคราวที่ส่งไปยังอีเมลของคุณ","Password Length should be 8":"ความยาวของรหัสผ่านควรมี 8 ตัว","Okay":"ตกลง","Backstage: {title}":"เบื้องหลัง: {title}","Prep Area":"พื้นที่เตรียมการ","Starting at {time}":"เริ่มในเวลา {time}","person":"บุคคล","inside":"ภายใน","No one is inside":"ไม่มีใคร","This area is for you to sync up with your fellow speakers before you go on stage.":"พื้นที่นี้มีไว้สำหรับให้คุณซิงค์กับผู้พูดก่อนเข้าพื้นที่งาน","This area is for you to check your cam and mic before you enter the room.":"บริเวณนี้มีไว้สำหรับให้คุณตรวจสอบกล้องและไมโครโฟนก่อนเข้าห้อง","I\'m Ready":"ฉันพร้อมแล้ว","Watch Live":"ดูการถ่ายทอดสด","Backstage":"เบื้องหลัง","You are sharing your screen":"คุณกำลังแชร์หน้าจอของคุณ","LIVE":"ถ่ายทอดสด","Live":"ถ่ายทอดสด","Virtual":"ออนไลน์","Only available for ":"มีให้เฉพาะสำหรับ ","See Booths":"ดูบูธ","See Rooms":"ดูห้อง","Enter Backstage":"ไปที่เบื้องหลัง","This track has no upcoming sessions. Check out a different track.":"แทร็กนี้ไม่มีเซสชันที่กำลังจะมาถึง ลองดูแทร็กอื่น","View":"มุมมอง","Agenda":"กำหนดการ","Scroll to see all tracks":"เลื่อนเพื่อดูแทร็กทั้งหมด","No Agenda Items to show!":"ไม่มีรายการกำหนดการที่จะแสดง!","ENTER EVENT":"เข้าร่วมงานกิจกรรม","change":"เปลี่ยน","Upload":"อัปโหลด","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF หรือ PNG ขนาดสูงสุด 5MB","Create Profile":"สร้างโปรไฟล์","Email":"อีเมล","Company":"บริษัท","Title":"ตำแหน่ง","No matching locations found":"ไม่พบตำแหน่งที่ตั้งที่ตรงกัน","You can try searching for the location with another keyword":"คุณสามารถลองค้นหาตำแหน่งที่ตั้งด้วยคีย์เวิร์ดอื่นได้","Interest Tags":"แท็กความสนใจ","Pick your first tag":"เลือกแท็กแรกของคุณ","Save":"บันทึก","Searching...":"กำลังค้นหา...","Twitter":"Twitter","Select Your First Tags":"เลือกแท็กแรกของคุณ","Add Interest tags":"เพิ่มแท็กความสนใจ","Congratulations!":"ยินดีด้วย!","Your first Goldcast event is set up":"งานกิจกรรม Goldcast แรกของคุณได้รับการตั้งค่าแล้ว","You can always visit":"คุณสามารถเยี่ยมชม","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"สำหรับคำแนะนำในการตั้งค่าและดำเนินงานกิจกรรมของคุณ","See My Event":"ดูงานกิจกรรมของฉัน","Peak Community":"Peak Community","Loading Lite Mode... This may take up to 30s":"กำลังโหลดโหมด Lite...การดำเนินการนี้อาจใช้เวลาถึง 30 วินาที","Loading Video...":"กำลังโหลดวิดีโอ...","Video will begin at session start time":"วิดีโอจะเริ่มในเวลาเริ่มต้นเซสชัน","TIME":"เวลา","TITLE":"ชื่อ","STATUS":"สถานะ","END":"สิ้นสุด","START":"เริ่มต้น","AGENDA":"กำหนดการ","Enable Audio":"เปิดใช้งานเสียง","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"เสียงถูกปิดเนื่องจากนโยบายการเล่นอัตโนมัติของเบราว์เซอร์ คลิกเปิดใช้งานด้านล่างเพื่อเปิดเสียง คุณยังสามารถเปิดเสียงได้ในภายหลังผ่านการควบคุมแบบฝัง","Enable":"เปิดใช้งาน","You are being redirected outside the room. Would you like to continue?":"ระบบกำลังเปลี่ยนเส้นทางคุณไปนอกห้อง คุณต้องการดำเนินการต่อหรือไม่","Continue":"ดำเนินการต่อ","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"หรือคุณสามารถใช้โหมด Lite ซึ่งจะล่าช้า 30 วินาทีจากการถ่ายทอดสด","We detected a network issue":"เราตรวจพบปัญหาเครือข่าย","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"โปรดตรวจสอบว่าคุณไม่ได้เชื่อมต่อผ่าน VPN/ไฟร์วอลล์ ลองเปลี่ยนเครือข่าย เบราว์เซอร์ หรืออุปกรณ์ของคุณหากปัญหายังคงอยู่","Could not connect":"เชื่อมต่อไม่ได้","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"อาจเนื่องมาจากปัญหาเครือข่าย เบราว์เซอร์/อุปกรณ์ที่ปลอดภัย โปรดลองเปลี่ยนเครือข่าย เบราว์เซอร์ หรืออุปกรณ์ของคุณหากปัญหายังคงอยู่","Switch to Lite Mode":"เปลี่ยนเป็นโหมด Lite","Leave":"ออก","Screenshare had an issue":"การแชร์หน้าจอมีปัญหา","Could not share screen unexpectedly. Refresh & retry. On mac go to":"ไม่สามารถแชร์หน้าจอได้เนื่องจากเกิดปัญหาที่ไม่คาดคิด รีเฟรชและลองอีกครั้ง บนไมโครโฟน ให้ไปที่","and check if your browser has the required permission":"และตรวจสอบว่าเบราว์เซอร์ของคุณมีสิทธิ์ที่จำเป็นหรือไม่","Uh OH... Something went wrong":"ขออภัย... เกิดข้อผิดพลาด","To fix this, click the":"หากต้องการแก้ไขปัญหานี้ ให้คลิกที่","in your URL bar, then select “Allow”, and then click “Try Again”":"ในแถบ URL ของคุณ จากนั้นเลือก \\"อนุญาต\\" จากนั้นคลิก \\"ลองอีกครั้ง\\"","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"ไม่สามารถเริ่มต้นสตรีมสื่อของคุณได้เนื่องจากไม่ทราบสาเหตุ! แพลตฟอร์มของเราอาจไม่รองรับเบราว์เซอร์ของคุณ เราแนะนำให้ใช้ \\"Google Chrome\\" หากปัญหานี้ยังคงอยู่ โปรดติดต่อฝ่ายสนับสนุนของ Goldcast","To fix this, make sure your":"เพื่อแก้ไขปัญหานี้ ตรวจสอบว่า","is not being accessed by any other app. If not, please try changing your":"ไม่สามารถเข้าถึงได้โดยแอปอื่น หากไม่ใช่ โปรดลองเปลี่ยน","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"อุปกรณ์โดยคลิกที่ \\"ไปที่การตั้งค่า\\" หลังจากแก้ไขปัญหาที่เป็นไปได้แล้ว ให้กด \\"ลองอีกครั้ง\\"!","Go To Settings":"ไปที่การตั้งค่า","Try Again":"ลองอีกครั้ง","Try Joining without Video":"ลองเข้าร่วมโดยไม่มีวิดีโอ","A refresh and rejoin should work":"การรีเฟรชและเข้าร่วมอีกครั้งควรใช้งานได้","Refresh & Rejoin":"รีเฟรชและเข้าร่วมอีกครั้ง","Start Chat":"เริ่มแชท","On Stage":"ในพื้นที่งาน","Connect your on-site camera and microphone to present to your virtual attendees":"เชื่อมต่อกล้องและไมโครโฟนในสถานที่เพื่อนำเสนอแก่ผู้เข้าร่วมออนไลน์ของคุณ","Stop Streaming":"หยุดการสตรีม","Start Streaming":"เริ่มการสตรีม","Set up on-site video feed":"ตั้งค่าฟีดวิดีโอในไซต์","Open TV":"เปิดทีวี","Layout: {layout} ":"เลย์เอาต์: {layout} ","With Speaker Videos":"พร้อมวิดีโอจากลำโพง","Full Screen":"เต็มจอ","No Speakers":"ไม่มีลำโพง","Turn Off Setup Mode":"ปิดโหมดการตั้งค่า","Setup Mode":"โหมดการตั้งค่า","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"โปรดกดปิดหากคุณต้องการหยุดการตั้งค่าโหมดสำหรับ {roomTitle} การทำเช่นนี้จะปิดสตรีมที่ใช้งานอยู่ด้วย","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"กำลังเตรียมสตรีม: {roomTitle} โปรดใช้โหมดการตั้งค่าเพื่อสตรีมจากสถานที่ถ่ายทอดสดเท่านั้น","Starting in {duration}":"เริ่มใน {duration}","Can\'t share screen while there is something else being presented on stage":"ไม่สามารถแชร์หน้าจอได้ในขณะที่มีการนำเสนออย่างอื่นในพื้นที่งาน","You are now in attendee view!":"ขณะนี้คุณอยู่ในมุมมองของผู้เข้าร่วม!","You are now in organizer view!":"ขณะนี้คุณอยู่ในมุมมองผู้จัดงาน!","Note :":"บันทึก:","Only organizer accounts can see this tag, normal attendees can’t see this":"เฉพาะบัญชีผู้จัดงานเท่านั้นที่สามารถเห็นแท็กนี้ได้ ผู้เข้าร่วมทั่วไปจะไม่เห็นแท็กนี้","Attendee":"ผู้เข้าร่วม","Event Information":"ข้อมูลงานกิจกรรม","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"ข้อมูลงานกิจกรรมจะแสดงแก่ผู้จัดงานเท่านั้น! <br /> ส่วนนี้ไม่แสดงแก่ผู้เข้าร่วม","Operating System":"ระบบปฏิบัติการ","Secondary Booths":"บูธรอง","Sort":"จัดเรียง","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"กำลังติดตาม {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2}จะเลิกติดตามคุณโดยอัตโนมัติจาก{track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}คุณต้องการดำเนินการต่อหรือไม่","Track only available for {tracks}":"ติดตามได้เฉพาะสำหรับ {tracks}","Add to Calendar":"เพิ่มลงในปฏิทิน","Open Speakers Control Panel":"เปิดแผงควบคุมลำโพง","Move Offstage ↓":"ย้ายออกจากพื้นที่งาน ↓","Error Moving ⚠":"เกิดข้อผิดพลาดในการย้าย ⚠","Off Stage":"นอกพื้นที่งาน","Move to Stage":"ย้ายไปที่พื้นที่งาน","An error occurred!":"เกิดข้อผิดพลาด!","{eventName} Documents":"เอกสารเกี่ยวกับ {eventName}"," Set Up Mode":" ตั้งค่าโหมด","Camera & Mic blocked":"กล้องและไมโครโฟนถูกบล็อก","Camera/Mic Inaccessible":"กล้อง/ไมโครโฟนไม่สามารถเข้าถึงได้","Camera/Mic Not Found":"ไม่พบกล้อง/ไมโครโฟน","Camera Inaccessible":"กล้องไม่สามารถเข้าถึงได้","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"กล้องถูกใช้งานหรือไม่รองรับความละเอียด โปรดตรวจสอบว่าแอปพลิเคชันอื่นไม่ได้ใช้งานกล้องของคุณอยู่ แล้วลองอีกครั้ง!","No microphone/camera is found":"ไม่พบไมโครโฟน/กล้อง","The browser does not support using camera and microphone!":"เบราว์เซอร์ไม่รองรับการใช้กล้องและไมโครโฟน!","{n} Slides":"{n} สไลด์","Starting in {timeduration}":"เริ่มใน {timeduration}","{eventtitle} has ended":"{eventtitle} สิ้นสุดลงแล้ว","This is a text q&a question!":"นี่คือคำถามสำหรับช่วงถามตอบ!","Click here{if_it_does_not}":"คลิกที่นี่{if_it_does_not}","{click_here}if it does not":"{click_here}หากไม่เป็นเช่นนั้น","{title}up next":"{title}ต่อไป","seat(s) open":"ที่นั่งว่างอยู่","Signal strength is low. Close other windows or connect to a different network.":"ความแรงของสัญญาณต่ำ ปิดหน้าต่างอื่นหรือเชื่อมต่อกับเครือข่ายอื่น","GO BACKSTAGE":"ไปที่เบื้องหลัง","LEAVE STAGE":"ออกจากพื้นที่งาน","LEAVE":"ออก","This event begins on{startitme}":"งานกิจกรรมนี้เริ่มต้นเวลา {startitme}","Please refresh to enter.":"โปรดรีเฟรชเพื่อเข้าร่วม","people":"ผู้คน","Oops, Something went wrong":"ขออภัย เกิดข้อผิดพลาด","Back Home":"กลับไปที่หน้าหลัก","Deciding where to go ...":"ตัดสินใจว่าจะไปที่ไหน...","Go to Event Hub":"ไปที่ศูนย์กลางงานกิจกรรม","CREATE":"สร้าง","Attending Virtually":"เข้าร่วมทางออนไลน์","Attending In Person":"เข้าร่วมด้วยตนเอง","Click to change your attendance type":"คลิกเพื่อเปลี่ยนประเภทการเข้าร่วมของคุณ","Open Chat":"เปิดแชท","Create your profile for {eventtitle}":"สร้างโปรไฟล์ของคุณสำหรับ {eventtitle}","Move to stage":"ย้ายไปที่พื้นที่งาน","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"ผู้จัดงานกิจกรรมได้ขอย้ายคุณไปที่พื้นที่งานสำหรับ <strong>{broadcastTitle}</strong><br /><br />หากคุณคลิกเพื่อยอมรับคำขอ คุณจะถ่ายทอดสดและผู้เข้าร่วมงานกิจกรรมจะมองเห็นได้<br /><br />","Go Live On Stage":"ถ่ายทอดสดในพื้นที่งาน","Moved to backstage":"ย้ายไปที่เบื้องหลังแล้ว","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"ผู้จัดงานได้นำคุณออกจากพื้นที่งานแล้ว โปรดอย่าพยายามเข้าร่วมอีกครั้งโดยไม่ติดต่อกับผู้จัดงาน","Error creating Screen stream":"เกิดข้อผิดพลาดในการสร้างสตรีมหน้าจอ","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"ไม่ได้รับอนุญาตให้แชร์หน้าจอ โปรด*คลิกที่นี่*เพื่อดูเอกสารการแก้ไขปัญหา","Error publishing stream":"เกิดข้อผิดพลาดในการเผยแพร่สตรีม","Could not publish stream. Please refresh and try again!":"ไม่สามารถเผยแพร่สตรีมได้ โปรดรีเฟรชและลองอีกครั้ง!","Error publishing screen":"เกิดข้อผิดพลาดในการเผยแพร่หน้าจอ","Error publishing screen. Please refresh and try again!":"เกิดข้อผิดพลาดในการเผยแพร่หน้าจอ โปรดรีเฟรชและลองอีกครั้ง!","Error unpublishing stream":"เกิดข้อผิดพลาดในการยกเลิกการเผยแพร่สตรีม","Error unpublishing stream. Please refresh and try again!":"เกิดข้อผิดพลาดในการยกเลิกการเผยแพร่สตรีม โปรดรีเฟรชและลองอีกครั้ง!","Invalid Publish Operation":"การดำเนินการเผยแพร่ไม่ถูกต้อง","{username} profile picture":"รูปโปรไฟล์ {username}","Default":"ค่าเริ่มต้น","A-Z":"A-Z","Random":"แบบสุ่ม","All":"ทั้งหมด","Past":"ที่ผ่านมา","Upcoming":"ที่กำลังจะมาถึง","Learn More":"ดูข้อมูลเพิ่มเติม","close":"ปิด","Discussion Rooms":"ห้องสนทนา","ATTENDEE MODE":"โหมดผู้เข้าร่วม","Loading...":"กำลังโหลด...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"อุปกรณ์ถูกปิดใช้งานโดยเบราว์เซอร์หรือไม่ได้รับสิทธิ์ให้ใช้งาน โปรดให้สิทธิ์และคลิก \\"ลองอีกครั้ง\\"","You are now registered. You will receive an email confirming details shortly.":"ตอนนี้คุณได้ลงทะเบียนแล้ว คุณจะได้รับอีเมลยืนยันรายละเอียดในเร็วๆ นี้","Streaming to Virtual Users from on-site video feed":"การสตรีมไปยังผู้ใช้ออนไลน์จากฟีดวิดีโอในไซต์","Ending in ":"สิ้นสุดใน ","GO LIVE":"ถ่ายทอดสด","You have no past events.":"คุณไม่มีงานกิจกรรมที่ผ่านมา","You have no upcoming or live events.":"คุณไม่มีงานกิจกรรมที่กำลังจะมาถึงหรือถ่ายทอดสด","left":"ซ้าย","center":"ศูนย์กลาง","right":"ขวา","top":"ด้านบน","bottom":"ด้านล่าง","loading...":"กำลังโหลด...","Loading ...":"กำลังโหลด ...","Failed to redirect!":"ไม่สามารถเปลี่ยนเส้นทางได้!","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"ดูเหมือนคุณจะเปิดใช้งานตัวบล็อกโฆษณาอยู่ อาจทำให้คุณไม่มีประสบการณ์ที่ดีที่สุดเท่าที่จะเป็นไปได้ โปรดปิดใช้งาน<br />หากคุณต้องการความช่วยเหลือเกี่ยวกับวิธีการดำเนินการนี้ คลิก<a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>ที่นี่</a>เพื่อดูคำแนะนำเพิ่มเติม","redirecting in {duration}":"เปลี่ยนเส้นทางใน {duration}","STOP VIDEO":"หยุดวิดีโอ","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"คุณกำลังจะหยุดเล่นวิดีโอนี้ การออกอากาศของคุณจะกลับสู่โหมดถ่ายทอดสด และผู้ชมของคุณจะเห็นและได้ยินผู้พูด คุณแน่ใจไหม","STOP SHARING":"หยุดแชร์","No Next Slide":"ไม่มีสไลด์ถัดไป","Next Slide":"สไลด์ถัดไป","No Previous Slide":"ไม่มีสไลด์ก่อนหน้า","Previous Slide":"สไลด์ก่อนหน้า","something went wrong while recording the response please try again":"เกิดข้อผิดพลาดขณะบันทึกการตอบกลับ โปรดลองอีกครั้ง","Start In-Person Streaming":"เริ่มการสตรีมแบบเข้าร่วมด้วยตนเอง","Stop In-Person Streaming":"หยุดการสตรีมแบบเข้าร่วมด้วยตนเอง","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"วิดีโอของคุณมีการบัฟเฟอร์ และเซสชันการทดสอบจะเริ่มในไม่ช้า สิ่งนี้จะไม่เกิดขึ้นระหว่างเซสชันจริง","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"ทิกเกอร์จะปรากฏที่ด้านบนของหน้าเว็บสำหรับผู้เข้าร่วมทุกคน หากต้องการเปลี่ยนทิกเกอร์ให้เป็นไฮเปอร์ลิงก์ ให้ป้อน URL ด้านล่าง","Allow {key}":"อนุญาต {key}","{messageType} can only be published from inside a broadcast.":"สามารถเผยแพร่{messageType}ได้จากภายในการออกอากาศเท่านั้น","To grant {deviceName} access to this page, follow the two steps below:":"หากต้องการให้สิทธิ์ {deviceName} เข้าถึงหน้านี้ ให้ปฏิบัติตามสองขั้นตอนด้านล่าง:","2. Allow {deviceName} access and then refresh the page.":"2. อนุญาตการเข้าถึง {deviceName} จากนั้นรีเฟรชหน้าเว็บ"}');

/***/ }),

/***/ 8923:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Etkinlik Ayarı Açılır Menüsü"," Stage Control":" Sahne Kontrolü","Stage Controls and Information":"Sahne Kontrolleri ve Bilgileri","Live in ":"Canlı ","Start Session":"Oturumu Başlat","End Session":"Oturumu Sonlandır","Present Screen":"Mevcut Ekran","Rehearse On Stage":"Sahnede Prova Yap","Turn on Microphone":"Mikrofonu aç","Turn off Microphone":"Mikrofonu kapat","Turn on camera":"Kamerayı aç","Turn off camera":"Kamerayı kapat","rehearsal mode":"prova modu","People Watching: ${watchCount}":"İzleyen Kişi Sayısı: ${watchCount}","Turn on Audio":"Sesi aç","Turn off Audio":"Sesi kapat","Are you sure you want to leave this room?":"Bu odadan çıkmak istediğinizden emin misiniz?","you will be redirected to stage in":"saniye içinde sahneye","sec. . ":"yönlendirileceksiniz. ","Skip to Main Navigation":"Ana Gezinme Ekranına Geç","Skip to Chat":"Sohbete Geç","Skip to Meeting Controls":"Toplantı Kontrollerine Geç","LinkedIn":"LinkedIn","Live in":"Canlı","UPCOMING":"YAKLAŞAN","Rehearse on stage":"Sahnede prova yap","Watch Rehearsal":"Provayı İzle","Answered by:":"Yanıtlayan:","Speaker Off":"Hoparlör Kapalı","Speaker On":"Hoparlör Açık","Speaker Controls":"Hoparlör Kontrolleri","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"Tüm sahne öğeleri paylaşılan görüntünün arkasında bulunmaktadır.Tam ekran görüntü paylaşımı durdurulduğunda tekrar görünür olacaklar.","Close Ticker Popup":"Kayan Yazı Açılır Penceresini Kapat","Open GIF Picker":"GIF Seçiciyi Aç","Open Emoji Picker":"Emoji Seçiciyi Aç","Send Message":"Mesaj Gönder","Tabs: Messaging and More":"Sekmeler: Mesajlaşma ve Daha Fazlası","Thanks for attending!":"Katıldığın için teşekkürler!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" Abone olduğun parçada yaklaşan oturum yok. Canlı oturumları görmek için lütfen diğer parçalara geçin","Redirecting you to ":"Saniyeler ","in ":"içinde ","seconds":"yönlendirileceksiniz","Main Navigation":"Ana Gezinme Ekranı","YOU ARE HERE":"BURADASINIZ","Live Now":"Şimdi Canlı","SUBMIT":"GÖNDER","Allocated time for engagement has ended. You will be redirected to main stage":"Katılım için ayrılan süre sona erdi. Ana sahneye yönlendirileceksiniz","Wrap up in":"Sonlandırma zamanı","Session overrun by":"Oturum şu kadar kişi tarafından aşıldı:","Ending in":"Bitiş saati","Bring this session live?":"Bu oturum canlı yayınlansın mı?","START SESSION":"OTURUMU BAŞLAT","Bring this session to end?":"Bu oturum sonlandırılsın mı?","END SESSION":"OTURUMU SONLANDIR","Go On Stage":"Sahneye Çık","Muted by organizer":"Organizatör tarafından sessize alındı","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"Etkinlik organizatörlerinden biri sizi sessize aldı. Mikrofon düğmesine tıklayarak kendi sesinizi açabilirsiniz.","Gifs":"Gif\'ler","Stickers":"Çıkartmalar","Launch Survey":"Anketi Başlat","Microphone is on":"Mikrofon açık","Microphone is off":"Mikrofon kapalı","Secret Code’s length should be 6 digits":"Gizli Kod 6 haneli olmalıdır","Closing in 00:":"Kapanış 00:","Submit":"Gönder","Questions":"Sorular","Preview":"Önizleme","Close Survey":"Anketi Kapat","This is a required question":"Bu zorunlu bir sorudur","Enter the text you’d like to present on stage below.":"Sahnede sunmak istediğiniz metni aşağıya girin.","Use Chrome/Edge for best performance":"En iyi performans için Chrome/Edge kullanın","Do you want to launch your survey now?":"Anketinizi şimdi başlatmak istiyor musunuz?","Success! Your Survey has been launched for attendees.":"Başarılı! Anketiniz katılımcılar için başlatıldı.","Unable to publish. Please try again.":"Yayınlanamıyor. Lütfen tekrar deneyin.","Are you sure you want to close this survey?":"Bu anketi kapatmak istediğinizden emin misiniz?","Success! Your Survey has been closed for attendees.":"Başarılı! Anketiniz katılımcılar için kapatıldı.","Unable to un-publish. Please try again.":"Yayından kaldırılamıyor. Lütfen tekrar deneyin.","Please answer all required questions.":"Lütfen zorunlu tüm soruları yanıtlayın.","You have already submitted this survey.":"Bu anketi zaten gönderdiniz.","Success! Thank you for your feedback.":"Başarılı! Geri bildiriminiz için teşekkür ederiz.","Unable to submit. Please try again.":"Gönderilemiyor. Lütfen tekrar deneyin.","Launch surveys will take over attendees\' engagement panel.":"Anketi başlatma seçeneği katılımcıların katılım panelinin yerini alacaktır.","Closing this survey will remove it from attendees\' engagement panel.":"Bu anketin kapatılması, anket katılımcılarının katılım panelinden kaldırılmasına neden olacaktır.","Survey":"Anket","Updating Survey...":"Anket güncelleniyor...","Closing":"Kapatılıyor","Goldcast needs access to your camera and microphone":"Goldcast\'in kameranıza ve mikrofonunuza erişmesi gerekiyor","Goldcast needs access to your microphone":"Goldcast\'in mikrofonunuza erişmesi gerekiyor","Goldcast needs access to your camera":"Goldcast\'in kameranıza erişmesi gerekiyor","SPEAKERS":"HOPARLÖRLER","Mark as Unanswered":"Yanıtlanmadı olarak işaretle","Mark as Answered":"Yanıtlandı olarak işaretle","Remove from Priority":"Öncelikten kaldır","Mark as Priority":"Öncelik olarak işaretle","Answer":"Yanıtla","Enter answer...":"Yanıtı girin...","Answered by":"Yanıtlayan:","Submit Answer":"Yanıtı Gönder","Test your system’s speaker":"Sisteminizin hoparlörünü test edin","Click \\"Yes\\" if you hear the sound.":"Sesi duyuyorsanız \\"Evet\\" seçeneğine tıklayın.","Load previous":"Öncekini yükle","Hide Name":"Adı Gizle","Text Q&A is disabled in On Demand mode.":"Yazılı Soru-Cevap, On Demand modunda devre dışı bırakılır.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"Yazılı Soru-Cevap sınırına ulaşıldı. Katılımcılar yeni soru soramayacaktır.","Sent to Q&A":"Soru-Cevap bölümüne gönderildi","Couldn\'t post as Q&A. Please try again.":"Soru-Cevap olarak yayınlanamadı. Lütfen tekrar deneyin.","Yes this is being recorded":"Evet, bu kaydediliyor","No this is not being recorded":"Hayır, bu kaydedilmiyor","System\'s Speaker Check":"Sistem Hoparlör Kontrolü","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"Etkinlik sırasında duyabildiğinizden emin olmak için, sisteminizin hoparlörlerinin iyi çalıştığından emin olun","Click on “Test your system’s speaker” to proceed":"Devam etmek için “Sisteminizin hoparlörünü test edin” seçeneğine tıklayın","Error while sharing message to screen. Post not found":"Mesaj ekrana paylaşılırken hata oluştu. Gönderi bulunamadı","Lost connection to servers. Refresh your page to get live event experience.":"Sunucularla bağlantı kesildi. Canlı etkinlik deneyimi yaşamak için sayfanızı yenileyin.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"VPN/Güvenlik Duvarı kimlik doğrulamanızı engelliyor. <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>Bu alan adlarının</a> Goldcast\'e sorunsuz bir şekilde erişmesine izin vermek için lütfen ağını değiştirin veya BT ekibinizle bağlantı kurun.","It\'s taking too long":"Çok uzun sürüyor","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"VPN aracılığıyla bağlandığınız veya güvenlik duvarınızın açık olduğu görülüyor. Goldcast\'in sorunsuz çalışması için lütfen bu <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>yardım belgesine</a> bakın ve gerekli alan adlarını güvenilir adresler alın, aksi halde ağınızı değiştirmeniz gerekecektir","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"VPN aracılığıyla bağlandığınız veya güvenlik duvarınızın açık olduğu görülüyor. Goldcast\'in sorunsuz çalışması için lütfen bu <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>yardım belgesine</a> bakın ve gerekli alan adlarını güvenilir adresler alın, aksi halde ağınızı değiştirmeniz veya oturumu Lite Modunda izlemeniz gerekecektir","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"Goldcast video yayın hizmeti, yetersiz ağ bant genişliği nedeniyle bağlanamıyor. Canlı yayın hizmetine bağlanmak için lütfen ağınızı değiştirin.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"Goldcast video yayın hizmeti, yetersiz ağ bant genişliği nedeniyle bağlanamıyor. Yayın hizmetine bağlanmak için lütfen lite moduna geçin veya ağınızı değiştirin","Most Upvotes":"En Çok Oylananlar","Most Recent":"En Yeni","My Questions":"Sorularım","Prioritized":"Öncelikli","Approved":"Onaylı","Unapproved":"Onaylanmadı","Unanswered":"Yanıtlanmadı","Failed to update answer. Please try again!":"Yanıt güncellenemedi. Lütfen tekrar deneyin!","Failed to post answer. Please try again!":"Yanıt gönderilemedi. Lütfen tekrar deneyin!","Failed to delete question. Please try again!":"Soru silinemedi. Lütfen tekrar deneyin!","Survey Link":"Anket Bağlantısı","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"Geçiş yapılması geçerli sayfanızın yeniden katılımcı görünümüne yüklenmesine neden olacaktır. Organizatör görünümüne geri dönmek için profil açılır menüsünden katılımcı görünümünü kapatın.","You haven\'t asked any questions yet":"Henüz soru sormadınız","No prioritized questions":"Öncelikli soru yok","Create prioritized list of questions for speakers by marking questions as priority":"Soruları öncelikli olarak işaretleyerek konuşmacılar için öncelikli soru listesi oluşturun","No Approved Questions":"Onaylı Soru Yok","Approve incoming questions to see list of approved questions":"Onaylı soruların listesini görmek için gelen soruları onaylayın","No Unapproved Questions":"Onaylanmamış Soru Yok","No Answered Questions":"Yanıtlanmış Soru Yok","Answer a question on stage or with inline text":"Bir soruyu sahnede veya satır içi metin ile yanıtlayın","All questions are answered":"Tüm sorular yanıtlandı","Rate Your Experience":"Deneyiminizi Puanlayın","How satisfied are you with Goldcast?":"Goldcast\'ten ne kadar memnunsunuz?","What are the main reasons for your rating?":"Verdiğiniz puanın temel nedenleri nelerdir?","I am interested in seeing a demo of Goldcast":"Goldcast\'in demosunu görmek istiyorum","Thank You":"Teşekkürler","Your feedback was successfully submitted.":"Geri bildiriminiz başarıyla gönderildi.","Tell us how we can improve...":"Bize ürün ve hizmetlerimizi nasıl geliştirebileceğimizi söyleyin...","1 Slide":"1. Slayt","Your internet connection is unstable.":"İnternet bağlantınız stabil değil.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"Sessizde konuşuyormuşsunuz gibi görünüyor. Kendi sesinizi açmak için Mikrofon simgesine tıklayın","The registration could not be completed! Please check that this email is allowed to register for the event.":"Kayıt tamamlanamadı! Lütfen bu e-postanın etkinliğe kaydolmasına izin verildiğini kontrol edin.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Görünüşe göre bu etkinliğe zaten kaydolmuşsunuz! Size ulaşmadıysa, lütfen spam klasörünüzden kayıt onayınızı kontrol edin. Daha fazla yardıma ihtiyacınız varsa lütfen etkinliğin organizatörüyle iletişime geçin.","Your registration could not be completed. This event has reached its registration capacity.":"Kaydınız tamamlanamadı. Bu etkinlik kayıt kapasitesi sınırına ulaştı.","Image cannot be an svg":"Görsel svg formatında olamaz","This should be a valid linkedin url":"Bu geçerli bir Linkedin url\'si olmalıdır","This should be a valid twitter url":"Bu geçerli bir Twitter url\'si olmalıdır","This should be a valid url":"Bu geçerli bir url olmalıdır","Video":"Video","Read Less":"Daha Az Oku","live":"canlı","Opened":"Açıldı","In person only":"Yalnızca yüz yüze","Stage Stream":"Sahne Yayını","Streaming not available":"Yayın akışı kullanılamıyor","Close TV":"TV\'yi kapat","Streaming is not available for prerecorded and RTMP sessions":"Yayın akışı, önceden kaydedilmiş oturumlar ve RTMP oturumları için kullanılamaz","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Yüz yüze katılımcılarınızın sanal sahnenizde, slaytlar, Soru-Cevap vb. dahil, neler olduğunu görmesini sağlamak için bilgisayarınızı bir TV ekranına veya projektöre bağlayın. Bağlandıktan sonra TV\'yi AÇ seçeneğine tıklayın ve yeni pencereyi TV ekranınıza veya projektörünüze sürükleyin veya paylaşın. ","Close Setup Mode":"Kurulum Modunu Kapat","Help":"Yardım","upcoming":"yaklaşan","ended":"sonlandırıldı","Remove from favorites":"Favorilerden çıkar","Add to favorites":"Favorilere ekle","PLAY RECORDING":"KAYDI OYNAT","VIEW RECORDING":"KAYDI GÖRÜNTÜLE","VIEW RECORDINGS":"KAYITLARI GÖRÜNTÜLE","Virtual Backgrounds":"Sanal Arka Planlar","No Device Available":"Mevcut Cihaz Yok","Needs permission":"İzin gerekiyor","Device not detected":"Cihaz algılanmadı","Camera is on":"Kamera açık","Camera is off":"Kamera kapalı","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"Yansıtılan video izleyicilere yansıtılmaz. İzleyiciler her zaman yansıtılmamış videoyu görür","Mirror My Video":"Videomu Yansıt","Camera":"Kamera","1. Click on Safari > Settings for this\\n            website":"1. Bu \\n            web sitesi için Safari > Ayarlar seçeneğine tıklayın","1. Click the lock":"1. Tarayıcınızın adres çubuğundaki kilit","icon in your browser’s address bar":"simgesine tıklayın","3. Unmute":"3. Sesi açın","and":"ve","icons from stage control panel":"sahne kontrol panelindeki simgeler","icon from stage control panel":"sahne kontrol panelindeki simge","2. Set camera and microphone to “Allow”.":"2. Kamerayı ve mikrofonu “İzin ver” olarak ayarlayın.","2. Set camera to “Allow”.":"2. Kamerayı “İzin ver” olarak ayarlayın.","2. Set microphone to \\"Allow\\"":"2. Mikrofonu \\"İzin ver\\" olarak ayarlayın","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. \\"Goldcast\'in kameranıza ve mikrofonunuza erişmesine her zaman izin ver\\" seçeneğini seçin","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. \\"Goldcast\'in kameranıza erişmesine her zaman izin ver\\" seçeneğini seçin.","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. \\"Goldcast\'in mikrofonunuza erişmesine her zaman izin ver\\" seçeneğini seçin","Questions?":"Sorunuz mu var?","If you’re having issues, check out our comprehensive":"Sorun yaşıyorsanız kapsamlı","help docs":"yardım belgelerimize göz atın","Speaker is on":"Hoparlör açık","Stop Test":"Testi Durdur","Test your system’s audio":"Sisteminizin sesini test edin","Still can\'t hear any sound?":"Hala hiçbir ses duyamıyor musunuz?","Microphone":"Mikrofon","Audio is being played in system\'s default audio device.":"Ses, sistemin varsayılan ses cihazında çalınıyor.","Click to view/change audio device":"Ses cihazını görüntülemek/değiştirmek için tıklayın","Speaker":"Hoparlör","Play Recording":"Kaydı Oynat","Recording for this broadcast is currently being processed and will be available soon":"Bu yayının kaydı şu anda işleniyor ve yakında kullanıma sunulacak","You haven\'t favorited anything yet!":"Henüz favorilerinize hiçbir şey eklemediniz!","Add an item to favorites by selecting the ♡ in the top right corner.":"Sağ üst köşedeki ♡ simgesini seçerek favorilere bir öğe ekleyin.","Session has ended":"Oturum sonlandırıldı","System Check":"Sistem Kontrolü","Need help? Check out the":"Yardıma mı ihtiyacınız var? Şunları kontrol edin","Skip Checks and Continue":"Kontrolleri Atla ve Devam Et","Click the button above to run the test":"Testi çalıştırmak için yukarıdaki düğmeye tıklayın","Test Screenshare":"Ekran Paylaşımını Test Et","Share message to stage":"Mesajı sahneye paylaşın","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"Sahnede sunmak istediğiniz kayan yazıyı aşağıya girin. Kayan yazıyı köprüye dönüştürmek için bir URL girin.","Ticker":"Kayan yazı","Coffee Break! Be back in 10m.":"Kahve Molası! 10 dakika sonra döneceğim.","Enter Message":"Mesaj Girin","https://www.xyz.com":"https://www.xyz.com","Launch":"Başlat","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Sorularınızı gönderdiğiniz için teşekkür ederiz. Mevcut sorularınızdan biri onaylandıktan sonra başka bir soru gönderebileceksiniz.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"Üzgünüz! Soru-Cevap şu an için devre dışı. Soru-Cevap tekrar etkinleştirildiğinde soru gönderebileceksiniz.","Votes":"Oylar","Vote":"Oy","is inviting you to a video call":"sizi bir görüntülü aramaya davet ediyor","ENTER ROOM":"ODAYA GİR","Start the conversation!":"Konuşmayı başlatın!","Couldn\'t send message. Click here to retry.":"Mesaj gönderilemedi. Tekrar denemek için buraya tıklayın.","Couldn\'t add emoji. Please try again.":"Emoji eklenemedi. Lütfen tekrar deneyin.","Couldn\'t remove emoji. Please try again.":"Emoji kaldırılamadı. Lütfen tekrar deneyin.","Couldn\'t delete message. Please try again.":"Mesaj silinemedi. Lütfen tekrar deneyin.","Couldn\'t pin message. Please try again.":"Mesaj sabitlenemedi. Lütfen tekrar deneyin.","Couldn\'t unpin message. Please try again.":"Mesajın sabitlemesi kaldırılamadı. Lütfen tekrar deneyin.","Today":"Bugün","No messages yet":"Henüz mesaj yok","Messages from organizers and speakers appear here!":"Organizatörlerden ve konuşmacılardan gelen mesajlar burada görünür!","Next Session is Starting":"Bir Sonraki Oturum Başlıyor","Go to Next Session":"Bir Sonraki Oturuma Git","I’d like to stay":"Kalmak istiyorum","My favorites":"Favorilerim","1. Click on the lock icon in your address bar":"1. Adres çubuğunuzdaki kilit simgesine tıklayın","We recommend organizers and speakers use a desktop\\n        device":"Organizatörlerin ve konuşmacıların masaüstü\\n        cihaz kullanmalarını öneririz","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"Katılımcılara iyi deneyimi sunmak için, konuşmacılar ve organizatörler\\n        Goldcast\'i masaüstü bilgisayardan kullanmalıdır. Mobil cihazdan yayın yapmak\\n        deneyimin olumsuz etkilenmesine neden olacaktır.","Watch Now":"Şimdi İzle","Video progress time":"Video ilerleme süresi","Total video duration":"Toplam video süresi","Rate Goldcast!":"Goldcast\'i Puanlayın!","Running Required Checks...":"Gerekli Kontroller Gerçekleştiriliyor...","Test Your Setup":"Kurulumunuzu Test Edin","Test your Computer Device, Microphone and Camera before you join the event":"Etkinliğe katılmadan önce Bilgisayarınızı, Mikrofonunuzu ve Kameranızı test edin","Speaker and microphone not working?":"Hoparlör ve mikrofon çalışmıyor mu?","Passed":"Başarılı","Fix Audio Issues":"Ses Sorunlarını Giderin","Check if audio is being played in other sound devices connected to phone/tablet":"Telefona/tablete bağlı diğer ses cihazlarından ses gelip gelmediğini kontrol edin","Check if correct audio device is chosen from the below dropdown":"Aşağıdaki açılır menüden doğru ses cihazının seçilip seçilmediğini kontrol edin","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"Sesin gelmesi gereken yerde doğru ses cihazının seçilip seçilmediğini kontrol etmek için <a href=\'ms-settings:sound\'>Buraya tıklayın</a>","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"Sesin gelmesi gereken yerde doğru ses cihazının seçilip seçilmediğini kontrol etmek için <a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Buraya tıklayın</a>","Right click on the browser tab & click “Unmute Site”":"Tarayıcı sekmesine sağ tıklayın ve “Sitenin Sesini Aç” seçeneğine tıklayın","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Tarayıcı sekmesi sesinin açık olup olmadığını kontrol edin veya Pencere > Bu sekmenin sesini aç seçeneğine tıklayın","System Check Failed!":"Sistem Kontrolü Başarısız!","System Check Passed!":"Sistem Kontrolü Başarılı!","Complete checks to proceed":"Devam etmek için kontrolleri tamamlayın","Enter Event":"Etkinliğe Gir","Skip Screen Sharing Check? ":"Ekran Paylaşımı Kontrolü atlansın mı? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"Etkinlikte ekranınızın sunulması gerekiyorsa ekran paylaşımı kontrolünü tamamlamanızı öneririz","Ignore & Enter Event":"Yoksay ve Etkinliğe Gir","Test screenshare":"Ekran paylaşımını test et","Retry Now":"Şimdi Tekrar Dene","SHARE":"PAYLAŞ","Rooms Closed":"Odalar Kapalı","Discussion rooms are now closed. You are being redirected to the Stage.":"Tartışma odaları artık kapalı. Sahneye yönlendiriliyorsunuz.","Return To Stage":"Sahneye Geri Dön","Unrecognized embedded widget provider - ":"Tanınmayan yerleşik widget sağlayıcısı - ","Room Ended":"Oda Sonlandırıldı","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"Etkinlik organizatörünüz tüm Odaları kapattı. Şimdi etkinlik sahnesine yönlendirileceksiniz.","Video Q&A Request Cancelled":"Görüntülü Soru-Cevap İsteği İptal Edildi","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Görüntülü Soru-Cevap isteğiniz, Lite Modunda görüntülediğiniz için iptal edildi. Tekrar El Kaldırmak için Canlı Moda geçin.","Camera Passed":"Kamera Başarılı","Camera Error":"Kamera Hatası","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"Tarayıcıdan kamera izinleri alınamıyor. “Kameraya İzin Ver” seçeneğine tıklayın.","Camera permissions aren’t granted from system. Click “Allow Camera”":"Sistemden kamera izinleri alınamıyor. “Kameraya İzin Ver” seçeneğine tıklayın","Uh-oh! Error occurred while creating camera stream":"Olamaz! Kamera akışı oluşturulurken hata oluştu","Close other applications which might use camera stream":"Kamera akışını kullanabilecek diğer uygulamaları kapatın","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"Tarayıcının kameraya erişimi olup olmadığını kontrol etmek için <a href=\'ms-settings:privacy-webcam\'>buraya tıklayın</a>","Microphone Passed":"Mikrofon Başarılı","Microphone Error":"Mikrofon Hatası","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"Tarayıcıdan mikrofon izinleri alınamıyor. \\"Mikrofona İzin Ver\\" seçeneğine tıklayın","Mic permissions aren’t granted from system. Click “Allow Microphone”":"Sistemden mikrofon izinleri alınamıyor. \\"Mikrofona İzin Ver\\" seçeneğine tıklayın","Uh-oh! Error occurred while creating mic stream":"Olamaz! Mikrofon akışı oluşturulurken hata oluştu","Close other applications which might use mic stream":"Mikrofon akışını kullanabilecek diğer uygulamaları kapatın","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"Tarayıcının mikrofona erişimi olup olmadığını kontrol etmek için <a href=\'ms-settings:privacy-microphone\'>buraya tıklayın</a>","Speaker and Microphone Error":"Hoparlör ve Mikrofon Hatası","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"Sisteme bağlı hoparlör cihazlarının listesini göstermek için mikrofon izinleri gerekir. \\"Mikrofona İzin Ver\\" seçeneğine tıklayın","It seems mic is being used by other application. Close other applications to proceed.":"Mikrofon başka bir uygulama tarafından kullanılıyor gibi görünüyor. Devam etmek için diğer uygulamaları kapatın.","Camera & Microphone Error":"Kamera ve Mikrofon Hatası","To enable permissions, click the Allow Camera & Mic button below":"İzinleri etkinleştirmek için aşağıdaki Kameraya ve Mikrofona İzin Ver düğmesine tıklayın","Network Connection":"Ağ Bağlantısı","Check Passed":"Kontrol Başarılı","Could not establish a network connection":"Ağ bağlantısı kurulamadı","Connect to a different network, or use a mobile hotspot.":"Farklı bir ağa bağlanın veya bir mobil erişim noktası kullanın.","Disable any VPN or firewall is connected.":"Bağlı VPN\'leri veya güvenlik duvarını devre dışı bırakın.","Connection: Good":"Bağlantı: İyi","Network Connection Error":"Ağ Bağlantısı Hatası","Can’t connect to network. Change your network or limited functionality will be available during event.":"Ağa bağlanılamıyor. Ağınızı değiştirin, aksi halde etkinlik sırasında bazı işlevlerin kullanımı sınırlandırılacaktır.","AdBlocker":"AdBlocker","AdBlocker not detected.":"AdBlocker algılanmadı.","AdBlocker detected. This may degrade your event experience.":"AdBlocker algılandı. Bu, etkinlik deneyiminizi olumsuz etkileyebilir.","Disable adblocker for best experience.":"En iyi deneyim için reklam engelleyiciyi devre dışı bırakın.","You are using ":"Şunu kullanıyorsunuz: ","Use Windows or Mac OS for best performance":"En iyi performans için Windows veya Mac OS kullanın","Browser Check":"Tarayıcı Kontrolü","Check Passed.":"Kontrol Başarılı.","Switch To Lite Mode":"Lite Moduna Geç","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Bekleyen Görüntülü Soru-Cevap isteğiniz, lite moduna geçtiğinizde iptal edilecektir","Stay on Live Mode":"Canlı Modda Kal","Unable to mark as favorite":"Favori olarak işaretlenemiyor","Event organizers must enter the event to select favorites.":"Etkinlik organizatörlerinin favorileri seçebilmeleri için etkinliğe girmeleri gerekir.","Make an Announcement":"Duyuru Yap","STOP":"DURDUR","InPerson CheckIn App":"InPerson CheckIn Uygulaması","App to Check-In In-Person attendees":"Yüz Yüze Katılımcı Kontrolüne Başvur","SEE AGENDA":"AJANDAYI GÖR","Please visit the Agenda tab to view the session recordings":"Oturum kayıtlarını görüntülemek için lütfen Ajanda sekmesini ziyaret edin","The session recordings will be available soon in the Agenda tab":"Oturum kayıtları yakında Ajanda sekmesinden bulunabilecek","FAILED!":"BAŞARISIZ!","Next session is beginning":"Bir sonraki oturum başlıyor","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"Bir sonraki oturuma geçmek istiyor musunuz? Yayın akışınız devam edecek ve TV\'nizde yeni oturum yayınlanacaktır.","Banners":"Banner\'lar","Images":"Görseller","Screen Share":"Ekran Paylaşımı","Browser might not have screen-recording permission on your computer.":"Tarayıcının bilgisayarınızda ekran kaydetme izni olmayabilir.","Open System Preferences":"Sistem Tercihlerini Aç","Error publishing screen because someone else started screen share already.":"Halihazırda başka birisi tarafından ekran paylaşımını başlatıldığı için ekran yayınlanırken hata oluştu.","Live Feed":"Canlı Yayın","Check Your Network":"Ağınızı Kontrol Edin","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"Videoyu oynatırken bir hata tespit ettik! Video oynatmayla ilgili sorun yaşıyorsanız lütfen sayfayı yenilemeyi veya lite moduna geçmeyi deneyin.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"Videoyu oynatırken bir hata tespit ettik! Video oynatmayla ilgili sorun yaşıyorsanız lütfen sayfayı yenilemeyi deneyin.","All Dates":"Tüm Tarihler","All Tracks":"Tüm Parçalar","Create Ticker":"Kayan Yazı Oluştur","Booths Closed":"Stantlar Kapalı","Your event organizer has closed all the booths. You will now be redirected to the stage":"Etkinlik organizatörünüz tüm stantları kapattı. Şimdi sahneye yönlendirileceksiniz","Visit the Polls tab to view live results.":"Canlı sonuçları görüntülemek için Oylama sekmesini ziyaret edin.","A new poll is open! Visit the Polls tab to vote.":"Yeni bir oylama açıldı! Oy vermek için Oylama sekmesini ziyaret edin.","Vote for Polls":"Oylama için oy kullanın","Go to Polls Tab":"Oylama Sekmesine Git","Microphone audio too low":"Mikrofon sesi çok düşük","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"Sesinizle ilgili bir sorun tespit ettik. Sorun devam ederse, sesi kapatmayı/sesi açmayı veya başka bir cihaz kullanmayı denemenizi öneririz.","Audio/Video bitrate too low":"Ses/Görüntü bit hızı çok düşük","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"Ağ güvenlik duvarı ayarlarınız A/V yayın akışını engelliyor. Farklı bir ağ bağlantısına geçmenizi öneririz.","Error sharing screen":"Ekran paylaşımı hatası","A network error occurred while sharing screen. Please check your network connection.":"Ekran paylaşılırken bir ağ hatası oluştu. Lütfen ağ bağlantınızı kontrol edin.","Apologies, due to some errors, we need to refresh the page!":"Özür dileriz. Bazı hatalar nedeniyle sayfayı yenilememiz gerekiyor!","Warning":"Uyarı","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"Görüntünüzle ilgili bir sorun tespit ettik. Bu sorunu çözmek için cihazınızda çalışan diğer tarayıcı sekmelerini veya diğer uygulamaları kapatmayı denemenizi ve internet bağlantınızı kontrol etmenizi/yükseltmenizi öneririz.","No results found":"Sonuç bulunamadı","Audio":"Ses","Please choose another microphone and camera":"Lütfen başka bir mikrofon ve kamera seçin","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"Şu anda seçili olan mikrofon ve kamera çalışmıyor. Lütfen aşağıdaki açılır menülerden başka bir mikrofon ve kamera seçin.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"Şu anda seçili olan kamera çalışmıyor. Lütfen aşağıdaki açılır menüden başka bir kamera seçin.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"Kamera olmadan devam edebilirsiniz, ancak sorunsuz bir yayın deneyimi için çakışmayı çözmenizi öneririz","Please choose another microphone":"Lütfen başka bir mikrofon seçin","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"Şu anda seçili olan mikrofon çalışmıyor. Lütfen aşağıdaki açılır menüden başka bir mikrofon seçin.","Please check that your TV speaker is correct":"Lütfen TV hoparlörünüzün doğru olduğunu kontrol edin","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"Şu anda seçili olan hoparlör çalışmıyor. Lütfen aşağıdaki açılır menüden başka bir hoparlör seçin.","Your answer":"Yanıtınız","Edit":"Düzenle","Delete":"Sil","Settings":"Ayarlar","Signing Out":"Çıkış Yapılıyor","Confirming your account...":"Hesabınız doğrulanıyor...","Something Went Wrong. Please Retry :(":"Bir Şeyler Ters Gitti. Lütfen Tekrar Deneyin :(","Resending Mail":"Posta Tekrar Gönderliyor","offline":"çevrimdışı","I am inviting you to a video meeting:":"Sizi bir görüntülü toplantıya davet ediyorum:","Resending secure login link to your email":"E-postanıza güvenli oturum açma bağlantısı tekrar gönderiliyor","Sending secure login link to your email":"E-postanıza güvenli oturum açma bağlantısı gönderiliyor","Something went Wrong. Please Retry :(":"Bir şeyler ters gitti. Lütfen Tekrar Deneyin :(","Updating your password":"Şifreniz güncelleniyor","Sending mail":"Posta gönderiliyor","Verifying":"Doğrulanıyor","This might be slower than usual":"Bu normalden daha yavaş olabilir","Checking":"Kontrol ediliyor","New results available! Refresh!":"Yeni sonuçlar mevcut! Yenile!","Saving":"Kaydediliyor","Turn off Attendee mode":"Katılımcı modunu kapat","See Attendee View":"Katılımcı Görünümünü Gör","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Şu anda bu oturumu görüntüleyen toplam katılımcı sayısı Not: Bunu yalnızca organizatör görebilir","Session Count":"Oturum Sayısı","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"Şu anda canlı oturumları izleyen katılımcı sayısı. Not: Bunu yalnızca organizatör görebilir","Role":"Rol","Total Attendees":"Toplam Katılımcı Sayısı","Total number of attendees online at this time Note: This is for organizer eyes only":"Şu anda çevrimiçi olan toplam katılımcı sayısı Not: Bunu yalnızca organizatör görebilir","My Profile":"Profilim","Languages":"Diller","Filling out your profile can help you connect with people with similar interests.":"Profilinizi doldurmak, benzer ilgi alanlarına sahip kişilerle bağlantı kurmanıza yardımcı olabilir.","type to search for your address":"adresinizi aramak için yazın","Could not open direct call":"Doğrudan arama açılamadı","Chat messages can only be published from inside a broadcast.":"Sohbet mesajları yalnızca yayının içinden yayınlanabilir.","Stage Logo can only be published from inside a broadcast.":"Sahne Logosu yalnızca yayın içinden yayınlanabilir.","Loading Speakers":"Hoparlörler Yükleniyor","Raise hand is disabled for organizer accounts, but active for attendee accounts":"El kaldırma, organizatör hesapları için devre dışı bırakıldı, ancak katılımcı hesapları için etkin","Disabled in lite mode, return to live if you’d like to raise hand!":"Lite modunda devre dışı bırakıldı, el kaldırmak istiyorsanız canlı yayına dönün!","Raise hand to enter stage for video q&a":"Görüntülü soru-cevap sahnesine girmek için el kaldırın","Speakers":"Konuşmacılar","Hosting organization: {organization}":"Sunumu yapan organizasyon: {organization}","Failed to switch {deviceTag}":"{deviceTag} cihazına geçilemedi","Make sure your {deviceTag} is not being used by any other application and is working properly.":"{deviceTag} cihazınızın başka bir uygulama tarafından kullanılmadığından ve düzgün çalıştığından emin olun.","Facing issues with audio or video? Switch on lite mode":"Ses veya görüntüyle ilgili sorunlarla mı karşılaşıyorsunuz? Lite moduna geç","Failed to get event for eventID: {eventID}":"{eventID} etkinlik kimliği için etkinlik alınamadı","Error while playing video.":"Video oynatılırken hata oluştu.","Speakers only, attendees can\'t see this chat":"Yalnızca konuşmacılar, katılımcılar bu sohbeti göremez","Kudo":"Ödül","Room":"Oda","Session":"Oturum","Booth":"Stant","Public":"Genel","Drift":"Sürükle","Slides":"Slaytlar","Videos":"Videolar","Chat":"Sohbet","Messages":"Mesajlar","Poll":"Oylama","Docs":"Belgeler","Q&A":"Soru-Cevap","Media":"Medya","Messages Chat":"Yazılı Sohbet","Leaderboard":"Liderlik panosu","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Not: Ayrıca bu etkinlikte konuşmacısınız. Her zaman Sahne arkası alanına girip sahneye çıkabileceksiniz.","Switch to Attendee View":"Katılımcı Görünümüne Geç","Return to Organizer View":"Organizatör Görünümüne Geri Dön","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"Katılımcı görünümünün kapatılması, geçerli sayfanızın yeniden yüklenmesine ve katılımcı görünümüne geri dönmenize neden olacaktır. Devam etmek istiyor musunuz?","Switch":"Geçiş yap","Request Sent":"İstek Gönderildi","Your request for a demo has been submitted":"Demo isteğiniz gönderildi","Organizer Redirection":"Organizatör Yönlendirme","YES, REDIRECT":"EVET, YÖNLENDİR","DISMISS":"YOKSAY","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"Katılımcılar bir sonraki oturuma yönlendiriliyor: {title}. Bir sonraki oturuma da yönlendirilmek istiyor musunuz?","Stage":"Sahne","Rooms":"Odalar","Join a round table to discuss moderated topics with your fellow attendees":"Makul konuları katılımcı arkadaşlarınızla tartışmak için bir yuvarlak masa toplantısına katılın","Booths":"Stantlar","Join a booth to know more about a sponsor":"Sponsor hakkında daha fazla bilgi edinmek için standa katılın","You are in the booth":"Stanttasınız","People":"Kişi","Connect with your fellow attendees":"Katılımcı arkadaşlarınızla bağlantı kurun","Connect with speakers":"Konuşmacılarla bağlantı kurun","starting in {duration}":"{duration} içinde başlıyor","You will be redirected to booths in {duration}":"{duration} içinde stantlara yönlendirileceksiniz","booths":"stantlar","agenda":"ajanda","You will be redirected to {word} in {duration}":"{duration} içinde {word} konumuna yönlendirileceksiniz","You will be redirected to the live stage in {duration}":"{duration} içinde canlı sahneye yönlendirileceksiniz","- You are about to be redirected to {tabTitle} in {duration}":"- {duration} içinde {tabTitle} sekmesine yönlendirilmek üzeresiniz","See Agenda":"Ajandayı Gör","Break":"Mola","{title} is now live":"{title} şimdi yayında","Apologies, due to an error we need to refresh the page!":"Özür dileriz. Bir hata nedeniyle sayfayı yenilememiz gerekiyor!","Network interruption detected":"Ağ kesintisi algılandı","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"İnternet bağlantınızda bazı sorunlar var. VPN kullanıyorsanız, devre dışı bırakmanız işe yarayabilir. Alternatif olarak farklı bir ağa bağlanmayı deneyin","No audio output device detected":"Ses çıkış cihazı algılanmadı","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Lütfen hoparlörlerinizi/kulaklıklarınızı bağlayın ve herhangi bir sorunla karşılaşırsanız bunları test etmek için dişli (ayarlar) simgesini kullanın.","Please disable ad blocker for this page":"Lütfen bu sayfa için reklam engelleyiciyi devre dışı bırakın","Yes, I understand":"Evet, anladım","No event user found so attended not marked!":"Katıldığı işaretlenmemiş hiçbir etkinlik kullanıcısı bulunamadı!","Wait while the speaker approves your video q&a request":"Konuşmacı görüntülü soru-cevap isteğinizi onaylayana kadar bekleyin","Organizer":"Organizatör","UPNEXT":"BİR SONRAKİ","Ended":"Sonlandırıldı","Hide":"Gizle","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"Bu sayfa sizi {durationLeftToRedirect} saniye içinde otomatik olarak yönlendirecektir.","Register":"Kaydol","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Hata: Kullanıcı bu etkinliğe kaydolamıyor. Yardım için lütfen etkinliğin organizatörüyle iletişime geçin","You are already registered!":"Zaten kaydoldunuz!","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Görünüşe göre bu etkinliğe zaten kaydolmuşsunuz! Size ulaşmadıysa, lütfen spam klasörünüzden kayıt onayınızı kontrol edin. Daha fazla yardıma ihtiyacınız varsa lütfen etkinliğin organizatörüyle iletişime geçin","Thank you for registering!":"Kaydolduğunuz için teşekkürler!","Submit another response":"Başka bir yanıt gönder","Share":"Paylaş","Know someone who want to attend this?":"Buna katılmak isteyen birini tanıyor musunuz?","COPY LINK":"BAĞLANTIYI KOPYALA","Powered by":"Destekleyen","VIEW PROFILE":"PROFİLİ GÖRÜNTÜLE","You can access the event landing here":"Etkinlik girişine buradan ulaşabilirsiniz","Need Help?":"Yardıma mı İhtiyacınız Var?","Welcome back":"Tekrar hoş geldiniz","Checking...":"Kontrol ediliyor...","Close":"Kapat","Enter":"Gir","See {roomCount} Room(s)":"{roomCount} Odayı Gör","Back":"Geri","Request a Demo":"Demo İste","Loading":"Yükleniyor","Thread":"Film şeridi tak","Load more":"Daha fazla yükle","Heads up!":"Dikkat!","YES":"EVET","No":"Hayır","Following":"Takip ediliyor","Error in loading drimify":"Drimify yüklenirken hata oluştu","You\'re not registered for this event":"Bu etkinliğe kaydolmadınız","Check out other events":"Diğer etkinliklere göz atın","Date":"Tarih","Location":"Konum","How are you attending the event":"Etkinliğe nasıl katılıyorsunuz?","In Person":"Yüz yüze","Virtually":"Sanal","Event Widgets":"Etkinlik Widget\'ları","Chat • Messages • Q&A • Poll • Docs":"Sohbet • Mesajlar • Soru-Cevap • Oylama • Belgeler","DISCUSSION":"TARTIŞMA","JOIN":"KATIL","WAIT":"BEKLE","more":"daha fazla","See Profile":"Profili Gör","Filter":"Filtre","Video player not supported by your browser":"Video oynatıcı tarayıcınız tarafından desteklenmiyor","We recommend using the latest version of Google Chrome to access your conference":"Konferansınıza erişmek için Google Chrome\'un en son sürümünü kullanmanızı öneririz","ANSWER":"YANITLA","REJECT":"REDDET","Don’t ask me this next time":"Bir dahaki sefere bunu sorma","Cancel":"İptal et","Lite Mode":"Lite Modu","On":"Açık","Connection Issues? Turn on Lite Mode":"Bağlantı sorunları mı yaşıyorsunuz? Lite Modunu aç","Turn On Lite Mode":"Lite Modunu Aç","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"Lite modu, canlı yayın ile ekranınızda göreceğiniz görüntü arasında 30 saniyelik bir gecikmeye neden olur. Devam etmek istiyor musunuz?","Turn On":"Aç","Lite Mode Active!":"Lite Modu Devrede!","Thanks for your patience, lite mode now on!":"Beklediğiniz için teşekkürler. Lite modu şimdi devrede!","Turn off Lite Mode?":"Lite Modu kapatılsın mı?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Canlı yayını izlemeye geri dönmek için lite modu kapatılıyor. Dikkat! Biz yetişmeye çalışırken, bu 30 saniyelik bir farka neden olacak.","Lite Mode Off!":"Lite Modu Kapalı!","Thanks for your patience, we’ve returned to the live broadcast!":"Beklediğiniz için teşekkürler. Canlı yayına geri döndük!","Lite Mode Unavailable":"Lite Modu Kullanılamıyor","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Verdiğimiz rahatsızlıktan dolayı özür dileriz. Lite modu şu anda kullanılamıyor. Oturumunuza devam etmek için lütfen Canlı Yayına geçin.","Turn off Lite mode?":"Lite modu kapatılsın mı?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"Bağlantınızın normale döndüğünü tespit ettik. Canlı yayına geri dönmek istiyor musunuz? Dikkat! Biz yetişmeye çalışırken, bu 30 saniyelik bir farka neden olacak.","Turn Off":"Kapat","Lite mode is disabled for organizer accounts, but active for attendee accounts":"Lite modu, organizatör hesapları için devre dışı bırakıldı, ancak katılımcı hesapları için etkin","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"Lite modu tarayıcınızda desteklenmiyor. Google Chrome\'un en son sürümünü kullanmanızı öneririz","Lite mode is not curently available. We’ll let you know once it’s available again":"Lite modu şu anda kullanılamıyor. Tekrar kullanılabildiğinde sizi bilgilendireceğiz","Turn off Lite Mode":"Lite Modunu kapat","We’ll let you know when Lite mode is available again":"Lite modu tekrar kullanılabildiğinde sizi bilgilendireceğiz","Lite Mode Available":"Lite Modu Kullanılabiliyor","Loading Lite Mode...":"Lite Modu yükleniyor...","Turning Off Lite Mode":"Lite Modunu Kapat","Lite Mode On":"Lite Modu Açık","Audio/Video Issues?":"Ses/Görüntü Sorunları mı yaşıyorsunuz?","Error":"Hata","Click a video to play":"Oynatmak için bir videoya tıklayın","Error starting video!":"Video başlatılırken hata oluştu!","Please rotate your device to {mode} mode":"Lütfen cihazınızı {mode} moduna döndürün","landscape":"yatay","portrait":"dikey","Thank you for attending this event!":"Bu etkinliğe katıldığınız için teşekkür ederiz!","Go to Rooms":"Odalara Git","Please use a desktop or laptop Google Chrome browser to access your conference":"Konferansınıza erişmek için lütfen bir masaüstü veya dizüstü bilgisayar Google Chrome tarayıcısı kullanın","If on Desktop":"Masaüstü durumunda","Please increase the width of your window":"Lütfen pencerenizin genişliğini artırın","Alternatively, check out the":"Alternatif olarak şuraya göz atın:","Youtube Livestream":"Youtube Canlı Yayını","Search":"Ara","Profile":"Profil","Yes":"Evet","Loading Chat":"Sohbet Yükleniyor","Please wait while we fetch the chat":"Sohbeti getirirken lütfen bekleyin","Load old messages":"Eski mesajları yükle","Join the room to see chat":"Sohbeti görmek için odaya katılın","Live Chat":"Canlı Sohbet","Uh..oh we couldn\'t load the content":"Olamaz! İçeriği yükleyemedik","Please reload the page":"Lütfen sayfayı yeniden yükleyin","New comments":"Yeni yorumlar","Start the conversation":"Konuşmayı başlatın","Be the first to add to chat!":"Sohbete ilk katılan siz olun!","Enter your message":"Mesajınızı girin","Joining chat!":"Sohbete katılıyorsunuz!","See all pinned messages":"Tüm sabitlenen mesajları görün","Failed to send! Retry?":"Gönderilemedi! Tekrar denemek istiyor musunuz?","Search for attendee":"Katılımcı ara","Up to date":"Güncel","Start a new conversation, We think you\'ll enjoy":"Yeni bir konuşma başlatın. Bu önerilen katılımcılarla sohbet etmenin","chatting with these recommended attendees!":"hoşunuza gideceğini düşünüyoruz!","Searching":"Aranıyor","Load Previous":"Öncekini Yükle","Load Next":"Sonrakini Yükle","Loading Channel":"Kanal Yükleniyor","Please wait while we fetch the channel":"Kanalı getirirken lütfen bekleyin","Please wait while we fetch the messages":"Mesajları getirirken lütfen bekleyin","Send the first message":"İlk mesajı gönderin","Join":"Katıl","link":"bağlantı","download":"indir","Click to open":"Açmak için tıklayın","No open polls":"Açık oylama yok","Check back later to see if a poll opens up!":"Bir oylama açılıp açılmadığını görmek için daha sonra tekrar kontrol edin!","Loading Poll":"Oylama Yükleniyor","Please wait while we fetch the polls":"Oylamayı getirirken lütfen bekleyin","Uh oh.. we couldn’t load the content":"Olamaz! İçeriği yükleyemedik","Polls":"Oylama","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"Bir Oylama başlatmak için Goldcast Yönetici Panelinde bu oturuma soruyu ve yanıtları ekleyin","Stop Sharing":"Paylaşmayı Durdur","Can\'t publish polls while something else is being presented on stage":"Sahnede başka bir şey sunulurken oylama yayınlanamaz","Open":"Aç","Cancel your video q&a request":"Görüntülü soru-cevap isteğinizi iptal edin","Pending...":"Beklemeye alınıyor...","Leave Stage":"Sahneden Ayrıl","Raise Hand":"El Kaldır","Text Q&A":"Yazılı Soru-Cevap","Video Q&A":"Görüntülü Soru-Cevap","Loading Q&amp;A":"Soru-Cevap Yükleniyor","Please wait while we fetch the Q&amp;A":"Soru-Cevabı getirirken lütfen bekleyin","Uh oh.. we couldn\'t load the content":"Olamaz! İçeriği yükleyemedik","No Questions Yet":"Henüz Soru Yok","Tell your audience to send in questions!":"Katılımcı kitlenize soru göndermelerini söyleyin!","Be the first to ask a question!":"İlk soru soran siz olun!","Tell your audience to raise their hand!":"Katılımcı kitlenize ellerini kaldırmalarını söyleyin!","Approve":"Onayla","Reject":"Reddet","End":"Sonlandır","RELOAD":"YENİDEN YÜKLE","Logos On Stage":"Logolar Sahnede","No File Chosen":"Dosya Seçilmedi","loading":"yükleniyor","Can\'t publish a slide when there is something else being presented on stage":"Sahnede başka bir şey sunulurken slayt yayınlanamaz","Change Deck":"Yatay Başlık Bölümünü Değiştir","stop-screen-share":"ekran-paylaşımını-durdur","screen-share":"ekran-paylaşımı","Select a deck to begin presenting":"Sunuma başlamak için bir yatay başlık bölümü seçin","CONFIRM":"ONAYLA","If you’re having issues, please refer to the":"Sorun yaşıyorsanız lütfen şuraya bakın:","SPEAKER":"HOPARLÖR","Issue Testing Audio!":"Ses Testinde Sorun!","VPN and adblockers may cause video issues, please disable them before proceeding":"VPN ve reklam engelleyiciler görüntü sorunlarına neden olabilir; lütfen devam etmeden önce bunları devre dışı bırakın","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"Not: VPN ve reklam engelleyiciler görüntü sorunlarına neden olabilir; bu nedenle yayın sırasında bunları devre dışı bıraktığınızdan emin olun","Follow":"Takip et","Read More":"Devamını Oku","Ask a question":"Bir soru sor","Shared":"Paylaşıldı","Answered":"Yanıtlandı","Waiting Approval":"Onay Bekliyor","cancel":"iptal et","ENTER":"GİR","Upcoming Events":"Yaklaşan Etkinlikler","Past Events":"Geçmiş Etkinlikler","Goldcast":"Goldcast","MANAGE EVENT":"ETKİNLİĞİ YÖNET","Edit Profile":"Profili Düzenle","Stay tuned!":"Bizi izlemeye devam edin!","Sign-in instructions will be available here 12 hours prior to the event":"Giriş talimatları etkinlikten 12 saat önce burada mevcut olacaktır","Please log out":"Lütfen oturumu kapatın","Logout":"Oturumu kapat","Continue as {differentUser}":"{differentUser} olarak devam et","You are already logged in as {user}.":"Zaten {user} olarak oturum açtınız.","EMAIL":"E-POSTA","user@email.com":"user@email.com","FIRST NAME":"ADI","First Name":"Adı","LAST NAME":"SOYADI","Last Name":"Soyadı","You are not registered to this event":"Bu etkinliğe kaydolmadınız","Please enter your email and name":"Lütfen e-posta adresinizi ve adınızı girin","Please enter your email":"Lütfen e-posta adresinizi girin","We have sent a secret code to":"Şuraya bir gizli kod gönderdik:","BACK":"GERİ","Didn\'t receive an email? Make sure to check spam list":"Bir e-posta almadınız mı? Spam listesini kontrol ettiğinizden emin olun","Resend Mail":"Postayı Tekrar Gönder","SECRET CODE":"GİZLİ KOD","Please enter the temporary password sent to your email":"Lütfen e-postanıza gönderilen geçici şifreyi girin","NEW PASSWORD":"YENİ ŞİFRE","Please enter a new password":"Lütfen yeni bir şifre girin","CONFIRM PASSWORD":"ŞİFREYİ ONAYLA","Please re-enter the new password":"Lütfen yeni şifreyi tekrar girin","Password length should be atleast 8":"Şifre en az 8 karakter olmalıdır","Password and Confirm Password don\'t match !!":"Şifre ve Şifreyi Onayla bölümü eşleşmiyor !!","Please enter your password to continue":"Devam etmek için lütfen şifrenizi girin","Logging you in...":"Oturumunuz açılıyor...","PASSWORD":"ŞİFRE","Forgot credentials?":"Kimlik bilgilerinizi mi unuttunuz?","Forgot Password? A mail will be sent to your registered email.":"Şifrenizi mi unuttunuz? Kayıtlı e-posta adresinize bir e-posta gönderilecektir.","Email cannot be blank!!":"E-posta boş olamaz!!","We have sent a secure login link to":"Şuraya güvenli bir oturum açma bağlantısı gönderdik:","from":"kimden","Please use that to access your event.":"Etkinliğinize erişmek için lütfen bunu kullanın.","Please check spam/promotion too if you can\'t find it.":"Bulamıyorsanız lütfen spam/tanıtımla klasörünü de kontrol edin.","Thank You !":"Teşekkürler !","The link is not valid.":"Bağlantı geçerli değil.","Please be patient.":"Lütfen bekleyin.","We are verifying your link.":"Bağlantınızı doğruluyoruz.","Thank you for entering the code!":"Bu etkinliğe katıldığınız için teşekkür ederiz!","Please create a new password":"Lütfen yeni bir şifre oluşturun","Signing you up...":"Kaydınız yapılıyor...","We have sent a temporary password to":"Şuraya geçici bir şifre gönderdik:","TEMPORARY PASSWORD":"GEÇİCİ ŞİFRE","Please enter the temporary password sent to your mail":"Lütfen e-postanıza gönderilen geçici şifreyi girin","Password Length should be 8":"Şifre 8 karakter olmalıdır","Okay":"Tamam","Backstage: {title}":"Sahne arkası: {title}","Prep Area":"Hazırlık Alanı","Starting at {time}":"Başlama saati: {time}","person":"kişi","inside":"içeride","No one is inside":"İçeride kimse yok","This area is for you to sync up with your fellow speakers before you go on stage.":"Bu alan sahneye çıkmadan önce konuşmacı arkadaşlarınızla senkronize olmanız içindir.","This area is for you to check your cam and mic before you enter the room.":"Bu alan odaya girmeden önce kameranızı ve mikrofonunuzu kontrol etmeniz içindir.","I\'m Ready":"Hazırım","Watch Live":"Canlı İzle","Backstage":"Sahne arkası","You are sharing your screen":"Ekranınızı paylaşıyorsunuz","LIVE":"CANLI","Live":"Canlı","Virtual":"Sanal","Only available for ":"Yalnızca şunlar için geçerli: ","See Booths":"Stantları Gör","See Rooms":"Odaları Gör","Enter Backstage":"Sahne Arkasına Gir","This track has no upcoming sessions. Check out a different track.":"Bu parça için yaklaşan oturumu yok. Farklı bir parçaya göz atın.","View":"Görüntüle","Agenda":"Ajanda","Scroll to see all tracks":"Tüm parçaları görmek için kaydırın","No Agenda Items to show!":"Gösterilecek Ajanda Öğesi yok!","ENTER EVENT":"ETKİNLİĞE GİR","change":"değiştir","Upload":"Yükle","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF VEYA PNG. MAKS. BOYUT 5MB","Create Profile":"Profil Oluştur","Email":"E-posta","Company":"Şirket","Title":"Unvan","No matching locations found":"Eşleşen konum bulunamadı","You can try searching for the location with another keyword":"Konumu başka bir anahtar kelimeyle aramayı deneyebilirsiniz","Interest Tags":"İlgi Alanı Etiketleri","Pick your first tag":"İlk etiketinizi seçin","Save":"Kaydet","Searching...":"Aranıyor...","Twitter":"Twitter","Select Your First Tags":"İlk Etiketlerinizi Seçin","Add Interest tags":"İlgi alanı etiketleri ekle","Congratulations!":"Tebrikler!","Your first Goldcast event is set up":"İlk Goldcast etkinliğiniz oluşturuldı","You can always visit":"Etkinliklerinizi nasıl oluşturacağınız ve yürüteceğiniz ile ilgili talimatlar için her zaman","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"adresinizi ziyaret edebilirsiniz","See My Event":"Etkinliğimi Gör","Peak Community":"Üst Düzey Topluluk","Loading Lite Mode... This may take up to 30s":"Lite Modu yükleniyor... Bu 30 saniye kadar sürebilir","Loading Video...":"Video Yükleniyor...","Video will begin at session start time":"Video, oturum başlangıç saatinde başlayacak","TIME":"SAAT","TITLE":"BAŞLIK","STATUS":"DURUM","END":"SONLANDIR","START":"BAŞLAT","AGENDA":"AJANDA","Enable Audio":"Sesi Etkinleştir","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"Tarayıcının otomatik oynatma politikaları nedeniyle ses kapatıldı. Sesi açmak için aşağıdaki etkinleştir seçeneğine tıklayın. Ayrıca yerleşik kontroller aracılığıyla da sesi daha sonra açabilirsiniz.","Enable":"Etkinleştir","You are being redirected outside the room. Would you like to continue?":"Odanın dışına yönlendiriliyorsunuz. Devam etmek istiyor musunuz?","Continue":"Devam et","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"Alternatif olarak, canlı yayından 30 saniyelik bir gecikmenin olduğu lite modunu kullanabilirsiniz","We detected a network issue":"Bir ağ sorunu tespit ettik","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Lütfen bir VPN/Güvenlik Duvarı aracılığıyla bağlanmadığınızdan emin olun. Sorun devam ederse, ağınızı, tarayıcınızı veya cihazınızı değiştirmeyi deneyin.","Could not connect":"Bağlanamadı","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"Bunun nedeni bir güvenli ağ, tarayıcı/cihaz sorunu olabilir. Sorun devam ederse, lütfen ağınızı, tarayıcınızı veya cihazınızı değiştirmeyi deneyin","Switch to Lite Mode":"Lite Moduna geç","Leave":"Ayrıl","Screenshare had an issue":"Ekran paylaşımında bir sorun oluştu","Could not share screen unexpectedly. Refresh & retry. On mac go to":"Beklenmedik bir şekilde ekran paylaşılamadı. Yenileyin ve tekrar deneyin. Mac için şuraya gidin:","and check if your browser has the required permission":"ve tarayıcınızın gerekli izne sahip olup olmadığını kontrol edin","Uh OH... Something went wrong":"Olamaz! Bir şeyler ters gitti","To fix this, click the":"Bunu düzeltmek için, URL çubuğunuzdaki şu seçeneğe tıklayın:","in your URL bar, then select “Allow”, and then click “Try Again”":"ardından “İzin ver” seçeneğini seçin ve daha sonra “Tekrar Dene” seçeneğine tıklayın","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"Bilinmeyen bir nedenden dolayı medya akışınız başlatılamadı! Tarayıcınız platformumuz tarafından desteklenmiyor olabilir. \\"Google Chrome\\" kullanmanızı öneririz. Bu sorun devam ederse lütfen, Goldcast Destek Ekibiyle iletişime geçin","To fix this, make sure your":"Bunu düzeltmek için,","is not being accessed by any other app. If not, please try changing your":"başka bir uygulama tarafından erişilmiyor olduğundan emin olun. Aksi halde,","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"\\"Ayarlara Git\\" seçeneğine tıklayarak cihazlarınızı değiştirmeyi deneyin. Olası sorunu çözdükten sonra \\"Tekrar Dene\\" düğmesine basın!","Go To Settings":"Ayarlara Git","Try Again":"Tekrar Dene","Try Joining without Video":"Görüntü Olmadan Katılmayı Dene","A refresh and rejoin should work":"Yenileme ve yeniden katılma işlemi işe yarayacaktır","Refresh & Rejoin":"Yenile ve Yeniden Katıl","Start Chat":"Sohbeti Başlat","On Stage":"Sahnede","Connect your on-site camera and microphone to present to your virtual attendees":"Sanal katılımcılarınıza sunum yapmak için mevcut kameranızı ve mikrofonunuzu bağlayın","Stop Streaming":"Yayın Akışını Durdur","Start Streaming":"Yayın Akışını Başlat","Set up on-site video feed":"Yerinde video yayını oluştur","Open TV":"TV\'yi Aç","Layout: {layout} ":"Yerleşim: {layout} ","With Speaker Videos":"Konuşmacı Videoları ile","Full Screen":"Tam Ekran","No Speakers":"Konuşmacı Yok","Turn Off Setup Mode":"Kurulum Modunu Kapat","Setup Mode":"Kurulum Modu","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"{roomTitle} için kurulum modunu durdurmak istiyorsanız lütfen kapat düğmesine basın. Bu durumda tüm aktif yayın akışları da kapatılacaktır.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"Yayın akışı için hazırlanılıyor: {roomTitle}. Lütfen kurulum modunu yalnızca canlı konumdan yayın yapmak için kullanın.","Starting in {duration}":"{duration} içinde başlıyor","Can\'t share screen while there is something else being presented on stage":"Sahnede başka bir şey sunulurken ekran paylaşılamaz","You are now in attendee view!":"Şimdi katılımcı görünümündesiniz!","You are now in organizer view!":"Şimdi organizatör görünümündesiniz!","Note :":"Not :","Only organizer accounts can see this tag, normal attendees can’t see this":"Bu etiketi yalnızca organizatör hesapları görebilir, normal katılımcılar bunu göremez","Attendee":"Katılımcı","Event Information":"Etkinlik Bilgileri","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"Etkinlik Bilgileri yalnızca organizatörler tarafından görülebilir! <br /> Bu bölüm katılımcılar tarafından görülemez","Operating System":"İşletim Sistemi","Secondary Booths":"Stantları Stantlar","Sort":"Sırala","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"{track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue} takip ediliyor","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2} sizi otomatik olarak {track1_Would_you_like_to_continue}\'den takip etmeyi bırakacak","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}Devam etmek istiyor musunuz?","Track only available for {tracks}":"Parça yalnızca {tracks} için geçerli","Add to Calendar":"Takvime ekle","Open Speakers Control Panel":"Konuşmacı Kontrol Panelini Aç","Move Offstage ↓":"Sahne Dışına Taşı ↓","Error Moving ⚠":"Taşıma Hatası ⚠","Off Stage":"Sahne Dışı","Move to Stage":"Sahneye Taşı","An error occurred!":"Bir hata oluştu!","{eventName} Documents":"{eventName} Belgeleri"," Set Up Mode":" Kurulum Modu","Camera & Mic blocked":"Kamera ve Mikrofon engellendi","Camera/Mic Inaccessible":"Kamera/Mikrofona Erişilemiyor","Camera/Mic Not Found":"Kamera/Mikrofon Bulunamadı","Camera Inaccessible":"Kameraya Erişilemiyor","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"Kamera meşgul veya çözünürlük desteklenmiyor. Lütfen kameranızın başka bir uygulama tarafından kullanılmadığından emin olun ve tekrar deneyin!","No microphone/camera is found":"Mikrofon/kamera bulunamadı","The browser does not support using camera and microphone!":"Tarayıcı kamera ve mikrofon kullanımını desteklemiyor!","{n} Slides":"{n} Slayt","Starting in {timeduration}":"{timeduration} içinde başlıyor","{eventtitle} has ended":"{eventtitle} sona erdi","This is a text q&a question!":"Bu bir yazılı soru-cevap sorusudur!","Click here{if_it_does_not}":"Burayı tıklayın{if_it_does_not}","{click_here}if it does not":"{click_here}olmazsa","{title}up next":"{title}bir sonraki","seat(s) open":"koltuk(lar) açıldı","Signal strength is low. Close other windows or connect to a different network.":"Sinyal gücü düşük. Alternatif olarak farklı bir ağa bağlanmayı deneyin.","GO BACKSTAGE":"SAHNE ARKASINA GİT","LEAVE STAGE":"SAHNEDEN AYRIL","LEAVE":"AYRIL","This event begins on{startitme}":"Bu etkinliğin başlangıç saati {startitme}","Please refresh to enter.":"Girmek için lütfen yenileyin.","people":"kişi","Oops, Something went wrong":"Olamaz! Bir şeyler ters gitti","Back Home":"Ana Ekrana Dön","Deciding where to go ...":"Nereye gidileceğine karar veriliyor...","Go to Event Hub":"Etkinlik Merkezine Git","CREATE":"OLUŞTUR","Attending Virtually":"Sanal Olarak Katılım","Attending In Person":"Yüz Yüze Katılım","Click to change your attendance type":"Katılım türünüzü değiştirmek için tıklayın","Open Chat":"Sohbeti Aç","Create your profile for {eventtitle}":"{eventtitle} için profilinizi oluşturun","Move to stage":"Sahneye taşı","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"Etkinliğin organizatörü sizi <strong>{broadcastTitle}</strong> için sahneye taşımayı istedi.<br /><br />İsteği kabul etmek için tıklarsanız canlı yayına geçecek ve etkinlik katılımcıları için görünür olacaksınız.<br /><br />","Go Live On Stage":"Sahnede Canlı Yayına Geç","Moved to backstage":"Sahne arkasına taşındı","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"Organizatör sizi sahneden aldı. Lütfen organizatörle iletişime geçmeden yeniden katılmaya çalışmayın.","Error creating Screen stream":"Ekran akışı oluşturulurken hata oluştu","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"Ekran paylaşım izni alınamadı. Sorun giderme belgelerini incelemek için lütfen *buraya tıklayın*.","Error publishing stream":"Yayın akışında hata oluştu","Could not publish stream. Please refresh and try again!":"Yayın akışı yapılamadı.Lütfen yenileyin ve tekrar deneyin!","Error publishing screen":"Ekran yayınlanırken hata oluştu","Error publishing screen. Please refresh and try again!":"Ekran yayınlanırken hata oluştu.Lütfen yenileyin ve tekrar deneyin!","Error unpublishing stream":"Yayın akışı kaldırılırken hata oluştu","Error unpublishing stream. Please refresh and try again!":"Yayın akışı kaldırılırken hata oluştu.Lütfen yenileyin ve tekrar deneyin!","Invalid Publish Operation":"Geçersiz Yayınlama İşlemi","{username} profile picture":"{username} profil resmi","Default":"Varsayılan","A-Z":"A-Z","Random":"Rastgele","All":"Tümü","Past":"Geçmiş","Upcoming":"Yaklaşan","Learn More":"Daha Fazla Bilgi Alın","close":"kapat","Discussion Rooms":"Tartışma Odaları","ATTENDEE MODE":"KATILIMCI MODU","Loading...":"Yükleniyor...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"Cihaz tarayıcı tarafından devre dışı bırakıldı veya kullanım için izin alınamadı. Lütfen izinleri sağlayın ve \'Tekrar dene\' seçeneğine tıklayın","You are now registered. You will receive an email confirming details shortly.":"Şimdi kaydoldunuz. Kısa süre içinde bilgilerinizin onaylandığı bir e-posta alacaksınız.","Streaming to Virtual Users from on-site video feed":"Yerinde video yayınından Sanal Kullanıcılara yayın akışı","Ending in ":"Bitiş saati ","GO LIVE":"CANLI YAYINA GEÇ","You have no past events.":"Geçmiş etkinliğiniz yok.","You have no upcoming or live events.":"Yaklaşan veya canlı etkinliğiniz yok.","left":"sol","center":"orta","right":"sağ","top":"üst","bottom":"alt","loading...":"yükleniyor...","Loading ...":"Yükleniyor...","Failed to redirect!":"Yönlendirilemedi!","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"Bir reklam engelleyiciyi etkinleştirmiş görünüyorsunuz. Bu, mümkün olan en iyi deneyimi yaşamanızı engelleyebilir. Lütfen devre dışı bırakın. <br />&lt;br / &gt; Bunun nasıl yapılacağı konusunda yardıma ihtiyacınız varsa, daha fazla talimat için <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>buraya</a> tıklayın.","redirecting in {duration}":"{duration} içinde yönlendiriliyor","STOP VIDEO":"VİDEOYU DURDUR","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"Bu videoyu oynatmayı bırakmak üzeresiniz. Yayınınız canlı moda dönecek ve katılımcı kitleniz konuşmacılarınızı görecek ve duyacak. Emin misiniz?","STOP SHARING":"PAYLAŞIMI DURDUR","No Next Slide":"Sonraki Slayt Yok","Next Slide":"Sonraki Slayt","No Previous Slide":"Önceki Slayt Yok","Previous Slide":"Önceki Slayt","something went wrong while recording the response please try again":"Yanıt kaydedilirken bir şeyler ters gitti, lütfen tekrar deneyin","Start In-Person Streaming":"Yüz Yüze Yayın Akışını Başlat","Stop In-Person Streaming":"Yüz Yüze Yayın Akışını Durdur","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Videonuz ara belleğe alınıyor ve test oturumu kısa süre içinde başlayacak. Gerçek oturum sırasında bu gerçekleşmeyecektir.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"Kayan yazı tüm katılımcılar için web sayfasının üst kısmında görünecektir. Kayan yazıyı köprüye dönüştürmek için aşağıdaki URL\'yi girin","Allow {key}":"{key} için izin ver","{messageType} can only be published from inside a broadcast.":"{messageType} yalnızca yayın içinden yayınlanabilir.","To grant {deviceName} access to this page, follow the two steps below:":"Bu sayfa için {deviceName} erişimine izin vermek istiyorsanız aşağıdaki iki adımı izleyin:","2. Allow {deviceName} access and then refresh the page.":"2. {deviceName} erişimine izin verin ve ardından sayfayı yenileyin."}');

/***/ }),

/***/ 3821:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Event Setting Dropdown":"Danh sách thiết lập sự kiện"," Stage Control":" Điều chỉnh diễn đàn","Stage Controls and Information":"Thông tin và điều chỉnh diễn đàn","Live in ":"Phát trực tiếp trong ","Start Session":"Bắt đầu phiên","End Session":"Kết thúc phiên","Present Screen":"Màn hình hiện tại","Rehearse On Stage":"Diễn tập trên diễn đàn","Turn on Microphone":"Bật micrô","Turn off Microphone":"Tắt micrô","Turn on camera":"Bật camera","Turn off camera":"Tắt camera","rehearsal mode":"chế độ diễn tập","People Watching: ${watchCount}":"Số người đang xem: ${watchCount}","Turn on Audio":"Bật tiếng","Turn off Audio":"Tắt tiếng","Are you sure you want to leave this room?":"Bạn chắc chắn muốn rời khỏi phòng này?","you will be redirected to stage in":"bạn sẽ được chuyển hướng đến diễn đàn trong","sec. . ":"giây. . ","Skip to Main Navigation":"Bỏ qua đến Điều hướng chính","Skip to Chat":"Bỏ qua đến Trò chuyện","Skip to Meeting Controls":"Bỏ qua đến Điều chỉnh cuộc gặp","LinkedIn":"LinkedIn","Live in":"Phát trực tiếp trong","UPCOMING":"SẮP DIỄN RA","Rehearse on stage":"Diễn tập trên diễn đàn","Watch Rehearsal":"Xem diễn tập","Answered by:":"Trả lời bởi:","Speaker Off":"Loa đang tắt","Speaker On":"Loa đang bật","Speaker Controls":"Điều chỉnh loa","All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.":"Mọi thành phần trên diễn đàn đều nằm ở đằng sau hình ảnh được chia sẻ. Bạn sẽ thấy lại chúng khi dừng chức năng chia sẻ hình ảnh toàn màn hình.","Close Ticker Popup":"Đóng cửa sổ đăng báo","Open GIF Picker":"Mở bộ chọn GIF","Open Emoji Picker":"Mở bộ chọn Emoji","Send Message":"Gửi thông báo","Tabs: Messaging and More":"Thẻ: Thông báo và chức năng khác","Thanks for attending!":"Cảm ơn bạn đã tham gia!"," No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions":" Không có phiên nào sắp diễn ra trong kênh đã đăng ký theo dõi của bạn. Vui lòng chuyển sang các kênh khác để xem các phiên phát trực tiếp","Redirecting you to ":"Đang chuyển hướng sang ","in ":"trong ","seconds":"giây","Main Navigation":"Điều hướng chính","YOU ARE HERE":"BẠN ĐANG Ở ĐÂY","Live Now":"Phát trực tiếp ngay","SUBMIT":"GỬI","Allocated time for engagement has ended. You will be redirected to main stage":"Thời gian ấn định để tham gia đã hết. Bạn sẽ được chuyển hướng về diễn đàn chính","Wrap up in":"Kết thúc trong","Session overrun by":"Phiên đã đầy","Ending in":"Sắp kết thúc trong","Bring this session live?":"Phát trực tiếp phiên này?","START SESSION":"BẮT ĐẦU PHIÊN","Bring this session to end?":"Kết thúc phiên này?","END SESSION":"KẾT THÚC PHIÊN","Go On Stage":"Lên diễn đàn","Muted by organizer":"Đã bị người tổ chức tắt tiếng","One of the event organizers has muted your audio. You may unmute yourself by clicking the mic button.":"Một trong những người tổ chức sự kiện đã tắt tiếng của bạn. Bạn có thể tự bỏ tắt tiếng bằng cách nhấp vào nút mic.","Gifs":"Ảnh gif","Stickers":"Nhãn dán","Launch Survey":"Chạy khảo sát","Microphone is on":"Micrô đang bật","Microphone is off":"Micrô đang tắt","Secret Code’s length should be 6 digits":"Độ dài của Mã bảo mật phải là 6 chữ số","Closing in 00:":"Đóng trong 00:","Submit":"Gửi","Questions":"Câu hỏi","Preview":"Xem trước","Close Survey":"Đóng khảo sát","This is a required question":"Đây là câu hỏi bắt buộc","Enter the text you’d like to present on stage below.":"Nhập nội dung bạn muốn hiển thị trên diễn đàn bên dưới.","Use Chrome/Edge for best performance":"Sử dụng Chrome/Edge để đạt hiệu quả tốt nhất","Do you want to launch your survey now?":"Bạn có muốn chạy khảo sát bây giờ không?","Success! Your Survey has been launched for attendees.":"Thành công! Đã khởi chạy Khảo sát cho người tham dự.","Unable to publish. Please try again.":"Không xuất bản được. Vui lòng thử lại.","Are you sure you want to close this survey?":"Bạn chắc chắn muốn đóng khảo sát này?","Success! Your Survey has been closed for attendees.":"Thành công! Đã đóng Khảo sát cho người tham dự.","Unable to un-publish. Please try again.":"Không thể hủy xuất bản. Vui lòng thử lại.","Please answer all required questions.":"Vui lòng trả lời mọi câu hỏi bắt buộc.","You have already submitted this survey.":"Bạn đã nộp khảo sát rồi.","Success! Thank you for your feedback.":"Thành công! Cảm ơn bạn đã phản hồi.","Unable to submit. Please try again.":"Không gửi được. Vui lòng thử lại.","Launch surveys will take over attendees\' engagement panel.":"Khởi chạy khảo sát sẽ chiếm dụng phần bảng tương tác của người tham dự.","Closing this survey will remove it from attendees\' engagement panel.":"Đóng khảo sát này sẽ xóa cuộc khảo sát khỏi bảng tương tác của người tham gia.","Survey":"Khảo sát","Updating Survey...":"Đang cập nhật khảo sát...","Closing":"Đang đóng","Goldcast needs access to your camera and microphone":"Goldcast cần được cấp quyền truy cập vào camera và micrô của bạn","Goldcast needs access to your microphone":"Goldcast cần được cấp quyền truy cập vào micrô của bạn","Goldcast needs access to your camera":"Goldcast cần được cấp quyền truy cập vào camera của bạn","SPEAKERS":"DIỄN GIẢ","Mark as Unanswered":"Đánh dấu là Chưa trả lời","Mark as Answered":"Đánh dấu là Đã trả lời","Remove from Priority":"Gỡ khỏi Ưu tiên","Mark as Priority":"Đánh dấu là Ưu tiên","Answer":"Trả lời","Enter answer...":"Nhập câu trả lời...","Answered by":"Người trả lời","Submit Answer":"Gửi câu trả lời","Test your system’s speaker":"Kiểm tra loa hệ thống của bạn","Click \\"Yes\\" if you hear the sound.":"Nhấp \\"Có\\" nếu bạn nghe thấy âm thanh.","Load previous":"Nạp trước đó","Hide Name":"Ẩn tên","Text Q&A is disabled in On Demand mode.":"Phần Hỏi đáp văn bản bị tắt trong chế độ Theo yêu cầu.","Text Q&A limit reached. Attendees won\'t be able to ask new questions.":"Đã đạt giới hạn Hỏi đáp văn bản. Người tham dự sẽ không đặt được câu hỏi mới.","Sent to Q&A":"Đã gửi đến Hỏi đáp","Couldn\'t post as Q&A. Please try again.":"Không đăng bài Hỏi đáp được. Vui lòng thử lại.","Yes this is being recorded":"Có, đang được thu lại","No this is not being recorded":"Không, không có thu lại","System\'s Speaker Check":"Kiểm tra loa hệ thống","To make sure that you will be able to hear during the event, make sure that your system’s speakers are working fine":"Để đảm bảo bạn có thể nghe được trong quá trình diễn ra sự kiện, hãy đảm bảo loa hệ thống của bạn đang hoạt động tốt","Click on “Test your system’s speaker” to proceed":"Nhấp vào \\"Kiểm tra loa hệ thống của bạn\\" để thực hiện","Error while sharing message to screen. Post not found":"Có lỗi khi chia sẻ thông điệp lên màn hình. Không tìm thấy bài đăng","Lost connection to servers. Refresh your page to get live event experience.":"Mất kết nối với máy chủ. Làm mới trang của bạn để tham gia sự kiện phát trực tiếp.","VPN/Firewall is interfering with your authentication. Kindly switch your network or connect with your IT team to allow <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>these domains</a> for accessing Goldcast smoothly.":"VPN/Tường lửa đang cản trở quá trình xác thực của bạn. Hãy chuyển đổi mạng hoặc liên hệ ban CNTN của bạn để cho phép <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>các miền này</a> truy cập Goldcast suôn sẻ.","It\'s taking too long":"Đang chờ quá lâu","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change your network":"Có vẻ như bạn kết nối qua VPN hoặc đang bật tường lửa. Vui lòng tham khảo <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>tài liệu trợ giúp</a> này &amp; đưa vào danh sách trắng các miền bắt buộc để Goldcast hoạt động trơn tru hoặc hãy nên đổi mạng","It seems that you are connected via VPN or have your firewall turned on. Kindly refer to this <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>help doc</a> & whitelist required domains for Goldcast to function smoothly or you should change network or watch session on Lite Mode":"Có vẻ như bạn kết nối qua VPN hoặc đang bật tường lửa. Vui lòng tham khảo <a href=\'https://help.goldcast.io/hc/en-us/articles/12086151633563\' target=\'_blank\'>tài liệu trợ giúp</a> này &amp; đưa vào danh sách trắng các miền bắt buộc để Goldcast hoạt động trơn tru hoặc hãy nên đổi mạng hoặc xem phiên sự kiện trên Chế độ phát trực tiếp","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly change your network to connect with live streaming service.":"Dịch vụ phát video Goldcast không kết nối được do băng thông mạng yếu. Hãy đổi mạng để kết nối với dịch vụ phát trực tiếp.","Goldcast video streaming service isn\'t able to connect due to poor network bandwidth. Kindly switch to lite mode or change your network to connect with streaming service":"Dịch vụ phát video Goldcast không kết nối được do băng thông mạng yếu. Vui lòng đổi sang chế độ lite (tinh gọn) hoặc đổi mạng để kết nối với dịch vụ phát trực tiếp","Most Upvotes":"Nhiều lượt ủng hộ nhất","Most Recent":"Gần đây nhất","My Questions":"Câu hỏi của tôi","Prioritized":"Được ưu tiên","Approved":"Được duyệt","Unapproved":"Không được duyệt","Unanswered":"Chưa được trả lời","Failed to update answer. Please try again!":"Không cập nhật được câu trả lời. Vui lòng thử lại!","Failed to post answer. Please try again!":"Không đăng được câu trả lời. Vui lòng thử lại!","Failed to delete question. Please try again!":"Không xóa được câu hỏi. Vui lòng thử lại!","Survey Link":"Liên kết khảo sát","Switching will reload your current page to the attendee view. To switch back to organizer view toggle off attendee view in the profile dropdown.":"Việc chuyển đổi sẽ nạp lại trang hiện tại sang chế độ xem người tham dự. Để chuyển về chế độ xem người tổ chức hãy tắt chế độ xem người tham dự trong danh sách hồ sơ thả xuống.","You haven\'t asked any questions yet":"Bạn chưa đặt câu hỏi nào","No prioritized questions":"Không có câu hỏi ưu tiên","Create prioritized list of questions for speakers by marking questions as priority":"Tạo danh sách các câu hỏi ưu tiên dành cho diễn giả bằng cách đánh dấu ưu tiên các câu hỏi","No Approved Questions":"Không có câu hỏi được duyệt","Approve incoming questions to see list of approved questions":"Hãy duyệt các câu hỏi mới có để xem danh sách các câu hỏi được duyệt","No Unapproved Questions":"Không có câu hỏi không được duyệt","No Answered Questions":"Không có câu hỏi được trả lời","Answer a question on stage or with inline text":"Hãy trả lời câu hỏi trên diễn đàn hoặc bằng văn bản nội tuyến","All questions are answered":"Mọi câu hỏi đã được trả lời","Rate Your Experience":"Đánh giá trải nghiệm của bạn","How satisfied are you with Goldcast?":"Mức độ hài lòng của bạn với Goldcast là bao nhiêu?","What are the main reasons for your rating?":"Đâu là các lý do chính khi bạn đánh giá như vậy?","I am interested in seeing a demo of Goldcast":"Tôi muốn xem bản demo Goldcast","Thank You":"Cảm ơn bạn","Your feedback was successfully submitted.":"Phản hồi của bạn đã được gửi thành công.","Tell us how we can improve...":"Xin cho biết chúng tôi cần cải thiện ở điểm nào...","1 Slide":"1 trang trình chiếu","Your internet connection is unstable.":"Kết nối Internet của bạn không ổn định.","It seems that you are speaking on mute. Click on Mic icon to unmute yourself":"Có vẻ như bạn nói khi đang bật chế độ tắt tiếng. Nhấp vào biểu tượng Mic để tự bỏ tắt tiếng","The registration could not be completed! Please check that this email is allowed to register for the event.":"Đăng ký chưa hoàn thành! Vui lòng kiểm tra xem email này có được cho phép đăng ký sự kiện này không.","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer.":"Có vẻ như bạn đã đăng ký sự kiện này! Vui lòng kiểm tra hộp thư rác để tìm thư xác nhận đăng ký của bạn, nếu bạn chưa nhận được. Nếu bạn cần hỗ trợ thêm, vui lòng liên hệ người tổ chức sự kiện.","Your registration could not be completed. This event has reached its registration capacity.":"Đăng ký của bạn chưa hoàn thành. Sự kiện này đã đạt đủ số lượng đăng ký.","Image cannot be an svg":"Ảnh không thể có định dạng svg","This should be a valid linkedin url":"Đây phải là url LinkedIn hợp lệ","This should be a valid twitter url":"Đây phải là url Twitter hợp lệ","This should be a valid url":"Đây phải là url hợp lệ","Video":"Video","Read Less":"Thu gọn","live":"trực tiếp","Opened":"Đã mở","In person only":"Chỉ gặp mặt trực tiếp","Stage Stream":"Phát trực tiếp diễn đàn","Streaming not available":"Tính năng phát trực tiếp không khả dụng","Close TV":"Tắt TV","Streaming is not available for prerecorded and RTMP sessions":"Không dùng được tính năng phát trực tiếp đối với các phiên sự kiện ghi sẵn và RTMP","Connect your computer to a TV screen or projector to enable your in-person attendees to see what\'s happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. ":"Kết nối máy tính của bạn với một màn hình TV hoặc máy chiếu để cho phép người tham dự trực tiếp xem được những gì đang diễn ra trên diễn đàn ảo của bạn; bao gồm cả các trang trình chiếu, phần Hỏi đáp v.v. Sau khi đã kết nối, nhấp vào MỞ TV và kéo hoặc chia sẻ cửa sổ mới vào màn hình TV hoặc máy chiếu của bạn. ","Close Setup Mode":"Đóng Chế độ cài đặt","Help":"Trợ giúp","upcoming":"sắp diễn ra","ended":"đã kết thúc","Remove from favorites":"Xóa khỏi mục yêu thích","Add to favorites":"Thêm vào mục yêu thích","PLAY RECORDING":"PHÁT BẢN GHI","VIEW RECORDING":"XEM BẢN GHI","VIEW RECORDINGS":"XEM NHIỀU BẢN GHI","Virtual Backgrounds":"Hình nền ảo","No Device Available":"Không có thiết bị khả dụng","Needs permission":"Cần được cấp phép","Device not detected":"Không tìm thấy thiết bị","Camera is on":"Camera đang bật","Camera is off":"Camera đang tắt","Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video":"Video phản chiếu không hiển thị cho người xem. Người xem luôn nhìn thấy video không phản chiếu","Mirror My Video":"Phản chiếu video của tôi","Camera":"Camera","1. Click on Safari > Settings for this\\n            website":"1. Nhấp trên Safari > Settings (Thiết lập) dành cho\\n            trang web này","1. Click the lock":"1. Nhấp vào biểu tượng","icon in your browser’s address bar":"khóa trên thanh địa chỉ của trình duyệt","3. Unmute":"3. Bỏ tắt tiếng","and":"và","icons from stage control panel":"các biểu tượng từ bảng điều khiển diễn đàn","icon from stage control panel":"biểu tượng từ bảng điều khiển diễn đàn","2. Set camera and microphone to “Allow”.":"2. Cài đặt camera và micrô thành \\"Allow\\" (Cho phép).","2. Set camera to “Allow”.":"2. Cài đặt camera thành \\"Allow\\" (Cho phép).","2. Set microphone to \\"Allow\\"":"2. Cài đặt micrô thành \\"Allow\\" (Cho phép)","2. Choose \\"Always allow Goldcast to access your camera and microphone\\"":"2. Chọn \\"Always allow Goldcast to access your camera and microphone\\" (Luôn cho phép Goldcast truy cập camera và micrô của bạn)","2. Choose \\"Always allow Goldcast to access your camera.\\"":"2. Chọn \\"Always allow Goldcast to access your camera.\\" (Luôn cho phép Goldcast truy cập camera của bạn)","2. Choose \\"Always allow Goldcast to access your microphone\\"":"2. Chọn \\"Always allow Goldcast to access your microphone\\" (Luôn cho phép Goldcast truy cập micrô của bạn)","Questions?":"Bạn có câu hỏi nào không?","If you’re having issues, check out our comprehensive":"Nếu bạn vẫn còn gặp vấn đề, hãy tham khảo tài liệu trợ giúp","help docs":"toàn diện của chúng tôi","Speaker is on":"Loa đang bật","Stop Test":"Dừng kiểm tra","Test your system’s audio":"Kiểm tra âm thanh hệ thống của bạn","Still can\'t hear any sound?":"Vẫn không nghe thấy âm thanh?","Microphone":"Micrô","Audio is being played in system\'s default audio device.":"Âm thanh đang được phát trên thiết bị âm thanh mặc định của hệ thống.","Click to view/change audio device":"Nhấp để xem/thay đổi thiết bị âm thanh","Speaker":"Loa","Play Recording":"Phát bản ghi","Recording for this broadcast is currently being processed and will be available soon":"Bản ghi dành cho chương trình phát sóng này hiện đang được xử lý và sẽ sớm dùng được","You haven\'t favorited anything yet!":"Bạn chưa có mục yêu thích nào!","Add an item to favorites by selecting the ♡ in the top right corner.":"Thêm một mục vào mục yêu thích bằng cách chọn♡ ở góc trên cùng bên phải.","Session has ended":"Phiên đã kết thúc","System Check":"Kiểm tra hệ thống","Need help? Check out the":"Cần trợ giúp? Hãy tham khảo","Skip Checks and Continue":"Bỏ qua kiểm tra và tiếp tục","Click the button above to run the test":"Nhấp vào nút ở trên để tiến hành kiểm tra","Test Screenshare":"Kiểm tra chức năng chia sẻ màn hình","Share message to stage":"Chia sẻ thông điệp đến diễn đàn","Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.":"Nhập nội dung bạn muốn sử dụng cho nhãn thông báo bên dưới. Để chuyển nhãn thông báo thành một siêu liên kết, hãy nhập vào URL.","Ticker":"Nhãn thông báo","Coffee Break! Be back in 10m.":"Nghỉ giải lao chút nhé! Sẽ quay lại trong 10 phút nữa.","Enter Message":"Nhập thông điệp","https://www.xyz.com":"https://www.xyz.com","Launch":"Khởi chạy","Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.":"Cảm ơn bạn đã gửi câu hỏi. Bạn sẽ gửi được một câu hỏi khác sau khi một trong các câu hỏi hiện tại của bạn được duyệt.","Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.":"Rất tiếc! Hiện mục Hỏi đáp đang bị tắt. Bạn sẽ có thể gửi câu hỏi sau khi mục Hỏi đáp được bật trở lại.","Votes":"Phiếu","Vote":"Bỏ phiếu","is inviting you to a video call":"đang mời bạn tham gia một cuộc gọi điện video","ENTER ROOM":"VÀO PHÒNG","Start the conversation!":"Bắt đầu trò chuyện!","Couldn\'t send message. Click here to retry.":"Không gửi được thông báo. Nhấp vào đây để thử lại.","Couldn\'t add emoji. Please try again.":"Không thêm được emoji. Vui lòng thử lại.","Couldn\'t remove emoji. Please try again.":"Không xóa được emoji. Vui lòng thử lại.","Couldn\'t delete message. Please try again.":"Không xóa được thông báo. Vui lòng thử lại.","Couldn\'t pin message. Please try again.":"Không ghim được thông báo. Vui lòng thử lại.","Couldn\'t unpin message. Please try again.":"Không bỏ ghim được thông báo. Vui lòng thử lại.","Today":"Hôm nay","No messages yet":"Chưa có thông báo","Messages from organizers and speakers appear here!":"Thông báo từ người tổ chức và diễn giả xuất hiện ở đây!","Next Session is Starting":"Phiên tiếp theo sắp bắt đầu","Go to Next Session":"Đến phiên tiếp theo","I’d like to stay":"Tôi muốn ở lại","My favorites":"Mục yêu thích của tôi","1. Click on the lock icon in your address bar":"1. Nhấp vào biểu tượng khóa trên thanh địa chỉ của bạn","We recommend organizers and speakers use a desktop\\n        device":"Chúng tôi đề nghị người tổ chức và diễn giả sử dụng thiết bị để bàn\\n        ","To ensure the best experience for attendees, speakers and organizers\\n        must use Goldcast from a desktop. Broadcasting from a mobile device will\\n        cause a degraded experience.":"Để đảm bảo người tham dự có được trải nghiệm tốt nhất, diễn giả và người tổ chức\\n        phải sử dụng Goldcast từ máy tính để bàn. Việc phát sóng từ thiết bị di động sẽ\\n        khiến người tham dự có trải nghiệm kém.","Watch Now":"Xem ngay","Video progress time":"Thời gian tiến trình video","Total video duration":"Tổng thời lượng video","Rate Goldcast!":"Đánh giá Goldcast!","Running Required Checks...":"Đang tiến hành các cuộc kiểm tra bắt buộc...","Test Your Setup":"Kiểm tra thiết lập của bạn","Test your Computer Device, Microphone and Camera before you join the event":"Kiểm tra Thiết bị máy tính, Micrô và Camera của bạn trước khi tham gia sự kiện","Speaker and microphone not working?":"Loa và micrô không hoạt động?","Passed":"Đã đạt","Fix Audio Issues":"Khắc phục sự cố âm thanh","Check if audio is being played in other sound devices connected to phone/tablet":"Kiểm tra xem âm thanh có đang được phát ở các thiết bị âm thanh khác đang kết nối với điện thoại/máy tính bảng hay không","Check if correct audio device is chosen from the below dropdown":"Kiểm tra xem có chọn đúng thiết bị âm thanh từ danh sách thả xuống bên dưới không","<a href=\'ms-settings:sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'ms-settings:sound\'>Nhấp vào đây</a> để kiểm tra xem có chọn đúng thiết bị âm thanh tại nơi cần phát âm thanh hay không","<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Click Here</a> to check if the right audio device is selected where audio needs to be played":"<a href=\'x-apple.systempreferences:com.apple.preference.sound\'>Nhấp vào đây</a> để kiểm tra xem có chọn đúng thiết bị âm thanh tại nơi cần phát âm thanh hay không","Right click on the browser tab & click “Unmute Site”":"Nhấp chuột phải trên thẻ trình duyệt & nhấp \\"Bỏ tắt tiếng trang\\"","Check if browser\'s tab is unmuted or click Window > Unmute this tab":"Kiểm tra xem thẻ trình duyệt có bị tắt tiếng không hoặc nhấp Window > Unmute this tab (Bỏ tắt tiếng thẻ này)","System Check Failed!":"Chưa vượt qua kiểm tra hệ thống!","System Check Passed!":"Đã vượt qua kiểm tra hệ thống!","Complete checks to proceed":"Hoàn thành các cuộc kiểm tra để tiếp tục","Enter Event":"Vào sự kiện","Skip Screen Sharing Check? ":"Bỏ qua kiểm tra chức năng chia sẻ màn hình? ","We recommend to complete screen sharing check if your screen needs to be presented in the event":"Chúng tôi đề nghị hoàn thành kiểm tra chức năng chia sẻ màn hình nếu bạn cần hiển thị màn hình của bạn trong sự kiện","Ignore & Enter Event":"Bỏ qua & Vào sự kiện","Test screenshare":"Kiểm tra chức năng chia sẻ màn hình","Retry Now":"Thử lại ngay","SHARE":"CHIA SẺ","Rooms Closed":"Phòng đã đóng","Discussion rooms are now closed. You are being redirected to the Stage.":"Phòng thảo luận hiện đã đóng. Bạn đang được chuyển về Diễn đàn.","Return To Stage":"Trở về diễn đàn","Unrecognized embedded widget provider - ":"Nhà cung cấp tiện ích nhúng không được công nhận - ","Room Ended":"Phòng đã kết thúc","Your event organizer has closed all the Rooms. You will now be redirected to the event stage.":"Người tổ chức sự kiện của bạn đã đóng hết mọi Phòng. Giờ bạn sẽ được chuyển về diễn đàn của sự kiện.","Video Q&A Request Cancelled":"Đã hủy yêu cầu Hỏi đáp video","Your Video Q&A request has been cancelled since you are viewing in Lite Mode. Switch to Live Mode to Raise hand again.":"Yêu cầu Hỏi đáp video của bạn đã bị hủy vì bạn đang xem ở Chế độ tinh gọn. Hãy chuyển sang Chế độ phát trực tiếp để giơ tay lần nữa.","Camera Passed":"Camera đạt","Camera Error":"Lỗi camera","Camera permissions aren’t granted from browser. Click “Allow Camera”.":"Bạn chưa cấp phép dùng camera từ trình duyệt. Nhấp vào \\"Allow Camera\\" (Cho phép camera).","Camera permissions aren’t granted from system. Click “Allow Camera”":"Bạn chưa cấp phép dùng camera từ hệ thống. Nhấp vào \\"Allow Camera\\" (Cho phép camera)","Uh-oh! Error occurred while creating camera stream":"Úi chà! Đã xuất hiện lỗi khi tạo luồng phát camera","Close other applications which might use camera stream":"Đóng các ứng dụng khác có thể đang sử dụng luồng phát camera","<a href=\'ms-settings:privacy-webcam\'>Click here</a> to check if browser has access to camera":"<a href=\'ms-settings:privacy-webcam\'>Nhấp vào đây</a> để kiểm tra xem trình duyệt có quyền truy cập camera không","Microphone Passed":"Micrô đạt","Microphone Error":"Lỗi micrô","Mic permissions aren’t granted from browser. Click “Allow Microphone”":"Bạn chưa cấp phép dùng mic từ trình duyệt. Nhấp vào “Allow Microphone” (Cho phép micrô)","Mic permissions aren’t granted from system. Click “Allow Microphone”":"Bạn chưa cấp phép dùng mic từ hệ thống. Nhấp vào “Allow Microphone” (Cho phép micrô)","Uh-oh! Error occurred while creating mic stream":"Úi chà! Đã xuất hiện lỗi khi tạo luồng phát mic","Close other applications which might use mic stream":"Đóng các ứng dụng khác có thể đang sử dụng luồng phát mic","<a href=\'ms-settings:privacy-microphone\'>Click here</a> to check if browser has access to mic":"<a href=\'ms-settings:privacy-microphone\'>Nhấp vào đây</a> để kiểm tra xem trình duyệt có quyền truy cập mic không","Speaker and Microphone Error":"Lỗi loa và micrô","Mic permissions are required to show list of speaker devices connected to system. Click “Allow Microphone”":"Phải được cấp phép sử dụng micrô để hiển thị danh sách thiết bị loa có kết nối với hệ thống. Nhấp vào “Allow Microphone” (Cho phép micrô)","It seems mic is being used by other application. Close other applications to proceed.":"Có vẻ như mic đang được ứng dụng khác sử dụng. Đóng các ứng dụng để tiếp tục.","Camera & Microphone Error":"Lỗi camera và micrô","To enable permissions, click the Allow Camera & Mic button below":"Để cấp quyền, nhấp vào nút Allow Camera & Mic (Cho phép camera & mic) bên dưới","Network Connection":"Kết nối mạng","Check Passed":"Đã vượt qua kiểm tra","Could not establish a network connection":"Không thiết lập được kết nối mạng","Connect to a different network, or use a mobile hotspot.":"Hãy kết nối với một mạng khác, hoặc sử dụng điểm phát sóng di động.","Disable any VPN or firewall is connected.":"Tắt bất kỳ VPN hay tường lửa nào đang kết nối.","Connection: Good":"Kết nối: tốt","Network Connection Error":"Lỗi kết nối mạng","Can’t connect to network. Change your network or limited functionality will be available during event.":"Không thể kết nối mạng. Hãy đổi mạng nếu không chức năng hoạt động trong quá trình diễn ra sự kiện sẽ bị hạn chế.","AdBlocker":"AdBlocker (Tiện ích chặn quảng cáo)","AdBlocker not detected.":"Không phát hiện có AdBlocker.","AdBlocker detected. This may degrade your event experience.":"Phát hiện có AdBlocker. Tiện ích này có thể làm giảm trải nghiệm sự kiện của bạn.","Disable adblocker for best experience.":"Tắt adblocker để có trải nghiệm tốt nhất.","You are using ":"Bạn đang sử dụng ","Use Windows or Mac OS for best performance":"Sử dụng hệ điều hành Windows hoặc Mac để đạt hiệu năng tốt nhất","Browser Check":"Kiểm tra trình duyệt","Check Passed.":"Đã vượt qua kiểm tra.","Switch To Lite Mode":"Chuyển sang Chế độ tinh gọn","Your pending Video Q&A request will be cancelled once you switch to lite mode":"Yêu cầu Hỏi đáp video đang chờ của bạn sẽ bị hủy khi bạn chuyển sang chế độ tinh gọn","Stay on Live Mode":"Ở lại Chế độ phát trực tiếp","Unable to mark as favorite":"Không thể đánh dấu mục yêu thích","Event organizers must enter the event to select favorites.":"Người tổ chức sự kiện phải nhập sự kiện thì mới chọn được các mục yêu thích.","Make an Announcement":"Ra thông báo","STOP":"DỪNG","InPerson CheckIn App":"Ứng dụng đăng ký gặp mặt trực tiếp","App to Check-In In-Person attendees":"Ứng dụng giúp người tham dự đăng ký trực tiếp","SEE AGENDA":"XEM CHƯƠNG TRÌNH","Please visit the Agenda tab to view the session recordings":"Vui lòng vào thẻ Chương trình để xem các bản ghi của phiên sự kiện","The session recordings will be available soon in the Agenda tab":"Bản ghi phiên sự kiện sẽ sớm có trong thẻ Chương trình","FAILED!":"KHÔNG THỰC HIỆN ĐƯỢC!","Next session is beginning":"Phiên tiếp theo sắp diễn ra","Do you want to move into the next session? Your stream will continue and your TV will broadcast the new session.":"Bạn có muốn chuyển đến phiên tiếp theo không? Luồng phát của bạn sẽ tiếp tục và TV của bạn sẽ phát phiên mới này.","Banners":"Biểu ngữ","Images":"Hình ảnh","Screen Share":"Chia sẻ màn hình","Browser might not have screen-recording permission on your computer.":"Trình duyệt có thể không được cấp phép ghi lại màn hình trên máy tính của bạn.","Open System Preferences":"Mở tùy chọn hệ thống","Error publishing screen because someone else started screen share already.":"Lỗi xuất màn hình vì có người đã bật tính năng chia sẻ màn hình.","Live Feed":"Nguồn cấp phát trực tiếp","Check Your Network":"Kiểm tra mạng của bạn","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page or switching to lite mode.":"Chúng tôi phát hiện có lỗi trong khi phát video! Nếu bạn gặp sự cố khi phát video, vui lòng thử làm mới trang hoặc đổi sang chế độ tinh gọn.","We detected an error while playing the video! If you are facing issues with the video playback, please try refreshing the page.":"Chúng tôi phát hiện có lỗi trong khi phát video! Nếu bạn gặp sự cố khi phát video, vui lòng thử làm mới trang.","All Dates":"Tất cả các ngày","All Tracks":"Tất cả các kênh","Create Ticker":"Tạo nhãn thông báo","Booths Closed":"Gian phòng đã đóng","Your event organizer has closed all the booths. You will now be redirected to the stage":"Người tổ chức sự kiện của bạn đã đóng hết mọi gian phòng. Giờ bạn sẽ được chuyển về diễn đàn","Visit the Polls tab to view live results.":"Vào thẻ Thăm dò ý kiến để xem kết quả trực tiếp.","A new poll is open! Visit the Polls tab to vote.":"Một cuộc thăm dò ý kiến mới đã được mở! Vào thẻ Thăm dò ý kiến để bỏ phiếu.","Vote for Polls":"Bỏ phiếu các Cuộc thăm dò ý kiến","Go to Polls Tab":"Vào thẻ Thăm dò ý kiến","Microphone audio too low":"Âm thanh micrô quá bé","We\'ve detected a problem with your audio. We recommend trying to mute/unmute or use another device if the issue persists.":"Chúng tôi phát hiện có sự cố với âm thanh của bạn. Chúng tôi đề nghị bạn thử tắt tiếng/bỏ tắt tiếng hoặc sử dụng một thiết bị khác nếu sự cố này vẫn tiếp diễn.","Audio/Video bitrate too low":"Tốc độ bit của âm thanh/video quá thấp","Your network firewall settings are blocking the A/V streams. We recommend that you switch to a different network connection.":"Thiết lập tường lửa mạng của bạn đang chặn các luồng phát A/V. Chúng tôi đề nghị bạn đổi sang một kết nối mạng khác.","Error sharing screen":"Lỗi chia sẻ màn hình","A network error occurred while sharing screen. Please check your network connection.":"Đã xuất hiện lỗi mạng trong khi chia sẻ màn hình. Vui lòng kiểm tra kết nối mạng của bạn.","Apologies, due to some errors, we need to refresh the page!":"Rất tiếc, vì một số lỗi nên chúng tôi cần làm mới trang này!","Warning":"Cảnh báo","We\'ve detected a problem with your video. We recommend trying to close other browser tabs or other applications running on your device and checking/upgrading your internet connection to resolve this issue.":"Chúng tôi phát hiện có sự cố với video của bạn. Chúng tôi đề nghị bạn thử đóng các thẻ trình duyệt khác hoặc các ứng dụng khác đang chạy trên thiết bị của bạn và kiểm tra/nâng cấp kết nối Internet của bạn để giải quyết vấn đề này.","No results found":"Không tìm thấy kết quả","Audio":"Âm thanh","Please choose another microphone and camera":"Vui lòng chọn một micrô và camera khác","The currently selected microphone and camera are not working. Please choose another microphone and camera from the dropdowns below.":"Micrô và camera hiện đang chọn không hoạt động. Vui lòng chọn một micrô và camera khác từ danh sách thả xuống bên dưới.","The currently selected camera is not working. Please choose another camera in the dropdown below.":"Camera hiện đang chọn không hoạt động. Vui lòng chọn một camera khác từ danh sách thả xuống bên dưới.","You are welcome to continue without a camera however we recommend resolving the conflict to ensure a smooth broadcast experience":"Dĩ nhiên bạn có thể tiếp tục mà không cần camera tuy nhiên chúng tôi đề nghị giải quyết vấn đề này nhằm đảm bảo có một trải nghiệm phát sóng ổn định","Please choose another microphone":"Vui lòng chọn một micrô khác","The currently selected microphone is not working. Please choose another microphone in the dropdown below.":"Micrô hiện đang chọn không hoạt động. Vui lòng chọn một micrô khác từ danh sách thả xuống bên dưới.","Please check that your TV speaker is correct":"Vui lòng kiểm tra loa TV của bạn xem có đúng không","The currently selected speaker is not working. Please choose another speaker in the dropdown below.":"Loa hiện đang chọn không hoạt động. Vui lòng chọn một loa khác từ danh sách thả xuống bên dưới.","Your answer":"Câu trả lời của bạn","Edit":"Sửa","Delete":"Xóa","Settings":"Thiết lập","Signing Out":"Đang đăng xuất","Confirming your account...":"Đang xác nhận tài khoản của bạn...","Something Went Wrong. Please Retry :(":"Đã xảy ra lỗi. Vui lòng thử lại :(","Resending Mail":"Đang gửi lại thư","offline":"ngoại tuyến","I am inviting you to a video meeting:":"Tôi muốn mời bạn tham gia một cuộc họp mặt video:","Resending secure login link to your email":"Đang gửi lại liên kết đăng nhập an toàn đến email của bạn","Sending secure login link to your email":"Đang gửi liên kết đăng nhập an toàn đến email của bạn","Something went Wrong. Please Retry :(":"Đã xảy ra lỗi. Vui lòng thử lại :(","Updating your password":"Đang cập nhật mật khẩu của bạn","Sending mail":"Đang gửi thư","Verifying":"Đang xác minh","This might be slower than usual":"Quá trình này có thể chậm hơn thông thường","Checking":"Đang kiểm tra","New results available! Refresh!":"Đã có kết quả mới! Làm mới!","Saving":"Đang lưu","Turn off Attendee mode":"Tắt Chế độ người tham dự","See Attendee View":"Xem chế độ Xem người tham dự","Total number of attendees currently viewing this session Note: This is for organizer eyes only":"Tổng số người tham dự hiện đang xem phiên sự kiện này Lưu ý: Chỉ người tổ chức mới thấy được con số này","Session Count":"Số người xem phiên","The number of attendees currently viewing live sessions. Note: This is for organizer eyes only":"Số người tham dự hiện đang xem các phiên phát trực tiếp. Lưu ý: Chỉ người tổ chức mới thấy được con số này","Role":"Vai trò","Total Attendees":"Tổng số người tham dự","Total number of attendees online at this time Note: This is for organizer eyes only":"Tổng số người tham dự đang trực tuyến tại thời điểm này Lưu ý: Chỉ người tổ chức mới thấy được con số này","My Profile":"Hồ sơ của tôi","Languages":"Ngôn ngữ","Filling out your profile can help you connect with people with similar interests.":"Điền thông tin vào hồ sơ của bạn có thể giúp bạn kết nối với những người có cùng mối quan tâm.","type to search for your address":"gõ để tìm địa chỉ của bạn","Could not open direct call":"Không mở được cuộc gọi trực tiếp","Chat messages can only be published from inside a broadcast.":"Tin nhắn trò chuyện chỉ được xuất từ trong quá trình phát sóng.","Stage Logo can only be published from inside a broadcast.":"Logo diễn đàn chỉ được xuất từ trong quá trình phát sóng.","Loading Speakers":"Đang nạp diễn giả","Raise hand is disabled for organizer accounts, but active for attendee accounts":"Tài khoản người tổ chức đã bị tắt chức năng giơ tay, nhưng vẫn mở đối với tài khoản người tham dự","Disabled in lite mode, return to live if you’d like to raise hand!":"Đã bị tắt ở chế độ tinh gọn, trở về chế độ phát trực tiếp nếu bạn muốn giơ tay!","Raise hand to enter stage for video q&a":"Giơ tay để vào diễn đàn hỏi đáp video","Speakers":"Diễn giả","Hosting organization: {organization}":"Tổ chức thực hiện: {organization}","Failed to switch {deviceTag}":"Không chuyển đổi được {deviceTag}","Make sure your {deviceTag} is not being used by any other application and is working properly.":"Đảm bảo {deviceTag} của bạn hiện đang không được sử dụng bởi bất kỳ ứng dụng nào khác và hoạt động tốt.","Facing issues with audio or video? Switch on lite mode":"Bạn đang gặp vấn đề với âm thanh hoặc video? Hãy đổi sang chế độ tinh gọn","Failed to get event for eventID: {eventID}":"Không tìm thấy sự kiện có ID sự kiện là: {eventID}","Error while playing video.":"Lỗi khi đang phát video.","Speakers only, attendees can\'t see this chat":"Chỉ dành cho diễn giả, người tham dự không xem được cuộc trò chuyện này","Kudo":"Kudo","Room":"Phòng","Session":"Phiên sự kiện","Booth":"Gian phòng","Public":"Công cộng","Drift":"Drift","Slides":"Trang trình chiếu","Videos":"Video","Chat":"Trò chuyện","Messages":"Thông báo","Poll":"Thăm dò ý kiến","Docs":"Tài liệu","Q&A":"Hỏi đáp","Media":"Phương tiện","Messages Chat":"Tin nhắn trò chuyện","Leaderboard":"Bảng xếp hạng","VCapture":"VCapture","Note: You are also a speaker for this event. You will always be able to enter the Backstage area and go on stage.":"Lưu ý: Bạn cũng là diễn giả của sự kiện này. Bạn sẽ luôn vào được khu vực Hậu trường và vào diễn đàn.","Switch to Attendee View":"Đổi sang chế độ Xem người tham dự","Return to Organizer View":"Trở về chế độ Xem người tổ chức","Switching off attendee view will reload your current page and return you to the organizer view. Would you like to continue?":"Việc tắt chế độ xem người tham dự sẽ nạp lại trang hiện tại và đưa bạn trở về chế độ xem người tổ chức. Bạn có muốn tiếp tục không?","Switch":"Chuyển đổi","Request Sent":"Đã gửi yêu cầu","Your request for a demo has been submitted":"Yêu cầu dùng bản demo của bạn đã được gửi đi","Organizer Redirection":"Chuyển hướng người tổ chức","YES, REDIRECT":"VÂNG, CHUYỂN HƯỚNG","DISMISS":"HỦY BỎ","Attendees are being redirected to the next session: {title}. Would you like to also be redirected to the next session?":"Người tham dự đang được chuyển hướng đến phiên sự kiện tiếp theo: {title}. Bạn có muốn cũng được chuyển hướng đến phiên tiếp theo này không?","Stage":"Diễn đàn","Rooms":"Phòng","Join a round table to discuss moderated topics with your fellow attendees":"Tham dự cuộc họp bàn tròn để thảo luận với những người tham dự khác về các chủ đề được đưa ra bàn luận","Booths":"Gian phòng","Join a booth to know more about a sponsor":"Tham dự một gian phòng để hiểu thêm về nhà tài trợ","You are in the booth":"Bạn đang ở trong gian phòng","People":"Người","Connect with your fellow attendees":"Kết nối với những người tham dự khác","Connect with speakers":"Kết nối với diễn giả","starting in {duration}":"bắt đầu trong {duration}","You will be redirected to booths in {duration}":"Bạn sẽ được chuyển hướng đến các gian phòng trong {duration}","booths":"gian phòng","agenda":"chương trình","You will be redirected to {word} in {duration}":"Bạn sẽ được chuyển hướng đến {word} trong {duration}","You will be redirected to the live stage in {duration}":"YBạn sẽ được chuyển hướng đến diễn đàn phát trực tiếp trong {duration}","- You are about to be redirected to {tabTitle} in {duration}":"- Bạn sắp được chuyển hướng đến {tabTitle} trong {duration}","See Agenda":"Xem chương trình","Break":"Giải lao","{title} is now live":"{title} hiện đang phát trực tiếp","Apologies, due to an error we need to refresh the page!":"Rất tiếc, vì đã xảy ra lỗi nên chúng tôi cần làm mới trang này!","Network interruption detected":"Phát hiện mạng bị gián đoạn","Your internet connection is having some issues. If you are using a VPN, consider disabling it. Alternatively, try connecting to a different network":"Kết nối Internet của bạn đang gặp vấn đề. Nếu bạn đang dùng VPN, hãy cân nhắc tắt tính năng này. Hoặc hãy thử kết nối với một mạng khác","No audio output device detected":"Không phát hiện có thiết bị đầu ra âm thanh","Please connect your speakers/headphones and use the gear icon to test them if you\'re facing any issues.":"Vui lòng kết nối với loa/tai nghe của bạn và sử dụng biểu tượng bánh răng để kiểm tra xem chúng có gặp vấn đề nào không.","Please disable ad blocker for this page":"Vui lòng vô hiệu trình chặn quảng cáo đối với trang này","Yes, I understand":"Có, tôi hiểu","No event user found so attended not marked!":"Không tìm thấy người dùng sự kiện nên người tham dự không được đánh dấu!","Wait while the speaker approves your video q&a request":"Xin chờ trong khi diễn giả duyệt yêu cầu hỏi đáp video của bạn","Organizer":"Người tổ chức","UPNEXT":"KẾ TIẾP","Ended":"Đã chấm dứt","Hide":"Ẩn","This page will automatically redirect you in {durationLeftToRedirect} seconds.":"Trang này sẽ tự động chuyển hướng bạn trong {durationLeftToRedirect} giây.","Register":"Đăng ký","Error: User unable to be registered for this event. Please contact event organizer for assistance":"Lỗi: Người dùng không được đăng ký cho sự kiện này. Vui lòng liên hệ người tổ chức sự kiện để được hỗ trợ","You are already registered!":"Bạn đã được đăng ký!","Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer":"Có vẻ như bạn đã đăng ký sự kiện này! Vui lòng kiểm tra hộp thư rác để tìm thư xác nhận đăng ký của bạn, nếu bạn chưa nhận được. Nếu bạn cần hỗ trợ thêm, vui lòng liên hệ người tổ chức sự kiện","Thank you for registering!":"Cảm ơn bạn đã đăng ký!","Submit another response":"Gửi một phản hồi khác","Share":"Chia sẻ","Know someone who want to attend this?":"Bạn biết có người muốn tham dự sự kiện này?","COPY LINK":"SAO CHÉP LIÊN KẾT","Powered by":"Được cung cấp bởi","VIEW PROFILE":"XEM HỒ SƠ","You can access the event landing here":"Bạn có thể truy cập trang đích của sự kiện ở đây","Need Help?":"Cần trợ giúp?","Welcome back":"Chào mừng bạn quay trở lại","Checking...":"Đang kiểm tra...","Close":"Đóng","Enter":"Vào","See {roomCount} Room(s)":"Xem {roomCount} phòng","Back":"Trở lại","Request a Demo":"Yêu cầu bản demo","Loading":"Đang nạp","Thread":"Chủ đề","Load more":"Nạp thêm","Heads up!":"Sắp diễn ra!","YES":"CÓ","No":"Không","Following":"Đang theo dõi","Error in loading drimify":"Lỗi khi nạp drimify","You\'re not registered for this event":"Bạn chưa được đăng ký cho sự kiện này","Check out other events":"Hãy tìm hiểu các sự kiện khác","Date":"Ngày","Location":"Địa điểm","How are you attending the event":"Bạn sẽ tham dự sự kiện này theo hình thức nào","In Person":"Trực tiếp","Virtually":"Trực tuyến","Event Widgets":"Tiện ích sự kiện","Chat • Messages • Q&A • Poll • Docs":"Trò chuyện • Tin nhắn • Hỏi đáp • Thăm dò ý kiến • Tài liệu","DISCUSSION":"THẢO LUẬN","JOIN":"THAM GIA","WAIT":"CHỜ","more":"khác","See Profile":"Xem hồ sơ","Filter":"Bộ lọc","Video player not supported by your browser":"Trình duyệt của bạn không hỗ trợ trình phát video này","We recommend using the latest version of Google Chrome to access your conference":"Chúng tôi đề nghị bạn sử dụng phiên bản Google Chrome mới nhất để truy cập cuộc hội nghị","ANSWER":"TRẢ LỜI","REJECT":"TỪ CHỐI","Don’t ask me this next time":"Lần tới đừng hỏi lại tôi","Cancel":"Hủy","Lite Mode":"Chế độ tinh gọn","On":"Bật","Connection Issues? Turn on Lite Mode":"Gặp sự cố kết nối? Bật Chế độ tinh gọn","Turn On Lite Mode":"Bật Chế độ tinh gọn","Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?":"Chế độ tinh gọn sẽ gây ra tình trạng chậm trễ 30 giây giữa chương trình phát sóng trực tiếp và những gì bạn nhìn thấy trên màn hình của mình. Bạn có muốn tiếp tục không?","Turn On":"Bật","Lite Mode Active!":"Đang bật Chế độ tinh gọn!","Thanks for your patience, lite mode now on!":"Cảm ơn bạn đã kiên nhẫn, giờ chế độ tinh gọn đã được bật!","Turn off Lite Mode?":"Tắt Chế độ tinh gọn?","Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.":"Tắt chế độ tinh gọn để quay lại xem chương trình phát sóng trực tiếp. Lưu ý, điều này sẽ khiến bạn mất 30 giây nội dung khi bắt kịp sự kiện trong thực tế.","Lite Mode Off!":"Đã tắt Chế độ tinh gọn!","Thanks for your patience, we’ve returned to the live broadcast!":"Cảm ơn bạn đã kiên nhẫn, chúng ta đã quay lại chế độ phát sóng trực tiếp!","Lite Mode Unavailable":"Chế độ tinh gọn không khả dụng","Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.":"Rất tiếc hiện có chút bất tiện khi chưa dùng được chế độ Tinh gọn, vui lòng chuyển sang Chương trình phát sóng trực tiếp để tiếp tục tham gia phiên sự kiện của bạn.","Turn off Lite mode?":"Tắt chế độ Tinh gọn?","We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.":"Chúng tôi phát hiện kết nối của bạn đã bình thường trở lại. Bạn có muốn chuyển về lại chế độ phát sóng trực tiếp không? Lưu ý, điều này sẽ khiến bạn mất 30 giây nội dung khi bắt kịp sự kiện trong thực tế.","Turn Off":"Tắt","Lite mode is disabled for organizer accounts, but active for attendee accounts":"Tài khoản người tổ chức đã bị tắt chế độ Tinh gọn, nhưng vẫn mở đối với tài khoản người tham dự","Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome":"Chế độ Tinh gọn chưa được hỗ trợ trên trình duyệt của bạn. Chúng tôi đề nghị sử dụng phiên bản Google Chrome mới nhất","Lite mode is not curently available. We’ll let you know once it’s available again":"Chế độ Tinh gọn hiện không khả dụng. Chúng tôi sẽ cho bạn biết khi có thể sử dụng trở lại","Turn off Lite Mode":"Tắt Chế độ tinh gọn","We’ll let you know when Lite mode is available again":"Chúng tôi sẽ cho bạn biết khi có thể sử dụng trở lại chế độ Tinh gọn","Lite Mode Available":"Có thể sử dụng Chế độ tinh gọn","Loading Lite Mode...":"Đang nạp Chế độ tinh gọn...","Turning Off Lite Mode":"Đang tắt Chế độ tinh gọn","Lite Mode On":"Chế độ tinh gọn đang được bật","Audio/Video Issues?":"Bạn gặp sự cố âm thanh/video?","Error":"Lỗi","Click a video to play":"Nhấp vào video để phát","Error starting video!":"Lỗi khởi chạy video!","Please rotate your device to {mode} mode":"Vui lòng xoay thiết bị của bạn sang chế độ {mode}","landscape":"ngang","portrait":"dọc","Thank you for attending this event!":"Cảm ơn bạn đã tham dự sự kiện này!","Go to Rooms":"Vào phòng","Please use a desktop or laptop Google Chrome browser to access your conference":"Vui lòng sử dụng trình duyệt Google Chrome trên máy tính để bàn hoặc máy tính xách tay để truy cập hội nghị của bạn","If on Desktop":"Nếu dùng trên Máy tính để bàn","Please increase the width of your window":"Vui lòng tăng chiều rộng của cửa sổ","Alternatively, check out the":"Hoặc hãy xem","Youtube Livestream":"Phát trực tiếp trên Youtube","Search":"Tìm","Profile":"Hồ sơ","Yes":"Có","Loading Chat":"Đang nạp trò chuyện","Please wait while we fetch the chat":"Vui lòng chờ trong khi chúng tôi tìm nạp cuộc trò chuyện","Load old messages":"Nạp tin nhắn cũ","Join the room to see chat":"Tham gia phòng để xem cuộc trò chuyện","Live Chat":"Trò chuyện trực tiếp","Uh..oh we couldn\'t load the content":"Úi chà chúng tôi không nạp được nội dung này","Please reload the page":"Vui lòng nạp lại trang","New comments":"Bình luận mới","Start the conversation":"Bắt đầu trò chuyện","Be the first to add to chat!":"Hãy là người mở lời đầu tiên trong cuộc trò chuyện!","Enter your message":"Nhập tin nhắn của bạn","Joining chat!":"Đang tham gia trò chuyện!","See all pinned messages":"Xem mọi tin nhắn đã ghim","Failed to send! Retry?":"Không gửi được! Thử lại?","Search for attendee":"Tìm người tham dự","Up to date":"Mới nhất","Start a new conversation, We think you\'ll enjoy":"Bắt đầu cuộc trò chuyện mới, chúng tôi nghĩ là bạn sẽ thích","chatting with these recommended attendees!":"trò chuyện với những người tham dự gợi ý này!","Searching":"Đang tìm","Load Previous":"Nạp trước đó","Load Next":"Nạp tiếp theo","Loading Channel":"Đang nạp kênh","Please wait while we fetch the channel":"Vui lòng chờ trong khi chúng tôi tìm nạp kênh","Please wait while we fetch the messages":"Vui lòng chờ trong khi chúng tôi tìm nạp tin nhắn","Send the first message":"Gửi tin nhắn đầu tiên","Join":"Tham gia","link":"liên kết","download":"tải xuống","Click to open":"Nhấp để mở","No open polls":"Không có cuộc thăm dò ý kiến nào đang mở","Check back later to see if a poll opens up!":"Hãy quay lại sau để xem có cuộc thăm dò ý kiến nào được mở không!","Loading Poll":"Đang nạp cuộc thăm dò ý kiến","Please wait while we fetch the polls":"Vui lòng chờ trong khi chúng tôi tìm nạp các cuộc thăm dò ý kiến","Uh oh.. we couldn’t load the content":"Úi chà chúng tôi không nạp được nội dung này","Polls":"Thăm dò ý kiến","To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel":"Để khởi chạy một cuộc Thăm dò ý kiến, hãy thêm câu hỏi và các lựa chọn phản hồi vào phiên này trong Bảng quản trị Goldcast","Stop Sharing":"Dừng chia sẻ","Can\'t publish polls while something else is being presented on stage":"Không xuất được cuộc thăm dò ý kiến trong khi có người đang trình bày trên diễn đàn","Open":"Mở","Cancel your video q&a request":"Hủy yêu cầu hỏi đáp video của bạn","Pending...":"Đang chờ...","Leave Stage":"Rời diễn đàn","Raise Hand":"Giơ tay","Text Q&A":"Hỏi đáp văn bản","Video Q&A":"Hỏi đáp video","Loading Q&amp;A":"Đang nạp Hỏi đáp","Please wait while we fetch the Q&amp;A":"Vui lòng chờ trong khi chúng tôi tìm nạp phần Hỏi đáp","Uh oh.. we couldn\'t load the content":"Úi chà chúng tôi không nạp được nội dung này","No Questions Yet":"Chưa có câu hỏi","Tell your audience to send in questions!":"Hãy yêu cầu khán giả gửi câu hỏi!","Be the first to ask a question!":"Hãy là người đặt câu hỏi đầu tiên!","Tell your audience to raise their hand!":"Hãy bảo khán giả giơ tay!","Approve":"Duyệt","Reject":"Từ chối","End":"Kết thúc","RELOAD":"NẠP LẠI","Logos On Stage":"Logo trên diễn đàn","No File Chosen":"Không có tập tin nào được chọn","loading":"đang nạp","Can\'t publish a slide when there is something else being presented on stage":"Không xuất được trang trình chiếu trong khi có người đang trình bày trên diễn đàn","Change Deck":"Đổi bộ","stop-screen-share":"dừng chia sẻ màn hình","screen-share":"chia sẻ màn hình","Select a deck to begin presenting":"Chọn một bộ trang trình chiếu để bắt đầu trình bày","CONFIRM":"XÁC NHẬN","If you’re having issues, please refer to the":"Nếu bạn vẫn còn gặp vấn đề, vui lòng tham khảo","SPEAKER":"LOA","Issue Testing Audio!":"Có vấn đề khi kiểm tra âm thanh!","VPN and adblockers may cause video issues, please disable them before proceeding":"VPN và trình chặn quảng cáo có thể gây ra sự cố video, vui lòng tắt chúng trước khi tiếp tục","As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast":"Xin lưu ý VPN và trình chặn quảng cáo có thể gây ra sự cố video, vì vậy đảm bảo bạn tắt chúng trong khi phát sóng","Follow":"Theo dõi","Read More":"Đọc thêm","Ask a question":"Đặt câu hỏi","Shared":"Đã chia sẻ","Answered":"Đã trả lời","Waiting Approval":"Đang chờ phê duyệt","cancel":"hủy","ENTER":"VÀO","Upcoming Events":"Sự kiện sắp diễn ra","Past Events":"Sự kiện đã qua","Goldcast":"Goldcast","MANAGE EVENT":"QUẢN LÝ SỰ KIỆN","Edit Profile":"Sửa hồ sơ","Stay tuned!":"Đừng chuyển kênh!","Sign-in instructions will be available here 12 hours prior to the event":"Tại đây sẽ có hướng dẫn đăng nhập 12 giờ trước khi sự kiện diễn ra","Please log out":"Vui lòng đăng xuất","Logout":"Đăng xuất","Continue as {differentUser}":"Tiếp tục bằng tài khoản {differentUser}","You are already logged in as {user}.":"Bạn đã đăng nhập bằng tài khoản {user}.","EMAIL":"EMAIL","user@email.com":"user@email.com","FIRST NAME":"TÊN","First Name":"Tên","LAST NAME":"HỌ","Last Name":"Họ","You are not registered to this event":"Bạn chưa được đăng ký vào sự kiện này","Please enter your email and name":"Vui lòng nhập email và tên của bạn","Please enter your email":"Vui lòng nhập email của bạn","We have sent a secret code to":"Chúng tôi đã gửi mã bí mật tới","BACK":"TRỞ VỀ","Didn\'t receive an email? Make sure to check spam list":"Chưa nhận được email? Đảm bảo kiểm tra danh sách thư rác","Resend Mail":"Gửi lại thư","SECRET CODE":"MÃ BÍ MẬT","Please enter the temporary password sent to your email":"Vui lòng nhập mật khẩu tạm thời được gửi tới email của bạn","NEW PASSWORD":"MẬT KHẨU MỚI","Please enter a new password":"Vui lòng nhập mật khẩu mới","CONFIRM PASSWORD":"XÁC NHẬN MẬT KHẨU","Please re-enter the new password":"Vui lòng nhập lại mật khẩu mới","Password length should be atleast 8":"Mật khẩu phải dài ít nhất 8 ký tự","Password and Confirm Password don\'t match !!":"Mật khẩu và Xác nhận mật khẩu không khớp !!","Please enter your password to continue":"Vui lòng nhập mật khẩu của bạn để tiếp tục","Logging you in...":"Đang đăng nhập...","PASSWORD":"MẬT KHẨU","Forgot credentials?":"Quên thông tin đăng nhập?","Forgot Password? A mail will be sent to your registered email.":"Quên mật khẩu? Chúng tôi sẽ gửi thư đến email đăng ký của bạn.","Email cannot be blank!!":"Không được để trống email!!","We have sent a secure login link to":"Chúng tôi đã gửi một liên kết đăng nhập an toàn tới","from":"từ","Please use that to access your event.":"Vui lòng sử dụng liên kết đó để truy cập sự kiện của bạn.","Please check spam/promotion too if you can\'t find it.":"Vui lòng kiểm tra thư mục rác/quảng cáo nếu bạn không tìm thấy được.","Thank You !":"Cảm ơn bạn!","The link is not valid.":"Liên kết không hợp lệ.","Please be patient.":"Xin hãy kiên nhẫn.","We are verifying your link.":"Chúng tôi đang xác minh liên kết của bạn.","Thank you for entering the code!":"Cảm ơn bạn đã nhập mã!","Please create a new password":"Vui lòng tạo mật khẩu mới","Signing you up...":"Đang đăng ký...","We have sent a temporary password to":"Chúng tôi có gửi mật khẩu tạm thời tới","TEMPORARY PASSWORD":"MẬT KHẨU TẠM THỜI","Please enter the temporary password sent to your mail":"Vui lòng nhập mật khẩu tạm thời được gửi tới thư của bạn","Password Length should be 8":"Mật khẩu phải dài 8 ký tự","Okay":"Okay","Backstage: {title}":"Hậu trường: {title}","Prep Area":"Khu vực chuẩn bị","Starting at {time}":"Bắt đầu vào {time}","person":"người","inside":"bên trong","No one is inside":"Không có ai ở trong","This area is for you to sync up with your fellow speakers before you go on stage.":"Khu vực này là nơi để bạn đồng bộ hóa với các diễn giả khác trước khi lên diễn đàn.","This area is for you to check your cam and mic before you enter the room.":"Khu vực này là nơi để bạn kiểm tra cam và mic trước khi vào phòng.","I\'m Ready":"Tôi đã sẵn sàng","Watch Live":"Xem trực tiếp","Backstage":"Hậu trường","You are sharing your screen":"Bạn đang chia sẻ màn hình","LIVE":"TRỰC TIẾP","Live":"Trực tiếp","Virtual":"Ảo","Only available for ":"Chỉ dành cho ","See Booths":"Xem gian phòng","See Rooms":"Xem phòng","Enter Backstage":"Vào hậu trường","This track has no upcoming sessions. Check out a different track.":"Kênh này không có phiên sự kiện nào sắp diễn ra. Hãy xem một kênh khác.","View":"Xem","Agenda":"Chương trình","Scroll to see all tracks":"Cuộn để xem mọi kênh","No Agenda Items to show!":"Không có mục chương trình nào để hiển thị!","ENTER EVENT":"VÀO SỰ KIỆN","change":"đổi","Upload":"Tải lên","JPG, GIF OR PNG. MAX SIZE OF 5MB":"JPG, GIF HOẶC PNG. KÍCH THƯỚC TỐI ĐA 5MB","Create Profile":"Tạo hồ sơ","Email":"Email","Company":"Công ty","Title":"Chức danh","No matching locations found":"Không tìm thấy địa điểm trùng khớp","You can try searching for the location with another keyword":"Bạn có thể thử tìm kiếm địa điểm này bằng từ khóa khác","Interest Tags":"Thẻ sở thích","Pick your first tag":"Chọn thẻ đầu tiên của bạn","Save":"Lưu","Searching...":"Đang tìm...","Twitter":"Twitter","Select Your First Tags":"Chọn thẻ đầu tiên của bạn","Add Interest tags":"Thêm thẻ sở thích","Congratulations!":"Chúc mừng!","Your first Goldcast event is set up":"Sự kiện Goldcast đầu tiên của bạn đã được thiết lập","You can always visit":"Bạn có thể luôn vào xem","help.goldcast.io":"help.goldcast.io","for instructions on how to set up and run your events":"để được hướng dẫn cách thức thiết lập và chạy các sự kiện của bạn","See My Event":"Xem sự kiện của tôi","Peak Community":"Peak Community","Loading Lite Mode... This may take up to 30s":"Đang nạp Chế độ tinh gọn... Quá trình này có thể mất tới 30 giây","Loading Video...":"Đang nạp video...","Video will begin at session start time":"Video sẽ bắt đầu vào thời gian bắt đầu của phiên sự kiện","TIME":"THỜI GIAN","TITLE":"TIÊU ĐỀ","STATUS":"TRẠNG THÁI","END":"KẾT THÚC","START":"BẮT ĐẦU","AGENDA":"CHƯƠNG TRÌNH","Enable Audio":"Bật âm thanh","Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.":"Âm thanh bị tắt do các chính sách tự động phát của trình duyệt. Nhấp vào nút bật bên dưới để bỏ tắt tiếng. Bạn cũng có thể bỏ tắt tiếng âm thanh sau thông qua các tiện ích điều khiển được nhúng.","Enable":"Bật","You are being redirected outside the room. Would you like to continue?":"Bạn đang được chuyển hướng bên ngoài phòng. Bạn có muốn tiếp tục không?","Continue":"Tiếp tục","Alternatively, you can use lite mode which will have a 30s delay from the live broadcast":"Ngoài ra, bạn có thể sử dụng chế độ tinh gọn với độ trễ 30 giây kể tính từ khi phát sóng trực tiếp","We detected a network issue":"Chúng tôi phát hiện có sự cố mạng","Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.":"Vui lòng đảm bảo bạn không kết nối qua VPN/Tường lửa. Hãy thử thay đổi mạng, trình duyệt hoặc thiết bị của bạn nếu sự cố vẫn tiếp diễn.","Could not connect":"Không kết nối được","This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists":"Có thể là do sự cố mạng bảo mật, trình duyệt/thiết bị. Hãy thử thay đổi mạng, trình duyệt hoặc thiết bị của bạn nếu sự cố vẫn tiếp diễn.","Switch to Lite Mode":"Chuyển sang Chế độ tinh gọn","Leave":"Rời khỏi","Screenshare had an issue":"Chức năng chia sẻ màn hình gặp sự cố","Could not share screen unexpectedly. Refresh & retry. On mac go to":"Đột ngột không chia sẻ được màn hình. Làm mới và thử lại. Trên hệ điều hành mac, vào","and check if your browser has the required permission":"và kiểm tra xem trình duyệt của bạn có được cấp phép cần thiết hay không","Uh OH... Something went wrong":"Ui chao đã xảy ra lỗi","To fix this, click the":"Để khắc phục, nhấp vào","in your URL bar, then select “Allow”, and then click “Try Again”":"trong thanh URL của bạn, sau đó chọn “Cho phép” rồi nhấp vào “Thử lại”","Couldn\'t initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using \\"Google Chrome\\". If this issue persists, please contact Goldcast Support":"Không thể khởi tạo luồng phương tiện của bạn vì lý do không xác định! Trình duyệt của bạn có thể không được nền tảng của chúng tôi hỗ trợ. Chúng tôi đề nghị sử dụng \\"Google Chrome\\". Nếu sự cố này vẫn tiếp diễn, vui lòng liên hệ với bộ phận Hỗ trợ của Goldcast","To fix this, make sure your":"Để khắc phục, đảm bảo","is not being accessed by any other app. If not, please try changing your":"của bạn không đang được truy cập bởi bất kỳ ứng dụng nào khác. Nếu không, hãy thử thay đổi","devices by clicking on \\"Go To Settings\\". After resolving the probable issue, hit \\"Try Again\\"!":"thiết bị của bạn bằng cách nhấp vào \\"Vào cài đặt\\". Sau khi giải quyết được sự cố có thể xảy ra, hãy nhấp \\"Thử lại\\"!","Go To Settings":"Vào cài đặt","Try Again":"Thử lại","Try Joining without Video":"Hãy thử tham gia mà không có video","A refresh and rejoin should work":"Làm mới và tham gia lại sẽ có hiệu quả","Refresh & Rejoin":"Làm mới & Tham gia lại","Start Chat":"Bắt đầu trò chuyện","On Stage":"Trên diễn đàn","Connect your on-site camera and microphone to present to your virtual attendees":"Kết nối camera và micrô có sẵn để thuyết trình với những người tham dự trực tuyến của bạn","Stop Streaming":"Dừng phát trực tiếp","Start Streaming":"Bắt đầu phát trực tiếp","Set up on-site video feed":"Cài đặt nguồn cấp dữ liệu video có sẵn","Open TV":"Mở TV","Layout: {layout} ":"Bố cục: {layout} ","With Speaker Videos":"Có video của diễn giả","Full Screen":"Toàn màn hình","No Speakers":"Không có loa","Turn Off Setup Mode":"Đóng chế độ cài đặt","Setup Mode":"Chế độ cài đặt","Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.":"Vui lòng nhấn tắt nếu bạn muốn dừng chế độ cài đặt cho {roomTitle}. Làm như vậy cũng sẽ tắt mọi luồng phát đang hoạt động.","Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.":"Đang chuẩn bị phát trực tuyến: {roomTitle}. Vui lòng chỉ sử dụng chế độ cài đặt để phát trực tiếp từ địa điểm phát trực tiếp.","Starting in {duration}":"Bắt đầu trong {duration}","Can\'t share screen while there is something else being presented on stage":"Không chia sẻ được màn hình trong khi có người đang trình bày trên diễn đàn","You are now in attendee view!":"Hiện bạn đang ở chế độ người tham dự!","You are now in organizer view!":"Hiện bạn đang ở chế độ người tổ chức!","Note :":"Ghi chú:","Only organizer accounts can see this tag, normal attendees can’t see this":"Chỉ tài khoản người tổ chức mới thấy được thẻ này, còn người tham dự bình thường không thấy được","Attendee":"Người tham dự","Event Information":"Thông tin sự kiện","Event Information is only visible to organizers! <br /> This section is not visible to attendees":"Thông tin sự kiện chỉ được hiển thị cho người tổ chức! <br /> Phần này không hiển thị cho người tham dự","Operating System":"Hệ điều hành","Secondary Booths":"Gian phòng phụ","Sort":"Sắp xếp","Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}":"Nếu theo dõi {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}","{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}":"{following_track2}bạn sẽ tự động bỏ theo dõi{track1_Would_you_like_to_continue}","{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?":"{following_track2_will_automatically_unfollow_you_from_track1}Bạn có muốn tiếp tục không?","Track only available for {tracks}":"Kênh chỉ dành cho {tracks}","Add to Calendar":"Thêm vào lịch","Open Speakers Control Panel":"Mở bảng điều khiển diễn giả","Move Offstage ↓":"Rời khỏi diễn đàn↓","Error Moving ⚠":"Lỗi khi di chuyển⚠","Off Stage":"Ngoài diễn đàn","Move to Stage":"Di chuyển lên diễn đàn","An error occurred!":"Đã xuất hiện lỗi!","{eventName} Documents":"{eventName} Tài liệu"," Set Up Mode":" Chế độ cài đặt","Camera & Mic blocked":"Camera & Mic bị chặn","Camera/Mic Inaccessible":"Không truy cập được Camera/Mic","Camera/Mic Not Found":"Không tìm thấy Camera/Mic","Camera Inaccessible":"Không truy cập được Camera","The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!":"Camera đang bị chiếm dụng hoặc độ phân giải không được hỗ trợ. Đảm bảo camera của bạn không được sử dụng bởi ứng dụng khác và thử lại!","No microphone/camera is found":"Không tìm thấy micrô/camera","The browser does not support using camera and microphone!":"Trình duyệt không hỗ trợ sử dụng camera và micrô!","{n} Slides":"{n} Trang trình chiếu","Starting in {timeduration}":"Bắt đầu trong {timeduration}","{eventtitle} has ended":"{eventtitle} đã kết thúc","This is a text q&a question!":"Đây là câu hỏi hỏi đáp văn bản!","Click here{if_it_does_not}":"Nhấp vào đây{if_it_does_not}","{click_here}if it does not":"{click_here}nếu không xảy ra","{title}up next":"{title}tiếp theo","seat(s) open":"chỗ còn mở","Signal strength is low. Close other windows or connect to a different network.":"Chất lượng tín hiệu kém. Đóng các cửa sổ khác hoặc kết nối với một mạng khác.","GO BACKSTAGE":"VÀO HẬU TRƯỜNG","LEAVE STAGE":"RỜI KHỎI DIỄN ĐÀN","LEAVE":"RỜI KHỎI","This event begins on{startitme}":"Sự kiện này bắt đầu vào{startitme}","Please refresh to enter.":"Vui lòng làm mới để vào.","people":"người","Oops, Something went wrong":"Ui chao đã xảy ra lỗi","Back Home":"Quay lại trang chủ","Deciding where to go ...":"Đang quyết định xem sẽ đi đâu...","Go to Event Hub":"Vào Trung tâm sự kiện","CREATE":"TẠO","Attending Virtually":"Tham dự trực tuyến","Attending In Person":"Tham dự trực tiếp","Click to change your attendance type":"Nhấp vào để thay đổi hình thức tham dự của bạn","Open Chat":"Mở trò chuyện","Create your profile for {eventtitle}":"Tạo hồ sơ của bạn cho {eventtitle}","Move to stage":"Di chuyển lên diễn đàn","The event organizer has requested to move you to the stage for <strong>{broadcastTitle}</strong>.<br /><br />If you click to accept the request, you will be live and visible to event attendees.<br /><br />":"Người tổ chức sự kiện đã yêu cầu chuyển bạn lên sân khấu cho sự kiện <strong>{broadcastTitle}</strong>.<br /><br />Nếu bạn nhấp để chấp nhận yêu cầu, bạn sẽ phát trực tiếp và những người tham dự sự kiện sẽ nhìn thấy bạn.<br /><br />","Go Live On Stage":"Phát trực tiếp trên diễn đàn","Moved to backstage":"Đã di chuyển về hậu trường","The organizer has removed you from the stage. Please do not try to rejoin without contacting the organizer.":"Người tổ chức đã loại bạn khỏi diễn đàn. Vui lòng không tìm cách tham gia lại khi chưa liên hệ với người tổ chức.","Error creating Screen stream":"Lỗi tạo luồng phát Màn hình","Permission to share screen is not granted. Please *click here* to go through troubleshooting docs.":"Chưa được cấp quyền chia sẻ màn hình. Vui lòng *nhấp vào đây* để tham khảo các tài liệu khắc phục sự cố.","Error publishing stream":"Lỗi xuất bản luồng phát","Could not publish stream. Please refresh and try again!":"Không thể xuất bản luồng phát. Vui lòng làm mới và thử lại!","Error publishing screen":"Lỗi xuất bản màn hình","Error publishing screen. Please refresh and try again!":"Lỗi xuất bản màn hình. Vui lòng làm mới và thử lại!","Error unpublishing stream":"Lỗi hủy xuất bản luồng phát","Error unpublishing stream. Please refresh and try again!":"Lỗi hủy xuất bản luồng phát. Vui lòng làm mới và thử lại!","Invalid Publish Operation":"Thao tác xuất bản không hợp lệ","{username} profile picture":"Ảnh hồ sơ {username}","Default":"Mặc định","A-Z":"A-Z","Random":"Ngẫu nhiên","All":"Tất cả","Past":"Đã qua","Upcoming":"Sắp diễn ra","Learn More":"Tìm hiểu thêm","close":"đóng","Discussion Rooms":"Phòng thảo luận","ATTENDEE MODE":"CHẾ ĐỘ NGƯỜI THAM DỰ","Loading...":"Đang nạp...","The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click \'Try again\'":"Thiết bị bị vô hiệu hóa bởi trình duyệt hoặc chưa được cấp quyền sử dụng. Vui lòng cấp quyền và nhấp vào \'Thử lại\'","You are now registered. You will receive an email confirming details shortly.":"Hiện bạn đã được đăng ký. Bạn sẽ sớm nhận được email xác nhận thông tin chi tiết.","Streaming to Virtual Users from on-site video feed":"Phát trực tuyến tới Người dùng trực tuyến từ nguồn cấp dữ liệu video có sẵn","Ending in ":"Sắp kết thúc trong ","GO LIVE":"PHÁT TRỰC TIẾP","You have no past events.":"Bạn không có sự kiện nào trong quá khứ.","You have no upcoming or live events.":"Bạn không có sự kiện trực tiếp hoặc sắp diễn ra nào.","left":"trái","center":"giữa","right":"phải","top":"trên cùng","bottom":"dưới cùng","loading...":"đang nạp..","Loading ...":"Đang nạp...","Failed to redirect!":"Không chuyển hướng được!","You seem to have an ad blocker enabled. It might prevent you from having the best possible experience. Please disable it. <br /><br / > If you need help on how to do this, click <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>here</a> for further instructions.":"Có vẻ như bạn đã đang kích hoạt trình chặn quảng cáo. Tiện ích này có thể ngăn bạn có được trải nghiệm tốt nhất có thể. Hãy vô hiệu hóa tiện ích này. <br />&lt;br / &gt; Nếu bạn cần trợ giúp để biết cách thực hiện, nhấp <a target = \'_blank\' href=\'https://help.goldcast.io/hc/en-us/articles/4408141111323#h_01FMW3QNNJ09TPH1R8NE4EW034\'>vào đây</a> để được hướng dẫn thêm.","redirecting in {duration}":"sẽ chuyển hướng trong {duration}","STOP VIDEO":"DỪNG VIDEO","You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?":"Bạn sắp ngừng phát video này. Chương trình phát sóng của bạn sẽ quay trở lại chế độ phát trực tiếp và khán giả sẽ nhìn và nghe thấy các diễn giả của bạn. Bạn có chắc không?","STOP SHARING":"DỪNG CHIA SẺ","No Next Slide":"Không có trang trình chiếu tiếp theo","Next Slide":"Trang trình chiếu tiếp theo","No Previous Slide":"Không có trang trình chiếu trước đó","Previous Slide":"Trang trình chiếu trước đó","something went wrong while recording the response please try again":"đã xảy ra lỗi khi ghi lại câu trả lời, vui lòng thử lại","Start In-Person Streaming":"Bắt đầu phát trực tiếp","Stop In-Person Streaming":"Dừng phát trực tiếp","Your video is being buffered and test session will begin shortly. This will not happen during the actual session.":"Video của bạn đang được lưu vào bộ nhớ đệm và phiên kiểm tra sẽ sớm bắt đầu. Điều này sẽ không xảy ra trong phiên thực tế.","The ticker will appear across the top of the webpage for for all attendees. To turn the ticker into a hyperlink enter the URL below":"Nhãn thông báo sẽ xuất hiện trên đầu trang web dành cho tất cả người tham dự. Để chuyển nhãn thông báo thành một siêu liên kết, hãy nhập URL vào bên dưới","Allow {key}":"Cho phép {key}","{messageType} can only be published from inside a broadcast.":"{messageType} chỉ được xuất từ trong quá trình phát sóng.","To grant {deviceName} access to this page, follow the two steps below:":"Để cấp cho {deviceName} quyền truy cập vào trang này, hãy làm theo hai bước dưới đây:","2. Allow {deviceName} access and then refresh the page.":"2. Cho phép {deviceName} truy cập và sau đó làm mới trang."}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AboutRegistration: function() { return /* reexport */ aboutRegistration; },
  AccessibleRating: function() { return /* reexport */ AccessibleRating; },
  AccessibleSelect: function() { return /* reexport */ AccessibleSelect; },
  AgendaFavoritesFilter: function() { return /* reexport */ AgendaFavoritesFilter; },
  AgendaFilter: function() { return /* reexport */ AgendaFilter; },
  AgoraV4Player: function() { return /* reexport */ AgoraV4Player; },
  ArrowWithCircleBg: function() { return /* reexport */ ArrowWithCircleBg; },
  AtcButton: function() { return /* reexport */ AtcButton; },
  AttendeePollView: function() { return /* reexport */ AttendeePollView; },
  AuthButton: function() { return /* reexport */ AuthButton; },
  AuthInput: function() { return /* reexport */ AuthInput; },
  AuthPageWrapper: function() { return /* reexport */ AuthPageWrapper; },
  AuthPopup: function() { return /* reexport */ AuthPopup; },
  AuthProgress: function() { return /* reexport */ AuthProgress; },
  AuthWrapper: function() { return /* reexport */ AuthWrapper; },
  AutoplayErrorDialog: function() { return /* reexport */ AutoplayErrorDialog; },
  Badge: function() { return /* reexport */ Badge; },
  Banner: function() { return /* reexport */ Banner; },
  BlockSpeakerOrgScreen: function() { return /* reexport */ BlockSpeakerOrgScreen; },
  BoothCard: function() { return /* reexport */ BoothCard; },
  BoothDetails: function() { return /* reexport */ BoothDetails; },
  BoothGrid: function() { return /* reexport */ BoothGrid; },
  BottomDrawer: function() { return /* reexport */ BottomDrawer; },
  BreakScreenSaver: function() { return /* reexport */ BreakScreenSaver; },
  BroadcastHybridSetupMode: function() { return /* reexport */ BroadcastHybridSetupMode; },
  BroadcastScreenSaver: function() { return /* reexport */ BroadcastScreenSaver; },
  BroadcastSlide: function() { return /* reexport */ BroadcastSlide; },
  CamAndMicPermissionPopUp: function() { return /* reexport */ CamAndMicPermissionPopUp; },
  ChatLoadMoreButton: function() { return /* reexport */ ChatLoadMoreButton; },
  ChatMessageRenderer: function() { return /* reexport */ ChatMessageRenderer; },
  ChatReactionBar: function() { return /* reexport */ ChatReactionBar; },
  CloseButton: function() { return /* reexport */ CloseButton; },
  ConferenceRoom: function() { return /* reexport */ ConferenceRoom; },
  ConfirmLiveSwitch: function() { return /* reexport */ ConfirmLiveSwitch; },
  ConfirmTrackChange: function() { return /* reexport */ ConfirmTrackChange; },
  ConfirmationDialog: function() { return /* reexport */ ConfirmationDialog; },
  ConfirmationDialogWrapper: function() { return /* reexport */ ConfirmationDialogWrapper; },
  CurrentLiveSessions: function() { return /* reexport */ CurrentLiveSessions; },
  DifferentUserLoggedIn: function() { return /* reexport */ DifferentUserLoggedIn; },
  DiscussionRoomWrapper: function() { return /* reexport */ DiscussionRoomWrapper; },
  DriftEmbed: function() { return /* reexport */ DriftEmbed; },
  DrimifyContainer: function() { return /* reexport */ DrimifyContainer; },
  DrimifyContainerNewConfigs: function() { return /* reexport */ DrimifyContainerNewConfigs; },
  DropdownSetup: function() { return /* reexport */ DropdownSetup; },
  ElementResizeObserver: function() { return /* reexport */ resizeobserverimport; },
  EntryPage: function() { return /* reexport */ EntryPage; },
  ErrorCrossSvg: function() { return /* reexport */ ErrorCrossSvg; },
  ErrorPage403: function() { return /* reexport */ ErrorPage_403; },
  EventAgenda: function() { return /* reexport */ EventAgenda; },
  EventBlur: function() { return /* reexport */ EventBlur; },
  EventCard: function() { return /* reexport */ EventCard; },
  EventDetails: function() { return /* reexport */ EventDetails; },
  EventOnboarding: function() { return /* reexport */ Onboarding; },
  EventOnboardingPage: function() { return /* reexport */ EventOnboardingPage; },
  EventPage: function() { return /* reexport */ EventPage; },
  EventScreenSaver: function() { return /* reexport */ EventScreenSaver; },
  EventsNavBar: function() { return /* reexport */ EventsNavBar; },
  EventsSection: function() { return /* reexport */ EventsSection; },
  FavoriteButton: function() { return /* reexport */ FavoriteButton; },
  FilterBar: function() { return /* reexport */ FilterBar; },
  FitText: function() { return /* reexport */ FitText; },
  ForgotPasswordPage: function() { return /* reexport */ ForgotPasswordPage; },
  FreeFormTextQuestion: function() { return /* reexport */ FreeFormText; },
  FreeTrialSuccessPage: function() { return /* reexport */ FreeTrialSuccessPage; },
  GCheckbox: function() { return /* reexport */ GCheckbox; },
  GSelect: function() { return /* reexport */ GSelect; },
  GTextArea: function() { return /* reexport */ GTextArea; },
  GToggle: function() { return /* reexport */ GToggle; },
  GTooltip: function() { return /* reexport */ GTooltip; },
  GenericHeaderNotification: function() { return /* reexport */ GenericHeaderNotification; },
  GenericMessageDialog: function() { return /* reexport */ GenericMessageDialog; },
  GifRenderer: function() { return /* reexport */ GifRenderer; },
  GoldBotRatingButton: function() { return /* reexport */ GoldBotRatingButton; },
  HelpdocLink: function() { return /* reexport */ HelpdocLink; },
  HlsNotSupported: function() { return /* reexport */ HlsNotSupported; },
  HlsRoom: function() { return /* reexport */ HlsRoom; },
  HlsSupportChecker: function() { return /* reexport */ HlsSupportChecker; },
  HlsVideoPlayer: function() { return /* reexport */ HlsVideoPlayer; },
  HybridDialog: function() { return /* reexport */ HybridDialog; },
  IconButton: function() { return /* reexport */ IconButton; },
  IframeEmbedder: function() { return /* reexport */ IframeEmbedder; },
  IncomingVideoCallNotify: function() { return /* reexport */ IncomingVideoCallNotify; },
  KudoEmbed: function() { return /* reexport */ KudoEmbed; },
  LabeledSeparator: function() { return /* reexport */ LabeledSeparator; },
  LeaveRoomDialog: function() { return /* reexport */ LeaveRoomDialog; },
  LiteModeToggle: function() { return /* reexport */ LiteModeToggle; },
  LitemodeSwitcher: function() { return /* reexport */ LitemodeSwitcher; },
  LiveHLSRoom: function() { return /* reexport */ LiveHLSRoom; },
  LiveVideoSelectorWidget: function() { return /* reexport */ LiveVideoSelectorWidget; },
  LivenessControlPage: function() { return /* reexport */ LivenessControlPage; },
  LivenessPanelRecordingItem: function() { return /* reexport */ LivenessPanelRecordingItem; },
  Loading: function() { return /* reexport */ Loading; },
  LoginPage: function() { return /* reexport */ LoginPage; },
  MagicLinkSent: function() { return /* reexport */ MagicLinkSent; },
  MagicLinkVerifyPage: function() { return /* reexport */ MagicLinkVerifyPage; },
  MobileChatToggle: function() { return /* reexport */ MobileChatToggle; },
  MultipleChoiceQuestion: function() { return /* reexport */ MultipleChoice; },
  MuteButton: function() { return /* reexport */ MuteButton; },
  NavigationBar: function() { return /* reexport */ NavigationBar; },
  NavigationItem: function() { return /* reexport */ NavigationItem; },
  NetworkErrorDialog: function() { return /* reexport */ NetworkErrorDialog; },
  NewPasswordPage: function() { return /* reexport */ NewPasswordPage; },
  NewSimpleSelect: function() { return /* reexport */ NewSimpleSelect; },
  NoICEErrorDialog: function() { return /* reexport */ NoICEErrorDialog; },
  NotificationDialog: function() { return /* reexport */ NotificationDialog; },
  Observer: function() { return /* reexport */ Observer; },
  OutlinedButton: function() { return /* reexport */ OutlinedButton; },
  OverflowWatcher: function() { return /* reexport */ OverflowWatcher; },
  Paginator: function() { return /* reexport */ Paginator; },
  PillButton: function() { return /* reexport */ PillButton; },
  PollWidget: function() { return /* reexport */ PollWidget; },
  PopUpCreateTickerDialog: function() { return /* reexport */ PopUpCreateTickerDialog; },
  PoweredBy: function() { return /* reexport */ PoweredBy; },
  PreRedirectionPopup: function() { return /* reexport */ PreRedirectionPopup; },
  ProfilePage: function() { return /* reexport */ ProfilePage; },
  ProgressBar: function() { return /* reexport */ ProgressBar; },
  ProgressLevel: function() { return /* reexport */ ProgressLevel; },
  PublishedStage: function() { return /* reexport */ PublishedStage; },
  RadioSelectBtn: function() { return /* reexport */ RadioSelectBtn; },
  RaiseHandButton: function() { return /* reexport */ RaiseHandButton; },
  RatingQuestion: function() { return /* reexport */ Rating; },
  ReadMoreLessWrapper: function() { return /* reexport */ ReadMoreLessWrapper; },
  RedirectionScreenSaver: function() { return /* reexport */ RedirectionScreenSaver; },
  RegistrationPage: function() { return /* reexport */ RegistrationPage; },
  Ribbon: function() { return /* reexport */ Ribbon; },
  RoomCard: function() { return /* reexport */ RoomCard; },
  RoomsPage: function() { return /* reexport */ RoomsPage; },
  RoomsScreenSaver: function() { return /* reexport */ RoomsScreenSaver; },
  RotationBlocker: function() { return /* reexport */ RotationBlocker; },
  ScreenSaverWrapper: function() { return /* reexport */ ScreenSaverWrapper; },
  ScreenShareTest: function() { return /* reexport */ ScreenShareTest; },
  ScreenSizeBlocker: function() { return /* reexport */ ScreenSizeBlocker; },
  ScreenStreamErrorDialog: function() { return /* reexport */ ScreenStreamErrorDialog; },
  ScrollCompWithLeftRightArrow: function() { return /* reexport */ ScrollCompWithLeftRightArrow; },
  ScrollCompWithTopBottomArrow: function() { return /* reexport */ ScrollCompWithTopBottomArrow; },
  SearchField: function() { return /* reexport */ SearchField; },
  SessionChangeConfirmation: function() { return /* reexport */ SessionChangeConfirmation; },
  SettingsModal: function() { return /* reexport */ SettingsModal; },
  SetupModeSwitch: function() { return /* reexport */ SetupModeSwitch; },
  SidebarAssetsTab: function() { return /* reexport */ SidebarAssetsTab; },
  SidebarChatInput: function() { return /* reexport */ SidebarChatInput; },
  SidebarChatScrollHelper: function() { return /* reexport */ SidebarChatScrollHelper; },
  SidebarChatWidget: function() { return /* reexport */ SidebarChatWidget; },
  SidebarContainer: function() { return /* reexport */ SidebarContainer; },
  SidebarDocs: function() { return /* reexport */ SidebarDocs; },
  SidebarEmptyState: function() { return /* reexport */ SidebarEmptyState; },
  SidebarMessageDateDivider: function() { return /* reexport */ SidebarMessageDateDivider; },
  SidebarMessageItem: function() { return /* reexport */ SidebarMessageItem; },
  SidebarMessageList: function() { return /* reexport */ SidebarMessageList; },
  SidebarP2PChat: function() { return /* reexport */ SidebarP2PChat; },
  SidebarPollsWidget: function() { return /* reexport */ SidebarPollsWidget; },
  SidebarPrimaryTabBtn: function() { return /* reexport */ SidebarPrimaryTabBtn; },
  SidebarPrimaryTabs: function() { return /* reexport */ SidebarPrimaryTabs; },
  SidebarQAWidget: function() { return /* reexport */ SidebarQAWidget; },
  SidebarSurveyWidget: function() { return /* reexport */ SidebarSurveyWidget; },
  SidebarTextInputWrapper: function() { return /* reexport */ SidebarTextInputWrapper; },
  SidebarTextQA: function() { return /* reexport */ SidebarTextQA; },
  SidebarUserProfile: function() { return /* reexport */ SidebarUserProfile; },
  SidebarVideoCallItem: function() { return /* reexport */ SidebarVideoCallItem; },
  SidebarVideoQA: function() { return /* reexport */ SidebarVideoQA; },
  SidebarWidgetContainer: function() { return /* reexport */ SidebarWidgetContainer; },
  SignalIndicator: function() { return /* reexport */ SignalIndicator; },
  SimpleButton: function() { return /* reexport */ SimpleButton; },
  SimpleInput: function() { return /* reexport */ SimpleInput; },
  SimpleLabel: function() { return /* reexport */ SimpleLabel; },
  SimpleProfileInput: function() { return /* reexport */ SimpleProfileInput; },
  SimpleRadioButton: function() { return /* reexport */ SimpleRadioButton; },
  SimpleRangeInput: function() { return /* reexport */ SimpleRangeInput; },
  SimpleScreenBlocker: function() { return /* reexport */ SimpleScreenBlocker; },
  SimpleSelect: function() { return /* reexport */ SimpleSelect; },
  SingleChoiceQuestion: function() { return /* reexport */ SingleChoice; },
  SingleSelect: function() { return /* reexport */ SingleSelect; },
  Slide: function() { return /* reexport */ Slide; },
  SlideControl: function() { return /* reexport */ SlideControl; },
  SlideDeck: function() { return /* reexport */ SlideDeck; },
  SlideImage: function() { return /* reexport */ SlideImage; },
  SlideScreen: function() { return /* reexport */ SlidesScreen; },
  SlidesList: function() { return /* reexport */ SlidesList; },
  SlidoContainer: function() { return /* reexport */ SlidoContainer; },
  SpeakerCard: function() { return /* reexport */ SpeakerCard; },
  SpeakerHandoffCard: function() { return /* reexport */ SpeakerHandoffCard; },
  SpeakerPollView: function() { return /* reexport */ SpeakerPollView; },
  SpeakerTestCard: function() { return /* reexport */ SpeakerTestCard; },
  SpeakersControlPanel: function() { return /* reexport */ SpeakersControlPanel; },
  SpeakersGrid: function() { return /* reexport */ SpeakersGrid; },
  SpeakersList: function() { return /* reexport */ SpeakersList; },
  SpeakersSection: function() { return /* reexport */ SpeakersSection; },
  Splash: function() { return /* reexport */ Splash; },
  Stage: function() { return /* reexport */ Stage; },
  StageControlBar: function() { return /* reexport */ StageControlBar; },
  StageLayoutsOptions: function() { return /* reexport */ StageLayoutsOptions; },
  StageRollVideoPlayer: function() { return /* reexport */ StageRollVideoPlayer; },
  StageSpeakers: function() { return /* reexport */ StageSpeakers; },
  StageSpeakersControl: function() { return /* reexport */ StageSpeakersControl; },
  StageWrapper: function() { return /* reexport */ StageWrapper; },
  StreamErrorDialog: function() { return /* reexport */ StreamErrorDialog; },
  StyledReadmoreText: function() { return /* reexport */ StyledReadmoreText; },
  StyledText: function() { return /* reexport */ StyledText; },
  SurveyPopUp: function() { return /* reexport */ SurveyPopUp; },
  SurveyStageBarTip: function() { return /* reexport */ SurveyStageBarTip; },
  SvgIcon: function() { return /* reexport */ SvgIcon; },
  TagsFilter: function() { return /* reexport */ TagsFilter; },
  TechCheck: function() { return /* reexport */ TechCheck; },
  TechSetup: function() { return /* reexport */ TechSetup; },
  TempPasswordPage: function() { return /* reexport */ TempPasswordPage; },
  TextButton: function() { return /* reexport */ TextButton; },
  TextQNAAnswerHolder: function() { return /* reexport */ TextQNAAnswerHolder; },
  TextQNAItem: function() { return /* reexport */ TextQNAItem; },
  TextQNAMoreDropdown: function() { return /* reexport */ TextQNAMoreDropdown; },
  TextQnaPublished: function() { return /* reexport */ TextQnaPublished; },
  Ticker: function() { return /* reexport */ Ticker; },
  TransitionToast: function() { return /* reexport */ TransitionToast; },
  TryAgain: function() { return /* reexport */ TryAgain; },
  TypeformContainer: function() { return /* reexport */ TypeformContainer; },
  UnknownErrorDialog: function() { return /* reexport */ UnknownErrorDialog; },
  UserBubble: function() { return /* reexport */ UserBubble; },
  UserHomeNavBar: function() { return /* reexport */ UserHomeNavBar; },
  UserImage: function() { return /* reexport */ UserImage; },
  UserLandingPage: function() { return /* reexport */ UserLandingPage; },
  UserModalPage: function() { return /* reexport */ UserModalPage; },
  UserProfile: function() { return /* reexport */ UserProfile; },
  UserProfileDropdown: function() { return /* reexport */ UserProfileDropdown; },
  UserProfilePage: function() { return /* reexport */ Profile; },
  UserTooltip: function() { return /* reexport */ UserTooltip; },
  VideoCaptions: function() { return /* reexport */ VideoCaptions; },
  VideoControls: function() { return /* reexport */ VideoControls; },
  VideoProgressBar: function() { return /* reexport */ VideoProgressBar; },
  VirtualScroll: function() { return /* reexport */ VirtualScroll; },
  VpnAdblocker: function() { return /* reexport */ VpnAdblocker; },
  WeBoothContainer: function() { return /* reexport */ WeBoothContainer; },
  languages: function() { return /* reexport */ languages; },
  sideBarReg: function() { return /* reexport */ sideBarReg; },
  sideBarShare: function() { return /* reexport */ sideBarShare; },
  sideButtons: function() { return /* reexport */ sideButtons; },
  themeHelper: function() { return /* reexport */ theme; },
  uicomponents: function() { return /* reexport */ src_plugin; }
});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@vue+cli-service@5.0.8_lodash@4.17.21_prettier@2.8.8_react@18.2.0_sass-loader@12.6.0_vue-temp_453k2uaekezdzqojt6pvxfd4km/node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/StyledText.vue?vue&type=template&id=61b2f0a4&functional=true
var render = function render(_c, _vm) {
  return _c('span', {
    class: _vm.$options.classes(_vm.$style, _vm.props, _vm.data),
    style: [_vm.data.style, _vm.data.staticStyle],
    attrs: {
      "id": _vm.props.id,
      "data-branding-target": _vm.props.dataBrandingTarget || _vm.props.color,
      "data-branding-color": _vm.props.color,
      "data-testmarker": _vm.props.dataTestmarker,
      "data-testid": _vm.props.dataTestId,
      "role": _vm.props.role,
      "aria-label": _vm.props.ariaLabel,
      "tabindex": _vm.props.tabIndex ? _vm.props.tabIndex : _vm.listeners.click ? 0 : null
    },
    on: {
      "click": e => _vm.listeners.click ? _vm.listeners.click(e) : null,
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        _vm.props.role === 'button' || _vm.props.role === 'link' || _vm.props.role === 'menuitem' ? _vm.listeners.click(_vm.e) : null;
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.preventDefault();
        _vm.props.role === 'button' || _vm.props.role === 'menuitem' ? _vm.listeners.click(_vm.e) : null;
      }]
    }
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.31.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(3340);
;// CONCATENATED MODULE: ./src/components/theme.module.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var theme_module = ({"green":"bjNJ0lt3gDoGGh04J4Ab","white":"UfN8QPAfuMqky1T3jC5U","warning":"augovAZXmGsWflJB_lkK","color-highlight":"AeXeRyhlbwRoOuxPXeEd","color-success":"XhbPfINJLm0rpusMvYXz","color-secondary-light":"LT5o4qnxDg4mkwHG0IBU","color-secondary-medium":"LRERrJFhfGwAeBkzA2MW","color-secondary-dark":"Gbx1SkI0DUw7hQpTEyIw","color-variant-dark-60":"MDNCrWvZ86kKjAW9JEcC","color-variant-light-80":"tGlJRG9wsPT7Cn4BUfd0","color-variant-light-70":"UPdJUPbF0y4vySYOoe1z","color-variant-light-50":"OaAOmPfTy4ed06qi4VgB","color-variant-light-30":"GQ70of5h7YU2pTK72YNf","color-variant-light-5":"JG_7YM4uWDkDujz0mM67","theme-highlight-text-color":"HnKVMRvg7ic484NGLvfz","theme-text-color":"Jwk6Sa7h_w8xrVzYR_TR","theme-secondary-color":"v8jqIcxOFmMcDIkTraLE","screen-saver-text-color":"LcrpfRDnQUkIvq74Xo4v","primary-text-color":"dS18est_o010BaHmtYAU","primary-text-color-05":"wHKjsl87Wc8LaTsjrfmP","stage-text-color":"bJdMLb1G4gxeZwySdFoc","secondary-text-color":"i5PLxeg3P9wJ14odffxS","primary-color-opaque":"vAhdMyDVaMwpJL8FBzNL","inherit":"uNhYy0t3qQgS5uJPcUvE","splash-text-onimage-color":"MAJ1hMBJBceLtpuXHHrm","windowsOs":"TlGroZuWk1YVI4njxrnn"});
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/StyledText.vue?vue&type=script&lang=js


/* harmony default export */ var StyledTextvue_type_script_lang_js = ({
  name: 'styled-text',
  functional: true,
  props: {
    dataTestmarker: {
      type: String
    },
    dataBrandingTarget: {
      type: String
    },
    color: {
      type: String,
      default: 'primary-text-color'
    },
    /**
     * @prop Can be one of huge, heading20, heading15, heading14, heading13, heading12, heading11,
     * body16, body15, body13, body12, body11, button16, number12, noVariant
     */
    variant: {
      type: String,
      default: 'body13'
    },
    nowrap: {
      type: Boolean,
      default: false
    },
    align: String,
    display: {
      type: String,
      default: 'flex'
    },
    underline: {
      type: Boolean,
      default: false
    },
    role: {
      type: [String, null],
      default: null
    },
    ariaLabel: {
      type: [String, null],
      default: null
    },
    tabIndex: {
      type: [Number, null],
      default: null
    },
    id: {
      type: [String, null],
      default: null
    },
    dataTestId: {
      type: [String, null],
      default: null
    }
  },
  classes($style, props, data) {
    const classes = [$style.root, theme_module[props.color], $style[props.variant], $style[`align-${props.align}`], data.staticClass, data.class, $style[props.display]];
    if (props.nowrap) {
      classes.push($style.nowrap);
    }
    if (props.underline) {
      classes.push($style.underline);
    }
    return classes;
  }
});
;// CONCATENATED MODULE: ./src/atoms/StyledText.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_StyledTextvue_type_script_lang_js = (StyledTextvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-11.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/StyledText.vue?vue&type=style&index=0&id=61b2f0a4&prod&module=true&lang=css
// extracted by mini-css-extract-plugin
/* harmony default export */ var StyledTextvue_type_style_index_0_id_61b2f0a4_prod_module_true_lang_css = ({"root":"StyledText_root_n3_tx","underline":"StyledText_underline_Tkd2j","flex":"StyledText_flex_BBPem","block":"StyledText_block_zglD1","inline":"StyledText_inline_CzrZs","nowrap":"StyledText_nowrap_PQ0KK","noBodyVariant":"StyledText_noBodyVariant_sshEe","align-center":"StyledText_align-center_g4rxm","align-justify":"StyledText_align-justify_QAdhc","heading85":"StyledText_heading85_KYau_","heading56":"StyledText_heading56_kh5KD","heading26":"StyledText_heading26_RTldB","heading24":"StyledText_heading24_pDhzO","subHeading26":"StyledText_subHeading26_kJEJl","heading20":"StyledText_heading20_eqnHR","subHeading18":"StyledText_subHeading18_RrNSd","heading16":"StyledText_heading16_K3Mag","subHeading16":"StyledText_subHeading16_Dr3Al","body16":"StyledText_body16_R5gfX","body20":"StyledText_body20_XOlyJ","heading15":"StyledText_heading15_V7hCn","subHeading15":"StyledText_subHeading15_Qxmtx","body15":"StyledText_body15_kgAOV","heading14":"StyledText_heading14_fjcU_","subHeading14":"StyledText_subHeading14_UJFBi","body14":"StyledText_body14_Prc6b","heading13":"StyledText_heading13_btBAQ","subHeading13":"StyledText_subHeading13_tOD0z","body13":"StyledText_body13_aq_Y5","body12":"StyledText_body12_o6yAK","body11":"StyledText_body11_WXt30","subHeading10":"StyledText_subHeading10_fFk62","heading10":"StyledText_heading10_jrGH0","body10":"StyledText_body10_hYMHh","justBold":"StyledText_justBold_Irj4Q","justNormal":"StyledText_justNormal_l3mKj"});
;// CONCATENATED MODULE: ./src/atoms/StyledText.vue?vue&type=style&index=0&id=61b2f0a4&prod&module=true&lang=css
 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/atoms/StyledText.vue



;




function injectStyles (context) {
  
  this["$style"] = (StyledTextvue_type_style_index_0_id_61b2f0a4_prod_module_true_lang_css.locals || StyledTextvue_type_style_index_0_id_61b2f0a4_prod_module_true_lang_css)

}

/* normalize component */

var component = normalizeComponent(
  atoms_StyledTextvue_type_script_lang_js,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

/* harmony default export */ var StyledText = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/SvgIcon.vue?vue&type=template&id=2f4268b8&functional=true
var SvgIconvue_type_template_id_2f4268b8_functional_true_render = function render(_c, _vm) {
  return _c('span', {
    class: _vm.$options.classes(_vm.$style, _vm.props, _vm.data),
    style: [_vm.data.style, _vm.data.staticStyle],
    attrs: {
      "aria-hidden": _vm.props.ariaHidden ? _vm.props.ariaHidden : null,
      "data-testmarker": "clickablesvgicon"
    },
    on: {
      "click": $event => _vm.listeners.click && _vm.listeners.click($event),
      "mouseover": $event => _vm.listeners.mouseover && _vm.listeners.mouseover($event),
      "mouseout": $event => _vm.listeners.mouseout && _vm.listeners.mouseout($event)
    }
  }, [_vm._t("default")], 2);
};
var SvgIconvue_type_template_id_2f4268b8_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/SvgIcon.vue?vue&type=script&lang=js

/* harmony default export */ var SvgIconvue_type_script_lang_js = ({
  functional: true,
  name: 'SvgIcon',
  props: {
    /**
     * @prop can be 'cross', 'caret', 'smiley'...
     */
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'medium'
    },
    color: {
      type: String,
      default: 'primary-text-color'
    },
    ariaHidden: {
      type: Boolean,
      default: false
    }
  },
  classes($style, props, data) {
    return [$style.root, `svg-font-${props.name}`, theme_module[props.color], $style[props.size], data.staticClass, data.class];
  }
});
;// CONCATENATED MODULE: ./src/atoms/SvgIcon.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_SvgIconvue_type_script_lang_js = (SvgIconvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/SvgIcon.vue?vue&type=style&index=0&id=2f4268b8&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SvgIconvue_type_style_index_0_id_2f4268b8_prod_module_true_lang_scss = ({"root":"SvgIcon_root_KmuzF","x-small":"SvgIcon_x-small_mHgGn","small":"SvgIcon_small_NhGs2","mediumXs":"SvgIcon_mediumXs_pmEGZ","medium":"SvgIcon_medium_MQzBV","regular":"SvgIcon_regular_WIFgS","large":"SvgIcon_large_S9bpU","x-large":"SvgIcon_x-large_wDSsM"});
;// CONCATENATED MODULE: ./src/atoms/SvgIcon.vue?vue&type=style&index=0&id=2f4268b8&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/SvgIcon.vue



;




function SvgIcon_injectStyles (context) {
  
  this["$style"] = (SvgIconvue_type_style_index_0_id_2f4268b8_prod_module_true_lang_scss.locals || SvgIconvue_type_style_index_0_id_2f4268b8_prod_module_true_lang_scss)

}

/* normalize component */

var SvgIcon_component = normalizeComponent(
  atoms_SvgIconvue_type_script_lang_js,
  SvgIconvue_type_template_id_2f4268b8_functional_true_render,
  SvgIconvue_type_template_id_2f4268b8_functional_true_staticRenderFns,
  true,
  SvgIcon_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SvgIcon = (SvgIcon_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/SimpleButton.vue?vue&type=template&id=fa2e0e4e
var SimpleButtonvue_type_template_id_fa2e0e4e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', _vm._b({
    class: [_vm.$style.root, _vm.$style[_vm.state], _vm.$style[_vm.palette], _vm.$style[_vm.variant]],
    attrs: {
      "simple-button": "",
      "disabled": _vm.state === 'disabled',
      "type": _vm.type
    },
    on: {
      "click": () => _vm.$emit('click')
    }
  }, 'button', _vm.$attrs, false), [_vm.icon ? _c('SvgIcon', {
    class: _vm.$style.icon,
    style: 'margin-right: 10px',
    attrs: {
      "name": _vm.icon,
      "size": "small",
      "color": "inherit"
    }
  }) : _vm._e(), _c('StyledText', {
    attrs: {
      "variant": "heading13",
      "color": "inherit",
      "align": _vm.textAlign
    }
  }, [_vm._t("default")], 2), _vm.loading ? _c('div', {
    class: _vm.$style.loader
  }, [_c('Loading', {
    attrs: {
      "size": "verySmall",
      "theme": "secondary"
    }
  })], 1) : _vm._e()], 1);
};
var SimpleButtonvue_type_template_id_fa2e0e4e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/SimpleButton.vue?vue&type=script&lang=js
/* harmony default export */ var SimpleButtonvue_type_script_lang_js = ({
  name: 'simple-button',
  props: {
    icon: {
      type: String,
      default: null,
      required: false
    },
    /**
     * @prop can be 'disabled'|'pressed'|'enabled'
     */
    state: {
      type: String,
      default: 'enabled'
    },
    /**
     * @prop size can be large, regular or small
     */
    size: {
      type: String,
      default: 'regular'
    },
    /**
     * @prop palette can be light or dark
     */
    palette: {
      type: String,
      default: 'dark'
    },
    textAlign: String,
    type: String,
    /**
     * @prop variant can be default or outline
     */
    variant: {
      type: String,
      default: 'default'
    },
    loading: Boolean
  }
});
;// CONCATENATED MODULE: ./src/atoms/SimpleButton.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_SimpleButtonvue_type_script_lang_js = (SimpleButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/SimpleButton.vue?vue&type=style&index=0&id=fa2e0e4e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SimpleButtonvue_type_style_index_0_id_fa2e0e4e_prod_module_true_lang_scss = ({"root":"SimpleButton_root_c1YTf","pressed":"SimpleButton_pressed_hS4kG","light":"SimpleButton_light_zz2cF","outline":"SimpleButton_outline_qv9Tg","dark":"SimpleButton_dark_ukyIl","loader":"SimpleButton_loader_OHyw1","icon":"SimpleButton_icon_zejyz"});
;// CONCATENATED MODULE: ./src/atoms/SimpleButton.vue?vue&type=style&index=0&id=fa2e0e4e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/SimpleButton.vue



;




function SimpleButton_injectStyles (context) {
  
  this["$style"] = (SimpleButtonvue_type_style_index_0_id_fa2e0e4e_prod_module_true_lang_scss.locals || SimpleButtonvue_type_style_index_0_id_fa2e0e4e_prod_module_true_lang_scss)

}

/* normalize component */

var SimpleButton_component = normalizeComponent(
  atoms_SimpleButtonvue_type_script_lang_js,
  SimpleButtonvue_type_template_id_fa2e0e4e_render,
  SimpleButtonvue_type_template_id_fa2e0e4e_staticRenderFns,
  false,
  SimpleButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SimpleButton = (SimpleButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/OutlinedButton.vue?vue&type=template&id=50b93122
var OutlinedButtonvue_type_template_id_50b93122_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    class: [_vm.$style.root, _vm.$style[_vm.variant], _vm.$style[_vm.size], _vm.alt && _vm.$style.alt],
    attrs: {
      "type": "button",
      "data-branding-target": _vm.variant,
      "disabled": _vm.disabled,
      "data-testmarker": _vm.dataTestmarker
    },
    on: {
      "click": e => _vm.$emit('click', e)
    }
  }, [_vm.icon || _vm.$slots.before ? _c('span', {
    class: _vm.$style.before
  }, [_vm.$slots.before ? _vm._t("before") : _vm.icon ? _c('SvgIcon', {
    attrs: {
      "name": _vm.icon,
      "color": "inherit",
      "ariaHidden": true
    }
  }) : _vm._e()], 2) : _vm._e(), _vm.$slots.default ? _c('StyledText', {
    class: {
      [_vm.$style.uppercase]: _vm.uppercase,
      [_vm.$style.center]: _vm.center
    },
    attrs: {
      "variant": _vm.boldText ? `heading13` : `body13`,
      "color": "inherit",
      "align": _vm.center ? 'center' : ''
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm.$slots.after ? _c('span', {
    class: _vm.$style.after
  }, [_vm._t("after")], 2) : _vm._e(), _vm.loading ? _c('div', {
    class: _vm.$style.loader
  }, [_c('Loading', {
    attrs: {
      "size": "verySmall",
      "theme": _vm.variant
    }
  })], 1) : _vm._e()], 1);
};
var OutlinedButtonvue_type_template_id_50b93122_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/OutlinedButton.vue?vue&type=script&lang=js
/* harmony default export */ var OutlinedButtonvue_type_script_lang_js = ({
  name: 'OutlinedButton',
  props: {
    /**
     * @prop size can be regular, small, large, x-large
     */
    size: {
      type: String,
      default: 'x-small'
    },
    icon: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * @prop can be primary or secondary
     */
    variant: {
      type: String,
      default: 'secondary'
    },
    boldText: Boolean,
    uppercase: {
      tyep: Boolean,
      default: true
    },
    center: Boolean,
    alt: Boolean,
    dataTestmarker: String
  }
});
;// CONCATENATED MODULE: ./src/atoms/OutlinedButton.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_OutlinedButtonvue_type_script_lang_js = (OutlinedButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/OutlinedButton.vue?vue&type=style&index=0&id=50b93122&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var OutlinedButtonvue_type_style_index_0_id_50b93122_prod_module_true_lang_scss = ({"root":"OutlinedButton_root_HoVzH","primary":"OutlinedButton_primary_VC8Yo","secondary":"OutlinedButton_secondary_JV_yy","alt":"OutlinedButton_alt_VFogs","before":"OutlinedButton_before__ekYb","after":"OutlinedButton_after_gZCA2","loader":"OutlinedButton_loader_i76ln","large":"OutlinedButton_large_O3U5W","regular":"OutlinedButton_regular_fiLxC","small":"OutlinedButton_small_e6iCC","x-small":"OutlinedButton_x-small_j2eT7","uppercase":"OutlinedButton_uppercase_DQ_UK","center":"OutlinedButton_center_Xo__Q"});
;// CONCATENATED MODULE: ./src/atoms/OutlinedButton.vue?vue&type=style&index=0&id=50b93122&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/OutlinedButton.vue



;




function OutlinedButton_injectStyles (context) {
  
  this["$style"] = (OutlinedButtonvue_type_style_index_0_id_50b93122_prod_module_true_lang_scss.locals || OutlinedButtonvue_type_style_index_0_id_50b93122_prod_module_true_lang_scss)

}

/* normalize component */

var OutlinedButton_component = normalizeComponent(
  atoms_OutlinedButtonvue_type_script_lang_js,
  OutlinedButtonvue_type_template_id_50b93122_render,
  OutlinedButtonvue_type_template_id_50b93122_staticRenderFns,
  false,
  OutlinedButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var OutlinedButton = (OutlinedButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/TextButton.vue?vue&type=template&id=26a88a61&functional=true
var TextButtonvue_type_template_id_26a88a61_functional_true_render = function render(_c, _vm) {
  return _c('button', {
    class: {
      [_vm.$style.root]: true,
      [_vm.data.staticClass]: _vm.data.staticClass,
      [_vm.data.class]: _vm.data.class
    },
    attrs: {
      "id": _vm.props.id,
      "type": "button",
      "aria-labelledby": _vm.props.ariaLabelledby,
      "data-branding-target": _vm.props.color,
      "disabled": _vm.props.disabled
    },
    on: {
      "click": e => _vm.listeners.click(e)
    }
  }, [_vm.props.icon || _vm.$slots.before ? _c('span', {
    class: _vm.$style.before
  }, [_vm.$slots.before ? _vm._t("before") : _vm.props.icon ? _c('SvgIcon', {
    attrs: {
      "name": _vm.props.icon,
      "color": _vm.props.color
    }
  }) : _vm._e()], 2) : _vm._e(), _vm.$slots.default ? _c('StyledText', {
    class: {
      [_vm.$style.uppercase]: _vm.props.uppercase,
      [_vm.$style.center]: _vm.props.center
    },
    attrs: {
      "variant": _vm.props.variant,
      "color": _vm.props.color,
      "align": _vm.props.center ? 'center' : ''
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm.$slots.after ? _c('span', {
    class: _vm.$style.after
  }, [_vm._t("after")], 2) : _vm._e(), _vm.props.loading ? _c('div', {
    class: _vm.$style.loader
  }, [_c('Loading', {
    attrs: {
      "size": "verySmall",
      "theme": "secondary"
    }
  })], 1) : _vm._e()], 1);
};
var TextButtonvue_type_template_id_26a88a61_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/TextButton.vue?vue&type=script&lang=js
/* harmony default export */ var TextButtonvue_type_script_lang_js = ({
  name: 'TextButton',
  functional: true,
  props: {
    icon: {
      type: String
    },
    color: {
      type: String,
      default: 'theme-secondary-color'
    },
    variant: {
      type: String,
      default: 'body13'
    },
    loading: Boolean,
    disabled: Boolean,
    uppercase: {
      tyep: Boolean,
      default: true
    },
    id: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    center: Boolean
  }
});
;// CONCATENATED MODULE: ./src/atoms/TextButton.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_TextButtonvue_type_script_lang_js = (TextButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/TextButton.vue?vue&type=style&index=0&id=26a88a61&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var TextButtonvue_type_style_index_0_id_26a88a61_prod_module_true_lang_scss = ({"root":"TextButton_root_wacPP","before":"TextButton_before_Y5Es8","after":"TextButton_after_jBWFi","loader":"TextButton_loader_bgm9E","uppercase":"TextButton_uppercase_fHJjX","center":"TextButton_center_QHPuR"});
;// CONCATENATED MODULE: ./src/atoms/TextButton.vue?vue&type=style&index=0&id=26a88a61&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/TextButton.vue



;




function TextButton_injectStyles (context) {
  
  this["$style"] = (TextButtonvue_type_style_index_0_id_26a88a61_prod_module_true_lang_scss.locals || TextButtonvue_type_style_index_0_id_26a88a61_prod_module_true_lang_scss)

}

/* normalize component */

var TextButton_component = normalizeComponent(
  atoms_TextButtonvue_type_script_lang_js,
  TextButtonvue_type_template_id_26a88a61_functional_true_render,
  TextButtonvue_type_template_id_26a88a61_functional_true_staticRenderFns,
  true,
  TextButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TextButton = (TextButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/IconButton.vue?vue&type=template&id=337db7fe&functional=true
var IconButtonvue_type_template_id_337db7fe_functional_true_render = function render(_c, _vm) {
  return _c('button', {
    class: _vm.$options.classes(_vm.$style, _vm.props, _vm.data),
    attrs: {
      "id": _vm.props.id,
      "type": "button",
      "aria-hidden": _vm.props.ariaHidden,
      "aria-label": _vm.$options.$t(_vm.props.ariaLabel),
      "aria-labelledby": _vm.props.ariaLabelledby,
      "tabindex": _vm.props.tabIndex ? _vm.props.tabIndex : _vm.listeners.click ? 0 : null,
      "aria-haspopup": _vm.props.ariaHasPopup,
      "aria-checked": _vm.props.ariaChecked,
      "role": _vm.props.role,
      "disabled": _vm.props.disabled,
      "data-testid": _vm.props.dataTestId,
      "data-testmarker": "iconbutton"
    },
    on: {
      "click": $e => _vm.listeners.click && _vm.listeners.click($e)
    }
  }, [_c('div', {
    class: _vm.$style.bg
  }), _vm.props.loading ? _c('Loading', {
    attrs: {
      "size": "verySmall",
      "theme": "secondary"
    }
  }) : _vm.$slots.default ? _vm._t("default") : _vm.props.icon ? _c('SvgIcon', {
    attrs: {
      "name": _vm.props.icon,
      "size": _vm.$options.text(_vm.props),
      "color": "inherit"
    }
  }) : _vm._e()], 2);
};
var IconButtonvue_type_template_id_337db7fe_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/IconButton.vue?vue&type=script&lang=js
/* harmony default export */ var IconButtonvue_type_script_lang_js = ({
  name: 'icon-button',
  functional: true,
  props: {
    id: {
      type: String,
      default: null
    },
    icon: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * @prop size can be large, regular, small and x-small
     */
    size: {
      type: String,
      default: 'regular'
    },
    /**
     * @prop can be primary or secondary, dark, light
     */
    variant: {
      type: String,
      default: 'secondary'
    },
    /**
     * @prop can be true, false or alt
     */
    ghost: [Boolean, String],
    loading: Boolean,
    alt: Boolean,
    ariaHidden: {
      type: [Boolean, null],
      default: null
    },
    ariaLabel: {
      type: [String, null],
      default: null
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    ariaHasPopup: {
      type: [String, null],
      default: null
    },
    ariaChecked: {
      type: [String, null],
      default: null
    },
    role: {
      type: [String, null],
      default: null
    },
    ariaLabelledby: {
      type: [String, null],
      default: null
    },
    dataTestId: {
      type: [String, null],
      default: null
    }
  },
  text({
    size
  }) {
    const sizes = {
      large: 'medium',
      regular: 'medium',
      small: 'small',
      'x-small': 'small'
    };
    return sizes[size];
  },
  classes($style, {
    size,
    variant,
    ghost,
    alt
  }, data) {
    return [$style.root, $style[size], $style[variant], ghost && $style.ghost, data.staticClass, data.class, ghost && $style[ghost], alt && $style.alt];
  }
});
;// CONCATENATED MODULE: ./src/atoms/IconButton.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_IconButtonvue_type_script_lang_js = (IconButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/IconButton.vue?vue&type=style&index=0&id=337db7fe&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var IconButtonvue_type_style_index_0_id_337db7fe_prod_module_true_lang_scss = ({"root":"IconButton_root_diSFH","bg":"IconButton_bg_lDpzY","dark":"IconButton_dark_AQUDV","light":"IconButton_light_LvRWE","primary":"IconButton_primary_JWMY0","secondary":"IconButton_secondary_oUkGi","highlight":"IconButton_highlight_UhPDs","lightgreen":"IconButton_lightgreen_IL0fm","outlined":"IconButton_outlined_XNj3R","alt":"IconButton_alt_Vega6","ghost":"IconButton_ghost_pq8p0","large":"IconButton_large_Orn3D","regular":"IconButton_regular_ZDOfd","small":"IconButton_small_or6F6","x-small":"IconButton_x-small_a6mYs"});
;// CONCATENATED MODULE: ./src/atoms/IconButton.vue?vue&type=style&index=0&id=337db7fe&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/IconButton.vue



;




function IconButton_injectStyles (context) {
  
  this["$style"] = (IconButtonvue_type_style_index_0_id_337db7fe_prod_module_true_lang_scss.locals || IconButtonvue_type_style_index_0_id_337db7fe_prod_module_true_lang_scss)

}

/* normalize component */

var IconButton_component = normalizeComponent(
  atoms_IconButtonvue_type_script_lang_js,
  IconButtonvue_type_template_id_337db7fe_functional_true_render,
  IconButtonvue_type_template_id_337db7fe_functional_true_staticRenderFns,
  true,
  IconButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var IconButton = (IconButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/PillButton.vue?vue&type=template&id=e34db3bc
var PillButtonvue_type_template_id_e34db3bc_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    class: [_vm.$style.root, _vm.selected && _vm.$style.selected, _vm.alt && _vm.$style.alt, _vm.$style[_vm.variant], _vm.$style[_vm.size], _vm.allowMultiLine && _vm.$style.multiline, _vm.disabled && _vm.$style.disabled],
    attrs: {
      "aria-disabled": _vm.disabled,
      "aria-labelledby": _vm.ariaLabelledby,
      "aria-live": _vm.ariaLive,
      "data-branding-target": _vm.variant + _vm.size
    },
    on: {
      "click": function ($event) {
        _vm.disabled ? () => {} : _vm.$emit('click');
      }
    }
  }, [_c('span', {
    class: _vm.$style.bg
  }), _vm.loading ? _c('SvgIcon', {
    class: [_vm.$style.icon, _vm.$style.flash],
    attrs: {
      "size": "small",
      "name": "bolt",
      "color": "inherit"
    }
  }) : _vm.icon ? _c('SvgIcon', {
    class: {
      [_vm.$style.icon]: true
    },
    attrs: {
      "size": _vm.iconSize,
      "name": _vm.icon,
      "color": "inherit"
    }
  }) : _vm._t("icon"), _vm.$slots.default ? _c('StyledText', {
    class: {
      [_vm.$style.text]: true,
      [_vm.$style.uppercase]: _vm.uppercase,
      [_vm.$style.center]: _vm.center,
      [_vm.$style.hasAfter]: _vm.$slots.after
    },
    attrs: {
      "variant": _vm.styledTextVariant,
      "color": "inherit",
      "align": _vm.center ? 'center' : ''
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm._t("after")], 2);
};
var PillButtonvue_type_template_id_e34db3bc_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/PillButton.vue?vue&type=script&lang=js
/* harmony default export */ var PillButtonvue_type_script_lang_js = ({
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    boldText: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    // possible values are primary and secondary
    variant: {
      type: String,
      default: 'secondary'
    },
    // possible values are large, medium and small
    size: {
      type: String,
      default: 'small'
    },
    iconSize: {
      type: String,
      default: 'medium'
    },
    uppercase: Boolean,
    alt: Boolean,
    center: Boolean,
    allowMultiLine: Boolean,
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLive: {
      type: String,
      default: null
    }
  },
  computed: {
    styledTextVariant() {
      const sizeMap = {
        'xx-small': '10'
      };
      return (this.boldText ? 'heading' : 'body') + sizeMap[this.size] || '13';
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/PillButton.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_PillButtonvue_type_script_lang_js = (PillButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/PillButton.vue?vue&type=style&index=0&id=e34db3bc&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var PillButtonvue_type_style_index_0_id_e34db3bc_prod_module_true_lang_scss = ({"root":"PillButton_root_YHEJw","bg":"PillButton_bg_mUg74","disabled":"PillButton_disabled_FxM88","selected":"PillButton_selected_T_H7W","text":"PillButton_text_oProL","multiline":"PillButton_multiline_IAAMI","primary":"PillButton_primary_v1YdY","secondary":"PillButton_secondary_n0SsO","warning":"PillButton_warning_Vqd4L","alt":"PillButton_alt_rSH8w","large":"PillButton_large_f0XkH","regular":"PillButton_regular_GK9fr","small":"PillButton_small__U2K8","x-small":"PillButton_x-small_r073f","xx-small":"PillButton_xx-small_rL6yg","icon":"PillButton_icon_B7s7W","hasAfter":"PillButton_hasAfter_bOLw4","flash":"PillButton_flash_SK3At","flashing":"PillButton_flashing_cUs8E","uppercase":"PillButton_uppercase_r5vuf","center":"PillButton_center_TUw4z"});
;// CONCATENATED MODULE: ./src/atoms/PillButton.vue?vue&type=style&index=0&id=e34db3bc&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/PillButton.vue



;




function PillButton_injectStyles (context) {
  
  this["$style"] = (PillButtonvue_type_style_index_0_id_e34db3bc_prod_module_true_lang_scss.locals || PillButtonvue_type_style_index_0_id_e34db3bc_prod_module_true_lang_scss)

}

/* normalize component */

var PillButton_component = normalizeComponent(
  atoms_PillButtonvue_type_script_lang_js,
  PillButtonvue_type_template_id_e34db3bc_render,
  PillButtonvue_type_template_id_e34db3bc_staticRenderFns,
  false,
  PillButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var PillButton = (PillButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/OverflowWatcher.vue?vue&type=template&id=e7cf70a2
var OverflowWatchervue_type_template_id_e7cf70a2_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', _vm._b({}, 'div', _vm.overflowing && _vm.overflowProps, false), [_vm._t("default", null, {
    "overflowing": !_vm.disabled && _vm.overflowing
  })], 2);
};
var OverflowWatchervue_type_template_id_e7cf70a2_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js
var resizeObservers = [];


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/algorithms/hasActiveObservations.js

var hasActiveObservations = function () {
    return resizeObservers.some(function (ro) { return ro.activeTargets.length > 0; });
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/algorithms/hasSkippedObservations.js

var hasSkippedObservations = function () {
    return resizeObservers.some(function (ro) { return ro.skippedTargets.length > 0; });
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/algorithms/deliverResizeLoopError.js
var msg = 'ResizeObserver loop completed with undelivered notifications.';
var deliverResizeLoopError = function () {
    var event;
    if (typeof ErrorEvent === 'function') {
        event = new ErrorEvent('error', {
            message: msg
        });
    }
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = msg;
    }
    window.dispatchEvent(event);
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/ResizeObserverBoxOptions.js
var ResizeObserverBoxOptions;
(function (ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/utils/freeze.js
var freeze = function (obj) { return Object.freeze(obj); };

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/ResizeObserverSize.js

var ResizeObserverSize = (function () {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        freeze(this);
    }
    return ResizeObserverSize;
}());


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/DOMRectReadOnly.js

var DOMRectReadOnly = (function () {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return freeze(this);
    }
    DOMRectReadOnly.prototype.toJSON = function () {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return { x: x, y: y, top: top, right: right, bottom: bottom, left: left, width: width, height: height };
    };
    DOMRectReadOnly.fromRect = function (rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}());


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/utils/element.js
var isSVG = function (target) { return target instanceof SVGElement && 'getBBox' in target; };
var isHidden = function (target) {
    if (isSVG(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isElement = function (obj) {
    var _a, _b;
    if (obj instanceof Element) {
        return true;
    }
    var scope = (_b = (_a = obj) === null || _a === void 0 ? void 0 : _a.ownerDocument) === null || _b === void 0 ? void 0 : _b.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var isReplacedElement = function (target) {
    switch (target.tagName) {
        case 'INPUT':
            if (target.type !== 'image') {
                break;
            }
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/utils/global.js
var global = typeof window !== 'undefined' ? window : {};

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/algorithms/calculateBoxSize.js






var cache = new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = (/msie|trident/i).test(global.navigator && global.navigator.userAgent);
var parseDimension = function (pixel) { return parseFloat(pixel || '0'); };
var size = function (inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) { inlineSize = 0; }
    if (blockSize === void 0) { blockSize = 0; }
    if (switchSizes === void 0) { switchSizes = false; }
    return new ResizeObserverSize((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var zeroBoxes = freeze({
    devicePixelContentBoxSize: size(),
    borderBoxSize: size(),
    contentBoxSize: size(),
    contentRect: new DOMRectReadOnly(0, 0, 0, 0)
});
var calculateBoxSizes = function (target, forceRecalculation) {
    if (forceRecalculation === void 0) { forceRecalculation = false; }
    if (cache.has(target) && !forceRecalculation) {
        return cache.get(target);
    }
    if (isHidden(target)) {
        cache.set(target, zeroBoxes);
        return zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = isSVG(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !IE && cs.boxSizing === 'border-box';
    var switchSizes = verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = freeze({
        devicePixelContentBoxSize: size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: size(contentWidth, contentHeight, switchSizes),
        contentRect: new DOMRectReadOnly(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    cache.set(target, boxes);
    return boxes;
};
var calculateBoxSize = function (target, observedBox, forceRecalculation) {
    var _a = calculateBoxSizes(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch (observedBox) {
        case ResizeObserverBoxOptions.DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case ResizeObserverBoxOptions.BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/ResizeObserverEntry.js


var ResizeObserverEntry = (function () {
    function ResizeObserverEntry(target) {
        var boxes = calculateBoxSizes(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = freeze([boxes.borderBoxSize]);
        this.contentBoxSize = freeze([boxes.contentBoxSize]);
        this.devicePixelContentBoxSize = freeze([boxes.devicePixelContentBoxSize]);
    }
    return ResizeObserverEntry;
}());


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/algorithms/calculateDepthForNode.js

var calculateDepthForNode = function (node) {
    if (isHidden(node)) {
        return Infinity;
    }
    var depth = 0;
    var parent = node.parentNode;
    while (parent) {
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/algorithms/broadcastActiveObservations.js




var broadcastActiveObservations = function () {
    var shallowestDepth = Infinity;
    var callbacks = [];
    resizeObservers.forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) {
            return;
        }
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new ResizeObserverEntry(ot.target);
            var targetDepth = calculateDepthForNode(ot.target);
            entries.push(entry);
            ot.lastReportedSize = calculateBoxSize(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) {
                shallowestDepth = targetDepth;
            }
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/algorithms/gatherActiveObservationsAtDepth.js


var gatherActiveObservationsAtDepth = function (depth) {
    resizeObservers.forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if (calculateDepthForNode(ot.target) > depth) {
                    ro.activeTargets.push(ot);
                }
                else {
                    ro.skippedTargets.push(ot);
                }
            }
        });
    });
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/utils/process.js





var process = function () {
    var depth = 0;
    gatherActiveObservationsAtDepth(depth);
    while (hasActiveObservations()) {
        depth = broadcastActiveObservations();
        gatherActiveObservationsAtDepth(depth);
    }
    if (hasSkippedObservations()) {
        deliverResizeLoopError();
    }
    return depth > 0;
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/utils/queueMicroTask.js
var trigger;
var callbacks = [];
var notify = function () { return callbacks.splice(0).forEach(function (cb) { return cb(); }); };
var queueMicroTask = function (callback) {
    if (!trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = { characterData: true };
        new MutationObserver(function () { return notify(); }).observe(el_1, config);
        trigger = function () { el_1.textContent = "" + (toggle_1 ? toggle_1-- : toggle_1++); };
    }
    callbacks.push(callback);
    trigger();
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/utils/queueResizeObserver.js

var queueResizeObserver = function (cb) {
    queueMicroTask(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/utils/scheduler.js



var watching = 0;
var isWatching = function () { return !!watching; };
var CATCH_PERIOD = 250;
var observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
var events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var time = function (timeout) {
    if (timeout === void 0) { timeout = 0; }
    return Date.now() + timeout;
};
var scheduled = false;
var Scheduler = (function () {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function () { return _this.schedule(); };
    }
    Scheduler.prototype.run = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = CATCH_PERIOD; }
        if (scheduled) {
            return;
        }
        scheduled = true;
        var until = time(timeout);
        queueResizeObserver(function () {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = process();
            }
            finally {
                scheduled = false;
                timeout = until - time();
                if (!isWatching()) {
                    return;
                }
                if (elementsHaveResized) {
                    _this.run(1000);
                }
                else if (timeout > 0) {
                    _this.run(timeout);
                }
                else {
                    _this.start();
                }
            }
        });
    };
    Scheduler.prototype.schedule = function () {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function () {
        var _this = this;
        var cb = function () { return _this.observer && _this.observer.observe(document.body, observerConfig); };
        document.body ? cb() : global.addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function () {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            events.forEach(function (name) { return global.addEventListener(name, _this.listener, true); });
        }
    };
    Scheduler.prototype.stop = function () {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(function (name) { return global.removeEventListener(name, _this.listener, true); });
            this.stopped = true;
        }
    };
    return Scheduler;
}());
var scheduler = new Scheduler();
var updateCount = function (n) {
    !watching && n > 0 && scheduler.start();
    watching += n;
    !watching && scheduler.stop();
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/ResizeObservation.js



var skipNotifyOnElement = function (target) {
    return !isSVG(target)
        && !isReplacedElement(target)
        && getComputedStyle(target).display === 'inline';
};
var ResizeObservation = (function () {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || ResizeObserverBoxOptions.CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function () {
        var size = calculateBoxSize(this.target, this.observedBox, true);
        if (skipNotifyOnElement(this.target)) {
            this.lastReportedSize = size;
        }
        if (this.lastReportedSize.inlineSize !== size.inlineSize
            || this.lastReportedSize.blockSize !== size.blockSize) {
            return true;
        }
        return false;
    };
    return ResizeObservation;
}());


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/ResizeObserverDetail.js
var ResizeObserverDetail = (function () {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}());


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/ResizeObserverController.js




var observerMap = new WeakMap();
var getObservationIndex = function (observationTargets, target) {
    for (var i = 0; i < observationTargets.length; i += 1) {
        if (observationTargets[i].target === target) {
            return i;
        }
    }
    return -1;
};
var ResizeObserverController = (function () {
    function ResizeObserverController() {
    }
    ResizeObserverController.connect = function (resizeObserver, callback) {
        var detail = new ResizeObserverDetail(resizeObserver, callback);
        observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function (resizeObserver, target, options) {
        var detail = observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if (getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && resizeObservers.push(detail);
            detail.observationTargets.push(new ResizeObservation(target, options && options.box));
            updateCount(1);
            scheduler.schedule();
        }
    };
    ResizeObserverController.unobserve = function (resizeObserver, target) {
        var detail = observerMap.get(resizeObserver);
        var index = getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && resizeObservers.splice(resizeObservers.indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            updateCount(-1);
        }
    };
    ResizeObserverController.disconnect = function (resizeObserver) {
        var _this = this;
        var detail = observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function (ot) { return _this.unobserve(resizeObserver, ot.target); });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}());


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/ResizeObserver.js


var ResizeObserver_ResizeObserver = (function () {
    function ResizeObserver(callback) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (typeof callback !== 'function') {
            throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        }
        ResizeObserverController.connect(this, callback);
    }
    ResizeObserver.prototype.observe = function (target, options) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (!isElement(target)) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        ResizeObserverController.observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function (target) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (!isElement(target)) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        ResizeObserverController.unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function () {
        ResizeObserverController.disconnect(this);
    };
    ResizeObserver.toString = function () {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}());


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@juggle+resize-observer@3.3.1/node_modules/@juggle/resize-observer/lib/exports/resize-observer.js




;// CONCATENATED MODULE: ./src/resizeobserverimport.js

let ourObserver = ResizeObserver_ResizeObserver;

// For ssr where window is not defined
try {
  if (window && window?.ResizeObserver) {
    ourObserver = window.ResizeObserver;
    // window.ResizeObserver = class {
    //   constructor() {
    //     throw new Error("DO NOT USE THIS! READ THE DOCS!!! TALK TO GASTON!!!!");
    //   }
    // };
  }
} catch (err) {
  console.warn('Failed to process resizeObserver.', err);
}
/* harmony default export */ var resizeobserverimport = (ourObserver);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/OverflowWatcher.vue?vue&type=script&lang=js

/* harmony default export */ var OverflowWatchervue_type_script_lang_js = ({
  name: 'OverflowWatcher',
  props: {
    /**
     * @prop this is going to be contributing to the content of the div, that way the element is reactive to change
     */
    overflowProps: {
      type: Object,
      default: () => ({})
    },
    /**
     * @prop number representing how many pixels of over flow we are willing to allow
     */
    allowance: {
      type: Number,
      default: 0
    },
    disabled: Boolean,
    variableProps: {
      type: [Number, Object, String, Array]
    }
  },
  watch: {
    variableProps() {
      this.resize(this.$el);
    }
  },
  data() {
    return {
      overflowing: false,
      observer: null
    };
  },
  mounted() {
    this.resize(this.$el);
    this.observer = new resizeobserverimport(entries => {
      entries.forEach(e => this.resize(e.target));
    });
    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    this.observer.unobserve(this.$el);
  },
  methods: {
    resize(el) {
      if (!el || this.disabled) {
        return;
      }
      this.overflowing = false;
      this.$nextTick().then(() => {
        this.overflowing = el.scrollWidth - el.offsetWidth > this.allowance;
      });
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/OverflowWatcher.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_OverflowWatchervue_type_script_lang_js = (OverflowWatchervue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/atoms/OverflowWatcher.vue





/* normalize component */
;
var OverflowWatcher_component = normalizeComponent(
  atoms_OverflowWatchervue_type_script_lang_js,
  OverflowWatchervue_type_template_id_e7cf70a2_render,
  OverflowWatchervue_type_template_id_e7cf70a2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OverflowWatcher = (OverflowWatcher_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/SimpleRadioButton.vue?vue&type=template&id=7933a9c2&functional=true
var SimpleRadioButtonvue_type_template_id_7933a9c2_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.selected]: _vm.props.selected
    },
    style: {
      '--color': `var(--${_vm.props.color}, ${_vm.props.color})`
    },
    on: {
      "click": () => _vm.listeners.select && _vm.listeners.select()
    }
  });
};
var SimpleRadioButtonvue_type_template_id_7933a9c2_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/SimpleRadioButton.vue?vue&type=script&lang=js
/* harmony default export */ var SimpleRadioButtonvue_type_script_lang_js = ({
  name: 'SimpleRadioButton',
  functional: true,
  props: {
    selected: Boolean,
    color: {
      type: String,
      default: 'theme-secondary-color'
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/SimpleRadioButton.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_SimpleRadioButtonvue_type_script_lang_js = (SimpleRadioButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-11.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/SimpleRadioButton.vue?vue&type=style&index=0&id=7933a9c2&prod&module=true&lang=css
// extracted by mini-css-extract-plugin
/* harmony default export */ var SimpleRadioButtonvue_type_style_index_0_id_7933a9c2_prod_module_true_lang_css = ({"root":"SimpleRadioButton_root_npIwU","selected":"SimpleRadioButton_selected_G8xdj"});
;// CONCATENATED MODULE: ./src/atoms/SimpleRadioButton.vue?vue&type=style&index=0&id=7933a9c2&prod&module=true&lang=css
 
;// CONCATENATED MODULE: ./src/atoms/SimpleRadioButton.vue



;




function SimpleRadioButton_injectStyles (context) {
  
  this["$style"] = (SimpleRadioButtonvue_type_style_index_0_id_7933a9c2_prod_module_true_lang_css.locals || SimpleRadioButtonvue_type_style_index_0_id_7933a9c2_prod_module_true_lang_css)

}

/* normalize component */

var SimpleRadioButton_component = normalizeComponent(
  atoms_SimpleRadioButtonvue_type_script_lang_js,
  SimpleRadioButtonvue_type_template_id_7933a9c2_functional_true_render,
  SimpleRadioButtonvue_type_template_id_7933a9c2_functional_true_staticRenderFns,
  true,
  SimpleRadioButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SimpleRadioButton = (SimpleRadioButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/DropdownSetup.vue?vue&type=template&id=298d69f8
var DropdownSetupvue_type_template_id_298d69f8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.dropdown
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.open,
      expression: "open"
    }],
    class: [_vm.$style.bg, _vm.backdropClass],
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('close');
      }
    }
  }), _c('div', {
    class: [_vm.$style.dropdownToggler, _vm.$style.open]
  }, [_vm._t("toggler")], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.open,
      expression: "open"
    }],
    class: [_vm.$style.dropdownContent, {
      [_vm.$style.fit]: _vm.fit,
      [_vm.$style.fullWidth]: _vm.fullWidth,
      [_vm.$style.top]: _vm.verticalPosition === 'top',
      [_vm.$style.bottom]: _vm.verticalPosition === 'bottom'
    }],
    style: _vm.dropdownContentStyles,
    attrs: {
      "data-branding-target": "user-dropdown"
    }
  }, [_vm._t("dropdown")], 2)]);
};
var DropdownSetupvue_type_template_id_298d69f8_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/DropdownSetup.vue?vue&type=script&lang=js
/* harmony default export */ var DropdownSetupvue_type_script_lang_js = ({
  name: 'dropdownSetup',
  props: {
    open: Boolean,
    backdropClass: String,
    align: {
      type: String,
      default: 'right'
    },
    verticalPosition: {
      type: String,
      default: 'bottom'
    },
    fit: Boolean,
    fullWidth: {
      type: Boolean,
      default: false
    },
    maxAllowedWidth: Number
  },
  computed: {
    dropdownContentStyles() {
      return {
        maxWidth: this.maxAllowedWidth + 'px',
        [this.align === 'right' ? 'right' : 'left']: 0
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/DropdownSetup.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_DropdownSetupvue_type_script_lang_js = (DropdownSetupvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/DropdownSetup.vue?vue&type=style&index=0&id=298d69f8&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var DropdownSetupvue_type_style_index_0_id_298d69f8_prod_module_true_lang_scss = ({"dropdown-enter-active":"DropdownSetup_dropdown-enter-active_vRd0h","dropdown-leave-active":"DropdownSetup_dropdown-leave-active_DSVYr","dropdown-enter":"DropdownSetup_dropdown-enter_KXV4U","dropdown-leave-to":"DropdownSetup_dropdown-leave-to_MNqIP","dropdown":"DropdownSetup_dropdown_m1ozl","dropdownContent":"DropdownSetup_dropdownContent_ohFrx","fit":"DropdownSetup_fit_T8KhF","fullWidth":"DropdownSetup_fullWidth_VNlcu","bg":"DropdownSetup_bg_LPnxz","dropdownToggler":"DropdownSetup_dropdownToggler_haTON","top":"DropdownSetup_top_orLWs"});
;// CONCATENATED MODULE: ./src/atoms/DropdownSetup.vue?vue&type=style&index=0&id=298d69f8&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/DropdownSetup.vue



;




function DropdownSetup_injectStyles (context) {
  
  this["$style"] = (DropdownSetupvue_type_style_index_0_id_298d69f8_prod_module_true_lang_scss.locals || DropdownSetupvue_type_style_index_0_id_298d69f8_prod_module_true_lang_scss)

}

/* normalize component */

var DropdownSetup_component = normalizeComponent(
  atoms_DropdownSetupvue_type_script_lang_js,
  DropdownSetupvue_type_template_id_298d69f8_render,
  DropdownSetupvue_type_template_id_298d69f8_staticRenderFns,
  false,
  DropdownSetup_injectStyles,
  null,
  null
  
)

/* harmony default export */ var DropdownSetup = (DropdownSetup_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/FitText.vue?vue&type=template&id=809ed976
var FitTextvue_type_template_id_809ed976_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    ref: "fittedTextContainer",
    class: [_vm.$style.root]
  }, [_c('canvas', {
    ref: "titlebanner"
  })]);
};
var FitTextvue_type_template_id_809ed976_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/FitText.vue?vue&type=script&lang=js

/* harmony default export */ var FitTextvue_type_script_lang_js = ({
  props: {
    textcontent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      numAttemptsForFont: 0
    };
  },
  mounted() {
    this.drawTitle();
    const computedFont = getComputedStyle(this.$refs.titlebanner).getPropertyValue('--font-name') || "''";
    this.checkThatFontIsLoaded(50, computedFont);
    window.addEventListener('resize', () => this.drawTitle());
  },
  methods: {
    checkThatFontIsLoaded(fontsize, fontname) {
      try {
        const isLoaded = fontsize && fontname && document.fonts.check(`${fontsize}px ${fontname}`);
        if (!isLoaded) {
          setTimeout(() => {
            // console.error(
            //   "Font is not loaded. Will retry in 1000ms. Attempt: " +
            //     this.numAttemptsForFont
            // );
            this.numAttemptsForFont += 1;
            if (this.numAttemptsForFont < 10) {
              this.checkThatFontIsLoaded();
            }
            this.drawTitle();
          }, 1000);
        }
      } catch (err) {
        console.warn('Error when checking font: ', err);
      }
    },
    drawTitle() {
      let container = null,
        containerSize = null,
        canvas = null,
        ctx = null,
        runResizer = true;
      try {
        container = this.$refs.fittedTextContainer;
        containerSize = container.getBoundingClientRect();
        canvas = this.$refs.titlebanner;
        canvas.setAttribute('width', containerSize.width);
        canvas.setAttribute('height', containerSize.height);
        ctx = canvas?.getContext('2d');
      } catch (err) {
        runResizer = false;
      }
      if (!runResizer) {
        return;
      }
      const computedFont = getComputedStyle(canvas).getPropertyValue('--font-name') || "''";
      const fontFamily = computedFont + ', GT-America, sans-serif';
      let textColor = getComputedStyle(canvas).getPropertyValue('--splash-text-onimage-color');
      if (!textColor) {
        textColor = '#ffffff';
      }
      let fontsize = 15;
      let overflow = -1;
      let allWordsFitInTheBox = true;

      // Increase fontsize till the text overflows vertically or
      // a single word becomes wide enough to overflow horizontally
      while (overflow < 0 && allWordsFitInTheBox) {
        const updates = getOverflows(++fontsize, fontFamily, this.textcontent, canvas.width, canvas.height);
        overflow = updates.overflow;
        allWordsFitInTheBox = updates.allWordsFitInTheBox;
      }

      // Backtrack because overshoots are a breaking case and we need to get
      // to the first undershoot fontsize
      let shouldBacktrack = () => false;
      if (!allWordsFitInTheBox) {
        shouldBacktrack = () => !allWordsFitInTheBox;
      } else {
        shouldBacktrack = () => overflow > 0;
      }
      while (shouldBacktrack()) {
        const updates = getOverflows(--fontsize, fontFamily, this.textcontent, canvas.width, canvas.height);
        overflow = updates.overflow;
        allWordsFitInTheBox = updates.allWordsFitInTheBox;
      }

      // Finally paint it
      const font = `${fontsize}px ${fontFamily}`;
      const boxes = getWordBoxes(this.textcontent, font);
      const metrics = getLines(boxes, canvas.width);
      const lines = metrics.lines;
      const spaceWidth = metrics.spaceWidth;
      ctx.fillStyle = textColor;
      paintLines(lines, spaceWidth);
      function getOverflows(fontsize, fontFamily, text, targetWidth, targetHeight) {
        const font = `${fontsize}px ${fontFamily}`;
        const boxes = getWordBoxes(text, font);
        const metrics = getLines(boxes, targetWidth);
        const lines = metrics.lines;
        const allWordsFitInTheBox = metrics.allWordsFitInTheBox;
        const overflow = yOverflow(lines, targetHeight);
        return {
          overflow,
          allWordsFitInTheBox
        };
      }
      function yOverflow(lines, targetHeight) {
        const firstline = lines[0];
        const totalHeight = lines.length * firstline[0].height;
        return totalHeight - targetHeight;
      }
      function getLines(boxes, targetWidth) {
        const testMeausres = ctx.measureText('Something');
        if (testMeausres.fontBoundingBoxAscent === undefined) {
          // For firefox make all words of the same height
          let maxWordHeight = 0;
          for (let j = 0; j < boxes.length; j++) {
            const word = boxes[j];
            if (maxWordHeight < word.height) {
              maxWordHeight = word.height;
            }
          }
          for (let j = 0; j < boxes.length; j++) {
            const word = boxes[j];
            word.height = maxWordHeight;
            word.fontBoundingBoxAscent = word.height;
          }
        }
        const lines = [];
        const spaceWidth = boxes[boxes.length - 1].width;
        boxes = boxes.slice(0, boxes.length - 1);
        let boxIndex = 0;
        let allWordsFitInTheBox = true;
        while (boxIndex < boxes.length) {
          let linewidth = 0;
          let expectedWidth = 0;
          const line = [];

          // If at least the first word is fitting in the box
          if (boxes[boxIndex].width <= targetWidth) {
            expectedWidth = linewidth + boxes[boxIndex].width + spaceWidth;
            while (expectedWidth <= targetWidth && boxIndex < boxes.length) {
              linewidth = expectedWidth;
              line.push(boxes[boxIndex]);
              boxIndex += 1;
              if (boxIndex < boxes.length) {
                expectedWidth = linewidth + boxes[boxIndex].width + spaceWidth;
              }
            }
            if (line.length === 0 && boxIndex < boxes.length) {
              // Not even the first word could be added
              allWordsFitInTheBox = false;
              line.push(boxes[boxIndex]);
              lines.push(line);
              boxIndex += 1;
            } else {
              lines.push(line);
            }
          } else {
            line.push(boxes[boxIndex]);
            allWordsFitInTheBox = false;
            lines.push(line);
            break;
          }
        }
        return {
          lines,
          spaceWidth,
          allWordsFitInTheBox
        };
      }
      function getWordBoxes(text, font) {
        ctx.font = font;
        const words = text.split(/\s/).concat(' ');
        const boxes = words.map(word => {
          const textMeasurements = ctx.measureText(word);
          const width = textMeasurements.width;
          const fontBoundingBoxAscent = textMeasurements.fontBoundingBoxAscent || textMeasurements.actualBoundingBoxAscent;
          const fontBoundingBoxDescent = textMeasurements.fontBoundingBoxDescent || textMeasurements.actualBoundingBoxDescent;
          return {
            width,
            word,
            fontBoundingBoxAscent,
            fontBoundingBoxDescent,
            height: fontBoundingBoxAscent + fontBoundingBoxDescent
          };
        });
        return boxes;
      }
      function paintLines(lines, spaceWidth) {
        lines.forEach((boxes, i) => {
          paintBoxes(boxes, spaceWidth, i);
        });
      }
      function paintBoxes(boxes, spaceWidth, lineNo) {
        let start = 0;
        for (let box of boxes) {
          const linesAbove = lineNo;
          const ascent = box.fontBoundingBoxAscent || font.actualBoundingBoxAscent;
          ctx.fillText(box.word, start, linesAbove * box.height + ascent);
          // ctx.strokeRect(start, box.height * lineNo, box.width, box.height);
          start += box.width + spaceWidth;
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/FitText.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_FitTextvue_type_script_lang_js = (FitTextvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/FitText.vue?vue&type=style&index=0&id=809ed976&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var FitTextvue_type_style_index_0_id_809ed976_prod_module_true_lang_scss = ({"root":"FitText_root_dnkHH"});
;// CONCATENATED MODULE: ./src/atoms/FitText.vue?vue&type=style&index=0&id=809ed976&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/FitText.vue



;




function FitText_injectStyles (context) {
  
  this["$style"] = (FitTextvue_type_style_index_0_id_809ed976_prod_module_true_lang_scss.locals || FitTextvue_type_style_index_0_id_809ed976_prod_module_true_lang_scss)

}

/* normalize component */

var FitText_component = normalizeComponent(
  atoms_FitTextvue_type_script_lang_js,
  FitTextvue_type_template_id_809ed976_render,
  FitTextvue_type_template_id_809ed976_staticRenderFns,
  false,
  FitText_injectStyles,
  null,
  null
  
)

/* harmony default export */ var FitText = (FitText_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/ProgressLevel.vue?vue&type=template&id=ab070c26
var ProgressLevelvue_type_template_id_ab070c26_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, _vm._l(_vm.bars, function (i) {
    return _c('div', {
      key: i,
      ref: "volumebars",
      refInFor: true,
      class: i + 1 < _vm.bars * _vm.level / 100 && _vm.$style.active
    });
  }), 0);
};
var ProgressLevelvue_type_template_id_ab070c26_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/ProgressLevel.vue?vue&type=script&lang=js
/* harmony default export */ var ProgressLevelvue_type_script_lang_js = ({
  props: {
    level: {
      type: Number,
      default: 0
    },
    bars: {
      type: Number,
      default: 30
    }
  },
  methods: {
    setLevel(level) {
      for (let i = 0; i < this.$refs.volumebars.length; i++) {
        const bar = this.$refs.volumebars[i];
        if (i + 1 < this.bars * level / 100) {
          bar.style.background = 'var(--theme-secondary-color)';
        } else {
          bar.style.background = 'rgba(var(--primary-background-shade), 0.3)';
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/ProgressLevel.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_ProgressLevelvue_type_script_lang_js = (ProgressLevelvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/ProgressLevel.vue?vue&type=style&index=0&id=ab070c26&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ProgressLevelvue_type_style_index_0_id_ab070c26_prod_module_true_lang_scss = ({"root":"ProgressLevel_root_Y4dLv","active":"ProgressLevel_active_bhps2"});
;// CONCATENATED MODULE: ./src/atoms/ProgressLevel.vue?vue&type=style&index=0&id=ab070c26&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/ProgressLevel.vue



;




function ProgressLevel_injectStyles (context) {
  
  this["$style"] = (ProgressLevelvue_type_style_index_0_id_ab070c26_prod_module_true_lang_scss.locals || ProgressLevelvue_type_style_index_0_id_ab070c26_prod_module_true_lang_scss)

}

/* normalize component */

var ProgressLevel_component = normalizeComponent(
  atoms_ProgressLevelvue_type_script_lang_js,
  ProgressLevelvue_type_template_id_ab070c26_render,
  ProgressLevelvue_type_template_id_ab070c26_staticRenderFns,
  false,
  ProgressLevel_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ProgressLevel = (ProgressLevel_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/Banner.vue?vue&type=template&id=382e03dc
var Bannervue_type_template_id_382e03dc_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isVisible ? _c('div', {
    class: [_vm.$style.root],
    attrs: {
      "data-branding-target": "demo-banner"
    }
  }, [_c('div', {
    class: [_vm.$style.left]
  }, [_c('TextButton', {
    attrs: {
      "color": "primary-text-color",
      "variant": "subheading13",
      "uppercase": false
    },
    on: {
      "click": _vm.onAction
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " "), _c('div', {
    class: [_vm.$style.linkIconContainer]
  }, [_c('SvgIcon', {
    attrs: {
      "name": "link",
      "color": "primary-text-color",
      "size": "small"
    }
  })], 1)])], 1), _c('div', {
    class: [_vm.$style.right]
  }, [_c('TextButton', {
    attrs: {
      "color": "primary-text-color",
      "variant": "subheading13",
      "uppercase": false
    },
    on: {
      "click": function ($event) {
        _vm.isVisible = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Hide')) + " ")])], 1)]) : _vm._e();
};
var Bannervue_type_template_id_382e03dc_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/Banner.vue?vue&type=script&lang=js
/* harmony default export */ var Bannervue_type_script_lang_js = ({
  data() {
    return {
      isVisible: true
    };
  },
  props: {
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    onAction() {
      this.$emit('action');
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/Banner.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_Bannervue_type_script_lang_js = (Bannervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/Banner.vue?vue&type=style&index=0&id=382e03dc&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var Bannervue_type_style_index_0_id_382e03dc_prod_module_true_lang_scss = ({"root":"Banner_root_yb_G5","left":"Banner_left_V0bgJ","linkIconContainer":"Banner_linkIconContainer_UprDZ","right":"Banner_right_oUoOu"});
;// CONCATENATED MODULE: ./src/atoms/Banner.vue?vue&type=style&index=0&id=382e03dc&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/Banner.vue



;




function Banner_injectStyles (context) {
  
  this["$style"] = (Bannervue_type_style_index_0_id_382e03dc_prod_module_true_lang_scss.locals || Bannervue_type_style_index_0_id_382e03dc_prod_module_true_lang_scss)

}

/* normalize component */

var Banner_component = normalizeComponent(
  atoms_Bannervue_type_script_lang_js,
  Bannervue_type_template_id_382e03dc_render,
  Bannervue_type_template_id_382e03dc_staticRenderFns,
  false,
  Banner_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Banner = (Banner_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/SignalIndicator.vue?vue&type=template&id=6e97182f
var SignalIndicatorvue_type_template_id_6e97182f_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('GTooltip', {
    attrs: {
      "text": _vm.$options.$t('Signal strength is low. Close other windows or connect to a different network.'),
      "forceShowTooltip": _vm.signalStrength < 1,
      "position": "top-right",
      "disabled": _vm.noTooltip || _vm.signalStrength > 2
    }
  }, [_c('div', {
    class: [_vm.$style.root, _vm.$style[_vm.size]]
  }, _vm._l(5, function (i) {
    return _c('div', {
      key: i,
      class: {
        [_vm.$style.fade]: i > _vm.signalStrength,
        [_vm.$style.badStrength]: _vm.signalStrength <= 2,
        [_vm.$style.okStrength]: _vm.signalStrength > 2,
        [_vm.$style.goodStrength]: _vm.signalStrength >= 4
      }
    });
  }), 0)]);
};
var SignalIndicatorvue_type_template_id_6e97182f_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/SignalIndicator.vue?vue&type=script&lang=js
/* harmony default export */ var SignalIndicatorvue_type_script_lang_js = ({
  name: 'SignalIndicator',
  props: {
    size: {
      type: String,
      default: 'large' // small, medium, large
    },

    value: {
      // Number 0-5
      type: Number,
      default: 2
    },
    noTooltip: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    signalStrength() {
      if (this.value >= 0 && this.value <= 5) {
        return this.value;
      }
      return 1;
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/SignalIndicator.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_SignalIndicatorvue_type_script_lang_js = (SignalIndicatorvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/SignalIndicator.vue?vue&type=style&index=0&id=6e97182f&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SignalIndicatorvue_type_style_index_0_id_6e97182f_prod_module_true_lang_scss = ({"root":"SignalIndicator_root_N2i3l","fade":"SignalIndicator_fade_UEitM","badStrength":"SignalIndicator_badStrength_CoJvs","okStrength":"SignalIndicator_okStrength_T9cDL","goodStrength":"SignalIndicator_goodStrength_Mcq3H","large":"SignalIndicator_large_nAUNG","medium":"SignalIndicator_medium_TI2d4","small":"SignalIndicator_small_cXO7a"});
;// CONCATENATED MODULE: ./src/atoms/SignalIndicator.vue?vue&type=style&index=0&id=6e97182f&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/SignalIndicator.vue



;




function SignalIndicator_injectStyles (context) {
  
  this["$style"] = (SignalIndicatorvue_type_style_index_0_id_6e97182f_prod_module_true_lang_scss.locals || SignalIndicatorvue_type_style_index_0_id_6e97182f_prod_module_true_lang_scss)

}

/* normalize component */

var SignalIndicator_component = normalizeComponent(
  atoms_SignalIndicatorvue_type_script_lang_js,
  SignalIndicatorvue_type_template_id_6e97182f_render,
  SignalIndicatorvue_type_template_id_6e97182f_staticRenderFns,
  false,
  SignalIndicator_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SignalIndicator = (SignalIndicator_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/VideoProgressBar.vue?vue&type=template&id=c7100d74
var VideoProgressBarvue_type_template_id_c7100d74_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.background,
    style: _vm.totalBarWidth
  }), _c('div', {
    class: _vm.$style.outerBar,
    style: _vm.totalBarWidth
  }, [_c('div', {
    class: _vm.$style.innerBar,
    style: _vm.width
  })]), _vm.showVideoTimer ? _c('div', {
    class: _vm.$style.videoTimer
  }, [_vm.showToolTip ? _c('GTooltip', {
    attrs: {
      "text": _vm.$options.$t(`Video progress time`),
      "position": "top-left"
    }
  }, [_c('StyledText', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatRemainingTime(_vm.progressBarConfig.currentVideoDuration, _vm.progressBarConfig.totalVideoDuration)) + " ")])], 1) : _c('StyledText', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatRemainingTime(_vm.progressBarConfig.currentVideoDuration, _vm.progressBarConfig.totalVideoDuration)) + " ")]), _c('StyledText', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v(" / ")]), _vm.showToolTip ? _c('GTooltip', {
    attrs: {
      "text": _vm.$options.$t(`Total video duration`),
      "position": "top-left"
    }
  }, [_c('StyledText', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatTotalTime(_vm.progressBarConfig.totalVideoDuration)) + " ")])], 1) : _c('StyledText', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatTotalTime(_vm.progressBarConfig.totalVideoDuration)) + " ")])], 1) : _vm._e()]);
};
var VideoProgressBarvue_type_template_id_c7100d74_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/utils/dates.js
const datesAreOnSameDay = (first, second) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
const timeFormatter = new Intl.DateTimeFormat('en', {
  hour: 'numeric',
  minute: 'numeric'
});
const dateFormatter = new Intl.DateTimeFormat('en', {
  month: 'short',
  day: 'numeric'
});
const startToEndDateString = (startDate, endDate) => {
  try {
    /* eslint-disable */
    return datesAreOnSameDay(startDate, endDate) ? `${dateFormatter.format(startDate)} · ${timeFormatter.format(startDate)} - ${timeFormatter.format(endDate)}` : `${dateFormatter.formatRange(startDate, endDate)} · ${timeFormatter.format(startDate)}`;
    /* eslint-enable */
  } catch (e) {
    return '';
  }
};
function getTimeZone() {
  const longTimeZone = new Date().toLocaleTimeString('en-us', {
    timeZoneName: 'long'
  }).split(' ').slice(2).join(' ');
  return longTimeZone.match(/\b(\w)/g).join('');
}
function getTimeZoneFromDate(date) {
  if (!date) {
    return '';
  }
  const jsDate = new Date(date);
  const formatter = Intl.DateTimeFormat({}, {
    timeZoneName: 'short'
  });
  const parts = formatter.formatToParts(jsDate);
  let timezone = '';
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    if (part.type === 'timeZoneName') {
      timezone = part.value;
      break;
    }
  }
  return timezone;
}
function formatDuration(mseconds) {
  // convert milliseconds to seconds
  let seconds = Math.floor(mseconds / 1000);
  // calculate (and subtract) whole days
  const days = Math.floor(seconds / 86400);
  seconds -= days * 86400;

  // calculate (and subtract) whole hours
  const hours = Math.floor(seconds / 3600) % 24;
  seconds -= hours * 3600;

  // calculate (and subtract) whole minutes
  const minutes = Math.floor(seconds / 60) % 60;
  seconds -= minutes * 60;
  const duration = {
    days,
    hours,
    minutes,
    seconds
  };
  function padTimeWithZeroPrefix(v) {
    return `${v}`.padStart(2, 0);
  }
  let formattedDuration = Object.keys(duration).reduce((acc, key) => duration[key] > 0 || acc.length > 0 ? [...acc, `${padTimeWithZeroPrefix(duration[key])}${''}`] : acc, []).join(':');
  if (formattedDuration === '') {
    formattedDuration = '00';
  }
  if ((formattedDuration.match(/:/g) || []).length === 0) {
    formattedDuration = `00:${formattedDuration}`;
  }
  return formattedDuration;
}
function timeDiff(start, end) {
  return new Date(end).getTime() - new Date(start).getTime();
}
function formatDurationV2(start, end, showKeys = true) {
  const startTime = new Date(start);
  const endTime = new Date(end);
  const durationMs = endTime - startTime;

  // Ensure that both dates are valid and the end date is after or equal to the start date
  if (isNaN(startTime) || isNaN(endTime) || durationMs < 0) {
    return 'Invalid duration';
  }
  const seconds = Math.floor(durationMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const remainingSeconds = seconds % 60;
  const remainingMinutes = minutes % 60;
  const remainingHours = hours % 24;
  const duration = {
    d: days,
    h: remainingHours,
    m: remainingMinutes,
    s: remainingSeconds
  };
  const formattedDuration = Object.keys(duration).reduce((acc, key) => {
    const value = duration[key];
    if (value > 0 || acc.length > 0) {
      const formattedValue = `${pad(value)}${showKeys ? key : ''}`;
      return [...acc, formattedValue];
    }
    return acc;
  }, []).join(':');
  return formattedDuration || '00';
}
function pad(value) {
  return `${value}`.padStart(2, '0');
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/VideoProgressBar.vue?vue&type=script&lang=js

/* harmony default export */ var VideoProgressBarvue_type_script_lang_js = ({
  name: 'VideoProgressBar',
  props: {
    showToolTip: {
      type: Boolean,
      default: true
    },
    progressBarConfig: {
      type: Object,
      default: () => {
        return {
          totalVideoDuration: 0,
          currentVideoDuration: 0,
          showProgressBar: false
        };
      }
    },
    showVideoTimer: {
      type: Boolean,
      default: true
    },
    totalBarWidth: String,
    totalVideoDuration: Number,
    currentDuration: Number
  },
  computed: {
    width() {
      return {
        '--bar-width': Math.min(this.currentDuration, this.totalVideoDuration) / this.totalVideoDuration * 100 + '%'
      };
    }
  },
  methods: {
    formatTotalTime(totalLength) {
      return formatDuration(totalLength);
    },
    formatRemainingTime(timeLeft, totalLength) {
      timeLeft = Math.min(timeLeft, totalLength);
      timeLeft = formatDuration(timeLeft);
      totalLength = formatDuration(totalLength);
      const totalLengthDivs = (totalLength.match(/:/g) || []).length;
      const timeLeftDivs = (timeLeft.match(/:/g) || []).length;
      const diff = totalLengthDivs - timeLeftDivs;
      if (diff > 0) {
        timeLeft = '00:'.repeat(diff) + timeLeft;
      }
      return timeLeft;
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/VideoProgressBar.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_VideoProgressBarvue_type_script_lang_js = (VideoProgressBarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/VideoProgressBar.vue?vue&type=style&index=0&id=c7100d74&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var VideoProgressBarvue_type_style_index_0_id_c7100d74_prod_module_true_lang_scss = ({"root":"VideoProgressBar_root_ylNks","background":"VideoProgressBar_background_T6vSx","outerBar":"VideoProgressBar_outerBar_z_yc0","innerBar":"VideoProgressBar_innerBar_YFbKn","videoTimer":"VideoProgressBar_videoTimer_Se39b"});
;// CONCATENATED MODULE: ./src/atoms/VideoProgressBar.vue?vue&type=style&index=0&id=c7100d74&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/VideoProgressBar.vue



;




function VideoProgressBar_injectStyles (context) {
  
  this["$style"] = (VideoProgressBarvue_type_style_index_0_id_c7100d74_prod_module_true_lang_scss.locals || VideoProgressBarvue_type_style_index_0_id_c7100d74_prod_module_true_lang_scss)

}

/* normalize component */

var VideoProgressBar_component = normalizeComponent(
  atoms_VideoProgressBarvue_type_script_lang_js,
  VideoProgressBarvue_type_template_id_c7100d74_render,
  VideoProgressBarvue_type_template_id_c7100d74_staticRenderFns,
  false,
  VideoProgressBar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var VideoProgressBar = (VideoProgressBar_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/GoldBotRatingButton.vue?vue&type=template&id=3a9151ea
var GoldBotRatingButtonvue_type_template_id_3a9151ea_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    on: {
      "click": function ($event) {
        return _vm.$emit('openGoldcastBot');
      },
      "focusin": function ($event) {
        _vm.showTransitionOnHover = true;
      },
      "focusout": function ($event) {
        _vm.showTransitionOnHover = false;
      }
    }
  }, [_c('GTooltip', {
    class: _vm.$style.toolTip,
    attrs: {
      "text": _vm.$options.$t('Rate Goldcast!'),
      "position": "bottom-right",
      "forceShowTooltip": _vm.showTransition || _vm.showTransitionOnHover
    }
  }, [_c('div', {
    class: [_vm.$style.transistionContainer, _vm.showTransition && _vm.$style.show]
  }), _c('IconButton', {
    class: _vm.$style.btnIcon,
    attrs: {
      "icon": "goldcast-symbol-logo",
      "size": "regular",
      "aria-label": _vm.$options.$t('Rate Goldcast!')
    }
  })], 1)], 1);
};
var GoldBotRatingButtonvue_type_template_id_3a9151ea_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/GoldBotRatingButton.vue?vue&type=script&lang=js
/* harmony default export */ var GoldBotRatingButtonvue_type_script_lang_js = ({
  name: 'GoldBotRatingButton',
  props: {
    showTransition: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showTransitionOnHover: false
    };
  }
});
;// CONCATENATED MODULE: ./src/atoms/GoldBotRatingButton.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_GoldBotRatingButtonvue_type_script_lang_js = (GoldBotRatingButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/GoldBotRatingButton.vue?vue&type=style&index=0&id=3a9151ea&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var GoldBotRatingButtonvue_type_style_index_0_id_3a9151ea_prod_module_true_lang_scss = ({"root":"GoldBotRatingButton_root_7XdVD","toolTip":"GoldBotRatingButton_toolTip_pXG3u","transistionContainer":"GoldBotRatingButton_transistionContainer_E9s5b","show":"GoldBotRatingButton_show_Sf3jA","buttonTransition":"GoldBotRatingButton_buttonTransition_Maksf","btnIcon":"GoldBotRatingButton_btnIcon_vaIOz"});
;// CONCATENATED MODULE: ./src/atoms/GoldBotRatingButton.vue?vue&type=style&index=0&id=3a9151ea&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/GoldBotRatingButton.vue



;




function GoldBotRatingButton_injectStyles (context) {
  
  this["$style"] = (GoldBotRatingButtonvue_type_style_index_0_id_3a9151ea_prod_module_true_lang_scss.locals || GoldBotRatingButtonvue_type_style_index_0_id_3a9151ea_prod_module_true_lang_scss)

}

/* normalize component */

var GoldBotRatingButton_component = normalizeComponent(
  atoms_GoldBotRatingButtonvue_type_script_lang_js,
  GoldBotRatingButtonvue_type_template_id_3a9151ea_render,
  GoldBotRatingButtonvue_type_template_id_3a9151ea_staticRenderFns,
  false,
  GoldBotRatingButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var GoldBotRatingButton = (GoldBotRatingButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/LabeledSeparator.vue?vue&type=template&id=246e3061
var LabeledSeparatorvue_type_template_id_246e3061_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('StyledText', _vm._b({
    class: _vm.$style.root
  }, 'StyledText', _vm.$attrs, false), [_c('span', {
    class: _vm.$style.line
  }), _c('span', {
    class: _vm.$style.text
  }, [_vm._t("default")], 2), _c('span', {
    class: _vm.$style.line
  })]);
};
var LabeledSeparatorvue_type_template_id_246e3061_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/LabeledSeparator.vue?vue&type=script&lang=js
/* harmony default export */ var LabeledSeparatorvue_type_script_lang_js = ({
  name: 'LabeledSeparator'
});
;// CONCATENATED MODULE: ./src/atoms/LabeledSeparator.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_LabeledSeparatorvue_type_script_lang_js = (LabeledSeparatorvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/LabeledSeparator.vue?vue&type=style&index=0&id=246e3061&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var LabeledSeparatorvue_type_style_index_0_id_246e3061_prod_lang_scss_module_true = ({"root":"LabeledSeparator_root_wfevI","text":"LabeledSeparator_text_MVPbT","line":"LabeledSeparator_line_OKoH7"});
;// CONCATENATED MODULE: ./src/atoms/LabeledSeparator.vue?vue&type=style&index=0&id=246e3061&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/atoms/LabeledSeparator.vue



;




function LabeledSeparator_injectStyles (context) {
  
  this["$style"] = (LabeledSeparatorvue_type_style_index_0_id_246e3061_prod_lang_scss_module_true.locals || LabeledSeparatorvue_type_style_index_0_id_246e3061_prod_lang_scss_module_true)

}

/* normalize component */

var LabeledSeparator_component = normalizeComponent(
  atoms_LabeledSeparatorvue_type_script_lang_js,
  LabeledSeparatorvue_type_template_id_246e3061_render,
  LabeledSeparatorvue_type_template_id_246e3061_staticRenderFns,
  false,
  LabeledSeparator_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LabeledSeparator = (LabeledSeparator_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/ErrorCrossSvg.vue?vue&type=template&id=68b4ecfb&functional=true
var ErrorCrossSvgvue_type_template_id_68b4ecfb_functional_true_render = function render(_c, _vm) {
  return _c('svg', {
    attrs: {
      "width": "11",
      "height": "11",
      "viewBox": "0 0 11 11",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0ZM8.86052 2.19841C9.12506 2.46296 9.12506 2.89188 8.86052 3.15643L6.48748 5.52946L8.86012 7.9021C9.12467 8.16665 9.12467 8.59557 8.86012 8.86012C8.59557 9.12467 8.16665 9.12467 7.9021 8.86012L5.52946 6.48748L3.15682 8.86012C2.89228 9.12467 2.46336 9.12467 2.19881 8.86012C1.93426 8.59557 1.93426 8.16665 2.19881 7.9021L4.57145 5.52946L2.19841 3.15643C1.93386 2.89188 1.93386 2.46296 2.19841 2.19841C2.46296 1.93386 2.89188 1.93386 3.15643 2.19841L5.52946 4.57145L7.9025 2.19841C8.16705 1.93386 8.59597 1.93386 8.86052 2.19841Z",
      "fill": "#F63333"
    }
  })]);
};
var ErrorCrossSvgvue_type_template_id_68b4ecfb_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/ErrorCrossSvg.vue?vue&type=script&lang=js
/* harmony default export */ var ErrorCrossSvgvue_type_script_lang_js = ({
  name: 'ErrorCrossSvg',
  functional: true
});
;// CONCATENATED MODULE: ./src/atoms/ErrorCrossSvg.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_ErrorCrossSvgvue_type_script_lang_js = (ErrorCrossSvgvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/atoms/ErrorCrossSvg.vue





/* normalize component */
;
var ErrorCrossSvg_component = normalizeComponent(
  atoms_ErrorCrossSvgvue_type_script_lang_js,
  ErrorCrossSvgvue_type_template_id_68b4ecfb_functional_true_render,
  ErrorCrossSvgvue_type_template_id_68b4ecfb_functional_true_staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var ErrorCrossSvg = (ErrorCrossSvg_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/GSelect.vue?vue&type=template&id=7fc44cfa
var GSelectvue_type_template_id_7fc44cfa_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('NewSimpleSelect', _vm._b({
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.error]: _vm.hasError
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, 'NewSimpleSelect', _vm.$attrs, false), [_vm._t("default")], 2);
};
var GSelectvue_type_template_id_7fc44cfa_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/GSelect.vue?vue&type=script&lang=js
/* harmony default export */ var GSelectvue_type_script_lang_js = ({
  name: 'GSelect',
  props: {
    hasError: Boolean
  }
});
;// CONCATENATED MODULE: ./src/atoms/GSelect.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_GSelectvue_type_script_lang_js = (GSelectvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/GSelect.vue?vue&type=style&index=0&id=7fc44cfa&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var GSelectvue_type_style_index_0_id_7fc44cfa_prod_module_true_lang_scss = ({"root":"GSelect_root_Mdk1F","error":"GSelect_error_Ph9L_"});
;// CONCATENATED MODULE: ./src/atoms/GSelect.vue?vue&type=style&index=0&id=7fc44cfa&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/GSelect.vue



;




function GSelect_injectStyles (context) {
  
  this["$style"] = (GSelectvue_type_style_index_0_id_7fc44cfa_prod_module_true_lang_scss.locals || GSelectvue_type_style_index_0_id_7fc44cfa_prod_module_true_lang_scss)

}

/* normalize component */

var GSelect_component = normalizeComponent(
  atoms_GSelectvue_type_script_lang_js,
  GSelectvue_type_template_id_7fc44cfa_render,
  GSelectvue_type_template_id_7fc44cfa_staticRenderFns,
  false,
  GSelect_injectStyles,
  null,
  null
  
)

/* harmony default export */ var GSelect = (GSelect_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/Ribbon.vue?vue&type=template&id=7cccf749
var Ribbonvue_type_template_id_7cccf749_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.$style[_vm.theme]]
  }, [_c('SvgIcon', {
    attrs: {
      "size": "small",
      "name": _vm.icon,
      "color": "secondary-text-color"
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "heading14",
      "color": "secondary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('StyledText', {
    attrs: {
      "color": "secondary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")]), _vm.cta ? _c('PillButton', {
    attrs: {
      "size": "xx-small",
      "variant": _vm.theme,
      "alt": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onCtaClick');
      }
    }
  }, [_vm._v(_vm._s(_vm.cta))]) : _vm._e()], 1);
};
var Ribbonvue_type_template_id_7cccf749_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/Ribbon.vue?vue&type=script&lang=js
/* harmony default export */ var Ribbonvue_type_script_lang_js = ({
  props: {
    theme: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: true
    },
    cta: {
      type: String,
      required: false
    }
  },
  methods: {
    onAction() {
      this.$emit('action');
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/Ribbon.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_Ribbonvue_type_script_lang_js = (Ribbonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/Ribbon.vue?vue&type=style&index=0&id=7cccf749&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var Ribbonvue_type_style_index_0_id_7cccf749_prod_module_true_lang_scss = ({"primary":"Ribbon_primary_OeKta","secondary":"Ribbon_secondary_FCatz","warning":"Ribbon_warning_r_3UR","root":"Ribbon_root_C1oXf"});
;// CONCATENATED MODULE: ./src/atoms/Ribbon.vue?vue&type=style&index=0&id=7cccf749&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/Ribbon.vue



;




function Ribbon_injectStyles (context) {
  
  this["$style"] = (Ribbonvue_type_style_index_0_id_7cccf749_prod_module_true_lang_scss.locals || Ribbonvue_type_style_index_0_id_7cccf749_prod_module_true_lang_scss)

}

/* normalize component */

var Ribbon_component = normalizeComponent(
  atoms_Ribbonvue_type_script_lang_js,
  Ribbonvue_type_template_id_7cccf749_render,
  Ribbonvue_type_template_id_7cccf749_staticRenderFns,
  false,
  Ribbon_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Ribbon = (Ribbon_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/ReadMoreLessWrapper.vue?vue&type=template&id=e2138bbc
var ReadMoreLessWrappervue_type_template_id_e2138bbc_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    ref: "textRef",
    class: [_vm.$style.text, _vm.isTextExpanded && _vm.$style.showFullText],
    style: {
      'max-height': _vm.visibleTextHeight
    }
  }, [_vm._t("default")], 2), _c('div', {
    class: _vm.$style.textActionBar
  }, [_vm.isTextLong ? _c('StyledText', {
    class: _vm.$style.actionButton,
    attrs: {
      "color": "theme-secondary-color",
      "variant": "body11"
    },
    on: {
      "click": _vm.toggleExpandText
    }
  }, [_vm._v(_vm._s(_vm.isTextExpanded ? _vm.$options.$t('Read Less') : _vm.$options.$t('Read More')) + " ")]) : _vm._e()], 1)]);
};
var ReadMoreLessWrappervue_type_template_id_e2138bbc_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/ReadMoreLessWrapper.vue?vue&type=script&lang=js
/* harmony default export */ var ReadMoreLessWrappervue_type_script_lang_js = ({
  name: 'ReadMoreLessWrapper',
  props: {
    text: {
      type: String,
      default: ''
    },
    visibleTextHeight: {
      type: String,
      default: '60px'
    }
  },
  data() {
    return {
      isTextExpanded: false,
      isTextLong: false
    };
  },
  methods: {
    toggleExpandText() {
      this.isTextExpanded = !this.isTextExpanded;
      if (this.isTextExpanded) {
        this.$refs.textRef.style.maxHeight = 'none';
      } else {
        this.$refs.textRef.style.maxHeight = this.visibleTextHeight;
      }
    }
  },
  watch: {
    text: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$nextTick(() => {
            this.isTextLong = this.$refs.textRef?.scrollHeight > this.$refs.textRef?.offsetHeight;
          });
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/ReadMoreLessWrapper.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_ReadMoreLessWrappervue_type_script_lang_js = (ReadMoreLessWrappervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/ReadMoreLessWrapper.vue?vue&type=style&index=0&id=e2138bbc&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ReadMoreLessWrappervue_type_style_index_0_id_e2138bbc_prod_module_true_lang_scss = ({"root":"ReadMoreLessWrapper_root_yiQPM","text":"ReadMoreLessWrapper_text_fRftU","showFullText":"ReadMoreLessWrapper_showFullText_Av4z8","textActionBar":"ReadMoreLessWrapper_textActionBar_gCwVi","actionButton":"ReadMoreLessWrapper_actionButton_tRYgo"});
;// CONCATENATED MODULE: ./src/atoms/ReadMoreLessWrapper.vue?vue&type=style&index=0&id=e2138bbc&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/ReadMoreLessWrapper.vue



;




function ReadMoreLessWrapper_injectStyles (context) {
  
  this["$style"] = (ReadMoreLessWrappervue_type_style_index_0_id_e2138bbc_prod_module_true_lang_scss.locals || ReadMoreLessWrappervue_type_style_index_0_id_e2138bbc_prod_module_true_lang_scss)

}

/* normalize component */

var ReadMoreLessWrapper_component = normalizeComponent(
  atoms_ReadMoreLessWrappervue_type_script_lang_js,
  ReadMoreLessWrappervue_type_template_id_e2138bbc_render,
  ReadMoreLessWrappervue_type_template_id_e2138bbc_staticRenderFns,
  false,
  ReadMoreLessWrapper_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ReadMoreLessWrapper = (ReadMoreLessWrapper_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/GTextArea.vue?vue&type=template&id=4d35d244
var GTextAreavue_type_template_id_4d35d244_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.textAnswer,
      expression: "textAnswer"
    }],
    ref: "textarea",
    class: [_vm.$style.textarea, _vm.$style[_vm.textColor]],
    attrs: {
      "placeholder": _vm.$options.$t(_vm.placeholder),
      "rows": "1"
    },
    domProps: {
      "value": _vm.textAnswer
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.textAnswer = $event.target.value;
      }, _vm.handleTextChange],
      "keyup": function ($event) {
        return _vm.$emit('onAnswer', _vm.textAnswer);
      }
    }
  })]);
};
var GTextAreavue_type_template_id_4d35d244_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/GTextArea.vue?vue&type=script&lang=js
/* harmony default export */ var GTextAreavue_type_script_lang_js = ({
  name: 'GTextArea',
  data() {
    return {
      textAnswer: ''
    };
  },
  props: {
    answer: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Your answer'
    },
    maxHeight: {
      type: Number,
      default: 120
    },
    textColor: {
      type: String,
      default: 'primary'
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.textarea.value = this.answer;
      this.handleTextChange();
    });
  },
  methods: {
    handleTextChange() {
      const textAreaRef = this.$refs.textarea;
      if (textAreaRef) {
        textAreaRef.style.height = '0px';
        const scrollHeight = Math.min(textAreaRef.scrollHeight, this.maxHeight);
        textAreaRef.style.height = scrollHeight + 'px';
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/GTextArea.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_GTextAreavue_type_script_lang_js = (GTextAreavue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/GTextArea.vue?vue&type=style&index=0&id=4d35d244&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var GTextAreavue_type_style_index_0_id_4d35d244_prod_lang_scss_module_true = ({"root":"GTextArea_root_rabhp","textarea":"GTextArea_textarea_lpslb","primary":"GTextArea_primary_C6ICj","secondary":"GTextArea_secondary_dXEJV"});
;// CONCATENATED MODULE: ./src/atoms/GTextArea.vue?vue&type=style&index=0&id=4d35d244&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/atoms/GTextArea.vue



;




function GTextArea_injectStyles (context) {
  
  this["$style"] = (GTextAreavue_type_style_index_0_id_4d35d244_prod_lang_scss_module_true.locals || GTextAreavue_type_style_index_0_id_4d35d244_prod_lang_scss_module_true)

}

/* normalize component */

var GTextArea_component = normalizeComponent(
  atoms_GTextAreavue_type_script_lang_js,
  GTextAreavue_type_template_id_4d35d244_render,
  GTextAreavue_type_template_id_4d35d244_staticRenderFns,
  false,
  GTextArea_injectStyles,
  null,
  null
  
)

/* harmony default export */ var GTextArea = (GTextArea_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/Badge.vue?vue&type=template&id=42bd5dee
var Badgevue_type_template_id_42bd5dee_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.$style[_vm.variant]]
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading10"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.text)) + " ")])], 1);
};
var Badgevue_type_template_id_42bd5dee_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/Badge.vue?vue&type=script&lang=js
/* harmony default export */ var Badgevue_type_script_lang_js = ({
  name: 'Badge',
  props: {
    text: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      required: true,
      default: 'warning',
      validator(value) {
        return ['info', 'warning', 'danger', 'primary', 'secondary'].includes(value);
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/Badge.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_Badgevue_type_script_lang_js = (Badgevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/Badge.vue?vue&type=style&index=0&id=42bd5dee&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var Badgevue_type_style_index_0_id_42bd5dee_prod_module_true_lang_scss = ({"root":"Badge_root_epDqM","warning":"Badge_warning_jDrEh","danger":"Badge_danger_saciy","info":"Badge_info_h8jX6","secondary":"Badge_secondary_TJRJ7","primary":"Badge_primary_OaEBt"});
;// CONCATENATED MODULE: ./src/atoms/Badge.vue?vue&type=style&index=0&id=42bd5dee&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/Badge.vue



;




function Badge_injectStyles (context) {
  
  this["$style"] = (Badgevue_type_style_index_0_id_42bd5dee_prod_module_true_lang_scss.locals || Badgevue_type_style_index_0_id_42bd5dee_prod_module_true_lang_scss)

}

/* normalize component */

var Badge_component = normalizeComponent(
  atoms_Badgevue_type_script_lang_js,
  Badgevue_type_template_id_42bd5dee_render,
  Badgevue_type_template_id_42bd5dee_staticRenderFns,
  false,
  Badge_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Badge = (Badge_component.exports);
;// CONCATENATED MODULE: ./src/atoms/index.js























;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/UserTooltip.vue?vue&type=template&id=0e0d322d&functional=true
var UserTooltipvue_type_template_id_0e0d322d_functional_true_render = function render(_c, _vm) {
  return _c('GTooltip', {
    class: _vm.$style.tip,
    attrs: {
      "showOpenIcon": !!_vm.listeners.click,
      "text": _vm.props.text || _vm.props.user.name,
      "variant": _vm.props.variant,
      "position": _vm.props.position
    },
    on: {
      "click": () => _vm.listeners.click ? _vm.listeners.click(_vm.props.user) : null
    }
  }, [_c('button', {
    class: _vm.$style.button,
    attrs: {
      "tabindex": _vm.listeners.click ? 0 : null,
      "aria-label": 'Avatar of' + _vm.props.user.name,
      "aria-haspopup": _vm.props.ariaHasPopup
    },
    on: {
      "click": () => _vm.listeners.click ? _vm.listeners.click(_vm.props.user) : null
    }
  }, [_c('UserImage', {
    class: [_vm.data.staticClass, _vm.data.class, _vm.$style.root],
    attrs: {
      "size": _vm.props.size,
      "user": _vm.props.user,
      "outlined": _vm.props.outlined,
      "forceHideHybrid": _vm.props.showInPersonSpeaker
    }
  })], 1)]);
};
var UserTooltipvue_type_template_id_0e0d322d_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/UserTooltip.vue?vue&type=script&lang=js
/* harmony default export */ var UserTooltipvue_type_script_lang_js = ({
  name: 'UserToolTip',
  functional: true,
  props: {
    user: Object,
    size: {
      type: String,
      default: 'small'
    },
    outlined: {
      type: Boolean,
      default: true
    },
    variant: {
      type: String,
      default: 'secondary'
    },
    position: {
      type: String,
      default: 'top-center'
    },
    text: String,
    showInPersonSpeaker: {
      type: Boolean,
      default: false
    },
    ariaHasPopup: {
      type: String,
      default: null
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/UserTooltip.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_UserTooltipvue_type_script_lang_js = (UserTooltipvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-11.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/UserTooltip.vue?vue&type=style&index=0&id=0e0d322d&prod&module=true&lang=css
// extracted by mini-css-extract-plugin
/* harmony default export */ var UserTooltipvue_type_style_index_0_id_0e0d322d_prod_module_true_lang_css = ({"tip":"UserTooltip_tip_TKIn1","button":"UserTooltip_button_vGdHq"});
;// CONCATENATED MODULE: ./src/molecules/UserTooltip.vue?vue&type=style&index=0&id=0e0d322d&prod&module=true&lang=css
 
;// CONCATENATED MODULE: ./src/molecules/UserTooltip.vue



;




function UserTooltip_injectStyles (context) {
  
  this["$style"] = (UserTooltipvue_type_style_index_0_id_0e0d322d_prod_module_true_lang_css.locals || UserTooltipvue_type_style_index_0_id_0e0d322d_prod_module_true_lang_css)

}

/* normalize component */

var UserTooltip_component = normalizeComponent(
  molecules_UserTooltipvue_type_script_lang_js,
  UserTooltipvue_type_template_id_0e0d322d_functional_true_render,
  UserTooltipvue_type_template_id_0e0d322d_functional_true_staticRenderFns,
  true,
  UserTooltip_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UserTooltip = (UserTooltip_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/StageControlBar.vue?vue&type=template&id=7f46c96e
var StageControlBarvue_type_template_id_7f46c96e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('footer', {
    class: [_vm.$style.root],
    attrs: {
      "id": "stageControlBar",
      "tabindex": "-1",
      "aria-label": _vm.$t('Stage Controls and Information')
    }
  }, [_c('div', {
    class: [_vm.$style.floatingControlsContainer, {
      [_vm.$style.newTimer]: _vm.isManualRedirectionEnabled
    }]
  }, [_c('div', {
    class: _vm.$style.floatingLeft
  }, [_vm.controls.emptyStage && _vm.room.subText ? _c('StyledText', {
    class: _vm.$style.startingInContainer,
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm.room.duration ? [_c('PillButton', {
    class: _vm.$style.timerSection
  }, [_c('SvgIcon', {
    class: _vm.$style.clock,
    attrs: {
      "color": "secondary",
      "name": "stopwatch",
      "center": "",
      "size": "medium"
    }
  }), _c('StyledText', {
    class: _vm.$style.timerText,
    attrs: {
      "color": "theme-primary-color",
      "variant": "heading13"
    }
  }, [_vm._v(_vm._s(_vm.$options.$t('Starting in {duration}', {
    duration: _vm.room.duration
  })) + " ")])], 1)] : _vm.room.thankYou ? [_vm._v(" " + _vm._s(_vm.room.thankYou) + " ")] : _vm.room.start_time && _vm.room.end_time ? [_vm._v(" " + _vm._s(_vm.formatTime(_vm.room.start_time)) + " - " + _vm._s(_vm.formatTime(_vm.room.end_time)) + " " + _vm._s(_vm.timezone(_vm.room.start_time)) + " ")] : _vm._e()], 2) : _vm._e(), _vm.controls.hasAdminAccess && _vm.timer.show && !_vm.isManualRedirectionEnabled ? [_c('PillButton', {
    class: _vm.$style.timerSection
  }, [_c('SvgIcon', {
    class: _vm.$style.clock,
    attrs: {
      "color": "secondary",
      "name": "stopwatch",
      "center": "",
      "size": "medium"
    }
  }), _c('StyledText', {
    class: _vm.$style.timerText,
    attrs: {
      "color": "theme-primary-color",
      "variant": "heading13"
    }
  }, [_vm._v(_vm._s(_vm.timer.highlight ? _vm.$options.$t('Ending in ') : _vm.$options.$t('Live in ')) + " " + _vm._s(_vm.timer.time) + " ")])], 1)] : _vm._e(), _vm.showNewCountdownButton ? [_c('Countdown', {
    attrs: {
      "size": "small",
      "outlined": false,
      "duration": _vm.timer.time,
      "prefixText": _vm.prefixText
    }
  })] : _vm._e()], 2), _c('div', {
    class: _vm.$style.floatingRight
  }, [_vm.controls.shouldShowLayoutControl ? _c('StageLayoutsOptions', {
    attrs: {
      "controls": _vm.controls
    },
    on: {
      "layoutChange": value => _vm.$emit('layoutChanged', value),
      "changeShowAllSpeakerSelection": value => _vm.$emit('changeShowAllSpeakerSelection', value),
      "changeRoundedVideoSelection": value => _vm.$emit('changeRoundedVideoSelection', value)
    }
  }) : _vm._e(), _vm.showStopSharingButton ? _c('PillButton', {
    class: _vm.$style.stopSharingButton,
    attrs: {
      "disabled": _vm.controls.publishedStage.loading,
      "size": "x-small",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('unpublish');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('STOP SHARING')) + " ")]) : _vm._e(), _vm.showSideController ? _c('SlideControl', {
    class: _vm.$style.slideControl,
    attrs: {
      "slides": _vm.slides
    },
    on: {
      "changeSlide": function ($event) {
        return _vm.$emit('changeSlide', $event);
      }
    }
  }) : _vm._e(), _vm.shouldShowReturnToLive ? _c('PillButton', {
    class: _vm.$style.switchToLiveButton,
    attrs: {
      "size": "x-small",
      "loading": _vm.isSwitchingToSpeakerMode,
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('switchToLiveMode');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('STOP VIDEO')) + " ")]) : _vm._e(), _vm.showSessionControlActions ? [_vm.showStartSession ? _c('OutlinedButton', {
    class: [_vm.$style.buttons, _vm.$style.startSession],
    attrs: {
      "disabled": _vm.timer.show && !_vm.timer.highlight || _vm.isButtonLoading
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('startSessionManually', _vm.room);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Start Session')) + " ")]) : _vm._e(), _vm.isLive ? _c('OutlinedButton', {
    class: [_vm.$style.buttons, _vm.$style.startSession],
    attrs: {
      "disabled": _vm.isButtonLoading
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('endSessionManually', _vm.room);
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('End Session')))])]) : _vm._e()] : _vm._e()], 2)]), _c('div', {
    class: _vm.$style.surveyStageTip
  }, [_vm.showSurveyMinimizedBarTip ? _c('SurveyStageBarTip', _vm._b({
    on: {
      "expandSurveyView": function ($event) {
        return _vm.$emit('expandSurveyView');
      }
    }
  }, 'SurveyStageBarTip', _vm.surveyBarTipMetaData, false)) : _vm._e()], 1), _c('div', {
    key: _vm.room.id,
    class: _vm.$style.staticControlsContainer
  }, [_c('div', {
    class: _vm.$style.staticLeft
  }, [_c('div', {
    class: _vm.$style.titleChangeTrackWrapper
  }, [_c('div', {
    class: _vm.$style.titleWrapper
  }, [_vm.room.is_live && _vm.controls.isBroadcast && !_vm.isManualRedirectionEnabled ? _c('Badge', {
    class: _vm.$style.live,
    attrs: {
      "variant": "danger",
      "text": "live"
    }
  }) : _vm._e(), _vm.isManualRedirectionEnabled && _vm.controls.isBroadcast && !_vm.controls.onDemandMode ? _c('Badge', {
    class: _vm.$style.live,
    attrs: {
      "variant": _vm.getBadgeDetails.variant,
      "text": _vm.getBadgeDetails.text
    }
  }) : _vm._e(), _c('GTooltip', {
    attrs: {
      "text": _vm.room.title,
      "position": "top-left"
    }
  }, [_c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "nowrap": "",
      "color": "primary-text-color",
      "variant": "heading14",
      "display": "block"
    }
  }, [_vm._v(" " + _vm._s(_vm.room.title || '') + " ")])], 1)], 1), !_vm.controls.isSpeaker && _vm.tracks && _vm.tracks.length > 1 && !_vm.controls.onDemandMode ? _c('div', {
    class: _vm.$style.changeTrackContainer
  }, [_c('AccessibleSelect', {
    attrs: {
      "id": "changeTrack",
      "dataTestId": "changeTrack",
      "value": {
        ..._vm.currentTrack,
        value: _vm.currentTrack.id
      },
      "variant": "primary",
      "verticalPosition": "top",
      "noBorder": true,
      "noPadding": true,
      "noRoundedCorner": true,
      "inheritThemeColor": true,
      "transparentOptionBackground": true,
      "optionIcon": "bell",
      "options": _vm.tracks.map(t => ({
        ...t,
        label: t.title,
        value: t.id,
        disabled: t.disabled
      }))
    },
    on: {
      "input": arg => _vm.$emit('trackChanged', arg)
    }
  })], 1) : _vm._e()]), _vm.broadcastSpeakers && _vm.broadcastSpeakers.length ? _c('div', [_vm.controls.shouldShowStageSpeakersControl ? _c('StageSpeakersControl', {
    attrs: {
      "speakers": _vm.broadcastSpeakers
    },
    on: {
      "openSpeakersControlPanel": function ($event) {
        return _vm.$emit('openSpeakersControlPanel');
      }
    }
  }) : _c('StageSpeakers', {
    attrs: {
      "speakers": _vm.broadcastSpeakers
    },
    on: {
      "seeAllSpeakers": speakers => _vm.$emit('seeAllSpeakers', speakers),
      "userClicked": user => _vm.$emit('userClicked', user)
    }
  })], 1) : _vm._e(), _vm.watchCount > 0 ? _c('StyledText', {
    class: _vm.$style.watching,
    attrs: {
      "color": "primary-text-color",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(`People Watching: ${_vm.watchCount}`)) + " ")]) : _vm._e()], 1), _c('div', {
    class: _vm.$style.staticRight
  }, [_c('div', {
    class: _vm.$style.buttonContainer_1
  }, [_vm.liteMode.showLiteModeToggle ? _c('LitemodeSwitcher', {
    attrs: {
      "externalMessage": _vm.liteMode.externalMessage,
      "liteModeActive": _vm.liteMode.liteModeActive,
      "liteModeState": _vm.liteMode.liteModeState,
      "liteModeNotAvailable": _vm.liteMode.liteModeNotAvailable,
      "liteModeNotSupported": _vm.liteMode.liteModeNotSupported,
      "viewAsAttendee": _vm.viewAsAttendee
    },
    on: {
      "litemodeswitchclicked": function ($event) {
        return _vm.$emit('litemodeswitchclicked');
      },
      "switchtolitemode": function ($event) {
        return _vm.$emit('toggletolitemode');
      },
      "switchtolivemode": function ($event) {
        return _vm.$emit('toggletolivemode');
      },
      "closelitemodeprompts": function ($event) {
        return _vm.$emit('closelitemodeprompts');
      },
      "recordintrestinlitemode": function ($event) {
        return _vm.$emit('recordintrestinlitemode');
      }
    }
  }) : _vm._e(), !_vm.controls.publishedStage.isHls || _vm.controls.isBackstage ? [!_vm.controls.hideAudioControls ? _c('span', {
    class: _vm.$style.controlButtonWrapper
  }, [_c('span', {
    ref: "volumelevel",
    class: _vm.$style.volume_level
  }), _c('IconButton', {
    attrs: {
      "role": "switch",
      "ariaChecked": _vm.streamControls.audio && _vm.streamControls.audio.isMuted ? 'false' : 'true',
      "aria-label": _vm.$t(_vm.microphoneLabelText),
      "icon": _vm.streamControls.audio && _vm.streamControls.audio.isMuted ? 'muted' : 'mic',
      "ghost": "",
      "alt": "",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('toggle_controls', 'audio');
      }
    }
  }), _vm.streamControls.audio && _vm.streamControls.audio.loading ? _c('div', {
    class: _vm.$style.loading
  }, [_c('Loading', {
    attrs: {
      "size": "verySmall",
      "theme": "secondary-theme"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), !_vm.controls.hideVideoControls ? _c('span', {
    class: _vm.$style.controlButtonWrapper
  }, [_c('IconButton', {
    attrs: {
      "role": "switch",
      "ariaChecked": _vm.streamControls.video && _vm.streamControls.video.isMuted ? 'false' : 'true',
      "aria-label": _vm.cameraLabelText,
      "icon": _vm.streamControls.video && _vm.streamControls.video.isMuted ? 'videocam-muted' : 'videocam',
      "ghost": "",
      "alt": "",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('toggle_controls', 'video');
      }
    }
  }), _vm.streamControls.video && _vm.streamControls.video.loading ? _c('div', {
    class: _vm.$style.loading
  }, [_c('Loading', {
    attrs: {
      "size": "verySmall",
      "theme": "secondary-theme"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm.controls.showScreenShareOption ? _c('GTooltip', {
    class: _vm.$style.nonmobile,
    attrs: {
      "disabled": !_vm.controls.publishedStage.currentScreen || _vm.controls.publishedStage.currentScreen === 'screen',
      "text": _vm.$options.$t(`Can't share screen while there is something else being presented on stage`)
    }
  }, [_c('IconButton', {
    attrs: {
      "icon": "screen-share",
      "aria-label": _vm.$options.$t('Present Screen'),
      "ghost": "",
      "alt": "",
      "variant": "primary",
      "disabled": !!_vm.controls.publishedStage.currentScreen
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('share_screen');
      }
    }
  })], 1) : _vm._e()] : _vm._e(), !_vm.controls.onDemandMode ? _c('IconButton', {
    attrs: {
      "id": "settingIconButton",
      "dataTestId": "settingIconButton",
      "icon": "settings",
      "aria-label": " Stage Control",
      "ariaHasPopup": "true",
      "ghost": "",
      "alt": "",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('open_settings');
      }
    }
  }) : _vm._e(), _vm.controls.showMuteButton ? _c('MuteButton', {
    attrs: {
      "muted": _vm.muted
    },
    on: {
      "toggleMute": function ($event) {
        return _vm.$emit('toggleMute');
      }
    }
  }) : _vm._e()], 2), _c('div', {
    class: _vm.$style.buttonContainer_2
  }, [_vm.room.ctaText ? _c('PillButton', {
    attrs: {
      "uppercase": "",
      "center": "",
      "size": "x-small"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('ctaClicked');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.room.ctaText) + " ")]) : _vm._e(), _vm.raiseHand && _vm.raiseHand.visible ? _c('RaiseHandButton', {
    class: _vm.$style.raiseHandButtonContainer,
    attrs: {
      "loading": _vm.raiseHand && _vm.raiseHand.loading,
      "buttonState": _vm.raiseHand && _vm.raiseHand.buttonState,
      "tooltipText": _vm.raiseHand && _vm.raiseHand.tooltipText
    },
    on: {
      "onClick": function ($event) {
        return _vm.$emit('onClickRaiseHand');
      }
    }
  }) : _vm._e(), _vm.controls.isBackstage && _vm.controls.wait ? _c('PillButton', {
    attrs: {
      "loading": true,
      "alt": "",
      "size": "x-small",
      "center": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('WAIT')) + " ")]) : _vm._e(), _vm.controls.shouldShowLeaveButton ? _c('PillButton', {
    attrs: {
      "disabled": _vm.controls.blockMovement,
      "loading": _vm.controls.blockMovement,
      "size": "x-small",
      "center": "",
      "variant": "warning"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('leave_stage');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.controls.roomType === 'BROADCAST' ? _vm.$options.$t('LEAVE STAGE') : _vm.$options.$t('LEAVE')) + " ")]) : _vm._e(), _vm.controls.shouldShowGoBackstageButton ? _c('OutlinedButton', {
    attrs: {
      "disabled": _vm.controls.blockMovement,
      "loading": _vm.controls.blockMovement,
      "size": "x-small",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('enter_backstage');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('GO BACKSTAGE')) + " ")]) : _vm._e(), _vm.controls.shouldShowGoLiveButton ? _c('PillButton', {
    attrs: {
      "disabled": _vm.controls.blockMovement,
      "loading": _vm.controls.blockMovement,
      "size": "x-small",
      "uppercase": "",
      "center": "",
      "variant": "warning"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('join_stage');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.showRehearsalButton ? _vm.$options.$t('Rehearse On Stage') : _vm.$options.$t('GO LIVE')) + " ")]) : _vm._e(), _vm.showSignal ? _c('SignalIndicator', {
    attrs: {
      "value": _vm.signalStrength
    }
  }) : _vm._e()], 1)])])]);
};
var StageControlBarvue_type_template_id_7f46c96e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/Countdown.vue?vue&type=template&id=85657980
var Countdownvue_type_template_id_85657980_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, {
      [_vm.$style.outlined]: _vm.outlined
    }, _vm.$style[_vm.size]]
  }, [_c('SvgIcon', {
    attrs: {
      "name": "timer",
      "color": _vm.color,
      "size": "mediumXs"
    }
  }), _c('StyledText', {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.prefixText)) + " "), _c('span', {
    class: _vm.$style.timer
  }, [_vm._v(_vm._s(_vm.duration))])])], 1);
};
var Countdownvue_type_template_id_85657980_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/Countdown.vue?vue&type=script&lang=js
/* harmony default export */ var Countdownvue_type_script_lang_js = ({
  name: 'Countdown',
  props: {
    duration: {
      type: String,
      required: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    prefixText: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'regular'
    }
  },
  computed: {
    color() {
      return this.outlined ? 'theme-secondary-color' : '';
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/Countdown.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_Countdownvue_type_script_lang_js = (Countdownvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/Countdown.vue?vue&type=style&index=0&id=85657980&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var Countdownvue_type_style_index_0_id_85657980_prod_module_true_lang_scss = ({"root":"Countdown_root_KQQBF","small":"Countdown_small_dbKHh","outlined":"Countdown_outlined_AC_bH","timer":"Countdown_timer_T09YJ"});
;// CONCATENATED MODULE: ./src/atoms/Countdown.vue?vue&type=style&index=0&id=85657980&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/Countdown.vue



;




function Countdown_injectStyles (context) {
  
  this["$style"] = (Countdownvue_type_style_index_0_id_85657980_prod_module_true_lang_scss.locals || Countdownvue_type_style_index_0_id_85657980_prod_module_true_lang_scss)

}

/* normalize component */

var Countdown_component = normalizeComponent(
  atoms_Countdownvue_type_script_lang_js,
  Countdownvue_type_template_id_85657980_render,
  Countdownvue_type_template_id_85657980_staticRenderFns,
  false,
  Countdown_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Countdown = (Countdown_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/StageControlBar.vue?vue&type=script&lang=js


/* harmony default export */ var StageControlBarvue_type_script_lang_js = ({
  name: 'StageControlBar',
  components: {
    Countdown: Countdown
  },
  props: {
    broadcastSpeakers: {
      type: Array,
      default: () => []
    },
    room: {
      type: Object,
      default: () => ({})
    },
    viewAsAttendee: {
      type: Boolean,
      default: false
    },
    tracks: Array,
    controls: {
      type: Object,
      default: () => ({
        publishedStage: {}
      })
    },
    surveyBarTipMetaData: {
      type: Object,
      default: () => ({
        showSurveyMinimizedBarTip: false,
        timeLeft: '',
        surveyTitle: ''
      })
    },
    streamControls: {
      type: Object,
      default: () => ({})
    },
    currentTrack: {
      type: Object,
      default: () => ({})
    },
    timer: {
      type: Object,
      default: () => ({
        show: false
      })
    },
    muted: Boolean,
    raiseHand: {
      type: Object,
      default: null
    },
    liteMode: {
      type: Object,
      default: () => ({})
    },
    signalStrength: {
      type: Number,
      default: 0
    },
    showSignal: Boolean,
    shouldShowSlideControls: {
      type: Boolean,
      default: false
    },
    slides: {
      type: Object,
      default: () => ({})
    },
    isSwitchingToSpeakerMode: {
      type: Boolean,
      default: false
    },
    shouldShowReturnToLive: Boolean,
    watchCount: {
      type: Number,
      default: 0
    },
    isManualRedirectionEnabled: {
      type: Boolean,
      default: false
    },
    prefixText: {
      type: String,
      default: ''
    }
  },
  methods: {
    formatTime(time) {
      return timeFormatter.format(new Date(time));
    },
    timezone(dateString) {
      const localTimezone = getTimeZoneFromDate(dateString);
      return localTimezone;
    }
  },
  computed: {
    hasEventEnded() {
      const endTime = new Date(this.room?.end_time);
      const currentTime = new Date();
      return endTime < currentTime;
    },
    microphoneLabelText() {
      return this.streamControls.audio?.isMuted ? 'Turn on Microphone' : 'Turn off Microphone';
    },
    cameraLabelText() {
      return this.streamControls.video.isMuted ? 'Turn on camera' : 'Turn off camera';
    },
    showNewCountdownButton() {
      return (this.controls.hasAdminAccess || this.controls.isSpeaker) && this.timer.show && this.isManualRedirectionEnabled;
    },
    showOldEndingCountdown() {
      return this.controls.hasAdminAccess && this.timer.show && !this.isManualRedirectionEnabled;
    },
    showStopSharingButton() {
      return !this.controls.isBackstage && this.controls.publishedStage.showControls && !this.controls.onDemandMode;
    },
    showSideController() {
      return this.controls.publishedStage.showControls && this.shouldShowSlideControls && !this.controls.onDemandMode;
    },
    showSessionControlActions() {
      return (this.controls.isOrganizer || this.controls.isSpeaker) && this.isManualRedirectionEnabled;
    },
    showStartSession() {
      // This is just kept to recall the logic
      this.timer.time;
      const allowedStartTime = new Date(this.room.allowed_start_time);
      const now = new Date();
      const allowedEndTime = new Date(this.room.allowed_end_time);
      return now >= allowedStartTime && now < allowedEndTime && !this.room.is_live;
    },
    showSurveyMinimizedBarTip() {
      return !this.controls.isSpeaker && this.surveyBarTipMetaData.showSurveyMinimizedBarTip;
    },
    isLive() {
      return this.room.is_live;
    },
    getBadgeDetails() {
      if (this.isLive) {
        return {
          variant: 'danger',
          text: 'live'
        };
      }
      return {
        variant: 'warning',
        text: 'rehearsal mode'
      };
    },
    showRehearsalButton() {
      return !this.isLive && this.isManualRedirectionEnabled;
    },
    isButtonLoading() {
      return this.room?.agenda_control_loading_state?.start_button || this.room?.agenda_control_loading_state?.end_button;
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/StageControlBar.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_StageControlBarvue_type_script_lang_js = (StageControlBarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/StageControlBar.vue?vue&type=style&index=0&id=7f46c96e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var StageControlBarvue_type_style_index_0_id_7f46c96e_prod_module_true_lang_scss = ({"root":"StageControlBar_root_y6h37","floatingControlsContainer":"StageControlBar_floatingControlsContainer_m7GxM","floatingLeft":"StageControlBar_floatingLeft_h5JpW","startingInContainer":"StageControlBar_startingInContainer_oR5B8","timerSection":"StageControlBar_timerSection_oshZ6","timerText":"StageControlBar_timerText_t6szX","floatingRight":"StageControlBar_floatingRight_BeIZ9","newTimer":"StageControlBar_newTimer_mCq9v","surveyStageTip":"StageControlBar_surveyStageTip_jSOe7","staticControlsContainer":"StageControlBar_staticControlsContainer_zeXPS","staticLeft":"StageControlBar_staticLeft_m6EZ8","titleChangeTrackWrapper":"StageControlBar_titleChangeTrackWrapper_JIeaf","titleWrapper":"StageControlBar_titleWrapper_ffC6I","title":"StageControlBar_title_lY5Py","changeTrackContainer":"StageControlBar_changeTrackContainer_C3TbY","watching":"StageControlBar_watching_PTG7A","staticRight":"StageControlBar_staticRight_B0cgx","buttonContainer_1":"StageControlBar_buttonContainer_1_MLcbr","buttonContainer_2":"StageControlBar_buttonContainer_2_jonNo","slideControl":"StageControlBar_slideControl_pV065","stopSharingButton":"StageControlBar_stopSharingButton_J4NI0","switchToLiveButton":"StageControlBar_switchToLiveButton_AMaK_","live":"StageControlBar_live_ULqQJ","selectedIcon":"StageControlBar_selectedIcon_xRuny","clock":"StageControlBar_clock_iFVif","option":"StageControlBar_option_OvXGP","shareIcon":"StageControlBar_shareIcon_x6zm4","controlButtonWrapper":"StageControlBar_controlButtonWrapper_AQJw9","loading":"StageControlBar_loading_DMJwT","volume_level":"StageControlBar_volume_level_M6uBR","nonmobile":"StageControlBar_nonmobile_TppPo"});
;// CONCATENATED MODULE: ./src/molecules/StageControlBar.vue?vue&type=style&index=0&id=7f46c96e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/StageControlBar.vue



;




function StageControlBar_injectStyles (context) {
  
  this["$style"] = (StageControlBarvue_type_style_index_0_id_7f46c96e_prod_module_true_lang_scss.locals || StageControlBarvue_type_style_index_0_id_7f46c96e_prod_module_true_lang_scss)

}

/* normalize component */

var StageControlBar_component = normalizeComponent(
  molecules_StageControlBarvue_type_script_lang_js,
  StageControlBarvue_type_template_id_7f46c96e_render,
  StageControlBarvue_type_template_id_7f46c96e_staticRenderFns,
  false,
  StageControlBar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var StageControlBar = (StageControlBar_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/Ticker.vue?vue&type=template&id=57c8bcd8
var Tickervue_type_template_id_57c8bcd8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.roundedBorder && _vm.$style.roundedBorder],
    on: {
      "click": _vm.handleUrlCllick
    }
  }, [_c('MarqueeText', {
    attrs: {
      "marqueeText": _vm.tickerData.ticker_text,
      "showLink": !!_vm.tickerData.ticker_url
    }
  }), _vm.isEventOrganizer ? _c('CloseButton', {
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }) : _vm._e()], 1);
};
var Tickervue_type_template_id_57c8bcd8_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/MarqueeText.vue?vue&type=template&id=6fe1f944
var MarqueeTextvue_type_template_id_6fe1f944_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    ref: "marqueeCanvas",
    class: [_vm.$style.root, _vm.showLink && _vm.$style.link],
    attrs: {
      "role": "marquee",
      "data-banner": ""
    }
  }, [_c('canvas', {
    ref: "datCcanvas",
    class: _vm.$style.canvas
  })]);
};
var MarqueeTextvue_type_template_id_6fe1f944_staticRenderFns = [];

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.31.0/node_modules/core-js/modules/es.typed-array.to-reversed.js
var es_typed_array_to_reversed = __webpack_require__(5834);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.31.0/node_modules/core-js/modules/es.typed-array.to-sorted.js
var es_typed_array_to_sorted = __webpack_require__(9890);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.31.0/node_modules/core-js/modules/es.typed-array.with.js
var es_typed_array_with = __webpack_require__(4365);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/MarqueeText.vue?vue&type=script&lang=js




/* harmony default export */ var MarqueeTextvue_type_script_lang_js = ({
  props: {
    speed: {
      type: Number,
      default: 1
    },
    showLink: {
      type: Boolean,
      default: false
    },
    marqueeText: {
      type: String,
      default: ''
    },
    linkIcon: {
      type: String,
      default: 'https://d6d4ismr40iw.cloudfront.net/link.svg'
    }
  },
  mounted() {
    this.canvas = this.$refs.datCcanvas;
    // this is to stop the animation when we hover on the ticker, we are setting a variable called mouseOver as true if
    // we hover on the ticker and we ll check this in requestAnimationFrame function.
    this.canvas.addEventListener('mouseenter', () => {
      if (!this.isMobile()) {
        this.mouseOver = true;
      }
    });
    window.addEventListener('resize', () => this.handleWindowResized());
    this.canvas.addEventListener('mouseleave', () => {
      this.mouseOver = false;
    });
    this.context = this.canvas?.getContext('2d');
    this.options = {
      text: this.marqueeText,
      speed: 1,
      textColor: getComputedStyle(this.canvas).getPropertyValue('--secondary-text-color'),
      font: '14px sans-serif',
      padding: 30
    };
    this.secondaryColor32bit = this.get32bitColorCode(getComputedStyle(this.canvas).getPropertyValue('--secondary-text-color'));

    // this tells the browser how many of the screen's actual pixels should be used to draw a single CSS pixel.
    this.ratio = window.devicePixelRatio || 1;
    this.textHeight = this.measureFontHeight().height;

    //get perfect height width of the canvas according to the ration
    this.resize();
    this.yloc = 0;
    this.xloc = 0;
    this.init();
    this.animate();
  },
  data() {
    return {
      secondaryColor32bit: null,
      mouseEntered: false,
      canvas: null,
      options: {},
      ratio: 1,
      textHeight: 0,
      yloc: 0,
      xloc: 0,
      animId: null,
      mouseOver: false
    };
  },
  methods: {
    handleWindowResized() {
      cancelAnimationFrame(this.animId);
      this.context?.clearRect(0, 0, this.canvas.width, this.canvas.height);
      setTimeout(() => {
        this.resize();
        this.init();
        this.animate();
      }, 100);
    },
    init() {
      this.context.font = this.options.font;
      this.textWidth = this.context.measureText(this.options.text).width + this.options.padding;
      this.duplicator = Math.ceil(this.canvas.width / this.textWidth) + 1;

      // collect all the start point - x (from where to start painting the text) so we ll duplicate this till it fills the container
      // and then we can just paint with all the x points collected.

      this.x = [];
      for (let i = 0; i < this.duplicator; i += 1) {
        const pos = i * this.textWidth + this.options.padding * (i + 1);
        this.x.push(pos);
        if (i === 1) {
          this.originalX = pos;
        }
      }
    },
    get32bitColorCode(orig) {
      let originalColor = orig;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(originalColor)) {
        let c = originalColor.substring(1).split('');
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        originalColor = 'rgba(' + [c >> 16 & 255, c >> 8 & 255, c & 255].join(',') + ',1)';
      }
      let colors = extractRgb(originalColor);
      function extractRgb(css) {
        return css.match(/[0-9.]+/gi);
      }
      let r = parseInt(colors[0]) & 0xff;
      let g = parseInt(colors[1]) & 0xff;
      let b = parseInt(colors[2]) & 0xff;
      let a = 255 & 0xff;
      return (a << 24) + (b << 16) + (g << 8) + r;
    },
    animate() {
      this.animId = requestAnimationFrame(() => {
        this.animate();
      });
      if (!this.mouseOver || this.isMobile()) {
        this.x.forEach((el, i) => {
          if (this.textWidth + this.x[i] < 0) {
            this.x[i] = this.textWidth * (this.duplicator - 1) + this.options.padding * (this.duplicator + 1);
          } else {
            this.x[i] -= this.options.speed;
          }
        });
        this.drawContect();
      }
    },
    drawSvg(i) {
      this.context.drawImage(this.base_image, this.x[i] + this.textWidth - 10, this.yloc + 2);
    },
    drawContect() {
      this.context?.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.setFont();
      for (let i = 0; i < this.duplicator; i += 1) {
        this.context.fillText(this.options.text, this.x[i], this.yloc);
        let imageWidth = 0;
        if (this.showLink) {
          this.base_image = new Image();
          this.base_image.crossOrigin = 'Anonymous';
          this.base_image.src = this.linkIcon;
          this.base_image.onload = this.drawSvg(i);
          imageWidth = this.base_image.width + 5;
          let x = this.x[i] + this.textWidth - 10;
          let y = this.yloc + 2;
          if (this.base_image?.naturalWidth) {
            var imageData = this.context.getImageData(x * this.ratio, y * this.ratio, this.base_image.naturalWidth * this.ratio, this.base_image.naturalHeight * this.ratio);
            var buf32 = new Uint32Array(imageData.data.buffer);
            for (let i = 0; i < buf32.length; i++) {
              if (buf32[i] !== 0) {
                buf32[i] = this.secondaryColor32bit;
              }
            }
            this.context.putImageData(imageData, x * this.ratio, y * this.ratio);
          }
        }
        var centerX = this.x[i] + this.textWidth + imageWidth;
        var centerY = this.textHeight / 2;
        var radius = 1.5;
        this.context.beginPath();
        this.context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
        this.context.fillStyle = getComputedStyle(this.canvas).getPropertyValue('--secondary-text-color');
        this.context.fill();
      }
    },
    resize() {
      let containerBox = this.$refs.marqueeCanvas;
      this.canvas.width = containerBox?.clientWidth * this.ratio;
      this.textHeight = this.measureFontHeight().height;
      this.canvas.height = this.textHeight * this.ratio;
      this.canvas.style.width = `${containerBox?.clientWidth - 24}px`;
      this.canvas.style.height = `${this.textHeight}px`;
      this.context.scale(this.ratio, this.ratio);
    },
    // setting the font style color and alignment.
    setFont() {
      this.context.font = this.options.font;
      this.context.fillStyle = this.options.textColor;
      this.context.textAlign = 'left';
      this.context.textBaseline = 'top';
    },
    // draw image -  this takes your image , x starting point and y starting point.

    measureFontHeight() {
      this.setFont();
      this.context.fillText(this.options.text, 0, 0);
      // using TextMetrics apis to get the height of the fonts.
      let metrics = this.context.measureText(this.options.text);
      let fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
      let actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
      return {
        height: fontHeight,
        actualHeight: actualHeight
      };
    },
    isMobile() {
      return window.mobileCheck && window.mobileCheck();
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/MarqueeText.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_MarqueeTextvue_type_script_lang_js = (MarqueeTextvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/MarqueeText.vue?vue&type=style&index=0&id=6fe1f944&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var MarqueeTextvue_type_style_index_0_id_6fe1f944_prod_module_true_lang_scss = ({"root":"MarqueeText_root_sSLZX","link":"MarqueeText_link_TqWYl","canvas":"MarqueeText_canvas_kVNfd"});
;// CONCATENATED MODULE: ./src/atoms/MarqueeText.vue?vue&type=style&index=0&id=6fe1f944&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/MarqueeText.vue



;




function MarqueeText_injectStyles (context) {
  
  this["$style"] = (MarqueeTextvue_type_style_index_0_id_6fe1f944_prod_module_true_lang_scss.locals || MarqueeTextvue_type_style_index_0_id_6fe1f944_prod_module_true_lang_scss)

}

/* normalize component */

var MarqueeText_component = normalizeComponent(
  atoms_MarqueeTextvue_type_script_lang_js,
  MarqueeTextvue_type_template_id_6fe1f944_render,
  MarqueeTextvue_type_template_id_6fe1f944_staticRenderFns,
  false,
  MarqueeText_injectStyles,
  null,
  null
  
)

/* harmony default export */ var MarqueeText = (MarqueeText_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/Ticker.vue?vue&type=script&lang=js

/* harmony default export */ var Tickervue_type_script_lang_js = ({
  components: {
    MarqueeText: MarqueeText
  },
  name: 'Ticker',
  props: {
    tickerId: {
      type: String,
      default: 'myId'
    },
    isEventOrganizer: {
      type: Boolean,
      default: false
    },
    tickerData: {
      type: Object,
      default: () => {}
    },
    roundedBorder: {
      type: Boolean,
      default: false
    },
    isAdmin: Boolean
  },
  methods: {
    handleUrlCllick(event) {
      const url = this.tickerData.ticker_url;
      // window.analytics.track("ticker_url_clicked", { url });
      if (url && event.target.tagName === 'CANVAS') {
        window.open(url, '_blank');
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/Ticker.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_Tickervue_type_script_lang_js = (Tickervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/Ticker.vue?vue&type=style&index=0&id=57c8bcd8&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var Tickervue_type_style_index_0_id_57c8bcd8_prod_module_true_lang_scss = ({"root":"Ticker_root_cZ5zV","roundedBorder":"Ticker_roundedBorder_hUK29"});
;// CONCATENATED MODULE: ./src/molecules/Ticker.vue?vue&type=style&index=0&id=57c8bcd8&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/Ticker.vue



;




function Ticker_injectStyles (context) {
  
  this["$style"] = (Tickervue_type_style_index_0_id_57c8bcd8_prod_module_true_lang_scss.locals || Tickervue_type_style_index_0_id_57c8bcd8_prod_module_true_lang_scss)

}

/* normalize component */

var Ticker_component = normalizeComponent(
  molecules_Tickervue_type_script_lang_js,
  Tickervue_type_template_id_57c8bcd8_render,
  Tickervue_type_template_id_57c8bcd8_staticRenderFns,
  false,
  Ticker_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Ticker = (Ticker_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/CloseButton.vue?vue&type=template&id=21646c2c
var CloseButtonvue_type_template_id_21646c2c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    class: _vm.$style.root,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    class: _vm.$style.hoverBox
  }, [_c('div', {
    class: _vm.$style.btnContainer
  }, [_c('StyledText', {
    class: _vm.$style.btnText,
    attrs: {
      "variant": "body12",
      "color": "primary-text-color"
    }
  }, [_vm._v(" STOP SHARING ")]), _c('SvgIcon', {
    class: _vm.$style.btnIcon,
    attrs: {
      "name": "cross",
      "color": "secondary-text-color",
      "size": "medium"
    }
  })], 1)])]);
};
var CloseButtonvue_type_template_id_21646c2c_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/CloseButton.vue?vue&type=script&lang=js
/* harmony default export */ var CloseButtonvue_type_script_lang_js = ({
  name: 'CloseButton'
});
;// CONCATENATED MODULE: ./src/molecules/CloseButton.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_CloseButtonvue_type_script_lang_js = (CloseButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/CloseButton.vue?vue&type=style&index=0&id=21646c2c&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var CloseButtonvue_type_style_index_0_id_21646c2c_prod_module_true_lang_scss = ({"root":"CloseButton_root_J3_ff","btnContainer":"CloseButton_btnContainer_AKktT","btnIcon":"CloseButton_btnIcon_Gj5P1","btnText":"CloseButton_btnText_7qvQh","hoverBox":"CloseButton_hoverBox_aBmQG"});
;// CONCATENATED MODULE: ./src/molecules/CloseButton.vue?vue&type=style&index=0&id=21646c2c&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/CloseButton.vue



;




function CloseButton_injectStyles (context) {
  
  this["$style"] = (CloseButtonvue_type_style_index_0_id_21646c2c_prod_module_true_lang_scss.locals || CloseButtonvue_type_style_index_0_id_21646c2c_prod_module_true_lang_scss)

}

/* normalize component */

var CloseButton_component = normalizeComponent(
  molecules_CloseButtonvue_type_script_lang_js,
  CloseButtonvue_type_template_id_21646c2c_render,
  CloseButtonvue_type_template_id_21646c2c_staticRenderFns,
  false,
  CloseButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var CloseButton = (CloseButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/ConfirmationDialogWrapper.vue?vue&type=template&id=f5b4c3b8
var ConfirmationDialogWrappervue_type_template_id_f5b4c3b8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ConfirmationDialog', {
    attrs: {
      "header": _vm.header,
      "bodyText": _vm.bodyText,
      "confirmationBtnText": _vm.confirmationBtnText,
      "cancelBtnText": _vm.cancelBtnText,
      "dontShowFurtherPrompts": _vm.dontShowFurtherPrompts,
      "showDontAskAgain": _vm.showDontAskAgain,
      "headerIcon": _vm.headerIcon
    },
    on: {
      "confirm": function ($event) {
        return _vm.$emit('hide', $event);
      },
      "cancel": function ($event) {
        return _vm.$emit('cancel', $event);
      }
    }
  });
};
var ConfirmationDialogWrappervue_type_template_id_f5b4c3b8_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/ConfirmationDialogWrapper.vue?vue&type=script&lang=js
/* harmony default export */ var ConfirmationDialogWrappervue_type_script_lang_js = ({
  name: 'ConfirmationDialogWrapper',
  props: {
    header: {
      type: String,
      default: ''
    },
    bodyText: {
      type: String,
      default: ''
    },
    confirmationBtnText: {
      type: String,
      default: ''
    },
    cancelBtnText: {
      type: String,
      default: 'Cancel'
    },
    dontShowFurtherPrompts: {
      type: Boolean,
      default: false
    },
    showDontAskAgain: {
      type: Boolean,
      default: true
    },
    headerIcon: {
      type: String,
      default: 'notification'
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/ConfirmationDialogWrapper.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_ConfirmationDialogWrappervue_type_script_lang_js = (ConfirmationDialogWrappervue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/molecules/ConfirmationDialogWrapper.vue





/* normalize component */
;
var ConfirmationDialogWrapper_component = normalizeComponent(
  molecules_ConfirmationDialogWrappervue_type_script_lang_js,
  ConfirmationDialogWrappervue_type_template_id_f5b4c3b8_render,
  ConfirmationDialogWrappervue_type_template_id_f5b4c3b8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConfirmationDialogWrapper = (ConfirmationDialogWrapper_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/VideoControls.vue?vue&type=template&id=c25f4fc4&functional=true
var VideoControlsvue_type_template_id_c25f4fc4_functional_true_render = function render(_c, _vm) {
  return _c('div', [_c('span', {
    class: _vm.$style.micWrapper
  }, [_c('span', {
    class: _vm.$style.volume_level,
    style: {
      height: `${_vm.props.controls.audioLevel}%`
    }
  }), !_vm.props.controls.hideAudioControls ? _c('IconButton', {
    attrs: {
      "icon": _vm.props.streamControls.audio ? 'mic' : 'muted',
      "ghost": "",
      "alt": "",
      "variant": "primary"
    },
    on: {
      "click": () => _vm.listeners.toggle_controls('audio')
    }
  }) : _vm._e()], 1), !_vm.props.controls.hideVideoControls ? _c('IconButton', {
    attrs: {
      "icon": _vm.props.streamControls.video ? 'videocam' : 'videocam-muted',
      "ghost": "",
      "alt": "",
      "variant": "primary"
    },
    on: {
      "click": () => _vm.listeners.toggle_controls('video')
    }
  }) : _vm._e(), _c('IconButton', {
    attrs: {
      "icon": "settings",
      "ghost": "",
      "alt": "",
      "variant": "primary"
    },
    on: {
      "click": () => _vm.listeners.open_settings()
    }
  })], 1);
};
var VideoControlsvue_type_template_id_c25f4fc4_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/VideoControls.vue?vue&type=script&lang=js
/* harmony default export */ var VideoControlsvue_type_script_lang_js = ({
  functional: true,
  name: 'VideoControls',
  props: {
    controls: {
      type: Object,
      default: () => ({
        publishedStage: {}
      })
    },
    streamControls: {
      type: Object,
      default: () => ({})
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/VideoControls.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_VideoControlsvue_type_script_lang_js = (VideoControlsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/VideoControls.vue?vue&type=style&index=0&id=c25f4fc4&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var VideoControlsvue_type_style_index_0_id_c25f4fc4_prod_module_true_lang_scss = ({"micWrapper":"VideoControls_micWrapper_CBVnG","volume_level":"VideoControls_volume_level_m813L"});
;// CONCATENATED MODULE: ./src/molecules/VideoControls.vue?vue&type=style&index=0&id=c25f4fc4&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/VideoControls.vue



;




function VideoControls_injectStyles (context) {
  
  this["$style"] = (VideoControlsvue_type_style_index_0_id_c25f4fc4_prod_module_true_lang_scss.locals || VideoControlsvue_type_style_index_0_id_c25f4fc4_prod_module_true_lang_scss)

}

/* normalize component */

var VideoControls_component = normalizeComponent(
  molecules_VideoControlsvue_type_script_lang_js,
  VideoControlsvue_type_template_id_c25f4fc4_functional_true_render,
  VideoControlsvue_type_template_id_c25f4fc4_functional_true_staticRenderFns,
  true,
  VideoControls_injectStyles,
  null,
  null
  
)

/* harmony default export */ var VideoControls = (VideoControls_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/HybridSetupMode/BroadcastHybridSetupMode.vue?vue&type=template&id=21c77d63
var BroadcastHybridSetupModevue_type_template_id_21c77d63_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.fullPage && _vm.$style.fullPage]
  }, [_c('HybridSetupModeSidebar', {
    attrs: {
      "items": _vm.broadcastsAgendaItemsAndDates,
      "currentBroadcast": _vm.broadcast,
      "dayOptions": _vm.dayOptions,
      "selectedDay": _vm.selectedDay,
      "trackOptions": _vm.trackOptions,
      "selectedTrack": _vm.selectedTrack,
      "heartBeatDate": _vm.heartBeatDate
    },
    on: {
      "user-clicked": function ($event) {
        return _vm.$emit('user-clicked', $event);
      },
      "on-day-select": function ($event) {
        return _vm.$emit('on-day-select', $event);
      },
      "on-track-select": function ($event) {
        return _vm.$emit('on-track-select', $event);
      },
      "cta-clicked": function ($event) {
        return _vm.$emit('cta-clicked', $event);
      },
      "show-speakers": function ($event) {
        return _vm.$emit('show-speakers', $event);
      }
    }
  }), _c('div', {
    class: _vm.$style.content
  }, [_c('NavigationBar', {
    class: _vm.$style.navbar,
    attrs: {
      "links": [],
      "status": _vm.status,
      "profileLinks": _vm.profileLinks,
      "eventLogo": _vm.eventLogo,
      "isInPerson": _vm.isInPerson,
      "isHybridEvent": _vm.isHybridEvent,
      "currentUser": _vm.currentUser
    },
    on: {
      "userDropDownToggle": function ($event) {
        return _vm.$emit('userDropDownToggle', $event);
      },
      "join": item => _vm.$emit('join', item)
    }
  }, [_c('div', {
    class: _vm.$style.navItems
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading16",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.broadcast.title) + " ")]), _c('StyledText', {
    class: _vm.$style.state,
    attrs: {
      "color": _vm.broadcast.is_live ? 'warning' : 'primary-text-color',
      "variant": "heading10"
    }
  }, [_vm._v(" " + _vm._s(_vm.broadcastLivenessStatus) + " ")]), _c('StyledText', {
    class: _vm.$style.time,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading10"
    }
  }, [_vm._v(" " + _vm._s(_vm.startTime) + " - " + _vm._s(_vm.endTime) + " ")])], 1)]), _c('LiveStreamInfoArea', {
    ref: "liveStreamInfoArea",
    class: _vm.$style.main,
    attrs: {
      "stream": _vm.stream,
      "actionConfig": _vm.actionConfig,
      "streamControls": _vm.streamControls,
      "isTvModeOpen": _vm.isTvModeOpen,
      "tvMuted": _vm.tvMuted
    },
    on: {
      "join_broadcast": function ($event) {
        return _vm.$emit('join_broadcast', $event);
      },
      "enter_backstage": function ($event) {
        return _vm.$emit('enter_backstage', $event);
      },
      "toggle_tv": function ($event) {
        return _vm.$emit('toggle_tv', $event);
      },
      "toggle_controls": function ($event) {
        return _vm.$emit('toggle_controls', $event);
      },
      "muteTv": function ($event) {
        return _vm.$emit('muteTv');
      }
    }
  }, [_vm._t("default"), _vm._t("tv", null, {
    "slot": "tv"
  })], 2), _c('div', {
    class: _vm.$style.footer
  }, [_c('PillButton', {
    attrs: {
      "variant": "warning",
      "alt": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Close Setup Mode')) + " ")]), _c('TextButton', {
    attrs: {
      "variant": "body13"
    },
    on: {
      "click": _vm.openHelpDoc
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Help')) + " "), _c('SvgIcon', {
    class: _vm.$style.icon,
    attrs: {
      "name": "link",
      "color": "theme-secondary-color"
    }
  })], 1)], 1)], 1)], 1);
};
var BroadcastHybridSetupModevue_type_template_id_21c77d63_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/utils/dateTime.js
const dateTime_datesAreOnSameDay = (first, second) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
const dateTime_timeFormatter = new Intl.DateTimeFormat('en', {
  hour: 'numeric',
  minute: 'numeric'
});
const dateTime_dateFormatter = new Intl.DateTimeFormat('en', {
  month: 'short',
  day: 'numeric'
});
const dateTime_startToEndDateString = (startDate, endDate) => {
  try {
    const startTimeString = dateTime_timeFormatter.format(startDate);
    const endTimeString = dateTime_timeFormatter.format(endDate);
    /* eslint-disable */
    return dateTime_datesAreOnSameDay(startDate, endDate) ? `${dateTime_dateFormatter.format(startDate)} · ${startTimeString} - ${endTimeString}` : dateTime_dateFormatter.formatRange(startDate, endDate);
    /* eslint-enable */
  } catch (e) {
    return '';
  }
};
function dateIsBefore(date, target = new Date()) {
  const [start, end] = [new Date(date), new Date(target)];
  return start < end;
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/HybridSetupMode/LiveStreamInfoArea.vue?vue&type=template&id=458fb10f
var LiveStreamInfoAreavue_type_template_id_458fb10f_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.page_info
  }, [_c('div', {
    class: _vm.$style.collapsableStep
  }, [_c('div', {
    class: _vm.$style.player
  }, [_c('AgoraV4Player', {
    attrs: {
      "isLocal": true,
      "videoTrack": _vm.stream,
      "loading": false,
      "user": {},
      "muted": false,
      "fit": "contain"
    }
  }), !_vm.stream ? _c('SvgIcon', {
    class: _vm.$style.icon,
    attrs: {
      "color": "warning",
      "name": "videocam-muted",
      "size": "large"
    }
  }) : _vm._e()], 1), _c('div', {
    class: _vm.$style.stretch
  }, [_c('div', {
    class: [_vm.$style.info, _vm.$style.top]
  }, [_c('StyledText', {
    class: _vm.$style.header,
    attrs: {
      "variant": "heading14",
      "color": "primary-text-color",
      "align": "left"
    }
  }, [_vm._v(" " + _vm._s(_vm.actionConfig.isBackstage ? _vm.$options.$t('Stage Stream') : _vm.$options.$t('Streaming to Virtual Users from on-site video feed')) + " ")]), _c('StyledText', {
    class: _vm.$style.info_text,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color",
      "align": "left"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Connect your on-site camera and microphone to present to your virtual attendees')) + ". ")])], 1), _vm._t("default")], 2), _c('div', {
    class: _vm.$style.actions
  }, [_c('span', {
    class: _vm.$style.controlButtonWrapper
  }, [_c('span', {
    ref: "volumelevel",
    class: _vm.$style.volume_level
  }), _c('IconButton', {
    attrs: {
      "icon": _vm.streamControls.audio.isMuted ? 'muted' : 'mic',
      "ghost": "",
      "alt": "",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('toggle_controls', 'audio');
      }
    }
  }), _vm.streamControls.audio && _vm.streamControls.audio.loading ? _c('div', {
    class: _vm.$style.loading
  }, [_c('Loading', {
    attrs: {
      "size": "verySmall",
      "theme": "secondary-theme"
    }
  })], 1) : _vm._e()], 1), _c('span', {
    class: _vm.$style.controlButtonWrapper
  }, [_c('IconButton', {
    attrs: {
      "icon": _vm.streamControls.video.isMuted ? 'videocam-muted' : 'videocam',
      "ghost": "",
      "alt": "",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('toggle_controls', 'video');
      }
    }
  }), _vm.streamControls.video && _vm.streamControls.video.loading ? _c('div', {
    class: _vm.$style.loading
  }, [_c('Loading', {
    attrs: {
      "size": "verySmall",
      "theme": "secondary-theme"
    }
  })], 1) : _vm._e()], 1), _vm.actionConfig.hasVideoJoinAccess ? [_vm.actionConfig.isBackstage ? _c('PillButton', {
    attrs: {
      "variant": "secondary",
      "center": "",
      "uppercase": "",
      "boldText": "",
      "size": "small",
      "disabled": _vm.canJoin
    },
    on: {
      "click": _vm.join
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Start Streaming')) + " ")]) : _c('PillButton', {
    attrs: {
      "variant": "warning",
      "center": "",
      "uppercase": "",
      "boldText": "",
      "size": "small"
    },
    on: {
      "click": () => _vm.actionConfig.hasVideoClientJoined && _vm.$emit('enter_backstage', true)
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Stop Streaming')) + " ")])] : _c('GTooltip', {
    attrs: {
      "text": _vm.$t('Streaming is not available for prerecorded and RTMP sessions')
    }
  }, [_c('PillButton', {
    attrs: {
      "variant": "secondary",
      "center": "",
      "boldText": "",
      "size": "small",
      "disabled": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Streaming not available')) + " ")])], 1)], 2)]), _c('div', {
    class: _vm.$style.collapsableStep
  }, [_c('div', {
    class: _vm.$style.center
  }, [_c('SvgIcon', {
    class: _vm.$style.tvmodegraphic,
    attrs: {
      "name": "tvmodegraphic",
      "size": "x-large",
      "color": "theme-secondary-color"
    }
  }), _c('div', {
    class: [_vm.$style.info, _vm.$style.top]
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading14",
      "color": "primary-text-color",
      "align": "left"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Set up on-site video feed')) + " ")]), _c('StyledText', {
    class: _vm.$style.info_text,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color",
      "align": "left"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(`Connect your computer to a TV screen or projector to enable your in-person attendees to see what's happening on your virtual stage; including slides, Q&A, etc. Once connected, click OPEN TV and drag or share the new window to your TV screen or projector. `)) + " ")])], 1), _c('div', {
    class: _vm.$style.tvSlotContent
  }, [_vm._t("tv")], 2)], 1), _c('div', {
    class: _vm.$style.actions
  }, [_c('IconButton', {
    attrs: {
      "icon": _vm.tvMuted ? 'faunmute' : 'volume',
      "ghost": "",
      "alt": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('muteTv');
      }
    }
  }), _c('PillButton', {
    attrs: {
      "variant": _vm.isTvModeOpen ? 'warning' : 'secondary',
      "center": "",
      "uppercase": "",
      "boldText": "",
      "size": "small"
    },
    on: {
      "click": () => _vm.$emit('toggle_tv')
    }
  }, [_vm._v(" " + _vm._s(_vm.isTvModeOpen ? _vm.$options.$t('Close TV') : _vm.$options.$t('Open TV')) + " ")])], 1)])]);
};
var LiveStreamInfoAreavue_type_template_id_458fb10f_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/HybridSetupMode/LiveStreamInfoArea.vue?vue&type=script&lang=js
/* harmony default export */ var LiveStreamInfoAreavue_type_script_lang_js = ({
  name: 'BroadcastHybridSetupMode',
  props: {
    stream: Object,
    isTvModeOpen: Boolean,
    tvMuted: Boolean,
    actionConfig: Object,
    streamControls: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    canJoin() {
      return !(this.actionConfig.hasVideoClientJoined && (!this.actionConfig.isBroadcast || !this.actionConfig.localStreamPublishInProgress) && !this.actionConfig.localStreamCreationInProgress);
    }
  },
  methods: {
    join() {
      if (this.actionConfig.hasVideoClientJoined && (!this.actionConfig.isBroadcast || !this.actionConfig.localStreamPublishInProgress) && !this.actionConfig.localStreamCreationInProgress) {
        this.$emit('join_broadcast', true);
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/LiveStreamInfoArea.vue?vue&type=script&lang=js
 /* harmony default export */ var HybridSetupMode_LiveStreamInfoAreavue_type_script_lang_js = (LiveStreamInfoAreavue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/HybridSetupMode/LiveStreamInfoArea.vue?vue&type=style&index=0&id=458fb10f&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var LiveStreamInfoAreavue_type_style_index_0_id_458fb10f_prod_module_true_lang_scss = ({"page_info":"LiveStreamInfoArea_page_info_FrKyM","fade":"LiveStreamInfoArea_fade_zp7uk","collapsableStep":"LiveStreamInfoArea_collapsableStep_kEbKw","center":"LiveStreamInfoArea_center_ipt0a","info":"LiveStreamInfoArea_info_vWVvO","tvSlotContent":"LiveStreamInfoArea_tvSlotContent_eWo7v","stretch":"LiveStreamInfoArea_stretch_F17IK","header":"LiveStreamInfoArea_header_BhhPA","actions":"LiveStreamInfoArea_actions_mpmMv","info_text":"LiveStreamInfoArea_info_text_BLt1r","player":"LiveStreamInfoArea_player_jRjcH","icon":"LiveStreamInfoArea_icon_ucRG3","controlButtonWrapper":"LiveStreamInfoArea_controlButtonWrapper_uJ2x9","loading":"LiveStreamInfoArea_loading_MoFVK","volume_level":"LiveStreamInfoArea_volume_level_m0DAX","tvmodegraphic":"LiveStreamInfoArea_tvmodegraphic_iER7Z"});
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/LiveStreamInfoArea.vue?vue&type=style&index=0&id=458fb10f&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/LiveStreamInfoArea.vue



;




function LiveStreamInfoArea_injectStyles (context) {
  
  this["$style"] = (LiveStreamInfoAreavue_type_style_index_0_id_458fb10f_prod_module_true_lang_scss.locals || LiveStreamInfoAreavue_type_style_index_0_id_458fb10f_prod_module_true_lang_scss)

}

/* normalize component */

var LiveStreamInfoArea_component = normalizeComponent(
  HybridSetupMode_LiveStreamInfoAreavue_type_script_lang_js,
  LiveStreamInfoAreavue_type_template_id_458fb10f_render,
  LiveStreamInfoAreavue_type_template_id_458fb10f_staticRenderFns,
  false,
  LiveStreamInfoArea_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LiveStreamInfoArea = (LiveStreamInfoArea_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/HybridSetupMode/HybridSetupModeSidebar.vue?vue&type=template&id=5b47147b
var HybridSetupModeSidebarvue_type_template_id_5b47147b_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.closed]: _vm.closed
    }
  }, [_c('IconButton', {
    class: _vm.$style.toggler,
    attrs: {
      "icon": "down-arrow",
      "alt": _vm.closed,
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.closed = !_vm.closed;
      }
    }
  }), _c('div', {
    class: _vm.$style.dateWrapper
  }, [(_vm.dayOptions || []).length > 1 ? _c('SimpleSelect', {
    attrs: {
      "align": "left",
      "options": _vm.dayOptions,
      "value": _vm.selectedDay
    },
    on: {
      "input": e => _vm.$emit('on-day-select', e)
    }
  }) : _vm._e()], 1), (_vm.trackOptions || []).length > 1 ? _c('AgendaFilter', {
    class: _vm.$style.track,
    attrs: {
      "options": _vm.trackOptions,
      "current": _vm.selectedTrack,
      "type": "pin"
    },
    on: {
      "select": e => _vm.$emit('on-track-select', e)
    }
  }) : _vm._e(), _c('div', {
    class: _vm.$style.agenda
  }, [_vm._l(_vm.agendaItems, function (item) {
    return [item.kind === 'date' ? _c('LabeledSeparator', {
      key: item.title
    }, [_vm._v(" " + _vm._s(item.title) + " ")]) : _c('MinimizedAgendaItem', {
      key: item.id,
      class: item.isNewBlock ? _vm.$style.newBlock : '',
      attrs: {
        "item": item,
        "isCurrent": item.id === _vm.currentBroadcast.id,
        "track": _vm.selectedTrack
      },
      on: {
        "user-clicked": function ($event) {
          return _vm.$emit('user-clicked', $event);
        },
        "show-speakers": function ($event) {
          return _vm.$emit('show-speakers', $event);
        },
        "cta-clicked": function ($event) {
          return _vm.$emit('cta-clicked', $event);
        }
      }
    })];
  })], 2)], 1);
};
var HybridSetupModeSidebarvue_type_template_id_5b47147b_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/HybridSetupMode/MinimizedAgendaItem.vue?vue&type=template&id=54b18e58
var MinimizedAgendaItemvue_type_template_id_54b18e58_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.current]: _vm.isCurrent
    }
  }, [_c('div', {
    class: _vm.$style.time
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.startTime) + " - " + _vm._s(_vm.endTime) + " ")]), _vm.item.is_live ? _c('StyledText', {
    class: _vm.$style.state,
    attrs: {
      "color": "warning",
      "variant": "heading10"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('live')) + " ")]) : _vm._e()], 1), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "heading14"
    }
  }, [_vm._v(" " + _vm._s(_vm.item.title) + " ")]), _c('StyledText', {
    class: _vm.$style.time,
    attrs: {
      "variant": "body13"
    }
  }, [_vm.track.value !== 'all' ? _c('span', [_vm._v(" " + _vm._s(_vm.track.label) + " ")]) : _vm._e(), _vm.showLocation && _vm.item.location ? [_c('span', {
    class: _vm.$style.dot
  }), _c('span', [_vm._v(" " + _vm._s(_vm.item.location) + " ")])] : _vm._e()], 2), _c('div', {
    class: _vm.$style.footer
  }, [_vm.item.speakers ? _c('div', {
    class: _vm.$style.speakers
  }, [_vm._l(_vm.item.speakers.slice(0, 3), function (user) {
    return _c('UserTooltip', {
      key: user.id,
      attrs: {
        "user": user,
        "position": "top-left"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('user-clicked', user);
        }
      }
    });
  }), _vm.item.speakers.length > 3 ? _c('div', {
    class: _vm.$style.plus,
    on: {
      "click": function ($event) {
        return _vm.$emit('show-speakers', _vm.item.speakers);
      }
    }
  }, [_c('StyledText', {
    attrs: {
      "variant": "body12"
    }
  }, [_vm._v(" +" + _vm._s(_vm.item.speakers.length - 3) + " ")])], 1) : _vm._e()], 2) : _vm._e(), _vm.item.type === 'BROADCAST' ? [_vm.isCurrent ? _c('StyledText', {
    attrs: {
      "variant": "heading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Opened')) + " ")]) : _vm.item.in_person_only ? _c('StyledText', {
    attrs: {
      "variant": "heading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('In person only')) + " ")]) : _c('PillButton', {
    attrs: {
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cta-clicked', _vm.item);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Open')) + " ")])] : _vm._e()], 2)], 1);
};
var MinimizedAgendaItemvue_type_template_id_54b18e58_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/HybridSetupMode/MinimizedAgendaItem.vue?vue&type=script&lang=js

/* harmony default export */ var MinimizedAgendaItemvue_type_script_lang_js = ({
  name: 'MinimizedAgendaItem',
  props: {
    item: Object,
    isCurrent: Boolean,
    track: {
      type: Object,
      default: () => ({})
    },
    showLocation: {
      type: Boolean,
      default: true
    },
    heartBeatDate: Date
  },
  computed: {
    startTime() {
      return timeFormatter.format(new Date(this.item.start_time));
    },
    endTime() {
      return timeFormatter.format(new Date(this.item.end_time));
    }
  },
  mounted() {
    if (this.isCurrent) {
      this.scrollIntoView();
    }
  },
  watch: {
    isCurrent(value) {
      if (value) {
        this.scrollIntoView();
      }
    }
  },
  methods: {
    scrollIntoView() {
      this.$el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/MinimizedAgendaItem.vue?vue&type=script&lang=js
 /* harmony default export */ var HybridSetupMode_MinimizedAgendaItemvue_type_script_lang_js = (MinimizedAgendaItemvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/HybridSetupMode/MinimizedAgendaItem.vue?vue&type=style&index=0&id=54b18e58&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var MinimizedAgendaItemvue_type_style_index_0_id_54b18e58_prod_module_true_lang_scss = ({"root":"MinimizedAgendaItem_root_Syq8a","current":"MinimizedAgendaItem_current_xNZa0","footer":"MinimizedAgendaItem_footer__fx26","speakers":"MinimizedAgendaItem_speakers_AowST","plus":"MinimizedAgendaItem_plus_Becsy","title":"MinimizedAgendaItem_title_AJPyY","time":"MinimizedAgendaItem_time_qlTit","dot":"MinimizedAgendaItem_dot_ElSCA","state":"MinimizedAgendaItem_state_D1Ran"});
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/MinimizedAgendaItem.vue?vue&type=style&index=0&id=54b18e58&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/MinimizedAgendaItem.vue



;




function MinimizedAgendaItem_injectStyles (context) {
  
  this["$style"] = (MinimizedAgendaItemvue_type_style_index_0_id_54b18e58_prod_module_true_lang_scss.locals || MinimizedAgendaItemvue_type_style_index_0_id_54b18e58_prod_module_true_lang_scss)

}

/* normalize component */

var MinimizedAgendaItem_component = normalizeComponent(
  HybridSetupMode_MinimizedAgendaItemvue_type_script_lang_js,
  MinimizedAgendaItemvue_type_template_id_54b18e58_render,
  MinimizedAgendaItemvue_type_template_id_54b18e58_staticRenderFns,
  false,
  MinimizedAgendaItem_injectStyles,
  null,
  null
  
)

/* harmony default export */ var MinimizedAgendaItem = (MinimizedAgendaItem_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/HybridSetupMode/HybridSetupModeSidebar.vue?vue&type=script&lang=js


/* harmony default export */ var HybridSetupModeSidebarvue_type_script_lang_js = ({
  name: 'SetupModeSidebar',
  components: {
    MinimizedAgendaItem: MinimizedAgendaItem
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    currentBroadcast: {
      type: Object,
      required: true,
      default: () => ({})
    },
    dayOptions: Array,
    selectedDay: Object,
    trackOptions: Array,
    selectedTrack: Object,
    heartBeatDate: Date
  },
  data() {
    return {
      closed: false
    };
  },
  computed: {
    agendaItems() {
      let currentLabel;
      const getLabel = ({
        is_live,
        start_time,
        end_time
      }) => {
        if (!is_live && dateIsBefore(end_time, this.heartBeatDate)) {
          return 'past';
        }
        if (!is_live && dateIsBefore(this.heartBeatDate, start_time)) {
          return 'upcoming';
        }
        return 'current';
      };
      return this.items.reduce((acc, item) => {
        if (item.kind === 'date') {
          currentLabel = null;
          return [...acc, item];
        }
        const label = getLabel(item);
        if (label != currentLabel) {
          item.isNewBlock = currentLabel !== null;
          currentLabel = label;
        }
        return [...acc, item];
      }, []);
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/HybridSetupModeSidebar.vue?vue&type=script&lang=js
 /* harmony default export */ var HybridSetupMode_HybridSetupModeSidebarvue_type_script_lang_js = (HybridSetupModeSidebarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/HybridSetupMode/HybridSetupModeSidebar.vue?vue&type=style&index=0&id=5b47147b&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var HybridSetupModeSidebarvue_type_style_index_0_id_5b47147b_prod_module_true_lang_scss = ({"root":"HybridSetupModeSidebar_root_Tg6M9","toggler":"HybridSetupModeSidebar_toggler_pyZUi","closed":"HybridSetupModeSidebar_closed_sRAvH","dateWrapper":"HybridSetupModeSidebar_dateWrapper_nNoao","track":"HybridSetupModeSidebar_track_VCc7T","agenda":"HybridSetupModeSidebar_agenda_xNwkE","newBlock":"HybridSetupModeSidebar_newBlock_FMXkl"});
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/HybridSetupModeSidebar.vue?vue&type=style&index=0&id=5b47147b&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/HybridSetupModeSidebar.vue



;




function HybridSetupModeSidebar_injectStyles (context) {
  
  this["$style"] = (HybridSetupModeSidebarvue_type_style_index_0_id_5b47147b_prod_module_true_lang_scss.locals || HybridSetupModeSidebarvue_type_style_index_0_id_5b47147b_prod_module_true_lang_scss)

}

/* normalize component */

var HybridSetupModeSidebar_component = normalizeComponent(
  HybridSetupMode_HybridSetupModeSidebarvue_type_script_lang_js,
  HybridSetupModeSidebarvue_type_template_id_5b47147b_render,
  HybridSetupModeSidebarvue_type_template_id_5b47147b_staticRenderFns,
  false,
  HybridSetupModeSidebar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var HybridSetupModeSidebar = (HybridSetupModeSidebar_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/HybridSetupMode/BroadcastHybridSetupMode.vue?vue&type=script&lang=js




/* harmony default export */ var BroadcastHybridSetupModevue_type_script_lang_js = ({
  name: 'BroadcastHybridSetupMode',
  components: {
    HybridSetupModeSidebar: HybridSetupModeSidebar,
    LiveStreamInfoArea: LiveStreamInfoArea
  },
  props: {
    broadcastsAgendaItemsAndDates: Array,
    broadcast: Object,
    stream: Object,
    actionConfig: Object,
    streamControls: {
      type: Object,
      default: () => ({})
    },
    profileLinks: {
      type: Object,
      required: true
    },
    eventLogo: {
      type: String,
      default: ''
    },
    currentUser: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      default: 'offline'
    },
    isInPerson: Boolean,
    isHybridEvent: Boolean,
    dayOptions: Array,
    selectedDay: Object,
    trackOptions: Array,
    selectedTrack: Object,
    fullPage: Boolean,
    isTvModeOpen: Boolean,
    heartBeatDate: Date,
    tvMuted: Boolean
  },
  computed: {
    broadcastLivenessStatus() {
      if (this.broadcast.is_live) {
        return this.$t('live');
      }
      if (!dateIsBefore(this.broadcast.start_time, this.heartBeatDate)) {
        return this.$t('upcoming');
      }
      if (dateIsBefore(this.broadcast.end_time, this.heartBeatDate)) {
        return this.$t('ended');
      }
      return '';
    },
    startTime() {
      return timeFormatter.format(new Date(this.broadcast.start_time));
    },
    endTime() {
      return timeFormatter.format(new Date(this.broadcast.end_time));
    }
  },
  methods: {
    openHelpDoc() {
      window.open('https://help.goldcast.io/hc/en-us/articles/4416794844571-Setting-Up-an-In-Person-and-Virtual-Hybrid-Event');
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/BroadcastHybridSetupMode.vue?vue&type=script&lang=js
 /* harmony default export */ var HybridSetupMode_BroadcastHybridSetupModevue_type_script_lang_js = (BroadcastHybridSetupModevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/HybridSetupMode/BroadcastHybridSetupMode.vue?vue&type=style&index=0&id=21c77d63&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var BroadcastHybridSetupModevue_type_style_index_0_id_21c77d63_prod_module_true_lang_scss = ({"root":"BroadcastHybridSetupMode_root_ZMKPB","fullPage":"BroadcastHybridSetupMode_fullPage_wqXAA","navbar":"BroadcastHybridSetupMode_navbar_YJmre","navItems":"BroadcastHybridSetupMode_navItems_tvhR3","state":"BroadcastHybridSetupMode_state_iyGsX","time":"BroadcastHybridSetupMode_time_vwjNn","main":"BroadcastHybridSetupMode_main_qJBZa","content":"BroadcastHybridSetupMode_content_nofPN","footer":"BroadcastHybridSetupMode_footer_GvS6L","icon":"BroadcastHybridSetupMode_icon_qj5VW"});
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/BroadcastHybridSetupMode.vue?vue&type=style&index=0&id=21c77d63&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/HybridSetupMode/BroadcastHybridSetupMode.vue



;




function BroadcastHybridSetupMode_injectStyles (context) {
  
  this["$style"] = (BroadcastHybridSetupModevue_type_style_index_0_id_21c77d63_prod_module_true_lang_scss.locals || BroadcastHybridSetupModevue_type_style_index_0_id_21c77d63_prod_module_true_lang_scss)

}

/* normalize component */

var BroadcastHybridSetupMode_component = normalizeComponent(
  HybridSetupMode_BroadcastHybridSetupModevue_type_script_lang_js,
  BroadcastHybridSetupModevue_type_template_id_21c77d63_render,
  BroadcastHybridSetupModevue_type_template_id_21c77d63_staticRenderFns,
  false,
  BroadcastHybridSetupMode_injectStyles,
  null,
  null
  
)

/* harmony default export */ var BroadcastHybridSetupMode = (BroadcastHybridSetupMode_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/SetupModeSwitch.vue?vue&type=template&id=69397735
var SetupModeSwitchvue_type_template_id_69397735_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    class: _vm.$style.root
  }, [_c('GTooltip', {
    attrs: {
      "neoDesign": true,
      "text": _vm.status ? _vm.$options.$t('Turn Off Setup Mode') : _vm.$options.$t('Setup Mode'),
      "text-color": "secondary-text-color",
      "disabled": _vm.prompt
    }
  }, [_c('IconButton', {
    attrs: {
      "icon": "setupmode",
      "ghost": "",
      "alt": _vm.status ? false : true,
      "variant": _vm.status ? 'secondary' : 'primary',
      "size": "regular"
    },
    on: {
      "click": _vm.togglePrompt
    }
  })], 1), _vm.prompt ? _c('ConfirmationDialog', {
    class: _vm.$style.confirmation,
    attrs: {
      "showDontAskAgain": false,
      "header": `${_vm.status ? _vm.$options.$t('Turn Off') : _vm.$options.$t('Turn On')} ${_vm.$options.$t(' Set Up Mode')}`,
      "bodyText": _vm.bodyText,
      "confirmationBtnText": `${_vm.status ? _vm.$options.$t('Turn Off') : _vm.$options.$t('Turn On')}`,
      "cancelBtnText": _vm.$t('Cancel'),
      "confirmationBtnVariant": _vm.status ? 'warning' : 'secondary'
    },
    on: {
      "confirm": _vm.toggleSetupMode,
      "dismiss": _vm.togglePrompt
    }
  }) : _vm._e()], 1);
};
var SetupModeSwitchvue_type_template_id_69397735_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/SetupModeSwitch.vue?vue&type=script&lang=js
/* harmony default export */ var SetupModeSwitchvue_type_script_lang_js = ({
  name: 'SetupModeSwitch',
  data() {
    return {
      prompt: false
    };
  },
  props: {
    roomTitle: String,
    status: Boolean
  },
  computed: {
    bodyText() {
      if (this.status) {
        return this.$t(`Please press turn off if you’d like to stop set up mode for {roomTitle}. Doing so will also turn off any active streams.`, {
          roomTitle: this.roomTitle
        });
      }
      return this.$t(`Preparing to stream: {roomTitle}. Please only use set up mode to stream from the live location only.`, {
        roomTitle: this.roomTitle
      });
    }
  },
  methods: {
    togglePrompt() {
      this.prompt = !this.prompt;
    },
    toggleSetupMode() {
      this.$emit('toggleSetupMode');
      this.togglePrompt();
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/SetupModeSwitch.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_SetupModeSwitchvue_type_script_lang_js = (SetupModeSwitchvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/SetupModeSwitch.vue?vue&type=style&index=0&id=69397735&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SetupModeSwitchvue_type_style_index_0_id_69397735_prod_module_true_lang_scss = ({"root":"SetupModeSwitch_root_Z_DG1","confirmation":"SetupModeSwitch_confirmation_GAhQ8"});
;// CONCATENATED MODULE: ./src/molecules/SetupModeSwitch.vue?vue&type=style&index=0&id=69397735&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/SetupModeSwitch.vue



;




function SetupModeSwitch_injectStyles (context) {
  
  this["$style"] = (SetupModeSwitchvue_type_style_index_0_id_69397735_prod_module_true_lang_scss.locals || SetupModeSwitchvue_type_style_index_0_id_69397735_prod_module_true_lang_scss)

}

/* normalize component */

var SetupModeSwitch_component = normalizeComponent(
  molecules_SetupModeSwitchvue_type_script_lang_js,
  SetupModeSwitchvue_type_template_id_69397735_render,
  SetupModeSwitchvue_type_template_id_69397735_staticRenderFns,
  false,
  SetupModeSwitch_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SetupModeSwitch = (SetupModeSwitch_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/UserProfileDropdown.vue?vue&type=template&id=3c0ea8ba
var UserProfileDropdownvue_type_template_id_3c0ea8ba_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('DropdownSetup', {
    attrs: {
      "open": _vm.open,
      "fit": ""
    },
    on: {
      "close": _vm.toggle
    }
  }, [_c('GTooltip', {
    attrs: {
      "slot": "toggler",
      "position": "bottom-right",
      "forceShowTooltip": _vm.forceShowViewAsAttendeeTooltip,
      "disabled": true
    },
    slot: "toggler"
  }, [_vm.attendeeTooltipMessage ? _c('StyledText', {
    attrs: {
      "slot": "text",
      "color": "secondary-text-color"
    },
    slot: "text"
  }, [_vm._v(" " + _vm._s(_vm.attendeeTooltipMessage) + " ")]) : _c('template', {
    slot: "text"
  }, [_vm._v(" " + _vm._s(_vm.viewAsAttendee ? _vm.$options.$t('You are now in attendee view!') : _vm.$options.$t('You are now in organizer view!')) + " "), _c('br'), _c('br'), _c('b', [_vm._v(" " + _vm._s(_vm.$options.$t('Note :')))]), _vm._v(" " + _vm._s(_vm.$options.$t('Only organizer accounts can see this tag, normal attendees can’t see this')) + " ")]), _c('div', {
    class: _vm.viewAsAttendee && _vm.$style.attendeeFlag
  }, [_c('button', {
    staticClass: "keyboard-focusable",
    class: _vm.$style.userimagecontainer,
    attrs: {
      "data-testmarker": "userprofiledropdown",
      "data-testid": "userProfileDropdown",
      "aria-haspopup": "menu",
      "aria-controls": "profileDropdown",
      "aria-label": "Event Setting Dropdown"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('UserImage', {
    class: _vm.$style.image,
    attrs: {
      "user": _vm.user,
      "size": "small"
    }
  }), _c('div', {
    class: {
      [_vm.$style.statusdot]: true,
      [_vm.$style.offline]: _vm.status === 'offline',
      [_vm.$style.online]: _vm.status === 'online'
    },
    attrs: {
      "data-testmarker": "statusdot"
    }
  })], 1), _vm.viewAsAttendee ? _c('StyledText', {
    attrs: {
      "data-testmarker": "attendeemodelabel",
      "variant": "body13",
      "color": "theme-secondary-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Attendee')) + " ")]) : _vm._e()], 1)], 2), _c('div', {
    class: {
      [_vm.$style.dropdown]: true,
      [_vm.$style.currentSection]: _vm.currentSectionIndex >= 0
    },
    attrs: {
      "slot": "dropdown",
      "id": "profileDropdown",
      "role": "menu",
      "data-branding-target": "profile-dropdown"
    },
    on: {
      "keydown": _vm.onComboKeyDown
    },
    slot: "dropdown"
  }, _vm._l(_vm.sections, function ({
    label,
    bg,
    links,
    tooltip
  }, index) {
    return _c('div', {
      key: index,
      class: {
        [_vm.$style.section]: bg
      },
      attrs: {
        "data-level": _vm.currentSectionIndex
      }
    }, [_c('div', {
      class: {
        [_vm.$style.sectionbackground]: bg
      }
    }, [label ? _c('div', {
      ref: "backButton",
      refInFor: true,
      class: [_vm.$style.link, _vm.$style.title],
      attrs: {
        "id": "menuCloseButton",
        "tabindex": "0",
        "role": "menuitem",
        "aria-label": _vm.closeButtonLabel
      },
      on: {
        "click": _vm.backToMainMenu
      }
    }, [_vm.currentSectionIndex >= 0 ? _c('SvgIcon', {
      class: _vm.$style.arrowReverse,
      attrs: {
        "name": "down-arrow",
        "size": "small"
      }
    }) : _vm._e(), _c('span', {
      class: _vm.$style.textWrapper
    }, [_c('StyledText', {
      class: _vm.$style.text,
      attrs: {
        "variant": "body14",
        "color": "primary-text-color"
      }
    }, [_vm._v(" " + _vm._s(label) + " ")]), tooltip ? _c('GTooltip', {
      attrs: {
        "position": "bottom-center",
        "forceShowTooltip": _vm.currentActiveElementId === 'menuCloseButton'
      }
    }, [_c('SvgIcon', {
      class: _vm.$style.icon,
      attrs: {
        "name": "alert",
        "size": "small"
      }
    }), _c('span', {
      attrs: {
        "slot": "text"
      },
      domProps: {
        "innerHTML": _vm._s(tooltip)
      },
      slot: "text"
    })], 1) : _vm._e()], 1), _c('span')], 1) : _vm._e(), _vm._l(links, function (link, i) {
      return _c('div', {
        key: i,
        class: _vm.$style.link,
        attrs: {
          "id": 'menuItem' + index + i,
          "data-testmarker": link.testmarker,
          "aria-label": link.ariaLabel ? link.ariaLabel : null,
          "aria-haspopup": !!link.links,
          "aria-expanded": _vm.dropdownLabel(link, index),
          "role": "menuitem",
          "tabindex": "0"
        },
        on: {
          "focusin": function ($event) {
            _vm.currentActiveElementId = 'menuItem' + index + i;
          },
          "click": function ($event) {
            return _vm.openLink(link, index, i);
          }
        }
      }, [_c('span', {
        class: _vm.$style.textWrapper
      }, [link.showEllipsisTip ? _c('GTooltip', {
        attrs: {
          "text": link.label,
          "containerWidth": true
        }
      }, [_c('StyledText', {
        class: _vm.$style.ellipsisText,
        attrs: {
          "variant": "body14",
          "color": "primary-text-color"
        }
      }, [_vm._v(" " + _vm._s(link.label) + " ")])], 1) : _c('StyledText', {
        class: _vm.$style.text,
        attrs: {
          "variant": "body14",
          "color": "primary-text-color"
        }
      }, [_vm._v(" " + _vm._s(link.label) + " ")]), link.tooltip ? _c('GTooltip', {
        class: _vm.$style.icon,
        attrs: {
          "text": link.tooltip,
          "forceShowTooltip": _vm.currentActiveElementId === 'menuItem' + index + i
        }
      }, [_c('SvgIcon', {
        attrs: {
          "name": "alert",
          "size": "small"
        }
      })], 1) : _vm._e()], 1), link.type === 'toggle' ? _c('GToggle', {
        attrs: {
          "active": link.selected,
          "icon": "record"
        }
      }) : link.type === 'button' ? _c('PillButton', {
        attrs: {
          "size": "x-small",
          "center": "",
          "allowMultiLine": ""
        }
      }, [link.buttonText && link.tooltipInfo ? _c('GTooltip', {
        class: [_vm.$style.icon],
        attrs: {
          "text": link.tooltipInfo,
          "position": "bottom-right"
        }
      }, [_vm._v(_vm._s(link.buttonText))]) : _c('span', [_vm._v(" " + _vm._s(link.buttonText))])], 1) : link.value || link.value === 0 ? _c('StyledText', {
        attrs: {
          "variant": "body14",
          "color": "theme-secondary-color"
        }
      }, [_vm._v(" " + _vm._s(link.value) + " ")]) : link.type === 'tick' ? [link.selected ? _c('SvgIcon', {
        attrs: {
          "name": "tick",
          "size": "small",
          "color": "theme-secondary-color"
        }
      }) : _vm._e()] : link.type === 'icon-action' ? _c('IconButton', {
        attrs: {
          "icon": link.icon,
          "alt": link.alt,
          "variant": link.variant,
          "tabIndex": -1,
          "size": link.size
        },
        on: {
          "click": () => {}
        }
      }) : link.type == 'textButton' ? _c('StyledText', {
        class: _vm.$style.textButton,
        attrs: {
          "variant": "body14",
          "color": "theme-secondary-color"
        }
      }, [_vm._v(" " + _vm._s(link.text) + " ")]) : link.links ? _c('SvgIcon', {
        class: _vm.$style.arrow,
        attrs: {
          "name": "down-arrow",
          "size": "small"
        }
      }) : _vm._e()], 2);
    })], 2)]);
  }), 0)], 1);
};
var UserProfileDropdownvue_type_template_id_3c0ea8ba_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/UserProfileDropdown.vue?vue&type=script&lang=js

/* harmony default export */ var UserProfileDropdownvue_type_script_lang_js = ({
  name: 'UserProfileDropdown',
  props: {
    links: {
      type: Array,
      default: () => []
    },
    eventInformationLinks: {
      type: Array,
      default: () => []
    },
    bottomLinks: {
      type: Array,
      default: () => []
    },
    user: {
      type: Object,
      requried: true
    },
    viewAsAttendee: {
      type: Boolean,
      required: true
    },
    forceShowViewAsAttendeeTooltip: {
      type: Boolean,
      default: false
    },
    attendeeTooltipMessage: String,
    status: String,
    open: Boolean
  },
  data() {
    return {
      currentSectionIndex: -1,
      currentSectionLinkIndex: -1,
      lastActiveElement: null,
      currentActiveElementId: '',
      searchString: '',
      searchTimeout: null
    };
  },
  methods: {
    toggle() {
      if (!this.open) {
        this.focusFirstElement();
      }
      this.$emit('userDropDownToggle', !this.open);
      this.currentSectionIndex = -1;
    },
    openLink(link, sectionIndex, linkIndex) {
      if (link.action) {
        this.toggle();
        link.action();
      } else if (link.links) {
        this.lastActiveElement = document.activeElement.getAttribute('id');
        this.currentSectionIndex = sectionIndex;
        this.currentSectionLinkIndex = linkIndex;
        this.focusFirstElement();
      }
    },
    backToMainMenu() {
      this.currentSectionIndex = -1;
      this.$nextTick(() => {
        document.querySelector(`#${this.lastActiveElement}`)?.focus();
      });
    },
    onComboKeyDown(event) {
      const {
        key,
        altKey,
        ctrlKey,
        metaKey,
        shiftKey
      } = event;
      const allFocusableElements = this.$el.querySelectorAll('[role="menuitem"]');
      const hasSubMenu = document.activeElement.getAttribute('aria-haspopup');
      const isBackButton = this.$refs?.backButton?.[0] === document.activeElement;
      if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Tab') {
        event.preventDefault();
        if (allFocusableElements.length > 0) {
          const currentFocusIndex = Array.from(allFocusableElements).findIndex(element => element === document.activeElement);
          if (currentFocusIndex >= 0) {
            let nextFocusIndex = currentFocusIndex;
            if (key === 'ArrowDown' || key === 'Tab' && !shiftKey) {
              nextFocusIndex = currentFocusIndex + 1;
            } else if (key === 'ArrowUp' || key === 'Tab' && shiftKey) {
              nextFocusIndex = currentFocusIndex - 1;
            }
            if (nextFocusIndex < 0) {
              nextFocusIndex = allFocusableElements.length - 1;
            } else if (nextFocusIndex >= allFocusableElements.length) {
              nextFocusIndex = 0;
            }
            allFocusableElements?.[nextFocusIndex]?.focus();
          }
        }
      } else if (key === 'Enter' || key === ' ' && hasSubMenu !== 'true' && isBackButton) {
        document.activeElement.click();
      } else if ((key === 'ArrowRight' || key === 'Enter' || key === ' ') && hasSubMenu === 'true') {
        this.lastActiveElement = document.activeElement.getAttribute('id');
        document.activeElement.click();
      } else if ((key === 'ArrowLeft' || key === 'Enter' || key === ' ') && isBackButton) {
        document.activeElement.click();
      } else if (key === 'Escape') {
        if (this.currentSectionIndex >= 0) {
          this.backToMainMenu();
        } else {
          this.toggle();
        }
      } else if (key === 'Backspace' || key === 'Clear' || key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey) {
        const searchString = this.getSearchString(key);
        const labels = this.sections.reduce((acc, section) => {
          return [...acc, ...section.links.map(link => link.label)];
        }, []);
        const searchIndex = this.getIndexByLetter(labels, searchString);
        if (searchIndex >= 0) {
          const allLinks = document.querySelectorAll('[id*="menuItem"]');
          allLinks[searchIndex]?.focus();
        } else {
          window.clearTimeout(this.searchTimeout);
          this.searchString = '';
        }
      }
    },
    getSearchString(char) {
      if (typeof this.searchTimeout === 'number') {
        window.clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = window.setTimeout(() => {
        this.searchString = '';
      }, 500);
      this.searchString += char;
      return this.searchString;
    },
    getIndexByLetter(options, filter, startIndex = 0) {
      const orderedOptions = [...options.slice(startIndex), ...options.slice(0, startIndex)];
      const firstMatch = this.filterOptions(orderedOptions, filter)[0];
      const allSameLetter = array => array.every(letter => letter === array[0]);
      if (firstMatch) {
        return options.indexOf(firstMatch);
      }
      if (allSameLetter(filter.split(''))) {
        const matches = this.filterOptions(orderedOptions, filter[0]);
        return options.indexOf(matches[0]);
      }
      return -1;
    },
    filterOptions(options = [], filter, exclude = []) {
      return options.filter(option => {
        const matches = option.toLowerCase().indexOf(filter.toLowerCase()) === 0;
        return matches && exclude.indexOf(option) < 0;
      });
    },
    focusFirstElement() {
      this.$nextTick(() => {
        const allFocusableElements = document.querySelector('#profileDropdown').querySelectorAll('[role="menuitem"]');
        if (allFocusableElements.length > 0) {
          setTimeout(() => {
            allFocusableElements[0]?.focus();
          }, 0);
        }
      });
    }
  },
  computed: {
    sections() {
      const sections = [];
      sections.push({
        links: this.links
      });
      if (this.eventInformationLinks?.length > 0) {
        let label = 'Event Information';
        let tooltip = 'Event Information is only visible to organizers! <br /> This section is not visible to attendees';
        if (this.$t) {
          label = this.$t(label);
          tooltip = this.$t(tooltip);
        }
        sections.push({
          label,
          links: this.eventInformationLinks.map(link => ({
            ...link,
            bg: true
          })),
          bg: true,
          tooltip
        });
      }
      if (this.bottomLinks?.length > 0) {
        sections.push({
          links: this.bottomLinks.map(link => ({
            ...link
          }))
        });
      }
      if (this.currentSectionIndex >= 0) {
        const currentSection = sections[this.currentSectionIndex];
        const currentLink = currentSection.links[this.currentSectionLinkIndex];
        return [currentLink];
      }
      return sections;
    },
    closeButtonLabel() {
      return this.currentSectionIndex >= 0 ? 'Go Back to main menu' : null;
    },
    dropdownLabel() {
      return (link, index) => {
        return link.links ? this.scurrentSectionIndex === index ? 'true' : 'false' : null;
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/UserProfileDropdown.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_UserProfileDropdownvue_type_script_lang_js = (UserProfileDropdownvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/UserProfileDropdown.vue?vue&type=style&index=0&id=3c0ea8ba&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var UserProfileDropdownvue_type_style_index_0_id_3c0ea8ba_prod_lang_scss_module_true = ({"userimagecontainer":"UserProfileDropdown_userimagecontainer_j_MZe","statusdot":"UserProfileDropdown_statusdot_KMOeb","online":"UserProfileDropdown_online_sMqem","offline":"UserProfileDropdown_offline_lNP0r","attendeeFlag":"UserProfileDropdown_attendeeFlag_MjLti","dropdown":"UserProfileDropdown_dropdown_V58wY","textButton":"UserProfileDropdown_textButton_nORFc","link":"UserProfileDropdown_link_juUo9","textWrapper":"UserProfileDropdown_textWrapper_d6MYw","text":"UserProfileDropdown_text_MuMbU","ellipsisText":"UserProfileDropdown_ellipsisText_m2BS3","icon":"UserProfileDropdown_icon_UsULW","arrow":"UserProfileDropdown_arrow_g_FDg","arrowReverse":"UserProfileDropdown_arrowReverse_FtvYg","section":"UserProfileDropdown_section_AGTzy","sectionbackground":"UserProfileDropdown_sectionbackground_SQBtx","currentSection":"UserProfileDropdown_currentSection_l9Kgf","title":"UserProfileDropdown_title_Hmfag","currentOption":"UserProfileDropdown_currentOption_jxQsf"});
;// CONCATENATED MODULE: ./src/molecules/UserProfileDropdown.vue?vue&type=style&index=0&id=3c0ea8ba&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/molecules/UserProfileDropdown.vue



;




function UserProfileDropdown_injectStyles (context) {
  
  this["$style"] = (UserProfileDropdownvue_type_style_index_0_id_3c0ea8ba_prod_lang_scss_module_true.locals || UserProfileDropdownvue_type_style_index_0_id_3c0ea8ba_prod_lang_scss_module_true)

}

/* normalize component */

var UserProfileDropdown_component = normalizeComponent(
  molecules_UserProfileDropdownvue_type_script_lang_js,
  UserProfileDropdownvue_type_template_id_3c0ea8ba_render,
  UserProfileDropdownvue_type_template_id_3c0ea8ba_staticRenderFns,
  false,
  UserProfileDropdown_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UserProfileDropdown = (UserProfileDropdown_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/FavoriteButton.vue?vue&type=template&id=6240d348
var FavoriteButtonvue_type_template_id_6240d348_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('GTooltip', {
    attrs: {
      "text": _vm.tooltipText,
      "position": "bottom-right"
    }
  }, [_c('IconButton', {
    attrs: {
      "role": "switch",
      "ariaChecked": _vm.isFavorited ? 'true' : 'false',
      "aria-label": _vm.tooltipText,
      "icon": _vm.isFavorited ? 'heart' : 'heart-outlined',
      "ghost": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  })], 1);
};
var FavoriteButtonvue_type_template_id_6240d348_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/FavoriteButton.vue?vue&type=script&lang=js
/* harmony default export */ var FavoriteButtonvue_type_script_lang_js = ({
  name: 'FavoriteButton',
  props: {
    isFavorited: Boolean
  },
  computed: {
    tooltipText() {
      if (this.isFavorited) {
        return this.$t('Remove from favorites');
      }
      return this.$t('Add to favorites');
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/FavoriteButton.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_FavoriteButtonvue_type_script_lang_js = (FavoriteButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/FavoriteButton.vue?vue&type=style&index=0&id=6240d348&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var FavoriteButtonvue_type_style_index_0_id_6240d348_prod_module_true_lang_scss = ({"switch":"FavoriteButton_switch_dG1fL"});
;// CONCATENATED MODULE: ./src/molecules/FavoriteButton.vue?vue&type=style&index=0&id=6240d348&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/FavoriteButton.vue



;




function FavoriteButton_injectStyles (context) {
  
  this["$style"] = (FavoriteButtonvue_type_style_index_0_id_6240d348_prod_module_true_lang_scss.locals || FavoriteButtonvue_type_style_index_0_id_6240d348_prod_module_true_lang_scss)

}

/* normalize component */

var FavoriteButton_component = normalizeComponent(
  molecules_FavoriteButtonvue_type_script_lang_js,
  FavoriteButtonvue_type_template_id_6240d348_render,
  FavoriteButtonvue_type_template_id_6240d348_staticRenderFns,
  false,
  FavoriteButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var FavoriteButton = (FavoriteButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/MuteButton.vue?vue&type=template&id=6890387a
var MuteButtonvue_type_template_id_6890387a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('GTooltip', {
    attrs: {
      "text": "Session audio is muted. Click on the icon to unmute.",
      "forceShowTooltip": _vm.showToolTipInfo,
      "disabled": !_vm.showToolTipInfo,
      "position": "top-right"
    }
  }, [_c('IconButton', {
    attrs: {
      "icon": _vm.muted ? 'faunmute' : 'volume',
      "variant": _vm.muted ? 'highlight' : 'primary',
      "role": "switch",
      "ariaChecked": _vm.muted ? 'true' : 'false',
      "aria-label": _vm.$t(_vm.tooltipLabel),
      "alt": !_vm.muted,
      "ghost": !_vm.muted
    },
    on: {
      "click": _vm.toggleMute
    }
  })], 1);
};
var MuteButtonvue_type_template_id_6890387a_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/MuteButton.vue?vue&type=script&lang=js
/* harmony default export */ var MuteButtonvue_type_script_lang_js = ({
  name: 'MuteButton',
  data() {
    return {
      showToolTip: false
    };
  },
  props: {
    muted: Boolean
  },
  mounted() {
    if (this.muted) {
      this.toggleShowInfo();
    }
  },
  computed: {
    showToolTipInfo() {
      if (!this.showToolTip) {
        return false;
      }
      if (!this.muted) {
        return false;
      }
      return true;
    },
    tooltipLabel() {
      return this.muted ? 'Turn on Audio' : 'Turn off Audio';
    }
  },
  methods: {
    toggleMute() {
      this.showToolTip = false;
      this.toggleShowInfo();
      this.$emit('toggleMute');
    },
    toggleShowInfo() {
      setTimeout(() => {
        this.showToolTip = true;
      }, 10000);
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/MuteButton.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_MuteButtonvue_type_script_lang_js = (MuteButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/molecules/MuteButton.vue





/* normalize component */
;
var MuteButton_component = normalizeComponent(
  molecules_MuteButtonvue_type_script_lang_js,
  MuteButtonvue_type_template_id_6890387a_render,
  MuteButtonvue_type_template_id_6890387a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MuteButton = (MuteButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/StageLayoutsOptions.vue?vue&type=template&id=9ecad356
var StageLayoutsOptionsvue_type_template_id_9ecad356_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('SimpleSelect', {
    staticClass: "layout-dropdown",
    attrs: {
      "settings": _vm.settings,
      "options": _vm.getOptions,
      "value": {
        value: _vm.controls.layout
      },
      "text": "LAYOUTS",
      "align": _vm.getAlignment,
      "verticalPosition": "top",
      "fullHeight": true
    },
    on: {
      "input": event => _vm.$emit('layoutChange', event.value)
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('StyledText', {
          attrs: {
            "color": "theme-secondary-color",
            "variant": "body14"
          }
        }, [_vm._v(" Layout ")])];
      },
      proxy: true
    }, {
      key: "setting",
      fn: function ({
        setting
      }) {
        return [_c('div', {
          class: _vm.$style.setting
        }, [_c('GToggle', {
          attrs: {
            "icon": "",
            "active": setting.active
          },
          on: {
            "toggle": setting.action
          }
        }), _c('span', [_vm._v(_vm._s(setting.label))])], 1), _c('div', {
          class: _vm.$style.separator
        })];
      }
    }, {
      key: "text",
      fn: function ({
        text
      }) {
        return [_c('StyledText', {
          attrs: {
            "variant": "body11",
            "color": "theme-secondary-color"
          }
        }, [_vm._v(" " + _vm._s(text) + " ")])];
      }
    }, {
      key: "option",
      fn: function ({
        selected,
        option
      }) {
        return [_c('div', {
          class: _vm.$style.option
        }, [_c('SimpleRadioButton', {
          attrs: {
            "selected": selected,
            "color": "theme-secondary-color"
          }
        }), _c('span', {
          class: _vm.$style.optionLabel
        }, [_vm._v(_vm._s(option.label))]), _c('SvgIcon', {
          class: _vm.$style.icon,
          attrs: {
            "name": _vm.getIconName(option.value),
            "color": "theme-secondary-color",
            "size": "medium"
          }
        })], 1)];
      }
    }])
  }, [_c('span', {
    attrs: {
      "slot": "setting"
    },
    slot: "setting"
  }), _c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }), _c('span', {
    attrs: {
      "slot": "option"
    },
    slot: "option"
  })]);
};
var StageLayoutsOptionsvue_type_template_id_9ecad356_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/GToggle.vue?vue&type=template&id=5a458f02&functional=true
var GTogglevue_type_template_id_5a458f02_functional_true_render = function render(_c, _vm) {
  return _c('span', {
    class: [_vm.$style.root, _vm.props.active && _vm.$style.active, _vm.props.disabled && _vm.$style.disabled],
    on: {
      "click": function ($event) {
        !_vm.disabled && _vm.listeners.toggle && _vm.listeners.toggle();
      }
    }
  }, [_c('span', {
    class: _vm.$style.toggleButton
  }, [_c('SvgIcon', {
    class: _vm.$style.toggleIcon,
    attrs: {
      "size": "x-small",
      "name": _vm.props.icon
    }
  })], 1)]);
};
var GTogglevue_type_template_id_5a458f02_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/GToggle.vue?vue&type=script&lang=js
/* harmony default export */ var GTogglevue_type_script_lang_js = ({
  functional: true,
  name: 'GToggle',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'wifi'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/GToggle.vue?vue&type=script&lang=js
 /* harmony default export */ var components_GTogglevue_type_script_lang_js = (GTogglevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/GToggle.vue?vue&type=style&index=0&id=5a458f02&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var GTogglevue_type_style_index_0_id_5a458f02_prod_module_true_lang_scss = ({"root":"GToggle_root_SGh9Y","toggleButton":"GToggle_toggleButton_TqV5D","toggleIcon":"GToggle_toggleIcon_WD6Jk","disabled":"GToggle_disabled_l_oyS","active":"GToggle_active_wPQdP"});
;// CONCATENATED MODULE: ./src/components/GToggle.vue?vue&type=style&index=0&id=5a458f02&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/GToggle.vue



;




function GToggle_injectStyles (context) {
  
  this["$style"] = (GTogglevue_type_style_index_0_id_5a458f02_prod_module_true_lang_scss.locals || GTogglevue_type_style_index_0_id_5a458f02_prod_module_true_lang_scss)

}

/* normalize component */

var GToggle_component = normalizeComponent(
  components_GTogglevue_type_script_lang_js,
  GTogglevue_type_template_id_5a458f02_functional_true_render,
  GTogglevue_type_template_id_5a458f02_functional_true_staticRenderFns,
  true,
  GToggle_injectStyles,
  null,
  null
  
)

/* harmony default export */ var GToggle = (GToggle_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/StageLayoutsOptions.vue?vue&type=script&lang=js

/* harmony default export */ var StageLayoutsOptionsvue_type_script_lang_js = ({
  name: 'StageLayoutsOptions',
  components: {
    GToggle: GToggle
  },
  props: {
    controls: {
      type: Object,
      default: () => ({
        publishedStage: {},
        isHlsStreamAvailable: false
      })
    }
  },
  data() {
    return {
      options: [{
        label: this.controls.isHlsStreamAvailable ? 'No Video' : 'No Speaker Videos',
        value: 'NO_SPEAKER_VIDEOS',
        type: 'both'
      }, {
        label: 'Left of screen',
        value: 'FLOATING',
        type: 'both'
      }, {
        label: 'Split Screen (16:9)',
        value: 'FLEX_16_9',
        type: 'both'
      }, {
        label: 'Split Screen (Fill)',
        value: 'FLEX',
        type: 'both'
      }, {
        label: 'Under Screen',
        value: 'UNDER_SCREEN',
        type: 'both'
      }
      // {
      //   label: "On top of stage content",
      //   value: "TOP_OF_VIDEO",
      //   type: "both"
      // },
      ]
    };
  },

  methods: {
    handleAllSpeakerToggle() {
      this.controls.showSingleSpeaker = !this.controls.showSingleSpeaker;
      this.$emit('changeShowAllSpeakerSelection', this.controls.showSingleSpeaker);
    },
    handleRoundSpeakerToggle() {
      this.controls.hasRoundedVideo = !this.controls.hasRoundedVideo;
      this.$emit('changeRoundedVideoSelection', this.controls.hasRoundedVideo);
    },
    getIconName(layoutName) {
      let stageLayoutName = `layout-${layoutName.replace(/_/g, '-').toLowerCase()}`;
      if (!this.controls.showSingleSpeaker) {
        stageLayoutName += `-all`;
      }
      if (this.controls.hasRoundedVideo) {
        stageLayoutName += `-round`;
      }
      return stageLayoutName;
    },
    isMobile() {
      return window.mobileCheck && window.mobileCheck();
    }
  },
  computed: {
    getOptions() {
      return this.options.filter(option => option.type === 'both' || this.controls.showSingleSpeaker && option.type === 'show_single_speaker');
    },
    getAlignment() {
      return this.isMobile() ? 'center' : 'right';
    },
    settings() {
      if (this.controls.isHlsStreamAvailable) {
        return [];
      }
      return [{
        label: 'Show only active speaker',
        value: 'show_active_speaker_only',
        action: () => this.handleAllSpeakerToggle(),
        active: this.controls.showSingleSpeaker
      }, {
        label: 'Round speaker video',
        value: 'round_speaker_video',
        action: () => this.handleRoundSpeakerToggle(),
        active: this.controls.hasRoundedVideo
      }];
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/StageLayoutsOptions.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_StageLayoutsOptionsvue_type_script_lang_js = (StageLayoutsOptionsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/StageLayoutsOptions.vue?vue&type=style&index=0&id=9ecad356&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var StageLayoutsOptionsvue_type_style_index_0_id_9ecad356_prod_module_true_lang_scss = ({"root":"StageLayoutsOptions_root_psEtW","layout-dropdown":"StageLayoutsOptions_layout-dropdown_wR9Gk","setting":"StageLayoutsOptions_setting_aWhLs","option":"StageLayoutsOptions_option_zA_MM","icon":"StageLayoutsOptions_icon_mAVGV"});
;// CONCATENATED MODULE: ./src/molecules/StageLayoutsOptions.vue?vue&type=style&index=0&id=9ecad356&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/StageLayoutsOptions.vue



;




function StageLayoutsOptions_injectStyles (context) {
  
  this["$style"] = (StageLayoutsOptionsvue_type_style_index_0_id_9ecad356_prod_module_true_lang_scss.locals || StageLayoutsOptionsvue_type_style_index_0_id_9ecad356_prod_module_true_lang_scss)

}

/* normalize component */

var StageLayoutsOptions_component = normalizeComponent(
  molecules_StageLayoutsOptionsvue_type_script_lang_js,
  StageLayoutsOptionsvue_type_template_id_9ecad356_render,
  StageLayoutsOptionsvue_type_template_id_9ecad356_staticRenderFns,
  false,
  StageLayoutsOptions_injectStyles,
  null,
  null
  
)

/* harmony default export */ var StageLayoutsOptions = (StageLayoutsOptions_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/ArrowWithCircleBg.vue?vue&type=template&id=060b618a
var ArrowWithCircleBgvue_type_template_id_060b618a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.$style[_vm.direction]],
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.move.apply(null, arguments);
      }
    }
  }, [_c('div', {
    class: _vm.$style.icon
  }, [_c('SvgIcon', {
    attrs: {
      "name": "down-arrow",
      "color": "color-variant-medium-5",
      "size": "small"
    }
  })], 1)]);
};
var ArrowWithCircleBgvue_type_template_id_060b618a_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/ArrowWithCircleBg.vue?vue&type=script&lang=js
/* harmony default export */ var ArrowWithCircleBgvue_type_script_lang_js = ({
  name: 'ArrowWithCircleBg',
  props: {
    /**
     * @prop Can be one of down, up, left and right
     */
    direction: {
      type: String,
      default: 'down'
    }
  },
  methods: {
    move() {
      this.$emit('move');
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/ArrowWithCircleBg.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_ArrowWithCircleBgvue_type_script_lang_js = (ArrowWithCircleBgvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/ArrowWithCircleBg.vue?vue&type=style&index=0&id=060b618a&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ArrowWithCircleBgvue_type_style_index_0_id_060b618a_prod_module_true_lang_scss = ({"root":"ArrowWithCircleBg_root_ArNIs","icon":"ArrowWithCircleBg_icon_ISYYV","up":"ArrowWithCircleBg_up_b2SOh","left":"ArrowWithCircleBg_left_X0qPs","right":"ArrowWithCircleBg_right_M0Za5"});
;// CONCATENATED MODULE: ./src/molecules/ArrowWithCircleBg.vue?vue&type=style&index=0&id=060b618a&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/ArrowWithCircleBg.vue



;




function ArrowWithCircleBg_injectStyles (context) {
  
  this["$style"] = (ArrowWithCircleBgvue_type_style_index_0_id_060b618a_prod_module_true_lang_scss.locals || ArrowWithCircleBgvue_type_style_index_0_id_060b618a_prod_module_true_lang_scss)

}

/* normalize component */

var ArrowWithCircleBg_component = normalizeComponent(
  molecules_ArrowWithCircleBgvue_type_script_lang_js,
  ArrowWithCircleBgvue_type_template_id_060b618a_render,
  ArrowWithCircleBgvue_type_template_id_060b618a_staticRenderFns,
  false,
  ArrowWithCircleBg_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ArrowWithCircleBg = (ArrowWithCircleBg_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/ScrollCompWithTopBottomArrow.vue?vue&type=template&id=6782a2ba
var ScrollCompWithTopBottomArrowvue_type_template_id_6782a2ba_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.showMoveUpBtn ? _c('ArrowWithCircleBg', {
    class: _vm.$style.iconTop,
    attrs: {
      "direction": "up"
    },
    on: {
      "move": _vm.moveUp
    }
  }) : _vm._e(), _c('div', {
    ref: "scrollContainer",
    class: _vm.$style.scrollContainer,
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    ref: "resizeObserverRef"
  }, [_vm._t("scrollContent")], 2)]), _vm.showMoveDownBtn ? _c('ArrowWithCircleBg', {
    class: _vm.$style.iconBottom,
    on: {
      "move": _vm.moveDown
    }
  }) : _vm._e()], 1);
};
var ScrollCompWithTopBottomArrowvue_type_template_id_6782a2ba_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/utils/scroll.js
const scrollToPosition = (element, scrollPixels, scrollPos, duration = 800, direction) => {
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
  window.requestAnimationFrame(function scroll(timestamp) {
    const timeElapsed = timestamp - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    element[direction] = scrollPos + scrollPixels * progress;
    if (timeElapsed < duration) {
      window.requestAnimationFrame(scroll);
    } else {
      return;
    }
  });
};
const scrollToTopBottom = (element, scrollPixels, duration) => {
  const scrollPos = element.scrollTop;
  // Condition to check if scrolling is required
  let isTabScrollable = (scrollPos === 0 || scrollPixels > 0) && (element.clientHeight + scrollPos === element.scrollHeight || scrollPixels < 0);
  if (!isTabScrollable) {
    scrollToPosition(element, scrollPixels, scrollPos, duration, 'scrollTop');
  }
};
const scrollToLeftRight = (element, scrollPixels, duration) => {
  const scrollPos = element.scrollLeft;
  // Condition to check if scrolling is required
  let isTabScrollable = (scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0);
  if (!isTabScrollable) {
    scrollToPosition(element, scrollPixels, scrollPos, duration, 'scrollLeft');
  }
};
const scrollToElement = (element, position, behaviour) => {
  try {
    {
      if (position === undefined) {
        position = 'start';
      }
      if (behaviour === undefined) {
        behaviour = 'smooth';
      }
      element.scrollIntoView({
        block: position,
        behavior: behaviour
      });
    }
  } catch (e) {
    //eslint-disable-next-line
    console.log('Error in scrollIntoView', e);
  }
};
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/ScrollCompWithTopBottomArrow.vue?vue&type=script&lang=js


/* harmony default export */ var ScrollCompWithTopBottomArrowvue_type_script_lang_js = ({
  name: 'ScrollCompWithTopBottomArrow',
  data() {
    return {
      showMoveUpBtn: false,
      showMoveDownBtn: true
    };
  },
  methods: {
    updateShowBottom() {
      this.$nextTick(() => {
        if (this.$refs.scrollContainer) {
          const scrolledToFarBottom = this.isScrolledToFarBottom();
          let enoughTabsForScroll = this.$refs.scrollContainer.scrollHeight - this.$refs.scrollContainer.clientHeight > 10;
          this.showMoveDownBtn = !scrolledToFarBottom && enoughTabsForScroll;
        }
      });
    },
    handleScroll() {
      if (this.$refs.scrollContainer) {
        let scrollPos = Math.round(this.$refs.scrollContainer.scrollTop);
        let scrolledToFarTop = scrollPos == 0;
        if (scrolledToFarTop) {
          this.showMoveUpBtn = false;
        } else {
          this.showMoveUpBtn = true;
        }
        const scrolledToFarBottom = this.isScrolledToFarBottom();
        if (scrolledToFarBottom) {
          this.showMoveDownBtn = false;
        } else {
          this.showMoveDownBtn = true;
        }
      }
    },
    isScrolledToFarBottom() {
      const scrollPos = Math.round(this.$refs.scrollContainer?.scrollTop);
      const scrolledToFarBottom = this.$refs.scrollContainer.clientHeight + scrollPos >= this.$refs.scrollContainer.scrollHeight;
      return scrolledToFarBottom;
    },
    moveDown() {
      const content = this.$refs.scrollContainer;
      scrollToTopBottom(content, content?.getBoundingClientRect().height - 50, 800);
    },
    moveUp() {
      const content = this.$refs.scrollContainer;
      let scrollPixels = content?.getBoundingClientRect().height - 50;
      scrollToTopBottom(content, -scrollPixels, 800);
    }
  },
  mounted() {
    this.observer = new resizeobserverimport(entries => {
      entries.forEach(() => {
        this.updateShowBottom();
      });
    });
    this.observer.observe(this.$refs.resizeObserverRef);
    setTimeout(() => {
      this.updateShowBottom();
    }, 100);
  },
  beforeDestroy() {
    this.observer.unobserve(this.$refs.resizeObserverRef);
  }
});
;// CONCATENATED MODULE: ./src/molecules/ScrollCompWithTopBottomArrow.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_ScrollCompWithTopBottomArrowvue_type_script_lang_js = (ScrollCompWithTopBottomArrowvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/ScrollCompWithTopBottomArrow.vue?vue&type=style&index=0&id=6782a2ba&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ScrollCompWithTopBottomArrowvue_type_style_index_0_id_6782a2ba_prod_module_true_lang_scss = ({"root":"ScrollCompWithTopBottomArrow_root_SroHO","scrollContainer":"ScrollCompWithTopBottomArrow_scrollContainer_MtxZY","iconTop":"ScrollCompWithTopBottomArrow_iconTop_v2078","iconBottom":"ScrollCompWithTopBottomArrow_iconBottom_r9qOg"});
;// CONCATENATED MODULE: ./src/molecules/ScrollCompWithTopBottomArrow.vue?vue&type=style&index=0&id=6782a2ba&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/ScrollCompWithTopBottomArrow.vue



;




function ScrollCompWithTopBottomArrow_injectStyles (context) {
  
  this["$style"] = (ScrollCompWithTopBottomArrowvue_type_style_index_0_id_6782a2ba_prod_module_true_lang_scss.locals || ScrollCompWithTopBottomArrowvue_type_style_index_0_id_6782a2ba_prod_module_true_lang_scss)

}

/* normalize component */

var ScrollCompWithTopBottomArrow_component = normalizeComponent(
  molecules_ScrollCompWithTopBottomArrowvue_type_script_lang_js,
  ScrollCompWithTopBottomArrowvue_type_template_id_6782a2ba_render,
  ScrollCompWithTopBottomArrowvue_type_template_id_6782a2ba_staticRenderFns,
  false,
  ScrollCompWithTopBottomArrow_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ScrollCompWithTopBottomArrow = (ScrollCompWithTopBottomArrow_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/ScrollCompWithLeftRightArrow.vue?vue&type=template&id=00b5849c
var ScrollCompWithLeftRightArrowvue_type_template_id_00b5849c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.showMoveLeftBtn ? _c('ArrowWithCircleBg', {
    class: _vm.$style.iconLeft,
    attrs: {
      "direction": "left"
    },
    on: {
      "move": _vm.moveLeft
    }
  }) : _vm._e(), _c('div', {
    ref: "scrollContainer",
    class: _vm.$style.scrollContainer,
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    ref: "resizeObserverRef",
    class: _vm.$style.resizeObserverDiv
  }, [_vm._t("scrollContentLeftToRight")], 2)]), _vm.showMoveRightBtn ? _c('ArrowWithCircleBg', {
    class: _vm.$style.iconRight,
    attrs: {
      "direction": "right"
    },
    on: {
      "move": _vm.moveRight
    }
  }) : _vm._e()], 1);
};
var ScrollCompWithLeftRightArrowvue_type_template_id_00b5849c_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/ScrollCompWithLeftRightArrow.vue?vue&type=script&lang=js


/* harmony default export */ var ScrollCompWithLeftRightArrowvue_type_script_lang_js = ({
  name: 'ScrollCompWithLeftRightArrow',
  data() {
    return {
      showMoveLeftBtn: false,
      showMoveRightBtn: true
    };
  },
  methods: {
    updateShowRight() {
      this.$nextTick(() => {
        if (this.$refs.scrollContainer) {
          const scrolledToFarRight = this.isScrolledToFarRight();
          let enoughTabsForScroll = this.$refs.scrollContainer.scrollWidth - this.$refs.scrollContainer.clientWidth > 10;
          this.showMoveRightBtn = !scrolledToFarRight && enoughTabsForScroll;
        }
      });
    },
    handleScroll() {
      if (this.$refs.scrollContainer) {
        let scrollPos = Math.round(this.$refs.scrollContainer?.scrollLeft);
        let scrolledToFarLeft = scrollPos == 0;
        if (scrolledToFarLeft) {
          this.showMoveLeftBtn = false;
        } else {
          this.showMoveLeftBtn = true;
        }
        const scrolledToFarRight = this.isScrolledToFarRight();
        if (scrolledToFarRight) {
          this.showMoveRightBtn = false;
        } else {
          this.showMoveRightBtn = true;
        }
      }
    },
    isScrolledToFarRight() {
      const scrollPos = Math.round(this.$refs.scrollContainer?.scrollLeft);
      const scrolledToFarRight = this.$refs.scrollContainer?.clientWidth + scrollPos >= this.$refs.scrollContainer?.scrollWidth;
      return scrolledToFarRight;
    },
    moveLeft() {
      const content = this.$refs.scrollContainer;
      let scrollPixels = this.$refs.scrollContainer?.getBoundingClientRect().width - 50;
      scrollToLeftRight(content, -scrollPixels, 800);
    },
    moveRight() {
      const content = this.$refs.scrollContainer;
      let scrollPixels = this.$refs.scrollContainer?.getBoundingClientRect().width - 50;
      scrollToLeftRight(content, scrollPixels, 800);
    }
  },
  mounted() {
    this.observer = new resizeobserverimport(entries => {
      entries.forEach(() => {
        this.updateShowRight();
      });
    });
    this.observer.observe(this.$refs.resizeObserverRef);
    setTimeout(() => {
      this.updateShowRight();
    }, 100);
  },
  beforeDestroy() {
    this.observer.unobserve(this.$refs.resizeObserverRef);
  }
});
;// CONCATENATED MODULE: ./src/molecules/ScrollCompWithLeftRightArrow.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_ScrollCompWithLeftRightArrowvue_type_script_lang_js = (ScrollCompWithLeftRightArrowvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/ScrollCompWithLeftRightArrow.vue?vue&type=style&index=0&id=00b5849c&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ScrollCompWithLeftRightArrowvue_type_style_index_0_id_00b5849c_prod_module_true_lang_scss = ({"root":"ScrollCompWithLeftRightArrow_root_PxnLA","scrollContainer":"ScrollCompWithLeftRightArrow_scrollContainer_KgRsV","resizeObserverDiv":"ScrollCompWithLeftRightArrow_resizeObserverDiv_n67U5","iconLeft":"ScrollCompWithLeftRightArrow_iconLeft_Hr7YE","iconRight":"ScrollCompWithLeftRightArrow_iconRight_MAyLM"});
;// CONCATENATED MODULE: ./src/molecules/ScrollCompWithLeftRightArrow.vue?vue&type=style&index=0&id=00b5849c&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/ScrollCompWithLeftRightArrow.vue



;




function ScrollCompWithLeftRightArrow_injectStyles (context) {
  
  this["$style"] = (ScrollCompWithLeftRightArrowvue_type_style_index_0_id_00b5849c_prod_module_true_lang_scss.locals || ScrollCompWithLeftRightArrowvue_type_style_index_0_id_00b5849c_prod_module_true_lang_scss)

}

/* normalize component */

var ScrollCompWithLeftRightArrow_component = normalizeComponent(
  molecules_ScrollCompWithLeftRightArrowvue_type_script_lang_js,
  ScrollCompWithLeftRightArrowvue_type_template_id_00b5849c_render,
  ScrollCompWithLeftRightArrowvue_type_template_id_00b5849c_staticRenderFns,
  false,
  ScrollCompWithLeftRightArrow_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ScrollCompWithLeftRightArrow = (ScrollCompWithLeftRightArrow_component.exports);
;// CONCATENATED MODULE: ./src/molecules/index.js















;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/CamAndMicPermissionPopUp.vue?vue&type=template&id=575aa25f&functional=true
var CamAndMicPermissionPopUpvue_type_template_id_575aa25f_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_c('span', {
    class: _vm.$style.topArrow
  }, [_c('span', {
    class: _vm.$style.arrow
  })]), _c('div', {
    class: _vm.$style.header
  }, [_c('SvgIcon', {
    class: _vm.$style.noVideo,
    attrs: {
      "icon": "warning",
      "name": _vm.props.mediaType === 'camera' ? 'videocam-muted' : 'muted',
      "size": "medium",
      "color": "secondary-text-color"
    }
  }), _c('StyledText', {
    class: _vm.$style.heading,
    attrs: {
      "variant": "body14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('To grant {deviceName} access to this page, follow the two steps below:', {
    deviceName: _vm.props.mediaType
  })) + " ")]), _c('SvgIcon', {
    class: _vm.$style.cancel,
    attrs: {
      "name": "cross",
      "color": "primary-text-color",
      "size": "regular"
    },
    on: {
      "click": _vm.listeners.cancelPermissionPopUp
    }
  })], 1), _c('div', {
    class: _vm.$style.dialogPermission
  }, [_c('div', {
    class: _vm.$style.dialogPermissionIcon
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "330",
      "height": "92.002",
      "viewBox": "0 0 238.001 92.002"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "a",
      "x": "0",
      "y": "0",
      "width": "92.002",
      "height": "92.002",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feOffset', {
    attrs: {
      "dx": "-2",
      "dy": "2",
      "input": "SourceAlpha"
    }
  }), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "5",
      "result": "b"
    }
  }), _c('feFlood', {
    attrs: {
      "flood-opacity": "0.102"
    }
  }), _c('feComposite', {
    attrs: {
      "operator": "in",
      "in2": "b"
    }
  }), _c('feComposite', {
    attrs: {
      "in": "SourceGraphic"
    }
  })], 1), _c('clipPath', {
    attrs: {
      "id": "c"
    }
  }, [_c('circle', {
    staticClass: "a",
    attrs: {
      "cx": "31",
      "cy": "31",
      "r": "31",
      "transform": "translate(0.001 0.001)"
    }
  })])]), _c('g', {
    attrs: {
      "transform": "translate(-551.999 -143.999)"
    }
  }, [_c('g', {
    staticClass: "b",
    attrs: {
      "transform": "translate(-29)"
    }
  }, [_c('g', {
    staticClass: "c",
    attrs: {
      "transform": "translate(605 168)"
    }
  }, [_c('rect', {
    staticClass: "i",
    attrs: {
      "width": "240",
      "height": "40",
      "rx": "20"
    }
  }), _c('rect', {
    staticClass: "j",
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "width": "213",
      "height": "39",
      "rx": "19.5"
    }
  })]), _c('g', {
    staticClass: "d",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "transform": "translate(760 187)"
    }
  }, [_c('text', {
    staticStyle: {
      "stroke": "none",
      "stroke-width": "1",
      "stroke-dasharray": "none",
      "stroke-linecap": "butt",
      "stroke-dashoffset": "0",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "fill": "rgb(0, 0, 0)",
      "fill-rule": "nonzero",
      "opacity": "1",
      "white-space": "pre"
    },
    attrs: {
      "xml:space": "preserve",
      "font-family": "'Open Sans', sans-serif",
      "font-size": "16",
      "font-style": "normal",
      "font-weight": "normal"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-92",
      "y": "6"
    }
  }, [_vm._v(_vm._s(_vm.$options.windowURL()))])])]), _c('path', {
    staticClass: "e",
    attrs: {
      "d": "M1.5,6H2V4a4,4,0,0,1,8,0V6h.5A1.5,1.5,0,0,1,12,7.5v7A1.5,1.5,0,0,1,10.5,16h-9A1.5,1.5,0,0,1,0,14.5v-7A1.5,1.5,0,0,1,1.5,6ZM8.667,4A2.667,2.667,0,0,0,3.333,4V6H8.667Zm0,0",
      "transform": "translate(646 180)"
    }
  })]), _c('g', {
    staticClass: "k",
    attrs: {
      "transform": "matrix(1, 0, 0, 1, 552, 144)"
    }
  }, [_c('path', {
    staticClass: "f",
    attrs: {
      "d": "M31,0A31,31,0,1,1,0,31,31,31,0,0,1,31,0Z",
      "transform": "translate(17 13)"
    }
  })]), _c('g', {
    staticClass: "g",
    attrs: {
      "transform": "translate(568.999 156.999)"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(11.515 9.743)"
    }
  }, [_c('g', {
    staticClass: "c",
    attrs: {
      "transform": "translate(0.486 0.258)"
    }
  }, [_c('rect', {
    staticClass: "i",
    attrs: {
      "width": "228",
      "height": "42",
      "rx": "21"
    }
  }), _c('rect', {
    staticClass: "j",
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "width": "227",
      "height": "41",
      "rx": "20.5"
    }
  })]), _c('path', {
    staticClass: "h",
    attrs: {
      "d": "M1.818,7.274h.606V4.849a4.849,4.849,0,1,1,9.7,0V7.274h.606a1.821,1.821,0,0,1,1.818,1.818v8.486A1.821,1.821,0,0,1,12.729,19.4H1.818A1.821,1.821,0,0,1,0,17.578V9.092A1.821,1.821,0,0,1,1.818,7.274Zm8.688-2.425a3.233,3.233,0,0,0-6.466,0V7.274h6.466Zm0,0",
      "transform": "translate(17.879 9.788)"
    }
  })])])])])])]), _c('StyledText', {
    class: _vm.$style.step1
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('1. Click on the lock icon in your address bar')) + " ")]), _c('StyledText', {
    class: _vm.$style.step2
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('2. Allow {deviceName} access and then refresh the page.', {
    deviceName: _vm.props.mediaType
  })) + " ")])], 1);
};
var CamAndMicPermissionPopUpvue_type_template_id_575aa25f_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/CamAndMicPermissionPopUp.vue?vue&type=script&lang=js
/* harmony default export */ var CamAndMicPermissionPopUpvue_type_script_lang_js = ({
  funtional: true,
  name: 'CamAndMicPermissionPopUp',
  windowURL() {
    const host = window.location.host;
    if (host?.length < 13) {
      return host;
    }
    return host?.substring(0, 12) + '...';
  },
  props: {
    mediaType: {
      type: String,
      default: 'camera'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/CamAndMicPermissionPopUp.vue?vue&type=script&lang=js
 /* harmony default export */ var components_CamAndMicPermissionPopUpvue_type_script_lang_js = (CamAndMicPermissionPopUpvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/CamAndMicPermissionPopUp.vue?vue&type=style&index=0&id=575aa25f&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var CamAndMicPermissionPopUpvue_type_style_index_0_id_575aa25f_prod_lang_scss_module_true = ({"root":"CamAndMicPermissionPopUp_root_LlIOf","topArrow":"CamAndMicPermissionPopUp_topArrow_AtQgq","arrow":"CamAndMicPermissionPopUp_arrow_A6oxc","header":"CamAndMicPermissionPopUp_header_7Ngze","noVideo":"CamAndMicPermissionPopUp_noVideo_zQ_Jv","heading":"CamAndMicPermissionPopUp_heading_VuImD","cancel":"CamAndMicPermissionPopUp_cancel_yAtSP","dialogPermission":"CamAndMicPermissionPopUp_dialogPermission_RkjLZ","dialogPermissionIcon":"CamAndMicPermissionPopUp_dialogPermissionIcon_I05u7","step1":"CamAndMicPermissionPopUp_step1_Yhtyi","step2":"CamAndMicPermissionPopUp_step2_aBVLT"});
;// CONCATENATED MODULE: ./src/components/CamAndMicPermissionPopUp.vue?vue&type=style&index=0&id=575aa25f&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-12.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/CamAndMicPermissionPopUp.vue?vue&type=style&index=1&id=575aa25f&prod&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/CamAndMicPermissionPopUp.vue?vue&type=style&index=1&id=575aa25f&prod&lang=css

;// CONCATENATED MODULE: ./src/components/CamAndMicPermissionPopUp.vue



;





function CamAndMicPermissionPopUp_injectStyles (context) {
  
  this["$style"] = (CamAndMicPermissionPopUpvue_type_style_index_0_id_575aa25f_prod_lang_scss_module_true.locals || CamAndMicPermissionPopUpvue_type_style_index_0_id_575aa25f_prod_lang_scss_module_true)

}

/* normalize component */

var CamAndMicPermissionPopUp_component = normalizeComponent(
  components_CamAndMicPermissionPopUpvue_type_script_lang_js,
  CamAndMicPermissionPopUpvue_type_template_id_575aa25f_functional_true_render,
  CamAndMicPermissionPopUpvue_type_template_id_575aa25f_functional_true_staticRenderFns,
  true,
  CamAndMicPermissionPopUp_injectStyles,
  null,
  null
  
)

/* harmony default export */ var CamAndMicPermissionPopUp = (CamAndMicPermissionPopUp_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/BlockSpeakerOrgScreen.vue?vue&type=template&id=59f26b05
var BlockSpeakerOrgScreenvue_type_template_id_59f26b05_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('SvgIcon', {
    attrs: {
      "name": "cross",
      "size": "regular",
      "variant": "primary"
    },
    on: {
      "click": () => _vm.$emit('cancel')
    }
  })], 1), _c('div', {
    class: _vm.$style.body
  }, [_c('IconButton', {
    class: _vm.$style.bodyIcon,
    attrs: {
      "icon": "mobile-restrict",
      "size": "large",
      "alt": ""
    }
  }), _c('StyledText', {
    class: _vm.$style.mainHeading,
    attrs: {
      "variant": "heading15"
    }
  }, [_vm._v(_vm._s(_vm.$options.$t(`We recommend organizers and speakers use a desktop device`)))]), _c('StyledText', {
    class: _vm.$style.subHeading,
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(_vm._s(_vm.$options.$t(`To ensure the best experience for attendees, speakers and organizers must use Goldcast from a desktop. Broadcasting from a mobile device will cause a degraded experience.`)))]), _c('PillButton', {
    class: _vm.$style.backButton,
    attrs: {
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('logout');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(`Logout`)) + " ")]), _c('TextButton', {
    attrs: {
      "center": "",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('continue');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(`Continue`)) + " ")])], 1), _c('div', {
    class: _vm.$style.footer
  }, [_c('SvgIcon', {
    attrs: {
      "name": "logo"
    }
  })], 1)]);
};
var BlockSpeakerOrgScreenvue_type_template_id_59f26b05_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/BlockSpeakerOrgScreen.vue?vue&type=script&lang=js
/* harmony default export */ var BlockSpeakerOrgScreenvue_type_script_lang_js = ({
  name: 'BlockSpeakerOrgScreen'
});
;// CONCATENATED MODULE: ./src/components/BlockSpeakerOrgScreen.vue?vue&type=script&lang=js
 /* harmony default export */ var components_BlockSpeakerOrgScreenvue_type_script_lang_js = (BlockSpeakerOrgScreenvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/BlockSpeakerOrgScreen.vue?vue&type=style&index=0&id=59f26b05&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var BlockSpeakerOrgScreenvue_type_style_index_0_id_59f26b05_prod_lang_scss_module_true = ({"root":"BlockSpeakerOrgScreen_root_Uimoj","header":"BlockSpeakerOrgScreen_header_ifQFH","body":"BlockSpeakerOrgScreen_body_wiLNv","bodyIcon":"BlockSpeakerOrgScreen_bodyIcon__zTil","mainHeading":"BlockSpeakerOrgScreen_mainHeading_mWj2q","subHeading":"BlockSpeakerOrgScreen_subHeading_Yyf3g","backButton":"BlockSpeakerOrgScreen_backButton_AgU6f","footer":"BlockSpeakerOrgScreen_footer_XEU7N"});
;// CONCATENATED MODULE: ./src/components/BlockSpeakerOrgScreen.vue?vue&type=style&index=0&id=59f26b05&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/BlockSpeakerOrgScreen.vue



;




function BlockSpeakerOrgScreen_injectStyles (context) {
  
  this["$style"] = (BlockSpeakerOrgScreenvue_type_style_index_0_id_59f26b05_prod_lang_scss_module_true.locals || BlockSpeakerOrgScreenvue_type_style_index_0_id_59f26b05_prod_lang_scss_module_true)

}

/* normalize component */

var BlockSpeakerOrgScreen_component = normalizeComponent(
  components_BlockSpeakerOrgScreenvue_type_script_lang_js,
  BlockSpeakerOrgScreenvue_type_template_id_59f26b05_render,
  BlockSpeakerOrgScreenvue_type_template_id_59f26b05_staticRenderFns,
  false,
  BlockSpeakerOrgScreen_injectStyles,
  null,
  null
  
)

/* harmony default export */ var BlockSpeakerOrgScreen = (BlockSpeakerOrgScreen_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventBlur.vue?vue&type=template&id=368f3b92&functional=true
var EventBlurvue_type_template_id_368f3b92_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: [_vm.$style.root]
  }, [_vm._t("default")], 2);
};
var EventBlurvue_type_template_id_368f3b92_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventBlur.vue?vue&type=script&lang=js
/* harmony default export */ var EventBlurvue_type_script_lang_js = ({
  props: {
    heavy: {
      type: Boolean,
      default: true
    },
    radial: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EventBlur.vue?vue&type=script&lang=js
 /* harmony default export */ var components_EventBlurvue_type_script_lang_js = (EventBlurvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventBlur.vue?vue&type=style&index=0&id=368f3b92&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var EventBlurvue_type_style_index_0_id_368f3b92_prod_module_true_lang_scss = ({"root":"EventBlur_root_khLLo"});
;// CONCATENATED MODULE: ./src/components/EventBlur.vue?vue&type=style&index=0&id=368f3b92&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/EventBlur.vue



;




function EventBlur_injectStyles (context) {
  
  this["$style"] = (EventBlurvue_type_style_index_0_id_368f3b92_prod_module_true_lang_scss.locals || EventBlurvue_type_style_index_0_id_368f3b92_prod_module_true_lang_scss)

}

/* normalize component */

var EventBlur_component = normalizeComponent(
  components_EventBlurvue_type_script_lang_js,
  EventBlurvue_type_template_id_368f3b92_functional_true_render,
  EventBlurvue_type_template_id_368f3b92_functional_true_staticRenderFns,
  true,
  EventBlur_injectStyles,
  null,
  null
  
)

/* harmony default export */ var EventBlur = (EventBlur_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserImage.vue?vue&type=template&id=67fa16fa
var UserImagevue_type_template_id_67fa16fa_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "userImage",
    class: _vm.$style.root,
    on: {
      "click": function ($event) {
        return _vm.$emit('click', $event);
      }
    }
  }, [_c('UserBubble', {
    attrs: {
      "size": _vm.size,
      "src": _vm.currentImageUrl,
      "name": _vm.name,
      "outlied": _vm.outlined,
      "aria-label": 'Photo of ' + _vm.user.name
    },
    on: {
      "error": _vm.imageLoadError
    }
  }), _vm.showIsInPerson ? _c('IconButton', {
    class: [_vm.$style.hybridIndicator, 'hybrid-only'],
    attrs: {
      "icon": _vm.isInPerson ? 'in-person-attendee' : 'virtual-attendee',
      "alt": _vm.isInPerson ? false : true,
      "variant": "secondary",
      "size": "x-small"
    },
    on: {
      "click": () => {}
    }
  }) : _vm._e(), _vm._t("delete-button")], 2);
};
var UserImagevue_type_template_id_67fa16fa_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserImage.vue?vue&type=script&lang=js
/* harmony default export */ var UserImagevue_type_script_lang_js = ({
  name: 'UserImage',
  props: {
    src: String,
    /**
     * @prop object with this structure: {name: String, display_email: String}
     */
    user: Object,
    size: String,
    /**
     * @prop string whch can be thumbnail, full, medium
     */
    imageScale: {
      type: String,
      default: 'thumbnail'
    },
    scaleImage: {
      type: Boolean,
      defaut: true
    },
    outlined: Boolean,
    forceHideHybrid: Boolean
  },
  data() {
    return {
      srcIndex: 0
    };
  },
  watch: {
    src() {
      this.srcIndex = 0;
    },
    user() {
      this.srcIndex = 0;
    }
  },
  computed: {
    showIsInPerson() {
      return !this.forceHideHybrid && [true, false].includes(this.isInPerson);
    },
    isInPerson() {
      return this.user?.eventUser?.is_in_person;
    },
    name() {
      return this.user?.name || this.user?.display_email || '';
    },
    imageUrls() {
      if (this.src) {
        return [this.src];
      }
      const {
        image,
        thumbnail,
        mediumimage
      } = this.user || {};
      let urls = [thumbnail, mediumimage, image];
      if (this.imageScale === 'full') {
        urls = [image, mediumimage, thumbnail];
      } else if (this.imageScale === 'medium') {
        urls = [mediumimage, image, thumbnail];
      }
      return urls.filter(Boolean);
    },
    currentImageUrl() {
      return this.imageUrls[this.srcIndex];
    }
  },
  methods: {
    imageLoadError() {
      this.srcIndex += 1;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserImage.vue?vue&type=script&lang=js
 /* harmony default export */ var components_UserImagevue_type_script_lang_js = (UserImagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/UserImage.vue?vue&type=style&index=0&id=67fa16fa&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var UserImagevue_type_style_index_0_id_67fa16fa_prod_module_true_lang_scss = ({"root":"UserImage_root_INY5Y","hybridIndicator":"UserImage_hybridIndicator_C2TI1"});
;// CONCATENATED MODULE: ./src/components/UserImage.vue?vue&type=style&index=0&id=67fa16fa&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/UserImage.vue



;




function UserImage_injectStyles (context) {
  
  this["$style"] = (UserImagevue_type_style_index_0_id_67fa16fa_prod_module_true_lang_scss.locals || UserImagevue_type_style_index_0_id_67fa16fa_prod_module_true_lang_scss)

}

/* normalize component */

var UserImage_component = normalizeComponent(
  components_UserImagevue_type_script_lang_js,
  UserImagevue_type_template_id_67fa16fa_render,
  UserImagevue_type_template_id_67fa16fa_staticRenderFns,
  false,
  UserImage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UserImage = (UserImage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserBubble.vue?vue&type=template&id=582a0cf1
var UserBubblevue_type_template_id_582a0cf1_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.$style[_vm.size], {
      [_vm.$style.noborder]: !_vm.src && !_vm.name,
      [_vm.$style.error]: !_vm.src,
      [_vm.$style.transparent]: _vm.transparent,
      [_vm.$style.outline]: _vm.outlined
    }]
  }, [_vm.src ? _c('img', {
    ref: "userImage",
    attrs: {
      "src": _vm.src,
      "alt": 'Avatar of ' + _vm.name,
      "loading": "lazy"
    },
    on: {
      "error": _vm.onUserImageLoadError,
      "load": _vm.onUserImageLoad
    }
  }) : _vm._e(), !_vm.src || _vm.showInitialsAvatar ? _c('StyledText', {
    class: _vm.$style.initialsAvatar,
    style: {
      'text-transform': 'uppercase'
    },
    attrs: {
      "color": "color-secondary-light",
      "variant": _vm.nameVariant(_vm.size),
      "aria-label": _vm.ariaLabel
    }
  }, [_vm._v(" " + _vm._s(_vm.initials(_vm.name)) + " ")]) : _vm._e()], 1);
};
var UserBubblevue_type_template_id_582a0cf1_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserBubble.vue?vue&type=script&lang=js
/* harmony default export */ var UserBubblevue_type_script_lang_js = ({
  name: 'user-bubble',
  props: {
    src: {
      type: String
    },
    /**
     * @prop can be large, midlarge, medium or small
     */
    size: {
      type: String,
      default: 'large'
    },
    name: {
      type: String,
      default: ''
    },
    transparent: Boolean,
    outlined: Boolean,
    ariaLabel: String
  },
  data() {
    return {
      showInitialsAvatar: true,
      retryImageTimeout: null,
      retries: 0
    };
  },
  methods: {
    onUserImageLoad() {
      if (this.$refs.userImage) {
        this.$refs.userImage.style.display = 'block';
      }
      this.showInitialsAvatar = false;
      this.retries = 0;
      this.clearImageTimeout();
    },
    onUserImageLoadError() {
      if (this.$refs.userImage) {
        this.$refs.userImage.style.display = 'none';
      }
      this.showInitialsAvatar = true;
      this.clearImageTimeout();
      this.retryImageLoad();
    },
    nameVariant(size) {
      return size === 'large' ? 'heading26' : 'body13';
    },
    initials(name) {
      return name?.trim()?.split(' ').slice(0, 2).map(([c]) => c).filter(Boolean).join('');
    },
    retryImageLoad() {
      const reloadImage = () => {
        if (this.retries < 2) {
          this.retries++;

          // eslint-disable-next-line no-console
          console.warn('Image load failed! Retrying image load! Image retry count: ', this.retries);
          this.retryImageTimeout = setTimeout(() => {
            if (this.$refs.userImage) {
              this.$refs.userImage.src = this.src;
            }
            reloadImage();
          }, 2000);
        }
      };
      reloadImage();
    },
    clearImageTimeout() {
      if (this.retryImageTimeout) {
        clearTimeout(this.retryImageTimeout);
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserBubble.vue?vue&type=script&lang=js
 /* harmony default export */ var components_UserBubblevue_type_script_lang_js = (UserBubblevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/UserBubble.vue?vue&type=style&index=0&id=582a0cf1&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var UserBubblevue_type_style_index_0_id_582a0cf1_prod_module_true_lang_scss = ({"root":"UserBubble_root_XgQlX","initialsAvatar":"UserBubble_initialsAvatar_xV92u","noborder":"UserBubble_noborder_qDJDB","large":"UserBubble_large_TsdTc","midlarge":"UserBubble_midlarge_aXnt5","medium":"UserBubble_medium_Tq3Dm","small":"UserBubble_small_mMTHJ","mini":"UserBubble_mini_zFHcT","x-small":"UserBubble_x-small_kKDKN","usual":"UserBubble_usual_BqHOF","error":"UserBubble_error_IOSJv","transparent":"UserBubble_transparent_DbMd1","outline":"UserBubble_outline_sT5Ja"});
;// CONCATENATED MODULE: ./src/components/UserBubble.vue?vue&type=style&index=0&id=582a0cf1&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/UserBubble.vue



;




function UserBubble_injectStyles (context) {
  
  this["$style"] = (UserBubblevue_type_style_index_0_id_582a0cf1_prod_module_true_lang_scss.locals || UserBubblevue_type_style_index_0_id_582a0cf1_prod_module_true_lang_scss)

}

/* normalize component */

var UserBubble_component = normalizeComponent(
  components_UserBubblevue_type_script_lang_js,
  UserBubblevue_type_template_id_582a0cf1_render,
  UserBubblevue_type_template_id_582a0cf1_staticRenderFns,
  false,
  UserBubble_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UserBubble = (UserBubble_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/GTooltip.vue?vue&type=template&id=24208568
var GTooltipvue_type_template_id_24208568_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    class: [_vm.$style.root, {
      [_vm.$style.containerWidth]: _vm.containerWidth
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    ref: "tooltip",
    class: [_vm.$style.tooltip, {
      [_vm.$style.nohovervisible]: _vm.forceShowTooltip
    }, _vm.$style[_vm.positions.horizontal], _vm.$style[_vm.positions.vertical], _vm.$style[_vm.variant]],
    on: {
      "click": function ($event) {
        return _vm.$emit('click', $event);
      }
    }
  }, [_c('span', {
    class: [_vm.$style.text, {
      [_vm.$style.clickable]: _vm.showOpenIcon
    }]
  }, [_c('StyledText', {
    class: _vm.$style.tooltipTextContent,
    attrs: {
      "id": _vm.id,
      "nowrap": _vm.nowrap,
      "color": "inherit",
      "variant": _vm.textVariant,
      "align": "center",
      "display": "block"
    }
  }, [_vm._v(" " + _vm._s(_vm.text) + " "), _vm._t("text")], 2), _vm.showOpenIcon ? _c('svg', {
    class: _vm.$style.openIcon,
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "opacity": "0.8",
      "d": "M7 6H18M18 6V17M18 6L7 17",
      "stroke": "#EDF0FF"
    }
  })]) : _vm._e()], 1), _c('span', {
    class: _vm.$style.arrow
  })]), _vm._t("default")], 2);
};
var GTooltipvue_type_template_id_24208568_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/GTooltip.vue?vue&type=script&lang=js
/* harmony default export */ var GTooltipvue_type_script_lang_js = ({
  name: 'g-tooltip',
  props: {
    text: {
      type: String,
      default: ''
    },
    showOpenIcon: Boolean,
    position: {
      type: String,
      default: 'top-center'
    },
    /**
     * @prop color can be light, primary, secondary, secondarywide
     */
    variant: {
      type: String,
      default: 'secondary'
    },
    disabled: Boolean,
    nowrap: {
      type: Boolean,
      default: false
    },
    forceShowTooltip: {
      type: Boolean,
      default: false
    },
    textVariant: {
      type: String,
      default: 'body13'
    },
    // When set to true, the width of the root element is 100% so that it takes
    // the width of the container where this component is added. Otherwise it is
    // fit-content, so it expands to fill the
    containerWidth: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isMobile: false
    };
  },
  computed: {
    positions() {
      const [vertical, horizontal] = (this.position || 'top-center').split('-');
      return {
        vertical,
        horizontal
      };
    },
    visible() {
      return !this.disabled && !this.isMobile || this.forceShowTooltip;
    }
  },
  mounted() {
    this.isMobile = window.mobileCheck && window.mobileCheck();
  }
});
;// CONCATENATED MODULE: ./src/atoms/GTooltip.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_GTooltipvue_type_script_lang_js = (GTooltipvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/GTooltip.vue?vue&type=style&index=0&id=24208568&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var GTooltipvue_type_style_index_0_id_24208568_prod_module_true_lang_scss = ({"root":"GTooltip_root_NRAg0","containerWidth":"GTooltip_containerWidth_Ib7I_","tooltip":"GTooltip_tooltip_GjR0S","nohovervisible":"GTooltip_nohovervisible_USWpe","secondary":"GTooltip_secondary_B6bzl","secondarywide":"GTooltip_secondarywide_dumMW","text":"GTooltip_text_PkvT9","primary":"GTooltip_primary_gh1TK","light":"GTooltip_light_QZeyj","right":"GTooltip_right_LQS1q","left":"GTooltip_left_MWnkB","center":"GTooltip_center_YM7v_","top":"GTooltip_top_VVEcX","bottom":"GTooltip_bottom_uAOOn","arrow":"GTooltip_arrow_RqLeb","clickable":"GTooltip_clickable__WMo7","openIcon":"GTooltip_openIcon_cVC_P","tooltipTextContent":"GTooltip_tooltipTextContent_NJ_ND"});
;// CONCATENATED MODULE: ./src/atoms/GTooltip.vue?vue&type=style&index=0&id=24208568&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/GTooltip.vue



;




function GTooltip_injectStyles (context) {
  
  this["$style"] = (GTooltipvue_type_style_index_0_id_24208568_prod_module_true_lang_scss.locals || GTooltipvue_type_style_index_0_id_24208568_prod_module_true_lang_scss)

}

/* normalize component */

var GTooltip_component = normalizeComponent(
  atoms_GTooltipvue_type_script_lang_js,
  GTooltipvue_type_template_id_24208568_render,
  GTooltipvue_type_template_id_24208568_staticRenderFns,
  false,
  GTooltip_injectStyles,
  null,
  null
  
)

/* harmony default export */ var GTooltip = (GTooltip_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SingleSelect.vue?vue&type=template&id=2f9dba38
var SingleSelectvue_type_template_id_2f9dba38_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "singleSelectWrapper",
    class: [_vm.$style.root, {
      open: _vm.open
    }],
    attrs: {
      "single-select": ""
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.caret,
    attrs: {
      "name": "caret",
      "color": "theme-text-color",
      "size": "small"
    }
  }), _vm.nosearch ? _c('div', {
    class: _vm.$style.input,
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": function ($event) {
        _vm.open = true;
      },
      "blur": _vm.handleBlur
    }
  }, [_c('StyledText', {
    attrs: {
      "color": "theme-text-color"
    }
  }, [_vm._v(_vm._s(_vm.currentValue))])], 1) : _c('input', {
    ref: "input",
    class: _vm.$style.input,
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "focus": function ($event) {
        _vm.open = true;
      },
      "blur": _vm.handleBlur,
      "input": e => _vm.$emit('search', e.target.value)
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.open,
      expression: "open"
    }],
    staticClass: "singleSelectOptionList",
    class: _vm.$style.list
  }, [_c('div', {
    staticClass: "optionsWrapper"
  }, _vm._l(_vm.options, function (option) {
    return _c('div', {
      key: option.name,
      staticClass: "singleSelectOption",
      class: _vm.$style.option,
      on: {
        "click": () => {
          _vm.$emit('select', option);
          _vm.open = false;
        }
      }
    }, [_c('StyledText', {
      attrs: {
        "color": "color-variant-light-50"
      }
    }, [_vm._v(" " + _vm._s(option.display_name) + " ")])], 1);
  }), 0)])], 1);
};
var SingleSelectvue_type_template_id_2f9dba38_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SingleSelect.vue?vue&type=script&lang=js
/* harmony default export */ var SingleSelectvue_type_script_lang_js = ({
  name: 'SingleSelect',
  props: {
    /**
     * @prop Array<{name: string|number; display_name: string;}>
     */
    options: {
      type: Array,
      default: () => [],
      required: true
    },
    /**
     * @prop selected value of type {name: string|number; display_name: string;}
     */
    value: {
      type: Object
    },
    /**
     * @prop query is a string
     */
    query: {
      type: String
    },
    /**
     * @prop boolean indicating if the field is editable or not
     */
    disabled: {
      type: Boolean
    },
    placeholder: {
      type: String
    },
    nosearch: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    open: false
  }),
  computed: {
    currentValue() {
      return this.open ? this.query : this.value.display_name;
    }
  },
  mounted() {
    if (this.autoFocus && this.$refs.input && this.$refs.input.focus) {
      this.$refs.input.focus();
    }
  },
  methods: {
    handleBlur() {
      setTimeout(() => {
        this.open = false;
      }, 300);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SingleSelect.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SingleSelectvue_type_script_lang_js = (SingleSelectvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SingleSelect.vue?vue&type=style&index=0&id=2f9dba38&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SingleSelectvue_type_style_index_0_id_2f9dba38_prod_module_true_lang_scss = ({"root":"SingleSelect_root_Bdy9E","input":"SingleSelect_input_BSDx4","list":"SingleSelect_list_SXJE1","option":"SingleSelect_option_NLnAc","caret":"SingleSelect_caret_QN9Hp"});
;// CONCATENATED MODULE: ./src/components/SingleSelect.vue?vue&type=style&index=0&id=2f9dba38&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SingleSelect.vue



;




function SingleSelect_injectStyles (context) {
  
  this["$style"] = (SingleSelectvue_type_style_index_0_id_2f9dba38_prod_module_true_lang_scss.locals || SingleSelectvue_type_style_index_0_id_2f9dba38_prod_module_true_lang_scss)

}

/* normalize component */

var SingleSelect_component = normalizeComponent(
  components_SingleSelectvue_type_script_lang_js,
  SingleSelectvue_type_template_id_2f9dba38_render,
  SingleSelectvue_type_template_id_2f9dba38_staticRenderFns,
  false,
  SingleSelect_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SingleSelect = (SingleSelect_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/SimpleSelect.vue?vue&type=template&id=03b27e59
var SimpleSelectvue_type_template_id_03b27e59_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('DropdownSetup', {
    class: {
      [_vm.$style.open]: _vm.open,
      [_vm.$style[_vm.variant]]: true,
      [_vm.$style.root]: true
    },
    attrs: {
      "fullWidth": _vm.fullWidth,
      "open": _vm.open,
      "align": _vm.align,
      "verticalPosition": _vm.verticalPosition
    },
    on: {
      "close": function ($event) {
        _vm.open = false;
      }
    }
  }, [_c('div', {
    class: _vm.$style.toggler,
    attrs: {
      "slot": "toggler"
    },
    on: {
      "click": _vm.toggle
    },
    slot: "toggler"
  }, [_c('StyledText', {
    class: _vm.$style[_vm.selectedOptionAlignment],
    attrs: {
      "variant": "body13",
      "color": "inherit"
    }
  }, [!_vm.$slots.default ? [_vm._v(" " + _vm._s(_vm.label ? `${_vm.label}:` : '') + " " + _vm._s(_vm.value && _vm.value.label) + " ")] : _vm._t("default")], 2), _vm.showCaret ? _c('SvgIcon', {
    class: _vm.$style.caret,
    attrs: {
      "name": "caret",
      "size": "x-small",
      "color": "inherit"
    }
  }) : _vm._e()], 1), _c('div', {
    class: {
      [_vm.$style.dropdown]: true,
      [_vm.$style.fullWidth]: _vm.fullWidth,
      [_vm.$style[_vm.align]]: true,
      [_vm.$style[_vm.verticalPosition]]: true,
      [_vm.$style.fitContent]: _vm.fullHeight
    },
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_vm._l(_vm.settings, function (setting) {
    return _c('StyledText', {
      key: setting.label,
      class: {
        [_vm.$style.option]: true
      },
      attrs: {
        "variant": "body13",
        "color": "inherit",
        "align": _vm.textAlign
      }
    }, [!_vm.$slots.setting ? [_vm._v(_vm._s(setting.label))] : _vm._t("setting", null, {
      "setting": setting,
      "selected": _vm.value && _vm.value.value === setting.value
    })], 2);
  }), _vm.text ? _c('StyledText', {
    class: {
      [_vm.$style.text]: true
    },
    attrs: {
      "variant": "body12",
      "color": "inherit"
    }
  }, [!_vm.$slots.text ? [_vm._v(_vm._s(_vm.text))] : _vm._t("text", null, {
    "text": _vm.text
  })], 2) : _vm._e(), _vm._l(_vm.options, function (option) {
    return _c('StyledText', {
      key: option.value,
      class: {
        [_vm.$style.option]: true,
        [_vm.$style.selected]: _vm.value && _vm.value.value === option.value,
        [_vm.$style.disabled]: option.disabled
      },
      attrs: {
        "variant": "body13",
        "color": "inherit",
        "align": _vm.textAlign
      },
      on: {
        "click": function ($event) {
          return _vm.select(option);
        }
      }
    }, [!_vm.$slots.option ? [_vm._v(_vm._s(option.label))] : _vm._t("option", null, {
      "option": option,
      "selected": _vm.value && _vm.value.value === option.value
    })], 2);
  })], 2)]);
};
var SimpleSelectvue_type_template_id_03b27e59_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/SimpleSelect.vue?vue&type=script&lang=js
/* harmony default export */ var SimpleSelectvue_type_script_lang_js = ({
  name: 'SimpleSelect',
  props: {
    value: Object,
    options: Array,
    settings: Array,
    label: String,
    align: String,
    text: String,
    /**
     * @prop can be primary or secondary, dark, light
     */
    variant: {
      type: String,
      default: 'primary'
    },
    showCaret: {
      type: Boolean,
      default: true
    },
    textAlign: {
      type: String,
      default: 'center'
    },
    verticalPosition: String,
    fullHeight: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    selectedOptionAlignment: {
      type: String,
      default: 'leftAlign'
    }
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    select(option) {
      this.open = false;
      return open.disabled ? null : this.$emit('input', option);
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/SimpleSelect.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_SimpleSelectvue_type_script_lang_js = (SimpleSelectvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/SimpleSelect.vue?vue&type=style&index=0&id=03b27e59&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SimpleSelectvue_type_style_index_0_id_03b27e59_prod_module_true_lang_scss = ({"caret":"SimpleSelect_caret_DB3CK","light":"SimpleSelect_light_lKm75","root":"SimpleSelect_root_aaDhx","primary":"SimpleSelect_primary_qQOmV","secondary":"SimpleSelect_secondary_Zs_92","toggler":"SimpleSelect_toggler_KPcyV","centerAlign":"SimpleSelect_centerAlign_CGGdy","option":"SimpleSelect_option_gCYzB","selected":"SimpleSelect_selected_goOoh","disabled":"SimpleSelect_disabled_ITpLT","dropdown":"SimpleSelect_dropdown_AMmf5","fitContent":"SimpleSelect_fitContent_WB7DZ","fullWidth":"SimpleSelect_fullWidth_vwgDB","right":"SimpleSelect_right_dUJBB","top":"SimpleSelect_top_EnlTv","center":"SimpleSelect_center_FIArT","open":"SimpleSelect_open_Dy8cW","text":"SimpleSelect_text_EBy1P"});
;// CONCATENATED MODULE: ./src/atoms/SimpleSelect.vue?vue&type=style&index=0&id=03b27e59&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/atoms/SimpleSelect.vue



;




function SimpleSelect_injectStyles (context) {
  
  this["$style"] = (SimpleSelectvue_type_style_index_0_id_03b27e59_prod_module_true_lang_scss.locals || SimpleSelectvue_type_style_index_0_id_03b27e59_prod_module_true_lang_scss)

}

/* normalize component */

var SimpleSelect_component = normalizeComponent(
  atoms_SimpleSelectvue_type_script_lang_js,
  SimpleSelectvue_type_template_id_03b27e59_render,
  SimpleSelectvue_type_template_id_03b27e59_staticRenderFns,
  false,
  SimpleSelect_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SimpleSelect = (SimpleSelect_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/NewSimpleSelect.vue?vue&type=template&id=88182256
var NewSimpleSelectvue_type_template_id_88182256_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('DropdownSetup', {
    class: {
      [_vm.$style.open]: _vm.open
    },
    attrs: {
      "open": _vm.open,
      "align": _vm.align,
      "maxAllowedWidth": _vm.maxAllowedWidth
    },
    on: {
      "close": function ($event) {
        _vm.open = false;
      }
    }
  }, [_c('div', {
    ref: "toggler",
    class: [_vm.$style.toggler, _vm.$style[_vm.theme], _vm.bordered && _vm.$style.bordered, 'toggler'],
    attrs: {
      "slot": "toggler"
    },
    on: {
      "click": _vm.toggle
    },
    slot: "toggler"
  }, [_c('StyledText', {
    class: [_vm.$style.label, _vm.$style[_vm.theme]],
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.label ? `${_vm.label}:` : '') + " " + _vm._s(_vm.value && _vm.value.label) + " "), _vm._t("default")], 2), _c('SvgIcon', {
    class: [_vm.$style.caret, _vm.$style[_vm.theme]],
    attrs: {
      "name": "caret",
      "size": "small"
    }
  })], 1), _c('div', {
    class: [_vm.$style.dropdown, _vm.$style[_vm.theme]],
    style: {
      maxHeight: _vm.maxAllowedHeight + 'px',
      maxWidth: _vm.maxAllowedWidth + 'px'
    },
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.options, function (option) {
    return _c('StyledText', {
      key: option[_vm.uniqueKey],
      class: {
        [_vm.$style.option]: true,
        [_vm.$style.selected]: _vm.value && _vm.value[_vm.uniqueKey] === option[_vm.uniqueKey],
        selected: _vm.value && _vm.value[_vm.uniqueKey] === option[_vm.uniqueKey]
      },
      attrs: {
        "variant": "body13",
        "color": _vm.color,
        "align": "center"
      },
      on: {
        "click": function ($event) {
          return _vm.select(option);
        }
      }
    }, [_c('span', [_vm._v(" " + _vm._s(option.label) + " ")])]);
  }), 1)]);
};
var NewSimpleSelectvue_type_template_id_88182256_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/NewSimpleSelect.vue?vue&type=script&lang=js
/* harmony default export */ var NewSimpleSelectvue_type_script_lang_js = ({
  name: 'NewSimpleSelect',
  props: {
    value: {
      // required: true,
      validator: function (value) {
        if (value?.label) {
          return true;
        }
        return false;
      }
    },
    options: Array,
    label: String,
    align: {
      type: String,
      default: 'right'
    },
    lightMode: {
      type: Boolean,
      default: false
    },
    theme: String,
    // secondary / primary,
    bordered: {
      type: Boolean,
      default: true
    },
    uniqueKey: {
      type: String,
      default: 'value'
    }
  },
  data() {
    return {
      open: false,
      maxAllowedHeight: 303,
      maxAllowedWidth: 300
    };
  },
  computed: {
    color() {
      if (this.theme === 'primary') {
        return 'primary-text-color';
      }
      if (this.theme === 'secondary') {
        return 'secondary-text-color';
      }
      return '';
    }
  },
  methods: {
    toggle() {
      this.computeMaxHeight();
      this.open = !!this.options.length && !this.open;
    },
    select(option) {
      this.open = false;
      this.$emit('input', option);
    },
    computeMaxHeight() {
      const toggler = this.$refs.toggler;
      try {
        if (toggler) {
          const clientRect = toggler.getBoundingClientRect();
          this.maxAllowedHeight = window.innerHeight - clientRect.top - clientRect.height;
          const maxWidthsForAlignment = {
            left: window.innerWidth - clientRect.left,
            right: clientRect.left + clientRect.width
          };
          this.maxAllowedWidth = maxWidthsForAlignment[this.align];
        } else {
          this.maxAllowedHeight = 303;
          this.maxAllowedWidth = 303;
        }
      } catch (err) {
        console.warn('Error when getting max height: ', err);
        this.maxAllowedHeight = 301;
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/NewSimpleSelect.vue?vue&type=script&lang=js
 /* harmony default export */ var components_NewSimpleSelectvue_type_script_lang_js = (NewSimpleSelectvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/NewSimpleSelect.vue?vue&type=style&index=0&id=88182256&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var NewSimpleSelectvue_type_style_index_0_id_88182256_prod_module_true_lang_scss = ({"caret":"NewSimpleSelect_caret_ipbDb","primary":"NewSimpleSelect_primary_IdnhN","secondary":"NewSimpleSelect_secondary_AsVN3","label":"NewSimpleSelect_label_UNkd6","toggler":"NewSimpleSelect_toggler_YP1hu","bordered":"NewSimpleSelect_bordered_z2WIQ","option":"NewSimpleSelect_option_E90sz","selected":"NewSimpleSelect_selected_VoHv5","dropdown":"NewSimpleSelect_dropdown_Xgn7g","open":"NewSimpleSelect_open_BpPX_"});
;// CONCATENATED MODULE: ./src/components/NewSimpleSelect.vue?vue&type=style&index=0&id=88182256&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/NewSimpleSelect.vue



;




function NewSimpleSelect_injectStyles (context) {
  
  this["$style"] = (NewSimpleSelectvue_type_style_index_0_id_88182256_prod_module_true_lang_scss.locals || NewSimpleSelectvue_type_style_index_0_id_88182256_prod_module_true_lang_scss)

}

/* normalize component */

var NewSimpleSelect_component = normalizeComponent(
  components_NewSimpleSelectvue_type_script_lang_js,
  NewSimpleSelectvue_type_template_id_88182256_render,
  NewSimpleSelectvue_type_template_id_88182256_staticRenderFns,
  false,
  NewSimpleSelect_injectStyles,
  null,
  null
  
)

/* harmony default export */ var NewSimpleSelect = (NewSimpleSelect_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SimpleRangeInput.vue?vue&type=template&id=65e9e1a3
var SimpleRangeInputvue_type_template_id_65e9e1a3_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.range, _vm.$style[_vm.theme]]
  }, [_c('StyledText', {
    class: _vm.$style.label,
    attrs: {
      "variant": "body13",
      "color": "color-variant-light-50"
    }
  }, [_vm._t("default")], 2), _c('div', {
    class: _vm.$style.fromTo
  }, [_c('SimpleInput', {
    attrs: {
      "type": _vm.type
    },
    model: {
      value: _vm.fromVal,
      callback: function ($$v) {
        _vm.fromVal = $$v;
      },
      expression: "fromVal"
    }
  }), _c('SimpleInput', {
    attrs: {
      "type": _vm.type
    },
    model: {
      value: _vm.toVal,
      callback: function ($$v) {
        _vm.toVal = $$v;
      },
      expression: "toVal"
    }
  })], 1)], 1);
};
var SimpleRangeInputvue_type_template_id_65e9e1a3_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SimpleInput.vue?vue&type=template&id=92723162
var SimpleInputvue_type_template_id_92723162_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.input, _vm.$style[_vm.theme]],
    style: _vm.wrapperCss
  }, [_c('StyledText', {
    class: _vm.$style.label,
    attrs: {
      "variant": "body13"
    }
  }, [_vm._t("default")], 2), _vm.$attrs.type === 'file' ? _c('input', _vm._b({
    ref: "input",
    attrs: {
      "id": "fileinput"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event.target.files);
      },
      "change": function ($event) {
        return _vm.$emit('change', $event.target.files);
      },
      "focus": function ($event) {
        return _vm.$emit('focus', $event);
      },
      "blur": function ($event) {
        return _vm.$emit('blur', $event);
      }
    }
  }, 'input', _vm.$attrs, false)) : _vm.$attrs.type === 'select' ? _c('SingleSelect', {
    attrs: {
      "value": _vm.selectValue,
      "options": _vm.selectOptions,
      "autoFocus": _vm.autoFocus
    },
    on: {
      "select": _vm.onSingleSelect
    }
  }) : _c('input', _vm._b({
    ref: "input",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event.target.value);
      },
      "change": function ($event) {
        return _vm.$emit('change', $event.target.value);
      },
      "focus": function ($event) {
        return _vm.$emit('focus', $event);
      },
      "blur": function ($event) {
        return _vm.$emit('blur', $event);
      }
    }
  }, 'input', _vm.$attrs, false)), _vm.$attrs.type === 'file' ? _c('label', {
    attrs: {
      "for": "fileinput"
    }
  }, [_c('StyledText', {
    class: [_vm.$style.filelabel, !_vm.fileName && _vm.$style.flplcholder],
    attrs: {
      "variant": "body14"
    }
  }, [_vm._v(" " + _vm._s(_vm.fileName || _vm.$options.$t(_vm.filePlaceholder)) + " ")])], 1) : _vm._e(), _c('StyledText', {
    class: [_vm.$style.error, {
      [_vm.$style.hasNoerror]: !_vm.error
    }],
    attrs: {
      "variant": "body13",
      "color": "color-secondary-light"
    }
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")])], 1);
};
var SimpleInputvue_type_template_id_92723162_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SimpleInput.vue?vue&type=script&lang=js
/* harmony default export */ var SimpleInputvue_type_script_lang_js = ({
  name: 'SimpleInput',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: null
    },
    filePlaceholder: {
      type: String,
      default: 'No File Chosen'
    },
    value: {
      type: [Number, String, Array],
      default: ''
    },
    theme: {
      type: String,
      default: 'dark'
    },
    field: {
      type: Object,
      default: () => {}
    },
    wrapperCss: {
      type: Object,
      default: () => {}
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    error: String,
    customtheme: Boolean
  },
  data() {
    return {
      fromval: '',
      toval: '',
      selectValue: {
        name: '',
        display_name: ''
      }
    };
  },
  created() {
    this.fromVal = this.fromValue;
    this.toVal = this.toValue;
  },
  mounted() {
    if (this.autoFocus && this.$refs.input && this.$refs.input.focus) {
      this.$refs.input.focus();
    }
  },
  methods: {
    onSingleSelect(data) {
      this.selectValue.display_name = data.value;
      this.$emit('change', data.value);
      this.$emit('input', data.value);
    }
  },
  computed: {
    selectOptions() {
      return this.field.choices.map(elm => {
        return {
          name: elm,
          display_name: elm,
          value: elm
        };
      });
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SimpleInput.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SimpleInputvue_type_script_lang_js = (SimpleInputvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SimpleInput.vue?vue&type=style&index=0&id=92723162&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SimpleInputvue_type_style_index_0_id_92723162_prod_module_true_lang_scss = ({"input":"SimpleInput_input_tfcwD","label":"SimpleInput_label_PBPA1","filelabel":"SimpleInput_filelabel_ZYiio","flplcholder":"SimpleInput_flplcholder_a554N","dark":"SimpleInput_dark_iMgSf","light":"SimpleInput_light_wP7aX","secondary":"SimpleInput_secondary_LA6qP","primary":"SimpleInput_primary_VoEk6","error":"SimpleInput_error_k3lgd","hasNoerror":"SimpleInput_hasNoerror_QDsOI"});
;// CONCATENATED MODULE: ./src/components/SimpleInput.vue?vue&type=style&index=0&id=92723162&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SimpleInput.vue



;




function SimpleInput_injectStyles (context) {
  
  this["$style"] = (SimpleInputvue_type_style_index_0_id_92723162_prod_module_true_lang_scss.locals || SimpleInputvue_type_style_index_0_id_92723162_prod_module_true_lang_scss)

}

/* normalize component */

var SimpleInput_component = normalizeComponent(
  components_SimpleInputvue_type_script_lang_js,
  SimpleInputvue_type_template_id_92723162_render,
  SimpleInputvue_type_template_id_92723162_staticRenderFns,
  false,
  SimpleInput_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SimpleInput = (SimpleInput_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SimpleRangeInput.vue?vue&type=script&lang=js

/* harmony default export */ var SimpleRangeInputvue_type_script_lang_js = ({
  components: {
    SimpleInput: SimpleInput
  },
  name: 'SimpleRangeInput',
  props: {
    fromValue: {
      type: [Number, String],
      default: ''
    },
    toValue: {
      type: [Number, String],
      default: ''
    },
    theme: {
      type: String,
      default: 'dark'
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  data() {
    return {
      fromVal: this.fromValue,
      toVal: this.toValue
    };
  },
  watch: {
    toVal(newValue) {
      this.$emit('update-to-value', newValue);
    },
    fromVal(newValue) {
      this.$emit('update-from-value', newValue);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SimpleRangeInput.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SimpleRangeInputvue_type_script_lang_js = (SimpleRangeInputvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SimpleRangeInput.vue?vue&type=style&index=0&id=65e9e1a3&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SimpleRangeInputvue_type_style_index_0_id_65e9e1a3_prod_module_true_lang_scss = ({"range":"SimpleRangeInput_range_oDSc5","label":"SimpleRangeInput_label_XjtsH","dark":"SimpleRangeInput_dark_OnvvV","light":"SimpleRangeInput_light_Zzwi2","fromTo":"SimpleRangeInput_fromTo_A6qyt"});
;// CONCATENATED MODULE: ./src/components/SimpleRangeInput.vue?vue&type=style&index=0&id=65e9e1a3&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SimpleRangeInput.vue



;




function SimpleRangeInput_injectStyles (context) {
  
  this["$style"] = (SimpleRangeInputvue_type_style_index_0_id_65e9e1a3_prod_module_true_lang_scss.locals || SimpleRangeInputvue_type_style_index_0_id_65e9e1a3_prod_module_true_lang_scss)

}

/* normalize component */

var SimpleRangeInput_component = normalizeComponent(
  components_SimpleRangeInputvue_type_script_lang_js,
  SimpleRangeInputvue_type_template_id_65e9e1a3_render,
  SimpleRangeInputvue_type_template_id_65e9e1a3_staticRenderFns,
  false,
  SimpleRangeInput_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SimpleRangeInput = (SimpleRangeInput_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SearchField.vue?vue&type=template&id=3fcedd71
var SearchFieldvue_type_template_id_3fcedd71_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.noOutline]: _vm.variant === 'no-outline',
      [_vm.$style.active]: !!_vm.value
    }
  }, [_c('div', {
    class: _vm.$style.border
  }), _c('input', {
    class: {
      [_vm.$style.fullWidth]: _vm.fullWidth
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$options.$t(_vm.placeholder)
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.input($event);
      },
      "change": function ($event) {
        return _vm.input($event, 'change');
      }
    }
  }), _c('SvgIcon', {
    attrs: {
      "name": "cross",
      "color": "primary-text-color",
      "size": "small"
    },
    on: {
      "click": function ($event) {
        return _vm.input({
          target: {
            value: ''
          }
        });
      }
    }
  })], 1);
};
var SearchFieldvue_type_template_id_3fcedd71_staticRenderFns = [];

// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash.debounce@4.0.8/node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(2869);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SearchField.vue?vue&type=script&lang=js

/* harmony default export */ var SearchFieldvue_type_script_lang_js = ({
  name: 'SimpleSearchField',
  props: {
    value: String,
    placeholder: {
      type: String,
      default: 'Search'
    },
    variant: {
      type: String,
      default: '' //no-outline
    },

    showIcon: {
      type: Boolean,
      default: true
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    input: lodash_debounce_default()(function ({
      target: {
        value
      }
    }, eventName = 'input') {
      this.$emit(eventName, value);
    }, 500)
  }
});
;// CONCATENATED MODULE: ./src/components/SearchField.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SearchFieldvue_type_script_lang_js = (SearchFieldvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SearchField.vue?vue&type=style&index=0&id=3fcedd71&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SearchFieldvue_type_style_index_0_id_3fcedd71_prod_module_true_lang_scss = ({"root":"SearchField_root_NDTBw","border":"SearchField_border_LlOW1","noOutline":"SearchField_noOutline_Uwv_B","active":"SearchField_active_bED8l","fullWidth":"SearchField_fullWidth_QT9ew"});
;// CONCATENATED MODULE: ./src/components/SearchField.vue?vue&type=style&index=0&id=3fcedd71&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SearchField.vue



;




function SearchField_injectStyles (context) {
  
  this["$style"] = (SearchFieldvue_type_style_index_0_id_3fcedd71_prod_module_true_lang_scss.locals || SearchFieldvue_type_style_index_0_id_3fcedd71_prod_module_true_lang_scss)

}

/* normalize component */

var SearchField_component = normalizeComponent(
  components_SearchFieldvue_type_script_lang_js,
  SearchFieldvue_type_template_id_3fcedd71_render,
  SearchFieldvue_type_template_id_3fcedd71_staticRenderFns,
  false,
  SearchField_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SearchField = (SearchField_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TagsFilter.vue?vue&type=template&id=5fdb0c48
var TagsFiltervue_type_template_id_5fdb0c48_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    class: _vm.$style.root
  }, [_c('span', {
    class: [_vm.$style.shadow, _vm.$style.shadowleft]
  }, [_c('SvgIcon', {
    class: [_vm.$style.leftArrow, _vm.$style.arrow],
    attrs: {
      "color": "primary-text-color",
      "name": "caret",
      "size": "small"
    },
    on: {
      "click": _vm.scrollLeft
    }
  })], 1), _c('span', {
    class: [_vm.$style.shadow, _vm.$style.shadowright]
  }, [_c('SvgIcon', {
    class: [_vm.$style.rightArrow, _vm.$style.arrow],
    attrs: {
      "color": "primary-text-color",
      "name": "caret",
      "size": "small"
    },
    on: {
      "click": _vm.scrollRight
    }
  })], 1), _c('div', {
    ref: "tagsFilterContainer",
    class: _vm.$style.tags
  }, _vm._l(_vm.tags, function (tag, index) {
    return _c('Tag', {
      key: index,
      attrs: {
        "tag": tag,
        "added": _vm.added(tag.toLowerCase()),
        "rounded": true,
        "showRemove": true
      },
      on: {
        "click": function ($event) {
          _vm.add(tag.toLowerCase());
        },
        "remove": function ($event) {
          _vm.remove(tag.toLowerCase());
        }
      }
    });
  }), 1)]);
};
var TagsFiltervue_type_template_id_5fdb0c48_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/Tag.vue?vue&type=template&id=303e05eb&functional=true
var Tagvue_type_template_id_303e05eb_functional_true_render = function render(_c, _vm) {
  return _c('StyledText', {
    class: {
      [_vm.$style.tag]: true,
      [_vm.$style.added]: _vm.props.added,
      [_vm.data.staticClass]: _vm.data.staticClass,
      [_vm.data.class]: _vm.data.class,
      [_vm.$style.rounded]: _vm.props.rounded,
      [_vm.$style.pointer]: _vm.props.showRemove
    },
    attrs: {
      "variant": "subHeading13",
      "color": 'secondary-text-color',
      "tabIndex": _vm.props.tabindex
    },
    on: {
      "click": function ($event) {
        _vm.listeners.click ? _vm.listeners.click($event) : () => {};
      }
    }
  }, [_c('span', {
    class: _vm.$style.bg
  }), _c('span', {
    class: _vm.$style.border
  }), _c('span', {
    class: _vm.$style.text
  }, [_vm._v(" " + _vm._s(_vm.props.noHash ? '' : '#') + _vm._s(_vm.props.tag) + " ")]), _vm.props.added && _vm.props.showRemove ? _c('SvgIcon', {
    class: {
      [_vm.$style.tagRemover]: _vm.props.showRemove
    },
    attrs: {
      "color": "secondary-text-color",
      "name": "cross"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return ($event => _vm.listeners.remove ? _vm.listeners.remove($event) : null).apply(null, arguments);
      }
    }
  }) : _vm._e()], 1);
};
var Tagvue_type_template_id_303e05eb_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventOnboarding/Tag.vue?vue&type=style&index=0&id=303e05eb&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var Tagvue_type_style_index_0_id_303e05eb_prod_module_true_lang_scss = ({"tag":"Tag_tag_ybtmx","pointer":"Tag_pointer_UFMOC","added":"Tag_added_fLSRi","text":"Tag_text_tmgZk","tagRemover":"Tag_tagRemover_vP1Tg","bg":"Tag_bg_rpY6G","border":"Tag_border_K8fk9","rounded":"Tag_rounded_f0FAy"});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/Tag.vue?vue&type=style&index=0&id=303e05eb&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/Tag.vue

var script = {}
;




function Tag_injectStyles (context) {
  
  this["$style"] = (Tagvue_type_style_index_0_id_303e05eb_prod_module_true_lang_scss.locals || Tagvue_type_style_index_0_id_303e05eb_prod_module_true_lang_scss)

}

/* normalize component */

var Tag_component = normalizeComponent(
  script,
  Tagvue_type_template_id_303e05eb_functional_true_render,
  Tagvue_type_template_id_303e05eb_functional_true_staticRenderFns,
  true,
  Tag_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Tag = (Tag_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TagsFilter.vue?vue&type=script&lang=js

/* harmony default export */ var TagsFiltervue_type_script_lang_js = ({
  name: 'TagsFilter',
  props: {
    tags: Array,
    value: Array
  },
  components: {
    Tag: Tag
  },
  methods: {
    horizontalScroll(element, direction, speed, distance, step) {
      let scrollAmount = 0;
      let slideTimer = setInterval(function () {
        if (direction == 'left') {
          element.scrollLeft -= step;
        } else {
          element.scrollLeft += step;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer);
        }
      }, speed);
    },
    scrollRight() {
      this.horizontalScroll(this.$refs.tagsFilterContainer, 'right', 24, 100, 10);
    },
    scrollLeft() {
      this.horizontalScroll(this.$refs.tagsFilterContainer, 'left', 24, 100, 10);
    },
    added(tag) {
      return this.value.includes(tag);
    },
    add(tag) {
      if (this.added(tag)) {
        this.remove(tag);
      } else {
        this.input([...this.value, tag]);
      }
      this.clicked(tag);
    },
    remove(tag) {
      this.input(this.value.filter(t => tag !== t));
      this.clicked(tag);
    },
    input(value) {
      this.$emit('input', value);
    },
    clicked(tag) {
      this.$emit('tag-clicked', tag);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TagsFilter.vue?vue&type=script&lang=js
 /* harmony default export */ var components_TagsFiltervue_type_script_lang_js = (TagsFiltervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TagsFilter.vue?vue&type=style&index=0&id=5fdb0c48&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var TagsFiltervue_type_style_index_0_id_5fdb0c48_prod_module_true_lang_scss = ({"root":"TagsFilter_root_Ovx2S","arrow":"TagsFilter_arrow_UfBOV","leftArrow":"TagsFilter_leftArrow_mT1i_","rightArrow":"TagsFilter_rightArrow_QTeCd","shadow":"TagsFilter_shadow_nzZzf","shadowright":"TagsFilter_shadowright_HXyqC","shadowleft":"TagsFilter_shadowleft_CrVwN","tags":"TagsFilter_tags_psYPq"});
;// CONCATENATED MODULE: ./src/components/TagsFilter.vue?vue&type=style&index=0&id=5fdb0c48&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/TagsFilter.vue



;




function TagsFilter_injectStyles (context) {
  
  this["$style"] = (TagsFiltervue_type_style_index_0_id_5fdb0c48_prod_module_true_lang_scss.locals || TagsFiltervue_type_style_index_0_id_5fdb0c48_prod_module_true_lang_scss)

}

/* normalize component */

var TagsFilter_component = normalizeComponent(
  components_TagsFiltervue_type_script_lang_js,
  TagsFiltervue_type_template_id_5fdb0c48_render,
  TagsFiltervue_type_template_id_5fdb0c48_staticRenderFns,
  false,
  TagsFilter_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TagsFilter = (TagsFilter_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/FilterBar.vue?vue&type=template&id=3a54cc2a&functional=true
var FilterBarvue_type_template_id_3a54cc2a_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.filterHeaderContainer
  }, [_c('div', {
    class: _vm.$style.headerSlot
  }, [_vm._t("headerContent")], 2), _c('div', {
    class: _vm.$style.inputsContainer
  }, [!_vm.props.hideFilters ? [_c('SearchField', {
    class: _vm.$style.searchInput,
    attrs: {
      "value": _vm.props.searchTerm,
      "showIcon": false
    },
    on: {
      "input": $event => _vm.listeners.search ? _vm.listeners.search($event) : null
    }
  }), _c('PillButton', {
    class: _vm.$style.filterButton,
    attrs: {
      "icon": "filter",
      "selected": _vm.props.enabledFilters,
      "size": "small",
      "icon-size": "small",
      "uppercase": ""
    },
    on: {
      "click": _vm.listeners.toggle
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Filter')) + " "), _vm.props.searchTerm || _vm.props.filterTags && _vm.props.filterTags.length > 0 ? _c('SvgIcon', {
    class: _vm.$style.filterIcon,
    attrs: {
      "slot": "after",
      "name": "cross",
      "color": "secondary-text-color"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.listeners.clear.apply(null, arguments);
      }
    },
    slot: "after"
  }) : _vm._e()], 1)] : _vm._e(), _c('div', {
    class: _vm.$style.minimizedVideoContainer
  }, [_vm._t("minimizedVideo")], 2)], 2)]), !_vm.props.hideFilters && _vm.props.enabledFilters ? _c('div', {
    class: _vm.$style.filters
  }, [_vm.props.sortOptions && _vm.props.sortOptions.length > 0 ? _c('SimpleSelect', {
    attrs: {
      "label": _vm.$options.$t('Sort'),
      "align": "right",
      "options": _vm.props.sortOptions,
      "value": _vm.props.sortBy
    },
    on: {
      "input": $event => _vm.listeners.sort ? _vm.listeners.sort($event) : null
    }
  }) : _vm._e(), _vm.props.tags ? _c('TagsFilter', {
    class: _vm.$style.tagsFilter,
    attrs: {
      "tags": _vm.props.tags,
      "value": _vm.props.filterTags
    },
    on: {
      "input": $event => _vm.listeners.tags ? _vm.listeners.tags($event) : null
    }
  }) : _vm._e()], 1) : _vm._e()]);
};
var FilterBarvue_type_template_id_3a54cc2a_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/FilterBar.vue?vue&type=script&lang=js
/* harmony default export */ var FilterBarvue_type_script_lang_js = ({
  name: 'EventAgendaHeader',
  functional: true,
  props: {
    dateFilter: Object,
    searchTerm: String,
    tags: Array,
    sortBy: Object,
    filterTags: Array,
    dates: Array,
    sortOptions: Array,
    enabledFilters: {
      type: Boolean,
      default: false
    },
    hideFilters: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/FilterBar.vue?vue&type=script&lang=js
 /* harmony default export */ var components_FilterBarvue_type_script_lang_js = (FilterBarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/FilterBar.vue?vue&type=style&index=0&id=3a54cc2a&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var FilterBarvue_type_style_index_0_id_3a54cc2a_prod_module_true_lang_scss = ({"root":"FilterBar_root_V5QaE","minimizedVideoContainer":"FilterBar_minimizedVideoContainer_zNpZP","sortContainer":"FilterBar_sortContainer_QGatW","sortInnerContainer":"FilterBar_sortInnerContainer_oeIt6","headerSlot":"FilterBar_headerSlot_oBung","inputsContainer":"FilterBar_inputsContainer_SyYhV","filterButton":"FilterBar_filterButton_uHs_P","filterIcon":"FilterBar_filterIcon_Ioapp","filters":"FilterBar_filters__OX44","filterHeaderContainer":"FilterBar_filterHeaderContainer_T6zDE","searchInput":"FilterBar_searchInput_tJ6lQ","tagsFilter":"FilterBar_tagsFilter_MpYik"});
;// CONCATENATED MODULE: ./src/components/FilterBar.vue?vue&type=style&index=0&id=3a54cc2a&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/FilterBar.vue



;




function FilterBar_injectStyles (context) {
  
  this["$style"] = (FilterBarvue_type_style_index_0_id_3a54cc2a_prod_module_true_lang_scss.locals || FilterBarvue_type_style_index_0_id_3a54cc2a_prod_module_true_lang_scss)

}

/* normalize component */

var FilterBar_component = normalizeComponent(
  components_FilterBarvue_type_script_lang_js,
  FilterBarvue_type_template_id_3a54cc2a_functional_true_render,
  FilterBarvue_type_template_id_3a54cc2a_functional_true_staticRenderFns,
  true,
  FilterBar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var FilterBar = (FilterBar_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Paginator.vue?vue&type=template&id=d525c3d6
var Paginatorvue_type_template_id_d525c3d6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.pages > 1 ? _c('div', {
    class: _vm.$style.root
  }, [_vm.value > 2 ? _c('SvgIcon', {
    class: _vm.$style.leftIcon,
    attrs: {
      "name": "double-right-arrow",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        return _vm.open(1);
      }
    }
  }) : _vm._e(), _vm.value > 1 ? _c('SvgIcon', {
    class: _vm.$style.leftIcon,
    attrs: {
      "name": "right-arrow",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        return _vm.open(_vm.value - 1);
      }
    }
  }) : _vm._e(), _vm._l(_vm.visiblePages, function (page) {
    return _c('StyledText', {
      key: page,
      class: {
        [_vm.$style.activePage]: page === _vm.value
      },
      attrs: {
        "variant": "subHeading13",
        "color": "primary-text-color"
      },
      on: {
        "click": function ($event) {
          return _vm.open(page);
        }
      }
    }, [_vm._v(" " + _vm._s(page) + " ")]);
  }), _vm.value < _vm.pages ? _c('SvgIcon', {
    attrs: {
      "name": "right-arrow",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        return _vm.open(_vm.value + 1);
      }
    }
  }) : _vm._e(), _vm.value < _vm.pages - 1 ? _c('SvgIcon', {
    attrs: {
      "name": "double-right-arrow",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        return _vm.open(_vm.pages);
      }
    }
  }) : _vm._e()], 2) : _vm._e();
};
var Paginatorvue_type_template_id_d525c3d6_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Paginator.vue?vue&type=script&lang=js

/* harmony default export */ var Paginatorvue_type_script_lang_js = ({
  name: 'Paginator',
  props: {
    pages: Number,
    value: Number
  },
  computed: {
    visiblePages() {
      const pages = [this.value];
      let i = 1;
      while (pages.length <= 4 && i < this.pages) {
        if (this.value - i > 0) {
          pages.push(this.value - i);
        }
        if (this.value + i <= this.pages) {
          pages.push(this.value + i);
        }
        i++;
      }
      return pages.sort((a, b) => a > b ? a : b > a ? -1 : 0);
    }
  },
  methods: {
    open(value) {
      this.$emit('input', value);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Paginator.vue?vue&type=script&lang=js
 /* harmony default export */ var components_Paginatorvue_type_script_lang_js = (Paginatorvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-11.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Paginator.vue?vue&type=style&index=0&id=d525c3d6&prod&module=true&lang=css
// extracted by mini-css-extract-plugin
/* harmony default export */ var Paginatorvue_type_style_index_0_id_d525c3d6_prod_module_true_lang_css = ({"root":"Paginator_root_JeBwK","leftIcon":"Paginator_leftIcon_T2ghr","activePage":"Paginator_activePage_la_jN"});
;// CONCATENATED MODULE: ./src/components/Paginator.vue?vue&type=style&index=0&id=d525c3d6&prod&module=true&lang=css
 
;// CONCATENATED MODULE: ./src/components/Paginator.vue



;




function Paginator_injectStyles (context) {
  
  this["$style"] = (Paginatorvue_type_style_index_0_id_d525c3d6_prod_module_true_lang_css.locals || Paginatorvue_type_style_index_0_id_d525c3d6_prod_module_true_lang_css)

}

/* normalize component */

var Paginator_component = normalizeComponent(
  components_Paginatorvue_type_script_lang_js,
  Paginatorvue_type_template_id_d525c3d6_render,
  Paginatorvue_type_template_id_d525c3d6_staticRenderFns,
  false,
  Paginator_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Paginator = (Paginator_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ProgressBar.vue?vue&type=template&id=46a4f580&functional=true
var ProgressBarvue_type_template_id_46a4f580_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.wrapper
  }, [_c('StyledText', {
    class: _vm.$style.label,
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._t("default")], 2), _c('div', {
    class: _vm.$style.slider
  }, [_c('div', {
    class: _vm.$style.line
  }), _c('div', {
    class: [_vm.$style.subline, _vm.$style.inc]
  }), _c('div', {
    class: [_vm.$style.subline, _vm.$style.dec]
  })])], 1);
};
var ProgressBarvue_type_template_id_46a4f580_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ProgressBar.vue?vue&type=script&lang=js
/* harmony default export */ var ProgressBarvue_type_script_lang_js = ({
  name: 'AuthProgress',
  functional: true
});
;// CONCATENATED MODULE: ./src/components/ProgressBar.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ProgressBarvue_type_script_lang_js = (ProgressBarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/ProgressBar.vue?vue&type=style&index=0&id=46a4f580&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var ProgressBarvue_type_style_index_0_id_46a4f580_prod_lang_scss_module_true = ({"slider":"ProgressBar_slider_fC0hN","wrapper":"ProgressBar_wrapper_RFEsl","line":"ProgressBar_line_siDhE","subline":"ProgressBar_subline_JTVmM","inc":"ProgressBar_inc_yIQVV","increase":"ProgressBar_increase_aEfvv","dec":"ProgressBar_dec_pXUer","decrease":"ProgressBar_decrease_jTDHd","label":"ProgressBar_label_euryG"});
;// CONCATENATED MODULE: ./src/components/ProgressBar.vue?vue&type=style&index=0&id=46a4f580&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/ProgressBar.vue



;




function ProgressBar_injectStyles (context) {
  
  this["$style"] = (ProgressBarvue_type_style_index_0_id_46a4f580_prod_lang_scss_module_true.locals || ProgressBarvue_type_style_index_0_id_46a4f580_prod_lang_scss_module_true)

}

/* normalize component */

var ProgressBar_component = normalizeComponent(
  components_ProgressBarvue_type_script_lang_js,
  ProgressBarvue_type_template_id_46a4f580_functional_true_render,
  ProgressBarvue_type_template_id_46a4f580_functional_true_staticRenderFns,
  true,
  ProgressBar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ProgressBar = (ProgressBar_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/RadioSelectBtn.vue?vue&type=template&id=46629116
var RadioSelectBtnvue_type_template_id_46629116_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    class: [_vm.$style.root, _vm.disabled && _vm.$style.disabled, _vm.$style[_vm.theme]],
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('span', {
    class: [_vm.$style.selectBtn, _vm.selected && _vm.$style.btnSelected]
  }, [_vm.selected ? _c('span', {
    class: _vm.$style.selected
  }) : _vm._e()]), _vm.label ? _c('StyledText', {
    class: [_vm.$style.label, _vm.selected && _vm.$style.lableSelected],
    attrs: {
      "variant": "body15",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e()], 1);
};
var RadioSelectBtnvue_type_template_id_46629116_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/RadioSelectBtn.vue?vue&type=script&lang=js
/* harmony default export */ var RadioSelectBtnvue_type_script_lang_js = ({
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'primary'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/RadioSelectBtn.vue?vue&type=script&lang=js
 /* harmony default export */ var components_RadioSelectBtnvue_type_script_lang_js = (RadioSelectBtnvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/RadioSelectBtn.vue?vue&type=style&index=0&id=46629116&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var RadioSelectBtnvue_type_style_index_0_id_46629116_prod_module_true_lang_scss = ({"root":"RadioSelectBtn_root_cj9fd","selectBtn":"RadioSelectBtn_selectBtn_rogBj","selected":"RadioSelectBtn_selected_BREbs","btnSelected":"RadioSelectBtn_btnSelected_DCDyo","label":"RadioSelectBtn_label_S_a7z","lableSelected":"RadioSelectBtn_lableSelected_aH_8Y","disabled":"RadioSelectBtn_disabled_jxP1f","primary":"RadioSelectBtn_primary_eG95u","secondary":"RadioSelectBtn_secondary_We5os","screen-saver":"RadioSelectBtn_screen-saver_2Yg2K"});
;// CONCATENATED MODULE: ./src/components/RadioSelectBtn.vue?vue&type=style&index=0&id=46629116&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/RadioSelectBtn.vue



;




function RadioSelectBtn_injectStyles (context) {
  
  this["$style"] = (RadioSelectBtnvue_type_style_index_0_id_46629116_prod_module_true_lang_scss.locals || RadioSelectBtnvue_type_style_index_0_id_46629116_prod_module_true_lang_scss)

}

/* normalize component */

var RadioSelectBtn_component = normalizeComponent(
  components_RadioSelectBtnvue_type_script_lang_js,
  RadioSelectBtnvue_type_template_id_46629116_render,
  RadioSelectBtnvue_type_template_id_46629116_staticRenderFns,
  false,
  RadioSelectBtn_injectStyles,
  null,
  null
  
)

/* harmony default export */ var RadioSelectBtn = (RadioSelectBtn_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/StyledReadmoreText.vue?vue&type=template&id=a3ac6b36
var StyledReadmoreTextvue_type_template_id_a3ac6b36_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.showReadmore && !_vm.extraContentDisplayed ? _c('StyledText', _vm._b({
    on: {
      "click": function ($event) {
        _vm.extraContentDisplayed = true;
      }
    }
  }, 'StyledText', _vm.$attrs, false), [_vm._v(" " + _vm._s(_vm.collapsedText) + " "), _c('StyledText', {
    class: _vm.$style.readmore,
    attrs: {
      "variant": "heading13"
    }
  }, [_vm._v(" ... " + _vm._s(_vm.$options.$t('Read More')) + " ")])], 1) : _c('StyledText', _vm._b({
    on: {
      "click": function ($event) {
        _vm.extraContentDisplayed = true;
      }
    }
  }, 'StyledText', _vm.$attrs, false), [_vm._v(" " + _vm._s(_vm.text) + " ")]);
};
var StyledReadmoreTextvue_type_template_id_a3ac6b36_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/StyledReadmoreText.vue?vue&type=script&lang=js
/* harmony default export */ var StyledReadmoreTextvue_type_script_lang_js = ({
  name: 'styled-readmore-text',
  props: {
    text: {
      type: String,
      value: ''
    },
    turncationLimit: {
      type: Number,
      default: 174
    }
  },
  data() {
    return {
      extraContentDisplayed: false
    };
  },
  computed: {
    showReadmore() {
      return this.text && typeof this.text === 'string' && this.turncationLimit && this.text.length > this.turncationLimit;
    },
    collapsedText() {
      if (this.showReadmore) {
        return this.text && this.text.slice(0, this.turncationLimit);
      }
      return this.text;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/StyledReadmoreText.vue?vue&type=script&lang=js
 /* harmony default export */ var components_StyledReadmoreTextvue_type_script_lang_js = (StyledReadmoreTextvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/StyledReadmoreText.vue?vue&type=style&index=0&id=a3ac6b36&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var StyledReadmoreTextvue_type_style_index_0_id_a3ac6b36_prod_module_true_lang_scss = ({"readmore":"StyledReadmoreText_readmore_u1XwW"});
;// CONCATENATED MODULE: ./src/components/StyledReadmoreText.vue?vue&type=style&index=0&id=a3ac6b36&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/StyledReadmoreText.vue



;




function StyledReadmoreText_injectStyles (context) {
  
  this["$style"] = (StyledReadmoreTextvue_type_style_index_0_id_a3ac6b36_prod_module_true_lang_scss.locals || StyledReadmoreTextvue_type_style_index_0_id_a3ac6b36_prod_module_true_lang_scss)

}

/* normalize component */

var StyledReadmoreText_component = normalizeComponent(
  components_StyledReadmoreTextvue_type_script_lang_js,
  StyledReadmoreTextvue_type_template_id_a3ac6b36_render,
  StyledReadmoreTextvue_type_template_id_a3ac6b36_staticRenderFns,
  false,
  StyledReadmoreText_injectStyles,
  null,
  null
  
)

/* harmony default export */ var StyledReadmoreText = (StyledReadmoreText_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AtcButton.vue?vue&type=template&id=0270e7f8
var AtcButtonvue_type_template_id_0270e7f8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('OutlinedButton', {
    class: {
      [_vm.$style.root]: true,
      addeventatc: true
    },
    attrs: {
      "title": _vm.$options.$t('Add to Calendar'),
      "size": "small",
      "icon": "calendar",
      "data-styling": "none"
    },
    on: {
      "click": e => {}
    }
  }, [_vm._v(" + "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.time_formatted(_vm.start_time)))]), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.time_formatted(_vm.end_time)))]), _c('span', {
    staticClass: "timezone"
  }, [_vm._v(_vm._s(_vm.timezoneLocale))]), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('span', {
    staticClass: "description"
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('You can access the event landing here')) + ": " + _vm._s(_vm.url) + " ")]), _c('span', {
    staticClass: "client"
  }, [_vm._v("aubYlVxPfzyYINamvmOw93760")])]);
};
var AtcButtonvue_type_template_id_0270e7f8_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AtcButton.vue?vue&type=script&lang=js
/* harmony default export */ var AtcButtonvue_type_script_lang_js = ({
  name: 'AtcButton',
  props: {
    theme: {
      type: String,
      default: 'agendaTheme'
    },
    start_time: {
      type: String,
      default: '20201108T213000Z'
    },
    end_time: {
      type: String,
      default: '20201109T213000Z'
    },
    timezone: {
      type: String,
      default: 'UTC'
    },
    title: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  computed: {
    timezoneLocale() {
      return this.timezone.split(' ')[0];
    }
  },
  methods: {
    time_formatted(time) {
      let time_obj = new Date(time);
      let [mm, dd, yy] = time_obj.toLocaleDateString('en-US', {
        timeZone: this.timezoneLocale,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }).split('/');
      if (parseInt(mm) <= 9) {
        mm = '0' + mm;
      }
      if (parseInt(dd) <= 9) {
        dd = '0' + dd;
      }
      let local_time = time_obj.toLocaleTimeString('en-US', {
        timeZone: this.timezoneLocale,
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).replace(/[:]/g, '');
      let [hr, min, sec] = local_time.match(/.{1,2}/g);
      if (parseInt(hr) === 24) {
        hr = '00';
      }
      return `${yy}${mm}${dd}T${hr}${min}${sec}Z`;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/AtcButton.vue?vue&type=script&lang=js
 /* harmony default export */ var components_AtcButtonvue_type_script_lang_js = (AtcButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/AtcButton.vue?vue&type=style&index=0&id=0270e7f8&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var AtcButtonvue_type_style_index_0_id_0270e7f8_prod_module_true_lang_scss = ({"root":"AtcButton_root_g649P"});
;// CONCATENATED MODULE: ./src/components/AtcButton.vue?vue&type=style&index=0&id=0270e7f8&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/AtcButton.vue



;




function AtcButton_injectStyles (context) {
  
  this["$style"] = (AtcButtonvue_type_style_index_0_id_0270e7f8_prod_module_true_lang_scss.locals || AtcButtonvue_type_style_index_0_id_0270e7f8_prod_module_true_lang_scss)

}

/* normalize component */

var AtcButton_component = normalizeComponent(
  components_AtcButtonvue_type_script_lang_js,
  AtcButtonvue_type_template_id_0270e7f8_render,
  AtcButtonvue_type_template_id_0270e7f8_staticRenderFns,
  false,
  AtcButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AtcButton = (AtcButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SimpleLabel.vue?vue&type=template&id=72a6608b
var SimpleLabelvue_type_template_id_72a6608b_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.label,
    on: {
      "click": function ($event) {
        return _vm.$emit('on-click');
      }
    }
  }, [_vm._t("default")], 2);
};
var SimpleLabelvue_type_template_id_72a6608b_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SimpleLabel.vue?vue&type=script&lang=js
/* harmony default export */ var SimpleLabelvue_type_script_lang_js = ({
  name: 'SimpleLabel',
  props: {
    label: {
      type: [String, Number],
      default: ''
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SimpleLabel.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SimpleLabelvue_type_script_lang_js = (SimpleLabelvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SimpleLabel.vue?vue&type=style&index=0&id=72a6608b&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SimpleLabelvue_type_style_index_0_id_72a6608b_prod_lang_scss_module_true = ({"label":"SimpleLabel_label_iKniS"});
;// CONCATENATED MODULE: ./src/components/SimpleLabel.vue?vue&type=style&index=0&id=72a6608b&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/SimpleLabel.vue



;




function SimpleLabel_injectStyles (context) {
  
  this["$style"] = (SimpleLabelvue_type_style_index_0_id_72a6608b_prod_lang_scss_module_true.locals || SimpleLabelvue_type_style_index_0_id_72a6608b_prod_lang_scss_module_true)

}

/* normalize component */

var SimpleLabel_component = normalizeComponent(
  components_SimpleLabelvue_type_script_lang_js,
  SimpleLabelvue_type_template_id_72a6608b_render,
  SimpleLabelvue_type_template_id_72a6608b_staticRenderFns,
  false,
  SimpleLabel_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SimpleLabel = (SimpleLabel_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/StageWrapper.vue?vue&type=template&id=1469b9cf&functional=true
var StageWrappervue_type_template_id_1469b9cf_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.flexible_wrapper
  }, [!_vm.props.hideMiniPlayer ? _c('div', {
    class: [_vm.$style.root, _vm.$style[_vm.props.minimized && 'minimized'], {
      [_vm.$style.stageRecordMode]: _vm.props.recordingMode
    }]
  }, [_c('div', {
    class: [_vm.$style.room_section, _vm.props.recordingMode && _vm.$style.recordingMode]
  }, [_vm.props.minimized && _vm.props.activePage ? _c('div', {
    class: _vm.$style.page_info
  }, [_c('div', {
    class: _vm.$style.bottomPart
  }, [_c('div', {
    attrs: {
      "else": ""
    }
  }), _c('div', {
    class: _vm.$style.filters
  }, [_c('FilterBar', _vm._b({
    on: {
      "tags": payload => _vm.listeners.filters({
        name: 'filterTags',
        payload
      }),
      "sort": payload => _vm.listeners.filters({
        name: 'sortBy',
        payload
      }),
      "search": payload => _vm.listeners.filters({
        name: 'searchTerm',
        payload
      }),
      "date": payload => _vm.listeners.filters({
        name: 'dateFilter',
        payload
      }),
      "clear": () => _vm.listeners.filters({
        name: 'clear'
      }),
      "toggle": () => _vm.listeners.filters({
        name: 'clickFilter'
      })
    },
    scopedSlots: _vm._u([{
      key: "minimizedVideo",
      fn: function () {
        return [_c('div', {
          class: _vm.$style.room_player
        }, [_vm._t("default"), _vm.props.showMuteButton ? _c('IconButton', {
          class: [_vm.$style.icon, _vm.$style.mute],
          attrs: {
            "role": "switch",
            "ariaChecked": _vm.props.muted ? 'false' : 'true',
            "aria-label": _vm.props.muted ? _vm.$options.$t('Speaker Off') : _vm.$options.$t('Speaker On'),
            "icon": _vm.props.muted ? 'faunmute' : 'volume',
            "variant": "highlight"
          },
          on: {
            "click": () => _vm.listeners.mute ? _vm.listeners.mute() : null
          }
        }) : _vm._e(), _c('IconButton', {
          class: [_vm.$style.icon, _vm.$style.fullscreen],
          attrs: {
            "icon": "fullscreen",
            "aria-label": 'Switch to full screen mode'
          },
          on: {
            "click": () => _vm.listeners.switch_fullscreen()
          }
        })], 2)];
      },
      proxy: true
    }, {
      key: "headerContent",
      fn: function () {
        return [_c('span', {
          class: _vm.$style.header
        }, [_c('h1', {
          attrs: {
            "tabindex": "-1"
          }
        }, [_c('StyledText', {
          attrs: {
            "variant": "heading26",
            "color": "primary-text-color",
            "data-branding-target": "room-page-title"
          }
        }, [_vm._v(" " + _vm._s(_vm.props.activePage.label) + " ")])], 1), _vm.props.activePage.name !== 'agenda' ? _c('span') : _vm.props.selectedTrack && _vm.props.selectedTrack.id && (_vm.props.trackOptions || []).length > 1 ? _c('GTooltip', {
          attrs: {
            "disabled": !_vm.props.selectedTrack.disabled,
            "text": _vm.$options.$t(`Track only available for {tracks}`, {
              tracks: _vm.props.selectedTrack.tickets.map(t => t.label || t.code).join(', ')
            }),
            "position": "bottom-right"
          }
        }, [_c('PillButton', {
          class: _vm.$style.follow_button,
          attrs: {
            "alt": "",
            "icon": _vm.props.subscribedTrack.value === _vm.props.selectedTrack.value ? 'tick' : 'notification',
            "disabled": _vm.props.selectedTrack.disabled
          },
          on: {
            "click": function ($event) {
              _vm.props.subscribedTrack.value !== _vm.props.selectedTrack.value ? _vm.listeners.subscribeTrack(_vm.props.selectedTrack) : null;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.props.subscribedTrack.value === _vm.props.selectedTrack.value ? _vm.$options.$t('Following') : _vm.$options.$t('Follow')) + " "), _c('b', [_vm._v(" " + _vm._s(_vm.props.selectedTrack.title) + " ")])])], 1) : _vm._e()], 1), _vm.props.activePage.name !== 'agenda' ? _c('StyledText', {
          class: _vm.$style.description,
          attrs: {
            "variant": "body13",
            "color": "primary-text-color",
            "dataBrandingTarget": "page-description"
          }
        }, [_vm._v(" " + _vm._s(_vm.props.activePage.description) + " ")]) : _c('div', {
          class: _vm.$style.agendaFilters
        }, [(_vm.props.agendaDayOptions || []).length > 1 ? _c('AgendaFilter', {
          attrs: {
            "addAriaAttributes": true,
            "ariaControlId": "stageAgendaItemContainer",
            "options": _vm.props.agendaDayOptions,
            "current": _vm.props.selectedAgendaDay,
            "type": "dropdown"
          },
          on: {
            "select": e => _vm.listeners.onagendadayselect(e)
          }
        }) : _vm._e(), (_vm.props.trackOptions || []).length > 1 ? _c('AgendaFilter', {
          attrs: {
            "addAriaAttributes": true,
            "ariaControlId": "stageAgendaItemContainer",
            "options": _vm.props.trackOptions,
            "current": _vm.props.selectedTrack,
            "type": _vm.$options.isMobile() ? 'dropdown' : 'pin',
            "icon": "notification",
            "iconOn": _vm.props.subscribedTrack
          },
          on: {
            "select": e => _vm.listeners.ontrackselect(e)
          }
        }) : _vm._e(), _vm.props.showFavorites ? _c('AgendaFavoritesFilter', {
          attrs: {
            "selected": _vm.props.agendaFilters.agendaFavoritesFilter,
            "agendaFavorites": _vm.props.agendaFavorites
          },
          on: {
            "click": e => _vm.listeners.onClickFavoritesFilter(e)
          }
        }) : _vm._e()], 1)];
      },
      proxy: true
    }], null, true)
  }, 'FilterBar', _vm.props.filters, false))], 1)])]) : _vm._e(), !_vm.props.minimized ? _c('div', {
    class: _vm.$style.room_player
  }, [_vm._t("default"), _c('SvgIcon', {
    class: [_vm.$style.icon, _vm.$style.mute],
    attrs: {
      "name": _vm.props.muted ? 'faunmute' : 'volume',
      "color": "primary-text-color"
    },
    on: {
      "click": () => _vm.listeners.mute ? _vm.listeners.mute() : null
    }
  }), _c('SvgIcon', {
    class: [_vm.$style.icon, _vm.$style.fullscreen],
    attrs: {
      "name": "fullscreen",
      "size": "small",
      "color": "secondary-text-color"
    },
    on: {
      "click": () => _vm.listeners.switch_fullscreen()
    }
  })], 2) : _vm._e()]), _vm._t("controls")], 2) : _vm._e(), _vm.props.minimized ? _c('div', {
    class: _vm.$style.page_content,
    attrs: {
      "id": "stageWrapper_subPage"
    }
  }, [_vm._t("subpage")], 2) : _vm._e()]);
};
var StageWrappervue_type_template_id_1469b9cf_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/StageWrapper.vue?vue&type=script&lang=js

/* harmony default export */ var StageWrappervue_type_script_lang_js = ({
  components: {
    PillButton: PillButton
  },
  name: 'StageWrappper',
  functional: true,
  props: {
    filters: {
      type: Object,
      default: null
    },
    organizer: {
      type: Boolean,
      default: false
    },
    activePage: {
      type: Object,
      default: null
    },
    minimized: Boolean,
    hasLocalStream: {
      type: Boolean,
      default: false
    },
    agendaDayOptions: Array,
    selectedAgendaDay: Object,
    trackOptions: Array,
    selectedTrack: Object,
    agendaFavorites: Array,
    muted: {
      type: Boolean,
      default: false
    },
    subscribedTrack: Object,
    recordingMode: {
      type: Boolean,
      default: false
    },
    hideMiniPlayer: {
      type: Boolean,
      default: false
    },
    showMuteButton: Boolean,
    showFavorites: Boolean,
    agendaFilters: Object
  },
  isMobile() {
    return window.mobileCheck && window.mobileCheck();
  }
});
;// CONCATENATED MODULE: ./src/components/StageWrapper.vue?vue&type=script&lang=js
 /* harmony default export */ var components_StageWrappervue_type_script_lang_js = (StageWrappervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/StageWrapper.vue?vue&type=style&index=0&id=1469b9cf&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var StageWrappervue_type_style_index_0_id_1469b9cf_prod_module_true_lang_scss = ({"root":"StageWrapper_root_ZnD4x","stageRecordMode":"StageWrapper_stageRecordMode_yEmWj","room_section":"StageWrapper_room_section_g8Xbs","recordingMode":"StageWrapper_recordingMode_wgdXt","room_player":"StageWrapper_room_player_Viu8_","icon":"StageWrapper_icon_a6mXP","navigation":"StageWrapper_navigation_eAfa7","minimized":"StageWrapper_minimized__CBGL","page_info":"StageWrapper_page_info_zfNQ9","header":"StageWrapper_header_sTnGL","following":"StageWrapper_following_PQSD0","following_icon":"StageWrapper_following_icon_MawG3","follow_button":"StageWrapper_follow_button_Pochw","bottomPart":"StageWrapper_bottomPart_WQdfG","description":"StageWrapper_description_LIejq","filters":"StageWrapper_filters_hFyZk","agendaFilters":"StageWrapper_agendaFilters_RmFu8","fullscreen":"StageWrapper_fullscreen_QfhKP","mute":"StageWrapper_mute_gK9v_","page_content":"StageWrapper_page_content_wsfsj","flexible_wrapper":"StageWrapper_flexible_wrapper_QN2Yv"});
;// CONCATENATED MODULE: ./src/components/StageWrapper.vue?vue&type=style&index=0&id=1469b9cf&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/StageWrapper.vue



;




function StageWrapper_injectStyles (context) {
  
  this["$style"] = (StageWrappervue_type_style_index_0_id_1469b9cf_prod_module_true_lang_scss.locals || StageWrappervue_type_style_index_0_id_1469b9cf_prod_module_true_lang_scss)

}

/* normalize component */

var StageWrapper_component = normalizeComponent(
  components_StageWrappervue_type_script_lang_js,
  StageWrappervue_type_template_id_1469b9cf_functional_true_render,
  StageWrappervue_type_template_id_1469b9cf_functional_true_staticRenderFns,
  true,
  StageWrapper_injectStyles,
  null,
  null
  
)

/* harmony default export */ var StageWrapper = (StageWrapper_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarDocs/SidebarDocs.vue?vue&type=template&id=5da0ee46
var SidebarDocsvue_type_template_id_5da0ee46_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "id": "sidebarDocs"
    }
  }, [_c('SidebarWidgetContainer', {
    attrs: {
      "widgetLabel": _vm.$options.$t(`{eventName} Documents`, {
        eventName: _vm.eventName
      })
    }
  }, [_c('div', {
    class: _vm.$style.docsWidget
  }, _vm._l(_vm.documents, function (doc, i) {
    return _c('div', {
      key: i,
      class: _vm.$style.docItem,
      on: {
        "click": function ($event) {
          return _vm.$emit('opendoc', doc);
        }
      }
    }, [_c('div', {
      class: _vm.$style.docTypeCircleHolder
    }, [_c('div', {
      class: _vm.$style.docTypeCircle
    }, [_c('StyledText', {
      class: _vm.$style.docTypeName,
      attrs: {
        "variant": "body13"
      }
    }, [_vm._v(" " + _vm._s(doc && doc.typeText) + " ")]), _c('SvgIcon', {
      class: _vm.$style.doctTypeCircleHoverIcon,
      attrs: {
        "color": "secondary-text-color",
        "size": "small",
        "name": doc && doc.typeText && doc.typeText === 'LINK' ? _vm.$options.$t('link') : _vm.$options.$t('download')
      }
    })], 1)]), _c('div', {
      class: _vm.$style.documentDetails
    }, [_c('StyledText', {
      class: _vm.$style.docTitle,
      attrs: {
        "variant": "body15"
      }
    }, [_vm._v(" " + _vm._s(doc && doc.text) + " ")]), _c('StyledText', {
      class: _vm.$style.docTitle,
      attrs: {
        "variant": "body13"
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Click to open')) + " ")])], 1)]);
  }), 0)])], 1);
};
var SidebarDocsvue_type_template_id_5da0ee46_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarDocs/SidebarDocs.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarDocsvue_type_script_lang_js = ({
  props: {
    documents: {
      type: Array,
      default() {
        return [];
      }
    },
    eventName: {
      type: String,
      default: ''
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarDocs/SidebarDocs.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarDocs_SidebarDocsvue_type_script_lang_js = (SidebarDocsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarDocs/SidebarDocs.vue?vue&type=style&index=0&id=5da0ee46&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarDocsvue_type_style_index_0_id_5da0ee46_prod_module_true_lang_scss = ({"root":"SidebarDocs_root_Vj4k_","docsWidget":"SidebarDocs_docsWidget_muAad","docItem":"SidebarDocs_docItem_jHqkW","docTypeCircleHolder":"SidebarDocs_docTypeCircleHolder_GH3I7","docTypeCircle":"SidebarDocs_docTypeCircle_tIuRS","docTypeName":"SidebarDocs_docTypeName_c7SIQ","doctTypeCircleHoverIcon":"SidebarDocs_doctTypeCircleHoverIcon_XfWuj","documentDetails":"SidebarDocs_documentDetails_wKKwe","docTitle":"SidebarDocs_docTitle_F2z87"});
;// CONCATENATED MODULE: ./src/components/SidebarDocs/SidebarDocs.vue?vue&type=style&index=0&id=5da0ee46&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarDocs/SidebarDocs.vue



;




function SidebarDocs_injectStyles (context) {
  
  this["$style"] = (SidebarDocsvue_type_style_index_0_id_5da0ee46_prod_module_true_lang_scss.locals || SidebarDocsvue_type_style_index_0_id_5da0ee46_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarDocs_component = normalizeComponent(
  SidebarDocs_SidebarDocsvue_type_script_lang_js,
  SidebarDocsvue_type_template_id_5da0ee46_render,
  SidebarDocsvue_type_template_id_5da0ee46_staticRenderFns,
  false,
  SidebarDocs_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarDocs = (SidebarDocs_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AgoraV4Player.vue?vue&type=template&id=32567e18
var AgoraV4Playervue_type_template_id_32567e18_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, (!(_vm.user || {}).id || _vm.applyRoundedCss) && _vm.$style.is_screen, _vm.applyRoundedCss && _vm.$style.roundedBorder],
    attrs: {
      "data-branding-target": "virtual-background"
    }
  }, [_c('div', {
    ref: "videoElement",
    class: [_vm.$style.video_item, !(_vm.user || {}).id && _vm.$style.screen, _vm.isLocal && (_vm.user || {}).id && _vm.$style.mirror]
  }), _vm.user && !_vm.videoTrack ? _c('UserImage', {
    class: [_vm.$style.video_item, _vm.$style.user_image],
    attrs: {
      "user": _vm.user,
      "image-scale": "medium",
      "forceHideHybrid": true
    }
  }) : _vm._e(), _vm.mask ? _c('div', {
    class: _vm.$style.virtualBgPreview,
    style: {
      'mask-image': `url('${_vm.mask}')`
    }
  }, [_c('div', {
    class: _vm.$style.virtualBackground
  })]) : _vm._e(), _vm.showNameCard && !_vm.minimized && _vm.user && _vm.user.name ? _c('NameCard', _vm._b({
    class: {
      [_vm.$style.hoveringStage]: _vm.hoveringStage
    },
    attrs: {
      "applyRoundedCss": _vm.applyRoundedCss,
      "user": _vm.user,
      "muted": !_vm.audioTrack,
      "minimizedView": _vm.minimizedView,
      "forceDefaultView": _vm.forceDefaultView
    }
  }, 'NameCard', _vm.$attrs, false)) : _vm._e(), _vm.signalStrength ? _c('SignalIndicator', {
    class: _vm.$style.signalIndicator,
    attrs: {
      "size": _vm.minimizedView ? 'small' : 'medium',
      "noTooltip": true,
      "value": _vm.signalStrength
    }
  }) : _vm._e(), _vm.loading ? _c('Loading', {
    class: _vm.$style.loader,
    attrs: {
      "size": "small"
    }
  }) : _vm._e()], 1);
};
var AgoraV4Playervue_type_template_id_32567e18_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/NameCard.vue?vue&type=template&id=5f78aee2
var NameCardvue_type_template_id_5f78aee2_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.minimizedView && _vm.$style.minimizedView, _vm.forceDefaultView && _vm.$style.forceDefault, _vm.applyRoundedCss && _vm.$style.roundedVideo],
    attrs: {
      "data-branding-target": "name-card"
    }
  }, [_c('span', {
    class: [_vm.$style.name, _vm.applyRoundedCss && _vm.$style.centerContent]
  }, [_c('StyledText', {
    class: [_vm.$style.ellipsis, _vm.applyRoundedCss && _vm.$style.roundedVideoEllipsis],
    attrs: {
      "variant": "heading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.user.name) + " ")]), _vm.muted ? _c('SvgIcon', {
    attrs: {
      "name": "muted",
      "color": "theme-highlight-text-color"
    }
  }) : _vm._e()], 1), _c('span', {
    class: [_vm.$style.name, _vm.applyRoundedCss && _vm.$style.centerContent]
  }, [!_vm.minimizedView ? _c('StyledText', {
    class: [_vm.$style.ellipsis, _vm.$style.title, _vm.$style.nonmobile, _vm.applyRoundedCss && _vm.$style.roundedVideoEllipsis],
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.titleString) + " ")]) : _vm._e()], 1)]);
};
var NameCardvue_type_template_id_5f78aee2_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/NameCard.vue?vue&type=script&lang=js
/* harmony default export */ var NameCardvue_type_script_lang_js = ({
  name: 'NameCard',
  props: {
    muted: Boolean,
    user: {
      type: Object,
      default: () => {}
    },
    minimizedView: Boolean,
    forceDefaultView: Boolean,
    applyRoundedCss: Boolean
  },
  computed: {
    titleString() {
      const user = this.user;
      return `${user.title || ''}${user.title && user.company ? ', ' : ''}${user.company || ''}`;
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/NameCard.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_NameCardvue_type_script_lang_js = (NameCardvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/NameCard.vue?vue&type=style&index=0&id=5f78aee2&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var NameCardvue_type_style_index_0_id_5f78aee2_prod_module_true_lang_scss = ({"root":"NameCard_root_mtLQn","forceDefault":"NameCard_forceDefault_sPmcZ","roundedVideo":"NameCard_roundedVideo_hb9yu","minimizedView":"NameCard_minimizedView_B38TI","name":"NameCard_name_OGlO3","centerContent":"NameCard_centerContent_IGn1V","ellipsis":"NameCard_ellipsis_VUJph","roundedVideoEllipsis":"NameCard_roundedVideoEllipsis_wxVaC","title":"NameCard_title_LiOxJ","nonmobile":"NameCard_nonmobile_k9jEA"});
;// CONCATENATED MODULE: ./src/molecules/NameCard.vue?vue&type=style&index=0&id=5f78aee2&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/NameCard.vue



;




function NameCard_injectStyles (context) {
  
  this["$style"] = (NameCardvue_type_style_index_0_id_5f78aee2_prod_module_true_lang_scss.locals || NameCardvue_type_style_index_0_id_5f78aee2_prod_module_true_lang_scss)

}

/* normalize component */

var NameCard_component = normalizeComponent(
  molecules_NameCardvue_type_script_lang_js,
  NameCardvue_type_template_id_5f78aee2_render,
  NameCardvue_type_template_id_5f78aee2_staticRenderFns,
  false,
  NameCard_injectStyles,
  null,
  null
  
)

/* harmony default export */ var NameCard = (NameCard_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AgoraV4Player.vue?vue&type=script&lang=js


/* harmony default export */ var AgoraV4Playervue_type_script_lang_js = ({
  components: {
    NameCard: NameCard
  },
  name: 'AgoraV4Player',
  data() {
    return {
      autoplayError: false,
      minimizedView: false,
      showNameCard: true,
      forceDefaultView: false
    };
  },
  props: {
    videoTrack: Object,
    audioTrack: Object,
    user: {
      type: Object,
      default: () => ({})
    },
    applyRoundedCss: {
      type: Boolean,
      default: false
    },
    isLocal: {
      type: Boolean,
      default: false
    },
    minimized: {
      type: Boolean,
      default: false
    },
    fit: {
      type: String,
      default: 'cover'
    },
    hoveringStage: Boolean,
    muted: Boolean,
    loading: Boolean,
    audioOutputDeviceId: {
      type: String
    },
    // Namecard visibility breakpoints
    minimizedViewBreakpoint: {
      type: Number,
      default: 420
    },
    defaultViewBreakpoint: {
      type: Number,
      default: 300
    },
    visibilityBreakpoint: {
      type: Number,
      default: 120
    },
    mask: {
      type: String,
      default: ''
    },
    signalStrength: Number
  },
  methods: {
    isValidTrackToPlay(track) {
      if (track && track.play) {
        this.stop(track);
        return true;
      }
      return false;
    },
    playVideo() {
      if (!this.isValidTrackToPlay(this.videoTrack)) {
        return;
      }
      this.videoTrack.play(this.$refs.videoElement, {
        fit: this.fit,
        mirror: false
      });
    },
    playAudio() {
      if (!this.isValidTrackToPlay(this.audioTrack) || this.isLocal || this.muted) {
        return;
      }
      this.setPlaybackDevice();
      this.audioTrack.play();
    },
    setPlaybackDevice() {
      try {
        this.audioTrack?.setPlaybackDevice(this.audioOutputDeviceId);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Audio playback device could not be set', e);
      }
    },
    setMinimizedView(el) {
      if (!el) {
        return;
      }
      this.$nextTick().then(() => {
        this.minimizedView = el.offsetWidth < this.minimizedViewBreakpoint;
        this.forceDefaultView = el.offsetWidth < this.defaultViewBreakpoint;
        this.showNameCard = el.offsetWidth > this.visibilityBreakpoint;
      });
    },
    stop(track) {
      if (track?.stop && track?.isPlaying) {
        track.stop();
      }
    }
  },
  watch: {
    audioOutputDeviceId() {
      this.setPlaybackDevice();
    },
    videoTrack(newTrack, oldTrack) {
      if (newTrack?.getTrackId && newTrack?.getTrackId() === oldTrack?.getTrackId()) {
        return;
      }
      this.stop(oldTrack);
      this.playVideo();
    },
    audioTrack(newTrack, oldTrack) {
      if (newTrack?.getTrackId && newTrack?.getTrackId() === oldTrack?.getTrackId()) {
        return;
      }
      this.stop(oldTrack);
      this.playAudio();
    },
    muted(isMuted, wasMuted) {
      const hasValueChanged = isMuted !== wasMuted;
      if (!hasValueChanged) {
        return;
      }
      if (isMuted) {
        this.stop(this.audioTrack);
      } else {
        this.playAudio();
      }
    }
  },
  mounted() {
    this.playVideo();
    this.playAudio();
    this.setMinimizedView(this.$el);
    this.observer = new resizeobserverimport(entries => {
      entries.forEach(e => this.setMinimizedView(e.target));
    });
    this.observer.observe(this.$el);
  },
  destroyed() {
    this.stop(this.videoTrack);
    this.stop(this.audioTrack);
  },
  beforeDestroy() {
    this.observer.unobserve(this.$el);
  }
});
;// CONCATENATED MODULE: ./src/components/AgoraV4Player.vue?vue&type=script&lang=js
 /* harmony default export */ var components_AgoraV4Playervue_type_script_lang_js = (AgoraV4Playervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/AgoraV4Player.vue?vue&type=style&index=0&id=32567e18&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var AgoraV4Playervue_type_style_index_0_id_32567e18_prod_module_true_lang_scss = ({"root":"AgoraV4Player_root_R8QK3","is_screen":"AgoraV4Player_is_screen_r0Hmx","roundedBorder":"AgoraV4Player_roundedBorder_WAe4Z","video_item":"AgoraV4Player_video_item_rL_M9","mirror":"AgoraV4Player_mirror_Q9uBR","user_image":"AgoraV4Player_user_image_BALRm","screen":"AgoraV4Player_screen_ityqC","hoveringStage":"AgoraV4Player_hoveringStage_K1XHf","loader":"AgoraV4Player_loader_hppft","virtualBgPreview":"AgoraV4Player_virtualBgPreview_yG_YC","virtualBackground":"AgoraV4Player_virtualBackground_wEAa7","signalIndicator":"AgoraV4Player_signalIndicator_TUmOO"});
;// CONCATENATED MODULE: ./src/components/AgoraV4Player.vue?vue&type=style&index=0&id=32567e18&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/AgoraV4Player.vue



;




function AgoraV4Player_injectStyles (context) {
  
  this["$style"] = (AgoraV4Playervue_type_style_index_0_id_32567e18_prod_module_true_lang_scss.locals || AgoraV4Playervue_type_style_index_0_id_32567e18_prod_module_true_lang_scss)

}

/* normalize component */

var AgoraV4Player_component = normalizeComponent(
  components_AgoraV4Playervue_type_script_lang_js,
  AgoraV4Playervue_type_template_id_32567e18_render,
  AgoraV4Playervue_type_template_id_32567e18_staticRenderFns,
  false,
  AgoraV4Player_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AgoraV4Player = (AgoraV4Player_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/GenericHeaderNotification.vue?vue&type=template&id=bc60a026&functional=true
var GenericHeaderNotificationvue_type_template_id_bc60a026_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.text
  }, [_vm.props.iconName ? _c('IconButton', {
    class: _vm.$style.icon,
    attrs: {
      "icon": _vm.props.iconName,
      "variant": _vm.props.iconColor,
      "size": "regular",
      "alt": ""
    }
  }) : _vm._e(), _c('StyledText', {
    attrs: {
      "variant": "body15",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.text) + " ")])], 1)]);
};
var GenericHeaderNotificationvue_type_template_id_bc60a026_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/GenericHeaderNotification.vue?vue&type=script&lang=js
/* harmony default export */ var GenericHeaderNotificationvue_type_script_lang_js = ({
  functional: true,
  name: 'GenericHeaderNotification',
  props: {
    iconName: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: 'lightgreen'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/GenericHeaderNotification.vue?vue&type=script&lang=js
 /* harmony default export */ var components_GenericHeaderNotificationvue_type_script_lang_js = (GenericHeaderNotificationvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/GenericHeaderNotification.vue?vue&type=style&index=0&id=bc60a026&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var GenericHeaderNotificationvue_type_style_index_0_id_bc60a026_prod_module_true_lang_scss = ({"root":"GenericHeaderNotification_root_fkGbZ","icon":"GenericHeaderNotification_icon_GaHkU","text":"GenericHeaderNotification_text_FezN9"});
;// CONCATENATED MODULE: ./src/components/GenericHeaderNotification.vue?vue&type=style&index=0&id=bc60a026&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/GenericHeaderNotification.vue



;




function GenericHeaderNotification_injectStyles (context) {
  
  this["$style"] = (GenericHeaderNotificationvue_type_style_index_0_id_bc60a026_prod_module_true_lang_scss.locals || GenericHeaderNotificationvue_type_style_index_0_id_bc60a026_prod_module_true_lang_scss)

}

/* normalize component */

var GenericHeaderNotification_component = normalizeComponent(
  components_GenericHeaderNotificationvue_type_script_lang_js,
  GenericHeaderNotificationvue_type_template_id_bc60a026_functional_true_render,
  GenericHeaderNotificationvue_type_template_id_bc60a026_functional_true_staticRenderFns,
  true,
  GenericHeaderNotification_injectStyles,
  null,
  null
  
)

/* harmony default export */ var GenericHeaderNotification = (GenericHeaderNotification_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/HlsVideoPlayer.vue?vue&type=template&id=33fd0f4e
var HlsVideoPlayervue_type_template_id_33fd0f4e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root]
  }, [_c('div', {
    ref: "hlsVideoRoot",
    class: [_vm.$style.videoPlayerContainer, _vm.maintainHeight && _vm.$style.maintainHeight]
  }, [_c('Loading', {
    class: [_vm.$style.loader, _vm.$style.behindLoader],
    attrs: {
      "size": "small"
    }
  }), _c('div', {
    ref: "hlsProgressBarParent",
    class: _vm.$style.hlsParentBox,
    on: {
      "mousemove": _vm.hovered,
      "mouseleave": _vm.hoverout
    }
  }, [_c('video', {
    ref: "hlsPlayer",
    class: [_vm.$style.hlsPlayer, _vm.maintainHeight && _vm.$style.rounded],
    attrs: {
      "autoplay": true,
      "loop": _vm.loop
    },
    domProps: {
      "muted": _vm.muted
    }
  }), _vm.progressBarConfig.showProgressBar && _vm.isVideoHovered ? _c('VideoProgressBar', {
    style: _vm.width,
    attrs: {
      "id": "progressbar",
      "totalBarWidth": _vm.width,
      "progressBarConfig": _vm.progressBarConfig,
      "totalVideoDuration": _vm.progressBarConfig.totalVideoDuration,
      "currentDuration": _vm.progressBarConfig.currentVideoDuration,
      "showToolTip": !_vm.minimized
    }
  }) : _vm._e()], 1), _vm.bufferingAndPlaybackStalled ? _c('Loading', {
    class: _vm.$style.loader,
    attrs: {
      "size": "small"
    }
  }) : _vm._e()], 1)]);
};
var HlsVideoPlayervue_type_template_id_33fd0f4e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/hls.js@1.4.10/node_modules/hls.js/dist/hls.mjs
function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var urlToolkit = {exports: {}};

(function (module, exports) {
	// see https://tools.ietf.org/html/rfc1808

	(function (root) {
	  var URL_REGEX =
	    /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
	  var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
	  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
	  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;

	  var URLToolkit = {
	    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
	    // E.g
	    // With opts.alwaysNormalize = false (default, spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
	    // With opts.alwaysNormalize = true (not spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
	    buildAbsoluteURL: function (baseURL, relativeURL, opts) {
	      opts = opts || {};
	      // remove any remaining space and CRLF
	      baseURL = baseURL.trim();
	      relativeURL = relativeURL.trim();
	      if (!relativeURL) {
	        // 2a) If the embedded URL is entirely empty, it inherits the
	        // entire base URL (i.e., is set equal to the base URL)
	        // and we are done.
	        if (!opts.alwaysNormalize) {
	          return baseURL;
	        }
	        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
	        if (!basePartsForNormalise) {
	          throw new Error('Error trying to parse base URL.');
	        }
	        basePartsForNormalise.path = URLToolkit.normalizePath(
	          basePartsForNormalise.path
	        );
	        return URLToolkit.buildURLFromParts(basePartsForNormalise);
	      }
	      var relativeParts = URLToolkit.parseURL(relativeURL);
	      if (!relativeParts) {
	        throw new Error('Error trying to parse relative URL.');
	      }
	      if (relativeParts.scheme) {
	        // 2b) If the embedded URL starts with a scheme name, it is
	        // interpreted as an absolute URL and we are done.
	        if (!opts.alwaysNormalize) {
	          return relativeURL;
	        }
	        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
	        return URLToolkit.buildURLFromParts(relativeParts);
	      }
	      var baseParts = URLToolkit.parseURL(baseURL);
	      if (!baseParts) {
	        throw new Error('Error trying to parse base URL.');
	      }
	      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
	        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
	        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
	        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
	        baseParts.netLoc = pathParts[1];
	        baseParts.path = pathParts[2];
	      }
	      if (baseParts.netLoc && !baseParts.path) {
	        baseParts.path = '/';
	      }
	      var builtParts = {
	        // 2c) Otherwise, the embedded URL inherits the scheme of
	        // the base URL.
	        scheme: baseParts.scheme,
	        netLoc: relativeParts.netLoc,
	        path: null,
	        params: relativeParts.params,
	        query: relativeParts.query,
	        fragment: relativeParts.fragment,
	      };
	      if (!relativeParts.netLoc) {
	        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
	        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
	        // (if any) of the base URL.
	        builtParts.netLoc = baseParts.netLoc;
	        // 4) If the embedded URL path is preceded by a slash "/", the
	        // path is not relative and we skip to Step 7.
	        if (relativeParts.path[0] !== '/') {
	          if (!relativeParts.path) {
	            // 5) If the embedded URL path is empty (and not preceded by a
	            // slash), then the embedded URL inherits the base URL path
	            builtParts.path = baseParts.path;
	            // 5a) if the embedded URL's <params> is non-empty, we skip to
	            // step 7; otherwise, it inherits the <params> of the base
	            // URL (if any) and
	            if (!relativeParts.params) {
	              builtParts.params = baseParts.params;
	              // 5b) if the embedded URL's <query> is non-empty, we skip to
	              // step 7; otherwise, it inherits the <query> of the base
	              // URL (if any) and we skip to step 7.
	              if (!relativeParts.query) {
	                builtParts.query = baseParts.query;
	              }
	            }
	          } else {
	            // 6) The last segment of the base URL's path (anything
	            // following the rightmost slash "/", or the entire path if no
	            // slash is present) is removed and the embedded URL's path is
	            // appended in its place.
	            var baseURLPath = baseParts.path;
	            var newPath =
	              baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) +
	              relativeParts.path;
	            builtParts.path = URLToolkit.normalizePath(newPath);
	          }
	        }
	      }
	      if (builtParts.path === null) {
	        builtParts.path = opts.alwaysNormalize
	          ? URLToolkit.normalizePath(relativeParts.path)
	          : relativeParts.path;
	      }
	      return URLToolkit.buildURLFromParts(builtParts);
	    },
	    parseURL: function (url) {
	      var parts = URL_REGEX.exec(url);
	      if (!parts) {
	        return null;
	      }
	      return {
	        scheme: parts[1] || '',
	        netLoc: parts[2] || '',
	        path: parts[3] || '',
	        params: parts[4] || '',
	        query: parts[5] || '',
	        fragment: parts[6] || '',
	      };
	    },
	    normalizePath: function (path) {
	      // The following operations are
	      // then applied, in order, to the new path:
	      // 6a) All occurrences of "./", where "." is a complete path
	      // segment, are removed.
	      // 6b) If the path ends with "." as a complete path segment,
	      // that "." is removed.
	      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
	      // 6c) All occurrences of "<segment>/../", where <segment> is a
	      // complete path segment not equal to "..", are removed.
	      // Removal of these path segments is performed iteratively,
	      // removing the leftmost matching pattern on each iteration,
	      // until no matching pattern remains.
	      // 6d) If the path ends with "<segment>/..", where <segment> is a
	      // complete path segment not equal to "..", that
	      // "<segment>/.." is removed.
	      while (
	        path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length
	      ) {}
	      return path.split('').reverse().join('');
	    },
	    buildURLFromParts: function (parts) {
	      return (
	        parts.scheme +
	        parts.netLoc +
	        parts.path +
	        parts.params +
	        parts.query +
	        parts.fragment
	      );
	    },
	  };

	  module.exports = URLToolkit;
	})(); 
} (urlToolkit));

var urlToolkitExports = urlToolkit.exports;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

const isFiniteNumber = Number.isFinite || function (value) {
  return typeof value === 'number' && isFinite(value);
};

let Events = /*#__PURE__*/function (Events) {
  Events["MEDIA_ATTACHING"] = "hlsMediaAttaching";
  Events["MEDIA_ATTACHED"] = "hlsMediaAttached";
  Events["MEDIA_DETACHING"] = "hlsMediaDetaching";
  Events["MEDIA_DETACHED"] = "hlsMediaDetached";
  Events["BUFFER_RESET"] = "hlsBufferReset";
  Events["BUFFER_CODECS"] = "hlsBufferCodecs";
  Events["BUFFER_CREATED"] = "hlsBufferCreated";
  Events["BUFFER_APPENDING"] = "hlsBufferAppending";
  Events["BUFFER_APPENDED"] = "hlsBufferAppended";
  Events["BUFFER_EOS"] = "hlsBufferEos";
  Events["BUFFER_FLUSHING"] = "hlsBufferFlushing";
  Events["BUFFER_FLUSHED"] = "hlsBufferFlushed";
  Events["MANIFEST_LOADING"] = "hlsManifestLoading";
  Events["MANIFEST_LOADED"] = "hlsManifestLoaded";
  Events["MANIFEST_PARSED"] = "hlsManifestParsed";
  Events["LEVEL_SWITCHING"] = "hlsLevelSwitching";
  Events["LEVEL_SWITCHED"] = "hlsLevelSwitched";
  Events["LEVEL_LOADING"] = "hlsLevelLoading";
  Events["LEVEL_LOADED"] = "hlsLevelLoaded";
  Events["LEVEL_UPDATED"] = "hlsLevelUpdated";
  Events["LEVEL_PTS_UPDATED"] = "hlsLevelPtsUpdated";
  Events["LEVELS_UPDATED"] = "hlsLevelsUpdated";
  Events["AUDIO_TRACKS_UPDATED"] = "hlsAudioTracksUpdated";
  Events["AUDIO_TRACK_SWITCHING"] = "hlsAudioTrackSwitching";
  Events["AUDIO_TRACK_SWITCHED"] = "hlsAudioTrackSwitched";
  Events["AUDIO_TRACK_LOADING"] = "hlsAudioTrackLoading";
  Events["AUDIO_TRACK_LOADED"] = "hlsAudioTrackLoaded";
  Events["SUBTITLE_TRACKS_UPDATED"] = "hlsSubtitleTracksUpdated";
  Events["SUBTITLE_TRACKS_CLEARED"] = "hlsSubtitleTracksCleared";
  Events["SUBTITLE_TRACK_SWITCH"] = "hlsSubtitleTrackSwitch";
  Events["SUBTITLE_TRACK_LOADING"] = "hlsSubtitleTrackLoading";
  Events["SUBTITLE_TRACK_LOADED"] = "hlsSubtitleTrackLoaded";
  Events["SUBTITLE_FRAG_PROCESSED"] = "hlsSubtitleFragProcessed";
  Events["CUES_PARSED"] = "hlsCuesParsed";
  Events["NON_NATIVE_TEXT_TRACKS_FOUND"] = "hlsNonNativeTextTracksFound";
  Events["INIT_PTS_FOUND"] = "hlsInitPtsFound";
  Events["FRAG_LOADING"] = "hlsFragLoading";
  Events["FRAG_LOAD_EMERGENCY_ABORTED"] = "hlsFragLoadEmergencyAborted";
  Events["FRAG_LOADED"] = "hlsFragLoaded";
  Events["FRAG_DECRYPTED"] = "hlsFragDecrypted";
  Events["FRAG_PARSING_INIT_SEGMENT"] = "hlsFragParsingInitSegment";
  Events["FRAG_PARSING_USERDATA"] = "hlsFragParsingUserdata";
  Events["FRAG_PARSING_METADATA"] = "hlsFragParsingMetadata";
  Events["FRAG_PARSED"] = "hlsFragParsed";
  Events["FRAG_BUFFERED"] = "hlsFragBuffered";
  Events["FRAG_CHANGED"] = "hlsFragChanged";
  Events["FPS_DROP"] = "hlsFpsDrop";
  Events["FPS_DROP_LEVEL_CAPPING"] = "hlsFpsDropLevelCapping";
  Events["ERROR"] = "hlsError";
  Events["DESTROYING"] = "hlsDestroying";
  Events["KEY_LOADING"] = "hlsKeyLoading";
  Events["KEY_LOADED"] = "hlsKeyLoaded";
  Events["LIVE_BACK_BUFFER_REACHED"] = "hlsLiveBackBufferReached";
  Events["BACK_BUFFER_REACHED"] = "hlsBackBufferReached";
  return Events;
}({});

/**
 * Defines each Event type and payload by Event name. Used in {@link hls.js#HlsEventEmitter} to strongly type the event listener API.
 */

let ErrorTypes = /*#__PURE__*/function (ErrorTypes) {
  ErrorTypes["NETWORK_ERROR"] = "networkError";
  ErrorTypes["MEDIA_ERROR"] = "mediaError";
  ErrorTypes["KEY_SYSTEM_ERROR"] = "keySystemError";
  ErrorTypes["MUX_ERROR"] = "muxError";
  ErrorTypes["OTHER_ERROR"] = "otherError";
  return ErrorTypes;
}({});
let ErrorDetails = /*#__PURE__*/function (ErrorDetails) {
  ErrorDetails["KEY_SYSTEM_NO_KEYS"] = "keySystemNoKeys";
  ErrorDetails["KEY_SYSTEM_NO_ACCESS"] = "keySystemNoAccess";
  ErrorDetails["KEY_SYSTEM_NO_SESSION"] = "keySystemNoSession";
  ErrorDetails["KEY_SYSTEM_NO_CONFIGURED_LICENSE"] = "keySystemNoConfiguredLicense";
  ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"] = "keySystemLicenseRequestFailed";
  ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED"] = "keySystemServerCertificateRequestFailed";
  ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED"] = "keySystemServerCertificateUpdateFailed";
  ErrorDetails["KEY_SYSTEM_SESSION_UPDATE_FAILED"] = "keySystemSessionUpdateFailed";
  ErrorDetails["KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED"] = "keySystemStatusOutputRestricted";
  ErrorDetails["KEY_SYSTEM_STATUS_INTERNAL_ERROR"] = "keySystemStatusInternalError";
  ErrorDetails["MANIFEST_LOAD_ERROR"] = "manifestLoadError";
  ErrorDetails["MANIFEST_LOAD_TIMEOUT"] = "manifestLoadTimeOut";
  ErrorDetails["MANIFEST_PARSING_ERROR"] = "manifestParsingError";
  ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"] = "manifestIncompatibleCodecsError";
  ErrorDetails["LEVEL_EMPTY_ERROR"] = "levelEmptyError";
  ErrorDetails["LEVEL_LOAD_ERROR"] = "levelLoadError";
  ErrorDetails["LEVEL_LOAD_TIMEOUT"] = "levelLoadTimeOut";
  ErrorDetails["LEVEL_PARSING_ERROR"] = "levelParsingError";
  ErrorDetails["LEVEL_SWITCH_ERROR"] = "levelSwitchError";
  ErrorDetails["AUDIO_TRACK_LOAD_ERROR"] = "audioTrackLoadError";
  ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"] = "audioTrackLoadTimeOut";
  ErrorDetails["SUBTITLE_LOAD_ERROR"] = "subtitleTrackLoadError";
  ErrorDetails["SUBTITLE_TRACK_LOAD_TIMEOUT"] = "subtitleTrackLoadTimeOut";
  ErrorDetails["FRAG_LOAD_ERROR"] = "fragLoadError";
  ErrorDetails["FRAG_LOAD_TIMEOUT"] = "fragLoadTimeOut";
  ErrorDetails["FRAG_DECRYPT_ERROR"] = "fragDecryptError";
  ErrorDetails["FRAG_PARSING_ERROR"] = "fragParsingError";
  ErrorDetails["FRAG_GAP"] = "fragGap";
  ErrorDetails["REMUX_ALLOC_ERROR"] = "remuxAllocError";
  ErrorDetails["KEY_LOAD_ERROR"] = "keyLoadError";
  ErrorDetails["KEY_LOAD_TIMEOUT"] = "keyLoadTimeOut";
  ErrorDetails["BUFFER_ADD_CODEC_ERROR"] = "bufferAddCodecError";
  ErrorDetails["BUFFER_INCOMPATIBLE_CODECS_ERROR"] = "bufferIncompatibleCodecsError";
  ErrorDetails["BUFFER_APPEND_ERROR"] = "bufferAppendError";
  ErrorDetails["BUFFER_APPENDING_ERROR"] = "bufferAppendingError";
  ErrorDetails["BUFFER_STALLED_ERROR"] = "bufferStalledError";
  ErrorDetails["BUFFER_FULL_ERROR"] = "bufferFullError";
  ErrorDetails["BUFFER_SEEK_OVER_HOLE"] = "bufferSeekOverHole";
  ErrorDetails["BUFFER_NUDGE_ON_STALL"] = "bufferNudgeOnStall";
  ErrorDetails["INTERNAL_EXCEPTION"] = "internalException";
  ErrorDetails["INTERNAL_ABORTED"] = "aborted";
  ErrorDetails["UNKNOWN"] = "unknown";
  return ErrorDetails;
}({});

const noop = function noop() {};
const fakeLogger = {
  trace: noop,
  debug: noop,
  log: noop,
  warn: noop,
  info: noop,
  error: noop
};
let exportedLogger = fakeLogger;

// let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }

function consolePrintFn(type) {
  const func = self.console[type];
  if (func) {
    return func.bind(self.console, `[${type}] >`);
  }
  return noop;
}
function exportLoggerFunctions(debugConfig, ...functions) {
  functions.forEach(function (type) {
    exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
  });
}
function enableLogs(debugConfig, id) {
  // check that console is available
  if (self.console && debugConfig === true || typeof debugConfig === 'object') {
    exportLoggerFunctions(debugConfig,
    // Remove out from list here to hard-disable a log-level
    // 'trace',
    'debug', 'log', 'info', 'warn', 'error');
    // Some browsers don't allow to use bind on console object anyway
    // fallback to default if needed
    try {
      exportedLogger.log(`Debug logs enabled for "${id}" in hls.js version ${"1.4.10"}`);
    } catch (e) {
      exportedLogger = fakeLogger;
    }
  } else {
    exportedLogger = fakeLogger;
  }
}
const logger = exportedLogger;

const DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
const ATTR_LIST_REGEX = /(.+?)=(".*?"|.*?)(?:,|$)/g;

// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
class AttrList {
  constructor(attrs) {
    if (typeof attrs === 'string') {
      attrs = AttrList.parseAttrList(attrs);
    }
    for (const attr in attrs) {
      if (attrs.hasOwnProperty(attr)) {
        if (attr.substring(0, 2) === 'X-') {
          this.clientAttrs = this.clientAttrs || [];
          this.clientAttrs.push(attr);
        }
        this[attr] = attrs[attr];
      }
    }
  }
  decimalInteger(attrName) {
    const intValue = parseInt(this[attrName], 10);
    if (intValue > Number.MAX_SAFE_INTEGER) {
      return Infinity;
    }
    return intValue;
  }
  hexadecimalInteger(attrName) {
    if (this[attrName]) {
      let stringValue = (this[attrName] || '0x').slice(2);
      stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;
      const value = new Uint8Array(stringValue.length / 2);
      for (let i = 0; i < stringValue.length / 2; i++) {
        value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
      }
      return value;
    } else {
      return null;
    }
  }
  hexadecimalIntegerAsNumber(attrName) {
    const intValue = parseInt(this[attrName], 16);
    if (intValue > Number.MAX_SAFE_INTEGER) {
      return Infinity;
    }
    return intValue;
  }
  decimalFloatingPoint(attrName) {
    return parseFloat(this[attrName]);
  }
  optionalFloat(attrName, defaultValue) {
    const value = this[attrName];
    return value ? parseFloat(value) : defaultValue;
  }
  enumeratedString(attrName) {
    return this[attrName];
  }
  bool(attrName) {
    return this[attrName] === 'YES';
  }
  decimalResolution(attrName) {
    const res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
    if (res === null) {
      return undefined;
    }
    return {
      width: parseInt(res[1], 10),
      height: parseInt(res[2], 10)
    };
  }
  static parseAttrList(input) {
    let match;
    const attrs = {};
    const quote = '"';
    ATTR_LIST_REGEX.lastIndex = 0;
    while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
      let value = match[2];
      if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) {
        value = value.slice(1, -1);
      }
      const name = match[1].trim();
      attrs[name] = value;
    }
    return attrs;
  }
}

// Avoid exporting const enum so that these values can be inlined

function isDateRangeCueAttribute(attrName) {
  return attrName !== "ID" && attrName !== "CLASS" && attrName !== "START-DATE" && attrName !== "DURATION" && attrName !== "END-DATE" && attrName !== "END-ON-NEXT";
}
function isSCTE35Attribute(attrName) {
  return attrName === "SCTE35-OUT" || attrName === "SCTE35-IN";
}
class DateRange {
  constructor(dateRangeAttr, dateRangeWithSameId) {
    this.attr = void 0;
    this._startDate = void 0;
    this._endDate = void 0;
    this._badValueForSameId = void 0;
    if (dateRangeWithSameId) {
      const previousAttr = dateRangeWithSameId.attr;
      for (const key in previousAttr) {
        if (Object.prototype.hasOwnProperty.call(dateRangeAttr, key) && dateRangeAttr[key] !== previousAttr[key]) {
          logger.warn(`DATERANGE tag attribute: "${key}" does not match for tags with ID: "${dateRangeAttr.ID}"`);
          this._badValueForSameId = key;
          break;
        }
      }
      // Merge DateRange tags with the same ID
      dateRangeAttr = _extends(new AttrList({}), previousAttr, dateRangeAttr);
    }
    this.attr = dateRangeAttr;
    this._startDate = new Date(dateRangeAttr["START-DATE"]);
    if ("END-DATE" in this.attr) {
      const endDate = new Date(this.attr["END-DATE"]);
      if (isFiniteNumber(endDate.getTime())) {
        this._endDate = endDate;
      }
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    if (this._endDate) {
      return this._endDate;
    }
    const duration = this.duration;
    if (duration !== null) {
      return new Date(this._startDate.getTime() + duration * 1000);
    }
    return null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const duration = this.attr.decimalFloatingPoint("DURATION");
      if (isFiniteNumber(duration)) {
        return duration;
      }
    } else if (this._endDate) {
      return (this._endDate.getTime() - this._startDate.getTime()) / 1000;
    }
    return null;
  }
  get plannedDuration() {
    if ("PLANNED-DURATION" in this.attr) {
      return this.attr.decimalFloatingPoint("PLANNED-DURATION");
    }
    return null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && isFiniteNumber(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
  }
}

class LoadStats {
  constructor() {
    this.aborted = false;
    this.loaded = 0;
    this.retry = 0;
    this.total = 0;
    this.chunkCount = 0;
    this.bwEstimate = 0;
    this.loading = {
      start: 0,
      first: 0,
      end: 0
    };
    this.parsing = {
      start: 0,
      end: 0
    };
    this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}

var ElementaryStreamTypes = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class BaseSegment {
  // baseurl is the URL to the playlist

  // relurl is the portion of the URL that comes from inside the playlist.

  // Holds the types of data this fragment supports

  constructor(baseurl) {
    this._byteRange = null;
    this._url = null;
    this.baseurl = void 0;
    this.relurl = void 0;
    this.elementaryStreams = {
      [ElementaryStreamTypes.AUDIO]: null,
      [ElementaryStreamTypes.VIDEO]: null,
      [ElementaryStreamTypes.AUDIOVIDEO]: null
    };
    this.baseurl = baseurl;
  }

  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(value, previous) {
    const params = value.split('@', 2);
    const byteRange = [];
    if (params.length === 1) {
      byteRange[0] = previous ? previous.byteRangeEndOffset : 0;
    } else {
      byteRange[0] = parseInt(params[1]);
    }
    byteRange[1] = parseInt(params[0]) + byteRange[0];
    this._byteRange = byteRange;
  }
  get byteRange() {
    if (!this._byteRange) {
      return [];
    }
    return this._byteRange;
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get url() {
    if (!this._url && this.baseurl && this.relurl) {
      this._url = urlToolkitExports.buildAbsoluteURL(this.baseurl, this.relurl, {
        alwaysNormalize: true
      });
    }
    return this._url || '';
  }
  set url(value) {
    this._url = value;
  }
}

/**
 * Object representing parsed data from an HLS Segment. Found in {@link hls.js#LevelDetails.fragments}.
 */
class Fragment extends BaseSegment {
  // EXTINF has to be present for a m3u8 to be considered valid

  // sn notates the sequence number for a segment, and if set to a string can be 'initSegment'

  // levelkeys are the EXT-X-KEY tags that apply to this segment for decryption
  // core difference from the private field _decryptdata is the lack of the initialized IV
  // _decryptdata will set the IV for this segment based on the segment number in the fragment
  // A string representing the fragment type
  // A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading
  // A reference to the key loader. Set while the key is loading, and removed afterwards. Used to abort key loading
  // The level/track index to which the fragment belongs
  // The continuity counter of the fragment
  // The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
  // The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
  // The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
  // The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
  // The start time of the fragment, as listed in the manifest. Updated after transmux complete.
  // Set by `updateFragPTSDTS` in level-helper
  // The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
  // The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
  // Load/parse timing information
  // A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered
  // #EXTINF  segment title
  // The Media Initialization Section for this segment
  // Fragment is the last fragment in the media playlist
  // Fragment is marked by an EXT-X-GAP tag indicating that it does not contain media data and should not be loaded
  constructor(type, baseurl) {
    super(baseurl);
    this._decryptdata = null;
    this.rawProgramDateTime = null;
    this.programDateTime = null;
    this.tagList = [];
    this.duration = 0;
    this.sn = 0;
    this.levelkeys = void 0;
    this.type = void 0;
    this.loader = null;
    this.keyLoader = null;
    this.level = -1;
    this.cc = 0;
    this.startPTS = void 0;
    this.endPTS = void 0;
    this.startDTS = void 0;
    this.endDTS = void 0;
    this.start = 0;
    this.deltaPTS = void 0;
    this.maxStartPTS = void 0;
    this.minEndPTS = void 0;
    this.stats = new LoadStats();
    this.urlId = 0;
    this.data = void 0;
    this.bitrateTest = false;
    this.title = null;
    this.initSegment = null;
    this.endList = void 0;
    this.gap = void 0;
    this.type = type;
  }
  get decryptdata() {
    const {
      levelkeys
    } = this;
    if (!levelkeys && !this._decryptdata) {
      return null;
    }
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const key = this.levelkeys.identity;
      if (key) {
        this._decryptdata = key.getDecryptData(this.sn);
      } else {
        const keyFormats = Object.keys(this.levelkeys);
        if (keyFormats.length === 1) {
          return this._decryptdata = this.levelkeys[keyFormats[0]].getDecryptData(this.sn);
        }
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null) {
      return null;
    }
    if (!isFiniteNumber(this.programDateTime)) {
      return null;
    }
    const duration = !isFiniteNumber(this.duration) ? 0 : this.duration;
    return this.programDateTime + duration * 1000;
  }
  get encrypted() {
    var _this$_decryptdata;
    // At the m3u8-parser level we need to add support for manifest signalled keyformats
    // when we want the fragment to start reporting that it is encrypted.
    // Currently, keyFormat will only be set for identity keys
    if ((_this$_decryptdata = this._decryptdata) != null && _this$_decryptdata.encrypted) {
      return true;
    } else if (this.levelkeys) {
      const keyFormats = Object.keys(this.levelkeys);
      const len = keyFormats.length;
      if (len > 1 || len === 1 && this.levelkeys[keyFormats[0]].encrypted) {
        return true;
      }
    }
    return false;
  }
  setKeyFormat(keyFormat) {
    if (this.levelkeys) {
      const key = this.levelkeys[keyFormat];
      if (key && !this._decryptdata) {
        this._decryptdata = key.getDecryptData(this.sn);
      }
    }
  }
  abortRequests() {
    var _this$loader, _this$keyLoader;
    (_this$loader = this.loader) == null ? void 0 : _this$loader.abort();
    (_this$keyLoader = this.keyLoader) == null ? void 0 : _this$keyLoader.abort();
  }
  setElementaryStreamInfo(type, startPTS, endPTS, startDTS, endDTS, partial = false) {
    const {
      elementaryStreams
    } = this;
    const info = elementaryStreams[type];
    if (!info) {
      elementaryStreams[type] = {
        startPTS,
        endPTS,
        startDTS,
        endDTS,
        partial
      };
      return;
    }
    info.startPTS = Math.min(info.startPTS, startPTS);
    info.endPTS = Math.max(info.endPTS, endPTS);
    info.startDTS = Math.min(info.startDTS, startDTS);
    info.endDTS = Math.max(info.endDTS, endDTS);
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams
    } = this;
    elementaryStreams[ElementaryStreamTypes.AUDIO] = null;
    elementaryStreams[ElementaryStreamTypes.VIDEO] = null;
    elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO] = null;
  }
}

/**
 * Object representing parsed data from an HLS Partial Segment. Found in {@link hls.js#LevelDetails.partList}.
 */
class Part extends BaseSegment {
  constructor(partAttrs, frag, baseurl, index, previous) {
    super(baseurl);
    this.fragOffset = 0;
    this.duration = 0;
    this.gap = false;
    this.independent = false;
    this.relurl = void 0;
    this.fragment = void 0;
    this.index = void 0;
    this.stats = new LoadStats();
    this.duration = partAttrs.decimalFloatingPoint('DURATION');
    this.gap = partAttrs.bool('GAP');
    this.independent = partAttrs.bool('INDEPENDENT');
    this.relurl = partAttrs.enumeratedString('URI');
    this.fragment = frag;
    this.index = index;
    const byteRange = partAttrs.enumeratedString('BYTERANGE');
    if (byteRange) {
      this.setByteRange(byteRange, previous);
    }
    if (previous) {
      this.fragOffset = previous.fragOffset + previous.duration;
    }
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams
    } = this;
    return !!(elementaryStreams.audio || elementaryStreams.video || elementaryStreams.audiovideo);
  }
}

const DEFAULT_TARGET_DURATION = 10;

/**
 * Object representing parsed data from an HLS Media Playlist. Found in {@link hls.js#Level.details}.
 */
class LevelDetails {
  // Manifest reload synchronization

  constructor(baseUrl) {
    this.PTSKnown = false;
    this.alignedSliding = false;
    this.averagetargetduration = void 0;
    this.endCC = 0;
    this.endSN = 0;
    this.fragments = void 0;
    this.fragmentHint = void 0;
    this.partList = null;
    this.dateRanges = void 0;
    this.live = true;
    this.ageHeader = 0;
    this.advancedDateTime = void 0;
    this.updated = true;
    this.advanced = true;
    this.availabilityDelay = void 0;
    this.misses = 0;
    this.startCC = 0;
    this.startSN = 0;
    this.startTimeOffset = null;
    this.targetduration = 0;
    this.totalduration = 0;
    this.type = null;
    this.url = void 0;
    this.m3u8 = '';
    this.version = null;
    this.canBlockReload = false;
    this.canSkipUntil = 0;
    this.canSkipDateRanges = false;
    this.skippedSegments = 0;
    this.recentlyRemovedDateranges = void 0;
    this.partHoldBack = 0;
    this.holdBack = 0;
    this.partTarget = 0;
    this.preloadHint = void 0;
    this.renditionReports = void 0;
    this.tuneInGoal = 0;
    this.deltaUpdateFailed = void 0;
    this.driftStartTime = 0;
    this.driftEndTime = 0;
    this.driftStart = 0;
    this.driftEnd = 0;
    this.encryptedFragments = void 0;
    this.playlistParsingError = null;
    this.variableList = null;
    this.hasVariableRefs = false;
    this.fragments = [];
    this.encryptedFragments = [];
    this.dateRanges = {};
    this.url = baseUrl;
  }
  reloaded(previous) {
    if (!previous) {
      this.advanced = true;
      this.updated = true;
      return;
    }
    const partSnDiff = this.lastPartSn - previous.lastPartSn;
    const partIndexDiff = this.lastPartIndex - previous.lastPartIndex;
    this.updated = this.endSN !== previous.endSN || !!partIndexDiff || !!partSnDiff;
    this.advanced = this.endSN > previous.endSN || partSnDiff > 0 || partSnDiff === 0 && partIndexDiff > 0;
    if (this.updated || this.advanced) {
      this.misses = Math.floor(previous.misses * 0.6);
    } else {
      this.misses = previous.misses + 1;
    }
    this.availabilityDelay = previous.availabilityDelay;
  }
  get hasProgramDateTime() {
    if (this.fragments.length) {
      return isFiniteNumber(this.fragments[this.fragments.length - 1].programDateTime);
    }
    return false;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || DEFAULT_TARGET_DURATION;
  }
  get drift() {
    const runTime = this.driftEndTime - this.driftStartTime;
    if (runTime > 0) {
      const runDuration = this.driftEnd - this.driftStart;
      return runDuration * 1000 / runTime;
    }
    return 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var _this$partList;
    if ((_this$partList = this.partList) != null && _this$partList.length) {
      return this.partList[this.partList.length - 1].end;
    }
    return this.fragmentEnd;
  }
  get fragmentEnd() {
    var _this$fragments;
    if ((_this$fragments = this.fragments) != null && _this$fragments.length) {
      return this.fragments[this.fragments.length - 1].end;
    }
    return 0;
  }
  get age() {
    if (this.advancedDateTime) {
      return Math.max(Date.now() - this.advancedDateTime, 0) / 1000;
    }
    return 0;
  }
  get lastPartIndex() {
    var _this$partList2;
    if ((_this$partList2 = this.partList) != null && _this$partList2.length) {
      return this.partList[this.partList.length - 1].index;
    }
    return -1;
  }
  get lastPartSn() {
    var _this$partList3;
    if ((_this$partList3 = this.partList) != null && _this$partList3.length) {
      return this.partList[this.partList.length - 1].fragment.sn;
    }
    return this.endSN;
  }
}

function base64Decode(base64encodedStr) {
  return Uint8Array.from(atob(base64encodedStr), c => c.charCodeAt(0));
}

function getKeyIdBytes(str) {
  const keyIdbytes = strToUtf8array(str).subarray(0, 16);
  const paddedkeyIdbytes = new Uint8Array(16);
  paddedkeyIdbytes.set(keyIdbytes, 16 - keyIdbytes.length);
  return paddedkeyIdbytes;
}
function changeEndianness(keyId) {
  const swap = function swap(array, from, to) {
    const cur = array[from];
    array[from] = array[to];
    array[to] = cur;
  };
  swap(keyId, 0, 3);
  swap(keyId, 1, 2);
  swap(keyId, 4, 5);
  swap(keyId, 6, 7);
}
function convertDataUriToArrayBytes(uri) {
  // data:[<media type][;attribute=value][;base64],<data>
  const colonsplit = uri.split(':');
  let keydata = null;
  if (colonsplit[0] === 'data' && colonsplit.length === 2) {
    const semicolonsplit = colonsplit[1].split(';');
    const commasplit = semicolonsplit[semicolonsplit.length - 1].split(',');
    if (commasplit.length === 2) {
      const isbase64 = commasplit[0] === 'base64';
      const data = commasplit[1];
      if (isbase64) {
        semicolonsplit.splice(-1, 1); // remove from processing
        keydata = base64Decode(data);
      } else {
        keydata = getKeyIdBytes(data);
      }
    }
  }
  return keydata;
}
function strToUtf8array(str) {
  return Uint8Array.from(unescape(encodeURIComponent(str)), c => c.charCodeAt(0));
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */
var KeySystems = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
};

// Playlist #EXT-X-KEY KEYFORMAT values
var KeySystemFormats = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function keySystemFormatToKeySystemDomain(format) {
  switch (format) {
    case KeySystemFormats.FAIRPLAY:
      return KeySystems.FAIRPLAY;
    case KeySystemFormats.PLAYREADY:
      return KeySystems.PLAYREADY;
    case KeySystemFormats.WIDEVINE:
      return KeySystems.WIDEVINE;
    case KeySystemFormats.CLEARKEY:
      return KeySystems.CLEARKEY;
  }
}

// System IDs for which we can extract a key ID from "encrypted" event PSSH
var KeySystemIds = {
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function keySystemIdToKeySystemDomain(systemId) {
  if (systemId === KeySystemIds.WIDEVINE) {
    return KeySystems.WIDEVINE;
    // } else if (systemId === KeySystemIds.PLAYREADY) {
    //   return KeySystems.PLAYREADY;
    // } else if (systemId === KeySystemIds.CENC || systemId === KeySystemIds.CLEARKEY) {
    //   return KeySystems.CLEARKEY;
  }
}

function keySystemDomainToKeySystemFormat(keySystem) {
  switch (keySystem) {
    case KeySystems.FAIRPLAY:
      return KeySystemFormats.FAIRPLAY;
    case KeySystems.PLAYREADY:
      return KeySystemFormats.PLAYREADY;
    case KeySystems.WIDEVINE:
      return KeySystemFormats.WIDEVINE;
    case KeySystems.CLEARKEY:
      return KeySystemFormats.CLEARKEY;
  }
}
function getKeySystemsForConfig(config) {
  const {
    drmSystems,
    widevineLicenseUrl
  } = config;
  const keySystemsToAttempt = drmSystems ? [KeySystems.FAIRPLAY, KeySystems.WIDEVINE, KeySystems.PLAYREADY, KeySystems.CLEARKEY].filter(keySystem => !!drmSystems[keySystem]) : [];
  if (!keySystemsToAttempt[KeySystems.WIDEVINE] && widevineLicenseUrl) {
    keySystemsToAttempt.push(KeySystems.WIDEVINE);
  }
  return keySystemsToAttempt;
}
const requestMediaKeySystemAccess = function () {
  if (typeof self !== 'undefined' && self.navigator && self.navigator.requestMediaKeySystemAccess) {
    return self.navigator.requestMediaKeySystemAccess.bind(self.navigator);
  } else {
    return null;
  }
}();

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 */
function getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, drmSystemOptions) {
  let initDataTypes;
  switch (keySystem) {
    case KeySystems.FAIRPLAY:
      initDataTypes = ['cenc', 'sinf'];
      break;
    case KeySystems.WIDEVINE:
    case KeySystems.PLAYREADY:
      initDataTypes = ['cenc'];
      break;
    case KeySystems.CLEARKEY:
      initDataTypes = ['cenc', 'keyids'];
      break;
    default:
      throw new Error(`Unknown key-system: ${keySystem}`);
  }
  return createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions);
}
function createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions) {
  const baseConfig = {
    initDataTypes: initDataTypes,
    persistentState: drmSystemOptions.persistentState || 'not-allowed',
    distinctiveIdentifier: drmSystemOptions.distinctiveIdentifier || 'not-allowed',
    sessionTypes: drmSystemOptions.sessionTypes || [drmSystemOptions.sessionType || 'temporary'],
    audioCapabilities: audioCodecs.map(codec => ({
      contentType: `audio/mp4; codecs="${codec}"`,
      robustness: drmSystemOptions.audioRobustness || '',
      encryptionScheme: drmSystemOptions.audioEncryptionScheme || null
    })),
    videoCapabilities: videoCodecs.map(codec => ({
      contentType: `video/mp4; codecs="${codec}"`,
      robustness: drmSystemOptions.videoRobustness || '',
      encryptionScheme: drmSystemOptions.videoEncryptionScheme || null
    }))
  };
  return [baseConfig];
}

function sliceUint8(array, start, end) {
  // @ts-expect-error This polyfills IE11 usage of Uint8Array slice.
  // It always exists in the TypeScript definition so fails, but it fails at runtime on IE11.
  return Uint8Array.prototype.slice ? array.slice(start, end) : new Uint8Array(Array.prototype.slice.call(array, start, end));
}

// breaking up those two types in order to clarify what is happening in the decoding path.

/**
 * Returns true if an ID3 header can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */
const isHeader$2 = (data, offset) => {
  /*
   * http://id3.org/id3v2.3.0
   * [0]     = 'I'
   * [1]     = 'D'
   * [2]     = '3'
   * [3,4]   = {Version}
   * [5]     = {Flags}
   * [6-9]   = {ID3 Size}
   *
   * An ID3v2 tag can be detected with the following pattern:
   *  $49 44 33 yy yy xx zz zz zz zz
   * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
   */
  if (offset + 10 <= data.length) {
    // look for 'ID3' identifier
    if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) {
      // check version is within range
      if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
        // check size is within range
        if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
          return true;
        }
      }
    }
  }
  return false;
};

/**
 * Returns true if an ID3 footer can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */
const isFooter = (data, offset) => {
  /*
   * The footer is a copy of the header, but with a different identifier
   */
  if (offset + 10 <= data.length) {
    // look for '3DI' identifier
    if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) {
      // check version is within range
      if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
        // check size is within range
        if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
          return true;
        }
      }
    }
  }
  return false;
};

/**
 * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 * @returns the block of data containing any ID3 tags found
 * or *undefined* if no header is found at the starting offset
 */
const getID3Data = (data, offset) => {
  const front = offset;
  let length = 0;
  while (isHeader$2(data, offset)) {
    // ID3 header is 10 bytes
    length += 10;
    const size = readSize(data, offset + 6);
    length += size;
    if (isFooter(data, offset + 10)) {
      // ID3 footer is 10 bytes
      length += 10;
    }
    offset += length;
  }
  if (length > 0) {
    return data.subarray(front, front + length);
  }
  return undefined;
};
const readSize = (data, offset) => {
  let size = 0;
  size = (data[offset] & 0x7f) << 21;
  size |= (data[offset + 1] & 0x7f) << 14;
  size |= (data[offset + 2] & 0x7f) << 7;
  size |= data[offset + 3] & 0x7f;
  return size;
};
const canParse$2 = (data, offset) => {
  return isHeader$2(data, offset) && readSize(data, offset + 6) + 10 <= data.length - offset;
};

/**
 * Searches for the Elementary Stream timestamp found in the ID3 data chunk
 * @param data - Block of data containing one or more ID3 tags
 */
const getTimeStamp = data => {
  const frames = getID3Frames(data);
  for (let i = 0; i < frames.length; i++) {
    const frame = frames[i];
    if (isTimeStampFrame(frame)) {
      return readTimeStamp(frame);
    }
  }
  return undefined;
};

/**
 * Returns true if the ID3 frame is an Elementary Stream timestamp frame
 */
const isTimeStampFrame = frame => {
  return frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp';
};
const getFrameData = data => {
  /*
  Frame ID       $xx xx xx xx (four characters)
  Size           $xx xx xx xx
  Flags          $xx xx
  */
  const type = String.fromCharCode(data[0], data[1], data[2], data[3]);
  const size = readSize(data, 4);

  // skip frame id, size, and flags
  const offset = 10;
  return {
    type,
    size,
    data: data.subarray(offset, offset + size)
  };
};

/**
 * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
 * @param id3Data - The ID3 data containing one or more ID3 tags
 */
const getID3Frames = id3Data => {
  let offset = 0;
  const frames = [];
  while (isHeader$2(id3Data, offset)) {
    const size = readSize(id3Data, offset + 6);
    // skip past ID3 header
    offset += 10;
    const end = offset + size;
    // loop through frames in the ID3 tag
    while (offset + 8 < end) {
      const frameData = getFrameData(id3Data.subarray(offset));
      const frame = decodeFrame(frameData);
      if (frame) {
        frames.push(frame);
      }

      // skip frame header and frame data
      offset += frameData.size + 10;
    }
    if (isFooter(id3Data, offset)) {
      offset += 10;
    }
  }
  return frames;
};
const decodeFrame = frame => {
  if (frame.type === 'PRIV') {
    return decodePrivFrame(frame);
  } else if (frame.type[0] === 'W') {
    return decodeURLFrame(frame);
  }
  return decodeTextFrame(frame);
};
const decodePrivFrame = frame => {
  /*
  Format: <text string>\0<binary data>
  */
  if (frame.size < 2) {
    return undefined;
  }
  const owner = utf8ArrayToStr(frame.data, true);
  const privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
  return {
    key: frame.type,
    info: owner,
    data: privateData.buffer
  };
};
const decodeTextFrame = frame => {
  if (frame.size < 2) {
    return undefined;
  }
  if (frame.type === 'TXXX') {
    /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{Value}
    */
    let index = 1;
    const description = utf8ArrayToStr(frame.data.subarray(index), true);
    index += description.length + 1;
    const value = utf8ArrayToStr(frame.data.subarray(index));
    return {
      key: frame.type,
      info: description,
      data: value
    };
  }
  /*
  Format:
  [0]   = {Text Encoding}
  [1-?] = {Value}
  */
  const text = utf8ArrayToStr(frame.data.subarray(1));
  return {
    key: frame.type,
    data: text
  };
};
const decodeURLFrame = frame => {
  if (frame.type === 'WXXX') {
    /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{URL}
    */
    if (frame.size < 2) {
      return undefined;
    }
    let index = 1;
    const description = utf8ArrayToStr(frame.data.subarray(index), true);
    index += description.length + 1;
    const value = utf8ArrayToStr(frame.data.subarray(index));
    return {
      key: frame.type,
      info: description,
      data: value
    };
  }
  /*
  Format:
  [0-?] = {URL}
  */
  const url = utf8ArrayToStr(frame.data);
  return {
    key: frame.type,
    data: url
  };
};
const readTimeStamp = timeStampFrame => {
  if (timeStampFrame.data.byteLength === 8) {
    const data = new Uint8Array(timeStampFrame.data);
    // timestamp is 33 bit expressed as a big-endian eight-octet number,
    // with the upper 31 bits set to zero.
    const pts33Bit = data[3] & 0x1;
    let timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
    timestamp /= 45;
    if (pts33Bit) {
      timestamp += 47721858.84;
    } // 2^32 / 90

    return Math.round(timestamp);
  }
  return undefined;
};

// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */
const utf8ArrayToStr = (array, exitOnNull = false) => {
  const decoder = getTextDecoder();
  if (decoder) {
    const decoded = decoder.decode(array);
    if (exitOnNull) {
      // grab up to the first null
      const idx = decoded.indexOf('\0');
      return idx !== -1 ? decoded.substring(0, idx) : decoded;
    }

    // remove any null characters
    return decoded.replace(/\0/g, '');
  }
  const len = array.length;
  let c;
  let char2;
  let char3;
  let out = '';
  let i = 0;
  while (i < len) {
    c = array[i++];
    if (c === 0x00 && exitOnNull) {
      return out;
    } else if (c === 0x00 || c === 0x03) {
      // If the character is 3 (END_OF_TEXT) or 0 (NULL) then skip it
      continue;
    }
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12:
      case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode((c & 0x1f) << 6 | char2 & 0x3f);
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode((c & 0x0f) << 12 | (char2 & 0x3f) << 6 | (char3 & 0x3f) << 0);
        break;
    }
  }
  return out;
};
let decoder;
function getTextDecoder() {
  if (!decoder && typeof self.TextDecoder !== 'undefined') {
    decoder = new self.TextDecoder('utf-8');
  }
  return decoder;
}

/**
 *  hex dump helper class
 */

const Hex = {
  hexDump: function (array) {
    let str = '';
    for (let i = 0; i < array.length; i++) {
      let h = array[i].toString(16);
      if (h.length < 2) {
        h = '0' + h;
      }
      str += h;
    }
    return str;
  }
};

const UINT32_MAX$1 = Math.pow(2, 32) - 1;
const push = [].push;

// We are using fixed track IDs for driving the MP4 remuxer
// instead of following the TS PIDs.
// There is no reason not to do this and some browsers/SourceBuffer-demuxers
// may not like if there are TrackID "switches"
// See https://github.com/video-dev/hls.js/issues/1331
// Here we are mapping our internal track types to constant MP4 track IDs
// With MSE currently one can only have one track of each, and we are muxing
// whatever video/audio rendition in them.
const RemuxerTrackIdConfig = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function bin2str(data) {
  return String.fromCharCode.apply(null, data);
}
function readUint16(buffer, offset) {
  const val = buffer[offset] << 8 | buffer[offset + 1];
  return val < 0 ? 65536 + val : val;
}
function readUint32(buffer, offset) {
  const val = readSint32(buffer, offset);
  return val < 0 ? 4294967296 + val : val;
}
function readSint32(buffer, offset) {
  return buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
}
function writeUint32(buffer, offset, value) {
  buffer[offset] = value >> 24;
  buffer[offset + 1] = value >> 16 & 0xff;
  buffer[offset + 2] = value >> 8 & 0xff;
  buffer[offset + 3] = value & 0xff;
}

// Find the data for a box specified by its path
function findBox(data, path) {
  const results = [];
  if (!path.length) {
    // short-circuit the search for empty paths
    return results;
  }
  const end = data.byteLength;
  for (let i = 0; i < end;) {
    const size = readUint32(data, i);
    const type = bin2str(data.subarray(i + 4, i + 8));
    const endbox = size > 1 ? i + size : end;
    if (type === path[0]) {
      if (path.length === 1) {
        // this is the end of the path and we've found the box we were
        // looking for
        results.push(data.subarray(i + 8, endbox));
      } else {
        // recursively search for the next box along the path
        const subresults = findBox(data.subarray(i + 8, endbox), path.slice(1));
        if (subresults.length) {
          push.apply(results, subresults);
        }
      }
    }
    i = endbox;
  }

  // we've finished searching all of data
  return results;
}
function parseSegmentIndex(sidx) {
  const references = [];
  const version = sidx[0];

  // set initial offset, we skip the reference ID (not needed)
  let index = 8;
  const timescale = readUint32(sidx, index);
  index += 4;

  // TODO: parse earliestPresentationTime and firstOffset
  // usually zero in our case
  const earliestPresentationTime = 0;
  const firstOffset = 0;
  if (version === 0) {
    index += 8;
  } else {
    index += 16;
  }

  // skip reserved
  index += 2;
  let startByte = sidx.length + firstOffset;
  const referencesCount = readUint16(sidx, index);
  index += 2;
  for (let i = 0; i < referencesCount; i++) {
    let referenceIndex = index;
    const referenceInfo = readUint32(sidx, referenceIndex);
    referenceIndex += 4;
    const referenceSize = referenceInfo & 0x7fffffff;
    const referenceType = (referenceInfo & 0x80000000) >>> 31;
    if (referenceType === 1) {
      logger.warn('SIDX has hierarchical references (not supported)');
      return null;
    }
    const subsegmentDuration = readUint32(sidx, referenceIndex);
    referenceIndex += 4;
    references.push({
      referenceSize,
      subsegmentDuration,
      // unscaled
      info: {
        duration: subsegmentDuration / timescale,
        start: startByte,
        end: startByte + referenceSize - 1
      }
    });
    startByte += referenceSize;

    // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
    // for |sapDelta|.
    referenceIndex += 4;

    // skip to next ref
    index = referenceIndex;
  }
  return {
    earliestPresentationTime,
    timescale,
    version,
    referencesCount,
    references
  };
}

/**
 * Parses an MP4 initialization segment and extracts stream type and
 * timescale values for any declared tracks. Timescale values indicate the
 * number of clock ticks per second to assume for time-based values
 * elsewhere in the MP4.
 *
 * To determine the start time of an MP4, you need two pieces of
 * information: the timescale unit and the earliest base media decode
 * time. Multiple timescales can be specified within an MP4 but the
 * base media decode time is always expressed in the timescale from
 * the media header box for the track:
 * ```
 * moov > trak > mdia > mdhd.timescale
 * moov > trak > mdia > hdlr
 * ```
 * @param initSegment the bytes of the init segment
 * @returns a hash of track type to timescale values or null if
 * the init segment is malformed.
 */

function parseInitSegment(initSegment) {
  const result = [];
  const traks = findBox(initSegment, ['moov', 'trak']);
  for (let i = 0; i < traks.length; i++) {
    const trak = traks[i];
    const tkhd = findBox(trak, ['tkhd'])[0];
    if (tkhd) {
      let version = tkhd[0];
      let index = version === 0 ? 12 : 20;
      const trackId = readUint32(tkhd, index);
      const mdhd = findBox(trak, ['mdia', 'mdhd'])[0];
      if (mdhd) {
        version = mdhd[0];
        index = version === 0 ? 12 : 20;
        const timescale = readUint32(mdhd, index);
        const hdlr = findBox(trak, ['mdia', 'hdlr'])[0];
        if (hdlr) {
          const hdlrType = bin2str(hdlr.subarray(8, 12));
          const type = {
            soun: ElementaryStreamTypes.AUDIO,
            vide: ElementaryStreamTypes.VIDEO
          }[hdlrType];
          if (type) {
            // Parse codec details
            const stsd = findBox(trak, ['mdia', 'minf', 'stbl', 'stsd'])[0];
            let codec;
            if (stsd) {
              codec = bin2str(stsd.subarray(12, 16));
              // TODO: Parse codec details to be able to build MIME type.
              // stsd.start += 8;
              // const codecBox = findBox(stsd, [codec])[0];
              // if (codecBox) {
              //   TODO: Codec parsing support for avc1, mp4a, hevc, av01...
              // }
            }

            result[trackId] = {
              timescale,
              type
            };
            result[type] = {
              timescale,
              id: trackId,
              codec
            };
          }
        }
      }
    }
  }
  const trex = findBox(initSegment, ['moov', 'mvex', 'trex']);
  trex.forEach(trex => {
    const trackId = readUint32(trex, 4);
    const track = result[trackId];
    if (track) {
      track.default = {
        duration: readUint32(trex, 12),
        flags: readUint32(trex, 20)
      };
    }
  });
  return result;
}
function patchEncyptionData(initSegment, decryptdata) {
  if (!initSegment || !decryptdata) {
    return initSegment;
  }
  const keyId = decryptdata.keyId;
  if (keyId && decryptdata.isCommonEncryption) {
    const traks = findBox(initSegment, ['moov', 'trak']);
    traks.forEach(trak => {
      const stsd = findBox(trak, ['mdia', 'minf', 'stbl', 'stsd'])[0];

      // skip the sample entry count
      const sampleEntries = stsd.subarray(8);
      let encBoxes = findBox(sampleEntries, ['enca']);
      const isAudio = encBoxes.length > 0;
      if (!isAudio) {
        encBoxes = findBox(sampleEntries, ['encv']);
      }
      encBoxes.forEach(enc => {
        const encBoxChildren = isAudio ? enc.subarray(28) : enc.subarray(78);
        const sinfBoxes = findBox(encBoxChildren, ['sinf']);
        sinfBoxes.forEach(sinf => {
          const tenc = parseSinf(sinf);
          if (tenc) {
            // Look for default key id (keyID offset is always 8 within the tenc box):
            const tencKeyId = tenc.subarray(8, 24);
            if (!tencKeyId.some(b => b !== 0)) {
              logger.log(`[eme] Patching keyId in 'enc${isAudio ? 'a' : 'v'}>sinf>>tenc' box: ${Hex.hexDump(tencKeyId)} -> ${Hex.hexDump(keyId)}`);
              tenc.set(keyId, 8);
            }
          }
        });
      });
    });
  }
  return initSegment;
}
function parseSinf(sinf) {
  const schm = findBox(sinf, ['schm'])[0];
  if (schm) {
    const scheme = bin2str(schm.subarray(4, 8));
    if (scheme === 'cbcs' || scheme === 'cenc') {
      return findBox(sinf, ['schi', 'tenc'])[0];
    }
  }
  logger.error(`[eme] missing 'schm' box`);
  return null;
}

/**
 * Determine the base media decode start time, in seconds, for an MP4
 * fragment. If multiple fragments are specified, the earliest time is
 * returned.
 *
 * The base media decode time can be parsed from track fragment
 * metadata:
 * ```
 * moof > traf > tfdt.baseMediaDecodeTime
 * ```
 * It requires the timescale value from the mdhd to interpret.
 *
 * @param initData - a hash of track type to timescale values
 * @param fmp4 - the bytes of the mp4 fragment
 * @returns the earliest base media decode start time for the
 * fragment, in seconds
 */
function getStartDTS(initData, fmp4) {
  // we need info from two children of each track fragment box
  return findBox(fmp4, ['moof', 'traf']).reduce((result, traf) => {
    const tfdt = findBox(traf, ['tfdt'])[0];
    const version = tfdt[0];
    const start = findBox(traf, ['tfhd']).reduce((result, tfhd) => {
      // get the track id from the tfhd
      const id = readUint32(tfhd, 4);
      const track = initData[id];
      if (track) {
        let baseTime = readUint32(tfdt, 4);
        if (version === 1) {
          // If value is too large, assume signed 64-bit. Negative track fragment decode times are invalid, but they exist in the wild.
          // This prevents large values from being used for initPTS, which can cause playlist sync issues.
          // https://github.com/video-dev/hls.js/issues/5303
          if (baseTime === UINT32_MAX$1) {
            logger.warn(`[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time`);
            return result;
          }
          baseTime *= UINT32_MAX$1 + 1;
          baseTime += readUint32(tfdt, 8);
        }
        // assume a 90kHz clock if no timescale was specified
        const scale = track.timescale || 90e3;
        // convert base time to seconds
        const startTime = baseTime / scale;
        if (isFinite(startTime) && (result === null || startTime < result)) {
          return startTime;
        }
      }
      return result;
    }, null);
    if (start !== null && isFinite(start) && (result === null || start < result)) {
      return start;
    }
    return result;
  }, null);
}

/*
  For Reference:
  aligned(8) class TrackFragmentHeaderBox
           extends FullBox(‘tfhd’, 0, tf_flags){
     unsigned int(32)  track_ID;
     // all the following are optional fields
     unsigned int(64)  base_data_offset;
     unsigned int(32)  sample_description_index;
     unsigned int(32)  default_sample_duration;
     unsigned int(32)  default_sample_size;
     unsigned int(32)  default_sample_flags
  }
 */
function getDuration(data, initData) {
  let rawDuration = 0;
  let videoDuration = 0;
  let audioDuration = 0;
  const trafs = findBox(data, ['moof', 'traf']);
  for (let i = 0; i < trafs.length; i++) {
    const traf = trafs[i];
    // There is only one tfhd & trun per traf
    // This is true for CMAF style content, and we should perhaps check the ftyp
    // and only look for a single trun then, but for ISOBMFF we should check
    // for multiple track runs.
    const tfhd = findBox(traf, ['tfhd'])[0];
    // get the track id from the tfhd
    const id = readUint32(tfhd, 4);
    const track = initData[id];
    if (!track) {
      continue;
    }
    const trackDefault = track.default;
    const tfhdFlags = readUint32(tfhd, 0) | (trackDefault == null ? void 0 : trackDefault.flags);
    let sampleDuration = trackDefault == null ? void 0 : trackDefault.duration;
    if (tfhdFlags & 0x000008) {
      // 0x000008 indicates the presence of the default_sample_duration field
      if (tfhdFlags & 0x000002) {
        // 0x000002 indicates the presence of the sample_description_index field, which precedes default_sample_duration
        // If present, the default_sample_duration exists at byte offset 12
        sampleDuration = readUint32(tfhd, 12);
      } else {
        // Otherwise, the duration is at byte offset 8
        sampleDuration = readUint32(tfhd, 8);
      }
    }
    // assume a 90kHz clock if no timescale was specified
    const timescale = track.timescale || 90e3;
    const truns = findBox(traf, ['trun']);
    for (let j = 0; j < truns.length; j++) {
      rawDuration = computeRawDurationFromSamples(truns[j]);
      if (!rawDuration && sampleDuration) {
        const sampleCount = readUint32(truns[j], 4);
        rawDuration = sampleDuration * sampleCount;
      }
      if (track.type === ElementaryStreamTypes.VIDEO) {
        videoDuration += rawDuration / timescale;
      } else if (track.type === ElementaryStreamTypes.AUDIO) {
        audioDuration += rawDuration / timescale;
      }
    }
  }
  if (videoDuration === 0 && audioDuration === 0) {
    // If duration samples are not available in the traf use sidx subsegment_duration
    let sidxDuration = 0;
    const sidxs = findBox(data, ['sidx']);
    for (let i = 0; i < sidxs.length; i++) {
      const sidx = parseSegmentIndex(sidxs[i]);
      if (sidx != null && sidx.references) {
        sidxDuration += sidx.references.reduce((dur, ref) => dur + ref.info.duration || 0, 0);
      }
    }
    return sidxDuration;
  }
  if (videoDuration) {
    return videoDuration;
  }
  return audioDuration;
}

/*
  For Reference:
  aligned(8) class TrackRunBox
           extends FullBox(‘trun’, version, tr_flags) {
     unsigned int(32)  sample_count;
     // the following are optional fields
     signed int(32) data_offset;
     unsigned int(32)  first_sample_flags;
     // all fields in the following array are optional
     {
        unsigned int(32)  sample_duration;
        unsigned int(32)  sample_size;
        unsigned int(32)  sample_flags
        if (version == 0)
           { unsigned int(32)
        else
           { signed int(32)
     }[ sample_count ]
  }
 */
function computeRawDurationFromSamples(trun) {
  const flags = readUint32(trun, 0);
  // Flags are at offset 0, non-optional sample_count is at offset 4. Therefore we start 8 bytes in.
  // Each field is an int32, which is 4 bytes
  let offset = 8;
  // data-offset-present flag
  if (flags & 0x000001) {
    offset += 4;
  }
  // first-sample-flags-present flag
  if (flags & 0x000004) {
    offset += 4;
  }
  let duration = 0;
  const sampleCount = readUint32(trun, 4);
  for (let i = 0; i < sampleCount; i++) {
    // sample-duration-present flag
    if (flags & 0x000100) {
      const sampleDuration = readUint32(trun, offset);
      duration += sampleDuration;
      offset += 4;
    }
    // sample-size-present flag
    if (flags & 0x000200) {
      offset += 4;
    }
    // sample-flags-present flag
    if (flags & 0x000400) {
      offset += 4;
    }
    // sample-composition-time-offsets-present flag
    if (flags & 0x000800) {
      offset += 4;
    }
  }
  return duration;
}
function offsetStartDTS(initData, fmp4, timeOffset) {
  findBox(fmp4, ['moof', 'traf']).forEach(traf => {
    findBox(traf, ['tfhd']).forEach(tfhd => {
      // get the track id from the tfhd
      const id = readUint32(tfhd, 4);
      const track = initData[id];
      if (!track) {
        return;
      }
      // assume a 90kHz clock if no timescale was specified
      const timescale = track.timescale || 90e3;
      // get the base media decode time from the tfdt
      findBox(traf, ['tfdt']).forEach(tfdt => {
        const version = tfdt[0];
        let baseMediaDecodeTime = readUint32(tfdt, 4);
        if (version === 0) {
          baseMediaDecodeTime -= timeOffset * timescale;
          baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
          writeUint32(tfdt, 4, baseMediaDecodeTime);
        } else {
          baseMediaDecodeTime *= Math.pow(2, 32);
          baseMediaDecodeTime += readUint32(tfdt, 8);
          baseMediaDecodeTime -= timeOffset * timescale;
          baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
          const upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX$1 + 1));
          const lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX$1 + 1));
          writeUint32(tfdt, 4, upper);
          writeUint32(tfdt, 8, lower);
        }
      });
    });
  });
}

// TODO: Check if the last moof+mdat pair is part of the valid range
function segmentValidRange(data) {
  const segmentedRange = {
    valid: null,
    remainder: null
  };
  const moofs = findBox(data, ['moof']);
  if (!moofs) {
    return segmentedRange;
  } else if (moofs.length < 2) {
    segmentedRange.remainder = data;
    return segmentedRange;
  }
  const last = moofs[moofs.length - 1];
  // Offset by 8 bytes; findBox offsets the start by as much
  segmentedRange.valid = sliceUint8(data, 0, last.byteOffset - 8);
  segmentedRange.remainder = sliceUint8(data, last.byteOffset - 8);
  return segmentedRange;
}
function appendUint8Array(data1, data2) {
  const temp = new Uint8Array(data1.length + data2.length);
  temp.set(data1);
  temp.set(data2, data1.length);
  return temp;
}
function parseSamples(timeOffset, track) {
  const seiSamples = [];
  const videoData = track.samples;
  const timescale = track.timescale;
  const trackId = track.id;
  let isHEVCFlavor = false;
  const moofs = findBox(videoData, ['moof']);
  moofs.map(moof => {
    const moofOffset = moof.byteOffset - 8;
    const trafs = findBox(moof, ['traf']);
    trafs.map(traf => {
      // get the base media decode time from the tfdt
      const baseTime = findBox(traf, ['tfdt']).map(tfdt => {
        const version = tfdt[0];
        let result = readUint32(tfdt, 4);
        if (version === 1) {
          result *= Math.pow(2, 32);
          result += readUint32(tfdt, 8);
        }
        return result / timescale;
      })[0];
      if (baseTime !== undefined) {
        timeOffset = baseTime;
      }
      return findBox(traf, ['tfhd']).map(tfhd => {
        const id = readUint32(tfhd, 4);
        const tfhdFlags = readUint32(tfhd, 0) & 0xffffff;
        const baseDataOffsetPresent = (tfhdFlags & 0x000001) !== 0;
        const sampleDescriptionIndexPresent = (tfhdFlags & 0x000002) !== 0;
        const defaultSampleDurationPresent = (tfhdFlags & 0x000008) !== 0;
        let defaultSampleDuration = 0;
        const defaultSampleSizePresent = (tfhdFlags & 0x000010) !== 0;
        let defaultSampleSize = 0;
        const defaultSampleFlagsPresent = (tfhdFlags & 0x000020) !== 0;
        let tfhdOffset = 8;
        if (id === trackId) {
          if (baseDataOffsetPresent) {
            tfhdOffset += 8;
          }
          if (sampleDescriptionIndexPresent) {
            tfhdOffset += 4;
          }
          if (defaultSampleDurationPresent) {
            defaultSampleDuration = readUint32(tfhd, tfhdOffset);
            tfhdOffset += 4;
          }
          if (defaultSampleSizePresent) {
            defaultSampleSize = readUint32(tfhd, tfhdOffset);
            tfhdOffset += 4;
          }
          if (defaultSampleFlagsPresent) {
            tfhdOffset += 4;
          }
          if (track.type === 'video') {
            isHEVCFlavor = isHEVC(track.codec);
          }
          findBox(traf, ['trun']).map(trun => {
            const version = trun[0];
            const flags = readUint32(trun, 0) & 0xffffff;
            const dataOffsetPresent = (flags & 0x000001) !== 0;
            let dataOffset = 0;
            const firstSampleFlagsPresent = (flags & 0x000004) !== 0;
            const sampleDurationPresent = (flags & 0x000100) !== 0;
            let sampleDuration = 0;
            const sampleSizePresent = (flags & 0x000200) !== 0;
            let sampleSize = 0;
            const sampleFlagsPresent = (flags & 0x000400) !== 0;
            const sampleCompositionOffsetsPresent = (flags & 0x000800) !== 0;
            let compositionOffset = 0;
            const sampleCount = readUint32(trun, 4);
            let trunOffset = 8; // past version, flags, and sample count

            if (dataOffsetPresent) {
              dataOffset = readUint32(trun, trunOffset);
              trunOffset += 4;
            }
            if (firstSampleFlagsPresent) {
              trunOffset += 4;
            }
            let sampleOffset = dataOffset + moofOffset;
            for (let ix = 0; ix < sampleCount; ix++) {
              if (sampleDurationPresent) {
                sampleDuration = readUint32(trun, trunOffset);
                trunOffset += 4;
              } else {
                sampleDuration = defaultSampleDuration;
              }
              if (sampleSizePresent) {
                sampleSize = readUint32(trun, trunOffset);
                trunOffset += 4;
              } else {
                sampleSize = defaultSampleSize;
              }
              if (sampleFlagsPresent) {
                trunOffset += 4;
              }
              if (sampleCompositionOffsetsPresent) {
                if (version === 0) {
                  compositionOffset = readUint32(trun, trunOffset);
                } else {
                  compositionOffset = readSint32(trun, trunOffset);
                }
                trunOffset += 4;
              }
              if (track.type === ElementaryStreamTypes.VIDEO) {
                let naluTotalSize = 0;
                while (naluTotalSize < sampleSize) {
                  const naluSize = readUint32(videoData, sampleOffset);
                  sampleOffset += 4;
                  if (isSEIMessage(isHEVCFlavor, videoData[sampleOffset])) {
                    const data = videoData.subarray(sampleOffset, sampleOffset + naluSize);
                    parseSEIMessageFromNALu(data, isHEVCFlavor ? 2 : 1, timeOffset + compositionOffset / timescale, seiSamples);
                  }
                  sampleOffset += naluSize;
                  naluTotalSize += naluSize + 4;
                }
              }
              timeOffset += sampleDuration / timescale;
            }
          });
        }
      });
    });
  });
  return seiSamples;
}
function isHEVC(codec) {
  if (!codec) {
    return false;
  }
  const delimit = codec.indexOf('.');
  const baseCodec = delimit < 0 ? codec : codec.substring(0, delimit);
  return baseCodec === 'hvc1' || baseCodec === 'hev1' ||
  // Dolby Vision
  baseCodec === 'dvh1' || baseCodec === 'dvhe';
}
function isSEIMessage(isHEVCFlavor, naluHeader) {
  if (isHEVCFlavor) {
    const naluType = naluHeader >> 1 & 0x3f;
    return naluType === 39 || naluType === 40;
  } else {
    const naluType = naluHeader & 0x1f;
    return naluType === 6;
  }
}
function parseSEIMessageFromNALu(unescapedData, headerSize, pts, samples) {
  const data = discardEPB(unescapedData);
  let seiPtr = 0;
  // skip nal header
  seiPtr += headerSize;
  let payloadType = 0;
  let payloadSize = 0;
  let endOfCaptions = false;
  let b = 0;
  while (seiPtr < data.length) {
    payloadType = 0;
    do {
      if (seiPtr >= data.length) {
        break;
      }
      b = data[seiPtr++];
      payloadType += b;
    } while (b === 0xff);

    // Parse payload size.
    payloadSize = 0;
    do {
      if (seiPtr >= data.length) {
        break;
      }
      b = data[seiPtr++];
      payloadSize += b;
    } while (b === 0xff);
    const leftOver = data.length - seiPtr;
    if (!endOfCaptions && payloadType === 4 && seiPtr < data.length) {
      endOfCaptions = true;
      const countryCode = data[seiPtr++];
      if (countryCode === 181) {
        const providerCode = readUint16(data, seiPtr);
        seiPtr += 2;
        if (providerCode === 49) {
          const userStructure = readUint32(data, seiPtr);
          seiPtr += 4;
          if (userStructure === 0x47413934) {
            const userDataType = data[seiPtr++];

            // Raw CEA-608 bytes wrapped in CEA-708 packet
            if (userDataType === 3) {
              const firstByte = data[seiPtr++];
              const totalCCs = 0x1f & firstByte;
              const enabled = 0x40 & firstByte;
              const totalBytes = enabled ? 2 + totalCCs * 3 : 0;
              const byteArray = new Uint8Array(totalBytes);
              if (enabled) {
                byteArray[0] = firstByte;
                for (let i = 1; i < totalBytes; i++) {
                  byteArray[i] = data[seiPtr++];
                }
              }
              samples.push({
                type: userDataType,
                payloadType,
                pts,
                bytes: byteArray
              });
            }
          }
        }
      }
    } else if (payloadType === 5 && payloadSize < leftOver) {
      endOfCaptions = true;
      if (payloadSize > 16) {
        const uuidStrArray = [];
        for (let i = 0; i < 16; i++) {
          const _b = data[seiPtr++].toString(16);
          uuidStrArray.push(_b.length == 1 ? '0' + _b : _b);
          if (i === 3 || i === 5 || i === 7 || i === 9) {
            uuidStrArray.push('-');
          }
        }
        const length = payloadSize - 16;
        const userDataBytes = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
          userDataBytes[i] = data[seiPtr++];
        }
        samples.push({
          payloadType,
          pts,
          uuid: uuidStrArray.join(''),
          userData: utf8ArrayToStr(userDataBytes),
          userDataBytes
        });
      }
    } else if (payloadSize < leftOver) {
      seiPtr += payloadSize;
    } else if (payloadSize > leftOver) {
      break;
    }
  }
}

/**
 * remove Emulation Prevention bytes from a RBSP
 */
function discardEPB(data) {
  const length = data.byteLength;
  const EPBPositions = [];
  let i = 1;

  // Find all `Emulation Prevention Bytes`
  while (i < length - 2) {
    if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
      EPBPositions.push(i + 2);
      i += 2;
    } else {
      i++;
    }
  }

  // If no Emulation Prevention Bytes were found just return the original
  // array
  if (EPBPositions.length === 0) {
    return data;
  }

  // Create a new array to hold the NAL unit data
  const newLength = length - EPBPositions.length;
  const newData = new Uint8Array(newLength);
  let sourceIndex = 0;
  for (i = 0; i < newLength; sourceIndex++, i++) {
    if (sourceIndex === EPBPositions[0]) {
      // Skip this byte
      sourceIndex++;
      // Remove this position index
      EPBPositions.shift();
    }
    newData[i] = data[sourceIndex];
  }
  return newData;
}
function parseEmsg(data) {
  const version = data[0];
  let schemeIdUri = '';
  let value = '';
  let timeScale = 0;
  let presentationTimeDelta = 0;
  let presentationTime = 0;
  let eventDuration = 0;
  let id = 0;
  let offset = 0;
  if (version === 0) {
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      schemeIdUri += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    schemeIdUri += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      value += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    value += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    timeScale = readUint32(data, 12);
    presentationTimeDelta = readUint32(data, 16);
    eventDuration = readUint32(data, 20);
    id = readUint32(data, 24);
    offset = 28;
  } else if (version === 1) {
    offset += 4;
    timeScale = readUint32(data, offset);
    offset += 4;
    const leftPresentationTime = readUint32(data, offset);
    offset += 4;
    const rightPresentationTime = readUint32(data, offset);
    offset += 4;
    presentationTime = 2 ** 32 * leftPresentationTime + rightPresentationTime;
    if (!Number.isSafeInteger(presentationTime)) {
      presentationTime = Number.MAX_SAFE_INTEGER;
      logger.warn('Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box');
    }
    eventDuration = readUint32(data, offset);
    offset += 4;
    id = readUint32(data, offset);
    offset += 4;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      schemeIdUri += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    schemeIdUri += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      value += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    value += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
  }
  const payload = data.subarray(offset, data.byteLength);
  return {
    schemeIdUri,
    value,
    timeScale,
    presentationTime,
    presentationTimeDelta,
    eventDuration,
    id,
    payload
  };
}
function mp4Box(type, ...payload) {
  const len = payload.length;
  let size = 8;
  let i = len;
  while (i--) {
    size += payload[i].byteLength;
  }
  const result = new Uint8Array(size);
  result[0] = size >> 24 & 0xff;
  result[1] = size >> 16 & 0xff;
  result[2] = size >> 8 & 0xff;
  result[3] = size & 0xff;
  result.set(type, 4);
  for (i = 0, size = 8; i < len; i++) {
    result.set(payload[i], size);
    size += payload[i].byteLength;
  }
  return result;
}
function mp4pssh(systemId, keyids, data) {
  if (systemId.byteLength !== 16) {
    throw new RangeError('Invalid system id');
  }
  let version;
  let kids;
  if (keyids) {
    version = 1;
    kids = new Uint8Array(keyids.length * 16);
    for (let ix = 0; ix < keyids.length; ix++) {
      const k = keyids[ix]; // uint8array
      if (k.byteLength !== 16) {
        throw new RangeError('Invalid key');
      }
      kids.set(k, ix * 16);
    }
  } else {
    version = 0;
    kids = new Uint8Array();
  }
  let kidCount;
  if (version > 0) {
    kidCount = new Uint8Array(4);
    if (keyids.length > 0) {
      new DataView(kidCount.buffer).setUint32(0, keyids.length, false);
    }
  } else {
    kidCount = new Uint8Array();
  }
  const dataSize = new Uint8Array(4);
  if (data && data.byteLength > 0) {
    new DataView(dataSize.buffer).setUint32(0, data.byteLength, false);
  }
  return mp4Box([112, 115, 115, 104], new Uint8Array([version, 0x00, 0x00, 0x00 // Flags
  ]), systemId,
  // 16 bytes
  kidCount, kids, dataSize, data || new Uint8Array());
}
function parsePssh(initData) {
  if (!(initData instanceof ArrayBuffer) || initData.byteLength < 32) {
    return null;
  }
  const result = {
    version: 0,
    systemId: '',
    kids: null,
    data: null
  };
  const view = new DataView(initData);
  const boxSize = view.getUint32(0);
  if (initData.byteLength !== boxSize && boxSize > 44) {
    return null;
  }
  const type = view.getUint32(4);
  if (type !== 0x70737368) {
    return null;
  }
  result.version = view.getUint32(8) >>> 24;
  if (result.version > 1) {
    return null;
  }
  result.systemId = Hex.hexDump(new Uint8Array(initData, 12, 16));
  const dataSizeOrKidCount = view.getUint32(28);
  if (result.version === 0) {
    if (boxSize - 32 < dataSizeOrKidCount) {
      return null;
    }
    result.data = new Uint8Array(initData, 32, dataSizeOrKidCount);
  } else if (result.version === 1) {
    result.kids = [];
    for (let i = 0; i < dataSizeOrKidCount; i++) {
      result.kids.push(new Uint8Array(initData, 32 + i * 16, 16));
    }
  }
  return result;
}

let keyUriToKeyIdMap = {};
class LevelKey {
  static clearKeyUriToKeyIdMap() {
    keyUriToKeyIdMap = {};
  }
  constructor(method, uri, format, formatversions = [1], iv = null) {
    this.uri = void 0;
    this.method = void 0;
    this.keyFormat = void 0;
    this.keyFormatVersions = void 0;
    this.encrypted = void 0;
    this.isCommonEncryption = void 0;
    this.iv = null;
    this.key = null;
    this.keyId = null;
    this.pssh = null;
    this.method = method;
    this.uri = uri;
    this.keyFormat = format;
    this.keyFormatVersions = formatversions;
    this.iv = iv;
    this.encrypted = method ? method !== 'NONE' : false;
    this.isCommonEncryption = this.encrypted && method !== 'AES-128';
  }
  isSupported() {
    // If it's Segment encryption or No encryption, just select that key system
    if (this.method) {
      if (this.method === 'AES-128' || this.method === 'NONE') {
        return true;
      }
      if (this.keyFormat === 'identity') {
        // Maintain support for clear SAMPLE-AES with MPEG-3 TS
        return this.method === 'SAMPLE-AES';
      } else {
        switch (this.keyFormat) {
          case KeySystemFormats.FAIRPLAY:
          case KeySystemFormats.WIDEVINE:
          case KeySystemFormats.PLAYREADY:
          case KeySystemFormats.CLEARKEY:
            return ['ISO-23001-7', 'SAMPLE-AES', 'SAMPLE-AES-CENC', 'SAMPLE-AES-CTR'].indexOf(this.method) !== -1;
        }
      }
    }
    return false;
  }
  getDecryptData(sn) {
    if (!this.encrypted || !this.uri) {
      return null;
    }
    if (this.method === 'AES-128' && this.uri && !this.iv) {
      if (typeof sn !== 'number') {
        // We are fetching decryption data for a initialization segment
        // If the segment was encrypted with AES-128
        // It must have an IV defined. We cannot substitute the Segment Number in.
        if (this.method === 'AES-128' && !this.iv) {
          logger.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`);
        }
        // Explicitly set sn to resulting value from implicit conversions 'initSegment' values for IV generation.
        sn = 0;
      }
      const iv = createInitializationVector(sn);
      const decryptdata = new LevelKey(this.method, this.uri, 'identity', this.keyFormatVersions, iv);
      return decryptdata;
    }

    // Initialize keyId if possible
    const keyBytes = convertDataUriToArrayBytes(this.uri);
    if (keyBytes) {
      switch (this.keyFormat) {
        case KeySystemFormats.WIDEVINE:
          this.pssh = keyBytes;
          // In case of widevine keyID is embedded in PSSH box. Read Key ID.
          if (keyBytes.length >= 22) {
            this.keyId = keyBytes.subarray(keyBytes.length - 22, keyBytes.length - 6);
          }
          break;
        case KeySystemFormats.PLAYREADY:
          {
            const PlayReadyKeySystemUUID = new Uint8Array([0x9a, 0x04, 0xf0, 0x79, 0x98, 0x40, 0x42, 0x86, 0xab, 0x92, 0xe6, 0x5b, 0xe0, 0x88, 0x5f, 0x95]);
            this.pssh = mp4pssh(PlayReadyKeySystemUUID, null, keyBytes);
            const keyBytesUtf16 = new Uint16Array(keyBytes.buffer, keyBytes.byteOffset, keyBytes.byteLength / 2);
            const keyByteStr = String.fromCharCode.apply(null, Array.from(keyBytesUtf16));

            // Parse Playready WRMHeader XML
            const xmlKeyBytes = keyByteStr.substring(keyByteStr.indexOf('<'), keyByteStr.length);
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlKeyBytes, 'text/xml');
            const keyData = xmlDoc.getElementsByTagName('KID')[0];
            if (keyData) {
              const keyId = keyData.childNodes[0] ? keyData.childNodes[0].nodeValue : keyData.getAttribute('VALUE');
              if (keyId) {
                const keyIdArray = base64Decode(keyId).subarray(0, 16);
                // KID value in PRO is a base64-encoded little endian GUID interpretation of UUID
                // KID value in ‘tenc’ is a big endian UUID GUID interpretation of UUID
                changeEndianness(keyIdArray);
                this.keyId = keyIdArray;
              }
            }
            break;
          }
        default:
          {
            let keydata = keyBytes.subarray(0, 16);
            if (keydata.length !== 16) {
              const padded = new Uint8Array(16);
              padded.set(keydata, 16 - keydata.length);
              keydata = padded;
            }
            this.keyId = keydata;
            break;
          }
      }
    }

    // Default behavior: assign a new keyId for each uri
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let keyId = keyUriToKeyIdMap[this.uri];
      if (!keyId) {
        const val = Object.keys(keyUriToKeyIdMap).length % Number.MAX_SAFE_INTEGER;
        keyId = new Uint8Array(16);
        const dv = new DataView(keyId.buffer, 12, 4); // Just set the last 4 bytes
        dv.setUint32(0, val);
        keyUriToKeyIdMap[this.uri] = keyId;
      }
      this.keyId = keyId;
    }
    return this;
  }
}
function createInitializationVector(segmentNumber) {
  const uint8View = new Uint8Array(16);
  for (let i = 12; i < 16; i++) {
    uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
  }
  return uint8View;
}

const VARIABLE_REPLACEMENT_REGEX = /\{\$([a-zA-Z0-9-_]+)\}/g;
function hasVariableReferences(str) {
  return VARIABLE_REPLACEMENT_REGEX.test(str);
}
function substituteVariablesInAttributes(parsed, attr, attributeNames) {
  if (parsed.variableList !== null || parsed.hasVariableRefs) {
    for (let i = attributeNames.length; i--;) {
      const name = attributeNames[i];
      const value = attr[name];
      if (value) {
        attr[name] = substituteVariables(parsed, value);
      }
    }
  }
}
function substituteVariables(parsed, value) {
  if (parsed.variableList !== null || parsed.hasVariableRefs) {
    const variableList = parsed.variableList;
    return value.replace(VARIABLE_REPLACEMENT_REGEX, variableReference => {
      const variableName = variableReference.substring(2, variableReference.length - 1);
      const variableValue = variableList == null ? void 0 : variableList[variableName];
      if (variableValue === undefined) {
        parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${variableName}"`));
        return variableReference;
      }
      return variableValue;
    });
  }
  return value;
}
function addVariableDefinition(parsed, attr, parentUrl) {
  let variableList = parsed.variableList;
  if (!variableList) {
    parsed.variableList = variableList = {};
  }
  let NAME;
  let VALUE;
  if ('QUERYPARAM' in attr) {
    NAME = attr.QUERYPARAM;
    try {
      const searchParams = new self.URL(parentUrl).searchParams;
      if (searchParams.has(NAME)) {
        VALUE = searchParams.get(NAME);
      } else {
        throw new Error(`"${NAME}" does not match any query parameter in URI: "${parentUrl}"`);
      }
    } catch (error) {
      parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${error.message}`));
    }
  } else {
    NAME = attr.NAME;
    VALUE = attr.VALUE;
  }
  if (NAME in variableList) {
    parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${NAME}"`));
  } else {
    variableList[NAME] = VALUE || '';
  }
}
function importVariableDefinition(parsed, attr, sourceVariableList) {
  const IMPORT = attr.IMPORT;
  if (sourceVariableList && IMPORT in sourceVariableList) {
    let variableList = parsed.variableList;
    if (!variableList) {
      parsed.variableList = variableList = {};
    }
    variableList[IMPORT] = sourceVariableList[IMPORT];
  } else {
    parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${IMPORT}"`));
  }
}

/**
 * MediaSource helper
 */

function getMediaSource() {
  if (typeof self === 'undefined') return undefined;
  return self.MediaSource || self.WebKitMediaSource;
}

// from http://mp4ra.org/codecs.html
const sampleEntryCodesISO = {
  audio: {
    a3ds: true,
    'ac-3': true,
    'ac-4': true,
    alac: true,
    alaw: true,
    dra1: true,
    'dts+': true,
    'dts-': true,
    dtsc: true,
    dtse: true,
    dtsh: true,
    'ec-3': true,
    enca: true,
    g719: true,
    g726: true,
    m4ae: true,
    mha1: true,
    mha2: true,
    mhm1: true,
    mhm2: true,
    mlpa: true,
    mp4a: true,
    'raw ': true,
    Opus: true,
    opus: true,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: true,
    sawb: true,
    sawp: true,
    sevc: true,
    sqcp: true,
    ssmv: true,
    twos: true,
    ulaw: true
  },
  video: {
    avc1: true,
    avc2: true,
    avc3: true,
    avc4: true,
    avcp: true,
    av01: true,
    drac: true,
    dva1: true,
    dvav: true,
    dvh1: true,
    dvhe: true,
    encv: true,
    hev1: true,
    hvc1: true,
    mjp2: true,
    mp4v: true,
    mvc1: true,
    mvc2: true,
    mvc3: true,
    mvc4: true,
    resv: true,
    rv60: true,
    s263: true,
    svc1: true,
    svc2: true,
    'vc-1': true,
    vp08: true,
    vp09: true
  },
  text: {
    stpp: true,
    wvtt: true
  }
};
const MediaSource$2 = getMediaSource();
function isCodecType(codec, type) {
  const typeCodes = sampleEntryCodesISO[type];
  return !!typeCodes && typeCodes[codec.slice(0, 4)] === true;
}
function isCodecSupportedInMp4(codec, type) {
  var _MediaSource$isTypeSu;
  return (_MediaSource$isTypeSu = MediaSource$2 == null ? void 0 : MediaSource$2.isTypeSupported(`${type || 'video'}/mp4;codecs="${codec}"`)) != null ? _MediaSource$isTypeSu : false;
}

const MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g;
const MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
const IS_MEDIA_PLAYLIST = /^#EXT(?:INF|-X-TARGETDURATION):/m; // Handle empty Media Playlist (first EXTINF not signaled, but TARGETDURATION present)

const LEVEL_PLAYLIST_REGEX_FAST = new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
// duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
/(?!#) *(\S[\S ]*)/.source,
// segment URI, group 3 => the URI (note newline is not eaten)
/#EXT-X-BYTERANGE:*(.+)/.source,
// next segment's byterange, group 4 => range spec (x@y)
/#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
// next segment's program date/time group 5 => the datetime spec
/#.*/.source // All other non-segment oriented tags will match with all groups empty
].join('|'), 'g');
const LEVEL_PLAYLIST_REGEX_SLOW = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join('|'));
class M3U8Parser {
  static findGroup(groups, mediaGroupId) {
    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];
      if (group.id === mediaGroupId) {
        return group;
      }
    }
  }
  static convertAVC1ToAVCOTI(codec) {
    // Convert avc1 codec string from RFC-4281 to RFC-6381 for MediaSource.isTypeSupported
    const avcdata = codec.split('.');
    if (avcdata.length > 2) {
      let result = avcdata.shift() + '.';
      result += parseInt(avcdata.shift()).toString(16);
      result += ('000' + parseInt(avcdata.shift()).toString(16)).slice(-4);
      return result;
    }
    return codec;
  }
  static resolve(url, baseUrl) {
    return urlToolkitExports.buildAbsoluteURL(baseUrl, url, {
      alwaysNormalize: true
    });
  }
  static isMediaPlaylist(str) {
    return IS_MEDIA_PLAYLIST.test(str);
  }
  static parseMasterPlaylist(string, baseurl) {
    const hasVariableRefs = hasVariableReferences(string) ;
    const parsed = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs
    };
    const levelsWithKnownCodecs = [];
    MASTER_PLAYLIST_REGEX.lastIndex = 0;
    let result;
    while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
      if (result[1]) {
        var _level$unknownCodecs;
        // '#EXT-X-STREAM-INF' is found, parse level tag  in group 1
        const attrs = new AttrList(result[1]);
        {
          substituteVariablesInAttributes(parsed, attrs, ['CODECS', 'SUPPLEMENTAL-CODECS', 'ALLOWED-CPC', 'PATHWAY-ID', 'STABLE-VARIANT-ID', 'AUDIO', 'VIDEO', 'SUBTITLES', 'CLOSED-CAPTIONS', 'NAME']);
        }
        const uri = substituteVariables(parsed, result[2]) ;
        const level = {
          attrs,
          bitrate: attrs.decimalInteger('AVERAGE-BANDWIDTH') || attrs.decimalInteger('BANDWIDTH'),
          name: attrs.NAME,
          url: M3U8Parser.resolve(uri, baseurl)
        };
        const resolution = attrs.decimalResolution('RESOLUTION');
        if (resolution) {
          level.width = resolution.width;
          level.height = resolution.height;
        }
        setCodecs((attrs.CODECS || '').split(/[ ,]+/).filter(c => c), level);
        if (level.videoCodec && level.videoCodec.indexOf('avc1') !== -1) {
          level.videoCodec = M3U8Parser.convertAVC1ToAVCOTI(level.videoCodec);
        }
        if (!((_level$unknownCodecs = level.unknownCodecs) != null && _level$unknownCodecs.length)) {
          levelsWithKnownCodecs.push(level);
        }
        parsed.levels.push(level);
      } else if (result[3]) {
        const tag = result[3];
        const attributes = result[4];
        switch (tag) {
          case 'SESSION-DATA':
            {
              // #EXT-X-SESSION-DATA
              const sessionAttrs = new AttrList(attributes);
              {
                substituteVariablesInAttributes(parsed, sessionAttrs, ['DATA-ID', 'LANGUAGE', 'VALUE', 'URI']);
              }
              const dataId = sessionAttrs['DATA-ID'];
              if (dataId) {
                if (parsed.sessionData === null) {
                  parsed.sessionData = {};
                }
                parsed.sessionData[dataId] = sessionAttrs;
              }
              break;
            }
          case 'SESSION-KEY':
            {
              // #EXT-X-SESSION-KEY
              const sessionKey = parseKey(attributes, baseurl, parsed);
              if (sessionKey.encrypted && sessionKey.isSupported()) {
                if (parsed.sessionKeys === null) {
                  parsed.sessionKeys = [];
                }
                parsed.sessionKeys.push(sessionKey);
              } else {
                logger.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${attributes}"`);
              }
              break;
            }
          case 'DEFINE':
            {
              // #EXT-X-DEFINE
              {
                const variableAttributes = new AttrList(attributes);
                substituteVariablesInAttributes(parsed, variableAttributes, ['NAME', 'VALUE', 'QUERYPARAM']);
                addVariableDefinition(parsed, variableAttributes, baseurl);
              }
              break;
            }
          case 'CONTENT-STEERING':
            {
              // #EXT-X-CONTENT-STEERING
              const contentSteeringAttributes = new AttrList(attributes);
              {
                substituteVariablesInAttributes(parsed, contentSteeringAttributes, ['SERVER-URI', 'PATHWAY-ID']);
              }
              parsed.contentSteering = {
                uri: M3U8Parser.resolve(contentSteeringAttributes['SERVER-URI'], baseurl),
                pathwayId: contentSteeringAttributes['PATHWAY-ID'] || '.'
              };
              break;
            }
          case 'START':
            {
              // #EXT-X-START
              parsed.startTimeOffset = parseStartTimeOffset(attributes);
              break;
            }
        }
      }
    }
    // Filter out levels with unknown codecs if it does not remove all levels
    const stripUnknownCodecLevels = levelsWithKnownCodecs.length > 0 && levelsWithKnownCodecs.length < parsed.levels.length;
    parsed.levels = stripUnknownCodecLevels ? levelsWithKnownCodecs : parsed.levels;
    if (parsed.levels.length === 0) {
      parsed.playlistParsingError = new Error('no levels found in manifest');
    }
    return parsed;
  }
  static parseMasterPlaylistMedia(string, baseurl, parsed) {
    let result;
    const results = {};
    const levels = parsed.levels;
    const groupsByType = {
      AUDIO: levels.map(level => ({
        id: level.attrs.AUDIO,
        audioCodec: level.audioCodec
      })),
      SUBTITLES: levels.map(level => ({
        id: level.attrs.SUBTITLES,
        textCodec: level.textCodec
      })),
      'CLOSED-CAPTIONS': []
    };
    let id = 0;
    MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
    while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null) {
      const attrs = new AttrList(result[1]);
      const type = attrs.TYPE;
      if (type) {
        const groups = groupsByType[type];
        const medias = results[type] || [];
        results[type] = medias;
        {
          substituteVariablesInAttributes(parsed, attrs, ['URI', 'GROUP-ID', 'LANGUAGE', 'ASSOC-LANGUAGE', 'STABLE-RENDITION-ID', 'NAME', 'INSTREAM-ID', 'CHARACTERISTICS', 'CHANNELS']);
        }
        const media = {
          attrs,
          bitrate: 0,
          id: id++,
          groupId: attrs['GROUP-ID'] || '',
          instreamId: attrs['INSTREAM-ID'],
          name: attrs.NAME || attrs.LANGUAGE || '',
          type,
          default: attrs.bool('DEFAULT'),
          autoselect: attrs.bool('AUTOSELECT'),
          forced: attrs.bool('FORCED'),
          lang: attrs.LANGUAGE,
          url: attrs.URI ? M3U8Parser.resolve(attrs.URI, baseurl) : ''
        };
        if (groups != null && groups.length) {
          // If there are audio or text groups signalled in the manifest, let's look for a matching codec string for this track
          // If we don't find the track signalled, lets use the first audio groups codec we have
          // Acting as a best guess
          const groupCodec = M3U8Parser.findGroup(groups, media.groupId) || groups[0];
          assignCodec(media, groupCodec, 'audioCodec');
          assignCodec(media, groupCodec, 'textCodec');
        }
        medias.push(media);
      }
    }
    return results;
  }
  static parseLevelPlaylist(string, baseurl, id, type, levelUrlId, multivariantVariableList) {
    const level = new LevelDetails(baseurl);
    const fragments = level.fragments;
    // The most recent init segment seen (applies to all subsequent segments)
    let currentInitSegment = null;
    let currentSN = 0;
    let currentPart = 0;
    let totalduration = 0;
    let discontinuityCounter = 0;
    let prevFrag = null;
    let frag = new Fragment(type, baseurl);
    let result;
    let i;
    let levelkeys;
    let firstPdtIndex = -1;
    let createNextFrag = false;
    LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
    level.m3u8 = string;
    level.hasVariableRefs = hasVariableReferences(string) ;
    while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
      if (createNextFrag) {
        createNextFrag = false;
        frag = new Fragment(type, baseurl);
        // setup the next fragment for part loading
        frag.start = totalduration;
        frag.sn = currentSN;
        frag.cc = discontinuityCounter;
        frag.level = id;
        if (currentInitSegment) {
          frag.initSegment = currentInitSegment;
          frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
          currentInitSegment.rawProgramDateTime = null;
        }
      }
      const duration = result[1];
      if (duration) {
        // INF
        frag.duration = parseFloat(duration);
        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
        const title = (' ' + result[2]).slice(1);
        frag.title = title || null;
        frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);
      } else if (result[3]) {
        // url
        if (isFiniteNumber(frag.duration)) {
          frag.start = totalduration;
          if (levelkeys) {
            setFragLevelKeys(frag, levelkeys, level);
          }
          frag.sn = currentSN;
          frag.level = id;
          frag.cc = discontinuityCounter;
          frag.urlId = levelUrlId;
          fragments.push(frag);
          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          const uri = (' ' + result[3]).slice(1);
          frag.relurl = substituteVariables(level, uri) ;
          assignProgramDateTime(frag, prevFrag);
          prevFrag = frag;
          totalduration += frag.duration;
          currentSN++;
          currentPart = 0;
          createNextFrag = true;
        }
      } else if (result[4]) {
        // X-BYTERANGE
        const data = (' ' + result[4]).slice(1);
        if (prevFrag) {
          frag.setByteRange(data, prevFrag);
        } else {
          frag.setByteRange(data);
        }
      } else if (result[5]) {
        // PROGRAM-DATE-TIME
        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
        frag.rawProgramDateTime = (' ' + result[5]).slice(1);
        frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
        if (firstPdtIndex === -1) {
          firstPdtIndex = fragments.length;
        }
      } else {
        result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
        if (!result) {
          logger.warn('No matches on slow regex match for level playlist!');
          continue;
        }
        for (i = 1; i < result.length; i++) {
          if (typeof result[i] !== 'undefined') {
            break;
          }
        }

        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
        const tag = (' ' + result[i]).slice(1);
        const value1 = (' ' + result[i + 1]).slice(1);
        const value2 = result[i + 2] ? (' ' + result[i + 2]).slice(1) : '';
        switch (tag) {
          case 'PLAYLIST-TYPE':
            level.type = value1.toUpperCase();
            break;
          case 'MEDIA-SEQUENCE':
            currentSN = level.startSN = parseInt(value1);
            break;
          case 'SKIP':
            {
              const skipAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, skipAttrs, ['RECENTLY-REMOVED-DATERANGES']);
              }
              const skippedSegments = skipAttrs.decimalInteger('SKIPPED-SEGMENTS');
              if (isFiniteNumber(skippedSegments)) {
                level.skippedSegments = skippedSegments;
                // This will result in fragments[] containing undefined values, which we will fill in with `mergeDetails`
                for (let _i = skippedSegments; _i--;) {
                  fragments.unshift(null);
                }
                currentSN += skippedSegments;
              }
              const recentlyRemovedDateranges = skipAttrs.enumeratedString('RECENTLY-REMOVED-DATERANGES');
              if (recentlyRemovedDateranges) {
                level.recentlyRemovedDateranges = recentlyRemovedDateranges.split('\t');
              }
              break;
            }
          case 'TARGETDURATION':
            level.targetduration = Math.max(parseInt(value1), 1);
            break;
          case 'VERSION':
            level.version = parseInt(value1);
            break;
          case 'EXTM3U':
            break;
          case 'ENDLIST':
            level.live = false;
            break;
          case '#':
            if (value1 || value2) {
              frag.tagList.push(value2 ? [value1, value2] : [value1]);
            }
            break;
          case 'DISCONTINUITY':
            discontinuityCounter++;
            frag.tagList.push(['DIS']);
            break;
          case 'GAP':
            frag.gap = true;
            frag.tagList.push([tag]);
            break;
          case 'BITRATE':
            frag.tagList.push([tag, value1]);
            break;
          case 'DATERANGE':
            {
              const dateRangeAttr = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, dateRangeAttr, ['ID', 'CLASS', 'START-DATE', 'END-DATE', 'SCTE35-CMD', 'SCTE35-OUT', 'SCTE35-IN']);
                substituteVariablesInAttributes(level, dateRangeAttr, dateRangeAttr.clientAttrs);
              }
              const dateRange = new DateRange(dateRangeAttr, level.dateRanges[dateRangeAttr.ID]);
              if (dateRange.isValid || level.skippedSegments) {
                level.dateRanges[dateRange.id] = dateRange;
              } else {
                logger.warn(`Ignoring invalid DATERANGE tag: "${value1}"`);
              }
              // Add to fragment tag list for backwards compatibility (< v1.2.0)
              frag.tagList.push(['EXT-X-DATERANGE', value1]);
              break;
            }
          case 'DEFINE':
            {
              {
                const variableAttributes = new AttrList(value1);
                substituteVariablesInAttributes(level, variableAttributes, ['NAME', 'VALUE', 'IMPORT', 'QUERYPARAM']);
                if ('IMPORT' in variableAttributes) {
                  importVariableDefinition(level, variableAttributes, multivariantVariableList);
                } else {
                  addVariableDefinition(level, variableAttributes, baseurl);
                }
              }
              break;
            }
          case 'DISCONTINUITY-SEQUENCE':
            discontinuityCounter = parseInt(value1);
            break;
          case 'KEY':
            {
              const levelKey = parseKey(value1, baseurl, level);
              if (levelKey.isSupported()) {
                if (levelKey.method === 'NONE') {
                  levelkeys = undefined;
                  break;
                }
                if (!levelkeys) {
                  levelkeys = {};
                }
                if (levelkeys[levelKey.keyFormat]) {
                  levelkeys = _extends({}, levelkeys);
                }
                levelkeys[levelKey.keyFormat] = levelKey;
              } else {
                logger.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${value1}"`);
              }
              break;
            }
          case 'START':
            level.startTimeOffset = parseStartTimeOffset(value1);
            break;
          case 'MAP':
            {
              const mapAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, mapAttrs, ['BYTERANGE', 'URI']);
              }
              if (frag.duration) {
                // Initial segment tag is after segment duration tag.
                //   #EXTINF: 6.0
                //   #EXT-X-MAP:URI="init.mp4
                const init = new Fragment(type, baseurl);
                setInitSegment(init, mapAttrs, id, levelkeys);
                currentInitSegment = init;
                frag.initSegment = currentInitSegment;
                if (currentInitSegment.rawProgramDateTime && !frag.rawProgramDateTime) {
                  frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                }
              } else {
                // Initial segment tag is before segment duration tag
                setInitSegment(frag, mapAttrs, id, levelkeys);
                currentInitSegment = frag;
                createNextFrag = true;
              }
              break;
            }
          case 'SERVER-CONTROL':
            {
              const serverControlAttrs = new AttrList(value1);
              level.canBlockReload = serverControlAttrs.bool('CAN-BLOCK-RELOAD');
              level.canSkipUntil = serverControlAttrs.optionalFloat('CAN-SKIP-UNTIL', 0);
              level.canSkipDateRanges = level.canSkipUntil > 0 && serverControlAttrs.bool('CAN-SKIP-DATERANGES');
              level.partHoldBack = serverControlAttrs.optionalFloat('PART-HOLD-BACK', 0);
              level.holdBack = serverControlAttrs.optionalFloat('HOLD-BACK', 0);
              break;
            }
          case 'PART-INF':
            {
              const partInfAttrs = new AttrList(value1);
              level.partTarget = partInfAttrs.decimalFloatingPoint('PART-TARGET');
              break;
            }
          case 'PART':
            {
              let partList = level.partList;
              if (!partList) {
                partList = level.partList = [];
              }
              const previousFragmentPart = currentPart > 0 ? partList[partList.length - 1] : undefined;
              const index = currentPart++;
              const partAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, partAttrs, ['BYTERANGE', 'URI']);
              }
              const part = new Part(partAttrs, frag, baseurl, index, previousFragmentPart);
              partList.push(part);
              frag.duration += part.duration;
              break;
            }
          case 'PRELOAD-HINT':
            {
              const preloadHintAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, preloadHintAttrs, ['URI']);
              }
              level.preloadHint = preloadHintAttrs;
              break;
            }
          case 'RENDITION-REPORT':
            {
              const renditionReportAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, renditionReportAttrs, ['URI']);
              }
              level.renditionReports = level.renditionReports || [];
              level.renditionReports.push(renditionReportAttrs);
              break;
            }
          default:
            logger.warn(`line parsed but not handled: ${result}`);
            break;
        }
      }
    }
    if (prevFrag && !prevFrag.relurl) {
      fragments.pop();
      totalduration -= prevFrag.duration;
      if (level.partList) {
        level.fragmentHint = prevFrag;
      }
    } else if (level.partList) {
      assignProgramDateTime(frag, prevFrag);
      frag.cc = discontinuityCounter;
      level.fragmentHint = frag;
      if (levelkeys) {
        setFragLevelKeys(frag, levelkeys, level);
      }
    }
    const fragmentLength = fragments.length;
    const firstFragment = fragments[0];
    const lastFragment = fragments[fragmentLength - 1];
    totalduration += level.skippedSegments * level.targetduration;
    if (totalduration > 0 && fragmentLength && lastFragment) {
      level.averagetargetduration = totalduration / fragmentLength;
      const lastSn = lastFragment.sn;
      level.endSN = lastSn !== 'initSegment' ? lastSn : 0;
      if (!level.live) {
        lastFragment.endList = true;
      }
      if (firstFragment) {
        level.startCC = firstFragment.cc;
      }
    } else {
      level.endSN = 0;
      level.startCC = 0;
    }
    if (level.fragmentHint) {
      totalduration += level.fragmentHint.duration;
    }
    level.totalduration = totalduration;
    level.endCC = discontinuityCounter;

    /**
     * Backfill any missing PDT values
     * "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
     * one or more Media Segment URIs, the client SHOULD extrapolate
     * backward from that tag (using EXTINF durations and/or media
     * timestamps) to associate dates with those segments."
     * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
     * computed.
     */
    if (firstPdtIndex > 0) {
      backfillProgramDateTimes(fragments, firstPdtIndex);
    }
    return level;
  }
}
function parseKey(keyTagAttributes, baseurl, parsed) {
  var _keyAttrs$METHOD, _keyAttrs$KEYFORMAT;
  // https://tools.ietf.org/html/rfc8216#section-4.3.2.4
  const keyAttrs = new AttrList(keyTagAttributes);
  {
    substituteVariablesInAttributes(parsed, keyAttrs, ['KEYFORMAT', 'KEYFORMATVERSIONS', 'URI', 'IV', 'URI']);
  }
  const decryptmethod = (_keyAttrs$METHOD = keyAttrs.METHOD) != null ? _keyAttrs$METHOD : '';
  const decrypturi = keyAttrs.URI;
  const decryptiv = keyAttrs.hexadecimalInteger('IV');
  const decryptkeyformatversions = keyAttrs.KEYFORMATVERSIONS;
  // From RFC: This attribute is OPTIONAL; its absence indicates an implicit value of "identity".
  const decryptkeyformat = (_keyAttrs$KEYFORMAT = keyAttrs.KEYFORMAT) != null ? _keyAttrs$KEYFORMAT : 'identity';
  if (decrypturi && keyAttrs.IV && !decryptiv) {
    logger.error(`Invalid IV: ${keyAttrs.IV}`);
  }
  // If decrypturi is a URI with a scheme, then baseurl will be ignored
  // No uri is allowed when METHOD is NONE
  const resolvedUri = decrypturi ? M3U8Parser.resolve(decrypturi, baseurl) : '';
  const keyFormatVersions = (decryptkeyformatversions ? decryptkeyformatversions : '1').split('/').map(Number).filter(Number.isFinite);
  return new LevelKey(decryptmethod, resolvedUri, decryptkeyformat, keyFormatVersions, decryptiv);
}
function parseStartTimeOffset(startAttributes) {
  const startAttrs = new AttrList(startAttributes);
  const startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
  if (isFiniteNumber(startTimeOffset)) {
    return startTimeOffset;
  }
  return null;
}
function setCodecs(codecs, level) {
  ['video', 'audio', 'text'].forEach(type => {
    const filtered = codecs.filter(codec => isCodecType(codec, type));
    if (filtered.length) {
      const preferred = filtered.filter(codec => {
        return codec.lastIndexOf('avc1', 0) === 0 || codec.lastIndexOf('mp4a', 0) === 0;
      });
      level[`${type}Codec`] = preferred.length > 0 ? preferred[0] : filtered[0];

      // remove from list
      codecs = codecs.filter(codec => filtered.indexOf(codec) === -1);
    }
  });
  level.unknownCodecs = codecs;
}
function assignCodec(media, groupItem, codecProperty) {
  const codecValue = groupItem[codecProperty];
  if (codecValue) {
    media[codecProperty] = codecValue;
  }
}
function backfillProgramDateTimes(fragments, firstPdtIndex) {
  let fragPrev = fragments[firstPdtIndex];
  for (let i = firstPdtIndex; i--;) {
    const frag = fragments[i];
    // Exit on delta-playlist skipped segments
    if (!frag) {
      return;
    }
    frag.programDateTime = fragPrev.programDateTime - frag.duration * 1000;
    fragPrev = frag;
  }
}
function assignProgramDateTime(frag, prevFrag) {
  if (frag.rawProgramDateTime) {
    frag.programDateTime = Date.parse(frag.rawProgramDateTime);
  } else if (prevFrag != null && prevFrag.programDateTime) {
    frag.programDateTime = prevFrag.endProgramDateTime;
  }
  if (!isFiniteNumber(frag.programDateTime)) {
    frag.programDateTime = null;
    frag.rawProgramDateTime = null;
  }
}
function setInitSegment(frag, mapAttrs, id, levelkeys) {
  frag.relurl = mapAttrs.URI;
  if (mapAttrs.BYTERANGE) {
    frag.setByteRange(mapAttrs.BYTERANGE);
  }
  frag.level = id;
  frag.sn = 'initSegment';
  if (levelkeys) {
    frag.levelkeys = levelkeys;
  }
  frag.initSegment = null;
}
function setFragLevelKeys(frag, levelkeys, level) {
  frag.levelkeys = levelkeys;
  const {
    encryptedFragments
  } = level;
  if ((!encryptedFragments.length || encryptedFragments[encryptedFragments.length - 1].levelkeys !== levelkeys) && Object.keys(levelkeys).some(format => levelkeys[format].isCommonEncryption)) {
    encryptedFragments.push(frag);
  }
}

var PlaylistContextType = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
};
var PlaylistLevelType = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};

function mapContextToLevelType(context) {
  const {
    type
  } = context;
  switch (type) {
    case PlaylistContextType.AUDIO_TRACK:
      return PlaylistLevelType.AUDIO;
    case PlaylistContextType.SUBTITLE_TRACK:
      return PlaylistLevelType.SUBTITLE;
    default:
      return PlaylistLevelType.MAIN;
  }
}
function getResponseUrl(response, context) {
  let url = response.url;
  // responseURL not supported on some browsers (it is used to detect URL redirection)
  // data-uri mode also not supported (but no need to detect redirection)
  if (url === undefined || url.indexOf('data:') === 0) {
    // fallback to initial URL
    url = context.url;
  }
  return url;
}
class PlaylistLoader {
  constructor(hls) {
    this.hls = void 0;
    this.loaders = Object.create(null);
    this.variableList = null;
    this.hls = hls;
    this.registerListeners();
  }
  startLoad(startPosition) {}
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
    hls.on(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
    hls.off(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }

  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(context) {
    const config = this.hls.config;
    const PLoader = config.pLoader;
    const Loader = config.loader;
    const InternalLoader = PLoader || Loader;
    const loader = new InternalLoader(config);
    this.loaders[context.type] = loader;
    return loader;
  }
  getInternalLoader(context) {
    return this.loaders[context.type];
  }
  resetInternalLoader(contextType) {
    if (this.loaders[contextType]) {
      delete this.loaders[contextType];
    }
  }

  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const contextType in this.loaders) {
      const loader = this.loaders[contextType];
      if (loader) {
        loader.destroy();
      }
      this.resetInternalLoader(contextType);
    }
  }
  destroy() {
    this.variableList = null;
    this.unregisterListeners();
    this.destroyInternalLoaders();
  }
  onManifestLoading(event, data) {
    const {
      url
    } = data;
    this.variableList = null;
    this.load({
      id: null,
      level: 0,
      responseType: 'text',
      type: PlaylistContextType.MANIFEST,
      url,
      deliveryDirectives: null
    });
  }
  onLevelLoading(event, data) {
    const {
      id,
      level,
      url,
      deliveryDirectives
    } = data;
    this.load({
      id,
      level,
      responseType: 'text',
      type: PlaylistContextType.LEVEL,
      url,
      deliveryDirectives
    });
  }
  onAudioTrackLoading(event, data) {
    const {
      id,
      groupId,
      url,
      deliveryDirectives
    } = data;
    this.load({
      id,
      groupId,
      level: null,
      responseType: 'text',
      type: PlaylistContextType.AUDIO_TRACK,
      url,
      deliveryDirectives
    });
  }
  onSubtitleTrackLoading(event, data) {
    const {
      id,
      groupId,
      url,
      deliveryDirectives
    } = data;
    this.load({
      id,
      groupId,
      level: null,
      responseType: 'text',
      type: PlaylistContextType.SUBTITLE_TRACK,
      url,
      deliveryDirectives
    });
  }
  load(context) {
    var _context$deliveryDire;
    const config = this.hls.config;

    // logger.debug(`[playlist-loader]: Loading playlist of type ${context.type}, level: ${context.level}, id: ${context.id}`);

    // Check if a loader for this context already exists
    let loader = this.getInternalLoader(context);
    if (loader) {
      const loaderContext = loader.context;
      if (loaderContext && loaderContext.url === context.url) {
        // same URL can't overlap
        logger.trace('[playlist-loader]: playlist request ongoing');
        return;
      }
      logger.log(`[playlist-loader]: aborting previous loader for type: ${context.type}`);
      loader.abort();
    }

    // apply different configs for retries depending on
    // context (manifest, level, audio/subs playlist)
    let loadPolicy;
    if (context.type === PlaylistContextType.MANIFEST) {
      loadPolicy = config.manifestLoadPolicy.default;
    } else {
      loadPolicy = _extends({}, config.playlistLoadPolicy.default, {
        timeoutRetry: null,
        errorRetry: null
      });
    }
    loader = this.createInternalLoader(context);

    // Override level/track timeout for LL-HLS requests
    // (the default of 10000ms is counter productive to blocking playlist reload requests)
    if ((_context$deliveryDire = context.deliveryDirectives) != null && _context$deliveryDire.part) {
      let levelDetails;
      if (context.type === PlaylistContextType.LEVEL && context.level !== null) {
        levelDetails = this.hls.levels[context.level].details;
      } else if (context.type === PlaylistContextType.AUDIO_TRACK && context.id !== null) {
        levelDetails = this.hls.audioTracks[context.id].details;
      } else if (context.type === PlaylistContextType.SUBTITLE_TRACK && context.id !== null) {
        levelDetails = this.hls.subtitleTracks[context.id].details;
      }
      if (levelDetails) {
        const partTarget = levelDetails.partTarget;
        const targetDuration = levelDetails.targetduration;
        if (partTarget && targetDuration) {
          const maxLowLatencyPlaylistRefresh = Math.max(partTarget * 3, targetDuration * 0.8) * 1000;
          loadPolicy = _extends({}, loadPolicy, {
            maxTimeToFirstByteMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
    const loaderConfig = {
      loadPolicy,
      timeout: loadPolicy.maxLoadTimeMs,
      maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
      retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
      maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
    };
    const loaderCallbacks = {
      onSuccess: (response, stats, context, networkDetails) => {
        const loader = this.getInternalLoader(context);
        this.resetInternalLoader(context.type);
        const string = response.data;

        // Validate if it is an M3U8 at all
        if (string.indexOf('#EXTM3U') !== 0) {
          this.handleManifestParsingError(response, context, new Error('no EXTM3U delimiter'), networkDetails || null, stats);
          return;
        }
        stats.parsing.start = performance.now();
        if (M3U8Parser.isMediaPlaylist(string)) {
          this.handleTrackOrLevelPlaylist(response, stats, context, networkDetails || null, loader);
        } else {
          this.handleMasterPlaylist(response, stats, context, networkDetails);
        }
      },
      onError: (response, context, networkDetails, stats) => {
        this.handleNetworkError(context, networkDetails, false, response, stats);
      },
      onTimeout: (stats, context, networkDetails) => {
        this.handleNetworkError(context, networkDetails, true, undefined, stats);
      }
    };

    // logger.debug(`[playlist-loader]: Calling internal loader delegate for URL: ${context.url}`);

    loader.load(context, loaderConfig, loaderCallbacks);
  }
  handleMasterPlaylist(response, stats, context, networkDetails) {
    const hls = this.hls;
    const string = response.data;
    const url = getResponseUrl(response, context);
    const parsedResult = M3U8Parser.parseMasterPlaylist(string, url);
    if (parsedResult.playlistParsingError) {
      this.handleManifestParsingError(response, context, parsedResult.playlistParsingError, networkDetails, stats);
      return;
    }
    const {
      contentSteering,
      levels,
      sessionData,
      sessionKeys,
      startTimeOffset,
      variableList
    } = parsedResult;
    this.variableList = variableList;
    const {
      AUDIO: audioTracks = [],
      SUBTITLES: subtitles,
      'CLOSED-CAPTIONS': captions
    } = M3U8Parser.parseMasterPlaylistMedia(string, url, parsedResult);
    if (audioTracks.length) {
      // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
      const embeddedAudioFound = audioTracks.some(audioTrack => !audioTrack.url);

      // if no embedded audio track defined, but audio codec signaled in quality level,
      // we need to signal this main audio track this could happen with playlists with
      // alt audio rendition in which quality levels (main)
      // contains both audio+video. but with mixed audio track not signaled
      if (!embeddedAudioFound && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
        logger.log('[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one');
        audioTracks.unshift({
          type: 'main',
          name: 'main',
          groupId: 'main',
          default: false,
          autoselect: false,
          forced: false,
          id: -1,
          attrs: new AttrList({}),
          bitrate: 0,
          url: ''
        });
      }
    }
    hls.trigger(Events.MANIFEST_LOADED, {
      levels,
      audioTracks,
      subtitles,
      captions,
      contentSteering,
      url,
      stats,
      networkDetails,
      sessionData,
      sessionKeys,
      startTimeOffset,
      variableList
    });
  }
  handleTrackOrLevelPlaylist(response, stats, context, networkDetails, loader) {
    const hls = this.hls;
    const {
      id,
      level,
      type
    } = context;
    const url = getResponseUrl(response, context);
    const levelUrlId = isFiniteNumber(id) ? id : 0;
    const levelId = isFiniteNumber(level) ? level : levelUrlId;
    const levelType = mapContextToLevelType(context);
    const levelDetails = M3U8Parser.parseLevelPlaylist(response.data, url, levelId, levelType, levelUrlId, this.variableList);

    // We have done our first request (Manifest-type) and receive
    // not a master playlist but a chunk-list (track/level)
    // We fire the manifest-loaded event anyway with the parsed level-details
    // by creating a single-level structure for it.
    if (type === PlaylistContextType.MANIFEST) {
      const singleLevel = {
        attrs: new AttrList({}),
        bitrate: 0,
        details: levelDetails,
        name: '',
        url
      };
      hls.trigger(Events.MANIFEST_LOADED, {
        levels: [singleLevel],
        audioTracks: [],
        url,
        stats,
        networkDetails,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }

    // save parsing time
    stats.parsing.end = performance.now();

    // extend the context with the new levelDetails property
    context.levelDetails = levelDetails;
    this.handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader);
  }
  handleManifestParsingError(response, context, error, networkDetails, stats) {
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.NETWORK_ERROR,
      details: ErrorDetails.MANIFEST_PARSING_ERROR,
      fatal: context.type === PlaylistContextType.MANIFEST,
      url: response.url,
      err: error,
      error,
      reason: error.message,
      response,
      context,
      networkDetails,
      stats
    });
  }
  handleNetworkError(context, networkDetails, timeout = false, response, stats) {
    let message = `A network ${timeout ? 'timeout' : 'error' + (response ? ' (status ' + response.code + ')' : '')} occurred while loading ${context.type}`;
    if (context.type === PlaylistContextType.LEVEL) {
      message += `: ${context.level} id: ${context.id}`;
    } else if (context.type === PlaylistContextType.AUDIO_TRACK || context.type === PlaylistContextType.SUBTITLE_TRACK) {
      message += ` id: ${context.id} group-id: "${context.groupId}"`;
    }
    const error = new Error(message);
    logger.warn(`[playlist-loader]: ${message}`);
    let details = ErrorDetails.UNKNOWN;
    let fatal = false;
    const loader = this.getInternalLoader(context);
    switch (context.type) {
      case PlaylistContextType.MANIFEST:
        details = timeout ? ErrorDetails.MANIFEST_LOAD_TIMEOUT : ErrorDetails.MANIFEST_LOAD_ERROR;
        fatal = true;
        break;
      case PlaylistContextType.LEVEL:
        details = timeout ? ErrorDetails.LEVEL_LOAD_TIMEOUT : ErrorDetails.LEVEL_LOAD_ERROR;
        fatal = false;
        break;
      case PlaylistContextType.AUDIO_TRACK:
        details = timeout ? ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
        fatal = false;
        break;
      case PlaylistContextType.SUBTITLE_TRACK:
        details = timeout ? ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : ErrorDetails.SUBTITLE_LOAD_ERROR;
        fatal = false;
        break;
    }
    if (loader) {
      this.resetInternalLoader(context.type);
    }
    const errorData = {
      type: ErrorTypes.NETWORK_ERROR,
      details,
      fatal,
      url: context.url,
      loader,
      context,
      error,
      networkDetails,
      stats
    };
    if (response) {
      const url = (networkDetails == null ? void 0 : networkDetails.url) || context.url;
      errorData.response = _objectSpread2({
        url,
        data: undefined
      }, response);
    }
    this.hls.trigger(Events.ERROR, errorData);
  }
  handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader) {
    const hls = this.hls;
    const {
      type,
      level,
      id,
      groupId,
      deliveryDirectives
    } = context;
    const url = getResponseUrl(response, context);
    const parent = mapContextToLevelType(context);
    const levelIndex = typeof context.level === 'number' && parent === PlaylistLevelType.MAIN ? level : undefined;
    if (!levelDetails.fragments.length) {
      const _error = new Error('No Segments found in Playlist');
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.LEVEL_EMPTY_ERROR,
        fatal: false,
        url,
        error: _error,
        reason: _error.message,
        response,
        context,
        level: levelIndex,
        parent,
        networkDetails,
        stats
      });
      return;
    }
    if (!levelDetails.targetduration) {
      levelDetails.playlistParsingError = new Error('Missing Target Duration');
    }
    const error = levelDetails.playlistParsingError;
    if (error) {
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.LEVEL_PARSING_ERROR,
        fatal: false,
        url,
        error,
        reason: error.message,
        response,
        context,
        level: levelIndex,
        parent,
        networkDetails,
        stats
      });
      return;
    }
    if (levelDetails.live && loader) {
      if (loader.getCacheAge) {
        levelDetails.ageHeader = loader.getCacheAge() || 0;
      }
      if (!loader.getCacheAge || isNaN(levelDetails.ageHeader)) {
        levelDetails.ageHeader = 0;
      }
    }
    switch (type) {
      case PlaylistContextType.MANIFEST:
      case PlaylistContextType.LEVEL:
        hls.trigger(Events.LEVEL_LOADED, {
          details: levelDetails,
          level: levelIndex || 0,
          id: id || 0,
          stats,
          networkDetails,
          deliveryDirectives
        });
        break;
      case PlaylistContextType.AUDIO_TRACK:
        hls.trigger(Events.AUDIO_TRACK_LOADED, {
          details: levelDetails,
          id: id || 0,
          groupId: groupId || '',
          stats,
          networkDetails,
          deliveryDirectives
        });
        break;
      case PlaylistContextType.SUBTITLE_TRACK:
        hls.trigger(Events.SUBTITLE_TRACK_LOADED, {
          details: levelDetails,
          id: id || 0,
          groupId: groupId || '',
          stats,
          networkDetails,
          deliveryDirectives
        });
        break;
    }
  }
}

function sendAddTrackEvent(track, videoEl) {
  let event;
  try {
    event = new Event('addtrack');
  } catch (err) {
    // for IE11
    event = document.createEvent('Event');
    event.initEvent('addtrack', false, false);
  }
  event.track = track;
  videoEl.dispatchEvent(event);
}
function addCueToTrack(track, cue) {
  // Sometimes there are cue overlaps on segmented vtts so the same
  // cue can appear more than once in different vtt files.
  // This avoid showing duplicated cues with same timecode and text.
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues && !track.cues.getCueById(cue.id)) {
    try {
      track.addCue(cue);
      if (!track.cues.getCueById(cue.id)) {
        throw new Error(`addCue is failed for: ${cue}`);
      }
    } catch (err) {
      logger.debug(`[texttrack-utils]: ${err}`);
      try {
        const textTrackCue = new self.TextTrackCue(cue.startTime, cue.endTime, cue.text);
        textTrackCue.id = cue.id;
        track.addCue(textTrackCue);
      } catch (err2) {
        logger.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${err2}`);
      }
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}
function clearCurrentCues(track) {
  // When track.mode is disabled, track.cues will be null.
  // To guarantee the removal of cues, we need to temporarily
  // change the mode to hidden
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues) {
    for (let i = track.cues.length; i--;) {
      track.removeCue(track.cues[i]);
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}
function removeCuesInRange(track, start, end, predicate) {
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues && track.cues.length > 0) {
    const cues = getCuesInRange(track.cues, start, end);
    for (let i = 0; i < cues.length; i++) {
      if (!predicate || predicate(cues[i])) {
        track.removeCue(cues[i]);
      }
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}

// Find first cue starting after given time.
// Modified version of binary search O(log(n)).
function getFirstCueIndexAfterTime(cues, time) {
  // If first cue starts after time, start there
  if (time < cues[0].startTime) {
    return 0;
  }
  // If the last cue ends before time there is no overlap
  const len = cues.length - 1;
  if (time > cues[len].endTime) {
    return -1;
  }
  let left = 0;
  let right = len;
  while (left <= right) {
    const mid = Math.floor((right + left) / 2);
    if (time < cues[mid].startTime) {
      right = mid - 1;
    } else if (time > cues[mid].startTime && left < len) {
      left = mid + 1;
    } else {
      // If it's not lower or higher, it must be equal.
      return mid;
    }
  }
  // At this point, left and right have swapped.
  // No direct match was found, left or right element must be the closest. Check which one has the smallest diff.
  return cues[left].startTime - time < time - cues[right].startTime ? left : right;
}
function getCuesInRange(cues, start, end) {
  const cuesFound = [];
  const firstCueInRange = getFirstCueIndexAfterTime(cues, start);
  if (firstCueInRange > -1) {
    for (let i = firstCueInRange, len = cues.length; i < len; i++) {
      const cue = cues[i];
      if (cue.startTime >= start && cue.endTime <= end) {
        cuesFound.push(cue);
      } else if (cue.startTime > end) {
        return cuesFound;
      }
    }
  }
  return cuesFound;
}

var MetadataSchema = {
  audioId3: "org.id3",
  dateRange: "com.apple.quicktime.HLS",
  emsg: "https://aomedia.org/emsg/ID3"
};

const MIN_CUE_DURATION = 0.25;
function getCueClass() {
  if (typeof self === 'undefined') return undefined;

  // Attempt to recreate Safari functionality by creating
  // WebKitDataCue objects when available and store the decoded
  // ID3 data in the value property of the cue
  return self.WebKitDataCue || self.VTTCue || self.TextTrackCue;
}

// VTTCue latest draft allows an infinite duration, fallback
// to MAX_VALUE if necessary
const MAX_CUE_ENDTIME = (() => {
  const Cue = getCueClass();
  try {
    new Cue(0, Number.POSITIVE_INFINITY, '');
  } catch (e) {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function dateRangeDateToTimelineSeconds(date, offset) {
  return date.getTime() / 1000 - offset;
}
function hexToArrayBuffer(str) {
  return Uint8Array.from(str.replace(/^0x/, '').replace(/([\da-fA-F]{2}) ?/g, '0x$1 ').replace(/ +$/, '').split(' ')).buffer;
}
class ID3TrackController {
  constructor(hls) {
    this.hls = void 0;
    this.id3Track = null;
    this.media = null;
    this.dateRangeCuesAppended = {};
    this.hls = hls;
    this._registerListeners();
  }
  destroy() {
    this._unregisterListeners();
    this.id3Track = null;
    this.media = null;
    this.dateRangeCuesAppended = {};
    // @ts-ignore
    this.hls = null;
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }

  // Add ID3 metatadata text track.
  onMediaAttached(event, data) {
    this.media = data.media;
  }
  onMediaDetaching() {
    if (!this.id3Track) {
      return;
    }
    clearCurrentCues(this.id3Track);
    this.id3Track = null;
    this.media = null;
    this.dateRangeCuesAppended = {};
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(media) {
    const track = this.getID3Track(media.textTracks);
    track.mode = 'hidden';
    return track;
  }
  getID3Track(textTracks) {
    if (!this.media) {
      return;
    }
    for (let i = 0; i < textTracks.length; i++) {
      const textTrack = textTracks[i];
      if (textTrack.kind === 'metadata' && textTrack.label === 'id3') {
        // send 'addtrack' when reusing the textTrack for metadata,
        // same as what we do for captions
        sendAddTrackEvent(textTrack, this.media);
        return textTrack;
      }
    }
    return this.media.addTextTrack('metadata', 'id3');
  }
  onFragParsingMetadata(event, data) {
    if (!this.media) {
      return;
    }
    const {
      hls: {
        config: {
          enableEmsgMetadataCues,
          enableID3MetadataCues
        }
      }
    } = this;
    if (!enableEmsgMetadataCues && !enableID3MetadataCues) {
      return;
    }
    const {
      samples
    } = data;

    // create track dynamically
    if (!this.id3Track) {
      this.id3Track = this.createTrack(this.media);
    }
    const Cue = getCueClass();
    for (let i = 0; i < samples.length; i++) {
      const type = samples[i].type;
      if (type === MetadataSchema.emsg && !enableEmsgMetadataCues || !enableID3MetadataCues) {
        continue;
      }
      const frames = getID3Frames(samples[i].data);
      if (frames) {
        const startTime = samples[i].pts;
        let endTime = startTime + samples[i].duration;
        if (endTime > MAX_CUE_ENDTIME) {
          endTime = MAX_CUE_ENDTIME;
        }
        const timeDiff = endTime - startTime;
        if (timeDiff <= 0) {
          endTime = startTime + MIN_CUE_DURATION;
        }
        for (let j = 0; j < frames.length; j++) {
          const frame = frames[j];
          // Safari doesn't put the timestamp frame in the TextTrack
          if (!isTimeStampFrame(frame)) {
            // add a bounds to any unbounded cues
            this.updateId3CueEnds(startTime, type);
            const cue = new Cue(startTime, endTime, '');
            cue.value = frame;
            if (type) {
              cue.type = type;
            }
            this.id3Track.addCue(cue);
          }
        }
      }
    }
  }
  updateId3CueEnds(startTime, type) {
    var _this$id3Track;
    const cues = (_this$id3Track = this.id3Track) == null ? void 0 : _this$id3Track.cues;
    if (cues) {
      for (let i = cues.length; i--;) {
        const cue = cues[i];
        if (cue.type === type && cue.startTime < startTime && cue.endTime === MAX_CUE_ENDTIME) {
          cue.endTime = startTime;
        }
      }
    }
  }
  onBufferFlushing(event, {
    startOffset,
    endOffset,
    type
  }) {
    const {
      id3Track,
      hls
    } = this;
    if (!hls) {
      return;
    }
    const {
      config: {
        enableEmsgMetadataCues,
        enableID3MetadataCues
      }
    } = hls;
    if (id3Track && (enableEmsgMetadataCues || enableID3MetadataCues)) {
      let predicate;
      if (type === 'audio') {
        predicate = cue => cue.type === MetadataSchema.audioId3 && enableID3MetadataCues;
      } else if (type === 'video') {
        predicate = cue => cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
      } else {
        predicate = cue => cue.type === MetadataSchema.audioId3 && enableID3MetadataCues || cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
      }
      removeCuesInRange(id3Track, startOffset, endOffset, predicate);
    }
  }
  onLevelUpdated(event, {
    details
  }) {
    if (!this.media || !details.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues) {
      return;
    }
    const {
      dateRangeCuesAppended,
      id3Track
    } = this;
    const {
      dateRanges
    } = details;
    const ids = Object.keys(dateRanges);
    // Remove cues from track not found in details.dateRanges
    if (id3Track) {
      const idsToRemove = Object.keys(dateRangeCuesAppended).filter(id => !ids.includes(id));
      for (let i = idsToRemove.length; i--;) {
        const id = idsToRemove[i];
        Object.keys(dateRangeCuesAppended[id].cues).forEach(key => {
          id3Track.removeCue(dateRangeCuesAppended[id].cues[key]);
        });
        delete dateRangeCuesAppended[id];
      }
    }
    // Exit if the playlist does not have Date Ranges or does not have Program Date Time
    const lastFragment = details.fragments[details.fragments.length - 1];
    if (ids.length === 0 || !isFiniteNumber(lastFragment == null ? void 0 : lastFragment.programDateTime)) {
      return;
    }
    if (!this.id3Track) {
      this.id3Track = this.createTrack(this.media);
    }
    const dateTimeOffset = lastFragment.programDateTime / 1000 - lastFragment.start;
    const Cue = getCueClass();
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      const dateRange = dateRanges[id];
      const appendedDateRangeCues = dateRangeCuesAppended[id];
      const cues = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.cues) || {};
      let durationKnown = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.durationKnown) || false;
      const startTime = dateRangeDateToTimelineSeconds(dateRange.startDate, dateTimeOffset);
      let endTime = MAX_CUE_ENDTIME;
      const endDate = dateRange.endDate;
      if (endDate) {
        endTime = dateRangeDateToTimelineSeconds(endDate, dateTimeOffset);
        durationKnown = true;
      } else if (dateRange.endOnNext && !durationKnown) {
        const nextDateRangeWithSameClass = ids.reduce((filterMapArray, id) => {
          const candidate = dateRanges[id];
          if (candidate.class === dateRange.class && candidate.id !== id && candidate.startDate > dateRange.startDate) {
            filterMapArray.push(candidate);
          }
          return filterMapArray;
        }, []).sort((a, b) => a.startDate.getTime() - b.startDate.getTime())[0];
        if (nextDateRangeWithSameClass) {
          endTime = dateRangeDateToTimelineSeconds(nextDateRangeWithSameClass.startDate, dateTimeOffset);
          durationKnown = true;
        }
      }
      const attributes = Object.keys(dateRange.attr);
      for (let j = 0; j < attributes.length; j++) {
        const key = attributes[j];
        if (!isDateRangeCueAttribute(key)) {
          continue;
        }
        let cue = cues[key];
        if (cue) {
          if (durationKnown && !appendedDateRangeCues.durationKnown) {
            cue.endTime = endTime;
          }
        } else {
          let data = dateRange.attr[key];
          cue = new Cue(startTime, endTime, '');
          if (isSCTE35Attribute(key)) {
            data = hexToArrayBuffer(data);
          }
          cue.value = {
            key,
            data
          };
          cue.type = MetadataSchema.dateRange;
          cue.id = id;
          this.id3Track.addCue(cue);
          cues[key] = cue;
        }
      }
      dateRangeCuesAppended[id] = {
        cues,
        dateRange,
        durationKnown
      };
    }
  }
}

class LatencyController {
  constructor(hls) {
    this.hls = void 0;
    this.config = void 0;
    this.media = null;
    this.levelDetails = null;
    this.currentTime = 0;
    this.stallCount = 0;
    this._latency = null;
    this.timeupdateHandler = () => this.timeupdate();
    this.hls = hls;
    this.config = hls.config;
    this.registerListeners();
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config,
      levelDetails
    } = this;
    if (config.liveMaxLatencyDuration !== undefined) {
      return config.liveMaxLatencyDuration;
    }
    return levelDetails ? config.liveMaxLatencyDurationCount * levelDetails.targetduration : 0;
  }
  get targetLatency() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return null;
    }
    const {
      holdBack,
      partHoldBack,
      targetduration
    } = levelDetails;
    const {
      liveSyncDuration,
      liveSyncDurationCount,
      lowLatencyMode
    } = this.config;
    const userConfig = this.hls.userConfig;
    let targetLatency = lowLatencyMode ? partHoldBack || holdBack : holdBack;
    if (userConfig.liveSyncDuration || userConfig.liveSyncDurationCount || targetLatency === 0) {
      targetLatency = liveSyncDuration !== undefined ? liveSyncDuration : liveSyncDurationCount * targetduration;
    }
    const maxLiveSyncOnStallIncrease = targetduration;
    const liveSyncOnStallIncrease = 1.0;
    return targetLatency + Math.min(this.stallCount * liveSyncOnStallIncrease, maxLiveSyncOnStallIncrease);
  }
  get liveSyncPosition() {
    const liveEdge = this.estimateLiveEdge();
    const targetLatency = this.targetLatency;
    const levelDetails = this.levelDetails;
    if (liveEdge === null || targetLatency === null || levelDetails === null) {
      return null;
    }
    const edge = levelDetails.edge;
    const syncPosition = liveEdge - targetLatency - this.edgeStalled;
    const min = edge - levelDetails.totalduration;
    const max = edge - (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration);
    return Math.min(Math.max(min, syncPosition), max);
  }
  get drift() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return 1;
    }
    return levelDetails.drift;
  }
  get edgeStalled() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return 0;
    }
    const maxLevelUpdateAge = (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration) * 3;
    return Math.max(levelDetails.age - maxLevelUpdateAge, 0);
  }
  get forwardBufferLength() {
    const {
      media,
      levelDetails
    } = this;
    if (!media || !levelDetails) {
      return 0;
    }
    const bufferedRanges = media.buffered.length;
    return (bufferedRanges ? media.buffered.end(bufferedRanges - 1) : levelDetails.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners();
    this.onMediaDetaching();
    this.levelDetails = null;
    // @ts-ignore
    this.hls = this.timeupdateHandler = null;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    this.hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    this.hls.off(Events.ERROR, this.onError, this);
  }
  onMediaAttached(event, data) {
    this.media = data.media;
    this.media.addEventListener('timeupdate', this.timeupdateHandler);
  }
  onMediaDetaching() {
    if (this.media) {
      this.media.removeEventListener('timeupdate', this.timeupdateHandler);
      this.media = null;
    }
  }
  onManifestLoading() {
    this.levelDetails = null;
    this._latency = null;
    this.stallCount = 0;
  }
  onLevelUpdated(event, {
    details
  }) {
    this.levelDetails = details;
    if (details.advanced) {
      this.timeupdate();
    }
    if (!details.live && this.media) {
      this.media.removeEventListener('timeupdate', this.timeupdateHandler);
    }
  }
  onError(event, data) {
    var _this$levelDetails;
    if (data.details !== ErrorDetails.BUFFER_STALLED_ERROR) {
      return;
    }
    this.stallCount++;
    if ((_this$levelDetails = this.levelDetails) != null && _this$levelDetails.live) {
      logger.warn('[playback-rate-controller]: Stall detected, adjusting target latency');
    }
  }
  timeupdate() {
    const {
      media,
      levelDetails
    } = this;
    if (!media || !levelDetails) {
      return;
    }
    this.currentTime = media.currentTime;
    const latency = this.computeLatency();
    if (latency === null) {
      return;
    }
    this._latency = latency;

    // Adapt playbackRate to meet target latency in low-latency mode
    const {
      lowLatencyMode,
      maxLiveSyncPlaybackRate
    } = this.config;
    if (!lowLatencyMode || maxLiveSyncPlaybackRate === 1) {
      return;
    }
    const targetLatency = this.targetLatency;
    if (targetLatency === null) {
      return;
    }
    const distanceFromTarget = latency - targetLatency;
    // Only adjust playbackRate when within one target duration of targetLatency
    // and more than one second from under-buffering.
    // Playback further than one target duration from target can be considered DVR playback.
    const liveMinLatencyDuration = Math.min(this.maxLatency, targetLatency + levelDetails.targetduration);
    const inLiveRange = distanceFromTarget < liveMinLatencyDuration;
    if (levelDetails.live && inLiveRange && distanceFromTarget > 0.05 && this.forwardBufferLength > 1) {
      const max = Math.min(2, Math.max(1.0, maxLiveSyncPlaybackRate));
      const rate = Math.round(2 / (1 + Math.exp(-0.75 * distanceFromTarget - this.edgeStalled)) * 20) / 20;
      media.playbackRate = Math.min(max, Math.max(1, rate));
    } else if (media.playbackRate !== 1 && media.playbackRate !== 0) {
      media.playbackRate = 1;
    }
  }
  estimateLiveEdge() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return null;
    }
    return levelDetails.edge + levelDetails.age;
  }
  computeLatency() {
    const liveEdge = this.estimateLiveEdge();
    if (liveEdge === null) {
      return null;
    }
    return liveEdge - this.currentTime;
  }
}

const HdcpLevels = ['NONE', 'TYPE-0', 'TYPE-1', null];
var HlsSkip = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function getSkipValue(details, msn) {
  const {
    canSkipUntil,
    canSkipDateRanges,
    endSN
  } = details;
  const snChangeGoal = msn !== undefined ? msn - endSN : 0;
  if (canSkipUntil && snChangeGoal < canSkipUntil) {
    if (canSkipDateRanges) {
      return HlsSkip.v2;
    }
    return HlsSkip.Yes;
  }
  return HlsSkip.No;
}
class HlsUrlParameters {
  constructor(msn, part, skip) {
    this.msn = void 0;
    this.part = void 0;
    this.skip = void 0;
    this.msn = msn;
    this.part = part;
    this.skip = skip;
  }
  addDirectives(uri) {
    const url = new self.URL(uri);
    if (this.msn !== undefined) {
      url.searchParams.set('_HLS_msn', this.msn.toString());
    }
    if (this.part !== undefined) {
      url.searchParams.set('_HLS_part', this.part.toString());
    }
    if (this.skip) {
      url.searchParams.set('_HLS_skip', this.skip);
    }
    return url.href;
  }
}
class Level {
  constructor(data) {
    this._attrs = void 0;
    this.audioCodec = void 0;
    this.bitrate = void 0;
    this.codecSet = void 0;
    this.height = void 0;
    this.id = void 0;
    this.name = void 0;
    this.videoCodec = void 0;
    this.width = void 0;
    this.unknownCodecs = void 0;
    this.audioGroupIds = void 0;
    this.details = void 0;
    this.fragmentError = 0;
    this.loadError = 0;
    this.loaded = void 0;
    this.realBitrate = 0;
    this.textGroupIds = void 0;
    this.url = void 0;
    this._urlId = 0;
    this.url = [data.url];
    this._attrs = [data.attrs];
    this.bitrate = data.bitrate;
    if (data.details) {
      this.details = data.details;
    }
    this.id = data.id || 0;
    this.name = data.name;
    this.width = data.width || 0;
    this.height = data.height || 0;
    this.audioCodec = data.audioCodec;
    this.videoCodec = data.videoCodec;
    this.unknownCodecs = data.unknownCodecs;
    this.codecSet = [data.videoCodec, data.audioCodec].filter(c => c).join(',').replace(/\.[^.,]+/g, '');
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get attrs() {
    return this._attrs[this._urlId];
  }
  get pathwayId() {
    return this.attrs['PATHWAY-ID'] || '.';
  }
  get uri() {
    return this.url[this._urlId] || '';
  }
  get urlId() {
    return this._urlId;
  }
  set urlId(value) {
    const newValue = value % this.url.length;
    if (this._urlId !== newValue) {
      this.fragmentError = 0;
      this.loadError = 0;
      this.details = undefined;
      this._urlId = newValue;
    }
  }
  get audioGroupId() {
    var _this$audioGroupIds;
    return (_this$audioGroupIds = this.audioGroupIds) == null ? void 0 : _this$audioGroupIds[this.urlId];
  }
  get textGroupId() {
    var _this$textGroupIds;
    return (_this$textGroupIds = this.textGroupIds) == null ? void 0 : _this$textGroupIds[this.urlId];
  }
  addFallback(data) {
    this.url.push(data.url);
    this._attrs.push(data.attrs);
  }
}

function updateFromToPTS(fragFrom, fragTo) {
  const fragToPTS = fragTo.startPTS;
  // if we know startPTS[toIdx]
  if (isFiniteNumber(fragToPTS)) {
    // update fragment duration.
    // it helps to fix drifts between playlist reported duration and fragment real duration
    let duration = 0;
    let frag;
    if (fragTo.sn > fragFrom.sn) {
      duration = fragToPTS - fragFrom.start;
      frag = fragFrom;
    } else {
      duration = fragFrom.start - fragToPTS;
      frag = fragTo;
    }
    if (frag.duration !== duration) {
      frag.duration = duration;
    }
    // we dont know startPTS[toIdx]
  } else if (fragTo.sn > fragFrom.sn) {
    const contiguous = fragFrom.cc === fragTo.cc;
    // TODO: With part-loading end/durations we need to confirm the whole fragment is loaded before using (or setting) minEndPTS
    if (contiguous && fragFrom.minEndPTS) {
      fragTo.start = fragFrom.start + (fragFrom.minEndPTS - fragFrom.start);
    } else {
      fragTo.start = fragFrom.start + fragFrom.duration;
    }
  } else {
    fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
  }
}
function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
  const parsedMediaDuration = endPTS - startPTS;
  if (parsedMediaDuration <= 0) {
    logger.warn('Fragment should have a positive duration', frag);
    endPTS = startPTS + frag.duration;
    endDTS = startDTS + frag.duration;
  }
  let maxStartPTS = startPTS;
  let minEndPTS = endPTS;
  const fragStartPts = frag.startPTS;
  const fragEndPts = frag.endPTS;
  if (isFiniteNumber(fragStartPts)) {
    // delta PTS between audio and video
    const deltaPTS = Math.abs(fragStartPts - startPTS);
    if (!isFiniteNumber(frag.deltaPTS)) {
      frag.deltaPTS = deltaPTS;
    } else {
      frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
    }
    maxStartPTS = Math.max(startPTS, fragStartPts);
    startPTS = Math.min(startPTS, fragStartPts);
    startDTS = Math.min(startDTS, frag.startDTS);
    minEndPTS = Math.min(endPTS, fragEndPts);
    endPTS = Math.max(endPTS, fragEndPts);
    endDTS = Math.max(endDTS, frag.endDTS);
  }
  const drift = startPTS - frag.start;
  if (frag.start !== 0) {
    frag.start = startPTS;
  }
  frag.duration = endPTS - frag.start;
  frag.startPTS = startPTS;
  frag.maxStartPTS = maxStartPTS;
  frag.startDTS = startDTS;
  frag.endPTS = endPTS;
  frag.minEndPTS = minEndPTS;
  frag.endDTS = endDTS;
  const sn = frag.sn; // 'initSegment'
  // exit if sn out of range
  if (!details || sn < details.startSN || sn > details.endSN) {
    return 0;
  }
  let i;
  const fragIdx = sn - details.startSN;
  const fragments = details.fragments;
  // update frag reference in fragments array
  // rationale is that fragments array might not contain this frag object.
  // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
  // if we don't update frag, we won't be able to propagate PTS info on the playlist
  // resulting in invalid sliding computation
  fragments[fragIdx] = frag;
  // adjust fragment PTS/duration from seqnum-1 to frag 0
  for (i = fragIdx; i > 0; i--) {
    updateFromToPTS(fragments[i], fragments[i - 1]);
  }

  // adjust fragment PTS/duration from seqnum to last frag
  for (i = fragIdx; i < fragments.length - 1; i++) {
    updateFromToPTS(fragments[i], fragments[i + 1]);
  }
  if (details.fragmentHint) {
    updateFromToPTS(fragments[fragments.length - 1], details.fragmentHint);
  }
  details.PTSKnown = details.alignedSliding = true;
  return drift;
}
function mergeDetails(oldDetails, newDetails) {
  // Track the last initSegment processed. Initialize it to the last one on the timeline.
  let currentInitSegment = null;
  const oldFragments = oldDetails.fragments;
  for (let i = oldFragments.length - 1; i >= 0; i--) {
    const oldInit = oldFragments[i].initSegment;
    if (oldInit) {
      currentInitSegment = oldInit;
      break;
    }
  }
  if (oldDetails.fragmentHint) {
    // prevent PTS and duration from being adjusted on the next hint
    delete oldDetails.fragmentHint.endPTS;
  }
  // check if old/new playlists have fragments in common
  // loop through overlapping SN and update startPTS , cc, and duration if any found
  let ccOffset = 0;
  let PTSFrag;
  mapFragmentIntersection(oldDetails, newDetails, (oldFrag, newFrag) => {
    if (oldFrag.relurl) {
      // Do not compare CC if the old fragment has no url. This is a level.fragmentHint used by LL-HLS parts.
      // It maybe be off by 1 if it was created before any parts or discontinuity tags were appended to the end
      // of the playlist.
      ccOffset = oldFrag.cc - newFrag.cc;
    }
    if (isFiniteNumber(oldFrag.startPTS) && isFiniteNumber(oldFrag.endPTS)) {
      newFrag.start = newFrag.startPTS = oldFrag.startPTS;
      newFrag.startDTS = oldFrag.startDTS;
      newFrag.maxStartPTS = oldFrag.maxStartPTS;
      newFrag.endPTS = oldFrag.endPTS;
      newFrag.endDTS = oldFrag.endDTS;
      newFrag.minEndPTS = oldFrag.minEndPTS;
      newFrag.duration = oldFrag.endPTS - oldFrag.startPTS;
      if (newFrag.duration) {
        PTSFrag = newFrag;
      }

      // PTS is known when any segment has startPTS and endPTS
      newDetails.PTSKnown = newDetails.alignedSliding = true;
    }
    newFrag.elementaryStreams = oldFrag.elementaryStreams;
    newFrag.loader = oldFrag.loader;
    newFrag.stats = oldFrag.stats;
    newFrag.urlId = oldFrag.urlId;
    if (oldFrag.initSegment) {
      newFrag.initSegment = oldFrag.initSegment;
      currentInitSegment = oldFrag.initSegment;
    }
  });
  if (currentInitSegment) {
    const fragmentsToCheck = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
    fragmentsToCheck.forEach(frag => {
      var _currentInitSegment;
      if (!frag.initSegment || frag.initSegment.relurl === ((_currentInitSegment = currentInitSegment) == null ? void 0 : _currentInitSegment.relurl)) {
        frag.initSegment = currentInitSegment;
      }
    });
  }
  if (newDetails.skippedSegments) {
    newDetails.deltaUpdateFailed = newDetails.fragments.some(frag => !frag);
    if (newDetails.deltaUpdateFailed) {
      logger.warn('[level-helper] Previous playlist missing segments skipped in delta playlist');
      for (let i = newDetails.skippedSegments; i--;) {
        newDetails.fragments.shift();
      }
      newDetails.startSN = newDetails.fragments[0].sn;
      newDetails.startCC = newDetails.fragments[0].cc;
    } else if (newDetails.canSkipDateRanges) {
      newDetails.dateRanges = mergeDateRanges(oldDetails.dateRanges, newDetails.dateRanges, newDetails.recentlyRemovedDateranges);
    }
  }
  const newFragments = newDetails.fragments;
  if (ccOffset) {
    logger.warn('discontinuity sliding from playlist, take drift into account');
    for (let i = 0; i < newFragments.length; i++) {
      newFragments[i].cc += ccOffset;
    }
  }
  if (newDetails.skippedSegments) {
    newDetails.startCC = newDetails.fragments[0].cc;
  }

  // Merge parts
  mapPartIntersection(oldDetails.partList, newDetails.partList, (oldPart, newPart) => {
    newPart.elementaryStreams = oldPart.elementaryStreams;
    newPart.stats = oldPart.stats;
  });

  // if at least one fragment contains PTS info, recompute PTS information for all fragments
  if (PTSFrag) {
    updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
  } else {
    // ensure that delta is within oldFragments range
    // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
    // in that case we also need to adjust start offset of all fragments
    adjustSliding(oldDetails, newDetails);
  }
  if (newFragments.length) {
    newDetails.totalduration = newDetails.edge - newFragments[0].start;
  }
  newDetails.driftStartTime = oldDetails.driftStartTime;
  newDetails.driftStart = oldDetails.driftStart;
  const advancedDateTime = newDetails.advancedDateTime;
  if (newDetails.advanced && advancedDateTime) {
    const edge = newDetails.edge;
    if (!newDetails.driftStart) {
      newDetails.driftStartTime = advancedDateTime;
      newDetails.driftStart = edge;
    }
    newDetails.driftEndTime = advancedDateTime;
    newDetails.driftEnd = edge;
  } else {
    newDetails.driftEndTime = oldDetails.driftEndTime;
    newDetails.driftEnd = oldDetails.driftEnd;
    newDetails.advancedDateTime = oldDetails.advancedDateTime;
  }
}
function mergeDateRanges(oldDateRanges, deltaDateRanges, recentlyRemovedDateranges) {
  const dateRanges = _extends({}, oldDateRanges);
  if (recentlyRemovedDateranges) {
    recentlyRemovedDateranges.forEach(id => {
      delete dateRanges[id];
    });
  }
  Object.keys(deltaDateRanges).forEach(id => {
    const dateRange = new DateRange(deltaDateRanges[id].attr, dateRanges[id]);
    if (dateRange.isValid) {
      dateRanges[id] = dateRange;
    } else {
      logger.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(deltaDateRanges[id].attr)}"`);
    }
  });
  return dateRanges;
}
function mapPartIntersection(oldParts, newParts, intersectionFn) {
  if (oldParts && newParts) {
    let delta = 0;
    for (let i = 0, len = oldParts.length; i <= len; i++) {
      const oldPart = oldParts[i];
      const newPart = newParts[i + delta];
      if (oldPart && newPart && oldPart.index === newPart.index && oldPart.fragment.sn === newPart.fragment.sn) {
        intersectionFn(oldPart, newPart);
      } else {
        delta--;
      }
    }
  }
}
function mapFragmentIntersection(oldDetails, newDetails, intersectionFn) {
  const skippedSegments = newDetails.skippedSegments;
  const start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN;
  const end = (oldDetails.fragmentHint ? 1 : 0) + (skippedSegments ? newDetails.endSN : Math.min(oldDetails.endSN, newDetails.endSN)) - newDetails.startSN;
  const delta = newDetails.startSN - oldDetails.startSN;
  const newFrags = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
  const oldFrags = oldDetails.fragmentHint ? oldDetails.fragments.concat(oldDetails.fragmentHint) : oldDetails.fragments;
  for (let i = start; i <= end; i++) {
    const oldFrag = oldFrags[delta + i];
    let newFrag = newFrags[i];
    if (skippedSegments && !newFrag && i < skippedSegments) {
      // Fill in skipped segments in delta playlist
      newFrag = newDetails.fragments[i] = oldFrag;
    }
    if (oldFrag && newFrag) {
      intersectionFn(oldFrag, newFrag);
    }
  }
}
function adjustSliding(oldDetails, newDetails) {
  const delta = newDetails.startSN + newDetails.skippedSegments - oldDetails.startSN;
  const oldFragments = oldDetails.fragments;
  if (delta < 0 || delta >= oldFragments.length) {
    return;
  }
  addSliding(newDetails, oldFragments[delta].start);
}
function addSliding(details, start) {
  if (start) {
    const fragments = details.fragments;
    for (let i = details.skippedSegments; i < fragments.length; i++) {
      fragments[i].start += start;
    }
    if (details.fragmentHint) {
      details.fragmentHint.start += start;
    }
  }
}
function computeReloadInterval(newDetails, distanceToLiveEdgeMs = Infinity) {
  let reloadInterval = 1000 * newDetails.targetduration;
  if (newDetails.updated) {
    // Use last segment duration when shorter than target duration and near live edge
    const fragments = newDetails.fragments;
    const liveEdgeMaxTargetDurations = 4;
    if (fragments.length && reloadInterval * liveEdgeMaxTargetDurations > distanceToLiveEdgeMs) {
      const lastSegmentDuration = fragments[fragments.length - 1].duration * 1000;
      if (lastSegmentDuration < reloadInterval) {
        reloadInterval = lastSegmentDuration;
      }
    }
  } else {
    // estimate = 'miss half average';
    // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
    // changed then it MUST wait for a period of one-half the target
    // duration before retrying.
    reloadInterval /= 2;
  }
  return Math.round(reloadInterval);
}
function getFragmentWithSN(level, sn, fragCurrent) {
  if (!(level != null && level.details)) {
    return null;
  }
  const levelDetails = level.details;
  let fragment = levelDetails.fragments[sn - levelDetails.startSN];
  if (fragment) {
    return fragment;
  }
  fragment = levelDetails.fragmentHint;
  if (fragment && fragment.sn === sn) {
    return fragment;
  }
  if (sn < levelDetails.startSN && fragCurrent && fragCurrent.sn === sn) {
    return fragCurrent;
  }
  return null;
}
function getPartWith(level, sn, partIndex) {
  var _level$details;
  if (!(level != null && level.details)) {
    return null;
  }
  return findPart((_level$details = level.details) == null ? void 0 : _level$details.partList, sn, partIndex);
}
function findPart(partList, sn, partIndex) {
  if (partList) {
    for (let i = partList.length; i--;) {
      const part = partList[i];
      if (part.index === partIndex && part.fragment.sn === sn) {
        return part;
      }
    }
  }
  return null;
}

function isTimeoutError(error) {
  switch (error.details) {
    case ErrorDetails.FRAG_LOAD_TIMEOUT:
    case ErrorDetails.KEY_LOAD_TIMEOUT:
    case ErrorDetails.LEVEL_LOAD_TIMEOUT:
    case ErrorDetails.MANIFEST_LOAD_TIMEOUT:
      return true;
  }
  return false;
}
function getRetryConfig(loadPolicy, error) {
  const isTimeout = isTimeoutError(error);
  return loadPolicy.default[`${isTimeout ? 'timeout' : 'error'}Retry`];
}
function getRetryDelay(retryConfig, retryCount) {
  // exponential backoff capped to max retry delay
  const backoffFactor = retryConfig.backoff === 'linear' ? 1 : Math.pow(2, retryCount);
  return Math.min(backoffFactor * retryConfig.retryDelayMs, retryConfig.maxRetryDelayMs);
}
function getLoaderConfigWithoutReties(loderConfig) {
  return _objectSpread2(_objectSpread2({}, loderConfig), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function shouldRetry(retryConfig, retryCount, isTimeout, httpStatus) {
  return !!retryConfig && retryCount < retryConfig.maxNumRetry && (retryForHttpStatus(httpStatus) || !!isTimeout);
}
function retryForHttpStatus(httpStatus) {
  // Do not retry on status 4xx, status 0 (CORS error), or undefined (decrypt/gap/parse error)
  return httpStatus === 0 && navigator.onLine === false || !!httpStatus && (httpStatus < 400 || httpStatus > 499);
}

const BinarySearch = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function (list, comparisonFn) {
    let minIndex = 0;
    let maxIndex = list.length - 1;
    let currentIndex = null;
    let currentElement = null;
    while (minIndex <= maxIndex) {
      currentIndex = (minIndex + maxIndex) / 2 | 0;
      currentElement = list[currentIndex];
      const comparisonResult = comparisonFn(currentElement);
      if (comparisonResult > 0) {
        minIndex = currentIndex + 1;
      } else if (comparisonResult < 0) {
        maxIndex = currentIndex - 1;
      } else {
        return currentElement;
      }
    }
    return null;
  }
};

/**
 * Returns first fragment whose endPdt value exceeds the given PDT, or null.
 * @param fragments - The array of candidate fragments
 * @param PDTValue - The PDT value which must be exceeded
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 */
function findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
  if (PDTValue === null || !Array.isArray(fragments) || !fragments.length || !isFiniteNumber(PDTValue)) {
    return null;
  }

  // if less than start
  const startPDT = fragments[0].programDateTime;
  if (PDTValue < (startPDT || 0)) {
    return null;
  }
  const endPDT = fragments[fragments.length - 1].endProgramDateTime;
  if (PDTValue >= (endPDT || 0)) {
    return null;
  }
  maxFragLookUpTolerance = maxFragLookUpTolerance || 0;
  for (let seg = 0; seg < fragments.length; ++seg) {
    const frag = fragments[seg];
    if (pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) {
      return frag;
    }
  }
  return null;
}

/**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param fragPrevious - The last frag successfully appended
 * @param fragments - The array of candidate fragments
 * @param bufferEnd - The end of the contiguous buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns a matching fragment or null
 */
function findFragmentByPTS(fragPrevious, fragments, bufferEnd = 0, maxFragLookUpTolerance = 0) {
  let fragNext = null;
  if (fragPrevious) {
    fragNext = fragments[fragPrevious.sn - fragments[0].sn + 1] || null;
  } else if (bufferEnd === 0 && fragments[0].start === 0) {
    fragNext = fragments[0];
  }
  // Prefer the next fragment if it's within tolerance
  if (fragNext && fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext) === 0) {
    return fragNext;
  }
  // We might be seeking past the tolerance so find the best match
  const foundFragment = BinarySearch.search(fragments, fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
  if (foundFragment && (foundFragment !== fragPrevious || !fragNext)) {
    return foundFragment;
  }
  // If no match was found return the next fragment after fragPrevious, or null
  return fragNext;
}

/**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param candidate - The fragment to test
 * @param bufferEnd - The end of the current buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns 0 if it matches, 1 if too low, -1 if too high
 */
function fragmentWithinToleranceTest(bufferEnd = 0, maxFragLookUpTolerance = 0, candidate) {
  // eagerly accept an accurate match (no tolerance)
  if (candidate.start <= bufferEnd && candidate.start + candidate.duration > bufferEnd) {
    return 0;
  }
  // offset should be within fragment boundary - config.maxFragLookUpTolerance
  // this is to cope with situations like
  // bufferEnd = 9.991
  // frag[Ø] : [0,10]
  // frag[1] : [10,20]
  // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
  //              frag start               frag start+duration
  //                  |-----------------------------|
  //              <--->                         <--->
  //  ...--------><-----------------------------><---------....
  // previous frag         matching fragment         next frag
  //  return -1             return 0                 return 1
  // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
  // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
  const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
  if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
    return 1;
  } else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
    // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
    return -1;
  }
  return 0;
}

/**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param candidate - The fragment to test
 * @param pdtBufferEnd - The Unix time representing the end of the current buffered range
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns true if contiguous, false otherwise
 */
function pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
  const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000;

  // endProgramDateTime can be null, default to zero
  const endProgramDateTime = candidate.endProgramDateTime || 0;
  return endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
}
function findFragWithCC(fragments, cc) {
  return BinarySearch.search(fragments, candidate => {
    if (candidate.cc < cc) {
      return 1;
    } else if (candidate.cc > cc) {
      return -1;
    } else {
      return 0;
    }
  });
}

const RENDITION_PENALTY_DURATION_MS = 300000;
var NetworkErrorAction = {
  DoNothing: 0,
  SendEndCallback: 1,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  InsertDiscontinuity: 4,
  RetryRequest: 5
};
var ErrorActionFlags = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2,
  SwitchToSDR: 4
}; // Reserved for future use
class ErrorController {
  constructor(hls) {
    this.hls = void 0;
    this.playlistError = 0;
    this.penalizedRenditions = {};
    this.log = void 0;
    this.warn = void 0;
    this.error = void 0;
    this.hls = hls;
    this.log = logger.log.bind(logger, `[info]:`);
    this.warn = logger.warn.bind(logger, `[warning]:`);
    this.error = logger.error.bind(logger, `[error]:`);
    this.registerListeners();
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    if (!hls) {
      return;
    }
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.ERROR, this.onErrorOut, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  destroy() {
    this.unregisterListeners();
    // @ts-ignore
    this.hls = null;
    this.penalizedRenditions = {};
  }
  startLoad(startPosition) {
    this.playlistError = 0;
  }
  stopLoad() {}
  getVariantLevelIndex(frag) {
    return (frag == null ? void 0 : frag.type) === PlaylistLevelType.MAIN ? frag.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0;
    this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(event, data) {
    var _data$frag, _data$level;
    if (data.fatal) {
      return;
    }
    const hls = this.hls;
    const context = data.context;
    switch (data.details) {
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        data.errorAction = this.getFragRetryOrSwitchAction(data);
        return;
      case ErrorDetails.FRAG_PARSING_ERROR:
        // ignore empty segment errors marked as gap
        if ((_data$frag = data.frag) != null && _data$frag.gap) {
          data.errorAction = {
            action: NetworkErrorAction.DoNothing,
            flags: ErrorActionFlags.None
          };
          return;
        }
      // falls through
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
        {
          // Switch level if possible, otherwise allow retry count to reach max error retries
          data.errorAction = this.getFragRetryOrSwitchAction(data);
          data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
          return;
        }
      case ErrorDetails.LEVEL_EMPTY_ERROR:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        {
          var _data$context, _data$context$levelDe;
          // Only retry when empty and live
          const levelIndex = data.parent === PlaylistLevelType.MAIN ? data.level : hls.loadLevel;
          if (data.details === ErrorDetails.LEVEL_EMPTY_ERROR && !!((_data$context = data.context) != null && (_data$context$levelDe = _data$context.levelDetails) != null && _data$context$levelDe.live)) {
            data.errorAction = this.getPlaylistRetryOrSwitchAction(data, levelIndex);
          } else {
            // Escalate to fatal if not retrying or switching
            data.levelRetry = false;
            data.errorAction = this.getLevelSwitchAction(data, levelIndex);
          }
        }
        return;
      case ErrorDetails.LEVEL_LOAD_ERROR:
      case ErrorDetails.LEVEL_LOAD_TIMEOUT:
        if (typeof (context == null ? void 0 : context.level) === 'number') {
          data.errorAction = this.getPlaylistRetryOrSwitchAction(data, context.level);
        }
        return;
      case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
      case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
      case ErrorDetails.SUBTITLE_LOAD_ERROR:
      case ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (context) {
          const level = hls.levels[hls.loadLevel];
          if (level && (context.type === PlaylistContextType.AUDIO_TRACK && context.groupId === level.audioGroupId || context.type === PlaylistContextType.SUBTITLE_TRACK && context.groupId === level.textGroupId)) {
            // Perform Pathway switch or Redundant failover if possible for fastest recovery
            // otherwise allow playlist retry count to reach max error retries
            data.errorAction = this.getPlaylistRetryOrSwitchAction(data, hls.loadLevel);
            data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
            data.errorAction.flags = ErrorActionFlags.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const level = hls.levels[hls.loadLevel];
          const restrictedHdcpLevel = level == null ? void 0 : level.attrs['HDCP-LEVEL'];
          if (restrictedHdcpLevel) {
            data.errorAction = {
              action: NetworkErrorAction.SendAlternateToPenaltyBox,
              flags: ErrorActionFlags.MoveAllAlternatesMatchingHDCP,
              hdcpLevel: restrictedHdcpLevel
            };
          }
        }
        return;
      case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
      case ErrorDetails.REMUX_ALLOC_ERROR:
        data.errorAction = this.getLevelSwitchAction(data, (_data$level = data.level) != null ? _data$level : hls.loadLevel);
        return;
      case ErrorDetails.INTERNAL_EXCEPTION:
      case ErrorDetails.BUFFER_APPENDING_ERROR:
      case ErrorDetails.BUFFER_APPEND_ERROR:
      case ErrorDetails.BUFFER_FULL_ERROR:
      case ErrorDetails.LEVEL_SWITCH_ERROR:
      case ErrorDetails.BUFFER_STALLED_ERROR:
      case ErrorDetails.BUFFER_SEEK_OVER_HOLE:
      case ErrorDetails.BUFFER_NUDGE_ON_STALL:
        data.errorAction = {
          action: NetworkErrorAction.DoNothing,
          flags: ErrorActionFlags.None
        };
        return;
    }
    if (data.type === ErrorTypes.KEY_SYSTEM_ERROR) {
      const levelIndex = this.getVariantLevelIndex(data.frag);
      // Do not retry level. Escalate to fatal if switching levels fails.
      data.levelRetry = false;
      data.errorAction = this.getLevelSwitchAction(data, levelIndex);
      return;
    }
  }
  getPlaylistRetryOrSwitchAction(data, levelIndex) {
    var _data$response;
    const hls = this.hls;
    const retryConfig = getRetryConfig(hls.config.playlistLoadPolicy, data);
    const retryCount = this.playlistError++;
    const httpStatus = (_data$response = data.response) == null ? void 0 : _data$response.code;
    const retry = shouldRetry(retryConfig, retryCount, isTimeoutError(data), httpStatus);
    if (retry) {
      return {
        action: NetworkErrorAction.RetryRequest,
        flags: ErrorActionFlags.None,
        retryConfig,
        retryCount
      };
    }
    const errorAction = this.getLevelSwitchAction(data, levelIndex);
    if (retryConfig) {
      errorAction.retryConfig = retryConfig;
      errorAction.retryCount = retryCount;
    }
    return errorAction;
  }
  getFragRetryOrSwitchAction(data) {
    const hls = this.hls;
    // Share fragment error count accross media options (main, audio, subs)
    // This allows for level based rendition switching when media option assets fail
    const variantLevelIndex = this.getVariantLevelIndex(data.frag);
    const level = hls.levels[variantLevelIndex];
    const {
      fragLoadPolicy,
      keyLoadPolicy
    } = hls.config;
    const retryConfig = getRetryConfig(data.details.startsWith('key') ? keyLoadPolicy : fragLoadPolicy, data);
    const fragmentErrors = hls.levels.reduce((acc, level) => acc + level.fragmentError, 0);
    // Switch levels when out of retried or level index out of bounds
    if (level) {
      var _data$response2;
      if (data.details !== ErrorDetails.FRAG_GAP) {
        level.fragmentError++;
      }
      const httpStatus = (_data$response2 = data.response) == null ? void 0 : _data$response2.code;
      const retry = shouldRetry(retryConfig, fragmentErrors, isTimeoutError(data), httpStatus);
      if (retry) {
        return {
          action: NetworkErrorAction.RetryRequest,
          flags: ErrorActionFlags.None,
          retryConfig,
          retryCount: fragmentErrors
        };
      }
    }
    // Reach max retry count, or Missing level reference
    // Switch to valid index
    const errorAction = this.getLevelSwitchAction(data, variantLevelIndex);
    // Add retry details to allow skipping of FRAG_PARSING_ERROR
    if (retryConfig) {
      errorAction.retryConfig = retryConfig;
      errorAction.retryCount = fragmentErrors;
    }
    return errorAction;
  }
  getLevelSwitchAction(data, levelIndex) {
    const hls = this.hls;
    if (levelIndex === null || levelIndex === undefined) {
      levelIndex = hls.loadLevel;
    }
    const level = this.hls.levels[levelIndex];
    if (level) {
      level.loadError++;
      if (hls.autoLevelEnabled) {
        var _data$frag2, _data$context2;
        // Search for next level to retry
        let nextLevel = -1;
        const {
          levels,
          loadLevel,
          minAutoLevel,
          maxAutoLevel
        } = hls;
        const fragErrorType = (_data$frag2 = data.frag) == null ? void 0 : _data$frag2.type;
        const {
          type: playlistErrorType,
          groupId: playlistErrorGroupId
        } = (_data$context2 = data.context) != null ? _data$context2 : {};
        for (let i = levels.length; i--;) {
          const candidate = (i + loadLevel) % levels.length;
          if (candidate !== loadLevel && candidate >= minAutoLevel && candidate <= maxAutoLevel && levels[candidate].loadError === 0) {
            const levelCandidate = levels[candidate];
            // Skip level switch if GAP tag is found in next level at same position
            if (data.details === ErrorDetails.FRAG_GAP && data.frag) {
              const levelDetails = levels[candidate].details;
              if (levelDetails) {
                const fragCandidate = findFragmentByPTS(data.frag, levelDetails.fragments, data.frag.start);
                if (fragCandidate != null && fragCandidate.gap) {
                  continue;
                }
              }
            } else if (playlistErrorType === PlaylistContextType.AUDIO_TRACK && playlistErrorGroupId === levelCandidate.audioGroupId || playlistErrorType === PlaylistContextType.SUBTITLE_TRACK && playlistErrorGroupId === levelCandidate.textGroupId) {
              // For audio/subs playlist errors find another group ID or fallthrough to redundant fail-over
              continue;
            } else if (fragErrorType === PlaylistLevelType.AUDIO && level.audioGroupId === levelCandidate.audioGroupId || fragErrorType === PlaylistLevelType.SUBTITLE && level.textGroupId === levelCandidate.textGroupId) {
              // For audio/subs frag errors find another group ID or fallthrough to redundant fail-over
              continue;
            }
            nextLevel = candidate;
            break;
          }
        }
        if (nextLevel > -1 && hls.loadLevel !== nextLevel) {
          data.levelRetry = true;
          this.playlistError = 0;
          return {
            action: NetworkErrorAction.SendAlternateToPenaltyBox,
            flags: ErrorActionFlags.None,
            nextAutoLevel: nextLevel
          };
        }
      }
    }
    // No levels to switch / Manual level selection / Level not found
    // Resolve with Pathway switch, Redundant fail-over, or stay on lowest Level
    return {
      action: NetworkErrorAction.SendAlternateToPenaltyBox,
      flags: ErrorActionFlags.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(event, data) {
    var _data$errorAction;
    switch ((_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.action) {
      case NetworkErrorAction.DoNothing:
        break;
      case NetworkErrorAction.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(data);
        if (!data.errorAction.resolved && data.details !== ErrorDetails.FRAG_GAP) {
          data.fatal = true;
        }
        break;
    }
    if (data.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(data) {
    const hls = this.hls;
    const errorAction = data.errorAction;
    if (!errorAction) {
      return;
    }
    const {
      flags,
      hdcpLevel,
      nextAutoLevel
    } = errorAction;
    switch (flags) {
      case ErrorActionFlags.None:
        this.switchLevel(data, nextAutoLevel);
        break;
      case ErrorActionFlags.MoveAllAlternatesMatchingHost:
        {
          // Handle Redundant Levels here. Pathway switching is handled by content-steering-controller
          if (!errorAction.resolved) {
            errorAction.resolved = this.redundantFailover(data);
          }
        }
        break;
      case ErrorActionFlags.MoveAllAlternatesMatchingHDCP:
        if (hdcpLevel) {
          hls.maxHdcpLevel = HdcpLevels[HdcpLevels.indexOf(hdcpLevel) - 1];
          errorAction.resolved = true;
        }
        this.warn(`Restricting playback to HDCP-LEVEL of "${hls.maxHdcpLevel}" or lower`);
        break;
    }
    // If not resolved by previous actions try to switch to next level
    if (!errorAction.resolved) {
      this.switchLevel(data, nextAutoLevel);
    }
  }
  switchLevel(data, levelIndex) {
    if (levelIndex !== undefined && data.errorAction) {
      this.warn(`switching to level ${levelIndex} after ${data.details}`);
      this.hls.nextAutoLevel = levelIndex;
      data.errorAction.resolved = true;
      // Stream controller is responsible for this but won't switch on false start
      this.hls.nextLoadLevel = this.hls.nextAutoLevel;
    }
  }
  redundantFailover(data) {
    const {
      hls,
      penalizedRenditions
    } = this;
    const levelIndex = data.parent === PlaylistLevelType.MAIN ? data.level : hls.loadLevel;
    const level = hls.levels[levelIndex];
    const redundantLevels = level.url.length;
    const errorUrlId = data.frag ? data.frag.urlId : level.urlId;
    if (level.urlId === errorUrlId && (!data.frag || level.details)) {
      this.penalizeRendition(level, data);
    }
    for (let i = 1; i < redundantLevels; i++) {
      const newUrlId = (errorUrlId + i) % redundantLevels;
      const penalizedRendition = penalizedRenditions[newUrlId];
      // Check if rendition is penalized and skip if it is a bad fit for failover
      if (!penalizedRendition || checkExpired(penalizedRendition, data, penalizedRenditions[errorUrlId])) {
        // delete penalizedRenditions[newUrlId];
        // Update the url id of all levels so that we stay on the same set of variants when level switching
        this.warn(`Switching to Redundant Stream ${newUrlId + 1}/${redundantLevels}: "${level.url[newUrlId]}" after ${data.details}`);
        this.playlistError = 0;
        hls.levels.forEach(lv => {
          lv.urlId = newUrlId;
        });
        hls.nextLoadLevel = levelIndex;
        return true;
      }
    }
    return false;
  }
  penalizeRendition(level, data) {
    const {
      penalizedRenditions
    } = this;
    const penalizedRendition = penalizedRenditions[level.urlId] || {
      lastErrorPerfMs: 0,
      errors: [],
      details: undefined
    };
    penalizedRendition.lastErrorPerfMs = performance.now();
    penalizedRendition.errors.push(data);
    penalizedRendition.details = level.details;
    penalizedRenditions[level.urlId] = penalizedRendition;
  }
}
function checkExpired(penalizedRendition, data, currentPenaltyState) {
  // Expire penalty for switching back to rendition after RENDITION_PENALTY_DURATION_MS
  if (performance.now() - penalizedRendition.lastErrorPerfMs > RENDITION_PENALTY_DURATION_MS) {
    return true;
  }
  // Expire penalty on GAP tag error if rendition has no GAP at position (does not cover media tracks)
  const lastErrorDetails = penalizedRendition.details;
  if (data.details === ErrorDetails.FRAG_GAP && lastErrorDetails && data.frag) {
    const position = data.frag.start;
    const candidateFrag = findFragmentByPTS(null, lastErrorDetails.fragments, position);
    if (candidateFrag && !candidateFrag.gap) {
      return true;
    }
  }
  // Expire penalty if there are more errors in currentLevel than in penalizedRendition
  if (currentPenaltyState && penalizedRendition.errors.length < currentPenaltyState.errors.length) {
    const lastCandidateError = penalizedRendition.errors[penalizedRendition.errors.length - 1];
    if (lastErrorDetails && lastCandidateError.frag && data.frag && Math.abs(lastCandidateError.frag.start - data.frag.start) > lastErrorDetails.targetduration * 3) {
      return true;
    }
  }
  return false;
}

class BasePlaylistController {
  constructor(hls, logPrefix) {
    this.hls = void 0;
    this.timer = -1;
    this.requestScheduled = -1;
    this.canLoad = false;
    this.log = void 0;
    this.warn = void 0;
    this.log = logger.log.bind(logger, `${logPrefix}:`);
    this.warn = logger.warn.bind(logger, `${logPrefix}:`);
    this.hls = hls;
  }
  destroy() {
    this.clearTimer();
    // @ts-ignore
    this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    clearTimeout(this.timer);
    this.timer = -1;
  }
  startLoad() {
    this.canLoad = true;
    this.requestScheduled = -1;
    this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = false;
    this.clearTimer();
  }
  switchParams(playlistUri, previous) {
    const renditionReports = previous == null ? void 0 : previous.renditionReports;
    if (renditionReports) {
      let foundIndex = -1;
      for (let i = 0; i < renditionReports.length; i++) {
        const attr = renditionReports[i];
        let uri;
        try {
          uri = new self.URL(attr.URI, previous.url).href;
        } catch (error) {
          logger.warn(`Could not construct new URL for Rendition Report: ${error}`);
          uri = attr.URI || '';
        }
        // Use exact match. Otherwise, the last partial match, if any, will be used
        // (Playlist URI includes a query string that the Rendition Report does not)
        if (uri === playlistUri) {
          foundIndex = i;
          break;
        } else if (uri === playlistUri.substring(0, uri.length)) {
          foundIndex = i;
        }
      }
      if (foundIndex !== -1) {
        const attr = renditionReports[foundIndex];
        const msn = parseInt(attr['LAST-MSN']) || (previous == null ? void 0 : previous.lastPartSn);
        let part = parseInt(attr['LAST-PART']) || (previous == null ? void 0 : previous.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const currentGoal = Math.min(previous.age - previous.partTarget, previous.targetduration);
          if (part >= 0 && currentGoal > previous.partTarget) {
            part += 1;
          }
        }
        return new HlsUrlParameters(msn, part >= 0 ? part : undefined, HlsSkip.No);
      }
    }
  }
  loadPlaylist(hlsUrlParameters) {
    if (this.requestScheduled === -1) {
      this.requestScheduled = self.performance.now();
    }
    // Loading is handled by the subclasses
  }

  shouldLoadPlaylist(playlist) {
    return this.canLoad && !!playlist && !!playlist.url && (!playlist.details || playlist.details.live);
  }
  shouldReloadPlaylist(playlist) {
    return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(playlist);
  }
  playlistLoaded(index, data, previousDetails) {
    const {
      details,
      stats
    } = data;

    // Set last updated date-time
    const now = self.performance.now();
    const elapsed = stats.loading.first ? Math.max(0, now - stats.loading.first) : 0;
    details.advancedDateTime = Date.now() - elapsed;

    // if current playlist is a live playlist, arm a timer to reload it
    if (details.live || previousDetails != null && previousDetails.live) {
      details.reloaded(previousDetails);
      if (previousDetails) {
        this.log(`live playlist ${index} ${details.advanced ? 'REFRESHED ' + details.lastPartSn + '-' + details.lastPartIndex : 'MISSED'}`);
      }
      // Merge live playlists to adjust fragment starts and fill in delta playlist skipped segments
      if (previousDetails && details.fragments.length > 0) {
        mergeDetails(previousDetails, details);
      }
      if (!this.canLoad || !details.live) {
        return;
      }
      let deliveryDirectives;
      let msn = undefined;
      let part = undefined;
      if (details.canBlockReload && details.endSN && details.advanced) {
        // Load level with LL-HLS delivery directives
        const lowLatencyMode = this.hls.config.lowLatencyMode;
        const lastPartSn = details.lastPartSn;
        const endSn = details.endSN;
        const lastPartIndex = details.lastPartIndex;
        const hasParts = lastPartIndex !== -1;
        const lastPart = lastPartSn === endSn;
        // When low latency mode is disabled, we'll skip part requests once the last part index is found
        const nextSnStartIndex = lowLatencyMode ? 0 : lastPartIndex;
        if (hasParts) {
          msn = lastPart ? endSn + 1 : lastPartSn;
          part = lastPart ? nextSnStartIndex : lastPartIndex + 1;
        } else {
          msn = endSn + 1;
        }
        // Low-Latency CDN Tune-in: "age" header and time since load indicates we're behind by more than one part
        // Update directives to obtain the Playlist that has the estimated additional duration of media
        const lastAdvanced = details.age;
        const cdnAge = lastAdvanced + details.ageHeader;
        let currentGoal = Math.min(cdnAge - details.partTarget, details.targetduration * 1.5);
        if (currentGoal > 0) {
          if (previousDetails && currentGoal > previousDetails.tuneInGoal) {
            // If we attempted to get the next or latest playlist update, but currentGoal increased,
            // then we either can't catchup, or the "age" header cannot be trusted.
            this.warn(`CDN Tune-in goal increased from: ${previousDetails.tuneInGoal} to: ${currentGoal} with playlist age: ${details.age}`);
            currentGoal = 0;
          } else {
            const segments = Math.floor(currentGoal / details.targetduration);
            msn += segments;
            if (part !== undefined) {
              const parts = Math.round(currentGoal % details.targetduration / details.partTarget);
              part += parts;
            }
            this.log(`CDN Tune-in age: ${details.ageHeader}s last advanced ${lastAdvanced.toFixed(2)}s goal: ${currentGoal} skip sn ${segments} to part ${part}`);
          }
          details.tuneInGoal = currentGoal;
        }
        deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
        if (lowLatencyMode || !lastPart) {
          this.loadPlaylist(deliveryDirectives);
          return;
        }
      } else if (details.canBlockReload) {
        deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
      }
      const bufferInfo = this.hls.mainForwardBufferInfo;
      const position = bufferInfo ? bufferInfo.end - bufferInfo.len : 0;
      const distanceToLiveEdgeMs = (details.edge - position) * 1000;
      const reloadInterval = computeReloadInterval(details, distanceToLiveEdgeMs);
      if (details.updated && now > this.requestScheduled + reloadInterval) {
        this.requestScheduled = stats.loading.start;
      }
      if (msn !== undefined && details.canBlockReload) {
        this.requestScheduled = stats.loading.first + reloadInterval - (details.partTarget * 1000 || 1000);
      } else if (this.requestScheduled === -1 || this.requestScheduled + reloadInterval < now) {
        this.requestScheduled = now;
      } else if (this.requestScheduled - now <= 0) {
        this.requestScheduled += reloadInterval;
      }
      let estimatedTimeUntilUpdate = this.requestScheduled - now;
      estimatedTimeUntilUpdate = Math.max(0, estimatedTimeUntilUpdate);
      this.log(`reload live playlist ${index} in ${Math.round(estimatedTimeUntilUpdate)} ms`);
      // this.log(
      //   `live reload ${details.updated ? 'REFRESHED' : 'MISSED'}
      // reload in ${estimatedTimeUntilUpdate / 1000}
      // round trip ${(stats.loading.end - stats.loading.start) / 1000}
      // diff ${
      //   (reloadInterval -
      //     (estimatedTimeUntilUpdate +
      //       stats.loading.end -
      //       stats.loading.start)) /
      //   1000
      // }
      // reload interval ${reloadInterval / 1000}
      // target duration ${details.targetduration}
      // distance to edge ${distanceToLiveEdgeMs / 1000}`
      // );

      this.timer = self.setTimeout(() => this.loadPlaylist(deliveryDirectives), estimatedTimeUntilUpdate);
    } else {
      this.clearTimer();
    }
  }
  getDeliveryDirectives(details, previousDeliveryDirectives, msn, part) {
    let skip = getSkipValue(details, msn);
    if (previousDeliveryDirectives != null && previousDeliveryDirectives.skip && details.deltaUpdateFailed) {
      msn = previousDeliveryDirectives.msn;
      part = previousDeliveryDirectives.part;
      skip = HlsSkip.No;
    }
    return new HlsUrlParameters(msn, part, skip);
  }
  checkRetry(errorEvent) {
    const errorDetails = errorEvent.details;
    const isTimeout = isTimeoutError(errorEvent);
    const errorAction = errorEvent.errorAction;
    const {
      action,
      retryCount = 0,
      retryConfig
    } = errorAction || {};
    const retry = !!errorAction && !!retryConfig && (action === NetworkErrorAction.RetryRequest || !errorAction.resolved && action === NetworkErrorAction.SendAlternateToPenaltyBox);
    if (retry) {
      var _errorEvent$context;
      this.requestScheduled = -1;
      if (retryCount >= retryConfig.maxNumRetry) {
        return false;
      }
      if (isTimeout && (_errorEvent$context = errorEvent.context) != null && _errorEvent$context.deliveryDirectives) {
        // The LL-HLS request already timed out so retry immediately
        this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" without delivery-directives`);
        this.loadPlaylist();
      } else {
        const delay = getRetryDelay(retryConfig, retryCount);
        // Schedule level/track reload
        this.timer = self.setTimeout(() => this.loadPlaylist(), delay);
        this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" in ${delay}ms`);
      }
      // `levelRetry = true` used to inform other controllers that a retry is happening
      errorEvent.levelRetry = true;
      errorAction.resolved = true;
    }
    return retry;
  }
}

let chromeOrFirefox;
class LevelController extends BasePlaylistController {
  constructor(hls, contentSteeringController) {
    super(hls, '[level-controller]');
    this._levels = [];
    this._firstLevel = -1;
    this._startLevel = void 0;
    this.currentLevel = null;
    this.currentLevelIndex = -1;
    this.manualLevelIndex = -1;
    this.steering = void 0;
    this.onParsedComplete = void 0;
    this.steering = contentSteeringController;
    this._registerListeners();
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners();
    this.steering = null;
    this.resetLevels();
    super.destroy();
  }
  startLoad() {
    const levels = this._levels;

    // clean up live level details to force reload them, and reset load errors
    levels.forEach(level => {
      level.loadError = 0;
      level.fragmentError = 0;
    });
    super.startLoad();
  }
  resetLevels() {
    this._startLevel = undefined;
    this.manualLevelIndex = -1;
    this.currentLevelIndex = -1;
    this.currentLevel = null;
    this._levels = [];
  }
  onManifestLoading(event, data) {
    this.resetLevels();
  }
  onManifestLoaded(event, data) {
    const levels = [];
    const levelSet = {};
    let levelFromSet;

    // regroup redundant levels together
    data.levels.forEach(levelParsed => {
      var _levelParsed$audioCod;
      const attributes = levelParsed.attrs;

      // erase audio codec info if browser does not support mp4a.40.34.
      // demuxer will autodetect codec and fallback to mpeg/audio
      if (((_levelParsed$audioCod = levelParsed.audioCodec) == null ? void 0 : _levelParsed$audioCod.indexOf('mp4a.40.34')) !== -1) {
        chromeOrFirefox || (chromeOrFirefox = /chrome|firefox/i.test(navigator.userAgent));
        if (chromeOrFirefox) {
          levelParsed.audioCodec = undefined;
        }
      }
      const {
        AUDIO,
        CODECS,
        'FRAME-RATE': FRAMERATE,
        'PATHWAY-ID': PATHWAY,
        RESOLUTION,
        SUBTITLES
      } = attributes;
      const contentSteeringPrefix = `${PATHWAY || '.'}-` ;
      const levelKey = `${contentSteeringPrefix}${levelParsed.bitrate}-${RESOLUTION}-${FRAMERATE}-${CODECS}`;
      levelFromSet = levelSet[levelKey];
      if (!levelFromSet) {
        levelFromSet = new Level(levelParsed);
        levelSet[levelKey] = levelFromSet;
        levels.push(levelFromSet);
      } else {
        levelFromSet.addFallback(levelParsed);
      }
      addGroupId(levelFromSet, 'audio', AUDIO);
      addGroupId(levelFromSet, 'text', SUBTITLES);
    });
    this.filterAndSortMediaOptions(levels, data);
  }
  filterAndSortMediaOptions(unfilteredLevels, data) {
    let audioTracks = [];
    let subtitleTracks = [];
    let resolutionFound = false;
    let videoCodecFound = false;
    let audioCodecFound = false;

    // only keep levels with supported audio/video codecs
    let levels = unfilteredLevels.filter(({
      audioCodec,
      videoCodec,
      width,
      height,
      unknownCodecs
    }) => {
      resolutionFound || (resolutionFound = !!(width && height));
      videoCodecFound || (videoCodecFound = !!videoCodec);
      audioCodecFound || (audioCodecFound = !!audioCodec);
      return !(unknownCodecs != null && unknownCodecs.length) && (!audioCodec || isCodecSupportedInMp4(audioCodec, 'audio')) && (!videoCodec || isCodecSupportedInMp4(videoCodec, 'video'));
    });

    // remove audio-only level if we also have levels with video codecs or RESOLUTION signalled
    if ((resolutionFound || videoCodecFound) && audioCodecFound) {
      levels = levels.filter(({
        videoCodec,
        width,
        height
      }) => !!videoCodec || !!(width && height));
    }
    if (levels.length === 0) {
      // Dispatch error after MANIFEST_LOADED is done propagating
      Promise.resolve().then(() => {
        if (this.hls) {
          const error = new Error('no level with compatible codecs found in manifest');
          this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: true,
            url: data.url,
            error,
            reason: error.message
          });
        }
      });
      return;
    }
    if (data.audioTracks) {
      audioTracks = data.audioTracks.filter(track => !track.audioCodec || isCodecSupportedInMp4(track.audioCodec, 'audio'));
      // Assign ids after filtering as array indices by group-id
      assignTrackIdsByGroup(audioTracks);
    }
    if (data.subtitles) {
      subtitleTracks = data.subtitles;
      assignTrackIdsByGroup(subtitleTracks);
    }
    // start bitrate is the first bitrate of the manifest
    const unsortedLevels = levels.slice(0);
    // sort levels from lowest to highest
    levels.sort((a, b) => {
      if (a.attrs['HDCP-LEVEL'] !== b.attrs['HDCP-LEVEL']) {
        return (a.attrs['HDCP-LEVEL'] || '') > (b.attrs['HDCP-LEVEL'] || '') ? 1 : -1;
      }
      if (a.bitrate !== b.bitrate) {
        return a.bitrate - b.bitrate;
      }
      if (a.attrs['FRAME-RATE'] !== b.attrs['FRAME-RATE']) {
        return a.attrs.decimalFloatingPoint('FRAME-RATE') - b.attrs.decimalFloatingPoint('FRAME-RATE');
      }
      if (a.attrs.SCORE !== b.attrs.SCORE) {
        return a.attrs.decimalFloatingPoint('SCORE') - b.attrs.decimalFloatingPoint('SCORE');
      }
      if (resolutionFound && a.height !== b.height) {
        return a.height - b.height;
      }
      return 0;
    });
    let firstLevelInPlaylist = unsortedLevels[0];
    if (this.steering) {
      levels = this.steering.filterParsedLevels(levels);
      if (levels.length !== unsortedLevels.length) {
        for (let i = 0; i < unsortedLevels.length; i++) {
          if (unsortedLevels[i].pathwayId === levels[0].pathwayId) {
            firstLevelInPlaylist = unsortedLevels[i];
            break;
          }
        }
      }
    }
    this._levels = levels;

    // find index of first level in sorted levels
    for (let i = 0; i < levels.length; i++) {
      if (levels[i] === firstLevelInPlaylist) {
        this._firstLevel = i;
        this.log(`manifest loaded, ${levels.length} level(s) found, first bitrate: ${firstLevelInPlaylist.bitrate}`);
        break;
      }
    }

    // Audio is only alternate if manifest include a URI along with the audio group tag,
    // and this is not an audio-only stream where levels contain audio-only
    const audioOnly = audioCodecFound && !videoCodecFound;
    const edata = {
      levels,
      audioTracks,
      subtitleTracks,
      sessionData: data.sessionData,
      sessionKeys: data.sessionKeys,
      firstLevel: this._firstLevel,
      stats: data.stats,
      audio: audioCodecFound,
      video: videoCodecFound,
      altAudio: !audioOnly && audioTracks.some(t => !!t.url)
    };
    this.hls.trigger(Events.MANIFEST_PARSED, edata);

    // Initiate loading after all controllers have received MANIFEST_PARSED
    if (this.hls.config.autoStartLoad || this.hls.forceStartLoad) {
      this.hls.startLoad(this.hls.config.startPosition);
    }
  }
  get levels() {
    if (this._levels.length === 0) {
      return null;
    }
    return this._levels;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(newLevel) {
    const levels = this._levels;
    if (levels.length === 0) {
      return;
    }
    // check if level idx is valid
    if (newLevel < 0 || newLevel >= levels.length) {
      // invalid level id given, trigger error
      const error = new Error('invalid level idx');
      const fatal = newLevel < 0;
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.LEVEL_SWITCH_ERROR,
        level: newLevel,
        fatal,
        error,
        reason: error.message
      });
      if (fatal) {
        return;
      }
      newLevel = Math.min(newLevel, levels.length - 1);
    }
    const lastLevelIndex = this.currentLevelIndex;
    const lastLevel = this.currentLevel;
    const lastPathwayId = lastLevel ? lastLevel.attrs['PATHWAY-ID'] : undefined;
    const level = levels[newLevel];
    const pathwayId = level.attrs['PATHWAY-ID'];
    this.currentLevelIndex = newLevel;
    this.currentLevel = level;
    if (lastLevelIndex === newLevel && level.details && lastLevel && lastPathwayId === pathwayId) {
      return;
    }
    this.log(`Switching to level ${newLevel}${pathwayId ? ' with Pathway ' + pathwayId : ''} from level ${lastLevelIndex}${lastPathwayId ? ' with Pathway ' + lastPathwayId : ''}`);
    const levelSwitchingData = _extends({}, level, {
      level: newLevel,
      maxBitrate: level.maxBitrate,
      attrs: level.attrs,
      uri: level.uri,
      urlId: level.urlId
    });
    // @ts-ignore
    delete levelSwitchingData._attrs;
    // @ts-ignore
    delete levelSwitchingData._urlId;
    this.hls.trigger(Events.LEVEL_SWITCHING, levelSwitchingData);
    // check if we need to load playlist for this level
    const levelDetails = level.details;
    if (!levelDetails || levelDetails.live) {
      // level not retrieved yet, or live playlist we need to (re)load it
      const hlsUrlParameters = this.switchParams(level.uri, lastLevel == null ? void 0 : lastLevel.details);
      this.loadPlaylist(hlsUrlParameters);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(newLevel) {
    this.manualLevelIndex = newLevel;
    if (this._startLevel === undefined) {
      this._startLevel = newLevel;
    }
    if (newLevel !== -1) {
      this.level = newLevel;
    }
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(newLevel) {
    this._firstLevel = newLevel;
  }
  get startLevel() {
    // hls.startLevel takes precedence over config.startLevel
    // if none of these values are defined, fallback on this._firstLevel (first quality level appearing in variant manifest)
    if (this._startLevel === undefined) {
      const configStartLevel = this.hls.config.startLevel;
      if (configStartLevel !== undefined) {
        return configStartLevel;
      } else {
        return this._firstLevel;
      }
    } else {
      return this._startLevel;
    }
  }
  set startLevel(newLevel) {
    this._startLevel = newLevel;
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.LEVEL && data.context.level === this.level) {
      this.checkRetry(data);
    }
  }

  // reset errors on the successful load of a fragment
  onFragLoaded(event, {
    frag
  }) {
    if (frag !== undefined && frag.type === PlaylistLevelType.MAIN) {
      const level = this._levels[frag.level];
      if (level !== undefined) {
        level.loadError = 0;
      }
    }
  }
  onLevelLoaded(event, data) {
    var _data$deliveryDirecti2;
    const {
      level,
      details
    } = data;
    const curLevel = this._levels[level];
    if (!curLevel) {
      var _data$deliveryDirecti;
      this.warn(`Invalid level index ${level}`);
      if ((_data$deliveryDirecti = data.deliveryDirectives) != null && _data$deliveryDirecti.skip) {
        details.deltaUpdateFailed = true;
      }
      return;
    }

    // only process level loaded events matching with expected level
    if (level === this.currentLevelIndex) {
      // reset level load error counter on successful level loaded only if there is no issues with fragments
      if (curLevel.fragmentError === 0) {
        curLevel.loadError = 0;
      }
      this.playlistLoaded(level, data, curLevel.details);
    } else if ((_data$deliveryDirecti2 = data.deliveryDirectives) != null && _data$deliveryDirecti2.skip) {
      // received a delta playlist update that cannot be merged
      details.deltaUpdateFailed = true;
    }
  }
  onAudioTrackSwitched(event, data) {
    const currentLevel = this.currentLevel;
    if (!currentLevel) {
      return;
    }
    const audioGroupId = this.hls.audioTracks[data.id].groupId;
    if (currentLevel.audioGroupIds && currentLevel.audioGroupId !== audioGroupId) {
      let urlId = -1;
      for (let i = 0; i < currentLevel.audioGroupIds.length; i++) {
        if (currentLevel.audioGroupIds[i] === audioGroupId) {
          urlId = i;
          break;
        }
      }
      if (urlId !== -1 && urlId !== currentLevel.urlId) {
        currentLevel.urlId = urlId;
        if (this.canLoad) {
          this.startLoad();
        }
      }
    }
  }
  loadPlaylist(hlsUrlParameters) {
    super.loadPlaylist();
    const currentLevelIndex = this.currentLevelIndex;
    const currentLevel = this.currentLevel;
    if (currentLevel && this.shouldLoadPlaylist(currentLevel)) {
      const id = currentLevel.urlId;
      let url = currentLevel.uri;
      if (hlsUrlParameters) {
        try {
          url = hlsUrlParameters.addDirectives(url);
        } catch (error) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
        }
      }
      const pathwayId = currentLevel.attrs['PATHWAY-ID'];
      this.log(`Loading level index ${currentLevelIndex}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''} with${pathwayId ? ' Pathway ' + pathwayId : ''} URI ${id + 1}/${currentLevel.url.length} ${url}`);

      // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
      // console.log('New video quality level audio group id:', levelObject.attrs.AUDIO, level);
      this.clearTimer();
      this.hls.trigger(Events.LEVEL_LOADING, {
        url,
        level: currentLevelIndex,
        id,
        deliveryDirectives: hlsUrlParameters || null
      });
    }
  }
  get nextLoadLevel() {
    if (this.manualLevelIndex !== -1) {
      return this.manualLevelIndex;
    } else {
      return this.hls.nextAutoLevel;
    }
  }
  set nextLoadLevel(nextLevel) {
    this.level = nextLevel;
    if (this.manualLevelIndex === -1) {
      this.hls.nextAutoLevel = nextLevel;
    }
  }
  removeLevel(levelIndex, urlId) {
    const filterLevelAndGroupByIdIndex = (url, id) => id !== urlId;
    const levels = this._levels.filter((level, index) => {
      if (index !== levelIndex) {
        return true;
      }
      if (level.url.length > 1 && urlId !== undefined) {
        level.url = level.url.filter(filterLevelAndGroupByIdIndex);
        if (level.audioGroupIds) {
          level.audioGroupIds = level.audioGroupIds.filter(filterLevelAndGroupByIdIndex);
        }
        if (level.textGroupIds) {
          level.textGroupIds = level.textGroupIds.filter(filterLevelAndGroupByIdIndex);
        }
        level.urlId = 0;
        return true;
      }
      if (this.steering) {
        this.steering.removeLevel(level);
      }
      return false;
    });
    this.hls.trigger(Events.LEVELS_UPDATED, {
      levels
    });
  }
  onLevelsUpdated(event, {
    levels
  }) {
    levels.forEach((level, index) => {
      const {
        details
      } = level;
      if (details != null && details.fragments) {
        details.fragments.forEach(fragment => {
          fragment.level = index;
        });
      }
    });
    this._levels = levels;
  }
}
function addGroupId(level, type, id) {
  if (!id) {
    return;
  }
  if (type === 'audio') {
    if (!level.audioGroupIds) {
      level.audioGroupIds = [];
    }
    level.audioGroupIds[level.url.length - 1] = id;
  } else if (type === 'text') {
    if (!level.textGroupIds) {
      level.textGroupIds = [];
    }
    level.textGroupIds[level.url.length - 1] = id;
  }
}
function assignTrackIdsByGroup(tracks) {
  const groups = {};
  tracks.forEach(track => {
    const groupId = track.groupId || '';
    track.id = groups[groupId] = groups[groupId] || 0;
    groups[groupId]++;
  });
}

var FragmentState = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class FragmentTracker {
  constructor(hls) {
    this.activePartLists = Object.create(null);
    this.endListFragments = Object.create(null);
    this.fragments = Object.create(null);
    this.timeRanges = Object.create(null);
    this.bufferPadding = 0.2;
    this.hls = void 0;
    this.hasGaps = false;
    this.hls = hls;
    this._registerListeners();
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners();
    // @ts-ignore
    this.fragments =
    // @ts-ignore
    this.activePartLists =
    // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }

  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(position, levelType) {
    const activeParts = this.activePartLists[levelType];
    if (activeParts) {
      for (let i = activeParts.length; i--;) {
        const activePart = activeParts[i];
        if (!activePart) {
          break;
        }
        const appendedPTS = activePart.end;
        if (activePart.start <= position && appendedPTS !== null && position <= appendedPTS) {
          return activePart;
        }
      }
    }
    return this.getBufferedFrag(position, levelType);
  }

  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(position, levelType) {
    const {
      fragments
    } = this;
    const keys = Object.keys(fragments);
    for (let i = keys.length; i--;) {
      const fragmentEntity = fragments[keys[i]];
      if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === levelType && fragmentEntity.buffered) {
        const frag = fragmentEntity.body;
        if (frag.start <= position && position <= frag.end) {
          return frag;
        }
      }
    }
    return null;
  }

  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(elementaryStream, timeRange, playlistType, appendedPart) {
    if (this.timeRanges) {
      this.timeRanges[elementaryStream] = timeRange;
    }
    // Check if any flagged fragments have been unloaded
    // excluding anything newer than appendedPartSn
    const appendedPartSn = (appendedPart == null ? void 0 : appendedPart.fragment.sn) || -1;
    Object.keys(this.fragments).forEach(key => {
      const fragmentEntity = this.fragments[key];
      if (!fragmentEntity) {
        return;
      }
      if (appendedPartSn >= fragmentEntity.body.sn) {
        return;
      }
      if (!fragmentEntity.buffered && !fragmentEntity.loaded) {
        if (fragmentEntity.body.type === playlistType) {
          this.removeFragment(fragmentEntity.body);
        }
        return;
      }
      const esData = fragmentEntity.range[elementaryStream];
      if (!esData) {
        return;
      }
      esData.time.some(time => {
        const isNotBuffered = !this.isTimeBuffered(time.startPTS, time.endPTS, timeRange);
        if (isNotBuffered) {
          // Unregister partial fragment as it needs to load again to be reused
          this.removeFragment(fragmentEntity.body);
        }
        return isNotBuffered;
      });
    });
  }

  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(data) {
    const timeRanges = this.timeRanges;
    const {
      frag,
      part
    } = data;
    if (!timeRanges || frag.sn === 'initSegment') {
      return;
    }
    const fragKey = getFragmentKey(frag);
    const fragmentEntity = this.fragments[fragKey];
    if (!fragmentEntity || fragmentEntity.buffered && frag.gap) {
      return;
    }
    const isFragHint = !frag.relurl;
    Object.keys(timeRanges).forEach(elementaryStream => {
      const streamInfo = frag.elementaryStreams[elementaryStream];
      if (!streamInfo) {
        return;
      }
      const timeRange = timeRanges[elementaryStream];
      const partial = isFragHint || streamInfo.partial === true;
      fragmentEntity.range[elementaryStream] = this.getBufferedTimes(frag, part, partial, timeRange);
    });
    fragmentEntity.loaded = null;
    if (Object.keys(fragmentEntity.range).length) {
      fragmentEntity.buffered = true;
      if (fragmentEntity.body.endList) {
        this.endListFragments[fragmentEntity.body.type] = fragmentEntity;
      }
      if (!isPartial(fragmentEntity)) {
        // Remove older fragment parts from lookup after frag is tracked as buffered
        this.removeParts(frag.sn - 1, frag.type);
      }
    } else {
      // remove fragment if nothing was appended
      this.removeFragment(fragmentEntity.body);
    }
  }
  removeParts(snToKeep, levelType) {
    const activeParts = this.activePartLists[levelType];
    if (!activeParts) {
      return;
    }
    this.activePartLists[levelType] = activeParts.filter(part => part.fragment.sn >= snToKeep);
  }
  fragBuffered(frag, force) {
    const fragKey = getFragmentKey(frag);
    let fragmentEntity = this.fragments[fragKey];
    if (!fragmentEntity && force) {
      fragmentEntity = this.fragments[fragKey] = {
        body: frag,
        appendedPTS: null,
        loaded: null,
        buffered: false,
        range: Object.create(null)
      };
      if (frag.gap) {
        this.hasGaps = true;
      }
    }
    if (fragmentEntity) {
      fragmentEntity.loaded = null;
      fragmentEntity.buffered = true;
    }
  }
  getBufferedTimes(fragment, part, partial, timeRange) {
    const buffered = {
      time: [],
      partial
    };
    const startPTS = fragment.start;
    const endPTS = fragment.end;
    const minEndPTS = fragment.minEndPTS || endPTS;
    const maxStartPTS = fragment.maxStartPTS || startPTS;
    for (let i = 0; i < timeRange.length; i++) {
      const startTime = timeRange.start(i) - this.bufferPadding;
      const endTime = timeRange.end(i) + this.bufferPadding;
      if (maxStartPTS >= startTime && minEndPTS <= endTime) {
        // Fragment is entirely contained in buffer
        // No need to check the other timeRange times since it's completely playable
        buffered.time.push({
          startPTS: Math.max(startPTS, timeRange.start(i)),
          endPTS: Math.min(endPTS, timeRange.end(i))
        });
        break;
      } else if (startPTS < endTime && endPTS > startTime) {
        buffered.partial = true;
        // Check for intersection with buffer
        // Get playable sections of the fragment
        buffered.time.push({
          startPTS: Math.max(startPTS, timeRange.start(i)),
          endPTS: Math.min(endPTS, timeRange.end(i))
        });
      } else if (endPTS <= startTime) {
        // No need to check the rest of the timeRange as it is in order
        break;
      }
    }
    return buffered;
  }

  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(time) {
    let bestFragment = null;
    let timePadding;
    let startTime;
    let endTime;
    let bestOverlap = 0;
    const {
      bufferPadding,
      fragments
    } = this;
    Object.keys(fragments).forEach(key => {
      const fragmentEntity = fragments[key];
      if (!fragmentEntity) {
        return;
      }
      if (isPartial(fragmentEntity)) {
        startTime = fragmentEntity.body.start - bufferPadding;
        endTime = fragmentEntity.body.end + bufferPadding;
        if (time >= startTime && time <= endTime) {
          // Use the fragment that has the most padding from start and end time
          timePadding = Math.min(time - startTime, endTime - time);
          if (bestOverlap <= timePadding) {
            bestFragment = fragmentEntity.body;
            bestOverlap = timePadding;
          }
        }
      }
    });
    return bestFragment;
  }
  isEndListAppended(type) {
    const lastFragmentEntity = this.endListFragments[type];
    return lastFragmentEntity !== undefined && (lastFragmentEntity.buffered || isPartial(lastFragmentEntity));
  }
  getState(fragment) {
    const fragKey = getFragmentKey(fragment);
    const fragmentEntity = this.fragments[fragKey];
    if (fragmentEntity) {
      if (!fragmentEntity.buffered) {
        return FragmentState.APPENDING;
      } else if (isPartial(fragmentEntity)) {
        return FragmentState.PARTIAL;
      } else {
        return FragmentState.OK;
      }
    }
    return FragmentState.NOT_LOADED;
  }
  isTimeBuffered(startPTS, endPTS, timeRange) {
    let startTime;
    let endTime;
    for (let i = 0; i < timeRange.length; i++) {
      startTime = timeRange.start(i) - this.bufferPadding;
      endTime = timeRange.end(i) + this.bufferPadding;
      if (startPTS >= startTime && endPTS <= endTime) {
        return true;
      }
      if (endPTS <= startTime) {
        // No need to check the rest of the timeRange as it is in order
        return false;
      }
    }
    return false;
  }
  onFragLoaded(event, data) {
    const {
      frag,
      part
    } = data;
    // don't track initsegment (for which sn is not a number)
    // don't track frags used for bitrateTest, they're irrelevant.
    if (frag.sn === 'initSegment' || frag.bitrateTest) {
      return;
    }

    // Fragment entity `loaded` FragLoadedData is null when loading parts
    const loaded = part ? null : data;
    const fragKey = getFragmentKey(frag);
    this.fragments[fragKey] = {
      body: frag,
      appendedPTS: null,
      loaded,
      buffered: false,
      range: Object.create(null)
    };
  }
  onBufferAppended(event, data) {
    const {
      frag,
      part,
      timeRanges
    } = data;
    if (frag.sn === 'initSegment') {
      return;
    }
    const playlistType = frag.type;
    if (part) {
      let activeParts = this.activePartLists[playlistType];
      if (!activeParts) {
        this.activePartLists[playlistType] = activeParts = [];
      }
      activeParts.push(part);
    }
    // Store the latest timeRanges loaded in the buffer
    this.timeRanges = timeRanges;
    Object.keys(timeRanges).forEach(elementaryStream => {
      const timeRange = timeRanges[elementaryStream];
      this.detectEvictedFragments(elementaryStream, timeRange, playlistType, part);
    });
  }
  onFragBuffered(event, data) {
    this.detectPartialFragments(data);
  }
  hasFragment(fragment) {
    const fragKey = getFragmentKey(fragment);
    return !!this.fragments[fragKey];
  }
  hasParts(type) {
    var _this$activePartLists;
    return !!((_this$activePartLists = this.activePartLists[type]) != null && _this$activePartLists.length);
  }
  removeFragmentsInRange(start, end, playlistType, withGapOnly, unbufferedOnly) {
    if (withGapOnly && !this.hasGaps) {
      return;
    }
    Object.keys(this.fragments).forEach(key => {
      const fragmentEntity = this.fragments[key];
      if (!fragmentEntity) {
        return;
      }
      const frag = fragmentEntity.body;
      if (frag.type !== playlistType || withGapOnly && !frag.gap) {
        return;
      }
      if (frag.start < end && frag.end > start && (fragmentEntity.buffered || unbufferedOnly)) {
        this.removeFragment(frag);
      }
    });
  }
  removeFragment(fragment) {
    const fragKey = getFragmentKey(fragment);
    fragment.stats.loaded = 0;
    fragment.clearElementaryStreamInfo();
    const activeParts = this.activePartLists[fragment.type];
    if (activeParts) {
      const snToRemove = fragment.sn;
      this.activePartLists[fragment.type] = activeParts.filter(part => part.fragment.sn !== snToRemove);
    }
    delete this.fragments[fragKey];
    if (fragment.endList) {
      delete this.endListFragments[fragment.type];
    }
  }
  removeAllFragments() {
    this.fragments = Object.create(null);
    this.endListFragments = Object.create(null);
    this.activePartLists = Object.create(null);
    this.hasGaps = false;
  }
}
function isPartial(fragmentEntity) {
  var _fragmentEntity$range, _fragmentEntity$range2, _fragmentEntity$range3;
  return fragmentEntity.buffered && (fragmentEntity.body.gap || ((_fragmentEntity$range = fragmentEntity.range.video) == null ? void 0 : _fragmentEntity$range.partial) || ((_fragmentEntity$range2 = fragmentEntity.range.audio) == null ? void 0 : _fragmentEntity$range2.partial) || ((_fragmentEntity$range3 = fragmentEntity.range.audiovideo) == null ? void 0 : _fragmentEntity$range3.partial));
}
function getFragmentKey(fragment) {
  return `${fragment.type}_${fragment.level}_${fragment.urlId}_${fragment.sn}`;
}

const MIN_CHUNK_SIZE = Math.pow(2, 17); // 128kb

class FragmentLoader {
  constructor(config) {
    this.config = void 0;
    this.loader = null;
    this.partLoadTimeout = -1;
    this.config = config;
  }
  destroy() {
    if (this.loader) {
      this.loader.destroy();
      this.loader = null;
    }
  }
  abort() {
    if (this.loader) {
      // Abort the loader for current fragment. Only one may load at any given time
      this.loader.abort();
    }
  }
  load(frag, onProgress) {
    const url = frag.url;
    if (!url) {
      return Promise.reject(new LoadError({
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.FRAG_LOAD_ERROR,
        fatal: false,
        frag,
        error: new Error(`Fragment does not have a ${url ? 'part list' : 'url'}`),
        networkDetails: null
      }));
    }
    this.abort();
    const config = this.config;
    const FragmentILoader = config.fLoader;
    const DefaultILoader = config.loader;
    return new Promise((resolve, reject) => {
      if (this.loader) {
        this.loader.destroy();
      }
      if (frag.gap) {
        if (frag.tagList.some(tags => tags[0] === 'GAP')) {
          reject(createGapLoadError(frag));
          return;
        } else {
          // Reset temporary treatment as GAP tag
          frag.gap = false;
        }
      }
      const loader = this.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
      const loaderContext = createLoaderContext(frag);
      const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: frag.sn === 'initSegment' ? Infinity : MIN_CHUNK_SIZE
      };
      // Assign frag stats to the loader's stats reference
      frag.stats = loader.stats;
      loader.load(loaderContext, loaderConfig, {
        onSuccess: (response, stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          let payload = response.data;
          if (context.resetIV && frag.decryptdata) {
            frag.decryptdata.iv = new Uint8Array(payload.slice(0, 16));
            payload = payload.slice(16);
          }
          resolve({
            frag,
            part: null,
            payload,
            networkDetails
          });
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_ERROR,
            fatal: false,
            frag,
            response: _objectSpread2({
              url,
              data: undefined
            }, response),
            error: new Error(`HTTP Error ${response.code} ${response.text}`),
            networkDetails,
            stats
          }));
        },
        onAbort: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.INTERNAL_ABORTED,
            fatal: false,
            frag,
            error: new Error('Aborted'),
            networkDetails,
            stats
          }));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_TIMEOUT,
            fatal: false,
            frag,
            error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
            networkDetails,
            stats
          }));
        },
        onProgress: (stats, context, data, networkDetails) => {
          if (onProgress) {
            onProgress({
              frag,
              part: null,
              payload: data,
              networkDetails
            });
          }
        }
      });
    });
  }
  loadPart(frag, part, onProgress) {
    this.abort();
    const config = this.config;
    const FragmentILoader = config.fLoader;
    const DefaultILoader = config.loader;
    return new Promise((resolve, reject) => {
      if (this.loader) {
        this.loader.destroy();
      }
      if (frag.gap || part.gap) {
        reject(createGapLoadError(frag, part));
        return;
      }
      const loader = this.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
      const loaderContext = createLoaderContext(frag, part);
      // Should we define another load policy for parts?
      const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: MIN_CHUNK_SIZE
      };
      // Assign part stats to the loader's stats reference
      part.stats = loader.stats;
      loader.load(loaderContext, loaderConfig, {
        onSuccess: (response, stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          this.updateStatsFromPart(frag, part);
          const partLoadedData = {
            frag,
            part,
            payload: response.data,
            networkDetails
          };
          onProgress(partLoadedData);
          resolve(partLoadedData);
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_ERROR,
            fatal: false,
            frag,
            part,
            response: _objectSpread2({
              url: loaderContext.url,
              data: undefined
            }, response),
            error: new Error(`HTTP Error ${response.code} ${response.text}`),
            networkDetails,
            stats
          }));
        },
        onAbort: (stats, context, networkDetails) => {
          frag.stats.aborted = part.stats.aborted;
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.INTERNAL_ABORTED,
            fatal: false,
            frag,
            part,
            error: new Error('Aborted'),
            networkDetails,
            stats
          }));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_TIMEOUT,
            fatal: false,
            frag,
            part,
            error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
            networkDetails,
            stats
          }));
        }
      });
    });
  }
  updateStatsFromPart(frag, part) {
    const fragStats = frag.stats;
    const partStats = part.stats;
    const partTotal = partStats.total;
    fragStats.loaded += partStats.loaded;
    if (partTotal) {
      const estTotalParts = Math.round(frag.duration / part.duration);
      const estLoadedParts = Math.min(Math.round(fragStats.loaded / partTotal), estTotalParts);
      const estRemainingParts = estTotalParts - estLoadedParts;
      const estRemainingBytes = estRemainingParts * Math.round(fragStats.loaded / estLoadedParts);
      fragStats.total = fragStats.loaded + estRemainingBytes;
    } else {
      fragStats.total = Math.max(fragStats.loaded, fragStats.total);
    }
    const fragLoading = fragStats.loading;
    const partLoading = partStats.loading;
    if (fragLoading.start) {
      // add to fragment loader latency
      fragLoading.first += partLoading.first - partLoading.start;
    } else {
      fragLoading.start = partLoading.start;
      fragLoading.first = partLoading.first;
    }
    fragLoading.end = partLoading.end;
  }
  resetLoader(frag, loader) {
    frag.loader = null;
    if (this.loader === loader) {
      self.clearTimeout(this.partLoadTimeout);
      this.loader = null;
    }
    loader.destroy();
  }
}
function createLoaderContext(frag, part = null) {
  const segment = part || frag;
  const loaderContext = {
    frag,
    part,
    responseType: 'arraybuffer',
    url: segment.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  };
  const start = segment.byteRangeStartOffset;
  const end = segment.byteRangeEndOffset;
  if (isFiniteNumber(start) && isFiniteNumber(end)) {
    var _frag$decryptdata;
    let byteRangeStart = start;
    let byteRangeEnd = end;
    if (frag.sn === 'initSegment' && ((_frag$decryptdata = frag.decryptdata) == null ? void 0 : _frag$decryptdata.method) === 'AES-128') {
      // MAP segment encrypted with method 'AES-128', when served with HTTP Range,
      // has the unencrypted size specified in the range.
      // Ref: https://tools.ietf.org/html/draft-pantos-hls-rfc8216bis-08#section-6.3.6
      const fragmentLen = end - start;
      if (fragmentLen % 16) {
        byteRangeEnd = end + (16 - fragmentLen % 16);
      }
      if (start !== 0) {
        loaderContext.resetIV = true;
        byteRangeStart = start - 16;
      }
    }
    loaderContext.rangeStart = byteRangeStart;
    loaderContext.rangeEnd = byteRangeEnd;
  }
  return loaderContext;
}
function createGapLoadError(frag, part) {
  const error = new Error(`GAP ${frag.gap ? 'tag' : 'attribute'} found`);
  const errorData = {
    type: ErrorTypes.MEDIA_ERROR,
    details: ErrorDetails.FRAG_GAP,
    fatal: false,
    frag,
    error,
    networkDetails: null
  };
  if (part) {
    errorData.part = part;
  }
  (part ? part : frag).stats.aborted = true;
  return new LoadError(errorData);
}
class LoadError extends Error {
  constructor(data) {
    super(data.error.message);
    this.data = void 0;
    this.data = data;
  }
}

class KeyLoader {
  constructor(config) {
    this.config = void 0;
    this.keyUriToKeyInfo = {};
    this.emeController = null;
    this.config = config;
  }
  abort(type) {
    for (const uri in this.keyUriToKeyInfo) {
      const loader = this.keyUriToKeyInfo[uri].loader;
      if (loader) {
        if (type && type !== loader.context.frag.type) {
          return;
        }
        loader.abort();
      }
    }
  }
  detach() {
    for (const uri in this.keyUriToKeyInfo) {
      const keyInfo = this.keyUriToKeyInfo[uri];
      // Remove cached EME keys on detach
      if (keyInfo.mediaKeySessionContext || keyInfo.decryptdata.isCommonEncryption) {
        delete this.keyUriToKeyInfo[uri];
      }
    }
  }
  destroy() {
    this.detach();
    for (const uri in this.keyUriToKeyInfo) {
      const loader = this.keyUriToKeyInfo[uri].loader;
      if (loader) {
        loader.destroy();
      }
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(frag, details = ErrorDetails.KEY_LOAD_ERROR, error, networkDetails, response) {
    return new LoadError({
      type: ErrorTypes.NETWORK_ERROR,
      details,
      fatal: false,
      frag,
      response,
      error,
      networkDetails
    });
  }
  loadClear(loadingFrag, encryptedFragments) {
    if (this.emeController && this.config.emeEnabled) {
      // access key-system with nearest key on start (loaidng frag is unencrypted)
      const {
        sn,
        cc
      } = loadingFrag;
      for (let i = 0; i < encryptedFragments.length; i++) {
        const frag = encryptedFragments[i];
        if (cc <= frag.cc && (sn === 'initSegment' || frag.sn === 'initSegment' || sn < frag.sn)) {
          this.emeController.selectKeySystemFormat(frag).then(keySystemFormat => {
            frag.setKeyFormat(keySystemFormat);
          });
          break;
        }
      }
    }
  }
  load(frag) {
    if (!frag.decryptdata && frag.encrypted && this.emeController) {
      // Multiple keys, but none selected, resolve in eme-controller
      return this.emeController.selectKeySystemFormat(frag).then(keySystemFormat => {
        return this.loadInternal(frag, keySystemFormat);
      });
    }
    return this.loadInternal(frag);
  }
  loadInternal(frag, keySystemFormat) {
    var _keyInfo, _keyInfo2;
    if (keySystemFormat) {
      frag.setKeyFormat(keySystemFormat);
    }
    const decryptdata = frag.decryptdata;
    if (!decryptdata) {
      const error = new Error(keySystemFormat ? `Expected frag.decryptdata to be defined after setting format ${keySystemFormat}` : 'Missing decryption data on fragment in onKeyLoading');
      return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, error));
    }
    const uri = decryptdata.uri;
    if (!uri) {
      return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${uri}"`)));
    }
    let keyInfo = this.keyUriToKeyInfo[uri];
    if ((_keyInfo = keyInfo) != null && _keyInfo.decryptdata.key) {
      decryptdata.key = keyInfo.decryptdata.key;
      return Promise.resolve({
        frag,
        keyInfo
      });
    }
    // Return key load promise as long as it does not have a mediakey session with an unusable key status
    if ((_keyInfo2 = keyInfo) != null && _keyInfo2.keyLoadPromise) {
      var _keyInfo$mediaKeySess;
      switch ((_keyInfo$mediaKeySess = keyInfo.mediaKeySessionContext) == null ? void 0 : _keyInfo$mediaKeySess.keyStatus) {
        case undefined:
        case 'status-pending':
        case 'usable':
        case 'usable-in-future':
          return keyInfo.keyLoadPromise.then(keyLoadedData => {
            // Return the correct fragment with updated decryptdata key and loaded keyInfo
            decryptdata.key = keyLoadedData.keyInfo.decryptdata.key;
            return {
              frag,
              keyInfo
            };
          });
      }
      // If we have a key session and status and it is not pending or usable, continue
      // This will go back to the eme-controller for expired keys to get a new keyLoadPromise
    }

    // Load the key or return the loading promise
    keyInfo = this.keyUriToKeyInfo[uri] = {
      decryptdata,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    };
    switch (decryptdata.method) {
      case 'ISO-23001-7':
      case 'SAMPLE-AES':
      case 'SAMPLE-AES-CENC':
      case 'SAMPLE-AES-CTR':
        if (decryptdata.keyFormat === 'identity') {
          // loadKeyHTTP handles http(s) and data URLs
          return this.loadKeyHTTP(keyInfo, frag);
        }
        return this.loadKeyEME(keyInfo, frag);
      case 'AES-128':
        return this.loadKeyHTTP(keyInfo, frag);
      default:
        return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${decryptdata.method}"`)));
    }
  }
  loadKeyEME(keyInfo, frag) {
    const keyLoadedData = {
      frag,
      keyInfo
    };
    if (this.emeController && this.config.emeEnabled) {
      const keySessionContextPromise = this.emeController.loadKey(keyLoadedData);
      if (keySessionContextPromise) {
        return (keyInfo.keyLoadPromise = keySessionContextPromise.then(keySessionContext => {
          keyInfo.mediaKeySessionContext = keySessionContext;
          return keyLoadedData;
        })).catch(error => {
          // Remove promise for license renewal or retry
          keyInfo.keyLoadPromise = null;
          throw error;
        });
      }
    }
    return Promise.resolve(keyLoadedData);
  }
  loadKeyHTTP(keyInfo, frag) {
    const config = this.config;
    const Loader = config.loader;
    const keyLoader = new Loader(config);
    frag.keyLoader = keyInfo.loader = keyLoader;
    return keyInfo.keyLoadPromise = new Promise((resolve, reject) => {
      const loaderContext = {
        keyInfo,
        frag,
        responseType: 'arraybuffer',
        url: keyInfo.decryptdata.uri
      };

      // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
      // key-loader will trigger an error and rely on stream-controller to handle retry logic.
      // this will also align retry logic with fragment-loader
      const loadPolicy = config.keyLoadPolicy.default;
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      };
      const loaderCallbacks = {
        onSuccess: (response, stats, context, networkDetails) => {
          const {
            frag,
            keyInfo,
            url: uri
          } = context;
          if (!frag.decryptdata || keyInfo !== this.keyUriToKeyInfo[uri]) {
            return reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error('after key load, decryptdata unset or changed'), networkDetails));
          }
          keyInfo.decryptdata.key = frag.decryptdata.key = new Uint8Array(response.data);

          // detach fragment key loader on load success
          frag.keyLoader = null;
          keyInfo.loader = null;
          resolve({
            frag,
            keyInfo
          });
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`HTTP Error ${response.code} loading key ${response.text}`), networkDetails, _objectSpread2({
            url: loaderContext.url,
            data: undefined
          }, response)));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_TIMEOUT, new Error('key loading timed out'), networkDetails));
        },
        onAbort: (stats, context, networkDetails) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.INTERNAL_ABORTED, new Error('key loading aborted'), networkDetails));
        }
      };
      keyLoader.load(loaderContext, loaderConfig, loaderCallbacks);
    });
  }
  resetLoader(context) {
    const {
      frag,
      keyInfo,
      url: uri
    } = context;
    const loader = keyInfo.loader;
    if (frag.keyLoader === loader) {
      frag.keyLoader = null;
      keyInfo.loader = null;
    }
    delete this.keyUriToKeyInfo[uri];
    if (loader) {
      loader.destroy();
    }
  }
}

/**
 * @ignore
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */
class TaskLoop {
  constructor() {
    this._boundTick = void 0;
    this._tickTimer = null;
    this._tickInterval = null;
    this._tickCallCount = 0;
    this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying();
    this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    // clear all timers before unregistering from event bus
    this.clearNextTick();
    this.clearInterval();
  }
  onHandlerDestroyed() {}
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }

  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(millis) {
    if (!this._tickInterval) {
      this._tickCallCount = 0;
      this._tickInterval = self.setInterval(this._boundTick, millis);
      return true;
    }
    return false;
  }

  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    if (this._tickInterval) {
      self.clearInterval(this._tickInterval);
      this._tickInterval = null;
      return true;
    }
    return false;
  }

  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    if (this._tickTimer) {
      self.clearTimeout(this._tickTimer);
      this._tickTimer = null;
      return true;
    }
    return false;
  }

  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++;
    if (this._tickCallCount === 1) {
      this.doTick();
      // re-entrant call to tick from previous doTick call stack
      // -> schedule a call on the next main loop iteration to process this task processing request
      if (this._tickCallCount > 1) {
        // make sure only one timer exists at any time at max
        this.tickImmediate();
      }
      this._tickCallCount = 0;
    }
  }
  tickImmediate() {
    this.clearNextTick();
    this._tickTimer = self.setTimeout(this._boundTick, 0);
  }

  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {}
}

/**
 * Provides methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
 */

const noopBuffered = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class BufferHelper {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(media, position) {
    try {
      if (media) {
        const buffered = BufferHelper.getBuffered(media);
        for (let i = 0; i < buffered.length; i++) {
          if (position >= buffered.start(i) && position <= buffered.end(i)) {
            return true;
          }
        }
      }
    } catch (error) {
      // this is to catch
      // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
      // This SourceBuffer has been removed from the parent media source
    }
    return false;
  }
  static bufferInfo(media, pos, maxHoleDuration) {
    try {
      if (media) {
        const vbuffered = BufferHelper.getBuffered(media);
        const buffered = [];
        let i;
        for (i = 0; i < vbuffered.length; i++) {
          buffered.push({
            start: vbuffered.start(i),
            end: vbuffered.end(i)
          });
        }
        return this.bufferedInfo(buffered, pos, maxHoleDuration);
      }
    } catch (error) {
      // this is to catch
      // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
      // This SourceBuffer has been removed from the parent media source
    }
    return {
      len: 0,
      start: pos,
      end: pos,
      nextStart: undefined
    };
  }
  static bufferedInfo(buffered, pos, maxHoleDuration) {
    pos = Math.max(0, pos);
    // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
    buffered.sort(function (a, b) {
      const diff = a.start - b.start;
      if (diff) {
        return diff;
      } else {
        return b.end - a.end;
      }
    });
    let buffered2 = [];
    if (maxHoleDuration) {
      // there might be some small holes between buffer time range
      // consider that holes smaller than maxHoleDuration are irrelevant and build another
      // buffer time range representations that discards those holes
      for (let i = 0; i < buffered.length; i++) {
        const buf2len = buffered2.length;
        if (buf2len) {
          const buf2end = buffered2[buf2len - 1].end;
          // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
          if (buffered[i].start - buf2end < maxHoleDuration) {
            // merge overlapping time ranges
            // update lastRange.end only if smaller than item.end
            // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
            // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
            if (buffered[i].end > buf2end) {
              buffered2[buf2len - 1].end = buffered[i].end;
            }
          } else {
            // big hole
            buffered2.push(buffered[i]);
          }
        } else {
          // first value
          buffered2.push(buffered[i]);
        }
      }
    } else {
      buffered2 = buffered;
    }
    let bufferLen = 0;

    // bufferStartNext can possibly be undefined based on the conditional logic below
    let bufferStartNext;

    // bufferStart and bufferEnd are buffer boundaries around current video position
    let bufferStart = pos;
    let bufferEnd = pos;
    for (let i = 0; i < buffered2.length; i++) {
      const start = buffered2[i].start;
      const end = buffered2[i].end;
      // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
      if (pos + maxHoleDuration >= start && pos < end) {
        // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
        bufferStart = start;
        bufferEnd = end;
        bufferLen = bufferEnd - pos;
      } else if (pos + maxHoleDuration < start) {
        bufferStartNext = start;
        break;
      }
    }
    return {
      len: bufferLen,
      start: bufferStart || 0,
      end: bufferEnd || 0,
      nextStart: bufferStartNext
    };
  }

  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(media) {
    try {
      return media.buffered;
    } catch (e) {
      logger.log('failed to get media.buffered', e);
      return noopBuffered;
    }
  }
}

class ChunkMetadata {
  constructor(level, sn, id, size = 0, part = -1, partial = false) {
    this.level = void 0;
    this.sn = void 0;
    this.part = void 0;
    this.id = void 0;
    this.size = void 0;
    this.partial = void 0;
    this.transmuxing = getNewPerformanceTiming();
    this.buffering = {
      audio: getNewPerformanceTiming(),
      video: getNewPerformanceTiming(),
      audiovideo: getNewPerformanceTiming()
    };
    this.level = level;
    this.sn = sn;
    this.id = id;
    this.size = size;
    this.part = part;
    this.partial = partial;
  }
}
function getNewPerformanceTiming() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}

function findFirstFragWithCC(fragments, cc) {
  let firstFrag = null;
  for (let i = 0, len = fragments.length; i < len; i++) {
    const currentFrag = fragments[i];
    if (currentFrag && currentFrag.cc === cc) {
      firstFrag = currentFrag;
      break;
    }
  }
  return firstFrag;
}
function shouldAlignOnDiscontinuities(lastFrag, lastLevel, details) {
  if (lastLevel.details) {
    if (details.endCC > details.startCC || lastFrag && lastFrag.cc < details.startCC) {
      return true;
    }
  }
  return false;
}

// Find the first frag in the previous level which matches the CC of the first frag of the new level
function findDiscontinuousReferenceFrag(prevDetails, curDetails, referenceIndex = 0) {
  const prevFrags = prevDetails.fragments;
  const curFrags = curDetails.fragments;
  if (!curFrags.length || !prevFrags.length) {
    logger.log('No fragments to align');
    return;
  }
  const prevStartFrag = findFirstFragWithCC(prevFrags, curFrags[0].cc);
  if (!prevStartFrag || prevStartFrag && !prevStartFrag.startPTS) {
    logger.log('No frag in previous level to align on');
    return;
  }
  return prevStartFrag;
}
function adjustFragmentStart(frag, sliding) {
  if (frag) {
    const start = frag.start + sliding;
    frag.start = frag.startPTS = start;
    frag.endPTS = start + frag.duration;
  }
}
function adjustSlidingStart(sliding, details) {
  // Update segments
  const fragments = details.fragments;
  for (let i = 0, len = fragments.length; i < len; i++) {
    adjustFragmentStart(fragments[i], sliding);
  }
  // Update LL-HLS parts at the end of the playlist
  if (details.fragmentHint) {
    adjustFragmentStart(details.fragmentHint, sliding);
  }
  details.alignedSliding = true;
}

/**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastFrag
 * @param lastLevel
 * @param details
 */
function alignStream(lastFrag, lastLevel, details) {
  if (!lastLevel) {
    return;
  }
  alignDiscontinuities(lastFrag, details, lastLevel);
  if (!details.alignedSliding && lastLevel.details) {
    // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
    // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
    // discontinuity sequence.
    alignPDT(details, lastLevel.details);
  }
  if (!details.alignedSliding && lastLevel.details && !details.skippedSegments) {
    // Try to align on sn so that we pick a better start fragment.
    // Do not perform this on playlists with delta updates as this is only to align levels on switch
    // and adjustSliding only adjusts fragments after skippedSegments.
    adjustSliding(lastLevel.details, details);
  }
}

/**
 * Computes the PTS if a new level's fragments using the PTS of a fragment in the last level which shares the same
 * discontinuity sequence.
 * @param lastFrag - The last Fragment which shares the same discontinuity sequence
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */
function alignDiscontinuities(lastFrag, details, lastLevel) {
  if (shouldAlignOnDiscontinuities(lastFrag, lastLevel, details)) {
    const referenceFrag = findDiscontinuousReferenceFrag(lastLevel.details, details);
    if (referenceFrag && isFiniteNumber(referenceFrag.start)) {
      logger.log(`Adjusting PTS using last level due to CC increase within current level ${details.url}`);
      adjustSlidingStart(referenceFrag.start, details);
    }
  }
}

/**
 * Computes the PTS of a new level's fragments using the difference in Program Date Time from the last level.
 * @param details - The details of the new level
 * @param lastDetails - The details of the last loaded level
 */
function alignPDT(details, lastDetails) {
  // This check protects the unsafe "!" usage below for null program date time access.
  if (!lastDetails.fragments.length || !details.hasProgramDateTime || !lastDetails.hasProgramDateTime) {
    return;
  }
  // if last level sliding is 1000 and its first frag PROGRAM-DATE-TIME is 2017-08-20 1:10:00 AM
  // and if new details first frag PROGRAM DATE-TIME is 2017-08-20 1:10:08 AM
  // then we can deduce that playlist B sliding is 1000+8 = 1008s
  const lastPDT = lastDetails.fragments[0].programDateTime; // hasProgramDateTime check above makes this safe.
  const newPDT = details.fragments[0].programDateTime;
  // date diff is in ms. frag.start is in seconds
  const sliding = (newPDT - lastPDT) / 1000 + lastDetails.fragments[0].start;
  if (sliding && isFiniteNumber(sliding)) {
    logger.log(`Adjusting PTS using programDateTime delta ${newPDT - lastPDT}ms, sliding:${sliding.toFixed(3)} ${details.url} `);
    adjustSlidingStart(sliding, details);
  }
}

/**
 * Ensures appropriate time-alignment between renditions based on PDT. Unlike `alignPDT`, which adjusts
 * the timeline based on the delta between PDTs of the 0th fragment of two playlists/`LevelDetails`,
 * this function assumes the timelines represented in `refDetails` are accurate, including the PDTs,
 * and uses the "wallclock"/PDT timeline as a cross-reference to `details`, adjusting the presentation
 * times/timelines of `details` accordingly.
 * Given the asynchronous nature of fetches and initial loads of live `main` and audio/subtitle tracks,
 * the primary purpose of this function is to ensure the "local timelines" of audio/subtitle tracks
 * are aligned to the main/video timeline, using PDT as the cross-reference/"anchor" that should
 * be consistent across playlists, per the HLS spec.
 * @param details - The details of the rendition you'd like to time-align (e.g. an audio rendition).
 * @param refDetails - The details of the reference rendition with start and PDT times for alignment.
 */
function alignMediaPlaylistByPDT(details, refDetails) {
  if (!details.hasProgramDateTime || !refDetails.hasProgramDateTime) {
    return;
  }
  const fragments = details.fragments;
  const refFragments = refDetails.fragments;
  if (!fragments.length || !refFragments.length) {
    return;
  }

  // Calculate a delta to apply to all fragments according to the delta in PDT times and start times
  // of a fragment in the reference details, and a fragment in the target details of the same discontinuity.
  // If a fragment of the same discontinuity was not found use the middle fragment of both.
  const middleFrag = Math.round(refFragments.length / 2) - 1;
  const refFrag = refFragments[middleFrag];
  const frag = findFirstFragWithCC(fragments, refFrag.cc) || fragments[Math.round(fragments.length / 2) - 1];
  const refPDT = refFrag.programDateTime;
  const targetPDT = frag.programDateTime;
  if (refPDT === null || targetPDT === null) {
    return;
  }
  const delta = (targetPDT - refPDT) / 1000 - (frag.start - refFrag.start);
  adjustSlidingStart(delta, details);
}

class AESCrypto {
  constructor(subtle, iv) {
    this.subtle = void 0;
    this.aesIV = void 0;
    this.subtle = subtle;
    this.aesIV = iv;
  }
  decrypt(data, key) {
    return this.subtle.decrypt({
      name: 'AES-CBC',
      iv: this.aesIV
    }, key, data);
  }
}

class FastAESKey {
  constructor(subtle, key) {
    this.subtle = void 0;
    this.key = void 0;
    this.subtle = subtle;
    this.key = key;
  }
  expandKey() {
    return this.subtle.importKey('raw', this.key, {
      name: 'AES-CBC'
    }, false, ['encrypt', 'decrypt']);
  }
}

// PKCS7
function removePadding(array) {
  const outputBytes = array.byteLength;
  const paddingBytes = outputBytes && new DataView(array.buffer).getUint8(outputBytes - 1);
  if (paddingBytes) {
    return sliceUint8(array, 0, outputBytes - paddingBytes);
  }
  return array;
}
class AESDecryptor {
  constructor() {
    this.rcon = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
    this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.sBox = new Uint32Array(256);
    this.invSBox = new Uint32Array(256);
    this.key = new Uint32Array(0);
    this.ksRows = 0;
    this.keySize = 0;
    this.keySchedule = void 0;
    this.invKeySchedule = void 0;
    this.initTable();
  }

  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(arrayBuffer) {
    const view = new DataView(arrayBuffer);
    const newArray = new Uint32Array(4);
    for (let i = 0; i < 4; i++) {
      newArray[i] = view.getUint32(i * 4);
    }
    return newArray;
  }
  initTable() {
    const sBox = this.sBox;
    const invSBox = this.invSBox;
    const subMix = this.subMix;
    const subMix0 = subMix[0];
    const subMix1 = subMix[1];
    const subMix2 = subMix[2];
    const subMix3 = subMix[3];
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    const d = new Uint32Array(256);
    let x = 0;
    let xi = 0;
    let i = 0;
    for (i = 0; i < 256; i++) {
      if (i < 128) {
        d[i] = i << 1;
      } else {
        d[i] = i << 1 ^ 0x11b;
      }
    }
    for (i = 0; i < 256; i++) {
      let sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
      sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
      sBox[x] = sx;
      invSBox[sx] = x;

      // Compute multiplication
      const x2 = d[x];
      const x4 = d[x2];
      const x8 = d[x4];

      // Compute sub/invSub bytes, mix columns tables
      let t = d[sx] * 0x101 ^ sx * 0x1010100;
      subMix0[x] = t << 24 | t >>> 8;
      subMix1[x] = t << 16 | t >>> 16;
      subMix2[x] = t << 8 | t >>> 24;
      subMix3[x] = t;

      // Compute inv sub bytes, inv mix columns tables
      t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
      invSubMix0[sx] = t << 24 | t >>> 8;
      invSubMix1[sx] = t << 16 | t >>> 16;
      invSubMix2[sx] = t << 8 | t >>> 24;
      invSubMix3[sx] = t;

      // Compute next counter
      if (!x) {
        x = xi = 1;
      } else {
        x = x2 ^ d[d[d[x8 ^ x2]]];
        xi ^= d[d[xi]];
      }
    }
  }
  expandKey(keyBuffer) {
    // convert keyBuffer to Uint32Array
    const key = this.uint8ArrayToUint32Array_(keyBuffer);
    let sameKey = true;
    let offset = 0;
    while (offset < key.length && sameKey) {
      sameKey = key[offset] === this.key[offset];
      offset++;
    }
    if (sameKey) {
      return;
    }
    this.key = key;
    const keySize = this.keySize = key.length;
    if (keySize !== 4 && keySize !== 6 && keySize !== 8) {
      throw new Error('Invalid aes key size=' + keySize);
    }
    const ksRows = this.ksRows = (keySize + 6 + 1) * 4;
    let ksRow;
    let invKsRow;
    const keySchedule = this.keySchedule = new Uint32Array(ksRows);
    const invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
    const sbox = this.sBox;
    const rcon = this.rcon;
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    let prev;
    let t;
    for (ksRow = 0; ksRow < ksRows; ksRow++) {
      if (ksRow < keySize) {
        prev = keySchedule[ksRow] = key[ksRow];
        continue;
      }
      t = prev;
      if (ksRow % keySize === 0) {
        // Rot word
        t = t << 8 | t >>> 24;

        // Sub word
        t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];

        // Mix Rcon
        t ^= rcon[ksRow / keySize | 0] << 24;
      } else if (keySize > 6 && ksRow % keySize === 4) {
        // Sub word
        t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
      }
      keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
    }
    for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
      ksRow = ksRows - invKsRow;
      if (invKsRow & 3) {
        t = keySchedule[ksRow];
      } else {
        t = keySchedule[ksRow - 4];
      }
      if (invKsRow < 4 || ksRow <= 4) {
        invKeySchedule[invKsRow] = t;
      } else {
        invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
      }
      invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
    }
  }

  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(word) {
    return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
  }
  decrypt(inputArrayBuffer, offset, aesIV) {
    const nRounds = this.keySize + 6;
    const invKeySchedule = this.invKeySchedule;
    const invSBOX = this.invSBox;
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    const initVector = this.uint8ArrayToUint32Array_(aesIV);
    let initVector0 = initVector[0];
    let initVector1 = initVector[1];
    let initVector2 = initVector[2];
    let initVector3 = initVector[3];
    const inputInt32 = new Int32Array(inputArrayBuffer);
    const outputInt32 = new Int32Array(inputInt32.length);
    let t0, t1, t2, t3;
    let s0, s1, s2, s3;
    let inputWords0, inputWords1, inputWords2, inputWords3;
    let ksRow, i;
    const swapWord = this.networkToHostOrderSwap;
    while (offset < inputInt32.length) {
      inputWords0 = swapWord(inputInt32[offset]);
      inputWords1 = swapWord(inputInt32[offset + 1]);
      inputWords2 = swapWord(inputInt32[offset + 2]);
      inputWords3 = swapWord(inputInt32[offset + 3]);
      s0 = inputWords0 ^ invKeySchedule[0];
      s1 = inputWords3 ^ invKeySchedule[1];
      s2 = inputWords2 ^ invKeySchedule[2];
      s3 = inputWords1 ^ invKeySchedule[3];
      ksRow = 4;

      // Iterate through the rounds of decryption
      for (i = 1; i < nRounds; i++) {
        t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
        t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
        t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
        t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
        // Update state
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
        ksRow = ksRow + 4;
      }

      // Shift rows, sub bytes, add round key
      t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
      t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
      t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
      t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];

      // Write
      outputInt32[offset] = swapWord(t0 ^ initVector0);
      outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
      outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
      outputInt32[offset + 3] = swapWord(t1 ^ initVector3);

      // reset initVector to last 4 unsigned int
      initVector0 = inputWords0;
      initVector1 = inputWords1;
      initVector2 = inputWords2;
      initVector3 = inputWords3;
      offset = offset + 4;
    }
    return outputInt32.buffer;
  }
}

const CHUNK_SIZE = 16; // 16 bytes, 128 bits

class Decrypter {
  constructor(config, {
    removePKCS7Padding = true
  } = {}) {
    this.logEnabled = true;
    this.removePKCS7Padding = void 0;
    this.subtle = null;
    this.softwareDecrypter = null;
    this.key = null;
    this.fastAesKey = null;
    this.remainderData = null;
    this.currentIV = null;
    this.currentResult = null;
    this.useSoftware = void 0;
    this.useSoftware = config.enableSoftwareAES;
    this.removePKCS7Padding = removePKCS7Padding;
    // built in decryptor expects PKCS7 padding
    if (removePKCS7Padding) {
      try {
        const browserCrypto = self.crypto;
        if (browserCrypto) {
          this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
        }
      } catch (e) {
        /* no-op */
      }
    }
    if (this.subtle === null) {
      this.useSoftware = true;
    }
  }
  destroy() {
    this.subtle = null;
    this.softwareDecrypter = null;
    this.key = null;
    this.fastAesKey = null;
    this.remainderData = null;
    this.currentIV = null;
    this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult,
      remainderData
    } = this;
    if (!currentResult || remainderData) {
      this.reset();
      return null;
    }
    const data = new Uint8Array(currentResult);
    this.reset();
    if (this.removePKCS7Padding) {
      return removePadding(data);
    }
    return data;
  }
  reset() {
    this.currentResult = null;
    this.currentIV = null;
    this.remainderData = null;
    if (this.softwareDecrypter) {
      this.softwareDecrypter = null;
    }
  }
  decrypt(data, key, iv) {
    if (this.useSoftware) {
      return new Promise((resolve, reject) => {
        this.softwareDecrypt(new Uint8Array(data), key, iv);
        const decryptResult = this.flush();
        if (decryptResult) {
          resolve(decryptResult.buffer);
        } else {
          reject(new Error('[softwareDecrypt] Failed to decrypt data'));
        }
      });
    }
    return this.webCryptoDecrypt(new Uint8Array(data), key, iv);
  }

  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(data, key, iv) {
    const {
      currentIV,
      currentResult,
      remainderData
    } = this;
    this.logOnce('JS AES decrypt');
    // The output is staggered during progressive parsing - the current result is cached, and emitted on the next call
    // This is done in order to strip PKCS7 padding, which is found at the end of each segment. We only know we've reached
    // the end on flush(), but by that time we have already received all bytes for the segment.
    // Progressive decryption does not work with WebCrypto

    if (remainderData) {
      data = appendUint8Array(remainderData, data);
      this.remainderData = null;
    }

    // Byte length must be a multiple of 16 (AES-128 = 128 bit blocks = 16 bytes)
    const currentChunk = this.getValidChunk(data);
    if (!currentChunk.length) {
      return null;
    }
    if (currentIV) {
      iv = currentIV;
    }
    let softwareDecrypter = this.softwareDecrypter;
    if (!softwareDecrypter) {
      softwareDecrypter = this.softwareDecrypter = new AESDecryptor();
    }
    softwareDecrypter.expandKey(key);
    const result = currentResult;
    this.currentResult = softwareDecrypter.decrypt(currentChunk.buffer, 0, iv);
    this.currentIV = sliceUint8(currentChunk, -16).buffer;
    if (!result) {
      return null;
    }
    return result;
  }
  webCryptoDecrypt(data, key, iv) {
    const subtle = this.subtle;
    if (this.key !== key || !this.fastAesKey) {
      this.key = key;
      this.fastAesKey = new FastAESKey(subtle, key);
    }
    return this.fastAesKey.expandKey().then(aesKey => {
      // decrypt using web crypto
      if (!subtle) {
        return Promise.reject(new Error('web crypto not initialized'));
      }
      this.logOnce('WebCrypto AES decrypt');
      const crypto = new AESCrypto(subtle, new Uint8Array(iv));
      return crypto.decrypt(data.buffer, aesKey);
    }).catch(err => {
      logger.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${err.name}: ${err.message}`);
      return this.onWebCryptoError(data, key, iv);
    });
  }
  onWebCryptoError(data, key, iv) {
    this.useSoftware = true;
    this.logEnabled = true;
    this.softwareDecrypt(data, key, iv);
    const decryptResult = this.flush();
    if (decryptResult) {
      return decryptResult.buffer;
    }
    throw new Error('WebCrypto and softwareDecrypt: failed to decrypt data');
  }
  getValidChunk(data) {
    let currentChunk = data;
    const splitPoint = data.length - data.length % CHUNK_SIZE;
    if (splitPoint !== data.length) {
      currentChunk = sliceUint8(data, 0, splitPoint);
      this.remainderData = sliceUint8(data, splitPoint);
    }
    return currentChunk;
  }
  logOnce(msg) {
    if (!this.logEnabled) {
      return;
    }
    logger.log(`[decrypter]: ${msg}`);
    this.logEnabled = false;
  }
}

/**
 *  TimeRanges to string helper
 */

const TimeRanges = {
  toString: function (r) {
    let log = '';
    const len = r.length;
    for (let i = 0; i < len; i++) {
      log += `[${r.start(i).toFixed(3)}-${r.end(i).toFixed(3)}]`;
    }
    return log;
  }
};

const State = {
  STOPPED: 'STOPPED',
  IDLE: 'IDLE',
  KEY_LOADING: 'KEY_LOADING',
  FRAG_LOADING: 'FRAG_LOADING',
  FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
  WAITING_TRACK: 'WAITING_TRACK',
  PARSING: 'PARSING',
  PARSED: 'PARSED',
  ENDED: 'ENDED',
  ERROR: 'ERROR',
  WAITING_INIT_PTS: 'WAITING_INIT_PTS',
  WAITING_LEVEL: 'WAITING_LEVEL'
};
class BaseStreamController extends TaskLoop {
  constructor(hls, fragmentTracker, keyLoader, logPrefix, playlistType) {
    super();
    this.hls = void 0;
    this.fragPrevious = null;
    this.fragCurrent = null;
    this.fragmentTracker = void 0;
    this.transmuxer = null;
    this._state = State.STOPPED;
    this.playlistType = void 0;
    this.media = null;
    this.mediaBuffer = null;
    this.config = void 0;
    this.bitrateTest = false;
    this.lastCurrentTime = 0;
    this.nextLoadPosition = 0;
    this.startPosition = 0;
    this.startTimeOffset = null;
    this.loadedmetadata = false;
    this.retryDate = 0;
    this.levels = null;
    this.fragmentLoader = void 0;
    this.keyLoader = void 0;
    this.levelLastLoaded = null;
    this.startFragRequested = false;
    this.decrypter = void 0;
    this.initPTS = [];
    this.onvseeking = null;
    this.onvended = null;
    this.logPrefix = '';
    this.log = void 0;
    this.warn = void 0;
    this.playlistType = playlistType;
    this.logPrefix = logPrefix;
    this.log = logger.log.bind(logger, `${logPrefix}:`);
    this.warn = logger.warn.bind(logger, `${logPrefix}:`);
    this.hls = hls;
    this.fragmentLoader = new FragmentLoader(hls.config);
    this.keyLoader = keyLoader;
    this.fragmentTracker = fragmentTracker;
    this.config = hls.config;
    this.decrypter = new Decrypter(hls.config);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  startLoad(startPosition) {}
  stopLoad() {
    this.fragmentLoader.abort();
    this.keyLoader.abort(this.playlistType);
    const frag = this.fragCurrent;
    if (frag != null && frag.loader) {
      frag.abortRequests();
      this.fragmentTracker.removeFragment(frag);
    }
    this.resetTransmuxer();
    this.fragCurrent = null;
    this.fragPrevious = null;
    this.clearInterval();
    this.clearNextTick();
    this.state = State.STOPPED;
  }
  _streamEnded(bufferInfo, levelDetails) {
    // If playlist is live, there is another buffered range after the current range, nothing buffered, media is detached,
    // of nothing loading/loaded return false
    if (levelDetails.live || bufferInfo.nextStart || !bufferInfo.end || !this.media) {
      return false;
    }
    const partList = levelDetails.partList;
    // Since the last part isn't guaranteed to correspond to the last playlist segment for Low-Latency HLS,
    // check instead if the last part is buffered.
    if (partList != null && partList.length) {
      const lastPart = partList[partList.length - 1];

      // Checking the midpoint of the part for potential margin of error and related issues.
      // NOTE: Technically I believe parts could yield content that is < the computed duration (including potential a duration of 0)
      // and still be spec-compliant, so there may still be edge cases here. Likewise, there could be issues in end of stream
      // part mismatches for independent audio and video playlists/segments.
      const lastPartBuffered = BufferHelper.isBuffered(this.media, lastPart.start + lastPart.duration / 2);
      return lastPartBuffered;
    }
    const playlistType = levelDetails.fragments[levelDetails.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(playlistType);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var _this$levels$this$lev;
      return (_this$levels$this$lev = this.levels[this.levelLastLoaded]) == null ? void 0 : _this$levels$this$lev.details;
    }
  }
  onMediaAttached(event, data) {
    const media = this.media = this.mediaBuffer = data.media;
    this.onvseeking = this.onMediaSeeking.bind(this);
    this.onvended = this.onMediaEnded.bind(this);
    media.addEventListener('seeking', this.onvseeking);
    media.addEventListener('ended', this.onvended);
    const config = this.config;
    if (this.levels && config.autoStartLoad && this.state === State.STOPPED) {
      this.startLoad(config.startPosition);
    }
  }
  onMediaDetaching() {
    const media = this.media;
    if (media != null && media.ended) {
      this.log('MSE detaching and video ended, reset startPosition');
      this.startPosition = this.lastCurrentTime = 0;
    }

    // remove video listeners
    if (media && this.onvseeking && this.onvended) {
      media.removeEventListener('seeking', this.onvseeking);
      media.removeEventListener('ended', this.onvended);
      this.onvseeking = this.onvended = null;
    }
    if (this.keyLoader) {
      this.keyLoader.detach();
    }
    this.media = this.mediaBuffer = null;
    this.loadedmetadata = false;
    this.fragmentTracker.removeAllFragments();
    this.stopLoad();
  }
  onMediaSeeking() {
    const {
      config,
      fragCurrent,
      media,
      mediaBuffer,
      state
    } = this;
    const currentTime = media ? media.currentTime : 0;
    const bufferInfo = BufferHelper.bufferInfo(mediaBuffer ? mediaBuffer : media, currentTime, config.maxBufferHole);
    this.log(`media seeking to ${isFiniteNumber(currentTime) ? currentTime.toFixed(3) : currentTime}, state: ${state}`);
    if (this.state === State.ENDED) {
      this.resetLoadingState();
    } else if (fragCurrent) {
      // Seeking while frag load is in progress
      const tolerance = config.maxFragLookUpTolerance;
      const fragStartOffset = fragCurrent.start - tolerance;
      const fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
      // if seeking out of buffered range or into new one
      if (!bufferInfo.len || fragEndOffset < bufferInfo.start || fragStartOffset > bufferInfo.end) {
        const pastFragment = currentTime > fragEndOffset;
        // if the seek position is outside the current fragment range
        if (currentTime < fragStartOffset || pastFragment) {
          if (pastFragment && fragCurrent.loader) {
            this.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
            fragCurrent.abortRequests();
            this.resetLoadingState();
          }
          this.fragPrevious = null;
        }
      }
    }
    if (media) {
      // Remove gap fragments
      this.fragmentTracker.removeFragmentsInRange(currentTime, Infinity, this.playlistType, true);
      this.lastCurrentTime = currentTime;
    }

    // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
    if (!this.loadedmetadata && !bufferInfo.len) {
      this.nextLoadPosition = this.startPosition = currentTime;
    }

    // Async tick to speed up processing
    this.tickImmediate();
  }
  onMediaEnded() {
    // reset startPosition and lastCurrentTime to restart playback @ stream beginning
    this.startPosition = this.lastCurrentTime = 0;
  }
  onManifestLoaded(event, data) {
    this.startTimeOffset = data.startTimeOffset;
    this.initPTS = [];
  }
  onHandlerDestroying() {
    this.stopLoad();
    super.onHandlerDestroying();
  }
  onHandlerDestroyed() {
    this.state = State.STOPPED;
    if (this.fragmentLoader) {
      this.fragmentLoader.destroy();
    }
    if (this.keyLoader) {
      this.keyLoader.destroy();
    }
    if (this.decrypter) {
      this.decrypter.destroy();
    }
    this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null;
    super.onHandlerDestroyed();
  }
  loadFragment(frag, level, targetBufferTime) {
    this._loadFragForPlayback(frag, level, targetBufferTime);
  }
  _loadFragForPlayback(frag, level, targetBufferTime) {
    const progressCallback = data => {
      if (this.fragContextChanged(frag)) {
        this.warn(`Fragment ${frag.sn}${data.part ? ' p: ' + data.part.index : ''} of level ${frag.level} was dropped during download.`);
        this.fragmentTracker.removeFragment(frag);
        return;
      }
      frag.stats.chunkCount++;
      this._handleFragmentLoadProgress(data);
    };
    this._doFragLoad(frag, level, targetBufferTime, progressCallback).then(data => {
      if (!data) {
        // if we're here we probably needed to backtrack or are waiting for more parts
        return;
      }
      const state = this.state;
      if (this.fragContextChanged(frag)) {
        if (state === State.FRAG_LOADING || !this.fragCurrent && state === State.PARSING) {
          this.fragmentTracker.removeFragment(frag);
          this.state = State.IDLE;
        }
        return;
      }
      if ('payload' in data) {
        this.log(`Loaded fragment ${frag.sn} of level ${frag.level}`);
        this.hls.trigger(Events.FRAG_LOADED, data);
      }

      // Pass through the whole payload; controllers not implementing progressive loading receive data from this callback
      this._handleFragmentLoadComplete(data);
    }).catch(reason => {
      if (this.state === State.STOPPED || this.state === State.ERROR) {
        return;
      }
      this.warn(reason);
      this.resetFragmentLoading(frag);
    });
  }
  clearTrackerIfNeeded(frag) {
    var _this$mediaBuffer;
    const {
      fragmentTracker
    } = this;
    const fragState = fragmentTracker.getState(frag);
    if (fragState === FragmentState.APPENDING) {
      // Lower the buffer size and try again
      const playlistType = frag.type;
      const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
      const minForwardBufferLength = Math.max(frag.duration, bufferedInfo ? bufferedInfo.len : this.config.maxBufferLength);
      if (this.reduceMaxBufferLength(minForwardBufferLength)) {
        fragmentTracker.removeFragment(frag);
      }
    } else if (((_this$mediaBuffer = this.mediaBuffer) == null ? void 0 : _this$mediaBuffer.buffered.length) === 0) {
      // Stop gap for bad tracker / buffer flush behavior
      fragmentTracker.removeAllFragments();
    } else if (fragmentTracker.hasParts(frag.type)) {
      // In low latency mode, remove fragments for which only some parts were buffered
      fragmentTracker.detectPartialFragments({
        frag,
        part: null,
        stats: frag.stats,
        id: frag.type
      });
      if (fragmentTracker.getState(frag) === FragmentState.PARTIAL) {
        fragmentTracker.removeFragment(frag);
      }
    }
  }
  flushMainBuffer(startOffset, endOffset, type = null) {
    if (!(startOffset - endOffset)) {
      return;
    }
    // When alternate audio is playing, the audio-stream-controller is responsible for the audio buffer. Otherwise,
    // passing a null type flushes both buffers
    const flushScope = {
      startOffset,
      endOffset,
      type
    };
    this.hls.trigger(Events.BUFFER_FLUSHING, flushScope);
  }
  _loadInitSegment(frag, level) {
    this._doFragLoad(frag, level).then(data => {
      if (!data || this.fragContextChanged(frag) || !this.levels) {
        throw new Error('init load aborted');
      }
      return data;
    }).then(data => {
      const {
        hls
      } = this;
      const {
        payload
      } = data;
      const decryptData = frag.decryptdata;

      // check to see if the payload needs to be decrypted
      if (payload && payload.byteLength > 0 && decryptData && decryptData.key && decryptData.iv && decryptData.method === 'AES-128') {
        const startTime = self.performance.now();
        // decrypt init segment data
        return this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).catch(err => {
          hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.FRAG_DECRYPT_ERROR,
            fatal: false,
            error: err,
            reason: err.message,
            frag
          });
          throw err;
        }).then(decryptedData => {
          const endTime = self.performance.now();
          hls.trigger(Events.FRAG_DECRYPTED, {
            frag,
            payload: decryptedData,
            stats: {
              tstart: startTime,
              tdecrypt: endTime
            }
          });
          data.payload = decryptedData;
          return data;
        });
      }
      return data;
    }).then(data => {
      const {
        fragCurrent,
        hls,
        levels
      } = this;
      if (!levels) {
        throw new Error('init load aborted, missing levels');
      }
      const stats = frag.stats;
      this.state = State.IDLE;
      level.fragmentError = 0;
      frag.data = new Uint8Array(data.payload);
      stats.parsing.start = stats.buffering.start = self.performance.now();
      stats.parsing.end = stats.buffering.end = self.performance.now();

      // Silence FRAG_BUFFERED event if fragCurrent is null
      if (data.frag === fragCurrent) {
        hls.trigger(Events.FRAG_BUFFERED, {
          stats,
          frag: fragCurrent,
          part: null,
          id: frag.type
        });
      }
      this.tick();
    }).catch(reason => {
      if (this.state === State.STOPPED || this.state === State.ERROR) {
        return;
      }
      this.warn(reason);
      this.resetFragmentLoading(frag);
    });
  }
  fragContextChanged(frag) {
    const {
      fragCurrent
    } = this;
    return !frag || !fragCurrent || frag.level !== fragCurrent.level || frag.sn !== fragCurrent.sn || frag.urlId !== fragCurrent.urlId;
  }
  fragBufferedComplete(frag, part) {
    var _frag$startPTS, _frag$endPTS, _this$fragCurrent, _this$fragPrevious;
    const media = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.log(`Buffered ${frag.type} sn: ${frag.sn}${part ? ' part: ' + part.index : ''} of ${this.playlistType === PlaylistLevelType.MAIN ? 'level' : 'track'} ${frag.level} (frag:[${((_frag$startPTS = frag.startPTS) != null ? _frag$startPTS : NaN).toFixed(3)}-${((_frag$endPTS = frag.endPTS) != null ? _frag$endPTS : NaN).toFixed(3)}] > buffer:${media ? TimeRanges.toString(BufferHelper.getBuffered(media)) : '(detached)'})`);
    this.state = State.IDLE;
    if (!media) {
      return;
    }
    if (!this.loadedmetadata && frag.type == PlaylistLevelType.MAIN && media.buffered.length && ((_this$fragCurrent = this.fragCurrent) == null ? void 0 : _this$fragCurrent.sn) === ((_this$fragPrevious = this.fragPrevious) == null ? void 0 : _this$fragPrevious.sn)) {
      this.loadedmetadata = true;
      this.seekToStartPos();
    }
    this.tick();
  }
  seekToStartPos() {}
  _handleFragmentLoadComplete(fragLoadedEndData) {
    const {
      transmuxer
    } = this;
    if (!transmuxer) {
      return;
    }
    const {
      frag,
      part,
      partsLoaded
    } = fragLoadedEndData;
    // If we did not load parts, or loaded all parts, we have complete (not partial) fragment data
    const complete = !partsLoaded || partsLoaded.length === 0 || partsLoaded.some(fragLoaded => !fragLoaded);
    const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount + 1, 0, part ? part.index : -1, !complete);
    transmuxer.flush(chunkMeta);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _handleFragmentLoadProgress(frag) {}
  _doFragLoad(frag, level, targetBufferTime = null, progressCallback) {
    var _frag$decryptdata;
    const details = level == null ? void 0 : level.details;
    if (!this.levels || !details) {
      throw new Error(`frag load aborted, missing level${details ? '' : ' detail'}s`);
    }
    let keyLoadingPromise = null;
    if (frag.encrypted && !((_frag$decryptdata = frag.decryptdata) != null && _frag$decryptdata.key)) {
      this.log(`Loading key for ${frag.sn} of [${details.startSN}-${details.endSN}], ${this.logPrefix === '[stream-controller]' ? 'level' : 'track'} ${frag.level}`);
      this.state = State.KEY_LOADING;
      this.fragCurrent = frag;
      keyLoadingPromise = this.keyLoader.load(frag).then(keyLoadedData => {
        if (!this.fragContextChanged(keyLoadedData.frag)) {
          this.hls.trigger(Events.KEY_LOADED, keyLoadedData);
          if (this.state === State.KEY_LOADING) {
            this.state = State.IDLE;
          }
          return keyLoadedData;
        }
      });
      this.hls.trigger(Events.KEY_LOADING, {
        frag
      });
      if (this.fragCurrent === null) {
        keyLoadingPromise = Promise.reject(new Error(`frag load aborted, context changed in KEY_LOADING`));
      }
    } else if (!frag.encrypted && details.encryptedFragments.length) {
      this.keyLoader.loadClear(frag, details.encryptedFragments);
    }
    targetBufferTime = Math.max(frag.start, targetBufferTime || 0);
    if (this.config.lowLatencyMode && frag.sn !== 'initSegment') {
      const partList = details.partList;
      if (partList && progressCallback) {
        if (targetBufferTime > frag.end && details.fragmentHint) {
          frag = details.fragmentHint;
        }
        const partIndex = this.getNextPart(partList, frag, targetBufferTime);
        if (partIndex > -1) {
          const part = partList[partIndex];
          this.log(`Loading part sn: ${frag.sn} p: ${part.index} cc: ${frag.cc} of playlist [${details.startSN}-${details.endSN}] parts [0-${partIndex}-${partList.length - 1}] ${this.logPrefix === '[stream-controller]' ? 'level' : 'track'}: ${frag.level}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
          this.nextLoadPosition = part.start + part.duration;
          this.state = State.FRAG_LOADING;
          let _result;
          if (keyLoadingPromise) {
            _result = keyLoadingPromise.then(keyLoadedData => {
              if (!keyLoadedData || this.fragContextChanged(keyLoadedData.frag)) {
                return null;
              }
              return this.doFragPartsLoad(frag, part, level, progressCallback);
            }).catch(error => this.handleFragLoadError(error));
          } else {
            _result = this.doFragPartsLoad(frag, part, level, progressCallback).catch(error => this.handleFragLoadError(error));
          }
          this.hls.trigger(Events.FRAG_LOADING, {
            frag,
            part,
            targetBufferTime
          });
          if (this.fragCurrent === null) {
            return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING parts`));
          }
          return _result;
        } else if (!frag.url || this.loadedEndOfParts(partList, targetBufferTime)) {
          // Fragment hint has no parts
          return Promise.resolve(null);
        }
      }
    }
    this.log(`Loading fragment ${frag.sn} cc: ${frag.cc} ${details ? 'of [' + details.startSN + '-' + details.endSN + '] ' : ''}${this.logPrefix === '[stream-controller]' ? 'level' : 'track'}: ${frag.level}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
    // Don't update nextLoadPosition for fragments which are not buffered
    if (isFiniteNumber(frag.sn) && !this.bitrateTest) {
      this.nextLoadPosition = frag.start + frag.duration;
    }
    this.state = State.FRAG_LOADING;

    // Load key before streaming fragment data
    const dataOnProgress = this.config.progressive;
    let result;
    if (dataOnProgress && keyLoadingPromise) {
      result = keyLoadingPromise.then(keyLoadedData => {
        if (!keyLoadedData || this.fragContextChanged(keyLoadedData == null ? void 0 : keyLoadedData.frag)) {
          return null;
        }
        return this.fragmentLoader.load(frag, progressCallback);
      }).catch(error => this.handleFragLoadError(error));
    } else {
      // load unencrypted fragment data with progress event,
      // or handle fragment result after key and fragment are finished loading
      result = Promise.all([this.fragmentLoader.load(frag, dataOnProgress ? progressCallback : undefined), keyLoadingPromise]).then(([fragLoadedData]) => {
        if (!dataOnProgress && fragLoadedData && progressCallback) {
          progressCallback(fragLoadedData);
        }
        return fragLoadedData;
      }).catch(error => this.handleFragLoadError(error));
    }
    this.hls.trigger(Events.FRAG_LOADING, {
      frag,
      targetBufferTime
    });
    if (this.fragCurrent === null) {
      return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING`));
    }
    return result;
  }
  doFragPartsLoad(frag, fromPart, level, progressCallback) {
    return new Promise((resolve, reject) => {
      var _level$details;
      const partsLoaded = [];
      const initialPartList = (_level$details = level.details) == null ? void 0 : _level$details.partList;
      const loadPart = part => {
        this.fragmentLoader.loadPart(frag, part, progressCallback).then(partLoadedData => {
          partsLoaded[part.index] = partLoadedData;
          const loadedPart = partLoadedData.part;
          this.hls.trigger(Events.FRAG_LOADED, partLoadedData);
          const nextPart = getPartWith(level, frag.sn, part.index + 1) || findPart(initialPartList, frag.sn, part.index + 1);
          if (nextPart) {
            loadPart(nextPart);
          } else {
            return resolve({
              frag,
              part: loadedPart,
              partsLoaded
            });
          }
        }).catch(reject);
      };
      loadPart(fromPart);
    });
  }
  handleFragLoadError(error) {
    if ('data' in error) {
      const data = error.data;
      if (error.data && data.details === ErrorDetails.INTERNAL_ABORTED) {
        this.handleFragLoadAborted(data.frag, data.part);
      } else {
        this.hls.trigger(Events.ERROR, data);
      }
    } else {
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.INTERNAL_EXCEPTION,
        err: error,
        error,
        fatal: true
      });
    }
    return null;
  }
  _handleTransmuxerFlush(chunkMeta) {
    const context = this.getCurrentContext(chunkMeta);
    if (!context || this.state !== State.PARSING) {
      if (!this.fragCurrent && this.state !== State.STOPPED && this.state !== State.ERROR) {
        this.state = State.IDLE;
      }
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const now = self.performance.now();
    frag.stats.parsing.end = now;
    if (part) {
      part.stats.parsing.end = now;
    }
    this.updateLevelTiming(frag, part, level, chunkMeta.partial);
  }
  getCurrentContext(chunkMeta) {
    const {
      levels,
      fragCurrent
    } = this;
    const {
      level: levelIndex,
      sn,
      part: partIndex
    } = chunkMeta;
    if (!(levels != null && levels[levelIndex])) {
      this.warn(`Levels object was unset while buffering fragment ${sn} of level ${levelIndex}. The current chunk will not be buffered.`);
      return null;
    }
    const level = levels[levelIndex];
    const part = partIndex > -1 ? getPartWith(level, sn, partIndex) : null;
    const frag = part ? part.fragment : getFragmentWithSN(level, sn, fragCurrent);
    if (!frag) {
      return null;
    }
    if (fragCurrent && fragCurrent !== frag) {
      frag.stats = fragCurrent.stats;
    }
    return {
      frag,
      part,
      level
    };
  }
  bufferFragmentData(data, frag, part, chunkMeta, noBacktracking) {
    var _buffer;
    if (!data || this.state !== State.PARSING) {
      return;
    }
    const {
      data1,
      data2
    } = data;
    let buffer = data1;
    if (data1 && data2) {
      // Combine the moof + mdat so that we buffer with a single append
      buffer = appendUint8Array(data1, data2);
    }
    if (!((_buffer = buffer) != null && _buffer.length)) {
      return;
    }
    const segment = {
      type: data.type,
      frag,
      part,
      chunkMeta,
      parent: frag.type,
      data: buffer
    };
    this.hls.trigger(Events.BUFFER_APPENDING, segment);
    if (data.dropped && data.independent && !part) {
      if (noBacktracking) {
        return;
      }
      // Clear buffer so that we reload previous segments sequentially if required
      this.flushBufferGap(frag);
    }
  }
  flushBufferGap(frag) {
    const media = this.media;
    if (!media) {
      return;
    }
    // If currentTime is not buffered, clear the back buffer so that we can backtrack as much as needed
    if (!BufferHelper.isBuffered(media, media.currentTime)) {
      this.flushMainBuffer(0, frag.start);
      return;
    }
    // Remove back-buffer without interrupting playback to allow back tracking
    const currentTime = media.currentTime;
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const fragDuration = frag.duration;
    const segmentFraction = Math.min(this.config.maxFragLookUpTolerance * 2, fragDuration * 0.25);
    const start = Math.max(Math.min(frag.start - segmentFraction, bufferInfo.end - segmentFraction), currentTime + segmentFraction);
    if (frag.start - start > segmentFraction) {
      this.flushMainBuffer(start, frag.start);
    }
  }
  getFwdBufferInfo(bufferable, type) {
    const pos = this.getLoadPosition();
    if (!isFiniteNumber(pos)) {
      return null;
    }
    return this.getFwdBufferInfoAtPos(bufferable, pos, type);
  }
  getFwdBufferInfoAtPos(bufferable, pos, type) {
    const {
      config: {
        maxBufferHole
      }
    } = this;
    const bufferInfo = BufferHelper.bufferInfo(bufferable, pos, maxBufferHole);
    // Workaround flaw in getting forward buffer when maxBufferHole is smaller than gap at current pos
    if (bufferInfo.len === 0 && bufferInfo.nextStart !== undefined) {
      const bufferedFragAtPos = this.fragmentTracker.getBufferedFrag(pos, type);
      if (bufferedFragAtPos && bufferInfo.nextStart < bufferedFragAtPos.end) {
        return BufferHelper.bufferInfo(bufferable, pos, Math.max(bufferInfo.nextStart, maxBufferHole));
      }
    }
    return bufferInfo;
  }
  getMaxBufferLength(levelBitrate) {
    const {
      config
    } = this;
    let maxBufLen;
    if (levelBitrate) {
      maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
    } else {
      maxBufLen = config.maxBufferLength;
    }
    return Math.min(maxBufLen, config.maxMaxBufferLength);
  }
  reduceMaxBufferLength(threshold) {
    const config = this.config;
    const minLength = threshold || config.maxBufferLength;
    if (config.maxMaxBufferLength >= minLength) {
      // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
      config.maxMaxBufferLength /= 2;
      this.warn(`Reduce max buffer length to ${config.maxMaxBufferLength}s`);
      return true;
    }
    return false;
  }
  getAppendedFrag(position, playlistType = PlaylistLevelType.MAIN) {
    const fragOrPart = this.fragmentTracker.getAppendedFrag(position, PlaylistLevelType.MAIN);
    if (fragOrPart && 'fragment' in fragOrPart) {
      return fragOrPart.fragment;
    }
    return fragOrPart;
  }
  getNextFragment(pos, levelDetails) {
    const fragments = levelDetails.fragments;
    const fragLen = fragments.length;
    if (!fragLen) {
      return null;
    }

    // find fragment index, contiguous with end of buffer position
    const {
      config
    } = this;
    const start = fragments[0].start;
    let frag;
    if (levelDetails.live) {
      const initialLiveManifestSize = config.initialLiveManifestSize;
      if (fragLen < initialLiveManifestSize) {
        this.warn(`Not enough fragments to start playback (have: ${fragLen}, need: ${initialLiveManifestSize})`);
        return null;
      }
      // The real fragment start times for a live stream are only known after the PTS range for that level is known.
      // In order to discover the range, we load the best matching fragment for that level and demux it.
      // Do not load using live logic if the starting frag is requested - we want to use getFragmentAtPosition() so that
      // we get the fragment matching that start time
      if (!levelDetails.PTSKnown && !this.startFragRequested && this.startPosition === -1) {
        frag = this.getInitialLiveFragment(levelDetails, fragments);
        this.startPosition = frag ? this.hls.liveSyncPosition || frag.start : pos;
      }
    } else if (pos <= start) {
      // VoD playlist: if loadPosition before start of playlist, load first fragment
      frag = fragments[0];
    }

    // If we haven't run into any special cases already, just load the fragment most closely matching the requested position
    if (!frag) {
      const end = config.lowLatencyMode ? levelDetails.partEnd : levelDetails.fragmentEnd;
      frag = this.getFragmentAtPosition(pos, end, levelDetails);
    }
    return this.mapToInitFragWhenRequired(frag);
  }
  isLoopLoading(frag, targetBufferTime) {
    const trackerState = this.fragmentTracker.getState(frag);
    return (trackerState === FragmentState.OK || trackerState === FragmentState.PARTIAL && !!frag.gap) && this.nextLoadPosition > targetBufferTime;
  }
  getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, playlistType, maxBufLen) {
    const gapStart = frag.gap;
    const nextFragment = this.getNextFragment(this.nextLoadPosition, levelDetails);
    if (nextFragment === null) {
      return nextFragment;
    }
    frag = nextFragment;
    if (gapStart && frag && !frag.gap && bufferInfo.nextStart) {
      // Media buffered after GAP tags should not make the next buffer timerange exceed forward buffer length
      const nextbufferInfo = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, bufferInfo.nextStart, playlistType);
      if (nextbufferInfo !== null && bufferInfo.len + nextbufferInfo.len >= maxBufLen) {
        // Returning here might result in not finding an audio and video candiate to skip to
        this.log(`buffer full after gaps in "${playlistType}" playlist starting at sn: ${frag.sn}`);
        return null;
      }
    }
    return frag;
  }
  mapToInitFragWhenRequired(frag) {
    // If an initSegment is present, it must be buffered first
    if (frag != null && frag.initSegment && !(frag != null && frag.initSegment.data) && !this.bitrateTest) {
      return frag.initSegment;
    }
    return frag;
  }
  getNextPart(partList, frag, targetBufferTime) {
    let nextPart = -1;
    let contiguous = false;
    let independentAttrOmitted = true;
    for (let i = 0, len = partList.length; i < len; i++) {
      const part = partList[i];
      independentAttrOmitted = independentAttrOmitted && !part.independent;
      if (nextPart > -1 && targetBufferTime < part.start) {
        break;
      }
      const loaded = part.loaded;
      if (loaded) {
        nextPart = -1;
      } else if ((contiguous || part.independent || independentAttrOmitted) && part.fragment === frag) {
        nextPart = i;
      }
      contiguous = loaded;
    }
    return nextPart;
  }
  loadedEndOfParts(partList, targetBufferTime) {
    const lastPart = partList[partList.length - 1];
    return lastPart && targetBufferTime > lastPart.start && lastPart.loaded;
  }

  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(levelDetails, fragments) {
    const fragPrevious = this.fragPrevious;
    let frag = null;
    if (fragPrevious) {
      if (levelDetails.hasProgramDateTime) {
        // Prefer using PDT, because it can be accurate enough to choose the correct fragment without knowing the level sliding
        this.log(`Live playlist, switching playlist, load frag with same PDT: ${fragPrevious.programDateTime}`);
        frag = findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, this.config.maxFragLookUpTolerance);
      }
      if (!frag) {
        // SN does not need to be accurate between renditions, but depending on the packaging it may be so.
        const targetSN = fragPrevious.sn + 1;
        if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
          const fragNext = fragments[targetSN - levelDetails.startSN];
          // Ensure that we're staying within the continuity range, since PTS resets upon a new range
          if (fragPrevious.cc === fragNext.cc) {
            frag = fragNext;
            this.log(`Live playlist, switching playlist, load frag with next SN: ${frag.sn}`);
          }
        }
        // It's important to stay within the continuity range if available; otherwise the fragments in the playlist
        // will have the wrong start times
        if (!frag) {
          frag = findFragWithCC(fragments, fragPrevious.cc);
          if (frag) {
            this.log(`Live playlist, switching playlist, load frag with same CC: ${frag.sn}`);
          }
        }
      }
    } else {
      // Find a new start fragment when fragPrevious is null
      const liveStart = this.hls.liveSyncPosition;
      if (liveStart !== null) {
        frag = this.getFragmentAtPosition(liveStart, this.bitrateTest ? levelDetails.fragmentEnd : levelDetails.edge, levelDetails);
      }
    }
    return frag;
  }

  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(bufferEnd, end, levelDetails) {
    const {
      config
    } = this;
    let {
      fragPrevious
    } = this;
    let {
      fragments,
      endSN
    } = levelDetails;
    const {
      fragmentHint
    } = levelDetails;
    const tolerance = config.maxFragLookUpTolerance;
    const partList = levelDetails.partList;
    const loadingParts = !!(config.lowLatencyMode && partList != null && partList.length && fragmentHint);
    if (loadingParts && fragmentHint && !this.bitrateTest) {
      // Include incomplete fragment with parts at end
      fragments = fragments.concat(fragmentHint);
      endSN = fragmentHint.sn;
    }
    let frag;
    if (bufferEnd < end) {
      const lookupTolerance = bufferEnd > end - tolerance ? 0 : tolerance;
      // Remove the tolerance if it would put the bufferEnd past the actual end of stream
      // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
      frag = findFragmentByPTS(fragPrevious, fragments, bufferEnd, lookupTolerance);
    } else {
      // reach end of playlist
      frag = fragments[fragments.length - 1];
    }
    if (frag) {
      const curSNIdx = frag.sn - levelDetails.startSN;
      // Move fragPrevious forward to support forcing the next fragment to load
      // when the buffer catches up to a previously buffered range.
      const fragState = this.fragmentTracker.getState(frag);
      if (fragState === FragmentState.OK || fragState === FragmentState.PARTIAL && frag.gap) {
        fragPrevious = frag;
      }
      if (fragPrevious && frag.sn === fragPrevious.sn && (!loadingParts || partList[0].fragment.sn > frag.sn)) {
        // Force the next fragment to load if the previous one was already selected. This can occasionally happen with
        // non-uniform fragment durations
        const sameLevel = fragPrevious && frag.level === fragPrevious.level;
        if (sameLevel) {
          const nextFrag = fragments[curSNIdx + 1];
          if (frag.sn < endSN && this.fragmentTracker.getState(nextFrag) !== FragmentState.OK) {
            frag = nextFrag;
          } else {
            frag = null;
          }
        }
      }
    }
    return frag;
  }
  synchronizeToLiveEdge(levelDetails) {
    const {
      config,
      media
    } = this;
    if (!media) {
      return;
    }
    const liveSyncPosition = this.hls.liveSyncPosition;
    const currentTime = media.currentTime;
    const start = levelDetails.fragments[0].start;
    const end = levelDetails.edge;
    const withinSlidingWindow = currentTime >= start - config.maxFragLookUpTolerance && currentTime <= end;
    // Continue if we can seek forward to sync position or if current time is outside of sliding window
    if (liveSyncPosition !== null && media.duration > liveSyncPosition && (currentTime < liveSyncPosition || !withinSlidingWindow)) {
      // Continue if buffer is starving or if current time is behind max latency
      const maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
      if (!withinSlidingWindow && media.readyState < 4 || currentTime < end - maxLatency) {
        if (!this.loadedmetadata) {
          this.nextLoadPosition = liveSyncPosition;
        }
        // Only seek if ready and there is not a significant forward buffer available for playback
        if (media.readyState) {
          this.warn(`Playback: ${currentTime.toFixed(3)} is located too far from the end of live sliding playlist: ${end}, reset currentTime to : ${liveSyncPosition.toFixed(3)}`);
          media.currentTime = liveSyncPosition;
        }
      }
    }
  }
  alignPlaylists(details, previousDetails) {
    const {
      levels,
      levelLastLoaded,
      fragPrevious
    } = this;
    const lastLevel = levelLastLoaded !== null ? levels[levelLastLoaded] : null;

    // FIXME: If not for `shouldAlignOnDiscontinuities` requiring fragPrevious.cc,
    //  this could all go in level-helper mergeDetails()
    const length = details.fragments.length;
    if (!length) {
      this.warn(`No fragments in live playlist`);
      return 0;
    }
    const slidingStart = details.fragments[0].start;
    const firstLevelLoad = !previousDetails;
    const aligned = details.alignedSliding && isFiniteNumber(slidingStart);
    if (firstLevelLoad || !aligned && !slidingStart) {
      alignStream(fragPrevious, lastLevel, details);
      const alignedSlidingStart = details.fragments[0].start;
      this.log(`Live playlist sliding: ${alignedSlidingStart.toFixed(2)} start-sn: ${previousDetails ? previousDetails.startSN : 'na'}->${details.startSN} prev-sn: ${fragPrevious ? fragPrevious.sn : 'na'} fragments: ${length}`);
      return alignedSlidingStart;
    }
    return slidingStart;
  }
  waitForCdnTuneIn(details) {
    // Wait for Low-Latency CDN Tune-in to get an updated playlist
    const advancePartLimit = 3;
    return details.live && details.canBlockReload && details.partTarget && details.tuneInGoal > Math.max(details.partHoldBack, details.partTarget * advancePartLimit);
  }
  setStartPosition(details, sliding) {
    // compute start position if set to -1. use it straight away if value is defined
    let startPosition = this.startPosition;
    if (startPosition < sliding) {
      startPosition = -1;
    }
    if (startPosition === -1 || this.lastCurrentTime === -1) {
      // Use Playlist EXT-X-START:TIME-OFFSET when set
      // Prioritize Multivariant Playlist offset so that main, audio, and subtitle stream-controller start times match
      const offsetInMultivariantPlaylist = this.startTimeOffset !== null;
      const startTimeOffset = offsetInMultivariantPlaylist ? this.startTimeOffset : details.startTimeOffset;
      if (startTimeOffset !== null && isFiniteNumber(startTimeOffset)) {
        startPosition = sliding + startTimeOffset;
        if (startTimeOffset < 0) {
          startPosition += details.totalduration;
        }
        startPosition = Math.min(Math.max(sliding, startPosition), sliding + details.totalduration);
        this.log(`Start time offset ${startTimeOffset} found in ${offsetInMultivariantPlaylist ? 'multivariant' : 'media'} playlist, adjust startPosition to ${startPosition}`);
        this.startPosition = startPosition;
      } else if (details.live) {
        // Leave this.startPosition at -1, so that we can use `getInitialLiveFragment` logic when startPosition has
        // not been specified via the config or an as an argument to startLoad (#3736).
        startPosition = this.hls.liveSyncPosition || sliding;
      } else {
        this.startPosition = startPosition = 0;
      }
      this.lastCurrentTime = startPosition;
    }
    this.nextLoadPosition = startPosition;
  }
  getLoadPosition() {
    const {
      media
    } = this;
    // if we have not yet loaded any fragment, start loading from start position
    let pos = 0;
    if (this.loadedmetadata && media) {
      pos = media.currentTime;
    } else if (this.nextLoadPosition) {
      pos = this.nextLoadPosition;
    }
    return pos;
  }
  handleFragLoadAborted(frag, part) {
    if (this.transmuxer && frag.sn !== 'initSegment' && frag.stats.aborted) {
      this.warn(`Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of level ${frag.level} was aborted`);
      this.resetFragmentLoading(frag);
    }
  }
  resetFragmentLoading(frag) {
    if (!this.fragCurrent || !this.fragContextChanged(frag) && this.state !== State.FRAG_LOADING_WAITING_RETRY) {
      this.state = State.IDLE;
    }
  }
  onFragmentOrKeyLoadError(filterType, data) {
    if (data.chunkMeta && !data.frag) {
      const context = this.getCurrentContext(data.chunkMeta);
      if (context) {
        data.frag = context.frag;
      }
    }
    const frag = data.frag;
    // Handle frag error related to caller's filterType
    if (!frag || frag.type !== filterType || !this.levels) {
      return;
    }
    if (this.fragContextChanged(frag)) {
      var _this$fragCurrent2;
      this.warn(`Frag load error must match current frag to retry ${frag.url} > ${(_this$fragCurrent2 = this.fragCurrent) == null ? void 0 : _this$fragCurrent2.url}`);
      return;
    }
    const gapTagEncountered = data.details === ErrorDetails.FRAG_GAP;
    if (gapTagEncountered) {
      this.fragmentTracker.fragBuffered(frag, true);
    }
    // keep retrying until the limit will be reached
    const errorAction = data.errorAction;
    const {
      action,
      retryCount = 0,
      retryConfig
    } = errorAction || {};
    if (errorAction && action === NetworkErrorAction.RetryRequest && retryConfig) {
      var _this$levelLastLoaded;
      this.resetStartWhenNotLoaded((_this$levelLastLoaded = this.levelLastLoaded) != null ? _this$levelLastLoaded : frag.level);
      const delay = getRetryDelay(retryConfig, retryCount);
      this.warn(`Fragment ${frag.sn} of ${filterType} ${frag.level} errored with ${data.details}, retrying loading ${retryCount + 1}/${retryConfig.maxNumRetry} in ${delay}ms`);
      errorAction.resolved = true;
      this.retryDate = self.performance.now() + delay;
      this.state = State.FRAG_LOADING_WAITING_RETRY;
    } else if (retryConfig && errorAction) {
      this.resetFragmentErrors(filterType);
      if (retryCount < retryConfig.maxNumRetry) {
        // Network retry is skipped when level switch is preferred
        if (!gapTagEncountered) {
          errorAction.resolved = true;
        }
      } else {
        logger.warn(`${data.details} reached or exceeded max retry (${retryCount})`);
      }
    } else if ((errorAction == null ? void 0 : errorAction.action) === NetworkErrorAction.SendAlternateToPenaltyBox) {
      this.state = State.WAITING_LEVEL;
    } else {
      this.state = State.ERROR;
    }
    // Perform next async tick sooner to speed up error action resolution
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(data) {
    // if in appending state
    if (this.state === State.PARSING || this.state === State.PARSED) {
      const playlistType = data.parent;
      const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
      // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
      // reduce max buf len if current position is buffered
      const buffered = bufferedInfo && bufferedInfo.len > 0.5;
      if (buffered) {
        this.reduceMaxBufferLength(bufferedInfo.len);
      }
      const flushBuffer = !buffered;
      if (flushBuffer) {
        // current position is not buffered, but browser is still complaining about buffer full error
        // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
        // in that case flush the whole audio buffer to recover
        this.warn(`Buffer full error while media.currentTime is not buffered, flush ${playlistType} buffer`);
      }
      if (data.frag) {
        this.fragmentTracker.removeFragment(data.frag);
        this.nextLoadPosition = data.frag.start;
      }
      this.resetLoadingState();
      return flushBuffer;
    }
    return false;
  }
  resetFragmentErrors(filterType) {
    if (filterType === PlaylistLevelType.AUDIO) {
      // Reset current fragment since audio track audio is essential and may not have a fail-over track
      this.fragCurrent = null;
    }
    // Fragment errors that result in a level switch or redundant fail-over
    // should reset the stream controller state to idle
    if (!this.loadedmetadata) {
      this.startFragRequested = false;
    }
    if (this.state !== State.STOPPED) {
      this.state = State.IDLE;
    }
  }
  afterBufferFlushed(media, bufferType, playlistType) {
    if (!media) {
      return;
    }
    // After successful buffer flushing, filter flushed fragments from bufferedFrags use mediaBuffered instead of media
    // (so that we will check against video.buffered ranges in case of alt audio track)
    const bufferedTimeRanges = BufferHelper.getBuffered(media);
    this.fragmentTracker.detectEvictedFragments(bufferType, bufferedTimeRanges, playlistType);
    if (this.state === State.ENDED) {
      this.resetLoadingState();
    }
  }
  resetLoadingState() {
    this.log('Reset loading state');
    this.fragCurrent = null;
    this.fragPrevious = null;
    this.state = State.IDLE;
  }
  resetStartWhenNotLoaded(level) {
    // if loadedmetadata is not set, it means that first frag request failed
    // in that case, reset startFragRequested flag
    if (!this.loadedmetadata) {
      this.startFragRequested = false;
      const details = this.levels ? this.levels[level].details : null;
      if (details != null && details.live) {
        // Update the start position and return to IDLE to recover live start
        this.startPosition = -1;
        this.setStartPosition(details, 0);
        this.resetLoadingState();
      } else {
        this.nextLoadPosition = this.startPosition;
      }
    }
  }
  resetWhenMissingContext(chunkMeta) {
    var _this$levelLastLoaded2;
    this.warn(`The loading context changed while buffering fragment ${chunkMeta.sn} of level ${chunkMeta.level}. This chunk will not be buffered.`);
    this.removeUnbufferedFrags();
    this.resetStartWhenNotLoaded((_this$levelLastLoaded2 = this.levelLastLoaded) != null ? _this$levelLastLoaded2 : chunkMeta.level);
    this.resetLoadingState();
  }
  removeUnbufferedFrags(start = 0) {
    this.fragmentTracker.removeFragmentsInRange(start, Infinity, this.playlistType, false, true);
  }
  updateLevelTiming(frag, part, level, partial) {
    var _this$transmuxer;
    const details = level.details;
    if (!details) {
      this.warn('level.details undefined');
      return;
    }
    const parsed = Object.keys(frag.elementaryStreams).reduce((result, type) => {
      const info = frag.elementaryStreams[type];
      if (info) {
        const parsedDuration = info.endPTS - info.startPTS;
        if (parsedDuration <= 0) {
          // Destroy the transmuxer after it's next time offset failed to advance because duration was <= 0.
          // The new transmuxer will be configured with a time offset matching the next fragment start,
          // preventing the timeline from shifting.
          this.warn(`Could not parse fragment ${frag.sn} ${type} duration reliably (${parsedDuration})`);
          return result || false;
        }
        const drift = partial ? 0 : updateFragPTSDTS(details, frag, info.startPTS, info.endPTS, info.startDTS, info.endDTS);
        this.hls.trigger(Events.LEVEL_PTS_UPDATED, {
          details,
          level,
          drift,
          type,
          frag,
          start: info.startPTS,
          end: info.endPTS
        });
        return true;
      }
      return result;
    }, false);
    if (parsed) {
      level.fragmentError = 0;
    } else if (((_this$transmuxer = this.transmuxer) == null ? void 0 : _this$transmuxer.error) === null) {
      const error = new Error(`Found no media in fragment ${frag.sn} of level ${frag.level} resetting transmuxer to fallback to playlist timing`);
      if (level.fragmentError === 0) {
        // Mark and track the odd empty segment as a gap to avoid reloading
        level.fragmentError++;
        frag.gap = true;
        this.fragmentTracker.removeFragment(frag);
        this.fragmentTracker.fragBuffered(frag, true);
      }
      this.warn(error.message);
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.FRAG_PARSING_ERROR,
        fatal: false,
        error,
        frag,
        reason: `Found no media in msn ${frag.sn} of level "${level.url}"`
      });
      if (!this.hls) {
        return;
      }
      this.resetTransmuxer();
      // For this error fallthrough. Marking parsed will allow advancing to next fragment.
    }

    this.state = State.PARSED;
    this.hls.trigger(Events.FRAG_PARSED, {
      frag,
      part
    });
  }
  resetTransmuxer() {
    if (this.transmuxer) {
      this.transmuxer.destroy();
      this.transmuxer = null;
    }
  }
  recoverWorkerError(data) {
    if (data.event === 'demuxerWorker') {
      var _ref, _this$levelLastLoaded3, _this$fragCurrent3;
      this.fragmentTracker.removeAllFragments();
      this.resetTransmuxer();
      this.resetStartWhenNotLoaded((_ref = (_this$levelLastLoaded3 = this.levelLastLoaded) != null ? _this$levelLastLoaded3 : (_this$fragCurrent3 = this.fragCurrent) == null ? void 0 : _this$fragCurrent3.level) != null ? _ref : 0);
      this.resetLoadingState();
    }
  }
  set state(nextState) {
    const previousState = this._state;
    if (previousState !== nextState) {
      this._state = nextState;
      this.log(`${previousState}->${nextState}`);
    }
  }
  get state() {
    return this._state;
  }
}

function getSourceBuffer() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}

/**
 * @ignore
 */
function isSupported() {
  const mediaSource = getMediaSource();
  if (!mediaSource) {
    return false;
  }
  const sourceBuffer = getSourceBuffer();
  const isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');

  // if SourceBuffer is exposed ensure its API is valid
  // Older browsers do not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
  const sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
  return !!isTypeSupported && !!sourceBufferValidAPI;
}

/**
 * @ignore
 */
function changeTypeSupported() {
  var _sourceBuffer$prototy;
  const sourceBuffer = getSourceBuffer();
  return typeof (sourceBuffer == null ? void 0 : (_sourceBuffer$prototy = sourceBuffer.prototype) == null ? void 0 : _sourceBuffer$prototy.changeType) === 'function';
}

// ensure the worker ends up in the bundle
// If the worker should not be included this gets aliased to empty.js
function hasUMDWorker() {
  return typeof __HLS_WORKER_BUNDLE__ === 'function';
}
function injectWorker() {
  const blob = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: 'text/javascript'
  });
  const objectURL = self.URL.createObjectURL(blob);
  const worker = new self.Worker(objectURL);
  return {
    worker,
    objectURL
  };
}
function loadWorker(path) {
  const scriptURL = new self.URL(path, self.location.href).href;
  const worker = new self.Worker(scriptURL);
  return {
    worker,
    scriptURL
  };
}

function dummyTrack(type = '', inputTimeScale = 90000) {
  return {
    type,
    id: -1,
    pid: -1,
    inputTimeScale,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}

class BaseAudioDemuxer {
  constructor() {
    this._audioTrack = void 0;
    this._id3Track = void 0;
    this.frameIndex = 0;
    this.cachedData = null;
    this.basePTS = null;
    this.initPTS = null;
    this.lastPTS = null;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    this._id3Track = {
      type: 'id3',
      id: 3,
      pid: -1,
      inputTimeScale: 90000,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(deaultTimestamp) {
    this.initPTS = deaultTimestamp;
    this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null;
    this.lastPTS = null;
    this.frameIndex = 0;
  }
  canParse(data, offset) {
    return false;
  }
  appendFrame(track, data, offset) {}

  // feed incoming data to the front of the parsing pipeline
  demux(data, timeOffset) {
    if (this.cachedData) {
      data = appendUint8Array(this.cachedData, data);
      this.cachedData = null;
    }
    let id3Data = getID3Data(data, 0);
    let offset = id3Data ? id3Data.length : 0;
    let lastDataIndex;
    const track = this._audioTrack;
    const id3Track = this._id3Track;
    const timestamp = id3Data ? getTimeStamp(id3Data) : undefined;
    const length = data.length;
    if (this.basePTS === null || this.frameIndex === 0 && isFiniteNumber(timestamp)) {
      this.basePTS = initPTSFn(timestamp, timeOffset, this.initPTS);
      this.lastPTS = this.basePTS;
    }
    if (this.lastPTS === null) {
      this.lastPTS = this.basePTS;
    }

    // more expressive than alternative: id3Data?.length
    if (id3Data && id3Data.length > 0) {
      id3Track.samples.push({
        pts: this.lastPTS,
        dts: this.lastPTS,
        data: id3Data,
        type: MetadataSchema.audioId3,
        duration: Number.POSITIVE_INFINITY
      });
    }
    while (offset < length) {
      if (this.canParse(data, offset)) {
        const frame = this.appendFrame(track, data, offset);
        if (frame) {
          this.frameIndex++;
          this.lastPTS = frame.sample.pts;
          offset += frame.length;
          lastDataIndex = offset;
        } else {
          offset = length;
        }
      } else if (canParse$2(data, offset)) {
        // after a ID3.canParse, a call to ID3.getID3Data *should* always returns some data
        id3Data = getID3Data(data, offset);
        id3Track.samples.push({
          pts: this.lastPTS,
          dts: this.lastPTS,
          data: id3Data,
          type: MetadataSchema.audioId3,
          duration: Number.POSITIVE_INFINITY
        });
        offset += id3Data.length;
        lastDataIndex = offset;
      } else {
        offset++;
      }
      if (offset === length && lastDataIndex !== length) {
        const partialData = sliceUint8(data, lastDataIndex);
        if (this.cachedData) {
          this.cachedData = appendUint8Array(this.cachedData, partialData);
        } else {
          this.cachedData = partialData;
        }
      }
    }
    return {
      audioTrack: track,
      videoTrack: dummyTrack(),
      id3Track,
      textTrack: dummyTrack()
    };
  }
  demuxSampleAes(data, keyData, timeOffset) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(timeOffset) {
    // Parse cache in case of remaining frames.
    const cachedData = this.cachedData;
    if (cachedData) {
      this.cachedData = null;
      this.demux(cachedData, 0);
    }
    return {
      audioTrack: this._audioTrack,
      videoTrack: dummyTrack(),
      id3Track: this._id3Track,
      textTrack: dummyTrack()
    };
  }
  destroy() {}
}

/**
 * Initialize PTS
 * <p>
 *    use timestamp unless it is undefined, NaN or Infinity
 * </p>
 */
const initPTSFn = (timestamp, timeOffset, initPTS) => {
  if (isFiniteNumber(timestamp)) {
    return timestamp * 90;
  }
  const init90kHz = initPTS ? initPTS.baseTime * 90000 / initPTS.timescale : 0;
  return timeOffset * 90000 + init90kHz;
};

/**
 * ADTS parser helper
 * @link https://wiki.multimedia.cx/index.php?title=ADTS
 */
function getAudioConfig(observer, data, offset, audioCodec) {
  let adtsObjectType;
  let adtsExtensionSamplingIndex;
  let adtsChannelConfig;
  let config;
  const userAgent = navigator.userAgent.toLowerCase();
  const manifestCodec = audioCodec;
  const adtsSamplingRates = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
  // byte 2
  adtsObjectType = ((data[offset + 2] & 0xc0) >>> 6) + 1;
  const adtsSamplingIndex = (data[offset + 2] & 0x3c) >>> 2;
  if (adtsSamplingIndex > adtsSamplingRates.length - 1) {
    observer.trigger(Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.FRAG_PARSING_ERROR,
      fatal: true,
      reason: `invalid ADTS sampling index:${adtsSamplingIndex}`
    });
    return;
  }
  adtsChannelConfig = (data[offset + 2] & 0x01) << 2;
  // byte 3
  adtsChannelConfig |= (data[offset + 3] & 0xc0) >>> 6;
  logger.log(`manifest codec:${audioCodec}, ADTS type:${adtsObjectType}, samplingIndex:${adtsSamplingIndex}`);
  // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
  if (/firefox/i.test(userAgent)) {
    if (adtsSamplingIndex >= 6) {
      adtsObjectType = 5;
      config = new Array(4);
      // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
      // there is a factor 2 between frame sample rate and output sample rate
      // multiply frequency by 2 (see table below, equivalent to substract 3)
      adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
    } else {
      adtsObjectType = 2;
      config = new Array(2);
      adtsExtensionSamplingIndex = adtsSamplingIndex;
    }
    // Android : always use AAC
  } else if (userAgent.indexOf('android') !== -1) {
    adtsObjectType = 2;
    config = new Array(2);
    adtsExtensionSamplingIndex = adtsSamplingIndex;
  } else {
    /*  for other browsers (Chrome/Vivaldi/Opera ...)
        always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
    */
    adtsObjectType = 5;
    config = new Array(4);
    // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
    if (audioCodec && (audioCodec.indexOf('mp4a.40.29') !== -1 || audioCodec.indexOf('mp4a.40.5') !== -1) || !audioCodec && adtsSamplingIndex >= 6) {
      // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
      // there is a factor 2 between frame sample rate and output sample rate
      // multiply frequency by 2 (see table below, equivalent to substract 3)
      adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
    } else {
      // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
      // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
      if (audioCodec && audioCodec.indexOf('mp4a.40.2') !== -1 && (adtsSamplingIndex >= 6 && adtsChannelConfig === 1 || /vivaldi/i.test(userAgent)) || !audioCodec && adtsChannelConfig === 1) {
        adtsObjectType = 2;
        config = new Array(2);
      }
      adtsExtensionSamplingIndex = adtsSamplingIndex;
    }
  }
  /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
      ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
    Audio Profile / Audio Object Type
    0: Null
    1: AAC Main
    2: AAC LC (Low Complexity)
    3: AAC SSR (Scalable Sample Rate)
    4: AAC LTP (Long Term Prediction)
    5: SBR (Spectral Band Replication)
    6: AAC Scalable
   sampling freq
    0: 96000 Hz
    1: 88200 Hz
    2: 64000 Hz
    3: 48000 Hz
    4: 44100 Hz
    5: 32000 Hz
    6: 24000 Hz
    7: 22050 Hz
    8: 16000 Hz
    9: 12000 Hz
    10: 11025 Hz
    11: 8000 Hz
    12: 7350 Hz
    13: Reserved
    14: Reserved
    15: frequency is written explictly
    Channel Configurations
    These are the channel configurations:
    0: Defined in AOT Specifc Config
    1: 1 channel: front-center
    2: 2 channels: front-left, front-right
  */
  // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
  config[0] = adtsObjectType << 3;
  // samplingFrequencyIndex
  config[0] |= (adtsSamplingIndex & 0x0e) >> 1;
  config[1] |= (adtsSamplingIndex & 0x01) << 7;
  // channelConfiguration
  config[1] |= adtsChannelConfig << 3;
  if (adtsObjectType === 5) {
    // adtsExtensionSamplingIndex
    config[1] |= (adtsExtensionSamplingIndex & 0x0e) >> 1;
    config[2] = (adtsExtensionSamplingIndex & 0x01) << 7;
    // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
    //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
    config[2] |= 2 << 2;
    config[3] = 0;
  }
  return {
    config,
    samplerate: adtsSamplingRates[adtsSamplingIndex],
    channelCount: adtsChannelConfig,
    codec: 'mp4a.40.' + adtsObjectType,
    manifestCodec
  };
}
function isHeaderPattern$1(data, offset) {
  return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
}
function getHeaderLength(data, offset) {
  return data[offset + 1] & 0x01 ? 7 : 9;
}
function getFullFrameLength(data, offset) {
  return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xe0) >>> 5;
}
function canGetFrameLength(data, offset) {
  return offset + 5 < data.length;
}
function isHeader$1(data, offset) {
  // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
  // Layer bits (position 14 and 15) in header should be always 0 for ADTS
  // More info https://wiki.multimedia.cx/index.php?title=ADTS
  return offset + 1 < data.length && isHeaderPattern$1(data, offset);
}
function canParse$1(data, offset) {
  return canGetFrameLength(data, offset) && isHeaderPattern$1(data, offset) && getFullFrameLength(data, offset) <= data.length - offset;
}
function probe$1(data, offset) {
  // same as isHeader but we also check that ADTS frame follows last ADTS frame
  // or end of data is reached
  if (isHeader$1(data, offset)) {
    // ADTS header Length
    const headerLength = getHeaderLength(data, offset);
    if (offset + headerLength >= data.length) {
      return false;
    }
    // ADTS frame Length
    const frameLength = getFullFrameLength(data, offset);
    if (frameLength <= headerLength) {
      return false;
    }
    const newOffset = offset + frameLength;
    return newOffset === data.length || isHeader$1(data, newOffset);
  }
  return false;
}
function initTrackConfig(track, observer, data, offset, audioCodec) {
  if (!track.samplerate) {
    const config = getAudioConfig(observer, data, offset, audioCodec);
    if (!config) {
      return;
    }
    track.config = config.config;
    track.samplerate = config.samplerate;
    track.channelCount = config.channelCount;
    track.codec = config.codec;
    track.manifestCodec = config.manifestCodec;
    logger.log(`parsed codec:${track.codec}, rate:${config.samplerate}, channels:${config.channelCount}`);
  }
}
function getFrameDuration(samplerate) {
  return 1024 * 90000 / samplerate;
}
function parseFrameHeader(data, offset) {
  // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
  const headerLength = getHeaderLength(data, offset);
  if (offset + headerLength <= data.length) {
    // retrieve frame size
    const frameLength = getFullFrameLength(data, offset) - headerLength;
    if (frameLength > 0) {
      // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}`);
      return {
        headerLength,
        frameLength
      };
    }
  }
}
function appendFrame$1(track, data, offset, pts, frameIndex) {
  const frameDuration = getFrameDuration(track.samplerate);
  const stamp = pts + frameIndex * frameDuration;
  const header = parseFrameHeader(data, offset);
  let unit;
  if (header) {
    const {
      frameLength,
      headerLength
    } = header;
    const _length = headerLength + frameLength;
    const missing = Math.max(0, offset + _length - data.length);
    // logger.log(`AAC frame ${frameIndex}, pts:${stamp} length@offset/total: ${frameLength}@${offset+headerLength}/${data.byteLength} missing: ${missing}`);
    if (missing) {
      unit = new Uint8Array(_length - headerLength);
      unit.set(data.subarray(offset + headerLength, data.length), 0);
    } else {
      unit = data.subarray(offset + headerLength, offset + _length);
    }
    const _sample = {
      unit,
      pts: stamp
    };
    if (!missing) {
      track.samples.push(_sample);
    }
    return {
      sample: _sample,
      length: _length,
      missing
    };
  }
  // overflow incomplete header
  const length = data.length - offset;
  unit = new Uint8Array(length);
  unit.set(data.subarray(offset, data.length), 0);
  const sample = {
    unit,
    pts: stamp
  };
  return {
    sample,
    length,
    missing: -1
  };
}

/**
 * AAC demuxer
 */
class AACDemuxer extends BaseAudioDemuxer {
  constructor(observer, config) {
    super();
    this.observer = void 0;
    this.config = void 0;
    this.observer = observer;
    this.config = config;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
    this._audioTrack = {
      container: 'audio/adts',
      type: 'audio',
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: 'aac',
      samples: [],
      manifestCodec: audioCodec,
      duration: trackDuration,
      inputTimeScale: 90000,
      dropped: 0
    };
  }

  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(data) {
    if (!data) {
      return false;
    }

    // Check for the ADTS sync word
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    const id3Data = getID3Data(data, 0) || [];
    let offset = id3Data.length;
    for (let length = data.length; offset < length; offset++) {
      if (probe$1(data, offset)) {
        logger.log('ADTS sync word found !');
        return true;
      }
    }
    return false;
  }
  canParse(data, offset) {
    return canParse$1(data, offset);
  }
  appendFrame(track, data, offset) {
    initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
    const frame = appendFrame$1(track, data, offset, this.basePTS, this.frameIndex);
    if (frame && frame.missing === 0) {
      return frame;
    }
  }
}

const emsgSchemePattern = /\/emsg[-/]ID3/i;
class MP4Demuxer {
  constructor(observer, config) {
    this.remainderData = null;
    this.timeOffset = 0;
    this.config = void 0;
    this.videoTrack = void 0;
    this.audioTrack = void 0;
    this.id3Track = void 0;
    this.txtTrack = void 0;
    this.config = config;
  }
  resetTimeStamp() {}
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    const videoTrack = this.videoTrack = dummyTrack('video', 1);
    const audioTrack = this.audioTrack = dummyTrack('audio', 1);
    const captionTrack = this.txtTrack = dummyTrack('text', 1);
    this.id3Track = dummyTrack('id3', 1);
    this.timeOffset = 0;
    if (!(initSegment != null && initSegment.byteLength)) {
      return;
    }
    const initData = parseInitSegment(initSegment);
    if (initData.video) {
      const {
        id,
        timescale,
        codec
      } = initData.video;
      videoTrack.id = id;
      videoTrack.timescale = captionTrack.timescale = timescale;
      videoTrack.codec = codec;
    }
    if (initData.audio) {
      const {
        id,
        timescale,
        codec
      } = initData.audio;
      audioTrack.id = id;
      audioTrack.timescale = timescale;
      audioTrack.codec = codec;
    }
    captionTrack.id = RemuxerTrackIdConfig.text;
    videoTrack.sampleDuration = 0;
    videoTrack.duration = audioTrack.duration = trackDuration;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(data) {
    // ensure we find a moof box in the first 16 kB
    data = data.length > 16384 ? data.subarray(0, 16384) : data;
    return findBox(data, ['moof']).length > 0;
  }
  demux(data, timeOffset) {
    this.timeOffset = timeOffset;
    // Load all data into the avc track. The CMAF remuxer will look for the data in the samples object; the rest of the fields do not matter
    let videoSamples = data;
    const videoTrack = this.videoTrack;
    const textTrack = this.txtTrack;
    if (this.config.progressive) {
      // Split the bytestream into two ranges: one encompassing all data up until the start of the last moof, and everything else.
      // This is done to guarantee that we're sending valid data to MSE - when demuxing progressively, we have no guarantee
      // that the fetch loader gives us flush moof+mdat pairs. If we push jagged data to MSE, it will throw an exception.
      if (this.remainderData) {
        videoSamples = appendUint8Array(this.remainderData, data);
      }
      const segmentedData = segmentValidRange(videoSamples);
      this.remainderData = segmentedData.remainder;
      videoTrack.samples = segmentedData.valid || new Uint8Array();
    } else {
      videoTrack.samples = videoSamples;
    }
    const id3Track = this.extractID3Track(videoTrack, timeOffset);
    textTrack.samples = parseSamples(timeOffset, videoTrack);
    return {
      videoTrack,
      audioTrack: this.audioTrack,
      id3Track,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const timeOffset = this.timeOffset;
    const videoTrack = this.videoTrack;
    const textTrack = this.txtTrack;
    videoTrack.samples = this.remainderData || new Uint8Array();
    this.remainderData = null;
    const id3Track = this.extractID3Track(videoTrack, this.timeOffset);
    textTrack.samples = parseSamples(timeOffset, videoTrack);
    return {
      videoTrack,
      audioTrack: dummyTrack(),
      id3Track,
      textTrack: dummyTrack()
    };
  }
  extractID3Track(videoTrack, timeOffset) {
    const id3Track = this.id3Track;
    if (videoTrack.samples.length) {
      const emsgs = findBox(videoTrack.samples, ['emsg']);
      if (emsgs) {
        emsgs.forEach(data => {
          const emsgInfo = parseEmsg(data);
          if (emsgSchemePattern.test(emsgInfo.schemeIdUri)) {
            const pts = isFiniteNumber(emsgInfo.presentationTime) ? emsgInfo.presentationTime / emsgInfo.timeScale : timeOffset + emsgInfo.presentationTimeDelta / emsgInfo.timeScale;
            let duration = emsgInfo.eventDuration === 0xffffffff ? Number.POSITIVE_INFINITY : emsgInfo.eventDuration / emsgInfo.timeScale;
            // Safari takes anything <= 0.001 seconds and maps it to Infinity
            if (duration <= 0.001) {
              duration = Number.POSITIVE_INFINITY;
            }
            const payload = emsgInfo.payload;
            id3Track.samples.push({
              data: payload,
              len: payload.byteLength,
              dts: pts,
              pts: pts,
              type: MetadataSchema.emsg,
              duration: duration
            });
          }
        });
      }
    }
    return id3Track;
  }
  demuxSampleAes(data, keyData, timeOffset) {
    return Promise.reject(new Error('The MP4 demuxer does not support SAMPLE-AES decryption'));
  }
  destroy() {}
}

/**
 *  MPEG parser helper
 */

let chromeVersion$1 = null;
const BitratesMap = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160];
const SamplingRateMap = [44100, 48000, 32000, 22050, 24000, 16000, 11025, 12000, 8000];
const SamplesCoefficients = [
// MPEG 2.5
[0,
// Reserved
72,
// Layer3
144,
// Layer2
12 // Layer1
],
// Reserved
[0,
// Reserved
0,
// Layer3
0,
// Layer2
0 // Layer1
],
// MPEG 2
[0,
// Reserved
72,
// Layer3
144,
// Layer2
12 // Layer1
],
// MPEG 1
[0,
// Reserved
144,
// Layer3
144,
// Layer2
12 // Layer1
]];

const BytesInSlot = [0,
// Reserved
1,
// Layer3
1,
// Layer2
4 // Layer1
];

function appendFrame(track, data, offset, pts, frameIndex) {
  // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
  if (offset + 24 > data.length) {
    return;
  }
  const header = parseHeader(data, offset);
  if (header && offset + header.frameLength <= data.length) {
    const frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
    const stamp = pts + frameIndex * frameDuration;
    const sample = {
      unit: data.subarray(offset, offset + header.frameLength),
      pts: stamp,
      dts: stamp
    };
    track.config = [];
    track.channelCount = header.channelCount;
    track.samplerate = header.sampleRate;
    track.samples.push(sample);
    return {
      sample,
      length: header.frameLength,
      missing: 0
    };
  }
}
function parseHeader(data, offset) {
  const mpegVersion = data[offset + 1] >> 3 & 3;
  const mpegLayer = data[offset + 1] >> 1 & 3;
  const bitRateIndex = data[offset + 2] >> 4 & 15;
  const sampleRateIndex = data[offset + 2] >> 2 & 3;
  if (mpegVersion !== 1 && bitRateIndex !== 0 && bitRateIndex !== 15 && sampleRateIndex !== 3) {
    const paddingBit = data[offset + 2] >> 1 & 1;
    const channelMode = data[offset + 3] >> 6;
    const columnInBitrates = mpegVersion === 3 ? 3 - mpegLayer : mpegLayer === 3 ? 3 : 4;
    const bitRate = BitratesMap[columnInBitrates * 14 + bitRateIndex - 1] * 1000;
    const columnInSampleRates = mpegVersion === 3 ? 0 : mpegVersion === 2 ? 1 : 2;
    const sampleRate = SamplingRateMap[columnInSampleRates * 3 + sampleRateIndex];
    const channelCount = channelMode === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
    const sampleCoefficient = SamplesCoefficients[mpegVersion][mpegLayer];
    const bytesInSlot = BytesInSlot[mpegLayer];
    const samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
    const frameLength = Math.floor(sampleCoefficient * bitRate / sampleRate + paddingBit) * bytesInSlot;
    if (chromeVersion$1 === null) {
      const userAgent = navigator.userAgent || '';
      const result = userAgent.match(/Chrome\/(\d+)/i);
      chromeVersion$1 = result ? parseInt(result[1]) : 0;
    }
    const needChromeFix = !!chromeVersion$1 && chromeVersion$1 <= 87;
    if (needChromeFix && mpegLayer === 2 && bitRate >= 224000 && channelMode === 0) {
      // Work around bug in Chromium by setting channelMode to dual-channel (01) instead of stereo (00)
      data[offset + 3] = data[offset + 3] | 0x80;
    }
    return {
      sampleRate,
      channelCount,
      frameLength,
      samplesPerFrame
    };
  }
}
function isHeaderPattern(data, offset) {
  return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
}
function isHeader(data, offset) {
  // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
  // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
  // More info http://www.mp3-tech.org/programmer/frame_header.html
  return offset + 1 < data.length && isHeaderPattern(data, offset);
}
function canParse(data, offset) {
  const headerSize = 4;
  return isHeaderPattern(data, offset) && headerSize <= data.length - offset;
}
function probe(data, offset) {
  // same as isHeader but we also check that MPEG frame follows last MPEG frame
  // or end of data is reached
  if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
    // MPEG header Length
    const headerLength = 4;
    // MPEG frame Length
    const header = parseHeader(data, offset);
    let frameLength = headerLength;
    if (header != null && header.frameLength) {
      frameLength = header.frameLength;
    }
    const newOffset = offset + frameLength;
    return newOffset === data.length || isHeader(data, newOffset);
  }
  return false;
}

/**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
 */

class ExpGolomb {
  constructor(data) {
    this.data = void 0;
    this.bytesAvailable = void 0;
    this.word = void 0;
    this.bitsAvailable = void 0;
    this.data = data;
    // the number of bytes left to examine in this.data
    this.bytesAvailable = data.byteLength;
    // the current word being examined
    this.word = 0; // :uint
    // the number of bits left to examine in the current word
    this.bitsAvailable = 0; // :uint
  }

  // ():void
  loadWord() {
    const data = this.data;
    const bytesAvailable = this.bytesAvailable;
    const position = data.byteLength - bytesAvailable;
    const workingBytes = new Uint8Array(4);
    const availableBytes = Math.min(4, bytesAvailable);
    if (availableBytes === 0) {
      throw new Error('no bytes available');
    }
    workingBytes.set(data.subarray(position, position + availableBytes));
    this.word = new DataView(workingBytes.buffer).getUint32(0);
    // track the amount of this.data that has been processed
    this.bitsAvailable = availableBytes * 8;
    this.bytesAvailable -= availableBytes;
  }

  // (count:int):void
  skipBits(count) {
    let skipBytes; // :int
    count = Math.min(count, this.bytesAvailable * 8 + this.bitsAvailable);
    if (this.bitsAvailable > count) {
      this.word <<= count;
      this.bitsAvailable -= count;
    } else {
      count -= this.bitsAvailable;
      skipBytes = count >> 3;
      count -= skipBytes << 3;
      this.bytesAvailable -= skipBytes;
      this.loadWord();
      this.word <<= count;
      this.bitsAvailable -= count;
    }
  }

  // (size:int):uint
  readBits(size) {
    let bits = Math.min(this.bitsAvailable, size); // :uint
    const valu = this.word >>> 32 - bits; // :uint
    if (size > 32) {
      logger.error('Cannot read more than 32 bits at a time');
    }
    this.bitsAvailable -= bits;
    if (this.bitsAvailable > 0) {
      this.word <<= bits;
    } else if (this.bytesAvailable > 0) {
      this.loadWord();
    } else {
      throw new Error('no bits available');
    }
    bits = size - bits;
    if (bits > 0 && this.bitsAvailable) {
      return valu << bits | this.readBits(bits);
    } else {
      return valu;
    }
  }

  // ():uint
  skipLZ() {
    let leadingZeroCount; // :uint
    for (leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount) {
      if ((this.word & 0x80000000 >>> leadingZeroCount) !== 0) {
        // the first bit of working word is 1
        this.word <<= leadingZeroCount;
        this.bitsAvailable -= leadingZeroCount;
        return leadingZeroCount;
      }
    }
    // we exhausted word and still have not found a 1
    this.loadWord();
    return leadingZeroCount + this.skipLZ();
  }

  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }

  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }

  // ():uint
  readUEG() {
    const clz = this.skipLZ(); // :uint
    return this.readBits(clz + 1) - 1;
  }

  // ():int
  readEG() {
    const valu = this.readUEG(); // :int
    if (0x01 & valu) {
      // the number is odd if the low order bit is set
      return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
    } else {
      return -1 * (valu >>> 1); // divide by two then make it negative
    }
  }

  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }

  // ():int
  readUByte() {
    return this.readBits(8);
  }

  // ():int
  readUShort() {
    return this.readBits(16);
  }

  // ():int
  readUInt() {
    return this.readBits(32);
  }

  /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(count) {
    let lastScale = 8;
    let nextScale = 8;
    let deltaScale;
    for (let j = 0; j < count; j++) {
      if (nextScale !== 0) {
        deltaScale = this.readEG();
        nextScale = (lastScale + deltaScale + 256) % 256;
      }
      lastScale = nextScale === 0 ? lastScale : nextScale;
    }
  }

  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS() {
    let frameCropLeftOffset = 0;
    let frameCropRightOffset = 0;
    let frameCropTopOffset = 0;
    let frameCropBottomOffset = 0;
    let numRefFramesInPicOrderCntCycle;
    let scalingListCount;
    let i;
    const readUByte = this.readUByte.bind(this);
    const readBits = this.readBits.bind(this);
    const readUEG = this.readUEG.bind(this);
    const readBoolean = this.readBoolean.bind(this);
    const skipBits = this.skipBits.bind(this);
    const skipEG = this.skipEG.bind(this);
    const skipUEG = this.skipUEG.bind(this);
    const skipScalingList = this.skipScalingList.bind(this);
    readUByte();
    const profileIdc = readUByte(); // profile_idc
    readBits(5); // profileCompat constraint_set[0-4]_flag, u(5)
    skipBits(3); // reserved_zero_3bits u(3),
    readUByte(); // level_idc u(8)
    skipUEG(); // seq_parameter_set_id
    // some profiles have more optional data we don't need
    if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
      const chromaFormatIdc = readUEG();
      if (chromaFormatIdc === 3) {
        skipBits(1);
      } // separate_colour_plane_flag

      skipUEG(); // bit_depth_luma_minus8
      skipUEG(); // bit_depth_chroma_minus8
      skipBits(1); // qpprime_y_zero_transform_bypass_flag
      if (readBoolean()) {
        // seq_scaling_matrix_present_flag
        scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
        for (i = 0; i < scalingListCount; i++) {
          if (readBoolean()) {
            // seq_scaling_list_present_flag[ i ]
            if (i < 6) {
              skipScalingList(16);
            } else {
              skipScalingList(64);
            }
          }
        }
      }
    }
    skipUEG(); // log2_max_frame_num_minus4
    const picOrderCntType = readUEG();
    if (picOrderCntType === 0) {
      readUEG(); // log2_max_pic_order_cnt_lsb_minus4
    } else if (picOrderCntType === 1) {
      skipBits(1); // delta_pic_order_always_zero_flag
      skipEG(); // offset_for_non_ref_pic
      skipEG(); // offset_for_top_to_bottom_field
      numRefFramesInPicOrderCntCycle = readUEG();
      for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
        skipEG();
      } // offset_for_ref_frame[ i ]
    }

    skipUEG(); // max_num_ref_frames
    skipBits(1); // gaps_in_frame_num_value_allowed_flag
    const picWidthInMbsMinus1 = readUEG();
    const picHeightInMapUnitsMinus1 = readUEG();
    const frameMbsOnlyFlag = readBits(1);
    if (frameMbsOnlyFlag === 0) {
      skipBits(1);
    } // mb_adaptive_frame_field_flag

    skipBits(1); // direct_8x8_inference_flag
    if (readBoolean()) {
      // frame_cropping_flag
      frameCropLeftOffset = readUEG();
      frameCropRightOffset = readUEG();
      frameCropTopOffset = readUEG();
      frameCropBottomOffset = readUEG();
    }
    let pixelRatio = [1, 1];
    if (readBoolean()) {
      // vui_parameters_present_flag
      if (readBoolean()) {
        // aspect_ratio_info_present_flag
        const aspectRatioIdc = readUByte();
        switch (aspectRatioIdc) {
          case 1:
            pixelRatio = [1, 1];
            break;
          case 2:
            pixelRatio = [12, 11];
            break;
          case 3:
            pixelRatio = [10, 11];
            break;
          case 4:
            pixelRatio = [16, 11];
            break;
          case 5:
            pixelRatio = [40, 33];
            break;
          case 6:
            pixelRatio = [24, 11];
            break;
          case 7:
            pixelRatio = [20, 11];
            break;
          case 8:
            pixelRatio = [32, 11];
            break;
          case 9:
            pixelRatio = [80, 33];
            break;
          case 10:
            pixelRatio = [18, 11];
            break;
          case 11:
            pixelRatio = [15, 11];
            break;
          case 12:
            pixelRatio = [64, 33];
            break;
          case 13:
            pixelRatio = [160, 99];
            break;
          case 14:
            pixelRatio = [4, 3];
            break;
          case 15:
            pixelRatio = [3, 2];
            break;
          case 16:
            pixelRatio = [2, 1];
            break;
          case 255:
            {
              pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
              break;
            }
        }
      }
    }
    return {
      width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
      height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
      pixelRatio: pixelRatio
    };
  }
  readSliceType() {
    // skip NALu type
    this.readUByte();
    // discard first_mb_in_slice
    this.readUEG();
    // return slice_type
    return this.readUEG();
  }
}

/**
 * SAMPLE-AES decrypter
 */

class SampleAesDecrypter {
  constructor(observer, config, keyData) {
    this.keyData = void 0;
    this.decrypter = void 0;
    this.keyData = keyData;
    this.decrypter = new Decrypter(config, {
      removePKCS7Padding: false
    });
  }
  decryptBuffer(encryptedData) {
    return this.decrypter.decrypt(encryptedData, this.keyData.key.buffer, this.keyData.iv.buffer);
  }

  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(samples, sampleIndex, callback) {
    const curUnit = samples[sampleIndex].unit;
    if (curUnit.length <= 16) {
      // No encrypted portion in this sample (first 16 bytes is not
      // encrypted, see https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/HLS_Sample_Encryption/Encryption/Encryption.html),
      return;
    }
    const encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
    const encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
    this.decryptBuffer(encryptedBuffer).then(decryptedBuffer => {
      const decryptedData = new Uint8Array(decryptedBuffer);
      curUnit.set(decryptedData, 16);
      if (!this.decrypter.isSync()) {
        this.decryptAacSamples(samples, sampleIndex + 1, callback);
      }
    });
  }
  decryptAacSamples(samples, sampleIndex, callback) {
    for (;; sampleIndex++) {
      if (sampleIndex >= samples.length) {
        callback();
        return;
      }
      if (samples[sampleIndex].unit.length < 32) {
        continue;
      }
      this.decryptAacSample(samples, sampleIndex, callback);
      if (!this.decrypter.isSync()) {
        return;
      }
    }
  }

  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(decodedData) {
    const encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
    const encryptedData = new Int8Array(encryptedDataLen);
    let outputPos = 0;
    for (let inputPos = 32; inputPos < decodedData.length - 16; inputPos += 160, outputPos += 16) {
      encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
    }
    return encryptedData;
  }
  getAvcDecryptedUnit(decodedData, decryptedData) {
    const uint8DecryptedData = new Uint8Array(decryptedData);
    let inputPos = 0;
    for (let outputPos = 32; outputPos < decodedData.length - 16; outputPos += 160, inputPos += 16) {
      decodedData.set(uint8DecryptedData.subarray(inputPos, inputPos + 16), outputPos);
    }
    return decodedData;
  }
  decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit) {
    const decodedData = discardEPB(curUnit.data);
    const encryptedData = this.getAvcEncryptedData(decodedData);
    this.decryptBuffer(encryptedData.buffer).then(decryptedBuffer => {
      curUnit.data = this.getAvcDecryptedUnit(decodedData, decryptedBuffer);
      if (!this.decrypter.isSync()) {
        this.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
      }
    });
  }
  decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
    if (samples instanceof Uint8Array) {
      throw new Error('Cannot decrypt samples of type Uint8Array');
    }
    for (;; sampleIndex++, unitIndex = 0) {
      if (sampleIndex >= samples.length) {
        callback();
        return;
      }
      const curUnits = samples[sampleIndex].units;
      for (;; unitIndex++) {
        if (unitIndex >= curUnits.length) {
          break;
        }
        const curUnit = curUnits[unitIndex];
        if (curUnit.data.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) {
          continue;
        }
        this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit);
        if (!this.decrypter.isSync()) {
          return;
        }
      }
    }
  }
}

const PACKET_LENGTH = 188;
class TSDemuxer {
  constructor(observer, config, typeSupported) {
    this.observer = void 0;
    this.config = void 0;
    this.typeSupported = void 0;
    this.sampleAes = null;
    this.pmtParsed = false;
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this._duration = 0;
    this._pmtId = -1;
    this._avcTrack = void 0;
    this._audioTrack = void 0;
    this._id3Track = void 0;
    this._txtTrack = void 0;
    this.aacOverFlow = null;
    this.avcSample = null;
    this.remainderData = null;
    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
  }
  static probe(data) {
    const syncOffset = TSDemuxer.syncOffset(data);
    if (syncOffset > 0) {
      logger.warn(`MPEG2-TS detected but first sync word found @ offset ${syncOffset}`);
    }
    return syncOffset !== -1;
  }
  static syncOffset(data) {
    const length = data.length;
    let scanwindow = Math.min(PACKET_LENGTH * 5, data.length - PACKET_LENGTH) + 1;
    let i = 0;
    while (i < scanwindow) {
      // a TS init segment should contain at least 2 TS packets: PAT and PMT, each starting with 0x47
      let foundPat = false;
      let packetStart = -1;
      let tsPackets = 0;
      for (let j = i; j < length; j += PACKET_LENGTH) {
        if (data[j] === 0x47) {
          tsPackets++;
          if (packetStart === -1) {
            packetStart = j;
            // First sync word found at offset, increase scan length (#5251)
            if (packetStart !== 0) {
              scanwindow = Math.min(packetStart + PACKET_LENGTH * 99, data.length - PACKET_LENGTH) + 1;
            }
          }
          if (!foundPat) {
            foundPat = parsePID(data, j) === 0;
          }
          // Sync word found at 0 with 3 packets, or found at offset least 2 packets up to scanwindow (#5501)
          if (foundPat && tsPackets > 1 && (packetStart === 0 && tsPackets > 2 || j + PACKET_LENGTH > scanwindow)) {
            return packetStart;
          }
        } else if (tsPackets) {
          // Exit if sync word found, but does not contain contiguous packets (#5501)
          return -1;
        } else {
          break;
        }
      }
      i++;
    }
    return -1;
  }

  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(type, duration) {
    return {
      container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
      type,
      id: RemuxerTrackIdConfig[type],
      pid: -1,
      inputTimeScale: 90000,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: type === 'audio' ? duration : undefined
    };
  }

  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    this.pmtParsed = false;
    this._pmtId = -1;
    this._avcTrack = TSDemuxer.createTrack('video');
    this._audioTrack = TSDemuxer.createTrack('audio', trackDuration);
    this._id3Track = TSDemuxer.createTrack('id3');
    this._txtTrack = TSDemuxer.createTrack('text');
    this._audioTrack.segmentCodec = 'aac';

    // flush any partial content
    this.aacOverFlow = null;
    this.avcSample = null;
    this.remainderData = null;
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
    this._duration = trackDuration;
  }
  resetTimeStamp() {}
  resetContiguity() {
    const {
      _audioTrack,
      _avcTrack,
      _id3Track
    } = this;
    if (_audioTrack) {
      _audioTrack.pesData = null;
    }
    if (_avcTrack) {
      _avcTrack.pesData = null;
    }
    if (_id3Track) {
      _id3Track.pesData = null;
    }
    this.aacOverFlow = null;
    this.avcSample = null;
    this.remainderData = null;
  }
  demux(data, timeOffset, isSampleAes = false, flush = false) {
    if (!isSampleAes) {
      this.sampleAes = null;
    }
    let pes;
    const videoTrack = this._avcTrack;
    const audioTrack = this._audioTrack;
    const id3Track = this._id3Track;
    const textTrack = this._txtTrack;
    let avcId = videoTrack.pid;
    let avcData = videoTrack.pesData;
    let audioId = audioTrack.pid;
    let id3Id = id3Track.pid;
    let audioData = audioTrack.pesData;
    let id3Data = id3Track.pesData;
    let unknownPID = null;
    let pmtParsed = this.pmtParsed;
    let pmtId = this._pmtId;
    let len = data.length;
    if (this.remainderData) {
      data = appendUint8Array(this.remainderData, data);
      len = data.length;
      this.remainderData = null;
    }
    if (len < PACKET_LENGTH && !flush) {
      this.remainderData = data;
      return {
        audioTrack,
        videoTrack,
        id3Track,
        textTrack
      };
    }
    const syncOffset = Math.max(0, TSDemuxer.syncOffset(data));
    len -= (len - syncOffset) % PACKET_LENGTH;
    if (len < data.byteLength && !flush) {
      this.remainderData = new Uint8Array(data.buffer, len, data.buffer.byteLength - len);
    }

    // loop through TS packets
    let tsPacketErrors = 0;
    for (let start = syncOffset; start < len; start += PACKET_LENGTH) {
      if (data[start] === 0x47) {
        const stt = !!(data[start + 1] & 0x40);
        const pid = parsePID(data, start);
        const atf = (data[start + 3] & 0x30) >> 4;

        // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
        let offset;
        if (atf > 1) {
          offset = start + 5 + data[start + 4];
          // continue if there is only adaptation field
          if (offset === start + PACKET_LENGTH) {
            continue;
          }
        } else {
          offset = start + 4;
        }
        switch (pid) {
          case avcId:
            if (stt) {
              if (avcData && (pes = parsePES(avcData))) {
                this.parseAVCPES(videoTrack, textTrack, pes, false);
              }
              avcData = {
                data: [],
                size: 0
              };
            }
            if (avcData) {
              avcData.data.push(data.subarray(offset, start + PACKET_LENGTH));
              avcData.size += start + PACKET_LENGTH - offset;
            }
            break;
          case audioId:
            if (stt) {
              if (audioData && (pes = parsePES(audioData))) {
                switch (audioTrack.segmentCodec) {
                  case 'aac':
                    this.parseAACPES(audioTrack, pes);
                    break;
                  case 'mp3':
                    this.parseMPEGPES(audioTrack, pes);
                    break;
                }
              }
              audioData = {
                data: [],
                size: 0
              };
            }
            if (audioData) {
              audioData.data.push(data.subarray(offset, start + PACKET_LENGTH));
              audioData.size += start + PACKET_LENGTH - offset;
            }
            break;
          case id3Id:
            if (stt) {
              if (id3Data && (pes = parsePES(id3Data))) {
                this.parseID3PES(id3Track, pes);
              }
              id3Data = {
                data: [],
                size: 0
              };
            }
            if (id3Data) {
              id3Data.data.push(data.subarray(offset, start + PACKET_LENGTH));
              id3Data.size += start + PACKET_LENGTH - offset;
            }
            break;
          case 0:
            if (stt) {
              offset += data[offset] + 1;
            }
            pmtId = this._pmtId = parsePAT(data, offset);
            // logger.log('PMT PID:'  + this._pmtId);
            break;
          case pmtId:
            {
              if (stt) {
                offset += data[offset] + 1;
              }
              const parsedPIDs = parsePMT(data, offset, this.typeSupported, isSampleAes);

              // only update track id if track PID found while parsing PMT
              // this is to avoid resetting the PID to -1 in case
              // track PID transiently disappears from the stream
              // this could happen in case of transient missing audio samples for example
              // NOTE this is only the PID of the track as found in TS,
              // but we are not using this for MP4 track IDs.
              avcId = parsedPIDs.avc;
              if (avcId > 0) {
                videoTrack.pid = avcId;
              }
              audioId = parsedPIDs.audio;
              if (audioId > 0) {
                audioTrack.pid = audioId;
                audioTrack.segmentCodec = parsedPIDs.segmentCodec;
              }
              id3Id = parsedPIDs.id3;
              if (id3Id > 0) {
                id3Track.pid = id3Id;
              }
              if (unknownPID !== null && !pmtParsed) {
                logger.warn(`MPEG-TS PMT found at ${start} after unknown PID '${unknownPID}'. Backtracking to sync byte @${syncOffset} to parse all TS packets.`);
                unknownPID = null;
                // we set it to -188, the += 188 in the for loop will reset start to 0
                start = syncOffset - 188;
              }
              pmtParsed = this.pmtParsed = true;
              break;
            }
          case 0x11:
          case 0x1fff:
            break;
          default:
            unknownPID = pid;
            break;
        }
      } else {
        tsPacketErrors++;
      }
    }
    if (tsPacketErrors > 0) {
      const error = new Error(`Found ${tsPacketErrors} TS packet/s that do not start with 0x47`);
      this.observer.emit(Events.ERROR, Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.FRAG_PARSING_ERROR,
        fatal: false,
        error,
        reason: error.message
      });
    }
    videoTrack.pesData = avcData;
    audioTrack.pesData = audioData;
    id3Track.pesData = id3Data;
    const demuxResult = {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    };
    if (flush) {
      this.extractRemainingSamples(demuxResult);
    }
    return demuxResult;
  }
  flush() {
    const {
      remainderData
    } = this;
    this.remainderData = null;
    let result;
    if (remainderData) {
      result = this.demux(remainderData, -1, false, true);
    } else {
      result = {
        videoTrack: this._avcTrack,
        audioTrack: this._audioTrack,
        id3Track: this._id3Track,
        textTrack: this._txtTrack
      };
    }
    this.extractRemainingSamples(result);
    if (this.sampleAes) {
      return this.decrypt(result, this.sampleAes);
    }
    return result;
  }
  extractRemainingSamples(demuxResult) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = demuxResult;
    const avcData = videoTrack.pesData;
    const audioData = audioTrack.pesData;
    const id3Data = id3Track.pesData;
    // try to parse last PES packets
    let pes;
    if (avcData && (pes = parsePES(avcData))) {
      this.parseAVCPES(videoTrack, textTrack, pes, true);
      videoTrack.pesData = null;
    } else {
      // either avcData null or PES truncated, keep it for next frag parsing
      videoTrack.pesData = avcData;
    }
    if (audioData && (pes = parsePES(audioData))) {
      switch (audioTrack.segmentCodec) {
        case 'aac':
          this.parseAACPES(audioTrack, pes);
          break;
        case 'mp3':
          this.parseMPEGPES(audioTrack, pes);
          break;
      }
      audioTrack.pesData = null;
    } else {
      if (audioData != null && audioData.size) {
        logger.log('last AAC PES packet truncated,might overlap between fragments');
      }

      // either audioData null or PES truncated, keep it for next frag parsing
      audioTrack.pesData = audioData;
    }
    if (id3Data && (pes = parsePES(id3Data))) {
      this.parseID3PES(id3Track, pes);
      id3Track.pesData = null;
    } else {
      // either id3Data null or PES truncated, keep it for next frag parsing
      id3Track.pesData = id3Data;
    }
  }
  demuxSampleAes(data, keyData, timeOffset) {
    const demuxResult = this.demux(data, timeOffset, true, !this.config.progressive);
    const sampleAes = this.sampleAes = new SampleAesDecrypter(this.observer, this.config, keyData);
    return this.decrypt(demuxResult, sampleAes);
  }
  decrypt(demuxResult, sampleAes) {
    return new Promise(resolve => {
      const {
        audioTrack,
        videoTrack
      } = demuxResult;
      if (audioTrack.samples && audioTrack.segmentCodec === 'aac') {
        sampleAes.decryptAacSamples(audioTrack.samples, 0, () => {
          if (videoTrack.samples) {
            sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, () => {
              resolve(demuxResult);
            });
          } else {
            resolve(demuxResult);
          }
        });
      } else if (videoTrack.samples) {
        sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, () => {
          resolve(demuxResult);
        });
      }
    });
  }
  destroy() {
    this._duration = 0;
  }
  parseAVCPES(track, textTrack, pes, last) {
    const units = this.parseAVCNALu(track, pes.data);
    let avcSample = this.avcSample;
    let push;
    let spsfound = false;
    // free pes.data to save up some memory
    pes.data = null;

    // if new NAL units found and last sample still there, let's push ...
    // this helps parsing streams with missing AUD (only do this if AUD never found)
    if (avcSample && units.length && !track.audFound) {
      pushAccessUnit(avcSample, track);
      avcSample = this.avcSample = createAVCSample(false, pes.pts, pes.dts, '');
    }
    units.forEach(unit => {
      var _avcSample2;
      switch (unit.type) {
        // NDR
        case 1:
          {
            let iskey = false;
            push = true;
            const data = unit.data;
            // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
            if (spsfound && data.length > 4) {
              // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
              const sliceType = new ExpGolomb(data).readSliceType();
              // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
              // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
              // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
              // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
              // if (sliceType === 2 || sliceType === 7) {
              if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) {
                iskey = true;
              }
            }
            if (iskey) {
              var _avcSample;
              // if we have non-keyframe data already, that cannot belong to the same frame as a keyframe, so force a push
              if ((_avcSample = avcSample) != null && _avcSample.frame && !avcSample.key) {
                pushAccessUnit(avcSample, track);
                avcSample = this.avcSample = null;
              }
            }
            if (!avcSample) {
              avcSample = this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');
            }
            avcSample.frame = true;
            avcSample.key = iskey;
            break;
            // IDR
          }

        case 5:
          push = true;
          // handle PES not starting with AUD
          // if we have non-keyframe data already, that cannot belong to the same frame as a keyframe, so force a push
          if ((_avcSample2 = avcSample) != null && _avcSample2.frame && !avcSample.key) {
            pushAccessUnit(avcSample, track);
            avcSample = this.avcSample = null;
          }
          if (!avcSample) {
            avcSample = this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');
          }
          avcSample.key = true;
          avcSample.frame = true;
          break;
        // SEI
        case 6:
          {
            push = true;
            parseSEIMessageFromNALu(unit.data, 1, pes.pts, textTrack.samples);
            break;
            // SPS
          }

        case 7:
          push = true;
          spsfound = true;
          if (!track.sps) {
            const sps = unit.data;
            const expGolombDecoder = new ExpGolomb(sps);
            const config = expGolombDecoder.readSPS();
            track.width = config.width;
            track.height = config.height;
            track.pixelRatio = config.pixelRatio;
            track.sps = [sps];
            track.duration = this._duration;
            const codecarray = sps.subarray(1, 4);
            let codecstring = 'avc1.';
            for (let i = 0; i < 3; i++) {
              let h = codecarray[i].toString(16);
              if (h.length < 2) {
                h = '0' + h;
              }
              codecstring += h;
            }
            track.codec = codecstring;
          }
          break;
        // PPS
        case 8:
          push = true;
          if (!track.pps) {
            track.pps = [unit.data];
          }
          break;
        // AUD
        case 9:
          push = false;
          track.audFound = true;
          if (avcSample) {
            pushAccessUnit(avcSample, track);
          }
          avcSample = this.avcSample = createAVCSample(false, pes.pts, pes.dts, '');
          break;
        // Filler Data
        case 12:
          push = true;
          break;
        default:
          push = false;
          if (avcSample) {
            avcSample.debug += 'unknown NAL ' + unit.type + ' ';
          }
          break;
      }
      if (avcSample && push) {
        const units = avcSample.units;
        units.push(unit);
      }
    });
    // if last PES packet, push samples
    if (last && avcSample) {
      pushAccessUnit(avcSample, track);
      this.avcSample = null;
    }
  }
  getLastNalUnit(samples) {
    var _avcSample3;
    let avcSample = this.avcSample;
    let lastUnit;
    // try to fallback to previous sample if current one is empty
    if (!avcSample || avcSample.units.length === 0) {
      avcSample = samples[samples.length - 1];
    }
    if ((_avcSample3 = avcSample) != null && _avcSample3.units) {
      const units = avcSample.units;
      lastUnit = units[units.length - 1];
    }
    return lastUnit;
  }
  parseAVCNALu(track, array) {
    const len = array.byteLength;
    let state = track.naluState || 0;
    const lastState = state;
    const units = [];
    let i = 0;
    let value;
    let overflow;
    let unitType;
    let lastUnitStart = -1;
    let lastUnitType = 0;
    // logger.log('PES:' + Hex.hexDump(array));

    if (state === -1) {
      // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
      lastUnitStart = 0;
      // NALu type is value read from offset 0
      lastUnitType = array[0] & 0x1f;
      state = 0;
      i = 1;
    }
    while (i < len) {
      value = array[i++];
      // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
      if (!state) {
        state = value ? 0 : 1;
        continue;
      }
      if (state === 1) {
        state = value ? 0 : 2;
        continue;
      }
      // here we have state either equal to 2 or 3
      if (!value) {
        state = 3;
      } else if (value === 1) {
        if (lastUnitStart >= 0) {
          const unit = {
            data: array.subarray(lastUnitStart, i - state - 1),
            type: lastUnitType
          };
          // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
          units.push(unit);
        } else {
          // lastUnitStart is undefined => this is the first start code found in this PES packet
          // first check if start code delimiter is overlapping between 2 PES packets,
          // ie it started in last packet (lastState not zero)
          // and ended at the beginning of this PES packet (i <= 4 - lastState)
          const lastUnit = this.getLastNalUnit(track.samples);
          if (lastUnit) {
            if (lastState && i <= 4 - lastState) {
              // start delimiter overlapping between PES packets
              // strip start delimiter bytes from the end of last NAL unit
              // check if lastUnit had a state different from zero
              if (lastUnit.state) {
                // strip last bytes
                lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
              }
            }
            // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
            overflow = i - state - 1;
            if (overflow > 0) {
              // logger.log('first NALU found with overflow:' + overflow);
              const tmp = new Uint8Array(lastUnit.data.byteLength + overflow);
              tmp.set(lastUnit.data, 0);
              tmp.set(array.subarray(0, overflow), lastUnit.data.byteLength);
              lastUnit.data = tmp;
              lastUnit.state = 0;
            }
          }
        }
        // check if we can read unit type
        if (i < len) {
          unitType = array[i] & 0x1f;
          // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
          lastUnitStart = i;
          lastUnitType = unitType;
          state = 0;
        } else {
          // not enough byte to read unit type. let's read it on next PES parsing
          state = -1;
        }
      } else {
        state = 0;
      }
    }
    if (lastUnitStart >= 0 && state >= 0) {
      const unit = {
        data: array.subarray(lastUnitStart, len),
        type: lastUnitType,
        state: state
      };
      units.push(unit);
      // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
    }
    // no NALu found
    if (units.length === 0) {
      // append pes.data to previous NAL unit
      const lastUnit = this.getLastNalUnit(track.samples);
      if (lastUnit) {
        const tmp = new Uint8Array(lastUnit.data.byteLength + array.byteLength);
        tmp.set(lastUnit.data, 0);
        tmp.set(array, lastUnit.data.byteLength);
        lastUnit.data = tmp;
      }
    }
    track.naluState = state;
    return units;
  }
  parseAACPES(track, pes) {
    let startOffset = 0;
    const aacOverFlow = this.aacOverFlow;
    let data = pes.data;
    if (aacOverFlow) {
      this.aacOverFlow = null;
      const frameMissingBytes = aacOverFlow.missing;
      const sampleLength = aacOverFlow.sample.unit.byteLength;
      // logger.log(`AAC: append overflowing ${sampleLength} bytes to beginning of new PES`);
      if (frameMissingBytes === -1) {
        const tmp = new Uint8Array(sampleLength + data.byteLength);
        tmp.set(aacOverFlow.sample.unit, 0);
        tmp.set(data, sampleLength);
        data = tmp;
      } else {
        const frameOverflowBytes = sampleLength - frameMissingBytes;
        aacOverFlow.sample.unit.set(data.subarray(0, frameMissingBytes), frameOverflowBytes);
        track.samples.push(aacOverFlow.sample);
        startOffset = aacOverFlow.missing;
      }
    }
    // look for ADTS header (0xFFFx)
    let offset;
    let len;
    for (offset = startOffset, len = data.length; offset < len - 1; offset++) {
      if (isHeader$1(data, offset)) {
        break;
      }
    }
    // if ADTS header does not start straight from the beginning of the PES payload, raise an error
    if (offset !== startOffset) {
      let reason;
      const recoverable = offset < len - 1;
      if (recoverable) {
        reason = `AAC PES did not start with ADTS header,offset:${offset}`;
      } else {
        reason = 'No ADTS header found in AAC PES';
      }
      const error = new Error(reason);
      logger.warn(`parsing error: ${reason}`);
      this.observer.emit(Events.ERROR, Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.FRAG_PARSING_ERROR,
        fatal: false,
        levelRetry: recoverable,
        error,
        reason
      });
      if (!recoverable) {
        return;
      }
    }
    initTrackConfig(track, this.observer, data, offset, this.audioCodec);
    let pts;
    if (pes.pts !== undefined) {
      pts = pes.pts;
    } else if (aacOverFlow) {
      // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
      // first sample PTS should be equal to last sample PTS + frameDuration
      const frameDuration = getFrameDuration(track.samplerate);
      pts = aacOverFlow.sample.pts + frameDuration;
    } else {
      logger.warn('[tsdemuxer]: AAC PES unknown PTS');
      return;
    }

    // scan for aac samples
    let frameIndex = 0;
    let frame;
    while (offset < len) {
      frame = appendFrame$1(track, data, offset, pts, frameIndex);
      offset += frame.length;
      if (!frame.missing) {
        frameIndex++;
        for (; offset < len - 1; offset++) {
          if (isHeader$1(data, offset)) {
            break;
          }
        }
      } else {
        this.aacOverFlow = frame;
        break;
      }
    }
  }
  parseMPEGPES(track, pes) {
    const data = pes.data;
    const length = data.length;
    let frameIndex = 0;
    let offset = 0;
    const pts = pes.pts;
    if (pts === undefined) {
      logger.warn('[tsdemuxer]: MPEG PES unknown PTS');
      return;
    }
    while (offset < length) {
      if (isHeader(data, offset)) {
        const frame = appendFrame(track, data, offset, pts, frameIndex);
        if (frame) {
          offset += frame.length;
          frameIndex++;
        } else {
          // logger.log('Unable to parse Mpeg audio frame');
          break;
        }
      } else {
        // nothing found, keep looking
        offset++;
      }
    }
  }
  parseID3PES(id3Track, pes) {
    if (pes.pts === undefined) {
      logger.warn('[tsdemuxer]: ID3 PES unknown PTS');
      return;
    }
    const id3Sample = _extends({}, pes, {
      type: this._avcTrack ? MetadataSchema.emsg : MetadataSchema.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    id3Track.samples.push(id3Sample);
  }
}
function createAVCSample(key, pts, dts, debug) {
  return {
    key,
    frame: false,
    pts,
    dts,
    units: [],
    debug,
    length: 0
  };
}
function parsePID(data, offset) {
  // pid is a 13-bit field starting at the last bit of TS[1]
  return ((data[offset + 1] & 0x1f) << 8) + data[offset + 2];
}
function parsePAT(data, offset) {
  // skip the PSI header and parse the first PMT entry
  return (data[offset + 10] & 0x1f) << 8 | data[offset + 11];
}
function parsePMT(data, offset, typeSupported, isSampleAes) {
  const result = {
    audio: -1,
    avc: -1,
    id3: -1,
    segmentCodec: 'aac'
  };
  const sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
  const tableEnd = offset + 3 + sectionLength - 4;
  // to determine where the table is, we have to figure out how
  // long the program info descriptors are
  const programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
  // advance the offset to the first entry in the mapping table
  offset += 12 + programInfoLength;
  while (offset < tableEnd) {
    const pid = parsePID(data, offset);
    switch (data[offset]) {
      case 0xcf:
        // SAMPLE-AES AAC
        if (!isSampleAes) {
          logger.log('ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream');
          break;
        }
      /* falls through */
      case 0x0f:
        // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
        // logger.log('AAC PID:'  + pid);
        if (result.audio === -1) {
          result.audio = pid;
        }
        break;

      // Packetized metadata (ID3)
      case 0x15:
        // logger.log('ID3 PID:'  + pid);
        if (result.id3 === -1) {
          result.id3 = pid;
        }
        break;
      case 0xdb:
        // SAMPLE-AES AVC
        if (!isSampleAes) {
          logger.log('H.264 with AES-128-CBC slice encryption found in unencrypted stream');
          break;
        }
      /* falls through */
      case 0x1b:
        // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
        // logger.log('AVC PID:'  + pid);
        if (result.avc === -1) {
          result.avc = pid;
        }
        break;

      // ISO/IEC 11172-3 (MPEG-1 audio)
      // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
      case 0x03:
      case 0x04:
        // logger.log('MPEG PID:'  + pid);
        if (typeSupported.mpeg !== true && typeSupported.mp3 !== true) {
          logger.log('MPEG audio found, not supported in this browser');
        } else if (result.audio === -1) {
          result.audio = pid;
          result.segmentCodec = 'mp3';
        }
        break;
      case 0x24:
        logger.warn('Unsupported HEVC stream type found');
        break;
    }
    // move to the next table entry
    // skip past the elementary stream descriptors, if present
    offset += ((data[offset + 3] & 0x0f) << 8 | data[offset + 4]) + 5;
  }
  return result;
}
function parsePES(stream) {
  let i = 0;
  let frag;
  let pesLen;
  let pesHdrLen;
  let pesPts;
  let pesDts;
  const data = stream.data;
  // safety check
  if (!stream || stream.size === 0) {
    return null;
  }

  // we might need up to 19 bytes to read PES header
  // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
  // usually only one merge is needed (and this is rare ...)
  while (data[0].length < 19 && data.length > 1) {
    const newData = new Uint8Array(data[0].length + data[1].length);
    newData.set(data[0]);
    newData.set(data[1], data[0].length);
    data[0] = newData;
    data.splice(1, 1);
  }
  // retrieve PTS/DTS from first fragment
  frag = data[0];
  const pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
  if (pesPrefix === 1) {
    pesLen = (frag[4] << 8) + frag[5];
    // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
    // minus 6 : PES header size
    if (pesLen && pesLen > stream.size - 6) {
      return null;
    }
    const pesFlags = frag[7];
    if (pesFlags & 0xc0) {
      /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
          as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
          as Bitwise operators treat their operands as a sequence of 32 bits */
      pesPts = (frag[9] & 0x0e) * 536870912 +
      // 1 << 29
      (frag[10] & 0xff) * 4194304 +
      // 1 << 22
      (frag[11] & 0xfe) * 16384 +
      // 1 << 14
      (frag[12] & 0xff) * 128 +
      // 1 << 7
      (frag[13] & 0xfe) / 2;
      if (pesFlags & 0x40) {
        pesDts = (frag[14] & 0x0e) * 536870912 +
        // 1 << 29
        (frag[15] & 0xff) * 4194304 +
        // 1 << 22
        (frag[16] & 0xfe) * 16384 +
        // 1 << 14
        (frag[17] & 0xff) * 128 +
        // 1 << 7
        (frag[18] & 0xfe) / 2;
        if (pesPts - pesDts > 60 * 90000) {
          logger.warn(`${Math.round((pesPts - pesDts) / 90000)}s delta between PTS and DTS, align them`);
          pesPts = pesDts;
        }
      } else {
        pesDts = pesPts;
      }
    }
    pesHdrLen = frag[8];
    // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
    let payloadStartOffset = pesHdrLen + 9;
    if (stream.size <= payloadStartOffset) {
      return null;
    }
    stream.size -= payloadStartOffset;
    // reassemble PES packet
    const pesData = new Uint8Array(stream.size);
    for (let j = 0, dataLen = data.length; j < dataLen; j++) {
      frag = data[j];
      let len = frag.byteLength;
      if (payloadStartOffset) {
        if (payloadStartOffset > len) {
          // trim full frag if PES header bigger than frag
          payloadStartOffset -= len;
          continue;
        } else {
          // trim partial frag if PES header smaller than frag
          frag = frag.subarray(payloadStartOffset);
          len -= payloadStartOffset;
          payloadStartOffset = 0;
        }
      }
      pesData.set(frag, i);
      i += len;
    }
    if (pesLen) {
      // payload size : remove PES header + PES extension
      pesLen -= pesHdrLen + 3;
    }
    return {
      data: pesData,
      pts: pesPts,
      dts: pesDts,
      len: pesLen
    };
  }
  return null;
}
function pushAccessUnit(avcSample, avcTrack) {
  if (avcSample.units.length && avcSample.frame) {
    // if sample does not have PTS/DTS, patch with last sample PTS/DTS
    if (avcSample.pts === undefined) {
      const samples = avcTrack.samples;
      const nbSamples = samples.length;
      if (nbSamples) {
        const lastSample = samples[nbSamples - 1];
        avcSample.pts = lastSample.pts;
        avcSample.dts = lastSample.dts;
      } else {
        // dropping samples, no timestamp found
        avcTrack.dropped++;
        return;
      }
    }
    avcTrack.samples.push(avcSample);
  }
  if (avcSample.debug.length) {
    logger.log(avcSample.pts + '/' + avcSample.dts + ':' + avcSample.debug);
  }
}

/**
 * MP3 demuxer
 */
class MP3Demuxer extends BaseAudioDemuxer {
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
    this._audioTrack = {
      container: 'audio/mpeg',
      type: 'audio',
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: 'mp3',
      samples: [],
      manifestCodec: audioCodec,
      duration: trackDuration,
      inputTimeScale: 90000,
      dropped: 0
    };
  }
  static probe(data) {
    if (!data) {
      return false;
    }

    // check if data contains ID3 timestamp and MPEG sync word
    // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
    // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
    // More info http://www.mp3-tech.org/programmer/frame_header.html
    const id3Data = getID3Data(data, 0) || [];
    let offset = id3Data.length;
    for (let length = data.length; offset < length; offset++) {
      if (probe(data, offset)) {
        logger.log('MPEG Audio sync word found !');
        return true;
      }
    }
    return false;
  }
  canParse(data, offset) {
    return canParse(data, offset);
  }
  appendFrame(track, data, offset) {
    if (this.basePTS === null) {
      return;
    }
    return appendFrame(track, data, offset, this.basePTS, this.frameIndex);
  }
}

/**
 *  AAC helper
 */

class AAC {
  static getSilentFrame(codec, channelCount) {
    switch (codec) {
      case 'mp4a.40.2':
        if (channelCount === 1) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x23, 0x80]);
        } else if (channelCount === 2) {
          return new Uint8Array([0x21, 0x00, 0x49, 0x90, 0x02, 0x19, 0x00, 0x23, 0x80]);
        } else if (channelCount === 3) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x8e]);
        } else if (channelCount === 4) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x80, 0x2c, 0x80, 0x08, 0x02, 0x38]);
        } else if (channelCount === 5) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x38]);
        } else if (channelCount === 6) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x00, 0xb2, 0x00, 0x20, 0x08, 0xe0]);
        }
        break;
      // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
      default:
        if (channelCount === 1) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x4e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x1c, 0x6, 0xf1, 0xc1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        } else if (channelCount === 2) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        } else if (channelCount === 3) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        }
        break;
    }
    return undefined;
  }
}

/**
 * Generate MP4 Box
 */

const UINT32_MAX = Math.pow(2, 32) - 1;
class MP4 {
  static init() {
    MP4.types = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      '.mp3': [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let i;
    for (i in MP4.types) {
      if (MP4.types.hasOwnProperty(i)) {
        MP4.types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
      }
    }
    const videoHdlr = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0x76, 0x69, 0x64, 0x65,
    // handler_type: 'vide'
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
    ]);

    const audioHdlr = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0x73, 0x6f, 0x75, 0x6e,
    // handler_type: 'soun'
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
    ]);

    MP4.HDLR_TYPES = {
      video: videoHdlr,
      audio: audioHdlr
    };
    const dref = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x01,
    // entry_count
    0x00, 0x00, 0x00, 0x0c,
    // entry_size
    0x75, 0x72, 0x6c, 0x20,
    // 'url' type
    0x00,
    // version 0
    0x00, 0x00, 0x01 // entry_flags
    ]);

    const stco = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00 // entry_count
    ]);

    MP4.STTS = MP4.STSC = MP4.STCO = stco;
    MP4.STSZ = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // sample_size
    0x00, 0x00, 0x00, 0x00 // sample_count
    ]);

    MP4.VMHD = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x01,
    // flags
    0x00, 0x00,
    // graphicsmode
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
    ]);

    MP4.SMHD = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00,
    // balance
    0x00, 0x00 // reserved
    ]);

    MP4.STSD = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x01]); // entry_count

    const majorBrand = new Uint8Array([105, 115, 111, 109]); // isom
    const avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1
    const minorVersion = new Uint8Array([0, 0, 0, 1]);
    MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
    MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
  }
  static box(type, ...payload) {
    let size = 8;
    let i = payload.length;
    const len = i;
    // calculate the total size we need to allocate
    while (i--) {
      size += payload[i].byteLength;
    }
    const result = new Uint8Array(size);
    result[0] = size >> 24 & 0xff;
    result[1] = size >> 16 & 0xff;
    result[2] = size >> 8 & 0xff;
    result[3] = size & 0xff;
    result.set(type, 4);
    // copy the payload into the result
    for (i = 0, size = 8; i < len; i++) {
      // copy payload[i] array @ offset size
      result.set(payload[i], size);
      size += payload[i].byteLength;
    }
    return result;
  }
  static hdlr(type) {
    return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
  }
  static mdat(data) {
    return MP4.box(MP4.types.mdat, data);
  }
  static mdhd(timescale, duration) {
    duration *= timescale;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    return MP4.box(MP4.types.mdhd, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    timescale >> 24 & 0xff, timescale >> 16 & 0xff, timescale >> 8 & 0xff, timescale & 0xff,
    // timescale
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x55, 0xc4,
    // 'und' language (undetermined)
    0x00, 0x00]));
  }
  static mdia(track) {
    return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
  }
  static mfhd(sequenceNumber) {
    return MP4.box(MP4.types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00,
    // flags
    sequenceNumber >> 24, sequenceNumber >> 16 & 0xff, sequenceNumber >> 8 & 0xff, sequenceNumber & 0xff // sequence_number
    ]));
  }

  static minf(track) {
    if (track.type === 'audio') {
      return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
    } else {
      return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
    }
  }
  static moof(sn, baseMediaDecodeTime, track) {
    return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
  }
  static moov(tracks) {
    let i = tracks.length;
    const boxes = [];
    while (i--) {
      boxes[i] = MP4.trak(tracks[i]);
    }
    return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale, tracks[0].duration)].concat(boxes).concat(MP4.mvex(tracks)));
  }
  static mvex(tracks) {
    let i = tracks.length;
    const boxes = [];
    while (i--) {
      boxes[i] = MP4.trex(tracks[i]);
    }
    return MP4.box.apply(null, [MP4.types.mvex, ...boxes]);
  }
  static mvhd(timescale, duration) {
    duration *= timescale;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    const bytes = new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    timescale >> 24 & 0xff, timescale >> 16 & 0xff, timescale >> 8 & 0xff, timescale & 0xff,
    // timescale
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x00, 0x01, 0x00, 0x00,
    // 1.0 rate
    0x01, 0x00,
    // 1.0 volume
    0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00,
    // transformation: unity matrix
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0xff, 0xff, 0xff, 0xff // next_track_ID
    ]);

    return MP4.box(MP4.types.mvhd, bytes);
  }
  static sdtp(track) {
    const samples = track.samples || [];
    const bytes = new Uint8Array(4 + samples.length);
    let i;
    let flags;
    // leave the full box header (4 bytes) all zero
    // write the sample table
    for (i = 0; i < samples.length; i++) {
      flags = samples[i].flags;
      bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
    }
    return MP4.box(MP4.types.sdtp, bytes);
  }
  static stbl(track) {
    return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
  }
  static avc1(track) {
    let sps = [];
    let pps = [];
    let i;
    let data;
    let len;
    // assemble the SPSs

    for (i = 0; i < track.sps.length; i++) {
      data = track.sps[i];
      len = data.byteLength;
      sps.push(len >>> 8 & 0xff);
      sps.push(len & 0xff);

      // SPS
      sps = sps.concat(Array.prototype.slice.call(data));
    }

    // assemble the PPSs
    for (i = 0; i < track.pps.length; i++) {
      data = track.pps[i];
      len = data.byteLength;
      pps.push(len >>> 8 & 0xff);
      pps.push(len & 0xff);
      pps = pps.concat(Array.prototype.slice.call(data));
    }
    const avcc = MP4.box(MP4.types.avcC, new Uint8Array([0x01,
    // version
    sps[3],
    // profile
    sps[4],
    // profile compat
    sps[5],
    // level
    0xfc | 3,
    // lengthSizeMinusOne, hard-coded to 4 bytes
    0xe0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(sps).concat([track.pps.length // numOfPictureParameterSets
    ]).concat(pps))); // "PPS"
    const width = track.width;
    const height = track.height;
    const hSpacing = track.pixelRatio[0];
    const vSpacing = track.pixelRatio[1];
    return MP4.box(MP4.types.avc1, new Uint8Array([0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // data_reference_index
    0x00, 0x00,
    // pre_defined
    0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // pre_defined
    width >> 8 & 0xff, width & 0xff,
    // width
    height >> 8 & 0xff, height & 0xff,
    // height
    0x00, 0x48, 0x00, 0x00,
    // horizresolution
    0x00, 0x48, 0x00, 0x00,
    // vertresolution
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // frame_count
    0x12, 0x64, 0x61, 0x69, 0x6c,
    // dailymotion/hls.js
    0x79, 0x6d, 0x6f, 0x74, 0x69, 0x6f, 0x6e, 0x2f, 0x68, 0x6c, 0x73, 0x2e, 0x6a, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // compressorname
    0x00, 0x18,
    // depth = 24
    0x11, 0x11]),
    // pre_defined = -1
    avcc, MP4.box(MP4.types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80,
    // bufferSizeDB
    0x00, 0x2d, 0xc6, 0xc0,
    // maxBitrate
    0x00, 0x2d, 0xc6, 0xc0])),
    // avgBitrate
    MP4.box(MP4.types.pasp, new Uint8Array([hSpacing >> 24,
    // hSpacing
    hSpacing >> 16 & 0xff, hSpacing >> 8 & 0xff, hSpacing & 0xff, vSpacing >> 24,
    // vSpacing
    vSpacing >> 16 & 0xff, vSpacing >> 8 & 0xff, vSpacing & 0xff])));
  }
  static esds(track) {
    const configlen = track.config.length;
    return new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags

    0x03,
    // descriptor_type
    0x17 + configlen,
    // length
    0x00, 0x01,
    // es_id
    0x00,
    // stream_priority

    0x04,
    // descriptor_type
    0x0f + configlen,
    // length
    0x40,
    // codec : mpeg4_audio
    0x15,
    // stream_type
    0x00, 0x00, 0x00,
    // buffer_size
    0x00, 0x00, 0x00, 0x00,
    // maxBitrate
    0x00, 0x00, 0x00, 0x00,
    // avgBitrate

    0x05 // descriptor_type
    ].concat([configlen]).concat(track.config).concat([0x06, 0x01, 0x02])); // GASpecificConfig)); // length + audio config descriptor
  }

  static mp4a(track) {
    const samplerate = track.samplerate;
    return MP4.box(MP4.types.mp4a, new Uint8Array([0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // data_reference_index
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, track.channelCount,
    // channelcount
    0x00, 0x10,
    // sampleSize:16bits
    0x00, 0x00, 0x00, 0x00,
    // reserved2
    samplerate >> 8 & 0xff, samplerate & 0xff,
    //
    0x00, 0x00]), MP4.box(MP4.types.esds, MP4.esds(track)));
  }
  static mp3(track) {
    const samplerate = track.samplerate;
    return MP4.box(MP4.types['.mp3'], new Uint8Array([0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // data_reference_index
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, track.channelCount,
    // channelcount
    0x00, 0x10,
    // sampleSize:16bits
    0x00, 0x00, 0x00, 0x00,
    // reserved2
    samplerate >> 8 & 0xff, samplerate & 0xff,
    //
    0x00, 0x00]));
  }
  static stsd(track) {
    if (track.type === 'audio') {
      if (track.segmentCodec === 'mp3' && track.codec === 'mp3') {
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
      }
      return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
    } else {
      return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
    }
  }
  static tkhd(track) {
    const id = track.id;
    const duration = track.duration * track.timescale;
    const width = track.width;
    const height = track.height;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    return MP4.box(MP4.types.tkhd, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x07,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    id >> 24 & 0xff, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff,
    // track_ID
    0x00, 0x00, 0x00, 0x00,
    // reserved
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00,
    // layer
    0x00, 0x00,
    // alternate_group
    0x00, 0x00,
    // non-audio track volume
    0x00, 0x00,
    // reserved
    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00,
    // transformation: unity matrix
    width >> 8 & 0xff, width & 0xff, 0x00, 0x00,
    // width
    height >> 8 & 0xff, height & 0xff, 0x00, 0x00 // height
    ]));
  }

  static traf(track, baseMediaDecodeTime) {
    const sampleDependencyTable = MP4.sdtp(track);
    const id = track.id;
    const upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
    const lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
    return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    id >> 24, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff // track_ID
    ])), MP4.box(MP4.types.tfdt, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    upperWordBaseMediaDecodeTime >> 24, upperWordBaseMediaDecodeTime >> 16 & 0xff, upperWordBaseMediaDecodeTime >> 8 & 0xff, upperWordBaseMediaDecodeTime & 0xff, lowerWordBaseMediaDecodeTime >> 24, lowerWordBaseMediaDecodeTime >> 16 & 0xff, lowerWordBaseMediaDecodeTime >> 8 & 0xff, lowerWordBaseMediaDecodeTime & 0xff])), MP4.trun(track, sampleDependencyTable.length + 16 +
    // tfhd
    20 +
    // tfdt
    8 +
    // traf header
    16 +
    // mfhd
    8 +
    // moof header
    8),
    // mdat header
    sampleDependencyTable);
  }

  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(track) {
    track.duration = track.duration || 0xffffffff;
    return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
  }
  static trex(track) {
    const id = track.id;
    return MP4.box(MP4.types.trex, new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    id >> 24, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff,
    // track_ID
    0x00, 0x00, 0x00, 0x01,
    // default_sample_description_index
    0x00, 0x00, 0x00, 0x00,
    // default_sample_duration
    0x00, 0x00, 0x00, 0x00,
    // default_sample_size
    0x00, 0x01, 0x00, 0x01 // default_sample_flags
    ]));
  }

  static trun(track, offset) {
    const samples = track.samples || [];
    const len = samples.length;
    const arraylen = 12 + 16 * len;
    const array = new Uint8Array(arraylen);
    let i;
    let sample;
    let duration;
    let size;
    let flags;
    let cts;
    offset += 8 + arraylen;
    array.set([track.type === 'video' ? 0x01 : 0x00,
    // version 1 for video with signed-int sample_composition_time_offset
    0x00, 0x0f, 0x01,
    // flags
    len >>> 24 & 0xff, len >>> 16 & 0xff, len >>> 8 & 0xff, len & 0xff,
    // sample_count
    offset >>> 24 & 0xff, offset >>> 16 & 0xff, offset >>> 8 & 0xff, offset & 0xff // data_offset
    ], 0);
    for (i = 0; i < len; i++) {
      sample = samples[i];
      duration = sample.duration;
      size = sample.size;
      flags = sample.flags;
      cts = sample.cts;
      array.set([duration >>> 24 & 0xff, duration >>> 16 & 0xff, duration >>> 8 & 0xff, duration & 0xff,
      // sample_duration
      size >>> 24 & 0xff, size >>> 16 & 0xff, size >>> 8 & 0xff, size & 0xff,
      // sample_size
      flags.isLeading << 2 | flags.dependsOn, flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync, flags.degradPrio & 0xf0 << 8, flags.degradPrio & 0x0f,
      // sample_flags
      cts >>> 24 & 0xff, cts >>> 16 & 0xff, cts >>> 8 & 0xff, cts & 0xff // sample_composition_time_offset
      ], 12 + 16 * i);
    }
    return MP4.box(MP4.types.trun, array);
  }
  static initSegment(tracks) {
    if (!MP4.types) {
      MP4.init();
    }
    const movie = MP4.moov(tracks);
    const result = new Uint8Array(MP4.FTYP.byteLength + movie.byteLength);
    result.set(MP4.FTYP);
    result.set(movie, MP4.FTYP.byteLength);
    return result;
  }
}
MP4.types = void 0;
MP4.HDLR_TYPES = void 0;
MP4.STTS = void 0;
MP4.STSC = void 0;
MP4.STCO = void 0;
MP4.STSZ = void 0;
MP4.VMHD = void 0;
MP4.SMHD = void 0;
MP4.STSD = void 0;
MP4.FTYP = void 0;
MP4.DINF = void 0;

const MPEG_TS_CLOCK_FREQ_HZ = 90000;
function toTimescaleFromBase(baseTime, destScale, srcBase = 1, round = false) {
  const result = baseTime * destScale * srcBase; // equivalent to `(value * scale) / (1 / base)`
  return round ? Math.round(result) : result;
}
function toTimescaleFromScale(baseTime, destScale, srcScale = 1, round = false) {
  return toTimescaleFromBase(baseTime, destScale, 1 / srcScale, round);
}
function toMsFromMpegTsClock(baseTime, round = false) {
  return toTimescaleFromBase(baseTime, 1000, 1 / MPEG_TS_CLOCK_FREQ_HZ, round);
}
function toMpegTsClockFromTimescale(baseTime, srcScale = 1) {
  return toTimescaleFromBase(baseTime, MPEG_TS_CLOCK_FREQ_HZ, 1 / srcScale);
}

const MAX_SILENT_FRAME_DURATION = 10 * 1000; // 10 seconds
const AAC_SAMPLES_PER_FRAME = 1024;
const MPEG_AUDIO_SAMPLE_PER_FRAME = 1152;
let chromeVersion = null;
let safariWebkitVersion = null;
class MP4Remuxer {
  constructor(observer, config, typeSupported, vendor = '') {
    this.observer = void 0;
    this.config = void 0;
    this.typeSupported = void 0;
    this.ISGenerated = false;
    this._initPTS = null;
    this._initDTS = null;
    this.nextAvcDts = null;
    this.nextAudioPts = null;
    this.videoSampleDuration = null;
    this.isAudioContiguous = false;
    this.isVideoContiguous = false;
    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
    this.ISGenerated = false;
    if (chromeVersion === null) {
      const userAgent = navigator.userAgent || '';
      const result = userAgent.match(/Chrome\/(\d+)/i);
      chromeVersion = result ? parseInt(result[1]) : 0;
    }
    if (safariWebkitVersion === null) {
      const result = navigator.userAgent.match(/Safari\/(\d+)/i);
      safariWebkitVersion = result ? parseInt(result[1]) : 0;
    }
  }
  destroy() {}
  resetTimeStamp(defaultTimeStamp) {
    logger.log('[mp4-remuxer]: initPTS & initDTS reset');
    this._initPTS = this._initDTS = defaultTimeStamp;
  }
  resetNextTimestamp() {
    logger.log('[mp4-remuxer]: reset next timestamp');
    this.isVideoContiguous = false;
    this.isAudioContiguous = false;
  }
  resetInitSegment() {
    logger.log('[mp4-remuxer]: ISGenerated flag reset');
    this.ISGenerated = false;
  }
  getVideoStartPts(videoSamples) {
    let rolloverDetected = false;
    const startPTS = videoSamples.reduce((minPTS, sample) => {
      const delta = sample.pts - minPTS;
      if (delta < -4294967296) {
        // 2^32, see PTSNormalize for reasoning, but we're hitting a rollover here, and we don't want that to impact the timeOffset calculation
        rolloverDetected = true;
        return normalizePts(minPTS, sample.pts);
      } else if (delta > 0) {
        return minPTS;
      } else {
        return sample.pts;
      }
    }, videoSamples[0].pts);
    if (rolloverDetected) {
      logger.debug('PTS rollover detected');
    }
    return startPTS;
  }
  remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, flush, playlistType) {
    let video;
    let audio;
    let initSegment;
    let text;
    let id3;
    let independent;
    let audioTimeOffset = timeOffset;
    let videoTimeOffset = timeOffset;

    // If we're remuxing audio and video progressively, wait until we've received enough samples for each track before proceeding.
    // This is done to synchronize the audio and video streams. We know if the current segment will have samples if the "pid"
    // parameter is greater than -1. The pid is set when the PMT is parsed, which contains the tracks list.
    // However, if the initSegment has already been generated, or we've reached the end of a segment (flush),
    // then we can remux one track without waiting for the other.
    const hasAudio = audioTrack.pid > -1;
    const hasVideo = videoTrack.pid > -1;
    const length = videoTrack.samples.length;
    const enoughAudioSamples = audioTrack.samples.length > 0;
    const enoughVideoSamples = flush && length > 0 || length > 1;
    const canRemuxAvc = (!hasAudio || enoughAudioSamples) && (!hasVideo || enoughVideoSamples) || this.ISGenerated || flush;
    if (canRemuxAvc) {
      if (!this.ISGenerated) {
        initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
      }
      const isVideoContiguous = this.isVideoContiguous;
      let firstKeyFrameIndex = -1;
      let firstKeyFramePTS;
      if (enoughVideoSamples) {
        firstKeyFrameIndex = findKeyframeIndex(videoTrack.samples);
        if (!isVideoContiguous && this.config.forceKeyFrameOnDiscontinuity) {
          independent = true;
          if (firstKeyFrameIndex > 0) {
            logger.warn(`[mp4-remuxer]: Dropped ${firstKeyFrameIndex} out of ${length} video samples due to a missing keyframe`);
            const startPTS = this.getVideoStartPts(videoTrack.samples);
            videoTrack.samples = videoTrack.samples.slice(firstKeyFrameIndex);
            videoTrack.dropped += firstKeyFrameIndex;
            videoTimeOffset += (videoTrack.samples[0].pts - startPTS) / videoTrack.inputTimeScale;
            firstKeyFramePTS = videoTimeOffset;
          } else if (firstKeyFrameIndex === -1) {
            logger.warn(`[mp4-remuxer]: No keyframe found out of ${length} video samples`);
            independent = false;
          }
        }
      }
      if (this.ISGenerated) {
        if (enoughAudioSamples && enoughVideoSamples) {
          // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
          // if first audio DTS is not aligned with first video DTS then we need to take that into account
          // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
          // drift between audio and video streams
          const startPTS = this.getVideoStartPts(videoTrack.samples);
          const tsDelta = normalizePts(audioTrack.samples[0].pts, startPTS) - startPTS;
          const audiovideoTimestampDelta = tsDelta / videoTrack.inputTimeScale;
          audioTimeOffset += Math.max(0, audiovideoTimestampDelta);
          videoTimeOffset += Math.max(0, -audiovideoTimestampDelta);
        }

        // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is calculated in remuxAudio.
        if (enoughAudioSamples) {
          // if initSegment was generated without audio samples, regenerate it again
          if (!audioTrack.samplerate) {
            logger.warn('[mp4-remuxer]: regenerate InitSegment as audio detected');
            initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
          }
          audio = this.remuxAudio(audioTrack, audioTimeOffset, this.isAudioContiguous, accurateTimeOffset, hasVideo || enoughVideoSamples || playlistType === PlaylistLevelType.AUDIO ? videoTimeOffset : undefined);
          if (enoughVideoSamples) {
            const audioTrackLength = audio ? audio.endPTS - audio.startPTS : 0;
            // if initSegment was generated without video samples, regenerate it again
            if (!videoTrack.inputTimeScale) {
              logger.warn('[mp4-remuxer]: regenerate InitSegment as video detected');
              initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
            }
            video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, audioTrackLength);
          }
        } else if (enoughVideoSamples) {
          video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, 0);
        }
        if (video) {
          video.firstKeyFrame = firstKeyFrameIndex;
          video.independent = firstKeyFrameIndex !== -1;
          video.firstKeyFramePTS = firstKeyFramePTS;
        }
      }
    }

    // Allow ID3 and text to remux, even if more audio/video samples are required
    if (this.ISGenerated && this._initPTS && this._initDTS) {
      if (id3Track.samples.length) {
        id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, this._initPTS, this._initDTS);
      }
      if (textTrack.samples.length) {
        text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, this._initPTS);
      }
    }
    return {
      audio,
      video,
      initSegment,
      independent,
      text,
      id3
    };
  }
  generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset) {
    const audioSamples = audioTrack.samples;
    const videoSamples = videoTrack.samples;
    const typeSupported = this.typeSupported;
    const tracks = {};
    const _initPTS = this._initPTS;
    let computePTSDTS = !_initPTS || accurateTimeOffset;
    let container = 'audio/mp4';
    let initPTS;
    let initDTS;
    let timescale;
    if (computePTSDTS) {
      initPTS = initDTS = Infinity;
    }
    if (audioTrack.config && audioSamples.length) {
      // let's use audio sampling rate as MP4 time scale.
      // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
      // using audio sampling rate here helps having an integer MP4 frame duration
      // this avoids potential rounding issue and AV sync issue
      audioTrack.timescale = audioTrack.samplerate;
      switch (audioTrack.segmentCodec) {
        case 'mp3':
          if (typeSupported.mpeg) {
            // Chrome and Safari
            container = 'audio/mpeg';
            audioTrack.codec = '';
          } else if (typeSupported.mp3) {
            // Firefox
            audioTrack.codec = 'mp3';
          }
          break;
      }
      tracks.audio = {
        id: 'audio',
        container: container,
        codec: audioTrack.codec,
        initSegment: audioTrack.segmentCodec === 'mp3' && typeSupported.mpeg ? new Uint8Array(0) : MP4.initSegment([audioTrack]),
        metadata: {
          channelCount: audioTrack.channelCount
        }
      };
      if (computePTSDTS) {
        timescale = audioTrack.inputTimeScale;
        if (!_initPTS || timescale !== _initPTS.timescale) {
          // remember first PTS of this demuxing context. for audio, PTS = DTS
          initPTS = initDTS = audioSamples[0].pts - Math.round(timescale * timeOffset);
        } else {
          computePTSDTS = false;
        }
      }
    }
    if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
      // let's use input time scale as MP4 video timescale
      // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
      videoTrack.timescale = videoTrack.inputTimeScale;
      tracks.video = {
        id: 'main',
        container: 'video/mp4',
        codec: videoTrack.codec,
        initSegment: MP4.initSegment([videoTrack]),
        metadata: {
          width: videoTrack.width,
          height: videoTrack.height
        }
      };
      if (computePTSDTS) {
        timescale = videoTrack.inputTimeScale;
        if (!_initPTS || timescale !== _initPTS.timescale) {
          const startPTS = this.getVideoStartPts(videoSamples);
          const startOffset = Math.round(timescale * timeOffset);
          initDTS = Math.min(initDTS, normalizePts(videoSamples[0].dts, startPTS) - startOffset);
          initPTS = Math.min(initPTS, startPTS - startOffset);
        } else {
          computePTSDTS = false;
        }
      }
    }
    if (Object.keys(tracks).length) {
      this.ISGenerated = true;
      if (computePTSDTS) {
        this._initPTS = {
          baseTime: initPTS,
          timescale: timescale
        };
        this._initDTS = {
          baseTime: initDTS,
          timescale: timescale
        };
      } else {
        initPTS = timescale = undefined;
      }
      return {
        tracks,
        initPTS,
        timescale
      };
    }
  }
  remuxVideo(track, timeOffset, contiguous, audioTrackLength) {
    const timeScale = track.inputTimeScale;
    const inputSamples = track.samples;
    const outputSamples = [];
    const nbSamples = inputSamples.length;
    const initPTS = this._initPTS;
    let nextAvcDts = this.nextAvcDts;
    let offset = 8;
    let mp4SampleDuration = this.videoSampleDuration;
    let firstDTS;
    let lastDTS;
    let minPTS = Number.POSITIVE_INFINITY;
    let maxPTS = Number.NEGATIVE_INFINITY;
    let sortSamples = false;

    // if parsed fragment is contiguous with last one, let's use last DTS value as reference
    if (!contiguous || nextAvcDts === null) {
      const pts = timeOffset * timeScale;
      const cts = inputSamples[0].pts - normalizePts(inputSamples[0].dts, inputSamples[0].pts);
      // if not contiguous, let's use target timeOffset
      nextAvcDts = pts - cts;
    }

    // PTS is coded on 33bits, and can loop from -2^32 to 2^32
    // PTSNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
    const initTime = initPTS.baseTime * timeScale / initPTS.timescale;
    for (let i = 0; i < nbSamples; i++) {
      const sample = inputSamples[i];
      sample.pts = normalizePts(sample.pts - initTime, nextAvcDts);
      sample.dts = normalizePts(sample.dts - initTime, nextAvcDts);
      if (sample.dts < inputSamples[i > 0 ? i - 1 : i].dts) {
        sortSamples = true;
      }
    }

    // sort video samples by DTS then PTS then demux id order
    if (sortSamples) {
      inputSamples.sort(function (a, b) {
        const deltadts = a.dts - b.dts;
        const deltapts = a.pts - b.pts;
        return deltadts || deltapts;
      });
    }

    // Get first/last DTS
    firstDTS = inputSamples[0].dts;
    lastDTS = inputSamples[inputSamples.length - 1].dts;

    // Sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
    // set this constant duration as being the avg delta between consecutive DTS.
    const inputDuration = lastDTS - firstDTS;
    const averageSampleDuration = inputDuration ? Math.round(inputDuration / (nbSamples - 1)) : mp4SampleDuration || track.inputTimeScale / 30;

    // if fragment are contiguous, detect hole/overlapping between fragments
    if (contiguous) {
      // check timestamp continuity across consecutive fragments (this is to remove inter-fragment gap/hole)
      const delta = firstDTS - nextAvcDts;
      const foundHole = delta > averageSampleDuration;
      const foundOverlap = delta < -1;
      if (foundHole || foundOverlap) {
        if (foundHole) {
          logger.warn(`AVC: ${toMsFromMpegTsClock(delta, true)} ms (${delta}dts) hole between fragments detected, filling it`);
        } else {
          logger.warn(`AVC: ${toMsFromMpegTsClock(-delta, true)} ms (${delta}dts) overlapping between fragments detected`);
        }
        if (!foundOverlap || nextAvcDts >= inputSamples[0].pts) {
          firstDTS = nextAvcDts;
          const firstPTS = inputSamples[0].pts - delta;
          inputSamples[0].dts = firstDTS;
          inputSamples[0].pts = firstPTS;
          logger.log(`Video: First PTS/DTS adjusted: ${toMsFromMpegTsClock(firstPTS, true)}/${toMsFromMpegTsClock(firstDTS, true)}, delta: ${toMsFromMpegTsClock(delta, true)} ms`);
        }
      }
    }
    firstDTS = Math.max(0, firstDTS);
    let nbNalu = 0;
    let naluLen = 0;
    for (let i = 0; i < nbSamples; i++) {
      // compute total/avc sample length and nb of NAL units
      const sample = inputSamples[i];
      const units = sample.units;
      const nbUnits = units.length;
      let sampleLen = 0;
      for (let j = 0; j < nbUnits; j++) {
        sampleLen += units[j].data.length;
      }
      naluLen += sampleLen;
      nbNalu += nbUnits;
      sample.length = sampleLen;

      // ensure sample monotonic DTS
      sample.dts = Math.max(sample.dts, firstDTS);
      minPTS = Math.min(sample.pts, minPTS);
      maxPTS = Math.max(sample.pts, maxPTS);
    }
    lastDTS = inputSamples[nbSamples - 1].dts;

    /* concatenate the video data and construct the mdat in place
      (need 8 more bytes to fill length and mpdat type) */
    const mdatSize = naluLen + 4 * nbNalu + 8;
    let mdat;
    try {
      mdat = new Uint8Array(mdatSize);
    } catch (err) {
      this.observer.emit(Events.ERROR, Events.ERROR, {
        type: ErrorTypes.MUX_ERROR,
        details: ErrorDetails.REMUX_ALLOC_ERROR,
        fatal: false,
        error: err,
        bytes: mdatSize,
        reason: `fail allocating video mdat ${mdatSize}`
      });
      return;
    }
    const view = new DataView(mdat.buffer);
    view.setUint32(0, mdatSize);
    mdat.set(MP4.types.mdat, 4);
    let stretchedLastFrame = false;
    let minDtsDelta = Number.POSITIVE_INFINITY;
    let minPtsDelta = Number.POSITIVE_INFINITY;
    let maxDtsDelta = Number.NEGATIVE_INFINITY;
    let maxPtsDelta = Number.NEGATIVE_INFINITY;
    for (let i = 0; i < nbSamples; i++) {
      const avcSample = inputSamples[i];
      const avcSampleUnits = avcSample.units;
      let mp4SampleLength = 0;
      // convert NALU bitstream to MP4 format (prepend NALU with size field)
      for (let j = 0, nbUnits = avcSampleUnits.length; j < nbUnits; j++) {
        const unit = avcSampleUnits[j];
        const unitData = unit.data;
        const unitDataLen = unit.data.byteLength;
        view.setUint32(offset, unitDataLen);
        offset += 4;
        mdat.set(unitData, offset);
        offset += unitDataLen;
        mp4SampleLength += 4 + unitDataLen;
      }

      // expected sample duration is the Decoding Timestamp diff of consecutive samples
      let ptsDelta;
      if (i < nbSamples - 1) {
        mp4SampleDuration = inputSamples[i + 1].dts - avcSample.dts;
        ptsDelta = inputSamples[i + 1].pts - avcSample.pts;
      } else {
        const config = this.config;
        const lastFrameDuration = i > 0 ? avcSample.dts - inputSamples[i - 1].dts : averageSampleDuration;
        ptsDelta = i > 0 ? avcSample.pts - inputSamples[i - 1].pts : averageSampleDuration;
        if (config.stretchShortVideoTrack && this.nextAudioPts !== null) {
          // In some cases, a segment's audio track duration may exceed the video track duration.
          // Since we've already remuxed audio, and we know how long the audio track is, we look to
          // see if the delta to the next segment is longer than maxBufferHole.
          // If so, playback would potentially get stuck, so we artificially inflate
          // the duration of the last frame to minimize any potential gap between segments.
          const gapTolerance = Math.floor(config.maxBufferHole * timeScale);
          const deltaToFrameEnd = (audioTrackLength ? minPTS + audioTrackLength * timeScale : this.nextAudioPts) - avcSample.pts;
          if (deltaToFrameEnd > gapTolerance) {
            // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
            // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
            mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
            if (mp4SampleDuration < 0) {
              mp4SampleDuration = lastFrameDuration;
            } else {
              stretchedLastFrame = true;
            }
            logger.log(`[mp4-remuxer]: It is approximately ${deltaToFrameEnd / 90} ms to the next segment; using duration ${mp4SampleDuration / 90} ms for the last video frame.`);
          } else {
            mp4SampleDuration = lastFrameDuration;
          }
        } else {
          mp4SampleDuration = lastFrameDuration;
        }
      }
      const compositionTimeOffset = Math.round(avcSample.pts - avcSample.dts);
      minDtsDelta = Math.min(minDtsDelta, mp4SampleDuration);
      maxDtsDelta = Math.max(maxDtsDelta, mp4SampleDuration);
      minPtsDelta = Math.min(minPtsDelta, ptsDelta);
      maxPtsDelta = Math.max(maxPtsDelta, ptsDelta);
      outputSamples.push(new Mp4Sample(avcSample.key, mp4SampleDuration, mp4SampleLength, compositionTimeOffset));
    }
    if (outputSamples.length) {
      if (chromeVersion) {
        if (chromeVersion < 70) {
          // Chrome workaround, mark first sample as being a Random Access Point (keyframe) to avoid sourcebuffer append issue
          // https://code.google.com/p/chromium/issues/detail?id=229412
          const flags = outputSamples[0].flags;
          flags.dependsOn = 2;
          flags.isNonSync = 0;
        }
      } else if (safariWebkitVersion) {
        // Fix for "CNN special report, with CC" in test-streams (Safari browser only)
        // Ignore DTS when frame durations are irregular. Safari MSE does not handle this leading to gaps.
        if (maxPtsDelta - minPtsDelta < maxDtsDelta - minDtsDelta && averageSampleDuration / maxDtsDelta < 0.025 && outputSamples[0].cts === 0) {
          logger.warn('Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.');
          let dts = firstDTS;
          for (let i = 0, len = outputSamples.length; i < len; i++) {
            const nextDts = dts + outputSamples[i].duration;
            const pts = dts + outputSamples[i].cts;
            if (i < len - 1) {
              const nextPts = nextDts + outputSamples[i + 1].cts;
              outputSamples[i].duration = nextPts - pts;
            } else {
              outputSamples[i].duration = i ? outputSamples[i - 1].duration : averageSampleDuration;
            }
            outputSamples[i].cts = 0;
            dts = nextDts;
          }
        }
      }
    }
    // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
    mp4SampleDuration = stretchedLastFrame || !mp4SampleDuration ? averageSampleDuration : mp4SampleDuration;
    this.nextAvcDts = nextAvcDts = lastDTS + mp4SampleDuration;
    this.videoSampleDuration = mp4SampleDuration;
    this.isVideoContiguous = true;
    const moof = MP4.moof(track.sequenceNumber++, firstDTS, _extends({}, track, {
      samples: outputSamples
    }));
    const type = 'video';
    const data = {
      data1: moof,
      data2: mdat,
      startPTS: minPTS / timeScale,
      endPTS: (maxPTS + mp4SampleDuration) / timeScale,
      startDTS: firstDTS / timeScale,
      endDTS: nextAvcDts / timeScale,
      type,
      hasAudio: false,
      hasVideo: true,
      nb: outputSamples.length,
      dropped: track.dropped
    };
    track.samples = [];
    track.dropped = 0;
    return data;
  }
  remuxAudio(track, timeOffset, contiguous, accurateTimeOffset, videoTimeOffset) {
    const inputTimeScale = track.inputTimeScale;
    const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
    const scaleFactor = inputTimeScale / mp4timeScale;
    const mp4SampleDuration = track.segmentCodec === 'aac' ? AAC_SAMPLES_PER_FRAME : MPEG_AUDIO_SAMPLE_PER_FRAME;
    const inputSampleDuration = mp4SampleDuration * scaleFactor;
    const initPTS = this._initPTS;
    const rawMPEG = track.segmentCodec === 'mp3' && this.typeSupported.mpeg;
    const outputSamples = [];
    const alignedWithVideo = videoTimeOffset !== undefined;
    let inputSamples = track.samples;
    let offset = rawMPEG ? 0 : 8;
    let nextAudioPts = this.nextAudioPts || -1;

    // window.audioSamples ? window.audioSamples.push(inputSamples.map(s => s.pts)) : (window.audioSamples = [inputSamples.map(s => s.pts)]);

    // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
    // for sake of clarity:
    // consecutive fragments are frags with
    //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
    //  - less than 20 audio frames distance
    // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
    // this helps ensuring audio continuity
    // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
    const timeOffsetMpegTS = timeOffset * inputTimeScale;
    const initTime = initPTS.baseTime * inputTimeScale / initPTS.timescale;
    this.isAudioContiguous = contiguous = contiguous || inputSamples.length && nextAudioPts > 0 && (accurateTimeOffset && Math.abs(timeOffsetMpegTS - nextAudioPts) < 9000 || Math.abs(normalizePts(inputSamples[0].pts - initTime, timeOffsetMpegTS) - nextAudioPts) < 20 * inputSampleDuration);

    // compute normalized PTS
    inputSamples.forEach(function (sample) {
      sample.pts = normalizePts(sample.pts - initTime, timeOffsetMpegTS);
    });
    if (!contiguous || nextAudioPts < 0) {
      // filter out sample with negative PTS that are not playable anyway
      // if we don't remove these negative samples, they will shift all audio samples forward.
      // leading to audio overlap between current / next fragment
      inputSamples = inputSamples.filter(sample => sample.pts >= 0);

      // in case all samples have negative PTS, and have been filtered out, return now
      if (!inputSamples.length) {
        return;
      }
      if (videoTimeOffset === 0) {
        // Set the start to 0 to match video so that start gaps larger than inputSampleDuration are filled with silence
        nextAudioPts = 0;
      } else if (accurateTimeOffset && !alignedWithVideo) {
        // When not seeking, not live, and LevelDetails.PTSKnown, use fragment start as predicted next audio PTS
        nextAudioPts = Math.max(0, timeOffsetMpegTS);
      } else {
        // if frags are not contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
        nextAudioPts = inputSamples[0].pts;
      }
    }

    // If the audio track is missing samples, the frames seem to get "left-shifted" within the
    // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
    // In an effort to prevent this from happening, we inject frames here where there are gaps.
    // When possible, we inject a silent frame; when that's not possible, we duplicate the last
    // frame.

    if (track.segmentCodec === 'aac') {
      const maxAudioFramesDrift = this.config.maxAudioFramesDrift;
      for (let i = 0, nextPts = nextAudioPts; i < inputSamples.length; i++) {
        // First, let's see how far off this frame is from where we expect it to be
        const sample = inputSamples[i];
        const pts = sample.pts;
        const delta = pts - nextPts;
        const duration = Math.abs(1000 * delta / inputTimeScale);

        // When remuxing with video, if we're overlapping by more than a duration, drop this sample to stay in sync
        if (delta <= -maxAudioFramesDrift * inputSampleDuration && alignedWithVideo) {
          if (i === 0) {
            logger.warn(`Audio frame @ ${(pts / inputTimeScale).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1000 * delta / inputTimeScale)} ms.`);
            this.nextAudioPts = nextAudioPts = nextPts = pts;
          }
        } // eslint-disable-line brace-style

        // Insert missing frames if:
        // 1: We're more than maxAudioFramesDrift frame away
        // 2: Not more than MAX_SILENT_FRAME_DURATION away
        // 3: currentTime (aka nextPtsNorm) is not 0
        // 4: remuxing with video (videoTimeOffset !== undefined)
        else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && alignedWithVideo) {
          let missing = Math.round(delta / inputSampleDuration);
          // Adjust nextPts so that silent samples are aligned with media pts. This will prevent media samples from
          // later being shifted if nextPts is based on timeOffset and delta is not a multiple of inputSampleDuration.
          nextPts = pts - missing * inputSampleDuration;
          if (nextPts < 0) {
            missing--;
            nextPts += inputSampleDuration;
          }
          if (i === 0) {
            this.nextAudioPts = nextAudioPts = nextPts;
          }
          logger.warn(`[mp4-remuxer]: Injecting ${missing} audio frame @ ${(nextPts / inputTimeScale).toFixed(3)}s due to ${Math.round(1000 * delta / inputTimeScale)} ms gap.`);
          for (let j = 0; j < missing; j++) {
            const newStamp = Math.max(nextPts, 0);
            let fillFrame = AAC.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
            if (!fillFrame) {
              logger.log('[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead.');
              fillFrame = sample.unit.subarray();
            }
            inputSamples.splice(i, 0, {
              unit: fillFrame,
              pts: newStamp
            });
            nextPts += inputSampleDuration;
            i++;
          }
        }
        sample.pts = nextPts;
        nextPts += inputSampleDuration;
      }
    }
    let firstPTS = null;
    let lastPTS = null;
    let mdat;
    let mdatSize = 0;
    let sampleLength = inputSamples.length;
    while (sampleLength--) {
      mdatSize += inputSamples[sampleLength].unit.byteLength;
    }
    for (let j = 0, _nbSamples = inputSamples.length; j < _nbSamples; j++) {
      const audioSample = inputSamples[j];
      const unit = audioSample.unit;
      let pts = audioSample.pts;
      if (lastPTS !== null) {
        // If we have more than one sample, set the duration of the sample to the "real" duration; the PTS diff with
        // the previous sample
        const prevSample = outputSamples[j - 1];
        prevSample.duration = Math.round((pts - lastPTS) / scaleFactor);
      } else {
        if (contiguous && track.segmentCodec === 'aac') {
          // set PTS/DTS to expected PTS/DTS
          pts = nextAudioPts;
        }
        // remember first PTS of our audioSamples
        firstPTS = pts;
        if (mdatSize > 0) {
          /* concatenate the audio data and construct the mdat in place
            (need 8 more bytes to fill length and mdat type) */
          mdatSize += offset;
          try {
            mdat = new Uint8Array(mdatSize);
          } catch (err) {
            this.observer.emit(Events.ERROR, Events.ERROR, {
              type: ErrorTypes.MUX_ERROR,
              details: ErrorDetails.REMUX_ALLOC_ERROR,
              fatal: false,
              error: err,
              bytes: mdatSize,
              reason: `fail allocating audio mdat ${mdatSize}`
            });
            return;
          }
          if (!rawMPEG) {
            const view = new DataView(mdat.buffer);
            view.setUint32(0, mdatSize);
            mdat.set(MP4.types.mdat, 4);
          }
        } else {
          // no audio samples
          return;
        }
      }
      mdat.set(unit, offset);
      const unitLen = unit.byteLength;
      offset += unitLen;
      // Default the sample's duration to the computed mp4SampleDuration, which will either be 1024 for AAC or 1152 for MPEG
      // In the case that we have 1 sample, this will be the duration. If we have more than one sample, the duration
      // becomes the PTS diff with the previous sample
      outputSamples.push(new Mp4Sample(true, mp4SampleDuration, unitLen, 0));
      lastPTS = pts;
    }

    // We could end up with no audio samples if all input samples were overlapping with the previously remuxed ones
    const nbSamples = outputSamples.length;
    if (!nbSamples) {
      return;
    }

    // The next audio sample PTS should be equal to last sample PTS + duration
    const lastSample = outputSamples[outputSamples.length - 1];
    this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSample.duration;

    // Set the track samples from inputSamples to outputSamples before remuxing
    const moof = rawMPEG ? new Uint8Array(0) : MP4.moof(track.sequenceNumber++, firstPTS / scaleFactor, _extends({}, track, {
      samples: outputSamples
    }));

    // Clear the track samples. This also clears the samples array in the demuxer, since the reference is shared
    track.samples = [];
    const start = firstPTS / inputTimeScale;
    const end = nextAudioPts / inputTimeScale;
    const type = 'audio';
    const audioData = {
      data1: moof,
      data2: mdat,
      startPTS: start,
      endPTS: end,
      startDTS: start,
      endDTS: end,
      type,
      hasAudio: true,
      hasVideo: false,
      nb: nbSamples
    };
    this.isAudioContiguous = true;
    return audioData;
  }
  remuxEmptyAudio(track, timeOffset, contiguous, videoData) {
    const inputTimeScale = track.inputTimeScale;
    const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
    const scaleFactor = inputTimeScale / mp4timeScale;
    const nextAudioPts = this.nextAudioPts;
    // sync with video's timestamp
    const initDTS = this._initDTS;
    const init90kHz = initDTS.baseTime * 90000 / initDTS.timescale;
    const startDTS = (nextAudioPts !== null ? nextAudioPts : videoData.startDTS * inputTimeScale) + init90kHz;
    const endDTS = videoData.endDTS * inputTimeScale + init90kHz;
    // one sample's duration value
    const frameDuration = scaleFactor * AAC_SAMPLES_PER_FRAME;
    // samples count of this segment's duration
    const nbSamples = Math.ceil((endDTS - startDTS) / frameDuration);
    // silent frame
    const silentFrame = AAC.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
    logger.warn('[mp4-remuxer]: remux empty Audio');
    // Can't remux if we can't generate a silent frame...
    if (!silentFrame) {
      logger.trace('[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec');
      return;
    }
    const samples = [];
    for (let i = 0; i < nbSamples; i++) {
      const stamp = startDTS + i * frameDuration;
      samples.push({
        unit: silentFrame,
        pts: stamp,
        dts: stamp
      });
    }
    track.samples = samples;
    return this.remuxAudio(track, timeOffset, contiguous, false);
  }
}
function normalizePts(value, reference) {
  let offset;
  if (reference === null) {
    return value;
  }
  if (reference < value) {
    // - 2^33
    offset = -8589934592;
  } else {
    // + 2^33
    offset = 8589934592;
  }
  /* PTS is 33bit (from 0 to 2^33 -1)
    if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
    PTS looping occured. fill the gap */
  while (Math.abs(value - reference) > 4294967296) {
    value += offset;
  }
  return value;
}
function findKeyframeIndex(samples) {
  for (let i = 0; i < samples.length; i++) {
    if (samples[i].key) {
      return i;
    }
  }
  return -1;
}
function flushTextTrackMetadataCueSamples(track, timeOffset, initPTS, initDTS) {
  const length = track.samples.length;
  if (!length) {
    return;
  }
  const inputTimeScale = track.inputTimeScale;
  for (let index = 0; index < length; index++) {
    const sample = track.samples[index];
    // setting id3 pts, dts to relative time
    // using this._initPTS and this._initDTS to calculate relative time
    sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    sample.dts = normalizePts(sample.dts - initDTS.baseTime * inputTimeScale / initDTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
  }
  const samples = track.samples;
  track.samples = [];
  return {
    samples
  };
}
function flushTextTrackUserdataCueSamples(track, timeOffset, initPTS) {
  const length = track.samples.length;
  if (!length) {
    return;
  }
  const inputTimeScale = track.inputTimeScale;
  for (let index = 0; index < length; index++) {
    const sample = track.samples[index];
    // setting text pts, dts to relative time
    // using this._initPTS and this._initDTS to calculate relative time
    sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
  }
  track.samples.sort((a, b) => a.pts - b.pts);
  const samples = track.samples;
  track.samples = [];
  return {
    samples
  };
}
class Mp4Sample {
  constructor(isKeyframe, duration, size, cts) {
    this.size = void 0;
    this.duration = void 0;
    this.cts = void 0;
    this.flags = void 0;
    this.duration = duration;
    this.size = size;
    this.cts = cts;
    this.flags = new Mp4SampleFlags(isKeyframe);
  }
}
class Mp4SampleFlags {
  constructor(isKeyframe) {
    this.isLeading = 0;
    this.isDependedOn = 0;
    this.hasRedundancy = 0;
    this.degradPrio = 0;
    this.dependsOn = 1;
    this.isNonSync = 1;
    this.dependsOn = isKeyframe ? 2 : 1;
    this.isNonSync = isKeyframe ? 0 : 1;
  }
}

class PassThroughRemuxer {
  constructor() {
    this.emitInitSegment = false;
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this.initData = void 0;
    this.initPTS = null;
    this.initTracks = void 0;
    this.lastEndTime = null;
  }
  destroy() {}
  resetTimeStamp(defaultInitPTS) {
    this.initPTS = defaultInitPTS;
    this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.lastEndTime = null;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, decryptdata) {
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
    this.generateInitSegment(patchEncyptionData(initSegment, decryptdata));
    this.emitInitSegment = true;
  }
  generateInitSegment(initSegment) {
    let {
      audioCodec,
      videoCodec
    } = this;
    if (!(initSegment != null && initSegment.byteLength)) {
      this.initTracks = undefined;
      this.initData = undefined;
      return;
    }
    const initData = this.initData = parseInitSegment(initSegment);

    // Get codec from initSegment or fallback to default
    if (!audioCodec) {
      audioCodec = getParsedTrackCodec(initData.audio, ElementaryStreamTypes.AUDIO);
    }
    if (!videoCodec) {
      videoCodec = getParsedTrackCodec(initData.video, ElementaryStreamTypes.VIDEO);
    }
    const tracks = {};
    if (initData.audio && initData.video) {
      tracks.audiovideo = {
        container: 'video/mp4',
        codec: audioCodec + ',' + videoCodec,
        initSegment,
        id: 'main'
      };
    } else if (initData.audio) {
      tracks.audio = {
        container: 'audio/mp4',
        codec: audioCodec,
        initSegment,
        id: 'audio'
      };
    } else if (initData.video) {
      tracks.video = {
        container: 'video/mp4',
        codec: videoCodec,
        initSegment,
        id: 'main'
      };
    } else {
      logger.warn('[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes.');
    }
    this.initTracks = tracks;
  }
  remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset) {
    var _initData, _initData2;
    let {
      initPTS,
      lastEndTime
    } = this;
    const result = {
      audio: undefined,
      video: undefined,
      text: textTrack,
      id3: id3Track,
      initSegment: undefined
    };

    // If we haven't yet set a lastEndDTS, or it was reset, set it to the provided timeOffset. We want to use the
    // lastEndDTS over timeOffset whenever possible; during progressive playback, the media source will not update
    // the media duration (which is what timeOffset is provided as) before we need to process the next chunk.
    if (!isFiniteNumber(lastEndTime)) {
      lastEndTime = this.lastEndTime = timeOffset || 0;
    }

    // The binary segment data is added to the videoTrack in the mp4demuxer. We don't check to see if the data is only
    // audio or video (or both); adding it to video was an arbitrary choice.
    const data = videoTrack.samples;
    if (!(data != null && data.length)) {
      return result;
    }
    const initSegment = {
      initPTS: undefined,
      timescale: 1
    };
    let initData = this.initData;
    if (!((_initData = initData) != null && _initData.length)) {
      this.generateInitSegment(data);
      initData = this.initData;
    }
    if (!((_initData2 = initData) != null && _initData2.length)) {
      // We can't remux if the initSegment could not be generated
      logger.warn('[passthrough-remuxer.ts]: Failed to generate initSegment.');
      return result;
    }
    if (this.emitInitSegment) {
      initSegment.tracks = this.initTracks;
      this.emitInitSegment = false;
    }
    const duration = getDuration(data, initData);
    const startDTS = getStartDTS(initData, data);
    const decodeTime = startDTS === null ? timeOffset : startDTS;
    if (isInvalidInitPts(initPTS, decodeTime, timeOffset, duration) || initSegment.timescale !== initPTS.timescale && accurateTimeOffset) {
      initSegment.initPTS = decodeTime - timeOffset;
      if (initPTS && initPTS.timescale === 1) {
        logger.warn(`Adjusting initPTS by ${initSegment.initPTS - initPTS.baseTime}`);
      }
      this.initPTS = initPTS = {
        baseTime: initSegment.initPTS,
        timescale: 1
      };
    }
    const startTime = audioTrack ? decodeTime - initPTS.baseTime / initPTS.timescale : lastEndTime;
    const endTime = startTime + duration;
    offsetStartDTS(initData, data, initPTS.baseTime / initPTS.timescale);
    if (duration > 0) {
      this.lastEndTime = endTime;
    } else {
      logger.warn('Duration parsed from mp4 should be greater than zero');
      this.resetNextTimestamp();
    }
    const hasAudio = !!initData.audio;
    const hasVideo = !!initData.video;
    let type = '';
    if (hasAudio) {
      type += 'audio';
    }
    if (hasVideo) {
      type += 'video';
    }
    const track = {
      data1: data,
      startPTS: startTime,
      startDTS: startTime,
      endPTS: endTime,
      endDTS: endTime,
      type,
      hasAudio,
      hasVideo,
      nb: 1,
      dropped: 0
    };
    result.audio = track.type === 'audio' ? track : undefined;
    result.video = track.type !== 'audio' ? track : undefined;
    result.initSegment = initSegment;
    result.id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, initPTS, initPTS);
    if (textTrack.samples.length) {
      result.text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, initPTS);
    }
    return result;
  }
}
function isInvalidInitPts(initPTS, startDTS, timeOffset, duration) {
  if (initPTS === null) {
    return true;
  }
  // InitPTS is invalid when distance from program would be more than segment duration or a minimum of one second
  const minDuration = Math.max(duration, 1);
  const startTime = startDTS - initPTS.baseTime / initPTS.timescale;
  return Math.abs(startTime - timeOffset) > minDuration;
}
function getParsedTrackCodec(track, type) {
  const parsedCodec = track == null ? void 0 : track.codec;
  if (parsedCodec && parsedCodec.length > 4) {
    return parsedCodec;
  }
  // Since mp4-tools cannot parse full codec string (see 'TODO: Parse codec details'... in mp4-tools)
  // Provide defaults based on codec type
  // This allows for some playback of some fmp4 playlists without CODECS defined in manifest
  if (parsedCodec === 'hvc1' || parsedCodec === 'hev1') {
    return 'hvc1.1.6.L120.90';
  }
  if (parsedCodec === 'av01') {
    return 'av01.0.04M.08';
  }
  if (parsedCodec === 'avc1' || type === ElementaryStreamTypes.VIDEO) {
    return 'avc1.42e01e';
  }
  return 'mp4a.40.5';
}

let now;
// performance.now() not available on WebWorker, at least on Safari Desktop
try {
  now = self.performance.now.bind(self.performance);
} catch (err) {
  logger.debug('Unable to use Performance API on this environment');
  now = typeof self !== 'undefined' && self.Date.now;
}
const muxConfig = [{
  demux: MP4Demuxer,
  remux: PassThroughRemuxer
}, {
  demux: TSDemuxer,
  remux: MP4Remuxer
}, {
  demux: AACDemuxer,
  remux: MP4Remuxer
}, {
  demux: MP3Demuxer,
  remux: MP4Remuxer
}];
class Transmuxer {
  constructor(observer, typeSupported, config, vendor, id) {
    this.async = false;
    this.observer = void 0;
    this.typeSupported = void 0;
    this.config = void 0;
    this.vendor = void 0;
    this.id = void 0;
    this.demuxer = void 0;
    this.remuxer = void 0;
    this.decrypter = void 0;
    this.probe = void 0;
    this.decryptionPromise = null;
    this.transmuxConfig = void 0;
    this.currentTransmuxState = void 0;
    this.observer = observer;
    this.typeSupported = typeSupported;
    this.config = config;
    this.vendor = vendor;
    this.id = id;
  }
  configure(transmuxConfig) {
    this.transmuxConfig = transmuxConfig;
    if (this.decrypter) {
      this.decrypter.reset();
    }
  }
  push(data, decryptdata, chunkMeta, state) {
    const stats = chunkMeta.transmuxing;
    stats.executeStart = now();
    let uintData = new Uint8Array(data);
    const {
      currentTransmuxState,
      transmuxConfig
    } = this;
    if (state) {
      this.currentTransmuxState = state;
    }
    const {
      contiguous,
      discontinuity,
      trackSwitch,
      accurateTimeOffset,
      timeOffset,
      initSegmentChange
    } = state || currentTransmuxState;
    const {
      audioCodec,
      videoCodec,
      defaultInitPts,
      duration,
      initSegmentData
    } = transmuxConfig;
    const keyData = getEncryptionType(uintData, decryptdata);
    if (keyData && keyData.method === 'AES-128') {
      const decrypter = this.getDecrypter();
      // Software decryption is synchronous; webCrypto is not
      if (decrypter.isSync()) {
        // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
        // data is handled in the flush() call
        let decryptedData = decrypter.softwareDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer);
        // For Low-Latency HLS Parts, decrypt in place, since part parsing is expected on push progress
        const loadingParts = chunkMeta.part > -1;
        if (loadingParts) {
          decryptedData = decrypter.flush();
        }
        if (!decryptedData) {
          stats.executeEnd = now();
          return emptyResult(chunkMeta);
        }
        uintData = new Uint8Array(decryptedData);
      } else {
        this.decryptionPromise = decrypter.webCryptoDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer).then(decryptedData => {
          // Calling push here is important; if flush() is called while this is still resolving, this ensures that
          // the decrypted data has been transmuxed
          const result = this.push(decryptedData, null, chunkMeta);
          this.decryptionPromise = null;
          return result;
        });
        return this.decryptionPromise;
      }
    }
    const resetMuxers = this.needsProbing(discontinuity, trackSwitch);
    if (resetMuxers) {
      const error = this.configureTransmuxer(uintData);
      if (error) {
        logger.warn(`[transmuxer] ${error.message}`);
        this.observer.emit(Events.ERROR, Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.FRAG_PARSING_ERROR,
          fatal: false,
          error,
          reason: error.message
        });
        stats.executeEnd = now();
        return emptyResult(chunkMeta);
      }
    }
    if (discontinuity || trackSwitch || initSegmentChange || resetMuxers) {
      this.resetInitSegment(initSegmentData, audioCodec, videoCodec, duration, decryptdata);
    }
    if (discontinuity || initSegmentChange || resetMuxers) {
      this.resetInitialTimestamp(defaultInitPts);
    }
    if (!contiguous) {
      this.resetContiguity();
    }
    const result = this.transmux(uintData, keyData, timeOffset, accurateTimeOffset, chunkMeta);
    const currentState = this.currentTransmuxState;
    currentState.contiguous = true;
    currentState.discontinuity = false;
    currentState.trackSwitch = false;
    stats.executeEnd = now();
    return result;
  }

  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(chunkMeta) {
    const stats = chunkMeta.transmuxing;
    stats.executeStart = now();
    const {
      decrypter,
      currentTransmuxState,
      decryptionPromise
    } = this;
    if (decryptionPromise) {
      // Upon resolution, the decryption promise calls push() and returns its TransmuxerResult up the stack. Therefore
      // only flushing is required for async decryption
      return decryptionPromise.then(() => {
        return this.flush(chunkMeta);
      });
    }
    const transmuxResults = [];
    const {
      timeOffset
    } = currentTransmuxState;
    if (decrypter) {
      // The decrypter may have data cached, which needs to be demuxed. In this case we'll have two TransmuxResults
      // This happens in the case that we receive only 1 push call for a segment (either for non-progressive downloads,
      // or for progressive downloads with small segments)
      const decryptedData = decrypter.flush();
      if (decryptedData) {
        // Push always returns a TransmuxerResult if decryptdata is null
        transmuxResults.push(this.push(decryptedData, null, chunkMeta));
      }
    }
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      // If probing failed, then Hls.js has been given content its not able to handle
      stats.executeEnd = now();
      return [emptyResult(chunkMeta)];
    }
    const demuxResultOrPromise = demuxer.flush(timeOffset);
    if (isPromise(demuxResultOrPromise)) {
      // Decrypt final SAMPLE-AES samples
      return demuxResultOrPromise.then(demuxResult => {
        this.flushRemux(transmuxResults, demuxResult, chunkMeta);
        return transmuxResults;
      });
    }
    this.flushRemux(transmuxResults, demuxResultOrPromise, chunkMeta);
    return transmuxResults;
  }
  flushRemux(transmuxResults, demuxResult, chunkMeta) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = demuxResult;
    const {
      accurateTimeOffset,
      timeOffset
    } = this.currentTransmuxState;
    logger.log(`[transmuxer.ts]: Flushed fragment ${chunkMeta.sn}${chunkMeta.part > -1 ? ' p: ' + chunkMeta.part : ''} of level ${chunkMeta.level}`);
    const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, true, this.id);
    transmuxResults.push({
      remuxResult,
      chunkMeta
    });
    chunkMeta.transmuxing.executeEnd = now();
  }
  resetInitialTimestamp(defaultInitPts) {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetTimeStamp(defaultInitPts);
    remuxer.resetTimeStamp(defaultInitPts);
  }
  resetContiguity() {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetContiguity();
    remuxer.resetNextTimestamp();
  }
  resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration, decryptdata) {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration);
    remuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, decryptdata);
  }
  destroy() {
    if (this.demuxer) {
      this.demuxer.destroy();
      this.demuxer = undefined;
    }
    if (this.remuxer) {
      this.remuxer.destroy();
      this.remuxer = undefined;
    }
  }
  transmux(data, keyData, timeOffset, accurateTimeOffset, chunkMeta) {
    let result;
    if (keyData && keyData.method === 'SAMPLE-AES') {
      result = this.transmuxSampleAes(data, keyData, timeOffset, accurateTimeOffset, chunkMeta);
    } else {
      result = this.transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta);
    }
    return result;
  }
  transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = this.demuxer.demux(data, timeOffset, false, !this.config.progressive);
    const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, false, this.id);
    return {
      remuxResult,
      chunkMeta
    };
  }
  transmuxSampleAes(data, decryptData, timeOffset, accurateTimeOffset, chunkMeta) {
    return this.demuxer.demuxSampleAes(data, decryptData, timeOffset).then(demuxResult => {
      const remuxResult = this.remuxer.remux(demuxResult.audioTrack, demuxResult.videoTrack, demuxResult.id3Track, demuxResult.textTrack, timeOffset, accurateTimeOffset, false, this.id);
      return {
        remuxResult,
        chunkMeta
      };
    });
  }
  configureTransmuxer(data) {
    const {
      config,
      observer,
      typeSupported,
      vendor
    } = this;
    // probe for content type
    let mux;
    for (let i = 0, len = muxConfig.length; i < len; i++) {
      if (muxConfig[i].demux.probe(data)) {
        mux = muxConfig[i];
        break;
      }
    }
    if (!mux) {
      return new Error('Failed to find demuxer by probing fragment data');
    }
    // so let's check that current remuxer and demuxer are still valid
    const demuxer = this.demuxer;
    const remuxer = this.remuxer;
    const Remuxer = mux.remux;
    const Demuxer = mux.demux;
    if (!remuxer || !(remuxer instanceof Remuxer)) {
      this.remuxer = new Remuxer(observer, config, typeSupported, vendor);
    }
    if (!demuxer || !(demuxer instanceof Demuxer)) {
      this.demuxer = new Demuxer(observer, config, typeSupported);
      this.probe = Demuxer.probe;
    }
  }
  needsProbing(discontinuity, trackSwitch) {
    // in case of continuity change, or track switch
    // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
    return !this.demuxer || !this.remuxer || discontinuity || trackSwitch;
  }
  getDecrypter() {
    let decrypter = this.decrypter;
    if (!decrypter) {
      decrypter = this.decrypter = new Decrypter(this.config);
    }
    return decrypter;
  }
}
function getEncryptionType(data, decryptData) {
  let encryptionType = null;
  if (data.byteLength > 0 && decryptData != null && decryptData.key != null && decryptData.iv !== null && decryptData.method != null) {
    encryptionType = decryptData;
  }
  return encryptionType;
}
const emptyResult = chunkMeta => ({
  remuxResult: {},
  chunkMeta
});
function isPromise(p) {
  return 'then' in p && p.then instanceof Function;
}
class TransmuxConfig {
  constructor(audioCodec, videoCodec, initSegmentData, duration, defaultInitPts) {
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this.initSegmentData = void 0;
    this.duration = void 0;
    this.defaultInitPts = void 0;
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
    this.initSegmentData = initSegmentData;
    this.duration = duration;
    this.defaultInitPts = defaultInitPts || null;
  }
}
class TransmuxState {
  constructor(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange) {
    this.discontinuity = void 0;
    this.contiguous = void 0;
    this.accurateTimeOffset = void 0;
    this.trackSwitch = void 0;
    this.timeOffset = void 0;
    this.initSegmentChange = void 0;
    this.discontinuity = discontinuity;
    this.contiguous = contiguous;
    this.accurateTimeOffset = accurateTimeOffset;
    this.trackSwitch = trackSwitch;
    this.timeOffset = timeOffset;
    this.initSegmentChange = initSegmentChange;
  }
}

var eventemitter3 = {exports: {}};

(function (module) {

	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';

	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}

	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);

	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}

	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}

	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }

	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;

	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];

	  return emitter;
	}

	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}

	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}

	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;

	  if (this._eventsCount === 0) return names;

	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }

	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }

	  return names;
	};

	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];

	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];

	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }

	  return ee;
	};

	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];

	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};

	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return false;

	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;

	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }

	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }

	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;

	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }

	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }

	  return true;
	};

	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};

	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};

	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }

	  var listeners = this._events[evt];

	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }

	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }

	  return this;
	};

	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;

	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }

	  return this;
	};

	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;

	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;

	//
	// Expose the module.
	//
	{
	  module.exports = EventEmitter;
	} 
} (eventemitter3));

var eventemitter3Exports = eventemitter3.exports;
var EventEmitter = /*@__PURE__*/getDefaultExportFromCjs(eventemitter3Exports);

const MediaSource$1 = getMediaSource() || {
  isTypeSupported: () => false
};
class TransmuxerInterface {
  constructor(hls, id, onTransmuxComplete, onFlush) {
    this.error = null;
    this.hls = void 0;
    this.id = void 0;
    this.observer = void 0;
    this.frag = null;
    this.part = null;
    this.useWorker = void 0;
    this.workerContext = null;
    this.onwmsg = void 0;
    this.transmuxer = null;
    this.onTransmuxComplete = void 0;
    this.onFlush = void 0;
    const config = hls.config;
    this.hls = hls;
    this.id = id;
    this.useWorker = !!config.enableWorker;
    this.onTransmuxComplete = onTransmuxComplete;
    this.onFlush = onFlush;
    const forwardMessage = (ev, data) => {
      data = data || {};
      data.frag = this.frag;
      data.id = this.id;
      if (ev === Events.ERROR) {
        this.error = data.error;
      }
      this.hls.trigger(ev, data);
    };

    // forward events to main thread
    this.observer = new EventEmitter();
    this.observer.on(Events.FRAG_DECRYPTED, forwardMessage);
    this.observer.on(Events.ERROR, forwardMessage);
    const typeSupported = {
      mp4: MediaSource$1.isTypeSupported('video/mp4'),
      mpeg: MediaSource$1.isTypeSupported('audio/mpeg'),
      mp3: MediaSource$1.isTypeSupported('audio/mp4; codecs="mp3"')
    };
    // navigator.vendor is not always available in Web Worker
    // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
    const vendor = navigator.vendor;
    if (this.useWorker && typeof Worker !== 'undefined') {
      const canCreateWorker = config.workerPath || hasUMDWorker();
      if (canCreateWorker) {
        try {
          if (config.workerPath) {
            logger.log(`loading Web Worker ${config.workerPath} for "${id}"`);
            this.workerContext = loadWorker(config.workerPath);
          } else {
            logger.log(`injecting Web Worker for "${id}"`);
            this.workerContext = injectWorker();
          }
          this.onwmsg = ev => this.onWorkerMessage(ev);
          const {
            worker
          } = this.workerContext;
          worker.addEventListener('message', this.onwmsg);
          worker.onerror = event => {
            const error = new Error(`${event.message}  (${event.filename}:${event.lineno})`);
            config.enableWorker = false;
            logger.warn(`Error in "${id}" Web Worker, fallback to inline`);
            this.hls.trigger(Events.ERROR, {
              type: ErrorTypes.OTHER_ERROR,
              details: ErrorDetails.INTERNAL_EXCEPTION,
              fatal: false,
              event: 'demuxerWorker',
              error
            });
          };
          worker.postMessage({
            cmd: 'init',
            typeSupported: typeSupported,
            vendor: vendor,
            id: id,
            config: JSON.stringify(config)
          });
        } catch (err) {
          logger.warn(`Error setting up "${id}" Web Worker, fallback to inline`, err);
          this.resetWorker();
          this.error = null;
          this.transmuxer = new Transmuxer(this.observer, typeSupported, config, vendor, id);
        }
        return;
      }
    }
    this.transmuxer = new Transmuxer(this.observer, typeSupported, config, vendor, id);
  }
  resetWorker() {
    if (this.workerContext) {
      const {
        worker,
        objectURL
      } = this.workerContext;
      if (objectURL) {
        // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
        self.URL.revokeObjectURL(objectURL);
      }
      worker.removeEventListener('message', this.onwmsg);
      worker.onerror = null;
      worker.terminate();
      this.workerContext = null;
    }
  }
  destroy() {
    if (this.workerContext) {
      this.resetWorker();
      this.onwmsg = undefined;
    } else {
      const transmuxer = this.transmuxer;
      if (transmuxer) {
        transmuxer.destroy();
        this.transmuxer = null;
      }
    }
    const observer = this.observer;
    if (observer) {
      observer.removeAllListeners();
    }
    this.frag = null;
    // @ts-ignore
    this.observer = null;
    // @ts-ignore
    this.hls = null;
  }
  push(data, initSegmentData, audioCodec, videoCodec, frag, part, duration, accurateTimeOffset, chunkMeta, defaultInitPTS) {
    var _frag$initSegment, _lastFrag$initSegment;
    chunkMeta.transmuxing.start = self.performance.now();
    const {
      transmuxer
    } = this;
    const timeOffset = part ? part.start : frag.start;
    // TODO: push "clear-lead" decrypt data for unencrypted fragments in streams with encrypted ones
    const decryptdata = frag.decryptdata;
    const lastFrag = this.frag;
    const discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
    const trackSwitch = !(lastFrag && chunkMeta.level === lastFrag.level);
    const snDiff = lastFrag ? chunkMeta.sn - lastFrag.sn : -1;
    const partDiff = this.part ? chunkMeta.part - this.part.index : -1;
    const progressive = snDiff === 0 && chunkMeta.id > 1 && chunkMeta.id === (lastFrag == null ? void 0 : lastFrag.stats.chunkCount);
    const contiguous = !trackSwitch && (snDiff === 1 || snDiff === 0 && (partDiff === 1 || progressive && partDiff <= 0));
    const now = self.performance.now();
    if (trackSwitch || snDiff || frag.stats.parsing.start === 0) {
      frag.stats.parsing.start = now;
    }
    if (part && (partDiff || !contiguous)) {
      part.stats.parsing.start = now;
    }
    const initSegmentChange = !(lastFrag && ((_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.url) === ((_lastFrag$initSegment = lastFrag.initSegment) == null ? void 0 : _lastFrag$initSegment.url));
    const state = new TransmuxState(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange);
    if (!contiguous || discontinuity || initSegmentChange) {
      logger.log(`[transmuxer-interface, ${frag.type}]: Starting new transmux session for sn: ${chunkMeta.sn} p: ${chunkMeta.part} level: ${chunkMeta.level} id: ${chunkMeta.id}
        discontinuity: ${discontinuity}
        trackSwitch: ${trackSwitch}
        contiguous: ${contiguous}
        accurateTimeOffset: ${accurateTimeOffset}
        timeOffset: ${timeOffset}
        initSegmentChange: ${initSegmentChange}`);
      const config = new TransmuxConfig(audioCodec, videoCodec, initSegmentData, duration, defaultInitPTS);
      this.configureTransmuxer(config);
    }
    this.frag = frag;
    this.part = part;

    // Frags with sn of 'initSegment' are not transmuxed
    if (this.workerContext) {
      // post fragment payload as transferable objects for ArrayBuffer (no copy)
      this.workerContext.worker.postMessage({
        cmd: 'demux',
        data,
        decryptdata,
        chunkMeta,
        state
      }, data instanceof ArrayBuffer ? [data] : []);
    } else if (transmuxer) {
      const transmuxResult = transmuxer.push(data, decryptdata, chunkMeta, state);
      if (isPromise(transmuxResult)) {
        transmuxer.async = true;
        transmuxResult.then(data => {
          this.handleTransmuxComplete(data);
        }).catch(error => {
          this.transmuxerError(error, chunkMeta, 'transmuxer-interface push error');
        });
      } else {
        transmuxer.async = false;
        this.handleTransmuxComplete(transmuxResult);
      }
    }
  }
  flush(chunkMeta) {
    chunkMeta.transmuxing.start = self.performance.now();
    const {
      transmuxer
    } = this;
    if (this.workerContext) {
      this.workerContext.worker.postMessage({
        cmd: 'flush',
        chunkMeta
      });
    } else if (transmuxer) {
      let transmuxResult = transmuxer.flush(chunkMeta);
      const asyncFlush = isPromise(transmuxResult);
      if (asyncFlush || transmuxer.async) {
        if (!isPromise(transmuxResult)) {
          transmuxResult = Promise.resolve(transmuxResult);
        }
        transmuxResult.then(data => {
          this.handleFlushResult(data, chunkMeta);
        }).catch(error => {
          this.transmuxerError(error, chunkMeta, 'transmuxer-interface flush error');
        });
      } else {
        this.handleFlushResult(transmuxResult, chunkMeta);
      }
    }
  }
  transmuxerError(error, chunkMeta, reason) {
    if (!this.hls) {
      return;
    }
    this.error = error;
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.FRAG_PARSING_ERROR,
      chunkMeta,
      fatal: false,
      error,
      err: error,
      reason
    });
  }
  handleFlushResult(results, chunkMeta) {
    results.forEach(result => {
      this.handleTransmuxComplete(result);
    });
    this.onFlush(chunkMeta);
  }
  onWorkerMessage(ev) {
    const data = ev.data;
    const hls = this.hls;
    switch (data.event) {
      case 'init':
        {
          var _this$workerContext;
          const objectURL = (_this$workerContext = this.workerContext) == null ? void 0 : _this$workerContext.objectURL;
          if (objectURL) {
            // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
            self.URL.revokeObjectURL(objectURL);
          }
          break;
        }
      case 'transmuxComplete':
        {
          this.handleTransmuxComplete(data.data);
          break;
        }
      case 'flush':
        {
          this.onFlush(data.data);
          break;
        }

      // pass logs from the worker thread to the main logger
      case 'workerLog':
        if (logger[data.data.logType]) {
          logger[data.data.logType](data.data.message);
        }
        break;
      default:
        {
          data.data = data.data || {};
          data.data.frag = this.frag;
          data.data.id = this.id;
          hls.trigger(data.event, data.data);
          break;
        }
    }
  }
  configureTransmuxer(config) {
    const {
      transmuxer
    } = this;
    if (this.workerContext) {
      this.workerContext.worker.postMessage({
        cmd: 'configure',
        config
      });
    } else if (transmuxer) {
      transmuxer.configure(config);
    }
  }
  handleTransmuxComplete(result) {
    result.chunkMeta.transmuxing.end = self.performance.now();
    this.onTransmuxComplete(result);
  }
}

const STALL_MINIMUM_DURATION_MS = 250;
const MAX_START_GAP_JUMP = 2.0;
const SKIP_BUFFER_HOLE_STEP_SECONDS = 0.1;
const SKIP_BUFFER_RANGE_START = 0.05;
class GapController {
  constructor(config, media, fragmentTracker, hls) {
    this.config = void 0;
    this.media = null;
    this.fragmentTracker = void 0;
    this.hls = void 0;
    this.nudgeRetry = 0;
    this.stallReported = false;
    this.stalled = null;
    this.moved = false;
    this.seeking = false;
    this.config = config;
    this.media = media;
    this.fragmentTracker = fragmentTracker;
    this.hls = hls;
  }
  destroy() {
    this.media = null;
    // @ts-ignore
    this.hls = this.fragmentTracker = null;
  }

  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(lastCurrentTime, activeFrag) {
    const {
      config,
      media,
      stalled
    } = this;
    if (media === null) {
      return;
    }
    const {
      currentTime,
      seeking
    } = media;
    const seeked = this.seeking && !seeking;
    const beginSeek = !this.seeking && seeking;
    this.seeking = seeking;

    // The playhead is moving, no-op
    if (currentTime !== lastCurrentTime) {
      this.moved = true;
      if (stalled !== null) {
        // The playhead is now moving, but was previously stalled
        if (this.stallReported) {
          const _stalledDuration = self.performance.now() - stalled;
          logger.warn(`playback not stuck anymore @${currentTime}, after ${Math.round(_stalledDuration)}ms`);
          this.stallReported = false;
        }
        this.stalled = null;
        this.nudgeRetry = 0;
      }
      return;
    }

    // Clear stalled state when beginning or finishing seeking so that we don't report stalls coming out of a seek
    if (beginSeek || seeked) {
      this.stalled = null;
      return;
    }

    // The playhead should not be moving
    if (media.paused && !seeking || media.ended || media.playbackRate === 0 || !BufferHelper.getBuffered(media).length) {
      return;
    }
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const isBuffered = bufferInfo.len > 0;
    const nextStart = bufferInfo.nextStart || 0;

    // There is no playable buffer (seeked, waiting for buffer)
    if (!isBuffered && !nextStart) {
      return;
    }
    if (seeking) {
      // Waiting for seeking in a buffered range to complete
      const hasEnoughBuffer = bufferInfo.len > MAX_START_GAP_JUMP;
      // Next buffered range is too far ahead to jump to while still seeking
      const noBufferGap = !nextStart || activeFrag && activeFrag.start <= currentTime || nextStart - currentTime > MAX_START_GAP_JUMP && !this.fragmentTracker.getPartialFragment(currentTime);
      if (hasEnoughBuffer || noBufferGap) {
        return;
      }
      // Reset moved state when seeking to a point in or before a gap
      this.moved = false;
    }

    // Skip start gaps if we haven't played, but the last poll detected the start of a stall
    // The addition poll gives the browser a chance to jump the gap for us
    if (!this.moved && this.stalled !== null) {
      var _level$details;
      // Jump start gaps within jump threshold
      const startJump = Math.max(nextStart, bufferInfo.start || 0) - currentTime;

      // When joining a live stream with audio tracks, account for live playlist window sliding by allowing
      // a larger jump over start gaps caused by the audio-stream-controller buffering a start fragment
      // that begins over 1 target duration after the video start position.
      const level = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null;
      const isLive = level == null ? void 0 : (_level$details = level.details) == null ? void 0 : _level$details.live;
      const maxStartGapJump = isLive ? level.details.targetduration * 2 : MAX_START_GAP_JUMP;
      const partialOrGap = this.fragmentTracker.getPartialFragment(currentTime);
      if (startJump > 0 && (startJump <= maxStartGapJump || partialOrGap)) {
        this._trySkipBufferHole(partialOrGap);
        return;
      }
    }

    // Start tracking stall time
    const tnow = self.performance.now();
    if (stalled === null) {
      this.stalled = tnow;
      return;
    }
    const stalledDuration = tnow - stalled;
    if (!seeking && stalledDuration >= STALL_MINIMUM_DURATION_MS) {
      // Report stalling after trying to fix
      this._reportStall(bufferInfo);
      if (!this.media) {
        return;
      }
    }
    const bufferedWithHoles = BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
    this._tryFixBufferStall(bufferedWithHoles, stalledDuration);
  }

  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(bufferInfo, stalledDurationMs) {
    const {
      config,
      fragmentTracker,
      media
    } = this;
    if (media === null) {
      return;
    }
    const currentTime = media.currentTime;
    const partial = fragmentTracker.getPartialFragment(currentTime);
    if (partial) {
      // Try to skip over the buffer hole caused by a partial fragment
      // This method isn't limited by the size of the gap between buffered ranges
      const targetTime = this._trySkipBufferHole(partial);
      // we return here in this case, meaning
      // the branch below only executes when we haven't seeked to a new position
      if (targetTime || !this.media) {
        return;
      }
    }

    // if we haven't had to skip over a buffer hole of a partial fragment
    // we may just have to "nudge" the playlist as the browser decoding/rendering engine
    // needs to cross some sort of threshold covering all source-buffers content
    // to start playing properly.
    if ((bufferInfo.len > config.maxBufferHole || bufferInfo.nextStart && bufferInfo.nextStart - currentTime < config.maxBufferHole) && stalledDurationMs > config.highBufferWatchdogPeriod * 1000) {
      logger.warn('Trying to nudge playhead over buffer-hole');
      // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
      // We only try to jump the hole if it's under the configured size
      // Reset stalled so to rearm watchdog timer
      this.stalled = null;
      this._tryNudgeBuffer();
    }
  }

  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(bufferInfo) {
    const {
      hls,
      media,
      stallReported
    } = this;
    if (!stallReported && media) {
      // Report stalled error once
      this.stallReported = true;
      const error = new Error(`Playback stalling at @${media.currentTime} due to low buffer (${JSON.stringify(bufferInfo)})`);
      logger.warn(error.message);
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_STALLED_ERROR,
        fatal: false,
        error,
        buffer: bufferInfo.len
      });
    }
  }

  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(partial) {
    const {
      config,
      hls,
      media
    } = this;
    if (media === null) {
      return 0;
    }

    // Check if currentTime is between unbuffered regions of partial fragments
    const currentTime = media.currentTime;
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const startTime = currentTime < bufferInfo.start ? bufferInfo.start : bufferInfo.nextStart;
    if (startTime) {
      const bufferStarved = bufferInfo.len <= config.maxBufferHole;
      const waiting = bufferInfo.len > 0 && bufferInfo.len < 1 && media.readyState < 3;
      const gapLength = startTime - currentTime;
      if (gapLength > 0 && (bufferStarved || waiting)) {
        // Only allow large gaps to be skipped if it is a start gap, or all fragments in skip range are partial
        if (gapLength > config.maxBufferHole) {
          const {
            fragmentTracker
          } = this;
          let startGap = false;
          if (currentTime === 0) {
            const startFrag = fragmentTracker.getAppendedFrag(0, PlaylistLevelType.MAIN);
            if (startFrag && startTime < startFrag.end) {
              startGap = true;
            }
          }
          if (!startGap) {
            const startProvisioned = partial || fragmentTracker.getAppendedFrag(currentTime, PlaylistLevelType.MAIN);
            if (startProvisioned) {
              let moreToLoad = false;
              let pos = startProvisioned.end;
              while (pos < startTime) {
                const provisioned = fragmentTracker.getPartialFragment(pos);
                if (provisioned) {
                  pos += provisioned.duration;
                } else {
                  moreToLoad = true;
                  break;
                }
              }
              if (moreToLoad) {
                return 0;
              }
            }
          }
        }
        const targetTime = Math.max(startTime + SKIP_BUFFER_RANGE_START, currentTime + SKIP_BUFFER_HOLE_STEP_SECONDS);
        logger.warn(`skipping hole, adjusting currentTime from ${currentTime} to ${targetTime}`);
        this.moved = true;
        this.stalled = null;
        media.currentTime = targetTime;
        if (partial && !partial.gap) {
          const error = new Error(`fragment loaded with buffer holes, seeking from ${currentTime} to ${targetTime}`);
          hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.BUFFER_SEEK_OVER_HOLE,
            fatal: false,
            error,
            reason: error.message,
            frag: partial
          });
        }
        return targetTime;
      }
    }
    return 0;
  }

  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer() {
    const {
      config,
      hls,
      media,
      nudgeRetry
    } = this;
    if (media === null) {
      return;
    }
    const currentTime = media.currentTime;
    this.nudgeRetry++;
    if (nudgeRetry < config.nudgeMaxRetry) {
      const targetTime = currentTime + (nudgeRetry + 1) * config.nudgeOffset;
      // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
      const error = new Error(`Nudging 'currentTime' from ${currentTime} to ${targetTime}`);
      logger.warn(error.message);
      media.currentTime = targetTime;
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_NUDGE_ON_STALL,
        error,
        fatal: false
      });
    } else {
      const error = new Error(`Playhead still not moving while enough data buffered @${currentTime} after ${config.nudgeMaxRetry} nudges`);
      logger.error(error.message);
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_STALLED_ERROR,
        error,
        fatal: true
      });
    }
  }
}

const TICK_INTERVAL$2 = 100; // how often to tick in ms

class StreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, '[stream-controller]', PlaylistLevelType.MAIN);
    this.audioCodecSwap = false;
    this.gapController = null;
    this.level = -1;
    this._forceStartLoad = false;
    this.altAudio = false;
    this.audioOnly = false;
    this.fragPlaying = null;
    this.onvplaying = null;
    this.onvseeked = null;
    this.fragLastKbps = 0;
    this.couldBacktrack = false;
    this.backtrackFragment = null;
    this.audioCodecSwitch = false;
    this.videoBuffer = null;
    this._registerListeners();
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.on(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.off(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this._unregisterListeners();
    this.onMediaDetaching();
  }
  startLoad(startPosition) {
    if (this.levels) {
      const {
        lastCurrentTime,
        hls
      } = this;
      this.stopLoad();
      this.setInterval(TICK_INTERVAL$2);
      this.level = -1;
      if (!this.startFragRequested) {
        // determine load level
        let startLevel = hls.startLevel;
        if (startLevel === -1) {
          if (hls.config.testBandwidth && this.levels.length > 1) {
            // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
            startLevel = 0;
            this.bitrateTest = true;
          } else {
            startLevel = hls.nextAutoLevel;
          }
        }
        // set new level to playlist loader : this will trigger start level load
        // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
        this.level = hls.nextLoadLevel = startLevel;
        this.loadedmetadata = false;
      }
      // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
      if (lastCurrentTime > 0 && startPosition === -1) {
        this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
        startPosition = lastCurrentTime;
      }
      this.state = State.IDLE;
      this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
      this.tick();
    } else {
      this._forceStartLoad = true;
      this.state = State.STOPPED;
    }
  }
  stopLoad() {
    this._forceStartLoad = false;
    super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case State.WAITING_LEVEL:
        {
          var _levels$level;
          const {
            levels,
            level
          } = this;
          const details = levels == null ? void 0 : (_levels$level = levels[level]) == null ? void 0 : _levels$level.details;
          if (details && (!details.live || this.levelLastLoaded === this.level)) {
            if (this.waitForCdnTuneIn(details)) {
              break;
            }
            this.state = State.IDLE;
            break;
          } else if (this.hls.nextLoadLevel !== this.level) {
            this.state = State.IDLE;
            break;
          }
          break;
        }
      case State.FRAG_LOADING_WAITING_RETRY:
        {
          var _this$media;
          const now = self.performance.now();
          const retryDate = this.retryDate;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
            this.resetStartWhenNotLoaded(this.level);
            this.state = State.IDLE;
          }
        }
        break;
    }
    if (this.state === State.IDLE) {
      this.doTickIdle();
    }
    this.onTickEnd();
  }
  onTickEnd() {
    super.onTickEnd();
    this.checkBuffer();
    this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls,
      levelLastLoaded,
      levels,
      media
    } = this;
    const {
      config,
      nextLoadLevel: level
    } = hls;

    // if start level not parsed yet OR
    // if video not attached AND start fragment already requested OR start frag prefetch not enabled
    // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
    if (levelLastLoaded === null || !media && (this.startFragRequested || !config.startFragPrefetch)) {
      return;
    }

    // If the "main" level is audio-only but we are loading an alternate track in the same group, do not load anything
    if (this.altAudio && this.audioOnly) {
      return;
    }
    if (!(levels != null && levels[level])) {
      return;
    }
    const levelInfo = levels[level];

    // if buffer length is less than maxBufLen try to load a new fragment

    const bufferInfo = this.getMainFwdBufferInfo();
    if (bufferInfo === null) {
      return;
    }
    const lastDetails = this.getLevelDetails();
    if (lastDetails && this._streamEnded(bufferInfo, lastDetails)) {
      const data = {};
      if (this.altAudio) {
        data.type = 'video';
      }
      this.hls.trigger(Events.BUFFER_EOS, data);
      this.state = State.ENDED;
      return;
    }

    // set next load level : this will trigger a playlist load if needed
    if (hls.loadLevel !== level && hls.manualLevel === -1) {
      this.log(`Adapting to level ${level} from level ${this.level}`);
    }
    this.level = hls.nextLoadLevel = level;
    const levelDetails = levelInfo.details;
    // if level info not retrieved yet, switch state and wait for level retrieval
    // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
    // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
    if (!levelDetails || this.state === State.WAITING_LEVEL || levelDetails.live && this.levelLastLoaded !== level) {
      this.level = level;
      this.state = State.WAITING_LEVEL;
      return;
    }
    const bufferLen = bufferInfo.len;

    // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
    const maxBufLen = this.getMaxBufferLength(levelInfo.maxBitrate);

    // Stay idle if we are still with buffer margins
    if (bufferLen >= maxBufLen) {
      return;
    }
    if (this.backtrackFragment && this.backtrackFragment.start > bufferInfo.end) {
      this.backtrackFragment = null;
    }
    const targetBufferTime = this.backtrackFragment ? this.backtrackFragment.start : bufferInfo.end;
    let frag = this.getNextFragment(targetBufferTime, levelDetails);
    // Avoid backtracking by loading an earlier segment in streams with segments that do not start with a key frame (flagged by `couldBacktrack`)
    if (this.couldBacktrack && !this.fragPrevious && frag && frag.sn !== 'initSegment' && this.fragmentTracker.getState(frag) !== FragmentState.OK) {
      var _this$backtrackFragme;
      const backtrackSn = ((_this$backtrackFragme = this.backtrackFragment) != null ? _this$backtrackFragme : frag).sn;
      const fragIdx = backtrackSn - levelDetails.startSN;
      const backtrackFrag = levelDetails.fragments[fragIdx - 1];
      if (backtrackFrag && frag.cc === backtrackFrag.cc) {
        frag = backtrackFrag;
        this.fragmentTracker.removeFragment(backtrackFrag);
      }
    } else if (this.backtrackFragment && bufferInfo.len) {
      this.backtrackFragment = null;
    }
    // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
    if (frag && this.isLoopLoading(frag, targetBufferTime)) {
      const gapStart = frag.gap;
      if (!gapStart) {
        // Cleanup the fragment tracker before trying to find the next unbuffered fragment
        const type = this.audioOnly && !this.altAudio ? ElementaryStreamTypes.AUDIO : ElementaryStreamTypes.VIDEO;
        const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        if (mediaBuffer) {
          this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
        }
      }
      frag = this.getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
    }
    if (!frag) {
      return;
    }
    if (frag.initSegment && !frag.initSegment.data && !this.bitrateTest) {
      frag = frag.initSegment;
    }
    this.loadFragment(frag, levelInfo, targetBufferTime);
  }
  loadFragment(frag, level, targetBufferTime) {
    // Check if fragment is not loaded
    const fragState = this.fragmentTracker.getState(frag);
    this.fragCurrent = frag;
    if (fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
      if (frag.sn === 'initSegment') {
        this._loadInitSegment(frag, level);
      } else if (this.bitrateTest) {
        this.log(`Fragment ${frag.sn} of level ${frag.level} is being downloaded to test bitrate and will not be buffered`);
        this._loadBitrateTestFrag(frag, level);
      } else {
        this.startFragRequested = true;
        super.loadFragment(frag, level, targetBufferTime);
      }
    } else {
      this.clearTrackerIfNeeded(frag);
    }
  }
  getBufferedFrag(position) {
    return this.fragmentTracker.getBufferedFrag(position, PlaylistLevelType.MAIN);
  }
  followingBufferedFrag(frag) {
    if (frag) {
      // try to get range of next fragment (500ms after this range)
      return this.getBufferedFrag(frag.end + 0.5);
    }
    return null;
  }

  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag();
    this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }

  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels,
      media
    } = this;
    // ensure that media is defined and that metadata are available (to retrieve currentTime)
    if (media != null && media.readyState) {
      let fetchdelay;
      const fragPlayingCurrent = this.getAppendedFrag(media.currentTime);
      if (fragPlayingCurrent && fragPlayingCurrent.start > 1) {
        // flush buffer preceding current fragment (flush until current fragment start offset)
        // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
        this.flushMainBuffer(0, fragPlayingCurrent.start - 1);
      }
      const levelDetails = this.getLevelDetails();
      if (levelDetails != null && levelDetails.live) {
        const bufferInfo = this.getMainFwdBufferInfo();
        // Do not flush in live stream with low buffer
        if (!bufferInfo || bufferInfo.len < levelDetails.targetduration * 2) {
          return;
        }
      }
      if (!media.paused && levels) {
        // add a safety delay of 1s
        const nextLevelId = this.hls.nextLoadLevel;
        const nextLevel = levels[nextLevelId];
        const fragLastKbps = this.fragLastKbps;
        if (fragLastKbps && this.fragCurrent) {
          fetchdelay = this.fragCurrent.duration * nextLevel.maxBitrate / (1000 * fragLastKbps) + 1;
        } else {
          fetchdelay = 0;
        }
      } else {
        fetchdelay = 0;
      }
      // this.log('fetchdelay:'+fetchdelay);
      // find buffer range that will be reached once new fragment will be fetched
      const bufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
      if (bufferedFrag) {
        // we can flush buffer range following this one without stalling playback
        const nextBufferedFrag = this.followingBufferedFrag(bufferedFrag);
        if (nextBufferedFrag) {
          // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
          this.abortCurrentFrag();
          // start flush position is in next buffered frag. Leave some padding for non-independent segments and smoother playback.
          const maxStart = nextBufferedFrag.maxStartPTS ? nextBufferedFrag.maxStartPTS : nextBufferedFrag.start;
          const fragDuration = nextBufferedFrag.duration;
          const startPts = Math.max(bufferedFrag.end, maxStart + Math.min(Math.max(fragDuration - this.config.maxFragLookUpTolerance, fragDuration * 0.5), fragDuration * 0.75));
          this.flushMainBuffer(startPts, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const fragCurrent = this.fragCurrent;
    this.fragCurrent = null;
    this.backtrackFragment = null;
    if (fragCurrent) {
      fragCurrent.abortRequests();
      this.fragmentTracker.removeFragment(fragCurrent);
    }
    switch (this.state) {
      case State.KEY_LOADING:
      case State.FRAG_LOADING:
      case State.FRAG_LOADING_WAITING_RETRY:
      case State.PARSING:
      case State.PARSED:
        this.state = State.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(startOffset, endOffset) {
    super.flushMainBuffer(startOffset, endOffset, this.altAudio ? 'video' : null);
  }
  onMediaAttached(event, data) {
    super.onMediaAttached(event, data);
    const media = data.media;
    this.onvplaying = this.onMediaPlaying.bind(this);
    this.onvseeked = this.onMediaSeeked.bind(this);
    media.addEventListener('playing', this.onvplaying);
    media.addEventListener('seeked', this.onvseeked);
    this.gapController = new GapController(this.config, media, this.fragmentTracker, this.hls);
  }
  onMediaDetaching() {
    const {
      media
    } = this;
    if (media && this.onvplaying && this.onvseeked) {
      media.removeEventListener('playing', this.onvplaying);
      media.removeEventListener('seeked', this.onvseeked);
      this.onvplaying = this.onvseeked = null;
      this.videoBuffer = null;
    }
    this.fragPlaying = null;
    if (this.gapController) {
      this.gapController.destroy();
      this.gapController = null;
    }
    super.onMediaDetaching();
  }
  onMediaPlaying() {
    // tick to speed up FRAG_CHANGED triggering
    this.tick();
  }
  onMediaSeeked() {
    const media = this.media;
    const currentTime = media ? media.currentTime : null;
    if (isFiniteNumber(currentTime)) {
      this.log(`Media seeked to ${currentTime.toFixed(3)}`);
    }

    // If seeked was issued before buffer was appended do not tick immediately
    const bufferInfo = this.getMainFwdBufferInfo();
    if (bufferInfo === null || bufferInfo.len === 0) {
      this.warn(`Main forward buffer length on "seeked" event ${bufferInfo ? bufferInfo.len : 'empty'})`);
      return;
    }

    // tick to speed up FRAG_CHANGED triggering
    this.tick();
  }
  onManifestLoading() {
    // reset buffer on manifest loading
    this.log('Trigger BUFFER_RESET');
    this.hls.trigger(Events.BUFFER_RESET, undefined);
    this.fragmentTracker.removeAllFragments();
    this.couldBacktrack = false;
    this.startPosition = this.lastCurrentTime = 0;
    this.levels = this.fragPlaying = this.backtrackFragment = null;
    this.altAudio = this.audioOnly = false;
  }
  onManifestParsed(event, data) {
    let aac = false;
    let heaac = false;
    let codec;
    data.levels.forEach(level => {
      // detect if we have different kind of audio codecs used amongst playlists
      codec = level.audioCodec;
      if (codec) {
        if (codec.indexOf('mp4a.40.2') !== -1) {
          aac = true;
        }
        if (codec.indexOf('mp4a.40.5') !== -1) {
          heaac = true;
        }
      }
    });
    this.audioCodecSwitch = aac && heaac && !changeTypeSupported();
    if (this.audioCodecSwitch) {
      this.log('Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
    }
    this.levels = data.levels;
    this.startFragRequested = false;
  }
  onLevelLoading(event, data) {
    const {
      levels
    } = this;
    if (!levels || this.state !== State.IDLE) {
      return;
    }
    const level = levels[data.level];
    if (!level.details || level.details.live && this.levelLastLoaded !== data.level || this.waitForCdnTuneIn(level.details)) {
      this.state = State.WAITING_LEVEL;
    }
  }
  onLevelLoaded(event, data) {
    var _curLevel$details;
    const {
      levels
    } = this;
    const newLevelId = data.level;
    const newDetails = data.details;
    const duration = newDetails.totalduration;
    if (!levels) {
      this.warn(`Levels were reset while loading level ${newLevelId}`);
      return;
    }
    this.log(`Level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''}, cc [${newDetails.startCC}, ${newDetails.endCC}] duration:${duration}`);
    const curLevel = levels[newLevelId];
    const fragCurrent = this.fragCurrent;
    if (fragCurrent && (this.state === State.FRAG_LOADING || this.state === State.FRAG_LOADING_WAITING_RETRY)) {
      if ((fragCurrent.level !== data.level || fragCurrent.urlId !== curLevel.urlId) && fragCurrent.loader) {
        this.abortCurrentFrag();
      }
    }
    let sliding = 0;
    if (newDetails.live || (_curLevel$details = curLevel.details) != null && _curLevel$details.live) {
      if (!newDetails.fragments[0]) {
        newDetails.deltaUpdateFailed = true;
      }
      if (newDetails.deltaUpdateFailed) {
        return;
      }
      sliding = this.alignPlaylists(newDetails, curLevel.details);
    }
    // override level info
    curLevel.details = newDetails;
    this.levelLastLoaded = newLevelId;
    this.hls.trigger(Events.LEVEL_UPDATED, {
      details: newDetails,
      level: newLevelId
    });

    // only switch back to IDLE state if we were waiting for level to start downloading a new fragment
    if (this.state === State.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(newDetails)) {
        // Wait for Low-Latency CDN Tune-in
        return;
      }
      this.state = State.IDLE;
    }
    if (!this.startFragRequested) {
      this.setStartPosition(newDetails, sliding);
    } else if (newDetails.live) {
      this.synchronizeToLiveEdge(newDetails);
    }

    // trigger handler right now
    this.tick();
  }
  _handleFragmentLoadProgress(data) {
    var _frag$initSegment;
    const {
      frag,
      part,
      payload
    } = data;
    const {
      levels
    } = this;
    if (!levels) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
      return;
    }
    const currentLevel = levels[frag.level];
    const details = currentLevel.details;
    if (!details) {
      this.warn(`Dropping fragment ${frag.sn} of level ${frag.level} after level details were reset`);
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    const videoCodec = currentLevel.videoCodec;

    // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
    const accurateTimeOffset = details.PTSKnown || !details.live;
    const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
    const audioCodec = this._getAudioCodec(currentLevel);

    // transmux the MPEG-TS data to ISO-BMFF segments
    // this.log(`Transmuxing ${frag.sn} of [${details.startSN} ,${details.endSN}],level ${frag.level}, cc ${frag.cc}`);
    const transmuxer = this.transmuxer = this.transmuxer || new TransmuxerInterface(this.hls, PlaylistLevelType.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
    const partIndex = part ? part.index : -1;
    const partial = partIndex !== -1;
    const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
    const initPTS = this.initPTS[frag.cc];
    transmuxer.push(payload, initSegmentData, audioCodec, videoCodec, frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
  }
  onAudioTrackSwitching(event, data) {
    // if any URL found on new audio track, it is an alternate audio track
    const fromAltAudio = this.altAudio;
    const altAudio = !!data.url;
    // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
    // don't do anything if we switch to alt audio: audio stream controller is handling it.
    // we will just have to change buffer scheduling on audioTrackSwitched
    if (!altAudio) {
      if (this.mediaBuffer !== this.media) {
        this.log('Switching on main audio, use media.buffered to schedule main fragment loading');
        this.mediaBuffer = this.media;
        const fragCurrent = this.fragCurrent;
        // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
        if (fragCurrent) {
          this.log('Switching to main audio track, cancel main fragment load');
          fragCurrent.abortRequests();
          this.fragmentTracker.removeFragment(fragCurrent);
        }
        // destroy transmuxer to force init segment generation (following audio switch)
        this.resetTransmuxer();
        // switch to IDLE state to load new fragment
        this.resetLoadingState();
      } else if (this.audioOnly) {
        // Reset audio transmuxer so when switching back to main audio we're not still appending where we left off
        this.resetTransmuxer();
      }
      const hls = this.hls;
      // If switching from alt to main audio, flush all audio and trigger track switched
      if (fromAltAudio) {
        hls.trigger(Events.BUFFER_FLUSHING, {
          startOffset: 0,
          endOffset: Number.POSITIVE_INFINITY,
          type: null
        });
        this.fragmentTracker.removeAllFragments();
      }
      hls.trigger(Events.AUDIO_TRACK_SWITCHED, data);
    }
  }
  onAudioTrackSwitched(event, data) {
    const trackId = data.id;
    const altAudio = !!this.hls.audioTracks[trackId].url;
    if (altAudio) {
      const videoBuffer = this.videoBuffer;
      // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
      if (videoBuffer && this.mediaBuffer !== videoBuffer) {
        this.log('Switching on alternate audio, use video.buffered to schedule main fragment loading');
        this.mediaBuffer = videoBuffer;
      }
    }
    this.altAudio = altAudio;
    this.tick();
  }
  onBufferCreated(event, data) {
    const tracks = data.tracks;
    let mediaTrack;
    let name;
    let alternate = false;
    for (const type in tracks) {
      const track = tracks[type];
      if (track.id === 'main') {
        name = type;
        mediaTrack = track;
        // keep video source buffer reference
        if (type === 'video') {
          const videoTrack = tracks[type];
          if (videoTrack) {
            this.videoBuffer = videoTrack.buffer;
          }
        }
      } else {
        alternate = true;
      }
    }
    if (alternate && mediaTrack) {
      this.log(`Alternate track found, use ${name}.buffered to schedule main fragment loading`);
      this.mediaBuffer = mediaTrack.buffer;
    } else {
      this.mediaBuffer = this.media;
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    if (frag && frag.type !== PlaylistLevelType.MAIN) {
      return;
    }
    if (this.fragContextChanged(frag)) {
      // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
      // Avoid setting state back to IDLE, since that will interfere with a level switch
      this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}`);
      if (this.state === State.PARSED) {
        this.state = State.IDLE;
      }
      return;
    }
    const stats = part ? part.stats : frag.stats;
    this.fragLastKbps = Math.round(8 * stats.total / (stats.buffering.end - stats.loading.first));
    if (frag.sn !== 'initSegment') {
      this.fragPrevious = frag;
    }
    this.fragBufferedComplete(frag, part);
  }
  onError(event, data) {
    var _data$context;
    if (data.fatal) {
      this.state = State.ERROR;
      return;
    }
    switch (data.details) {
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_PARSING_ERROR:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(PlaylistLevelType.MAIN, data);
        break;
      case ErrorDetails.LEVEL_LOAD_ERROR:
      case ErrorDetails.LEVEL_LOAD_TIMEOUT:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        // in case of non fatal error while loading level, if level controller is not retrying to load level, switch back to IDLE
        if (!data.levelRetry && this.state === State.WAITING_LEVEL && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.LEVEL) {
          this.state = State.IDLE;
        }
        break;
      case ErrorDetails.BUFFER_FULL_ERROR:
        if (!data.parent || data.parent !== 'main') {
          return;
        }
        if (this.reduceLengthAndFlushBuffer(data)) {
          this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        }
        break;
      case ErrorDetails.INTERNAL_EXCEPTION:
        this.recoverWorkerError(data);
        break;
    }
  }

  // Checks the health of the buffer and attempts to resolve playback stalls.
  checkBuffer() {
    const {
      media,
      gapController
    } = this;
    if (!media || !gapController || !media.readyState) {
      // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
      return;
    }
    if (this.loadedmetadata || !BufferHelper.getBuffered(media).length) {
      // Resolve gaps using the main buffer, whose ranges are the intersections of the A/V sourcebuffers
      const activeFrag = this.state !== State.IDLE ? this.fragCurrent : null;
      gapController.poll(this.lastCurrentTime, activeFrag);
    }
    this.lastCurrentTime = media.currentTime;
  }
  onFragLoadEmergencyAborted() {
    this.state = State.IDLE;
    // if loadedmetadata is not set, it means that we are emergency switch down on first frag
    // in that case, reset startFragRequested flag
    if (!this.loadedmetadata) {
      this.startFragRequested = false;
      this.nextLoadPosition = this.startPosition;
    }
    this.tickImmediate();
  }
  onBufferFlushed(event, {
    type
  }) {
    if (type !== ElementaryStreamTypes.AUDIO || this.audioOnly && !this.altAudio) {
      const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
    }
  }
  onLevelsUpdated(event, data) {
    this.levels = data.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }

  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media
    } = this;
    if (!media) {
      return;
    }
    const currentTime = media.currentTime;
    let startPosition = this.startPosition;
    // only adjust currentTime if different from startPosition or if startPosition not buffered
    // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
    if (startPosition >= 0 && currentTime < startPosition) {
      if (media.seeking) {
        this.log(`could not seek to ${startPosition}, already seeking at ${currentTime}`);
        return;
      }
      const buffered = BufferHelper.getBuffered(media);
      const bufferStart = buffered.length ? buffered.start(0) : 0;
      const delta = bufferStart - startPosition;
      if (delta > 0 && (delta < this.config.maxBufferHole || delta < this.config.maxFragLookUpTolerance)) {
        this.log(`adjusting start position by ${delta} to match buffer start`);
        startPosition += delta;
        this.startPosition = startPosition;
      }
      this.log(`seek to target start position ${startPosition} from current time ${currentTime}`);
      media.currentTime = startPosition;
    }
  }
  _getAudioCodec(currentLevel) {
    let audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
    if (this.audioCodecSwap && audioCodec) {
      this.log('Swapping audio codec');
      if (audioCodec.indexOf('mp4a.40.5') !== -1) {
        audioCodec = 'mp4a.40.2';
      } else {
        audioCodec = 'mp4a.40.5';
      }
    }
    return audioCodec;
  }
  _loadBitrateTestFrag(frag, level) {
    frag.bitrateTest = true;
    this._doFragLoad(frag, level).then(data => {
      const {
        hls
      } = this;
      if (!data || this.fragContextChanged(frag)) {
        return;
      }
      level.fragmentError = 0;
      this.state = State.IDLE;
      this.startFragRequested = false;
      this.bitrateTest = false;
      const stats = frag.stats;
      // Bitrate tests fragments are neither parsed nor buffered
      stats.parsing.start = stats.parsing.end = stats.buffering.start = stats.buffering.end = self.performance.now();
      hls.trigger(Events.FRAG_LOADED, data);
      frag.bitrateTest = false;
    });
  }
  _handleTransmuxComplete(transmuxResult) {
    var _id3$samples;
    const id = 'main';
    const {
      hls
    } = this;
    const {
      remuxResult,
      chunkMeta
    } = transmuxResult;
    const context = this.getCurrentContext(chunkMeta);
    if (!context) {
      this.resetWhenMissingContext(chunkMeta);
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const {
      video,
      text,
      id3,
      initSegment
    } = remuxResult;
    const {
      details
    } = level;
    // The audio-stream-controller handles audio buffering if Hls.js is playing an alternate audio track
    const audio = this.altAudio ? undefined : remuxResult.audio;

    // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
    // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
    if (this.fragContextChanged(frag)) {
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    this.state = State.PARSING;
    if (initSegment) {
      if (initSegment != null && initSegment.tracks) {
        const mapFragment = frag.initSegment || frag;
        this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
        hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
          frag: mapFragment,
          id,
          tracks: initSegment.tracks
        });
      }

      // This would be nice if Number.isFinite acted as a typeguard, but it doesn't. See: https://github.com/Microsoft/TypeScript/issues/10038
      const initPTS = initSegment.initPTS;
      const timescale = initSegment.timescale;
      if (isFiniteNumber(initPTS)) {
        this.initPTS[frag.cc] = {
          baseTime: initPTS,
          timescale
        };
        hls.trigger(Events.INIT_PTS_FOUND, {
          frag,
          id,
          initPTS,
          timescale
        });
      }
    }

    // Avoid buffering if backtracking this fragment
    if (video && details && frag.sn !== 'initSegment') {
      const prevFrag = details.fragments[frag.sn - 1 - details.startSN];
      const isFirstFragment = frag.sn === details.startSN;
      const isFirstInDiscontinuity = !prevFrag || frag.cc > prevFrag.cc;
      if (remuxResult.independent !== false) {
        const {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        } = video;
        if (part) {
          part.elementaryStreams[video.type] = {
            startPTS,
            endPTS,
            startDTS,
            endDTS
          };
        } else {
          if (video.firstKeyFrame && video.independent && chunkMeta.id === 1 && !isFirstInDiscontinuity) {
            this.couldBacktrack = true;
          }
          if (video.dropped && video.independent) {
            // Backtrack if dropped frames create a gap after currentTime

            const bufferInfo = this.getMainFwdBufferInfo();
            const targetBufferTime = (bufferInfo ? bufferInfo.end : this.getLoadPosition()) + this.config.maxBufferHole;
            const startTime = video.firstKeyFramePTS ? video.firstKeyFramePTS : startPTS;
            if (!isFirstFragment && targetBufferTime < startTime - this.config.maxBufferHole && !isFirstInDiscontinuity) {
              this.backtrack(frag);
              return;
            } else if (isFirstInDiscontinuity) {
              // Mark segment with a gap to avoid loop loading
              frag.gap = true;
            }
            // Set video stream start to fragment start so that truncated samples do not distort the timeline, and mark it partial
            frag.setElementaryStreamInfo(video.type, frag.start, endPTS, frag.start, endDTS, true);
          }
        }
        frag.setElementaryStreamInfo(video.type, startPTS, endPTS, startDTS, endDTS);
        if (this.backtrackFragment) {
          this.backtrackFragment = frag;
        }
        this.bufferFragmentData(video, frag, part, chunkMeta, isFirstFragment || isFirstInDiscontinuity);
      } else if (isFirstFragment || isFirstInDiscontinuity) {
        // Mark segment with a gap to avoid loop loading
        frag.gap = true;
      } else {
        this.backtrack(frag);
        return;
      }
    }
    if (audio) {
      const {
        startPTS,
        endPTS,
        startDTS,
        endDTS
      } = audio;
      if (part) {
        part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        };
      }
      frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
      this.bufferFragmentData(audio, frag, part, chunkMeta);
    }
    if (details && id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
      const emittedID3 = {
        id,
        frag,
        details,
        samples: id3.samples
      };
      hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
    }
    if (details && text) {
      const emittedText = {
        id,
        frag,
        details,
        samples: text.samples
      };
      hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
    }
  }
  _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
    if (this.state !== State.PARSING) {
      return;
    }
    this.audioOnly = !!tracks.audio && !tracks.video;

    // if audio track is expected to come from audio stream controller, discard any coming from main
    if (this.altAudio && !this.audioOnly) {
      delete tracks.audio;
    }
    // include levelCodec in audio and video tracks
    const {
      audio,
      video,
      audiovideo
    } = tracks;
    if (audio) {
      let audioCodec = currentLevel.audioCodec;
      const ua = navigator.userAgent.toLowerCase();
      if (this.audioCodecSwitch) {
        if (audioCodec) {
          if (audioCodec.indexOf('mp4a.40.5') !== -1) {
            audioCodec = 'mp4a.40.2';
          } else {
            audioCodec = 'mp4a.40.5';
          }
        }
        // In the case that AAC and HE-AAC audio codecs are signalled in manifest,
        // force HE-AAC, as it seems that most browsers prefers it.
        // don't force HE-AAC if mono stream, or in Firefox
        if (audio.metadata.channelCount !== 1 && ua.indexOf('firefox') === -1) {
          audioCodec = 'mp4a.40.5';
        }
      }
      // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
      if (ua.indexOf('android') !== -1 && audio.container !== 'audio/mpeg') {
        // Exclude mpeg audio
        audioCodec = 'mp4a.40.2';
        this.log(`Android: force audio codec to ${audioCodec}`);
      }
      if (currentLevel.audioCodec && currentLevel.audioCodec !== audioCodec) {
        this.log(`Swapping manifest audio codec "${currentLevel.audioCodec}" for "${audioCodec}"`);
      }
      audio.levelCodec = audioCodec;
      audio.id = 'main';
      this.log(`Init audio buffer, container:${audio.container}, codecs[selected/level/parsed]=[${audioCodec || ''}/${currentLevel.audioCodec || ''}/${audio.codec}]`);
    }
    if (video) {
      video.levelCodec = currentLevel.videoCodec;
      video.id = 'main';
      this.log(`Init video buffer, container:${video.container}, codecs[level/parsed]=[${currentLevel.videoCodec || ''}/${video.codec}]`);
    }
    if (audiovideo) {
      this.log(`Init audiovideo buffer, container:${audiovideo.container}, codecs[level/parsed]=[${currentLevel.attrs.CODECS || ''}/${audiovideo.codec}]`);
    }
    this.hls.trigger(Events.BUFFER_CODECS, tracks);
    // loop through tracks that are going to be provided to bufferController
    Object.keys(tracks).forEach(trackName => {
      const track = tracks[trackName];
      const initSegment = track.initSegment;
      if (initSegment != null && initSegment.byteLength) {
        this.hls.trigger(Events.BUFFER_APPENDING, {
          type: trackName,
          data: initSegment,
          frag,
          part: null,
          chunkMeta,
          parent: frag.type
        });
      }
    });
    // trigger handler right now
    this.tick();
  }
  getMainFwdBufferInfo() {
    return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, PlaylistLevelType.MAIN);
  }
  backtrack(frag) {
    this.couldBacktrack = true;
    // Causes findFragments to backtrack through fragments to find the keyframe
    this.backtrackFragment = frag;
    this.resetTransmuxer();
    this.flushBufferGap(frag);
    this.fragmentTracker.removeFragment(frag);
    this.fragPrevious = null;
    this.nextLoadPosition = frag.start;
    this.state = State.IDLE;
  }
  checkFragmentChanged() {
    const video = this.media;
    let fragPlayingCurrent = null;
    if (video && video.readyState > 1 && video.seeking === false) {
      const currentTime = video.currentTime;
      /* if video element is in seeked state, currentTime can only increase.
        (assuming that playback rate is positive ...)
        As sometimes currentTime jumps back to zero after a
        media decode error, check this, to avoid seeking back to
        wrong position after a media decode error
      */

      if (BufferHelper.isBuffered(video, currentTime)) {
        fragPlayingCurrent = this.getAppendedFrag(currentTime);
      } else if (BufferHelper.isBuffered(video, currentTime + 0.1)) {
        /* ensure that FRAG_CHANGED event is triggered at startup,
          when first video frame is displayed and playback is paused.
          add a tolerance of 100ms, in case current position is not buffered,
          check if current pos+100ms is buffered and use that buffer range
          for FRAG_CHANGED event reporting */
        fragPlayingCurrent = this.getAppendedFrag(currentTime + 0.1);
      }
      if (fragPlayingCurrent) {
        this.backtrackFragment = null;
        const fragPlaying = this.fragPlaying;
        const fragCurrentLevel = fragPlayingCurrent.level;
        if (!fragPlaying || fragPlayingCurrent.sn !== fragPlaying.sn || fragPlaying.level !== fragCurrentLevel || fragPlayingCurrent.urlId !== fragPlaying.urlId) {
          this.fragPlaying = fragPlayingCurrent;
          this.hls.trigger(Events.FRAG_CHANGED, {
            frag: fragPlayingCurrent
          });
          if (!fragPlaying || fragPlaying.level !== fragCurrentLevel) {
            this.hls.trigger(Events.LEVEL_SWITCHED, {
              level: fragCurrentLevel
            });
          }
        }
      }
    }
  }
  get nextLevel() {
    const frag = this.nextBufferedFrag;
    if (frag) {
      return frag.level;
    }
    return -1;
  }
  get currentFrag() {
    const media = this.media;
    if (media) {
      return this.fragPlaying || this.getAppendedFrag(media.currentTime);
    }
    return null;
  }
  get currentProgramDateTime() {
    const media = this.media;
    if (media) {
      const currentTime = media.currentTime;
      const frag = this.currentFrag;
      if (frag && isFiniteNumber(currentTime) && isFiniteNumber(frag.programDateTime)) {
        const epocMs = frag.programDateTime + (currentTime - frag.start) * 1000;
        return new Date(epocMs);
      }
    }
    return null;
  }
  get currentLevel() {
    const frag = this.currentFrag;
    if (frag) {
      return frag.level;
    }
    return -1;
  }
  get nextBufferedFrag() {
    const frag = this.currentFrag;
    if (frag) {
      return this.followingBufferedFrag(frag);
    }
    return null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}

/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */

class EWMA {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(halfLife, estimate = 0, weight = 0) {
    this.halfLife = void 0;
    this.alpha_ = void 0;
    this.estimate_ = void 0;
    this.totalWeight_ = void 0;
    this.halfLife = halfLife;
    // Larger values of alpha expire historical data more slowly.
    this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
    this.estimate_ = estimate;
    this.totalWeight_ = weight;
  }
  sample(weight, value) {
    const adjAlpha = Math.pow(this.alpha_, weight);
    this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
    this.totalWeight_ += weight;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (zeroFactor) {
        return this.estimate_ / zeroFactor;
      }
    }
    return this.estimate_;
  }
}

/*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */

class EwmaBandWidthEstimator {
  constructor(slow, fast, defaultEstimate, defaultTTFB = 100) {
    this.defaultEstimate_ = void 0;
    this.minWeight_ = void 0;
    this.minDelayMs_ = void 0;
    this.slow_ = void 0;
    this.fast_ = void 0;
    this.defaultTTFB_ = void 0;
    this.ttfb_ = void 0;
    this.defaultEstimate_ = defaultEstimate;
    this.minWeight_ = 0.001;
    this.minDelayMs_ = 50;
    this.slow_ = new EWMA(slow);
    this.fast_ = new EWMA(fast);
    this.defaultTTFB_ = defaultTTFB;
    this.ttfb_ = new EWMA(slow);
  }
  update(slow, fast) {
    const {
      slow_,
      fast_,
      ttfb_
    } = this;
    if (slow_.halfLife !== slow) {
      this.slow_ = new EWMA(slow, slow_.getEstimate(), slow_.getTotalWeight());
    }
    if (fast_.halfLife !== fast) {
      this.fast_ = new EWMA(fast, fast_.getEstimate(), fast_.getTotalWeight());
    }
    if (ttfb_.halfLife !== slow) {
      this.ttfb_ = new EWMA(slow, ttfb_.getEstimate(), ttfb_.getTotalWeight());
    }
  }
  sample(durationMs, numBytes) {
    durationMs = Math.max(durationMs, this.minDelayMs_);
    const numBits = 8 * numBytes;
    // weight is duration in seconds
    const durationS = durationMs / 1000;
    // value is bandwidth in bits/s
    const bandwidthInBps = numBits / durationS;
    this.fast_.sample(durationS, bandwidthInBps);
    this.slow_.sample(durationS, bandwidthInBps);
  }
  sampleTTFB(ttfb) {
    // weight is frequency curve applied to TTFB in seconds
    // (longer times have less weight with expected input under 1 second)
    const seconds = ttfb / 1000;
    const weight = Math.sqrt(2) * Math.exp(-Math.pow(seconds, 2) / 2);
    this.ttfb_.sample(weight, Math.max(ttfb, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    if (this.canEstimate()) {
      // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
      // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
      // Take the minimum of these two estimates.  This should have the effect of
      // adapting down quickly, but up more slowly.
      return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
    } else {
      return this.defaultEstimate_;
    }
  }
  getEstimateTTFB() {
    if (this.ttfb_.getTotalWeight() >= this.minWeight_) {
      return this.ttfb_.getEstimate();
    } else {
      return this.defaultTTFB_;
    }
  }
  destroy() {}
}

class AbrController {
  constructor(hls) {
    this.hls = void 0;
    this.lastLevelLoadSec = 0;
    this.lastLoadedFragLevel = 0;
    this._nextAutoLevel = -1;
    this.timer = -1;
    this.onCheck = this._abandonRulesCheck.bind(this);
    this.fragCurrent = null;
    this.partCurrent = null;
    this.bitrateTestDelay = 0;
    this.bwEstimator = void 0;
    this.hls = hls;
    const config = hls.config;
    this.bwEstimator = new EwmaBandWidthEstimator(config.abrEwmaSlowVoD, config.abrEwmaFastVoD, config.abrEwmaDefaultEstimate);
    this.registerListeners();
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
  }
  destroy() {
    this.unregisterListeners();
    this.clearTimer();
    // @ts-ignore
    this.hls = this.onCheck = null;
    this.fragCurrent = this.partCurrent = null;
  }
  onFragLoading(event, data) {
    var _data$part;
    const frag = data.frag;
    if (this.ignoreFragment(frag)) {
      return;
    }
    this.fragCurrent = frag;
    this.partCurrent = (_data$part = data.part) != null ? _data$part : null;
    this.clearTimer();
    this.timer = self.setInterval(this.onCheck, 100);
  }
  onLevelSwitching(event, data) {
    this.clearTimer();
  }
  getTimeToLoadFrag(timeToFirstByteSec, bandwidth, fragSizeBits, isSwitch) {
    const fragLoadSec = timeToFirstByteSec + fragSizeBits / bandwidth;
    const playlistLoadSec = isSwitch ? this.lastLevelLoadSec : 0;
    return fragLoadSec + playlistLoadSec;
  }
  onLevelLoaded(event, data) {
    const config = this.hls.config;
    const {
      total,
      bwEstimate
    } = data.stats;
    // Total is the bytelength and bwEstimate in bits/sec
    if (isFiniteNumber(total) && isFiniteNumber(bwEstimate)) {
      this.lastLevelLoadSec = 8 * total / bwEstimate;
    }
    if (data.details.live) {
      this.bwEstimator.update(config.abrEwmaSlowLive, config.abrEwmaFastLive);
    } else {
      this.bwEstimator.update(config.abrEwmaSlowVoD, config.abrEwmaFastVoD);
    }
  }

  /*
      This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
      quickly enough to prevent underbuffering
    */
  _abandonRulesCheck() {
    const {
      fragCurrent: frag,
      partCurrent: part,
      hls
    } = this;
    const {
      autoLevelEnabled,
      media
    } = hls;
    if (!frag || !media) {
      return;
    }
    const now = performance.now();
    const stats = part ? part.stats : frag.stats;
    const duration = part ? part.duration : frag.duration;
    const timeLoading = now - stats.loading.start;
    // If frag loading is aborted, complete, or from lowest level, stop timer and return
    if (stats.aborted || stats.loaded && stats.loaded === stats.total || frag.level === 0) {
      this.clearTimer();
      // reset forced auto level value so that next level will be selected
      this._nextAutoLevel = -1;
      return;
    }

    // This check only runs if we're in ABR mode and actually playing
    if (!autoLevelEnabled || media.paused || !media.playbackRate || !media.readyState) {
      return;
    }
    const bufferInfo = hls.mainForwardBufferInfo;
    if (bufferInfo === null) {
      return;
    }
    const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
    const playbackRate = Math.abs(media.playbackRate);
    // To maintain stable adaptive playback, only begin monitoring frag loading after half or more of its playback duration has passed
    if (timeLoading <= Math.max(ttfbEstimate, 1000 * (duration / (playbackRate * 2)))) {
      return;
    }

    // bufferStarvationDelay is an estimate of the amount time (in seconds) it will take to exhaust the buffer
    const bufferStarvationDelay = bufferInfo.len / playbackRate;
    // Only downswitch if less than 2 fragment lengths are buffered
    if (bufferStarvationDelay >= 2 * duration / playbackRate) {
      return;
    }
    const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
    const loadedFirstByte = stats.loaded && ttfb > -1;
    const bwEstimate = this.bwEstimator.getEstimate();
    const {
      levels,
      minAutoLevel
    } = hls;
    const level = levels[frag.level];
    const expectedLen = stats.total || Math.max(stats.loaded, Math.round(duration * level.maxBitrate / 8));
    let timeStreaming = timeLoading - ttfb;
    if (timeStreaming < 1 && loadedFirstByte) {
      timeStreaming = Math.min(timeLoading, stats.loaded * 8 / bwEstimate);
    }
    const loadRate = loadedFirstByte ? stats.loaded * 1000 / timeStreaming : 0;
    // fragLoadDelay is an estimate of the time (in seconds) it will take to buffer the remainder of the fragment
    const fragLoadedDelay = loadRate ? (expectedLen - stats.loaded) / loadRate : expectedLen * 8 / bwEstimate + ttfbEstimate / 1000;
    // Only downswitch if the time to finish loading the current fragment is greater than the amount of buffer left
    if (fragLoadedDelay <= bufferStarvationDelay) {
      return;
    }
    const bwe = loadRate ? loadRate * 8 : bwEstimate;
    let fragLevelNextLoadedDelay = Number.POSITIVE_INFINITY;
    let nextLoadLevel;
    // Iterate through lower level and try to find the largest one that avoids rebuffering
    for (nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
      // compute time to load next fragment at lower level
      // 8 = bits per byte (bps/Bps)
      const levelNextBitrate = levels[nextLoadLevel].maxBitrate;
      fragLevelNextLoadedDelay = this.getTimeToLoadFrag(ttfbEstimate / 1000, bwe, duration * levelNextBitrate, !levels[nextLoadLevel].details);
      if (fragLevelNextLoadedDelay < bufferStarvationDelay) {
        break;
      }
    }
    // Only emergency switch down if it takes less time to load a new fragment at lowest level instead of continuing
    // to load the current one
    if (fragLevelNextLoadedDelay >= fragLoadedDelay) {
      return;
    }

    // if estimated load time of new segment is completely unreasonable, ignore and do not emergency switch down
    if (fragLevelNextLoadedDelay > duration * 10) {
      return;
    }
    hls.nextLoadLevel = nextLoadLevel;
    if (loadedFirstByte) {
      // If there has been loading progress, sample bandwidth using loading time offset by minimum TTFB time
      this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
    } else {
      // If there has been no loading progress, sample TTFB
      this.bwEstimator.sampleTTFB(timeLoading);
    }
    this.clearTimer();
    logger.warn(`[abr] Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of level ${frag.level} is loading too slowly;
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s
      Estimated load time for current fragment: ${fragLoadedDelay.toFixed(3)} s
      Estimated load time for down switch fragment: ${fragLevelNextLoadedDelay.toFixed(3)} s
      TTFB estimate: ${ttfb}
      Current BW estimate: ${isFiniteNumber(bwEstimate) ? (bwEstimate / 1024).toFixed(3) : 'Unknown'} Kb/s
      New BW estimate: ${(this.bwEstimator.getEstimate() / 1024).toFixed(3)} Kb/s
      Aborting and switching to level ${nextLoadLevel}`);
    if (frag.loader) {
      this.fragCurrent = this.partCurrent = null;
      frag.abortRequests();
    }
    hls.trigger(Events.FRAG_LOAD_EMERGENCY_ABORTED, {
      frag,
      part,
      stats
    });
  }
  onFragLoaded(event, {
    frag,
    part
  }) {
    const stats = part ? part.stats : frag.stats;
    if (frag.type === PlaylistLevelType.MAIN) {
      this.bwEstimator.sampleTTFB(stats.loading.first - stats.loading.start);
    }
    if (this.ignoreFragment(frag)) {
      return;
    }
    // stop monitoring bw once frag loaded
    this.clearTimer();
    // store level id after successful fragment load
    this.lastLoadedFragLevel = frag.level;
    // reset forced auto level value so that next level will be selected
    this._nextAutoLevel = -1;

    // compute level average bitrate
    if (this.hls.config.abrMaxWithRealBitrate) {
      const duration = part ? part.duration : frag.duration;
      const level = this.hls.levels[frag.level];
      const loadedBytes = (level.loaded ? level.loaded.bytes : 0) + stats.loaded;
      const loadedDuration = (level.loaded ? level.loaded.duration : 0) + duration;
      level.loaded = {
        bytes: loadedBytes,
        duration: loadedDuration
      };
      level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
    }
    if (frag.bitrateTest) {
      const fragBufferedData = {
        stats,
        frag,
        part,
        id: frag.type
      };
      this.onFragBuffered(Events.FRAG_BUFFERED, fragBufferedData);
      frag.bitrateTest = false;
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    const stats = part != null && part.stats.loaded ? part.stats : frag.stats;
    if (stats.aborted) {
      return;
    }
    if (this.ignoreFragment(frag)) {
      return;
    }
    // Use the difference between parsing and request instead of buffering and request to compute fragLoadingProcessing;
    // rationale is that buffer appending only happens once media is attached. This can happen when config.startFragPrefetch
    // is used. If we used buffering in that case, our BW estimate sample will be very large.
    const processingMs = stats.parsing.end - stats.loading.start - Math.min(stats.loading.first - stats.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(processingMs, stats.loaded);
    stats.bwEstimate = this.bwEstimator.getEstimate();
    if (frag.bitrateTest) {
      this.bitrateTestDelay = processingMs / 1000;
    } else {
      this.bitrateTestDelay = 0;
    }
  }
  ignoreFragment(frag) {
    // Only count non-alt-audio frags which were actually buffered in our BW calculations
    return frag.type !== PlaylistLevelType.MAIN || frag.sn === 'initSegment';
  }
  clearTimer() {
    self.clearInterval(this.timer);
  }

  // return next auto level
  get nextAutoLevel() {
    const forcedAutoLevel = this._nextAutoLevel;
    const bwEstimator = this.bwEstimator;
    // in case next auto level has been forced, and bw not available or not reliable, return forced value
    if (forcedAutoLevel !== -1 && !bwEstimator.canEstimate()) {
      return forcedAutoLevel;
    }

    // compute next level using ABR logic
    let nextABRAutoLevel = this.getNextABRAutoLevel();
    // use forced auto level when ABR selected level has errored
    if (forcedAutoLevel !== -1) {
      const levels = this.hls.levels;
      if (levels.length > Math.max(forcedAutoLevel, nextABRAutoLevel) && levels[forcedAutoLevel].loadError <= levels[nextABRAutoLevel].loadError) {
        return forcedAutoLevel;
      }
    }
    // if forced auto level has been defined, use it to cap ABR computed quality level
    if (forcedAutoLevel !== -1) {
      nextABRAutoLevel = Math.min(forcedAutoLevel, nextABRAutoLevel);
    }
    return nextABRAutoLevel;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent,
      partCurrent,
      hls
    } = this;
    const {
      maxAutoLevel,
      config,
      minAutoLevel,
      media
    } = hls;
    const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;

    // playbackRate is the absolute value of the playback rate; if media.playbackRate is 0, we use 1 to load as
    // if we're playing back at the normal rate.
    const playbackRate = media && media.playbackRate !== 0 ? Math.abs(media.playbackRate) : 1.0;
    const avgbw = this.bwEstimator ? this.bwEstimator.getEstimate() : config.abrEwmaDefaultEstimate;
    // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
    const bufferInfo = hls.mainForwardBufferInfo;
    const bufferStarvationDelay = (bufferInfo ? bufferInfo.len : 0) / playbackRate;

    // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
    let bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, config.abrBandWidthFactor, config.abrBandWidthUpFactor);
    if (bestLevel >= 0) {
      return bestLevel;
    }
    logger.trace(`[abr] ${bufferStarvationDelay ? 'rebuffering expected' : 'buffer is empty'}, finding optimal quality level`);
    // not possible to get rid of rebuffering ... let's try to find level that will guarantee less than maxStarvationDelay of rebuffering
    // if no matching level found, logic will return 0
    let maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
    let bwFactor = config.abrBandWidthFactor;
    let bwUpFactor = config.abrBandWidthUpFactor;
    if (!bufferStarvationDelay) {
      // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
      const bitrateTestDelay = this.bitrateTestDelay;
      if (bitrateTestDelay) {
        // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
        // max video loading delay used in  automatic start level selection :
        // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
        // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
        // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
        const maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
        maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
        logger.trace(`[abr] bitrate test took ${Math.round(1000 * bitrateTestDelay)}ms, set first fragment max fetchDuration to ${Math.round(1000 * maxStarvationDelay)} ms`);
        // don't use conservative factor on bitrate test
        bwFactor = bwUpFactor = 1;
      }
    }
    bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay + maxStarvationDelay, bwFactor, bwUpFactor);
    return Math.max(bestLevel, 0);
  }
  findBestLevel(currentBw, minAutoLevel, maxAutoLevel, maxFetchDuration, bwFactor, bwUpFactor) {
    var _level$details;
    const {
      fragCurrent,
      partCurrent,
      lastLoadedFragLevel: currentLevel
    } = this;
    const {
      levels
    } = this.hls;
    const level = levels[currentLevel];
    const live = !!(level != null && (_level$details = level.details) != null && _level$details.live);
    const currentCodecSet = level == null ? void 0 : level.codecSet;
    const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
    const ttfbEstimateSec = this.bwEstimator.getEstimateTTFB() / 1000;
    let levelSkippedMin = minAutoLevel;
    let levelSkippedMax = -1;
    for (let i = maxAutoLevel; i >= minAutoLevel; i--) {
      const levelInfo = levels[i];
      if (!levelInfo || currentCodecSet && levelInfo.codecSet !== currentCodecSet) {
        if (levelInfo) {
          levelSkippedMin = Math.min(i, levelSkippedMin);
          levelSkippedMax = Math.max(i, levelSkippedMax);
        }
        continue;
      }
      if (levelSkippedMax !== -1) {
        logger.trace(`[abr] Skipped level(s) ${levelSkippedMin}-${levelSkippedMax} with CODECS:"${levels[levelSkippedMax].attrs.CODECS}"; not compatible with "${level.attrs.CODECS}"`);
      }
      const levelDetails = levelInfo.details;
      const avgDuration = (partCurrent ? levelDetails == null ? void 0 : levelDetails.partTarget : levelDetails == null ? void 0 : levelDetails.averagetargetduration) || currentFragDuration;
      let adjustedbw;
      // follow algorithm captured from stagefright :
      // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
      // Pick the highest bandwidth stream below or equal to estimated bandwidth.
      // consider only 80% of the available bandwidth, but if we are switching up,
      // be even more conservative (70%) to avoid overestimating and immediately
      // switching back.
      if (i <= currentLevel) {
        adjustedbw = bwFactor * currentBw;
      } else {
        adjustedbw = bwUpFactor * currentBw;
      }
      const bitrate = levels[i].maxBitrate;
      const fetchDuration = this.getTimeToLoadFrag(ttfbEstimateSec, adjustedbw, bitrate * avgDuration, levelDetails === undefined);
      logger.trace(`[abr] level:${i} adjustedbw-bitrate:${Math.round(adjustedbw - bitrate)} avgDuration:${avgDuration.toFixed(1)} maxFetchDuration:${maxFetchDuration.toFixed(1)} fetchDuration:${fetchDuration.toFixed(1)}`);
      // if adjusted bw is greater than level bitrate AND
      if (adjustedbw > bitrate && (
      // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
      // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
      // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
      fetchDuration === 0 || !isFiniteNumber(fetchDuration) || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration)) {
        // as we are looping from highest to lowest, this will return the best achievable quality level
        return i;
      }
    }
    // not enough time budget even with quality level 0 ... rebuffering might happen
    return -1;
  }
  set nextAutoLevel(nextLevel) {
    this._nextAutoLevel = nextLevel;
  }
}

class ChunkCache {
  constructor() {
    this.chunks = [];
    this.dataLength = 0;
  }
  push(chunk) {
    this.chunks.push(chunk);
    this.dataLength += chunk.length;
  }
  flush() {
    const {
      chunks,
      dataLength
    } = this;
    let result;
    if (!chunks.length) {
      return new Uint8Array(0);
    } else if (chunks.length === 1) {
      result = chunks[0];
    } else {
      result = concatUint8Arrays(chunks, dataLength);
    }
    this.reset();
    return result;
  }
  reset() {
    this.chunks.length = 0;
    this.dataLength = 0;
  }
}
function concatUint8Arrays(chunks, dataLength) {
  const result = new Uint8Array(dataLength);
  let offset = 0;
  for (let i = 0; i < chunks.length; i++) {
    const chunk = chunks[i];
    result.set(chunk, offset);
    offset += chunk.length;
  }
  return result;
}

const TICK_INTERVAL$1 = 100; // how often to tick in ms

class AudioStreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, '[audio-stream-controller]', PlaylistLevelType.AUDIO);
    this.videoBuffer = null;
    this.videoTrackCC = -1;
    this.waitingVideoCC = -1;
    this.bufferedTrack = null;
    this.switchingTrack = null;
    this.trackId = -1;
    this.waitingData = null;
    this.mainDetails = null;
    this.bufferFlushed = false;
    this.cachedTrackLoadedData = null;
    this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners();
    this.mainDetails = null;
    this.bufferedTrack = null;
    this.switchingTrack = null;
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
    hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
    hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }

  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(event, {
    frag,
    id,
    initPTS,
    timescale
  }) {
    // Always update the new INIT PTS
    // Can change due level switch
    if (id === 'main') {
      const cc = frag.cc;
      this.initPTS[frag.cc] = {
        baseTime: initPTS,
        timescale
      };
      this.log(`InitPTS for cc: ${cc} found from main: ${initPTS}`);
      this.videoTrackCC = cc;
      // If we are waiting, tick immediately to unblock audio fragment transmuxing
      if (this.state === State.WAITING_INIT_PTS) {
        this.tick();
      }
    }
  }
  startLoad(startPosition) {
    if (!this.levels) {
      this.startPosition = startPosition;
      this.state = State.STOPPED;
      return;
    }
    const lastCurrentTime = this.lastCurrentTime;
    this.stopLoad();
    this.setInterval(TICK_INTERVAL$1);
    if (lastCurrentTime > 0 && startPosition === -1) {
      this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
      startPosition = lastCurrentTime;
      this.state = State.IDLE;
    } else {
      this.loadedmetadata = false;
      this.state = State.WAITING_TRACK;
    }
    this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
    this.tick();
  }
  doTick() {
    switch (this.state) {
      case State.IDLE:
        this.doTickIdle();
        break;
      case State.WAITING_TRACK:
        {
          var _levels$trackId;
          const {
            levels,
            trackId
          } = this;
          const details = levels == null ? void 0 : (_levels$trackId = levels[trackId]) == null ? void 0 : _levels$trackId.details;
          if (details) {
            if (this.waitForCdnTuneIn(details)) {
              break;
            }
            this.state = State.WAITING_INIT_PTS;
          }
          break;
        }
      case State.FRAG_LOADING_WAITING_RETRY:
        {
          var _this$media;
          const now = performance.now();
          const retryDate = this.retryDate;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
            this.log('RetryDate reached, switch back to IDLE state');
            this.resetStartWhenNotLoaded(this.trackId);
            this.state = State.IDLE;
          }
          break;
        }
      case State.WAITING_INIT_PTS:
        {
          // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
          const waitingData = this.waitingData;
          if (waitingData) {
            const {
              frag,
              part,
              cache,
              complete
            } = waitingData;
            if (this.initPTS[frag.cc] !== undefined) {
              this.waitingData = null;
              this.waitingVideoCC = -1;
              this.state = State.FRAG_LOADING;
              const payload = cache.flush();
              const data = {
                frag,
                part,
                payload,
                networkDetails: null
              };
              this._handleFragmentLoadProgress(data);
              if (complete) {
                super._handleFragmentLoadComplete(data);
              }
            } else if (this.videoTrackCC !== this.waitingVideoCC) {
              // Drop waiting fragment if videoTrackCC has changed since waitingFragment was set and initPTS was not found
              this.log(`Waiting fragment cc (${frag.cc}) cancelled because video is at cc ${this.videoTrackCC}`);
              this.clearWaitingFragment();
            } else {
              // Drop waiting fragment if an earlier fragment is needed
              const pos = this.getLoadPosition();
              const bufferInfo = BufferHelper.bufferInfo(this.mediaBuffer, pos, this.config.maxBufferHole);
              const waitingFragmentAtPosition = fragmentWithinToleranceTest(bufferInfo.end, this.config.maxFragLookUpTolerance, frag);
              if (waitingFragmentAtPosition < 0) {
                this.log(`Waiting fragment cc (${frag.cc}) @ ${frag.start} cancelled because another fragment at ${bufferInfo.end} is needed`);
                this.clearWaitingFragment();
              }
            }
          } else {
            this.state = State.IDLE;
          }
        }
    }
    this.onTickEnd();
  }
  clearWaitingFragment() {
    const waitingData = this.waitingData;
    if (waitingData) {
      this.fragmentTracker.removeFragment(waitingData.frag);
      this.waitingData = null;
      this.waitingVideoCC = -1;
      this.state = State.IDLE;
    }
  }
  resetLoadingState() {
    this.clearWaitingFragment();
    super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media
    } = this;
    if (!(media != null && media.readyState)) {
      // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
      return;
    }
    this.lastCurrentTime = media.currentTime;
  }
  doTickIdle() {
    const {
      hls,
      levels,
      media,
      trackId
    } = this;
    const config = hls.config;
    if (!(levels != null && levels[trackId])) {
      return;
    }

    // if video not attached AND
    // start fragment already requested OR start frag prefetch not enabled
    // exit loop
    // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
    if (!media && (this.startFragRequested || !config.startFragPrefetch)) {
      return;
    }
    const levelInfo = levels[trackId];
    const trackDetails = levelInfo.details;
    if (!trackDetails || trackDetails.live && this.levelLastLoaded !== trackId || this.waitForCdnTuneIn(trackDetails)) {
      this.state = State.WAITING_TRACK;
      return;
    }
    const bufferable = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.bufferFlushed && bufferable) {
      this.bufferFlushed = false;
      this.afterBufferFlushed(bufferable, ElementaryStreamTypes.AUDIO, PlaylistLevelType.AUDIO);
    }
    const bufferInfo = this.getFwdBufferInfo(bufferable, PlaylistLevelType.AUDIO);
    if (bufferInfo === null) {
      return;
    }
    const {
      bufferedTrack,
      switchingTrack
    } = this;
    if (!switchingTrack && this._streamEnded(bufferInfo, trackDetails)) {
      hls.trigger(Events.BUFFER_EOS, {
        type: 'audio'
      });
      this.state = State.ENDED;
      return;
    }
    const mainBufferInfo = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, PlaylistLevelType.MAIN);
    const bufferLen = bufferInfo.len;
    const maxBufLen = this.getMaxBufferLength(mainBufferInfo == null ? void 0 : mainBufferInfo.len);

    // if buffer length is less than maxBufLen try to load a new fragment
    if (bufferLen >= maxBufLen && !switchingTrack) {
      return;
    }
    const fragments = trackDetails.fragments;
    const start = fragments[0].start;
    let targetBufferTime = bufferInfo.end;
    if (switchingTrack && media) {
      const pos = this.getLoadPosition();
      if (bufferedTrack && switchingTrack.attrs !== bufferedTrack.attrs) {
        targetBufferTime = pos;
      }
      // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
      if (trackDetails.PTSKnown && pos < start) {
        // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
        if (bufferInfo.end > start || bufferInfo.nextStart) {
          this.log('Alt audio track ahead of main track, seek to start of alt audio track');
          media.currentTime = start + 0.05;
        }
      }
    }
    let frag = this.getNextFragment(targetBufferTime, trackDetails);
    let atGap = false;
    // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
    if (frag && this.isLoopLoading(frag, targetBufferTime)) {
      atGap = !!frag.gap;
      frag = this.getNextFragmentLoopLoading(frag, trackDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
    }
    if (!frag) {
      this.bufferFlushed = true;
      return;
    }

    // Buffer audio up to one target duration ahead of main buffer
    const atBufferSyncLimit = mainBufferInfo && frag.start > mainBufferInfo.end + trackDetails.targetduration;
    if (atBufferSyncLimit ||
    // Or wait for main buffer after buffing some audio
    !(mainBufferInfo != null && mainBufferInfo.len) && bufferInfo.len) {
      // Check fragment-tracker for main fragments since GAP segments do not show up in bufferInfo
      const mainFrag = this.getAppendedFrag(frag.start, PlaylistLevelType.MAIN);
      if (mainFrag === null) {
        return;
      }
      // Bridge gaps in main buffer
      atGap || (atGap = !!mainFrag.gap || !!atBufferSyncLimit && mainBufferInfo.len === 0);
      if (atBufferSyncLimit && !atGap || atGap && bufferInfo.nextStart && bufferInfo.nextStart < mainFrag.end) {
        return;
      }
    }
    this.loadFragment(frag, levelInfo, targetBufferTime);
  }
  getMaxBufferLength(mainBufferLength) {
    const maxConfigBuffer = super.getMaxBufferLength();
    if (!mainBufferLength) {
      return maxConfigBuffer;
    }
    return Math.min(Math.max(maxConfigBuffer, mainBufferLength), this.config.maxMaxBufferLength);
  }
  onMediaDetaching() {
    this.videoBuffer = null;
    super.onMediaDetaching();
  }
  onAudioTracksUpdated(event, {
    audioTracks
  }) {
    this.resetTransmuxer();
    this.levels = audioTracks.map(mediaPlaylist => new Level(mediaPlaylist));
  }
  onAudioTrackSwitching(event, data) {
    // if any URL found on new audio track, it is an alternate audio track
    const altAudio = !!data.url;
    this.trackId = data.id;
    const {
      fragCurrent
    } = this;
    if (fragCurrent) {
      fragCurrent.abortRequests();
      this.removeUnbufferedFrags(fragCurrent.start);
    }
    this.resetLoadingState();
    // destroy useless transmuxer when switching audio to main
    if (!altAudio) {
      this.resetTransmuxer();
    } else {
      // switching to audio track, start timer if not already started
      this.setInterval(TICK_INTERVAL$1);
    }

    // should we switch tracks ?
    if (altAudio) {
      this.switchingTrack = data;
      // main audio track are handled by stream-controller, just do something if switching to alt audio track
      this.state = State.IDLE;
    } else {
      this.switchingTrack = null;
      this.bufferedTrack = data;
      this.state = State.STOPPED;
    }
    this.tick();
  }
  onManifestLoading() {
    this.fragmentTracker.removeAllFragments();
    this.startPosition = this.lastCurrentTime = 0;
    this.bufferFlushed = false;
    this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null;
    this.startFragRequested = false;
    this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
  }
  onLevelLoaded(event, data) {
    this.mainDetails = data.details;
    if (this.cachedTrackLoadedData !== null) {
      this.hls.trigger(Events.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData);
      this.cachedTrackLoadedData = null;
    }
  }
  onAudioTrackLoaded(event, data) {
    var _track$details;
    if (this.mainDetails == null) {
      this.cachedTrackLoadedData = data;
      return;
    }
    const {
      levels
    } = this;
    const {
      details: newDetails,
      id: trackId
    } = data;
    if (!levels) {
      this.warn(`Audio tracks were reset while loading level ${trackId}`);
      return;
    }
    this.log(`Track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
    const track = levels[trackId];
    let sliding = 0;
    if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
      const mainDetails = this.mainDetails;
      if (!newDetails.fragments[0]) {
        newDetails.deltaUpdateFailed = true;
      }
      if (newDetails.deltaUpdateFailed || !mainDetails) {
        return;
      }
      if (!track.details && newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
        // Make sure our audio rendition is aligned with the "main" rendition, using
        // pdt as our reference times.
        alignMediaPlaylistByPDT(newDetails, mainDetails);
        sliding = newDetails.fragments[0].start;
      } else {
        sliding = this.alignPlaylists(newDetails, track.details);
      }
    }
    track.details = newDetails;
    this.levelLastLoaded = trackId;

    // compute start position if we are aligned with the main playlist
    if (!this.startFragRequested && (this.mainDetails || !newDetails.live)) {
      this.setStartPosition(track.details, sliding);
    }
    // only switch back to IDLE state if we were waiting for track to start downloading a new fragment
    if (this.state === State.WAITING_TRACK && !this.waitForCdnTuneIn(newDetails)) {
      this.state = State.IDLE;
    }

    // trigger handler right now
    this.tick();
  }
  _handleFragmentLoadProgress(data) {
    var _frag$initSegment;
    const {
      frag,
      part,
      payload
    } = data;
    const {
      config,
      trackId,
      levels
    } = this;
    if (!levels) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
      return;
    }
    const track = levels[trackId];
    if (!track) {
      this.warn('Audio track is undefined on fragment load progress');
      return;
    }
    const details = track.details;
    if (!details) {
      this.warn('Audio track details undefined on fragment load progress');
      this.removeUnbufferedFrags(frag.start);
      return;
    }
    const audioCodec = config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2';
    let transmuxer = this.transmuxer;
    if (!transmuxer) {
      transmuxer = this.transmuxer = new TransmuxerInterface(this.hls, PlaylistLevelType.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
    }

    // Check if we have video initPTS
    // If not we need to wait for it
    const initPTS = this.initPTS[frag.cc];
    const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
    if (initPTS !== undefined) {
      // this.log(`Transmuxing ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
      // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
      const accurateTimeOffset = false; // details.PTSKnown || !details.live;
      const partIndex = part ? part.index : -1;
      const partial = partIndex !== -1;
      const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
      transmuxer.push(payload, initSegmentData, audioCodec, '', frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
    } else {
      this.log(`Unknown video PTS for cc ${frag.cc}, waiting for video PTS before demuxing audio frag ${frag.sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
      const {
        cache
      } = this.waitingData = this.waitingData || {
        frag,
        part,
        cache: new ChunkCache(),
        complete: false
      };
      cache.push(new Uint8Array(payload));
      this.waitingVideoCC = this.videoTrackCC;
      this.state = State.WAITING_INIT_PTS;
    }
  }
  _handleFragmentLoadComplete(fragLoadedData) {
    if (this.waitingData) {
      this.waitingData.complete = true;
      return;
    }
    super._handleFragmentLoadComplete(fragLoadedData);
  }
  onBufferReset( /* event: Events.BUFFER_RESET */
  ) {
    // reset reference to sourcebuffers
    this.mediaBuffer = this.videoBuffer = null;
    this.loadedmetadata = false;
  }
  onBufferCreated(event, data) {
    const audioTrack = data.tracks.audio;
    if (audioTrack) {
      this.mediaBuffer = audioTrack.buffer || null;
    }
    if (data.tracks.video) {
      this.videoBuffer = data.tracks.video.buffer || null;
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    if (frag.type !== PlaylistLevelType.AUDIO) {
      if (!this.loadedmetadata && frag.type === PlaylistLevelType.MAIN) {
        const bufferable = this.videoBuffer || this.media;
        if (bufferable) {
          const bufferedTimeRanges = BufferHelper.getBuffered(bufferable);
          if (bufferedTimeRanges.length) {
            this.loadedmetadata = true;
          }
        }
      }
      return;
    }
    if (this.fragContextChanged(frag)) {
      // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
      // Avoid setting state back to IDLE or concluding the audio switch; otherwise, the switched-to track will not buffer
      this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : 'false'}`);
      return;
    }
    if (frag.sn !== 'initSegment') {
      this.fragPrevious = frag;
      const track = this.switchingTrack;
      if (track) {
        this.bufferedTrack = track;
        this.switchingTrack = null;
        this.hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, track));
      }
    }
    this.fragBufferedComplete(frag, part);
  }
  onError(event, data) {
    var _data$context;
    if (data.fatal) {
      this.state = State.ERROR;
      return;
    }
    switch (data.details) {
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_PARSING_ERROR:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(PlaylistLevelType.AUDIO, data);
        break;
      case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
      case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        // in case of non fatal error while loading track, if not retrying to load track, switch back to IDLE
        if (!data.levelRetry && this.state === State.WAITING_TRACK && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.AUDIO_TRACK) {
          this.state = State.IDLE;
        }
        break;
      case ErrorDetails.BUFFER_FULL_ERROR:
        if (!data.parent || data.parent !== 'audio') {
          return;
        }
        if (this.reduceLengthAndFlushBuffer(data)) {
          this.bufferedTrack = null;
          super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
        }
        break;
      case ErrorDetails.INTERNAL_EXCEPTION:
        this.recoverWorkerError(data);
        break;
    }
  }
  onBufferFlushed(event, {
    type
  }) {
    if (type === ElementaryStreamTypes.AUDIO) {
      this.bufferFlushed = true;
      if (this.state === State.ENDED) {
        this.state = State.IDLE;
      }
    }
  }
  _handleTransmuxComplete(transmuxResult) {
    var _id3$samples;
    const id = 'audio';
    const {
      hls
    } = this;
    const {
      remuxResult,
      chunkMeta
    } = transmuxResult;
    const context = this.getCurrentContext(chunkMeta);
    if (!context) {
      this.resetWhenMissingContext(chunkMeta);
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const {
      details
    } = level;
    const {
      audio,
      text,
      id3,
      initSegment
    } = remuxResult;

    // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
    // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
    if (this.fragContextChanged(frag) || !details) {
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    this.state = State.PARSING;
    if (this.switchingTrack && audio) {
      this.completeAudioSwitch(this.switchingTrack);
    }
    if (initSegment != null && initSegment.tracks) {
      const mapFragment = frag.initSegment || frag;
      this._bufferInitSegment(initSegment.tracks, mapFragment, chunkMeta);
      hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
        frag: mapFragment,
        id,
        tracks: initSegment.tracks
      });
      // Only flush audio from old audio tracks when PTS is known on new audio track
    }

    if (audio) {
      const {
        startPTS,
        endPTS,
        startDTS,
        endDTS
      } = audio;
      if (part) {
        part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        };
      }
      frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
      this.bufferFragmentData(audio, frag, part, chunkMeta);
    }
    if (id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
      const emittedID3 = _extends({
        id,
        frag,
        details
      }, id3);
      hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
    }
    if (text) {
      const emittedText = _extends({
        id,
        frag,
        details
      }, text);
      hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
    }
  }
  _bufferInitSegment(tracks, frag, chunkMeta) {
    if (this.state !== State.PARSING) {
      return;
    }
    // delete any video track found on audio transmuxer
    if (tracks.video) {
      delete tracks.video;
    }

    // include levelCodec in audio and video tracks
    const track = tracks.audio;
    if (!track) {
      return;
    }
    track.levelCodec = track.codec;
    track.id = 'audio';
    this.log(`Init audio buffer, container:${track.container}, codecs[parsed]=[${track.codec}]`);
    this.hls.trigger(Events.BUFFER_CODECS, tracks);
    const initSegment = track.initSegment;
    if (initSegment != null && initSegment.byteLength) {
      const segment = {
        type: 'audio',
        frag,
        part: null,
        chunkMeta,
        parent: frag.type,
        data: initSegment
      };
      this.hls.trigger(Events.BUFFER_APPENDING, segment);
    }
    // trigger handler right now
    this.tick();
  }
  loadFragment(frag, track, targetBufferTime) {
    // only load if fragment is not loaded or if in audio switch
    const fragState = this.fragmentTracker.getState(frag);
    this.fragCurrent = frag;

    // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
    if (this.switchingTrack || fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
      var _track$details2;
      if (frag.sn === 'initSegment') {
        this._loadInitSegment(frag, track);
      } else if ((_track$details2 = track.details) != null && _track$details2.live && !this.initPTS[frag.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${frag.cc} of live stream before loading audio fragment ${frag.sn} of level ${this.trackId}`);
        this.state = State.WAITING_INIT_PTS;
      } else {
        this.startFragRequested = true;
        super.loadFragment(frag, track, targetBufferTime);
      }
    } else {
      this.clearTrackerIfNeeded(frag);
    }
  }
  completeAudioSwitch(switchingTrack) {
    const {
      hls,
      media,
      bufferedTrack
    } = this;
    const bufferedAttributes = bufferedTrack == null ? void 0 : bufferedTrack.attrs;
    const switchAttributes = switchingTrack.attrs;
    if (media && bufferedAttributes && (bufferedAttributes.CHANNELS !== switchAttributes.CHANNELS || bufferedAttributes.NAME !== switchAttributes.NAME || bufferedAttributes.LANGUAGE !== switchAttributes.LANGUAGE)) {
      this.log('Switching audio track : flushing all audio');
      super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
    }
    this.bufferedTrack = switchingTrack;
    this.switchingTrack = null;
    hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, switchingTrack));
  }
}

class AudioTrackController extends BasePlaylistController {
  constructor(hls) {
    super(hls, '[audio-track-controller]');
    this.tracks = [];
    this.groupId = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.currentTrack = null;
    this.selectDefaultTrack = true;
    this.registerListeners();
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners();
    this.tracks.length = 0;
    this.tracksInGroup.length = 0;
    this.currentTrack = null;
    super.destroy();
  }
  onManifestLoading() {
    this.tracks = [];
    this.groupId = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.currentTrack = null;
    this.selectDefaultTrack = true;
  }
  onManifestParsed(event, data) {
    this.tracks = data.audioTracks || [];
  }
  onAudioTrackLoaded(event, data) {
    const {
      id,
      groupId,
      details
    } = data;
    const trackInActiveGroup = this.tracksInGroup[id];
    if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
      this.warn(`Track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup.groupId}`);
      return;
    }
    const curDetails = trackInActiveGroup.details;
    trackInActiveGroup.details = data.details;
    this.log(`audio-track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
    if (id === this.trackId) {
      this.playlistLoaded(id, data, curDetails);
    }
  }
  onLevelLoading(event, data) {
    this.switchLevel(data.level);
  }
  onLevelSwitching(event, data) {
    this.switchLevel(data.level);
  }
  switchLevel(levelIndex) {
    const levelInfo = this.hls.levels[levelIndex];
    if (!(levelInfo != null && levelInfo.audioGroupIds)) {
      return;
    }
    const audioGroupId = levelInfo.audioGroupIds[levelInfo.urlId];
    if (this.groupId !== audioGroupId) {
      this.groupId = audioGroupId || null;
      const audioTracks = this.tracks.filter(track => !audioGroupId || track.groupId === audioGroupId);

      // Disable selectDefaultTrack if there are no default tracks
      if (this.selectDefaultTrack && !audioTracks.some(track => track.default)) {
        this.selectDefaultTrack = false;
      }
      this.tracksInGroup = audioTracks;
      const audioTracksUpdated = {
        audioTracks
      };
      this.log(`Updating audio tracks, ${audioTracks.length} track(s) found in group:${audioGroupId}`);
      this.hls.trigger(Events.AUDIO_TRACKS_UPDATED, audioTracksUpdated);
      this.selectInitialTrack();
    } else if (this.shouldReloadPlaylist(this.currentTrack)) {
      // Retry playlist loading if no playlist is or has been loaded yet
      this.setAudioTrack(this.trackId);
    }
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.AUDIO_TRACK && data.context.id === this.trackId && data.context.groupId === this.groupId) {
      this.requestScheduled = -1;
      this.checkRetry(data);
    }
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(newId) {
    // If audio track is selected from API then don't choose from the manifest default track
    this.selectDefaultTrack = false;
    this.setAudioTrack(newId);
  }
  setAudioTrack(newId) {
    const tracks = this.tracksInGroup;

    // check if level idx is valid
    if (newId < 0 || newId >= tracks.length) {
      this.warn('Invalid id passed to audio-track controller');
      return;
    }

    // stopping live reloading timer if any
    this.clearTimer();
    const lastTrack = this.currentTrack;
    tracks[this.trackId];
    const track = tracks[newId];
    const {
      groupId,
      name
    } = track;
    this.log(`Switching to audio-track ${newId} "${name}" lang:${track.lang} group:${groupId}`);
    this.trackId = newId;
    this.currentTrack = track;
    this.selectDefaultTrack = false;
    this.hls.trigger(Events.AUDIO_TRACK_SWITCHING, _objectSpread2({}, track));
    // Do not reload track unless live
    if (track.details && !track.details.live) {
      return;
    }
    const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details);
    this.loadPlaylist(hlsUrlParameters);
  }
  selectInitialTrack() {
    const audioTracks = this.tracksInGroup;
    const trackId = this.findTrackId(this.currentTrack) | this.findTrackId(null);
    if (trackId !== -1) {
      this.setAudioTrack(trackId);
    } else {
      const error = new Error(`No track found for running audio group-ID: ${this.groupId} track count: ${audioTracks.length}`);
      this.warn(error.message);
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
        fatal: true,
        error
      });
    }
  }
  findTrackId(currentTrack) {
    const audioTracks = this.tracksInGroup;
    for (let i = 0; i < audioTracks.length; i++) {
      const track = audioTracks[i];
      if (!this.selectDefaultTrack || track.default) {
        if (!currentTrack || currentTrack.attrs['STABLE-RENDITION-ID'] !== undefined && currentTrack.attrs['STABLE-RENDITION-ID'] === track.attrs['STABLE-RENDITION-ID']) {
          return track.id;
        }
        if (currentTrack.name === track.name && currentTrack.lang === track.lang) {
          return track.id;
        }
      }
    }
    return -1;
  }
  loadPlaylist(hlsUrlParameters) {
    super.loadPlaylist();
    const audioTrack = this.tracksInGroup[this.trackId];
    if (this.shouldLoadPlaylist(audioTrack)) {
      const id = audioTrack.id;
      const groupId = audioTrack.groupId;
      let url = audioTrack.url;
      if (hlsUrlParameters) {
        try {
          url = hlsUrlParameters.addDirectives(url);
        } catch (error) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
        }
      }
      // track not retrieved yet, or live playlist we need to (re)load it
      this.log(`loading audio-track playlist ${id} "${audioTrack.name}" lang:${audioTrack.lang} group:${groupId}`);
      this.clearTimer();
      this.hls.trigger(Events.AUDIO_TRACK_LOADING, {
        url,
        id,
        groupId,
        deliveryDirectives: hlsUrlParameters || null
      });
    }
  }
}

function subtitleOptionsIdentical(trackList1, trackList2) {
  if (trackList1.length !== trackList2.length) {
    return false;
  }
  for (let i = 0; i < trackList1.length; i++) {
    if (!subtitleAttributesIdentical(trackList1[i].attrs, trackList2[i].attrs)) {
      return false;
    }
  }
  return true;
}
function subtitleAttributesIdentical(attrs1, attrs2) {
  // Media options with the same rendition ID must be bit identical
  const stableRenditionId = attrs1['STABLE-RENDITION-ID'];
  if (stableRenditionId) {
    return stableRenditionId === attrs2['STABLE-RENDITION-ID'];
  }
  // When rendition ID is not present, compare attributes
  return !['LANGUAGE', 'NAME', 'CHARACTERISTICS', 'AUTOSELECT', 'DEFAULT', 'FORCED'].some(subtitleAttribute => attrs1[subtitleAttribute] !== attrs2[subtitleAttribute]);
}

const TICK_INTERVAL = 500; // how often to tick in ms

class SubtitleStreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, '[subtitle-stream-controller]', PlaylistLevelType.SUBTITLE);
    this.levels = [];
    this.currentTrackId = -1;
    this.tracksBuffered = [];
    this.mainDetails = null;
    this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners();
    this.mainDetails = null;
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.on(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
    hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.on(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.off(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
    hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.off(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  startLoad(startPosition) {
    this.stopLoad();
    this.state = State.IDLE;
    this.setInterval(TICK_INTERVAL);
    this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
    this.tick();
  }
  onManifestLoading() {
    this.mainDetails = null;
    this.fragmentTracker.removeAllFragments();
  }
  onMediaDetaching() {
    this.tracksBuffered = [];
    super.onMediaDetaching();
  }
  onLevelLoaded(event, data) {
    this.mainDetails = data.details;
  }
  onSubtitleFragProcessed(event, data) {
    const {
      frag,
      success
    } = data;
    this.fragPrevious = frag;
    this.state = State.IDLE;
    if (!success) {
      return;
    }
    const buffered = this.tracksBuffered[this.currentTrackId];
    if (!buffered) {
      return;
    }

    // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
    // so we can re-use the logic used to detect how much has been buffered
    let timeRange;
    const fragStart = frag.start;
    for (let i = 0; i < buffered.length; i++) {
      if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
        timeRange = buffered[i];
        break;
      }
    }
    const fragEnd = frag.start + frag.duration;
    if (timeRange) {
      timeRange.end = fragEnd;
    } else {
      timeRange = {
        start: fragStart,
        end: fragEnd
      };
      buffered.push(timeRange);
    }
    this.fragmentTracker.fragBuffered(frag);
  }
  onBufferFlushing(event, data) {
    const {
      startOffset,
      endOffset
    } = data;
    if (startOffset === 0 && endOffset !== Number.POSITIVE_INFINITY) {
      const endOffsetSubtitles = endOffset - 1;
      if (endOffsetSubtitles <= 0) {
        return;
      }
      data.endOffsetSubtitles = Math.max(0, endOffsetSubtitles);
      this.tracksBuffered.forEach(buffered => {
        for (let i = 0; i < buffered.length;) {
          if (buffered[i].end <= endOffsetSubtitles) {
            buffered.shift();
            continue;
          } else if (buffered[i].start < endOffsetSubtitles) {
            buffered[i].start = endOffsetSubtitles;
          } else {
            break;
          }
          i++;
        }
      });
      this.fragmentTracker.removeFragmentsInRange(startOffset, endOffsetSubtitles, PlaylistLevelType.SUBTITLE);
    }
  }
  onFragBuffered(event, data) {
    if (!this.loadedmetadata && data.frag.type === PlaylistLevelType.MAIN) {
      var _this$media;
      if ((_this$media = this.media) != null && _this$media.buffered.length) {
        this.loadedmetadata = true;
      }
    }
  }

  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(event, data) {
    const frag = data.frag;
    if ((frag == null ? void 0 : frag.type) === PlaylistLevelType.SUBTITLE) {
      if (this.fragCurrent) {
        this.fragCurrent.abortRequests();
      }
      if (this.state !== State.STOPPED) {
        this.state = State.IDLE;
      }
    }
  }

  // Got all new subtitle levels.
  onSubtitleTracksUpdated(event, {
    subtitleTracks
  }) {
    if (subtitleOptionsIdentical(this.levels, subtitleTracks)) {
      this.levels = subtitleTracks.map(mediaPlaylist => new Level(mediaPlaylist));
      return;
    }
    this.tracksBuffered = [];
    this.levels = subtitleTracks.map(mediaPlaylist => {
      const level = new Level(mediaPlaylist);
      this.tracksBuffered[level.id] = [];
      return level;
    });
    this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, PlaylistLevelType.SUBTITLE);
    this.fragPrevious = null;
    this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(event, data) {
    this.currentTrackId = data.id;
    if (!this.levels.length || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }

    // Check if track has the necessary details to load fragments
    const currentTrack = this.levels[this.currentTrackId];
    if (currentTrack != null && currentTrack.details) {
      this.mediaBuffer = this.mediaBufferTimeRanges;
    } else {
      this.mediaBuffer = null;
    }
    if (currentTrack) {
      this.setInterval(TICK_INTERVAL);
    }
  }

  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(event, data) {
    var _track$details;
    const {
      details: newDetails,
      id: trackId
    } = data;
    const {
      currentTrackId,
      levels
    } = this;
    if (!levels.length) {
      return;
    }
    const track = levels[currentTrackId];
    if (trackId >= levels.length || trackId !== currentTrackId || !track) {
      return;
    }
    this.mediaBuffer = this.mediaBufferTimeRanges;
    let sliding = 0;
    if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
      const mainDetails = this.mainDetails;
      if (newDetails.deltaUpdateFailed || !mainDetails) {
        return;
      }
      const mainSlidingStartFragment = mainDetails.fragments[0];
      if (!track.details) {
        if (newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
          alignMediaPlaylistByPDT(newDetails, mainDetails);
          sliding = newDetails.fragments[0].start;
        } else if (mainSlidingStartFragment) {
          // line up live playlist with main so that fragments in range are loaded
          sliding = mainSlidingStartFragment.start;
          addSliding(newDetails, sliding);
        }
      } else {
        sliding = this.alignPlaylists(newDetails, track.details);
        if (sliding === 0 && mainSlidingStartFragment) {
          // realign with main when there is no overlap with last refresh
          sliding = mainSlidingStartFragment.start;
          addSliding(newDetails, sliding);
        }
      }
    }
    track.details = newDetails;
    this.levelLastLoaded = trackId;
    if (!this.startFragRequested && (this.mainDetails || !newDetails.live)) {
      this.setStartPosition(track.details, sliding);
    }

    // trigger handler right now
    this.tick();

    // If playlist is misaligned because of bad PDT or drift, delete details to resync with main on reload
    if (newDetails.live && !this.fragCurrent && this.media && this.state === State.IDLE) {
      const foundFrag = findFragmentByPTS(null, newDetails.fragments, this.media.currentTime, 0);
      if (!foundFrag) {
        this.warn('Subtitle playlist not aligned with playback');
        track.details = undefined;
      }
    }
  }
  _handleFragmentLoadComplete(fragLoadedData) {
    const {
      frag,
      payload
    } = fragLoadedData;
    const decryptData = frag.decryptdata;
    const hls = this.hls;
    if (this.fragContextChanged(frag)) {
      return;
    }
    // check to see if the payload needs to be decrypted
    if (payload && payload.byteLength > 0 && decryptData && decryptData.key && decryptData.iv && decryptData.method === 'AES-128') {
      const startTime = performance.now();
      // decrypt the subtitles
      this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).catch(err => {
        hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.FRAG_DECRYPT_ERROR,
          fatal: false,
          error: err,
          reason: err.message,
          frag
        });
        throw err;
      }).then(decryptedData => {
        const endTime = performance.now();
        hls.trigger(Events.FRAG_DECRYPTED, {
          frag,
          payload: decryptedData,
          stats: {
            tstart: startTime,
            tdecrypt: endTime
          }
        });
      }).catch(err => {
        this.warn(`${err.name}: ${err.message}`);
        this.state = State.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = State.IDLE;
      return;
    }
    if (this.state === State.IDLE) {
      const {
        currentTrackId,
        levels
      } = this;
      const track = levels[currentTrackId];
      if (!levels.length || !track || !track.details) {
        return;
      }
      const {
        config
      } = this;
      const currentTime = this.getLoadPosition();
      const bufferedInfo = BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], currentTime, config.maxBufferHole);
      const {
        end: targetBufferTime,
        len: bufferLen
      } = bufferedInfo;
      const mainBufferInfo = this.getFwdBufferInfo(this.media, PlaylistLevelType.MAIN);
      const trackDetails = track.details;
      const maxBufLen = this.getMaxBufferLength(mainBufferInfo == null ? void 0 : mainBufferInfo.len) + trackDetails.levelTargetDuration;
      if (bufferLen > maxBufLen) {
        return;
      }
      const fragments = trackDetails.fragments;
      const fragLen = fragments.length;
      const end = trackDetails.edge;
      let foundFrag = null;
      const fragPrevious = this.fragPrevious;
      if (targetBufferTime < end) {
        const tolerance = config.maxFragLookUpTolerance;
        const lookupTolerance = targetBufferTime > end - tolerance ? 0 : tolerance;
        foundFrag = findFragmentByPTS(fragPrevious, fragments, Math.max(fragments[0].start, targetBufferTime), lookupTolerance);
        if (!foundFrag && fragPrevious && fragPrevious.start < fragments[0].start) {
          foundFrag = fragments[0];
        }
      } else {
        foundFrag = fragments[fragLen - 1];
      }
      if (!foundFrag) {
        return;
      }
      foundFrag = this.mapToInitFragWhenRequired(foundFrag);
      if (foundFrag.sn !== 'initSegment') {
        // Load earlier fragment in same discontinuity to make up for misaligned playlists and cues that extend beyond end of segment
        const curSNIdx = foundFrag.sn - trackDetails.startSN;
        const prevFrag = fragments[curSNIdx - 1];
        if (prevFrag && prevFrag.cc === foundFrag.cc && this.fragmentTracker.getState(prevFrag) === FragmentState.NOT_LOADED) {
          foundFrag = prevFrag;
        }
      }
      if (this.fragmentTracker.getState(foundFrag) === FragmentState.NOT_LOADED) {
        // only load if fragment is not loaded
        this.loadFragment(foundFrag, track, targetBufferTime);
      }
    }
  }
  getMaxBufferLength(mainBufferLength) {
    const maxConfigBuffer = super.getMaxBufferLength();
    if (!mainBufferLength) {
      return maxConfigBuffer;
    }
    return Math.max(maxConfigBuffer, mainBufferLength);
  }
  loadFragment(frag, level, targetBufferTime) {
    this.fragCurrent = frag;
    if (frag.sn === 'initSegment') {
      this._loadInitSegment(frag, level);
    } else {
      this.startFragRequested = true;
      super.loadFragment(frag, level, targetBufferTime);
    }
  }
  get mediaBufferTimeRanges() {
    return new BufferableInstance(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class BufferableInstance {
  constructor(timeranges) {
    this.buffered = void 0;
    const getRange = (name, index, length) => {
      index = index >>> 0;
      if (index > length - 1) {
        throw new DOMException(`Failed to execute '${name}' on 'TimeRanges': The index provided (${index}) is greater than the maximum bound (${length})`);
      }
      return timeranges[index][name];
    };
    this.buffered = {
      get length() {
        return timeranges.length;
      },
      end(index) {
        return getRange('end', index, timeranges.length);
      },
      start(index) {
        return getRange('start', index, timeranges.length);
      }
    };
  }
}

class SubtitleTrackController extends BasePlaylistController {
  constructor(hls) {
    super(hls, '[subtitle-track-controller]');
    this.media = null;
    this.tracks = [];
    this.groupId = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.selectDefaultTrack = true;
    this.queuedDefaultTrack = -1;
    this.trackChangeListener = () => this.onTextTracksChanged();
    this.asyncPollTrackChange = () => this.pollTrackChange(0);
    this.useTextTrackPolling = false;
    this.subtitlePollingInterval = -1;
    this._subtitleDisplay = true;
    this.registerListeners();
  }
  destroy() {
    this.unregisterListeners();
    this.tracks.length = 0;
    this.tracksInGroup.length = 0;
    this.trackChangeListener = this.asyncPollTrackChange = null;
    super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(value) {
    this._subtitleDisplay = value;
    if (this.trackId > -1) {
      this.toggleTrackModes(this.trackId);
    }
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
  }

  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(event, data) {
    this.media = data.media;
    if (!this.media) {
      return;
    }
    if (this.queuedDefaultTrack > -1) {
      this.subtitleTrack = this.queuedDefaultTrack;
      this.queuedDefaultTrack = -1;
    }
    this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
    if (this.useTextTrackPolling) {
      this.pollTrackChange(500);
    } else {
      this.media.textTracks.addEventListener('change', this.asyncPollTrackChange);
    }
  }
  pollTrackChange(timeout) {
    self.clearInterval(this.subtitlePollingInterval);
    this.subtitlePollingInterval = self.setInterval(this.trackChangeListener, timeout);
  }
  onMediaDetaching() {
    if (!this.media) {
      return;
    }
    self.clearInterval(this.subtitlePollingInterval);
    if (!this.useTextTrackPolling) {
      this.media.textTracks.removeEventListener('change', this.asyncPollTrackChange);
    }
    if (this.trackId > -1) {
      this.queuedDefaultTrack = this.trackId;
    }
    const textTracks = filterSubtitleTracks(this.media.textTracks);
    // Clear loaded cues on media detachment from tracks
    textTracks.forEach(track => {
      clearCurrentCues(track);
    });
    // Disable all subtitle tracks before detachment so when reattached only tracks in that content are enabled.
    this.subtitleTrack = -1;
    this.media = null;
  }
  onManifestLoading() {
    this.tracks = [];
    this.groupId = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.selectDefaultTrack = true;
  }

  // Fired whenever a new manifest is loaded.
  onManifestParsed(event, data) {
    this.tracks = data.subtitleTracks;
  }
  onSubtitleTrackLoaded(event, data) {
    const {
      id,
      details
    } = data;
    const {
      trackId
    } = this;
    const currentTrack = this.tracksInGroup[trackId];
    if (!currentTrack) {
      this.warn(`Invalid subtitle track id ${id}`);
      return;
    }
    const curDetails = currentTrack.details;
    currentTrack.details = data.details;
    this.log(`subtitle track ${id} loaded [${details.startSN}-${details.endSN}]`);
    if (id === this.trackId) {
      this.playlistLoaded(id, data, curDetails);
    }
  }
  onLevelLoading(event, data) {
    this.switchLevel(data.level);
  }
  onLevelSwitching(event, data) {
    this.switchLevel(data.level);
  }
  switchLevel(levelIndex) {
    const levelInfo = this.hls.levels[levelIndex];
    if (!(levelInfo != null && levelInfo.textGroupIds)) {
      return;
    }
    const textGroupId = levelInfo.textGroupIds[levelInfo.urlId];
    const lastTrack = this.tracksInGroup ? this.tracksInGroup[this.trackId] : undefined;
    if (this.groupId !== textGroupId) {
      const subtitleTracks = this.tracks.filter(track => !textGroupId || track.groupId === textGroupId);
      this.tracksInGroup = subtitleTracks;
      const initialTrackId = this.findTrackId(lastTrack == null ? void 0 : lastTrack.name) || this.findTrackId();
      this.groupId = textGroupId || null;
      const subtitleTracksUpdated = {
        subtitleTracks
      };
      this.log(`Updating subtitle tracks, ${subtitleTracks.length} track(s) found in "${textGroupId}" group-id`);
      this.hls.trigger(Events.SUBTITLE_TRACKS_UPDATED, subtitleTracksUpdated);
      if (initialTrackId !== -1) {
        this.setSubtitleTrack(initialTrackId, lastTrack);
      }
    } else if (this.shouldReloadPlaylist(lastTrack)) {
      // Retry playlist loading if no playlist is or has been loaded yet
      this.setSubtitleTrack(this.trackId, lastTrack);
    }
  }
  findTrackId(name) {
    const textTracks = this.tracksInGroup;
    for (let i = 0; i < textTracks.length; i++) {
      const track = textTracks[i];
      if (!this.selectDefaultTrack || track.default) {
        if (!name || name === track.name) {
          return track.id;
        }
      }
    }
    return -1;
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.SUBTITLE_TRACK && data.context.id === this.trackId && data.context.groupId === this.groupId) {
      this.checkRetry(data);
    }
  }

  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }

  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(newId) {
    this.selectDefaultTrack = false;
    const lastTrack = this.tracksInGroup ? this.tracksInGroup[this.trackId] : undefined;
    this.setSubtitleTrack(newId, lastTrack);
  }
  loadPlaylist(hlsUrlParameters) {
    super.loadPlaylist();
    const currentTrack = this.tracksInGroup[this.trackId];
    if (this.shouldLoadPlaylist(currentTrack)) {
      const id = currentTrack.id;
      const groupId = currentTrack.groupId;
      let url = currentTrack.url;
      if (hlsUrlParameters) {
        try {
          url = hlsUrlParameters.addDirectives(url);
        } catch (error) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
        }
      }
      this.log(`Loading subtitle playlist for id ${id}`);
      this.hls.trigger(Events.SUBTITLE_TRACK_LOADING, {
        url,
        id,
        groupId,
        deliveryDirectives: hlsUrlParameters || null
      });
    }
  }

  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes(newId) {
    const {
      media,
      trackId
    } = this;
    if (!media) {
      return;
    }
    const textTracks = filterSubtitleTracks(media.textTracks);
    const groupTracks = textTracks.filter(track => track.groupId === this.groupId);
    if (newId === -1) {
      [].slice.call(textTracks).forEach(track => {
        track.mode = 'disabled';
      });
    } else {
      const oldTrack = groupTracks[trackId];
      if (oldTrack) {
        oldTrack.mode = 'disabled';
      }
    }
    const nextTrack = groupTracks[newId];
    if (nextTrack) {
      nextTrack.mode = this.subtitleDisplay ? 'showing' : 'hidden';
    }
  }

  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(newId, lastTrack) {
    var _tracks$newId;
    const tracks = this.tracksInGroup;

    // setting this.subtitleTrack will trigger internal logic
    // if media has not been attached yet, it will fail
    // we keep a reference to the default track id
    // and we'll set subtitleTrack when onMediaAttached is triggered
    if (!this.media) {
      this.queuedDefaultTrack = newId;
      return;
    }
    if (this.trackId !== newId) {
      this.toggleTrackModes(newId);
    }

    // exit if track id as already set or invalid
    if (this.trackId === newId && (newId === -1 || (_tracks$newId = tracks[newId]) != null && _tracks$newId.details) || newId < -1 || newId >= tracks.length) {
      return;
    }

    // stopping live reloading timer if any
    this.clearTimer();
    const track = tracks[newId];
    this.log(`Switching to subtitle-track ${newId}` + (track ? ` "${track.name}" lang:${track.lang} group:${track.groupId}` : ''));
    this.trackId = newId;
    if (track) {
      const {
        id,
        groupId = '',
        name,
        type,
        url
      } = track;
      this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
        id,
        groupId,
        name,
        type,
        url
      });
      const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details);
      this.loadPlaylist(hlsUrlParameters);
    } else {
      // switch to -1
      this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
        id: newId
      });
    }
  }
  onTextTracksChanged() {
    if (!this.useTextTrackPolling) {
      self.clearInterval(this.subtitlePollingInterval);
    }
    // Media is undefined when switching streams via loadSource()
    if (!this.media || !this.hls.config.renderTextTracksNatively) {
      return;
    }
    let trackId = -1;
    const tracks = filterSubtitleTracks(this.media.textTracks);
    for (let id = 0; id < tracks.length; id++) {
      if (tracks[id].mode === 'hidden') {
        // Do not break in case there is a following track with showing.
        trackId = id;
      } else if (tracks[id].mode === 'showing') {
        trackId = id;
        break;
      }
    }

    // Setting current subtitleTrack will invoke code.
    if (this.subtitleTrack !== trackId) {
      this.subtitleTrack = trackId;
    }
  }
}
function filterSubtitleTracks(textTrackList) {
  const tracks = [];
  for (let i = 0; i < textTrackList.length; i++) {
    const track = textTrackList[i];
    // Edge adds a track without a label; we don't want to use it
    if ((track.kind === 'subtitles' || track.kind === 'captions') && track.label) {
      tracks.push(textTrackList[i]);
    }
  }
  return tracks;
}

class BufferOperationQueue {
  constructor(sourceBufferReference) {
    this.buffers = void 0;
    this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    };
    this.buffers = sourceBufferReference;
  }
  append(operation, type) {
    const queue = this.queues[type];
    queue.push(operation);
    if (queue.length === 1 && this.buffers[type]) {
      this.executeNext(type);
    }
  }
  insertAbort(operation, type) {
    const queue = this.queues[type];
    queue.unshift(operation);
    this.executeNext(type);
  }
  appendBlocker(type) {
    let execute;
    const promise = new Promise(resolve => {
      execute = resolve;
    });
    const operation = {
      execute,
      onStart: () => {},
      onComplete: () => {},
      onError: () => {}
    };
    this.append(operation, type);
    return promise;
  }
  executeNext(type) {
    const {
      buffers,
      queues
    } = this;
    const sb = buffers[type];
    const queue = queues[type];
    if (queue.length) {
      const operation = queue[0];
      try {
        // Operations are expected to result in an 'updateend' event being fired. If not, the queue will lock. Operations
        // which do not end with this event must call _onSBUpdateEnd manually
        operation.execute();
      } catch (e) {
        logger.warn('[buffer-operation-queue]: Unhandled exception executing the current operation');
        operation.onError(e);

        // Only shift the current operation off, otherwise the updateend handler will do this for us
        if (!(sb != null && sb.updating)) {
          queue.shift();
          this.executeNext(type);
        }
      }
    }
  }
  shiftAndExecuteNext(type) {
    this.queues[type].shift();
    this.executeNext(type);
  }
  current(type) {
    return this.queues[type][0];
  }
}

const MediaSource = getMediaSource();
const VIDEO_CODEC_PROFILE_REPACE = /([ha]vc.)(?:\.[^.,]+)+/;
class BufferController {
  // The level details used to determine duration, target-duration and live

  // cache the self generated object url to detect hijack of video tag

  // A queue of buffer operations which require the SourceBuffer to not be updating upon execution

  // References to event listeners for each SourceBuffer, so that they can be referenced for event removal

  // The number of BUFFER_CODEC events received before any sourceBuffers are created

  // The total number of BUFFER_CODEC events received

  // A reference to the attached media element

  // A reference to the active media source

  // Last MP3 audio chunk appended

  // counters

  constructor(hls) {
    this.details = null;
    this._objectUrl = null;
    this.operationQueue = void 0;
    this.listeners = void 0;
    this.hls = void 0;
    this.bufferCodecEventsExpected = 0;
    this._bufferCodecEventsTotal = 0;
    this.media = null;
    this.mediaSource = null;
    this.lastMpegAudioChunk = null;
    this.appendError = 0;
    this.tracks = {};
    this.pendingTracks = {};
    this.sourceBuffer = void 0;
    // Keep as arrow functions so that we can directly reference these functions directly as event listeners
    this._onMediaSourceOpen = () => {
      const {
        media,
        mediaSource
      } = this;
      logger.log('[buffer-controller]: Media source opened');
      if (media) {
        media.removeEventListener('emptied', this._onMediaEmptied);
        this.updateMediaElementDuration();
        this.hls.trigger(Events.MEDIA_ATTACHED, {
          media
        });
      }
      if (mediaSource) {
        // once received, don't listen anymore to sourceopen event
        mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
      }
      this.checkPendingTracks();
    };
    this._onMediaSourceClose = () => {
      logger.log('[buffer-controller]: Media source closed');
    };
    this._onMediaSourceEnded = () => {
      logger.log('[buffer-controller]: Media source ended');
    };
    this._onMediaEmptied = () => {
      const {
        media,
        _objectUrl
      } = this;
      if (media && media.src !== _objectUrl) {
        logger.error(`Media element src was set while attaching MediaSource (${_objectUrl} > ${media.src})`);
      }
    };
    this.hls = hls;
    this._initSourceBuffer();
    this.registerListeners();
  }
  hasSourceTypes() {
    return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
  }
  destroy() {
    this.unregisterListeners();
    this.details = null;
    this.lastMpegAudioChunk = null;
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.on(Events.BUFFER_APPENDING, this.onBufferAppending, this);
    hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.on(Events.BUFFER_EOS, this.onBufferEos, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.on(Events.FRAG_PARSED, this.onFragParsed, this);
    hls.on(Events.FRAG_CHANGED, this.onFragChanged, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.off(Events.BUFFER_APPENDING, this.onBufferAppending, this);
    hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.off(Events.BUFFER_EOS, this.onBufferEos, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.off(Events.FRAG_PARSED, this.onFragParsed, this);
    hls.off(Events.FRAG_CHANGED, this.onFragChanged, this);
  }
  _initSourceBuffer() {
    this.sourceBuffer = {};
    this.operationQueue = new BufferOperationQueue(this.sourceBuffer);
    this.listeners = {
      audio: [],
      video: [],
      audiovideo: []
    };
    this.lastMpegAudioChunk = null;
  }
  onManifestLoading() {
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0;
    this.details = null;
  }
  onManifestParsed(event, data) {
    // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
    // sourcebuffers will be created all at once when the expected nb of tracks will be reached
    // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
    // it will contain the expected nb of source buffers, no need to compute it
    let codecEvents = 2;
    if (data.audio && !data.video || !data.altAudio || !true) {
      codecEvents = 1;
    }
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = codecEvents;
    logger.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
  }
  onMediaAttaching(event, data) {
    const media = this.media = data.media;
    if (media && MediaSource) {
      const ms = this.mediaSource = new MediaSource();
      // MediaSource listeners are arrow functions with a lexical scope, and do not need to be bound
      ms.addEventListener('sourceopen', this._onMediaSourceOpen);
      ms.addEventListener('sourceended', this._onMediaSourceEnded);
      ms.addEventListener('sourceclose', this._onMediaSourceClose);
      // link video and media Source
      media.src = self.URL.createObjectURL(ms);
      // cache the locally generated object url
      this._objectUrl = media.src;
      media.addEventListener('emptied', this._onMediaEmptied);
    }
  }
  onMediaDetaching() {
    const {
      media,
      mediaSource,
      _objectUrl
    } = this;
    if (mediaSource) {
      logger.log('[buffer-controller]: media source detaching');
      if (mediaSource.readyState === 'open') {
        try {
          // endOfStream could trigger exception if any sourcebuffer is in updating state
          // we don't really care about checking sourcebuffer state here,
          // as we are anyway detaching the MediaSource
          // let's just avoid this exception to propagate
          mediaSource.endOfStream();
        } catch (err) {
          logger.warn(`[buffer-controller]: onMediaDetaching: ${err.message} while calling endOfStream`);
        }
      }
      // Clean up the SourceBuffers by invoking onBufferReset
      this.onBufferReset();
      mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
      mediaSource.removeEventListener('sourceended', this._onMediaSourceEnded);
      mediaSource.removeEventListener('sourceclose', this._onMediaSourceClose);

      // Detach properly the MediaSource from the HTMLMediaElement as
      // suggested in https://github.com/w3c/media-source/issues/53.
      if (media) {
        media.removeEventListener('emptied', this._onMediaEmptied);
        if (_objectUrl) {
          self.URL.revokeObjectURL(_objectUrl);
        }

        // clean up video tag src only if it's our own url. some external libraries might
        // hijack the video tag and change its 'src' without destroying the Hls instance first
        if (media.src === _objectUrl) {
          media.removeAttribute('src');
          media.load();
        } else {
          logger.warn('[buffer-controller]: media.src was changed by a third party - skip cleanup');
        }
      }
      this.mediaSource = null;
      this.media = null;
      this._objectUrl = null;
      this.bufferCodecEventsExpected = this._bufferCodecEventsTotal;
      this.pendingTracks = {};
      this.tracks = {};
    }
    this.hls.trigger(Events.MEDIA_DETACHED, undefined);
  }
  onBufferReset() {
    this.getSourceBufferTypes().forEach(type => {
      const sb = this.sourceBuffer[type];
      try {
        if (sb) {
          this.removeBufferListeners(type);
          if (this.mediaSource) {
            this.mediaSource.removeSourceBuffer(sb);
          }
          // Synchronously remove the SB from the map before the next call in order to prevent an async function from
          // accessing it
          this.sourceBuffer[type] = undefined;
        }
      } catch (err) {
        logger.warn(`[buffer-controller]: Failed to reset the ${type} buffer`, err);
      }
    });
    this._initSourceBuffer();
  }
  onBufferCodecs(event, data) {
    const sourceBufferCount = this.getSourceBufferTypes().length;
    Object.keys(data).forEach(trackName => {
      if (sourceBufferCount) {
        // check if SourceBuffer codec needs to change
        const track = this.tracks[trackName];
        if (track && typeof track.buffer.changeType === 'function') {
          const {
            id,
            codec,
            levelCodec,
            container,
            metadata
          } = data[trackName];
          const currentCodec = (track.levelCodec || track.codec).replace(VIDEO_CODEC_PROFILE_REPACE, '$1');
          const nextCodec = (levelCodec || codec).replace(VIDEO_CODEC_PROFILE_REPACE, '$1');
          if (currentCodec !== nextCodec) {
            const mimeType = `${container};codecs=${levelCodec || codec}`;
            this.appendChangeType(trackName, mimeType);
            logger.log(`[buffer-controller]: switching codec ${currentCodec} to ${nextCodec}`);
            this.tracks[trackName] = {
              buffer: track.buffer,
              codec,
              container,
              levelCodec,
              metadata,
              id
            };
          }
        }
      } else {
        // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
        this.pendingTracks[trackName] = data[trackName];
      }
    });

    // if sourcebuffers already created, do nothing ...
    if (sourceBufferCount) {
      return;
    }
    this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0);
    if (this.mediaSource && this.mediaSource.readyState === 'open') {
      this.checkPendingTracks();
    }
  }
  appendChangeType(type, mimeType) {
    const {
      operationQueue
    } = this;
    const operation = {
      execute: () => {
        const sb = this.sourceBuffer[type];
        if (sb) {
          logger.log(`[buffer-controller]: changing ${type} sourceBuffer type to ${mimeType}`);
          sb.changeType(mimeType);
        }
        operationQueue.shiftAndExecuteNext(type);
      },
      onStart: () => {},
      onComplete: () => {},
      onError: e => {
        logger.warn(`[buffer-controller]: Failed to change ${type} SourceBuffer type`, e);
      }
    };
    operationQueue.append(operation, type);
  }
  onBufferAppending(event, eventData) {
    const {
      hls,
      operationQueue,
      tracks
    } = this;
    const {
      data,
      type,
      frag,
      part,
      chunkMeta
    } = eventData;
    const chunkStats = chunkMeta.buffering[type];
    const bufferAppendingStart = self.performance.now();
    chunkStats.start = bufferAppendingStart;
    const fragBuffering = frag.stats.buffering;
    const partBuffering = part ? part.stats.buffering : null;
    if (fragBuffering.start === 0) {
      fragBuffering.start = bufferAppendingStart;
    }
    if (partBuffering && partBuffering.start === 0) {
      partBuffering.start = bufferAppendingStart;
    }

    // TODO: Only update timestampOffset when audio/mpeg fragment or part is not contiguous with previously appended
    // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
    // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
    // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos).
    // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
    const audioTrack = tracks.audio;
    let checkTimestampOffset = false;
    if (type === 'audio' && (audioTrack == null ? void 0 : audioTrack.container) === 'audio/mpeg') {
      checkTimestampOffset = !this.lastMpegAudioChunk || chunkMeta.id === 1 || this.lastMpegAudioChunk.sn !== chunkMeta.sn;
      this.lastMpegAudioChunk = chunkMeta;
    }
    const fragStart = frag.start;
    const operation = {
      execute: () => {
        chunkStats.executeStart = self.performance.now();
        if (checkTimestampOffset) {
          const sb = this.sourceBuffer[type];
          if (sb) {
            const delta = fragStart - sb.timestampOffset;
            if (Math.abs(delta) >= 0.1) {
              logger.log(`[buffer-controller]: Updating audio SourceBuffer timestampOffset to ${fragStart} (delta: ${delta}) sn: ${frag.sn})`);
              sb.timestampOffset = fragStart;
            }
          }
        }
        this.appendExecutor(data, type);
      },
      onStart: () => {
        // logger.debug(`[buffer-controller]: ${type} SourceBuffer updatestart`);
      },
      onComplete: () => {
        // logger.debug(`[buffer-controller]: ${type} SourceBuffer updateend`);
        const end = self.performance.now();
        chunkStats.executeEnd = chunkStats.end = end;
        if (fragBuffering.first === 0) {
          fragBuffering.first = end;
        }
        if (partBuffering && partBuffering.first === 0) {
          partBuffering.first = end;
        }
        const {
          sourceBuffer
        } = this;
        const timeRanges = {};
        for (const type in sourceBuffer) {
          timeRanges[type] = BufferHelper.getBuffered(sourceBuffer[type]);
        }
        this.appendError = 0;
        this.hls.trigger(Events.BUFFER_APPENDED, {
          type,
          frag,
          part,
          chunkMeta,
          parent: frag.type,
          timeRanges
        });
      },
      onError: err => {
        // in case any error occured while appending, put back segment in segments table
        logger.error(`[buffer-controller]: Error encountered while trying to append to the ${type} SourceBuffer`, err);
        const event = {
          type: ErrorTypes.MEDIA_ERROR,
          parent: frag.type,
          details: ErrorDetails.BUFFER_APPEND_ERROR,
          frag,
          part,
          chunkMeta,
          error: err,
          err,
          fatal: false
        };
        if (err.code === DOMException.QUOTA_EXCEEDED_ERR) {
          // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
          // let's stop appending any segments, and report BUFFER_FULL_ERROR error
          event.details = ErrorDetails.BUFFER_FULL_ERROR;
        } else {
          this.appendError++;
          event.details = ErrorDetails.BUFFER_APPEND_ERROR;
          /* with UHD content, we could get loop of quota exceeded error until
            browser is able to evict some data from sourcebuffer. Retrying can help recover.
          */
          if (this.appendError > hls.config.appendErrorMaxRetry) {
            logger.error(`[buffer-controller]: Failed ${hls.config.appendErrorMaxRetry} times to append segment in sourceBuffer`);
            event.fatal = true;
          }
        }
        hls.trigger(Events.ERROR, event);
      }
    };
    operationQueue.append(operation, type);
  }
  onBufferFlushing(event, data) {
    const {
      operationQueue
    } = this;
    const flushOperation = type => ({
      execute: this.removeExecutor.bind(this, type, data.startOffset, data.endOffset),
      onStart: () => {
        // logger.debug(`[buffer-controller]: Started flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
      },
      onComplete: () => {
        // logger.debug(`[buffer-controller]: Finished flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
        this.hls.trigger(Events.BUFFER_FLUSHED, {
          type
        });
      },
      onError: e => {
        logger.warn(`[buffer-controller]: Failed to remove from ${type} SourceBuffer`, e);
      }
    });
    if (data.type) {
      operationQueue.append(flushOperation(data.type), data.type);
    } else {
      this.getSourceBufferTypes().forEach(type => {
        operationQueue.append(flushOperation(type), type);
      });
    }
  }
  onFragParsed(event, data) {
    const {
      frag,
      part
    } = data;
    const buffersAppendedTo = [];
    const elementaryStreams = part ? part.elementaryStreams : frag.elementaryStreams;
    if (elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO]) {
      buffersAppendedTo.push('audiovideo');
    } else {
      if (elementaryStreams[ElementaryStreamTypes.AUDIO]) {
        buffersAppendedTo.push('audio');
      }
      if (elementaryStreams[ElementaryStreamTypes.VIDEO]) {
        buffersAppendedTo.push('video');
      }
    }
    const onUnblocked = () => {
      const now = self.performance.now();
      frag.stats.buffering.end = now;
      if (part) {
        part.stats.buffering.end = now;
      }
      const stats = part ? part.stats : frag.stats;
      this.hls.trigger(Events.FRAG_BUFFERED, {
        frag,
        part,
        stats,
        id: frag.type
      });
    };
    if (buffersAppendedTo.length === 0) {
      logger.warn(`Fragments must have at least one ElementaryStreamType set. type: ${frag.type} level: ${frag.level} sn: ${frag.sn}`);
    }
    this.blockBuffers(onUnblocked, buffersAppendedTo);
  }
  onFragChanged(event, data) {
    this.flushBackBuffer();
  }

  // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(event, data) {
    const ended = this.getSourceBufferTypes().reduce((acc, type) => {
      const sb = this.sourceBuffer[type];
      if (sb && (!data.type || data.type === type)) {
        sb.ending = true;
        if (!sb.ended) {
          sb.ended = true;
          logger.log(`[buffer-controller]: ${type} sourceBuffer now EOS`);
        }
      }
      return acc && !!(!sb || sb.ended);
    }, true);
    if (ended) {
      logger.log(`[buffer-controller]: Queueing mediaSource.endOfStream()`);
      this.blockBuffers(() => {
        this.getSourceBufferTypes().forEach(type => {
          const sb = this.sourceBuffer[type];
          if (sb) {
            sb.ending = false;
          }
        });
        const {
          mediaSource
        } = this;
        if (!mediaSource || mediaSource.readyState !== 'open') {
          if (mediaSource) {
            logger.info(`[buffer-controller]: Could not call mediaSource.endOfStream(). mediaSource.readyState: ${mediaSource.readyState}`);
          }
          return;
        }
        logger.log(`[buffer-controller]: Calling mediaSource.endOfStream()`);
        // Allow this to throw and be caught by the enqueueing function
        mediaSource.endOfStream();
      });
    }
  }
  onLevelUpdated(event, {
    details
  }) {
    if (!details.fragments.length) {
      return;
    }
    this.details = details;
    if (this.getSourceBufferTypes().length) {
      this.blockBuffers(this.updateMediaElementDuration.bind(this));
    } else {
      this.updateMediaElementDuration();
    }
  }
  flushBackBuffer() {
    const {
      hls,
      details,
      media,
      sourceBuffer
    } = this;
    if (!media || details === null) {
      return;
    }
    const sourceBufferTypes = this.getSourceBufferTypes();
    if (!sourceBufferTypes.length) {
      return;
    }

    // Support for deprecated liveBackBufferLength
    const backBufferLength = details.live && hls.config.liveBackBufferLength !== null ? hls.config.liveBackBufferLength : hls.config.backBufferLength;
    if (!isFiniteNumber(backBufferLength) || backBufferLength < 0) {
      return;
    }
    const currentTime = media.currentTime;
    const targetDuration = details.levelTargetDuration;
    const maxBackBufferLength = Math.max(backBufferLength, targetDuration);
    const targetBackBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration - maxBackBufferLength;
    sourceBufferTypes.forEach(type => {
      const sb = sourceBuffer[type];
      if (sb) {
        const buffered = BufferHelper.getBuffered(sb);
        // when target buffer start exceeds actual buffer start
        if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
          hls.trigger(Events.BACK_BUFFER_REACHED, {
            bufferEnd: targetBackBufferPosition
          });

          // Support for deprecated event:
          if (details.live) {
            hls.trigger(Events.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: targetBackBufferPosition
            });
          } else if (sb.ended && buffered.end(buffered.length - 1) - currentTime < targetDuration * 2) {
            logger.info(`[buffer-controller]: Cannot flush ${type} back buffer while SourceBuffer is in ended state`);
            return;
          }
          hls.trigger(Events.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: targetBackBufferPosition,
            type
          });
        }
      }
    });
  }

  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  updateMediaElementDuration() {
    if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== 'open') {
      return;
    }
    const {
      details,
      hls,
      media,
      mediaSource
    } = this;
    const levelDuration = details.fragments[0].start + details.totalduration;
    const mediaDuration = media.duration;
    const msDuration = isFiniteNumber(mediaSource.duration) ? mediaSource.duration : 0;
    if (details.live && hls.config.liveDurationInfinity) {
      // Override duration to Infinity
      logger.log('[buffer-controller]: Media Source duration is set to Infinity');
      mediaSource.duration = Infinity;
      this.updateSeekableRange(details);
    } else if (levelDuration > msDuration && levelDuration > mediaDuration || !isFiniteNumber(mediaDuration)) {
      // levelDuration was the last value we set.
      // not using mediaSource.duration as the browser may tweak this value
      // only update Media Source duration if its value increase, this is to avoid
      // flushing already buffered portion when switching between quality level
      logger.log(`[buffer-controller]: Updating Media Source duration to ${levelDuration.toFixed(3)}`);
      mediaSource.duration = levelDuration;
    }
  }
  updateSeekableRange(levelDetails) {
    const mediaSource = this.mediaSource;
    const fragments = levelDetails.fragments;
    const len = fragments.length;
    if (len && levelDetails.live && mediaSource != null && mediaSource.setLiveSeekableRange) {
      const start = Math.max(0, fragments[0].start);
      const end = Math.max(start, start + levelDetails.totalduration);
      mediaSource.setLiveSeekableRange(start, end);
    }
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsExpected,
      operationQueue,
      pendingTracks
    } = this;

    // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
    // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
    // data has been appended to existing ones.
    // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
    const pendingTracksCount = Object.keys(pendingTracks).length;
    if (pendingTracksCount && !bufferCodecEventsExpected || pendingTracksCount === 2) {
      // ok, let's create them now !
      this.createSourceBuffers(pendingTracks);
      this.pendingTracks = {};
      // append any pending segments now !
      const buffers = this.getSourceBufferTypes();
      if (buffers.length) {
        this.hls.trigger(Events.BUFFER_CREATED, {
          tracks: this.tracks
        });
        buffers.forEach(type => {
          operationQueue.executeNext(type);
        });
      } else {
        const error = new Error('could not create source buffer for media codec(s)');
        this.hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
          fatal: true,
          error,
          reason: error.message
        });
      }
    }
  }
  createSourceBuffers(tracks) {
    const {
      sourceBuffer,
      mediaSource
    } = this;
    if (!mediaSource) {
      throw Error('createSourceBuffers called when mediaSource was null');
    }
    for (const trackName in tracks) {
      if (!sourceBuffer[trackName]) {
        const track = tracks[trackName];
        if (!track) {
          throw Error(`source buffer exists for track ${trackName}, however track does not`);
        }
        // use levelCodec as first priority
        const codec = track.levelCodec || track.codec;
        const mimeType = `${track.container};codecs=${codec}`;
        logger.log(`[buffer-controller]: creating sourceBuffer(${mimeType})`);
        try {
          const sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
          const sbName = trackName;
          this.addBufferListener(sbName, 'updatestart', this._onSBUpdateStart);
          this.addBufferListener(sbName, 'updateend', this._onSBUpdateEnd);
          this.addBufferListener(sbName, 'error', this._onSBUpdateError);
          this.tracks[trackName] = {
            buffer: sb,
            codec: codec,
            container: track.container,
            levelCodec: track.levelCodec,
            metadata: track.metadata,
            id: track.id
          };
        } catch (err) {
          logger.error(`[buffer-controller]: error while trying to add sourceBuffer: ${err.message}`);
          this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.BUFFER_ADD_CODEC_ERROR,
            fatal: false,
            error: err,
            mimeType: mimeType
          });
        }
      }
    }
  }
  _onSBUpdateStart(type) {
    const {
      operationQueue
    } = this;
    const operation = operationQueue.current(type);
    operation.onStart();
  }
  _onSBUpdateEnd(type) {
    const {
      operationQueue
    } = this;
    const operation = operationQueue.current(type);
    operation.onComplete();
    operationQueue.shiftAndExecuteNext(type);
  }
  _onSBUpdateError(type, event) {
    const error = new Error(`${type} SourceBuffer error`);
    logger.error(`[buffer-controller]: ${error}`, event);
    // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
    // SourceBuffer errors are not necessarily fatal; if so, the HTMLMediaElement will fire an error event
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.BUFFER_APPENDING_ERROR,
      error,
      fatal: false
    });
    // updateend is always fired after error, so we'll allow that to shift the current operation off of the queue
    const operation = this.operationQueue.current(type);
    if (operation) {
      operation.onError(event);
    }
  }

  // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
  removeExecutor(type, startOffset, endOffset) {
    const {
      media,
      mediaSource,
      operationQueue,
      sourceBuffer
    } = this;
    const sb = sourceBuffer[type];
    if (!media || !mediaSource || !sb) {
      logger.warn(`[buffer-controller]: Attempting to remove from the ${type} SourceBuffer, but it does not exist`);
      operationQueue.shiftAndExecuteNext(type);
      return;
    }
    const mediaDuration = isFiniteNumber(media.duration) ? media.duration : Infinity;
    const msDuration = isFiniteNumber(mediaSource.duration) ? mediaSource.duration : Infinity;
    const removeStart = Math.max(0, startOffset);
    const removeEnd = Math.min(endOffset, mediaDuration, msDuration);
    if (removeEnd > removeStart && !sb.ending) {
      sb.ended = false;
      logger.log(`[buffer-controller]: Removing [${removeStart},${removeEnd}] from the ${type} SourceBuffer`);
      sb.remove(removeStart, removeEnd);
    } else {
      // Cycle the queue
      operationQueue.shiftAndExecuteNext(type);
    }
  }

  // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
  appendExecutor(data, type) {
    const {
      operationQueue,
      sourceBuffer
    } = this;
    const sb = sourceBuffer[type];
    if (!sb) {
      logger.warn(`[buffer-controller]: Attempting to append to the ${type} SourceBuffer, but it does not exist`);
      operationQueue.shiftAndExecuteNext(type);
      return;
    }
    sb.ended = false;
    sb.appendBuffer(data);
  }

  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(onUnblocked, buffers = this.getSourceBufferTypes()) {
    if (!buffers.length) {
      logger.log('[buffer-controller]: Blocking operation requested, but no SourceBuffers exist');
      Promise.resolve().then(onUnblocked);
      return;
    }
    const {
      operationQueue
    } = this;

    // logger.debug(`[buffer-controller]: Blocking ${buffers} SourceBuffer`);
    const blockingOperations = buffers.map(type => operationQueue.appendBlocker(type));
    Promise.all(blockingOperations).then(() => {
      // logger.debug(`[buffer-controller]: Blocking operation resolved; unblocking ${buffers} SourceBuffer`);
      onUnblocked();
      buffers.forEach(type => {
        const sb = this.sourceBuffer[type];
        // Only cycle the queue if the SB is not updating. There's a bug in Chrome which sets the SB updating flag to
        // true when changing the MediaSource duration (https://bugs.chromium.org/p/chromium/issues/detail?id=959359&can=2&q=mediasource%20duration)
        // While this is a workaround, it's probably useful to have around
        if (!(sb != null && sb.updating)) {
          operationQueue.shiftAndExecuteNext(type);
        }
      });
    });
  }
  getSourceBufferTypes() {
    return Object.keys(this.sourceBuffer);
  }
  addBufferListener(type, event, fn) {
    const buffer = this.sourceBuffer[type];
    if (!buffer) {
      return;
    }
    const listener = fn.bind(this, type);
    this.listeners[type].push({
      event,
      listener
    });
    buffer.addEventListener(event, listener);
  }
  removeBufferListeners(type) {
    const buffer = this.sourceBuffer[type];
    if (!buffer) {
      return;
    }
    this.listeners[type].forEach(l => {
      buffer.removeEventListener(l.event, l.listener);
    });
  }
}

/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
 */

const specialCea608CharsCodes = {
  0x2a: 0xe1,
  // lowercase a, acute accent
  0x5c: 0xe9,
  // lowercase e, acute accent
  0x5e: 0xed,
  // lowercase i, acute accent
  0x5f: 0xf3,
  // lowercase o, acute accent
  0x60: 0xfa,
  // lowercase u, acute accent
  0x7b: 0xe7,
  // lowercase c with cedilla
  0x7c: 0xf7,
  // division symbol
  0x7d: 0xd1,
  // uppercase N tilde
  0x7e: 0xf1,
  // lowercase n tilde
  0x7f: 0x2588,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  0x80: 0xae,
  // Registered symbol (R)
  0x81: 0xb0,
  // degree sign
  0x82: 0xbd,
  // 1/2 symbol
  0x83: 0xbf,
  // Inverted (open) question mark
  0x84: 0x2122,
  // Trademark symbol (TM)
  0x85: 0xa2,
  // Cents symbol
  0x86: 0xa3,
  // Pounds sterling
  0x87: 0x266a,
  // Music 8'th note
  0x88: 0xe0,
  // lowercase a, grave accent
  0x89: 0x20,
  // transparent space (regular)
  0x8a: 0xe8,
  // lowercase e, grave accent
  0x8b: 0xe2,
  // lowercase a, circumflex accent
  0x8c: 0xea,
  // lowercase e, circumflex accent
  0x8d: 0xee,
  // lowercase i, circumflex accent
  0x8e: 0xf4,
  // lowercase o, circumflex accent
  0x8f: 0xfb,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  0x90: 0xc1,
  // capital letter A with acute
  0x91: 0xc9,
  // capital letter E with acute
  0x92: 0xd3,
  // capital letter O with acute
  0x93: 0xda,
  // capital letter U with acute
  0x94: 0xdc,
  // capital letter U with diaresis
  0x95: 0xfc,
  // lowercase letter U with diaeresis
  0x96: 0x2018,
  // opening single quote
  0x97: 0xa1,
  // inverted exclamation mark
  0x98: 0x2a,
  // asterisk
  0x99: 0x2019,
  // closing single quote
  0x9a: 0x2501,
  // box drawings heavy horizontal
  0x9b: 0xa9,
  // copyright sign
  0x9c: 0x2120,
  // Service mark
  0x9d: 0x2022,
  // (round) bullet
  0x9e: 0x201c,
  // Left double quotation mark
  0x9f: 0x201d,
  // Right double quotation mark
  0xa0: 0xc0,
  // uppercase A, grave accent
  0xa1: 0xc2,
  // uppercase A, circumflex
  0xa2: 0xc7,
  // uppercase C with cedilla
  0xa3: 0xc8,
  // uppercase E, grave accent
  0xa4: 0xca,
  // uppercase E, circumflex
  0xa5: 0xcb,
  // capital letter E with diaresis
  0xa6: 0xeb,
  // lowercase letter e with diaresis
  0xa7: 0xce,
  // uppercase I, circumflex
  0xa8: 0xcf,
  // uppercase I, with diaresis
  0xa9: 0xef,
  // lowercase i, with diaresis
  0xaa: 0xd4,
  // uppercase O, circumflex
  0xab: 0xd9,
  // uppercase U, grave accent
  0xac: 0xf9,
  // lowercase u, grave accent
  0xad: 0xdb,
  // uppercase U, circumflex
  0xae: 0xab,
  // left-pointing double angle quotation mark
  0xaf: 0xbb,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  0xb0: 0xc3,
  // Uppercase A, tilde
  0xb1: 0xe3,
  // Lowercase a, tilde
  0xb2: 0xcd,
  // Uppercase I, acute accent
  0xb3: 0xcc,
  // Uppercase I, grave accent
  0xb4: 0xec,
  // Lowercase i, grave accent
  0xb5: 0xd2,
  // Uppercase O, grave accent
  0xb6: 0xf2,
  // Lowercase o, grave accent
  0xb7: 0xd5,
  // Uppercase O, tilde
  0xb8: 0xf5,
  // Lowercase o, tilde
  0xb9: 0x7b,
  // Open curly brace
  0xba: 0x7d,
  // Closing curly brace
  0xbb: 0x5c,
  // Backslash
  0xbc: 0x5e,
  // Caret
  0xbd: 0x5f,
  // Underscore
  0xbe: 0x7c,
  // Pipe (vertical line)
  0xbf: 0x223c,
  // Tilde operator
  0xc0: 0xc4,
  // Uppercase A, umlaut
  0xc1: 0xe4,
  // Lowercase A, umlaut
  0xc2: 0xd6,
  // Uppercase O, umlaut
  0xc3: 0xf6,
  // Lowercase o, umlaut
  0xc4: 0xdf,
  // Esszett (sharp S)
  0xc5: 0xa5,
  // Yen symbol
  0xc6: 0xa4,
  // Generic currency sign
  0xc7: 0x2503,
  // Box drawings heavy vertical
  0xc8: 0xc5,
  // Uppercase A, ring
  0xc9: 0xe5,
  // Lowercase A, ring
  0xca: 0xd8,
  // Uppercase O, stroke
  0xcb: 0xf8,
  // Lowercase o, strok
  0xcc: 0x250f,
  // Box drawings heavy down and right
  0xcd: 0x2513,
  // Box drawings heavy down and left
  0xce: 0x2517,
  // Box drawings heavy up and right
  0xcf: 0x251b // Box drawings heavy up and left
};

/**
 * Utils
 */
const getCharForByte = function getCharForByte(byte) {
  let charCode = byte;
  if (specialCea608CharsCodes.hasOwnProperty(byte)) {
    charCode = specialCea608CharsCodes[byte];
  }
  return String.fromCharCode(charCode);
};
const NR_ROWS = 15;
const NR_COLS = 100;
// Tables to look up row from PAC data
const rowsLowCh1 = {
  0x11: 1,
  0x12: 3,
  0x15: 5,
  0x16: 7,
  0x17: 9,
  0x10: 11,
  0x13: 12,
  0x14: 14
};
const rowsHighCh1 = {
  0x11: 2,
  0x12: 4,
  0x15: 6,
  0x16: 8,
  0x17: 10,
  0x13: 13,
  0x14: 15
};
const rowsLowCh2 = {
  0x19: 1,
  0x1a: 3,
  0x1d: 5,
  0x1e: 7,
  0x1f: 9,
  0x18: 11,
  0x1b: 12,
  0x1c: 14
};
const rowsHighCh2 = {
  0x19: 2,
  0x1a: 4,
  0x1d: 6,
  0x1e: 8,
  0x1f: 10,
  0x1b: 13,
  0x1c: 15
};
const backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];
class CaptionsLogger {
  constructor() {
    this.time = null;
    this.verboseLevel = 0;
  }
  log(severity, msg) {
    if (this.verboseLevel >= severity) {
      const m = typeof msg === 'function' ? msg() : msg;
      logger.log(`${this.time} [${severity}] ${m}`);
    }
  }
}
const numArrayToHexArray = function numArrayToHexArray(numArray) {
  const hexArray = [];
  for (let j = 0; j < numArray.length; j++) {
    hexArray.push(numArray[j].toString(16));
  }
  return hexArray;
};
class PenState {
  constructor(foreground, underline, italics, background, flash) {
    this.foreground = void 0;
    this.underline = void 0;
    this.italics = void 0;
    this.background = void 0;
    this.flash = void 0;
    this.foreground = foreground || 'white';
    this.underline = underline || false;
    this.italics = italics || false;
    this.background = background || 'black';
    this.flash = flash || false;
  }
  reset() {
    this.foreground = 'white';
    this.underline = false;
    this.italics = false;
    this.background = 'black';
    this.flash = false;
  }
  setStyles(styles) {
    const attribs = ['foreground', 'underline', 'italics', 'background', 'flash'];
    for (let i = 0; i < attribs.length; i++) {
      const style = attribs[i];
      if (styles.hasOwnProperty(style)) {
        this[style] = styles[style];
      }
    }
  }
  isDefault() {
    return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
  }
  equals(other) {
    return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
  }
  copy(newPenState) {
    this.foreground = newPenState.foreground;
    this.underline = newPenState.underline;
    this.italics = newPenState.italics;
    this.background = newPenState.background;
    this.flash = newPenState.flash;
  }
  toString() {
    return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
  }
}

/**
 * Unicode character with styling and background.
 * @constructor
 */
class StyledUnicodeChar {
  constructor(uchar, foreground, underline, italics, background, flash) {
    this.uchar = void 0;
    this.penState = void 0;
    this.uchar = uchar || ' '; // unicode character
    this.penState = new PenState(foreground, underline, italics, background, flash);
  }
  reset() {
    this.uchar = ' ';
    this.penState.reset();
  }
  setChar(uchar, newPenState) {
    this.uchar = uchar;
    this.penState.copy(newPenState);
  }
  setPenState(newPenState) {
    this.penState.copy(newPenState);
  }
  equals(other) {
    return this.uchar === other.uchar && this.penState.equals(other.penState);
  }
  copy(newChar) {
    this.uchar = newChar.uchar;
    this.penState.copy(newChar.penState);
  }
  isEmpty() {
    return this.uchar === ' ' && this.penState.isDefault();
  }
}

/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */
class Row {
  constructor(logger) {
    this.chars = void 0;
    this.pos = void 0;
    this.currPenState = void 0;
    this.cueStartTime = void 0;
    this.logger = void 0;
    this.chars = [];
    for (let i = 0; i < NR_COLS; i++) {
      this.chars.push(new StyledUnicodeChar());
    }
    this.logger = logger;
    this.pos = 0;
    this.currPenState = new PenState();
  }
  equals(other) {
    let equal = true;
    for (let i = 0; i < NR_COLS; i++) {
      if (!this.chars[i].equals(other.chars[i])) {
        equal = false;
        break;
      }
    }
    return equal;
  }
  copy(other) {
    for (let i = 0; i < NR_COLS; i++) {
      this.chars[i].copy(other.chars[i]);
    }
  }
  isEmpty() {
    let empty = true;
    for (let i = 0; i < NR_COLS; i++) {
      if (!this.chars[i].isEmpty()) {
        empty = false;
        break;
      }
    }
    return empty;
  }

  /**
   *  Set the cursor to a valid column.
   */
  setCursor(absPos) {
    if (this.pos !== absPos) {
      this.pos = absPos;
    }
    if (this.pos < 0) {
      this.logger.log(3, 'Negative cursor position ' + this.pos);
      this.pos = 0;
    } else if (this.pos > NR_COLS) {
      this.logger.log(3, 'Too large cursor position ' + this.pos);
      this.pos = NR_COLS;
    }
  }

  /**
   * Move the cursor relative to current position.
   */
  moveCursor(relPos) {
    const newPos = this.pos + relPos;
    if (relPos > 1) {
      for (let i = this.pos + 1; i < newPos + 1; i++) {
        this.chars[i].setPenState(this.currPenState);
      }
    }
    this.setCursor(newPos);
  }

  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1);
    this.chars[this.pos].setChar(' ', this.currPenState);
  }
  insertChar(byte) {
    if (byte >= 0x90) {
      // Extended char
      this.backSpace();
    }
    const char = getCharForByte(byte);
    if (this.pos >= NR_COLS) {
      this.logger.log(0, () => 'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
      return;
    }
    this.chars[this.pos].setChar(char, this.currPenState);
    this.moveCursor(1);
  }
  clearFromPos(startPos) {
    let i;
    for (i = startPos; i < NR_COLS; i++) {
      this.chars[i].reset();
    }
  }
  clear() {
    this.clearFromPos(0);
    this.pos = 0;
    this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const chars = [];
    let empty = true;
    for (let i = 0; i < NR_COLS; i++) {
      const char = this.chars[i].uchar;
      if (char !== ' ') {
        empty = false;
      }
      chars.push(char);
    }
    if (empty) {
      return '';
    } else {
      return chars.join('');
    }
  }
  setPenStyles(styles) {
    this.currPenState.setStyles(styles);
    const currChar = this.chars[this.pos];
    currChar.setPenState(this.currPenState);
  }
}

/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
 */
class CaptionScreen {
  constructor(logger) {
    this.rows = void 0;
    this.currRow = void 0;
    this.nrRollUpRows = void 0;
    this.lastOutputScreen = void 0;
    this.logger = void 0;
    this.rows = [];
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows.push(new Row(logger));
    } // Note that we use zero-based numbering (0-14)

    this.logger = logger;
    this.currRow = NR_ROWS - 1;
    this.nrRollUpRows = null;
    this.lastOutputScreen = null;
    this.reset();
  }
  reset() {
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows[i].clear();
    }
    this.currRow = NR_ROWS - 1;
  }
  equals(other) {
    let equal = true;
    for (let i = 0; i < NR_ROWS; i++) {
      if (!this.rows[i].equals(other.rows[i])) {
        equal = false;
        break;
      }
    }
    return equal;
  }
  copy(other) {
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows[i].copy(other.rows[i]);
    }
  }
  isEmpty() {
    let empty = true;
    for (let i = 0; i < NR_ROWS; i++) {
      if (!this.rows[i].isEmpty()) {
        empty = false;
        break;
      }
    }
    return empty;
  }
  backSpace() {
    const row = this.rows[this.currRow];
    row.backSpace();
  }
  clearToEndOfRow() {
    const row = this.rows[this.currRow];
    row.clearToEndOfRow();
  }

  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(char) {
    const row = this.rows[this.currRow];
    row.insertChar(char);
  }
  setPen(styles) {
    const row = this.rows[this.currRow];
    row.setPenStyles(styles);
  }
  moveCursor(relPos) {
    const row = this.rows[this.currRow];
    row.moveCursor(relPos);
  }
  setCursor(absPos) {
    this.logger.log(2, 'setCursor: ' + absPos);
    const row = this.rows[this.currRow];
    row.setCursor(absPos);
  }
  setPAC(pacData) {
    this.logger.log(2, () => 'pacData = ' + JSON.stringify(pacData));
    let newRow = pacData.row - 1;
    if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
      newRow = this.nrRollUpRows - 1;
    }

    // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
    if (this.nrRollUpRows && this.currRow !== newRow) {
      // clear all rows first
      for (let i = 0; i < NR_ROWS; i++) {
        this.rows[i].clear();
      }

      // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
      // topRowIndex - the start of rows to copy (inclusive index)
      const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
      // We only copy if the last position was already shown.
      // We use the cueStartTime value to check this.
      const lastOutputScreen = this.lastOutputScreen;
      if (lastOutputScreen) {
        const prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
        const time = this.logger.time;
        if (prevLineTime && time !== null && prevLineTime < time) {
          for (let i = 0; i < this.nrRollUpRows; i++) {
            this.rows[newRow - this.nrRollUpRows + i + 1].copy(lastOutputScreen.rows[topRowIndex + i]);
          }
        }
      }
    }
    this.currRow = newRow;
    const row = this.rows[this.currRow];
    if (pacData.indent !== null) {
      const indent = pacData.indent;
      const prevPos = Math.max(indent - 1, 0);
      row.setCursor(pacData.indent);
      pacData.color = row.chars[prevPos].penState.foreground;
    }
    const styles = {
      foreground: pacData.color,
      underline: pacData.underline,
      italics: pacData.italics,
      background: 'black',
      flash: false
    };
    this.setPen(styles);
  }

  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(bkgData) {
    this.logger.log(2, () => 'bkgData = ' + JSON.stringify(bkgData));
    this.backSpace();
    this.setPen(bkgData);
    this.insertChar(0x20); // Space
  }

  setRollUpRows(nrRows) {
    this.nrRollUpRows = nrRows;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, 'roll_up but nrRollUpRows not set yet');
      return; // Not properly setup
    }

    this.logger.log(1, () => this.getDisplayText());
    const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
    const topRow = this.rows.splice(topRowIndex, 1)[0];
    topRow.clear();
    this.rows.splice(this.currRow, 0, topRow);
    this.logger.log(2, 'Rolling up');
    // this.logger.log(VerboseLevel.TEXT, this.get_display_text())
  }

  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(asOneRow) {
    asOneRow = asOneRow || false;
    const displayText = [];
    let text = '';
    let rowNr = -1;
    for (let i = 0; i < NR_ROWS; i++) {
      const rowText = this.rows[i].getTextString();
      if (rowText) {
        rowNr = i + 1;
        if (asOneRow) {
          displayText.push('Row ' + rowNr + ": '" + rowText + "'");
        } else {
          displayText.push(rowText.trim());
        }
      }
    }
    if (displayText.length > 0) {
      if (asOneRow) {
        text = '[' + displayText.join(' | ') + ']';
      } else {
        text = displayText.join('\n');
      }
    }
    return text;
  }
  getTextAndFormat() {
    return this.rows;
  }
}

// var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];

class Cea608Channel {
  constructor(channelNumber, outputFilter, logger) {
    this.chNr = void 0;
    this.outputFilter = void 0;
    this.mode = void 0;
    this.verbose = void 0;
    this.displayedMemory = void 0;
    this.nonDisplayedMemory = void 0;
    this.lastOutputScreen = void 0;
    this.currRollUpRow = void 0;
    this.writeScreen = void 0;
    this.cueStartTime = void 0;
    this.logger = void 0;
    this.chNr = channelNumber;
    this.outputFilter = outputFilter;
    this.mode = null;
    this.verbose = 0;
    this.displayedMemory = new CaptionScreen(logger);
    this.nonDisplayedMemory = new CaptionScreen(logger);
    this.lastOutputScreen = new CaptionScreen(logger);
    this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
    this.writeScreen = this.displayedMemory;
    this.mode = null;
    this.cueStartTime = null; // Keeps track of where a cue started.
    this.logger = logger;
  }
  reset() {
    this.mode = null;
    this.displayedMemory.reset();
    this.nonDisplayedMemory.reset();
    this.lastOutputScreen.reset();
    this.outputFilter.reset();
    this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
    this.writeScreen = this.displayedMemory;
    this.mode = null;
    this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(newHandler) {
    this.outputFilter = newHandler;
  }
  setPAC(pacData) {
    this.writeScreen.setPAC(pacData);
  }
  setBkgData(bkgData) {
    this.writeScreen.setBkgData(bkgData);
  }
  setMode(newMode) {
    if (newMode === this.mode) {
      return;
    }
    this.mode = newMode;
    this.logger.log(2, () => 'MODE=' + newMode);
    if (this.mode === 'MODE_POP-ON') {
      this.writeScreen = this.nonDisplayedMemory;
    } else {
      this.writeScreen = this.displayedMemory;
      this.writeScreen.reset();
    }
    if (this.mode !== 'MODE_ROLL-UP') {
      this.displayedMemory.nrRollUpRows = null;
      this.nonDisplayedMemory.nrRollUpRows = null;
    }
    this.mode = newMode;
  }
  insertChars(chars) {
    for (let i = 0; i < chars.length; i++) {
      this.writeScreen.insertChar(chars[i]);
    }
    const screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
    this.logger.log(2, () => screen + ': ' + this.writeScreen.getDisplayText(true));
    if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
      this.logger.log(1, () => 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
      this.outputDataUpdate();
    }
  }
  ccRCL() {
    // Resume Caption Loading (switch mode to Pop On)
    this.logger.log(2, 'RCL - Resume Caption Loading');
    this.setMode('MODE_POP-ON');
  }
  ccBS() {
    // BackSpace
    this.logger.log(2, 'BS - BackSpace');
    if (this.mode === 'MODE_TEXT') {
      return;
    }
    this.writeScreen.backSpace();
    if (this.writeScreen === this.displayedMemory) {
      this.outputDataUpdate();
    }
  }
  ccAOF() {
    // Reserved (formerly Alarm Off)
  }
  ccAON() {
    // Reserved (formerly Alarm On)
  }
  ccDER() {
    // Delete to End of Row
    this.logger.log(2, 'DER- Delete to End of Row');
    this.writeScreen.clearToEndOfRow();
    this.outputDataUpdate();
  }
  ccRU(nrRows) {
    // Roll-Up Captions-2,3,or 4 Rows
    this.logger.log(2, 'RU(' + nrRows + ') - Roll Up');
    this.writeScreen = this.displayedMemory;
    this.setMode('MODE_ROLL-UP');
    this.writeScreen.setRollUpRows(nrRows);
  }
  ccFON() {
    // Flash On
    this.logger.log(2, 'FON - Flash On');
    this.writeScreen.setPen({
      flash: true
    });
  }
  ccRDC() {
    // Resume Direct Captioning (switch mode to PaintOn)
    this.logger.log(2, 'RDC - Resume Direct Captioning');
    this.setMode('MODE_PAINT-ON');
  }
  ccTR() {
    // Text Restart in text mode (not supported, however)
    this.logger.log(2, 'TR');
    this.setMode('MODE_TEXT');
  }
  ccRTD() {
    // Resume Text Display in Text mode (not supported, however)
    this.logger.log(2, 'RTD');
    this.setMode('MODE_TEXT');
  }
  ccEDM() {
    // Erase Displayed Memory
    this.logger.log(2, 'EDM - Erase Displayed Memory');
    this.displayedMemory.reset();
    this.outputDataUpdate(true);
  }
  ccCR() {
    // Carriage Return
    this.logger.log(2, 'CR - Carriage Return');
    this.writeScreen.rollUp();
    this.outputDataUpdate(true);
  }
  ccENM() {
    // Erase Non-Displayed Memory
    this.logger.log(2, 'ENM - Erase Non-displayed Memory');
    this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    // End of Caption (Flip Memories)
    this.logger.log(2, 'EOC - End Of Caption');
    if (this.mode === 'MODE_POP-ON') {
      const tmp = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory;
      this.nonDisplayedMemory = tmp;
      this.writeScreen = this.nonDisplayedMemory;
      this.logger.log(1, () => 'DISP: ' + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(true);
  }
  ccTO(nrCols) {
    // Tab Offset 1,2, or 3 columns
    this.logger.log(2, 'TO(' + nrCols + ') - Tab Offset');
    this.writeScreen.moveCursor(nrCols);
  }
  ccMIDROW(secondByte) {
    // Parse MIDROW command
    const styles = {
      flash: false
    };
    styles.underline = secondByte % 2 === 1;
    styles.italics = secondByte >= 0x2e;
    if (!styles.italics) {
      const colorIndex = Math.floor(secondByte / 2) - 0x10;
      const colors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'];
      styles.foreground = colors[colorIndex];
    } else {
      styles.foreground = 'white';
    }
    this.logger.log(2, 'MIDROW: ' + JSON.stringify(styles));
    this.writeScreen.setPen(styles);
  }
  outputDataUpdate(dispatch = false) {
    const time = this.logger.time;
    if (time === null) {
      return;
    }
    if (this.outputFilter) {
      if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) {
        // Start of a new cue
        this.cueStartTime = time;
      } else {
        if (!this.displayedMemory.equals(this.lastOutputScreen)) {
          this.outputFilter.newCue(this.cueStartTime, time, this.lastOutputScreen);
          if (dispatch && this.outputFilter.dispatchCue) {
            this.outputFilter.dispatchCue();
          }
          this.cueStartTime = this.displayedMemory.isEmpty() ? null : time;
        }
      }
      this.lastOutputScreen.copy(this.displayedMemory);
    }
  }
  cueSplitAtTime(t) {
    if (this.outputFilter) {
      if (!this.displayedMemory.isEmpty()) {
        if (this.outputFilter.newCue) {
          this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
        }
        this.cueStartTime = t;
      }
    }
  }
}

// Will be 1 or 2 when parsing captions

class Cea608Parser {
  constructor(field, out1, out2) {
    this.channels = void 0;
    this.currentChannel = 0;
    this.cmdHistory = void 0;
    this.logger = void 0;
    const logger = new CaptionsLogger();
    this.channels = [null, new Cea608Channel(field, out1, logger), new Cea608Channel(field + 1, out2, logger)];
    this.cmdHistory = createCmdHistory();
    this.logger = logger;
  }
  getHandler(channel) {
    return this.channels[channel].getHandler();
  }
  setHandler(channel, newHandler) {
    this.channels[channel].setHandler(newHandler);
  }

  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(time, byteList) {
    let cmdFound;
    let a;
    let b;
    let charsFound = false;
    this.logger.time = time;
    for (let i = 0; i < byteList.length; i += 2) {
      a = byteList[i] & 0x7f;
      b = byteList[i + 1] & 0x7f;
      if (a === 0 && b === 0) {
        continue;
      } else {
        this.logger.log(3, '[' + numArrayToHexArray([byteList[i], byteList[i + 1]]) + '] -> (' + numArrayToHexArray([a, b]) + ')');
      }
      cmdFound = this.parseCmd(a, b);
      if (!cmdFound) {
        cmdFound = this.parseMidrow(a, b);
      }
      if (!cmdFound) {
        cmdFound = this.parsePAC(a, b);
      }
      if (!cmdFound) {
        cmdFound = this.parseBackgroundAttributes(a, b);
      }
      if (!cmdFound) {
        charsFound = this.parseChars(a, b);
        if (charsFound) {
          const currChNr = this.currentChannel;
          if (currChNr && currChNr > 0) {
            const channel = this.channels[currChNr];
            channel.insertChars(charsFound);
          } else {
            this.logger.log(2, 'No channel found yet. TEXT-MODE?');
          }
        }
      }
      if (!cmdFound && !charsFound) {
        this.logger.log(2, "Couldn't parse cleaned data " + numArrayToHexArray([a, b]) + ' orig: ' + numArrayToHexArray([byteList[i], byteList[i + 1]]));
      }
    }
  }

  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(a, b) {
    const {
      cmdHistory
    } = this;
    const cond1 = (a === 0x14 || a === 0x1c || a === 0x15 || a === 0x1d) && b >= 0x20 && b <= 0x2f;
    const cond2 = (a === 0x17 || a === 0x1f) && b >= 0x21 && b <= 0x23;
    if (!(cond1 || cond2)) {
      return false;
    }
    if (hasCmdRepeated(a, b, cmdHistory)) {
      setLastCmd(null, null, cmdHistory);
      this.logger.log(3, 'Repeated command (' + numArrayToHexArray([a, b]) + ') is dropped');
      return true;
    }
    const chNr = a === 0x14 || a === 0x15 || a === 0x17 ? 1 : 2;
    const channel = this.channels[chNr];
    if (a === 0x14 || a === 0x15 || a === 0x1c || a === 0x1d) {
      if (b === 0x20) {
        channel.ccRCL();
      } else if (b === 0x21) {
        channel.ccBS();
      } else if (b === 0x22) {
        channel.ccAOF();
      } else if (b === 0x23) {
        channel.ccAON();
      } else if (b === 0x24) {
        channel.ccDER();
      } else if (b === 0x25) {
        channel.ccRU(2);
      } else if (b === 0x26) {
        channel.ccRU(3);
      } else if (b === 0x27) {
        channel.ccRU(4);
      } else if (b === 0x28) {
        channel.ccFON();
      } else if (b === 0x29) {
        channel.ccRDC();
      } else if (b === 0x2a) {
        channel.ccTR();
      } else if (b === 0x2b) {
        channel.ccRTD();
      } else if (b === 0x2c) {
        channel.ccEDM();
      } else if (b === 0x2d) {
        channel.ccCR();
      } else if (b === 0x2e) {
        channel.ccENM();
      } else if (b === 0x2f) {
        channel.ccEOC();
      }
    } else {
      // a == 0x17 || a == 0x1F
      channel.ccTO(b - 0x20);
    }
    setLastCmd(a, b, cmdHistory);
    this.currentChannel = chNr;
    return true;
  }

  /**
   * Parse midrow styling command
   */
  parseMidrow(a, b) {
    let chNr = 0;
    if ((a === 0x11 || a === 0x19) && b >= 0x20 && b <= 0x2f) {
      if (a === 0x11) {
        chNr = 1;
      } else {
        chNr = 2;
      }
      if (chNr !== this.currentChannel) {
        this.logger.log(0, 'Mismatch channel in midrow parsing');
        return false;
      }
      const channel = this.channels[chNr];
      if (!channel) {
        return false;
      }
      channel.ccMIDROW(b);
      this.logger.log(3, 'MIDROW (' + numArrayToHexArray([a, b]) + ')');
      return true;
    }
    return false;
  }

  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(a, b) {
    let row;
    const cmdHistory = this.cmdHistory;
    const case1 = (a >= 0x11 && a <= 0x17 || a >= 0x19 && a <= 0x1f) && b >= 0x40 && b <= 0x7f;
    const case2 = (a === 0x10 || a === 0x18) && b >= 0x40 && b <= 0x5f;
    if (!(case1 || case2)) {
      return false;
    }
    if (hasCmdRepeated(a, b, cmdHistory)) {
      setLastCmd(null, null, cmdHistory);
      return true; // Repeated commands are dropped (once)
    }

    const chNr = a <= 0x17 ? 1 : 2;
    if (b >= 0x40 && b <= 0x5f) {
      row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
    } else {
      // 0x60 <= b <= 0x7F
      row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
    }
    const channel = this.channels[chNr];
    if (!channel) {
      return false;
    }
    channel.setPAC(this.interpretPAC(row, b));
    setLastCmd(a, b, cmdHistory);
    this.currentChannel = chNr;
    return true;
  }

  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(row, byte) {
    let pacIndex;
    const pacData = {
      color: null,
      italics: false,
      indent: null,
      underline: false,
      row: row
    };
    if (byte > 0x5f) {
      pacIndex = byte - 0x60;
    } else {
      pacIndex = byte - 0x40;
    }
    pacData.underline = (pacIndex & 1) === 1;
    if (pacIndex <= 0xd) {
      pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
    } else if (pacIndex <= 0xf) {
      pacData.italics = true;
      pacData.color = 'white';
    } else {
      pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
    }
    return pacData; // Note that row has zero offset. The spec uses 1.
  }

  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(a, b) {
    let channelNr;
    let charCodes = null;
    let charCode1 = null;
    if (a >= 0x19) {
      channelNr = 2;
      charCode1 = a - 8;
    } else {
      channelNr = 1;
      charCode1 = a;
    }
    if (charCode1 >= 0x11 && charCode1 <= 0x13) {
      // Special character
      let oneCode;
      if (charCode1 === 0x11) {
        oneCode = b + 0x50;
      } else if (charCode1 === 0x12) {
        oneCode = b + 0x70;
      } else {
        oneCode = b + 0x90;
      }
      this.logger.log(2, "Special char '" + getCharForByte(oneCode) + "' in channel " + channelNr);
      charCodes = [oneCode];
    } else if (a >= 0x20 && a <= 0x7f) {
      charCodes = b === 0 ? [a] : [a, b];
    }
    if (charCodes) {
      const hexCodes = numArrayToHexArray(charCodes);
      this.logger.log(3, 'Char codes =  ' + hexCodes.join(','));
      setLastCmd(a, b, this.cmdHistory);
    }
    return charCodes;
  }

  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(a, b) {
    const case1 = (a === 0x10 || a === 0x18) && b >= 0x20 && b <= 0x2f;
    const case2 = (a === 0x17 || a === 0x1f) && b >= 0x2d && b <= 0x2f;
    if (!(case1 || case2)) {
      return false;
    }
    let index;
    const bkgData = {};
    if (a === 0x10 || a === 0x18) {
      index = Math.floor((b - 0x20) / 2);
      bkgData.background = backgroundColors[index];
      if (b % 2 === 1) {
        bkgData.background = bkgData.background + '_semi';
      }
    } else if (b === 0x2d) {
      bkgData.background = 'transparent';
    } else {
      bkgData.foreground = 'black';
      if (b === 0x2f) {
        bkgData.underline = true;
      }
    }
    const chNr = a <= 0x17 ? 1 : 2;
    const channel = this.channels[chNr];
    channel.setBkgData(bkgData);
    setLastCmd(a, b, this.cmdHistory);
    return true;
  }

  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let i = 0; i < Object.keys(this.channels).length; i++) {
      const channel = this.channels[i];
      if (channel) {
        channel.reset();
      }
    }
    this.cmdHistory = createCmdHistory();
  }

  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(t) {
    for (let i = 0; i < this.channels.length; i++) {
      const channel = this.channels[i];
      if (channel) {
        channel.cueSplitAtTime(t);
      }
    }
  }
}
function setLastCmd(a, b, cmdHistory) {
  cmdHistory.a = a;
  cmdHistory.b = b;
}
function hasCmdRepeated(a, b, cmdHistory) {
  return cmdHistory.a === a && cmdHistory.b === b;
}
function createCmdHistory() {
  return {
    a: null,
    b: null
  };
}

class OutputFilter {
  constructor(timelineController, trackName) {
    this.timelineController = void 0;
    this.cueRanges = [];
    this.trackName = void 0;
    this.startTime = null;
    this.endTime = null;
    this.screen = null;
    this.timelineController = timelineController;
    this.trackName = trackName;
  }
  dispatchCue() {
    if (this.startTime === null) {
      return;
    }
    this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges);
    this.startTime = null;
  }
  newCue(startTime, endTime, screen) {
    if (this.startTime === null || this.startTime > startTime) {
      this.startTime = startTime;
    }
    this.endTime = endTime;
    this.screen = screen;
    this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [];
    this.startTime = null;
  }
}

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var VTTCue = (function () {
  if (typeof self !== 'undefined' && self.VTTCue) {
    return self.VTTCue;
  }
  const AllowedDirections = ['', 'lr', 'rl'];
  const AllowedAlignments = ['start', 'middle', 'end', 'left', 'right'];
  function isAllowedValue(allowed, value) {
    if (typeof value !== 'string') {
      return false;
    }
    // necessary for assuring the generic conforms to the Array interface
    if (!Array.isArray(allowed)) {
      return false;
    }
    // reset the type so that the next narrowing works well
    const lcValue = value.toLowerCase();
    // use the allow list to narrow the type to a specific subset of strings
    if (~allowed.indexOf(lcValue)) {
      return lcValue;
    }
    return false;
  }
  function findDirectionSetting(value) {
    return isAllowedValue(AllowedDirections, value);
  }
  function findAlignSetting(value) {
    return isAllowedValue(AllowedAlignments, value);
  }
  function extend(obj, ...rest) {
    let i = 1;
    for (; i < arguments.length; i++) {
      const cobj = arguments[i];
      for (const p in cobj) {
        obj[p] = cobj[p];
      }
    }
    return obj;
  }
  function VTTCue(startTime, endTime, text) {
    const cue = this;
    const baseObj = {
      enumerable: true
    };
    /**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */

    // Lets us know when the VTTCue's data has changed in such a way that we need
    // to recompute its display state. This lets us compute its display state
    // lazily.
    cue.hasBeenReset = false;

    /**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */

    let _id = '';
    let _pauseOnExit = false;
    let _startTime = startTime;
    let _endTime = endTime;
    let _text = text;
    let _region = null;
    let _vertical = '';
    let _snapToLines = true;
    let _line = 'auto';
    let _lineAlign = 'start';
    let _position = 50;
    let _positionAlign = 'middle';
    let _size = 50;
    let _align = 'middle';
    Object.defineProperty(cue, 'id', extend({}, baseObj, {
      get: function () {
        return _id;
      },
      set: function (value) {
        _id = '' + value;
      }
    }));
    Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
      get: function () {
        return _pauseOnExit;
      },
      set: function (value) {
        _pauseOnExit = !!value;
      }
    }));
    Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
      get: function () {
        return _startTime;
      },
      set: function (value) {
        if (typeof value !== 'number') {
          throw new TypeError('Start time must be set to a number.');
        }
        _startTime = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
      get: function () {
        return _endTime;
      },
      set: function (value) {
        if (typeof value !== 'number') {
          throw new TypeError('End time must be set to a number.');
        }
        _endTime = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'text', extend({}, baseObj, {
      get: function () {
        return _text;
      },
      set: function (value) {
        _text = '' + value;
        this.hasBeenReset = true;
      }
    }));

    // todo: implement VTTRegion polyfill?
    Object.defineProperty(cue, 'region', extend({}, baseObj, {
      get: function () {
        return _region;
      },
      set: function (value) {
        _region = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
      get: function () {
        return _vertical;
      },
      set: function (value) {
        const setting = findDirectionSetting(value);
        // Have to check for false because the setting an be an empty string.
        if (setting === false) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _vertical = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
      get: function () {
        return _snapToLines;
      },
      set: function (value) {
        _snapToLines = !!value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'line', extend({}, baseObj, {
      get: function () {
        return _line;
      },
      set: function (value) {
        if (typeof value !== 'number' && value !== 'auto') {
          throw new SyntaxError('An invalid number or illegal string was specified.');
        }
        _line = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
      get: function () {
        return _lineAlign;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _lineAlign = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'position', extend({}, baseObj, {
      get: function () {
        return _position;
      },
      set: function (value) {
        if (value < 0 || value > 100) {
          throw new Error('Position must be between 0 and 100.');
        }
        _position = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
      get: function () {
        return _positionAlign;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _positionAlign = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'size', extend({}, baseObj, {
      get: function () {
        return _size;
      },
      set: function (value) {
        if (value < 0 || value > 100) {
          throw new Error('Size must be between 0 and 100.');
        }
        _size = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'align', extend({}, baseObj, {
      get: function () {
        return _align;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _align = setting;
        this.hasBeenReset = true;
      }
    }));

    /**
     * Other <track> spec defined properties
     */

    // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
    cue.displayState = undefined;
  }

  /**
   * VTTCue methods
   */

  VTTCue.prototype.getCueAsHTML = function () {
    // Assume WebVTT.convertCueToDOMTree is on the global.
    const WebVTT = self.WebVTT;
    return WebVTT.convertCueToDOMTree(self, this.text);
  };
  // this is a polyfill hack
  return VTTCue;
})();

/*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js
 */

class StringDecoder {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  decode(data, options) {
    if (!data) {
      return '';
    }
    if (typeof data !== 'string') {
      throw new Error('Error - expected string data.');
    }
    return decodeURIComponent(encodeURIComponent(data));
  }
}

// Try to parse input as a time stamp.
function parseTimeStamp(input) {
  function computeSeconds(h, m, s, f) {
    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + parseFloat(f || 0);
  }
  const m = input.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  if (!m) {
    return null;
  }
  if (parseFloat(m[2]) > 59) {
    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[2], m[3], 0, m[4]);
  }
  // Timestamp takes the form of [hours (optional)]:[minutes]:[seconds].[milliseconds]
  return computeSeconds(m[1], m[2], m[3], m[4]);
}

// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
class Settings {
  constructor() {
    this.values = Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(k, v) {
    if (!this.get(k) && v !== '') {
      this.values[k] = v;
    }
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(k, dflt, defaultKey) {
    if (defaultKey) {
      return this.has(k) ? this.values[k] : dflt[defaultKey];
    }
    return this.has(k) ? this.values[k] : dflt;
  }
  // Check whether we have a value for a key.
  has(k) {
    return k in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(k, v, a) {
    for (let n = 0; n < a.length; ++n) {
      if (v === a[n]) {
        this.set(k, v);
        break;
      }
    }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(k, v) {
    if (/^-?\d+$/.test(v)) {
      // integer
      this.set(k, parseInt(v, 10));
    }
  }
  // Accept a setting if its a valid percentage.
  percent(k, v) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(v)) {
      const percent = parseFloat(v);
      if (percent >= 0 && percent <= 100) {
        this.set(k, percent);
        return true;
      }
    }
    return false;
  }
}

// Helper function to parse input into groups separated by 'groupDelim', and
// interpret each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
  const groups = groupDelim ? input.split(groupDelim) : [input];
  for (const i in groups) {
    if (typeof groups[i] !== 'string') {
      continue;
    }
    const kv = groups[i].split(keyValueDelim);
    if (kv.length !== 2) {
      continue;
    }
    const k = kv[0];
    const v = kv[1];
    callback(k, v);
  }
}
const defaults = new VTTCue(0, 0, '');
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
//  Safari doesn't yet support this change, but FF and Chrome do.
const center = defaults.align === 'middle' ? 'middle' : 'center';
function parseCue(input, cue, regionList) {
  // Remember the original input if we need to throw an error.
  const oInput = input;
  // 4.1 WebVTT timestamp
  function consumeTimeStamp() {
    const ts = parseTimeStamp(input);
    if (ts === null) {
      throw new Error('Malformed timestamp: ' + oInput);
    }

    // Remove time stamp from input.
    input = input.replace(/^[^\sa-zA-Z-]+/, '');
    return ts;
  }

  // 4.4.2 WebVTT cue settings
  function consumeCueSettings(input, cue) {
    const settings = new Settings();
    parseOptions(input, function (k, v) {
      let vals;
      switch (k) {
        case 'region':
          // Find the last region we parsed with the same region id.
          for (let i = regionList.length - 1; i >= 0; i--) {
            if (regionList[i].id === v) {
              settings.set(k, regionList[i].region);
              break;
            }
          }
          break;
        case 'vertical':
          settings.alt(k, v, ['rl', 'lr']);
          break;
        case 'line':
          vals = v.split(',');
          settings.integer(k, vals[0]);
          if (settings.percent(k, vals[0])) {
            settings.set('snapToLines', false);
          }
          settings.alt(k, vals[0], ['auto']);
          if (vals.length === 2) {
            settings.alt('lineAlign', vals[1], ['start', center, 'end']);
          }
          break;
        case 'position':
          vals = v.split(',');
          settings.percent(k, vals[0]);
          if (vals.length === 2) {
            settings.alt('positionAlign', vals[1], ['start', center, 'end', 'line-left', 'line-right', 'auto']);
          }
          break;
        case 'size':
          settings.percent(k, v);
          break;
        case 'align':
          settings.alt(k, v, ['start', center, 'end', 'left', 'right']);
          break;
      }
    }, /:/, /\s/);

    // Apply default values for any missing fields.
    cue.region = settings.get('region', null);
    cue.vertical = settings.get('vertical', '');
    let line = settings.get('line', 'auto');
    if (line === 'auto' && defaults.line === -1) {
      // set numeric line number for Safari
      line = -1;
    }
    cue.line = line;
    cue.lineAlign = settings.get('lineAlign', 'start');
    cue.snapToLines = settings.get('snapToLines', true);
    cue.size = settings.get('size', 100);
    cue.align = settings.get('align', center);
    let position = settings.get('position', 'auto');
    if (position === 'auto' && defaults.position === 50) {
      // set numeric position for Safari
      position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
    }
    cue.position = position;
  }
  function skipWhitespace() {
    input = input.replace(/^\s+/, '');
  }

  // 4.1 WebVTT cue timings.
  skipWhitespace();
  cue.startTime = consumeTimeStamp(); // (1) collect cue start time
  skipWhitespace();
  if (input.slice(0, 3) !== '-->') {
    // (3) next characters must match '-->'
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
  }
  input = input.slice(3);
  skipWhitespace();
  cue.endTime = consumeTimeStamp(); // (5) collect cue end time

  // 4.1 WebVTT cue settings list.
  skipWhitespace();
  consumeCueSettings(input, cue);
}
function fixLineBreaks(input) {
  return input.replace(/<br(?: \/)?>/gi, '\n');
}
class VTTParser {
  constructor() {
    this.state = 'INITIAL';
    this.buffer = '';
    this.decoder = new StringDecoder();
    this.regionList = [];
    this.cue = null;
    this.oncue = void 0;
    this.onparsingerror = void 0;
    this.onflush = void 0;
  }
  parse(data) {
    const _this = this;

    // If there is no data then we won't decode it, but will just try to parse
    // whatever is in buffer already. This may occur in circumstances, for
    // example when flush() is called.
    if (data) {
      // Try to decode the data that we received.
      _this.buffer += _this.decoder.decode(data, {
        stream: true
      });
    }
    function collectNextLine() {
      let buffer = _this.buffer;
      let pos = 0;
      buffer = fixLineBreaks(buffer);
      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
        ++pos;
      }
      const line = buffer.slice(0, pos);
      // Advance the buffer early in case we fail below.
      if (buffer[pos] === '\r') {
        ++pos;
      }
      if (buffer[pos] === '\n') {
        ++pos;
      }
      _this.buffer = buffer.slice(pos);
      return line;
    }

    // 3.2 WebVTT metadata header syntax
    function parseHeader(input) {
      parseOptions(input, function (k, v) {
        // switch (k) {
        // case 'region':
        // 3.3 WebVTT region metadata header syntax
        // console.log('parse region', v);
        // parseRegion(v);
        // break;
        // }
      }, /:/);
    }

    // 5.1 WebVTT file parsing.
    try {
      let line = '';
      if (_this.state === 'INITIAL') {
        // We can't start parsing until we have the first line.
        if (!/\r\n|\n/.test(_this.buffer)) {
          return this;
        }
        line = collectNextLine();
        // strip of UTF-8 BOM if any
        // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
        const m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(m != null && m[0])) {
          throw new Error('Malformed WebVTT signature.');
        }
        _this.state = 'HEADER';
      }
      let alreadyCollectedLine = false;
      while (_this.buffer) {
        // We can't parse a line until we have the full line.
        if (!/\r\n|\n/.test(_this.buffer)) {
          return this;
        }
        if (!alreadyCollectedLine) {
          line = collectNextLine();
        } else {
          alreadyCollectedLine = false;
        }
        switch (_this.state) {
          case 'HEADER':
            // 13-18 - Allow a header (metadata) under the WEBVTT line.
            if (/:/.test(line)) {
              parseHeader(line);
            } else if (!line) {
              // An empty line terminates the header and starts the body (cues).
              _this.state = 'ID';
            }
            continue;
          case 'NOTE':
            // Ignore NOTE blocks.
            if (!line) {
              _this.state = 'ID';
            }
            continue;
          case 'ID':
            // Check for the start of NOTE blocks.
            if (/^NOTE($|[ \t])/.test(line)) {
              _this.state = 'NOTE';
              break;
            }
            // 19-29 - Allow any number of line terminators, then initialize new cue values.
            if (!line) {
              continue;
            }
            _this.cue = new VTTCue(0, 0, '');
            _this.state = 'CUE';
            // 30-39 - Check if self line contains an optional identifier or timing data.
            if (line.indexOf('-->') === -1) {
              _this.cue.id = line;
              continue;
            }
          // Process line as start of a cue.
          /* falls through */
          case 'CUE':
            // 40 - Collect cue timings and settings.
            if (!_this.cue) {
              _this.state = 'BADCUE';
              continue;
            }
            try {
              parseCue(line, _this.cue, _this.regionList);
            } catch (e) {
              // In case of an error ignore rest of the cue.
              _this.cue = null;
              _this.state = 'BADCUE';
              continue;
            }
            _this.state = 'CUETEXT';
            continue;
          case 'CUETEXT':
            {
              const hasSubstring = line.indexOf('-->') !== -1;
              // 34 - If we have an empty line then report the cue.
              // 35 - If we have the special substring '-->' then report the cue,
              // but do not collect the line as we need to process the current
              // one as a new cue.
              if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                // We are done parsing self cue.
                if (_this.oncue && _this.cue) {
                  _this.oncue(_this.cue);
                }
                _this.cue = null;
                _this.state = 'ID';
                continue;
              }
              if (_this.cue === null) {
                continue;
              }
              if (_this.cue.text) {
                _this.cue.text += '\n';
              }
              _this.cue.text += line;
            }
            continue;
          case 'BADCUE':
            // 54-62 - Collect and discard the remaining cue.
            if (!line) {
              _this.state = 'ID';
            }
        }
      }
    } catch (e) {
      // If we are currently parsing a cue, report what we have.
      if (_this.state === 'CUETEXT' && _this.cue && _this.oncue) {
        _this.oncue(_this.cue);
      }
      _this.cue = null;
      // Enter BADWEBVTT state if header was not parsed correctly otherwise
      // another exception occurred so enter BADCUE state.
      _this.state = _this.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
    }
    return this;
  }
  flush() {
    const _this = this;
    try {
      // Finish decoding the stream.
      // _this.buffer += _this.decoder.decode();
      // Synthesize the end of the current cue or region.
      if (_this.cue || _this.state === 'HEADER') {
        _this.buffer += '\n\n';
        _this.parse();
      }
      // If we've flushed, parsed, and we're still on the INITIAL state then
      // that means we don't have enough of the stream to parse the first
      // line.
      if (_this.state === 'INITIAL' || _this.state === 'BADWEBVTT') {
        throw new Error('Malformed WebVTT signature.');
      }
    } catch (e) {
      if (_this.onparsingerror) {
        _this.onparsingerror(e);
      }
    }
    if (_this.onflush) {
      _this.onflush();
    }
    return this;
  }
}

const LINEBREAKS = /\r\n|\n\r|\n|\r/g;

// String.prototype.startsWith is not supported in IE11
const startsWith = function startsWith(inputString, searchString, position = 0) {
  return inputString.slice(position, position + searchString.length) === searchString;
};
const cueString2millis = function cueString2millis(timeString) {
  let ts = parseInt(timeString.slice(-3));
  const secs = parseInt(timeString.slice(-6, -4));
  const mins = parseInt(timeString.slice(-9, -7));
  const hours = timeString.length > 9 ? parseInt(timeString.substring(0, timeString.indexOf(':'))) : 0;
  if (!isFiniteNumber(ts) || !isFiniteNumber(secs) || !isFiniteNumber(mins) || !isFiniteNumber(hours)) {
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${timeString}`);
  }
  ts += 1000 * secs;
  ts += 60 * 1000 * mins;
  ts += 60 * 60 * 1000 * hours;
  return ts;
};

// From https://github.com/darkskyapp/string-hash
const hash = function hash(text) {
  let _hash = 5381;
  let i = text.length;
  while (i) {
    _hash = _hash * 33 ^ text.charCodeAt(--i);
  }
  return (_hash >>> 0).toString();
};

// Create a unique hash id for a cue based on start/end times and text.
// This helps timeline-controller to avoid showing repeated captions.
function generateCueId(startTime, endTime, text) {
  return hash(startTime.toString()) + hash(endTime.toString()) + hash(text);
}
const calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
  let currCC = vttCCs[cc];
  let prevCC = vttCCs[currCC.prevCC];

  // This is the first discontinuity or cues have been processed since the last discontinuity
  // Offset = current discontinuity time
  if (!prevCC || !prevCC.new && currCC.new) {
    vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
    currCC.new = false;
    return;
  }

  // There have been discontinuities since cues were last parsed.
  // Offset = time elapsed
  while ((_prevCC = prevCC) != null && _prevCC.new) {
    var _prevCC;
    vttCCs.ccOffset += currCC.start - prevCC.start;
    currCC.new = false;
    currCC = prevCC;
    prevCC = vttCCs[currCC.prevCC];
  }
  vttCCs.presentationOffset = presentationTime;
};
function parseWebVTT(vttByteArray, initPTS, vttCCs, cc, timeOffset, callBack, errorCallBack) {
  const parser = new VTTParser();
  // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
  // Uint8Array.prototype.reduce is not implemented in IE11
  const vttLines = utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace(LINEBREAKS, '\n').split('\n');
  const cues = [];
  const init90kHz = initPTS ? toMpegTsClockFromTimescale(initPTS.baseTime, initPTS.timescale) : 0;
  let cueTime = '00:00.000';
  let timestampMapMPEGTS = 0;
  let timestampMapLOCAL = 0;
  let parsingError;
  let inHeader = true;
  parser.oncue = function (cue) {
    // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
    const currCC = vttCCs[cc];
    let cueOffset = vttCCs.ccOffset;

    // Calculate subtitle PTS offset
    const webVttMpegTsMapOffset = (timestampMapMPEGTS - init90kHz) / 90000;

    // Update offsets for new discontinuities
    if (currCC != null && currCC.new) {
      if (timestampMapLOCAL !== undefined) {
        // When local time is provided, offset = discontinuity start time - local time
        cueOffset = vttCCs.ccOffset = currCC.start;
      } else {
        calculateOffset(vttCCs, cc, webVttMpegTsMapOffset);
      }
    }
    if (webVttMpegTsMapOffset) {
      if (!initPTS) {
        parsingError = new Error('Missing initPTS for VTT MPEGTS');
        return;
      }
      // If we have MPEGTS, offset = presentation time + discontinuity offset
      cueOffset = webVttMpegTsMapOffset - vttCCs.presentationOffset;
    }
    const duration = cue.endTime - cue.startTime;
    const startTime = normalizePts((cue.startTime + cueOffset - timestampMapLOCAL) * 90000, timeOffset * 90000) / 90000;
    cue.startTime = Math.max(startTime, 0);
    cue.endTime = Math.max(startTime + duration, 0);

    //trim trailing webvtt block whitespaces
    const text = cue.text.trim();

    // Fix encoding of special characters
    cue.text = decodeURIComponent(encodeURIComponent(text));

    // If the cue was not assigned an id from the VTT file (line above the content), create one.
    if (!cue.id) {
      cue.id = generateCueId(cue.startTime, cue.endTime, text);
    }
    if (cue.endTime > 0) {
      cues.push(cue);
    }
  };
  parser.onparsingerror = function (error) {
    parsingError = error;
  };
  parser.onflush = function () {
    if (parsingError) {
      errorCallBack(parsingError);
      return;
    }
    callBack(cues);
  };

  // Go through contents line by line.
  vttLines.forEach(line => {
    if (inHeader) {
      // Look for X-TIMESTAMP-MAP in header.
      if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
        // Once found, no more are allowed anyway, so stop searching.
        inHeader = false;
        // Extract LOCAL and MPEGTS.
        line.slice(16).split(',').forEach(timestamp => {
          if (startsWith(timestamp, 'LOCAL:')) {
            cueTime = timestamp.slice(6);
          } else if (startsWith(timestamp, 'MPEGTS:')) {
            timestampMapMPEGTS = parseInt(timestamp.slice(7));
          }
        });
        try {
          // Convert cue time to seconds
          timestampMapLOCAL = cueString2millis(cueTime) / 1000;
        } catch (error) {
          parsingError = error;
        }
        // Return without parsing X-TIMESTAMP-MAP line.
        return;
      } else if (line === '') {
        inHeader = false;
      }
    }
    // Parse line by default.
    parser.parse(line + '\n');
  });
  parser.flush();
}

const IMSC1_CODEC = 'stpp.ttml.im1t';

// Time format: h:m:s:frames(.subframes)
const HMSF_REGEX = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;

// Time format: hours, minutes, seconds, milliseconds, frames, ticks
const TIME_UNIT_REGEX = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/;
const textAlignToLineAlign = {
  left: 'start',
  center: 'center',
  right: 'end',
  start: 'start',
  end: 'end'
};
function parseIMSC1(payload, initPTS, callBack, errorCallBack) {
  const results = findBox(new Uint8Array(payload), ['mdat']);
  if (results.length === 0) {
    errorCallBack(new Error('Could not parse IMSC1 mdat'));
    return;
  }
  const ttmlList = results.map(mdat => utf8ArrayToStr(mdat));
  const syncTime = toTimescaleFromScale(initPTS.baseTime, 1, initPTS.timescale);
  try {
    ttmlList.forEach(ttml => callBack(parseTTML(ttml, syncTime)));
  } catch (error) {
    errorCallBack(error);
  }
}
function parseTTML(ttml, syncTime) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(ttml, 'text/xml');
  const tt = xmlDoc.getElementsByTagName('tt')[0];
  if (!tt) {
    throw new Error('Invalid ttml');
  }
  const defaultRateInfo = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  };
  const rateInfo = Object.keys(defaultRateInfo).reduce((result, key) => {
    result[key] = tt.getAttribute(`ttp:${key}`) || defaultRateInfo[key];
    return result;
  }, {});
  const trim = tt.getAttribute('xml:space') !== 'preserve';
  const styleElements = collectionToDictionary(getElementCollection(tt, 'styling', 'style'));
  const regionElements = collectionToDictionary(getElementCollection(tt, 'layout', 'region'));
  const cueElements = getElementCollection(tt, 'body', '[begin]');
  return [].map.call(cueElements, cueElement => {
    const cueText = getTextContent(cueElement, trim);
    if (!cueText || !cueElement.hasAttribute('begin')) {
      return null;
    }
    const startTime = parseTtmlTime(cueElement.getAttribute('begin'), rateInfo);
    const duration = parseTtmlTime(cueElement.getAttribute('dur'), rateInfo);
    let endTime = parseTtmlTime(cueElement.getAttribute('end'), rateInfo);
    if (startTime === null) {
      throw timestampParsingError(cueElement);
    }
    if (endTime === null) {
      if (duration === null) {
        throw timestampParsingError(cueElement);
      }
      endTime = startTime + duration;
    }
    const cue = new VTTCue(startTime - syncTime, endTime - syncTime, cueText);
    cue.id = generateCueId(cue.startTime, cue.endTime, cue.text);
    const region = regionElements[cueElement.getAttribute('region')];
    const style = styleElements[cueElement.getAttribute('style')];

    // Apply styles to cue
    const styles = getTtmlStyles(region, style, styleElements);
    const {
      textAlign
    } = styles;
    if (textAlign) {
      // cue.positionAlign not settable in FF~2016
      const lineAlign = textAlignToLineAlign[textAlign];
      if (lineAlign) {
        cue.lineAlign = lineAlign;
      }
      cue.align = textAlign;
    }
    _extends(cue, styles);
    return cue;
  }).filter(cue => cue !== null);
}
function getElementCollection(fromElement, parentName, childName) {
  const parent = fromElement.getElementsByTagName(parentName)[0];
  if (parent) {
    return [].slice.call(parent.querySelectorAll(childName));
  }
  return [];
}
function collectionToDictionary(elementsWithId) {
  return elementsWithId.reduce((dict, element) => {
    const id = element.getAttribute('xml:id');
    if (id) {
      dict[id] = element;
    }
    return dict;
  }, {});
}
function getTextContent(element, trim) {
  return [].slice.call(element.childNodes).reduce((str, node, i) => {
    var _node$childNodes;
    if (node.nodeName === 'br' && i) {
      return str + '\n';
    }
    if ((_node$childNodes = node.childNodes) != null && _node$childNodes.length) {
      return getTextContent(node, trim);
    } else if (trim) {
      return str + node.textContent.trim().replace(/\s+/g, ' ');
    }
    return str + node.textContent;
  }, '');
}
function getTtmlStyles(region, style, styleElements) {
  const ttsNs = 'http://www.w3.org/ns/ttml#styling';
  let regionStyle = null;
  const styleAttributes = ['displayAlign', 'textAlign', 'color', 'backgroundColor', 'fontSize', 'fontFamily'
  // 'fontWeight',
  // 'lineHeight',
  // 'wrapOption',
  // 'fontStyle',
  // 'direction',
  // 'writingMode'
  ];

  const regionStyleName = region != null && region.hasAttribute('style') ? region.getAttribute('style') : null;
  if (regionStyleName && styleElements.hasOwnProperty(regionStyleName)) {
    regionStyle = styleElements[regionStyleName];
  }
  return styleAttributes.reduce((styles, name) => {
    const value = getAttributeNS(style, ttsNs, name) || getAttributeNS(region, ttsNs, name) || getAttributeNS(regionStyle, ttsNs, name);
    if (value) {
      styles[name] = value;
    }
    return styles;
  }, {});
}
function getAttributeNS(element, ns, name) {
  if (!element) {
    return null;
  }
  return element.hasAttributeNS(ns, name) ? element.getAttributeNS(ns, name) : null;
}
function timestampParsingError(node) {
  return new Error(`Could not parse ttml timestamp ${node}`);
}
function parseTtmlTime(timeAttributeValue, rateInfo) {
  if (!timeAttributeValue) {
    return null;
  }
  let seconds = parseTimeStamp(timeAttributeValue);
  if (seconds === null) {
    if (HMSF_REGEX.test(timeAttributeValue)) {
      seconds = parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo);
    } else if (TIME_UNIT_REGEX.test(timeAttributeValue)) {
      seconds = parseTimeUnits(timeAttributeValue, rateInfo);
    }
  }
  return seconds;
}
function parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo) {
  const m = HMSF_REGEX.exec(timeAttributeValue);
  const frames = (m[4] | 0) + (m[5] | 0) / rateInfo.subFrameRate;
  return (m[1] | 0) * 3600 + (m[2] | 0) * 60 + (m[3] | 0) + frames / rateInfo.frameRate;
}
function parseTimeUnits(timeAttributeValue, rateInfo) {
  const m = TIME_UNIT_REGEX.exec(timeAttributeValue);
  const value = Number(m[1]);
  const unit = m[2];
  switch (unit) {
    case 'h':
      return value * 3600;
    case 'm':
      return value * 60;
    case 'ms':
      return value * 1000;
    case 'f':
      return value / rateInfo.frameRate;
    case 't':
      return value / rateInfo.tickRate;
  }
  return value;
}

class TimelineController {
  constructor(hls) {
    this.hls = void 0;
    this.media = null;
    this.config = void 0;
    this.enabled = true;
    this.Cues = void 0;
    this.textTracks = [];
    this.tracks = [];
    this.initPTS = [];
    this.unparsedVttFrags = [];
    this.captionsTracks = {};
    this.nonNativeCaptionsTracks = {};
    this.cea608Parser1 = void 0;
    this.cea608Parser2 = void 0;
    this.lastSn = -1;
    this.lastPartIndex = -1;
    this.prevCC = -1;
    this.vttCCs = newVTTCCs();
    this.captionsProperties = void 0;
    this.hls = hls;
    this.config = hls.config;
    this.Cues = hls.config.cueHandler;
    this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    };
    if (this.config.enableCEA708Captions) {
      const channel1 = new OutputFilter(this, 'textTrack1');
      const channel2 = new OutputFilter(this, 'textTrack2');
      const channel3 = new OutputFilter(this, 'textTrack3');
      const channel4 = new OutputFilter(this, 'textTrack4');
      this.cea608Parser1 = new Cea608Parser(1, channel1, channel2);
      this.cea608Parser2 = new Cea608Parser(3, channel3, channel4);
    }
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.on(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
    hls.on(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
    hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.on(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.off(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
    hls.off(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
    hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.off(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    // @ts-ignore
    this.hls = this.config = this.cea608Parser1 = this.cea608Parser2 = null;
  }
  addCues(trackName, startTime, endTime, screen, cueRanges) {
    // skip cues which overlap more than 50% with previously parsed time ranges
    let merged = false;
    for (let i = cueRanges.length; i--;) {
      const cueRange = cueRanges[i];
      const overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
      if (overlap >= 0) {
        cueRange[0] = Math.min(cueRange[0], startTime);
        cueRange[1] = Math.max(cueRange[1], endTime);
        merged = true;
        if (overlap / (endTime - startTime) > 0.5) {
          return;
        }
      }
    }
    if (!merged) {
      cueRanges.push([startTime, endTime]);
    }
    if (this.config.renderTextTracksNatively) {
      const track = this.captionsTracks[trackName];
      this.Cues.newCue(track, startTime, endTime, screen);
    } else {
      const cues = this.Cues.newCue(null, startTime, endTime, screen);
      this.hls.trigger(Events.CUES_PARSED, {
        type: 'captions',
        cues,
        track: trackName
      });
    }
  }

  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(event, {
    frag,
    id,
    initPTS,
    timescale
  }) {
    const {
      unparsedVttFrags
    } = this;
    if (id === 'main') {
      this.initPTS[frag.cc] = {
        baseTime: initPTS,
        timescale
      };
    }

    // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
    // Parse any unparsed fragments upon receiving the initial PTS.
    if (unparsedVttFrags.length) {
      this.unparsedVttFrags = [];
      unparsedVttFrags.forEach(frag => {
        this.onFragLoaded(Events.FRAG_LOADED, frag);
      });
    }
  }
  getExistingTrack(trackName) {
    const {
      media
    } = this;
    if (media) {
      for (let i = 0; i < media.textTracks.length; i++) {
        const textTrack = media.textTracks[i];
        if (textTrack[trackName]) {
          return textTrack;
        }
      }
    }
    return null;
  }
  createCaptionsTrack(trackName) {
    if (this.config.renderTextTracksNatively) {
      this.createNativeTrack(trackName);
    } else {
      this.createNonNativeTrack(trackName);
    }
  }
  createNativeTrack(trackName) {
    if (this.captionsTracks[trackName]) {
      return;
    }
    const {
      captionsProperties,
      captionsTracks,
      media
    } = this;
    const {
      label,
      languageCode
    } = captionsProperties[trackName];
    // Enable reuse of existing text track.
    const existingTrack = this.getExistingTrack(trackName);
    if (!existingTrack) {
      const textTrack = this.createTextTrack('captions', label, languageCode);
      if (textTrack) {
        // Set a special property on the track so we know it's managed by Hls.js
        textTrack[trackName] = true;
        captionsTracks[trackName] = textTrack;
      }
    } else {
      captionsTracks[trackName] = existingTrack;
      clearCurrentCues(captionsTracks[trackName]);
      sendAddTrackEvent(captionsTracks[trackName], media);
    }
  }
  createNonNativeTrack(trackName) {
    if (this.nonNativeCaptionsTracks[trackName]) {
      return;
    }
    // Create a list of a single track for the provider to consume
    const trackProperties = this.captionsProperties[trackName];
    if (!trackProperties) {
      return;
    }
    const label = trackProperties.label;
    const track = {
      _id: trackName,
      label,
      kind: 'captions',
      default: trackProperties.media ? !!trackProperties.media.default : false,
      closedCaptions: trackProperties.media
    };
    this.nonNativeCaptionsTracks[trackName] = track;
    this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [track]
    });
  }
  createTextTrack(kind, label, lang) {
    const media = this.media;
    if (!media) {
      return;
    }
    return media.addTextTrack(kind, label, lang);
  }
  onMediaAttaching(event, data) {
    this.media = data.media;
    this._cleanTracks();
  }
  onMediaDetaching() {
    const {
      captionsTracks
    } = this;
    Object.keys(captionsTracks).forEach(trackName => {
      clearCurrentCues(captionsTracks[trackName]);
      delete captionsTracks[trackName];
    });
    this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    this.lastSn = -1; // Detect discontinuity in fragment parsing
    this.lastPartIndex = -1;
    this.prevCC = -1;
    this.vttCCs = newVTTCCs(); // Detect discontinuity in subtitle manifests
    this._cleanTracks();
    this.tracks = [];
    this.captionsTracks = {};
    this.nonNativeCaptionsTracks = {};
    this.textTracks = [];
    this.unparsedVttFrags = [];
    this.initPTS = [];
    if (this.cea608Parser1 && this.cea608Parser2) {
      this.cea608Parser1.reset();
      this.cea608Parser2.reset();
    }
  }
  _cleanTracks() {
    // clear outdated subtitles
    const {
      media
    } = this;
    if (!media) {
      return;
    }
    const textTracks = media.textTracks;
    if (textTracks) {
      for (let i = 0; i < textTracks.length; i++) {
        clearCurrentCues(textTracks[i]);
      }
    }
  }
  onSubtitleTracksUpdated(event, data) {
    const tracks = data.subtitleTracks || [];
    const hasIMSC1 = tracks.some(track => track.textCodec === IMSC1_CODEC);
    if (this.config.enableWebVTT || hasIMSC1 && this.config.enableIMSC1) {
      const listIsIdentical = subtitleOptionsIdentical(this.tracks, tracks);
      if (listIsIdentical) {
        this.tracks = tracks;
        return;
      }
      this.textTracks = [];
      this.tracks = tracks;
      if (this.config.renderTextTracksNatively) {
        const inUseTracks = this.media ? this.media.textTracks : null;
        this.tracks.forEach((track, index) => {
          let textTrack;
          if (inUseTracks && index < inUseTracks.length) {
            let inUseTrack = null;
            for (let i = 0; i < inUseTracks.length; i++) {
              if (canReuseVttTextTrack(inUseTracks[i], track)) {
                inUseTrack = inUseTracks[i];
                break;
              }
            }

            // Reuse tracks with the same label, but do not reuse 608/708 tracks
            if (inUseTrack) {
              textTrack = inUseTrack;
            }
          }
          if (textTrack) {
            clearCurrentCues(textTrack);
          } else {
            const textTrackKind = this._captionsOrSubtitlesFromCharacteristics(track);
            textTrack = this.createTextTrack(textTrackKind, track.name, track.lang);
            if (textTrack) {
              textTrack.mode = 'disabled';
            }
          }
          if (textTrack) {
            textTrack.groupId = track.groupId;
            this.textTracks.push(textTrack);
          }
        });
      } else if (this.tracks.length) {
        // Create a list of tracks for the provider to consume
        const tracksList = this.tracks.map(track => {
          return {
            label: track.name,
            kind: track.type.toLowerCase(),
            default: track.default,
            subtitleTrack: track
          };
        });
        this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: tracksList
        });
      }
    }
  }
  _captionsOrSubtitlesFromCharacteristics(track) {
    if (track.attrs.CHARACTERISTICS) {
      const transcribesSpokenDialog = /transcribes-spoken-dialog/gi.test(track.attrs.CHARACTERISTICS);
      const describesMusicAndSound = /describes-music-and-sound/gi.test(track.attrs.CHARACTERISTICS);
      if (transcribesSpokenDialog && describesMusicAndSound) {
        return 'captions';
      }
    }
    return 'subtitles';
  }
  onManifestLoaded(event, data) {
    if (this.config.enableCEA708Captions && data.captions) {
      data.captions.forEach(captionsTrack => {
        const instreamIdMatch = /(?:CC|SERVICE)([1-4])/.exec(captionsTrack.instreamId);
        if (!instreamIdMatch) {
          return;
        }
        const trackName = `textTrack${instreamIdMatch[1]}`;
        const trackProperties = this.captionsProperties[trackName];
        if (!trackProperties) {
          return;
        }
        trackProperties.label = captionsTrack.name;
        if (captionsTrack.lang) {
          // optional attribute
          trackProperties.languageCode = captionsTrack.lang;
        }
        trackProperties.media = captionsTrack;
      });
    }
  }
  closedCaptionsForLevel(frag) {
    const level = this.hls.levels[frag.level];
    return level == null ? void 0 : level.attrs['CLOSED-CAPTIONS'];
  }
  onFragLoading(event, data) {
    const {
      cea608Parser1,
      cea608Parser2,
      lastSn,
      lastPartIndex
    } = this;
    if (!this.enabled || !(cea608Parser1 && cea608Parser2)) {
      return;
    }
    // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
    if (data.frag.type === PlaylistLevelType.MAIN) {
      var _data$part$index, _data$part;
      const sn = data.frag.sn;
      const partIndex = (_data$part$index = data == null ? void 0 : (_data$part = data.part) == null ? void 0 : _data$part.index) != null ? _data$part$index : -1;
      if (!(sn === lastSn + 1 || sn === lastSn && partIndex === lastPartIndex + 1)) {
        cea608Parser1.reset();
        cea608Parser2.reset();
      }
      this.lastSn = sn;
      this.lastPartIndex = partIndex;
    }
  }
  onFragLoaded(event, data) {
    const {
      frag,
      payload
    } = data;
    if (frag.type === PlaylistLevelType.SUBTITLE) {
      // If fragment is subtitle type, parse as WebVTT.
      if (payload.byteLength) {
        const decryptData = frag.decryptdata;
        // fragment after decryption has a stats object
        const decrypted = ('stats' in data);
        // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
        if (decryptData == null || !decryptData.encrypted || decrypted) {
          const trackPlaylistMedia = this.tracks[frag.level];
          const vttCCs = this.vttCCs;
          if (!vttCCs[frag.cc]) {
            vttCCs[frag.cc] = {
              start: frag.start,
              prevCC: this.prevCC,
              new: true
            };
            this.prevCC = frag.cc;
          }
          if (trackPlaylistMedia && trackPlaylistMedia.textCodec === IMSC1_CODEC) {
            this._parseIMSC1(frag, payload);
          } else {
            this._parseVTTs(data);
          }
        }
      } else {
        // In case there is no payload, finish unsuccessfully.
        this.hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
          success: false,
          frag,
          error: new Error('Empty subtitle payload')
        });
      }
    }
  }
  _parseIMSC1(frag, payload) {
    const hls = this.hls;
    parseIMSC1(payload, this.initPTS[frag.cc], cues => {
      this._appendCues(cues, frag.level);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: true,
        frag: frag
      });
    }, error => {
      logger.log(`Failed to parse IMSC1: ${error}`);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: false,
        frag: frag,
        error
      });
    });
  }
  _parseVTTs(data) {
    var _frag$initSegment;
    const {
      frag,
      payload
    } = data;
    // We need an initial synchronisation PTS. Store fragments as long as none has arrived
    const {
      initPTS,
      unparsedVttFrags
    } = this;
    const maxAvCC = initPTS.length - 1;
    if (!initPTS[frag.cc] && maxAvCC === -1) {
      unparsedVttFrags.push(data);
      return;
    }
    const hls = this.hls;
    // Parse the WebVTT file contents.
    const payloadWebVTT = (_frag$initSegment = frag.initSegment) != null && _frag$initSegment.data ? appendUint8Array(frag.initSegment.data, new Uint8Array(payload)) : payload;
    parseWebVTT(payloadWebVTT, this.initPTS[frag.cc], this.vttCCs, frag.cc, frag.start, cues => {
      this._appendCues(cues, frag.level);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: true,
        frag: frag
      });
    }, error => {
      const missingInitPTS = error.message === 'Missing initPTS for VTT MPEGTS';
      if (missingInitPTS) {
        unparsedVttFrags.push(data);
      } else {
        this._fallbackToIMSC1(frag, payload);
      }
      // Something went wrong while parsing. Trigger event with success false.
      logger.log(`Failed to parse VTT cue: ${error}`);
      if (missingInitPTS && maxAvCC > frag.cc) {
        return;
      }
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: false,
        frag: frag,
        error
      });
    });
  }
  _fallbackToIMSC1(frag, payload) {
    // If textCodec is unknown, try parsing as IMSC1. Set textCodec based on the result
    const trackPlaylistMedia = this.tracks[frag.level];
    if (!trackPlaylistMedia.textCodec) {
      parseIMSC1(payload, this.initPTS[frag.cc], () => {
        trackPlaylistMedia.textCodec = IMSC1_CODEC;
        this._parseIMSC1(frag, payload);
      }, () => {
        trackPlaylistMedia.textCodec = 'wvtt';
      });
    }
  }
  _appendCues(cues, fragLevel) {
    const hls = this.hls;
    if (this.config.renderTextTracksNatively) {
      const textTrack = this.textTracks[fragLevel];
      // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
      // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
      // and trying to access getCueById method of cues will throw an exception
      // Because we check if the mode is disabled, we can force check `cues` below. They can't be null.
      if (!textTrack || textTrack.mode === 'disabled') {
        return;
      }
      cues.forEach(cue => addCueToTrack(textTrack, cue));
    } else {
      const currentTrack = this.tracks[fragLevel];
      if (!currentTrack) {
        return;
      }
      const track = currentTrack.default ? 'default' : 'subtitles' + fragLevel;
      hls.trigger(Events.CUES_PARSED, {
        type: 'subtitles',
        cues,
        track
      });
    }
  }
  onFragDecrypted(event, data) {
    const {
      frag
    } = data;
    if (frag.type === PlaylistLevelType.SUBTITLE) {
      this.onFragLoaded(Events.FRAG_LOADED, data);
    }
  }
  onSubtitleTracksCleared() {
    this.tracks = [];
    this.captionsTracks = {};
  }
  onFragParsingUserdata(event, data) {
    const {
      cea608Parser1,
      cea608Parser2
    } = this;
    if (!this.enabled || !(cea608Parser1 && cea608Parser2)) {
      return;
    }
    const {
      frag,
      samples
    } = data;
    if (frag.type === PlaylistLevelType.MAIN && this.closedCaptionsForLevel(frag) === 'NONE') {
      return;
    }
    // If the event contains captions (found in the bytes property), push all bytes into the parser immediately
    // It will create the proper timestamps based on the PTS value
    for (let i = 0; i < samples.length; i++) {
      const ccBytes = samples[i].bytes;
      if (ccBytes) {
        const ccdatas = this.extractCea608Data(ccBytes);
        cea608Parser1.addData(samples[i].pts, ccdatas[0]);
        cea608Parser2.addData(samples[i].pts, ccdatas[1]);
      }
    }
  }
  onBufferFlushing(event, {
    startOffset,
    endOffset,
    endOffsetSubtitles,
    type
  }) {
    const {
      media
    } = this;
    if (!media || media.currentTime < endOffset) {
      return;
    }
    // Clear 608 caption cues from the captions TextTracks when the video back buffer is flushed
    // Forward cues are never removed because we can loose streamed 608 content from recent fragments
    if (!type || type === 'video') {
      const {
        captionsTracks
      } = this;
      Object.keys(captionsTracks).forEach(trackName => removeCuesInRange(captionsTracks[trackName], startOffset, endOffset));
    }
    if (this.config.renderTextTracksNatively) {
      // Clear VTT/IMSC1 subtitle cues from the subtitle TextTracks when the back buffer is flushed
      if (startOffset === 0 && endOffsetSubtitles !== undefined) {
        const {
          textTracks
        } = this;
        Object.keys(textTracks).forEach(trackName => removeCuesInRange(textTracks[trackName], startOffset, endOffsetSubtitles));
      }
    }
  }
  extractCea608Data(byteArray) {
    const actualCCBytes = [[], []];
    const count = byteArray[0] & 0x1f;
    let position = 2;
    for (let j = 0; j < count; j++) {
      const tmpByte = byteArray[position++];
      const ccbyte1 = 0x7f & byteArray[position++];
      const ccbyte2 = 0x7f & byteArray[position++];
      if (ccbyte1 === 0 && ccbyte2 === 0) {
        continue;
      }
      const ccValid = (0x04 & tmpByte) !== 0; // Support all four channels
      if (ccValid) {
        const ccType = 0x03 & tmpByte;
        if (0x00 /* CEA608 field1*/ === ccType || 0x01 /* CEA608 field2*/ === ccType) {
          // Exclude CEA708 CC data.
          actualCCBytes[ccType].push(ccbyte1);
          actualCCBytes[ccType].push(ccbyte2);
        }
      }
    }
    return actualCCBytes;
  }
}
function canReuseVttTextTrack(inUseTrack, manifestTrack) {
  return !!inUseTrack && inUseTrack.label === manifestTrack.name && !(inUseTrack.textTrack1 || inUseTrack.textTrack2);
}
function intersection(x1, x2, y1, y2) {
  return Math.min(x2, y2) - Math.max(x1, y1);
}
function newVTTCCs() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: true
    }
  };
}

/*
 * cap stream level to media size dimension controller
 */

class CapLevelController {
  constructor(hls) {
    this.hls = void 0;
    this.autoLevelCapping = void 0;
    this.firstLevel = void 0;
    this.media = void 0;
    this.restrictedLevels = void 0;
    this.timer = void 0;
    this.clientRect = void 0;
    this.streamController = void 0;
    this.hls = hls;
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    this.firstLevel = -1;
    this.media = null;
    this.restrictedLevels = [];
    this.timer = undefined;
    this.clientRect = null;
    this.registerListeners();
  }
  setStreamController(streamController) {
    this.streamController = streamController;
  }
  destroy() {
    this.unregisterListener();
    if (this.hls.config.capLevelToPlayerSize) {
      this.stopCapping();
    }
    this.media = null;
    this.clientRect = null;
    // @ts-ignore
    this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls
    } = this;
    hls.off(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(event, data) {
    // Don't add a restricted level more than once
    const level = this.hls.levels[data.droppedLevel];
    if (this.isLevelAllowed(level)) {
      this.restrictedLevels.push({
        bitrate: level.bitrate,
        height: level.height,
        width: level.width
      });
    }
  }
  onMediaAttaching(event, data) {
    this.media = data.media instanceof HTMLVideoElement ? data.media : null;
    this.clientRect = null;
  }
  onManifestParsed(event, data) {
    const hls = this.hls;
    this.restrictedLevels = [];
    this.firstLevel = data.firstLevel;
    if (hls.config.capLevelToPlayerSize && data.video) {
      // Start capping immediately if the manifest has signaled video codecs
      this.startCapping();
    }
  }

  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(event, data) {
    const hls = this.hls;
    if (hls.config.capLevelToPlayerSize && data.video) {
      // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
      this.startCapping();
    }
  }
  onMediaDetaching() {
    this.stopCapping();
  }
  detectPlayerSize() {
    if (this.media && this.mediaHeight > 0 && this.mediaWidth > 0) {
      const levels = this.hls.levels;
      if (levels.length) {
        const hls = this.hls;
        hls.autoLevelCapping = this.getMaxLevel(levels.length - 1);
        if (hls.autoLevelCapping > this.autoLevelCapping && this.streamController) {
          // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
          // usually happen when the user go to the fullscreen mode.
          this.streamController.nextLevelSwitch();
        }
        this.autoLevelCapping = hls.autoLevelCapping;
      }
    }
  }

  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(capLevelIndex) {
    const levels = this.hls.levels;
    if (!levels.length) {
      return -1;
    }
    const validLevels = levels.filter((level, index) => this.isLevelAllowed(level) && index <= capLevelIndex);
    this.clientRect = null;
    return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    if (this.timer) {
      // Don't reset capping if started twice; this can happen if the manifest signals a video codec
      return;
    }
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    this.hls.firstLevel = this.getMaxLevel(this.firstLevel);
    self.clearInterval(this.timer);
    this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1000);
    this.detectPlayerSize();
  }
  stopCapping() {
    this.restrictedLevels = [];
    this.firstLevel = -1;
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    if (this.timer) {
      self.clearInterval(this.timer);
      this.timer = undefined;
    }
  }
  getDimensions() {
    if (this.clientRect) {
      return this.clientRect;
    }
    const media = this.media;
    const boundsRect = {
      width: 0,
      height: 0
    };
    if (media) {
      const clientRect = media.getBoundingClientRect();
      boundsRect.width = clientRect.width;
      boundsRect.height = clientRect.height;
      if (!boundsRect.width && !boundsRect.height) {
        // When the media element has no width or height (equivalent to not being in the DOM),
        // then use its width and height attributes (media.width, media.height)
        boundsRect.width = clientRect.right - clientRect.left || media.width || 0;
        boundsRect.height = clientRect.bottom - clientRect.top || media.height || 0;
      }
    }
    this.clientRect = boundsRect;
    return boundsRect;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let pixelRatio = 1;
    if (!this.hls.config.ignoreDevicePixelRatio) {
      try {
        pixelRatio = self.devicePixelRatio;
      } catch (e) {
        /* no-op */
      }
    }
    return pixelRatio;
  }
  isLevelAllowed(level) {
    const restrictedLevels = this.restrictedLevels;
    return !restrictedLevels.some(restrictedLevel => {
      return level.bitrate === restrictedLevel.bitrate && level.width === restrictedLevel.width && level.height === restrictedLevel.height;
    });
  }
  static getMaxLevelByMediaSize(levels, width, height) {
    if (!(levels != null && levels.length)) {
      return -1;
    }

    // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
    // to determine whether we've chosen the greatest bandwidth for the media's dimensions
    const atGreatestBandwidth = (curLevel, nextLevel) => {
      if (!nextLevel) {
        return true;
      }
      return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
    };

    // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
    // the max level
    let maxLevelIndex = levels.length - 1;
    for (let i = 0; i < levels.length; i += 1) {
      const level = levels[i];
      if ((level.width >= width || level.height >= height) && atGreatestBandwidth(level, levels[i + 1])) {
        maxLevelIndex = i;
        break;
      }
    }
    return maxLevelIndex;
  }
}

class FPSController {
  // stream controller must be provided as a dependency!

  constructor(hls) {
    this.hls = void 0;
    this.isVideoPlaybackQualityAvailable = false;
    this.timer = void 0;
    this.media = null;
    this.lastTime = void 0;
    this.lastDroppedFrames = 0;
    this.lastDecodedFrames = 0;
    this.streamController = void 0;
    this.hls = hls;
    this.registerListeners();
  }
  setStreamController(streamController) {
    this.streamController = streamController;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  destroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.unregisterListeners();
    this.isVideoPlaybackQualityAvailable = false;
    this.media = null;
  }
  onMediaAttaching(event, data) {
    const config = this.hls.config;
    if (config.capLevelOnFPSDrop) {
      const media = data.media instanceof self.HTMLVideoElement ? data.media : null;
      this.media = media;
      if (media && typeof media.getVideoPlaybackQuality === 'function') {
        this.isVideoPlaybackQualityAvailable = true;
      }
      self.clearInterval(this.timer);
      this.timer = self.setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
    }
  }
  checkFPS(video, decodedFrames, droppedFrames) {
    const currentTime = performance.now();
    if (decodedFrames) {
      if (this.lastTime) {
        const currentPeriod = currentTime - this.lastTime;
        const currentDropped = droppedFrames - this.lastDroppedFrames;
        const currentDecoded = decodedFrames - this.lastDecodedFrames;
        const droppedFPS = 1000 * currentDropped / currentPeriod;
        const hls = this.hls;
        hls.trigger(Events.FPS_DROP, {
          currentDropped: currentDropped,
          currentDecoded: currentDecoded,
          totalDroppedFrames: droppedFrames
        });
        if (droppedFPS > 0) {
          // logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
          if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
            let currentLevel = hls.currentLevel;
            logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
            if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
              currentLevel = currentLevel - 1;
              hls.trigger(Events.FPS_DROP_LEVEL_CAPPING, {
                level: currentLevel,
                droppedLevel: hls.currentLevel
              });
              hls.autoLevelCapping = currentLevel;
              this.streamController.nextLevelSwitch();
            }
          }
        }
      }
      this.lastTime = currentTime;
      this.lastDroppedFrames = droppedFrames;
      this.lastDecodedFrames = decodedFrames;
    }
  }
  checkFPSInterval() {
    const video = this.media;
    if (video) {
      if (this.isVideoPlaybackQualityAvailable) {
        const videoPlaybackQuality = video.getVideoPlaybackQuality();
        this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
      } else {
        // HTMLVideoElement doesn't include the webkit types
        this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
      }
    }
  }
}

const LOGGER_PREFIX = '[eme]';
/**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */
class EMEController {
  constructor(hls) {
    this.hls = void 0;
    this.config = void 0;
    this.media = null;
    this.keyFormatPromise = null;
    this.keySystemAccessPromises = {};
    this._requestLicenseFailureCount = 0;
    this.mediaKeySessions = [];
    this.keyIdToKeySessionPromise = {};
    this.setMediaKeysQueue = EMEController.CDMCleanupPromise ? [EMEController.CDMCleanupPromise] : [];
    this.onMediaEncrypted = this._onMediaEncrypted.bind(this);
    this.onWaitingForKey = this._onWaitingForKey.bind(this);
    this.debug = logger.debug.bind(logger, LOGGER_PREFIX);
    this.log = logger.log.bind(logger, LOGGER_PREFIX);
    this.warn = logger.warn.bind(logger, LOGGER_PREFIX);
    this.error = logger.error.bind(logger, LOGGER_PREFIX);
    this.hls = hls;
    this.config = hls.config;
    this.registerListeners();
  }
  destroy() {
    this.unregisterListeners();
    this.onMediaDetached();
    // Remove any references that could be held in config options or callbacks
    const config = this.config;
    config.requestMediaKeySystemAccessFunc = null;
    config.licenseXhrSetup = config.licenseResponseCallback = undefined;
    config.drmSystems = config.drmSystemOptions = {};
    // @ts-ignore
    this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null;
    // @ts-ignore
    this.config = null;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  getLicenseServerUrl(keySystem) {
    const {
      drmSystems,
      widevineLicenseUrl
    } = this.config;
    const keySystemConfiguration = drmSystems[keySystem];
    if (keySystemConfiguration) {
      return keySystemConfiguration.licenseUrl;
    }

    // For backward compatibility
    if (keySystem === KeySystems.WIDEVINE && widevineLicenseUrl) {
      return widevineLicenseUrl;
    }
    throw new Error(`no license server URL configured for key-system "${keySystem}"`);
  }
  getServerCertificateUrl(keySystem) {
    const {
      drmSystems
    } = this.config;
    const keySystemConfiguration = drmSystems[keySystem];
    if (keySystemConfiguration) {
      return keySystemConfiguration.serverCertificateUrl;
    } else {
      this.log(`No Server Certificate in config.drmSystems["${keySystem}"]`);
    }
  }
  attemptKeySystemAccess(keySystemsToAttempt) {
    const levels = this.hls.levels;
    const uniqueCodec = (value, i, a) => !!value && a.indexOf(value) === i;
    const audioCodecs = levels.map(level => level.audioCodec).filter(uniqueCodec);
    const videoCodecs = levels.map(level => level.videoCodec).filter(uniqueCodec);
    if (audioCodecs.length + videoCodecs.length === 0) {
      videoCodecs.push('avc1.42e01e');
    }
    return new Promise((resolve, reject) => {
      const attempt = keySystems => {
        const keySystem = keySystems.shift();
        this.getMediaKeysPromise(keySystem, audioCodecs, videoCodecs).then(mediaKeys => resolve({
          keySystem,
          mediaKeys
        })).catch(error => {
          if (keySystems.length) {
            attempt(keySystems);
          } else if (error instanceof EMEKeyError) {
            reject(error);
          } else {
            reject(new EMEKeyError({
              type: ErrorTypes.KEY_SYSTEM_ERROR,
              details: ErrorDetails.KEY_SYSTEM_NO_ACCESS,
              error,
              fatal: true
            }, error.message));
          }
        });
      };
      attempt(keySystemsToAttempt);
    });
  }
  requestMediaKeySystemAccess(keySystem, supportedConfigurations) {
    const {
      requestMediaKeySystemAccessFunc
    } = this.config;
    if (!(typeof requestMediaKeySystemAccessFunc === 'function')) {
      let errMessage = `Configured requestMediaKeySystemAccess is not a function ${requestMediaKeySystemAccessFunc}`;
      if (requestMediaKeySystemAccess === null && self.location.protocol === 'http:') {
        errMessage = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`;
      }
      return Promise.reject(new Error(errMessage));
    }
    return requestMediaKeySystemAccessFunc(keySystem, supportedConfigurations);
  }
  getMediaKeysPromise(keySystem, audioCodecs, videoCodecs) {
    // This can throw, but is caught in event handler callpath
    const mediaKeySystemConfigs = getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, this.config.drmSystemOptions);
    const keySystemAccessPromises = this.keySystemAccessPromises[keySystem];
    let keySystemAccess = keySystemAccessPromises == null ? void 0 : keySystemAccessPromises.keySystemAccess;
    if (!keySystemAccess) {
      this.log(`Requesting encrypted media "${keySystem}" key-system access with config: ${JSON.stringify(mediaKeySystemConfigs)}`);
      keySystemAccess = this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs);
      const _keySystemAccessPromises = this.keySystemAccessPromises[keySystem] = {
        keySystemAccess
      };
      keySystemAccess.catch(error => {
        this.log(`Failed to obtain access to key-system "${keySystem}": ${error}`);
      });
      return keySystemAccess.then(mediaKeySystemAccess => {
        this.log(`Access for key-system "${mediaKeySystemAccess.keySystem}" obtained`);
        const certificateRequest = this.fetchServerCertificate(keySystem);
        this.log(`Create media-keys for "${keySystem}"`);
        _keySystemAccessPromises.mediaKeys = mediaKeySystemAccess.createMediaKeys().then(mediaKeys => {
          this.log(`Media-keys created for "${keySystem}"`);
          return certificateRequest.then(certificate => {
            if (certificate) {
              return this.setMediaKeysServerCertificate(mediaKeys, keySystem, certificate);
            }
            return mediaKeys;
          });
        });
        _keySystemAccessPromises.mediaKeys.catch(error => {
          this.error(`Failed to create media-keys for "${keySystem}"}: ${error}`);
        });
        return _keySystemAccessPromises.mediaKeys;
      });
    }
    return keySystemAccess.then(() => keySystemAccessPromises.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata,
    keySystem,
    mediaKeys
  }) {
    this.log(`Creating key-system session "${keySystem}" keyId: ${Hex.hexDump(decryptdata.keyId || [])}`);
    const mediaKeysSession = mediaKeys.createSession();
    const mediaKeySessionContext = {
      decryptdata,
      keySystem,
      mediaKeys,
      mediaKeysSession,
      keyStatus: 'status-pending'
    };
    this.mediaKeySessions.push(mediaKeySessionContext);
    return mediaKeySessionContext;
  }
  renewKeySession(mediaKeySessionContext) {
    const decryptdata = mediaKeySessionContext.decryptdata;
    if (decryptdata.pssh) {
      const keySessionContext = this.createMediaKeySessionContext(mediaKeySessionContext);
      const keyId = this.getKeyIdString(decryptdata);
      const scheme = 'cenc';
      this.keyIdToKeySessionPromise[keyId] = this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh, 'expired');
    } else {
      this.warn(`Could not renew expired session. Missing pssh initData.`);
    }
    this.removeSession(mediaKeySessionContext);
  }
  getKeyIdString(decryptdata) {
    if (!decryptdata) {
      throw new Error('Could not read keyId of undefined decryptdata');
    }
    if (decryptdata.keyId === null) {
      throw new Error('keyId is null');
    }
    return Hex.hexDump(decryptdata.keyId);
  }
  updateKeySession(mediaKeySessionContext, data) {
    var _mediaKeySessionConte;
    const keySession = mediaKeySessionContext.mediaKeysSession;
    this.log(`Updating key-session "${keySession.sessionId}" for keyID ${Hex.hexDump(((_mediaKeySessionConte = mediaKeySessionContext.decryptdata) == null ? void 0 : _mediaKeySessionConte.keyId) || [])}
      } (data length: ${data ? data.byteLength : data})`);
    return keySession.update(data);
  }
  selectKeySystemFormat(frag) {
    const keyFormats = Object.keys(frag.levelkeys || {});
    if (!this.keyFormatPromise) {
      this.log(`Selecting key-system from fragment (sn: ${frag.sn} ${frag.type}: ${frag.level}) key formats ${keyFormats.join(', ')}`);
      this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
    }
    return this.keyFormatPromise;
  }
  getKeyFormatPromise(keyFormats) {
    return new Promise((resolve, reject) => {
      const keySystemsInConfig = getKeySystemsForConfig(this.config);
      const keySystemsToAttempt = keyFormats.map(keySystemFormatToKeySystemDomain).filter(value => !!value && keySystemsInConfig.indexOf(value) !== -1);
      return this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({
        keySystem
      }) => {
        const keySystemFormat = keySystemDomainToKeySystemFormat(keySystem);
        if (keySystemFormat) {
          resolve(keySystemFormat);
        } else {
          reject(new Error(`Unable to find format for key-system "${keySystem}"`));
        }
      }).catch(reject);
    });
  }
  loadKey(data) {
    const decryptdata = data.keyInfo.decryptdata;
    const keyId = this.getKeyIdString(decryptdata);
    const keyDetails = `(keyId: ${keyId} format: "${decryptdata.keyFormat}" method: ${decryptdata.method} uri: ${decryptdata.uri})`;
    this.log(`Starting session for key ${keyDetails}`);
    let keySessionContextPromise = this.keyIdToKeySessionPromise[keyId];
    if (!keySessionContextPromise) {
      keySessionContextPromise = this.keyIdToKeySessionPromise[keyId] = this.getKeySystemForKeyPromise(decryptdata).then(({
        keySystem,
        mediaKeys
      }) => {
        this.throwIfDestroyed();
        this.log(`Handle encrypted media sn: ${data.frag.sn} ${data.frag.type}: ${data.frag.level} using key ${keyDetails}`);
        return this.attemptSetMediaKeys(keySystem, mediaKeys).then(() => {
          this.throwIfDestroyed();
          const keySessionContext = this.createMediaKeySessionContext({
            keySystem,
            mediaKeys,
            decryptdata
          });
          const scheme = 'cenc';
          return this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh, 'playlist-key');
        });
      });
      keySessionContextPromise.catch(error => this.handleError(error));
    }
    return keySessionContextPromise;
  }
  throwIfDestroyed(message = 'Invalid state') {
    if (!this.hls) {
      throw new Error('invalid state');
    }
  }
  handleError(error) {
    if (!this.hls) {
      return;
    }
    this.error(error.message);
    if (error instanceof EMEKeyError) {
      this.hls.trigger(Events.ERROR, error.data);
    } else {
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_KEYS,
        error,
        fatal: true
      });
    }
  }
  getKeySystemForKeyPromise(decryptdata) {
    const keyId = this.getKeyIdString(decryptdata);
    const mediaKeySessionContext = this.keyIdToKeySessionPromise[keyId];
    if (!mediaKeySessionContext) {
      const keySystem = keySystemFormatToKeySystemDomain(decryptdata.keyFormat);
      const keySystemsToAttempt = keySystem ? [keySystem] : getKeySystemsForConfig(this.config);
      return this.attemptKeySystemAccess(keySystemsToAttempt);
    }
    return mediaKeySessionContext;
  }
  getKeySystemSelectionPromise(keySystemsToAttempt) {
    if (!keySystemsToAttempt.length) {
      keySystemsToAttempt = getKeySystemsForConfig(this.config);
    }
    if (keySystemsToAttempt.length === 0) {
      throw new EMEKeyError({
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: true
      }, `Missing key-system license configuration options ${JSON.stringify({
        drmSystems: this.config.drmSystems
      })}`);
    }
    return this.attemptKeySystemAccess(keySystemsToAttempt);
  }
  _onMediaEncrypted(event) {
    const {
      initDataType,
      initData
    } = event;
    this.debug(`"${event.type}" event: init data type: "${initDataType}"`);

    // Ignore event when initData is null
    if (initData === null) {
      return;
    }
    let keyId;
    let keySystemDomain;
    if (initDataType === 'sinf' && this.config.drmSystems[KeySystems.FAIRPLAY]) {
      // Match sinf keyId to playlist skd://keyId=
      const json = bin2str(new Uint8Array(initData));
      try {
        const sinf = base64Decode(JSON.parse(json).sinf);
        const tenc = parseSinf(new Uint8Array(sinf));
        if (!tenc) {
          return;
        }
        keyId = tenc.subarray(8, 24);
        keySystemDomain = KeySystems.FAIRPLAY;
      } catch (error) {
        this.warn('Failed to parse sinf "encrypted" event message initData');
        return;
      }
    } else {
      // Support clear-lead key-session creation (otherwise depend on playlist keys)
      const psshInfo = parsePssh(initData);
      if (psshInfo === null) {
        return;
      }
      if (psshInfo.version === 0 && psshInfo.systemId === KeySystemIds.WIDEVINE && psshInfo.data) {
        keyId = psshInfo.data.subarray(8, 24);
      }
      keySystemDomain = keySystemIdToKeySystemDomain(psshInfo.systemId);
    }
    if (!keySystemDomain || !keyId) {
      return;
    }
    const keyIdHex = Hex.hexDump(keyId);
    const {
      keyIdToKeySessionPromise,
      mediaKeySessions
    } = this;
    let keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex];
    for (let i = 0; i < mediaKeySessions.length; i++) {
      // Match playlist key
      const keyContext = mediaKeySessions[i];
      const decryptdata = keyContext.decryptdata;
      if (decryptdata.pssh || !decryptdata.keyId) {
        continue;
      }
      const oldKeyIdHex = Hex.hexDump(decryptdata.keyId);
      if (keyIdHex === oldKeyIdHex || decryptdata.uri.replace(/-/g, '').indexOf(keyIdHex) !== -1) {
        keySessionContextPromise = keyIdToKeySessionPromise[oldKeyIdHex];
        delete keyIdToKeySessionPromise[oldKeyIdHex];
        decryptdata.pssh = new Uint8Array(initData);
        decryptdata.keyId = keyId;
        keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = keySessionContextPromise.then(() => {
          return this.generateRequestWithPreferredKeySession(keyContext, initDataType, initData, 'encrypted-event-key-match');
        });
        break;
      }
    }
    if (!keySessionContextPromise) {
      // Clear-lead key (not encountered in playlist)
      keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = this.getKeySystemSelectionPromise([keySystemDomain]).then(({
        keySystem,
        mediaKeys
      }) => {
        var _keySystemToKeySystem;
        this.throwIfDestroyed();
        const decryptdata = new LevelKey('ISO-23001-7', keyIdHex, (_keySystemToKeySystem = keySystemDomainToKeySystemFormat(keySystem)) != null ? _keySystemToKeySystem : '');
        decryptdata.pssh = new Uint8Array(initData);
        decryptdata.keyId = keyId;
        return this.attemptSetMediaKeys(keySystem, mediaKeys).then(() => {
          this.throwIfDestroyed();
          const keySessionContext = this.createMediaKeySessionContext({
            decryptdata,
            keySystem,
            mediaKeys
          });
          return this.generateRequestWithPreferredKeySession(keySessionContext, initDataType, initData, 'encrypted-event-no-match');
        });
      });
    }
    keySessionContextPromise.catch(error => this.handleError(error));
  }
  _onWaitingForKey(event) {
    this.log(`"${event.type}" event`);
  }
  attemptSetMediaKeys(keySystem, mediaKeys) {
    const queue = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${keySystem}"`);
    // Only one setMediaKeys() can run at one time, and multiple setMediaKeys() operations
    // can be queued for execution for multiple key sessions.
    const setMediaKeysPromise = Promise.all(queue).then(() => {
      if (!this.media) {
        throw new Error('Attempted to set mediaKeys without media element attached');
      }
      return this.media.setMediaKeys(mediaKeys);
    });
    this.setMediaKeysQueue.push(setMediaKeysPromise);
    return setMediaKeysPromise.then(() => {
      this.log(`Media-keys set for "${keySystem}"`);
      queue.push(setMediaKeysPromise);
      this.setMediaKeysQueue = this.setMediaKeysQueue.filter(p => queue.indexOf(p) === -1);
    });
  }
  generateRequestWithPreferredKeySession(context, initDataType, initData, reason) {
    var _this$config$drmSyste, _this$config$drmSyste2;
    const generateRequestFilter = (_this$config$drmSyste = this.config.drmSystems) == null ? void 0 : (_this$config$drmSyste2 = _this$config$drmSyste[context.keySystem]) == null ? void 0 : _this$config$drmSyste2.generateRequest;
    if (generateRequestFilter) {
      try {
        const mappedInitData = generateRequestFilter.call(this.hls, initDataType, initData, context);
        if (!mappedInitData) {
          throw new Error('Invalid response from configured generateRequest filter');
        }
        initDataType = mappedInitData.initDataType;
        initData = context.decryptdata.pssh = mappedInitData.initData ? new Uint8Array(mappedInitData.initData) : null;
      } catch (error) {
        var _this$hls;
        this.warn(error.message);
        if ((_this$hls = this.hls) != null && _this$hls.config.debug) {
          throw error;
        }
      }
    }
    if (initData === null) {
      this.log(`Skipping key-session request for "${reason}" (no initData)`);
      return Promise.resolve(context);
    }
    const keyId = this.getKeyIdString(context.decryptdata);
    this.log(`Generating key-session request for "${reason}": ${keyId} (init data type: ${initDataType} length: ${initData ? initData.byteLength : null})`);
    const licenseStatus = new EventEmitter();
    context.mediaKeysSession.onmessage = event => {
      const keySession = context.mediaKeysSession;
      if (!keySession) {
        licenseStatus.emit('error', new Error('invalid state'));
        return;
      }
      const {
        messageType,
        message
      } = event;
      this.log(`"${messageType}" message event for session "${keySession.sessionId}" message size: ${message.byteLength}`);
      if (messageType === 'license-request' || messageType === 'license-renewal') {
        this.renewLicense(context, message).catch(error => {
          this.handleError(error);
          licenseStatus.emit('error', error);
        });
      } else if (messageType === 'license-release') {
        if (context.keySystem === KeySystems.FAIRPLAY) {
          this.updateKeySession(context, strToUtf8array('acknowledged'));
          this.removeSession(context);
        }
      } else {
        this.warn(`unhandled media key message type "${messageType}"`);
      }
    };
    context.mediaKeysSession.onkeystatuseschange = event => {
      const keySession = context.mediaKeysSession;
      if (!keySession) {
        licenseStatus.emit('error', new Error('invalid state'));
        return;
      }
      this.onKeyStatusChange(context);
      const keyStatus = context.keyStatus;
      licenseStatus.emit('keyStatus', keyStatus);
      if (keyStatus === 'expired') {
        this.warn(`${context.keySystem} expired for key ${keyId}`);
        this.renewKeySession(context);
      }
    };
    const keyUsablePromise = new Promise((resolve, reject) => {
      licenseStatus.on('error', reject);
      licenseStatus.on('keyStatus', keyStatus => {
        if (keyStatus.startsWith('usable')) {
          resolve();
        } else if (keyStatus === 'output-restricted') {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
            fatal: false
          }, 'HDCP level output restricted'));
        } else if (keyStatus === 'internal-error') {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
            fatal: true
          }, `key status changed to "${keyStatus}"`));
        } else if (keyStatus === 'expired') {
          reject(new Error('key expired while generating request'));
        } else {
          this.warn(`unhandled key status change "${keyStatus}"`);
        }
      });
    });
    return context.mediaKeysSession.generateRequest(initDataType, initData).then(() => {
      var _context$mediaKeysSes;
      this.log(`Request generated for key-session "${(_context$mediaKeysSes = context.mediaKeysSession) == null ? void 0 : _context$mediaKeysSes.sessionId}" keyId: ${keyId}`);
    }).catch(error => {
      throw new EMEKeyError({
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_SESSION,
        error,
        fatal: false
      }, `Error generating key-session request: ${error}`);
    }).then(() => keyUsablePromise).catch(error => {
      licenseStatus.removeAllListeners();
      this.removeSession(context);
      throw error;
    }).then(() => {
      licenseStatus.removeAllListeners();
      return context;
    });
  }
  onKeyStatusChange(mediaKeySessionContext) {
    mediaKeySessionContext.mediaKeysSession.keyStatuses.forEach((status, keyId) => {
      this.log(`key status change "${status}" for keyStatuses keyId: ${Hex.hexDump('buffer' in keyId ? new Uint8Array(keyId.buffer, keyId.byteOffset, keyId.byteLength) : new Uint8Array(keyId))} session keyId: ${Hex.hexDump(new Uint8Array(mediaKeySessionContext.decryptdata.keyId || []))} uri: ${mediaKeySessionContext.decryptdata.uri}`);
      mediaKeySessionContext.keyStatus = status;
    });
  }
  fetchServerCertificate(keySystem) {
    const config = this.config;
    const Loader = config.loader;
    const certLoader = new Loader(config);
    const url = this.getServerCertificateUrl(keySystem);
    if (!url) {
      return Promise.resolve();
    }
    this.log(`Fetching serverCertificate for "${keySystem}"`);
    return new Promise((resolve, reject) => {
      const loaderContext = {
        responseType: 'arraybuffer',
        url
      };
      const loadPolicy = config.certLoadPolicy.default;
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      };
      const loaderCallbacks = {
        onSuccess: (response, stats, context, networkDetails) => {
          resolve(response.data);
        },
        onError: (response, contex, networkDetails, stats) => {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: true,
            networkDetails,
            response: _objectSpread2({
              url: loaderContext.url,
              data: undefined
            }, response)
          }, `"${keySystem}" certificate request failed (${url}). Status: ${response.code} (${response.text})`));
        },
        onTimeout: (stats, context, networkDetails) => {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: true,
            networkDetails,
            response: {
              url: loaderContext.url,
              data: undefined
            }
          }, `"${keySystem}" certificate request timed out (${url})`));
        },
        onAbort: (stats, context, networkDetails) => {
          reject(new Error('aborted'));
        }
      };
      certLoader.load(loaderContext, loaderConfig, loaderCallbacks);
    });
  }
  setMediaKeysServerCertificate(mediaKeys, keySystem, cert) {
    return new Promise((resolve, reject) => {
      mediaKeys.setServerCertificate(cert).then(success => {
        this.log(`setServerCertificate ${success ? 'success' : 'not supported by CDM'} (${cert == null ? void 0 : cert.byteLength}) on "${keySystem}"`);
        resolve(mediaKeys);
      }).catch(error => {
        reject(new EMEKeyError({
          type: ErrorTypes.KEY_SYSTEM_ERROR,
          details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error,
          fatal: true
        }, error.message));
      });
    });
  }
  renewLicense(context, keyMessage) {
    return this.requestLicense(context, new Uint8Array(keyMessage)).then(data => {
      return this.updateKeySession(context, new Uint8Array(data)).catch(error => {
        throw new EMEKeyError({
          type: ErrorTypes.KEY_SYSTEM_ERROR,
          details: ErrorDetails.KEY_SYSTEM_SESSION_UPDATE_FAILED,
          error,
          fatal: true
        }, error.message);
      });
    });
  }
  setupLicenseXHR(xhr, url, keysListItem, licenseChallenge) {
    const licenseXhrSetup = this.config.licenseXhrSetup;
    if (!licenseXhrSetup) {
      xhr.open('POST', url, true);
      return Promise.resolve({
        xhr,
        licenseChallenge
      });
    }
    return Promise.resolve().then(() => {
      if (!keysListItem.decryptdata) {
        throw new Error('Key removed');
      }
      return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
    }).catch(error => {
      if (!keysListItem.decryptdata) {
        // Key session removed. Cancel license request.
        throw error;
      }
      // let's try to open before running setup
      xhr.open('POST', url, true);
      return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
    }).then(licenseXhrSetupResult => {
      // if licenseXhrSetup did not yet call open, let's do it now
      if (!xhr.readyState) {
        xhr.open('POST', url, true);
      }
      const finalLicenseChallenge = licenseXhrSetupResult ? licenseXhrSetupResult : licenseChallenge;
      return {
        xhr,
        licenseChallenge: finalLicenseChallenge
      };
    });
  }
  requestLicense(keySessionContext, licenseChallenge) {
    const keyLoadPolicy = this.config.keyLoadPolicy.default;
    return new Promise((resolve, reject) => {
      const url = this.getLicenseServerUrl(keySessionContext.keySystem);
      this.log(`Sending license request to URL: ${url}`);
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'arraybuffer';
      xhr.onreadystatechange = () => {
        if (!this.hls || !keySessionContext.mediaKeysSession) {
          return reject(new Error('invalid state'));
        }
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            this._requestLicenseFailureCount = 0;
            let data = xhr.response;
            this.log(`License received ${data instanceof ArrayBuffer ? data.byteLength : data}`);
            const licenseResponseCallback = this.config.licenseResponseCallback;
            if (licenseResponseCallback) {
              try {
                data = licenseResponseCallback.call(this.hls, xhr, url, keySessionContext);
              } catch (error) {
                this.error(error);
              }
            }
            resolve(data);
          } else {
            const retryConfig = keyLoadPolicy.errorRetry;
            const maxNumRetry = retryConfig ? retryConfig.maxNumRetry : 0;
            this._requestLicenseFailureCount++;
            if (this._requestLicenseFailureCount > maxNumRetry || xhr.status >= 400 && xhr.status < 500) {
              reject(new EMEKeyError({
                type: ErrorTypes.KEY_SYSTEM_ERROR,
                details: ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: true,
                networkDetails: xhr,
                response: {
                  url,
                  data: undefined,
                  code: xhr.status,
                  text: xhr.statusText
                }
              }, `License Request XHR failed (${url}). Status: ${xhr.status} (${xhr.statusText})`));
            } else {
              const attemptsLeft = maxNumRetry - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${attemptsLeft} attempts left`);
              this.requestLicense(keySessionContext, licenseChallenge).then(resolve, reject);
            }
          }
        }
      };
      if (keySessionContext.licenseXhr && keySessionContext.licenseXhr.readyState !== XMLHttpRequest.DONE) {
        keySessionContext.licenseXhr.abort();
      }
      keySessionContext.licenseXhr = xhr;
      this.setupLicenseXHR(xhr, url, keySessionContext, licenseChallenge).then(({
        xhr,
        licenseChallenge
      }) => {
        xhr.send(licenseChallenge);
      });
    });
  }
  onMediaAttached(event, data) {
    if (!this.config.emeEnabled) {
      return;
    }
    const media = data.media;

    // keep reference of media
    this.media = media;
    media.addEventListener('encrypted', this.onMediaEncrypted);
    media.addEventListener('waitingforkey', this.onWaitingForKey);
  }
  onMediaDetached() {
    const media = this.media;
    const mediaKeysList = this.mediaKeySessions;
    if (media) {
      media.removeEventListener('encrypted', this.onMediaEncrypted);
      media.removeEventListener('waitingforkey', this.onWaitingForKey);
      this.media = null;
    }
    this._requestLicenseFailureCount = 0;
    this.setMediaKeysQueue = [];
    this.mediaKeySessions = [];
    this.keyIdToKeySessionPromise = {};
    LevelKey.clearKeyUriToKeyIdMap();

    // Close all sessions and remove media keys from the video element.
    const keySessionCount = mediaKeysList.length;
    EMEController.CDMCleanupPromise = Promise.all(mediaKeysList.map(mediaKeySessionContext => this.removeSession(mediaKeySessionContext)).concat(media == null ? void 0 : media.setMediaKeys(null).catch(error => {
      this.log(`Could not clear media keys: ${error}. media.src: ${media == null ? void 0 : media.src}`);
    }))).then(() => {
      if (keySessionCount) {
        this.log('finished closing key sessions and clearing media keys');
        mediaKeysList.length = 0;
      }
    }).catch(error => {
      this.log(`Could not close sessions and clear media keys: ${error}. media.src: ${media == null ? void 0 : media.src}`);
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(event, {
    sessionKeys
  }) {
    if (!sessionKeys || !this.config.emeEnabled) {
      return;
    }
    if (!this.keyFormatPromise) {
      const keyFormats = sessionKeys.reduce((formats, sessionKey) => {
        if (formats.indexOf(sessionKey.keyFormat) === -1) {
          formats.push(sessionKey.keyFormat);
        }
        return formats;
      }, []);
      this.log(`Selecting key-system from session-keys ${keyFormats.join(', ')}`);
      this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
    }
  }
  removeSession(mediaKeySessionContext) {
    const {
      mediaKeysSession,
      licenseXhr
    } = mediaKeySessionContext;
    if (mediaKeysSession) {
      this.log(`Remove licenses and keys and close session ${mediaKeysSession.sessionId}`);
      mediaKeysSession.onmessage = null;
      mediaKeysSession.onkeystatuseschange = null;
      if (licenseXhr && licenseXhr.readyState !== XMLHttpRequest.DONE) {
        licenseXhr.abort();
      }
      mediaKeySessionContext.mediaKeysSession = mediaKeySessionContext.decryptdata = mediaKeySessionContext.licenseXhr = undefined;
      const index = this.mediaKeySessions.indexOf(mediaKeySessionContext);
      if (index > -1) {
        this.mediaKeySessions.splice(index, 1);
      }
      return mediaKeysSession.remove().catch(error => {
        this.log(`Could not remove session: ${error}`);
      }).then(() => {
        return mediaKeysSession.close();
      }).catch(error => {
        this.log(`Could not close session: ${error}`);
      });
    }
  }
}
EMEController.CDMCleanupPromise = void 0;
class EMEKeyError extends Error {
  constructor(data, message) {
    super(message);
    this.data = void 0;
    data.error || (data.error = new Error(message));
    this.data = data;
    data.err = data.error;
  }
}

/**
 * CMCD spec version
 */
const CMCDVersion = 1;

/**
 * CMCD Object Type
 */
var CMCDObjectType = {
  MANIFEST: "m",
  AUDIO: "a",
  VIDEO: "v",
  MUXED: "av",
  INIT: "i",
  CAPTION: "c",
  TIMED_TEXT: "tt",
  KEY: "k",
  OTHER: "o"
};

/**
 * CMCD Streaming Format
 */
const CMCDStreamingFormatHLS = 'h';

/**
 * CMCD Streaming Type
 */

/**
 * CMCD Headers
 */

/**
 * CMCD
 */

/**
 * Controller to deal with Common Media Client Data (CMCD)
 * @see https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf
 */
class CMCDController {
  // eslint-disable-line no-restricted-globals
  // eslint-disable-line no-restricted-globals

  constructor(hls) {
    this.hls = void 0;
    this.config = void 0;
    this.media = void 0;
    this.sid = void 0;
    this.cid = void 0;
    this.useHeaders = false;
    this.initialized = false;
    this.starved = false;
    this.buffering = true;
    this.audioBuffer = void 0;
    this.videoBuffer = void 0;
    this.onWaiting = () => {
      if (this.initialized) {
        this.starved = true;
      }
      this.buffering = true;
    };
    this.onPlaying = () => {
      if (!this.initialized) {
        this.initialized = true;
      }
      this.buffering = false;
    };
    /**
     * Apply CMCD data to a manifest request.
     */
    this.applyPlaylistData = context => {
      try {
        this.apply(context, {
          ot: CMCDObjectType.MANIFEST,
          su: !this.initialized
        });
      } catch (error) {
        logger.warn('Could not generate manifest CMCD data.', error);
      }
    };
    /**
     * Apply CMCD data to a segment request
     */
    this.applyFragmentData = context => {
      try {
        const fragment = context.frag;
        const level = this.hls.levels[fragment.level];
        const ot = this.getObjectType(fragment);
        const data = {
          d: fragment.duration * 1000,
          ot
        };
        if (ot === CMCDObjectType.VIDEO || ot === CMCDObjectType.AUDIO || ot == CMCDObjectType.MUXED) {
          data.br = level.bitrate / 1000;
          data.tb = this.getTopBandwidth(ot) / 1000;
          data.bl = this.getBufferLength(ot);
        }
        this.apply(context, data);
      } catch (error) {
        logger.warn('Could not generate segment CMCD data.', error);
      }
    };
    this.hls = hls;
    const config = this.config = hls.config;
    const {
      cmcd
    } = config;
    if (cmcd != null) {
      config.pLoader = this.createPlaylistLoader();
      config.fLoader = this.createFragmentLoader();
      this.sid = cmcd.sessionId || CMCDController.uuid();
      this.cid = cmcd.contentId;
      this.useHeaders = cmcd.useHeaders === true;
      this.registerListeners();
    }
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners();
    this.onMediaDetached();

    // @ts-ignore
    this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
  }
  onMediaAttached(event, data) {
    this.media = data.media;
    this.media.addEventListener('waiting', this.onWaiting);
    this.media.addEventListener('playing', this.onPlaying);
  }
  onMediaDetached() {
    if (!this.media) {
      return;
    }
    this.media.removeEventListener('waiting', this.onWaiting);
    this.media.removeEventListener('playing', this.onPlaying);

    // @ts-ignore
    this.media = null;
  }
  onBufferCreated(event, data) {
    var _data$tracks$audio, _data$tracks$video;
    this.audioBuffer = (_data$tracks$audio = data.tracks.audio) == null ? void 0 : _data$tracks$audio.buffer;
    this.videoBuffer = (_data$tracks$video = data.tracks.video) == null ? void 0 : _data$tracks$video.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var _this$media;
    return {
      v: CMCDVersion,
      sf: CMCDStreamingFormatHLS,
      sid: this.sid,
      cid: this.cid,
      pr: (_this$media = this.media) == null ? void 0 : _this$media.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1000
    };
  }

  /**
   * Apply CMCD data to a request.
   */
  apply(context, data = {}) {
    // apply baseline data
    _extends(data, this.createData());
    const isVideo = data.ot === CMCDObjectType.INIT || data.ot === CMCDObjectType.VIDEO || data.ot === CMCDObjectType.MUXED;
    if (this.starved && isVideo) {
      data.bs = true;
      data.su = true;
      this.starved = false;
    }
    if (data.su == null) {
      data.su = this.buffering;
    }

    // TODO: Implement rtp, nrr, nor, dl

    if (this.useHeaders) {
      const headers = CMCDController.toHeaders(data);
      if (!Object.keys(headers).length) {
        return;
      }
      if (!context.headers) {
        context.headers = {};
      }
      _extends(context.headers, headers);
    } else {
      const query = CMCDController.toQuery(data);
      if (!query) {
        return;
      }
      context.url = CMCDController.appendQueryToUri(context.url, query);
    }
  }
  /**
   * The CMCD object type.
   */
  getObjectType(fragment) {
    const {
      type
    } = fragment;
    if (type === 'subtitle') {
      return CMCDObjectType.TIMED_TEXT;
    }
    if (fragment.sn === 'initSegment') {
      return CMCDObjectType.INIT;
    }
    if (type === 'audio') {
      return CMCDObjectType.AUDIO;
    }
    if (type === 'main') {
      if (!this.hls.audioTracks.length) {
        return CMCDObjectType.MUXED;
      }
      return CMCDObjectType.VIDEO;
    }
    return undefined;
  }

  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(type) {
    let bitrate = 0;
    let levels;
    const hls = this.hls;
    if (type === CMCDObjectType.AUDIO) {
      levels = hls.audioTracks;
    } else {
      const max = hls.maxAutoLevel;
      const len = max > -1 ? max + 1 : hls.levels.length;
      levels = hls.levels.slice(0, len);
    }
    for (const level of levels) {
      if (level.bitrate > bitrate) {
        bitrate = level.bitrate;
      }
    }
    return bitrate > 0 ? bitrate : NaN;
  }

  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(type) {
    const media = this.hls.media;
    const buffer = type === CMCDObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
    if (!buffer || !media) {
      return NaN;
    }
    const info = BufferHelper.bufferInfo(buffer, media.currentTime, this.config.maxBufferHole);
    return info.len * 1000;
  }

  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader
    } = this.config;
    const apply = this.applyPlaylistData;
    const Ctor = pLoader || this.config.loader;
    return class CmcdPlaylistLoader {
      constructor(config) {
        this.loader = void 0;
        this.loader = new Ctor(config);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(context, config, callbacks) {
        apply(context);
        this.loader.load(context, config, callbacks);
      }
    };
  }

  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader
    } = this.config;
    const apply = this.applyFragmentData;
    const Ctor = fLoader || this.config.loader;
    return class CmcdFragmentLoader {
      constructor(config) {
        this.loader = void 0;
        this.loader = new Ctor(config);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(context, config, callbacks) {
        apply(context);
        this.loader.load(context, config, callbacks);
      }
    };
  }

  /**
   * Generate a random v4 UUI
   *
   * @returns {string}
   */
  static uuid() {
    const url = URL.createObjectURL(new Blob());
    const uuid = url.toString();
    URL.revokeObjectURL(url);
    return uuid.slice(uuid.lastIndexOf('/') + 1);
  }

  /**
   * Serialize a CMCD data object according to the rules defined in the
   * section 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static serialize(data) {
    const results = [];
    const isValid = value => !Number.isNaN(value) && value != null && value !== '' && value !== false;
    const toRounded = value => Math.round(value);
    const toHundred = value => toRounded(value / 100) * 100;
    const toUrlSafe = value => encodeURIComponent(value);
    const formatters = {
      br: toRounded,
      d: toRounded,
      bl: toHundred,
      dl: toHundred,
      mtp: toHundred,
      nor: toUrlSafe,
      rtp: toHundred,
      tb: toRounded
    };
    const keys = Object.keys(data || {}).sort();
    for (const key of keys) {
      let value = data[key];

      // ignore invalid values
      if (!isValid(value)) {
        continue;
      }

      // Version should only be reported if not equal to 1.
      if (key === 'v' && value === 1) {
        continue;
      }

      // Playback rate should only be sent if not equal to 1.
      if (key == 'pr' && value === 1) {
        continue;
      }

      // Certain values require special formatting
      const formatter = formatters[key];
      if (formatter) {
        value = formatter(value);
      }

      // Serialize the key/value pair
      const type = typeof value;
      let result;
      if (key === 'ot' || key === 'sf' || key === 'st') {
        result = `${key}=${value}`;
      } else if (type === 'boolean') {
        result = key;
      } else if (type === 'number') {
        result = `${key}=${value}`;
      } else {
        result = `${key}=${JSON.stringify(value)}`;
      }
      results.push(result);
    }
    return results.join(',');
  }

  /**
   * Convert a CMCD data object to request headers according to the rules
   * defined in the section 2.1 and 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static toHeaders(data) {
    const keys = Object.keys(data);
    const headers = {};
    const headerNames = ['Object', 'Request', 'Session', 'Status'];
    const headerGroups = [{}, {}, {}, {}];
    const headerMap = {
      br: 0,
      d: 0,
      ot: 0,
      tb: 0,
      bl: 1,
      dl: 1,
      mtp: 1,
      nor: 1,
      nrr: 1,
      su: 1,
      cid: 2,
      pr: 2,
      sf: 2,
      sid: 2,
      st: 2,
      v: 2,
      bs: 3,
      rtp: 3
    };
    for (const key of keys) {
      // Unmapped fields are mapped to the Request header
      const index = headerMap[key] != null ? headerMap[key] : 1;
      headerGroups[index][key] = data[key];
    }
    for (let i = 0; i < headerGroups.length; i++) {
      const value = CMCDController.serialize(headerGroups[i]);
      if (value) {
        headers[`CMCD-${headerNames[i]}`] = value;
      }
    }
    return headers;
  }

  /**
   * Convert a CMCD data object to query args according to the rules
   * defined in the section 2.2 and 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static toQuery(data) {
    return `CMCD=${encodeURIComponent(CMCDController.serialize(data))}`;
  }

  /**
   * Append query args to a uri.
   */
  static appendQueryToUri(uri, query) {
    if (!query) {
      return uri;
    }
    const separator = uri.includes('?') ? '&' : '?';
    return `${uri}${separator}${query}`;
  }
}

const PATHWAY_PENALTY_DURATION_MS = 300000;
class ContentSteeringController {
  constructor(hls) {
    this.hls = void 0;
    this.log = void 0;
    this.loader = null;
    this.uri = null;
    this.pathwayId = '.';
    this.pathwayPriority = null;
    this.timeToLoad = 300;
    this.reloadTimer = -1;
    this.updated = 0;
    this.started = false;
    this.enabled = true;
    this.levels = null;
    this.audioTracks = null;
    this.subtitleTracks = null;
    this.penalizedPathways = {};
    this.hls = hls;
    this.log = logger.log.bind(logger, `[content-steering]:`);
    this.registerListeners();
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    if (!hls) {
      return;
    }
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  startLoad() {
    this.started = true;
    self.clearTimeout(this.reloadTimer);
    if (this.enabled && this.uri) {
      if (this.updated) {
        const ttl = Math.max(this.timeToLoad * 1000 - (performance.now() - this.updated), 0);
        this.scheduleRefresh(this.uri, ttl);
      } else {
        this.loadSteeringManifest(this.uri);
      }
    }
  }
  stopLoad() {
    this.started = false;
    if (this.loader) {
      this.loader.destroy();
      this.loader = null;
    }
    self.clearTimeout(this.reloadTimer);
  }
  destroy() {
    this.unregisterListeners();
    this.stopLoad();
    // @ts-ignore
    this.hls = null;
    this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(levelToRemove) {
    const levels = this.levels;
    if (levels) {
      this.levels = levels.filter(level => level !== levelToRemove);
    }
  }
  onManifestLoading() {
    this.stopLoad();
    this.enabled = true;
    this.timeToLoad = 300;
    this.updated = 0;
    this.uri = null;
    this.pathwayId = '.';
    this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(event, data) {
    const {
      contentSteering
    } = data;
    if (contentSteering === null) {
      return;
    }
    this.pathwayId = contentSteering.pathwayId;
    this.uri = contentSteering.uri;
    if (this.started) {
      this.startLoad();
    }
  }
  onManifestParsed(event, data) {
    this.audioTracks = data.audioTracks;
    this.subtitleTracks = data.subtitleTracks;
  }
  onError(event, data) {
    const {
      errorAction
    } = data;
    if ((errorAction == null ? void 0 : errorAction.action) === NetworkErrorAction.SendAlternateToPenaltyBox && errorAction.flags === ErrorActionFlags.MoveAllAlternatesMatchingHost) {
      let pathwayPriority = this.pathwayPriority;
      const pathwayId = this.pathwayId;
      if (!this.penalizedPathways[pathwayId]) {
        this.penalizedPathways[pathwayId] = performance.now();
      }
      if (!pathwayPriority && this.levels) {
        // If PATHWAY-PRIORITY was not provided, list pathways for error handling
        pathwayPriority = this.levels.reduce((pathways, level) => {
          if (pathways.indexOf(level.pathwayId) === -1) {
            pathways.push(level.pathwayId);
          }
          return pathways;
        }, []);
      }
      if (pathwayPriority && pathwayPriority.length > 1) {
        this.updatePathwayPriority(pathwayPriority);
        errorAction.resolved = this.pathwayId !== pathwayId;
      }
    }
  }
  filterParsedLevels(levels) {
    // Filter levels to only include those that are in the initial pathway
    this.levels = levels;
    let pathwayLevels = this.getLevelsForPathway(this.pathwayId);
    if (pathwayLevels.length === 0) {
      const pathwayId = levels[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${pathwayId}"`);
      pathwayLevels = this.getLevelsForPathway(pathwayId);
      this.pathwayId = pathwayId;
    }
    if (pathwayLevels.length !== levels.length) {
      this.log(`Found ${pathwayLevels.length}/${levels.length} levels in Pathway "${this.pathwayId}"`);
      return pathwayLevels;
    }
    return levels;
  }
  getLevelsForPathway(pathwayId) {
    if (this.levels === null) {
      return [];
    }
    return this.levels.filter(level => pathwayId === level.pathwayId);
  }
  updatePathwayPriority(pathwayPriority) {
    this.pathwayPriority = pathwayPriority;
    let levels;

    // Evaluate if we should remove the pathway from the penalized list
    const penalizedPathways = this.penalizedPathways;
    const now = performance.now();
    Object.keys(penalizedPathways).forEach(pathwayId => {
      if (now - penalizedPathways[pathwayId] > PATHWAY_PENALTY_DURATION_MS) {
        delete penalizedPathways[pathwayId];
      }
    });
    for (let i = 0; i < pathwayPriority.length; i++) {
      const pathwayId = pathwayPriority[i];
      if (penalizedPathways[pathwayId]) {
        continue;
      }
      if (pathwayId === this.pathwayId) {
        return;
      }
      const selectedIndex = this.hls.nextLoadLevel;
      const selectedLevel = this.hls.levels[selectedIndex];
      levels = this.getLevelsForPathway(pathwayId);
      if (levels.length > 0) {
        this.log(`Setting Pathway to "${pathwayId}"`);
        this.pathwayId = pathwayId;
        this.hls.trigger(Events.LEVELS_UPDATED, {
          levels
        });
        // Set LevelController's level to trigger LEVEL_SWITCHING which loads playlist if needed
        const levelAfterChange = this.hls.levels[selectedIndex];
        if (selectedLevel && levelAfterChange && this.levels) {
          if (levelAfterChange.attrs['STABLE-VARIANT-ID'] !== selectedLevel.attrs['STABLE-VARIANT-ID'] && levelAfterChange.bitrate !== selectedLevel.bitrate) {
            this.log(`Unstable Pathways change from bitrate ${selectedLevel.bitrate} to ${levelAfterChange.bitrate}`);
          }
          this.hls.nextLoadLevel = selectedIndex;
        }
        break;
      }
    }
  }
  clonePathways(pathwayClones) {
    const levels = this.levels;
    if (!levels) {
      return;
    }
    const audioGroupCloneMap = {};
    const subtitleGroupCloneMap = {};
    pathwayClones.forEach(pathwayClone => {
      const {
        ID: cloneId,
        'BASE-ID': baseId,
        'URI-REPLACEMENT': uriReplacement
      } = pathwayClone;
      if (levels.some(level => level.pathwayId === cloneId)) {
        return;
      }
      const clonedVariants = this.getLevelsForPathway(baseId).map(baseLevel => {
        const levelParsed = _extends({}, baseLevel);
        levelParsed.details = undefined;
        levelParsed.url = performUriReplacement(baseLevel.uri, baseLevel.attrs['STABLE-VARIANT-ID'], 'PER-VARIANT-URIS', uriReplacement);
        const attributes = new AttrList(baseLevel.attrs);
        attributes['PATHWAY-ID'] = cloneId;
        const clonedAudioGroupId = attributes.AUDIO && `${attributes.AUDIO}_clone_${cloneId}`;
        const clonedSubtitleGroupId = attributes.SUBTITLES && `${attributes.SUBTITLES}_clone_${cloneId}`;
        if (clonedAudioGroupId) {
          audioGroupCloneMap[attributes.AUDIO] = clonedAudioGroupId;
          attributes.AUDIO = clonedAudioGroupId;
        }
        if (clonedSubtitleGroupId) {
          subtitleGroupCloneMap[attributes.SUBTITLES] = clonedSubtitleGroupId;
          attributes.SUBTITLES = clonedSubtitleGroupId;
        }
        levelParsed.attrs = attributes;
        const clonedLevel = new Level(levelParsed);
        addGroupId(clonedLevel, 'audio', clonedAudioGroupId);
        addGroupId(clonedLevel, 'text', clonedSubtitleGroupId);
        return clonedLevel;
      });
      levels.push(...clonedVariants);
      cloneRenditionGroups(this.audioTracks, audioGroupCloneMap, uriReplacement, cloneId);
      cloneRenditionGroups(this.subtitleTracks, subtitleGroupCloneMap, uriReplacement, cloneId);
    });
  }
  loadSteeringManifest(uri) {
    const config = this.hls.config;
    const Loader = config.loader;
    if (this.loader) {
      this.loader.destroy();
    }
    this.loader = new Loader(config);
    let url;
    try {
      url = new self.URL(uri);
    } catch (error) {
      this.enabled = false;
      this.log(`Failed to parse Steering Manifest URI: ${uri}`);
      return;
    }
    if (url.protocol !== 'data:') {
      const throughput = (this.hls.bandwidthEstimate || config.abrEwmaDefaultEstimate) | 0;
      url.searchParams.set('_HLS_pathway', this.pathwayId);
      url.searchParams.set('_HLS_throughput', '' + throughput);
    }
    const context = {
      responseType: 'json',
      url: url.href
    };
    const loadPolicy = config.steeringManifestLoadPolicy.default;
    const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
    const loaderConfig = {
      loadPolicy,
      timeout: loadPolicy.maxLoadTimeMs,
      maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
      retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
      maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
    };
    const callbacks = {
      onSuccess: (response, stats, context, networkDetails) => {
        this.log(`Loaded steering manifest: "${url}"`);
        const steeringData = response.data;
        if (steeringData.VERSION !== 1) {
          this.log(`Steering VERSION ${steeringData.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now();
        this.timeToLoad = steeringData.TTL;
        const {
          'RELOAD-URI': reloadUri,
          'PATHWAY-CLONES': pathwayClones,
          'PATHWAY-PRIORITY': pathwayPriority
        } = steeringData;
        if (reloadUri) {
          try {
            this.uri = new self.URL(reloadUri, url).href;
          } catch (error) {
            this.enabled = false;
            this.log(`Failed to parse Steering Manifest RELOAD-URI: ${reloadUri}`);
            return;
          }
        }
        this.scheduleRefresh(this.uri || context.url);
        if (pathwayClones) {
          this.clonePathways(pathwayClones);
        }
        if (pathwayPriority) {
          this.updatePathwayPriority(pathwayPriority);
        }
      },
      onError: (error, context, networkDetails, stats) => {
        this.log(`Error loading steering manifest: ${error.code} ${error.text} (${context.url})`);
        this.stopLoad();
        if (error.code === 410) {
          this.enabled = false;
          this.log(`Steering manifest ${context.url} no longer available`);
          return;
        }
        let ttl = this.timeToLoad * 1000;
        if (error.code === 429) {
          const loader = this.loader;
          if (typeof (loader == null ? void 0 : loader.getResponseHeader) === 'function') {
            const retryAfter = loader.getResponseHeader('Retry-After');
            if (retryAfter) {
              ttl = parseFloat(retryAfter) * 1000;
            }
          }
          this.log(`Steering manifest ${context.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || context.url, ttl);
      },
      onTimeout: (stats, context, networkDetails) => {
        this.log(`Timeout loading steering manifest (${context.url})`);
        this.scheduleRefresh(this.uri || context.url);
      }
    };
    this.log(`Requesting steering manifest: ${url}`);
    this.loader.load(context, loaderConfig, callbacks);
  }
  scheduleRefresh(uri, ttlMs = this.timeToLoad * 1000) {
    self.clearTimeout(this.reloadTimer);
    this.reloadTimer = self.setTimeout(() => {
      this.loadSteeringManifest(uri);
    }, ttlMs);
  }
}
function cloneRenditionGroups(tracks, groupCloneMap, uriReplacement, cloneId) {
  if (!tracks) {
    return;
  }
  Object.keys(groupCloneMap).forEach(audioGroupId => {
    const clonedTracks = tracks.filter(track => track.groupId === audioGroupId).map(track => {
      const clonedTrack = _extends({}, track);
      clonedTrack.details = undefined;
      clonedTrack.attrs = new AttrList(clonedTrack.attrs);
      clonedTrack.url = clonedTrack.attrs.URI = performUriReplacement(track.url, track.attrs['STABLE-RENDITION-ID'], 'PER-RENDITION-URIS', uriReplacement);
      clonedTrack.groupId = clonedTrack.attrs['GROUP-ID'] = groupCloneMap[audioGroupId];
      clonedTrack.attrs['PATHWAY-ID'] = cloneId;
      return clonedTrack;
    });
    tracks.push(...clonedTracks);
  });
}
function performUriReplacement(uri, stableId, perOptionKey, uriReplacement) {
  const {
    HOST: host,
    PARAMS: params,
    [perOptionKey]: perOptionUris
  } = uriReplacement;
  let perVariantUri;
  if (stableId) {
    perVariantUri = perOptionUris == null ? void 0 : perOptionUris[stableId];
    if (perVariantUri) {
      uri = perVariantUri;
    }
  }
  const url = new self.URL(uri);
  if (host && !perVariantUri) {
    url.host = host;
  }
  if (params) {
    Object.keys(params).sort().forEach(key => {
      if (key) {
        url.searchParams.set(key, params[key]);
      }
    });
  }
  return url.href;
}

const AGE_HEADER_LINE_REGEX = /^age:\s*[\d.]+\s*$/im;
class XhrLoader {
  constructor(config) {
    this.xhrSetup = void 0;
    this.requestTimeout = void 0;
    this.retryTimeout = void 0;
    this.retryDelay = void 0;
    this.config = null;
    this.callbacks = null;
    this.context = void 0;
    this.loader = null;
    this.stats = void 0;
    this.xhrSetup = config ? config.xhrSetup || null : null;
    this.stats = new LoadStats();
    this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null;
    this.abortInternal();
    this.loader = null;
    this.config = null;
  }
  abortInternal() {
    const loader = this.loader;
    self.clearTimeout(this.requestTimeout);
    self.clearTimeout(this.retryTimeout);
    if (loader) {
      loader.onreadystatechange = null;
      loader.onprogress = null;
      if (loader.readyState !== 4) {
        this.stats.aborted = true;
        loader.abort();
      }
    }
  }
  abort() {
    var _this$callbacks;
    this.abortInternal();
    if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) {
      this.callbacks.onAbort(this.stats, this.context, this.loader);
    }
  }
  load(context, config, callbacks) {
    if (this.stats.loading.start) {
      throw new Error('Loader can only be used once.');
    }
    this.stats.loading.start = self.performance.now();
    this.context = context;
    this.config = config;
    this.callbacks = callbacks;
    this.loadInternal();
  }
  loadInternal() {
    const {
      config,
      context
    } = this;
    if (!config) {
      return;
    }
    const xhr = this.loader = new self.XMLHttpRequest();
    const stats = this.stats;
    stats.loading.first = 0;
    stats.loaded = 0;
    stats.aborted = false;
    const xhrSetup = this.xhrSetup;
    if (xhrSetup) {
      Promise.resolve().then(() => {
        if (this.stats.aborted) return;
        return xhrSetup(xhr, context.url);
      }).catch(error => {
        xhr.open('GET', context.url, true);
        return xhrSetup(xhr, context.url);
      }).then(() => {
        if (this.stats.aborted) return;
        this.openAndSendXhr(xhr, context, config);
      }).catch(error => {
        // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
        this.callbacks.onError({
          code: xhr.status,
          text: error.message
        }, context, xhr, stats);
        return;
      });
    } else {
      this.openAndSendXhr(xhr, context, config);
    }
  }
  openAndSendXhr(xhr, context, config) {
    if (!xhr.readyState) {
      xhr.open('GET', context.url, true);
    }
    const headers = this.context.headers;
    const {
      maxTimeToFirstByteMs,
      maxLoadTimeMs
    } = config.loadPolicy;
    if (headers) {
      for (const header in headers) {
        xhr.setRequestHeader(header, headers[header]);
      }
    }
    if (context.rangeEnd) {
      xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
    }
    xhr.onreadystatechange = this.readystatechange.bind(this);
    xhr.onprogress = this.loadprogress.bind(this);
    xhr.responseType = context.responseType;
    // setup timeout before we perform request
    self.clearTimeout(this.requestTimeout);
    config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
    this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.timeout);
    xhr.send();
  }
  readystatechange() {
    const {
      context,
      loader: xhr,
      stats
    } = this;
    if (!context || !xhr) {
      return;
    }
    const readyState = xhr.readyState;
    const config = this.config;

    // don't proceed if xhr has been aborted
    if (stats.aborted) {
      return;
    }

    // >= HEADERS_RECEIVED
    if (readyState >= 2) {
      if (stats.loading.first === 0) {
        stats.loading.first = Math.max(self.performance.now(), stats.loading.start);
        // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
        if (config.timeout !== config.loadPolicy.maxLoadTimeMs) {
          self.clearTimeout(this.requestTimeout);
          config.timeout = config.loadPolicy.maxLoadTimeMs;
          this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.loadPolicy.maxLoadTimeMs - (stats.loading.first - stats.loading.start));
        }
      }
      if (readyState === 4) {
        self.clearTimeout(this.requestTimeout);
        xhr.onreadystatechange = null;
        xhr.onprogress = null;
        const status = xhr.status;
        // http status between 200 to 299 are all successful
        const useResponse = xhr.responseType !== 'text';
        if (status >= 200 && status < 300 && (useResponse && xhr.response || xhr.responseText !== null)) {
          stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
          const data = useResponse ? xhr.response : xhr.responseText;
          const len = xhr.responseType === 'arraybuffer' ? data.byteLength : data.length;
          stats.loaded = stats.total = len;
          stats.bwEstimate = stats.total * 8000 / (stats.loading.end - stats.loading.first);
          if (!this.callbacks) {
            return;
          }
          const onProgress = this.callbacks.onProgress;
          if (onProgress) {
            onProgress(stats, context, data, xhr);
          }
          if (!this.callbacks) {
            return;
          }
          const response = {
            url: xhr.responseURL,
            data: data,
            code: status
          };
          this.callbacks.onSuccess(response, stats, context, xhr);
        } else {
          const retryConfig = config.loadPolicy.errorRetry;
          const retryCount = stats.retry;
          // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
          if (shouldRetry(retryConfig, retryCount, false, status)) {
            this.retry(retryConfig);
          } else {
            logger.error(`${status} while loading ${context.url}`);
            this.callbacks.onError({
              code: status,
              text: xhr.statusText
            }, context, xhr, stats);
          }
        }
      }
    }
  }
  loadtimeout() {
    var _this$config;
    const retryConfig = (_this$config = this.config) == null ? void 0 : _this$config.loadPolicy.timeoutRetry;
    const retryCount = this.stats.retry;
    if (shouldRetry(retryConfig, retryCount, true)) {
      this.retry(retryConfig);
    } else {
      logger.warn(`timeout while loading ${this.context.url}`);
      const callbacks = this.callbacks;
      if (callbacks) {
        this.abortInternal();
        callbacks.onTimeout(this.stats, this.context, this.loader);
      }
    }
  }
  retry(retryConfig) {
    const {
      context,
      stats
    } = this;
    this.retryDelay = getRetryDelay(retryConfig, stats.retry);
    stats.retry++;
    logger.warn(`${status ? 'HTTP Status ' + status : 'Timeout'} while loading ${context.url}, retrying ${stats.retry}/${retryConfig.maxNumRetry} in ${this.retryDelay}ms`);
    // abort and reset internal state
    this.abortInternal();
    this.loader = null;
    // schedule retry
    self.clearTimeout(this.retryTimeout);
    this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(event) {
    const stats = this.stats;
    stats.loaded = event.loaded;
    if (event.lengthComputable) {
      stats.total = event.total;
    }
  }
  getCacheAge() {
    let result = null;
    if (this.loader && AGE_HEADER_LINE_REGEX.test(this.loader.getAllResponseHeaders())) {
      const ageHeader = this.loader.getResponseHeader('age');
      result = ageHeader ? parseFloat(ageHeader) : null;
    }
    return result;
  }
  getResponseHeader(name) {
    if (this.loader && new RegExp(`^${name}:\\s*[\\d.]+\\s*$`, 'im').test(this.loader.getAllResponseHeaders())) {
      return this.loader.getResponseHeader(name);
    }
    return null;
  }
}

function fetchSupported() {
  if (
  // @ts-ignore
  self.fetch && self.AbortController && self.ReadableStream && self.Request) {
    try {
      new self.ReadableStream({}); // eslint-disable-line no-new
      return true;
    } catch (e) {
      /* noop */
    }
  }
  return false;
}
const BYTERANGE = /(\d+)-(\d+)\/(\d+)/;
class FetchLoader {
  constructor(config /* HlsConfig */) {
    this.fetchSetup = void 0;
    this.requestTimeout = void 0;
    this.request = void 0;
    this.response = void 0;
    this.controller = void 0;
    this.context = void 0;
    this.config = null;
    this.callbacks = null;
    this.stats = void 0;
    this.loader = null;
    this.fetchSetup = config.fetchSetup || getRequest;
    this.controller = new self.AbortController();
    this.stats = new LoadStats();
  }
  destroy() {
    this.loader = this.callbacks = null;
    this.abortInternal();
  }
  abortInternal() {
    const response = this.response;
    if (!(response != null && response.ok)) {
      this.stats.aborted = true;
      this.controller.abort();
    }
  }
  abort() {
    var _this$callbacks;
    this.abortInternal();
    if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) {
      this.callbacks.onAbort(this.stats, this.context, this.response);
    }
  }
  load(context, config, callbacks) {
    const stats = this.stats;
    if (stats.loading.start) {
      throw new Error('Loader can only be used once.');
    }
    stats.loading.start = self.performance.now();
    const initParams = getRequestParameters(context, this.controller.signal);
    const onProgress = callbacks.onProgress;
    const isArrayBuffer = context.responseType === 'arraybuffer';
    const LENGTH = isArrayBuffer ? 'byteLength' : 'length';
    const {
      maxTimeToFirstByteMs,
      maxLoadTimeMs
    } = config.loadPolicy;
    this.context = context;
    this.config = config;
    this.callbacks = callbacks;
    this.request = this.fetchSetup(context, initParams);
    self.clearTimeout(this.requestTimeout);
    config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
    this.requestTimeout = self.setTimeout(() => {
      this.abortInternal();
      callbacks.onTimeout(stats, context, this.response);
    }, config.timeout);
    self.fetch(this.request).then(response => {
      this.response = this.loader = response;
      const first = Math.max(self.performance.now(), stats.loading.start);
      self.clearTimeout(this.requestTimeout);
      config.timeout = maxLoadTimeMs;
      this.requestTimeout = self.setTimeout(() => {
        this.abortInternal();
        callbacks.onTimeout(stats, context, this.response);
      }, maxLoadTimeMs - (first - stats.loading.start));
      if (!response.ok) {
        const {
          status,
          statusText
        } = response;
        throw new FetchError(statusText || 'fetch, bad network response', status, response);
      }
      stats.loading.first = first;
      stats.total = getContentLength(response.headers) || stats.total;
      if (onProgress && isFiniteNumber(config.highWaterMark)) {
        return this.loadProgressively(response, stats, context, config.highWaterMark, onProgress);
      }
      if (isArrayBuffer) {
        return response.arrayBuffer();
      }
      if (context.responseType === 'json') {
        return response.json();
      }
      return response.text();
    }).then(responseData => {
      const {
        response
      } = this;
      self.clearTimeout(this.requestTimeout);
      stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
      const total = responseData[LENGTH];
      if (total) {
        stats.loaded = stats.total = total;
      }
      const loaderResponse = {
        url: response.url,
        data: responseData,
        code: response.status
      };
      if (onProgress && !isFiniteNumber(config.highWaterMark)) {
        onProgress(stats, context, responseData, response);
      }
      callbacks.onSuccess(loaderResponse, stats, context, response);
    }).catch(error => {
      self.clearTimeout(this.requestTimeout);
      if (stats.aborted) {
        return;
      }
      // CORS errors result in an undefined code. Set it to 0 here to align with XHR's behavior
      // when destroying, 'error' itself can be undefined
      const code = !error ? 0 : error.code || 0;
      const text = !error ? null : error.message;
      callbacks.onError({
        code,
        text
      }, context, error ? error.details : null, stats);
    });
  }
  getCacheAge() {
    let result = null;
    if (this.response) {
      const ageHeader = this.response.headers.get('age');
      result = ageHeader ? parseFloat(ageHeader) : null;
    }
    return result;
  }
  getResponseHeader(name) {
    return this.response ? this.response.headers.get(name) : null;
  }
  loadProgressively(response, stats, context, highWaterMark = 0, onProgress) {
    const chunkCache = new ChunkCache();
    const reader = response.body.getReader();
    const pump = () => {
      return reader.read().then(data => {
        if (data.done) {
          if (chunkCache.dataLength) {
            onProgress(stats, context, chunkCache.flush(), response);
          }
          return Promise.resolve(new ArrayBuffer(0));
        }
        const chunk = data.value;
        const len = chunk.length;
        stats.loaded += len;
        if (len < highWaterMark || chunkCache.dataLength) {
          // The current chunk is too small to to be emitted or the cache already has data
          // Push it to the cache
          chunkCache.push(chunk);
          if (chunkCache.dataLength >= highWaterMark) {
            // flush in order to join the typed arrays
            onProgress(stats, context, chunkCache.flush(), response);
          }
        } else {
          // If there's nothing cached already, and the chache is large enough
          // just emit the progress event
          onProgress(stats, context, chunk, response);
        }
        return pump();
      }).catch(() => {
        /* aborted */
        return Promise.reject();
      });
    };
    return pump();
  }
}
function getRequestParameters(context, signal) {
  const initParams = {
    method: 'GET',
    mode: 'cors',
    credentials: 'same-origin',
    signal,
    headers: new self.Headers(_extends({}, context.headers))
  };
  if (context.rangeEnd) {
    initParams.headers.set('Range', 'bytes=' + context.rangeStart + '-' + String(context.rangeEnd - 1));
  }
  return initParams;
}
function getByteRangeLength(byteRangeHeader) {
  const result = BYTERANGE.exec(byteRangeHeader);
  if (result) {
    return parseInt(result[2]) - parseInt(result[1]) + 1;
  }
}
function getContentLength(headers) {
  const contentRange = headers.get('Content-Range');
  if (contentRange) {
    const byteRangeLength = getByteRangeLength(contentRange);
    if (isFiniteNumber(byteRangeLength)) {
      return byteRangeLength;
    }
  }
  const contentLength = headers.get('Content-Length');
  if (contentLength) {
    return parseInt(contentLength);
  }
}
function getRequest(context, initParams) {
  return new self.Request(context.url, initParams);
}
class FetchError extends Error {
  constructor(message, code, details) {
    super(message);
    this.code = void 0;
    this.details = void 0;
    this.code = code;
    this.details = details;
  }
}

const WHITESPACE_CHAR = /\s/;
const Cues = {
  newCue(track, startTime, endTime, captionScreen) {
    const result = [];
    let row;
    // the type data states this is VTTCue, but it can potentially be a TextTrackCue on old browsers
    let cue;
    let indenting;
    let indent;
    let text;
    const Cue = self.VTTCue || self.TextTrackCue;
    for (let r = 0; r < captionScreen.rows.length; r++) {
      row = captionScreen.rows[r];
      indenting = true;
      indent = 0;
      text = '';
      if (!row.isEmpty()) {
        var _track$cues;
        for (let c = 0; c < row.chars.length; c++) {
          if (WHITESPACE_CHAR.test(row.chars[c].uchar) && indenting) {
            indent++;
          } else {
            text += row.chars[c].uchar;
            indenting = false;
          }
        }
        // To be used for cleaning-up orphaned roll-up captions
        row.cueStartTime = startTime;

        // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
        if (startTime === endTime) {
          endTime += 0.0001;
        }
        if (indent >= 16) {
          indent--;
        } else {
          indent++;
        }
        const cueText = fixLineBreaks(text.trim());
        const id = generateCueId(startTime, endTime, cueText);

        // If this cue already exists in the track do not push it
        if (!(track != null && (_track$cues = track.cues) != null && _track$cues.getCueById(id))) {
          cue = new Cue(startTime, endTime, cueText);
          cue.id = id;
          cue.line = r + 1;
          cue.align = 'left';
          // Clamp the position between 10 and 80 percent (CEA-608 PAC indent code)
          // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
          // Firefox throws an exception and captions break with out of bounds 0-100 values
          cue.position = 10 + Math.min(80, Math.floor(indent * 8 / 32) * 10);
          result.push(cue);
        }
      }
    }
    if (track && result.length) {
      // Sort bottom cues in reverse order so that they render in line order when overlapping in Chrome
      result.sort((cueA, cueB) => {
        if (cueA.line === 'auto' || cueB.line === 'auto') {
          return 0;
        }
        if (cueA.line > 8 && cueB.line > 8) {
          return cueB.line - cueA.line;
        }
        return cueA.line - cueB.line;
      });
      result.forEach(cue => addCueToTrack(track, cue));
    }
    return result;
  }
};

/**
 * @deprecated use fragLoadPolicy.default
 */

/**
 * @deprecated use manifestLoadPolicy.default and playlistLoadPolicy.default
 */

const defaultLoadPolicy = {
  maxTimeToFirstByteMs: 8000,
  maxLoadTimeMs: 20000,
  timeoutRetry: null,
  errorRetry: null
};

/**
 * @ignore
 * If possible, keep hlsDefaultConfig shallow
 * It is cloned whenever a new Hls instance is created, by keeping the config
 * shallow the properties are cloned, and we don't end up manipulating the default
 */
const hlsDefaultConfig = _objectSpread2(_objectSpread2({
  autoStartLoad: true,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: undefined,
  // used by stream-controller
  debug: false,
  // used by logger
  capLevelOnFPSDrop: false,
  // used by fps-controller
  capLevelToPlayerSize: false,
  // used by cap-level-controller
  ignoreDevicePixelRatio: false,
  // used by cap-level-controller
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: Infinity,
  // used by buffer-controller
  maxBufferSize: 60 * 1000 * 1000,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller
  highBufferWatchdogPeriod: 2,
  // used by stream-controller
  nudgeOffset: 0.1,
  // used by stream-controller
  nudgeMaxRetry: 3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveMaxLatencyDurationCount: Infinity,
  // used by latency-controller
  liveSyncDuration: undefined,
  // used by latency-controller
  liveMaxLatencyDuration: undefined,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: false,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: true,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: true,
  // used by decrypter
  startLevel: undefined,
  // used by level-controller
  startFragPrefetch: false,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5000,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  loader: XhrLoader,
  // loader: FetchLoader,
  fLoader: undefined,
  // used by fragment-loader
  pLoader: undefined,
  // used by playlist-loader
  xhrSetup: undefined,
  // used by xhr-loader
  licenseXhrSetup: undefined,
  // used by eme-controller
  licenseResponseCallback: undefined,
  // used by eme-controller
  abrController: AbrController,
  bufferController: BufferController,
  capLevelController: CapLevelController,
  errorController: ErrorController,
  fpsController: FPSController,
  stretchShortVideoTrack: false,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: true,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: false,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: false,
  // used by eme-controller
  widevineLicenseUrl: undefined,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: requestMediaKeySystemAccess ,
  // used by eme-controller
  testBandwidth: true,
  progressive: false,
  lowLatencyMode: true,
  cmcd: undefined,
  enableDateRangeMetadataCues: true,
  enableEmsgMetadataCues: true,
  enableID3MetadataCues: true,
  certLoadPolicy: {
    default: defaultLoadPolicy
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 20000,
        backoff: 'linear'
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1000,
        maxRetryDelayMs: 20000,
        backoff: 'linear'
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: Infinity,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 120000,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    } 
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 10000,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1000,
  manifestLoadingMaxRetryTimeout: 64000,
  levelLoadingTimeOut: 10000,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1000,
  levelLoadingMaxRetryTimeout: 64000,
  fragLoadingTimeOut: 20000,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1000,
  fragLoadingMaxRetryTimeout: 64000
}, timelineConfig()), {}, {
  subtitleStreamController: SubtitleStreamController ,
  subtitleTrackController: SubtitleTrackController ,
  timelineController: TimelineController ,
  audioStreamController: AudioStreamController ,
  audioTrackController: AudioTrackController ,
  emeController: EMEController ,
  cmcdController: CMCDController ,
  contentSteeringController: ContentSteeringController 
});
function timelineConfig() {
  return {
    cueHandler: Cues,
    // used by timeline-controller
    enableWebVTT: true,
    // used by timeline-controller
    enableIMSC1: true,
    // used by timeline-controller
    enableCEA708Captions: true,
    // used by timeline-controller
    captionsTextTrack1Label: 'English',
    // used by timeline-controller
    captionsTextTrack1LanguageCode: 'en',
    // used by timeline-controller
    captionsTextTrack2Label: 'Spanish',
    // used by timeline-controller
    captionsTextTrack2LanguageCode: 'es',
    // used by timeline-controller
    captionsTextTrack3Label: 'Unknown CC',
    // used by timeline-controller
    captionsTextTrack3LanguageCode: '',
    // used by timeline-controller
    captionsTextTrack4Label: 'Unknown CC',
    // used by timeline-controller
    captionsTextTrack4LanguageCode: '',
    // used by timeline-controller
    renderTextTracksNatively: true
  };
}

/**
 * @ignore
 */
function mergeConfig(defaultConfig, userConfig) {
  if ((userConfig.liveSyncDurationCount || userConfig.liveMaxLatencyDurationCount) && (userConfig.liveSyncDuration || userConfig.liveMaxLatencyDuration)) {
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  }
  if (userConfig.liveMaxLatencyDurationCount !== undefined && (userConfig.liveSyncDurationCount === undefined || userConfig.liveMaxLatencyDurationCount <= userConfig.liveSyncDurationCount)) {
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  }
  if (userConfig.liveMaxLatencyDuration !== undefined && (userConfig.liveSyncDuration === undefined || userConfig.liveMaxLatencyDuration <= userConfig.liveSyncDuration)) {
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  }
  const defaultsCopy = deepCpy(defaultConfig);

  // Backwards compatibility with deprecated config values
  const deprecatedSettingTypes = ['manifest', 'level', 'frag'];
  const deprecatedSettings = ['TimeOut', 'MaxRetry', 'RetryDelay', 'MaxRetryTimeout'];
  deprecatedSettingTypes.forEach(type => {
    const policyName = `${type === 'level' ? 'playlist' : type}LoadPolicy`;
    const policyNotSet = userConfig[policyName] === undefined;
    const report = [];
    deprecatedSettings.forEach(setting => {
      const deprecatedSetting = `${type}Loading${setting}`;
      const value = userConfig[deprecatedSetting];
      if (value !== undefined && policyNotSet) {
        report.push(deprecatedSetting);
        const settings = defaultsCopy[policyName].default;
        userConfig[policyName] = {
          default: settings
        };
        switch (setting) {
          case 'TimeOut':
            settings.maxLoadTimeMs = value;
            settings.maxTimeToFirstByteMs = value;
            break;
          case 'MaxRetry':
            settings.errorRetry.maxNumRetry = value;
            settings.timeoutRetry.maxNumRetry = value;
            break;
          case 'RetryDelay':
            settings.errorRetry.retryDelayMs = value;
            settings.timeoutRetry.retryDelayMs = value;
            break;
          case 'MaxRetryTimeout':
            settings.errorRetry.maxRetryDelayMs = value;
            settings.timeoutRetry.maxRetryDelayMs = value;
            break;
        }
      }
    });
    if (report.length) {
      logger.warn(`hls.js config: "${report.join('", "')}" setting(s) are deprecated, use "${policyName}": ${JSON.stringify(userConfig[policyName])}`);
    }
  });
  return _objectSpread2(_objectSpread2({}, defaultsCopy), userConfig);
}
function deepCpy(obj) {
  if (obj && typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return obj.map(deepCpy);
    }
    return Object.keys(obj).reduce((result, key) => {
      result[key] = deepCpy(obj[key]);
      return result;
    }, {});
  }
  return obj;
}

/**
 * @ignore
 */
function enableStreamingMode(config) {
  const currentLoader = config.loader;
  if (currentLoader !== FetchLoader && currentLoader !== XhrLoader) {
    // If a developer has configured their own loader, respect that choice
    logger.log('[config]: Custom loader detected, cannot enable progressive streaming');
    config.progressive = false;
  } else {
    const canStreamProgressively = fetchSupported();
    if (canStreamProgressively) {
      config.loader = FetchLoader;
      config.progressive = true;
      config.enableSoftwareAES = true;
      logger.log('[config]: Progressive streaming enabled, using FetchLoader');
    }
  }
}

/**
 * The `Hls` class is the core of the HLS.js library used to instantiate player instances.
 * @public
 */
class Hls {
  /**
   * The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
   */

  /**
   * The configuration object provided on player instantiation.
   */

  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return "1.4.10";
  }

  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isSupported() {
    return isSupported();
  }
  static get Events() {
    return Events;
  }
  static get ErrorTypes() {
    return ErrorTypes;
  }
  static get ErrorDetails() {
    return ErrorDetails;
  }

  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    if (!Hls.defaultConfig) {
      return hlsDefaultConfig;
    }
    return Hls.defaultConfig;
  }

  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(defaultConfig) {
    Hls.defaultConfig = defaultConfig;
  }

  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(userConfig = {}) {
    this.config = void 0;
    this.userConfig = void 0;
    this.coreComponents = void 0;
    this.networkControllers = void 0;
    this._emitter = new EventEmitter();
    this._autoLevelCapping = void 0;
    this._maxHdcpLevel = null;
    this.abrController = void 0;
    this.bufferController = void 0;
    this.capLevelController = void 0;
    this.latencyController = void 0;
    this.levelController = void 0;
    this.streamController = void 0;
    this.audioTrackController = void 0;
    this.subtitleTrackController = void 0;
    this.emeController = void 0;
    this.cmcdController = void 0;
    this._media = null;
    this.url = null;
    enableLogs(userConfig.debug || false, 'Hls instance');
    const config = this.config = mergeConfig(Hls.DefaultConfig, userConfig);
    this.userConfig = userConfig;
    this._autoLevelCapping = -1;
    if (config.progressive) {
      enableStreamingMode(config);
    }

    // core controllers and network loaders
    const {
      abrController: ConfigAbrController,
      bufferController: ConfigBufferController,
      capLevelController: ConfigCapLevelController,
      errorController: ConfigErrorController,
      fpsController: ConfigFpsController
    } = config;
    const errorController = new ConfigErrorController(this);
    const abrController = this.abrController = new ConfigAbrController(this);
    const bufferController = this.bufferController = new ConfigBufferController(this);
    const capLevelController = this.capLevelController = new ConfigCapLevelController(this);
    const fpsController = new ConfigFpsController(this);
    const playListLoader = new PlaylistLoader(this);
    const id3TrackController = new ID3TrackController(this);
    const ConfigContentSteeringController = config.contentSteeringController;
    // ConentSteeringController is defined before LevelController to receive Multivariant Playlist events first
    const contentSteering = ConfigContentSteeringController ? new ConfigContentSteeringController(this) : null;
    const levelController = this.levelController = new LevelController(this, contentSteering);
    // FragmentTracker must be defined before StreamController because the order of event handling is important
    const fragmentTracker = new FragmentTracker(this);
    const keyLoader = new KeyLoader(this.config);
    const streamController = this.streamController = new StreamController(this, fragmentTracker, keyLoader);

    // Cap level controller uses streamController to flush the buffer
    capLevelController.setStreamController(streamController);
    // fpsController uses streamController to switch when frames are being dropped
    fpsController.setStreamController(streamController);
    const networkControllers = [playListLoader, levelController, streamController];
    if (contentSteering) {
      networkControllers.splice(1, 0, contentSteering);
    }
    this.networkControllers = networkControllers;
    const coreComponents = [abrController, bufferController, capLevelController, fpsController, id3TrackController, fragmentTracker];
    this.audioTrackController = this.createController(config.audioTrackController, networkControllers);
    const AudioStreamControllerClass = config.audioStreamController;
    if (AudioStreamControllerClass) {
      networkControllers.push(new AudioStreamControllerClass(this, fragmentTracker, keyLoader));
    }
    // subtitleTrackController must be defined before subtitleStreamController because the order of event handling is important
    this.subtitleTrackController = this.createController(config.subtitleTrackController, networkControllers);
    const SubtitleStreamControllerClass = config.subtitleStreamController;
    if (SubtitleStreamControllerClass) {
      networkControllers.push(new SubtitleStreamControllerClass(this, fragmentTracker, keyLoader));
    }
    this.createController(config.timelineController, coreComponents);
    keyLoader.emeController = this.emeController = this.createController(config.emeController, coreComponents);
    this.cmcdController = this.createController(config.cmcdController, coreComponents);
    this.latencyController = this.createController(LatencyController, coreComponents);
    this.coreComponents = coreComponents;

    // Error controller handles errors before and after all other controllers
    // This listener will be invoked after all other controllers error listeners
    networkControllers.push(errorController);
    const onErrorOut = errorController.onErrorOut;
    if (typeof onErrorOut === 'function') {
      this.on(Events.ERROR, onErrorOut, errorController);
    }
  }
  createController(ControllerClass, components) {
    if (ControllerClass) {
      const controllerInstance = new ControllerClass(this);
      if (components) {
        components.push(controllerInstance);
      }
      return controllerInstance;
    }
    return null;
  }

  // Delegate the EventEmitter through the public API of Hls.js
  on(event, listener, context = this) {
    this._emitter.on(event, listener, context);
  }
  once(event, listener, context = this) {
    this._emitter.once(event, listener, context);
  }
  removeAllListeners(event) {
    this._emitter.removeAllListeners(event);
  }
  off(event, listener, context = this, once) {
    this._emitter.off(event, listener, context, once);
  }
  listeners(event) {
    return this._emitter.listeners(event);
  }
  emit(event, name, eventObject) {
    return this._emitter.emit(event, name, eventObject);
  }
  trigger(event, eventObject) {
    if (this.config.debug) {
      return this.emit(event, event, eventObject);
    } else {
      try {
        return this.emit(event, event, eventObject);
      } catch (e) {
        logger.error('An internal error happened while handling event ' + event + '. Error message: "' + e.message + '". Here is a stacktrace:', e);
        this.trigger(Events.ERROR, {
          type: ErrorTypes.OTHER_ERROR,
          details: ErrorDetails.INTERNAL_EXCEPTION,
          fatal: false,
          event: event,
          error: e
        });
      }
    }
    return false;
  }
  listenerCount(event) {
    return this._emitter.listenerCount(event);
  }

  /**
   * Dispose of the instance
   */
  destroy() {
    logger.log('destroy');
    this.trigger(Events.DESTROYING, undefined);
    this.detachMedia();
    this.removeAllListeners();
    this._autoLevelCapping = -1;
    this.url = null;
    this.networkControllers.forEach(component => component.destroy());
    this.networkControllers.length = 0;
    this.coreComponents.forEach(component => component.destroy());
    this.coreComponents.length = 0;
    // Remove any references that could be held in config options or callbacks
    const config = this.config;
    config.xhrSetup = config.fetchSetup = undefined;
    // @ts-ignore
    this.userConfig = null;
  }

  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(media) {
    logger.log('attachMedia');
    this._media = media;
    this.trigger(Events.MEDIA_ATTACHING, {
      media: media
    });
  }

  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    logger.log('detachMedia');
    this.trigger(Events.MEDIA_DETACHING, undefined);
    this._media = null;
  }

  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(url) {
    this.stopLoad();
    const media = this.media;
    const loadedSource = this.url;
    const loadingSource = this.url = urlToolkitExports.buildAbsoluteURL(self.location.href, url, {
      alwaysNormalize: true
    });
    logger.log(`loadSource:${loadingSource}`);
    if (media && loadedSource && (loadedSource !== loadingSource || this.bufferController.hasSourceTypes())) {
      this.detachMedia();
      this.attachMedia(media);
    }
    // when attaching to a source URL, trigger a playlist load
    this.trigger(Events.MANIFEST_LOADING, {
      url: url
    });
  }

  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(startPosition = -1) {
    logger.log(`startLoad(${startPosition})`);
    this.networkControllers.forEach(controller => {
      controller.startLoad(startPosition);
    });
  }

  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    logger.log('stopLoad');
    this.networkControllers.forEach(controller => {
      controller.stopLoad();
    });
  }

  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    logger.log('swapAudioCodec');
    this.streamController.swapAudioCodec();
  }

  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    logger.log('recoverMediaError');
    const media = this._media;
    this.detachMedia();
    if (media) {
      this.attachMedia(media);
    }
  }
  removeLevel(levelIndex, urlId = 0) {
    this.levelController.removeLevel(levelIndex, urlId);
  }

  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, BANDWIDTH, SCORE, and RESOLUTION (height)
   */
  get levels() {
    const levels = this.levelController.levels;
    return levels ? levels : [];
  }

  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }

  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(newLevel) {
    logger.log(`set currentLevel:${newLevel}`);
    this.loadLevel = newLevel;
    this.abrController.clearTimer();
    this.streamController.immediateLevelSwitch();
  }

  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }

  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(newLevel) {
    logger.log(`set nextLevel:${newLevel}`);
    this.levelController.manualLevel = newLevel;
    this.streamController.nextLevelSwitch();
  }

  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }

  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(newLevel) {
    logger.log(`set loadLevel:${newLevel}`);
    this.levelController.manualLevel = newLevel;
  }

  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }

  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(level) {
    this.levelController.nextLoadLevel = level;
  }

  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }

  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(newLevel) {
    logger.log(`set firstLevel:${newLevel}`);
    this.levelController.firstLevel = newLevel;
  }

  /**
   * Return start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  get startLevel() {
    return this.levelController.startLevel;
  }

  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(newLevel) {
    logger.log(`set startLevel:${newLevel}`);
    // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
    if (newLevel !== -1) {
      newLevel = Math.max(newLevel, this.minAutoLevel);
    }
    this.levelController.startLevel = newLevel;
  }

  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }

  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(shouldStartCapping) {
    const newCapLevelToPlayerSize = !!shouldStartCapping;
    if (newCapLevelToPlayerSize !== this.config.capLevelToPlayerSize) {
      if (newCapLevelToPlayerSize) {
        this.capLevelController.startCapping(); // If capping occurs, nextLevelSwitch will happen based on size.
      } else {
        this.capLevelController.stopCapping();
        this.autoLevelCapping = -1;
        this.streamController.nextLevelSwitch(); // Now we're uncapped, get the next level asap.
      }

      this.config.capLevelToPlayerSize = newCapLevelToPlayerSize;
    }
  }

  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }

  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator
    } = this.abrController;
    if (!bwEstimator) {
      return NaN;
    }
    return bwEstimator.getEstimate();
  }

  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator
    } = this.abrController;
    if (!bwEstimator) {
      return NaN;
    }
    return bwEstimator.getEstimateTTFB();
  }

  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(newLevel) {
    if (this._autoLevelCapping !== newLevel) {
      logger.log(`set autoLevelCapping:${newLevel}`);
      this._autoLevelCapping = newLevel;
    }
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(value) {
    if (HdcpLevels.indexOf(value) > -1) {
      this._maxHdcpLevel = value;
    }
  }

  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }

  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }

  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels,
      config: {
        minAutoBitrate
      }
    } = this;
    if (!levels) return 0;
    const len = levels.length;
    for (let i = 0; i < len; i++) {
      if (levels[i].maxBitrate >= minAutoBitrate) {
        return i;
      }
    }
    return 0;
  }

  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels,
      autoLevelCapping,
      maxHdcpLevel
    } = this;
    let maxAutoLevel;
    if (autoLevelCapping === -1 && levels && levels.length) {
      maxAutoLevel = levels.length - 1;
    } else {
      maxAutoLevel = autoLevelCapping;
    }
    if (maxHdcpLevel) {
      for (let i = maxAutoLevel; i--;) {
        const hdcpLevel = levels[i].attrs['HDCP-LEVEL'];
        if (hdcpLevel && hdcpLevel <= maxHdcpLevel) {
          return i;
        }
      }
    }
    return maxAutoLevel;
  }

  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    // ensure next auto level is between  min and max auto level
    return Math.min(Math.max(this.abrController.nextAutoLevel, this.minAutoLevel), this.maxAutoLevel);
  }

  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(nextLevel) {
    this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, nextLevel);
  }

  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }

  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const audioTrackController = this.audioTrackController;
    return audioTrackController ? audioTrackController.audioTracks : [];
  }

  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const audioTrackController = this.audioTrackController;
    return audioTrackController ? audioTrackController.audioTrack : -1;
  }

  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(audioTrackId) {
    const audioTrackController = this.audioTrackController;
    if (audioTrackController) {
      audioTrackController.audioTrack = audioTrackId;
    }
  }

  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
  }

  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }

  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(subtitleTrackId) {
    const subtitleTrackController = this.subtitleTrackController;
    if (subtitleTrackController) {
      subtitleTrackController.subtitleTrack = subtitleTrackId;
    }
  }

  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
  }

  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(value) {
    const subtitleTrackController = this.subtitleTrackController;
    if (subtitleTrackController) {
      subtitleTrackController.subtitleDisplay = value;
    }
  }

  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }

  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(mode) {
    this.config.lowLatencyMode = mode;
  }

  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }

  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }

  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }

  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }

  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }

  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
}
Hls.defaultConfig = void 0;


//# sourceMappingURL=hls.mjs.map

;// CONCATENATED MODULE: ./src/utils/videoPlayer.js
const calculateVideoHeightWidth = videoPlayerContainer => {
  const videoHeight = videoPlayerContainer?.getBoundingClientRect().height || 0;
  const maxContainerWidth = videoPlayerContainer?.getBoundingClientRect().width;
  const maxContainerHeight = videoPlayerContainer?.getBoundingClientRect().height;
  const video = videoPlayerContainer?.querySelector('video');
  if (!video) {
    return {
      width: 0,
      height: 0
    };
  }
  video.removeAttribute('style');
  if (maxContainerWidth / maxContainerHeight > 1) {
    video.removeAttribute('width');
    let videoHeightToSet = videoHeight;
    if (video.videoHeight && video.videoWidth) {
      const aspectRatio = video.videoWidth / video.videoHeight;
      const heightToAspectRatio = maxContainerWidth / aspectRatio;
      videoHeightToSet = heightToAspectRatio < videoHeight ? heightToAspectRatio : videoHeight;
    }
    video.height = videoHeightToSet;
    video.style.maxWidth = `${maxContainerWidth}px`;
  } else {
    video.removeAttribute('height');
    video.width = maxContainerWidth;
    video.style.maxHeight = `${maxContainerHeight}px`;
  }
  return {
    width: video.getBoundingClientRect()?.width,
    height: video.getBoundingClientRect()?.height
  };
};
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/HlsVideoPlayer.vue?vue&type=script&lang=js



/* harmony default export */ var HlsVideoPlayervue_type_script_lang_js = ({
  props: {
    progressBarConfig: {
      type: Object,
      default: () => {
        return {
          totalVideoDuration: 0,
          currentVideoDuration: 0,
          showProgressBar: false
        };
      }
    },
    videoSrc: {
      type: String,
      default: ''
    },
    muted: {
      type: Boolean,
      default: false
    },
    borderRadius: {
      type: String,
      default: '0px'
    },
    maintainHeight: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    },
    activeAudioOutputDeviceID: {
      type: String
    },
    emitFragChangedEvents: {
      type: Boolean,
      default: false
    },
    startPosition: {
      type: Number,
      // If -1 the playback will start from the live edge
      // rather than the custom start point.
      // Otherwise set it to the time from start in seconds.
      default: -1
    },
    minimized: {
      type: Boolean,
      default: false
    },
    renderCaptionsTrackNatively: {
      type: Boolean,
      default: false
    },
    captionsAndSubtitlesEnabled: {
      type: Boolean,
      default: false
    },
    selectedCaptionLanguageID: {
      type: Number,
      default: -1
    }
  },
  data() {
    const retryDelayForLoadingErrors = 8000;
    return {
      isVideoHovered: false,
      progressBarWidth: 0,
      overrideStartPosition: false,
      overrideStartPostionTo: -1,
      autoplayError: false,
      showPlayButton: false,
      videoPlayer: null,
      track: null,
      currentCaptionsTrackID: null,
      availableBitrates: [],
      currentLevel: -1,
      retryDelayForLoadingErrors: retryDelayForLoadingErrors,
      bufferingAndPlaybackStalled: false,
      bufferingLoaderTimeout: null,
      minBufferWaitDurationBeforeShowingLoading: 2000,
      fragmentsThatFailedLoading: [],
      currentFragStartPos: 0,
      hlsPlayerConfig: {
        autoStartLoad: this.startPosition < 0,
        startPositon: this.startPosition,
        liveSyncDurationCount: 3,
        liveMaxLatencyDurationCount: 9,
        initialLiveManifestSize: 1,
        backBufferLength: this.loop ? Infinity : 0,
        liveDurationInfinity: false,
        startFragPrefetch: true,
        manifestLoadingMaxRetry: 6,
        manifestLoadingMaxRetryTimeout: 64000,
        // Max delay for retying fetching the manifest
        manifestLoadingRetryDelay: retryDelayForLoadingErrors,
        levelLoadingRetryDelay: retryDelayForLoadingErrors,
        levelLoadingMaxRetryTimeout: 64000,
        fragLoadingMaxRetryTimeout: 1000,
        subtitleDisplay: true,
        renderTextTracksNatively: this.renderCaptionsTrackNatively,
        maxMaxBufferLength: 30,
        abrBandWidthUpFactor: 0.6
      },
      videoSourceRetryLoaderTimeout: null,
      playingInIOS: false,
      nativePlaybackTextTracks: [],
      levelEmptyErrorHandlerTimeout: null
    };
  },
  computed: {
    width() {
      return `width: ${this.progressBarWidth}px;`;
    },
    bitRateSelectOptions() {
      const bitRates = this.availableBitrates.map((bitRate, index) => {
        let qualityString = 'High';
        if (bitRate.height === 360) {
          qualityString = 'Low';
        } else if (bitRate.height === 720) {
          qualityString = 'Medium';
        }
        return {
          value: index,
          label: `${qualityString} ${bitRate.height}`
        };
      }) || [];
      return bitRates;
    },
    currentSelectedBitRate() {
      if (this.hls && this.bitRateSelectOptions) {
        const selectedBitRate = this.bitRateSelectOptions.find(bitrate => {
          return bitrate.value === this.currentLevel;
        });
        return selectedBitRate;
      }
      return null;
    }
  },
  mounted() {
    window.addEventListener('resize', () => this.calculateProgressbarWidth());
    this.playingInIOS = false;
    if (Hls.isSupported() && this.videoSrc) {
      this.hls = new Hls(this.hlsPlayerConfig);
      this.playVideoStream();
    } else {
      this.playNonHLS();
    }
  },
  updated() {
    let containerHeight = this.$refs.hlsVideoRoot?.getBoundingClientRect()?.height;
    let videoHeight = this.$refs.hlsPlayer?.getBoundingClientRect()?.height;
    if (containerHeight != videoHeight || this.progressBarWidth == 0) {
      this.calculateProgressbarWidth();
    }
  },
  watch: {
    videoSrc(newLink, oldLink) {
      if (newLink !== oldLink && this.hls) {
        // this "&& this.hls" can cause a issue where the video does not reload properly
        // when changing sessions, not changing it now because no one complains about it

        this.playingInIOS = false;
        if (Hls.isSupported() && this.videoSrc) {
          this.hls.destroy();
          setTimeout(() => {
            this.hls = new Hls(this.hlsPlayerConfig);
            this.playVideoStream();
          }, 2000); // Waiting some time before restarting the playback.
        } else {
          this.playNonHLS();
        }
      }
    },
    muted() {
      if (!this.muted && this.autoplayError) {
        this.playStream();
        this.autoplayError = false;
      }
    },
    activeAudioOutputDeviceID: {
      handler: function (newAudioOutDeviceSyncID, oldAudioOutDeviceSyncID) {
        if (newAudioOutDeviceSyncID !== oldAudioOutDeviceSyncID) {
          this.$nextTick(() => {
            this.setAudioOutputDevice();
          });
        }
      },
      immediate: true
    },
    captionsAndSubtitlesEnabled: {
      handler: function (wasCaptionsAndSubsEnabled, areCaptionsAndSubsEnabled) {
        if (wasCaptionsAndSubsEnabled !== areCaptionsAndSubsEnabled) {
          this.setSubtitleTrackByID();
          this.setSubtitleTrackEnabledState();
        }
      },
      immediate: true
    },
    selectedCaptionLanguageID: {
      handler: function (oldselectedCaptionLanguageID, newselectedCaptionLanguageID) {
        if (oldselectedCaptionLanguageID !== newselectedCaptionLanguageID) {
          this.setSubtitleTrackByID();
        }
      },
      immediate: true
    },
    renderCaptionsTrackNatively: {
      handler: function (renderCaptionsTrackNativelyOldValue, renderCaptionsTrackNativelyNewValue) {
        if (renderCaptionsTrackNativelyOldValue !== renderCaptionsTrackNativelyNewValue) {
          this.setSubtitleTrackByID();
        }
      },
      immediate: true
    }
  },
  methods: {
    hovered() {
      this.isVideoHovered = true;
      this.$emit('videoPlayerHoverStateChange', true);
    },
    hoverout() {
      this.isVideoHovered = false;
      this.$emit('videoPlayerHoverStateChange', false);
    },
    calculateProgressbarWidth() {
      const hlsVideoRoot = this.$refs.hlsVideoRoot;
      const hlsProgressBarParent = this.$refs.hlsProgressBarParent;
      const videoHeightWidth = calculateVideoHeightWidth(hlsVideoRoot);
      this.progressBarWidth = videoHeightWidth.width;
      if (videoHeightWidth.height) {
        hlsProgressBarParent.style.maxHeight = `${videoHeightWidth.height}px`;
      }
    },
    setAudioOutputDevice() {
      if (this.activeAudioOutputDeviceID) {
        this.videoPlayer.setSinkId(this.activeAudioOutputDeviceID).then(() => {}).catch(function (error) {
          var errorMessage = error;
          if (error.name === 'SecurityError') {
            errorMessage = 'You need to use HTTPS for selecting audio output ' + 'device: ' + error;
          }
          console.error(errorMessage);
        });
      }
    },
    handleFatalFragLoadingError(errorDetails) {
      if (errorDetails?.fatal) {
        console.error('A frag failed loading even 6 after retries!', 'Frag url:', errorDetails?.frag?.relurl);
        this.fragmentsThatFailedLoading.push(errorDetails.frag);
        if (this.currentFragStartPos === errorDetails.frag.start) {
          this.nudgePlaybackForwardToNextFrag(errorDetails.frag);
        }
      }
    },
    handleManifestLoadError() {
      this.$emit('stream-loading-error');
      this.clearVideoSourceTimeout();
      this.videoSourceRetryLoaderTimeout = setTimeout(() => {
        this.hls.loadSource(this.videoSrc);
      }, this.retryDelayForLoadingErrors);
    },
    handleNetworkErrors(errorDetails) {
      console.warn('Fatal network error encountered, trying to recover!');
      if (errorDetails?.details === Hls.ErrorDetails.LEVEL_LOAD_ERROR || errorDetails?.details === Hls.ErrorDetails.LEVEL_EMPTY_ERROR) {
        this.hls.startLoad();
      } else if (errorDetails?.details === Hls.ErrorDetails.MANIFEST_LOAD_ERROR) {
        this.handleManifestLoadError();
      } else if (errorDetails?.details === Hls.ErrorDetails.FRAG_LOAD_ERROR) {
        this.handleFatalFragLoadingError(errorDetails);
      }
    },
    tryRestartingBufferLoad() {
      console.warn('New buffer addition might have stopped because of frag load error!', 'Checking and trying to recover');
      const fragThatStalledPlayback = (this.fragmentsThatFailedLoading || []).find(frag => {
        return frag?.start == this.currentFragStartPos;
      });
      if (fragThatStalledPlayback) {
        this.nudgePlaybackForwardToNextFrag(fragThatStalledPlayback);
      }
    },
    nudgePlaybackForwardToNextFrag(frag) {
      try {
        if (parseFloat(frag?.start) > -1 && parseFloat(frag?.duration) > -1) {
          this.hls.destroy();
          setTimeout(() => {
            this.hlsPlayerConfig.autoStartLoad = false;
            this.overrideStartPostionTo = parseFloat(frag?.start) + parseFloat(frag?.duration) + 0.1;
            this.hlsPlayerConfig.startPositon = this.overrideStartPostionTo;
            this.overrideStartPosition = true;
            this.hls = new Hls(this.hlsPlayerConfig);
            this.playVideoStream();
          }, 2000);
        }
      } catch (err) {
        console.error('Error while nudging the plaback forward by one chunk duration!', err);
      }
    },
    handleMediaErrors(errorDetails) {
      if (errorDetails?.details === Hls.ErrorDetails.BUFFER_STALLED_ERROR) {
        this.tryRestartingBufferLoad();
      } else {
        console.warn('Fatal media error encountered, trying to recover!');
        this.hls.recoverMediaError();
      }
    },
    handleLevelEmptyError() {
      if (this.levelEmptyErrorHandlerTimeout) {
        clearTimeout(this.levelEmptyErrorHandlerTimeout);
        this.levelEmptyErrorHandlerTimeout = null;
      }
      this.levelEmptyErrorHandlerTimeout = setTimeout(() => {
        clearTimeout(this.levelEmptyErrorHandlerTimeout);
        this.levelEmptyErrorHandlerTimeout = null;
        this.hls.startLoad();
      }, this.retryDelayForLoadingErrors);
    },
    handleNonFatalErrors(errorDetails) {
      if (errorDetails?.details === Hls.ErrorDetails.LEVEL_EMPTY_ERROR) {
        console.warn('Got a level empty error!', errorDetails);
        this.handleLevelEmptyError();
      }
    },
    handleHlsErrors(event, errorDetails) {
      const errormessage = `
          Hls player encountered an error!,
          IS fatal: ${errorDetails?.fatal},
          Error details:
        `;
      console.warn(errormessage, event, errorDetails);
      if (errorDetails?.fatal) {
        if (errorDetails.type === Hls.ErrorTypes.NETWORK_ERROR) {
          this.handleNetworkErrors(errorDetails);
        } else if (errorDetails.type === Hls.ErrorTypes.MEDIA_ERROR) {
          this.handleMediaErrors(errorDetails);
        } else {
          console.error("Couldn't recover from hls error! Destroying the component.");
          this.hls.destroy();
        }
      } else {
        console.warn('Hls player encounted a non-fatal error!', event, errorDetails);
        this.handleNonFatalErrors(errorDetails);
      }
    },
    playNonHLS() {
      this.videoPlayer = this.$refs.hlsPlayer;
      this.handleListeners();
      if (this.videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
        this.playingInIOS = true;
        this.nativePlaybackTextTracks = [];
        this.videoPlayer.setAttribute('playsinline', '');
        this.videoPlayer.src = this.videoSrc;
        this.videoPlayer.addEventListener('loadedmetadata', () => {
          this.$emit('stream-playback-started');
          this.playStream();
        });
        this.videoPlayer.addEventListener('error', () => {
          setTimeout(() => this.$emit('remountHLS'), 6000);
        }, true);
        // Commenting it out for now, because ios handling of captions track
        // for live playlist is still buggy, we will only show mattermost
        // captions for now for ios untill we find a fix for the issue.
        // if (this.videoPlayer.textTracks) {
        //   this.videoPlayer.textTracks.addEventListener("addtrack", () => {
        //     this.parseAndEmitNativeCaptionsLanguages(
        //       this.videoPlayer.textTracks || []
        //     );
        //   });

        //   this.videoPlayer.textTracks.addEventListener("removetrack", () => {
        //     this.parseAndEmitNativeCaptionsLanguages(
        //       this.videoPlayer.textTracks || []
        //     );
        //   });
        // }
        this.handleVideoStreamEnd();
      }
    },
    handleListeners() {
      this.videoPlayer = this.$refs.hlsPlayer;
      this.setAudioOutputDevice();
      this.videoPlayer.onwaiting = () => {
        if (this.bufferingLoaderTimeout) {
          clearTimeout(this.bufferingLoaderTimeout);
        }

        // If the player is waiting wait for some time before
        // showing the loader.
        this.bufferingLoaderTimeout = setTimeout(() => {
          this.bufferingLoaderTimeout = null;
          this.bufferingAndPlaybackStalled = true;
          this.$emit('bufferingAndPlaybackStalled', true);
        }, this.minBufferWaitDurationBeforeShowingLoading);
      };
      this.videoPlayer.oncanplay = () => {
        this.calculateProgressbarWidth();
        this.bufferingAndPlaybackStalled = false;
        this.$emit('bufferingAndPlaybackStalled', false);
        if (this.bufferingLoaderTimeout) {
          clearTimeout(this.bufferingLoaderTimeout);
          this.bufferingLoaderTimeout = null;
        }
      };
      this.videoPlayer.onplay = () => {
        this.$emit('onplay', true);
      };
      this.handleVideoStreamEnd();
    },
    playVideoStream() {
      this.$emit('hls-embedded-text-tracks', []);
      this.videoPlayer = this.$refs.hlsPlayer;
      this.handleListeners();
      this.hls.attachMedia(this.videoPlayer);
      this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
        this.hls.loadSource(this.videoSrc);
      });
      this.hls.on(Hls.Events.MANIFEST_PARSED, (e, details) => {
        if (this.startPosition >= 0 && !this.overrideStartPosition) {
          this.hls.startLoad(this.startPosition);
        } else if (this.overrideStartPosition && this.overrideStartPostionTo > -1) {
          this.hls.startLoad(this.overrideStartPostionTo);
          this.overrideStartPostionTo = -1;
          this.overrideStartPosition = false;
        }
        this.playStream();
        this.availableBitrates = this.hls.levels;
        const embeddedTextTracks = details?.subtitleTracks || [];
        this.$emit('hls-embedded-text-tracks', embeddedTextTracks);
        // eslint-disable-next-line
        console.info('Embedded caption tracks from hls.js:', embeddedTextTracks);
        this.embeddedTextTracks = embeddedTextTracks;
        this.setSubtitleTrackEnabledState();
        this.setSubtitleTrackByID();
      });
      this.hls.on(Hls.Events.FRAG_PARSED, () => {
        this.$emit('stream-playback-started');
      });
      this.hls.on(Hls.Events.ERROR, this.handleHlsErrors);
      this.hls.on(Hls.Events.LEVEL_SWITCHED, () => {
        this.currentLevel = this.hls.currentLevel;
      });
      this.hls.on(Hls.Events.FRAG_CHANGED, (e, data) => {
        this.currentFragStartPos = data?.frag?.start;
        if (this.emitFragChangedEvents) {
          this.$emit('startofnextfragment', this.currentFragStartPos);
        }
      });
      this.hls.on(Hls.Events.NON_NATIVE_TEXT_TRACKS_FOUND, (e, data) => {
        try {
          if (!data?.tracks || !data?.tracks[0] || !data?.tracks[0]['_id'] || this.track) {
            return;
          }
          this.currentCaptionsTrackID = data?.tracks[0]['_id'];
          this.track = this.videoPlayer.addTextTrack('captions', 'English', 'en');
          this.track.mode = 'showing';
        } catch (err) {
          console.error('Error while parsing new captions!', err, data);
        }
      });
      this.hls.on(Hls.Events.CUES_PARSED, (e, data) => {
        try {
          if (!data?.cues?.length || this.currentCaptionsTrackID !== data?.track || !this.track) {
            return;
          }
          for (let i = 0; i < data.cues.length; i++) {
            const cue = data.cues[i];
            this.track.addCue(cue);
          }
        } catch (err) {
          console.error('Error parsing captions cues!', err, data);
        }
      });
      this.hls.on(Hls.Events.LEVEL_LOADED, (e, data) => {
        this.$emit('hls-level-loaded', data?.details?.url);
      });
    },
    playStream() {
      this.showPlayButton = false;
      this.videoPlayer.play().catch(() => {
        this.showPlayButton = true;
        try {
          this.autoplayError = true;
          this.$emit('play-aborted');
        } catch (e) {
          console.error('Error resuming the HLS Video', e);
        }
      });
    },
    selectBitrate(selectedBitRate) {
      if (selectedBitRate) {
        this.hls.currentLevel = selectedBitRate.value;
      }
    },
    clearVideoSourceTimeout() {
      if (this.videoSourceRetryLoaderTimeout) {
        clearTimeout(this.videoSourceRetryLoaderTimeout);
        this.videoSourceRetryLoaderTimeout = null;
      }
    },
    handleVideoStreamEnd() {
      this.videoPlayer.addEventListener('ended', () => {
        this.$emit('video-playback-ended');
      });
    },
    setSubtitleTrackEnabledState() {
      if (!this.hls) {
        return;
      }
      this.hls.subtitleDisplay = this.captionsAndSubtitlesEnabled;
    },
    setSubtitleTrackByID() {
      // if the embedded captions are disabled, do not show native embedded captions.
      const captionLanguageId = this.renderCaptionsTrackNatively ? this.selectedCaptionLanguageID : -1;
      // eslint-disable-next-line
      console.info('To render caption tracks natively:', this.renderCaptionsTrackNatively);
      // eslint-disable-next-line
      console.info('Setting subtitle tracks by ID', captionLanguageId);
      // eslint-disable-next-line
      console.info('Playing in ios:', this.playingInIOS);
      if (this.playingInIOS) {
        // // commenting native captions handling logic for ios,
        // // ios captions support for out embedded playlist is still buggy
        // // so we are falling back to mattermost captions for the time being
        // // till we find a solution.
        // for (
        //   let index = 0;
        //   index < this.nativePlaybackTextTracks.length;
        //   index++
        // ) {
        //   const textTrack = this.nativePlaybackTextTracks[index];
        //   textTrack.textTrack.mode =
        //     textTrack.id === captionLanguageId ? "showing" : "hidden";
        // }
        // eslint-disable-next-line
        console.info('Bailing from setting subtitle track id cause playback is in ios!');
        return;
      }
      if (!this.hls) {
        // eslint-disable-next-line
        console.info('Bailing from setting subtitle track id cause hls is not initialized yet!');
        return;
      }
      // eslint-disable-next-line
      console.info('Setting the caption id as:', captionLanguageId);
      this.hls.subtitleTrack = captionLanguageId;
    },
    parseAndEmitNativeCaptionsLanguages(textTracks) {
      const embeddedTextTracks = Array.prototype.map.call(textTracks, (textTrack, index) => {
        textTrack.mode = 'hidden';
        return {
          name: textTrack['label'],
          id: index,
          lang: textTrack['language'],
          value: textTrack['language'],
          textTrack: textTrack
        };
      });
      this.nativePlaybackTextTracks = embeddedTextTracks;
      // eslint-disable-next-line
      console.info('Native playback caption tracks found:', embeddedTextTracks);
      this.$emit('hls-embedded-text-tracks', embeddedTextTracks);
    }
  },
  beforeDestroy() {
    try {
      this.clearVideoSourceTimeout();
      this.videoPlayer.pause();
      this.hls.destroy();
    } catch (err) {
      console.error('Error stopping playing of hls player', err);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/HlsVideoPlayer.vue?vue&type=script&lang=js
 /* harmony default export */ var components_HlsVideoPlayervue_type_script_lang_js = (HlsVideoPlayervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/HlsVideoPlayer.vue?vue&type=style&index=0&id=33fd0f4e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var HlsVideoPlayervue_type_style_index_0_id_33fd0f4e_prod_module_true_lang_scss = ({"root":"HlsVideoPlayer_root_R0xl7","videoPlayerContainer":"HlsVideoPlayer_videoPlayerContainer_IukT9","hlsParentBox":"HlsVideoPlayer_hlsParentBox_ecphy","behindLoader":"HlsVideoPlayer_behindLoader_xrsA8","hlsPlayer":"HlsVideoPlayer_hlsPlayer_ac_Mu","rounded":"HlsVideoPlayer_rounded_dpANx","hidePlayer":"HlsVideoPlayer_hidePlayer_pI4Fp","loader":"HlsVideoPlayer_loader_SPLQf","maintainHeight":"HlsVideoPlayer_maintainHeight_ACS7N","videoControlsHolder":"HlsVideoPlayer_videoControlsHolder_wZfms","bitRateSelectorHolder":"HlsVideoPlayer_bitRateSelectorHolder_HB4Ag","bitRateSelector":"HlsVideoPlayer_bitRateSelector_Rd_S7"});
;// CONCATENATED MODULE: ./src/components/HlsVideoPlayer.vue?vue&type=style&index=0&id=33fd0f4e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/HlsVideoPlayer.vue



;




function HlsVideoPlayer_injectStyles (context) {
  
  this["$style"] = (HlsVideoPlayervue_type_style_index_0_id_33fd0f4e_prod_module_true_lang_scss.locals || HlsVideoPlayervue_type_style_index_0_id_33fd0f4e_prod_module_true_lang_scss)

}

/* normalize component */

var HlsVideoPlayer_component = normalizeComponent(
  components_HlsVideoPlayervue_type_script_lang_js,
  HlsVideoPlayervue_type_template_id_33fd0f4e_render,
  HlsVideoPlayervue_type_template_id_33fd0f4e_staticRenderFns,
  false,
  HlsVideoPlayer_injectStyles,
  null,
  null
  
)

/* harmony default export */ var HlsVideoPlayer = (HlsVideoPlayer_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/DiscussionRoomWrapper.vue?vue&type=template&id=cd3c45d8&functional=true
var DiscussionRoomWrappervue_type_template_id_cd3c45d8_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.flexible_wrapper
  }, [_c('div', {
    class: [_vm.$style.flexible_wrapper, _vm.$style.player_styles]
  }, [_vm._t("room_content")], 2), _vm._t("controls")], 2);
};
var DiscussionRoomWrappervue_type_template_id_cd3c45d8_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/DiscussionRoomWrapper.vue?vue&type=script&lang=js
/* harmony default export */ var DiscussionRoomWrappervue_type_script_lang_js = ({
  name: 'DiscussionRoomWrapper'
});
;// CONCATENATED MODULE: ./src/components/DiscussionRoomWrapper.vue?vue&type=script&lang=js
 /* harmony default export */ var components_DiscussionRoomWrappervue_type_script_lang_js = (DiscussionRoomWrappervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/DiscussionRoomWrapper.vue?vue&type=style&index=0&id=cd3c45d8&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var DiscussionRoomWrappervue_type_style_index_0_id_cd3c45d8_prod_module_true_lang_scss = ({"flexible_wrapper":"DiscussionRoomWrapper_flexible_wrapper_s9nBY","player_styles":"DiscussionRoomWrapper_player_styles_GMVvK"});
;// CONCATENATED MODULE: ./src/components/DiscussionRoomWrapper.vue?vue&type=style&index=0&id=cd3c45d8&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/DiscussionRoomWrapper.vue



;




function DiscussionRoomWrapper_injectStyles (context) {
  
  this["$style"] = (DiscussionRoomWrappervue_type_style_index_0_id_cd3c45d8_prod_module_true_lang_scss.locals || DiscussionRoomWrappervue_type_style_index_0_id_cd3c45d8_prod_module_true_lang_scss)

}

/* normalize component */

var DiscussionRoomWrapper_component = normalizeComponent(
  components_DiscussionRoomWrappervue_type_script_lang_js,
  DiscussionRoomWrappervue_type_template_id_cd3c45d8_functional_true_render,
  DiscussionRoomWrappervue_type_template_id_cd3c45d8_functional_true_staticRenderFns,
  true,
  DiscussionRoomWrapper_injectStyles,
  null,
  null
  
)

/* harmony default export */ var DiscussionRoomWrapper = (DiscussionRoomWrapper_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Loading.vue?vue&type=template&id=2af3fee2&functional=true
var Loadingvue_type_template_id_2af3fee2_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: [_vm.data.class, _vm.data.staticClass, _vm.$style[_vm.props.size]]
  }, [_c('svg', {
    class: [_vm.$style.spinner, _vm.$style[_vm.props.size], _vm.props.classes, _vm.$style[_vm.props.theme]],
    attrs: {
      "width": "203",
      "height": "203",
      "viewBox": "0 0 203 203",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "opacity": "0.2",
      "cx": "101.5",
      "cy": "101.5",
      "r": "101"
    }
  }), _c('path', {
    attrs: {
      "d": "M84.6256 200.066C63.4321 196.438 43.9726 186.075 29.1332 170.515C14.2938 154.955 4.86492 135.026 2.24507 113.684"
    }
  })]), _vm._t("default")], 2);
};
var Loadingvue_type_template_id_2af3fee2_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Loading.vue?vue&type=style&index=0&id=2af3fee2&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var Loadingvue_type_style_index_0_id_2af3fee2_prod_module_true_lang_scss = ({"spinner":"Loading_spinner_rCTW0","rotating":"Loading_rotating_eSChe","dark":"Loading_dark_ACuu8","secondary":"Loading_secondary_Q3YGM","primary":"Loading_primary_GCQ4q","secondary-theme":"Loading_secondary-theme_H5_ND","veryVerySmall":"Loading_veryVerySmall_o4TVj","verySmall":"Loading_verySmall_Zt2LV","small":"Loading_small_fZzfW","medium":"Loading_medium_B4JxQ","large":"Loading_large_T0Lfa","loadersvg":"Loading_loadersvg_JDLoZ"});
;// CONCATENATED MODULE: ./src/components/Loading.vue?vue&type=style&index=0&id=2af3fee2&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Loading.vue

var Loading_script = {}
;




function Loading_injectStyles (context) {
  
  this["$style"] = (Loadingvue_type_style_index_0_id_2af3fee2_prod_module_true_lang_scss.locals || Loadingvue_type_style_index_0_id_2af3fee2_prod_module_true_lang_scss)

}

/* normalize component */

var Loading_component = normalizeComponent(
  Loading_script,
  Loadingvue_type_template_id_2af3fee2_functional_true_render,
  Loadingvue_type_template_id_2af3fee2_functional_true_staticRenderFns,
  true,
  Loading_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Loading = (Loading_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TransitionToast.vue?vue&type=template&id=c5ce332e&functional=true
var TransitionToastvue_type_template_id_c5ce332e_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: {
      [_vm.$style.root]: true
    }
  }, [_c('StyledText', {
    class: _vm.$style.text,
    attrs: {
      "variant": "body13",
      "color": "secondary-text-color"
    }
  }, [_c('span', {
    class: _vm.$style.time
  }, [_vm._v(_vm._s(_vm.props.time))]), _c('span', {
    class: _vm.$style.item
  }, [_vm._v(_vm._s(_vm.props.item))]), _c('span', {
    class: _vm.$style.postText
  }, [_vm._v(_vm._s(_vm.props.text))])]), _vm.props.canCancel ? _c('TextButton', {
    attrs: {
      "variant": "body13",
      "color": "secondary-text-color"
    },
    on: {
      "click": () => _vm.listeners.cancel()
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('cancel')) + " ")]) : _vm._e(), _vm.props.canJoin ? _c('PillButton', {
    attrs: {
      "variant": "secondary",
      "alt": "",
      "center": "",
      "uppercase": "",
      "size": "small",
      "color": "secondary-text-color"
    },
    on: {
      "click": () => _vm.listeners.join()
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Join')) + " ")]) : _vm._e()], 1);
};
var TransitionToastvue_type_template_id_c5ce332e_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TransitionToast.vue?vue&type=script&lang=js
/* harmony default export */ var TransitionToastvue_type_script_lang_js = ({
  name: 'TransitionToast',
  functional: true,
  props: {
    time: String,
    text: String,
    item: String,
    canCancel: Boolean,
    canJoin: Boolean
  }
});
;// CONCATENATED MODULE: ./src/components/TransitionToast.vue?vue&type=script&lang=js
 /* harmony default export */ var components_TransitionToastvue_type_script_lang_js = (TransitionToastvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TransitionToast.vue?vue&type=style&index=0&id=c5ce332e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var TransitionToastvue_type_style_index_0_id_c5ce332e_prod_module_true_lang_scss = ({"root":"TransitionToast_root_yG2t6","time":"TransitionToast_time_zB2h7","postText":"TransitionToast_postText_OwIHb","item":"TransitionToast_item_C4RKw","text":"TransitionToast_text_cHuVR"});
;// CONCATENATED MODULE: ./src/components/TransitionToast.vue?vue&type=style&index=0&id=c5ce332e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/TransitionToast.vue



;




function TransitionToast_injectStyles (context) {
  
  this["$style"] = (TransitionToastvue_type_style_index_0_id_c5ce332e_prod_module_true_lang_scss.locals || TransitionToastvue_type_style_index_0_id_c5ce332e_prod_module_true_lang_scss)

}

/* normalize component */

var TransitionToast_component = normalizeComponent(
  components_TransitionToastvue_type_script_lang_js,
  TransitionToastvue_type_template_id_c5ce332e_functional_true_render,
  TransitionToastvue_type_template_id_c5ce332e_functional_true_staticRenderFns,
  true,
  TransitionToast_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TransitionToast = (TransitionToast_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/IncomingVideoCallNotify.vue?vue&type=template&id=97ed2cae
var IncomingVideoCallNotifyvue_type_template_id_97ed2cae_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    class: _vm.$style.root,
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel-ivc-dialog');
      }
    }
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading15",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.contentHeader) + " ")]), _c('br'), _vm.from ? _c('StyledText', {
    attrs: {
      "variant": "body14",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.from) + " ")]) : _vm._e(), _c('br'), _c('br'), _c('div', {
    class: _vm.$style.buttonPlace
  }, [_c('OutlinedButton', {
    attrs: {
      "uppercase": "",
      "alt": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('answer-call');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('ANSWER')) + " ")]), _c('TextButton', {
    class: _vm.$style.reject,
    attrs: {
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('reject-call');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('REJECT')) + " ")])], 1)], 1);
};
var IncomingVideoCallNotifyvue_type_template_id_97ed2cae_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Modals/ModalsWrapper.vue?vue&type=template&id=11d9cf0e
var ModalsWrappervue_type_template_id_11d9cf0e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.modal,
    attrs: {
      "data-branding-target": "popup",
      "role": "dialog",
      "aria-modal": "true"
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_vm._t("default")], 2), _vm.footerText ? _c('div', {
    class: _vm.$style.footer,
    on: {
      "click": function ($event) {
        return _vm.$emit('footerClick');
      }
    }
  }, [_c('StyledText', {
    class: _vm.$style.footerText,
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.footerText) + " ")])], 1) : _vm._e(), _c('div', {
    class: _vm.$style.header
  }, [!_vm.noCancel ? _c('IconButton', {
    attrs: {
      "ariaLabel": 'Close button',
      "icon": "cross",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }) : _vm._e()], 1)]);
};
var ModalsWrappervue_type_template_id_11d9cf0e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Modals/ModalsWrapper.vue?vue&type=script&lang=js
/* harmony default export */ var ModalsWrappervue_type_script_lang_js = ({
  name: 'ModalsWrapper',
  props: {
    dark: {
      default: false
    },
    footerText: {
      default: null
    },
    noCancel: Boolean
  },
  mounted() {
    const allFocusableElements = this.$el.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
    const firstFocusableElement = allFocusableElements[0];
    const lastFocusableElement = allFocusableElements[allFocusableElements.length - 1];
    firstFocusableElement?.focus();
    this.$el.addEventListener('keydown', e => this.handleKeyDown(e, firstFocusableElement, lastFocusableElement));
  },
  beforeDestroy() {
    this.$el.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    handleKeyDown(e, firstFocusableElement, lastFocusableElement) {
      if (e.key === 'Tab') {
        if (e.shiftKey && document.activeElement === firstFocusableElement) {
          e.preventDefault();
          lastFocusableElement.focus();
        } else if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      } else if (e.key === 'Escape') {
        this.$emit('cancel');
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Modals/ModalsWrapper.vue?vue&type=script&lang=js
 /* harmony default export */ var Modals_ModalsWrappervue_type_script_lang_js = (ModalsWrappervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Modals/ModalsWrapper.vue?vue&type=style&index=0&id=11d9cf0e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ModalsWrappervue_type_style_index_0_id_11d9cf0e_prod_module_true_lang_scss = ({"modal":"ModalsWrapper_modal_OORPe","container":"ModalsWrapper_container_jp47d","header":"ModalsWrapper_header_LPOgZ","footer":"ModalsWrapper_footer_TyJr_","footerText":"ModalsWrapper_footerText_qe7Uo"});
;// CONCATENATED MODULE: ./src/components/Modals/ModalsWrapper.vue?vue&type=style&index=0&id=11d9cf0e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Modals/ModalsWrapper.vue



;




function ModalsWrapper_injectStyles (context) {
  
  this["$style"] = (ModalsWrappervue_type_style_index_0_id_11d9cf0e_prod_module_true_lang_scss.locals || ModalsWrappervue_type_style_index_0_id_11d9cf0e_prod_module_true_lang_scss)

}

/* normalize component */

var ModalsWrapper_component = normalizeComponent(
  Modals_ModalsWrappervue_type_script_lang_js,
  ModalsWrappervue_type_template_id_11d9cf0e_render,
  ModalsWrappervue_type_template_id_11d9cf0e_staticRenderFns,
  false,
  ModalsWrapper_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ModalsWrapper = (ModalsWrapper_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/IncomingVideoCallNotify.vue?vue&type=script&lang=js

/* harmony default export */ var IncomingVideoCallNotifyvue_type_script_lang_js = ({
  name: 'IncomingVideoCallNotify',
  components: {
    ModalsWrapper: ModalsWrapper
  },
  props: {
    from: {
      type: String,
      default: null
    },
    contentHeader: {
      type: String,
      default: null
    }
  },
  watch: {
    roomSize(value) {
      this.breakoutSession = {
        ...this.breakoutSession,
        ...{
          roomSize: value
        }
      };
    },
    timeDuration(value) {
      this.breakoutSession = {
        ...this.breakoutSession,
        ...{
          timeDuration: value
        }
      };
    }
  },
  data() {
    return {
      breakoutSession: {
        roomSize: this.roomSize,
        timeDuration: this.timeDuration
      }
    };
  }
});
;// CONCATENATED MODULE: ./src/components/IncomingVideoCallNotify.vue?vue&type=script&lang=js
 /* harmony default export */ var components_IncomingVideoCallNotifyvue_type_script_lang_js = (IncomingVideoCallNotifyvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/IncomingVideoCallNotify.vue?vue&type=style&index=0&id=97ed2cae&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var IncomingVideoCallNotifyvue_type_style_index_0_id_97ed2cae_prod_module_true_lang_scss = ({"buttonPlace":"IncomingVideoCallNotify_buttonPlace_iJiAY","loadingContainer":"IncomingVideoCallNotify_loadingContainer_CUf5G"});
;// CONCATENATED MODULE: ./src/components/IncomingVideoCallNotify.vue?vue&type=style&index=0&id=97ed2cae&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/IncomingVideoCallNotify.vue



;




function IncomingVideoCallNotify_injectStyles (context) {
  
  this["$style"] = (IncomingVideoCallNotifyvue_type_style_index_0_id_97ed2cae_prod_module_true_lang_scss.locals || IncomingVideoCallNotifyvue_type_style_index_0_id_97ed2cae_prod_module_true_lang_scss)

}

/* normalize component */

var IncomingVideoCallNotify_component = normalizeComponent(
  components_IncomingVideoCallNotifyvue_type_script_lang_js,
  IncomingVideoCallNotifyvue_type_template_id_97ed2cae_render,
  IncomingVideoCallNotifyvue_type_template_id_97ed2cae_staticRenderFns,
  false,
  IncomingVideoCallNotify_injectStyles,
  null,
  null
  
)

/* harmony default export */ var IncomingVideoCallNotify = (IncomingVideoCallNotify_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ConfirmTrackChange.vue?vue&type=template&id=8a5bde92
var ConfirmTrackChangevue_type_template_id_8a5bde92_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    class: _vm.$style.root,
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading15",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Heads up!')) + " ")]), _c('br'), _c('StyledText', {
    attrs: {
      "variant": "body14",
      "align": "center",
      "color": "primary-text-color",
      "display": "block"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Following {track2} {will_automatically_unfollow_you_from_track1_Would_you_like_to_continue}', {
    track2: '',
    will_automatically_unfollow_you_from_track1_Would_you_like_to_continue: ''
  })) + " "), _c('b', [_vm._v(" " + _vm._s(_vm.to) + " ")]), _vm._v(" " + _vm._s(_vm.$options.$t('{following_track2}will automatically unfollow you from{track1_Would_you_like_to_continue}', {
    following_track2: '',
    track1_Would_you_like_to_continue: ''
  })) + " "), _c('b', [_vm._v(" " + _vm._s(_vm.from) + " ")]), _vm._v(" . " + _vm._s(_vm.$options.$t('{following_track2_will_automatically_unfollow_you_from_track1}Would you like to continue?', {
    following_track2_will_automatically_unfollow_you_from_track1: ''
  })) + " ")]), _c('br'), _c('div', {
    class: _vm.$style.buttonPlace
  }, [_c('OutlinedButton', {
    attrs: {
      "uppercase": "",
      "alt": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('hide');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('YES')) + " ")]), _c('OutlinedButton', {
    class: _vm.$style.reject,
    attrs: {
      "uppercase": "",
      "alt": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('No')) + " ")])], 1)], 1);
};
var ConfirmTrackChangevue_type_template_id_8a5bde92_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ConfirmTrackChange.vue?vue&type=script&lang=js

/* harmony default export */ var ConfirmTrackChangevue_type_script_lang_js = ({
  name: 'ConfirmTrackChange',
  components: {
    ModalsWrapper: ModalsWrapper
  },
  props: {
    from: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: ''
    }
  }
});
;// CONCATENATED MODULE: ./src/components/ConfirmTrackChange.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ConfirmTrackChangevue_type_script_lang_js = (ConfirmTrackChangevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/ConfirmTrackChange.vue?vue&type=style&index=0&id=8a5bde92&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ConfirmTrackChangevue_type_style_index_0_id_8a5bde92_prod_module_true_lang_scss = ({"buttonPlace":"ConfirmTrackChange_buttonPlace_D3ip7"});
;// CONCATENATED MODULE: ./src/components/ConfirmTrackChange.vue?vue&type=style&index=0&id=8a5bde92&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/ConfirmTrackChange.vue



;




function ConfirmTrackChange_injectStyles (context) {
  
  this["$style"] = (ConfirmTrackChangevue_type_style_index_0_id_8a5bde92_prod_module_true_lang_scss.locals || ConfirmTrackChangevue_type_style_index_0_id_8a5bde92_prod_module_true_lang_scss)

}

/* normalize component */

var ConfirmTrackChange_component = normalizeComponent(
  components_ConfirmTrackChangevue_type_script_lang_js,
  ConfirmTrackChangevue_type_template_id_8a5bde92_render,
  ConfirmTrackChangevue_type_template_id_8a5bde92_staticRenderFns,
  false,
  ConfirmTrackChange_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ConfirmTrackChange = (ConfirmTrackChange_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ConfirmLiveSwitch.vue?vue&type=template&id=292e1870
var ConfirmLiveSwitchvue_type_template_id_292e1870_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    class: _vm.$style.root,
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Heads up!')) + " ")]), _c('br'), _c('StyledText', {
    attrs: {
      "variant": "body14",
      "align": "center",
      "color": "primary-text-color",
      "display": "block"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('You are about to stop playing this video. Your broadcast will return to live mode and your audience will see and hear your speakers. Are you sure?')) + " ")]), _c('br'), _c('div', {
    class: _vm.$style.buttonPlace
  }, [_c('OutlinedButton', {
    attrs: {
      "uppercase": "",
      "alt": "",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('hide');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('YES')) + " ")]), _c('OutlinedButton', {
    class: _vm.$style.reject,
    attrs: {
      "uppercase": "",
      "alt": "",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('No')) + " ")])], 1)], 1);
};
var ConfirmLiveSwitchvue_type_template_id_292e1870_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ConfirmLiveSwitch.vue?vue&type=script&lang=js

/* harmony default export */ var ConfirmLiveSwitchvue_type_script_lang_js = ({
  name: 'ConfirmLiveSwitch',
  components: {
    ModalsWrapper: ModalsWrapper
  }
});
;// CONCATENATED MODULE: ./src/components/ConfirmLiveSwitch.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ConfirmLiveSwitchvue_type_script_lang_js = (ConfirmLiveSwitchvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/ConfirmLiveSwitch.vue?vue&type=style&index=0&id=292e1870&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ConfirmLiveSwitchvue_type_style_index_0_id_292e1870_prod_module_true_lang_scss = ({"buttonPlace":"ConfirmLiveSwitch_buttonPlace_TWDOT"});
;// CONCATENATED MODULE: ./src/components/ConfirmLiveSwitch.vue?vue&type=style&index=0&id=292e1870&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/ConfirmLiveSwitch.vue



;




function ConfirmLiveSwitch_injectStyles (context) {
  
  this["$style"] = (ConfirmLiveSwitchvue_type_style_index_0_id_292e1870_prod_module_true_lang_scss.locals || ConfirmLiveSwitchvue_type_style_index_0_id_292e1870_prod_module_true_lang_scss)

}

/* normalize component */

var ConfirmLiveSwitch_component = normalizeComponent(
  components_ConfirmLiveSwitchvue_type_script_lang_js,
  ConfirmLiveSwitchvue_type_template_id_292e1870_render,
  ConfirmLiveSwitchvue_type_template_id_292e1870_staticRenderFns,
  false,
  ConfirmLiveSwitch_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ConfirmLiveSwitch = (ConfirmLiveSwitch_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SimpleProfileInput.vue?vue&type=template&id=48e9186c
var SimpleProfileInputvue_type_template_id_48e9186c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    class: [_vm.$style.input],
    style: _vm.wrapperCss
  }, [_c('StyledText', {
    class: [!_vm.active ? _vm.$style.inActivelabel : _vm.$style.floatLabel, _vm.$style.label],
    on: {
      "focus": function ($event) {
        return _vm.$emit('focusLabel', $event);
      }
    }
  }, [_vm._t("default")], 2), _vm.$attrs.type === 'file' ? _c('input', _vm._b({
    ref: "input",
    attrs: {
      "id": "fileinput"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event.target.files);
      },
      "change": function ($event) {
        return _vm.$emit('change', $event.target.files);
      },
      "focus": function ($event) {
        return _vm.$emit('focus', $event);
      },
      "blur": function ($event) {
        return _vm.$emit('blur', $event);
      }
    }
  }, 'input', _vm.$attrs, false)) : _vm.$attrs.type === 'select' ? _c('SingleSelect', {
    attrs: {
      "value": _vm.selectValue,
      "options": _vm.selectOptions,
      "autoFocus": _vm.autoFocus
    },
    on: {
      "select": _vm.onSingleSelect
    }
  }) : _vm.linkInput ? _c('div', {
    class: _vm.$style.linkInput
  }, [_vm.active ? _c('StyledText', {
    class: _vm.$style.staticLink,
    attrs: {
      "variant": "body12"
    },
    on: {
      "focus": function ($event) {
        return _vm.$emit('focusLabel', $event);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.baseUrl) + " ")]) : _vm._e(), _c('input', _vm._b({
    ref: "input",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event.target.value);
      },
      "change": function ($event) {
        return _vm.$emit('change', $event.target.value);
      },
      "focus": function ($event) {
        return _vm.$emit('focus', $event);
      },
      "blur": function ($event) {
        return _vm.$emit('blur', $event);
      }
    }
  }, 'input', _vm.$attrs, false))], 1) : _vm.type === 'textArea' ? _c('textarea', {
    ref: "input",
    attrs: {
      "rows": "15"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event.target.value);
      },
      "change": function ($event) {
        return _vm.$emit('change', $event.target.value);
      },
      "focus": function ($event) {
        return _vm.$emit('focus', $event);
      },
      "blur": function ($event) {
        return _vm.$emit('blur', $event);
      }
    }
  }) : _c('input', _vm._b({
    ref: "input",
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event.target.value);
      },
      "change": function ($event) {
        return _vm.$emit('change', $event.target.value);
      },
      "focus": function ($event) {
        return _vm.$emit('focus', $event);
      },
      "blur": function ($event) {
        return _vm.$emit('blur', $event);
      }
    }
  }, 'input', _vm.$attrs, false)), _vm.$attrs.type === 'file' ? _c('label', {
    attrs: {
      "for": "fileinput"
    }
  }, [_c('StyledText', {
    class: [_vm.$style.filelabel, !_vm.fileName && _vm.$style.filePlaceholder],
    attrs: {
      "variant": "body14"
    }
  }, [_vm._v(" " + _vm._s(_vm.fileName || _vm.$options.$t(_vm.filePlaceholder)) + " ")])], 1) : _vm._e()], 1), _vm.error ? _c('StyledText', {
    class: [_vm.$style.error, {
      [_vm.$style.hasNoerror]: !_vm.error
    }],
    attrs: {
      "color": "color-secondary-light"
    }
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm._e()], 1);
};
var SimpleProfileInputvue_type_template_id_48e9186c_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SimpleProfileInput.vue?vue&type=script&lang=js
/* harmony default export */ var SimpleProfileInputvue_type_script_lang_js = ({
  name: 'SimpleProfileInput',
  props: {
    fileName: {
      type: String,
      default: null
    },
    filePlaceholder: {
      type: String,
      default: 'No File Chosen'
    },
    value: {
      type: [Number, String, Array],
      default: ''
    },
    field: {
      type: Object,
      default: () => {}
    },
    wrapperCss: {
      type: Object,
      default: () => {}
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    error: String,
    customtheme: Boolean,
    placeholder: String,
    baseUrl: String,
    linkInput: Boolean,
    disabled: Boolean,
    type: String,
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fromval: '',
      toval: '',
      selectValue: {
        name: '',
        display_name: ''
      }
    };
  },
  mounted() {
    if (this.autoFocus && this.$refs.input && this.$refs.input.focus) {
      this.$refs.input.focus();
    }
  },
  methods: {
    onSingleSelect(data) {
      this.selectValue.display_name = data.value;
      this.$emit('change', data.value);
      this.$emit('input', data.value);
    }
  },
  computed: {
    selectOptions() {
      return this.field.choices.map(elm => {
        return {
          name: elm,
          display_name: elm,
          value: elm
        };
      });
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SimpleProfileInput.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SimpleProfileInputvue_type_script_lang_js = (SimpleProfileInputvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SimpleProfileInput.vue?vue&type=style&index=0&id=48e9186c&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SimpleProfileInputvue_type_style_index_0_id_48e9186c_prod_module_true_lang_scss = ({"input":"SimpleProfileInput_input_j0hCY","label":"SimpleProfileInput_label_jerd1","inActivelabel":"SimpleProfileInput_inActivelabel_vYpAa","label-animation":"SimpleProfileInput_label-animation_AYiW3","floatLabel":"SimpleProfileInput_floatLabel__nraU","active-label-animation":"SimpleProfileInput_active-label-animation_wMM8t","filelabel":"SimpleProfileInput_filelabel_NmvMW","filePlaceholder":"SimpleProfileInput_filePlaceholder_pe9iO","hasNoerror":"SimpleProfileInput_hasNoerror_Zlq_I","linkInput":"SimpleProfileInput_linkInput_AWMIH","staticLink":"SimpleProfileInput_staticLink_Fsw7i","error":"SimpleProfileInput_error_DBMa3"});
;// CONCATENATED MODULE: ./src/components/SimpleProfileInput.vue?vue&type=style&index=0&id=48e9186c&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SimpleProfileInput.vue



;




function SimpleProfileInput_injectStyles (context) {
  
  this["$style"] = (SimpleProfileInputvue_type_style_index_0_id_48e9186c_prod_module_true_lang_scss.locals || SimpleProfileInputvue_type_style_index_0_id_48e9186c_prod_module_true_lang_scss)

}

/* normalize component */

var SimpleProfileInput_component = normalizeComponent(
  components_SimpleProfileInputvue_type_script_lang_js,
  SimpleProfileInputvue_type_template_id_48e9186c_render,
  SimpleProfileInputvue_type_template_id_48e9186c_staticRenderFns,
  false,
  SimpleProfileInput_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SimpleProfileInput = (SimpleProfileInput_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LivenessPanelRecordingItem.vue?vue&type=template&id=3e31bd71
var LivenessPanelRecordingItemvue_type_template_id_3e31bd71_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.agenda && !_vm.agenda.kind ? _c('span', {
    class: _vm.$style.recordingItem
  }, [_c('GTooltip', {
    class: _vm.$style.tooltip,
    attrs: {
      "text": _vm.agenda && _vm.agenda.is_recording ? _vm.$options.$t('Yes this is being recorded') : _vm.$options.$t('No this is not being recorded')
    }
  }, [_c('IconButton', {
    class: {
      [_vm.agenda.is_recording]: _vm.$style.recording,
      [_vm.$style.recordingStatusButton]: true
    },
    attrs: {
      "icon": "record",
      "variant": "light",
      "size": "regular"
    }
  })], 1)], 1) : _c('span');
};
var LivenessPanelRecordingItemvue_type_template_id_3e31bd71_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LivenessPanelRecordingItem.vue?vue&type=script&lang=js
/* harmony default export */ var LivenessPanelRecordingItemvue_type_script_lang_js = ({
  props: {
    agenda: {
      type: Object,
      default() {
        return {};
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/LivenessPanelRecordingItem.vue?vue&type=script&lang=js
 /* harmony default export */ var components_LivenessPanelRecordingItemvue_type_script_lang_js = (LivenessPanelRecordingItemvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/LivenessPanelRecordingItem.vue?vue&type=style&index=0&id=3e31bd71&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var LivenessPanelRecordingItemvue_type_style_index_0_id_3e31bd71_prod_module_true_lang_scss = ({"recordingItem":"LivenessPanelRecordingItem_recordingItem_rCYGp","tooltip":"LivenessPanelRecordingItem_tooltip_hT9oy","recordingStatusButton":"LivenessPanelRecordingItem_recordingStatusButton_e_1Op","recording":"LivenessPanelRecordingItem_recording_oph6f"});
;// CONCATENATED MODULE: ./src/components/LivenessPanelRecordingItem.vue?vue&type=style&index=0&id=3e31bd71&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/LivenessPanelRecordingItem.vue



;




function LivenessPanelRecordingItem_injectStyles (context) {
  
  this["$style"] = (LivenessPanelRecordingItemvue_type_style_index_0_id_3e31bd71_prod_module_true_lang_scss.locals || LivenessPanelRecordingItemvue_type_style_index_0_id_3e31bd71_prod_module_true_lang_scss)

}

/* normalize component */

var LivenessPanelRecordingItem_component = normalizeComponent(
  components_LivenessPanelRecordingItemvue_type_script_lang_js,
  LivenessPanelRecordingItemvue_type_template_id_3e31bd71_render,
  LivenessPanelRecordingItemvue_type_template_id_3e31bd71_staticRenderFns,
  false,
  LivenessPanelRecordingItem_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LivenessPanelRecordingItem = (LivenessPanelRecordingItem_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/GCheckbox.vue?vue&type=template&id=4a74bbaa&functional=true
var GCheckboxvue_type_template_id_4a74bbaa_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: [_vm.$style.root, _vm.$style[_vm.props.theme]],
    attrs: {
      "tabindex": "0",
      "aria-label": _vm.props.label,
      "aria-checked": _vm.props.checked,
      "role": "checkbox"
    },
    on: {
      "click": _vm.listeners.toggle,
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.preventDefault();
        return _vm.listeners.toggle.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.listeners.toggle.apply(null, arguments);
      }]
    }
  }, [_c('input', {
    class: _vm.$style.checkboxInput,
    attrs: {
      "type": "checkbox",
      "tabindex": "-1"
    },
    domProps: {
      "checked": _vm.props.checked
    }
  }), _c('span', {
    class: _vm.$style.displayedCheckbox
  }, [_c('SvgIcon', {
    class: _vm.$style.checkMark,
    attrs: {
      "name": "tick",
      "color": `${_vm.props.theme}-text-color`,
      "size": "small"
    }
  })], 1), _c('StyledText', {
    class: _vm.$style.label,
    attrs: {
      "id": _vm.props.label,
      "variant": "body13",
      "color": `${_vm.props.theme}-text-color`
    }
  }, [_vm._v(" " + _vm._s(_vm.props.label) + " ")])], 1);
};
var GCheckboxvue_type_template_id_4a74bbaa_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/GCheckbox.vue?vue&type=script&lang=js
/* harmony default export */ var GCheckboxvue_type_script_lang_js = ({
  functional: true,
  name: 'GCheckbox',
  props: {
    label: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'primary'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/GCheckbox.vue?vue&type=script&lang=js
 /* harmony default export */ var components_GCheckboxvue_type_script_lang_js = (GCheckboxvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/GCheckbox.vue?vue&type=style&index=0&id=4a74bbaa&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var GCheckboxvue_type_style_index_0_id_4a74bbaa_prod_module_true_lang_scss = ({"root":"GCheckbox_root_jfTvY","secondary":"GCheckbox_secondary_noNEn","screen-saver":"GCheckbox_screen-saver_zXs8p","checkboxInput":"GCheckbox_checkboxInput_ggnU9","displayedCheckbox":"GCheckbox_displayedCheckbox_z4igs","checkMark":"GCheckbox_checkMark_UFEuk","label":"GCheckbox_label_Pa0n3"});
;// CONCATENATED MODULE: ./src/components/GCheckbox.vue?vue&type=style&index=0&id=4a74bbaa&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/GCheckbox.vue



;




function GCheckbox_injectStyles (context) {
  
  this["$style"] = (GCheckboxvue_type_style_index_0_id_4a74bbaa_prod_module_true_lang_scss.locals || GCheckboxvue_type_style_index_0_id_4a74bbaa_prod_module_true_lang_scss)

}

/* normalize component */

var GCheckbox_component = normalizeComponent(
  components_GCheckboxvue_type_script_lang_js,
  GCheckboxvue_type_template_id_4a74bbaa_functional_true_render,
  GCheckboxvue_type_template_id_4a74bbaa_functional_true_staticRenderFns,
  true,
  GCheckbox_injectStyles,
  null,
  null
  
)

/* harmony default export */ var GCheckbox = (GCheckbox_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarAssetsTab.vue?vue&type=template&id=217d7771
var SidebarAssetsTabvue_type_template_id_217d7771_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "id": "sidebarAssets"
    }
  }, [_vm.tabs.length > 0 ? _c('div', {
    class: _vm.$style.headerSwitchableTabs
  }, [_c('div', {
    class: _vm.$style.headerHolder
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c('div', {
      key: tab.id,
      class: {
        [_vm.$style.clickableWidgetHeaderTabs]: true,
        [_vm.$style.selected]: tab.id === _vm.currentTabId
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('toggleTab', index);
        }
      }
    }, [_c('GTooltip', {
      attrs: {
        "text": tab.label
      }
    }, [_c('StyledText', {
      class: _vm.$style.overflowElips,
      attrs: {
        "color": "primary-text-color"
      }
    }, [_vm._v(" " + _vm._s(tab.label) + " ")])], 1)], 1);
  }), 0)]) : _vm._e(), _vm.currentTabId === 'slides' ? _c('SlidesList', _vm._b({
    attrs: {
      "publishedStage": _vm.publishedStage,
      "usePdfConfigs": _vm.usePdfConfigs
    },
    on: {
      "selectSlide": function ($event) {
        return _vm.$emit('selectSlide', $event);
      },
      "openDeck": function ($event) {
        return _vm.$emit('openDeck', $event);
      }
    }
  }, 'SlidesList', _vm.slides, false)) : _vm.currentTabId === 'vids' && _vm.isLiveHybridBroadcast ? _c('LiveVideoSelectorWidget', {
    attrs: {
      "videos": _vm.videos,
      "playingVideoID": _vm.currentSelectedVideoID,
      "idOfSelectedVideo": _vm.liveModeVideoSelectorConfig.idOfSelectedVideo,
      "liveVideoRoomVideoPlaybackStartState": _vm.liveModeVideoSelectorConfig.liveVideoRoomVideoPlaybackStartState,
      "isSwitchingToSpeakerMode": _vm.liveModeVideoSelectorConfig.isSwitchingToSpeakerMode
    },
    on: {
      "selectvideotoplay": function ($event) {
        return _vm.$emit('selectvideo', $event);
      },
      "switchtolivemode": function ($event) {
        return _vm.$emit('switchtolive');
      }
    }
  }) : _vm.currentTabId === 'logos' ? _c('SidebarLogos', {
    attrs: {
      "currentStageLogo": _vm.currentStageLogo,
      "logos": _vm.stageLogos
    },
    on: {
      "publishStageLogo": src => _vm.$emit('publishStageLogo', src)
    }
  }) : _vm.currentTabId === 'banner' ? _c('SidebarBannersControl', _vm._b({
    on: {
      "handleOverlayCtaClick": data => _vm.$emit('submitOverlay', data),
      "handleTickerCtaClick": data => _vm.$emit('submitTicker', data)
    }
  }, 'SidebarBannersControl', _vm.$attrs, false)) : _vm._e()], 1);
};
var SidebarAssetsTabvue_type_template_id_217d7771_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarVideoProduction/SidebarLogos.vue?vue&type=template&id=c590ab06
var SidebarLogosvue_type_template_id_c590ab06_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('SidebarWidgetContainer', {
    attrs: {
      "widgetLabel": _vm.$options.$t('Logos On Stage')
    }
  }, [_c('div', {
    class: _vm.$style.filterbar
  }, [_c('LogoPositionDropdown', {
    attrs: {
      "currentPosition": _vm.currentStageLogo && _vm.currentStageLogo.position,
      "fullScreen": _vm.currentStageLogo && _vm.currentStageLogo.fullScreen
    },
    on: {
      "change": _vm.handlePositionClick,
      "setFullScreen": _vm.handleFullScreenClick
    }
  }), _vm.currentStageLogo && _vm.currentStageLogo.url ? _c('PillButton', {
    attrs: {
      "size": "x-small",
      "variant": "secondary"
    },
    on: {
      "click": () => _vm.handleImageClick(_vm.src)
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Stop Sharing')) + " ")]) : _vm._e()], 1), _vm.currentStageLogo && _vm.currentStageLogo.fullScreen ? _c('div', {
    class: _vm.$style.messageBar
  }, [_c('StyledText', [_vm._v(_vm._s(_vm.$options.$t('All stage elements are present behind the shared image. They will be visible again once full screen image sharing is stopped.')))])], 1) : _vm._e(), _c('div', {
    class: _vm.$style.options
  }, _vm._l(_vm.logos, function (src, i) {
    return _c('span', {
      key: i
    }, [_c('img', {
      attrs: {
        "src": src
      }
    }), _c('RadioSelectBtn', {
      attrs: {
        "selected": _vm.currentStageLogo && _vm.currentStageLogo.url === src,
        "theme": "primary"
      },
      on: {
        "click": () => _vm.handleImageClick(src)
      }
    })], 1);
  }), 0)])], 1);
};
var SidebarLogosvue_type_template_id_c590ab06_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/LogoPositionDropdown.vue?vue&type=template&id=54b41287
var LogoPositionDropdownvue_type_template_id_54b41287_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('DropdownSetup', {
    class: _vm.$style.dropdownRoot,
    attrs: {
      "open": _vm.open,
      "align": "left",
      "verticalPosition": "bottom"
    },
    on: {
      "close": function ($event) {
        _vm.open = false;
      }
    }
  }, [_c('div', {
    class: _vm.$style.toggler,
    attrs: {
      "slot": "toggler"
    },
    on: {
      "click": function ($event) {
        _vm.open = !_vm.open;
      }
    },
    slot: "toggler"
  }, [_c('StyledText', {
    attrs: {
      "variant": "body13",
      "color": "theme-secondary-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Layout: {layout} ', {
    layout: _vm.layout
  })) + " ")]), !_vm.open ? _c('SvgIcon', {
    class: _vm.$style.caret,
    attrs: {
      "name": "caret",
      "size": "x-small",
      "color": "theme-secondary-color"
    }
  }) : _vm._e()], 1), _c('div', {
    class: {
      [_vm.$style.dropdown]: true
    },
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('div', {
    class: _vm.$style.option
  }, [_c('SimpleRadioButton', {
    attrs: {
      "selected": !_vm.fullScreen,
      "color": "primary-text-color"
    },
    on: {
      "select": () => _vm.fullScreen && _vm.$emit('setFullScreen', false)
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "heading14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('With Speaker Videos')) + " ")])], 1), _c('div', {
    class: _vm.$style.positionSelector
  }, [_vm._l(_vm.positions.vertical, function (posY) {
    return _vm._l(_vm.positions.horizontal, function (posX) {
      return _c('span', {
        key: `${_vm.$options.$t(posX)}${_vm.$options.$t(posY)}`,
        class: {
          [_vm.$style.selectedPosition]: posX === _vm.position.horizontal && posY === _vm.position.vertical
        },
        on: {
          "click": () => _vm.handlePositionClick(posX, posY)
        }
      });
    });
  })], 2), _c('div', {
    class: _vm.$style.option
  }, [_c('SimpleRadioButton', {
    attrs: {
      "selected": _vm.fullScreen,
      "color": "primary-text-color"
    },
    on: {
      "select": () => !_vm.fullScreen && _vm.$emit('setFullScreen', true)
    }
  }), _c('span', [_c('StyledText', {
    attrs: {
      "variant": "heading14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Full Screen')) + " ")]), _c('StyledText', {
    attrs: {
      "variant": "subHeading14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('No Speakers')) + " ")])], 1)], 1)])]);
};
var LogoPositionDropdownvue_type_template_id_54b41287_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/LogoPositionDropdown.vue?vue&type=script&lang=js
/* harmony default export */ var LogoPositionDropdownvue_type_script_lang_js = ({
  name: 'LogoPositionDropdown',
  props: {
    currentPosition: {
      type: String,
      default: 'top-right'
    },
    fullScreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
      positions: {
        horizontal: ['left', 'center', 'right'],
        vertical: ['top', 'bottom']
      }
    };
  },
  computed: {
    position() {
      if (!this.currentPosition.includes('-')) {
        return {
          horizontal: 'right',
          vertical: 'top'
        };
      }
      const [vertical, horizontal] = this.currentPosition.split('-');
      return {
        vertical: vertical || 'top',
        horizontal: horizontal || 'right'
      };
    },
    layout() {
      const layoutString = `${this.$t(this.position.vertical)} ${this.$t(this.position.horizontal)}`;
      return this.fullScreen ? 'Full Screen' : layoutString;
    }
  },
  methods: {
    handlePositionClick(horizontal, vertical) {
      const newPosition = `${vertical}-${horizontal}`;
      if (newPosition !== this.currentPosition) {
        this.$emit('change', newPosition);
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/LogoPositionDropdown.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_LogoPositionDropdownvue_type_script_lang_js = (LogoPositionDropdownvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/LogoPositionDropdown.vue?vue&type=style&index=0&id=54b41287&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var LogoPositionDropdownvue_type_style_index_0_id_54b41287_prod_module_true_lang_scss = ({"dropdownRoot":"LogoPositionDropdown_dropdownRoot_clm9v","toggler":"LogoPositionDropdown_toggler_lMItJ","caret":"LogoPositionDropdown_caret_bYhzJ","dropdown":"LogoPositionDropdown_dropdown_B5mk9","option":"LogoPositionDropdown_option_GL4ZS","positionSelector":"LogoPositionDropdown_positionSelector_lGYnD","selectedPosition":"LogoPositionDropdown_selectedPosition_IJRkx"});
;// CONCATENATED MODULE: ./src/molecules/LogoPositionDropdown.vue?vue&type=style&index=0&id=54b41287&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/LogoPositionDropdown.vue



;




function LogoPositionDropdown_injectStyles (context) {
  
  this["$style"] = (LogoPositionDropdownvue_type_style_index_0_id_54b41287_prod_module_true_lang_scss.locals || LogoPositionDropdownvue_type_style_index_0_id_54b41287_prod_module_true_lang_scss)

}

/* normalize component */

var LogoPositionDropdown_component = normalizeComponent(
  molecules_LogoPositionDropdownvue_type_script_lang_js,
  LogoPositionDropdownvue_type_template_id_54b41287_render,
  LogoPositionDropdownvue_type_template_id_54b41287_staticRenderFns,
  false,
  LogoPositionDropdown_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LogoPositionDropdown = (LogoPositionDropdown_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarVideoProduction/SidebarLogos.vue?vue&type=script&lang=js

/* harmony default export */ var SidebarLogosvue_type_script_lang_js = ({
  components: {
    LogoPositionDropdown: LogoPositionDropdown
  },
  props: {
    logos: {
      type: Array,
      default: () => ['https://global-uploads.webflow.com/5d644148b208941bdfb23d97/61685bc48eba51405df2770a_kong.svg', 'https://global-uploads.webflow.com/5d644148b208941bdfb23d97/61685bc48eba517ed3f27722_Microsoft.svg', 'https://global-uploads.webflow.com/5d644148b208941bdfb23d97/61685bc48eba51535ff27737_Attentive.svg', 'https://global-uploads.webflow.com/5d644148b208941bdfb23d97/61685bc48eba51e3c9f27740_Toast.svg', 'https://global-uploads.webflow.com/5d644148b208941bdfb23d97/61685bc48eba51bf2af2772c_Drift.svg', 'https://global-uploads.webflow.com/5d644148b208941bdfb23d97/61685bc48eba517e3af27772_bloomreach.svg']
    },
    currentStageLogo: {
      type: Object,
      default: () => ({
        url: 'https://global-uploads.webflow.com/5d644148b208941bdfb23d97/61685bc48eba51405df2770a_kong.svg',
        position: 'top-left'
      })
    }
  },
  methods: {
    handleChange(key, value) {
      try {
        if (this.currentStageLogo[key] === value) {
          return;
        }
      } catch (e) {
        console.error(e);
      }
      this.$emit('publishStageLogo', {
        ...this.currentStageLogo,
        [key]: value
      });
    },
    handleImageClick(url) {
      this.handleChange('url', url);
    },
    handlePositionClick(position) {
      this.handleChange('position', position);
    },
    handleFullScreenClick(fullScreen) {
      this.handleChange('fullScreen', fullScreen);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/SidebarLogos.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarVideoProduction_SidebarLogosvue_type_script_lang_js = (SidebarLogosvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarVideoProduction/SidebarLogos.vue?vue&type=style&index=0&id=c590ab06&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarLogosvue_type_style_index_0_id_c590ab06_prod_module_true_lang_scss = ({"root":"SidebarLogos_root_zM0dF","filterbar":"SidebarLogos_filterbar_GJ1ne","messageBar":"SidebarLogos_messageBar_AsnqJ","options":"SidebarLogos_options_oljRo"});
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/SidebarLogos.vue?vue&type=style&index=0&id=c590ab06&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/SidebarLogos.vue



;




function SidebarLogos_injectStyles (context) {
  
  this["$style"] = (SidebarLogosvue_type_style_index_0_id_c590ab06_prod_module_true_lang_scss.locals || SidebarLogosvue_type_style_index_0_id_c590ab06_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarLogos_component = normalizeComponent(
  SidebarVideoProduction_SidebarLogosvue_type_script_lang_js,
  SidebarLogosvue_type_template_id_c590ab06_render,
  SidebarLogosvue_type_template_id_c590ab06_staticRenderFns,
  false,
  SidebarLogos_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarLogos = (SidebarLogos_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarVideoProduction/SidebarBannersControl.vue?vue&type=template&id=0c5bf363
var SidebarBannersControlvue_type_template_id_0c5bf363_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.showOverlayControlPanel ? _c('BannersTabCard', _vm._b({
    key: "0",
    class: _vm.$style.bannerCard,
    attrs: {
      "inputFieldType": "textarea",
      "butonText": _vm.overlayData.overlayCtaText,
      "buttonIcon": "screen-share",
      "isSecondTextField": !_vm.isSecondTextField,
      "subHeading": "Enter the text you’d like to present on stage below.",
      "heading": "Share message to stage",
      "canOverlayPublished": _vm.overlayData.canOverlayPublished,
      "textField": _vm.overlay,
      "textFieldVal1": _vm.overlayData.overlayText,
      "isPresenting": _vm.overlayData.isOverlayPresented
    },
    on: {
      "submit": data => _vm.$emit('handleOverlayCtaClick', data)
    }
  }, 'BannersTabCard', _vm.$attrs, false)) : _vm._e(), _c('BannersTabCard', _vm._b({
    key: "1",
    class: _vm.$style.bannerCard,
    attrs: {
      "butonText": _vm.tickerData.tickerCtaText,
      "buttonIcon": "screen-share",
      "subHeading": "Enter the text you’d like to use for the ticker below. To turn the ticker into an hyperlink, enter a URL.",
      "heading": "Ticker",
      "isSecondTextField": _vm.isSecondTextField,
      "textField": _vm.tickerTextObj,
      "secondtextField": _vm.tickerUrlObj,
      "textFieldVal1": _vm.tickerData.tickerText,
      "textFieldVal2": _vm.tickerData.tickerUrl,
      "isPresenting": _vm.tickerData.isTickerPresented
    },
    on: {
      "submit": data => _vm.$emit('handleTickerCtaClick', data)
    }
  }, 'BannersTabCard', _vm.$attrs, false))], 1);
};
var SidebarBannersControlvue_type_template_id_0c5bf363_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarVideoProduction/BannersTabCard.vue?vue&type=template&id=b4bf7b92
var BannersTabCardvue_type_template_id_b4bf7b92_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: _vm.$style.heading,
    attrs: {
      "variant": "heading16",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.heading)) + " ")]), _c('StyledText', {
    class: _vm.$style.subHeading,
    attrs: {
      "variant": "subHeading14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.subHeading)) + " ")]), _c('form', {
    class: _vm.$style.form,
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit();
      }
    }
  }, [_vm.inputFieldType === 'textarea' ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.textField1,
      expression: "textField1"
    }],
    ref: "copyTextHolder",
    class: [_vm.$style.sidebrTextarea, _vm.isPresenting && _vm.$style.disabled],
    attrs: {
      "placeholder": _vm.$options.$t(_vm.textField.placeholder),
      "disabled": _vm.isPresenting,
      "theme": "dark"
    },
    domProps: {
      "value": _vm.textField1
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.textField1 = $event.target.value;
      }
    }
  }) : _c('SimpleInput', {
    attrs: {
      "disabled": _vm.isPresenting,
      "type": "text",
      "placeholder": _vm.$options.$t(_vm.textField.placeholder),
      "theme": "dark"
    },
    model: {
      value: _vm.textField1,
      callback: function ($$v) {
        _vm.textField1 = $$v;
      },
      expression: "textField1"
    }
  }), _vm.error.length > 0 ? _c('StyledText', {
    class: [_vm.$style.error, _vm.inputFieldType !== 'textarea' && _vm.$style.errorInput]
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm.isSecondTextField ? _c('SimpleInput', {
    class: _vm.$style.secondInputField,
    attrs: {
      "disabled": _vm.isPresenting,
      "type": "text",
      "placeholder": _vm.$options.$t(_vm.secondtextField.placeholder),
      "theme": "dark"
    },
    model: {
      value: _vm.textField2,
      callback: function ($$v) {
        _vm.textField2 = $$v;
      },
      expression: "textField2"
    }
  }) : _vm._e(), _vm.urlError ? _c('StyledText', {
    class: [_vm.$style.error, _vm.$style.errorInput]
  }, [_vm._v(_vm._s(_vm.urlError))]) : _vm._e()], 1), _c('div', {
    class: [_vm.$style.actionBar, _vm.actionDisabled && _vm.$style.disabled]
  }, [_c('PillButton', {
    attrs: {
      "icon": _vm.isPresenting ? _vm.$options.$t('stop-screen-share') : _vm.$options.$t('screen-share'),
      "disabled": _vm.actionDisabled,
      "uppercase": ""
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.butonText)) + " ")])], 1)], 1);
};
var BannersTabCardvue_type_template_id_b4bf7b92_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/utilFunction.js
const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const getMonthFromDate = (date, mode = 0) => {
  // mode: 0:FULLNAME/ 1:NUMBER/ 2:FIRST_THREE_CHAR
  const monthNum = date?.getMonth() ?? null;
  if (monthNum === null || mode === 1) {
    return monthNum;
  }
  if (mode === 0) {
    return monthNames[monthNum];
  }
  if (mode === 2) {
    return monthNames[monthNum].substring(0, 3);
  }
  return null;
};
const getDayFromDate = date => {
  const day = date?.getDate() ?? null;
  if (!day || day > 9) {
    return day;
  }
  return '0' + day;
};
const getAMPMFromDate = date => {
  var hours = date?.getHours();
  var minutes = date?.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var time = hours + ':' + minutes + ' ' + ampm;
  return time;
};
const urlValidation = text => {
  if (text) {
    const urlRegex =
    // eslint-disable-next-line no-useless-escape
    /((?:(?:http?|ftp)[s]*:\/\/)?[a-z0-9-%\/\&=?\.]+\.[a-z]{2,4}\/?([^\s<>\#%"\,\{\}\\|\\\^\[\]`]+)?)/gi;
    let res = text.match(urlRegex);
    if (res == null) {
      return 'please enter valid URL';
    }
    return false;
  }
  return false;
};
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarVideoProduction/BannersTabCard.vue?vue&type=script&lang=js

/* harmony default export */ var BannersTabCardvue_type_script_lang_js = ({
  name: 'BannersTabCard',
  data() {
    return {
      textField1: this.textFieldVal1 || '',
      textField2: this.textFieldVal2 || ''
    };
  },
  watch: {
    textFieldVal1(value) {
      this.textField1 = value;
    },
    textFieldVal2(value) {
      this.textField2 = value;
    }
  },
  props: {
    inputFieldType: {
      type: String,
      default: 'input'
    },
    canOverlayPublished: {
      type: Boolean,
      default: true
    },
    textFieldVal1: {
      type: String,
      default: ''
    },
    textFieldVal2: {
      type: String,
      default: ''
    },
    heading: {
      type: String,
      required: true
    },
    subHeading: {
      type: String,
      required: true
    },
    textField: {
      type: Object,
      required: true // placeholder,length
    },

    secondtextField: {
      type: Object
    },
    isSecondTextField: {
      type: Boolean,
      default: false
    },
    butonText: {
      type: String,
      default: 'SHARE'
    },
    isPresenting: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    error() {
      if (this.textField1?.length > this.textField.length) {
        return `${this.textField.length} characters limit`;
      }
      return false;
    },
    urlError() {
      if (this.isSecondTextField && this.textField2?.length) {
        return urlValidation(this.textField2);
      }
      return false;
    },
    actionDisabled() {
      return !!(!this.textField1?.length || this.error || this.urlError || !this.canOverlayPublished);
    }
  },
  methods: {
    onSubmit() {
      if (!this.actionDisabled) {
        this.$emit('submit', {
          tickerText: this.textField1,
          tickerUrl: this.textField2
        });
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/BannersTabCard.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarVideoProduction_BannersTabCardvue_type_script_lang_js = (BannersTabCardvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarVideoProduction/BannersTabCard.vue?vue&type=style&index=0&id=b4bf7b92&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var BannersTabCardvue_type_style_index_0_id_b4bf7b92_prod_module_true_lang_scss = ({"root":"BannersTabCard_root_CpbJV","sidebrTextarea":"BannersTabCard_sidebrTextarea_zC_Ar","heading":"BannersTabCard_heading_tqxTS","subHeading":"BannersTabCard_subHeading_AYMEu","form":"BannersTabCard_form_DpRs1","secondInputField":"BannersTabCard_secondInputField_oHTVh","actionBar":"BannersTabCard_actionBar_SlOvZ","buttonIcon":"BannersTabCard_buttonIcon_qu42W","highlightIcon":"BannersTabCard_highlightIcon_pcZw4","disabled":"BannersTabCard_disabled_vc7ho","error":"BannersTabCard_error_VKy3w","errorInput":"BannersTabCard_errorInput_ayIvS"});
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/BannersTabCard.vue?vue&type=style&index=0&id=b4bf7b92&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/BannersTabCard.vue



;




function BannersTabCard_injectStyles (context) {
  
  this["$style"] = (BannersTabCardvue_type_style_index_0_id_b4bf7b92_prod_module_true_lang_scss.locals || BannersTabCardvue_type_style_index_0_id_b4bf7b92_prod_module_true_lang_scss)

}

/* normalize component */

var BannersTabCard_component = normalizeComponent(
  SidebarVideoProduction_BannersTabCardvue_type_script_lang_js,
  BannersTabCardvue_type_template_id_b4bf7b92_render,
  BannersTabCardvue_type_template_id_b4bf7b92_staticRenderFns,
  false,
  BannersTabCard_injectStyles,
  null,
  null
  
)

/* harmony default export */ var BannersTabCard = (BannersTabCard_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarVideoProduction/SidebarBannersControl.vue?vue&type=script&lang=js

/* harmony default export */ var SidebarBannersControlvue_type_script_lang_js = ({
  components: {
    BannersTabCard: BannersTabCard
  },
  name: 'SidebarBannersControl',
  props: {
    showOverlayControlPanel: {
      type: Boolean,
      default: true
    },
    overlayData: {
      type: Object,
      default: () => {}
    },
    tickerData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isSecondTextField: true,
      overlay: {
        placeholder: 'Coffee Break! Be back in 10m.',
        length: 150
      },
      tickerTextObj: {
        placeholder: 'Enter Message',
        length: 50
      },
      tickerUrlObj: {
        placeholder: 'https://www.xyz.com',
        length: 150
      }
    };
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/SidebarBannersControl.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarVideoProduction_SidebarBannersControlvue_type_script_lang_js = (SidebarBannersControlvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarVideoProduction/SidebarBannersControl.vue?vue&type=style&index=0&id=0c5bf363&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarBannersControlvue_type_style_index_0_id_0c5bf363_prod_module_true_lang_scss = ({"root":"SidebarBannersControl_root_AYmji","bannerCard":"SidebarBannersControl_bannerCard_xpUVz"});
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/SidebarBannersControl.vue?vue&type=style&index=0&id=0c5bf363&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/SidebarBannersControl.vue



;




function SidebarBannersControl_injectStyles (context) {
  
  this["$style"] = (SidebarBannersControlvue_type_style_index_0_id_0c5bf363_prod_module_true_lang_scss.locals || SidebarBannersControlvue_type_style_index_0_id_0c5bf363_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarBannersControl_component = normalizeComponent(
  SidebarVideoProduction_SidebarBannersControlvue_type_script_lang_js,
  SidebarBannersControlvue_type_template_id_0c5bf363_render,
  SidebarBannersControlvue_type_template_id_0c5bf363_staticRenderFns,
  false,
  SidebarBannersControl_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarBannersControl = (SidebarBannersControl_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarAssetsTab.vue?vue&type=script&lang=js


/* harmony default export */ var SidebarAssetsTabvue_type_script_lang_js = ({
  components: {
    SidebarLogos: SidebarLogos,
    SidebarBannersControl: SidebarBannersControl
  },
  name: 'AssetsTab',
  props: {
    tabs: Array,
    currentTabId: String,
    // videos props
    videos: {
      type: Array,
      default() {
        return [];
      }
    },
    currentSelectedVideoID: {
      type: String,
      default: ''
    },
    // slides props
    slides: {
      type: Object,
      required: true
    },
    publishedStage: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentStageLogo: {
      type: Object,
      default: () => null
    },
    stageLogos: {
      type: Array,
      default: () => []
    },
    isLiveHybridBroadcast: {
      type: Boolean,
      default: false
    },
    liveModeVideoSelectorConfig: {
      type: Object,
      default() {
        return {
          idOfSelectedVideo: '',
          liveVideoRoomVideoPlaybackStartState: 'IDLE',
          isSwitchingToSpeakerMode: false,
          errorWhileSwitchingToSpeakerMode: false
        };
      }
    },
    usePdfConfigs: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarAssetsTab.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SidebarAssetsTabvue_type_script_lang_js = (SidebarAssetsTabvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarAssetsTab.vue?vue&type=style&index=0&id=217d7771&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarAssetsTabvue_type_style_index_0_id_217d7771_prod_module_true_lang_scss = ({"root":"SidebarAssetsTab_root_JHu9W","headerSwitchableTabs":"SidebarAssetsTab_headerSwitchableTabs_fdOyv","headerHolder":"SidebarAssetsTab_headerHolder_awIhX","clickableWidgetHeaderTabs":"SidebarAssetsTab_clickableWidgetHeaderTabs_eA3ZL","selected":"SidebarAssetsTab_selected_MbkKJ","overflowElips":"SidebarAssetsTab_overflowElips_fxwNi","divider":"SidebarAssetsTab_divider_flMYp"});
;// CONCATENATED MODULE: ./src/components/SidebarAssetsTab.vue?vue&type=style&index=0&id=217d7771&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarAssetsTab.vue



;




function SidebarAssetsTab_injectStyles (context) {
  
  this["$style"] = (SidebarAssetsTabvue_type_style_index_0_id_217d7771_prod_module_true_lang_scss.locals || SidebarAssetsTabvue_type_style_index_0_id_217d7771_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarAssetsTab_component = normalizeComponent(
  components_SidebarAssetsTabvue_type_script_lang_js,
  SidebarAssetsTabvue_type_template_id_217d7771_render,
  SidebarAssetsTabvue_type_template_id_217d7771_staticRenderFns,
  false,
  SidebarAssetsTab_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarAssetsTab = (SidebarAssetsTab_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SpeakerHandoffCard.vue?vue&type=template&id=2a118325&functional=true
var SpeakerHandoffCardvue_type_template_id_2a118325_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: [_vm.$style.root, !_vm.props.active && _vm.$style.checked]
  }, [_c('div', {
    class: [_vm.$style.heading, !_vm.props.active && _vm.$style.shift]
  }, [_c('StyledText', {
    class: [_vm.$style.title, !_vm.props.active && _vm.$style.shift]
  }, [_vm._v(" " + _vm._s(_vm.props.title) + " ")]), _vm.props.check ? _c('button', {
    class: _vm.$style.done,
    on: {
      "click": _vm.listeners.uncheck
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.tick,
    attrs: {
      "name": "tick",
      "size": "small"
    }
  })], 1) : _vm._e()], 1), _vm._t("default"), _c('div', {
    class: [_vm.$style.check, !_vm.props.active && _vm.$style.off, !_vm.props.allowConfirm && _vm.$style.disabled]
  }, [_c('TextButton', {
    class: _vm.$style.confirm,
    on: {
      "click": function ($event) {
        _vm.props.allowConfirm ? _vm.listeners.confirm(_vm.props.index) : () => {};
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('CONFIRM')) + " ")])], 1)], 2);
};
var SpeakerHandoffCardvue_type_template_id_2a118325_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SpeakerHandoffCard.vue?vue&type=script&lang=js
/* harmony default export */ var SpeakerHandoffCardvue_type_script_lang_js = ({
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    check: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: true
    },
    allowConfirm: {
      type: Boolean,
      default: true
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SpeakerHandoffCard.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SpeakerHandoffCardvue_type_script_lang_js = (SpeakerHandoffCardvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SpeakerHandoffCard.vue?vue&type=style&index=0&id=2a118325&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SpeakerHandoffCardvue_type_style_index_0_id_2a118325_prod_module_true_lang_scss = ({"root":"SpeakerHandoffCard_root_AtVve","heading":"SpeakerHandoffCard_heading_ioPNK","title":"SpeakerHandoffCard_title_y2L_g","shift":"SpeakerHandoffCard_shift_Cqk7B","confirm":"SpeakerHandoffCard_confirm_ipmdT","off":"SpeakerHandoffCard_off_h9xTn","done":"SpeakerHandoffCard_done_thWa3","tick":"SpeakerHandoffCard_tick_b6UUC","checked":"SpeakerHandoffCard_checked_NQuuy","disabled":"SpeakerHandoffCard_disabled_igYoU"});
;// CONCATENATED MODULE: ./src/components/SpeakerHandoffCard.vue?vue&type=style&index=0&id=2a118325&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SpeakerHandoffCard.vue



;




function SpeakerHandoffCard_injectStyles (context) {
  
  this["$style"] = (SpeakerHandoffCardvue_type_style_index_0_id_2a118325_prod_module_true_lang_scss.locals || SpeakerHandoffCardvue_type_style_index_0_id_2a118325_prod_module_true_lang_scss)

}

/* normalize component */

var SpeakerHandoffCard_component = normalizeComponent(
  components_SpeakerHandoffCardvue_type_script_lang_js,
  SpeakerHandoffCardvue_type_template_id_2a118325_functional_true_render,
  SpeakerHandoffCardvue_type_template_id_2a118325_functional_true_staticRenderFns,
  true,
  SpeakerHandoffCard_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SpeakerHandoffCard = (SpeakerHandoffCard_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSizeBlocker.vue?vue&type=template&id=57367a96&functional=true
var ScreenSizeBlockervue_type_template_id_57367a96_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: [_vm.$style.container, _vm.$style.parentContainer]
  }, [_c('div', {
    class: _vm.$style.image
  }, [_c('svg', {
    attrs: {
      "width": "38",
      "height": "37",
      "viewBox": "0 0 38 37",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0)"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M19.0467 25.3029C17.2755 25.3001 15.5776 24.5983 14.3253 23.3514C13.0729 22.1045 12.3683 20.4142 12.3659 18.6511C12.3679 16.8874 13.0726 15.1965 14.3253 13.9492C15.578 12.7019 17.2765 12.0001 19.0483 11.9977C20.8203 11.9997 22.5192 12.7013 23.7723 13.9486C25.0253 15.196 25.7302 16.8871 25.7322 18.6511C25.7298 20.4148 25.0247 22.1055 23.7717 23.3525C22.5187 24.5995 20.8201 25.3009 19.0483 25.3029H19.0467Z",
      "fill": "#4285F4"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M21.8645 26.4869C20.4705 26.9904 18.9688 27.1236 17.5074 26.8732C16.046 26.6228 14.6754 25.9975 13.5308 25.059C12.2969 24.0459 11.3746 22.7073 10.8696 21.1965L10.8665 21.1873L3.50103 8.49103C0.859638 12.5142 -0.0893106 17.409 0.858425 22.1217C1.32383 24.5024 2.25893 26.7677 3.60963 28.7863C4.96033 30.805 6.69979 32.5369 8.72736 33.8819C10.8562 35.3065 13.2605 36.2728 15.7862 36.7191L21.8645 26.4884V26.4869Z",
      "fill": "#4AAE48"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M35.7578 10.3354C34.3645 7.54526 32.2903 5.1476 29.7251 3.36198C27.1599 1.57636 24.1857 0.459843 21.0748 0.114658C17.9639 -0.230528 14.8157 0.206648 11.9184 1.38616C9.02119 2.56567 6.4675 4.44982 4.49117 6.8661L10.712 17.5917C10.968 15.6059 11.9352 13.7786 13.436 12.4456C14.9367 11.1126 16.8703 10.3633 18.8814 10.3354H35.7578Z",
      "fill": "#EA3939"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M18.9757 37C23.6382 37 28.1009 35.2592 31.5381 32.0998C34.9885 28.9366 37.1016 24.5858 37.4491 19.9293C37.6491 17.2335 37.2558 14.5266 36.2966 11.9977H24.1277C25.1415 12.796 25.9597 13.8132 26.5206 14.9725C27.0814 16.1318 27.3702 17.4029 27.3651 18.6896C27.3528 20.5815 26.7087 22.4155 25.5342 23.9029L17.7768 36.963C18.1764 36.9877 18.5791 37 18.9757 37Z",
      "fill": "#FED14B"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0"
    }
  }, [_c('rect', {
    attrs: {
      "width": "37",
      "height": "37",
      "fill": "white",
      "transform": "translate(0.5)"
    }
  })])])])]), _c('div', {
    class: _vm.$style.container
  }, [_c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Please use a desktop or laptop Google Chrome browser to access your conference')) + " ")]), _c('StyledText', {
    class: _vm.$style.subTitle,
    attrs: {
      "variant": "body14",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('If on Desktop')) + ": "), _c('br'), _vm._v(" " + _vm._s(_vm.$options.$t('Please increase the width of your window')) + " ")]), _vm.props.event && _vm.props.event.mobile_link_url ? [_c('hr', {
    class: _vm.$style.line
  }), _c('StyledText', {
    class: _vm.$style.link,
    attrs: {
      "variant": "body14",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Alternatively, check out the')) + " "), _c('a', {
    class: _vm.$style.link,
    attrs: {
      "href": _vm.props.event.mobile_link_url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/staticassets.goldcast.com/img/youtube.svg",
      "alt": "youtube logo"
    }
  }), _vm._v(" " + _vm._s(_vm.$options.$t('Youtube Livestream')) + " "), _c('SvgIcon', {
    attrs: {
      "name": "open-in-new"
    }
  })], 1)])] : _vm._e(), _c('PoweredBy')], 2)])]);
};
var ScreenSizeBlockervue_type_template_id_57367a96_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSizeBlocker.vue?vue&type=script&lang=js
/* harmony default export */ var ScreenSizeBlockervue_type_script_lang_js = ({
  name: 'ScreenSizeBlocker',
  functional: true,
  props: {
    event: {
      type: Object,
      default: null
    }
  }
});
;// CONCATENATED MODULE: ./src/components/ScreenSizeBlocker.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ScreenSizeBlockervue_type_script_lang_js = (ScreenSizeBlockervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-11.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/ScreenSizeBlocker.vue?vue&type=style&index=0&id=57367a96&prod&module=true&lang=css
// extracted by mini-css-extract-plugin
/* harmony default export */ var ScreenSizeBlockervue_type_style_index_0_id_57367a96_prod_module_true_lang_css = ({"root":"ScreenSizeBlocker_root_bfe_G","container":"ScreenSizeBlocker_container_Hndiw","image":"ScreenSizeBlocker_image_oXAxM","title":"ScreenSizeBlocker_title_fIQ9d","logo":"ScreenSizeBlocker_logo_GDtW8","link":"ScreenSizeBlocker_link_xrUOU","line":"ScreenSizeBlocker_line_anzbG","parentContainer":"ScreenSizeBlocker_parentContainer_HhezN"});
;// CONCATENATED MODULE: ./src/components/ScreenSizeBlocker.vue?vue&type=style&index=0&id=57367a96&prod&module=true&lang=css
 
;// CONCATENATED MODULE: ./src/components/ScreenSizeBlocker.vue



;




function ScreenSizeBlocker_injectStyles (context) {
  
  this["$style"] = (ScreenSizeBlockervue_type_style_index_0_id_57367a96_prod_module_true_lang_css.locals || ScreenSizeBlockervue_type_style_index_0_id_57367a96_prod_module_true_lang_css)

}

/* normalize component */

var ScreenSizeBlocker_component = normalizeComponent(
  components_ScreenSizeBlockervue_type_script_lang_js,
  ScreenSizeBlockervue_type_template_id_57367a96_functional_true_render,
  ScreenSizeBlockervue_type_template_id_57367a96_functional_true_staticRenderFns,
  true,
  ScreenSizeBlocker_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ScreenSizeBlocker = (ScreenSizeBlocker_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SimpleScreenBlocker.vue?vue&type=template&id=0e8ea9e5&scoped=true&functional=true
var SimpleScreenBlockervue_type_template_id_0e8ea9e5_scoped_true_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.props.icon ? _c('SvgIcon', {
    attrs: {
      "name": _vm.props.icon,
      "size": "large",
      "color": "theme-secondary-color"
    }
  }) : _vm._e(), _vm.props.title ? _c('StyledText', {
    attrs: {
      "variant": "heading26",
      "color": "theme-secondary-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.title) + " ")]) : _vm._e(), _vm.props.text ? _c('StyledText', {
    attrs: {
      "variant": "body20",
      "color": "primary-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.text) + " ")]) : _vm._e(), _vm.props.cta ? _c('PillButton', {
    attrs: {
      "center": ""
    },
    on: {
      "click": _vm.listeners.onCtaClick
    }
  }, [_vm._v(_vm._s(_vm.props.cta))]) : _vm._e()], 1);
};
var SimpleScreenBlockervue_type_template_id_0e8ea9e5_scoped_true_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SimpleScreenBlocker.vue?vue&type=script&lang=js
/* harmony default export */ var SimpleScreenBlockervue_type_script_lang_js = ({
  name: 'SimpleScreenBlocker',
  functional: true,
  props: {
    icon: String,
    title: String,
    text: String,
    cta: String
  }
});
;// CONCATENATED MODULE: ./src/components/SimpleScreenBlocker.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SimpleScreenBlockervue_type_script_lang_js = (SimpleScreenBlockervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SimpleScreenBlocker.vue?vue&type=style&index=0&id=0e8ea9e5&prod&module=true&scoped=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SimpleScreenBlockervue_type_style_index_0_id_0e8ea9e5_prod_module_true_scoped_true_lang_scss = ({"root":"SimpleScreenBlocker_root_lsUSC"});
;// CONCATENATED MODULE: ./src/components/SimpleScreenBlocker.vue?vue&type=style&index=0&id=0e8ea9e5&prod&module=true&scoped=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SimpleScreenBlocker.vue



;




function SimpleScreenBlocker_injectStyles (context) {
  
  this["$style"] = (SimpleScreenBlockervue_type_style_index_0_id_0e8ea9e5_prod_module_true_scoped_true_lang_scss.locals || SimpleScreenBlockervue_type_style_index_0_id_0e8ea9e5_prod_module_true_scoped_true_lang_scss)

}

/* normalize component */

var SimpleScreenBlocker_component = normalizeComponent(
  components_SimpleScreenBlockervue_type_script_lang_js,
  SimpleScreenBlockervue_type_template_id_0e8ea9e5_scoped_true_functional_true_render,
  SimpleScreenBlockervue_type_template_id_0e8ea9e5_scoped_true_functional_true_staticRenderFns,
  true,
  SimpleScreenBlocker_injectStyles,
  "0e8ea9e5",
  null
  
)

/* harmony default export */ var SimpleScreenBlocker = (SimpleScreenBlocker_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/RotationBlocker.vue?vue&type=template&id=32d152b5&functional=true
var RotationBlockervue_type_template_id_32d152b5_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: [_vm.$style.root, _vm.props.fullScreen && _vm.$style.landscape]
  }, [_c('div', {
    class: _vm.$style.device
  }), _c('StyledText', {
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Please rotate your device to {mode} mode', {
    mode: _vm.props.fullScreen ? _vm.$options.$t('landscape') : _vm.$options.$t('portrait')
  })) + " ")])], 1);
};
var RotationBlockervue_type_template_id_32d152b5_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/RotationBlocker.vue?vue&type=script&lang=js

/* harmony default export */ var RotationBlockervue_type_script_lang_js = ({
  components: {
    StyledText: StyledText
  },
  name: 'RotationBlocker',
  functional: true,
  props: {
    fullScreen: Boolean
  }
});
;// CONCATENATED MODULE: ./src/components/RotationBlocker.vue?vue&type=script&lang=js
 /* harmony default export */ var components_RotationBlockervue_type_script_lang_js = (RotationBlockervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/RotationBlocker.vue?vue&type=style&index=0&id=32d152b5&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var RotationBlockervue_type_style_index_0_id_32d152b5_prod_module_true_lang_scss = ({"root":"RotationBlocker_root_l9J3O","device":"RotationBlocker_device_XBxIr","landscape":"RotationBlocker_landscape_yUa8j"});
;// CONCATENATED MODULE: ./src/components/RotationBlocker.vue?vue&type=style&index=0&id=32d152b5&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/RotationBlocker.vue



;




function RotationBlocker_injectStyles (context) {
  
  this["$style"] = (RotationBlockervue_type_style_index_0_id_32d152b5_prod_module_true_lang_scss.locals || RotationBlockervue_type_style_index_0_id_32d152b5_prod_module_true_lang_scss)

}

/* normalize component */

var RotationBlocker_component = normalizeComponent(
  components_RotationBlockervue_type_script_lang_js,
  RotationBlockervue_type_template_id_32d152b5_functional_true_render,
  RotationBlockervue_type_template_id_32d152b5_functional_true_staticRenderFns,
  true,
  RotationBlocker_injectStyles,
  null,
  null
  
)

/* harmony default export */ var RotationBlocker = (RotationBlocker_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ErrorPage_403.vue?vue&type=template&id=22694360
var ErrorPage_403vue_type_template_id_22694360_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('svg', {
    class: _vm.$style.star,
    attrs: {
      "width": "30",
      "height": "29",
      "viewBox": "0 0 30 29",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.2594 19.5933H15.8677V15.207H19.9156V13.647H15.8677V9.26071H14.2594V13.647H10.2628V15.207H14.2594V19.5933Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.80008 25.9296H8.16491V22.0302H11.7718V20.8116H8.16491V16.864H6.80008V20.8116H3.19318V22.0302H6.80008V25.9296Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M21.9588 11.8417H23.3237V7.94475H26.9789V6.77447H23.3237V2.82681H21.9588V6.77447H18.3519V7.94475H21.9588V11.8417Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.503 28.9999H15.6726V26.2207H18.1588V25.1984H15.6726V22.4192H14.503V25.1984H12.0663V26.2207H14.503V28.9999Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.84902 11.8417H8.11778V7.89581H11.7736V6.77447H8.11355V2.82681H6.84479V6.77447H3.19318V7.89581H6.84902V11.8417Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M25.922 17.6923H27.0917V14.9626H29.5639V13.8908H27.0917V11.1612H25.922V13.8908H23.4854V14.9626H25.922V17.6923Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M21.9588 25.9296H23.3237V22.0302H26.9789V20.8116H23.3237V16.864H21.9588V20.8116H18.3519V22.0302H21.9588V25.9296Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.1452 3.50903V2.68071H15.708V0H14.8308V2.68071H12.3941V3.50903H14.8308V6.18974H15.708V3.50903H18.1452ZM2.98718 17.4974H3.86443V14.8167H6.30347V13.9884H3.86443V11.3584H2.98718V13.9902H0.563843V14.8675L2.98718 14.8626V17.4974Z",
      "fill": "#2400FF"
    }
  })]), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "heading30",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.errorPageData.errorMessage)) + " ")]), _vm.errorPageData.showButton ? _c('SimpleButton', {
    class: _vm.$style.redirect_button,
    on: {
      "click": function ($event) {
        return _vm.$emit('go-to-userhome');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.errorPageData.buttonText).toUpperCase()) + " ")]) : _vm._e(), _c('svg', {
    class: _vm.$style.bottom_left,
    attrs: {
      "viewBox": "0 0 580 535",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M528.329 437.196C528.556 428.723 528.016 410.169 521.54 391.312C502.273 335.196 457.166 297.159 403.964 254.718C355.285 215.883 369.284 196.325 324.037 147.376C310.157 132.351 263.615 86.7261 200.439 80.2175C126.492 72.5864 41.1142 104.698 9.40244 178.138C-19.136 244.216 10.2767 276.543 -21.91 353.826C-37.8414 392.068 -71.075 412.36 -77.5728 447.342C-82.4947 473.851 -76.4395 496.755 -67.6319 510.042C-51.3874 534.544 -12.962 539.347 6.00244 539.347C143.449 539.347 272.552 539.725 409.998 539.919C415.384 540.394 471.986 544.485 505.436 503.912C527.26 477.435 528.113 445.432 528.329 437.196Z",
      "fill": "#2400FF",
      "fill-opacity": "0.1"
    }
  }), _c('path', {
    attrs: {
      "d": "M440.871 537.67C215.348 537.616 2.17372 518.932 156.631 492.757C156.631 492.757 253.094 477.711 307.04 496.427C315.719 499.439 327.71 504.296 350.517 511.905C388.274 524.501 419.78 532.672 440.871 537.67Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M440.871 537.67C215.348 537.616 2.17372 518.932 156.631 492.757C156.631 492.757 253.094 477.711 307.04 496.427C315.719 499.439 327.71 504.296 350.517 511.905C388.274 524.501 419.78 532.672 440.871 537.67Z",
      "fill": "black",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M207.782 306.548L241.728 293.93C263.402 285.878 278.027 265.489 278.707 242.38L281.621 140.175C282.01 126.467 271 115.134 257.292 115.134C243.93 115.134 233.071 125.906 232.953 139.257L232.219 221.3C232.1 234.285 225.257 246.277 214.129 252.99L204.252 258.948L207.782 306.548Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M151.945 200.151L127.022 190.89C111.112 184.975 100.373 170.004 99.8655 153.036L97.7283 77.9989C97.4369 67.9284 105.521 59.6173 115.592 59.6173C125.403 59.6173 133.38 67.5183 133.466 77.3297L134.006 137.558C134.092 147.089 139.122 155.897 147.282 160.819L154.535 165.19L151.945 200.151Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "opacity": "0.5",
      "d": "M151.945 200.151L127.022 190.89C111.112 184.975 100.373 170.004 99.8655 153.036L97.7283 77.9989C97.4369 67.9284 105.521 59.6173 115.592 59.6173C125.403 59.6173 133.38 67.5183 133.466 77.3297L134.006 137.558C134.092 147.089 139.122 155.897 147.282 160.819L154.535 165.19L151.945 200.151Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M155.292 372.091L145.092 367.569C129.096 360.477 118.777 344.621 118.777 327.125V229.604C118.777 214.104 106.213 201.541 90.7136 201.541C74.9333 201.541 62.2616 214.547 62.6609 230.316L65.7911 352.76C66.4603 379.129 83.3524 402.346 108.232 411.11L155.292 427.678V372.091Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "opacity": "0.5",
      "d": "M155.292 372.091L145.092 367.569C129.096 360.477 118.777 344.621 118.777 327.125V229.604C118.777 214.104 106.213 201.541 90.7136 201.541C74.9333 201.541 62.2616 214.547 62.6609 230.316L65.7911 352.76C66.4603 379.129 83.3524 402.346 108.232 411.11L155.292 427.678V372.091Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M150.553 400.265L123.86 388.381C104.636 379.822 92.1697 360.836 91.9754 339.788L90.8097 200.615L85.877 204.878C79.7786 210.156 76.3246 217.874 76.4541 225.937L78.343 345.897C78.6884 368.068 91.7919 388.057 111.987 397.221L151.621 415.236",
      "stroke": "white",
      "stroke-width": "2.17806",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M90.8093 200.629L97.8036 206.911C102.434 211.066 105.089 216.981 105.133 223.209L105.748 331.394C105.866 352.064 117.966 370.801 136.758 379.404L152.495 386.614",
      "stroke": "white",
      "stroke-width": "2.17806",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M154.493 182.747L136.662 173.831C124.54 167.765 116.812 155.45 116.639 141.893L115.592 59.6451L113.552 61.0158C108.879 64.1676 106.094 69.4457 106.137 75.0908L106.731 145.368C106.871 160.587 115.452 174.457 129.009 181.376L152.744 193.476",
      "stroke": "white",
      "stroke-width": "2.17806",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M115.591 59.6335L117.988 61.695C122.672 65.7211 125.36 71.5928 125.36 77.7668V136.063C125.36 148.487 131.771 160.036 142.306 166.609L152.786 173.14",
      "stroke": "white",
      "stroke-width": "2.17806",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M209.162 280.843L233.178 269.067C246.81 262.386 255.531 248.602 255.736 233.427L257.301 115.139L252.563 118.172C247.641 121.313 244.641 126.721 244.565 132.56L243.345 232.11C243.216 243.065 237.161 253.093 227.533 258.328L206.949 269.499",
      "stroke": "white",
      "stroke-width": "2.17806",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M257.303 115.139L260.8 118.054C266.585 122.868 269.899 130.045 269.802 137.579L268.496 239.655C268.259 258.08 256.839 274.497 239.645 281.124L209.088 292.9",
      "stroke": "white",
      "stroke-width": "2.17806",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M178.854 30.3444C162.124 30.3444 148.524 43.8256 148.373 60.5558L144.174 535.39H221.953L209.325 60.0269C208.882 43.5018 195.369 30.3444 178.854 30.3444Z",
      "fill": "#9DC9B2"
    }
  }), _c('path', {
    attrs: {
      "d": "M178.854 30.3444C162.124 30.3444 148.524 43.8256 148.373 60.5558L144.174 535.39H221.953L209.325 60.0269C208.882 43.5018 195.369 30.3444 178.854 30.3444Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M184.996 535.401L178.855 30.3443L186.302 37.2414C191.818 42.3468 195.002 49.4814 195.132 56.9938L203.313 535.412",
      "stroke": "white",
      "stroke-width": "2.17806",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M178.854 30.3448L171.903 36.821C166.301 42.0451 163.127 49.3524 163.138 57.0159L163.818 536.222",
      "stroke": "white",
      "stroke-width": "2.17806",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M31.006 475.218C31.006 475.218 29.1171 498.187 1.48534 523.185H-4.17053C-4.15974 523.196 9.23518 496.891 31.006 475.218Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M31.006 475.218C31.006 475.218 29.1171 498.187 1.48534 523.185H-4.17053C-4.15974 523.196 9.23518 496.891 31.006 475.218Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M-0.877832 462.212C-0.877832 462.212 11.4701 493.956 -2.71276 523.196H-12.0601C-12.0601 523.196 -2.38894 488.646 -0.877832 462.212Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M-0.877832 462.212C-0.877832 462.212 11.4701 493.956 -2.71276 523.196H-12.0601C-12.0601 523.196 -2.38894 488.646 -0.877832 462.212Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M1.49652 523.2C2.67303 523.168 4.31367 523.146 6.25653 522.488C12.0419 520.513 16.586 516.055 25.0699 502.217C27.6603 497.997 30.8337 492.525 34.1473 485.973C30.0889 488.974 25.8362 492.568 21.508 496.734C14.5784 503.426 6.40763 512.731 1.49652 523.2Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M1.49652 523.2C2.67303 523.168 4.31367 523.146 6.25653 522.488C12.0419 520.513 16.586 516.055 25.0699 502.217C27.6603 497.997 30.8337 492.525 34.1473 485.973C30.0889 488.974 25.8362 492.568 21.508 496.734C14.5784 503.426 6.40763 512.731 1.49652 523.2Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.4701 452.626C14.4701 452.626 24.098 499.298 1.49611 523.195H-7.71088C-7.71088 523.195 0.449131 497.636 7.77802 475.228C15.0961 452.81 14.4701 452.626 14.4701 452.626Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.4701 452.626C14.4701 452.626 24.098 499.298 1.49611 523.195H-7.71088C-7.71088 523.195 0.449131 497.636 7.77802 475.228C15.0961 452.81 14.4701 452.626 14.4701 452.626Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M24.7759 493.68C30.3886 482.67 31.0038 475.223 31.0038 475.223C25.0133 481.192 19.6489 487.506 15.0292 493.529C18.5263 473.517 14.7162 453.884 14.4787 452.696C14.4895 453.074 14.1225 455.805 7.76505 475.233C6.50219 479.098 5.21775 483.048 3.95489 486.945C3.14537 472.589 -0.891457 462.216 -0.891457 462.216C-1.38796 470.873 -2.74797 480.404 -4.37781 489.308C-5.0686 480.986 -6.16955 473.442 -7.23812 469.308C-9.90415 458.967 -10.4115 450.106 -10.4115 450.106C-14.2432 460.845 -16.0457 472.395 -16.7365 483.07C-18.7873 475.352 -19.4242 463.393 -19.4242 463.393C-23.8711 473.42 -25.6953 482.972 -26.0838 491.392C-34.2546 477.338 -42.6197 462.659 -42.6197 462.659C-42.4254 475.244 -40.5905 485.628 -38.0972 494.047C-41.9829 488.887 -46.6781 483.545 -52.2908 478.461C-52.2908 478.461 -39.36 523.2 -22.0794 523.2H-20.741H-17.4057H-14.9016H-13.2286H-12.0629H-7.71304H-5.38161H-4.15113H-2.71559H1.49394C2.67045 523.168 4.31109 523.146 6.25394 522.488C12.0393 520.513 16.5835 516.055 25.0673 502.218C27.6578 497.997 30.8311 492.525 34.1447 485.973C31.1117 488.207 27.9708 490.787 24.7759 493.68Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M24.7759 493.68C30.3886 482.67 31.0038 475.223 31.0038 475.223C25.0133 481.192 19.6489 487.506 15.0292 493.529C18.5263 473.517 14.7162 453.884 14.4787 452.696C14.4895 453.074 14.1225 455.805 7.76505 475.233C6.50219 479.098 5.21775 483.048 3.95489 486.945C3.14537 472.589 -0.891457 462.216 -0.891457 462.216C-1.38796 470.873 -2.74797 480.404 -4.37781 489.308C-5.0686 480.986 -6.16955 473.442 -7.23812 469.308C-9.90415 458.967 -10.4115 450.106 -10.4115 450.106C-14.2432 460.845 -16.0457 472.395 -16.7365 483.07C-18.7873 475.352 -19.4242 463.393 -19.4242 463.393C-23.8711 473.42 -25.6953 482.972 -26.0838 491.392C-34.2546 477.338 -42.6197 462.659 -42.6197 462.659C-42.4254 475.244 -40.5905 485.628 -38.0972 494.047C-41.9829 488.887 -46.6781 483.545 -52.2908 478.461C-52.2908 478.461 -39.36 523.2 -22.0794 523.2H-20.741H-17.4057H-14.9016H-13.2286H-12.0629H-7.71304H-5.38161H-4.15113H-2.71559H1.49394C2.67045 523.168 4.31109 523.146 6.25394 522.488C12.0393 520.513 16.5835 516.055 25.0673 502.218C27.6578 497.997 30.8311 492.525 34.1447 485.973C31.1117 488.207 27.9708 490.787 24.7759 493.68Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.4689 452.626C14.4689 452.626 14.4689 452.647 14.4794 452.689C14.4794 452.626 14.4689 452.626 14.4689 452.626Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.4689 452.626C14.4689 452.626 14.4689 452.647 14.4794 452.689C14.4794 452.626 14.4689 452.626 14.4689 452.626Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M580 537.666H277.875C277.875 537.666 307.579 520.277 347.429 525.35C387.279 530.423 404.668 505.069 445.241 504.335C485.815 503.612 505.373 523.893 535.811 526.073C566.238 528.254 580 537.666 580 537.666Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M580 537.666H277.875C277.875 537.666 307.579 520.277 347.429 525.35C387.279 530.423 404.668 505.069 445.241 504.335C485.815 503.612 505.373 523.893 535.811 526.073C566.238 528.254 580 537.666 580 537.666Z",
      "fill": "black",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M268.139 444.339C268.139 444.339 295.727 537.661 332.588 537.661C332.588 537.661 315.858 486.542 268.139 444.339Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M268.139 444.339C268.139 444.339 295.727 537.661 332.588 537.661C332.588 537.661 315.858 486.542 268.139 444.339Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M445.845 437.604C445.845 437.604 441.83 485.506 382.875 537.661H370.818C370.818 537.661 399.4 482.807 445.845 437.604Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M445.845 437.604C445.845 437.604 441.83 485.506 382.875 537.661H370.818C370.818 537.661 399.4 482.807 445.845 437.604Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M377.814 410.47C377.814 410.47 404.161 476.689 373.896 537.673H353.96C353.949 537.662 374.608 465.593 377.814 410.47Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M377.814 410.47C377.814 410.47 404.161 476.689 373.896 537.673H353.96C353.949 537.662 374.608 465.593 377.814 410.47Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M357.509 385.213C357.509 385.213 358.578 403.692 364.277 425.257C369.976 446.823 376.031 512.416 368.195 537.673H347.903C347.903 537.662 332.587 453.58 357.509 385.213Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M357.509 385.213C357.509 385.213 358.578 403.692 364.277 425.257C369.976 446.823 376.031 512.416 368.195 537.673H347.903C347.903 537.662 332.587 453.58 357.509 385.213Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M288.799 411.385C288.799 411.385 308.378 444.953 326.544 475.445C344.71 505.937 342.562 537.66 342.562 537.66H332.589C332.589 537.66 290.213 501.317 288.799 411.385Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M288.799 411.385C288.799 411.385 308.378 444.953 326.544 475.445C344.71 505.937 342.562 537.66 342.562 537.66H332.589C332.589 537.66 290.213 501.317 288.799 411.385Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M338.287 412.929C338.287 412.929 339.711 439.104 344.342 455.122C348.972 471.139 359.291 504.092 351.466 537.661H335.448C335.437 537.661 307.665 480.379 338.287 412.929Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M338.287 412.929C338.287 412.929 339.711 439.104 344.342 455.122C348.972 471.139 359.291 504.092 351.466 537.661H335.448C335.437 537.661 307.665 480.379 338.287 412.929Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M382.874 537.66C385.389 537.595 388.897 537.552 393.02 536.17C405.357 532.047 415.061 522.743 433.172 493.892C438.699 485.084 445.455 473.675 452.547 460.01C443.89 466.271 434.813 473.761 425.584 482.461C410.786 496.428 393.365 515.835 382.874 537.66Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M382.874 537.66C385.389 537.595 388.897 537.552 393.02 536.17C405.357 532.047 415.061 522.743 433.172 493.892C438.699 485.084 445.455 473.675 452.547 460.01C443.89 466.271 434.813 473.761 425.584 482.461C410.786 496.428 393.365 515.835 382.874 537.66Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M410.561 390.481C410.561 390.481 431.101 487.829 382.875 537.674H363.22C363.22 537.674 380.641 484.364 396.27 437.617C411.91 390.869 410.561 390.481 410.561 390.481Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M410.561 390.481C410.561 390.481 431.101 487.829 382.875 537.674H363.22C363.22 537.674 380.641 484.364 396.27 437.617C411.91 390.869 410.561 390.481 410.561 390.481Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M432.548 476.115C444.529 453.146 445.846 437.625 445.846 437.625C433.055 450.07 421.625 463.238 411.77 475.802C419.229 434.052 411.09 393.101 410.583 390.629C410.615 391.428 409.817 397.105 396.26 437.625C393.572 445.677 390.82 453.923 388.121 462.051C386.394 432.12 377.792 410.479 377.792 410.479C376.745 428.537 373.82 448.419 370.366 466.984C368.887 449.627 366.545 433.901 364.268 425.255C358.568 403.7 357.5 385.211 357.5 385.211C349.329 407.619 345.487 431.71 344.008 453.966C339.636 437.884 338.276 412.929 338.276 412.929C328.789 433.836 324.903 453.772 324.072 471.323C306.651 442.007 288.787 411.385 288.787 411.385C289.208 437.625 293.105 459.299 298.426 476.849C290.126 466.088 280.109 454.938 268.139 444.349C268.139 444.349 295.728 537.671 332.588 537.671H335.438H342.561H347.904H351.466H353.96H363.231H368.196H370.819H373.895H382.876C385.391 537.606 388.899 537.563 393.022 536.182C405.359 532.059 415.062 522.754 433.174 493.903C438.701 485.095 445.457 473.686 452.549 460.022C446.083 464.695 439.381 470.071 432.548 476.115Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M432.548 476.115C444.529 453.146 445.846 437.625 445.846 437.625C433.055 450.07 421.625 463.238 411.77 475.802C419.229 434.052 411.09 393.101 410.583 390.629C410.615 391.428 409.817 397.105 396.26 437.625C393.572 445.677 390.82 453.923 388.121 462.051C386.394 432.12 377.792 410.479 377.792 410.479C376.745 428.537 373.82 448.419 370.366 466.984C368.887 449.627 366.545 433.901 364.268 425.255C358.568 403.7 357.5 385.211 357.5 385.211C349.329 407.619 345.487 431.71 344.008 453.966C339.636 437.884 338.276 412.929 338.276 412.929C328.789 433.836 324.903 453.772 324.072 471.323C306.651 442.007 288.787 411.385 288.787 411.385C289.208 437.625 293.105 459.299 298.426 476.849C290.126 466.088 280.109 454.938 268.139 444.349C268.139 444.349 295.728 537.671 332.588 537.671H335.438H342.561H347.904H351.466H353.96H363.231H368.196H370.819H373.895H382.876C385.391 537.606 388.899 537.563 393.022 536.182C405.359 532.059 415.062 522.754 433.174 493.903C438.701 485.095 445.457 473.686 452.549 460.022C446.083 464.695 439.381 470.071 432.548 476.115Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M410.561 390.482C410.561 390.482 410.571 390.536 410.593 390.612C410.593 390.493 410.561 390.482 410.561 390.482Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M410.561 390.482C410.561 390.482 410.571 390.536 410.593 390.612C410.593 390.493 410.561 390.482 410.561 390.482Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M401.667 537.67H-134C-134 537.67 -88.494 521.166 -39.48 522.666C9.53401 524.167 39.4972 489.659 102.737 482.147C165.977 474.645 234.819 506.821 278.22 518.165C319.916 529.056 401.667 537.67 401.667 537.67Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M401.667 537.67H-134C-134 537.67 -88.494 521.166 -39.48 522.666C9.53401 524.167 39.4972 489.659 102.737 482.147C165.977 474.645 234.819 506.821 278.22 518.165C319.916 529.056 401.667 537.67 401.667 537.67Z",
      "fill": "black",
      "fill-opacity": "0.15"
    }
  })]), _c('svg', {
    class: _vm.$style.bottom_right,
    attrs: {
      "viewBox": "0 0 437 278",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M31.6254 267.584C31.4867 262.398 31.817 251.042 35.7807 239.501C47.5727 205.156 75.1801 181.875 107.742 155.9C137.536 132.131 128.968 120.16 156.661 90.2011C165.157 81.0053 193.642 53.0809 232.309 49.0973C277.568 44.4268 329.823 64.0802 349.232 109.029C366.698 149.472 348.697 169.257 368.396 216.558C378.147 239.964 398.487 252.383 402.464 273.794C405.477 290.019 401.771 304.037 396.38 312.169C386.438 327.165 362.92 330.105 351.313 330.105C267.189 330.105 188.172 330.336 104.049 330.455C100.753 330.746 66.1098 333.25 45.6371 308.417C32.2794 292.212 31.7575 272.625 31.6254 267.584Z",
      "fill": "#2400FF",
      "fill-opacity": "0.1"
    }
  }), _c('path', {
    attrs: {
      "d": "M397.49 227.75C402.551 227.181 407.366 222.081 407.829 215.158C408.727 201.701 392.483 187.108 386.187 171.888C381.318 160.122 377.064 155.986 373.926 157.149C372.743 157.585 370.544 158.398 370.141 167.765C368.965 194.732 384.925 229.157 397.49 227.75Z",
      "fill": "#2400FF",
      "fill-opacity": "0.03"
    }
  }), _c('path', {
    attrs: {
      "d": "M85.1532 280.996C223.183 280.963 353.656 269.528 259.121 253.508C259.121 253.508 200.081 244.299 167.063 255.754C161.752 257.597 154.413 260.57 140.454 265.227C117.345 272.937 98.0617 277.938 85.1532 280.996Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M85.1532 280.996C223.183 280.963 353.656 269.528 259.121 253.508C259.121 253.508 200.081 244.299 167.063 255.754C161.752 257.597 154.413 260.57 140.454 265.227C117.345 272.937 98.0617 277.938 85.1532 280.996Z",
      "fill": "black",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M227.814 187.623L207.038 179.9C193.773 174.972 184.821 162.493 184.405 148.349L182.621 85.7947C182.383 77.4049 189.122 70.4684 197.512 70.4684C205.69 70.4684 212.336 77.0613 212.409 85.2332L212.858 135.447C212.931 143.394 217.119 150.734 223.93 154.843L229.975 158.489L227.814 187.623Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M261.989 122.503L277.243 116.835C286.98 113.215 293.553 104.052 293.864 93.667L295.172 47.7407C295.35 41.5771 290.402 36.4903 284.239 36.4903C278.233 36.4903 273.351 41.326 273.299 47.3311L272.968 84.1937C272.915 90.0269 269.837 95.4176 264.843 98.43L260.403 101.106L261.989 122.503Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "opacity": "0.5",
      "d": "M261.989 122.503L277.243 116.835C286.98 113.215 293.553 104.052 293.864 93.667L295.172 47.7407C295.35 41.5771 290.402 36.4903 284.239 36.4903C278.233 36.4903 273.351 41.326 273.299 47.3311L272.968 84.1937C272.915 90.0269 269.837 95.4176 264.843 98.43L260.403 101.106L261.989 122.503Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M260.429 111.851L271.343 106.394C278.762 102.681 283.492 95.1438 283.597 86.8464L284.238 36.5072L285.487 37.3462C288.347 39.2752 290.052 42.5056 290.025 45.9607L289.662 88.9736C289.576 98.2884 284.324 106.777 276.027 111.012L261.5 118.417",
      "stroke": "white",
      "stroke-width": "1.33307",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M284.239 36.4998L282.772 37.7616C279.905 40.2257 278.26 43.8195 278.26 47.5982V83.2783C278.26 90.882 274.336 97.9507 267.888 101.974L261.474 105.971",
      "stroke": "white",
      "stroke-width": "1.33307",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M226.969 171.89L212.271 164.683C203.927 160.594 198.589 152.158 198.464 142.869L197.506 70.472L200.406 72.3283C203.418 74.2507 205.255 77.5604 205.301 81.1344L206.048 142.063C206.127 148.769 209.833 154.906 215.726 158.11L228.324 164.947",
      "stroke": "white",
      "stroke-width": "1.33307",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M197.504 70.4723L195.364 72.2559C191.823 75.2023 189.795 79.5954 189.854 84.2066L190.654 146.681C190.799 157.958 197.788 168.006 208.312 172.062L227.014 179.27",
      "stroke": "white",
      "stroke-width": "1.33307",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M245.519 18.5737C255.759 18.5737 264.083 26.8248 264.175 37.0644L266.745 327.684H219.141L226.87 36.7407C227.141 26.6266 235.412 18.5737 245.519 18.5737Z",
      "fill": "#9DC9B2"
    }
  }), _c('path', {
    attrs: {
      "d": "M245.519 18.5737C255.759 18.5737 264.083 26.8248 264.175 37.0644L266.745 327.684H219.141L226.87 36.7407C227.141 26.6266 235.412 18.5737 245.519 18.5737Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M241.76 327.691L245.519 18.5741L240.96 22.7955C237.585 25.9202 235.636 30.2869 235.557 34.8848L230.549 327.698",
      "stroke": "white",
      "stroke-width": "1.33307",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M245.52 18.5738L249.774 22.5375C253.203 25.7349 255.145 30.2073 255.138 34.8977L254.722 328.193",
      "stroke": "white",
      "stroke-width": "1.33307",
      "stroke-miterlimit": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M386.989 244.754C386.989 244.754 379.075 272.136 368.498 272.136C368.498 272.136 373.301 257.134 386.989 244.754Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M386.989 244.754C386.989 244.754 379.075 272.136 368.498 272.136C368.498 272.136 373.301 257.134 386.989 244.754Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M336.009 242.772C336.009 242.772 337.165 256.83 354.077 272.13H357.538C357.532 272.137 349.334 256.038 336.009 242.772Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M336.009 242.772C336.009 242.772 337.165 256.83 354.077 272.13H357.538C357.532 272.137 349.334 256.038 336.009 242.772Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M355.523 234.812C355.523 234.812 347.966 254.241 356.646 272.137H362.367C362.367 272.137 356.448 250.991 355.523 234.812Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M355.523 234.812C355.523 234.812 347.966 254.241 356.646 272.137H362.367C362.367 272.137 356.448 250.991 355.523 234.812Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M361.35 227.401C361.35 227.401 361.046 232.824 359.408 239.153C357.776 245.482 356.039 264.732 358.285 272.145H364.105C364.105 272.138 368.498 247.464 361.35 227.401Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M361.35 227.401C361.35 227.401 361.046 232.824 359.408 239.153C357.776 245.482 356.039 264.732 358.285 272.145H364.105C364.105 272.138 368.498 247.464 361.35 227.401Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M381.063 235.082C381.063 235.082 375.448 244.932 370.236 253.884C365.024 262.828 365.638 272.143 365.638 272.143H368.498C368.498 272.137 380.654 261.474 381.063 235.082Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M381.063 235.082C381.063 235.082 375.448 244.932 370.236 253.884C365.024 262.828 365.638 272.143 365.638 272.143H368.498C368.498 272.137 380.654 261.474 381.063 235.082Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M366.866 235.535C366.866 235.535 366.457 243.218 365.129 247.915C363.801 252.612 360.841 262.283 363.087 272.14H367.685C367.679 272.14 375.646 255.327 366.866 235.535Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M366.866 235.535C366.866 235.535 366.457 243.218 365.129 247.915C363.801 252.612 360.841 262.283 363.087 272.14H367.685C367.679 272.14 375.646 255.327 366.866 235.535Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M354.07 272.14C353.35 272.12 352.346 272.107 351.157 271.704C347.616 270.495 344.835 267.767 339.642 259.298C338.057 256.715 336.114 253.365 334.086 249.355C336.57 251.192 339.173 253.392 341.822 255.942C346.063 260.038 351.064 265.732 354.07 272.14Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M354.07 272.14C353.35 272.12 352.346 272.107 351.157 271.704C347.616 270.495 344.835 267.767 339.642 259.298C338.057 256.715 336.114 253.365 334.086 249.355C336.57 251.192 339.173 253.392 341.822 255.942C346.063 260.038 351.064 265.732 354.07 272.14Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M346.129 228.946C346.129 228.946 340.237 257.511 354.07 272.137H359.705C359.705 272.137 354.711 256.494 350.225 242.779C345.746 229.058 346.129 228.946 346.129 228.946Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M346.129 228.946C346.129 228.946 340.237 257.511 354.07 272.137H359.705C359.705 272.137 354.711 256.494 350.225 242.779C345.746 229.058 346.129 228.946 346.129 228.946Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M339.822 254.073C336.387 247.335 336.01 242.777 336.01 242.777C339.677 246.43 342.96 250.294 345.787 253.981C343.647 241.733 345.979 229.716 346.124 228.989C346.118 229.221 346.342 230.892 350.233 242.783C351.006 245.148 351.792 247.566 352.565 249.951C353.061 241.165 355.532 234.816 355.532 234.816C355.835 240.114 356.668 245.948 357.665 251.398C358.088 246.304 358.762 241.687 359.416 239.156C361.048 232.828 361.358 227.404 361.358 227.404C363.703 233.977 364.807 241.046 365.229 247.579C366.485 242.856 366.874 235.536 366.874 235.536C369.596 241.673 370.713 247.52 370.95 252.673C375.951 244.071 381.071 235.087 381.071 235.087C380.952 242.79 379.829 249.145 378.303 254.298C380.681 251.14 383.555 247.87 386.99 244.758C386.99 244.758 379.076 272.141 368.499 272.141H367.68H365.639H364.106H363.082H362.369H359.707H358.28H357.527H356.648H354.072C353.351 272.121 352.347 272.108 351.158 271.705C347.617 270.496 344.836 267.768 339.644 259.299C338.058 256.716 336.116 253.366 334.088 249.356C335.944 250.724 337.867 252.303 339.822 254.073Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M339.822 254.073C336.387 247.335 336.01 242.777 336.01 242.777C339.677 246.43 342.96 250.294 345.787 253.981C343.647 241.733 345.979 229.716 346.124 228.989C346.118 229.221 346.342 230.892 350.233 242.783C351.006 245.148 351.792 247.566 352.565 249.951C353.061 241.165 355.532 234.816 355.532 234.816C355.835 240.114 356.668 245.948 357.665 251.398C358.088 246.304 358.762 241.687 359.416 239.156C361.048 232.828 361.358 227.404 361.358 227.404C363.703 233.977 364.807 241.046 365.229 247.579C366.485 242.856 366.874 235.536 366.874 235.536C369.596 241.673 370.713 247.52 370.95 252.673C375.951 244.071 381.071 235.087 381.071 235.087C380.952 242.79 379.829 249.145 378.303 254.298C380.681 251.14 383.555 247.87 386.99 244.758C386.99 244.758 379.076 272.141 368.499 272.141H367.68H365.639H364.106H363.082H362.369H359.707H358.28H357.527H356.648H354.072C353.351 272.121 352.347 272.108 351.158 271.705C347.617 270.496 344.836 267.768 339.644 259.299C338.058 256.716 336.116 253.366 334.088 249.356C335.944 250.724 337.867 252.303 339.822 254.073Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M346.13 228.946C346.13 228.946 346.13 228.959 346.124 228.985C346.124 228.946 346.13 228.946 346.13 228.946Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M346.13 228.946C346.13 228.946 346.13 228.959 346.124 228.985C346.124 228.946 346.13 228.946 346.13 228.946Z",
      "fill": "white",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M-9.15527e-05 280.994H184.914C184.914 280.994 166.734 270.351 142.344 273.456C117.954 276.561 107.311 261.043 82.4783 260.594C57.6456 260.151 45.6752 272.564 27.0457 273.899C8.42281 275.233 -9.15527e-05 280.994 -9.15527e-05 280.994Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M-9.15527e-05 280.994H184.914C184.914 280.994 166.734 270.351 142.344 273.456C117.954 276.561 107.311 261.043 82.4783 260.594C57.6456 260.151 45.6752 272.564 27.0457 273.899C8.42281 275.233 -9.15527e-05 280.994 -9.15527e-05 280.994Z",
      "fill": "black",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    attrs: {
      "d": "M109.148 280.996H437C437 280.996 409.148 270.895 379.15 271.814C349.151 272.732 330.812 251.612 292.106 247.014C253.4 242.423 211.266 262.116 184.703 269.059C159.183 275.724 109.148 280.996 109.148 280.996Z",
      "fill": "#2400FF"
    }
  }), _c('path', {
    attrs: {
      "d": "M109.148 280.996H437C437 280.996 409.148 270.895 379.15 271.814C349.151 272.732 330.812 251.612 292.106 247.014C253.4 242.423 211.266 262.116 184.703 269.059C159.183 275.724 109.148 280.996 109.148 280.996Z",
      "fill": "black",
      "fill-opacity": "0.15"
    }
  })])], 1)]);
};
var ErrorPage_403vue_type_template_id_22694360_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ErrorPage_403.vue?vue&type=script&lang=js
/* harmony default export */ var ErrorPage_403vue_type_script_lang_js = ({
  name: 'error_page_403',
  props: {
    errorPageData: {
      type: Object,
      default: () => {
        return {
          errorMessage: "You're not registered for this event",
          buttonText: 'Check out other events',
          showButton: true
        };
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/ErrorPage_403.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ErrorPage_403vue_type_script_lang_js = (ErrorPage_403vue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/ErrorPage_403.vue?vue&type=style&index=0&id=22694360&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var ErrorPage_403vue_type_style_index_0_id_22694360_prod_lang_scss_module_true = ({"root":"ErrorPage_403_root_Q8c_0","container":"ErrorPage_403_container_uHSYQ","star":"ErrorPage_403_star_kCb62","bottom_left":"ErrorPage_403_bottom_left_SNKbr","bottom_right":"ErrorPage_403_bottom_right_e90UW","title":"ErrorPage_403_title_F1z7g","redirect_button":"ErrorPage_403_redirect_button_pmK9G"});
;// CONCATENATED MODULE: ./src/components/ErrorPage_403.vue?vue&type=style&index=0&id=22694360&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/ErrorPage_403.vue



;




function ErrorPage_403_injectStyles (context) {
  
  this["$style"] = (ErrorPage_403vue_type_style_index_0_id_22694360_prod_lang_scss_module_true.locals || ErrorPage_403vue_type_style_index_0_id_22694360_prod_lang_scss_module_true)

}

/* normalize component */

var ErrorPage_403_component = normalizeComponent(
  components_ErrorPage_403vue_type_script_lang_js,
  ErrorPage_403vue_type_template_id_22694360_render,
  ErrorPage_403vue_type_template_id_22694360_staticRenderFns,
  false,
  ErrorPage_403_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ErrorPage_403 = (ErrorPage_403_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/BottomDrawer.vue?vue&type=template&id=c2dfe124&functional=true
var BottomDrawervue_type_template_id_c2dfe124_functional_true_render = function render(_c, _vm) {
  return !_vm.props.loading ? _c('div', {
    class: _vm.$style.root
  }, [_c('IconButton', {
    attrs: {
      "ghost": "",
      "icon": "cross"
    },
    on: {
      "click": _vm.listeners.close
    }
  }), _c('div', {
    class: _vm.$style.title
  }, [_c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "body16"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.props.title)) + " ")])], 1), _vm._t("default")], 2) : _vm._e();
};
var BottomDrawervue_type_template_id_c2dfe124_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/BottomDrawer.vue?vue&type=script&lang=js
/* harmony default export */ var BottomDrawervue_type_script_lang_js = ({
  name: 'BottomDrawer',
  props: {
    title: {
      type: String,
      default: 'Thread'
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/BottomDrawer.vue?vue&type=script&lang=js
 /* harmony default export */ var components_BottomDrawervue_type_script_lang_js = (BottomDrawervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/BottomDrawer.vue?vue&type=style&index=0&id=c2dfe124&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var BottomDrawervue_type_style_index_0_id_c2dfe124_prod_module_true_lang_scss = ({"root":"BottomDrawer_root_Kz5HH","title":"BottomDrawer_title_IhORm"});
;// CONCATENATED MODULE: ./src/components/BottomDrawer.vue?vue&type=style&index=0&id=c2dfe124&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/BottomDrawer.vue



;




function BottomDrawer_injectStyles (context) {
  
  this["$style"] = (BottomDrawervue_type_style_index_0_id_c2dfe124_prod_module_true_lang_scss.locals || BottomDrawervue_type_style_index_0_id_c2dfe124_prod_module_true_lang_scss)

}

/* normalize component */

var BottomDrawer_component = normalizeComponent(
  components_BottomDrawervue_type_script_lang_js,
  BottomDrawervue_type_template_id_c2dfe124_functional_true_render,
  BottomDrawervue_type_template_id_c2dfe124_functional_true_staticRenderFns,
  true,
  BottomDrawer_injectStyles,
  null,
  null
  
)

/* harmony default export */ var BottomDrawer = (BottomDrawer_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/HlsSupportChecker.vue?vue&type=template&id=21b17eba
var HlsSupportCheckervue_type_template_id_21b17eba_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    class: _vm.$style.root
  });
};
var HlsSupportCheckervue_type_template_id_21b17eba_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/HlsSupportChecker.vue?vue&type=script&lang=js

/* harmony default export */ var HlsSupportCheckervue_type_script_lang_js = ({
  name: 'HlsSupportChecker',
  mounted() {
    // Just check for hls js support for now.
    // Later we will add the checks for native hls support on ios
    // when we build the ios playback support.
    const videoElem = document.createElement('video');
    if (Hls.isSupported() || videoElem.canPlayType('application/vnd.apple.mpegurl')) {
      this.$emit('hlssupported');
    } else {
      this.$emit('hlsnotsupported');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/HlsSupportChecker.vue?vue&type=script&lang=js
 /* harmony default export */ var components_HlsSupportCheckervue_type_script_lang_js = (HlsSupportCheckervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/HlsSupportChecker.vue?vue&type=style&index=0&id=21b17eba&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var HlsSupportCheckervue_type_style_index_0_id_21b17eba_prod_module_true_lang_scss = ({"root":"HlsSupportChecker_root_eP5YY"});
;// CONCATENATED MODULE: ./src/components/HlsSupportChecker.vue?vue&type=style&index=0&id=21b17eba&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/HlsSupportChecker.vue



;




function HlsSupportChecker_injectStyles (context) {
  
  this["$style"] = (HlsSupportCheckervue_type_style_index_0_id_21b17eba_prod_module_true_lang_scss.locals || HlsSupportCheckervue_type_style_index_0_id_21b17eba_prod_module_true_lang_scss)

}

/* normalize component */

var HlsSupportChecker_component = normalizeComponent(
  components_HlsSupportCheckervue_type_script_lang_js,
  HlsSupportCheckervue_type_template_id_21b17eba_render,
  HlsSupportCheckervue_type_template_id_21b17eba_staticRenderFns,
  false,
  HlsSupportChecker_injectStyles,
  null,
  null
  
)

/* harmony default export */ var HlsSupportChecker = (HlsSupportChecker_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/HlsNotSupported.vue?vue&type=template&id=2fa11890&functional=true
var HlsNotSupportedvue_type_template_id_2fa11890_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [!_vm.props.minimized ? _c('svg', {
    class: _vm.$style.cactusImage,
    attrs: {
      "width": "271",
      "height": "193",
      "viewBox": "0 0 271 193",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M250.753 153.836C250.838 150.632 250.634 143.615 248.185 136.485C240.9 115.264 223.842 100.881 203.724 84.8315C185.316 70.1458 190.61 62.7499 173.5 44.2397C168.251 38.558 150.651 21.305 126.761 18.8438C98.7975 15.958 66.5118 28.1009 54.52 55.8723C43.7281 80.8601 54.8506 93.0846 42.6791 122.309C36.6546 136.77 24.0873 144.444 21.6302 157.672C19.7689 167.697 22.0587 176.358 25.3893 181.383C31.5322 190.648 46.0628 192.464 53.2342 192.464C105.21 192.464 154.03 192.607 206.006 192.681C208.042 192.86 229.447 194.407 242.096 179.064C250.349 169.052 250.671 156.95 250.753 153.836Z",
      "fill-opacity": "0.1"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M24.7036 129.224C21.5771 128.873 18.6015 125.722 18.3158 121.444C17.7607 113.13 27.7975 104.114 31.6873 94.7097C34.6954 87.4403 37.324 84.8852 39.2628 85.6036C39.9934 85.873 41.3526 86.375 41.6016 92.1628C42.3281 108.824 32.4669 130.093 24.7036 129.224Z",
      "fill-opacity": "0.03"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M217.681 191.83C132.399 191.81 51.7866 184.744 110.195 174.846C110.195 174.846 146.672 169.156 167.072 176.234C170.354 177.373 174.889 179.21 183.513 182.087C197.791 186.85 209.705 189.94 217.681 191.83Z",
      "fill-opacity": "0.65"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M217.681 191.83C132.399 191.81 51.7866 184.744 110.195 174.846C110.195 174.846 146.672 169.156 167.072 176.234C170.354 177.373 174.889 179.21 183.513 182.087C197.791 186.85 209.705 189.94 217.681 191.83Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M31.1912 169.439C31.1912 169.439 36.081 186.357 42.6157 186.357C42.6157 186.357 39.6483 177.088 31.1912 169.439Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M31.1912 169.439C31.1912 169.439 36.081 186.357 42.6157 186.357C42.6157 186.357 39.6483 177.088 31.1912 169.439Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M62.6893 168.213C62.6893 168.213 61.975 176.899 51.526 186.352H49.3872C49.3913 186.356 54.4566 176.409 62.6893 168.213Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M62.6893 168.213C62.6893 168.213 61.975 176.899 51.526 186.352H49.3872C49.3913 186.356 54.4566 176.409 62.6893 168.213Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M50.6321 163.296C50.6321 163.296 55.3015 175.3 49.9383 186.357H46.4036C46.4036 186.357 50.0607 173.292 50.6321 163.296Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M50.6321 163.296C50.6321 163.296 55.3015 175.3 49.9383 186.357H46.4036C46.4036 186.357 50.0607 173.292 50.6321 163.296Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M47.032 158.716C47.032 158.716 47.2197 162.067 48.232 165.978C49.2401 169.888 50.3136 181.782 48.9258 186.361H45.3299C45.3299 186.357 42.6156 171.112 47.032 158.716Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M47.032 158.716C47.032 158.716 47.2197 162.067 48.232 165.978C49.2401 169.888 50.3136 181.782 48.9258 186.361H45.3299C45.3299 186.357 42.6156 171.112 47.032 158.716Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M34.8523 163.462C34.8523 163.462 38.3217 169.548 41.5421 175.079C44.7625 180.605 44.3829 186.36 44.3829 186.36H42.6156C42.6156 186.356 35.1054 179.769 34.8523 163.462Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M34.8523 163.462C34.8523 163.462 38.3217 169.548 41.5421 175.079C44.7625 180.605 44.3829 186.36 44.3829 186.36H42.6156C42.6156 186.356 35.1054 179.769 34.8523 163.462Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M43.6242 163.742C43.6242 163.742 43.8772 168.489 44.6976 171.391C45.518 174.293 47.3466 180.269 45.9589 186.358H43.118C43.1221 186.358 38.1997 175.971 43.6242 163.742Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M43.6242 163.742C43.6242 163.742 43.8772 168.489 44.6976 171.391C45.518 174.293 47.3466 180.269 45.9589 186.358H43.118C43.1221 186.358 38.1997 175.971 43.6242 163.742Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M51.53 186.359C51.9749 186.347 52.5953 186.338 53.33 186.089C55.5178 185.343 57.2362 183.657 60.4443 178.424C61.4239 176.828 62.6239 174.759 63.877 172.281C62.3423 173.416 60.7341 174.775 59.0974 176.351C56.477 178.881 53.3872 182.4 51.53 186.359Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M51.53 186.359C51.9749 186.347 52.5953 186.338 53.33 186.089C55.5178 185.343 57.2362 183.657 60.4443 178.424C61.4239 176.828 62.6239 174.759 63.877 172.281C62.3423 173.416 60.7341 174.775 59.0974 176.351C56.477 178.881 53.3872 182.4 51.53 186.359Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M56.4361 159.67C56.4361 159.67 60.0769 177.319 51.53 186.356H48.0483C48.0483 186.356 51.1341 176.691 53.9055 168.217C56.6728 159.74 56.4361 159.67 56.4361 159.67Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M56.4361 159.67C56.4361 159.67 60.0769 177.319 51.53 186.356H48.0483C48.0483 186.356 51.1341 176.691 53.9055 168.217C56.6728 159.74 56.4361 159.67 56.4361 159.67Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M60.3335 175.196C62.456 171.032 62.6886 168.216 62.6886 168.216C60.4233 170.473 58.3948 172.861 56.6478 175.139C57.9703 167.571 56.5295 160.147 56.4397 159.698C56.4437 159.841 56.305 160.873 53.9009 168.22C53.4233 169.681 52.9376 171.175 52.4601 172.649C52.1539 167.22 50.6274 163.298 50.6274 163.298C50.4397 166.571 49.9254 170.175 49.309 173.543C49.0478 170.396 48.6315 167.543 48.2274 165.979C47.2192 162.069 47.0274 158.718 47.0274 158.718C45.5784 162.779 44.8968 167.147 44.6356 171.184C43.8601 168.265 43.6192 163.743 43.6192 163.743C41.9376 167.535 41.2478 171.147 41.1009 174.33C38.0111 169.016 34.8478 163.465 34.8478 163.465C34.9213 168.224 35.6152 172.151 36.558 175.335C35.0886 173.384 33.3131 171.363 31.1907 169.441C31.1907 169.441 36.0805 186.359 42.6152 186.359H43.1213H44.3825H45.3295H45.9621H46.4029H48.0478H48.9295H49.3948H49.9376H51.5295C51.9743 186.347 52.5948 186.339 53.3295 186.09C55.5172 185.343 57.2356 183.657 60.4437 178.424C61.4233 176.828 62.6233 174.759 63.8764 172.281C62.7295 173.126 61.5417 174.102 60.3335 175.196Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M60.3335 175.196C62.456 171.032 62.6886 168.216 62.6886 168.216C60.4233 170.473 58.3948 172.861 56.6478 175.139C57.9703 167.571 56.5295 160.147 56.4397 159.698C56.4437 159.841 56.305 160.873 53.9009 168.22C53.4233 169.681 52.9376 171.175 52.4601 172.649C52.1539 167.22 50.6274 163.298 50.6274 163.298C50.4397 166.571 49.9254 170.175 49.309 173.543C49.0478 170.396 48.6315 167.543 48.2274 165.979C47.2192 162.069 47.0274 158.718 47.0274 158.718C45.5784 162.779 44.8968 167.147 44.6356 171.184C43.8601 168.265 43.6192 163.743 43.6192 163.743C41.9376 167.535 41.2478 171.147 41.1009 174.33C38.0111 169.016 34.8478 163.465 34.8478 163.465C34.9213 168.224 35.6152 172.151 36.558 175.335C35.0886 173.384 33.3131 171.363 31.1907 169.441C31.1907 169.441 36.0805 186.359 42.6152 186.359H43.1213H44.3825H45.3295H45.9621H46.4029H48.0478H48.9295H49.3948H49.9376H51.5295C51.9743 186.347 52.5948 186.339 53.3295 186.09C55.5172 185.343 57.2356 183.657 60.4437 178.424C61.4233 176.828 62.6233 174.759 63.8764 172.281C62.7295 173.126 61.5417 174.102 60.3335 175.196Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M56.436 159.671C56.436 159.671 56.436 159.679 56.44 159.695C56.44 159.671 56.436 159.671 56.436 159.671Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M56.436 159.671C56.436 159.671 56.436 159.679 56.44 159.695C56.44 159.671 56.436 159.671 56.436 159.671Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M270.292 191.829H156.043C156.043 191.829 167.276 185.253 182.345 187.172C197.415 189.09 203.99 179.502 219.333 179.225C234.676 178.951 242.072 186.621 253.582 187.445C265.088 188.27 270.292 191.829 270.292 191.829Z",
      "fill-opacity": "0.65"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M270.292 191.829H156.043C156.043 191.829 167.276 185.253 182.345 187.172C197.415 189.09 203.99 179.502 219.333 179.225C234.676 178.951 242.072 186.621 253.582 187.445C265.088 188.27 270.292 191.829 270.292 191.829Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M152.362 156.538C152.362 156.538 162.794 191.828 176.733 191.828C176.733 191.828 170.406 172.497 152.362 156.538Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M152.362 156.538C152.362 156.538 162.794 191.828 176.733 191.828C176.733 191.828 170.406 172.497 152.362 156.538Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M219.561 153.991C219.561 153.991 218.043 172.105 195.749 191.828H191.19C191.19 191.828 201.998 171.085 219.561 153.991Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M219.561 153.991C219.561 153.991 218.043 172.105 195.749 191.828H191.19C191.19 191.828 201.998 171.085 219.561 153.991Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M193.835 143.73C193.835 143.73 203.799 168.771 192.354 191.832H184.815C184.811 191.828 192.623 164.575 193.835 143.73Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M193.835 143.73C193.835 143.73 203.799 168.771 192.354 191.832H184.815C184.811 191.828 192.623 164.575 193.835 143.73Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M186.157 134.179C186.157 134.179 186.561 141.167 188.716 149.322C190.872 157.477 193.161 182.281 190.198 191.832H182.525C182.525 191.828 176.733 160.032 186.157 134.179Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M186.157 134.179C186.157 134.179 186.561 141.167 188.716 149.322C190.872 157.477 193.161 182.281 190.198 191.832H182.525C182.525 191.828 176.733 160.032 186.157 134.179Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M160.174 144.076C160.174 144.076 167.578 156.77 174.448 168.3C181.317 179.831 180.505 191.827 180.505 191.827H176.733C176.733 191.827 160.709 178.084 160.174 144.076Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M160.174 144.076C160.174 144.076 167.578 156.77 174.448 168.3C181.317 179.831 180.505 191.827 180.505 191.827H176.733C176.733 191.827 160.709 178.084 160.174 144.076Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M178.888 144.659C178.888 144.659 179.427 154.557 181.178 160.615C182.929 166.672 186.831 179.133 183.872 191.827H177.815C177.811 191.827 167.309 170.166 178.888 144.659Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M178.888 144.659C178.888 144.659 179.427 154.557 181.178 160.615C182.929 166.672 186.831 179.133 183.872 191.827H177.815C177.811 191.827 167.309 170.166 178.888 144.659Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M195.749 191.826C196.7 191.802 198.026 191.785 199.586 191.263C204.251 189.704 207.92 186.185 214.769 175.275C216.859 171.944 219.414 167.63 222.096 162.463C218.822 164.83 215.39 167.663 211.9 170.953C206.304 176.234 199.716 183.573 195.749 191.826Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M195.749 191.826C196.7 191.802 198.026 191.785 199.586 191.263C204.251 189.704 207.92 186.185 214.769 175.275C216.859 171.944 219.414 167.63 222.096 162.463C218.822 164.83 215.39 167.663 211.9 170.953C206.304 176.234 199.716 183.573 195.749 191.826Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M206.219 136.17C206.219 136.17 213.986 172.983 195.749 191.832H188.317C188.317 191.832 194.904 171.673 200.815 153.995C206.729 136.317 206.219 136.17 206.219 136.17Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M206.219 136.17C206.219 136.17 213.986 172.983 195.749 191.832H188.317C188.317 191.832 194.904 171.673 200.815 153.995C206.729 136.317 206.219 136.17 206.219 136.17Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M214.533 168.553C219.064 159.867 219.562 153.998 219.562 153.998C214.725 158.704 210.402 163.684 206.676 168.435C209.496 152.647 206.419 137.161 206.227 136.227C206.239 136.529 205.937 138.676 200.811 153.998C199.794 157.043 198.753 160.161 197.733 163.235C197.08 151.916 193.827 143.733 193.827 143.733C193.431 150.561 192.325 158.08 191.019 165.1C190.46 158.537 189.574 152.59 188.713 149.32C186.557 141.169 186.153 134.178 186.153 134.178C183.064 142.651 181.611 151.761 181.051 160.178C179.398 154.096 178.884 144.659 178.884 144.659C175.296 152.565 173.827 160.104 173.513 166.741C166.925 155.655 160.17 144.076 160.17 144.076C160.329 153.998 161.802 162.194 163.815 168.831C160.676 164.761 156.888 160.545 152.362 156.541C152.362 156.541 162.794 191.831 176.733 191.831H177.811H180.504H182.525H183.872H184.815H188.321H190.198H191.19H192.353H195.749C196.7 191.806 198.027 191.79 199.586 191.267C204.251 189.708 207.921 186.19 214.77 175.28C216.86 171.949 219.415 167.635 222.096 162.467C219.651 164.235 217.117 166.267 214.533 168.553Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M214.533 168.553C219.064 159.867 219.562 153.998 219.562 153.998C214.725 158.704 210.402 163.684 206.676 168.435C209.496 152.647 206.419 137.161 206.227 136.227C206.239 136.529 205.937 138.676 200.811 153.998C199.794 157.043 198.753 160.161 197.733 163.235C197.08 151.916 193.827 143.733 193.827 143.733C193.431 150.561 192.325 158.08 191.019 165.1C190.46 158.537 189.574 152.59 188.713 149.32C186.557 141.169 186.153 134.178 186.153 134.178C183.064 142.651 181.611 151.761 181.051 160.178C179.398 154.096 178.884 144.659 178.884 144.659C175.296 152.565 173.827 160.104 173.513 166.741C166.925 155.655 160.17 144.076 160.17 144.076C160.329 153.998 161.802 162.194 163.815 168.831C160.676 164.761 156.888 160.545 152.362 156.541C152.362 156.541 162.794 191.831 176.733 191.831H177.811H180.504H182.525H183.872H184.815H188.321H190.198H191.19H192.353H195.749C196.7 191.806 198.027 191.79 199.586 191.267C204.251 189.708 207.921 186.19 214.77 175.28C216.86 171.949 219.415 167.635 222.096 162.467C219.651 164.235 217.117 166.267 214.533 168.553Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M206.219 136.171C206.219 136.171 206.223 136.191 206.231 136.219C206.231 136.175 206.219 136.171 206.219 136.171Z"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M206.219 136.171C206.219 136.171 206.223 136.191 206.231 136.219C206.231 136.175 206.219 136.171 206.219 136.171Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M202.856 191.83H0.292236C0.292236 191.83 17.5004 185.589 36.0351 186.156C54.5698 186.724 65.9004 173.675 89.8147 170.834C113.729 167.997 139.762 180.164 156.174 184.454C171.941 188.573 202.856 191.83 202.856 191.83Z",
      "fill-opacity": "0.95"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "d": "M202.856 191.83H0.292236C0.292236 191.83 17.5004 185.589 36.0351 186.156C54.5698 186.724 65.9004 173.675 89.8147 170.834C113.729 167.997 139.762 180.164 156.174 184.454C171.941 188.573 202.856 191.83 202.856 191.83Z",
      "fill-opacity": "0.15"
    }
  }), _c('path', {
    class: _vm.$style.cactusFill,
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M107.88 11.408C107.935 5.2902 112.746 0.32125 118.784 0L116.497 2.1311L116.497 2.13123C114.295 4.18473 113.047 7.0573 113.052 10.0697L113.308 190.967H106.292L106.662 149.171L91.8921 143.971C82.484 140.656 76.0962 131.877 75.8432 121.905L74.6595 75.6033C74.5175 69.9969 78.7444 65.3142 84.2096 64.7737L83.1693 65.6729C80.7711 67.7484 79.4126 70.7834 79.4635 73.9542L80.1778 119.317C80.3109 127.86 85.3602 135.563 93.1419 139.094L106.696 145.255L106.704 144.354L93.4824 138.344C85.9907 134.945 81.1295 127.529 81.0014 119.305L80.8886 112.141L80.2871 73.9412C80.2401 71.0142 81.494 68.2121 83.708 66.2959L84.8995 65.266L84.9488 71.1462L85.3329 117.004C85.4079 125.125 90.2177 132.45 97.6343 135.752L106.745 139.808L106.753 138.91L97.9693 135C90.8473 131.829 86.2286 124.795 86.1565 116.997L85.7235 65.3076L87.6734 67.0588C89.3377 68.5524 90.2926 70.6788 90.3082 72.9182L90.5408 113.828C90.5866 121.805 95.2559 129.036 102.508 132.355L106.793 134.319L106.801 133.417L102.851 131.607C95.8904 128.42 91.4084 121.48 91.3645 113.824L91.1318 72.9134C91.1147 70.4428 90.0613 68.0952 88.2237 66.4461L86.3663 64.7778C91.7113 65.3275 95.8799 69.8437 95.8799 75.3339V112.211C95.8799 118.828 99.7819 124.824 105.831 127.505L106.849 127.957L107.417 63.8231L98.9979 60.6949C92.9816 58.4582 88.9204 52.7969 88.7285 46.3806L87.9204 18.0051C87.8179 14.4642 90.4538 11.4985 93.8856 11.0997L93.6744 11.2416C91.7927 12.5106 90.6708 14.6362 90.6882 16.909L90.9127 43.4849C90.9672 49.3933 94.2986 54.7785 99.5618 57.4645L107.437 61.4792L107.445 60.5589L99.9362 56.7309C94.9463 54.1843 91.7879 49.0793 91.7363 43.4776L91.5118 16.9027C91.4965 14.9062 92.4813 13.0397 94.1341 11.925L94.2734 11.8314L94.6596 42.1723C94.7269 47.4531 97.7373 52.2502 102.459 54.6129L107.476 57.1215L107.484 56.2047L102.827 53.8764C98.3811 51.6513 95.5466 47.1341 95.4832 42.1618L95.0989 11.9682L95.3125 12.1521C96.9927 13.596 97.9571 15.7024 97.9571 17.9174V39.9623C97.9571 44.8025 100.455 49.3018 104.559 51.8627L107.506 53.6989L107.515 52.7338L104.995 51.164C101.132 48.7534 98.7807 44.5181 98.7807 39.9623V17.9174C98.7807 15.4631 97.7123 13.1286 95.8497 11.5277L95.3363 11.0859C98.7374 11.4157 101.404 14.2648 101.435 17.752L101.639 40.5275C101.671 44.1316 103.573 47.4622 106.659 49.3235L107.54 49.8543L107.88 11.408ZM121.317 190.967H114.132L113.875 10.0686C113.871 7.28507 115.024 4.6311 117.058 2.73359L119.006 0.918937L121.317 190.967ZM128.244 190.967H122.078L122.141 190.966L119.83 0.937104L121.943 2.89399L121.943 2.89406C123.946 4.74822 125.103 7.33948 125.15 10.0683L125.15 10.0683L128.244 190.967ZM125.974 10.0542L129.067 190.967H135.704L133.368 103.007L142.374 99.6595C150.57 96.6146 156.1 88.9044 156.357 80.1657L157.46 41.5167C157.6 36.5594 153.799 32.4234 148.933 32.0715L149.849 32.8356C152.133 34.7353 153.44 37.5678 153.402 40.5411L152.908 79.1411C152.816 86.2767 148.393 92.635 141.734 95.2017L133.247 98.4723L133.224 97.5986L141.438 94.4332C147.783 91.9876 151.997 85.9295 152.084 79.1305L152.578 40.5305C152.613 37.8058 151.415 35.2095 149.322 33.4685L148.663 32.9192L148.083 76.786C148.003 82.6799 144.616 88.033 139.322 90.6278L133.12 93.6689L133.096 92.7634L138.959 89.8882C143.975 87.43 147.184 82.3585 147.259 76.7749L147.841 32.8088L146.693 33.5439C144.949 34.6568 143.885 36.573 143.858 38.6429L143.397 76.2874C143.346 80.5797 140.974 84.5081 137.202 86.5587L132.991 88.844L132.967 87.9202L136.809 85.835C140.319 83.9265 142.526 80.2708 142.574 76.2774L143.035 38.6323C143.065 36.2859 144.271 34.1123 146.25 32.8496L147.448 32.0826C142.774 32.4911 139.098 36.3941 139.055 41.1697L138.778 72.1942C138.736 76.7381 136.517 80.9604 132.852 83.577L130.929 11.208C130.767 5.16846 125.988 0.318471 120.031 0.000119329L122.503 2.28962L122.503 2.28969C124.671 4.29673 125.923 7.10134 125.974 10.0541V10.0542Z"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#clip0)"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M67.5468 176.706C65.7756 176.703 64.0777 176.001 62.8254 174.755C61.573 173.508 60.8684 171.817 60.866 170.054C60.868 168.291 61.5727 166.6 62.8254 165.352C64.0781 164.105 65.7766 163.403 67.5484 163.401C69.3204 163.403 71.0193 164.104 72.2724 165.352C73.5254 166.599 74.2303 168.29 74.2323 170.054C74.2299 171.818 73.5248 173.509 72.2718 174.756C71.0188 176.003 69.3202 176.704 67.5484 176.706H67.5468Z",
      "fill": "#4285F4"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M70.3645 177.89C68.9705 178.394 67.4688 178.527 66.0074 178.276C64.546 178.026 63.1754 177.401 62.0308 176.462C60.7969 175.449 59.8746 174.111 59.3696 172.6L59.3665 172.59L52.001 159.894C49.3596 163.917 48.4107 168.812 49.3584 173.525C49.8238 175.906 50.7589 178.171 52.1096 180.19C53.4603 182.208 55.1998 183.94 57.2274 185.285C59.3562 186.71 61.7605 187.676 64.2862 188.122L70.3645 177.892V177.89Z",
      "fill": "#4AAE48"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M84.2579 161.739C82.8645 158.948 80.7903 156.551 78.2251 154.765C75.6599 152.98 72.6857 151.863 69.5748 151.518C66.4639 151.173 63.3157 151.61 60.4185 152.789C57.5212 153.969 54.9675 155.853 52.9912 158.269L59.212 168.995C59.468 167.009 60.4353 165.182 61.936 163.849C63.4368 162.516 65.3703 161.767 67.3815 161.739H84.2579Z",
      "fill": "#EA3939"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M67.4758 188.403C72.1383 188.403 76.601 186.662 80.0382 183.503C83.4886 180.34 85.6017 175.989 85.9492 171.332C86.1493 168.637 85.756 165.93 84.7967 163.401H72.6278C73.6416 164.199 74.4598 165.216 75.0207 166.376C75.5815 167.535 75.8703 168.806 75.8652 170.093C75.8529 171.985 75.2088 173.819 74.0343 175.306L66.2769 188.366C66.6765 188.391 67.0792 188.403 67.4758 188.403Z",
      "fill": "#FED14B"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0"
    }
  }, [_c('rect', {
    class: _vm.$style.cactusFill,
    attrs: {
      "width": "37",
      "height": "37",
      "transform": "translate(49 151.403)"
    }
  })])])]) : _vm._e(), _c('StyledText', {
    class: [_vm.$style.textHolderBlocks, _vm.props.minimized && _vm.$style.minimized],
    attrs: {
      "variant": _vm.props.minimized ? 'heading14' : 'heading20',
      "color": "secondary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Video player not supported by your browser')) + " ")]), !_vm.props.minimized ? _c('StyledText', {
    class: [_vm.$style.textHolderBlocks, _vm.$style.supportText],
    attrs: {
      "variant": "body14",
      "color": "secondary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('We recommend using the latest version of Google Chrome to access your conference')) + ". ")]) : _vm._e()], 1);
};
var HlsNotSupportedvue_type_template_id_2fa11890_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/HlsNotSupported.vue?vue&type=script&lang=js
/* harmony default export */ var HlsNotSupportedvue_type_script_lang_js = ({
  functional: true,
  name: 'HlsNotSupported',
  props: {
    minimized: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/HlsNotSupported.vue?vue&type=script&lang=js
 /* harmony default export */ var components_HlsNotSupportedvue_type_script_lang_js = (HlsNotSupportedvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/HlsNotSupported.vue?vue&type=style&index=0&id=2fa11890&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var HlsNotSupportedvue_type_style_index_0_id_2fa11890_prod_module_true_lang_scss = ({"root":"HlsNotSupported_root_XMoc8","imageHolder":"HlsNotSupported_imageHolder_jTPUM","cactusFill":"HlsNotSupported_cactusFill_cUgSX","textHolderBlocks":"HlsNotSupported_textHolderBlocks_sMP5N","minimized":"HlsNotSupported_minimized_L5sTn","supportText":"HlsNotSupported_supportText_Vq9_x"});
;// CONCATENATED MODULE: ./src/components/HlsNotSupported.vue?vue&type=style&index=0&id=2fa11890&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/HlsNotSupported.vue



;




function HlsNotSupported_injectStyles (context) {
  
  this["$style"] = (HlsNotSupportedvue_type_style_index_0_id_2fa11890_prod_module_true_lang_scss.locals || HlsNotSupportedvue_type_style_index_0_id_2fa11890_prod_module_true_lang_scss)

}

/* normalize component */

var HlsNotSupported_component = normalizeComponent(
  components_HlsNotSupportedvue_type_script_lang_js,
  HlsNotSupportedvue_type_template_id_2fa11890_functional_true_render,
  HlsNotSupportedvue_type_template_id_2fa11890_functional_true_staticRenderFns,
  true,
  HlsNotSupported_injectStyles,
  null,
  null
  
)

/* harmony default export */ var HlsNotSupported = (HlsNotSupported_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiteMode/LiteModeToggle.vue?vue&type=template&id=c95a34f6
var LiteModeTogglevue_type_template_id_c95a34f6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.buttonContainer, 'non-mobile'],
    on: {
      "mouseleave": _vm.recordInterestInLiteMode
    }
  }, [_c('button', {
    staticClass: "keyboard-focusable",
    class: _vm.$style.button,
    attrs: {
      "aria-labelledby": _vm.ariaLabelledby,
      "type": "button",
      "disabled": _vm.isButtonDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    class: _vm.$style.prefixContainer
  }, [_vm.$props.isActive ? _c('div', {
    class: _vm.$style.liteModeOnPrefix,
    attrs: {
      "disabled": _vm.$props.isLoading
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.wifiIcon,
    attrs: {
      "color": "theme-secondary-color",
      "size": "x-small",
      "name": "wifi"
    }
  })], 1) : _c('div', {
    class: _vm.$style.liteModeOffPrefix,
    attrs: {
      "disabled": !_vm.$props.isAvailable
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.wifiIcon,
    attrs: {
      "color": "color-secondary-light",
      "size": "x-small",
      "name": "wifi"
    }
  })], 1)]), _c('div', {
    class: _vm.$style.textContainer
  }, [_c('StyledText', {
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")])], 1)])]);
};
var LiteModeTogglevue_type_template_id_c95a34f6_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiteMode/LiteModeToggle.vue?vue&type=script&lang=js

/* harmony default export */ var LiteModeTogglevue_type_script_lang_js = ({
  components: {
    SvgIcon: SvgIcon
  },
  name: 'LiteModeToggle',
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    isAvailable: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  computed: {
    buttonText() {
      if (this.isLoading && !this.isActive) {
        let msg = 'Loading Lite Mode...';
        if (this.$t) {
          msg = this.$t(msg);
        }
        return msg;
      }
      if (this.isLoading) {
        let msg = 'Turning Off Lite Mode';
        if (this.$t) {
          msg = this.$t(msg);
        }
        return msg;
      }
      if (this.isActive) {
        let msg = 'Lite Mode On';
        if (this.$t) {
          msg = this.$t(msg);
        }
        return msg;
      }
      if (!this.isAvailable) {
        let msg = 'Lite Mode Unavailable';
        if (this.$t) {
          msg = this.$t(msg);
        }
        return msg;
      }
      let msg = 'Audio/Video Issues?';
      if (this.$t) {
        msg = this.$t(msg);
      }
      return msg;
    },
    isButtonDisabled() {
      // There could be a case where lite mode becomes unavailable while it is already on
      if (this.isActive) {
        return false;
      }
      if (this.isLoading) {
        return true;
      }
      if (!this.isAvailable) {
        return true;
      }
      return false;
    }
  },
  methods: {
    recordInterestInLiteMode() {
      if (this.isButtonDisabled) {
        this.$emit('recordInterestInLiteMode');
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/LiteMode/LiteModeToggle.vue?vue&type=script&lang=js
 /* harmony default export */ var LiteMode_LiteModeTogglevue_type_script_lang_js = (LiteModeTogglevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/LiteMode/LiteModeToggle.vue?vue&type=style&index=0&id=c95a34f6&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var LiteModeTogglevue_type_style_index_0_id_c95a34f6_prod_module_true_lang_scss = ({"button":"LiteModeToggle_button_dJMJT","prefixContainer":"LiteModeToggle_prefixContainer_u1hLU","liteModeOffPrefix":"LiteModeToggle_liteModeOffPrefix_ruR8p","wifiIcon":"LiteModeToggle_wifiIcon_jUQYm","liteModeOnPrefix":"LiteModeToggle_liteModeOnPrefix_TfNyZ","textContainer":"LiteModeToggle_textContainer__8Wa8"});
;// CONCATENATED MODULE: ./src/components/LiteMode/LiteModeToggle.vue?vue&type=style&index=0&id=c95a34f6&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/LiteMode/LiteModeToggle.vue



;




function LiteModeToggle_injectStyles (context) {
  
  this["$style"] = (LiteModeTogglevue_type_style_index_0_id_c95a34f6_prod_module_true_lang_scss.locals || LiteModeTogglevue_type_style_index_0_id_c95a34f6_prod_module_true_lang_scss)

}

/* normalize component */

var LiteModeToggle_component = normalizeComponent(
  LiteMode_LiteModeTogglevue_type_script_lang_js,
  LiteModeTogglevue_type_template_id_c95a34f6_render,
  LiteModeTogglevue_type_template_id_c95a34f6_staticRenderFns,
  false,
  LiteModeToggle_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LiteModeToggle = (LiteModeToggle_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/StageSpeakers.vue?vue&type=template&id=5de2abec
var StageSpeakersvue_type_template_id_5de2abec_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.getSpeakers && _vm.getSpeakers.length ? _c('div', {
    class: {
      [_vm.$style.speakers]: true,
      [_vm.$style.overflowing]: _vm.getSpeakers.length > _vm.overflowLimit
    }
  }, [_c('ul', _vm._l(_vm.getSpeakers.slice(0, _vm.overflowLimit), function (user) {
    return _c('li', {
      key: user.id
    }, [_c('UserTooltip', {
      attrs: {
        "user": user,
        "size": _vm.userImageSize,
        "showInPersonSpeaker": _vm.showInPersonSpeaker
      },
      on: {
        "click": () => _vm.$emit('userClicked', user)
      }
    })], 1);
  }), 0), _c('GTooltip', {
    attrs: {
      "text": _vm.$options.$t('See All Speakers'),
      "showOpenIcon": true
    },
    on: {
      "click": () => _vm.$emit('seeAllSpeakers', _vm.getSpeakers)
    }
  }, [_c('IconButton', {
    class: _vm.$style.plusIcon,
    attrs: {
      "ghost": "",
      "alt": "",
      "size": _vm.userImageSize
    },
    on: {
      "click": () => _vm.$emit('seeAllSpeakers', _vm.getSpeakers)
    }
  }, [_c('StyledText', {
    class: _vm.$style[_vm.userImageSize],
    attrs: {
      "color": "primary-text-color",
      "variant": "heading10"
    }
  }, [_vm._v(" +" + _vm._s(_vm.getSpeakers.length - _vm.overflowLimit + 1) + " ")])], 1)], 1)], 1) : _vm._e();
};
var StageSpeakersvue_type_template_id_5de2abec_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/StageSpeakers.vue?vue&type=script&lang=js
/* harmony default export */ var StageSpeakersvue_type_script_lang_js = ({
  name: 'StageSpeakers',
  props: {
    speakers: {
      type: Array,
      default: () => []
    },
    userImageSize: {
      type: String,
      default: 'small'
    },
    showInPersonSpeaker: {
      type: Boolean,
      default: false
    },
    overflowLimit: {
      type: Number,
      default: 4
    }
  },
  computed: {
    getSpeakers() {
      return this.speakers.filter(e => !e.hidden);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/StageSpeakers.vue?vue&type=script&lang=js
 /* harmony default export */ var components_StageSpeakersvue_type_script_lang_js = (StageSpeakersvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/StageSpeakers.vue?vue&type=style&index=0&id=5de2abec&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var StageSpeakersvue_type_style_index_0_id_5de2abec_prod_module_true_lang_scss = ({"speakers":"StageSpeakers_speakers_cgUnX","plusIcon":"StageSpeakers_plusIcon_R7qGX","overflowing":"StageSpeakers_overflowing_cHaOd","x-small":"StageSpeakers_x-small_s73i8"});
;// CONCATENATED MODULE: ./src/components/StageSpeakers.vue?vue&type=style&index=0&id=5de2abec&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/StageSpeakers.vue



;




function StageSpeakers_injectStyles (context) {
  
  this["$style"] = (StageSpeakersvue_type_style_index_0_id_5de2abec_prod_module_true_lang_scss.locals || StageSpeakersvue_type_style_index_0_id_5de2abec_prod_module_true_lang_scss)

}

/* normalize component */

var StageSpeakers_component = normalizeComponent(
  components_StageSpeakersvue_type_script_lang_js,
  StageSpeakersvue_type_template_id_5de2abec_render,
  StageSpeakersvue_type_template_id_5de2abec_staticRenderFns,
  false,
  StageSpeakers_injectStyles,
  null,
  null
  
)

/* harmony default export */ var StageSpeakers = (StageSpeakers_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/StageSpeakersControl.vue?vue&type=template&id=7dffedea
var StageSpeakersControlvue_type_template_id_7dffedea_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('GTooltip', {
    attrs: {
      "text": _vm.$options.$t('Open Speakers Control Panel')
    }
  }, [_c('button', {
    class: _vm.$style.container,
    on: {
      "click": () => _vm.$emit('openSpeakersControlPanel')
    }
  }, [_vm.getSpeakers.length ? [_vm._l(_vm.getSpeakers.slice(0, 4), function (user, index) {
    return _c('UserImage', {
      key: user.id,
      class: {
        [_vm.$style.userImageMargin]: _vm.getSpeakers[index + 1] && index < 3,
        [_vm.$style.blur]: _vm.getSpeakers.length > 4 && index === 3
      },
      attrs: {
        "user": user,
        "size": "small"
      }
    });
  }), _vm.getSpeakers.length > 4 ? _c('StyledText', {
    class: _vm.$style.plus,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading13"
    }
  }, [_vm._v(" +" + _vm._s(_vm.getSpeakers.length - 3) + " ")]) : _vm._e()] : _c('StyledText', {
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(_vm._s(_vm.$t('Speaker Controls')))])], 2)]);
};
var StageSpeakersControlvue_type_template_id_7dffedea_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/StageSpeakersControl.vue?vue&type=script&lang=js
/* harmony default export */ var StageSpeakersControlvue_type_script_lang_js = ({
  name: 'StageSpeakersControl',
  props: {
    speakers: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getSpeakers() {
      return this.speakers.filter(e => !e.hidden);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/StageSpeakersControl.vue?vue&type=script&lang=js
 /* harmony default export */ var components_StageSpeakersControlvue_type_script_lang_js = (StageSpeakersControlvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/StageSpeakersControl.vue?vue&type=style&index=0&id=7dffedea&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var StageSpeakersControlvue_type_style_index_0_id_7dffedea_prod_module_true_lang_scss = ({"container":"StageSpeakersControl_container_z8LyL","userImageMargin":"StageSpeakersControl_userImageMargin_hKf3S","blur":"StageSpeakersControl_blur_qVbz1","plus":"StageSpeakersControl_plus_TPFD8"});
;// CONCATENATED MODULE: ./src/components/StageSpeakersControl.vue?vue&type=style&index=0&id=7dffedea&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/StageSpeakersControl.vue



;




function StageSpeakersControl_injectStyles (context) {
  
  this["$style"] = (StageSpeakersControlvue_type_style_index_0_id_7dffedea_prod_module_true_lang_scss.locals || StageSpeakersControlvue_type_style_index_0_id_7dffedea_prod_module_true_lang_scss)

}

/* normalize component */

var StageSpeakersControl_component = normalizeComponent(
  components_StageSpeakersControlvue_type_script_lang_js,
  StageSpeakersControlvue_type_template_id_7dffedea_render,
  StageSpeakersControlvue_type_template_id_7dffedea_staticRenderFns,
  false,
  StageSpeakersControl_injectStyles,
  null,
  null
  
)

/* harmony default export */ var StageSpeakersControl = (StageSpeakersControl_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SpeakersControlPanel.vue?vue&type=template&id=14ebdb47
var SpeakersControlPanelvue_type_template_id_14ebdb47_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.speakers.length ? _c('div', {
    class: _vm.$style.contentContainer
  }, [_vm.onStageSpeakers.length ? _c('div', {
    class: _vm.$style.onStageSpeakersContainer
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading14",
      "color": "primary-text-color",
      "align": "left"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('On Stage')) + " ")]), _c('div', {
    class: _vm.$style.onStageSpeakers
  }, _vm._l(_vm.onStageSpeakers, function (onStageSpeaker, onStageSpeakerIndex) {
    return _c('div', {
      key: onStageSpeaker.id,
      class: _vm.$style.onStageSpeaker,
      attrs: {
        "error": _vm.isErrored(onStageSpeaker.id)
      }
    }, [_c('button', {
      class: _vm.$style.removeFromStageButton,
      on: {
        "click": function ($event) {
          return _vm.$emit('moveSpeakerOffStage', onStageSpeaker.id);
        }
      }
    }, [_c('StyledText', {
      class: _vm.$style.moveOffstageButtonText,
      attrs: {
        "color": "secondary-text-color",
        "variant": "body10"
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Move Offstage ↓')) + " ")]), _c('SvgIcon', {
      attrs: {
        "name": "cross",
        "color": "secondary-text-color",
        "size": "medium"
      }
    })], 1), [_vm.isLoading(onStageSpeaker.id) ? _c('Loading', {
      attrs: {
        "size": "small"
      }
    }) : _c('UserImage', {
      class: _vm.$style.userImage,
      attrs: {
        "user": onStageSpeaker,
        "size": "medium"
      },
      on: {
        "click": function ($event) {
          return _vm.openUserProfile(onStageSpeaker);
        }
      }
    })], _c('GTooltip', {
      class: _vm.$style.onStageSpeakerNameTooltip,
      attrs: {
        "text": onStageSpeaker.name,
        "position": ['top-left', 'top-center', 'top-right'][onStageSpeakerIndex % 3]
      }
    }, [_c('StyledText', {
      class: _vm.$style.onStageSpeakerName,
      attrs: {
        "variant": "body14",
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(onStageSpeaker.first_name) + " ")])], 1), _vm.isErrored(onStageSpeaker.id) ? _c('StyledText', {
      class: _vm.$style.errorMovingOffStageText,
      attrs: {
        "variant": "body10",
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Error Moving ⚠')) + " ")]) : _c('button', {
      class: _vm.$style.muteButton,
      attrs: {
        "disabled": _vm.isMuted(onStageSpeaker.id)
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('muteSpeaker', onStageSpeaker.id);
        }
      }
    }, [_c('div', {
      class: _vm.isMuted(onStageSpeaker.id) ? _vm.$style.mutedSvg : _vm.$style.audioBarsSvg
    }), _c('SvgIcon', {
      class: _vm.$style.micIcon,
      attrs: {
        "variant": "primary",
        "name": _vm.isMuted(onStageSpeaker.id) ? 'muted' : 'mic',
        "size": "small"
      }
    })], 1)], 2);
  }), 0)], 1) : _vm._e(), _vm.offStageSpeakers.length ? _c('div', {
    class: _vm.$style.offStageSpeakersContainer
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading14",
      "color": "primary-text-color",
      "align": "left"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Off Stage')) + " ")]), _vm._l(_vm.offStageSpeakers, function (offStageSpeaker) {
    return _c('div', {
      key: offStageSpeaker.id,
      class: {
        [_vm.$style.offStageSpeaker]: true,
        [_vm.$style.offline]: !_vm.isOnline(offStageSpeaker.id)
      }
    }, [_c('div', {
      class: _vm.$style.offStageSpeakerInfo,
      attrs: {
        "data-testmarker": "offStageSpeakerInfo"
      }
    }, [_c('div', {
      class: _vm.$style.offStageSpeakerImageContainer
    }, [_c('UserImage', {
      class: _vm.$style.userImage,
      attrs: {
        "size": "small",
        "user": offStageSpeaker
      },
      on: {
        "click": function ($event) {
          return _vm.openUserProfile(offStageSpeaker);
        }
      }
    }), _c('div', {
      class: {
        [_vm.$style.statusDot]: false,
        [_vm.$style.online]: _vm.isOnline(offStageSpeaker.id)
      }
    })], 1), _c('div', {
      class: _vm.$style.offStageSpeakerName
    }, [_c('StyledText', {
      attrs: {
        "variant": "body14"
      }
    }, [_vm._v(" " + _vm._s(offStageSpeaker.name) + " ")]), offStageSpeaker.hidden ? _c('StyledText', {
      class: _vm.$style.offStageSpeakerHidden,
      attrs: {
        "variant": "body12"
      }
    }, [_vm._v(" Hidden ")]) : _vm._e()], 1)]), _vm.isPendingOnStage(offStageSpeaker.id) ? _c('div', {
      class: _vm.$style.offStagePendingActions
    }, [_c('StyledText', {
      class: _vm.$style.pendingText,
      attrs: {
        "variant": "body13"
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Pending...')) + " ")]), _vm.isLoading(offStageSpeaker.id) ? _c('Loading', {
      attrs: {
        "size": "verySmall"
      }
    }) : _c('TextButton', {
      attrs: {
        "variant": "heading13"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('cancelOnStageRequest', offStageSpeaker.id);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Cancel')) + " ")])], 1) : [_vm.isLoading(offStageSpeaker.id) ? _c('Loading', {
      attrs: {
        "size": "verySmall"
      }
    }) : _c('TextButton', {
      attrs: {
        "variant": "heading13"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('moveSpeakerOnStage', offStageSpeaker.id);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Move to Stage')) + " ")])]], 2);
  })], 2) : _vm._e()]) : _c('div', {
    class: _vm.$style.emptyContainer
  }, [_c('StyledText', {
    attrs: {
      "variant": "subHeading14",
      "color": "primary-text-color",
      "align": "center"
    }
  }, [_vm._v(" There are no other speakers in this broadcast. ")])], 1);
};
var SpeakersControlPanelvue_type_template_id_14ebdb47_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/assets/svgs/audio-bars.svg
var audio_bars_namespaceObject = __webpack_require__.p + "img/audio-bars.65a83e9e.svg";
;// CONCATENATED MODULE: ./src/assets/svgs/audio-bars-muted.svg
var audio_bars_muted_namespaceObject = __webpack_require__.p + "img/audio-bars-muted.2249af98.svg";
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SpeakersControlPanel.vue?vue&type=script&lang=js



/* harmony default export */ var SpeakersControlPanelvue_type_script_lang_js = ({
  components: {
    SvgIcon: SvgIcon
  },
  name: 'SpeakersControlPanel',
  props: {
    /**
     * All speakers
     */
    speakers: Array,
    /**
     * Speakers that are currently on stage
     */
    onStageSpeakers: Array,
    /**
     * Speakers that were not moved off stage
     */
    erroredSpeakerIds: Array,
    /**
     * Speakers that are pending to be moved on stage
     */
    pendingOnStageSpeakerIds: Array,
    /**
     * Speakers online as per mattermost websocket
     */
    onlineSpeakerIds: Array,
    /**
     * Speakers for who the request is loading
     */
    loadingSpeakerIds: Array,
    mutedSpeakerIds: Array
  },
  computed: {
    offStageSpeakers() {
      return this.speakers.filter(speaker => {
        return !this.onStageSpeakers.some(onStageSpeaker => onStageSpeaker.id === speaker.id);
      });
    }
  },
  data() {
    return {
      mutedSvg: audio_bars_muted_namespaceObject,
      audioBarsSvg: audio_bars_namespaceObject
    };
  },
  methods: {
    isErrored(speakerId) {
      return this.erroredSpeakerIds.includes(speakerId);
    },
    isPendingOnStage(speakerId) {
      return this.pendingOnStageSpeakerIds.includes(speakerId);
    },
    isOnline(speakerId) {
      return this.onlineSpeakerIds.includes(speakerId);
    },
    isLoading(speakerId) {
      return this.loadingSpeakerIds.includes(speakerId);
    },
    isMuted(speakerId) {
      return this.mutedSpeakerIds.includes(speakerId);
    },
    openUserProfile(speaker) {
      this.$emit('openUserProfile', speaker);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SpeakersControlPanel.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SpeakersControlPanelvue_type_script_lang_js = (SpeakersControlPanelvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SpeakersControlPanel.vue?vue&type=style&index=0&id=14ebdb47&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SpeakersControlPanelvue_type_style_index_0_id_14ebdb47_prod_module_true_lang_scss = ({"contentContainer":"SpeakersControlPanel_contentContainer_PCRMU","onStageSpeakersContainer":"SpeakersControlPanel_onStageSpeakersContainer_CGxNF","onStageSpeakers":"SpeakersControlPanel_onStageSpeakers_Dq5IJ","onStageSpeaker":"SpeakersControlPanel_onStageSpeaker_oZptJ","removeFromStageButton":"SpeakersControlPanel_removeFromStageButton_A7GGB","moveOffstageButtonText":"SpeakersControlPanel_moveOffstageButtonText_AHRWV","onStageSpeakerNameTooltip":"SpeakersControlPanel_onStageSpeakerNameTooltip_D2eCr","onStageSpeakerName":"SpeakersControlPanel_onStageSpeakerName_zvGLO","errorMovingOffStageText":"SpeakersControlPanel_errorMovingOffStageText_d3cDO","muteButton":"SpeakersControlPanel_muteButton_Z_2Rz","audioBarsSvg":"SpeakersControlPanel_audioBarsSvg_pThNH","mutedSvg":"SpeakersControlPanel_mutedSvg_KGEfI","micIcon":"SpeakersControlPanel_micIcon_WRRds","offStageSpeakersContainer":"SpeakersControlPanel_offStageSpeakersContainer_ws504","offStageSpeaker":"SpeakersControlPanel_offStageSpeaker_qgjCm","offStageSpeakerInfo":"SpeakersControlPanel_offStageSpeakerInfo_zyU6i","offStageSpeakerImageContainer":"SpeakersControlPanel_offStageSpeakerImageContainer_sDGkz","statusDot":"SpeakersControlPanel_statusDot_Njtms","online":"SpeakersControlPanel_online_GkfX4","offStageSpeakerName":"SpeakersControlPanel_offStageSpeakerName_zV6Pv","offStageSpeakerHidden":"SpeakersControlPanel_offStageSpeakerHidden_TEnY9","offStagePendingActions":"SpeakersControlPanel_offStagePendingActions__9W6S","pendingText":"SpeakersControlPanel_pendingText_O8HlW","userImage":"SpeakersControlPanel_userImage_XbqHh","emptyContainer":"SpeakersControlPanel_emptyContainer_SJLge"});
;// CONCATENATED MODULE: ./src/components/SpeakersControlPanel.vue?vue&type=style&index=0&id=14ebdb47&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SpeakersControlPanel.vue



;




function SpeakersControlPanel_injectStyles (context) {
  
  this["$style"] = (SpeakersControlPanelvue_type_style_index_0_id_14ebdb47_prod_module_true_lang_scss.locals || SpeakersControlPanelvue_type_style_index_0_id_14ebdb47_prod_module_true_lang_scss)

}

/* normalize component */

var SpeakersControlPanel_component = normalizeComponent(
  components_SpeakersControlPanelvue_type_script_lang_js,
  SpeakersControlPanelvue_type_template_id_14ebdb47_render,
  SpeakersControlPanelvue_type_template_id_14ebdb47_staticRenderFns,
  false,
  SpeakersControlPanel_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SpeakersControlPanel = (SpeakersControlPanel_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/VideoCaptions.vue?vue&type=template&id=53bc7116
var VideoCaptionsvue_type_template_id_53bc7116_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.captionsToShow && _vm.captionsToShow.length > 0 ? _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: {
      [_vm.$style.captionWrapper]: true
    },
    style: {
      'max-height': `${_vm.captionWrapperHeight}px`
    }
  }, [_c('div', {
    style: _vm.animStyle
  }, _vm._l(_vm.captionsToShow, function (caption, index) {
    return _c('div', {
      key: index,
      ref: "captionWrapper",
      refInFor: true
    }, [_c('StyledText', {
      class: _vm.$style.caption,
      attrs: {
        "variant": "body20",
        "color": "primary-text-color"
      }
    }, [_vm._v(" " + _vm._s(caption) + " ")])], 1);
  }), 0)])]) : _vm._e();
};
var VideoCaptionsvue_type_template_id_53bc7116_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/VideoCaptions.vue?vue&type=script&lang=js
/* harmony default export */ var VideoCaptionsvue_type_script_lang_js = ({
  name: 'VideoCaptions',
  data() {
    return {
      animStyle: {},
      captionsToShow: [],
      changedCaptionsFor: [],
      captionWrapperHeight: 50
    };
  },
  props: {
    captions: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    captions: {
      immediate: true,
      handler() {
        if (this.captions.length > 2) {
          const shouldAnimate = this.captions[1]?.trim() != this.captionsToShow[0]?.trim();
          if (shouldAnimate) {
            // if the sentence is complete then animate whole sentence to upward
            this.animateCaption();
          } else {
            // update the last line only
            this.captionsToShow = this.captions.slice(1, 3);
            setTimeout(() => {
              this.calcCaptionWrapperHeight();
            }, 200);
          }
        } else {
          this.captionsToShow = [...this.captions]; // update whole captions if caption's lines are less than or equal to two
          setTimeout(() => {
            this.calcCaptionWrapperHeight();
          }, 200);
        }
      }
    }
  },
  methods: {
    calcCaptionWrapperHeight() {
      const capslength = this.$refs.captionWrapper?.length;
      if (capslength && capslength >= 1) {
        let totalHeight = 0;
        let limit = capslength > 1 ? capslength - 2 : 0;
        for (let i = capslength - 1; i >= limit; i--) {
          totalHeight = totalHeight + this.$refs.captionWrapper[i].clientHeight;
        }
        this.captionWrapperHeight = totalHeight || 50;
      } else {
        this.captionWrapperHeight = 50;
      }
      if (capslength > 2) {
        const heightOfFirstElement = this.$refs.captionWrapper[0].clientHeight;
        this.animStyle = {
          transform: `translateY(-${heightOfFirstElement}px)`,
          transition: 'transform 200ms ease'
        };
      }
    },
    animateCaption() {
      this.captionsToShow = [...this.captions];
      setTimeout(() => {
        this.calcCaptionWrapperHeight();
        setTimeout(() => {
          this.animStyle = {};
          if (this.captionsToShow.length >= 3) {
            this.captionsToShow = this.captionsToShow.slice(1, this.captionsToShow.length);
          }
        }, 200);
      }, 100);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/VideoCaptions.vue?vue&type=script&lang=js
 /* harmony default export */ var components_VideoCaptionsvue_type_script_lang_js = (VideoCaptionsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/VideoCaptions.vue?vue&type=style&index=0&id=53bc7116&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var VideoCaptionsvue_type_style_index_0_id_53bc7116_prod_module_true_lang_scss = ({"root":"VideoCaptions_root_Mis_X","captionWrapper":"VideoCaptions_captionWrapper_NOJBL","caption":"VideoCaptions_caption_MUgqq"});
;// CONCATENATED MODULE: ./src/components/VideoCaptions.vue?vue&type=style&index=0&id=53bc7116&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/VideoCaptions.vue



;




function VideoCaptions_injectStyles (context) {
  
  this["$style"] = (VideoCaptionsvue_type_style_index_0_id_53bc7116_prod_module_true_lang_scss.locals || VideoCaptionsvue_type_style_index_0_id_53bc7116_prod_module_true_lang_scss)

}

/* normalize component */

var VideoCaptions_component = normalizeComponent(
  components_VideoCaptionsvue_type_script_lang_js,
  VideoCaptionsvue_type_template_id_53bc7116_render,
  VideoCaptionsvue_type_template_id_53bc7116_staticRenderFns,
  false,
  VideoCaptions_injectStyles,
  null,
  null
  
)

/* harmony default export */ var VideoCaptions = (VideoCaptions_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiveVideoSelectorWidget.vue?vue&type=template&id=3756a4b4
var LiveVideoSelectorWidgetvue_type_template_id_3756a4b4_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('SidebarWidgetContainer', [_c('div', {
    class: _vm.$style.hybridVideoToggleItem
  }, [_c('StyledText', {
    class: _vm.$style.videoPlayerHeading,
    attrs: {
      "variant": "heading15",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Click a video to play')) + " ")]), _c('div', {
    class: _vm.$style.videosListHolder
  }, _vm._l(_vm.videos, function (video) {
    return _c('div', {
      key: video.id,
      class: {
        [_vm.$style.videoItem]: true,
        [_vm.$style.selected]: _vm.playingVideoID === video.id || _vm.idOfSelectedVideo === video.id && (_vm.liveVideoRoomVideoPlaybackStartState === 'SUCCESS' || _vm.liveVideoRoomVideoPlaybackStartState === 'LOADING'),
        [_vm.$style.error]: video.transcode_status === 'ERROR',
        [_vm.$style.processing]: ['SUBMITTED', 'PROGRESSING'].includes(video.transcode_status)
      },
      on: {
        "click": () => video.transcode_status === 'COMPLETE' && _vm.playThisVideo(video.id)
      }
    }, [_vm.playingVideoID === video.id || _vm.idOfSelectedVideo === video.id && _vm.liveVideoRoomVideoPlaybackStartState === 'SUCCESS' ? _c('SvgIcon', {
      attrs: {
        "color": "theme-secondary-color",
        "name": "play",
        "size": "small"
      }
    }) : _c('div'), video.thumbnail ? _c('div', {
      class: [_vm.$style.videoThumbnailHolder, _vm.$style.imageThumbnail],
      style: {
        backgroundImage: `url(${_vm.getThumbnailURL(video)})`
      }
    }) : _c('div', {
      class: _vm.$style.videoThumbnailHolder
    }, [_c('SvgIcon', {
      attrs: {
        "name": "play",
        "size": "large"
      }
    })], 1), _c('div', {
      class: _vm.$style.videoDetailsHolder
    }, [_c('div', [_c('StyledText', {
      class: _vm.$style.videoItemName,
      attrs: {
        "color": "primary-text-color",
        "variant": "body14"
      }
    }, [_vm._v(" " + _vm._s(video.name) + " ")])], 1), _vm.liveVideoRoomVideoPlaybackStartState === 'ERROR' && video.id === _vm.idOfSelectedVideo ? _c('div', [_c('StyledText', {
      class: [_vm.$style.videoLoadingText, _vm.$style.error],
      attrs: {
        "color": "theme-secondary-color",
        "variant": "body13"
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Error starting video!')) + " ")])], 1) : video.id === _vm.idOfSelectedVideo && _vm.liveVideoRoomVideoPlaybackStartState === 'LOADING' ? _c('div', [_c('StyledText', {
      class: _vm.$style.videoLoadingText,
      attrs: {
        "color": "theme-secondary-color",
        "variant": "body13"
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Loading')) + "... ")])], 1) : _vm._e(), video.transcode_status !== 'COMPLETE' ? _c('StyledText', [_vm._v(" " + _vm._s(_vm.statusPrettyNames[video.transcode_status] || video.transcode_status) + "... ")]) : _vm._e()], 1)], 1);
  }), 0), _vm.playingVideoID ? _c('PillButton', {
    class: _vm.$style.switchToLiveButton,
    attrs: {
      "loading": _vm.isSwitchingToSpeakerMode
    },
    on: {
      "click": function ($event) {
        return _vm.switchToLiveMode();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('STOP VIDEO')) + " ")]) : _vm._e()], 1)]);
};
var LiveVideoSelectorWidgetvue_type_template_id_3756a4b4_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/constants.js
function getCloudFrontUrl() {
  return getEnv('VUE_APP_CLOUD_FRONT_URL');
}
function getEnv(value) {
  const isFeatureFlagEnabled = window.featureFlag?.Use_Goldcast_Domain?.value || false;
  let name = value;
  if (isFeatureFlagEnabled) {
    const v2Name = `${name}_v2`;
    const isV2UrlAvailable = window?.configs?.[v2Name] || ({"VUE_APP_ADMIN_PREVIEW_MOB":"false","NODE_ENV":"production","BASE_URL":""})[v2Name];
    if (isV2UrlAvailable) {
      name = v2Name;
    }
  }
  return window?.configs?.[name] || ({"VUE_APP_ADMIN_PREVIEW_MOB":"false","NODE_ENV":"production","BASE_URL":""})[name];
}
/*eslint-disable */
const REGEX = {
  URL_REGEX_STR: "((?:(http|https|Http|Https|rtsp|Rtsp):\\/\\/(?:(?:[a-zA-Z0-9\\$\\-\\_\\.\\+\\!\\*\\'\\(\\)" + '\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,64}(?:\\:(?:[a-zA-Z0-9\\$\\-\\_' + "\\.\\+\\!\\*\\'\\(\\)\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,25})?\\@)?)?" + '((?:(?:[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}\\.)+' +
  // named host
  '(?:' +
  // plus top level domain
  'a[abcdefgiklmnopqrstuvwxz][a-z]{0,19}' + '|b[abcdefghijlmnorstuvwyz][a-z]{0,13}' + '|c[abcdefghiklomnprsuvwxyz][a-z]{0,12}' + '|d[acdehijkmnortuvz][a-z]{0,7}' + '|e[acdegmnpqrstuvx][a-z]{0,9}' + '|f[aemijklortuy][a-z]{0,9}' + '|g[abdefhgilmnopqrstuwy][a-z]{0,7}' + '|h[abdegikmnorstuy][a-z]{0,8}' + '|i[bcdefklmnoqprstv][a-z]{0,11}' + '|j[aceilmnopu][a-z]{0,6}' + '|k[adefghmnioprwuyz][a-z]{0,14}' + '|l[abcdegikloprstuvy][a-z]{0,11}' + '|m[abcdeghiklmnopqrstuvwxyz][a-z]{0,9}' + '|n[abcefghiloprtuzy][a-z]{0,16}' + '|o[bfklmnoprstv][a-z]{0,11}' + '|p[acefghiklmnorstuwy][a-z]{0,9}' + '|q[apuv][a-z]{0,4}' + '|r[aeimosuwy][a-z]{0,9}' + '|s[a-z][a-z]{0,13}' + '|t[acdefghijklmnoprtuvwz][a-z]{0,16}' + '|u[abgkmnopsyz][a-z]{0,8}' + '|v[aceloginu][a-z]{0,10}' + '|w[aefhimost][a-z]{0,12}' + '|x[befiinxy][a-z-1-90]{0,22}' + '|y[aoetu][a-z]{0,7}' + '|z[aeioumw][a-z]{0,5}))' + '|(?:(?:25[0-5]|2[0-4]' +
  // or ip address
  '[0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\\.(?:25[0-5]|2[0-4][0-9]' + '|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1]' + '[0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}' + '|[1-9][0-9]|[0-9])))' + '(?:\\:\\d{1,5})?)' +
  // plus option port number
  '(\\/(?:(?:[a-zA-Z0-9\\;\\/\\?\\:\\@\\&\\=\\#\\~' +
  // plus option query params
  "\\-\\.\\+\\!\\*\\'\\(\\)\\,\\_])|(?:\\%[a-fA-F0-9]{2}))*)?" + '(?:\\b|$)',
  EMAIL_REGEX_STR: `(?:[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+)`
};
/*eslint-enable */

const helpDocLinks = {
  ROOT_HELP_DOC_LINK: 'https://help.goldcast.io/hc/en-us',
  SCREEN_SHARE_TEST: 'https://help.goldcast.io/hc/en-us/articles/9191758014875-Troubleshooting-Screen-sharing-',
  CAMERA_MIC_SETUP: 'https://help.goldcast.io/hc/en-us/articles/9190580004763',
  SPEAKER_TECH_SETUP_CHECK: 'https://help.goldcast.io/hc/en-us/articles/9188871212699',
  AUDIO_SETTINGS: 'https://help.goldcast.io/hc/en-us/articles/9223491550875',
  CONNECTION_SETTINGS: 'https://help.goldcast.io/hc/en-us/articles/4408141111323-Configuring-Your-Connection-Settings-Network-VPN-and-Firewall'
};
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiveVideoSelectorWidget.vue?vue&type=script&lang=js

/* harmony default export */ var LiveVideoSelectorWidgetvue_type_script_lang_js = ({
  props: {
    videos: {
      type: Array,
      default() {
        return [];
      }
    },
    playingVideoID: {
      type: String,
      default: ''
    },
    idOfSelectedVideo: {
      type: String,
      default: ''
    },
    liveVideoRoomVideoPlaybackStartState: {
      type: String,
      // Can be IDLE, LOADING, SUCCESS, ERROR
      default: 'IDLE'
    },
    isSwitchingToSpeakerMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      statusPrettyNames: {
        SUBMITTED: 'Processing',
        PROGRESSING: 'Processing',
        ERROR: 'Error',
        COMPLETE: 'Complete'
      }
    };
  },
  methods: {
    playThisVideo(videoID) {
      if (videoID) {
        this.$emit('selectvideotoplay', videoID);
      }
    },
    switchToLiveMode() {
      if (!this.isSwitchingToSpeakerMode) {
        this.$emit('switchtolivemode');
      }
    },
    getThumbnailURL(video) {
      return `${getCloudFrontUrl()}organization/${video?.organization}/thumbnails/${video?.thumbnail}`;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/LiveVideoSelectorWidget.vue?vue&type=script&lang=js
 /* harmony default export */ var components_LiveVideoSelectorWidgetvue_type_script_lang_js = (LiveVideoSelectorWidgetvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/LiveVideoSelectorWidget.vue?vue&type=style&index=0&id=3756a4b4&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var LiveVideoSelectorWidgetvue_type_style_index_0_id_3756a4b4_prod_module_true_lang_scss = ({"hybridVideoToggleItem":"LiveVideoSelectorWidget_hybridVideoToggleItem_ncD9z","videoPlayerHeading":"LiveVideoSelectorWidget_videoPlayerHeading_pEgE8","videosListHolder":"LiveVideoSelectorWidget_videosListHolder_Qjhk9","videoItem":"LiveVideoSelectorWidget_videoItem_lJMrQ","selected":"LiveVideoSelectorWidget_selected_LwTmT","error":"LiveVideoSelectorWidget_error_MgyIo","processing":"LiveVideoSelectorWidget_processing_Ctd1o","videoThumbnailHolder":"LiveVideoSelectorWidget_videoThumbnailHolder_j1A6d","imageThumbnail":"LiveVideoSelectorWidget_imageThumbnail_SHnFE","videoDetailsHolder":"LiveVideoSelectorWidget_videoDetailsHolder_toiNc","videoItemName":"LiveVideoSelectorWidget_videoItemName_uyKvk","videoLoadingText":"LiveVideoSelectorWidget_videoLoadingText_J00dG","videoLockedIcon":"LiveVideoSelectorWidget_videoLockedIcon_l4w61","videoNotSelectable":"LiveVideoSelectorWidget_videoNotSelectable_OJ3Il","switchToLiveButton":"LiveVideoSelectorWidget_switchToLiveButton_BxD7V"});
;// CONCATENATED MODULE: ./src/components/LiveVideoSelectorWidget.vue?vue&type=style&index=0&id=3756a4b4&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/LiveVideoSelectorWidget.vue



;




function LiveVideoSelectorWidget_injectStyles (context) {
  
  this["$style"] = (LiveVideoSelectorWidgetvue_type_style_index_0_id_3756a4b4_prod_module_true_lang_scss.locals || LiveVideoSelectorWidgetvue_type_style_index_0_id_3756a4b4_prod_module_true_lang_scss)

}

/* normalize component */

var LiveVideoSelectorWidget_component = normalizeComponent(
  components_LiveVideoSelectorWidgetvue_type_script_lang_js,
  LiveVideoSelectorWidgetvue_type_template_id_3756a4b4_render,
  LiveVideoSelectorWidgetvue_type_template_id_3756a4b4_staticRenderFns,
  false,
  LiveVideoSelectorWidget_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LiveVideoSelectorWidget = (LiveVideoSelectorWidget_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiveHLSRoom.vue?vue&type=template&id=705061e5
var LiveHLSRoomvue_type_template_id_705061e5_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "videoPlayerContainer",
    class: [_vm.$style.root]
  }, [_vm.isHLSStreamingSupported ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isFillerSlideVisible,
      expression: "isFillerSlideVisible"
    }],
    class: [_vm.$style.videoContainer, _vm.isVideoPlayerMinimized && _vm.$style.minimizedVideoPlayer],
    attrs: {
      "id": "fillerSlidePlayerContainer"
    }
  }, [_c('img', {
    class: _vm.$style.fillerSlideImage,
    attrs: {
      "src": _vm.fillerSlideUrl
    }
  }), _vm.onStageMessage && !_vm.isVideoPlayerMinimized ? _c('div', {
    class: _vm.$style.litemodeStageMessage
  }, [_c('StyledText', {
    class: _vm.$style.loadingMessageText,
    attrs: {
      "variant": "body11"
    }
  }, [_vm._v(" " + _vm._s(_vm.onStageMessage) + " ")])], 1) : _vm._e()]), _c('div', {
    ref: "hlsProgressBarParent",
    class: _vm.$style.hlsParentBox,
    on: {
      "mousemove": _vm.hovered,
      "mouseleave": _vm.hoverout
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isFillerSlideVisible,
      expression: "!isFillerSlideVisible"
    }],
    ref: "videoroot",
    class: [_vm.$style.liveHlsContainer, _vm.isVideoPlayerMinimized && _vm.$style.minimizedVideoPlayer],
    attrs: {
      "id": "hlsVideoPlayerContainer"
    }
  }), _vm.progressBarConfig.showProgressBar && _vm.isVideoHovered ? _c('VideoProgressBar', {
    class: _vm.$style.progressBar,
    style: _vm.width,
    attrs: {
      "id": "progressbar",
      "showToolTip": _vm.showProgressBarTooltip,
      "totalBarWidth": _vm.width,
      "showVideoTimer": _vm.showVideoTimer,
      "progressBarConfig": _vm.progressBarConfig,
      "totalVideoDuration": _vm.progressBarConfig.totalVideoDuration,
      "currentDuration": _vm.progressBarConfig.currentVideoDuration
    }
  }) : _vm._e(), _vm.videoBufferStall ? _c('Loading', {
    class: _vm.$style.loader,
    attrs: {
      "size": "small"
    }
  }) : _vm._e()], 1)] : _c('HlsNotSupported', {
    attrs: {
      "minimized": _vm.isVideoPlayerMinimized
    }
  })], 2);
};
var LiveHLSRoomvue_type_template_id_705061e5_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiveHLSRoom.vue?vue&type=script&lang=js

/* harmony default export */ var LiveHLSRoomvue_type_script_lang_js = ({
  props: {
    hlsVideoPlayer: {
      default() {
        return {};
      }
    },
    progressBarConfig: {
      type: Object,
      default: () => {
        return {
          totalVideoDuration: 0,
          currentVideoDuration: 0,
          showProgressBar: false
        };
      }
    },
    isFillerSlideVisible: {
      type: Boolean,
      default: false
    },
    fillerSlideUrl: {
      type: String,
      default: ''
    },
    videoBufferStall: {
      type: Boolean,
      default: false
    },
    isVideoPlayerMinimized: {
      type: Boolean,
      default: false
    },
    isHLSStreamingSupported: {
      type: Boolean,
      default: false
    },
    onStageMessage: {
      type: String,
      default: ''
    },
    showProgressBarTooltip: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    window.addEventListener('resize', () => this.calculateProgressbarWidth());
    this.calculateProgressbarWidth();
  },
  computed: {
    width() {
      return `width: ${this.progressBarWidth}px;`;
    },
    showVideoTimer() {
      return this.progressBarWidth > 0;
    }
  },
  data() {
    return {
      progressBarWidth: 0,
      isVideoHovered: false
    };
  },
  watch: {
    hlsVideoPlayer: {
      immediate: true,
      handler(newVideoPlayer, oldVideoPlayer) {
        if (newVideoPlayer === oldVideoPlayer) {
          return;
        }
        this.addPlayerToContainer('hlsVideoPlayerContainer', newVideoPlayer);
      }
    },
    isFillerSlideVisible() {
      if (!this.isFillerSlideVisible) {
        setTimeout(() => {
          this.calculateProgressbarWidth();
        }, 0);
      }
    }
  },
  methods: {
    hovered() {
      this.isVideoHovered = true;
      this.$emit('videoPlayerHoverStateChange', true);
    },
    hoverout() {
      this.isVideoHovered = false;
      this.$emit('videoPlayerHoverStateChange', false);
    },
    calculateProgressbarWidth() {
      const videoPlayerContainer = this.$refs.videoPlayerContainer;
      const videoHeightWidth = calculateVideoHeightWidth(videoPlayerContainer);
      this.progressBarWidth = videoHeightWidth.width;
    },
    addPlayerToContainer(containerId, videoPlayer) {
      this.$nextTick(() => {
        const playerContainer = document.getElementById(containerId);
        if (!playerContainer || !videoPlayer) {
          return;
        }
        playerContainer.innerHTML = '';
        playerContainer.appendChild(videoPlayer);
      });
    }
  },
  updated() {
    let videoHeight = this.$refs.videoPlayerContainer?.querySelector('video')?.getBoundingClientRect()?.height;
    let containerHeight = this.$refs.videoPlayerContainer?.getBoundingClientRect()?.height;
    if (parseInt(containerHeight) != parseInt(videoHeight) && !this.isFillerSlideVisible) {
      this.calculateProgressbarWidth();
    }
  }
});
;// CONCATENATED MODULE: ./src/components/LiveHLSRoom.vue?vue&type=script&lang=js
 /* harmony default export */ var components_LiveHLSRoomvue_type_script_lang_js = (LiveHLSRoomvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/LiveHLSRoom.vue?vue&type=style&index=0&id=705061e5&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var LiveHLSRoomvue_type_style_index_0_id_705061e5_prod_module_true_lang_scss = ({"root":"LiveHLSRoom_root_I1a7c","hlsParentBox":"LiveHLSRoom_hlsParentBox_teGHL","loader":"LiveHLSRoom_loader_h72CD","liveHlsContainer":"LiveHLSRoom_liveHlsContainer_CtzdG","progressBar":"LiveHLSRoom_progressBar_svqnH","videoContainer":"LiveHLSRoom_videoContainer_apjMM","fillerSlideImage":"LiveHLSRoom_fillerSlideImage_xiMKs","minimizedVideoPlayer":"LiveHLSRoom_minimizedVideoPlayer_xOL9O","litemodeStageMessage":"LiveHLSRoom_litemodeStageMessage_VN515","loadingMessageText":"LiveHLSRoom_loadingMessageText_rZdBL"});
;// CONCATENATED MODULE: ./src/components/LiveHLSRoom.vue?vue&type=style&index=0&id=705061e5&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/LiveHLSRoom.vue



;




function LiveHLSRoom_injectStyles (context) {
  
  this["$style"] = (LiveHLSRoomvue_type_style_index_0_id_705061e5_prod_module_true_lang_scss.locals || LiveHLSRoomvue_type_style_index_0_id_705061e5_prod_module_true_lang_scss)

}

/* normalize component */

var LiveHLSRoom_component = normalizeComponent(
  components_LiveHLSRoomvue_type_script_lang_js,
  LiveHLSRoomvue_type_template_id_705061e5_render,
  LiveHLSRoomvue_type_template_id_705061e5_staticRenderFns,
  false,
  LiveHLSRoom_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LiveHLSRoom = (LiveHLSRoom_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/BroadcastModals/GenericMessageDialog.vue?vue&type=template&id=1ca3623c
var GenericMessageDialogvue_type_template_id_1ca3623c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    attrs: {
      "noCancel": _vm.noCancel
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "heading14",
      "color": "primary-text-color"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.titleHtml)
    }
  })]), _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "display": "block",
      "align": "center",
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.msgHtml)
    }
  })]), _c('div', {
    class: _vm.$style.actions
  }, [_c('PillButton', {
    class: _vm.$style.okay,
    attrs: {
      "variant": _vm.ctaButtonVariant,
      "center": "",
      "uppercase": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('hide');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.resolveLabel)) + " ")]), _vm.secondaryCTAText ? _c('PillButton', {
    class: _vm.$style.okay,
    attrs: {
      "variant": _vm.secondaryCTAButtonVariant,
      "center": "",
      "uppercase": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('secondaryCTA');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.secondaryCTAText)) + " ")]) : _vm._e()], 1)], 1);
};
var GenericMessageDialogvue_type_template_id_1ca3623c_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/BroadcastModals/GenericMessageDialog.vue?vue&type=script&lang=js


const linkMatchRegexStr = `${REGEX.EMAIL_REGEX_STR}|${REGEX.URL_REGEX_STR}`;
const emailRegexp = new RegExp(REGEX.EMAIL_REGEX_STR, 'ig');
const linkRegexp = new RegExp(linkMatchRegexStr, 'ig');

/* harmony default export */ var GenericMessageDialogvue_type_script_lang_js = ({
  name: 'GenericMessageDialog',
  components: {
    ModalsWrapper: ModalsWrapper
  },
  props: {
    title: String,
    message: String,
    resolveLabel: {
      type: String,
      default: 'Okay'
    },
    secondaryCTAText: {
      type: String,
      default: ''
    },
    noCancel: Boolean,
    ctaButtonVariant: {
      type: String,
      default: 'secondary'
    },
    secondaryCTAButtonVariant: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    titleHtml() {
      return this.parseLinks(this.title);
    },
    msgHtml() {
      return this.parseLinks(this.message);
    }
  },
  methods: {
    parseLinks(messageText) {
      if (!messageText) {
        messageText = '';
      }
      const children = [];
      const matches = messageText.matchAll(linkRegexp);
      const arrayOfMatches = Array.from(matches);
      let lastMatchedNextCharIndex = 0;
      if (arrayOfMatches && arrayOfMatches.length) {
        arrayOfMatches.forEach(match => {
          const matchedString = match[0];
          let matchedLink = matchedString;
          if (match.index - lastMatchedNextCharIndex > 0) {
            children.push(messageText.substring(lastMatchedNextCharIndex, match.index));
          }
          // If the matched link is a mail append mailto: to the link
          if (emailRegexp.test(matchedLink)) {
            matchedLink = `mailto:${matchedLink}`;
          }
          const linkElem = `<a href="${matchedLink}" target="_blank">
          ${matchedString}
          </a>`;
          children.push(linkElem);
          lastMatchedNextCharIndex = match.index + matchedString.length;
        });
        if (lastMatchedNextCharIndex <= messageText.length - 1) {
          children.push(messageText.substring(lastMatchedNextCharIndex));
        }
      } else {
        children.push(messageText);
      }
      return children.join('');
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/BroadcastModals/GenericMessageDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var BroadcastModals_GenericMessageDialogvue_type_script_lang_js = (GenericMessageDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/BroadcastModals/GenericMessageDialog.vue?vue&type=style&index=0&id=1ca3623c&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var GenericMessageDialogvue_type_style_index_0_id_1ca3623c_prod_module_true_lang_scss = ({"title":"GenericMessageDialog_title_QCMue","content":"GenericMessageDialog_content_qO31N","actions":"GenericMessageDialog_actions_vYRqI","okay":"GenericMessageDialog_okay_ExYCC"});
;// CONCATENATED MODULE: ./src/examples/BroadcastModals/GenericMessageDialog.vue?vue&type=style&index=0&id=1ca3623c&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/BroadcastModals/GenericMessageDialog.vue



;




function GenericMessageDialog_injectStyles (context) {
  
  this["$style"] = (GenericMessageDialogvue_type_style_index_0_id_1ca3623c_prod_module_true_lang_scss.locals || GenericMessageDialogvue_type_style_index_0_id_1ca3623c_prod_module_true_lang_scss)

}

/* normalize component */

var GenericMessageDialog_component = normalizeComponent(
  BroadcastModals_GenericMessageDialogvue_type_script_lang_js,
  GenericMessageDialogvue_type_template_id_1ca3623c_render,
  GenericMessageDialogvue_type_template_id_1ca3623c_staticRenderFns,
  false,
  GenericMessageDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var GenericMessageDialog = (GenericMessageDialog_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TryAgain.vue?vue&type=template&id=777fe319
var TryAgainvue_type_template_id_777fe319_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.container
  }, [_c('SvgIcon', {
    attrs: {
      "name": "warning",
      "color": _vm.textColor
    }
  }), _c('StyledText', {
    class: _vm.$style.errorMessage,
    attrs: {
      "align": "center",
      "color": _vm.textColor
    }
  }, [_vm._v(" " + _vm._s(_vm.errorMessage || _vm.$options.$t('An error occurred!')) + " ")]), _c('TextButton', {
    class: _vm.$style.tryAgainButton,
    attrs: {
      "variant": "heading13",
      "color": _vm.linkColor
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._v(" Try again ")])], 1);
};
var TryAgainvue_type_template_id_777fe319_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TryAgain.vue?vue&type=script&lang=js
/* harmony default export */ var TryAgainvue_type_script_lang_js = ({
  name: 'TryAgain',
  props: {
    errorMessage: {
      type: String
    },
    textColor: {
      type: String,
      default: 'primary-text-color'
    },
    linkColor: {
      type: String,
      default: 'theme-secondary-color'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TryAgain.vue?vue&type=script&lang=js
 /* harmony default export */ var components_TryAgainvue_type_script_lang_js = (TryAgainvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TryAgain.vue?vue&type=style&index=0&id=777fe319&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var TryAgainvue_type_style_index_0_id_777fe319_prod_lang_scss_module_true = ({"container":"TryAgain_container_kKwzn","errorMessage":"TryAgain_errorMessage_iQYIC","tryAgainButton":"TryAgain_tryAgainButton_UZB9w"});
;// CONCATENATED MODULE: ./src/components/TryAgain.vue?vue&type=style&index=0&id=777fe319&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/TryAgain.vue



;




function TryAgain_injectStyles (context) {
  
  this["$style"] = (TryAgainvue_type_style_index_0_id_777fe319_prod_lang_scss_module_true.locals || TryAgainvue_type_style_index_0_id_777fe319_prod_lang_scss_module_true)

}

/* normalize component */

var TryAgain_component = normalizeComponent(
  components_TryAgainvue_type_script_lang_js,
  TryAgainvue_type_template_id_777fe319_render,
  TryAgainvue_type_template_id_777fe319_staticRenderFns,
  false,
  TryAgain_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TryAgain = (TryAgain_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/GifRenderer.vue?vue&type=template&id=40f8d2d4
var GifRenderervue_type_template_id_40f8d2d4_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "gifContainerRef",
    class: _vm.$style.root
  }, [_vm.isAnimating ? _c('img', {
    class: _vm.$style.gifImg,
    attrs: {
      "src": _vm.animatedSrc
    }
  }) : _c('img', {
    class: _vm.$style.gifImg,
    attrs: {
      "src": _vm.stillSrc
    }
  })]);
};
var GifRenderervue_type_template_id_40f8d2d4_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/GifRenderer.vue?vue&type=script&lang=js
const GIF_PAUSE_TIMEOUT = 5000;
/* harmony default export */ var GifRenderervue_type_script_lang_js = ({
  name: 'GifRenderer',
  props: {
    stillSrc: String,
    animatedSrc: String
  },
  data() {
    return {
      isAnimating: true,
      pauseTimeout: null
    };
  },
  mounted() {
    this.animate();
    this.pauseAfterTimeout();
    const gifContainer = this.$refs.gifContainerRef;
    gifContainer.onmouseover = this.playPerpetually;
    gifContainer.onmouseout = this.pauseAfterTimeout;
  },
  methods: {
    animate() {
      this.isAnimating = true;
    },
    pauseAfterTimeout() {
      this.pauseTimeout = setTimeout(() => {
        this.isAnimating = false;
      }, GIF_PAUSE_TIMEOUT);
    },
    playPerpetually() {
      if (this.pauseTimeout) {
        clearTimeout(this.pauseTimeout);
      }
      this.animate();
    }
  }
});
;// CONCATENATED MODULE: ./src/components/GifRenderer.vue?vue&type=script&lang=js
 /* harmony default export */ var components_GifRenderervue_type_script_lang_js = (GifRenderervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/GifRenderer.vue?vue&type=style&index=0&id=40f8d2d4&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var GifRenderervue_type_style_index_0_id_40f8d2d4_prod_module_true_lang_scss = ({"root":"GifRenderer_root_quaJr","gifImg":"GifRenderer_gifImg_A9hKA"});
;// CONCATENATED MODULE: ./src/components/GifRenderer.vue?vue&type=style&index=0&id=40f8d2d4&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/GifRenderer.vue



;




function GifRenderer_injectStyles (context) {
  
  this["$style"] = (GifRenderervue_type_style_index_0_id_40f8d2d4_prod_module_true_lang_scss.locals || GifRenderervue_type_style_index_0_id_40f8d2d4_prod_module_true_lang_scss)

}

/* normalize component */

var GifRenderer_component = normalizeComponent(
  components_GifRenderervue_type_script_lang_js,
  GifRenderervue_type_template_id_40f8d2d4_render,
  GifRenderervue_type_template_id_40f8d2d4_staticRenderFns,
  false,
  GifRenderer_injectStyles,
  null,
  null
  
)

/* harmony default export */ var GifRenderer = (GifRenderer_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/PublishedStage.vue?vue&type=template&id=5241b1ee
var PublishedStagevue_type_template_id_5241b1ee_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "publishedStage",
    class: [_vm.$style.screen, _vm.minimized && _vm.$style.minimzed, _vm.applyPublishedStageCss && _vm.$style[`published-stage-with-${_vm.stageLayout}`]]
  }, [_vm.is('slide') ? _c('SlideScreen', _vm._b({
    attrs: {
      "minimized": _vm.minimized,
      "layout": _vm.stageLayout
    }
  }, 'SlideScreen', _vm.currentScreenParams, false)) : _vm.is('textQna') ? _c('TextQnaPublished', {
    attrs: {
      "question": _vm.currentScreenParams,
      "minimized": _vm.minimized,
      "textQNAAnswerMeta": _vm.textQNAAnswerMeta
    }
  }) : _vm.is('poll') ? _c('PollWidget', {
    class: _vm.$style.presenting_screen,
    attrs: {
      "minimized": _vm.minimized,
      "pollDetails": _vm.currentScreenParams
    },
    on: {
      "unpublish": () => _vm.$emit('unpublish-poll'),
      "vote": function ($event) {
        return _vm.$emit('vote-poll', $event);
      }
    }
  }) : _vm.is('broadcastOverlay') ? _c('PublishedOverlay', {
    attrs: {
      "overlayText": _vm.currentScreenParams.overlay_text,
      "logo": _vm.currentScreenParams.logo,
      "minimized": _vm.minimized
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }) : _vm.is('screen') && _vm.currentScreenParams.hideOwnScreen ? _c('div', {
    class: _vm.$style.presenting_screen
  }, [[_c('SvgIcon', {
    attrs: {
      "name": "screen-share",
      "size": "large",
      "color": "screen-saver-text-color"
    }
  }), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": _vm.minimized ? 'body14' : 'heading26',
      "color": "screen-saver-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('You are sharing your screen')) + " ")]), _c('div', {
    class: _vm.$style.own_screen
  }, [_vm.currentScreenParams.screenPublishing ? _c('Loading', {
    attrs: {
      "size": "small"
    }
  }) : _c('AgoraV4Player', {
    attrs: {
      "isLocal": _vm.currentScreenParams.isLocalScreen,
      "videoTrack": _vm.currentScreenParams.stream.videoTrack,
      "audioTrack": _vm.currentScreenParams.stream.audioTrack,
      "loading": _vm.currentScreenParams.stream.loading,
      "signalStrength": _vm.currentScreenParams.stream.signalStrength,
      "user": {},
      "muted": _vm.currentScreenParams.muted,
      "fit": "contain",
      "audioOutputDeviceId": _vm.currentScreenParams.audioOutputDeviceId
    },
    on: {
      "play-aborted": function ($event) {
        return _vm.$emit('play-aborted');
      }
    }
  })], 1)]], 2) : _c('AgoraV4Player', {
    attrs: {
      "isLocal": _vm.currentScreenParams.isLocalScreen,
      "videoTrack": _vm.currentScreenParams.stream.videoTrack,
      "audioTrack": _vm.currentScreenParams.stream.audioTrack,
      "signalStrength": _vm.currentScreenParams.stream.signalStrength,
      "user": {},
      "muted": _vm.currentScreenParams.muted,
      "fit": "contain",
      "loading": _vm.currentScreenParams.stream.loading,
      "audioOutputDeviceId": _vm.currentScreenParams.audioOutputDeviceId
    },
    on: {
      "play-aborted": function ($event) {
        return _vm.$emit('play-aborted');
      }
    }
  })], 1);
};
var PublishedStagevue_type_template_id_5241b1ee_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/RoomAssets/PollWidget.vue?vue&type=template&id=663fac77&functional=true
var PollWidgetvue_type_template_id_663fac77_functional_true_render = function render(_c, _vm) {
  return _vm.props.pollDetails && _vm.props.pollDetails.id ? _c('div', {
    class: [_vm.$style.root, _vm.props.minimized && _vm.$style.minimized]
  }, [_c('div', [_c('StyledText', {
    class: _vm.$style.question,
    attrs: {
      "variant": "subHeading26"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.pollDetails && _vm.props.pollDetails.question) + " ")]), _vm._l(_vm.props.pollDetails.answers, function (answer) {
    return _c('div', {
      key: answer.id,
      class: {
        [_vm.$style.answerItem]: true,
        [_vm.$style.open]: _vm.props.pollDetails.open,
        [_vm.$style.selected]: answer.selected,
        [_vm.$style.disabled]: _vm.props.pollDetails.isAnswerLoading
      },
      on: {
        "click": function ($event) {
          _vm.props.pollDetails.open && !_vm.props.pollDetails.isAnswerLoading && _vm.listeners.vote(answer.id);
        }
      }
    }, [_vm.props.pollDetails.open ? [_vm.props.pollDetails.multipleChoice ? _c('GCheckbox', {
      class: _vm.$style.radio,
      attrs: {
        "checked": answer.selected,
        "theme": "screen-saver"
      },
      on: {
        "toggle": () => null
      }
    }) : _c('RadioSelectBtn', {
      class: _vm.$style.radio,
      attrs: {
        "selected": answer.selected,
        "theme": "screen-saver"
      }
    })] : _vm._e(), _c('div', {
      class: _vm.$style.answerTextItem
    }, [_c('StyledText', {
      attrs: {
        "variant": "subHeading16",
        "color": "screen-saver-text-color"
      }
    }, [_vm._v(" " + _vm._s(answer.answer) + " ")]), _c('div', {
      class: _vm.$style.visualizerContainer
    }, [_c('div', {
      class: _vm.$style.visualizer,
      style: {
        '--size': `${_vm.$options.getPercentage(answer.votes, _vm.props.pollDetails.totalVotes)}%`
      }
    }), _c('StyledText', {
      class: _vm.$style.votesHolder,
      attrs: {
        "variant": "body13",
        "color": "screen-saver-text-color"
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.getPercentage(answer.votes, _vm.props.pollDetails.totalVotes)) + "% "), _vm.props.pollDetails.hasAdminAccess ? [_vm._v(" (" + _vm._s(answer && answer.votes) + " " + _vm._s(answer && answer.votes > 1 ? _vm.$options.$t('Votes') : _vm.$options.$t('Vote')) + ") ")] : _vm._e()], 2)], 1)], 1)], 2);
  })], 2)]) : _vm._e();
};
var PollWidgetvue_type_template_id_663fac77_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/RoomAssets/PollWidget.vue?vue&type=script&lang=js
/* harmony default export */ var PollWidgetvue_type_script_lang_js = ({
  functional: true,
  props: {
    pollDetails: {
      type: Object,
      default() {
        return {};
      }
    },
    minimized: {
      type: Boolean,
      default: false
    }
  },
  getPercentage(a, b) {
    const percentage = (a / b * 100).toFixed(2);
    return isNaN(percentage) ? 0.0 : percentage;
  }
});
;// CONCATENATED MODULE: ./src/components/RoomAssets/PollWidget.vue?vue&type=script&lang=js
 /* harmony default export */ var RoomAssets_PollWidgetvue_type_script_lang_js = (PollWidgetvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/RoomAssets/PollWidget.vue?vue&type=style&index=0&id=663fac77&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var PollWidgetvue_type_style_index_0_id_663fac77_prod_module_true_lang_scss = ({"root":"PollWidget_root_OnjiP","minimized":"PollWidget_minimized_qdTaK","question":"PollWidget_question_rYV5X","answerItem":"PollWidget_answerItem_MHkgQ","answerTextItem":"PollWidget_answerTextItem_VpO1e","open":"PollWidget_open_Ggcu7","disabled":"PollWidget_disabled_TryPY","selected":"PollWidget_selected_Uo4kX","radio":"PollWidget_radio_wY9_0","visualizerContainer":"PollWidget_visualizerContainer_G5hMV","visualizer":"PollWidget_visualizer_XoEk9","votesHolder":"PollWidget_votesHolder_cJnmb"});
;// CONCATENATED MODULE: ./src/components/RoomAssets/PollWidget.vue?vue&type=style&index=0&id=663fac77&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/RoomAssets/PollWidget.vue



;




function PollWidget_injectStyles (context) {
  
  this["$style"] = (PollWidgetvue_type_style_index_0_id_663fac77_prod_module_true_lang_scss.locals || PollWidgetvue_type_style_index_0_id_663fac77_prod_module_true_lang_scss)

}

/* normalize component */

var PollWidget_component = normalizeComponent(
  RoomAssets_PollWidgetvue_type_script_lang_js,
  PollWidgetvue_type_template_id_663fac77_functional_true_render,
  PollWidgetvue_type_template_id_663fac77_functional_true_staticRenderFns,
  true,
  PollWidget_injectStyles,
  null,
  null
  
)

/* harmony default export */ var PollWidget = (PollWidget_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarVideoProduction/PublishedOverlay.vue?vue&type=template&id=5fe0e7a3&functional=true
var PublishedOverlayvue_type_template_id_5fe0e7a3_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: {
      [_vm.$style.overlayContainer]: true,
      [_vm.$style.minimized]: _vm.props.minimized
    }
  }, [_vm.props.logo ? _c('img', {
    class: [_vm.$style.logoImage],
    attrs: {
      "src": _vm.props.logo
    }
  }) : _vm._e(), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": _vm.$options.isMobile() || _vm.props.minimized ? 'heading15' : 'heading26',
      "color": "screen-saver-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.overlayText) + " ")])], 1)]);
};
var PublishedOverlayvue_type_template_id_5fe0e7a3_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarVideoProduction/PublishedOverlay.vue?vue&type=script&lang=js
/* harmony default export */ var PublishedOverlayvue_type_script_lang_js = ({
  name: 'PublishedOverlay',
  functional: true,
  props: {
    overlayText: {
      type: String,
      required: true
    },
    minimized: Boolean,
    logo: String
  },
  isMobile() {
    return window.mobileCheck && window.mobileCheck();
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/PublishedOverlay.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarVideoProduction_PublishedOverlayvue_type_script_lang_js = (PublishedOverlayvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarVideoProduction/PublishedOverlay.vue?vue&type=style&index=0&id=5fe0e7a3&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var PublishedOverlayvue_type_style_index_0_id_5fe0e7a3_prod_module_true_lang_scss = ({"root":"PublishedOverlay_root_BZo53","overlayContainer":"PublishedOverlay_overlayContainer_sfxyh","logoImage":"PublishedOverlay_logoImage_Mzlc7","title":"PublishedOverlay_title_W7kxe","minimized":"PublishedOverlay_minimized_XxraE"});
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/PublishedOverlay.vue?vue&type=style&index=0&id=5fe0e7a3&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/PublishedOverlay.vue



;




function PublishedOverlay_injectStyles (context) {
  
  this["$style"] = (PublishedOverlayvue_type_style_index_0_id_5fe0e7a3_prod_module_true_lang_scss.locals || PublishedOverlayvue_type_style_index_0_id_5fe0e7a3_prod_module_true_lang_scss)

}

/* normalize component */

var PublishedOverlay_component = normalizeComponent(
  SidebarVideoProduction_PublishedOverlayvue_type_script_lang_js,
  PublishedOverlayvue_type_template_id_5fe0e7a3_functional_true_render,
  PublishedOverlayvue_type_template_id_5fe0e7a3_functional_true_staticRenderFns,
  true,
  PublishedOverlay_injectStyles,
  null,
  null
  
)

/* harmony default export */ var PublishedOverlay = (PublishedOverlay_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/PublishedStage.vue?vue&type=script&lang=js



/* harmony default export */ var PublishedStagevue_type_script_lang_js = ({
  name: 'PublishedStage',
  components: {
    PollWidget: PollWidget,
    AgoraV4Player: AgoraV4Player,
    PublishedOverlay: PublishedOverlay
  },
  props: {
    minimized: Boolean,
    currentScreen: String,
    stageLayout: String,
    isBackstage: Boolean,
    currentScreenParams: {
      type: Object,
      default: () => ({})
    },
    textQNAAnswerMeta: {
      type: Object,
      default: () => {
        return {
          showAnswerersIdentity: true,
          answerersAlias: ''
        };
      }
    }
  },
  methods: {
    is(screen) {
      return this.currentScreen === screen;
    },
    isMobile() {
      return window.mobileCheck && window.mobileCheck();
    }
  },
  computed: {
    applyPublishedStageCss() {
      return !this.isBackstage && !this.isMobile();
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/PublishedStage.vue?vue&type=script&lang=js
 /* harmony default export */ var ConferenceRoom_PublishedStagevue_type_script_lang_js = (PublishedStagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/PublishedStage.vue?vue&type=style&index=0&id=5241b1ee&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var PublishedStagevue_type_style_index_0_id_5241b1ee_prod_module_true_lang_scss = ({"screen":"PublishedStage_screen_tCNi2","published-stage-with-UNDER_SCREEN":"PublishedStage_published-stage-with-UNDER_SCREEN_csioe","published-stage-with-FLEX_16_9":"PublishedStage_published-stage-with-FLEX_16_9_NspPz","presenting_screen":"PublishedStage_presenting_screen_d85jm","own_screen":"PublishedStage_own_screen_XELDz","minimized":"PublishedStage_minimized_rZUie","published-stage-with-FLEX":"PublishedStage_published-stage-with-FLEX_TFC4L"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/PublishedStage.vue?vue&type=style&index=0&id=5241b1ee&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/PublishedStage.vue



;




function PublishedStage_injectStyles (context) {
  
  this["$style"] = (PublishedStagevue_type_style_index_0_id_5241b1ee_prod_module_true_lang_scss.locals || PublishedStagevue_type_style_index_0_id_5241b1ee_prod_module_true_lang_scss)

}

/* normalize component */

var PublishedStage_component = normalizeComponent(
  ConferenceRoom_PublishedStagevue_type_script_lang_js,
  PublishedStagevue_type_template_id_5241b1ee_render,
  PublishedStagevue_type_template_id_5241b1ee_staticRenderFns,
  false,
  PublishedStage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var PublishedStage = (PublishedStage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/SettingsModal.vue?vue&type=template&id=cee13d6e
var SettingsModalvue_type_template_id_cee13d6e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.hasError]: _vm.hasError,
      [_vm.$style.dark]: _vm.dark
    }
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('StyledText', {
    attrs: {
      "variant": "subHeading18"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Settings')) + " ")]), _c('IconButton', {
    staticClass: "black-outline-focus",
    class: _vm.$style.cancelButton,
    attrs: {
      "size": "large",
      "icon": "cross",
      "variant": "primary"
    },
    on: {
      "click": _vm.handleClose
    }
  })], 1), _vm.permissionErrorHeader ? _c('ErrorComp', {
    attrs: {
      "errorIcon": _vm.permissionErrorHeader.icon,
      "errorTitle": _vm.permissionErrorHeader.title
    }
  }, [_c('template', {
    slot: "errorText"
  }, [_c('div', {
    class: _vm.$style.permissionErrorText
  }, [_c('div', [_vm.browser === 'Safari' ? _c('StyledText', {
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`1. Click on Safari > Settings for this website`)) + " ")]) : _c('StyledText', {
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`1. Click the lock`)) + " "), _c('SvgIcon', {
    class: _vm.$style.lockIcon,
    attrs: {
      "name": "lock",
      "size": "small",
      "color": "primary-text-color"
    }
  }), _vm._v(" " + _vm._s(_vm.$t(`icon in your browser’s address bar`)) + " ")], 1)], 1), _c('div', [_c('StyledText', {
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.getStepTwoText(_vm.permissionErrorHeader.type))) + " ")]), _c('div', [_vm.permissionErrorHeader.type === 'both' ? _c('StyledText', {
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`3. Unmute`)) + " "), _c('SvgIcon', {
    class: _vm.$style.lockIcon,
    attrs: {
      "name": "mic",
      "size": "small",
      "color": "primary-text-color"
    }
  }), _vm._v(" " + _vm._s(_vm.$t(`and`)) + " "), _c('SvgIcon', {
    class: _vm.$style.lockIcon,
    attrs: {
      "name": "videocam",
      "size": "small",
      "color": "primary-text-color"
    }
  }), _vm._v(" " + _vm._s(_vm.$t(`icons from stage control panel`)) + " ")], 1) : _c('StyledText', {
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`3. Unmute`)) + " "), _c('SvgIcon', {
    class: _vm.$style.lockIcon,
    attrs: {
      "name": _vm.permissionErrorHeader.type === 'camera' ? 'videocam' : ' mic',
      "size": "small",
      "color": "primary-text-color"
    }
  }), _vm._v(" " + _vm._s(_vm.$t(`icon from stage control panel`)) + " ")], 1)], 1)], 1)])])], 2) : _vm.deviceErrorHeader ? _c('ErrorComp', {
    attrs: {
      "errorIcon": _vm.deviceErrorHeader.icon,
      "errorTitle": _vm.deviceErrorHeader.title
    }
  }, [_c('template', {
    slot: "errorText"
  }, [_c('StyledText', {
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.deviceErrorHeader.text)) + " ")])], 1)], 2) : _vm._e(), _c('div', {
    class: _vm.$style.body
  }, [_c('ul', {
    class: _vm.$style.sidebar,
    attrs: {
      "id": "settingItems",
      "role": "menu"
    }
  }, [_vm._l(_vm.tabs, function (tab) {
    return _c('li', {
      key: tab.id,
      attrs: {
        "role": "none"
      }
    }, [_c('button', {
      staticClass: "button keyboard-focusable",
      class: {
        [_vm.$style.tab]: true,
        [_vm.$style.active]: _vm.currentTab === tab.id
      },
      attrs: {
        "role": "menuitem",
        "aria-controls": "settings-content",
        "aria-haspopup": "true"
      },
      on: {
        "click": function ($event) {
          return _vm.onTabClick(tab);
        }
      }
    }, [_c('div', {
      class: {
        [_vm.$style.icon]: true,
        [_vm.$style.withError]: tab.error,
        [_vm.$style[tab.id]]: true
      }
    }, [_c('SvgIcon', {
      attrs: {
        "name": tab.icon,
        "color": "inherit"
      }
    }), tab.error ? _c('ErrorCrossSvg') : _vm._e()], 1), _c('StyledText', {
      class: _vm.$style.tabHeading,
      attrs: {
        "variant": "body14",
        "color": "inherit"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(tab.label)) + " ")])], 1)]);
  }), _c('HelpDocLinkSettingsModal', {
    attrs: {
      "helpLink": _vm.helpLink
    }
  })], 2), _c('div', {
    ref: "settingContent",
    class: _vm.$style.content,
    attrs: {
      "id": "settings-content",
      "tabindex": "-1"
    }
  }, [_vm.currentTab === 'video' ? _c('VideoSettings', {
    attrs: {
      "cameras": _vm.cameras,
      "selectedCamera": _vm.selectedCamera,
      "active": _vm.active.camera,
      "permission": _vm.permissions.camera,
      "error": _vm.errors.camera,
      "mirror": _vm.mirror,
      "showVideoMirrorOption": _vm.showVideoMirrorOption
    },
    on: {
      "toggleMirror": function ($event) {
        return _vm.$emit('toggleMirror');
      },
      "selectCamera": function ($event) {
        return _vm.$emit('selectDevice', 'camera', $event);
      }
    }
  }) : _vm._e(), _vm.currentTab === 'audio' ? _c('AudioSettings', {
    ref: "audioSettings",
    attrs: {
      "showOnlySpeakerUI": _vm.showOnlySpeakerUI,
      "microphones": _vm.microphones,
      "speakers": _vm.speakers,
      "selectedMicrophone": _vm.selectedMicrophone,
      "selectedSpeaker": _vm.selectedSpeaker,
      "errors": _vm.errors,
      "permissions": _vm.permissions,
      "active": _vm.active
    },
    on: {
      "openSystemLink": function ($event) {
        return _vm.$emit('openSystemLink');
      },
      "selectMic": function ($event) {
        return _vm.$emit('selectDevice', 'microphone', $event);
      },
      "selectSpeaker": function ($event) {
        return _vm.$emit('selectDevice', 'speaker', $event);
      }
    }
  }) : _vm._e(), _vm.currentTab === 'virtualBackground' ? _c('VirtualBackgroundSettings', {
    attrs: {
      "virtualBackgrounds": _vm.virtualBackgrounds,
      "selectedVirtualBackground": _vm.selectedVirtualBackground
    },
    on: {
      "setVirtualBackground": function ($event) {
        return _vm.$emit('setVirtualBackground', $event);
      }
    }
  }) : _vm._e()], 1)])], 1);
};
var SettingsModalvue_type_template_id_cee13d6e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/VideoSettings.vue?vue&type=template&id=5fe149c2
var VideoSettingsvue_type_template_id_5fe149c2_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: _vm.$style.label,
    attrs: {
      "variant": "subHeading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`Camera`)) + " ")]), _c('div', {
    class: _vm.$style.flex
  }, [_c('div', {
    class: [_vm.$style.deviceList, !_vm.showIcon && _vm.$style.noIconList]
  }, [_c('AccessibleSelect', {
    class: _vm.$style.dropdown,
    attrs: {
      "id": "techcheckCamera",
      "comboInputClass": _vm.$style.comboElement,
      "transparentOptionBackground": true,
      "fullWidth": true,
      "showShadows": true,
      "value": _vm.selectedCamera,
      "valueKey": "deviceId",
      "options": _vm.cameras,
      "hasError": !!_vm.error || !_vm.permission
    },
    on: {
      "input": $event => _vm.$emit('selectCamera', $event)
    }
  }), _vm.errorMessage ? _c('StyledText', {
    class: _vm.$style.error,
    attrs: {
      "color": "warning",
      "variant": "body14"
    }
  }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e()], 1), _vm.showIcon ? _c('div', {
    class: _vm.$style.status
  }, [_c('SvgIcon', {
    attrs: {
      "name": _vm.statusMessage.icon
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "body12",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.statusMessage.status) + " ")])], 1) : _vm._e()]), _vm.showVideoMirrorOption ? _c('div', {
    class: _vm.$style.mirror
  }, [_c('GTooltip', {
    attrs: {
      "text": _vm.$t('Mirrored video doesn’t reflect to viewers. Viewers always sees non-mirrored video')
    }
  }, [_c('GCheckbox', {
    attrs: {
      "theme": "primary",
      "checked": _vm.mirror,
      "label": _vm.$options.$t('Mirror My Video')
    },
    on: {
      "toggle": function ($event) {
        return _vm.$emit('toggleMirror');
      }
    }
  })], 1)], 1) : _vm._e()], 1);
};
var VideoSettingsvue_type_template_id_5fe149c2_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/AccessibleSelect.vue?vue&type=template&id=7bc30550
var AccessibleSelectvue_type_template_id_7bc30550_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.combo, {
      [_vm.$style.open]: _vm.open
    }, _vm.$style.root, _vm.$style[_vm.variant], {
      [_vm.$style.top]: _vm.verticalPosition === 'top'
    }]
  }, [_c('div', {
    ref: "comboEl",
    class: [_vm.$style.comboInput, _vm.$style.root, _vm.$style[_vm.variant], _vm.comboInputClass, {
      [_vm.$style.error]: _vm.hasError
    }, {
      [_vm.$style.border]: !_vm.noBorder
    }, {
      [_vm.$style.padding]: !_vm.noPadding,
      [_vm.$style.rounded]: !_vm.noRoundedCorner,
      [_vm.$style.secondaryColor]: _vm.inheritThemeColor
    }],
    attrs: {
      "id": _vm.id,
      "aria-controls": "listboxId",
      "data-testid": _vm.dataTestId,
      "aria-expanded": _vm.open ? 'true' : 'false',
      "aria-haspopup": "listbox",
      "aria-labelledby": _vm.id + 'selectedOption',
      "role": "combobox",
      "tabindex": "0"
    },
    on: {
      "blur": _vm.onComboBlur,
      "click": _vm.onComboClick,
      "keydown": _vm.onComboKeyDown
    }
  }, [_vm.comboboxValue ? _c('StyledText', {
    class: _vm.$style.selected,
    attrs: {
      "id": _vm.id + 'selectedOption',
      "variant": "body13",
      "color": "inherit"
    }
  }, [!_vm.$slots.option ? [_vm._v(_vm._s(_vm.comboboxValue))] : _vm._e(), _vm._t("option", null, {
    "option": _vm.comboboxValue
  })], 2) : _vm._e(), _vm.showCaret ? _c('SvgIcon', {
    class: [{
      [_vm.$style.optionIcon]: true,
      [_vm.$style.caret]: _vm.optionIcon === 'caret'
    }],
    attrs: {
      "name": _vm.optionIcon,
      "size": "x-small",
      "color": "inherit"
    }
  }) : _vm._e()], 1), _vm.options.length ? _c('div', {
    ref: "listboxEl",
    class: [_vm.$style.comboMenu, {
      [_vm.$style.open]: _vm.open
    }, {
      [_vm.$style.fullWidth]: _vm.fullWidth
    }, {
      [_vm.$style.shadow]: _vm.showShadows
    }],
    attrs: {
      "id": _vm.id + '-listbox',
      "data-testid": _vm.dataTestId + '-listbox',
      "role": "listbox",
      "tabindex": "-1"
    }
  }, _vm._l(_vm.options, function (option, index) {
    return _c('div', {
      key: index,
      class: [_vm.$style.comboOption, {
        [_vm.$style.hasTransparentBackground]: _vm.transparentOptionBackground
      }, _vm.activeIndex === index ? _vm.computedBorderStyle : null],
      attrs: {
        "id": _vm.getOptionId(index),
        "data-testid": _vm.dataTestId + '-option',
        "aria-selected": _vm.isSelected(option),
        "role": "option"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onOptionClick(index);
        },
        "mousedown": _vm.onOptionMouseDown
      }
    }, [_c('StyledText', {
      attrs: {
        "variant": "body13",
        "color": "inherit"
      }
    }, [!_vm.$slots.option ? [_vm._v(" " + _vm._s(option.label) + " ")] : _vm._t("option", null, {
      "option": option
    })], 2)], 1);
  }), 0) : _vm._e()]);
};
var AccessibleSelectvue_type_template_id_7bc30550_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/AccessibleSelect.vue?vue&type=script&lang=js
/* harmony default export */ var AccessibleSelectvue_type_script_lang_js = ({
  name: 'AccessibleSelect',
  props: {
    id: {
      type: String,
      required: true,
      default: 'comboId'
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    value: {
      type: Object,
      default: () => {},
      required: true
    },
    variant: {
      enum: ['primary', 'secondary', 'light', 'dark'],
      default: 'primary'
    },
    showCaret: {
      type: Boolean,
      default: true
    },
    hasError: {
      type: Boolean
    },
    comboInputClass: {
      type: String,
      default: ''
    },
    verticalPosition: {
      type: String,
      default: null,
      validator: value => {
        return ['top', null].includes(value);
      }
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    noRoundedCorner: {
      type: Boolean,
      default: false
    },
    inheritThemeColor: {
      type: Boolean,
      default: null
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    selectedOptionAlignment: {
      type: String,
      default: 'leftAlign'
    },
    transparentOptionBackground: {
      type: Boolean,
      default: false
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    showShadows: {
      type: Boolean,
      default: false
    },
    defaultSelectedText: {
      type: Object,
      default: () => {
        return {
          label: ''
        };
      }
    },
    optionIcon: {
      type: String,
      default: 'caret'
    },
    dataTestId: {
      type: [String, null],
      default: null
    }
  },
  data() {
    return {
      activeIndex: 0,
      open: false,
      searchString: '',
      searchTimeout: null,
      comboboxValue: '',
      SelectActions: {
        Close: 0,
        CloseSelect: 1,
        First: 2,
        Last: 3,
        Next: 4,
        Open: 5,
        PageDown: 6,
        PageUp: 7,
        Previous: 8,
        Select: 9,
        Type: 10
      },
      interactionType: 'mouse'
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.value?.label) {
        this.comboboxValue = this.value.label;
      } else if (this.options?.length) {
        this.comboboxValue = this.options?.[0]?.label;
      } else {
        this.comboboxValue = this.defaultSelectedText?.label;
      }
    },
    onOptionMouseDown() {
      this.ignoreBlur = true;
    },
    getOptionId(index) {
      return `${this.id}-${index}`;
    },
    isElementInView(element) {
      const bounding = element.getBoundingClientRect();
      return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
    },
    updateMenuState(open, callFocus = true) {
      if (this.open === open) {
        return;
      }
      this.open = open;
      const activeID = open ? `${this.id}-${this.activeIndex}` : '';
      this.$refs.comboEl.setAttribute('aria-activedescendant', activeID);
      if (activeID === '' && !this.isElementInView(this.$refs.comboEl)) {
        this.$refs.comboEl.scrollIntoView({
          behavior: 'smooth',
          block: this.verticalPosition === 'top' ? 'start' : 'nearest'
        });
      }
      callFocus && this.$refs.comboEl.focus();
    },
    onComboClick() {
      this.interactionType = 'mouse';
      this.updateMenuState(!this.open, false);
    },
    selectOption(index) {
      this.activeIndex = index;
      const selected = this.options[index];
      this.$emit('input', selected);
    },
    onOptionChange(index) {
      this.activeIndex = index;
      this.$refs.comboEl.setAttribute('aria-activedescendant', `${this.id}-${index}`);
      const options = this.$el.querySelectorAll('[role=option]');
      if (this.isScrollable(this.$refs.listboxEl)) {
        this.maintainScrollVisibility(options[index], this.$refs.listboxEl);
      }
      if (!this.isElementInView(options[index])) {
        options[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    },
    maintainScrollVisibility(activeElement, scrollParent) {
      const {
        offsetHeight,
        offsetTop
      } = activeElement;
      const {
        offsetHeight: parentOffsetHeight,
        scrollTop
      } = scrollParent;
      const isAbove = offsetTop < scrollTop;
      const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
      if (isAbove) {
        scrollParent.scrollTo(0, offsetTop);
      } else if (isBelow) {
        scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
      }
    },
    onOptionClick(index) {
      this.onOptionChange(index);
      this.selectOption(index);
      this.updateMenuState(false);
    },
    isScrollable(element) {
      return element && element.clientHeight < element.scrollHeight;
    },
    onComboKeyDown(event) {
      this.interactionType = 'keyboard';
      const {
        key
      } = event;
      const max = this.options.length - 1;
      const action = this.getActionFromKey(event, this.open);
      if (this.options?.length) {
        switch (action) {
          case this.SelectActions.Last:
          case this.SelectActions.First:
            this.updateMenuState(true);
          // intentional fallthrough
          case this.SelectActions.Next:
          case this.SelectActions.Previous:
          case this.SelectActions.PageUp:
          case this.SelectActions.PageDown:
            event.preventDefault();
            return this.onOptionChange(this.getUpdatedIndex(this.activeIndex, max, action));
          case this.SelectActions.CloseSelect:
            event.preventDefault();
            this.selectOption(this.activeIndex);
          // eslint-disable-next-line no-fallthrough
          case this.SelectActions.Close:
            // intentional fallthrough
            event.preventDefault();
            return this.updateMenuState(false);
          case this.SelectActions.Type:
            return this.onComboType(key);
          case this.SelectActions.Open:
            event.preventDefault();
            return this.updateMenuState(true);
        }
      }
    },
    getActionFromKey(event, menuOpen) {
      const {
        key,
        altKey,
        ctrlKey,
        metaKey
      } = event;
      const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' '];
      if (!menuOpen && openKeys.includes(key)) {
        return this.SelectActions.Open;
      }
      if (key === 'Home') {
        return this.SelectActions.First;
      }
      if (key === 'End') {
        return this.SelectActions.Last;
      }
      if (key === 'Backspace' || key === 'Clear' || key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey) {
        return this.SelectActions.Type;
      }
      if (menuOpen) {
        if (key === 'ArrowUp' && altKey) {
          return this.SelectActions.CloseSelect;
        }
        if (key === 'ArrowDown' && !altKey) {
          return this.SelectActions.Next;
        }
        if (key === 'ArrowUp') {
          return this.SelectActions.Previous;
        }
        if (key === 'PageUp') {
          return this.SelectActions.PageUp;
        }
        if (key === 'PageDown') {
          return this.SelectActions.PageDown;
        }
        if (key === 'Escape') {
          return this.SelectActions.Close;
        }
        if (key === 'Enter' || key === ' ') {
          return this.SelectActions.CloseSelect;
        }
      }
    },
    onComboType(letter) {
      this.updateMenuState(true);
      const searchString = this.getSearchString(letter);
      const searchIndex = this.getIndexByLetter(this.options, searchString, this.activeIndex + 1);
      if (searchIndex >= 0) {
        this.onOptionChange(searchIndex);
      } else {
        window.clearTimeout(this.searchTimeout);
        this.searchString = '';
      }
    },
    getSearchString(char) {
      if (typeof this.searchTimeout === 'number') {
        window.clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = window.setTimeout(() => {
        this.searchString = '';
      }, 500);
      this.searchString += char;
      return this.searchString;
    },
    getIndexByLetter(options, filter, startIndex = 0) {
      const orderedOptions = [...options.slice(startIndex), ...options.slice(0, startIndex)];
      const firstMatch = this.filterOptions(orderedOptions, filter)[0];
      const allSameLetter = array => array.every(letter => letter === array[0]);
      if (firstMatch) {
        return options.indexOf(firstMatch);
      }
      if (allSameLetter(filter.split(''))) {
        const matches = this.filterOptions(orderedOptions, filter[0]);
        return options.indexOf(matches[0]);
      }
      return -1;
    },
    filterOptions(options = [], filter, exclude = []) {
      return options.filter(option => {
        const matches = option.label.toLowerCase().indexOf(filter.toLowerCase()) === 0;
        return matches && exclude.indexOf(option) < 0;
      });
    },
    getUpdatedIndex(currentIndex, maxIndex, action) {
      const pageSize = 10;
      switch (action) {
        case this.SelectActions.First:
          return 0;
        case this.SelectActions.Last:
          return maxIndex;
        case this.SelectActions.Previous:
          return Math.max(0, currentIndex - 1);
        case this.SelectActions.Next:
          return Math.min(maxIndex, currentIndex + 1);
        case this.SelectActions.PageUp:
          return Math.max(0, currentIndex - pageSize);
        case this.SelectActions.PageDown:
          return Math.min(maxIndex, currentIndex + pageSize);
        default:
          return currentIndex;
      }
    },
    onComboBlur() {
      if (this.ignoreBlur) {
        this.ignoreBlur = false;
        return;
      }
      if (this.open && this.options.length) {
        this.selectOption(this.activeIndex);
        this.updateMenuState(false, false);
      }
    }
  },
  computed: {
    computedBorderStyle() {
      return this.interactionType === 'keyboard' ? this.$style.selectedDropdownBorder : this.$style.optionCurrent;
    },
    isSelected() {
      return option => this.value && (this.value[this.valueKey] === option[this.valueKey]).toString();
    }
  },
  watch: {
    value(val, oldVal) {
      if (oldVal?.label !== val.label && this?.init) {
        this.init();
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/AccessibleSelect.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_AccessibleSelectvue_type_script_lang_js = (AccessibleSelectvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/AccessibleSelect.vue?vue&type=style&index=0&id=7bc30550&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var AccessibleSelectvue_type_style_index_0_id_7bc30550_prod_lang_scss_module_true = ({"light":"AccessibleSelect_light_WhGzU","root":"AccessibleSelect_root_IZiIT","primary":"AccessibleSelect_primary_tMuez","secondary":"AccessibleSelect_secondary_RZ1Wb","combo":"AccessibleSelect_combo_UJ2QU","top":"AccessibleSelect_top_j9KCg","comboMenu":"AccessibleSelect_comboMenu_P0huS","padding":"AccessibleSelect_padding_Nwgx1","border":"AccessibleSelect_border_ne0QP","secondaryColor":"AccessibleSelect_secondaryColor_RbShW","rounded":"AccessibleSelect_rounded_k0nZG","comboInput":"AccessibleSelect_comboInput_KHfg0","error":"AccessibleSelect_error_a2r1J","comboLabel":"AccessibleSelect_comboLabel_bJ6Pp","shadow":"AccessibleSelect_shadow_fnBl6","comboOption":"AccessibleSelect_comboOption_a8Q7c","hasTransparentBackground":"AccessibleSelect_hasTransparentBackground_rQp6F","selectedDropdownBorder":"AccessibleSelect_selectedDropdownBorder_nOGgo","optionCurrent":"AccessibleSelect_optionCurrent_dsade","open":"AccessibleSelect_open_n4dZH","optionIcon":"AccessibleSelect_optionIcon_xhTaY","caret":"AccessibleSelect_caret_uSqET","selected":"AccessibleSelect_selected_b9qeb","fullWidth":"AccessibleSelect_fullWidth_iECNJ"});
;// CONCATENATED MODULE: ./src/atoms/AccessibleSelect.vue?vue&type=style&index=0&id=7bc30550&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/atoms/AccessibleSelect.vue



;




function AccessibleSelect_injectStyles (context) {
  
  this["$style"] = (AccessibleSelectvue_type_style_index_0_id_7bc30550_prod_lang_scss_module_true.locals || AccessibleSelectvue_type_style_index_0_id_7bc30550_prod_lang_scss_module_true)

}

/* normalize component */

var AccessibleSelect_component = normalizeComponent(
  atoms_AccessibleSelectvue_type_script_lang_js,
  AccessibleSelectvue_type_template_id_7bc30550_render,
  AccessibleSelectvue_type_template_id_7bc30550_staticRenderFns,
  false,
  AccessibleSelect_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AccessibleSelect = (AccessibleSelect_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/VideoSettings.vue?vue&type=script&lang=js

/* harmony default export */ var VideoSettingsvue_type_script_lang_js = ({
  name: 'VideoSettings',
  props: {
    cameras: {
      type: Array,
      default: () => []
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showVideoMirrorOption: {
      type: Boolean,
      default: true
    },
    selectedCamera: {
      type: Object,
      default: () => {
        return {
          label: 'No Device Available'
        };
      }
    },
    error: {
      type: [String, Boolean]
    },
    active: [Boolean, String, Object],
    permission: [Boolean, Number],
    mirror: Boolean
  },
  components: {
    AccessibleSelect: AccessibleSelect
  },
  computed: {
    statusMessage() {
      let icon = 'videocam-muted';
      let status;
      if (!this.permission) {
        status = this.$t('Needs permission');
      }
      if (this.cameras.length == 0) {
        status = this.$t('Device not detected');
      }
      if (this.active && !this.error) {
        icon = 'videocam';
        status = this.$t('Camera is on');
      } else {
        status = this.$t('Camera is off');
      }
      return {
        icon,
        status
      };
    },
    errorMessage() {
      return this.error && typeof this.error == 'string' ? this.error : '';
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/VideoSettings.vue?vue&type=script&lang=js
 /* harmony default export */ var SettingsModal_VideoSettingsvue_type_script_lang_js = (VideoSettingsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/SettingsModal/VideoSettings.vue?vue&type=style&index=0&id=5fe149c2&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var VideoSettingsvue_type_style_index_0_id_5fe149c2_prod_module_true_lang_scss = ({"root":"VideoSettings_root_GSSf5","label":"VideoSettings_label_rPIyW","flex":"VideoSettings_flex_iVcKB","deviceList":"VideoSettings_deviceList_tDdE6","noIconList":"VideoSettings_noIconList_y5XFg","dropdown":"VideoSettings_dropdown_PWo5N","status":"VideoSettings_status_o0p9f","error":"VideoSettings_error_WQ2ku","mirror":"VideoSettings_mirror_BQM1i","comboElement":"VideoSettings_comboElement_G3u_g"});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/VideoSettings.vue?vue&type=style&index=0&id=5fe149c2&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/SettingsModal/VideoSettings.vue



;




function VideoSettings_injectStyles (context) {
  
  this["$style"] = (VideoSettingsvue_type_style_index_0_id_5fe149c2_prod_module_true_lang_scss.locals || VideoSettingsvue_type_style_index_0_id_5fe149c2_prod_module_true_lang_scss)

}

/* normalize component */

var VideoSettings_component = normalizeComponent(
  SettingsModal_VideoSettingsvue_type_script_lang_js,
  VideoSettingsvue_type_template_id_5fe149c2_render,
  VideoSettingsvue_type_template_id_5fe149c2_staticRenderFns,
  false,
  VideoSettings_injectStyles,
  null,
  null
  
)

/* harmony default export */ var VideoSettings = (VideoSettings_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/AudioSettings.vue?vue&type=template&id=3e6e6f06
var AudioSettingsvue_type_template_id_3e6e6f06_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [!_vm.showOnlySpeakerUI ? [_c('StyledText', {
    class: _vm.$style.label,
    attrs: {
      "variant": "subHeading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`Microphone`)) + " ")]), _c('div', {
    class: _vm.$style.flex
  }, [_c('div', {
    class: [_vm.$style.deviceList, !_vm.showIcon && _vm.$style.noIconList]
  }, [_c('AccessibleSelect', {
    class: _vm.$style.dropdown,
    attrs: {
      "id": "techcheckMicrophone",
      "valueKey": "deviceId",
      "value": _vm.selectedMicrophone,
      "transparentOptionBackground": true,
      "fullWidth": true,
      "showShadows": true,
      "options": _vm.microphones,
      "comboInputClass": _vm.$style.comboElement,
      "hasError": !!_vm.errors.microphone || !_vm.permissions.microphone
    },
    on: {
      "input": $event => _vm.$emit('selectMic', $event)
    }
  }), _vm.errorMessage.microphone ? _c('StyledText', {
    class: _vm.$style.error,
    attrs: {
      "color": "warning",
      "variant": "body14"
    }
  }, [_vm._v(" " + _vm._s(_vm.errorMessage.microphone) + " ")]) : _vm._e()], 1), _vm.showIcon ? _c('div', {
    class: _vm.$style.status
  }, [_c('SvgIcon', {
    attrs: {
      "name": _vm.statusMessageForMic.microphone.icon
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "body12",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.statusMessageForMic.microphone.status) + " ")])], 1) : _vm._e()]), _c('ProgressLevel', {
    ref: "audioIndicator",
    class: _vm.$style.audioLevel,
    attrs: {
      "bars": 20
    }
  })] : _vm._e(), _vm.showSpeakerSettings ? [_vm.showOnlySpeakerUI && !_vm.speakers.length ? _c('div', {
    class: _vm.$style.alterUI
  }, [_c('StyledText', {
    class: _vm.$style.labelText,
    attrs: {
      "variant": "subHeading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`Audio is being played in system's default audio device.`)) + " ")]), !_vm.isMobile ? _c('StyledText', {
    class: _vm.$style.linker,
    attrs: {
      "variant": "subHeading13"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openSystemLink');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`Click to view/change audio device`)) + " ")]) : _vm._e()], 1) : [_c('StyledText', {
    class: _vm.$style.label,
    attrs: {
      "variant": "subHeading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`Speaker`)) + " ")]), _c('div', {
    class: _vm.$style.flex
  }, [_c('div', {
    class: [_vm.$style.deviceList, !_vm.showIcon && _vm.$style.noIconList]
  }, [_c('AccessibleSelect', {
    class: _vm.$style.dropdown,
    attrs: {
      "id": "techcheckSpeaker",
      "valueKey": "deviceId",
      "transparentOptionBackground": true,
      "fullWidth": true,
      "showShadows": true,
      "value": _vm.selectedSpeaker,
      "options": _vm.speakers,
      "comboInputClass": _vm.$style.comboElement,
      "hasError": !!_vm.errors.microphone || !_vm.permissions.microphone
    },
    on: {
      "input": $event => _vm.$emit('selectSpeaker', $event)
    }
  }), _vm.errorMessage.speaker ? _c('StyledText', {
    class: _vm.$style.error,
    attrs: {
      "color": "warning",
      "variant": "body14"
    }
  }, [_vm._v(" " + _vm._s(_vm.errorMessage.speaker) + " ")]) : _vm._e()], 1), _vm.showIcon ? _c('div', {
    class: _vm.$style.status
  }, [_c('SvgIcon', {
    attrs: {
      "name": _vm.speakers.length ? 'volume' : 'faunmute'
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "body12",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.speakers.length ? _vm.$options.$t('Speaker is on') : _vm.$options.$t('Device not detected')) + " ")])], 1) : _vm._e()])], _vm.showAudioTestButton ? _c('div', {
    class: _vm.$style.speakerTest
  }, [_c('OutlinedButton', {
    attrs: {
      "icon": _vm.isAudioPlaying ? 'faunmute' : 'volume',
      "loading": _vm.isAudioLoading,
      "disabled": _vm.isAudioLoading,
      "uppercase": false,
      "variant": "primary",
      "size": "small",
      "alt": ""
    },
    on: {
      "click": _vm.toggleAudioPlay
    }
  }, [_vm._v(" " + _vm._s(_vm.isAudioPlaying ? _vm.$options.$t('Stop Test') : _vm.$options.$t('Test your system’s audio')) + " ")]), _c('ProgressLevel', {
    ref: "fakeAudioIndicator",
    class: _vm.$style.audioLevel,
    attrs: {
      "bars": 20
    }
  }), _vm.isAudioPlaying ? _c('StyledText', {
    class: _vm.$style.issue,
    attrs: {
      "underline": ""
    },
    on: {
      "click": _vm.openHelpDoc
    }
  }, [_vm._v(_vm._s(_vm.$options.$t("Still can't hear any sound?")))]) : _vm._e(), _c('audio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "audiofile",
    attrs: {
      "controls": "",
      "loop": ""
    },
    on: {
      "ended": _vm.audioFileEnded,
      "play": _vm.audioFileStarted
    }
  }, [_c('source', {
    attrs: {
      "src": "https://s3.amazonaws.com/staticassets.goldcast.com/audiotest.mp3",
      "type": "audio/mpeg"
    }
  }), _vm._v(" " + _vm._s(_vm.$options.$t('Issue Testing Audio!')) + " ")])], 1) : _vm._e()] : _vm._e()], 2);
};
var AudioSettingsvue_type_template_id_3e6e6f06_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/AudioSettings.vue?vue&type=script&lang=js


/* harmony default export */ var AudioSettingsvue_type_script_lang_js = ({
  name: 'AudioSettings',
  components: {
    AccessibleSelect: AccessibleSelect
  },
  props: {
    microphones: {
      type: Array,
      default: () => []
    },
    showOnlySpeakerUI: {
      type: Boolean,
      default: false
    },
    showAudioTestButton: {
      type: Boolean,
      default: true
    },
    selectedMicrophone: {
      type: Object,
      default: () => {
        return {
          label: 'No Device Available'
        };
      }
    },
    speakers: {
      type: Array,
      default: () => []
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showSpeakerSettings: {
      type: Boolean,
      default: true
    },
    selectedSpeaker: {
      type: Object,
      default: () => {
        return {
          label: 'No Device Available'
        };
      }
    },
    errors: Object,
    active: Object,
    permissions: Object
  },
  data() {
    return {
      isAudioPlaying: false,
      isAudioLoading: false
    };
  },
  computed: {
    isMobile() {
      return window.mobileCheck && window.mobileCheck();
    },
    statusMessageForMic() {
      const icons = {
        micOn: 'mic',
        micOff: 'muted'
      };
      return ['microphone'].reduce((acc, device) => {
        let icon = icons.micOff;
        let status;
        if (!this.permissions.microphone) {
          status = this.$t('Needs permission');
        } else if (this.microphones.length === 0) {
          status = this.$t('Device not detected');
        } else if (this.active.microphone && !this.error?.microphone) {
          icon = icons.micOn;
          status = this.$t('Microphone is on');
        } else {
          status = this.$t('Microphone is off');
        }
        return {
          ...acc,
          [device]: {
            icon,
            status
          }
        };
      }, {});
    },
    errorMessage() {
      return ['microphone', 'speaker'].reduce((acc, device) => {
        if (this.errors[device] && typeof this.errors[device] == 'string') {
          acc[device] = this.errors[device];
        }
        return acc;
      }, {});
    },
    audioOutputDeviceId() {
      return this.selectedSpeaker?.deviceId ?? '';
    }
  },
  methods: {
    audioFileEnded() {
      this.isAudioLoading = false;
    },
    audioFileStarted() {
      this.isAudioLoading = false;
    },
    runFakIndicatorUpdate() {
      if (this.isAudioPlaying) {
        setTimeout(() => {
          this.runFakIndicatorUpdate();
        }, 200);
        let audioLevel = 0;
        if (this.isAudioLoading) {
          audioLevel = 0;
        } else {
          audioLevel = 40 + Math.random() * 60;
        }
        if (this.$refs.fakeAudioIndicator?.setLevel) {
          this.$refs.fakeAudioIndicator.setLevel(audioLevel);
        }
      } else {
        if (this.$refs.fakeAudioIndicator?.setLevel) {
          this.$refs.fakeAudioIndicator.setLevel(0);
        }
      }
    },
    toggleAudioPlay() {
      if (!this.isAudioPlaying) {
        this.isAudioLoading = true;
        this.setAudioOutputDevice();
        this.$refs.audiofile.play();
      } else {
        this.$refs.audiofile.pause();
      }
      this.isAudioPlaying = !this.isAudioPlaying;
      this.runFakIndicatorUpdate();
    },
    setAudioOutputDevice() {
      try {
        if (this.audioOutputDeviceId) {
          this.$refs.audiofile?.setSinkId(this.audioOutputDeviceId).then(() => {}).catch(function (error) {
            var errorMessage = error;
            if (error.name === 'SecurityError') {
              errorMessage = 'You need to use HTTPS for selecting audio output ' + 'device: ' + error;
            }
            throw errorMessage;
          });
        }
      } catch (error) {
        console.error('Error while playing audio asset :', error);
      }
    },
    openHelpDoc() {
      window.open(helpDocLinks.AUDIO_SETTINGS, '_blank');
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/AudioSettings.vue?vue&type=script&lang=js
 /* harmony default export */ var SettingsModal_AudioSettingsvue_type_script_lang_js = (AudioSettingsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/SettingsModal/AudioSettings.vue?vue&type=style&index=0&id=3e6e6f06&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var AudioSettingsvue_type_style_index_0_id_3e6e6f06_prod_module_true_lang_scss = ({"root":"AudioSettings_root_rD7jQ","alterUI":"AudioSettings_alterUI_ycbjq","labelText":"AudioSettings_labelText_tq7Un","linker":"AudioSettings_linker_J51Rj","label":"AudioSettings_label_oY8fy","flex":"AudioSettings_flex_ryF33","deviceList":"AudioSettings_deviceList_zJWLW","noIconList":"AudioSettings_noIconList_tROtW","dropdown":"AudioSettings_dropdown_n8Coc","status":"AudioSettings_status_TDXrr","audioLevel":"AudioSettings_audioLevel_fCn8b","error":"AudioSettings_error_pWZXd","speakerTest":"AudioSettings_speakerTest_w6lr5","issue":"AudioSettings_issue_njFGD","comboElement":"AudioSettings_comboElement_sjfRn"});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/AudioSettings.vue?vue&type=style&index=0&id=3e6e6f06&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/SettingsModal/AudioSettings.vue



;




function AudioSettings_injectStyles (context) {
  
  this["$style"] = (AudioSettingsvue_type_style_index_0_id_3e6e6f06_prod_module_true_lang_scss.locals || AudioSettingsvue_type_style_index_0_id_3e6e6f06_prod_module_true_lang_scss)

}

/* normalize component */

var AudioSettings_component = normalizeComponent(
  SettingsModal_AudioSettingsvue_type_script_lang_js,
  AudioSettingsvue_type_template_id_3e6e6f06_render,
  AudioSettingsvue_type_template_id_3e6e6f06_staticRenderFns,
  false,
  AudioSettings_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AudioSettings = (AudioSettings_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/VirtualBackgroundSettings.vue?vue&type=template&id=50822888
var VirtualBackgroundSettingsvue_type_template_id_50822888_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: _vm.$style.label,
    attrs: {
      "variant": "subHeading13",
      "uppercase": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Virtual Backgrounds')) + " ")]), _c('ul', {
    class: _vm.$style.videos
  }, _vm._l(_vm.backgrounds, function ({
    value,
    background,
    label
  }, index) {
    return _c('li', {
      key: value + index
    }, [_c('button', {
      attrs: {
        "id": value,
        "aria-pressed": _vm.selectedVirtualBackground === value ? 'true' : 'false',
        "aria-label": label !== '' ? label : 'Custom Virtual Background'
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('setVirtualBackground', value);
        }
      }
    }, [_c('img', {
      class: {
        [_vm.$style.selected]: _vm.selectedVirtualBackground === value
      },
      attrs: {
        "src": background,
        "alt": "Virtual Background"
      }
    })])]);
  }), 0)], 1);
};
var VirtualBackgroundSettingsvue_type_template_id_50822888_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/VirtualBackgroundSettings.vue?vue&type=script&lang=js
/* harmony default export */ var VirtualBackgroundSettingsvue_type_script_lang_js = ({
  name: 'VirtualBackgroundSettings',
  props: {
    virtualBackgrounds: {
      type: Array,
      default: () => []
    },
    selectedVirtualBackground: String
  },
  computed: {
    backgrounds() {
      return [{
        label: 'Turn off visual effects',
        value: '',
        background: 'https://d6d4ismr40iw.cloudfront.net/no-blur.svg'
      }, {
        label: 'Blur your background',
        value: 'blur',
        background: 'https://d6d4ismr40iw.cloudfront.net/blur.svg'
      }, ...this.virtualBackgrounds.map(background => ({
        background,
        // This is temporary until we have label system implement in admin panel
        label: '',
        value: background
      }))];
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/VirtualBackgroundSettings.vue?vue&type=script&lang=js
 /* harmony default export */ var SettingsModal_VirtualBackgroundSettingsvue_type_script_lang_js = (VirtualBackgroundSettingsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/SettingsModal/VirtualBackgroundSettings.vue?vue&type=style&index=0&id=50822888&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var VirtualBackgroundSettingsvue_type_style_index_0_id_50822888_prod_module_true_lang_scss = ({"root":"VirtualBackgroundSettings_root_yNFlj","label":"VirtualBackgroundSettings_label_UglC_","videos":"VirtualBackgroundSettings_videos_VMEDg","selected":"VirtualBackgroundSettings_selected_B7g7y"});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/VirtualBackgroundSettings.vue?vue&type=style&index=0&id=50822888&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/SettingsModal/VirtualBackgroundSettings.vue



;




function VirtualBackgroundSettings_injectStyles (context) {
  
  this["$style"] = (VirtualBackgroundSettingsvue_type_style_index_0_id_50822888_prod_module_true_lang_scss.locals || VirtualBackgroundSettingsvue_type_style_index_0_id_50822888_prod_module_true_lang_scss)

}

/* normalize component */

var VirtualBackgroundSettings_component = normalizeComponent(
  SettingsModal_VirtualBackgroundSettingsvue_type_script_lang_js,
  VirtualBackgroundSettingsvue_type_template_id_50822888_render,
  VirtualBackgroundSettingsvue_type_template_id_50822888_staticRenderFns,
  false,
  VirtualBackgroundSettings_injectStyles,
  null,
  null
  
)

/* harmony default export */ var VirtualBackgroundSettings = (VirtualBackgroundSettings_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/HelpDocLinkSettingsModal.vue?vue&type=template&id=60165819
var HelpDocLinkSettingsModalvue_type_template_id_60165819_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('SvgIcon', {
    class: _vm.$style.icon,
    attrs: {
      "name": "question",
      "color": "secondary-text-color"
    }
  }), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "color": "theme-secondary-color",
      "variant": "heading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Questions?')) + " ")]), _c('StyledText', {
    attrs: {
      "vraiant": "body12"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('If you’re having issues, check out our comprehensive')) + " "), _c('a', {
    attrs: {
      "href": _vm.helpLink,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('help docs')) + " "), _c('SvgIcon', {
    attrs: {
      "size": "small",
      "name": "link"
    }
  })], 1)])], 1);
};
var HelpDocLinkSettingsModalvue_type_template_id_60165819_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/HelpDocLinkSettingsModal.vue?vue&type=script&lang=js
/* harmony default export */ var HelpDocLinkSettingsModalvue_type_script_lang_js = ({
  name: 'HelpDocLinkSettingsModal',
  props: {
    helpLink: String
  }
});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/HelpDocLinkSettingsModal.vue?vue&type=script&lang=js
 /* harmony default export */ var SettingsModal_HelpDocLinkSettingsModalvue_type_script_lang_js = (HelpDocLinkSettingsModalvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/SettingsModal/HelpDocLinkSettingsModal.vue?vue&type=style&index=0&id=60165819&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var HelpDocLinkSettingsModalvue_type_style_index_0_id_60165819_prod_module_true_lang_scss = ({"root":"HelpDocLinkSettingsModal_root_e6b6o","icon":"HelpDocLinkSettingsModal_icon_G_LWL"});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/HelpDocLinkSettingsModal.vue?vue&type=style&index=0&id=60165819&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/SettingsModal/HelpDocLinkSettingsModal.vue



;




function HelpDocLinkSettingsModal_injectStyles (context) {
  
  this["$style"] = (HelpDocLinkSettingsModalvue_type_style_index_0_id_60165819_prod_module_true_lang_scss.locals || HelpDocLinkSettingsModalvue_type_style_index_0_id_60165819_prod_module_true_lang_scss)

}

/* normalize component */

var HelpDocLinkSettingsModal_component = normalizeComponent(
  SettingsModal_HelpDocLinkSettingsModalvue_type_script_lang_js,
  HelpDocLinkSettingsModalvue_type_template_id_60165819_render,
  HelpDocLinkSettingsModalvue_type_template_id_60165819_staticRenderFns,
  false,
  HelpDocLinkSettingsModal_injectStyles,
  null,
  null
  
)

/* harmony default export */ var HelpDocLinkSettingsModal = (HelpDocLinkSettingsModal_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/ErrorComp.vue?vue&type=template&id=564be484
var ErrorCompvue_type_template_id_564be484_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('IconButton', {
    class: _vm.$style.errorIcon,
    attrs: {
      "variant": "highlight",
      "icon": _vm.errorIcon
    }
  }), _c('div', [_c('StyledText', {
    attrs: {
      "variant": "heading13",
      "color": "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.errorTitle)) + " ")]), _vm._t("errorText")], 2)], 1);
};
var ErrorCompvue_type_template_id_564be484_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/ErrorComp.vue?vue&type=script&lang=js
/* harmony default export */ var ErrorCompvue_type_script_lang_js = ({
  name: 'ErrorComp',
  props: {
    errorIcon: {
      type: String
    },
    errorTitle: {
      type: String
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/ErrorComp.vue?vue&type=script&lang=js
 /* harmony default export */ var SettingsModal_ErrorCompvue_type_script_lang_js = (ErrorCompvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/SettingsModal/ErrorComp.vue?vue&type=style&index=0&id=564be484&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ErrorCompvue_type_style_index_0_id_564be484_prod_module_true_lang_scss = ({"root":"ErrorComp_root_cKHPx","lockIcon":"ErrorComp_lockIcon_YuWhg","errorIcon":"ErrorComp_errorIcon_sHApe"});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/ErrorComp.vue?vue&type=style&index=0&id=564be484&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/SettingsModal/ErrorComp.vue



;




function ErrorComp_injectStyles (context) {
  
  this["$style"] = (ErrorCompvue_type_style_index_0_id_564be484_prod_module_true_lang_scss.locals || ErrorCompvue_type_style_index_0_id_564be484_prod_module_true_lang_scss)

}

/* normalize component */

var ErrorComp_component = normalizeComponent(
  SettingsModal_ErrorCompvue_type_script_lang_js,
  ErrorCompvue_type_template_id_564be484_render,
  ErrorCompvue_type_template_id_564be484_staticRenderFns,
  false,
  ErrorComp_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ErrorComp = (ErrorComp_component.exports);
;// CONCATENATED MODULE: ./src/utils/accessibility.js

const eventListeners = [];
const focusTrap = ({
  getAllFocusableElementOf,
  allFocusableElements,
  firstFocusableElement,
  lastFocusableElement,
  focusFirstElementOnMount = false,
  executeOnEscape
}) => {
  const focusableElements = allFocusableElements || (getAllFocusableElementOf || document).querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"]), [tabindex="0"]');
  let filterFocusableElements = [];
  focusableElements.forEach(element => {
    if (element.getAttribute('tabindex') !== '-1') {
      filterFocusableElements.push(element);
    }
  });
  const firstFocusable = firstFocusableElement || filterFocusableElements[0];
  const lastFocusable = lastFocusableElement || filterFocusableElements[filterFocusableElements.length - 1];
  if (focusFirstElementOnMount) {
    firstFocusable.focus();
  }
  const handleKeyDown = event => {
    if (event.key === 'Tab') {
      if (event.shiftKey) {
        if (document.activeElement === firstFocusable) {
          lastFocusable.focus();
          event.preventDefault();
        }
      } else if (document.activeElement === lastFocusable) {
        firstFocusable.focus();
        event.preventDefault();
      }
    } else if (executeOnEscape && event.key === 'Escape') {
      executeOnEscape();
    }
  };
  if (eventListeners.length > 0) {
    eventListeners.forEach(eventListener => {
      document.removeEventListener('keydown', eventListener);
    });
    eventListeners.length = 0;
  }
  eventListeners.push(handleKeyDown);
  document.addEventListener('keydown', handleKeyDown);
};
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/SettingsModal/SettingsModal.vue?vue&type=script&lang=js







/* harmony default export */ var SettingsModalvue_type_script_lang_js = ({
  name: 'SettingsModal',
  components: {
    VideoSettings: VideoSettings,
    AudioSettings: AudioSettings,
    VirtualBackgroundSettings: VirtualBackgroundSettings,
    HelpDocLinkSettingsModal: HelpDocLinkSettingsModal,
    ErrorComp: ErrorComp
  },
  props: {
    dark: {
      type: Boolean,
      default: true
    },
    currentTab: {
      type: String,
      default: 'video'
    },
    errors: {
      type: Object,
      default: () => {}
    },
    browser: {
      type: String,
      default: 'Chrome'
    },
    mirror: Boolean,
    deviceErrorHeader: Object,
    permissionErrorHeader: Object,
    active: Object,
    permissions: Object,
    cameras: Array,
    microphones: Array,
    speakers: Array,
    selectedCamera: Object,
    selectedMicrophone: Object,
    selectedSpeaker: Object,
    showOnlySpeakerUI: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: () => []
    },
    virtualBackgrounds: {
      type: Array,
      default: () => []
    },
    selectedVirtualBackground: String
  },
  data() {
    return {
      helpLink: helpDocLinks.CAMERA_MIC_SETUP,
      firstFocusableElement: null
    };
  },
  mounted() {
    this.updateFocusTrap();
    const settingsItems = document.querySelector('#settingItems');
    this.$nextTick(() => {
      settingsItems?.querySelector('ul li button')?.focus();
      settingsItems?.addEventListener('keydown', this.handleMenuKeyDown);
    });
  },
  methods: {
    getStepTwoText(type) {
      if (this.browser === 'Safari') {
        if (type == 'both') {
          return this.$t(`2. Set camera and microphone to “Allow”.`);
        }
        if (type == 'camera') {
          return this.$t(`2. Set camera to “Allow”.`);
        }
        if (type == 'microphone') {
          return this.$t(`2. Set microphone to "Allow"`);
        }
      } else {
        if (type == 'both') {
          return this.$t(`2. Choose "Always allow Goldcast to access your camera and microphone"`);
        }
        if (type == 'camera') {
          return this.$t(`2. Choose "Always allow Goldcast to access your camera."`);
        }
        if (type == 'microphone') {
          return this.$t(`2. Choose "Always allow Goldcast to access your microphone"`);
        }
      }
      return this.$t(`2. Choose "Always allow Goldcast to access your camera and microphone"`);
    },
    onTabClick(tab) {
      this.$emit('tab', tab.id);
      const settingContent = this.$refs.settingContent;
      this.$nextTick(() => {
        settingContent.focus();
      });
    },
    updateFocusTrap() {
      if (this.focusTrapInstance) {
        this.focusTrapInstance.destroy();
      }
      this.focusTrapInstance = focusTrap({
        getAllFocusableElementOf: this.$el,
        focusFirstElementOnMount: false,
        executeOnEscape: () => {
          this.handleClose();
        }
      });
    },
    handleMenuKeyDown(event) {
      const {
        key
      } = event;
      const allMenuItems = document.querySelector('#settingItems')?.querySelectorAll('ul li button');
      const firstFocusableElement = allMenuItems?.[0];
      const lastFocusableElement = allMenuItems?.[allMenuItems.length - 1];
      if (key === 'ArrowDown') {
        event.preventDefault();
        if (event.target === lastFocusableElement) {
          firstFocusableElement?.focus();
        } else {
          event.target.parentElement.nextElementSibling?.querySelector('button')?.focus();
        }
      } else if (key === 'ArrowUp') {
        event.preventDefault();
        if (event.target === firstFocusableElement) {
          lastFocusableElement?.focus();
        } else {
          event.target.parentElement.previousElementSibling?.querySelector('button')?.focus();
        }
      }
    },
    handleClose() {
      this.$emit('cancel');
      this.$nextTick(() => {
        document.querySelector('#settingIconButton')?.focus();
      });
    }
  },
  computed: {
    hasError() {
      return Object.keys(this.errors).some(key => this.errors[key]);
    }
  },
  watch: {
    currentTab: {
      handler(oldVal, newVal) {
        this.$nextTick(() => {
          if (oldVal !== newVal) {
            this.updateFocusTrap();
          }
        });
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/SettingsModal.vue?vue&type=script&lang=js
 /* harmony default export */ var SettingsModal_SettingsModalvue_type_script_lang_js = (SettingsModalvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/SettingsModal/SettingsModal.vue?vue&type=style&index=0&id=cee13d6e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SettingsModalvue_type_style_index_0_id_cee13d6e_prod_module_true_lang_scss = ({"root":"SettingsModal_root_PCqOB","dark":"SettingsModal_dark_xxJwk","header":"SettingsModal_header_ovA0_","cancelButton":"SettingsModal_cancelButton__A_iA","body":"SettingsModal_body_uZvFS","sidebar":"SettingsModal_sidebar_Ic_cY","tab":"SettingsModal_tab_tF9Eo","icon":"SettingsModal_icon_RZGFI","video":"SettingsModal_video_yom1Q","withError":"SettingsModal_withError_jDZL4","active":"SettingsModal_active_q3ACY","hasError":"SettingsModal_hasError_YzYwS","content":"SettingsModal_content_rnFZq","crossIconContainer":"SettingsModal_crossIconContainer_c2gc5","crossIconContent":"SettingsModal_crossIconContent_QLxOS","permissionErrorText":"SettingsModal_permissionErrorText_xGnYJ","lockIcon":"SettingsModal_lockIcon_Q1y2F","tabHeading":"SettingsModal_tabHeading_AP_EG"});
;// CONCATENATED MODULE: ./src/examples/SettingsModal/SettingsModal.vue?vue&type=style&index=0&id=cee13d6e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/SettingsModal/SettingsModal.vue



;




function SettingsModal_injectStyles (context) {
  
  this["$style"] = (SettingsModalvue_type_style_index_0_id_cee13d6e_prod_module_true_lang_scss.locals || SettingsModalvue_type_style_index_0_id_cee13d6e_prod_module_true_lang_scss)

}

/* normalize component */

var SettingsModal_component = normalizeComponent(
  SettingsModal_SettingsModalvue_type_script_lang_js,
  SettingsModalvue_type_template_id_cee13d6e_render,
  SettingsModalvue_type_template_id_cee13d6e_staticRenderFns,
  false,
  SettingsModal_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SettingsModal = (SettingsModal_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/VirtualScroll/VirtualScroll.vue?vue&type=template&id=a2b91814
var VirtualScrollvue_type_template_id_a2b91814_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "parentContainer",
    class: _vm.$style.root
  }, [_c('div', {
    ref: "scrollerRef",
    style: _vm.parentContainerStyle,
    on: {
      "&scroll": function ($event) {
        return _vm.handleScroll.apply(null, arguments);
      }
    }
  }, [_c('div', {
    style: _vm.itemsContainerStyle
  }, [_c('div', {
    style: _vm.offsetY
  }, [_c('div', {
    class: _vm.$style.scrollContainer,
    attrs: {
      "data-testmarker": _vm.dataTestmarker,
      "role": _vm.role
    }
  }, [_vm._l(_vm.itemsArrayUpdated, function (item, index) {
    return _vm._t("default", null, {
      "item": item,
      "index": index
    });
  })], 2)])])])]);
};
var VirtualScrollvue_type_template_id_a2b91814_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/VirtualScroll/VirtualScroll.vue?vue&type=script&lang=js
/* harmony default export */ var VirtualScrollvue_type_script_lang_js = ({
  name: 'VirtualScroll',
  props: {
    itemsArray: {
      type: Array,
      default: () => [],
      required: true
    },
    cardWidth: {
      type: Number,
      default: 50,
      //make sure u have added margin of card to width prop
      required: true
    },
    cardHeight: {
      type: Number,
      default: 50,
      //make sure u have added margin of card to height prop
      required: true
    },
    dataTestmarker: {
      type: String,
      default: ''
    },
    role: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      nodePadding: 0,
      // extra cards that are added on top and bottom of view port
      rowWiseCardLength: 0,
      // no of cards to render in one row
      scrollTop: 0,
      containerHeight: 100,
      containerWidth: 100,
      maxCardWidth: '100px'
    };
  },
  mounted() {
    this.startUpTask();
    window.addEventListener('resize', () => {
      this.handleResize();
    });
  },
  destroyed() {
    window.removeEventListener('resize', () => {
      this.handleResize();
    });
  },
  computed: {
    parentContainerStyle() {
      return {
        height: `${this.containerHeight}px`,
        width: '100%',
        overflow: 'auto'
      };
    },
    itemsContainerStyle() {
      const maxNoOfRowsAllowed = Math.ceil(this.itemsArray.length / this.rowWiseCardLength);
      return {
        height: `${this.cardHeight * maxNoOfRowsAllowed}px`,
        overflow: 'hidden',
        '--max-width': this.maxCardWidth
      };
    },
    startingIndex() {
      const startNode = Math.floor(this.scrollTop / this.cardHeight) * this.rowWiseCardLength - this.nodePadding;
      return Math.max(0, startNode);
    },
    visibleCardsLength() {
      const totalNoOfRows = Math.ceil(this.containerHeight / this.cardHeight);
      const visibleNodes = totalNoOfRows * this.rowWiseCardLength + 2 * this.nodePadding;
      return Math.min(this.itemsArray.length - this.startingIndex, visibleNodes);
    },
    itemsArrayUpdated() {
      return this.itemsArray.slice(this.startingIndex, this.startingIndex + this.visibleCardsLength);
    },
    offsetY() {
      return {
        transform: `translateY(${Math.floor(this.startingIndex / this.rowWiseCardLength) * this.cardHeight}px)`
      };
    }
  },
  methods: {
    handleScroll() {
      const el = this.$refs.scrollerRef;
      requestAnimationFrame(() => {
        this.scrollTop = el.scrollTop;
      });
    },
    handleResize() {
      this.startUpTask();
    },
    startUpTask() {
      const el = this.$refs.parentContainer;
      const boundingClientRect = el?.getBoundingClientRect();
      if (!boundingClientRect) {
        return;
      }
      this.containerHeight = boundingClientRect.height;
      this.containerWidth = boundingClientRect.width;
      this.nodePadding = Math.floor(boundingClientRect.width / this.cardWidth);
      this.rowWiseCardLength = this.nodePadding;
      this.maxCardWidth = `${boundingClientRect.width / this.nodePadding}px`;
      this.handleScroll();
    }
  }
});
;// CONCATENATED MODULE: ./src/components/VirtualScroll/VirtualScroll.vue?vue&type=script&lang=js
 /* harmony default export */ var VirtualScroll_VirtualScrollvue_type_script_lang_js = (VirtualScrollvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/VirtualScroll/VirtualScroll.vue?vue&type=style&index=0&id=a2b91814&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var VirtualScrollvue_type_style_index_0_id_a2b91814_prod_lang_scss_module_true = ({"root":"VirtualScroll_root_OxrIr","scrollContainer":"VirtualScroll_scrollContainer_JXruB"});
;// CONCATENATED MODULE: ./src/components/VirtualScroll/VirtualScroll.vue?vue&type=style&index=0&id=a2b91814&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/VirtualScroll/VirtualScroll.vue



;




function VirtualScroll_injectStyles (context) {
  
  this["$style"] = (VirtualScrollvue_type_style_index_0_id_a2b91814_prod_lang_scss_module_true.locals || VirtualScrollvue_type_style_index_0_id_a2b91814_prod_lang_scss_module_true)

}

/* normalize component */

var VirtualScroll_component = normalizeComponent(
  VirtualScroll_VirtualScrollvue_type_script_lang_js,
  VirtualScrollvue_type_template_id_a2b91814_render,
  VirtualScrollvue_type_template_id_a2b91814_staticRenderFns,
  false,
  VirtualScroll_injectStyles,
  null,
  null
  
)

/* harmony default export */ var VirtualScroll = (VirtualScroll_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SpeakerCard.vue?vue&type=template&id=3d7b09a5
var SpeakerCardvue_type_template_id_3d7b09a5_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    key: _vm.keyValue,
    class: [_vm.$style.root, _vm.isBlurBg ? _vm.$style.blurBg : _vm.$style.noBlurBg],
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": 'Click this button to open user profile of' + _vm.user.name
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('viewProfileClick', _vm.user);
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.$emit('viewProfileClick', _vm.user);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.preventDefault();
        return _vm.$emit('viewProfileClick', _vm.user);
      }]
    }
  }, [_c('UserImage', {
    key: _vm.user.id,
    attrs: {
      "user": _vm.user,
      "size": "midlarge",
      "imageScale": "medium"
    }
  }), _c('StyledText', {
    class: _vm.$style.speakerName,
    attrs: {
      "variant": "heading15",
      "align": "center",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.user.name) + " ")]), _c('StyledText', {
    class: _vm.$style.speakerInfo,
    attrs: {
      "variant": "body13",
      "align": "center",
      "color": "primary-text-color"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.user.title))]), _c('div', [_vm._v(_vm._s(_vm.user.company))])]), _c('div', {
    class: _vm.$style.viewProfileActionsWrapper
  }, [_c('div', {
    class: _vm.$style.viewProfileButton
  }, [_c('StyledText', {
    class: _vm.$style.viewProfileAction,
    attrs: {
      "variant": "body13",
      "align": "center",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('VIEW PROFILE')) + " ")])], 1)])], 1);
};
var SpeakerCardvue_type_template_id_3d7b09a5_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SpeakerCard.vue?vue&type=script&lang=js
/* harmony default export */ var SpeakerCardvue_type_script_lang_js = ({
  name: 'SpeakerCard',
  props: {
    user: {
      type: Object,
      // {name, display_email, image, thumbnail}
      default: () => {}
    },
    keyValue: {
      type: Number,
      default: 0,
      required: true
    },
    isBlurBg: {
      type: Boolean,
      default: true
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SpeakerCard.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SpeakerCardvue_type_script_lang_js = (SpeakerCardvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SpeakerCard.vue?vue&type=style&index=0&id=3d7b09a5&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SpeakerCardvue_type_style_index_0_id_3d7b09a5_prod_lang_scss_module_true = ({"root":"SpeakerCard_root_UtNzd","blurBg":"SpeakerCard_blurBg_tYTP_","noBlurBg":"SpeakerCard_noBlurBg_NfePb","viewProfileActionsWrapper":"SpeakerCard_viewProfileActionsWrapper_NKn5Y","speakerInfo":"SpeakerCard_speakerInfo_VDRmd","viewProfileButton":"SpeakerCard_viewProfileButton_EEL6p","speakerName":"SpeakerCard_speakerName_c5AfV"});
;// CONCATENATED MODULE: ./src/components/SpeakerCard.vue?vue&type=style&index=0&id=3d7b09a5&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/SpeakerCard.vue



;




function SpeakerCard_injectStyles (context) {
  
  this["$style"] = (SpeakerCardvue_type_style_index_0_id_3d7b09a5_prod_lang_scss_module_true.locals || SpeakerCardvue_type_style_index_0_id_3d7b09a5_prod_lang_scss_module_true)

}

/* normalize component */

var SpeakerCard_component = normalizeComponent(
  components_SpeakerCardvue_type_script_lang_js,
  SpeakerCardvue_type_template_id_3d7b09a5_render,
  SpeakerCardvue_type_template_id_3d7b09a5_staticRenderFns,
  false,
  SpeakerCard_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SpeakerCard = (SpeakerCard_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/AccessibleRating.vue?vue&type=template&id=976c461e
var AccessibleRatingvue_type_template_id_976c461e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "rating",
    attrs: {
      "tabindex": "0",
      "role": "slider",
      "aria-valuemin": "0",
      "aria-valuemax": _vm.maxRating,
      "aria-valuenow": _vm.rating,
      "aria-label": "Rating"
    },
    on: {
      "keydown": _vm.handleKeyDown
    }
  }, _vm._l(_vm.stars, function (star) {
    return _c('span', {
      key: star,
      class: ['star', {
        filled: star <= _vm.rating
      }],
      attrs: {
        "tabindex": "0",
        "role": "radio",
        "aria-checked": star <= _vm.rating
      },
      on: {
        "click": function ($event) {
          return _vm.setRating(star);
        },
        "keydown": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.setRating(star);
        },
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
          return _vm.setRating(star);
        },
        "mouseenter": function ($event) {
          return _vm.handleHover(star);
        },
        "mouseleave": function ($event) {
          return _vm.handleHover(0);
        }
      }
    }, [_c('SvgIcon', {
      staticClass: "starIcon",
      attrs: {
        "name": _vm.starIconName(star),
        "size": "regular"
      }
    })], 1);
  }), 0);
};
var AccessibleRatingvue_type_template_id_976c461e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/atoms/AccessibleRating.vue?vue&type=script&lang=js
/* harmony default export */ var AccessibleRatingvue_type_script_lang_js = ({
  name: 'AccessibleRating',
  props: {
    maxRating: {
      type: Number,
      default: 5
    },
    initialRating: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      rating: this.initialRating,
      hoverRating: 0
    };
  },
  computed: {
    stars() {
      return Array.from({
        length: this.maxRating
      }, (_, index) => index + 1);
    },
    starIconName() {
      return currentStar => this.hoverRating > 0 ? currentStar <= this.hoverRating ? 'star' : 'outline-star' : currentStar <= this.rating ? 'star' : 'outline-star';
    }
  },
  methods: {
    setRating(rating) {
      this.rating = rating;
      this.$emit('input', this.rating);
    },
    handleHover(rating) {
      this.hoverRating = rating;
    },
    handleKeyDown(event) {
      const keyPressed = event.key;
      if (keyPressed === 'ArrowLeft' || keyPressed === 'ArrowDown') {
        event.preventDefault();
        this.rating = Math.max(this.rating - 1, 0);
      } else if (keyPressed === 'ArrowRight' || keyPressed === 'ArrowUp') {
        event.preventDefault();
        this.rating = Math.min(this.rating + 1, this.maxRating);
      } else if (keyPressed === 'Home') {
        event.preventDefault();
        this.rating = 1;
      } else if (keyPressed === 'End') {
        event.preventDefault();
        this.rating = this.maxRating;
      } else if (keyPressed === ' ') {
        event.preventDefault();
        this.rating = this.rating === 1 ? 0 : 1;
      }
      this.$emit('input', this.rating);
    }
  }
});
;// CONCATENATED MODULE: ./src/atoms/AccessibleRating.vue?vue&type=script&lang=js
 /* harmony default export */ var atoms_AccessibleRatingvue_type_script_lang_js = (AccessibleRatingvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/atoms/AccessibleRating.vue?vue&type=style&index=0&id=976c461e&prod&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/atoms/AccessibleRating.vue?vue&type=style&index=0&id=976c461e&prod&lang=scss

;// CONCATENATED MODULE: ./src/atoms/AccessibleRating.vue



;


/* normalize component */

var AccessibleRating_component = normalizeComponent(
  atoms_AccessibleRatingvue_type_script_lang_js,
  AccessibleRatingvue_type_template_id_976c461e_render,
  AccessibleRatingvue_type_template_id_976c461e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AccessibleRating = (AccessibleRating_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/SessionChangeConfirmation.vue?vue&type=template&id=e46cebc4
var SessionChangeConfirmationvue_type_template_id_e46cebc4_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "align": "center",
      "variant": "heading14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.title)) + " ")]), _c('div', {
    class: _vm.$style.buttonContainer
  }, [_c('OutlinedButton', {
    attrs: {
      "size": "x-small",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.cancelText)) + " ")]), _c('PillButton', {
    attrs: {
      "size": "x-small",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('confirm');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.confirmText)) + " ")])], 1)], 1);
};
var SessionChangeConfirmationvue_type_template_id_e46cebc4_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/SessionChangeConfirmation.vue?vue&type=script&lang=js
/* harmony default export */ var SessionChangeConfirmationvue_type_script_lang_js = ({
  name: 'SessionChangeConfirmation',
  props: {
    title: String,
    confirmText: String,
    cancelText: String
  }
});
;// CONCATENATED MODULE: ./src/components/EventWidgets/SessionChangeConfirmation.vue?vue&type=script&lang=js
 /* harmony default export */ var EventWidgets_SessionChangeConfirmationvue_type_script_lang_js = (SessionChangeConfirmationvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventWidgets/SessionChangeConfirmation.vue?vue&type=style&index=0&id=e46cebc4&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SessionChangeConfirmationvue_type_style_index_0_id_e46cebc4_prod_module_true_lang_scss = ({"root":"SessionChangeConfirmation_root_arCkz","title":"SessionChangeConfirmation_title_fVvkr","buttonContainer":"SessionChangeConfirmation_buttonContainer_WpQXB"});
;// CONCATENATED MODULE: ./src/components/EventWidgets/SessionChangeConfirmation.vue?vue&type=style&index=0&id=e46cebc4&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/EventWidgets/SessionChangeConfirmation.vue



;




function SessionChangeConfirmation_injectStyles (context) {
  
  this["$style"] = (SessionChangeConfirmationvue_type_style_index_0_id_e46cebc4_prod_module_true_lang_scss.locals || SessionChangeConfirmationvue_type_style_index_0_id_e46cebc4_prod_module_true_lang_scss)

}

/* normalize component */

var SessionChangeConfirmation_component = normalizeComponent(
  EventWidgets_SessionChangeConfirmationvue_type_script_lang_js,
  SessionChangeConfirmationvue_type_template_id_e46cebc4_render,
  SessionChangeConfirmationvue_type_template_id_e46cebc4_staticRenderFns,
  false,
  SessionChangeConfirmation_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SessionChangeConfirmation = (SessionChangeConfirmation_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Chat/ChatReactionBar.vue?vue&type=template&id=96cbc090
var ChatReactionBarvue_type_template_id_96cbc090_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', {
    class: _vm.$style.root
  }, _vm._l(_vm.emojis, function ([emoji, count, isReactedByCurrentUser], i) {
    return _c('li', {
      key: 'left-' + i
    }, [_c('div', {
      staticClass: "messageFocusable",
      class: _vm.$style.emojiContainer,
      attrs: {
        "role": "button",
        "highlighted": isReactedByCurrentUser
      },
      on: {
        "click": () => _vm.$emit('click', emoji),
        "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
          $event.preventDefault();
          return _vm.$emit('click', emoji);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
          $event.preventDefault();
          return _vm.$emit('click', emoji);
        }]
      }
    }, [_c('StyledText', {
      attrs: {
        "variant": "heading13"
      }
    }, [_vm._v(" " + _vm._s(emoji) + " ")]), _c('StyledText', {
      attrs: {
        "variant": "body13",
        "color": isReactedByCurrentUser ? 'secondary-text-color' : 'primary-text-color'
      }
    }, [_vm._v(" " + _vm._s(count) + " ")])], 1)]);
  }), 0);
};
var ChatReactionBarvue_type_template_id_96cbc090_staticRenderFns = [];

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.31.0/node_modules/core-js/modules/web.dom-exception.stack.js
var web_dom_exception_stack = __webpack_require__(7765);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Chat/ChatReactionBar.vue?vue&type=script&lang=js

/* harmony default export */ var ChatReactionBarvue_type_script_lang_js = ({
  name: 'ChatReactionBar',
  props: {
    reactions: Object,
    currentUserMMID: String
  },
  computed: {
    emojis() {
      const reactionKeys = Object.keys(this.reactions || {});
      if (reactionKeys.length === 0) {
        return [];
      }
      return reactionKeys.map(base64Code => {
        const emojiCode = decodeURIComponent(escape(atob(base64Code)));
        const count = this.reactions[base64Code]?.length;
        const isReactedByCurrentUser = this.reactions[base64Code].findIndex(reaction => reaction.user_id === this.currentUserMMID) > -1;
        return [emojiCode, count, isReactedByCurrentUser];
      }).filter(it => it[1] > 0);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Chat/ChatReactionBar.vue?vue&type=script&lang=js
 /* harmony default export */ var Chat_ChatReactionBarvue_type_script_lang_js = (ChatReactionBarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Chat/ChatReactionBar.vue?vue&type=style&index=0&id=96cbc090&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ChatReactionBarvue_type_style_index_0_id_96cbc090_prod_module_true_lang_scss = ({"root":"ChatReactionBar_root_v3OLj","emojiContainer":"ChatReactionBar_emojiContainer_B_L_W"});
;// CONCATENATED MODULE: ./src/components/Chat/ChatReactionBar.vue?vue&type=style&index=0&id=96cbc090&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Chat/ChatReactionBar.vue



;




function ChatReactionBar_injectStyles (context) {
  
  this["$style"] = (ChatReactionBarvue_type_style_index_0_id_96cbc090_prod_module_true_lang_scss.locals || ChatReactionBarvue_type_style_index_0_id_96cbc090_prod_module_true_lang_scss)

}

/* normalize component */

var ChatReactionBar_component = normalizeComponent(
  Chat_ChatReactionBarvue_type_script_lang_js,
  ChatReactionBarvue_type_template_id_96cbc090_render,
  ChatReactionBarvue_type_template_id_96cbc090_staticRenderFns,
  false,
  ChatReactionBar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ChatReactionBar = (ChatReactionBar_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Chat/ChatLoadMoreButton.vue?vue&type=template&id=59ea7aa5
var ChatLoadMoreButtonvue_type_template_id_59ea7aa5_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('TextButton', {
    class: _vm.$style.root,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading13"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.message)) + " ")]);
};
var ChatLoadMoreButtonvue_type_template_id_59ea7aa5_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Chat/ChatLoadMoreButton.vue?vue&type=script&lang=js
/* harmony default export */ var ChatLoadMoreButtonvue_type_script_lang_js = ({
  props: {
    message: {
      type: String,
      default: 'Load more'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Chat/ChatLoadMoreButton.vue?vue&type=script&lang=js
 /* harmony default export */ var Chat_ChatLoadMoreButtonvue_type_script_lang_js = (ChatLoadMoreButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-11.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Chat/ChatLoadMoreButton.vue?vue&type=style&index=0&id=59ea7aa5&prod&module=true&lang=css
// extracted by mini-css-extract-plugin
/* harmony default export */ var ChatLoadMoreButtonvue_type_style_index_0_id_59ea7aa5_prod_module_true_lang_css = ({"root":"ChatLoadMoreButton_root_x3ay_"});
;// CONCATENATED MODULE: ./src/components/Chat/ChatLoadMoreButton.vue?vue&type=style&index=0&id=59ea7aa5&prod&module=true&lang=css
 
;// CONCATENATED MODULE: ./src/components/Chat/ChatLoadMoreButton.vue



;




function ChatLoadMoreButton_injectStyles (context) {
  
  this["$style"] = (ChatLoadMoreButtonvue_type_style_index_0_id_59ea7aa5_prod_module_true_lang_css.locals || ChatLoadMoreButtonvue_type_style_index_0_id_59ea7aa5_prod_module_true_lang_css)

}

/* normalize component */

var ChatLoadMoreButton_component = normalizeComponent(
  Chat_ChatLoadMoreButtonvue_type_script_lang_js,
  ChatLoadMoreButtonvue_type_template_id_59ea7aa5_render,
  ChatLoadMoreButtonvue_type_template_id_59ea7aa5_staticRenderFns,
  false,
  ChatLoadMoreButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ChatLoadMoreButton = (ChatLoadMoreButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Chat/Observer.vue?vue&type=template&id=5d2d37a3
var Observervue_type_template_id_5d2d37a3_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.observer
  });
};
var Observervue_type_template_id_5d2d37a3_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Chat/Observer.vue?vue&type=script&lang=js
/* harmony default export */ var Observervue_type_script_lang_js = ({
  name: 'observer',
  props: {
    root: {
      default: null
    }
  },
  data() {
    return {
      observer: null
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit('intersect');
      }
    }, {
      root: this.root
    });
    this.observer.observe(this.$el);
  }
});
;// CONCATENATED MODULE: ./src/components/Chat/Observer.vue?vue&type=script&lang=js
 /* harmony default export */ var Chat_Observervue_type_script_lang_js = (Observervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-11.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Chat/Observer.vue?vue&type=style&index=0&id=5d2d37a3&prod&module=true&lang=css
// extracted by mini-css-extract-plugin
/* harmony default export */ var Observervue_type_style_index_0_id_5d2d37a3_prod_module_true_lang_css = ({"observer":"Observer_observer_JOYaA"});
;// CONCATENATED MODULE: ./src/components/Chat/Observer.vue?vue&type=style&index=0&id=5d2d37a3&prod&module=true&lang=css
 
;// CONCATENATED MODULE: ./src/components/Chat/Observer.vue



;




function Observer_injectStyles (context) {
  
  this["$style"] = (Observervue_type_style_index_0_id_5d2d37a3_prod_module_true_lang_css.locals || Observervue_type_style_index_0_id_5d2d37a3_prod_module_true_lang_css)

}

/* normalize component */

var Observer_component = normalizeComponent(
  Chat_Observervue_type_script_lang_js,
  Observervue_type_template_id_5d2d37a3_render,
  Observervue_type_template_id_5d2d37a3_staticRenderFns,
  false,
  Observer_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Observer = (Observer_component.exports);
;// CONCATENATED MODULE: ./src/components/Chat/ChatMessageRenderer.js


const ChatMessageRenderer_linkMatchRegexStr = `${REGEX.EMAIL_REGEX_STR}|${REGEX.URL_REGEX_STR}`;
const ChatMessageRenderer_emailRegexp = new RegExp(REGEX.EMAIL_REGEX_STR, 'ig');
const ChatMessageRenderer_linkRegexp = new RegExp(ChatMessageRenderer_linkMatchRegexStr, 'ig');
const buttonRegexp = new RegExp('{{(.*)~(.*)}}', 'ig');
/* harmony default export */ var ChatMessageRenderer = ({
  functional: true,
  render: function (createElement, context) {
    const childrens = [];
    let messageText = context.props.text || '';
    const matches = messageText.matchAll(ChatMessageRenderer_linkRegexp);
    const buttonMatches = messageText.matchAll(buttonRegexp);
    const arrayOfButtonMatches = Array.from(buttonMatches);
    const arrayOfMatches = Array.from(matches);
    let lastMatchedNextCharIndex = 0;
    if (arrayOfMatches && arrayOfMatches.length) {
      arrayOfMatches.forEach(match => {
        const matchedString = match[0];
        let matchedLink = matchedString;
        if (match.index - lastMatchedNextCharIndex > 0) {
          childrens.push(messageText.substring(lastMatchedNextCharIndex, match.index));
        }
        // If the matched link is a mail append mailto: to the link
        if (ChatMessageRenderer_emailRegexp.test(matchedLink)) {
          matchedLink = `mailto:${matchedLink}`;
        }
        const linkElem = createElement('span', {
          attrs: {
            class: context.props.linkClass,
            target: '_blank'
          },
          on: {
            click: () => {
              context.listeners.linkclicked(matchedLink);
            }
          }
        }, matchedString);
        childrens.push(linkElem);
        lastMatchedNextCharIndex = match.index + matchedString.length;
      });
      if (lastMatchedNextCharIndex <= messageText.length - 1) {
        childrens.push(messageText.substring(lastMatchedNextCharIndex));
      }
    } else if (arrayOfButtonMatches && arrayOfButtonMatches.length) {
      arrayOfButtonMatches.forEach(match => {
        const matchedArray = match[0].split('~');
        const matchedString = match[0];
        const label = matchedArray[0].substring(2);
        const value = matchedArray[1].substring(0, matchedArray[1].length - 2);
        if (match.index - lastMatchedNextCharIndex > 0) {
          childrens.push(messageText.substring(lastMatchedNextCharIndex, match.index));
        }
        const buttonElem = createElement('span', {
          attrs: {
            class: context.props.linkClass
          },
          on: {
            click: () => {
              context.listeners.buttonclicked(value);
            }
          }
        }, label);
        childrens.push(buttonElem);
        lastMatchedNextCharIndex = match.index + matchedString.length;
      });
      if (lastMatchedNextCharIndex <= messageText.length - 1) {
        childrens.push(messageText.substring(lastMatchedNextCharIndex));
      }
    } else {
      childrens.push(messageText);
    }
    return createElement('pre', {
      attrs: {
        class: context.props.containerClass
      }
    }, childrens);
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    linkClass: {
      type: String,
      default: ''
    },
    containerClass: {
      type: String,
      default: ''
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Chat/index.js




;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Auth/AuthWrapper.vue?vue&type=template&id=0e8cc876
var AuthWrappervue_type_template_id_0e8cc876_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.space
  }, [_vm.userName ? _c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Welcome back')) + " " + _vm._s(_vm.userName) + "! ")]) : _vm._e(), _c('StyledText', {
    attrs: {
      "color": _vm.contentHeaderColor,
      "variant": "body15"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentHeader)
    }
  })]), _vm.headerExtra ? _c('StyledText', {
    attrs: {
      "color": _vm.contentHeaderColor,
      "variant": "body15"
    }
  }, [_vm._v(" " + _vm._s(_vm.headerExtra) + " ")]) : _vm._e(), _vm.email ? _c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.email) + " ")]) : _vm._e()], 1), _c('form', {
    class: _vm.$style.authForm,
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.$emit('next');
      }
    }
  }, [_c('div', {
    class: _vm.$style.slotSpace
  }, [_vm._t("default")], 2), _vm.nextButton ? _c('AuthButton', {
    attrs: {
      "disabled": !_vm.canProceed
    }
  }) : _vm._e()], 1), _vm.errorMessage ? _c('StyledText', {
    class: _vm.$style.errorMessage,
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e(), _c('div', {
    class: _vm.$style.loading
  }, [_vm.loading ? _c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.loadingText)) + " ")]) : _vm._e(), _vm.loading ? _c('div', {
    class: _vm.$style.progressbar,
    attrs: {
      "data-testmarker": "authloadingbar"
    }
  }, [_c('AuthProgress')], 1) : _vm._e()], 1), _vm.backText ? _c('TextButton', {
    class: _vm.$style.backLink,
    attrs: {
      "color": "color-variant-light-50"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('go-back');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.backText) + " ")]) : _vm._e()], 1);
};
var AuthWrappervue_type_template_id_0e8cc876_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Auth/AuthButton.vue?vue&type=template&id=3860dc00
var AuthButtonvue_type_template_id_3860dc00_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('PillButton', _vm._b({
    attrs: {
      "size": "x-small",
      "disabled": _vm.disabled,
      "center": "",
      "data-testmarker": "authbutton"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, 'PillButton', _vm.$attrs, false), [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.buttonText)) + " ")]);
};
var AuthButtonvue_type_template_id_3860dc00_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Auth/AuthButton.vue?vue&type=script&lang=js
/* harmony default export */ var AuthButtonvue_type_script_lang_js = ({
  name: 'AuthButton',
  props: {
    buttonText: {
      type: String,
      default: 'SUBMIT'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Auth/AuthButton.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_AuthButtonvue_type_script_lang_js = (AuthButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/Auth/AuthButton.vue





/* normalize component */
;
var AuthButton_component = normalizeComponent(
  Auth_AuthButtonvue_type_script_lang_js,
  AuthButtonvue_type_template_id_3860dc00_render,
  AuthButtonvue_type_template_id_3860dc00_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AuthButton = (AuthButton_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Auth/AuthProgress.vue?vue&type=template&id=606aae0a
var AuthProgressvue_type_template_id_606aae0a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.slider
  }, [_c('div', {
    class: _vm.$style.line
  }), _c('div', {
    class: [_vm.$style.subline, _vm.$style.inc]
  }), _c('div', {
    class: [_vm.$style.subline, _vm.$style.dec]
  })]);
};
var AuthProgressvue_type_template_id_606aae0a_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Auth/AuthProgress.vue?vue&type=script&lang=js
/* harmony default export */ var AuthProgressvue_type_script_lang_js = ({
  name: 'AuthProgress',
  props: {
    popupContent: {
      type: String,
      default: 'Need Help?'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Auth/AuthProgress.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_AuthProgressvue_type_script_lang_js = (AuthProgressvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Auth/AuthProgress.vue?vue&type=style&index=0&id=606aae0a&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var AuthProgressvue_type_style_index_0_id_606aae0a_prod_lang_scss_module_true = ({"slider":"AuthProgress_slider_Hhwb1","line":"AuthProgress_line_KHCf8","subline":"AuthProgress_subline_VsBrm","inc":"AuthProgress_inc_PS9xu","increase":"AuthProgress_increase_VJAfe","dec":"AuthProgress_dec_PwYrg","decrease":"AuthProgress_decrease_mWwvF"});
;// CONCATENATED MODULE: ./src/components/Auth/AuthProgress.vue?vue&type=style&index=0&id=606aae0a&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Auth/AuthProgress.vue



;




function AuthProgress_injectStyles (context) {
  
  this["$style"] = (AuthProgressvue_type_style_index_0_id_606aae0a_prod_lang_scss_module_true.locals || AuthProgressvue_type_style_index_0_id_606aae0a_prod_lang_scss_module_true)

}

/* normalize component */

var AuthProgress_component = normalizeComponent(
  Auth_AuthProgressvue_type_script_lang_js,
  AuthProgressvue_type_template_id_606aae0a_render,
  AuthProgressvue_type_template_id_606aae0a_staticRenderFns,
  false,
  AuthProgress_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AuthProgress = (AuthProgress_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Auth/AuthWrapper.vue?vue&type=script&lang=js



/* harmony default export */ var AuthWrappervue_type_script_lang_js = ({
  name: 'auth-wrapper',
  components: {
    StyledText: StyledText,
    AuthButton: AuthButton,
    AuthProgress: AuthProgress
  },
  props: {
    eventLogo: {
      type: String,
      props: ''
    },
    contentHeader: {
      type: String,
      default: ''
    },
    contentHeaderColor: {
      type: String,
      default: 'primary-text-color'
    },
    headerExtra: {
      type: String,
      default: ''
    },
    canProceed: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    nextButton: {
      type: Boolean,
      default: true
    },
    userName: {
      type: String,
      default: null
    },
    loadingText: {
      type: String,
      default: 'Checking...'
    },
    email: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    backText: {
      type: String,
      default: null
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Auth/AuthWrapper.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_AuthWrappervue_type_script_lang_js = (AuthWrappervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Auth/AuthWrapper.vue?vue&type=style&index=0&id=0e8cc876&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var AuthWrappervue_type_style_index_0_id_0e8cc876_prod_lang_scss_module_true = ({"root":"AuthWrapper_root_WyupI","space":"AuthWrapper_space_xzs20","slotSpace":"AuthWrapper_slotSpace_UoiBm","errorMessage":"AuthWrapper_errorMessage_MUMym","backLink":"AuthWrapper_backLink_z3_Rd","authForm":"AuthWrapper_authForm_ivKCg","loading":"AuthWrapper_loading_TitYG","progressbar":"AuthWrapper_progressbar_A5D8R"});
;// CONCATENATED MODULE: ./src/components/Auth/AuthWrapper.vue?vue&type=style&index=0&id=0e8cc876&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Auth/AuthWrapper.vue



;




function AuthWrapper_injectStyles (context) {
  
  this["$style"] = (AuthWrappervue_type_style_index_0_id_0e8cc876_prod_lang_scss_module_true.locals || AuthWrappervue_type_style_index_0_id_0e8cc876_prod_lang_scss_module_true)

}

/* normalize component */

var AuthWrapper_component = normalizeComponent(
  Auth_AuthWrappervue_type_script_lang_js,
  AuthWrappervue_type_template_id_0e8cc876_render,
  AuthWrappervue_type_template_id_0e8cc876_staticRenderFns,
  false,
  AuthWrapper_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AuthWrapper = (AuthWrapper_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Auth/AuthInput.vue?vue&type=template&id=20833507
var AuthInputvue_type_template_id_20833507_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.label
  }, [_c('StyledText', {
    attrs: {
      "id": _vm.label,
      "color": "primary-text-color",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")])], 1), _c('input', _vm._b({
    ref: "input",
    class: {
      [_vm.$style.error]: _vm.errorMessage
    },
    attrs: {
      "aria-labelledby": _vm.label,
      "data-testmarker": _vm.dataTestMarker,
      "type": _vm.type,
      "required": _vm.required,
      "maxlength": _vm.maxLength
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event.target.value);
      },
      "change": function ($event) {
        return _vm.$emit('change', $event.target.value);
      },
      "focus": function ($event) {
        return _vm.$emit('focus', $event);
      },
      "blur": function ($event) {
        return _vm.$emit('blur', $event);
      },
      "invalid": function ($event) {
        return _vm.$emit('invalid', $event);
      }
    }
  }, 'input', _vm.$attrs, false))]);
};
var AuthInputvue_type_template_id_20833507_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Auth/AuthInput.vue?vue&type=script&lang=js

/* harmony default export */ var AuthInputvue_type_script_lang_js = ({
  name: 'AuthInput',
  components: {
    StyledText: StyledText
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: ''
    },
    errorMessage: {
      type: String,
      default: null
    },
    maxLength: {
      type: Number,
      default: null
    },
    // The testmarker attribute that is set to the email input field
    dataTestMarker: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkValidity() {
      return this.$refs.input.checkValidity();
    },
    focus() {
      this.$refs.input.focus();
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Auth/AuthInput.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_AuthInputvue_type_script_lang_js = (AuthInputvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Auth/AuthInput.vue?vue&type=style&index=0&id=20833507&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var AuthInputvue_type_style_index_0_id_20833507_prod_lang_scss_module_true = ({"root":"AuthInput_root_OZSD8","label":"AuthInput_label_dFF1d","error":"AuthInput_error_AaMZi"});
;// CONCATENATED MODULE: ./src/components/Auth/AuthInput.vue?vue&type=style&index=0&id=20833507&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Auth/AuthInput.vue



;




function AuthInput_injectStyles (context) {
  
  this["$style"] = (AuthInputvue_type_style_index_0_id_20833507_prod_lang_scss_module_true.locals || AuthInputvue_type_style_index_0_id_20833507_prod_lang_scss_module_true)

}

/* normalize component */

var AuthInput_component = normalizeComponent(
  Auth_AuthInputvue_type_script_lang_js,
  AuthInputvue_type_template_id_20833507_render,
  AuthInputvue_type_template_id_20833507_staticRenderFns,
  false,
  AuthInput_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AuthInput = (AuthInput_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Auth/AuthPopup.vue?vue&type=template&id=2e7bd3e7
var AuthPopupvue_type_template_id_2e7bd3e7_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.popup
  }, [_c('div', {
    class: _vm.$style.arrow
  }), _c('div', {
    class: _vm.$style.popupMessage
  }, [_c('StyledText', {
    attrs: {
      "color": "color-secondary-light",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.popupContent) + " ")])], 1)]);
};
var AuthPopupvue_type_template_id_2e7bd3e7_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Auth/AuthPopup.vue?vue&type=script&lang=js
/* harmony default export */ var AuthPopupvue_type_script_lang_js = ({
  name: 'AuthPopup',
  props: {
    popupContent: {
      type: String,
      default: 'Need Help?'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Auth/AuthPopup.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_AuthPopupvue_type_script_lang_js = (AuthPopupvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Auth/AuthPopup.vue?vue&type=style&index=0&id=2e7bd3e7&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var AuthPopupvue_type_style_index_0_id_2e7bd3e7_prod_lang_scss_module_true = ({"popup":"AuthPopup_popup_Ihyki","popupMessage":"AuthPopup_popupMessage_c5eCL","arrow":"AuthPopup_arrow_SiWM4"});
;// CONCATENATED MODULE: ./src/components/Auth/AuthPopup.vue?vue&type=style&index=0&id=2e7bd3e7&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Auth/AuthPopup.vue



;




function AuthPopup_injectStyles (context) {
  
  this["$style"] = (AuthPopupvue_type_style_index_0_id_2e7bd3e7_prod_lang_scss_module_true.locals || AuthPopupvue_type_style_index_0_id_2e7bd3e7_prod_lang_scss_module_true)

}

/* normalize component */

var AuthPopup_component = normalizeComponent(
  Auth_AuthPopupvue_type_script_lang_js,
  AuthPopupvue_type_template_id_2e7bd3e7_render,
  AuthPopupvue_type_template_id_2e7bd3e7_staticRenderFns,
  false,
  AuthPopup_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AuthPopup = (AuthPopup_component.exports);
;// CONCATENATED MODULE: ./src/components/Auth/index.js





;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/NavigationBar.vue?vue&type=template&id=8e02685c
var NavigationBarvue_type_template_id_8e02685c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.navandbanner
  }, [_vm.showDemoLink && !_vm.demoRequested && _vm.isMobile() ? _c('Banner', {
    attrs: {
      "label": _vm.demoButtonText
    },
    on: {
      "action": function ($event) {
        return _vm.$emit('onDemoLink', $event);
      }
    }
  }) : _vm._e(), _c('header', {
    attrs: {
      "id": "mainStageNavigation",
      "tabindex": "-1",
      "aria-label": _vm.$t('Main Navigation')
    }
  }, [_c('nav', {
    class: _vm.$style.root
  }, [_c('OverflowWatcher', {
    class: _vm.$style.left,
    attrs: {
      "variableProps": _vm.links
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (props) {
        return [_vm.eventLogo ? _c('img', {
          class: _vm.$style.logo,
          attrs: {
            "src": _vm.eventLogo,
            "data-branding-target": "logo",
            "alt": ""
          }
        }) : _vm._e(), _vm.links.length ? _c('ul', {
          attrs: {
            "role": "menu"
          }
        }, _vm._l(props.overflowing ? _vm.links.slice(0, _vm.navOptionsStatic) : _vm.links.filter(l => l.show), function (link) {
          return _c('li', {
            key: link.name,
            attrs: {
              "role": "none"
            }
          }, [_c('NavigationItem', {
            attrs: {
              "name": link.name,
              "label": link.label,
              "count": link.count,
              "active": link.active,
              "notificationText": link.notificationText,
              "otherLiveSessions": link.otherLiveSessions
            },
            on: {
              "click": function ($event) {
                return _vm.visit(link);
              },
              "join": item => _vm.$emit('join', item)
            }
          }, [!!link.showHoverComponent ? [_c(link.hoverComponent, _vm._g(_vm._b({
            tag: "component",
            class: _vm.$style.dropdown
          }, 'component', link.props, false), _vm.$listeners))] : _vm._e()], 2)], 1);
        }), 0) : _vm._e(), _vm.linkOptions.length > 0 ? _c('SimpleSelect', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: props.overflowing,
            expression: "props.overflowing"
          }],
          attrs: {
            "options": _vm.linkOptions,
            "value": _vm.activeLink,
            "show-caret": false,
            "variant": "primary",
            "text-align": "left",
            "align": "left"
          },
          on: {
            "input": _vm.visit
          }
        }, [_c('span', {
          attrs: {
            "data-branding-target": "nav-hamburger"
          }
        }, [_c('IconButton', {
          attrs: {
            "icon": "hamburger-menu",
            "ghost": ""
          }
        })], 1)]) : _vm._e(), _vm.showDemoLink && !_vm.isMobile() ? _c('span', {
          attrs: {
            "data-branding-target": "demo-button"
          }
        }, [_c('PillButton', {
          class: _vm.$style.demoRequested,
          attrs: {
            "size": "regular",
            "disabled": _vm.demoRequested
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('onDemoLink', $event);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.demoButtonText) + " ")])], 1) : _vm._e(), _vm._t("default")];
      }
    }], null, true)
  }), _c('div', {
    class: _vm.$style.right
  }, [_vm.showPoweredBy ? _c('div', {
    class: [_vm.$style.poweredBy, _vm.$style.nonmobile]
  }, [_c('StyledText', {
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Powered by')) + " ")]), _c('a', {
    attrs: {
      "href": _vm.linkConstants.poweredByLink,
      "target": "_blank",
      "aria-label": "Goldcast"
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "logo"
    }
  })], 1)], 1) : _vm._e(), _vm.showGoldBotRatingButton ? _c('GoldBotRatingButton', {
    attrs: {
      "showTransition": _vm.showGoldBotRatingButtonTransition
    },
    on: {
      "openGoldcastBot": function ($event) {
        return _vm.$emit('openGoldcastBot');
      }
    }
  }) : _vm._e(), _vm.isInPerson && _vm.internalSessionCheckin ? _c('IconButton', {
    attrs: {
      "icon": "qr-code-icon",
      "size": "regular"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openBadge');
      }
    }
  }) : _vm._e(), _c('UserProfileDropdown', _vm._b({
    attrs: {
      "user": _vm.currentUser,
      "viewAsAttendee": _vm.viewAsAttendee,
      "forceShowViewAsAttendeeTooltip": _vm.forceShowViewAsAttendeeTooltip,
      "attendeeTooltipMessage": _vm.attendeeTooltipMessage,
      "status": _vm.status
    },
    on: {
      "userDropDownToggle": function ($event) {
        return _vm.$emit('userDropDownToggle', $event);
      }
    }
  }, 'UserProfileDropdown', _vm.profileLinks, false))], 1)], 1)])], 1);
};
var NavigationBarvue_type_template_id_8e02685c_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/utils/links.js
/* harmony default export */ var links = ({
  poweredByLink: 'https://goldcast.io/?utm_source=eventapp&utm_medium=referral&utm_campaign=eventapp_sidebar'
});
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/NavigationBar.vue?vue&type=script&lang=js

/* harmony default export */ var NavigationBarvue_type_script_lang_js = ({
  name: 'navigation-bar',
  props: {
    links: {
      type: Array,
      required: true
    },
    profileLinks: {
      type: Object,
      required: true
    },
    eventLogo: {
      type: String,
      default: ''
    },
    currentUser: {
      type: Object,
      required: true
    },
    showPoweredBy: Boolean,
    showDemoLink: Boolean,
    demoRequested: Boolean,
    status: {
      type: String,
      default: 'offline'
    },
    demoButtonText: String,
    isInPerson: Boolean,
    isHybridEvent: Boolean,
    viewAsAttendee: {
      type: Boolean,
      default: false
    },
    forceShowViewAsAttendeeTooltip: {
      type: Boolean,
      default: false
    },
    showGoldBotRatingButton: {
      type: Boolean,
      default: false
    },
    showGoldBotRatingButtonTransition: {
      type: Boolean,
      default: false
    },
    attendeeTooltipMessage: String,
    internalSessionCheckin: Boolean
  },
  data() {
    return {
      navOptionsStatic: 2,
      linkConstants: links
    };
  },
  mounted() {
    if (this.isMobile()) {
      this.navOptionsStatic = 0;
    }
  },
  computed: {
    linkOptions() {
      return this.links.slice(this.navOptionsStatic).filter(l => l.show).map(link => ({
        ...link,
        value: link.name
      }));
    },
    activeLink() {
      return this.linkOptions.find(link => link.active);
    }
  },
  methods: {
    visit(link) {
      !link.active && this.$emit('menuclick', link);
      this.$nextTick(() => {
        document.querySelector('#eventPageContainer')?.querySelector('h1')?.focus();
      });
    },
    isMobile() {
      return window.mobileCheck && window.mobileCheck();
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EventWidgets/NavigationBar.vue?vue&type=script&lang=js
 /* harmony default export */ var EventWidgets_NavigationBarvue_type_script_lang_js = (NavigationBarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventWidgets/NavigationBar.vue?vue&type=style&index=0&id=8e02685c&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var NavigationBarvue_type_style_index_0_id_8e02685c_prod_lang_scss_module_true = ({"navandbanner":"NavigationBar_navandbanner_gio9U","root":"NavigationBar_root_Gc3YS","left":"NavigationBar_left_ZT03m","right":"NavigationBar_right_U_UKR","logo":"NavigationBar_logo_b8KMF","image":"NavigationBar_image_FKecC","dropdown":"NavigationBar_dropdown_xf0GD","poweredBy":"NavigationBar_poweredBy_FuzcJ","demoRequested":"NavigationBar_demoRequested_DudoD","nonmobile":"NavigationBar_nonmobile_XiwCS"});
;// CONCATENATED MODULE: ./src/components/EventWidgets/NavigationBar.vue?vue&type=style&index=0&id=8e02685c&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/EventWidgets/NavigationBar.vue



;




function NavigationBar_injectStyles (context) {
  
  this["$style"] = (NavigationBarvue_type_style_index_0_id_8e02685c_prod_lang_scss_module_true.locals || NavigationBarvue_type_style_index_0_id_8e02685c_prod_lang_scss_module_true)

}

/* normalize component */

var NavigationBar_component = normalizeComponent(
  EventWidgets_NavigationBarvue_type_script_lang_js,
  NavigationBarvue_type_template_id_8e02685c_render,
  NavigationBarvue_type_template_id_8e02685c_staticRenderFns,
  false,
  NavigationBar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var NavigationBar = (NavigationBar_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/NavigationItem.vue?vue&type=template&id=5455f275&functional=true
var NavigationItemvue_type_template_id_5455f275_functional_true_render = function render(_c, _vm) {
  return _c('span', {
    class: _vm.$style.container
  }, [_c('StyledText', {
    staticClass: "keyboard-focusable",
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.active]: _vm.props.active
    },
    attrs: {
      "variant": "body15",
      "color": "primary-text-color",
      "dataTestId": 'navigationItem-' + _vm.props.name,
      "role": "menuitem",
      "tabIndex": 0
    },
    on: {
      "click": _vm.listeners.click
    }
  }, [_vm.props.icon ? _c('SvgIcon', {
    class: _vm.$style.icon,
    attrs: {
      "name": _vm.props.icon,
      "color": _vm.props.active ? 'secondary-text-color' : 'theme-secondary-color'
    }
  }) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.props.label) + " " + _vm._s(_vm.props.showCount ? _vm.props.count : ''))]), _vm.props.notificationText ? _c('StyledText', {
    class: _vm.$style.notification,
    attrs: {
      "variant": "body12"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.notificationText) + " ")]) : _vm._e()], 1), _vm._t("default")], 2);
};
var NavigationItemvue_type_template_id_5455f275_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/NavigationItem.vue?vue&type=script&lang=js
/* harmony default export */ var NavigationItemvue_type_script_lang_js = ({
  functional: true,
  name: 'navigation-item',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: 'Menu'
    },
    label: {
      type: String,
      default: ''
    },
    showCount: {
      type: Boolean,
      default: false
    },
    icon: String,
    notificationText: {
      type: [String, Number],
      default: ''
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EventWidgets/NavigationItem.vue?vue&type=script&lang=js
 /* harmony default export */ var EventWidgets_NavigationItemvue_type_script_lang_js = (NavigationItemvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventWidgets/NavigationItem.vue?vue&type=style&index=0&id=5455f275&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var NavigationItemvue_type_style_index_0_id_5455f275_prod_module_true_lang_scss = ({"container":"NavigationItem_container_K2LTP","root":"NavigationItem_root_ShTX2","icon":"NavigationItem_icon_wVuiC","active":"NavigationItem_active_Uhn7f","notification":"NavigationItem_notification__JXk1"});
;// CONCATENATED MODULE: ./src/components/EventWidgets/NavigationItem.vue?vue&type=style&index=0&id=5455f275&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/EventWidgets/NavigationItem.vue



;




function NavigationItem_injectStyles (context) {
  
  this["$style"] = (NavigationItemvue_type_style_index_0_id_5455f275_prod_module_true_lang_scss.locals || NavigationItemvue_type_style_index_0_id_5455f275_prod_module_true_lang_scss)

}

/* normalize component */

var NavigationItem_component = normalizeComponent(
  EventWidgets_NavigationItemvue_type_script_lang_js,
  NavigationItemvue_type_template_id_5455f275_functional_true_render,
  NavigationItemvue_type_template_id_5455f275_functional_true_staticRenderFns,
  true,
  NavigationItem_injectStyles,
  null,
  null
  
)

/* harmony default export */ var NavigationItem = (NavigationItem_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/RoomCard.vue?vue&type=template&id=9733935e&functional=true
var RoomCardvue_type_template_id_9733935e_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "id": 'channelcard-' + _vm.props.id,
      "data-branding-target": "group-card"
    }
  }, [_c('div', {
    class: [_vm.$style.card, _vm.$style[_vm.props.status]],
    attrs: {
      "id": 'channelcard-' + _vm.props.id
    }
  }, [_c('div', {
    class: [_vm.$style.usersarea, {
      [_vm.$style.userareawithsponsor]: _vm.props.sponsorlogo
    }, !!!_vm.props.sponsorlogo && _vm.$style.showRoomSeats],
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ul', [_vm._l(_vm.props.attendees, function (att, i) {
    return _c('li', {
      key: `${i}-attendee`,
      class: _vm.$style.userimages
    }, [_c('UserTooltip', {
      attrs: {
        "size": "small",
        "user": att,
        "outlined": false
      },
      on: {
        "click": () => _vm.listeners.openUser ? _vm.listeners.openUser(att) : () => {}
      }
    }), i == 15 && _vm.props.attendee > 15 ? _c('StyledText', {
      class: _vm.$style.moreUsers,
      attrs: {
        "variant": "body12",
        "color": "primary-text-color",
        "align": "center"
      }
    }, [_vm._v(" +" + _vm._s(_vm.props.Attendees - 2) + " ")]) : _vm._e()], 1);
  }), _vm._l(_vm.props.openspots, function (i) {
    return _c('li', {
      key: `${i}-empty`
    }, [_c('button', {
      staticClass: "button rounded",
      class: _vm.$style.emptyseatButton,
      attrs: {
        "aria-label": 'Join ' + _vm.props.title + ' room'
      },
      on: {
        "click": () => _vm.props.openspots > 0 ? _vm.listeners.click() : null
      }
    }, [_c('StyledText', {
      class: _vm.$style.emptyseat,
      attrs: {
        "variant": "body13",
        "color": "primary-text-color",
        "align": "center"
      }
    }, [_vm._v(" + ")])], 1)]);
  })], 2)]), !!_vm.props.sponsorlogo ? _c('div', {
    class: _vm.$style.logo
  }, [_c('img', {
    attrs: {
      "src": _vm.props.sponsorlogo
    }
  })]) : _vm._e(), _c('div', {
    class: _vm.$style.label
  }, [_c('StyledText', {
    attrs: {
      "variant": "body14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.title) + " ")]), _c('span', {
    class: _vm.$style.attendeestats
  }, [_c('StyledText', {
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.openspots) + " " + _vm._s(_vm.$options.$t('seat(s) open')) + " ")])], 1), _c('TextButton', {
    class: [_vm.props.openspots > 0 || _vm.props.canOrganiserJoin ? _vm.$style.joinbutton : _vm.$style.waitbutton],
    attrs: {
      "id": 'joinRoomButton' + _vm.props.id,
      "variant": "body12",
      "ariaLabelledby": 'joinRoomButton' + _vm.props.id,
      "size": "regular",
      "color": _vm.props.openspots > 0 || _vm.props.canOrganiserJoin ? 'theme-secondary-color' : 'primary-text-color-05'
    },
    on: {
      "click": () => _vm.props.openspots > 0 || _vm.props.canOrganiserJoin ? _vm.listeners.click() : null
    }
  }, [_vm._v(" " + _vm._s(_vm.props.openspots > 0 || _vm.props.canOrganiserJoin ? _vm.$options.$t('JOIN') : _vm.$options.$t('WAIT')) + " ")])], 1)]), _c('span', {
    class: _vm.$style.bottomtext
  }, [_c('span', {
    class: _vm.$style.bottomsubtext
  }, [_c('StyledText', {
    class: _vm.$style.roomcount,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color-05"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.tags.join('# ').length > 32 ? _vm.props.tags.map(e => `#${e}`).join(' ').substring(0, 32) : _vm.props.tags.map(e => `#${e}`).join(' ')) + " ")]), _vm.props.tags.join('# ').length > 32 ? _c('GTooltip', {
    class: _vm.$style.moretags,
    attrs: {
      "text": _vm.props.tags.map(e => `#${e}`).join(' ')
    }
  }, [_c('StyledText', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "variant": "body13",
      "color": "primary-text-color-05"
    }
  }, [_vm._v(" ..." + _vm._s(_vm.$options.$t('more')) + " ")])], 1) : _vm._e()], 1)])]);
};
var RoomCardvue_type_template_id_9733935e_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/RoomCard.vue?vue&type=script&lang=js
/* harmony default export */ var RoomCardvue_type_script_lang_js = ({
  name: 'room-card',
  functional: true,
  props: {
    title: {
      type: String,
      default: ''
    },
    tags: {
      type: Array,
      deafult: () => {}
    },
    attendees: {
      type: Array,
      default: () => []
    },
    sponsorlogo: {
      type: String
    },
    count: {
      type: Number,
      default: 0
    },
    openspots: {
      type: Number,
      default: 12
    },
    id: {
      type: String
    },
    status: {
      type: String,
      default: 'loading'
    },
    canOrganiserJoin: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EventWidgets/RoomCard.vue?vue&type=script&lang=js
 /* harmony default export */ var EventWidgets_RoomCardvue_type_script_lang_js = (RoomCardvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventWidgets/RoomCard.vue?vue&type=style&index=0&id=9733935e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var RoomCardvue_type_style_index_0_id_9733935e_prod_module_true_lang_scss = ({"root":"RoomCard_root_kfkO3","card":"RoomCard_card_t74Ry","logo":"RoomCard_logo_ZFVam","loading":"RoomCard_loading_oHDwb","error":"RoomCard_error_GXR9J","userareawithsponsor":"RoomCard_userareawithsponsor_axDdh","usersarea":"RoomCard_usersarea_W7Uhb","userimages":"RoomCard_userimages_XRfNl","moreUsers":"RoomCard_moreUsers_K45OI","emptyseatButton":"RoomCard_emptyseatButton_j0kMH","emptyseat":"RoomCard_emptyseat_mB4wi","showRoomSeats":"RoomCard_showRoomSeats_w_ocT","label":"RoomCard_label_W2f_H","joinbutton":"RoomCard_joinbutton_dzPlD","waitbutton":"RoomCard_waitbutton_nfDZs","attendeestats":"RoomCard_attendeestats_dWp7U","bottomtext":"RoomCard_bottomtext_ZGm_g","bottomsubtext":"RoomCard_bottomsubtext_e5oeU","roomcount":"RoomCard_roomcount_ioR7a","moretags":"RoomCard_moretags_TjNNP","backgroundscaling":"RoomCard_backgroundscaling_Q13Io"});
;// CONCATENATED MODULE: ./src/components/EventWidgets/RoomCard.vue?vue&type=style&index=0&id=9733935e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/EventWidgets/RoomCard.vue



;




function RoomCard_injectStyles (context) {
  
  this["$style"] = (RoomCardvue_type_style_index_0_id_9733935e_prod_module_true_lang_scss.locals || RoomCardvue_type_style_index_0_id_9733935e_prod_module_true_lang_scss)

}

/* normalize component */

var RoomCard_component = normalizeComponent(
  EventWidgets_RoomCardvue_type_script_lang_js,
  RoomCardvue_type_template_id_9733935e_functional_true_render,
  RoomCardvue_type_template_id_9733935e_functional_true_staticRenderFns,
  true,
  RoomCard_injectStyles,
  null,
  null
  
)

/* harmony default export */ var RoomCard = (RoomCard_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/RoomsPage.vue?vue&type=template&id=9a9cf254&functional=true
var RoomsPagevue_type_template_id_9a9cf254_functional_true_render = function render(_c, _vm) {
  return _c('span', [_vm.props.showLoading ? _c('ProgressBar', [_vm._v("Loading...")]) : _vm._e(), _c('ul', {
    class: _vm.$style.root,
    attrs: {
      "aria-live": "polite",
      "data-testmarker": "roomsgrid"
    }
  }, _vm._l(_vm.props.groups, function (group, i) {
    return _c('li', {
      key: i
    }, [_c('RoomCard', {
      attrs: {
        "id": group.id,
        "canOrganiserJoin": group.canOrganiserJoin,
        "moderators": group.moderators,
        "attendees": group.attendees,
        "hiddenattendees": group.hiddenattendees,
        "sponsorlogo": group.sponsorlogo,
        "title": group.title,
        "tags": group.tags,
        "count": group.count,
        "openspots": group.openspots,
        "status": group.status
      },
      on: {
        "click": () => _vm.listeners.join(group),
        "openUser": user => _vm.listeners.openUser ? _vm.listeners.openUser(user) : null
      }
    })], 1);
  }), 0)], 1);
};
var RoomsPagevue_type_template_id_9a9cf254_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/RoomsPage.vue?vue&type=script&lang=js
/* harmony default export */ var RoomsPagevue_type_script_lang_js = ({
  name: 'rooms-page',
  functional: true,
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    showLoading: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EventWidgets/RoomsPage.vue?vue&type=script&lang=js
 /* harmony default export */ var EventWidgets_RoomsPagevue_type_script_lang_js = (RoomsPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventWidgets/RoomsPage.vue?vue&type=style&index=0&id=9a9cf254&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var RoomsPagevue_type_style_index_0_id_9a9cf254_prod_lang_scss_module_true = ({"root":"RoomsPage_root_mP3EM"});
;// CONCATENATED MODULE: ./src/components/EventWidgets/RoomsPage.vue?vue&type=style&index=0&id=9a9cf254&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/EventWidgets/RoomsPage.vue



;




function RoomsPage_injectStyles (context) {
  
  this["$style"] = (RoomsPagevue_type_style_index_0_id_9a9cf254_prod_lang_scss_module_true.locals || RoomsPagevue_type_style_index_0_id_9a9cf254_prod_lang_scss_module_true)

}

/* normalize component */

var RoomsPage_component = normalizeComponent(
  EventWidgets_RoomsPagevue_type_script_lang_js,
  RoomsPagevue_type_template_id_9a9cf254_functional_true_render,
  RoomsPagevue_type_template_id_9a9cf254_functional_true_staticRenderFns,
  true,
  RoomsPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var RoomsPage = (RoomsPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/AgendaFilter.vue?vue&type=template&id=2d70686e
var AgendaFiltervue_type_template_id_2d70686e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "data-value": _vm.current.value
    }
  }, [_vm.type === 'dropdown' ? _c('AccessibleSelect', {
    attrs: {
      "id": "agendaDate",
      "options": _vm.options,
      "variant": "primary",
      "value": _vm.current
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('select', $event);
      }
    }
  }) : _c('ul', {
    class: [_vm.$style.root],
    attrs: {
      "role": _vm.addAriaAttributes ? 'radiogroup' : null,
      "aria-controls": _vm.addAriaAttributes ? _vm.ariaControlId : null
    }
  }, _vm._l(_vm.options, function (link) {
    return _c('li', {
      key: link.value,
      class: _vm.$style.listItem,
      attrs: {
        "role": "none"
      }
    }, [_c('GTooltip', {
      attrs: {
        "text": link.label
      }
    }, [link.value === _vm.current.value ? _c('PillButton', {
      class: _vm.$style.nav_item,
      attrs: {
        "role": _vm.addAriaAttributes ? 'radio' : null,
        "aria-checked": _vm.addAriaAttributes ? 'true' : null,
        "aria-label": _vm.addAriaAttributes ? 'Filter by Track: ' + link.label : null,
        "size": "small",
        "icon": _vm.iconOn && link.value === _vm.iconOn.value ? _vm.icon : ''
      },
      on: {
        "click": () => _vm.$emit('select', link)
      }
    }, [_vm._v(" " + _vm._s(link.label) + " ")]) : _c('OutlinedButton', {
      class: _vm.$style.nav_item,
      attrs: {
        "role": _vm.addAriaAttributes ? 'radio' : null,
        "aria-checked": _vm.addAriaAttributes ? 'false' : null,
        "aria-label": _vm.addAriaAttributes ? 'Filter by Track: ' + link.label : null,
        "size": "small",
        "icon": _vm.iconOn && link.value === _vm.iconOn.value ? _vm.icon : '',
        "uppercase": false
      },
      on: {
        "click": () => _vm.$emit('select', link)
      }
    }, [_vm._v(" " + _vm._s(link.label) + " ")])], 1)], 1);
  }), 0)], 1);
};
var AgendaFiltervue_type_template_id_2d70686e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/AgendaFilter.vue?vue&type=script&lang=js

/* harmony default export */ var AgendaFiltervue_type_script_lang_js = ({
  components: {
    AccessibleSelect: AccessibleSelect
  },
  name: 'AgendaFilter',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    current: {
      type: Object
    },
    type: {
      type: String,
      default: 'dropdown'
    },
    icon: String,
    addAriaAttributes: {
      type: Boolean,
      default: false
    },
    ariaControlId: String,
    iconOn: Object,
    fullWidthDropdown: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EventWidgets/AgendaFilter.vue?vue&type=script&lang=js
 /* harmony default export */ var EventWidgets_AgendaFiltervue_type_script_lang_js = (AgendaFiltervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventWidgets/AgendaFilter.vue?vue&type=style&index=0&id=2d70686e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var AgendaFiltervue_type_style_index_0_id_2d70686e_prod_module_true_lang_scss = ({"dropdown":"AgendaFilter_dropdown_GLXoE","root":"AgendaFilter_root_CppGa","nav_item":"AgendaFilter_nav_item_Vrkhp","listItem":"AgendaFilter_listItem_IofsU"});
;// CONCATENATED MODULE: ./src/components/EventWidgets/AgendaFilter.vue?vue&type=style&index=0&id=2d70686e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/EventWidgets/AgendaFilter.vue



;




function AgendaFilter_injectStyles (context) {
  
  this["$style"] = (AgendaFiltervue_type_style_index_0_id_2d70686e_prod_module_true_lang_scss.locals || AgendaFiltervue_type_style_index_0_id_2d70686e_prod_module_true_lang_scss)

}

/* normalize component */

var AgendaFilter_component = normalizeComponent(
  EventWidgets_AgendaFiltervue_type_script_lang_js,
  AgendaFiltervue_type_template_id_2d70686e_render,
  AgendaFiltervue_type_template_id_2d70686e_staticRenderFns,
  false,
  AgendaFilter_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AgendaFilter = (AgendaFilter_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/SpeakersList.vue?vue&type=template&id=43cad146&functional=true
var SpeakersListvue_type_template_id_43cad146_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, _vm._l(_vm.props.users, function (user) {
    return _c('div', {
      key: user.id,
      class: _vm.$style.user,
      on: {
        "click": () => _vm.listeners.seeProfile(user)
      }
    }, [_c('div', {
      class: _vm.$style.bg
    }), _c('UserImage', {
      class: _vm.$style.image,
      attrs: {
        "size": "small",
        "user": user
      }
    }), _c('StyledText', {
      class: _vm.$style.name,
      attrs: {
        "color": "primary-text-color",
        "variant": "body16",
        "display": "block"
      }
    }, [_vm._v(" " + _vm._s(user.name) + " ")]), _c('StyledText', {
      attrs: {
        "color": "theme-secondary-color",
        "variant": "body13"
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('See Profile')) + " ")])], 1);
  }), 0);
};
var SpeakersListvue_type_template_id_43cad146_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/SpeakersList.vue?vue&type=script&lang=js
/* harmony default export */ var SpeakersListvue_type_script_lang_js = ({
  functional: true,
  name: 'BottomDrawer',
  props: {
    users: {
      type: Array,
      required: true
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EventWidgets/SpeakersList.vue?vue&type=script&lang=js
 /* harmony default export */ var EventWidgets_SpeakersListvue_type_script_lang_js = (SpeakersListvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventWidgets/SpeakersList.vue?vue&type=style&index=0&id=43cad146&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SpeakersListvue_type_style_index_0_id_43cad146_prod_lang_scss_module_true = ({"root":"SpeakersList_root_Y3tNW","image":"SpeakersList_image_bWVeG","user":"SpeakersList_user_o6ltN","bg":"SpeakersList_bg_SRLqC","name":"SpeakersList_name_BSIlK"});
;// CONCATENATED MODULE: ./src/components/EventWidgets/SpeakersList.vue?vue&type=style&index=0&id=43cad146&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/EventWidgets/SpeakersList.vue



;




function SpeakersList_injectStyles (context) {
  
  this["$style"] = (SpeakersListvue_type_style_index_0_id_43cad146_prod_lang_scss_module_true.locals || SpeakersListvue_type_style_index_0_id_43cad146_prod_lang_scss_module_true)

}

/* normalize component */

var SpeakersList_component = normalizeComponent(
  EventWidgets_SpeakersListvue_type_script_lang_js,
  SpeakersListvue_type_template_id_43cad146_functional_true_render,
  SpeakersListvue_type_template_id_43cad146_functional_true_staticRenderFns,
  true,
  SpeakersList_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SpeakersList = (SpeakersList_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/MobileChatToggle.vue?vue&type=template&id=db43ccc6&functional=true
var MobileChatTogglevue_type_template_id_db43ccc6_functional_true_render = function render(_c, _vm) {
  return _c('span', {
    class: [_vm.$style.root, _vm.props.showChatOnMobile ? _vm.$style.on : _vm.$style.off],
    attrs: {
      "data-branding-target": "mobile-sidebar-controls"
    },
    on: {
      "click": _vm.listeners.toggle
    }
  }, [_vm.props.showChatOnMobile ? [_c('SvgIcon', {
    class: [_vm.$style.upvote, _vm.props.answered && _vm.$style.disableCursor],
    attrs: {
      "name": "down-arrow",
      "size": "regular",
      "color": "primary-text-color"
    }
  }), _c('StyledText', {
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v("Collapse")])] : [_c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "heading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Event Widgets')) + " ")]), _c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "subHeading10"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Chat • Messages • Q&A • Poll • Docs')) + " ")])]], 2);
};
var MobileChatTogglevue_type_template_id_db43ccc6_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/MobileChatToggle.vue?vue&type=script&lang=js

/* harmony default export */ var MobileChatTogglevue_type_script_lang_js = ({
  components: {
    StyledText: StyledText
  },
  name: 'MobileChatToggle',
  functional: true,
  props: {
    showChatOnMobile: {
      type: Boolean,
      default: true
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EventWidgets/MobileChatToggle.vue?vue&type=script&lang=js
 /* harmony default export */ var EventWidgets_MobileChatTogglevue_type_script_lang_js = (MobileChatTogglevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventWidgets/MobileChatToggle.vue?vue&type=style&index=0&id=db43ccc6&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var MobileChatTogglevue_type_style_index_0_id_db43ccc6_prod_module_true_lang_scss = ({"root":"MobileChatToggle_root_yb0AH","on":"MobileChatToggle_on_lOSwL","off":"MobileChatToggle_off_CGRGz"});
;// CONCATENATED MODULE: ./src/components/EventWidgets/MobileChatToggle.vue?vue&type=style&index=0&id=db43ccc6&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/EventWidgets/MobileChatToggle.vue



;




function MobileChatToggle_injectStyles (context) {
  
  this["$style"] = (MobileChatTogglevue_type_style_index_0_id_db43ccc6_prod_module_true_lang_scss.locals || MobileChatTogglevue_type_style_index_0_id_db43ccc6_prod_module_true_lang_scss)

}

/* normalize component */

var MobileChatToggle_component = normalizeComponent(
  EventWidgets_MobileChatTogglevue_type_script_lang_js,
  MobileChatTogglevue_type_template_id_db43ccc6_functional_true_render,
  MobileChatTogglevue_type_template_id_db43ccc6_functional_true_staticRenderFns,
  true,
  MobileChatToggle_injectStyles,
  null,
  null
  
)

/* harmony default export */ var MobileChatToggle = (MobileChatToggle_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/AgendaFavoritesFilter.vue?vue&type=template&id=facb7636
var AgendaFavoritesFiltervue_type_template_id_facb7636_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('GTooltip', {
    class: _vm.$style.container,
    attrs: {
      "text": _vm.tooltipText,
      "position": "top-center"
    }
  }, [_c('OutlinedButton', {
    attrs: {
      "variant": "secondary",
      "alt": false,
      "size": "small",
      "align": "center",
      "icon": _vm.selectedState ? 'heart' : 'heart-outlined'
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('span', {
    attrs: {
      "aria-label": `Favorited: ${_vm.favoritesCount} items`
    }
  }, [_vm._v(" (" + _vm._s(_vm.favoritesCount) + ") ")])])], 1);
};
var AgendaFavoritesFiltervue_type_template_id_facb7636_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/AgendaFavoritesFilter.vue?vue&type=script&lang=js
/* harmony default export */ var AgendaFavoritesFiltervue_type_script_lang_js = ({
  name: 'AgendaFavoritesFilter',
  props: {
    agendaFavorites: Array,
    selected: Boolean
  },
  data() {
    return {
      tooltipText: this.$t('My favorites'),
      selectedState: this.selected
    };
  },
  methods: {
    handleClick() {
      this.selectedState = !this.selectedState;
      this.$emit('click', {
        selected: this.selectedState
      });
    }
  },
  computed: {
    favoritesCount() {
      return this.agendaFavorites.length;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EventWidgets/AgendaFavoritesFilter.vue?vue&type=script&lang=js
 /* harmony default export */ var EventWidgets_AgendaFavoritesFiltervue_type_script_lang_js = (AgendaFavoritesFiltervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventWidgets/AgendaFavoritesFilter.vue?vue&type=style&index=0&id=facb7636&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var AgendaFavoritesFiltervue_type_style_index_0_id_facb7636_prod_lang_scss_module_true = ({"container":"AgendaFavoritesFilter_container_kKJUp"});
;// CONCATENATED MODULE: ./src/components/EventWidgets/AgendaFavoritesFilter.vue?vue&type=style&index=0&id=facb7636&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/EventWidgets/AgendaFavoritesFilter.vue



;




function AgendaFavoritesFilter_injectStyles (context) {
  
  this["$style"] = (AgendaFavoritesFiltervue_type_style_index_0_id_facb7636_prod_lang_scss_module_true.locals || AgendaFavoritesFiltervue_type_style_index_0_id_facb7636_prod_lang_scss_module_true)

}

/* normalize component */

var AgendaFavoritesFilter_component = normalizeComponent(
  EventWidgets_AgendaFavoritesFiltervue_type_script_lang_js,
  AgendaFavoritesFiltervue_type_template_id_facb7636_render,
  AgendaFavoritesFiltervue_type_template_id_facb7636_staticRenderFns,
  false,
  AgendaFavoritesFilter_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AgendaFavoritesFilter = (AgendaFavoritesFilter_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/CurrentLiveSessions.vue?vue&type=template&id=a3188a74
var CurrentLiveSessionsvue_type_template_id_a3188a74_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading16",
      "color": "theme-primary-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Live Now')))]), _c('div', {
    class: _vm.$style.divider
  }), _c('div', {
    class: _vm.$style.agendaRowWrapper
  }, [_vm.currentSession ? _c('CurrentlyLiveAgendaItem', {
    attrs: {
      "item": _vm.currentSession,
      "isOutLinedButton": "",
      "isButtonDisabled": ""
    }
  }) : _vm._e(), _vm._l(_vm.sessions, function (session) {
    return _c('CurrentlyLiveAgendaItem', {
      key: session.id,
      attrs: {
        "item": session
      },
      on: {
        "join": item => _vm.$emit('join', item)
      }
    });
  })], 2)], 1);
};
var CurrentLiveSessionsvue_type_template_id_a3188a74_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/CurrentlyLiveAgendaItem.vue?vue&type=template&id=6eba5934
var CurrentlyLiveAgendaItemvue_type_template_id_6eba5934_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.itemWrapper
  }, [_c('div', {
    class: _vm.$style.details
  }, [_c('StyledText', {
    attrs: {
      "variant": "body15",
      "color": "theme-primary-color"
    }
  }, [_vm._v(_vm._s(_vm.item.title || 'Session'))])], 1), _c('div', {
    class: _vm.$style.ticketWrapper
  }, _vm._l(_vm.item.availableTracks, function (ticket) {
    return _c('div', {
      key: ticket,
      class: _vm.$style.ticket
    }, [_c('StyledText', {
      attrs: {
        "variant": "body12",
        "color": "theme-primary-color"
      }
    }, [_vm._v(_vm._s(ticket))])], 1);
  }), 0)]), _vm.isOutLinedButton ? _c('OutlinedButton', {
    class: [_vm.$style.button],
    attrs: {
      "uppercase": "",
      "size": "small",
      "disabled": _vm.isButtonDisabled,
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('YOU ARE HERE')) + " ")]) : _c('PillButton', {
    class: _vm.$style.button,
    attrs: {
      "size": "small",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('join', _vm.item);
      }
    }
  }, [_vm._v(_vm._s(_vm.$options.$t('JOIN')))])], 1);
};
var CurrentlyLiveAgendaItemvue_type_template_id_6eba5934_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/CurrentlyLiveAgendaItem.vue?vue&type=script&lang=js
/* harmony default export */ var CurrentlyLiveAgendaItemvue_type_script_lang_js = ({
  name: 'CurrentlyLiveAgendaItem',
  props: {
    item: Object,
    isButtonDisabled: Boolean,
    isOutLinedButton: Boolean
  }
});
;// CONCATENATED MODULE: ./src/components/EventWidgets/CurrentlyLiveAgendaItem.vue?vue&type=script&lang=js
 /* harmony default export */ var EventWidgets_CurrentlyLiveAgendaItemvue_type_script_lang_js = (CurrentlyLiveAgendaItemvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventWidgets/CurrentlyLiveAgendaItem.vue?vue&type=style&index=0&id=6eba5934&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var CurrentlyLiveAgendaItemvue_type_style_index_0_id_6eba5934_prod_lang_scss_module_true = ({"root":"CurrentlyLiveAgendaItem_root_bJkVv","itemWrapper":"CurrentlyLiveAgendaItem_itemWrapper_OMfHs","details":"CurrentlyLiveAgendaItem_details_NMOMM","ticketWrapper":"CurrentlyLiveAgendaItem_ticketWrapper_d_8ql","ticket":"CurrentlyLiveAgendaItem_ticket_CHjQE","button":"CurrentlyLiveAgendaItem_button_m5Y8R","disabled":"CurrentlyLiveAgendaItem_disabled_o37Xc"});
;// CONCATENATED MODULE: ./src/components/EventWidgets/CurrentlyLiveAgendaItem.vue?vue&type=style&index=0&id=6eba5934&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/EventWidgets/CurrentlyLiveAgendaItem.vue



;




function CurrentlyLiveAgendaItem_injectStyles (context) {
  
  this["$style"] = (CurrentlyLiveAgendaItemvue_type_style_index_0_id_6eba5934_prod_lang_scss_module_true.locals || CurrentlyLiveAgendaItemvue_type_style_index_0_id_6eba5934_prod_lang_scss_module_true)

}

/* normalize component */

var CurrentlyLiveAgendaItem_component = normalizeComponent(
  EventWidgets_CurrentlyLiveAgendaItemvue_type_script_lang_js,
  CurrentlyLiveAgendaItemvue_type_template_id_6eba5934_render,
  CurrentlyLiveAgendaItemvue_type_template_id_6eba5934_staticRenderFns,
  false,
  CurrentlyLiveAgendaItem_injectStyles,
  null,
  null
  
)

/* harmony default export */ var CurrentlyLiveAgendaItem = (CurrentlyLiveAgendaItem_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventWidgets/CurrentLiveSessions.vue?vue&type=script&lang=js

/* harmony default export */ var CurrentLiveSessionsvue_type_script_lang_js = ({
  name: 'CurrentLiveSessions',
  components: {
    CurrentlyLiveAgendaItem: CurrentlyLiveAgendaItem
  },
  props: {
    currentSession: Object,
    sessions: Array
  }
});
;// CONCATENATED MODULE: ./src/components/EventWidgets/CurrentLiveSessions.vue?vue&type=script&lang=js
 /* harmony default export */ var EventWidgets_CurrentLiveSessionsvue_type_script_lang_js = (CurrentLiveSessionsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventWidgets/CurrentLiveSessions.vue?vue&type=style&index=0&id=a3188a74&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var CurrentLiveSessionsvue_type_style_index_0_id_a3188a74_prod_lang_scss_module_true = ({"root":"CurrentLiveSessions_root_KpvBw","divider":"CurrentLiveSessions_divider_FlE9o","agendaRowWrapper":"CurrentLiveSessions_agendaRowWrapper_bEBf_"});
;// CONCATENATED MODULE: ./src/components/EventWidgets/CurrentLiveSessions.vue?vue&type=style&index=0&id=a3188a74&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/EventWidgets/CurrentLiveSessions.vue



;




function CurrentLiveSessions_injectStyles (context) {
  
  this["$style"] = (CurrentLiveSessionsvue_type_style_index_0_id_a3188a74_prod_lang_scss_module_true.locals || CurrentLiveSessionsvue_type_style_index_0_id_a3188a74_prod_lang_scss_module_true)

}

/* normalize component */

var CurrentLiveSessions_component = normalizeComponent(
  EventWidgets_CurrentLiveSessionsvue_type_script_lang_js,
  CurrentLiveSessionsvue_type_template_id_a3188a74_render,
  CurrentLiveSessionsvue_type_template_id_a3188a74_staticRenderFns,
  false,
  CurrentLiveSessions_injectStyles,
  null,
  null
  
)

/* harmony default export */ var CurrentLiveSessions = (CurrentLiveSessions_component.exports);
;// CONCATENATED MODULE: ./src/components/EventWidgets/index.js









;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TextQNA/TextQNAItem.vue?vue&type=template&id=0ce9cc83
var TextQNAItemvue_type_template_id_0ce9cc83_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.userImageHolder
  }, [_c('UserImage', {
    attrs: {
      "user": _vm.user,
      "size": "small"
    },
    on: {
      "click": _vm.openUserProfile
    }
  })], 1), _c('div', {
    class: _vm.$style.textQnADetails
  }, [_c('div', {
    class: _vm.$style.userNameDetailsHolder
  }, [_c('StyledText', {
    class: [_vm.$style.primaryColor, _vm.$style.userName],
    attrs: {
      "variant": "heading13",
      "display": "block"
    },
    on: {
      "click": _vm.openUserProfile
    }
  }, [_vm._v(" " + _vm._s(_vm.user && _vm.user.name) + " ")]), _c('StyledText', {
    class: [_vm.$style.primaryColor, _vm.$style.qaTime],
    attrs: {
      "variant": "body14"
    }
  }, [_vm._v(" " + _vm._s(_vm.time) + " ")]), _vm.showPrioritizedIcon ? _c('SvgIcon', {
    class: _vm.$style.priortizedIcon,
    attrs: {
      "name": "star",
      "size": "medium",
      "color": "primary-text-color"
    }
  }) : _vm._e()], 1), _c('ReadMoreLessWrapper', {
    class: [_vm.$style.primaryColor, _vm.$style.textbubble],
    attrs: {
      "text": _vm.text,
      "visibleTextHeight": "40px"
    }
  }, [_c('ChatMessageRenderer', {
    attrs: {
      "text": _vm.text,
      "linkClass": _vm.$style.chatLinks,
      "containerClass": _vm.$style.messageTextBody
    },
    on: {
      "linkclicked": e => _vm.$emit('linkClicked', e),
      "buttonclicked": () => {}
    }
  })], 1), _vm.answer || _vm.showAnswerMode ? _c('TextQNAAnswerHolder', {
    attrs: {
      "answer": _vm.answer,
      "answered": _vm.answered,
      "answeredByUser": _vm.answeredByUser,
      "canEditAnswer": _vm.canEditAnswer,
      "isSpeakerOrOrganizer": _vm.isSpeakerOrOrganizer,
      "textQNAAnswerMeta": _vm.textQNAAnswerMeta,
      "placeholder": _vm.$options.$t(`Enter answer...`)
    },
    on: {
      "linkClicked": e => _vm.$emit('linkClicked', e),
      "buttonClicked": () => {},
      "sendnewtextqna": answerText => {
        _vm.showAnswerMode = false, _vm.$emit('answertextqna', {
          answer: answerText,
          questionId: _vm.id
        });
      }
    }
  }) : _vm._e(), _c('div', {
    class: _vm.$style.testQNAActionBtnHolder
  }, [_c('span', [_vm.approvedByMods && !_vm.isTextQNAUpvotingDisabled ? _c('div', {
    class: _vm.$style.upvotes
  }, [_c('div', {
    class: [_vm.$style.upvoteButton, _vm.upvotedByUser && _vm.$style.upvoted, _vm.answered && _vm.$style.disableCursor],
    on: {
      "click": function ($event) {
        return _vm.$emit('voteforquestion', _vm.id);
      }
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.upvote,
    attrs: {
      "name": "thumbsup",
      "size": "medium",
      "color": "primary-text-color"
    }
  }), _c('StyledText', {
    class: _vm.$style.votesHolder,
    attrs: {
      "variant": "body12"
    }
  }, [_vm._v(" " + _vm._s(_vm.totalUpvotes) + " ")])], 1)]) : _vm._e()]), _vm.isSpeakerOrOrganizer ? _c('div', {
    class: _vm.$style.speakerActionBtnsHolder
  }, [_vm.approvedByMods && _vm.sharingEnabled ? _c('div', {
    class: _vm.$style.actionButton,
    on: {
      "click": function ($event) {
        return _vm.$emit('publishqnapost', _vm.id);
      }
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.actionIcon,
    attrs: {
      "name": "screen-share"
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "body11"
    }
  }, [_vm._v(" " + _vm._s(_vm.published ? _vm.$options.$t('Shared') : _vm.$options.$t('Share')) + " ")])], 1) : _vm._e(), !_vm.answered ? _c('div', {
    class: _vm.$style.actionButton,
    on: {
      "click": function ($event) {
        _vm.showAnswerMode = !_vm.showAnswerMode;
      }
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.actionIcon,
    attrs: {
      "name": "answer"
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "body11"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Answer')) + " ")])], 1) : _c('div', {
    class: [_vm.$style.actionButton, _vm.$style.nonAction]
  }, [_c('StyledText', {
    attrs: {
      "variant": "body11"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Answered')) + " ")])], 1), !_vm.approvedByMods ? _c('div', {
    class: _vm.$style.actionButton,
    on: {
      "click": function ($event) {
        return _vm.$emit('approveqnapost', _vm.id);
      }
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.actionIcon,
    attrs: {
      "name": "approve"
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "body11"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Approve')) + " ")])], 1) : _vm._e()]) : [!_vm.approvedByMods ? _c('div', {
    class: _vm.$style.speakerActionBtnsHolder
  }, [!_vm.approvedByMods ? _c('StyledText', {
    class: _vm.$style.audienceText,
    attrs: {
      "variant": "body11",
      "uppercase": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Waiting Approval')) + "... ")]) : _vm._e()], 1) : _vm.approvedByMods && _vm.answered ? _c('div', {
    class: _vm.$style.speakerActionBtnsHolder
  }, [_c('StyledText', {
    class: _vm.$style.audienceText,
    attrs: {
      "uppercase": "",
      "variant": "body11"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Answered')) + " ")])], 1) : _vm._e()]], 2)], 1), _vm.isMoreDropdownAvailable ? _c('span', [_c('TextQNAMoreDropdown', {
    class: _vm.$style.more,
    attrs: {
      "isPrioritized": _vm.isPrioritized,
      "answered": _vm.answered,
      "isSpeakerOrOrganizer": _vm.isSpeakerOrOrganizer
    },
    on: {
      "unmarkTextQNAPriority": function ($event) {
        return _vm.$emit('unmarkTextQNAPriority', _vm.id);
      },
      "markTextQNAPriority": function ($event) {
        return _vm.$emit('markTextQNAPriority', _vm.id);
      },
      "deleteQuestion": function ($event) {
        return _vm.$emit('deleteQuestion', _vm.id);
      },
      "markasanswered": function ($event) {
        return _vm.$emit('markasanswered', _vm.id);
      },
      "markunasanswered": function ($event) {
        return _vm.$emit('markunasanswered', {
          questionId: _vm.id,
          answerId: _vm.answerId
        });
      }
    }
  })], 1) : _vm._e()]);
};
var TextQNAItemvue_type_template_id_0ce9cc83_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TextQNA/TextQNAMoreDropdown.vue?vue&type=template&id=33977397
var TextQNAMoreDropdownvue_type_template_id_33977397_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.more,
    on: {
      "click": _vm.toggleMoreMenu
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "more",
      "size": "small",
      "color": "primary-text-color"
    }
  })], 1), _c('DropdownSetup', {
    attrs: {
      "open": _vm.isMoreMenuOpen
    },
    on: {
      "close": _vm.toggleMoreMenu
    }
  }, [_c('div', {
    class: _vm.$style.dropdown,
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_vm.isSpeakerOrOrganizer ? _c('StyledText', {
    class: _vm.$style.primaryColor,
    attrs: {
      "variant": "body14"
    },
    on: {
      "click": _vm.toggleAnswered
    }
  }, [_vm._v(" " + _vm._s(_vm.answered ? _vm.$options.$t('Mark as Unanswered') : _vm.$options.$t('Mark as Answered')) + " ")]) : _vm._e(), _vm.isSpeakerOrOrganizer ? _c('StyledText', {
    class: _vm.$style.primaryColor,
    attrs: {
      "variant": "body14"
    },
    on: {
      "click": _vm.togglePriority
    }
  }, [_vm._v(" " + _vm._s(_vm.isPrioritized ? _vm.$options.$t('Remove from Priority') : _vm.$options.$t('Mark as Priority')) + " ")]) : _vm._e(), _c('StyledText', {
    class: _vm.$style.primaryColor,
    attrs: {
      "variant": "body14"
    },
    on: {
      "click": _vm.deleteQuestion
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Delete')) + " ")])], 1)])], 1);
};
var TextQNAMoreDropdownvue_type_template_id_33977397_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TextQNA/TextQNAMoreDropdown.vue?vue&type=script&lang=js
/* harmony default export */ var TextQNAMoreDropdownvue_type_script_lang_js = ({
  name: 'TextQNAMoreDropdown',
  data() {
    return {
      isMoreMenuOpen: false
    };
  },
  props: {
    isPrioritized: {
      type: Boolean,
      default: false
    },
    answered: {
      type: Boolean,
      default: false
    },
    isSpeakerOrOrganizer: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleMoreMenu() {
      this.isMoreMenuOpen = !this.isMoreMenuOpen;
    },
    closeMoreMenu() {
      this.isMoreMenuOpen = false;
    },
    deleteQuestion() {
      this.isMoreMenuOpen = !this.isMoreMenuOpen;
      this.$emit('deleteQuestion');
    },
    togglePriority() {
      this.closeMoreMenu();
      if (this.isPrioritized) {
        this.$emit('unmarkTextQNAPriority');
        return;
      }
      this.$emit('markTextQNAPriority');
    },
    toggleAnswered() {
      this.closeMoreMenu();
      if (this.answered) {
        this.$emit('markunasanswered');
        return;
      }
      this.$emit('markasanswered');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQNAMoreDropdown.vue?vue&type=script&lang=js
 /* harmony default export */ var TextQNA_TextQNAMoreDropdownvue_type_script_lang_js = (TextQNAMoreDropdownvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TextQNA/TextQNAMoreDropdown.vue?vue&type=style&index=0&id=33977397&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var TextQNAMoreDropdownvue_type_style_index_0_id_33977397_prod_module_true_lang_scss = ({"root":"TextQNAMoreDropdown_root_xSA5V","more":"TextQNAMoreDropdown_more_pPd_R","primaryColor":"TextQNAMoreDropdown_primaryColor_QzLE6","dropdown":"TextQNAMoreDropdown_dropdown_bxaYK"});
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQNAMoreDropdown.vue?vue&type=style&index=0&id=33977397&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQNAMoreDropdown.vue



;




function TextQNAMoreDropdown_injectStyles (context) {
  
  this["$style"] = (TextQNAMoreDropdownvue_type_style_index_0_id_33977397_prod_module_true_lang_scss.locals || TextQNAMoreDropdownvue_type_style_index_0_id_33977397_prod_module_true_lang_scss)

}

/* normalize component */

var TextQNAMoreDropdown_component = normalizeComponent(
  TextQNA_TextQNAMoreDropdownvue_type_script_lang_js,
  TextQNAMoreDropdownvue_type_template_id_33977397_render,
  TextQNAMoreDropdownvue_type_template_id_33977397_staticRenderFns,
  false,
  TextQNAMoreDropdown_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TextQNAMoreDropdown = (TextQNAMoreDropdown_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TextQNA/TextQNAItem.vue?vue&type=script&lang=js

/* harmony default export */ var TextQNAItemvue_type_script_lang_js = ({
  name: 'TextQNAItem',
  data() {
    return {
      showAnswerMode: false
    };
  },
  components: {
    TextQNAMoreDropdown: TextQNAMoreDropdown
  },
  props: {
    id: {
      type: String,
      value: ''
    },
    currentUser: {
      type: Object,
      default: () => {
        return {
          name: '',
          image: '',
          id: ''
        };
      }
    },
    user: {
      type: Object,
      default: () => {
        return {
          name: '',
          image: ''
        };
      }
    },
    time: {
      type: String,
      default: '9:45 PM'
    },
    text: {
      type: String,
      default: 'This is a text q&a question!'
    },
    upvotedByUser: {
      type: Boolean,
      default: false
    },
    totalUpvotes: {
      type: Number,
      default: 0
    },
    isSpeakerOrOrganizer: {
      type: Boolean,
      default: false
    },
    approvedByMods: {
      type: Boolean,
      default: true
    },
    isPrioritized: {
      type: Boolean,
      default: false
    },
    answered: {
      type: Boolean,
      default: false
    },
    published: {
      type: Boolean,
      default: false
    },
    answer: {
      type: String,
      default: ''
    },
    answerId: {
      type: String,
      default: ''
    },
    answeredByUser: {
      type: Object,
      default: () => {
        return {
          name: '',
          id: ''
        };
      }
    },
    textQNAAnswerMeta: Object,
    sharingEnabled: Boolean,
    isTextQNAUpvotingDisabled: Boolean
  },
  computed: {
    showPrioritizedIcon() {
      if (!this.isPrioritized) {
        return false;
      }
      if (this.isSpeakerOrOrganizer) {
        return true;
      }
      return false;
    },
    canEditAnswer() {
      if (!this.isSpeakerOrOrganizer) {
        return false;
      }
      if (!this.answered) {
        return true;
      }
      if (this.answeredByUser.id === this.currentUser.id) {
        return true;
      }
      return false;
    },
    isMoreDropdownAvailable() {
      if (this.isSpeakerOrOrganizer) {
        return true;
      }
      if (this.answered) {
        return false;
      }
      if (this.user?.id === this.currentUser?.id) {
        return true;
      }
      return false;
    }
  },
  methods: {
    openUserProfile() {
      if (this.user?.name === 'Anonymous') {
        return;
      }
      this.$emit('userClicked', this.user?.id);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQNAItem.vue?vue&type=script&lang=js
 /* harmony default export */ var TextQNA_TextQNAItemvue_type_script_lang_js = (TextQNAItemvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TextQNA/TextQNAItem.vue?vue&type=style&index=0&id=0ce9cc83&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var TextQNAItemvue_type_style_index_0_id_0ce9cc83_prod_module_true_lang_scss = ({"root":"TextQNAItem_root__qy3t","userImageHolder":"TextQNAItem_userImageHolder__7o6R","textQnADetails":"TextQNAItem_textQnADetails_RU1Ds","userNameDetailsHolder":"TextQNAItem_userNameDetailsHolder_lKyKu","primaryColor":"TextQNAItem_primaryColor_UImTP","userName":"TextQNAItem_userName_rEsgL","qaTime":"TextQNAItem_qaTime_RHg5z","priortizedIcon":"TextQNAItem_priortizedIcon_shQK7","textbubble":"TextQNAItem_textbubble_NLfmJ","messageTextBody":"TextQNAItem_messageTextBody_ZwPuy","chatLinks":"TextQNAItem_chatLinks_CCMkI","testQNAActionBtnHolder":"TextQNAItem_testQNAActionBtnHolder_b3Zf1","upvotes":"TextQNAItem_upvotes_J2Yxa","upvoteButton":"TextQNAItem_upvoteButton_54m8V","upvoted":"TextQNAItem_upvoted_npcxi","disableCursor":"TextQNAItem_disableCursor_OALOI","votesHolder":"TextQNAItem_votesHolder_oq2mw","upvote":"TextQNAItem_upvote_kc1Cw","speakerActionBtnsHolder":"TextQNAItem_speakerActionBtnsHolder_WNQDE","actionButton":"TextQNAItem_actionButton__8v6v","actionIcon":"TextQNAItem_actionIcon_xXHae","shareButton":"TextQNAItem_shareButton_qOEE8","nonAction":"TextQNAItem_nonAction_Qi8tx","audienceText":"TextQNAItem_audienceText_wG64l","answered":"TextQNAItem_answered_xhjSY"});
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQNAItem.vue?vue&type=style&index=0&id=0ce9cc83&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQNAItem.vue



;




function TextQNAItem_injectStyles (context) {
  
  this["$style"] = (TextQNAItemvue_type_style_index_0_id_0ce9cc83_prod_module_true_lang_scss.locals || TextQNAItemvue_type_style_index_0_id_0ce9cc83_prod_module_true_lang_scss)

}

/* normalize component */

var TextQNAItem_component = normalizeComponent(
  TextQNA_TextQNAItemvue_type_script_lang_js,
  TextQNAItemvue_type_template_id_0ce9cc83_render,
  TextQNAItemvue_type_template_id_0ce9cc83_staticRenderFns,
  false,
  TextQNAItem_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TextQNAItem = (TextQNAItem_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TextQNA/TextQNAAnswerHolder.vue?vue&type=template&id=5ddde95f
var TextQNAAnswerHoldervue_type_template_id_5ddde95f_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.answerWrapper
  }, [_vm.answer && !_vm.isEditModeOn ? _c('div', [_vm.answeredByUserName ? _c('StyledText', {
    class: _vm.$style.answeredBy,
    attrs: {
      "variant": "body11",
      "color": "theme-secondary-color"
    }
  }, [_vm._v(_vm._s(_vm.$options.$t('Answered by')) + " " + _vm._s(_vm.answeredByUserName))]) : _vm._e(), _c('ReadMoreLessWrapper', {
    class: _vm.$style.textbubble,
    attrs: {
      "text": _vm.answer,
      "visibleTextHeight": "40px"
    }
  }, [_c('ChatMessageRenderer', {
    attrs: {
      "text": _vm.answer,
      "linkClass": _vm.$style.chatLinks,
      "containerClass": _vm.$style.messageTextBody
    },
    on: {
      "linkclicked": e => _vm.$emit('linkClicked', e),
      "buttonclicked": e => _vm.$emit('buttonClicked', e)
    }
  })], 1), _vm.canEditAnswer ? _c('StyledText', {
    class: _vm.$style.actionButton,
    attrs: {
      "variant": "body11",
      "color": "theme-secondary-color"
    },
    on: {
      "click": _vm.switchToEditMode
    }
  }, [_vm._v(_vm._s(_vm.$options.$t('Edit')) + " ")]) : _vm._e()], 1) : _c('div', {
    class: _vm.$style.textInputWrapper
  }, [_vm.placeholder && !_vm.value ? _c('StyledText', {
    class: {
      [_vm.$style.placeholder]: true
    },
    attrs: {
      "color": "primary-text-color",
      "variant": "body14"
    }
  }, [_vm._v(" " + _vm._s(_vm.placeholder) + " ")]) : _vm._e(), _c('div', {
    ref: "textarea",
    class: _vm.$style.txtQnaTextBox,
    attrs: {
      "contenteditable": ""
    },
    on: {
      "paste": function ($event) {
        $event.preventDefault();
        return _vm.handlepaste.apply(null, arguments);
      },
      "keydown": _vm.handleKeyboard,
      "keyup": function ($event) {
        _vm.value = _vm.$refs.textarea.innerHTML;
      }
    }
  })], 1)]), !_vm.answer || _vm.isEditModeOn ? _c('div', {
    class: _vm.$style.actionBar
  }, [_c('StyledText', {
    class: _vm.$style.submitAnswer,
    attrs: {
      "variant": "body11"
    },
    on: {
      "click": _vm.sendQNA
    }
  }, [_vm._v(_vm._s(_vm.$options.$t('Submit Answer')) + " ")])], 1) : _vm._e()]);
};
var TextQNAAnswerHoldervue_type_template_id_5ddde95f_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TextQNA/TextQNAAnswerHolder.vue?vue&type=script&lang=js
/* harmony default export */ var TextQNAAnswerHoldervue_type_script_lang_js = ({
  name: 'TextQNAAnswerHolder',
  props: {
    placeholder: {
      type: String,
      default: 'Enter answer...'
    },
    answer: {
      type: String,
      default: ''
    },
    answered: {
      type: Boolean,
      default: false
    },
    canEditAnswer: {
      type: Boolean,
      default: false
    },
    isSpeakerOrOrganizer: {
      type: Boolean,
      default: false
    },
    textQNAAnswerMeta: Object,
    answeredByUser: {
      type: Object,
      default: () => {
        return {
          name: '',
          id: ''
        };
      }
    }
  },
  data() {
    return {
      isEditModeOn: false,
      value: ''
    };
  },
  methods: {
    handlepaste(e) {
      let text = e.clipboardData.getData('text/plain');
      this.$refs.textarea.innerHTML += text;
      this.value = this.$refs.textarea.innerHTML;
      this.$nextTick(() => {
        const textarea = this.$refs.textarea;
        const range = document.createRange();
        const selection = window.getSelection();
        let numlines = textarea.childNodes?.length;
        if (numlines === 0) {
          numlines = 1;
        }
        const lastLine = textarea.childNodes[numlines - 1];
        range.setStart(lastLine, lastLine?.length);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
      });
    },
    switchToEditMode() {
      if (!this.canEditAnswer) {
        return;
      }
      this.isEditModeOn = true;
      this.$nextTick(() => {
        this.$refs.textarea.innerHTML = this.answer;
        this.value = this.answer;
        const textarea = this.$refs.textarea;
        const range = document.createRange();
        const selection = window.getSelection();
        let numlines = textarea.childNodes?.length;
        if (numlines === 0) {
          numlines = 1;
        }
        const lastLine = textarea.childNodes[numlines - 1];
        range.setStart(lastLine, lastLine?.length);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
      });
    },
    handleKeyboard(ev) {
      if (ev.key === 'Enter' && !ev.shiftKey) {
        ev.preventDefault();
      }
    },
    sendQNA() {
      this.isEditModeOn = false;
      this.$emit('sendnewtextqna', this.value);
    }
  },
  computed: {
    answeredByUserName() {
      if (this.isSpeakerOrOrganizer) {
        return this.answeredByUser?.name || '';
      }
      if (!this.textQNAAnswerMeta.showAnswerersIdentity) {
        return '';
      }
      if (this.textQNAAnswerMeta?.answerersAlias.length > 0) {
        return this.textQNAAnswerMeta.answerersAlias;
      }
      return this.answeredByUser?.name || '';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQNAAnswerHolder.vue?vue&type=script&lang=js
 /* harmony default export */ var TextQNA_TextQNAAnswerHoldervue_type_script_lang_js = (TextQNAAnswerHoldervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TextQNA/TextQNAAnswerHolder.vue?vue&type=style&index=0&id=5ddde95f&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var TextQNAAnswerHoldervue_type_style_index_0_id_5ddde95f_prod_module_true_lang_scss = ({"root":"TextQNAAnswerHolder_root_EakoP","answerWrapper":"TextQNAAnswerHolder_answerWrapper_u4PRQ","answeredBy":"TextQNAAnswerHolder_answeredBy_NRhnI","textbubble":"TextQNAAnswerHolder_textbubble_PnO7R","messageTextBody":"TextQNAAnswerHolder_messageTextBody_JRPFX","chatLinks":"TextQNAAnswerHolder_chatLinks_yeQY6","actionButton":"TextQNAAnswerHolder_actionButton_PgrKG","textInputWrapper":"TextQNAAnswerHolder_textInputWrapper_GmKsW","placeholder":"TextQNAAnswerHolder_placeholder_juxHi","txtQnaTextBox":"TextQNAAnswerHolder_txtQnaTextBox_ipSAz","actionBar":"TextQNAAnswerHolder_actionBar_YHN2L","submitAnswer":"TextQNAAnswerHolder_submitAnswer_hk3vm"});
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQNAAnswerHolder.vue?vue&type=style&index=0&id=5ddde95f&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQNAAnswerHolder.vue



;




function TextQNAAnswerHolder_injectStyles (context) {
  
  this["$style"] = (TextQNAAnswerHoldervue_type_style_index_0_id_5ddde95f_prod_module_true_lang_scss.locals || TextQNAAnswerHoldervue_type_style_index_0_id_5ddde95f_prod_module_true_lang_scss)

}

/* normalize component */

var TextQNAAnswerHolder_component = normalizeComponent(
  TextQNA_TextQNAAnswerHoldervue_type_script_lang_js,
  TextQNAAnswerHoldervue_type_template_id_5ddde95f_render,
  TextQNAAnswerHoldervue_type_template_id_5ddde95f_staticRenderFns,
  false,
  TextQNAAnswerHolder_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TextQNAAnswerHolder = (TextQNAAnswerHolder_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TextQNA/TextQnaPublished.vue?vue&type=template&id=5d9d3b9f
var TextQnaPublishedvue_type_template_id_5d9d3b9f_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.minimized]: _vm.minimized
    },
    attrs: {
      "data-branding-target": "text-qna-published"
    }
  }, [_c('div', {
    class: _vm.$style.sender
  }, [_c('UserTooltip', {
    class: _vm.$style.image,
    attrs: {
      "size": "small",
      "user": _vm.question.user,
      "variant": "primary",
      "position": "top-left"
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "subHeading18",
      "color": "screen-saver-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.question.user.name) + " " + _vm._s(_vm.question.time) + " ")])], 1), _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "variant": _vm.minimized ? 'heading15' : 'heading24',
      "color": "screen-saver-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.question.questionText) + " "), _c('div', {
    class: _vm.$style.likes
  }, [_c('SvgIcon', {
    attrs: {
      "name": "thumbsup",
      "color": "screen-saver-text-color",
      "size": "regular"
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "subHeading18",
      "color": "screen-saver-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.question.totalUpvotes) + " ")])], 1), _vm.question.answer ? [_c('StyledText', {
    class: _vm.$style.answer,
    attrs: {
      "variant": "heading24"
    }
  }, [_c('ChatMessageRenderer', {
    attrs: {
      "text": _vm.question.answer,
      "linkClass": _vm.$style.chatLinks,
      "containerClass": _vm.$style.messageTextBody
    },
    on: {
      "linkclicked": () => {},
      "buttonclicked": () => {}
    }
  })], 1), _vm.textQNAAnswerMeta.showAnswerersIdentity ? _c('div', {
    class: _vm.$style.sender
  }, [_c('StyledText', {
    attrs: {
      "variant": "subHeading18",
      "color": "screen-saver-text-color"
    }
  }, [_vm._v(_vm._s(_vm.$t('Answered by:')) + "   ")]), _c('UserTooltip', {
    class: _vm.$style.image,
    attrs: {
      "size": "small",
      "user": _vm.answerersUser,
      "variant": "primary",
      "position": "top-left"
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "subHeading18",
      "color": "screen-saver-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.answeredByUserName) + " ")])], 1) : _vm._e()] : _vm._e()], 2)], 1);
};
var TextQnaPublishedvue_type_template_id_5d9d3b9f_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TextQNA/TextQnaPublished.vue?vue&type=script&lang=js
/* harmony default export */ var TextQnaPublishedvue_type_script_lang_js = ({
  name: 'TextQnaPublished',
  props: {
    question: {
      type: Object,
      required: true
    },
    minimized: Boolean,
    textQNAAnswerMeta: Object
  },
  computed: {
    answerersUser() {
      const answerUser = this.question.answeredByUser;
      if (this.textQNAAnswerMeta?.answerersAlias.length > 0) {
        return {
          name: this.textQNAAnswerMeta.answerersAlias,
          id: '',
          mediumimage: '',
          is_in_person: answerUser.is_in_person
        };
      }
      return this.question.answeredByUser;
    },
    answeredByUserName() {
      if (!this.textQNAAnswerMeta.showAnswerersIdentity) {
        return '';
      }
      if (this.textQNAAnswerMeta?.answerersAlias.length > 0) {
        return this.textQNAAnswerMeta.answerersAlias;
      }
      return this.question.answeredByUser?.name || '';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQnaPublished.vue?vue&type=script&lang=js
 /* harmony default export */ var TextQNA_TextQnaPublishedvue_type_script_lang_js = (TextQnaPublishedvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TextQNA/TextQnaPublished.vue?vue&type=style&index=0&id=5d9d3b9f&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var TextQnaPublishedvue_type_style_index_0_id_5d9d3b9f_prod_module_true_lang_scss = ({"root":"TextQnaPublished_root_d5kDo","sender":"TextQnaPublished_sender_i0No7","likes":"TextQnaPublished_likes_gDwFk","image":"TextQnaPublished_image_QdG9o","content":"TextQnaPublished_content_lYLZY","answer":"TextQnaPublished_answer_UXdhq","messageTextBody":"TextQnaPublished_messageTextBody_hUsGR","chatLinks":"TextQnaPublished_chatLinks_l3hPZ","minimized":"TextQnaPublished_minimized_VzxfL"});
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQnaPublished.vue?vue&type=style&index=0&id=5d9d3b9f&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/TextQNA/TextQnaPublished.vue



;




function TextQnaPublished_injectStyles (context) {
  
  this["$style"] = (TextQnaPublishedvue_type_style_index_0_id_5d9d3b9f_prod_module_true_lang_scss.locals || TextQnaPublishedvue_type_style_index_0_id_5d9d3b9f_prod_module_true_lang_scss)

}

/* normalize component */

var TextQnaPublished_component = normalizeComponent(
  TextQNA_TextQnaPublishedvue_type_script_lang_js,
  TextQnaPublishedvue_type_template_id_5d9d3b9f_render,
  TextQnaPublishedvue_type_template_id_5d9d3b9f_staticRenderFns,
  false,
  TextQnaPublished_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TextQnaPublished = (TextQnaPublished_component.exports);
;// CONCATENATED MODULE: ./src/components/TextQNA/index.js




;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/UserHomeNavBar.vue?vue&type=template&id=68a7ab88
var UserHomeNavBarvue_type_template_id_68a7ab88_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.ulheader
  }, [_c('div', {
    class: _vm.$style.headerelement
  }, [_c('PoweredBy', {
    attrs: {
      "text": ""
    }
  })], 1), _c('div', {
    class: _vm.$style.headerelement
  }, [_vm.showManageEventButton ? _c('button', {
    class: _vm.$style.manageEvents,
    on: {
      "click": function ($event) {
        return _vm.$emit('manage-events');
      }
    }
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading14",
      "color": "color-secondary-light"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('MANAGE EVENT')) + " ")])], 1) : _vm._e(), _c('div', {
    class: _vm.$style.userBubble,
    on: {
      "click": function ($event) {
        return _vm.$emit('go-to-profile');
      }
    }
  }, [_c('UserImage', {
    attrs: {
      "user": _vm.user,
      "size": "small"
    }
  })], 1)])]);
};
var UserHomeNavBarvue_type_template_id_68a7ab88_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/UserHomeNavBar.vue?vue&type=script&lang=js

/* harmony default export */ var UserHomeNavBarvue_type_script_lang_js = ({
  name: 'UserHomeNavBar',
  components: {
    StyledText: StyledText
  },
  props: {
    user: {
      type: Object,
      // {name, display_email, image, thumbnail}
      default: () => ({})
    },
    showManageEventButton: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserHome/UserHomeNavBar.vue?vue&type=script&lang=js
 /* harmony default export */ var UserHome_UserHomeNavBarvue_type_script_lang_js = (UserHomeNavBarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/UserHome/UserHomeNavBar.vue?vue&type=style&index=0&id=68a7ab88&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var UserHomeNavBarvue_type_style_index_0_id_68a7ab88_prod_lang_scss_module_true = ({"ulheader":"UserHomeNavBar_ulheader_sFReC","headerelement":"UserHomeNavBar_headerelement_xsM0C","manageEvents":"UserHomeNavBar_manageEvents_qzxet","userBubble":"UserHomeNavBar_userBubble_FATQO","userNavImg":"UserHomeNavBar_userNavImg_dzeOQ"});
;// CONCATENATED MODULE: ./src/components/UserHome/UserHomeNavBar.vue?vue&type=style&index=0&id=68a7ab88&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/UserHome/UserHomeNavBar.vue



;




function UserHomeNavBar_injectStyles (context) {
  
  this["$style"] = (UserHomeNavBarvue_type_style_index_0_id_68a7ab88_prod_lang_scss_module_true.locals || UserHomeNavBarvue_type_style_index_0_id_68a7ab88_prod_lang_scss_module_true)

}

/* normalize component */

var UserHomeNavBar_component = normalizeComponent(
  UserHome_UserHomeNavBarvue_type_script_lang_js,
  UserHomeNavBarvue_type_template_id_68a7ab88_render,
  UserHomeNavBarvue_type_template_id_68a7ab88_staticRenderFns,
  false,
  UserHomeNavBar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UserHomeNavBar = (UserHomeNavBar_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/UserProfile.vue?vue&type=template&id=3a8e7b8e
var UserProfilevue_type_template_id_3a8e7b8e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('UserImage', {
    attrs: {
      "user": _vm.user,
      "size": "large",
      "image-scale": "medium"
    }
  }), _c('StyledText', {
    style: {
      'margin-top': '10px'
    },
    attrs: {
      "color": "color-secondary-light",
      "variant": "subHeading18"
    }
  }, [_vm._v(" " + _vm._s(_vm.user.name || _vm.user.display_email) + " ")]), _vm.user.name ? _c('div', {
    class: _vm.$style.subTitle
  }, [_c('StyledText', {
    attrs: {
      "color": "color-variant-light-5",
      "variant": "body15"
    }
  }, [_vm._v(" " + _vm._s(_vm.user.display_email) + " ")])], 1) : _vm._e(), _c('div', {
    class: _vm.$style.editProf,
    on: {
      "click": function ($event) {
        return _vm.$emit('go-to-profile');
      }
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "edit",
      "size": "small",
      "color": "color-variant-light-5"
    }
  }), _c('div', {
    class: _vm.$style.text
  }, [_c('StyledText', {
    attrs: {
      "color": "color-secondary-light",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Edit Profile')) + " ")])], 1)], 1)], 1);
};
var UserProfilevue_type_template_id_3a8e7b8e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/UserProfile.vue?vue&type=script&lang=js

/* harmony default export */ var UserProfilevue_type_script_lang_js = ({
  name: 'UserProfile',
  components: {
    StyledText: StyledText
  },
  props: {
    user: {
      type: Object,
      // {name, display_email, image, thumbnail}
      default: () => ({})
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserHome/UserProfile.vue?vue&type=script&lang=js
 /* harmony default export */ var UserHome_UserProfilevue_type_script_lang_js = (UserProfilevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/UserHome/UserProfile.vue?vue&type=style&index=0&id=3a8e7b8e&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var UserProfilevue_type_style_index_0_id_3a8e7b8e_prod_lang_scss_module_true = ({"root":"UserProfile_root_t4GlR","subTitle":"UserProfile_subTitle_CaOa2","editProf":"UserProfile_editProf_OBfQl","text":"UserProfile_text_tGQGX"});
;// CONCATENATED MODULE: ./src/components/UserHome/UserProfile.vue?vue&type=style&index=0&id=3a8e7b8e&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/UserHome/UserProfile.vue



;




function UserProfile_injectStyles (context) {
  
  this["$style"] = (UserProfilevue_type_style_index_0_id_3a8e7b8e_prod_lang_scss_module_true.locals || UserProfilevue_type_style_index_0_id_3a8e7b8e_prod_lang_scss_module_true)

}

/* normalize component */

var UserProfile_component = normalizeComponent(
  UserHome_UserProfilevue_type_script_lang_js,
  UserProfilevue_type_template_id_3a8e7b8e_render,
  UserProfilevue_type_template_id_3a8e7b8e_staticRenderFns,
  false,
  UserProfile_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UserProfile = (UserProfile_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/EventsNavBar.vue?vue&type=template&id=74415e40
var EventsNavBarvue_type_template_id_74415e40_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.ulheader
  }, [_c('div', {
    class: _vm.$style.tabLabel,
    attrs: {
      "active": _vm.active === 0
    },
    on: {
      "click": _vm.selectUE
    }
  }, [_c('StyledText', {
    attrs: {
      "color": "color-secondary-light",
      "variant": "subHeading18"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Upcoming Events')) + " ")])], 1), _c('div', {
    class: _vm.$style.tabLabel,
    attrs: {
      "active": _vm.active === 1
    },
    on: {
      "click": _vm.selectPE
    }
  }, [_c('StyledText', {
    attrs: {
      "color": "color-secondary-light",
      "variant": "subHeading18"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Past Events')) + " ")])], 1)]);
};
var EventsNavBarvue_type_template_id_74415e40_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/EventsNavBar.vue?vue&type=script&lang=js
/* harmony default export */ var EventsNavBarvue_type_script_lang_js = ({
  name: 'UserHomeNavBar',
  data() {
    return {
      active: 0
    };
  },
  props: {
    imageUrl: {
      type: String,
      default: '../assets/logo.png'
    }
  },
  methods: {
    selectUE() {
      this.active = 0;
      this.$emit('on-select-tab', 0);
    },
    selectPE() {
      this.active = 1;
      this.$emit('on-select-tab', 1);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserHome/EventsNavBar.vue?vue&type=script&lang=js
 /* harmony default export */ var UserHome_EventsNavBarvue_type_script_lang_js = (EventsNavBarvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/UserHome/EventsNavBar.vue?vue&type=style&index=0&id=74415e40&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var EventsNavBarvue_type_style_index_0_id_74415e40_prod_lang_scss_module_true = ({"ulheader":"EventsNavBar_ulheader_Il9Kr","tabLabel":"EventsNavBar_tabLabel_uicaV"});
;// CONCATENATED MODULE: ./src/components/UserHome/EventsNavBar.vue?vue&type=style&index=0&id=74415e40&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/UserHome/EventsNavBar.vue



;




function EventsNavBar_injectStyles (context) {
  
  this["$style"] = (EventsNavBarvue_type_style_index_0_id_74415e40_prod_lang_scss_module_true.locals || EventsNavBarvue_type_style_index_0_id_74415e40_prod_lang_scss_module_true)

}

/* normalize component */

var EventsNavBar_component = normalizeComponent(
  UserHome_EventsNavBarvue_type_script_lang_js,
  EventsNavBarvue_type_template_id_74415e40_render,
  EventsNavBarvue_type_template_id_74415e40_staticRenderFns,
  false,
  EventsNavBar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var EventsNavBar = (EventsNavBar_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/EventsSection.vue?vue&type=template&id=0f8e8f44
var EventsSectionvue_type_template_id_0f8e8f44_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.loading ? _c('div', {
    class: _vm.$style.loading
  }, [_c('Loading', {
    attrs: {
      "size": "medium"
    }
  })], 1) : _vm._e(), !_vm.loading && !_vm.events.length ? _c('div', {
    class: _vm.$style.noEvent
  }, [_c('StyledText', {
    attrs: {
      "variant": "body15",
      "color": "color-secondary-light"
    }
  }, [_vm._v(" " + _vm._s(_vm.noEventText) + " ")])], 1) : _vm._e(), !_vm.loading && _vm.events.length ? _c('div', {
    class: _vm.$style.eventSection,
    style: _vm.eSStyle
  }, _vm._l(_vm.events, function (e) {
    return _c('div', {
      key: e.href
    }, [_c('div', {
      class: [_vm.$style.event],
      attrs: {
        "data-testmarker": "upcomingevents"
      }
    }, [_c('EventCard', {
      attrs: {
        "title": e.title,
        "image": e.image,
        "startTime": e.startTime,
        "endTime": e.endTime,
        "past": _vm.past
      },
      on: {
        "go-to-event": function ($event) {
          return _vm.$emit('go-to-event', e);
        }
      }
    })], 1)]);
  }), 0) : _vm._e()]);
};
var EventsSectionvue_type_template_id_0f8e8f44_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/EventCard.vue?vue&type=template&id=0f79723c
var EventCardvue_type_template_id_0f79723c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root]
  }, [_c('img', {
    class: [{
      [_vm.$style.pastImg]: _vm.past
    }],
    attrs: {
      "src": _vm.image
    }
  }), _c('div', {
    class: _vm.$style.overlay,
    on: {
      "mouseover": function ($event) {
        _vm.hover = true;
      },
      "mouseleave": function ($event) {
        _vm.hover = false;
      }
    }
  }, [_c('div', {
    class: _vm.$style.title
  }, [_c('StyledText', {
    attrs: {
      "color": "color-secondary-light",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])], 1), _c('div', {
    class: _vm.$style.details
  }, [_vm.hover ? _c('SimpleButton', {
    class: _vm.$style.enterBtn,
    attrs: {
      "variant": "outline",
      "textAlign": "center",
      "palette": "light"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('go-to-event');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('ENTER')) + " ")]) : _vm._e(), !_vm.hover ? _c('div', {
    class: _vm.$style.dateTime
  }, [_c('StyledText', {
    attrs: {
      "color": "color-secondary-light"
    }
  }, [_vm._v(_vm._s(_vm.eventDate) + " - ")]), _c('StyledText', {
    attrs: {
      "color": "color-secondary-light"
    }
  }, [_vm._v(_vm._s(_vm.eventTime))])], 1) : _vm._e()], 1)])]);
};
var EventCardvue_type_template_id_0f79723c_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/EventCard.vue?vue&type=script&lang=js


/* harmony default export */ var EventCardvue_type_script_lang_js = ({
  name: 'EventCard',
  components: {
    StyledText: StyledText
  },
  data() {
    return {
      hover: false
    };
  },
  computed: {
    eventDate() {
      const startMonth = getMonthFromDate(this.startTime, 2);
      const endMonth = getMonthFromDate(this.endTime, 2);
      const startDay = getDayFromDate(this.startTime);
      const endDay = getDayFromDate(this.endTime);
      let date = `${startMonth} ${startDay} -`;
      if (startMonth !== endMonth) {
        date += ` ${endMonth} ${endDay}`;
      } else {
        date += ` ${endDay}`;
      }
      return date;
    },
    eventTime() {
      return getAMPMFromDate(this.startTime);
    }
  },
  props: {
    image: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    startTime: {
      type: Date,
      default: () => new Date('2020-12-01T11:30:00Z')
    },
    endTime: {
      type: Date,
      default: () => null
    },
    past: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserHome/EventCard.vue?vue&type=script&lang=js
 /* harmony default export */ var UserHome_EventCardvue_type_script_lang_js = (EventCardvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/UserHome/EventCard.vue?vue&type=style&index=0&id=0f79723c&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var EventCardvue_type_style_index_0_id_0f79723c_prod_lang_scss_module_true = ({"root":"EventCard_root_PLXOe","pastImg":"EventCard_pastImg_RKX3D","overlay":"EventCard_overlay_AmuJj","title":"EventCard_title_N2_Er","details":"EventCard_details_JlWoe","dateTime":"EventCard_dateTime_ok303","enterBtn":"EventCard_enterBtn_QozhP"});
;// CONCATENATED MODULE: ./src/components/UserHome/EventCard.vue?vue&type=style&index=0&id=0f79723c&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/UserHome/EventCard.vue



;




function EventCard_injectStyles (context) {
  
  this["$style"] = (EventCardvue_type_style_index_0_id_0f79723c_prod_lang_scss_module_true.locals || EventCardvue_type_style_index_0_id_0f79723c_prod_lang_scss_module_true)

}

/* normalize component */

var EventCard_component = normalizeComponent(
  UserHome_EventCardvue_type_script_lang_js,
  EventCardvue_type_template_id_0f79723c_render,
  EventCardvue_type_template_id_0f79723c_staticRenderFns,
  false,
  EventCard_injectStyles,
  null,
  null
  
)

/* harmony default export */ var EventCard = (EventCard_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/EventsSection.vue?vue&type=script&lang=js


/* harmony default export */ var EventsSectionvue_type_script_lang_js = ({
  name: 'EventsSection',
  components: {
    EventCard: EventCard,
    Loading: Loading
  },
  props: {
    events: {
      type: Array,
      default: () => []
    },
    past: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      gridColumns: 0
    };
  },
  created() {
    const possibleNo = Math.floor((window.innerWidth - 100 - 100) / 225);
    const possibleGapWidth = (possibleNo - 1) * 50;
    const pCardCoveringGW = Math.ceil(possibleGapWidth / 225);
    const columnNos = possibleNo - pCardCoveringGW + 1;
    this.gridColumns = columnNos;
  },
  computed: {
    eSStyle() {
      return {
        'grid-template-columns': `repeat(${this.gridColumns}, auto)`
      };
    },
    noEventText() {
      if (this.past) {
        return this.$t('You have no past events.').toUpperCase();
      }
      return this.$t('You have no upcoming or live events.').toUpperCase();
    }
  }
});
;// CONCATENATED MODULE: ./src/components/UserHome/EventsSection.vue?vue&type=script&lang=js
 /* harmony default export */ var UserHome_EventsSectionvue_type_script_lang_js = (EventsSectionvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/UserHome/EventsSection.vue?vue&type=style&index=0&id=0f8e8f44&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var EventsSectionvue_type_style_index_0_id_0f8e8f44_prod_lang_scss_module_true = ({"root":"EventsSection_root_lgI3u","loading":"EventsSection_loading_o0tZ_","noEvent":"EventsSection_noEvent_ix3uN","eventSection":"EventsSection_eventSection_fOitd","event":"EventsSection_event_R3ktL"});
;// CONCATENATED MODULE: ./src/components/UserHome/EventsSection.vue?vue&type=style&index=0&id=0f8e8f44&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/UserHome/EventsSection.vue



;




function EventsSection_injectStyles (context) {
  
  this["$style"] = (EventsSectionvue_type_style_index_0_id_0f8e8f44_prod_lang_scss_module_true.locals || EventsSectionvue_type_style_index_0_id_0f8e8f44_prod_lang_scss_module_true)

}

/* normalize component */

var EventsSection_component = normalizeComponent(
  UserHome_EventsSectionvue_type_script_lang_js,
  EventsSectionvue_type_template_id_0f8e8f44_render,
  EventsSectionvue_type_template_id_0f8e8f44_staticRenderFns,
  false,
  EventsSection_injectStyles,
  null,
  null
  
)

/* harmony default export */ var EventsSection = (EventsSection_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/PoweredBy.vue?vue&type=template&id=148ea224
var PoweredByvue_type_template_id_148ea224_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [{
      [_vm.$style.root]: true,
      [_vm.$style.fullWidth]: _vm.fullWidth,
      [_vm.$style.background]: _vm.background
    }],
    style: !_vm.background && {
      background: 'transparent'
    }
  }, [_vm.text ? _c('StyledText', {
    attrs: {
      "color": "color-variant-light-50",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.text)) + " ")]) : _vm._e(), _c('a', {
    class: _vm.$style.goldcastLogo,
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "logo"
    }
  })], 1)], 1);
};
var PoweredByvue_type_template_id_148ea224_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/UserHome/PoweredBy.vue?vue&type=script&lang=js

/* harmony default export */ var PoweredByvue_type_script_lang_js = ({
  name: 'PoweredBy',
  props: {
    background: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Powered by'
    },
    link: {
      type: String,
      default: 'https://goldcast.io/'
    }
  },
  components: {
    StyledText: StyledText
  }
});
;// CONCATENATED MODULE: ./src/components/UserHome/PoweredBy.vue?vue&type=script&lang=js
 /* harmony default export */ var UserHome_PoweredByvue_type_script_lang_js = (PoweredByvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/UserHome/PoweredBy.vue?vue&type=style&index=0&id=148ea224&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var PoweredByvue_type_style_index_0_id_148ea224_prod_lang_scss_module_true = ({"root":"PoweredBy_root_bstEB","fullWidth":"PoweredBy_fullWidth_v1zTP","background":"PoweredBy_background_VEZpK","goldcastLogo":"PoweredBy_goldcastLogo_aCenf"});
;// CONCATENATED MODULE: ./src/components/UserHome/PoweredBy.vue?vue&type=style&index=0&id=148ea224&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/UserHome/PoweredBy.vue



;




function PoweredBy_injectStyles (context) {
  
  this["$style"] = (PoweredByvue_type_style_index_0_id_148ea224_prod_lang_scss_module_true.locals || PoweredByvue_type_style_index_0_id_148ea224_prod_lang_scss_module_true)

}

/* normalize component */

var PoweredBy_component = normalizeComponent(
  UserHome_PoweredByvue_type_script_lang_js,
  PoweredByvue_type_template_id_148ea224_render,
  PoweredByvue_type_template_id_148ea224_staticRenderFns,
  false,
  PoweredBy_injectStyles,
  null,
  null
  
)

/* harmony default export */ var PoweredBy = (PoweredBy_component.exports);
;// CONCATENATED MODULE: ./src/components/UserHome/index.js






;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/BoothWidgets/BoothGrid.vue?vue&type=template&id=530c334a&functional=true
var BoothGridvue_type_template_id_530c334a_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.props.showLoading ? _c('ProgressBar', [_vm._v(_vm._s(_vm.$options.$t('Loading...')))]) : _vm._e(), _vm._l(_vm.props.booths, function (key, index) {
    return _c('div', {
      key: index
    }, [key.name && key.booths.length && _vm.props.enableBoothTiers ? _c('LabeledSeparator', {
      attrs: {
        "variant": "subHeading18"
      }
    }, [_vm._v(" " + _vm._s(key.name) + " ")]) : _vm._e(), _c('ul', {
      class: [_vm.$style.grid, _vm.props.enableBoothTiers && key.booths.length && _vm.$style[key.booths[0].tier]],
      attrs: {
        "aria-live": "polite"
      }
    }, _vm._l(key.booths, function (group, i) {
      return _c('li', {
        key: i
      }, [_c('BoothCard', {
        attrs: {
          "id": group.id,
          "sponsorlogo": group.logo,
          "description": group.description,
          "totalrooms": (group.discussion_group || []).length,
          "poster": group.poster,
          "poster_type": group.poster_type,
          "showBoothRooms": _vm.props.showBoothRooms,
          "title": group.name,
          "tags": group.tags,
          "sponsorLink": group.sponsorLink,
          "index": i
        },
        on: {
          "click": () => _vm.listeners.join(group),
          "play": _vm.listeners.play,
          "pause": _vm.listeners.pause,
          "ended": _vm.listeners.ended
        }
      })], 1);
    }), 0)], 1);
  })], 2);
};
var BoothGridvue_type_template_id_530c334a_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/BoothWidgets/BoothGrid.vue?vue&type=script&lang=js
/* harmony default export */ var BoothGridvue_type_script_lang_js = ({
  name: 'boothtiers-grid',
  functional: true,
  props: {
    booths: {
      type: Array,
      default: () => {}
    },
    showLoading: {
      type: Boolean,
      default: false
    },
    showBoothRooms: {
      type: Boolean,
      default: true
    },
    enableBoothTiers: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/BoothWidgets/BoothGrid.vue?vue&type=script&lang=js
 /* harmony default export */ var BoothWidgets_BoothGridvue_type_script_lang_js = (BoothGridvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/BoothWidgets/BoothGrid.vue?vue&type=style&index=0&id=530c334a&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var BoothGridvue_type_style_index_0_id_530c334a_prod_lang_scss_module_true = ({"root":"BoothGrid_root_PgztP","grid":"BoothGrid_grid_BzrUG","TIER1":"BoothGrid_TIER1_xPFH0","TIER2":"BoothGrid_TIER2_gtGRP","TIER3":"BoothGrid_TIER3_emK_z","button":"BoothGrid_button_SlCLi","icon":"BoothGrid_icon_etgWf"});
;// CONCATENATED MODULE: ./src/components/BoothWidgets/BoothGrid.vue?vue&type=style&index=0&id=530c334a&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/BoothWidgets/BoothGrid.vue



;




function BoothGrid_injectStyles (context) {
  
  this["$style"] = (BoothGridvue_type_style_index_0_id_530c334a_prod_lang_scss_module_true.locals || BoothGridvue_type_style_index_0_id_530c334a_prod_lang_scss_module_true)

}

/* normalize component */

var BoothGrid_component = normalizeComponent(
  BoothWidgets_BoothGridvue_type_script_lang_js,
  BoothGridvue_type_template_id_530c334a_functional_true_render,
  BoothGridvue_type_template_id_530c334a_functional_true_staticRenderFns,
  true,
  BoothGrid_injectStyles,
  null,
  null
  
)

/* harmony default export */ var BoothGrid = (BoothGrid_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/BoothWidgets/BoothCard.vue?vue&type=template&id=9a65e158&functional=true
var BoothCardvue_type_template_id_9a65e158_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-labelledby": ['title-' + _vm.props.id, 'roomCountButton-' + _vm.props.id].join(' ')
    },
    on: {
      "click": _vm.listeners.click,
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.preventDefault();
        return _vm.listeners.click.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.listeners.click.apply(null, arguments);
      }]
    }
  }, [_c('div', {
    class: [_vm.$style.card, _vm.$style[_vm.props.status]],
    attrs: {
      "id": 'boothcard-' + _vm.props.id
    }
  }, [_c('div', {
    class: _vm.$style.img,
    style: {
      'background-image': `url('${_vm.props.poster}')`
    }
  }, [_vm.props.sponsorlogo ? _c('div', {
    class: _vm.$style.logocontainer
  }, [_vm.props.sponsorLink ? _c('a', {
    attrs: {
      "href": _vm.props.sponsorLink,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.sponsorlogo,
      "alt": _vm.props.title + 'Logo'
    }
  })]) : _c('img', {
    attrs: {
      "src": _vm.props.sponsorlogo,
      "alt": _vm.props.title + 'Logo'
    }
  })]) : _vm._e()]), _c('div', {
    class: _vm.$style.boothdetails
  }, [_c('div', {
    class: _vm.$style.boothdetails_top
  }, [_c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "id": 'title-' + _vm.props.id,
      "color": "primary-text-color",
      "variant": "subHeading18"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.title) + " ")])], 1), _c('div', {
    class: _vm.$style.boothdetails_bottom
  }, [_c('StyledText', {
    class: _vm.$style.description,
    attrs: {
      "color": "primary-text-color",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.description) + " ")]), _c('StyledText', {
    class: _vm.$style.boothdetails_actionLink,
    style: {
      color: 'var(--theme-secondary-color)'
    },
    attrs: {
      "variant": "body14"
    }
  }, [_vm.props.totalrooms === 0 || !_vm.props.showBoothRooms ? [_vm._v(" " + _vm._s(_vm.$options.$t('Enter')) + " ")] : [_c('span', {
    attrs: {
      "id": 'roomCountButton-' + _vm.props.id
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('See {roomCount} Room(s)', {
    roomCount: _vm.props.totalrooms
  })) + " ")])]], 2)], 1)])])]);
};
var BoothCardvue_type_template_id_9a65e158_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/BoothWidgets/BoothCard.vue?vue&type=script&lang=js
/* harmony default export */ var BoothCardvue_type_script_lang_js = ({
  name: 'usergroup-card',
  functional: true,
  props: {
    title: {
      type: String,
      default: ''
    },
    tags: {
      type: Array,
      deafult: () => {}
    },
    sponsorlogo: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    },
    poster_type: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    totalrooms: {
      type: [Number, String],
      default: ''
    },
    sponsorLink: {
      type: String,
      default: ''
    },
    showBoothRooms: {
      type: Boolean,
      default: true
    }
  }
});
;// CONCATENATED MODULE: ./src/components/BoothWidgets/BoothCard.vue?vue&type=script&lang=js
 /* harmony default export */ var BoothWidgets_BoothCardvue_type_script_lang_js = (BoothCardvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/BoothWidgets/BoothCard.vue?vue&type=style&index=0&id=9a65e158&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var BoothCardvue_type_style_index_0_id_9a65e158_prod_module_true_lang_scss = ({"root":"BoothCard_root_Glbzr","card":"BoothCard_card_FPt5m","img":"BoothCard_img_SN5Rz","poster":"BoothCard_poster_YjuBJ","logocontainer":"BoothCard_logocontainer_ouSeP","boothdetails":"BoothCard_boothdetails_fGUjd","boothdetails_top":"BoothCard_boothdetails_top_ftb6U","boothdetails_bottom":"BoothCard_boothdetails_bottom_Fzxm1","boothdetails_actionLink":"BoothCard_boothdetails_actionLink_k8oHc","description":"BoothCard_description_LE7bC","title":"BoothCard_title_wA4jy","backgroundscaling":"BoothCard_backgroundscaling_hoCUY"});
;// CONCATENATED MODULE: ./src/components/BoothWidgets/BoothCard.vue?vue&type=style&index=0&id=9a65e158&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/BoothWidgets/BoothCard.vue



;




function BoothCard_injectStyles (context) {
  
  this["$style"] = (BoothCardvue_type_style_index_0_id_9a65e158_prod_module_true_lang_scss.locals || BoothCardvue_type_style_index_0_id_9a65e158_prod_module_true_lang_scss)

}

/* normalize component */

var BoothCard_component = normalizeComponent(
  BoothWidgets_BoothCardvue_type_script_lang_js,
  BoothCardvue_type_template_id_9a65e158_functional_true_render,
  BoothCardvue_type_template_id_9a65e158_functional_true_staticRenderFns,
  true,
  BoothCard_injectStyles,
  null,
  null
  
)

/* harmony default export */ var BoothCard = (BoothCard_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/BoothWidgets/BoothDetails.vue?vue&type=template&id=76f64b4b
var BoothDetailsvue_type_template_id_76f64b4b_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('TextButton', {
    class: _vm.$style.backButton,
    attrs: {
      "id": "backButton",
      "color": "primary-text-color",
      "variant": "heading15"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goBack');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Back')) + " ")]), _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.heroassetcontainer
  }, [_c('div', {
    class: _vm.$style.herroassetpicandlogo
  }, [_vm.booth.heroasset_type === 'hero_asset_video' && !_vm.videoPlaying ? _c('div', {
    class: _vm.$style.playButton,
    on: {
      "click": () => _vm.$refs.player.play()
    }
  }, [_c('SvgIcon', {
    attrs: {
      "color": "color-secondary-light",
      "size": "x-large",
      "name": "play"
    }
  })], 1) : _vm._e(), _vm.booth.heroasset_type === 'hero_asset_video' ? _c('video', {
    ref: "player",
    class: _vm.$style.video,
    attrs: {
      "data-testmarker": "boothVideo",
      "src": _vm.booth.heroasset,
      "controls": "",
      "autoplay": "",
      "controlslist": "nodownload",
      "crossorigin": "anonymous"
    },
    on: {
      "contextmenu": function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      },
      "pause": function ($event) {
        return _vm.pauseVideo($event, _vm.booth);
      },
      "play": function ($event) {
        return _vm.playVideo($event, _vm.booth);
      },
      "timeupdate": function ($event) {
        return _vm.videoTimeUpdate($event, _vm.booth);
      },
      "ended": event => _vm.$emit('ended', {
        event: event,
        booth_id: _vm.booth.id
      })
    }
  }, [_vm.booth.english_captions_url ? _c('track', {
    attrs: {
      "label": "English",
      "kind": "subtitles",
      "srclang": "en",
      "src": _vm.booth.english_captions_url,
      "default": ""
    }
  }) : _vm._e()]) : _c('img', {
    attrs: {
      "src": _vm.booth.heroasset
    }
  }), _vm.booth.logo ? _c('div', {
    class: _vm.$style.logocontainer
  }, [_vm.booth.sponsorLink ? _c('a', {
    attrs: {
      "href": _vm.booth.sponsorLink,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.booth.logo
    }
  })]) : _c('img', {
    attrs: {
      "src": _vm.booth.logo
    }
  })]) : _vm._e()])]), _c('div', {
    class: _vm.$style.imageinfo
  }, [_c('div', {
    class: _vm.$style.descriptiontext
  }, [_c('StyledText', {
    style: {
      'font-weight': 'bold'
    },
    attrs: {
      "variant": "subHeading18",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.booth.title) + " ")]), _vm.booth.demo_request_enabled ? _c('PillButton', {
    attrs: {
      "disabled": _vm.isBoothCtaDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('ctaClicked');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.booth.demo_request_button_text || _vm.$options.$t('Request a Demo')) + " ")]) : _vm._e()], 1), _vm._l(_vm.descriptionLines, function (line, i) {
    return _c('StyledText', {
      key: 'line-' + i,
      style: {
        'text-align': 'justify'
      },
      attrs: {
        "variant": "body13",
        "color": "primary-text-color"
      }
    }, [_vm._v(" " + _vm._s(line) + " ")]);
  })], 2), _c('ul', {
    class: [_vm.$style.fullwidthcontainer, _vm.$style.tagscontainer]
  }, _vm._l(_vm.booth.tags, function (tag) {
    return _c('li', {
      key: tag
    }, [_c('Tag', {
      attrs: {
        "tag": tag,
        "rounded": true,
        "added": true,
        "showRemove": false,
        "tabindex": -1
      }
    })], 1);
  }), 0), (_vm.booth.resources || []).length > 0 ? _c('div', {
    class: [_vm.$style.fullwidthcontainer, _vm.$style.resourcescontainer]
  }, _vm._l(_vm.booth.resources, function (res) {
    return _c('div', {
      key: res.link,
      class: _vm.$style.resourcepill,
      on: {
        "click": function ($event) {
          return _vm.$emit('resourceopen', res);
        }
      }
    }, [_c('SvgIcon', {
      attrs: {
        "name": "double-right-arrow",
        "size": "small"
      }
    }), _c('StyledText', {
      style: {
        'margin-left': '7px'
      },
      attrs: {
        "color": "primary-text-color"
      }
    }, [_vm._v(" " + _vm._s(res.name) + " ")])], 1);
  }), 0) : _vm._e(), _c('div', {
    class: [_vm.$style.separator]
  }), _vm.showBoothRooms ? _c('ul', {
    class: [_vm.$style.pluswidthcontainer, _vm.$style.discgrid],
    attrs: {
      "aria-live": "polite"
    }
  }, _vm._l(_vm.booth.discussionGroups, function (group, i) {
    return _c('li', {
      key: i
    }, [_c('RoomCard', {
      attrs: {
        "id": group.id,
        "canOrganiserJoin": group.canOrganiserJoin,
        "moderators": group.moderators,
        "attendees": group.attendees,
        "hiddenattendees": group.hiddenattendees,
        "sponsorlogo": group.sponsor_image,
        "title": group.title,
        "tags": group.tags,
        "count": group.count,
        "openspots": group.openspots,
        "status": group.status
      },
      on: {
        "click": () => _vm.$emit('join', group),
        "openUser": user => _vm.$emit('open-user', user)
      }
    })], 1);
  }), 0) : _vm._e()])], 1);
};
var BoothDetailsvue_type_template_id_76f64b4b_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/BoothWidgets/BoothDetails.vue?vue&type=script&lang=js


// import CoreItem from "";
/* harmony default export */ var BoothDetailsvue_type_script_lang_js = ({
  name: 'booth-details',
  components: {
    Tag: Tag
    // CoreItem
  },

  data() {
    return {
      videoPlaying: false
    };
  },
  props: {
    /**
     * An object of type
     * title: string;
     * discussionGroups: Array<group>;
     * logo: string;
     * heroasset: string;
     * heroasset_type: "image"|"video";
     * description: string;
     * moderators: Array<{ name: string; id: string; image: string; }>;
     * resources: Array<{ name: string; link: string; }>;
     * cta: string;
     */
    booth: {
      type: Object,
      required: true
    },
    isBoothCtaDisabled: {
      type: Boolean,
      default: false
    },
    showBoothRooms: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.querySelector('#backButton')?.focus();
    });
  },
  computed: {
    descriptionLines() {
      return (this.booth.description || '').split('\n');
    }
  },
  methods: {
    toggleVideoPlaying() {
      this.videoPlaying = !this.videoPlaying;
    },
    pauseVideo(event, booth) {
      this.toggleVideoPlaying();
      this.$emit('pause', {
        event: event,
        booth_id: booth.id
      });
    },
    playVideo(event, booth) {
      this.toggleVideoPlaying();
      this.$emit('play', {
        event: event,
        booth_id: booth.id
      });
    },
    videoTimeUpdate(event, booth) {
      this.$emit('timeupdate', {
        event,
        booth_id: booth.id
      });
    }
  }
});
;// CONCATENATED MODULE: ./src/components/BoothWidgets/BoothDetails.vue?vue&type=script&lang=js
 /* harmony default export */ var BoothWidgets_BoothDetailsvue_type_script_lang_js = (BoothDetailsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/BoothWidgets/BoothDetails.vue?vue&type=style&index=0&id=76f64b4b&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var BoothDetailsvue_type_style_index_0_id_76f64b4b_prod_module_true_lang_scss = ({"root":"BoothDetails_root_Lymkg","backButton":"BoothDetails_backButton_bGDC1","container":"BoothDetails_container_OAiXI","descriptiontext":"BoothDetails_descriptiontext_BcXs3","pluswidthcontainer":"BoothDetails_pluswidthcontainer_lHTQ9","heading":"BoothDetails_heading_tYTLF","fullwidthcontainer":"BoothDetails_fullwidthcontainer_ZeEb1","separator":"BoothDetails_separator_jmAGv","resourcescontainer":"BoothDetails_resourcescontainer_aulf2","resourcepill":"BoothDetails_resourcepill_cZMdx","tagscontainer":"BoothDetails_tagscontainer_eOWUN","discgrid":"BoothDetails_discgrid_PgfWb","heroassetcontainer":"BoothDetails_heroassetcontainer_hP1_w","herroassetpicandlogo":"BoothDetails_herroassetpicandlogo_ZI0ep","playButton":"BoothDetails_playButton_i7Szc","video":"BoothDetails_video_s78v_","logocontainer":"BoothDetails_logocontainer_x2snQ","imageinfo":"BoothDetails_imageinfo_7xOPa"});
;// CONCATENATED MODULE: ./src/components/BoothWidgets/BoothDetails.vue?vue&type=style&index=0&id=76f64b4b&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/BoothWidgets/BoothDetails.vue



;




function BoothDetails_injectStyles (context) {
  
  this["$style"] = (BoothDetailsvue_type_style_index_0_id_76f64b4b_prod_module_true_lang_scss.locals || BoothDetailsvue_type_style_index_0_id_76f64b4b_prod_module_true_lang_scss)

}

/* normalize component */

var BoothDetails_component = normalizeComponent(
  BoothWidgets_BoothDetailsvue_type_script_lang_js,
  BoothDetailsvue_type_template_id_76f64b4b_render,
  BoothDetailsvue_type_template_id_76f64b4b_staticRenderFns,
  false,
  BoothDetails_injectStyles,
  null,
  null
  
)

/* harmony default export */ var BoothDetails = (BoothDetails_component.exports);
;// CONCATENATED MODULE: ./src/components/BoothWidgets/index.js



;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/aboutRegistration.vue?vue&type=template&id=4a777a24&functional=true
var aboutRegistrationvue_type_template_id_4a777a24_functional_true_render = function render(_c, _vm) {
  return _c('div', [_c('StyledText', {
    class: _vm.$style.pageDescription,
    attrs: {
      "color": "primary-text-color",
      "variant": "noBodyVariant"
    }
  }, [_c('span', {
    class: _vm.$style.descriptionText,
    domProps: {
      "innerHTML": _vm._s(_vm.props.description)
    }
  })])], 1);
};
var aboutRegistrationvue_type_template_id_4a777a24_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/aboutRegistration.vue?vue&type=script&lang=js
/* harmony default export */ var aboutRegistrationvue_type_script_lang_js = ({
  functional: true,
  props: {
    description: {
      type: String,
      required: true
    }
  }
});
;// CONCATENATED MODULE: ./src/components/AboutReg/aboutRegistration.vue?vue&type=script&lang=js
 /* harmony default export */ var AboutReg_aboutRegistrationvue_type_script_lang_js = (aboutRegistrationvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/AboutReg/aboutRegistration.vue?vue&type=style&index=0&id=4a777a24&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var aboutRegistrationvue_type_style_index_0_id_4a777a24_prod_lang_scss_module_true = ({"about_registration":"aboutRegistration_about_registration_lU8Z3","descriptionText":"aboutRegistration_descriptionText_dB6mr"});
;// CONCATENATED MODULE: ./src/components/AboutReg/aboutRegistration.vue?vue&type=style&index=0&id=4a777a24&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/AboutReg/aboutRegistration.vue



;




function aboutRegistration_injectStyles (context) {
  
  this["$style"] = (aboutRegistrationvue_type_style_index_0_id_4a777a24_prod_lang_scss_module_true.locals || aboutRegistrationvue_type_style_index_0_id_4a777a24_prod_lang_scss_module_true)

}

/* normalize component */

var aboutRegistration_component = normalizeComponent(
  AboutReg_aboutRegistrationvue_type_script_lang_js,
  aboutRegistrationvue_type_template_id_4a777a24_functional_true_render,
  aboutRegistrationvue_type_template_id_4a777a24_functional_true_staticRenderFns,
  true,
  aboutRegistration_injectStyles,
  null,
  null
  
)

/* harmony default export */ var aboutRegistration = (aboutRegistration_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/sideBarReg.vue?vue&type=template&id=67c182de
var sideBarRegvue_type_template_id_67c182de_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.open ? _c('div', {
    staticClass: "sidebarReg",
    class: _vm.$style.sidebar
  }, [!_vm.registerProcessed ? _c('div', {
    class: _vm.$style.contact
  }, [_c('div', {
    class: _vm.$style.flex
  }, [_c('span'), _c('SvgIcon', {
    class: _vm.$style.closeBtn,
    attrs: {
      "name": "cross",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        return _vm.handleCloseSideBar();
      }
    }
  })], 1), _vm._t("registrationForm"), !_vm.formioEnabled ? _c('div', [_c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "subHeading18"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Register')) + " ")]), _vm._l(_vm.formfields, function (field, i) {
    return _c('SimpleInput', {
      key: i,
      class: _vm.$style.simpleInputClass,
      attrs: {
        "type": field.type,
        "tabindexs": i + 100,
        "requireds": !field.optional,
        "value": _vm.formvalues[field.id],
        "error": field.error,
        "field": field,
        "wrapperCss": _vm.simpleInputWrapper,
        "autoFocus": i == 0
      },
      on: {
        "change": $event => _vm.$emit('fieldchange', {
          fieldId: field.id,
          value: $event
        }),
        "input": value => _vm.setvalue(field.id, value)
      }
    }, [_c('StyledText', {
      attrs: {
        "variant": "body13",
        "color": "primary-text-color"
      }
    }, [_c('ChatMessageRenderer', {
      attrs: {
        "text": _vm.getFieldTitle(field),
        "linkClass": _vm.$style.regFormInputLinks,
        "containerClass": _vm.$style.regFormInputName
      },
      on: {
        "linkclicked": $event => _vm.$emit('regforminputlinkclicked', $event)
      }
    })], 1)], 1);
  }), _c('PillButton', {
    class: _vm.$style.registerBtn,
    attrs: {
      "loading": _vm.sidebarloading,
      "disabled": _vm.sidebarloading
    },
    on: {
      "click": function ($event) {
        return _vm.submit_data();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Register')) + " ")])], 2) : _vm._e()], 2) : _vm._e(), _vm.registerProcessed ? _c('div', {
    class: _vm.$style.contact
  }, [_c('div', {
    class: _vm.$style.flex
  }, [_c('span'), _c('SvgIcon', {
    class: _vm.$style.closeBtn,
    attrs: {
      "name": "cross",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        return _vm.handleCloseSideBar();
      }
    }
  })], 1), _vm.userIsBlocked ? _c('div', {
    staticClass: "registrationMessageWrapper",
    class: _vm.$style.registrationMessageWrapper
  }, [_c('StyledText', {
    class: _vm.$style.errorMessageSideBar,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Error: User unable to be registered for this event. Please contact event organizer for assistance')) + ". ")])], 1) : _vm.userHasAlreadyRegistered ? _c('div', {
    staticClass: "registrationMessageWrapper",
    class: _vm.$style.registrationMessageWrapper
  }, [_c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "subHeading18"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('You are already registered!')) + " ")]), _c('StyledText', {
    class: _vm.$style.messageSecondLine,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Looks like you are already registered for this event! Please check your spam folder for your registration confirmation, if you haven’t received it. If you need further assistance, please contact the event organizer')) + ". ")])], 1) : _c('div', {
    staticClass: "registrationMessageWrapper",
    class: _vm.$style.registrationMessageWrapper
  }, [_c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "subHeading18"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Thank you for registering!')) + " ")]), _c('StyledText', {
    class: _vm.$style.messageSecondLine,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('You are now registered. You will receive an email confirming details shortly.')) + " ")])], 1), !_vm.userIsBlocked ? _c('PillButton', {
    staticClass: "registrationAnotherResponseButton",
    class: [_vm.$style.registerBtn, _vm.$style.registrationAnotherResponseButton],
    attrs: {
      "loading": false,
      "disabled": false
    },
    on: {
      "click": function ($event) {
        return _vm.submitAnotherResponse();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Submit another response')) + " ")]) : _vm._e()], 1) : _vm._e(), _vm.registrationErrorMessage ? _c('div', [_c('div', {
    class: _vm.$style.regErrorPopup
  }, [_c('StyledText', {
    class: _vm.$style.regErrorMessage,
    attrs: {
      "color": "primary-text-color",
      "variant": "body13",
      "align": "justify"
    }
  }, [_vm._v(" " + _vm._s(_vm.registrationErrorMessage) + " ")]), _c('IconButton', {
    class: _vm.$style.closeRegErrorPopupBtn,
    attrs: {
      "icon": "cross"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('closeregerrorpopup');
      }
    }
  })], 1), _c('div', {
    class: _vm.$style.regErrorPopupBackground
  })]) : _vm._e()]) : _vm._e();
};
var sideBarRegvue_type_template_id_67c182de_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/sideBarReg.vue?vue&type=script&lang=js
/* harmony default export */ var sideBarRegvue_type_script_lang_js = ({
  name: 'sideBarReg',
  data: () => {
    return {
      formvalues: {},
      simpleInputWrapper: {
        outline: 'none'
      }
    };
  },
  mounted() {
    this.$root.$on('sideBarRegistrationFormClear', () => {
      this.clearFields();
    });
  },
  methods: {
    handleCloseSideBar() {
      if (this.userIsBlocked) {
        this.$root.$emit('registrationSubmitAnotherRequest');
      }
      this.$emit('togglenav');
    },
    setvalue(id, value) {
      this.formvalues = {
        ...this.formvalues,
        [id]: value
      };
    },
    submit_data() {
      this.$emit('register', this.formvalues);
    },
    clearFields() {
      Object.keys(this.formvalues).forEach(key => {
        this.formvalues[key] = '';
      });
    },
    submitAnotherResponse() {
      this.$root.$emit('registrationSubmitAnotherRequest');
    },
    getFieldTitle(field) {
      return (field?.title || '') + (field && !field.optional ? '*' : '');
    }
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    formfields: {
      type: Array,
      default: () => []
    },
    sidebarloading: {
      type: Boolean,
      default: false
    },
    registerProcessed: {
      type: Boolean,
      default: false
    },
    userHasAlreadyRegistered: {
      type: Boolean,
      default: false
    },
    userIsBlocked: {
      type: Boolean,
      default: true
    },
    formioEnabled: {
      type: Boolean,
      default: false
    },
    registrationErrorMessage: {
      type: String,
      default: ''
    }
  }
});
;// CONCATENATED MODULE: ./src/components/AboutReg/sideBarReg.vue?vue&type=script&lang=js
 /* harmony default export */ var AboutReg_sideBarRegvue_type_script_lang_js = (sideBarRegvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/AboutReg/sideBarReg.vue?vue&type=style&index=0&id=67c182de&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var sideBarRegvue_type_style_index_0_id_67c182de_prod_lang_scss_module_true = ({"simpleInputFieldsWrapper":"sideBarReg_simpleInputFieldsWrapper_qovGx","registerButtonWrapper":"sideBarReg_registerButtonWrapper_OZlfK","sidebar":"sideBarReg_sidebar_V9tlZ","closeBtn":"sideBarReg_closeBtn_oejMx","flex":"sideBarReg_flex_C25It","contact":"sideBarReg_contact_AqZ6w","registerBtn":"sideBarReg_registerBtn_Chfsm","copyright":"sideBarReg_copyright_iS6RP","simpleInputClass":"sideBarReg_simpleInputClass_BVggM","registrationMessageWrapper":"sideBarReg_registrationMessageWrapper_fKBBP","registrationAnotherResponseButton":"sideBarReg_registrationAnotherResponseButton_NAj6l","messageSecondLine":"sideBarReg_messageSecondLine_bV5pI","regFormInputLinks":"sideBarReg_regFormInputLinks__gUrE","regFormInputName":"sideBarReg_regFormInputName_CtiHT","errorMessageSideBar":"sideBarReg_errorMessageSideBar_GH9GK","regErrorPopup":"sideBarReg_regErrorPopup_qvEKo","closeRegErrorPopupBtn":"sideBarReg_closeRegErrorPopupBtn_fin69","regErrorMessage":"sideBarReg_regErrorMessage_MLCrZ","regErrorPopupBackground":"sideBarReg_regErrorPopupBackground__GD85"});
;// CONCATENATED MODULE: ./src/components/AboutReg/sideBarReg.vue?vue&type=style&index=0&id=67c182de&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/AboutReg/sideBarReg.vue?vue&type=style&index=1&id=67c182de&prod&lang=scss&scope=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/AboutReg/sideBarReg.vue?vue&type=style&index=1&id=67c182de&prod&lang=scss&scope=true

;// CONCATENATED MODULE: ./src/components/AboutReg/sideBarReg.vue



;





function sideBarReg_injectStyles (context) {
  
  this["$style"] = (sideBarRegvue_type_style_index_0_id_67c182de_prod_lang_scss_module_true.locals || sideBarRegvue_type_style_index_0_id_67c182de_prod_lang_scss_module_true)

}

/* normalize component */

var sideBarReg_component = normalizeComponent(
  AboutReg_sideBarRegvue_type_script_lang_js,
  sideBarRegvue_type_template_id_67c182de_render,
  sideBarRegvue_type_template_id_67c182de_staticRenderFns,
  false,
  sideBarReg_injectStyles,
  null,
  null
  
)

/* harmony default export */ var sideBarReg = (sideBarReg_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/sideBarShare.vue?vue&type=template&id=2387e3e1
var sideBarSharevue_type_template_id_2387e3e1_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.openShare ? _c('div', {
    ref: "mySidebar",
    staticClass: "sideBarShare",
    class: _vm.$style.sidebar
  }, [_c('div', {
    class: _vm.$style.contact,
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    class: _vm.$style.flex
  }, [_c('span'), _c('SvgIcon', {
    class: _vm.$style.closeBtn,
    attrs: {
      "name": "cross",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('toggleshare');
      }
    }
  })], 1), _c('StyledText', {
    class: _vm.$style.sharenav,
    attrs: {
      "color": "primary-text-color",
      "variant": "subHeading18"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Share')) + " ")]), _c('StyledText', {
    class: _vm.$style.sharenav,
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Know someone who want to attend this?')) + " ")]), _c('div', {
    class: _vm.$style.flex
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentUrl,
      expression: "currentUrl"
    }],
    ref: "copyTextHolder",
    class: _vm.$style.link,
    attrs: {
      "id": "copyTextHolder",
      "readonly": ""
    },
    domProps: {
      "value": _vm.currentUrl
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.currentUrl = $event.target.value;
      }
    }
  }), _c('PillButton', {
    class: _vm.$style.copy,
    on: {
      "click": _vm.copyLink
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('COPY LINK')) + " ")])], 1)], 1)]) : _vm._e();
};
var sideBarSharevue_type_template_id_2387e3e1_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/sideBarShare.vue?vue&type=script&lang=js
/* harmony default export */ var sideBarSharevue_type_script_lang_js = ({
  name: 'sideBarShare',
  props: ['openShare'],
  data: () => {
    return {
      currentUrl: ''
    };
  },
  mounted() {
    this.currentUrl = window.location.href;
  },
  methods: {
    copyLink() {
      var copyTextHolder = this.$refs.copyTextHolder;
      if (copyTextHolder) {
        copyTextHolder.setAttribute('type', 'text');
        copyTextHolder.select();
        document.execCommand('copy');
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/AboutReg/sideBarShare.vue?vue&type=script&lang=js
 /* harmony default export */ var AboutReg_sideBarSharevue_type_script_lang_js = (sideBarSharevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/AboutReg/sideBarShare.vue?vue&type=style&index=0&id=2387e3e1&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var sideBarSharevue_type_style_index_0_id_2387e3e1_prod_lang_scss_module_true = ({"sidebar":"sideBarShare_sidebar_ZzvrX","closeBtn":"sideBarShare_closeBtn_ORb0v","flex":"sideBarShare_flex_hnwgo","contact":"sideBarShare_contact_P4drL","sharenav":"sideBarShare_sharenav_RiGe8","link":"sideBarShare_link_akoWC","copy":"sideBarShare_copy_aDWI7"});
;// CONCATENATED MODULE: ./src/components/AboutReg/sideBarShare.vue?vue&type=style&index=0&id=2387e3e1&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/AboutReg/sideBarShare.vue?vue&type=style&index=1&id=2387e3e1&prod&lang=scss&scope=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/AboutReg/sideBarShare.vue?vue&type=style&index=1&id=2387e3e1&prod&lang=scss&scope=true

;// CONCATENATED MODULE: ./src/components/AboutReg/sideBarShare.vue



;





function sideBarShare_injectStyles (context) {
  
  this["$style"] = (sideBarSharevue_type_style_index_0_id_2387e3e1_prod_lang_scss_module_true.locals || sideBarSharevue_type_style_index_0_id_2387e3e1_prod_lang_scss_module_true)

}

/* normalize component */

var sideBarShare_component = normalizeComponent(
  AboutReg_sideBarSharevue_type_script_lang_js,
  sideBarSharevue_type_template_id_2387e3e1_render,
  sideBarSharevue_type_template_id_2387e3e1_staticRenderFns,
  false,
  sideBarShare_injectStyles,
  null,
  null
  
)

/* harmony default export */ var sideBarShare = (sideBarShare_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/sideButtons.vue?vue&type=template&id=4fcaa5e0
var sideButtonsvue_type_template_id_4fcaa5e0_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('PillButton', {
    class: _vm.$style.sidebtn,
    attrs: {
      "loading": _vm.loading,
      "size": "large",
      "center": ""
    },
    on: {
      "click": () => _vm.$emit('togglenav')
    }
  }, [_vm._v(" " + _vm._s(_vm.onDemandMode ? _vm.$options.$t('Watch Now') : _vm.$options.$t('Register')) + " ")]), _vm.showShareButton ? _c('PillButton', {
    class: _vm.$style.sidebtn,
    attrs: {
      "loading": _vm.loading,
      "size": "large",
      "center": ""
    },
    on: {
      "click": () => _vm.$emit('toggleshare')
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Share')) + " ")]) : _vm._e(), _vm.showPoweredBy ? _c('div', {
    class: _vm.$style.poweredBy
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Powered by')) + " ")]), _c('a', {
    attrs: {
      "href": _vm.links.poweredByLink,
      "target": "_blank"
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "logo"
    }
  })], 1)], 1) : _vm._e()], 1);
};
var sideButtonsvue_type_template_id_4fcaa5e0_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/sideButtons.vue?vue&type=script&lang=js

/* harmony default export */ var sideButtonsvue_type_script_lang_js = ({
  methods: {},
  data() {
    return {
      links: links
    };
  },
  name: 'SideButtons',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    showShareButton: {
      type: Boolean,
      default: false
    },
    showPoweredBy: Boolean,
    onDemandMode: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/AboutReg/sideButtons.vue?vue&type=script&lang=js
 /* harmony default export */ var AboutReg_sideButtonsvue_type_script_lang_js = (sideButtonsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/AboutReg/sideButtons.vue?vue&type=style&index=0&id=4fcaa5e0&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var sideButtonsvue_type_style_index_0_id_4fcaa5e0_prod_lang_scss_module_true = ({"sidebtn":"sideButtons_sidebtn_YxNvu","poweredBy":"sideButtons_poweredBy_TFlaC"});
;// CONCATENATED MODULE: ./src/components/AboutReg/sideButtons.vue?vue&type=style&index=0&id=4fcaa5e0&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/AboutReg/sideButtons.vue



;




function sideButtons_injectStyles (context) {
  
  this["$style"] = (sideButtonsvue_type_style_index_0_id_4fcaa5e0_prod_lang_scss_module_true.locals || sideButtonsvue_type_style_index_0_id_4fcaa5e0_prod_lang_scss_module_true)

}

/* normalize component */

var sideButtons_component = normalizeComponent(
  AboutReg_sideButtonsvue_type_script_lang_js,
  sideButtonsvue_type_template_id_4fcaa5e0_render,
  sideButtonsvue_type_template_id_4fcaa5e0_staticRenderFns,
  false,
  sideButtons_injectStyles,
  null,
  null
  
)

/* harmony default export */ var sideButtons = (sideButtons_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/SpeakersSection.vue?vue&type=template&id=71a87cb6
var SpeakersSectionvue_type_template_id_71a87cb6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: _vm.$style.heading,
    attrs: {
      "variant": "heading26",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.speakerSectionTitle) + " ")]), _c('div', {
    class: _vm.$style.speakers
  }, _vm._l(_vm.users, function (user, i) {
    return _c('SpeakerCard', {
      key: i,
      attrs: {
        "keyValue": i,
        "user": user
      },
      on: {
        "viewProfileClick": userData => _vm.$emit('viewProfileClick', userData)
      }
    });
  }), 1)], 1);
};
var SpeakersSectionvue_type_template_id_71a87cb6_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/SpeakersSection.vue?vue&type=script&lang=js
/* harmony default export */ var SpeakersSectionvue_type_script_lang_js = ({
  name: 'SpeakersSection',
  props: {
    users: {
      type: Array,
      default: () => []
    },
    speakerSectionTitle: {
      type: String,
      default: () => ''
    }
  }
});
;// CONCATENATED MODULE: ./src/components/AboutReg/SpeakersSection.vue?vue&type=script&lang=js
 /* harmony default export */ var AboutReg_SpeakersSectionvue_type_script_lang_js = (SpeakersSectionvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/AboutReg/SpeakersSection.vue?vue&type=style&index=0&id=71a87cb6&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SpeakersSectionvue_type_style_index_0_id_71a87cb6_prod_lang_scss_module_true = ({"root":"SpeakersSection_root_qwZt2","heading":"SpeakersSection_heading_Z_wIi","speakers":"SpeakersSection_speakers_oVQCX"});
;// CONCATENATED MODULE: ./src/components/AboutReg/SpeakersSection.vue?vue&type=style&index=0&id=71a87cb6&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/AboutReg/SpeakersSection.vue



;




function SpeakersSection_injectStyles (context) {
  
  this["$style"] = (SpeakersSectionvue_type_style_index_0_id_71a87cb6_prod_lang_scss_module_true.locals || SpeakersSectionvue_type_style_index_0_id_71a87cb6_prod_lang_scss_module_true)

}

/* normalize component */

var SpeakersSection_component = normalizeComponent(
  AboutReg_SpeakersSectionvue_type_script_lang_js,
  SpeakersSectionvue_type_template_id_71a87cb6_render,
  SpeakersSectionvue_type_template_id_71a87cb6_staticRenderFns,
  false,
  SpeakersSection_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SpeakersSection = (SpeakersSection_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/PreRedirectionPopup.vue?vue&type=template&id=0e12cf95
var PreRedirectionPopupvue_type_template_id_0e12cf95_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: _vm.$style.heading,
    attrs: {
      "variant": "heading20"
    }
  }, [_vm._v(_vm._s(_vm.heading))]), _c('StyledText', {
    class: _vm.$style.message,
    attrs: {
      "variant": "body15"
    }
  }, [_vm._v(_vm._s(_vm.message))]), _vm.url ? _c('StyledText', {
    class: [_vm.$style.message, _vm.$style.clickerLinkHolder],
    attrs: {
      "variant": "body12"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('This page will automatically redirect you in {durationLeftToRedirect} seconds.', {
    durationLeftToRedirect: _vm.durationLeftToRedirect
  })) + " "), _c('a', {
    attrs: {
      "href": _vm.url,
      "target": _vm.target
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Click here{if_it_does_not}', {
    if_it_does_not: ''
  })))]), _vm._v(" " + _vm._s(_vm.$options.$t('{click_here}if it does not', {
    click_here: ''
  })) + ". ")]) : _vm._e()], 1);
};
var PreRedirectionPopupvue_type_template_id_0e12cf95_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/AboutReg/PreRedirectionPopup.vue?vue&type=script&lang=js
/* harmony default export */ var PreRedirectionPopupvue_type_script_lang_js = ({
  name: 'PreRedirectionPopup',
  props: {
    heading: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    // Time to redirection in seconds.
    durationToRedirect: {
      type: Number,
      default: 0
    },
    url: {
      type: String,
      default: ''
    },
    // is the usual target attribute. Can be "_blank", "_self" etc
    target: {
      type: String,
      default: '_self'
    }
  },
  data() {
    return {
      configRedirectDuration: this.durationToRedirect,
      durationLeftToRedirect: 0,
      countdownInterval: null
    };
  },
  watch: {
    configRedirectDuration: {
      handler: function (time) {
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
        }
        if (time <= 0) {
          this.durationLeftToRedirect = 0;
          return;
        }
        this.durationLeftToRedirect = time;
        this.countdownInterval = setInterval(() => {
          this.durationLeftToRedirect = this.durationLeftToRedirect - 1;
          if (this.durationLeftToRedirect <= 0) {
            clearInterval(this.countdownInterval);
            return;
          }
        }, 1000);
      },
      immediate: true
    }
  }
});
;// CONCATENATED MODULE: ./src/components/AboutReg/PreRedirectionPopup.vue?vue&type=script&lang=js
 /* harmony default export */ var AboutReg_PreRedirectionPopupvue_type_script_lang_js = (PreRedirectionPopupvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/AboutReg/PreRedirectionPopup.vue?vue&type=style&index=0&id=0e12cf95&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var PreRedirectionPopupvue_type_style_index_0_id_0e12cf95_prod_module_true_lang_scss = ({"root":"PreRedirectionPopup_root_VeVct","heading":"PreRedirectionPopup_heading_zq7Cm","message":"PreRedirectionPopup_message_Hhq5C","clickerLinkHolder":"PreRedirectionPopup_clickerLinkHolder_TNTKf"});
;// CONCATENATED MODULE: ./src/components/AboutReg/PreRedirectionPopup.vue?vue&type=style&index=0&id=0e12cf95&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/AboutReg/PreRedirectionPopup.vue



;




function PreRedirectionPopup_injectStyles (context) {
  
  this["$style"] = (PreRedirectionPopupvue_type_style_index_0_id_0e12cf95_prod_module_true_lang_scss.locals || PreRedirectionPopupvue_type_style_index_0_id_0e12cf95_prod_module_true_lang_scss)

}

/* normalize component */

var PreRedirectionPopup_component = normalizeComponent(
  AboutReg_PreRedirectionPopupvue_type_script_lang_js,
  PreRedirectionPopupvue_type_template_id_0e12cf95_render,
  PreRedirectionPopupvue_type_template_id_0e12cf95_staticRenderFns,
  false,
  PreRedirectionPopup_injectStyles,
  null,
  null
  
)

/* harmony default export */ var PreRedirectionPopup = (PreRedirectionPopup_component.exports);
;// CONCATENATED MODULE: ./src/components/AboutReg/index.js






;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarContainer.vue?vue&type=template&id=6cc48f62&functional=true
var SidebarContainervue_type_template_id_6cc48f62_functional_true_render = function render(_c, _vm) {
  return _c('aside', {
    class: [_vm.$style.root, _vm.props.scaleChat && _vm.$style.scaleChat],
    attrs: {
      "id": "stageSidebar",
      "tabindex": "-1",
      "aria-label": _vm.$options.$t('Tabs: Messaging and More')
    }
  }, [!_vm.props.hidePrimaryTabs ? _c('div', {
    class: _vm.$style.primaryTabsHolder
  }, [_vm._t("primaryTabs")], 2) : _vm._e(), _c('div', {
    class: _vm.$style.mainContentArea
  }, [_vm._t("mainContent")], 2)]);
};
var SidebarContainervue_type_template_id_6cc48f62_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarContainer.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarContainervue_type_script_lang_js = ({
  props: {
    hidePrimaryTabs: Boolean,
    scaleChat: Boolean
  }
});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarContainer.vue?vue&type=script&lang=js
 /* harmony default export */ var Sidebar_SidebarContainervue_type_script_lang_js = (SidebarContainervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Sidebar/SidebarContainer.vue?vue&type=style&index=0&id=6cc48f62&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarContainervue_type_style_index_0_id_6cc48f62_prod_module_true_lang_scss = ({"root":"SidebarContainer_root_cIcfk","scaleChat":"SidebarContainer_scaleChat_AqdZW","primaryTabsHolder":"SidebarContainer_primaryTabsHolder_Benz8","mainContentArea":"SidebarContainer_mainContentArea_tem6R"});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarContainer.vue?vue&type=style&index=0&id=6cc48f62&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarContainer.vue



;




function SidebarContainer_injectStyles (context) {
  
  this["$style"] = (SidebarContainervue_type_style_index_0_id_6cc48f62_prod_module_true_lang_scss.locals || SidebarContainervue_type_style_index_0_id_6cc48f62_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarContainer_component = normalizeComponent(
  Sidebar_SidebarContainervue_type_script_lang_js,
  SidebarContainervue_type_template_id_6cc48f62_functional_true_render,
  SidebarContainervue_type_template_id_6cc48f62_functional_true_staticRenderFns,
  true,
  SidebarContainer_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarContainer = (SidebarContainer_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarPrimaryTabs.vue?vue&type=template&id=79d6d63e
var SidebarPrimaryTabsvue_type_template_id_79d6d63e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.showLeft ? _c('div', {
    class: _vm.$style.left
  }, [_c('div', {
    class: _vm.$style.licon
  }, [_c('SvgIcon', {
    attrs: {
      "name": "down-arrow",
      "color": "primary-text-color",
      "size": "x-small"
    },
    on: {
      "click": _vm.moveLeft
    }
  })], 1)]) : _vm._e(), _c('div', {
    ref: "content",
    class: _vm.$style.container,
    attrs: {
      "id": "sidebarPrimaryTabContainer",
      "role": "tablist"
    },
    on: {
      "scroll": _vm.handleScroll,
      "keydown": e => this.handleKeydown(e)
    }
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('SidebarPrimaryTabBtn', {
      key: tab.id,
      attrs: {
        "id": tab.id,
        "label": tab.name,
        "icon": tab.icon,
        "selected": _vm.selected === tab.id,
        "showIndicator": tab.showIndicator,
        "indicatorDetails": tab.indicatorDetails,
        "notificationCount": tab.notificationCount
      },
      on: {
        "click": () => _vm.$emit('toggletab', tab.id)
      }
    });
  }), 1), _vm.showRight ? _c('div', {
    class: _vm.$style.right
  }, [_c('div', {
    class: _vm.$style.ricon
  }, [_c('SvgIcon', {
    attrs: {
      "name": "down-arrow",
      "color": "primary-text-color",
      "size": "x-small"
    },
    on: {
      "click": _vm.moveRight
    }
  })], 1)]) : _vm._e()]);
};
var SidebarPrimaryTabsvue_type_template_id_79d6d63e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarPrimaryTabs.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarPrimaryTabsvue_type_script_lang_js = ({
  data() {
    return {
      showLeft: false,
      showRight: false,
      tabElements: null,
      focusedTabIndex: 0
    };
  },
  props: {
    /**
     * @prop is a list of tab objects for the primaryTabs in the following format:
     * {
     *    name: string, Name of the tab
     *    icon: string, Optional icon for the tab
     *    id: string, Identifier for the tab
     *    showIndicator: boolean
     *    indicatorDetails: Array<{ user, count }>;
     * }
     */
    tabs: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * @prop can be "" or the id of the selected primary tab
     */
    selected: {
      type: String,
      default: ''
    }
  },
  mounted() {
    // Listen for scroll events for this DOM
    // if (this.$refs.content) {
    //   this.$refs.content.addEventListener("scroll", this.handleScroll);
    // }
    this.updateShowRight();
    this.tabElements = document.getElementById('sidebarPrimaryTabContainer')?.querySelectorAll('[role=tab]');
  },
  watch: {
    tabs(oldvalue, newvalue) {
      if (oldvalue.length === newvalue.length) {
        // Check if name has changed for any item
        for (let i = 0; i < newvalue.length; i++) {
          if (newvalue[i]?.name !== oldvalue[i]?.name) {
            this.updateShowRight();
            break;
          }
        }
      } else {
        this.updateShowRight();
      }
    }
  },
  methods: {
    updateShowRight() {
      this.$nextTick(() => {
        this.tabElements = document.getElementById('sidebarPrimaryTabContainer')?.querySelectorAll('[role=tab]');
        if (this.$refs.content) {
          const scrolledToFarRight = this.isScrolledToFarRight();
          let enoughTabsForScroll = this.$refs.content?.scrollWidth - this.$refs.content?.clientWidth > 10;
          this.showRight = !scrolledToFarRight && enoughTabsForScroll;
        }
      });
    },
    isScrolledToFarRight() {
      const scrollPos = Math.round(this.$refs.content?.scrollLeft);
      const scrolledToFarRight = this.$refs.content?.clientWidth + scrollPos === this.$refs.content?.scrollWidth;
      return scrolledToFarRight;
    },
    handleScroll() {
      if (this.$refs.content) {
        let scrollPos = Math.round(this.$refs.content.scrollLeft);
        let scrolledToFarLeft = scrollPos == 0;
        if (scrolledToFarLeft) {
          this.showLeft = false;
        } else {
          this.showLeft = true;
        }
        const scrolledToFarRight = this.isScrolledToFarRight();
        if (scrolledToFarRight) {
          this.showRight = false;
        } else {
          this.showRight = true;
        }
      }
    },
    scrollTo(element, scrollPixels, duration) {
      const scrollPos = element.scrollLeft;
      // Condition to check if scrolling is required
      let isTabScrollable = (scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0);
      if (!isTabScrollable) {
        const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
        window.requestAnimationFrame(function scroll(timestamp) {
          const timeElapsed = timestamp - startTime;
          const progress = Math.min(timeElapsed / duration, 1);
          element.scrollLeft = scrollPos + scrollPixels * progress;
          if (timeElapsed < duration) {
            window.requestAnimationFrame(scroll);
          } else {
            return;
          }
        });
      }
    },
    moveRight() {
      const content = this.$refs.content;
      this.scrollTo(content, 300, 800);
    },
    moveLeft() {
      const content = this.$refs.content;
      this.scrollTo(content, -300, 800);
    },
    handleKeydown(event) {
      let flag = false;
      const targetIndex = this.focusedTabIndex;
      switch (event.key) {
        case 'ArrowLeft':
          this.moveFocusToPreviousTab(targetIndex);
          flag = true;
          break;
        case 'ArrowRight':
          this.moveFocusToNextTab(targetIndex);
          flag = true;
          break;
        case 'Home':
          this.moveFocusToTab(0);
          flag = true;
          break;
        case 'End':
          this.moveFocusToTab(this.tabs.length - 1);
          flag = true;
          break;
        default:
          break;
      }
      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    moveFocusToTab(targetIndex) {
      if (targetIndex >= 0 && targetIndex < this.tabs.length) {
        this.tabElements?.[targetIndex]?.focus();
        this.focusedTabIndex = targetIndex;
      }
    },
    moveFocusToPreviousTab(targetIndex) {
      const previousIndex = targetIndex === 0 ? this.tabs.length - 1 : targetIndex - 1;
      this.moveFocusToTab(previousIndex);
    },
    moveFocusToNextTab(targetIndex) {
      const nextIndex = targetIndex === this.tabs.length - 1 ? 0 : targetIndex + 1;
      this.moveFocusToTab(nextIndex);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarPrimaryTabs.vue?vue&type=script&lang=js
 /* harmony default export */ var Sidebar_SidebarPrimaryTabsvue_type_script_lang_js = (SidebarPrimaryTabsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Sidebar/SidebarPrimaryTabs.vue?vue&type=style&index=0&id=79d6d63e&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarPrimaryTabsvue_type_style_index_0_id_79d6d63e_prod_lang_scss_module_true = ({"root":"SidebarPrimaryTabs_root_xP1kA","left":"SidebarPrimaryTabs_left_KwDyX","licon":"SidebarPrimaryTabs_licon_LeG_N","container":"SidebarPrimaryTabs_container_EYL3j","right":"SidebarPrimaryTabs_right_JA4dF","ricon":"SidebarPrimaryTabs_ricon_WYf6H"});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarPrimaryTabs.vue?vue&type=style&index=0&id=79d6d63e&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarPrimaryTabs.vue



;




function SidebarPrimaryTabs_injectStyles (context) {
  
  this["$style"] = (SidebarPrimaryTabsvue_type_style_index_0_id_79d6d63e_prod_lang_scss_module_true.locals || SidebarPrimaryTabsvue_type_style_index_0_id_79d6d63e_prod_lang_scss_module_true)

}

/* normalize component */

var SidebarPrimaryTabs_component = normalizeComponent(
  Sidebar_SidebarPrimaryTabsvue_type_script_lang_js,
  SidebarPrimaryTabsvue_type_template_id_79d6d63e_render,
  SidebarPrimaryTabsvue_type_template_id_79d6d63e_staticRenderFns,
  false,
  SidebarPrimaryTabs_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarPrimaryTabs = (SidebarPrimaryTabs_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarPrimaryTabBtn.vue?vue&type=template&id=c5941de0
var SidebarPrimaryTabBtnvue_type_template_id_c5941de0_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    class: _vm.$style.root,
    attrs: {
      "id": 'tab' + this.id,
      "type": "button",
      "aria-selected": this.selected ? 'true' : 'false',
      "role": "tab",
      "tabindex": _vm.selected ? 0 : -1,
      "data-branding-target": "primary-chattab-button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click', _vm.id);
      }
    }
  }, [this.id === 'messages' && _vm.indicatorMaximized && _vm.showIndicator && _vm.indicatorDetails ? _c('div', {
    class: {
      [_vm.$style.detailedindicator]: true,
      [_vm.$style.left60]: this.id === 'messages'
    },
    attrs: {
      "data-branding-target": "chattab-notification"
    }
  }, [_c('UserImage', {
    attrs: {
      "size": "small",
      "user": _vm.indicatorDetails[_vm.shownUserIndex] && _vm.indicatorDetails[_vm.shownUserIndex].user,
      "imageScale": "full"
    }
  }), _c('div', {
    class: _vm.$style.text
  }, [_c('StyledText', {
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.indicatorText > 9 ? '9+' : _vm.indicatorText) + " ")])], 1)], 1) : _vm._e(), _vm.showOldUnreadIndicator ? _c('div', {
    class: _vm.$style.oldindicator
  }) : _vm._e(), (this.id !== 'messages' || this.id === 'messages' && !_vm.indicatorMaximized) && _vm.showIndicator && _vm.indicatorDetails ? _c('div', {
    class: {
      [_vm.$style.detailedindicator]: true,
      [_vm.$style.left60]: this.id === 'messages',
      [_vm.$style.left20]: this.id !== 'messages'
    }
  }, [_c('div', {
    class: [_vm.$style.text, _vm.$style.min]
  }, [_c('StyledText', {
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.indicatorText > 9 ? '9+' : _vm.indicatorText) + " ")])], 1)]) : _vm._e(), _vm.icon ? _c('SvgIcon', {
    class: _vm.$style.btnIcon,
    attrs: {
      "name": _vm.icon,
      "color": _vm.selected ? 'theme-secondary-color' : 'primary-text-color',
      "size": "small"
    }
  }) : _vm._e(), _c('div', {
    class: [_vm.$style.btnContent, {
      [_vm.$style.selectedBtn]: _vm.selected,
      [_vm.$style.hideText]: this.id === 'messages' && _vm.indicatorMaximized && _vm.showIndicator && _vm.indicatorDetails
    }]
  }, [_c('StyledText', {
    class: _vm.$style.tabBtnLabel,
    attrs: {
      "variant": "body13",
      "color": _vm.labelTextColor
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")])], 1), _vm.selected ? _c('div', {
    class: _vm.$style.selectedHighlight
  }) : _vm._e()], 1);
};
var SidebarPrimaryTabBtnvue_type_template_id_c5941de0_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarPrimaryTabBtn.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarPrimaryTabBtnvue_type_script_lang_js = ({
  props: {
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    selected: {
      type: Boolean,
      default: false
    },
    showIndicator: {
      type: Boolean,
      default: false
    },
    /**
     * Array<{ user, count }>
     */
    indicatorDetails: {
      type: Array
    },
    notificationCount: {
      type: Number,
      default: 0
    },
    /**
     * can be loading or loaded
     */
    loadingstate: {
      type: String,
      default: 'loaded'
    }
  },
  data() {
    return {
      indicatorMaximized: true,
      shownUserIndex: 0
    };
  },
  mounted() {
    this.startIndicatorLoop();
  },
  methods: {
    startIndicatorLoop() {
      setTimeout(() => {
        this.minimizeIndicator();
      }, 3000);
    },
    minimizeIndicator() {
      this.indicatorMaximized = false;
      setTimeout(() => {
        this.maximizeIndicator();
      }, 3 * 1000);
    },
    maximizeIndicator() {
      this.indicatorMaximized = true;
      let current = this.shownUserIndex;
      if (current + 1 < this.indicatorDetails?.length) {
        this.shownUserIndex = current + 1;
      } else {
        this.shownUserIndex = 0;
      }
      setTimeout(() => {
        this.minimizeIndicator();
      }, 3000);
    }
  },
  computed: {
    showOldUnreadIndicator() {
      return this.id != 'messages' && this.id != 'stage_chat' && this.showIndicator;
    },
    indicatorText() {
      if (this.indicatorDetails) {
        return this.indicatorDetails.reduce((count, item) => count + item.count, 0);
      }
      return 0;
    },
    labelTextColor() {
      if (this.selected) {
        return 'theme-secondary-color';
      }
      return 'primary-text-color';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarPrimaryTabBtn.vue?vue&type=script&lang=js
 /* harmony default export */ var Sidebar_SidebarPrimaryTabBtnvue_type_script_lang_js = (SidebarPrimaryTabBtnvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Sidebar/SidebarPrimaryTabBtn.vue?vue&type=style&index=0&id=c5941de0&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarPrimaryTabBtnvue_type_style_index_0_id_c5941de0_prod_module_true_lang_scss = ({"root":"SidebarPrimaryTabBtn_root_Z06sx","btnContent":"SidebarPrimaryTabBtn_btnContent_q0zVg","oldindicator":"SidebarPrimaryTabBtn_oldindicator_aUkq0","detailedindicator":"SidebarPrimaryTabBtn_detailedindicator_tjRON","text":"SidebarPrimaryTabBtn_text_llkmf","min":"SidebarPrimaryTabBtn_min_nfaD5","left60":"SidebarPrimaryTabBtn_left60_j3bpc","left20":"SidebarPrimaryTabBtn_left20_jev9V","notificationCount":"SidebarPrimaryTabBtn_notificationCount_gZkDx","btnIcon":"SidebarPrimaryTabBtn_btnIcon_zDjwM","tabBtnLabel":"SidebarPrimaryTabBtn_tabBtnLabel_HXh6v","selectedBtn":"SidebarPrimaryTabBtn_selectedBtn_YJVBy","hideText":"SidebarPrimaryTabBtn_hideText_fZ1aZ","selectedHighlight":"SidebarPrimaryTabBtn_selectedHighlight_JszQE"});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarPrimaryTabBtn.vue?vue&type=style&index=0&id=c5941de0&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarPrimaryTabBtn.vue



;




function SidebarPrimaryTabBtn_injectStyles (context) {
  
  this["$style"] = (SidebarPrimaryTabBtnvue_type_style_index_0_id_c5941de0_prod_module_true_lang_scss.locals || SidebarPrimaryTabBtnvue_type_style_index_0_id_c5941de0_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarPrimaryTabBtn_component = normalizeComponent(
  Sidebar_SidebarPrimaryTabBtnvue_type_script_lang_js,
  SidebarPrimaryTabBtnvue_type_template_id_c5941de0_render,
  SidebarPrimaryTabBtnvue_type_template_id_c5941de0_staticRenderFns,
  false,
  SidebarPrimaryTabBtn_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarPrimaryTabBtn = (SidebarPrimaryTabBtn_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarWidgetContainer.vue?vue&type=template&id=e097a684&functional=true
var SidebarWidgetContainervue_type_template_id_e097a684_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_vm._t("default")], 2);
};
var SidebarWidgetContainervue_type_template_id_e097a684_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarWidgetContainer.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarWidgetContainervue_type_script_lang_js = ({
  functional: true,
  props: {
    widgetLabel: {
      type: String,
      default: 'chat'
    },
    slottedLabel: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarWidgetContainer.vue?vue&type=script&lang=js
 /* harmony default export */ var Sidebar_SidebarWidgetContainervue_type_script_lang_js = (SidebarWidgetContainervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Sidebar/SidebarWidgetContainer.vue?vue&type=style&index=0&id=e097a684&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarWidgetContainervue_type_style_index_0_id_e097a684_prod_module_true_lang_scss = ({"root":"SidebarWidgetContainer_root_CGbm_"});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarWidgetContainer.vue?vue&type=style&index=0&id=e097a684&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarWidgetContainer.vue



;




function SidebarWidgetContainer_injectStyles (context) {
  
  this["$style"] = (SidebarWidgetContainervue_type_style_index_0_id_e097a684_prod_module_true_lang_scss.locals || SidebarWidgetContainervue_type_style_index_0_id_e097a684_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarWidgetContainer_component = normalizeComponent(
  Sidebar_SidebarWidgetContainervue_type_script_lang_js,
  SidebarWidgetContainervue_type_template_id_e097a684_functional_true_render,
  SidebarWidgetContainervue_type_template_id_e097a684_functional_true_staticRenderFns,
  true,
  SidebarWidgetContainer_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarWidgetContainer = (SidebarWidgetContainer_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarTextInputWrapper.vue?vue&type=template&id=f7bb3d8a
var SidebarTextInputWrappervue_type_template_id_f7bb3d8a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.disabled]: _vm.disabled
    }
  }, [_vm.wait ? _c('Loading', {
    attrs: {
      "size": "verySmall",
      "theme": "secondary"
    }
  }) : _vm._e(), !_vm.disabled ? [_c('div', {
    ref: "textbox",
    class: {
      [_vm.$style.inputHolder]: true,
      [_vm.$style.hasIcon]: _vm.icon,
      [_vm.$style.hasGifsEnabled]: _vm.hasGifsEnabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('inputclick', $event);
      }
    }
  }, [_vm.icon ? _c('SvgIcon', {
    class: _vm.$style.lockIcon,
    attrs: {
      "color": "primary-text-color",
      "name": _vm.icon
    }
  }) : _vm._e(), _vm._t("default"), _vm.hasGifsEnabled ? _c('IconButton', {
    attrs: {
      "aria-label": _vm.$t('Open GIF Picker'),
      "ariaHasPopup": "dialog",
      "icon": "gif",
      "variant": "primary",
      "ghost": "alt"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openGifPickerDialog');
      }
    }
  }) : _vm._e(), _c('div', {
    ref: "emojiPickerButton",
    class: _vm.$style.nonmobile
  }, [_c('IconButton', {
    ref: "emojiPickerButton",
    attrs: {
      "aria-label": _vm.$t('Open Emoji Picker'),
      "icon": "emoticon",
      "ariaHasPopup": "dialog",
      "variant": "primary",
      "ghost": "alt"
    },
    on: {
      "click": _vm.toggleEmojiPicker
    }
  })], 1)], 2), _c('div', {
    class: _vm.$style.sendButtonHolder,
    attrs: {
      "data-branding-target": "chat-send-button"
    }
  }, [_c('IconButton', {
    attrs: {
      "aria-label": _vm.$t('Send Message'),
      "disabled": _vm.disabled,
      "data-textmarker": _vm.testMarkerNameForSendButton,
      "dataTestId": _vm.testMarkerNameForSendButton,
      "size": "small",
      "icon": "sendplane2"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('send');
      }
    }
  })], 1)] : _c('StyledText', {
    class: _vm.$style.placeholder,
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.disabledPlaceholder) + " ")])], 2);
};
var SidebarTextInputWrappervue_type_template_id_f7bb3d8a_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/picmo@5.7.0/node_modules/picmo/dist/index.js
var O = (s, e, t) => {
  if (!e.has(s))
    throw TypeError("Cannot " + t);
};
var y = (s, e, t) => (O(s, e, "read from private field"), t ? t.call(s) : e.get(s)), f = (s, e, t) => {
  if (e.has(s))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(s) : e.set(s, t);
}, A = (s, e, t, o) => (O(s, e, "write to private field"), o ? o.call(s, t) : e.set(s, t), t);
var p = (s, e, t) => (O(s, e, "access private method"), t);
const $e = "14.0";
function Le(s, e, t) {
  let o = `https://cdn.jsdelivr.net/npm/emojibase-data@${e}/${s}`;
  return typeof t == "function" ? o = t(s, e) : typeof t == "string" && (o = `${t}/${s}`), o;
}
async function oe(s, e = {}) {
  const {
    local: t = !1,
    version: o = "latest",
    cdnUrl: i,
    ...r
  } = e, a = Le(s, o, i), n = t ? localStorage : sessionStorage, l = `emojibase/${o}/${s}`, m = n.getItem(l);
  if (m)
    return Promise.resolve(JSON.parse(m));
  const d = await fetch(a, {
    credentials: "omit",
    mode: "cors",
    redirect: "error",
    ...r
  });
  if (!d.ok)
    throw new Error("Failed to load Emojibase dataset.");
  const h = await d.json();
  try {
    n.setItem(l, JSON.stringify(h));
  } catch {
  }
  return h;
}
const Fe = {
  discord: "joypixels",
  slack: "iamcal"
};
async function le(s, e, t) {
  var o;
  return oe(`${s}/shortcodes/${(o = Fe[e]) !== null && o !== void 0 ? o : e}.json`, t);
}
function k(s, e) {
  if (e.length === 0)
    return s;
  const t = new Set(s.shortcodes);
  return e.forEach((o) => {
    const i = o[s.hexcode];
    Array.isArray(i) ? i.forEach((r) => t.add(r)) : i && t.add(i);
  }), s.shortcodes = [...t], s.skins && s.skins.forEach((o) => {
    k(o, e);
  }), s;
}
function Ae(s, e = []) {
  const t = [];
  return s.forEach((o) => {
    if (o.skins) {
      const {
        skins: i,
        ...r
      } = o;
      t.push(k(r, e)), i.forEach((a) => {
        const n = {
          ...a
        };
        r.tags && (n.tags = [...r.tags]), t.push(k(n, e));
      });
    } else
      t.push(k(o, e));
  }), t;
}
function Ie(s, e) {
  return e.length === 0 || s.forEach((t) => {
    k(t, e);
  }), s;
}
async function ve(s, e = {}) {
  const {
    compact: t = !1,
    flat: o = !1,
    shortcodes: i = [],
    ...r
  } = e, a = await oe(`${s}/${t ? "compact" : "data"}.json`, r);
  let n = [];
  return i.length > 0 && (n = await Promise.all(i.map((l) => {
    let m;
    if (l.includes("/")) {
      const [d, h] = l.split("/");
      m = le(d, h, r);
    } else
      m = le(s, l, r);
    return m.catch(() => ({}));
  }))), o ? Ae(a, n) : Ie(a, n);
}
async function we(s, e) {
  return oe(`${s}/messages.json`, e);
}
function U(s, e) {
  const o = s.target.closest("[data-emoji]");
  if (o) {
    const i = e.find((r) => r.emoji === o.dataset.emoji);
    if (i)
      return i;
  }
  return null;
}
function be(s) {
  var t;
  const e = (t = window.matchMedia) == null ? void 0 : t.call(window, "(prefers-reduced-motion: reduce)");
  return s.animate && !(e != null && e.matches);
}
function he(s, e) {
  return s.toLowerCase().includes(e.toLowerCase());
}
function Te(s, e) {
  let t = null;
  return () => {
    t || (t = window.setTimeout(() => {
      s(), t = null;
    }, e));
  };
}
function Re(s, e) {
  let t = null;
  return (...o) => {
    t && window.clearTimeout(t), t = window.setTimeout(() => {
      s(...o), t = null;
    }, e);
  };
}
function I(s, e, t, o) {
  if (be(o) && s.animate)
    return s.animate(e, t).finished;
  const i = t.direction === "normal" ? 1 : 0, r = Object.entries(e).reduce((a, [n, l]) => ({
    ...a,
    [n]: l[i]
  }), {});
  return Object.assign(s.style, r), Promise.resolve();
}
function J(s) {
  var t;
  const e = document.createElement("template");
  return e.innerHTML = s, (t = e.content) == null ? void 0 : t.firstElementChild;
}
async function Ve(s) {
  const e = new TextEncoder().encode(s), t = await crypto.subtle.digest("SHA-256", e);
  return Array.from(new Uint8Array(t)).map((i) => i.toString(16).padStart(2, "0")).join("");
}
function g(...s) {
  return s.reduce((e, t) => ({
    ...e,
    [t]: ie(t)
  }), {});
}
function ie(s) {
  return `${s}`;
}
function Be(s, e) {
  const t = `https://cdn.jsdelivr.net/npm/emojibase-data@${s}/${e}`;
  return {
    emojisUrl: `${t}/data.json`,
    messagesUrl: `${t}/messages.json`
  };
}
async function de(s) {
  try {
    return (await fetch(s, { method: "HEAD" })).headers.get("etag");
  } catch {
    return null;
  }
}
function Me(s) {
  const { emojisUrl: e, messagesUrl: t } = Be("latest", s);
  try {
    return Promise.all([
      de(e),
      de(t)
    ]);
  } catch {
    return Promise.all([null, null]);
  }
}
async function De(s, e, t) {
  let o;
  try {
    o = await s.getEtags();
  } catch {
    o = {};
  }
  const { storedEmojisEtag: i, storedMessagesEtag: r } = o;
  if (t !== r || e !== i) {
    const [a, n] = await Promise.all([we(s.locale), ve(s.locale)]);
    await s.populate({
      groups: a.groups,
      emojis: n,
      emojisEtag: e,
      messagesEtag: t
    });
  }
}
async function He(s, e) {
  const t = await s.getHash();
  return e !== t;
}
async function Ce(s, e, t) {
  const o = t || e(s);
  return await o.open(), o;
}
async function Ne(s, e, t) {
  const o = await Ce(s, e, t), [i, r] = await Me(s);
  if (await o.isPopulated())
    i && r && await De(o, i, r);
  else {
    const [a, n] = await Promise.all([we(s), ve(s)]);
    await o.populate({ groups: a.groups, emojis: n, emojisEtag: i, messagesEtag: r });
  }
  return o;
}
async function Oe(s, e, t, o, i) {
  const r = await Ce(s, e, i), a = await Ve(o);
  return (!await r.isPopulated() || await He(r, a)) && await r.populate({ groups: t.groups, emojis: o, hash: a }), r;
}
async function re(s, e, t, o, i) {
  return t && o ? Oe(s, e, t, o, i) : Ne(s, e, i);
}
function Ps(s, e) {
  s.deleteDatabase(e);
}
class Ue {
  constructor() {
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  activate(e) {
    this.rootElement = e, this.rootElement.addEventListener("keydown", this.handleKeyDown);
  }
  deactivate() {
    var e;
    (e = this.rootElement) == null || e.removeEventListener("keydown", this.handleKeyDown);
  }
  get focusableElements() {
    return this.rootElement.querySelectorAll('input, [tabindex="0"]');
  }
  get lastFocusableElement() {
    return this.focusableElements[this.focusableElements.length - 1];
  }
  get firstFocusableElement() {
    return this.focusableElements[0];
  }
  checkFocus(e, t, o) {
    e.target === t && (o.focus(), e.preventDefault());
  }
  handleKeyDown(e) {
    e.key === "Tab" && this.checkFocus(
      e,
      e.shiftKey ? this.firstFocusableElement : this.lastFocusableElement,
      e.shiftKey ? this.lastFocusableElement : this.firstFocusableElement
    );
  }
}
const {
  light: Ke,
  dark: zs,
  auto: $s
} = g("light", "dark", "auto");
class c {
  constructor({ template: e, classes: t, parent: o }) {
    this.isDestroyed = !1, this.appEvents = {}, this.uiEvents = [], this.uiElements = {}, this.ui = {}, this.template = e, this.classes = t, this.parent = o, this.keyBindingHandler = this.keyBindingHandler.bind(this);
  }
  initialize() {
    this.bindAppEvents();
  }
  setCustomEmojis(e) {
    this.customEmojis = e;
  }
  setEvents(e) {
    this.events = e;
  }
  setPickerId(e) {
    this.pickerId = e;
  }
  emit(e, ...t) {
    this.events.emit(e, ...t);
  }
  setI18n(e) {
    this.i18n = e;
  }
  setRenderer(e) {
    this.renderer = e;
  }
  setEmojiData(e) {
    this.emojiDataPromise = e, e.then((t) => {
      this.emojiData = t;
    });
  }
  updateEmojiData(e) {
    this.emojiData = e, this.emojiDataPromise = Promise.resolve(e);
  }
  setOptions(e) {
    this.options = e;
  }
  renderSync(e = {}) {
    return this.el = this.template.renderSync({
      classes: this.classes,
      i18n: this.i18n,
      pickerId: this.pickerId,
      ...e
    }), this.postRender(), this.el;
  }
  async render(e = {}) {
    return await this.emojiDataPromise, this.el = await this.template.renderAsync({
      classes: this.classes,
      i18n: this.i18n,
      pickerId: this.pickerId,
      ...e
    }), this.postRender(), this.el;
  }
  postRender() {
    this.bindUIElements(), this.bindKeyBindings(), this.bindUIEvents(), this.scheduleShowAnimation();
  }
  bindAppEvents() {
    Object.keys(this.appEvents).forEach((e) => {
      this.events.on(e, this.appEvents[e], this);
    }), this.events.on("data:ready", this.updateEmojiData, this);
  }
  unbindAppEvents() {
    Object.keys(this.appEvents).forEach((e) => {
      this.events.off(e, this.appEvents[e]);
    }), this.events.off("data:ready", this.updateEmojiData);
  }
  keyBindingHandler(e) {
    const t = this.keyBindings[e.key];
    t && t.call(this, e);
  }
  bindKeyBindings() {
    this.keyBindings && this.el.addEventListener("keydown", this.keyBindingHandler);
  }
  unbindKeyBindings() {
    this.keyBindings && this.el.removeEventListener("keydown", this.keyBindingHandler);
  }
  bindUIElements() {
    this.ui = Object.keys(this.uiElements).reduce((e, t) => ({
      ...e,
      [t]: this.el.querySelector(this.uiElements[t])
    }), {});
  }
  bindUIEvents() {
    this.uiEvents.forEach((e) => {
      e.handler = e.handler.bind(this), (e.target ? this.ui[e.target] : this.el).addEventListener(e.event, e.handler, e.options);
    });
  }
  unbindUIEvents() {
    this.uiEvents.forEach((e) => {
      (e.target ? this.ui[e.target] : this.el).removeEventListener(e.event, e.handler);
    });
  }
  destroy() {
    this.unbindAppEvents(), this.unbindUIEvents(), this.unbindKeyBindings(), this.el.remove(), this.isDestroyed = !0;
  }
  scheduleShowAnimation() {
    if (this.parent) {
      const e = new MutationObserver((t) => {
        const [o] = t;
        o.type === "childList" && o.addedNodes[0] === this.el && (be(this.options) && this.animateShow && this.animateShow(), e.disconnect);
      });
      e.observe(this.parent, { childList: !0 });
    }
  }
  static childEvent(e, t, o, i = {}) {
    return { target: e, event: t, handler: o, options: i };
  }
  static uiEvent(e, t, o = {}) {
    return { event: e, handler: t, options: o };
  }
  static byClass(e) {
    return `.${e}`;
  }
}
const qe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"/></svg>', Ge = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M64 496C64 504.8 56.75 512 48 512h-32C7.25 512 0 504.8 0 496V32c0-17.75 14.25-32 32-32s32 14.25 32 32V496zM476.3 0c-6.365 0-13.01 1.35-19.34 4.233c-45.69 20.86-79.56 27.94-107.8 27.94c-59.96 0-94.81-31.86-163.9-31.87C160.9 .3055 131.6 4.867 96 15.75v350.5c32-9.984 59.87-14.1 84.85-14.1c73.63 0 124.9 31.78 198.6 31.78c31.91 0 68.02-5.971 111.1-23.09C504.1 355.9 512 344.4 512 332.1V30.73C512 11.1 495.3 0 476.3 0z"/></svg>', We = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM176.4 240C194 240 208.4 225.7 208.4 208C208.4 190.3 194 176 176.4 176C158.7 176 144.4 190.3 144.4 208C144.4 225.7 158.7 240 176.4 240zM336.4 176C318.7 176 304.4 190.3 304.4 208C304.4 225.7 318.7 240 336.4 240C354 240 368.4 225.7 368.4 208C368.4 190.3 354 176 336.4 176zM259.9 369.4C288.8 369.4 316.2 375.2 340.6 385.5C352.9 390.7 366.7 381.3 361.4 369.1C344.8 330.9 305.6 303.1 259.9 303.1C214.3 303.1 175.1 330.8 158.4 369.1C153.1 381.3 166.1 390.6 179.3 385.4C203.7 375.1 231 369.4 259.9 369.4L259.9 369.4z"/></svg>', _e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M448 64H192C85.96 64 0 149.1 0 256s85.96 192 192 192h256c106 0 192-85.96 192-192S554 64 448 64zM247.1 280h-32v32c0 13.2-10.78 24-23.98 24c-13.2 0-24.02-10.8-24.02-24v-32L136 279.1C122.8 279.1 111.1 269.2 111.1 256c0-13.2 10.85-24.01 24.05-24.01L167.1 232v-32c0-13.2 10.82-24 24.02-24c13.2 0 23.98 10.8 23.98 24v32h32c13.2 0 24.02 10.8 24.02 24C271.1 269.2 261.2 280 247.1 280zM431.1 344c-22.12 0-39.1-17.87-39.1-39.1s17.87-40 39.1-40s39.1 17.88 39.1 40S454.1 344 431.1 344zM495.1 248c-22.12 0-39.1-17.87-39.1-39.1s17.87-40 39.1-40c22.12 0 39.1 17.88 39.1 40S518.1 248 495.1 248z"/></svg>', Je = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M112.1 454.3c0 6.297 1.816 12.44 5.284 17.69l17.14 25.69c5.25 7.875 17.17 14.28 26.64 14.28h61.67c9.438 0 21.36-6.401 26.61-14.28l17.08-25.68c2.938-4.438 5.348-12.37 5.348-17.7L272 415.1h-160L112.1 454.3zM191.4 .0132C89.44 .3257 16 82.97 16 175.1c0 44.38 16.44 84.84 43.56 115.8c16.53 18.84 42.34 58.23 52.22 91.45c.0313 .25 .0938 .5166 .125 .7823h160.2c.0313-.2656 .0938-.5166 .125-.7823c9.875-33.22 35.69-72.61 52.22-91.45C351.6 260.8 368 220.4 368 175.1C368 78.61 288.9-.2837 191.4 .0132zM192 96.01c-44.13 0-80 35.89-80 79.1C112 184.8 104.8 192 96 192S80 184.8 80 176c0-61.76 50.25-111.1 112-111.1c8.844 0 16 7.159 16 16S200.8 96.01 192 96.01z"/></svg>', Ye = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M512 32H120c-13.25 0-24 10.75-24 24L96.01 288c0 53 43 96 96 96h192C437 384 480 341 480 288h32c70.63 0 128-57.38 128-128S582.6 32 512 32zM512 224h-32V96h32c35.25 0 64 28.75 64 64S547.3 224 512 224zM560 416h-544C7.164 416 0 423.2 0 432C0 458.5 21.49 480 48 480h480c26.51 0 48-21.49 48-48C576 423.2 568.8 416 560 416z"/></svg>', Qe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M482.3 192C516.5 192 576 221 576 256C576 292 516.5 320 482.3 320H365.7L265.2 495.9C259.5 505.8 248.9 512 237.4 512H181.2C170.6 512 162.9 501.8 165.8 491.6L214.9 320H112L68.8 377.6C65.78 381.6 61.04 384 56 384H14.03C6.284 384 0 377.7 0 369.1C0 368.7 .1818 367.4 .5398 366.1L32 256L.5398 145.9C.1818 144.6 0 143.3 0 142C0 134.3 6.284 128 14.03 128H56C61.04 128 65.78 130.4 68.8 134.4L112 192H214.9L165.8 20.4C162.9 10.17 170.6 0 181.2 0H237.4C248.9 0 259.5 6.153 265.2 16.12L365.7 192H482.3z"/></svg>', Xe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M9.375 233.4C3.375 239.4 0 247.5 0 256v128c0 8.5 3.375 16.62 9.375 22.62S23.5 416 32 416h32V224H32C23.5 224 15.38 227.4 9.375 233.4zM464 96H352V32c0-17.62-14.38-32-32-32S288 14.38 288 32v64H176C131.8 96 96 131.8 96 176V448c0 35.38 28.62 64 64 64h320c35.38 0 64-28.62 64-64V176C544 131.8 508.3 96 464 96zM256 416H192v-32h64V416zM224 296C201.9 296 184 278.1 184 256S201.9 216 224 216S264 233.9 264 256S246.1 296 224 296zM352 416H288v-32h64V416zM448 416h-64v-32h64V416zM416 296c-22.12 0-40-17.88-40-40S393.9 216 416 216S456 233.9 456 256S438.1 296 416 296zM630.6 233.4C624.6 227.4 616.5 224 608 224h-32v192h32c8.5 0 16.62-3.375 22.62-9.375S640 392.5 640 384V256C640 247.5 636.6 239.4 630.6 233.4z"/></svg>', Ze = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  <defs>
    <radialGradient gradientUnits="userSpaceOnUse" cy="10%" id="gradient-0">
      <stop offset="0" stop-color="hsl(50, 100%, 50%)" />
      <stop offset="1" stop-color="hsl(50, 100%, 60%)" />
    </radialGradient>
  </defs>
  <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
  <ellipse stroke="#000" fill="rgba(0, 0, 0, 0.6)" cx="172.586" cy="207.006" rx="39.974" ry="39.974"/>
  <ellipse stroke="#000" fill="rgba(0, 0, 0, 0.6)" cx="334.523" cy="207.481" rx="39.974" ry="39.974"/>
  <ellipse stroke="#000" fill="rgba(0, 0, 0, 0.6)" cx="313.325" cy="356.208" rx="91.497" ry="59.893"/>
  <path fill="#55a7ff" d="M 159.427 274.06 L 102.158 363.286 L 124.366 417.011 L 160.476 423.338 L 196.937 414.736 L 218.502 375.214"></path>
  <path fill="url(#gradient-0)" d="M256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM256 352C290.9 352 323.2 367.8 348.3 394.9C354.3 401.4 364.4 401.7 370.9 395.7C377.4 389.7 377.7 379.6 371.7 373.1C341.6 340.5 301 320 256 320C247.2 320 240 327.2 240 336C240 344.8 247.2 352 256 352H256zM208 369C208 349 179.6 308.6 166.4 291.3C163.2 286.9 156.8 286.9 153.6 291.3C140.6 308.6 112 349 112 369C112 395 133.5 416 160 416C186.5 416 208 395 208 369H208zM303.6 208C303.6 225.7 317.1 240 335.6 240C353.3 240 367.6 225.7 367.6 208C367.6 190.3 353.3 176 335.6 176C317.1 176 303.6 190.3 303.6 208zM207.6 208C207.6 190.3 193.3 176 175.6 176C157.1 176 143.6 190.3 143.6 208C143.6 225.7 157.1 240 175.6 240C193.3 240 207.6 225.7 207.6 208z" />
</svg>`, et = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"/></svg>', tt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256.3 331.8C208.9 331.8 164.1 324.9 124.5 312.8C112.2 309 100.2 319.7 105.2 331.5C130.1 390.6 188.4 432 256.3 432C324.2 432 382.4 390.6 407.4 331.5C412.4 319.7 400.4 309 388.1 312.8C348.4 324.9 303.7 331.8 256.3 331.8H256.3zM176.4 176C158.7 176 144.4 190.3 144.4 208C144.4 225.7 158.7 240 176.4 240C194 240 208.4 225.7 208.4 208C208.4 190.3 194 176 176.4 176zM336.4 240C354 240 368.4 225.7 368.4 208C368.4 190.3 354 176 336.4 176C318.7 176 304.4 190.3 304.4 208C304.4 225.7 318.7 240 336.4 240z"/></svg>', st = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M500.3 7.251C507.7 13.33 512 22.41 512 31.1V175.1C512 202.5 483.3 223.1 447.1 223.1C412.7 223.1 383.1 202.5 383.1 175.1C383.1 149.5 412.7 127.1 447.1 127.1V71.03L351.1 90.23V207.1C351.1 234.5 323.3 255.1 287.1 255.1C252.7 255.1 223.1 234.5 223.1 207.1C223.1 181.5 252.7 159.1 287.1 159.1V63.1C287.1 48.74 298.8 35.61 313.7 32.62L473.7 .6198C483.1-1.261 492.9 1.173 500.3 7.251H500.3zM74.66 303.1L86.5 286.2C92.43 277.3 102.4 271.1 113.1 271.1H174.9C185.6 271.1 195.6 277.3 201.5 286.2L213.3 303.1H239.1C266.5 303.1 287.1 325.5 287.1 351.1V463.1C287.1 490.5 266.5 511.1 239.1 511.1H47.1C21.49 511.1-.0019 490.5-.0019 463.1V351.1C-.0019 325.5 21.49 303.1 47.1 303.1H74.66zM143.1 359.1C117.5 359.1 95.1 381.5 95.1 407.1C95.1 434.5 117.5 455.1 143.1 455.1C170.5 455.1 191.1 434.5 191.1 407.1C191.1 381.5 170.5 359.1 143.1 359.1zM440.3 367.1H496C502.7 367.1 508.6 372.1 510.1 378.4C513.3 384.6 511.6 391.7 506.5 396L378.5 508C372.9 512.1 364.6 513.3 358.6 508.9C352.6 504.6 350.3 496.6 353.3 489.7L391.7 399.1H336C329.3 399.1 323.4 395.9 321 389.6C318.7 383.4 320.4 376.3 325.5 371.1L453.5 259.1C459.1 255 467.4 254.7 473.4 259.1C479.4 263.4 481.6 271.4 478.7 278.3L440.3 367.1zM116.7 219.1L19.85 119.2C-8.112 90.26-6.614 42.31 24.85 15.34C51.82-8.137 93.26-3.642 118.2 21.83L128.2 32.32L137.7 21.83C162.7-3.642 203.6-8.137 231.6 15.34C262.6 42.31 264.1 90.26 236.1 119.2L139.7 219.1C133.2 225.6 122.7 225.6 116.7 219.1H116.7z"/></svg>', ot = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M413.8 447.1L256 448l0 31.99C256 497.7 241.8 512 224.1 512c-17.67 0-32.1-14.32-32.1-31.99l0-31.99l-158.9-.0099c-28.5 0-43.69-34.49-24.69-56.4l68.98-79.59H62.22c-25.41 0-39.15-29.8-22.67-49.13l60.41-70.85H89.21c-21.28 0-32.87-22.5-19.28-37.31l134.8-146.5c10.4-11.3 28.22-11.3 38.62-.0033l134.9 146.5c13.62 14.81 2.001 37.31-19.28 37.31h-10.77l60.35 70.86c16.46 19.34 2.716 49.12-22.68 49.12h-15.2l68.98 79.59C458.7 413.7 443.1 447.1 413.8 447.1z"/></svg>', it = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3c-95.73 0-173.3 77.6-173.3 173.3C0 496.5 15.52 512 34.66 512H413.3C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM479.1 320h-73.85C451.2 357.7 480 414.1 480 477.3C480 490.1 476.2 501.9 470 512h138C625.7 512 640 497.6 640 479.1C640 391.6 568.4 320 479.1 320zM432 256C493.9 256 544 205.9 544 144S493.9 32 432 32c-25.11 0-48.04 8.555-66.72 22.51C376.8 76.63 384 101.4 384 128c0 35.52-11.93 68.14-31.59 94.71C372.7 243.2 400.8 256 432 256z"/></svg>', rt = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  <defs>
    <radialGradient id="radial" cy="85%">
      <stop offset="20%" stop-color="var(--color-secondary)" />
      <stop offset="100%" stop-color="var(--color-primary)" />
    </radialGradient>
  </defs>
  <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
  <path fill="url('#radial')" d="M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z" />
</svg>`, at = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"/></svg>';
function nt(s, e) {
  const t = J(e);
  return t.dataset.icon = s, t.classList.add(ie("icon")), t;
}
const me = {
  clock: qe,
  flag: Ge,
  frown: We,
  gamepad: _e,
  lightbulb: Je,
  mug: Ye,
  plane: Qe,
  robot: Xe,
  sad: Ze,
  search: et,
  smiley: tt,
  symbols: st,
  tree: ot,
  users: it,
  warning: rt,
  xmark: at
}, D = {
  recents: "clock",
  "smileys-emotion": "smiley",
  "people-body": "users",
  "animals-nature": "tree",
  "food-drink": "mug",
  activities: "gamepad",
  "travel-places": "plane",
  objects: "lightbulb",
  symbols: "symbols",
  flags: "flag",
  custom: "robot"
};
function je(s, e) {
  if (!(s in me))
    return console.warn(`Unknown icon: "${s}"`), document.createElement("div");
  const t = nt(s, me[s]);
  return e && t.classList.add(ie(`icon-${e}`)), t;
}
const ct = {
  mode: "sync"
};
var w, E, S, Y, P, Q, z, X;
class u {
  constructor(e, t = {}) {
    f(this, S);
    f(this, P);
    f(this, z);
    f(this, w, void 0);
    f(this, E, void 0);
    A(this, w, e), A(this, E, t.mode || ct.mode);
  }
  renderSync(e = {}) {
    const t = J(y(this, w).call(this, e));
    return p(this, z, X).call(this, t, e), p(this, P, Q).call(this, t), p(this, S, Y).call(this, t, e), t;
  }
  async renderAsync(e = {}) {
    const t = J(y(this, w).call(this, e));
    return p(this, z, X).call(this, t, e), p(this, P, Q).call(this, t), await p(this, S, Y).call(this, t, e), t;
  }
  render(e) {
    return y(this, E) === "sync" ? this.renderSync(e) : this.renderAsync(e);
  }
}
w = new WeakMap(), E = new WeakMap(), S = new WeakSet(), Y = async function(e, t) {
  const o = e.querySelectorAll("[data-view]"), i = [];
  for (const r of o) {
    const a = t[r.dataset.view];
    a ? r.dataset.render !== "sync" ? i.push(a.render().then((n) => (r.replaceWith(n), n))) : r.replaceWith(a.renderSync()) : r.remove();
  }
  return Promise.all(i);
}, P = new WeakSet(), Q = function(e) {
  e.querySelectorAll("i[data-icon]").forEach((o) => {
    const { icon: i, size: r } = o.dataset;
    o.replaceWith(je(i, r));
  });
}, z = new WeakSet(), X = function(e, t) {
  return e.querySelectorAll("[data-placeholder]").forEach((i) => {
    const r = i.dataset.placeholder;
    if (r && t[r]) {
      const a = t[r];
      i.replaceWith(...[a].flat());
    } else
      console.warn(`Missing placeholder element for key "${r}"`);
  }), e;
};
const lt = g(
  "imagePlaceholder",
  "placeholder"
), ht = new u(({ classes: s }) => `
  <div class="${s.placeholder} ${s.imagePlaceholder}"></div>
`);
class dt extends c {
  constructor({ classNames: e } = {}) {
    super({ template: ht, classes: lt }), this.classNames = e;
  }
  load(e) {
    const t = document.createElement("img");
    this.classNames && (t.className = this.classNames), t.addEventListener("load", () => {
      this.el.replaceWith(t);
    }, { once: !0 }), Promise.resolve(e).then((o) => t.src = o);
  }
  renderSync() {
    return super.renderSync(), this.classNames && this.classNames.split(" ").forEach((t) => this.el.classList.add(t)), this.el;
  }
}
const mt = g("customEmoji");
class ut {
  renderElement(e) {
    return { content: e };
  }
  renderImage(e = "", t) {
    const o = new dt({ classNames: e });
    return o.renderSync(), { content: o, resolver: () => (o.load(t()), o.el) };
  }
  doRender(e, t, o) {
    if (e.custom)
      return this.renderCustom(e, t, o);
    const { content: i, resolver: r } = this.render(e, o), a = i instanceof Element ? i : i.el;
    return r && r(), a;
  }
  doEmit(e) {
    return e.custom ? this.emitCustom(e) : this.emit(e);
  }
  emitCustom({ url: e, label: t, emoji: o, data: i }) {
    return { url: e, label: t, emoji: o, data: i };
  }
  renderCustom(e, t, o = "") {
    const i = [mt.customEmoji, o].join(" ").trim(), { content: r, resolver: a } = this.renderImage(i, () => e.url), n = r instanceof Element ? r : r.el;
    return a && a(), n;
  }
}
const gt = new u(({ emoji: s }) => `<span>${s}</span>`);
class pt extends ut {
  render(e) {
    return this.renderElement(gt.renderSync({ emoji: e.emoji }));
  }
  emit({ emoji: e, hexcode: t, label: o }) {
    return { emoji: e, hexcode: t, label: o };
  }
}
const yt = {
  "categories.activities": "Activities",
  "categories.animals-nature": "Animals & Nature",
  "categories.custom": "Custom",
  "categories.flags": "Flags",
  "categories.food-drink": "Food & Drink",
  "categories.objects": "Objects",
  "categories.people-body": "People & Body",
  "categories.recents": "Recently Used",
  "categories.smileys-emotion": "Smileys & Emotion",
  "categories.symbols": "Symbols",
  "categories.travel-places": "Travel & Places",
  "error.load": "Failed to load emojis",
  "recents.clear": "Clear recent emojis",
  "recents.none": "You haven't selected any emojis yet.",
  retry: "Try again",
  "search.clear": "Clear search",
  "search.error": "Failed to search emojis",
  "search.notFound": "No results found",
  search: "Search emojis..."
}, ft = [
  (s, e) => (s.hexcode === "1F91D" && e < 14 && (s.skins = []), s),
  (s, e) => (s.skins && (s.skins = s.skins.filter((t) => !t.version || t.version <= e)), s)
];
function vt(s, e) {
  return ft.some((t) => t(s, e) === null) ? null : s;
}
function B(s, e) {
  return s.filter((t) => vt(t, e) !== null);
}
function x(s) {
  var e;
  return {
    emoji: s.emoji,
    label: s.label,
    tags: s.tags,
    skins: (e = s.skins) == null ? void 0 : e.map((t) => x(t)),
    order: s.order,
    custom: !1,
    hexcode: s.hexcode,
    version: s.version
  };
}
function M(s, e, t) {
  var o;
  return t && !t.some((i) => i.order === s.group) ? !1 : he(s.label, e) || ((o = s.tags) == null ? void 0 : o.some((i) => he(i, e)));
}
class ke {
  constructor(e = "en") {
    this.locale = e;
  }
}
const Z = "PicMo";
function xe(s) {
  return new wt(s);
}
xe.deleteDatabase = (s) => new Promise((e, t) => {
  const o = indexedDB.deleteDatabase(`${Z}-${s}`);
  o.addEventListener("success", e), o.addEventListener("error", t);
});
class wt extends ke {
  async open() {
    const e = indexedDB.open(`${Z}-${this.locale}`);
    return new Promise((t, o) => {
      e.addEventListener("success", (i) => {
        var r;
        this.db = (r = i.target) == null ? void 0 : r.result, t();
      }), e.addEventListener("error", o), e.addEventListener("upgradeneeded", async (i) => {
        var a;
        this.db = (a = i.target) == null ? void 0 : a.result, this.db.createObjectStore("category", { keyPath: "order" });
        const r = this.db.createObjectStore("emoji", { keyPath: "emoji" });
        r.createIndex("category", "group"), r.createIndex("version", "version"), this.db.createObjectStore("meta");
      });
    });
  }
  async delete() {
    this.close();
    const e = indexedDB.deleteDatabase(`${Z}-${this.locale}`);
    await this.waitForRequest(e);
  }
  close() {
    this.db.close();
  }
  async getEmojiCount() {
    const t = this.db.transaction("emoji", "readonly").objectStore("emoji");
    return (await this.waitForRequest(t.count())).target.result;
  }
  async getEtags() {
    const t = this.db.transaction("meta", "readonly").objectStore("meta"), [o, i] = await Promise.all([
      this.waitForRequest(t.get("emojisEtag")),
      this.waitForRequest(t.get("messagesEtag"))
    ]);
    return {
      storedEmojisEtag: o.target.result,
      storedMessagesEtag: i.target.result
    };
  }
  async setMeta(e) {
    const t = this.db.transaction("meta", "readwrite"), o = t.objectStore("meta");
    return new Promise((i) => {
      t.oncomplete = i, Object.keys(e).filter(Boolean).forEach((a) => {
        o.put(e[a], a);
      });
    });
  }
  async getHash() {
    const t = this.db.transaction("meta", "readonly").objectStore("meta");
    return (await this.waitForRequest(t.get("hash"))).target.result;
  }
  async isPopulated() {
    const t = this.db.transaction("category", "readonly").objectStore("category");
    return (await this.waitForRequest(t.count())).target.result > 0;
  }
  async populate({
    groups: e,
    emojis: t,
    emojisEtag: o,
    messagesEtag: i,
    hash: r
  }) {
    await this.removeAllObjects("category", "emoji");
    const a = [
      this.addObjects("category", e),
      this.addObjects("emoji", t),
      this.setMeta({ emojisEtag: o, messagesEtag: i, hash: r })
    ];
    await Promise.all(a);
  }
  async getCategories(e) {
    var a;
    const o = this.db.transaction("category", "readonly").objectStore("category");
    let r = (await this.waitForRequest(o.getAll())).target.result.filter((n) => n.key !== "component");
    if (e.showRecents && r.unshift({ key: "recents", order: -1 }), (a = e.custom) != null && a.length && r.push({ key: "custom", order: 10 }), e.categories) {
      const n = e.categories;
      r = r.filter((l) => n.includes(l.key)), r.sort((l, m) => n.indexOf(l.key) - n.indexOf(m.key));
    } else
      r.sort((n, l) => n.order - l.order);
    return r;
  }
  async getEmojis(e, t) {
    const r = this.db.transaction("emoji", "readonly").objectStore("emoji").index("category"), l = (await this.waitForRequest(r.getAll(e.order))).target.result.filter((m) => m.version <= t).sort((m, d) => m.order != null && d.order != null ? m.order - d.order : 0).map(x);
    return B(l, t);
  }
  async searchEmojis(e, t, o, i) {
    const r = [];
    return new Promise((a, n) => {
      const d = this.db.transaction("emoji", "readonly").objectStore("emoji").openCursor();
      d.addEventListener("success", (h) => {
        var ce;
        const H = (ce = h.target) == null ? void 0 : ce.result;
        if (!H)
          return a([
            ...B(r, o),
            ...t.filter((ze) => M(ze, e))
          ]);
        const N = H.value;
        M(N, e, i) && N.version <= o && r.push(x(N)), H.continue();
      }), d.addEventListener("error", (h) => {
        n(h);
      });
    });
  }
  async waitForRequest(e) {
    return new Promise((t, o) => {
      e.onsuccess = t, e.onerror = o;
    });
  }
  withTransaction(e, t = "readwrite", o) {
    return new Promise((i, r) => {
      const a = this.db.transaction(e, t);
      a.oncomplete = i, a.onerror = r, o(a);
    });
  }
  async removeAllObjects(...e) {
    const t = this.db.transaction(e, "readwrite"), o = e.map((i) => t.objectStore(i));
    await Promise.all(o.map((i) => this.waitForRequest(i.clear())));
  }
  async addObjects(e, t) {
    return this.withTransaction(e, "readwrite", (o) => {
      const i = o.objectStore(e);
      t.forEach((r) => {
        i.add(r);
      });
    });
  }
}
class bt {
}
const K = "PicMo:recents";
class Ee extends bt {
  constructor(e) {
    super(), this.storage = e;
  }
  clear() {
    this.storage.removeItem(K);
  }
  getRecents(e) {
    var t;
    try {
      return JSON.parse((t = this.storage.getItem(K)) != null ? t : "[]").slice(0, e);
    } catch {
      return [];
    }
  }
  addOrUpdateRecent(e, t) {
    const o = [
      e,
      ...this.getRecents(t).filter((i) => i.hexcode !== e.hexcode)
    ].slice(0, t);
    try {
      this.storage.setItem(K, JSON.stringify(o));
    } catch {
      console.warn("storage is not available, recent emojis will not be saved");
    }
  }
}
class Ct extends Ee {
  constructor() {
    super(localStorage);
  }
}
const jt = {
  dataStore: xe,
  theme: Ke,
  animate: !0,
  showCategoryTabs: !0,
  showPreview: !0,
  showRecents: !0,
  showSearch: !0,
  showVariants: !0,
  emojisPerRow: 8,
  visibleRows: 6,
  emojiVersion: "auto",
  i18n: yt,
  locale: "en",
  maxRecents: 50,
  custom: []
};
function kt(s = {}) {
  return {
    ...jt,
    ...s,
    renderer: s.renderer || new pt(),
    recentsProvider: s.recentsProvider || new Ct()
  };
}
var v, b, V, $, ee;
class ae {
  constructor() {
    f(this, b);
    f(this, $);
    f(this, v, /* @__PURE__ */ new Map());
  }
  on(e, t, o) {
    p(this, $, ee).call(this, e, t, o);
  }
  once(e, t, o) {
    p(this, $, ee).call(this, e, t, o, !0);
  }
  off(e, t) {
    const o = p(this, b, V).call(this, e);
    y(this, v).set(e, o.filter((i) => i.handler !== t));
  }
  emit(e, ...t) {
    p(this, b, V).call(this, e).forEach((i) => {
      i.handler.apply(i.context, t), i.once && this.off(e, i.handler);
    });
  }
  removeAll() {
    y(this, v).clear();
  }
}
v = new WeakMap(), b = new WeakSet(), V = function(e) {
  return y(this, v).has(e) || y(this, v).set(e, []), y(this, v).get(e);
}, $ = new WeakSet(), ee = function(e, t, o, i = !1) {
  p(this, b, V).call(this, e).push({ context: o, handler: t, once: i });
};
const xt = {
  injectStyles: !0
};
class Et extends ae {
}
class St extends ae {
}
const te = g(
  "emojiCategory",
  "categoryName",
  "noRecents",
  "recentEmojis"
);
class ne extends c {
  constructor({ template: e, category: t, showVariants: o, lazyLoader: i }) {
    super({ template: e, classes: te }), this.baseUIElements = {
      categoryName: c.byClass(te.categoryName)
    }, this.category = t, this.showVariants = o, this.lazyLoader = i;
  }
  setActive(e, t, o) {
    this.emojiContainer.setActive(e, t, o);
  }
}
const Pt = new u(({ classes: s, emoji: e }) => `
  <button
    type="button"
    class="${s.emojiButton}"
    title="${e.label}"
    data-emoji="${e.emoji}"
    tabindex="-1">
    <div data-placeholder="emojiContent"></div>
  </button>
`), zt = g("emojiButton");
class Se extends c {
  constructor({ emoji: e, lazyLoader: t, category: o }) {
    super({ template: Pt, classes: zt }), this.emoji = e, this.lazyLoader = t, this.category = o;
  }
  initialize() {
    this.uiEvents = [
      c.uiEvent("focus", this.handleFocus)
    ], super.initialize();
  }
  handleFocus() {
    this.category && this.events.emit("focus:change", this.category);
  }
  activateFocus(e) {
    this.el.tabIndex = 0, e && this.el.focus();
  }
  deactivateFocus() {
    this.el.tabIndex = -1;
  }
  renderSync() {
    return super.renderSync({
      emoji: this.emoji,
      emojiContent: this.renderer.doRender(this.emoji, this.lazyLoader)
    });
  }
}
class $t {
  constructor(e, t, o = 0, i = 0, r = !1) {
    this.events = new ae(), this.keyHandlers = {
      ArrowLeft: this.focusPrevious.bind(this),
      ArrowRight: this.focusNext.bind(this),
      ArrowUp: this.focusUp.bind(this),
      ArrowDown: this.focusDown.bind(this)
    }, this.rowCount = Math.ceil(t / e), this.columnCount = e, this.focusedRow = o, this.focusedColumn = i, this.emojiCount = t, this.wrap = r, this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  destroy() {
    this.events.removeAll();
  }
  on(e, t) {
    this.events.on(e, t);
  }
  handleKeyDown(e) {
    e.key in this.keyHandlers && (e.preventDefault(), this.keyHandlers[e.key]());
  }
  setCell(e, t, o = !0) {
    const i = this.getIndex();
    this.focusedRow = e, t !== void 0 && (this.focusedColumn = Math.min(this.columnCount, t)), (this.focusedRow >= this.rowCount || this.getIndex() >= this.emojiCount) && (this.focusedRow = this.rowCount - 1, this.focusedColumn = this.emojiCount % this.columnCount - 1), this.events.emit("focus:change", { from: i, to: this.getIndex(), performFocus: o });
  }
  setFocusedIndex(e, t = !0) {
    const o = Math.floor(e / this.columnCount), i = e % this.columnCount;
    this.setCell(o, i, t);
  }
  focusNext() {
    this.focusedColumn < this.columnCount - 1 && this.getIndex() < this.emojiCount - 1 ? this.setCell(this.focusedRow, this.focusedColumn + 1) : this.focusedRow < this.rowCount - 1 ? this.setCell(this.focusedRow + 1, 0) : this.wrap ? this.setCell(0, 0) : this.events.emit("focus:overflow", 0);
  }
  focusPrevious() {
    this.focusedColumn > 0 ? this.setCell(this.focusedRow, this.focusedColumn - 1) : this.focusedRow > 0 ? this.setCell(this.focusedRow - 1, this.columnCount - 1) : this.wrap ? this.setCell(this.rowCount - 1, this.columnCount - 1) : this.events.emit("focus:underflow", this.columnCount - 1);
  }
  focusUp() {
    this.focusedRow > 0 ? this.setCell(this.focusedRow - 1, this.focusedColumn) : this.events.emit("focus:underflow", this.focusedColumn);
  }
  focusDown() {
    this.focusedRow < this.rowCount - 1 ? this.setCell(this.focusedRow + 1, this.focusedColumn) : this.events.emit("focus:overflow", this.focusedColumn);
  }
  focusToIndex(e) {
    this.setCell(Math.floor(e / this.columnCount), e % this.columnCount);
  }
  getIndex() {
    return this.focusedRow * this.columnCount + this.focusedColumn;
  }
  getCell() {
    return { row: this.focusedRow, column: this.focusedColumn };
  }
  getRowCount() {
    return this.rowCount;
  }
}
const Lt = new u(({ classes: s }) => `
  <div class="${s.emojiContainer}">
    <div data-placeholder="emojis"></div>
  </div>
`), Ft = g("emojiContainer");
class F extends c {
  constructor({ emojis: e, showVariants: t, preview: o = !0, lazyLoader: i, category: r, fullHeight: a = !1 }) {
    super({ template: Lt, classes: Ft }), this.fullHeight = !1, this.showVariants = t, this.lazyLoader = i, this.preview = o, this.emojis = e, this.category = r, this.fullHeight = a, this.setFocus = this.setFocus.bind(this), this.triggerNextCategory = this.triggerNextCategory.bind(this), this.triggerPreviousCategory = this.triggerPreviousCategory.bind(this);
  }
  initialize() {
    this.grid = new $t(this.options.emojisPerRow, this.emojiCount, 0, 0, !this.category), this.grid.on("focus:change", this.setFocus), this.grid.on("focus:overflow", this.triggerNextCategory), this.grid.on("focus:underflow", this.triggerPreviousCategory), this.uiEvents = [
      c.uiEvent("click", this.selectEmoji),
      c.uiEvent("keydown", this.grid.handleKeyDown)
    ], this.preview && this.uiEvents.push(
      c.uiEvent("mouseover", this.showPreview),
      c.uiEvent("mouseout", this.hidePreview),
      c.uiEvent("focus", this.showPreview, { capture: !0 }),
      c.uiEvent("blur", this.hidePreview, { capture: !0 })
    ), super.initialize();
  }
  setFocusedView(e, t) {
    if (!!e)
      if (typeof e == "string") {
        const o = this.emojis.findIndex((i) => i.emoji === e);
        this.grid.setFocusedIndex(o, !1), setTimeout(() => {
          var n, l, m, d;
          const i = this.emojiViews[o].el;
          i.scrollIntoView();
          const r = (n = i.parentElement) == null ? void 0 : n.previousElementSibling, a = (m = (l = i.parentElement) == null ? void 0 : l.parentElement) == null ? void 0 : m.parentElement;
          a.scrollTop -= (d = r == null ? void 0 : r.offsetHeight) != null ? d : 0;
        });
      } else
        e.row === "first" || e.row === 0 ? this.grid.setCell(0, e.offset, t) : e.row === "last" && this.grid.setCell(this.grid.getRowCount() - 1, e.offset, t);
  }
  setActive(e, t, o) {
    var i;
    e ? this.setFocusedView(t, o) : (i = this.emojiViews[this.grid.getIndex()]) == null || i.deactivateFocus();
  }
  renderSync() {
    return this.emojiViews = this.emojis.map(
      (e) => this.viewFactory.create(Se, {
        emoji: e,
        category: this.category,
        lazyLoader: this.lazyLoader,
        renderer: this.renderer
      })
    ), this.emojiElements = this.emojiViews.map((e) => e.renderSync()), super.renderSync({
      emojis: this.emojiElements,
      i18n: this.i18n
    });
  }
  destroy() {
    super.destroy(), this.emojiViews.forEach((e) => e.destroy()), this.grid.destroy();
  }
  triggerPreviousCategory(e) {
    this.events.emit("category:previous", e);
  }
  triggerNextCategory(e) {
    this.category && this.events.emit("category:next", e);
  }
  setFocus({ from: e, to: t, performFocus: o }) {
    var i, r;
    (i = this.emojiViews[e]) == null || i.deactivateFocus(), (r = this.emojiViews[t]) == null || r.activateFocus(o);
  }
  selectEmoji(e) {
    e.stopPropagation();
    const t = U(e, this.emojis);
    t && this.events.emit("emoji:select", {
      emoji: t,
      showVariants: this.showVariants
    });
  }
  showPreview(e) {
    const o = e.target.closest("button"), i = o == null ? void 0 : o.firstElementChild, r = U(e, this.emojis);
    r && this.events.emit("preview:show", r, i == null ? void 0 : i.cloneNode(!0));
  }
  hidePreview(e) {
    U(e, this.emojis) && this.events.emit("preview:hide");
  }
  get emojiCount() {
    return this.emojis.length;
  }
}
const At = new u(({ classes: s, category: e, pickerId: t, icon: o, i18n: i }) => `
  <section class="${s.emojiCategory}" role="tabpanel" aria-labelledby="${t}-category-${e.key}">
    <h3 data-category="${e.key}" class="${s.categoryName}">
      <i data-icon="${o}"></i>
      ${i.get(`categories.${e.key}`, e.message || e.key)}
    </h3>
    <div data-view="emojis" data-render="sync"></div>
  </section>
`);
class It extends ne {
  constructor({ category: e, showVariants: t, lazyLoader: o, emojiVersion: i }) {
    super({ category: e, showVariants: t, lazyLoader: o, template: At }), this.showVariants = t, this.lazyLoader = o, this.emojiVersion = i;
  }
  initialize() {
    this.uiElements = { ...this.baseUIElements }, super.initialize();
  }
  async render() {
    await this.emojiDataPromise;
    const e = await this.emojiData.getEmojis(this.category, this.emojiVersion);
    return this.emojiContainer = this.viewFactory.create(F, {
      emojis: e,
      showVariants: this.showVariants,
      lazyLoader: this.lazyLoader,
      category: this.category.key
    }), super.render({
      category: this.category,
      emojis: this.emojiContainer,
      emojiCount: e.length,
      icon: D[this.category.key]
    });
  }
}
class Tt extends F {
  constructor({ category: e, emojis: t, preview: o = !0, lazyLoader: i }) {
    super({ category: e, emojis: t, showVariants: !1, preview: o, lazyLoader: i });
  }
  async addOrUpdate(e) {
    const t = this.el.querySelector(`[data-emoji="${e.emoji}"]`);
    t && (this.el.removeChild(t), this.emojis = this.emojis.filter((i) => i !== e));
    const o = this.viewFactory.create(Se, { emoji: e });
    if (this.el.insertBefore(o.renderSync(), this.el.firstChild), this.emojis = [
      e,
      ...this.emojis.filter((i) => i !== e)
    ], this.emojis.length > this.options.maxRecents) {
      this.emojis = this.emojis.slice(0, this.options.maxRecents);
      const i = this.el.childElementCount - this.options.maxRecents;
      for (let r = 0; r < i; r++)
        this.el.lastElementChild && this.el.removeChild(this.el.lastElementChild);
    }
  }
}
const Rt = new u(({ emojiCount: s, classes: e, category: t, pickerId: o, icon: i, i18n: r }) => `
  <section class="${e.emojiCategory}" role="tabpanel" aria-labelledby="${o}-category-${t.key}">
    <h3 data-category="${t.key}" class="${e.categoryName}">
      <i data-icon="${i}"></i>
      ${r.get(`categories.${t.key}`, t.message || t.key)}
    </h3>
    <div data-empty="${s === 0}" class="${e.recentEmojis}">
      <div data-view="emojis" data-render="sync"></div>
    </div>
    <div class="${e.noRecents}">
      ${r.get("recents.none")}
    </div>
  </section>
`, { mode: "async" });
class Vt extends ne {
  constructor({ category: e, lazyLoader: t, provider: o }) {
    super({ category: e, showVariants: !1, lazyLoader: t, template: Rt }), this.provider = o;
  }
  initialize() {
    this.uiElements = {
      ...this.baseUIElements,
      recents: c.byClass(te.recentEmojis)
    }, this.appEvents = {
      "recent:add": this.addRecent
    }, super.initialize();
  }
  async addRecent(e) {
    await this.emojiContainer.addOrUpdate(e), this.ui.recents.dataset.empty = "false";
  }
  async render() {
    var t;
    const e = (t = this.provider) == null ? void 0 : t.getRecents(this.options.maxRecents);
    return this.emojiContainer = this.viewFactory.create(Tt, {
      emojis: e,
      showVariants: !1,
      lazyLoader: this.lazyLoader,
      category: this.category.key
    }), await super.render({
      category: this.category,
      emojis: this.emojiContainer,
      emojiCount: e.length,
      icon: D[this.category.key]
    }), this.el;
  }
}
const Bt = new u(({ classes: s, category: e, pickerId: t, icon: o, i18n: i }) => `
  <section class="${s.emojiCategory}" role="tabpanel" aria-labelledby="${t}-category-${e.key}">
    <h3 data-category="${e.key}" class="${s.categoryName}">
      <i data-icon="${o}"></i>
      ${i.get(`categories.${e.key}`, e.message || e.key)}
    </h3>
    <div data-view="emojis" data-render="sync"></div>
  </section>
`);
class Mt extends ne {
  constructor({ category: e, lazyLoader: t }) {
    super({ template: Bt, showVariants: !1, lazyLoader: t, category: e });
  }
  initialize() {
    this.uiElements = { ...this.baseUIElements }, super.initialize();
  }
  async render() {
    return this.emojiContainer = this.viewFactory.create(F, {
      emojis: this.customEmojis,
      showVariants: this.showVariants,
      lazyLoader: this.lazyLoader,
      category: this.category.key
    }), super.render({
      category: this.category,
      emojis: this.emojiContainer,
      emojiCount: this.customEmojis.length,
      icon: D[this.category.key]
    });
  }
}
class Pe {
  constructor() {
    this.elements = /* @__PURE__ */ new Map();
  }
  lazyLoad(e, t) {
    return this.elements.set(e, t), e;
  }
  observe(e) {
    if (window.IntersectionObserver) {
      const t = new IntersectionObserver(
        (o) => {
          o.filter((i) => i.intersectionRatio > 0).map((i) => i.target).forEach((i) => {
            const r = this.elements.get(i);
            r == null || r(), t.unobserve(i);
          });
        },
        {
          root: e
        }
      );
      this.elements.forEach((o, i) => {
        t.observe(i);
      });
    } else
      this.elements.forEach((t) => {
        t();
      });
  }
}
const ue = g("emojiArea"), Dt = new u(({ classes: s }) => `
  <div class="${s.emojiArea}">
    <div data-placeholder="emojis"></div>
  </div>
`, { mode: "async" }), Ht = {
  recents: Vt,
  custom: Mt
};
function Nt(s) {
  return Ht[s.key] || It;
}
function Ot(s) {
  return !s || s === "button" ? {
    row: "first",
    offset: 0
  } : s;
}
class Ut extends c {
  constructor({ categoryTabs: e, categories: t, emojiVersion: o }) {
    super({ template: Dt, classes: ue }), this.selectedCategory = 0, this.scrollListenerState = "active", this.lazyLoader = new Pe(), this.categoryTabs = e, this.categories = t, this.emojiVersion = o, this.handleScroll = Te(this.handleScroll.bind(this), 100);
  }
  initialize() {
    this.appEvents = {
      "category:select": this.handleCategorySelect,
      "category:previous": this.focusPreviousCategory,
      "category:next": this.focusNextCategory,
      "focus:change": this.updateFocusedCategory
    }, this.uiElements = { emojis: c.byClass(ue.emojiArea) }, this.uiEvents = [c.uiEvent("scroll", this.handleScroll)], super.initialize();
  }
  get focusableEmoji() {
    return this.el.querySelector('[tabindex="0"]');
  }
  async render() {
    this.emojiCategories = this.categories.map(this.createCategory, this);
    const e = {};
    return this.categories.forEach((t, o) => {
      e[`emojis-${t.key}`] = this.emojiCategories[o];
    }), await super.render({
      emojis: await Promise.all(this.emojiCategories.map((t) => t.render()))
    }), this.lazyLoader.observe(this.el), window.ResizeObserver && (this.observer = new ResizeObserver(() => {
      const t = this.el.scrollHeight - this.scrollHeight;
      this.el.scrollTop - this.scrollTop === 0 && t > 0 && (this.el.scrollTop += t), this.scrollHeight = this.el.scrollHeight, this.scrollTop = this.el.scrollTop;
    }), this.emojiCategories.forEach((t) => {
      this.observer.observe(t.el);
    })), this.el;
  }
  destroy() {
    super.destroy(), this.emojiCategories.forEach((e) => {
      var t;
      (t = this.observer) == null || t.unobserve(e.el), e.destroy();
    });
  }
  handleCategorySelect(e, t) {
    this.selectCategory(e, t);
  }
  createCategory(e) {
    const t = Nt(e);
    return this.viewFactory.create(t, {
      category: e,
      showVariants: !0,
      lazyLoader: this.lazyLoader,
      emojiVersion: this.emojiVersion,
      provider: this.options.recentsProvider
    });
  }
  determineInitialCategory() {
    var e;
    return this.options.initialCategory && this.categories.find((t) => t.key === this.options.initialCategory) ? this.options.initialCategory : (e = this.categories.find((t) => t.key !== "recents")) == null ? void 0 : e.key;
  }
  determineFocusTarget(e) {
    const t = this.emojiCategories.find((o) => o.category.key === e);
    return this.options.initialEmoji && (t == null ? void 0 : t.el.querySelector(`[data-emoji="${this.options.initialEmoji}"]`)) ? this.options.initialEmoji : "button";
  }
  reset(e = !0) {
    this.events.emit("preview:hide");
    const t = this.determineInitialCategory();
    t && (this.selectCategory(t, {
      focus: this.determineFocusTarget(t),
      performFocus: e,
      scroll: "jump"
    }), this.selectedCategory = this.getCategoryIndex(t));
  }
  getCategoryIndex(e) {
    return this.categories.findIndex((t) => t.key === e);
  }
  focusPreviousCategory(e) {
    this.selectedCategory > 0 && this.focusCategory(this.selectedCategory - 1, { row: "last", offset: e != null ? e : this.options.emojisPerRow });
  }
  focusNextCategory(e) {
    this.selectedCategory < this.categories.length - 1 && this.focusCategory(this.selectedCategory + 1, { row: "first", offset: e != null ? e : 0 });
  }
  focusCategory(e, t) {
    this.selectCategory(e, {
      focus: t,
      performFocus: !0
    });
  }
  async selectCategory(e, t = {}) {
    var l;
    this.scrollListenerState = "suspend";
    const { focus: o, performFocus: i, scroll: r } = {
      performFocus: !1,
      ...t
    };
    this.emojiCategories[this.selectedCategory].setActive(!1);
    const a = this.selectedCategory = typeof e == "number" ? e : this.getCategoryIndex(e);
    (l = this.categoryTabs) == null || l.setActiveTab(this.selectedCategory, {
      performFocus: i,
      scroll: o === "button"
    });
    const n = this.emojiCategories[a].el.offsetTop;
    this.emojiCategories[a].setActive(!0, Ot(o), o !== "button" && i), r && (this.el.scrollTop = n), this.scrollListenerState = "resume";
  }
  updateFocusedCategory(e) {
    var t;
    this.categories[this.selectedCategory].key !== e && (this.scrollListenerState = "suspend", this.selectedCategory = this.getCategoryIndex(e), (t = this.categoryTabs) == null || t.setActiveTab(this.selectedCategory, {
      changeFocusable: !1,
      performFocus: !1
    }), this.scrollListenerState = "resume");
  }
  handleScroll() {
    if (this.scrollListenerState === "suspend" || !this.categoryTabs)
      return;
    if (this.scrollListenerState === "resume") {
      this.scrollListenerState = "active";
      return;
    }
    const e = this.el.scrollTop, t = this.el.scrollHeight - this.el.offsetHeight, o = this.emojiCategories.findIndex((r, a) => {
      var n;
      return e < ((n = this.emojiCategories[a + 1]) == null ? void 0 : n.el.offsetTop);
    }), i = {
      changeFocusable: !1,
      performFocus: !1,
      scroll: !1
    };
    e === 0 ? this.categoryTabs.setActiveTab(0, i) : Math.floor(e) === Math.floor(t) || o < 0 ? this.categoryTabs.setActiveTab(this.categories.length - 1, i) : this.categoryTabs.setActiveTab(o, i);
  }
}
const Kt = new u(({ classList: s, classes: e, icon: t, message: o }) => `
<div class="${s}" role="alert">
  <div class="${e.iconContainer}"><i data-size="10x" data-icon="${t}"></i></div>
  <h3 class="${e.title}">${o}</h3>
</div>
`), ge = g("error", "iconContainer", "title");
class se extends c {
  constructor({ message: e, icon: t = "warning", template: o = Kt, className: i }) {
    super({ template: o, classes: ge }), this.message = e, this.icon = t, this.className = i;
  }
  renderSync() {
    const e = [ge.error, this.className].join(" ").trim();
    return super.renderSync({ message: this.message, icon: this.icon, classList: e });
  }
}
const qt = new u(({ classList: s, classes: e, icon: t, i18n: o, message: i }) => `
  <div class="${s}" role="alert">
    <div class="${e.icon}"><i data-size="10x" data-icon="${t}"></i></div>
    <h3 class="${e.title}">${i}</h3>
    <button type="button">${o.get("retry")}</button>
  </div>
`), Gt = g("dataError");
class Wt extends se {
  constructor({ message: e }) {
    super({ message: e, template: qt, className: Gt.dataError });
  }
  initialize() {
    this.uiElements = { retryButton: "button" }, this.uiEvents = [c.childEvent("retryButton", "click", this.onRetry)], super.initialize();
  }
  async onRetry() {
    this.emojiData ? await this.emojiData.delete() : await this.options.dataStore.deleteDatabase(this.options.locale), this.events.emit("reinitialize");
    const e = await re(this.options.locale, this.options.dataStore, this.options.messages, this.options.emojiData, this.emojiData);
    this.viewFactory.setEmojiData(e), this.events.emit("data:ready", e);
  }
}
const C = g(
  "preview",
  "previewEmoji",
  "previewName",
  "tagList",
  "tag"
), _t = new u(({ classes: s, tag: e }) => `
  <li class="${s.tag}">${e}</li>
`), Jt = new u(({ classes: s }) => `
  <div class="${s.preview}">
    <div class="${s.previewEmoji}"></div>
    <div class="${s.previewName}"></div>
    <ul class="${s.tagList}"></ul>
  </div>
`);
class Yt extends c {
  constructor() {
    super({ template: Jt, classes: C });
  }
  initialize() {
    this.uiElements = {
      emoji: c.byClass(C.previewEmoji),
      name: c.byClass(C.previewName),
      tagList: c.byClass(C.tagList)
    }, this.appEvents = {
      "preview:show": this.showPreview,
      "preview:hide": this.hidePreview
    }, super.initialize();
  }
  showPreview(e, t) {
    if (this.ui.emoji.replaceChildren(t), this.ui.name.textContent = e.label, e.tags) {
      this.ui.tagList.style.display = "flex";
      const o = e.tags.map((i) => _t.renderSync({ tag: i, classes: C }));
      this.ui.tagList.replaceChildren(...o);
    }
  }
  hidePreview() {
    this.ui.emoji.replaceChildren(), this.ui.name.textContent = "", this.ui.tagList.replaceChildren();
  }
}
const Qt = new u(({ classes: s, i18n: e }) => `
  <button title="${e.get("search.clear")}" class="${s.clearSearchButton}">
    <i data-icon="xmark"></i>
  </button>
`), Xt = new u(({ classes: s, i18n: e }) => `
<div class="${s.searchContainer}">
  <input class="${s.searchField}" placeholder="${e.get("search")}">
  <span class="${s.searchAccessory}"></span>
</div>
`, { mode: "async" }), j = g(
  "searchContainer",
  "searchField",
  "clearButton",
  "searchAccessory",
  "clearSearchButton",
  "notFound"
);
class Zt extends c {
  constructor({ categories: e, emojiVersion: t }) {
    super({ template: Xt, classes: j }), this.categories = e.filter((o) => o.key !== "recents"), this.emojiVersion = t, this.search = Re(this.search.bind(this), 100);
  }
  initialize() {
    this.uiElements = {
      searchField: c.byClass(j.searchField),
      searchAccessory: c.byClass(j.searchAccessory)
    }, this.uiEvents = [
      c.childEvent("searchField", "keydown", this.onKeyDown),
      c.childEvent("searchField", "input", this.onSearchInput)
    ], super.initialize();
  }
  async render() {
    return await super.render(), this.searchIcon = je("search"), this.notFoundMessage = this.viewFactory.create(se, {
      message: this.i18n.get("search.notFound"),
      className: j.notFound,
      icon: "sad"
    }), this.notFoundMessage.renderSync(), this.errorMessage = this.viewFactory.create(se, { message: this.i18n.get("search.error") }), this.errorMessage.renderSync(), this.clearSearchButton = Qt.render({
      classes: j,
      i18n: this.i18n
    }), this.clearSearchButton.addEventListener("click", (e) => this.onClearSearch(e)), this.searchField = this.ui.searchField, this.showSearchIcon(), this.el;
  }
  showSearchIcon() {
    this.showSearchAccessory(this.searchIcon);
  }
  showClearSearchButton() {
    this.showSearchAccessory(this.clearSearchButton);
  }
  showSearchAccessory(e) {
    this.ui.searchAccessory.replaceChildren(e);
  }
  clear() {
    this.searchField.value = "", this.showSearchIcon();
  }
  focus() {
    this.searchField.focus();
  }
  onClearSearch(e) {
    var t;
    e.stopPropagation(), this.searchField.value = "", (t = this.resultsContainer) == null || t.destroy(), this.resultsContainer = null, this.showSearchIcon(), this.events.emit("content:show"), this.searchField.focus();
  }
  handleResultsKeydown(e) {
    this.resultsContainer && e.key === "Escape" && this.onClearSearch(e);
  }
  onKeyDown(e) {
    var t;
    e.key === "Escape" && this.searchField.value ? this.onClearSearch(e) : (e.key === "Enter" || e.key === "ArrowDown") && this.resultsContainer && (e.preventDefault(), (t = this.resultsContainer.el.querySelector('[tabindex="0"]')) == null || t.focus());
  }
  onSearchInput(e) {
    this.searchField.value ? (this.showClearSearchButton(), this.search()) : this.onClearSearch(e);
  }
  async search() {
    var e;
    if (!!this.searchField.value)
      try {
        const t = await this.emojiData.searchEmojis(
          this.searchField.value,
          this.customEmojis,
          this.emojiVersion,
          this.categories
        );
        if (this.events.emit("preview:hide"), t.length) {
          const o = new Pe();
          this.resultsContainer = this.viewFactory.create(F, {
            emojis: t,
            fullHeight: !0,
            showVariants: !0,
            lazyLoader: o
          }), this.resultsContainer.renderSync(), (e = this.resultsContainer) != null && e.el && (o.observe(this.resultsContainer.el), this.resultsContainer.setActive(!0, { row: 0, offset: 0 }, !1), this.resultsContainer.el.addEventListener("keydown", (i) => this.handleResultsKeydown(i)), this.events.emit("content:show", this.resultsContainer));
        } else
          this.events.emit("content:show", this.notFoundMessage);
      } catch {
        this.events.emit("content:show", this.errorMessage);
      }
  }
}
const es = new u(({ classes: s }) => `
  <div class="${s.variantOverlay}">
    <div class="${s.variantPopup}">
      <div data-view="emojis" data-render="sync"></div>
    </div>
  </div>
`), pe = g(
  "variantOverlay",
  "variantPopup"
), q = {
  easing: "ease-in-out",
  duration: 250,
  fill: "both"
}, ye = {
  opacity: [0, 1]
}, fe = {
  opacity: [0, 1],
  transform: ["scale3d(0.8, 0.8, 0.8)", "scale3d(1, 1, 1)"]
};
class ts extends c {
  constructor({ emoji: e, parent: t }) {
    super({ template: es, classes: pe, parent: t }), this.focusedEmojiIndex = 0, this.focusTrap = new Ue(), this.animateShow = () => Promise.all([
      I(this.el, ye, q, this.options),
      I(this.ui.popup, fe, q, this.options)
    ]), this.emoji = e;
  }
  initialize() {
    this.uiElements = {
      popup: c.byClass(pe.variantPopup)
    }, this.uiEvents = [
      c.uiEvent("click", this.handleClick),
      c.uiEvent("keydown", this.handleKeydown)
    ], super.initialize();
  }
  animateHide() {
    const e = { ...q, direction: "reverse" };
    return Promise.all([
      I(this.el, ye, e, this.options),
      I(this.ui.popup, fe, e, this.options)
    ]);
  }
  async hide() {
    await this.animateHide(), this.events.emit("variantPopup:hide");
  }
  handleKeydown(e) {
    e.key === "Escape" && (this.hide(), e.stopPropagation());
  }
  handleClick(e) {
    this.ui.popup.contains(e.target) || this.hide();
  }
  getEmoji(e) {
    return this.renderedEmojis[e];
  }
  setFocusedEmoji(e) {
    const t = this.getEmoji(this.focusedEmojiIndex);
    t.tabIndex = -1, this.focusedEmojiIndex = e;
    const o = this.getEmoji(this.focusedEmojiIndex);
    o.tabIndex = 0, o.focus();
  }
  destroy() {
    this.emojiContainer.destroy(), this.focusTrap.deactivate(), super.destroy();
  }
  renderSync() {
    const e = {
      ...this.emoji,
      skins: null
    }, t = (this.emoji.skins || []).map((i) => ({
      ...i,
      label: this.emoji.label,
      tags: this.emoji.tags
    })), o = [e, ...t];
    return this.emojiContainer = this.viewFactory.create(F, {
      emojis: o,
      preview: !1
    }), super.renderSync({ emojis: this.emojiContainer }), o.length < this.options.emojisPerRow && this.el.style.setProperty("--emojis-per-row", o.length.toString()), this.el;
  }
  activate() {
    this.emojiContainer.setActive(!0, { row: 0, offset: 0 }, !0), this.focusTrap.activate(this.el);
  }
}
const ss = new u(({ classes: s, i18n: e, category: t, pickerId: o, icon: i }) => `
<li class="${s.categoryTab}">
  <button
    aria-selected="false"
    role="tab"
    class="${s.categoryButton}"
    tabindex="-1"
    title="${e.get(`categories.${t.key}`, t.message || t.key)}"
    type="button"
    data-category="${t.key}"
    id="${o}-category-${t.key}"
  >
    <i data-icon="${i}"></i>
</li>
`), G = g(
  "categoryTab",
  "categoryTabActive",
  "categoryButton"
);
class os extends c {
  constructor({ category: e, icon: t }) {
    super({ template: ss, classes: G }), this.isActive = !1, this.category = e, this.icon = t;
  }
  initialize() {
    this.uiElements = {
      button: c.byClass(G.categoryButton)
    }, this.uiEvents = [
      c.childEvent("button", "click", this.selectCategory),
      c.childEvent("button", "focus", this.selectCategory)
    ], super.initialize();
  }
  renderSync() {
    return super.renderSync({
      category: this.category,
      icon: this.icon
    }), this.ui.button.ariaSelected = "false", this.el;
  }
  setActive(e, t = {}) {
    const { changeFocusable: o, performFocus: i, scroll: r } = {
      changeFocusable: !0,
      performFocus: !0,
      scroll: !0,
      ...t
    };
    this.el.classList.toggle(G.categoryTabActive, e), o && (this.ui.button.tabIndex = e ? 0 : -1, this.ui.button.ariaSelected = e.toString()), e && i && (this.ui.button.focus(), r && this.events.emit("category:select", this.category.key, { scroll: "animate", focus: "button", performFocus: !1 })), this.isActive = e;
  }
  selectCategory() {
    this.isActive || this.events.emit("category:select", this.category.key, { scroll: "animate", focus: "button", performFocus: !0 });
  }
}
const is = new u(({ classes: s }) => `
  <div class="${s.categoryButtonsContainer}">
    <ul role="tablist" class="${s.categoryButtons}">
      <div data-placeholder="tabs"></div>
    </ul>
  </div>
`), rs = g("categoryButtons", "categoryButtonsContainer");
class as extends c {
  constructor({ categories: e }) {
    super({ template: is, classes: rs }), this.activeCategoryIndex = 0, this.categories = e;
  }
  initialize() {
    this.keyBindings = {
      ArrowLeft: this.stepSelectedTab(-1),
      ArrowRight: this.stepSelectedTab(1)
    }, this.uiEvents = [
      c.uiEvent("scroll", this.checkOverflow)
    ], super.initialize();
  }
  checkOverflow() {
    const e = Math.abs(this.el.scrollLeft - (this.el.scrollWidth - this.el.offsetWidth)) > 1, t = this.el.scrollLeft > 0;
    this.el.className = "categoryButtonsContainer", t && e ? this.el.classList.add("has-overflow-both") : t ? this.el.classList.add("has-overflow-left") : e && this.el.classList.add("has-overflow-right");
  }
  renderSync() {
    return this.tabViews = this.categories.map((e) => this.viewFactory.create(os, { category: e, icon: D[e.key] })), super.renderSync({
      tabs: this.tabViews.map((e) => e.renderSync())
    }), this.el;
  }
  get currentCategory() {
    return this.categories[this.activeCategoryIndex];
  }
  get currentTabView() {
    return this.tabViews[this.activeCategoryIndex];
  }
  setActiveTab(e, t = {}) {
    this.checkOverflow();
    const o = this.currentTabView, i = this.tabViews[e];
    o.setActive(!1, t), i.setActive(!0, t), this.activeCategoryIndex = e;
  }
  getTargetCategory(e) {
    return e < 0 ? this.categories.length - 1 : e >= this.categories.length ? 0 : e;
  }
  stepSelectedTab(e) {
    return () => {
      const t = this.activeCategoryIndex + e;
      this.setActiveTab(this.getTargetCategory(t), {
        changeFocusable: !0,
        performFocus: !0
      });
    };
  }
}
const ns = [
  { version: 15, emoji: String.fromCodePoint(129768) },
  { version: 14, emoji: String.fromCodePoint(128733) },
  { version: 13, emoji: String.fromCodePoint(129729) },
  { version: 12, emoji: String.fromCodePoint(129449) },
  { version: 11, emoji: String.fromCodePoint(129463) },
  { version: 5, emoji: String.fromCodePoint(129322) },
  { version: 4, emoji: String.fromCodePoint(9877) },
  { version: 3, emoji: String.fromCodePoint(129314) },
  { version: 2, emoji: String.fromCodePoint(128488) },
  { version: 1, emoji: String.fromCodePoint(128512) }
];
function cs() {
  var e;
  const s = ns.find((t) => ls(t.emoji));
  return (e = s == null ? void 0 : s.version) != null ? e : 1;
}
function ls(s) {
  const e = document.createElement("canvas").getContext("2d");
  if (e)
    return e.textBaseline = "top", e.font = "32px Arial", e.fillText(s, 0, 0), e.getImageData(16, 16, 1, 1).data[0] !== 0;
}
function W(s, e) {
  return Array.from({ length: s }, () => e).join("");
}
function hs({ showHeader: s, classes: e }) {
  return s ? `
    <header class="${e.header}">
      <div data-view="search"></div>
      <div data-view="categoryTabs" data-render="sync"></div>
    </header>
  ` : "";
}
function ds(s) {
  const { classes: e, theme: t, className: o = "" } = s;
  return `
    <div class="picmo-picker ${e.picker} ${t} ${o}">
      ${hs(s)}
      <div class="${e.content}">
        <div data-view="emojiArea"></div>
      </div>
      <div data-view="preview"></div>
    </div>
  `;
}
function ms(s) {
  const { emojiCount: e, classes: t, theme: o, className: i, categoryCount: r } = s, a = ({ showSearch: d, classes: h }) => d ? `
    <div class="${h.searchSkeleton}">
      <div class="${h.searchInput} ${h.placeholder}"></div>
    </div>
  ` : "", n = ({ showCategoryTabs: d, classes: h }) => d ? `
    <div class="${h.categoryTabsSkeleton}">
      ${W(r, `<div class="${h.placeholder} ${h.categoryTab}"></div>`)}
    </div>
  ` : "", l = ({ showHeader: d, classes: h }) => d ? `
    <header class="${h.headerSkeleton}">
      ${a(s)}
      ${n(s)}
    </header>
  ` : "", m = ({ showPreview: d, classes: h }) => d ? `
    <div class="${h.previewSkeleton}">
      <div class="${h.placeholder} ${h.previewEmoji}"></div>
      <div class="${h.placeholder} ${h.previewName}"></div>
      <ul class="${h.tagList}">
        ${W(3, `<li class="${h.placeholder} ${h.tag}"></li>`)}
      </ul>
    </div>
  ` : "";
  return `
    <div class="picmo-picker ${t.skeleton} ${t.picker} ${o} ${i}">
      ${l(s)}
      <div class="${t.contentSkeleton}">
        <div class="${t.placeholder} ${t.categoryName}"></div>
        <div class="${t.emojiGrid}">
          ${W(e, `<div class="${t.placeholder} ${t.emoji}"></div>`)}
        </div>
      </div>
      ${m(s)}
    </div>
  `;
}
const us = new u((s) => s.isLoaded ? ds(s) : ms(s)), T = g(
  "picker",
  "skeleton",
  "placeholder",
  "searchSkeleton",
  "searchInput",
  "categoryTabsSkeleton",
  "headerSkeleton",
  "categoryTab",
  "contentSkeleton",
  "categoryName",
  "emojiGrid",
  "emoji",
  "previewSkeleton",
  "previewEmoji",
  "previewName",
  "tagList",
  "tag",
  "overlay",
  "content",
  "fullHeight",
  "pluginContainer",
  "header"
), R = {
  emojisPerRow: "--emojis-per-row",
  visibleRows: "--row-count",
  emojiSize: "--emoji-size"
};
class gs extends c {
  constructor() {
    super({ template: us, classes: T }), this.pickerReady = !1, this.externalEvents = new St(), this.updaters = {
      styleProperty: (e) => (t) => this.el.style.setProperty(R[e], t.toString()),
      theme: (e) => {
        this.el.classList.remove(this.options.theme), this.el.classList.add(e);
      },
      className: (e) => {
        this.options.className && this.el.classList.remove(this.options.className), this.el.classList.add(e);
      },
      emojisPerRow: this.updateStyleProperty.bind(this, "emojisPerRow"),
      emojiSize: this.updateStyleProperty.bind(this, "emojiSize"),
      visibleRows: this.updateStyleProperty.bind(this, "visibleRows")
    };
  }
  initialize() {
    this.uiElements = {
      pickerContent: c.byClass(T.content),
      header: c.byClass(T.header)
    }, this.uiEvents = [
      c.uiEvent("keydown", this.handleKeyDown)
    ], this.appEvents = {
      error: this.onError,
      reinitialize: this.reinitialize,
      "data:ready": this.onDataReady,
      "content:show": this.showContent,
      "variantPopup:hide": this.hideVariantPopup,
      "emoji:select": this.selectEmoji
    }, super.initialize(), this.options.recentsProvider;
  }
  destroy() {
    var e, t;
    super.destroy(), (e = this.search) == null || e.destroy(), this.emojiArea.destroy(), (t = this.categoryTabs) == null || t.destroy(), this.events.removeAll(), this.externalEvents.removeAll();
  }
  clearRecents() {
    this.options.recentsProvider.clear();
  }
  addEventListener(e, t) {
    this.externalEvents.on(e, t);
  }
  removeEventListener(e, t) {
    this.externalEvents.off(e, t);
  }
  initializePickerView() {
    this.pickerReady && (this.showContent(), this.emojiArea.reset(!1));
  }
  handleKeyDown(e) {
    const t = e.ctrlKey || e.metaKey;
    e.key === "s" && t && this.search && (e.preventDefault(), this.search.focus());
  }
  buildChildViews() {
    return this.options.showPreview && (this.preview = this.viewFactory.create(Yt)), this.options.showSearch && (this.search = this.viewFactory.create(Zt, {
      categories: this.categories,
      emojiVersion: this.emojiVersion
    })), this.options.showCategoryTabs && (this.categoryTabs = this.viewFactory.create(as, {
      categories: this.categories
    })), this.currentView = this.emojiArea = this.viewFactory.create(Ut, {
      categoryTabs: this.categoryTabs,
      categories: this.categories,
      emojiVersion: this.emojiVersion
    }), [this.preview, this.search, this.emojiArea, this.categoryTabs];
  }
  setStyleProperties() {
    this.options.showSearch || this.el.style.setProperty("--search-height-full", "0px"), this.options.showCategoryTabs || (this.el.style.setProperty("--category-tabs-height", "0px"), this.el.style.setProperty("--category-tabs-offset", "0px")), this.options.showPreview || this.el.style.setProperty("--emoji-preview-height-full", "0px"), Object.keys(R).forEach((e) => {
      this.options[e] && this.el.style.setProperty(R[e], this.options[e].toString());
    });
  }
  updateStyleProperty(e, t) {
    this.el.style.setProperty(R[e], t.toString());
  }
  reinitialize() {
    this.renderSync();
  }
  onError(e) {
    const t = this.viewFactory.create(Wt, { message: this.i18n.get("error.load") }), o = this.el.offsetHeight || 375;
    throw this.el.style.height = `${o}px`, this.el.replaceChildren(t.renderSync()), e;
  }
  async onDataReady(e) {
    const t = this.el;
    try {
      e ? this.emojiData = e : await this.emojiDataPromise, this.options.emojiVersion === "auto" ? this.emojiVersion = cs() || parseFloat($e) : this.emojiVersion = this.options.emojiVersion, this.categories = await this.emojiData.getCategories(this.options);
      const [o, i, r, a] = this.buildChildViews();
      await super.render({
        isLoaded: !0,
        search: i,
        categoryTabs: a,
        emojiArea: r,
        preview: o,
        showHeader: Boolean(this.search || this.categoryTabs),
        theme: this.options.theme,
        className: this.options.className
      }), this.el.style.setProperty("--category-count", this.categories.length.toString()), this.pickerReady = !0, t.replaceWith(this.el), this.setStyleProperties(), this.initializePickerView(), this.setInitialFocus(), this.externalEvents.emit("data:ready");
    } catch (o) {
      this.events.emit("error", o);
    }
  }
  renderSync() {
    var t;
    let e = ((t = this.options.categories) == null ? void 0 : t.length) || 10;
    if (this.options.showRecents && (e += 1), super.renderSync({
      isLoaded: !1,
      theme: this.options.theme,
      showSearch: this.options.showSearch,
      showPreview: this.options.showPreview,
      showCategoryTabs: this.options.showCategoryTabs,
      showHeader: this.options.showSearch || this.options.showCategoryTabs,
      emojiCount: this.options.emojisPerRow * this.options.visibleRows,
      categoryCount: e
    }), this.el.style.setProperty("--category-count", e.toString()), !this.options.rootElement)
      throw new Error("Picker must be given a root element via the rootElement option");
    return this.options.rootElement.replaceChildren(this.el), this.setStyleProperties(), this.pickerReady && this.initializePickerView(), this.el;
  }
  getInitialFocusTarget() {
    if (typeof this.options.autoFocus < "u")
      switch (this.options.autoFocus) {
        case "emojis":
          return this.emojiArea.focusableEmoji;
        case "search":
          return this.search;
        case "auto":
          return this.search || this.emojiArea.focusableEmoji;
        default:
          return null;
      }
    if (this.options.autoFocusSearch === !0)
      return console.warn("options.autoFocusSearch is deprecated, please use options.focusTarget instead"), this.search;
  }
  setInitialFocus() {
    var e;
    !this.pickerReady || (e = this.getInitialFocusTarget()) == null || e.focus();
  }
  reset(e = !0) {
    var t;
    this.pickerReady && (this.emojiArea.reset(e), this.showContent(this.emojiArea)), (t = this.search) == null || t.clear(), this.hideVariantPopup();
  }
  showContent(e = this.emojiArea) {
    var t, o;
    e !== this.currentView && (this.currentView !== this.emojiArea && ((t = this.currentView) == null || t.destroy()), this.ui.pickerContent.classList.toggle(T.fullHeight, e !== this.emojiArea), this.ui.pickerContent.replaceChildren(e.el), this.currentView = e, e === this.emojiArea ? (this.emojiArea.reset(), this.categoryTabs && this.ui.header.appendChild(this.categoryTabs.el)) : (o = this.categoryTabs) == null || o.el.remove());
  }
  hideVariantPopup() {
    var e;
    (e = this.variantPopup) == null || e.destroy();
  }
  isPickerClick(e) {
    var r, a;
    const t = e.target, o = this.el.contains(t), i = (a = (r = this.variantPopup) == null ? void 0 : r.el) == null ? void 0 : a.contains(t);
    return o || i;
  }
  async selectEmoji({ emoji: e }) {
    var t, o;
    ((t = e.skins) == null ? void 0 : t.length) && this.options.showVariants && !this.isVariantPopupOpen ? this.showVariantPopup(e) : (await ((o = this.variantPopup) == null ? void 0 : o.animateHide()), this.events.emit("variantPopup:hide"), await this.emitEmoji(e));
  }
  get isVariantPopupOpen() {
    return this.variantPopup && !this.variantPopup.isDestroyed;
  }
  async showVariantPopup(e) {
    const t = document.activeElement;
    this.events.once("variantPopup:hide", () => {
      t == null || t.focus();
    }), this.variantPopup = this.viewFactory.create(ts, { emoji: e, parent: this.el }), this.el.appendChild(this.variantPopup.renderSync()), this.variantPopup.activate();
  }
  async emitEmoji(e) {
    this.externalEvents.emit("emoji:select", await this.renderer.doEmit(e)), this.options.recentsProvider.addOrUpdateRecent(e, this.options.maxRecents), this.events.emit("recent:add", e);
  }
  updateOptions(e) {
    Object.keys(e).forEach((t) => {
      this.updaters[t](e[t]);
    }), Object.assign(this.options, e);
  }
}
class ps {
  constructor({ events: e, i18n: t, renderer: o, emojiData: i, options: r, customEmojis: a = [], pickerId: n }) {
    this.events = e, this.i18n = t, this.renderer = o, this.emojiData = i, this.options = r, this.customEmojis = a, this.pickerId = n;
  }
  setEmojiData(e) {
    this.emojiData = Promise.resolve(e);
  }
  create(e, ...t) {
    const o = new e(...t);
    return o.setPickerId(this.pickerId), o.setEvents(this.events), o.setI18n(this.i18n), o.setRenderer(this.renderer), o.setEmojiData(this.emojiData), o.setOptions(this.options), o.setCustomEmojis(this.customEmojis), o.viewFactory = this, o.initialize(), o;
  }
}
var L;
class ys {
  constructor(e = {}) {
    f(this, L, void 0);
    A(this, L, new Map(Object.entries(e)));
  }
  get(e, t = e) {
    return y(this, L).get(e) || t;
  }
}
L = new WeakMap();
function fs(s, e) {
  e === void 0 && (e = {});
  var t = e.insertAt;
  if (!(!s || typeof document > "u")) {
    var o = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
    i.type = "text/css", t === "top" && o.firstChild ? o.insertBefore(i, o.firstChild) : o.appendChild(i), i.styleSheet ? i.styleSheet.cssText = s : i.appendChild(document.createTextNode(s));
  }
}
function vs() {
  let s = !1;
  return function(t) {
    xt.injectStyles && !s && (fs(t), s = !0);
  };
}
const ws = `.picmo-picker .icon{width:1.25em;height:1em;fill:currentColor}.icon-small{font-size:.8em}.icon-medium{font-size:1em}.icon-large{font-size:1.25em}.icon-2x{font-size:2em}.icon-3x{font-size:3em}.icon-4x{font-size:4em}.icon-5x{font-size:5em}.icon-8x{font-size:8em}.icon-10x{font-size:10em}.light,.auto{color-scheme:light;--accent-color: #4f46e5;--background-color: #f9fafb;--border-color: #cccccc;--category-name-background-color: #f9fafb;--category-name-button-color: #999999;--category-name-text-color: hsl(214, 30%, 50%);--category-tab-active-background-color: rgba(255, 255, 255, .6);--category-tab-active-color: var(--accent-color);--category-tab-color: #666;--category-tab-highlight-background-color: rgba(0, 0, 0, .15);--error-color-dark: hsl(0, 100%, 45%);--error-color: hsl(0, 100%, 40%);--focus-indicator-background-color: hsl(198, 65%, 85%);--focus-indicator-color: #333333;--hover-background-color: #c7d2fe;--placeholder-background-color: #cccccc;--preview-background-color: var(--secondary-background-color);--scrollbar-background-color: var(--background-color);--scrollbar-color: #aaa;--search-background-color: #f9fafb;--search-focus-background-color: #ffffff;--search-icon-color: #999999;--search-placeholder-color: #71717a;--secondary-background-color: #e2e8f0;--secondary-text-color: #666666;--tag-background-color: rgba(162, 190, 245, .3);--text-color: #000000;--variant-popup-background-color: #ffffff}.dark{color-scheme:dark;--accent-color: #A580F9;--background-color: #333333;--border-color: #666666;--category-name-background-color: #333333;--category-name-button-color: #eeeeee;--category-name-text-color: #ffffff;--category-tab-active-background-color: #000000;--category-tab-active-color: var(--accent-color);--category-tab-color: #cccccc;--category-tab-highlight-background-color: #4A4A4A;--error-color-dark: hsl(0, 7%, 3%);--error-color: hsl(0, 30%, 60%);--focus-indicator-background-color: hsl(0, 0%, 50%);--focus-indicator-color: #999999;--hover-background-color: hsla(0, 0%, 40%, .85);--image-placeholder-color: #ffffff;--placeholder-background-color: #666666;--search-background-color: #71717a;--search-focus-background-color: #52525b;--search-icon-color: #cccccc;--search-placeholder-color: #d4d4d8;--secondary-background-color: #000000 ;--secondary-text-color: #999999;--tag-background-color: rgba(162, 190, 245, .3);--text-color: #ffffff;--variant-popup-background-color: #333333}@media (prefers-color-scheme: dark){.auto{color-scheme:dark;--accent-color: #A580F9;--background-color: #333333;--border-color: #666666;--category-name-background-color: #333333;--category-name-button-color: #eeeeee;--category-name-text-color: #ffffff;--category-tab-active-background-color: #000000;--category-tab-active-color: var(--accent-color);--category-tab-color: #cccccc;--category-tab-highlight-background-color: #4A4A4A;--error-color-dark: hsl(0, 7%, 3%);--error-color: hsl(0, 30%, 60%);--focus-indicator-background-color: hsl(0, 0%, 50%);--focus-indicator-color: #999999;--hover-background-color: hsla(0, 0%, 40%, .85);--image-placeholder-color: #ffffff;--placeholder-background-color: #666666;--search-background-color: #71717a;--search-focus-background-color: #52525b;--search-icon-color: #cccccc;--search-placeholder-color: #d4d4d8;--secondary-background-color: #000000 ;--secondary-text-color: #999999;--tag-background-color: rgba(162, 190, 245, .3);--text-color: #ffffff;--variant-popup-background-color: #333333}}.picmo-picker .categoryButtonsContainer{overflow:auto;padding:2px 0;scrollbar-width:thin}.picmo-picker .categoryButtonsContainer.has-overflow-right{mask-image:linear-gradient(270deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 10%);-webkit-mask-image:linear-gradient(270deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 10%)}.picmo-picker .categoryButtonsContainer.has-overflow-left{mask-image:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 10%);-webkit-mask-image:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 10%)}.picmo-picker .categoryButtonsContainer.has-overflow-both{mask-image:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 10%,rgba(255,255,255,1) 90%,rgba(255,255,255,0) 100%);-webkit-mask-image:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 10%,rgba(255,255,255,1) 90%,rgba(255,255,255,0) 100%)}.picmo-picker .categoryButtonsContainer::-webkit-scrollbar{width:8px;height:8px}.picmo-picker .categoryButtonsContainer::-webkit-scrollbar-thumb{background:var(--scrollbar-color);border-radius:1em}.picmo-picker .categoryButtons{display:flex;flex-direction:row;gap:var(--tab-gap);margin:0;padding:0 .5em;align-items:center;height:var(--category-tabs-height);box-sizing:border-box;width:100%;justify-content:space-between;position:relative;list-style-type:none;justify-self:center;max-width:min(23.55rem,calc(var(--category-count, 1) * 2.5rem))}.picmo-picker .categoryButtons .categoryTab{display:flex;align-items:center;transition:all .1s;width:2em}.picmo-picker .categoryButtons .categoryTab.categoryTabActive .categoryButton{color:var(--category-tab-active-color);background:linear-gradient(rgba(255,255,255,.75) 0%,rgba(255,255,255,.75) 100%),linear-gradient(var(--category-tab-active-color) 0%,var(--category-tab-active-color) 100%);border:2px solid var(--category-tab-active-color)}.picmo-picker .categoryButtons .categoryTab.categoryTabActive .categoryButton:hover{background-color:var(--category-tab-active-background-color)}.picmo-picker .categoryButtons .categoryTab button.categoryButton{border-radius:5px;background:transparent;border:2px solid transparent;color:var(--category-tab-color);cursor:pointer;padding:2px;vertical-align:middle;display:flex;align-items:center;justify-content:center;font-size:1.2rem;width:1.6em;height:1.6em;transition:all .1s}.picmo-picker .categoryButtons .categoryTab button.categoryButton:is(img){width:var(--category-tab-size);height:var(--category-tab-size)}.picmo-picker .categoryButtons .categoryTab button.categoryButton:hover{background:var(--category-tab-highlight-background-color)}.dataError [data-icon]{opacity:.8}@keyframes appear{0%{opacity:0}to{opacity:.8}}@keyframes appear-grow{0%{opacity:0;transform:scale(.8)}to{opacity:.8;transform:scale(1)}}.picmo-picker .error{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;color:var(--secondary-text-color)}.picmo-picker .error .iconContainer{opacity:.8;animation:appear-grow .25s cubic-bezier(.175,.885,.32,1.275);--color-primary: var(--error-color);--color-secondary: var(--error-color-dark)}.picmo-picker .error .title{animation:appear .25s;animation-delay:50ms;animation-fill-mode:both}.picmo-picker .error button{padding:8px 16px;cursor:pointer;background:var(--background-color);border:1px solid var(--text-color);border-radius:5px;color:var(--text-color)}.picmo-picker .error button:hover{background:var(--text-color);color:var(--background-color)}.emojiButton{background:transparent;border:none;border-radius:15px;cursor:pointer;display:flex;font-family:var(--emoji-font);font-size:var(--emoji-size);height:100%;justify-content:center;align-items:center;margin:0;overflow:hidden;padding:0;width:100%}.emojiButton:hover{background:var(--hover-background-color)}.emojiButton:focus{border-radius:0;background:var(--focus-indicator-background-color);outline:1px solid var(--focus-indicator-color)}.picmo-picker .emojiArea{height:var(--emoji-area-height);overflow-y:auto;position:relative;scrollbar-color:var(--scrollbar-color) var(--scrollbar-background-color);scrollbar-width:thin}.picmo-picker .emojiArea::-webkit-scrollbar{background:var(--scrollbar-background-color);width:1.1em}.picmo-picker .emojiArea::-webkit-scrollbar-thumb{background:var(--scrollbar-color);border-left:4px solid transparent;border-right:4px solid transparent;background-clip:padding-box;height:1em;border-radius:1em}.picmo-picker .emojiCategory{position:relative}.picmo-picker .emojiCategory .categoryName{font-size:.9em;padding:.5rem;margin:0;background:var(--category-name-background-color);color:var(--category-name-text-color);top:0;z-index:1;display:grid;gap:4px;grid-template-columns:auto 1fr auto;align-items:center;line-height:1;box-sizing:border-box;height:var(--category-name-height);justify-content:flex-start;text-transform:uppercase}.picmo-picker .emojiCategory .categoryName button{background:transparent;border:none;display:flex;align-items:center;cursor:pointer;color:var(--category-name-button-color)}.picmo-picker .emojiCategory .categoryName button:hover{opacity:1}.picmo-picker .emojiCategory .noRecents{color:var(--secondary-text-color);grid-column:1 / span var(--emojis-per-row);font-size:.9em;text-align:center;display:flex;align-items:center;justify-content:center;min-height:calc(var(--emoji-size) * var(--emoji-size-multiplier))}.picmo-picker .emojiCategory .recentEmojis[data-empty=true]{display:none}:is(.picmo-picker .emojiCategory) .recentEmojis[data-empty=false]+div{display:none}.picmo-picker .emojiContainer{display:grid;justify-content:space-between;gap:1px;padding:0 .5em;grid-template-columns:repeat(var(--emojis-per-row),calc(var(--emoji-size) * var(--emoji-size-multiplier)));grid-auto-rows:calc(var(--emoji-size) * var(--emoji-size-multiplier));align-items:center;justify-items:center}.picmo-picker.picker{--border-radius: 5px;--emoji-area-height: calc( (var(--row-count) * var(--emoji-size) * var(--emoji-size-multiplier)) + var(--category-name-height) );--content-height: var(--emoji-area-height);--emojis-per-row: 8;--row-count: 6;--emoji-preview-margin: 4px;--emoji-preview-height: calc(var(--emoji-preview-size) + 1em + 1px);--emoji-preview-height-full: calc(var(--emoji-preview-height) + var(--emoji-preview-margin));--emoji-preview-size: 2.75em;--emoji-size: 2rem;--emoji-size-multiplier: 1.3;--content-margin: 8px;--category-tabs-height:calc(1.5em + 9px);--category-tabs-offset: 8px;--category-tab-size: 1.2rem;--category-name-height: 2rem;--category-name-padding-y: 6px;--search-height: 2em;--search-margin: .5em;--search-margin-bottom: 4px;--search-height-full: calc(var(--search-height) + var(--search-margin) + var(--search-margin-bottom));--overlay-background-color: rgba(0, 0, 0, .8);--emoji-font: "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji";--ui-font: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;--ui-font-size: 16px;--picker-width: calc(var(--emojis-per-row) * var(--emoji-size) * var(--emoji-size-multiplier) + 2.75rem);background:var(--background-color);border-radius:var(--border-radius);border:1px solid var(--border-color);font-family:var(--ui-font);font-size:var(--ui-font-size);overflow:hidden;position:relative;width:var(--picker-width);display:grid;gap:8px}.picmo-picker.picker>*{font-family:var(--ui-font)}.picmo-picker.skeleton{background:var(--background-color);border-radius:var(--border-radius);border:1px solid var(--border-color);font-family:var(--ui-font);width:var(--picker-width);color:var(--secondary-text-color)}.picmo-picker.skeleton *{box-sizing:border-box}.picmo-picker.skeleton .placeholder{background:var(--placeholder-background-color);position:relative;overflow:hidden}.picmo-picker.skeleton .placeholder:after{position:absolute;top:0;right:0;bottom:0;left:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0) 100%);animation:shine 2s infinite;content:""}.picmo-picker.skeleton .headerSkeleton{background-color:var(--secondary-background-color);padding-top:8px;padding-bottom:8px;display:flex;flex-direction:column;overflow:hidden;gap:8px;border-bottom:1px solid var(--border-color);width:var(--picker-width)}.picmo-picker.skeleton .searchSkeleton{padding:0 8px;height:var(--search-height)}.picmo-picker.skeleton .searchSkeleton .searchInput{width:100%;height:28px;border-radius:3px}.picmo-picker.skeleton .categoryTabsSkeleton{height:var(--category-tabs-height);display:flex;flex-direction:row;align-items:center;justify-self:center;width:calc(2rem * var(--category-count, 1))}.picmo-picker.skeleton .categoryTabsSkeleton .categoryTab{width:25px;height:25px;padding:2px;border-radius:5px;margin:.25em}.picmo-picker.skeleton .contentSkeleton{height:var(--content-height);padding-right:8px;opacity:.7}.picmo-picker.skeleton .contentSkeleton .categoryName{width:50%;height:1rem;margin:.5rem;box-sizing:border-box}.picmo-picker.skeleton .contentSkeleton .emojiGrid{display:grid;justify-content:space-between;gap:1px;padding:0 .5em;grid-template-columns:repeat(var(--emojis-per-row),calc(var(--emoji-size) * var(--emoji-size-multiplier)));grid-auto-rows:calc(var(--emoji-size) * var(--emoji-size-multiplier));align-items:center;justify-items:center;width:var(--picker-width)}.picmo-picker.skeleton .contentSkeleton .emojiGrid .emoji{width:var(--emoji-size);height:var(--emoji-size);border-radius:50%}.picmo-picker.skeleton .previewSkeleton{height:var(--emoji-preview-height);border-top:1px solid var(--border-color);display:grid;align-items:center;padding:.5em;gap:6px;grid-template-columns:auto 1fr;grid-template-rows:auto 1fr;grid-template-areas:"emoji name" "emoji tags"}.picmo-picker.skeleton .previewSkeleton .previewEmoji{grid-area:emoji;border-radius:50%;width:var(--emoji-preview-size);height:var(--emoji-preview-size)}.picmo-picker.skeleton .previewSkeleton .previewName{grid-area:name;height:.8em;width:80%}.picmo-picker.skeleton .previewSkeleton .tagList{grid-area:tags;list-style-type:none;display:flex;flex-direction:row;padding:0;margin:0}.picmo-picker.skeleton .previewSkeleton .tagList .tag{border-radius:3px;padding:2px 8px;margin-right:.25em;height:1em;width:20%}.overlay{background:rgba(0,0,0,.75);height:100%;left:0;position:fixed;top:0;width:100%;z-index:1000}.content{position:relative;overflow:hidden;height:var(--content-height)}.content.fullHeight{height:calc(var(--content-height) + var(--category-tabs-height) + var(--category-tabs-offset));overflow-y:auto;scrollbar-color:var(--scrollbar-color) var(--scrollbar-background-color);scrollbar-width:thin}.content.fullHeight::-webkit-scrollbar{background:var(--scrollbar-background-color);width:1.1em}.content.fullHeight::-webkit-scrollbar-thumb{background:var(--scrollbar-color);background-clip:padding-box;height:1em;border-radius:.5em}.pluginContainer{margin:.5em;display:flex;flex-direction:row}.header{background-color:var(--secondary-background-color);padding-top:8px;padding-bottom:8px;display:grid;gap:8px;border-bottom:1px solid var(--border-color)}@media (prefers-reduced-motion: reduce){.placeholder{background:var(--placeholder-background-color);position:relative;overflow:hidden}.placeholder:after{display:none}}.picmo-picker .preview{border-top:1px solid var(--border-color);display:grid;align-items:center;gap:6px;grid-template-columns:auto 1fr;grid-template-rows:auto 1fr;grid-template-areas:"emoji name" "emoji tags";height:var(--emoji-preview-height);box-sizing:border-box;padding:.5em;position:relative;background:var(--preview-background-color)}.picmo-picker .preview .previewEmoji{grid-area:emoji;font-size:var(--emoji-preview-size);font-family:var(--emoji-font);width:1.25em;display:flex;align-items:center;justify-content:center}.picmo-picker .preview .previewName{grid-area:name;color:var(--text-color);font-size:.8em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:500}.picmo-picker .preview .tagList{grid-area:tags;list-style-type:none;display:flex;flex-direction:row;padding:0;margin:0;font-size:.75em;overflow:hidden}.picmo-picker .preview .tag{border-radius:3px;background:var(--tag-background-color);color:var(--text-color);padding:2px 8px;margin-right:.25em;white-space:nowrap}.picmo-picker .preview .tag:last-child{margin-right:0}.picmo-picker .searchContainer{display:flex;height:var(--search-height);box-sizing:border-box;padding:0 8px;position:relative}.picmo-picker .searchContainer .searchField{background:var(--search-background-color);border-radius:3px;border:none;box-sizing:border-box;color:var(--text-color);font-size:.9em;outline:none;padding:.5em 2.25em .5em .5em;width:100%}.picmo-picker .searchContainer .searchField:focus{background:var(--search-focus-background-color)}.picmo-picker .searchContainer .searchField::placeholder{color:var(--search-placeholder-color)}.picmo-picker .searchContainer .searchAccessory{color:var(--search-icon-color);height:100%;position:absolute;right:1em;top:0;width:1.25rem;display:flex;align-items:center}.picmo-picker .searchContainer .searchAccessory svg{fill:var(--search-icon-color)}.picmo-picker .searchContainer .clearButton{border:0;color:var(--search-icon-color);background:transparent;cursor:pointer}.picmo-picker .searchContainer .clearSearchButton{cursor:pointer;border:none;background:transparent;color:var(--search-icon-color);font-size:1em;width:100%;height:100%;display:flex;align-items:center;padding:0}.picmo-picker .searchContainer .notFound [data-icon]{fill:#f3e265}.picmo-picker .variantOverlay{background:var(--overlay-background-color);border-radius:5px;display:flex;flex-direction:column;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%;z-index:1}.picmo-picker .variantOverlay .variantPopup{background:var(--variant-popup-background-color);border-radius:5px;margin:.5em;padding:.5em;text-align:center;user-select:none;display:flex;align-items:center;justify-content:center}.customEmoji{width:1em;height:1em}@keyframes shine{to{transform:translate(100%)}}.picmo-picker .imagePlaceholder{width:2rem;height:2rem;border-radius:50%}.placeholder{background:#DDDBDD;position:relative}.placeholder:after{position:absolute;top:0;right:0;bottom:0;left:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0) 100%);animation:shine 2s infinite;content:""}
`;
function bs(s) {
  return re(s.locale, s.dataStore, s.messages, s.emojiData);
}
let Cs = 0;
function js() {
  return `picmo-${Date.now()}-${Cs++}`;
}
const ks = vs();
function Ls(s) {
  ks(ws);
  const e = kt(s), t = ((e == null ? void 0 : e.custom) || []).map((l) => ({
    ...l,
    custom: !0,
    tags: ["custom", ...l.tags || []]
  })), o = new Et(), i = bs(e), r = new ys(e.i18n);
  i.then((l) => {
    o.emit("data:ready", l);
  }).catch((l) => {
    o.emit("error", l);
  });
  const n = new ps({
    events: o,
    i18n: r,
    customEmojis: t,
    renderer: e.renderer,
    options: e,
    emojiData: i,
    pickerId: js()
  }).create(gs);
  return n.renderSync(), n;
}
const _ = {};
function xs(s) {
  return _[s] || (_[s] = new Es(s)), _[s];
}
xs.deleteDatabase = (s) => {
};
class Es extends ke {
  open() {
    return Promise.resolve();
  }
  delete() {
    return Promise.resolve();
  }
  close() {
  }
  isPopulated() {
    return Promise.resolve(!1);
  }
  getEmojiCount() {
    return Promise.resolve(this.emojis.length);
  }
  getEtags() {
    return Promise.resolve({ foo: "bar" });
  }
  getHash() {
    return Promise.resolve("");
  }
  populate(e) {
    return this.categories = e.groups, this.emojis = e.emojis, Promise.resolve();
  }
  getCategories(e) {
    var o;
    let t = this.categories.filter((i) => i.key !== "component");
    if (e.showRecents && t.unshift({ key: "recents", order: -1 }), (o = e.custom) != null && o.length && t.push({ key: "custom", order: 10 }), e.categories) {
      const i = e.categories;
      t = t.filter((r) => i.includes(r.key)), t.sort((r, a) => i.indexOf(r.key) - i.indexOf(a.key));
    } else
      t.sort((i, r) => i.order - r.order);
    return Promise.resolve(t);
  }
  getEmojis(e, t) {
    const o = this.emojis.filter((i) => i.group === e.order).filter((i) => i.version <= t).sort((i, r) => i.order != null && r.order != null ? i.order - r.order : 0).map(x);
    return Promise.resolve(B(o, t));
  }
  searchEmojis(e, t, o, i) {
    const r = this.emojis.filter((l) => M(l, e, i)).map(x), a = t.filter((l) => M(l, e, i)), n = [
      ...B(r, o),
      ...a
    ];
    return Promise.resolve(n);
  }
  setMeta(e) {
    this.meta = e;
  }
}
class Fs extends (/* unused pure expression or super */ null && (Ee)) {
  constructor() {
    super(sessionStorage);
  }
}
async function As(s, e, t, o) {
  (await re(s, e, t, o)).close();
}


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@picmo+popup-picker@5.7.0_picmo@5.7.0/node_modules/@picmo/popup-picker/dist/index.js

function dist_V(t) {
  return t.split("-")[0];
}
function N(t) {
  return t.split("-")[1];
}
function dist_K(t) {
  return ["top", "bottom"].includes(dist_V(t)) ? "x" : "y";
}
function dist_at(t) {
  return t === "y" ? "height" : "width";
}
function dist_tt(t, e, n) {
  let {
    reference: i,
    floating: o
  } = t;
  const c = i.x + i.width / 2 - o.width / 2, r = i.y + i.height / 2 - o.height / 2, s = dist_K(e), l = dist_at(s), a = i[l] / 2 - o[l] / 2, d = dist_V(e), f = s === "x";
  let u;
  switch (d) {
    case "top":
      u = {
        x: c,
        y: i.y - o.height
      };
      break;
    case "bottom":
      u = {
        x: c,
        y: i.y + i.height
      };
      break;
    case "right":
      u = {
        x: i.x + i.width,
        y: r
      };
      break;
    case "left":
      u = {
        x: i.x - o.width,
        y: r
      };
      break;
    default:
      u = {
        x: i.x,
        y: i.y
      };
  }
  switch (N(e)) {
    case "start":
      u[s] -= a * (n && f ? -1 : 1);
      break;
    case "end":
      u[s] += a * (n && f ? -1 : 1);
      break;
  }
  return u;
}
const dist_Pt = async (t, e, n) => {
  const {
    placement: i = "bottom",
    strategy: o = "absolute",
    middleware: c = [],
    platform: r
  } = n, s = await (r.isRTL == null ? void 0 : r.isRTL(e));
  let l = await r.getElementRects({
    reference: t,
    floating: e,
    strategy: o
  }), {
    x: a,
    y: d
  } = dist_tt(l, i, s), f = i, u = {}, p = 0;
  for (let m = 0; m < c.length; m++) {
    const {
      name: h,
      fn: w
    } = c[m], {
      x: y,
      y: g,
      data: v,
      reset: x
    } = await w({
      x: a,
      y: d,
      initialPlacement: i,
      placement: f,
      strategy: o,
      middlewareData: u,
      rects: l,
      platform: r,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (a = y != null ? y : a, d = g != null ? g : d, u = {
      ...u,
      [h]: {
        ...u[h],
        ...v
      }
    }, x && p <= 50) {
      p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await r.getElementRects({
        reference: t,
        floating: e,
        strategy: o
      }) : x.rects), {
        x: a,
        y: d
      } = dist_tt(l, f, s)), m = -1;
      continue;
    }
  }
  return {
    x: a,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: u
  };
};
function dist_At(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function dist_Lt(t) {
  return typeof t != "number" ? dist_At(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function dist_I(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
async function dist_Q(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: i,
    y: o,
    platform: c,
    rects: r,
    elements: s,
    strategy: l
  } = t, {
    boundary: a = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: u = !1,
    padding: p = 0
  } = e, m = dist_Lt(p), w = s[u ? f === "floating" ? "reference" : "floating" : f], y = dist_I(await c.getClippingRect({
    element: (n = await (c.isElement == null ? void 0 : c.isElement(w))) == null || n ? w : w.contextElement || await (c.getDocumentElement == null ? void 0 : c.getDocumentElement(s.floating)),
    boundary: a,
    rootBoundary: d,
    strategy: l
  })), g = dist_I(c.convertOffsetParentRelativeRectToViewportRelativeRect ? await c.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: f === "floating" ? {
      ...r.floating,
      x: i,
      y: o
    } : r.reference,
    offsetParent: await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(s.floating)),
    strategy: l
  }) : r[f]);
  return {
    top: y.top - g.top + m.top,
    bottom: g.bottom - y.bottom + m.bottom,
    left: y.left - g.left + m.left,
    right: g.right - y.right + m.right
  };
}
const dist_Ot = Math.min, dist_Rt = Math.max;
function dist_et(t, e, n) {
  return dist_Rt(t, dist_Ot(e, n));
}
const dist_kt = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function dist_z(t) {
  return t.replace(/left|right|bottom|top/g, (e) => dist_kt[e]);
}
function dist_ft(t, e, n) {
  n === void 0 && (n = !1);
  const i = N(t), o = dist_K(t), c = dist_at(o);
  let r = o === "x" ? i === (n ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return e.reference[c] > e.floating[c] && (r = dist_z(r)), {
    main: r,
    cross: dist_z(r)
  };
}
const dist_Tt = {
  start: "end",
  end: "start"
};
function dist_G(t) {
  return t.replace(/start|end/g, (e) => dist_Tt[e]);
}
const dist_Bt = ["top", "right", "bottom", "left"], dist_St = /* @__PURE__ */ dist_Bt.reduce((t, e) => t.concat(e, e + "-start", e + "-end"), []);
function dist_Dt(t, e, n) {
  return (t ? [...n.filter((o) => N(o) === t), ...n.filter((o) => N(o) !== t)] : n.filter((o) => dist_V(o) === o)).filter((o) => t ? N(o) === t || (e ? dist_G(o) !== o : !1) : !0);
}
const dist_Vt = function(t) {
  return t === void 0 && (t = {}), {
    name: "autoPlacement",
    options: t,
    async fn(e) {
      var n, i, o, c, r;
      const {
        x: s,
        y: l,
        rects: a,
        middlewareData: d,
        placement: f,
        platform: u,
        elements: p
      } = e, {
        alignment: m = null,
        allowedPlacements: h = dist_St,
        autoAlignment: w = !0,
        ...y
      } = t, g = dist_Dt(m, w, h), v = await dist_Q(e, y), x = (n = (i = d.autoPlacement) == null ? void 0 : i.index) != null ? n : 0, b = g[x];
      if (b == null)
        return {};
      const {
        main: H,
        cross: j
      } = dist_ft(b, a, await (u.isRTL == null ? void 0 : u.isRTL(p.floating)));
      if (f !== b)
        return {
          x: s,
          y: l,
          reset: {
            placement: g[0]
          }
        };
      const _ = [v[dist_V(b)], v[H], v[j]], E = [...(o = (c = d.autoPlacement) == null ? void 0 : c.overflows) != null ? o : [], {
        placement: b,
        overflows: _
      }], B = g[x + 1];
      if (B)
        return {
          data: {
            index: x + 1,
            overflows: E
          },
          reset: {
            placement: B
          }
        };
      const S = E.slice().sort((A, W) => A.overflows[0] - W.overflows[0]), $ = (r = S.find((A) => {
        let {
          overflows: W
        } = A;
        return W.every((yt) => yt <= 0);
      })) == null ? void 0 : r.placement, D = $ != null ? $ : S[0].placement;
      return D !== f ? {
        data: {
          index: x + 1,
          overflows: E
        },
        reset: {
          placement: D
        }
      } : {};
    }
  };
};
function dist_Nt(t) {
  const e = dist_z(t);
  return [dist_G(t), e, dist_G(e)];
}
const dist_Ft = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n;
      const {
        placement: i,
        middlewareData: o,
        rects: c,
        initialPlacement: r,
        platform: s,
        elements: l
      } = e, {
        mainAxis: a = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: u = "bestFit",
        flipAlignment: p = !0,
        ...m
      } = t, h = dist_V(i), y = f || (h === r || !p ? [dist_z(r)] : dist_Nt(r)), g = [r, ...y], v = await dist_Q(e, m), x = [];
      let b = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (a && x.push(v[h]), d) {
        const {
          main: E,
          cross: B
        } = dist_ft(i, c, await (s.isRTL == null ? void 0 : s.isRTL(l.floating)));
        x.push(v[E], v[B]);
      }
      if (b = [...b, {
        placement: i,
        overflows: x
      }], !x.every((E) => E <= 0)) {
        var H, j;
        const E = ((H = (j = o.flip) == null ? void 0 : j.index) != null ? H : 0) + 1, B = g[E];
        if (B)
          return {
            data: {
              index: E,
              overflows: b
            },
            reset: {
              placement: B
            }
          };
        let S = "bottom";
        switch (u) {
          case "bestFit": {
            var _;
            const $ = (_ = b.map((D) => [D, D.overflows.filter((A) => A > 0).reduce((A, W) => A + W, 0)]).sort((D, A) => D[1] - A[1])[0]) == null ? void 0 : _[0].placement;
            $ && (S = $);
            break;
          }
          case "initialPlacement":
            S = r;
            break;
        }
        if (i !== S)
          return {
            reset: {
              placement: S
            }
          };
      }
      return {};
    }
  };
};
async function dist_$t(t, e) {
  const {
    placement: n,
    platform: i,
    elements: o
  } = t, c = await (i.isRTL == null ? void 0 : i.isRTL(o.floating)), r = dist_V(n), s = N(n), l = dist_K(n) === "x", a = ["left", "top"].includes(r) ? -1 : 1, d = c && l ? -1 : 1, f = typeof e == "function" ? e(t) : e;
  let {
    mainAxis: u,
    crossAxis: p,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), l ? {
    x: p * d,
    y: u * a
  } : {
    x: u * a,
    y: p * d
  };
}
const dist_nt = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: i
      } = e, o = await dist_$t(e, t);
      return {
        x: n + o.x,
        y: i + o.y,
        data: o
      };
    }
  };
};
function dist_Wt(t) {
  return t === "x" ? "y" : "x";
}
const dist_ot = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: i,
        placement: o
      } = e, {
        mainAxis: c = !0,
        crossAxis: r = !1,
        limiter: s = {
          fn: (w) => {
            let {
              x: y,
              y: g
            } = w;
            return {
              x: y,
              y: g
            };
          }
        },
        ...l
      } = t, a = {
        x: n,
        y: i
      }, d = await dist_Q(e, l), f = dist_K(dist_V(o)), u = dist_Wt(f);
      let p = a[f], m = a[u];
      if (c) {
        const w = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", g = p + d[w], v = p - d[y];
        p = dist_et(g, p, v);
      }
      if (r) {
        const w = u === "y" ? "top" : "left", y = u === "y" ? "bottom" : "right", g = m + d[w], v = m - d[y];
        m = dist_et(g, m, v);
      }
      const h = s.fn({
        ...e,
        [f]: p,
        [u]: m
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - i
        }
      };
    }
  };
};
function dist_ut(t) {
  return t && t.document && t.location && t.alert && t.setInterval;
}
function dist_R(t) {
  if (t == null)
    return window;
  if (!dist_ut(t)) {
    const e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function dist_C(t) {
  return dist_R(t).getComputedStyle(t);
}
function dist_L(t) {
  return dist_ut(t) ? "" : t ? (t.nodeName || "").toLowerCase() : "";
}
function dist_dt() {
  const t = navigator.userAgentData;
  return t != null && t.brands ? t.brands.map((e) => e.brand + "/" + e.version).join(" ") : navigator.userAgent;
}
function dist_P(t) {
  return t instanceof dist_R(t).HTMLElement;
}
function dist_k(t) {
  return t instanceof dist_R(t).Element;
}
function dist_Mt(t) {
  return t instanceof dist_R(t).Node;
}
function dist_F(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  const e = dist_R(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function dist_U(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: i
  } = dist_C(t);
  return /auto|scroll|overlay|hidden/.test(e + i + n);
}
function dist_Ht(t) {
  return ["table", "td", "th"].includes(dist_L(t));
}
function dist_ht(t) {
  const e = /firefox/i.test(dist_dt()), n = dist_C(t);
  return n.transform !== "none" || n.perspective !== "none" || n.contain === "paint" || ["transform", "perspective"].includes(n.willChange) || e && n.willChange === "filter" || e && (n.filter ? n.filter !== "none" : !1);
}
function dist_pt() {
  return !/^((?!chrome|android).)*safari/i.test(dist_dt());
}
const dist_it = Math.min, dist_M = Math.max, dist_X = Math.round;
function dist_O(t, e, n) {
  var i, o, c, r;
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const s = t.getBoundingClientRect();
  let l = 1, a = 1;
  e && dist_P(t) && (l = t.offsetWidth > 0 && dist_X(s.width) / t.offsetWidth || 1, a = t.offsetHeight > 0 && dist_X(s.height) / t.offsetHeight || 1);
  const d = dist_k(t) ? dist_R(t) : window, f = !dist_pt() && n, u = (s.left + (f && (i = (o = d.visualViewport) == null ? void 0 : o.offsetLeft) != null ? i : 0)) / l, p = (s.top + (f && (c = (r = d.visualViewport) == null ? void 0 : r.offsetTop) != null ? c : 0)) / a, m = s.width / l, h = s.height / a;
  return {
    width: m,
    height: h,
    top: p,
    right: u + m,
    bottom: p + h,
    left: u,
    x: u,
    y: p
  };
}
function dist_T(t) {
  return ((dist_Mt(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function dist_q(t) {
  return dist_k(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function dist_mt(t) {
  return dist_O(dist_T(t)).left + dist_q(t).scrollLeft;
}
function dist_jt(t) {
  const e = dist_O(t);
  return dist_X(e.width) !== t.offsetWidth || dist_X(e.height) !== t.offsetHeight;
}
function dist_t(t, e, n) {
  const i = dist_P(e), o = dist_T(e), c = dist_O(
    t,
    i && dist_jt(e),
    n === "fixed"
  );
  let r = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = {
    x: 0,
    y: 0
  };
  if (i || !i && n !== "fixed")
    if ((dist_L(e) !== "body" || dist_U(o)) && (r = dist_q(e)), dist_P(e)) {
      const l = dist_O(e, !0);
      s.x = l.x + e.clientLeft, s.y = l.y + e.clientTop;
    } else
      o && (s.x = dist_mt(o));
  return {
    x: c.left + r.scrollLeft - s.x,
    y: c.top + r.scrollTop - s.y,
    width: c.width,
    height: c.height
  };
}
function dist_gt(t) {
  return dist_L(t) === "html" ? t : t.assignedSlot || t.parentNode || (dist_F(t) ? t.host : null) || dist_T(t);
}
function dist_st(t) {
  return !dist_P(t) || dist_C(t).position === "fixed" ? null : dist_It(t);
}
function dist_It(t) {
  let {
    offsetParent: e
  } = t, n = t, i = !1;
  for (; n && n !== e; ) {
    const {
      assignedSlot: o
    } = n;
    if (o) {
      let c = o.offsetParent;
      if (dist_C(o).display === "contents") {
        const r = o.hasAttribute("style"), s = o.style.display;
        o.style.display = dist_C(n).display, c = o.offsetParent, o.style.display = s, r || o.removeAttribute("style");
      }
      n = o, e !== c && (e = c, i = !0);
    } else if (dist_F(n) && n.host && i)
      break;
    n = dist_F(n) && n.host || n.parentNode;
  }
  return e;
}
function dist_zt(t) {
  let e = dist_gt(t);
  for (dist_F(e) && (e = e.host); dist_P(e) && !["html", "body"].includes(dist_L(e)); ) {
    if (dist_ht(e))
      return e;
    {
      const n = e.parentNode;
      e = dist_F(n) ? n.host : n;
    }
  }
  return null;
}
function dist_J(t) {
  const e = dist_R(t);
  let n = dist_st(t);
  for (; n && dist_Ht(n) && dist_C(n).position === "static"; )
    n = dist_st(n);
  return n && (dist_L(n) === "html" || dist_L(n) === "body" && dist_C(n).position === "static" && !dist_ht(n)) ? e : n || dist_zt(t) || e;
}
function dist_rt(t) {
  if (dist_P(t))
    return {
      width: t.offsetWidth,
      height: t.offsetHeight
    };
  const e = dist_O(t);
  return {
    width: e.width,
    height: e.height
  };
}
function dist_Xt(t) {
  let {
    rect: e,
    offsetParent: n,
    strategy: i
  } = t;
  const o = dist_P(n), c = dist_T(n);
  if (n === c)
    return e;
  let r = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = {
    x: 0,
    y: 0
  };
  if ((o || !o && i !== "fixed") && ((dist_L(n) !== "body" || dist_U(c)) && (r = dist_q(n)), dist_P(n))) {
    const l = dist_O(n, !0);
    s.x = l.x + n.clientLeft, s.y = l.y + n.clientTop;
  }
  return {
    ...e,
    x: e.x - r.scrollLeft + s.x,
    y: e.y - r.scrollTop + s.y
  };
}
function dist_Yt(t, e) {
  const n = dist_R(t), i = dist_T(t), o = n.visualViewport;
  let c = i.clientWidth, r = i.clientHeight, s = 0, l = 0;
  if (o) {
    c = o.width, r = o.height;
    const a = dist_pt();
    (a || !a && e === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: c,
    height: r,
    x: s,
    y: l
  };
}
function dist_Kt(t) {
  var e;
  const n = dist_T(t), i = dist_q(t), o = (e = t.ownerDocument) == null ? void 0 : e.body, c = dist_M(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), r = dist_M(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0);
  let s = -i.scrollLeft + dist_mt(t);
  const l = -i.scrollTop;
  return dist_C(o || n).direction === "rtl" && (s += dist_M(n.clientWidth, o ? o.clientWidth : 0) - c), {
    width: c,
    height: r,
    x: s,
    y: l
  };
}
function dist_wt(t) {
  const e = dist_gt(t);
  return ["html", "body", "#document"].includes(dist_L(e)) ? t.ownerDocument.body : dist_P(e) && dist_U(e) ? e : dist_wt(e);
}
function dist_Y(t, e) {
  var n;
  e === void 0 && (e = []);
  const i = dist_wt(t), o = i === ((n = t.ownerDocument) == null ? void 0 : n.body), c = dist_R(i), r = o ? [c].concat(c.visualViewport || [], dist_U(i) ? i : []) : i, s = e.concat(r);
  return o ? s : s.concat(dist_Y(r));
}
function dist_Ut(t, e) {
  const n = e.getRootNode == null ? void 0 : e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && dist_F(n)) {
    let i = e;
    do {
      if (i && t === i)
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function dist_qt(t, e) {
  const n = dist_O(t, !1, e === "fixed"), i = n.top + t.clientTop, o = n.left + t.clientLeft;
  return {
    top: i,
    left: o,
    x: o,
    y: i,
    right: o + t.clientWidth,
    bottom: i + t.clientHeight,
    width: t.clientWidth,
    height: t.clientHeight
  };
}
function dist_ct(t, e, n) {
  return e === "viewport" ? dist_I(dist_Yt(t, n)) : dist_k(e) ? dist_qt(e, n) : dist_I(dist_Kt(dist_T(t)));
}
function dist_Gt(t) {
  const e = dist_Y(t), i = ["absolute", "fixed"].includes(dist_C(t).position) && dist_P(t) ? dist_J(t) : t;
  return dist_k(i) ? e.filter((o) => dist_k(o) && dist_Ut(o, i) && dist_L(o) !== "body") : [];
}
function dist_Jt(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: i,
    strategy: o
  } = t;
  const r = [...n === "clippingAncestors" ? dist_Gt(e) : [].concat(n), i], s = r[0], l = r.reduce((a, d) => {
    const f = dist_ct(e, d, o);
    return a.top = dist_M(f.top, a.top), a.right = dist_it(f.right, a.right), a.bottom = dist_it(f.bottom, a.bottom), a.left = dist_M(f.left, a.left), a;
  }, dist_ct(e, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
const dist_Qt = {
  getClippingRect: dist_Jt,
  convertOffsetParentRelativeRectToViewportRelativeRect: dist_Xt,
  isElement: dist_k,
  getDimensions: dist_rt,
  getOffsetParent: dist_J,
  getDocumentElement: dist_T,
  getElementRects: (t) => {
    let {
      reference: e,
      floating: n,
      strategy: i
    } = t;
    return {
      reference: dist_t(e, dist_J(n), i),
      floating: {
        ...dist_rt(n),
        x: 0,
        y: 0
      }
    };
  },
  getClientRects: (t) => Array.from(t.getClientRects()),
  isRTL: (t) => dist_C(t).direction === "rtl"
};
function dist_Zt(t, e, n, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: c = !0,
    elementResize: r = !0,
    animationFrame: s = !1
  } = i, l = o && !s, a = c && !s, d = l || a ? [...dist_k(t) ? dist_Y(t) : [], ...dist_Y(e)] : [];
  d.forEach((h) => {
    l && h.addEventListener("scroll", n, {
      passive: !0
    }), a && h.addEventListener("resize", n);
  });
  let f = null;
  if (r) {
    let h = !0;
    f = new ResizeObserver(() => {
      h || n(), h = !1;
    }), dist_k(t) && !s && f.observe(t), f.observe(e);
  }
  let u, p = s ? dist_O(t) : null;
  s && m();
  function m() {
    const h = dist_O(t);
    p && (h.x !== p.x || h.y !== p.y || h.width !== p.width || h.height !== p.height) && n(), p = h, u = requestAnimationFrame(m);
  }
  return n(), () => {
    var h;
    d.forEach((w) => {
      l && w.removeEventListener("scroll", n), a && w.removeEventListener("resize", n);
    }), (h = f) == null || h.disconnect(), f = null, s && cancelAnimationFrame(u);
  };
}
const dist_te = (t, e, n) => dist_Pt(t, e, {
  platform: dist_Qt,
  ...n
});
async function dist_ee(t, e, n, i) {
  if (!i)
    throw new Error("Must provide a positioning option");
  return await (typeof i == "string" ? dist_ne(t, e, n, i) : dist_oe(e, i));
}
async function dist_ne(t, e, n, i) {
  if (!n)
    throw new Error("Reference element is required for relative positioning");
  let o;
  return i === "auto" ? o = {
    middleware: [
      dist_Vt(),
      dist_ot(),
      dist_nt({ mainAxis: 5, crossAxis: 12 })
    ]
  } : o = {
    placement: i,
    middleware: [
      dist_Ft(),
      dist_ot(),
      dist_nt(5)
    ]
  }, dist_Zt(n, e, async () => {
    if ((!n.isConnected || !n.offsetParent) && dist_ie(t))
      return;
    const { x: c, y: r } = await dist_te(n, e, o);
    Object.assign(e.style, {
      position: "absolute",
      left: `${c}px`,
      top: `${r}px`
    });
  });
}
function dist_oe(t, e) {
  return t.style.position = "fixed", Object.entries(e).forEach(([n, i]) => {
    t.style[n] = i;
  }), () => {
  };
}
function dist_ie(t) {
  switch (t.options.onPositionLost) {
    case "close":
      return t.close(), !0;
    case "destroy":
      return t.destroy(), !0;
    case "hold":
      return !0;
  }
}
const dist_se = {
  hideOnClickOutside: !0,
  hideOnEmojiSelect: !0,
  hideOnEscape: !0,
  position: "auto",
  showCloseButton: !0,
  onPositionLost: "none"
};
function dist_re(t = {}) {
  return {
    ...dist_se,
    rootElement: document.body,
    ...t
  };
}
const ce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"/></svg>', dist_lt = {
  popupContainer: "popupContainer",
  closeButton: "closeButton"
};
class dist_le {
  constructor(e, n) {
    this.isOpen = !1, this.externalEvents = new ae(), this.options = { ...dist_re(n), ...kt(e) }, this.popupEl = document.createElement("div"), this.popupEl.classList.add(dist_lt.popupContainer), this.popupEl.classList.add(this.options.theme), n.className && this.popupEl.classList.add(n.className), this.options.showCloseButton && (this.closeButton = document.createElement("button"), this.closeButton.type = "button", this.closeButton.classList.add(dist_lt.closeButton), this.closeButton.innerHTML = ce, this.closeButton.addEventListener("click", () => {
      this.close();
    }), this.popupEl.appendChild(this.closeButton));
    const i = document.createElement("div");
    this.popupEl.appendChild(i), this.picker = Ls({ ...this.options, rootElement: i }), this.focusTrap = new Ue(), this.picker.addEventListener("data:ready", () => {
      this.focusTrap.activate(this.picker.el), this.picker.setInitialFocus();
    }), this.options.hideOnEmojiSelect && this.picker.addEventListener("emoji:select", () => {
      var o;
      this.close(), (o = this.triggerElement) == null || o.focus();
    }), this.options.hideOnClickOutside && (this.onDocumentClick = this.onDocumentClick.bind(this), document.addEventListener("click", this.onDocumentClick)), this.options.hideOnEscape && (this.handleKeydown = this.handleKeydown.bind(this), this.popupEl.addEventListener("keydown", this.handleKeydown)), this.referenceElement = this.options.referenceElement, this.triggerElement = this.options.triggerElement;
  }
  addEventListener(e, n) {
    this.externalEvents.on(e, n), this.picker.addEventListener(e, n);
  }
  removeEventListener(e, n) {
    this.externalEvents.off(e, n), this.picker.removeEventListener(e, n);
  }
  handleKeydown(e) {
    var n;
    e.key === "Escape" && (this.close(), (n = this.triggerElement) == null || n.focus());
  }
  async destroy() {
    this.isOpen && await this.close(), document.removeEventListener("click", this.onDocumentClick), this.picker.destroy(), this.externalEvents.removeAll();
  }
  toggle(e) {
    return this.isOpen ? this.close() : this.open(e);
  }
  async open({ triggerElement: e, referenceElement: n } = {}) {
    this.isOpen || (e && (this.triggerElement = e), n && (this.referenceElement = n), await this.initiateOpenStateChange(!0), this.popupEl.style.opacity = "0", this.options.rootElement.appendChild(this.popupEl), await this.setPosition(), this.picker.reset(!1), await this.animatePopup(!0), await this.animateCloseButton(!0), this.picker.setInitialFocus(), this.externalEvents.emit("picker:open"));
  }
  async close() {
    var e;
    !this.isOpen || (await this.initiateOpenStateChange(!1), await this.animateCloseButton(!1), await this.animatePopup(!1), this.popupEl.remove(), this.picker.reset(), (e = this.positionCleanup) == null || e.call(this), this.focusTrap.deactivate(), this.externalEvents.emit("picker:close"));
  }
  getRunningAnimations() {
    return this.picker.el.getAnimations().filter((e) => e.playState === "running");
  }
  async setPosition() {
    var e;
    (e = this.positionCleanup) == null || e.call(this), this.positionCleanup = await dist_ee(
      this,
      this.popupEl,
      this.referenceElement,
      this.options.position
    );
  }
  awaitPendingAnimations() {
    return Promise.all(this.getRunningAnimations().map((e) => e.finished));
  }
  onDocumentClick(e) {
    var o;
    const n = e.target, i = (o = this.triggerElement) == null ? void 0 : o.contains(n);
    this.isOpen && !this.picker.isPickerClick(e) && !i && this.close();
  }
  animatePopup(e) {
    return I(
      this.popupEl,
      {
        opacity: [0, 1],
        transform: ["scale(0.9)", "scale(1)"]
      },
      {
        duration: 150,
        id: e ? "show-picker" : "hide-picker",
        easing: "ease-in-out",
        direction: e ? "normal" : "reverse",
        fill: "both"
      },
      this.options
    );
  }
  animateCloseButton(e) {
    if (this.closeButton)
      return I(
        this.closeButton,
        {
          opacity: [0, 1]
        },
        {
          duration: 25,
          id: e ? "show-close" : "hide-close",
          easing: "ease-in-out",
          direction: e ? "normal" : "reverse",
          fill: "both"
        },
        this.options
      );
  }
  async initiateOpenStateChange(e) {
    this.isOpen = e, await this.awaitPendingAnimations();
  }
}
const dist_ae = `.popupContainer{display:flex;flex-direction:column;position:absolute}.popupContainer .closeButton{position:absolute;opacity:0;background:transparent;border:none;z-index:1;right:0;top:0;cursor:pointer;padding:4px;align-self:flex-end;transform:translate(50%,-50%);background:#999999;width:1.5rem;height:1.5rem;display:flex;align-items:center;justify-content:center;border-radius:50%}.popupContainer .closeButton:hover{background:var(--accent-color)}.popupContainer .closeButton svg{fill:#fff;width:1.25rem;height:1.25rem}
`, dist_fe = vs();
function dist_de(t, e) {
  return dist_fe(dist_ae), new dist_le({
    autoFocus: "auto",
    ...t
  }, e);
}


;// CONCATENATED MODULE: ./src/utils/emoji.js


/**
 * @param {HTMLElement} triggerElement
 */
function createChatInputEmojiPopup(triggerElement) {
  return dist_de({}, {
    triggerElement,
    referenceElement: triggerElement,
    position: 'top-start',
    hideOnClickOutside: true,
    hideOnEmojiSelect: false,
    hideOnEscape: true,
    showCloseButton: false,
    className: 'emoji-picker',
    onPositionLost: 'close'
  });
}

/**
 * @param {HTMLElement} triggerElement
 * @param {string} className
 */
function createReactionEmojiPopup(triggerElement, className) {
  const isMobile = window.mobileCheck && window.mobileCheck();
  return dist_de({}, {
    triggerElement,
    referenceElement: isMobile ? window : triggerElement,
    position: isMobile ? 'bottom' : 'left',
    hideOnClickOutside: true,
    hideOnEmojiSelect: true,
    hideOnEscape: true,
    showCloseButton: false,
    className,
    onPositionLost: 'hold'
  });
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarTextInputWrapper.vue?vue&type=script&lang=js

/* harmony default export */ var SidebarTextInputWrappervue_type_script_lang_js = ({
  props: {
    testMarkerNameForSendButton: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: String,
    disabledPlaceholder: String,
    wait: {
      type: Boolean,
      default: false
    },
    hasGifsEnabled: Boolean
  },
  data: () => ({
    emojiPicker: null
  }),
  methods: {
    hideEmojiPicker() {
      this.emojiPicker?.close().then(() => {
        this.emojiPicker = null;
        if (this.$refs.emojiPickerButton) {
          this.$refs.emojiPickerButton?.querySelector('button')?.focus();
        }
      });
    },
    toggleEmojiPicker() {
      if (this.emojiPicker) {
        this.hideEmojiPicker();
        return;
      }
      const triggerElement = this.$refs.emojiPickerButton;
      this.emojiPicker = createChatInputEmojiPopup(triggerElement, 'top-start');
      this.emojiPicker.addEventListener('emoji:select', event => {
        this.$emit('selectEmoji', event);
      });
      this.emojiPicker.addEventListener('picker:close', () => {
        this.hideEmojiPicker();
      });
      this.emojiPicker.open();
      // window.analytics.track("emoji_picker_opened", {
      //   openFrom: "chat input"
      // });
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarTextInputWrapper.vue?vue&type=script&lang=js
 /* harmony default export */ var Sidebar_SidebarTextInputWrappervue_type_script_lang_js = (SidebarTextInputWrappervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Sidebar/SidebarTextInputWrapper.vue?vue&type=style&index=0&id=f7bb3d8a&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarTextInputWrappervue_type_style_index_0_id_f7bb3d8a_prod_module_true_lang_scss = ({"root":"SidebarTextInputWrapper_root_ofoUB","disabled":"SidebarTextInputWrapper_disabled_iblAh","inputHolder":"SidebarTextInputWrapper_inputHolder_YxSna","hasGifsEnabled":"SidebarTextInputWrapper_hasGifsEnabled_q1i0K","hasIcon":"SidebarTextInputWrapper_hasIcon_oRsUF","sendButtonHolder":"SidebarTextInputWrapper_sendButtonHolder_If4F3","placeholder":"SidebarTextInputWrapper_placeholder_eTA2U","lockIcon":"SidebarTextInputWrapper_lockIcon_Fu442","nonmobile":"SidebarTextInputWrapper_nonmobile_Vb1hZ","emojiPicker":"SidebarTextInputWrapper_emojiPicker_em3pb"});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarTextInputWrapper.vue?vue&type=style&index=0&id=f7bb3d8a&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarTextInputWrapper.vue



;




function SidebarTextInputWrapper_injectStyles (context) {
  
  this["$style"] = (SidebarTextInputWrappervue_type_style_index_0_id_f7bb3d8a_prod_module_true_lang_scss.locals || SidebarTextInputWrappervue_type_style_index_0_id_f7bb3d8a_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarTextInputWrapper_component = normalizeComponent(
  Sidebar_SidebarTextInputWrappervue_type_script_lang_js,
  SidebarTextInputWrappervue_type_template_id_f7bb3d8a_render,
  SidebarTextInputWrappervue_type_template_id_f7bb3d8a_staticRenderFns,
  false,
  SidebarTextInputWrapper_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarTextInputWrapper = (SidebarTextInputWrapper_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarUserProfile.vue?vue&type=template&id=18a8120a
var SidebarUserProfilevue_type_template_id_18a8120a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "sidebarProfileWrapper",
    class: [_vm.$style.root, {
      open: _vm.openProfileSideBar
    }],
    style: _vm.dynoSytle
  }, [_c('div', {
    class: _vm.$style.closeButton
  }, [_c('SvgIcon', {
    attrs: {
      "name": "cross",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('closeSideBarProfile');
      }
    }
  })], 1), _c('div', {
    class: _vm.$style.headerText
  }, [_c('StyledText', {
    attrs: {
      "variant": "body18",
      "align": "center",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Profile')) + " ")])], 1), _c('div', {
    class: _vm.$style.userImageWrapper
  }, [_c('UserImage', {
    attrs: {
      "user": _vm.userdata,
      "size": "large",
      "image-scale": "medium"
    }
  })], 1), _c('div', {
    class: _vm.$style.userName
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading20",
      "align": "center",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.userdata.name) + " ")])], 1), _c('div', {
    class: _vm.$style.userDetails
  }, [_c('StyledText', {
    class: _vm.$style.userInfo,
    attrs: {
      "variant": "body15",
      "align": "center",
      "color": "primary-text-color"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.userdata.title))]), _c('div', [_vm._v(_vm._s(_vm.userdata.company))])])], 1), _c('div', {
    class: _vm.$style.aboutUser
  }, [_c('StyledText', {
    attrs: {
      "variant": "noBodyVariant",
      "align": "center",
      "color": "primary-text-color"
    }
  }, [_c('span', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: _vm.userdata.description,
      expression: "userdata.description"
    }]
  })])], 1), _vm.userdata.location && _vm.userdata.location.location ? _c('div', {
    class: _vm.$style.address
  }, [_c('StyledText', {
    class: [_vm.$style.withIcon, _vm.$style.location],
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [[_c('SvgIcon', {
    attrs: {
      "name": "location",
      "color": "primary-text-color"
    }
  }), _vm._v(" " + _vm._s(_vm.userdata.location.location) + " ")]], 2)], 1) : _vm._e(), _vm.linkedinTitle ? _c('div', {
    class: _vm.$style.linkedin
  }, [_c('a', {
    class: _vm.$style.link,
    attrs: {
      "href": _vm.userdata.linkedin_url || '',
      "target": "_blank"
    }
  }, [_c('StyledText', {
    class: _vm.$style.withIcon,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "linkedin",
      "color": "primary-text-color"
    }
  }), _vm._v(" " + _vm._s(_vm.linkedinTitle) + " ")], 1)], 1)]) : _vm._e(), _vm.twitterTitle ? _c('div', {
    class: _vm.$style.twitter
  }, [_c('a', {
    class: _vm.$style.link,
    attrs: {
      "href": _vm.userdata.twitter_url || '',
      "target": "_blank"
    }
  }, [_c('StyledText', {
    class: _vm.$style.withIcon,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "twitter",
      "color": "primary-text-color"
    }
  }), _vm._v(" " + _vm._s(_vm.twitterTitle) + " ")], 1)], 1)]) : _vm._e()]);
};
var SidebarUserProfilevue_type_template_id_18a8120a_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Sidebar/SidebarUserProfile.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarUserProfilevue_type_script_lang_js = ({
  name: 'SidebarUserProfile',
  props: {
    userdata: {
      type: Object
    },
    description: {
      type: String,
      default: ''
    },
    openProfileSideBar: {
      type: Boolean,
      default: false
    },
    cssVars: {
      type: Object,
      default: () => {
        return {
          height: '100vh',
          width: '390px',
          position: 'fixed',
          top: '0',
          transform: 'translateX(390px)',
          right: '0',
          'z-index': '9'
        };
      }
    }
  },
  computed: {
    dynoSytle() {
      return this.cssVars;
    },
    linkedinTitle() {
      return this.userdata?.linkedin_url?.split('linkedin.com').pop().split('?').shift();
    },
    twitterTitle() {
      return this.userdata?.twitter_url?.split('twitter.com').pop().split('?').shift();
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarUserProfile.vue?vue&type=script&lang=js
 /* harmony default export */ var Sidebar_SidebarUserProfilevue_type_script_lang_js = (SidebarUserProfilevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Sidebar/SidebarUserProfile.vue?vue&type=style&index=0&id=18a8120a&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarUserProfilevue_type_style_index_0_id_18a8120a_prod_lang_scss_module_true = ({"root":"SidebarUserProfile_root_mRW3e","headerText":"SidebarUserProfile_headerText_SXPXs","userImageWrapper":"SidebarUserProfile_userImageWrapper_LUxLa","userName":"SidebarUserProfile_userName_vvhOO","userDetails":"SidebarUserProfile_userDetails_rALOS","closeButton":"SidebarUserProfile_closeButton_hevR8","aboutUser":"SidebarUserProfile_aboutUser_nmSel","hashTagWrapper":"SidebarUserProfile_hashTagWrapper_AEHKu","userKeySection":"SidebarUserProfile_userKeySection_tX0bc","address":"SidebarUserProfile_address_XwLgU","linkedin":"SidebarUserProfile_linkedin_t_ten","twitter":"SidebarUserProfile_twitter_oJ7T6","email":"SidebarUserProfile_email_X33Ug","userInfo":"SidebarUserProfile_userInfo_W4TPd","location":"SidebarUserProfile_location_ZbYQU","withIcon":"SidebarUserProfile_withIcon_RJJ41"});
;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarUserProfile.vue?vue&type=style&index=0&id=18a8120a&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Sidebar/SidebarUserProfile.vue?vue&type=style&index=1&id=18a8120a&prod&lang=scss&scope=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarUserProfile.vue?vue&type=style&index=1&id=18a8120a&prod&lang=scss&scope=true

;// CONCATENATED MODULE: ./src/components/Sidebar/SidebarUserProfile.vue



;





function SidebarUserProfile_injectStyles (context) {
  
  this["$style"] = (SidebarUserProfilevue_type_style_index_0_id_18a8120a_prod_lang_scss_module_true.locals || SidebarUserProfilevue_type_style_index_0_id_18a8120a_prod_lang_scss_module_true)

}

/* normalize component */

var SidebarUserProfile_component = normalizeComponent(
  Sidebar_SidebarUserProfilevue_type_script_lang_js,
  SidebarUserProfilevue_type_template_id_18a8120a_render,
  SidebarUserProfilevue_type_template_id_18a8120a_staticRenderFns,
  false,
  SidebarUserProfile_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarUserProfile = (SidebarUserProfile_component.exports);
;// CONCATENATED MODULE: ./src/components/Sidebar/index.js






;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarChatWidget.vue?vue&type=template&id=f3486a46
var SidebarChatWidgetvue_type_template_id_f3486a46_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, {
      [_vm.$style.hideroot]: _vm.hideComponent
    }],
    attrs: {
      "id": "sidebarChatWidget"
    }
  }, [_c('SidebarWidgetContainer', {
    attrs: {
      "widgetLabel": _vm.$options.$t('Live Chat')
    }
  }, [_c('div', {
    class: {
      [_vm.$style.chatContainer]: true,
      [_vm.$style.hasTabs]: _vm.tabs.length > 1,
      [_vm.$style.hasPinned]: (_vm.pinnedMessages || []).length > 0,
      [_vm.$style.canChat]: _vm.canChat
    }
  }, [_c('div', {
    class: _vm.$style.sidebarHeading
  }, [_vm.isTVModeChatToggle ? _c('div', {
    class: _vm.$style.sidebarChatToggle
  }, [_c('SvgIcon', {
    style: {
      transform: 'rotate(270deg)'
    },
    attrs: {
      "name": "down-arrow",
      "color": "primary-text-color"
    },
    on: {
      "click": () => _vm.$emit('closeChatToggle')
    }
  })], 1) : _vm._e(), _vm.tabs.length > 1 ? _c('div', {
    class: _vm.$style.tabs,
    attrs: {
      "role": "tablist"
    }
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c('button', {
      key: tab.id,
      ref: "tab",
      refInFor: true,
      staticClass: "button",
      class: {
        [_vm.$style.buttonWithIcon]: tab.icon
      },
      attrs: {
        "id": tab.id,
        "role": "tab",
        "data-testid": 'subtab-' + tab.id,
        "aria-selected": _vm.isTabSelected(tab),
        "tabindex": tab.selected ? 0 : -1
      },
      on: {
        "keydown": e => _vm.onKeydown(index, e),
        "click": () => _vm.$emit('tabChanged', index)
      }
    }, [tab.icon ? _c('SvgIcon', {
      key: tab.id,
      class: {
        [_vm.$style.selectedTab]: tab.selected,
        [_vm.$style.tabIcon]: true
      },
      attrs: {
        "name": tab.icon,
        "color": "primary-text-color",
        "size": "small"
      },
      on: {
        "click": () => _vm.$emit('tabChanged', index)
      }
    }) : _vm._e(), _c('GTooltip', {
      key: tab.id,
      class: _vm.$style.tabcontainer,
      attrs: {
        "text": tab.description,
        "disabled": !tab.description,
        "forceShowTooltip": !!tab.description,
        "position": "bottom-left"
      }
    }, [tab && tab.count > 0 && !tab.selected ? _c('div', {
      class: _vm.$style.detailedindicator
    }, [_c('div', {
      class: _vm.$style.text
    }, [_c('StyledText', {
      attrs: {
        "variant": "body13",
        "color": "primary-text-color"
      }
    }, [_vm._v(" " + _vm._s(tab.count > 9 ? '9+' : tab.count) + " ")])], 1)]) : _vm._e(), _c('StyledText', {
      class: {
        [_vm.$style.selectedTab]: tab.selected,
        [_vm.$style.tab]: true
      },
      attrs: {
        "dataBrandingTarget": tab.selected ? 'sidebar-subtab-tab' : 'unselected-subtab',
        "variant": "heading13",
        "color": "primary-text-color",
        "tabIndex": -1
      },
      on: {
        "click": () => _vm.$emit('tabChanged', index)
      }
    }, [_vm._v(" " + _vm._s(tab.label) + " ")])], 1)], 1);
  }), 0) : _vm._e(), _vm.isTVModeChatToggle ? _c('div', {
    class: _vm.$style.sidebarSettingToggle
  }, [_c('GTooltip', {
    attrs: {
      "text": "Open Settings",
      "position": "bottom-right"
    }
  }, [_c('SvgIcon', {
    style: {
      transform: 'rotate(270deg)'
    },
    attrs: {
      "name": "settings",
      "color": "primary-text-color"
    },
    on: {
      "click": () => _vm.$emit('openSettingsDialog')
    }
  })], 1)], 1) : _vm._e()]), !(_vm.tabs.find(it => it.id === 'drift_embed') || {}).selected ? [_vm.pinnedMessages.length > 0 ? _c('div', {
    class: [_vm.$style.pinMsgs, {
      [_vm.$style.withTabs]: _vm.tabs.length > 1,
      [_vm.$style.expanded]: _vm.expanded
    }],
    attrs: {
      "data-branding-target": "pinned-chats-expanded"
    }
  }, [_c('div', {
    class: _vm.$style.msglist
  }, _vm._l(_vm.pinnedMessages, function (pinnedMessage) {
    return _c('SidebarMessageItem', {
      key: pinnedMessage.id,
      attrs: {
        "message": pinnedMessage,
        "show": {
          pin: false,
          smiley: false,
          delete: false
        },
        "currentUserMMID": _vm.currentUserMMID,
        "isEventUsingSlidoQA": _vm.isEventUsingSlidoQA
      },
      on: {
        "showUserModal": () => _vm.$emit('showUserModal', pinnedMessage.coreuserid),
        "pinPost": () => _vm.$emit('pinPost', pinnedMessage),
        "delPost": () => _vm.$emit('delPost', pinnedMessage),
        "unpinPost": () => _vm.$emit('unpinPost', pinnedMessage),
        "linkclicked": data => _vm.$emit('linkclicked', data),
        "react": _vm.react
      }
    });
  }), 1), _c('TextButton', {
    class: _vm.$style.pinButton,
    attrs: {
      "color": "primary-text-color",
      "uppercase": false
    },
    on: {
      "click": () => _vm.$emit('togglePinned')
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.buttonText)) + " ")])], 1) : _vm._e(), _vm.messages.length > 0 || _vm.loading !== 'loaded' ? _c('div', {
    class: {
      [_vm.$style.chatMessagesHolder]: true,
      [_vm.$style.hasTabs]: _vm.tabs.length > 1,
      [_vm.$style.hasPinned]: (_vm.pinnedMessages || []).length > 0,
      [_vm.$style.canChat]: _vm.canChat
    },
    attrs: {
      "data-branding-target": "chatmessagesholder"
    }
  }, [_vm.loading === 'left' ? _c('div', {
    class: _vm.$style.failed
  }, [_c('SidebarEmptyState', {
    attrs: {
      "failed": true,
      "title": _vm.$options.$t(`Uh..oh we couldn't load the content`),
      "message": _vm.$options.$t('Please reload the page')
    },
    on: {
      "refresh": () => _vm.$emit('rejoinChat')
    }
  })], 1) : _vm._e(), _c('SidebarChatScrollHelper', {
    attrs: {
      "prevPostsPresent": _vm.prevPostsPresent,
      "loading": _vm.loading,
      "messages": _vm.messages,
      "haveTextQNA": _vm.haveTextQNA,
      "isSpeaker": _vm.isSpeaker,
      "showNewMsgsButton": _vm.showNewMsgsButton,
      "lockScroll": _vm.lockScroll,
      "canPublishLowerThird": _vm.canPublishLowerThird,
      "currentUserMMID": _vm.currentUserMMID,
      "canPublishChatToQNA": _vm.canPublishChatToQNA,
      "isEventUsingSlidoQA": _vm.isEventUsingSlidoQA
    },
    on: {
      "react": r => _vm.$emit('react', r),
      "pinPost": message => _vm.$emit('pinPost', message),
      "unpinPost": message => _vm.$emit('unpinPost', message),
      "delPost": message => _vm.$emit('delPost', message),
      "loadoldmessages": () => _vm.$emit('loadoldmessages'),
      "showUserModal": user => _vm.$emit('showUserModal', user),
      "linkclicked": data => _vm.$emit('linkclicked', data),
      "publishChatMessageAsTextQnA": message => _vm.$emit('publishChatMessageAsTextQnA', message),
      "chatscroll": e => _vm.$emit('chatscroll', e),
      "publish": message => _vm.$emit('publish', message),
      "retrySendMessage": message => _vm.$emit('retrySendMessage', message)
    }
  })], 1) : _vm._e(), _vm.showNewMsgsButton ? _c('div', {
    class: _vm.$style.newmessagesbutton
  }, [_c('PillButton', {
    on: {
      "click": () => _vm.$emit('showlatest')
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('New comments')) + " ")])], 1) : _vm._e(), _vm.loading === 'loaded' && _vm.messages.length === 0 && _vm.pinnedMessages.length === 0 ? _c('div', {
    class: {
      [_vm.$style.empty]: true,
      [_vm.$style.noTabs]: _vm.tabs.length < 2
    }
  }, [_c('SidebarEmptyState', {
    attrs: {
      "icon": "empty-plane",
      "title": _vm.canChat ? _vm.$options.$t('Start the conversation') : _vm.$options.$t('No messages yet'),
      "message": _vm.canChat ? _vm.$options.$t('Be the first to add to chat!') : _vm.$options.$t('Messages from organizers and speakers appear here!')
    }
  })], 1) : _vm._e(), _c('div', {
    class: [_vm.$style.chatInputHolder, {
      [_vm.$style.hasPinned]: (_vm.pinnedMessages || []).length > 0
    }]
  }, [_c('SidebarChatInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading !== 'left' && _vm.loading !== 'blocked' && _vm.canChat,
      expression: "loading !== 'left' && loading !== 'blocked' && canChat"
    }],
    attrs: {
      "wait": _vm.loading === 'loading',
      "placeholder": _vm.$options.$t('Enter your message'),
      "disabled": !_vm.canChat || _vm.loading !== 'loaded',
      "disabled-placeholder": _vm.loading === 'loading' ? _vm.$options.$t('Joining chat!') : '...',
      "hasGifsEnabled": _vm.hasGifsEnabled
    },
    on: {
      "send": text => text && _vm.$emit('sendChatMessage', text),
      "openGifPickerDialog": () => _vm.$emit('openGifPickerDialog')
    }
  })], 1)] : _vm._e(), _c('DriftEmbed', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs.find(it => it.id === 'drift_embed') || {}).selected,
      expression: "(tabs.find(it => it.id === 'drift_embed') || {}).selected"
    }],
    attrs: {
      "driftLandingUrl": _vm.driftLandingUrl
    }
  })], 2)])], 1);
};
var SidebarChatWidgetvue_type_template_id_f3486a46_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarChatWidget.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarChatWidgetvue_type_script_lang_js = ({
  props: {
    prevPostsPresent: {
      type: Boolean,
      default: false
    },
    showNewMsgsButton: {
      type: Boolean,
      default: false
    },
    canPublishChatToQNA: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: false
    },
    loading: {
      type: String,
      default: 'loading'
    },
    isTVModeChatToggle: {
      type: Boolean,
      default: false
    },
    messages: {
      type: Array,
      default() {
        return [];
      }
    },
    pinnedMessages: {
      type: Array,
      default() {
        return [];
      }
    },
    haveTextQNA: {
      type: Boolean,
      default: false
    },
    isSpeaker: {
      type: Boolean,
      default: false
    },
    isOrganizer: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: () => []
    },
    buttonText: {
      type: String,
      default: 'See all pinned messages'
    },
    expanded: {
      type: Boolean,
      default: false
    },
    canChat: Boolean,
    driftLandingUrl: {
      type: String,
      default: ''
    },
    hideComponent: {
      type: Boolean,
      default: false
    },
    resendText: {
      type: String,
      default: 'Failed to send! Retry?'
    },
    sending: {
      type: String,
      default: 'sending'
    },
    isEventUsingSlidoQA: {
      type: Boolean,
      default: false
    },
    canPublishLowerThird: Boolean,
    hasGifsEnabled: Boolean,
    currentUserMMID: String
  },
  methods: {
    react() {
      //empty method for pinned messages as we are using this.$parent.react method from SidebarMessageItem
    },
    onKeydown(index, event) {
      const targetIndex = index;
      let flag = false;
      switch (event.key) {
        case 'ArrowLeft':
          this.moveFocusToPreviousTab(targetIndex);
          flag = true;
          break;
        case 'ArrowRight':
          this.moveFocusToNextTab(targetIndex);
          flag = true;
          break;
        case 'Home':
          this.moveFocusToTab(0);
          flag = true;
          break;
        case 'End':
          this.moveFocusToTab(this.tabs.length - 1);
          flag = true;
          break;
        default:
          break;
      }
      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    moveFocusToTab(targetIndex) {
      this.$refs.tab[targetIndex].focus();
    },
    moveFocusToPreviousTab(targetIndex) {
      const previousIndex = targetIndex === 0 ? this.tabs.length - 1 : targetIndex - 1;
      this.moveFocusToTab(previousIndex);
    },
    moveFocusToNextTab(targetIndex) {
      const nextIndex = targetIndex === this.tabs.length - 1 ? 0 : targetIndex + 1;
      this.moveFocusToTab(nextIndex);
    },
    isTabSelected() {
      return tab => tab.selected ? 'true' : 'false';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarChatWidget.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarChat_SidebarChatWidgetvue_type_script_lang_js = (SidebarChatWidgetvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarChat/SidebarChatWidget.vue?vue&type=style&index=0&id=f3486a46&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarChatWidgetvue_type_style_index_0_id_f3486a46_prod_module_true_lang_scss = ({"hideroot":"SidebarChatWidget_hideroot_CWvch","sidebarHeading":"SidebarChatWidget_sidebarHeading_o0JhC","sidebarSettingToggle":"SidebarChatWidget_sidebarSettingToggle_pUdRR","sidebarChatToggle":"SidebarChatWidget_sidebarChatToggle_i9x4G","root":"SidebarChatWidget_root_RYKoD","chatContainer":"SidebarChatWidget_chatContainer_kxJzN","hasPinned":"SidebarChatWidget_hasPinned_HHdFD","hasTabs":"SidebarChatWidget_hasTabs__FqQf","canChat":"SidebarChatWidget_canChat_oY5M8","newmessagesbutton":"SidebarChatWidget_newmessagesbutton_JGsnn","chatMessagesHolder":"SidebarChatWidget_chatMessagesHolder_hxKSC","chatInputHolder":"SidebarChatWidget_chatInputHolder_XkDW8","pinMsgs":"SidebarChatWidget_pinMsgs_bYAjP","withTabs":"SidebarChatWidget_withTabs_Qu8Tb","expanded":"SidebarChatWidget_expanded_AmGFV","msglist":"SidebarChatWidget_msglist_IGsjd","pinButton":"SidebarChatWidget_pinButton_INKF7","tabs":"SidebarChatWidget_tabs_Fz8fe","buttonWithIcon":"SidebarChatWidget_buttonWithIcon_J78HA","tabIcon":"SidebarChatWidget_tabIcon_X1PD1","tabcontainer":"SidebarChatWidget_tabcontainer_EIS4s","detailedindicator":"SidebarChatWidget_detailedindicator_JPhwA","text":"SidebarChatWidget_text_vzIUZ","min":"SidebarChatWidget_min_bDDjq","tab":"SidebarChatWidget_tab_sn2h9","selectedTab":"SidebarChatWidget_selectedTab_v2UbE","failed":"SidebarChatWidget_failed_BFrgK","empty":"SidebarChatWidget_empty_r1V8K","noTabs":"SidebarChatWidget_noTabs_qxag3"});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarChatWidget.vue?vue&type=style&index=0&id=f3486a46&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarChatWidget.vue



;




function SidebarChatWidget_injectStyles (context) {
  
  this["$style"] = (SidebarChatWidgetvue_type_style_index_0_id_f3486a46_prod_module_true_lang_scss.locals || SidebarChatWidgetvue_type_style_index_0_id_f3486a46_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarChatWidget_component = normalizeComponent(
  SidebarChat_SidebarChatWidgetvue_type_script_lang_js,
  SidebarChatWidgetvue_type_template_id_f3486a46_render,
  SidebarChatWidgetvue_type_template_id_f3486a46_staticRenderFns,
  false,
  SidebarChatWidget_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarChatWidget = (SidebarChatWidget_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarChatScrollHelper.vue?vue&type=template&id=29f27086
var SidebarChatScrollHelpervue_type_template_id_29f27086_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "chatmessages",
    class: _vm.$style.root,
    attrs: {
      "data-forceupdate": 'chatscrollhelper',
      "role": "application"
    },
    on: {
      "scroll": _vm.handleScroll,
      "keydown": _vm.handleKeydown
    }
  }, [_vm.showFullLoader ? _c('div', {
    class: _vm.$style.loadercontainer
  }, [_c('SidebarEmptyState', {
    attrs: {
      "loading": true,
      "title": _vm.$options.$t('Loading Chat'),
      "message": _vm.$options.$t('Please wait while we fetch the chat')
    }
  })], 1) : _vm.loading === 'blocked' ? _c('div', {
    class: _vm.$style.loadercontainer
  }, [_c('StyledText', {
    attrs: {
      "variant": "body14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Join the room to see chat')) + " ")])], 1) : _vm.loading === 'blocked-norecourse' ? _c('div', {
    class: _vm.$style.loadercontainer
  }, [_c('StyledText', {
    attrs: {
      "variant": "body14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('loading...')) + " ")])], 1) : [_vm.prevPostsPresent && _vm.loading === 'loaded' ? _c('div', {
    class: _vm.$style.loadMoreButton,
    on: {
      "click": function ($event) {
        return _vm.$emit('loadoldmessages');
      }
    }
  }, [_c('StyledText', {
    class: _vm.$style.loadMoreBtnText,
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Load old messages')) + " ")])], 1) : _vm._e(), _vm.showMessages ? _vm._l(_vm.messages, function (message, i) {
    return _c('div', {
      key: message.id + i,
      attrs: {
        "data-key": message.id
      }
    }, [message.dayChange && !_vm.allMessagesAreFromToday ? _c('SidebarMessageDateDivider', {
      attrs: {
        "postedToday": message.postedToday,
        "day": message.day
      }
    }) : _vm._e(), _c('div', {
      class: _vm.$style.focusableMessage,
      attrs: {
        "role": "row",
        "tabindex": i === _vm.messages.length - 1 ? 0 : -1
      },
      on: {
        "focus": function ($event) {
          return _vm.onFocusIn(i);
        }
      }
    }, [_c('SidebarMessageItem', {
      ref: "messageItemRef",
      refInFor: true,
      attrs: {
        "message": message,
        "show": {
          pin: _vm.isSpeaker && !message.gif,
          smiley: true,
          delete: _vm.isSpeaker,
          publish: _vm.canPublishLowerThird && !message.gif,
          postAsTextQnA: _vm.canPublishChatToQNA && !message.gif
        },
        "index": i,
        "haveTextQNA": _vm.haveTextQNA,
        "currentUserMMID": _vm.currentUserMMID,
        "isEventUsingSlidoQA": _vm.isEventUsingSlidoQA,
        "selected": i === _vm.currentFocusedIndex
      },
      on: {
        "showUserModal": function ($event) {
          return _vm.$emit('showUserModal', message.coreuserid);
        },
        "pinPost": function ($event) {
          return _vm.$emit('pinPost', message);
        },
        "delPost": function ($event) {
          return _vm.$emit('delPost', message);
        },
        "unpinPost": function ($event) {
          return _vm.$emit('unpinPost', message);
        },
        "publish": function ($event) {
          return _vm.$emit('publish', message);
        },
        "publishChatMessageAsTextQnA": function ($event) {
          return _vm.$emit('publishChatMessageAsTextQnA', message);
        },
        "react": _vm.react,
        "linkclicked": data => _vm.$emit('linkclicked', data),
        "retrySendMessage": () => _vm.$emit('retrySendMessage', message)
      }
    })], 1)], 1);
  }) : _vm._e()]], 2);
};
var SidebarChatScrollHelpervue_type_template_id_29f27086_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarChatScrollHelper.vue?vue&type=script&lang=js

/* harmony default export */ var SidebarChatScrollHelpervue_type_script_lang_js = ({
  props: {
    showNewMsgsButton: {
      type: Boolean,
      default: false
    },
    canPublishChatToQNA: {
      type: Boolean,
      default: false
    },
    haveTextQNA: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: false
    },
    prevPostsPresent: {
      type: Boolean,
      default: false
    },
    loading: {
      type: String,
      default: 'loaded'
    },
    messages: {
      type: Array,
      default() {
        return [];
      }
    },
    isSpeaker: {
      type: Boolean,
      default: false
    },
    isEventUsingSlidoQA: {
      type: Boolean,
      default: false
    },
    canPublishLowerThird: Boolean,
    currentUserMMID: String
  },
  data() {
    return {
      currentFocusedIndex: -1
    };
  },
  methods: {
    handleScroll() {
      if (this.$refs.chatmessages) {
        this.$emit('chatscroll', {
          scrolltop: this.$refs.chatmessages.scrollTop,
          scrollheight: this.$refs.chatmessages.scrollHeight,
          clientheight: this.$refs.chatmessages.clientHeight
        });
      }
    },
    react(emoji, message) {
      this.$emit('react', {
        reaction: btoa(unescape(encodeURIComponent(emoji))),
        message
      });
    },
    scrollToLastMessage() {
      if (!this.$refs.chatmessages) {
        return;
      }
      this.$refs.chatmessages.scrollTop = this.$refs.chatmessages.scrollHeight;
    },
    scrollIfNotLocked() {
      const self = this;
      if (!this.showNewMsgsButton && !this.lockScroll) {
        this.showLoadingNewMsgs = true;
        // Wait for all children to be rendered
        this.$nextTick(() => {
          self.scrollToLastMessage();
          this.showLoadingNewMsgs = false;
        });
      }
    },
    handleKeydown(event) {
      if (event.key === 'ArrowUp') {
        this.moveFocus('up');
        event.preventDefault();
      } else if (event.key === 'ArrowDown') {
        this.moveFocus('down');
        event.preventDefault();
      } else if (event.key === 'ArrowLeft') {
        this.handleLeftRightArrowPress('left');
        event.preventDefault();
      } else if (event.key === 'ArrowRight') {
        this.handleLeftRightArrowPress('right');
        event.preventDefault();
      } else if (event.key !== 'ArrowLeft' || event.key !== 'ArrowRight') {
        const rows = document.querySelector('#sidebarChatWidget').querySelectorAll('[role=row]');
        rows.forEach(currentRow => {
          const allFocusableElements = currentRow.querySelectorAll('.messageFocusable');
          allFocusableElements.forEach(element => {
            element.setAttribute('tabindex', '-1');
          });
        });
      }
    },
    setFocus(index) {
      const rows = document.querySelector('#sidebarChatWidget').querySelectorAll('[role=row]');
      rows.forEach((row, i) => {
        if (i === index) {
          row.setAttribute('tabindex', '0');
          row?.focus();
        } else {
          row.setAttribute('tabindex', '-1');
        }
      });
    },
    moveFocus(direction) {
      if (direction === 'up') {
        if (this.currentFocusedIndex <= 0) {
          this.currentFocusedIndex = this.messages.length - 1;
        } else {
          this.currentFocusedIndex = this.currentFocusedIndex - 1;
        }
      } else if (direction === 'down') {
        if (this.currentFocusedIndex === this.messages.length - 1) {
          this.currentFocusedIndex = 0;
        } else {
          this.currentFocusedIndex = this.currentFocusedIndex + 1;
        }
      }
      this.setFocus(this.currentFocusedIndex);
    },
    onFocusIn(index) {
      this.currentFocusedIndex = index;
    },
    handleLeftRightArrowPress(direction) {
      const rows = document.querySelector('#sidebarChatWidget').querySelectorAll('[role=row]');
      const currentRow = rows[this.currentFocusedIndex];
      const allFocusableElements = currentRow.querySelectorAll('.messageFocusable');
      const inMessageFocusIndex = this.$refs.messageItemRef[this.currentFocusedIndex].inMessageFocusIndex;
      const setInMessageFocusIndex = this.$refs.messageItemRef[this.currentFocusedIndex].setInMessageFocusIndex;
      this.onFocusIn(this.currentFocusedIndex);
      if (direction === 'left') {
        if (inMessageFocusIndex === 0) {
          setInMessageFocusIndex(allFocusableElements.length - 1);
        } else {
          if (inMessageFocusIndex !== null) {
            setInMessageFocusIndex(inMessageFocusIndex - 1);
          } else {
            setInMessageFocusIndex(0);
          }
        }
      } else if (direction === 'right') {
        if (inMessageFocusIndex === allFocusableElements.length - 1) {
          setInMessageFocusIndex(0);
        } else {
          if (inMessageFocusIndex !== null) {
            setInMessageFocusIndex(inMessageFocusIndex + 1);
          } else {
            setInMessageFocusIndex(1);
          }
        }
      }
      allFocusableElements.forEach((element, index) => {
        element.setAttribute('tabindex', '-1');
        if (index === inMessageFocusIndex) {
          element.setAttribute('tabindex', '0');
          element?.focus();
        }
      });
    }
  },
  watch: {
    messages(newvalue, oldvalue) {
      try {
        const self = this;
        if (Array.isArray(newvalue) && Array.isArray(oldvalue) && newvalue.length !== oldvalue.length && !this.showNewMsgsButton && !this.lockScroll) {
          this.showLoadingNewMsgs = true;
          // Wait for all children to be rendered
          this.$nextTick(() => {
            self.scrollToLastMessage();
            this.showLoadingNewMsgs = false;
          });
        }
      } catch (err) {
        console.error('Error watching messages changes!', err);
      }
    }
  },
  computed: {
    allMessagesAreFromToday() {
      return this.messages.findIndex(message => !message.postedToday) === -1;
    },
    showFullLoader() {
      return this.loading === 'loading' && !this.messages?.length;
    },
    showMessages() {
      return !!this.messages?.length;
    }
  },
  mounted() {
    const self = this;
    // Wait for all children to be rendered
    this.$nextTick(() => {
      self.scrollToLastMessage();
    });
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarChatScrollHelper.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarChat_SidebarChatScrollHelpervue_type_script_lang_js = (SidebarChatScrollHelpervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarChat/SidebarChatScrollHelper.vue?vue&type=style&index=0&id=29f27086&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarChatScrollHelpervue_type_style_index_0_id_29f27086_prod_module_true_lang_scss = ({"root":"SidebarChatScrollHelper_root_dXKIR","focusableMessage":"SidebarChatScrollHelper_focusableMessage_SwoPn","messageEmojiPicker":"SidebarChatScrollHelper_messageEmojiPicker_AXLr9","loadercontainer":"SidebarChatScrollHelper_loadercontainer_AMBC9","loadMoreButton":"SidebarChatScrollHelper_loadMoreButton_cNA8c","loadMoreBtnText":"SidebarChatScrollHelper_loadMoreBtnText_Q44ZU","loadingMessage":"SidebarChatScrollHelper_loadingMessage_sOgNf"});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarChatScrollHelper.vue?vue&type=style&index=0&id=29f27086&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarChatScrollHelper.vue



;




function SidebarChatScrollHelper_injectStyles (context) {
  
  this["$style"] = (SidebarChatScrollHelpervue_type_style_index_0_id_29f27086_prod_module_true_lang_scss.locals || SidebarChatScrollHelpervue_type_style_index_0_id_29f27086_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarChatScrollHelper_component = normalizeComponent(
  SidebarChat_SidebarChatScrollHelpervue_type_script_lang_js,
  SidebarChatScrollHelpervue_type_template_id_29f27086_render,
  SidebarChatScrollHelpervue_type_template_id_29f27086_staticRenderFns,
  false,
  SidebarChatScrollHelper_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarChatScrollHelper = (SidebarChatScrollHelper_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarMessageItem.vue?vue&type=template&id=572b3df3
var SidebarMessageItemvue_type_template_id_572b3df3_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, {
      [_vm.$style.loading]: _vm.message.isMessageProcessing || _vm.isSendingMessage
    }],
    attrs: {
      "data-selected": _vm.selected.toString(),
      "data-branding-target": "chatmessage-root",
      "aria-labelledby": ['time' + _vm.index, 'message' + _vm.index].join(' ')
    }
  }, [_c('div', {
    class: [_vm.$style.messageitembody, !_vm.message.name && _vm.$style.noUserFound]
  }, [_c('div', {
    staticClass: "messageFocusable rounded",
    class: _vm.$style.userImageHolder,
    attrs: {
      "role": "button",
      "tabindex": "-1"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('showUserModal');
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.$emit('showUserModal');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.preventDefault();
        return _vm.$emit('showUserModal');
      }]
    }
  }, [_c('UserImage', {
    class: _vm.$style.userImg,
    attrs: {
      "user": {
        name: _vm.message.name,
        mediumimage: _vm.message.mediumimage,
        thumbnail: _vm.message.thumbnail,
        eventUser: {
          is_in_person: _vm.message.is_in_person
        }
      },
      "size": "small"
    }
  })], 1), _c('span', {
    class: _vm.$style.messageDetailsHolder
  }, [_c('div', {
    class: _vm.$style.messagePropsHolder
  }, [_vm.message.name ? [_c('StyledText', {
    class: _vm.$style.messageUserName,
    attrs: {
      "variant": "heading13",
      "data-branding-target": "chat-name",
      "tabIndex": -1
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('showUserModal');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.message.name) + " ")])] : [_c('div', {
    class: _vm.$style.messageSkeleton
  })], _c('StyledText', {
    class: _vm.$style.messageTime,
    attrs: {
      "id": 'time' + _vm.index,
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.message.time) + " ")]), _vm.message.is_pinned ? _c('button', {
    on: {
      "click": e => _vm.$emit('unpinPost', e)
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.pin,
    attrs: {
      "name": "pushpin"
    }
  })], 1) : _vm._e()], 2), _vm.message.text === '@@gif@@' && _vm.message.gif && _vm.message.gif.still && _vm.message.gif.animated ? _c('GifRenderer', {
    class: _vm.$style.gifRenderer,
    attrs: {
      "stillSrc": _vm.message.gif.still,
      "animatedSrc": _vm.message.gif.animated
    }
  }) : _c('StyledText', {
    class: _vm.$style.messageStyledText,
    attrs: {
      "id": 'message' + _vm.index,
      "variant": "body14",
      "data-branding-target": "chat-message"
    }
  }, [_c('ChatMessageRenderer', {
    attrs: {
      "text": _vm.message.text,
      "linkClass": _vm.$style.chatLinks,
      "containerClass": _vm.$style.messageTextBody
    },
    on: {
      "linkclicked": e => _vm.$emit('linkclicked', e),
      "buttonclicked": e => _vm.$emit('buttonclicked', e)
    }
  })], 1), _c('ChatReactionBar', {
    class: _vm.$style.chatReactionBar,
    attrs: {
      "reactions": _vm.message.reactions,
      "currentUserMMID": _vm.currentUserMMID
    },
    on: {
      "click": _vm.postEmoji
    }
  }), _vm.isChatPostedAsQNA ? _c('StyledText', {
    class: _vm.$style.textQnABar,
    attrs: {
      "variant": "body11"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Sent to Q&A')) + " ")]) : _vm._e(), _vm.message.error ? _c('div', {
    class: _vm.$style.errorContainer
  }, [_c('SvgIcon', {
    attrs: {
      "size": "x-small",
      "name": "warning",
      "color": "color-highlight"
    }
  }), _c('button', {
    class: _vm.$style.sendMessageErrorButton,
    attrs: {
      "disabled": !_vm.errorConfig.retryAction
    },
    on: {
      "click": function ($event) {
        _vm.errorConfig.retryAction ? _vm.errorConfig.retryAction() : () => null;
      }
    }
  }, [_c('StyledText', {
    attrs: {
      "color": "color-highlight",
      "variant": "body13",
      "nowrap": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.errorConfig.message) + " ")])], 1)], 1) : _vm._e()], 1)]), _vm.showMessageControls ? _c('span', {
    class: [_vm.$style.reactiontools, {
      [_vm.$style.keepopen]: this.emojiPicker && this.emojiPicker.isOpen
    }]
  }, [_vm.show.smiley && !_vm.isChatPostedAsQNA ? _vm._m(0) : _vm._e(), _vm.show.pin && !_vm.isChatPostedAsQNA ? _vm._m(1) : _vm._e(), _vm.show.delete ? _vm._m(2) : _vm._e(), _vm.show.publish ? _vm._m(3) : _vm._e(), _vm.show.postAsTextQnA && !_vm.isChatPostedAsQNA && !_vm.isEventUsingSlidoQA ? _vm._m(4) : _vm._e()]) : _vm._e()]);
};
var SidebarMessageItemvue_type_template_id_572b3df3_staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    ref: "emojiPicker",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": _vm.toggleEmojiPicker
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.smiley,
    attrs: {
      "ariaHidden": true,
      "name": "smiley",
      "color": "secondary-text-color"
    }
  }), _vm._v("+ ")], 1);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": e => _vm.$emit('pinPost', e)
    }
  }, [_c('SvgIcon', {
    attrs: {
      "ariaHidden": true,
      "name": "pushpin",
      "color": "secondary-text-color"
    }
  })], 1);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": e => _vm.$emit('delPost', e)
    }
  }, [_c('SvgIcon', {
    attrs: {
      "ariaHidden": true,
      "name": "delete",
      "color": "secondary-text-color"
    }
  })], 1);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": e => _vm.$emit('publish', e)
    }
  }, [_c('SvgIcon', {
    attrs: {
      "ariaHidden": true,
      "name": "screen-share",
      "color": "secondary-text-color"
    }
  })], 1);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": e => _vm.$emit('publishChatMessageAsTextQnA', e)
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "chat-qna",
      "color": "secondary-text-color"
    }
  })], 1);
}];

;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarMessageItem.vue?vue&type=template&id=572b3df3

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarMessageItem.vue?vue&type=script&lang=js

/* harmony default export */ var SidebarMessageItemvue_type_script_lang_js = ({
  props: {
    currentUserMMID: String,
    message: Object,
    haveTextQNA: Boolean,
    show: {
      type: Object,
      default: () => ({
        smiley: false,
        pin: false,
        delete: false,
        postAsTextQnA: false
      })
    },
    isEventUsingSlidoQA: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    index: {
      type: [Number, null],
      default: null
    }
  },
  data: () => ({
    emojiPicker: null,
    messageOnEmojiPicker: null,
    inMessageFocusIndex: 0
  }),
  methods: {
    hideEmojiPicker() {
      this.emojiPicker?.close().then(() => {
        this.emojiPicker = null;
      });
      if (this.parentElement.parentElement) {
        this.parentElement.parentElement.closest('[role=row]')?.focus();
      }
    },
    toggleEmojiPicker() {
      this.parentElement = document.activeElement;
      if (this.emojiPicker) {
        this.hideEmojiPicker();
        return;
      }
      const triggerElement = this.$refs.emojiPicker;
      this.messageOnEmojiPicker = this.message;
      this.emojiPicker = createReactionEmojiPopup(triggerElement, this.$style.emojiPicker);
      this.emojiPicker.addEventListener('emoji:select', event => {
        this.postEmoji(event.emoji);
      });
      this.emojiPicker.addEventListener('picker:close', () => {
        this.hideEmojiPicker();
      });
      this.emojiPicker.open();
    },
    postEmoji(emoji) {
      if (this.isChatPostedAsQNA) {
        return;
      }
      this.$parent.react(emoji, this.messageOnEmojiPicker || this.message);
    },
    setInMessageFocusIndex(index) {
      this.inMessageFocusIndex = index;
    }
  },
  computed: {
    isSendingMessage() {
      return this.message.serverResponseState === 'unverified';
    },
    isChatPostedAsQNA() {
      if (!this.haveTextQNA) {
        return false;
      }
      return this.message?.isPostedAsQNA;
    },
    errorConfig() {
      const errorMessageMap = {
        send_message_error: {
          message: this.$t("Couldn't send message. Click here to retry."),
          retryAction: () => this.$emit('retrySendMessage')
        },
        add_emoji_error: {
          message: this.$t("Couldn't add emoji. Please try again.")
        },
        remove_emoji_error: {
          message: this.$t("Couldn't remove emoji. Please try again.")
        },
        delete_message_error: {
          message: this.$t("Couldn't delete message. Please try again.")
        },
        pin_message_error: {
          message: this.$t("Couldn't pin message. Please try again.")
        },
        unpin_message_error: {
          message: this.$t("Couldn't unpin message. Please try again.")
        },
        chat_qna_message_error: {
          message: this.$t("Couldn't post as Q&A. Please try again.")
        }
      };
      return errorMessageMap[this.message.error];
    },
    showMessageControls() {
      if (this.message.isMessageProcessing) {
        return false;
      }
      if (this.isSendingMessage) {
        return false;
      }
      if (this.message.error === 'send_message_error') {
        return false;
      }
      return this.show.smiley || this.show.pin || this.show.delete || this.show.publish || this.show.postAsTextQnA;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarMessageItem.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarChat_SidebarMessageItemvue_type_script_lang_js = (SidebarMessageItemvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarChat/SidebarMessageItem.vue?vue&type=style&index=0&id=572b3df3&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarMessageItemvue_type_style_index_0_id_572b3df3_prod_module_true_lang_scss = ({"root":"SidebarMessageItem_root_anc_a","messageitembody":"SidebarMessageItem_messageitembody_Hnlyk","reactiontools":"SidebarMessageItem_reactiontools_mr0xd","keepopen":"SidebarMessageItem_keepopen_MHwHs","gifRenderer":"SidebarMessageItem_gifRenderer_ZR3uM","userImageHolder":"SidebarMessageItem_userImageHolder_FPPZz","userImg":"SidebarMessageItem_userImg_SbfIF","noUserFound":"SidebarMessageItem_noUserFound_UcpCm","messageDetailsHolder":"SidebarMessageItem_messageDetailsHolder_lngtV","messagePropsHolder":"SidebarMessageItem_messagePropsHolder_Wuc5p","pin":"SidebarMessageItem_pin_VczzU","messageUserName":"SidebarMessageItem_messageUserName_I0xKL","messageSkeleton":"SidebarMessageItem_messageSkeleton_zdcNS","messageTime":"SidebarMessageItem_messageTime_x6nM8","chatReactionBar":"SidebarMessageItem_chatReactionBar_Qb9jT","textQnABar":"SidebarMessageItem_textQnABar_douOG","errorContainer":"SidebarMessageItem_errorContainer_QsUB6","sendMessageErrorButton":"SidebarMessageItem_sendMessageErrorButton_jFZJt","messageStyledText":"SidebarMessageItem_messageStyledText_mrFBB","messageTextBody":"SidebarMessageItem_messageTextBody_L3DC4","chatLinks":"SidebarMessageItem_chatLinks_ijE0f","loading":"SidebarMessageItem_loading_NmJp6","emojiPicker":"SidebarMessageItem_emojiPicker_LIUpI"});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarMessageItem.vue?vue&type=style&index=0&id=572b3df3&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarMessageItem.vue



;




function SidebarMessageItem_injectStyles (context) {
  
  this["$style"] = (SidebarMessageItemvue_type_style_index_0_id_572b3df3_prod_module_true_lang_scss.locals || SidebarMessageItemvue_type_style_index_0_id_572b3df3_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarMessageItem_component = normalizeComponent(
  SidebarChat_SidebarMessageItemvue_type_script_lang_js,
  SidebarMessageItemvue_type_template_id_572b3df3_render,
  SidebarMessageItemvue_type_template_id_572b3df3_staticRenderFns,
  false,
  SidebarMessageItem_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarMessageItem = (SidebarMessageItem_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarMessageDateDivider.vue?vue&type=template&id=353affac
var SidebarMessageDateDividervue_type_template_id_353affac_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.dayContainer
  }, [_c('StyledText', {
    attrs: {
      "align": "center",
      "display": "inline"
    }
  }, [_vm._v(" " + _vm._s(_vm.postedToday ? _vm.$options.$t('Today') : _vm.day) + " ")])], 1)]);
};
var SidebarMessageDateDividervue_type_template_id_353affac_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarMessageDateDivider.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarMessageDateDividervue_type_script_lang_js = ({
  name: 'SidebarP2PChat',
  props: {
    day: String,
    postedToday: Boolean
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarMessageDateDivider.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarChat_SidebarMessageDateDividervue_type_script_lang_js = (SidebarMessageDateDividervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarChat/SidebarMessageDateDivider.vue?vue&type=style&index=0&id=353affac&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarMessageDateDividervue_type_style_index_0_id_353affac_prod_lang_scss_module_true = ({"root":"SidebarMessageDateDivider_root_iSE3R","dayContainer":"SidebarMessageDateDivider_dayContainer_iIkeT"});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarMessageDateDivider.vue?vue&type=style&index=0&id=353affac&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarMessageDateDivider.vue



;




function SidebarMessageDateDivider_injectStyles (context) {
  
  this["$style"] = (SidebarMessageDateDividervue_type_style_index_0_id_353affac_prod_lang_scss_module_true.locals || SidebarMessageDateDividervue_type_style_index_0_id_353affac_prod_lang_scss_module_true)

}

/* normalize component */

var SidebarMessageDateDivider_component = normalizeComponent(
  SidebarChat_SidebarMessageDateDividervue_type_script_lang_js,
  SidebarMessageDateDividervue_type_template_id_353affac_render,
  SidebarMessageDateDividervue_type_template_id_353affac_staticRenderFns,
  false,
  SidebarMessageDateDivider_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarMessageDateDivider = (SidebarMessageDateDivider_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarChatInput.vue?vue&type=template&id=1e41f5fb
var SidebarChatInputvue_type_template_id_1e41f5fb_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('SidebarTextInputWrapper', {
    ref: "wrapper",
    attrs: {
      "disabled": _vm.disabled,
      "icon": _vm.icon,
      "disabled-placeholder": _vm.disabledPlaceholder,
      "wait": _vm.wait,
      "hasGifsEnabled": _vm.hasGifsEnabled,
      "testMarkerNameForSendButton": "sidebarMessageSendButton"
    },
    on: {
      "inputclick": _vm.focusChatInput,
      "send": _vm.sendMsg,
      "selectEmoji": _vm.onSelectEmoji,
      "openGifPickerDialog": function ($event) {
        return _vm.$emit('openGifPickerDialog');
      }
    }
  }, [_vm.placeholder && !_vm.value ? _c('StyledText', {
    class: {
      [_vm.$style.placeholder]: true,
      [_vm.$style.noIcon]: !_vm.icon
    },
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.placeholder) + " ")]) : _vm._e(), _c('div', {
    ref: "textarea",
    class: _vm.$style.root,
    attrs: {
      "contenteditable": "",
      "data-testmarker": "chatinput"
    },
    on: {
      "paste": function ($event) {
        $event.preventDefault();
        return _vm.handlepaste.apply(null, arguments);
      },
      "keydown": _vm.handleKeyboard,
      "keyup": function ($event) {
        _vm.value = _vm.$refs.textarea.innerHTML;
      }
    }
  })], 1);
};
var SidebarChatInputvue_type_template_id_1e41f5fb_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/utils/strings.js
const decodeHtmlEntities = text => {
  if (!text) {
    return text;
  }
  if (typeof text !== 'string') {
    return text;
  }
  const element = document.createElement('div');
  element.innerHTML = text;
  return element.textContent;
};
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarChatInput.vue?vue&type=script&lang=js

/* harmony default export */ var SidebarChatInputvue_type_script_lang_js = ({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    icon: String,
    placeholder: String,
    disabledPlaceholder: String,
    hasGifsEnabled: Boolean,
    wait: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    cursor: 0,
    value: '',
    messagesInInterval: 0
  }),
  methods: {
    handlepaste(e) {
      let text = e.clipboardData.getData('text/plain');
      this.$refs.textarea.innerHTML += text;
      this.value = this.$refs.textarea.innerHTML;
      this.$nextTick(() => {
        const textarea = this.$refs.textarea;
        const range = document.createRange();
        const selection = window.getSelection();
        let numlines = textarea.childNodes?.length;
        if (numlines === 0) {
          numlines = 1;
        }
        const lastLine = textarea.childNodes[numlines - 1];
        range.setStart(lastLine, lastLine?.length);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
      });
    },
    onSelectEmoji(emojiEvent) {
      var text = this.$refs.textarea?.innerHTML;
      text = decodeHtmlEntities(text);
      if (window.getSelection && window.getSelection().getRangeAt) {
        var selectedObj = window.getSelection();
        if (selectedObj.anchorNode.parentNode === this.$refs.textarea) {
          var range = selectedObj.getRangeAt(0);
          var rangeCount = 0;
          var childNodes = selectedObj.anchorNode.parentNode.childNodes;
          for (var i = 0; i < childNodes.length; i++) {
            if (childNodes[i] == selectedObj.anchorNode) {
              break;
            }
            if (childNodes[i].outerHTML) {
              rangeCount += childNodes[i].outerHTML.length;
            } else if (childNodes[i].nodeType == 3) {
              rangeCount += childNodes[i].textContent.length;
            }
          }
        } else {
          // If the selectedobject is not in the textarea then set things
          // such that the cursorPos will be 0, then set cursor value at
          // the end so that the emoji gets inserted at the end
          range = document.createRange();
          rangeCount = 0;
          this.cursor = text.length;
        }
      }
      var cursorPos = range.startOffset + rangeCount;
      if (cursorPos === 0) {
        cursorPos = this.cursor;
      }
      const left = text.slice(0, cursorPos);
      const right = text.slice(cursorPos, text.length);
      this.$refs.textarea.innerHTML = null;
      this.$refs.textarea.innerHTML = left + emojiEvent.emoji + right;
      var length = left.length + emojiEvent.emoji.length;
      this.cursor = length;
      range.setStart(this.$refs.textarea?.firstChild, length);
      range.collapse(true);
      selectedObj.removeAllRanges();
      selectedObj.addRange(range);
      this.value = this.$refs.textarea?.innerHTML;
    },
    handleKeyboard(ev) {
      if (ev.key === 'Enter' && !ev.shiftKey) {
        ev.preventDefault();
        this.sendMsg();
      }
    },
    sendMsg() {
      try {
        if (this.$refs.textarea) {
          this.$emit('send', this.$refs.textarea.innerHTML);
          this.$refs.textarea.innerHTML = null;
          // var node = this.$refs.textarea.parentNode.parentNode;
          // node.childNodes[2].style.display = "none";
          setTimeout(() => {
            if (this.$refs.textarea) {
              this.$refs.textarea.innerHTML = null;
              this.value = this.$refs.textarea.innerHTML;
              if (this.expandingChatInput && this.expanded) {
                this.toggleExpandingInput();
              }
            }
          }, 50);
        }
      } catch (err) {
        console.error('Error sending chat message!', err);
      }
    },
    focusChatInput(ev) {
      var node = this.$refs.textarea?.parentNode;
      if (ev?.target === node?.childNodes?.[1]) {
        ev.stopPropagation();
        if (window.getSelection && window.getSelection().getRangeAt) {
          var range = window.getSelection().getRangeAt(0);
          var selectedObj = window.getSelection();
          var rangeCount = 0;
          var childNodes = selectedObj.anchorNode.parentNode.childNodes;
          for (var i = 0; i < childNodes.length; i++) {
            if (childNodes[i] == selectedObj.anchorNode) {
              break;
            }
            if (childNodes[i].outerHTML) {
              rangeCount += childNodes[i].outerHTML.length;
            } else if (childNodes[i].nodeType == 3) {
              rangeCount += childNodes[i].textContent.length;
            }
          }
        }
        var cursorPos = range.startOffset + rangeCount;
        this.cursor = cursorPos;
      } else if (ev?.target === this.$refs.textarea) {
        this.$refs.textarea?.focus();
        this.cursor = 0;
        // node = this.$refs.textarea.parentNode.parentNode;
        // node.childNodes[2].style.display = "none";
      } else {
        this.$refs.textarea?.focus();
      }
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        if (!(window.mobileCheck && window.mobileCheck())) {
          el.focus();
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarChatInput.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarChat_SidebarChatInputvue_type_script_lang_js = (SidebarChatInputvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarChat/SidebarChatInput.vue?vue&type=style&index=0&id=1e41f5fb&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarChatInputvue_type_style_index_0_id_1e41f5fb_prod_module_true_lang_scss = ({"root":"SidebarChatInput_root_MfimB","placeholder":"SidebarChatInput_placeholder__BH_A","noIcon":"SidebarChatInput_noIcon_RsVFq"});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarChatInput.vue?vue&type=style&index=0&id=1e41f5fb&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarChatInput.vue



;




function SidebarChatInput_injectStyles (context) {
  
  this["$style"] = (SidebarChatInputvue_type_style_index_0_id_1e41f5fb_prod_module_true_lang_scss.locals || SidebarChatInputvue_type_style_index_0_id_1e41f5fb_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarChatInput_component = normalizeComponent(
  SidebarChat_SidebarChatInputvue_type_script_lang_js,
  SidebarChatInputvue_type_template_id_1e41f5fb_render,
  SidebarChatInputvue_type_template_id_1e41f5fb_staticRenderFns,
  false,
  SidebarChatInput_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarChatInput = (SidebarChatInput_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarMessageList.vue?vue&type=template&id=01542840
var SidebarMessageListvue_type_template_id_01542840_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "id": "sidebarMessageList"
    }
  }, [_c('SearchField', {
    attrs: {
      "placeholder": _vm.$options.$t('Search for attendee'),
      "fullWidth": true,
      "value": _vm.searchfilter
    },
    on: {
      "input": value => _vm.$emit('search', value)
    }
  }), _c('div', {
    class: _vm.$style.topseparator
  }), _c('div', {
    class: _vm.$style.item
  }, _vm._l(_vm.latestChats, function (chat) {
    return _c('span', {
      key: chat.id,
      class: _vm.$style.wrapper,
      on: {
        "click": () => _vm.$emit('click', chat)
      }
    }, [_c('SidebarMessageItem', {
      attrs: {
        "message": {
          text: chat.text === '@@gif@@' ? 'GIF' : chat.text,
          time: chat.time,
          name: chat?.user?.name,
          ...(chat.user || {})
        },
        "show": {
          pin: false,
          smiley: false,
          delete: false
        }
      },
      on: {
        "showUserModal": () => {},
        "pinPost": () => {},
        "delPost": () => {},
        "unpinPost": () => {},
        "react": () => {}
      }
    }), chat.total_unread > 0 ? _c('div', {
      class: _vm.$style.unreadcount
    }, [_c('StyledText', {
      attrs: {
        "color": "secondary-text-color"
      }
    }, [_vm._v(" " + _vm._s(chat.total_unread) + " ")])], 1) : _vm._e(), _c('div', {
      class: _vm.$style.topseparator
    })], 1);
  }), 0), _c('div', {
    class: _vm.$style.separator
  }, [_c('div', {
    class: _vm.$style.info
  }, [_c('StyledText', {
    attrs: {
      "variant": "body14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Up to date')) + " ")]), _c('StyledText', {
    attrs: {
      "variant": "body14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t("Start a new conversation, We think you'll enjoy")) + " ")]), _c('StyledText', {
    attrs: {
      "variant": "body14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('chatting with these recommended attendees!')) + " ")])], 1)]), _c('div', {
    class: _vm.$style.topseparator
  }), _vm.loadingUsers ? _c('ProgressBar', [_vm._v(" " + _vm._s(_vm.$options.$t('Searching')) + "... ")]) : [_vm.showprevious ? _c('ChatLoadMoreButton', {
    attrs: {
      "message": _vm.$options.$t('Load Previous')
    },
    on: {
      "click": () => _vm.$emit('showprevious')
    }
  }) : _vm._e(), _c('div', {
    class: _vm.$style.item
  }, _vm._l(_vm.recommendedUsers, function (user) {
    return _c('span', {
      key: user.id,
      class: _vm.$style.wrapper,
      on: {
        "click": () => _vm.$emit('click', user)
      }
    }, [_c('SidebarMessageItem', {
      attrs: {
        "message": {
          text: user.title || user.company,
          ...user.user
        },
        "show": {
          pin: false,
          smiley: false,
          delete: false
        }
      },
      on: {
        "showUserModal": () => {},
        "pinPost": () => {},
        "delPost": () => {},
        "unpinPost": () => {},
        "react": () => {}
      }
    }), _c('div', {
      class: _vm.$style.topseparator
    })], 1);
  }), 0), _vm.shownext ? _c('ChatLoadMoreButton', {
    style: {
      'margin-bottom': '15px'
    },
    attrs: {
      "message": _vm.$options.$t('Load Next')
    },
    on: {
      "click": () => _vm.$emit('shownext')
    }
  }) : _vm._e()]], 2);
};
var SidebarMessageListvue_type_template_id_01542840_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarMessageList.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarMessageListvue_type_script_lang_js = ({
  name: 'sidebar-message-list',
  props: {
    /**
     * Array of objects of the type
     * {
     *    id: string;
     *    user: object;
     *    text: string;
     *    time: string;
     * }
     */
    latestChats: {
      type: Array,
      default: () => []
    },
    searchfilter: {
      type: String,
      default: ''
    },
    recommendedUsers: {
      type: Array,
      default: () => []
    },
    showprevious: {
      type: Boolean,
      default: false
    },
    shownext: {
      type: Boolean,
      default: false
    },
    loadingUsers: Boolean
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarMessageList.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarChat_SidebarMessageListvue_type_script_lang_js = (SidebarMessageListvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarChat/SidebarMessageList.vue?vue&type=style&index=0&id=01542840&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarMessageListvue_type_style_index_0_id_01542840_prod_module_true_lang_scss = ({"root":"SidebarMessageList_root_nowIl","topseparator":"SidebarMessageList_topseparator_TOFHV","item":"SidebarMessageList_item_rTZcb","wrapper":"SidebarMessageList_wrapper_jC85W","unreadcount":"SidebarMessageList_unreadcount_nez7k","separator":"SidebarMessageList_separator_TXrTd","info":"SidebarMessageList_info_iKUhK"});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarMessageList.vue?vue&type=style&index=0&id=01542840&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarMessageList.vue



;




function SidebarMessageList_injectStyles (context) {
  
  this["$style"] = (SidebarMessageListvue_type_style_index_0_id_01542840_prod_module_true_lang_scss.locals || SidebarMessageListvue_type_style_index_0_id_01542840_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarMessageList_component = normalizeComponent(
  SidebarChat_SidebarMessageListvue_type_script_lang_js,
  SidebarMessageListvue_type_template_id_01542840_render,
  SidebarMessageListvue_type_template_id_01542840_staticRenderFns,
  false,
  SidebarMessageList_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarMessageList = (SidebarMessageList_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarP2PChat.vue?vue&type=template&id=275b21f8
var SidebarP2PChatvue_type_template_id_275b21f8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "id": "sidebarP2PChat",
      "data-branding-target": "p2p"
    }
  }, [_c('div', {
    class: _vm.$style.headerActions
  }, [_c('IconButton', {
    attrs: {
      "icon": "cross",
      "variant": "primary"
    },
    on: {
      "click": () => _vm.$emit('close')
    }
  }), _vm.showVideoCall ? _c('IconButton', {
    attrs: {
      "icon": "video-plus",
      "variant": "secondary",
      "ghost": "",
      "disabled": _vm.establishingVideoCall,
      "loading": _vm.establishingVideoCall
    },
    on: {
      "click": () => _vm.$emit('videocall', _vm.otherUser.id)
    }
  }) : _vm._e()], 1), _vm.loadingChannelCreation ? _c('SidebarEmptyState', {
    attrs: {
      "loading": true,
      "title": _vm.$options.$t('Loading Channel'),
      "message": _vm.$options.$t('Please wait while we fetch the channel')
    }
  }) : [_c('div', {
    class: _vm.$style.conversationHeader
  }, [_c('button', {
    class: _vm.$style.userDetailsButton,
    on: {
      "click": function ($event) {
        return _vm.$emit('showUserModal', _vm.otherUser.id);
      }
    }
  }, [_c('UserImage', {
    attrs: {
      "size": "small",
      "user": _vm.otherUser
    }
  }), _c('StyledText', {
    class: _vm.$style.name,
    attrs: {
      "variant": "heading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.otherUser && _vm.otherUser.name) + " ")])], 1)]), _vm.loadingChannelMessages === 'loading' ? _c('SidebarEmptyState', {
    attrs: {
      "loading": true,
      "title": _vm.$options.$t('Loading Chat'),
      "message": _vm.$options.$t('Please wait while we fetch the messages')
    }
  }) : [_c('div', {
    class: _vm.$style.messageblock
  }, [_vm.messages.length === 0 ? _c('SidebarEmptyState', {
    attrs: {
      "icon": "empty-message",
      "title": _vm.$options.$t('Start the conversation!'),
      "message": _vm.$options.$t('Send the first message')
    }
  }) : _vm._l(_vm.messages, function (message) {
    return _c('div', {
      key: message.id
    }, [message.dayChange && !_vm.allMessagesAreFromToday ? _c('SidebarMessageDateDivider', {
      attrs: {
        "postedToday": message.postedToday,
        "day": message.day
      }
    }) : _vm._e(), _vm.isVideoCallMessage(message) ? _c('SidebarVideoCallItem', {
      attrs: {
        "user": _vm.currentUser,
        "otherUser": _vm.otherUser,
        "messageUser": _vm.allUsersByMMID[message.user_id],
        "canJoinVideoCall": !!_vm.roomId(message.user_id)
      },
      on: {
        "join": function ($event) {
          _vm.$emit('join', _vm.roomId(message.user_id));
        },
        "openUserProfile": function ($event) {
          return _vm.$emit('showUserModal', $event);
        }
      }
    }) : _c('SidebarMessageItem', {
      attrs: {
        "message": {
          ...message,
          ...(_vm.currentUser && _vm.currentUser.mmid === message.user_id ? _vm.currentUser : _vm.otherUser)
        },
        "show": {
          pin: false,
          smiley: false,
          delete: false
        }
      },
      on: {
        "linkclicked": link => _vm.$emit('linkclicked', link),
        "buttonclicked": value => _vm.$emit('buttonclicked', value),
        "showUserModal": function ($event) {
          return _vm.$emit('showUserModal', _vm.currentUser && _vm.currentUser.mmid === message.user_id ? _vm.currentUser.id : _vm.otherUser.id);
        },
        "retrySendMessage": () => _vm.$emit('retrySendMessage', message),
        "pinPost": () => {},
        "delPost": () => {},
        "unpinPost": () => {},
        "react": () => {}
      }
    })], 1);
  })], 2), _vm.showChatInput ? _c('SidebarChatInput', {
    attrs: {
      "hasGifsEnabled": _vm.hasGifsEnabled
    },
    on: {
      "send": msg => _vm.$emit('sendDirectMessage', msg),
      "openGifPickerDialog": function ($event) {
        return _vm.$emit('openGifPickerDialog');
      }
    }
  }) : _vm._e()]]], 2);
};
var SidebarP2PChatvue_type_template_id_275b21f8_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarVideoCallItem.vue?vue&type=template&id=374b0a66
var SidebarVideoCallItemvue_type_template_id_374b0a66_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('div', {
    class: _vm.$style.left
  }, [_c('SvgIcon', {
    class: _vm.$style.videocamIcon,
    attrs: {
      "name": "videocam",
      "size": "x-small",
      "color": "secondary-text-color"
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "heading14"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Room')) + " ")])], 1), _c('div', {
    class: _vm.$style.right
  }, [_c('UserImage', {
    class: _vm.$style.userImage,
    attrs: {
      "user": _vm.user,
      "size": "small"
    },
    on: {
      "click": () => _vm.$emit('openUserProfile', _vm.user.id)
    }
  }), _c('UserImage', {
    class: _vm.$style.userImage,
    attrs: {
      "user": _vm.otherUser,
      "size": "small"
    },
    on: {
      "click": () => _vm.$emit('openUserProfile', _vm.otherUser.id)
    }
  })], 1)]), _c('p', {
    class: _vm.$style.message
  }, [_c('StyledText', {
    class: _vm.$style.otherUserName,
    attrs: {
      "variant": "heading14"
    }
  }, [_vm._v(" " + _vm._s(_vm.messageUser && _vm.messageUser.name) + " ")]), _c('StyledText', {
    attrs: {
      "variant": "body14"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('is inviting you to a video call')) + " ")])], 1), _c('div', {
    class: _vm.$style.joinButtonContainer
  }, [_c('PillButton', {
    attrs: {
      "disabled": !_vm.canJoinVideoCall,
      "size": "small",
      "center": ""
    },
    on: {
      "click": () => _vm.$emit('join')
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('ENTER ROOM')) + " ")])], 1)]);
};
var SidebarVideoCallItemvue_type_template_id_374b0a66_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarVideoCallItem.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarVideoCallItemvue_type_script_lang_js = ({
  props: {
    user: Object,
    otherUser: Object,
    messageUser: Object,
    canJoinVideoCall: Boolean
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarVideoCallItem.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarChat_SidebarVideoCallItemvue_type_script_lang_js = (SidebarVideoCallItemvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarChat/SidebarVideoCallItem.vue?vue&type=style&index=0&id=374b0a66&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarVideoCallItemvue_type_style_index_0_id_374b0a66_prod_module_true_lang_scss = ({"root":"SidebarVideoCallItem_root_hNE7R","header":"SidebarVideoCallItem_header_M7fdz","left":"SidebarVideoCallItem_left_Bq_LH","videocamIcon":"SidebarVideoCallItem_videocamIcon_VwCMO","right":"SidebarVideoCallItem_right_M0d6a","userImage":"SidebarVideoCallItem_userImage_aj9we","message":"SidebarVideoCallItem_message_cxgBM","joinButtonContainer":"SidebarVideoCallItem_joinButtonContainer_wXKC2"});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarVideoCallItem.vue?vue&type=style&index=0&id=374b0a66&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarVideoCallItem.vue



;




function SidebarVideoCallItem_injectStyles (context) {
  
  this["$style"] = (SidebarVideoCallItemvue_type_style_index_0_id_374b0a66_prod_module_true_lang_scss.locals || SidebarVideoCallItemvue_type_style_index_0_id_374b0a66_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarVideoCallItem_component = normalizeComponent(
  SidebarChat_SidebarVideoCallItemvue_type_script_lang_js,
  SidebarVideoCallItemvue_type_template_id_374b0a66_render,
  SidebarVideoCallItemvue_type_template_id_374b0a66_staticRenderFns,
  false,
  SidebarVideoCallItem_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarVideoCallItem = (SidebarVideoCallItem_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/SidebarP2PChat.vue?vue&type=script&lang=js

/* harmony default export */ var SidebarP2PChatvue_type_script_lang_js = ({
  components: {
    SidebarVideoCallItem: SidebarVideoCallItem
  },
  name: 'SidebarP2PChat',
  props: {
    otherUser: {
      type: Object,
      required: true
    },
    currentUser: {
      type: Object,
      required: true
    },
    messages: {
      type: Array,
      default: () => []
    },
    showVideoCall: {
      type: Boolean,
      default: true
    },
    establishingVideoCall: {
      type: Boolean
    },
    privateDiscussionRoomId: String,
    peerPrivateRoomId: String,
    loadingChannelCreation: {
      type: Boolean,
      default: false
    },
    loadingChannelMessages: {
      type: String,
      default: 'loaded'
    },
    showChatInput: {
      type: Boolean,
      default: true
    },
    hasGifsEnabled: Boolean,
    allUsersByMMID: Object
  },
  computed: {
    allMessagesAreFromToday() {
      return this.messages.findIndex(message => !message.postedToday) === -1;
    }
  },
  methods: {
    isVideoCallMessage(message) {
      return message?.props?.kind === 'P2PVideoCallPost';
    },
    roomId(messageUserMMID) {
      if (messageUserMMID === this.currentUser.mmid) {
        return this.privateDiscussionRoomId;
      }
      return this.peerPrivateRoomId;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarP2PChat.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarChat_SidebarP2PChatvue_type_script_lang_js = (SidebarP2PChatvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarChat/SidebarP2PChat.vue?vue&type=style&index=0&id=275b21f8&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarP2PChatvue_type_style_index_0_id_275b21f8_prod_lang_scss_module_true = ({"root":"SidebarP2PChat_root_GobtD","headerActions":"SidebarP2PChat_headerActions_L_YwF","conversationHeader":"SidebarP2PChat_conversationHeader_eIb51","userDetailsButton":"SidebarP2PChat_userDetailsButton_Zc7yJ","name":"SidebarP2PChat_name_UlSbt","messageblock":"SidebarP2PChat_messageblock_gwJwh"});
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarP2PChat.vue?vue&type=style&index=0&id=275b21f8&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/SidebarChat/SidebarP2PChat.vue



;




function SidebarP2PChat_injectStyles (context) {
  
  this["$style"] = (SidebarP2PChatvue_type_style_index_0_id_275b21f8_prod_lang_scss_module_true.locals || SidebarP2PChatvue_type_style_index_0_id_275b21f8_prod_lang_scss_module_true)

}

/* normalize component */

var SidebarP2PChat_component = normalizeComponent(
  SidebarChat_SidebarP2PChatvue_type_script_lang_js,
  SidebarP2PChatvue_type_template_id_275b21f8_render,
  SidebarP2PChatvue_type_template_id_275b21f8_staticRenderFns,
  false,
  SidebarP2PChat_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarP2PChat = (SidebarP2PChat_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/DriftEmbed.vue?vue&type=template&id=f813b880
var DriftEmbedvue_type_template_id_f813b880_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.driftLandingUrl ? _c('div', {
    class: _vm.$style.rowcontainer
  }, [_c('iframe', {
    class: _vm.$style.embedrow,
    attrs: {
      "id": "drift-embed-frame",
      "src": _vm.driftLandingUrl
    }
  })]) : _vm._e()]);
};
var DriftEmbedvue_type_template_id_f813b880_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/DriftEmbed.vue?vue&type=script&lang=js
/* harmony default export */ var DriftEmbedvue_type_script_lang_js = ({
  props: {
    driftLandingUrl: {
      type: String,
      default: ''
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarChat/DriftEmbed.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarChat_DriftEmbedvue_type_script_lang_js = (DriftEmbedvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarChat/DriftEmbed.vue?vue&type=style&index=0&id=f813b880&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var DriftEmbedvue_type_style_index_0_id_f813b880_prod_module_true_lang_scss = ({"root":"DriftEmbed_root_SrSTv","rowcontainer":"DriftEmbed_rowcontainer_V28_1","embedrow":"DriftEmbed_embedrow_GgqID"});
;// CONCATENATED MODULE: ./src/components/SidebarChat/DriftEmbed.vue?vue&type=style&index=0&id=f813b880&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarChat/DriftEmbed.vue



;




function DriftEmbed_injectStyles (context) {
  
  this["$style"] = (DriftEmbedvue_type_style_index_0_id_f813b880_prod_module_true_lang_scss.locals || DriftEmbedvue_type_style_index_0_id_f813b880_prod_module_true_lang_scss)

}

/* normalize component */

var DriftEmbed_component = normalizeComponent(
  SidebarChat_DriftEmbedvue_type_script_lang_js,
  DriftEmbedvue_type_template_id_f813b880_render,
  DriftEmbedvue_type_template_id_f813b880_staticRenderFns,
  false,
  DriftEmbed_injectStyles,
  null,
  null
  
)

/* harmony default export */ var DriftEmbed = (DriftEmbed_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/KudoEmbed.vue?vue&type=template&id=9e1bd9c2
var KudoEmbedvue_type_template_id_9e1bd9c2_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('iframe', {
    class: _vm.$style.root,
    attrs: {
      "name": "KUDO Widget",
      "src": _vm.kudoUrl,
      "width": "100%",
      "height": "100%",
      "scrolling": "no",
      "allowfullscreen": ""
    }
  });
};
var KudoEmbedvue_type_template_id_9e1bd9c2_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarChat/KudoEmbed.vue?vue&type=script&lang=js
/* harmony default export */ var KudoEmbedvue_type_script_lang_js = ({
  props: {
    kudoUrl: {
      type: String
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarChat/KudoEmbed.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarChat_KudoEmbedvue_type_script_lang_js = (KudoEmbedvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarChat/KudoEmbed.vue?vue&type=style&index=0&id=9e1bd9c2&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var KudoEmbedvue_type_style_index_0_id_9e1bd9c2_prod_module_true_lang_scss = ({"root":"KudoEmbed_root_mT750"});
;// CONCATENATED MODULE: ./src/components/SidebarChat/KudoEmbed.vue?vue&type=style&index=0&id=9e1bd9c2&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarChat/KudoEmbed.vue



;




function KudoEmbed_injectStyles (context) {
  
  this["$style"] = (KudoEmbedvue_type_style_index_0_id_9e1bd9c2_prod_module_true_lang_scss.locals || KudoEmbedvue_type_style_index_0_id_9e1bd9c2_prod_module_true_lang_scss)

}

/* normalize component */

var KudoEmbed_component = normalizeComponent(
  SidebarChat_KudoEmbedvue_type_script_lang_js,
  KudoEmbedvue_type_template_id_9e1bd9c2_render,
  KudoEmbedvue_type_template_id_9e1bd9c2_staticRenderFns,
  false,
  KudoEmbed_injectStyles,
  null,
  null
  
)

/* harmony default export */ var KudoEmbed = (KudoEmbed_component.exports);
;// CONCATENATED MODULE: ./src/components/SidebarChat/index.js










;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarPolls/SidebarPollsWidget.vue?vue&type=template&id=31429ff3&functional=true
var SidebarPollsWidgetvue_type_template_id_31429ff3_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "id": "sidebarPollsWidget"
    }
  }, [_vm.props.slidoPollURL ? [_c('SidebarWidgetContainer', {
    attrs: {
      "widgetLabel": _vm.$options.$t('Polls')
    }
  }, [_c('SlidoContainer', {
    attrs: {
      "slidoURL": _vm.props.slidoPollURL
    }
  })], 1)] : [_vm.props.loading === 'loading' ? _c('div', {
    class: _vm.$style.loadercontainer
  }, [_c('SidebarEmptyState', {
    attrs: {
      "loading": true,
      "title": _vm.$options.$t('Loading Poll'),
      "message": _vm.$options.$t('Please wait while we fetch the polls')
    }
  })], 1) : _vm._e(), _vm.props.loading === 'left' ? _c('div', {
    class: _vm.$style.rejoinbuttonContainer
  }, [_c('SidebarEmptyState', {
    attrs: {
      "failed": true,
      "title": _vm.$options.$t('Uh oh.. we couldn’t load the content'),
      "message": _vm.$options.$t('Please reload the page')
    },
    on: {
      "refresh": _vm.listeners.rejoinChat
    }
  })], 1) : _vm._e(), _c('SidebarWidgetContainer', {
    attrs: {
      "widgetLabel": _vm.$options.$t('Polls')
    }
  }, [_vm.props.loading === 'loaded' ? [_vm.props.isSpeaker ? _c('SpeakerPollView', {
    attrs: {
      "polls": _vm.props.pollQuestions,
      "currentPublishedPollID": _vm.props.currentPublishedPollID,
      "openedPollQuestionId": _vm.props.openedPollQuestionId,
      "publishedStage": _vm.props.publishedStage
    },
    on: {
      "openpoll": id => _vm.listeners.openpoll(id),
      "closepolling": _vm.listeners.closepolling,
      "publishpoll": _vm.listeners.publishpoll,
      "unpublishpoll": _vm.listeners.unpublishpoll
    }
  }) : _c('AttendeePollView', {
    attrs: {
      "openedPollQuestionId": _vm.props.openedPollQuestionId,
      "openPollDetails": _vm.props.openPollDetails,
      "isAnyAnswerLoading": _vm.props.isAnyAnswerLoading
    },
    on: {
      "handleuservote": id => _vm.listeners.handleuservote(id)
    }
  })] : _vm._e()], 2)]], 2);
};
var SidebarPollsWidgetvue_type_template_id_31429ff3_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarPolls/SidebarPollsWidget.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarPollsWidgetvue_type_script_lang_js = ({
  functional: true,
  props: {
    isSpeaker: {
      type: Boolean,
      default: false
    },
    pollQuestions: {
      type: Object,
      default() {
        return {};
      }
    },
    currentPublishedPollID: String,
    openedPollQuestionId: {
      type: String,
      default: ''
    },
    openPollDetails: {
      type: Object,
      default() {
        return {};
      }
    },
    loading: {
      type: String,
      default: 'loading'
    },
    isAnyAnswerLoading: {
      type: Boolean,
      default: false
    },
    publishedStage: {
      type: Object,
      default: () => ({})
    },
    slidoPollURL: {
      type: String,
      default: ''
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarPolls/SidebarPollsWidget.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarPolls_SidebarPollsWidgetvue_type_script_lang_js = (SidebarPollsWidgetvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarPolls/SidebarPollsWidget.vue?vue&type=style&index=0&id=31429ff3&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarPollsWidgetvue_type_style_index_0_id_31429ff3_prod_module_true_lang_scss = ({"root":"SidebarPollsWidget_root_PclzY","loadercontainer":"SidebarPollsWidget_loadercontainer_xzQPz","rejoinbuttonContainer":"SidebarPollsWidget_rejoinbuttonContainer_Hr4xu"});
;// CONCATENATED MODULE: ./src/components/SidebarPolls/SidebarPollsWidget.vue?vue&type=style&index=0&id=31429ff3&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarPolls/SidebarPollsWidget.vue



;




function SidebarPollsWidget_injectStyles (context) {
  
  this["$style"] = (SidebarPollsWidgetvue_type_style_index_0_id_31429ff3_prod_module_true_lang_scss.locals || SidebarPollsWidgetvue_type_style_index_0_id_31429ff3_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarPollsWidget_component = normalizeComponent(
  SidebarPolls_SidebarPollsWidgetvue_type_script_lang_js,
  SidebarPollsWidgetvue_type_template_id_31429ff3_functional_true_render,
  SidebarPollsWidgetvue_type_template_id_31429ff3_functional_true_staticRenderFns,
  true,
  SidebarPollsWidget_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarPollsWidget = (SidebarPollsWidget_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarPolls/SpeakerPollView.vue?vue&type=template&id=61aa376e
var SpeakerPollViewvue_type_template_id_61aa376e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isPollsEmpty() ? _c('div', {
    class: _vm.$style.emptyStateContainer
  }, [_c('SidebarEmptyState', {
    attrs: {
      "icon": "empty-poll",
      "title": _vm.$options.$t('No open polls'),
      "message": _vm.$options.$t('To launch a Poll, add the question and responses to this session in the Goldcast Admin Panel')
    }
  })], 1) : _vm.polls ? _c('div', {
    class: _vm.$style.pollViewContainer
  }, _vm._l(_vm.polls, function (poll) {
    return _c('div', {
      key: poll.id,
      class: _vm.$style.pollCard
    }, [_c('StyledText', {
      class: _vm.$style.question,
      attrs: {
        "variant": "subHeading15",
        "color": "primary-text-color"
      }
    }, [_vm._v(" " + _vm._s(poll && poll.question) + " ")]), poll && poll.answers ? _c('div', _vm._l(poll.answers, function (answer) {
      return _c('div', {
        key: answer.id,
        class: _vm.$style.answerContainer
      }, [_c('StyledText', {
        class: {
          [_vm.$style.answerText]: true,
          [_vm.$style.bestAnswer]: _vm.highestVotedAnswers[poll.id] === answer.id
        },
        style: {
          '--size': `${_vm.getPollPercentage(answer.votes, poll.totalVotes)}`
        },
        attrs: {
          "variant": "subHeading13",
          "color": "primary-text-color"
        }
      }, [_c('span', [_vm._v(_vm._s(answer && answer.answer))])]), _c('StyledText', {
        class: _vm.$style.votesHolder,
        attrs: {
          "variant": "body13",
          "color": "primary-text-color"
        }
      }, [_vm._v(" " + _vm._s(answer && answer.votes) + " " + _vm._s(answer && answer.votes > 1 ? _vm.$t('Votes') : _vm.$t('Vote')) + " ")])], 1);
    }), 0) : _vm._e(), _c('div', {
      class: _vm.$style.speakerButtonsHolder
    }, [_vm.currentPublishedPollID === poll.id ? _c('PillButton', {
      attrs: {
        "boldText": "",
        "uppercase": "",
        "size": "x-small",
        "icon": "stop-screen-share"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('unpublishpoll');
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Stop Sharing')) + " ")]) : _c('GTooltip', {
      attrs: {
        "disabled": _vm.publishedStage.isOverridable,
        "text": _vm.$options.$t(`Can't publish polls while something else is being presented on stage`)
      }
    }, [_c('IconButton', {
      class: _vm.$style.icon,
      attrs: {
        "icon": "screen-share",
        "disabled": !_vm.publishedStage.isOverridable
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('publishpoll', poll.id);
        }
      }
    })], 1), poll.id === _vm.openedPollQuestionId ? _c('PillButton', {
      attrs: {
        "boldText": "",
        "uppercase": "",
        "center": "",
        "size": "x-small"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('closepolling');
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Close')) + " ")]) : _c('PillButton', {
      attrs: {
        "boldText": "",
        "size": "x-small",
        "uppercase": "",
        "center": "",
        "disabled": !!_vm.openedPollQuestionId && poll.id !== _vm.openedPollQuestionId
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('openpoll', poll.id);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Open')) + " ")])], 1)], 1);
  }), 0) : _vm._e();
};
var SpeakerPollViewvue_type_template_id_61aa376e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarPolls/SpeakerPollView.vue?vue&type=script&lang=js
/* harmony default export */ var SpeakerPollViewvue_type_script_lang_js = ({
  props: {
    polls: {
      type: Object,
      default() {
        return {};
      }
    },
    currentPublishedPollID: String,
    openedPollQuestionId: {
      type: String,
      default: ''
    },
    publishedStage: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    highestVotedAnswers() {
      return Object.values(this.polls || {}).reduce((acc, poll) => {
        const answers = poll.answers;
        acc[poll.id] = Object.values(answers).reduce((a, {
          votes,
          id
        }) => {
          return votes > a.votes ? {
            votes,
            id
          } : a;
        }, {
          id: null,
          votes: 0
        }).id;
        return acc;
      }, {});
    }
  },
  methods: {
    getPollPercentage(votes, totalVotes) {
      try {
        const percentage = (votes / totalVotes * 100).toFixed(2);
        return `${isNaN(percentage) ? 0.0 : percentage}%`;
      } catch (err) {
        console.error('Error converting the vote count to percentage!');
        return `0%`;
      }
    },
    isPollsEmpty() {
      return !this.polls || Object.values(this.polls).length === 0;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarPolls/SpeakerPollView.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarPolls_SpeakerPollViewvue_type_script_lang_js = (SpeakerPollViewvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarPolls/SpeakerPollView.vue?vue&type=style&index=0&id=61aa376e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SpeakerPollViewvue_type_style_index_0_id_61aa376e_prod_module_true_lang_scss = ({"emptyStateContainer":"SpeakerPollView_emptyStateContainer_In7I1","pollViewContainer":"SpeakerPollView_pollViewContainer_vV5rA","pollCard":"SpeakerPollView_pollCard_XYJuh","question":"SpeakerPollView_question_LwtH9","answerContainer":"SpeakerPollView_answerContainer_P6J2L","answerText":"SpeakerPollView_answerText_qFbKy","bestAnswer":"SpeakerPollView_bestAnswer_kue5m","votesHolder":"SpeakerPollView_votesHolder_rVRWS","speakerButtonsHolder":"SpeakerPollView_speakerButtonsHolder_ogSHu","icon":"SpeakerPollView_icon_Do_QB"});
;// CONCATENATED MODULE: ./src/components/SidebarPolls/SpeakerPollView.vue?vue&type=style&index=0&id=61aa376e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarPolls/SpeakerPollView.vue



;




function SpeakerPollView_injectStyles (context) {
  
  this["$style"] = (SpeakerPollViewvue_type_style_index_0_id_61aa376e_prod_module_true_lang_scss.locals || SpeakerPollViewvue_type_style_index_0_id_61aa376e_prod_module_true_lang_scss)

}

/* normalize component */

var SpeakerPollView_component = normalizeComponent(
  SidebarPolls_SpeakerPollViewvue_type_script_lang_js,
  SpeakerPollViewvue_type_template_id_61aa376e_render,
  SpeakerPollViewvue_type_template_id_61aa376e_staticRenderFns,
  false,
  SpeakerPollView_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SpeakerPollView = (SpeakerPollView_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarPolls/AttendeePollView.vue?vue&type=template&id=2bf39c0e&functional=true
var AttendeePollViewvue_type_template_id_2bf39c0e_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.main
  }, [!_vm.props.openPollDetails || !_vm.props.openPollDetails.id ? _c('div', {
    class: _vm.$style.emptyState
  }, [_c('SidebarEmptyState', {
    attrs: {
      "icon": "empty-poll",
      "title": _vm.$options.$t('No open polls'),
      "message": _vm.$options.$t('Check back later to see if a poll opens up!')
    }
  })], 1) : _vm.props.openPollDetails && _vm.props.openPollDetails.id ? _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: _vm.$style.question,
    attrs: {
      "variant": "body15"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.openPollDetails && _vm.props.openPollDetails.question) + " ")]), _vm._l(_vm.props.openPollDetails.answers, function (answer) {
    return _c('span', {
      key: answer.id
    }, [_c('PillButton', {
      class: {
        [_vm.$style.answerBtn]: true,
        [_vm.$style.selectedCloseBtn]: (_vm.props.openPollDetails.votedAnswers || []).some(answerID => answerID === answer.id)
      },
      attrs: {
        "loading": answer.loading,
        "disabled": _vm.props.isAnyAnswerLoading,
        "boldText": "",
        "allowMultiLine": true,
        "center": ""
      },
      on: {
        "click": function ($event) {
          return _vm.listeners.handleuservote(answer.id);
        }
      }
    }, [_vm._v(" " + _vm._s(answer.answer) + " ")])], 1);
  })], 2) : _vm._e()]);
};
var AttendeePollViewvue_type_template_id_2bf39c0e_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarPolls/AttendeePollView.vue?vue&type=script&lang=js
/* harmony default export */ var AttendeePollViewvue_type_script_lang_js = ({
  functional: true,
  props: {
    openPollDetails: {
      type: Object,
      default() {
        return {};
      }
    },
    isAnyAnswerLoading: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarPolls/AttendeePollView.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarPolls_AttendeePollViewvue_type_script_lang_js = (AttendeePollViewvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarPolls/AttendeePollView.vue?vue&type=style&index=0&id=2bf39c0e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var AttendeePollViewvue_type_style_index_0_id_2bf39c0e_prod_module_true_lang_scss = ({"main":"AttendeePollView_main_Gy4V6","emptyState":"AttendeePollView_emptyState_Bi8ml","root":"AttendeePollView_root_DpHKR","question":"AttendeePollView_question_K3uID","answerBtn":"AttendeePollView_answerBtn_oWAXP","selectedCloseBtn":"AttendeePollView_selectedCloseBtn_xnkwu"});
;// CONCATENATED MODULE: ./src/components/SidebarPolls/AttendeePollView.vue?vue&type=style&index=0&id=2bf39c0e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarPolls/AttendeePollView.vue



;




function AttendeePollView_injectStyles (context) {
  
  this["$style"] = (AttendeePollViewvue_type_style_index_0_id_2bf39c0e_prod_module_true_lang_scss.locals || AttendeePollViewvue_type_style_index_0_id_2bf39c0e_prod_module_true_lang_scss)

}

/* normalize component */

var AttendeePollView_component = normalizeComponent(
  SidebarPolls_AttendeePollViewvue_type_script_lang_js,
  AttendeePollViewvue_type_template_id_2bf39c0e_functional_true_render,
  AttendeePollViewvue_type_template_id_2bf39c0e_functional_true_staticRenderFns,
  true,
  AttendeePollView_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AttendeePollView = (AttendeePollView_component.exports);
;// CONCATENATED MODULE: ./src/components/SidebarPolls/index.js



;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarQA/SidebarQAWidget.vue?vue&type=template&id=72f1abe4
var SidebarQAWidgetvue_type_template_id_72f1abe4_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "id": "sidebarQAWidget"
    }
  }, [_c('SidebarWidgetContainer', [_vm.hasTextQna && _vm.hasVideoQna && _vm.isSpeakerOrOrganizer ? _c('div', {
    class: _vm.$style.headerSwitchableTabs
  }, [_c('div', {
    class: _vm.$style.headerHolder
  }, [_c('div', {
    class: [_vm.$style.clickableWidgetHeaderTabs, _vm.selectedQnaType === 'text' && _vm.$style.selected],
    on: {
      "click": function ($event) {
        return _vm.$emit('toggleqnatab', 'text');
      }
    }
  }, [_c('GTooltip', {
    attrs: {
      "text": _vm.$options.$t('Text Q&A')
    }
  }, [_c('StyledText', {
    class: [_vm.$style.widgetLabel, _vm.$style.overflowElips]
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Text Q&A')) + " ")])], 1)], 1), _c('div', {
    class: [_vm.$style.clickableWidgetHeaderTabs, _vm.selectedQnaType === 'video' && _vm.$style.selected],
    on: {
      "click": function ($event) {
        return _vm.$emit('toggleqnatab', 'video');
      }
    }
  }, [_c('GTooltip', {
    attrs: {
      "text": _vm.$options.$t('Video Q&A')
    }
  }, [_c('StyledText', {
    class: [_vm.$style.widgetLabel, _vm.$style.overflowElips]
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Video Q&A')) + " ")])], 1)], 1)])]) : _vm._e(), _c('div', {
    class: [_vm.$style.qnaWidget, _vm.hasTextQna && _vm.hasVideoQna && _vm.isSpeakerOrOrganizer && _vm.$style.speakerSection]
  }, [_vm.hasTextQna && (_vm.selectedQnaType === 'text' || !_vm.hasVideoQna && _vm.noAttendeeOnStage) ? [_vm.slidoQAURL ? _c('SlidoContainer', {
    attrs: {
      "slidoURL": _vm.slidoQAURL
    }
  }) : _c('SidebarTextQA', {
    attrs: {
      "textQnAChannelStatus": _vm.textQnAChannelStatus,
      "textQNADetails": _vm.textQNADetails,
      "currentUser": _vm.currentUser,
      "isSpeakerOrOrganizer": _vm.isSpeakerOrOrganizer,
      "isAskAnonymouslyChecked": _vm.isAskAnonymouslyChecked,
      "askAnonymouslyAllowed": _vm.askAnonymouslyAllowed,
      "disableNewTextQA": _vm.disableNewTextQA,
      "sharingEnabled": _vm.sharingEnabled,
      "textQnAEmptyStateConfig": _vm.textQnAEmptyStateConfig,
      "currentPublishedTextQNAId": _vm.currentPublishedTextQNAId,
      "textQNAAnswerMeta": _vm.textQNAAnswerMeta,
      "isTextQNAUpvotingDisabled": _vm.isTextQNAUpvotingDisabled,
      "hasReachedUserUnmoderatedQuestionsLimit": _vm.hasReachedUserUnmoderatedQuestionsLimit,
      "paginateQAPosts": _vm.paginateQAPosts,
      "paginatedQAListSize": _vm.paginatedQAListSize
    },
    on: {
      "linkClicked": data => _vm.$emit('linkClicked', data),
      "toggleAskAnonymous": function ($event) {
        return _vm.$emit('toggleAskAnonymous');
      },
      "unmarkTextQNAPriority": id => _vm.$emit('unmarkTextQNAPriority', id),
      "markTextQNAPriority": id => _vm.$emit('markTextQNAPriority', id),
      "changeSortMethod": $event => _vm.$emit('changeSortMethod', $event),
      "changeFilterMethod": $event => _vm.$emit('changeFilterMethod', $event),
      "deleteQuestion": id => _vm.$emit('deleteQuestion', id),
      "sendnewtextqna": (qaText, askAnonymously) => _vm.$emit('sendnewtextqna', qaText, askAnonymously),
      "toggleupvote": id => _vm.$emit('toggleupvote', id),
      "approveqnapost": id => _vm.$emit('approveqnapost', id),
      "publishqnapost": id => _vm.$emit('publishqnapost', id),
      "markasanswered": id => _vm.$emit('markasanswered', id),
      "markunasanswered": ids => _vm.$emit('markunasanswered', ids),
      "answertextqna": details => _vm.$emit('answertextqna', details),
      "userClicked": function ($event) {
        return _vm.$emit('userClicked', $event);
      },
      "rejoinChat": function ($event) {
        return _vm.$emit('rejoinChat');
      }
    }
  })] : _vm._e(), _vm.isSpeakerOrOrganizer && (_vm.selectedQnaType === 'video' || !_vm.hasTextQna) && (_vm.hasVideoQna || !_vm.noAttendeeOnStage) ? _c('SidebarVideoQA', {
    attrs: {
      "videoQNARequests": _vm.videoQNARequests
    },
    on: {
      "acceptVideoQNARequest": requestId => _vm.$emit('acceptVideoQNARequest', requestId),
      "rejectVideoQNARequest": requestId => _vm.$emit('rejectVideoQNARequest', requestId),
      "completeVideoQNARequest": requestId => _vm.$emit('completeVideoQNARequest', requestId)
    }
  }) : _vm._e()], 2)])], 1);
};
var SidebarQAWidgetvue_type_template_id_72f1abe4_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarQA/SidebarQAWidget.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarQAWidgetvue_type_script_lang_js = ({
  props: {
    currentPublishedTextQNAId: {
      type: String,
      default: ''
    },
    askAnonymouslyAllowed: {
      type: Boolean,
      default: true
    },
    isAskAnonymouslyChecked: {
      type: Boolean,
      default: true
    },
    currentUser: {
      type: Object,
      default: () => {
        return {
          name: '',
          image: '',
          id: ''
        };
      }
    },
    isSpeakerOrOrganizer: {
      type: Boolean,
      default: false
    },
    hasTextQna: {
      type: Boolean,
      default: false
    },
    hasVideoQna: {
      type: Boolean,
      default: false
    },
    noAttendeeOnStage: {
      type: Boolean,
      default: true
    },
    /**
     * Can be 'text', 'video' only works if both text qna and video qna is active, otherwise the default one is shown
     */
    selectedQnaType: {
      type: String,
      default: 'text'
    },
    sharingEnabled: Boolean,
    textQnAEmptyStateConfig: {
      type: Object,
      default: () => {
        return {
          title: '',
          message: ''
        };
      }
    },
    textQNAAnswerMeta: {
      type: Object,
      default: () => {
        return {
          showAnswerersIdentity: true,
          answerersAlias: ''
        };
      }
    },
    textQNADetails: {
      type: Object,
      default: () => {
        return {
          questions: [],
          totalNoOfQuestions: 0,
          newQnaPresent: Boolean,
          numberOfUserUnmoddedPosts: 0,
          sortedBy: {
            label: 'Upvotes',
            value: 'upvotes'
          },
          filteredBy: {
            label: 'All',
            value: 'all'
          },
          sortingMethods: [],
          filteringMethods: []
        };
      }
    },
    videoQNARequests: {
      type: Array,
      default() {
        return [];
      }
    },
    textQnAChannelStatus: {
      type: String
    },
    disableNewTextQA: {
      type: Boolean,
      default: false
    },
    slidoQAURL: {
      type: String,
      default: ''
    },
    isTextQNAUpvotingDisabled: Boolean,
    hasReachedUserUnmoderatedQuestionsLimit: Boolean,
    paginateQAPosts: Boolean,
    paginatedQAListSize: Number
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarQA/SidebarQAWidget.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarQA_SidebarQAWidgetvue_type_script_lang_js = (SidebarQAWidgetvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarQA/SidebarQAWidget.vue?vue&type=style&index=0&id=72f1abe4&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarQAWidgetvue_type_style_index_0_id_72f1abe4_prod_module_true_lang_scss = ({"root":"SidebarQAWidget_root_otuAQ","headerSwitchableTabs":"SidebarQAWidget_headerSwitchableTabs_SAphw","headerHolder":"SidebarQAWidget_headerHolder_Lt8h4","clickableWidgetHeaderTabs":"SidebarQAWidget_clickableWidgetHeaderTabs_BGnwc","widgetLabel":"SidebarQAWidget_widgetLabel_Ee2G6","overflowElips":"SidebarQAWidget_overflowElips_AILXx","selected":"SidebarQAWidget_selected_dNQ8d","divider":"SidebarQAWidget_divider_hK5xQ","qnaWidget":"SidebarQAWidget_qnaWidget_DpRTV","speakerSection":"SidebarQAWidget_speakerSection_dTfwf"});
;// CONCATENATED MODULE: ./src/components/SidebarQA/SidebarQAWidget.vue?vue&type=style&index=0&id=72f1abe4&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarQA/SidebarQAWidget.vue



;




function SidebarQAWidget_injectStyles (context) {
  
  this["$style"] = (SidebarQAWidgetvue_type_style_index_0_id_72f1abe4_prod_module_true_lang_scss.locals || SidebarQAWidgetvue_type_style_index_0_id_72f1abe4_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarQAWidget_component = normalizeComponent(
  SidebarQA_SidebarQAWidgetvue_type_script_lang_js,
  SidebarQAWidgetvue_type_template_id_72f1abe4_render,
  SidebarQAWidgetvue_type_template_id_72f1abe4_staticRenderFns,
  false,
  SidebarQAWidget_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarQAWidget = (SidebarQAWidget_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarQA/SidebarTextQA.vue?vue&type=template&id=82ea7868
var SidebarTextQAvue_type_template_id_82ea7868_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.textQNADetails.sortingMethods || _vm.textQNADetails.filteringMethods ? [_c('div', {
    class: _vm.$style.filterAndSortBar
  }, [_vm.textQNADetails.filteringMethods ? _c('NewSimpleSelect', {
    attrs: {
      "theme": "secondary",
      "bordered": false,
      "options": _vm.textQNADetails.filteringMethods,
      "value": _vm.textQNADetails.filteredBy
    },
    on: {
      "input": $event => _vm.$emit('changeFilterMethod', $event)
    }
  }) : _vm._e(), _vm.textQNADetails.sortingMethods ? _c('NewSimpleSelect', {
    attrs: {
      "theme": "secondary",
      "bordered": false,
      "options": _vm.textQNADetails.sortingMethods,
      "value": _vm.textQNADetails.sortedBy
    },
    on: {
      "input": $event => _vm.$emit('changeSortMethod', $event)
    }
  }) : _vm._e()], 1), _c('div', {
    class: _vm.$style.divider
  })] : _vm._e(), _vm.textQnAChannelStatus === 'loading' ? _c('SidebarEmptyState', {
    attrs: {
      "loading": true,
      "title": _vm.$options.$t('Loading Q&A'),
      "message": _vm.$options.$t('Please wait while we fetch the Q&A')
    }
  }) : _vm.textQnAChannelStatus === 'left' ? _c('SidebarEmptyState', {
    attrs: {
      "failed": true,
      "title": _vm.$options.$t(`Uh oh.. we couldn't load the content`),
      "message": _vm.$options.$t(`Please reload the page`)
    },
    on: {
      "refresh": function ($event) {
        return _vm.$emit('rejoinChat');
      }
    }
  }) : _vm.textQNADetails.questions.length === 0 ? _c('SidebarEmptyState', {
    attrs: {
      "icon": "empty-question",
      "title": _vm.textQnAEmptyStateConfig.title,
      "message": _vm.textQnAEmptyStateConfig.message
    }
  }) : [_c('div', {
    class: [_vm.$style.textQnaItemsContainerHolder],
    attrs: {
      "id": "text_qna_posts_list"
    }
  }, [_vm.textQNADetails && _vm.textQNADetails.questions ? _c('div', {
    class: _vm.$style.textQNAsHolder
  }, [_vm.paginateQAPosts && this.qAListFirstDisplayedPostIndex != 0 ? _c('div', {
    class: _vm.$style.loadMoreButton,
    on: {
      "click": _vm.loadPreviousQNAs
    }
  }, [_c('StyledText', {
    class: _vm.$style.loadMoreBtnText,
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Load previous')) + " ")])], 1) : _vm._e(), _vm._l(_vm.paginatedQuestionList, function (question) {
    return _c('div', {
      key: question.id,
      ref: `tqna_question${question.id}`,
      refInFor: true,
      class: _vm.$style.questionsHolder
    }, [_c('TextQNAItem', {
      attrs: {
        "id": question.id,
        "currentUser": _vm.currentUser,
        "text": question.questionText,
        "time": question.time,
        "user": question.user,
        "upvotedByUser": question.upvotedByUser,
        "totalUpvotes": question.totalUpvotes,
        "isSpeakerOrOrganizer": _vm.isSpeakerOrOrganizer,
        "approvedByMods": question.approvedByMods,
        "answered": question.answered,
        "isPrioritized": question.isPrioritized,
        "answer": question.answer,
        "answerId": question.answerId,
        "sharingEnabled": _vm.sharingEnabled,
        "textQNAAnswerMeta": _vm.textQNAAnswerMeta,
        "published": question.id === _vm.currentPublishedTextQNAId,
        "isTextQNAUpvotingDisabled": _vm.isTextQNAUpvotingDisabled,
        "answeredByUser": question.answeredByUser,
        "hasReachedUserUnmoderatedQuestionsLimit": _vm.hasReachedUserUnmoderatedQuestionsLimit
      },
      on: {
        "linkClicked": data => _vm.$emit('linkClicked', data),
        "unmarkTextQNAPriority": id => _vm.$emit('unmarkTextQNAPriority', id),
        "markTextQNAPriority": id => _vm.$emit('markTextQNAPriority', id),
        "deleteQuestion": id => _vm.$emit('deleteQuestion', id),
        "userClicked": function ($event) {
          return _vm.$emit('userClicked', $event);
        },
        "voteforquestion": id => _vm.$emit('toggleupvote', id),
        "approveqnapost": id => _vm.$emit('approveqnapost', id),
        "publishqnapost": id => _vm.$emit('publishqnapost', id),
        "markunasanswered": ids => _vm.$emit('markunasanswered', ids),
        "markasanswered": id => _vm.$emit('markasanswered', id),
        "answertextqna": details => _vm.$emit('answertextqna', details)
      }
    })], 1);
  }), _vm.paginateQAPosts && this.paginatedQAListSize && this.textQNADetails.questions.length && this.qAListFirstDisplayedPostIndex + this.paginatedQAListSize < this.textQNADetails.questions.length ? _c('div', {
    class: _vm.$style.loadMoreButton,
    on: {
      "click": _vm.loadNextQNAs
    }
  }, [_c('StyledText', {
    class: _vm.$style.loadMoreBtnText,
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Load more')) + " ")])], 1) : _vm._e()], 2) : _vm._e()])], _vm.textQnAChannelStatus === 'loaded' && !_vm.disableNewTextQA ? _c('div', {
    class: _vm.$style.textQnAInputWrapper
  }, [_c('SidebarChatInput', {
    attrs: {
      "placeholder": _vm.$options.$t('Ask a question')
    },
    on: {
      "send": _vm.sendquestion
    }
  }), _vm.askAnonymouslyAllowed ? _c('div', {
    class: _vm.$style.anonButton
  }, [_c('StyledText', {
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(_vm._s(_vm.$options.$t('Hide Name')))]), _c('GCheckbox', {
    attrs: {
      "checked": _vm.isAskAnonymouslyChecked,
      "icon": ''
    },
    on: {
      "toggle": function ($event) {
        return _vm.$emit('toggleAskAnonymous');
      }
    }
  })], 1) : _vm._e()], 1) : _vm.disableNewTextQA ? _c('StyledText', {
    class: _vm.$style.disabledQA,
    attrs: {
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.disabledTextQAMessage) + " ")]) : _vm._e()], 2);
};
var SidebarTextQAvue_type_template_id_82ea7868_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarQA/SidebarTextQA.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarTextQAvue_type_script_lang_js = ({
  props: {
    textQnAChannelStatus: {
      type: String
    },
    isSpeakerOrOrganizer: {
      type: Boolean,
      default: false
    },
    askAnonymouslyAllowed: {
      type: Boolean,
      default: true
    },
    sharingEnabled: Boolean,
    currentUser: {
      type: Object,
      default: () => {
        return {
          name: '',
          image: '',
          id: ''
        };
      }
    },
    textQnAEmptyStateConfig: {
      type: Object,
      default: () => {
        return {
          title: '',
          message: ''
        };
      }
    },
    textQNAAnswerMeta: Object,
    textQNADetails: {
      type: Object,
      default: () => {
        return {
          totalNoOfQuestions: 0,
          questions: [],
          newQnaPresent: Boolean,
          numberOfUserUnmoddedPosts: 0,
          sortedBy: {
            label: 'Upvotes',
            value: 'upvotes'
          },
          filteredBy: {
            label: 'All',
            value: 'all'
          },
          sortingMethods: [],
          filteringMethods: []
        };
      }
    },
    isAskAnonymouslyChecked: {
      type: Boolean,
      default: true
    },
    currentPublishedTextQNAId: {
      type: String,
      default: ''
    },
    disableNewTextQA: {
      type: Boolean,
      default: false
    },
    isTextQNAUpvotingDisabled: Boolean,
    hasReachedUserUnmoderatedQuestionsLimit: Boolean,
    paginateQAPosts: Boolean,
    paginatedQAListSize: Number
  },
  data() {
    return {
      qAListFirstDisplayedPostIndex: 0
    };
  },
  methods: {
    sendquestion(qaText) {
      if (qaText) {
        if (this.askAnonymouslyAllowed) {
          this.$emit('sendnewtextqna', qaText, this.isAskAnonymouslyChecked);
        } else {
          this.$emit('sendnewtextqna', qaText, false);
        }
      }
    },
    loadPreviousQNAs() {
      this.qAListFirstDisplayedPostIndex = this.qAListFirstDisplayedPostIndex - this.paginatedQAListSize;
      if (this.qAListFirstDisplayedPostIndex < 0) {
        this.qAListFirstDisplayedPostIndex = 0;
      }
      this.scrollToBottom();
    },
    loadNextQNAs() {
      if (this.qAListLastDisplayedPostIndex > this.textQNADetails?.questions?.length) {
        return;
      }
      this.qAListFirstDisplayedPostIndex = this.qAListFirstDisplayedPostIndex + this.paginatedQAListSize;
      this.scrollToTop();
    },
    scrollToTop() {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const qnaPostListElem = document.getElementById('text_qna_posts_list');
          if (qnaPostListElem) {
            qnaPostListElem.scrollTop = 0;
          }
        }, 300);
      });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const qnaPostListElem = document.getElementById('text_qna_posts_list');
          if (qnaPostListElem) {
            qnaPostListElem.scrollTop = qnaPostListElem.scrollHeight;
          }
        }, 300);
      });
    }
  },
  computed: {
    disabledTextQAMessage() {
      //sharing enabled is false only when demandMode is true
      if (!this.sharingEnabled) {
        return this.$options.$t('Text Q&A is disabled in On Demand mode.');
      }
      if (this.hasReachedUserUnmoderatedQuestionsLimit) {
        return this.$options.$t('Thanks for submitting your questions. You will be able to submit another once one of your current ones has been approved.');
      }
      if (this.isSpeakerOrOrganizer) {
        return this.$options.$t("Text Q&A limit reached. Attendees won't be able to ask new questions.");
      }
      return this.$options.$t('Sorry! QA is disabled for the moment. You will be able to submit a question once qa is enabled again.');
    },
    paginatedQuestionList() {
      if (!this.paginateQAPosts || this.paginatedQAListSize < 1 || !this.textQNADetails?.questions) {
        return this.textQNADetails?.questions;
      }
      const paginatedListFirstPostIndex = this.qAListFirstDisplayedPostIndex || 0;
      const pageSize = this.paginatedQAListSize;
      const paginatedListLastPostIndex = paginatedListFirstPostIndex + pageSize;
      const questions = this.textQNADetails?.questions.slice(paginatedListFirstPostIndex, paginatedListLastPostIndex);
      return questions;
    }
  },
  watch: {
    'textQNADetails.filteredBy': function (newVal, oldVal) {
      if (newVal?.value !== oldVal?.value) {
        this.qAListFirstDisplayedPostIndex = 0;
        this.scrollToTop();
      }
    },
    'textQNADetails.sortedBy': function (newVal, oldVal) {
      if (newVal?.value !== oldVal?.value) {
        this.qAListFirstDisplayedPostIndex = 0;
        this.scrollToTop();
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarQA/SidebarTextQA.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarQA_SidebarTextQAvue_type_script_lang_js = (SidebarTextQAvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarQA/SidebarTextQA.vue?vue&type=style&index=0&id=82ea7868&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarTextQAvue_type_style_index_0_id_82ea7868_prod_module_true_lang_scss = ({"root":"SidebarTextQA_root_A2Rcw","filterAndSortBar":"SidebarTextQA_filterAndSortBar_hfTeX","divider":"SidebarTextQA_divider_z_Pe0","textQnaItemsContainerHolder":"SidebarTextQA_textQnaItemsContainerHolder_aSItt","textQNAsHolder":"SidebarTextQA_textQNAsHolder_QUzLM","questionsHolder":"SidebarTextQA_questionsHolder_7PJJU","textQnAInputWrapper":"SidebarTextQA_textQnAInputWrapper_HQl0N","anonButton":"SidebarTextQA_anonButton_yVsjs","disabledQA":"SidebarTextQA_disabledQA_UnY1l","loadMoreButton":"SidebarTextQA_loadMoreButton_oCbbM"});
;// CONCATENATED MODULE: ./src/components/SidebarQA/SidebarTextQA.vue?vue&type=style&index=0&id=82ea7868&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarQA/SidebarTextQA.vue



;




function SidebarTextQA_injectStyles (context) {
  
  this["$style"] = (SidebarTextQAvue_type_style_index_0_id_82ea7868_prod_module_true_lang_scss.locals || SidebarTextQAvue_type_style_index_0_id_82ea7868_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarTextQA_component = normalizeComponent(
  SidebarQA_SidebarTextQAvue_type_script_lang_js,
  SidebarTextQAvue_type_template_id_82ea7868_render,
  SidebarTextQAvue_type_template_id_82ea7868_staticRenderFns,
  false,
  SidebarTextQA_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarTextQA = (SidebarTextQA_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarQA/SidebarVideoQA.vue?vue&type=template&id=2d4eca7a&functional=true
var SidebarVideoQAvue_type_template_id_2d4eca7a_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.props.videoQNARequests.length === 0 ? _c('SidebarEmptyState', {
    attrs: {
      "icon": "hand-wave",
      "title": _vm.$options.$t('No Questions Yet'),
      "message": _vm.$options.$t('Tell your audience to raise their hand!')
    }
  }) : _c('div', {
    class: _vm.$style.listContainer
  }, _vm._l(_vm.props.videoQNARequests, function (request) {
    return _c('div', {
      key: request && request.id,
      class: _vm.$style.listItem
    }, [_c('UserImage', {
      attrs: {
        "size": "medium",
        "user": request && request.userDetails
      }
    }), _c('div', {
      class: _vm.$style.right
    }, [_c('StyledText', {
      class: _vm.$style.userName,
      attrs: {
        "variant": "body15",
        "display": "block"
      }
    }, [_vm._v(" " + _vm._s(request && request.userDetails && request.userDetails.name) + " ")]), request && request.status === 'OPEN' ? _c('div', [_c('PillButton', {
      attrs: {
        "size": "x-small",
        "uppercase": "",
        "center": ""
      },
      on: {
        "click": function ($event) {
          return _vm.listeners.acceptVideoQNARequest(request.id);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Approve')) + " ")]), _c('PillButton', {
      attrs: {
        "size": "x-small",
        "uppercase": "",
        "center": ""
      },
      on: {
        "click": function ($event) {
          return _vm.listeners.rejectVideoQNARequest(request.id);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('Reject')) + " ")])], 1) : request ? _c('div', [_c('PillButton', {
      attrs: {
        "size": "x-small",
        "uppercase": "",
        "center": ""
      },
      on: {
        "click": function ($event) {
          return _vm.listeners.completeVideoQNARequest(request.id);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$options.$t('End')) + " ")])], 1) : _vm._e()], 1)], 1);
  }), 0)], 1);
};
var SidebarVideoQAvue_type_template_id_2d4eca7a_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarQA/SidebarVideoQA.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarVideoQAvue_type_script_lang_js = ({
  functional: true,
  props: {
    videoQNARequests: {
      type: Array,
      default() {
        return [];
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarQA/SidebarVideoQA.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarQA_SidebarVideoQAvue_type_script_lang_js = (SidebarVideoQAvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarQA/SidebarVideoQA.vue?vue&type=style&index=0&id=2d4eca7a&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarVideoQAvue_type_style_index_0_id_2d4eca7a_prod_module_true_lang_scss = ({"root":"SidebarVideoQA_root_w6P7o","listContainer":"SidebarVideoQA_listContainer_UKOlZ","listItem":"SidebarVideoQA_listItem_ldLGV","right":"SidebarVideoQA_right_Enf7W","userName":"SidebarVideoQA_userName_WeG97"});
;// CONCATENATED MODULE: ./src/components/SidebarQA/SidebarVideoQA.vue?vue&type=style&index=0&id=2d4eca7a&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarQA/SidebarVideoQA.vue



;




function SidebarVideoQA_injectStyles (context) {
  
  this["$style"] = (SidebarVideoQAvue_type_style_index_0_id_2d4eca7a_prod_module_true_lang_scss.locals || SidebarVideoQAvue_type_style_index_0_id_2d4eca7a_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarVideoQA_component = normalizeComponent(
  SidebarQA_SidebarVideoQAvue_type_script_lang_js,
  SidebarVideoQAvue_type_template_id_2d4eca7a_functional_true_render,
  SidebarVideoQAvue_type_template_id_2d4eca7a_functional_true_staticRenderFns,
  true,
  SidebarVideoQA_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarVideoQA = (SidebarVideoQA_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarQA/RaiseHandButton.vue?vue&type=template&id=52e1c622
var RaiseHandButtonvue_type_template_id_52e1c622_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.raiseHandButtonContainer
  }, [_c('GTooltip', {
    attrs: {
      "id": "raiseHandButtonState",
      "position": "top-right",
      "text": _vm.$props.tooltipText
    }
  }, [_c('PillButton', {
    attrs: {
      "disabled": _vm.$props.buttonState === 'DISABLED' || _vm.$props.buttonState === 'PENDING' || _vm.$props.loading,
      "loading": _vm.$props.loading,
      "center": true,
      "ariaLabelledby": "raiseHandButtonState",
      "ariaLive": "polite",
      "variant": _vm.$props.buttonState === 'ACCEPTED' ? 'warning' : 'secondary',
      "uppercase": "",
      "size": "x-small"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClick');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")])], 1), _vm.$props.buttonState === 'PENDING' ? _c('GTooltip', {
    attrs: {
      "id": "raiseHandButtonStatePending",
      "position": "top-right",
      "text": _vm.$options.$t('Cancel your video q&a request')
    }
  }, [_c('IconButton', {
    class: _vm.$style.cancelButton,
    attrs: {
      "ariaLabelledby": "raiseHandButtonStatePending",
      "icon": "cross"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClick');
      }
    }
  })], 1) : _vm._e()], 1);
};
var RaiseHandButtonvue_type_template_id_52e1c622_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarQA/RaiseHandButton.vue?vue&type=script&lang=js
/* harmony default export */ var RaiseHandButtonvue_type_script_lang_js = ({
  name: 'RaiseHandButton',
  props: {
    buttonState: {
      type: String
    },
    requestStatus: {
      type: String
    },
    tooltipText: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonText() {
      if (this.buttonState === 'PENDING') {
        return this.$t('Pending...');
      }
      if (this.buttonState === 'ACCEPTED') {
        return this.$t('Leave Stage');
      }
      return this.$t('Raise Hand');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarQA/RaiseHandButton.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarQA_RaiseHandButtonvue_type_script_lang_js = (RaiseHandButtonvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarQA/RaiseHandButton.vue?vue&type=style&index=0&id=52e1c622&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var RaiseHandButtonvue_type_style_index_0_id_52e1c622_prod_module_true_lang_scss = ({"raiseHandButtonContainer":"RaiseHandButton_raiseHandButtonContainer_N8f0R","cancelButton":"RaiseHandButton_cancelButton_MsHtS"});
;// CONCATENATED MODULE: ./src/components/SidebarQA/RaiseHandButton.vue?vue&type=style&index=0&id=52e1c622&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarQA/RaiseHandButton.vue



;




function RaiseHandButton_injectStyles (context) {
  
  this["$style"] = (RaiseHandButtonvue_type_style_index_0_id_52e1c622_prod_module_true_lang_scss.locals || RaiseHandButtonvue_type_style_index_0_id_52e1c622_prod_module_true_lang_scss)

}

/* normalize component */

var RaiseHandButton_component = normalizeComponent(
  SidebarQA_RaiseHandButtonvue_type_script_lang_js,
  RaiseHandButtonvue_type_template_id_52e1c622_render,
  RaiseHandButtonvue_type_template_id_52e1c622_staticRenderFns,
  false,
  RaiseHandButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var RaiseHandButton = (RaiseHandButton_component.exports);
;// CONCATENATED MODULE: ./src/components/SidebarQA/index.js




;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/ScreenSaverWrapper.vue?vue&type=template&id=2de57da3&functional=true
var ScreenSaverWrappervue_type_template_id_2de57da3_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.minimized]: _vm.props.minimized,
      [_vm.$style.recordingMode]: _vm.props.recordingMode
    },
    attrs: {
      "data-branding-target": _vm.props.dataBrandingTarget
    }
  }, [_vm.props.logo ? _c('div', {
    class: [_vm.$style.logoContainer, _vm.$style.nonmobile]
  }, [_c('img', {
    class: _vm.$style.logoImage,
    attrs: {
      "src": _vm.props.logo
    }
  })]) : _vm._e(), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": _vm.$options.isMobile() || _vm.props.minimized ? 'heading15' : 'heading26',
      "color": "screen-saver-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.title) + " " + _vm._s(_vm.props.upNext ? _vm.$options.$t('{title}up next', {
    title: ''
  }) : '') + " ")]), !_vm.props.hideTime ? _c('StyledText', {
    class: _vm.$style.time,
    attrs: {
      "color": "screen-saver-text-color",
      "variant": "body16"
    }
  }, [_vm.props.useDate ? [_vm._v(" " + _vm._s(_vm.$options.formatDateRange(_vm.props.startTime, _vm.props.endTime)) + " ")] : [_vm._v(" " + _vm._s(_vm.$options.formatTimeRange(_vm.props.startTime, _vm.props.endTime)) + " ")]], 2) : _vm._e(), _c('StyledText', {
    class: _vm.$style.description,
    attrs: {
      "color": "screen-saver-text-color",
      "variant": "body16",
      "align": "center"
    }
  }, [_vm._t("description")], 2), _c('div', {
    class: _vm.$style.after
  }, [_vm._t("after")], 2)], 1);
};
var ScreenSaverWrappervue_type_template_id_2de57da3_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/ScreenSaverWrapper.vue?vue&type=script&lang=js

/* harmony default export */ var ScreenSaverWrappervue_type_script_lang_js = ({
  name: 'ScreenSaverWrapper',
  functional: true,
  props: {
    title: String,
    startTime: String,
    endTime: String,
    upNext: Boolean,
    useDate: Boolean,
    hideTime: Boolean,
    minimized: Boolean,
    recordingMode: {
      type: Boolean,
      default: false
    },
    logo: String,
    dataBrandingTarget: {
      type: String,
      default: ''
    }
  },
  formatTime(time) {
    try {
      return timeFormatter.format(new Date(time));
    } catch (e) {
      return '-';
    }
  },
  formatDateRange(start, end) {
    try {
      return startToEndDateString(new Date(start), new Date(end)) + ' ' + this.timezone(start);
    } catch (e) {
      return '-';
    }
  },
  formatTimeRange(start, end) {
    const formattedStartTime = this.formatTime(start);
    const formattedEndTime = this.formatTime(end);
    const localTimezone = this.timezone(start);
    let timeRange = formattedStartTime + ' - ' + formattedEndTime;
    if (formattedStartTime !== '-' && formattedEndTime !== '-') {
      timeRange += ' ' + localTimezone;
    }
    return timeRange;
  },
  timezone(dateString) {
    const localTimezone = getTimeZoneFromDate(dateString);
    return localTimezone;
  },
  isMobile() {
    return window.mobileCheck && window.mobileCheck();
  }
});
;// CONCATENATED MODULE: ./src/components/ScreenSavers/ScreenSaverWrapper.vue?vue&type=script&lang=js
 /* harmony default export */ var ScreenSavers_ScreenSaverWrappervue_type_script_lang_js = (ScreenSaverWrappervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/ScreenSavers/ScreenSaverWrapper.vue?vue&type=style&index=0&id=2de57da3&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ScreenSaverWrappervue_type_style_index_0_id_2de57da3_prod_module_true_lang_scss = ({"root":"ScreenSaverWrapper_root_ZE2G3","recordingMode":"ScreenSaverWrapper_recordingMode_RXgxf","logoContainer":"ScreenSaverWrapper_logoContainer_JVqbe","logoImage":"ScreenSaverWrapper_logoImage_L5fi2","title":"ScreenSaverWrapper_title_wruhu","time":"ScreenSaverWrapper_time_IjvDt","description":"ScreenSaverWrapper_description_Vir_5","after":"ScreenSaverWrapper_after_I7ds1","minimized":"ScreenSaverWrapper_minimized_HcEsI","nonmobile":"ScreenSaverWrapper_nonmobile_eM3PK"});
;// CONCATENATED MODULE: ./src/components/ScreenSavers/ScreenSaverWrapper.vue?vue&type=style&index=0&id=2de57da3&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/ScreenSavers/ScreenSaverWrapper.vue



;




function ScreenSaverWrapper_injectStyles (context) {
  
  this["$style"] = (ScreenSaverWrappervue_type_style_index_0_id_2de57da3_prod_module_true_lang_scss.locals || ScreenSaverWrappervue_type_style_index_0_id_2de57da3_prod_module_true_lang_scss)

}

/* normalize component */

var ScreenSaverWrapper_component = normalizeComponent(
  ScreenSavers_ScreenSaverWrappervue_type_script_lang_js,
  ScreenSaverWrappervue_type_template_id_2de57da3_functional_true_render,
  ScreenSaverWrappervue_type_template_id_2de57da3_functional_true_staticRenderFns,
  true,
  ScreenSaverWrapper_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ScreenSaverWrapper = (ScreenSaverWrapper_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/BroadcastScreenSaver.vue?vue&type=template&id=2e32fe1b&functional=true
var BroadcastScreenSavervue_type_template_id_2e32fe1b_functional_true_render = function render(_c, _vm) {
  return _c('ScreenSaverWrapper', {
    attrs: {
      "title": _vm.props.broadcast.title,
      "startTime": _vm.props.broadcast.start_time,
      "endTime": _vm.props.broadcast.end_time,
      "upNext": _vm.props.upNext,
      "minimized": _vm.props.minimized,
      "recordingMode": _vm.props.recordingMode,
      "logo": _vm.props.logo,
      "dataBrandingTarget": "broadcast-screen-saver"
    },
    scopedSlots: _vm._u([_vm.props.message ? {
      key: "description",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.props.message)) + " ")];
      },
      proxy: true
    } : null, {
      key: "after",
      fn: function () {
        return [_c('div', {
          class: _vm.$style.users
        }, _vm._l(_vm.$options.getBroadcastSpeakers(_vm.props.broadcast.speakers), function (user) {
          return _c('UserTooltip', {
            key: user.id,
            attrs: {
              "size": _vm.$options.isMobile() ? 'small' : 'usual',
              "user": user,
              "variant": "primary"
            },
            on: {
              "click": () => _vm.listeners.userClicked ? _vm.listeners.userClicked(user) : null
            }
          });
        }), 1), _vm.props.ctaText ? _c('PillButton', {
          class: _vm.$style.join,
          attrs: {
            "variant": "primary",
            "uppercase": "",
            "center": ""
          },
          on: {
            "click": _vm.listeners.go
          }
        }, [_vm._v(" " + _vm._s(_vm.props.ctaText) + " ")]) : _vm._e()];
      },
      proxy: true
    }], null, true)
  });
};
var BroadcastScreenSavervue_type_template_id_2e32fe1b_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/BroadcastScreenSaver.vue?vue&type=script&lang=js
/* harmony default export */ var BroadcastScreenSavervue_type_script_lang_js = ({
  name: 'BroadcastScreenSaver',
  functional: true,
  props: {
    broadcast: {
      type: Object,
      required: true
    },
    upNext: Boolean,
    message: String,
    minimized: Boolean,
    ctaText: String,
    logo: {
      type: String,
      default: ''
    },
    recordingMode: {
      type: Boolean,
      default: false
    }
  },
  isMobile() {
    return window.mobileCheck && window.mobileCheck();
  },
  getBroadcastSpeakers(speakers) {
    return speakers.filter(e => !e.hidden);
  }
});
;// CONCATENATED MODULE: ./src/components/ScreenSavers/BroadcastScreenSaver.vue?vue&type=script&lang=js
 /* harmony default export */ var ScreenSavers_BroadcastScreenSavervue_type_script_lang_js = (BroadcastScreenSavervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/ScreenSavers/BroadcastScreenSaver.vue?vue&type=style&index=0&id=2e32fe1b&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var BroadcastScreenSavervue_type_style_index_0_id_2e32fe1b_prod_module_true_lang_scss = ({"users":"BroadcastScreenSaver_users_sP_ve","join":"BroadcastScreenSaver_join_jqS5C"});
;// CONCATENATED MODULE: ./src/components/ScreenSavers/BroadcastScreenSaver.vue?vue&type=style&index=0&id=2e32fe1b&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/ScreenSavers/BroadcastScreenSaver.vue



;




function BroadcastScreenSaver_injectStyles (context) {
  
  this["$style"] = (BroadcastScreenSavervue_type_style_index_0_id_2e32fe1b_prod_module_true_lang_scss.locals || BroadcastScreenSavervue_type_style_index_0_id_2e32fe1b_prod_module_true_lang_scss)

}

/* normalize component */

var BroadcastScreenSaver_component = normalizeComponent(
  ScreenSavers_BroadcastScreenSavervue_type_script_lang_js,
  BroadcastScreenSavervue_type_template_id_2e32fe1b_functional_true_render,
  BroadcastScreenSavervue_type_template_id_2e32fe1b_functional_true_staticRenderFns,
  true,
  BroadcastScreenSaver_injectStyles,
  null,
  null
  
)

/* harmony default export */ var BroadcastScreenSaver = (BroadcastScreenSaver_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/BreakScreenSaver.vue?vue&type=template&id=e3b2d442&functional=true
var BreakScreenSavervue_type_template_id_e3b2d442_functional_true_render = function render(_c, _vm) {
  return _c('ScreenSaverWrapper', {
    attrs: {
      "title": _vm.props.breakItem.title,
      "startTime": _vm.props.breakItem.start_time,
      "endTime": _vm.props.breakItem.end_time,
      "upNext": _vm.props.upNext,
      "minimized": _vm.props.minimized,
      "logo": _vm.props.logo
    },
    scopedSlots: _vm._u([{
      key: "description",
      fn: function () {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.props.breakItem.description)
          }
        })];
      },
      proxy: true
    }, {
      key: "after",
      fn: function () {
        return [_vm.props.ctaText ? _c('PillButton', {
          attrs: {
            "variant": "primary",
            "uppercase": "",
            "center": ""
          },
          on: {
            "click": () => _vm.listeners.go()
          }
        }, [_vm._v(" " + _vm._s(_vm.props.ctaText) + " ")]) : _vm._e()];
      },
      proxy: true
    }])
  });
};
var BreakScreenSavervue_type_template_id_e3b2d442_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/BreakScreenSaver.vue?vue&type=script&lang=js
/* harmony default export */ var BreakScreenSavervue_type_script_lang_js = ({
  name: 'BreakScreenSaver',
  functional: true,
  props: {
    breakItem: {
      type: Object,
      required: true
    },
    upNext: Boolean,
    logo: String,
    minimized: Boolean,
    ctaText: String
  }
});
;// CONCATENATED MODULE: ./src/components/ScreenSavers/BreakScreenSaver.vue?vue&type=script&lang=js
 /* harmony default export */ var ScreenSavers_BreakScreenSavervue_type_script_lang_js = (BreakScreenSavervue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/ScreenSavers/BreakScreenSaver.vue





/* normalize component */
;
var BreakScreenSaver_component = normalizeComponent(
  ScreenSavers_BreakScreenSavervue_type_script_lang_js,
  BreakScreenSavervue_type_template_id_e3b2d442_functional_true_render,
  BreakScreenSavervue_type_template_id_e3b2d442_functional_true_staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var BreakScreenSaver = (BreakScreenSaver_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/RoomsScreenSaver.vue?vue&type=template&id=56a7846c&functional=true
var RoomsScreenSavervue_type_template_id_56a7846c_functional_true_render = function render(_c, _vm) {
  return _c('ScreenSaverWrapper', {
    attrs: {
      "title": _vm.props.roomsItem.title,
      "startTime": _vm.props.roomsItem.start_time,
      "endTime": _vm.props.roomsItem.end_time,
      "upNext": _vm.props.upNext,
      "minimized": _vm.props.minimized,
      "logo": _vm.props.logo
    },
    scopedSlots: _vm._u([{
      key: "description",
      fn: function () {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.props.roomsItem.description)
          }
        })];
      },
      proxy: true
    }, {
      key: "after",
      fn: function () {
        return [_vm.props.ctaText ? _c('PillButton', {
          attrs: {
            "uppercase": "",
            "variant": "primary",
            "center": ""
          },
          on: {
            "click": _vm.listeners.go
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.props.ctaText)) + " ")]) : _vm._e()];
      },
      proxy: true
    }])
  });
};
var RoomsScreenSavervue_type_template_id_56a7846c_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/RoomsScreenSaver.vue?vue&type=script&lang=js
// import i18n from "../../i18n";
/* harmony default export */ var RoomsScreenSavervue_type_script_lang_js = ({
  name: 'RoomsScreenSaver',
  functional: true,
  props: {
    roomsItem: {
      type: Object,
      required: true
    },
    upNext: Boolean,
    ctaText: {
      type: String,
      default: 'Go to Rooms'
    },
    minimized: Boolean,
    logo: String
  }
});
;// CONCATENATED MODULE: ./src/components/ScreenSavers/RoomsScreenSaver.vue?vue&type=script&lang=js
 /* harmony default export */ var ScreenSavers_RoomsScreenSavervue_type_script_lang_js = (RoomsScreenSavervue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/ScreenSavers/RoomsScreenSaver.vue





/* normalize component */
;
var RoomsScreenSaver_component = normalizeComponent(
  ScreenSavers_RoomsScreenSavervue_type_script_lang_js,
  RoomsScreenSavervue_type_template_id_56a7846c_functional_true_render,
  RoomsScreenSavervue_type_template_id_56a7846c_functional_true_staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var RoomsScreenSaver = (RoomsScreenSaver_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/EventScreenSaver.vue?vue&type=template&id=17ae5242&functional=true
var EventScreenSavervue_type_template_id_17ae5242_functional_true_render = function render(_c, _vm) {
  return _c('ScreenSaverWrapper', {
    attrs: {
      "title": `${!_vm.props.pre ? _vm.$options.$t('{eventtitle} has ended', {
        eventtitle: _vm.props.event.title
      }) : _vm.props.event.title}`,
      "startTime": _vm.props.event.start_time,
      "endTime": _vm.props.event.end_time,
      "useDate": true,
      "hideTime": !_vm.props.pre,
      "minimized": _vm.props.minimized,
      "logo": _vm.props.event.logo
    },
    scopedSlots: _vm._u([_vm.props.pre ? {
      key: "description",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.$options.$t('Starting in {timeduration}', {
          timeduration: ''
        })) + " "), _c('span', {
          class: _vm.$style.bold
        }, [_vm._v(_vm._s(_vm.props.duration))])];
      },
      proxy: true
    } : {
      key: "description",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.props.thankYou)) + " ")];
      },
      proxy: true
    }, {
      key: "after",
      fn: function () {
        return [_vm.props.ctaText ? _c('PillButton', {
          attrs: {
            "uppercase": "",
            "variant": "primary",
            "center": ""
          },
          on: {
            "click": _vm.listeners.go
          }
        }, [_vm._v(" " + _vm._s(_vm.props.ctaText) + " ")]) : _vm._e()];
      },
      proxy: true
    }], null, true)
  });
};
var EventScreenSavervue_type_template_id_17ae5242_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/EventScreenSaver.vue?vue&type=script&lang=js
// import i18n from "../../i18n";
/* harmony default export */ var EventScreenSavervue_type_script_lang_js = ({
  name: 'EventScreenSaver',
  functional: true,
  props: {
    event: {
      type: Object,
      required: true
    },
    pre: Boolean,
    duration: String,
    thankYou: {
      type: String,
      default: 'Thank you for attending this event!'
    },
    ctaText: String,
    minimized: Boolean
  }
});
;// CONCATENATED MODULE: ./src/components/ScreenSavers/EventScreenSaver.vue?vue&type=script&lang=js
 /* harmony default export */ var ScreenSavers_EventScreenSavervue_type_script_lang_js = (EventScreenSavervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/ScreenSavers/EventScreenSaver.vue?vue&type=style&index=0&id=17ae5242&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var EventScreenSavervue_type_style_index_0_id_17ae5242_prod_module_true_lang_scss = ({"bold":"EventScreenSaver_bold_r53va"});
;// CONCATENATED MODULE: ./src/components/ScreenSavers/EventScreenSaver.vue?vue&type=style&index=0&id=17ae5242&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/ScreenSavers/EventScreenSaver.vue



;




function EventScreenSaver_injectStyles (context) {
  
  this["$style"] = (EventScreenSavervue_type_style_index_0_id_17ae5242_prod_module_true_lang_scss.locals || EventScreenSavervue_type_style_index_0_id_17ae5242_prod_module_true_lang_scss)

}

/* normalize component */

var EventScreenSaver_component = normalizeComponent(
  ScreenSavers_EventScreenSavervue_type_script_lang_js,
  EventScreenSavervue_type_template_id_17ae5242_functional_true_render,
  EventScreenSavervue_type_template_id_17ae5242_functional_true_staticRenderFns,
  true,
  EventScreenSaver_injectStyles,
  null,
  null
  
)

/* harmony default export */ var EventScreenSaver = (EventScreenSaver_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/RedirectionScreenSaver.vue?vue&type=template&id=62500b50
var RedirectionScreenSavervue_type_template_id_62500b50_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.minimized && _vm.$style.minimized]
  }, [_c('div', {
    class: _vm.$style.contentWrapper
  }, [_vm.title ? _c('StyledText', {
    class: [_vm.minimized && _vm.$style.minimizedTitle],
    attrs: {
      "variant": "subHeading26",
      "color": "screen-saver-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm.subtitle && !_vm.minimized ? _c('StyledText', {
    class: _vm.$style.subheading,
    attrs: {
      "variant": "heading20",
      "color": "screen-saver-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Thanks for attending!')) + " ")]) : _vm._e(), _vm.redirectingAgendaItem ? _c('StyledText', {
    class: [_vm.$style.message, _vm.minimized && _vm.$style.minimizedMessage],
    attrs: {
      "variant": "subHeading16",
      "color": "screen-saver-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(`Redirecting you to `)) + " " + _vm._s(_vm.redirectingAgendaItem.title) + " " + _vm._s(_vm.$options.$t(`in `)) + " " + _vm._s(_vm.time) + " " + _vm._s(_vm.$options.$t(`seconds`)) + " ")]) : _vm._e(), !_vm.minimized ? _c('div', {
    class: _vm.$style.content
  }, [(_vm.trackOptions || []).length > 1 ? _c('AgendaFilter', {
    attrs: {
      "options": _vm.trackOptions,
      "current": _vm.selectedTrack,
      "type": _vm.isMobile ? 'dropdown' : 'pin',
      "fullWidthDropdown": _vm.isMobile ? true : false
    },
    on: {
      "select": e => _vm.$emit('on-track-select', e)
    }
  }) : _vm._e(), _vm.liveSessions.length === 0 && !_vm.redirectingAgendaItem ? _c('div', {
    class: _vm.$style.emptyState
  }, [_c('StyledText', {
    class: _vm.$style.message,
    attrs: {
      "variant": "subHeading16",
      "color": "screen-saver-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('No upcoming sessions in your subscribed track. Please switch to other tracks to see live sessions')) + " ")])], 1) : _vm._e(), _c('div', {
    class: _vm.$style.agendaItemContainer
  }, [_vm.redirectingAgendaItem ? _c('AgendaItem', {
    class: _vm.$style.nextItem,
    style: _vm.progress,
    attrs: {
      "sleakView": true,
      "broadcast": _vm.redirectingAgendaItem
    },
    on: {
      "join": function ($event) {
        return _vm.$emit('joinAgenda', _vm.redirectingAgendaItem);
      }
    }
  }) : _vm._e(), _vm._l(_vm.liveSessions, function (session) {
    return _c('AgendaItem', {
      key: session.id,
      attrs: {
        "sleakView": true,
        "broadcast": session
      },
      on: {
        "join": function ($event) {
          return _vm.$emit('joinAgenda', session);
        }
      }
    });
  })], 2)], 1) : _vm._e()], 1)]);
};
var RedirectionScreenSavervue_type_template_id_62500b50_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventAgenda/AgendaItemForScreenSaver.vue?vue&type=template&id=a85d0364
var AgendaItemForScreenSavervue_type_template_id_a85d0364_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.live]: _vm.broadcast.is_live,
      [_vm.$style.disabled]: _vm.broadcast.disabled
    },
    attrs: {
      "data-branding-target": "agenda-item"
    }
  }, [_c('div', {
    class: _vm.$style.timeAndTadWrapper
  }, [_c('StyledText', {
    class: _vm.$style.time,
    attrs: {
      "variant": "body14",
      "color": "primary-text-color",
      "data-branding-target": "agenda-item-sreen-saver"
    }
  }, [_vm._v(" " + _vm._s(_vm.startTime) + " - " + _vm._s(_vm.endTime) + " " + _vm._s(_vm.formattedLocalTimezone) + " ")]), _c('div', {
    class: _vm.$style.tagWrapper
  }, [_vm.broadcast.is_live ? _c('StyledText', {
    class: [_vm.$style.indicator, _vm.$style.live],
    attrs: {
      "variant": "body11",
      "color": "color-highlight",
      "data-branding-target": "screen-saver-agenda-item-specs"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('LIVE')) + " ")]) : _c('StyledText', {
    class: [_vm.$style.indicator, _vm.$style.upcoming],
    attrs: {
      "variant": "body11",
      "color": "color-highlight",
      "data-branding-target": "screen-saver-agenda-item-specs"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('UPCOMING')) + " ")])], 1)], 1), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "subHeading18",
      "color": "primary-text-color",
      "data-branding-target": "screen-saver-agenda-item-title"
    }
  }, [_vm._v(" " + _vm._s(_vm.broadcast.title) + " ")]), _c('PillButton', {
    class: _vm.$style.joinCta,
    attrs: {
      "disabled": _vm.broadcast.disabled || !_vm.broadcast.is_live,
      "boldText": "",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('join');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Join')) + " ")])], 1);
};
var AgendaItemForScreenSavervue_type_template_id_a85d0364_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventAgenda/AgendaItemForScreenSaver.vue?vue&type=script&lang=js

/* harmony default export */ var AgendaItemForScreenSavervue_type_script_lang_js = ({
  name: 'AgendaItemForScreenSaver',
  props: {
    broadcast: Object,
    timezone: {
      type: String,
      default: 'UTC'
    },
    localTimezone: {
      type: String,
      default: 'UTC'
    }
  },
  computed: {
    formattedLocalTimezone() {
      return getTimeZoneFromDate(this.broadcast?.start_time);
    },
    startTime() {
      return timeFormatter.format(new Date(this.broadcast.start_time));
    },
    endTime() {
      return timeFormatter.format(new Date(this.broadcast.end_time));
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaItemForScreenSaver.vue?vue&type=script&lang=js
 /* harmony default export */ var EventAgenda_AgendaItemForScreenSavervue_type_script_lang_js = (AgendaItemForScreenSavervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventAgenda/AgendaItemForScreenSaver.vue?vue&type=style&index=0&id=a85d0364&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var AgendaItemForScreenSavervue_type_style_index_0_id_a85d0364_prod_module_true_lang_scss = ({"root":"AgendaItemForScreenSaver_root_ZUYMk","timeAndTadWrapper":"AgendaItemForScreenSaver_timeAndTadWrapper_hT6ZA","indicator":"AgendaItemForScreenSaver_indicator_TfWUE","live":"AgendaItemForScreenSaver_live_NWaT7","upcoming":"AgendaItemForScreenSaver_upcoming_BXf_u","joinCta":"AgendaItemForScreenSaver_joinCta_X6DPf","time":"AgendaItemForScreenSaver_time_Dxy5f","title":"AgendaItemForScreenSaver_title_Ccz3S"});
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaItemForScreenSaver.vue?vue&type=style&index=0&id=a85d0364&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaItemForScreenSaver.vue



;




function AgendaItemForScreenSaver_injectStyles (context) {
  
  this["$style"] = (AgendaItemForScreenSavervue_type_style_index_0_id_a85d0364_prod_module_true_lang_scss.locals || AgendaItemForScreenSavervue_type_style_index_0_id_a85d0364_prod_module_true_lang_scss)

}

/* normalize component */

var AgendaItemForScreenSaver_component = normalizeComponent(
  EventAgenda_AgendaItemForScreenSavervue_type_script_lang_js,
  AgendaItemForScreenSavervue_type_template_id_a85d0364_render,
  AgendaItemForScreenSavervue_type_template_id_a85d0364_staticRenderFns,
  false,
  AgendaItemForScreenSaver_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AgendaItemForScreenSaver = (AgendaItemForScreenSaver_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/ScreenSavers/RedirectionScreenSaver.vue?vue&type=script&lang=js


/* harmony default export */ var RedirectionScreenSavervue_type_script_lang_js = ({
  name: 'RedirectionScreenSaver',
  props: {
    redirectingAgendaItem: Object,
    liveSessions: Array,
    title: String,
    subtitle: String,
    minimized: {
      type: Boolean,
      default: false
    },
    trackOptions: Array,
    selectedTrack: Object,
    transitionTime: {
      type: Number,
      default: 15
    }
  },
  components: {
    AgendaItem: AgendaItemForScreenSaver,
    AgendaFilter: AgendaFilter
  },
  data() {
    return {
      time: 15,
      interval: null
    };
  },
  methods: {
    initTransition() {
      this.time = this.transitionTime;
      this.interval = setInterval(() => {
        this.time = this.time - 1;
        if (this.time === 0) {
          clearInterval(this.interval);
          this.$emit('redirect', this.redirectingAgendaItem);
        }
      }, 1000);
    }
  },
  mounted() {
    if (this.redirectingAgendaItem) {
      this.initTransition();
    }
  },
  computed: {
    isMobile() {
      return window.mobileCheck && window.mobileCheck();
    },
    progress() {
      return {
        '--progress': (this.transitionTime - this.time) / (this.transitionTime / 100) + '%'
      };
    }
  },
  watch: {
    redirectingAgendaItem(newVal, oldVal) {
      if (newVal.id && newVal?.id != oldVal?.id) {
        this.initTransition();
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
});
;// CONCATENATED MODULE: ./src/components/ScreenSavers/RedirectionScreenSaver.vue?vue&type=script&lang=js
 /* harmony default export */ var ScreenSavers_RedirectionScreenSavervue_type_script_lang_js = (RedirectionScreenSavervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/ScreenSavers/RedirectionScreenSaver.vue?vue&type=style&index=0&id=62500b50&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var RedirectionScreenSavervue_type_style_index_0_id_62500b50_prod_module_true_lang_scss = ({"root":"RedirectionScreenSaver_root_uZ6Z8","contentWrapper":"RedirectionScreenSaver_contentWrapper_AOBTW","minimizedTitle":"RedirectionScreenSaver_minimizedTitle_mHFQD","subheading":"RedirectionScreenSaver_subheading_ohOpN","message":"RedirectionScreenSaver_message_ON4D1","minimizedMessage":"RedirectionScreenSaver_minimizedMessage_bqvTX","content":"RedirectionScreenSaver_content_wQXtO","emptyState":"RedirectionScreenSaver_emptyState_Dbvl2","agendaItemContainer":"RedirectionScreenSaver_agendaItemContainer_BOPLC","nextItem":"RedirectionScreenSaver_nextItem_isAJ_","minimized":"RedirectionScreenSaver_minimized_DgX3K"});
;// CONCATENATED MODULE: ./src/components/ScreenSavers/RedirectionScreenSaver.vue?vue&type=style&index=0&id=62500b50&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/ScreenSavers/RedirectionScreenSaver.vue



;




function RedirectionScreenSaver_injectStyles (context) {
  
  this["$style"] = (RedirectionScreenSavervue_type_style_index_0_id_62500b50_prod_module_true_lang_scss.locals || RedirectionScreenSavervue_type_style_index_0_id_62500b50_prod_module_true_lang_scss)

}

/* normalize component */

var RedirectionScreenSaver_component = normalizeComponent(
  ScreenSavers_RedirectionScreenSavervue_type_script_lang_js,
  RedirectionScreenSavervue_type_template_id_62500b50_render,
  RedirectionScreenSavervue_type_template_id_62500b50_staticRenderFns,
  false,
  RedirectionScreenSaver_injectStyles,
  null,
  null
  
)

/* harmony default export */ var RedirectionScreenSaver = (RedirectionScreenSaver_component.exports);
;// CONCATENATED MODULE: ./src/components/ScreenSavers/index.js






;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarStates/SidebarEmptyState.vue?vue&type=template&id=70951ab4
var SidebarEmptyStatevue_type_template_id_70951ab4_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.loading ? _c('Loading', {
    attrs: {
      "size": "small"
    }
  }) : _c('SvgIcon', {
    class: _vm.$style.icon,
    attrs: {
      "name": _vm.failed ? 'error-triangle' : _vm.icon,
      "color": "theme-secondary-color",
      "size": "medium"
    }
  }), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "align": "center",
      "variant": "body14"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('StyledText', {
    class: _vm.$style.message,
    attrs: {
      "align": "center",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.failed ? _vm.$options.$t('Please reload the page') : _vm.message) + " ")]), _vm.failed ? _c('PillButton', {
    class: _vm.$style.callButton,
    attrs: {
      "icon": "refresh",
      "size": "x-small"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('refresh');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('RELOAD')) + " ")]) : _vm._e()], 1);
};
var SidebarEmptyStatevue_type_template_id_70951ab4_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarStates/SidebarEmptyState.vue?vue&type=script&lang=js
/* harmony default export */ var SidebarEmptyStatevue_type_script_lang_js = ({
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    failed: {
      type: Boolean,
      default: false
    },
    image: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarStates/SidebarEmptyState.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarStates_SidebarEmptyStatevue_type_script_lang_js = (SidebarEmptyStatevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarStates/SidebarEmptyState.vue?vue&type=style&index=0&id=70951ab4&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarEmptyStatevue_type_style_index_0_id_70951ab4_prod_module_true_lang_scss = ({"root":"SidebarEmptyState_root_KRR6R","title":"SidebarEmptyState_title_zl_Yt","message":"SidebarEmptyState_message_pPPj5","icon":"SidebarEmptyState_icon_RKFeV","callButton":"SidebarEmptyState_callButton_sWcPw"});
;// CONCATENATED MODULE: ./src/components/SidebarStates/SidebarEmptyState.vue?vue&type=style&index=0&id=70951ab4&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarStates/SidebarEmptyState.vue



;




function SidebarEmptyState_injectStyles (context) {
  
  this["$style"] = (SidebarEmptyStatevue_type_style_index_0_id_70951ab4_prod_module_true_lang_scss.locals || SidebarEmptyStatevue_type_style_index_0_id_70951ab4_prod_module_true_lang_scss)

}

/* normalize component */

var SidebarEmptyState_component = normalizeComponent(
  SidebarStates_SidebarEmptyStatevue_type_script_lang_js,
  SidebarEmptyStatevue_type_template_id_70951ab4_render,
  SidebarEmptyStatevue_type_template_id_70951ab4_staticRenderFns,
  false,
  SidebarEmptyState_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarEmptyState = (SidebarEmptyState_component.exports);
;// CONCATENATED MODULE: ./src/components/SidebarStates/index.js

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/SidebarSurveyWidget.vue?vue&type=template&id=5081adb3
var SidebarSurveyWidgetvue_type_template_id_5081adb3_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "id": "sidebarSurvey"
    }
  }, [_vm.showLoading ? _c('Loading', {
    class: _vm.$style.loading,
    attrs: {
      "size": "small"
    }
  }) : _vm._l(_vm.surveys, function (survey) {
    return _c('SurveyCard', {
      key: survey.id,
      attrs: {
        "survey": survey,
        "publishedSurveyId": _vm.publishedSurveyId,
        "previewSurveyId": _vm.previewSurveyId,
        "timeLeftInClosingSurvey": _vm.timeLeftInClosingSurvey
      },
      on: {
        "closeSurveyPreview": id => _vm.$emit('closeSurveyPreview', id),
        "openSurveyPreview": id => _vm.$emit('openSurveyPreview', id),
        "unPublishSurvey": id => _vm.$emit('unPublishSurvey', id),
        "publishSurvey": id => _vm.$emit('publishSurvey', id)
      }
    });
  })], 2);
};
var SidebarSurveyWidgetvue_type_template_id_5081adb3_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/SurveyCard.vue?vue&type=template&id=193e7932
var SurveyCardvue_type_template_id_193e7932_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "subHeading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.survey.title) + " ")]), _c('StyledText', {
    class: _vm.$style.questionsCount,
    attrs: {
      "variant": "subHeading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.survey.questions && _vm.survey.questions.length) + " " + _vm._s(_vm.$options.$t('Questions')) + " ")]), _c('div', {
    class: _vm.$style.actionBar
  }, [_vm.survey.timeLeftInClosingSurvey && _vm.survey.id === _vm.publishedSurveyId ? [_c('PillButton', {
    class: _vm.$style.timer,
    attrs: {
      "icon": "stopwatch",
      "size": "x-small",
      "center": ""
    },
    on: {
      "click": () => {}
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Closing in 00:')) + _vm._s(_vm.survey.timeLeftInClosingSurvey) + " ")])] : [_vm.previewSurveyId === _vm.survey.id ? _c('PillButton', {
    attrs: {
      "uppercase": "",
      "center": "",
      "size": "x-small"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('closeSurveyPreview', _vm.survey.id);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Close')) + " ")]) : _c('PillButton', {
    attrs: {
      "uppercase": "",
      "center": "",
      "size": "x-small"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openSurveyPreview', _vm.survey.id);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Preview')) + " ")]), _vm.publishedSurveyId === _vm.survey.id ? _c('PillButton', {
    attrs: {
      "uppercase": "",
      "center": "",
      "size": "x-small"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('unPublishSurvey', _vm.survey.id);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Close Survey')) + " ")]) : _c('PillButton', {
    attrs: {
      "icon": "link",
      "uppercase": "",
      "disabled": !!_vm.publishedSurveyId,
      "center": "",
      "size": "x-small"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('publishSurvey', _vm.survey.id);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Launch Survey')) + " ")])]], 2)], 1);
};
var SurveyCardvue_type_template_id_193e7932_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/SurveyCard.vue?vue&type=script&lang=js
/* harmony default export */ var SurveyCardvue_type_script_lang_js = ({
  name: 'SurveyCard',
  props: {
    survey: {
      type: Object,
      default: () => ({
        id: '',
        title: '',
        questions: [],
        timeLeftInClosingSurvey: ''
      })
    },
    publishedSurveyId: {
      type: String,
      default: ''
    },
    previewSurveyId: {
      type: String,
      default: ''
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Surveys/SurveyCard.vue?vue&type=script&lang=js
 /* harmony default export */ var Surveys_SurveyCardvue_type_script_lang_js = (SurveyCardvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Surveys/SurveyCard.vue?vue&type=style&index=0&id=193e7932&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SurveyCardvue_type_style_index_0_id_193e7932_prod_module_true_lang_scss = ({"root":"SurveyCard_root_XZoRv","title":"SurveyCard_title_L3TXe","questionsCount":"SurveyCard_questionsCount_I6LaT","actionBar":"SurveyCard_actionBar_W9qKx","timer":"SurveyCard_timer_S0Xyu"});
;// CONCATENATED MODULE: ./src/components/Surveys/SurveyCard.vue?vue&type=style&index=0&id=193e7932&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Surveys/SurveyCard.vue



;




function SurveyCard_injectStyles (context) {
  
  this["$style"] = (SurveyCardvue_type_style_index_0_id_193e7932_prod_module_true_lang_scss.locals || SurveyCardvue_type_style_index_0_id_193e7932_prod_module_true_lang_scss)

}

/* normalize component */

var SurveyCard_component = normalizeComponent(
  Surveys_SurveyCardvue_type_script_lang_js,
  SurveyCardvue_type_template_id_193e7932_render,
  SurveyCardvue_type_template_id_193e7932_staticRenderFns,
  false,
  SurveyCard_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SurveyCard = (SurveyCard_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/SidebarSurveyWidget.vue?vue&type=script&lang=js

/* harmony default export */ var SidebarSurveyWidgetvue_type_script_lang_js = ({
  name: 'SidebarSurveyWidget',
  components: {
    SurveyCard: SurveyCard
  },
  props: {
    surveys: {
      type: Array,
      default: () => []
    },
    showLoading: {
      type: Boolean,
      default: false
    },
    publishedSurveyId: String,
    previewSurveyId: String,
    timeLeftInClosingSurvey: String
  }
});
;// CONCATENATED MODULE: ./src/components/Surveys/SidebarSurveyWidget.vue?vue&type=script&lang=js
 /* harmony default export */ var Surveys_SidebarSurveyWidgetvue_type_script_lang_js = (SidebarSurveyWidgetvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Surveys/SidebarSurveyWidget.vue?vue&type=style&index=0&id=5081adb3&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SidebarSurveyWidgetvue_type_style_index_0_id_5081adb3_prod_lang_scss_module_true = ({"root":"SidebarSurveyWidget_root_Uk1uL","loading":"SidebarSurveyWidget_loading_oaQcl"});
;// CONCATENATED MODULE: ./src/components/Surveys/SidebarSurveyWidget.vue?vue&type=style&index=0&id=5081adb3&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Surveys/SidebarSurveyWidget.vue



;




function SidebarSurveyWidget_injectStyles (context) {
  
  this["$style"] = (SidebarSurveyWidgetvue_type_style_index_0_id_5081adb3_prod_lang_scss_module_true.locals || SidebarSurveyWidgetvue_type_style_index_0_id_5081adb3_prod_lang_scss_module_true)

}

/* normalize component */

var SidebarSurveyWidget_component = normalizeComponent(
  Surveys_SidebarSurveyWidgetvue_type_script_lang_js,
  SidebarSurveyWidgetvue_type_template_id_5081adb3_render,
  SidebarSurveyWidgetvue_type_template_id_5081adb3_staticRenderFns,
  false,
  SidebarSurveyWidget_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SidebarSurveyWidget = (SidebarSurveyWidget_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/Questions/SingleChoice.vue?vue&type=template&id=0489a656
var SingleChoicevue_type_template_id_0489a656_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: [_vm.$style.questionText, _vm.required && _vm.$style.required],
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(_vm._s(_vm.text) + " ")]), _vm._l(_vm.options, function (option) {
    return [_c('div', {
      key: option.id,
      class: _vm.$style.option,
      on: {
        "click": function ($event) {
          return _vm.$emit('onAnswer', option);
        }
      }
    }, [_c('RadioSelectBtn', {
      class: _vm.$style.radio,
      attrs: {
        "selected": _vm.answer.id === option.id,
        "theme": "primary"
      }
    }), _c('StyledText', {
      class: _vm.$style.label,
      attrs: {
        "variant": "body12"
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")])], 1)];
  }), _vm.showError ? _c('QuestionErrorComp') : _vm._e()], 2);
};
var SingleChoicevue_type_template_id_0489a656_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/Questions/QuestionErrorComp.vue?vue&type=template&id=230de81a
var QuestionErrorCompvue_type_template_id_230de81a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('SvgIcon', {
    attrs: {
      "name": "error-triangle",
      "color": "color-highlight",
      "size": "small"
    }
  }), _c('StyledText', {
    class: _vm.$style.errorText,
    attrs: {
      "variant": "body10",
      "color": "color-highlight"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('This is a required question')) + " ")])], 1);
};
var QuestionErrorCompvue_type_template_id_230de81a_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/Questions/QuestionErrorComp.vue?vue&type=script&lang=js
/* harmony default export */ var QuestionErrorCompvue_type_script_lang_js = ({
  name: 'QuestionErrorComp'
});
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/QuestionErrorComp.vue?vue&type=script&lang=js
 /* harmony default export */ var Questions_QuestionErrorCompvue_type_script_lang_js = (QuestionErrorCompvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Surveys/Questions/QuestionErrorComp.vue?vue&type=style&index=0&id=230de81a&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var QuestionErrorCompvue_type_style_index_0_id_230de81a_prod_lang_scss_module_true = ({"root":"QuestionErrorComp_root_hDIX3","errorText":"QuestionErrorComp_errorText_TaGEP"});
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/QuestionErrorComp.vue?vue&type=style&index=0&id=230de81a&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/QuestionErrorComp.vue



;




function QuestionErrorComp_injectStyles (context) {
  
  this["$style"] = (QuestionErrorCompvue_type_style_index_0_id_230de81a_prod_lang_scss_module_true.locals || QuestionErrorCompvue_type_style_index_0_id_230de81a_prod_lang_scss_module_true)

}

/* normalize component */

var QuestionErrorComp_component = normalizeComponent(
  Questions_QuestionErrorCompvue_type_script_lang_js,
  QuestionErrorCompvue_type_template_id_230de81a_render,
  QuestionErrorCompvue_type_template_id_230de81a_staticRenderFns,
  false,
  QuestionErrorComp_injectStyles,
  null,
  null
  
)

/* harmony default export */ var QuestionErrorComp = (QuestionErrorComp_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/Questions/SingleChoice.vue?vue&type=script&lang=js

/* harmony default export */ var SingleChoicevue_type_script_lang_js = ({
  name: 'SingleChoiceQuestion',
  components: {
    QuestionErrorComp: QuestionErrorComp
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    answer: {
      type: Object,
      default: () => ({
        id: '',
        text: ''
      })
    },
    required: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/SingleChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var Questions_SingleChoicevue_type_script_lang_js = (SingleChoicevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Surveys/Questions/SingleChoice.vue?vue&type=style&index=0&id=0489a656&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SingleChoicevue_type_style_index_0_id_0489a656_prod_module_true_lang_scss = ({"root":"SingleChoice_root_2Aoww","questionText":"SingleChoice_questionText_elEz_","required":"SingleChoice_required_iMcnI","option":"SingleChoice_option_WSCBX","label":"SingleChoice_label_TrABg"});
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/SingleChoice.vue?vue&type=style&index=0&id=0489a656&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/SingleChoice.vue



;




function SingleChoice_injectStyles (context) {
  
  this["$style"] = (SingleChoicevue_type_style_index_0_id_0489a656_prod_module_true_lang_scss.locals || SingleChoicevue_type_style_index_0_id_0489a656_prod_module_true_lang_scss)

}

/* normalize component */

var SingleChoice_component = normalizeComponent(
  Questions_SingleChoicevue_type_script_lang_js,
  SingleChoicevue_type_template_id_0489a656_render,
  SingleChoicevue_type_template_id_0489a656_staticRenderFns,
  false,
  SingleChoice_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SingleChoice = (SingleChoice_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/Questions/MultipleChoice.vue?vue&type=template&id=d4753a3a
var MultipleChoicevue_type_template_id_d4753a3a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: [_vm.$style.questionText, _vm.required && _vm.$style.required],
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(_vm._s(_vm.text))]), _vm._l(_vm.options, function (option) {
    return [_c('div', {
      key: option.id,
      class: _vm.$style.option,
      on: {
        "click": function ($event) {
          return _vm.$emit('onAnswer', option);
        }
      }
    }, [_c('GCheckbox', {
      class: _vm.$style.radio,
      attrs: {
        "checked": _vm.isOptionSelected(option),
        "theme": "primary"
      },
      on: {
        "toggle": () => null
      }
    }), _c('StyledText', {
      class: _vm.$style.label,
      attrs: {
        "variant": "body12"
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")])], 1)];
  }), _vm.showError ? _c('QuestionErrorComp') : _vm._e()], 2);
};
var MultipleChoicevue_type_template_id_d4753a3a_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/Questions/MultipleChoice.vue?vue&type=script&lang=js

/* harmony default export */ var MultipleChoicevue_type_script_lang_js = ({
  name: 'MultipleChoiceQuestion',
  components: {
    QuestionErrorComp: QuestionErrorComp
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    answer: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    showError: {}
  },
  methods: {
    isOptionSelected(option) {
      return this.answer?.some(item => item.id === option.id);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/MultipleChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var Questions_MultipleChoicevue_type_script_lang_js = (MultipleChoicevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Surveys/Questions/MultipleChoice.vue?vue&type=style&index=0&id=d4753a3a&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var MultipleChoicevue_type_style_index_0_id_d4753a3a_prod_module_true_lang_scss = ({"root":"MultipleChoice_root_IjxIF","questionText":"MultipleChoice_questionText_o9OVr","required":"MultipleChoice_required_EM8DC","option":"MultipleChoice_option_VNEl_","label":"MultipleChoice_label_DgNBl"});
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/MultipleChoice.vue?vue&type=style&index=0&id=d4753a3a&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/MultipleChoice.vue



;




function MultipleChoice_injectStyles (context) {
  
  this["$style"] = (MultipleChoicevue_type_style_index_0_id_d4753a3a_prod_module_true_lang_scss.locals || MultipleChoicevue_type_style_index_0_id_d4753a3a_prod_module_true_lang_scss)

}

/* normalize component */

var MultipleChoice_component = normalizeComponent(
  Questions_MultipleChoicevue_type_script_lang_js,
  MultipleChoicevue_type_template_id_d4753a3a_render,
  MultipleChoicevue_type_template_id_d4753a3a_staticRenderFns,
  false,
  MultipleChoice_injectStyles,
  null,
  null
  
)

/* harmony default export */ var MultipleChoice = (MultipleChoice_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/Questions/FreeFormText.vue?vue&type=template&id=c66f9a74
var FreeFormTextvue_type_template_id_c66f9a74_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: [_vm.$style.questionText, _vm.required && _vm.$style.required],
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")]), _c('GTextArea', {
    attrs: {
      "answer": _vm.answer,
      "placeholder": _vm.placeholder,
      "textColor": "primary"
    },
    on: {
      "onAnswer": $event => _vm.$emit('onAnswer', $event)
    }
  }), _vm.showError ? _c('QuestionErrorComp', {
    class: _vm.$style.error
  }) : _vm._e()], 1);
};
var FreeFormTextvue_type_template_id_c66f9a74_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/Questions/FreeFormText.vue?vue&type=script&lang=js

/* harmony default export */ var FreeFormTextvue_type_script_lang_js = ({
  name: 'FreeFormTextQuestion',
  components: {
    QuestionErrorComp: QuestionErrorComp
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    answer: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Your answer'
    },
    showError: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/FreeFormText.vue?vue&type=script&lang=js
 /* harmony default export */ var Questions_FreeFormTextvue_type_script_lang_js = (FreeFormTextvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Surveys/Questions/FreeFormText.vue?vue&type=style&index=0&id=c66f9a74&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var FreeFormTextvue_type_style_index_0_id_c66f9a74_prod_lang_scss_module_true = ({"root":"FreeFormText_root_h1A0G","questionText":"FreeFormText_questionText_XhU77","required":"FreeFormText_required_BzboC","error":"FreeFormText_error_CWTdm"});
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/FreeFormText.vue?vue&type=style&index=0&id=c66f9a74&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/FreeFormText.vue



;




function FreeFormText_injectStyles (context) {
  
  this["$style"] = (FreeFormTextvue_type_style_index_0_id_c66f9a74_prod_lang_scss_module_true.locals || FreeFormTextvue_type_style_index_0_id_c66f9a74_prod_lang_scss_module_true)

}

/* normalize component */

var FreeFormText_component = normalizeComponent(
  Questions_FreeFormTextvue_type_script_lang_js,
  FreeFormTextvue_type_template_id_c66f9a74_render,
  FreeFormTextvue_type_template_id_c66f9a74_staticRenderFns,
  false,
  FreeFormText_injectStyles,
  null,
  null
  
)

/* harmony default export */ var FreeFormText = (FreeFormText_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/Questions/Rating.vue?vue&type=template&id=1b2c822e
var Ratingvue_type_template_id_1b2c822e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: [_vm.$style.questionText, _vm.required && _vm.$style.required],
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(_vm._s(_vm.text))]), _c('div', {
    class: _vm.$style.ratingWrapper
  }, _vm._l(_vm.starConfigs, function (conf, i) {
    return _c('SvgIcon', {
      key: i + 'input',
      attrs: {
        "name": conf.selected ? 'star' : 'outline-star',
        "size": "regular"
      },
      on: {
        "mouseover": function ($event) {
          _vm.hoveredStar = i;
        },
        "mouseout": function ($event) {
          _vm.hoveredStar = null;
        },
        "click": function ($event) {
          return _vm.$emit('onAnswer', i + 1);
        }
      }
    });
  }), 1), _vm.showError ? _c('QuestionErrorComp', {
    class: _vm.$style.error
  }) : _vm._e()], 1);
};
var Ratingvue_type_template_id_1b2c822e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/Questions/Rating.vue?vue&type=script&lang=js

/* harmony default export */ var Ratingvue_type_script_lang_js = ({
  name: 'RatingQuestion',
  components: {
    QuestionErrorComp: QuestionErrorComp
  },
  data() {
    return {
      maxStars: 5,
      hoveredStar: null
    };
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    answer: {
      type: Number,
      default: -1
    },
    required: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    starConfigs() {
      return new Array(this.maxStars).fill(0).map((_, i) => {
        let selected = false;
        if (this.hoveredStar !== null && i <= this.hoveredStar) {
          selected = true;
        } else if (this.hoveredStar === null && i < this.answer) {
          selected = true;
        }
        return {
          name: 'star' + i,
          selected
        };
      });
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/Rating.vue?vue&type=script&lang=js
 /* harmony default export */ var Questions_Ratingvue_type_script_lang_js = (Ratingvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Surveys/Questions/Rating.vue?vue&type=style&index=0&id=1b2c822e&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var Ratingvue_type_style_index_0_id_1b2c822e_prod_lang_scss_module_true = ({"root":"Rating_root_NJMma","questionText":"Rating_questionText_uk68J","required":"Rating_required_t0bSw","ratingWrapper":"Rating_ratingWrapper_M03pY","error":"Rating_error_h13Q2"});
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/Rating.vue?vue&type=style&index=0&id=1b2c822e&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Surveys/Questions/Rating.vue



;




function Rating_injectStyles (context) {
  
  this["$style"] = (Ratingvue_type_style_index_0_id_1b2c822e_prod_lang_scss_module_true.locals || Ratingvue_type_style_index_0_id_1b2c822e_prod_lang_scss_module_true)

}

/* normalize component */

var Rating_component = normalizeComponent(
  Questions_Ratingvue_type_script_lang_js,
  Ratingvue_type_template_id_1b2c822e_render,
  Ratingvue_type_template_id_1b2c822e_staticRenderFns,
  false,
  Rating_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Rating = (Rating_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/SurveyPopUp.vue?vue&type=template&id=3d46a358
var SurveyPopUpvue_type_template_id_3d46a358_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('IconButton', {
    class: _vm.$style.icon,
    attrs: {
      "icon": "rocket",
      "size": "large"
    }
  }), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "subHeading14"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('StyledText', {
    class: _vm.$style.description,
    attrs: {
      "variant": "heading14"
    }
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]), _c('div', {
    class: _vm.$style.actionBar
  }, [_c('PillButton', {
    class: _vm.$style.leftButton,
    attrs: {
      "alt": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onCancel');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.closeButtonText)) + " ")]), _c('PillButton', {
    class: _vm.$style.rightButton,
    attrs: {
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onSubmit');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.submitButtonText)) + " ")])], 1)], 1);
};
var SurveyPopUpvue_type_template_id_3d46a358_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/SurveyPopUp.vue?vue&type=script&lang=js
/* harmony default export */ var SurveyPopUpvue_type_script_lang_js = ({
  name: 'SurveyPopUp',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    submitButtonText: {
      type: String,
      default: 'Submit'
    },
    closeButtonText: {
      type: String,
      default: 'Cancel'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Surveys/SurveyPopUp.vue?vue&type=script&lang=js
 /* harmony default export */ var Surveys_SurveyPopUpvue_type_script_lang_js = (SurveyPopUpvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Surveys/SurveyPopUp.vue?vue&type=style&index=0&id=3d46a358&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SurveyPopUpvue_type_style_index_0_id_3d46a358_prod_lang_scss_module_true = ({"root":"SurveyPopUp_root_HhY4c","icon":"SurveyPopUp_icon_YwRXi","title":"SurveyPopUp_title_Ab7tK","description":"SurveyPopUp_description_TbTC_","actionBar":"SurveyPopUp_actionBar_N2NVu","leftButton":"SurveyPopUp_leftButton_h9xHx","rightButton":"SurveyPopUp_rightButton_C7Jab"});
;// CONCATENATED MODULE: ./src/components/Surveys/SurveyPopUp.vue?vue&type=style&index=0&id=3d46a358&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Surveys/SurveyPopUp.vue



;




function SurveyPopUp_injectStyles (context) {
  
  this["$style"] = (SurveyPopUpvue_type_style_index_0_id_3d46a358_prod_lang_scss_module_true.locals || SurveyPopUpvue_type_style_index_0_id_3d46a358_prod_lang_scss_module_true)

}

/* normalize component */

var SurveyPopUp_component = normalizeComponent(
  Surveys_SurveyPopUpvue_type_script_lang_js,
  SurveyPopUpvue_type_template_id_3d46a358_render,
  SurveyPopUpvue_type_template_id_3d46a358_staticRenderFns,
  false,
  SurveyPopUp_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SurveyPopUp = (SurveyPopUp_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/SurveyStageBarTip.vue?vue&type=template&id=dfbe9b6e
var SurveyStageBarTipvue_type_template_id_dfbe9b6e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.timeLeft ? _c('PillButton', {
    class: _vm.$style.timer,
    attrs: {
      "icon": "stopwatch",
      "center": "",
      "size": "x-small",
      "disabled": ""
    },
    on: {
      "click": () => {}
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Closing in 00:')) + _vm._s(_vm.timeLeft) + " ")]) : _vm._e(), _c('StyledText', {
    class: _vm.$style.text,
    attrs: {
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.surveyTitle)) + " ")]), _c('IconButton', {
    class: _vm.$style.actionButton,
    attrs: {
      "icon": "expand-view",
      "variant": "primary",
      "size": "small",
      "alt": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('expandSurveyView');
      }
    }
  })], 1);
};
var SurveyStageBarTipvue_type_template_id_dfbe9b6e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Surveys/SurveyStageBarTip.vue?vue&type=script&lang=js
/* harmony default export */ var SurveyStageBarTipvue_type_script_lang_js = ({
  name: 'SurveyStageBarTip',
  props: {
    timeLeft: {
      type: String,
      default: ''
    },
    surveyTitle: {
      type: String,
      default: 'Survey Title'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Surveys/SurveyStageBarTip.vue?vue&type=script&lang=js
 /* harmony default export */ var Surveys_SurveyStageBarTipvue_type_script_lang_js = (SurveyStageBarTipvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Surveys/SurveyStageBarTip.vue?vue&type=style&index=0&id=dfbe9b6e&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SurveyStageBarTipvue_type_style_index_0_id_dfbe9b6e_prod_lang_scss_module_true = ({"root":"SurveyStageBarTip_root_bFE8B","timer":"SurveyStageBarTip_timer_Fdrn5","text":"SurveyStageBarTip_text_rL2ED"});
;// CONCATENATED MODULE: ./src/components/Surveys/SurveyStageBarTip.vue?vue&type=style&index=0&id=dfbe9b6e&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Surveys/SurveyStageBarTip.vue



;




function SurveyStageBarTip_injectStyles (context) {
  
  this["$style"] = (SurveyStageBarTipvue_type_style_index_0_id_dfbe9b6e_prod_lang_scss_module_true.locals || SurveyStageBarTipvue_type_style_index_0_id_dfbe9b6e_prod_lang_scss_module_true)

}

/* normalize component */

var SurveyStageBarTip_component = normalizeComponent(
  Surveys_SurveyStageBarTipvue_type_script_lang_js,
  SurveyStageBarTipvue_type_template_id_dfbe9b6e_render,
  SurveyStageBarTipvue_type_template_id_dfbe9b6e_staticRenderFns,
  false,
  SurveyStageBarTip_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SurveyStageBarTip = (SurveyStageBarTip_component.exports);
;// CONCATENATED MODULE: ./src/components/Surveys/index.js







;// CONCATENATED MODULE: ./src/components/RoomAssets/index.js

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventEntry/EventDetails.vue?vue&type=template&id=90e0fac0
var EventDetailsvue_type_template_id_90e0fac0_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.eventImage,
    attrs: {
      "data-branding-target": "splash-hero"
    }
  }), _vm.is_title_visible ? _c('div', {
    class: _vm.$style.eventDetails
  }, [_c('div', {
    class: _vm.$style.titleContainer,
    attrs: {
      "data-branding-target": "splash-title"
    }
  }, [_c('FitText', {
    attrs: {
      "textcontent": _vm.eventTitle
    }
  })], 1), _vm.description ? _c('AboutRegistration', {
    attrs: {
      "description": _vm.description
    }
  }) : _vm._e(), _vm.ctaLink && _vm.ctaTitle ? _c('div', {
    class: _vm.$style.labelDiv
  }, [_c('SimpleLabel', {
    attrs: {
      "label": _vm.ctaLink
    },
    on: {
      "on-click": function ($event) {
        return _vm.$emit('cta-click');
      }
    }
  }, [_c('StyledText', {
    class: _vm.$style.ctaStyle,
    attrs: {
      "variant": "body13",
      "color": "splash-text-onimage-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.ctaTitle) + " ")])], 1)], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.hideEventDate,
      expression: "!hideEventDate"
    }],
    class: _vm.$style.headerFloaters,
    attrs: {
      "data-branding-target": "splash-dates"
    }
  }, [_c('div', {
    class: _vm.$style.floater
  }, [_c('SvgIcon', {
    class: _vm.$style.svgIcon,
    attrs: {
      "name": "calendar",
      "size": "medium",
      "color": "splash-text-onimage-color"
    }
  }), _c('div', {
    class: _vm.$style.floaterDetails,
    attrs: {
      "data-branding-target": "event-details"
    }
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading16",
      "color": "splash-text-onimage-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Date')) + " ")]), _c('StyledText', {
    class: _vm.$style.eventDates,
    attrs: {
      "variant": "body14",
      "color": "splash-text-onimage-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.eventDate) + " ")])], 1)], 1), _vm.eventLocation ? _c('div', {
    class: _vm.$style.floater
  }, [_c('SvgIcon', {
    class: _vm.$style.svgIcon,
    attrs: {
      "name": "location",
      "size": "medium",
      "color": "splash-text-onimage-color"
    }
  }), _c('div', {
    class: _vm.$style.floaterDetails
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading16",
      "color": "splash-text-onimage-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Location')) + " ")]), _c('StyledText', {
    class: _vm.$style.eventDates,
    attrs: {
      "variant": "body14",
      "color": "splash-text-onimage-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.eventLocation) + " ")])], 1)], 1) : _vm._e()])], 1) : _vm._e()]);
};
var EventDetailsvue_type_template_id_90e0fac0_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventEntry/EventDetails.vue?vue&type=script&lang=js

/* harmony default export */ var EventDetailsvue_type_script_lang_js = ({
  components: {
    aboutRegistration: aboutRegistration
  },
  props: {
    ctaLink: {
      type: String,
      default: ''
    },
    ctaTitle: {
      type: String,
      default: ''
    },
    eventTitle: {
      type: String,
      default: null
    },
    eventDate: {
      type: String,
      default: null
    },
    is_title_visible: {
      type: Boolean,
      default: true
    },
    eventLocation: String,
    description: String,
    hideEventDate: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EventEntry/EventDetails.vue?vue&type=script&lang=js
 /* harmony default export */ var EventEntry_EventDetailsvue_type_script_lang_js = (EventDetailsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventEntry/EventDetails.vue?vue&type=style&index=0&id=90e0fac0&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var EventDetailsvue_type_style_index_0_id_90e0fac0_prod_module_true_lang_scss = ({"root":"EventDetails_root_t18Ri","landingImg":"EventDetails_landingImg_aDAPh","eventImage":"EventDetails_eventImage_NUOck","eventDetails":"EventDetails_eventDetails_OScvE","headerFloaters":"EventDetails_headerFloaters_vlPVT","floater":"EventDetails_floater_UeTcY","svgIcon":"EventDetails_svgIcon_hDEm_","floaterDetails":"EventDetails_floaterDetails_JQ6Ve","eventDates":"EventDetails_eventDates_Y0cY4","titleContainer":"EventDetails_titleContainer_ooNgp","ctaStyle":"EventDetails_ctaStyle_Fq4_j","labelDiv":"EventDetails_labelDiv_Xwmwz","eventHeader":"EventDetails_eventHeader_JJmjS"});
;// CONCATENATED MODULE: ./src/components/EventEntry/EventDetails.vue?vue&type=style&index=0&id=90e0fac0&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/EventEntry/EventDetails.vue



;




function EventDetails_injectStyles (context) {
  
  this["$style"] = (EventDetailsvue_type_style_index_0_id_90e0fac0_prod_module_true_lang_scss.locals || EventDetailsvue_type_style_index_0_id_90e0fac0_prod_module_true_lang_scss)

}

/* normalize component */

var EventDetails_component = normalizeComponent(
  EventEntry_EventDetailsvue_type_script_lang_js,
  EventDetailsvue_type_template_id_90e0fac0_render,
  EventDetailsvue_type_template_id_90e0fac0_staticRenderFns,
  false,
  EventDetails_injectStyles,
  null,
  null
  
)

/* harmony default export */ var EventDetails = (EventDetails_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventEntry/HybridDialog.vue?vue&type=template&id=0bc7a21e
var HybridDialogvue_type_template_id_0bc7a21e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    attrs: {
      "noCancel": true
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('StyledText', {
    attrs: {
      "id": "dialogLabel",
      "variant": "heading15",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('How are you attending the event')) + "? ")]), _c('div', {
    class: _vm.$style.actions
  }, [_c('PillButton', {
    attrs: {
      "variant": "secondary",
      "icon": "virtual-attendee",
      "size": "large"
    },
    on: {
      "click": function ($event) {
        _vm.$emit('virtual') && _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Virtually')) + " ")]), _c('PillButton', {
    attrs: {
      "variant": "secondary",
      "alt": "",
      "icon": "in-person-attendee",
      "size": "large"
    },
    on: {
      "click": function ($event) {
        _vm.$emit('inPerson') && _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('In Person')) + " ")])], 1)], 1);
};
var HybridDialogvue_type_template_id_0bc7a21e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EventEntry/HybridDialog.vue?vue&type=script&lang=js

/* harmony default export */ var HybridDialogvue_type_script_lang_js = ({
  name: 'HybridDialog',
  components: {
    ModalsWrapper: ModalsWrapper
  }
});
;// CONCATENATED MODULE: ./src/components/EventEntry/HybridDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var EventEntry_HybridDialogvue_type_script_lang_js = (HybridDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EventEntry/HybridDialog.vue?vue&type=style&index=0&id=0bc7a21e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var HybridDialogvue_type_style_index_0_id_0bc7a21e_prod_module_true_lang_scss = ({"actions":"HybridDialog_actions_hhTZU"});
;// CONCATENATED MODULE: ./src/components/EventEntry/HybridDialog.vue?vue&type=style&index=0&id=0bc7a21e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/EventEntry/HybridDialog.vue



;




function HybridDialog_injectStyles (context) {
  
  this["$style"] = (HybridDialogvue_type_style_index_0_id_0bc7a21e_prod_module_true_lang_scss.locals || HybridDialogvue_type_style_index_0_id_0bc7a21e_prod_module_true_lang_scss)

}

/* normalize component */

var HybridDialog_component = normalizeComponent(
  EventEntry_HybridDialogvue_type_script_lang_js,
  HybridDialogvue_type_template_id_0bc7a21e_render,
  HybridDialogvue_type_template_id_0bc7a21e_staticRenderFns,
  false,
  HybridDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var HybridDialog = (HybridDialog_component.exports);
;// CONCATENATED MODULE: ./src/components/EventEntry/index.js


;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarVideoProduction/PopUpCreateTickerDialog.vue?vue&type=template&id=c0440652
var PopUpCreateTickerDialogvue_type_template_id_c0440652_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.dialogForm
  }, [!_vm.loading ? _c('div', {
    class: _vm.$style.header
  }, [_c('button', {
    staticClass: "button keyboard-focusable",
    attrs: {
      "aria-label": _vm.$options.$t('Close Ticker Popup')
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.cancel,
    attrs: {
      "name": "cross",
      "color": "primary-text-color"
    }
  })], 1)]) : _vm._e(), _c('div', {
    class: _vm.$style.headerContainer
  }, [_c('div', {
    class: _vm.$style.headerIcon
  }, [_c('SvgIcon', {
    class: _vm.$style.cancel,
    attrs: {
      "name": "notification",
      "color": "secondary-text-color"
    }
  })], 1), _c('StyledText', {
    attrs: {
      "variant": "heading16",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.heading)) + " ")])], 1), _c('div', {
    class: _vm.$style.subHeaderContainer
  }, [_c('StyledText', {
    attrs: {
      "variant": "body14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.subHeading)) + " ")])], 1), !_vm.loading ? _c('form', {
    class: _vm.$style.Form,
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('SimpleInput', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$options.$t(_vm.textPlaceholder1),
      "theme": "dark"
    },
    model: {
      value: _vm.textField1,
      callback: function ($$v) {
        _vm.textField1 = $$v;
      },
      expression: "textField1"
    }
  }), _vm.error.length > 0 ? _c('StyledText', {
    class: _vm.$style.error
  }, [_vm._v(_vm._s(_vm.$options.$t(_vm.error)))]) : _vm._e(), _c('SimpleInput', {
    class: _vm.$style.inputField,
    attrs: {
      "type": "text",
      "placeholder": _vm.textPlaceholder2,
      "theme": "dark"
    },
    model: {
      value: _vm.textField2,
      callback: function ($$v) {
        _vm.textField2 = $$v;
      },
      expression: "textField2"
    }
  }), _vm.urlError ? _c('StyledText', {
    class: _vm.$style.error
  }, [_vm._v(_vm._s(_vm.$options.$t(_vm.urlError)))]) : _vm._e()], 1) : _c('div', {
    class: _vm.$style.loadingContainer
  }, [_c('Loading', {
    attrs: {
      "size": "small",
      "theme": "primary"
    }
  })], 1), _c('div', {
    class: _vm.$style.buttonBar
  }, [_c('PillButton', {
    attrs: {
      "disabled": _vm.loading || _vm.buttonDisable,
      "center": "",
      "color": "primary-text-color",
      "align": "center"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.buttonText)) + " ")])], 1)]);
};
var PopUpCreateTickerDialogvue_type_template_id_c0440652_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SidebarVideoProduction/PopUpCreateTickerDialog.vue?vue&type=script&lang=js



/* harmony default export */ var PopUpCreateTickerDialogvue_type_script_lang_js = ({
  name: 'PopUpCreateTickerDialog',
  components: {
    SimpleInput: SimpleInput
  },
  props: {
    heading: {
      type: String
    },
    subHeading: {
      type: String
    },
    buttonText: {
      type: String,
      default: 'Launch'
    },
    charLimit1: {
      type: Number,
      default: 50
    },
    loading: {
      type: Boolean,
      default: false
    },
    textPlaceholder1: String,
    textPlaceholder2: String
  },
  data() {
    return {
      textField1: '',
      textField2: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      const messageInput = document.getElementById('tickerMessage');
      if (messageInput) {
        messageInput.querySelector('input')?.focus();
      }
      focusTrap({
        getAllFocusableElementOf: this.$el
      });
    });
  },
  methods: {
    submit() {
      this.$emit('submit', {
        text1: this.textField1,
        text2: this.textField2
      });
    }
  },
  computed: {
    buttonDisable() {
      if (!this.textField1 || parseInt(this.textField1.length) <= 0 || this.error.length !== 0 || this.urlError) {
        return true;
      }
      return false;
    },
    error() {
      if (parseInt(this.textField1.length) > this.charLimit1) {
        return `${this.charLimit1} characters limit`;
      }
      return '';
    },
    urlError() {
      return urlValidation(this.textField2);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/PopUpCreateTickerDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var SidebarVideoProduction_PopUpCreateTickerDialogvue_type_script_lang_js = (PopUpCreateTickerDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SidebarVideoProduction/PopUpCreateTickerDialog.vue?vue&type=style&index=0&id=c0440652&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var PopUpCreateTickerDialogvue_type_style_index_0_id_c0440652_prod_module_true_lang_scss = ({"dialogForm":"PopUpCreateTickerDialog_dialogForm_JsPZi","header":"PopUpCreateTickerDialog_header_g1xzp","headerContainer":"PopUpCreateTickerDialog_headerContainer_TjxTN","headerIcon":"PopUpCreateTickerDialog_headerIcon_HhgzW","subHeaderContainer":"PopUpCreateTickerDialog_subHeaderContainer_Vusnr","middleContainer":"PopUpCreateTickerDialog_middleContainer_KTOZg","loadingContainer":"PopUpCreateTickerDialog_loadingContainer_XZfGM","Form":"PopUpCreateTickerDialog_Form_xHbU3","SimpleInput_error":"PopUpCreateTickerDialog_SimpleInput_error_qF1X2","inputField":"PopUpCreateTickerDialog_inputField_HvDPo","buttonBar":"PopUpCreateTickerDialog_buttonBar_xb7rU","cancel":"PopUpCreateTickerDialog_cancel_Zn5CE","error":"PopUpCreateTickerDialog_error_dOAzA"});
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/PopUpCreateTickerDialog.vue?vue&type=style&index=0&id=c0440652&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/PopUpCreateTickerDialog.vue



;




function PopUpCreateTickerDialog_injectStyles (context) {
  
  this["$style"] = (PopUpCreateTickerDialogvue_type_style_index_0_id_c0440652_prod_module_true_lang_scss.locals || PopUpCreateTickerDialogvue_type_style_index_0_id_c0440652_prod_module_true_lang_scss)

}

/* normalize component */

var PopUpCreateTickerDialog_component = normalizeComponent(
  SidebarVideoProduction_PopUpCreateTickerDialogvue_type_script_lang_js,
  PopUpCreateTickerDialogvue_type_template_id_c0440652_render,
  PopUpCreateTickerDialogvue_type_template_id_c0440652_staticRenderFns,
  false,
  PopUpCreateTickerDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var PopUpCreateTickerDialog = (PopUpCreateTickerDialog_component.exports);
;// CONCATENATED MODULE: ./src/components/SidebarVideoProduction/index.js

;// CONCATENATED MODULE: ./src/examples/BroadcastModals/index.js

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/StreamErrorDialog.vue?vue&type=template&id=21853688
var StreamErrorDialogvue_type_template_id_21853688_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('div', {
    class: _vm.$style.icons
  }, [_vm.errorTypes[_vm.type] && (_vm.errorTypes[_vm.type].icons || []).includes('camera') ? _c('svg', {
    attrs: {
      "width": "80",
      "height": "80",
      "viewBox": "0 0 80 80",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "40",
      "r": "40",
      "fill": "#F5FAFF",
      "fill-opacity": "0.2"
    }
  }), _c('line', {
    attrs: {
      "x1": "24.3918",
      "y1": "26.4898",
      "x2": "58.4343",
      "y2": "57.9136",
      "stroke": "#FF0000",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M27.4918 33.2325C27.2993 33.5292 27.1875 33.883 27.1875 34.263V49.2214C27.1875 50.2684 28.0363 51.1172 29.0833 51.1172H46.8669L31.6945 37.112C31.4844 37.2721 31.2221 37.3672 30.9375 37.3672C30.2471 37.3672 29.6875 36.8075 29.6875 36.1172C29.6875 35.8685 29.7601 35.6367 29.8854 35.442L27.4918 33.2325ZM49.078 51.1168C50.1083 51.0975 50.9375 50.2563 50.9375 49.2214V45.2839L56.7716 47.2286C56.9762 47.2968 57.1875 47.1445 57.1875 46.9288V36.6284C57.1875 36.3936 56.9403 36.2408 56.7302 36.3458L50.9375 39.2422V34.263C50.9375 33.216 50.0887 32.3672 49.0417 32.3672H29.0833C28.9836 32.3672 28.8858 32.3749 28.7902 32.3897L49.078 51.1168Z",
      "fill": "#FF0000"
    }
  })]) : _vm._e(), _vm.errorTypes[_vm.type] && (_vm.errorTypes[_vm.type].icons || []).includes('mic') ? _c('svg', {
    attrs: {
      "width": "80",
      "height": "80",
      "viewBox": "0 0 80 80",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "40",
      "r": "40",
      "fill": "#F5FAFF",
      "fill-opacity": "0.2"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M24.9032 25.9411C24.5989 25.6601 24.1244 25.6791 23.8434 25.9835C23.5625 26.2878 23.5815 26.7623 23.8858 27.0433L34.6624 36.9909V37.6521L45.4489 47.6089C45.5679 47.4987 45.6827 47.3841 45.793 47.2653L47.1758 48.5417C47.0668 48.6618 46.9545 48.7786 46.839 48.8921L47.4746 49.4788C47.5896 49.3648 47.7016 49.2477 47.8106 49.1277L57.9283 58.4671C58.2326 58.748 58.7071 58.7291 58.9881 58.4247C59.269 58.1203 59.25 57.6458 58.9457 57.3649L48.731 47.9359C49.7062 46.44 50.2742 44.6428 50.2742 42.7122C50.2742 42.4736 50.0808 42.2802 49.8422 42.2802C49.6036 42.2802 49.4102 42.4736 49.4102 42.7122C49.4102 44.4196 48.9238 46.008 48.0865 47.341L46.6842 46.0466C47.2097 45.1153 47.5096 44.0398 47.5096 42.8942V32.9667C47.5096 29.4191 44.6337 26.5431 41.086 26.5431C37.5383 26.5431 34.6624 29.4191 34.6624 32.9667V34.9495L24.9032 25.9411ZM34.6624 42.8942V39.6935L44.2111 48.5077C43.2861 49.0237 42.2204 49.3178 41.086 49.3178C37.5383 49.3178 34.6624 46.4418 34.6624 42.8942ZM41.0827 51.2642C42.7749 51.2642 44.3515 50.745 45.6675 49.8521L46.3183 50.4528C44.9443 51.4302 43.2967 52.0337 41.5147 52.1181V56.7669H44.2945C44.5331 56.7669 44.7266 56.9604 44.7266 57.199C44.7266 57.4376 44.5331 57.631 44.2945 57.631H41.0827H37.8709C37.6323 57.631 37.4389 57.4376 37.4389 57.199C37.4389 56.9604 37.6323 56.7669 37.8709 56.7669H40.6507V51.6963V51.2642H41.0827ZM32.7553 42.7122C32.7553 42.4736 32.5618 42.2802 32.3232 42.2802C32.0847 42.2802 31.8912 42.4736 31.8912 42.7122C31.8912 45.9376 33.4751 48.7876 35.8933 50.485C36.0886 50.6221 36.358 50.5749 36.4951 50.3796C36.6322 50.1843 36.585 49.9149 36.3897 49.7778C34.1969 48.2386 32.7553 45.65 32.7553 42.7122Z",
      "fill": "#FF0000"
    }
  })]) : _vm._e()]), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.errorTypes[_vm.type] ? _vm.errorTypes[_vm.type].title : _vm.$options.$t('Uh OH... Something went wrong')) + " ")]), _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm.type === 'NotAllowedError' ? _c('span', [_vm._v(" " + _vm._s(_vm.$options.$t('To fix this, click the')) + " "), _c('svg', {
    class: _vm.$style.svg,
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "8",
      "cy": "8",
      "r": "8",
      "fill": "#F5FAFF"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.20508 6.74645C3.20508 6.15298 3.68618 5.67188 4.27965 5.67188H9.25551C9.84898 5.67188 10.3301 6.15298 10.3301 6.74645V7.73361L11.946 6.92563C12.0651 6.86609 12.2052 6.95268 12.2052 7.08582V9.92256C12.2052 10.0448 12.0855 10.1311 11.9695 10.0925L10.3301 9.54599V10.2223C10.3301 10.8158 9.84898 11.2969 9.25551 11.2969H4.27965C3.68618 11.2969 3.20508 10.8158 3.20508 10.2223V6.74645ZM4.70452 6.79636C4.70452 7.00347 4.53662 7.17136 4.32952 7.17136C4.12241 7.17136 3.95452 7.00347 3.95452 6.79636C3.95452 6.58926 4.12241 6.42136 4.32952 6.42136C4.53662 6.42136 4.70452 6.58926 4.70452 6.79636Z",
      "fill": "#101013",
      "fill-opacity": "0.5"
    }
  })]), _vm._v(" & "), _c('svg', {
    class: _vm.$style.svg,
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "8",
      "cy": "8",
      "r": "8",
      "fill": "#F5FAFF"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.70762 3.5459C6.71587 3.5459 5.9119 4.34987 5.9119 5.34162V8.48965C5.9119 9.4814 6.71587 10.2854 7.70762 10.2854C8.69937 10.2854 9.50334 9.4814 9.50334 8.48965V5.34162C9.50334 4.34987 8.69937 3.5459 7.70762 3.5459ZM5.50341 8.33274C5.50341 8.1975 5.39378 8.08786 5.25854 8.08786C5.1233 8.08786 5.01367 8.1975 5.01367 8.33274C5.01367 9.32034 5.4718 10.1986 6.17988 10.7248C6.28844 10.8054 6.44182 10.7828 6.52248 10.6743C6.60314 10.5657 6.58053 10.4123 6.47198 10.3317C5.89108 9.90005 5.50341 9.16898 5.50341 8.33274ZM10.4008 8.33274C10.4008 8.1975 10.2912 8.08786 10.156 8.08786C10.0207 8.08786 9.9111 8.1975 9.9111 8.33274C9.9111 9.68513 8.90584 10.7464 7.70726 10.7464H7.46238V10.9913V12.3748H6.80939C6.67416 12.3748 6.56452 12.4844 6.56452 12.6197C6.56452 12.7549 6.67416 12.8645 6.80939 12.8645H7.70726H8.60512C8.74036 12.8645 8.84999 12.7549 8.84999 12.6197C8.84999 12.4844 8.74036 12.3748 8.60512 12.3748H7.95213V11.2244C9.34016 11.0906 10.4008 9.83001 10.4008 8.33274Z",
      "fill": "#101013",
      "fill-opacity": "0.5"
    }
  })]), _vm._v(" " + _vm._s(_vm.$options.$t('in your URL bar, then select “Allow”, and then click “Try Again”')) + " ")]) : _vm._e(), _vm.errorTypes[_vm.type] ? _c('span', [_vm._v(" " + _vm._s(_vm.errorTypes[_vm.type].text || '') + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.$options.$t(`Couldn't initialize your media stream due to an unknown reason! Your browser might not be supported by our platform. We recommend using "Google Chrome". If this issue persists, please contact Goldcast Support`)) + ". ")]), _vm.type === 'NotReadableError' ? _c('span', [_vm._v(" " + _vm._s(_vm.$options.$t('To fix this, make sure your')) + " "), _c('svg', {
    class: _vm.$style.svg,
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "8",
      "cy": "8",
      "r": "8",
      "fill": "#F5FAFF"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.20508 6.74645C3.20508 6.15298 3.68618 5.67188 4.27965 5.67188H9.25551C9.84898 5.67188 10.3301 6.15298 10.3301 6.74645V7.73361L11.946 6.92563C12.0651 6.86609 12.2052 6.95268 12.2052 7.08582V9.92256C12.2052 10.0448 12.0855 10.1311 11.9695 10.0925L10.3301 9.54599V10.2223C10.3301 10.8158 9.84898 11.2969 9.25551 11.2969H4.27965C3.68618 11.2969 3.20508 10.8158 3.20508 10.2223V6.74645ZM4.70452 6.79636C4.70452 7.00347 4.53662 7.17136 4.32952 7.17136C4.12241 7.17136 3.95452 7.00347 3.95452 6.79636C3.95452 6.58926 4.12241 6.42136 4.32952 6.42136C4.53662 6.42136 4.70452 6.58926 4.70452 6.79636Z",
      "fill": "#101013",
      "fill-opacity": "0.5"
    }
  })]), _vm._v(" / "), _c('svg', {
    class: _vm.$style.svg,
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "8",
      "cy": "8",
      "r": "8",
      "fill": "#F5FAFF"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.70762 3.5459C6.71587 3.5459 5.9119 4.34987 5.9119 5.34162V8.48965C5.9119 9.4814 6.71587 10.2854 7.70762 10.2854C8.69937 10.2854 9.50334 9.4814 9.50334 8.48965V5.34162C9.50334 4.34987 8.69937 3.5459 7.70762 3.5459ZM5.50341 8.33274C5.50341 8.1975 5.39378 8.08786 5.25854 8.08786C5.1233 8.08786 5.01367 8.1975 5.01367 8.33274C5.01367 9.32034 5.4718 10.1986 6.17988 10.7248C6.28844 10.8054 6.44182 10.7828 6.52248 10.6743C6.60314 10.5657 6.58053 10.4123 6.47198 10.3317C5.89108 9.90005 5.50341 9.16898 5.50341 8.33274ZM10.4008 8.33274C10.4008 8.1975 10.2912 8.08786 10.156 8.08786C10.0207 8.08786 9.9111 8.1975 9.9111 8.33274C9.9111 9.68513 8.90584 10.7464 7.70726 10.7464H7.46238V10.9913V12.3748H6.80939C6.67416 12.3748 6.56452 12.4844 6.56452 12.6197C6.56452 12.7549 6.67416 12.8645 6.80939 12.8645H7.70726H8.60512C8.74036 12.8645 8.84999 12.7549 8.84999 12.6197C8.84999 12.4844 8.74036 12.3748 8.60512 12.3748H7.95213V11.2244C9.34016 11.0906 10.4008 9.83001 10.4008 8.33274Z",
      "fill": "#101013",
      "fill-opacity": "0.5"
    }
  })]), _vm._v(" " + _vm._s(_vm.$options.$t('is not being accessed by any other app. If not, please try changing your')) + " "), _c('svg', {
    class: _vm.$style.svg,
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "8",
      "cy": "8",
      "r": "8",
      "fill": "#F5FAFF"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.20508 6.74645C3.20508 6.15298 3.68618 5.67188 4.27965 5.67188H9.25551C9.84898 5.67188 10.3301 6.15298 10.3301 6.74645V7.73361L11.946 6.92563C12.0651 6.86609 12.2052 6.95268 12.2052 7.08582V9.92256C12.2052 10.0448 12.0855 10.1311 11.9695 10.0925L10.3301 9.54599V10.2223C10.3301 10.8158 9.84898 11.2969 9.25551 11.2969H4.27965C3.68618 11.2969 3.20508 10.8158 3.20508 10.2223V6.74645ZM4.70452 6.79636C4.70452 7.00347 4.53662 7.17136 4.32952 7.17136C4.12241 7.17136 3.95452 7.00347 3.95452 6.79636C3.95452 6.58926 4.12241 6.42136 4.32952 6.42136C4.53662 6.42136 4.70452 6.58926 4.70452 6.79636Z",
      "fill": "#101013",
      "fill-opacity": "0.5"
    }
  })]), _vm._v(" / "), _c('svg', {
    class: _vm.$style.svg,
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "8",
      "cy": "8",
      "r": "8",
      "fill": "#F5FAFF"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.70762 3.5459C6.71587 3.5459 5.9119 4.34987 5.9119 5.34162V8.48965C5.9119 9.4814 6.71587 10.2854 7.70762 10.2854C8.69937 10.2854 9.50334 9.4814 9.50334 8.48965V5.34162C9.50334 4.34987 8.69937 3.5459 7.70762 3.5459ZM5.50341 8.33274C5.50341 8.1975 5.39378 8.08786 5.25854 8.08786C5.1233 8.08786 5.01367 8.1975 5.01367 8.33274C5.01367 9.32034 5.4718 10.1986 6.17988 10.7248C6.28844 10.8054 6.44182 10.7828 6.52248 10.6743C6.60314 10.5657 6.58053 10.4123 6.47198 10.3317C5.89108 9.90005 5.50341 9.16898 5.50341 8.33274ZM10.4008 8.33274C10.4008 8.1975 10.2912 8.08786 10.156 8.08786C10.0207 8.08786 9.9111 8.1975 9.9111 8.33274C9.9111 9.68513 8.90584 10.7464 7.70726 10.7464H7.46238V10.9913V12.3748H6.80939C6.67416 12.3748 6.56452 12.4844 6.56452 12.6197C6.56452 12.7549 6.67416 12.8645 6.80939 12.8645H7.70726H8.60512C8.74036 12.8645 8.84999 12.7549 8.84999 12.6197C8.84999 12.4844 8.74036 12.3748 8.60512 12.3748H7.95213V11.2244C9.34016 11.0906 10.4008 9.83001 10.4008 8.33274Z",
      "fill": "#101013",
      "fill-opacity": "0.5"
    }
  })]), _vm._v(" " + _vm._s(_vm.$options.$t(`devices by clicking on "Go To Settings". After resolving the probable issue, hit "Try Again"!`)) + " ")]) : _vm._e()]), _c('PillButton', {
    class: _vm.$style.okay,
    attrs: {
      "alt": "",
      "variant": "primary",
      "size": "x-small",
      "selected": "",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('opensettings');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Go To Settings')) + " ")]), _c('PillButton', {
    class: _vm.$style.okay,
    attrs: {
      "alt": "",
      "variant": "primary",
      "size": "x-small",
      "selected": "",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('hide');
      }
    }
  }, [_c('svg', {
    class: _vm.$style.refreshIcon,
    attrs: {
      "slot": "icon",
      "width": "12",
      "height": "14",
      "viewBox": "0 0 12 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    slot: "icon"
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.85356 3.03933L7.20711 2.68577L6.85356 2.33222L4.73224 0.2109C4.53697 0.0156376 4.22039 0.0156376 4.02513 0.2109C3.82987 0.406162 3.82987 0.722744 4.02513 0.918006L5.10936 2.00224C4.23907 2.13288 3.40437 2.45398 2.66658 2.94696C1.67989 3.60624 0.910851 4.54332 0.456726 5.63967C0.00259971 6.73603 -0.11622 7.94243 0.115291 9.10632C0.346802 10.2702 0.918247 11.3393 1.75736 12.1784C2.59648 13.0175 3.66557 13.589 4.82946 13.8205C5.99335 14.052 7.19975 13.9332 8.2961 13.4791C9.39246 13.0249 10.3295 12.2559 10.9888 11.2692C11.6481 10.2825 12 9.12246 12 7.93577C12 7.65963 11.7761 7.43577 11.5 7.43577C11.2239 7.43577 11 7.65963 11 7.93577C11 8.92468 10.7068 9.89138 10.1574 10.7136C9.60794 11.5359 8.82705 12.1767 7.91342 12.5552C6.99979 12.9336 5.99446 13.0326 5.02455 12.8397C4.05465 12.6468 3.16373 12.1706 2.46447 11.4713C1.76521 10.772 1.289 9.88113 1.09608 8.91123C0.90315 7.94132 1.00217 6.93599 1.38061 6.02236C1.75904 5.10873 2.39991 4.32783 3.22215 3.77843C3.91067 3.31837 4.70047 3.03794 5.51979 2.95888L4.02513 4.45354C3.82987 4.6488 3.82987 4.96538 4.02513 5.16065C4.22039 5.35591 4.53697 5.35591 4.73224 5.16065L6.85356 3.03933Z",
      "fill": "#101013"
    }
  })]), _vm._v(" " + _vm._s(_vm.$options.$t('Try Again')) + " ")]), _c('PillButton', {
    class: _vm.$style.okay,
    attrs: {
      "alt": "",
      "variant": "primary",
      "size": "x-small",
      "selected": "",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        _vm.$emit('enterwithoutvideo') && _vm.$emit('cancel');
      }
    }
  }, [_c('svg', {
    attrs: {
      "slot": "icon",
      "width": "12",
      "height": "14",
      "viewBox": "0 0 12 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    slot: "icon"
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.85356 3.03933L7.20711 2.68577L6.85356 2.33222L4.73224 0.2109C4.53697 0.0156376 4.22039 0.0156376 4.02513 0.2109C3.82987 0.406162 3.82987 0.722744 4.02513 0.918006L5.10936 2.00224C4.23907 2.13288 3.40437 2.45398 2.66658 2.94696C1.67989 3.60624 0.910851 4.54332 0.456726 5.63967C0.00259971 6.73603 -0.11622 7.94243 0.115291 9.10632C0.346802 10.2702 0.918247 11.3393 1.75736 12.1784C2.59648 13.0175 3.66557 13.589 4.82946 13.8205C5.99335 14.052 7.19975 13.9332 8.2961 13.4791C9.39246 13.0249 10.3295 12.2559 10.9888 11.2692C11.6481 10.2825 12 9.12246 12 7.93577C12 7.65963 11.7761 7.43577 11.5 7.43577C11.2239 7.43577 11 7.65963 11 7.93577C11 8.92468 10.7068 9.89138 10.1574 10.7136C9.60794 11.5359 8.82705 12.1767 7.91342 12.5552C6.99979 12.9336 5.99446 13.0326 5.02455 12.8397C4.05465 12.6468 3.16373 12.1706 2.46447 11.4713C1.76521 10.772 1.289 9.88113 1.09608 8.91123C0.90315 7.94132 1.00217 6.93599 1.38061 6.02236C1.75904 5.10873 2.39991 4.32783 3.22215 3.77843C3.91067 3.31837 4.70047 3.03794 5.51979 2.95888L4.02513 4.45354C3.82987 4.6488 3.82987 4.96538 4.02513 5.16065C4.22039 5.35591 4.53697 5.35591 4.73224 5.16065L6.85356 3.03933Z",
      "fill": "#101013"
    }
  })]), _vm._v(" " + _vm._s(_vm.$options.$t('Try Joining without Video')) + " ")])], 1);
};
var StreamErrorDialogvue_type_template_id_21853688_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/StreamErrorDialog.vue?vue&type=script&lang=js

/* harmony default export */ var StreamErrorDialogvue_type_script_lang_js = ({
  name: 'StreamErrorDialog',
  components: {
    ModalsWrapper: ModalsWrapper
  },
  data() {
    return {
      errorTypes: {
        NotAllowedError: {
          title: this.$t('Camera & Mic blocked'),
          icons: ['camera', 'mic']
        },
        NotReadableError: {
          title: this.$t('Camera/Mic Inaccessible'),
          icons: ['camera', 'mic']
        },
        NotFoundError: {
          title: this.$t('Camera/Mic Not Found'),
          icons: ['camera', 'mic'],
          text: 'No microphone/camera is found'
        },
        MEDIA_OPTION_INVALID: {
          title: this.$t('Camera Inaccessible'),
          icons: ['camera'],
          text: this.$t('The camera is occupied or the resolution is not supported. Please make sure your camera is not being used by another application and try again!')
        },
        DEVICES_NOT_FOUND: {
          title: this.$t('Camera/Mic Not Found'),
          icons: ['camera', 'mic'],
          text: this.$t('No microphone/camera is found')
        },
        NOT_SUPPORTED: {
          title: this.$t('Camera & Mic blocked'),
          icons: ['camera', 'mic'],
          text: this.$t('The browser does not support using camera and microphone!')
        },
        PERMISSION_DENIED: {
          title: this.$t('Camera & Mic blocked'),
          icons: ['camera', 'mic'],
          text: this.$t("The device is disabled by the browser or permissions have not been granted for the use. Please provide permissions and click 'Try again'")
        }
      }
    };
  },
  props: {
    type: String
  }
});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/StreamErrorDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var RoomErrorModals_StreamErrorDialogvue_type_script_lang_js = (StreamErrorDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/RoomErrorModals/StreamErrorDialog.vue?vue&type=style&index=0&id=21853688&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var StreamErrorDialogvue_type_style_index_0_id_21853688_prod_module_true_lang_scss = ({"icons":"StreamErrorDialog_icons_ez6Fp","title":"StreamErrorDialog_title_pqbab","content":"StreamErrorDialog_content_PqJeX","okay":"StreamErrorDialog_okay_unpT0","svg":"StreamErrorDialog_svg_KjJva"});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/StreamErrorDialog.vue?vue&type=style&index=0&id=21853688&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/StreamErrorDialog.vue



;




function StreamErrorDialog_injectStyles (context) {
  
  this["$style"] = (StreamErrorDialogvue_type_style_index_0_id_21853688_prod_module_true_lang_scss.locals || StreamErrorDialogvue_type_style_index_0_id_21853688_prod_module_true_lang_scss)

}

/* normalize component */

var StreamErrorDialog_component = normalizeComponent(
  RoomErrorModals_StreamErrorDialogvue_type_script_lang_js,
  StreamErrorDialogvue_type_template_id_21853688_render,
  StreamErrorDialogvue_type_template_id_21853688_staticRenderFns,
  false,
  StreamErrorDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var StreamErrorDialog = (StreamErrorDialog_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/ScreenStreamErrorDialog.vue?vue&type=template&id=08b2435e
var ScreenStreamErrorDialogvue_type_template_id_08b2435e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('div', {
    class: _vm.$style.icons
  }, [_c('svg', {
    attrs: {
      "width": "80",
      "height": "80",
      "viewBox": "0 0 80 80",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "40",
      "cy": "40",
      "r": "40",
      "fill": "#F5FAFF",
      "fill-opacity": "0.2"
    }
  }), _c('line', {
    attrs: {
      "x1": "24.3938",
      "y1": "26.4918",
      "x2": "58.4362",
      "y2": "57.9156",
      "stroke": "#FF0000",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M41.5556 36L41.5557 46",
      "stroke": "#FF0000",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M46 40.4453L41.5556 36.0009L37.1111 40.4453",
      "stroke": "#FF0000",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M24.2312 30.0658C24.0836 30.3446 24 30.6625 24 31V51C24 52.1046 24.8954 53 26 53H49.0766L47.9933 52H26C25.4477 52 25 51.5523 25 51V31C25 30.9297 25.0073 30.8611 25.0211 30.7949L24.2312 30.0658ZM50.9419 52H56C56.5523 52 57 51.5523 57 51V31C57 30.4477 56.5523 30 56 30H27.1086L26.0252 29H56C57.1046 29 58 29.8954 58 31V51C58 52.1046 57.1046 53 56 53H52.0252L50.9419 52Z",
      "fill": "#FF0000"
    }
  })])]), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Screenshare had an issue')) + " ")]), _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.type) + " " + _vm._s(_vm.$options.$t('Could not share screen unexpectedly. Refresh & retry. On mac go to')) + " "), _c('div', {
    class: _vm.$style.path
  }, [_c('span', {
    class: _vm.$style.tag
  }, [_vm._v("System Preference")]), _vm._v(" > "), _c('span', {
    class: _vm.$style.tag
  }, [_vm._v("Security & Privacy")]), _vm._v(" > "), _c('span', {
    class: _vm.$style.tag
  }, [_vm._v("Screen Recording")])]), _vm._v(" " + _vm._s(_vm.$options.$t('and check if your browser has the required permission')) + ". ")])], 1);
};
var ScreenStreamErrorDialogvue_type_template_id_08b2435e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/ScreenStreamErrorDialog.vue?vue&type=script&lang=js

/* harmony default export */ var ScreenStreamErrorDialogvue_type_script_lang_js = ({
  name: 'ScreenStreamErrorDialog',
  components: {
    ModalsWrapper: ModalsWrapper
  },
  props: {
    title: String,
    text: String
  }
});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/ScreenStreamErrorDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var RoomErrorModals_ScreenStreamErrorDialogvue_type_script_lang_js = (ScreenStreamErrorDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/RoomErrorModals/ScreenStreamErrorDialog.vue?vue&type=style&index=0&id=08b2435e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ScreenStreamErrorDialogvue_type_style_index_0_id_08b2435e_prod_module_true_lang_scss = ({"icons":"ScreenStreamErrorDialog_icons_PvG9d","title":"ScreenStreamErrorDialog_title_wMbbe","content":"ScreenStreamErrorDialog_content_mU_7P","okay":"ScreenStreamErrorDialog_okay_VCi85","svg":"ScreenStreamErrorDialog_svg_seC0b","refreshIcon":"ScreenStreamErrorDialog_refreshIcon_ADyJm","path":"ScreenStreamErrorDialog_path_Nl8EQ","tag":"ScreenStreamErrorDialog_tag_FzkGd"});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/ScreenStreamErrorDialog.vue?vue&type=style&index=0&id=08b2435e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/ScreenStreamErrorDialog.vue



;




function ScreenStreamErrorDialog_injectStyles (context) {
  
  this["$style"] = (ScreenStreamErrorDialogvue_type_style_index_0_id_08b2435e_prod_module_true_lang_scss.locals || ScreenStreamErrorDialogvue_type_style_index_0_id_08b2435e_prod_module_true_lang_scss)

}

/* normalize component */

var ScreenStreamErrorDialog_component = normalizeComponent(
  RoomErrorModals_ScreenStreamErrorDialogvue_type_script_lang_js,
  ScreenStreamErrorDialogvue_type_template_id_08b2435e_render,
  ScreenStreamErrorDialogvue_type_template_id_08b2435e_staticRenderFns,
  false,
  ScreenStreamErrorDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ScreenStreamErrorDialog = (ScreenStreamErrorDialog_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/UnknownErrorDialog.vue?vue&type=template&id=61cb3a0f
var UnknownErrorDialogvue_type_template_id_61cb3a0f_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.title)) + " ")]), !_vm.customMessage ? _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.type) + " " + _vm._s(_vm.$options.$t('A refresh and rejoin should work')) + " ")]) : _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")]), _c('PillButton', {
    class: _vm.$style.okay,
    attrs: {
      "alt": "",
      "variant": "primary",
      "size": "x-small",
      "selected": "",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('hide');
      }
    }
  }, [_c('svg', {
    attrs: {
      "slot": "icon",
      "width": "12",
      "height": "14",
      "viewBox": "0 0 12 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    slot: "icon"
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.85356 3.03933L7.20711 2.68577L6.85356 2.33222L4.73224 0.2109C4.53697 0.0156376 4.22039 0.0156376 4.02513 0.2109C3.82987 0.406162 3.82987 0.722744 4.02513 0.918006L5.10936 2.00224C4.23907 2.13288 3.40437 2.45398 2.66658 2.94696C1.67989 3.60624 0.910851 4.54332 0.456726 5.63967C0.00259971 6.73603 -0.11622 7.94243 0.115291 9.10632C0.346802 10.2702 0.918247 11.3393 1.75736 12.1784C2.59648 13.0175 3.66557 13.589 4.82946 13.8205C5.99335 14.052 7.19975 13.9332 8.2961 13.4791C9.39246 13.0249 10.3295 12.2559 10.9888 11.2692C11.6481 10.2825 12 9.12246 12 7.93577C12 7.65963 11.7761 7.43577 11.5 7.43577C11.2239 7.43577 11 7.65963 11 7.93577C11 8.92468 10.7068 9.89138 10.1574 10.7136C9.60794 11.5359 8.82705 12.1767 7.91342 12.5552C6.99979 12.9336 5.99446 13.0326 5.02455 12.8397C4.05465 12.6468 3.16373 12.1706 2.46447 11.4713C1.76521 10.772 1.289 9.88113 1.09608 8.91123C0.90315 7.94132 1.00217 6.93599 1.38061 6.02236C1.75904 5.10873 2.39991 4.32783 3.22215 3.77843C3.91067 3.31837 4.70047 3.03794 5.51979 2.95888L4.02513 4.45354C3.82987 4.6488 3.82987 4.96538 4.02513 5.16065C4.22039 5.35591 4.53697 5.35591 4.73224 5.16065L6.85356 3.03933Z",
      "fill": "#101013"
    }
  })]), _vm._v(" " + _vm._s(_vm.$options.$t(_vm.buttonText)) + " ")])], 1);
};
var UnknownErrorDialogvue_type_template_id_61cb3a0f_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/UnknownErrorDialog.vue?vue&type=script&lang=js

/* harmony default export */ var UnknownErrorDialogvue_type_script_lang_js = ({
  name: 'UnknownErrorDialog',
  components: {
    ModalsWrapper: ModalsWrapper
  },
  props: {
    title: {
      type: String,
      default: 'Uh OH... Something went wrong'
    },
    text: String,
    buttonText: {
      type: String,
      default: 'Refresh & Rejoin'
    },
    customMessage: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/UnknownErrorDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var RoomErrorModals_UnknownErrorDialogvue_type_script_lang_js = (UnknownErrorDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/RoomErrorModals/UnknownErrorDialog.vue?vue&type=style&index=0&id=61cb3a0f&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var UnknownErrorDialogvue_type_style_index_0_id_61cb3a0f_prod_module_true_lang_scss = ({"icons":"UnknownErrorDialog_icons_RH3gQ","title":"UnknownErrorDialog_title_NkBGe","content":"UnknownErrorDialog_content_XU9ec","okay":"UnknownErrorDialog_okay_I4DAT","svg":"UnknownErrorDialog_svg_ACoPI"});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/UnknownErrorDialog.vue?vue&type=style&index=0&id=61cb3a0f&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/UnknownErrorDialog.vue



;




function UnknownErrorDialog_injectStyles (context) {
  
  this["$style"] = (UnknownErrorDialogvue_type_style_index_0_id_61cb3a0f_prod_module_true_lang_scss.locals || UnknownErrorDialogvue_type_style_index_0_id_61cb3a0f_prod_module_true_lang_scss)

}

/* normalize component */

var UnknownErrorDialog_component = normalizeComponent(
  RoomErrorModals_UnknownErrorDialogvue_type_script_lang_js,
  UnknownErrorDialogvue_type_template_id_61cb3a0f_render,
  UnknownErrorDialogvue_type_template_id_61cb3a0f_staticRenderFns,
  false,
  UnknownErrorDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UnknownErrorDialog = (UnknownErrorDialog_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/AutoplayErrorDialog.vue?vue&type=template&id=e8a355b4
var AutoplayErrorDialogvue_type_template_id_e8a355b4_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    class: _vm.$style.root,
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('div', {
    class: _vm.$style.icons
  }, [_c('SvgIcon', {
    class: _vm.$style.svgIcon,
    attrs: {
      "name": "volume",
      "size": "medium",
      "color": "alert"
    }
  })], 1), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Enable Audio')) + " ")]), _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Audio got muted due to browser autoplay policies. Click enable below, to unmute. You can also unmute audio later through embedded controls.')) + " ")]), _c('PillButton', {
    class: _vm.$style.okay,
    attrs: {
      "alt": "",
      "variant": "primary",
      "size": "x-small",
      "selected": "",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('hide');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Enable')) + " ")]), _c('button', {
    staticClass: "button keyboard-focusable",
    class: _vm.$style.cancel,
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('StyledText', {
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Cancel')) + " ")])], 1)], 1);
};
var AutoplayErrorDialogvue_type_template_id_e8a355b4_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/AutoplayErrorDialog.vue?vue&type=script&lang=js

/* harmony default export */ var AutoplayErrorDialogvue_type_script_lang_js = ({
  name: 'AutoplayErrorDialog',
  components: {
    ModalsWrapper: ModalsWrapper
  },
  props: {
    title: String,
    text: String
  }
});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/AutoplayErrorDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var RoomErrorModals_AutoplayErrorDialogvue_type_script_lang_js = (AutoplayErrorDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/RoomErrorModals/AutoplayErrorDialog.vue?vue&type=style&index=0&id=e8a355b4&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var AutoplayErrorDialogvue_type_style_index_0_id_e8a355b4_prod_module_true_lang_scss = ({"root":"AutoplayErrorDialog_root_LUxwv","icons":"AutoplayErrorDialog_icons_tot2z","title":"AutoplayErrorDialog_title_jYRta","content":"AutoplayErrorDialog_content_R8onJ","okay":"AutoplayErrorDialog_okay_rwezl","svg":"AutoplayErrorDialog_svg_SmFFv","svgIcon":"AutoplayErrorDialog_svgIcon_gM41H","cancel":"AutoplayErrorDialog_cancel_XA0g8"});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/AutoplayErrorDialog.vue?vue&type=style&index=0&id=e8a355b4&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/AutoplayErrorDialog.vue



;




function AutoplayErrorDialog_injectStyles (context) {
  
  this["$style"] = (AutoplayErrorDialogvue_type_style_index_0_id_e8a355b4_prod_module_true_lang_scss.locals || AutoplayErrorDialogvue_type_style_index_0_id_e8a355b4_prod_module_true_lang_scss)

}

/* normalize component */

var AutoplayErrorDialog_component = normalizeComponent(
  RoomErrorModals_AutoplayErrorDialogvue_type_script_lang_js,
  AutoplayErrorDialogvue_type_template_id_e8a355b4_render,
  AutoplayErrorDialogvue_type_template_id_e8a355b4_staticRenderFns,
  false,
  AutoplayErrorDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AutoplayErrorDialog = (AutoplayErrorDialog_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/LeaveRoomDialog.vue?vue&type=template&id=7f0467a7
var LeaveRoomDialogvue_type_template_id_7f0467a7_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    attrs: {
      "noCancel": _vm.noCancel
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('StyledText', {
    class: [_vm.$style.title, _vm.uppercase && _vm.$style.uppercase],
    attrs: {
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.getTitle) + " ")]), _vm.showTimerText && _vm.timeRemaining ? _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(`you will be redirected to stage in`)) + " " + _vm._s(_vm.timeRemaining) + " " + _vm._s(_vm.$options.$t(`sec. . `)) + " ")]) : _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.getText) + " ")]), _c('PillButton', {
    class: _vm.$style.okay,
    attrs: {
      "alt": "",
      "variant": "primary",
      "size": "x-small",
      "selected": "",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('hide');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Continue')) + " ")]), _vm.showCancelButton ? _c('StyledText', {
    class: _vm.$style.cancel,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Cancel')) + " ")]) : _vm._e()], 1);
};
var LeaveRoomDialogvue_type_template_id_7f0467a7_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/LeaveRoomDialog.vue?vue&type=script&lang=js

/* harmony default export */ var LeaveRoomDialogvue_type_script_lang_js = ({
  name: 'LeaveRoomDialog',
  components: {
    ModalsWrapper: ModalsWrapper
  },
  data() {
    return {
      timeRemaining: 5,
      interval: null
    };
  },
  props: {
    noCancel: {
      type: Boolean,
      default: false
    },
    title: String,
    text: String,
    showTimerText: {
      type: Boolean,
      default: false
    },
    time: {
      type: Number,
      default: 5
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    uppercase: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.timeRemaining = this.time;
    this.interval = setInterval(() => {
      if (this.timeRemaining) {
        this.timeRemaining -= 1;
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  computed: {
    getTitle() {
      if (!this.title) {
        return this.$options.$t('Are you sure you want to leave this room?');
      }
      return this.title;
    },
    getText() {
      if (!this.text) {
        return this.$options.$t('You are being redirected outside the room. Would you like to continue?');
      }
      return this.text;
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/LeaveRoomDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var RoomErrorModals_LeaveRoomDialogvue_type_script_lang_js = (LeaveRoomDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/RoomErrorModals/LeaveRoomDialog.vue?vue&type=style&index=0&id=7f0467a7&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var LeaveRoomDialogvue_type_style_index_0_id_7f0467a7_prod_module_true_lang_scss = ({"title":"LeaveRoomDialog_title_wgR9U","uppercase":"LeaveRoomDialog_uppercase_ZT2O1","content":"LeaveRoomDialog_content_S91O5","okay":"LeaveRoomDialog_okay_ixmYe","cancel":"LeaveRoomDialog_cancel_zZISx"});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/LeaveRoomDialog.vue?vue&type=style&index=0&id=7f0467a7&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/LeaveRoomDialog.vue



;




function LeaveRoomDialog_injectStyles (context) {
  
  this["$style"] = (LeaveRoomDialogvue_type_style_index_0_id_7f0467a7_prod_module_true_lang_scss.locals || LeaveRoomDialogvue_type_style_index_0_id_7f0467a7_prod_module_true_lang_scss)

}

/* normalize component */

var LeaveRoomDialog_component = normalizeComponent(
  RoomErrorModals_LeaveRoomDialogvue_type_script_lang_js,
  LeaveRoomDialogvue_type_template_id_7f0467a7_render,
  LeaveRoomDialogvue_type_template_id_7f0467a7_staticRenderFns,
  false,
  LeaveRoomDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LeaveRoomDialog = (LeaveRoomDialog_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/NoICEErrorDialog.vue?vue&type=template&id=0f547896
var NoICEErrorDialogvue_type_template_id_0f547896_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Could not connect')) + " ")]), _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('This could be due a secure network, browser/device issue. Please try changing your network, browser or device if the issue persists')) + ". ")]), _vm.liteMode ? _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Alternatively, you can use lite mode which will have a 30s delay from the live broadcast')) + ". ")]) : _vm._e(), _c('div', {
    class: _vm.$style.actions
  }, [!_vm.hideAction ? _c('PillButton', {
    class: _vm.$style.okay,
    attrs: {
      "variant": "secondary",
      "size": "x-small",
      "selected": "",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('hide');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.liteMode ? _vm.$options.$t('Switch to Lite Mode') : _vm.$options.$t('Leave')) + " ")]) : _vm._e(), _c('StyledText', {
    class: _vm.$style.cancel,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color",
      "underline": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Cancel')) + " ")])], 1)], 1);
};
var NoICEErrorDialogvue_type_template_id_0f547896_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/NoICEErrorDialog.vue?vue&type=script&lang=js

/* harmony default export */ var NoICEErrorDialogvue_type_script_lang_js = ({
  name: 'NoICEErrorDialog',
  components: {
    ModalsWrapper: ModalsWrapper
  },
  props: {
    title: String,
    text: String,
    liteMode: Boolean,
    hideAction: Boolean
  }
});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/NoICEErrorDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var RoomErrorModals_NoICEErrorDialogvue_type_script_lang_js = (NoICEErrorDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/RoomErrorModals/NoICEErrorDialog.vue?vue&type=style&index=0&id=0f547896&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var NoICEErrorDialogvue_type_style_index_0_id_0f547896_prod_module_true_lang_scss = ({"title":"NoICEErrorDialog_title_uJHHO","content":"NoICEErrorDialog_content_dvBXu","actions":"NoICEErrorDialog_actions_I0AEQ","okay":"NoICEErrorDialog_okay_63C7Z","cancel":"NoICEErrorDialog_cancel__i3Mu"});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/NoICEErrorDialog.vue?vue&type=style&index=0&id=0f547896&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/NoICEErrorDialog.vue



;




function NoICEErrorDialog_injectStyles (context) {
  
  this["$style"] = (NoICEErrorDialogvue_type_style_index_0_id_0f547896_prod_module_true_lang_scss.locals || NoICEErrorDialogvue_type_style_index_0_id_0f547896_prod_module_true_lang_scss)

}

/* normalize component */

var NoICEErrorDialog_component = normalizeComponent(
  RoomErrorModals_NoICEErrorDialogvue_type_script_lang_js,
  NoICEErrorDialogvue_type_template_id_0f547896_render,
  NoICEErrorDialogvue_type_template_id_0f547896_staticRenderFns,
  false,
  NoICEErrorDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var NoICEErrorDialog = (NoICEErrorDialog_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/NetworkErrorDialog.vue?vue&type=template&id=0698b4d6
var NetworkErrorDialogvue_type_template_id_0698b4d6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalsWrapper', {
    class: _vm.$style.root,
    attrs: {
      "noCancel": _vm.noCancel
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.title)) + " ")]), _vm.text ? _c('StyledText', {
    class: _vm.$style.content,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$options.$t(_vm.text))
    }
  })]) : _vm._e(), _c('Loading', {
    class: _vm.$style.loader,
    attrs: {
      "size": "small"
    }
  }), _vm.liteMode ? _c('PillButton', {
    class: _vm.$style.actions,
    attrs: {
      "variant": "secondary",
      "size": "xx-small",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('turnOnLiteMode');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Turn On Lite Mode')) + " ")]) : _vm._e(), _vm.buttonText ? _c('PillButton', {
    class: _vm.$style.actions,
    attrs: {
      "variant": _vm.liteMode ? 'primary' : 'secondary',
      "size": "xx-small",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('buttonAction');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.buttonText)) + " ")]) : _vm._e(), _vm.bannerText ? _c('StyledText', {
    class: _vm.$style.actions,
    attrs: {
      "variant": "subHeading15",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.bannerText)) + " ")]) : _vm._e(), _c('div', {
    class: _vm.$style.helpdocLink
  }, [_c('HelpdocLink', {
    attrs: {
      "link": _vm.helpdocLink
    }
  })], 1)], 1);
};
var NetworkErrorDialogvue_type_template_id_0698b4d6_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RoomErrorModals/NetworkErrorDialog.vue?vue&type=script&lang=js


/* harmony default export */ var NetworkErrorDialogvue_type_script_lang_js = ({
  name: 'NetworkErrorDialog',
  components: {
    ModalsWrapper: ModalsWrapper
  },
  props: {
    title: {
      type: String,
      default: 'We detected a network issue'
    },
    text: {
      type: String,
      default: 'Please make sure you are not connected through a VPN/Firewall. Try changing your network, browser or device if the issue persists.'
    },
    liteMode: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: ''
    },
    bannerText: {
      type: String,
      default: ''
    },
    noCancel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      helpdocLink: helpDocLinks.CONNECTION_SETTINGS
    };
  }
});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/NetworkErrorDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var RoomErrorModals_NetworkErrorDialogvue_type_script_lang_js = (NetworkErrorDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/RoomErrorModals/NetworkErrorDialog.vue?vue&type=style&index=0&id=0698b4d6&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var NetworkErrorDialogvue_type_style_index_0_id_0698b4d6_prod_module_true_lang_scss = ({"root":"NetworkErrorDialog_root_TZ6O5","title":"NetworkErrorDialog_title_cHcwx","content":"NetworkErrorDialog_content_mIj7K","helpdocLink":"NetworkErrorDialog_helpdocLink_eDWo7","loader":"NetworkErrorDialog_loader_PBB13","actions":"NetworkErrorDialog_actions_YqPxa"});
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/NetworkErrorDialog.vue?vue&type=style&index=0&id=0698b4d6&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/NetworkErrorDialog.vue



;




function NetworkErrorDialog_injectStyles (context) {
  
  this["$style"] = (NetworkErrorDialogvue_type_style_index_0_id_0698b4d6_prod_module_true_lang_scss.locals || NetworkErrorDialogvue_type_style_index_0_id_0698b4d6_prod_module_true_lang_scss)

}

/* normalize component */

var NetworkErrorDialog_component = normalizeComponent(
  RoomErrorModals_NetworkErrorDialogvue_type_script_lang_js,
  NetworkErrorDialogvue_type_template_id_0698b4d6_render,
  NetworkErrorDialogvue_type_template_id_0698b4d6_staticRenderFns,
  false,
  NetworkErrorDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var NetworkErrorDialog = (NetworkErrorDialog_component.exports);
;// CONCATENATED MODULE: ./src/examples/RoomErrorModals/index.js







;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiteMode/LitemodeSwitcher.vue?vue&type=template&id=581b3d8e
var LitemodeSwitchervue_type_template_id_581b3d8e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    class: _vm.$style.root
  }, [_c('span', [_c('GTooltip', {
    attrs: {
      "id": "litemodeSwitcherTooltip",
      "text": _vm.tooltipText,
      "text-color": "secondary-text-color",
      "textVariant": _vm.textVariant,
      "forceShowTooltip": _vm.forceShowToolTip,
      "variant": _vm.tipVariant,
      "position": _vm.tipPosition
    }
  }, [_c('LiteModeToggle', {
    staticClass: "non-mobile",
    attrs: {
      "ariaLabelledby": 'litemodeSwitcherTooltip',
      "isActive": _vm.liteModeActive,
      "isAvailable": !(_vm.liteModeNotAvailable || _vm.liteModeNotSupported || _vm.viewAsAttendee),
      "isLoading": _vm.liteModeState === 'LOADINGTOLIVEMODE' || _vm.liteModeState === 'LOADINGTOLITEMODE'
    },
    on: {
      "click": _vm.handleLiteModeToggleClick,
      "recordInterestInLiteMode": _vm.recordInterestInLiteMode
    }
  }), !(_vm.liteModeNotAvailable || _vm.liteModeNotSupported || _vm.viewAsAttendee) ? _c('div', {
    staticClass: "mobile-only",
    class: _vm.$style.mobileSwitcher
  }, [_c('GToggle', {
    attrs: {
      "icon": "wifi",
      "active": _vm.liteModeActive
    },
    on: {
      "toggle": _vm.handleLiteModeToggleClick,
      "mouseleave": _vm.recordInterestInLiteMode
    }
  }), _c('StyledText', {
    attrs: {
      "color": "theme-secondary-color",
      "variant": "body12"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Lite Mode')) + " " + _vm._s(_vm.liteModeActive ? _vm.$options.$t('On') : '') + " ")])], 1) : _vm._e()], 1)], 1), _vm.liteModeState === 'CONFRIMLITEMODESWITCH' || _vm.liteModeState === 'PROMPTLITEMODESWITCH' ? _c('ConfirmationDialog', {
    class: _vm.$style.switcherConfrmDialog,
    attrs: {
      "header": _vm.liteModeState === 'PROMPTLITEMODESWITCH' ? _vm.$options.$t('Connection Issues? Turn on Lite Mode') : _vm.$options.$t('Turn On Lite Mode'),
      "cancelBtnText": _vm.$options.$t('Cancel'),
      "bodyText": _vm.$options.$t('Lite mode will result in a 30 second delay between the live broadcast and what you’ll see on your screen. Would you like to continue?'),
      "confirmationBtnText": _vm.$options.$t('Turn On'),
      "dontShowFurtherPrompts": _vm.hideFurtherLiteModePrompts
    },
    on: {
      "toggleHideFurtherPrompts": function ($event) {
        _vm.hideFurtherLiteModePrompts = !_vm.hideFurtherLiteModePrompts;
      },
      "confirm": function ($event) {
        return _vm.$emit('switchtolitemode', {
          disable_future_prompts: _vm.hideFurtherLiteModePrompts
        });
      },
      "dismiss": function ($event) {
        return _vm.$emit('closelitemodeprompts', {
          disable_future_prompts: _vm.hideFurtherLiteModePrompts
        });
      }
    }
  }) : _vm._e(), _vm.liteModeState === 'LITEMODESWITCHSUCCESS' ? _c('NotificationDialog', {
    class: _vm.$style.switcherNotificationDialog,
    attrs: {
      "header": _vm.$options.$t('Lite Mode Active!'),
      "bodyText": _vm.$options.$t('Thanks for your patience, lite mode now on!')
    }
  }) : _vm._e(), _vm.liteModeState === 'LOADINGTOLIVEMODE' && !_vm.liteModeNotAvailable ? _c('NotificationDialog', {
    class: _vm.$style.switcherNotificationDialog,
    attrs: {
      "header": _vm.$options.$t('Turn off Lite Mode?'),
      "bodyText": _vm.$options.$t('Turning off lite mode to return to the watching the live broadcast. Heads up, this will cause a 30s gap as we catch up.')
    }
  }) : _vm._e(), _vm.liteModeState === 'LIVEMODESWITCHSUCCESS' ? _c('NotificationDialog', {
    class: _vm.$style.switcherNotificationDialog,
    attrs: {
      "header": _vm.$options.$t('Lite Mode Off!'),
      "bodyText": _vm.$options.$t('Thanks for your patience, we’ve returned to the live broadcast!')
    }
  }) : _vm._e(), _vm.liteModeNotAvailable && _vm.liteModeActive && _vm.liteModeState === 'LOADED' ? _c('NotificationDialog', {
    class: _vm.$style.switcherNotificationDialog,
    attrs: {
      "header": _vm.$options.$t('Lite Mode Unavailable'),
      "bodyText": _vm.$options.$t('Sorry about the inconvience Lite mode is unavailable right now, please switch to Live Broadcast to resume your session.'),
      "leftAligned": true
    }
  }) : _vm._e(), _vm.liteModeState === 'PROMPTLIVEMODESWITCH' ? _c('ConfirmationDialog', {
    class: _vm.$style.switcherConfrmDialog,
    attrs: {
      "header": _vm.$options.$t('Turn off Lite mode?'),
      "bodyText": _vm.$options.$t('We’ve detected that your connection has returned to normal. Would you like to switch back to the live broadcast? Heads up, this will cause a 30s gap as we catch up.'),
      "confirmationBtnText": _vm.$options.$t('Turn Off'),
      "dontShowFurtherPrompts": _vm.hideFurtherLiteModePrompts,
      "cancelBtnText": _vm.$t('Cancel')
    },
    on: {
      "toggleHideFurtherPrompts": function ($event) {
        _vm.hideFurtherLiteModePrompts = !_vm.hideFurtherLiteModePrompts;
      },
      "confirm": function ($event) {
        return _vm.$emit('switchtolivemode', {
          disable_future_prompts: _vm.hideFurtherLiteModePrompts
        });
      },
      "dismiss": function ($event) {
        return _vm.$emit('closelitemodeprompts', {
          disable_future_prompts: _vm.hideFurtherLiteModePrompts
        });
      }
    }
  }) : _vm._e()], 1);
};
var LitemodeSwitchervue_type_template_id_581b3d8e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiteMode/LitemodeSwitcher.vue?vue&type=script&lang=js
/* harmony default export */ var LitemodeSwitchervue_type_script_lang_js = ({
  name: 'LitemodeSwitcher',
  props: {
    liteModeState: {
      type: String,
      default: 'LOADED'
    },
    liteModeActive: {
      type: Boolean,
      default: false
    },
    liteModeNotAvailable: {
      type: Boolean,
      default: false
    },
    liteModeNotSupported: {
      type: Boolean,
      default: false
    },
    externalMessage: {
      type: String,
      default: ''
    },
    viewAsAttendee: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hideFurtherLiteModePrompts: false,
      forceShowToolTip: false,
      forceShowTooltipTimeout: null
    };
  },
  watch: {
    liteModeNotAvailable: {
      immediate: true,
      handler: function () {
        this.setForceShowTooltip();
      }
    },
    liteModeActive: {
      immediate: true,
      handler: function () {
        this.setForceShowTooltip();
      }
    },
    liteModeState: {
      immediate: true,
      handler: function () {
        this.setForceShowTooltip();
      }
    },
    externalMessage: {
      immediate: true,
      handler: function () {
        this.setForceShowTooltip();
      }
    }
  },
  computed: {
    textVariant() {
      const isMobile = window.mobileCheck && window.mobileCheck();
      if (isMobile && this.externalMessage) {
        return 'heading15';
      }
      if (!isMobile && this.externalMessage) {
        return 'heading26';
      }
      return 'body13';
    },
    tipVariant() {
      const isMobile = window.mobileCheck && window.mobileCheck();
      if (isMobile && this.externalMessage) {
        return 'secondary';
      }
      if (!isMobile && this.externalMessage) {
        return 'secondarywide';
      }
      return 'secondary';
    },
    tipPosition() {
      return this.externalMessage ? 'top-right' : 'top-center';
    },
    tooltipText() {
      if (this.externalMessage) {
        return this.externalMessage;
      }
      if (this.viewAsAttendee) {
        return this.$t('Lite mode is disabled for organizer accounts, but active for attendee accounts');
      }
      if (this.liteModeNotSupported) {
        return this.$t('Lite mode is not supported on your browser. We recommend using the latest version of Google Chrome');
      }
      if (this.liteModeState === 'LOADED' && this.liteModeNotAvailable && !this.liteModeActive) {
        return this.$t('Lite mode is not curently available. We’ll let you know once it’s available again');
      }
      if (this.liteModeState === 'LOADED' && this.liteModeNotAvailable && this.liteModeActive) {
        return this.$t('Turn off Lite Mode');
      }
      if (this.liteModeState === 'INFORMWHENAVAILABLEPROMPT' && !this.liteModeActive) {
        return this.$t('We’ll let you know when Lite mode is available again');
      }
      if (this.liteModeState === 'AVAILABLEAGAINPROMPT' && !this.liteModeActive) {
        return this.$t('Lite Mode Available');
      }
      return this.liteModeActive ? this.$t('Turn off Lite Mode') : this.$t('Connection Issues? Turn on Lite Mode');
    }
  },
  methods: {
    setForceShowTooltip() {
      if (this.externalMessage) {
        this.forceShowToolTip = true;
      } else {
        try {
          if (this.forceShowTooltipTimeout) {
            clearTimeout(this.forceShowTooltipTimeout);
          }
          this.forceShowToolTip = false;
          this.forceShowTooltipTimeout = setTimeout(() => {
            this.forceShowToolTip = this.liteModeNotAvailable && this.liteModeActive && this.liteModeState === 'LOADED' || this.liteModeState === 'INFORMWHENAVAILABLEPROMPT' && !this.liteModeActive || this.liteModeState === 'AVAILABLEAGAINPROMPT' && !this.liteModeActive;
            this.forceShowTooltipTimeout = null;
          }, 400);
        } catch (err) {
          console.error('Error while force showing litemode tooltip!', err);
          this.forceShowToolTip = false;
          this.forceShowTooltipTimeout = null;
        }
      }
      if (this.forceShowToolTip) {
        this.$options.$trackEvent('lite_mode_force_show_tooltip');
      }
    },
    handleLiteModeToggleClick() {
      if (!this.liteModeActive) {
        this.$emit('litemodeswitchclicked');
      } else {
        this.$emit('switchtolivemode');
      }
    },
    recordInterestInLiteMode() {
      // TODO: Fix naming here
      this.$emit('recordinterestinlitemode');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/LiteMode/LitemodeSwitcher.vue?vue&type=script&lang=js
 /* harmony default export */ var LiteMode_LitemodeSwitchervue_type_script_lang_js = (LitemodeSwitchervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/LiteMode/LitemodeSwitcher.vue?vue&type=style&index=0&id=581b3d8e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var LitemodeSwitchervue_type_style_index_0_id_581b3d8e_prod_module_true_lang_scss = ({"root":"LitemodeSwitcher_root_Er6eh","switcherConfrmDialog":"LitemodeSwitcher_switcherConfrmDialog_zEpws","mobileSwitcher":"LitemodeSwitcher_mobileSwitcher_y6Uqq","nonMobile":"LitemodeSwitcher_nonMobile_u8Mw0","switcherNotificationDialog":"LitemodeSwitcher_switcherNotificationDialog_bfWBS"});
;// CONCATENATED MODULE: ./src/components/LiteMode/LitemodeSwitcher.vue?vue&type=style&index=0&id=581b3d8e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/LiteMode/LitemodeSwitcher.vue



;




function LitemodeSwitcher_injectStyles (context) {
  
  this["$style"] = (LitemodeSwitchervue_type_style_index_0_id_581b3d8e_prod_module_true_lang_scss.locals || LitemodeSwitchervue_type_style_index_0_id_581b3d8e_prod_module_true_lang_scss)

}

/* normalize component */

var LitemodeSwitcher_component = normalizeComponent(
  LiteMode_LitemodeSwitchervue_type_script_lang_js,
  LitemodeSwitchervue_type_template_id_581b3d8e_render,
  LitemodeSwitchervue_type_template_id_581b3d8e_staticRenderFns,
  false,
  LitemodeSwitcher_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LitemodeSwitcher = (LitemodeSwitcher_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiteMode/ConfirmationDialog.vue?vue&type=template&id=772117da
var ConfirmationDialogvue_type_template_id_772117da_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, {
      [_vm.$style.noFixedPosition]: _vm.noFixedPositioning
    }],
    attrs: {
      "role": "alertdialog",
      "data-testmarker": "confirmationdialog"
    }
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('SvgIcon', {
    class: _vm.$style.icon,
    attrs: {
      "size": "small",
      "name": _vm.headerIcon,
      "color": "secondary-text-color"
    }
  }), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "body15",
      "color": "theme-secondary-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.header) + " ")])], 1), _c('StyledText', {
    class: _vm.$style.text,
    attrs: {
      "variant": "body15",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.bodyText) + " ")]), _vm.noteText ? _c('StyledText', {
    class: _vm.$style.noteText,
    attrs: {
      "variant": "subHeading15",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.noteText) + " ")]) : _vm._e(), _vm.showDontAskAgain ? _c('GCheckbox', {
    attrs: {
      "label": _vm.$options.$t('Don’t ask me this next time'),
      "checked": _vm.dontShowFurtherPrompts
    },
    on: {
      "toggle": function ($event) {
        return _vm.$emit('toggleHideFurtherPrompts');
      }
    }
  }) : _vm._e(), _c('div', {
    class: _vm.$style.actions
  }, [_vm.cancelBtnText ? _c('TextButton', {
    class: _vm.$style.cancel,
    attrs: {
      "color": "primary-text-color",
      "variant": "body13",
      "data-testmarker": "cancel"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('dismiss', {
          cancelCta: true
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.cancelBtnText)) + " ")]) : _vm._e(), _vm.confirmationBtnText ? _c('PillButton', {
    attrs: {
      "size": "x-small",
      "uppercase": "",
      "variant": _vm.confirmationBtnVariant,
      "data-testmarker": "confirm",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('confirm');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmationBtnText) + " ")]) : _vm._e()], 1)], 1);
};
var ConfirmationDialogvue_type_template_id_772117da_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiteMode/ConfirmationDialog.vue?vue&type=script&lang=js

/* harmony default export */ var ConfirmationDialogvue_type_script_lang_js = ({
  name: 'confirmation-dialog',
  props: {
    header: {
      type: String,
      default: ''
    },
    bodyText: {
      type: String,
      default: ''
    },
    noteText: {
      type: String,
      default: ''
    },
    confirmationBtnText: {
      type: String,
      default: ''
    },
    confirmationBtnVariant: {
      type: String,
      default: 'secondary'
    },
    cancelBtnText: {
      type: String,
      default: 'Cancel'
    },
    dontShowFurtherPrompts: {
      type: Boolean,
      default: false
    },
    showDontAskAgain: {
      type: Boolean,
      default: true
    },
    headerIcon: {
      type: String,
      default: 'notification'
    },
    noFixedPositioning: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      focusTrap({
        getAllFocusableElementOf: this.$el,
        focusFirstElementOnMount: true,
        executeOnEscape: () => this.$emit('cancel')
      });
    });
  }
});
;// CONCATENATED MODULE: ./src/components/LiteMode/ConfirmationDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var LiteMode_ConfirmationDialogvue_type_script_lang_js = (ConfirmationDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/LiteMode/ConfirmationDialog.vue?vue&type=style&index=0&id=772117da&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ConfirmationDialogvue_type_style_index_0_id_772117da_prod_module_true_lang_scss = ({"root":"ConfirmationDialog_root_qehre","noFixedPosition":"ConfirmationDialog_noFixedPosition_E79u5","header":"ConfirmationDialog_header_YK921","title":"ConfirmationDialog_title_OjBPO","icon":"ConfirmationDialog_icon_emBMJ","text":"ConfirmationDialog_text_mkr2f","noteText":"ConfirmationDialog_noteText_pLE1M","actions":"ConfirmationDialog_actions_RZalu","cancel":"ConfirmationDialog_cancel_jQuC4"});
;// CONCATENATED MODULE: ./src/components/LiteMode/ConfirmationDialog.vue?vue&type=style&index=0&id=772117da&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/LiteMode/ConfirmationDialog.vue



;




function ConfirmationDialog_injectStyles (context) {
  
  this["$style"] = (ConfirmationDialogvue_type_style_index_0_id_772117da_prod_module_true_lang_scss.locals || ConfirmationDialogvue_type_style_index_0_id_772117da_prod_module_true_lang_scss)

}

/* normalize component */

var ConfirmationDialog_component = normalizeComponent(
  LiteMode_ConfirmationDialogvue_type_script_lang_js,
  ConfirmationDialogvue_type_template_id_772117da_render,
  ConfirmationDialogvue_type_template_id_772117da_staticRenderFns,
  false,
  ConfirmationDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ConfirmationDialog = (ConfirmationDialog_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiteMode/NotificationDialog.vue?vue&type=template&id=11b1ec0c&functional=true
var NotificationDialogvue_type_template_id_11b1ec0c_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: [_vm.$style.root, _vm.props.leftAligned && _vm.$style.leftAligned]
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('SvgIcon', {
    class: _vm.$style.icon,
    attrs: {
      "size": "small",
      "name": "notification",
      "color": "secondary-text-color"
    }
  }), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "body15",
      "color": "theme-secondary-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.header) + " ")])], 1), _c('StyledText', {
    class: _vm.$style.text,
    attrs: {
      "variant": "body15",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.bodyText) + " ")])], 1);
};
var NotificationDialogvue_type_template_id_11b1ec0c_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/LiteMode/NotificationDialog.vue?vue&type=script&lang=js
/* harmony default export */ var NotificationDialogvue_type_script_lang_js = ({
  name: 'notification-dialog',
  functional: true,
  props: {
    header: {
      type: String,
      default: ''
    },
    bodyText: {
      type: String,
      default: ''
    },
    leftAligned: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/LiteMode/NotificationDialog.vue?vue&type=script&lang=js
 /* harmony default export */ var LiteMode_NotificationDialogvue_type_script_lang_js = (NotificationDialogvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/LiteMode/NotificationDialog.vue?vue&type=style&index=0&id=11b1ec0c&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var NotificationDialogvue_type_style_index_0_id_11b1ec0c_prod_module_true_lang_scss = ({"root":"NotificationDialog_root_W27l6","header":"NotificationDialog_header_Zatis","title":"NotificationDialog_title_yxhDE","icon":"NotificationDialog_icon_uA8my","text":"NotificationDialog_text_SxbJg","actions":"NotificationDialog_actions_EWfTm","cancel":"NotificationDialog_cancel_zIFgF","button":"NotificationDialog_button_VJWzR","leftAligned":"NotificationDialog_leftAligned_r4fXa"});
;// CONCATENATED MODULE: ./src/components/LiteMode/NotificationDialog.vue?vue&type=style&index=0&id=11b1ec0c&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/LiteMode/NotificationDialog.vue



;




function NotificationDialog_injectStyles (context) {
  
  this["$style"] = (NotificationDialogvue_type_style_index_0_id_11b1ec0c_prod_module_true_lang_scss.locals || NotificationDialogvue_type_style_index_0_id_11b1ec0c_prod_module_true_lang_scss)

}

/* normalize component */

var NotificationDialog_component = normalizeComponent(
  LiteMode_NotificationDialogvue_type_script_lang_js,
  NotificationDialogvue_type_template_id_11b1ec0c_functional_true_render,
  NotificationDialogvue_type_template_id_11b1ec0c_functional_true_staticRenderFns,
  true,
  NotificationDialog_injectStyles,
  null,
  null
  
)

/* harmony default export */ var NotificationDialog = (NotificationDialog_component.exports);
;// CONCATENATED MODULE: ./src/components/LiteMode/index.js



;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/VpnAdblocker.vue?vue&type=template&id=0e178b38&functional=true
var VpnAdblockervue_type_template_id_0e178b38_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: _vm.$style.body
  }, [_vm._v(" " + _vm._s(_vm.props.msg) + " ")]), _vm.props.detected ? _c('StyledText', {
    class: _vm.$style.message
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('VPN and adblockers may cause video issues, please disable them before proceeding')) + ".. ")]) : _c('StyledText', {
    class: _vm.$style.message
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('As a note, VPN and adblockers may cause video issues so make sure you keep them disabled during the broadcast')) + " ")])], 1);
};
var VpnAdblockervue_type_template_id_0e178b38_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/VpnAdblocker.vue?vue&type=script&lang=js
/* harmony default export */ var VpnAdblockervue_type_script_lang_js = ({
  name: 'VpnAdblocker',
  props: {
    msg: {
      type: String,
      default: ''
    },
    detected: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TechCheck/VpnAdblocker.vue?vue&type=script&lang=js
 /* harmony default export */ var TechCheck_VpnAdblockervue_type_script_lang_js = (VpnAdblockervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TechCheck/VpnAdblocker.vue?vue&type=style&index=0&id=0e178b38&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var VpnAdblockervue_type_style_index_0_id_0e178b38_prod_module_true_lang_scss = ({"root":"VpnAdblocker_root_VHtoU","body":"VpnAdblocker_body_rznB5","message":"VpnAdblocker_message_C6s5n","link":"VpnAdblocker_link_ohytP"});
;// CONCATENATED MODULE: ./src/components/TechCheck/VpnAdblocker.vue?vue&type=style&index=0&id=0e178b38&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/TechCheck/VpnAdblocker.vue



;




function VpnAdblocker_injectStyles (context) {
  
  this["$style"] = (VpnAdblockervue_type_style_index_0_id_0e178b38_prod_module_true_lang_scss.locals || VpnAdblockervue_type_style_index_0_id_0e178b38_prod_module_true_lang_scss)

}

/* normalize component */

var VpnAdblocker_component = normalizeComponent(
  TechCheck_VpnAdblockervue_type_script_lang_js,
  VpnAdblockervue_type_template_id_0e178b38_functional_true_render,
  VpnAdblockervue_type_template_id_0e178b38_functional_true_staticRenderFns,
  true,
  VpnAdblocker_injectStyles,
  null,
  null
  
)

/* harmony default export */ var VpnAdblocker = (VpnAdblocker_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/TechSetup.vue?vue&type=template&id=710b215e
var TechSetupvue_type_template_id_710b215e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.showVideoControls ? _c('VideoSettings', {
    attrs: {
      "showIcon": false,
      "cameras": _vm.cameras,
      "selectedCamera": _vm.selectedCamera,
      "active": _vm.active.camera,
      "permission": _vm.permissions.camera,
      "error": _vm.errors.camera,
      "mirror": _vm.mirror,
      "showVideoMirrorOption": _vm.showVideoMirrorOption
    },
    on: {
      "toggleMirror": function ($event) {
        return _vm.$emit('toggleMirror');
      },
      "selectCamera": function ($event) {
        return _vm.$emit('selectDevice', 'camera', $event);
      }
    }
  }) : _vm._e(), _vm.showAudioSettings ? _c('AudioSettings', {
    ref: "audioSettings",
    attrs: {
      "showIcon": false,
      "showAudioTestButton": _vm.showAudioTestButton,
      "microphones": _vm.microphones,
      "speakers": _vm.speaker,
      "selectedMicrophone": _vm.selectedMicrophone,
      "selectedSpeaker": _vm.selectedSpeaker,
      "showSpeakerSettings": _vm.showSpeakerSettings,
      "errors": _vm.errors,
      "permissions": _vm.permissions,
      "active": _vm.active
    },
    on: {
      "selectMic": function ($event) {
        return _vm.$emit('selectDevice', 'microphone', $event);
      },
      "selectSpeaker": function ($event) {
        return _vm.$emit('selectDevice', 'speaker', $event);
      }
    }
  }) : _vm._e(), _vm.showVirtualBackgrounds ? _c('VirtualBackgroundSettings', {
    attrs: {
      "virtualBackgrounds": _vm.virtualBackgrounds,
      "selectedVirtualBackground": _vm.selectedVirtualBackground
    },
    on: {
      "setVirtualBackground": function ($event) {
        return _vm.$emit('setVirtualBackground', $event);
      }
    }
  }) : _vm._e(), _vm.customHelpdocLinkMeta.show ? _c('div', {
    class: _vm.$style.customHelpdocLinkContainer
  }, [_c('StyledText', {
    attrs: {
      "underline": ""
    },
    on: {
      "click": function ($event) {
        return _vm.openLink(_vm.customHelpdocLinkMeta.link);
      }
    }
  }, [_vm._v(_vm._s(_vm.customHelpdocLinkMeta.text))])], 1) : _vm._e(), _vm.showHelpdocLink ? _c('div', {
    class: _vm.$style.helpdocLinkContainer
  }, [_c('HelpdocLink', {
    attrs: {
      "link": _vm.helpdocLink
    }
  })], 1) : _vm._e()], 1);
};
var TechSetupvue_type_template_id_710b215e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/HelpdocLink.vue?vue&type=template&id=579aae05&functional=true
var HelpdocLinkvue_type_template_id_579aae05_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('If you’re having issues, please refer to the')) + " ")]), _c('a', {
    attrs: {
      "href": _vm.props.link,
      "target": "_blank"
    }
  }, [_c('StyledText', {
    attrs: {
      "align": "center",
      "color": "theme-secondary-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('help docs')) + " "), _c('div', {
    class: _vm.$style.linkIconContainer
  }, [_c('SvgIcon', {
    attrs: {
      "name": "link",
      "color": "theme-secondary-color",
      "size": "small"
    }
  })], 1)])], 1)], 1);
};
var HelpdocLinkvue_type_template_id_579aae05_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/HelpdocLink.vue?vue&type=script&lang=js

/* harmony default export */ var HelpdocLinkvue_type_script_lang_js = ({
  name: 'HelpdocLink',
  props: {
    link: {
      type: String,
      default: helpDocLinks.ROOT_HELP_DOC_LINK
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TechCheck/HelpdocLink.vue?vue&type=script&lang=js
 /* harmony default export */ var TechCheck_HelpdocLinkvue_type_script_lang_js = (HelpdocLinkvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TechCheck/HelpdocLink.vue?vue&type=style&index=0&id=579aae05&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var HelpdocLinkvue_type_style_index_0_id_579aae05_prod_module_true_lang_scss = ({"root":"HelpdocLink_root_iPvRD","linkIconContainer":"HelpdocLink_linkIconContainer_V_Clt"});
;// CONCATENATED MODULE: ./src/components/TechCheck/HelpdocLink.vue?vue&type=style&index=0&id=579aae05&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/TechCheck/HelpdocLink.vue



;




function HelpdocLink_injectStyles (context) {
  
  this["$style"] = (HelpdocLinkvue_type_style_index_0_id_579aae05_prod_module_true_lang_scss.locals || HelpdocLinkvue_type_style_index_0_id_579aae05_prod_module_true_lang_scss)

}

/* normalize component */

var HelpdocLink_component = normalizeComponent(
  TechCheck_HelpdocLinkvue_type_script_lang_js,
  HelpdocLinkvue_type_template_id_579aae05_functional_true_render,
  HelpdocLinkvue_type_template_id_579aae05_functional_true_staticRenderFns,
  true,
  HelpdocLink_injectStyles,
  null,
  null
  
)

/* harmony default export */ var HelpdocLink = (HelpdocLink_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/TechSetup.vue?vue&type=script&lang=js





/* harmony default export */ var TechSetupvue_type_script_lang_js = ({
  components: {
    HelpdocLink: HelpdocLink,
    VirtualBackgroundSettings: VirtualBackgroundSettings,
    AudioSettings: AudioSettings,
    VideoSettings: VideoSettings
  },
  name: 'TechSetup',
  props: {
    active: Object,
    errors: Object,
    permissions: Object,
    cameras: Array,
    microphones: Array,
    speaker: Array,
    selectedCamera: Object,
    selectedMicrophone: Object,
    selectedSpeaker: Object,
    showSpeakerSettings: {
      type: Boolean,
      default: true
    },
    customHelpdocLinkMeta: {
      type: Object,
      default: () => ({
        show: false,
        link: '',
        text: ''
      })
    },
    showVideoMirrorOption: {
      type: Boolean,
      default: true
    },
    showAudioTestButton: {
      type: Boolean,
      default: true
    },
    showVideoControls: {
      type: Boolean,
      default: true
    },
    showAudioSettings: {
      type: Boolean,
      default: true
    },
    showVirtualBackgrounds: {
      type: Boolean,
      default: true
    },
    showHelpdocLink: {
      type: Boolean,
      default: false
    },
    hideSpeaker: Boolean,
    virtualBackgrounds: {
      type: Array,
      default: () => []
    },
    selectedVirtualBackground: String,
    mirror: Boolean
  },
  data() {
    return {
      helpdocLink: helpDocLinks.CAMERA_MIC_SETUP
    };
  },
  methods: {
    openLink(url) {
      window.open(url, '_blank');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TechCheck/TechSetup.vue?vue&type=script&lang=js
 /* harmony default export */ var TechCheck_TechSetupvue_type_script_lang_js = (TechSetupvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TechCheck/TechSetup.vue?vue&type=style&index=0&id=710b215e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var TechSetupvue_type_style_index_0_id_710b215e_prod_module_true_lang_scss = ({"root":"TechSetup_root_Ulu79","helpdocLinkContainer":"TechSetup_helpdocLinkContainer_qSzKW","customHelpdocLinkContainer":"TechSetup_customHelpdocLinkContainer_ZFxWk"});
;// CONCATENATED MODULE: ./src/components/TechCheck/TechSetup.vue?vue&type=style&index=0&id=710b215e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/TechCheck/TechSetup.vue



;




function TechSetup_injectStyles (context) {
  
  this["$style"] = (TechSetupvue_type_style_index_0_id_710b215e_prod_module_true_lang_scss.locals || TechSetupvue_type_style_index_0_id_710b215e_prod_module_true_lang_scss)

}

/* normalize component */

var TechSetup_component = normalizeComponent(
  TechCheck_TechSetupvue_type_script_lang_js,
  TechSetupvue_type_template_id_710b215e_render,
  TechSetupvue_type_template_id_710b215e_staticRenderFns,
  false,
  TechSetup_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TechSetup = (TechSetup_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/TechCheck.vue?vue&type=template&id=1221a3bc
var TechCheckvue_type_template_id_1221a3bc_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.description
  }, [_c('h1', {
    ref: "heading",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('StyledText', {
    class: _vm.$style.heading,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading26"
    }
  }, [_vm._v(" " + _vm._s(_vm.metaUIConfig.techCheckHeading) + " ")])], 1), _vm.metaUIConfig.techCheckSubHeading ? _c('StyledText', {
    class: _vm.$style.desc,
    attrs: {
      "color": "primary-text-color",
      "variant": "body18"
    }
  }, [_vm._v(" " + _vm._s(_vm.metaUIConfig.techCheckSubHeading) + " ")]) : _vm._e()], 1), _vm.metaUIConfig.allowSkipping ? _c('div', {
    class: _vm.$style.headerAction
  }, [_vm.metaUIConfig.isStreamsLoading ? _c('Loading', {
    attrs: {
      "size": "verySmall",
      "theme": "secondary-theme"
    }
  }) : _c('button', {
    on: {
      "click": function ($event) {
        return _vm.$emit('skipOrContinue');
      }
    }
  }, [_c('StyledText', {
    attrs: {
      "variant": "subHeading14"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Skip Checks and Continue')))])], 1)], 1) : _vm._e(), _c('div', {
    class: _vm.$style.row
  }, [!_vm.metaUIConfig.minifiedTechCheck ? _c('div', {
    class: _vm.$style.deviceSetupPreview
  }, [_vm.metaUIConfig.showVideoControls ? _c('div', {
    class: _vm.$style.player
  }, [_vm.videoTrack ? _c('AgoraV4Player', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.active.camera,
      expression: "active.camera"
    }],
    attrs: {
      "isLocal": true,
      "videoTrack": _vm.videoTrack,
      "audioTrack": _vm.audioTrack,
      "user": _vm.user,
      "muted": false,
      "loading": _vm.loading
    }
  }) : _vm._e(), !_vm.videoTrack || _vm.errors.camera ? _c('div', {
    class: [_vm.$style.nocam, _vm.$style.errored]
  }, [_c('SvgIcon', {
    attrs: {
      "color": "warning",
      "name": "videocam-muted",
      "size": "large"
    }
  })], 1) : !_vm.active.camera ? _c('div', {
    class: _vm.$style.nocam
  }, [_c('UserImage', {
    attrs: {
      "user": _vm.user,
      "image-scale": "small"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _c('div', {
    class: _vm.$style.setup
  }, [_c('TechSetup', _vm._b({
    ref: "techsetup",
    attrs: {
      "cameras": _vm.devices.cameras,
      "selectedCamera": _vm.selectedDevices.camera,
      "microphones": _vm.devices.microphones,
      "selectedMicrophone": _vm.selectedDevices.microphone,
      "speaker": _vm.devices.speakers,
      "selectedSpeaker": _vm.selectedDevices.speaker,
      "active": _vm.active,
      "errors": _vm.errors,
      "permissions": _vm.permissions,
      "virtualBackgrounds": _vm.virtualBackgrounds,
      "selectedVirtualBackground": _vm.selectedVirtualBackground,
      "showIcons": false,
      "mirror": _vm.mirror
    },
    on: {
      "toggleMirror": function ($event) {
        return _vm.$emit('toggleMirror');
      },
      "setVirtualBackground": bg => _vm.$emit('setVirtualBackground', bg),
      "toggleVideo": function ($event) {
        return _vm.$emit('toggle-device', 'video');
      },
      "toggleMic": function ($event) {
        return _vm.$emit('toggle-device', 'audio');
      },
      "toggleSpeaker": function ($event) {
        return _vm.$emit('toggle-device', 'speaker');
      },
      "selectDevice": (d, e) => _vm.$emit('select-device', d, e)
    }
  }, 'TechSetup', _vm.metaUIConfig, false))], 1)]) : _vm._e(), _c('div', {
    class: _vm.$style.checkListWrapper
  }, [_c('TechCheckResults', _vm._b({
    attrs: {
      "speakerTestCardConfig": _vm.speakerTestCardConfig,
      "speakers": _vm.devices.speakers,
      "selectedSpeaker": _vm.selectedDevices.speaker,
      "loadingConfig": _vm.loadingConfig,
      "techCheckHeadingMetaData": _vm.techCheckHeadingMetaData,
      "screenStream": _vm.screenStream,
      "blockingErrorsConfig": _vm.blockingErrorsConfig,
      "checkResults": _vm.techCheckResults
    },
    on: {
      "isSoundAudible": data => _vm.$emit('isSoundAudible', data),
      "continue": function ($event) {
        return _vm.$emit('continue');
      },
      "toggleScreen": function ($event) {
        return _vm.$emit('toggleScreen');
      },
      "selectDevice": (d, e) => _vm.$emit('select-device', d, e)
    }
  }, 'TechCheckResults', _vm.metaUIConfig, false))], 1)])]);
};
var TechCheckvue_type_template_id_1221a3bc_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/TechCheckResults.vue?vue&type=template&id=5a5ca891
var TechCheckResultsvue_type_template_id_5a5ca891_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.loadingConfig.isLoading ? _c('div', {
    class: _vm.$style.checkStatus
  }, [_c('Loading', {
    attrs: {
      "size": "verySmall",
      "theme": "secondary-theme"
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "subHeading12",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.loadingConfig.text) + " ")])], 1) : [_c('div', {
    class: _vm.$style.checkList
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading16"
    }
  }, [_vm._v(_vm._s(_vm.$options.$t('System Check')))]), _vm.techCheckHeadingMetaData.showHeader ? _c('div', {
    class: [_vm.$style.checkListHeading, _vm.techCheckHeadingMetaData.isFail && _vm.$style.fail, _vm.techCheckHeadingMetaData.isSuccess && _vm.$style.success]
  }, [_c('span', {
    class: _vm.$style.heading
  }, [_vm.techCheckHeadingMetaData.iconName === 'empty' ? _c('span') : _vm.techCheckHeadingMetaData.showSvg ? _c('SvgIcon', {
    attrs: {
      "size": "medium",
      "name": _vm.techCheckHeadingMetaData.iconName,
      "color": _vm.techCheckHeadingMetaData.color
    }
  }) : _c('IconButton', {
    attrs: {
      "tabIndex": -1,
      "ariaHidden": true,
      "icon": _vm.techCheckHeadingMetaData.iconName,
      "variant": _vm.techCheckHeadingMetaData.color,
      "size": "x-small"
    }
  }), _c('StyledText', {
    attrs: {
      "variant": "heading13"
    }
  }, [_vm._v(_vm._s(_vm.$options.$t(_vm.techCheckHeadingMetaData.heading)))])], 1)]) : _vm._e()], 1), _vm.checkResults.length ? _c('div', {
    class: _vm.$style.checkListTiles
  }, _vm._l(_vm.checkResults, function (item) {
    return _c('TechCheckCard', _vm._b({
      key: item.heading
    }, 'TechCheckCard', item, false));
  }), 1) : _vm._e(), _c('div', {
    class: _vm.$style.techCheckContainer,
    attrs: {
      "aria-live": "polite"
    }
  }, [_c('TechCheckCard', _vm._b({}, 'TechCheckCard', _vm.speakerTestCardConfig, false), [_vm.speakerTestCardConfig.otherInfo && _vm.speakerTestCardConfig.otherInfo.showTestCard ? _c('SpeakerTestCard', {
    attrs: {
      "selectedSpeaker": _vm.selectedSpeaker,
      "speakers": _vm.speakers
    },
    on: {
      "isSoundAudible": data => _vm.$emit('isSoundAudible', data),
      "selectSpeaker": function ($event) {
        return _vm.$emit('selectDevice', 'speaker', $event);
      }
    }
  }) : _vm._e()], 1)], 1), _vm.showScreenTestCard ? _c('ScreenShareTest', {
    attrs: {
      "screenStream": _vm.screenStream
    },
    on: {
      "toggleScreen": function ($event) {
        return _vm.$emit('toggleScreen');
      }
    }
  }) : _vm._e(), _vm.blockingErrorsConfig.show ? _c('div', {
    class: _vm.$style.checkListFooter
  }, [_c('div', {
    class: _vm.$style.divider
  }), _c('PillButton', {
    class: [_vm.$style.actionButton, _vm.blockingErrorsConfig.isButtonDisabled && _vm.$style.disabledButton],
    attrs: {
      "disabled": _vm.blockingErrorsConfig.isButtonDisabled,
      "variant": _vm.blockingErrorsConfig.color,
      "center": "",
      "uppercase": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('continue');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t(_vm.blockingErrorsConfig.text)))])], 1) : _vm._e()]], 2);
};
var TechCheckResultsvue_type_template_id_5a5ca891_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/SpeakerTestCard.vue?vue&type=template&id=5ceb8bd6
var SpeakerTestCardvue_type_template_id_5ceb8bd6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.speakers.length ? _c('AccessibleSelect', {
    class: _vm.$style.dropdown,
    attrs: {
      "id": "speakerSelect",
      "valueKey": "deviceId",
      "transparentOptionBackground": true,
      "fullWidth": true,
      "showShadows": true,
      "value": _vm.selectedSpeaker,
      "options": _vm.speakers
    },
    on: {
      "input": $event => _vm.$emit('selectSpeaker', $event)
    }
  }) : _vm._e(), _c('div', {
    class: _vm.$style.mainCTA
  }, [_c('PillButton', {
    class: [_vm.$style.action, _vm.isAudioPlaying && _vm.$style.playButton],
    attrs: {
      "uppercase": false,
      "loading": _vm.isAudioLoading,
      "disabled": _vm.isAudioLoading,
      "role": "switch",
      "aria-checked": _vm.isAudioPlaying ? 'true' : 'false',
      "variant": "secondary",
      "size": "small",
      "center": ""
    },
    on: {
      "click": _vm.toggleAudioPlay
    }
  }, [_c('SvgIcon', {
    class: _vm.$style.icon,
    attrs: {
      "name": _vm.isAudioPlaying ? 'faunmute' : 'volume',
      "color": _vm.isAudioPlaying ? 'theme-secondary-color' : 'secondary-text-color'
    }
  }), _vm._v(" " + _vm._s(_vm.isAudioPlaying ? _vm.$options.$t('Stop Test') : _vm.$options.$t('Test your system’s speaker')) + " ")], 1)], 1), _c('div', {
    class: _vm.$style.audioData
  }, [_c('ProgressLevel', {
    ref: "audioIndicator",
    class: _vm.$style.audioLevel,
    attrs: {
      "bars": 20
    }
  }), _c('StyledText', {
    class: _vm.$style.issue,
    attrs: {
      "id": "audioTest",
      "variant": "body14"
    }
  }, [_vm._v(_vm._s(_vm.isAudioPlaying ? _vm.$options.$t('Click "Yes" if you hear the sound.') : _vm.$options.$t('Click the button above to run the test')))]), _c('div', {
    class: _vm.$style.audioActionBar
  }, [_c('PillButton', {
    class: _vm.$style.leftButton,
    attrs: {
      "aria-describedby": "audioTest",
      "variant": "theme-primary-color",
      "size": "small",
      "center": "",
      "disabled": !_vm.isAudioPlaying,
      "uppercase": false
    },
    on: {
      "click": function ($event) {
        return _vm.isSoundAudible(false);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('No')) + " ")]), _c('PillButton', {
    class: _vm.$style.rightButton,
    attrs: {
      "aria-describedby": "audioTest",
      "variant": "secondary",
      "size": "small",
      "center": "",
      "disabled": !_vm.isAudioPlaying,
      "uppercase": false
    },
    on: {
      "click": function ($event) {
        return _vm.isSoundAudible(true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Yes')) + " ")])], 1)], 1), _c('audio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "audiofile",
    attrs: {
      "controls": "",
      "loop": ""
    },
    on: {
      "ended": _vm.audioFileEnded,
      "play": _vm.audioFileStarted
    }
  }, [_c('source', {
    attrs: {
      "src": "https://s3.amazonaws.com/staticassets.goldcast.com/audiotest.mp3",
      "type": "audio/mpeg"
    }
  }), _vm._v(" " + _vm._s(_vm.$options.$t('Issue Testing Audio!')) + " ")])], 1);
};
var SpeakerTestCardvue_type_template_id_5ceb8bd6_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/SpeakerTestCard.vue?vue&type=script&lang=js

/* harmony default export */ var SpeakerTestCardvue_type_script_lang_js = ({
  name: 'SpeakerTestCard',
  components: {
    AccessibleSelect: AccessibleSelect
  },
  props: {
    speakers: {
      type: Array,
      default: () => []
    },
    selectedSpeaker: {
      type: Object,
      default: () => {
        return {
          label: 'No Device Available'
        };
      }
    }
  },
  data() {
    return {
      isAudioPlaying: false,
      testPassed: null,
      isAudioLoading: false
    };
  },
  computed: {
    audioOutputDeviceId() {
      return this.selectedSpeaker?.deviceId ?? '';
    }
  },
  watch: {
    audioOutputDeviceId(newId, oldId) {
      if (newId !== oldId) {
        this.setAudioOutputDevice();
      }
    }
  },
  methods: {
    audioFileEnded() {
      this.isAudioLoading = false;
    },
    audioFileStarted() {
      this.isAudioLoading = false;
    },
    isSoundAudible(data) {
      if (this.isAudioPlaying) {
        this.toggleAudioPlay();
      }
      this.testPassed = data;
      this.$emit('isSoundAudible', data);
    },
    runFakeAudioLevel() {
      if (this.isAudioPlaying) {
        setTimeout(() => {
          this.runFakeAudioLevel();
        }, 200);
        let audioLevel = 0;
        if (!this.isAudioLoading) {
          audioLevel = 40 + Math.random() * 60;
        }
        if (this.$refs.audioIndicator?.setLevel) {
          this.$refs.audioIndicator.setLevel(audioLevel);
        }
      } else {
        if (this.$refs.audioIndicator?.setLevel) {
          this.$refs.audioIndicator.setLevel(0);
        }
      }
    },
    toggleAudioPlay() {
      this.testPassed = null;
      if (!this.isAudioPlaying) {
        this.isAudioLoading = true;
        this.setAudioOutputDevice();
        this.$refs.audiofile?.play();
      } else {
        this.$refs.audiofile?.pause();
      }
      this.isAudioPlaying = !this.isAudioPlaying;
      this.runFakeAudioLevel();
    },
    setAudioOutputDevice() {
      try {
        if (this.audioOutputDeviceId) {
          this.$refs.audiofile?.setSinkId(this.audioOutputDeviceId).then(() => {}).catch(function (error) {
            var errorMessage = error;
            if (error.name === 'SecurityError') {
              errorMessage = 'You need to use HTTPS for selecting audio output ' + 'device: ' + error;
            }
            throw errorMessage;
          });
        }
      } catch (error) {
        console.error('Error while playing audio asset :', error);
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TechCheck/SpeakerTestCard.vue?vue&type=script&lang=js
 /* harmony default export */ var TechCheck_SpeakerTestCardvue_type_script_lang_js = (SpeakerTestCardvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TechCheck/SpeakerTestCard.vue?vue&type=style&index=0&id=5ceb8bd6&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SpeakerTestCardvue_type_style_index_0_id_5ceb8bd6_prod_lang_scss_module_true = ({"root":"SpeakerTestCard_root_rQE5f","dropdown":"SpeakerTestCard_dropdown_thsKO","mainCTA":"SpeakerTestCard_mainCTA_KwDYS","playButton":"SpeakerTestCard_playButton_faepz","action":"SpeakerTestCard_action_eYS7H","icon":"SpeakerTestCard_icon_qkt_q","iconBlock":"SpeakerTestCard_iconBlock_iHS0p","audioData":"SpeakerTestCard_audioData_NdgqQ","audioLevel":"SpeakerTestCard_audioLevel_waDAQ","issue":"SpeakerTestCard_issue_K8QyJ","audioActionBar":"SpeakerTestCard_audioActionBar_EvIAM","leftButton":"SpeakerTestCard_leftButton_DIKrq","rightButton":"SpeakerTestCard_rightButton_np12I"});
;// CONCATENATED MODULE: ./src/components/TechCheck/SpeakerTestCard.vue?vue&type=style&index=0&id=5ceb8bd6&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/TechCheck/SpeakerTestCard.vue



;




function SpeakerTestCard_injectStyles (context) {
  
  this["$style"] = (SpeakerTestCardvue_type_style_index_0_id_5ceb8bd6_prod_lang_scss_module_true.locals || SpeakerTestCardvue_type_style_index_0_id_5ceb8bd6_prod_lang_scss_module_true)

}

/* normalize component */

var SpeakerTestCard_component = normalizeComponent(
  TechCheck_SpeakerTestCardvue_type_script_lang_js,
  SpeakerTestCardvue_type_template_id_5ceb8bd6_render,
  SpeakerTestCardvue_type_template_id_5ceb8bd6_staticRenderFns,
  false,
  SpeakerTestCard_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SpeakerTestCard = (SpeakerTestCard_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/TechCheckCard.vue?vue&type=template&id=40426116&functional=true
var TechCheckCardvue_type_template_id_40426116_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.props.otherInfo || {}).showCard,
      expression: "(props.otherInfo || {}).showCard"
    }],
    class: [_vm.$style.root, (_vm.props.otherInfo || {}).showBg && _vm.$style.addBg, (_vm.props.otherInfo || {}).critical && _vm.$style.critical, (_vm.props.otherInfo || {}).success && _vm.$style.success]
  }, [_vm.props.heading ? _c('StyledText', {
    class: _vm.$style.header,
    attrs: {
      "variant": "heading14"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.heading) + " ")]) : _vm._e(), _vm.props.subHeading ? _c('StyledText', {
    class: _vm.$style.subHeading,
    attrs: {
      "variant": "body12",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.subHeading) + " "), (_vm.props.otherInfo || {}).success ? _c('SvgIcon', {
    class: _vm.$style.icon,
    attrs: {
      "size": "medium",
      "name": "tick",
      "color": "color-success"
    }
  }) : _vm._e()], 1) : _vm._e(), (_vm.props.otherInfo || {}).errors && _vm.props.otherInfo.errors.length ? _c('div', {
    class: _vm.$style.errorList
  }, _vm._l(_vm.props.otherInfo.errors, function (error) {
    return _c('div', {
      key: error,
      class: _vm.$style.error
    }, [_c('SvgIcon', {
      attrs: {
        "size": "small",
        "name": "warning",
        "color": "color-highlight"
      }
    }), _c('StyledText', {
      attrs: {
        "variant": "body12"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(error)
      }
    })])], 1);
  }), 0) : _vm._e(), _vm.props.actionConfig.showAction ? _c('div', {
    class: _vm.$style.actionBar
  }, [_c('PillButton', {
    class: _vm.$style.actionButton,
    attrs: {
      "variant": _vm.props.actionConfig.color,
      "center": "",
      "uppercase": ""
    },
    on: {
      "click": _vm.props.actionConfig.action
    }
  }, [_vm._v(" " + _vm._s(_vm.props.actionConfig.text))])], 1) : _vm._e(), _vm._t("default"), _vm.props.url ? _c('div', {
    class: _vm.$style.recommendations
  }, [_c('StyledText', {
    class: _vm.$style.recommendationText,
    attrs: {
      "variant": "subHeading10"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Need help? Check out the')) + " ")]), _c('StyledText', {
    class: _vm.$style.link,
    attrs: {
      "variant": "subHeading10"
    },
    on: {
      "click": function ($event) {
        return _vm.$options.openURL(_vm.props);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('help docs')) + " "), _c('SvgIcon', {
    attrs: {
      "name": "link",
      "size": "x-small",
      "color": "theme-secondary-color"
    }
  })], 1)], 1) : _vm._e()], 2);
};
var TechCheckCardvue_type_template_id_40426116_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/TechCheckCard.vue?vue&type=script&lang=js
/* harmony default export */ var TechCheckCardvue_type_script_lang_js = ({
  functional: true,
  name: 'TechCheckCard',
  props: {
    heading: {
      type: String,
      default: ''
    },
    subHeading: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    otherInfo: {
      type: Object,
      default: () => {
        return {
          showCard: false,
          showBg: true
        };
      }
    },
    actionConfig: {
      type: Object,
      default: () => {
        return {
          text: '',
          action: () => {},
          color: 'primary',
          showAction: false
        };
      }
    }
  },
  openURL({
    url
  }) {
    window.open(url, '_blank');
  }
});
;// CONCATENATED MODULE: ./src/components/TechCheck/TechCheckCard.vue?vue&type=script&lang=js
 /* harmony default export */ var TechCheck_TechCheckCardvue_type_script_lang_js = (TechCheckCardvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TechCheck/TechCheckCard.vue?vue&type=style&index=0&id=40426116&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var TechCheckCardvue_type_style_index_0_id_40426116_prod_module_true_lang_scss = ({"root":"TechCheckCard_root_kxHWF","header":"TechCheckCard_header_Wd4go","subHeading":"TechCheckCard_subHeading_UE6u3","icon":"TechCheckCard_icon_UzYLs","addBg":"TechCheckCard_addBg_lsCmL","critical":"TechCheckCard_critical_XFgcZ","success":"TechCheckCard_success_rLXeg","errorList":"TechCheckCard_errorList_b_6Yf","error":"TechCheckCard_error_nqjAC","actionBar":"TechCheckCard_actionBar_Q2cX_","recommendations":"TechCheckCard_recommendations_wEi8d","link":"TechCheckCard_link_Oie0I"});
;// CONCATENATED MODULE: ./src/components/TechCheck/TechCheckCard.vue?vue&type=style&index=0&id=40426116&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/TechCheck/TechCheckCard.vue



;




function TechCheckCard_injectStyles (context) {
  
  this["$style"] = (TechCheckCardvue_type_style_index_0_id_40426116_prod_module_true_lang_scss.locals || TechCheckCardvue_type_style_index_0_id_40426116_prod_module_true_lang_scss)

}

/* normalize component */

var TechCheckCard_component = normalizeComponent(
  TechCheck_TechCheckCardvue_type_script_lang_js,
  TechCheckCardvue_type_template_id_40426116_functional_true_render,
  TechCheckCardvue_type_template_id_40426116_functional_true_staticRenderFns,
  true,
  TechCheckCard_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TechCheckCard = (TechCheckCard_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/TechCheckResults.vue?vue&type=script&lang=js


/* harmony default export */ var TechCheckResultsvue_type_script_lang_js = ({
  name: 'TechCheckResults',
  components: {
    TechCheckCard: TechCheckCard,
    SpeakerTestCard: SpeakerTestCard
  },
  props: {
    loadingConfig: {
      type: Object,
      default: () => {}
    },
    speakerTestCardConfig: {
      type: Object,
      default: () => {} // contain all props of techcheckcard and want to show or not
    },

    techCheckHeadingMetaData: {
      type: Object,
      default: () => {}
    },
    checkResults: Array,
    screenStream: Object,
    blockingErrorsConfig: {
      type: Object,
      default: () => {
        return {
          text: 'Allow Devices',
          isBanner: false,
          // footer button be a banner or cta
          status: 'succes',
          // status of type fail,success,""
          show: true
        };
      }
    },
    showScreenTestCard: {
      type: Boolean,
      default: false
    },
    selectedSpeaker: {
      type: Object,
      default: () => {}
    },
    speakers: {
      type: Array,
      default: () => []
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TechCheck/TechCheckResults.vue?vue&type=script&lang=js
 /* harmony default export */ var TechCheck_TechCheckResultsvue_type_script_lang_js = (TechCheckResultsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TechCheck/TechCheckResults.vue?vue&type=style&index=0&id=5a5ca891&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var TechCheckResultsvue_type_style_index_0_id_5a5ca891_prod_lang_scss_module_true = ({"root":"TechCheckResults_root_GAFL4","checkList":"TechCheckResults_checkList_nUWGj","checkListHeading":"TechCheckResults_checkListHeading_eDJ28","fail":"TechCheckResults_fail_QaLPi","success":"TechCheckResults_success_Vokj4","heading":"TechCheckResults_heading_JvSHn","checkListTiles":"TechCheckResults_checkListTiles_bL6sM","checkListFooter":"TechCheckResults_checkListFooter_wypyg","divider":"TechCheckResults_divider_nu9tg","actionButton":"TechCheckResults_actionButton_srD4k","checkStatus":"TechCheckResults_checkStatus_s0tOC","disabledButton":"TechCheckResults_disabledButton_aMIQN","techCheckContainer":"TechCheckResults_techCheckContainer_GM18n"});
;// CONCATENATED MODULE: ./src/components/TechCheck/TechCheckResults.vue?vue&type=style&index=0&id=5a5ca891&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/TechCheck/TechCheckResults.vue



;




function TechCheckResults_injectStyles (context) {
  
  this["$style"] = (TechCheckResultsvue_type_style_index_0_id_5a5ca891_prod_lang_scss_module_true.locals || TechCheckResultsvue_type_style_index_0_id_5a5ca891_prod_lang_scss_module_true)

}

/* normalize component */

var TechCheckResults_component = normalizeComponent(
  TechCheck_TechCheckResultsvue_type_script_lang_js,
  TechCheckResultsvue_type_template_id_5a5ca891_render,
  TechCheckResultsvue_type_template_id_5a5ca891_staticRenderFns,
  false,
  TechCheckResults_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TechCheckResults = (TechCheckResults_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/TechCheck.vue?vue&type=script&lang=js




/* harmony default export */ var TechCheckvue_type_script_lang_js = ({
  components: {
    AgoraV4Player: AgoraV4Player,
    TechSetup: TechSetup,
    TechCheckResults: TechCheckResults
  },
  name: 'TechCheck',
  props: {
    metaUIConfig: {
      type: Object,
      default: () => {}
    },
    screenStream: Object,
    user: Object,
    localStream: Object,
    devices: Object,
    selectedDevices: Object,
    permissions: Object,
    errors: Object,
    active: Object,
    videoTrack: Object,
    audioTrack: Object,
    virtualBackgrounds: Array,
    techCheckResults: Array,
    selectedVirtualBackground: String,
    blockingErrorsConfig: Object,
    loadingConfig: Object,
    speakerTestCardConfig: Object,
    techCheckHeadingMetaData: Object,
    loading: {
      type: Boolean,
      default: false
    },
    mirror: Boolean
  },
  data() {
    return {
      link: helpDocLinks.CAMERA_MIC_SETUP
    };
  },
  mounted() {
    this.$refs.heading.focus();
  }
});
;// CONCATENATED MODULE: ./src/components/TechCheck/TechCheck.vue?vue&type=script&lang=js
 /* harmony default export */ var TechCheck_TechCheckvue_type_script_lang_js = (TechCheckvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TechCheck/TechCheck.vue?vue&type=style&index=0&id=1221a3bc&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var TechCheckvue_type_style_index_0_id_1221a3bc_prod_lang_scss_module_true = ({"root":"TechCheck_root_whvvj","headerAction":"TechCheck_headerAction_mNIc5","description":"TechCheck_description_RffT_","heading":"TechCheck_heading_ooDWz","desc":"TechCheck_desc_WtTBB","row":"TechCheck_row_Y9dFH","deviceSetupPreview":"TechCheck_deviceSetupPreview_XDrc7","player":"TechCheck_player_J4XrQ","nocam":"TechCheck_nocam_Ns0Vl","errored":"TechCheck_errored_XFPCh","setup":"TechCheck_setup_dPolX","checkListWrapper":"TechCheck_checkListWrapper_WCHbo","nonmobile":"TechCheck_nonmobile_qt35V"});
;// CONCATENATED MODULE: ./src/components/TechCheck/TechCheck.vue?vue&type=style&index=0&id=1221a3bc&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/TechCheck/TechCheck.vue



;




function TechCheck_injectStyles (context) {
  
  this["$style"] = (TechCheckvue_type_style_index_0_id_1221a3bc_prod_lang_scss_module_true.locals || TechCheckvue_type_style_index_0_id_1221a3bc_prod_lang_scss_module_true)

}

/* normalize component */

var TechCheck_component = normalizeComponent(
  TechCheck_TechCheckvue_type_script_lang_js,
  TechCheckvue_type_template_id_1221a3bc_render,
  TechCheckvue_type_template_id_1221a3bc_staticRenderFns,
  false,
  TechCheck_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TechCheck = (TechCheck_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/ScreenShareTest.vue?vue&type=template&id=58fed388&functional=true
var ScreenShareTestvue_type_template_id_58fed388_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.props.screenStream ? [_c('div', {
    class: _vm.$style.screen_wrapper
  }, [_vm.props.screenStream ? _c('AgoraV4Player', {
    attrs: {
      "isLocal": true,
      "videoTrack": _vm.props.screenStream,
      "loading": false,
      "user": {},
      "muted": _vm.muted,
      "fit": "contain"
    }
  }) : _vm._e(), _c('div', {
    class: [_vm.$style.cta, _vm.props.screenStream && _vm.$style.bottom]
  }, [_c('IconButton', {
    attrs: {
      "size": "large",
      "icon": _vm.props.screenStream ? 'stop-screen-share' : 'screen-share',
      "variant": _vm.props.screenStream ? 'highlight' : 'secondary'
    },
    on: {
      "click": _vm.listeners.toggleScreen
    }
  })], 1)], 1), _c('HelpdocLink', {
    attrs: {
      "link": _vm.props.helpDocLink
    }
  })] : [_c('TextButton', {
    class: _vm.$style.action,
    attrs: {
      "color": "primary-text-color",
      "icon": "screen-share",
      "center": "",
      "uppercase": false
    },
    on: {
      "click": _vm.listeners.toggleScreen
    }
  }, [_vm._v(_vm._s(_vm.$options.$t('Test Screenshare')))])]], 2);
};
var ScreenShareTestvue_type_template_id_58fed388_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/TechCheck/ScreenShareTest.vue?vue&type=script&lang=js


/* harmony default export */ var ScreenShareTestvue_type_script_lang_js = ({
  name: 'ScreenShareTest',
  components: {
    HelpdocLink: HelpdocLink
  },
  props: {
    screenStream: Object,
    helpDocLink: {
      type: String,
      default: helpDocLinks.SCREEN_SHARE_TEST
    }
  }
});
;// CONCATENATED MODULE: ./src/components/TechCheck/ScreenShareTest.vue?vue&type=script&lang=js
 /* harmony default export */ var TechCheck_ScreenShareTestvue_type_script_lang_js = (ScreenShareTestvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/TechCheck/ScreenShareTest.vue?vue&type=style&index=0&id=58fed388&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ScreenShareTestvue_type_style_index_0_id_58fed388_prod_module_true_lang_scss = ({"root":"ScreenShareTest_root_DUQUF","screen_wrapper":"ScreenShareTest_screen_wrapper_h321B","cta":"ScreenShareTest_cta_NbraP","bottom":"ScreenShareTest_bottom_lP2mP","action":"ScreenShareTest_action_CYJHd"});
;// CONCATENATED MODULE: ./src/components/TechCheck/ScreenShareTest.vue?vue&type=style&index=0&id=58fed388&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/TechCheck/ScreenShareTest.vue



;




function ScreenShareTest_injectStyles (context) {
  
  this["$style"] = (ScreenShareTestvue_type_style_index_0_id_58fed388_prod_module_true_lang_scss.locals || ScreenShareTestvue_type_style_index_0_id_58fed388_prod_module_true_lang_scss)

}

/* normalize component */

var ScreenShareTest_component = normalizeComponent(
  TechCheck_ScreenShareTestvue_type_script_lang_js,
  ScreenShareTestvue_type_template_id_58fed388_functional_true_render,
  ScreenShareTestvue_type_template_id_58fed388_functional_true_staticRenderFns,
  true,
  ScreenShareTest_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ScreenShareTest = (ScreenShareTest_component.exports);
;// CONCATENATED MODULE: ./src/components/TechCheck/index.js






;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/BroadcastSlide.vue?vue&type=template&id=4350ff58
var BroadcastSlidevue_type_template_id_4350ff58_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "container",
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.presenting]: _vm.presenting
    },
    attrs: {
      "data-slidedeckid": _vm.slideid,
      "data-layout": _vm.layout
    }
  }, [_c('div', {
    ref: "rendertarget",
    class: _vm.$style.rendertarget
  }), !_vm.loaded ? _c('div', {
    staticClass: "secondary",
    class: _vm.$style.loading
  }, [_c('Loading', {
    attrs: {
      "size": "medium"
    }
  })], 1) : _vm._e()]);
};
var BroadcastSlidevue_type_template_id_4350ff58_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/BroadcastSlide.vue?vue&type=script&lang=js
/* harmony default export */ var BroadcastSlidevue_type_script_lang_js = ({
  name: 'BroadcastSlide',
  props: {
    pageNumber: {
      type: Number,
      required: true
    },
    size: {
      type: String,
      // can be "thumbnail" or "fullwidth"
      required: true
    },
    presenting: Boolean,
    loaded: {
      type: Boolean,
      default: false
    },
    // Both slideid and stageLayout are taken as props
    // so that the addSlideImage will be run through updated
    // whenever these are changed. Layout because we need to
    // reset the max-width of the image
    slideid: {
      type: String,
      required: true
    },
    layout: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.addSlideImage();
  },
  updated() {
    this.addSlideImage();
  },
  methods: {
    addSlideImage() {
      if (this.slideid && this.loaded && this.$refs.rendertarget) {
        const image = document.querySelector(`#slides-container > [id="${this.slideid}"][page-num="${this.pageNumber}"][page-size="${this.size}"]`);
        if (image) {
          const newimage = image.cloneNode();
          try {
            this.$refs.rendertarget.innerHTML = '';
          } catch (err) {
            // eslint-disable-next-line
            console.error('Slide container reference not found!', err);
          }
          // Give dom time to reflow after changing layouts possibly
          setTimeout(() => {
            try {
              this.$refs.rendertarget.replaceChildren(newimage);
            } catch (err) {
              //eslint-disable-next-line
              console.error('Failed to add slide!', err);
            }
          }, 100);
        } else {
          // eslint-disable-next-line
          console.error('Failed to get the image when changing slide!');
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Slides/BroadcastSlide.vue?vue&type=script&lang=js
 /* harmony default export */ var Slides_BroadcastSlidevue_type_script_lang_js = (BroadcastSlidevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-11.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Slides/BroadcastSlide.vue?vue&type=style&index=0&id=4350ff58&prod&module=true&lang=css
// extracted by mini-css-extract-plugin
/* harmony default export */ var BroadcastSlidevue_type_style_index_0_id_4350ff58_prod_module_true_lang_css = ({"root":"BroadcastSlide_root_IfVUd","rendertarget":"BroadcastSlide_rendertarget_NtEbg","loading":"BroadcastSlide_loading_LaFT7"});
;// CONCATENATED MODULE: ./src/components/Slides/BroadcastSlide.vue?vue&type=style&index=0&id=4350ff58&prod&module=true&lang=css
 
;// CONCATENATED MODULE: ./src/components/Slides/BroadcastSlide.vue



;




function BroadcastSlide_injectStyles (context) {
  
  this["$style"] = (BroadcastSlidevue_type_style_index_0_id_4350ff58_prod_module_true_lang_css.locals || BroadcastSlidevue_type_style_index_0_id_4350ff58_prod_module_true_lang_css)

}

/* normalize component */

var BroadcastSlide_component = normalizeComponent(
  Slides_BroadcastSlidevue_type_script_lang_js,
  BroadcastSlidevue_type_template_id_4350ff58_render,
  BroadcastSlidevue_type_template_id_4350ff58_staticRenderFns,
  false,
  BroadcastSlide_injectStyles,
  null,
  null
  
)

/* harmony default export */ var BroadcastSlide = (BroadcastSlide_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/SlideImage.vue?vue&type=template&id=434d9586
var SlideImagevue_type_template_id_434d9586_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.presenting]: _vm.presenting
    },
    attrs: {
      "data-layout": _vm.layout
    }
  }, [_c('div', {
    class: _vm.$style.rendertarget
  }, [_c('img', {
    attrs: {
      "src": _vm.config[_vm.currentSize],
      "loading": _vm.loading
    },
    on: {
      "load": _vm.setLoaded
    }
  }), _vm.size != _vm.currentSize || !_vm.loaded ? _c('div', {
    staticClass: "secondary",
    class: _vm.$style.loading
  }, [_c('Loading', {
    attrs: {
      "size": "medium"
    }
  })], 1) : _vm._e()])]);
};
var SlideImagevue_type_template_id_434d9586_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/SlideImage.vue?vue&type=script&lang=js
/* harmony default export */ var SlideImagevue_type_script_lang_js = ({
  name: 'SlideImage',
  props: {
    size: {
      type: String,
      // can be "thumb" or "low" or "high"
      required: true
    },
    presenting: Boolean,
    layout: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      required: true
    },
    loading: {
      type: String,
      // can be "lazy" or "eager"
      default: 'lazy'
    }
  },
  data() {
    return {
      currentSize: 'thumb',
      loaded: false
    };
  },
  mounted() {
    try {
      if (this.size === this.currentSize) {
        return;
      }
      const src = this.config[this.size];
      if (!src) {
        return;
      }
      const img = new Image();
      img.src = src;
      img.onload = () => {
        this.currentSize = this.size;
      };
    } catch (e) {
      console.error('Could not load SlideImage', e);
    }
  },
  methods: {
    setLoaded() {
      if (this.size === this.currentSize) {
        this.loaded = true;
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Slides/SlideImage.vue?vue&type=script&lang=js
 /* harmony default export */ var Slides_SlideImagevue_type_script_lang_js = (SlideImagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-11.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Slides/SlideImage.vue?vue&type=style&index=0&id=434d9586&prod&module=true&lang=css
// extracted by mini-css-extract-plugin
/* harmony default export */ var SlideImagevue_type_style_index_0_id_434d9586_prod_module_true_lang_css = ({"root":"SlideImage_root_Ha4VU","rendertarget":"SlideImage_rendertarget_ZRZxS","loading":"SlideImage_loading_klviB"});
;// CONCATENATED MODULE: ./src/components/Slides/SlideImage.vue?vue&type=style&index=0&id=434d9586&prod&module=true&lang=css
 
;// CONCATENATED MODULE: ./src/components/Slides/SlideImage.vue



;




function SlideImage_injectStyles (context) {
  
  this["$style"] = (SlideImagevue_type_style_index_0_id_434d9586_prod_module_true_lang_css.locals || SlideImagevue_type_style_index_0_id_434d9586_prod_module_true_lang_css)

}

/* normalize component */

var SlideImage_component = normalizeComponent(
  Slides_SlideImagevue_type_script_lang_js,
  SlideImagevue_type_template_id_434d9586_render,
  SlideImagevue_type_template_id_434d9586_staticRenderFns,
  false,
  SlideImage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SlideImage = (SlideImage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/SlidesList.vue?vue&type=template&id=7709b839
var SlidesListvue_type_template_id_7709b839_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.onsidebar ? _c('div', {
    key: _vm.onsidebar.src,
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('StyledText', {
    class: _vm.$style.name,
    attrs: {
      "color": "primary-text-color",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.onsidebar.name) + " ")]), _vm.decks.length > 1 ? _c('StyledText', {
    class: _vm.$style.change,
    attrs: {
      "color": "theme-secondary-color",
      "variant": "heading13"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openDeck', null);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Change Deck')) + " ")]) : _vm._e()], 1), _c('div', {
    ref: "slides"
  }, _vm._l(_vm.onsidebar.numPages, function (_, page) {
    return _c('Slide', {
      key: page,
      attrs: {
        "page": page + 1,
        "slideid": _vm.onsidebar.id,
        "loaded": _vm.onsidebar.pageloading[page + 1] == 'loaded',
        "config": _vm.usePdfConfigs && _vm.onsidebar.slides[page],
        "isCurrent": _vm.currentDeck && _vm.onsidebar.id === _vm.currentDeck.id && _vm.currentPage === page + 1,
        "publishedStage": _vm.publishedStage
      },
      on: {
        "publish": function ($event) {
          return _vm.$emit('selectSlide', {
            slide: _vm.onsidebar.id,
            page
          });
        }
      }
    });
  }), 1), _c('GTooltip', {
    class: _vm.$style.publishButton,
    attrs: {
      "disabled": _vm.publishedStage.isOverridable,
      "text": _vm.$options.$t(`Can't publish a slide when there is something else being presented on stage`)
    }
  }, [_c('PillButton', {
    attrs: {
      "icon": _vm.onsidebar.isPublished ? _vm.$options.$t('stop-screen-share') : _vm.$options.$t('screen-share'),
      "loading": _vm.onsidebar.loading,
      "disabled": _vm.onsidebar.loading || !_vm.publishedStage.isOverridable,
      "uppercase": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('selectSlide', {
          slide: _vm.onsidebar.isPublished ? null : _vm.onsidebar.id,
          page: 0
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.onsidebar.isPublished ? _vm.$options.$t('Stop Sharing') : _vm.$options.$t('Share')) + " ")])], 1)], 1) : _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    class: _vm.$style.heading,
    attrs: {
      "color": "primary-text-color",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Select a deck to begin presenting')) + " ")]), _vm._l(_vm.decks, function (deck) {
    return _c('SlideDeck', _vm._b({
      key: deck.id,
      attrs: {
        "usePdfConfigs": _vm.usePdfConfigs,
        "isCurrent": _vm.currentDeck && _vm.currentDeck.id === deck.id
      },
      on: {
        "openDeck": function ($event) {
          return _vm.openDeck(deck.id);
        },
        "publish": function ($event) {
          return _vm.$emit('selectSlide', {
            slide: deck.id,
            page: 0
          });
        }
      }
    }, 'SlideDeck', deck, false));
  })], 2);
};
var SlidesListvue_type_template_id_7709b839_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/SlidesList.vue?vue&type=script&lang=js
/* harmony default export */ var SlidesListvue_type_script_lang_js = ({
  name: 'SlidesList',
  props: {
    currentDeck: {
      type: Object,
      default: null
    },
    decks: Array,
    onsidebar: Object,
    currentPage: Number,
    publishedStage: {
      type: Object,
      default: () => ({})
    },
    usePdfConfigs: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    currentPage(n, o) {
      if (n !== o) {
        this.scrollToPublishSlide();
      }
    }
  },
  activated() {
    this.scrollToPublishSlide();
  },
  mounted() {
    this.scrollToPublishSlide();
  },
  methods: {
    openDeck(id) {
      this.$emit('openDeck', id);
      setTimeout(() => {
        this.scrollToPublishSlide();
      }, 100);
    },
    scrollToPublishSlide() {
      if (!this.onsidebar?.isPublished) {
        return;
      }
      const slides = this.$refs.slides;
      if (!slides?.children?.length) {
        return;
      }
      const currentPublishedSlide = slides.children[this.currentPage - 1];
      if (currentPublishedSlide) {
        currentPublishedSlide.scrollIntoView();
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Slides/SlidesList.vue?vue&type=script&lang=js
 /* harmony default export */ var Slides_SlidesListvue_type_script_lang_js = (SlidesListvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Slides/SlidesList.vue?vue&type=style&index=0&id=7709b839&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SlidesListvue_type_style_index_0_id_7709b839_prod_module_true_lang_scss = ({"root":"SlidesList_root_g3_LU","publishButton":"SlidesList_publishButton_d1OWn","heading":"SlidesList_heading_phvXk","header":"SlidesList_header_xsGz7","name":"SlidesList_name_g1YTk","change":"SlidesList_change_pgTcz"});
;// CONCATENATED MODULE: ./src/components/Slides/SlidesList.vue?vue&type=style&index=0&id=7709b839&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Slides/SlidesList.vue



;




function SlidesList_injectStyles (context) {
  
  this["$style"] = (SlidesListvue_type_style_index_0_id_7709b839_prod_module_true_lang_scss.locals || SlidesListvue_type_style_index_0_id_7709b839_prod_module_true_lang_scss)

}

/* normalize component */

var SlidesList_component = normalizeComponent(
  Slides_SlidesListvue_type_script_lang_js,
  SlidesListvue_type_template_id_7709b839_render,
  SlidesListvue_type_template_id_7709b839_staticRenderFns,
  false,
  SlidesList_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SlidesList = (SlidesList_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/SlidesScreen.vue?vue&type=template&id=bc0a4dac
var SlidesScreenvue_type_template_id_bc0a4dac_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.usePdfConfigs ? [_c('SlideImage', {
    key: _vm.currentPage,
    attrs: {
      "size": "high",
      "loading": "eager",
      "config": _vm.slides && _vm.slides[_vm.currentPage - 1] || {}
    }
  }), _vm._l(_vm.slidesToCache, function (url) {
    return _c('img', {
      key: url,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "src": url
      }
    });
  })] : [_c('BroadcastSlide', {
    key: _vm.currentPage + 'loaded',
    attrs: {
      "slideid": _vm.id,
      "pageNumber": _vm.currentPage,
      "isCurrent": true,
      "presenting": true,
      "size": "fullwidth",
      "loaded": _vm.currentPageLoaded,
      "layout": _vm.layout
    }
  }), !_vm.currentPageLoaded ? _c('BroadcastSlide', {
    key: _vm.currentPage + 'loading',
    class: _vm.$style.loading,
    attrs: {
      "slideid": _vm.id,
      "pageNumber": _vm.currentPage,
      "isCurrent": true,
      "presenting": true,
      "loaded": _vm.currentPageLoaded,
      "size": "fullwidth",
      "layout": _vm.layout
    }
  }) : _vm._e()]], 2);
};
var SlidesScreenvue_type_template_id_bc0a4dac_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/SlidesScreen.vue?vue&type=script&lang=js
/* harmony default export */ var SlidesScreenvue_type_script_lang_js = ({
  name: 'SlideScreen',
  props: {
    pageloading: Object,
    id: String,
    currentPage: Number,
    layout: {
      type: String,
      default: ''
    },
    usePdfConfigs: Boolean,
    slides: {
      type: Array
    }
  },
  computed: {
    slidesToCache() {
      if (!this.slides) {
        return [];
      }
      const currentIndex = this.currentPage - 1;
      const numberOfPagesToCache = 2;
      const eligibleSlides = this.slides.slice(currentIndex + 1, currentIndex + numberOfPagesToCache);
      return eligibleSlides.map(slide => slide?.high || null).filter(slide => slide);
    },
    currentPageLoaded() {
      if (this.slides) {
        return true;
      }
      return this.pageloading[this.currentPage] == 'loaded';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Slides/SlidesScreen.vue?vue&type=script&lang=js
 /* harmony default export */ var Slides_SlidesScreenvue_type_script_lang_js = (SlidesScreenvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Slides/SlidesScreen.vue?vue&type=style&index=0&id=bc0a4dac&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SlidesScreenvue_type_style_index_0_id_bc0a4dac_prod_module_true_lang_scss = ({"root":"SlidesScreen_root_vjiXF","loading":"SlidesScreen_loading_gEbGN"});
;// CONCATENATED MODULE: ./src/components/Slides/SlidesScreen.vue?vue&type=style&index=0&id=bc0a4dac&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Slides/SlidesScreen.vue



;




function SlidesScreen_injectStyles (context) {
  
  this["$style"] = (SlidesScreenvue_type_style_index_0_id_bc0a4dac_prod_module_true_lang_scss.locals || SlidesScreenvue_type_style_index_0_id_bc0a4dac_prod_module_true_lang_scss)

}

/* normalize component */

var SlidesScreen_component = normalizeComponent(
  Slides_SlidesScreenvue_type_script_lang_js,
  SlidesScreenvue_type_template_id_bc0a4dac_render,
  SlidesScreenvue_type_template_id_bc0a4dac_staticRenderFns,
  false,
  SlidesScreen_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SlidesScreen = (SlidesScreen_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/SlideDeck.vue?vue&type=template&id=9993be8e&functional=true
var SlideDeckvue_type_template_id_9993be8e_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.error]: _vm.props.transcodeStatus === 'ERROR',
      [_vm.$style.processing]: ['SUBMITTED', 'PROGRESSING'].includes(_vm.props.transcodeStatus)
    },
    on: {
      "click": () => _vm.props.transcodeStatus === 'COMPLETE' && _vm.listeners.openDeck()
    }
  }, [_c('div', {
    class: _vm.$style.slide
  }, [_vm.props.usePdfConfigs ? _c('SlideImage', {
    attrs: {
      "size": "thumb",
      "slideid": _vm.props.slideid,
      "pageNumber": "1",
      "loaded": "",
      "config": _vm.props.slides[0]
    }
  }) : _c('BroadcastSlide', {
    attrs: {
      "slideid": _vm.props.id,
      "pageNumber": 1,
      "loaded": _vm.props.pageloading[1] == 'loaded',
      "size": "thumbnail"
    }
  })], 1), _c('div', {
    class: _vm.$style.details
  }, [_c('StyledText', {
    class: _vm.$style.name,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.name) + " ")]), !_vm.props.loading ? _c('StyledText', {
    class: _vm.$style.slidesCount,
    attrs: {
      "color": "primary-text-color",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.numPages > 1 ? _vm.$options.$t('{n} Slides', {
    n: _vm.props.numPages
  }) : '') + " " + _vm._s(_vm.props.numPages == 1 ? _vm.$options.$t('1 Slide') : '') + " ")]) : _vm._e(), _vm.props.transcodeStatus !== 'COMPLETE' ? _c('StyledText', [_vm._v(" " + _vm._s(_vm.props.statusPrettyNames[_vm.props.transcodeStatus] || _vm.props.transcodeStatus) + "... ")]) : _vm._e()], 1)]);
};
var SlideDeckvue_type_template_id_9993be8e_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/SlideDeck.vue?vue&type=script&lang=js

/* harmony default export */ var SlideDeckvue_type_script_lang_js = ({
  components: {
    SlideImage: SlideImage
  },
  name: 'SlideDeck',
  functional: true,
  props: {
    id: String,
    name: String,
    isCurrent: Boolean,
    pageloading: Object,
    numPages: Number,
    loading: Boolean,
    slides: Array,
    thumbnail: String,
    usePdfConfigs: Boolean,
    transcodeStatus: String,
    statusPrettyNames: {
      type: Object,
      default: () => ({
        SUBMITTED: 'Processing',
        PROGRESSING: 'Processing',
        ERROR: 'Error',
        COMPLETE: 'Complete'
      })
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Slides/SlideDeck.vue?vue&type=script&lang=js
 /* harmony default export */ var Slides_SlideDeckvue_type_script_lang_js = (SlideDeckvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Slides/SlideDeck.vue?vue&type=style&index=0&id=9993be8e&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SlideDeckvue_type_style_index_0_id_9993be8e_prod_lang_scss_module_true = ({"root":"SlideDeck_root__SX6Y","slide":"SlideDeck_slide_pjJTb","details":"SlideDeck_details_HougC","slidesCount":"SlideDeck_slidesCount_Yowma","name":"SlideDeck_name_Jbb28","error":"SlideDeck_error_B43LC","processing":"SlideDeck_processing_cYIaa"});
;// CONCATENATED MODULE: ./src/components/Slides/SlideDeck.vue?vue&type=style&index=0&id=9993be8e&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Slides/SlideDeck.vue



;




function SlideDeck_injectStyles (context) {
  
  this["$style"] = (SlideDeckvue_type_style_index_0_id_9993be8e_prod_lang_scss_module_true.locals || SlideDeckvue_type_style_index_0_id_9993be8e_prod_lang_scss_module_true)

}

/* normalize component */

var SlideDeck_component = normalizeComponent(
  Slides_SlideDeckvue_type_script_lang_js,
  SlideDeckvue_type_template_id_9993be8e_functional_true_render,
  SlideDeckvue_type_template_id_9993be8e_functional_true_staticRenderFns,
  true,
  SlideDeck_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SlideDeck = (SlideDeck_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/Slide.vue?vue&type=template&id=7b6db348
var Slidevue_type_template_id_7b6db348_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.isSlideDisabled && _vm.$style.disabled],
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.publishSlide.apply(null, arguments);
      }
    }
  }, [_c('StyledText', {
    class: _vm.$style.pageNumber,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.page) + ". ")]), _c('div', {
    class: _vm.$style.slide
  }, [_vm.config ? _c('SlideImage', {
    attrs: {
      "size": "thumb",
      "pageNumber": _vm.page,
      "loaded": _vm.loaded,
      "config": _vm.config
    }
  }) : _c('BroadcastSlide', {
    attrs: {
      "slideid": _vm.slideid,
      "pageNumber": _vm.page,
      "loaded": _vm.loaded,
      "size": "thumbnail"
    }
  })], 1), _c('div', {
    class: _vm.$style.details
  }, [_c('GTooltip', {
    attrs: {
      "disabled": _vm.publishedStage.isOverridable,
      "text": _vm.$options.$t(`Can't publish a slide when there is something else being presented on stage`),
      "position": "top-right"
    }
  }, [_c('IconButton', {
    class: _vm.$style.share,
    attrs: {
      "icon": "screen-share",
      "disabled": _vm.isSlideDisabled,
      "ghost": !_vm.isCurrent
    }
  })], 1)], 1)], 1);
};
var Slidevue_type_template_id_7b6db348_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/Slide.vue?vue&type=script&lang=js

/* harmony default export */ var Slidevue_type_script_lang_js = ({
  components: {
    SlideImage: SlideImage
  },
  name: 'Slide',
  props: {
    slideid: String,
    page: Number,
    isCurrent: Boolean,
    loaded: Boolean,
    publishedStage: {
      type: Object,
      default: () => ({})
    },
    config: {
      type: [Object, Boolean],
      default: false
    }
  },
  computed: {
    isSlideDisabled() {
      if (!this.publishedStage.isOverridable || this.isCurrent) {
        return true;
      }
      return false;
    }
  },
  methods: {
    publishSlide() {
      if (!this.isSlideDisabled) {
        this.$emit('publish');
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Slides/Slide.vue?vue&type=script&lang=js
 /* harmony default export */ var Slides_Slidevue_type_script_lang_js = (Slidevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Slides/Slide.vue?vue&type=style&index=0&id=7b6db348&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var Slidevue_type_style_index_0_id_7b6db348_prod_lang_scss_module_true = ({"root":"Slide_root_XBaB5","slide":"Slide_slide_RceEC","details":"Slide_details_P9LmZ","slidesCount":"Slide_slidesCount_KZ9Oo","pageNumber":"Slide_pageNumber_yc3Qa","share":"Slide_share_WxpBO","disabled":"Slide_disabled_RpDDA"});
;// CONCATENATED MODULE: ./src/components/Slides/Slide.vue?vue&type=style&index=0&id=7b6db348&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/Slides/Slide.vue



;




function Slide_injectStyles (context) {
  
  this["$style"] = (Slidevue_type_style_index_0_id_7b6db348_prod_lang_scss_module_true.locals || Slidevue_type_style_index_0_id_7b6db348_prod_lang_scss_module_true)

}

/* normalize component */

var Slide_component = normalizeComponent(
  Slides_Slidevue_type_script_lang_js,
  Slidevue_type_template_id_7b6db348_render,
  Slidevue_type_template_id_7b6db348_staticRenderFns,
  false,
  Slide_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Slide = (Slide_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/SlideControl.vue?vue&type=template&id=4116ca34
var SlideControlvue_type_template_id_4116ca34_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.slides && _vm.slides.isPublished ? _c('div', {
    class: _vm.$style.root
  }, [_c('GTooltip', {
    attrs: {
      "text": _vm.leftArrowTooltipText,
      "position": "top-right"
    }
  }, [_c('IconButton', {
    class: _vm.$style.leftArrowButton,
    attrs: {
      "icon": "down-arrow",
      "disabled": _vm.isLeftArrowDisabled,
      "variant": "secondary"
    },
    on: {
      "click": _vm.goToPreviousSlide
    }
  })], 1), _c('GTooltip', {
    attrs: {
      "text": _vm.rightArrowTooltipText,
      "position": "top-right"
    }
  }, [_c('IconButton', {
    class: _vm.$style.rightArrowButton,
    attrs: {
      "icon": "down-arrow",
      "disabled": _vm.isRightArrowDisabled,
      "variant": "secondary"
    },
    on: {
      "click": _vm.goToNextSlide
    }
  })], 1)], 1) : _vm._e();
};
var SlideControlvue_type_template_id_4116ca34_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/Slides/SlideControl.vue?vue&type=script&lang=js
/* harmony default export */ var SlideControlvue_type_script_lang_js = ({
  name: 'SlideControl',
  props: {
    slides: Object
  },
  computed: {
    isCurrentSlideLoading() {
      if (!this.slides) {
        return true;
      }
      if (this.slides.pageloading?.[this.slides.currentPage] == 'loading') {
        return true;
      }
      return false;
    },
    isLeftArrowDisabled() {
      if (this.slides.currentPage === 1 || this.isCurrentSlideLoading) {
        return true;
      }
      return false;
    },
    isRightArrowDisabled() {
      if (this.slides.currentPage === this.slides.numPages || this.isCurrentSlideLoading) {
        return true;
      }
      return false;
    },
    rightArrowTooltipText() {
      if (this.slides.currentPage === this.slides.numPages) {
        return 'No Next Slide';
      }
      return 'Next Slide';
    },
    leftArrowTooltipText() {
      if (this.slides.currentPage === 1) {
        return 'No Previous Slide';
      }
      return 'Previous Slide';
    }
  },
  methods: {
    goToNextSlide() {
      if (this.slides.currentPage < this.slides.numPages) {
        // currentPage is 1 based indexing whereas broadcast.current_playing_slide_number is 0 based
        // so just sending the currentPage will set the next slide as current
        this.$emit('changeSlide', {
          slide: this.slides.id,
          page: this.slides.currentPage
        });
      }
    },
    goToPreviousSlide() {
      // The lowest value of currentPage is 1. So only if its 2 or greater than 2
      if (this.slides.currentPage > 1) {
        this.$emit('changeSlide', {
          slide: this.slides.id,
          // since currentPage >= 2 this works. Check goToNextSlide function above for more explanation
          page: this.slides.currentPage - 2
        });
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Slides/SlideControl.vue?vue&type=script&lang=js
 /* harmony default export */ var Slides_SlideControlvue_type_script_lang_js = (SlideControlvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/Slides/SlideControl.vue?vue&type=style&index=0&id=4116ca34&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SlideControlvue_type_style_index_0_id_4116ca34_prod_module_true_lang_scss = ({"root":"SlideControl_root_DMHfo","leftArrowButton":"SlideControl_leftArrowButton_LSvd_","rightArrowButton":"SlideControl_rightArrowButton_N4OYy"});
;// CONCATENATED MODULE: ./src/components/Slides/SlideControl.vue?vue&type=style&index=0&id=4116ca34&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/Slides/SlideControl.vue



;




function SlideControl_injectStyles (context) {
  
  this["$style"] = (SlideControlvue_type_style_index_0_id_4116ca34_prod_module_true_lang_scss.locals || SlideControlvue_type_style_index_0_id_4116ca34_prod_module_true_lang_scss)

}

/* normalize component */

var SlideControl_component = normalizeComponent(
  Slides_SlideControlvue_type_script_lang_js,
  SlideControlvue_type_template_id_4116ca34_render,
  SlideControlvue_type_template_id_4116ca34_staticRenderFns,
  false,
  SlideControl_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SlideControl = (SlideControl_component.exports);
;// CONCATENATED MODULE: ./src/components/Slides/index.js








;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/DrimifyContainer.vue?vue&type=template&id=5aca64b9
var DrimifyContainervue_type_template_id_5aca64b9_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.loading !== 'error' ? _c('div', {
    ref: "drimifyelement"
  }) : _c('StyledText', {
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Error in loading drimify')) + " ")])], 1);
};
var DrimifyContainervue_type_template_id_5aca64b9_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/DrimifyContainer.vue?vue&type=script&lang=js
/* harmony default export */ var DrimifyContainervue_type_script_lang_js = ({
  name: 'drimify-container',
  props: {
    configuration: {
      type: Object,
      default() {
        return {
          autofocus: true,
          height: '600px',
          engine: 'https://go.drimify.com/pacman/40619/app.html?projectid=207716808860c3a92c3e43a996648923-60c3a92c3e43f&lang=en',
          style: 'border:0px solid #d1d1d1;',
          src: 'https://cdn.drimify.com/js/drimifywidget.release.min.js'
        };
      }
    }
  },
  data() {
    return {
      loading: 'loading',
      widget: null
    };
  },
  mounted() {
    this.loadDrimifyScriptIfNotLoaded().then(() => {
      const el = this.$refs.drimifyelement;
      this.widget = new window.Drimify.Widget({
        autofocus: this.configuration.autofocus,
        height: this.configuration.height,
        element: el,
        engine: this.configuration.engine + `&custom_drimid=${this.configuration.userEmail}`,
        style: this.configuration.style
      });
      this.loading = 'loaded';
      this.widget.load();
    }).catch(err => {
      console.error(err);
      this.loading = 'error';
    });
  },
  methods: {
    loadDrimifyScriptIfNotLoaded() {
      return new Promise((resolve, reject) => {
        if (!window.Drimify) {
          let el = document.createElement('script');
          el.setAttribute('src', this.configuration.src);
          document.body.appendChild(el);
          el.onload = () => {
            resolve();
          };
          el.onerror = () => {
            reject('Failed to download drimify files');
          };
        } else {
          resolve();
        }
      });
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/DrimifyContainer.vue?vue&type=script&lang=js
 /* harmony default export */ var EmbeddableWidgetContainers_DrimifyContainervue_type_script_lang_js = (DrimifyContainervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EmbeddableWidgetContainers/DrimifyContainer.vue?vue&type=style&index=0&id=5aca64b9&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var DrimifyContainervue_type_style_index_0_id_5aca64b9_prod_lang_scss_module_true = ({"root":"DrimifyContainer_root_YQFSn"});
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/DrimifyContainer.vue?vue&type=style&index=0&id=5aca64b9&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/DrimifyContainer.vue



;




function DrimifyContainer_injectStyles (context) {
  
  this["$style"] = (DrimifyContainervue_type_style_index_0_id_5aca64b9_prod_lang_scss_module_true.locals || DrimifyContainervue_type_style_index_0_id_5aca64b9_prod_lang_scss_module_true)

}

/* normalize component */

var DrimifyContainer_component = normalizeComponent(
  EmbeddableWidgetContainers_DrimifyContainervue_type_script_lang_js,
  DrimifyContainervue_type_template_id_5aca64b9_render,
  DrimifyContainervue_type_template_id_5aca64b9_staticRenderFns,
  false,
  DrimifyContainer_injectStyles,
  null,
  null
  
)

/* harmony default export */ var DrimifyContainer = (DrimifyContainer_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/DrimifyContainerNewConfigs.vue?vue&type=template&id=30e78c2f
var DrimifyContainerNewConfigsvue_type_template_id_30e78c2f_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.loading !== 'error' ? _c('div', {
    ref: "drimifyelement"
  }) : _c('StyledText', {
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Error in loading drimify')) + " ")])], 1);
};
var DrimifyContainerNewConfigsvue_type_template_id_30e78c2f_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/DrimifyContainerNewConfigs.vue?vue&type=script&lang=js
/* harmony default export */ var DrimifyContainerNewConfigsvue_type_script_lang_js = ({
  name: 'DrimifyContainerNewConfigs',
  props: {
    configuration: {
      type: Object,
      default() {
        return {
          autofocus: true,
          height: '600px',
          engine: 'https://apps.drimify.com/As6PhZwP/',
          style: 'border:0px solid #d1d1d1;',
          src: 'https://cdn-apps.drimify.com/prod/widget/index.js'
        };
      }
    }
  },
  data() {
    return {
      loading: 'loading',
      widget: null
    };
  },
  mounted() {
    this.loadDrimifyScriptIfNotLoaded().then(() => {
      const el = this.$refs.drimifyelement;
      this.widget = window.DigitaService.Widget.Create({
        autoscroll: true,
        height: this.configuration.height,
        fixed: true,
        element: el,
        engine: this.configuration.engine + `?session_uid=${this.configuration.userEmail}`,
        sharingurl: this.configuration.engine,
        width: this.configuration.width || '100%'
      });
      this.loading = 'loaded';
      this.widget.load();
    }).catch(err => {
      console.error(err);
      this.loading = 'error';
    });
  },
  methods: {
    loadDrimifyScriptIfNotLoaded() {
      return new Promise((resolve, reject) => {
        if (!window.Drimify) {
          let el = document.createElement('script');
          el.setAttribute('src', this.configuration.src);
          document.body.appendChild(el);
          el.onload = () => {
            resolve();
          };
          el.onerror = () => {
            reject('Failed to download drimify files');
          };
        } else {
          resolve();
        }
      });
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/DrimifyContainerNewConfigs.vue?vue&type=script&lang=js
 /* harmony default export */ var EmbeddableWidgetContainers_DrimifyContainerNewConfigsvue_type_script_lang_js = (DrimifyContainerNewConfigsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EmbeddableWidgetContainers/DrimifyContainerNewConfigs.vue?vue&type=style&index=0&id=30e78c2f&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var DrimifyContainerNewConfigsvue_type_style_index_0_id_30e78c2f_prod_lang_scss_module_true = ({"root":"DrimifyContainerNewConfigs_root_GztnQ"});
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/DrimifyContainerNewConfigs.vue?vue&type=style&index=0&id=30e78c2f&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/DrimifyContainerNewConfigs.vue



;




function DrimifyContainerNewConfigs_injectStyles (context) {
  
  this["$style"] = (DrimifyContainerNewConfigsvue_type_style_index_0_id_30e78c2f_prod_lang_scss_module_true.locals || DrimifyContainerNewConfigsvue_type_style_index_0_id_30e78c2f_prod_lang_scss_module_true)

}

/* normalize component */

var DrimifyContainerNewConfigs_component = normalizeComponent(
  EmbeddableWidgetContainers_DrimifyContainerNewConfigsvue_type_script_lang_js,
  DrimifyContainerNewConfigsvue_type_template_id_30e78c2f_render,
  DrimifyContainerNewConfigsvue_type_template_id_30e78c2f_staticRenderFns,
  false,
  DrimifyContainerNewConfigs_injectStyles,
  null,
  null
  
)

/* harmony default export */ var DrimifyContainerNewConfigs = (DrimifyContainerNewConfigs_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/WeBoothContainer.vue?vue&type=template&id=c520a4fa
var WeBoothContainervue_type_template_id_c520a4fa_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('iframe', {
    style: _vm.configuration.style,
    attrs: {
      "allow": _vm.configuration.allow,
      "width": "100%",
      "height": "100%",
      "scrolling": _vm.configuration.scrolling,
      "src": _vm.configuration.src
    }
  });
};
var WeBoothContainervue_type_template_id_c520a4fa_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/WeBoothContainer.vue?vue&type=script&lang=js
/* harmony default export */ var WeBoothContainervue_type_script_lang_js = ({
  name: 'webooth-container',
  props: {
    configuration: {
      type: Object,
      default() {
        return {
          src: 'https://fun.webooth.fun/gold/lobby/ltx1rsts&autoJoin=true',
          style: 'border:none;',
          scrolling: 'no',
          allow: 'camera;microphone;clipboard-write'
        };
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/WeBoothContainer.vue?vue&type=script&lang=js
 /* harmony default export */ var EmbeddableWidgetContainers_WeBoothContainervue_type_script_lang_js = (WeBoothContainervue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/WeBoothContainer.vue





/* normalize component */
;
var WeBoothContainer_component = normalizeComponent(
  EmbeddableWidgetContainers_WeBoothContainervue_type_script_lang_js,
  WeBoothContainervue_type_template_id_c520a4fa_render,
  WeBoothContainervue_type_template_id_c520a4fa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var WeBoothContainer = (WeBoothContainer_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/TypeformContainer.vue?vue&type=template&id=0d8cc7b4
var TypeformContainervue_type_template_id_0d8cc7b4_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.typeformContainer,
    attrs: {
      "data-tf-widget": _vm.configuration.data_tf_widget,
      "data-tf-medium": _vm.configuration.data_tf_medium
    }
  });
};
var TypeformContainervue_type_template_id_0d8cc7b4_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/TypeformContainer.vue?vue&type=script&lang=js
/* harmony default export */ var TypeformContainervue_type_script_lang_js = ({
  name: 'TypeformContainer',
  props: {
    configuration: Object
  },
  mounted() {
    if (!window.tf) {
      this.addTypeformScript();
    } else {
      window.tf = undefined;
      const oldscript = document.querySelector('script#typeformscript');
      document.head.removeChild(oldscript);
      this.addTypeformScript();
    }
  },
  methods: {
    addTypeformScript() {
      const script = document.createElement('script');
      script.src = '//embed.typeform.com/next/embed.js';
      script.setAttribute('id', 'typeformscript');
      document.head.appendChild(script);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/TypeformContainer.vue?vue&type=script&lang=js
 /* harmony default export */ var EmbeddableWidgetContainers_TypeformContainervue_type_script_lang_js = (TypeformContainervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-11.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EmbeddableWidgetContainers/TypeformContainer.vue?vue&type=style&index=0&id=0d8cc7b4&prod&module=true&lang=css
// extracted by mini-css-extract-plugin
/* harmony default export */ var TypeformContainervue_type_style_index_0_id_0d8cc7b4_prod_module_true_lang_css = ({"typeformContainer":"TypeformContainer_typeformContainer_TqO6C"});
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/TypeformContainer.vue?vue&type=style&index=0&id=0d8cc7b4&prod&module=true&lang=css
 
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/TypeformContainer.vue



;




function TypeformContainer_injectStyles (context) {
  
  this["$style"] = (TypeformContainervue_type_style_index_0_id_0d8cc7b4_prod_module_true_lang_css.locals || TypeformContainervue_type_style_index_0_id_0d8cc7b4_prod_module_true_lang_css)

}

/* normalize component */

var TypeformContainer_component = normalizeComponent(
  EmbeddableWidgetContainers_TypeformContainervue_type_script_lang_js,
  TypeformContainervue_type_template_id_0d8cc7b4_render,
  TypeformContainervue_type_template_id_0d8cc7b4_staticRenderFns,
  false,
  TypeformContainer_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TypeformContainer = (TypeformContainer_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/IframeEmbedder.vue?vue&type=template&id=8b2a3910
var IframeEmbeddervue_type_template_id_8b2a3910_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('iframe', _vm._b({
    class: _vm.$style.iframestyles
  }, 'iframe', _vm.configuration, false));
};
var IframeEmbeddervue_type_template_id_8b2a3910_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/IframeEmbedder.vue?vue&type=script&lang=js
/* harmony default export */ var IframeEmbeddervue_type_script_lang_js = ({
  name: 'webooth-container',
  props: {
    configuration: {
      type: Object,
      default() {
        return {
          src: 'https://appweb.twine.nyc/embed/rooms/1956?uid_h=9fe5e2c774d596aeccd8569d73867dc6',
          sandbox: 'allow-scripts allow-same-origin allow-top-navigation allow-forms allow-popups allow-pointer-lock allow-popups-to-escape-sandbox',
          allow: 'camera;microphone',
          width: '100',
          height: '100'
        };
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/IframeEmbedder.vue?vue&type=script&lang=js
 /* harmony default export */ var EmbeddableWidgetContainers_IframeEmbeddervue_type_script_lang_js = (IframeEmbeddervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/EmbeddableWidgetContainers/IframeEmbedder.vue?vue&type=style&index=0&id=8b2a3910&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var IframeEmbeddervue_type_style_index_0_id_8b2a3910_prod_module_true_lang_scss = ({"iframestyles":"IframeEmbedder_iframestyles_x1Ie_"});
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/IframeEmbedder.vue?vue&type=style&index=0&id=8b2a3910&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/IframeEmbedder.vue



;




function IframeEmbedder_injectStyles (context) {
  
  this["$style"] = (IframeEmbeddervue_type_style_index_0_id_8b2a3910_prod_module_true_lang_scss.locals || IframeEmbeddervue_type_style_index_0_id_8b2a3910_prod_module_true_lang_scss)

}

/* normalize component */

var IframeEmbedder_component = normalizeComponent(
  EmbeddableWidgetContainers_IframeEmbeddervue_type_script_lang_js,
  IframeEmbeddervue_type_template_id_8b2a3910_render,
  IframeEmbeddervue_type_template_id_8b2a3910_staticRenderFns,
  false,
  IframeEmbedder_injectStyles,
  null,
  null
  
)

/* harmony default export */ var IframeEmbedder = (IframeEmbedder_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/SlidoContainer.vue?vue&type=template&id=30454105
var SlidoContainervue_type_template_id_30454105_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.slidoURL ? _c('IframeEmbedder', {
    attrs: {
      "configuration": _vm.slidoConfigurations
    }
  }) : _vm._e();
};
var SlidoContainervue_type_template_id_30454105_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/EmbeddableWidgetContainers/SlidoContainer.vue?vue&type=script&lang=js

/* harmony default export */ var SlidoContainervue_type_script_lang_js = ({
  name: 'SlidoContainer',
  components: {
    IframeEmbedder: IframeEmbedder
  },
  props: {
    slidoURL: {
      type: String,
      default: ''
    }
  },
  computed: {
    slidoConfigurations() {
      const slidoURL = this.slidoURL;
      return {
        src: slidoURL,
        sandbox: 'allow-scripts allow-same-origin allow-top-navigation allow-forms allow-popups allow-pointer-lock allow-popups-to-escape-sandbox',
        allow: '',
        width: '100%',
        height: '97%'
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/SlidoContainer.vue?vue&type=script&lang=js
 /* harmony default export */ var EmbeddableWidgetContainers_SlidoContainervue_type_script_lang_js = (SlidoContainervue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/SlidoContainer.vue





/* normalize component */
;
var SlidoContainer_component = normalizeComponent(
  EmbeddableWidgetContainers_SlidoContainervue_type_script_lang_js,
  SlidoContainervue_type_template_id_30454105_render,
  SlidoContainervue_type_template_id_30454105_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SlidoContainer = (SlidoContainer_component.exports);
;// CONCATENATED MODULE: ./src/components/EmbeddableWidgetContainers/index.js






;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/UserLandingPage.vue?vue&type=template&id=9f0d2bbc
var UserLandingPagevue_type_template_id_9f0d2bbc_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.foreground
  }, [_c('UserHomeNavBar', {
    attrs: {
      "user": _vm.user,
      "showManageEventButton": _vm.showManageEventButton
    },
    on: {
      "go-to-profile": function ($event) {
        return _vm.$emit('go-to-profile');
      },
      "manage-events": function ($event) {
        return _vm.$emit('manage-events');
      }
    }
  }), _c('div', {
    class: _vm.$style.main
  }, [_c('div', {
    class: _vm.$style.elemContainer
  }, [_c('UserProfile', {
    attrs: {
      "user": _vm.user
    },
    on: {
      "go-to-profile": function ($event) {
        return _vm.$emit('go-to-profile');
      }
    }
  }), _c('div', {
    class: _vm.$style.message
  }, [_vm.message ? _c('StyledText', {
    attrs: {
      "variant": "subHeading18",
      "color": "color-highlight"
    }
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")]) : _vm._e()], 1), _c('EventsNavBar', {
    on: {
      "on-select-tab": e => _vm.$emit('on-select-tab', e)
    }
  }), _c('EventsSection', {
    attrs: {
      "past": _vm.past,
      "events": _vm.events,
      "loading": _vm.loading
    },
    on: {
      "go-to-event": e => _vm.$emit('go-to-event', e)
    }
  })], 1)])], 1)]);
};
var UserLandingPagevue_type_template_id_9f0d2bbc_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/UserLandingPage.vue?vue&type=script&lang=js

/* harmony default export */ var UserLandingPagevue_type_script_lang_js = ({
  name: 'App',
  components: {
    UserHomeNavBar: UserHomeNavBar,
    UserProfile: UserProfile,
    EventsNavBar: EventsNavBar,
    EventsSection: EventsSection
  },
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({
        username: 'Ïrish Smith'
      })
    },
    events: {
      type: Array,
      default: () => []
    },
    past: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    showManageEventButton: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/UserLandingPage.vue?vue&type=script&lang=js
 /* harmony default export */ var examples_UserLandingPagevue_type_script_lang_js = (UserLandingPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/UserLandingPage.vue?vue&type=style&index=0&id=9f0d2bbc&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var UserLandingPagevue_type_style_index_0_id_9f0d2bbc_prod_module_true_lang_scss = ({"root":"UserLandingPage_root_i3kgM","foreground":"UserLandingPage_foreground_jTr8p","eventscard":"UserLandingPage_eventscard_wxjuw","userimage":"UserLandingPage_userimage_zXIu0","main":"UserLandingPage_main_UpufJ","elemContainer":"UserLandingPage_elemContainer_KRpFy","message":"UserLandingPage_message_iNnnN","label":"UserLandingPage_label_aznLr","userlabel":"UserLandingPage_userlabel_G6Fnn","eventSection":"UserLandingPage_eventSection_xUh6G","event":"UserLandingPage_event_UwApM","ulheader":"UserLandingPage_ulheader_KONYb","headerelement":"UserLandingPage_headerelement_Se4oQ","logout":"UserLandingPage_logout_pTeeY"});
;// CONCATENATED MODULE: ./src/examples/UserLandingPage.vue?vue&type=style&index=0&id=9f0d2bbc&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/UserLandingPage.vue



;




function UserLandingPage_injectStyles (context) {
  
  this["$style"] = (UserLandingPagevue_type_style_index_0_id_9f0d2bbc_prod_module_true_lang_scss.locals || UserLandingPagevue_type_style_index_0_id_9f0d2bbc_prod_module_true_lang_scss)

}

/* normalize component */

var UserLandingPage_component = normalizeComponent(
  examples_UserLandingPagevue_type_script_lang_js,
  UserLandingPagevue_type_template_id_9f0d2bbc_render,
  UserLandingPagevue_type_template_id_9f0d2bbc_staticRenderFns,
  false,
  UserLandingPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UserLandingPage = (UserLandingPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/Onboarding.vue?vue&type=template&id=49b410a6
var Onboardingvue_type_template_id_49b410a6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.page
  }, [_c('header', {
    class: _vm.$style.header
  }), !_vm.loading ? _c('UserProfilePage', {
    class: _vm.$style.content,
    attrs: {
      "user": _vm.user,
      "locationOptions": _vm.locationOptions,
      "proposedTags": _vm.proposedTags,
      "tagOptions": _vm.tagOptions,
      "isProfilePage": _vm.isProfilePage
    },
    on: {
      "save": _vm.submit,
      "searched-location": function ($event) {
        return _vm.$emit('searched-location', $event);
      },
      "logout": function ($event) {
        return _vm.$emit('logout');
      }
    }
  }, [_c('span', {
    class: _vm.$style.logo
  }, [_c('UserBubble', {
    attrs: {
      "src": _vm.logo,
      "transparent": true
    }
  })], 1), _c('StyledText', {
    attrs: {
      "variant": "heading26",
      "color": "color-secondary-light"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('StyledText', {
    attrs: {
      "variant": "body13"
    }
  }, [_vm._v(_vm._s(_vm.subTitle))])], 1) : _c('div', {
    class: [_vm.$style.page, _vm.$style.loading]
  }, [_c('Loading')], 1)], 1);
};
var Onboardingvue_type_template_id_49b410a6_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/Onboarding.vue?vue&type=script&lang=js


/* harmony default export */ var Onboardingvue_type_script_lang_js = ({
  name: 'OnBoardingPage',
  components: {
    UserBubble: UserBubble,
    Loading: Loading
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    logo: {
      type: String,
      required: false
    },
    locationOptions: {
      type: [Array, String],
      default: () => []
    },
    proposedTags: {
      type: Array,
      default: () => []
    },
    tagOptions: {
      type: Array,
      default: () => []
    },
    loading: Boolean,
    isProfilePage: Boolean
  },
  methods: {
    submit(data) {
      this.$emit('save', data);
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/Onboarding.vue?vue&type=script&lang=js
 /* harmony default export */ var EventOnboarding_Onboardingvue_type_script_lang_js = (Onboardingvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventOnboarding/Onboarding.vue?vue&type=style&index=0&id=49b410a6&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var Onboardingvue_type_style_index_0_id_49b410a6_prod_module_true_lang_scss = ({"page":"Onboarding_page_aIkWm","header":"Onboarding_header_BtMNp","content":"Onboarding_content_onm6i","logo":"Onboarding_logo_VMGHv","loading":"Onboarding_loading_sYY48"});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/Onboarding.vue?vue&type=style&index=0&id=49b410a6&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/Onboarding.vue



;




function Onboarding_injectStyles (context) {
  
  this["$style"] = (Onboardingvue_type_style_index_0_id_49b410a6_prod_module_true_lang_scss.locals || Onboardingvue_type_style_index_0_id_49b410a6_prod_module_true_lang_scss)

}

/* normalize component */

var Onboarding_component = normalizeComponent(
  EventOnboarding_Onboardingvue_type_script_lang_js,
  Onboardingvue_type_template_id_49b410a6_render,
  Onboardingvue_type_template_id_49b410a6_staticRenderFns,
  false,
  Onboarding_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Onboarding = (Onboarding_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/EventOnboardingPage.vue?vue&type=template&id=339192de
var EventOnboardingPagevue_type_template_id_339192de_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.page
  }, [!_vm.loading ? _c('div', {
    class: _vm.$style.body
  }, [_c('div', {
    class: [_vm.$style.left, _vm.$style.nonmobile]
  }, [_c('div', {
    class: _vm.$style.noteCard,
    attrs: {
      "data-branding-target": "onboarding-popup"
    }
  }, [_vm.logo ? _c('span', {
    class: _vm.$style.logo
  }, [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  })]) : _vm._e(), _c('StyledText', {
    attrs: {
      "variant": "heading16",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('StyledText', {
    attrs: {
      "variant": "body14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.subTitle) + " ")])], 1)]), !_vm.loading ? _c('ProfilePage', {
    class: _vm.$style.content,
    attrs: {
      "user": _vm.user,
      "locationOptions": _vm.locationOptions,
      "isSearchingLocation": _vm.isSearchingLocation,
      "proposedTags": _vm.proposedTags,
      "tagOptions": _vm.tagOptions,
      "buttonText": _vm.$options.$t(`Create Profile`),
      "pageTitle": _vm.$options.$t(`Register`),
      "cancel": false,
      "showDefaultTags": _vm.showDefaultTags
    },
    on: {
      "saveEdits": data => _vm.$emit('saveEdits', data),
      "searchLocation": function ($event) {
        return _vm.$emit('searchLocation', $event);
      }
    }
  }) : _vm._e()], 1) : _c('div', {
    class: _vm.$style.loading
  }, [_c('Loading')], 1)]);
};
var EventOnboardingPagevue_type_template_id_339192de_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/EventOnboardingPage.vue?vue&type=script&lang=js

/* harmony default export */ var EventOnboardingPagevue_type_script_lang_js = ({
  name: 'EventOnboardingPage',
  components: {
    Loading: Loading
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    logo: {
      type: String,
      default: ''
    },
    locationOptions: {
      type: [Array, String],
      default: () => []
    },
    proposedTags: {
      type: Array,
      default: () => []
    },
    tagOptions: {
      type: Array,
      default: () => []
    },
    isSearchingLocation: {
      type: Boolean,
      default: false
    },
    showDefaultTags: {
      type: Boolean,
      default: true
    },
    loading: Boolean
  }
});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/EventOnboardingPage.vue?vue&type=script&lang=js
 /* harmony default export */ var EventOnboarding_EventOnboardingPagevue_type_script_lang_js = (EventOnboardingPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventOnboarding/EventOnboardingPage.vue?vue&type=style&index=0&id=339192de&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var EventOnboardingPagevue_type_style_index_0_id_339192de_prod_module_true_lang_scss = ({"page":"EventOnboardingPage_page_eEWra","body":"EventOnboardingPage_body_cL6mB","left":"EventOnboardingPage_left_Eik5N","noteCard":"EventOnboardingPage_noteCard_UdqiL","content":"EventOnboardingPage_content_Uj2TU","logo":"EventOnboardingPage_logo_WWetM","bottom":"EventOnboardingPage_bottom_gbFuU","loading":"EventOnboardingPage_loading_PgTPj","nonmobile":"EventOnboardingPage_nonmobile_IA08y"});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/EventOnboardingPage.vue?vue&type=style&index=0&id=339192de&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/EventOnboardingPage.vue



;




function EventOnboardingPage_injectStyles (context) {
  
  this["$style"] = (EventOnboardingPagevue_type_style_index_0_id_339192de_prod_module_true_lang_scss.locals || EventOnboardingPagevue_type_style_index_0_id_339192de_prod_module_true_lang_scss)

}

/* normalize component */

var EventOnboardingPage_component = normalizeComponent(
  EventOnboarding_EventOnboardingPagevue_type_script_lang_js,
  EventOnboardingPagevue_type_template_id_339192de_render,
  EventOnboardingPagevue_type_template_id_339192de_staticRenderFns,
  false,
  EventOnboardingPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var EventOnboardingPage = (EventOnboardingPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/Profile.vue?vue&type=template&id=e9993cce
var Profilevue_type_template_id_e9993cce_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ValidationObserver', {
    attrs: {
      "slim": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        handleSubmit
      }) {
        return [_c('form', {
          class: _vm.$style.content,
          on: {
            "submit": function ($event) {
              $event.preventDefault();
              return handleSubmit(_vm.submit);
            }
          }
        }, [_c('ValidationProvider', {
          attrs: {
            "name": "profile picture",
            "slim": "",
            "rules": `denySvg|${_vm.imageRules}`
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('ProfilePicture', {
                attrs: {
                  "user": _vm.userData
                },
                model: {
                  value: _vm.userData.image,
                  callback: function ($$v) {
                    _vm.$set(_vm.userData, "image", $$v);
                  },
                  expression: "userData.image"
                }
              }), _c('StyledText', {
                class: _vm.$style.error,
                attrs: {
                  "variant": "body13",
                  "color": "color-secondary-light"
                }
              }, [_vm._v(" " + _vm._s(errors[0]) + " ")])];
            }
          }], null, true)
        }), _c('div', {
          class: _vm.$style.form
        }, [_c('ValidationProvider', {
          attrs: {
            "name": "linkedin url",
            "rules": "url|linkedInUrl",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleInput', {
                attrs: {
                  "type": "text",
                  "error": errors[0]
                },
                model: {
                  value: _vm.userData.linkedin_url,
                  callback: function ($$v) {
                    _vm.$set(_vm.userData, "linkedin_url", $$v);
                  },
                  expression: "userData.linkedin_url"
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('LinkedIn')) + " ")])];
            }
          }], null, true)
        }), _c('div', {
          class: _vm.$style.name_field
        }, [_c('div', {
          class: _vm.$style.name_slot
        }, [_c('ValidationProvider', {
          attrs: {
            "name": "first_name",
            "rules": "required",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleInput', {
                attrs: {
                  "type": "text",
                  "error": errors[0]
                },
                model: {
                  value: _vm.userData.first_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.userData, "first_name", $$v);
                  },
                  expression: "userData.first_name"
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('First Name')) + " ")])];
            }
          }], null, true)
        })], 1), _c('div', {
          class: _vm.$style.name_slot
        }, [_c('ValidationProvider', {
          attrs: {
            "name": "last_name",
            "rules": "required",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleInput', {
                attrs: {
                  "type": "text",
                  "error": errors[0]
                },
                model: {
                  value: _vm.userData.last_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.userData, "last_name", $$v);
                  },
                  expression: "userData.last_name"
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('Last Name')) + " ")])];
            }
          }], null, true)
        })], 1)]), _c('ValidationProvider', {
          attrs: {
            "name": "email address",
            "rules": "required|email",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleInput', {
                attrs: {
                  "value": _vm.userData.email,
                  "type": "email",
                  "error": errors[0],
                  "disabled": _vm.userData.display_email
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('Email')) + " ")])];
            }
          }], null, true)
        }), _c('ValidationProvider', {
          attrs: {
            "name": "company",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleInput', {
                attrs: {
                  "type": "text",
                  "error": errors[0]
                },
                model: {
                  value: _vm.userData.company,
                  callback: function ($$v) {
                    _vm.$set(_vm.userData, "company", $$v);
                  },
                  expression: "userData.company"
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('Company')) + " ")])];
            }
          }], null, true)
        }), _c('ValidationProvider', {
          attrs: {
            "name": "title",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleInput', {
                attrs: {
                  "type": "text",
                  "error": errors[0]
                },
                model: {
                  value: _vm.userData.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.userData, "title", $$v);
                  },
                  expression: "userData.title"
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('Title')) + " ")])];
            }
          }], null, true)
        }), _c('SelectInput', {
          on: {
            "input": function ($event) {
              return _vm.$emit('searchLocation', $event);
            }
          },
          model: {
            value: _vm.location,
            callback: function ($$v) {
              _vm.location = $$v;
            },
            expression: "location"
          }
        }, [_c('span', {
          attrs: {
            "slot": "label"
          },
          slot: "label"
        }, [_vm._v("Location")]), typeof _vm.locationOptions == 'string' ? _c('StyledText', {
          attrs: {
            "variant": "body13",
            "color": "color-variant-light-80"
          }
        }, [_vm._v(" " + _vm._s(_vm.locationOptions) + " ")]) : [_vm._l(_vm.locationOptions, function (location) {
          return _c('div', {
            key: location.place_id,
            staticClass: "option",
            on: {
              "click": ev => _vm.updateLocation(ev, location)
            }
          }, [_c('StyledText', {
            class: _vm.$style.label,
            attrs: {
              "variant": "body15"
            }
          }, [_vm._v(" " + _vm._s(location.location) + " ")])], 1);
        }), _vm.locationOptions.length === 0 ? _c('div', [_c('div', [_c('StyledText', {
          attrs: {
            "variant": "body15"
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('No matching locations found')) + " ")])], 1), _c('StyledText', {
          attrs: {
            "variant": "body13"
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('You can try searching for the location with another keyword')) + " ")])], 1) : _vm._e()]], 2), _vm.showTags ? _c('TagsInput', {
          attrs: {
            "proposed-tags": _vm.tagOptions
          },
          model: {
            value: _vm.userData.tags,
            callback: function ($$v) {
              _vm.$set(_vm.userData, "tags", $$v);
            },
            expression: "userData.tags"
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('Interest Tags')) + " "), _c('div', {
          class: _vm.$style.tags,
          attrs: {
            "slot": "after"
          },
          slot: "after"
        }, [_c('StyledText', {
          class: _vm.$style.tagLabel,
          attrs: {
            "variant": "heading13"
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('Pick your first tag')) + " ")]), _vm._l(_vm.proposedTags, function (tag, index) {
          return _c('Tag', {
            key: index,
            attrs: {
              "tag": tag,
              "showRemove": true
            },
            on: {
              "click": function ($event) {
                return _vm.addTag(tag);
              }
            }
          });
        })], 2)]) : _vm._e(), _c('div', {
          class: _vm.$style.button
        }, [_c('span', [_vm.isProfilePage ? _c('SimpleButton', {
          attrs: {
            "palette": "dark",
            "textAlign": "center",
            "type": "button",
            "loading": _vm.loggingOut,
            "state": _vm.logoutBtnState
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('logout');
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('Logout')) + " ")]) : _vm._e()], 1), _c('SimpleButton', {
          attrs: {
            "palette": "dark",
            "textAlign": "center"
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('Save')) + " ")])], 1)], 1), _c('div', {
          class: _vm.$style.messages
        }, [_vm._t("default")], 2)], 1)];
      }
    }], null, true)
  });
};
var Profilevue_type_template_id_e9993cce_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/EditProfilePicture.vue?vue&type=template&id=77a9a244
var EditProfilePicturevue_type_template_id_77a9a244_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.profilePicture
  }, [_vm.src ? _c('UserImage', {
    class: _vm.$style.image,
    attrs: {
      "src": _vm.src,
      "user": _vm.user,
      "forceHideHybrid": true
    }
  }, [_vm.src ? _c('IconButton', {
    class: _vm.$style.deleteButton,
    attrs: {
      "slot": "delete-button",
      "icon": "delete"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.deleteImage();
      }
    },
    slot: "delete-button"
  }) : _vm._e()], 1) : _c('div', {
    class: _vm.$style.emptyImage
  }, [_c('SvgIcon', {
    attrs: {
      "name": "empty-image",
      "color": "theme-secondary-color"
    }
  })], 1), _c('input', {
    ref: "input",
    class: _vm.$style.picker,
    attrs: {
      "type": "file",
      "name": "file",
      "accept": _vm.validImageFormats
    },
    on: {
      "change": _vm.updateImage
    }
  }), _c('PillButton', {
    class: _vm.$style.button,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.input.click();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.src ? _vm.$options.$t('change') : _vm.$options.$t('Upload')) + " ")]), _c('StyledText', {
    class: _vm.$style.text,
    attrs: {
      "variant": "body10",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('JPG, GIF OR PNG. MAX SIZE OF 5MB')) + " ")])], 1);
};
var EditProfilePicturevue_type_template_id_77a9a244_staticRenderFns = [];

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.31.0/node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(1295);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.31.0/node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(5611);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.31.0/node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(2166);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/EditProfilePicture.vue?vue&type=script&lang=js




/* harmony default export */ var EditProfilePicturevue_type_script_lang_js = ({
  components: {
    SvgIcon: SvgIcon
  },
  name: 'EditProfilePicture',
  data() {
    return {
      validImageFormats: ['apng', 'avif', 'gif', 'png', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'webp'].map(format => `image/${format}`).join(', ')
    };
  },
  computed: {
    src() {
      return this.value && typeof this.value != 'string' ? URL.createObjectURL(this.value) : this.value;
    }
  },
  props: {
    value: {
      type: [String, Object],
      //  File], <- This makes it fail in ssr as there is no File in node
      required: false
    },
    user: Object
  },
  methods: {
    updateImage({
      target
    }) {
      this.$emit('input', target.files[0]);
    },
    deleteImage() {
      if (this.$refs.input) {
        this.$refs.input.value = null;
      }
      this.$emit('input', null);
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/EditProfilePicture.vue?vue&type=script&lang=js
 /* harmony default export */ var EventOnboarding_EditProfilePicturevue_type_script_lang_js = (EditProfilePicturevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventOnboarding/EditProfilePicture.vue?vue&type=style&index=0&id=77a9a244&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var EditProfilePicturevue_type_style_index_0_id_77a9a244_prod_module_true_lang_scss = ({"profilePicture":"EditProfilePicture_profilePicture_oEH8S","emptyImage":"EditProfilePicture_emptyImage_PNx9F","button":"EditProfilePicture_button_qXpA2","text":"EditProfilePicture_text_m1Ijd","picker":"EditProfilePicture_picker_dY6jT","deleteButton":"EditProfilePicture_deleteButton_X7gic","image":"EditProfilePicture_image_ZjmLr"});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/EditProfilePicture.vue?vue&type=style&index=0&id=77a9a244&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/EditProfilePicture.vue



;




function EditProfilePicture_injectStyles (context) {
  
  this["$style"] = (EditProfilePicturevue_type_style_index_0_id_77a9a244_prod_module_true_lang_scss.locals || EditProfilePicturevue_type_style_index_0_id_77a9a244_prod_module_true_lang_scss)

}

/* normalize component */

var EditProfilePicture_component = normalizeComponent(
  EventOnboarding_EditProfilePicturevue_type_script_lang_js,
  EditProfilePicturevue_type_template_id_77a9a244_render,
  EditProfilePicturevue_type_template_id_77a9a244_staticRenderFns,
  false,
  EditProfilePicture_injectStyles,
  null,
  null
  
)

/* harmony default export */ var EditProfilePicture = (EditProfilePicture_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/SelectInput.vue?vue&type=template&id=60060325
var SelectInputvue_type_template_id_60060325_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    class: _vm.$style.select
  }, [_c('DropdownSetup', {
    attrs: {
      "open": _vm.open
    },
    on: {
      "close": function ($event) {
        return _vm.toggle(false);
      }
    }
  }, [_c('SimpleProfileInput', {
    attrs: {
      "slot": "toggler",
      "type": "text",
      "autocomplete": "false",
      "value": _vm.value,
      "active": !!_vm.value || _vm.editing
    },
    on: {
      "input": _vm.input,
      "focus": function ($event) {
        return _vm.toggle(true);
      },
      "blur": function ($event) {
        return _vm.toggle(false);
      }
    },
    slot: "toggler"
  }, [_vm._t("label")], 2), _c('div', {
    class: _vm.$style.options,
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_vm._t("default")], 2)], 1)], 1);
};
var SelectInputvue_type_template_id_60060325_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/SelectInput.vue?vue&type=script&lang=js


/* harmony default export */ var SelectInputvue_type_script_lang_js = ({
  name: 'SelectInput',
  components: {
    SimpleProfileInput: SimpleProfileInput
  },
  props: {
    value: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      open: false,
      editing: false
    };
  },
  methods: {
    toggle(value) {
      setTimeout(() => {
        this.open = value;
      }, 500);
      this.editing = value;
    },
    input: lodash_debounce_default()(function ($event) {
      this.$emit('input', $event);
    }, 300)
  }
});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/SelectInput.vue?vue&type=script&lang=js
 /* harmony default export */ var EventOnboarding_SelectInputvue_type_script_lang_js = (SelectInputvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventOnboarding/SelectInput.vue?vue&type=style&index=0&id=60060325&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SelectInputvue_type_style_index_0_id_60060325_prod_module_true_lang_scss = ({"options":"SelectInput_options_ZMUDb","select":"SelectInput_select_motu2"});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/SelectInput.vue?vue&type=style&index=0&id=60060325&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/SelectInput.vue



;




function SelectInput_injectStyles (context) {
  
  this["$style"] = (SelectInputvue_type_style_index_0_id_60060325_prod_module_true_lang_scss.locals || SelectInputvue_type_style_index_0_id_60060325_prod_module_true_lang_scss)

}

/* normalize component */

var SelectInput_component = normalizeComponent(
  EventOnboarding_SelectInputvue_type_script_lang_js,
  SelectInputvue_type_template_id_60060325_render,
  SelectInputvue_type_template_id_60060325_staticRenderFns,
  false,
  SelectInput_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SelectInput = (SelectInput_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/UserTagsInput.vue?vue&type=template&id=019a9e89
var UserTagsInputvue_type_template_id_019a9e89_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.input
  }, [_c('DropdownSetup', {
    class: _vm.$style.select,
    attrs: {
      "open": _vm.open
    },
    on: {
      "close": function ($event) {
        return _vm.toggle(false);
      }
    }
  }, [_c('template', {
    slot: "toggler"
  }, [_c('label', {
    class: _vm.$style.content,
    attrs: {
      "for": "interest-tags"
    }
  }, [_c('StyledText', {
    class: [_vm.open || _vm.value.length > 0 ? _vm.$style.floatLabel : _vm.$style.inActivelabel, _vm.$style.label],
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Add Interest tags')) + " ")]), _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.text,
      expression: "text",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "id": "interest-tags",
      "autocomplete": "false"
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.addTag.apply(null, arguments);
      },
      "focus": function ($event) {
        return _vm.toggle(true);
      },
      "blur": [function ($event) {
        return _vm.toggle(false);
      }, function ($event) {
        return _vm.$forceUpdate();
      }],
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.text = $event.target.value.trim();
      }
    }
  }, 'input', _vm.$attrs, false)), _c('div', {
    class: _vm.$style.tags
  }, _vm._l(_vm.value, function (tag, index) {
    return _c('Tag', {
      key: index,
      attrs: {
        "added": true,
        "tag": tag,
        "showRemove": true
      },
      on: {
        "remove": () => _vm.removeTag(tag)
      }
    });
  }), 1)], 1)]), _vm.$slots.default ? _c('div', {
    class: _vm.$style.options,
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.proposedTags, function (tag, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function ($event) {
          return _vm.add(tag);
        }
      }
    }, [_c('StyledText', {
      attrs: {
        "variant": "body15",
        "color": "primary-text-color"
      }
    }, [_vm._v(" #" + _vm._s(tag) + " ")])], 1);
  }), 0) : _vm._e()], 2), _c('div', [_vm._t("after")], 2)], 1);
};
var UserTagsInputvue_type_template_id_019a9e89_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/UserTagsInput.vue?vue&type=script&lang=js

/* harmony default export */ var UserTagsInputvue_type_script_lang_js = ({
  name: 'UserTagsInput',
  components: {
    Tag: Tag
  },
  data() {
    return {
      text: '',
      open: false
    };
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    proposedTags: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    add(tag) {
      this.$emit('input', [...new Set([...this.value, tag])]);
    },
    addTag() {
      if (this.text) {
        this.add(this.text);
        this.text = '';
      }
    },
    removeTag(tag) {
      this.$emit('input', this.value.filter(t => tag.toLowerCase() !== t.toLowerCase()));
    },
    toggle(value) {
      setTimeout(() => this.open = value, 100);
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/UserTagsInput.vue?vue&type=script&lang=js
 /* harmony default export */ var EventOnboarding_UserTagsInputvue_type_script_lang_js = (UserTagsInputvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventOnboarding/UserTagsInput.vue?vue&type=style&index=0&id=019a9e89&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var UserTagsInputvue_type_style_index_0_id_019a9e89_prod_module_true_lang_scss = ({"input":"UserTagsInput_input_XRyXv","select":"UserTagsInput_select_WzpJb","content":"UserTagsInput_content_oz5sa","label":"UserTagsInput_label_XJlos","inActivelabel":"UserTagsInput_inActivelabel_xIuMg","label-animation":"UserTagsInput_label-animation_IPu__","floatLabel":"UserTagsInput_floatLabel_nBsSQ","active-label-animation":"UserTagsInput_active-label-animation_egEzK","options":"UserTagsInput_options_jnKxi","tags":"UserTagsInput_tags_txr0Z"});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/UserTagsInput.vue?vue&type=style&index=0&id=019a9e89&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/UserTagsInput.vue



;




function UserTagsInput_injectStyles (context) {
  
  this["$style"] = (UserTagsInputvue_type_style_index_0_id_019a9e89_prod_module_true_lang_scss.locals || UserTagsInputvue_type_style_index_0_id_019a9e89_prod_module_true_lang_scss)

}

/* normalize component */

var UserTagsInput_component = normalizeComponent(
  EventOnboarding_UserTagsInputvue_type_script_lang_js,
  UserTagsInputvue_type_template_id_019a9e89_render,
  UserTagsInputvue_type_template_id_019a9e89_staticRenderFns,
  false,
  UserTagsInput_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UserTagsInput = (UserTagsInput_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/Profile.vue?vue&type=script&lang=js





/* harmony default export */ var Profilevue_type_script_lang_js = ({
  name: 'OnProfilePage',
  components: {
    ProfilePicture: EditProfilePicture,
    SimpleInput: SimpleInput,
    SelectInput: SelectInput,
    TagsInput: UserTagsInput,
    Tag: Tag
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    showTags: {
      type: Boolean,
      default: true
    },
    locationOptions: {
      type: [Array, String],
      default: () => []
    },
    proposedTags: {
      type: Array,
      default: () => []
    },
    tagOptions: {
      type: Array,
      default: () => []
    },
    isProfilePage: Boolean
  },
  watch: {
    locationOptions(newval) {
      if (newval.length === 0) {
        this.updateLocation(null, null);
      }
    },
    user(value) {
      this.userData = {
        ...this.userData,
        ...value
      };
      this.location = value.location?.location;
    }
  },
  data() {
    return {
      userData: {
        ...this.user
      },
      location: this.user?.location?.location || ''
    };
  },
  computed: {
    imageRules() {
      return this.userData.image && typeof this.userData.image != 'string' ? '|size:5120' : '';
    }
  },
  methods: {
    updateLocation(ev, location) {
      // eslint-disable-next-line
      console.log('Update location: ', location);
      if (ev) {
        ev.stopPropagation();
        ev.preventDefault();
      }
      this.userData = {
        ...this.userData,
        location
      };
      if (location != null) {
        this.location = location.location;
      }
    },
    submit() {
      const data = {
        ...this.userData,
        linkedin_url: validLinkedinUrl(this.userData.linkedin_url)
      };
      this.$emit('save', data);
      function validLinkedinUrl(url) {
        if (url) {
          url = url.toLowerCase();
          return url.startsWith('http') ? url : `https://${url}`;
        }
        return '';
      }
    },
    addTag(tag) {
      this.userData = {
        ...this.userData,
        tags: [...new Set([...(this.userData.tags || []), tag])]
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/Profile.vue?vue&type=script&lang=js
 /* harmony default export */ var EventOnboarding_Profilevue_type_script_lang_js = (Profilevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventOnboarding/Profile.vue?vue&type=style&index=0&id=e9993cce&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var Profilevue_type_style_index_0_id_e9993cce_prod_module_true_lang_scss = ({"content":"Profile_content_IQNRF","form":"Profile_form_HLouX","messages":"Profile_messages_zDvxx","button":"Profile_button_bFbev","tagLabel":"Profile_tagLabel_Z4LdA","tags":"Profile_tags_Ey59h","error":"Profile_error_nJxGQ","name_field":"Profile_name_field_tJfvF","name_slot":"Profile_name_slot_SaVbr"});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/Profile.vue?vue&type=style&index=0&id=e9993cce&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/Profile.vue



;




function Profile_injectStyles (context) {
  
  this["$style"] = (Profilevue_type_style_index_0_id_e9993cce_prod_module_true_lang_scss.locals || Profilevue_type_style_index_0_id_e9993cce_prod_module_true_lang_scss)

}

/* normalize component */

var Profile_component = normalizeComponent(
  EventOnboarding_Profilevue_type_script_lang_js,
  Profilevue_type_template_id_e9993cce_render,
  Profilevue_type_template_id_e9993cce_staticRenderFns,
  false,
  Profile_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Profile = (Profile_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/ProfilePage.vue?vue&type=template&id=64eb18de
var ProfilePagevue_type_template_id_64eb18de_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ValidationObserver', {
    attrs: {
      "slim": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        handleSubmit
      }) {
        return [_c('form', {
          class: [_vm.isMobile ? _vm.$style.MobileContent : _vm.$style.desktopContent, _vm.$style.content],
          attrs: {
            "data-branding-target": "profile-page"
          },
          on: {
            "submit": function ($event) {
              $event.preventDefault();
              return handleSubmit(_vm.submit);
            }
          }
        }, [_c('div', {
          class: _vm.$style.header
        }, [_vm.cancel ? _c('SvgIcon', {
          attrs: {
            "name": "cross",
            "color": "primary-text-color",
            "size": "regular"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('hide');
            }
          }
        }) : _vm._e(), _c('StyledText', {
          class: _vm.$style.name,
          attrs: {
            "variant": "body15",
            "color": "primary-text-color",
            "align": "center"
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('Profile')) + " ")])], 1), _c('ValidationProvider', {
          attrs: {
            "name": "profile picture",
            "slim": "",
            "rules": `denySvg${_vm.imageRules}`
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('ProfilePicture', {
                attrs: {
                  "user": _vm.userData
                },
                model: {
                  value: _vm.userData.image,
                  callback: function ($$v) {
                    _vm.$set(_vm.userData, "image", $$v);
                  },
                  expression: "userData.image"
                }
              }), _c('StyledText', {
                class: _vm.$style.pictureError,
                attrs: {
                  "variant": "body13",
                  "color": "color-highlight"
                }
              }, [_vm._v(" " + _vm._s(errors[0]) + " ")])];
            }
          }], null, true)
        }), _c('div', {
          class: [_vm.$style.form, _vm.isMobile && _vm.$style.mobileForm]
        }, [_c('div', {
          class: _vm.$style.name_field
        }, [_c('div', {
          class: _vm.$style.name_slot
        }, [_c('ValidationProvider', {
          attrs: {
            "name": "first_name",
            "rules": "required",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleProfileInput', {
                attrs: {
                  "type": "text",
                  "error": errors[0],
                  "active": !!_vm.userData.first_name || _vm.editing.first_name
                },
                on: {
                  "focus": function ($event) {
                    return _vm.startEditing('first_name');
                  },
                  "blur": function ($event) {
                    return _vm.stopEditing('first_name');
                  }
                },
                model: {
                  value: _vm.userData.first_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.userData, "first_name", $$v);
                  },
                  expression: "userData.first_name"
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('First Name')) + " ")])];
            }
          }], null, true)
        })], 1), _c('div', {
          class: _vm.$style.name_slot
        }, [_c('ValidationProvider', {
          attrs: {
            "name": "last_name",
            "rules": "required",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleProfileInput', {
                attrs: {
                  "type": "text",
                  "error": errors[0],
                  "active": !!_vm.userData.last_name || _vm.editing.last_name
                },
                on: {
                  "focus": function ($event) {
                    return _vm.startEditing('last_name');
                  },
                  "blur": function ($event) {
                    return _vm.stopEditing('last_name');
                  }
                },
                model: {
                  value: _vm.userData.last_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.userData, "last_name", $$v);
                  },
                  expression: "userData.last_name"
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('Last Name')) + " ")])];
            }
          }], null, true)
        })], 1)]), _c('ValidationProvider', {
          attrs: {
            "name": "email address",
            "rules": "required|email",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleProfileInput', {
                attrs: {
                  "value": _vm.userData.email,
                  "type": "email",
                  "error": errors[0],
                  "disabled": !!_vm.userData.email,
                  "active": !!_vm.userData.email || _vm.editing.display_email
                },
                on: {
                  "focus": function ($event) {
                    return _vm.startEditing('email');
                  },
                  "blur": function ($event) {
                    return _vm.stopEditing('email');
                  }
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('Email')) + " ")])];
            }
          }], null, true)
        }), _c('ValidationProvider', {
          attrs: {
            "name": "title",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleProfileInput', {
                attrs: {
                  "type": "text",
                  "error": errors[0],
                  "active": !!_vm.userData.title || _vm.editing.title
                },
                on: {
                  "focus": function ($event) {
                    return _vm.startEditing('title');
                  },
                  "blur": function ($event) {
                    return _vm.stopEditing('title');
                  }
                },
                model: {
                  value: _vm.userData.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.userData, "title", $$v);
                  },
                  expression: "userData.title"
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('Title')) + " ")])];
            }
          }], null, true)
        }), _c('div', {
          class: _vm.$style.name_field
        }, [_c('div', {
          class: _vm.$style.name_slot
        }, [_c('ValidationProvider', {
          attrs: {
            "name": "company",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleProfileInput', {
                attrs: {
                  "type": "text",
                  "error": errors[0],
                  "active": !!_vm.userData.company || _vm.editing.company
                },
                on: {
                  "focus": function ($event) {
                    return _vm.startEditing('company');
                  },
                  "blur": function ($event) {
                    return _vm.stopEditing('company');
                  }
                },
                model: {
                  value: _vm.userData.company,
                  callback: function ($$v) {
                    _vm.$set(_vm.userData, "company", $$v);
                  },
                  expression: "userData.company"
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('Company')) + " ")])];
            }
          }], null, true)
        })], 1), _c('div', {
          class: _vm.$style.name_slot
        }, [_c('SelectInput', {
          on: {
            "input": function ($event) {
              return _vm.$emit('searchLocation', $event);
            }
          },
          model: {
            value: _vm.location,
            callback: function ($$v) {
              _vm.location = $$v;
            },
            expression: "location"
          }
        }, [_c('span', {
          attrs: {
            "slot": "label"
          },
          slot: "label"
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('Location')) + " ")]), typeof _vm.locationOptions == 'string' ? _c('StyledText', {
          attrs: {
            "variant": "body13",
            "color": "primary-text-color"
          }
        }, [_vm._v(" " + _vm._s(_vm.isSearchingLocation ? _vm.$options.$t('Searching...') : _vm.locationOptions) + " ")]) : [_vm._l(_vm.locationOptions, function (location) {
          return _c('div', {
            key: location.place_id,
            staticClass: "option",
            on: {
              "click": ev => _vm.updateLocation(ev, location)
            }
          }, [_c('StyledText', {
            class: _vm.$style.label,
            attrs: {
              "variant": "body15"
            }
          }, [_vm._v(" " + _vm._s(location.location) + " ")])], 1);
        }), _vm.locationOptions.length === 0 ? _c('div', [_c('div', [_c('StyledText', {
          attrs: {
            "variant": "body15",
            "color": "primary-text-color"
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('No matching locations found')) + " ")])], 1), _c('StyledText', {
          attrs: {
            "variant": "body13",
            "color": "primary-text-color"
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('You can try searching for the location with another keyword')) + " ")])], 1) : _vm._e()]], 2)], 1)]), _c('ValidationProvider', {
          attrs: {
            "name": "linkedin url",
            "rules": "validateLinkedInUrl|linkedInUrl",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleProfileInput', {
                attrs: {
                  "linkInput": true,
                  "baseUrl": _vm.staticLinkedin,
                  "error": errors[0],
                  "active": !!_vm.userData.linkedin_url || _vm.editing.linkedin_url
                },
                on: {
                  "focus": function ($event) {
                    return _vm.startEditing('linkedin_url');
                  },
                  "blur": function ($event) {
                    return _vm.stopEditing('linkedin_url');
                  }
                },
                model: {
                  value: _vm.shortenedLinkedin,
                  callback: function ($$v) {
                    _vm.shortenedLinkedin = $$v;
                  },
                  expression: "shortenedLinkedin"
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('LinkedIn')) + " ")])];
            }
          }], null, true)
        }), _c('ValidationProvider', {
          attrs: {
            "name": "twitter url",
            "rules": "validateTwitterUrl|twitterUrl",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              errors
            }) {
              return [_c('SimpleProfileInput', {
                attrs: {
                  "linkInput": true,
                  "baseUrl": _vm.staticTwitter,
                  "error": errors[0],
                  "active": !!_vm.userData.twitter_url || _vm.editing.twitter_url
                },
                on: {
                  "focus": function ($event) {
                    return _vm.startEditing('twitter_url');
                  },
                  "blur": function ($event) {
                    return _vm.stopEditing('twitter_url');
                  }
                },
                model: {
                  value: _vm.shortenedTwitter,
                  callback: function ($$v) {
                    _vm.shortenedTwitter = $$v;
                  },
                  expression: "shortenedTwitter"
                }
              }, [_vm._v(" " + _vm._s(_vm.$options.$t('Twitter')) + " ")])];
            }
          }], null, true)
        }), _vm.showTags ? _c('TagsInput', {
          attrs: {
            "proposedTags": _vm.tagOptions
          },
          model: {
            value: _vm.userData.tags,
            callback: function ($$v) {
              _vm.$set(_vm.userData, "tags", $$v);
            },
            expression: "userData.tags"
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('Interest Tags')) + " "), _vm.showDefaultTags ? _c('div', {
          class: _vm.$style.tags,
          attrs: {
            "slot": "after"
          },
          slot: "after"
        }, [_c('StyledText', {
          class: _vm.$style.tagLabel,
          attrs: {
            "variant": "body14",
            "color": "primary-text-color"
          }
        }, [_vm._v(" " + _vm._s(_vm.$options.$t('Select Your First Tags')) + " ")]), _vm._l(_vm.proposedTags, function (tag, index) {
          return _c('Tag', {
            key: index,
            attrs: {
              "tag": tag,
              "showRemove": true
            },
            on: {
              "click": function ($event) {
                return _vm.addTag(tag);
              }
            }
          });
        })], 2) : _vm._e()]) : _vm._e(), _c('div', {
          class: _vm.$style.buttonContainer
        }, [_c('PillButton', {
          class: _vm.$style.button,
          attrs: {
            "loading": _vm.loading,
            "disabled": _vm.loading,
            "uppercase": true
          }
        }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")])], 1)], 1), _c('div', {
          class: _vm.$style.messages
        }, [_vm._t("default")], 2)], 1)];
      }
    }], null, true)
  });
};
var ProfilePagevue_type_template_id_64eb18de_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/utils/url.js
const re_weburl = new RegExp('^' +
// protocol identifier (optional)
// short syntax // still required
'(?:(?:(?:https?|ftp):\\/\\/)?)' +
// user:pass BasicAuth (optional)
'(?:\\S+(?::\\S*)?@)?' + '(?:' +
// IP address exclusion
// private & local networks
'(?!(?:10|127)(?:\\.\\d{1,3}){3})' + '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' + '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
// IP address dotted notation octets
// excludes loopback network 0.0.0.0
// excludes reserved space >= 224.0.0.0
// excludes network & broadcast addresses
// (first & last IP address of each class)
'(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' + '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' + '|' +
// host & domain names, may end with dot
// can be replaced by a shortest alternative
// (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
'(?:' + '(?:' + '[a-z0-9\\u00a1-\\uffff]' + '[a-z0-9\\u00a1-\\uffff_-]{0,62}' + ')?' + '[a-z0-9\\u00a1-\\uffff]\\.' + ')+' +
// TLD identifier name, may end with dot
'(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' + ')' +
// port number (optional)
'(?::\\d{2,5})?' +
// resource path (optional)
'(?:[/?#]\\S*)?' + '$', 'i');
const isUrl = url => re_weburl.test(url);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventOnboarding/ProfilePage.vue?vue&type=script&lang=js






/* harmony default export */ var ProfilePagevue_type_script_lang_js = ({
  name: 'ProfilePage',
  components: {
    ProfilePicture: EditProfilePicture,
    SimpleProfileInput: SimpleProfileInput,
    SelectInput: SelectInput,
    TagsInput: UserTagsInput,
    Tag: Tag
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    showTags: {
      type: Boolean,
      default: true
    },
    locationOptions: {
      type: [Array, String],
      default: () => []
    },
    proposedTags: {
      type: Array,
      default: () => []
    },
    tagOptions: {
      type: Array,
      default: () => []
    },
    icon: String,
    pageTitle: String,
    cancel: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String
    },
    isSearchingLocation: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showDefaultTags: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    locationOptions(newval) {
      if (newval.length === 0) {
        this.updateLocation(null, null);
      }
    },
    user(value) {
      this.userData = {
        ...this.userData,
        ...value
      };
      this.location = value.location?.location;
    }
  },
  data() {
    return {
      isMobile: false,
      userData: {
        ...this.user
      },
      location: this.user?.location?.location || '',
      staticLinkedin: 'https://www.linkedin.com/in/',
      staticTwitter: 'https://www.twitter.com/',
      shortenedLinkedin: '',
      shortenedTwitter: '',
      editing: {
        first_name: false,
        last_name: false,
        email: false,
        linkedin_url: false,
        twitter_url: false,
        company: false,
        title: false,
        display_email: false
      }
    };
  },
  computed: {
    imageRules() {
      return this.userData.image && typeof this.userData.image != 'string' ? '|size:5120' : '';
    }
  },
  mounted() {
    if (this.userData.linkedin_url) {
      this.shortenLinkedinUrl(this.userData.linkedin_url);
    }
    if (this.userData.twitter_url) {
      this.shortenTwitterUrl(this.userData.twitter_url);
    }
    this.isMobile = window.mobileCheck && window.mobileCheck();
  },
  methods: {
    updateLocation(ev, location) {
      // eslint-disable-next-line
      console.log('Updating location: ', location);
      if (ev) {
        ev.stopPropagation();
        ev.preventDefault();
      }
      this.userData = {
        ...this.userData,
        location
      };
      if (location != null) {
        this.location = location.location;
      }
    },
    shortenLinkedinUrl(linkedinUrl) {
      const r = /^(http(s)?:\/\/)?(www\.)?linkedin\.com\/(pub|in|profile)\//;
      if (!linkedinUrl || linkedinUrl === ' ' || !isUrl(linkedinUrl)) {
        return;
      }
      this.staticLinkedin = linkedinUrl.match(r)?.[0];
      this.shortenedLinkedin = linkedinUrl.slice(linkedinUrl.match(r)[0].length);
    },
    shortenTwitterUrl(twitterUrl) {
      const r = /^(http(s)?:\/\/)?(www\.)?twitter\.com\//;
      if (!twitterUrl || twitterUrl === ' ' || !isUrl(twitterUrl)) {
        return;
      }
      this.staticTwitter = twitterUrl.match(r)?.[0];
      this.shortenedTwitter = twitterUrl.slice(twitterUrl.match(r)[0].length);
    },
    submit() {
      const data = {
        ...this.userData,
        linkedin_url: this.shortenedLinkedin && validLinkedinUrl(this.staticLinkedin + this.shortenedLinkedin),
        twitter_url: this.shortenedTwitter && validLinkedinUrl(this.staticTwitter + this.shortenedTwitter)
      };
      function validLinkedinUrl(url) {
        if (url) {
          url = url.toLowerCase();
          return url.startsWith('http') ? url : `https://${url}`;
        }
        return '';
      }
      this.$emit('saveEdits', data);
    },
    addTag(tag) {
      this.userData = {
        ...this.userData,
        tags: [...new Set([...(this.userData.tags || []), tag])]
      };
    },
    startEditing(name) {
      this.editing[name] = true;
    },
    stopEditing(name) {
      if (name === 'twitter_url') {
        this.shortenTwitterUrl(this.shortenedTwitter);
      } else if (name === 'linkedin_url') {
        this.shortenLinkedinUrl(this.shortenedLinkedin);
      } else {
        this.editing[name] = false;
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/ProfilePage.vue?vue&type=script&lang=js
 /* harmony default export */ var EventOnboarding_ProfilePagevue_type_script_lang_js = (ProfilePagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventOnboarding/ProfilePage.vue?vue&type=style&index=0&id=64eb18de&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ProfilePagevue_type_style_index_0_id_64eb18de_prod_module_true_lang_scss = ({"content":"ProfilePage_content_h0lY6","desktopContent":"ProfilePage_desktopContent_ySeHx","MobileContent":"ProfilePage_MobileContent_VABaN","form":"ProfilePage_form_IFAUH","mobileForm":"ProfilePage_mobileForm_tDuMN","messages":"ProfilePage_messages_XvmyA","inputs":"ProfilePage_inputs_NKXJ5","buttonContainer":"ProfilePage_buttonContainer_GwA5f","tagLabel":"ProfilePage_tagLabel_SMl8H","tags":"ProfilePage_tags_BVgxY","error":"ProfilePage_error_erG0Y","pictureError":"ProfilePage_pictureError_gsnn6","name_field":"ProfilePage_name_field_veTm1","name_slot":"ProfilePage_name_slot_NVgfF","header":"ProfilePage_header_YzSmN","name":"ProfilePage_name_du7Qb"});
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/ProfilePage.vue?vue&type=style&index=0&id=64eb18de&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventOnboarding/ProfilePage.vue



;




function ProfilePage_injectStyles (context) {
  
  this["$style"] = (ProfilePagevue_type_style_index_0_id_64eb18de_prod_module_true_lang_scss.locals || ProfilePagevue_type_style_index_0_id_64eb18de_prod_module_true_lang_scss)

}

/* normalize component */

var ProfilePage_component = normalizeComponent(
  EventOnboarding_ProfilePagevue_type_script_lang_js,
  ProfilePagevue_type_template_id_64eb18de_render,
  ProfilePagevue_type_template_id_64eb18de_staticRenderFns,
  false,
  ProfilePage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ProfilePage = (ProfilePage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventPage.vue?vue&type=template&id=0b881368
var EventPagevue_type_template_id_0b881368_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.isOrgAttendeeMode && _vm.$style.attendeeFrameBorder, _vm.isInPerson && _vm.$style.inPerson, _vm.isStage && _vm.$style.isStage],
    attrs: {
      "data-branding-target": "event-page"
    }
  }, [_c('nav', {
    class: _vm.$style.skipToRegisterLink
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#mainStageNavigation"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Skip to Main Navigation')) + " ")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#stageSidebar"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Skip to Chat')) + " ")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#stageControlBar"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Skip to Meeting Controls')) + " ")])])])]), _vm.isOrgAttendeeMode ? _c('div', {
    class: _vm.$style.attendeeModeFrameContainer
  }, [_c('div', {
    class: [_vm.$style.attendeeModeNotch, _vm.$style.attendeeModeNotchLeft]
  }), _c('div', {
    class: [_vm.$style.attendeeModeNotch, _vm.$style.attendeeModeNotchRight]
  }), _c('StyledText', {
    class: _vm.$style.text
  }, [_vm._v(" " + _vm._s(_vm.$t('ATTENDEE MODE')) + " ")])], 1) : _vm._e(), _vm.eventTickerData && _vm.eventTickerData.show_ticker ? _c('Ticker', {
    attrs: {
      "tickerId": "eventTicker",
      "tickerData": _vm.eventTickerData,
      "isEventOrganizer": _vm.isEventOrganizer
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('stopPulishingEventTicker');
      }
    }
  }) : _vm._e(), !_vm.hideNavbar && !_vm.showChatOnMobile ? _c('NavigationBar', _vm._b({
    attrs: {
      "status": _vm.status,
      "showChatOnMobile": _vm.showChatOnMobile,
      "profileLinks": _vm.profileLinks,
      "viewAsAttendee": _vm.viewAsAttendee,
      "forceShowViewAsAttendeeTooltip": _vm.forceShowViewAsAttendeeTooltip,
      "attendeeTooltipMessage": _vm.attendeeTooltipMessage,
      "showGoldBotRatingButton": _vm.showGoldBotRatingButton,
      "showGoldBotRatingButtonTransition": _vm.showGoldBotRatingButtonTransition,
      "internalSessionCheckin": _vm.internalSessionCheckin,
      "isInPerson": _vm.isInPerson
    },
    on: {
      "join": item => _vm.$emit('join', item),
      "openBadge": function ($event) {
        return _vm.$emit('openBadge');
      },
      "openGoldcastBot": function ($event) {
        return _vm.$emit('openGoldcastBot');
      },
      "onDemoLink": function ($event) {
        return _vm.$emit('onDemoLink', $event);
      },
      "menuclick": function ($event) {
        return _vm.$emit('onSubmenuClick', $event);
      },
      "userDropDownToggle": function ($event) {
        return _vm.$emit('userDropDownToggle', $event);
      }
    }
  }, 'NavigationBar', _vm.submenubar, false)) : _vm._e(), _c('div', {
    class: _vm.$style.content_wrapper
  }, [_c('div', {
    class: [_vm.$style.page_section, _vm.recordingMode && _vm.$style['recordingMode']],
    attrs: {
      "id": "eventPageContainer"
    }
  }, [_vm._t("default", null, {
    "default": ""
  }), _vm.showNoAutoRedirectionToast ? _c('NotAutoRedirectToast', _vm._b({
    attrs: {
      "logo": _vm.submenubar.eventLogo
    },
    on: {
      "join": function ($event) {
        return _vm.$emit('joinSession', _vm.transition);
      }
    }
  }, 'NotAutoRedirectToast', _vm.nonAutoRedirectTransition, false)) : _vm._e(), _vm.transition.active && !_vm.useNewRedirections ? _c('TransitionToast', _vm._b({
    on: {
      "cancel": function ($event) {
        return _vm.$emit('canceledToast', _vm.transition);
      },
      "join": function ($event) {
        return _vm.$emit('joinSession', _vm.transition);
      }
    }
  }, 'TransitionToast', _vm.transition, false)) : _vm._e()], 2), !_vm.hideNavbar ? _c('MobileChatToggle', {
    attrs: {
      "showChatOnMobile": _vm.showChatOnMobile
    },
    on: {
      "toggle": function ($event) {
        return _vm.$emit('toggleMobileChat');
      }
    }
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSidebar,
      expression: "showSidebar"
    }],
    class: [_vm.$style.chat_section, _vm.showChatOnMobile && _vm.$style.slideIn],
    attrs: {
      "data-branding-target": "sidebar"
    }
  }, [_c('div', {
    class: _vm.$style.bg,
    attrs: {
      "data-branding-target": "sidebar-target"
    }
  }), _c('div', [_vm._t("sidebar")], 2)])], 1)], 1);
};
var EventPagevue_type_template_id_0b881368_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/NotAutoRedirectToast.vue?vue&type=template&id=6f1fb1a7
var NotAutoRedirectToastvue_type_template_id_6f1fb1a7_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.expanded]: _vm.expanded,
      [_vm.$style.inRoom]: _vm.inRoom
    }
  }, [_vm.expanded ? _c('div', {
    class: _vm.$style.modal
  }, [_c('div', {
    class: _vm.$style.minimize
  }, [_c('IconButton', {
    attrs: {
      "icon": "exit-fullscreen",
      "variant": "secondary",
      "alt": !_vm.inRoom
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggle.apply(null, arguments);
      }
    }
  })], 1), _vm.logo ? _c('img', {
    class: _vm.$style.logo,
    attrs: {
      "src": _vm.logo
    }
  }) : _vm._e(), _c('StyledText', {
    attrs: {
      "color": "inherit",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Next Session is Starting')) + " ")]), _c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "color": "inherit",
      "variant": "body15"
    }
  }, [_vm._v(" " + _vm._s(_vm.item) + " ")]), _c('StyledText', {
    attrs: {
      "color": "inherit",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.time) + " ")]), _c('OutlinedButton', {
    class: _vm.$style.button,
    attrs: {
      "variant": "secondary",
      "alt": !_vm.inRoom
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('join');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Go to Next Session')) + " ")]), _c('StyledText', {
    class: _vm.$style.stay,
    attrs: {
      "color": "inherit",
      "variant": "body13"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('I’d like to stay')) + " ")])], 1) : _c('PillButton', {
    attrs: {
      "size": "x-small",
      "variant": "secondary",
      "alt": _vm.inRoom,
      "uppercase": "",
      "bold": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('join');
      }
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "fullscreen",
      "color": !_vm.inRoom ? 'secondary-text-color' : 'theme-secondary-color'
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggle.apply(null, arguments);
      }
    }
  }), _c('span', {
    class: _vm.$style.line
  }), _vm._v(" " + _vm._s(_vm.$t('Go to Next Session')) + " ")], 1)], 1);
};
var NotAutoRedirectToastvue_type_template_id_6f1fb1a7_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/NotAutoRedirectToast.vue?vue&type=script&lang=js
/* harmony default export */ var NotAutoRedirectToastvue_type_script_lang_js = ({
  name: 'TransitionToast',
  props: {
    time: String,
    item: String,
    logo: String,
    inRoom: Boolean
  },
  data() {
    return {
      expanded: true
    };
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/NotAutoRedirectToast.vue?vue&type=script&lang=js
 /* harmony default export */ var components_NotAutoRedirectToastvue_type_script_lang_js = (NotAutoRedirectToastvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/NotAutoRedirectToast.vue?vue&type=style&index=0&id=6f1fb1a7&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var NotAutoRedirectToastvue_type_style_index_0_id_6f1fb1a7_prod_module_true_lang_scss = ({"root":"NotAutoRedirectToast_root_dXQL8","expanded":"NotAutoRedirectToast_expanded_xwX9O","line":"NotAutoRedirectToast_line_Yz0AJ","modal":"NotAutoRedirectToast_modal_o5WWZ","minimize":"NotAutoRedirectToast_minimize_RMJFs","title":"NotAutoRedirectToast_title_AzYAx","button":"NotAutoRedirectToast_button_hXfrG","stay":"NotAutoRedirectToast_stay_Avu3r","inRoom":"NotAutoRedirectToast_inRoom_WJzJN","logo":"NotAutoRedirectToast_logo_N5HO6"});
;// CONCATENATED MODULE: ./src/components/NotAutoRedirectToast.vue?vue&type=style&index=0&id=6f1fb1a7&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/components/NotAutoRedirectToast.vue



;




function NotAutoRedirectToast_injectStyles (context) {
  
  this["$style"] = (NotAutoRedirectToastvue_type_style_index_0_id_6f1fb1a7_prod_module_true_lang_scss.locals || NotAutoRedirectToastvue_type_style_index_0_id_6f1fb1a7_prod_module_true_lang_scss)

}

/* normalize component */

var NotAutoRedirectToast_component = normalizeComponent(
  components_NotAutoRedirectToastvue_type_script_lang_js,
  NotAutoRedirectToastvue_type_template_id_6f1fb1a7_render,
  NotAutoRedirectToastvue_type_template_id_6f1fb1a7_staticRenderFns,
  false,
  NotAutoRedirectToast_injectStyles,
  null,
  null
  
)

/* harmony default export */ var NotAutoRedirectToast = (NotAutoRedirectToast_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventPage.vue?vue&type=script&lang=js



/* harmony default export */ var EventPagevue_type_script_lang_js = ({
  components: {
    MobileChatToggle: MobileChatToggle,
    NotAutoRedirectToast: NotAutoRedirectToast
  },
  name: 'EventPage',
  props: {
    showSidebar: {
      type: Boolean,
      default: true
    },
    isOrgAttendeeMode: {
      type: Boolean,
      default: false
    },
    isEventOrganizer: {
      type: Boolean,
      default: false
    },
    submenubar: {
      type: Object,
      required: true
    },
    profileLinks: {
      type: Object,
      required: true
    },
    transition: {
      type: Object,
      default: () => ({
        active: false,
        canCancel: true
      })
    },
    nonAutoRedirectTransition: {
      type: Object,
      default: null
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    eventTickerData: {
      type: Object,
      default: () => {}
    },
    status: {
      type: String,
      default: 'offline'
    },
    recordingMode: {
      type: Boolean,
      default: false
    },
    showChatOnMobile: {
      type: Boolean,
      default: false
    },
    hideNavbar: {
      type: Boolean,
      default: false
    },
    isInPerson: {
      type: Boolean,
      default: false
    },
    viewAsAttendee: {
      type: Boolean,
      default: false
    },
    forceShowViewAsAttendeeTooltip: {
      type: Boolean,
      default: false
    },
    attendeeTooltipMessage: String,
    isStage: {
      type: Boolean,
      default: false
    },
    showGoldBotRatingButton: {
      type: Boolean,
      default: false
    },
    showGoldBotRatingButtonTransition: {
      type: Boolean,
      default: false
    },
    internalSessionCheckin: {
      type: Boolean,
      default: false
    },
    showNoAutoRedirectionToast: {
      type: Boolean,
      default: false
    },
    useNewRedirections: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      links: links
    };
  }
});
;// CONCATENATED MODULE: ./src/examples/EventPage.vue?vue&type=script&lang=js
 /* harmony default export */ var examples_EventPagevue_type_script_lang_js = (EventPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventPage.vue?vue&type=style&index=0&id=0b881368&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var EventPagevue_type_style_index_0_id_0b881368_prod_module_true_lang_scss = ({"root":"EventPage_root_XpZd8","skipToRegisterLink":"EventPage_skipToRegisterLink_Z8nDN","attendeeFrameBorder":"EventPage_attendeeFrameBorder_Wn5nz","attendeeModeNotch":"EventPage_attendeeModeNotch_TL3Jw","attendeeModeFrameContainer":"EventPage_attendeeModeFrameContainer_yfwe2","attendeeModeNotchLeft":"EventPage_attendeeModeNotchLeft_tL9tK","attendeeModeNotchRight":"EventPage_attendeeModeNotchRight_DH83J","text":"EventPage_text_WLOk4","content_wrapper":"EventPage_content_wrapper_RrKaq","page_section":"EventPage_page_section_ThJnf","recordingMode":"EventPage_recordingMode_z4mia","chat_section":"EventPage_chat_section__DVrp","bg":"EventPage_bg_NLzek","hide":"EventPage_hide_hdbdL","poweredBy":"EventPage_poweredBy_GaXYM","inPerson":"EventPage_inPerson_ZlEMM","isStage":"EventPage_isStage_RZ_AU","slideIn":"EventPage_slideIn_yUJ_W","nonmobile":"EventPage_nonmobile_qEHD_"});
;// CONCATENATED MODULE: ./src/examples/EventPage.vue?vue&type=style&index=0&id=0b881368&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventPage.vue



;




function EventPage_injectStyles (context) {
  
  this["$style"] = (EventPagevue_type_style_index_0_id_0b881368_prod_module_true_lang_scss.locals || EventPagevue_type_style_index_0_id_0b881368_prod_module_true_lang_scss)

}

/* normalize component */

var EventPage_component = normalizeComponent(
  examples_EventPagevue_type_script_lang_js,
  EventPagevue_type_template_id_0b881368_render,
  EventPagevue_type_template_id_0b881368_staticRenderFns,
  false,
  EventPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var EventPage = (EventPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/UserModalPage.vue?vue&type=template&id=3b1468aa
var UserModalPagevue_type_template_id_3b1468aa_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "userModalPage",
    class: _vm.$style.modal,
    style: _vm.isSplashPage ? _vm.splashThemeOverwrites : '',
    attrs: {
      "aria-modal": "true"
    },
    on: {
      "keydown": _vm.keydownHandler
    }
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('button', {
    staticClass: "keyboard-focusable button",
    attrs: {
      "id": "userModalPageCloseButton",
      "aria-label": "Close button"
    },
    on: {
      "click": function ($event) {
        return _vm.closePopup();
      }
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "cross",
      "color": "primary-text-color",
      "size": "regular"
    }
  })], 1), _c('StyledText', {
    class: _vm.$style.name,
    attrs: {
      "variant": "body15",
      "color": "primary-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Profile')) + " ")])], 1), _c('div', {
    class: _vm.$style.container
  }, [_c('UserImage', {
    attrs: {
      "user": _vm.user,
      "imageScale": "medium",
      "size": "midlarge"
    }
  }), _c('StyledText', {
    class: _vm.$style.name,
    attrs: {
      "variant": "body15",
      "color": "primary-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.user.name) + " ")]), _vm.user.title ? _c('StyledText', {
    class: _vm.$style.middleInfo,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.user.title) + " ")]) : _vm._e(), _vm.user.company ? _c('StyledText', {
    class: _vm.$style.middleInfo,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.user.company) + " ")]) : _vm._e(), _vm.location ? _c('StyledText', {
    class: [_vm.$style.withIcon, _vm.$style.location],
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [[_c('SvgIcon', {
    attrs: {
      "name": "location",
      "color": "primary-text-color"
    }
  }), _vm._v(" " + _vm._s(_vm.location) + " ")]], 2) : _vm._e(), _vm.linkedinTitle ? _c('div', {
    class: _vm.$style.linkedin
  }, [_c('a', {
    class: _vm.$style.link,
    attrs: {
      "href": _vm.linkedinUrl,
      "target": "_blank"
    }
  }, [_c('StyledText', {
    class: _vm.$style.withIcon,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "linkedin",
      "size": "small",
      "color": "primary-text-color"
    }
  }), _vm._v(" " + _vm._s(_vm.linkedinTitle) + " ")], 1)], 1)]) : _vm._e(), _vm.twitterTitle ? _c('div', {
    class: _vm.$style.twitter
  }, [_c('a', {
    class: _vm.$style.link,
    attrs: {
      "href": _vm.twitterUrl,
      "target": "_blank"
    }
  }, [_c('StyledText', {
    class: _vm.$style.withIcon,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "twitter",
      "color": "primary-text-color"
    }
  }), _vm._v(" " + _vm._s(_vm.twitterTitle) + " ")], 1)], 1)]) : _vm._e(), _vm.showBio && _vm.user.description ? _c('StyledText', {
    class: _vm.$style.bio,
    attrs: {
      "variant": "noBodyVariant",
      "color": "primary-text-color",
      "align": "justify"
    }
  }, [_c('span', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: _vm.user.description,
      expression: "user.description"
    }]
  })]) : _vm._e(), _vm.showEmail && _vm.user.display_email ? _c('StyledText', {
    class: _vm.$style.withIcon,
    attrs: {
      "variant": "body13",
      "color": "primary-text-color"
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "email",
      "color": "primary-text-color"
    }
  }), _vm._v(" " + _vm._s(_vm.user.display_email) + " ")], 1) : _vm._e(), _c('div', {
    class: _vm.$style.tags
  }, _vm._l(_vm.user.tags, function (tag, index) {
    return _c('Tag', {
      key: index,
      attrs: {
        "tag": tag,
        "showRemove": true
      }
    });
  }), 1), !_vm.isSplashPage ? _c('div', {
    class: _vm.$style.actionButtonContainer
  }, [_vm.isOwner ? _c('PillButton', {
    attrs: {
      "icon": "edit",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('hideModal', _vm.action);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Edit Profile')) + " ")]) : _vm.p2pChatEnabled ? _c('PillButton', {
    attrs: {
      "icon": "chat-bubble",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('hideModal', _vm.action);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Start Chat')) + " ")]) : _vm._e()], 1) : _vm._e()], 1)]);
};
var UserModalPagevue_type_template_id_3b1468aa_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/utils/theme.js
const FONT_TYPES = Object.freeze({
  CUSTOM: 'Custom',
  WEB: 'Web Font',
  DEFAULT: 'Default-GT-America',
  LIBRARY: 'Web Safe Font',
  CUSTOM_SPLASH: 'Custom Splash'
});
const CUSTOM_FONT_NAME = 'Custom Font';
function getSelectedFontType(font_type, theme_font_src, theme_font_link, theme_font_name) {
  if (font_type) {
    return font_type;
  }
  if (theme_font_src) {
    return FONT_TYPES.CUSTOM;
  }
  if (theme_font_link) {
    return FONT_TYPES.WEB;
  }
  if (theme_font_name) {
    return FONT_TYPES.LIBRARY;
  }
  return FONT_TYPES.DEFAULT;
}
function getSelectedFontName(font_type, theme_font_src, theme_font_link, custom_font_name, theme_font_name) {
  const names = {
    [FONT_TYPES.WEB]: custom_font_name,
    [FONT_TYPES.LIBRARY]: theme_font_name,
    [FONT_TYPES.CUSTOM]: CUSTOM_FONT_NAME,
    [FONT_TYPES.CUSTOM_SPLASH]: 'Custom Splash Font'
  };
  return names[getSelectedFontType(font_type, theme_font_src, theme_font_link, theme_font_name)] || FONT_TYPES.DEFAULT;
}
function loadFont(font_type, theme_font_src, theme_font_link) {
  try {
    const type = getSelectedFontType(font_type, theme_font_src, theme_font_link);
    if (type === FONT_TYPES.CUSTOM_SPLASH) {
      document.fonts.forEach(face => {
        if (face.family === 'Custom Splash Font') {
          document.fonts.delete(face);
        }
      });
      const font = new FontFace('Custom Splash Font', `url(${theme_font_src})`);
      document.fonts.add(font);
      font.load();
    } else if (type === FONT_TYPES.CUSTOM) {
      document.fonts.forEach(face => {
        if (face.family === CUSTOM_FONT_NAME) {
          document.fonts.delete(face);
        }
      });
      const font = new FontFace(CUSTOM_FONT_NAME, `url(${theme_font_src})`);
      document.fonts.add(font);
      font.load();
    } else if (type === FONT_TYPES.WEB) {
      const link = document.createElement('link');
      link.href = theme_font_link;
      link.type = 'text/css';
      link.rel = 'stylesheet';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  } catch (e) {
    console.error('Unable to load font ', e);
  }
}
function getForcedOverwrites({
  isLiveStreamMode
}) {
  const overwrites = {};
  if (isLiveStreamMode) {
    overwrites['--mobile-event-background'] = 'var(--theme-primary-color)';
    overwrites['--event-background'] = 'var(--theme-primary-color)';
  }
  return overwrites;
}
function themeObjToStyleVariables(theme_obj, is_hybrid, isLiteMode, isLiveStreamMode) {
  const virtualBackgrounds = theme_obj.virtual_backgrounds || [];
  return {
    '--mobile-event-background': theme_obj.event_background,
    '--mobile-splash-page-hero': theme_obj.splash_page_hero,
    '--mobile-stage-background': theme_obj.stage_background,
    '--hybrid-display': is_hybrid ? 'block' : 'none',
    ...Object.keys(theme_obj).reduce((acc, key) => {
      if (!theme_obj[key]) {
        return acc;
      }
      return {
        ...acc,
        [`--${key.split('_').join('-')}`]: theme_obj[key]
      };
    }, {}),
    '--stage-padding': isLiteMode || isTransparent(theme_obj.stage_background) ? '0px' : '24px',
    '--border-size': theme_obj.show_borders ? '1px' : '0px',
    '--font-name': getSelectedFontName(theme_obj.font_type, theme_obj.theme_font_src, theme_obj.theme_font_link, theme_obj.custom_font_name, theme_obj.theme_font_name),
    '--splash-font-name': getSelectedFontName(theme_obj.splash_font_type, theme_obj.splash_theme_font_src, theme_obj.splash_theme_font_link, theme_obj.splash_custom_font_name, theme_obj.splash_theme_font_name),
    '--default-virtual-background': `url('${virtualBackgrounds[0]}')`,
    ...getForcedOverwrites({
      isLiveStreamMode
    })
  };
}
function isTransparent(color) {
  return !color || color === 'transparent' || color.trim().startsWith('rgba(') && color.trim().endsWith('0)');
}
const splashThemeOverwrites = {
  '--theme-primary-color': 'var(--splash-background-color)',
  '--primary-background-shade': 'var(--splash-background-shade)',
  '--primary-text-color': 'var(--splash-text-color)',
  '--font-name': 'var(--splash-font-name)'
};
/* harmony default export */ var theme = ({
  loadFont,
  themeObjToStyleVariables,
  FONT_TYPES,
  splashThemeOverwrites
});
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/UserModalPage.vue?vue&type=script&lang=js



/* harmony default export */ var UserModalPagevue_type_script_lang_js = ({
  name: 'UserModalPage',
  components: {
    Tag: Tag
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    isOwner: Boolean,
    showEmail: Boolean,
    showBio: Boolean,
    p2pChatEnabled: Boolean,
    showCallButton: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: true
    },
    isSplashPage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tagsSlicePoint: 4,
      splashThemeOverwrites: theme.splashThemeOverwrites,
      target: null
    };
  },
  mounted() {
    this.target = document.activeElement;
    this.$nextTick(() => {
      const closeButton = document.querySelector('#userModalPageCloseButton');
      setTimeout(() => {
        closeButton.focus();
        focusTrap({
          getAllFocusableElementOf: this.$refs.userModalPage
        });
      }, 0);
    });
  },
  computed: {
    location() {
      return this.user.location?.location || '';
    },
    linkedin() {
      return this.user?.linkedin_url?.split('linkedin.com').pop().split('?').shift();
    },
    linkedinTitle() {
      return this.user?.linkedin_url?.split('linkedin.com').pop().split('?').shift();
    },
    linkedinUrl() {
      return this.user?.linkedin_url || '';
    },
    twitterTitle() {
      return this.user?.twitter_url?.split('twitter.com').pop().split('?').shift();
    },
    twitterUrl() {
      return this.user?.twitter_url || '';
    }
  },
  methods: {
    showMore() {
      this.tagsSlicePoint = this.user.tags.length;
    },
    closePopup() {
      this.$emit('hide');
      if (this.target) {
        this.$nextTick(() => {
          this.target.focus();
        });
      }
    },
    keydownHandler(event) {
      if (event.key === 'Escape') {
        this.closePopup();
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/UserModalPage.vue?vue&type=script&lang=js
 /* harmony default export */ var examples_UserModalPagevue_type_script_lang_js = (UserModalPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/UserModalPage.vue?vue&type=style&index=0&id=3b1468aa&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var UserModalPagevue_type_style_index_0_id_3b1468aa_prod_module_true_lang_scss = ({"modal":"UserModalPage_modal_LGAXd","actionButtonContainer":"UserModalPage_actionButtonContainer_mnEi2","middleInfo":"UserModalPage_middleInfo_LtdR8","container":"UserModalPage_container_quMvM","header":"UserModalPage_header_MQL4r","name":"UserModalPage_name_eOeot","location":"UserModalPage_location_tfRTT","withIcon":"UserModalPage_withIcon_dPbLA","bio":"UserModalPage_bio_Fr4vx","tags":"UserModalPage_tags_Efplv","actionsContainer":"UserModalPage_actionsContainer_Qonvr","action":"UserModalPage_action_vUZcU","linkedin":"UserModalPage_linkedin_NjnOg","twitter":"UserModalPage_twitter_J7G36","link":"UserModalPage_link_KHi8M"});
;// CONCATENATED MODULE: ./src/examples/UserModalPage.vue?vue&type=style&index=0&id=3b1468aa&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/UserModalPage.vue



;




function UserModalPage_injectStyles (context) {
  
  this["$style"] = (UserModalPagevue_type_style_index_0_id_3b1468aa_prod_module_true_lang_scss.locals || UserModalPagevue_type_style_index_0_id_3b1468aa_prod_module_true_lang_scss)

}

/* normalize component */

var UserModalPage_component = normalizeComponent(
  examples_UserModalPagevue_type_script_lang_js,
  UserModalPagevue_type_template_id_3b1468aa_render,
  UserModalPagevue_type_template_id_3b1468aa_staticRenderFns,
  false,
  UserModalPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UserModalPage = (UserModalPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/EntryPage.vue?vue&type=template&id=9a2e2636
var EntryPagevue_type_template_id_9a2e2636_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('AuthWrapper', {
    attrs: {
      "contentHeader": _vm.contentHeader,
      "headerExtra": _vm.headerExtra,
      "contentHeaderColor": _vm.contentHeaderColor,
      "canProceed": !_vm.loading,
      "loading": _vm.loading,
      "loadingText": _vm.$options.$t(_vm.loadingText),
      "errorMessage": _vm.errorMessage
    },
    on: {
      "next": _vm.handleNext
    }
  }, [_c('AuthInput', {
    ref: "emailInput",
    attrs: {
      "label": _vm.$options.$t(`EMAIL`),
      "placeholder": _vm.$options.$t(`user@email.com`),
      "type": "email",
      "required": true,
      "dataTestMarker": "emailinput"
    },
    model: {
      value: _vm.emailId,
      callback: function ($$v) {
        _vm.emailId = $$v;
      },
      expression: "emailId"
    }
  }), _vm.showNameField ? _c('br') : _vm._e(), _vm.showNameField ? _c('AuthInput', {
    ref: "firstNameInput",
    attrs: {
      "label": _vm.$options.$t(`FIRST NAME`),
      "placeholder": _vm.$options.$t(`First Name`),
      "required": true,
      "type": "text",
      "dataTestMarker": "firstname"
    },
    model: {
      value: _vm.firstName,
      callback: function ($$v) {
        _vm.firstName = $$v;
      },
      expression: "firstName"
    }
  }) : _vm._e(), _vm.showNameField ? _c('br') : _vm._e(), _vm.showNameField ? _c('AuthInput', {
    ref: "lastNameInput",
    attrs: {
      "label": _vm.$options.$t(`LAST NAME`),
      "placeholder": _vm.$options.$t(`Last Name`),
      "required": true,
      "type": "text",
      "dataTestMarker": "lastname"
    },
    model: {
      value: _vm.lastName,
      callback: function ($$v) {
        _vm.lastName = $$v;
      },
      expression: "lastName"
    }
  }) : _vm._e()], 1);
};
var EntryPagevue_type_template_id_9a2e2636_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/EntryPage.vue?vue&type=script&lang=js

/* harmony default export */ var EntryPagevue_type_script_lang_js = ({
  name: 'EntryPage',
  components: {
    AuthWrapper: AuthWrapper,
    AuthInput: AuthInput
  },
  props: {
    notRegistered: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: 'Checking...'
    },
    email: {
      type: String,
      default: ''
    },
    firstname: {
      type: String,
      default: ''
    },
    lastname: {
      type: String,
      default: ''
    },
    showNameField: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      emailId: this.email,
      firstName: this.firstname,
      lastName: this.lastname
    };
  },
  watch: {
    emailId(value) {
      this.emailId = value?.toLowerCase()?.trim() ?? '';
    }
  },
  computed: {
    contentHeader() {
      if (this.notRegistered) {
        return this.$t('You are not registered to this event');
      }
      if (this.showNameField) {
        return this.$t('Please enter your email and name');
      }
      return this.$t('Please enter your email');
    },
    headerExtra() {
      if (this.notRegistered) {
        return 'Please ensure you have used a registered email';
      }
      return null;
    },
    contentHeaderColor() {
      return this.notRegistered ? 'theme-highlight-text-color' : 'primary-text-color';
    }
  },
  methods: {
    handleNext() {
      const {
        emailInput,
        firstNameInput,
        lastNameInput
      } = this.$refs;
      if (!emailInput?.checkValidity()) {
        emailInput?.focus();
        return;
      }
      if (this.showNameField && !firstNameInput?.checkValidity()) {
        firstNameInput?.focus();
        return;
      }
      if (this.showNameField && !lastNameInput?.checkValidity()) {
        lastNameInput?.focus();
        return;
      }
      this.$emit('next', {
        emailId: this.emailId,
        firstname: this.firstName,
        lastname: this.lastName
      });
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/Auth/EntryPage.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_EntryPagevue_type_script_lang_js = (EntryPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/Auth/EntryPage.vue?vue&type=style&index=0&id=9a2e2636&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var EntryPagevue_type_style_index_0_id_9a2e2636_prod_lang_scss_module_true = ({"content":"EntryPage_content_uFUB2","goldcastSignup":"EntryPage_goldcastSignup_moISt","redirectButton":"EntryPage_redirectButton_Zg2uH"});
;// CONCATENATED MODULE: ./src/examples/Auth/EntryPage.vue?vue&type=style&index=0&id=9a2e2636&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/Auth/EntryPage.vue



;




function EntryPage_injectStyles (context) {
  
  this["$style"] = (EntryPagevue_type_style_index_0_id_9a2e2636_prod_lang_scss_module_true.locals || EntryPagevue_type_style_index_0_id_9a2e2636_prod_lang_scss_module_true)

}

/* normalize component */

var EntryPage_component = normalizeComponent(
  Auth_EntryPagevue_type_script_lang_js,
  EntryPagevue_type_template_id_9a2e2636_render,
  EntryPagevue_type_template_id_9a2e2636_staticRenderFns,
  false,
  EntryPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var EntryPage = (EntryPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/DifferentUserLoggedIn.vue?vue&type=template&id=32620db9
var DifferentUserLoggedInvue_type_template_id_32620db9_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('AuthWrapper', {
    attrs: {
      "contentHeader": _vm.contentHeader,
      "headerExtra": _vm.$t(`Please log out`),
      "contentHeaderColor": "theme-highlight-text-color",
      "loading": _vm.loading,
      "loadingText": _vm.loadingText,
      "nextButton": false
    }
  }, [_c('div', {
    class: _vm.$style.diffUser
  }, [_c('TextButton', {
    class: _vm.$style.redirectButton,
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('logout');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Logout')) + " ")]), _c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    }
  }, [_vm._v(" | ")]), _c('TextButton', {
    class: _vm.$style.redirectButton,
    attrs: {
      "color": "primary-text-color",
      "variant": "body15",
      "uppercase": false
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('continue');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Continue as {differentUser}', {
    differentUser: _vm.differentUser
  })) + " ")])], 1)]);
};
var DifferentUserLoggedInvue_type_template_id_32620db9_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/DifferentUserLoggedIn.vue?vue&type=script&lang=js

/* harmony default export */ var DifferentUserLoggedInvue_type_script_lang_js = ({
  name: 'DifferentUserLoggedIn',
  components: {
    AuthWrapper: AuthWrapper,
    StyledText: StyledText
  },
  props: {
    differentUser: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      emailId: ''
    };
  },
  computed: {
    contentHeader() {
      return this.$t('You are already logged in as {user}.', {
        user: this.differentUser
      });
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/Auth/DifferentUserLoggedIn.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_DifferentUserLoggedInvue_type_script_lang_js = (DifferentUserLoggedInvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/Auth/DifferentUserLoggedIn.vue?vue&type=style&index=0&id=32620db9&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var DifferentUserLoggedInvue_type_style_index_0_id_32620db9_prod_lang_scss_module_true = ({"content":"DifferentUserLoggedIn_content_DhaZk","diffUser":"DifferentUserLoggedIn_diffUser_ovN1y","redirectButton":"DifferentUserLoggedIn_redirectButton_mUTxQ"});
;// CONCATENATED MODULE: ./src/examples/Auth/DifferentUserLoggedIn.vue?vue&type=style&index=0&id=32620db9&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/Auth/DifferentUserLoggedIn.vue



;




function DifferentUserLoggedIn_injectStyles (context) {
  
  this["$style"] = (DifferentUserLoggedInvue_type_style_index_0_id_32620db9_prod_lang_scss_module_true.locals || DifferentUserLoggedInvue_type_style_index_0_id_32620db9_prod_lang_scss_module_true)

}

/* normalize component */

var DifferentUserLoggedIn_component = normalizeComponent(
  Auth_DifferentUserLoggedInvue_type_script_lang_js,
  DifferentUserLoggedInvue_type_template_id_32620db9_render,
  DifferentUserLoggedInvue_type_template_id_32620db9_staticRenderFns,
  false,
  DifferentUserLoggedIn_injectStyles,
  null,
  null
  
)

/* harmony default export */ var DifferentUserLoggedIn = (DifferentUserLoggedIn_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/MagicLinkSent.vue?vue&type=template&id=37c0b972
var MagicLinkSentvue_type_template_id_37c0b972_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.content
  }, [_c('StyledText', {
    class: _vm.$style.textContent,
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('We have sent a secure login link to')) + " "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.emailId))])]), _vm._v(" " + _vm._s(_vm.$options.$t('from')) + " "), _c('span', [_c('b', [_vm._v("no-reply@goldcast.io")])]), _vm._v(" . ")]), _c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Please use that to access your event.')) + " ")]), _c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t("Please check spam/promotion too if you can't find it.")) + " ")]), _c('br'), _c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Thank You !')) + " ")])], 1);
};
var MagicLinkSentvue_type_template_id_37c0b972_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/MagicLinkSent.vue?vue&type=script&lang=js

/* harmony default export */ var MagicLinkSentvue_type_script_lang_js = ({
  name: 'MagicLinkSent',
  components: {
    StyledText: StyledText
  },
  props: {
    emailId: {
      type: String,
      default: ''
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/Auth/MagicLinkSent.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_MagicLinkSentvue_type_script_lang_js = (MagicLinkSentvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/Auth/MagicLinkSent.vue?vue&type=style&index=0&id=37c0b972&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var MagicLinkSentvue_type_style_index_0_id_37c0b972_prod_lang_scss_module_true = ({"content":"MagicLinkSent_content_R0Be0","fromMail":"MagicLinkSent_fromMail_lh3VU","textContent":"MagicLinkSent_textContent_h2qNm"});
;// CONCATENATED MODULE: ./src/examples/Auth/MagicLinkSent.vue?vue&type=style&index=0&id=37c0b972&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/Auth/MagicLinkSent.vue



;




function MagicLinkSent_injectStyles (context) {
  
  this["$style"] = (MagicLinkSentvue_type_style_index_0_id_37c0b972_prod_lang_scss_module_true.locals || MagicLinkSentvue_type_style_index_0_id_37c0b972_prod_lang_scss_module_true)

}

/* normalize component */

var MagicLinkSent_component = normalizeComponent(
  Auth_MagicLinkSentvue_type_script_lang_js,
  MagicLinkSentvue_type_template_id_37c0b972_render,
  MagicLinkSentvue_type_template_id_37c0b972_staticRenderFns,
  false,
  MagicLinkSent_injectStyles,
  null,
  null
  
)

/* harmony default export */ var MagicLinkSent = (MagicLinkSent_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/LoginPage.vue?vue&type=template&id=3676b5f2
var LoginPagevue_type_template_id_3676b5f2_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('AuthWrapper', {
    attrs: {
      "userName": _vm.userName,
      "contentHeader": _vm.$options.$t(`Please enter your password to continue`),
      "canProceed": _vm.canProceed && !_vm.loading,
      "errorMessage": _vm.errorMessage,
      "loading": _vm.loading,
      "loadingText": _vm.$options.$t(`Logging you in...`)
    },
    on: {
      "next": function ($event) {
        return _vm.$emit('next', _vm.password);
      }
    }
  }, [_c('AuthInput', {
    attrs: {
      "label": _vm.$options.$t(`EMAIL`),
      "placeholder": _vm.$options.$t(`user@email.com`),
      "type": "email",
      "errorMessage": _vm.errorField === 'email' ? _vm.errorMessage : null,
      "disabled": true
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  }), _c('br'), _c('AuthInput', {
    attrs: {
      "label": _vm.$options.$t(`PASSWORD`),
      "placeholder": _vm.$options.$t(`PASSWORD`),
      "type": "password",
      "errorMessage": _vm.errorField === 'password' ? _vm.errorMessage : null,
      "dataTestMarker": "passwordinput"
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _c('div', {
    class: _vm.$style.forgotCredLink
  }, [_c('TextButton', {
    attrs: {
      "color": "color-variant-light-5",
      "variant": "body13",
      "uppercase": false
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('forgot-password');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Forgot credentials?')) + " ")]), _vm.showAlert ? _c('AuthPopup', {
    attrs: {
      "popupContent": _vm.$options.$t(`Forgot Password? A mail will be sent to your registered email.`)
    }
  }) : _vm._e()], 1)], 1);
};
var LoginPagevue_type_template_id_3676b5f2_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/LoginPage.vue?vue&type=script&lang=js

/* harmony default export */ var LoginPagevue_type_script_lang_js = ({
  name: 'LoginPage',
  components: {
    AuthWrapper: AuthWrapper,
    AuthInput: AuthInput,
    AuthPopup: AuthPopup
  },
  props: {
    email: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: ''
    },
    showAlert: {
      type: Boolean,
      default: false
    },
    serverErrorMessage: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      password: null
    };
  },
  computed: {
    canProceed() {
      return this.password && this.password.length >= 8;
    },
    errorField() {
      if (!this.email) {
        return 'email';
      }
      if (this.password && this.password.length < 8) {
        return 'password';
      }
      if (this.serverErrorMessage) {
        return 'password';
      }
      return null;
    },
    errorMessage() {
      if (!this.email) {
        return this.$t('Email cannot be blank!!');
      }
      if (this.password && this.password.length < 8) {
        return this.$t('Password length should be atleast 8');
      }
      if (this.serverErrorMessage) {
        return this.serverErrorMessage;
      }
      return null;
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/Auth/LoginPage.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_LoginPagevue_type_script_lang_js = (LoginPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/Auth/LoginPage.vue?vue&type=style&index=0&id=3676b5f2&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var LoginPagevue_type_style_index_0_id_3676b5f2_prod_lang_scss_module_true = ({"content":"LoginPage_content_eviQ0","forgotCredLink":"LoginPage_forgotCredLink_feiv1","popupMessage":"LoginPage_popupMessage_QG1Hu","arrow":"LoginPage_arrow__7Np2"});
;// CONCATENATED MODULE: ./src/examples/Auth/LoginPage.vue?vue&type=style&index=0&id=3676b5f2&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/Auth/LoginPage.vue



;




function LoginPage_injectStyles (context) {
  
  this["$style"] = (LoginPagevue_type_style_index_0_id_3676b5f2_prod_lang_scss_module_true.locals || LoginPagevue_type_style_index_0_id_3676b5f2_prod_lang_scss_module_true)

}

/* normalize component */

var LoginPage_component = normalizeComponent(
  Auth_LoginPagevue_type_script_lang_js,
  LoginPagevue_type_template_id_3676b5f2_render,
  LoginPagevue_type_template_id_3676b5f2_staticRenderFns,
  false,
  LoginPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LoginPage = (LoginPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/NewPasswordPage.vue?vue&type=template&id=9e079c22
var NewPasswordPagevue_type_template_id_9e079c22_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('AuthWrapper', {
    attrs: {
      "contentHeader": _vm.$options.$t(`Thank you for entering the code!`),
      "headerExtra": _vm.$options.$t(`Please create a new password`),
      "canProceed": _vm.canProceed && !_vm.loading,
      "errorMessage": _vm.errorMessage,
      "loading": _vm.loading,
      "loadingText": _vm.$options.$t(`Signing you up...`)
    },
    on: {
      "next": function ($event) {
        return _vm.$emit('next', _vm.newPassword);
      }
    }
  }, [_c('AuthInput', {
    attrs: {
      "label": _vm.$options.$t(`NEW PASSWORD`),
      "placeholder": _vm.$options.$t(`Please enter a new password`),
      "type": "password",
      "errorMessage": _vm.errorField === `newPassword` ? _vm.errorMessage : null
    },
    model: {
      value: _vm.newPassword,
      callback: function ($$v) {
        _vm.newPassword = $$v;
      },
      expression: "newPassword"
    }
  }), _c('br'), _c('AuthInput', {
    attrs: {
      "label": _vm.$options.$t(`CONFIRM PASSWORD`),
      "placeholder": _vm.$options.$t(`Please re-enter the new password`),
      "type": "password",
      "errorMessage": _vm.errorField === `confirmPassword` ? _vm.errorMessage : null
    },
    model: {
      value: _vm.confirmPassword,
      callback: function ($$v) {
        _vm.confirmPassword = $$v;
      },
      expression: "confirmPassword"
    }
  })], 1);
};
var NewPasswordPagevue_type_template_id_9e079c22_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/NewPasswordPage.vue?vue&type=script&lang=js

/* harmony default export */ var NewPasswordPagevue_type_script_lang_js = ({
  name: 'NewPasswordPage',
  components: {
    AuthWrapper: AuthWrapper,
    AuthInput: AuthInput
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newPassword: null,
      confirmPassword: null
    };
  },
  computed: {
    errorField() {
      if (this.newPassword && this.newPassword.length < 8) {
        return 'newPassword';
      }
      if (this.newPassword && this.newPassword !== this.confirmPassword) {
        return 'confirmPassword';
      }
      return null;
    },
    errorMessage() {
      if (this.newPassword && this.newPassword.length < 8) {
        return this.$t('Password length should be atleast 8');
      }
      if (this.newPassword && this.newPassword !== this.confirmPassword) {
        return this.$t("Password and Confirm Password don't match !!");
      }
      return null;
    },
    canProceed() {
      return this.newPassword && this.newPassword.length >= 8 && this.newPassword === this.confirmPassword;
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/Auth/NewPasswordPage.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_NewPasswordPagevue_type_script_lang_js = (NewPasswordPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/Auth/NewPasswordPage.vue?vue&type=style&index=0&id=9e079c22&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var NewPasswordPagevue_type_style_index_0_id_9e079c22_prod_lang_scss_module_true = ({"content":"NewPasswordPage_content_vtGnS","forgotCredLink":"NewPasswordPage_forgotCredLink_W0R69"});
;// CONCATENATED MODULE: ./src/examples/Auth/NewPasswordPage.vue?vue&type=style&index=0&id=9e079c22&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/Auth/NewPasswordPage.vue



;




function NewPasswordPage_injectStyles (context) {
  
  this["$style"] = (NewPasswordPagevue_type_style_index_0_id_9e079c22_prod_lang_scss_module_true.locals || NewPasswordPagevue_type_style_index_0_id_9e079c22_prod_lang_scss_module_true)

}

/* normalize component */

var NewPasswordPage_component = normalizeComponent(
  Auth_NewPasswordPagevue_type_script_lang_js,
  NewPasswordPagevue_type_template_id_9e079c22_render,
  NewPasswordPagevue_type_template_id_9e079c22_staticRenderFns,
  false,
  NewPasswordPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var NewPasswordPage = (NewPasswordPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/TempPasswordPage.vue?vue&type=template&id=e954401c
var TempPasswordPagevue_type_template_id_e954401c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('AuthWrapper', {
    attrs: {
      "contentHeader": _vm.$options.$t(`We have sent a temporary password to`),
      "email": _vm.email,
      "canProceed": _vm.canProceed && !_vm.loading,
      "errorMessage": _vm.errorMessage,
      "backText": _vm.$options.$t(`BACK`),
      "loading": _vm.loading,
      "loadingText": _vm.loadingText
    },
    on: {
      "next": function ($event) {
        return _vm.$emit('next', _vm.password);
      },
      "go-back": function ($event) {
        return _vm.$emit('go-back');
      }
    }
  }, [_c('div', {
    class: _vm.$style.resendMailLink
  }, [_c('StyledText', {
    attrs: {
      "color": "color-variant-light-5",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t("Didn't receive an email? Make sure to check spam list")) + ". ")]), _c('TextButton', {
    class: _vm.$style.resendBtn,
    attrs: {
      "color": "color-variant-light-5",
      "variant": "body13",
      "uppercase": false
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('resend-mail');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Resend Mail')) + " ")])], 1), _c('AuthInput', {
    attrs: {
      "label": _vm.$options.$t(`TEMPORARY PASSWORD`),
      "placeholder": _vm.$options.$t(`Please enter the temporary password sent to your mail`),
      "type": "password",
      "errorMessage": _vm.errorMessage
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1);
};
var TempPasswordPagevue_type_template_id_e954401c_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/TempPasswordPage.vue?vue&type=script&lang=js

/* harmony default export */ var TempPasswordPagevue_type_script_lang_js = ({
  name: 'AuthPageWrapper',
  components: {
    AuthWrapper: AuthWrapper,
    AuthInput: AuthInput
  },
  props: {
    email: {
      type: String,
      default: ''
    },
    serverErrorMessage: {
      type: String,
      default: null
    },
    loadingText: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      password: null
    };
  },
  watch: {
    password(value) {
      this.password = value?.trim() ?? '';
    }
  },
  computed: {
    errorMessage() {
      if (this.serverErrorMessage) {
        return this.serverErrorMessage;
      }
      if (this.password && this.password.length !== 8) {
        return this.$t('Password Length should be 8');
      }
      return null;
    },
    canProceed() {
      return this.password && this.password.length >= 8;
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/Auth/TempPasswordPage.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_TempPasswordPagevue_type_script_lang_js = (TempPasswordPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/Auth/TempPasswordPage.vue?vue&type=style&index=0&id=e954401c&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var TempPasswordPagevue_type_style_index_0_id_e954401c_prod_lang_scss_module_true = ({"content":"TempPasswordPage_content_pvL7b","resendMailLink":"TempPasswordPage_resendMailLink_BRYzD","resendBtn":"TempPasswordPage_resendBtn_hDEdI"});
;// CONCATENATED MODULE: ./src/examples/Auth/TempPasswordPage.vue?vue&type=style&index=0&id=e954401c&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/Auth/TempPasswordPage.vue



;




function TempPasswordPage_injectStyles (context) {
  
  this["$style"] = (TempPasswordPagevue_type_style_index_0_id_e954401c_prod_lang_scss_module_true.locals || TempPasswordPagevue_type_style_index_0_id_e954401c_prod_lang_scss_module_true)

}

/* normalize component */

var TempPasswordPage_component = normalizeComponent(
  Auth_TempPasswordPagevue_type_script_lang_js,
  TempPasswordPagevue_type_template_id_e954401c_render,
  TempPasswordPagevue_type_template_id_e954401c_staticRenderFns,
  false,
  TempPasswordPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var TempPasswordPage = (TempPasswordPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/ForgotPasswordPage.vue?vue&type=template&id=4f1ecf66
var ForgotPasswordPagevue_type_template_id_4f1ecf66_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('AuthWrapper', {
    attrs: {
      "contentHeader": _vm.$options.$t(`We have sent a secret code to`),
      "email": _vm.email,
      "canProceed": _vm.canProceed && !_vm.loading,
      "errorMessage": _vm.errorMessage,
      "backText": _vm.$options.$t(`BACK`),
      "loading": _vm.loading,
      "loadingText": _vm.loadingText
    },
    on: {
      "next": function ($event) {
        return _vm.$emit('next', _vm.secretCode, _vm.newPassword);
      },
      "go-back": function ($event) {
        return _vm.$emit('go-back');
      }
    }
  }, [_c('div', {
    class: _vm.$style.resendMailLink
  }, [_c('StyledText', {
    attrs: {
      "color": "color-variant-light-5",
      "variant": "body13"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t("Didn't receive an email? Make sure to check spam list")) + ". ")]), _c('TextButton', {
    class: _vm.$style.resendBtn,
    attrs: {
      "color": "color-variant-light-5",
      "variant": "body13",
      "uppercase": false
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('resend-mail');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Resend Mail')) + " ")])], 1), _c('AuthInput', {
    attrs: {
      "type": "password",
      "maxLength": 6,
      "label": _vm.$options.$t(`SECRET CODE`),
      "placeholder": _vm.$options.$t(`Please enter the temporary password sent to your email`),
      "errorMessage": _vm.errorField === `secretCode` ? _vm.errorMessage : null
    },
    model: {
      value: _vm.secretCode,
      callback: function ($$v) {
        _vm.secretCode = $$v;
      },
      expression: "secretCode"
    }
  }), _c('br'), _c('AuthInput', {
    attrs: {
      "label": _vm.$options.$t(`NEW PASSWORD`),
      "placeholder": _vm.$options.$t(`Please enter a new password`),
      "type": "password",
      "errorMessage": _vm.errorField === `newPassword` ? _vm.errorMessage : null
    },
    model: {
      value: _vm.newPassword,
      callback: function ($$v) {
        _vm.newPassword = $$v;
      },
      expression: "newPassword"
    }
  }), _c('br'), _c('AuthInput', {
    attrs: {
      "label": _vm.$options.$t(`CONFIRM PASSWORD`),
      "placeholder": _vm.$options.$t(`Please re-enter the new password`),
      "type": "password",
      "errorMessage": _vm.errorField === `confirmPassword` ? _vm.errorMessage : null
    },
    model: {
      value: _vm.confirmPassword,
      callback: function ($$v) {
        _vm.confirmPassword = $$v;
      },
      expression: "confirmPassword"
    }
  })], 1);
};
var ForgotPasswordPagevue_type_template_id_4f1ecf66_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/ForgotPasswordPage.vue?vue&type=script&lang=js

/* harmony default export */ var ForgotPasswordPagevue_type_script_lang_js = ({
  name: 'ForgotPasswordPage',
  components: {
    AuthWrapper: AuthWrapper,
    AuthInput: AuthInput
  },
  props: {
    email: {
      type: String,
      default: null
    },
    serverErrorField: {
      type: String,
      default: null
    },
    loadingText: {
      type: String,
      default: null
    },
    serverErrorMessage: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      secretCode: null,
      newPassword: null,
      confirmPassword: null
    };
  },
  computed: {
    errorField() {
      if (this.serverErrorField) {
        return this.serverErrorField;
      }
      if (this.secretCode && this.secretCode.length !== 6) {
        return 'secretCode';
      }
      if (this.newPassword && this.newPassword.length < 8) {
        return 'newPassword';
      }
      if (this.newPassword && this.newPassword !== this.confirmPassword) {
        return 'confirmPassword';
      }
      return null;
    },
    errorMessage() {
      if (this.serverErrorMessage) {
        return this.serverErrorMessage;
      }
      if (this.secretCode && this.secretCode.length !== 6) {
        return this.$t('Secret Code’s length should be 6 digits');
      }
      if (this.newPassword && this.newPassword.length < 8) {
        return this.$t('Password length should be atleast 8');
      }
      if (this.newPassword && this.newPassword !== this.confirmPassword) {
        return this.$t("Password and Confirm Password don't match !!");
      }
      return null;
    },
    canProceed() {
      return this.secretCode && this.secretCode.length === 6 && this.newPassword && this.newPassword.length >= 8 && this.newPassword === this.confirmPassword;
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/Auth/ForgotPasswordPage.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_ForgotPasswordPagevue_type_script_lang_js = (ForgotPasswordPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/Auth/ForgotPasswordPage.vue?vue&type=style&index=0&id=4f1ecf66&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var ForgotPasswordPagevue_type_style_index_0_id_4f1ecf66_prod_lang_scss_module_true = ({"content":"ForgotPasswordPage_content_RtAvX","forgotCredLink":"ForgotPasswordPage_forgotCredLink_n0mPx","resendMailLink":"ForgotPasswordPage_resendMailLink_CT_bl","resendBtn":"ForgotPasswordPage_resendBtn__WFk4"});
;// CONCATENATED MODULE: ./src/examples/Auth/ForgotPasswordPage.vue?vue&type=style&index=0&id=4f1ecf66&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/Auth/ForgotPasswordPage.vue



;




function ForgotPasswordPage_injectStyles (context) {
  
  this["$style"] = (ForgotPasswordPagevue_type_style_index_0_id_4f1ecf66_prod_lang_scss_module_true.locals || ForgotPasswordPagevue_type_style_index_0_id_4f1ecf66_prod_lang_scss_module_true)

}

/* normalize component */

var ForgotPasswordPage_component = normalizeComponent(
  Auth_ForgotPasswordPagevue_type_script_lang_js,
  ForgotPasswordPagevue_type_template_id_4f1ecf66_render,
  ForgotPasswordPagevue_type_template_id_4f1ecf66_staticRenderFns,
  false,
  ForgotPasswordPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ForgotPasswordPage = (ForgotPasswordPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/AuthPageWrapper.vue?vue&type=template&id=bcf7e568
var AuthPageWrappervue_type_template_id_bcf7e568_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.bannerView && _vm.$style.bannerView]
  }, [_c('div', {
    class: _vm.$style.brand
  }, [!_vm.bannerView || _vm.isEventTitleVisible ? [_vm.eventLogo ? _c('img', {
    class: _vm.$style.logo,
    attrs: {
      "src": _vm.eventLogo,
      "alt": _vm.altText
    }
  }) : _vm._e(), _vm.bannerView ? _c('StyledText', {
    attrs: {
      "variant": "body14",
      "color": _vm.bannerView ? 'primary-text-color' : 'color-secondary-light'
    }
  }, [_vm._v(" " + _vm._s(_vm.eventDate) + " ")]) : _vm._e(), !_vm.eventLogo ? _c('Loading', {
    class: _vm.$style.loading,
    attrs: {
      "size": "small"
    }
  }) : _vm._e(), _c('StyledText', {
    attrs: {
      "variant": _vm.bannerView ? 'heading26' : 'subHeading18',
      "color": _vm.bannerView ? 'primary-text-color' : 'color-secondary-light'
    }
  }, [_vm._v(" " + _vm._s(_vm.eventTitle) + " ")])] : _vm._e()], 2), _c('aside', {
    ref: "loginSidebar",
    class: _vm.$style.loginSection
  }, [_vm.bannerView && !_vm.isLoginAvailable ? [_c('StyledText', {
    class: _vm.$style.barHeader,
    attrs: {
      "variant": "heading26",
      "color": "color-secondary-light"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Stay tuned!')) + " ")]), _c('StyledText', {
    attrs: {
      "variant": "body14",
      "color": "color-secondary-light"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Sign-in instructions will be available here 12 hours prior to the event')) + ". ")])] : _c('router-view', {
    attrs: {
      "eventId": _vm.eventId
    }
  })], 2)]);
};
var AuthPageWrappervue_type_template_id_bcf7e568_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/AuthPageWrapper.vue?vue&type=script&lang=js


/* harmony default export */ var AuthPageWrappervue_type_script_lang_js = ({
  name: 'AuthPageWrapper',
  components: {
    StyledText: StyledText,
    Loading: Loading
  },
  props: {
    eventLogo: {
      type: String,
      default: null
    },
    altText: {
      type: String,
      default: null
    },
    eventTitle: {
      type: String,
      default: null
    },
    bannerView: {
      type: Boolean,
      default: false
    },
    eventDate: {
      type: String,
      default: null
    },
    isLoginAvailable: {
      type: Boolean,
      default: false
    },
    isEventTitleVisible: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      const allFocusableElements = this.$refs.loginSidebar?.querySelectorAll('input, button, select, textarea, a[href], [tabindex]:not([tabindex="-1"])');
      const firstFocusableElement = allFocusableElements?.[0];
      const lastFocusableElement = allFocusableElements?.[allFocusableElements.length - 1];
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
      this.$refs.loginSidebar?.addEventListener('keydown', e => this.handleKeyPress(e, firstFocusableElement, lastFocusableElement));
    });
  },
  beforeDestroy() {
    this.$refs.loginSidebar.removeEventListener('keydown', this.handleKeyPress);
  },
  methods: {
    handleKeyPress(e, firstFocusableElement, lastFocusableElement) {
      if (e.key === 'Tab') {
        if (e.shiftKey && document.activeElement === firstFocusableElement) {
          lastFocusableElement?.focus();
          e.preventDefault();
        } else if (document.activeElement === lastFocusableElement) {
          firstFocusableElement?.focus();
          e.preventDefault();
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/Auth/AuthPageWrapper.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_AuthPageWrappervue_type_script_lang_js = (AuthPageWrappervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/Auth/AuthPageWrapper.vue?vue&type=style&index=0&id=bcf7e568&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var AuthPageWrappervue_type_style_index_0_id_bcf7e568_prod_lang_scss_module_true = ({"root":"AuthPageWrapper_root_xywG_","brand":"AuthPageWrapper_brand_aavt7","loginSection":"AuthPageWrapper_loginSection_lawZp","bannerView":"AuthPageWrapper_bannerView_mFq7o","barHeader":"AuthPageWrapper_barHeader_ZTSEI","logo":"AuthPageWrapper_logo__VWLa","loading":"AuthPageWrapper_loading_CPefC"});
;// CONCATENATED MODULE: ./src/examples/Auth/AuthPageWrapper.vue?vue&type=style&index=0&id=bcf7e568&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/Auth/AuthPageWrapper.vue



;




function AuthPageWrapper_injectStyles (context) {
  
  this["$style"] = (AuthPageWrappervue_type_style_index_0_id_bcf7e568_prod_lang_scss_module_true.locals || AuthPageWrappervue_type_style_index_0_id_bcf7e568_prod_lang_scss_module_true)

}

/* normalize component */

var AuthPageWrapper_component = normalizeComponent(
  Auth_AuthPageWrappervue_type_script_lang_js,
  AuthPageWrappervue_type_template_id_bcf7e568_render,
  AuthPageWrappervue_type_template_id_bcf7e568_staticRenderFns,
  false,
  AuthPageWrapper_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AuthPageWrapper = (AuthPageWrapper_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/MagicLinkVerifyPage.vue?vue&type=template&id=dfec2abc
var MagicLinkVerifyPagevue_type_template_id_dfec2abc_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('AuthWrapper', {
    attrs: {
      "contentHeader": _vm.contentHeader,
      "headerExtra": _vm.headerExtra,
      "contentHeaderColor": _vm.contentHeaderColor,
      "loading": _vm.loading,
      "loadingText": _vm.loadingText,
      "nextButton": false
    },
    on: {
      "next": function ($event) {
        return _vm.$emit('next', _vm.emailId);
      }
    }
  }, [_vm.differentUserLoggedIn ? _c('div', {
    class: _vm.$style.magicLinkFailed
  }, [_c('TextButton', {
    class: _vm.$style.redirectButton,
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('logout');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Logout')) + " ")])], 1) : _vm._e(), _vm.shouldShowErrorActions ? _c('div', {
    class: _vm.$style.magicLinkFailed
  }, [_c('TextButton', {
    class: _vm.$style.redirectButton,
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('resend-link');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Resend Link')) + " ")]), _c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    }
  }, [_vm._v(" | ")]), _c('TextButton', {
    class: _vm.$style.redirectButton,
    attrs: {
      "color": "primary-text-color",
      "variant": "body15"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('go-to-login');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Login')) + " ")])], 1) : _vm._e()]);
};
var MagicLinkVerifyPagevue_type_template_id_dfec2abc_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Auth/MagicLinkVerifyPage.vue?vue&type=script&lang=js

/* harmony default export */ var MagicLinkVerifyPagevue_type_script_lang_js = ({
  name: 'MagicLinkVerifyPage',
  components: {
    AuthWrapper: AuthWrapper,
    StyledText: StyledText
  },
  props: {
    error: Object,
    differentUserLoggedIn: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      emailId: ''
    };
  },
  watch: {
    emailId(value) {
      this.emailId = value?.toLowerCase()?.trim() ?? '';
    }
  },
  computed: {
    errorMessage() {
      if (!this.error) {
        return undefined;
      }
      return this.error?.message || this.$t('The link is not valid.');
    },
    shouldShowErrorActions() {
      if (!this.error) {
        return false;
      }
      if (this.error?.code === 'NetworkError') {
        return false;
      }
      return true;
    },
    contentHeader() {
      if (this.errorMessage) {
        return this.errorMessage;
      }
      if (this.differentUserLoggedIn) {
        return this.$t(`You are already logged in as {user}.`, {
          user: this.differentUserLoggedIn
        });
      }
      return this.$t('Please be patient.');
    },
    headerExtra() {
      if (this.errorMessage) {
        return null;
      }
      if (this.differentUserLoggedIn) {
        return this.$t(`Please log out`);
      }
      return this.$t('We are verifying your link.');
    },
    contentHeaderColor() {
      return this.errorMessage || this.differentUserLoggedIn ? 'theme-highlight-text-color' : 'primary-text-color';
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/Auth/MagicLinkVerifyPage.vue?vue&type=script&lang=js
 /* harmony default export */ var Auth_MagicLinkVerifyPagevue_type_script_lang_js = (MagicLinkVerifyPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/Auth/MagicLinkVerifyPage.vue?vue&type=style&index=0&id=dfec2abc&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var MagicLinkVerifyPagevue_type_style_index_0_id_dfec2abc_prod_lang_scss_module_true = ({"content":"MagicLinkVerifyPage_content_Gk4NH","magicLinkFailed":"MagicLinkVerifyPage_magicLinkFailed_Nz6wR","redirectButton":"MagicLinkVerifyPage_redirectButton_Vyola"});
;// CONCATENATED MODULE: ./src/examples/Auth/MagicLinkVerifyPage.vue?vue&type=style&index=0&id=dfec2abc&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/Auth/MagicLinkVerifyPage.vue



;




function MagicLinkVerifyPage_injectStyles (context) {
  
  this["$style"] = (MagicLinkVerifyPagevue_type_style_index_0_id_dfec2abc_prod_lang_scss_module_true.locals || MagicLinkVerifyPagevue_type_style_index_0_id_dfec2abc_prod_lang_scss_module_true)

}

/* normalize component */

var MagicLinkVerifyPage_component = normalizeComponent(
  Auth_MagicLinkVerifyPagevue_type_script_lang_js,
  MagicLinkVerifyPagevue_type_template_id_dfec2abc_render,
  MagicLinkVerifyPagevue_type_template_id_dfec2abc_staticRenderFns,
  false,
  MagicLinkVerifyPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var MagicLinkVerifyPage = (MagicLinkVerifyPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventAgenda/EventAgenda.vue?vue&type=template&id=731bfbc0
var EventAgendavue_type_template_id_731bfbc0_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "id": "stageAgendaItemContainer",
      "aria-live": "polite"
    }
  }, [!_vm.loading ? [_vm.visiblePage.length ? _c('div', [_vm._l(_vm.visiblePage, function (item) {
    return [item.kind === 'date' ? _c('LabeledSeparator', {
      key: item.title,
      attrs: {
        "variant": "subHeading15"
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")]) : [_vm.isManualRedirectionEnabled ? _c('AgendaItemV2', {
      key: item.id + 'V2',
      attrs: {
        "id": `agendaItem__${item.id}`,
        "broadcast": item,
        "selectedTags": _vm.filterTags,
        "current-user-id": _vm.currentUserId,
        "searchTerm": _vm.searchTerm,
        "onDemandMode": _vm.onDemandMode,
        "ticketsEnabled": _vm.ticketsEnabled,
        "isEventOrganizer": _vm.isEventOrganizer,
        "speakerCTAText": _vm.speakerCTAText(item),
        "url": _vm.atcurl,
        "timezone": _vm.timezone,
        "localTimezone": _vm.localTimezone,
        "showLocation": _vm.showLocation,
        "isFavorited": _vm.isFavorited(item),
        "showFavorites": _vm.showFavorites,
        "heartbeatDate": _vm.heartbeatDate,
        "isManualRedirectionEnabled": _vm.isManualRedirectionEnabled
      },
      on: {
        "addtocal-mounted": function ($event) {
          return _vm.$emit('addtocal-mounted');
        },
        "userClicked": function ($event) {
          return _vm.$emit('user-clicked', $event);
        },
        "join": function ($event) {
          return _vm.$emit('join', item);
        },
        "toggleFavorite": function ($event) {
          return _vm.$emit('toggleFavorite', item);
        },
        "startSessionManually": function ($event) {
          return _vm.$emit('startSessionManually', item);
        },
        "endSessionManually": function ($event) {
          return _vm.$emit('endSessionManually', item);
        }
      }
    }) : _c('AgendaItem', {
      key: item.id,
      attrs: {
        "id": `agendaItem__${item.id}`,
        "broadcast": item,
        "selectedTags": _vm.filterTags,
        "current-user-id": _vm.currentUserId,
        "searchTerm": _vm.searchTerm,
        "onDemandMode": _vm.onDemandMode,
        "ticketsEnabled": _vm.ticketsEnabled,
        "isEventOrganizer": _vm.isEventOrganizer,
        "speakerCTAText": _vm.speakerCTAText(item),
        "url": _vm.atcurl,
        "timezone": _vm.timezone,
        "localTimezone": _vm.localTimezone,
        "showLocation": _vm.showLocation,
        "isFavorited": _vm.isFavorited(item),
        "showFavorites": _vm.showFavorites
      },
      on: {
        "addtocal-mounted": function ($event) {
          return _vm.$emit('addtocal-mounted');
        },
        "userClicked": function ($event) {
          return _vm.$emit('user-clicked', $event);
        },
        "join": function ($event) {
          return _vm.$emit('join', item);
        },
        "toggleFavorite": function ($event) {
          return _vm.$emit('toggleFavorite', item);
        }
      }
    })]];
  })], 2) : _c('AgendaEmptyState', {
    attrs: {
      "agendaFilters": _vm.agendaFilters
    }
  }), _vm.pages > 1 ? _c('Paginator', {
    attrs: {
      "value": _vm.currentPage,
      "pages": _vm.pages
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('currentPage', $event);
      }
    }
  }) : _vm._e()] : _c('ProgressBar', [_vm._v(" " + _vm._s(_vm.$options.$t('loading')) + "... ")])], 2);
};
var EventAgendavue_type_template_id_731bfbc0_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventAgenda/AgendaItem.vue?vue&type=template&id=e86a9fb6
var AgendaItemvue_type_template_id_e86a9fb6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.live]: _vm.broadcast.is_live,
      [_vm.$style.disabled]: _vm.broadcast.disabled
    },
    attrs: {
      "data-branding-target": "agenda-item"
    }
  }, [_c('div', {
    class: _vm.$style.dates
  }, [_vm.broadcast.is_live && _vm.showLiveButton ? _c('StyledText', {
    class: _vm.$style.liveMode,
    attrs: {
      "variant": "heading13",
      "color": "color-highlight",
      "data-branding-target": "agenda-item-specs"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('LIVE')) + " ")]) : _vm._e(), _c('StyledText', {
    class: _vm.$style.time,
    attrs: {
      "variant": "body14",
      "color": "primary-text-color",
      "data-branding-target": _vm.dataBrandingTarget
    }
  }, [_vm._v(" " + _vm._s(_vm.startTime) + " - " + _vm._s(_vm.endTime) + " " + _vm._s(_vm.formattedLocalTimezone) + " ")]), _vm.showLocation ? _c('StyledText', {
    class: _vm.$style.time,
    attrs: {
      "variant": "body14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.broadcast.location || _vm.$options.$t('Virtual')) + " ")]) : _vm._e()], 1), _c('div', {
    class: _vm.$style.aboutAgenda
  }, [_c('div', {
    class: _vm.$style.top
  }, [_c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "subHeading18",
      "color": "primary-text-color",
      "data-branding-target": "agenda-item-title"
    }
  }, [_vm._v(" " + _vm._s(_vm.broadcast.title) + " ")]), _c('div', {
    class: _vm.$style.topRight
  }, [
  // tickets_enabled is true is for vivenu ticketing.
  // But for vivenu ticketing we currently want to hide the ticket types, hence this check.
  // Yeah it's misleading but product wants to keep two versions of ticketing. SMH...
  _vm.ticketsEnabled === false && _vm.broadcast.tickets ? _c('GTooltip', {
    attrs: {
      "text": _vm.broadcast.tickets && _vm.broadcast.tickets.join(', '),
      "position": "bottom-right"
    }
  }, [_c('StyledText', {
    attrs: {
      "variant": "body13",
      "display": "block",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.broadcast.tickets && _vm.broadcast.tickets.join(', ')) + " ")])], 1) : _vm._e(), _vm.broadcast.type !== 'BREAK' && _vm.showFavorites ? _c('FavoriteButton', {
    attrs: {
      "isFavorited": _vm.isFavorited
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('toggleFavorite');
      }
    }
  }) : _vm._e()], 1)], 1), _c('RichText', {
    attrs: {
      "data-branding-target": "agenda-item-description",
      "text": _vm.broadcast.description
    }
  }), _c('div', {
    class: _vm.$style.tags
  }, [_vm._l(_vm.visibleTags.tags || [], function (tag, index) {
    return _c('StyledText', {
      key: index,
      class: {
        [_vm.$style.tag]: true,
        [_vm.$style.highlighted]: _vm.highlightTag(tag)
      },
      attrs: {
        "variant": "body15",
        "color": "primary-text-color"
      }
    }, [_vm._v(" #" + _vm._s(tag) + " ")]);
  }), _vm.visibleTags.more > 0 ? _c('StyledText', {
    class: {
      [_vm.$style.tag]: true,
      [_vm.$style.moreTag]: true
    },
    attrs: {
      "variant": "subHeading13",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        _vm.tagReadMore = true;
      }
    }
  }, [_vm._v(" +" + _vm._s(_vm.visibleTags.more) + " more ")]) : _vm._e()], 2), _c('div', {
    class: _vm.$style.bottom
  }, [_c('div', {
    class: _vm.$style.users
  }, [_c('ul', {
    class: _vm.$style.speakerList
  }, _vm._l(_vm.getBroadcastSpeakers, function (user) {
    return _c('li', {
      key: user.id
    }, [_c('UserTooltip', {
      attrs: {
        "user": user
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('userClicked', user);
        }
      }
    })], 1);
  }), 0)]), _c('div', {
    class: _vm.$style.actionButtons
  }, [_vm.onDemandMode ? [_vm.isInPast && !_vm.isWebinar && _vm.broadcast.is_available_on_demand && !_vm.broadcast.disabled && _vm.letButtonsShow ? _c('GTooltip', {
    attrs: {
      "text": _vm.$options.$t('Recording for this broadcast is currently being processed and will be available soon'),
      "disabled": !!_vm.broadcast.on_demand_asset,
      "position": "top-right"
    }
  }, [_c('PillButton', {
    attrs: {
      "disabled": !_vm.broadcast.on_demand_asset,
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('join');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Play Recording')) + " ")])], 1) : _vm._e()] : _vm.letButtonsShow ? [_c('GTooltip', {
    attrs: {
      "text": _vm.$options.$t('Only available for ') + (_vm.broadcast.tickets && _vm.broadcast.tickets.join(', ')),
      "disabled": !_vm.broadcast.disabled,
      "position": "top-right"
    }
  }, [_vm.broadcast.type !== 'BREAK' ? [(_vm.isSpeaker || _vm.isOrganizer || _vm.isEventOrganizer) && _vm.broadcast.type === 'BROADCAST' ? _c('PillButton', {
    attrs: {
      "boldText": "",
      "disabled": _vm.broadcast.disabled || _vm.loading,
      "loading": _vm.loading,
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('join');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$options.$t(_vm.speakerCTAText)))])]) : _vm.broadcast.is_live ? _c('PillButton', {
    attrs: {
      "disabled": _vm.broadcast.disabled || _vm.loading,
      "loading": _vm.loading,
      "boldText": "",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('join');
      }
    }
  }, [_vm.broadcast.type === 'BROADCAST' ? [_vm._v(" " + _vm._s(_vm.$options.$t('Join')) + " ")] : ['BOOTH', 'BOOTH2'].includes(_vm.broadcast.type) ? [_vm._v(" " + _vm._s(_vm.$options.$t('See Booths')) + " ")] : [_vm._v(" " + _vm._s(_vm.$options.$t('See Rooms')) + " ")]], 2) : _vm._e()] : _vm._e()], 2)] : _vm._e(), _vm.isInFuture ? _c('AtcButton', {
    attrs: {
      "disabled": _vm.broadcast.disabled,
      "start_time": _vm.broadcast.start_time,
      "end_time": _vm.broadcast.end_time,
      "title": _vm.broadcast.title,
      "url": _vm.url,
      "timezone": _vm.timezone
    }
  }) : _vm._e()], 2)])], 1)]);
};
var AgendaItemvue_type_template_id_e86a9fb6_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/RichText.vue?vue&type=template&id=4f47c8fb
var RichTextvue_type_template_id_4f47c8fb_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('StyledText', {
    attrs: {
      "variant": "noBodyVariant",
      "display": "inline",
      "color": "primary-text-color"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getText)
    }
  }), _vm.showReadMoreLessCta ? _c('TextButton', {
    class: _vm.$style.readMoreLessButton,
    attrs: {
      "color": "primary-text-color",
      "variant": "body15",
      "uppercase": false
    },
    on: {
      "click": _vm.handleReadMoreLessCtaClick
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.textExpanded ? _vm.$options.$t('Read Less') : _vm.$options.$t('Read More')))])]) : _vm._e()], 1)], 1);
};
var RichTextvue_type_template_id_4f47c8fb_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/RichText.vue?vue&type=script&lang=js

/* harmony default export */ var RichTextvue_type_script_lang_js = ({
  name: 'RichText',
  data() {
    return {
      textExpanded: false
    };
  },
  props: {
    text: {
      type: String,
      default: null
    },
    maxStringLength: {
      type: Number,
      default: 200
    }
  },
  computed: {
    showReadMoreLessCta() {
      return this.text?.length > this.maxStringLength;
    },
    getText() {
      if (this.text?.length > this.maxStringLength && !this.textExpanded) {
        return this.getTrimmedHtml(this.text, this.maxStringLength);
      }
      return this.text;
    }
  },
  methods: {
    handleReadMoreLessCtaClick() {
      this.textExpanded = !this.textExpanded;
    },
    getTrimmedHtml(html, maxStringLimit) {
      const limit = maxStringLimit || 100;
      const preserveTags = true;
      const wordBreak = false;
      const suffix = '...';
      let arr = html.replace(/</g, '\n<').replace(/>/g, '>\n').replace(/\n\n/g, '\n').replace(/^\n/g, '').replace(/\n$/g, '').split('\n');
      let sum = 0;
      let row;
      let cut;
      let add;
      let tagMatch;
      let tagName;
      let tagStack = [];
      for (let i = 0; i < arr.length; i++) {
        row = arr[i];
        // count multiple spaces as one character
        let rowCut = row.replace(/[ ]+/g, ' ');
        if (!row.length) {
          continue;
        }
        if (row[0] !== '<') {
          if (sum >= limit) {
            row = '';
          } else if (sum + rowCut.length >= limit) {
            cut = limit - sum;
            if (row[cut - 1] === ' ') {
              while (cut) {
                cut -= 1;
                if (row[cut - 1] !== ' ') {
                  break;
                }
              }
            } else {
              add = row.substring(cut).split('').indexOf(' ');

              // break on halh of word
              if (!wordBreak) {
                if (add !== -1) {
                  cut += add;
                } else {
                  cut = row.length;
                }
              }
            }
            row = row.substring(0, cut) + suffix;
            sum = limit;
          } else {
            sum += rowCut.length;
          }
        } else if (!preserveTags) {
          row = '';
        } else if (sum >= limit) {
          tagMatch = row.match(/[a-zA-Z]+/);
          tagName = tagMatch ? tagMatch[0] : '';
          if (tagName) {
            if (row.substring(0, 2) !== '</') {
              tagStack.push(tagName);
              row = '';
            } else {
              while (tagStack[tagStack.length - 1] !== tagName && tagStack.length) {
                tagStack.pop();
              }
              if (tagStack.length) {
                row = '';
              }
              tagStack.pop();
            }
          } else {
            row = '';
          }
        }
        arr[i] = row;
      }
      return arr.join('\n').replace(/\n/g, '');
    }
  }
});
;// CONCATENATED MODULE: ./src/molecules/RichText.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_RichTextvue_type_script_lang_js = (RichTextvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/RichText.vue?vue&type=style&index=0&id=4f47c8fb&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var RichTextvue_type_style_index_0_id_4f47c8fb_prod_module_true_lang_scss = ({"root":"RichText_root_NCB2I","readMoreLessButton":"RichText_readMoreLessButton_LjLKl"});
;// CONCATENATED MODULE: ./src/molecules/RichText.vue?vue&type=style&index=0&id=4f47c8fb&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/RichText.vue



;




function RichText_injectStyles (context) {
  
  this["$style"] = (RichTextvue_type_style_index_0_id_4f47c8fb_prod_module_true_lang_scss.locals || RichTextvue_type_style_index_0_id_4f47c8fb_prod_module_true_lang_scss)

}

/* normalize component */

var RichText_component = normalizeComponent(
  molecules_RichTextvue_type_script_lang_js,
  RichTextvue_type_template_id_4f47c8fb_render,
  RichTextvue_type_template_id_4f47c8fb_staticRenderFns,
  false,
  RichText_injectStyles,
  null,
  null
  
)

/* harmony default export */ var RichText = (RichText_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventAgenda/AgendaItem.vue?vue&type=script&lang=js




/* harmony default export */ var AgendaItemvue_type_script_lang_js = ({
  name: 'AgendaItem',
  components: {
    AtcButton: AtcButton,
    RichText: RichText
  },
  props: {
    broadcast: Object,
    selectedTags: Array,
    currentUserId: String,
    searchTerm: String,
    onDemandMode: Boolean,
    letButtonsShow: {
      type: Boolean,
      default: true
    },
    ticketsEnabled: Boolean,
    maxVisibleTagCharacters: {
      type: Number,
      default: 20
    },
    loading: Boolean,
    isSplash: {
      type: Boolean,
      default: false
    },
    showLiveButton: {
      type: Boolean,
      default: true
    },
    isWebinar: {
      type: Boolean,
      default: false
    },
    timezone: {
      type: String,
      default: 'UTC'
    },
    localTimezone: {
      type: String,
      default: 'UTC'
    },
    location: {
      type: String,
      default: ''
    },
    speakerCTAText: {
      type: String,
      default: 'Enter Backstage'
    },
    isEventOrganizer: Boolean,
    url: String,
    showLocation: Boolean,
    isFavorited: Boolean,
    showFavorites: Boolean,
    dataBrandingTarget: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tagReadMore: false
    };
  },
  mounted() {
    this.$emit('addtocal-mounted');
  },
  computed: {
    formattedLocalTimezone() {
      return getTimeZoneFromDate(this.broadcast?.start_time);
    },
    getBroadcastSpeakers() {
      return this.broadcast.speakers?.filter(e => !e.hidden);
    },
    overflowing() {
      return (this.broadcast.description || '').length > this.maxStringLength;
    },
    isInPast() {
      return new Date(this.broadcast.end_time) < new Date();
    },
    isInFuture() {
      return new Date(this.broadcast.end_time) > new Date();
    },
    startTime() {
      return timeFormatter.format(new Date(this.broadcast.start_time));
    },
    endTime() {
      return timeFormatter.format(new Date(this.broadcast.end_time));
    },
    userColumns() {
      const perColumn = 4;
      return [(this.broadcast.speakers || []).slice(0, perColumn), (this.broadcast.speakers || []).slice(perColumn, perColumn * 2)].filter(col => col.length > 0);
    },
    isSpeaker() {
      return (this.broadcast.speakers || []).some(user => user.id === this.currentUserId);
    },
    isOrganizer() {
      return (this.broadcast.moderator || []).includes(this.currentUserId);
    },
    visibleTags() {
      return (this.broadcast.tags || []).reduce((acc, tag) => {
        if (acc.count >= this.maxVisibleTagCharacters && !this.tagReadMore) {
          acc.more += 1;
        } else {
          acc.count += tag.length;
          acc.tags.push(tag.toLowerCase());
        }
        return acc;
      }, {
        tags: [],
        more: 0,
        count: 0
      });
    }
  },
  methods: {
    highlightTag(tag) {
      return this.searchTerm && tag && tag.includes(this.searchTerm.toLowerCase()) || this.selectedTags && this.selectedTags.includes(tag);
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaItem.vue?vue&type=script&lang=js
 /* harmony default export */ var EventAgenda_AgendaItemvue_type_script_lang_js = (AgendaItemvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventAgenda/AgendaItem.vue?vue&type=style&index=0&id=e86a9fb6&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var AgendaItemvue_type_style_index_0_id_e86a9fb6_prod_module_true_lang_scss = ({"root":"AgendaItem_root_qmTuR","disabled":"AgendaItem_disabled_we2ee","live":"AgendaItem_live_T8b1G","dates":"AgendaItem_dates_DXp5n","time":"AgendaItem_time_Hg3ti","aboutAgenda":"AgendaItem_aboutAgenda_KTknO","top":"AgendaItem_top_g9PKl","title":"AgendaItem_title_juDto","topRight":"AgendaItem_topRight_CbIvC","description":"AgendaItem_description_rLsmV","users":"AgendaItem_users_AGg8I","tags":"AgendaItem_tags_s6ctp","tag":"AgendaItem_tag_jM4xA","highlighted":"AgendaItem_highlighted_R0utV","moreTag":"AgendaItem_moreTag_PDtNe","actionButtons":"AgendaItem_actionButtons_Wn3CE","bottom":"AgendaItem_bottom_iPtl5","speakerList":"AgendaItem_speakerList_GRLjp"});
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaItem.vue?vue&type=style&index=0&id=e86a9fb6&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaItem.vue



;




function AgendaItem_injectStyles (context) {
  
  this["$style"] = (AgendaItemvue_type_style_index_0_id_e86a9fb6_prod_module_true_lang_scss.locals || AgendaItemvue_type_style_index_0_id_e86a9fb6_prod_module_true_lang_scss)

}

/* normalize component */

var AgendaItem_component = normalizeComponent(
  EventAgenda_AgendaItemvue_type_script_lang_js,
  AgendaItemvue_type_template_id_e86a9fb6_render,
  AgendaItemvue_type_template_id_e86a9fb6_staticRenderFns,
  false,
  AgendaItem_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AgendaItem = (AgendaItem_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventAgenda/AgendaItemV2.vue?vue&type=template&id=71e0f3fe
var AgendaItemV2vue_type_template_id_71e0f3fe_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      [_vm.$style.root]: true,
      [_vm.$style.live]: _vm.broadcast.is_live,
      [_vm.$style.disabled]: _vm.broadcast.disabled
    },
    attrs: {
      "data-branding-target": "agenda-item"
    }
  }, [_c('div', {
    class: _vm.$style.badgeContainer
  }, [_vm.badgeTextAndColor.text ? _c('Badge', {
    attrs: {
      "data-branding-target": "agenda-item-specs",
      "variant": _vm.badgeTextAndColor.color,
      "text": _vm.badgeTextAndColor.text
    }
  }) : _vm._e()], 1), _c('div', {
    class: _vm.$style.infoContainer
  }, [_c('div', {
    class: _vm.$style.dates
  }, [_c('StyledText', {
    class: _vm.$style.time,
    attrs: {
      "variant": "body14",
      "color": "primary-text-color",
      "data-branding-target": _vm.dataBrandingTarget
    }
  }, [_vm._v(" " + _vm._s(_vm.startTime) + " - " + _vm._s(_vm.endTime) + " " + _vm._s(_vm.formattedLocalTimezone) + " ")]), _vm.showLocation ? _c('StyledText', {
    class: _vm.$style.time,
    attrs: {
      "variant": "body14",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.broadcast.location || _vm.$t('Virtual')) + " ")]) : _vm._e()], 1), _c('div', {
    class: _vm.$style.aboutAgenda
  }, [_c('div', {
    class: _vm.$style.top
  }, [_c('StyledText', {
    class: _vm.$style.title,
    attrs: {
      "variant": "subHeading18",
      "color": "primary-text-color",
      "data-branding-target": "agenda-item-title"
    }
  }, [_vm._v(" " + _vm._s(_vm.broadcast.title) + " ")]), _c('div', {
    class: _vm.$style.topRight
  }, [
  // tickets_enabled is true is for vivenu ticketing.
  // But for vivenu ticketing we currently want to hide the ticket types, hence this check.
  // Yeah it's misleading but product wants to keep two versions of ticketing. SMH...
  _vm.ticketsEnabled === false && _vm.broadcast.tickets ? _c('GTooltip', {
    attrs: {
      "text": _vm.broadcast.tickets && _vm.broadcast.tickets.join(', '),
      "position": "bottom-right"
    }
  }, [_c('StyledText', {
    attrs: {
      "variant": "body13",
      "display": "block",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.broadcast.tickets && _vm.broadcast.tickets.join(', ')) + " ")])], 1) : _vm._e(), _vm.broadcast.type !== 'BREAK' && _vm.showFavorites ? _c('FavoriteButton', {
    attrs: {
      "isFavorited": _vm.isFavorited
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('toggleFavorite');
      }
    }
  }) : _vm._e()], 1)], 1), _c('RichText', {
    attrs: {
      "data-branding-target": "agenda-item-description",
      "text": _vm.broadcast.description
    }
  }), _c('div', {
    class: _vm.$style.tags
  }, [_vm._l(_vm.visibleTags.tags || [], function (tag, index) {
    return _c('StyledText', {
      key: index,
      class: {
        [_vm.$style.tag]: true,
        [_vm.$style.highlighted]: _vm.highlightTag(tag)
      },
      attrs: {
        "variant": "body15",
        "color": "primary-text-color"
      }
    }, [_vm._v(" #" + _vm._s(tag) + " ")]);
  }), _vm.visibleTags.more > 0 ? _c('StyledText', {
    class: {
      [_vm.$style.tag]: true,
      [_vm.$style.moreTag]: true
    },
    attrs: {
      "variant": "subHeading13",
      "color": "primary-text-color"
    },
    on: {
      "click": function ($event) {
        _vm.tagReadMore = true;
      }
    }
  }, [_vm._v(" +" + _vm._s(_vm.visibleTags.more) + " more ")]) : _vm._e()], 2), _c('div', {
    class: _vm.$style.bottom
  }, [_c('div', {
    class: _vm.$style.users
  }, [_c('ul', {
    class: _vm.$style.speakerList
  }, _vm._l(_vm.getBroadcastSpeakers, function (user) {
    return _c('li', {
      key: user.id
    }, [_c('UserTooltip', {
      attrs: {
        "user": user
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('userClicked', user);
        }
      }
    })], 1);
  }), 0)]), _c('div', {
    class: _vm.$style.actionButtons
  }, [_vm.onDemandMode ? [_vm.showProcessingRecordingToolTip ? _c('GTooltip', {
    attrs: {
      "text": _vm.$t('Recording for this broadcast is currently being processed and will be available soon'),
      "disabled": !!_vm.broadcast.on_demand_asset,
      "position": "top-right"
    }
  }, [_c('PillButton', {
    attrs: {
      "disabled": !_vm.broadcast.on_demand_asset,
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('join');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Play Recording')) + " ")])], 1) : _vm._e()] : _vm.letButtonsShow ? [_c('GTooltip', {
    attrs: {
      "text": _vm.$t('Only available for ') + (_vm.broadcast.tickets && _vm.broadcast.tickets.join(', ')),
      "disabled": !_vm.broadcast.disabled,
      "position": "top-right"
    }
  }, [_vm.broadcast.type !== 'BREAK' ? [_vm.showEnterBackStageButton ? _c('PillButton', {
    attrs: {
      "boldText": "",
      "disabled": _vm.broadcast.disabled || _vm.loading,
      "loading": _vm.loading,
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('join');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.speakerCTAText)))])]) : _vm.broadcast.is_live ? _c('PillButton', {
    attrs: {
      "disabled": _vm.broadcast.disabled || _vm.loading,
      "loading": _vm.loading,
      "boldText": "",
      "uppercase": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('join');
      }
    }
  }, [_vm.isBroadcast ? [_vm._v(" " + _vm._s(_vm.$t('Join')) + " ")] : _vm.isBooth ? [_vm._v(" " + _vm._s(_vm.$t('See Booths')) + " ")] : [_vm._v(" " + _vm._s(_vm.$t('See Rooms')) + " ")]], 2) : _vm._e()] : _vm._e(), _vm.showSessionControlButtons ? [_vm.showStartSessionButton ? _c('OutlinedButton', {
    class: _vm.$style.startSession,
    attrs: {
      "disabled": _vm.broadcast.disabled || _vm.loading || _vm.isButtonLoading,
      "loading": _vm.loading,
      "size": "small"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('startSessionManually');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.speakerStartSessionText)))])]) : _vm._e(), _vm.broadcast.is_live ? _c('OutlinedButton', {
    class: _vm.$style.startSession,
    attrs: {
      "disabled": _vm.broadcast.disabled || _vm.loading || _vm.isButtonLoading,
      "loading": _vm.loading,
      "size": "small"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('endSessionManually');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.speakerEndSessionText)))])]) : _vm._e(), _vm.timer.show && !_vm.broadcast.is_live && !_vm.timer.highlight ? _c('Countdown', {
    class: _vm.$style.startSession,
    attrs: {
      "prefixText": "Live in",
      "duration": _vm.timer.time
    }
  }) : _vm._e()] : _vm._e()], 2)] : _vm._e(), _vm.isInFuture ? _c('AtcButton', {
    attrs: {
      "disabled": _vm.broadcast.disabled,
      "start_time": _vm.broadcast.start_time,
      "end_time": _vm.broadcast.end_time,
      "title": _vm.broadcast.title,
      "url": _vm.url,
      "timezone": _vm.timezone
    }
  }) : _vm._e()], 2)])], 1)])]);
};
var AgendaItemV2vue_type_template_id_71e0f3fe_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventAgenda/AgendaItemV2.vue?vue&type=script&lang=js





/* harmony default export */ var AgendaItemV2vue_type_script_lang_js = ({
  name: 'AgendaItemV2',
  components: {
    AtcButton: AtcButton,
    RichText: RichText,
    Countdown: Countdown
  },
  props: {
    broadcast: Object,
    selectedTags: Array,
    currentUserId: String,
    searchTerm: String,
    onDemandMode: Boolean,
    letButtonsShow: {
      type: Boolean,
      default: true
    },
    ticketsEnabled: Boolean,
    maxVisibleTagCharacters: {
      type: Number,
      default: 20
    },
    loading: Boolean,
    isSplash: {
      type: Boolean,
      default: false
    },
    showLiveButton: {
      type: Boolean,
      default: true
    },
    isWebinar: {
      type: Boolean,
      default: false
    },
    timezone: {
      type: String,
      default: 'UTC'
    },
    localTimezone: {
      type: String,
      default: 'UTC'
    },
    location: {
      type: String,
      default: ''
    },
    speakerCTAText: {
      type: String,
      default: 'Enter Backstage'
    },
    speakerStartSessionText: {
      type: String,
      default: 'Start Session'
    },
    speakerEndSessionText: {
      type: String,
      default: 'End Session'
    },
    isEventOrganizer: Boolean,
    url: String,
    showLocation: Boolean,
    isFavorited: Boolean,
    showFavorites: Boolean,
    dataBrandingTarget: {
      type: String,
      default: ''
    },
    heartbeatDate: {
      type: Date
    },
    isManualRedirectionEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tagReadMore: false,
      countingDown: false,
      countdownStopped: false
    };
  },
  mounted() {
    this.$emit('addtocal-mounted');
  },
  computed: {
    formattedLocalTimezone() {
      return getTimeZoneFromDate(this.broadcast?.start_time);
    },
    getBroadcastSpeakers() {
      return this.broadcast.speakers?.filter(e => !e.hidden);
    },
    overflowing() {
      return (this.broadcast.description || '').length > this.maxStringLength;
    },
    isInPast() {
      return new Date(this.broadcast.end_time) < new Date();
    },
    isInFuture() {
      return new Date(this.broadcast.end_time) > new Date();
    },
    startTime() {
      return timeFormatter.format(new Date(this.broadcast.start_time));
    },
    endTime() {
      return timeFormatter.format(new Date(this.broadcast.end_time));
    },
    userColumns() {
      const perColumn = 4;
      return [(this.broadcast.speakers || []).slice(0, perColumn), (this.broadcast.speakers || []).slice(perColumn, perColumn * 2)].filter(col => col.length > 0);
    },
    isSpeaker() {
      return (this.broadcast.speakers || []).some(user => user.id === this.currentUserId);
    },
    isOrganizer() {
      return (this.broadcast.moderator || []).includes(this.currentUserId);
    },
    visibleTags() {
      return (this.broadcast.tags || []).reduce((acc, tag) => {
        if (acc.count >= this.maxVisibleTagCharacters && !this.tagReadMore) {
          acc.more += 1;
        } else {
          acc.count += tag.length;
          acc.tags.push(tag.toLowerCase());
        }
        return acc;
      }, {
        tags: [],
        more: 0,
        count: 0
      });
    },
    showProcessingRecordingToolTip() {
      return this.isInPast && !this.isWebinar && this.broadcast.is_available_on_demand && !this.broadcast.disabled && this.letButtonsShow;
    },
    showEnterBackStageButton() {
      return (this.isSpeaker || this.isOrganizer || this.isEventOrganizer) && this.broadcast.type === 'BROADCAST';
    },
    showSessionControlButtons() {
      if (this.isManualRedirectionEnabled) {
        const {
          type
        } = this.broadcast;
        if (type === 'BREAK') {
          return this.isOrganizer || this.isEventOrganizer;
        }
        return (this.isSpeaker || this.isOrganizer || this.isEventOrganizer) && (type === 'BROADCAST' || type === 'DISCUSSION_GROUP' || type === 'BOOTH');
      }
      return false;
    },
    showStartSessionButton() {
      const allowedStartTime = new Date(this.broadcast.allowed_start_time);
      const now = new Date();
      const allowedEndTime = new Date(this.broadcast.allowed_end_time);
      const canStartSession = now >= allowedStartTime && now < allowedEndTime;
      return !this.broadcast.is_live && !this.timer.show && canStartSession;
    },
    isBroadcast() {
      return this.broadcast.type === 'BROADCAST';
    },
    isBooth() {
      return ['BOOTH', 'BOOTH2'].includes(this.broadcast.type);
    },
    timer() {
      let diff = timeDiff(this.heartbeatDate, this.broadcast?.live_start_time),
        highlight,
        time = formatDurationV2(this.heartbeatDate, this.broadcast?.live_start_time, false);
      if (diff && diff > 0 && this.isBroadcastLive) {
        return {
          show: false,
          highlight,
          time: ''
        };
      }
      return {
        show: diff > 0 && diff <= 30000 && !!time,
        highlight,
        time
      };
    },
    showLiveBadge() {
      return this.broadcast.is_live && this.showLiveButton;
    },
    badgeTextAndColor() {
      const wasLiveEarlier = this.broadcast?.live_start_time && this.broadcast?.live_end_time;
      // This is needed to show the "upcoming" badge when organizer restart the session and we show 30s countdown
      const upcomingSession = this.broadcast?.live_start_time && !this.broadcast?.live_end_time;
      if (this.showLiveBadge) {
        return {
          text: 'live',
          color: 'danger'
        };
      }
      if (this.isInPast || wasLiveEarlier) {
        return {
          text: 'ended',
          color: 'info'
        };
      }
      if (this.isInFuture || upcomingSession) {
        return {
          text: 'upcoming',
          color: 'secondary'
        };
      }
      return {
        text: '',
        color: ''
      };
    },
    isButtonLoading() {
      return this.broadcast?.agenda_control_loading_state?.start_button || this.broadcast?.agenda_control_loading_state?.end_button;
    }
  },
  methods: {
    highlightTag(tag) {
      return this.searchTerm && tag && tag?.includes(this.searchTerm?.toLowerCase()) || this.selectedTags && this.selectedTags.includes(tag);
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaItemV2.vue?vue&type=script&lang=js
 /* harmony default export */ var EventAgenda_AgendaItemV2vue_type_script_lang_js = (AgendaItemV2vue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventAgenda/AgendaItemV2.vue?vue&type=style&index=0&id=71e0f3fe&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var AgendaItemV2vue_type_style_index_0_id_71e0f3fe_prod_module_true_lang_scss = ({"root":"AgendaItemV2_root_TbHil","infoContainer":"AgendaItemV2_infoContainer_It6vD","disabled":"AgendaItemV2_disabled_wIBTm","live":"AgendaItemV2_live_N0KdR","dates":"AgendaItemV2_dates_f7otH","time":"AgendaItemV2_time_l7rp1","aboutAgenda":"AgendaItemV2_aboutAgenda_Ny6Wu","top":"AgendaItemV2_top_f3wTh","title":"AgendaItemV2_title_AeZSI","topRight":"AgendaItemV2_topRight_ObTId","description":"AgendaItemV2_description_WgUkg","users":"AgendaItemV2_users_lJgew","tags":"AgendaItemV2_tags_I3L8U","tag":"AgendaItemV2_tag_TZN1G","highlighted":"AgendaItemV2_highlighted_TKXeB","moreTag":"AgendaItemV2_moreTag_wN6eS","actionButtons":"AgendaItemV2_actionButtons_K8Mn5","startSession":"AgendaItemV2_startSession_L_Vr4","bottom":"AgendaItemV2_bottom__jyQP","speakerList":"AgendaItemV2_speakerList_LBQXS"});
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaItemV2.vue?vue&type=style&index=0&id=71e0f3fe&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaItemV2.vue



;




function AgendaItemV2_injectStyles (context) {
  
  this["$style"] = (AgendaItemV2vue_type_style_index_0_id_71e0f3fe_prod_module_true_lang_scss.locals || AgendaItemV2vue_type_style_index_0_id_71e0f3fe_prod_module_true_lang_scss)

}

/* normalize component */

var AgendaItemV2_component = normalizeComponent(
  EventAgenda_AgendaItemV2vue_type_script_lang_js,
  AgendaItemV2vue_type_template_id_71e0f3fe_render,
  AgendaItemV2vue_type_template_id_71e0f3fe_staticRenderFns,
  false,
  AgendaItemV2_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AgendaItemV2 = (AgendaItemV2_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventAgenda/AgendaEmptyState.vue?vue&type=template&id=da37ebea
var AgendaEmptyStatevue_type_template_id_da37ebea_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_vm.config.icon ? _c('SvgIcon', {
    attrs: {
      "name": _vm.config.icon
    }
  }) : _vm._e(), _c('StyledText', {
    attrs: {
      "variant": "heading16",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.config.heading) + " ")]), _vm.config.subheading ? _c('StyledText', {
    attrs: {
      "align": "center",
      "variant": "subHeading14"
    }
  }, [_vm._v(" " + _vm._s(_vm.config.subheading) + " ")]) : _vm._e()], 1);
};
var AgendaEmptyStatevue_type_template_id_da37ebea_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventAgenda/AgendaEmptyState.vue?vue&type=script&lang=js
/* harmony default export */ var AgendaEmptyStatevue_type_script_lang_js = ({
  name: 'AgendaEmptyState',
  props: {
    agendaFilters: Object
  },
  computed: {
    config() {
      if (this.agendaFilters?.agendaFavoritesFilter) {
        return {
          heading: this.$options.$t("You haven't favorited anything yet!"),
          subheading: this.$options.$t('Add an item to favorites by selecting the ♡ in the top right corner.'),
          icon: 'heartbreak'
        };
      }
      if (this.agendaFilters?.trackFilter?.value) {
        return {
          heading: this.$options.$t('This track has no upcoming sessions. Check out a different track.')
        };
      }
      return {
        heading: this.$options.$t('No Agenda Items to show!')
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaEmptyState.vue?vue&type=script&lang=js
 /* harmony default export */ var EventAgenda_AgendaEmptyStatevue_type_script_lang_js = (AgendaEmptyStatevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventAgenda/AgendaEmptyState.vue?vue&type=style&index=0&id=da37ebea&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var AgendaEmptyStatevue_type_style_index_0_id_da37ebea_prod_lang_scss_module_true = ({"root":"AgendaEmptyState_root_OKAwR"});
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaEmptyState.vue?vue&type=style&index=0&id=da37ebea&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/EventAgenda/AgendaEmptyState.vue



;




function AgendaEmptyState_injectStyles (context) {
  
  this["$style"] = (AgendaEmptyStatevue_type_style_index_0_id_da37ebea_prod_lang_scss_module_true.locals || AgendaEmptyStatevue_type_style_index_0_id_da37ebea_prod_lang_scss_module_true)

}

/* normalize component */

var AgendaEmptyState_component = normalizeComponent(
  EventAgenda_AgendaEmptyStatevue_type_script_lang_js,
  AgendaEmptyStatevue_type_template_id_da37ebea_render,
  AgendaEmptyStatevue_type_template_id_da37ebea_staticRenderFns,
  false,
  AgendaEmptyState_injectStyles,
  null,
  null
  
)

/* harmony default export */ var AgendaEmptyState = (AgendaEmptyState_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/EventAgenda/EventAgenda.vue?vue&type=script&lang=js




/* harmony default export */ var EventAgendavue_type_script_lang_js = ({
  name: 'EventAgenda',
  props: {
    broadcastsAgendaItemsAndDates: Array,
    currentUserId: String,
    dateFilter: Object,
    filterTags: Array,
    loading: Boolean,
    searchTerm: String,
    isEventOrganizer: Boolean,
    onDemandMode: Boolean,
    ticketsEnabled: Boolean,
    currentlyActiveBroadcast: Object,
    atcurl: String,
    timezone: {
      type: String,
      default: 'UTC'
    },
    localTimezone: {
      type: String,
      default: 'UTC'
    },
    perPage: Number,
    currentPage: {
      type: Number,
      default: 1
    },
    isBackstageOnCurrentBroadcast: Boolean,
    showLocation: Boolean,
    agendaFavorites: Array,
    showFavorites: Boolean,
    agendaFilters: Object,
    heartbeatDate: {
      type: Date
    },
    isManualRedirectionEnabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AgendaItem: AgendaItem,
    Paginator: Paginator,
    AgendaEmptyState: AgendaEmptyState,
    AgendaItemV2: AgendaItemV2
  },
  computed: {
    itemsPagePage() {
      return this.perPage || this.broadcastsAgendaItemsAndDates.length;
    },
    pages() {
      return Math.ceil(this.broadcastsAgendaItemsAndDates.length / this.itemsPagePage);
    },
    visiblePage() {
      const start = (this.currentPage - 1) * this.itemsPagePage;
      return this.broadcastsAgendaItemsAndDates.slice(start, start + this.itemsPagePage);
    }
  },
  methods: {
    speakerCTAText(broadcast) {
      let isActive = false;
      if (this.currentlyActiveBroadcast !== undefined && broadcast !== undefined) {
        isActive = this.currentlyActiveBroadcast.id === broadcast.id;
      }
      if (isActive && !this.isBackstageOnCurrentBroadcast) {
        return this.$t('View');
      }
      return this.$t('Enter Backstage');
    },
    isFavorited(broadcast) {
      return !!this.agendaFavorites?.find(agendaFavorite => agendaFavorite.broadcast === broadcast.id || agendaFavorite.agenda_item === broadcast.id);
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/EventAgenda/EventAgenda.vue?vue&type=script&lang=js
 /* harmony default export */ var EventAgenda_EventAgendavue_type_script_lang_js = (EventAgendavue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/EventAgenda/EventAgenda.vue?vue&type=style&index=0&id=731bfbc0&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var EventAgendavue_type_style_index_0_id_731bfbc0_prod_lang_scss_module_true = ({"root":"EventAgenda_root___Bs_"});
;// CONCATENATED MODULE: ./src/examples/EventAgenda/EventAgenda.vue?vue&type=style&index=0&id=731bfbc0&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/EventAgenda/EventAgenda.vue



;




function EventAgenda_injectStyles (context) {
  
  this["$style"] = (EventAgendavue_type_style_index_0_id_731bfbc0_prod_lang_scss_module_true.locals || EventAgendavue_type_style_index_0_id_731bfbc0_prod_lang_scss_module_true)

}

/* normalize component */

var EventAgenda_component = normalizeComponent(
  EventAgenda_EventAgendavue_type_script_lang_js,
  EventAgendavue_type_template_id_731bfbc0_render,
  EventAgendavue_type_template_id_731bfbc0_staticRenderFns,
  false,
  EventAgenda_injectStyles,
  null,
  null
  
)

/* harmony default export */ var EventAgenda = (EventAgenda_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/LivenessControlPage.vue?vue&type=template&id=aff51ffc
var LivenessControlPagevue_type_template_id_aff51ffc_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: _vm.$style.row
  }, [_c('StyledText', {
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('TIME')))]), _c('StyledText', {
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('TITLE')))]), _c('StyledText', {
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('STATUS')))])], 1), _vm._l(_vm.agendas, function (item, i) {
    return _c('div', {
      key: i,
      class: _vm.$style.row
    }, [_c('StyledText', {
      attrs: {
        "color": "primary-text-color"
      }
    }, [_vm._v(_vm._s(item.time))]), _c('StyledText', {
      attrs: {
        "color": "primary-text-color"
      }
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      class: _vm.$style.buttonsHolder
    }, [_c('LivenessPanelRecordingItem', {
      attrs: {
        "agenda": item
      }
    }), _c('PillButton', {
      class: _vm.$style.livenessBtn,
      on: {
        "click": () => _vm.$emit('click', item)
      }
    }, [_vm._v(" " + _vm._s(item.status === 'LIVE' && _vm.$options.$t('END') || _vm.$options.$t('START')) + " ")])], 1)], 1);
  })], 2);
};
var LivenessControlPagevue_type_template_id_aff51ffc_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/LivenessControlPage.vue?vue&type=script&lang=js
/* harmony default export */ var LivenessControlPagevue_type_script_lang_js = ({
  props: {
    agendas: {
      type: Array,
      default: () => []
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/LivenessControlPage.vue?vue&type=script&lang=js
 /* harmony default export */ var examples_LivenessControlPagevue_type_script_lang_js = (LivenessControlPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/LivenessControlPage.vue?vue&type=style&index=0&id=aff51ffc&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var LivenessControlPagevue_type_style_index_0_id_aff51ffc_prod_module_true_lang_scss = ({"root":"LivenessControlPage_root_OCmUb","row":"LivenessControlPage_row_R84xP","buttonsHolder":"LivenessControlPage_buttonsHolder_W6HME","livenessBtn":"LivenessControlPage_livenessBtn_GEBdb"});
;// CONCATENATED MODULE: ./src/examples/LivenessControlPage.vue?vue&type=style&index=0&id=aff51ffc&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/LivenessControlPage.vue



;




function LivenessControlPage_injectStyles (context) {
  
  this["$style"] = (LivenessControlPagevue_type_style_index_0_id_aff51ffc_prod_module_true_lang_scss.locals || LivenessControlPagevue_type_style_index_0_id_aff51ffc_prod_module_true_lang_scss)

}

/* normalize component */

var LivenessControlPage_component = normalizeComponent(
  examples_LivenessControlPagevue_type_script_lang_js,
  LivenessControlPagevue_type_template_id_aff51ffc_render,
  LivenessControlPagevue_type_template_id_aff51ffc_staticRenderFns,
  false,
  LivenessControlPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LivenessControlPage = (LivenessControlPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Splash.vue?vue&type=template&id=0abc1e61
var Splashvue_type_template_id_0abc1e61_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    style: _vm.splashThemeOverwrites,
    attrs: {
      "data-branding-target": "splash-background"
    }
  }, [_c('a', {
    class: _vm.$style.skipToRegisterLink,
    attrs: {
      "href": "#enter-live-broadcast"
    }
  }, [_vm._v("Skip To Event")]), _c('div', {
    class: _vm.$style.enterBroadCast,
    attrs: {
      "data-branding-target": "fonts"
    }
  }, [_vm.eventStartTimeString ? _c('p', {
    class: _vm.$style.eventBeginMsg
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('This event begins on{startitme}', {
    starttime: ''
  })) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.eventStartTimeString) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.$options.$t('Please refresh to enter.')) + " ")]) : _vm._e(), _c('PillButton', {
    attrs: {
      "id": "enter-live-broadcast",
      "aria-label": _vm.joinButtonText + ' ' + _vm.eventTitle,
      "loading": _vm.joiningEvent,
      "disabled": _vm.disableEventButton || _vm.joiningEvent,
      "size": "large",
      "boldText": "",
      "center": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('enter-live-broadcast');
      }
    }
  }, [_vm.disableEventButton ? _c('span', {
    staticClass: "svg-font-lock",
    class: _vm.$style.fontLockIcon
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.joinButtonText) + " ")]), _vm.showPoweredBy ? _c('div', {
    class: _vm.$style.poweredBy
  }, [_c('StyledText', {
    attrs: {
      "variant": "heading13",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Powered by')) + " ")]), _c('a', {
    attrs: {
      "href": _vm.links.poweredByLink,
      "target": "_blank",
      "aria-label": "Goldcast"
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": "logo"
    }
  })], 1)], 1) : _vm._e()], 1), _vm.showEventDetails ? _c('EventDetails', {
    ref: "eventDetails",
    class: _vm.$style.topSection,
    attrs: {
      "eventTitle": _vm.eventTitle,
      "eventDate": _vm.eventDate,
      "hideEventDate": _vm.isWebinar && _vm.onDemandMode,
      "eventLocation": _vm.showLocation ? _vm.eventLocation : '',
      "ctaLink": _vm.ctaLink,
      "ctaTitle": _vm.ctaTitle,
      "is_title_visible": _vm.is_title_visible
    },
    on: {
      "cta-click": function ($event) {
        return _vm.$emit('cta-click');
      }
    }
  }) : _vm._e(), !_vm.hideEventAgenda && !_vm.loading ? _c('div', {
    class: {
      [_vm.$style.agendaSection]: true,
      [_vm.$style.noTopImage]: !_vm.showEventDetails
    }
  }, [_c('div', [_c('StyledText', {
    class: _vm.$style.agendaHeading,
    attrs: {
      "variant": "subHeading18",
      "data-branding-target": "page-title"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Agenda')) + " ")]), _c('div', {
    class: _vm.$style.mobileScroll,
    attrs: {
      "data-branding-target": "splash-mobilescroll"
    }
  }, [_c('StyledText', {
    attrs: {
      "align": "center",
      "color": "primary-text-color",
      "opacity": 0.3
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Scroll to see all tracks')) + " ")]), _c('SvgIcon', {
    attrs: {
      "name": "scroll",
      "size": "regular"
    }
  })], 1), _c('div', {
    class: _vm.$style.agendaFiltersContainer
  }, [(_vm.dayOptions || []).length > 1 ? _c('AgendaFilter', {
    attrs: {
      "options": _vm.dayOptions,
      "current": _vm.selectedDay,
      "type": "dropdown"
    },
    on: {
      "select": e => _vm.$emit('on-day-select', e)
    }
  }) : _vm._e(), (_vm.trackOptions || []).length > 1 ? _c('AgendaFilter', {
    attrs: {
      "options": _vm.trackOptions,
      "aria-control-id": "agenda-filtered-list",
      "add-aria-attributes": true,
      "current": _vm.selectedTrack,
      "type": _vm.isMobile ? 'dropdown' : 'pin'
    },
    on: {
      "select": e => _vm.$emit('on-track-select', e)
    }
  }) : _vm._e(), _vm.showFavorites ? _c('AgendaFavoritesFilter', {
    attrs: {
      "selected": _vm.agendaFilters ? _vm.agendaFilters.agendaFavoritesFilter : false,
      "agendaFavorites": _vm.agendaFavorites
    },
    on: {
      "click": e => _vm.$emit('onClickFavoritesFilter', e)
    }
  }) : _vm._e()], 1), _c('div', {
    attrs: {
      "id": "agenda-filtered-list"
    }
  }, [(_vm.broadcastsAgendaItemsAndDates || []).length ? _c('div', {
    class: _vm.$style.broadcasts
  }, [_vm._l(_vm.broadcastsAgendaItemsAndDates, function (item) {
    return [item.kind === 'date' ? _c('LabeledSeparator', {
      key: item.title,
      attrs: {
        "variant": "subHeading15"
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")]) : _c('AgendaItem', {
      key: item.id,
      class: _vm.$style.agendaItem,
      attrs: {
        "isWebinar": _vm.isWebinar,
        "broadcast": item,
        "selectedTags": _vm.filterTags,
        "current-user-id": _vm.currentUserId,
        "searchTerm": _vm.searchTerm,
        "loading": _vm.loadingItemId === item.id,
        "onDemandMode": _vm.onDemandMode,
        "ticketsEnabled": _vm.ticketsEnabled,
        "speakerCTAText": _vm.$options.$t('Enter Backstage'),
        "isSplash": true,
        "isEventOrganizer": _vm.isEventOrganizer,
        "url": _vm.atcurl,
        "timezone": _vm.timezone,
        "localTimezone": _vm.localTimezone,
        "showLocation": _vm.showLocation,
        "isFavorited": _vm.isFavorited(item),
        "showFavorites": _vm.showFavorites,
        "dataBrandingTarget": "agenda-tile-date"
      },
      on: {
        "userClicked": function ($event) {
          return _vm.$emit('userClicked', $event);
        },
        "join": function ($event) {
          return _vm.$emit('join', item);
        },
        "toggleFavorite": function ($event) {
          return _vm.$emit('toggleFavorite', item);
        },
        "addtocal-mounted": function ($event) {
          return _vm.$emit('addtocal-mounted');
        }
      }
    })];
  })], 2) : _c('AgendaEmptyState', {
    attrs: {
      "agendaFilters": _vm.agendaFilters
    }
  })], 1)], 1)]) : _vm._e(), _c('button', {
    class: [_vm.$style.skipToRegisterLink, _vm.$style.bottom],
    on: {
      "click": _vm.handleBackToTopClick
    }
  }, [_vm._v("Back to top")])], 1);
};
var Splashvue_type_template_id_0abc1e61_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Splash.vue?vue&type=script&lang=js






/* harmony default export */ var Splashvue_type_script_lang_js = ({
  name: 'Splash',
  props: {
    eventStartTimeString: String,
    disableEventButton: Boolean,
    broadcastsAgendaItemsAndDates: Array,
    currentUserId: String,
    dateFilter: Object,
    filterTags: Array,
    loading: Boolean,
    agendaFavorites: Array,
    is_title_visible: {
      type: Boolean,
      default: true
    },
    searchTerm: String,
    loadingItemId: String,
    eventTitle: {
      type: String,
      default: ''
    },
    eventDate: {
      type: String,
      default: ''
    },
    timezone: {
      type: String,
      default: 'UTC'
    },
    localTimezone: {
      type: String,
      default: 'UTC'
    },
    ctaLink: {
      type: String,
      default: null
    },
    ctaTitle: {
      type: String,
      default: null
    },
    dayOptions: Array,
    selectedDay: Object,
    trackOptions: Array,
    selectedTrack: Object,
    joiningEvent: Boolean,
    isEventOrganizer: Boolean,
    onDemandMode: Boolean,
    ticketsEnabled: Boolean,
    atcurl: String,
    showPoweredBy: Boolean,
    eventLocation: String,
    showLocation: Boolean,
    showEventDetails: {
      type: Boolean,
      default: true
    },
    hideEventAgenda: {
      type: Boolean,
      default: false
    },
    isWebinar: {
      type: Boolean,
      default: false
    },
    agendaFilters: Object,
    showFavorites: Boolean
  },
  components: {
    AgendaItem: AgendaItem,
    AgendaFilter: AgendaFilter,
    AgendaEmptyState: AgendaEmptyState
  },
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      links: links,
      isMobile: window.mobileCheck && window.mobileCheck(),
      splashThemeOverwrites: theme.splashThemeOverwrites
    };
  },
  watch: {
    dateFilter() {
      this.currentPage = 1;
    }
  },
  computed: {
    joinButtonText() {
      if (this.onDemandMode && this.isWebinar) {
        return this.$options.$t('PLAY RECORDING');
      }
      const agendaItemsLength = this.broadcastsAgendaItemsAndDates?.filter(agenda => agenda?.kind !== 'date')?.length;
      if (this.onDemandMode && agendaItemsLength === 1) {
        return this.$options.$t('VIEW RECORDING');
      }
      if (this.onDemandMode && agendaItemsLength > 1) {
        return this.$options.$t('VIEW RECORDINGS');
      }
      return this.$options.$t('ENTER EVENT');
    }
  },
  methods: {
    isFavorited(broadcast) {
      return !!this.agendaFavorites?.find(agendaFavorite => agendaFavorite.broadcast === broadcast.id || agendaFavorite.agenda_item === broadcast.id);
    },
    handleBackToTopClick(e) {
      if (this.$refs.eventDetails) {
        scrollToElement(this.$refs.eventDetails.$el);
        e.target.blur();
        this.$refs.eventDetails.$el.focus();
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/Splash.vue?vue&type=script&lang=js
 /* harmony default export */ var examples_Splashvue_type_script_lang_js = (Splashvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/Splash.vue?vue&type=style&index=0&id=0abc1e61&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var Splashvue_type_style_index_0_id_0abc1e61_prod_lang_scss_module_true = ({"root":"Splash_root_LfKAd","fontLockIcon":"Splash_fontLockIcon_EmFwB","eventBeginMsg":"Splash_eventBeginMsg_dg29Y","topSection":"Splash_topSection_S0Se2","agendaSection":"Splash_agendaSection_YKVIL","noTopImage":"Splash_noTopImage_vlAD4","mobileScroll":"Splash_mobileScroll_JtKSo","agendaHeading":"Splash_agendaHeading_aMLY2","agendaFiltersContainer":"Splash_agendaFiltersContainer_wTlQr","agendaItem":"Splash_agendaItem_a4fvx","enterBroadCast":"Splash_enterBroadCast_GErBV","poweredBy":"Splash_poweredBy_kHi3v","skipToRegisterLink":"Splash_skipToRegisterLink_CMZvN","bottom":"Splash_bottom_V8I17"});
;// CONCATENATED MODULE: ./src/examples/Splash.vue?vue&type=style&index=0&id=0abc1e61&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/examples/Splash.vue



;




function Splash_injectStyles (context) {
  
  this["$style"] = (Splashvue_type_style_index_0_id_0abc1e61_prod_lang_scss_module_true.locals || Splashvue_type_style_index_0_id_0abc1e61_prod_lang_scss_module_true)

}

/* normalize component */

var Splash_component = normalizeComponent(
  examples_Splashvue_type_script_lang_js,
  Splashvue_type_template_id_0abc1e61_render,
  Splashvue_type_template_id_0abc1e61_staticRenderFns,
  false,
  Splash_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Splash = (Splash_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RegistrationPage.vue?vue&type=template&id=1ae755e9
var RegistrationPagevue_type_template_id_1ae755e9_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, {
      navOpen: _vm.navOpen || _vm.shareOpen
    }, _vm.miniview && _vm.$style.miniview],
    style: _vm.splashThemeOverwrites
  }, [_c('SidebarReg', {
    attrs: {
      "open": _vm.navOpen,
      "formfields": _vm.formfields,
      "sidebarloading": _vm.sidebarloading,
      "registerProcessed": _vm.registerProcessed,
      "userHasAlreadyRegistered": _vm.userHasAlreadyRegistered,
      "userIsBlocked": _vm.userIsBlocked,
      "formioEnabled": _vm.formioEnabled,
      "registrationErrorMessage": _vm.registrationErrorMessage
    },
    on: {
      "register": data => _vm.$emit('register', data),
      "togglenav": () => _vm.$emit('toggleNav'),
      "fieldchange": data => _vm.$emit('fieldchange', data),
      "regforminputlinkclicked": $event => _vm.$emit('regforminputlinkclicked', $event),
      "closeregerrorpopup": function ($event) {
        return _vm.$emit('closeregerrorpopup');
      }
    },
    scopedSlots: _vm._u([{
      key: "registrationForm",
      fn: function () {
        return [_vm._t("registrationForm")];
      },
      proxy: true
    }], null, true)
  }), _c('SidebarShare', {
    attrs: {
      "openShare": _vm.shareOpen
    },
    on: {
      "toggleshare": () => _vm.$emit('toggleShare'),
      "fieldchange": data => _vm.fieldchange(data)
    }
  }), _c('div', {
    staticClass: "registrationTopSection",
    class: _vm.$style.topSection
  }, [_c('EventDetails', {
    class: _vm.$style.eventDetails,
    attrs: {
      "eventTitle": _vm.eventTitle,
      "eventDate": _vm.eventDate,
      "ctaLink": _vm.ctaLink,
      "ctaTitle": _vm.ctaTitle,
      "is_title_visible": _vm.is_title_visible,
      "eventLocation": _vm.showLocation ? _vm.eventLocation : '',
      "hideEventDate": _vm.isWebinar && _vm.onDemandMode
    },
    on: {
      "cta-click": function ($event) {
        return _vm.$emit('cta-click');
      }
    }
  })], 1), !_vm.loading ? [_c('div', {
    staticClass: "registrationAgendaSection",
    class: _vm.$style.agendaSection
  }, [!_vm.miniview && _vm.description ? _c('AboutRegister', {
    attrs: {
      "description": _vm.description
    }
  }) : _vm._e(), _vm.shouldShowSpeakers ? _c('SpeakersSection', {
    class: _vm.$style.speaker_class,
    attrs: {
      "users": _vm.eventSpeakers,
      "speakerSectionTitle": _vm.speakerSectionTitle
    },
    on: {
      "viewProfileClick": _vm.onViewProfileClick
    }
  }) : _vm._e(), _vm.showSponsersSection ? [_c('Sponsors', {
    attrs: {
      "enableBoothTiers": _vm.enableBoothTiers,
      "sponsors": _vm.eventSponsers,
      "sponsorsSectionTitle": _vm.sponsersSectionTitle
    },
    on: {
      "onSponsorsLogoClick": e => _vm.$emit('onSponsersLogoClick', e)
    }
  })] : _vm._e(), _vm.showAgenda ? [_c('StyledText', {
    class: _vm.$style.agendaHeading,
    attrs: {
      "variant": "heading26"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('AGENDA')) + " ")]), _c('div', {
    class: _vm.$style.dayFilter
  }, [(_vm.dayOptions || []).length > 1 ? _c('AgendaFilter', {
    attrs: {
      "options": _vm.dayOptions,
      "current": _vm.selectedDay,
      "type": "dropdown"
    },
    on: {
      "select": e => _vm.$emit('on-day-select', e)
    }
  }) : _vm._e(), (_vm.trackOptions || []).length > 1 ? _c('AgendaFilter', {
    attrs: {
      "options": _vm.trackOptions,
      "current": _vm.selectedTrack,
      "type": "pin"
    },
    on: {
      "select": e => _vm.$emit('on-track-select', e)
    }
  }) : _vm._e()], 1), (_vm.broadcastsAgendaItemsAndDates || []).length ? _c('div', {
    class: _vm.$style.broadcasts
  }, [_vm._l(_vm.broadcastsAgendaItemsAndDates, function (item) {
    return [item.kind === 'date' ? _c('LabeledSeparator', {
      key: item.title,
      attrs: {
        "variant": "subHeading15"
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")]) : _c('AgendaItem', {
      key: item.id,
      class: _vm.$style.agendaItem,
      attrs: {
        "broadcast": item,
        "selectedTags": _vm.filterTags,
        "current-user-id": _vm.currentUserId,
        "searchTerm": _vm.searchTerm,
        "isSplash": true,
        "url": _vm.atcurl,
        "showJoinButton": _vm.showJoinButton,
        "showLiveButton": _vm.showLiveButton,
        "timezone": _vm.timezone,
        "localTimezone": _vm.localTimezone,
        "showLocation": _vm.showLocation,
        "showFavorites": false,
        "letButtonsShow": false
      },
      on: {
        "addtocal-mounted": function ($event) {
          return _vm.$emit('addtocal-mounted');
        },
        "user-clicked": _vm.onViewProfileClick,
        "join": function ($event) {
          return _vm.$emit('join', item);
        }
      }
    })];
  })], 2) : _c('AgendaEmptyState')] : _vm._e()], 2)] : _vm._e(), _c('div', {
    class: _vm.$style.sideButtonWrapper
  }, [_c('SideButtons', {
    attrs: {
      "loading": _vm.regappMounterLoading,
      "showShareButton": _vm.showShareButton,
      "showPoweredBy": _vm.showPoweredBy,
      "onDemandMode": _vm.onDemandMode
    },
    on: {
      "togglenav": () => _vm.$emit('toggleNav'),
      "toggleshare": () => _vm.$emit('toggleShare')
    }
  })], 1), _c('SidebarUserProfile', {
    attrs: {
      "userdata": _vm.selectedSpeakerData,
      "openProfileSideBar": _vm.openProfileSideBar,
      "cssVars": _vm.profileSidebarCss
    },
    on: {
      "closeSideBarProfile": _vm.onViewProfileClick
    }
  })], 2);
};
var RegistrationPagevue_type_template_id_1ae755e9_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/sponsors.vue?vue&type=template&id=03d4abb2
var sponsorsvue_type_template_id_03d4abb2_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    style: _vm.wrapperCssVars
  }, [_vm.sponsorsSectionTitle ? _c('StyledText', {
    attrs: {
      "variant": "heading26",
      "color": "primary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.sponsorsSectionTitle) + " ")]) : _vm._e(), _vm._l(_vm.sponsors, function (sponsor, index) {
    return _c('div', {
      key: index,
      class: _vm.$style.sponsorsHolder
    }, [sponsor.name && sponsor.booths.length && _vm.enableBoothTiers ? _c('LabeledSeparator', {
      attrs: {
        "variant": "subHeading18"
      }
    }, [_vm._v(" " + _vm._s(sponsor.name) + " ")]) : _vm._e(), _c('div', {
      class: [_vm.$style.grid, _vm.enableBoothTiers ? sponsor.booths.length && _vm.$style[sponsor.booths[0].tier] : _vm.$style.TIER1],
      attrs: {
        "data-testmarker": "bootgrid"
      }
    }, _vm._l(sponsor.booths, function (sp, i) {
      return _c('div', {
        key: i,
        class: _vm.$style.card
      }, [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function ($event) {
            return _vm.navigateToLogoUrl($event, sp.sponsor_link);
          }
        }
      }, [sp.logo ? _c('img', {
        attrs: {
          "src": sp.logo,
          "alt": sp.name,
          "width": "100%"
        },
        on: {
          "error": () => _vm.listeners.error && _vm.listeners.error()
        }
      }) : _vm._e()])]);
    }), 0)], 1);
  })], 2);
};
var sponsorsvue_type_template_id_03d4abb2_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/sponsors.vue?vue&type=script&lang=js
/* harmony default export */ var sponsorsvue_type_script_lang_js = ({
  name: 'Sponsors',
  props: {
    sponsors: {
      type: Array,
      // {name, display_email, image, thumbnail}
      default: () => []
    },
    wrapperCssVars: {
      type: Object,
      default: () => {}
    },
    sponsorsSectionTitle: {
      type: String,
      default: () => ''
    },
    enableBoothTiers: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    navigateToLogoUrl(event, url) {
      event.preventDefault();
      this.$emit('onSponsorsLogoClick', url);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/sponsors.vue?vue&type=script&lang=js
 /* harmony default export */ var components_sponsorsvue_type_script_lang_js = (sponsorsvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/sponsors.vue?vue&type=style&index=0&id=03d4abb2&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var sponsorsvue_type_style_index_0_id_03d4abb2_prod_lang_scss_module_true = ({"root":"sponsors_root_MbrS3","sponsorsHolder":"sponsors_sponsorsHolder_k1Nvi","card":"sponsors_card_GZ0VX","grid":"sponsors_grid_Z5BP9","TIER1":"sponsors_TIER1_TJvUp","TIER2":"sponsors_TIER2_GuF5O","TIER3":"sponsors_TIER3_HKXpa","images":"sponsors_images_GHYli"});
;// CONCATENATED MODULE: ./src/components/sponsors.vue?vue&type=style&index=0&id=03d4abb2&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/sponsors.vue



;




function sponsors_injectStyles (context) {
  
  this["$style"] = (sponsorsvue_type_style_index_0_id_03d4abb2_prod_lang_scss_module_true.locals || sponsorsvue_type_style_index_0_id_03d4abb2_prod_lang_scss_module_true)

}

/* normalize component */

var sponsors_component = normalizeComponent(
  components_sponsorsvue_type_script_lang_js,
  sponsorsvue_type_template_id_03d4abb2_render,
  sponsorsvue_type_template_id_03d4abb2_staticRenderFns,
  false,
  sponsors_injectStyles,
  null,
  null
  
)

/* harmony default export */ var sponsors = (sponsors_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/RegistrationPage.vue?vue&type=script&lang=js










/* harmony default export */ var RegistrationPagevue_type_script_lang_js = ({
  name: 'RegistrationPage',
  props: {
    formfields: {
      type: Array,
      default: () => []
    },
    description: {
      type: String,
      default: ''
    },
    atcurl: String,
    broadcastsAgendaItemsAndDates: Array,
    currentUserId: String,
    dateFilter: Object,
    filterTags: Array,
    loading: Boolean,
    sidebarloading: Boolean,
    searchTerm: String,
    eventTitle: {
      type: String,
      default: ''
    },
    eventDate: {
      type: String,
      default: ''
    },
    timezone: {
      type: String,
      default: 'UTC'
    },
    localTimezone: {
      type: String,
      default: 'UTC'
    },
    ctaLink: {
      type: String,
      default: null
    },
    ctaTitle: {
      type: String,
      default: null
    },
    dayOptions: Array,
    selectedDay: Object,
    trackOptions: Array,
    selectedTrack: Object,
    joiningEvent: Boolean,
    navOpen: {
      type: Boolean,
      default: true
    },
    shareOpen: {
      type: Boolean,
      default: false
    },
    eventSpeakers: {
      type: Array,
      default: () => []
    },
    eventSponsers: {
      type: Array,
      default: () => []
    },
    showSponsersSection: {
      type: Boolean,
      default: () => false
    },
    sponsersSectionTitle: {
      type: String,
      default: () => ''
    },
    speakerSectionTitle: {
      type: String,
      default: () => ''
    },
    showAgenda: {
      type: Boolean,
      default: true
    },
    shouldShowSpeakers: {
      type: Boolean,
      default: true
    },
    is_title_visible: {
      type: Boolean,
      default: true
    },
    registerProcessed: {
      type: Boolean,
      default: true
    },
    userIsBlocked: {
      type: Boolean,
      default: true
    },
    userHasAlreadyRegistered: {
      type: Boolean,
      default: false
    },
    showLiveButton: {
      type: Boolean,
      default: true
    },
    showJoinButton: {
      type: Boolean,
      default: true
    },
    regappMounterLoading: {
      type: Boolean,
      default: () => false
    },
    showShareButton: {
      type: Boolean,
      default: () => true
    },
    showPoweredBy: Boolean,
    eventLocation: String,
    showLocation: Boolean,
    formioEnabled: {
      type: Boolean,
      default: false
    },
    registrationErrorMessage: {
      type: String,
      default: ''
    },
    miniview: {
      type: Boolean,
      default: false
    },
    isWebinar: {
      type: Boolean,
      default: false
    },
    onDemandMode: {
      type: Boolean,
      default: false
    },
    enableBoothTiers: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AgendaFilter: AgendaFilter,
    AboutRegister: aboutRegistration,
    SideButtons: sideButtons,
    SidebarShare: sideBarShare,
    SidebarReg: sideBarReg,
    AgendaItem: AgendaItem,
    Sponsors: sponsors,
    AgendaEmptyState: AgendaEmptyState,
    SpeakersSection: SpeakersSection
  },
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      selectedSpeakerData: {},
      openProfileSideBar: false,
      splashThemeOverwrites: theme.splashThemeOverwrites,
      profileSidebarCss: {
        height: '100%',
        width: '40vw',
        position: 'fixed',
        top: '0',
        transform: 'translateX(40vw)',
        right: '0',
        'z-index': '999',
        'box-shadow': '0 0 20px 0 rgba(var(--primary-background-shade),.2),0 5px 5px 0 rgba(var(--primary-background-shade),.24)',
        'background-color': 'var(--theme-primary-color)'
      }
    };
  },
  watch: {
    dateFilter() {
      this.currentPage = 1;
    }
  },
  methods: {
    onViewProfileClick(selectedSpeakerData) {
      if (!selectedSpeakerData || this.selectedSpeakerData.id == selectedSpeakerData.id || !this.openProfileSideBar) {
        this.openProfileSideBar = !this.openProfileSideBar;
      }
      if (selectedSpeakerData) {
        this.selectedSpeakerData = selectedSpeakerData;
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/RegistrationPage.vue?vue&type=script&lang=js
 /* harmony default export */ var examples_RegistrationPagevue_type_script_lang_js = (RegistrationPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/RegistrationPage.vue?vue&type=style&index=0&id=1ae755e9&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var RegistrationPagevue_type_style_index_0_id_1ae755e9_prod_lang_scss_module_true = ({"root":"RegistrationPage_root_Ibt9m","topSection":"RegistrationPage_topSection_xMpzq","eventDetails":"RegistrationPage_eventDetails_zIs0K","agendaSection":"RegistrationPage_agendaSection_E5oLP","speaker_class":"RegistrationPage_speaker_class_Gbisu","agendaHeading":"RegistrationPage_agendaHeading_ulZTy","dayFilter":"RegistrationPage_dayFilter_plcNJ","agendaItem":"RegistrationPage_agendaItem_HK_tZ","enterBroadCast":"RegistrationPage_enterBroadCast_lJcLb","bottomText":"RegistrationPage_bottomText_mLkAs","sideButtonWrapper":"RegistrationPage_sideButtonWrapper_Q4WPc","miniview":"RegistrationPage_miniview_dkXPY","broadcasts":"RegistrationPage_broadcasts_t7iFM","mobileScroll":"RegistrationPage_mobileScroll_MFIZP"});
;// CONCATENATED MODULE: ./src/examples/RegistrationPage.vue?vue&type=style&index=0&id=1ae755e9&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/RegistrationPage.vue?vue&type=style&index=1&id=1ae755e9&prod&lang=scss&scope=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/examples/RegistrationPage.vue?vue&type=style&index=1&id=1ae755e9&prod&lang=scss&scope=true

;// CONCATENATED MODULE: ./src/examples/RegistrationPage.vue



;





function RegistrationPage_injectStyles (context) {
  
  this["$style"] = (RegistrationPagevue_type_style_index_0_id_1ae755e9_prod_lang_scss_module_true.locals || RegistrationPagevue_type_style_index_0_id_1ae755e9_prod_lang_scss_module_true)

}

/* normalize component */

var RegistrationPage_component = normalizeComponent(
  examples_RegistrationPagevue_type_script_lang_js,
  RegistrationPagevue_type_template_id_1ae755e9_render,
  RegistrationPagevue_type_template_id_1ae755e9_staticRenderFns,
  false,
  RegistrationPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var RegistrationPage = (RegistrationPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Stage.vue?vue&type=template&id=27cc5efe
var Stagevue_type_template_id_27cc5efe_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('StageWrapper', {
    attrs: {
      "minimized": _vm.minimized,
      "hasLocalStream": _vm.hasLocalStream,
      "activePage": _vm.activePage,
      "filters": _vm.filters,
      "muted": _vm.muted,
      "selectedAgendaDay": _vm.selectedAgendaDay,
      "selectedTrack": _vm.selectedTrack,
      "subscribedTrack": _vm.subscribedTrack,
      "recordingMode": _vm.recordingMode,
      "hideMiniPlayer": _vm.hideMiniPlayer,
      "agendaDayOptions": _vm.agendaDayOptions,
      "trackOptions": _vm.trackOptions,
      "showMuteButton": _vm.showMuteButton,
      "organizer": _vm.organizer,
      "agendaFilters": _vm.agendaFilters,
      "agendaFavorites": _vm.agendaFavorites,
      "showFavorites": _vm.showFavorites
    },
    on: {
      "onClickFavoritesFilter": e => _vm.$emit('onClickFavoritesFilter', e),
      "filters": payload => _vm.$emit('filters', payload),
      "joinBroadcast": function ($event) {
        return _vm.$emit('joinBroadcast');
      },
      "switch_fullscreen": function ($event) {
        return _vm.$emit('switchToFullScreen');
      },
      "onagendadayselect": e => _vm.$emit('onagendadayselect', e),
      "ontrackselect": e => _vm.$emit('ontrackselect', e),
      "mute": function ($event) {
        return _vm.$emit('mute');
      },
      "subscribeTrack": e => _vm.$emit('subscribeTrack', e)
    },
    scopedSlots: _vm._u([{
      key: "controls",
      fn: function () {
        return [_vm._t("controls")];
      },
      proxy: true
    }, {
      key: "subpage",
      fn: function () {
        return [_vm._t("subpage")];
      },
      proxy: true
    }], null, true)
  }, [_c('div', {
    class: [_vm.$style.root, _vm.minimized && _vm.$style.minimized]
  }, [_c('div', {
    class: [_vm.$style.videos, _vm.recordingMode && _vm.$style.recordingMode]
  }, [_vm._t("default")], 2)]), _vm.showTimerToast ? _c('GenericHeaderNotification', {
    attrs: {
      "text": [_vm.gteToasterText, _vm.timer.time].join(' ')
    }
  }) : _vm._e()], 1);
};
var Stagevue_type_template_id_27cc5efe_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/Stage.vue?vue&type=script&lang=js

/* harmony default export */ var Stagevue_type_script_lang_js = ({
  name: 'AgoraRoom',
  components: {
    GenericHeaderNotification: GenericHeaderNotification
  },
  props: {
    filters: {
      type: Object,
      default: () => {}
    },
    minimized: {
      type: Boolean,
      default: false
    },
    organizer: {
      type: Boolean,
      default: false
    },
    hasLocalStream: {
      type: Boolean,
      default: false
    },
    activePage: {
      type: Object,
      default: null
    },
    agendaDayOptions: Array,
    selectedAgendaDay: Object,
    trackOptions: Array,
    selectedTrack: Object,
    muted: {
      type: Boolean,
      default: false
    },
    subscribedTrack: Object,
    recordingMode: {
      type: Boolean,
      default: false
    },
    fullScreen: Boolean,
    hideMiniPlayer: {
      type: Boolean,
      default: false
    },
    showMuteButton: Boolean,
    agendaFilters: Object,
    agendaFavorites: Array,
    showFavorites: Boolean,
    isManualRedirectionEnabled: {
      type: Boolean,
      default: false
    },
    timer: {
      type: Object,
      default: () => {}
    },
    isSpeaker: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showTimerToast() {
      return this.isManualRedirectionEnabled && this.timer?.show && this.timer?.showToaster && (this.organizer || this.isSpeaker) && this.$route?.name === 'Broadcast';
    },
    gteToasterText() {
      return this.timer?.highlight ? 'Session will end in ' : 'This session goes live in ';
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/Stage.vue?vue&type=script&lang=js
 /* harmony default export */ var examples_Stagevue_type_script_lang_js = (Stagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/Stage.vue?vue&type=style&index=0&id=27cc5efe&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var Stagevue_type_style_index_0_id_27cc5efe_prod_module_true_lang_scss = ({"videos":"Stage_videos_qxYzx","recordingMode":"Stage_recordingMode_iqENU","root":"Stage_root_iKmJI","minimized":"Stage_minimized_azdnw"});
;// CONCATENATED MODULE: ./src/examples/Stage.vue?vue&type=style&index=0&id=27cc5efe&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/Stage.vue



;




function Stage_injectStyles (context) {
  
  this["$style"] = (Stagevue_type_style_index_0_id_27cc5efe_prod_module_true_lang_scss.locals || Stagevue_type_style_index_0_id_27cc5efe_prod_module_true_lang_scss)

}

/* normalize component */

var Stage_component = normalizeComponent(
  examples_Stagevue_type_script_lang_js,
  Stagevue_type_template_id_27cc5efe_render,
  Stagevue_type_template_id_27cc5efe_staticRenderFns,
  false,
  Stage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var Stage = (Stage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/index.vue?vue&type=template&id=e1baa37c
var ConferenceRoomvue_type_template_id_e1baa37c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.$style[_vm.minimized && 'minimized'], _vm.$style[_vm.publishedItemOnStage && 'with_screen'], _vm.$style[_vm.recordingMode && 'recordingMode'], _vm.hovering && _vm.$style.hovering, (_vm.actionConfig.isBackstage || _vm.actionConfig.liveStreamMode) && _vm.$style.backstage, _vm.isLiteMode && _vm.$style.liteMode, !_vm.isLiteMode && _vm.$style.stagePadding],
    attrs: {
      "data-branding-target": "streams-background"
    },
    on: {
      "mousemove": _vm.hovered,
      "mouseleave": _vm.hoverout
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showContent,
      expression: "showContent"
    }],
    class: [_vm.$style.content, _vm.$style[`with-${_vm.layout}`]]
  }, [_vm.streamPublishing ? _c('Loading', {
    class: _vm.$style.loader
  }) : [!_vm.forceHideStageItems ? _c('VideoGridParent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !(_vm.publishedItemOnStage && _vm.minimized),
      expression: "!(publishedItemOnStage && minimized)"
    }],
    ref: "video_grid_parent",
    class: _vm.$style.video_grid,
    attrs: {
      "streamList": _vm.streamList,
      "isBackstage": _vm.actionConfig.isBackstage,
      "minimized": _vm.minimized,
      "audioOutputDeviceId": _vm.audioOutputDeviceId,
      "muted": _vm.muted,
      "showHls": _vm.$slots.hls && _vm.$slots.hls.length > 0,
      "screenLayout": _vm.layout,
      "hasRoundedVideo": _vm.broadcast.round_videos,
      "showSingleSpeaker": _vm.actionConfig.showSingleSpeaker,
      "publishedItemOnStage": _vm.publishedItemOnStage,
      "hoveringStage": _vm.hovering,
      "remoteSignalMetadata": _vm.remoteSignalMetadata,
      "isSomethingPublished": _vm.isSomethingPublished
    },
    on: {
      "play-aborted": function ($event) {
        return _vm.$emit('play-aborted', $event);
      }
    }
  }, [_vm._t("hls")], 2) : _vm._e(), _vm.publishedItemOnStage ? _vm._t("publishedStage") : !_vm.actionConfig.isBackstage ? _vm._t("emptyStage") : _vm._e(), _vm.actionConfig.isBackstage && !_vm.minimized && !_vm.actionConfig.liveStreamMode ? _c('BackstageInfoArea', {
    attrs: {
      "broadcast": _vm.broadcast,
      "usersInside": _vm.usersInside,
      "actionConfig": _vm.actionConfig,
      "isSessionEnded": _vm.isSessionEnded,
      "timer": _vm.timer,
      "isManualRedirectionEnabled": _vm.isManualRedirectionEnabled
    },
    on: {
      "join_broadcast": function ($event) {
        return _vm.$emit('joinBroadcast', $event);
      },
      "user-clicked": function ($event) {
        return _vm.$emit('user-clicked', $event);
      },
      "join_stage": function ($event) {
        return _vm.$emit('join_stage', true);
      }
    }
  }) : _vm._e(), _vm.minimized && _vm.actionConfig.isBackstage && _vm.actionConfig.isBroadcast ? _c('PillButton', {
    class: _vm.$style.backstage_pill,
    attrs: {
      "size": "x-small"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Backstage')) + " ")]) : _vm._e()], _vm.areCaptionsEnabled && _vm.enableCaptionsButton && !_vm.selectedCaptionLanguage.disabledCaptions && !_vm.renderCaptionsNativelyInVideoPlayer ? _c('VideoCaptions', {
    attrs: {
      "captions": _vm.captions
    }
  }) : _vm._e()], 2), _vm.showLowerThird ? _c('LowerThird', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showOnlyStageLogo,
      expression: "!showOnlyStageLogo"
    }],
    attrs: {
      "isAdmin": _vm.hasAdminAccess,
      "spec": _vm.lowerThirdSpec
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('remove_lower_third');
      }
    }
  }) : _vm._e(), _vm.showSponsorLogo ? _c('span', {
    class: {
      [_vm.$style.sponsorLogoContainer]: true,
      [_vm.$style.stage_logo]: true,
      [_vm.$style.fullScreen]: _vm.showOnlyStageLogo
    },
    style: _vm.stageLogoPositioningCSS
  }, [_c('span', {
    class: {
      [_vm.$style.sponsorLogoContainer]: true
    }
  }, [_c('img', {
    class: [_vm.showOnlyStageLogo ? _vm.$style.sponsorImageFullScreen : _vm.$style.sponsorImage],
    attrs: {
      "src": _vm.stageLogoSpec.url,
      "data-branding-target": "stage-logo"
    }
  }), _vm.hasAdminAccess ? _c('CloseButton', {
    class: _vm.$style.close,
    on: {
      "close": function ($event) {
        return _vm.$emit('unPublishStageLogo');
      }
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm.bottomTickerData && _vm.bottomTickerData.show_ticker ? _c('Ticker', {
    class: [_vm.$style.stageTicker, _vm.isLiteMode && _vm.$style.stageTickerLiteMode, _vm.showOnlyStageLogo && !_vm.isLiteMode && _vm.$style.stageTickerWithLogo],
    attrs: {
      "tickerId": "broadcastTicker",
      "isEventOrganizer": _vm.isEventOrganizer,
      "tickerData": _vm.bottomTickerData,
      "roundedBorder": true
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('stopPublishingTicker');
      }
    }
  }) : _vm._e(), _vm.actionConfig.showHoverUI && !_vm.minimized ? _c('ConferenceRoomHover', {
    attrs: {
      "time": _vm.timer.time,
      "watchCount": _vm.watchCount,
      "fullScreen": _vm.fullScreen,
      "enableCaptionsButton": _vm.enableCaptionsButton,
      "areCaptionsEnabled": _vm.areCaptionsEnabled,
      "hovering": _vm.hovering,
      "isBroadcast": _vm.actionConfig.isBroadcast,
      "languages": _vm.captionLanguages,
      "selectedCaptionLanguage": _vm.selectedCaptionLanguage,
      "enableTranslation": _vm.enableTranslation
    },
    on: {
      "enableCaptions": function ($event) {
        return _vm.$emit('enableCaptions', $event);
      },
      "setFullScreen": function ($event) {
        return _vm.$emit('setFullScreen', $event);
      },
      "selectedLanguage": function ($event) {
        return _vm.$emit('selectedLanguage', $event);
      }
    }
  }) : _vm._e()], 1);
};
var ConferenceRoomvue_type_template_id_e1baa37c_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/BackstageInfoArea.vue?vue&type=template&id=450296dc
var BackstageInfoAreavue_type_template_id_450296dc_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "id": "backstageInfoArea",
      "data-testmarker": "backstageinfoarea",
      "tabindex": "-1"
    }
  }, [_c('div', {
    class: _vm.$style.info
  }, [_c('StyledText', {
    class: _vm.$style.header,
    attrs: {
      "variant": "heading26",
      "color": "secondary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.bannerTitle) + " ")]), _vm.actionConfig.isBroadcast ? [_vm.isLive ? _c('StyledText', {
    class: _vm.$style.live,
    attrs: {
      "variant": "body13",
      "color": "secondary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Live')) + " ")]) : _vm.isSessionEnded ? _c('StyledText', {
    class: _vm.$style.info_text,
    attrs: {
      "variant": "body13",
      "color": "secondary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Session has ended')) + " ")]) : _c('StyledText', {
    class: _vm.$style.info_text,
    attrs: {
      "variant": "body13",
      "color": "secondary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.startingAtInfo) + " ")])] : [_vm.usersInside.length > 0 && !_vm.actionConfig.isBroadcast ? _c('div', {
    class: _vm.$style.users
  }, [_vm._l(_vm.usersInside.slice(0, 6), function (user) {
    return _c('UserTooltip', {
      key: user.id,
      class: _vm.$style.image,
      attrs: {
        "user": user,
        "variant": "primary"
      },
      on: {
        "click": () => _vm.$emit('user-clicked', user)
      }
    });
  }), _vm.usersInside.slice(6).length ? _c('GTooltip', {
    attrs: {
      "variant": "primary",
      "text": _vm.usersInside.slice(6).map(u => u.name || '').join(', ')
    }
  }, [_c('div', {
    class: _vm.$style.image
  }, [_c('StyledText', {
    attrs: {
      "color": "primary-text-color"
    }
  }, [_vm._v(" + " + _vm._s(_vm.usersInside.length - 6) + " ")])], 1)]) : _vm._e(), _c('StyledText', {
    class: _vm.$style.sub_text,
    attrs: {
      "variant": "body16",
      "color": "secondary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.usersInside.length) + " " + _vm._s(_vm.usersInside.length > 2 ? _vm.$t('people') : _vm.$t('person')) + " " + _vm._s(_vm.$t('inside')) + " ")])], 2) : _c('StyledText', {
    class: _vm.$style.sub_text,
    attrs: {
      "variant": "body16",
      "color": "secondary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('No one is inside')) + " ")])], _c('StyledText', {
    class: _vm.$style.info_text,
    attrs: {
      "variant": "body16",
      "color": "secondary-text-color"
    }
  }, [_vm._v(" " + _vm._s(_vm.actionConfig.isBroadcast ? _vm.$t('This area is for you to sync up with your fellow speakers before you go on stage.') : _vm.$t('This area is for you to check your cam and mic before you enter the room.')) + " ")])], 2), _c('div', {
    class: _vm.$style.cta
  }, [_vm.actionConfig.hasVideoJoinAccess ? _c('PillButton', {
    class: [{
      [_vm.$style.actions]: true,
      [_vm.$style.rehearsalButton]: _vm.showRehearsalButton
    }],
    attrs: {
      "alt": !_vm.actionConfig.isBroadcast,
      "variant": _vm.actionConfig.isBroadcast ? 'warning' : 'secondary',
      "center": "",
      "uppercase": "",
      "boldText": "",
      "data-testmarker": "readytostagebutton",
      "disabled": _vm.actionConfig.blockMovement,
      "loading": _vm.actionConfig.blockMovement
    },
    on: {
      "click": () => _vm.actionConfig.hasVideoClientJoined && (!_vm.actionConfig.isBroadcast || !_vm.actionConfig.localStreamPublishInProgress) && !_vm.actionConfig.localStreamCreationInProgress && _vm.join()
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.primaryButtonText)) + " ")]) : _vm._e(), _vm.actionConfig.isBroadcast && !_vm.actionConfig.localStreamPublishInProgress && !_vm.actionConfig.localStreamCreationInProgress ? _c('OutlinedButton', {
    class: _vm.$style.actions,
    attrs: {
      "disabled": _vm.actionConfig.blockMovement,
      "loading": _vm.actionConfig.blockMovement,
      "alt": "",
      "center": "",
      "data-testmarker": "watchlivebutton"
    },
    on: {
      "click": () => _vm.actionConfig.hasVideoClientJoined && _vm.$emit('join_broadcast', false)
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.secondaryButtonText)) + " ")]) : _vm._e()], 1)]);
};
var BackstageInfoAreavue_type_template_id_450296dc_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/BackstageInfoArea.vue?vue&type=script&lang=js

/* harmony default export */ var BackstageInfoAreavue_type_script_lang_js = ({
  name: 'BackstageInfoArea',
  filters: {
    time(time) {
      return timeFormatter.format(new Date(time));
    }
  },
  props: {
    broadcast: Object,
    actionConfig: {
      type: Object,
      default: () => ({})
    },
    usersInside: {
      type: Array,
      default: () => []
    },
    isSessionEnded: {
      type: Boolean,
      default: false
    },
    timer: {
      type: Object,
      default: () => ({
        show: false
      })
    },
    isManualRedirectionEnabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    join() {
      this.$emit('join_broadcast', true);
    }
  },
  computed: {
    bannerTitle() {
      const broadcastTitle = this.$t('Backstage: {title}', {
        title: this.broadcast.title
      });
      const roomTitle = this.$t('Prep Area');
      return this.actionConfig.isBroadcast ? broadcastTitle : roomTitle;
    },
    startingAtInfo() {
      let startTime = new Date(this.broadcast.start_time);
      let time = '_';
      if (!isNaN(startTime)) {
        time = timeFormatter.format(startTime);
      }
      return this.$t('Starting at {time}', {
        time: time + ' ' + getTimeZoneFromDate(startTime)
      });
    },
    isLive() {
      return this.broadcast.is_live;
    },
    showRehearsalButton() {
      return !this.isLive && this.isManualRedirectionEnabled;
    },
    primaryButtonText() {
      if (this.showRehearsalButton) {
        return 'Rehearse on stage';
      }
      if (this.actionConfig.isBroadcast) {
        return 'Go Live On Stage';
      }
      return "I'm Ready";
    },
    secondaryButtonText() {
      if (this.showRehearsalButton) {
        return 'Watch Rehearsal';
      }
      return 'Watch Live';
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/BackstageInfoArea.vue?vue&type=script&lang=js
 /* harmony default export */ var ConferenceRoom_BackstageInfoAreavue_type_script_lang_js = (BackstageInfoAreavue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/BackstageInfoArea.vue?vue&type=style&index=0&id=450296dc&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var BackstageInfoAreavue_type_style_index_0_id_450296dc_prod_module_true_lang_scss = ({"root":"BackstageInfoArea_root_D6HYc","header":"BackstageInfoArea_header_ofwBy","live":"BackstageInfoArea_live_edXtg","info":"BackstageInfoArea_info_lONyc","cta":"BackstageInfoArea_cta_QVORO","info_text":"BackstageInfoArea_info_text_Ptryb","users":"BackstageInfoArea_users_rdWQe","image":"BackstageInfoArea_image_fFf14","sub_text":"BackstageInfoArea_sub_text_Ql659","actions":"BackstageInfoArea_actions_RqjE5","rehearsalButton":"BackstageInfoArea_rehearsalButton_TpPBo"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/BackstageInfoArea.vue?vue&type=style&index=0&id=450296dc&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/BackstageInfoArea.vue



;




function BackstageInfoArea_injectStyles (context) {
  
  this["$style"] = (BackstageInfoAreavue_type_style_index_0_id_450296dc_prod_module_true_lang_scss.locals || BackstageInfoAreavue_type_style_index_0_id_450296dc_prod_module_true_lang_scss)

}

/* normalize component */

var BackstageInfoArea_component = normalizeComponent(
  ConferenceRoom_BackstageInfoAreavue_type_script_lang_js,
  BackstageInfoAreavue_type_template_id_450296dc_render,
  BackstageInfoAreavue_type_template_id_450296dc_staticRenderFns,
  false,
  BackstageInfoArea_injectStyles,
  null,
  null
  
)

/* harmony default export */ var BackstageInfoArea = (BackstageInfoArea_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/VideoGridParent.vue?vue&type=template&id=22b1cbaa
var VideoGridParentvue_type_template_id_22b1cbaa_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.getCurrentStageLayoutComp, _vm._b({
    ref: "videogridContainer",
    tag: "component",
    class: [_vm.$style.root, _vm.minimized && _vm.$style.minimized],
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "audioOutputDeviceId": _vm.audioOutputDeviceId,
      "showSingleSpeaker": _vm.showSingleSpeaker,
      "isBackstage": _vm.isBackstage,
      "minimized": _vm.minimized,
      "applyRoundedCss": _vm.applyRoundedCss
    }
  }, 'component', _vm.$props, false), [_vm.showHls ? _vm._t("default") : _vm._e()], 2);
};
var VideoGridParentvue_type_template_id_22b1cbaa_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/SpotlightInCorner.vue?vue&type=template&id=1dd70b9c
var SpotlightInCornervue_type_template_id_1dd70b9c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.streamList.length > 0 ? _c('ScrollCompWithTopBottomArrow', {
    class: _vm.$style[`with-FLOATING-container`]
  }, [_c('VideoGrid', _vm._b({
    class: [_vm.$style[`with-FLOATING`], _vm.showSingleSpeaker && _vm.$style.showSingleStream],
    style: _vm.dynamicSize,
    attrs: {
      "slot": "scrollContent",
      "streamList": _vm.streamList
    },
    slot: "scrollContent"
  }, 'VideoGrid', _vm.$attrs, false))], 1) : _c('div', {
    class: _vm.$style[`with-FLOATING-container`]
  }, [_c('div', {
    class: [_vm.$style[`with-FLOATING`]],
    style: _vm.dynamicSize
  }, [_vm._t("default")], 2)]);
};
var SpotlightInCornervue_type_template_id_1dd70b9c_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/VideoGrid.vue?vue&type=template&id=db4bd13a
var VideoGridvue_type_template_id_db4bd13a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root
  }, _vm._l(_vm.streamList, function ({
    id,
    audioTrack,
    videoTrack,
    isLocal,
    user,
    loading,
    mask
  }) {
    return _c('AgoraV4Player', _vm._b({
      key: id,
      attrs: {
        "mask": mask,
        "applyRoundedCss": _vm.applyRoundedCss,
        "isLocal": isLocal,
        "videoTrack": videoTrack,
        "audioTrack": audioTrack,
        "user": user,
        "muted": _vm.muted,
        "loading": loading,
        "minimizedViewBreakpoint": _vm.applyRoundedCss ? 500 : 420,
        "audioOutputDeviceId": _vm.audioOutputDeviceId,
        "signalStrength": _vm.remoteSignalMetadata && _vm.remoteSignalMetadata[id] && _vm.remoteSignalMetadata[id].strength
      },
      on: {
        "play-aborted": function ($event) {
          return _vm.$emit('play-aborted');
        }
      }
    }, 'AgoraV4Player', _vm.$attrs, false));
  }), 1);
};
var VideoGridvue_type_template_id_db4bd13a_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/VideoGrid.vue?vue&type=script&lang=js

/* harmony default export */ var VideoGridvue_type_script_lang_js = ({
  name: 'VideoGrid',
  components: {
    AgoraV4Player: AgoraV4Player
  },
  props: {
    applyRoundedCss: Boolean,
    isBackstage: Boolean,
    minimized: Boolean,
    streamList: Array,
    muted: Boolean,
    hoveringStage: Boolean,
    agoraVersion: Number,
    audioOutputDeviceId: String,
    remoteSignalMetadata: Object
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/VideoGrid.vue?vue&type=script&lang=js
 /* harmony default export */ var ConferenceRoom_VideoGridvue_type_script_lang_js = (VideoGridvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/VideoGrid.vue?vue&type=style&index=0&id=db4bd13a&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var VideoGridvue_type_style_index_0_id_db4bd13a_prod_module_true_lang_scss = ({"root":"VideoGrid_root_bAufP"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/VideoGrid.vue?vue&type=style&index=0&id=db4bd13a&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/VideoGrid.vue



;




function VideoGrid_injectStyles (context) {
  
  this["$style"] = (VideoGridvue_type_style_index_0_id_db4bd13a_prod_module_true_lang_scss.locals || VideoGridvue_type_style_index_0_id_db4bd13a_prod_module_true_lang_scss)

}

/* normalize component */

var VideoGrid_component = normalizeComponent(
  ConferenceRoom_VideoGridvue_type_script_lang_js,
  VideoGridvue_type_template_id_db4bd13a_render,
  VideoGridvue_type_template_id_db4bd13a_staticRenderFns,
  false,
  VideoGrid_injectStyles,
  null,
  null
  
)

/* harmony default export */ var VideoGrid = (VideoGrid_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/SpotlightInCorner.vue?vue&type=script&lang=js

/* harmony default export */ var SpotlightInCornervue_type_script_lang_js = ({
  name: 'SpotlightInCorner',
  components: {
    VideoGrid: VideoGrid
  },
  props: {
    showSingleSpeaker: Boolean,
    streamList: Array,
    minimized: Boolean,
    width: {
      type: Number,
      default: 90
    },
    height: {
      type: Number,
      default: 90
    }
  },
  computed: {
    dynamicSize() {
      return {
        '--dynamic-width': `${this.width}px`,
        '--dynamic-height': `${this.height}px`
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/SpotlightInCorner.vue?vue&type=script&lang=js
 /* harmony default export */ var StageLayouts_SpotlightInCornervue_type_script_lang_js = (SpotlightInCornervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/StageLayouts/SpotlightInCorner.vue?vue&type=style&index=0&id=1dd70b9c&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SpotlightInCornervue_type_style_index_0_id_1dd70b9c_prod_module_true_lang_scss = ({"with-FLOATING-container":"SpotlightInCorner_with-FLOATING-container_vH8BK","with-FLOATING":"SpotlightInCorner_with-FLOATING_nIvcj","showSingleStream":"SpotlightInCorner_showSingleStream_ZW3vm"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/SpotlightInCorner.vue?vue&type=style&index=0&id=1dd70b9c&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/SpotlightInCorner.vue



;




function SpotlightInCorner_injectStyles (context) {
  
  this["$style"] = (SpotlightInCornervue_type_style_index_0_id_1dd70b9c_prod_module_true_lang_scss.locals || SpotlightInCornervue_type_style_index_0_id_1dd70b9c_prod_module_true_lang_scss)

}

/* normalize component */

var SpotlightInCorner_component = normalizeComponent(
  StageLayouts_SpotlightInCornervue_type_script_lang_js,
  SpotlightInCornervue_type_template_id_1dd70b9c_render,
  SpotlightInCornervue_type_template_id_1dd70b9c_staticRenderFns,
  false,
  SpotlightInCorner_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SpotlightInCorner = (SpotlightInCorner_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/NoSpeaker.vue?vue&type=template&id=04bb8422
var NoSpeakervue_type_template_id_04bb8422_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.streamList.length > 0 ? _c('VideoGrid', _vm._b({
    class: _vm.$style.root,
    style: _vm.dynamicSize,
    attrs: {
      "applyRoundedCss": _vm.applyRoundedCss,
      "streamList": _vm.streamList
    }
  }, 'VideoGrid', _vm.$attrs, false)) : _c('div', {
    class: [_vm.$style.root],
    style: _vm.dynamicSize
  }, [_vm._t("default")], 2);
};
var NoSpeakervue_type_template_id_04bb8422_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/NoSpeaker.vue?vue&type=script&lang=js

/* harmony default export */ var NoSpeakervue_type_script_lang_js = ({
  name: 'NoSpeaker',
  components: {
    VideoGrid: VideoGrid
  },
  props: {
    recalculateVideoSize: Boolean,
    minimized: Boolean,
    isBackstage: Boolean,
    streamList: Array,
    applyRoundedCss: Boolean,
    width: {
      type: Number,
      default: 160
    },
    height: {
      type: Number,
      default: 90
    }
  },
  computed: {
    dynamicSize() {
      return {
        '--dynamic-width': `${this.width}px`,
        '--dynamic-height': `${this.height}px`
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/NoSpeaker.vue?vue&type=script&lang=js
 /* harmony default export */ var StageLayouts_NoSpeakervue_type_script_lang_js = (NoSpeakervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/StageLayouts/NoSpeaker.vue?vue&type=style&index=0&id=04bb8422&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var NoSpeakervue_type_style_index_0_id_04bb8422_prod_module_true_lang_scss = ({"root":"NoSpeaker_root_yQFTH"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/NoSpeaker.vue?vue&type=style&index=0&id=04bb8422&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/NoSpeaker.vue



;




function NoSpeaker_injectStyles (context) {
  
  this["$style"] = (NoSpeakervue_type_style_index_0_id_04bb8422_prod_module_true_lang_scss.locals || NoSpeakervue_type_style_index_0_id_04bb8422_prod_module_true_lang_scss)

}

/* normalize component */

var NoSpeaker_component = normalizeComponent(
  StageLayouts_NoSpeakervue_type_script_lang_js,
  NoSpeakervue_type_template_id_04bb8422_render,
  NoSpeakervue_type_template_id_04bb8422_staticRenderFns,
  false,
  NoSpeaker_injectStyles,
  null,
  null
  
)

/* harmony default export */ var NoSpeaker = (NoSpeaker_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/UnderTheScreen.vue?vue&type=template&id=5feac120
var UnderTheScreenvue_type_template_id_5feac120_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.streamList.length > 0 ? _c('ScrollCompWithLeftRightArrow', {
    class: _vm.$style[`with-UNDER_SCREEN-container`]
  }, [_c('VideoGrid', _vm._b({
    class: [_vm.$style[`with-UNDER_SCREEN`], _vm.showSingleSpeaker && _vm.$style.showSingleStream],
    style: _vm.dynamicSize,
    attrs: {
      "slot": "scrollContentLeftToRight",
      "streamList": _vm.streamList
    },
    slot: "scrollContentLeftToRight"
  }, 'VideoGrid', _vm.$attrs, false))], 1) : _c('div', {
    class: [_vm.$style[`with-UNDER_SCREEN-container`], _vm.$style.slotContainer],
    style: _vm.dynamicSize
  }, [_c('div', {
    class: [_vm.$style[`with-UNDER_SCREEN`]],
    style: _vm.dynamicSize
  }, [_vm._t("default")], 2)]);
};
var UnderTheScreenvue_type_template_id_5feac120_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/UnderTheScreen.vue?vue&type=script&lang=js

/* harmony default export */ var UnderTheScreenvue_type_script_lang_js = ({
  name: 'UnderTheScreen',
  components: {
    VideoGrid: VideoGrid
  },
  props: {
    showSingleSpeaker: Boolean,
    streamList: Array,
    screenLayout: String,
    minimized: Boolean,
    width: {
      type: Number,
      default: 90
    },
    height: {
      type: Number,
      default: 90
    }
  },
  computed: {
    dynamicSize() {
      return {
        '--dynamic-width': `${this.width}px`,
        '--dynamic-height': `${this.height}px`
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/UnderTheScreen.vue?vue&type=script&lang=js
 /* harmony default export */ var StageLayouts_UnderTheScreenvue_type_script_lang_js = (UnderTheScreenvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/StageLayouts/UnderTheScreen.vue?vue&type=style&index=0&id=5feac120&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var UnderTheScreenvue_type_style_index_0_id_5feac120_prod_module_true_lang_scss = ({"with-UNDER_SCREEN-container":"UnderTheScreen_with-UNDER_SCREEN-container_Dk_Hz","with-UNDER_SCREEN":"UnderTheScreen_with-UNDER_SCREEN_cUjja","showSingleStream":"UnderTheScreen_showSingleStream_mnK4I","slotContainer":"UnderTheScreen_slotContainer_qYpa_","iconLeft":"UnderTheScreen_iconLeft_Wm6q3","iconRight":"UnderTheScreen_iconRight_QANpf"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/UnderTheScreen.vue?vue&type=style&index=0&id=5feac120&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/UnderTheScreen.vue



;




function UnderTheScreen_injectStyles (context) {
  
  this["$style"] = (UnderTheScreenvue_type_style_index_0_id_5feac120_prod_module_true_lang_scss.locals || UnderTheScreenvue_type_style_index_0_id_5feac120_prod_module_true_lang_scss)

}

/* normalize component */

var UnderTheScreen_component = normalizeComponent(
  StageLayouts_UnderTheScreenvue_type_script_lang_js,
  UnderTheScreenvue_type_template_id_5feac120_render,
  UnderTheScreenvue_type_template_id_5feac120_staticRenderFns,
  false,
  UnderTheScreen_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UnderTheScreen = (UnderTheScreen_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/SplitScreen.vue?vue&type=template&id=31c3fd32
var SplitScreenvue_type_template_id_31c3fd32_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style[`with-FLEX-container`]
  }, [_vm.streamList.length > 0 ? _c('VideoGrid', _vm._b({
    class: [_vm.applyRoundedCss && _vm.$style.roundedVideo, _vm.$style[`with-FLEX`]],
    style: _vm.dynamicSize,
    attrs: {
      "applyRoundedCss": _vm.applyRoundedCss,
      "streamList": _vm.streamList
    }
  }, 'VideoGrid', _vm.$attrs, false)) : _c('div', {
    class: [_vm.$style[`with-FLEX`]],
    style: _vm.dynamicSize
  }, [_vm._t("default")], 2)], 1);
};
var SplitScreenvue_type_template_id_31c3fd32_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/SplitScreen.vue?vue&type=script&lang=js

/* harmony default export */ var SplitScreenvue_type_script_lang_js = ({
  name: 'SplitScreen',
  components: {
    VideoGrid: VideoGrid
  },
  props: {
    showSingleSpeaker: Boolean,
    streamList: Array,
    applyRoundedCss: Boolean,
    minimized: Boolean,
    width: {
      type: Number,
      default: 90
    },
    height: {
      type: Number,
      default: 90
    }
  },
  computed: {
    dynamicSize() {
      return {
        '--dynamic-width': `${this.width}px`,
        '--dynamic-height': `${this.height}px`
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/SplitScreen.vue?vue&type=script&lang=js
 /* harmony default export */ var StageLayouts_SplitScreenvue_type_script_lang_js = (SplitScreenvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/StageLayouts/SplitScreen.vue?vue&type=style&index=0&id=31c3fd32&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SplitScreenvue_type_style_index_0_id_31c3fd32_prod_module_true_lang_scss = ({"with-FLEX-container":"SplitScreen_with-FLEX-container_zGVef","with-FLEX":"SplitScreen_with-FLEX_yHtdl","roundedVideo":"SplitScreen_roundedVideo_hmVXz"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/SplitScreen.vue?vue&type=style&index=0&id=31c3fd32&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/SplitScreen.vue



;




function SplitScreen_injectStyles (context) {
  
  this["$style"] = (SplitScreenvue_type_style_index_0_id_31c3fd32_prod_module_true_lang_scss.locals || SplitScreenvue_type_style_index_0_id_31c3fd32_prod_module_true_lang_scss)

}

/* normalize component */

var SplitScreen_component = normalizeComponent(
  StageLayouts_SplitScreenvue_type_script_lang_js,
  SplitScreenvue_type_template_id_31c3fd32_render,
  SplitScreenvue_type_template_id_31c3fd32_staticRenderFns,
  false,
  SplitScreen_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SplitScreen = (SplitScreen_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/SplitScreen16to9.vue?vue&type=template&id=a9b31460
var SplitScreen16to9vue_type_template_id_a9b31460_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style[`with-FLEX_16_9-container`], _vm.applyRoundedCss && _vm.$style.roundedVideo]
  }, [_vm.streamList.length > 0 ? _c('VideoGrid', _vm._b({
    class: [_vm.$style[`with-FLEX_16_9`], _vm.applyRoundedCss && _vm.$style.roundedVideo],
    style: _vm.dynamicSize,
    attrs: {
      "applyRoundedCss": _vm.applyRoundedCss,
      "streamList": _vm.streamList
    }
  }, 'VideoGrid', _vm.$attrs, false)) : _c('div', {
    class: [_vm.$style[`with-FLEX_16_9`]],
    style: _vm.dynamicSize
  }, [_vm._t("default")], 2)], 1);
};
var SplitScreen16to9vue_type_template_id_a9b31460_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/SplitScreen16to9.vue?vue&type=script&lang=js

/* harmony default export */ var SplitScreen16to9vue_type_script_lang_js = ({
  name: 'SplitScreen16to9',
  components: {
    VideoGrid: VideoGrid
  },
  props: {
    showSingleSpeaker: Boolean,
    streamList: Array,
    applyRoundedCss: Boolean,
    minimized: Boolean,
    width: {
      type: Number,
      default: 160
    },
    height: {
      type: Number,
      default: 90
    }
  },
  computed: {
    dynamicSize() {
      return {
        '--dynamic-width': `${this.width}px`,
        '--dynamic-height': `${this.height}px`
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/SplitScreen16to9.vue?vue&type=script&lang=js
 /* harmony default export */ var StageLayouts_SplitScreen16to9vue_type_script_lang_js = (SplitScreen16to9vue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/StageLayouts/SplitScreen16to9.vue?vue&type=style&index=0&id=a9b31460&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var SplitScreen16to9vue_type_style_index_0_id_a9b31460_prod_module_true_lang_scss = ({"with-FLEX_16_9-container":"SplitScreen16to9_with-FLEX_16_9-container_tesE_","with-FLEX_16_9":"SplitScreen16to9_with-FLEX_16_9_patCd","roundedVideo":"SplitScreen16to9_roundedVideo__yrBA"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/SplitScreen16to9.vue?vue&type=style&index=0&id=a9b31460&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/SplitScreen16to9.vue



;




function SplitScreen16to9_injectStyles (context) {
  
  this["$style"] = (SplitScreen16to9vue_type_style_index_0_id_a9b31460_prod_module_true_lang_scss.locals || SplitScreen16to9vue_type_style_index_0_id_a9b31460_prod_module_true_lang_scss)

}

/* normalize component */

var SplitScreen16to9_component = normalizeComponent(
  StageLayouts_SplitScreen16to9vue_type_script_lang_js,
  SplitScreen16to9vue_type_template_id_a9b31460_render,
  SplitScreen16to9vue_type_template_id_a9b31460_staticRenderFns,
  false,
  SplitScreen16to9_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SplitScreen16to9 = (SplitScreen16to9_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/NoPublishedStage.vue?vue&type=template&id=0694052c
var NoPublishedStagevue_type_template_id_0694052c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.streamList.length > 0 ? _c('VideoGrid', _vm._b({
    ref: "noPublishStageVideoGrid",
    class: [_vm.$style.root, _vm.minimized && _vm.$style.minimized],
    style: _vm.dynamicSize,
    attrs: {
      "applyRoundedCss": false,
      "streamList": _vm.streamList
    }
  }, 'VideoGrid', _vm.$attrs, false)) : _c('div', {
    class: [_vm.$style.root, _vm.minimized && _vm.$style.minimized],
    style: _vm.dynamicSize
  }, [_vm._t("default")], 2);
};
var NoPublishedStagevue_type_template_id_0694052c_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/StageLayouts/NoPublishedStage.vue?vue&type=script&lang=js

/* harmony default export */ var NoPublishedStagevue_type_script_lang_js = ({
  name: 'NoPublishedStage',
  components: {
    VideoGrid: VideoGrid
  },
  props: {
    recalculateVideoSize: Boolean,
    minimized: Boolean,
    isBackstage: Boolean,
    streamList: Array,
    applyRoundedCss: Boolean,
    width: {
      type: Number,
      default: 160
    },
    height: {
      type: Number,
      default: 90
    }
  },
  computed: {
    dynamicSize() {
      return {
        '--dynamic-width': `${this.width}px`,
        '--dynamic-height': `${this.height}px`
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/NoPublishedStage.vue?vue&type=script&lang=js
 /* harmony default export */ var StageLayouts_NoPublishedStagevue_type_script_lang_js = (NoPublishedStagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/StageLayouts/NoPublishedStage.vue?vue&type=style&index=0&id=0694052c&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var NoPublishedStagevue_type_style_index_0_id_0694052c_prod_module_true_lang_scss = ({"root":"NoPublishedStage_root_OwbTv","minimized":"NoPublishedStage_minimized_pUW4g"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/NoPublishedStage.vue?vue&type=style&index=0&id=0694052c&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/StageLayouts/NoPublishedStage.vue



;




function NoPublishedStage_injectStyles (context) {
  
  this["$style"] = (NoPublishedStagevue_type_style_index_0_id_0694052c_prod_module_true_lang_scss.locals || NoPublishedStagevue_type_style_index_0_id_0694052c_prod_module_true_lang_scss)

}

/* normalize component */

var NoPublishedStage_component = normalizeComponent(
  StageLayouts_NoPublishedStagevue_type_script_lang_js,
  NoPublishedStagevue_type_template_id_0694052c_render,
  NoPublishedStagevue_type_template_id_0694052c_staticRenderFns,
  false,
  NoPublishedStage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var NoPublishedStage = (NoPublishedStage_component.exports);
;// CONCATENATED MODULE: ./src/utils/videoGrid.js
const videoSizeForSingleStream = (availableWidth, availableHeight, ratio, exclude) => {
  var targetWidth = availableWidth - exclude;
  var targetHeight = availableHeight - exclude;
  if (availableHeight * ratio != availableWidth) {
    if (availableHeight >= availableWidth) {
      targetHeight = availableWidth / ratio - exclude;
    } else {
      while (targetHeight * ratio > availableWidth) {
        targetHeight--;
      }
      targetWidth = targetHeight * ratio;
    }
  }
  return {
    width: targetWidth,
    height: targetHeight
  };
};
const videoSizeWithAspectRatio = (totalStreams, availableWidth, availableHeight, ratio, exclude) => {
  var target = videoSizeForSingleStream(availableWidth, availableHeight, ratio, exclude);
  if (totalStreams > 1) {
    var rowCount = 1;
    var colmnCount = 1;
    while (rowCount * colmnCount < totalStreams) {
      while (rowCount * colmnCount < totalStreams) {
        if ((target.height + exclude) * (rowCount + 1) <= availableHeight) {
          rowCount++;
          break;
        }
        if ((target.width + exclude) * (colmnCount + 1) <= availableWidth) {
          colmnCount++;
          break;
        }
        target.height--;
        target.width = target.height * ratio;
      }
    }
  }
  return target;
};
const detectVideoSizeWithAspectRatioForMinimisedVideo = (element, totalStreams, videoAspectRatio = 16 / 9, exclude = 8) => {
  if (totalStreams == 0) {
    return;
  }
  var width = element.clientWidth;
  var height = element.clientHeight;
  var target = videoSizeWithAspectRatio(totalStreams, width, height, videoAspectRatio, exclude);
  return {
    width: target.width,
    height: target.height
  };
};
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/VideoGridParent.vue?vue&type=script&lang=js



// import TopOfVideo from "./StageLayouts/TopOfVideo.vue";




const StageLayoutsCompMapping = {
  NO_SPEAKER_VIDEOS: {
    component: NoSpeaker,
    aspectRatio: 1,
    exclude: 4
  },
  FLOATING: {
    component: SpotlightInCorner,
    aspectRatio: 16 / 9,
    exclude: 4
  },
  UNDER_SCREEN: {
    component: UnderTheScreen,
    aspectRatio: 16 / 9,
    exclude: 4
  },
  // TOP_OF_VIDEO: { component: TopOfVideo, aspectRatio: 16 / 9, exclude: 4 },
  FLEX_16_9: {
    component: SplitScreen16to9,
    aspectRatio: 16 / 9,
    exclude: 8
  },
  FLEX: {
    component: SplitScreen,
    aspectRatio: 1,
    exclude: 0
  },
  DEFAULT: {
    component: NoPublishedStage,
    aspectRatio: 16 / 9,
    exclude: 8
  }
};
/* harmony default export */ var VideoGridParentvue_type_script_lang_js = ({
  components: {
    SpotlightInCorner: SpotlightInCorner,
    NoSpeaker: NoSpeaker,
    UnderTheScreen: UnderTheScreen,
    // TopOfVideo,
    SplitScreen: SplitScreen,
    SplitScreen16to9: SplitScreen16to9,
    NoPublishedStage: NoPublishedStage
  },
  data() {
    return {
      width: 160,
      height: 90
    };
  },
  props: {
    hasRoundedVideo: Boolean,
    showSingleSpeaker: Boolean,
    isBackstage: Boolean,
    streamList: Array,
    muted: Boolean,
    speakerId: String,
    screenLayout: String,
    audioOutputDeviceId: String,
    publishedItemOnStage: Boolean,
    hoveringStage: Boolean,
    agoraVersion: Number,
    minimized: Boolean,
    showHls: Boolean,
    isSomethingPublished: Object,
    remoteSignalMetadata: Object
  },
  computed: {
    getCompMeta() {
      if (this.isMobile() && this.publishedItemOnStage) {
        if (this.screenLayout == 'FLOATING') {
          return StageLayoutsCompMapping.UNDER_SCREEN;
        }
        if (this.screenLayout == 'FLEX_16_9') {
          return StageLayoutsCompMapping.FLEX;
        }
      }
      return this.publishedItemOnStage ? StageLayoutsCompMapping[this.screenLayout] : StageLayoutsCompMapping.DEFAULT;
    },
    getCurrentStageLayoutComp() {
      return this.getCompMeta.component;
    },
    applyRoundedCss() {
      return this.hasRoundedVideo && !this.isBackstage;
    }
  },
  methods: {
    detectVideoSizeForMinimisedVideo() {
      // eslint-disable-next-line no-console
      console.log('I am getting recalculated');
      if (this.$refs.videogridContainer?.$el) {
        const totalStreams = this.streamList?.length || (this.showHls ? 1 : 0);
        let streamsForCalculation = totalStreams;
        if (!this.isBackstage && this.publishedItemOnStage) {
          streamsForCalculation = 1;
        }
        let aspectRatio = 16 / 9;
        if (this.publishedItemOnStage && this.applyRoundedCss) {
          aspectRatio = 1;
        }
        if (this.publishedItemOnStage && this.screenLayout == 'FLEX_16_9') {
          aspectRatio = 16 / 9;
        }
        let dimensions = detectVideoSizeWithAspectRatioForMinimisedVideo(this.$refs.videogridContainer?.$el, streamsForCalculation, aspectRatio, this.getCompMeta?.exclude || 8);
        this.width = dimensions?.width;
        this.height = dimensions?.height;
      }
    },
    onWindowResize() {
      this.$nextTick(() => this.detectVideoSizeForMinimisedVideo());
    },
    isMobile() {
      return window.mobileCheck && window.mobileCheck();
    }
  },
  watch: {
    streamList(newVal, oldVal) {
      if (newVal.length != oldVal.length) {
        this.onWindowResize();
      }
    },
    screenLayout() {
      this.onWindowResize();
    },
    applyRoundedCss() {
      this.onWindowResize();
    },
    showSingleSpeaker() {
      this.onWindowResize();
    },
    isSomethingPublished: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.onWindowResize();
        }
      }
    }
  },
  mounted() {
    this.onWindowResize();
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/VideoGridParent.vue?vue&type=script&lang=js
 /* harmony default export */ var ConferenceRoom_VideoGridParentvue_type_script_lang_js = (VideoGridParentvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/VideoGridParent.vue?vue&type=style&index=0&id=22b1cbaa&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var VideoGridParentvue_type_style_index_0_id_22b1cbaa_prod_module_true_lang_scss = ({"root":"VideoGridParent_root_sjLbA","minimized":"VideoGridParent_minimized_hcs3N"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/VideoGridParent.vue?vue&type=style&index=0&id=22b1cbaa&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/VideoGridParent.vue



;




function VideoGridParent_injectStyles (context) {
  
  this["$style"] = (VideoGridParentvue_type_style_index_0_id_22b1cbaa_prod_module_true_lang_scss.locals || VideoGridParentvue_type_style_index_0_id_22b1cbaa_prod_module_true_lang_scss)

}

/* normalize component */

var VideoGridParent_component = normalizeComponent(
  ConferenceRoom_VideoGridParentvue_type_script_lang_js,
  VideoGridParentvue_type_template_id_22b1cbaa_render,
  VideoGridParentvue_type_template_id_22b1cbaa_staticRenderFns,
  false,
  VideoGridParent_injectStyles,
  null,
  null
  
)

/* harmony default export */ var VideoGridParent = (VideoGridParent_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/ConferenceRoomHover.vue?vue&type=template&id=21bea1b4&functional=true
var ConferenceRoomHovervue_type_template_id_21bea1b4_functional_true_render = function render(_c, _vm) {
  return _c('div', {
    class: [_vm.$style.root, _vm.props.hovering && _vm.$style.hovering]
  }, [_c('div', {
    class: _vm.$style.background
  }), _c('div', {
    class: _vm.$style.left
  }, [_vm.props.isBroadcast ? [_c('StyledText', {
    attrs: {
      "color": "primary-text-color",
      "variant": "subHeading13"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.time) + " ")]), _c('StyledText', {
    class: _vm.$style.dot,
    attrs: {
      "color": "primary-text-color",
      "variant": "heading26"
    }
  }, [_vm._v(" · ")])] : _vm._e()], 2), _c('div', {
    class: _vm.$style.rightSide
  }, [_c('GTooltip', {
    attrs: {
      "text": _vm.props.selectedCaptionLanguage ? _vm.props.selectedCaptionLanguage.disableReason : '',
      "disabled": _vm.props.selectedCaptionLanguage && !_vm.props.selectedCaptionLanguage.disabledCaptions,
      "position": "top-right"
    }
  }, [_vm.props.enableCaptionsButton ? _c('div', {
    class: _vm.props.selectedCaptionLanguage.disabledCaptions && _vm.$style.disabled,
    attrs: {
      "id": _vm.$style.captionButtonWrapper
    }
  }, [_c('div', {
    class: [_vm.$style.btnCaptionWrapper, _vm.props.areCaptionsEnabled && !_vm.props.selectedCaptionLanguage.disabledCaptions && _vm.$style.captionOn, _vm.props.selectedCaptionLanguage.disabledCaptions && _vm.$style.disabled]
  }, [_c('SvgIcon', {
    attrs: {
      "name": "captions",
      "ghost": "",
      "alt": ""
    },
    on: {
      "click": function ($event) {
        !_vm.props.selectedCaptionLanguage.disabledCaptions && _vm.listeners.enableCaptions(!_vm.props.areCaptionsEnabled);
      }
    }
  })], 1), _vm.props.enableTranslation && _vm.props.languages && _vm.props.languages.length > 0 && !_vm.props.selectedCaptionLanguage.disabledCaptions ? _c('SimpleSelect', {
    class: _vm.$style.languageSimpleSelect,
    attrs: {
      "options": _vm.props.languages,
      "value": _vm.props.selectedCaptionLanguage,
      "show-caret": false,
      "variant": "primary",
      "text-align": "left",
      "align": "right",
      "verticalPosition": "top"
    },
    on: {
      "input": selectedLanguage => _vm.listeners.selectedLanguage(selectedLanguage)
    }
  }, [_c('div', {
    class: _vm.$style.captionIcon
  }, [_c('StyledText', {
    attrs: {
      "variant": "body20"
    }
  }, [_vm._v(" " + _vm._s(_vm.props.selectedCaptionLanguage.value.toUpperCase()) + " ")]), _c('SvgIcon', {
    class: _vm.$style.dropDown,
    attrs: {
      "name": "down-arrow",
      "ghost": "",
      "alt": "",
      "variant": "primary",
      "size": "medium"
    }
  })], 1)]) : _vm._e()], 1) : _vm._e()]), _c('span', {
    attrs: {
      "id": _vm.$style.btnExpand
    }
  }, [_c('SvgIcon', {
    attrs: {
      "name": _vm.props.fullScreen ? 'collapse' : 'expand',
      "variant": "primary",
      "ghost": "",
      "alt": ""
    },
    on: {
      "click": function ($event) {
        return _vm.listeners.setFullScreen(!_vm.props.fullScreen);
      }
    }
  })], 1)], 1)]);
};
var ConferenceRoomHovervue_type_template_id_21bea1b4_functional_true_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/ConferenceRoomHover.vue?vue&type=script&lang=js
/* harmony default export */ var ConferenceRoomHovervue_type_script_lang_js = ({
  name: 'ConferenceRoomHover',
  functional: true,
  props: {
    time: String,
    watchCount: Number,
    fullScreen: Boolean,
    hovering: Boolean,
    isBroadcast: Boolean,
    areCaptionsEnabled: Boolean,
    enableCaptionsButton: Boolean,
    enableTranslation: Boolean,
    languages: Array,
    selectedCaptionLanguage: Object
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/ConferenceRoomHover.vue?vue&type=script&lang=js
 /* harmony default export */ var ConferenceRoom_ConferenceRoomHovervue_type_script_lang_js = (ConferenceRoomHovervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/ConferenceRoomHover.vue?vue&type=style&index=0&id=21bea1b4&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ConferenceRoomHovervue_type_style_index_0_id_21bea1b4_prod_module_true_lang_scss = ({"root":"ConferenceRoomHover_root_U6a9D","languageSimpleSelect":"ConferenceRoomHover_languageSimpleSelect_Y2NzQ","btnExpand":"ConferenceRoomHover_btnExpand_jZPyo","captionIcon":"ConferenceRoomHover_captionIcon_v6MWf","btnCaptionWrapper":"ConferenceRoomHover_btnCaptionWrapper_kWO7_","background":"ConferenceRoomHover_background_eZYwS","hovering":"ConferenceRoomHover_hovering_cHJmz","left":"ConferenceRoomHover_left_BXBPK","rightSide":"ConferenceRoomHover_rightSide_Ipl2S","captionButtonWrapper":"ConferenceRoomHover_captionButtonWrapper_IxyIo","dropDown":"ConferenceRoomHover_dropDown_iT8ZS","hardCodeText":"ConferenceRoomHover_hardCodeText_lDsNL","dot":"ConferenceRoomHover_dot_zSrcU","watching":"ConferenceRoomHover_watching_ioHhJ","captionOn":"ConferenceRoomHover_captionOn_NoZzF","disabled":"ConferenceRoomHover_disabled_UN9Fr"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/ConferenceRoomHover.vue?vue&type=style&index=0&id=21bea1b4&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/ConferenceRoomHover.vue



;




function ConferenceRoomHover_injectStyles (context) {
  
  this["$style"] = (ConferenceRoomHovervue_type_style_index_0_id_21bea1b4_prod_module_true_lang_scss.locals || ConferenceRoomHovervue_type_style_index_0_id_21bea1b4_prod_module_true_lang_scss)

}

/* normalize component */

var ConferenceRoomHover_component = normalizeComponent(
  ConferenceRoom_ConferenceRoomHovervue_type_script_lang_js,
  ConferenceRoomHovervue_type_template_id_21bea1b4_functional_true_render,
  ConferenceRoomHovervue_type_template_id_21bea1b4_functional_true_staticRenderFns,
  true,
  ConferenceRoomHover_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ConferenceRoomHover = (ConferenceRoomHover_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/LowerThird.vue?vue&type=template&id=9594c62a
var LowerThirdvue_type_template_id_9594c62a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    attrs: {
      "data-branding-target": "lower-third"
    }
  }, [_vm.spec.user ? _c('span', {
    class: _vm.$style.user_image
  }, [_c('UserImage', {
    class: _vm.$style.image,
    attrs: {
      "user": _vm.spec.user,
      "size": "small"
    }
  })], 1) : _vm._e(), _c('span', {
    class: _vm.$style.message_block
  }, [_vm.spec.user ? _c('StyledText', {
    attrs: {
      "variant": "heading20"
    }
  }, [_vm._v(" " + _vm._s(_vm.spec.user.name) + " ")]) : _vm._e(), _c('StyledText', {
    attrs: {
      "variant": "subHeading18"
    }
  }, [_vm._v(" " + _vm._s(_vm.spec.message) + " ")])], 1), _vm.isAdmin ? _c('CloseButton', {
    class: _vm.$style.close,
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }) : _vm._e()], 1);
};
var LowerThirdvue_type_template_id_9594c62a_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/molecules/LowerThird.vue?vue&type=script&lang=js
/* harmony default export */ var LowerThirdvue_type_script_lang_js = ({
  name: 'LowerThird',
  props: {
    spec: {
      type: Object,
      default: () => {}
    },
    isAdmin: Boolean
  }
});
;// CONCATENATED MODULE: ./src/molecules/LowerThird.vue?vue&type=script&lang=js
 /* harmony default export */ var molecules_LowerThirdvue_type_script_lang_js = (LowerThirdvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/molecules/LowerThird.vue?vue&type=style&index=0&id=9594c62a&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var LowerThirdvue_type_style_index_0_id_9594c62a_prod_module_true_lang_scss = ({"root":"LowerThird_root_IMOsr","message_block":"LowerThird_message_block_lmVtG","close":"LowerThird_close_KPBVk"});
;// CONCATENATED MODULE: ./src/molecules/LowerThird.vue?vue&type=style&index=0&id=9594c62a&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/molecules/LowerThird.vue



;




function LowerThird_injectStyles (context) {
  
  this["$style"] = (LowerThirdvue_type_style_index_0_id_9594c62a_prod_module_true_lang_scss.locals || LowerThirdvue_type_style_index_0_id_9594c62a_prod_module_true_lang_scss)

}

/* normalize component */

var LowerThird_component = normalizeComponent(
  molecules_LowerThirdvue_type_script_lang_js,
  LowerThirdvue_type_template_id_9594c62a_render,
  LowerThirdvue_type_template_id_9594c62a_staticRenderFns,
  false,
  LowerThird_injectStyles,
  null,
  null
  
)

/* harmony default export */ var LowerThird = (LowerThird_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/ConferenceRoom/index.vue?vue&type=script&lang=js







let hoverTimeout;
/* harmony default export */ var ConferenceRoomvue_type_script_lang_js = ({
  name: 'ConferenceRoom',
  components: {
    VideoGridParent: VideoGridParent,
    BackstageInfoArea: BackstageInfoArea,
    ConferenceRoomHover: ConferenceRoomHover,
    LowerThird: LowerThird,
    VideoCaptions: VideoCaptions
  },
  props: {
    streams: {
      type: Array,
      default: () => []
    },
    minimized: {
      type: Boolean,
      default: false
    },
    broadcast: {
      type: Object,
      default: () => ({})
    },
    hasAdminAccess: {
      type: Boolean,
      default: false
    },
    muted: {
      type: Boolean,
      default: false
    },
    recordingMode: {
      type: Boolean,
      default: false
    },
    isSessionEnded: {
      type: Boolean,
      default: false
    },
    streamPublishing: Boolean,
    hideOwnScreen: Boolean,
    audioOutputDeviceId: {
      type: String
    },
    layout: {
      type: String,
      default: 'FLOATING'
    },
    watchCount: Number,
    fullScreen: Boolean,
    areCaptionsEnabled: Boolean,
    publishedItemOnStage: Boolean,
    enableCaptionsButton: {
      type: Boolean,
      default: () => false
    },
    actionConfig: {
      type: Object,
      default: () => ({})
    },
    lowerThirdSpec: {
      type: Object,
      default: () => null
    },
    showLowerThird: {
      type: Boolean,
      default: false
    },
    bottomTickerData: {
      type: Object,
      default: () => null
    },
    isEventOrganizer: {
      type: Boolean,
      default: false
    },
    stageLogoSpec: {
      type: Object,
      default: () => ({
        url: null,
        fullScreen: false
      })
    },
    showSponsorLogo: {
      type: Boolean,
      default: false
    },
    isLiteMode: Boolean,
    captions: {
      type: Array,
      default: () => []
    },
    captionLanguages: {
      type: Array,
      default: () => []
    },
    selectedCaptionLanguage: {
      type: Object,
      default: null
    },
    enableTranslation: {
      type: Boolean,
      default: null
    },
    usersInside: {
      type: Array,
      default: () => []
    },
    forceHideStageItems: {
      type: Boolean,
      default: false
    },
    renderCaptionsNativelyInVideoPlayer: {
      type: Boolean,
      default: false
    },
    showOverlay: Boolean,
    remoteSignalMetadata: Object,
    timer: {
      type: Object,
      default: () => ({
        show: false
      })
    },
    isManualRedirectionEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hovering: false
    };
  },
  mounted() {
    document.querySelector('#backstageInfoArea')?.focus();
    this.observer = new resizeobserverimport(entries => {
      entries.forEach(() => {
        try {
          this.$refs?.video_grid_parent?.onWindowResize();
        } catch (e) {
          console.warn('Video Grid resizing calculations errored out!', e);
        }
      });
    });
    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    this.observer.unobserve(this.$el);
  },
  computed: {
    isSomethingPublished() {
      return {
        isLowerThird: this.showLowerThird,
        publishedItemOnStage: this.publishedItemOnStage,
        show_ticker: this.bottomTickerData?.show_ticker,
        showSponsorLogo: this.showSponsorLogo
      };
    },
    streamList() {
      const allStreams = this.streams || [];
      return !this.actionConfig.isBackstage || this.actionConfig.isBroadcast ? allStreams : allStreams.filter(e => e.isLocal);
    },
    showContent() {
      if (!this.showOnlyStageLogo) {
        return true;
      }
      if (this.isLiteMode) {
        return true;
      }
      return false;
    },
    stageLogoPositioningCSS() {
      if (this.showOnlyStageLogo) {
        return {};
      }
      const position = this.stageLogoSpec?.position || 'top-right';
      const [posY, posX] = position.split('-');
      let justifyContent = 'center';
      let order = 100;
      if (posX === 'left') {
        justifyContent = 'flex-start';
      } else if (posX === 'right') {
        justifyContent = 'flex-end';
      }
      if (posY === 'top') {
        order = -1;
      } else if (posY === 'bottom') {
        order = 100;
      }
      return {
        order,
        justifyContent
      };
    },
    showOnlyStageLogo() {
      return this.showSponsorLogo && !this.actionConfig.isBackstage && this.stageLogoSpec?.url && this.stageLogoSpec?.fullScreen;
    }
  },
  methods: {
    hovered: lodash_debounce_default()(function (event) {
      if (!this.isMobile() || this.isMobile() && event.target.nodeName != 'CANVAS') {
        this.hovering = !this.actionConfig.isBackstage;
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
          this.hovering = false;
        }, 3000);
      }
    }, 100),
    hoverout: lodash_debounce_default()(function () {
      this.hovering = false;
      clearTimeout(hoverTimeout);
    }, 101),
    isMobile() {
      return window.mobileCheck && window.mobileCheck();
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/index.vue?vue&type=script&lang=js
 /* harmony default export */ var examples_ConferenceRoomvue_type_script_lang_js = (ConferenceRoomvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/ConferenceRoom/index.vue?vue&type=style&index=0&id=e1baa37c&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var ConferenceRoomvue_type_style_index_0_id_e1baa37c_prod_module_true_lang_scss = ({"root":"index_root_TXErf","liteMode":"index_liteMode_KbnWP","stagePadding":"index_stagePadding_oIo0M","content":"index_content_LscMq","with-UNDER_SCREEN":"index_with-UNDER_SCREEN_hLNBV","backstage":"index_backstage_S5LQt","minimized":"index_minimized_eodxO","video_grid":"index_video_grid_LlCM_","recordingMode":"index_recordingMode_Uyv62","with_screen":"index_with_screen_XiNCz","stageTicker":"index_stageTicker_NqBhb","stageTickerWithLogo":"index_stageTickerWithLogo_pQeIa","stageTickerLiteMode":"index_stageTickerLiteMode_hbu1p","loader":"index_loader_UwDNl","backstage_pill":"index_backstage_pill_X_Ds5","sponsorLogoContainer":"index_sponsorLogoContainer_DYaUU","sponsorImageFullScreen":"index_sponsorImageFullScreen_i9LUt","sponsorImage":"index_sponsorImage_Vjdht","close":"index_close_bdAvR","stage_logo":"index_stage_logo_rbVZA","fullScreen":"index_fullScreen_I4Fz_","with-FLOATING":"index_with-FLOATING_xHtpg"});
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/index.vue?vue&type=style&index=0&id=e1baa37c&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/ConferenceRoom/index.vue



;




function ConferenceRoom_injectStyles (context) {
  
  this["$style"] = (ConferenceRoomvue_type_style_index_0_id_e1baa37c_prod_module_true_lang_scss.locals || ConferenceRoomvue_type_style_index_0_id_e1baa37c_prod_module_true_lang_scss)

}

/* normalize component */

var ConferenceRoom_component = normalizeComponent(
  examples_ConferenceRoomvue_type_script_lang_js,
  ConferenceRoomvue_type_template_id_e1baa37c_render,
  ConferenceRoomvue_type_template_id_e1baa37c_staticRenderFns,
  false,
  ConferenceRoom_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ConferenceRoom = (ConferenceRoom_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/HlsRoom.vue?vue&type=template&id=d964ff1c
var HlsRoomvue_type_template_id_d964ff1c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.$style.root, _vm.recordingMode && _vm.$style.recordingMode, _vm.isLiteMode && _vm.$style.liteMode],
    attrs: {
      "data-branding-target": "hls"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showHlsPlayer,
      expression: "showHlsPlayer"
    }],
    class: _vm.$style.videoPlayerContainer
  }, [_vm.hlsSupported ? _c('HlsVideoPlayer', {
    key: _vm.hlsVideoKey,
    attrs: {
      "progressBarConfig": _vm.progressBarConfig,
      "videoSrc": _vm.videoSource,
      "muted": _vm.muted,
      "borderRadius": _vm.minimized ? '4px' : '12px',
      "maintainHeight": _vm.minimized,
      "minimized": _vm.minimized,
      "activeAudioOutputDeviceID": _vm.audioOutputDeviceId,
      "renderCaptionsTrackNatively": _vm.renderCaptionsTrackNatively,
      "captionsAndSubtitlesEnabled": _vm.captionsAndSubtitlesEnabled,
      "selectedCaptionLanguageID": _vm.selectedCaptionLanguageID
    },
    on: {
      "play-aborted": function ($event) {
        return _vm.$emit('playAborted');
      },
      "stream-playback-started": _vm.onStreamPlayBackStarted,
      "stream-loading-error": function ($event) {
        _vm.simulivePlaybackStarted = false;
      },
      "remountHLS": () => _vm.hlsVideoKey++,
      "bufferingAndPlaybackStalled": data => _vm.$emit('bufferingAndPlaybackStalled', data),
      "onplay": function ($event) {
        return _vm.$emit('playStarted');
      },
      "video-playback-ended": function ($event) {
        return _vm.$emit('video-playback-ended');
      },
      "videoPlayerHoverStateChange": hoverState => _vm.$emit('videoPlayerHoverStateChange', hoverState),
      "hls-level-loaded": levelUrl => _vm.$emit('hls-level-loaded', levelUrl),
      "hls-embedded-text-tracks": tracks => _vm.$emit('hls-embedded-text-tracks', tracks)
    }
  }) : _c('HlsNotSupported', {
    attrs: {
      "minimized": _vm.minimized
    }
  })], 1), _vm.onStageMessage && _vm.showHlsPlayer && !_vm.minimized ? _c('div', {
    class: _vm.$style.additionalMessageContainer
  }, [_c('div', {
    class: _vm.$style.litemodeStageMessage
  }, [_c('StyledText', {
    class: _vm.$style.loadingMessageText,
    attrs: {
      "variant": "body11"
    }
  }, [_vm._v(" " + _vm._s(_vm.onStageMessage) + " ")])], 1)]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showHlsPlayer,
      expression: "!showHlsPlayer"
    }],
    class: _vm.$style.videoPlayerContainer
  }, [!_vm.isLiteMode ? _c('div', {
    class: _vm.$style.litemodeStageMessage
  }, [_c('StyledText', {
    class: _vm.$style.loadingMessageText,
    attrs: {
      "variant": "body14"
    }
  }, [_vm._v(" " + _vm._s(_vm.liteModeMessageText) + " ")])], 1) : !_vm.minimized && _vm.isLiteMode ? _c('div', {
    class: _vm.$style.litemodeStageMessage
  }, [_c('StyledText', {
    class: _vm.$style.loadingMessageText,
    attrs: {
      "variant": "body11"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('Loading Lite Mode... This may take up to 30s')) + " ")])], 1) : _vm._e()])]);
};
var HlsRoomvue_type_template_id_d964ff1c_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/HlsRoom.vue?vue&type=script&lang=js
/* harmony default export */ var HlsRoomvue_type_script_lang_js = ({
  props: {
    progressBarConfig: {
      type: Object,
      default: () => {
        return {
          totalVideoDuration: 0,
          currentVideoDuration: 0,
          showProgressBar: false
        };
      }
    },
    videoSource: {
      type: String,
      default: ''
    },
    muted: {
      type: Boolean,
      default: false
    },
    minimized: {
      type: Boolean,
      default: false
    },
    recordingMode: {
      type: Boolean,
      default: false
    },
    playerOnlyMode: {
      type: Boolean,
      default: false
    },
    isLiteMode: {
      type: Boolean,
      default: false
    },
    audioOutputDeviceId: {
      type: String
    },
    hlsSupported: {
      type: Boolean,
      default: false
    },
    isRtmpBroadcast: {
      type: Boolean,
      default: false
    },
    isBroadcastInLiveState: {
      type: Boolean,
      default: false
    },
    onStageMessage: {
      type: String,
      default: ''
    },
    renderCaptionsTrackNatively: {
      type: Boolean,
      default: false
    },
    captionsAndSubtitlesEnabled: {
      type: Boolean,
      default: false
    },
    selectedCaptionLanguageID: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      simulivePlaybackStarted: false,
      hlsVideoKey: 0
    };
  },
  computed: {
    showHlsPlayer() {
      return this.playerOnlyMode || this.simulivePlaybackStarted;
    },
    liteModeMessageText() {
      if (this.isBroadcastInLiveState) {
        return this.$t('Loading Video...');
      }
      return this.$t('Video will begin at session start time');
    }
  },
  methods: {
    onStreamPlayBackStarted() {
      this.$emit('streamPlayStarted');
      this.simulivePlaybackStarted = true;
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/HlsRoom.vue?vue&type=script&lang=js
 /* harmony default export */ var examples_HlsRoomvue_type_script_lang_js = (HlsRoomvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/HlsRoom.vue?vue&type=style&index=0&id=d964ff1c&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var HlsRoomvue_type_style_index_0_id_d964ff1c_prod_module_true_lang_scss = ({"root":"HlsRoom_root_zMu03","videoPlayerContainer":"HlsRoom_videoPlayerContainer_D5NrX","recordingMode":"HlsRoom_recordingMode__ostS","liteMode":"HlsRoom_liteMode_yNqy8","litemodeStageMessage":"HlsRoom_litemodeStageMessage_BZsH6","loadingMessageText":"HlsRoom_loadingMessageText_nQyh0"});
;// CONCATENATED MODULE: ./src/examples/HlsRoom.vue?vue&type=style&index=0&id=d964ff1c&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/HlsRoom.vue



;




function HlsRoom_injectStyles (context) {
  
  this["$style"] = (HlsRoomvue_type_style_index_0_id_d964ff1c_prod_module_true_lang_scss.locals || HlsRoomvue_type_style_index_0_id_d964ff1c_prod_module_true_lang_scss)

}

/* normalize component */

var HlsRoom_component = normalizeComponent(
  examples_HlsRoomvue_type_script_lang_js,
  HlsRoomvue_type_template_id_d964ff1c_render,
  HlsRoomvue_type_template_id_d964ff1c_staticRenderFns,
  false,
  HlsRoom_injectStyles,
  null,
  null
  
)

/* harmony default export */ var HlsRoom = (HlsRoom_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/StageRollVideoPlayer.vue?vue&type=template&id=263e16fe
var StageRollVideoPlayervue_type_template_id_263e16fe_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.hlsSupported ? _c('div', {
    class: _vm.$style.root
  }, [_c('HlsVideoPlayer', {
    key: _vm.hlsVideoKey,
    attrs: {
      "videoSrc": _vm.simuliveStreamUrl,
      "muted": _vm.streamsMuted,
      "borderRadius": "0px",
      "maintainHeight": _vm.minimized,
      "activeAudioOutputDeviceID": _vm.audioOutputDeviceId,
      "loop": true,
      "startPosition": _vm.startPosition,
      "emitFragChangedEvents": true
    },
    on: {
      "startofnextfragment": e => _vm.$emit('startofnextfragment', e),
      "play-aborted": () => _vm.$emit('playAborted'),
      "remountHLS": () => _vm.hlsVideoKey++
    }
  })], 1) : _c('HlsNotSupported', {
    attrs: {
      "minimized": _vm.minimized
    }
  });
};
var StageRollVideoPlayervue_type_template_id_263e16fe_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/StageRollVideoPlayer.vue?vue&type=script&lang=js
/* harmony default export */ var StageRollVideoPlayervue_type_script_lang_js = ({
  name: 'StageRollVideoPlayer',
  props: {
    simuliveStreamUrl: {
      type: String,
      default: ''
    },
    minimized: {
      type: Boolean,
      default: false
    },
    streamsMuted: {
      type: Boolean,
      default: false
    },
    audioOutputDeviceId: {
      type: String
    },
    // If -1 the playback will start from the live edge
    // rather than the custom start point.
    // Otherwise set it to the time from start in seconds.
    startPosition: {
      type: Number,
      default: -1
    },
    hlsSupported: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hlsVideoKey: 0
    };
  }
});
;// CONCATENATED MODULE: ./src/examples/StageRollVideoPlayer.vue?vue&type=script&lang=js
 /* harmony default export */ var examples_StageRollVideoPlayervue_type_script_lang_js = (StageRollVideoPlayervue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/StageRollVideoPlayer.vue?vue&type=style&index=0&id=263e16fe&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var StageRollVideoPlayervue_type_style_index_0_id_263e16fe_prod_module_true_lang_scss = ({"root":"StageRollVideoPlayer_root_EwEq6"});
;// CONCATENATED MODULE: ./src/examples/StageRollVideoPlayer.vue?vue&type=style&index=0&id=263e16fe&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/StageRollVideoPlayer.vue



;




function StageRollVideoPlayer_injectStyles (context) {
  
  this["$style"] = (StageRollVideoPlayervue_type_style_index_0_id_263e16fe_prod_module_true_lang_scss.locals || StageRollVideoPlayervue_type_style_index_0_id_263e16fe_prod_module_true_lang_scss)

}

/* normalize component */

var StageRollVideoPlayer_component = normalizeComponent(
  examples_StageRollVideoPlayervue_type_script_lang_js,
  StageRollVideoPlayervue_type_template_id_263e16fe_render,
  StageRollVideoPlayervue_type_template_id_263e16fe_staticRenderFns,
  false,
  StageRollVideoPlayer_injectStyles,
  null,
  null
  
)

/* harmony default export */ var StageRollVideoPlayer = (StageRollVideoPlayer_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SpeakersGrid.vue?vue&type=template&id=b4c6502e
var SpeakersGridvue_type_template_id_b4c6502e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.root,
    style: _vm.cssVars
  }, [_c('VirtualScroll', {
    attrs: {
      "cardHeight": 294,
      "cardWidth": 288,
      "itemsArray": _vm.eventSpeakers,
      "role": "list"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        item: user,
        index: i
      }) {
        return [_c('div', {
          attrs: {
            "role": "listitem"
          }
        }, [_c('SpeakerCard', {
          key: i,
          attrs: {
            "keyValue": i,
            "user": user
          },
          on: {
            "viewProfileClick": userData => _vm.$emit('viewProfileClick', userData)
          }
        })], 1)];
      }
    }])
  })], 1);
};
var SpeakersGridvue_type_template_id_b4c6502e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/components/SpeakersGrid.vue?vue&type=script&lang=js
/* harmony default export */ var SpeakersGridvue_type_script_lang_js = ({
  name: 'SpeakersGrid',
  props: {
    eventSpeakers: {
      type: Array,
      default: () => []
    },
    cssVars: {
      type: Object,
      default: () => {}
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SpeakersGrid.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SpeakersGridvue_type_script_lang_js = (SpeakersGridvue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/components/SpeakersGrid.vue?vue&type=style&index=0&id=b4c6502e&prod&lang=scss&module=true
// extracted by mini-css-extract-plugin
/* harmony default export */ var SpeakersGridvue_type_style_index_0_id_b4c6502e_prod_lang_scss_module_true = ({"root":"SpeakersGrid_root_KO1JH"});
;// CONCATENATED MODULE: ./src/components/SpeakersGrid.vue?vue&type=style&index=0&id=b4c6502e&prod&lang=scss&module=true
 
;// CONCATENATED MODULE: ./src/components/SpeakersGrid.vue



;




function SpeakersGrid_injectStyles (context) {
  
  this["$style"] = (SpeakersGridvue_type_style_index_0_id_b4c6502e_prod_lang_scss_module_true.locals || SpeakersGridvue_type_style_index_0_id_b4c6502e_prod_lang_scss_module_true)

}

/* normalize component */

var SpeakersGrid_component = normalizeComponent(
  components_SpeakersGridvue_type_script_lang_js,
  SpeakersGridvue_type_template_id_b4c6502e_render,
  SpeakersGridvue_type_template_id_b4c6502e_staticRenderFns,
  false,
  SpeakersGrid_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SpeakersGrid = (SpeakersGrid_component.exports);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/FreeTrialSuccessPage.vue?vue&type=template&id=abd2d93e
var FreeTrialSuccessPagevue_type_template_id_abd2d93e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.wrapper
  }, [_c('div', {
    class: _vm.$style.root
  }, [_c('h2', [_vm._v(_vm._s(_vm.$options.$t('Congratulations!')))]), _c('h4', [_vm._v(_vm._s(_vm.$options.$t(_vm.company)))]), _c('h5', [_vm._v(_vm._s(_vm.$options.$t('Your first Goldcast event is set up')) + ".")]), _c('span', [_vm._v(" " + _vm._s(_vm.$options.$t('You can always visit')) + " "), _c('a', {
    attrs: {
      "href": "https://help.goldcast.io/",
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('help.goldcast.io')) + " ")]), _vm._v(" " + _vm._s(_vm.$options.$t('for instructions on how to set up and run your events')) + ". ")]), _c('button', {
    class: _vm.$style.submit,
    on: {
      "click": function ($event) {
        return _vm.$emit('seeEvent');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$options.$t('See My Event')) + " ")])])]);
};
var FreeTrialSuccessPagevue_type_template_id_abd2d93e_staticRenderFns = [];

;// CONCATENATED MODULE: ../../node_modules/.pnpm/thread-loader@3.0.4_webpack@5.89.0/node_modules/thread-loader/dist/cjs.js!../../node_modules/.pnpm/babel-loader@8.2.3_@babel+core@7.22.5_webpack@5.89.0/node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!./src/examples/FreeTrialSuccessPage.vue?vue&type=script&lang=js
/* harmony default export */ var FreeTrialSuccessPagevue_type_script_lang_js = ({
  name: 'FreeTrialSuccessPage',
  props: {
    company: {
      type: String,
      default: 'Peak Community'
    }
  }
});
;// CONCATENATED MODULE: ./src/examples/FreeTrialSuccessPage.vue?vue&type=script&lang=js
 /* harmony default export */ var examples_FreeTrialSuccessPagevue_type_script_lang_js = (FreeTrialSuccessPagevue_type_script_lang_js); 
;// CONCATENATED MODULE: ../../node_modules/.pnpm/mini-css-extract-plugin@2.7.6_webpack@5.89.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-21.use[0]!../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-21.use[1]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.31_webpack@5.89.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-21.use[2]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.66.1_webpack@5.89.0/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-21.use[3]!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_prettier@2.8.8_react@18.2.0_vue-template-c_svjsps4hwl47tq2n6x5tdjdkzy/node_modules/vue-loader/lib/index.js??vue-loader-options!../../node_modules/.pnpm/file+scripts/node_modules/@goldcast/scripts/misc/languagestripper.js??clonedRuleSet-41.use!./src/examples/FreeTrialSuccessPage.vue?vue&type=style&index=0&id=abd2d93e&prod&module=true&lang=scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var FreeTrialSuccessPagevue_type_style_index_0_id_abd2d93e_prod_module_true_lang_scss = ({"wrapper":"FreeTrialSuccessPage_wrapper_qZ0sL","root":"FreeTrialSuccessPage_root_8DjBg","submit":"FreeTrialSuccessPage_submit_bm0eB"});
;// CONCATENATED MODULE: ./src/examples/FreeTrialSuccessPage.vue?vue&type=style&index=0&id=abd2d93e&prod&module=true&lang=scss
 
;// CONCATENATED MODULE: ./src/examples/FreeTrialSuccessPage.vue



;




function FreeTrialSuccessPage_injectStyles (context) {
  
  this["$style"] = (FreeTrialSuccessPagevue_type_style_index_0_id_abd2d93e_prod_module_true_lang_scss.locals || FreeTrialSuccessPagevue_type_style_index_0_id_abd2d93e_prod_module_true_lang_scss)

}

/* normalize component */

var FreeTrialSuccessPage_component = normalizeComponent(
  examples_FreeTrialSuccessPagevue_type_script_lang_js,
  FreeTrialSuccessPagevue_type_template_id_abd2d93e_render,
  FreeTrialSuccessPagevue_type_template_id_abd2d93e_staticRenderFns,
  false,
  FreeTrialSuccessPage_injectStyles,
  null,
  null
  
)

/* harmony default export */ var FreeTrialSuccessPage = (FreeTrialSuccessPage_component.exports);
;// CONCATENATED MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject = require("vue");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/vee-validate@3.3.9_vue@2.7.14/node_modules/vee-validate/dist/vee-validate.esm.js
/**
  * vee-validate v3.3.9
  * (c) 2020 Abdelrahman Awad
  * @license MIT
  */


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function vee_validate_esm_isNaN(value) {
    // NaN is the one value that does not equal itself.
    // eslint-disable-next-line
    return value !== value;
}
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
function isEmptyArray(arr) {
    return Array.isArray(arr) && arr.length === 0;
}
var isObject = function (obj) {
    return obj !== null && obj && typeof obj === 'object' && !Array.isArray(obj);
};
/**
 * A reference comparison function with NaN support
 */
function isRefEqual(lhs, rhs) {
    if (vee_validate_esm_isNaN(lhs) && vee_validate_esm_isNaN(rhs)) {
        return true;
    }
    return lhs === rhs;
}
/**
 * Shallow object comparison.
 */
function isEqual(lhs, rhs) {
    if (lhs instanceof RegExp && rhs instanceof RegExp) {
        return isEqual(lhs.source, rhs.source) && isEqual(lhs.flags, rhs.flags);
    }
    if (Array.isArray(lhs) && Array.isArray(rhs)) {
        if (lhs.length !== rhs.length)
            return false;
        for (var i = 0; i < lhs.length; i++) {
            if (!isEqual(lhs[i], rhs[i])) {
                return false;
            }
        }
        return true;
    }
    // if both are objects, compare each key recursively.
    if (isObject(lhs) && isObject(rhs)) {
        return (Object.keys(lhs).every(function (key) {
            return isEqual(lhs[key], rhs[key]);
        }) &&
            Object.keys(rhs).every(function (key) {
                return isEqual(lhs[key], rhs[key]);
            }));
    }
    return isRefEqual(lhs, rhs);
}
// Checks if a given value is not an empty string or null or undefined.
function isSpecified(val) {
    if (val === '') {
        return false;
    }
    return !isNullOrUndefined(val);
}
function isCallable(fn) {
    return typeof fn === 'function';
}
function isLocator(value) {
    return isCallable(value) && !!value.__locatorRef;
}

function findIndex(arrayLike, predicate) {
    var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
    if (isCallable(array.findIndex)) {
        return array.findIndex(predicate);
    }
    /* istanbul ignore next */
    for (var i = 0; i < array.length; i++) {
        if (predicate(array[i], i)) {
            return i;
        }
    }
    /* istanbul ignore next */
    return -1;
}
/**
 * finds the first element that satisfies the predicate callback, polyfills array.find
 */
function find(arrayLike, predicate) {
    var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
    var idx = findIndex(array, predicate);
    return idx === -1 ? undefined : array[idx];
}
function includes(collection, item) {
    return collection.indexOf(item) !== -1;
}
/**
 * Converts an array-like object to array, provides a simple polyfill for Array.from
 */
function toArray(arrayLike) {
    if (isCallable(Array.from)) {
        return Array.from(arrayLike);
    }
    /* istanbul ignore next */
    return _copyArray(arrayLike);
}
/* istanbul ignore next */
function _copyArray(arrayLike) {
    var array = [];
    var length = arrayLike.length;
    for (var i = 0; i < length; i++) {
        array.push(arrayLike[i]);
    }
    return array;
}
function values(obj) {
    if (isCallable(Object.values)) {
        return Object.values(obj);
    }
    // fallback to keys()
    /* istanbul ignore next */
    return Object.keys(obj).map(function (k) { return obj[k]; });
}
function merge(target, source) {
    Object.keys(source).forEach(function (key) {
        if (isObject(source[key])) {
            if (!target[key]) {
                target[key] = {};
            }
            merge(target[key], source[key]);
            return;
        }
        target[key] = source[key];
    });
    return target;
}

function createFlags() {
    return {
        untouched: true,
        touched: false,
        dirty: false,
        pristine: true,
        valid: false,
        invalid: false,
        validated: false,
        pending: false,
        required: false,
        changed: false,
        passed: false,
        failed: false
    };
}

function identity(x) {
    return x;
}
function debounce(fn, wait, token) {
    if (wait === void 0) { wait = 0; }
    if (token === void 0) { token = { cancelled: false }; }
    if (wait === 0) {
        return fn;
    }
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var later = function () {
            timeout = undefined;
            // check if the fn call was cancelled.
            if (!token.cancelled)
                fn.apply(void 0, args);
        };
        // because we might want to use Node.js setTimout for SSR.
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

/**
 * Emits a warning to the console
 */
function warn(message) {
    console.warn("[vee-validate] " + message);
}
/**
 * Replaces placeholder values in a string with their actual values
 */
function interpolate(template, values) {
    return template.replace(/{([^}]+)}/g, function (_, p) {
        return p in values ? values[p] : "{" + p + "}";
    });
}

var RULES = {};
function normalizeSchema(schema) {
    var _a;
    if ((_a = schema.params) === null || _a === void 0 ? void 0 : _a.length) {
        schema.params = schema.params.map(function (param) {
            if (typeof param === 'string') {
                return { name: param };
            }
            return param;
        });
    }
    return schema;
}
var RuleContainer = /** @class */ (function () {
    function RuleContainer() {
    }
    RuleContainer.extend = function (name, schema) {
        // if rule already exists, overwrite it.
        var rule = normalizeSchema(schema);
        if (RULES[name]) {
            RULES[name] = merge(RULES[name], schema);
            return;
        }
        RULES[name] = __assign({ lazy: false, computesRequired: false }, rule);
    };
    RuleContainer.isLazy = function (name) {
        var _a;
        return !!((_a = RULES[name]) === null || _a === void 0 ? void 0 : _a.lazy);
    };
    RuleContainer.isRequireRule = function (name) {
        var _a;
        return !!((_a = RULES[name]) === null || _a === void 0 ? void 0 : _a.computesRequired);
    };
    RuleContainer.getRuleDefinition = function (ruleName) {
        return RULES[ruleName];
    };
    return RuleContainer;
}());
/**
 * Adds a custom validator to the list of validation rules.
 */
function extend(name, schema) {
    // makes sure new rules are properly formatted.
    guardExtend(name, schema);
    // Full schema object.
    if (typeof schema === 'object') {
        RuleContainer.extend(name, schema);
        return;
    }
    RuleContainer.extend(name, {
        validate: schema
    });
}
/**
 * Guards from extension violations.
 */
function guardExtend(name, validator) {
    if (isCallable(validator)) {
        return;
    }
    if (isCallable(validator.validate)) {
        return;
    }
    if (RuleContainer.getRuleDefinition(name)) {
        return;
    }
    throw new Error("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.");
}

var DEFAULT_CONFIG = {
    defaultMessage: "{_field_} is not valid.",
    skipOptional: true,
    classes: {
        touched: 'touched',
        untouched: 'untouched',
        valid: 'valid',
        invalid: 'invalid',
        pristine: 'pristine',
        dirty: 'dirty' // control has been interacted with
    },
    bails: true,
    mode: 'aggressive',
    useConstraintAttrs: true
};
var currentConfig = __assign({}, DEFAULT_CONFIG);
var getConfig = function () { return currentConfig; };
var setConfig = function (newConf) {
    currentConfig = __assign(__assign({}, currentConfig), newConf);
};
var configure = function (cfg) {
    setConfig(cfg);
};

/**
 * Normalizes the given rules expression.
 */
function normalizeRules(rules) {
    // if falsy value return an empty object.
    var acc = {};
    Object.defineProperty(acc, '_$$isNormalized', {
        value: true,
        writable: false,
        enumerable: false,
        configurable: false
    });
    if (!rules) {
        return acc;
    }
    // Object is already normalized, skip.
    if (isObject(rules) && rules._$$isNormalized) {
        return rules;
    }
    if (isObject(rules)) {
        return Object.keys(rules).reduce(function (prev, curr) {
            var params = [];
            if (rules[curr] === true) {
                params = [];
            }
            else if (Array.isArray(rules[curr])) {
                params = rules[curr];
            }
            else if (isObject(rules[curr])) {
                params = rules[curr];
            }
            else {
                params = [rules[curr]];
            }
            if (rules[curr] !== false) {
                prev[curr] = buildParams(curr, params);
            }
            return prev;
        }, acc);
    }
    /* istanbul ignore if */
    if (typeof rules !== 'string') {
        warn('rules must be either a string or an object.');
        return acc;
    }
    return rules.split('|').reduce(function (prev, rule) {
        var parsedRule = parseRule(rule);
        if (!parsedRule.name) {
            return prev;
        }
        prev[parsedRule.name] = buildParams(parsedRule.name, parsedRule.params);
        return prev;
    }, acc);
}
function buildParams(ruleName, provided) {
    var ruleSchema = RuleContainer.getRuleDefinition(ruleName);
    if (!ruleSchema) {
        return provided;
    }
    var params = {};
    if (!ruleSchema.params && !Array.isArray(provided)) {
        throw new Error('You provided an object params to a rule that has no defined schema.');
    }
    // Rule probably uses an array for their args, keep it as is.
    if (Array.isArray(provided) && !ruleSchema.params) {
        return provided;
    }
    var definedParams;
    // collect the params schema.
    if (!ruleSchema.params || (ruleSchema.params.length < provided.length && Array.isArray(provided))) {
        var lastDefinedParam_1;
        // collect any additional parameters in the last item.
        definedParams = provided.map(function (_, idx) {
            var _a;
            var param = (_a = ruleSchema.params) === null || _a === void 0 ? void 0 : _a[idx];
            lastDefinedParam_1 = param || lastDefinedParam_1;
            if (!param) {
                param = lastDefinedParam_1;
            }
            return param;
        });
    }
    else {
        definedParams = ruleSchema.params;
    }
    // Match the provided array length with a temporary schema.
    for (var i = 0; i < definedParams.length; i++) {
        var options = definedParams[i];
        var value = options.default;
        // if the provided is an array, map element value.
        if (Array.isArray(provided)) {
            if (i in provided) {
                value = provided[i];
            }
        }
        else {
            // If the param exists in the provided object.
            if (options.name in provided) {
                value = provided[options.name];
                // if the provided is the first param value.
            }
            else if (definedParams.length === 1) {
                value = provided;
            }
        }
        // if the param is a target, resolve the target value.
        if (options.isTarget) {
            value = createLocator(value, options.cast);
        }
        // A target param using interpolation
        if (typeof value === 'string' && value[0] === '@') {
            value = createLocator(value.slice(1), options.cast);
        }
        // If there is a transformer defined.
        if (!isLocator(value) && options.cast) {
            value = options.cast(value);
        }
        // already been set, probably multiple values.
        if (params[options.name]) {
            params[options.name] = Array.isArray(params[options.name]) ? params[options.name] : [params[options.name]];
            params[options.name].push(value);
        }
        else {
            // set the value.
            params[options.name] = value;
        }
    }
    return params;
}
/**
 * Parses a rule string expression.
 */
var parseRule = function (rule) {
    var params = [];
    var name = rule.split(':')[0];
    if (includes(rule, ':')) {
        params = rule
            .split(':')
            .slice(1)
            .join(':')
            .split(',');
    }
    return { name: name, params: params };
};
function createLocator(value, castFn) {
    var locator = function (crossTable) {
        var val = crossTable[value];
        return castFn ? castFn(val) : val;
    };
    locator.__locatorRef = value;
    return locator;
}
function extractLocators(params) {
    if (Array.isArray(params)) {
        return params.filter(isLocator);
    }
    return Object.keys(params)
        .filter(function (key) { return isLocator(params[key]); })
        .map(function (key) { return params[key]; });
}

/**
 * Validates a value against the rules.
 */
function validate(value, rules, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var shouldBail, skipIfEmpty, field, result, errors, failedRules, regenerateMap;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    shouldBail = options === null || options === void 0 ? void 0 : options.bails;
                    skipIfEmpty = options === null || options === void 0 ? void 0 : options.skipIfEmpty;
                    field = {
                        name: (options === null || options === void 0 ? void 0 : options.name) || '{field}',
                        rules: normalizeRules(rules),
                        bails: shouldBail !== null && shouldBail !== void 0 ? shouldBail : true,
                        skipIfEmpty: skipIfEmpty !== null && skipIfEmpty !== void 0 ? skipIfEmpty : true,
                        forceRequired: false,
                        crossTable: (options === null || options === void 0 ? void 0 : options.values) || {},
                        names: (options === null || options === void 0 ? void 0 : options.names) || {},
                        customMessages: (options === null || options === void 0 ? void 0 : options.customMessages) || {}
                    };
                    return [4 /*yield*/, _validate(field, value, options)];
                case 1:
                    result = _a.sent();
                    errors = [];
                    failedRules = {};
                    regenerateMap = {};
                    result.errors.forEach(function (e) {
                        var msg = e.msg();
                        errors.push(msg);
                        failedRules[e.rule] = msg;
                        regenerateMap[e.rule] = e.msg;
                    });
                    return [2 /*return*/, {
                            valid: result.valid,
                            errors: errors,
                            failedRules: failedRules,
                            regenerateMap: regenerateMap
                        }];
            }
        });
    });
}
/**
 * Starts the validation process.
 */
function _validate(field, value, _a) {
    var _b = (_a === void 0 ? {} : _a).isInitial, isInitial = _b === void 0 ? false : _b;
    return __awaiter(this, void 0, void 0, function () {
        var _c, shouldSkip, errors, rules, length, i, rule, result;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, _shouldSkip(field, value)];
                case 1:
                    _c = _d.sent(), shouldSkip = _c.shouldSkip, errors = _c.errors;
                    if (shouldSkip) {
                        return [2 /*return*/, {
                                valid: !errors.length,
                                errors: errors
                            }];
                    }
                    rules = Object.keys(field.rules).filter(function (rule) { return !RuleContainer.isRequireRule(rule); });
                    length = rules.length;
                    i = 0;
                    _d.label = 2;
                case 2:
                    if (!(i < length)) return [3 /*break*/, 5];
                    if (isInitial && RuleContainer.isLazy(rules[i])) {
                        return [3 /*break*/, 4];
                    }
                    rule = rules[i];
                    return [4 /*yield*/, _test(field, value, {
                            name: rule,
                            params: field.rules[rule]
                        })];
                case 3:
                    result = _d.sent();
                    if (!result.valid && result.error) {
                        errors.push(result.error);
                        if (field.bails) {
                            return [2 /*return*/, {
                                    valid: false,
                                    errors: errors
                                }];
                        }
                    }
                    _d.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 2];
                case 5: return [2 /*return*/, {
                        valid: !errors.length,
                        errors: errors
                    }];
            }
        });
    });
}
function _shouldSkip(field, value) {
    return __awaiter(this, void 0, void 0, function () {
        var requireRules, length, errors, isEmpty, isEmptyAndOptional, isRequired, i, rule, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requireRules = Object.keys(field.rules).filter(RuleContainer.isRequireRule);
                    length = requireRules.length;
                    errors = [];
                    isEmpty = isNullOrUndefined(value) || value === '' || isEmptyArray(value);
                    isEmptyAndOptional = isEmpty && field.skipIfEmpty;
                    isRequired = false;
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < length)) return [3 /*break*/, 4];
                    rule = requireRules[i];
                    return [4 /*yield*/, _test(field, value, {
                            name: rule,
                            params: field.rules[rule]
                        })];
                case 2:
                    result = _a.sent();
                    if (!isObject(result)) {
                        throw new Error('Require rules has to return an object (see docs)');
                    }
                    if (result.required) {
                        isRequired = true;
                    }
                    if (!result.valid && result.error) {
                        errors.push(result.error);
                        // Exit early as the field is required and failed validation.
                        if (field.bails) {
                            return [2 /*return*/, {
                                    shouldSkip: true,
                                    errors: errors
                                }];
                        }
                    }
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4:
                    if (isEmpty && !isRequired && !field.skipIfEmpty) {
                        return [2 /*return*/, {
                                shouldSkip: false,
                                errors: errors
                            }];
                    }
                    // field is configured to run through the pipeline regardless
                    if (!field.bails && !isEmptyAndOptional) {
                        return [2 /*return*/, {
                                shouldSkip: false,
                                errors: errors
                            }];
                    }
                    // skip if the field is not required and has an empty value.
                    return [2 /*return*/, {
                            shouldSkip: !isRequired && isEmpty,
                            errors: errors
                        }];
            }
        });
    });
}
/**
 * Tests a single input value against a rule.
 */
function _test(field, value, rule) {
    return __awaiter(this, void 0, void 0, function () {
        var ruleSchema, normalizedValue, params, result, values_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ruleSchema = RuleContainer.getRuleDefinition(rule.name);
                    if (!ruleSchema || !ruleSchema.validate) {
                        throw new Error("No such validator '" + rule.name + "' exists.");
                    }
                    normalizedValue = ruleSchema.castValue ? ruleSchema.castValue(value) : value;
                    params = fillTargetValues(rule.params, field.crossTable);
                    return [4 /*yield*/, ruleSchema.validate(normalizedValue, params)];
                case 1:
                    result = _a.sent();
                    if (typeof result === 'string') {
                        values_1 = __assign(__assign({}, (params || {})), { _field_: field.name, _value_: value, _rule_: rule.name });
                        return [2 /*return*/, {
                                valid: false,
                                error: { rule: rule.name, msg: function () { return interpolate(result, values_1); } }
                            }];
                    }
                    if (!isObject(result)) {
                        result = { valid: result };
                    }
                    return [2 /*return*/, {
                            valid: result.valid,
                            required: result.required,
                            error: result.valid ? undefined : _generateFieldError(field, value, ruleSchema, rule.name, params)
                        }];
            }
        });
    });
}
/**
 * Generates error messages.
 */
function _generateFieldError(field, value, ruleSchema, ruleName, params) {
    var _a;
    var message = (_a = field.customMessages[ruleName]) !== null && _a !== void 0 ? _a : ruleSchema.message;
    var ruleTargets = _getRuleTargets(field, ruleSchema, ruleName);
    var _b = _getUserTargets(field, ruleSchema, ruleName, message), userTargets = _b.userTargets, userMessage = _b.userMessage;
    var values = __assign(__assign(__assign(__assign({}, (params || {})), { _field_: field.name, _value_: value, _rule_: ruleName }), ruleTargets), userTargets);
    return {
        msg: function () { return _normalizeMessage(userMessage || getConfig().defaultMessage, field.name, values); },
        rule: ruleName
    };
}
function _getRuleTargets(field, ruleSchema, ruleName) {
    var params = ruleSchema.params;
    if (!params) {
        return {};
    }
    var numTargets = params.filter(function (param) { return param.isTarget; }).length;
    if (numTargets <= 0) {
        return {};
    }
    var names = {};
    var ruleConfig = field.rules[ruleName];
    if (!Array.isArray(ruleConfig) && isObject(ruleConfig)) {
        ruleConfig = params.map(function (param) {
            return ruleConfig[param.name];
        });
    }
    for (var index = 0; index < params.length; index++) {
        var param = params[index];
        var key = ruleConfig[index];
        if (!isLocator(key)) {
            continue;
        }
        key = key.__locatorRef;
        var name_1 = field.names[key] || key;
        names[param.name] = name_1;
        names["_" + param.name + "_"] = field.crossTable[key];
    }
    return names;
}
function _getUserTargets(field, ruleSchema, ruleName, userMessage) {
    var userTargets = {};
    var rules = field.rules[ruleName];
    var params = ruleSchema.params || [];
    // early return if no rules
    if (!rules) {
        return {};
    }
    // check all rules to convert targets
    Object.keys(rules).forEach(function (key, index) {
        // get the rule
        var rule = rules[key];
        if (!isLocator(rule)) {
            return {};
        }
        // get associated parameter
        var param = params[index];
        if (!param) {
            return {};
        }
        // grab the name of the target
        var name = rule.__locatorRef;
        userTargets[param.name] = field.names[name] || name;
        userTargets["_" + param.name + "_"] = field.crossTable[name];
    });
    return {
        userTargets: userTargets,
        userMessage: userMessage
    };
}
function _normalizeMessage(template, field, values) {
    if (typeof template === 'function') {
        return template(field, values);
    }
    return interpolate(template, __assign(__assign({}, values), { _field_: field }));
}
function fillTargetValues(params, crossTable) {
    if (Array.isArray(params)) {
        return params;
    }
    var values = {};
    var normalize = function (value) {
        if (isLocator(value)) {
            return value(crossTable);
        }
        return value;
    };
    Object.keys(params).forEach(function (param) {
        values[param] = normalize(params[param]);
    });
    return values;
}

var aggressive = function () { return ({
    on: ['input', 'blur']
}); };
var lazy = function () { return ({
    on: ['change']
}); };
var eager = function (_a) {
    var errors = _a.errors;
    if (errors.length) {
        return {
            on: ['input', 'change']
        };
    }
    return {
        on: ['change', 'blur']
    };
};
var passive = function () { return ({
    on: []
}); };
var modes = {
    aggressive: aggressive,
    eager: eager,
    passive: passive,
    lazy: lazy
};
var setInteractionMode = function (mode, implementation) {
    setConfig({ mode: mode });
    if (!implementation) {
        return;
    }
    if (!isCallable(implementation)) {
        throw new Error('A mode implementation must be a function');
    }
    modes[mode] = implementation;
};

var EVENT_BUS = new (external_commonjs_vue_commonjs2_vue_root_Vue_default())();
function localeChanged() {
    EVENT_BUS.$emit('change:locale');
}

var Dictionary = /** @class */ (function () {
    function Dictionary(locale, dictionary) {
        this.container = {};
        this.locale = locale;
        this.merge(dictionary);
    }
    Dictionary.prototype.resolve = function (field, rule, values) {
        return this.format(this.locale, field, rule, values);
    };
    Dictionary.prototype.format = function (locale, field, rule, values) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var message;
        // find if specific message for that field was specified.
        message = ((_c = (_b = (_a = this.container[locale]) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b[field]) === null || _c === void 0 ? void 0 : _c[rule]) || ((_e = (_d = this.container[locale]) === null || _d === void 0 ? void 0 : _d.messages) === null || _e === void 0 ? void 0 : _e[rule]);
        if (!message) {
            message = '{_field_} is not valid';
        }
        field = (_h = (_g = (_f = this.container[locale]) === null || _f === void 0 ? void 0 : _f.names) === null || _g === void 0 ? void 0 : _g[field]) !== null && _h !== void 0 ? _h : field;
        return isCallable(message) ? message(field, values) : interpolate(message, __assign(__assign({}, values), { _field_: field }));
    };
    Dictionary.prototype.merge = function (dictionary) {
        merge(this.container, dictionary);
    };
    Dictionary.prototype.hasRule = function (name) {
        var _a, _b;
        return !!((_b = (_a = this.container[this.locale]) === null || _a === void 0 ? void 0 : _a.messages) === null || _b === void 0 ? void 0 : _b[name]);
    };
    return Dictionary;
}());
var DICTIONARY;
function localize(locale, dictionary) {
    var _a;
    if (!DICTIONARY) {
        DICTIONARY = new Dictionary('en', {});
        setConfig({
            defaultMessage: function (field, values) {
                return DICTIONARY.resolve(field, values === null || values === void 0 ? void 0 : values._rule_, values || {});
            }
        });
    }
    if (typeof locale === 'string') {
        DICTIONARY.locale = locale;
        if (dictionary) {
            DICTIONARY.merge((_a = {}, _a[locale] = dictionary, _a));
        }
        localeChanged();
        return;
    }
    DICTIONARY.merge(locale);
}

var isEvent = function (evt) {
    if (!evt) {
        return false;
    }
    if (typeof Event !== 'undefined' && isCallable(Event) && evt instanceof Event) {
        return true;
    }
    // this is for IE
    /* istanbul ignore next */
    if (evt && evt.srcElement) {
        return true;
    }
    return false;
};
function normalizeEventValue(value) {
    var _a, _b;
    if (!isEvent(value)) {
        return value;
    }
    var input = value.target;
    if (input.type === 'file' && input.files) {
        return toArray(input.files);
    }
    // If the input has a `v-model.number` modifier applied.
    if ((_a = input._vModifiers) === null || _a === void 0 ? void 0 : _a.number) {
        // as per the spec the v-model.number uses parseFloat
        var valueAsNumber = parseFloat(input.value);
        if (vee_validate_esm_isNaN(valueAsNumber)) {
            return input.value;
        }
        return valueAsNumber;
    }
    if ((_b = input._vModifiers) === null || _b === void 0 ? void 0 : _b.trim) {
        var trimmedValue = typeof input.value === 'string' ? input.value.trim() : input.value;
        return trimmedValue;
    }
    return input.value;
}

var isTextInput = function (vnode) {
    var _a;
    var attrs = ((_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs) || vnode.elm;
    // it will fallback to being a text input per browsers spec.
    if (vnode.tag === 'input' && (!attrs || !attrs.type)) {
        return true;
    }
    if (vnode.tag === 'textarea') {
        return true;
    }
    return includes(['text', 'password', 'search', 'email', 'tel', 'url', 'number'], attrs === null || attrs === void 0 ? void 0 : attrs.type);
};
// export const isCheckboxOrRadioInput = (vnode: VNode): boolean => {
//   const attrs = (vnode.data && vnode.data.attrs) || vnode.elm;
//   return includes(['radio', 'checkbox'], attrs && attrs.type);
// };
// Gets the model object on the vnode.
function findModel(vnode) {
    if (!vnode.data) {
        return undefined;
    }
    // Component Model
    // THIS IS NOT TYPED IN OFFICIAL VUE TYPINGS
    // eslint-disable-next-line
    var nonStandardVNodeData = vnode.data;
    if ('model' in nonStandardVNodeData) {
        return nonStandardVNodeData.model;
    }
    if (!vnode.data.directives) {
        return undefined;
    }
    return find(vnode.data.directives, function (d) { return d.name === 'model'; });
}
function findValue(vnode) {
    var _a, _b;
    var model = findModel(vnode);
    if (model) {
        return { value: model.value };
    }
    var config = findModelConfig(vnode);
    var prop = (config === null || config === void 0 ? void 0 : config.prop) || 'value';
    if (((_a = vnode.componentOptions) === null || _a === void 0 ? void 0 : _a.propsData) && prop in vnode.componentOptions.propsData) {
        var propsDataWithValue = vnode.componentOptions.propsData;
        return { value: propsDataWithValue[prop] };
    }
    if (((_b = vnode.data) === null || _b === void 0 ? void 0 : _b.domProps) && 'value' in vnode.data.domProps) {
        return { value: vnode.data.domProps.value };
    }
    return undefined;
}
function extractChildren(vnode) {
    if (Array.isArray(vnode)) {
        return vnode;
    }
    if (Array.isArray(vnode.children)) {
        return vnode.children;
    }
    /* istanbul ignore next */
    if (vnode.componentOptions && Array.isArray(vnode.componentOptions.children)) {
        return vnode.componentOptions.children;
    }
    return [];
}
function findInputNodes(vnode) {
    if (!Array.isArray(vnode) && findValue(vnode) !== undefined) {
        return [vnode];
    }
    var children = extractChildren(vnode);
    return children.reduce(function (nodes, node) {
        var candidates = findInputNodes(node);
        if (candidates.length) {
            nodes.push.apply(nodes, candidates);
        }
        return nodes;
    }, []);
}
// Resolves v-model config if exists.
function findModelConfig(vnode) {
    /* istanbul ignore next */
    if (!vnode.componentOptions)
        return null;
    // This is also not typed in the standard Vue TS.
    return vnode.componentOptions.Ctor.options.model;
}
// Adds a listener to vnode listener object.
function mergeVNodeListeners(obj, eventName, handler) {
    // no listener at all.
    if (isNullOrUndefined(obj[eventName])) {
        obj[eventName] = [handler];
        return;
    }
    // Is an invoker.
    if (isCallable(obj[eventName]) && obj[eventName].fns) {
        var invoker = obj[eventName];
        invoker.fns = Array.isArray(invoker.fns) ? invoker.fns : [invoker.fns];
        if (!includes(invoker.fns, handler)) {
            invoker.fns.push(handler);
        }
        return;
    }
    if (isCallable(obj[eventName])) {
        var prev = obj[eventName];
        obj[eventName] = [prev];
    }
    if (Array.isArray(obj[eventName]) && !includes(obj[eventName], handler)) {
        obj[eventName].push(handler);
    }
}
// Adds a listener to a native HTML vnode.
function addNativeNodeListener(node, eventName, handler) {
    /* istanbul ignore next */
    if (!node.data) {
        node.data = {};
    }
    if (isNullOrUndefined(node.data.on)) {
        node.data.on = {};
    }
    mergeVNodeListeners(node.data.on, eventName, handler);
}
// Adds a listener to a Vue component vnode.
function addComponentNodeListener(node, eventName, handler) {
    /* istanbul ignore next */
    if (!node.componentOptions) {
        return;
    }
    /* istanbul ignore next */
    if (!node.componentOptions.listeners) {
        node.componentOptions.listeners = {};
    }
    mergeVNodeListeners(node.componentOptions.listeners, eventName, handler);
}
function addVNodeListener(vnode, eventName, handler) {
    if (vnode.componentOptions) {
        addComponentNodeListener(vnode, eventName, handler);
        return;
    }
    addNativeNodeListener(vnode, eventName, handler);
}
// Determines if `change` should be used over `input` for listeners.
function getInputEventName(vnode, model) {
    var _a;
    // Is a component.
    if (vnode.componentOptions) {
        var event_1 = (findModelConfig(vnode) || { event: 'input' }).event;
        return event_1;
    }
    // Lazy Models typically use change event
    if ((_a = model === null || model === void 0 ? void 0 : model.modifiers) === null || _a === void 0 ? void 0 : _a.lazy) {
        return 'change';
    }
    // is a textual-type input.
    if (isTextInput(vnode)) {
        return 'input';
    }
    return 'change';
}
function isHTMLNode(node) {
    return includes(['input', 'select', 'textarea'], node.tag);
}
// TODO: Type this one properly.
function normalizeSlots(slots, ctx) {
    var acc = [];
    return Object.keys(slots).reduce(function (arr, key) {
        slots[key].forEach(function (vnode) {
            if (!vnode.context) {
                slots[key].context = ctx;
                if (!vnode.data) {
                    vnode.data = {};
                }
                vnode.data.slot = key;
            }
        });
        return arr.concat(slots[key]);
    }, acc);
}
function resolveTextualRules(vnode) {
    var _a;
    var attrs = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs;
    var rules = {};
    if (!attrs)
        return rules;
    if (attrs.type === 'email' && RuleContainer.getRuleDefinition('email')) {
        rules.email = ['multiple' in attrs];
    }
    if (attrs.pattern && RuleContainer.getRuleDefinition('regex')) {
        rules.regex = attrs.pattern;
    }
    if (attrs.maxlength >= 0 && RuleContainer.getRuleDefinition('max')) {
        rules.max = attrs.maxlength;
    }
    if (attrs.minlength >= 0 && RuleContainer.getRuleDefinition('min')) {
        rules.min = attrs.minlength;
    }
    if (attrs.type === 'number') {
        if (isSpecified(attrs.min) && RuleContainer.getRuleDefinition('min_value')) {
            rules.min_value = Number(attrs.min);
        }
        if (isSpecified(attrs.max) && RuleContainer.getRuleDefinition('max_value')) {
            rules.max_value = Number(attrs.max);
        }
    }
    return rules;
}
function resolveRules(vnode) {
    var _a;
    var htmlTags = ['input', 'select', 'textarea'];
    var attrs = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs;
    if (!includes(htmlTags, vnode.tag) || !attrs) {
        return {};
    }
    var rules = {};
    if ('required' in attrs && attrs.required !== false && RuleContainer.getRuleDefinition('required')) {
        rules.required = attrs.type === 'checkbox' ? [true] : true;
    }
    if (isTextInput(vnode)) {
        return normalizeRules(__assign(__assign({}, rules), resolveTextualRules(vnode)));
    }
    return normalizeRules(rules);
}
function normalizeChildren(context, slotProps) {
    if (context.$scopedSlots.default) {
        return context.$scopedSlots.default(slotProps) || [];
    }
    return context.$slots.default || [];
}

/**
 * Determines if a provider needs to run validation.
 */
function shouldValidate(ctx, value) {
    // when an immediate/initial validation is needed and wasn't done before.
    if (!ctx._ignoreImmediate && ctx.immediate) {
        return true;
    }
    // when the value changes for whatever reason.
    if (!isRefEqual(ctx.value, value) && ctx.normalizedEvents.length) {
        return true;
    }
    // when it needs validation due to props/cross-fields changes.
    if (ctx._needsValidation) {
        return true;
    }
    // when the initial value is undefined and the field wasn't rendered yet.
    if (!ctx.initialized && value === undefined) {
        return true;
    }
    return false;
}
function createValidationCtx(ctx) {
    return __assign(__assign({}, ctx.flags), { errors: ctx.errors, classes: ctx.classes, failedRules: ctx.failedRules, reset: function () { return ctx.reset(); }, validate: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return ctx.validate.apply(ctx, args);
        }, ariaInput: {
            'aria-invalid': ctx.flags.invalid ? 'true' : 'false',
            'aria-required': ctx.isRequired ? 'true' : 'false',
            'aria-errormessage': "vee_" + ctx.id
        }, ariaMsg: {
            id: "vee_" + ctx.id,
            'aria-live': ctx.errors.length ? 'assertive' : 'off'
        } });
}
function onRenderUpdate(vm, value) {
    if (!vm.initialized) {
        vm.initialValue = value;
    }
    var validateNow = shouldValidate(vm, value);
    vm._needsValidation = false;
    vm.value = value;
    vm._ignoreImmediate = true;
    if (!validateNow) {
        return;
    }
    var validate = function () {
        if (vm.immediate || vm.flags.validated) {
            return triggerThreadSafeValidation(vm);
        }
        vm.validateSilent();
    };
    if (vm.initialized) {
        validate();
        return;
    }
    vm.$once('hook:mounted', function () { return validate(); });
}
function computeModeSetting(ctx) {
    var compute = (isCallable(ctx.mode) ? ctx.mode : modes[ctx.mode]);
    return compute(ctx);
}
function triggerThreadSafeValidation(vm) {
    var pendingPromise = vm.validateSilent();
    // avoids race conditions between successive validations.
    vm._pendingValidation = pendingPromise;
    return pendingPromise.then(function (result) {
        if (pendingPromise === vm._pendingValidation) {
            vm.applyResult(result);
            vm._pendingValidation = undefined;
        }
        return result;
    });
}
// Creates the common handlers for a validatable context.
function createCommonHandlers(vm) {
    if (!vm.$veeOnInput) {
        vm.$veeOnInput = function (e) {
            vm.syncValue(e); // track and keep the value updated.
            vm.setFlags({ dirty: true, pristine: false });
        };
    }
    var onInput = vm.$veeOnInput;
    if (!vm.$veeOnBlur) {
        vm.$veeOnBlur = function () {
            vm.setFlags({ touched: true, untouched: false });
        };
    }
    // Blur event listener.
    var onBlur = vm.$veeOnBlur;
    var onValidate = vm.$veeHandler;
    var mode = computeModeSetting(vm);
    // Handle debounce changes.
    if (!onValidate || vm.$veeDebounce !== vm.debounce) {
        onValidate = debounce(function () {
            vm.$nextTick(function () {
                if (!vm._pendingReset) {
                    triggerThreadSafeValidation(vm);
                }
                vm._pendingReset = false;
            });
        }, mode.debounce || vm.debounce);
        // Cache the handler so we don't create it each time.
        vm.$veeHandler = onValidate;
        // cache the debounce value so we detect if it was changed.
        vm.$veeDebounce = vm.debounce;
    }
    return { onInput: onInput, onBlur: onBlur, onValidate: onValidate };
}
// Adds all plugin listeners to the vnode.
function addListeners(vm, node) {
    var value = findValue(node);
    // cache the input eventName.
    vm._inputEventName = vm._inputEventName || getInputEventName(node, findModel(node));
    onRenderUpdate(vm, value === null || value === void 0 ? void 0 : value.value);
    var _a = createCommonHandlers(vm), onInput = _a.onInput, onBlur = _a.onBlur, onValidate = _a.onValidate;
    addVNodeListener(node, vm._inputEventName, onInput);
    addVNodeListener(node, 'blur', onBlur);
    // add the validation listeners.
    vm.normalizedEvents.forEach(function (evt) {
        addVNodeListener(node, evt, onValidate);
    });
    vm.initialized = true;
}

var PROVIDER_COUNTER = 0;
function data() {
    var errors = [];
    var fieldName = '';
    var defaultValues = {
        errors: errors,
        value: undefined,
        initialized: false,
        initialValue: undefined,
        flags: createFlags(),
        failedRules: {},
        isActive: true,
        fieldName: fieldName,
        id: ''
    };
    return defaultValues;
}
var ValidationProvider = external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
    inject: {
        $_veeObserver: {
            from: '$_veeObserver',
            default: function () {
                if (!this.$vnode.context.$_veeObserver) {
                    this.$vnode.context.$_veeObserver = createObserver();
                }
                return this.$vnode.context.$_veeObserver;
            }
        }
    },
    props: {
        vid: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: null
        },
        mode: {
            type: [String, Function],
            default: function () {
                return getConfig().mode;
            }
        },
        rules: {
            type: [Object, String],
            default: null
        },
        immediate: {
            type: Boolean,
            default: false
        },
        bails: {
            type: Boolean,
            default: function () { return getConfig().bails; }
        },
        skipIfEmpty: {
            type: Boolean,
            default: function () { return getConfig().skipOptional; }
        },
        debounce: {
            type: Number,
            default: 0
        },
        tag: {
            type: String,
            default: 'span'
        },
        slim: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        customMessages: {
            type: Object,
            default: function () {
                return {};
            }
        }
    },
    watch: {
        rules: {
            deep: true,
            handler: function (val, oldVal) {
                this._needsValidation = !isEqual(val, oldVal);
            }
        }
    },
    data: data,
    computed: {
        fieldDeps: function () {
            var _this = this;
            return Object.keys(this.normalizedRules).reduce(function (acc, rule) {
                var deps = extractLocators(_this.normalizedRules[rule]).map(function (dep) { return dep.__locatorRef; });
                acc.push.apply(acc, deps);
                deps.forEach(function (depName) {
                    watchCrossFieldDep(_this, depName);
                });
                return acc;
            }, []);
        },
        normalizedEvents: function () {
            var _this = this;
            var on = computeModeSetting(this).on;
            return (on || []).map(function (e) {
                if (e === 'input') {
                    return _this._inputEventName;
                }
                return e;
            });
        },
        isRequired: function () {
            var rules = __assign(__assign({}, this._resolvedRules), this.normalizedRules);
            var isRequired = Object.keys(rules).some(RuleContainer.isRequireRule);
            this.flags.required = !!isRequired;
            return isRequired;
        },
        classes: function () {
            var names = getConfig().classes;
            return computeClassObj(names, this.flags);
        },
        normalizedRules: function () {
            return normalizeRules(this.rules);
        }
    },
    mounted: function () {
        var _this = this;
        var onLocaleChanged = function () {
            if (!_this.flags.validated) {
                return;
            }
            var regenerateMap = _this._regenerateMap;
            if (regenerateMap) {
                var errors_1 = [];
                var failedRules_1 = {};
                Object.keys(regenerateMap).forEach(function (rule) {
                    var msg = regenerateMap[rule]();
                    errors_1.push(msg);
                    failedRules_1[rule] = msg;
                });
                _this.applyResult({ errors: errors_1, failedRules: failedRules_1, regenerateMap: regenerateMap });
                return;
            }
            _this.validate();
        };
        EVENT_BUS.$on('change:locale', onLocaleChanged);
        this.$on('hook:beforeDestroy', function () {
            EVENT_BUS.$off('change:locale', onLocaleChanged);
        });
    },
    render: function (h) {
        var _this = this;
        this.registerField();
        var ctx = createValidationCtx(this);
        var children = normalizeChildren(this, ctx);
        var inputs = findInputNodes(children);
        if (!inputs.length) {
            // Silent exit if no input was found.
            return this.slim && children.length <= 1 ? children[0] : h(this.tag, children);
        }
        inputs.forEach(function (input, idx) {
            var _a, _b, _c, _d, _e, _f;
            // If the elements are not checkboxes and there are more input nodes
            if (!includes(['checkbox', 'radio'], (_b = (_a = input.data) === null || _a === void 0 ? void 0 : _a.attrs) === null || _b === void 0 ? void 0 : _b.type) && idx > 0) {
                return;
            }
            var resolved = getConfig().useConstraintAttrs ? resolveRules(input) : {};
            if (!isEqual(_this._resolvedRules, resolved)) {
                _this._needsValidation = true;
            }
            if (isHTMLNode(input)) {
                _this.fieldName = ((_d = (_c = input.data) === null || _c === void 0 ? void 0 : _c.attrs) === null || _d === void 0 ? void 0 : _d.name) || ((_f = (_e = input.data) === null || _e === void 0 ? void 0 : _e.attrs) === null || _f === void 0 ? void 0 : _f.id);
            }
            _this._resolvedRules = resolved;
            addListeners(_this, input);
        });
        return this.slim && children.length <= 1 ? children[0] : h(this.tag, children);
    },
    beforeDestroy: function () {
        // cleanup reference.
        this.$_veeObserver.unobserve(this.id);
    },
    activated: function () {
        this.isActive = true;
    },
    deactivated: function () {
        this.isActive = false;
    },
    methods: {
        setFlags: function (flags) {
            var _this = this;
            Object.keys(flags).forEach(function (flag) {
                _this.flags[flag] = flags[flag];
            });
        },
        syncValue: function (v) {
            var value = normalizeEventValue(v);
            this.value = value;
            this.flags.changed = this.initialValue !== value;
        },
        reset: function () {
            var _this = this;
            this.errors = [];
            this.initialValue = this.value;
            var flags = createFlags();
            flags.required = this.isRequired;
            this.setFlags(flags);
            this.failedRules = {};
            this.validateSilent();
            this._pendingValidation = undefined;
            this._pendingReset = true;
            setTimeout(function () {
                _this._pendingReset = false;
            }, this.debounce);
        },
        validate: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (args.length > 0) {
                        this.syncValue(args[0]);
                    }
                    return [2 /*return*/, triggerThreadSafeValidation(this)];
                });
            });
        },
        validateSilent: function () {
            return __awaiter(this, void 0, void 0, function () {
                var rules, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setFlags({ pending: true });
                            rules = __assign(__assign({}, this._resolvedRules), this.normalizedRules);
                            Object.defineProperty(rules, '_$$isNormalized', {
                                value: true,
                                writable: false,
                                enumerable: false,
                                configurable: false
                            });
                            return [4 /*yield*/, validate(this.value, rules, __assign(__assign({ name: this.name || this.fieldName }, createLookup(this)), { bails: this.bails, skipIfEmpty: this.skipIfEmpty, isInitial: !this.initialized, customMessages: this.customMessages }))];
                        case 1:
                            result = _a.sent();
                            this.setFlags({
                                pending: false,
                                valid: result.valid,
                                invalid: !result.valid
                            });
                            return [2 /*return*/, result];
                    }
                });
            });
        },
        setErrors: function (errors) {
            this.applyResult({ errors: errors, failedRules: {} });
        },
        applyResult: function (_a) {
            var errors = _a.errors, failedRules = _a.failedRules, regenerateMap = _a.regenerateMap;
            this.errors = errors;
            this._regenerateMap = regenerateMap;
            this.failedRules = __assign({}, (failedRules || {}));
            this.setFlags({
                valid: !errors.length,
                passed: !errors.length,
                invalid: !!errors.length,
                failed: !!errors.length,
                validated: true,
                changed: this.value !== this.initialValue
            });
        },
        registerField: function () {
            updateRenderingContextRefs(this);
        }
    }
});
function computeClassObj(names, flags) {
    var acc = {};
    var keys = Object.keys(flags);
    var length = keys.length;
    var _loop_1 = function (i) {
        var flag = keys[i];
        var className = (names && names[flag]) || flag;
        var value = flags[flag];
        if (isNullOrUndefined(value)) {
            return "continue";
        }
        if ((flag === 'valid' || flag === 'invalid') && !flags.validated) {
            return "continue";
        }
        if (typeof className === 'string') {
            acc[className] = value;
        }
        else if (Array.isArray(className)) {
            className.forEach(function (cls) {
                acc[cls] = value;
            });
        }
    };
    for (var i = 0; i < length; i++) {
        _loop_1(i);
    }
    return acc;
}
function createLookup(vm) {
    var providers = vm.$_veeObserver.refs;
    var reduced = {
        names: {},
        values: {}
    };
    return vm.fieldDeps.reduce(function (acc, depName) {
        if (!providers[depName]) {
            return acc;
        }
        acc.values[depName] = providers[depName].value;
        acc.names[depName] = providers[depName].name;
        return acc;
    }, reduced);
}
function extractId(vm) {
    if (vm.vid) {
        return vm.vid;
    }
    if (vm.name) {
        return vm.name;
    }
    if (vm.id) {
        return vm.id;
    }
    if (vm.fieldName) {
        return vm.fieldName;
    }
    PROVIDER_COUNTER++;
    return "_vee_" + PROVIDER_COUNTER;
}
function updateRenderingContextRefs(vm) {
    var providedId = extractId(vm);
    var id = vm.id;
    // Nothing has changed.
    if (!vm.isActive || (id === providedId && vm.$_veeObserver.refs[id])) {
        return;
    }
    // vid was changed.
    if (id !== providedId && vm.$_veeObserver.refs[id] === vm) {
        vm.$_veeObserver.unobserve(id);
    }
    vm.id = providedId;
    vm.$_veeObserver.observe(vm);
}
function createObserver() {
    return {
        refs: {},
        observe: function (vm) {
            this.refs[vm.id] = vm;
        },
        unobserve: function (id) {
            delete this.refs[id];
        }
    };
}
function watchCrossFieldDep(ctx, depName, withHooks) {
    if (withHooks === void 0) { withHooks = true; }
    var providers = ctx.$_veeObserver.refs;
    if (!ctx._veeWatchers) {
        ctx._veeWatchers = {};
    }
    if (!providers[depName] && withHooks) {
        return ctx.$once('hook:mounted', function () {
            watchCrossFieldDep(ctx, depName, false);
        });
    }
    if (!isCallable(ctx._veeWatchers[depName]) && providers[depName]) {
        ctx._veeWatchers[depName] = providers[depName].$watch('value', function () {
            if (ctx.flags.validated) {
                ctx._needsValidation = true;
                ctx.validate();
            }
        });
    }
}

var FLAGS_STRATEGIES = [
    ['pristine', 'every'],
    ['dirty', 'some'],
    ['touched', 'some'],
    ['untouched', 'every'],
    ['valid', 'every'],
    ['invalid', 'some'],
    ['pending', 'some'],
    ['validated', 'every'],
    ['changed', 'some'],
    ['passed', 'every'],
    ['failed', 'some']
];
var OBSERVER_COUNTER = 0;
function data$1() {
    var refs = {};
    var errors = {};
    var flags = createObserverFlags();
    var fields = {};
    // FIXME: Not sure of this one can be typed, circular type reference.
    var observers = [];
    return {
        id: '',
        refs: refs,
        observers: observers,
        errors: errors,
        flags: flags,
        fields: fields
    };
}
function provideSelf() {
    return {
        $_veeObserver: this
    };
}
var ValidationObserver = external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
    name: 'ValidationObserver',
    provide: provideSelf,
    inject: {
        $_veeObserver: {
            from: '$_veeObserver',
            default: function () {
                if (!this.$vnode.context.$_veeObserver) {
                    return null;
                }
                return this.$vnode.context.$_veeObserver;
            }
        }
    },
    props: {
        tag: {
            type: String,
            default: 'span'
        },
        vid: {
            type: String,
            default: function () {
                return "obs_" + OBSERVER_COUNTER++;
            }
        },
        slim: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: data$1,
    created: function () {
        var _this = this;
        this.id = this.vid;
        register(this);
        var onChange = debounce(function (_a) {
            var errors = _a.errors, flags = _a.flags, fields = _a.fields;
            _this.errors = errors;
            _this.flags = flags;
            _this.fields = fields;
        }, 16);
        this.$watch(computeObserverState, onChange);
    },
    activated: function () {
        register(this);
    },
    deactivated: function () {
        unregister(this);
    },
    beforeDestroy: function () {
        unregister(this);
    },
    render: function (h) {
        var children = normalizeChildren(this, prepareSlotProps(this));
        return this.slim && children.length <= 1 ? children[0] : h(this.tag, { on: this.$listeners }, children);
    },
    methods: {
        observe: function (subscriber, kind) {
            var _a;
            if (kind === void 0) { kind = 'provider'; }
            if (kind === 'observer') {
                this.observers.push(subscriber);
                return;
            }
            this.refs = __assign(__assign({}, this.refs), (_a = {}, _a[subscriber.id] = subscriber, _a));
        },
        unobserve: function (id, kind) {
            if (kind === void 0) { kind = 'provider'; }
            if (kind === 'provider') {
                var provider = this.refs[id];
                if (!provider) {
                    return;
                }
                this.$delete(this.refs, id);
                return;
            }
            var idx = findIndex(this.observers, function (o) { return o.id === id; });
            if (idx !== -1) {
                this.observers.splice(idx, 1);
            }
        },
        validate: function (_a) {
            var _b = (_a === void 0 ? {} : _a).silent, silent = _b === void 0 ? false : _b;
            return __awaiter(this, void 0, void 0, function () {
                var results;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, Promise.all(__spreadArrays(values(this.refs)
                                .filter(function (r) { return !r.disabled; })
                                .map(function (ref) { return ref[silent ? 'validateSilent' : 'validate']().then(function (r) { return r.valid; }); }), this.observers.filter(function (o) { return !o.disabled; }).map(function (obs) { return obs.validate({ silent: silent }); })))];
                        case 1:
                            results = _c.sent();
                            return [2 /*return*/, results.every(function (r) { return r; })];
                    }
                });
            });
        },
        handleSubmit: function (cb) {
            return __awaiter(this, void 0, void 0, function () {
                var isValid;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.validate()];
                        case 1:
                            isValid = _a.sent();
                            if (!isValid || !cb) {
                                return [2 /*return*/];
                            }
                            return [2 /*return*/, cb()];
                    }
                });
            });
        },
        reset: function () {
            return __spreadArrays(values(this.refs), this.observers).forEach(function (ref) { return ref.reset(); });
        },
        setErrors: function (errors) {
            var _this = this;
            Object.keys(errors).forEach(function (key) {
                var provider = _this.refs[key];
                if (!provider)
                    return;
                var errorArr = errors[key] || [];
                errorArr = typeof errorArr === 'string' ? [errorArr] : errorArr;
                provider.setErrors(errorArr);
            });
            this.observers.forEach(function (observer) {
                observer.setErrors(errors);
            });
        }
    }
});
function unregister(vm) {
    if (vm.$_veeObserver) {
        vm.$_veeObserver.unobserve(vm.id, 'observer');
    }
}
function register(vm) {
    if (vm.$_veeObserver) {
        vm.$_veeObserver.observe(vm, 'observer');
    }
}
function prepareSlotProps(vm) {
    return __assign(__assign({}, vm.flags), { errors: vm.errors, fields: vm.fields, validate: vm.validate, passes: vm.handleSubmit, handleSubmit: vm.handleSubmit, reset: vm.reset });
}
// Creates a modified version of validation flags
function createObserverFlags() {
    return __assign(__assign({}, createFlags()), { valid: true, invalid: false });
}
function computeObserverState() {
    var vms = __spreadArrays(values(this.refs), this.observers);
    var errors = {};
    var flags = createObserverFlags();
    var fields = {};
    var length = vms.length;
    for (var i = 0; i < length; i++) {
        var vm = vms[i];
        // validation provider
        if (Array.isArray(vm.errors)) {
            errors[vm.id] = vm.errors;
            fields[vm.id] = __assign({ id: vm.id, name: vm.name, failedRules: vm.failedRules }, vm.flags);
            continue;
        }
        // Nested observer, merge errors and fields
        errors = __assign(__assign({}, errors), vm.errors);
        fields = __assign(__assign({}, fields), vm.fields);
    }
    FLAGS_STRATEGIES.forEach(function (_a) {
        var flag = _a[0], method = _a[1];
        flags[flag] = vms[method](function (vm) { return vm.flags[flag]; });
    });
    return { errors: errors, flags: flags, fields: fields };
}

function withValidation(component, mapProps) {
    var _a;
    if (mapProps === void 0) { mapProps = identity; }
    var options = 'options' in component ? component.options : component;
    var providerOpts = ValidationProvider.options;
    var hoc = {
        name: (options.name || 'AnonymousHoc') + "WithValidation",
        props: __assign({}, providerOpts.props),
        data: providerOpts.data,
        computed: __assign({}, providerOpts.computed),
        methods: __assign({}, providerOpts.methods),
        beforeDestroy: providerOpts.beforeDestroy,
        inject: providerOpts.inject
    };
    var eventName = ((_a = options === null || options === void 0 ? void 0 : options.model) === null || _a === void 0 ? void 0 : _a.event) || 'input';
    hoc.render = function (h) {
        var _a;
        this.registerField();
        var vctx = createValidationCtx(this);
        var listeners = __assign({}, this.$listeners);
        var model = findModel(this.$vnode);
        this._inputEventName = this._inputEventName || getInputEventName(this.$vnode, model);
        var value = findValue(this.$vnode);
        onRenderUpdate(this, value === null || value === void 0 ? void 0 : value.value);
        var _b = createCommonHandlers(this), onInput = _b.onInput, onBlur = _b.onBlur, onValidate = _b.onValidate;
        mergeVNodeListeners(listeners, eventName, onInput);
        mergeVNodeListeners(listeners, 'blur', onBlur);
        this.normalizedEvents.forEach(function (evt) {
            mergeVNodeListeners(listeners, evt, onValidate);
        });
        // Props are any attrs not associated with ValidationProvider Plus the model prop.
        // WARNING: Accidental prop overwrite will probably happen.
        var prop = (findModelConfig(this.$vnode) || { prop: 'value' }).prop;
        var props = __assign(__assign(__assign({}, this.$attrs), (_a = {}, _a[prop] = model === null || model === void 0 ? void 0 : model.value, _a)), mapProps(vctx));
        return h(options, {
            attrs: this.$attrs,
            props: props,
            on: listeners,
            scopedSlots: this.$scopedSlots
        }, normalizeSlots(this.$slots, this.$vnode.context));
    };
    return hoc;
}

var version = '3.3.9';



;// CONCATENATED MODULE: ../../node_modules/.pnpm/vee-validate@3.3.9_vue@2.7.14/node_modules/vee-validate/dist/rules.js
/**
  * vee-validate v3.3.9
  * (c) 2020 Abdelrahman Awad
  * @license MIT
  */
/**
 * Some Alpha Regex helpers.
 * https://github.com/chriso/validator.js/blob/master/src/lib/alpha.js
 */
/* eslint-disable no-misleading-character-class */
var alpha = {
    en: /^[A-Z]*$/i,
    cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
    da: /^[A-ZÆØÅ]*$/i,
    de: /^[A-ZÄÖÜß]*$/i,
    es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
    fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
    fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
    it: /^[A-Z\xC0-\xFF]*$/i,
    lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
    nl: /^[A-ZÉËÏÓÖÜ]*$/i,
    hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
    pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
    pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
    ro: /^[A-ZĂÂÎŞŢ]*$/i,
    ru: /^[А-ЯЁ]*$/i,
    sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
    sr: /^[A-ZČĆŽŠĐ]*$/i,
    sv: /^[A-ZÅÄÖ]*$/i,
    tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
    uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
    az: /^[A-ZÇƏĞİıÖŞÜ]*$/i,
    el: /^[Α-ώ]*$/i
};
var alphaSpaces = {
    en: /^[A-Z\s]*$/i,
    cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
    da: /^[A-ZÆØÅ\s]*$/i,
    de: /^[A-ZÄÖÜß\s]*$/i,
    es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
    fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
    fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
    it: /^[A-Z\xC0-\xFF\s]*$/i,
    lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
    nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
    hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
    pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
    pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
    ro: /^[A-ZĂÂÎŞŢ\s]*$/i,
    ru: /^[А-ЯЁ\s]*$/i,
    sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
    sr: /^[A-ZČĆŽŠĐ\s]*$/i,
    sv: /^[A-ZÅÄÖ\s]*$/i,
    tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
    uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/,
    az: /^[A-ZÇƏĞİıÖŞÜ\s]*$/i,
    el: /^[Α-ώ\s]*$/i
};
var alphanumeric = {
    en: /^[0-9A-Z]*$/i,
    cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
    da: /^[0-9A-ZÆØÅ]$/i,
    de: /^[0-9A-ZÄÖÜß]*$/i,
    es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
    fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
    fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
    it: /^[0-9A-Z\xC0-\xFF]*$/i,
    lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
    hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
    nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
    pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
    pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
    ro: /^[0-9A-ZĂÂÎŞŢ]*$/i,
    ru: /^[0-9А-ЯЁ]*$/i,
    sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
    sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
    sv: /^[0-9A-ZÅÄÖ]*$/i,
    tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
    uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
    az: /^[0-9A-ZÇƏĞİıÖŞÜ]*$/i,
    el: /^[0-9Α-ώ]*$/i
};
var alphaDash = {
    en: /^[0-9A-Z_-]*$/i,
    cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
    da: /^[0-9A-ZÆØÅ_-]*$/i,
    de: /^[0-9A-ZÄÖÜß_-]*$/i,
    es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
    fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
    fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
    it: /^[0-9A-Z\xC0-\xFF_-]*$/i,
    lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
    nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
    hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
    pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
    pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
    ro: /^[0-9A-ZĂÂÎŞŢ_-]*$/i,
    ru: /^[0-9А-ЯЁ_-]*$/i,
    sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
    sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
    sv: /^[0-9A-ZÅÄÖ_-]*$/i,
    tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
    uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/,
    az: /^[0-9A-ZÇƏĞİıÖŞÜ_-]*$/i,
    el: /^[0-9Α-ώ_-]*$/i
};

var rules_validate = function (value, _a) {
    var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
    if (Array.isArray(value)) {
        return value.every(function (val) { return rules_validate(val, { locale: locale }); });
    }
    // Match at least one locale.
    if (!locale) {
        return Object.keys(alpha).some(function (loc) { return alpha[loc].test(value); });
    }
    return (alpha[locale] || alpha.en).test(value);
};
var params = [
    {
        name: 'locale'
    }
];
var alpha$1 = {
    validate: rules_validate,
    params: params
};

var validate$1 = function (value, _a) {
    var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$1(val, { locale: locale }); });
    }
    // Match at least one locale.
    if (!locale) {
        return Object.keys(alphaDash).some(function (loc) { return alphaDash[loc].test(value); });
    }
    return (alphaDash[locale] || alphaDash.en).test(value);
};
var params$1 = [
    {
        name: 'locale'
    }
];
var alpha_dash = {
    validate: validate$1,
    params: params$1
};

var validate$2 = function (value, _a) {
    var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$2(val, { locale: locale }); });
    }
    // Match at least one locale.
    if (!locale) {
        return Object.keys(alphanumeric).some(function (loc) { return alphanumeric[loc].test(value); });
    }
    return (alphanumeric[locale] || alphanumeric.en).test(value);
};
var params$2 = [
    {
        name: 'locale'
    }
];
var alpha_num = {
    validate: validate$2,
    params: params$2
};

var validate$3 = function (value, _a) {
    var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$3(val, { locale: locale }); });
    }
    // Match at least one locale.
    if (!locale) {
        return Object.keys(alphaSpaces).some(function (loc) { return alphaSpaces[loc].test(value); });
    }
    return (alphaSpaces[locale] || alphaSpaces.en).test(value);
};
var params$3 = [
    {
        name: 'locale'
    }
];
var alpha_spaces = {
    validate: validate$3,
    params: params$3
};

var validate$4 = function (value, _a) {
    var _b = _a === void 0 ? {} : _a, min = _b.min, max = _b.max;
    if (Array.isArray(value)) {
        return value.every(function (val) { return !!validate$4(val, { min: min, max: max }); });
    }
    return Number(min) <= value && Number(max) >= value;
};
var params$4 = [
    {
        name: 'min'
    },
    {
        name: 'max'
    }
];
var between = {
    validate: validate$4,
    params: params$4
};

var validate$5 = function (value, _a) {
    var target = _a.target;
    return String(value) === String(target);
};
var params$5 = [
    {
        name: 'target',
        isTarget: true
    }
];
var confirmed = {
    validate: validate$5,
    params: params$5
};

var validate$6 = function (value, _a) {
    var length = _a.length;
    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$6(val, { length: length }); });
    }
    var strVal = String(value);
    return /^[0-9]*$/.test(strVal) && strVal.length === length;
};
var params$6 = [
    {
        name: 'length',
        cast: function (value) {
            return Number(value);
        }
    }
];
var digits = {
    validate: validate$6,
    params: params$6
};

var validateImage = function (file, width, height) {
    var URL = window.URL || window.webkitURL;
    return new Promise(function (resolve) {
        var image = new Image();
        image.onerror = function () { return resolve(false); };
        image.onload = function () { return resolve(image.width === width && image.height === height); };
        image.src = URL.createObjectURL(file);
    });
};
var validate$7 = function (files, _a) {
    var width = _a.width, height = _a.height;
    var list = [];
    files = Array.isArray(files) ? files : [files];
    for (var i = 0; i < files.length; i++) {
        // if file is not an image, reject.
        if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
            return Promise.resolve(false);
        }
        list.push(files[i]);
    }
    return Promise.all(list.map(function (file) { return validateImage(file, width, height); })).then(function (values) {
        return values.every(function (v) { return v; });
    });
};
var params$7 = [
    {
        name: 'width',
        cast: function (value) {
            return Number(value);
        }
    },
    {
        name: 'height',
        cast: function (value) {
            return Number(value);
        }
    }
];
var dimensions = {
    validate: validate$7,
    params: params$7
};

var validate$8 = function (value, _a) {
    var multiple = (_a === void 0 ? {} : _a).multiple;
    // eslint-disable-next-line
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (multiple && !Array.isArray(value)) {
        value = String(value)
            .split(',')
            .map(function (emailStr) { return emailStr.trim(); });
    }
    if (Array.isArray(value)) {
        return value.every(function (val) { return re.test(String(val)); });
    }
    return re.test(String(value));
};
var params$8 = [
    {
        name: 'multiple',
        default: false
    }
];
var email = {
    validate: validate$8,
    params: params$8
};

function rules_isNullOrUndefined(value) {
    return value === null || value === undefined;
}
function rules_isEmptyArray(arr) {
    return Array.isArray(arr) && arr.length === 0;
}
function rules_isCallable(fn) {
    return typeof fn === 'function';
}

function rules_includes(collection, item) {
    return collection.indexOf(item) !== -1;
}
/**
 * Converts an array-like object to array, provides a simple polyfill for Array.from
 */
function rules_toArray(arrayLike) {
    if (rules_isCallable(Array.from)) {
        return Array.from(arrayLike);
    }
    /* istanbul ignore next */
    return rules_copyArray(arrayLike);
}
/* istanbul ignore next */
function rules_copyArray(arrayLike) {
    var array = [];
    var length = arrayLike.length;
    for (var i = 0; i < length; i++) {
        array.push(arrayLike[i]);
    }
    return array;
}

var validate$9 = function (value, options) {
    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$9(val, options); });
    }
    return rules_toArray(options).some(function (item) {
        // eslint-disable-next-line
        return item == value;
    });
};
var oneOf = {
    validate: validate$9
};

var validate$a = function (value, args) {
    return !validate$9(value, args);
};
var excluded = {
    validate: validate$a
};

var validate$b = function (files, extensions) {
    var regex = new RegExp(".(" + extensions.join('|') + ")$", 'i');
    if (Array.isArray(files)) {
        return files.every(function (file) { return regex.test(file.name); });
    }
    return regex.test(files.name);
};
var ext = {
    validate: validate$b
};

var validate$c = function (files) {
    var regex = /\.(jpg|svg|jpeg|png|bmp|gif|webp)$/i;
    if (Array.isArray(files)) {
        return files.every(function (file) { return regex.test(file.name); });
    }
    return regex.test(files.name);
};
var rules_image = {
    validate: validate$c
};

var validate$d = function (value) {
    if (Array.isArray(value)) {
        return value.every(function (val) { return /^-?[0-9]+$/.test(String(val)); });
    }
    return /^-?[0-9]+$/.test(String(value));
};
var integer = {
    validate: validate$d
};

var validate$e = function (value, _a) {
    var other = _a.other;
    return value === other;
};
var params$9 = [
    {
        name: 'other'
    }
];
var rules_is = {
    validate: validate$e,
    params: params$9
};

var validate$f = function (value, _a) {
    var other = _a.other;
    return value !== other;
};
var params$a = [
    {
        name: 'other'
    }
];
var is_not = {
    validate: validate$f,
    params: params$a
};

var validate$g = function (value, _a) {
    var length = _a.length;
    if (rules_isNullOrUndefined(value)) {
        return false;
    }
    if (typeof value === 'number') {
        value = String(value);
    }
    if (!value.length) {
        value = rules_toArray(value);
    }
    return value.length === length;
};
var params$b = [
    {
        name: 'length',
        cast: function (value) { return Number(value); }
    }
];
var rules_length = {
    validate: validate$g,
    params: params$b
};

var validate$h = function (value, _a) {
    var length = _a.length;
    if (rules_isNullOrUndefined(value)) {
        return length >= 0;
    }
    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$h(val, { length: length }); });
    }
    return String(value).length <= length;
};
var params$c = [
    {
        name: 'length',
        cast: function (value) {
            return Number(value);
        }
    }
];
var max = {
    validate: validate$h,
    params: params$c
};

var validate$i = function (value, _a) {
    var max = _a.max;
    if (rules_isNullOrUndefined(value) || value === '') {
        return false;
    }
    if (Array.isArray(value)) {
        return value.length > 0 && value.every(function (val) { return validate$i(val, { max: max }); });
    }
    return Number(value) <= max;
};
var params$d = [
    {
        name: 'max',
        cast: function (value) {
            return Number(value);
        }
    }
];
var max_value = {
    validate: validate$i,
    params: params$d
};

var validate$j = function (files, mimes) {
    var regex = new RegExp(mimes.join('|').replace('*', '.+') + "$", 'i');
    if (Array.isArray(files)) {
        return files.every(function (file) { return regex.test(file.type); });
    }
    return regex.test(files.type);
};
var mimes = {
    validate: validate$j
};

var validate$k = function (value, _a) {
    var length = _a.length;
    if (rules_isNullOrUndefined(value)) {
        return false;
    }
    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$k(val, { length: length }); });
    }
    return String(value).length >= length;
};
var params$e = [
    {
        name: 'length',
        cast: function (value) {
            return Number(value);
        }
    }
];
var min = {
    validate: validate$k,
    params: params$e
};

var validate$l = function (value, _a) {
    var min = _a.min;
    if (rules_isNullOrUndefined(value) || value === '') {
        return false;
    }
    if (Array.isArray(value)) {
        return value.length > 0 && value.every(function (val) { return validate$l(val, { min: min }); });
    }
    return Number(value) >= min;
};
var params$f = [
    {
        name: 'min',
        cast: function (value) {
            return Number(value);
        }
    }
];
var min_value = {
    validate: validate$l,
    params: params$f
};

var ar = /^[٠١٢٣٤٥٦٧٨٩]+$/;
var en = /^[0-9]+$/;
var validate$m = function (value) {
    var testValue = function (val) {
        var strValue = String(val);
        return en.test(strValue) || ar.test(strValue);
    };
    if (Array.isArray(value)) {
        return value.every(testValue);
    }
    return testValue(value);
};
var numeric = {
    validate: validate$m
};

var validate$n = function (value, _a) {
    var regex = _a.regex;
    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$n(val, { regex: regex }); });
    }
    return regex.test(String(value));
};
var params$g = [
    {
        name: 'regex',
        cast: function (value) {
            if (typeof value === 'string') {
                return new RegExp(value);
            }
            return value;
        }
    }
];
var regex = {
    validate: validate$n,
    params: params$g
};

var validate$o = function (value, _a) {
    var allowFalse = (_a === void 0 ? { allowFalse: true } : _a).allowFalse;
    var result = {
        valid: false,
        required: true
    };
    if (rules_isNullOrUndefined(value) || rules_isEmptyArray(value)) {
        return result;
    }
    // incase a field considers `false` as an empty value like checkboxes.
    if (value === false && !allowFalse) {
        return result;
    }
    result.valid = !!String(value).trim().length;
    return result;
};
var computesRequired = true;
var params$h = [
    {
        name: 'allowFalse',
        default: true
    }
];
var required = {
    validate: validate$o,
    params: params$h,
    computesRequired: computesRequired
};

var testEmpty = function (value) {
    return rules_isEmptyArray(value) || rules_includes([false, null, undefined], value) || !String(value).trim().length;
};
var validate$p = function (value, _a) {
    var target = _a.target, values = _a.values;
    var required;
    if (values && values.length) {
        if (!Array.isArray(values) && typeof values === 'string') {
            values = [values];
        }
        // eslint-disable-next-line
        required = values.some(function (val) { return val == String(target).trim(); });
    }
    else {
        required = !testEmpty(target);
    }
    if (!required) {
        return {
            valid: true,
            required: required
        };
    }
    return {
        valid: !testEmpty(value),
        required: required
    };
};
var params$i = [
    {
        name: 'target',
        isTarget: true
    },
    {
        name: 'values'
    }
];
var computesRequired$1 = true;
var required_if = {
    validate: validate$p,
    params: params$i,
    computesRequired: computesRequired$1
};

var validate$q = function (files, _a) {
    var size = _a.size;
    if (isNaN(size)) {
        return false;
    }
    var nSize = size * 1024;
    if (!Array.isArray(files)) {
        return files.size <= nSize;
    }
    for (var i = 0; i < files.length; i++) {
        if (files[i].size > nSize) {
            return false;
        }
    }
    return true;
};
var params$j = [
    {
        name: 'size',
        cast: function (value) {
            return Number(value);
        }
    }
];
var rules_size = {
    validate: validate$q,
    params: params$j
};



;// CONCATENATED MODULE: ../../node_modules/.pnpm/vee-validate@3.3.9_vue@2.7.14/node_modules/vee-validate/dist/locale/en.json
var en_namespaceObject = JSON.parse('{"s":{"Do":"The {_field_} field must be a valid email","C1":"The {_field_} field is required","dp":"The {_field_} field size must be less than {size}KB"}}');
;// CONCATENATED MODULE: ./src/vee-validate.js




function generateMessage(message) {
  return () => {
    try {
      const t = window.i18nInstance.t.bind(window.i18nInstance);
      return t(message);
    } catch (e) {
      return message;
    }
  };
}
function setup(Vue) {
  extend('required', {
    ...required,
    message: en_namespaceObject.s.C1
  });
  extend('email', {
    ...email,
    message: en_namespaceObject.s.Do
  });
  extend('size', {
    ...rules_size,
    message: en_namespaceObject.s.dp
  });
  extend('denySvg', {
    validate: value => {
      return !value || value.type !== 'image/svg+xml';
    },
    message: generateMessage('Image cannot be an svg')
  });
  extend('linkedInUrl', {
    validate: value => {
      const staticLinkedin = 'https://www.linkedin.com/in/';
      const r = /^(http(s)?:\/\/)?(www\.)?linkedin\.com\/(pub|in|profile)/gi;
      const userLink = staticLinkedin + value;
      return r.test(userLink);
    },
    message: generateMessage('This should be a valid linkedin url')
  });
  extend('twitterUrl', {
    validate: value => {
      const staticTwitter = 'https://www.twitter.com/';
      const r = /^(http(s)?:\/\/)?(www\.)?twitter\.com\//gi;
      const userLink = staticTwitter + value;
      return r.test(userLink);
    },
    message: 'This should be a valid twitter url'
  });
  extend('validateLinkedInUrl', {
    validate: value => {
      if (isUrl(value)) {
        const r = /^(http(s)?:\/\/)?(www\.)?linkedin\.com\/(pub|in|profile)/gi;
        return r.test(value);
      }
      return true;
    },
    message: generateMessage('This should be a valid linkedin url')
  });
  extend('validateTwitterUrl', {
    validate: value => {
      if (isUrl(value)) {
        const r = /^(http(s)?:\/\/)?(www\.)?twitter\.com\//gi;
        return r.test(value);
      }
      return true;
    },
    message: generateMessage('This should be a valid twitter url')
  });
  extend('url', {
    validate: isUrl,
    message: generateMessage('This should be a valid url')
  });
  Vue.component('ValidationProvider', ValidationProvider);
  Vue.component('ValidationObserver', ValidationObserver);
}
// EXTERNAL MODULE: ../../node_modules/.pnpm/vue-dompurify-html@2.3.0_vue@2.7.14/node_modules/vue-dompurify-html/dist/index.js
var dist = __webpack_require__(5320);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/vue-i18n@8.26.8_vue@2.7.14/node_modules/vue-i18n/dist/vue-i18n.esm.js
/*!
 * vue-i18n v8.26.8 
 * (c) 2021 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * constants
 */

var numberFormatKeys = [
  'compactDisplay',
  'currency',
  'currencyDisplay',
  'currencySign',
  'localeMatcher',
  'notation',
  'numberingSystem',
  'signDisplay',
  'style',
  'unit',
  'unitDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits'
];

/**
 * utilities
 */

function vue_i18n_esm_warn (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function error (msg, err) {
  if (typeof console !== 'undefined') {
    console.error('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.error(err.stack);
    }
  }
}

var isArray = Array.isArray;

function vue_i18n_esm_isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isBoolean (val) {
  return typeof val === 'boolean'
}

function isString (val) {
  return typeof val === 'string'
}

var vue_i18n_esm_toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject (obj) {
  return vue_i18n_esm_toString.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function isFunction (val) {
  return typeof val === 'function'
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (vue_i18n_esm_isObject(args[0]) || isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (vue_i18n_esm_isObject(args[1]) || isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function remove (arr, item) {
  if (arr.delete(item)) {
    return arr
  }
}

function arrayFrom (arr) {
  var ret = [];
  arr.forEach(function (a) { return ret.push(a); });
  return ret
}

function vue_i18n_esm_includes (arr, item) {
  return !!~arr.indexOf(item)
}

var vue_i18n_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return vue_i18n_esm_hasOwnProperty.call(obj, key)
}

function vue_i18n_esm_merge (target) {
  var arguments$1 = arguments;

  var output = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments$1[i];
    if (source !== undefined && source !== null) {
      var key = (void 0);
      for (key in source) {
        if (hasOwn(source, key)) {
          if (vue_i18n_esm_isObject(source[key])) {
            output[key] = vue_i18n_esm_merge(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output
}

function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = vue_i18n_esm_isObject(a);
  var isObjectB = vue_i18n_esm_isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = isArray(a);
      var isArrayB = isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Sanitizes html special characters from input strings. For mitigating risk of XSS attacks.
 * @param rawText The raw input from the user that should be escaped.
 */
function escapeHtml(rawText) {
  return rawText
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;')
}

/**
 * Escapes html tags and special symbols from all provided params which were returned from parseArgs().params.
 * This method performs an in-place operation on the params object.
 *
 * @param {any} params Parameters as provided from `parseArgs().params`.
 *                     May be either an array of strings or a string->any map.
 *
 * @returns The manipulated `params` object.
 */
function escapeParams(params) {
  if(params != null) {
    Object.keys(params).forEach(function (key) {
      if(typeof(params[key]) == 'string') {
        params[key] = escapeHtml(params[key]);
      }
    });
  }
  return params
}

/*  */

function vue_i18n_esm_extend (Vue) {
  if (!Vue.prototype.hasOwnProperty('$i18n')) {
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$i18n', {
      get: function get () { return this._i18n }
    });
  }

  Vue.prototype.$t = function (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

    var i18n = this.$i18n;
    return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this ].concat( values ))
  };

  Vue.prototype.$tc = function (key, choice) {
    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

    var i18n = this.$i18n;
    return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this, choice ].concat( values ))
  };

  Vue.prototype.$te = function (key, locale) {
    var i18n = this.$i18n;
    return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
  };

  Vue.prototype.$d = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).d.apply(ref, [ value ].concat( args ))
  };

  Vue.prototype.$n = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).n.apply(ref, [ value ].concat( args ))
  };
}

/*  */

/**
 * Mixin
 * 
 * If `bridge` mode, empty mixin is returned,
 * else regulary mixin implementation is returned.
 */
function defineMixin (bridge) {
  if ( bridge === void 0 ) bridge = false;

  function mounted () {
    if (this !== this.$root && this.$options.__INTLIFY_META__ && this.$el) {
      this.$el.setAttribute('data-intlify', this.$options.__INTLIFY_META__);
    }
  }

  return bridge
    ? { mounted: mounted } // delegate `vue-i18n-bridge` mixin implementation
    : { // regulary 
    beforeCreate: function beforeCreate () {
      var options = this.$options;
      options.i18n = options.i18n || ((options.__i18nBridge || options.__i18n) ? {} : null);

      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          // init locale messages via custom blocks
          if ((options.__i18nBridge || options.__i18n)) {
            try {
              var localeMessages = options.i18n && options.i18n.messages ? options.i18n.messages : {};
              var _i18n = options.__i18nBridge || options.__i18n;
              _i18n.forEach(function (resource) {
                localeMessages = vue_i18n_esm_merge(localeMessages, JSON.parse(resource));
              });
              Object.keys(localeMessages).forEach(function (locale) {
                options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
              });
            } catch (e) {
              if (false) {}
            }
          }
          this._i18n = options.i18n;
          this._i18nWatcher = this._i18n.watchI18nData();
        } else if (isPlainObject(options.i18n)) {
          var rootI18n = this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n
            ? this.$root.$i18n
            : null;
          // component local i18n
          if (rootI18n) {
            options.i18n.root = this.$root;
            options.i18n.formatter = rootI18n.formatter;
            options.i18n.fallbackLocale = rootI18n.fallbackLocale;
            options.i18n.formatFallbackMessages = rootI18n.formatFallbackMessages;
            options.i18n.silentTranslationWarn = rootI18n.silentTranslationWarn;
            options.i18n.silentFallbackWarn = rootI18n.silentFallbackWarn;
            options.i18n.pluralizationRules = rootI18n.pluralizationRules;
            options.i18n.preserveDirectiveContent = rootI18n.preserveDirectiveContent;
          }

          // init locale messages via custom blocks
          if ((options.__i18nBridge || options.__i18n)) {
            try {
              var localeMessages$1 = options.i18n && options.i18n.messages ? options.i18n.messages : {};
              var _i18n$1 = options.__i18nBridge || options.__i18n;
              _i18n$1.forEach(function (resource) {
                localeMessages$1 = vue_i18n_esm_merge(localeMessages$1, JSON.parse(resource));
              });
              options.i18n.messages = localeMessages$1;
            } catch (e) {
              if (false) {}
            }
          }

          var ref = options.i18n;
          var sharedMessages = ref.sharedMessages;
          if (sharedMessages && isPlainObject(sharedMessages)) {
            options.i18n.messages = vue_i18n_esm_merge(options.i18n.messages, sharedMessages);
          }

          this._i18n = new VueI18n(options.i18n);
          this._i18nWatcher = this._i18n.watchI18nData();

          if (options.i18n.sync === undefined || !!options.i18n.sync) {
            this._localeWatcher = this.$i18n.watchLocale();
          }

          if (rootI18n) {
            rootI18n.onComponentInstanceCreated(this._i18n);
          }
        } else {
          if (false) {}
        }
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        // root i18n
        this._i18n = this.$root.$i18n;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        // parent i18n
        this._i18n = options.parent.$i18n;
      }
    },

    beforeMount: function beforeMount () {
      var options = this.$options;
      options.i18n = options.i18n || ((options.__i18nBridge || options.__i18n) ? {} : null);

      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          // init locale messages via custom blocks
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else if (isPlainObject(options.i18n)) {
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else {
          if (false) {}
        }
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      }
    },

    mounted: mounted,

    beforeDestroy: function beforeDestroy () {
      if (!this._i18n) { return }

      var self = this;
      this.$nextTick(function () {
        if (self._subscribing) {
          self._i18n.unsubscribeDataChanging(self);
          delete self._subscribing;
        }

        if (self._i18nWatcher) {
          self._i18nWatcher();
          self._i18n.destroyVM();
          delete self._i18nWatcher;
        }

        if (self._localeWatcher) {
          self._localeWatcher();
          delete self._localeWatcher;
        }
      });
    }
  }
}

/*  */

var interpolationComponent = {
  name: 'i18n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: 'span'
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render (h, ref) {
    var data = ref.data;
    var parent = ref.parent;
    var props = ref.props;
    var slots = ref.slots;

    var $i18n = parent.$i18n;
    if (!$i18n) {
      if (false) {}
      return
    }

    var path = props.path;
    var locale = props.locale;
    var places = props.places;
    var params = slots();
    var children = $i18n.i(
      path,
      locale,
      onlyHasDefaultPlace(params) || places
        ? useLegacyPlaces(params.default, places)
        : params
    );

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag ? h(tag, data, children) : children
  }
};

function onlyHasDefaultPlace (params) {
  var prop;
  for (prop in params) {
    if (prop !== 'default') { return false }
  }
  return Boolean(prop)
}

function useLegacyPlaces (children, places) {
  var params = places ? createParamsFromPlaces(places) : {};

  if (!children) { return params }

  // Filter empty text nodes
  children = children.filter(function (child) {
    return child.tag || child.text.trim() !== ''
  });

  var everyPlace = children.every(vnodeHasPlaceAttribute);
  if (false) {}

  return children.reduce(
    everyPlace ? assignChildPlace : assignChildIndex,
    params
  )
}

function createParamsFromPlaces (places) {
  if (false) {}

  return Array.isArray(places)
    ? places.reduce(assignChildIndex, {})
    : Object.assign({}, places)
}

function assignChildPlace (params, child) {
  if (child.data && child.data.attrs && child.data.attrs.place) {
    params[child.data.attrs.place] = child;
  }
  return params
}

function assignChildIndex (params, child, index) {
  params[index] = child;
  return params
}

function vnodeHasPlaceAttribute (vnode) {
  return Boolean(vnode.data && vnode.data.attrs && vnode.data.attrs.place)
}

/*  */

var numberComponent = {
  name: 'i18n-n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: 'span'
    },
    value: {
      type: Number,
      required: true
    },
    format: {
      type: [String, Object]
    },
    locale: {
      type: String
    }
  },
  render: function render (h, ref) {
    var props = ref.props;
    var parent = ref.parent;
    var data = ref.data;

    var i18n = parent.$i18n;

    if (!i18n) {
      if (false) {}
      return null
    }

    var key = null;
    var options = null;

    if (isString(props.format)) {
      key = props.format;
    } else if (vue_i18n_esm_isObject(props.format)) {
      if (props.format.key) {
        key = props.format.key;
      }

      // Filter out number format options only
      options = Object.keys(props.format).reduce(function (acc, prop) {
        var obj;

        if (vue_i18n_esm_includes(numberFormatKeys, prop)) {
          return Object.assign({}, acc, ( obj = {}, obj[prop] = props.format[prop], obj ))
        }
        return acc
      }, null);
    }

    var locale = props.locale || i18n.locale;
    var parts = i18n._ntp(props.value, locale, key, options);

    var values = parts.map(function (part, index) {
      var obj;

      var slot = data.scopedSlots && data.scopedSlots[part.type];
      return slot ? slot(( obj = {}, obj[part.type] = part.value, obj.index = index, obj.parts = parts, obj )) : part.value
    });

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag
      ? h(tag, {
        attrs: data.attrs,
        'class': data['class'],
        staticClass: data.staticClass
      }, values)
      : values
  }
};

/*  */

function bind (el, binding, vnode) {
  if (!assert(el, vnode)) { return }

  t(el, binding, vnode);
}

function update (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  var i18n = vnode.context.$i18n;
  if (localeEqual(el, vnode) &&
    (looseEqual(binding.value, binding.oldValue) &&
     looseEqual(el._localeMessage, i18n.getLocaleMessage(i18n.locale)))) { return }

  t(el, binding, vnode);
}

function unbind (el, binding, vnode, oldVNode) {
  var vm = vnode.context;
  if (!vm) {
    vue_i18n_esm_warn('Vue instance does not exists in VNode context');
    return
  }

  var i18n = vnode.context.$i18n || {};
  if (!binding.modifiers.preserve && !i18n.preserveDirectiveContent) {
    el.textContent = '';
  }
  el._vt = undefined;
  delete el['_vt'];
  el._locale = undefined;
  delete el['_locale'];
  el._localeMessage = undefined;
  delete el['_localeMessage'];
}

function assert (el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    vue_i18n_esm_warn('Vue instance does not exists in VNode context');
    return false
  }

  if (!vm.$i18n) {
    vue_i18n_esm_warn('VueI18n instance does not exists in Vue instance');
    return false
  }

  return true
}

function localeEqual (el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale
}

function t (el, binding, vnode) {
  var ref$1, ref$2;

  var value = binding.value;

  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  var choice = ref.choice;
  if (!path && !locale && !args) {
    vue_i18n_esm_warn('value type not supported');
    return
  }

  if (!path) {
    vue_i18n_esm_warn('`path` is required in v-t directive');
    return
  }

  var vm = vnode.context;
  if (choice != null) {
    el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
  }
  el._locale = vm.$i18n.locale;
  el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
}

function parseValue (value) {
  var path;
  var locale;
  var args;
  var choice;

  if (isString(value)) {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }

  return { path: path, locale: locale, args: args, choice: choice }
}

function makeParams (locale, args) {
  var params = [];

  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }

  return params
}

var Vue;

function install (_Vue, options) {
  if ( options === void 0 ) options = { bridge: false };

  /* istanbul ignore if */
  if (false) {}
  install.installed = true;

  Vue = _Vue;

  var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
  /* istanbul ignore if */
  if (false) {}

  vue_i18n_esm_extend(Vue);
  Vue.mixin(defineMixin(options.bridge));
  Vue.directive('t', { bind: bind, update: update, unbind: unbind });
  Vue.component(interpolationComponent.name, interpolationComponent);
  Vue.component(numberComponent.name, numberComponent);

  // use simple mergeStrategies to prevent i18n instance lose '__proto__'
  var strats = Vue.config.optionMergeStrategies;
  strats.i18n = function (parentVal, childVal) {
    return childVal === undefined
      ? parentVal
      : childVal
  };
}

/*  */

var BaseFormatter = function BaseFormatter () {
  this._caches = Object.create(null);
};

BaseFormatter.prototype.interpolate = function interpolate (message, values) {
  if (!values) {
    return [message]
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values)
};



var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;

function parse (format) {
  var tokens = [];
  var position = 0;

  var text = '';
  while (position < format.length) {
    var char = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      var sub = '';
      char = format[position++];
      while (char !== undefined && char !== '}') {
        sub += char;
        char = format[position++];
      }
      var isClosed = char === '}';

      var type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type: type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens
}

function compile (tokens, values) {
  var compiled = [];
  var index = 0;

  var mode = Array.isArray(values)
    ? 'list'
    : vue_i18n_esm_isObject(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled }

  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break
      case 'list':
        compiled.push(values[parseInt(token.value, 10)]);
        break
      case 'named':
        if (mode === 'named') {
          compiled.push((values)[token.value]);
        } else {
          if (false) {}
        }
        break
      case 'unknown':
        if (false) {}
        break
    }
    index++;
  }

  return compiled
}

/*  */

/**
 *  Path parser
 *  - Inspired:
 *    Vue.js Path parser
 */

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  return 'ident'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse$1 (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      if (key === undefined) { return false }
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}





var I18nPath = function I18nPath () {
  this._cache = Object.create(null);
};

/**
 * External parse that check for a cache hit first
 */
I18nPath.prototype.parsePath = function parsePath (path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || []
};

/**
 * Get path value from path string
 */
I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
  if (!vue_i18n_esm_isObject(obj)) { return null }

  var paths = this.parsePath(path);
  if (paths.length === 0) {
    return null
  } else {
    var length = paths.length;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined || value === null) {
        return null
      }
      last = value;
      i++;
    }

    return last
  }
};

/*  */



var htmlTagMatcher = /<\/?[\w\s="/.':;#-\/]+>/;
var linkKeyMatcher = /(?:@(?:\.[a-z]+)?:(?:[\w\-_|./]+|\([\w\-_|./]+\)))/g;
var linkKeyPrefixMatcher = /^@(?:\.([a-z]+))?:/;
var bracketsMatcher = /[()]/g;
var defaultModifiers = {
  'upper': function (str) { return str.toLocaleUpperCase(); },
  'lower': function (str) { return str.toLocaleLowerCase(); },
  'capitalize': function (str) { return ("" + (str.charAt(0).toLocaleUpperCase()) + (str.substr(1))); }
};

var defaultFormatter = new BaseFormatter();

var VueI18n = function VueI18n (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #290
  /* istanbul ignore if */
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale === false
    ? false
    : options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || options.datetimeFormats || {};
  var numberFormats = options.numberFormats || {};

  this._vm = null;
  this._formatter = options.formatter || defaultFormatter;
  this._modifiers = options.modifiers || {};
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._formatFallbackMessages = options.formatFallbackMessages === undefined
    ? false
    : !!options.formatFallbackMessages;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : options.silentTranslationWarn;
  this._silentFallbackWarn = options.silentFallbackWarn === undefined
    ? false
    : !!options.silentFallbackWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = new Set();
  this._componentInstanceCreatedListener = options.componentInstanceCreatedListener || null;
  this._preserveDirectiveContent = options.preserveDirectiveContent === undefined
    ? false
    : !!options.preserveDirectiveContent;
  this.pluralizationRules = options.pluralizationRules || {};
  this._warnHtmlInMessage = options.warnHtmlInMessage || 'off';
  this._postTranslation = options.postTranslation || null;
  this._escapeParameterHtml = options.escapeParameterHtml || false;

  if ('__VUE_I18N_BRIDGE__' in options) {
    this.__VUE_I18N_BRIDGE__ = options.__VUE_I18N_BRIDGE__;
  }

  /**
   * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} an overall amount of available choices
   * @returns a final choice index
  */
  this.getChoiceIndex = function (choice, choicesLength) {
    var thisPrototype = Object.getPrototypeOf(this$1);
    if (thisPrototype && thisPrototype.getChoiceIndex) {
      var prototypeGetChoiceIndex = (thisPrototype.getChoiceIndex);
      return (prototypeGetChoiceIndex).call(this$1, choice, choicesLength)
    }

    // Default (old) getChoiceIndex implementation - english-compatible
    var defaultImpl = function (_choice, _choicesLength) {
      _choice = Math.abs(_choice);

      if (_choicesLength === 2) {
        return _choice
          ? _choice > 1
            ? 1
            : 0
          : 1
      }

      return _choice ? Math.min(_choice, 2) : 0
    };

    if (this$1.locale in this$1.pluralizationRules) {
      return this$1.pluralizationRules[this$1.locale].apply(this$1, [choice, choicesLength])
    } else {
      return defaultImpl(choice, choicesLength)
    }
  };


  this._exist = function (message, key) {
    if (!message || !key) { return false }
    if (!isNull(this$1._path.getPathValue(message, key))) { return true }
    // fallback for flat key
    if (message[key]) { return true }
    return false
  };

  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }

  this._initVM({
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
  });
};

var prototypeAccessors = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },availableLocales: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },formatFallbackMessages: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true },silentFallbackWarn: { configurable: true },preserveDirectiveContent: { configurable: true },warnHtmlInMessage: { configurable: true },postTranslation: { configurable: true },sync: { configurable: true } };

VueI18n.prototype._checkLocaleMessage = function _checkLocaleMessage (locale, level, message) {
  var paths = [];

  var fn = function (level, locale, message, paths) {
    if (isPlainObject(message)) {
      Object.keys(message).forEach(function (key) {
        var val = message[key];
        if (isPlainObject(val)) {
          paths.push(key);
          paths.push('.');
          fn(level, locale, val, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(key);
          fn(level, locale, val, paths);
          paths.pop();
        }
      });
    } else if (isArray(message)) {
      message.forEach(function (item, index) {
        if (isPlainObject(item)) {
          paths.push(("[" + index + "]"));
          paths.push('.');
          fn(level, locale, item, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(("[" + index + "]"));
          fn(level, locale, item, paths);
          paths.pop();
        }
      });
    } else if (isString(message)) {
      var ret = htmlTagMatcher.test(message);
      if (ret) {
        var msg = "Detected HTML in message '" + message + "' of keypath '" + (paths.join('')) + "' at '" + locale + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
        if (level === 'warn') {
          vue_i18n_esm_warn(msg);
        } else if (level === 'error') {
          error(msg);
        }
      }
    }
  };

  fn(level, locale, message, paths);
};

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  this._vm = new Vue({ data: data, __VUE18N__INSTANCE__: true });
  Vue.config.silent = silent;
};

VueI18n.prototype.destroyVM = function destroyVM () {
  this._vm.$destroy();
};

VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
  this._dataListeners.add(vm);
};

VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
  remove(this._dataListeners, vm);
};

VueI18n.prototype.watchI18nData = function watchI18nData () {
    var this$1 = this;
  return this._vm.$watch('$data', function () {
    var listeners = arrayFrom(this$1._dataListeners);
    var i = listeners.length;
    while(i--) {
      Vue.nextTick(function () {
        listeners[i] && listeners[i].$forceUpdate();
      });
    }
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale (composer) {
  if (!composer) {
    /* istanbul ignore if */
    if (!this._sync || !this._root) { return null }
    var target = this._vm;
    return this._root.$i18n.vm.$watch('locale', function (val) {
      target.$set(target, 'locale', val);
      target.$forceUpdate();
    }, { immediate: true })
  } else {
    // deal with vue-i18n-bridge
    if (!this.__VUE_I18N_BRIDGE__) { return null }
    var self = this;
    var target$1 = this._vm;
    return this.vm.$watch('locale', function (val) {
      target$1.$set(target$1, 'locale', val);
      if (self.__VUE_I18N_BRIDGE__ && composer) {
        composer.locale.value = val;
      }
      target$1.$forceUpdate();
    }, { immediate: true })
  }
};

VueI18n.prototype.onComponentInstanceCreated = function onComponentInstanceCreated (newI18n) {
  if (this._componentInstanceCreatedListener) {
    this._componentInstanceCreatedListener(newI18n, this);
  }
};

prototypeAccessors.vm.get = function () { return this._vm };

prototypeAccessors.messages.get = function () { return looseClone(this._getMessages()) };
prototypeAccessors.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
prototypeAccessors.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };
prototypeAccessors.availableLocales.get = function () { return Object.keys(this.messages).sort() };

prototypeAccessors.locale.get = function () { return this._vm.locale };
prototypeAccessors.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors.fallbackLocale.set = function (locale) {
  this._localeChainCache = {};
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors.formatFallbackMessages.get = function () { return this._formatFallbackMessages };
prototypeAccessors.formatFallbackMessages.set = function (fallback) { this._formatFallbackMessages = fallback; };

prototypeAccessors.missing.get = function () { return this._missing };
prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors.formatter.get = function () { return this._formatter };
prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

prototypeAccessors.silentFallbackWarn.get = function () { return this._silentFallbackWarn };
prototypeAccessors.silentFallbackWarn.set = function (silent) { this._silentFallbackWarn = silent; };

prototypeAccessors.preserveDirectiveContent.get = function () { return this._preserveDirectiveContent };
prototypeAccessors.preserveDirectiveContent.set = function (preserve) { this._preserveDirectiveContent = preserve; };

prototypeAccessors.warnHtmlInMessage.get = function () { return this._warnHtmlInMessage };
prototypeAccessors.warnHtmlInMessage.set = function (level) {
    var this$1 = this;

  var orgLevel = this._warnHtmlInMessage;
  this._warnHtmlInMessage = level;
  if (orgLevel !== level && (level === 'warn' || level === 'error')) {
    var messages = this._getMessages();
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }
};

prototypeAccessors.postTranslation.get = function () { return this._postTranslation };
prototypeAccessors.postTranslation.set = function (handler) { this._postTranslation = handler; };

prototypeAccessors.sync.get = function () { return this._sync };
prototypeAccessors.sync.set = function (val) { this._sync = val; };

VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values, interpolateMode) {
  if (!isNull(result)) { return result }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (isString(missingRet)) {
      return missingRet
    }
  } else {
    if (false) {}
  }

  if (this._formatFallbackMessages) {
    var parsedArgs = parseArgs.apply(void 0, values);
    return this._render(key, interpolateMode, parsedArgs.params, key)
  } else {
    return key
  }
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return !val && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._isSilentFallbackWarn = function _isSilentFallbackWarn (key) {
  return this._silentFallbackWarn instanceof RegExp
    ? this._silentFallbackWarn.test(key)
    : this._silentFallbackWarn
};

VueI18n.prototype._isSilentFallback = function _isSilentFallback (locale, key) {
  return this._isSilentFallbackWarn(key) && (this._isFallbackRoot() || locale !== this.fallbackLocale)
};

VueI18n.prototype._isSilentTranslationWarn = function _isSilentTranslationWarn (key) {
  return this._silentTranslationWarn instanceof RegExp
    ? this._silentTranslationWarn.test(key)
    : this._silentTranslationWarn
};

VueI18n.prototype._interpolate = function _interpolate (
  locale,
  message,
  key,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  if (!message) { return null }

  var pathRet = this._path.getPathValue(message, key);
  if (isArray(pathRet) || isPlainObject(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    /* istanbul ignore else */
    if (isPlainObject(message)) {
      ret = message[key];
      if (!(isString(ret) || isFunction(ret))) {
        if (false) {}
        return null
      }
    } else {
      return null
    }
  } else {
    /* istanbul ignore else */
    if (isString(pathRet) || isFunction(pathRet)) {
      ret = pathRet;
    } else {
      if (false) {}
      return null
    }
  }

  // Check for the existence of links within the translated string
  if (isString(ret) && (ret.indexOf('@:') >= 0 || ret.indexOf('@.') >= 0)) {
    ret = this._link(locale, message, ret, host, 'raw', values, visitedLinkStack);
  }

  return this._render(ret, interpolateMode, values, key)
};

VueI18n.prototype._link = function _link (
  locale,
  message,
  str,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  var ret = str;

  // Match all the links within the local
  // We are going to replace each of
  // them with its translation
  var matches = ret.match(linkKeyMatcher);
    
  // eslint-disable-next-line no-autofix/prefer-const
  for (var idx in matches) {
    // ie compatible: filter custom array
    // prototype method
    if (!matches.hasOwnProperty(idx)) {
      continue
    }
    var link = matches[idx];
    var linkKeyPrefixMatches = link.match(linkKeyPrefixMatcher);
    var linkPrefix = linkKeyPrefixMatches[0];
      var formatterName = linkKeyPrefixMatches[1];

    // Remove the leading @:, @.case: and the brackets
    var linkPlaceholder = link.replace(linkPrefix, '').replace(bracketsMatcher, '');

    if (vue_i18n_esm_includes(visitedLinkStack, linkPlaceholder)) {
      if (false) {}
      return ret
    }
    visitedLinkStack.push(linkPlaceholder);

    // Translate the link
    var translated = this._interpolate(
      locale, message, linkPlaceholder, host,
      interpolateMode === 'raw' ? 'string' : interpolateMode,
      interpolateMode === 'raw' ? undefined : values,
      visitedLinkStack
    );

    if (this._isFallbackRoot(translated)) {
      if (false) {}
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      var root = this._root.$i18n;
      translated = root._translate(
        root._getMessages(), root.locale, root.fallbackLocale,
        linkPlaceholder, host, interpolateMode, values
      );
    }
    translated = this._warnDefault(
      locale, linkPlaceholder, translated, host,
      isArray(values) ? values : [values],
      interpolateMode
    );

    if (this._modifiers.hasOwnProperty(formatterName)) {
      translated = this._modifiers[formatterName](translated);
    } else if (defaultModifiers.hasOwnProperty(formatterName)) {
      translated = defaultModifiers[formatterName](translated);
    }

    visitedLinkStack.pop();

    // Replace the link with the translated
    ret = !translated ? ret : ret.replace(link, translated);
  }

  return ret
};

VueI18n.prototype._createMessageContext = function _createMessageContext (values, formatter, path, interpolateMode) {
    var this$1 = this;

  var _list = isArray(values) ? values : [];
  var _named = vue_i18n_esm_isObject(values) ? values : {};
  var list = function (index) { return _list[index]; };
  var named = function (key) { return _named[key]; };
  var messages = this._getMessages();
  var locale = this.locale;

  return {
    list: list,
    named: named,
    values: values,
    formatter: formatter,
    path: path,
    messages: messages,
    locale: locale,
    linked: function (linkedKey) { return this$1._interpolate(locale, messages[locale] || {}, linkedKey, null, interpolateMode, undefined, [linkedKey]); }
  }
};

VueI18n.prototype._render = function _render (message, interpolateMode, values, path) {
  if (isFunction(message)) {
    return message(
      this._createMessageContext(values, this._formatter || defaultFormatter, path, interpolateMode)
    )
  }

  var ret = this._formatter.interpolate(message, values, path);

  // If the custom formatter refuses to work - apply the default one
  if (!ret) {
    ret = defaultFormatter.interpolate(message, values, path);
  }

  // if interpolateMode is **not** 'string' ('row'),
  // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
  return interpolateMode === 'string' && !isString(ret) ? ret.join('') : ret
};

VueI18n.prototype._appendItemToChain = function _appendItemToChain (chain, item, blocks) {
  var follow = false;
  if (!vue_i18n_esm_includes(chain, item)) {
    follow = true;
    if (item) {
      follow = item[item.length - 1] !== '!';
      item = item.replace(/!/g, '');
      chain.push(item);
      if (blocks && blocks[item]) {
        follow = blocks[item];
      }
    }
  }
  return follow
};

VueI18n.prototype._appendLocaleToChain = function _appendLocaleToChain (chain, locale, blocks) {
  var follow;
  var tokens = locale.split('-');
  do {
    var item = tokens.join('-');
    follow = this._appendItemToChain(chain, item, blocks);
    tokens.splice(-1, 1);
  } while (tokens.length && (follow === true))
  return follow
};

VueI18n.prototype._appendBlockToChain = function _appendBlockToChain (chain, block, blocks) {
  var follow = true;
  for (var i = 0; (i < block.length) && (isBoolean(follow)); i++) {
    var locale = block[i];
    if (isString(locale)) {
      follow = this._appendLocaleToChain(chain, locale, blocks);
    }
  }
  return follow
};

VueI18n.prototype._getLocaleChain = function _getLocaleChain (start, fallbackLocale) {
  if (start === '') { return [] }

  if (!this._localeChainCache) {
    this._localeChainCache = {};
  }

  var chain = this._localeChainCache[start];
  if (!chain) {
    if (!fallbackLocale) {
      fallbackLocale = this.fallbackLocale;
    }
    chain = [];

    // first block defined by start
    var block = [start];

    // while any intervening block found
    while (isArray(block)) {
      block = this._appendBlockToChain(
        chain,
        block,
        fallbackLocale
      );
    }

    // last block defined by default
    var defaults;
    if (isArray(fallbackLocale)) {
      defaults = fallbackLocale;
    } else if (vue_i18n_esm_isObject(fallbackLocale)) {
      /* $FlowFixMe */
      if (fallbackLocale['default']) {
        defaults = fallbackLocale['default'];
      } else {
        defaults = null;
      }
    } else {
      defaults = fallbackLocale;
    }

    // convert defaults to array
    if (isString(defaults)) {
      block = [defaults];
    } else {
      block = defaults;
    }
    if (block) {
      this._appendBlockToChain(
        chain,
        block,
        null
      );
    }
    this._localeChainCache[start] = chain;
  }
  return chain
};

VueI18n.prototype._translate = function _translate (
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  var chain = this._getLocaleChain(locale, fallback);
  var res;
  for (var i = 0; i < chain.length; i++) {
    var step = chain[i];
    res =
      this._interpolate(step, messages[step], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) {
      if (step !== locale && "production" !== 'production' && 0 && 0) {}
      return res
    }
  }
  return null
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var ref;

    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
  if(this._escapeParameterHtml) {
    parsedArgs.params = escapeParams(parsedArgs.params);
  }

  var locale = parsedArgs.locale || _locale;

  var ret = this._translate(
    messages, locale, this.fallbackLocale, key,
    host, 'string', parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    if (false) {}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return (ref = this._root).$t.apply(ref, [ key ].concat( values ))
  } else {
    ret = this._warnDefault(locale, key, ret, host, values, 'string');
    if (this._postTranslation && ret !== null && ret !== undefined) {
      ret = this._postTranslation(ret, key);
    }
    return ret
  }
};

VueI18n.prototype.t = function t (key) {
    var ref;

    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
  return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
};

VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
  var ret =
    this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
  if (this._isFallbackRoot(ret)) {
    if (false) {}
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.i(key, locale, values)
  } else {
    return this._warnDefault(locale, key, ret, host, [values], 'raw')
  }
};

VueI18n.prototype.i = function i (key, locale, values) {
  /* istanbul ignore if */
  if (!key) { return '' }

  if (!isString(locale)) {
    locale = this.locale;
  }

  return this._i(key, locale, this._getMessages(), null, values)
};

VueI18n.prototype._tc = function _tc (
  key,
  _locale,
  messages,
  host,
  choice
) {
    var ref;

    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
  if (!key) { return '' }
  if (choice === undefined) {
    choice = 1;
  }

  var predefined = { 'count': choice, 'n': choice };
  var parsedArgs = parseArgs.apply(void 0, values);
  parsedArgs.params = Object.assign(predefined, parsedArgs.params);
  values = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
  return this.fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
};

VueI18n.prototype.fetchChoice = function fetchChoice (message, choice) {
  /* istanbul ignore if */
  if (!message || !isString(message)) { return null }
  var choices = message.split('|');

  choice = this.getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
};

VueI18n.prototype.tc = function tc (key, choice) {
    var ref;

    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
  return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale] || {})
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, message);
};

VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, vue_i18n_esm_merge(
    typeof this._vm.messages[locale] !== 'undefined' && Object.keys(this._vm.messages[locale]).length
      ? Object.assign({}, this._vm.messages[locale])
      : {},
    message
  ));
};

VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {})
};

VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, vue_i18n_esm_merge(this._vm.dateTimeFormats[locale] || {}, format));
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype._clearDateTimeFormat = function _clearDateTimeFormat (locale, format) {
  // eslint-disable-next-line no-autofix/prefer-const
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._dateTimeFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._dateTimeFormatters[id];
  }
};

VueI18n.prototype._localizeDateTime = function _localizeDateTime (
  value,
  locale,
  fallback,
  dateTimeFormats,
  key
) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = dateTimeFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && "production" !== 'production' && 0 && 0) {}
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];
    var id = _locale + "__" + key;
    var formatter = this._dateTimeFormatters[id];
    if (!formatter) {
      formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._d = function _d (value, locale, key) {
  /* istanbul ignore if */
  if (false) {}

  if (!key) {
    return new Intl.DateTimeFormat(locale).format(value)
  }

  var ret =
    this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
  if (this._isFallbackRoot(ret)) {
    if (false) {}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.d(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.d = function d (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (vue_i18n_esm_isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._d(value, locale, key)
};

VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
  return looseClone(this._vm.numberFormats[locale] || {})
};

VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, vue_i18n_esm_merge(this._vm.numberFormats[locale] || {}, format));
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype._clearNumberFormat = function _clearNumberFormat (locale, format) {
  // eslint-disable-next-line no-autofix/prefer-const
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._numberFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._numberFormatters[id];
  }
};

VueI18n.prototype._getNumberFormatter = function _getNumberFormatter (
  value,
  locale,
  fallback,
  numberFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = numberFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = numberFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && "production" !== 'production' && 0 && 0) {}
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      // If options specified - create one time number formatter
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter
  }
};

VueI18n.prototype._n = function _n (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    if (false) {}
    return ''
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.format(value);
  if (this._isFallbackRoot(ret)) {
    if (false) {}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.n(value, Object.assign({}, { key: key, locale: locale }, options))
  } else {
    return ret || ''
  }
};

VueI18n.prototype.n = function n (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (vue_i18n_esm_isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }

      // Filter out number format options only
      options = Object.keys(args[0]).reduce(function (acc, key) {
          var obj;

        if (vue_i18n_esm_includes(numberFormatKeys, key)) {
          return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
        }
        return acc
      }, null);
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._n(value, locale, key, options)
};

VueI18n.prototype._ntp = function _ntp (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    if (false) {}
    return []
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.formatToParts(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.formatToParts(value);
  if (this._isFallbackRoot(ret)) {
    if (false) {}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n._ntp(value, locale, key, options)
  } else {
    return ret || []
  }
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors );

var availabilities;
// $FlowFixMe
Object.defineProperty(VueI18n, 'availabilities', {
  get: function get () {
    if (!availabilities) {
      var intlDefined = typeof Intl !== 'undefined';
      availabilities = {
        dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
        numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
      };
    }

    return availabilities
  }
});

VueI18n.install = install;
VueI18n.version = '8.26.8';

/* harmony default export */ var vue_i18n_esm = (VueI18n);

;// CONCATENATED MODULE: ./src/i18n/index.js

function loadLocaleMessages() {
  const locales = __webpack_require__(8648);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}
const languages = [{
  language: 'English',
  code: 'en',
  ariaLabel: 'English'
}, {
  language: '中文',
  code: 'cn',
  ariaLabel: 'Chinese'
}, {
  language: 'Deutsch',
  code: 'de',
  ariaLabel: 'German'
}, {
  language: '日本語',
  code: 'jp',
  ariaLabel: 'Japanese'
}, {
  language: '한국어',
  code: 'kr',
  ariaLabel: 'Korean'
}, {
  language: 'Español',
  code: 'es',
  ariaLabel: 'Spanish'
}, {
  language: 'Italiano',
  code: 'it',
  ariaLabel: 'Italian'
}, {
  language: 'Français',
  code: 'fr',
  ariaLabel: 'French'
}, {
  language: 'Dutch',
  code: 'nl',
  ariaLabel: 'Dutch'
}, {
  language: 'Portugués',
  code: 'pt',
  ariaLabel: 'Portuguese'
}, {
  language: 'Polish',
  code: 'pl',
  ariaLabel: 'Polish'
}, {
  language: 'ภาษาไทย',
  code: 'th',
  ariaLabel: 'Thai'
}, {
  language: 'Türkçe',
  code: 'tr',
  ariaLabel: 'Turkish'
}, {
  language: 'русский',
  code: 'ru',
  ariaLabel: 'Russian'
}, {
  language: 'Tiếng Việt',
  code: 'vi',
  ariaLabel: 'Vietnamese'
}, {
  language: 'Hrvatski',
  code: 'hr',
  ariaLabel: 'Croatian'
}];
const messages = loadLocaleMessages();
function initializeI18n() {
  try {
    if (window) {
      return new vue_i18n_esm({
        locale: 'en',
        // set locale
        messages,
        // set locale messages,
        availableLocales: languages.map(({
          code
        }) => code),
        silentTranslationWarn: true
      });
    }
  } catch (err) {
    // This error will be triggered on the server because window is undeclared
    // and on the client becuase VueI18n will initially throw an error when window.Vue is not defined
    console.error('Failed to use VueI18n: ', err);
    return {
      t: key => key
    };
  }
}
;// CONCATENATED MODULE: ./src/plugin.js








// const i18n = null;

/* harmony default export */ var src_plugin = ({
  install(Vue, options) {
    if (!Vue.uicomponentsInstalled) {
      Vue.component('GTextArea', GTextArea);
      Vue.component('VirtualScroll', VirtualScroll);
      Vue.component('ReadMoreLessWrapper', ReadMoreLessWrapper);
      Vue.component('ErrorCrossSvg', ErrorCrossSvg);
      Vue.component('SimpleButton', SimpleButton);
      Vue.component('GoldBotRatingButton', GoldBotRatingButton);
      Vue.component('TextQNAMoreDropdown', TextQNAMoreDropdown);
      Vue.component('SimpleRadioButton', SimpleRadioButton);
      Vue.component('ProgressLevel', ProgressLevel);
      Vue.component('StageControlBar', StageControlBar);
      Vue.component('Ticker', Ticker);
      Vue.component('CloseButton', CloseButton);
      Vue.component('ArrowWithCircleBg', ArrowWithCircleBg);
      Vue.component('ScrollCompWithTopBottomArrow', ScrollCompWithTopBottomArrow);
      Vue.component('ScrollCompWithLeftRightArrow', ScrollCompWithLeftRightArrow);
      Vue.component('SurveyPopUp', SurveyPopUp);
      Vue.component('SurveyStageBarTip', SurveyStageBarTip);
      Vue.component('SingleChoiceQuestion', SingleChoice);
      Vue.component('MultipleChoiceQuestion', MultipleChoice);
      Vue.component('FreeFormTextQuestion', FreeFormText);
      Vue.component('RatingQuestion', Rating);
      Vue.component('SidebarSurveyWidget', SidebarSurveyWidget);
      Vue.component('GSelect', GSelect);
      Vue.component('NetworkErrorDialog', NetworkErrorDialog);
      Vue.component('VideoControls', VideoControls);
      Vue.component('BroadcastHybridSetupMode', BroadcastHybridSetupMode);
      Vue.component('SetupModeSwitch', SetupModeSwitch);
      Vue.component('UserProfileDropdown', UserProfileDropdown);
      Vue.component('TextButton', TextButton);
      Vue.component('SimpleInput', SimpleInput);
      Vue.component('SimpleProfileInput', SimpleProfileInput);
      Vue.component('AboutRegistration', aboutRegistration);
      Vue.component('sideBarReg', sideBarReg);
      Vue.component('sideBarShare', sideBarShare);
      Vue.component('sideButtons', sideButtons);
      Vue.component('PopUpCreateTickerDialog', PopUpCreateTickerDialog);
      Vue.component('SpeakersGrid', SpeakersGrid);
      Vue.component('SpeakerCard', SpeakerCard);
      Vue.component('SvgIcon', SvgIcon);
      Vue.component('StyledText', StyledText);
      Vue.component('ChatReactionBar', ChatReactionBar);
      Vue.component('EventBlur', EventBlur);
      Vue.component('BlockSpeakerOrgScreen', BlockSpeakerOrgScreen);
      Vue.component('ChatMessageRenderer', ChatMessageRenderer);
      Vue.component('IconButton', IconButton);
      Vue.component('UserBubble', UserBubble);
      Vue.component('DropdownSetup', DropdownSetup);
      Vue.component('UserImage', UserImage);
      Vue.component('UserTooltip', UserTooltip);
      Vue.component('GTooltip', GTooltip);
      Vue.component('EventPage', EventPage);
      Vue.component('NavigationBar', NavigationBar);
      Vue.component('NavigationItem', NavigationItem);
      Vue.component('CamAndMicPermissionPopUp', CamAndMicPermissionPopUp);
      Vue.component('RoomsPage', RoomsPage);
      Vue.component('RoomCard', RoomCard);
      Vue.component('AuthWrapper', AuthWrapper);
      Vue.component('AuthInput', AuthInput);
      Vue.component('AuthButton', AuthButton);
      Vue.component('AuthPopup', AuthPopup);
      Vue.component('AuthProgress', AuthProgress);
      Vue.component('SingleSelect', SingleSelect);
      Vue.component('SimpleSelect', SimpleSelect);
      Vue.component('NewSimpleSelect', NewSimpleSelect);
      Vue.component('SimpleRangeInput', SimpleRangeInput);
      Vue.component('SearchField', SearchField);
      Vue.component('TagsFilter', TagsFilter);
      Vue.component('FilterBar', FilterBar);
      Vue.component('ChatLoadMoreButton', ChatLoadMoreButton);
      Vue.component('Observer', Observer);
      Vue.component('Paginator', Paginator);
      Vue.component('UserHomeNavBar', UserHomeNavBar);
      Vue.component('UserProfile', UserProfile);
      Vue.component('EventsNavBar', EventsNavBar);
      Vue.component('EventsSection', EventsSection);
      Vue.component('EventCard', EventCard);
      Vue.component('PoweredBy', PoweredBy);
      Vue.component('ProgressBar', ProgressBar);
      Vue.component('UserProfilePage', Profile);
      Vue.component('ProfilePage', ProfilePage);
      Vue.component('TextQNAItem', TextQNAItem);
      Vue.component('TextQNAAnswerHolder', TextQNAAnswerHolder);
      Vue.component('RadioSelectBtn', RadioSelectBtn);
      Vue.component('StyledReadmoreText', StyledReadmoreText);
      Vue.component('LivenessControlPage', LivenessControlPage);
      Vue.component('OutlinedButton', OutlinedButton);
      Vue.component('AtcButton', AtcButton);
      Vue.component('SidebarContainer', SidebarContainer);
      Vue.component('SidebarPrimaryTabs', SidebarPrimaryTabs);
      Vue.component('SidebarPrimaryTabBtn', SidebarPrimaryTabBtn);
      Vue.component('PillButton', PillButton);
      Vue.component('SidebarChatWidget', SidebarChatWidget);
      Vue.component('SidebarMessageList', SidebarMessageList);
      Vue.component('SidebarP2PChat', SidebarP2PChat);
      Vue.component('SidebarWidgetContainer', SidebarWidgetContainer);
      Vue.component('SidebarMessageItem', SidebarMessageItem);
      Vue.component('SidebarMessageDateDivider', SidebarMessageDateDivider);
      Vue.component('SidebarUserProfile', SidebarUserProfile);
      Vue.component('SidebarChatScrollHelper', SidebarChatScrollHelper);
      Vue.component('SidebarTextInputWrapper', SidebarTextInputWrapper);
      Vue.component('SidebarChatInput', SidebarChatInput);
      Vue.component('StageWrapper', StageWrapper);
      Vue.component('DiscussionRoomWrapper', DiscussionRoomWrapper);
      Vue.component('Stage', Stage);
      Vue.component('SidebarPollsWidget', SidebarPollsWidget);
      Vue.component('SpeakerPollView', SpeakerPollView);
      Vue.component('AttendeePollView', AttendeePollView);
      Vue.component('SidebarDocs', SidebarDocs);
      Vue.component('SidebarQAWidget', SidebarQAWidget);
      Vue.component('SidebarTextQA', SidebarTextQA);
      Vue.component('SidebarVideoQA', SidebarVideoQA);
      Vue.component('ConferenceRoom', ConferenceRoom);
      Vue.component('GenericHeaderNotification', GenericHeaderNotification);
      Vue.component('SimpleLabel', SimpleLabel);
      Vue.component('EventDetails', EventDetails);
      Vue.component('RegistrationPage', RegistrationPage);
      Vue.component('Splash', Splash);
      Vue.component('HlsVideoPlayer', HlsVideoPlayer);
      Vue.component('BroadcastScreenSaver', BroadcastScreenSaver);
      Vue.component('ScreenSaverWrapper', ScreenSaverWrapper);
      Vue.component('RedirectionScreenSaver', RedirectionScreenSaver);
      Vue.component('BreakScreenSaver', BreakScreenSaver);
      Vue.component('RoomsScreenSaver', RoomsScreenSaver);
      Vue.component('EventScreenSaver', EventScreenSaver);
      Vue.component('Loading', Loading);
      Vue.component('TransitionToast', TransitionToast);
      Vue.component('HlsRoom', HlsRoom);
      Vue.component('AgendaFilter', AgendaFilter);
      Vue.component('AgendaFavoritesFilter', AgendaFavoritesFilter);
      Vue.component('CurrentLiveSessions', CurrentLiveSessions);
      Vue.component('StageRollVideoPlayer', StageRollVideoPlayer);
      Vue.component('BoothCard', BoothCard);
      Vue.component('BoothGrid', BoothGrid);
      Vue.component('BoothDetails', BoothDetails);
      Vue.component('RaiseHandButton', RaiseHandButton);
      Vue.component('PollWidget', PollWidget);
      Vue.component('TextQnaPublished', TextQnaPublished);
      Vue.component('IncomingVideoCallNotify', IncomingVideoCallNotify);
      Vue.component('ConfirmTrackChange', ConfirmTrackChange);
      Vue.component('SidebarVideoCallItem', SidebarVideoCallItem);
      Vue.component('LivenessPanelRecordingItem', LivenessPanelRecordingItem);
      Vue.component('ConfirmLiveSwitch', ConfirmLiveSwitch);
      Vue.component('SlidesList', SlidesList);
      Vue.component('BroadcastSlide', BroadcastSlide);
      Vue.component('SlideImage', SlideImage);
      Vue.component('SidebarAssetsTab', SidebarAssetsTab);
      Vue.component('GToggle', GToggle);
      Vue.component('LitemodeSwitcher', LitemodeSwitcher);
      Vue.component('ConfirmationDialog', ConfirmationDialog);
      Vue.component('NotificationDialog', NotificationDialog);
      Vue.component('GCheckbox', GCheckbox);
      Vue.component('SlideScreen', SlidesScreen);
      Vue.component('SlideDeck', SlideDeck);
      Vue.component('Slide', Slide);
      Vue.component('SlideControl', SlideControl);
      Vue.component('SpeakerHandoffCard', SpeakerHandoffCard);
      Vue.component('VpnAdblocker', VpnAdblocker);
      Vue.component('DriftEmbed', DriftEmbed);
      Vue.component('TechSetup', TechSetup);
      Vue.component('TechCheck', TechCheck);
      Vue.component('ScreenSizeBlocker', ScreenSizeBlocker);
      Vue.component('SimpleScreenBlocker', SimpleScreenBlocker);
      Vue.component('RotationBlocker', RotationBlocker);
      Vue.component('ErrorPage403', ErrorPage_403);
      Vue.component('OverflowWatcher', OverflowWatcher);
      Vue.component('HlsSupportChecker', HlsSupportChecker);
      Vue.component('HlsNotSupported', HlsNotSupported);
      Vue.component('StageSpeakers', StageSpeakers);
      Vue.component('StageLayoutsOptions', StageLayoutsOptions);
      Vue.component('StageSpeakersControl', StageSpeakersControl);
      Vue.component('SpeakersControlPanel', SpeakersControlPanel);
      Vue.component('PreRedirectionPopup', PreRedirectionPopup);
      Vue.component('ScreenShareTest', ScreenShareTest);
      Vue.component('HelpdocLink', HelpdocLink);
      Vue.component('FitText', FitText);
      Vue.component('HybridDialog', HybridDialog);
      Vue.component('Banner', Banner);
      Vue.component('Ribbon', Ribbon);
      Vue.component('SignalIndicator', SignalIndicator);
      Vue.component('KudoEmbed', KudoEmbed);
      Vue.component('FreeTrialSuccessPage', FreeTrialSuccessPage);
      Vue.component('SidebarEmptyState', SidebarEmptyState);
      Vue.component('LiteModeToggle', LiteModeToggle);
      Vue.component('VideoCaptions', VideoCaptions);
      Vue.component('LiveVideoSelectorWidget', LiveVideoSelectorWidget);
      Vue.component('LiveHLSRoom', LiveHLSRoom);
      Vue.component('GenericMessageDialog', GenericMessageDialog);
      Vue.component('TryAgain', TryAgain);
      Vue.component('VideoProgressBar', VideoProgressBar);
      Vue.component('AgoraV4Player', AgoraV4Player);
      Vue.component('GifRenderer', GifRenderer);
      Vue.component('PublishedStage', PublishedStage);
      Vue.component('FavoriteButton', FavoriteButton);
      Vue.component('LabeledSeparator', LabeledSeparator);
      Vue.component('MuteButton', MuteButton);
      Vue.component('SettingsModal', SettingsModal);
      Vue.component('SlidoContainer', SlidoContainer);
      Vue.component('AccessibleRating', AccessibleRating);
      Vue.component('AccessibleSelect', AccessibleSelect);
      Vue.component('Badge', Badge);
      Vue.component('SessionChangeConfirmation', SessionChangeConfirmation);
      // This fails in ssr. This needs to be fixed properly so it works in ssr'ed dom too.
      try {
        Vue.use(dist/* default */.Z, {
          hooks: {
            afterSanitizeAttributes: currentNode => {
              if ('target' in currentNode) {
                currentNode.setAttribute('target', '_blank');
                currentNode.setAttribute('rel', 'noopener noreferer');
              }
            }
          }
        });
      } catch (err) {
        console.error('Error in using dompurify: ', err);
      }
      try {
        if (window) {
          // This library makes everything crash if used on server side
          if (!window.Vue) {
            console.warn('window.Vue is not defined! Setting');
            window.Vue = Vue;
          }
          Vue.use(vue_i18n_esm);
          window.i18nInstance = initializeI18n();
          Vue.mixin({
            $t: window.i18nInstance.t.bind(window.i18nInstance),
            $i18n: window.i18nInstance
          });
          Vue.$i18n = window.i18nInstance;
        }
      } catch (err) {
        console.error('Error in using VueI18n! Setting dummy values: ', err);
        Vue.mixin({
          $t: key => key,
          $i18n: {
            t: key => key
          }
        });
        Vue.$i18n = {
          t: key => key
        };
      }
      Vue.uicomponentsInstalled = true;

      /**
       * When using uicomponents in a project, $trackEvent can be overriden with
       * a custom function. Eg: window.analytics.track
       */

      // setup vee validate
      setup(Vue);
      Vue.mixin({
        $trackEvent: options.$trackEvent
      });
    } else {
      // eslint-disable-next-line
      console.log('Uicomponents is already installed! Skipping');
    }
  }
});
;// CONCATENATED MODULE: ./src/index.js

























































































// Pages


























// Plugin


// Utils


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@vue+cli-service@5.0.8_lodash@4.17.21_prettier@2.8.8_react@18.2.0_sass-loader@12.6.0_vue-temp_453k2uaekezdzqojt6pvxfd4km/node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;